import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import * as PathUtils from "@sanity/util/paths";
import { startsWith, isEqual as isEqual$3, toString, trimLeft, pathFor, get as get$1, fromString, FOCUS_TERMINATOR, trimChildPath as trimChildPath$1 } from "@sanity/util/paths";
import React, { useState, useReducer, useMemo, useRef, useLayoutEffect, memo, useContext, useEffect, forwardRef, useImperativeHandle, useCallback, Fragment as Fragment$1, useId, isValidElement, cloneElement, useSyncExternalStore, Suspense, startTransition, createElement, PureComponent, Children, Component, useInsertionEffect, createContext as createContext$1, useDebugValue, lazy, StrictMode } from "react";
import deepEquals from "react-fast-compare";
import { ChangeIndicatorTrackerContextStore, ChangeIndicatorTrackerContextGetSnapshot, ConnectorContext, ScrollContext, WorkspacesContext, LocaleContext, UserColorManagerContext, PresenceContext, FormBuilderContext, ValidationContext, PortableTextMarkersContext, PerspectiveContext, ReleasesUpsellContext, ResourceCacheContext, WorkspaceContext, SourceContext, TableContext, SearchContext, ReleasesMetadataContext, PresenceTrackerContextStore, PresenceTrackerContextGetSnapshot, FormFieldPresenceContext, VirtualizerScrollInstanceContext, HoveredFieldContext, FieldActionsContext, FormCallbacksContext, DocumentFieldActionsContext, PortableTextMemberItemsContext, ReferenceInputOptionsContext, ReviewChangesContext, DocumentIdContext, FormValueContext, ReferenceItemRefContext, SortableItemIdContext, TreeEditingEnabledContext, PortableTextMemberItemElementRefsContext, EventsContext, DocumentChangeContext, DiffContext, GetFormValueContext, CalendarContext, AppIdCacheContext, CommentsAuthoringPathContext, CommentsIntentContext, ActiveWorkspaceMatcherContext, CommentsContext, CommentsEnabledContext, CommentsOnboardingContext, CommentsSelectedPathContext, CommentsUpsellContext, SanityCreateConfigContext, ScheduledPublishingEnabledContext, SchedulesContext, SchedulePublishUpsellContext, DocumentActionPropsContext, TasksEnabledContext, IsLastPaneContext, MentionUserContext, TasksNavigationContext, TasksContext, TasksUpsellContext, RouterHistoryContext, AddonDatasetContext, ColorSchemeSetValueContext, ColorSchemeValueContext, NavbarContext, FreeTrialContext, StudioAnnouncementContext, CopyPasteContext, PreviewCardContext, ZIndexContext, zIndexContextDefaults, CommentInputContext } from "sanity/_singletons";
import debounce from "lodash/debounce.js";
import { useLayer, Flex, Box, Stack, Text as Text$1, Badge, Grid, rem, Card, Spinner, Layer, Dialog, useTheme, useToast, Heading, Inline, Autocomplete, TextInput as TextInput$1, Select, useClickOutsideEvent, LayerProvider, MenuItem, Button as Button$1, Menu, TabPanel, MenuDivider, useGlobalKeyDown, Skeleton, Avatar, TabList, Container as Container$2, Checkbox as Checkbox$1, Breadcrumbs, studioTheme, useMediaIndex, Code, Portal, PortalProvider, Label, TextSkeleton, AvatarStack, AvatarCounter, useElementRect, useElementSize, Switch as Switch$1, ElementQuery, TextArea, rgba, useBoundaryElement, BoundaryElementProvider, usePortal, isHTMLElement, Radio, _responsive, VirtualList as VirtualList$1, usePrefersDark, ThemeProvider, ToastProvider, useArrayProp, ThemeColorProvider, DialogProvider, focusLastDescendant, focusFirstDescendant } from "@sanity/ui";
import { ResizeObserver as ResizeObserver$1 } from "@juggle/resize-observer";
import createPubSub from "nano-pubsub";
import { Tooltip, Button, ErrorBoundary, Dialog as Dialog$1, TooltipDelayGroupProvider, Popover, MenuButton as MenuButton$1, MenuItem as MenuItem$1, Tab, ConditionalWrapper, generateHelpUrl } from "./_chunks-es/generate-help-url.esm.mjs";
import { Hotkeys } from "./_chunks-es/generate-help-url.esm.mjs";
import "./_singletons.mjs";
import { useTranslation as useTranslation$1, I18nextProvider, initReactI18next } from "react-i18next";
import { getTheme_v2, rgba as rgba$1, parseColor, rgbToHex, screen, multiply, createColorTheme, buildTheme } from "@sanity/ui/theme";
import { styled, css, keyframes, createGlobalStyle } from "styled-components";
import sortBy from "lodash/sortBy.js";
import { isKeyedObject, isImageSchemaType, isIndexSegment, isKeySegment, isIndexTuple, isReference as isReference$1, isArrayOfBlocksSchemaType, isSlug, isTypedObject, isGlobalDocumentReference, isObjectSchemaType, isArraySchemaType, isValidationErrorMarker, isPortableTextTextBlock, isNumberSchemaType, isBooleanSchemaType, isStringSchemaType, isPrimitiveSchemaType, isCrossDatasetReferenceSchemaType, isReferenceSchemaType, isArrayOfObjectsSchemaType, isArrayOfPrimitivesSchemaType, isCrossDatasetReference, isTitledListValue, isImage, isPortableTextSpan, isSearchStrategy, searchStrategies as searchStrategies$1, isValidationWarningMarker, isValidationInfoMarker, defineType, defineField, isDeprecatedSchemaType, isFileSchemaType, isBlockSchemaType, defineArrayMember } from "@sanity/types";
export * from "@sanity/types";
import { useVirtualizer, defaultRangeExtractor, elementScroll } from "@tanstack/react-virtual";
import throttle from "lodash/throttle.js";
import { ChevronRightIcon, EllipsisHorizontalIcon, ErrorOutlineIcon, DocumentIcon, ImageIcon, WarningOutlineIcon, InfoOutlineIcon, CalendarIcon, DotIcon, SearchIcon, ChevronLeftIcon, EarthGlobeIcon, ChevronDownIcon, LockIcon, CopyIcon, TrashIcon, AddIcon, ComposeSparklesIcon, CircleIcon, CheckmarkCircleIcon, ToggleArrowRightIcon, PublishIcon, PinFilledIcon, PinIcon, RestoreIcon, ClockIcon, CloseCircleIcon, UnarchiveIcon, ArchiveIcon, ArrowUpIcon, UnknownIcon, CheckmarkIcon, CloseIcon, ControlsIcon, SpinnerIcon, ArrowLeftIcon, SortIcon, UnpublishIcon, AccessDeniedIcon, Icon, LinkIcon, LaunchIcon, BulbOutlineIcon, EditIcon, HelpCircleIcon, SyncIcon, UploadIcon, DragHandleIcon, StackCompactIcon, PanelLeftIcon, InsertAboveIcon, InsertBelowIcon, AddDocumentIcon, ResetIcon, ReadOnlyIcon, BinaryDocumentIcon, ChevronUpIcon, DownloadIcon, DocumentsIcon, CropIcon, UlistIcon, OlistIcon, CodeIcon, UnderlineIcon, StrikethroughIcon, ItalicIcon, BoldIcon, BlockElementIcon, InlineElementIcon, CollapseIcon, ExpandIcon, EyeOpenIcon, AddCircleIcon, TimelineIcon, ArrowRightIcon, ArrowDownIcon, RevertIcon, ClipboardIcon, StringIcon, NumberIcon, BlockContentIcon, UndoIcon, UnlinkIcon, AddCommentIcon, CommentIcon, EarthAmericasIcon, SelectIcon, TaskIcon, UserIcon, DesktopIcon, MoonIcon, SunIcon, EyeClosedIcon, DoubleChevronRightIcon, BoltIcon, AddUserIcon, CogIcon, LeaveIcon, UsersIcon, MenuIcon, LinkRemovedIcon } from "@sanity/icons";
import { COLOR_HUES, hues, white, red, gray, yellow, purple, black, green, blue } from "@sanity/color";
import { darken, lighten, hasBadContrast, readableColor } from "color2k";
import { of, concat, defer, EMPTY as EMPTY$6, map as map$1, switchMap as switchMap$1, catchError as catchError$1, concatMap, interval, takeWhile, Observable, merge, Subject, fromEvent, throwError, timer, NEVER, finalize, shareReplay as shareReplay$1, iif, startWith as startWith$1, bufferTime, filter as filter$1, BehaviorSubject, tap as tap$1, concatWith, scan as scan$1, pipe, from, count, retry, share as share$1, ReplaySubject, combineLatest, asyncScheduler, mergeMap as mergeMap$1, firstValueFrom, lastValueFrom, partition as partition$1, distinctUntilChanged as distinctUntilChanged$1, expand, reduce as reduce$1, skip as skip$1, forkJoin, isObservable, asapScheduler, using, repeat, take as take$1, debounce as debounce$2, timeout, connect, debounceTime as debounceTime$1 } from "rxjs";
import { catchError, tap, switchMap, map, scan, distinctUntilChanged, shareReplay, filter, startWith, mergeMapTo, takeUntil, take, publishReplay, refCount, withLatestFrom, share, mergeMap, concatMap as concatMap$1, groupBy as groupBy$1, throttleTime, last, mergeAll, toArray as toArray$1, distinct, skip, first, debounceTime, debounce as debounce$1, expand as expand$1, reduce as reduce$2, switchAll, delay, auditTime, switchMapTo, mapTo } from "rxjs/operators";
import { createClient } from "@sanity/client";
import isEqual$2 from "lodash/isEqual.js";
import memoize$1 from "lodash/memoize.js";
import { useObservable, useObservableEvent } from "react-rx";
import { observableCallback } from "observable-callback";
import uniqueId from "lodash/uniqueId.js";
import { Schema } from "@sanity/schema";
import { DEFAULT_MAX_FIELD_DEPTH, builtinTypes, validateSchema, groupProblems, isActionEnabled } from "@sanity/schema/_internal";
import cloneDeep from "lodash/cloneDeep.js";
import get from "lodash/get.js";
import isPlainObject$1 from "lodash/isPlainObject.js";
import * as legacyDateFormat from "@sanity/util/legacyDateFormat";
import { DEFAULT_DATE_FORMAT, format as format$3, parse as parse$1, DEFAULT_TIME_FORMAT } from "@sanity/util/legacyDateFormat";
import { createInstance } from "i18next";
import { defineEvent, createSessionId, createBatchedStore } from "@sanity/telemetry";
import debug$7 from "debug";
import QuickLRU from "quick-lru";
import omit from "lodash/omit.js";
import { Mutation, BufferedDocument, arrayToJSONMatchPath } from "@sanity/mutator";
import groupBy from "lodash/groupBy.js";
import partition from "lodash/partition.js";
import FocusLock from "react-focus-lock";
import { useDevicePixelRatio, getDevicePixelRatio } from "use-device-pixel-ratio";
import classNames from "classnames";
import { isValidElementType } from "react-is";
import { isImageSource, isFileSource, getImageDimensions, isDefaultHotspot, isDefaultCrop, isAssetObjectStub, isImageAssetId, isFileAssetId } from "@sanity/asset-utils";
import imageUrlBuilder from "@sanity/image-url";
import { customAlphabet, nanoid } from "nanoid";
import cloneObject from "date-fns/_lib/cloneObject/index.js";
import dateFnsFormat from "date-fns/format/index.js";
import toInteger from "date-fns/_lib/toInteger/index.js";
import getTimezoneOffsetInMilliseconds from "date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js";
import { formatRelative, isValid, parse, isPast, addDays, startOfMonth, eachWeekOfInterval, lastDayOfMonth, getWeek, isSameDay, isSameMonth, setDate, setMonth, addMonths, setYear, setMinutes, setHours, format as format$2, parseISO, getMinutes, startOfHour, addHours, differenceInMonths, differenceInYears, differenceInWeeks, differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds, isBefore, startOfMinute, isWeekend, startOfDay, endOfDay, isAfter, set as set$1, startOfToday, endOfMinute, sub, formatDistance, isToday, isThisISOWeek, addWeeks } from "date-fns";
import { useTelemetry, TelemetryProvider } from "@sanity/telemetry/react";
import DataLoader from "dataloader";
import { mergeMapArray } from "rxjs-mergemap-array";
import { useRouter, IntentLink, useIntentLink, route, useRouterState, useStateLink, StateLink, RouteScope, STICKY_PARAMS, RouterProvider } from "sanity/router";
import isString$1 from "lodash/isString.js";
import { motion, AnimatePresence } from "framer-motion";
import uniqBy from "lodash/uniqBy.js";
import flatten$1 from "lodash/flatten.js";
import orderBy from "lodash/orderBy.js";
import compact from "lodash/compact.js";
import flow from "lodash/flow.js";
import toLower from "lodash/toLower.js";
import trim from "lodash/trim.js";
import union from "lodash/union.js";
import uniq from "lodash/uniq.js";
import words from "lodash/words.js";
import { randomKey as randomKey$1, isDeepEmpty, resolveTypeName as resolveTypeName$2, isShallowEmptyObject } from "@sanity/util/content";
import exif from "exif-component";
import capitalize from "lodash/capitalize.js";
import { useSensors, useSensor, PointerSensor, KeyboardSensor, DndContext, closestCenter } from "@dnd-kit/core";
import { restrictToHorizontalAxis, restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { sortableKeyboardCoordinates, useSortable, SortableContext, horizontalListSortingStrategy, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import shallowEquals from "shallow-equals";
import last$1 from "lodash/last.js";
import { PortableText as PortableText$1, toPlainText } from "@portabletext/react";
import { usePortableTextEditor, PortableTextEditor, usePortableTextEditorSelection, PortableTextEditable, EditorProvider, useEditor, keyGenerator as keyGenerator$1 } from "@portabletext/editor";
import { MarkdownPlugin, EventListenerPlugin } from "@portabletext/editor/plugins";
import { isHotkey } from "is-hotkey-esm";
import { useEffectEvent } from "use-effect-event";
import startCase from "lodash/startCase.js";
import { uuid } from "@sanity/uuid";
import template from "lodash/template.js";
import { applyPatches, parsePatch, cleanupEfficiency, makeDiff, DIFF_INSERT, DIFF_DELETE, DIFF_EQUAL, makePatches } from "@sanity/diff-match-patch";
import scrollIntoView$1 from "scroll-into-view-if-needed";
import difference from "lodash/difference.js";
import range from "lodash/range.js";
import { useSyncExternalStore as useSyncExternalStore$1 } from "use-sync-external-store/shim/index.js";
import castArray from "lodash/castArray.js";
import { MenuGroup } from "./_chunks-es/MenuGroup.mjs";
import deburr from "lodash/deburr.js";
import { normalizeBlock } from "@portabletext/block-tools";
import keyBy from "lodash/keyBy.js";
import pick from "lodash/pick.js";
import sample from "lodash/sample.js";
import intersection from "lodash/intersection.js";
import isEmpty$1 from "lodash/isEmpty.js";
import { renderToString } from "react-dom/server";
import isFinite from "lodash/isFinite.js";
import Refractor from "react-refractor";
import bash from "refractor/lang/bash.js";
import javascript from "refractor/lang/javascript.js";
import json from "refractor/lang/json.js";
import jsx2 from "refractor/lang/jsx.js";
import typescript from "refractor/lang/typescript.js";
import { makeFetchTransport, inboundFiltersIntegration, functionToStringIntegration, browserApiErrorsIntegration, breadcrumbsIntegration, globalHandlersIntegration, linkedErrorsIntegration, dedupeIntegration, httpContextIntegration, isInitialized, getClient, getCurrentScope, BrowserClient, defaultStackParser, Scope, init, withScope, captureException } from "@sentry/react";
import { SANITY_VERSION } from "./_chunks-es/version.mjs";
import { createMemoryHistory, createBrowserHistory } from "history";
import { useSyncExternalStoreWithSelector } from "use-sync-external-store/with-selector";
import escapeRegExp$1 from "lodash/escapeRegExp.js";
import { fromUrl } from "@sanity/bifur-client";
import { SanityLogo, SanityMonogram } from "@sanity/logos";
import semver, { satisfies } from "semver";
import { useHotModuleReload } from "use-hot-module-reload";
import isObject from "lodash/isObject.js";
import arrify from "arrify";
import { diffInput, wrap as wrap$1 } from "@sanity/diff";
import { getPublishedId as getPublishedId$1 } from "@sanity/client/csm";
import { parse as parse$2, evaluate } from "groq-js";
import { InsertMenu as InsertMenu$2 } from "@sanity/insert-menu";
import { applyPatch as applyPatch$1, incremental } from "mendoza";
import findIndex$1 from "lodash/findIndex.js";
import upperFirst from "lodash/upperFirst.js";
import getRandomValues from "get-random-values-esm";
import find from "lodash/find.js";
import clone from "lodash/clone.js";
import { reduce } from "json-reduce";
import { exhaustMapWithTrailing } from "rxjs-exhaustmap-with-trailing";
import { createClientConcurrencyLimiter } from "@sanity/util/client";
import { ConcurrencyLimiter } from "@sanity/util/concurrency-limiter";
import sortedIndex from "lodash/sortedIndex.js";
import identity$2 from "lodash/identity.js";
import values from "lodash/values.js";
import { createNode } from "@sanity/comlink";
import raf from "raf";
import speakingurl from "speakingurl";
import xor from "lodash/xor.js";
import { diffItem } from "@sanity/diff-patch";
import { createContext } from "sanity/_createContext";
import { createRoot } from "react-dom/client";
import { getLuminance, parseToRgb, rgb, mix } from "polished";
function createStore(reportedValues, publish2) {
  function add(id2, value) {
    reportedValues.has(id2), reportedValues.set(id2, value), publish2();
  }
  function update(id2, value) {
    reportedValues.has(id2), reportedValues.set(id2, value), publish2();
  }
  function remove2(id2) {
    reportedValues.has(id2), reportedValues.delete(id2), publish2();
  }
  return {
    add,
    remove: remove2,
    update
  };
}
function useTrackerStore() {
  const [reportedValues] = useState(() => /* @__PURE__ */ new Map()), [snapshot2, updateSnapshot] = useReducer(() => Array.from(reportedValues.entries()), []), debouncedUpdateSnapshot = useMemo(() => debounce(updateSnapshot, 10, {
    trailing: !0
  }), []);
  return {
    store: useMemo(() => createStore(reportedValues, debouncedUpdateSnapshot), [debouncedUpdateSnapshot, reportedValues]),
    snapshot: snapshot2
  };
}
function useTrackerStoreReporter(store, id2, value, t0) {
  const $ = c(10), isEqual2 = t0 === void 0 ? Object.is : t0, idRef = useRef(null), previousRef = useRef(null);
  let t1, t2;
  $[0] !== id2 || $[1] !== store || $[2] !== value ? (t1 = () => {
    if (id2 === null || store === null)
      return;
    const nextValue = value();
    return store.add(id2, nextValue), idRef.current = id2, previousRef.current = nextValue, () => {
      store.remove(id2), idRef.current = null, previousRef.current = null;
    };
  }, t2 = [id2, store, value], $[0] = id2, $[1] = store, $[2] = value, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useLayoutEffect(t1, t2);
  let t3;
  $[5] !== id2 || $[6] !== isEqual2 || $[7] !== store || $[8] !== value ? (t3 = () => {
    if (id2 === null || idRef.current === null || store === null || id2 !== idRef.current)
      return;
    const nextValue_0 = value();
    isEqual2(previousRef.current, nextValue_0) || (store.update(id2, nextValue_0), previousRef.current = nextValue_0);
  }, $[5] = id2, $[6] = isEqual2, $[7] = store, $[8] = value, $[9] = t3) : t3 = $[9], useLayoutEffect(t3);
}
function ChangeIndicatorsTrackerComponent(props2) {
  const $ = c(6), {
    children
  } = props2, {
    store,
    snapshot: snapshot2
  } = useTrackerStore();
  let t0;
  $[0] !== children || $[1] !== snapshot2 ? (t0 = /* @__PURE__ */ jsx(ChangeIndicatorTrackerContextGetSnapshot.Provider, { value: snapshot2, children }), $[0] = children, $[1] = snapshot2, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== store || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(ChangeIndicatorTrackerContextStore.Provider, { value: store, children: t0 }), $[3] = store, $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const ChangeIndicatorsTracker = memo(ChangeIndicatorsTrackerComponent), EMPTY_ARRAY$B = [];
function useChangeIndicatorsReportedValues() {
  const snapshot2 = useContext(ChangeIndicatorTrackerContextGetSnapshot);
  return snapshot2 === null ? (console.warn(new Error('No context provided for reporter. Make sure that the component calling "useChangeIndicatorsReportedValues()", is wrapped inside a <ChangeIndicatorsTracker> element')), EMPTY_ARRAY$B) : snapshot2;
}
const useChangeIndicatorsReporter = (id2, value, isEqual2) => {
  const store = useContext(ChangeIndicatorTrackerContextStore);
  store === null && console.warn(new Error('No context provided for reporter. Make sure that the component calling "useChangeIndicatorsReporter()", is wrapped inside a <ChangeIndicatorsTracker> element')), useTrackerStoreReporter(store, id2, value, isEqual2);
}, ChangeFieldWrapper = (props2) => {
  const $ = c(13), {
    path,
    hasHover
  } = props2, {
    onSetFocus
  } = useContext(ConnectorContext), [isHover, setHover] = useState(!1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setHover(!0);
  }, $[0] = t0) : t0 = $[0];
  const onMouseEnter = t0;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setHover(!1);
  }, $[1] = t1) : t1 = $[1];
  const onMouseLeave = t1, [element, setElement] = useState(null);
  let t2;
  t2 = element ? `change-${PathUtils.toString(path)}` : null;
  const reporterId = t2;
  let t3;
  $[2] !== element || $[3] !== hasHover || $[4] !== isHover || $[5] !== path ? (t3 = () => ({
    element,
    path,
    isChanged: !0,
    hasFocus: !1,
    hasHover: isHover,
    hasRevertHover: hasHover
  }), $[2] = element, $[3] = hasHover, $[4] = isHover, $[5] = path, $[6] = t3) : t3 = $[6], useChangeIndicatorsReporter(reporterId, t3, deepEquals);
  let t4;
  $[7] !== onSetFocus || $[8] !== path ? (t4 = (event) => {
    setFocusWithStopPropagation(event, onSetFocus, path);
  }, $[7] = onSetFocus, $[8] = path, $[9] = t4) : t4 = $[9];
  const handleClick = t4;
  let t5;
  return $[10] !== handleClick || $[11] !== props2.children ? (t5 = /* @__PURE__ */ jsx("div", { ref: setElement, onClick: handleClick, onMouseLeave, onMouseEnter, children: props2.children }), $[10] = handleClick, $[11] = props2.children, $[12] = t5) : t5 = $[12], t5;
};
function setFocusWithStopPropagation(event, onSetFocus, path) {
  event.stopPropagation(), onSetFocus(path);
}
function catchWithCount(selector) {
  return (input$) => {
    let successiveErrorsCount = 0;
    const errorOp = catchError((err, caught) => (successiveErrorsCount++, selector(err, successiveErrorsCount, caught).pipe(errorOp)));
    return input$.pipe(tap(() => {
      successiveErrorsCount = 0;
    }), errorOp);
  };
}
function createHookFromObservableFactory(observableFactory, initialValue) {
  const initialLoadingTuple = [initialValue, !0], initialResult = {
    type: "tuple",
    tuple: initialLoadingTuple
  };
  return function(arg) {
    const observable = useMemo(() => of(arg).pipe(switchMap((_arg) => concat(of({
      type: "loading"
    }), observableFactory(_arg).pipe(map((value) => ({
      type: "value",
      value
    }))))), scan(([prevValue], next) => next.type === "loading" ? [prevValue, !0] : [next.value, !1], initialLoadingTuple), distinctUntilChanged(([prevValue, prevIsLoading], [nextValue, nextIsLoading]) => !(prevValue !== nextValue || prevIsLoading !== nextIsLoading)), map((tuple) => ({
      type: "tuple",
      tuple
    })), catchError((error) => of({
      type: "error",
      error
    }))), [arg]), result = useObservable(observable, initialResult);
    if (result.type === "error") throw result.error;
    return result.tuple;
  };
}
function isNonNullable$3(value) {
  return value != null;
}
const DRAFTS_FOLDER = "drafts", VERSION_FOLDER = "versions", PATH_SEPARATOR = ".", DRAFTS_PREFIX = `${DRAFTS_FOLDER}${PATH_SEPARATOR}`, VERSION_PREFIX = `${VERSION_FOLDER}${PATH_SEPARATOR}`;
function documentIdEquals(documentId, equalsDocumentId) {
  return getPublishedId(documentId) === getPublishedId(equalsDocumentId);
}
function isDraft(document2) {
  return isDraftId(document2._id);
}
function isDraftId(id2) {
  return id2.startsWith(DRAFTS_PREFIX);
}
function isVersionId(id2) {
  return id2.startsWith(VERSION_PREFIX);
}
function getIdPair(id2, {
  version
} = {}) {
  if (version === "drafts" || version === "published")
    throw new Error('Version can not be "published" or "drafts"');
  return {
    publishedId: getPublishedId(id2),
    draftId: getDraftId(id2),
    ...version ? {
      versionId: getVersionId(id2, version)
    } : {}
  };
}
function isPublishedId(id2) {
  return !isDraftId(id2) && !isVersionId(id2);
}
function getDraftId(id2) {
  if (isVersionId(id2)) {
    const publishedId = getPublishedId(id2);
    return DRAFTS_PREFIX + publishedId;
  }
  return isDraftId(id2) ? id2 : DRAFTS_PREFIX + id2;
}
const systemBundles = ["drafts", "published"];
function isSystemBundle(maybeSystemBundle) {
  return systemBundles.includes(maybeSystemBundle);
}
const systemBundleNames = ["draft", "published"];
function isSystemBundleName(maybeSystemBundleName) {
  return systemBundleNames.includes(maybeSystemBundleName);
}
function getVersionId(id2, version) {
  if (isSystemBundle(version))
    throw new Error('Version can not be "published" or "drafts"');
  return `${VERSION_PREFIX}${version}${PATH_SEPARATOR}${getPublishedId(id2)}`;
}
function idMatchesPerspective(perspectiveStack, documentId) {
  return isPublishedId(documentId) ? !0 : perspectiveStack.some((perspective) => perspective === "drafts" ? isDraftId(documentId) : getVersionFromId(documentId) === perspective);
}
function getVersionFromId(id2) {
  if (!isVersionId(id2)) return;
  const [_versionPrefix, versionId, ..._publishedId] = id2.split(PATH_SEPARATOR);
  return versionId;
}
function getPublishedId(id2) {
  return isVersionId(id2) ? id2.split(PATH_SEPARATOR).slice(2).join(PATH_SEPARATOR) : isDraftId(id2) ? id2.slice(DRAFTS_PREFIX.length) : id2;
}
function createDraftFrom(document2) {
  return {
    ...document2,
    _id: getDraftId(document2._id)
  };
}
function newDraftFrom(document2) {
  return {
    ...document2,
    _id: DRAFTS_PREFIX
  };
}
function createPublishedFrom(document2) {
  return {
    ...document2,
    _id: getPublishedId(document2._id)
  };
}
function collate(documents) {
  const byId = documents.reduce((res, doc) => {
    const publishedId = getPublishedId(doc._id);
    let entry = res.get(publishedId);
    return entry || (entry = {
      id: publishedId,
      type: doc._type,
      published: void 0,
      draft: void 0,
      versions: []
    }, res.set(publishedId, entry)), isPublishedId(doc._id) && (entry.published = doc), isDraftId(doc._id) && (entry.draft = doc), isVersionId(doc._id) && entry.versions.push(doc), res;
  }, /* @__PURE__ */ new Map());
  return Array.from(byId.values());
}
function removeDupes$3(documents) {
  return collate(documents).map((entry) => entry.draft || entry.published || entry.versions[0]).filter(isNonNullable$3);
}
const EMPTY_OBJECT = Object.freeze({}), EMPTY_ARRAY$A = Object.freeze([]), formatRelativeLocale = (...args) => {
  const dateFnsRelative = formatRelative(...args);
  if (isValid(parse(dateFnsRelative, "MM/dd/yyyy", /* @__PURE__ */ new Date()))) {
    const [dateTime] = args;
    return new Date(dateTime).toLocaleDateString();
  }
  return dateFnsRelative;
};
function getDocumentVariantType(documentId) {
  return isDraftId(documentId) ? "draft" : isVersionId(documentId) ? "version" : "published";
}
function getGlobalScope() {
  if (typeof globalThis < "u") return globalThis;
  if (typeof window < "u") return window;
  if (typeof self < "u") return self;
  if (typeof global < "u") return global;
  throw new Error("@sanity/ui: could not locate global scope");
}
const globalScope = getGlobalScope();
function isArray(value) {
  return Array.isArray(value);
}
function isRecord$4(value) {
  return !!value && typeof value == "object" && !Array.isArray(value);
}
function isString(value) {
  return typeof value == "string";
}
function isTruthy(value) {
  return !!value;
}
const ResizeObserver = typeof document == "object" && typeof window == "object" && window.ResizeObserver ? window.ResizeObserver : ResizeObserver$1, createSharedResizeObserver = () => {
  const event = createPubSub(), resizeObserver2 = new ResizeObserver((entries) => event.publish(entries));
  return {
    observe: (element, observer, options) => {
      const unsubscribe = event.subscribe((entries) => {
        const entry = entries.find((e) => e.target === element);
        entry && observer(entry);
      });
      return resizeObserver2.observe(element, options), () => {
        unsubscribe(), resizeObserver2.unobserve(element);
      };
    },
    unobserve: (element) => resizeObserver2.unobserve(element)
  };
}, resizeObserver = createSharedResizeObserver(), createSWRCache = createLRUCache;
function createSWR(options) {
  const cache2 = createSWRCache(options);
  return function(key) {
    return (input$) => concat(defer(() => cache2.has(key) ? of({
      fromCache: !0,
      value: cache2.get(key)
    }) : EMPTY$6), input$.pipe(tap((result) => cache2.set(key, result)), map$1((value) => ({
      fromCache: !1,
      value
    }))));
  };
}
function createLRUCache(options) {
  const lru = new QuickLRU(options);
  return {
    get(key) {
      const entry = lru.get(key);
      if (!entry)
        throw new Error(`Key not found in LRU cache: ${key}`);
      return entry.value;
    },
    set(key, value) {
      lru.set(key, {
        value
      });
    },
    delete(key) {
      lru.delete(key);
    },
    has(key) {
      return lru.has(key);
    }
  };
}
const BUNDLED_DOC_TYPES = ["sanity.imageAsset", "sanity.fileAsset"];
function _isSanityDocumentTypeDefinition(def) {
  return def.type === "document" && BUNDLED_DOC_TYPES.includes(def.name);
}
function _isCustomDocumentTypeDefinition(def) {
  return def.type === "document" && !_isSanityDocumentTypeDefinition(def);
}
const GROQ_KEYWORDS = ["match", "in", "asc", "desc", "true", "false", "null"], VALID_FIELD = /^[a-zA-Z_][a-zA-Z0-9_]*$/, fieldNeedsEscape = (fieldName) => !VALID_FIELD.test(fieldName) || GROQ_KEYWORDS.includes(fieldName), escapeField = (fieldName) => `["${fieldName}"]`, escapeFirst = (fieldName) => `@${escapeField(fieldName)}`, isEmptyArray = (value) => Array.isArray(value) && value.length === 0, joinPath = (pathArray) => {
  let path = "";
  for (let i = 0; i < pathArray.length; i++) {
    const pathSegment = pathArray[i];
    if (isEmptyArray(pathSegment)) {
      path += "[]";
      continue;
    }
    if (typeof pathSegment == "number") {
      path += `[${pathSegment}]`;
      continue;
    }
    const isFirst = i === 0;
    fieldNeedsEscape(pathSegment) ? path = isFirst ? escapeFirst(pathSegment) : `${path}${escapeField(pathSegment)}` : path = isFirst ? pathSegment : `${path}.${pathSegment}`;
  }
  return path;
}, supportsTouch = isTouchDevice$1();
function isTouchDevice$1() {
  return typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
const FONT_SANS_SERIF = "-apple-system, BlinkMacSystemFont, \\'Segoe UI\\', Roboto, \\'Helvetica Neue\\', Helvetica, Arial, system-ui, sans-serif", FONT_MONOSPACE = "-apple-system-ui-monospace, \\'SF Mono\\', Menlo, Monaco, Consolas, monospace", uncaughtErrorHandler = () => (
  // prettier-ignore
  ["window.onerror = function(m,u,l,c,e) {", "var p=window.location.port;", "var h=window.location.protocol+'//'+window.location.hostname+(p?':'+p:'');", "var r=document.getElementById('sanity');", "while(r.firstChild){r.removeChild(r.firstChild);}", "var s=document.createElement('style');", "s.appendChild(document.createTextNode('", "html,body,#sanityBody,#sanity,#sanityError{height:100%;}", "body{-webkit-font-smoothing:antialiased;margin:0;}", `#sanityError{position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;background-color:#fff;color:#121923;font-family:${FONT_SANS_SERIF};font-size:16px;line-height:21px;min-height:100%;}`, "#sanityError>div{background-color:#fff;max-width:960px;margin:0 auto;padding:47px 32px 52px;}", "@media(min-width:512px){", "#sanityError>div{", "padding:47px 84px;", "}", "}", "#sanityError button{-webkit-font-smoothing:inherit;font:inherit;font-weight:500;background-color:#2276FC;color:#fff;padding:7px 12px;border-radius:3px;border:0;}", "#sanityError button:hover{background-color:#1E63D0;}", "#sanityError button:active{background-color:#1B50A5;}", "'));", "document.head.appendChild(s);", "var f=document.createElement('div');", "f.id='sanityError';", "f.innerHTML='", "<div>", '<h1 style="font-size:21px;line-height:27px;margin: 0 0 10px;">Unhandled error</h1>', '<p style="color:#66758D;margin:10px 0 14px;">Encountered an unhandled error in this Studio.</p>', '<button class="sanity-error-handler__reload-btn" type="button">Reload page</button>', '<pre style="background-color:#FDEBEA;color:#C3362C;font-size:13px;line-height:17px;padding:8px 12px;border-radius:3px;margin:32px 0 0;overflow:auto;">', `<code style="font-family:${FONT_MONOSPACE};">`, "'+e.stack.replaceAll(h,'')+'", "</code>", "</pre>", "</div>", "';", "var b=f.querySelector('.sanity-error-handler__reload-btn');", "if(b){", "b.onclick=function() {", "window.location.reload();", "}", "};", "r.appendChild(f);", "};"].join("")
), segmenter = typeof Intl == "object" && "Segmenter" in Intl ? new Intl.Segmenter() : void 0;
function sliceString(str, start, end) {
  if (end < start)
    throw new Error("End must be greater than start, use `String.prototype.slice()` for negative values");
  if (!segmenter)
    return str.slice(start, end);
  let i = 0, sliced = "";
  for (const value of segmenter.segment(str)) {
    if (i === end)
      return sliced;
    sliced += value.segment, i++;
  }
  return sliced;
}
function truncateString(str, maxLength) {
  const truncated = sliceString(str, 0, maxLength);
  return truncated === str ? truncated : `${truncated}\u2026`;
}
const LOADING_STATE$1 = {
  isLoading: !0,
  value: void 0,
  error: null
};
function useLoadable(value$, initialValue) {
  const $ = c(4);
  let t0;
  $[0] !== initialValue ? (t0 = typeof initialValue > "u" ? LOADING_STATE$1 : {
    isLoading: !1,
    value: initialValue,
    error: null
  }, $[0] = initialValue, $[1] = t0) : t0 = $[1];
  const initial2 = t0;
  let t1, t2;
  return $[2] !== value$ ? (t2 = value$.pipe(asLoadable()), $[2] = value$, $[3] = t2) : t2 = $[3], t1 = t2, useObservable(t1, initial2);
}
function asLoadable() {
  return (value$) => value$.pipe(map((value) => ({
    isLoading: !1,
    value,
    error: null
  })), catchError((error) => of({
    isLoading: !1,
    value: void 0,
    error
  })));
}
function userHasRole(user, roleId) {
  return user !== null && user.roles.some((role) => role.name === roleId);
}
function useThrottledCallback(callback, wait, options) {
  const $ = c(4);
  let t0, t1;
  return $[0] !== callback || $[1] !== options || $[2] !== wait ? (t1 = throttle(callback, wait, options), $[0] = callback, $[1] = options, $[2] = wait, $[3] = t1) : t1 = $[3], t0 = t1, t0;
}
function useUnique(value) {
  const [previous, setPrevious] = useState(value);
  return isEqual$2(previous, value) ? previous : (setPrevious(value), value);
}
const DEBUG_MODE$2 = typeof process > "u" ? !1 : process?.env?.SANITY_STUDIO_DEBUG_I18N, DEBUG_I18N = !!DEBUG_MODE$2, debugWrappers = {
  reverse: (str) => `\u202E${str}`,
  triangles: (str) => `\u25E4 ${str} \u25E2`
};
function maybeWrapT(t) {
  const wrapper = DEBUG_MODE$2 === "reverse" || DEBUG_MODE$2 === "triangles" ? debugWrappers[DEBUG_MODE$2] : null;
  return wrapper ? (...args) => wrapper(t(...args)) : t;
}
const translationOptionOverrides = {
  // We're manually forcing a re-render with the locale key in the LocaleProvider,
  // so we don't need to bind to the i18n instance for language change events.
  bindI18n: !1
};
function useTranslation(ns, options) {
  const $ = c(6);
  let t0;
  $[0] !== options ? (t0 = options ? {
    keyPrefix: options.keyPrefix,
    lng: options.lng,
    ...translationOptionOverrides
  } : translationOptionOverrides, $[0] = options, $[1] = t0) : t0 = $[1];
  const {
    t
  } = useTranslation$1(ns, t0);
  let t1;
  $[2] !== t ? (t1 = maybeWrapT(t), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== t1 ? (t2 = {
    t: t1
  }, $[4] = t1, $[5] = t2) : t2 = $[5], t2;
}
const animationSpeed = 250, ChangeBarWrapper$1 = styled.div(({
  $changed,
  $disabled,
  $hasFocus,
  $isReviewChangeOpen
}) => $disabled ? css`
        ${ChangeBarMarker}:after {
          display: none;
        }
      ` : css`
      --change-bar-offset: 4px;

      display: flex;
      position: relative;

      ${ChangeBarMarker}:after {
        opacity: 0.5;
      }

      @media (hover: hover) {
        &:hover {
          z-index: 10;
          ${ChangeBarMarker}:after {
            opacity: 1;
          }
        }
      }

      /* hide when field is not changed */
      ${$hasFocus && css`
        ${ChangeBarMarker}:after {
          opacity: 1;
        }
      `}

      /* hide when field is not changed */
      ${!$changed && css`
        ${ChangeBarMarker}:after {
          opacity: 0;
          pointer-events: none;
        }
      `}

      /* hide hover effect when review changes is open */
      ${$isReviewChangeOpen && css`
        ${ChangeBarButton} {
          opacity: 0;
        }
      `}
    `), FieldWrapper$1 = styled.div`
  flex-grow: 1;
  min-width: 0;
`, ChangeBar = styled.div`
  position: relative;
  opacity: 1;
  transition: opacity 100ms;
  z-index: ${({
  $zIndex
}) => $zIndex};
`, ChangeBarMarker = styled.div((props2) => {
  const {
    media
  } = getTheme_v2(props2.theme);
  return css`
    position: absolute;
    top: -1px;
    left: var(--change-bar-offset);
    width: 1px;
    bottom: -1px;
    background-color: var(--card-bg-color);

    @media (min-width: ${media[0]}px) {
      display: unset;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 1px;
      left: 0;
      width: 1px;
      bottom: 1px;
      background-color: var(--card-badge-caution-dot-color);
      border-radius: 0.5px;
    }
  `;
}), ChangeBarButton = styled.button((props2) => {
  const {
    $withHoverEffect,
    $isInteractive
  } = props2;
  return css`
    appearance: none;
    border: 0;
    outline: 0;
    display: block;
    padding: 0;
    background: transparent;
    opacity: 0;
    position: absolute;
    height: 100%;

    ${$isInteractive && css`
      cursor: pointer;
      pointer-events: all;
    `}

    left: calc(-0.25rem + var(--change-bar-offset));
    width: calc(1rem - 1px);
    transition: opacity ${animationSpeed}ms;

    &:focus {
      border: 0;
      outline: 0;
    }

    &:focus {
      border: 0;
      outline: 0;
    }

    ${$withHoverEffect && css`
      @media (hover: hover) {
        &:hover {
          opacity: 0.2;
        }
      }
    `}
  `;
});
function ElementWithChangeBar(props2) {
  const $ = c(18), {
    children,
    disabled,
    hasFocus,
    isChanged,
    withHoverEffect: t0,
    isInteractive: t1
  } = props2, withHoverEffect = t0 === void 0 ? !0 : t0, isInteractive = t1 === void 0 ? !0 : t1, {
    onOpenReviewChanges,
    isReviewChangesOpen
  } = useContext(ConnectorContext), {
    zIndex
  } = useLayer(), {
    t
  } = useTranslation();
  let t2, t3;
  $[0] !== disabled || $[1] !== isChanged || $[2] !== isInteractive || $[3] !== isReviewChangesOpen || $[4] !== onOpenReviewChanges || $[5] !== t || $[6] !== withHoverEffect || $[7] !== zIndex ? (t3 = disabled || !isChanged ? null : /* @__PURE__ */ jsxs(ChangeBar, { "data-testid": "change-bar", $zIndex: zIndex, children: [
    /* @__PURE__ */ jsx(ChangeBarMarker, { "data-testid": "change-bar__marker" }),
    /* @__PURE__ */ jsx(Tooltip, { content: t("changes.change-bar.aria-label"), portal: !0, disabled: !isInteractive, children: /* @__PURE__ */ jsx(ChangeBarButton, { "aria-label": t("changes.change-bar.aria-label"), "data-testid": "change-bar__button", onClick: isReviewChangesOpen ? void 0 : onOpenReviewChanges, tabIndex: -1, type: "button", $withHoverEffect: withHoverEffect, $isInteractive: isInteractive }) })
  ] }), $[0] = disabled, $[1] = isChanged, $[2] = isInteractive, $[3] = isReviewChangesOpen, $[4] = onOpenReviewChanges, $[5] = t, $[6] = withHoverEffect, $[7] = zIndex, $[8] = t3) : t3 = $[8], t2 = t3;
  const changeBar = t2;
  let t4;
  $[9] !== children ? (t4 = /* @__PURE__ */ jsx(FieldWrapper$1, { "data-testid": "change-bar__field-wrapper", children }), $[9] = children, $[10] = t4) : t4 = $[10];
  let t5;
  return $[11] !== changeBar || $[12] !== disabled || $[13] !== hasFocus || $[14] !== isChanged || $[15] !== isReviewChangesOpen || $[16] !== t4 ? (t5 = /* @__PURE__ */ jsxs(ChangeBarWrapper$1, { "data-testid": "change-bar-wrapper", $changed: isChanged, $disabled: disabled, $hasFocus: hasFocus, $isReviewChangeOpen: isReviewChangesOpen, children: [
    t4,
    changeBar
  ] }), $[11] = changeBar, $[12] = disabled, $[13] = hasFocus, $[14] = isChanged, $[15] = isReviewChangesOpen, $[16] = t4, $[17] = t5) : t5 = $[17], t5;
}
const ChangeBarWrapper = memo(function(props2) {
  const $ = c(34);
  let children, disabled, hasFocus, isChanged, isInteractive, onMouseEnterProp, onMouseLeaveProp, restProps, t0, withHoverEffect;
  $[0] !== props2 ? ({
    children,
    disabled,
    hasFocus,
    isChanged,
    onMouseEnter: onMouseEnterProp,
    onMouseLeave: onMouseLeaveProp,
    path: t0,
    withHoverEffect,
    isInteractive,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = disabled, $[3] = hasFocus, $[4] = isChanged, $[5] = isInteractive, $[6] = onMouseEnterProp, $[7] = onMouseLeaveProp, $[8] = restProps, $[9] = t0, $[10] = withHoverEffect) : (children = $[1], disabled = $[2], hasFocus = $[3], isChanged = $[4], isInteractive = $[5], onMouseEnterProp = $[6], onMouseLeaveProp = $[7], restProps = $[8], t0 = $[9], withHoverEffect = $[10]);
  const path = t0 === void 0 ? EMPTY_ARRAY$A : t0, layer = useLayer(), [hasHover, setHover] = useState(!1);
  let t1;
  $[11] !== onMouseEnterProp ? (t1 = (event) => {
    onMouseEnterProp?.(event), setHover(!0);
  }, $[11] = onMouseEnterProp, $[12] = t1) : t1 = $[12];
  const onMouseEnter = t1;
  let t2;
  $[13] !== onMouseLeaveProp ? (t2 = (event_0) => {
    onMouseLeaveProp?.(event_0), setHover(!1);
  }, $[13] = onMouseLeaveProp, $[14] = t2) : t2 = $[14];
  const onMouseLeave = t2, [element, setElement] = useState(null);
  let t3;
  t3 = disabled || !element ? null : `field-${PathUtils.toString(path)}`;
  const reporterId = t3;
  let t4;
  $[15] !== element || $[16] !== hasFocus || $[17] !== hasHover || $[18] !== isChanged || $[19] !== layer.zIndex || $[20] !== path ? (t4 = () => ({
    element,
    path,
    isChanged,
    hasFocus,
    hasHover,
    zIndex: layer.zIndex
  }), $[15] = element, $[16] = hasFocus, $[17] = hasHover, $[18] = isChanged, $[19] = layer.zIndex, $[20] = path, $[21] = t4) : t4 = $[21], useChangeIndicatorsReporter(reporterId, t4, deepEquals);
  let t5;
  $[22] !== children || $[23] !== disabled || $[24] !== hasFocus || $[25] !== isChanged || $[26] !== isInteractive || $[27] !== withHoverEffect ? (t5 = /* @__PURE__ */ jsx(ElementWithChangeBar, { hasFocus, isChanged, disabled, withHoverEffect, isInteractive, children }), $[22] = children, $[23] = disabled, $[24] = hasFocus, $[25] = isChanged, $[26] = isInteractive, $[27] = withHoverEffect, $[28] = t5) : t5 = $[28];
  let t6;
  return $[29] !== onMouseEnter || $[30] !== onMouseLeave || $[31] !== restProps || $[32] !== t5 ? (t6 = /* @__PURE__ */ jsx("div", { ...restProps, ref: setElement, onMouseEnter, onMouseLeave, children: t5 }), $[29] = onMouseEnter, $[30] = onMouseLeave, $[31] = restProps, $[32] = t5, $[33] = t6) : t6 = $[33], t6;
});
function ChangeIndicator(props2) {
  const $ = c(15);
  let children, hasFocus, isChanged, path, restProps, withHoverEffect;
  $[0] !== props2 ? ({
    children,
    hasFocus,
    isChanged,
    path,
    withHoverEffect,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = hasFocus, $[3] = isChanged, $[4] = path, $[5] = restProps, $[6] = withHoverEffect) : (children = $[1], hasFocus = $[2], isChanged = $[3], path = $[4], restProps = $[5], withHoverEffect = $[6]);
  const {
    isInteractive
  } = useContext(ConnectorContext);
  let t0;
  return $[7] !== children || $[8] !== hasFocus || $[9] !== isChanged || $[10] !== isInteractive || $[11] !== path || $[12] !== restProps || $[13] !== withHoverEffect ? (t0 = /* @__PURE__ */ jsx(ChangeBarWrapper, { ...restProps, path, hasFocus, isChanged, withHoverEffect, isInteractive, children }), $[7] = children, $[8] = hasFocus, $[9] = isChanged, $[10] = isInteractive, $[11] = path, $[12] = restProps, $[13] = withHoverEffect, $[14] = t0) : t0 = $[14], t0;
}
function useOnScroll(callback) {
  const $ = c(4), parentContext = useContext(ScrollContext);
  let t0, t1;
  $[0] !== callback || $[1] !== parentContext ? (t0 = () => parentContext?.subscribe(callback), t1 = [callback, parentContext], $[0] = callback, $[1] = parentContext, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
}
const ScrollContainerComponent = forwardRef(function(props2, forwardedRef) {
  const $ = c(22);
  let onScroll, rest, t0;
  $[0] !== props2 ? ({
    as: t0,
    onScroll,
    ...rest
  } = props2, $[0] = props2, $[1] = onScroll, $[2] = rest, $[3] = t0) : (onScroll = $[1], rest = $[2], t0 = $[3]);
  const As = t0 === void 0 ? "div" : t0, ref = useRef(null);
  let t1;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => ref.current, $[4] = t1) : t1 = $[4], useImperativeHandle(forwardedRef, t1);
  const parentContext = useContext(ScrollContext), [childContext] = useState(_temp$2H);
  let t2, t3;
  $[5] !== childContext || $[6] !== onScroll ? (t2 = () => {
    if (onScroll)
      return childContext.subscribe(onScroll);
  }, t3 = [childContext, onScroll], $[5] = childContext, $[6] = onScroll, $[7] = t2, $[8] = t3) : (t2 = $[7], t3 = $[8]), useEffect(t2, t3);
  let t4, t5;
  $[9] !== childContext || $[10] !== parentContext ? (t4 = () => {
    if (parentContext)
      return childContext.subscribe(parentContext.publish);
  }, t5 = [parentContext, childContext], $[9] = childContext, $[10] = parentContext, $[11] = t4, $[12] = t5) : (t4 = $[11], t5 = $[12]), useEffect(t4, t5);
  let t6, t7;
  $[13] !== childContext ? (t6 = () => {
    const handleScroll = (event) => {
      childContext.publish(event);
    }, el = ref.current;
    if (el)
      return el.addEventListener("scroll", handleScroll, {
        passive: !0,
        capture: !0
      }), () => {
        el.removeEventListener("scroll", handleScroll);
      };
  }, t7 = [childContext, ref], $[13] = childContext, $[14] = t6, $[15] = t7) : (t6 = $[14], t7 = $[15]), useEffect(t6, t7);
  let t8;
  $[16] !== As || $[17] !== rest ? (t8 = /* @__PURE__ */ jsx(As, { "data-testid": "scroll-container", ...rest, ref }), $[16] = As, $[17] = rest, $[18] = t8) : t8 = $[18];
  let t9;
  return $[19] !== childContext || $[20] !== t8 ? (t9 = /* @__PURE__ */ jsx(ScrollContext.Provider, { value: childContext, children: t8 }), $[19] = childContext, $[20] = t8, $[21] = t9) : t9 = $[21], t9;
}), ScrollContainer = memo(ScrollContainerComponent);
ScrollContainer.displayName = "Memo(Forwardref(ScrollContainer))";
function _temp$2H() {
  return createPubSub();
}
const CORNER_RADIUS = 4, INTERACTIVE_STROKE_WIDTH = 16, CONNECTOR_MARGIN = 8, ARROW_MARGIN_X = 8, ARROW_MARGIN_Y = 2, ARROW_SIZE = 4, ARROW_THRESHOLD = 12, STROKE_WIDTH$2 = 1, DEBUG$1 = !1, DEBUG_LAYER_BOUNDS = !1;
function findMostSpecificTarget(targetType, id2, values2) {
  const pathString = id2.slice(id2.indexOf("-") + 1) || "[]", path = PathUtils.fromString(pathString), exactId = `${targetType}-${PathUtils.toString(path)}`;
  if (values2.has(exactId))
    return values2.get(exactId);
  let mostSpecific;
  for (const [targetId, target] of values2) {
    if (!("path" in target) || !targetId.startsWith(targetType))
      continue;
    const numEqual = PathUtils.numEqualSegments(path, target.path), lastPathSegment = target.path[target.path.length - 1], pathOnlyDiffersByKey = numEqual === target.path.length - 1 && isKeyedObject(lastPathSegment);
    if (numEqual !== 0 && !(numEqual !== target.path.length && !pathOnlyDiffersByKey) && (mostSpecific = target, numEqual === path.length))
      break;
  }
  return mostSpecific;
}
function hasOverflowScroll(el) {
  const overflow = getComputedStyle(el).overflow;
  return overflow.includes("auto") || overflow.includes("scroll");
}
function isScrollable(el) {
  return (el.scrollHeight !== el.offsetHeight || el.scrollWidth !== el.offsetWidth) && hasOverflowScroll(el);
}
const getOffsetsTo$1 = (source, target) => {
  const bounds = {
    top: 0,
    left: 0,
    height: target.offsetHeight,
    width: target.offsetWidth
  }, rect = {
    top: 0,
    left: 0,
    height: source.offsetHeight,
    width: source.offsetWidth
  };
  let foundScrollContainer = !1, el = source;
  for (; el && el !== target && target.contains(el); )
    foundScrollContainer && (bounds.top += el.offsetTop, bounds.left += el.offsetLeft), hasOverflowScroll(el) && (bounds.top = el.offsetTop, bounds.height = el.offsetHeight, bounds.left = el.offsetLeft, bounds.width = el.offsetWidth, foundScrollContainer = !0), rect.top += el.offsetTop - el.scrollTop, rect.left += el.offsetLeft - el.scrollLeft, el = el.offsetParent;
  return {
    rect,
    bounds
  };
};
function isChangeBar(v) {
  return v[0] !== "changePanel";
}
const SCROLL_INTO_VIEW_TOP_PADDING = -15;
function scrollIntoView(field) {
  const element = field.element;
  if (!element) return;
  let parentElementWithScroll = element;
  for (; !isScrollable(parentElementWithScroll); )
    if (parentElementWithScroll = parentElementWithScroll.parentElement, !parentElementWithScroll)
      return;
  parentElementWithScroll.scroll({
    top: parentElementWithScroll.scrollTop + field.rect.top - field.bounds.top + SCROLL_INTO_VIEW_TOP_PADDING,
    left: 0,
    behavior: "smooth"
  });
}
function ClampedRect(props2) {
  const $ = c(9);
  let bounds, rest;
  $[0] !== props2 ? ({
    bounds,
    ...rest
  } = props2, $[0] = props2, $[1] = bounds, $[2] = rest) : (bounds = $[1], rest = $[2]);
  const x = Math.max(bounds.left, props2.left), y = Math.max(props2.top, bounds.top), height = Math.max(0, props2.height - (y - props2.top)), width = Math.max(0, props2.width - (x - props2.left));
  let t0;
  return $[3] !== height || $[4] !== rest || $[5] !== width || $[6] !== x || $[7] !== y ? (t0 = /* @__PURE__ */ jsx("rect", { ...rest, x, y, height, width }), $[3] = height, $[4] = rest, $[5] = width, $[6] = x, $[7] = y, $[8] = t0) : t0 = $[8], t0;
}
styled.rect`
  stroke: #ccc;
  fill: none;
  pointer-events: none;
  stroke-linecap: round;
`;
const ConnectorPath = styled.path`
  fill: none;
  pointer-events: none;
  stroke-linejoin: round;
  stroke: var(--card-badge-caution-dot-color);
`, InteractivePath = styled.path`
  fill: none;
  pointer-events: stroke;
  stroke: transparent;
  cursor: pointer;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0;

  &:hover {
    opacity: 0.2;
  }
`, RightBarWrapper = styled(ClampedRect)`
  stroke: none;
  pointer-events: none;
  fill: var(--card-badge-caution-dot-color);
`;
function arrowPath(x, y, dir) {
  return [`M ${x - ARROW_SIZE} ${y - ARROW_SIZE * dir} `, `L ${x} ${y}`, `L ${x + ARROW_SIZE} ${y - ARROW_SIZE * dir}`].join("");
}
function moveTo(x, y) {
  return `M${x} ${y}`;
}
function lineTo(x, y) {
  return `L${x} ${y}`;
}
function join(strings2, delim = "") {
  return strings2.join(delim);
}
function quadCurve(x1, y1, x, y) {
  return `Q${x1} ${y1} ${x} ${y}`;
}
function generateConnectorPath(line) {
  const {
    from: from2,
    to
  } = line, {
    left: fromX,
    top: fromY
  } = from2, {
    left: toX,
    top: toY
  } = to, cmds = [], r1 = Math.min(CORNER_RADIUS, Math.abs(fromY - toY) / 2);
  return from2.isAbove ? cmds.push(moveTo(fromX + ARROW_MARGIN_X, fromY - ARROW_THRESHOLD + ARROW_MARGIN_Y), lineTo(fromX + ARROW_MARGIN_X, fromY - CORNER_RADIUS), quadCurve(fromX + ARROW_MARGIN_X, fromY, fromX + ARROW_MARGIN_X + CORNER_RADIUS, fromY)) : from2.isBelow ? cmds.push(moveTo(fromX + ARROW_MARGIN_X, fromY + ARROW_THRESHOLD - ARROW_MARGIN_Y), lineTo(fromX + ARROW_MARGIN_X, fromY + CORNER_RADIUS), quadCurve(fromX + ARROW_MARGIN_X, fromY, fromX + ARROW_MARGIN_X + CORNER_RADIUS, fromY)) : cmds.push(moveTo(fromX, fromY)), to.isAbove ? fromY < to.bounds.top ? cmds.push(lineTo(to.bounds.left - 8 - r1, fromY), quadCurve(to.bounds.left - 8, fromY, to.bounds.left - 8, fromY + r1), lineTo(to.bounds.left - 8, toY - r1), quadCurve(to.bounds.left - 8, toY, to.bounds.left - 8 + r1, toY), lineTo(to.bounds.left + ARROW_MARGIN_X - CORNER_RADIUS, toY), quadCurve(to.bounds.left + ARROW_MARGIN_X, toY, to.bounds.left + ARROW_MARGIN_X, toY - CORNER_RADIUS), lineTo(to.bounds.left + ARROW_MARGIN_X, toY - ARROW_THRESHOLD + ARROW_MARGIN_Y)) : cmds.push(lineTo(to.bounds.left + ARROW_MARGIN_X - CORNER_RADIUS, fromY), quadCurve(to.bounds.left + ARROW_MARGIN_X, fromY, to.bounds.left + ARROW_MARGIN_X, fromY - CORNER_RADIUS), lineTo(to.bounds.left + ARROW_MARGIN_X, toY - ARROW_THRESHOLD + ARROW_MARGIN_Y)) : to.isBelow ? fromY > to.bounds.top + to.bounds.height ? cmds.push(lineTo(to.bounds.left - ARROW_MARGIN_X - r1, fromY), quadCurve(to.bounds.left - ARROW_MARGIN_X, fromY, to.bounds.left - ARROW_MARGIN_X, fromY - r1), lineTo(to.bounds.left - ARROW_MARGIN_X, toY + r1), quadCurve(to.bounds.left - ARROW_MARGIN_X, toY, to.bounds.left - ARROW_MARGIN_X + r1, toY), lineTo(to.bounds.left + ARROW_MARGIN_X - CORNER_RADIUS, toY), quadCurve(to.bounds.left + ARROW_MARGIN_X, toY, to.bounds.left + ARROW_MARGIN_X, toY + CORNER_RADIUS), lineTo(to.bounds.left + ARROW_MARGIN_X, toY + ARROW_THRESHOLD - ARROW_MARGIN_Y)) : cmds.push(lineTo(to.bounds.left + ARROW_MARGIN_X - CORNER_RADIUS, fromY), quadCurve(to.bounds.left + ARROW_MARGIN_X, fromY, to.bounds.left + ARROW_MARGIN_X, fromY + CORNER_RADIUS), lineTo(to.bounds.left + ARROW_MARGIN_X, toY + ARROW_THRESHOLD - ARROW_MARGIN_Y)) : fromY < toY ? cmds.push(lineTo(to.bounds.left + ARROW_MARGIN_X - r1, fromY), quadCurve(to.bounds.left + ARROW_MARGIN_X, fromY, to.bounds.left + ARROW_MARGIN_X, fromY + r1), lineTo(to.bounds.left + ARROW_MARGIN_X, toY - r1), quadCurve(to.bounds.left + ARROW_MARGIN_X, toY, to.bounds.left + ARROW_MARGIN_X + r1, toY), lineTo(toX, toY)) : cmds.push(lineTo(to.bounds.left + ARROW_MARGIN_X - r1, fromY), quadCurve(to.bounds.left + ARROW_MARGIN_X, fromY, to.bounds.left + ARROW_MARGIN_X, fromY - r1), lineTo(to.bounds.left + ARROW_MARGIN_X, toY + r1), quadCurve(to.bounds.left + ARROW_MARGIN_X, toY, to.bounds.left + ARROW_MARGIN_X + r1, toY), lineTo(toX, toY)), join(cmds);
}
function getConnectorLinePoint(rect, bounds) {
  const centerY = rect.top + rect.height / 2, isAbove = rect.top + rect.height < bounds.top + ARROW_MARGIN_Y, isBelow = rect.top > bounds.top + bounds.height - ARROW_MARGIN_Y;
  return {
    bounds,
    left: rect.left,
    top: centerY,
    centerY,
    startY: rect.top + CONNECTOR_MARGIN,
    endY: rect.top + rect.height - CONNECTOR_MARGIN,
    isAbove,
    isBelow,
    outOfBounds: isAbove || isBelow
  };
}
function mapConnectorToLine(connector) {
  const fromBounds = {
    top: connector.from.bounds.top + ARROW_THRESHOLD,
    bottom: connector.from.bounds.top + connector.from.bounds.height - ARROW_THRESHOLD,
    left: connector.from.bounds.left,
    right: connector.from.bounds.left + connector.from.bounds.width,
    width: connector.from.bounds.width,
    height: connector.from.bounds.height - ARROW_THRESHOLD * 2
  }, from2 = getConnectorLinePoint(connector.from.rect, fromBounds);
  from2.left = connector.from.rect.left + connector.from.rect.width + 1;
  const toBounds = {
    top: connector.to.bounds.top + ARROW_THRESHOLD,
    bottom: connector.to.bounds.top + connector.to.bounds.height - ARROW_THRESHOLD,
    left: connector.to.bounds.left,
    right: connector.to.bounds.left + connector.to.bounds.width,
    width: connector.to.bounds.width,
    height: connector.to.bounds.height - ARROW_THRESHOLD * 2
  }, to = getConnectorLinePoint(connector.to.rect, toBounds), maxStartY = Math.max(to.startY, from2.startY);
  return from2.top = Math.min(maxStartY, from2.endY), from2.top < toBounds.top ? from2.top = Math.min(toBounds.top, from2.endY) : from2.top > toBounds.bottom && (from2.top = Math.max(toBounds.bottom, from2.startY)), to.top = Math.min(maxStartY, to.endY), to.top < fromBounds.top ? to.top = Math.min(fromBounds.top, to.endY) : to.top > fromBounds.bottom && (to.top = Math.max(fromBounds.bottom, to.startY)), from2.top = Math.min(Math.max(from2.top, fromBounds.top), fromBounds.bottom), to.top = Math.min(Math.max(to.top, toBounds.top), toBounds.bottom), {
    from: from2,
    to
  };
}
const Connector = memo(function(t0) {
  const $ = c(41), {
    from: from2,
    to
  } = t0;
  let line, t1, t2;
  if ($[0] !== from2 || $[1] !== to) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      if (line = mapConnectorToLine({
        from: from2,
        to
      }), line.from.outOfBounds && line.to.outOfBounds) {
        t2 = null;
        break bb0;
      }
      t1 = generateConnectorPath(line);
    }
    $[0] = from2, $[1] = to, $[2] = line, $[3] = t1, $[4] = t2;
  } else
    line = $[2], t1 = $[3], t2 = $[4];
  if (t2 !== Symbol.for("react.early_return_sentinel"))
    return t2;
  const linePathDescription = t1;
  let t3, t4;
  $[5] !== linePathDescription ? (t3 = /* @__PURE__ */ jsx(InteractivePath, { d: linePathDescription, strokeWidth: INTERACTIVE_STROKE_WIDTH }), t4 = /* @__PURE__ */ jsx(ConnectorPath, { d: linePathDescription, strokeWidth: STROKE_WIDTH$2 }), $[5] = linePathDescription, $[6] = t3, $[7] = t4) : (t3 = $[6], t4 = $[7]);
  const t5 = to.rect.left - 0.5;
  let t6;
  $[8] !== t5 || $[9] !== to.bounds || $[10] !== to.rect.height || $[11] !== to.rect.top ? (t6 = /* @__PURE__ */ jsx(RightBarWrapper, { top: to.rect.top, left: t5, height: to.rect.height, width: STROKE_WIDTH$2, bounds: to.bounds }), $[8] = t5, $[9] = to.bounds, $[10] = to.rect.height, $[11] = to.rect.top, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== line.from.bounds || $[14] !== line.from.isAbove || $[15] !== line.from.left ? (t7 = line.from.isAbove && /* @__PURE__ */ jsx(ConnectorPath, { d: arrowPath(line.from.left + ARROW_MARGIN_X, line.from.bounds.top - ARROW_THRESHOLD + ARROW_MARGIN_Y, -1), strokeWidth: STROKE_WIDTH$2 }), $[13] = line.from.bounds, $[14] = line.from.isAbove, $[15] = line.from.left, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== line.from.bounds || $[18] !== line.from.isBelow || $[19] !== line.from.left ? (t8 = line.from.isBelow && /* @__PURE__ */ jsx(ConnectorPath, { d: arrowPath(line.from.left + ARROW_MARGIN_X, line.from.bounds.top + line.from.bounds.height + ARROW_THRESHOLD - ARROW_MARGIN_Y, 1), strokeWidth: STROKE_WIDTH$2 }), $[17] = line.from.bounds, $[18] = line.from.isBelow, $[19] = line.from.left, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== line.to.bounds || $[22] !== line.to.isAbove ? (t9 = line.to.isAbove && /* @__PURE__ */ jsx(ConnectorPath, { d: arrowPath(line.to.bounds.left + ARROW_MARGIN_X, line.to.bounds.top - ARROW_THRESHOLD + ARROW_MARGIN_Y, -1), strokeWidth: STROKE_WIDTH$2 }), $[21] = line.to.bounds, $[22] = line.to.isAbove, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== line.to.bounds || $[25] !== line.to.isBelow ? (t10 = line.to.isBelow && /* @__PURE__ */ jsx(ConnectorPath, { d: arrowPath(line.to.bounds.left + ARROW_MARGIN_X, line.to.bounds.top + line.to.bounds.height + ARROW_THRESHOLD - ARROW_MARGIN_Y, 1), strokeWidth: STROKE_WIDTH$2 }), $[24] = line.to.bounds, $[25] = line.to.isBelow, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== line.from.bounds || $[28] !== line.from.outOfBounds || $[29] !== line.to.bounds || $[30] !== line.to.outOfBounds ? (t11 = DEBUG$1, $[27] = line.from.bounds, $[28] = line.from.outOfBounds, $[29] = line.to.bounds, $[30] = line.to.outOfBounds, $[31] = t11) : t11 = $[31];
  let t12;
  return $[32] !== t10 || $[33] !== t11 || $[34] !== t3 || $[35] !== t4 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t3,
    t4,
    t6,
    t7,
    t8,
    t9,
    t10,
    t11
  ] }), $[32] = t10, $[33] = t11, $[34] = t3, $[35] = t4, $[36] = t6, $[37] = t7, $[38] = t8, $[39] = t9, $[40] = t12) : t12 = $[40], t12;
}), SvgWrapper = styled.svg`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;
function useResizeObserver(element, onResize) {
  const $ = c(4);
  let t0, t1;
  $[0] !== element || $[1] !== onResize ? (t0 = () => resizeObserver.observe(element, onResize), t1 = [element, onResize], $[0] = element, $[1] = onResize, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
}
function getState(allReportedValues, hovered, byId, rootElement) {
  const changeBarsWithHover = [], changeBarsWithFocus = [];
  for (const value of allReportedValues) {
    if (!isChangeBar(value) || !value[1].isChanged)
      continue;
    const [id2, reportedChangeBar] = value;
    if (id2 === hovered) {
      changeBarsWithHover.push(value);
      continue;
    }
    if (reportedChangeBar.hasHover) {
      changeBarsWithHover.push(value);
      continue;
    }
    if (reportedChangeBar.hasFocus) {
      changeBarsWithFocus.push(value);
      continue;
    }
  }
  const isHoverConnector = changeBarsWithHover.length > 0;
  return {
    connectors: (isHoverConnector ? changeBarsWithHover : changeBarsWithFocus).map(([id2]) => {
      const field = findMostSpecificTarget("field", id2, byId), change = findMostSpecificTarget("change", id2, byId);
      return !field || !change ? null : {
        field: {
          id: id2,
          ...field
        },
        change: {
          id: id2,
          ...change
        }
      };
    }).filter((value) => !!value?.field.element && !!value?.change.element).map(({
      field,
      change
    }) => ({
      hasHover: field.hasHover || change.hasHover,
      hasFocus: field.hasFocus,
      hasRevertHover: change.hasRevertHover,
      field: {
        ...field,
        ...getOffsetsTo$1(field.element, rootElement)
      },
      change: {
        ...change,
        ...getOffsetsTo$1(change.element, rootElement)
      }
    })),
    isHoverConnector
  };
}
function ConnectorsOverlay(props2) {
  const {
    rootElement,
    onSetFocus
  } = props2, [hovered, setHovered] = useState(null), allReportedValues = useChangeIndicatorsReportedValues(), byId = useMemo(() => new Map(allReportedValues), [allReportedValues]), [{
    connectors
  }, setState] = useState(() => getState(allReportedValues, hovered, byId, rootElement)), visibleConnectors = useMemo(() => sortBy(connectors, (c2) => 0 - c2.field.path.length).slice(0, 1), [connectors]), handleScrollOrResize = useCallback(() => {
    setState(getState(allReportedValues, hovered, byId, rootElement));
  }, [byId, allReportedValues, hovered, rootElement]);
  return useResizeObserver(rootElement, handleScrollOrResize), useOnScroll(handleScrollOrResize), /* @__PURE__ */ jsx(SvgWrapper, { style: {
    zIndex: visibleConnectors[0] && visibleConnectors[0].field.zIndex
  }, children: visibleConnectors.map(({
    field,
    change
  }) => change ? /* @__PURE__ */ jsx(ConnectorGroup, { field, change, onSetFocus, setHovered }, field.id) : null) });
}
function ConnectorGroup(props2) {
  const $ = c(35), {
    change,
    field,
    onSetFocus,
    setHovered
  } = props2;
  let t0;
  $[0] !== change || $[1] !== field || $[2] !== onSetFocus ? (t0 = () => {
    scrollIntoView(field), scrollIntoView(change), onSetFocus(field.path);
  }, $[0] = change, $[1] = field, $[2] = onSetFocus, $[3] = t0) : t0 = $[3];
  const onConnectorClick = t0;
  let t1;
  $[4] !== field.id || $[5] !== setHovered ? (t1 = () => setHovered(field.id), $[4] = field.id, $[5] = setHovered, $[6] = t1) : t1 = $[6];
  const handleMouseEnter = t1;
  let t2;
  $[7] !== setHovered ? (t2 = () => setHovered(null), $[7] = setHovered, $[8] = t2) : t2 = $[8];
  const handleMouseLeave = t2;
  let t3;
  const t4 = field.rect.left + 3;
  let t5;
  $[9] !== field.rect || $[10] !== t4 ? (t5 = {
    ...field.rect,
    left: t4
  }, $[9] = field.rect, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== field.bounds || $[13] !== t5 ? (t6 = {
    rect: t5,
    bounds: field.bounds
  }, $[12] = field.bounds, $[13] = t5, $[14] = t6) : t6 = $[14], t3 = t6;
  const from2 = t3;
  let t7;
  const t8 = change.rect.left + 1;
  let t9;
  $[15] !== change.rect || $[16] !== t8 ? (t9 = {
    ...change.rect,
    left: t8
  }, $[15] = change.rect, $[16] = t8, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== change.bounds || $[19] !== t9 ? (t10 = {
    rect: t9,
    bounds: change.bounds
  }, $[18] = change.bounds, $[19] = t9, $[20] = t10) : t10 = $[20], t7 = t10;
  const to = t7;
  let t11;
  $[21] !== from2 || $[22] !== to ? (t11 = /* @__PURE__ */ jsx(Connector, { from: from2, to }), $[21] = from2, $[22] = to, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== handleMouseEnter || $[25] !== handleMouseLeave || $[26] !== onConnectorClick || $[27] !== t11 ? (t12 = /* @__PURE__ */ jsx("g", { onClick: onConnectorClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: t11 }), $[24] = handleMouseEnter, $[25] = handleMouseLeave, $[26] = onConnectorClick, $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== change || $[30] !== field ? (t13 = DEBUG_LAYER_BOUNDS, $[29] = change, $[30] = field, $[31] = t13) : t13 = $[31];
  let t14;
  return $[32] !== t12 || $[33] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t12,
    t13
  ] }), $[32] = t12, $[33] = t13, $[34] = t14) : t14 = $[34], t14;
}
function ChangeConnectorRoot(t0) {
  const $ = c(22);
  let children, className, isReviewChangesOpen, onOpenReviewChanges, onSetFocus, restProps;
  $[0] !== t0 ? ({
    children,
    className,
    isReviewChangesOpen,
    onOpenReviewChanges,
    onSetFocus,
    ...restProps
  } = t0, $[0] = t0, $[1] = children, $[2] = className, $[3] = isReviewChangesOpen, $[4] = onOpenReviewChanges, $[5] = onSetFocus, $[6] = restProps) : (children = $[1], className = $[2], isReviewChangesOpen = $[3], onOpenReviewChanges = $[4], onSetFocus = $[5], restProps = $[6]);
  const [rootElement, setRootElement] = useState();
  let t1, t2;
  $[7] !== isReviewChangesOpen || $[8] !== onOpenReviewChanges || $[9] !== onSetFocus ? (t2 = {
    isReviewChangesOpen,
    onOpenReviewChanges,
    onSetFocus
  }, $[7] = isReviewChangesOpen, $[8] = onOpenReviewChanges, $[9] = onSetFocus, $[10] = t2) : t2 = $[10], t1 = t2;
  const contextValue = t1;
  let t3;
  $[11] !== onSetFocus || $[12] !== rootElement ? (t3 = rootElement && /* @__PURE__ */ jsx(ConnectorsOverlay, { rootElement, onSetFocus }), $[11] = onSetFocus, $[12] = rootElement, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== children || $[15] !== className || $[16] !== restProps || $[17] !== t3 ? (t4 = /* @__PURE__ */ jsx(ChangeIndicatorsTracker, { children: /* @__PURE__ */ jsxs(ScrollContainer, { ...restProps, ref: setRootElement, className, children: [
    children,
    t3
  ] }) }), $[14] = children, $[15] = className, $[16] = restProps, $[17] = t3, $[18] = t4) : t4 = $[18];
  let t5;
  return $[19] !== contextValue || $[20] !== t4 ? (t5 = /* @__PURE__ */ jsx(ConnectorContext.Provider, { value: contextValue, children: t4 }), $[19] = contextValue, $[20] = t4, $[21] = t5) : t5 = $[21], t5;
}
const separator = /* @__PURE__ */ jsx(Text$1, { muted: !0, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }), renderItem = (item, index) => /* @__PURE__ */ jsx(Box, { as: "li", children: /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", size: 1, weight: "medium", children: item }) }, `${item}-${index}`);
function CommentBreadcrumbs(props2) {
  const $ = c(11), {
    titlePath,
    maxLength
  } = props2;
  let t0;
  bb0: {
    const len = titlePath.length, beforeLength = Math.ceil(maxLength / 2), afterLength = Math.floor(maxLength / 2);
    if (maxLength && len > maxLength) {
      let t12;
      $[0] !== afterLength || $[1] !== beforeLength || $[2] !== len || $[3] !== titlePath ? (t12 = [...titlePath.slice(0, beforeLength - 1), titlePath.slice(beforeLength - 1, len - afterLength), ...titlePath.slice(len - afterLength)], $[0] = afterLength, $[1] = beforeLength, $[2] = len, $[3] = titlePath, $[4] = t12) : t12 = $[4], t0 = t12;
      break bb0;
    }
    t0 = titlePath;
  }
  const items = t0;
  let t1, t2;
  if ($[5] !== items) {
    let t32;
    $[7] !== items.length ? (t32 = (item, index) => {
      const key = `${item}-${index}`, showSeparator = index < items.length - 1;
      return Array.isArray(item) ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
        /* @__PURE__ */ jsx(Tooltip, { content: /* @__PURE__ */ jsx(Stack, { space: 2, padding: 2, children: item.map(renderItem) }), children: /* @__PURE__ */ jsx(Box, { children: renderItem("...", index) }) }),
        showSeparator && separator
      ] }, key) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
        renderItem(item, index),
        showSeparator && separator
      ] }, key);
    }, $[7] = items.length, $[8] = t32) : t32 = $[8], t2 = items.map(t32), $[5] = items, $[6] = t2;
  } else
    t2 = $[6];
  t1 = t2;
  const nodes = t1;
  let t3;
  return $[9] !== nodes ? (t3 = /* @__PURE__ */ jsx(Flex, { align: "center", as: "ol", gap: 2, children: nodes }), $[9] = nodes, $[10] = t3) : t3 = $[10], t3;
}
function BetaBadge(props2) {
  const $ = c(8);
  let rest, t0, t1;
  $[0] !== props2 ? ({
    fontSize: t0,
    children: t1,
    ...rest
  } = props2, $[0] = props2, $[1] = rest, $[2] = t0, $[3] = t1) : (rest = $[1], t0 = $[2], t1 = $[3]);
  const fontSize = t0 === void 0 ? 1 : t0, children = t1 === void 0 ? "Beta" : t1;
  let t2;
  return $[4] !== children || $[5] !== fontSize || $[6] !== rest ? (t2 = /* @__PURE__ */ jsx(Badge, { ...rest, fontSize, radius: 2, tone: "primary", children }), $[4] = children, $[5] = fontSize, $[6] = rest, $[7] = t2) : t2 = $[7], t2;
}
function focusRingBorderStyle$3(border) {
  return `inset 0 0 0 ${border.width}px ${border.color}`;
}
const AlignedBottomGrid$1 = styled(Grid)`
  align-items: flex-end;
`;
function focusRingStyle$2(opts) {
  const {
    base,
    border,
    focusRing
  } = opts, focusRingOutsetWidth = focusRing.offset + focusRing.width, focusRingInsetWidth = 0 - focusRing.offset, bgColor = base ? base.bg : "var(--card-bg-color)";
  return [focusRingInsetWidth > 0 && `inset 0 0 0 ${focusRingInsetWidth}px var(--card-focus-ring-color)`, border && focusRingBorderStyle$3(border), focusRingInsetWidth < 0 && `0 0 0 ${0 - focusRingInsetWidth}px ${bgColor}`, focusRingOutsetWidth > 0 && `0 0 0 ${focusRingOutsetWidth}px var(--card-focus-ring-color)`].filter(Boolean).join(",");
}
const LIST_ITEM_DATA_ATTR_ACTIVE = "data-active", LIST_ITEM_INTERACTIVE_SELECTOR = "a,button", FocusOverlayDiv = styled.div(({
  theme,
  offset
}) => css`
    bottom: ${-offset}px;
    border-radius: ${rem(theme.sanity.radius[1])};
    left: ${-offset}px;
    pointer-events: none;
    position: absolute;
    right: ${-offset}px;
    top: ${-offset}px;
    z-index: 2;

    ${VirtualListBox}:focus-visible & {
      box-shadow: ${focusRingStyle$2({
  base: theme.sanity.color.base,
  focusRing: theme.sanity.focusRing
})};
    }
  `), PointerOverlayDiv = styled.div`
  bottom: 0;
  display: none;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;

  @media (hover: hover) {
    &[data-enabled='true'] {
      display: block;
    }
  }
`, VirtualListBox = styled(Box)`
  height: 100%;
  outline: none;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  width: 100%;
`, VirtualListChildBox = styled(Box).attrs(({
  $height
}) => ({
  style: {
    height: `${$height}px`
  }
}))`
  position: relative;
  width: 100%;
`, CommandListComponent = forwardRef(function({
  activeItemDataAttr = LIST_ITEM_DATA_ATTR_ACTIVE,
  ariaLabel,
  ariaMultiselectable = !1,
  autoFocus,
  canReceiveFocus,
  fixedHeight,
  focusRingOffset = 0,
  getItemDisabled,
  getItemKey: getItemKey2,
  getItemSelected,
  initialIndex,
  initialScrollAlign = "start",
  inputElement,
  itemHeight,
  items,
  onEndReached,
  onEndReachedIndexOffset = 0,
  onlyShowSelectionWhenActive,
  overscan,
  renderItem: renderItem2,
  testId,
  wrapAround = !0,
  ...responsivePaddingProps
}, ref) {
  const isMountedRef = useRef(!1), [commandListId] = useState(useId()), activeIndexRef = useRef(initialIndex ?? 0), [childContainerElement, setChildContainerElement] = useState(null), [hovered, setHovered] = useState(!1), [pointerOverlayElement, setPointerOverlayElement] = useState(null), [virtualListElement, setVirtualListElement] = useState(null), handleChange = useCallback((v) => {
    if (!onEndReached) return;
    const [lastItem] = [...v.getVirtualItems()].reverse();
    lastItem && lastItem.index >= items.length - onEndReachedIndexOffset - 1 && isMountedRef.current && onEndReached();
  }, [onEndReached, items.length, onEndReachedIndexOffset]), virtualizer = useVirtualizer({
    count: items.length,
    getItemKey: getItemKey2,
    getScrollElement: () => virtualListElement,
    estimateSize: () => itemHeight,
    onChange: handleChange,
    overscan
  }), itemIndices = useMemo(() => {
    let i = -1;
    return items.reduce((acc, _, index) => {
      const disabled = getItemDisabled?.(index) ?? !1, selected = getItemSelected?.(index) ?? !1;
      return disabled || (i += 1), acc[index] = {
        activeIndex: disabled ? null : i,
        disabled,
        selected
      }, acc;
    }, []);
  }, [getItemDisabled, getItemSelected, items]), activeItemCount = useMemo(() => itemIndices.filter((v_0) => !v_0.disabled).length, [itemIndices]), enableChildContainerPointerEvents = useCallback((enabled) => pointerOverlayElement?.setAttribute("data-enabled", (!enabled).toString()), [pointerOverlayElement]), getChildDescendantId = useCallback((index_0) => `${commandListId}-item-${index_0}`, [commandListId]), getCommandListChildrenId = useCallback(() => `${commandListId}-children`, [commandListId]), showChildrenActiveState = useCallback(() => {
    const hasFocus = [inputElement, virtualListElement].some((el) => document.activeElement === el);
    onlyShowSelectionWhenActive && !hasFocus && !hovered || Array.from(childContainerElement?.children || [])?.forEach((child) => {
      const virtualIndex = Number(child.dataset?.index), targetIndex = itemIndices[virtualIndex]?.activeIndex;
      child.querySelector(LIST_ITEM_INTERACTIVE_SELECTOR)?.toggleAttribute(activeItemDataAttr, targetIndex === activeIndexRef.current);
    });
  }, [activeItemDataAttr, childContainerElement?.children, hovered, inputElement, itemIndices, onlyShowSelectionWhenActive, virtualListElement]), hideChildrenActiveState = useCallback(() => {
    Array.from(childContainerElement?.children || [])?.forEach((child_0) => {
      child_0.querySelector(LIST_ITEM_INTERACTIVE_SELECTOR)?.toggleAttribute(activeItemDataAttr, !1);
    });
  }, [activeItemDataAttr, childContainerElement?.children]), refreshChildrenActiveStateThrottled = useMemo(() => throttle(showChildrenActiveState, 200), [showChildrenActiveState]), handleUpdateActiveDescendant = useCallback(() => {
    const activeIndex = activeIndexRef?.current;
    items.length > 0 ? (inputElement?.setAttribute("aria-activedescendant", getChildDescendantId(activeIndex)), virtualListElement?.setAttribute("aria-activedescendant", getChildDescendantId(activeIndex))) : (inputElement?.removeAttribute("aria-activedescendant"), virtualListElement?.removeAttribute("aria-activedescendant"));
  }, [getChildDescendantId, inputElement, items.length, virtualListElement]), handleGetTopIndex = useCallback(() => {
    const childContainerParentElement = childContainerElement?.parentElement;
    if (childContainerElement && childContainerParentElement) {
      const offset = childContainerParentElement.getBoundingClientRect().top - childContainerElement.getBoundingClientRect().top;
      return virtualizer.getVirtualItemForOffset(offset)?.index ?? -1;
    }
    return -1;
  }, [childContainerElement, virtualizer]), setActiveIndex = useCallback(({
    index: index_1,
    scrollAlign,
    scrollIntoView: scrollIntoView2 = !0
  }) => {
    if (activeIndexRef.current = index_1, handleUpdateActiveDescendant(), showChildrenActiveState(), scrollIntoView2) {
      const virtualListIndex = itemIndices.findIndex((i_0) => i_0.activeIndex === index_1);
      virtualListIndex > -1 && virtualizer.scrollToIndex(virtualListIndex, scrollAlign ? {
        align: scrollAlign
      } : {});
    }
  }, [handleUpdateActiveDescendant, itemIndices, showChildrenActiveState, virtualizer]), selectAdjacentItemIndex = useCallback((direction) => {
    let nextIndex = -1;
    const lastIndex = activeItemCount - 1;
    if (direction === "next") {
      const wrapAroundIndex = wrapAround ? 0 : lastIndex;
      nextIndex = activeIndexRef.current < activeItemCount - 1 ? activeIndexRef.current + 1 : wrapAroundIndex;
    }
    if (direction === "previous") {
      const wrapAroundIndex_0 = wrapAround ? lastIndex : 0;
      nextIndex = activeIndexRef.current > 0 ? activeIndexRef.current - 1 : wrapAroundIndex_0;
    }
    setActiveIndex({
      index: nextIndex,
      scrollIntoView: !0
    }), enableChildContainerPointerEvents(!1);
  }, [activeItemCount, enableChildContainerPointerEvents, setActiveIndex, wrapAround]), focusElement = useCallback((type) => {
    switch (type) {
      case "input":
        inputElement?.focus();
        break;
      case "list":
        virtualListElement?.focus();
        break;
    }
  }, [inputElement, virtualListElement]), focusInputElement = useCallback(() => {
    inputElement?.focus();
  }, [inputElement]), focusListElement = useCallback(() => {
    virtualListElement?.focus();
  }, [virtualListElement]), handleChildMouseEnter = useCallback((index_2) => () => {
    setActiveIndex({
      index: index_2,
      scrollIntoView: !1
    });
  }, [setActiveIndex]), handleFocus = useCallback(() => {
    showChildrenActiveState();
  }, [showChildrenActiveState]), handleKeyDown = useCallback((type_0) => (event) => {
    const childElements_1 = Array.from(childContainerElement?.children || []);
    if (childElements_1.length && (event.key === "ArrowDown" && (event.preventDefault(), focusElement(type_0), selectAdjacentItemIndex("next")), event.key === "ArrowUp" && (event.preventDefault(), focusElement(type_0), selectAdjacentItemIndex("previous")), event.key === "Enter")) {
      event.preventDefault(), focusElement(type_0);
      const currentElement = childElements_1.find((el_0) => Number(el_0.dataset.index) === itemIndices.findIndex((i_1) => i_1.activeIndex === activeIndexRef.current));
      currentElement && currentElement?.querySelector(LIST_ITEM_INTERACTIVE_SELECTOR)?.click();
    }
  }, [childContainerElement?.children, focusElement, itemIndices, selectAdjacentItemIndex]), handleKeyDownInput = useCallback((event_0) => handleKeyDown("input")(event_0), [handleKeyDown]), handleKeyDownList = useCallback((event_1) => handleKeyDown("list")(event_1), [handleKeyDown]), handleVirtualListMouseEnter = useCallback(() => {
    onlyShowSelectionWhenActive && (showChildrenActiveState(), setHovered(!0));
  }, [onlyShowSelectionWhenActive, showChildrenActiveState]), handleVirtualListMouseLeave = useCallback(() => {
    onlyShowSelectionWhenActive && (hideChildrenActiveState(), setHovered(!1));
  }, [hideChildrenActiveState, onlyShowSelectionWhenActive]);
  useImperativeHandle(ref, () => ({
    focusInputElement() {
      focusInputElement();
    },
    focusListElement() {
      focusListElement();
    },
    getTopIndex() {
      return handleGetTopIndex();
    },
    scrollToIndex(index_3) {
      setActiveIndex({
        index: index_3
      }), enableChildContainerPointerEvents(!0);
    }
  }), [enableChildContainerPointerEvents, focusInputElement, focusListElement, handleGetTopIndex, setActiveIndex]), useEffect(() => {
    typeof initialIndex < "u" && !isMountedRef.current && setActiveIndex({
      index: initialIndex,
      scrollAlign: initialScrollAlign,
      scrollIntoView: !0
    }), isMountedRef.current = !0;
  }, [initialIndex, initialScrollAlign, onlyShowSelectionWhenActive, setActiveIndex]), useEffect(() => {
    function handleMouseEvent() {
      enableChildContainerPointerEvents(!0);
    }
    return virtualListElement?.addEventListener("mousemove", handleMouseEvent), virtualListElement?.addEventListener("wheel", handleMouseEvent, {
      passive: !0
    }), () => {
      virtualListElement?.removeEventListener("mousemove", handleMouseEvent), virtualListElement?.removeEventListener("wheel", handleMouseEvent);
    };
  }, [enableChildContainerPointerEvents, virtualListElement]), useEffect(() => (inputElement?.addEventListener("focus", handleFocus), inputElement?.addEventListener("keydown", handleKeyDownInput), virtualListElement?.addEventListener("focus", handleFocus), virtualListElement?.addEventListener("keydown", handleKeyDownList), () => {
    inputElement?.removeEventListener("focus", handleFocus), inputElement?.removeEventListener("keydown", handleKeyDownInput), virtualListElement?.removeEventListener("focus", handleFocus), virtualListElement?.removeEventListener("keydown", handleKeyDownList);
  }), [canReceiveFocus, handleFocus, handleKeyDown, handleKeyDownInput, handleKeyDownList, hideChildrenActiveState, inputElement, showChildrenActiveState, virtualListElement]), useEffect(() => {
    handleUpdateActiveDescendant();
  }, [handleUpdateActiveDescendant, items]), useEffect(() => {
    const mutationObserver = new MutationObserver(refreshChildrenActiveStateThrottled);
    return childContainerElement && mutationObserver.observe(childContainerElement, {
      childList: !0,
      subtree: !0
    }), () => {
      mutationObserver.disconnect();
    };
  }, [childContainerElement, refreshChildrenActiveStateThrottled]), useEffect(() => {
    inputElement?.setAttribute("aria-autocomplete", "list"), inputElement?.setAttribute("aria-expanded", "true"), inputElement?.setAttribute("aria-controls", getCommandListChildrenId()), inputElement?.setAttribute("role", "combobox");
  }, [getCommandListChildrenId, inputElement]), useEffect(() => {
    autoFocus && focusElement(autoFocus);
  }, [autoFocus, canReceiveFocus, focusListElement, focusInputElement, focusElement]);
  const rootTabIndex = canReceiveFocus ? 0 : -1;
  return /* @__PURE__ */ jsxs(VirtualListBox, { id: getCommandListChildrenId(), onMouseEnter: handleVirtualListMouseEnter, onMouseLeave: handleVirtualListMouseLeave, ref: setVirtualListElement, sizing: "border", tabIndex: rootTabIndex, "data-testid": testId, ...responsivePaddingProps, children: [
    canReceiveFocus && /* @__PURE__ */ jsx(FocusOverlayDiv, { offset: focusRingOffset }),
    /* @__PURE__ */ jsx(PointerOverlayDiv, { "aria-hidden": "true", "data-enabled": !0, ref: setPointerOverlayElement }),
    virtualizer && /* @__PURE__ */ jsx(VirtualListChildBox, { forwardedAs: "ul", $height: virtualizer.getTotalSize(), "aria-label": ariaLabel, "aria-multiselectable": ariaMultiselectable, flex: 1, ref: setChildContainerElement, role: "listbox", children: virtualizer.getVirtualItems().map((virtualRow) => {
      const virtualIndex_0 = virtualRow.index, {
        activeIndex: activeIndex_0,
        disabled: disabled_0,
        selected: selected_0
      } = itemIndices[virtualIndex_0], itemToRender = renderItem2(items[virtualIndex_0], {
        activeIndex: activeIndex_0,
        disabled: disabled_0,
        selected: selected_0,
        virtualIndex: virtualIndex_0
      }), clonedItem = isValidElement(itemToRender) && itemToRender.type != Fragment$1 ? cloneElement(itemToRender, {
        // @ts-expect-error @TODO shift the responsibility of setting tabIndex to the consumer, so we can remove the need to clone
        tabIndex: -1
      }) : itemToRender;
      return /* @__PURE__ */ jsx(CommandListItem2, { ref: fixedHeight ? void 0 : virtualizer.measureElement, activeIndex: activeIndex_0, activeItemCount, ariaMultiselectable, disabled: disabled_0, fixedHeight: fixedHeight ? `${virtualRow.size}px` : void 0, getChildDescendantId, handleChildMouseEnter, selected: selected_0, virtualIndex: virtualIndex_0, virtualRowStart: virtualRow.start, children: clonedItem }, virtualRow.key);
    }) })
  ] });
}), CommandList = memo(CommandListComponent);
CommandList.displayName = "Memo(ForwardRef(CommandList))";
const CommandListItemComponent = forwardRef(function(props2, forwardedRef) {
  const {
    children,
    activeIndex,
    activeItemCount,
    ariaMultiselectable,
    disabled,
    fixedHeight,
    getChildDescendantId,
    handleChildMouseEnter,
    selected,
    virtualIndex,
    virtualRowStart
  } = props2, onMouseEnter = useMemo(() => typeof activeIndex == "number" && !disabled ? handleChildMouseEnter(activeIndex) : void 0, [activeIndex, disabled, handleChildMouseEnter]), activeAriaAttributes = useMemo(() => typeof activeIndex == "number" && !disabled ? {
    "aria-posinset": activeIndex + 1,
    ...ariaMultiselectable ? {
      "aria-selected": selected.toString()
    } : {},
    "aria-setsize": activeItemCount,
    id: getChildDescendantId(activeIndex),
    role: "option"
  } : {}, [activeIndex, activeItemCount, ariaMultiselectable, disabled, getChildDescendantId, selected]), style = useMemo(() => ({
    flex: 1,
    height: fixedHeight,
    left: 0,
    position: "absolute",
    top: 0,
    transform: `translateY(${virtualRowStart}px)`,
    width: "100%"
  }), [fixedHeight, virtualRowStart]);
  return /* @__PURE__ */ jsx(Stack, { as: "li", "data-index": virtualIndex, ref: forwardedRef, style, tabIndex: -1, ...activeAriaAttributes, onMouseEnter, children });
}), CommandListItem2 = memo(CommandListItemComponent);
CommandListItem2.displayName = "Memo(ForwardRef(CommandListItem))";
const ContextMenuButton = forwardRef(function(props2, ref) {
  const $ = c(17);
  let rest, t0, tone, tooltipProps;
  $[0] !== props2 ? ({
    mode: t0,
    tooltipProps,
    tone,
    ...rest
  } = props2, $[0] = props2, $[1] = rest, $[2] = t0, $[3] = tone, $[4] = tooltipProps) : (rest = $[1], t0 = $[2], tone = $[3], tooltipProps = $[4]);
  const mode = t0 === void 0 ? "bleed" : t0, {
    t
  } = useTranslation();
  let t1;
  $[5] !== t || $[6] !== tooltipProps?.content ? (t1 = tooltipProps?.content || t("common.context-menu-button.tooltip"), $[5] = t, $[6] = tooltipProps?.content, $[7] = t1) : t1 = $[7];
  let t2;
  $[8] !== t1 || $[9] !== tooltipProps ? (t2 = {
    ...tooltipProps,
    content: t1
  }, $[8] = t1, $[9] = tooltipProps, $[10] = t2) : t2 = $[10];
  let t3;
  return $[11] !== mode || $[12] !== ref || $[13] !== rest || $[14] !== t2 || $[15] !== tone ? (t3 = /* @__PURE__ */ jsx(Button, { ...rest, icon: EllipsisHorizontalIcon, mode, ref, tone, tooltipProps: t2 }), $[11] = mode, $[12] = ref, $[13] = rest, $[14] = t2, $[15] = tone, $[16] = t3) : t3 = $[16], t3;
});
function getWorkspaceIdentifier({
  name,
  title
}, index) {
  return typeof name == "string" && name.trim().length > 0 ? name : getNamelessWorkspaceIdentifier(title, index);
}
function getNamelessWorkspaceIdentifier(title, index) {
  const withTitle = typeof title == "string" && title.trim().length > 0 ? ` (titled "${title}")` : "";
  return `at index ${index}${withTitle}`;
}
function useWorkspaces() {
  const workspaces = useContext(WorkspacesContext);
  if (!workspaces)
    throw new Error("Could not find `workspaces` context");
  return workspaces;
}
class WorkspaceValidationError extends Error {
  constructor(message, options) {
    super(message), this.name = "WorkspaceValidationError", this.index = options?.index, this.identifier = options?.workspace && getWorkspaceIdentifier(options.workspace, options.index);
  }
}
function validateWorkspaces({
  workspaces
}) {
  if (workspaces.length === 0)
    throw new WorkspaceValidationError("At least one workspace is required.");
  validateNames(workspaces), validateBasePaths(workspaces);
}
function validateNames(workspaces) {
  const isSingleWorkspace = workspaces.length === 1, names = /* @__PURE__ */ new Map();
  workspaces.forEach((workspace, index) => {
    const {
      name: rawName,
      title
    } = workspace, thisIdentifier = getNamelessWorkspaceIdentifier(title, index);
    if (!rawName && !isSingleWorkspace)
      throw new WorkspaceValidationError(`All workspaces must have a \`name\`, unless only a single workspace is defined. Workspace ${thisIdentifier} did not define a \`name\`.`, {
        workspace,
        index
      });
    const name = isSingleWorkspace && typeof rawName > "u" ? "default" : rawName;
    if (typeof name != "string")
      throw new WorkspaceValidationError(`Workspace at index ${index} defined an invalid \`name\` - must be a string.`, {
        workspace,
        index
      });
    const normalized = name.toLowerCase(), existingWorkspace = names.get(normalized);
    if (existingWorkspace) {
      const prevIdentifier = getNamelessWorkspaceIdentifier(existingWorkspace.workspace.title, existingWorkspace.index);
      throw new WorkspaceValidationError(`\`name\`s must be unique. Workspace ${prevIdentifier} and workspace ${thisIdentifier} both have the \`name\` \`${name}\``, {
        workspace,
        index
      });
    }
    if (names.set(normalized, {
      index,
      workspace
    }), !/^[a-z0-9][a-z0-9_-]*$/i.test(name))
      throw new WorkspaceValidationError(`All workspace \`name\`s must consist of only a-z, 0-9, underscore and dashes, and cannot begin with an underscore or dash. Workspace ${thisIdentifier} has the invalid name \`${name}\``, {
        workspace,
        index
      });
  });
}
function validateBasePaths(workspaces) {
  workspaces.length > 1 && workspaces.every(hasBasePath), workspaces.every(validateBasePath);
  const [firstWorkspace, ...restOfWorkspaces] = workspaces, firstWorkspaceSegmentCount = (firstWorkspace.basePath || "/").slice(1).split("/").filter(Boolean).length;
  restOfWorkspaces.forEach((workspace, index) => {
    const workspaceSegmentCount = (workspace.basePath || "/").slice(1).split("/").length;
    if (firstWorkspaceSegmentCount !== workspaceSegmentCount)
      throw new WorkspaceValidationError(`All workspace \`basePath\`s must have the same amount of segments. Workspace \`${getWorkspaceIdentifier(firstWorkspace, index)}\` had ${firstWorkspaceSegmentCount} segment${firstWorkspaceSegmentCount === 1 ? "" : "s"} \`${firstWorkspace.basePath}\` but workspace \`${getWorkspaceIdentifier(workspace, index)}\` had ${workspaceSegmentCount} segment${workspaceSegmentCount === 1 ? "" : "s"} \`${workspace.basePath}\``, {
        workspace,
        index
      });
  });
  const basePaths = /* @__PURE__ */ new Map();
  workspaces.forEach((workspace, index) => {
    const basePath = (workspace.basePath || "").toLowerCase(), existingWorkspace = basePaths.get(basePath);
    if (existingWorkspace)
      throw new WorkspaceValidationError(`\`basePath\`s must be unique. Workspaces \`${existingWorkspace}\` and \`${getWorkspaceIdentifier(workspace, index)}\` both have the \`basePath\` \`${basePath}\``, {
        workspace,
        index
      });
    basePaths.set(basePath, getWorkspaceIdentifier(workspace, index));
  });
}
function hasBasePath(workspace, index) {
  const {
    name,
    basePath
  } = workspace;
  if (basePath && typeof basePath == "string")
    return !0;
  throw typeof basePath > "u" ? new WorkspaceValidationError(`If more than one workspace is defined, every workspace must have a \`basePath\` defined. Workspace \`${name}\` is missing a \`basePath\``, {
    workspace,
    index
  }) : new WorkspaceValidationError(`If more than one workspace is defined, every workspace must have a \`basePath\` defined. Workspace \`${name}\` has an invalid \`basePath\` (must be a non-empty string)`, {
    workspace,
    index
  });
}
function validateBasePath(workspace, index) {
  const {
    name,
    basePath
  } = workspace;
  if (!(!basePath || basePath === "/") && !/^\/[a-z0-9/_-]*[a-z0-9_-]+$/i.test(basePath))
    throw new WorkspaceValidationError(`All workspace \`basePath\`s must start with a leading \`/\`, consist of only URL safe characters, and cannot end with a trailing \`/\`. Workspace \`${name}\`'s basePath is \`${basePath}\``, {
      workspace,
      index
    });
}
const DEBUG_MODE$1 = !1, SPINNER_DELAY = 750, TEXT_DELAY = 2e3, StyledCard$5 = styled(Card)(({
  $fill
}) => css`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${$fill ? css`
          bottom: 0;
          height: 100%;
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          width: 100%;
        ` : css`
          min-height: 75px;
          height: stretch;
          height: -webkit-fill-available;
          width: stretch;
          width: -webkit-fill-available;
        `}

    ${DEBUG_MODE$1}

    > * {
      position: absolute;
    }
  `), StyledSpinner = styled(Spinner)(({
  $animatePosition = !0
}) => css`
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @keyframes slideUp {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(-15px);
      }
    }
    animation: ${$animatePosition ? `500ms ease-out ${SPINNER_DELAY}ms 1 normal both running fadeIn, 750ms ease-out ${TEXT_DELAY}ms 1 normal both running slideUp` : `500ms ease-out ${SPINNER_DELAY}ms 1 normal both running fadeIn`};
  `), StyledText$7 = styled(Text$1)`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes slideDown {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(15px);
    }
  }
  animation:
    1500ms ease-out ${TEXT_DELAY}ms 1 normal both running fadeIn,
    750ms ease-out ${TEXT_DELAY}ms 1 normal both running slideDown;
`;
function LoadingBlock(t0) {
  const $ = c(10), {
    fill,
    showText,
    title
  } = t0, t1 = fill ? Layer : "div", t2 = !!showText;
  let t3;
  $[0] !== t2 ? (t3 = /* @__PURE__ */ jsx(StyledSpinner, { $animatePosition: t2, muted: !0 }), $[0] = t2, $[1] = t3) : t3 = $[1];
  let t4;
  $[2] !== showText || $[3] !== title ? (t4 = showText && /* @__PURE__ */ jsx(LoadingText, { title }), $[2] = showText, $[3] = title, $[4] = t4) : t4 = $[4];
  let t5;
  return $[5] !== fill || $[6] !== t1 || $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(StyledCard$5, { $fill: fill, as: t1, "data-testid": "loading-block", children: [
    t3,
    t4
  ] }), $[5] = fill, $[6] = t1, $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9], t5;
}
function LoadingText(t0) {
  const $ = c(5), {
    title
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t || $[1] !== title ? (t1 = title || t("common.loading"), $[0] = t, $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledText$7, { muted: !0, size: 1, children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
function defineLocaleResourceBundle(bundle) {
  return bundle;
}
function defineLocale(locale) {
  return locale;
}
function isStaticResourceBundle(bundle) {
  return !("then" in bundle.resources && typeof bundle.resources.then == "function");
}
function defineLocalesResources(namespace, resources) {
  return resources;
}
function removeUndefinedLocaleResources(resources) {
  const result = {};
  for (const key in resources)
    typeof resources[key] < "u" && (result[key] = resources[key]);
  return result;
}
const studioLocaleNamespace = "studio", validationLocaleNamespace = "validation", copyPasteLocalNamespace = "copy-paste", copyPasteLocaleStrings = defineLocalesResources("copy-paste", {
  /** Text on the field action button to copy a document */
  "copy-paste.field-action-copy-button.document.title": "Copy document",
  /** Text on the field action button to copy a field */
  "copy-paste.field-action-copy-button.field.title": "Copy field",
  /** Text on the field action button to paste a document */
  "copy-paste.field-action-paste-button.document.title": "Paste document",
  /** Text on the field action button to paste a field */
  "copy-paste.field-action-paste-button.field.title": "Paste field",
  /** --- On paste --- */
  /** The validation message that is shown when pasting a value into a read-only target */
  "copy-paste.on-paste.validation.read-only-target.description": "The target is read-only",
  /** The validation message that is shown when the source and target schema types are incompatible */
  "copy-paste.on-paste.validation.schema-type-incompatible.description": "Source and target schema types are not compatible",
  /** The validation message that is shown when reference types are incompatible */
  "copy-paste.on-paste.validation.reference-type-incompatible.description": 'References of type "{{sourceReferenceType}}" is not allowed in reference field that accepts types "{{targetReferenceTypes}}"',
  /** The validation message that is shown when reference is incompatible with filter */
  "copy-paste.on-paste.validation.reference-filter-incompatible.description": "Reference is not allowed in reference field according to filter",
  /** The validation message that is shown when reference does not exist */
  "copy-paste.on-paste.validation.reference-validation-failed.description": 'The referenced document "{{ref}}" does not exist',
  /** The validation message that is shown when image files are incompatible */
  "copy-paste.on-paste.validation.image-file-incompatible.description": 'A "{{sourceSchemaType}}" is not allowed in a "{{targetSchemaType}}"',
  /** The validation message that is shown when array types are incompatible */
  "copy-paste.on-paste.validation.array-type-incompatible.description": 'Value of type "{{type}}" is not allowed in this array field',
  /** The validation message that is shown when array values are incompatible */
  "copy-paste.on-paste.validation.array-value-incompatible.description": 'Value of type "{{type}}" is not allowed in this array field',
  /** The validation message that is shown when string values are incompatible */
  "copy-paste.on-paste.validation.string-value-incompatible.description": 'Value "{{value}}" is not allowed in "{{allowedStrings}}"',
  /** The validation message that is shown when primitive types are incompatible */
  "copy-paste.on-paste.validation.primitive-type-incompatible.description": 'Value of type "{{type}}" is not allowed in this field',
  /** The validation message that is shown when the clipboard is empty */
  "copy-paste.on-paste.validation.clipboard-empty.title": "Nothing to paste",
  /** The validation message that is shown when the clipboard item is invalid */
  "copy-paste.on-paste.validation.clipboard-invalid.title": "Invalid clipboard item",
  /** The validation message that is shown when schema types are incompatible */
  "copy-paste.on-paste.validation.schema-type-incompatible.title": "Could not resolve schema type for path: {{path}}",
  /** The warning message that is shown when not all values can be pasted */
  "copy-paste.on-paste.validation.partial-warning.title": "Could not paste all values",
  /** The error message that is shown when the MIME type is not accepted */
  "copy-paste.on-paste.validation.mime-type-incompatible.description": 'MIME type "{{mimeType}}" is not accepted for this field',
  /** The error message that is shown when the MIME type validation fails */
  "copy-paste.on-paste.validation.mime-type-validation-failed.description": "MIME type validation failed",
  /** --- On copy --- */
  /** The error message that is shown when schema types are incompatible */
  "copy-paste.on-copy.validation.schema-type-incompatible.title": "Could not resolve schema type for path: {{path}}",
  /** The error message that is shown when there is no value to copy */
  "copy-paste.on-copy.validation.no-value.title": "Empty value, nothing to copy",
  /** The error message that is shown when the clipboard is not supported */
  "copy-paste.on-copy.validation.clipboard-not-supported.title": "Your browser does not support this action"
}), copyPasteLocaleResources = {
  locale: "en-US",
  namespace: copyPasteLocalNamespace,
  resources: copyPasteLocaleStrings
}, studioLocaleStrings = defineLocalesResources("studio", {
  /** "Disabled" status for auto-updates in About-dialog */
  "about-dialog.version-info.auto-updates.disabled": "Disabled",
  /** "Enabled" status for auto-updates in About-dialog */
  "about-dialog.version-info.auto-updates.enabled": "Enabled",
  /** "Auto Updates" status header in About-dialog */
  "about-dialog.version-info.auto-updates.header": "Auto Updates",
  /** "How to enable" next to Disabled state for Auto updates in about dialog */
  "about-dialog.version-info.auto-updates.how-to-enable": "How to enable",
  /** Text displayed on the "Copy to clipboard"-button after clicked */
  "about-dialog.version-info.copy-to-clipboard-button.copied-text": "Copied to Clipboard. Happy pasting!",
  /** "Copy to Clipboard" button text for copying version details from About-dialog */
  "about-dialog.version-info.copy-to-clipboard-button.text": "Copy to Clipboard",
  /** "Current version" header in about dialog  */
  "about-dialog.version-info.current-version.header": "Current version",
  /** "How to upgrade" link text */
  "about-dialog.version-info.how-to-upgrade": "How to upgrade",
  /** "Latest version" header in about dialog */
  "about-dialog.version-info.latest-version.header": "Latest version",
  /** "Latest version" header in about dialog */
  "about-dialog.version-info.latest-version.text": "Latest version is {{latestVersion}}",
  /** "Up to date" status in About-dialog */
  "about-dialog.version-info.up-to-date": "Up to date",
  /** "User agent" header in About-dialog */
  "about-dialog.version-info.user-agent.header": "User agent",
  /** The text used in the tooltip shown in the dialog close button */
  "announcement.dialog.close": "Close",
  /** Aria label to be used in the dialog close button */
  "announcement.dialog.close-label": "Close dialog",
  /**Text to be used in the tooltip in the button in the studio announcement card */
  "announcement.floating-button.dismiss": "Close",
  /**Aria label to be used in the floating button in the studio announcement card, to dismiss the card */
  "announcement.floating-button.dismiss-label": "Dismiss announcements",
  /**Aria label to be used in the floating button in the studio announcement card */
  "announcement.floating-button.open-label": "Open announcements",
  /** Menu item for deleting the asset */
  "asset-source.asset-list.menu.delete": "Delete",
  /** Menu item for showing where a particular asset is used */
  "asset-source.asset-list.menu.show-usage": "Show usage",
  /** Header in usage dialog for file assets */
  "asset-source.asset-usage-dialog.header_file": "Documents using file",
  /** Header in usage dialog for image assets */
  "asset-source.asset-usage-dialog.header_image": "Documents using image",
  /** Text shown in usage dialog when loading documents using the selected asset */
  "asset-source.asset-usage-dialog.loading": "Loading\u2026",
  /** Text for cancel action in delete-asset dialog */
  "asset-source.delete-dialog.action.cancel": "Cancel",
  /** Text for "confirm delete" action in delete-asset dialog */
  "asset-source.delete-dialog.action.delete": "Delete",
  /** Dialog header for delete-asset dialog when deleting a file */
  "asset-source.delete-dialog.header_file": "Delete file",
  /** Dialog header for delete-asset dialog when deleting an image */
  "asset-source.delete-dialog.header_image": "Delete image",
  /** Text shown in delete dialog when loading documents using the selected asset */
  "asset-source.delete-dialog.loading": "Loading\u2026",
  /** Message confirming to delete *named* file */
  "asset-source.delete-dialog.usage-list.confirm-delete-file_named": "You are about to delete the file <strong>{{filename}}</strong> and its metadata. Are you sure?",
  /** Message confirming to delete *unnamed* file */
  "asset-source.delete-dialog.usage-list.confirm-delete-file_unnamed": "You are about to delete the file and its metadata. Are you sure?",
  /** Message confirming to delete *named* image */
  "asset-source.delete-dialog.usage-list.confirm-delete-image_named": "You are about to delete the image <strong>{{filename}}</strong> and its metadata. Are you sure?",
  /** Message confirming to delete *unnamed* image */
  "asset-source.delete-dialog.usage-list.confirm-delete-image_unnamed": "You are about to delete the image and its metadata. Are you sure?",
  /** Alt text showing on image preview in delete asset dialog  */
  "asset-source.delete-dialog.usage-list.image-preview-alt": "Preview of image",
  /** Warning message showing when *named* file can't be deleted because it is in use */
  "asset-source.delete-dialog.usage-list.warning-file-is-in-use_named": "{{filename}} cannot be deleted because it's being used. In order to delete this file, you first need to remove all uses of it.",
  /** Warning message showing when *unnamed* file can't be deleted because it is in use */
  "asset-source.delete-dialog.usage-list.warning-file-is-in-use_unnamed": "This file cannot be deleted because it's being used. In order to delete it, you first need to remove all uses of it.",
  /** Warning message showing when *named* image can't be deleted because it is in use */
  "asset-source.delete-dialog.usage-list.warning-image-is-in-use_named": "{{filename}} cannot be deleted because it's being used. In order to delete this image, you first need to remove all uses of it.",
  /** Warning message showing when *unnamed* image can't be deleted because it is in use */
  "asset-source.delete-dialog.usage-list.warning-image-is-in-use_unnamed": "This image cannot be deleted because it's being used. In order to delete it, you first need to remove all uses of it.",
  /** Text shown when the list of assets only include a specific set of types */
  "asset-source.dialog.accept-message": "Only showing assets of accepted types: <strong>{{acceptTypes}}</strong>",
  /** Select asset dialog cancel-button */
  "asset-source.dialog.button.cancel": "Cancel",
  /** Select asset dialog select-button */
  "asset-source.dialog.button.select": "Select",
  /** Keys shared between both image asset source and file asset source */
  /** Select asset dialog title for files */
  "asset-source.dialog.default-title_file": "Select file",
  /** Select asset dialog title for images */
  "asset-source.dialog.default-title_image": "Select image",
  /** Insert asset error */
  "asset-source.dialog.insert-asset-error": "Error inserting asset. See the console for more information.",
  /** Select asset dialog load more items */
  "asset-source.dialog.load-more": "Load more",
  /** Text shown when selecting a file but there's no files to select from */
  "asset-source.dialog.no-assets_file": "No files",
  /** Text shown when selecting an image but there's no images to select from */
  "asset-source.dialog.no-assets_image": "No images",
  "asset-source.file.asset-list.action.delete.disabled-cannot-delete-current-file": "Cannot delete currently selected file",
  "asset-source.file.asset-list.action.delete.text": "Delete",
  "asset-source.file.asset-list.action.delete.title": "Delete file",
  "asset-source.file.asset-list.action.select-file.title": "Select the file {{filename}}",
  "asset-source.file.asset-list.action.show-usage.title": "Show usage",
  "asset-source.file.asset-list.delete-failed": "File could not be deleted",
  "asset-source.file.asset-list.delete-successful": "File was deleted",
  "asset-source.file.asset-list.header.date-added": "Date added",
  /** File asset source */
  "asset-source.file.asset-list.header.filename": "Filename",
  "asset-source.file.asset-list.header.size": "Size",
  "asset-source.file.asset-list.header.type": "Type",
  /** Text displayed on button or menu invoking the file asset source */
  "asset-source.file.title": "Uploaded files",
  "asset-source.image.asset-list.delete-failed": "Image could not be deleted",
  /** Image asset source */
  "asset-source.image.asset-list.delete-successful": "Image was deleted",
  /** Text displayed on button or menu invoking the image asset source */
  "asset-source.image.title": "Uploaded images",
  /** Built in asset source usage texts */
  "asset-source.usage-list.documents-using-file_named_one": "One document is using file <code>{{filename}}</code>",
  "asset-source.usage-list.documents-using-file_named_other": "{{count}} documents are using file <code>{{filename}}</code>",
  /** Text shown in usage dialog for a file asset when there are zero, one or more documents using the *named* file **/
  "asset-source.usage-list.documents-using-file_named_zero": "No documents are using file <code>{{filename}}</code>",
  "asset-source.usage-list.documents-using-file_unnamed_one": "One document is using this file",
  "asset-source.usage-list.documents-using-file_unnamed_other": "{{count}} documents are using this file",
  /** Text shown in usage dialog for a file asset when there are zero, one or more documents using the *unnamed* file **/
  "asset-source.usage-list.documents-using-file_unnamed_zero": "No documents are using this file",
  "asset-source.usage-list.documents-using-image_named_one": "One document is using image <code>{{filename}}</code>",
  "asset-source.usage-list.documents-using-image_named_other": "{{count}} documents are using image <code>{{filename}}</code>",
  /** Text shown in usage dialog for an image asset when there are zero, one or more documents using the *named* image **/
  "asset-source.usage-list.documents-using-image_named_zero": "No documents are using image <code>{{filename}}</code>",
  "asset-source.usage-list.documents-using-image_unnamed_one": "One document is using this image",
  "asset-source.usage-list.documents-using-image_unnamed_other": "{{count}} documents are using this image",
  /** Text shown in usage dialog for an image asset when there are zero, one or more documents using the *unnamed* image **/
  "asset-source.usage-list.documents-using-image_unnamed_zero": "No documents are using this image",
  /** Common (all) Asset Source texts. Note that all translation keys starting with 'asset-source.' is for the built in asset source. */
  "asset-sources.common.uploader.upload-failed.description": "See the console for more information.",
  "asset-sources.common.uploader.upload-failed.title": "Upload failed",
  /** Menu Items for Dataset Asset Source (will be replaced with workspace name by default) */
  "asset-sources.dataset.file.title": "Workspace files",
  "asset-sources.dataset.image.title": "Workspace images",
  /** Error messages for the Media Library Asset Source  */
  "asset-sources.media-library.error.library-could-not-be-resolved": "Something went wrong trying to resolve the Media Library for this project.",
  /** Menu Items for Media Library Asset Source */
  "asset-sources.media-library.file.title": "Media Library",
  "asset-sources.media-library.image.title": "Media Library",
  /** Info messages for the Media Library Asset Source  */
  "asset-sources.media-library.info.provisioning": "Please wait while we prepare your Media Library",
  /** Label when a release has been deleted by a different user */
  "banners.deleted-bundle-banner.text": "The '<strong>{{title}}</strong>' release has been deleted.",
  /** Action message for navigating to next month */
  "calendar.action.go-to-next-month": "Go to next month",
  /** Action message for navigating to next year */
  "calendar.action.go-to-next-year": "Go to next year",
  /** Action message for navigating to previous month */
  "calendar.action.go-to-previous-month": "Go to previous month",
  /** Action message for navigating to previous year */
  "calendar.action.go-to-previous-year": "Go to previous year",
  /* Label for navigating the calendar to "today", without _selecting_ today. Short form, eg `Today`, not `Go to today` */
  "calendar.action.go-to-today": "Today",
  /* Accessibility label for navigating the calendar to "today", without _selecting_ today */
  "calendar.action.go-to-today-aria-label": "Go to today",
  /* Label for navigating the calendar to "tomorrow", without _selecting_ tomorrow. Short form, eg `Tomorrow`, not `Go to tomorrow` */
  "calendar.action.go-to-tomorrow": "Tomorrow",
  /* Label for navigating the calendar to "yesterday", without _selecting_ yesterday. Short form, eg `Yesterday`, not `Go to yesterday` */
  "calendar.action.go-to-yesterday": "Yesterday",
  /** Label for switch that controls whether or not to include time in given timestamp */
  "calendar.action.include-time-label": "Include time",
  /** Action message for selecting the time */
  "calendar.action.select-time": "Select time",
  /** Action message for setting to the current time */
  "calendar.action.set-to-current-time": "Set to current time",
  /** Label for selecting an hour preset. Receives a `time` param as a string on hh:mm format and a `date` param as a Date instance denoting the preset date */
  "calendar.action.set-to-time-preset": "{{time}} on {{date, datetime}}",
  /** Aria label for button to open date picker */
  "calendar.button.aria-label": "Open calendar",
  /** Tooltip content for button to open datetime input */
  "calendar.button.tooltip-text": "Select date",
  /** Error message displayed in calendar when entered date is not the correct format */
  "calendar.error.must-be-in-format": "Must be in the format: {{exampleDate}}",
  /** Month name for April */
  "calendar.month-names.april": "April",
  /** Month name for August */
  "calendar.month-names.august": "August",
  /** Month name for December */
  "calendar.month-names.december": "December",
  /** Month name for February */
  "calendar.month-names.february": "February",
  /** Month name for January */
  "calendar.month-names.january": "January",
  /** Month name for July */
  "calendar.month-names.july": "July",
  /** Month name for June */
  "calendar.month-names.june": "June",
  /** Month name for March */
  "calendar.month-names.march": "March",
  /** Month name for May */
  "calendar.month-names.may": "May",
  /** Month name for November */
  "calendar.month-names.november": "November",
  /** Month name for October */
  "calendar.month-names.october": "October",
  /** Month name for September */
  "calendar.month-names.september": "September",
  /** Short weekday name for Friday */
  "calendar.weekday-names.short.friday": "Fri",
  /** Short weekday name for Monday */
  "calendar.weekday-names.short.monday": "Mon",
  /** Short weekday name for Saturdayday */
  "calendar.weekday-names.short.saturday": "Sat",
  /** Short weekday name for Sunday */
  "calendar.weekday-names.short.sunday": "Sun",
  /** Short weekday name for Thursday */
  "calendar.weekday-names.short.thursday": "Thu",
  /** Short weekday name for Tuesday */
  "calendar.weekday-names.short.tuesday": "Tue",
  /** Short weekday name for Wednesday */
  "calendar.weekday-names.short.wednesday": "Wed",
  /** Label for the close button label in Review Changes pane */
  "changes.action.close-label": "Close history",
  /** Cancel label for revert button prompt action */
  "changes.action.revert-all-cancel": "Cancel",
  /** Revert all confirm label for revert button action - used on prompt button + review changes pane */
  "changes.action.revert-all-confirm": "Revert all",
  /** Prompt for reverting all changes in document in Review Changes pane. Includes a count of changes. */
  "changes.action.revert-all-description": "Are you sure you want to revert all {{count}} changes?",
  /** Prompt for confirming revert change (singular) label for field change action */
  "changes.action.revert-changes-confirm-change_one": "Revert change",
  /** Revert for confirming revert (plural) label for field change action */
  "changes.action.revert-changes-confirm-change_other": "Revert changes",
  /** Prompt for reverting changes for a field change */
  "changes.action.revert-changes-description": "Are you sure you want to revert the changes?",
  /** Prompt for reverting changes for a group change, eg multiple changes */
  "changes.action.revert-changes-description_one": "Are you sure you want to revert the change?",
  /** Label for when the action of the change was to set something that was previously empty, eg a field was given a value, an array item was added, an asset was selected or similar */
  "changes.added-label": "Added",
  /** Array diff: An item was added in a given position (`{{position}}`) */
  "changes.array.item-added-in-position": "Added in position {{position}}",
  "changes.array.item-moved_down_one": "Moved {{count}} position down",
  "changes.array.item-moved_down_other": "Moved {{count}} positions down",
  /**
   * Array diff: An item was moved within the array.
   * Receives `{{count}}` representing number of positions it moved.
   * Context is the direction of the move, either `up` or `down`.
   */
  "changes.array.item-moved_up_one": "Moved {{count}} position up",
  "changes.array.item-moved_up_other": "Moved {{count}} positions up",
  /** Array diff: An item was removed from a given position (`{{position}}`) */
  "changes.array.item-removed-from-position": "Removed from position {{position}}",
  /** Accessibility label for the "change bar" shown when there are edits on a field-level */
  "changes.change-bar.aria-label": "Review changes",
  /** Label for when the action of the change was _not_ an add/remove, eg a text field changed value, an image was changed from one asset to another or similar */
  "changes.changed-label": "Changed",
  /** Label and text for tooltip that indicates the authors of the changes */
  "changes.changes-by-author": "Changes by",
  /** Additional text shown in development mode when a diff component crashes during rendering */
  "changes.error-boundary.developer-info": "Check the developer console for more information",
  /** Text shown when a diff component crashes during rendering, triggering the error boundary */
  "changes.error-boundary.title": "Rendering the changes to this field caused an error",
  /* Error description when changes could not be loaded */
  "changes.error-description": "We're unable to load the changes for this document.",
  /** Error title when changes could not be loaded */
  "changes.error-title": "Something went wrong",
  /** Error message shown when the value of a field is not the expected one */
  "changes.error.incorrect-type-message": 'Value error: Value is of type "<code>{{actualType}}</code>", expected "<code>{{expectedType}}</code>"',
  /** File diff: Fallback title for the meta info section when there is no original filename to use  */
  "changes.file.meta-info-fallback-title": "Untitled",
  /** Image diff: Text shown in tooltip when hovering hotspot that has changed in diff view */
  "changes.image.crop-changed": "Crop changed",
  /** Image diff: Text shown if the previous image asset was deleted (shouldn't theoretically happen) */
  "changes.image.deleted": "Image deleted",
  /** Image diff: Text shown if the image failed to be loaded when previewing it */
  "changes.image.error-loading-image": "Error loading image",
  /** Image diff: Text shown in tooltip when hovering hotspot that has changed in diff view */
  "changes.image.hotspot-changed": "Hotspot changed",
  /** Image diff: Fallback title for the meta info section when there is no original filename to use  */
  "changes.image.meta-info-fallback-title": "Untitled",
  /** Image diff: Text shown if no asset has been set for the field (but has metadata changes) */
  "changes.image.no-asset-set": "Image not set",
  /** Image diff: Text shown when the from/to state has/had no image */
  "changes.image.no-image-placeholder": "(no image)",
  /** Label for the "from" value in the change inspector */
  "changes.inspector.from-label": "From",
  /** Label for the "meta" (field path, action etc) information in the change inspector */
  "changes.inspector.meta-label": "Meta",
  /** Label for the "to" value in the change inspector */
  "changes.inspector.to-label": "To",
  /** Loading author of change in the differences tooltip in the review changes pane */
  "changes.loading-author": "Loading\u2026",
  /** Loading changes in Review Changes Pane */
  "changes.loading-changes": "Loading changes\u2026",
  /** Error message shown when the document revision could not be found */
  "changes.missing-since-document-error": "We couldn't find the document revision with id: <code>{{revisionId}}</code> you're trying to compare. <Break/> This is probably due to history retention policy of your plan. <Break/> Please select a different <strong>From</strong> entry.",
  /** No Changes description in the Review Changes pane */
  "changes.no-changes-description": "Edit the document or select an older version in the timeline to see a list of changes appear in this panel.",
  /** No Changes title in the Review Changes pane */
  "changes.no-changes-title": "There are no changes",
  /* Label for the tooltip that shows when an action is not selectable*/
  "changes.not-selectable": "It is not possible to select this event",
  /** Portable Text diff: An annotation was added */
  "changes.portable-text.annotation_added": "Added annotation",
  /** Portable Text diff: An annotation was changed */
  "changes.portable-text.annotation_changed": "Changed annotation",
  /** Portable Text diff: An annotation was removed */
  "changes.portable-text.annotation_removed": "Removed annotation",
  /** Portable Text diff: An annotation was left unchanged */
  "changes.portable-text.annotation_unchanged": "Unchanged annotation",
  /** Portable Text diff: A block changed from one style to another (eg `normal` to `h1` or similar) */
  "changes.portable-text.block-style-changed": 'Changed block style from "{{fromStyle}}" to "{{toStyle}}"',
  /** Portable Text diff: Change formatting of text (setting/unsetting marks, eg bold/italic etc) */
  "changes.portable-text.changed-formatting": "Changed formatting",
  /** Portable Text diff: An empty inline object is part of a change */
  "changes.portable-text.empty-inline-object": "Empty {{inlineObjectType}}",
  /** Portable Text diff: An empty object is the result of adding/removing an annotation */
  "changes.portable-text.empty-object-annotation": "Empty {{annotationType}}",
  /** Portable Text diff: Added a block containing no text (eg empty block) */
  "changes.portable-text.empty-text_added": "Added empty text",
  /** Portable Text diff: Changed a block that contained no text (eg empty block) */
  "changes.portable-text.empty-text_changed": "Changed empty text",
  /** Portable Text diff: Removed a block containing no text (eg empty block) */
  "changes.portable-text.empty-text_removed": "Removed empty text",
  /** Portable Text diff: An inline object was added */
  "changes.portable-text.inline-object_added": "Added inline object",
  /** Portable Text diff: An inline object was changed */
  "changes.portable-text.inline-object_changed": "Changed inline object",
  /** Portable Text diff: An inline object was removed */
  "changes.portable-text.inline-object_removed": "Removed inline object",
  /** Portable Text diff: An inline object was left unchanged */
  "changes.portable-text.inline-object_unchanged": "Unchanged inline object",
  /** Portable Text diff: Added a chunk of text */
  "changes.portable-text.text_added": "Added text",
  /** Portable Text diff: Removed a chunk of text */
  "changes.portable-text.text_removed": "Removed text",
  /** Portable Text diff: Annotation has an unknown schema type */
  "changes.portable-text.unknown-annotation-schema-type": "Unknown schema type",
  /** Portable Text diff: Inline object has an unknown schema type */
  "changes.portable-text.unknown-inline-object-schema-type": "Unknown schema type",
  /** Label for when the action of the change was a removal, eg a field was cleared, an array item was removed, an asset was deselected or similar */
  "changes.removed-label": "Removed",
  /** Same Revision Selected description in the Review Changes pane */
  "changes.same-revision-selected-description": "You have selected the same <strong>from</strong> and <strong>to</strong> revision, please select different revisions to compare the changes between them.",
  /** Same Revision Selected title in the Review Changes pane */
  "changes.same-revision-selected-title": "Same revision selected",
  /** Title for the Review Changes pane */
  "changes.title": "History",
  /**The title that will be shown in the badge inside the events when the item is a draft */
  "changes.versions.draft": "Draft",
  /** --- Common components --- */
  /** Tooltip text for context menu buttons */
  "common.context-menu-button.tooltip": "Show more",
  /** Default text for dialog cancel button */
  "common.dialog.cancel-button.text": "Cancel",
  /** Default text for dialog confirm button */
  "common.dialog.confirm-button.text": "Confirm",
  /** Default text in shared loader text / spinner lockup */
  "common.loading": "Loading",
  /** The title of the reconnecting toast */
  "common.reconnecting.toast.title": "Trying to connect\u2026",
  /** --- Configuration issues --- */
  /** Default label text on configuration issues button */
  "configuration-issues.button.label": "Configuration issues",
  /** Tooltip displayed on configuration issues button */
  "configuration-issues.button.tooltip": "Found configuration issues",
  /** The fallback title for an ordering menu item if no localized titles are provided. */
  "default-menu-item.fallback-title": "Sort by {{title}}",
  /** Title for the default ordering/SortOrder if no orderings are provided and the caption field is found */
  "default-orderings.caption": "Sort by Caption",
  /** Title for the default ordering/SortOrder if no orderings are provided and the description field is found */
  "default-orderings.description": "Sort by Description",
  /** Title for the default ordering/SortOrder if no orderings are provided and the header field is found */
  "default-orderings.header": "Sort by Header",
  /** Title for the default ordering/SortOrder if no orderings are provided and the heading field is found */
  "default-orderings.heading": "Sort by Heading",
  /** Title for the default ordering/SortOrder if no orderings are provided and the label field is found */
  "default-orderings.label": "Sort by Label",
  /** Title for the default ordering/SortOrder if no orderings are provided and the name field is found */
  "default-orderings.name": "Sort by Name",
  /** Title for the default ordering/SortOrder if no orderings are provided and the title field is found */
  "default-orderings.title": "Sort by Title",
  /** Label to show in the document footer indicating the creation date of the document */
  "document-status.created": "Created {{date}}",
  /** Label to show in the document status indicating the date of the status */
  "document-status.date": "{{date}}",
  /** Label to show in the document footer indicating the last edited date of the document */
  "document-status.edited": "Edited {{date}}",
  /** Label to show in the document footer indicating the document is not published*/
  "document-status.not-published": "Not published",
  /** Label to show in the document footer indicating the published date of the document */
  "document-status.published": "Published {{date}}",
  /** Label to show in the document footer indicating the revision from date of the document */
  "document-status.revision-from": "Revision from <em>{{date}}</em>",
  /** Label to show in the document footer indicating that the revision was not found */
  "document-status.revision-not-found": "Revision not found",
  /** Label to indicate that a document type was not found */
  "document.type.not-found": 'Document type "{{type}}" not found',
  /** The value of the <code>_key</code> property must be a unique string. */
  "form.error.duplicate-keys-alert.details.additional-description": "The value of the <code>_key</code> property must be a unique string.",
  /** This usually happens when items are created using an API client, and the <code>_key</code> property of each elements has been generated non-uniquely. */
  "form.error.duplicate-keys-alert.details.description": "This usually happens when items are created using an API client, and the <code>_key</code> property of each elements has been generated non-uniquely.",
  /** Developer info */
  "form.error.duplicate-keys-alert.details.title": "Developer info",
  /** Generate unique keys */
  "form.error.duplicate-keys-alert.generate-button.text": "Generate unique keys",
  /** Several items in this list share the same identifier (key). Every item must have an unique identifier. */
  "form.error.duplicate-keys-alert.summary": "Several items in this list share the same identifier (key). Every item must have an unique identifier.",
  /** Non-unique keys */
  "form.error.duplicate-keys-alert.title": "Non-unique keys",
  /** Error text shown when a field with a given name cannot be found in the schema or is conditionally hidden but explicitly told to render  */
  "form.error.field-not-found": 'Field "{{fieldName}}" not found among members \u2013 verify that it is defined in the schema and that it has not been conditionally hidden.',
  /** Add missing keys */
  "form.error.missing-keys-alert.add-button.text": "Add missing keys",
  /** The value of the <code>_key</code> property must be a unique string. */
  "form.error.missing-keys-alert.details.additional-description": "The value of the <code>_key</code> property must be a unique string.",
  /** This usually happens when items are created using an API client, and the <code>_key</code> property has not been included. */
  "form.error.missing-keys-alert.details.description": "This usually happens when items are created using an API client, and the <code>_key</code> property has not been included.",
  /** Developer info */
  "form.error.missing-keys-alert.details.title": "Developer info",
  /** Some items in the list are missing their keys. This must be fixed in order to edit the list. */
  "form.error.missing-keys-alert.summary": "Some items in the list are missing their keys. This must be fixed in order to edit the list.",
  /** Missing keys */
  "form.error.missing-keys-alert.title": "Missing keys",
  /** This usually happens when items are created using an API client, or when a custom input component has added invalid data to the list. */
  "form.error.mixed-array-alert.details.description": "This usually happens when items are created using an API client, or when a custom input component has added invalid data to the list.",
  /** Developer info */
  "form.error.mixed-array-alert.details.title": "Developer info",
  /**  Remove non-object values */
  "form.error.mixed-array-alert.remove-button.text": "Remove non-object values",
  /** Some items in this list are not objects. This must be fixed in order to edit the list. */
  "form.error.mixed-array-alert.summary": "Some items in this list are not objects. This must be fixed in order to edit the list.",
  /** Invalid list values */
  "form.error.mixed-array-alert.title": "Invalid list values",
  /** Error text shown when form is unable to find an array item at a given indexed path */
  "form.error.no-array-item-at-index": "No array item at index <code>{{index}}</code> found at path <code>{{path}}</code>",
  /** Error text shown when form is unable to find an array item at a given keyed path */
  "form.error.no-array-item-at-key": 'No array item with `_key` <code>"{{key}}"</code> found at path <code>{{path}}</code>',
  /** The title above the error call stack output related to the crash */
  "form.error.unhandled-runtime-error.call-stack.title": "Call Stack:",
  /** The title above the error component stack provided by React's underlying ErrorBoundary component */
  "form.error.unhandled-runtime-error.component-stack.title": "Component Stack:",
  /** The error message for the unhandled error that crashed the Input component during render */
  "form.error.unhandled-runtime-error.error-message": "Error: {{message}}",
  /** The title for the error card rendered inside a field in place of a crashing input */
  "form.error.unhandled-runtime-error.title": "Unhandled Runtime Error",
  /** Form field deprecated label */
  "form.field.deprecated-label": "deprecated",
  /** Fallback title shown above field if it has no defined title */
  "form.field.untitled-field-label": "Untitled",
  /** Accessibility label for the icon that indicates the field has a validation error */
  "form.validation.has-error-aria-label": "Has error",
  /** Accessibility label for the icon that indicates the field has validation information */
  "form.validation.has-info-aria-label": "Has information",
  /** Accessibility label for the icon that indicates the field has a validation warning */
  "form.validation.has-warning-aria-label": "Has warning",
  /** Text shown when summarizing validation information, when the field has one or more errors */
  "form.validation.summary.errors-count_one": "{{count}} error",
  "form.validation.summary.errors-count_other": "{{count}} errors",
  /** Text shown when summarizing validation information, when the field has one or more warnings */
  "form.validation.summary.warnings-count_one": "{{count}} warning",
  "form.validation.summary.warnings-count_other": "{{count}} warnings",
  /** Tooltip for free trial navbar button indicating remaining days */
  "free-trial.tooltip.days-count_one": "{{count}} day left in trial",
  "free-trial.tooltip.days-count_other": "{{count}} days left in trial",
  /** Tooltip for free trial navbar button, once trial has ended */
  "free-trial.tooltip.trial-finished": "Upgrade your project",
  /**
   * Label for "contact sales" call to action
   * These are titles for fallback links in the event the help & resources endpoint isn't able to be fetched
   */
  "help-resources.action.contact-sales": "Contact sales",
  /**
   * Label for "help and support" call to action
   * These are titles for fallback links in the event the help & resources endpoint isn't able to be fetched
   */
  "help-resources.action.help-and-support": "Help and support",
  /**
   * Label for "join our community" call to action
   * These are titles for fallback links in the event the help & resources endpoint isn't able to be fetched
   */
  "help-resources.action.join-our-community": "Join our community",
  /** Information for what the latest sanity version is */
  "help-resources.latest-sanity-version": "Latest version is {{latestVersion}}",
  /** Information for what studio version the current studio is running */
  "help-resources.studio-version": "Sanity Studio version {{studioVersion}}",
  /** Title for help and resources menus */
  "help-resources.title": "Help and resources",
  /** Text for button to cancel an ongoing upload */
  "input.files.common.cancel-upload": "Cancel",
  /** Text for menuitem upload button default asset source */
  "input.files.common.upload-placeholder.file-input-button.default-source.badge": "Default",
  /** Text for file input button in upload placeholder */
  "input.files.common.upload-placeholder.file-input-button.text": "Upload",
  /** Uploading <FileName/> */
  "input.files.common.upload-progress": "Uploading <FileName/>",
  /** The referenced document cannot be opened, because the URL failed to be resolved */
  "input.reference.document-cannot-be-opened.failed-to-resolve-url": "This document cannot be opened (unable to resolve URL to Studio)",
  /** Label for adding item after a specific array item */
  "inputs.array.action.add-after": "Add item after",
  /** Label for adding item before a specific array item */
  "inputs.array.action.add-before": "Add item before",
  /** Label for adding array item action when the schema allows for only one schema type */
  "inputs.array.action.add-item": "Add item",
  /**
   * Label for adding one array item action when the schema allows for multiple schema types,
   * eg. will prompt the user to select a type once triggered
   */
  "inputs.array.action.add-item-select-type": "Add item...",
  /** Label for copying an array item  */
  "inputs.array.action.copy": "Copy",
  /** Array drag handle button tooltip */
  "inputs.array.action.drag.tooltip": "Drag to re-order",
  /** Label for duplicating an array item  */
  "inputs.array.action.duplicate": "Duplicate",
  /** Label for editing the item of a specific type, eg "Edit Person" */
  "inputs.array.action.edit": "Edit {{itemTypeTitle}}",
  /** Label for removing an array item action  */
  "inputs.array.action.remove": "Remove",
  /** Label for removing action when an array item has an error  */
  "inputs.array.action.remove-invalid-item": "Remove",
  /** Label for viewing the item of a specific type, eg "View Person" */
  "inputs.array.action.view": "View {{itemTypeTitle}}",
  /** Error description for the array item tooltip that explains that the current item can still be moved or deleted but not edited since the schema definition is not found */
  "inputs.array.error.can-delete-but-no-edit-description": "You can still move or delete this item, but it cannot be edited since the schema definition for its type is nowhere to be found.",
  /** Error label for toast when array could not resolve the initial value */
  "inputs.array.error.cannot-resolve-initial-value-title": "Unable to resolve initial value for type: {{schemaTypeTitle}}: {{errorMessage}}.",
  /** Error label for toast when trying to upload one array item of a type that cannot be converted to array */
  "inputs.array.error.cannot-upload-unable-to-convert_one": "The following item can't be uploaded because there's no known conversion from content type to array item:",
  /** Error label for toast when trying to upload multiple array items of a type that cannot be converted to array */
  "inputs.array.error.cannot-upload-unable-to-convert_other": "The following items can't be uploaded because there's no known conversion from content types to array item:",
  /** Error description for the array item tooltip that explains that the current type item is not valid for the list  */
  "inputs.array.error.current-schema-not-declare-description": "The current schema does not declare items of type <code>{{typeName}}</code> as valid for this list. This could mean that the type has been removed as a valid item type, or that someone else has added it to their own local schema that is not yet deployed.",
  /** Error description to show how the item is being represented in the json format */
  "inputs.array.error.json-representation-description": "JSON representation of this item:",
  /** Error description for the array item tooltip that explains what the error means with more context */
  "inputs.array.error.type-is-incompatible-prompt": "Item of type <code>{{typeName}}</code> not valid for this list",
  /** Error title for when an item type within an array input is incompatible, used in the tooltip */
  "inputs.array.error.type-is-incompatible-title": "Why is this happening?",
  /** Error label for unexpected errors in the Array Input */
  "inputs.array.error.unexpected-error": "Unexpected Error: {{error}}",
  /** Label for the array insert menu all items filter  */
  "inputs.array.insert-menu.filter.all-items": "All",
  /** Label for when the array insert menu search shows no items */
  "inputs.array.insert-menu.search.no-results": "No items found",
  /** Placeholder for the array insert menu search field */
  "inputs.array.insert-menu.search.placeholder": "Search",
  /** Tooltip for the array insert menu grid view toggle */
  "inputs.array.insert-menu.toggle-grid-view.tooltip": "Toggle grid view",
  /** Tooltip for the array insert menu list view toggle */
  "inputs.array.insert-menu.toggle-list-view.tooltip": "Toggle list view",
  /** Label for when the array input doesn't have any items */
  "inputs.array.no-items-label": "No items",
  /** Label for read only array fields */
  "inputs.array.read-only-label": "This field is read-only",
  /** Label for when the array input is resolving the initial value for the item */
  "inputs.array.resolving-initial-value": "Resolving initial value\u2026",
  /** Tooltip content when boolean input is disabled */
  "inputs.boolean.disabled": "Disabled",
  /** Warning label when selected datetime is in the past */
  "inputs.dateTime.past-date-warning": "Select a date in the future.",
  /** Placeholder value for datetime input */
  "inputs.datetime.placeholder": "e.g. {{example}}",
  /** Acessibility label for button to open file options menu */
  "inputs.file.actions-menu.file-options.aria-label": "Open file options menu",
  /** Browse */
  "inputs.file.browse-button.text": "Select",
  /** Select file */
  "inputs.file.dialog.title": "Select file",
  /** Unknown member kind: `{{kind}}` */
  "inputs.file.error.unknown-member-kind": "Unknown member kind: {{kind}}",
  /** The value of this field is not a valid file. Resetting this field will let you choose a new file. */
  "inputs.file.invalid-file-warning.description": "The value of this field is not a valid file. Resetting this field will let you choose a new file.",
  /** Reset value */
  "inputs.file.invalid-file-warning.reset-button.text": "Reset value",
  /** Invalid file value */
  "inputs.file.invalid-file-warning.title": "Invalid file value",
  /** Select */
  "inputs.file.multi-browse-button.text": "Select",
  /** The upload could not be completed at this time. */
  "inputs.file.upload-failed.description": "The upload could not be completed at this time.",
  /** Upload failed */
  "inputs.file.upload-failed.title": "Upload failed",
  /** Clear field */
  "inputs.files.common.actions-menu.clear-field.label": "Clear field",
  /** Copy URL */
  "inputs.files.common.actions-menu.copy-url.label": "Copy URL",
  /** Download */
  "inputs.files.common.actions-menu.download.label": "Download",
  /** The URL is copied to the clipboard */
  "inputs.files.common.actions-menu.notification.url-copied": "The URL is copied to the clipboard",
  /** Replace */
  "inputs.files.common.actions-menu.replace.label": "Replace",
  /** Upload */
  "inputs.files.common.actions-menu.upload.label": "Upload",
  /** Drop to upload */
  "inputs.files.common.drop-message.drop-to-upload": "Drop to upload",
  /** Drop to upload `{{count}}` file */
  "inputs.files.common.drop-message.drop-to-upload-multi_one": "Drop to upload {{count}} file",
  /** Drop to upload `{{count}}` files */
  "inputs.files.common.drop-message.drop-to-upload-multi_other": "Drop to upload {{count}} files",
  /** Can't upload this file here */
  "inputs.files.common.drop-message.drop-to-upload.no-accepted-file-message_one": "Can't upload this file here",
  /** Can't upload any of these files here */
  "inputs.files.common.drop-message.drop-to-upload.no-accepted-file-message_other": "Can't upload any of these files here",
  /** `{{count}}` file can't be uploaded here */
  "inputs.files.common.drop-message.drop-to-upload.rejected-file-message_one": "{{count}} file can't be uploaded here",
  /** `{{count}}` files can't be uploaded here */
  "inputs.files.common.drop-message.drop-to-upload.rejected-file-message_other": "{{count}} files can't be uploaded here",
  /** Cannot upload `{{count}}` files */
  "inputs.files.common.placeholder.cannot-upload-some-files_one": "Cannot upload file",
  "inputs.files.common.placeholder.cannot-upload-some-files_other": "Cannot upload {{count}} files",
  /** Drag or paste type here */
  "inputs.files.common.placeholder.drag-or-paste-to-upload_file": "Drag or paste file here",
  /** Drag or paste image here */
  "inputs.files.common.placeholder.drag-or-paste-to-upload_image": "Drag or paste image here",
  /** Drop to upload file */
  "inputs.files.common.placeholder.drop-to-upload_file": "Drop to upload file",
  /** Drop to upload image */
  "inputs.files.common.placeholder.drop-to-upload_image": "Drop to upload image",
  /** Read only */
  "inputs.files.common.placeholder.read-only": "Read only",
  /** Select asset source destination for files to upload */
  "inputs.files.common.placeholder.select-asset-source-upload-destination": "Upload files to:",
  /** Can't upload files here */
  "inputs.files.common.placeholder.upload-not-supported": "Can't upload files here",
  /** Clear upload */
  "inputs.files.common.stale-upload-warning.clear": "Clear upload",
  /** An upload has made no progress for at least `{{staleThresholdMinutes}}` minutes and likely got interrupted. You can safely clear the incomplete upload and try uploading again. */
  "inputs.files.common.stale-upload-warning.description": "An upload has made no progress for at least {{staleThresholdMinutes}} minutes and likely got interrupted. You can safely clear the incomplete upload and try uploading again.",
  /** Incomplete upload */
  "inputs.files.common.stale-upload-warning.title": "Incomplete upload",
  /** Tooltip text for action to crop image */
  "inputs.image.actions-menu.crop-image-tooltip": "Crop image",
  /** Accessibility label for button to open image edit dialog */
  "inputs.image.actions-menu.edit-details.aria-label": "Open image edit dialog",
  /** Accessibility label for button to open image options menu */
  "inputs.image.actions-menu.options.aria-label": "Open image options menu",
  /** Select */
  "inputs.image.browse-menu.text": "Select",
  /** Cannot upload this file here */
  "inputs.image.drag-overlay.cannot-upload-here": "Cannot upload this file here",
  /** Drop image to upload */
  "inputs.image.drag-overlay.drop-to-upload-image": "Drop image to upload",
  /** This field is read only */
  "inputs.image.drag-overlay.this-field-is-read-only": "This field is read only",
  /** Unknown member kind: `{{kind}}` */
  "inputs.image.error.unknown-member-kind": "Unknown member kind: {{kind}}",
  /** Edit hotspot and crop */
  "inputs.image.hotspot-dialog.title": "Edit hotspot and crop",
  /** The value of this field is not a valid image. Resetting this field will let you choose a new image. */
  "inputs.image.invalid-image-warning.description": "The value of this field is not a valid image. Resetting this field will let you choose a new image.",
  /** Reset value */
  "inputs.image.invalid-image-warning.reset-button.text": "Reset value",
  /** Invalid image value */
  "inputs.image.invalid-image-warning.title": "Invalid image value",
  /** Preview of uploaded image */
  "inputs.image.preview-uploaded-image": "Preview of uploaded image",
  /** The upload could not be completed at this time. */
  "inputs.image.upload-error.description": "The upload could not be completed at this time.",
  /** Upload failed */
  "inputs.image.upload-error.title": "Upload failed",
  /** Adjust the rectangle to crop image. Adjust the circle to specify the area that should always be visible. */
  "inputs.imagetool.description": "Adjust the rectangle to crop image. Adjust the circle to specify the area that should always be visible.",
  /** Error: `{{errorMessage}}` */
  "inputs.imagetool.load-error": "Error: {{errorMessage}}",
  /** Hotspot & Crop */
  "inputs.imagetool.title": "Hotspot & Crop",
  /** Warnings displayed to developers when using the crop/hotspot tool on vector images, notifying them that crops/hotspot are not respected when serving the image in vector format. For the crop/hotspot to apply, images must be served in a raster format such as JPG or PNG, by appending eg `fm=jpg` to the image url, or calling `format('jpg')` if using `@sanity/image-url` */
  "inputs.imagetool.vector-warning.developer-info": "The Asset Pipeline does not support hotspot and crop for vector formats. To enable hotspot & crop, output this image to any of the supported raster formats. For example: <code>fm=jpg</code> to the <ImageUrlDocumentationLink>image URL</ImageUrlDocumentationLink> or call <code>.format('png')</code> with <ImageUrlPackageDocumentationLink>@sanity/image-url</ImageUrlPackageDocumentationLink>.",
  /** See developer info */
  "inputs.imagetool.vector-warning.expand-developer-info": "See developer info",
  /** Gotcha: Serving vector images with hotspot and crop from the Sanity Image API */
  "inputs.imagetool.vector-warning.title": "Warning: Hotspot and crop might not be applied to this image where it's presented.",
  /** Convert to `{{targetType}}` */
  "inputs.invalid-value.convert-button.text": "Convert to {{targetType}}",
  /** The current value (<code>`{{actualType}}`</code>) */
  "inputs.invalid-value.current-type": "The current value (<code>{{actualType}}</code>)",
  /** The property value is stored as a value type that does not match the expected type. */
  "inputs.invalid-value.description": "The property value is stored as a value type that does not match the expected type.",
  /** The value of this property must be of type <code>`{{validType}}`</code> according to the schema. */
  "inputs.invalid-value.details.description": "The value of this property must be of type <code>{{validType}}</code> according to the schema.",
  /** Only the following types are valid here according to schema: */
  "inputs.invalid-value.details.multi-type-description": "Only the following types are valid here according to schema:",
  /** Mismatching value types typically occur when the schema has recently been changed. */
  "inputs.invalid-value.details.possible-reason": "Mismatching value types typically occur when the schema has recently been changed.",
  /** Developer info */
  "inputs.invalid-value.details.title": "Developer info",
  /** -- Invalid Value Input -- */
  /** Reset value */
  "inputs.invalid-value.reset-button.text": "Reset value",
  /** Invalid property value */
  "inputs.invalid-value.title": "Invalid property value",
  /** Title for the "All fields" field group */
  "inputs.object.field-group-tabs.all-fields-title": "All fields",
  /** Aria label for the "Field groups" select control on smaller screens */
  "inputs.object.field-group-tabs.aria-label": "Field groups",
  /** Read-only field description */
  "inputs.object.unknown-fields.read-only.description": "This field is <strong>read only</strong> according to the document\u2019s schema and cannot be unset. If you want to be able to unset this in Studio, make sure you remove the <code>readOnly</code> field from the enclosing type in the schema.",
  /** Remove field */
  "inputs.object.unknown-fields.remove-field-button.text": "Remove field",
  /** Encountered `{{count}}` fields that are not defined in the schema. */
  "inputs.object.unknown-fields.warning.description_one": "Encountered a field that is not defined in the schema.",
  "inputs.object.unknown-fields.warning.description_other": "Encountered {{count}} fields that are not defined in the schema.",
  /** Detailed description of unknown field warning */
  "inputs.object.unknown-fields.warning.details.description_one": "This field is not defined in the schema, which could mean that the field definition has been removed or that someone else has added it to their own local project and have not deployed their changes yet.",
  "inputs.object.unknown-fields.warning.details.description_other": "These fields are not defined in the document\u2019s schema, which could mean that the field definitions have been removed or that someone else has added them to their own local project and have not deployed their changes yet.",
  /** Developer info */
  "inputs.object.unknown-fields.warning.details.title": "Developer info",
  /** Unknown field found */
  "inputs.object.unknown-fields.warning.title_one": "Unknown field found",
  "inputs.object.unknown-fields.warning.title_other": "Unknown fields found",
  /** Collapse the editor to save screen space  */
  "inputs.portable-text.action.collapse-editor": "Collapse editor",
  /** Aria label for action to edit an existing annotation */
  "inputs.portable-text.action.edit-annotation-aria-label": "Edit annotation",
  /** Expand the editor to give more editing space */
  "inputs.portable-text.action.expand-editor": "Expand editor",
  /** Label label for action to insert a block of a given type (`{{typeName}}`) */
  "inputs.portable-text.action.insert-block": "Insert {{typeName}}",
  /** Accessibility label for action to insert a block of a given type (`{{typeName}}`) */
  "inputs.portable-text.action.insert-block-aria-label": "Insert {{typeName}} (block)",
  /** Label for action to insert an inline object of a given type (`{{typeName}}`) */
  "inputs.portable-text.action.insert-inline-object": "Insert {{typeName}}",
  /** Accessibility label for action to insert an inline object of a given type (`{{typeName}}`) */
  "inputs.portable-text.action.insert-inline-object-aria-label": "Insert {{typeName}} (inline)",
  /** Aria label for action to remove an annotation */
  "inputs.portable-text.action.remove-annotation-aria-label": "Remove annotation",
  /** Label for activate on focus with context of click and not focused */
  "inputs.portable-text.activate-on-focus-message_click": "Click to activate",
  /** Label for activate on focus with context of click and focused */
  "inputs.portable-text.activate-on-focus-message_click-focused": "Click or press space to activate",
  /** Label for activate on focus with context of tap and not focused */
  "inputs.portable-text.activate-on-focus-message_tap": "Tap to activate",
  /** Aria label for the annotation object */
  "inputs.portable-text.annotation-aria-label": "Annotation object",
  /** Title for dialog that allows editing an annotation */
  "inputs.portable-text.annotation-editor.title": "Edit {{schemaType}}",
  /** Title of the default "link" annotation */
  "inputs.portable-text.annotation.link": "Link",
  /** Aria label for the block object */
  "inputs.portable-text.block.aria-label": "Block object",
  /** Label for action to edit a block item, in the case where it is editable */
  "inputs.portable-text.block.edit": "Edit",
  /** Accessibility label for the button that opens the actions menu on blocks */
  "inputs.portable-text.block.open-menu-aria-label": "Open menu",
  /** Label for action to open a reference, in the case of block-level reference types */
  "inputs.portable-text.block.open-reference": "Open reference",
  /** Label for action to remove a block item */
  "inputs.portable-text.block.remove": "Remove",
  /** Label for action to view a block item, in the case where it is read-only and thus cannot be edited */
  "inputs.portable-text.block.view": "View",
  /** Title of the "code" decorator */
  "inputs.portable-text.decorator.code": "Code",
  /** Title of the "em" (emphasis) decorator */
  "inputs.portable-text.decorator.emphasis": "Italic",
  /** Title of the "strike-through" decorator */
  "inputs.portable-text.decorator.strike-through": "Strike",
  /** Title of the "strong" decorator */
  "inputs.portable-text.decorator.strong": "Strong",
  /** Title of the "underline" decorator */
  "inputs.portable-text.decorator.underline": "Underline",
  /** Placeholder text for when the editor is empty */
  "inputs.portable-text.empty-placeholder": "Empty",
  /** Aria label for the block object */
  "inputs.portable-text.inline-block.aria-label": "Inline object",
  /** Label for action to edit an inline object item */
  "inputs.portable-text.inline-object.edit": "Edit object",
  /** Aria label for icon for action to edit an inline object item */
  "inputs.portable-text.inline-object.edit-aria-label": "Edit object",
  /** Label for action to remove an inline object item */
  "inputs.portable-text.inline-object.remove": "Remove object",
  /** Aria label for icon for action to remove an inline object item */
  "inputs.portable-text.inline-object.remove-aria-label": "Remove object",
  /** Disclaimer text shown on invalid Portable Text value, when an action is available to unblock the user, but it is not guaranteed to be safe */
  "inputs.portable-text.invalid-value.action-disclaimer": "NOTE: It\u2019s generally safe to perform the action above, but if you are in doubt, get in touch with those responsible for configuring your studio.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` has a child with key `{{childKey}}` of type `{{childType}}` which is not allowed by the schema definition */
  "inputs.portable-text.invalid-value.disallowed-child-type.action": "Remove the object",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` has a child with key `{{childKey}}` of type `{{childType}}` which is not allowed by the schema definition */
  "inputs.portable-text.invalid-value.disallowed-child-type.description": "Child with key {{childKey}} of block with key <code>{{key}}</code> is of type <code>{{childType}}</code>, which is not allowed by the schema.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` has a type (`{{typeName}}`) that is not an allowed block type for this field */
  "inputs.portable-text.invalid-value.disallowed-type.action": "Remove the block",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` has a type (`{{typeName}}`) that is not an allowed block type for this field */
  "inputs.portable-text.invalid-value.disallowed-type.description": "Block with key <code>{{key}}</code> is of type <code>{{typeName}}</code>, which is not allowed by the schema.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` contains no children */
  "inputs.portable-text.invalid-value.empty-children.action": "Insert empty text span",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` contains no children */
  "inputs.portable-text.invalid-value.empty-children.description": "Text block with key <code>{{key}}</code> has no text spans.",
  /** Label for the button to ignore invalid values in the Portable Text editor */
  "inputs.portable-text.invalid-value.ignore-button.text": "Ignore",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` has a `_type` property that is set to `block`, but the block type defined in schema has a different name (`{{expectedTypeName}}`) */
  "inputs.portable-text.invalid-value.incorrect-block-type.action": "Use type <code>{{expectedTypeName}}</code>",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` has a `_type` property that is set to `block`, but the block type defined in schema has a different name (`{{expectedTypeName}}`) */
  "inputs.portable-text.invalid-value.incorrect-block-type.description": "Block with key <code>{{key}}</code> has an invalid type name. According to the schema, it should be <code>{{expectedTypeName}}</code>.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` has a span with key `{{childKey}}` that has a missing or invalid `text` property */
  "inputs.portable-text.invalid-value.invalid-span-text.action": "Set empty text value",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` has a span with key `{{childKey}}` that has a missing or invalid `text` property */
  "inputs.portable-text.invalid-value.invalid-span-text.description": "Span with key {{childKey}} of block with key <code>{{key}}</code> has a missing or invalid <code>text</code> property.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` is missing a `_type` property, but seems to be a block of type `{{expectedTypeName}}` */
  "inputs.portable-text.invalid-value.missing-block-type.action": "Use type <code>{{expectedTypeName}}</code>",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` is missing a `_type` property, but seems to be a block of type `{{expectedTypeName}}` */
  "inputs.portable-text.invalid-value.missing-block-type.description": "Block with key <code>{{key}}</code> is missing a type name. According to the schema, it should be <code>{{expectedTypeName}}</code>.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` has a child at `{{index}}` which is missing `_key` property */
  "inputs.portable-text.invalid-value.missing-child-key.action": "Assign random key",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` has a child at `{{index}}` which is missing `_key` property */
  "inputs.portable-text.invalid-value.missing-child-key.description": "Child at index <code>{{index}}</code> of block with key <code>{{key}}</code> is missing <code>_key</code> property.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` has a child with key `{{childKey}}` which is missing a `_type` property */
  "inputs.portable-text.invalid-value.missing-child-type.action": "Remove the object",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` has a child with key `{{childKey}}` which is missing a `_type` property */
  "inputs.portable-text.invalid-value.missing-child-type.description": "Child with key {{childKey}} of block with key <code>{{key}}</code> is missing <code>_type</code> property.",
  /** Action presented when the Portable Text field value is invalid, when child at `{{index}}` is missing the required `_key` property */
  "inputs.portable-text.invalid-value.missing-key.action": "Assign random key",
  /** Text explaining that the Portable Text field value is invalid, when child at `{{index}}` is missing the required `_key` property */
  "inputs.portable-text.invalid-value.missing-key.description": "Block at index <code>{{index}}</code> is missing required <code>_key</code> property.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` has a missing or invalid `children` property */
  "inputs.portable-text.invalid-value.missing-or-invalid-children.action": "Remove the block",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` has a missing or invalid `children` property */
  "inputs.portable-text.invalid-value.missing-or-invalid-children.description": "Text block with key <code>{{key}}</code> has an invalid or missing `children` property.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` has a missing or invalid `markDefs` property */
  "inputs.portable-text.invalid-value.missing-or-invalid-markdefs.action": "Add property",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` has a missing or invalid `markDefs` property */
  "inputs.portable-text.invalid-value.missing-or-invalid-markdefs.description": "Text block with key <code>{{key}}</code> has an invalid or missing `markDefs` property.",
  /** Action presented when the Portable Text field value is invalid, when child with key `{{key}}` is missing a `_type` property  */
  "inputs.portable-text.invalid-value.missing-type.action": "Remove the block",
  /** Text explaining that the Portable Text field value is invalid, when child with key `{{key}}` is missing a `_type` property  */
  "inputs.portable-text.invalid-value.missing-type.description": "Block with key <code>{{key}}</code> is missing a type name.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` contains a non-object child at index `{{index}}` */
  "inputs.portable-text.invalid-value.non-object-child.action": "Remove the item",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` contains a non-object child at index `{{index}}` */
  "inputs.portable-text.invalid-value.non-object-child.description": "Child at index <code>{{index}}</code> of block with key <code>{{key}}</code> is not an object.",
  /** Action presented when the Portable Text field value is invalid, when the Portable Text field is not an array, or the array is empty */
  "inputs.portable-text.invalid-value.not-an-array.action": "Unset the value",
  /** Text explaining that the Portable Text field value is invalid, when the Portable Text field is not an array, or the array is empty */
  "inputs.portable-text.invalid-value.not-an-array.description": "Value must be an array of Portable Text blocks, or undefined.",
  /** Action presented when the Portable Text field value is invalid, when child at `{{index}}` is not an object */
  "inputs.portable-text.invalid-value.not-an-object.action": "Remove item",
  /** Text explaining that the Portable Text field value is invalid, when child at `{{index}}` is not an object */
  "inputs.portable-text.invalid-value.not-an-object.description": "Item at <code>{{index}}</code> is not an object,.",
  /** Action presented when the Portable Text field value is invalid, when block with key `{{key}}` contains marks (`{{orphanedMarks}}`) that are not supported by the current schema */
  "inputs.portable-text.invalid-value.orphaned-marks.action": "Remove disallowed marks",
  /** Text explaining that the Portable Text field value is invalid, when block with key `{{key}}` contains marks (`{{orphanedMarks}}`) that are not supported by the current schema */
  "inputs.portable-text.invalid-value.orphaned-marks.description": "Text block with key <code>{{key}}</code> contains marks <code>({{orphanedMarks, list}})</code> that are not allowed by the schema.",
  /** Title for the alert indicating that the Portable Text field has an invalid value */
  "inputs.portable-text.invalid-value.title": "Invalid Portable Text value",
  /** Title of "bulleted" list type */
  "inputs.portable-text.list-type.bullet": "Bulleted list",
  /** Title of numbered list type */
  "inputs.portable-text.list-type.number": "Numbered list",
  /** Title of the "h1" block style */
  "inputs.portable-text.style.h1": "Heading 1",
  /** Title of the "h2" block style */
  "inputs.portable-text.style.h2": "Heading 2",
  /** Title of the "h3" block style */
  "inputs.portable-text.style.h3": "Heading 3",
  /** Title of the "h4" block style */
  "inputs.portable-text.style.h4": "Heading 4",
  /** Title of the "h5" block style */
  "inputs.portable-text.style.h5": "Heading 5",
  /** Title of the "h6" block style */
  "inputs.portable-text.style.h6": "Heading 6",
  /** Title shown when multiple blocks of varying styles is selected */
  "inputs.portable-text.style.multiple": "Multiple",
  /** Title of fallback when no style is given for a block */
  "inputs.portable-text.style.none": "No style",
  /** Title of the "normal" block style */
  "inputs.portable-text.style.normal": "Normal",
  /** Title of the "quote" block style */
  "inputs.portable-text.style.quote": "Quote",
  /** Label for action to clear the current value of the reference field */
  "inputs.reference.action.clear": "Clear",
  /** Label for action to copy the current item (used within arrays) */
  "inputs.reference.action.copy": "Copy",
  /** Label for action to create a new document from the reference input */
  "inputs.reference.action.create-new-document": "Create",
  /** Label for action to create a new document from the reference input, when there are multiple templates or document types to choose from */
  "inputs.reference.action.create-new-document-select": "Create\u2026",
  /** Label for action to duplicate the current item to a new item (used within arrays) */
  "inputs.reference.action.duplicate": "Duplicate",
  /** Label for action that opens the referenced document in a new tab */
  "inputs.reference.action.open-in-new-tab": "Open in new tab",
  /** Label for action to remove the reference from an array */
  "inputs.reference.action.remove": "Remove",
  /** Label for action to replace the current value of the field */
  "inputs.reference.action.replace": "Replace",
  /** Label for action to cancel a previously initiated replace action  */
  "inputs.reference.action.replace-cancel": "Cancel replace",
  /** The cross-dataset reference field currently has a reference, but the feature has been disabled since it was created. This explains what can/cannot be done in its current state. */
  "inputs.reference.cross-dataset.feature-disabled-actions": "You can still clear this field's existing reference, but it cannot be changed to a different document as long as the feature is disabled.",
  /** A cross-dataset reference field exists but the feature has been disabled. A <DocumentationLink> component is available. */
  "inputs.reference.cross-dataset.feature-disabled-description": "This feature has been disabled. Read how to enable it in <DocumentationLink>the documentation</DocumentationLink>.",
  /** Title for a warning telling the user that the current project does not have the "cross dataset references" feature */
  "inputs.reference.cross-dataset.feature-unavailable-title": "Unavailable feature: Cross dataset reference",
  /** The cross-dataset reference points to a document with an invalid type  */
  "inputs.reference.cross-dataset.invalid-type": "The referenced document is of invalid type ({{typeName}}) <JsonValue/>",
  /** The referenced document will open in a new tab (due to external studio) */
  "inputs.reference.document-opens-in-new-tab": "This document opens in a new tab",
  /** Error title for when the document is unavailable (for any possible reason) */
  "inputs.reference.error.document-unavailable-title": "Document unavailable",
  /** Error title for when the referenced document failed to be loaded */
  "inputs.reference.error.failed-to-load-document-title": "Failed to load referenced document",
  /** Error title for when the reference search returned a document that is not an allowed type for the field */
  "inputs.reference.error.invalid-search-result-type-title": `Search returned a type that's not valid for this reference: "{{returnedType}}"`,
  /** Error description for when the document referenced is not one of the types declared as allowed target types in schema */
  "inputs.reference.error.invalid-type-description": "Referenced document (<code>{{documentId}}</code>) is of type <code>{{actualType}}</code>. According to the schema, referenced documents can only be of type <AllowedTypes/>.",
  /** Error title for when the document referenced is not one of the types declared as allowed target types in schema */
  "inputs.reference.error.invalid-type-title": "Document of invalid type",
  /** Error description for when the user does not have permissions to read the referenced document */
  "inputs.reference.error.missing-read-permissions-description": "The referenced document could not be accessed due to insufficient permissions",
  /** Error title for when the user does not have permissions to read the referenced document */
  "inputs.reference.error.missing-read-permissions-title": "Insufficient permissions",
  /** Error description for when the current reference value points to a document that does not exist (on weak references) */
  "inputs.reference.error.nonexistent-document-description": "The referenced document does not exist (ID: <code>{{documentId}}</code>). You can either remove the reference or replace it with another document.",
  /** Error title for when the current reference value points to a document that does not exist (on weak references) */
  "inputs.reference.error.nonexistent-document-title": "Not found",
  /** Label for button that clears the reference when it points to a document that does not exist (on weak references) */
  "inputs.reference.error.nonexistent-document.clear-button-label": "Clear",
  /** Error title for when the search for a reference failed. Note that the message sent by the backend may not be localized. */
  "inputs.reference.error.search-failed-title": "Reference search failed",
  /** Label for when the GDR points to an invalid type  */
  "inputs.reference.global.invalid-type": "The referenced document is of invalid type ({{typeName}})",
  /** Alternative text for the image shown in cross-dataset reference input */
  "inputs.reference.image-preview-alt-text": "Image preview of referenced document",
  /** Description for alert shown when a reference in a live-edit document is marked as being weak, the referenced document exists, AND the reference is supposed to be have been strengthened on publish */
  "inputs.reference.incomplete-reference.finalize-action-description": "<strong>{{referencedDocument}}</strong> is published and this reference should now be finalized.",
  /** Title for alert shown when a reference in a live-edit document is marked as being weak, the referenced document exists, AND the reference is supposed to be have been strengthened on publish */
  "inputs.reference.incomplete-reference.finalize-action-title": "Finalize reference",
  /** Description for alert shown when a reference in a live-edit document points to a document that exists and has been published, but the reference is still marked as weak */
  "inputs.reference.incomplete-reference.strengthen-action-description": "<strong>{{referencedDocument}}</strong> is published and this reference should now be converted to a strong reference.",
  /** Title for alert shown when a reference in a live-edit document points to a document that exists and has been published, but the reference is still marked as weak */
  "inputs.reference.incomplete-reference.strengthen-action-title": "Convert to strong reference",
  /** Label for button that triggers the action that strengthen a reference */
  "inputs.reference.incomplete-reference.strengthen-button-label": "Convert to strong reference",
  /** Label for button that triggers a retry attempt for reference metadata  */
  "inputs.reference.metadata-error.retry-button-label": "Retry",
  /** Title for alert shown when reference metadata fails to be loaded */
  "inputs.reference.metadata-error.title": "Unable to load reference metadata",
  /** Message shown when no documents were found that matched the given search string */
  "inputs.reference.no-results-for-query": "No results for <strong>\u201C{{searchTerm}}\u201D</strong>",
  /** Text for tooltip showing when a document was edited, using relative time (eg "how long ago was it edited?") */
  "inputs.reference.preview.edited-at-time": "Edited <RelativeTime/>",
  /** Accessibility label for icon indicating that document does _not_ have any unpublished changes */
  "inputs.reference.preview.has-no-unpublished-changes-aria-label": "No unpublished edits",
  /** Accessibility label for icon indicating that document has unpublished changes */
  "inputs.reference.preview.has-unpublished-changes-aria-label": "Edited",
  /** Accessibility label for icon indicating that document does _not_ have a published version */
  "inputs.reference.preview.is-not-published-aria-label": "Not published",
  /** Accessibility label for icon indicating that document has a published version */
  "inputs.reference.preview.is-published-aria-label": "Published",
  /** Text for tooltip indicating that a document has no unpublished edits */
  "inputs.reference.preview.no-unpublished-edits": "No unpublished edits",
  /** Text for tooltip indicating that a document has not yet been published */
  "inputs.reference.preview.not-published": "Not published",
  /** Text for tooltip showing when a document was published, using relative time (eg "how long ago was it published?") */
  "inputs.reference.preview.published-at-time": "Published <RelativeTime/>",
  /** The referenced document no longer exist and might have been deleted (for weak references) */
  "inputs.reference.referenced-document-does-not-exist": "The referenced document no longer exist and might have been deleted (document ID: <code>{{documentId}}</code>).",
  /** The referenced document could not be displayed to the user because of insufficient permissions */
  "inputs.reference.referenced-document-insufficient-permissions": "The referenced document could not be accessed due to insufficient permissions",
  /** Label for when the reference input is resolving the initial value for an item */
  "inputs.reference.resolving-initial-value": "Resolving initial value\u2026",
  /** Placeholder shown in a reference input with no current value */
  "inputs.reference.search-placeholder": "Type to search",
  /** Explanation of the consequences of leaving the reference as strong instead of weak */
  "inputs.reference.strength-mismatch.is-strong-consquences": "It will not be possible to delete the reference document without first removing this reference or converting it to weak.",
  /** Description for alert shown when a reference is supposed to be weak, but the actual value is strong */
  "inputs.reference.strength-mismatch.is-strong-description": "This reference is <em>strong</em>, but according to the current schema it should be <em>weak</em>.",
  /** Explanation of the consequences of leaving the reference as weak instead of strong */
  "inputs.reference.strength-mismatch.is-weak-consquences": "This makes it possible to delete the referenced document without first deleting this reference, leaving this field referencing a nonexisting document.",
  /** Description for alert shown when a reference is supposed to be strong, but the actual value is weak */
  "inputs.reference.strength-mismatch.is-weak-description": "This reference is <em>weak</em>, but according to the current schema it should be <em>strong</em>.",
  /** Label for button that triggers the action that strengthens a reference on strength mismatch */
  "inputs.reference.strength-mismatch.strengthen-button-label": "Convert to strong reference",
  /** Title for alert shown when a reference is supposed to be weak/strong, but the actual value is the opposite of what it is supposed to be */
  "inputs.reference.strength-mismatch.title": "Reference strength mismatch",
  /** Label for button that triggers the action that weakens a reference on strength mismatch */
  "inputs.reference.strength-mismatch.weaken-button-label": "Convert to weak reference",
  /** Action message for generating the slug */
  "inputs.slug.action.generate": "Generate",
  /** Loading message for when the input is actively generating a slug */
  "inputs.slug.action.generating": "Generating\u2026",
  /** Error message for when the source to generate a slug from is missing */
  "inputs.slug.error.missing-source": "Source is missing. Check source on type {{schemaType}} in schema",
  /** Placeholder for an empty tag input */
  "inputs.tags.placeholder": "Enter tag and press ENTER\u2026",
  /** Placeholder for an empty tag input on touch devices */
  "inputs.tags.placeholder_touch": "Enter tag\u2026",
  /** Convert to `{{targetType}}` */
  "inputs.untyped-value.convert-button.text": "Convert to {{targetType}}",
  /** Encountered an object value without a <code>_type</code> property. */
  "inputs.untyped-value.description": "Encountered an object value without a <code>_type</code> property.",
  /** Either remove the <code>name</code> property of the object declaration, or set <code>_type</code> property on items. */
  "inputs.untyped-value.details.description": "Either remove the <code>name</code> property of the object declaration, or set <code>_type</code> property on items.",
  /** Current value (<code>object</code>): */
  "inputs.untyped-value.details.json-dump-prefix": "Current value (<code>object</code>):",
  /** The following types are valid here according to schema: */
  "inputs.untyped-value.details.multi-type-description": "The following types are valid here according to schema:",
  /** Developer info */
  "inputs.untyped-value.details.title": "Developer info",
  /** Property value missing <code>_type</code> */
  "inputs.untyped-value.title": "Property value missing <code>_type</code>",
  /** Unset value */
  "inputs.untyped-value.unset-item-button.text": "Unset value",
  /** The fallback explanation if no context is provided */
  "insufficient-permissions-message.not-authorized-explanation": "You do not have permission to access this feature.",
  /** The explanation when unable to create any document at all */
  "insufficient-permissions-message.not-authorized-explanation_create-any-document": "You do not have permission to create a document.",
  /** The explanation when unable to create a particular document */
  "insufficient-permissions-message.not-authorized-explanation_create-document": "You do not have permission to create this document.",
  /** The explanation when unable to create a particular type of document */
  "insufficient-permissions-message.not-authorized-explanation_create-document-type": "You do not have permission to create this kind of document.",
  /** The explanation when unable to create a new reference in a document */
  "insufficient-permissions-message.not-authorized-explanation_create-new-reference": "You do not have permission to create a new reference.",
  /** The explanation when unable to delete a particular document */
  "insufficient-permissions-message.not-authorized-explanation_delete-document": "You do not have permission to delete this document.",
  /** The explanation when unable to delete a schedule on scheduled publishing */
  "insufficient-permissions-message.not-authorized-explanation_delete-schedules": "You do not have permission to delete schedules.",
  /** The explanation when unable to discard changes in a particular document */
  "insufficient-permissions-message.not-authorized-explanation_discard-changes": "You do not have permission to discard changes in this document.",
  /** The explanation when unable to duplicate a particular document */
  "insufficient-permissions-message.not-authorized-explanation_duplicate-document": "You do not have permission to duplicate this document.",
  /** The explanation when unable to edit a schedule on scheduled publishing */
  "insufficient-permissions-message.not-authorized-explanation_edit-schedules": "You do not have permission to edit schedules.",
  /** The explanation when unable to execute a schedule on scheduled publishing */
  "insufficient-permissions-message.not-authorized-explanation_execute-schedules": "You do not have permission to execute schedules.",
  /** The explanation when unable to publish a particular document */
  "insufficient-permissions-message.not-authorized-explanation_publish-document": "You do not have permission to publish this document.",
  /** The explanation when unable to unpublish a particular document */
  "insufficient-permissions-message.not-authorized-explanation_unpublish-document": "You do not have permission to unpublish this document.",
  /** Appears after the not-authorized message. Lists the current roles. */
  "insufficient-permissions-message.roles": "Your roles: <Roles/>",
  /** The title for the insufficient permissions message component */
  "insufficient-permissions-message.title": "Insufficient permissions",
  /** Unexpected error: `{{error}}` */
  "member-field-error.unexpected-error": "Unexpected error: {{error}}",
  /** Text shown in warning when browser is using HTTP1 to communicate with the Sanity API */
  "network-check.slow-protocol-warning.description": "Your browser is using an outdated HTTP protocol to communicate with Sanity. This may result in substantially degraded performance.",
  /** Text for link that takes the user to the Sanity documentation to learn more about the HTTP1 issue */
  "network-check.slow-protocol-warning.learn-more-button.text": "Learn more",
  /** Text for link that takes the user to the Sanity documentation to learn more about the HTTP1 issue */
  "network-check.slow-protocol-warning.snooze-button.text": "Don't show again for this session",
  /** Title text for the warning dialog when browser is using HTTP1 to communicate with the Sanity API */
  "network-check.slow-protocol-warning.title": "You've got your breaks on",
  /** Button label for "Create new document" button */
  "new-document.button": "Create",
  /**
   * Tooltip message displayed when hovering/activating the "Create new document" action,
   * when there are templates/types available for creation
   */
  "new-document.create-new-document-label": "New document\u2026",
  /** Tooltip message for add document button when the selected perspective is published  */
  "new-document.disabled-published.tooltip": "You cannot create new published documents",
  /** Tooltip message for add document button when the selected perspective is for inactive release */
  "new-document.disabled-release.tooltip": "You cannot add documents to this release",
  /** Placeholder for the "filter" input within the new document menu */
  "new-document.filter-placeholder": "Search document types",
  /** Loading indicator text within the new document menu */
  "new-document.loading": "Loading\u2026",
  /** Accessibility label for the list displaying options in the new document menu */
  "new-document.new-document-aria-label": "New document",
  /** Message for when there are no document type options in the new document menu */
  "new-document.no-document-types-found": "No document types found",
  /**
   * Tooltip message displayed when hovering/activating the "Create new document" action,
   * when there are no templates/types to create from
   */
  "new-document.no-document-types-label": "No document types",
  /** Message for when no results are found for a specific search query in the new document menu */
  "new-document.no-results": "No results for <strong>{{searchQuery}}</strong>",
  /** Aria label for the button that opens the "Create new document" popover/dialog */
  "new-document.open-dialog-aria-label": "Create new document",
  /** Title for "Create new document" dialog */
  "new-document.title": "Create new document",
  /** Label for button that will make the browser reload when users' studio version is out-of-date */
  "package-version.new-package-available.reload-button": "Push to reload",
  /** Title of the alert for studio users when packages in their studio are out-of-date */
  "package-version.new-package-available.title": "Sanity Studio is ready to update!",
  /** Label for action to invite members to the current studio project */
  "presence.action.manage-members": "Invite members",
  /** Accessibility label for presence menu button */
  "presence.aria-label": "Global presence",
  /** Message description for when no one else is currently present */
  "presence.no-one-else-description": "Invite people to the project to see their online status.",
  /** Message title for when no one else is currently present */
  "presence.no-one-else-title": "No one else is here",
  /** Message for when a user is not in a document (displayed in the global presence menu) */
  "presence.not-in-a-document": "Not in a document",
  /** Tooltip content text for presence menu button */
  "presence.tooltip-content": "Who is here",
  /** Fallback title shown when a preview does not provide a title */
  "preview.default.title-fallback": "Untitled",
  /** Fallback preview value for types that have "no value" (eg null, undefined) */
  "preview.fallback.no-value": "(no value)",
  /** Alternative text for image being shown while image is being uploaded, in previews */
  "preview.image.file-is-being-uploaded.alt-text": "The image currently being uploaded",
  /* Relative time, just now */
  "relative-time.just-now": "just now",
  /** Action message to add document to new release */
  "release.action.add-to-new-release": "Add to release",
  /** Action message to add document to release */
  "release.action.add-to-release": "Add to {{title}}",
  /** Action message for when document is already in release  */
  "release.action.already-in-release": "Already in release {{title}}",
  /** Action message for when you click to view all versions you can copy the current document to */
  "release.action.copy-to": "Copy version to",
  /** Action message for creating new releases */
  "release.action.create-new": "New release",
  /** Action message for when document is already in release  */
  "release.action.discard-version": "Discard version",
  /** Description for toast when version discarding failed */
  "release.action.discard-version.failure": "Failed to discard version",
  /** Action message for when a new release is created off an existing version, draft or published document */
  "release.action.new-release": "New Release",
  /** Tooltip message for not having permissions for creating new releases */
  "release.action.permission.error": "You do not have permission to perform this action",
  /** Error message for when a version is set to be unpublished */
  "release.action.unpublish-version.failure": "Failed to set version to be unpublished on release",
  /** Action message for when a version is set to be unpublished successfully */
  "release.action.unpublish-version.success": "Successfully set <strong>{{title}}</strong> to be unpublished on release",
  /** Action message for when the view release is pressed */
  "release.action.view-release": "View release",
  /** Label for banner when release is scheduled */
  "release.banner.scheduled-for-publishing-on": "Scheduled to be published on {{date}}",
  /** Label for Draft chip in document header */
  "release.chip.draft": "Draft",
  /** Label for Draft chip in global header */
  "release.chip.global.drafts": "Drafts",
  /** Label for Published chip in document header */
  "release.chip.published": "Published",
  /** Label for tooltip in chip when document is in an archived release */
  "release.chip.tooltip.archived": "This release is archived and cannot be edited.",
  /** Label for tooltip in chip with the created date */
  "release.chip.tooltip.created-date": "Created {{date}}",
  /** Label for tooltip in draft chip when it's a live edit document */
  "release.chip.tooltip.draft-disabled.live-edit": "This document is in live edit mode, drafts are disabled",
  /** Label for tooltip in chip with the lasted edited date */
  "release.chip.tooltip.edited-date": "Edited {{date}}",
  /** Label for tooltip in chip when document is intended for a future release that hasn't been scheduled */
  "release.chip.tooltip.intended-for-date": "Intended for {{date}}",
  /** Label for tooltip in chip when there is no recent draft edits */
  "release.chip.tooltip.no-edits": "No edits",
  /** Label for tooltip in chip when document isn't published */
  "release.chip.tooltip.not-published": "Not published",
  /** Label for tooltip in chip with the published date */
  "release.chip.tooltip.published-date": "Published {{date}}",
  /** Label for tooltip in chip when document is in a release that has been scheduled */
  "release.chip.tooltip.scheduled-for-date": "Scheduled for {{date}}",
  /** Label for tooltip in scheduled chip without a known date */
  "release.chip.tooltip.unknown-date": "Unknown date",
  /** Label for tooltip on deleted release */
  "release.deleted-tooltip": "This release has been deleted",
  /** Title for copying version to a new release dialog */
  "release.dialog.copy-to-release.title": "Copy version to new release",
  /** Title for action create a release */
  "release.dialog.create.confirm": "Create release",
  /** Title for creating releases dialog */
  "release.dialog.create.title": "New release",
  /** Label for description in tooltip to explain release types */
  "release.dialog.tooltip.description": "The intended release time is used to create better previews and hints about whether documents conflict.",
  /** Label for noting that a release time is not final */
  "release.dialog.tooltip.note": "You can always change it later.",
  /** Title for tooltip to explain release time */
  "release.dialog.tooltip.title": "Approximate time of release",
  /** The placeholder text when the release doesn't have a description */
  "release.form.placeholder-describe-release": "Describe the release\u2026",
  /** Tooltip for button to hide release visibility */
  "release.layer.hide": "Hide release",
  /** Label for draft perspective in navbar */
  "release.navbar.drafts": "Drafts",
  /** Label for published releases in navbar */
  "release.navbar.published": "Published",
  /** Tooltip for releases navigation in navbar */
  "release.navbar.tooltip": "Releases",
  /** The placeholder text when the release doesn't have a title */
  "release.placeholder-untitled-release": "Untitled release",
  /** The toast description that will be shown when the user has a release perspective which is now archived */
  "release.toast.archived-release.description": "This release has been unpinned",
  /** The toast title that will be shown when the user has a release perspective which is now archived */
  "release.toast.archived-release.title": "The '{{title}}' release was archived",
  /** The toast title that will be shown the creating a release fails */
  "release.toast.create-release-error.title": "Failed to create release",
  /**The toast title that will be shown when the user has a release perspective which is now deleted */
  "release.toast.not-found-release.title": "The '{{title}}' release could not be found",
  /** The toast description that will be shown when the user has a release perspective which is now published */
  "release.toast.published-release.description": "This release has been unpinned",
  /** The toast title that will be shown when the user has a release perspective which is now deleted */
  "release.toast.published-release.title": "The '{{title}}' release was published",
  /** Label for when a version of a document has already been added to the release */
  "release.tooltip.already-added": "A version of this document has already been added",
  /** Label for when a release is scheduled / scheduling and a user can't add a document version to it */
  "release.tooltip.locked": "This release has been scheduled. Unsechedule it to add more documents.",
  /** Label for the release type 'as soon as possible' */
  "release.type.asap": "ASAP",
  /** Label for the release type 'at time', meaning it's a release with a scheduled date */
  "release.type.scheduled": "At time",
  /** Label for the release type 'undecided' */
  "release.type.undecided": "Undecided",
  /** Tooltip for the dropdown to show all versions of document */
  "release.version-list.tooltip": "See all document versions",
  /** Accessibility label to open search action when the search would go fullscreen (eg on narrower screens) */
  "search.action-open-aria-label": "Open search",
  /** Action label for adding a search filter */
  "search.action.add-filter": "Add filter",
  /** Action label for clearing search filters */
  "search.action.clear-filters": "Clear filters",
  /** Label for action to clear recent searches */
  "search.action.clear-recent-searches": "Clear recent searches",
  /** Accessibility label for action to clear all currently applied document type filters */
  "search.action.clear-type-filters-aria-label": "Clear checked filters",
  /** Label for action to clear all currently applied document type filters */
  "search.action.clear-type-filters-label": "Clear",
  /** Accessibility label for when the search is full screen (on narrow screens) and you want to close the search */
  "search.action.close-search-aria-label": "Close search",
  /** Accessibility label for filtering by document type */
  "search.action.filter-by-document-type-aria-label": "Filter by document type",
  /** Accessibility action label for removing an already applied search filter */
  "search.action.remove-filter-aria-label": "Remove filter",
  /**
   * Text displayed when either no document type(s) have been selected, or we need a fallback,
   * eg "Search for all types".
   */
  "search.action.search-all-types": "Search all documents",
  /**
   * Text displayed when we are able to determine one or more document types that will be used for
   * searching, and can fit within the space assigned by the design.
   */
  "search.action.search-specific-types": "Search for {{types, list}}",
  /**
   * Text displayed when we are able to determine one or more document types that will be used for
   * searching, but cannot list them all within the space assigned by the design, so we need an
   * additional "and X more" suffix. Allows using pluralization suffixes, eg `_one`, `_other` etc.
   */
  "search.action.search-specific-types-truncated": "Search for {{types, list}} +{{count}} more",
  /** Dialog title for action to select an asset of unknown type */
  "search.action.select-asset": "Select asset",
  /** Dialog title for action to select a file asset */
  "search.action.select-asset_file": "Select file",
  /** Dialog title for action to select an image asset */
  "search.action.select-asset_image": "Select image",
  /** Accessibility label for when the search is full screen (on narrow screens) and you want to hide filters */
  "search.action.toggle-filters-aria-label_hide": "Hide filters",
  /** Accessibility label for when the search is full screen (on narrow screens) and you want to show filters */
  "search.action.toggle-filters-aria-label_show": "Show filters",
  /** Label for when the search is full screen (on narrow screens) and you want to hide filters */
  "search.action.toggle-filters-label_hide": "Hide filters",
  /** Label for when the search is full screen (on narrow screens) and you want to show filters */
  "search.action.toggle-filters-label_show": "Show filters",
  /** Tooltip text for the global search button */
  "search.button.tooltip": "Search",
  /**
   * A list of provided types (use `list` formatter preferably).
   */
  "search.document-type-list": "{{types, list}}",
  /**
   * In the context of a list of document types - no filtering selection has been done,
   * thus the default is "all types".
   */
  "search.document-type-list-all-types": "All types",
  /**
   * A list of provided types that has been truncated - more types are included but not displayed,
   * thus we need to indicate that there are more. Allows using pluralization suffixes,
   * eg `_one`, `_other` etc.
   */
  "search.document-type-list-truncated": "{{types, list}} +{{count}} more",
  /** Accessibility label for list displaying the available document types */
  "search.document-types-aria-label": "Document types",
  /** Label for when no document types matching the filter are found */
  "search.document-types-no-matches-found": "No matches for {{filter}}",
  /** Description for error when a filter cannot be displayed, describes that you should check the schema */
  "search.error.display-filter-description": "This may indicate invalid options defined in your schema.",
  /** Title for error when a filter cannot be displayed (mainly a developer-oriented error) */
  "search.error.display-filter-title": "An error occurred whilst displaying this filter.",
  /** Description for error when no valid asset source is found, describes that you should check the the current studio config */
  "search.error.no-valid-asset-source-check-config-description": "Please ensure it's enabled in your studio configuration file.",
  /** Description for error when no valid asset source is found, describes that only the default asset is supported */
  "search.error.no-valid-asset-source-only-default-description": "Currently, only the default asset source is supported.",
  /** Title for error when no valid asset sources found */
  "search.error.no-valid-asset-source-title": "No valid asset sources found.",
  /** Helpful description for when search returned an error that we are not able to describe in detail */
  "search.error.unspecified-error-help-description": "Please try again or check your connection",
  /** Title label for when search returned an error that we are not able to describe in detail */
  "search.error.unspecified-error-title": "Something went wrong while searching",
  /**
   * Label for "All fields", a label that appears above the list of available fields when filtering.
   * If one or more document type has been chosen as filter, this label is replaced with a group of
   * fields per selected document type
   */
  "search.filter-all-fields-header": "All fields",
  /** Label for the action of changing from one file to a different file in asset search filter */
  "search.filter-asset-change_file": "Change file",
  /** Label for the action of changing from one image to a different image in asset search filter */
  "search.filter-asset-change_image": "Change image",
  /** Label for the action of clearing the currently selected asset in an image/file filter */
  "search.filter-asset-clear": "Clear",
  /** Label for the action of selecting a file in asset search filter */
  "search.filter-asset-select_file": "Select file",
  /** Label for the action of selecting an image in asset search filter */
  "search.filter-asset-select_image": "Select image",
  /** Label for boolean filter - false */
  "search.filter-boolean-false": "False",
  /** Label for boolean filter - true */
  "search.filter-boolean-true": "True",
  /** Accessibility label for list that lets you filter fields by title, when adding a new filter in search */
  "search.filter-by-title-aria-label": "Filter by title",
  /** Accessibility label for date filter input */
  "search.filter-date-aria-label": "Date",
  /** Accessibility label for selecting end date on the date range search filter */
  "search.filter-date-range-end-date-aria-label": "End date",
  /** Accessibility label for selecting start date on the date range search filter */
  "search.filter-date-range-start-date-aria-label": "Start date",
  /** Accessibility label for selecting the unit (day/month/year) when adding "X days ago" search filter */
  "search.filter-date-unit-aria-label": "Select unit",
  /**
   * Label for "Days"/"Months"/"Years" when selecting it as unit in "X days ago" search filter.
   * Capitalized, as it would be listed in a dropdown.
   */
  "search.filter-date-unit_days": "Days",
  "search.filter-date-unit_months": "Months",
  "search.filter-date-unit_years": "Years",
  /** Accessibility label for the input value (days/months/years) when adding "X days ago" search filter */
  "search.filter-date-value-aria-label": "Unit value",
  /** Label for "field description" shown in tooltip when navigating list of possible fields to filter */
  "search.filter-field-tooltip-description": "Field description",
  /** Label for "field name" shown in tooltip when navigating list of possible fields to filter */
  "search.filter-field-tooltip-name": "Field name",
  /** Label for "Used in document types", a list of the document types a field appears in. Shown in tooltip when navigating list of possible fields to filter */
  "search.filter-field-tooltip-used-in-document-types": "Used in document types",
  /** Label for when no fields/filters are found for the given term */
  "search.filter-no-matches-found": "No matches for {{filter}}",
  /** Placeholder value for maximum numeric value filter */
  "search.filter-number-max-value-placeholder": "Max value",
  /** Placeholder value for minimum numeric value filter */
  "search.filter-number-min-value-placeholder": "Min value",
  /** Placeholder value for the number filter */
  "search.filter-number-value-placeholder": "Value",
  /** Placeholder for the "Filter" input, when narrowing possible fields/filters */
  "search.filter-placeholder": "Filter",
  /** Label for the action of clearing the currently selected document in a reference filter */
  "search.filter-reference-clear": "Clear",
  /**
   * Label for "shared fields", a label that appears above a list of fields that all filtered types
   * have in common, when adding a new filter. For instance, if "book" and "employee" both have a
   * "title" field, this field would be listed under "shared fields".
   * */
  "search.filter-shared-fields-header": "Shared fields",
  /** Placeholder value for the string filter */
  "search.filter-string-value-placeholder": "Value",
  /** Label/placeholder prompting user to select one of the predefined, allowed values for a string field */
  "search.filter-string-value-select-predefined-value": "Select\u2026",
  /** Accessibility label for the "Filters" list, that is shown when using "Add filter" in search (singular) */
  "search.filters-aria-label_one": "Filter",
  /** Accessibility label for the "Filters" list, that is shown when using "Add filter" in search (plural) */
  "search.filters-aria-label_other": "Filters",
  /** Label for instructions on how to use the search - displayed when no recent searches are available */
  "search.instructions": "Use <ControlsIcon/> to refine your search",
  /** Helpful description for when no search results are found */
  "search.no-results-help-description": "Try another keyword or adjust your filters",
  /** Title label for when no search results are found */
  "search.no-results-title": "No results found",
  /**
   * Individual search operators.
   *
   * The `name` variant is the form we use when the user is building a query, and selecting from a
   * list of available operators for a field. Keep in mind that since the user knows what the field
   * represents, we do not need to contextualize too much, and that the user may not be a developer
   * eg prefer "quantity is" over "array has length". Additionally, (if applicable in language) use
   * lowercased names.
   *
   * The `description` variant is the form shown once the filter has enough information to apply,
   * and is shown in the list of applied filters. It is passed components that _should_ be used to
   * compose the filter string, and to format them correctly:
   *
   * `<Field/>` - eg "Bird species", "Category", "Date of birth"
   * `<Operator>operator text</Operator>` - eg "has ≤", "includes", "is"
   * `<Value>{{value}}</Value>` - eg "Hawk", "Sparrow", "Eagle"
   *
   * Where applicable, a `count` is passed, allowing you to pluralize where needed, by using
   * suffixes such as `_zero`, `_one`, `_other` etc.
   *
   * Prefer (reasonable) brevity since many filters may be applied. For instance:
   * `<Field/> has ≤ <Value/>` may be better than
   * `<Field/> has less than or equal to <Value/>`
   **/
  /* Array should have a count the given filter value */
  "search.operator.array-count-equal.description_one": "<Field/> <Operator>has</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-equal.description_other": "<Field/> <Operator>has</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-equal.name": "quantity is",
  /* Array should have a count greater than given filter value */
  "search.operator.array-count-gt.description_one": "<Field/> <Operator>has ></Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-gt.description_other": "<Field/> <Operator>has ></Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-gt.name": "quantity greater than",
  /* Array should have a count greater than or equal to the given filter value */
  "search.operator.array-count-gte.description_one": "<Field/> <Operator>has \u2265</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-gte.description_other": "<Field/> <Operator>has \u2265</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-gte.name": "quantity greater than or equal to",
  /* Array should have a count less than given filter value */
  "search.operator.array-count-lt.description_one": "<Field/> <Operator>has <</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-lt.description_other": "<Field/> <Operator>has <</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-lt.name": "quantity less than",
  /* Array should have a count less than or equal to the given filter value */
  "search.operator.array-count-lte.description_one": "<Field/> <Operator>has \u2264</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-lte.description_other": "<Field/> <Operator>has \u2264</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-lte.name": "quantity less than or equal to",
  /* Array should have a count that is not equal to the given filter value */
  "search.operator.array-count-not-equal.description_one": "<Field/> <Operator>does not have</Operator> <Value>{{count}} item</Value>",
  "search.operator.array-count-not-equal.description_other": "<Field/> <Operator>does not have</Operator> <Value>{{count}} items</Value>",
  "search.operator.array-count-not-equal.name": "quantity is not",
  /**
   * Array should have a count within the range of given filter values.
   * Gets passed `{{from}}` and `{{to}}` values.
   **/
  "search.operator.array-count-range.description": "<Field/> <Operator>has between</Operator> <Value>{{from}} \u2192 {{to}} items</Value>",
  "search.operator.array-count-range.name": "quantity is between",
  /* Array should include the given value */
  "search.operator.array-list-includes.description": "<Field/> <Operator>includes</Operator> <Value>{{value}}</Value>",
  "search.operator.array-list-includes.name": "includes",
  /* Array should not include the given value */
  "search.operator.array-list-not-includes.description": "<Field/> <Operator>does not include</Operator> <Value>{{value}}</Value>",
  "search.operator.array-list-not-includes.name": "does not include",
  /* Array should include the given reference */
  "search.operator.array-reference-includes.description": "<Field/> <Operator>includes</Operator> <Value>{{value}}</Value>",
  "search.operator.array-reference-includes.name": "includes",
  /* Array should not include the given reference */
  "search.operator.array-reference-not-includes.description": "<Field/> <Operator>does not include</Operator> <Value>{{value}}</Value>",
  "search.operator.array-reference-not-includes.name": "does not include",
  /* Asset (file) should be the selected asset */
  "search.operator.asset-file-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.asset-file-equal.name": "is",
  /* Asset (file) should not be the selected asset */
  "search.operator.asset-file-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.asset-file-not-equal.name": "is not",
  /* Asset (image) should be the selected asset */
  "search.operator.asset-image-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.asset-image-equal.name": "is",
  /* Asset (image) should not be the selected asset */
  "search.operator.asset-image-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.asset-image-not-equal.name": "is not",
  /**
   * Boolean value should be the given filter value (true/false).
   * Context passed is `true` and `false`, allowing for more specific translations:
   * - `search.operator.boolean-equal.description_true`
   * - `search.operator.boolean-equal.description_false`
   */
  "search.operator.boolean-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.boolean-equal.name": "is",
  /* Date should be after (later than) given filter value */
  "search.operator.date-after.description": "<Field/> <Operator>is after</Operator> <Value>{{value}}</Value>",
  "search.operator.date-after.name": "after",
  /* Date should be before (earlier than) given filter value */
  "search.operator.date-before.description": "<Field/> <Operator>is before</Operator> <Value>{{value}}</Value>",
  "search.operator.date-before.name": "before",
  /* Date should be the given filter value */
  "search.operator.date-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.date-equal.name": "is",
  /* Date should be within the given filter value range (eg "within the last X days") */
  "search.operator.date-last.description": "<Field/> <Operator>is in the last</Operator> <Value>{{value}}</Value>",
  "search.operator.date-last.name": "last",
  /* Date should not be the given filter value */
  "search.operator.date-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.date-not-equal.name": "is not",
  /* Date should be within the range of given filter values */
  "search.operator.date-range.description": "<Field/> <Operator>is between</Operator> <Value/>",
  "search.operator.date-range.name": "is between",
  /* Date and time should be after (later than) given filter value */
  "search.operator.date-time-after.description": "<Field/> <Operator>is after</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-after.name": "after",
  /* Date and time should be before (earlier than) given filter value */
  "search.operator.date-time-before.description": "<Field/> <Operator>is before</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-before.name": "before",
  /* Date and time should be the given filter value */
  "search.operator.date-time-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-equal.name": "is",
  /* Date and time should be within the given filter value range (eg "within the last X days") */
  "search.operator.date-time-last.description": "<Field/> <Operator>is in the last</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-last.name": "last",
  /* Date and time should not be the given filter value */
  "search.operator.date-time-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.date-time-not-equal.name": "is not",
  /* Date and time should be within the range of given filter values */
  "search.operator.date-time-range.description": "<Field/> <Operator>is between</Operator> <Value/>",
  "search.operator.date-time-range.name": "is between",
  /* Value should be defined */
  "search.operator.defined.description": "<Field/> <Operator>is</Operator> <Value>not empty</Value>",
  "search.operator.defined.name": "not empty",
  /* Value should not be defined */
  "search.operator.not-defined.description": "<Field/> <Operator>is</Operator> <Value>empty</Value>",
  "search.operator.not-defined.name": "empty",
  /* Number should be the given filter value */
  "search.operator.number-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.number-equal.name": "is",
  /* Number should be greater than given filter value */
  "search.operator.number-gt.description": "<Field/> <Operator>></Operator> <Value>{{value}}</Value>",
  "search.operator.number-gt.name": "greater than",
  /* Number should be greater than or the given filter value */
  "search.operator.number-gte.description": "<Field/> <Operator>\u2265</Operator> <Value>{{value}}</Value>",
  "search.operator.number-gte.name": "greater than or equal to",
  /* Number should be less than given filter value */
  "search.operator.number-lt.description": "<Field/> <Operator><</Operator> <Value>{{value}}</Value>",
  "search.operator.number-lt.name": "less than",
  /* Number should be less than or the given filter value */
  "search.operator.number-lte.description": "<Field/> <Operator>\u2264</Operator> <Value>{{value}}</Value>",
  "search.operator.number-lte.name": "less than or equal to",
  /* Number should not be the given filter value */
  "search.operator.number-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.number-not-equal.name": "is not",
  /* Number should be within the range of given filter values */
  "search.operator.number-range.description": "<Field/> <Operator>is between</Operator> <Value>{{from}} \u2192 {{to}}</Value>",
  "search.operator.number-range.name": "is between",
  /* Portable Text should contain the given filter value */
  "search.operator.portable-text-contains.description": "<Field/> <Operator>contains</Operator> <Value>{{value}}</Value>",
  "search.operator.portable-text-contains.name": "contains",
  /* Portable Text should be the given filter value */
  "search.operator.portable-text-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.portable-text-equal.name": "is",
  /* Portable Text should not contain the given filter value */
  "search.operator.portable-text-not-contains.description": "<Field/> <Operator>does not contain</Operator> <Value>{{value}}</Value>",
  "search.operator.portable-text-not-contains.name": "does not contain",
  /* Portable Text should not be the given filter value */
  "search.operator.portable-text-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.portable-text-not-equal.name": "is not",
  /* References the given asset (file) */
  "search.operator.reference-asset-file.description": "<Field/> <Operator>\u2192</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-asset-file.name": "file",
  /* References the given asset (image) */
  "search.operator.reference-asset-image.description": "<Field/> <Operator>\u2192</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-asset-image.name": "image",
  /* References the given document */
  "search.operator.reference-document.description": "<Field/> <Operator>\u2192</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-document.name": "document",
  /* Reference should be the given document */
  "search.operator.reference-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-equal.name": "is",
  /* Reference should not be the given document */
  "search.operator.reference-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.reference-not-equal.name": "is not",
  /* Slug contains the given value */
  "search.operator.slug-contains.description": "<Field/> <Operator>contains</Operator> <Value>{{value}}</Value>",
  "search.operator.slug-contains.name": "contains",
  /* Slug equals the given filter value */
  "search.operator.slug-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.slug-equal.name": "is",
  /* Slug does not contain the given value */
  "search.operator.slug-not-contains.description": "<Field/> <Operator>does not contain</Operator> <Value>{{value}}</Value>",
  "search.operator.slug-not-contains.name": "does not contain",
  /* Slug does not equal the given filter value */
  "search.operator.slug-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.slug-not-equal.name": "is not",
  /* String contains the given filter value */
  "search.operator.string-contains.description": "<Field/> <Operator>contains</Operator> <Value>{{value}}</Value>",
  "search.operator.string-contains.name": "contains",
  /* String equals the given filter value */
  "search.operator.string-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.string-equal.name": "is",
  /* String equals one of the predefined allowed values */
  "search.operator.string-list-equal.description": "<Field/> <Operator>is</Operator> <Value>{{value}}</Value>",
  "search.operator.string-list-equal.name": "is",
  /* String does not equal one of the predefined allowed values */
  "search.operator.string-list-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.string-list-not-equal.name": "is not",
  /* String does not contain the given filter value */
  "search.operator.string-not-contains.description": "<Field/> <Operator>does not contain</Operator> <Value>{{value}}</Value>",
  "search.operator.string-not-contains.name": "does not contain",
  /* String does not equal the given filter value */
  "search.operator.string-not-equal.description": "<Field/> <Operator>is not</Operator> <Value>{{value}}</Value>",
  "search.operator.string-not-equal.name": "is not",
  /** Label for the "Best match" search ordering type */
  "search.ordering.best-match-label": "Best match",
  /** Label for the "Created: Oldest first" search ordering type */
  "search.ordering.created-ascending-label": "Created: Oldest first",
  /** Label for the "Created: Newest first" search ordering type */
  "search.ordering.created-descending-label": "Created: Newest first",
  /** Label for the "Updated: Oldest first" search ordering type */
  "search.ordering.updated-ascending-label": "Updated: Oldest first",
  /** Label for the "Updated: Newest first" search ordering type */
  "search.ordering.updated-descending-label": "Updated: Newest first",
  /** Placeholder text for the global search input field */
  "search.placeholder": "Search",
  /** Accessibility label for the recent searches section, shown when no valid search terms has been given */
  "search.recent-searches-aria-label": "Recent searches",
  /** Label/heading shown for the recent searches section */
  "search.recent-searches-label": "Recent searches",
  /** Accessibility label for the search results section, shown when the user has typed valid terms */
  "search.search-results-aria-label": "Search results",
  /** Label for the edit columns button to change field visibility in sheet list */
  "sheet-list.edit-columns": "Edit columns",
  /** Label for the header menu option to hide a field from the sheet list */
  "sheet-list.hide-field": "Remove from table",
  /** Label for reset column visibilities button */
  "sheet-list.reset-columns": "Reset columns",
  /** Title for the edit columns menu */
  "sheet-list.select-fields": "Select up to 5 field types",
  /** Accessibility label for the navbar status button */
  "status-button.aria-label": "Configuration status",
  /** Title for the changes tooltip in the history inspector*/
  "timeline.changes.title": "Changes by",
  /** Description for error when the timeline for the given document can't be loaded */
  "timeline.error.load-document-changes-description": "Document history transactions have not been affected.",
  /** Title for error when the timeline for the given document can't be loaded */
  "timeline.error.load-document-changes-title": "An error occurred whilst retrieving document changes.",
  /** Description for error when the timeline for the given document can't be loaded */
  "timeline.error.load-document-changes-version-description": "Enable the events API through the Studio config to view document history.",
  /** Title for error when the timeline for the given version document can't be loaded */
  "timeline.error.load-document-changes-version-title": "Version documents history is only available through the Events API.",
  /** Error description for when the document doesn't have history */
  "timeline.error.no-document-history-description": "When changing the content of the document, the document versions will appear in this menu.",
  /** Error title for when the document doesn't have history */
  "timeline.error.no-document-history-title": "No document history",
  /** Error prompt when revision cannot be loaded */
  "timeline.error.unable-to-load-revision": "Unable to load revision",
  /** Label for when the timeline item is the latest in the history */
  "timeline.latest": "Latest",
  /** Label for latest revision for timeline menu dropdown */
  "timeline.latest-revision": "Latest revision",
  /**
   * Label for latest revision for timeline menu dropdown
   * @deprecated as of `v3.47.0` `timeline.latest-revision` should be used instead. Note: _usage_ of this key is deprecated, but Studios on `< v3.47.0` still require this key to be _defined_
   * */
  "timeline.latest-version": "Latest revision",
  /** The aria-label for the list of revisions in the timeline */
  "timeline.list.aria-label": "Document revisions",
  /** Label for loading history */
  "timeline.loading-history": "Loading history\u2026",
  /* Label for when no previous since events are available*/
  "timeline.no-previous-events": "No previous events",
  /** Label shown in review changes timeline when a document has been created */
  "timeline.operation.created": "Created",
  /** Label shown in review changes timeline when a document was initially created */
  "timeline.operation.created-initial": "Created",
  /** Label shown in review changes timeline when a document was initially created, with a timestamp */
  "timeline.operation.created-initial_timestamp": "Created: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document has been created, with a timestamp */
  "timeline.operation.created_timestamp": "Created: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document has been deleted */
  "timeline.operation.deleted": "Deleted",
  /** Label shown in review changes timeline when a document has been deleted, with a timestamp */
  "timeline.operation.deleted_timestamp": "Deleted: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a draft document has been created*/
  "timeline.operation.draft-created": "Draft created",
  /** Label shown in review changes timeline when a draft document has been created, with a timestamp */
  "timeline.operation.draft-created_timestamp": "Draft created: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a draft has been discarded */
  "timeline.operation.draft-discarded": "Discarded draft",
  /** Label shown in review changes timeline when a draft has been discarded, with a timestamp */
  "timeline.operation.draft-discarded_timestamp": "Discarded draft: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a draft has been edited */
  "timeline.operation.edited-draft": "Edited",
  /** Label shown in review changes timeline when a draft has been edited, with a timestamp */
  "timeline.operation.edited-draft_timestamp": "Edited: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document has been edited live */
  "timeline.operation.edited-live": "Live edited",
  /** Label shown in review changes timeline when a document has been edited live, with a timestamp */
  "timeline.operation.edited-live_timestamp": "Live edited: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document has been created */
  "timeline.operation.history-cleared": "Deleted by retention policy",
  /** Label shown in review changes timeline when a document was published */
  "timeline.operation.published": "Published",
  /** Label shown in review changes timeline when a document was published, with a timestamp */
  "timeline.operation.published_timestamp": "Published: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document was unpublished */
  "timeline.operation.unpublished": "Unpublished",
  /** Label shown in review changes timeline when a document was unpublished, with a timestamp */
  "timeline.operation.unpublished_timestamp": "Unpublished: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document version has been created */
  "timeline.operation.version-created": "Version created",
  /** Label shown in review changes timeline when a document version has been created, with a timestamp */
  "timeline.operation.version-created_timestamp": "Version created: {{timestamp, datetime}}",
  /** Label shown in review changes timeline when a document version has been discarded */
  "timeline.operation.version-discarded": "Version discarded",
  /** Label shown in review changes timeline when a document version has been discarded, with a timestamp */
  "timeline.operation.version-discarded_timestamp": "Version discarded: {{timestamp, datetime}}",
  /**
   * Label for determining since which version the changes for timeline menu dropdown are showing.
   * Receives the time label as a parameter (`timestamp`).
   */
  "timeline.since": "{{timestamp, datetime}}",
  /** Label for missing change version for timeline menu dropdown are showing */
  "timeline.since-version-missing": "Since: unknown version",
  /** Aria label for the action buttons in the PTE toolbar */
  "toolbar.portable-text.action-button-aria-label": "{{action}}",
  /** Accessibility label for the breadcrumb menu */
  "tree-editing-dialog.breadcrumbs.menu": "Breadcrumb menu",
  /** Title placeholder for search input in array of objects */
  "tree-editing-dialog.search-placeholder": "Search",
  /** Menu aria label for the search menu */
  "tree-editing-dialog.search.menu-label": "Search menu",
  /** Title label for when no search results are found on the tree of objects */
  "tree-editing-dialog.search.no-results-title": "No results found",
  /** Label to close the sidebar */
  "tree-editing-dialog.sidebar.action.close": "Close sidebar",
  /** Collapse label the menu item in the sidebar  */
  "tree-editing-dialog.sidebar.action.collapse": "Collapse",
  /** Label to close the dialog */
  "tree-editing-dialog.sidebar.action.done": "Done",
  /** Exapnd label the menu item in the sidebar  */
  "tree-editing-dialog.sidebar.action.expand": "Expand",
  /** Label to open the sidebar */
  "tree-editing-dialog.sidebar.action.open": "Open sidebar",
  /** Label for the button showed after trial ended */
  "user-menu.action.free-trial-finished": "Upgrade from free",
  /** Label for button showing the free trial days left */
  "user-menu.action.free-trial_one": "{{count}} day left in trial",
  "user-menu.action.free-trial_other": "{{count}} days left in trial",
  /** Label for action to invite members to the current sanity project */
  "user-menu.action.invite-members": "Invite members",
  /** Accessibility label for action to invite members to the current sanity project */
  "user-menu.action.invite-members-aria-label": "Invite members",
  /** Label for action to manage the current sanity project */
  "user-menu.action.manage-project": "Manage project",
  /** Accessibility label for the action to manage the current project */
  "user-menu.action.manage-project-aria-label": "Manage project",
  /** Tooltip helper text when portable text annotation is disabled for empty block*/
  "user-menu.action.portable-text.annotation-disabled_empty-block": "Cannot apply {{name}} to empty block",
  /** Tooltip helper text when portable text annotation is disabled for multiple blocks */
  "user-menu.action.portable-text.annotation-disabled_multiple-blocks": "Cannot apply {{name}} to multiple blocks",
  /** Label for action to sign out of the current sanity project */
  "user-menu.action.sign-out": "Sign out",
  /** Title for appearance section for the current studio (dark / light / system scheme) */
  "user-menu.appearance-title": "Appearance",
  /** Label for close menu button for user menu */
  "user-menu.close-menu": "Close menu",
  /** Description for using the "dark theme" in the appearance user menu */
  "user-menu.color-scheme.dark-description": "Use dark appearance",
  /** Title for using the "dark theme" in the appearance user menu */
  "user-menu.color-scheme.dark-title": "Dark",
  /** Description for using the "light theme" in the appearance user menu */
  "user-menu.color-scheme.light-description": "Use light appearance",
  /** Title for using the "light theme" in the appearance user menu */
  "user-menu.color-scheme.light-title": "Light",
  /** Description for using "system apparence" in the appearance user menu */
  "user-menu.color-scheme.system-description": "Use system appearance",
  /** Title for using system apparence in the appearance user menu */
  "user-menu.color-scheme.system-title": "System",
  /** Title for locale section for the current studio */
  "user-menu.locale-title": "Language",
  /** Label for tooltip to show which provider the currently logged in user is using */
  "user-menu.login-provider": "Signed in with {{providerTitle}}",
  /** Label for open menu button for user menu */
  "user-menu.open-menu": "Open menu",
  /**
   * Label for action to add a workspace (currently a developer-oriented action, as this will
   * lead to the documentation on workspace configuration)
   */
  "workspaces.action.add-workspace": "Add workspace",
  /**
   * Label for action to choose a different workspace, in the case where you are not logged in,
   * have selected a workspace, and are faced with the authentication options for the selected
   * workspace. In other words, label for the action shown when you have reconsidered which
   * workspace to authenticate in.
   */
  "workspaces.action.choose-another-workspace": "Choose another workspace",
  /** Label for heading that indicates that you can choose your workspace */
  "workspaces.choose-your-workspace-label": "Choose your workspace",
  /** Label for the workspace menu */
  "workspaces.select-workspace-aria-label": "Select workspace",
  /** Button label for opening the workspace switcher */
  "workspaces.select-workspace-label": "Select workspace",
  /** Tooltip for the workspace menu */
  "workspaces.select-workspace-tooltip": "Select workspace",
  /** Title for Workplaces dropdown menu */
  "workspaces.title": "Workspaces"
}), studioDefaultLocaleResources = {
  locale: "en-US",
  namespace: studioLocaleNamespace,
  resources: studioLocaleStrings
}, validationLocaleStrings = defineLocalesResources("validation", {
  /** Array must have exactly "$wantedLength" items, but has more/less */
  "array.exact-length": "Must have exactly {{wantedLength}} items",
  /** Portable Text array must have exactly "$wantedLength" blocks, but has more/less */
  "array.exact-length_blocks": "Must have exactly {{wantedLength}} blocks",
  /** Array item is a duplicate, but array wants only unique items */
  "array.item-duplicate": "Can't be a duplicate",
  /** Array has more than the maximum of "$maxLength" items */
  "array.maximum-length": "Must have at most {{maxLength}} items",
  /** Portable Text array has more than the maximum of "$maxLength" items */
  "array.maximum-length_blocks": "Must have at most {{maxLength}} blocks",
  /** Array has less than the minimum of "$minLength" items */
  "array.minimum-length": "Must have at least {{minLength}} items",
  /** Portable Text array has less than the minimum of "$minLength" blocks */
  "array.minimum-length_blocks": "Must have at least {{minLength}} blocks",
  /** Date is not valid or not in the correct format (ISO-8601) */
  "date.invalid-format": "Must be a valid ISO-8601 formatted date string",
  /** Date is later than the given maximum date "$maxDate" */
  "date.maximum": "Must be at or before {{maxDate}}",
  /** Date is earlier than the given minimum date "$minDate" */
  "date.minimum": "Must be at or after {{minDate}}",
  /** A value of incorrect type is found, eg found `number` instead of `string` */
  "generic.incorrect-type": 'Expected type "{{expectedType}}", got "{{actualType}}"',
  /** Value is not one of the values specifically allowed */
  "generic.not-allowed": "Value did not match any allowed values",
  /** Value "$givenValue" is not one of the values specifically allowed */
  "generic.not-allowed_hint": 'Value "{{hint}}" did not match any allowed values',
  /** A value is expected, but none is provided */
  "generic.required": "Required",
  /** Number is less than the given minimum threshold value "$threshold" */
  "number.greater-than": "Must be greater than {{threshold}}",
  /** Number is greater than the given maximum threshold value "$threshold" */
  "number.less-than": "Must be less than {{threshold}}",
  /** Number is higher than the given maximum value "$maxNumber" */
  "number.maximum": "Must be lower than or equal to {{maxNumber}}",
  /** Number has more precision (decimals) than the allowed "$limit" */
  "number.maximum-precision": "Max precision is {{limit}}",
  /** Number is lower than the given minimum value "$minNumber" */
  "number.minimum": "Must be greater than or equal to {{minNumber}}",
  /** Number is not an integer ("whole number") */
  "number.non-integer": "Must be an integer",
  /** Object is missing a reference to an asset document in its `asset` field */
  "object.asset-required": "Asset is required",
  /** Object is missing a reference to a file asset document in its `asset` field */
  "object.asset-required_file": "File is required",
  /** Object is missing a reference to an image asset document in its `asset` field */
  "object.asset-required_image": "Image is required",
  /** Object is not a reference to a document (eg `{_ref: 'documentId'}`) */
  "object.not-reference": "Must be a reference to a document",
  /** Object references a document which is not published */
  "object.reference-not-published": "Referenced document must be published",
  /** Accessibility label for closing the validation panel */
  "panel.close-button-aria-label": "Close validation",
  /** Message shown when the validation panel is opened but there are no errors/warnings */
  "panel.no-errors-message": "No validation errors",
  /** Title for the actual "Validation" panel/feature */
  "panel.title": "Validation",
  /** Slug is an object, but is missing a `current` string property */
  "slug.missing-current": "Slug must have a value",
  /** Slug is not an object (eg `{current: 'some-slug'}`) */
  "slug.not-object": "Slug must be an object",
  /** Slug is already in use somewhere else, but needs to be unique */
  "slug.not-unique": "Slug is already in use",
  /** String is not a valid email address */
  "string.email": "Must be a valid email address",
  /** String has a different character length than the exact number "$wantedLength" */
  "string.exact-length": "Must be exactly {{wantedLength}} characters long",
  /** String contains characters that are not in lowercase  */
  "string.lowercase": "Must be all lowercase characters",
  /** String is longer than the limit of "$maxLength" characters */
  "string.maximum-length": "Must be at most {{maxLength}} characters long",
  /** String is shorter than the limit of "$minLength" characters */
  "string.minimum-length": "Must be at least {{minLength}} characters long",
  /** String does not match the given regular expression, but should */
  "string.regex-does-not-match": 'Does not match "{{name}}"-pattern',
  /** String matches the given regular expression, but should not */
  "string.regex-match": 'Should not match "{{name}}"-pattern',
  /** String contains characters that are not in uppercase */
  "string.uppercase": "Must be all uppercase characters",
  /** String contains a protocol/scheme that is not allowed, eg (`ftp`, `mailto`…) */
  "string.url.disallowed-scheme": "Does not match allowed protocols/schemes",
  /** String contains a URL with a username or password specified before the host */
  "string.url.includes-credentials": "Username/password not allowed",
  /** String is not a valid URL */
  "string.url.invalid": "Not a valid URL",
  /** String is not an absolute URL (eg it is missing a protocol/host) */
  "string.url.not-absolute": "Relative URLs are not allowed",
  /** String is not a relative URL (eg it contains a protocol/host) */
  "string.url.not-relative": "Only relative URLs are allowed"
}), validationLocaleResources = {
  locale: "en-US",
  namespace: validationLocaleNamespace,
  resources: validationLocaleStrings
}, usEnglishLocale = {
  id: "en-US",
  title: "English (US)",
  bundles: [studioDefaultLocaleResources, validationLocaleResources, copyPasteLocaleResources],
  weekInfo: {
    firstDay: 7,
    // Sunday
    weekend: [6, 7],
    // Saturday, Sunday
    minimalDays: 1
  }
}, defaultLocale = usEnglishLocale, supportsLocalStorage = (() => {
  const key = "__tmp_supports_local_storage";
  try {
    return typeof localStorage > "u" ? !1 : (localStorage.setItem(key, "---"), localStorage.removeItem(key), !0);
  } catch {
    return !1;
  }
})(), LOCAL_STORAGE_PREFIX = "sanity-locale";
function getPreferredLocale(projectId, sourceId) {
  return supportsLocalStorage ? localStorage.getItem(getItemKey$2(projectId, sourceId)) ?? void 0 : void 0;
}
function storePreferredLocale(projectId, sourceId, locale) {
  supportsLocalStorage && localStorage.setItem(getItemKey$2(projectId, sourceId), locale);
}
function getItemKey$2(projectId, sourceId) {
  return [LOCAL_STORAGE_PREFIX, projectId, sourceId].join(":");
}
function LocaleProvider(props2) {
  const $ = c(6), {
    projectId,
    name: sourceId,
    i18n: t0,
    __internal: t1
  } = useSource(), {
    locales
  } = t0, {
    i18next
  } = t1;
  let t2;
  return $[0] !== i18next || $[1] !== locales || $[2] !== projectId || $[3] !== props2 || $[4] !== sourceId ? (t2 = /* @__PURE__ */ jsx(LocaleProviderBase, { ...props2, projectId, sourceId, locales, i18next }), $[0] = i18next, $[1] = locales, $[2] = projectId, $[3] = props2, $[4] = sourceId, $[5] = t2) : t2 = $[5], t2;
}
function LocaleProviderBase(t0) {
  const $ = c(24), {
    projectId,
    sourceId,
    locales,
    i18next,
    children
  } = t0;
  let t1;
  $[0] !== i18next ? (t1 = (callback) => (i18next.on("languageChanged", callback), () => i18next.off("languageChanged", callback)), $[0] = i18next, $[1] = t1) : t1 = $[1];
  const subscribe2 = t1;
  let t2;
  $[2] !== i18next.language || $[3] !== locales ? (t2 = () => locales.find((candidate) => i18next.language === candidate.id) || defaultLocale, $[2] = i18next.language, $[3] = locales, $[4] = t2) : t2 = $[4];
  const currentLocale = useSyncExternalStore(subscribe2, t2);
  let t3, t4;
  $[5] !== i18next ? (t4 = {
    i18next
  }, $[5] = i18next, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== i18next || $[8] !== projectId || $[9] !== sourceId ? (t5 = async (newLocale) => {
    storePreferredLocale(projectId, sourceId, newLocale), await i18next.changeLanguage(newLocale);
  }, $[7] = i18next, $[8] = projectId, $[9] = sourceId, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== currentLocale || $[12] !== locales || $[13] !== t4 || $[14] !== t5 ? (t6 = {
    locales,
    currentLocale,
    __internal: t4,
    changeLocale: t5
  }, $[11] = currentLocale, $[12] = locales, $[13] = t4, $[14] = t5, $[15] = t6) : t6 = $[15], t3 = t6;
  const context = t3;
  let t7;
  $[16] === Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(LoadingBlock, {}), $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== children || $[18] !== context || $[19] !== currentLocale.id ? (t8 = /* @__PURE__ */ jsx(LocaleContext.Provider, { value: context, children }, currentLocale.id), $[17] = children, $[18] = context, $[19] = currentLocale.id, $[20] = t8) : t8 = $[20];
  let t9;
  return $[21] !== i18next || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsx(Suspense, { fallback: t7, children: /* @__PURE__ */ jsx(I18nextProvider, { i18n: i18next, children: t8 }) }), $[21] = i18next, $[22] = t8, $[23] = t9) : t9 = $[23], t9;
}
function useGetI18nText(input) {
  const items = Array.isArray(input) ? input : [input], stableNamespaces = JSON.stringify(items.flatMap((item) => item?.i18n ? Object.values(item.i18n).map(({
    ns
  }) => ns) : []).filter(isNonNullable$3).sort()), namespaces = useMemo(() => JSON.parse(stableNamespaces), [stableNamespaces]), {
    t
  } = useTranslation(namespaces);
  return useCallback(function(node) {
    const {
      i18n
    } = node;
    return i18n ? new Proxy(node, {
      get: (target, property) => {
        const defaultValue2 = target[property];
        if (typeof property == "string" && property in i18n) {
          const {
            key,
            ns: ns_0
          } = i18n[property];
          return t(key, {
            ns: ns_0,
            // `defaultValue` is a special key in the i18next `t` API that
            // allows us to provide a fallback value if no translation is found
            // using the given key and namespace. if the value on the node
            // is a string, then we'll use that as the fallback value
            ...typeof defaultValue2 == "string" && {
              defaultValue: defaultValue2
            }
          });
        }
        return defaultValue2;
      }
    }) : node;
  }, [t]);
}
function useI18nText(node) {
  const namespaces = useMemo(() => node.i18n ? Array.from(new Set(Object.values(node.i18n).map(({
    ns
  }) => ns))).sort() : [], [node.i18n]), {
    t
  } = useTranslation(namespaces);
  return useMemo(() => {
    const {
      i18n
    } = node;
    return i18n ? new Proxy(node, {
      get: (target, property) => {
        const defaultValue2 = target[property];
        if (typeof property == "string" && property in i18n) {
          const {
            key,
            ns: ns_0
          } = i18n[property];
          return t(key, {
            ns: ns_0,
            // `defaultValue` is a special key in the i18next `t` API that
            // allows us to provide a fallback value if no translation is found
            // using the given key and namespace. if the value on the node
            // is a string, then we'll use that as the fallback value
            ...typeof defaultValue2 == "string" && {
              defaultValue: defaultValue2
            }
          });
        }
        return defaultValue2;
      }
    }) : node;
  }, [node, t]);
}
function useCurrentLocale() {
  return useLocale().currentLocale;
}
function useLocale() {
  const context = useContext(LocaleContext);
  if (!context)
    throw new Error("Sanity LocaleContext value missing. Is this hook being used outside LocaleContext.Provider?");
  return context;
}
const intlCache = (() => {
  const caches = {
    dateTimeFormat: createCache(),
    listFormat: createCache(),
    numberFormat: createCache(),
    relativeTimeFormat: createCache()
  };
  function dateTimeFormat(locale, options) {
    const key = getCacheId(locale, options);
    let instance = caches.dateTimeFormat[key];
    return instance || (instance = new Intl.DateTimeFormat(locale, options), caches.dateTimeFormat[key] = instance, instance);
  }
  function listFormat(locale, options) {
    const key = getCacheId(locale, options);
    let instance = caches.listFormat[key];
    return instance || (instance = new Intl.ListFormat(locale, options), caches.listFormat[key] = instance, instance);
  }
  function numberFormat(locale, options) {
    const key = getCacheId(locale, options);
    let instance = caches.numberFormat[key];
    return instance || (instance = new Intl.NumberFormat(locale, options), caches.numberFormat[key] = instance, instance);
  }
  function relativeTimeFormat(locale, options) {
    const key = getCacheId(locale, options);
    let instance = caches.relativeTimeFormat[key];
    return instance || (instance = new Intl.RelativeTimeFormat(locale, options), caches.relativeTimeFormat[key] = instance, instance);
  }
  return {
    dateTimeFormat,
    listFormat,
    numberFormat,
    relativeTimeFormat
  };
})();
function createCache() {
  return /* @__PURE__ */ Object.create(null);
}
function getCacheId(locale, options) {
  return `${locale}-${JSON.stringify(orderedProps(options))}`;
}
function orderedProps(obj) {
  const segments = [];
  for (const [key, value] of Object.entries(obj))
    segments.push(`${key}=${JSON.stringify(value)}`);
  return segments.sort().join(`
`);
}
function useListFormat(t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, currentLocale = useContext(LocaleContext)?.currentLocale.id;
  let t2;
  return $[2] !== currentLocale || $[3] !== options ? (t2 = currentLocale ? intlCache.listFormat(currentLocale, options) : intlCache.listFormat("en-US", {
    ...options,
    style: "narrow"
  }), $[2] = currentLocale, $[3] = options, $[4] = t2) : t2 = $[4], t2;
}
const OPEN_TAG_RE = /^<(?<tag>[^\s\d<][^/?><]+)\/?>/, CLOSE_TAG_RE = /<\/(?<tag>[^>]+)>/, SELF_CLOSING_RE = /<[^>]+\/>/, VALID_COMPONENT_NAME_RE = /^[A-Z][A-Za-z0-9]+$/, VALID_HTML_TAG_NAME_RE = /^[a-z]+$/, TEMPLATE_RE = /{{\s*?([^}]+)\s*?}}/g;
function simpleParser(input) {
  const tokens = [];
  let text = "", openTag = "", remainder = input;
  for (; remainder.length > 0; )
    if (!openTag && remainder[0] === "<") {
      const match = matchOpenTag(remainder);
      if (match) {
        const tagName = match.groups.tag;
        validateTagName(tagName), text && (tokens.push(...textTokenWithInterpolation(text)), text = ""), isSelfClosing(match[0]) ? tokens.push({
          type: "tagOpen",
          selfClosing: !0,
          name: tagName
        }) : (tokens.push({
          type: "tagOpen",
          name: tagName
        }), openTag = tagName), remainder = remainder.slice(match[0].length);
      } else
        text += remainder[0], remainder = remainder.slice(1);
    } else if (openTag && remainder[0] === "<" && remainder[1] !== "<") {
      const match = matchCloseTag(remainder);
      if (match) {
        const tagName = match.groups.tag;
        if (remainder[1] !== "/")
          throw new Error(`Expected closing tag for <${openTag}>, but found new opening tag <${tagName}>. Nested tags is not supported.`);
        if (tagName !== openTag)
          throw new Error(`Expected closing tag for <${openTag}>, but found closing tag </${tagName}> instead. Make sure each opening tag has a matching closing tag.`);
        text && (tokens.push(...textTokenWithInterpolation(text)), text = ""), tokens.push({
          type: "tagClose",
          name: tagName
        }), openTag = "", remainder = remainder.slice(match[0].length);
      } else
        text += remainder[0], remainder = remainder.slice(1);
    } else
      text += remainder[0], remainder = remainder.slice(1);
  if (openTag)
    throw new Error(`No matching closing tag for <${openTag}> found. Either make it self closing (e.g. "<${openTag}/>") or close it (e.g "<${openTag}>...</${openTag}>").`);
  return text && tokens.push(...textTokenWithInterpolation(text)), tokens;
}
function textTokenWithInterpolation(text) {
  const tokens = [], interpolations = text.matchAll(TEMPLATE_RE);
  let lastIndex = 0;
  for (const match of interpolations) {
    if (typeof match.index > "u")
      continue;
    const pre = text.slice(lastIndex, match.index);
    pre.length > 0 && tokens.push({
      type: "text",
      text: pre
    }), tokens.push(parseInterpolation(match[0])), lastIndex += pre.length + match[0].length;
  }
  return lastIndex < text.length && tokens.push({
    type: "text",
    text: text.slice(lastIndex)
  }), tokens;
}
function parseInterpolation(interpolation) {
  const [variable, ...formatters2] = interpolation.replace(/^\{\{|\}\}$/g, "").trim().split(/\s*,\s*/);
  if (formatters2.length === 1 && formatters2[0] === "list")
    return {
      type: "interpolation",
      variable,
      formatters: formatters2
    };
  if (formatters2.length > 0)
    throw new Error(`Interpolations with formatters are not supported when using <Translate>. Found "${interpolation}". Utilize "useTranslation" instead, or format the values passed to <Translate> ahead of time.`);
  return {
    type: "interpolation",
    variable
  };
}
function isSelfClosing(tag) {
  return SELF_CLOSING_RE.test(tag);
}
function matchOpenTag(input) {
  return input.match(OPEN_TAG_RE);
}
function matchCloseTag(input) {
  return input.match(CLOSE_TAG_RE);
}
function validateTagName(tagName) {
  if (!(VALID_COMPONENT_NAME_RE.test(tagName) || VALID_HTML_TAG_NAME_RE.test(tagName)))
    throw new Error(tagName.trim() === tagName ? `Invalid tag "<${tagName}>". Tag names must be lowercase HTML tags or start with an uppercase letter and can only include letters and numbers.` : `Invalid tag "<${tagName}>". No whitespace allowed in tags.`);
}
const COMPONENT_NAME_RE = /^[A-Z]/, RECOGNIZED_HTML_TAGS = ["abbr", "address", "cite", "code", "del", "em", "ins", "kbd", "q", "samp", "strong", "sub", "sup"];
function Translate(props2) {
  const translated = props2.t(props2.i18nKey, {
    context: props2.context,
    skipInterpolation: !0,
    count: props2.values && "count" in props2.values && typeof props2.values.count == "number" ? props2.values.count : void 0
  }), tokens = useMemo(() => simpleParser(translated), [translated]), listFormat = useListFormat(), formatters2 = {
    list: (listValues) => listFormat.format(listValues)
  };
  return /* @__PURE__ */ jsx(Fragment, { children: render(tokens, props2.values, props2.components || {}, formatters2) });
}
function render(tokens, values2, componentMap, formatters2) {
  const [head, ...tail] = tokens;
  if (!head)
    return null;
  if (head.type === "interpolation") {
    const value = values2 ? values2[head.variable] : void 0;
    if (typeof value > "u")
      return `{{${head.variable}}}`;
    const formattedValue = applyFormatters(value, head.formatters || [], formatters2);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      formattedValue,
      render(tail, values2, componentMap, formatters2)
    ] });
  }
  if (head.type === "text")
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      head.text,
      render(tail, values2, componentMap, formatters2)
    ] });
  if (head.type === "tagOpen" && head.selfClosing) {
    const Component2 = componentMap[head.name];
    if (!Component2)
      throw new Error(`Component not found: ${head.name}`);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Component2, {}),
      render(tail, values2, componentMap, formatters2)
    ] });
  }
  if (head.type === "tagOpen" && !head.selfClosing) {
    const nextCloseIdx = tail.findIndex((token) => token.type === "tagClose"), nextClose = tail[nextCloseIdx];
    if (nextClose && head.name !== nextClose.name)
      throw new Error("Nested tags is not allowed");
    const Component2 = componentMap[head.name];
    if (!Component2 && COMPONENT_NAME_RE.test(head.name))
      throw new Error(`Component not defined: ${head.name}`);
    if (!Component2 && !RECOGNIZED_HTML_TAGS.includes(head.name))
      throw new Error(`HTML tag "${head.name}" is not allowed`);
    const children = tail.slice(0, nextCloseIdx), remaining = tail.slice(nextCloseIdx + 1), As = Component2 || head.name;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(As, { children: render(children, values2, componentMap, formatters2) }),
      render(remaining, values2, componentMap, formatters2)
    ] });
  }
  return null;
}
function applyFormatters(value, formatters2, formatterFns) {
  let formattedValue = value;
  for (const formatter of formatters2)
    if (formatter === "list")
      if (Array.isArray(value))
        formattedValue = formatterFns.list(value);
      else
        throw new Error("List formatter used on non-array value");
  return `${formattedValue}`;
}
const isDev = process.env.NODE_ENV !== "production", isProd = !isDev, DEFAULT_API_VERSION = "vX", DEPLOYED_FRONTEND_HOST_STAGING = "https://media.sanity.work", CDN_HOST_STAGING = "https://sanity-cdn.work", API_HOST_STAGING = "https://api.sanity.work", DEPLOYED_FRONTEND_HOST_PRODUCTION = "https://media.sanity.io", CDN_HOST_PRODUCTION = "https://sanity-cdn.com", API_HOST_PRODUCTION = "https://api.sanity.io", IS_LOCAL_DEV = !1;
class ProvisionError extends Error {
  // eslint-disable-next-line unicorn/custom-error-definition
  constructor(message, error, code) {
    super(message), this.message = message, this.error = error, this.code = code;
  }
}
function getMediaLibrariesForOrganization(client, organizationId) {
  return client.request({
    uri: `/media-libraries?organizationId=${organizationId}`,
    method: "GET"
  }).pipe(concatMap((data) => {
    if (data && Array.isArray(data.data))
      return of(data.data);
    throw new ProvisionError("No media libraries found", "No media libraries found", "ERROR_NO_MEDIA_LIBRARIES_FOUND");
  }));
}
function getOrganizationIdFromProjectId(client, projectId) {
  return client.request({
    uri: `/projects/${projectId}`,
    method: "GET"
  }).pipe(concatMap(async (data) => {
    if (data.organizationId)
      return data.organizationId;
    throw new ProvisionError("Organization ID not found", "Organization ID not found", "ERROR_NO_ORGANIZATION_FOUND");
  }));
}
function requestMediaLibraryStatus(client, libraryId) {
  return client.request({
    uri: `/media-libraries/${libraryId}`,
    method: "GET"
  }).pipe(concatMap((data) => {
    if (data && data.id)
      return of({
        id: data.id,
        organizationId: data.organizationId,
        status: data.status
      });
    throw new ProvisionError("Media library not found", "Media library not found", "ERROR_NO_MEDIA_LIBRARIES_FOUND");
  }));
}
function createMediaLibrary(client, organizationId) {
  return client.request({
    uri: "/media-libraries",
    method: "POST",
    body: {
      organizationId
    }
  });
}
function useEnsureMediaLibrary(projectId) {
  const $ = c(7);
  if (!projectId)
    throw new Error("projectId is required to fetch organizationId");
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "v2025-02-19"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0).observable;
  let t1, t2;
  if ($[1] !== client || $[2] !== projectId) {
    let t32;
    $[4] !== client ? (t32 = (organizationId) => getMediaLibrariesForOrganization(client, organizationId).pipe(concatMap((mediaLibraryData) => mediaLibraryData.length > 0 ? of({
      id: mediaLibraryData[0].id,
      organizationId,
      status: "active"
    }) : createMediaLibrary(client, organizationId).pipe(concatMap((createdData) => {
      if (createdData && createdData.id)
        return of({
          id: createdData.id,
          organizationId,
          status: "provisioning"
        });
      throw new ProvisionError("Failed to create Media Library", "Failed to create Media Library", "ERROR_FAILED_TO_CREATE_MEDIA_LIBRARY");
    }), concatMap((libraryData) => concat(of(libraryData), interval(1e3).pipe(concatMap(() => libraryData.id ? requestMediaLibraryStatus(client, libraryData.id).pipe(concatMap(_temp$2G)) : of(libraryData)), takeWhile(_temp2$Y, !0))))))), $[4] = client, $[5] = t32) : t32 = $[5], t2 = getOrganizationIdFromProjectId(client, projectId).pipe(switchMap$1(t32), catchError$1(_temp3$j)), $[1] = client, $[2] = projectId, $[3] = t2;
  } else
    t2 = $[3];
  t1 = t2;
  const observable = t1;
  let t3;
  return $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    status: "loading"
  }, $[6] = t3) : t3 = $[6], useObservable(observable, t3);
}
function _temp3$j(err) {
  if (err instanceof ProvisionError)
    return of({
      id: void 0,
      organizationId: void 0,
      status: "error",
      error: err
    });
  throw err;
}
function _temp2$Y(pData) {
  return pData?.status === "provisioning";
}
function _temp$2G(statusData) {
  return of(statusData);
}
function EnsureMediaLibrary(props2) {
  const $ = c(19), {
    onSetMediaLibraryId
  } = props2, {
    t
  } = useTranslation(), {
    id: id2,
    status,
    error
  } = useEnsureMediaLibrary(props2.projectId);
  let t0, t1;
  if ($[0] !== id2 || $[1] !== onSetMediaLibraryId || $[2] !== status ? (t0 = () => {
    status === "active" && id2 && onSetMediaLibraryId(id2);
  }, t1 = [id2, onSetMediaLibraryId, status], $[0] = id2, $[1] = onSetMediaLibraryId, $[2] = status, $[3] = t0, $[4] = t1) : (t0 = $[3], t1 = $[4]), useEffect(t0, t1), status === "error" && error) {
    const errorCodeTestId = error.code;
    let t2;
    $[5] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[5] = t2) : t2 = $[5];
    let t3;
    $[6] !== error.message || $[7] !== t ? (t3 = error.message || t("asset-sources.media-library.error.library-could-not-be-resolved"), $[6] = error.message, $[7] = t, $[8] = t3) : t3 = $[8];
    let t4;
    $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t3 }), $[9] = t3, $[10] = t4) : t4 = $[10];
    let t5;
    return $[11] !== errorCodeTestId || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "critical", "data-testid": "media-library-provision-error", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
      t2,
      /* @__PURE__ */ jsx(Stack, { space: 4, "data-testid": errorCodeTestId, children: t4 })
    ] }) }), $[11] = errorCodeTestId, $[12] = t4, $[13] = t5) : t5 = $[13], t5;
  }
  if (status === "provisioning") {
    let t2;
    $[14] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Spinner, {}) }), $[14] = t2) : t2 = $[14];
    let t3;
    $[15] !== t ? (t3 = t("asset-sources.media-library.info.provisioning"), $[15] = t, $[16] = t3) : t3 = $[16];
    let t4;
    return $[17] !== t3 ? (t4 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
      t2,
      /* @__PURE__ */ jsx(Stack, { space: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", "data-testid": "media-library-provisioning-message", children: t3 }) })
    ] }) }), $[17] = t3, $[18] = t4) : t4 = $[18], t4;
  }
  return null;
}
const fetchedLibraryIdCache = /* @__PURE__ */ new Map(), MediaLibraryContext = createContext("sanity/_singletons/context/media-library", {
  mediaLibraryId: void 0
});
function MediaLibraryProvider(t0) {
  const $ = c(23), {
    projectId,
    libraryId: libraryIdProp,
    children
  } = t0;
  let t1;
  $[0] !== projectId ? (t1 = projectId && fetchedLibraryIdCache.get(projectId) || void 0, $[0] = projectId, $[1] = t1) : t1 = $[1];
  const cachedLibraryId = t1, [mediaLibraryId, setMediaLibraryId] = useState(libraryIdProp || cachedLibraryId || null), [unexpectedError, setUnexpectedError] = useState(null), {
    t
  } = useTranslation();
  let t2;
  $[2] !== projectId ? (t2 = (libraryId) => {
    setMediaLibraryId(libraryId), projectId && fetchedLibraryIdCache.set(projectId, libraryId);
  }, $[2] = projectId, $[3] = t2) : t2 = $[3];
  const handleSetMediaLibraryId = t2;
  let t3;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (t42) => {
    const {
      error,
      info
    } = t42;
    console.error(error, info), setUnexpectedError(error);
  }, $[4] = t3) : t3 = $[4];
  const handleUnexpectedMediaLibraryError = t3;
  if (unexpectedError) {
    let t42;
    $[5] === Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[5] = t42) : t42 = $[5];
    let t52;
    $[6] !== t || $[7] !== unexpectedError.message ? (t52 = unexpectedError.message || t("asset-sources.media-library.error.library-could-not-be-resolved"), $[6] = t, $[7] = unexpectedError.message, $[8] = t52) : t52 = $[8];
    let t62;
    return $[9] !== t52 ? (t62 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "critical", "data-testid": "media-library-provision-error", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
      t42,
      /* @__PURE__ */ jsx(Stack, { space: 4, "data-testid": "MEDIA_LIBRARY_ERROR_UNEXPECTED", children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t52 }) })
    ] }) }), $[9] = t52, $[10] = t62) : t62 = $[10], t62;
  }
  const t4 = mediaLibraryId || void 0;
  let t5;
  $[11] !== t4 ? (t5 = {
    mediaLibraryId: t4
  }, $[11] = t4, $[12] = t5) : t5 = $[12];
  const ctxValue = t5, t6 = mediaLibraryId && children;
  let t7;
  $[13] !== handleSetMediaLibraryId || $[14] !== mediaLibraryId || $[15] !== projectId ? (t7 = !mediaLibraryId && /* @__PURE__ */ jsx(EnsureMediaLibrary, { projectId, onSetMediaLibraryId: handleSetMediaLibraryId }), $[13] = handleSetMediaLibraryId, $[14] = mediaLibraryId, $[15] = projectId, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(ErrorBoundary, { onCatch: handleUnexpectedMediaLibraryError, children: [
    t6,
    t7
  ] }), $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  return $[20] !== ctxValue || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(MediaLibraryContext.Provider, { value: ctxValue, children: t8 }), $[20] = ctxValue, $[21] = t8, $[22] = t9) : t9 = $[22], t9;
}
function useToken() {
  const $ = c(3);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1;
  $[1] !== client ? (t1 = client.config(), $[1] = client, $[2] = t1) : t1 = $[2];
  const {
    token
  } = t1;
  return token;
}
function useAuthType() {
  return useToken() ? "token" : "cookie";
}
function useMediaLibrary() {
  const $ = c(2), context = useContext(MediaLibraryContext), {
    mediaLibraryId
  } = context;
  let t0;
  return $[0] !== mediaLibraryId ? (t0 = {
    mediaLibraryId
  }, $[0] = mediaLibraryId, $[1] = t0) : t0 = $[1], t0;
}
function useLinkAssets({
  schemaType
}) {
  const {
    mediaLibraryId: libraryId
  } = useMediaLibrary(), client = useClient({
    apiVersion: DEFAULT_API_VERSION
  });
  return {
    onLinkAssets: useCallback(async (assetSelection) => {
      if (!libraryId)
        throw new Error("No libraryId found");
      const metadataPropsFromSchema = schemaType && isImageSchemaType(schemaType) ? schemaType.options?.metadata : void 0, assetsFromSource = [];
      for (const asset of assetSelection)
        try {
          const assetDocument = (await client.request({
            method: "POST",
            url: `/assets/media-library-link/${client.config().dataset}?${metadataPropsFromSchema?.map((prop) => `meta[]=${prop}`).join("&") || ""}`,
            withCredentials: !0,
            body: {
              mediaLibraryId: libraryId,
              assetInstanceId: asset.assetInstanceId,
              assetId: asset.asset._id
            },
            tag: "media-library.link-asset"
          })).document;
          assetsFromSource.push({
            kind: "assetDocumentId",
            value: assetDocument._id,
            mediaLibraryProps: {
              mediaLibraryId: libraryId,
              assetId: asset.asset._id,
              assetInstanceId: asset.assetInstanceId
            }
          });
        } catch (error) {
          throw console.error(error), error;
        }
      return assetsFromSource;
    }, [client, libraryId, schemaType])
  };
}
const usePluginPostMessage = (origin, handleMessage) => {
  const $ = c(10), token = useToken(), iframeRef = useRef(null);
  let t0;
  $[0] !== origin ? (t0 = (message) => {
    iframeRef.current?.contentWindow && iframeRef.current.contentWindow?.postMessage(message, origin);
  }, $[0] = origin, $[1] = t0) : t0 = $[1];
  const postFn = t0;
  let t1, t2;
  $[2] !== handleMessage || $[3] !== postFn || $[4] !== token ? (t1 = () => {
    const handler = (event) => {
      event.data.type === "tokenRequest" && postFn({
        type: "tokenResponse",
        token: token || null
      }), handleMessage && handleMessage(event.data, postFn);
    };
    return window.addEventListener("message", handler, !1), () => {
      iframeRef.current?.contentWindow && window.removeEventListener("message", handler, !1);
    };
  }, t2 = [handleMessage, iframeRef, postFn, token], $[2] = handleMessage, $[3] = postFn, $[4] = token, $[5] = t1, $[6] = t2) : (t1 = $[5], t2 = $[6]), useEffect(t1, t2);
  let t3;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (iframe) => iframeRef.current = iframe, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== postFn ? (t4 = {
    postMessage: postFn,
    setIframe: t3
  }, $[8] = postFn, $[9] = t4) : t4 = $[9], t4;
};
function useSanityMediaLibraryConfig() {
  const $ = c(10);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[0] = t0) : t0 = $[0];
  const isStaging2 = useClient(t0).config().apiHost.endsWith("sanity.work"), appHost = isStaging2 ? DEPLOYED_FRONTEND_HOST_STAGING : DEPLOYED_FRONTEND_HOST_PRODUCTION, env = isStaging2 ? "staging" : "production", t1 = isStaging2 ? CDN_HOST_STAGING : CDN_HOST_PRODUCTION, t2 = isStaging2 ? API_HOST_STAGING : API_HOST_PRODUCTION;
  let t3;
  $[1] !== appHost || $[2] !== t1 || $[3] !== t2 ? (t3 = {
    cdn: t1,
    app: appHost,
    api: t2
  }, $[1] = appHost, $[2] = t1, $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== env || $[6] !== t3 ? (t4 = {
    apiVersion: DEFAULT_API_VERSION,
    appBasePath: "",
    pluginApiVersion: "v1",
    hosts: t3,
    isLocalDev: IS_LOCAL_DEV,
    env
  }, $[5] = env, $[6] = t3, $[7] = t4) : t4 = $[7];
  const internalConfig = t4;
  let t5;
  return $[8] !== internalConfig ? (t5 = {
    __internal: internalConfig
  }, $[8] = internalConfig, $[9] = t5) : t5 = $[9], t5;
}
const AppDialog = styled(Dialog)`
  [data-ui='Card']:first-child {
    flex: 1;
  }
`, defaultStyle = {
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  overflow: "hidden"
}, hiddenStyle = {
  display: "none"
}, Iframe = forwardRef(function(props2, forwardedRef) {
  const $ = c(7), {
    src,
    hidden
  } = props2, t0 = hidden ? hiddenStyle : defaultStyle;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    overflow: "hidden",
    flexGrow: 1,
    border: "none",
    margin: 0,
    padding: 0,
    height: "100%",
    width: "100%"
  }, $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== forwardedRef || $[2] !== src ? (t2 = /* @__PURE__ */ jsx("iframe", { ref: forwardedRef, src, style: t1 }), $[1] = forwardedRef, $[2] = src, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t0 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { style: t0, children: t2 }), $[4] = t0, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
});
function SelectAssetsDialog$1(props2) {
  const $ = c(36), theme = useTheme(), {
    t
  } = useTranslation(), {
    dark
  } = theme.sanity.color, {
    mediaLibraryId: libraryId
  } = useMediaLibrary(), mediaLibraryConfig = useSanityMediaLibraryConfig(), appHost = mediaLibraryConfig.__internal.hosts.app, authType = useAuthType(), {
    dialogHeaderTitle,
    onClose,
    open,
    onSelect,
    selectionType: t0,
    ref,
    selectAssetType,
    schemaType
  } = props2, selectionType = t0 === void 0 ? "single" : t0, toast = useToast(), [assetSelection, setAssetSelection] = useState(props2.selection), [didSelect, setDidSelect] = useState(!1), pluginApiVersion = mediaLibraryConfig.__internal.pluginApiVersion, appBasePath = mediaLibraryConfig.__internal.appBasePath, iframeUrl = `${appHost}${appBasePath}/plugin/${pluginApiVersion}/library/${libraryId}/assets?selectionType=${selectionType}&selectAssetTypes=${selectAssetType}&scheme=${dark ? "dark" : "light"}&auth=${authType}`;
  let t1;
  $[0] !== schemaType ? (t1 = {
    schemaType
  }, $[0] = schemaType, $[1] = t1) : t1 = $[1];
  const {
    onLinkAssets
  } = useLinkAssets(t1);
  let t2;
  $[2] !== assetSelection || $[3] !== onClose || $[4] !== onLinkAssets || $[5] !== onSelect || $[6] !== t || $[7] !== toast ? (t2 = async () => {
    try {
      setDidSelect(!0);
      const assets = await onLinkAssets([assetSelection[0]]);
      onSelect(assets), onClose();
    } catch (t32) {
      const error = t32;
      toast.push({
        closable: !0,
        status: "error",
        title: t("asset-source.dialog.insert-asset-error")
      }), console.error(error), setDidSelect(!1);
    }
  }, $[2] = assetSelection, $[3] = onClose, $[4] = onLinkAssets, $[5] = onSelect, $[6] = t, $[7] = toast, $[8] = t2) : t2 = $[8];
  const handleSelect = t2;
  let t3;
  $[9] !== onClose ? (t3 = () => {
    onClose();
  }, $[9] = onClose, $[10] = t3) : t3 = $[10];
  const handleClose = t3;
  let t4;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t4 = (message) => {
    message.type === "assetSelection" && setAssetSelection(message.selection);
  }, $[11] = t4) : t4 = $[11];
  const handlePluginMessage = t4, {
    setIframe
  } = usePluginPostMessage(appHost, handlePluginMessage);
  if (!open)
    return null;
  let t5;
  $[12] !== t ? (t5 = t("asset-source.dialog.button.cancel"), $[12] = t, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== handleClose || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleClose, text: t5, size: "large" }), $[14] = handleClose, $[15] = t5, $[16] = t6) : t6 = $[16];
  const t7 = assetSelection.length === 0;
  let t8;
  $[17] !== t ? (t8 = t("asset-source.dialog.button.select"), $[17] = t, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== didSelect || $[20] !== handleSelect || $[21] !== t7 || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { onClick: handleSelect, loading: didSelect, disabled: t7, text: t8, size: "large" }), $[19] = didSelect, $[20] = handleSelect, $[21] = t7, $[22] = t8, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== t6 || $[25] !== t9 ? (t10 = /* @__PURE__ */ jsx(Flex, { width: "full", gap: 3, justify: "flex-end", padding: 2, children: /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsxs(Flex, { width: "full", gap: 3, justify: "flex-end", padding: 3, children: [
    t6,
    t9
  ] }) }) }), $[24] = t6, $[25] = t9, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== iframeUrl || $[28] !== setIframe ? (t11 = /* @__PURE__ */ jsx(Iframe, { ref: setIframe, src: iframeUrl }), $[27] = iframeUrl, $[28] = setIframe, $[29] = t11) : t11 = $[29];
  let t12;
  return $[30] !== dialogHeaderTitle || $[31] !== handleClose || $[32] !== ref || $[33] !== t10 || $[34] !== t11 ? (t12 = /* @__PURE__ */ jsx(AppDialog, { animate: !0, header: dialogHeaderTitle, id: "media-library-plugin-dialog-select-assets", onClose: handleClose, open: !0, ref, "data-testid": "media-library-plugin-dialog-select-assets", width: 3, footer: t10, children: t11 }), $[30] = dialogHeaderTitle, $[31] = handleClose, $[32] = ref, $[33] = t10, $[34] = t11, $[35] = t12) : t12 = $[35], t12;
}
const UploadAssetsDialog = function(props2) {
  const $ = c(21), theme = useTheme(), {
    mediaLibraryId: libraryId
  } = useMediaLibrary(), {
    dark
  } = theme.sanity.color, {
    schemaType
  } = props2;
  let t0;
  $[0] !== schemaType ? (t0 = {
    schemaType
  }, $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const {
    onLinkAssets
  } = useLinkAssets(t0), {
    open,
    onSelect,
    onClose,
    uploader
  } = props2, pluginConfig = useSanityMediaLibraryConfig(), authType = useAuthType(), toast = useToast(), {
    t
  } = useTranslation(), appHost = pluginConfig.__internal.hosts.app, pluginApiVersion = pluginConfig.__internal.pluginApiVersion, appBasePath = pluginConfig.__internal.appBasePath, iframeUrl = `${appHost}${appBasePath}/plugin/${pluginApiVersion}/library/${libraryId}/upload?scheme=${dark ? "dark" : "light"}&auth=${authType}`, [pageReadyForUploads, setPageReadyForUploads] = useState(!1);
  let t1;
  $[2] !== onClose || $[3] !== onLinkAssets || $[4] !== onSelect || $[5] !== t || $[6] !== toast ? (t1 = async (uploadedAssets) => {
    try {
      const assets = await onLinkAssets(uploadedAssets);
      onSelect(assets), onClose();
    } catch (t22) {
      const error = t22;
      toast.push({
        closable: !0,
        status: "error",
        title: t("asset-source.dialog.insert-asset-error")
      }), console.error(error);
    }
  }, $[2] = onClose, $[3] = onLinkAssets, $[4] = onSelect, $[5] = t, $[6] = toast, $[7] = t1) : t1 = $[7];
  const handleUploaded = t1;
  let t2;
  $[8] !== handleUploaded || $[9] !== open || $[10] !== uploader ? (t2 = (message) => {
    open && (message.type === "pageLoaded" && message.page === "upload" && setPageReadyForUploads(!0), message.type === "pageUnloaded" && message.page === "upload" && setPageReadyForUploads(!1), message.type === "uploadProgress" && uploader && message.files.forEach((t32) => {
      const {
        id: id2,
        status,
        progress,
        error: error_0
      } = t32;
      uploader.updateFile(id2, {
        status,
        progress,
        error: error_0
      });
    }), message.type === "uploadResponse" && uploader && handleUploaded(message.assets));
  }, $[8] = handleUploaded, $[9] = open, $[10] = uploader, $[11] = t2) : t2 = $[11];
  const handlePluginMessage = t2, {
    postMessage,
    setIframe
  } = usePluginPostMessage(appHost, handlePluginMessage);
  let t3, t4;
  if ($[12] !== open || $[13] !== pageReadyForUploads || $[14] !== postMessage || $[15] !== uploader ? (t3 = () => {
    if (open && uploader)
      return pageReadyForUploads && uploader.getFiles().length > 0 && uploader.getFiles().every(_temp$2F) && (postMessage({
        type: "uploadRequest",
        files: uploader.getFiles()
      }), setPageReadyForUploads(!1)), uploader.subscribe((event) => {
        event.type === "status" && event.status === "aborted" && postMessage({
          type: "abortUploadRequest",
          files: [{
            id: event.file.id
          }]
        });
      });
  }, t4 = [open, pageReadyForUploads, postMessage, uploader], $[12] = open, $[13] = pageReadyForUploads, $[14] = postMessage, $[15] = uploader, $[16] = t3, $[17] = t4) : (t3 = $[16], t4 = $[17]), useEffect(t3, t4), !open)
    return null;
  let t5;
  return $[18] !== iframeUrl || $[19] !== setIframe ? (t5 = /* @__PURE__ */ jsx(Iframe, { ref: setIframe, src: iframeUrl, hidden: !0 }), $[18] = iframeUrl, $[19] = setIframe, $[20] = t5) : t5 = $[20], t5;
};
function _temp$2F(file) {
  return file.status === "pending";
}
const MediaLibraryAssetSourceComponent = function(props2, ref) {
  const $ = c(27), {
    action: t0,
    assetSource,
    assetType: t1,
    dialogHeaderTitle,
    libraryId: libraryIdProp,
    onClose,
    onSelect,
    schemaType
  } = props2, action = t0 === void 0 ? "select" : t0, assetType = t1 === void 0 ? "image" : t1, {
    t
  } = useTranslation();
  let t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    apiVersion: DEFAULT_API_VERSION
  }, $[0] = t2) : t2 = $[0];
  const client = useClient(t2);
  let t3;
  $[1] !== client ? (t3 = client.config(), $[1] = client, $[2] = t3) : t3 = $[2];
  const projectId = t3.projectId;
  if (!projectId)
    throw new Error("No projectId found");
  const t4 = action === "upload";
  let t5;
  $[3] !== assetSource.uploader || $[4] !== onClose || $[5] !== onSelect || $[6] !== schemaType || $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(UploadAssetsDialog, { open: t4, onClose, onSelect, schemaType, uploader: assetSource.uploader }), $[3] = assetSource.uploader, $[4] = onClose, $[5] = onSelect, $[6] = schemaType, $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== assetType || $[10] !== dialogHeaderTitle || $[11] !== t ? (t6 = dialogHeaderTitle || t("asset-source.dialog.default-title", {
    context: assetType
  }), $[9] = assetType, $[10] = dialogHeaderTitle, $[11] = t, $[12] = t6) : t6 = $[12];
  const t7 = action === "select";
  let t8;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t8 = [], $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== assetType || $[15] !== onClose || $[16] !== onSelect || $[17] !== ref || $[18] !== schemaType || $[19] !== t6 || $[20] !== t7 ? (t9 = /* @__PURE__ */ jsx(SelectAssetsDialog$1, { dialogHeaderTitle: t6, open: t7, ref, onClose, onSelect, selection: t8, schemaType, selectAssetType: assetType }), $[14] = assetType, $[15] = onClose, $[16] = onSelect, $[17] = ref, $[18] = schemaType, $[19] = t6, $[20] = t7, $[21] = t9) : t9 = $[21];
  let t10;
  return $[22] !== libraryIdProp || $[23] !== projectId || $[24] !== t5 || $[25] !== t9 ? (t10 = /* @__PURE__ */ jsxs(MediaLibraryProvider, { projectId, libraryId: libraryIdProp, children: [
    t5,
    t9
  ] }), $[22] = libraryIdProp, $[23] = projectId, $[24] = t5, $[25] = t9, $[26] = t10) : t10 = $[26], t10;
}, MediaLibraryAssetSource = memo(forwardRef(MediaLibraryAssetSourceComponent));
class MediaLibraryUploader {
  files = [];
  subscribers = /* @__PURE__ */ new Set();
  checkAllComplete() {
    this.files.length > 0 && this.files.every((file) => ["complete", "error", "aborted"].includes(file.status)) && (this.emit({
      type: "all-complete",
      files: this.files
    }), this.files.some((file) => file.status === "error") && this.emit({
      type: "error",
      files: this.files.filter((file) => file.status === "error")
    }), this.reset());
  }
  emit(event) {
    this.subscribers.forEach((fn) => fn(event));
  }
  upload(files) {
    for (const file of files) {
      const uploadFile2 = {
        id: uuid(),
        file,
        progress: 0,
        status: "pending"
      };
      this.files.push(uploadFile2);
    }
    return this.files;
  }
  abort(file) {
    if (file) {
      const target = this.files.find((f) => f.id === file.id);
      target && ["pending", "uploading"].includes(target.status) && this.updateFile(target.id, {
        status: "aborted"
      });
    } else
      for (const target of this.files)
        ["pending", "uploading"].includes(target.status) && this.updateFile(target.id, {
          status: "aborted"
        });
    this.emit({
      type: "abort",
      files: this.files.filter((abortedFile) => abortedFile.status === "aborted")
    }), this.checkAllComplete();
  }
  updateFile(fileId, data) {
    const target = this.files.find((f) => f.id === fileId);
    target && (data.error && (target.error = data.error), data.progress && data.progress !== target.progress && (target.progress = data.progress, this.emit({
      type: "progress",
      file: target,
      progress: target.progress * 100
    })), data.status && data.status !== target.status && (target.status = data.status, this.emit({
      type: "status",
      file: target,
      status: target.status
    }))), this.checkAllComplete();
  }
  subscribe(subscriber) {
    this.subscribers.add(subscriber);
    for (const file of this.files)
      subscriber({
        type: "status",
        file,
        status: file.status
      }), subscriber({
        type: "progress",
        file,
        progress: file.progress
      });
    return this.checkAllComplete(), () => {
      this.subscribers.delete(subscriber);
    };
  }
  getFiles() {
    return this.files;
  }
  reset() {
    this.files = [];
  }
}
const sourceName$1 = "sanity-media-library";
function createSanityMediaLibraryImageSource(props2) {
  return {
    name: props2.name || sourceName$1,
    i18nKey: props2.i18nKey || "asset-sources.media-library.image.title",
    component: (sourceProps) => /* @__PURE__ */ jsx(MediaLibraryAssetSource, { ...sourceProps, libraryId: props2.libraryId }),
    icon: props2.icon || ImageIcon,
    uploader: new MediaLibraryUploader()
  };
}
function createSanityMediaLibraryFileSource(props2) {
  return {
    name: props2.name || sourceName$1,
    i18nKey: props2.i18nKey || "asset-sources.media-library.file.title",
    component: (sourceProps) => /* @__PURE__ */ jsx(MediaLibraryAssetSource, { ...sourceProps, libraryId: props2.libraryId }),
    icon: props2.icon || DocumentIcon,
    uploader: new MediaLibraryUploader()
  };
}
const emptyRender = () => /* @__PURE__ */ jsx(Fragment$1, {});
function _createMiddlewareComponent(DefaultComponent2, middlewareComponents) {
  return (outerProps) => {
    let next = (props2) => /* @__PURE__ */ jsx(DefaultComponent2, { ...props2 });
    for (const Middleware of middlewareComponents) {
      const renderDefault2 = next;
      next = (props2) => /* @__PURE__ */ jsx(Middleware, { ...props2, renderDefault: renderDefault2 });
    }
    return next({
      ...outerProps,
      // NOTE: it's safe to pass the empty render function, since it'll be overwritten in the next step (above).
      // NOTE: it's important that the default component does not use `renderDefault`, since it will
      // get the `emptyRender` callback will be passed when the middleware stack is empty.
      renderDefault: emptyRender
    });
  };
}
function useMiddlewareComponents(props2) {
  const $ = c(4), {
    options
  } = useSource().__internal, {
    defaultComponent,
    pick: pick2
  } = props2;
  let t0, t1;
  if ($[0] !== defaultComponent || $[1] !== options || $[2] !== pick2) {
    const flattened = [...flattenConfig(options, [])];
    flattened.reverse();
    const result = flattened.map((t2) => {
      const {
        config
      } = t2;
      return pick2(config);
    }).filter(Boolean);
    t1 = _createMiddlewareComponent(defaultComponent, result), $[0] = defaultComponent, $[1] = options, $[2] = pick2, $[3] = t1;
  } else
    t1 = $[3];
  return t0 = t1, t0;
}
class ConfigPropertyError extends Error {
  constructor({
    propertyName,
    path,
    cause
  }) {
    const message = isRecord$4(cause) && typeof cause?.message == "string" ? `: ${cause.message}` : "";
    super(`An error occurred while resolving \`${propertyName}\` from ${path.join(" > ")}${message}`), this.name = "ConfigPropertyError", this.propertyName = propertyName, this.cause = cause, this.path = path;
  }
}
class ConfigResolutionError extends Error {
  constructor({
    causes,
    name,
    type
  }) {
    const messages = causes.filter(Boolean).map((cause) => isRecord$4(cause) && typeof cause?.message == "string" ? cause.message : String(cause));
    super(`Could not resolve ${type}${name ? ` \`${name}\`` : ""}:
${messages.map((message) => `	- ${message}`).join(`
`)}

`), this.name = name, this.causes = causes, this.type = type;
  }
}
function pseudoRandomNumber(seed) {
  const hashCode = seed.split("").reduce((prevHash, currVal) => (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0, 0);
  return Math.abs(hashCode * 16807 % 2147483647) / 2147483647;
}
const SvgText = styled.text`
  font-family: ${({
  theme
}) => theme.sanity.fonts.text.family};
  font-weight: ${({
  theme
}) => theme.sanity.fonts.text.weights.medium};
  font-size: ${({
  theme
}) => theme.sanity.fonts.text.sizes[1].fontSize}px;
  transform: translateY(1px);
`;
function createDefaultIcon(title, subtitle) {
  const rng1 = pseudoRandomNumber(`${title} ${subtitle}`), huesWithoutGray = COLOR_HUES.filter((hue) => hue !== "gray"), colorHue = huesWithoutGray[Math.floor(rng1 * huesWithoutGray.length)], possibleTints = ["300", "400", "500", "600", "700"], rng2 = pseudoRandomNumber(rng1.toString()), tint = possibleTints[Math.floor(rng2 * possibleTints.length)], color = hues[colorHue][tint].hex, letters = title.split(/\s/g).map((word) => word.replace(/\\W/g, "")).filter(Boolean).slice(0, 2).map((i) => i.charAt(0).toUpperCase()), darkened = darken(color, 0.4), lightened = lighten(color, 0.4), textColor = hasBadContrast(color, "readable", darkened) ? hasBadContrast(color, "readable", lightened) ? readableColor(color) : lightened : darkened;
  return /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", children: [
    /* @__PURE__ */ jsx("rect", { width: 32, height: 32, rx: 2, fill: color }),
    /* @__PURE__ */ jsx(SvgText, { x: "50%", y: "50%", textAnchor: "middle", alignmentBaseline: "middle", dominantBaseline: "middle", fill: textColor, children: letters })
  ] });
}
function defineConfig(config) {
  return config;
}
function createConfig(config) {
  return config;
}
function validatePlugin(pluginResult) {
  const messages = ["projectId" in pluginResult && "`projectId` not allowed in plugin configuration", "dataset" in pluginResult && "`dataset` not allowed in plugin configuration"].filter(isString$1);
  if (messages.length) throw new Error(`Invalid plugin configuration:
${messages.map((message) => `	${message}`).join(`
`)}`);
}
function definePlugin(arg) {
  if (typeof arg == "function") {
    const pluginFactory = arg;
    return (options) => {
      const result = pluginFactory(options);
      return validatePlugin(result), result;
    };
  }
  return validatePlugin(arg), () => arg;
}
function createPlugin(arg) {
  return definePlugin(arg);
}
function defineDocumentFieldAction(fieldAction) {
  return fieldAction;
}
const rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reKeySegment = /_key\s*==\s*['"](.*)['"]/;
function pathToString$1(path) {
  if (!Array.isArray(path))
    throw new Error("Path is not an array");
  return path.reduce((target, segment, i) => {
    if (isIndexSegment(segment))
      return `${target}[${segment}]`;
    if (isKeySegment(segment) && segment._key)
      return `${target}[_key=="${segment._key}"]`;
    if (isIndexTuple(segment)) {
      const [from2, to] = segment;
      return `${target}[${from2}:${to}]`;
    }
    if (typeof segment == "string")
      return `${target}${i === 0 ? "" : "."}${segment}`;
    throw new Error(`Unsupported path segment \`${JSON.stringify(segment)}\``);
  }, "");
}
function getValueAtPath(rootValue, path) {
  const segment = path[0];
  if (typeof segment > "u")
    return rootValue;
  const tail = path.slice(1);
  if (isIndexSegment(segment))
    return getValueAtPath(Array.isArray(rootValue) ? rootValue[segment] : void 0, tail);
  if (isKeySegment(segment))
    return getValueAtPath(Array.isArray(rootValue) ? rootValue.find((item) => item._key === segment._key) : void 0, tail);
  if (typeof segment == "string")
    return getValueAtPath(isRecord$4(rootValue) ? rootValue[segment] : void 0, tail);
  throw new Error(`Unknown segment type ${JSON.stringify(segment)}`);
}
function findIndex(array, segment) {
  return typeof segment != "number" && !isKeySegment(segment) ? -1 : typeof segment == "number" ? segment : array.findIndex((item) => isKeyedObject(item) && item._key === segment._key);
}
function stringToPath(path) {
  const segments = path.match(rePropName);
  if (!segments)
    throw new Error("Invalid path string");
  return segments.map(normalizePathSegment);
}
function normalizePathSegment(segment) {
  return isIndexSegment(segment) ? normalizeIndexSegment(segment) : isKeySegment(segment) ? normalizeKeySegment(segment) : isIndexTuple(segment) ? normalizeIndexTupleSegment(segment) : segment;
}
function normalizeIndexSegment(segment) {
  return Number(segment.replace(/[^\d]/g, ""));
}
function normalizeKeySegment(segment) {
  const segments = segment.match(reKeySegment);
  if (!segments)
    throw new Error("Invalid key segment");
  return {
    _key: segments[1]
  };
}
function normalizeIndexTupleSegment(segment) {
  const [from2, to] = segment.split(":").map((seg) => seg === "" ? seg : Number(seg));
  return [from2, to];
}
function pathsAreEqual(pathA, pathB) {
  return pathA.length !== pathB.length ? !1 : pathA.every((segmentA, index) => {
    const segmentB = pathB[index];
    return isKeySegment(segmentA) && isKeySegment(segmentB) ? segmentA._key === segmentB._key : isIndexSegment(segmentA) ? Number(segmentA) === Number(segmentB) : isIndexTuple(segmentA) && isIndexTuple(segmentB) ? segmentA[0] === segmentB[0] && segmentA[1] === segmentB[1] : segmentA === segmentB;
  });
}
function getItemKey$1(arrayItem) {
  return isKeyedObject(arrayItem) ? arrayItem._key : void 0;
}
function getItemKeySegment(arrayItem) {
  const key = getItemKey$1(arrayItem);
  return key ? {
    _key: key
  } : void 0;
}
function isEmptyObject$1(item) {
  return typeof item == "object" && item !== null && Object.keys(item).length <= 0;
}
function getAnnotationColor(colorManager, annotation) {
  return colorManager.get(annotation?.author || null);
}
function getAnnotationAtPath(diff, diffPath) {
  const path = Array.isArray(diffPath) ? diffPath : stringToPath(diffPath);
  return getAnnotationAt(diff, path);
}
function getDiffAtPath(diff, diffPath) {
  const path = Array.isArray(diffPath) ? diffPath : stringToPath(diffPath);
  return getDiffAt(diff, path);
}
function getAnnotationAt(diff, path) {
  const diffAt = getDiffAt(diff, path);
  if (diffAt && diffAt.action !== "unchanged")
    return diffAt.annotation || void 0;
}
function getDiffAt(diff, path, parentPath = []) {
  if (path.length === 0)
    return diff;
  const segment = path[0], tail = path.slice(1);
  if (isIndexTuple(segment))
    throw new Error("Index tuples are not supported in diff paths");
  if (isIndexSegment(segment) || isKeySegment(segment)) {
    const location2 = isIndexSegment(segment) ? `at index ${segment}` : `with key ${segment._key}`;
    if (diff.type !== "array") {
      `${location2}${pathToString$1(parentPath)}`;
      return;
    }
    const itemDiff = diff.items.find(isIndexSegment(segment) ? (item) => item.toIndex === segment : (item) => itemMatchesKey(item, segment));
    if (!itemDiff) {
      `${location2}${pathToString$1(parentPath)}`;
      return;
    }
    return getDiffAt(itemDiff.diff, tail, parentPath.concat(segment));
  }
  if (diff.type !== "object") {
    `${segment}${pathToString$1(parentPath)}`;
    return;
  }
  const fieldDiff = diff.fields[segment];
  if (typeof fieldDiff > "u") {
    `${segment}${pathToString$1(parentPath)}`;
    return;
  }
  return getDiffAt(fieldDiff, tail, parentPath.concat(segment));
}
function itemMatchesKey(item, key) {
  const itemDiff = item.diff;
  return itemDiff.type !== "object" || !itemDiff.toValue ? !1 : itemDiff.toValue._key === key;
}
function visitDiff(diff, visitor, path = []) {
  if (visitor(diff, path)) {
    if (diff.type === "array") {
      visitArrayDiff(diff, visitor, path);
      return;
    }
    if (diff.type === "object") {
      visitObjectDiff(diff, visitor, path);
      return;
    }
    diff.type === "string" && visitStringDiff(diff, visitor, path);
  }
}
function visitArrayDiff(diff, visitor, path) {
  diff.action !== "unchanged" && diff.items.forEach((itemDiff) => {
    const _key = itemDiff.diff.type === "object" && itemDiff.diff.toValue?._key, segment = _key ? {
      _key
    } : getItemDiffIndex(itemDiff);
    visitDiff(itemDiff.diff, visitor, path.concat(segment));
  });
}
function visitObjectDiff(diff, visitor, path) {
  diff.action !== "unchanged" && Object.keys(diff.fields).forEach((fieldName) => {
    const fieldDiff = diff.fields[fieldName];
    visitDiff(fieldDiff, visitor, path.concat(fieldName));
  });
}
function visitStringDiff(diff, visitor, path) {
  diff.action !== "unchanged" && diff.segments.forEach((segment) => {
    visitDiff(segment, visitor, path);
  });
}
function getItemDiffIndex(itemDiff) {
  return typeof itemDiff.toIndex > "u" ? itemDiff.fromIndex || 0 : itemDiff.toIndex;
}
function useUserColorManager() {
  const userColorManager = useContext(UserColorManagerContext);
  if (!userColorManager)
    throw new Error("UserColorManager: missing context value");
  return userColorManager;
}
function useUserColor(userId) {
  const $ = c(5), manager = useUserColorManager();
  let t0, t1;
  $[0] !== manager || $[1] !== userId ? (t1 = userId ? manager.listen(userId) : EMPTY$6, $[0] = manager, $[1] = userId, $[2] = t1) : t1 = $[2], t0 = t1;
  const observable = t0;
  let t2;
  return $[3] !== manager ? (t2 = manager.get(null), $[3] = manager, $[4] = t2) : t2 = $[4], useObservable(observable, t2);
}
const DEFAULT_CURRENT_USER_HUE = "purple", USER_COLOR_EXCLUDE_HUES = ["green", "red", "gray"], defaultHues = COLOR_HUES.filter((hue) => !USER_COLOR_EXCLUDE_HUES.includes(hue)), getTints = (scheme) => {
  const isDarkScheme = scheme === "dark";
  return {
    background: isDarkScheme ? "900" : "100",
    border: isDarkScheme ? "700" : "300",
    text: isDarkScheme ? "200" : "700"
  };
}, getDefaultColors = (scheme) => {
  const {
    background,
    border,
    text
  } = getTints(scheme);
  return defaultHues.reduce((colors, hue) => (colors[hue] = {
    name: hue,
    background: hues[hue][background].hex,
    border: hues[hue][border].hex,
    text: hues[hue][text].hex,
    tints: hues[hue]
  }, colors), {});
}, getAnonymousColor = (scheme) => {
  const {
    background,
    border,
    text
  } = getTints(scheme);
  return {
    name: "gray",
    background: hues.gray[background].hex,
    border: hues.gray[border].hex,
    text: hues.gray[text].hex,
    tints: hues.gray
  };
};
function createUserColorManager(options) {
  const {
    anonymousColor: anonymousColorProp,
    colors,
    currentUserColor: currentUserColorProp,
    scheme
  } = options, userColors = colors || getDefaultColors(scheme), anonymousColor = anonymousColorProp || getAnonymousColor(scheme), currentUserColor = currentUserColorProp || DEFAULT_CURRENT_USER_HUE;
  if (!userColors.hasOwnProperty(currentUserColor))
    throw new Error(`'colors' must contain 'currentUserColor' (${currentUserColor})`);
  const userColorKeys = Object.keys(userColors), subscriptions = /* @__PURE__ */ new Map(), previouslyAssigned = /* @__PURE__ */ new Map(), assignedCounts = userColorKeys.reduce((counts, color) => (counts[color] = 0, counts), {}), assigned = /* @__PURE__ */ new Map();
  let currentUserId;
  return options?.userStore && options.userStore.me.subscribe((user) => setCurrentUser(user ? user.id : null)), {
    get: get2,
    listen: listen2
  };
  function get2(userId) {
    return userId ? userColors[getUserHue(userId)] : anonymousColor;
  }
  function getUserHue(userId) {
    if (userId === currentUserId)
      return currentUserColor;
    const assignedHue = assigned.get(userId);
    if (assignedHue)
      return assignedHue;
    const prevHue = previouslyAssigned.get(userId);
    if (prevHue && (assignedCounts[prevHue] === 0 || !hasUnusedColor()))
      return assignHue(userId, prevHue);
    const preferredHue = getPreferredHue(userId);
    return assignedCounts[preferredHue] === 0 ? assignHue(userId, preferredHue) : assignHue(userId, getLeastUsedHue(prevHue));
  }
  function listen2(userId) {
    let subscription = subscriptions.get(userId);
    if (subscription)
      return subscription;
    const hue = getUserHue(userId);
    return subscription = getObservableColor(userId, hue), subscriptions.set(userId, subscription), subscription;
  }
  function assignHue(userId, hue) {
    return assigned.set(userId, hue), previouslyAssigned.set(userId, hue), assignedCounts[hue]++, hue;
  }
  function unassignHue(userId, hue) {
    assigned.delete(userId), assignedCounts[hue]--;
  }
  function getUnusedColor() {
    return userColorKeys.find((colorHue) => assignedCounts[colorHue] === 0);
  }
  function hasUnusedColor() {
    return !!getUnusedColor();
  }
  function getLeastUsedHue(tieBreakerPreference) {
    let leastUses = 1 / 0, leastUsed = [];
    return userColorKeys.forEach((colorHue) => {
      const uses = assignedCounts[colorHue];
      uses === leastUses ? leastUsed.push(colorHue) : uses < leastUses && (leastUses = uses, leastUsed = [colorHue]);
    }), tieBreakerPreference && leastUsed.includes(tieBreakerPreference) ? tieBreakerPreference : leastUsed[0];
  }
  function getObservableColor(userId, hue) {
    return new Observable((subscriber) => {
      const userColor = userColors[hue];
      return subscriber.next(userColor), () => {
        subscriptions.delete(userId), unassignHue(userId, hue);
      };
    }).pipe(shareReplay({
      refCount: !0
    }));
  }
  function setCurrentUser(userId) {
    currentUserId = userId, assignedCounts[currentUserColor] += userId ? 1 : -1;
  }
  function getPreferredHue(userId) {
    let hash2 = 0;
    for (let i = 0; i < userId.length; i++)
      hash2 = (hash2 << 5) - hash2 + userId.charCodeAt(i) | 0;
    return userColorKeys[Math.abs(hash2) % userColorKeys.length];
  }
}
function UserColorManagerProvider(t0) {
  const $ = c(6), {
    children,
    manager: managerFromProps
  } = t0, scheme = useColorSchemeValue();
  let t1, t2;
  $[0] !== managerFromProps || $[1] !== scheme ? (t2 = managerFromProps || createUserColorManager({
    scheme
  }), $[0] = managerFromProps, $[1] = scheme, $[2] = t2) : t2 = $[2], t1 = t2;
  const manager = t1;
  let t3;
  return $[3] !== children || $[4] !== manager ? (t3 = /* @__PURE__ */ jsx(UserColorManagerContext.Provider, { value: manager, children }), $[3] = children, $[4] = manager, $[5] = t3) : t3 = $[5], t3;
}
function useAnnotationColor(annotation) {
  const $ = c(3), userColorManager = useUserColorManager();
  let t0;
  return $[0] !== annotation || $[1] !== userColorManager ? (t0 = getAnnotationColor(userColorManager, annotation), $[0] = annotation, $[1] = userColorManager, $[2] = t0) : t0 = $[2], t0;
}
function useDiffAnnotationColor(diff, path = []) {
  const userColorManager = useUserColorManager(), annotation = useMemo(() => getAnnotationAtPath(diff, path), [diff, path]);
  return useMemo(() => getAnnotationColor(userColorManager, annotation), [annotation, userColorManager]);
}
function createMemoryStorage() {
  const DB = /* @__PURE__ */ Object.create(null);
  return {
    getKey(key) {
      return DB[key] || null;
    },
    setKey(key, value) {
      DB[key] = value;
    }
  };
}
function tryParse(val) {
  try {
    return JSON.parse(val);
  } catch (err) {
    return console.warn(`Failed to parse settings: ${err.message}`), null;
  }
}
function createLocalStoreStorage() {
  if (!supportsLocalStorage)
    return createMemoryStorage();
  function getKey(key) {
    const val = localStorage.getItem(key);
    return val === null ? null : tryParse(val);
  }
  return {
    getKey,
    setKey: function(key, nextValue) {
      typeof nextValue > "u" || nextValue === null ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(nextValue));
    }
  };
}
const localStoreStorage = createLocalStoreStorage();
function withLocalStorageSWR(wrappedStore) {
  function getKey(key) {
    return merge(of(localStoreStorage.getKey(key)), wrappedStore.getKey(key).pipe(tap((wrappedStoreValue) => {
      localStoreStorage.setKey(key, wrappedStoreValue);
    }))).pipe(distinctUntilChanged(isEqual$2));
  }
  function setKey2(key, nextValue) {
    return localStoreStorage.setKey(key, nextValue), wrappedStore.setKey(key, nextValue);
  }
  return {
    getKey,
    setKey: setKey2
  };
}
const DEFAULT_STUDIO_CLIENT_OPTIONS = {
  apiVersion: "2025-02-19"
}, versionedClient = (client, apiVersion) => apiVersion ? client.withConfig({
  apiVersion
}) : client;
function createServerStorage({
  client: _client
}) {
  const client = _client.withConfig(DEFAULT_STUDIO_CLIENT_OPTIONS), keyValueLoader = new DataLoader(async (keys) => {
    const keyValuePairs = (await client.request({
      uri: `/users/me/keyvalue/${keys.join(",")}`
    }).catch((error) => (console.error("Error fetching data:", error), Array(keys.length).fill(null)))).reduce((acc, next) => (next?.key && (acc[next.key] = next.value), acc), {});
    return keys.map((key) => keyValuePairs[key] || null);
  });
  return {
    getKey: (key) => keyValueLoader.load(key),
    setKey: (key, nextValue) => client.request({
      method: "PUT",
      uri: "/users/me/keyvalue",
      body: [{
        key,
        value: nextValue
      }]
    }).then((response) => {
      const pair = response[0];
      return keyValueLoader.clear(pair.key), keyValueLoader.prime(pair.key, pair.value), pair.value;
    }, (error) => (console.error("Error setting data:", error), null))
  };
}
function createServerKeyValueStore({
  client
}) {
  const serverStorage = createServerStorage({
    client
  }), events$ = new Subject();
  function getKey(key) {
    return serverStorage.getKey(key);
  }
  function setKey2(key, value) {
    return events$.next({
      type: "optimistic",
      key,
      value
    }), serverStorage.setKey(key, value).then((storedValue) => (events$.next({
      type: "commit",
      key,
      value: storedValue
    }), storedValue));
  }
  return {
    getKey(key) {
      return concat(getKey(key), events$.pipe(filter((event) => event.key === key), map((event) => event.value), distinctUntilChanged(isEqual$2)));
    },
    setKey: setKey2
  };
}
function createKeyValueStore(options) {
  return withLocalStorageSWR(createServerKeyValueStore(options));
}
class CorsOriginError extends Error {
  constructor({
    projectId
  }) {
    super("CorsOriginError"), this.name = "CorsOriginError", this.projectId = projectId;
  }
}
const memStore = {};
function setItem(key, value) {
  supportsLocalStorage ? localStorage[key] = value : memStore[key] = value;
}
function getItem(key) {
  return supportsLocalStorage ? localStorage[key] : memStore[key];
}
function removeItem(key) {
  supportsLocalStorage ? localStorage.removeItem(key) : delete memStore[key];
}
function createBroadcastChannel(namespace) {
  const storageEvents$ = typeof window > "u" ? of() : fromEvent(window, "storage"), storageKey = `__studio_local_storage_messaging_${namespace}`, broadcastedMessages$ = new Subject(), messages$ = merge(broadcastedMessages$, storageEvents$.pipe(filter((event) => event.key === storageKey), map((event) => event.newValue), filter(isNonNullable$3), map((newValue) => JSON.parse(newValue)))).pipe(
    // this is important to ensure all new subscribers get a message on subscribe
    shareReplay(1)
  );
  function broadcast(message) {
    try {
      setItem(storageKey, JSON.stringify(message)), removeItem(storageKey), broadcastedMessages$.next(message);
    } catch {
    }
  }
  return {
    messages: messages$,
    broadcast
  };
}
const GithubRootSvg = styled.svg(({
  theme
}) => {
  const {
    fg
  } = theme.sanity.color.base;
  return css`
    fill: ${fg};
  `;
}), CustomImage = styled.img`
  height: 19px;
  width: 19px;
  object-fit: contain;
`, GithubLogo = () => {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(GithubRootSvg, { width: "1em", height: "1em", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 438.55 438.55", children: /* @__PURE__ */ jsx("path", { d: "M409.13 114.57a218.32 218.32 0 0 0-79.8-79.8Q278.94 5.36 219.27 5.36T109.21 34.77a218.29 218.29 0 0 0-79.8 79.8Q0 165 0 224.63q0 71.67 41.83 128.91t108.06 79.23q7.71 1.43 11.42-2a11.17 11.17 0 0 0 3.69-8.57q0-.86-.14-15.42t-.14-25.41l-6.57 1.14a83.77 83.77 0 0 1-15.85 1 120.73 120.73 0 0 1-19.84-2 44.34 44.34 0 0 1-19.11-8.51 36.23 36.23 0 0 1-12.56-17.6l-2.86-6.57a71.34 71.34 0 0 0-9-14.56q-6.14-8-12.42-10.85l-2-1.43a21 21 0 0 1-3.71-3.43 15.66 15.66 0 0 1-2.57-4q-.86-2 1.43-3.29C61.2 310.42 64 310 68 310l5.71.85q5.71 1.14 14.13 6.85a46.08 46.08 0 0 1 13.85 14.84q6.57 11.71 15.85 17.85t18.7 6.14a81.19 81.19 0 0 0 16.27-1.42 56.78 56.78 0 0 0 12.85-4.29q2.57-19.14 14-29.41a195.49 195.49 0 0 1-29.36-5.13 116.52 116.52 0 0 1-26.83-11.14 76.86 76.86 0 0 1-23-19.13q-9.14-11.42-15-30t-5.8-42.81q0-34.55 22.56-58.82-10.57-26 2-58.24 8.28-2.57 24.55 3.85t23.84 11q7.57 4.56 12.13 7.71a206.2 206.2 0 0 1 109.64 0l10.85-6.85a153.65 153.65 0 0 1 26.26-12.56q15.13-5.71 23.13-3.14 12.84 32.26 2.28 58.24 22.55 24.27 22.56 58.82 0 24.27-5.85 43t-15.12 30a79.82 79.82 0 0 1-23.13 19 116.74 116.74 0 0 1-26.84 11.14 195.29 195.29 0 0 1-29.23 5.07q14.8 12.84 14.81 40.58v60.2a11.37 11.37 0 0 0 3.57 8.56q3.57 3.42 11.28 2 66.24-22 108.07-79.23t41.83-128.91q-.03-59.62-29.43-110.05z" }) }), $[0] = t0) : t0 = $[0], t0;
}, GoogleLogo = () => {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", children: [
    /* @__PURE__ */ jsx("path", { d: "M11 24a13 13 0 0 1 .66-4.08l-7.4-5.66a22.18 22.18 0 0 0 0 19.49l7.4-5.67A13 13 0 0 1 11 24z", fill: "#fbbc05" }),
    /* @__PURE__ */ jsx("path", { d: "M24 11a12.72 12.72 0 0 1 8.1 2.9l6.4-6.4a22 22 0 0 0-34.24 6.75l7.4 5.66A13 13 0 0 1 24 11z", fill: "#ea4335" }),
    /* @__PURE__ */ jsx("path", { d: "M24 37a13 13 0 0 1-12.34-8.92l-7.4 5.66A21.93 21.93 0 0 0 24 46a21 21 0 0 0 14.33-5.48l-7-5.44A13.59 13.59 0 0 1 24 37zm-12.35-8.93l-7.4 5.67 7.4-5.66z", fill: "#34a853" }),
    /* @__PURE__ */ jsx("path", { d: "M44.5 20H24v8.5h11.8a9.91 9.91 0 0 1-4.49 6.58l7 5.44C42.37 36.76 45 31.17 45 24a18.25 18.25 0 0 0-.5-4z", fill: "#4285f4" })
  ] }), $[0] = t0) : t0 = $[0], t0;
};
function CustomLogo(props2) {
  const $ = c(3), {
    provider
  } = props2;
  let t0;
  return $[0] !== provider.logo || $[1] !== provider.name ? (t0 = provider.logo ? /* @__PURE__ */ jsx(CustomImage, { src: provider.logo, alt: `Logo for ${provider.name}` }) : void 0, $[0] = provider.logo, $[1] = provider.name, $[2] = t0) : t0 = $[2], t0;
}
const providerLogos = {
  google: GoogleLogo,
  github: GithubLogo
  // sanity: () => <SanityMonogram data-sanity-icon="" />,
};
async function getProviders({
  client,
  mode,
  providers: customProviders = []
}) {
  if (mode === "replace" && Array.isArray(customProviders))
    return customProviders;
  const {
    providers
  } = await client.request({
    uri: "/auth/providers"
  });
  return typeof customProviders == "function" ? customProviders(providers) : customProviders.length === 0 ? providers : mode === "replace" ? customProviders : providers.filter((official) => customProviders.some((provider) => provider.url !== official.url)).concat(customProviders);
}
function createHrefForProvider({
  loginMethod = "dual",
  projectId,
  url,
  redirectPath
}) {
  const params = new URLSearchParams();
  return params.set("origin", `${window.location.origin}${redirectPath}`), params.set("projectId", projectId), loginMethod === "token" ? params.set("withSid", "true") : params.set("type", loginMethod), `${url}?${params}`;
}
function createLoginComponent({
  getClient: getClient2,
  loginMethod,
  redirectOnSingle,
  ...providerOptions
}) {
  const useClient2 = createHookFromObservableFactory(getClient2);
  function LoginComponent(t0) {
    const $ = c(24);
    let projectId, props2;
    $[0] !== t0 ? ({
      projectId,
      ...props2
    } = t0, $[0] = t0, $[1] = projectId, $[2] = props2) : (projectId = $[1], props2 = $[2]);
    const redirectPath = props2.redirectPath || props2.basePath || "/", [providers, setProviders] = useState(null), [error, setError] = useState(null);
    if (error)
      throw error;
    const [client] = useClient2();
    let t1, t2;
    $[3] !== client ? (t1 = () => {
      client && getProviders({
        client,
        ...providerOptions
      }).then(setProviders).catch(setError);
    }, t2 = [client], $[3] = client, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2);
    let t3;
    $[6] !== projectId || $[7] !== providers || $[8] !== redirectPath ? (t3 = redirectOnSingle && providers?.length === 1 && providers?.[0] && createHrefForProvider({
      loginMethod,
      projectId,
      url: providers[0].url,
      redirectPath
    }), $[6] = projectId, $[7] = providers, $[8] = redirectPath, $[9] = t3) : t3 = $[9];
    const redirectUrlForRedirectOnSingle = t3, loading = !providers || redirectUrlForRedirectOnSingle;
    let t4, t5;
    if ($[10] !== redirectUrlForRedirectOnSingle ? (t4 = () => {
      redirectUrlForRedirectOnSingle && (window.location.href = redirectUrlForRedirectOnSingle);
    }, t5 = [redirectUrlForRedirectOnSingle], $[10] = redirectUrlForRedirectOnSingle, $[11] = t4, $[12] = t5) : (t4 = $[11], t5 = $[12]), useEffect(t4, t5), loading) {
      let t62;
      return $[13] === Symbol.for("react.memo_cache_sentinel") ? (t62 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[13] = t62) : t62 = $[13], t62;
    }
    let t6;
    $[14] === Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(Heading, { align: "center", size: 1, children: "Choose login provider" }), $[14] = t6) : t6 = $[14];
    let t7;
    if ($[15] !== projectId || $[16] !== providers || $[17] !== redirectPath) {
      let t82;
      $[19] !== projectId || $[20] !== redirectPath ? (t82 = (provider, index) => /* @__PURE__ */ jsx(Button, { as: "a", icon: providerLogos[provider.name] || /* @__PURE__ */ jsx(CustomLogo, { provider }), href: createHrefForProvider({
        loginMethod,
        projectId,
        url: provider.url,
        redirectPath
      }), mode: "ghost", size: "large", text: provider.title }, `${provider.url}_${index}`), $[19] = projectId, $[20] = redirectPath, $[21] = t82) : t82 = $[21], t7 = providers.map(t82), $[15] = projectId, $[16] = providers, $[17] = redirectPath, $[18] = t7;
    } else
      t7 = $[18];
    let t8;
    return $[22] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      t6,
      /* @__PURE__ */ jsx(Stack, { space: 2, children: t7 })
    ] }), $[22] = t7, $[23] = t8) : t8 = $[23], t8;
  }
  return LoginComponent;
}
const sidPattern = /sid=([^&]{20,})&?/;
function consumeSessionId() {
  if (typeof window > "u" || typeof window.location != "object")
    return null;
  const hash2 = window.location.hash, [, sidParam] = hash2.match(sidPattern) || [];
  if (!sidParam)
    return null;
  const newHash = hash2.replace(sidPattern, ""), newUrl = new URL(window.location.href);
  return newUrl.hash = newHash.length > 1 ? newHash : "", history.replaceState(null, "", newUrl), sidParam;
}
let sessionId$1 = consumeSessionId();
const getSessionId$1 = () => {
  const id2 = sessionId$1;
  return id2 && (sessionId$1 = null), id2;
};
function isAuthStore(maybeStore) {
  return isRecord$4(maybeStore) && "state" in maybeStore && isRecord$4(maybeStore.state) && "subscribe" in maybeStore.state && typeof maybeStore.state.subscribe == "function";
}
function isCookielessCompatibleLoginMethod(loginMethod) {
  return ["dual", "token"].includes(loginMethod);
}
const getStorageKey = (projectId) => {
  if (!projectId) throw new Error("Invalid project id");
  return `__studio_auth_token_${projectId}`;
}, getHashToken = () => {
  if (typeof window > "u" || typeof window.location != "object")
    return null;
  const tokenPattern = /token=([^&]{32,})&?/, [, tokenParam] = window.location.hash.match(tokenPattern) || [];
  if (!tokenParam)
    return null;
  const newHash = window.location.hash.replace(tokenPattern, ""), newUrl = new URL(window.location.href);
  return newUrl.hash = newHash.length > 1 ? newHash : "", history.replaceState(null, "", newUrl), tokenParam;
}, getStoredToken = (projectId) => {
  try {
    const item = getItem(getStorageKey(projectId));
    if (!item) return null;
    const {
      token
    } = JSON.parse(item);
    return token && typeof token == "string" ? token : null;
  } catch (err) {
    return console.error(err), null;
  }
}, getToken = (projectId) => {
  const storedToken = getStoredToken(projectId), hashToken = getHashToken();
  return hashToken && (!storedToken || hashToken !== storedToken) ? (saveToken({
    token: hashToken,
    projectId
  }), hashToken) : storedToken || null;
}, clearToken = (projectId) => {
  try {
    removeItem(getStorageKey(projectId));
  } catch (err) {
    console.error("Failed to clear auth token from storage:", err);
  }
}, saveToken = ({
  token,
  projectId
}) => {
  try {
    setItem(getStorageKey(projectId), JSON.stringify({
      token,
      time: (/* @__PURE__ */ new Date()).toISOString()
    }));
  } catch (err) {
    console.error("Failed to save auth token to storage:", err);
  }
}, getCurrentUser = async (client, broadcastToken) => {
  try {
    const user = await client.request({
      uri: "/users/me",
      tag: "users.get-current"
    });
    return typeof user?.id == "string" ? user : null;
  } catch (err) {
    if (err.statusCode === 401)
      return clearToken(client.config().projectId || ""), broadcastToken(null), null;
    if (await client.request({
      uri: "/ping",
      withCredentials: !1,
      tag: "cors-check"
    }).then(
      () => !0,
      // Request succeeded, so likely the CORS origin is disallowed
      () => !1
      // Request failed, so likely a network error of some kind
    ))
      throw new CorsOriginError({
        projectId: client.config()?.projectId
      });
    if (err.isNetworkError && !err.message && err.request && err.request.url) {
      const host = new URL(err.request.url).host;
      throw new Error(`Unknown network error attempting to reach ${host}`);
    }
    throw err;
  }
};
function _createAuthStore({
  clientFactory: clientFactoryOption,
  projectId,
  dataset,
  apiHost,
  loginMethod = "dual",
  ...providerOptions
}) {
  const {
    broadcast,
    messages
  } = createBroadcastChannel(`dual_mode_auth_${projectId}`), clientFactory = clientFactoryOption ?? createClient, token$ = messages.pipe(startWith(isCookielessCompatibleLoginMethod(loginMethod) ? getToken(projectId) : null)), hostOptions = {};
  apiHost ? hostOptions.apiHost = apiHost : typeof __SANITY_STAGING__ < "u" && __SANITY_STAGING__ === !0 && (hostOptions.apiHost = "https://api.sanity.work");
  const state$ = token$.pipe(
    // // see above
    // debounce(() => firstMessage),
    map((token) => clientFactory({
      projectId,
      dataset,
      apiVersion: "2021-06-07",
      useCdn: !1,
      ...token ? {
        token
      } : {
        withCredentials: !0
      },
      perspective: "raw",
      requestTagPrefix: "sanity.studio",
      ignoreBrowserTokenWarning: !0,
      allowReconfigure: !1,
      ...hostOptions
    })),
    switchMap((client) => defer(async () => {
      const currentUser = await getCurrentUser(client, broadcast);
      return {
        currentUser,
        client,
        authenticated: !!currentUser
      };
    })),
    distinctUntilChanged((prev, next) => (
      // Only notify subscribers if the the currentUser object has changed.
      // Using isEqual is OK since the currentUser object being a small data structure.
      isEqual$2(prev.currentUser, next.currentUser)
    )),
    shareReplay(1)
  );
  async function handleCallbackUrl() {
    const sessionId2 = getSessionId$1();
    if (!sessionId2) {
      broadcast(loginMethod === "cookie" ? null : getToken(projectId));
      return;
    }
    const requestClient = clientFactory({
      projectId,
      dataset,
      useCdn: !0,
      withCredentials: !0,
      apiVersion: "2021-06-07",
      requestTagPrefix: "sanity.studio",
      ...hostOptions
    });
    let currentUser;
    if ((loginMethod === "dual" || loginMethod === "cookie") && (currentUser = await getCurrentUser(requestClient, broadcast)), currentUser || loginMethod === "cookie") {
      broadcast(null);
      return;
    }
    const token = await tradeSessionForToken(requestClient, sessionId2);
    broadcast(token ?? null);
  }
  async function tradeSessionForToken(client, sessionId2) {
    const {
      token
    } = await client.request({
      method: "GET",
      uri: "/auth/fetch",
      query: {
        sid: sessionId2
      },
      tag: "auth.fetch-token"
    });
    return saveToken({
      token,
      projectId
    }), token;
  }
  async function logout() {
    const token = getToken(projectId), requestClient = clientFactory({
      projectId,
      dataset,
      useCdn: !0,
      ...token ? {
        token
      } : {
        withCredentials: !0
      },
      apiVersion: "2021-06-07",
      requestTagPrefix: "sanity.studio",
      ...hostOptions
    });
    clearToken(projectId), await requestClient.request({
      uri: "/auth/logout",
      method: "POST"
    }), broadcast(null);
  }
  const LoginComponent = createLoginComponent({
    ...providerOptions,
    getClient: () => state$.pipe(map((state) => state.client)),
    loginMethod
  });
  return {
    handleCallbackUrl,
    token: token$,
    state: state$,
    LoginComponent,
    logout
  };
}
function hash(value) {
  return typeof value != "object" || value === null ? `${value}` : JSON.stringify(Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b, "en")).map(([k, v]) => [k, hash(v)])));
}
const createAuthStore = memoize$1(_createAuthStore, hash);
function createMockAuthStore({
  client,
  currentUser = null
}) {
  return {
    state: of({
      authenticated: !0,
      client,
      currentUser
    })
  };
}
function getProviderTitle(provider) {
  if (provider === "google")
    return "Google";
  if (provider === "github")
    return "GitHub";
  if (provider === "sanity")
    return "Sanity";
  if (provider?.startsWith("saml-"))
    return "SAML/SSO";
}
const onOnline$ = typeof window > "u" ? of({}) : fromEvent(window, "online"), onOffline$ = typeof window > "u" ? of({}) : fromEvent(window, "offline"), expBackoff = (retryCount) => Math.pow(2, retryCount) * 100, CONNECTING = {
  type: "connecting"
}, _callback = observableCallback(), onRetry$ = _callback[0], onRetry = _callback[1], createErrorStatus = ({
  error,
  isOffline,
  attemptNo,
  retryAt
}) => ({
  type: "error",
  error,
  attemptNo,
  isOffline,
  retryAt
});
function createConnectionStatusStore({
  bifur
}) {
  return {
    connectionStatus$: merge(bifur.heartbeats, onOffline$.pipe(mergeMapTo(throwError(new Error("The browser went offline"))))).pipe(map((ts) => ({
      type: "connected",
      lastHeartbeat: ts
    })), catchWithCount((error, successiveErrorsCount, caught) => {
      const timeUntilRetry = Math.min(24e4, expBackoff(successiveErrorsCount)), retryAt = new Date((/* @__PURE__ */ new Date()).getTime() + timeUntilRetry), expiry$ = timer(retryAt), isOffline = !navigator.onLine, initialErrorStatus = createErrorStatus({
        error,
        retryAt,
        isOffline,
        attemptNo: successiveErrorsCount
      }), triggerRetry$ = NEVER.pipe(takeUntil(isOffline ? onOnline$ : merge(expiry$, onOnline$, onRetry$)));
      return concat(of(initialErrorStatus), triggerRetry$.pipe(take(1)), caught);
    }), startWith(CONNECTING))
  };
}
function isBlockType(type) {
  return type.type ? isBlockType(type.type) : type.name === "block";
}
function isArrayOfObjectsFieldMember(member) {
  return member.kind === "field" && member.field.schemaType.jsonType === "array";
}
const IGNORE_KEYS = ["_key", "_type", "_weak"];
function isEmptyItem(value) {
  return Object.keys(value).every((key) => IGNORE_KEYS.includes(key));
}
function isPlainObject(obj) {
  return obj !== null && typeof obj == "object" && obj.constructor === Object;
}
function isSchemaType$3(obj) {
  return !(typeof obj != "object" || !obj || !("jsonType" in obj) || typeof obj.jsonType != "string" || !("name" in obj) || typeof obj.name != "string");
}
function identity$1(t) {
  return t;
}
function createImmutableReconcile({
  decorator = identity$1
} = {}) {
  const immutableReconcile2 = decorator(function(prev, curr) {
    if (prev === curr || prev === null || typeof prev != "object" || typeof curr != "object") return curr;
    if (Array.isArray(prev) && Array.isArray(curr)) {
      if (prev.length !== curr.length) return curr;
      const reconciled2 = curr.map((item, index) => immutableReconcile2(prev[index], item));
      return reconciled2.every((item, index) => item === prev[index]) ? prev : reconciled2;
    }
    if (isSchemaType$3(prev) || isSchemaType$3(curr) || !isPlainObject(prev) || !isPlainObject(curr)) return curr;
    const prevObj = prev, currObj = curr, reconciled = {};
    let changed = !1;
    const enumerableKeys = new Set(Object.keys(currObj));
    for (const key of Object.getOwnPropertyNames(currObj))
      if (key in prevObj) {
        const reconciledValue = immutableReconcile2(prevObj[key], currObj[key]);
        enumerableKeys.has(key) ? reconciled[key] = reconciledValue : Object.defineProperty(reconciled, key, {
          value: reconciledValue,
          enumerable: !1
        }), changed = changed || reconciledValue !== prevObj[key];
      } else
        enumerableKeys.has(key) ? reconciled[key] = currObj[key] : Object.defineProperty(reconciled, key, {
          value: currObj[key],
          enumerable: !1
        }), changed = !0;
    for (const key of Object.getOwnPropertyNames(prevObj))
      if (!(key in currObj)) {
        changed = !0;
        break;
      }
    return changed ? reconciled : prev;
  });
  return immutableReconcile2;
}
const immutableReconcile = createImmutableReconcile();
function PresenceProvider(props2) {
  const $ = c(3);
  let t0;
  return $[0] !== props2.children || $[1] !== props2.presence ? (t0 = /* @__PURE__ */ jsx(PresenceContext.Provider, { value: props2.presence, children: props2.children }), $[0] = props2.children, $[1] = props2.presence, $[2] = t0) : t0 = $[2], t0;
}
PresenceProvider.displayName = "PresenceProvider";
function useFormFieldPresence() {
  const ctx = useContext(PresenceContext);
  if (!ctx)
    throw new Error("Form context not provided");
  return ctx;
}
function useChildPresence(path, inclusive) {
  const presence = useFormFieldPresence(), prev = useRef(presence), next = immutableReconcile(prev.current, presence.filter((item) => startsWith(path, item.path) && inclusive));
  return prev.current = next, next;
}
function useFormBuilder() {
  const formBuilder = useContext(FormBuilderContext);
  if (!formBuilder)
    throw new Error("FormBuilder: missing context value");
  return formBuilder;
}
const getIcon = (level) => level === "error" ? /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) : level === "warning" ? /* @__PURE__ */ jsx(WarningOutlineIcon, {}) : /* @__PURE__ */ jsx(InfoOutlineIcon, {}), IconText = styled(Text$1)(({
  theme
}) => css`
    &[data-info] {
      color: ${theme.sanity.color.muted.primary.enabled.fg};
    }

    &[data-warning] {
      color: ${theme.sanity.color.muted.caution.enabled.fg};
    }

    &[data-error] {
      color: ${theme.sanity.color.muted.critical.enabled.fg};
    }
  `);
function DefaultMarkers(props2) {
  const $ = c(10), {
    markers,
    validation: validation2,
    renderCustomMarkers
  } = props2, {
    CustomMarkers
  } = useFormBuilder().__internal.components;
  if (markers.length === 0 && validation2.length === 0)
    return null;
  let t0;
  $[0] !== validation2 ? (t0 = validation2.length > 0 && validation2.map((t12, index) => {
    const {
      message,
      level
    } = t12;
    return /* @__PURE__ */ jsxs(Flex, { children: [
      /* @__PURE__ */ jsx(Box, { marginRight: 2, marginBottom: index + 1 === validation2.length ? 0 : 2, children: /* @__PURE__ */ jsx(IconText, { size: 1, "data-error": level === "error" ? "" : void 0, "data-warning": level === "warning" ? "" : void 0, "data-info": level === "info" ? "" : void 0, children: getIcon(level) }) }),
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: message || "Error" }) })
    ] }, `validationItem-${index}`);
  }), $[0] = validation2, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== CustomMarkers || $[3] !== markers || $[4] !== renderCustomMarkers || $[5] !== validation2.length ? (t1 = markers.length > 0 && /* @__PURE__ */ jsxs(Box, { marginTop: validation2.length > 0 ? 3 : 0, children: [
    renderCustomMarkers && renderCustomMarkers(markers),
    !renderCustomMarkers && /* @__PURE__ */ jsx(CustomMarkers, { markers })
  ] }), $[2] = CustomMarkers, $[3] = markers, $[4] = renderCustomMarkers, $[5] = validation2.length, $[6] = t1) : t1 = $[6];
  let t2;
  return $[7] !== t0 || $[8] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t0,
    t1
  ] }), $[7] = t0, $[8] = t1, $[9] = t2) : t2 = $[9], t2;
}
function ValidationProvider(props2) {
  const $ = c(3);
  let t0;
  return $[0] !== props2.children || $[1] !== props2.validation ? (t0 = /* @__PURE__ */ jsx(ValidationContext.Provider, { value: props2.validation, children: props2.children }), $[0] = props2.children, $[1] = props2.validation, $[2] = t0) : t0 = $[2], t0;
}
function useValidationMarkers() {
  const ctx = useContext(ValidationContext);
  if (!ctx)
    throw new Error("Form context not provided");
  return ctx;
}
function useChildValidation(path, t0) {
  const $ = c(7), inclusive = t0 === void 0 ? !1 : t0, validation2 = useValidationMarkers();
  let t1, t2;
  if ($[0] !== inclusive || $[1] !== path || $[2] !== validation2) {
    let t3;
    $[4] !== inclusive || $[5] !== path ? (t3 = (item) => startsWith(path, item.path) && (inclusive || !isEqual$3(path, item.path)), $[4] = inclusive, $[5] = path, $[6] = t3) : t3 = $[6], t2 = validation2.filter(t3).map(_temp$2E), $[0] = inclusive, $[1] = path, $[2] = validation2, $[3] = t2;
  } else
    t2 = $[3];
  return t1 = t2, t1;
}
function _temp$2E(marker) {
  return {
    message: marker.message,
    level: marker.level,
    path: marker.path
  };
}
const NONEXISTENT_PATH = ["@@_NONEXISTENT_PATH_@@"];
function useMemberValidation(member) {
  const prev = useRef(null), memberValidation = member?.validation && member.validation.length > 0 ? member.validation : EMPTY_ARRAY$A, childValidation = useChildValidation(member?.path || NONEXISTENT_PATH), validation2 = useMemo(() => member?.schemaType && isBlockType(member?.schemaType) ? memberValidation : memberValidation.concat(childValidation), [childValidation, member, memberValidation]), [hasError, hasWarning, hasInfo] = useMemo(() => [validation2.filter((v) => v.level === "error").length > 0, validation2.filter((v_0) => v_0.level === "warning").length > 0, validation2.filter((v_1) => v_1.level === "info").length > 0], [validation2]), reconciled = immutableReconcile(prev.current, validation2);
  return prev.current = reconciled, useMemo(() => ({
    validation: reconciled,
    hasError,
    hasWarning,
    hasInfo
  }), [reconciled, hasError, hasWarning, hasInfo]);
}
function usePortableTextMarkers(path) {
  const $ = c(5), ctx = useContext(PortableTextMarkersContext);
  if (!ctx)
    throw new Error("Form context not provided");
  let t0, t1;
  if ($[0] !== ctx || $[1] !== path) {
    let t2;
    $[3] !== path ? (t2 = (m) => isEqual$3(m.path, path), $[3] = path, $[4] = t2) : t2 = $[4], t1 = ctx.filter(t2), $[0] = ctx, $[1] = path, $[2] = t1;
  } else
    t1 = $[2];
  return t0 = t1, t0;
}
const AddedVersion = defineEvent({
  name: "Version Document Added to Release ",
  version: 1,
  description: "User added a document to a release"
}), CreatedRelease = defineEvent({
  name: "Release Created",
  version: 1,
  description: "User created a release"
});
defineEvent({
  name: "Release Updated",
  version: 1,
  description: "User updated a release"
});
const DeletedRelease = defineEvent({
  name: "Release Deleted",
  version: 1,
  description: "User deleted a release"
}), PublishedRelease = defineEvent({
  name: "Release Published",
  version: 1,
  description: "User published a release"
}), ScheduledRelease = defineEvent({
  name: "Release Scheduled",
  version: 1,
  description: "User scheduled a release"
}), UnscheduledRelease = defineEvent({
  name: "Release Unscheduled",
  version: 1,
  description: "User unscheduled a release"
}), ArchivedRelease = defineEvent({
  name: "Release Archived",
  version: 1,
  description: "User archived a release"
}), UnarchivedRelease = defineEvent({
  name: "Release Unarchived",
  version: 1,
  description: "User unarchived a release"
}), RevertRelease = defineEvent({
  name: "Release Reverted",
  version: 1,
  description: "User reverted a release"
});
function usePerspective() {
  const context = useContext(PerspectiveContext);
  if (!context)
    throw new Error("usePerspective must be used within a PerspectiveProvider");
  return context;
}
function useDataset() {
  return useSource().dataset;
}
function useProjectId$1() {
  return useSource().projectId;
}
const RELEASES_STUDIO_CLIENT_OPTIONS = {
  apiVersion: "v2025-02-19"
}, isReleasePerspective = (perspective) => !!Array.isArray(perspective), INITIAL_VALUE$5 = {
  data: [],
  error: null,
  loading: !0
}, observableCache = /* @__PURE__ */ new Map(), swr$2 = createSWR({
  maxSize: 100
});
function useDocumentVersions(props2) {
  const {
    documentId
  } = props2, publishedId = getPublishedId(documentId), dataset = useDataset(), projectId = useProjectId$1(), documentPreviewStore = useDocumentPreviewStore(), [results, setResults] = useState(INITIAL_VALUE$5), observable = useMemo(() => getOrCreateDocumentVersionsObservable({
    documentPreviewStore,
    publishedId,
    projectId,
    dataset
  }), [dataset, documentPreviewStore, projectId, publishedId]);
  return useEffect(() => {
    const subscription = observable.subscribe((result) => {
      setResults(result);
    });
    return () => subscription.unsubscribe();
  }, [observable]), results;
}
function getOrCreateDocumentVersionsObservable(options) {
  const {
    documentPreviewStore,
    projectId,
    dataset,
    publishedId,
    params = void 0
  } = options, cacheKey = `${projectId}-${dataset}-${publishedId}`, cachedObservable = observableCache.get(cacheKey);
  if (cachedObservable)
    return cachedObservable;
  const newObservable = documentPreviewStore.unstable_observeDocumentIdSet(`sanity::versionOf("${publishedId}")`, params, {
    apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
  }).pipe(swr$2(cacheKey), map$1(({
    value
  }) => ({
    data: value.documentIds,
    error: null,
    loading: !1
  })), catchError$1((error) => of({
    error,
    data: [],
    loading: !1
  })), finalize(() => {
    observableCache.delete(cacheKey);
  }), shareReplay$1({
    refCount: !0,
    bufferSize: 1
  }));
  return observableCache.set(cacheKey, newObservable), newObservable;
}
const RELEASE_DOCUMENT_TYPE = "system.release", RELEASE_DOCUMENTS_PATH = "_.releases", PATH_ID_PREFIX = `${RELEASE_DOCUMENTS_PATH}.`;
function getReleaseIdFromReleaseDocumentId(releaseDocumentId) {
  if (!releaseDocumentId.startsWith(PATH_ID_PREFIX))
    throw new Error(`Release document ID was ${releaseDocumentId} but should start with ${RELEASE_DOCUMENTS_PATH}`);
  return releaseDocumentId.slice(PATH_ID_PREFIX.length);
}
function sortReleases(releases2 = []) {
  return [...releases2].sort((a, b) => {
    if (a.metadata.releaseType === "undecided" && b.metadata.releaseType !== "undecided")
      return -1;
    if (a.metadata.releaseType !== "undecided" && b.metadata.releaseType === "undecided")
      return 1;
    if (a.metadata.releaseType === "undecided" && b.metadata.releaseType === "undecided")
      return new Date(b._createdAt).getTime() - new Date(a._createdAt).getTime();
    if (a.metadata.releaseType === "scheduled" && b.metadata.releaseType === "scheduled") {
      const aPublishAt = a.publishAt || a.metadata.intendedPublishAt;
      if (!aPublishAt)
        return 1;
      const bPublishAt = b.publishAt || b.metadata.intendedPublishAt;
      return bPublishAt ? new Date(bPublishAt).getTime() - new Date(aPublishAt).getTime() : -1;
    }
    return a.metadata.releaseType === "asap" && b.metadata.releaseType !== "asap" ? 1 : a.metadata.releaseType !== "asap" && b.metadata.releaseType === "asap" ? -1 : a.metadata.releaseType === "asap" && b.metadata.releaseType === "asap" ? new Date(b._createdAt).getTime() - new Date(a._createdAt).getTime() : 0;
  });
}
const DRAFTS = ["drafts"], PUBLISHED = ["published"], EMPTY$5 = [];
function getReleasesPerspectiveStack({
  selectedPerspectiveName,
  releases: releases2,
  excludedPerspectives
}) {
  if (!selectedPerspectiveName)
    return DRAFTS;
  if (selectedPerspectiveName === "published")
    return PUBLISHED;
  const sorted = sortReleases(releases2).map((release) => getReleaseIdFromReleaseDocumentId(release._id)), selectedIndex = sorted.indexOf(selectedPerspectiveName);
  return selectedIndex === -1 ? EMPTY$5 : sorted.slice(selectedIndex).concat(DRAFTS_FOLDER).filter((name) => !excludedPerspectives.includes(name));
}
const LATEST = "drafts", DEFAULT_RELEASE_TYPE$1 = "asap", ARCHIVED_RELEASE_STATES = ["archived", "published"], RELEASE_TYPES_TONES = {
  asap: {
    tone: "caution"
  },
  scheduled: {
    tone: "suggest"
  },
  undecided: {
    tone: "neutral"
  }
}, getFetchQuery = (releaseIds) => {
  const getSafeKey = (id2) => `release_${id2.replaceAll("-", "_")}`;
  return releaseIds.reduce(({
    subquery: accSubquery,
    projection: accProjection
  }, releaseId) => {
    const bundleId = getReleaseIdFromReleaseDocumentId(releaseId), safeId = getSafeKey(bundleId), subquery = `${accSubquery}"${safeId}": *[sanity::partOfRelease("${bundleId}")]{_updatedAt, "docId": string::split(_id, ".")[2] } | order(_updatedAt desc),`, projection = `${accProjection}"${releaseId}": {
              "updatedAt": ${safeId}[0]._updatedAt,
              "documentIds": ${safeId}[].docId,
            },`;
    return {
      subquery,
      projection
    };
  }, {
    subquery: "",
    projection: ""
  });
}, createReleaseMetadataAggregator = (client) => {
  const aggregatorFetch$ = (releaseIds, isInitialLoad = !1) => {
    if (!releaseIds?.length || !client) return of({
      data: null,
      error: null,
      loading: !1
    });
    const {
      subquery: queryAllDocumentsInReleases,
      projection: projectionToBundleMetadata
    } = getFetchQuery(releaseIds), fetchData$ = client.observable.fetch(`{${queryAllDocumentsInReleases}}{${projectionToBundleMetadata}}`, {}, {
      tag: "release-docs.fetch"
    }).pipe(switchMap$1((releaseDocumentIdResponse) => of({
      data: Object.entries(releaseDocumentIdResponse).reduce((existing, el) => {
        const [releaseId, metadata] = el;
        return {
          ...existing,
          [releaseId]: {
            ...metadata,
            documentCount: metadata.documentIds?.length || 0
          }
        };
      }, {}),
      error: null,
      loading: !1
    })), catchError$1((error) => (console.error("Failed to fetch release metadata", error), of({
      data: null,
      error,
      loading: !1
    }))));
    return iif(() => isInitialLoad, fetchData$.pipe(startWith$1({
      loading: !0,
      data: null,
      error: null
    })), fetchData$);
  }, aggregatorListener$ = (releaseIds) => !releaseIds?.length || !client ? EMPTY$6 : client.observable.listen(`*[(${releaseIds.reduce((accQuery, releaseId, index) => `${accQuery}${index === 0 ? "" : " ||"} sanity::partOfRelease("${releaseId}")`, "")})]`, {}, {
    includeResult: !0,
    includeAllVersions: !0,
    visibility: "query",
    events: ["mutation"],
    tag: "release-docs.listen"
  }).pipe(catchError$1((error) => (console.error("Failed to listen for release metadata", error), EMPTY$6)), bufferTime(1e3), filter$1((entriesArray) => entriesArray.length > 0), switchMap$1((entriesArray) => {
    const mutatedReleaseIds = entriesArray.reduce((accReleaseIds, event) => {
      if ("type" in event && event.type === "mutation") {
        const releaseId = event.documentId.split(".")[1];
        return accReleaseIds.includes(releaseId) ? accReleaseIds : [...accReleaseIds, releaseId];
      }
      return accReleaseIds;
    }, []);
    return mutatedReleaseIds.length ? aggregatorFetch$(mutatedReleaseIds) : EMPTY$6;
  }));
  return (releaseIds) => merge(aggregatorFetch$(releaseIds, !0), aggregatorListener$(releaseIds));
};
function createReleasesSet(releases2) {
  return (releases2 ?? []).reduce((acc, bundle) => (acc.set(bundle._id, bundle), acc), /* @__PURE__ */ new Map());
}
function releasesReducer(state, action) {
  switch (action.type) {
    case "LOADING_STATE_CHANGED":
      return {
        ...state,
        state: action.payload.loading ? "loading" : "loaded",
        error: action.payload.error
      };
    case "RELEASES_SET": {
      const releasesById = createReleasesSet(action.payload);
      return {
        ...state,
        releases: releasesById
      };
    }
    default:
      return state;
  }
}
const SORT_FIELD$2 = "_createdAt", SORT_ORDER$2 = "desc", QUERY_FILTER = `_type=="${RELEASE_DOCUMENT_TYPE}" && _id in path("${RELEASE_DOCUMENTS_PATH}.*")`, DEFAULT_RELEASE_TYPE = "undecided", QUERY_PROJECTION$2 = `{
  _id,
  _type,
  _rev,
  _createdAt,
  _updatedAt,
  state,
  finalDocumentStates,
  publishAt,
  publishedAt,
  "metadata": coalesce(metadata, {
    "title": "",
    "releaseType": "${DEFAULT_RELEASE_TYPE}",
  }),
  // Content Lake initially encoded non-error states as {error: {message: ""}}. This projection
  // ensures the error field only appears if the document has a non-empty error message.
  ...select(
    length(error.message) > 0 => { error },
    {}
  ),
}`, QUERY_SORT_ORDER$2 = `order(${SORT_FIELD$2} ${SORT_ORDER$2})`, QUERY$1 = `*[${QUERY_FILTER}] ${QUERY_PROJECTION$2} | ${QUERY_SORT_ORDER$2}`, INITIAL_STATE$b = {
  releases: /* @__PURE__ */ new Map(),
  state: "initialising"
};
function createReleaseStore(context) {
  const {
    client
  } = context, dispatch$ = new Subject(), fetchPending$ = new BehaviorSubject(!1);
  function dispatch(action) {
    dispatch$.next(action);
  }
  const listFetch$ = of({
    action: {
      type: "LOADING_STATE_CHANGED",
      payload: {
        loading: !0,
        error: void 0
      }
    }
  }).pipe(
    // Ignore invocations while the list fetch is pending.
    filter$1(() => !fetchPending$.value),
    tap$1(() => fetchPending$.next(!0)),
    concatWith(listenQuery(client, QUERY$1, {}, {
      tag: "releases.listen"
    }).pipe(tap$1(() => fetchPending$.next(!1)), map((releases2) => ({
      response: releases2
    })))),
    catchError$1((error) => of({
      action: {
        type: "LOADING_STATE_CHANGED",
        payload: {
          loading: !1,
          error
        }
      }
    })),
    switchMap$1((entry) => "action" in entry ? of(entry.action) : of({
      type: "RELEASES_SET",
      payload: entry.response
    }, {
      type: "LOADING_STATE_CHANGED",
      payload: {
        loading: !1,
        error: void 0
      }
    }))
  ), state$ = concat(merge(listFetch$, dispatch$)).pipe(filter$1((action) => typeof action < "u"), scan$1((state, action) => releasesReducer(state, action), INITIAL_STATE$b), startWith(INITIAL_STATE$b), shareReplay$1(1)), errorCount$ = state$.pipe(releaseStoreErrorCount(), shareReplay$1(1)), getMetadataStateForSlugs$ = createReleaseMetadataAggregator(client);
  return {
    state$,
    errorCount$,
    getMetadataStateForSlugs$,
    dispatch
  };
}
function releaseStoreErrorCount() {
  return pipe(switchMap$1(({
    releases: releases2
  }) => from(releases2.values()).pipe(filter$1((release) => release.state === "active"), filter$1((release) => typeof release.error < "u"), count())), distinctUntilChanged());
}
function useReleasesStore() {
  const $ = c(5), resourceCache = useResourceCache(), workspace = useWorkspace(), previewStore = useDocumentPreviewStore(), studioClient = useClient(RELEASES_STUDIO_CLIENT_OPTIONS);
  let t0, releaseStore;
  return $[0] !== previewStore || $[1] !== resourceCache || $[2] !== studioClient || $[3] !== workspace ? (releaseStore = resourceCache.get({
    dependencies: [workspace, previewStore],
    namespace: "ReleasesStore"
  }) || createReleaseStore({
    client: studioClient
  }), resourceCache.set({
    dependencies: [workspace, previewStore],
    namespace: "ReleasesStore",
    value: releaseStore
  }), $[0] = previewStore, $[1] = resourceCache, $[2] = studioClient, $[3] = workspace, $[4] = releaseStore) : releaseStore = $[4], t0 = releaseStore, t0;
}
function useActiveReleases() {
  const $ = c(8), {
    state$,
    dispatch
  } = useReleasesStore(), state = useObservable(state$);
  let t0, t1;
  $[0] !== state.releases ? (t1 = sortReleases(Array.from(state.releases.values()).filter(_temp$2D)).reverse(), $[0] = state.releases, $[1] = t1) : t1 = $[1], t0 = t1;
  const releasesAsArray = t0;
  let t2;
  const t3 = state.error;
  let t4;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t4 = ["loading", "initialising"], $[2] = t4) : t4 = $[2];
  const t5 = t4.includes(state.state);
  let t6;
  return $[3] !== dispatch || $[4] !== releasesAsArray || $[5] !== state.error || $[6] !== t5 ? (t6 = {
    data: releasesAsArray,
    dispatch,
    error: t3,
    loading: t5
  }, $[3] = dispatch, $[4] = releasesAsArray, $[5] = state.error, $[6] = t5, $[7] = t6) : t6 = $[7], t2 = t6, t2;
}
function _temp$2D(release) {
  return !ARCHIVED_RELEASE_STATES.includes(release.state);
}
const orderedReleaseTypes$1 = ["asap", "scheduled", "undecided"], useDocumentVersionTypeSortedList = (t0) => {
  const $ = c(9), {
    documentId
  } = t0, {
    data: releases2
  } = useActiveReleases();
  let t1;
  $[0] !== documentId ? (t1 = {
    documentId
  }, $[0] = documentId, $[1] = t1) : t1 = $[1];
  const {
    data: documentVersions
  } = useDocumentVersions(t1);
  let t2;
  if ($[2] !== documentVersions || $[3] !== releases2) {
    let t32;
    $[5] !== documentVersions ? (t32 = (t42) => {
      const {
        _id
      } = t42;
      return documentVersions.some((id2) => getVersionFromId(id2) === getReleaseIdFromReleaseDocumentId(_id));
    }, $[5] = documentVersions, $[6] = t32) : t32 = $[6], t2 = releases2.filter(t32).sort(_temp$2C), $[2] = documentVersions, $[3] = releases2, $[4] = t2;
  } else
    t2 = $[4];
  const sortedDocumentList = t2;
  let t3, t4;
  return $[7] !== sortedDocumentList ? (t4 = {
    sortedDocumentList
  }, $[7] = sortedDocumentList, $[8] = t4) : t4 = $[8], t3 = t4, t3;
};
function _temp$2C(releasesList, compareReleasesList) {
  if (releasesList.metadata.releaseType === "scheduled" && compareReleasesList.metadata.releaseType === "scheduled") {
    const aPublishAt = releasesList.publishAt || releasesList.metadata.intendedPublishAt;
    if (!aPublishAt)
      return -1;
    const bPublishAt = compareReleasesList.publishAt || compareReleasesList.metadata.intendedPublishAt;
    return bPublishAt ? new Date(aPublishAt).getTime() - new Date(bPublishAt).getTime() : 1;
  }
  return orderedReleaseTypes$1.indexOf(releasesList.metadata.releaseType) - orderedReleaseTypes$1.indexOf(compareReleasesList.metadata.releaseType);
}
const releaseTypes = ["asap", "scheduled", "undecided"];
function isReleaseType(maybeReleaseType) {
  return typeof maybeReleaseType == "string" && releaseTypes.includes(maybeReleaseType);
}
function isReleaseDocument(doc) {
  return typeof doc == "object" && doc !== null && "_type" in doc && doc._type === RELEASE_DOCUMENT_TYPE;
}
const createBundleId = customAlphabet("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", 8);
function createReleaseId() {
  return `${RELEASE_DOCUMENTS_PATH}.r${createBundleId()}`;
}
function getPublishDateFromRelease(release) {
  const dateString = release.publishedAt || release.publishAt || release.metadata.intendedPublishAt;
  return dateString ? new Date(dateString) : null;
}
function formatRelativeLocalePublishDate(release) {
  const publishDate = getPublishDateFromRelease(release);
  return publishDate ? formatRelativeLocale(publishDate, /* @__PURE__ */ new Date()) : "";
}
function isPublishedPerspective(perspective) {
  return perspective === "published";
}
function isDraftPerspective(perspective) {
  return perspective === LATEST;
}
function isReleaseScheduledOrScheduling(release) {
  return release.metadata.releaseType === "scheduled" && (release.state === "scheduled" || release.state === "scheduling");
}
const getReleaseDefaults = () => ({
  _id: createReleaseId(),
  metadata: {
    title: "",
    description: "",
    releaseType: DEFAULT_RELEASE_TYPE$1
  }
});
function isNotArchivedRelease(release) {
  return release.state !== "archived";
}
const useIsReleaseActive = () => {
  const $ = c(2), {
    selectedPerspective
  } = usePerspective();
  let t0;
  return $[0] !== selectedPerspective ? (t0 = !isPublishedPerspective(selectedPerspective) && (isDraftPerspective(selectedPerspective) || isReleaseDocument(selectedPerspective) && selectedPerspective.state === "active"), $[0] = selectedPerspective, $[1] = t0) : t0 = $[1], t0;
}, useOnlyHasVersions = (t0) => {
  const $ = c(4), {
    documentId
  } = t0;
  let t1;
  $[0] !== documentId ? (t1 = {
    documentId
  }, $[0] = documentId, $[1] = t1) : t1 = $[1];
  const {
    data: documentVersions
  } = useDocumentVersions(t1);
  let t2;
  return $[2] !== documentVersions ? (t2 = documentVersions && documentVersions.length > 0 && !documentVersions.some(_temp$2B), $[2] = documentVersions, $[3] = t2) : t2 = $[3], t2;
};
function _temp$2B(version) {
  return !isVersionId(version);
}
function useSetPerspective() {
  const $ = c(2), router = useRouter();
  let t0;
  return $[0] !== router ? (t0 = (releaseId) => {
    router.navigate({
      stickyParams: {
        excludedPerspectives: null,
        perspective: releaseId === "drafts" ? "" : releaseId
      }
    });
  }, $[0] = router, $[1] = t0) : t0 = $[1], t0;
}
function useReleasesUpsell() {
  return useContext(ReleasesUpsellContext) || FALLBACK_CONTEXT_VALUE$2;
}
const FALLBACK_CONTEXT_VALUE$2 = {
  upsellDialogOpen: !1,
  mode: "default",
  onReleaseLimitReached: () => null,
  guardWithReleaseLimitUpsell: async () => {
  },
  telemetryLogs: {
    dialogSecondaryClicked: () => null,
    dialogPrimaryClicked: () => null,
    panelViewed: () => null,
    panelDismissed: () => null,
    panelPrimaryClicked: () => null,
    panelSecondaryClicked: () => null
  }
};
function prepareVersionReferences(obj) {
  if (isReference$1(obj)) {
    const isStrengthenOnPublish = typeof obj._strengthenOnPublish < "u", isSchemaMandatedWeakReference = obj._strengthenOnPublish?.weak === !0;
    return isStrengthenOnPublish && !isSchemaMandatedWeakReference ? omit(obj, ["_weak"]) : obj;
  }
  return typeof obj != "object" || !obj ? obj : Array.isArray(obj) ? obj.map(prepareVersionReferences) : Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, prepareVersionReferences(value)]));
}
const isErrorWithDetails = (error) => typeof error == "object" && error !== null && "details" in error && typeof error.details == "object", isReleaseLimitError = (error) => isErrorWithDetails(error) && error.details?.type === "releaseLimitExceededError";
function createReleaseOperationsStore(options) {
  const {
    client,
    onReleaseLimitReached
  } = options, handleReleaseLimitError = (action, opts) => action.catch((error) => {
    throw !opts?.dryRun && isReleaseLimitError(error) && onReleaseLimitReached(error.details.limit || 0), error;
  }), handleCreateRelease = (release, opts) => handleReleaseLimitError(client.releases.create({
    releaseId: getReleaseIdFromReleaseDocumentId(release._id),
    metadata: release.metadata
  }, opts), opts), handleUpdateRelease = async (release, opts) => {
    const releaseId = getReleaseIdFromReleaseDocumentId(release._id), unsetKeys = Object.entries(release).filter(([_, value]) => value === void 0).map(([key]) => `metadata.${key}`);
    return handleReleaseLimitError(client.releases.edit({
      releaseId,
      patch: {
        set: {
          metadata: release.metadata
        },
        unset: unsetKeys
      }
    }, opts), opts);
  }, handlePublishRelease = (releaseId, opts) => handleReleaseLimitError(client.releases.publish({
    releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
  }, opts), opts);
  return {
    archive: (releaseId, opts) => client.releases.archive({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
    }, opts),
    unarchive: (releaseId, opts) => handleReleaseLimitError(client.releases.unarchive({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
    }, opts), opts),
    schedule: (releaseId, publishAt, opts) => handleReleaseLimitError(client.releases.schedule({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId),
      publishAt: publishAt.toISOString()
    }, opts), opts),
    unschedule: (releaseId, opts) => handleReleaseLimitError(client.releases.unschedule({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
    }, opts), opts),
    createRelease: handleCreateRelease,
    updateRelease: handleUpdateRelease,
    publishRelease: handlePublishRelease,
    deleteRelease: (releaseId, opts) => client.releases.delete({
      releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
    }, opts),
    revertRelease: async (revertReleaseId, releaseDocuments, releaseMetadata, revertType) => {
      await handleCreateRelease({
        _id: revertReleaseId,
        metadata: {
          title: releaseMetadata.title,
          description: releaseMetadata.description,
          releaseType: "asap"
        }
      });
      const versionId = getReleaseIdFromReleaseDocumentId(revertReleaseId), newVersionDocumentActions = releaseDocuments.map((releaseDocument) => ({
        actionType: "sanity.action.document.version.create",
        document: {
          ...releaseDocument,
          _id: getVersionId(releaseDocument._id, versionId)
        },
        publishedId: getPublishedId(releaseDocument._id)
      }));
      await client.action(newVersionDocumentActions), revertType === "immediate" && await handlePublishRelease(revertReleaseId);
    },
    createVersion: async (releaseId, documentId, initialValue, opts) => {
      const document2 = await client.getDocument(documentId);
      if (!document2 && !initialValue)
        throw new Error(`Document with id ${documentId} not found and no initial value provided`);
      const versionDocument = prepareVersionReferences({
        ...document2 || {},
        ...initialValue || {},
        _id: getVersionId(documentId, releaseId)
      });
      return client.createVersion({
        document: versionDocument,
        publishedId: getPublishedId(documentId),
        releaseId
      }, opts);
    },
    discardVersion: (releaseId, documentId, opts) => client.discardVersion({
      releaseId,
      publishedId: getPublishedId(documentId)
    }, !1, opts),
    unpublishVersion: (documentId, opts) => {
      const releaseId = getVersionFromId(documentId);
      if (!releaseId)
        throw new Error(`Release ID not found for document ${documentId}`);
      return client.unpublishVersion({
        releaseId,
        publishedId: getPublishedId(documentId)
      }, opts);
    }
  };
}
function useReleaseOperations() {
  const $ = c(3), studioClient = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), {
    onReleaseLimitReached
  } = useReleasesUpsell();
  let t0, t1;
  return $[0] !== onReleaseLimitReached || $[1] !== studioClient ? (t1 = createReleaseOperationsStore({
    client: studioClient,
    onReleaseLimitReached
  }), $[0] = onReleaseLimitReached, $[1] = studioClient, $[2] = t1) : t1 = $[2], t0 = t1, t0;
}
function useVersionOperations() {
  const $ = c(12), telemetry = useTelemetry(), {
    createVersion,
    discardVersion,
    unpublishVersion
  } = useReleaseOperations(), setPerspective = useSetPerspective();
  let t0;
  $[0] !== createVersion || $[1] !== setPerspective || $[2] !== telemetry ? (t0 = async (releaseId, documentId, initialValue) => {
    const origin = getDocumentVariantType(documentId);
    await createVersion(releaseId, documentId, initialValue), setPerspective(releaseId), telemetry.log(AddedVersion, {
      documentOrigin: origin
    });
  }, $[0] = createVersion, $[1] = setPerspective, $[2] = telemetry, $[3] = t0) : t0 = $[3];
  const handleCreateVersion = t0;
  let t1;
  $[4] !== discardVersion ? (t1 = async (releaseId_0, documentId_0) => discardVersion(releaseId_0, documentId_0), $[4] = discardVersion, $[5] = t1) : t1 = $[5];
  const handleDiscardVersion = t1;
  let t2;
  $[6] !== unpublishVersion ? (t2 = async (documentId_1) => unpublishVersion(documentId_1), $[6] = unpublishVersion, $[7] = t2) : t2 = $[7];
  const handleUnpublishVersion = t2;
  let t3;
  return $[8] !== handleCreateVersion || $[9] !== handleDiscardVersion || $[10] !== handleUnpublishVersion ? (t3 = {
    createVersion: handleCreateVersion,
    discardVersion: handleDiscardVersion,
    unpublishVersion: handleUnpublishVersion
  }, $[8] = handleCreateVersion, $[9] = handleDiscardVersion, $[10] = handleUnpublishVersion, $[11] = t3) : t3 = $[11], t3;
}
const releasesLocaleNamespace = "releases", releasesUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: releasesLocaleNamespace,
  resources: () => import("./_chunks-es/resources2.mjs")
};
function DiscardVersionDialog(props2) {
  const {
    onClose,
    documentId,
    documentType,
    fromPerspective
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: coreT
  } = useTranslation(), {
    discardChanges: discardChanges2
  } = useDocumentOperation(getPublishedId(documentId), documentType), {
    selectedPerspective
  } = usePerspective(), {
    discardVersion
  } = useVersionOperations(), schema2 = useSchema(), toast = useToast(), [isDiscarding, setIsDiscarding] = useState(!1), discardType = isDraftId(documentId) ? "draft" : "release", releaseName = typeof fromPerspective == "string" ? fromPerspective : fromPerspective.metadata.title, schemaType = schema2.get(documentType), handleDiscardVersion = useCallback(async () => {
    if (setIsDiscarding(!0), isVersionId(documentId))
      try {
        await discardVersion(getVersionFromId(documentId) || getReleaseIdFromReleaseDocumentId(selectedPerspective._id), documentId);
      } catch (err) {
        toast.push({
          closable: !0,
          status: "error",
          title: coreT("release.action.discard-version.failure"),
          description: err.message
        });
      }
    else
      discardChanges2.execute();
    setIsDiscarding(!1), onClose();
  }, [documentId, onClose, discardVersion, selectedPerspective, toast, coreT, discardChanges2]);
  return /* @__PURE__ */ jsx(Dialog$1, { id: "discard-version-dialog", header: /* @__PURE__ */ jsx(Translate, { t, i18nKey: `discard-version-dialog.header-${discardType}`, values: {
    releaseTitle: releaseName
  } }), onClose, width: 0, padding: !1, footer: {
    cancelButton: {
      disabled: isDiscarding,
      onClick: onClose
    },
    confirmButton: {
      text: t(`discard-version-dialog.title-${discardType}`),
      onClick: handleDiscardVersion,
      disabled: isDiscarding
    }
  }, children: /* @__PURE__ */ jsxs(Stack, { space: 3, paddingX: 3, marginBottom: 2, children: [
    schemaType ? /* @__PURE__ */ jsx(Preview$1, { value: {
      _id: documentId
    }, schemaType }) : /* @__PURE__ */ jsx(LoadingBlock, {}),
    /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: `discard-version-dialog.description-${discardType}`, values: {
      releaseTitle: releaseName
    } }) }) })
  ] }) });
}
var rawTimeZones = [
  {
    name: "Pacific/Niue",
    alternativeName: "Niue Time",
    group: [
      "Pacific/Niue"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Niue",
    countryCode: "NU",
    mainCities: [
      "Alofi"
    ],
    rawOffsetInMinutes: -660,
    abbreviation: "NUT",
    rawFormat: "-11:00 Niue Time - Alofi"
  },
  {
    name: "Pacific/Midway",
    alternativeName: "Samoa Time",
    group: [
      "Pacific/Midway"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "United States Minor Outlying Islands",
    countryCode: "UM",
    mainCities: [
      "Midway"
    ],
    rawOffsetInMinutes: -660,
    abbreviation: "SST",
    rawFormat: "-11:00 Samoa Time - Midway"
  },
  {
    name: "Pacific/Pago_Pago",
    alternativeName: "Samoa Time",
    group: [
      "Pacific/Pago_Pago",
      "US/Samoa",
      "Pacific/Samoa",
      "Pacific/Midway"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "American Samoa",
    countryCode: "AS",
    mainCities: [
      "Pago Pago"
    ],
    rawOffsetInMinutes: -660,
    abbreviation: "SST",
    rawFormat: "-11:00 Samoa Time - Pago Pago"
  },
  {
    name: "Pacific/Rarotonga",
    alternativeName: "Cook Islands Time",
    group: [
      "Pacific/Rarotonga"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Cook Islands",
    countryCode: "CK",
    mainCities: [
      "Avarua"
    ],
    rawOffsetInMinutes: -600,
    abbreviation: "CKT",
    rawFormat: "-10:00 Cook Islands Time - Avarua"
  },
  {
    name: "America/Adak",
    alternativeName: "Hawaii-Aleutian Time",
    group: [
      "America/Adak",
      "US/Aleutian",
      "America/Atka"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "United States",
    countryCode: "US",
    mainCities: [
      "Adak"
    ],
    rawOffsetInMinutes: -600,
    abbreviation: "HAST",
    rawFormat: "-10:00 Hawaii-Aleutian Time - Adak"
  },
  {
    name: "Pacific/Honolulu",
    alternativeName: "Hawaii-Aleutian Time",
    group: [
      "Pacific/Honolulu",
      "US/Hawaii",
      "Pacific/Johnston"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "United States",
    countryCode: "US",
    mainCities: [
      "Honolulu",
      "East Honolulu",
      "Pearl City",
      "Hilo"
    ],
    rawOffsetInMinutes: -600,
    abbreviation: "HAST",
    rawFormat: "-10:00 Hawaii-Aleutian Time - Honolulu, East Honolulu, Pearl City, Hilo"
  },
  {
    name: "Pacific/Tahiti",
    alternativeName: "Tahiti Time",
    group: [
      "Pacific/Tahiti"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "French Polynesia",
    countryCode: "PF",
    mainCities: [
      "Faaa",
      "Papeete",
      "Punaauia"
    ],
    rawOffsetInMinutes: -600,
    abbreviation: "TAHT",
    rawFormat: "-10:00 Tahiti Time - Faaa, Papeete, Punaauia"
  },
  {
    name: "Pacific/Marquesas",
    alternativeName: "Marquesas Time",
    group: [
      "Pacific/Marquesas"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "French Polynesia",
    countryCode: "PF",
    mainCities: [
      "Marquesas"
    ],
    rawOffsetInMinutes: -570,
    abbreviation: "MART",
    rawFormat: "-09:30 Marquesas Time - Marquesas"
  },
  {
    name: "America/Anchorage",
    alternativeName: "Alaska Time",
    group: [
      "America/Anchorage",
      "America/Juneau",
      "America/Metlakatla",
      "America/Nome",
      "America/Sitka",
      "America/Yakutat",
      "US/Alaska"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "United States",
    countryCode: "US",
    mainCities: [
      "Anchorage",
      "Juneau",
      "Fairbanks",
      "Eagle River"
    ],
    rawOffsetInMinutes: -540,
    abbreviation: "AKST",
    rawFormat: "-09:00 Alaska Time - Anchorage, Juneau, Fairbanks, Eagle River"
  },
  {
    name: "Pacific/Gambier",
    alternativeName: "Gambier Time",
    group: [
      "Pacific/Gambier"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "French Polynesia",
    countryCode: "PF",
    mainCities: [
      "Gambier"
    ],
    rawOffsetInMinutes: -540,
    abbreviation: "GAMT",
    rawFormat: "-09:00 Gambier Time - Gambier"
  },
  {
    name: "America/Los_Angeles",
    alternativeName: "Pacific Time",
    group: [
      "America/Los_Angeles",
      "US/Pacific"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "United States",
    countryCode: "US",
    mainCities: [
      "Los Angeles",
      "San Diego",
      "San Jose",
      "San Francisco"
    ],
    rawOffsetInMinutes: -480,
    abbreviation: "PST",
    rawFormat: "-08:00 Pacific Time - Los Angeles, San Diego, San Jose, San Francisco"
  },
  {
    name: "America/Tijuana",
    alternativeName: "Pacific Time",
    group: [
      "America/Tijuana",
      "Mexico/BajaNorte",
      "America/Ensenada",
      "America/Santa_Isabel"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Mexico",
    countryCode: "MX",
    mainCities: [
      "Tijuana",
      "Mexicali",
      "Ensenada",
      "Rosarito"
    ],
    rawOffsetInMinutes: -480,
    abbreviation: "PST",
    rawFormat: "-08:00 Pacific Time - Tijuana, Mexicali, Ensenada, Rosarito"
  },
  {
    name: "America/Vancouver",
    alternativeName: "Pacific Time",
    group: [
      "America/Vancouver",
      "Canada/Pacific"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Vancouver",
      "Surrey",
      "Okanagan",
      "Victoria"
    ],
    rawOffsetInMinutes: -480,
    abbreviation: "PST",
    rawFormat: "-08:00 Pacific Time - Vancouver, Surrey, Okanagan, Victoria"
  },
  {
    name: "Pacific/Pitcairn",
    alternativeName: "Pitcairn Time",
    group: [
      "Pacific/Pitcairn"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Pitcairn",
    countryCode: "PN",
    mainCities: [
      "Adamstown"
    ],
    rawOffsetInMinutes: -480,
    abbreviation: "PST",
    rawFormat: "-08:00 Pitcairn Time - Adamstown"
  },
  {
    name: "America/Hermosillo",
    alternativeName: "Mexican Pacific Time",
    group: [
      "America/Hermosillo",
      "America/Mazatlan",
      "Mexico/BajaSur"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Mexico",
    countryCode: "MX",
    mainCities: [
      "Hermosillo",
      "Culiac\xE1n",
      "Ciudad Obreg\xF3n",
      "Mazatl\xE1n"
    ],
    rawOffsetInMinutes: -420,
    abbreviation: "GMT-7",
    rawFormat: "-07:00 Mexican Pacific Time - Hermosillo, Culiac\xE1n, Ciudad Obreg\xF3n, Mazatl\xE1n"
  },
  {
    name: "America/Edmonton",
    alternativeName: "Mountain Time",
    group: [
      "America/Cambridge_Bay",
      "America/Edmonton",
      "America/Inuvik",
      "America/Yellowknife",
      "Canada/Mountain"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Calgary",
      "Edmonton",
      "Red Deer",
      "Sherwood Park"
    ],
    rawOffsetInMinutes: -420,
    abbreviation: "MST",
    rawFormat: "-07:00 Mountain Time - Calgary, Edmonton, Red Deer, Sherwood Park"
  },
  {
    name: "America/Ciudad_Juarez",
    alternativeName: "Mountain Time",
    group: [
      "America/Ciudad_Juarez"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Mexico",
    countryCode: "MX",
    mainCities: [
      "Ciudad Ju\xE1rez"
    ],
    rawOffsetInMinutes: -420,
    abbreviation: "MST",
    rawFormat: "-07:00 Mountain Time - Ciudad Ju\xE1rez"
  },
  {
    name: "America/Denver",
    alternativeName: "Mountain Time",
    group: [
      "America/Boise",
      "America/Denver",
      "Navajo",
      "US/Mountain",
      "America/Shiprock"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "United States",
    countryCode: "US",
    mainCities: [
      "Denver",
      "El Paso",
      "Albuquerque",
      "Colorado Springs"
    ],
    rawOffsetInMinutes: -420,
    abbreviation: "MST",
    rawFormat: "-07:00 Mountain Time - Denver, El Paso, Albuquerque, Colorado Springs"
  },
  {
    name: "America/Phoenix",
    alternativeName: "Mountain Time",
    group: [
      "America/Phoenix",
      "US/Arizona",
      "America/Creston"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "United States",
    countryCode: "US",
    mainCities: [
      "Phoenix",
      "Tucson",
      "Mesa",
      "Chandler"
    ],
    rawOffsetInMinutes: -420,
    abbreviation: "MST",
    rawFormat: "-07:00 Mountain Time - Phoenix, Tucson, Mesa, Chandler"
  },
  {
    name: "America/Whitehorse",
    alternativeName: "Yukon Time",
    group: [
      "America/Creston",
      "America/Dawson",
      "America/Dawson_Creek",
      "America/Fort_Nelson",
      "America/Whitehorse",
      "Canada/Yukon"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Whitehorse",
      "Fort St. John",
      "Creston",
      "Dawson"
    ],
    rawOffsetInMinutes: -420,
    abbreviation: "YT",
    rawFormat: "-07:00 Yukon Time - Whitehorse, Fort St. John, Creston, Dawson"
  },
  {
    name: "America/Belize",
    alternativeName: "Central Time",
    group: [
      "America/Belize"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Belize",
    countryCode: "BZ",
    mainCities: [
      "Belize City",
      "San Ignacio",
      "San Pedro",
      "Orange Walk"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Belize City, San Ignacio, San Pedro, Orange Walk"
  },
  {
    name: "America/Chicago",
    alternativeName: "Central Time",
    group: [
      "America/Chicago",
      "America/Indiana/Knox",
      "America/Indiana/Tell_City",
      "America/Menominee",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "US/Central",
      "US/Indiana-Starke",
      "America/Knox_IN"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "United States",
    countryCode: "US",
    mainCities: [
      "Chicago",
      "Houston",
      "San Antonio",
      "Dallas"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Chicago, Houston, San Antonio, Dallas"
  },
  {
    name: "America/Guatemala",
    alternativeName: "Central Time",
    group: [
      "America/Guatemala"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Guatemala",
    countryCode: "GT",
    mainCities: [
      "Guatemala City",
      "Villa Nueva",
      "Mixco",
      "Cob\xE1n"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Guatemala City, Villa Nueva, Mixco, Cob\xE1n"
  },
  {
    name: "America/Managua",
    alternativeName: "Central Time",
    group: [
      "America/Managua"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Nicaragua",
    countryCode: "NI",
    mainCities: [
      "Managua",
      "Le\xF3n",
      "Masaya",
      "Chinandega"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Managua, Le\xF3n, Masaya, Chinandega"
  },
  {
    name: "America/Mexico_City",
    alternativeName: "Central Time",
    group: [
      "America/Bahia_Banderas",
      "America/Chihuahua",
      "America/Merida",
      "America/Mexico_City",
      "America/Monterrey",
      "Mexico/General"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Mexico",
    countryCode: "MX",
    mainCities: [
      "Mexico City",
      "Iztapalapa",
      "Le\xF3n de los Aldama",
      "Puebla"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Mexico City, Iztapalapa, Le\xF3n de los Aldama, Puebla"
  },
  {
    name: "America/Matamoros",
    alternativeName: "Central Time",
    group: [
      "America/Matamoros",
      "America/Ojinaga"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Mexico",
    countryCode: "MX",
    mainCities: [
      "Reynosa",
      "Heroica Matamoros",
      "Nuevo Laredo",
      "Piedras Negras"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Reynosa, Heroica Matamoros, Nuevo Laredo, Piedras Negras"
  },
  {
    name: "America/Costa_Rica",
    alternativeName: "Central Time",
    group: [
      "America/Costa_Rica"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Costa Rica",
    countryCode: "CR",
    mainCities: [
      "San Jos\xE9",
      "Lim\xF3n",
      "San Francisco",
      "Alajuela"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - San Jos\xE9, Lim\xF3n, San Francisco, Alajuela"
  },
  {
    name: "America/El_Salvador",
    alternativeName: "Central Time",
    group: [
      "America/El_Salvador"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "El Salvador",
    countryCode: "SV",
    mainCities: [
      "San Salvador",
      "Soyapango",
      "San Miguel",
      "Santa Ana"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - San Salvador, Soyapango, San Miguel, Santa Ana"
  },
  {
    name: "America/Regina",
    alternativeName: "Central Time",
    group: [
      "America/Regina",
      "America/Swift_Current",
      "Canada/Saskatchewan"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Saskatoon",
      "Regina",
      "Prince Albert",
      "Moose Jaw"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Saskatoon, Regina, Prince Albert, Moose Jaw"
  },
  {
    name: "America/Tegucigalpa",
    alternativeName: "Central Time",
    group: [
      "America/Tegucigalpa"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Honduras",
    countryCode: "HN",
    mainCities: [
      "Tegucigalpa",
      "San Pedro Sula",
      "La Ceiba",
      "Choloma"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Tegucigalpa, San Pedro Sula, La Ceiba, Choloma"
  },
  {
    name: "America/Winnipeg",
    alternativeName: "Central Time",
    group: [
      "America/Rankin_Inlet",
      "America/Resolute",
      "America/Winnipeg",
      "Canada/Central",
      "America/Rainy_River"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Winnipeg",
      "Brandon",
      "Steinbach",
      "Kenora"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "CST",
    rawFormat: "-06:00 Central Time - Winnipeg, Brandon, Steinbach, Kenora"
  },
  {
    name: "Pacific/Easter",
    alternativeName: "Easter Island Time",
    group: [
      "Pacific/Easter",
      "Chile/EasterIsland"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Chile",
    countryCode: "CL",
    mainCities: [
      "Easter"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "EAST",
    rawFormat: "-06:00 Easter Island Time - Easter"
  },
  {
    name: "Pacific/Galapagos",
    alternativeName: "Galapagos Time",
    group: [
      "Pacific/Galapagos"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Ecuador",
    countryCode: "EC",
    mainCities: [
      "Galapagos"
    ],
    rawOffsetInMinutes: -360,
    abbreviation: "GALT",
    rawFormat: "-06:00 Galapagos Time - Galapagos"
  },
  {
    name: "America/Rio_Branco",
    alternativeName: "Acre Time",
    group: [
      "America/Eirunepe",
      "America/Rio_Branco",
      "Brazil/Acre",
      "America/Porto_Acre"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Brazil",
    countryCode: "BR",
    mainCities: [
      "Rio Branco",
      "Cruzeiro do Sul",
      "Senador Guiomard",
      "Sena Madureira"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "ACT",
    rawFormat: "-05:00 Acre Time - Rio Branco, Cruzeiro do Sul, Senador Guiomard, Sena Madureira"
  },
  {
    name: "America/Bogota",
    alternativeName: "Colombia Time",
    group: [
      "America/Bogota"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Colombia",
    countryCode: "CO",
    mainCities: [
      "Bogot\xE1",
      "Cali",
      "Medell\xEDn",
      "Barranquilla"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "COT",
    rawFormat: "-05:00 Colombia Time - Bogot\xE1, Cali, Medell\xEDn, Barranquilla"
  },
  {
    name: "America/Havana",
    alternativeName: "Cuba Time",
    group: [
      "America/Havana",
      "Cuba"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Cuba",
    countryCode: "CU",
    mainCities: [
      "Havana",
      "Santiago de Cuba",
      "Camag\xFCey",
      "Holgu\xEDn"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "CST",
    rawFormat: "-05:00 Cuba Time - Havana, Santiago de Cuba, Camag\xFCey, Holgu\xEDn"
  },
  {
    name: "America/Atikokan",
    alternativeName: "Eastern Time",
    group: [
      "America/Atikokan"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Atikokan"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - Atikokan"
  },
  {
    name: "America/Cancun",
    alternativeName: "Eastern Time",
    group: [
      "America/Cancun"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Mexico",
    countryCode: "MX",
    mainCities: [
      "Canc\xFAn",
      "Chetumal",
      "Playa del Carmen",
      "Cozumel"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - Canc\xFAn, Chetumal, Playa del Carmen, Cozumel"
  },
  {
    name: "America/Grand_Turk",
    alternativeName: "Eastern Time",
    group: [
      "America/Grand_Turk"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Turks and Caicos Islands",
    countryCode: "TC",
    mainCities: [
      "Cockburn Town"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - Cockburn Town"
  },
  {
    name: "America/Cayman",
    alternativeName: "Eastern Time",
    group: [
      "America/Cayman"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Cayman Islands",
    countryCode: "KY",
    mainCities: [
      "George Town",
      "West Bay"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - George Town, West Bay"
  },
  {
    name: "America/Jamaica",
    alternativeName: "Eastern Time",
    group: [
      "America/Jamaica",
      "Jamaica"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Jamaica",
    countryCode: "JM",
    mainCities: [
      "Kingston",
      "New Kingston",
      "Spanish Town",
      "Portmore"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - Kingston, New Kingston, Spanish Town, Portmore"
  },
  {
    name: "America/Nassau",
    alternativeName: "Eastern Time",
    group: [
      "America/Nassau"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Bahamas",
    countryCode: "BS",
    mainCities: [
      "Nassau",
      "Lucaya",
      "Freeport",
      "Killarney"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - Nassau, Lucaya, Freeport, Killarney"
  },
  {
    name: "America/New_York",
    alternativeName: "Eastern Time",
    group: [
      "America/Detroit",
      "America/Indiana/Indianapolis",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Vevay",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/New_York",
      "US/Michigan",
      "US/East-Indiana",
      "America/Indianapolis",
      "America/Fort_Wayne",
      "America/Louisville",
      "US/Eastern"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "United States",
    countryCode: "US",
    mainCities: [
      "New York City",
      "Brooklyn",
      "Queens",
      "Philadelphia"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - New York City, Brooklyn, Queens, Philadelphia"
  },
  {
    name: "America/Panama",
    alternativeName: "Eastern Time",
    group: [
      "America/Panama",
      "America/Atikokan",
      "America/Cayman",
      "America/Coral_Harbour"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Panama",
    countryCode: "PA",
    mainCities: [
      "Panam\xE1",
      "San Miguelito",
      "Juan D\xEDaz",
      "David"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - Panam\xE1, San Miguelito, Juan D\xEDaz, David"
  },
  {
    name: "America/Port-au-Prince",
    alternativeName: "Eastern Time",
    group: [
      "America/Port-au-Prince"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Haiti",
    countryCode: "HT",
    mainCities: [
      "Port-au-Prince",
      "Carrefour",
      "Delmas 73",
      "Port-de-Paix"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - Port-au-Prince, Carrefour, Delmas 73, Port-de-Paix"
  },
  {
    name: "America/Toronto",
    alternativeName: "Eastern Time",
    group: [
      "America/Iqaluit",
      "America/Toronto",
      "America/Pangnirtung",
      "Canada/Eastern",
      "America/Nassau",
      "America/Montreal",
      "America/Nipigon",
      "America/Thunder_Bay"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Toronto",
      "Montr\xE9al",
      "Ottawa",
      "Mississauga"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "EST",
    rawFormat: "-05:00 Eastern Time - Toronto, Montr\xE9al, Ottawa, Mississauga"
  },
  {
    name: "America/Guayaquil",
    alternativeName: "Ecuador Time",
    group: [
      "America/Guayaquil"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Ecuador",
    countryCode: "EC",
    mainCities: [
      "Quito",
      "Guayaquil",
      "Cuenca",
      "Santo Domingo de los Colorados"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "ECT",
    rawFormat: "-05:00 Ecuador Time - Quito, Guayaquil, Cuenca, Santo Domingo de los Colorados"
  },
  {
    name: "America/Lima",
    alternativeName: "Peru Time",
    group: [
      "America/Lima"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Peru",
    countryCode: "PE",
    mainCities: [
      "Lima",
      "Callao",
      "Arequipa",
      "Trujillo"
    ],
    rawOffsetInMinutes: -300,
    abbreviation: "PET",
    rawFormat: "-05:00 Peru Time - Lima, Callao, Arequipa, Trujillo"
  },
  {
    name: "America/Manaus",
    alternativeName: "Amazon Time",
    group: [
      "America/Boa_Vista",
      "America/Campo_Grande",
      "America/Cuiaba",
      "America/Manaus",
      "America/Porto_Velho",
      "Brazil/West"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Brazil",
    countryCode: "BR",
    mainCities: [
      "Manaus",
      "Campo Grande",
      "Cuiab\xE1",
      "Porto Velho"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AMT",
    rawFormat: "-04:00 Amazon Time - Manaus, Campo Grande, Cuiab\xE1, Porto Velho"
  },
  {
    name: "America/St_Kitts",
    alternativeName: "Atlantic Time",
    group: [
      "America/St_Kitts"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Saint Kitts and Nevis",
    countryCode: "KN",
    mainCities: [
      "Basseterre"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Basseterre"
  },
  {
    name: "America/Blanc-Sablon",
    alternativeName: "Atlantic Time",
    group: [
      "America/Blanc-Sablon"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Blanc-Sablon"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Blanc-Sablon"
  },
  {
    name: "America/Montserrat",
    alternativeName: "Atlantic Time",
    group: [
      "America/Montserrat"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Montserrat",
    countryCode: "MS",
    mainCities: [
      "Brades",
      "Plymouth"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Brades, Plymouth"
  },
  {
    name: "America/Barbados",
    alternativeName: "Atlantic Time",
    group: [
      "America/Barbados"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Barbados",
    countryCode: "BB",
    mainCities: [
      "Bridgetown"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Bridgetown"
  },
  {
    name: "America/Port_of_Spain",
    alternativeName: "Atlantic Time",
    group: [
      "America/Port_of_Spain"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Trinidad and Tobago",
    countryCode: "TT",
    mainCities: [
      "Chaguanas",
      "Mon Repos",
      "San Fernando",
      "Port of Spain"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Chaguanas, Mon Repos, San Fernando, Port of Spain"
  },
  {
    name: "America/Martinique",
    alternativeName: "Atlantic Time",
    group: [
      "America/Martinique"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Martinique",
    countryCode: "MQ",
    mainCities: [
      "Fort-de-France",
      "Le Lamentin",
      "Le Robert",
      "Sainte-Marie"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Fort-de-France, Le Lamentin, Le Robert, Sainte-Marie"
  },
  {
    name: "America/St_Lucia",
    alternativeName: "Atlantic Time",
    group: [
      "America/St_Lucia"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Saint Lucia",
    countryCode: "LC",
    mainCities: [
      "Gros Islet",
      "Castries"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Gros Islet, Castries"
  },
  {
    name: "America/St_Barthelemy",
    alternativeName: "Atlantic Time",
    group: [
      "America/St_Barthelemy"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Saint Barthelemy",
    countryCode: "BL",
    mainCities: [
      "Gustavia"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Gustavia"
  },
  {
    name: "America/Halifax",
    alternativeName: "Atlantic Time",
    group: [
      "America/Glace_Bay",
      "America/Goose_Bay",
      "America/Halifax",
      "America/Moncton",
      "Canada/Atlantic"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "Halifax",
      "Moncton",
      "Sydney",
      "Dartmouth"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Halifax, Moncton, Sydney, Dartmouth"
  },
  {
    name: "Atlantic/Bermuda",
    alternativeName: "Atlantic Time",
    group: [
      "Atlantic/Bermuda"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Bermuda",
    countryCode: "BM",
    mainCities: [
      "Hamilton"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Hamilton"
  },
  {
    name: "America/St_Vincent",
    alternativeName: "Atlantic Time",
    group: [
      "America/St_Vincent"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Saint Vincent and the Grenadines",
    countryCode: "VC",
    mainCities: [
      "Kingstown"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Kingstown"
  },
  {
    name: "America/Kralendijk",
    alternativeName: "Atlantic Time",
    group: [
      "America/Kralendijk"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Bonaire, Saint Eustatius and Saba ",
    countryCode: "BQ",
    mainCities: [
      "Kralendijk"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Kralendijk"
  },
  {
    name: "America/Guadeloupe",
    alternativeName: "Atlantic Time",
    group: [
      "America/Guadeloupe"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Guadeloupe",
    countryCode: "GP",
    mainCities: [
      "Les Abymes",
      "Baie-Mahault",
      "Le Gosier",
      "Petit-Bourg"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Les Abymes, Baie-Mahault, Le Gosier, Petit-Bourg"
  },
  {
    name: "America/Marigot",
    alternativeName: "Atlantic Time",
    group: [
      "America/Marigot"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Saint Martin",
    countryCode: "MF",
    mainCities: [
      "Marigot"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Marigot"
  },
  {
    name: "America/Aruba",
    alternativeName: "Atlantic Time",
    group: [
      "America/Aruba"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Aruba",
    countryCode: "AW",
    mainCities: [
      "Oranjestad",
      "Noord",
      "Tanki Leendert",
      "San Nicolas"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Oranjestad, Noord, Tanki Leendert, San Nicolas"
  },
  {
    name: "America/Lower_Princes",
    alternativeName: "Atlantic Time",
    group: [
      "America/Lower_Princes"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Sint Maarten",
    countryCode: "SX",
    mainCities: [
      "Philipsburg"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Philipsburg"
  },
  {
    name: "America/Tortola",
    alternativeName: "Atlantic Time",
    group: [
      "America/Tortola"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "British Virgin Islands",
    countryCode: "VG",
    mainCities: [
      "Road Town"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Road Town"
  },
  {
    name: "America/Dominica",
    alternativeName: "Atlantic Time",
    group: [
      "America/Dominica"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Dominica",
    countryCode: "DM",
    mainCities: [
      "Roseau"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Roseau"
  },
  {
    name: "America/St_Thomas",
    alternativeName: "Atlantic Time",
    group: [
      "America/St_Thomas"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "U.S. Virgin Islands",
    countryCode: "VI",
    mainCities: [
      "Saint Croix",
      "Charlotte Amalie"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Saint Croix, Charlotte Amalie"
  },
  {
    name: "America/Grenada",
    alternativeName: "Atlantic Time",
    group: [
      "America/Grenada"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Grenada",
    countryCode: "GD",
    mainCities: [
      "Saint George's"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Saint George's"
  },
  {
    name: "America/Antigua",
    alternativeName: "Atlantic Time",
    group: [
      "America/Antigua"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Antigua and Barbuda",
    countryCode: "AG",
    mainCities: [
      "Saint John\u2019s"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Saint John\u2019s"
  },
  {
    name: "America/Puerto_Rico",
    alternativeName: "Atlantic Time",
    group: [
      "America/Puerto_Rico",
      "America/Virgin",
      "America/Anguilla",
      "America/Antigua",
      "America/Aruba",
      "America/Blanc-Sablon",
      "America/Curacao",
      "America/Dominica",
      "America/Grenada",
      "America/Guadeloupe",
      "America/Kralendijk",
      "America/Lower_Princes",
      "America/Marigot",
      "America/Montserrat",
      "America/Port_of_Spain",
      "America/St_Barthelemy",
      "America/St_Kitts",
      "America/St_Lucia",
      "America/St_Thomas",
      "America/St_Vincent",
      "America/Tortola"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Puerto Rico",
    countryCode: "PR",
    mainCities: [
      "San Juan",
      "Bayam\xF3n",
      "Carolina",
      "Ponce"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - San Juan, Bayam\xF3n, Carolina, Ponce"
  },
  {
    name: "America/Santo_Domingo",
    alternativeName: "Atlantic Time",
    group: [
      "America/Santo_Domingo"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Dominican Republic",
    countryCode: "DO",
    mainCities: [
      "Santo Domingo",
      "Santiago de los Caballeros",
      "Santo Domingo Oeste",
      "Santo Domingo Este"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Santo Domingo, Santiago de los Caballeros, Santo Domingo Oeste, Santo Domingo Este"
  },
  {
    name: "America/Anguilla",
    alternativeName: "Atlantic Time",
    group: [
      "America/Anguilla"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Anguilla",
    countryCode: "AI",
    mainCities: [
      "The Valley"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - The Valley"
  },
  {
    name: "America/Thule",
    alternativeName: "Atlantic Time",
    group: [
      "America/Thule"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Greenland",
    countryCode: "GL",
    mainCities: [
      "Thule"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Thule"
  },
  {
    name: "America/Curacao",
    alternativeName: "Atlantic Time",
    group: [
      "America/Curacao"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Curacao",
    countryCode: "CW",
    mainCities: [
      "Willemstad"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "AST",
    rawFormat: "-04:00 Atlantic Time - Willemstad"
  },
  {
    name: "America/La_Paz",
    alternativeName: "Bolivia Time",
    group: [
      "America/La_Paz"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Bolivia",
    countryCode: "BO",
    mainCities: [
      "La Paz",
      "Santa Cruz de la Sierra",
      "Cochabamba",
      "Sucre"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "BOT",
    rawFormat: "-04:00 Bolivia Time - La Paz, Santa Cruz de la Sierra, Cochabamba, Sucre"
  },
  {
    name: "America/Santiago",
    alternativeName: "Chile Time",
    group: [
      "America/Santiago",
      "Chile/Continental"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Chile",
    countryCode: "CL",
    mainCities: [
      "Santiago",
      "Puente Alto",
      "Antofagasta",
      "Vi\xF1a del Mar"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "CLT",
    rawFormat: "-04:00 Chile Time - Santiago, Puente Alto, Antofagasta, Vi\xF1a del Mar"
  },
  {
    name: "America/Guyana",
    alternativeName: "Guyana Time",
    group: [
      "America/Guyana"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Guyana",
    countryCode: "GY",
    mainCities: [
      "Georgetown",
      "Linden",
      "New Amsterdam"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "GYT",
    rawFormat: "-04:00 Guyana Time - Georgetown, Linden, New Amsterdam"
  },
  {
    name: "America/Asuncion",
    alternativeName: "Paraguay Time",
    group: [
      "America/Asuncion"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Paraguay",
    countryCode: "PY",
    mainCities: [
      "Asunci\xF3n",
      "Ciudad del Este",
      "San Lorenzo",
      "Capiat\xE1"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "PYT",
    rawFormat: "-04:00 Paraguay Time - Asunci\xF3n, Ciudad del Este, San Lorenzo, Capiat\xE1"
  },
  {
    name: "America/Caracas",
    alternativeName: "Venezuela Time",
    group: [
      "America/Caracas"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Venezuela",
    countryCode: "VE",
    mainCities: [
      "Caracas",
      "Maracaibo",
      "Maracay",
      "Valencia"
    ],
    rawOffsetInMinutes: -240,
    abbreviation: "VET",
    rawFormat: "-04:00 Venezuela Time - Caracas, Maracaibo, Maracay, Valencia"
  },
  {
    name: "America/St_Johns",
    alternativeName: "Newfoundland Time",
    group: [
      "America/St_Johns",
      "Canada/Newfoundland"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Canada",
    countryCode: "CA",
    mainCities: [
      "St. John's",
      "Mount Pearl",
      "Corner Brook",
      "Conception Bay South"
    ],
    rawOffsetInMinutes: -210,
    abbreviation: "NST",
    rawFormat: "-03:30 Newfoundland Time - St. John's, Mount Pearl, Corner Brook, Conception Bay South"
  },
  {
    name: "America/Argentina/Buenos_Aires",
    alternativeName: "Argentina Time",
    group: [
      "America/Argentina/Buenos_Aires",
      "America/Argentina/Catamarca",
      "America/Argentina/Cordoba",
      "America/Argentina/Jujuy",
      "America/Argentina/La_Rioja",
      "America/Argentina/Mendoza",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Salta",
      "America/Argentina/San_Juan",
      "America/Argentina/San_Luis",
      "America/Argentina/Tucuman",
      "America/Argentina/Ushuaia",
      "America/Buenos_Aires",
      "America/Catamarca",
      "America/Argentina/ComodRivadavia",
      "America/Cordoba",
      "America/Rosario",
      "America/Jujuy",
      "America/Mendoza"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Argentina",
    countryCode: "AR",
    mainCities: [
      "Buenos Aires",
      "C\xF3rdoba",
      "Rosario",
      "Mar del Plata"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "ART",
    rawFormat: "-03:00 Argentina Time - Buenos Aires, C\xF3rdoba, Rosario, Mar del Plata"
  },
  {
    name: "America/Sao_Paulo",
    alternativeName: "Brasilia Time",
    group: [
      "America/Araguaina",
      "America/Bahia",
      "America/Belem",
      "America/Fortaleza",
      "America/Maceio",
      "America/Recife",
      "America/Santarem",
      "America/Sao_Paulo",
      "Brazil/East"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Brazil",
    countryCode: "BR",
    mainCities: [
      "S\xE3o Paulo",
      "Rio de Janeiro",
      "Belo Horizonte",
      "Salvador"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "BRT",
    rawFormat: "-03:00 Brasilia Time - S\xE3o Paulo, Rio de Janeiro, Belo Horizonte, Salvador"
  },
  {
    name: "Antarctica/Palmer",
    alternativeName: "Chile Time",
    group: [
      "Antarctica/Palmer",
      "Antarctica/Rothera"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "Antarctica",
    countryCode: "AQ",
    mainCities: [
      "Palmer",
      "Rothera"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "CLT",
    rawFormat: "-03:00 Chile Time - Palmer, Rothera"
  },
  {
    name: "America/Punta_Arenas",
    alternativeName: "Chile Time",
    group: [
      "America/Punta_Arenas"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Chile",
    countryCode: "CL",
    mainCities: [
      "Punta Arenas",
      "Puerto Natales"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "CLT",
    rawFormat: "-03:00 Chile Time - Punta Arenas, Puerto Natales"
  },
  {
    name: "Atlantic/Stanley",
    alternativeName: "Falkland Islands Time",
    group: [
      "Atlantic/Stanley"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Falkland Islands",
    countryCode: "FK",
    mainCities: [
      "Stanley"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "FKST",
    rawFormat: "-03:00 Falkland Islands Time - Stanley"
  },
  {
    name: "America/Cayenne",
    alternativeName: "French Guiana Time",
    group: [
      "America/Cayenne"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "French Guiana",
    countryCode: "GF",
    mainCities: [
      "Cayenne",
      "Matoury",
      "Saint-Laurent-du-Maroni",
      "Kourou"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "GFT",
    rawFormat: "-03:00 French Guiana Time - Cayenne, Matoury, Saint-Laurent-du-Maroni, Kourou"
  },
  {
    name: "America/Miquelon",
    alternativeName: "St. Pierre & Miquelon Time",
    group: [
      "America/Miquelon"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Saint Pierre and Miquelon",
    countryCode: "PM",
    mainCities: [
      "Saint-Pierre"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "PM",
    rawFormat: "-03:00 St. Pierre & Miquelon Time - Saint-Pierre"
  },
  {
    name: "America/Paramaribo",
    alternativeName: "Suriname Time",
    group: [
      "America/Paramaribo"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Suriname",
    countryCode: "SR",
    mainCities: [
      "Paramaribo",
      "Lelydorp"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "SRT",
    rawFormat: "-03:00 Suriname Time - Paramaribo, Lelydorp"
  },
  {
    name: "America/Montevideo",
    alternativeName: "Uruguay Time",
    group: [
      "America/Montevideo"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Uruguay",
    countryCode: "UY",
    mainCities: [
      "Montevideo",
      "Salto",
      "Paysand\xFA",
      "Las Piedras"
    ],
    rawOffsetInMinutes: -180,
    abbreviation: "UYT",
    rawFormat: "-03:00 Uruguay Time - Montevideo, Salto, Paysand\xFA, Las Piedras"
  },
  {
    name: "America/Scoresbysund",
    alternativeName: "East Greenland Time",
    group: [
      "America/Scoresbysund"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Greenland",
    countryCode: "GL",
    mainCities: [
      "Scoresbysund"
    ],
    rawOffsetInMinutes: -120,
    abbreviation: "EGT",
    rawFormat: "-02:00 East Greenland Time - Scoresbysund"
  },
  {
    name: "America/Noronha",
    alternativeName: "Fernando de Noronha Time",
    group: [
      "America/Noronha",
      "Brazil/DeNoronha"
    ],
    continentCode: "SA",
    continentName: "South America",
    countryName: "Brazil",
    countryCode: "BR",
    mainCities: [
      "Noronha"
    ],
    rawOffsetInMinutes: -120,
    abbreviation: "FNT",
    rawFormat: "-02:00 Fernando de Noronha Time - Noronha"
  },
  {
    name: "Atlantic/South_Georgia",
    alternativeName: "South Georgia Time",
    group: [
      "Atlantic/South_Georgia"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "South Georgia and the South Sandwich Islands",
    countryCode: "GS",
    mainCities: [
      "Grytviken"
    ],
    rawOffsetInMinutes: -120,
    abbreviation: "GST",
    rawFormat: "-02:00 South Georgia Time - Grytviken"
  },
  {
    name: "America/Nuuk",
    alternativeName: "West Greenland Time",
    group: [
      "America/Nuuk",
      "America/Godthab"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Greenland",
    countryCode: "GL",
    mainCities: [
      "Nuuk"
    ],
    rawOffsetInMinutes: -120,
    abbreviation: "WGT",
    rawFormat: "-02:00 West Greenland Time - Nuuk"
  },
  {
    name: "Atlantic/Azores",
    alternativeName: "Azores Time",
    group: [
      "Atlantic/Azores"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Portugal",
    countryCode: "PT",
    mainCities: [
      "Ponta Delgada"
    ],
    rawOffsetInMinutes: -60,
    abbreviation: "AZOT",
    rawFormat: "-01:00 Azores Time - Ponta Delgada"
  },
  {
    name: "Atlantic/Cape_Verde",
    alternativeName: "Cape Verde Time",
    group: [
      "Atlantic/Cape_Verde"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Cabo Verde",
    countryCode: "CV",
    mainCities: [
      "Praia",
      "Mindelo",
      "Espargos",
      "Assomada"
    ],
    rawOffsetInMinutes: -60,
    abbreviation: "CVT",
    rawFormat: "-01:00 Cape Verde Time - Praia, Mindelo, Espargos, Assomada"
  },
  {
    name: "Africa/Abidjan",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Abidjan",
      "Iceland",
      "Africa/Accra",
      "Africa/Bamako",
      "Africa/Banjul",
      "Africa/Conakry",
      "Africa/Dakar",
      "Africa/Freetown",
      "Africa/Lome",
      "Africa/Nouakchott",
      "Africa/Ouagadougou",
      "Atlantic/Reykjavik",
      "Atlantic/St_Helena",
      "Africa/Timbuktu"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Ivory Coast",
    countryCode: "CI",
    mainCities: [
      "Abidjan",
      "Abobo",
      "Bouak\xE9",
      "Korhogo"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Abidjan, Abobo, Bouak\xE9, Korhogo"
  },
  {
    name: "Africa/Bamako",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Bamako"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Mali",
    countryCode: "ML",
    mainCities: [
      "Bamako",
      "Sikasso",
      "Koutiala",
      "S\xE9gou"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Bamako, Sikasso, Koutiala, S\xE9gou"
  },
  {
    name: "Africa/Bissau",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Bissau"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Guinea-Bissau",
    countryCode: "GW",
    mainCities: [
      "Bissau",
      "Gab\xFA",
      "Bafat\xE1"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Bissau, Gab\xFA, Bafat\xE1"
  },
  {
    name: "Africa/Conakry",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Conakry"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Guinea",
    countryCode: "GN",
    mainCities: [
      "Conakry",
      "Camayenne",
      "Nz\xE9r\xE9kor\xE9",
      "Kankan"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Conakry, Camayenne, Nz\xE9r\xE9kor\xE9, Kankan"
  },
  {
    name: "Africa/Dakar",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Dakar"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Senegal",
    countryCode: "SN",
    mainCities: [
      "Dakar",
      "Pikine",
      "Touba",
      "Thi\xE8s"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Dakar, Pikine, Touba, Thi\xE8s"
  },
  {
    name: "America/Danmarkshavn",
    alternativeName: "Greenwich Mean Time",
    group: [
      "America/Danmarkshavn"
    ],
    continentCode: "NA",
    continentName: "North America",
    countryName: "Greenland",
    countryCode: "GL",
    mainCities: [
      "Danmarkshavn"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Danmarkshavn"
  },
  {
    name: "Europe/Isle_of_Man",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Europe/Isle_of_Man"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Isle of Man",
    countryCode: "IM",
    mainCities: [
      "Douglas"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Douglas"
  },
  {
    name: "Europe/Dublin",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Europe/Dublin",
      "Eire"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Ireland",
    countryCode: "IE",
    mainCities: [
      "Dublin",
      "South Dublin",
      "Cork",
      "Limerick"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Dublin, South Dublin, Cork, Limerick"
  },
  {
    name: "Africa/Freetown",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Freetown"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Sierra Leone",
    countryCode: "SL",
    mainCities: [
      "Freetown",
      "Bo",
      "Kenema",
      "Koidu"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Freetown, Bo, Kenema, Koidu"
  },
  {
    name: "Atlantic/St_Helena",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Atlantic/St_Helena"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Saint Helena",
    countryCode: "SH",
    mainCities: [
      "Jamestown"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Jamestown"
  },
  {
    name: "Africa/Accra",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Accra"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Ghana",
    countryCode: "GH",
    mainCities: [
      "Kumasi",
      "Accra",
      "Tamale",
      "Takoradi"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Kumasi, Accra, Tamale, Takoradi"
  },
  {
    name: "Africa/Lome",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Lome"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Togo",
    countryCode: "TG",
    mainCities: [
      "Lom\xE9",
      "Sokod\xE9",
      "Kara",
      "Atakpam\xE9"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Lom\xE9, Sokod\xE9, Kara, Atakpam\xE9"
  },
  {
    name: "Europe/London",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Europe/London",
      "GB",
      "GB-Eire",
      "Europe/Guernsey",
      "Europe/Isle_of_Man",
      "Europe/Jersey",
      "Europe/Belfast"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "United Kingdom",
    countryCode: "GB",
    mainCities: [
      "London",
      "Birmingham",
      "Liverpool",
      "Glasgow"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - London, Birmingham, Liverpool, Glasgow"
  },
  {
    name: "Africa/Monrovia",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Monrovia"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Liberia",
    countryCode: "LR",
    mainCities: [
      "Monrovia",
      "Gbarnga",
      "Buchanan",
      "Ganta"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Monrovia, Gbarnga, Buchanan, Ganta"
  },
  {
    name: "Africa/Nouakchott",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Nouakchott"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Mauritania",
    countryCode: "MR",
    mainCities: [
      "Nouakchott",
      "Nouadhibou",
      "Kiffa",
      "Dar Naim"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Nouakchott, Nouadhibou, Kiffa, Dar Naim"
  },
  {
    name: "Africa/Ouagadougou",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Ouagadougou"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Burkina Faso",
    countryCode: "BF",
    mainCities: [
      "Ouagadougou",
      "Bobo-Dioulasso",
      "Koudougou",
      "Saaba"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Ouagadougou, Bobo-Dioulasso, Koudougou, Saaba"
  },
  {
    name: "Atlantic/Reykjavik",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Atlantic/Reykjavik",
      "Iceland"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Iceland",
    countryCode: "IS",
    mainCities: [
      "Reykjav\xEDk",
      "K\xF3pavogur",
      "Hafnarfj\xF6r\xF0ur",
      "Reykjanesb\xE6r"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Reykjav\xEDk, K\xF3pavogur, Hafnarfj\xF6r\xF0ur, Reykjanesb\xE6r"
  },
  {
    name: "Europe/Jersey",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Europe/Jersey"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Jersey",
    countryCode: "JE",
    mainCities: [
      "Saint Helier"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Saint Helier"
  },
  {
    name: "Europe/Guernsey",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Europe/Guernsey"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Guernsey",
    countryCode: "GG",
    mainCities: [
      "Saint Peter Port"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Saint Peter Port"
  },
  {
    name: "Africa/Banjul",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Banjul"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Gambia",
    countryCode: "GM",
    mainCities: [
      "Serekunda",
      "Brikama",
      "Bununka Kunda",
      "Sukuta"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Serekunda, Brikama, Bununka Kunda, Sukuta"
  },
  {
    name: "Africa/Sao_Tome",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Africa/Sao_Tome"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Sao Tome and Principe",
    countryCode: "ST",
    mainCities: [
      "S\xE3o Tom\xE9"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - S\xE3o Tom\xE9"
  },
  {
    name: "Antarctica/Troll",
    alternativeName: "Greenwich Mean Time",
    group: [
      "Antarctica/Troll"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "Antarctica",
    countryCode: "AQ",
    mainCities: [
      "Troll"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "GMT",
    rawFormat: "+00:00 Greenwich Mean Time - Troll"
  },
  {
    name: "Africa/Casablanca",
    alternativeName: "Western European Time",
    group: [
      "Africa/Casablanca"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Morocco",
    countryCode: "MA",
    mainCities: [
      "Casablanca",
      "Rabat",
      "Fes",
      "Tangier"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "WET",
    rawFormat: "+00:00 Western European Time - Casablanca, Rabat, Fes, Tangier"
  },
  {
    name: "Africa/El_Aaiun",
    alternativeName: "Western European Time",
    group: [
      "Africa/El_Aaiun"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Western Sahara",
    countryCode: "EH",
    mainCities: [
      "Laayoune",
      "Dakhla",
      "Boujdour"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "WET",
    rawFormat: "+00:00 Western European Time - Laayoune, Dakhla, Boujdour"
  },
  {
    name: "Atlantic/Canary",
    alternativeName: "Western European Time",
    group: [
      "Atlantic/Canary"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Spain",
    countryCode: "ES",
    mainCities: [
      "Las Palmas de Gran Canaria",
      "Santa Cruz de Tenerife",
      "La Laguna",
      "Telde"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "WET",
    rawFormat: "+00:00 Western European Time - Las Palmas de Gran Canaria, Santa Cruz de Tenerife, La Laguna, Telde"
  },
  {
    name: "Europe/Lisbon",
    alternativeName: "Western European Time",
    group: [
      "Atlantic/Madeira",
      "Europe/Lisbon",
      "Portugal"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Portugal",
    countryCode: "PT",
    mainCities: [
      "Lisbon",
      "Porto",
      "Amadora",
      "Braga"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "WET",
    rawFormat: "+00:00 Western European Time - Lisbon, Porto, Amadora, Braga"
  },
  {
    name: "Atlantic/Faroe",
    alternativeName: "Western European Time",
    group: [
      "Atlantic/Faroe",
      "Atlantic/Faeroe"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Faroe Islands",
    countryCode: "FO",
    mainCities: [
      "T\xF3rshavn"
    ],
    rawOffsetInMinutes: 0,
    abbreviation: "WET",
    rawFormat: "+00:00 Western European Time - T\xF3rshavn"
  },
  {
    name: "Africa/Windhoek",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Windhoek"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Namibia",
    countryCode: "NA",
    mainCities: [
      "Windhoek",
      "Rundu",
      "Walvis Bay",
      "Swakopmund"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CAT",
    rawFormat: "+01:00 Central Africa Time - Windhoek, Rundu, Walvis Bay, Swakopmund"
  },
  {
    name: "Africa/Algiers",
    alternativeName: "Central European Time",
    group: [
      "Africa/Algiers"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Algeria",
    countryCode: "DZ",
    mainCities: [
      "Algiers",
      "Oran",
      "Constantine",
      "Annaba"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Algiers, Oran, Constantine, Annaba"
  },
  {
    name: "Europe/Amsterdam",
    alternativeName: "Central European Time",
    group: [
      "Europe/Amsterdam"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "The Netherlands",
    countryCode: "NL",
    mainCities: [
      "Amsterdam",
      "Rotterdam",
      "The Hague",
      "Utrecht"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Amsterdam, Rotterdam, The Hague, Utrecht"
  },
  {
    name: "Europe/Andorra",
    alternativeName: "Central European Time",
    group: [
      "Europe/Andorra"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Andorra",
    countryCode: "AD",
    mainCities: [
      "Andorra la Vella",
      "les Escaldes"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Andorra la Vella, les Escaldes"
  },
  {
    name: "Europe/Belgrade",
    alternativeName: "Central European Time",
    group: [
      "Europe/Belgrade",
      "Europe/Ljubljana",
      "Europe/Podgorica",
      "Europe/Sarajevo",
      "Europe/Skopje",
      "Europe/Zagreb"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Serbia",
    countryCode: "RS",
    mainCities: [
      "Belgrade",
      "Ni\u0161",
      "Novi Sad",
      "Zemun"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Belgrade, Ni\u0161, Novi Sad, Zemun"
  },
  {
    name: "Europe/Berlin",
    alternativeName: "Central European Time",
    group: [
      "Europe/Berlin",
      "Europe/Busingen",
      "Arctic/Longyearbyen",
      "Europe/Copenhagen",
      "Europe/Oslo",
      "Europe/Stockholm",
      "Atlantic/Jan_Mayen"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Germany",
    countryCode: "DE",
    mainCities: [
      "Berlin",
      "Hamburg",
      "Munich",
      "K\xF6ln"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Berlin, Hamburg, Munich, K\xF6ln"
  },
  {
    name: "Europe/Bratislava",
    alternativeName: "Central European Time",
    group: [
      "Europe/Bratislava"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Slovakia",
    countryCode: "SK",
    mainCities: [
      "Bratislava",
      "Ko\u0161ice",
      "Nitra",
      "Pre\u0161ov"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Bratislava, Ko\u0161ice, Nitra, Pre\u0161ov"
  },
  {
    name: "Europe/Brussels",
    alternativeName: "Central European Time",
    group: [
      "Europe/Brussels",
      "Europe/Amsterdam",
      "Europe/Luxembourg"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Belgium",
    countryCode: "BE",
    mainCities: [
      "Brussels",
      "Antwerpen",
      "Gent",
      "Charleroi"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Brussels, Antwerpen, Gent, Charleroi"
  },
  {
    name: "Europe/Budapest",
    alternativeName: "Central European Time",
    group: [
      "Europe/Budapest"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Hungary",
    countryCode: "HU",
    mainCities: [
      "Budapest",
      "Debrecen",
      "Szeged",
      "Miskolc"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Budapest, Debrecen, Szeged, Miskolc"
  },
  {
    name: "Europe/Copenhagen",
    alternativeName: "Central European Time",
    group: [
      "Europe/Copenhagen"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Denmark",
    countryCode: "DK",
    mainCities: [
      "Copenhagen",
      "\xC5rhus",
      "Odense",
      "Aalborg"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Copenhagen, \xC5rhus, Odense, Aalborg"
  },
  {
    name: "Europe/Gibraltar",
    alternativeName: "Central European Time",
    group: [
      "Europe/Gibraltar"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Gibraltar",
    countryCode: "GI",
    mainCities: [
      "Gibraltar"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Gibraltar"
  },
  {
    name: "Europe/Ljubljana",
    alternativeName: "Central European Time",
    group: [
      "Europe/Ljubljana"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Slovenia",
    countryCode: "SI",
    mainCities: [
      "Ljubljana",
      "Maribor",
      "Kranj",
      "Celje"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Ljubljana, Maribor, Kranj, Celje"
  },
  {
    name: "Arctic/Longyearbyen",
    alternativeName: "Central European Time",
    group: [
      "Arctic/Longyearbyen"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Svalbard and Jan Mayen",
    countryCode: "SJ",
    mainCities: [
      "Longyearbyen"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Longyearbyen"
  },
  {
    name: "Europe/Luxembourg",
    alternativeName: "Central European Time",
    group: [
      "Europe/Luxembourg"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Luxembourg",
    countryCode: "LU",
    mainCities: [
      "Luxembourg",
      "Esch-sur-Alzette",
      "Dudelange"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Luxembourg, Esch-sur-Alzette, Dudelange"
  },
  {
    name: "Europe/Madrid",
    alternativeName: "Central European Time",
    group: [
      "Africa/Ceuta",
      "Europe/Madrid"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Spain",
    countryCode: "ES",
    mainCities: [
      "Madrid",
      "Barcelona",
      "Valencia",
      "Sevilla"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Madrid, Barcelona, Valencia, Sevilla"
  },
  {
    name: "Europe/Monaco",
    alternativeName: "Central European Time",
    group: [
      "Europe/Monaco"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Monaco",
    countryCode: "MC",
    mainCities: [
      "Monaco",
      "Monte-Carlo"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Monaco, Monte-Carlo"
  },
  {
    name: "Europe/Oslo",
    alternativeName: "Central European Time",
    group: [
      "Europe/Oslo",
      "Atlantic/Jan_Mayen"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Norway",
    countryCode: "NO",
    mainCities: [
      "Oslo",
      "Bergen",
      "Trondheim",
      "Stavanger"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Oslo, Bergen, Trondheim, Stavanger"
  },
  {
    name: "Europe/Paris",
    alternativeName: "Central European Time",
    group: [
      "Europe/Paris",
      "Europe/Monaco"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "France",
    countryCode: "FR",
    mainCities: [
      "Paris",
      "Marseille",
      "Lyon",
      "Toulouse"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Paris, Marseille, Lyon, Toulouse"
  },
  {
    name: "Europe/Podgorica",
    alternativeName: "Central European Time",
    group: [
      "Europe/Podgorica"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Montenegro",
    countryCode: "ME",
    mainCities: [
      "Podgorica",
      "Nik\u0161i\u0107",
      "Herceg Novi",
      "Pljevlja"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Podgorica, Nik\u0161i\u0107, Herceg Novi, Pljevlja"
  },
  {
    name: "Europe/Prague",
    alternativeName: "Central European Time",
    group: [
      "Europe/Prague",
      "Europe/Bratislava"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Czechia",
    countryCode: "CZ",
    mainCities: [
      "Prague",
      "Brno",
      "Ostrava",
      "Pilsen"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Prague, Brno, Ostrava, Pilsen"
  },
  {
    name: "Europe/Rome",
    alternativeName: "Central European Time",
    group: [
      "Europe/Rome",
      "Europe/San_Marino",
      "Europe/Vatican"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Italy",
    countryCode: "IT",
    mainCities: [
      "Rome",
      "Milan",
      "Naples",
      "Turin"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Rome, Milan, Naples, Turin"
  },
  {
    name: "Europe/San_Marino",
    alternativeName: "Central European Time",
    group: [
      "Europe/San_Marino"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "San Marino",
    countryCode: "SM",
    mainCities: [
      "San Marino"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - San Marino"
  },
  {
    name: "Europe/Malta",
    alternativeName: "Central European Time",
    group: [
      "Europe/Malta"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Malta",
    countryCode: "MT",
    mainCities: [
      "San Pawl il-Ba\u0127ar",
      "Birkirkara",
      "Mosta",
      "Sliema"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - San Pawl il-Ba\u0127ar, Birkirkara, Mosta, Sliema"
  },
  {
    name: "Europe/Sarajevo",
    alternativeName: "Central European Time",
    group: [
      "Europe/Sarajevo"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Bosnia and Herzegovina",
    countryCode: "BA",
    mainCities: [
      "Sarajevo",
      "Banja Luka",
      "Zenica",
      "Tuzla"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Sarajevo, Banja Luka, Zenica, Tuzla"
  },
  {
    name: "Europe/Skopje",
    alternativeName: "Central European Time",
    group: [
      "Europe/Skopje"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "North Macedonia",
    countryCode: "MK",
    mainCities: [
      "Skopje",
      "Kumanovo",
      "Prilep",
      "Bitola"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Skopje, Kumanovo, Prilep, Bitola"
  },
  {
    name: "Europe/Stockholm",
    alternativeName: "Central European Time",
    group: [
      "Europe/Stockholm"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Sweden",
    countryCode: "SE",
    mainCities: [
      "Stockholm",
      "G\xF6teborg",
      "Malm\xF6",
      "Uppsala"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Stockholm, G\xF6teborg, Malm\xF6, Uppsala"
  },
  {
    name: "Europe/Tirane",
    alternativeName: "Central European Time",
    group: [
      "Europe/Tirane"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Albania",
    countryCode: "AL",
    mainCities: [
      "Tirana",
      "Durr\xEBs",
      "Elbasan",
      "Vlor\xEB"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Tirana, Durr\xEBs, Elbasan, Vlor\xEB"
  },
  {
    name: "Africa/Tunis",
    alternativeName: "Central European Time",
    group: [
      "Africa/Tunis"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Tunisia",
    countryCode: "TN",
    mainCities: [
      "Tunis",
      "Sfax",
      "Sousse",
      "Kairouan"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Tunis, Sfax, Sousse, Kairouan"
  },
  {
    name: "Europe/Vaduz",
    alternativeName: "Central European Time",
    group: [
      "Europe/Vaduz"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Liechtenstein",
    countryCode: "LI",
    mainCities: [
      "Vaduz"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Vaduz"
  },
  {
    name: "Europe/Vatican",
    alternativeName: "Central European Time",
    group: [
      "Europe/Vatican"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Vatican",
    countryCode: "VA",
    mainCities: [
      "Vatican City"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Vatican City"
  },
  {
    name: "Europe/Vienna",
    alternativeName: "Central European Time",
    group: [
      "Europe/Vienna"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Austria",
    countryCode: "AT",
    mainCities: [
      "Vienna",
      "Graz",
      "Linz",
      "Favoriten"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Vienna, Graz, Linz, Favoriten"
  },
  {
    name: "Europe/Warsaw",
    alternativeName: "Central European Time",
    group: [
      "Europe/Warsaw",
      "Poland"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Poland",
    countryCode: "PL",
    mainCities: [
      "Warsaw",
      "\u0141\xF3d\u017A",
      "Krak\xF3w",
      "Wroc\u0142aw"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Warsaw, \u0141\xF3d\u017A, Krak\xF3w, Wroc\u0142aw"
  },
  {
    name: "Europe/Zagreb",
    alternativeName: "Central European Time",
    group: [
      "Europe/Zagreb"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Croatia",
    countryCode: "HR",
    mainCities: [
      "Zagreb",
      "Split",
      "Rijeka",
      "Osijek"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Zagreb, Split, Rijeka, Osijek"
  },
  {
    name: "Europe/Zurich",
    alternativeName: "Central European Time",
    group: [
      "Europe/Zurich",
      "Europe/Busingen",
      "Europe/Vaduz"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Switzerland",
    countryCode: "CH",
    mainCities: [
      "Z\xFCrich",
      "Gen\xE8ve",
      "Basel",
      "Lausanne"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "CET",
    rawFormat: "+01:00 Central European Time - Z\xFCrich, Gen\xE8ve, Basel, Lausanne"
  },
  {
    name: "Africa/Bangui",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Bangui"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Central African Republic",
    countryCode: "CF",
    mainCities: [
      "Bangui",
      "Bimbo",
      "B\xE9goua",
      "Carnot"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Bangui, Bimbo, B\xE9goua, Carnot"
  },
  {
    name: "Africa/Malabo",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Malabo"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Equatorial Guinea",
    countryCode: "GQ",
    mainCities: [
      "Bata",
      "Malabo",
      "Ebebiyin"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Bata, Malabo, Ebebiyin"
  },
  {
    name: "Africa/Brazzaville",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Brazzaville"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Republic of the Congo",
    countryCode: "CG",
    mainCities: [
      "Brazzaville",
      "Pointe-Noire",
      "Dolisie",
      "Nkayi"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Brazzaville, Pointe-Noire, Dolisie, Nkayi"
  },
  {
    name: "Africa/Porto-Novo",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Porto-Novo"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Benin",
    countryCode: "BJ",
    mainCities: [
      "Cotonou",
      "Abomey-Calavi",
      "Porto-Novo",
      "Parakou"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Cotonou, Abomey-Calavi, Porto-Novo, Parakou"
  },
  {
    name: "Africa/Douala",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Douala"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Cameroon",
    countryCode: "CM",
    mainCities: [
      "Douala",
      "Yaound\xE9",
      "Bamenda",
      "Bafoussam"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Douala, Yaound\xE9, Bamenda, Bafoussam"
  },
  {
    name: "Africa/Kinshasa",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Kinshasa"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Democratic Republic of the Congo",
    countryCode: "CD",
    mainCities: [
      "Kinshasa",
      "Kikwit",
      "Masina",
      "Mbandaka"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Kinshasa, Kikwit, Masina, Mbandaka"
  },
  {
    name: "Africa/Lagos",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Lagos",
      "Africa/Bangui",
      "Africa/Brazzaville",
      "Africa/Douala",
      "Africa/Kinshasa",
      "Africa/Libreville",
      "Africa/Luanda",
      "Africa/Malabo",
      "Africa/Niamey",
      "Africa/Porto-Novo"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Nigeria",
    countryCode: "NG",
    mainCities: [
      "Lagos",
      "Kano",
      "Ibadan",
      "Abuja"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Lagos, Kano, Ibadan, Abuja"
  },
  {
    name: "Africa/Libreville",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Libreville"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Gabon",
    countryCode: "GA",
    mainCities: [
      "Libreville",
      "Port-Gentil",
      "Franceville",
      "Owendo"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Libreville, Port-Gentil, Franceville, Owendo"
  },
  {
    name: "Africa/Luanda",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Luanda"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Angola",
    countryCode: "AO",
    mainCities: [
      "Luanda",
      "Lubango",
      "Huambo",
      "Benguela"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Luanda, Lubango, Huambo, Benguela"
  },
  {
    name: "Africa/Ndjamena",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Ndjamena"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Chad",
    countryCode: "TD",
    mainCities: [
      "N'Djamena",
      "Moundou",
      "Ab\xE9ch\xE9",
      "Sarh"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - N'Djamena, Moundou, Ab\xE9ch\xE9, Sarh"
  },
  {
    name: "Africa/Niamey",
    alternativeName: "West Africa Time",
    group: [
      "Africa/Niamey"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Niger",
    countryCode: "NE",
    mainCities: [
      "Niamey",
      "Maradi",
      "Zinder",
      "Tahoua"
    ],
    rawOffsetInMinutes: 60,
    abbreviation: "WAT",
    rawFormat: "+01:00 West Africa Time - Niamey, Maradi, Zinder, Tahoua"
  },
  {
    name: "Africa/Bujumbura",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Bujumbura"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Burundi",
    countryCode: "BI",
    mainCities: [
      "Bujumbura",
      "Gitega",
      "Ngozi",
      "Rumonge"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Bujumbura, Gitega, Ngozi, Rumonge"
  },
  {
    name: "Africa/Gaborone",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Gaborone"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Botswana",
    countryCode: "BW",
    mainCities: [
      "Gaborone",
      "Francistown",
      "Mogoditshane",
      "Maun"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Gaborone, Francistown, Mogoditshane, Maun"
  },
  {
    name: "Africa/Harare",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Harare"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Zimbabwe",
    countryCode: "ZW",
    mainCities: [
      "Harare",
      "Bulawayo",
      "Chitungwiza",
      "Mutare"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Harare, Bulawayo, Chitungwiza, Mutare"
  },
  {
    name: "Africa/Juba",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Juba"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "South Sudan",
    countryCode: "SS",
    mainCities: [
      "Juba",
      "Winejok",
      "Yei",
      "Malakal"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Juba, Winejok, Yei, Malakal"
  },
  {
    name: "Africa/Khartoum",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Khartoum"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Sudan",
    countryCode: "SD",
    mainCities: [
      "Khartoum",
      "Omdurman",
      "Nyala",
      "Port Sudan"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Khartoum, Omdurman, Nyala, Port Sudan"
  },
  {
    name: "Africa/Kigali",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Kigali"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Rwanda",
    countryCode: "RW",
    mainCities: [
      "Kigali",
      "Gisenyi",
      "Butare",
      "Gitarama"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Kigali, Gisenyi, Butare, Gitarama"
  },
  {
    name: "Africa/Blantyre",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Blantyre"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Malawi",
    countryCode: "MW",
    mainCities: [
      "Lilongwe",
      "Blantyre",
      "Mzuzu",
      "Zomba"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Lilongwe, Blantyre, Mzuzu, Zomba"
  },
  {
    name: "Africa/Lubumbashi",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Lubumbashi"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Democratic Republic of the Congo",
    countryCode: "CD",
    mainCities: [
      "Lubumbashi",
      "Mbuji-Mayi",
      "Kananga",
      "Kisangani"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Lubumbashi, Mbuji-Mayi, Kananga, Kisangani"
  },
  {
    name: "Africa/Lusaka",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Lusaka"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Zambia",
    countryCode: "ZM",
    mainCities: [
      "Lusaka",
      "Ndola",
      "Kitwe",
      "Chipata"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Lusaka, Ndola, Kitwe, Chipata"
  },
  {
    name: "Africa/Maputo",
    alternativeName: "Central Africa Time",
    group: [
      "Africa/Maputo",
      "Africa/Blantyre",
      "Africa/Bujumbura",
      "Africa/Gaborone",
      "Africa/Harare",
      "Africa/Kigali",
      "Africa/Lubumbashi",
      "Africa/Lusaka"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Mozambique",
    countryCode: "MZ",
    mainCities: [
      "Maputo",
      "Matola",
      "Nampula",
      "Beira"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "CAT",
    rawFormat: "+02:00 Central Africa Time - Maputo, Matola, Nampula, Beira"
  },
  {
    name: "Europe/Athens",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Athens"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Greece",
    countryCode: "GR",
    mainCities: [
      "Athens",
      "Thessalon\xEDki",
      "P\xE1tra",
      "Piraeus"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Athens, Thessalon\xEDki, P\xE1tra, Piraeus"
  },
  {
    name: "Asia/Beirut",
    alternativeName: "Eastern European Time",
    group: [
      "Asia/Beirut"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Lebanon",
    countryCode: "LB",
    mainCities: [
      "Beirut",
      "Ra\u2019s Bayr\u016Bt",
      "Tripoli",
      "Sidon"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Beirut, Ra\u2019s Bayr\u016Bt, Tripoli, Sidon"
  },
  {
    name: "Europe/Bucharest",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Bucharest"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Romania",
    countryCode: "RO",
    mainCities: [
      "Bucharest",
      "Sector 3",
      "Ia\u015Fi",
      "Sector 6"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Bucharest, Sector 3, Ia\u015Fi, Sector 6"
  },
  {
    name: "Africa/Cairo",
    alternativeName: "Eastern European Time",
    group: [
      "Africa/Cairo",
      "Egypt"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Egypt",
    countryCode: "EG",
    mainCities: [
      "Cairo",
      "Alexandria",
      "Giza",
      "Shubr\u0101 al Khaymah"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Cairo, Alexandria, Giza, Shubr\u0101 al Khaymah"
  },
  {
    name: "Europe/Chisinau",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Chisinau",
      "Europe/Tiraspol"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Moldova",
    countryCode: "MD",
    mainCities: [
      "Chisinau",
      "Tiraspol",
      "B\u0103l\u0163i",
      "Bender"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Chisinau, Tiraspol, B\u0103l\u0163i, Bender"
  },
  {
    name: "Asia/Hebron",
    alternativeName: "Eastern European Time",
    group: [
      "Asia/Gaza",
      "Asia/Hebron"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Palestinian Territory",
    countryCode: "PS",
    mainCities: [
      "East Jerusalem",
      "Gaza",
      "Kh\u0101n Y\u016Bnis",
      "Jab\u0101ly\u0101"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - East Jerusalem, Gaza, Kh\u0101n Y\u016Bnis, Jab\u0101ly\u0101"
  },
  {
    name: "Europe/Helsinki",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Helsinki",
      "Europe/Mariehamn"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Finland",
    countryCode: "FI",
    mainCities: [
      "Helsinki",
      "Espoo",
      "Tampere",
      "Oulu"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Helsinki, Espoo, Tampere, Oulu"
  },
  {
    name: "Europe/Kaliningrad",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Kaliningrad"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Kaliningrad",
      "Chernyakhovsk",
      "Sovetsk",
      "Baltiysk"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk"
  },
  {
    name: "Europe/Kyiv",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Kyiv",
      "Europe/Uzhgorod",
      "Europe/Zaporozhye",
      "Europe/Kiev"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Ukraine",
    countryCode: "UA",
    mainCities: [
      "Kyiv",
      "Kharkiv",
      "Odesa",
      "Dnipro"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Kyiv, Kharkiv, Odesa, Dnipro"
  },
  {
    name: "Europe/Mariehamn",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Mariehamn"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Aland Islands",
    countryCode: "AX",
    mainCities: [
      "Mariehamn"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Mariehamn"
  },
  {
    name: "Asia/Nicosia",
    alternativeName: "Eastern European Time",
    group: [
      "Asia/Famagusta",
      "Asia/Nicosia",
      "Europe/Nicosia"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Cyprus",
    countryCode: "CY",
    mainCities: [
      "Nicosia",
      "Limassol",
      "Larnaca",
      "Str\xF3volos"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Nicosia, Limassol, Larnaca, Str\xF3volos"
  },
  {
    name: "Europe/Riga",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Riga"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Latvia",
    countryCode: "LV",
    mainCities: [
      "Riga",
      "Daugavpils",
      "Liep\u0101ja",
      "Jelgava"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Riga, Daugavpils, Liep\u0101ja, Jelgava"
  },
  {
    name: "Europe/Sofia",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Sofia"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Bulgaria",
    countryCode: "BG",
    mainCities: [
      "Sofia",
      "Plovdiv",
      "Varna",
      "Burgas"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Sofia, Plovdiv, Varna, Burgas"
  },
  {
    name: "Europe/Tallinn",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Tallinn"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Estonia",
    countryCode: "EE",
    mainCities: [
      "Tallinn",
      "Tartu",
      "Narva",
      "P\xE4rnu"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Tallinn, Tartu, Narva, P\xE4rnu"
  },
  {
    name: "Africa/Tripoli",
    alternativeName: "Eastern European Time",
    group: [
      "Africa/Tripoli",
      "Libya"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Libya",
    countryCode: "LY",
    mainCities: [
      "Tripoli",
      "Benghazi",
      "Misratah",
      "Zliten"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Tripoli, Benghazi, Misratah, Zliten"
  },
  {
    name: "Europe/Vilnius",
    alternativeName: "Eastern European Time",
    group: [
      "Europe/Vilnius"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Lithuania",
    countryCode: "LT",
    mainCities: [
      "Vilnius",
      "Kaunas",
      "Klaip\u0117da",
      "\u0160iauliai"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "EET",
    rawFormat: "+02:00 Eastern European Time - Vilnius, Kaunas, Klaip\u0117da, \u0160iauliai"
  },
  {
    name: "Asia/Jerusalem",
    alternativeName: "Israel Time",
    group: [
      "Asia/Jerusalem",
      "Israel",
      "Asia/Tel_Aviv"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Israel",
    countryCode: "IL",
    mainCities: [
      "Jerusalem",
      "Tel Aviv",
      "West Jerusalem",
      "Haifa"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "IST",
    rawFormat: "+02:00 Israel Time - Jerusalem, Tel Aviv, West Jerusalem, Haifa"
  },
  {
    name: "Africa/Johannesburg",
    alternativeName: "South Africa Time",
    group: [
      "Africa/Johannesburg",
      "Africa/Maseru",
      "Africa/Mbabane"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "South Africa",
    countryCode: "ZA",
    mainCities: [
      "Johannesburg",
      "Cape Town",
      "Durban",
      "Soweto"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "SAST",
    rawFormat: "+02:00 South Africa Time - Johannesburg, Cape Town, Durban, Soweto"
  },
  {
    name: "Africa/Mbabane",
    alternativeName: "South Africa Time",
    group: [
      "Africa/Mbabane"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Eswatini",
    countryCode: "SZ",
    mainCities: [
      "Manzini",
      "Mbabane",
      "Lobamba"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "SAST",
    rawFormat: "+02:00 South Africa Time - Manzini, Mbabane, Lobamba"
  },
  {
    name: "Africa/Maseru",
    alternativeName: "South Africa Time",
    group: [
      "Africa/Maseru"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Lesotho",
    countryCode: "LS",
    mainCities: [
      "Maseru",
      "Maputsoe",
      "Mohale's Hoek",
      "Mafeteng"
    ],
    rawOffsetInMinutes: 120,
    abbreviation: "SAST",
    rawFormat: "+02:00 South Africa Time - Maseru, Maputsoe, Mohale's Hoek, Mafeteng"
  },
  {
    name: "Asia/Kuwait",
    alternativeName: "Arabian Time",
    group: [
      "Asia/Kuwait"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Kuwait",
    countryCode: "KW",
    mainCities: [
      "Al A\u1E29mad\u012B",
      "\u1E28awall\u012B",
      "As S\u0101lim\u012Byah",
      "\u015Eab\u0101\u1E29 as S\u0101lim"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "AST",
    rawFormat: "+03:00 Arabian Time - Al A\u1E29mad\u012B, \u1E28awall\u012B, As S\u0101lim\u012Byah, \u015Eab\u0101\u1E29 as S\u0101lim"
  },
  {
    name: "Asia/Bahrain",
    alternativeName: "Arabian Time",
    group: [
      "Asia/Bahrain"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Bahrain",
    countryCode: "BH",
    mainCities: [
      "Ar Rif\u0101\u2018",
      "Manama",
      "Al Muharraq",
      "D\u0101r Kulayb"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "AST",
    rawFormat: "+03:00 Arabian Time - Ar Rif\u0101\u2018, Manama, Al Muharraq, D\u0101r Kulayb"
  },
  {
    name: "Asia/Baghdad",
    alternativeName: "Arabian Time",
    group: [
      "Asia/Baghdad"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Iraq",
    countryCode: "IQ",
    mainCities: [
      "Baghdad",
      "Al Maw\u015Fil al Jad\u012Bdah",
      "Al Ba\u015Frah al Qad\u012Bmah",
      "Mosul"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "AST",
    rawFormat: "+03:00 Arabian Time - Baghdad, Al Maw\u015Fil al Jad\u012Bdah, Al Ba\u015Frah al Qad\u012Bmah, Mosul"
  },
  {
    name: "Asia/Qatar",
    alternativeName: "Arabian Time",
    group: [
      "Asia/Qatar",
      "Asia/Bahrain"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Qatar",
    countryCode: "QA",
    mainCities: [
      "Doha",
      "Ar Rayy\u0101n",
      "Al Ma\u0163\u0101r al \u2018At\u012Bq",
      "Al Man\u015F\u016Brah"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "AST",
    rawFormat: "+03:00 Arabian Time - Doha, Ar Rayy\u0101n, Al Ma\u0163\u0101r al \u2018At\u012Bq, Al Man\u015F\u016Brah"
  },
  {
    name: "Asia/Riyadh",
    alternativeName: "Arabian Time",
    group: [
      "Asia/Riyadh",
      "Antarctica/Syowa",
      "Asia/Aden",
      "Asia/Kuwait"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Saudi Arabia",
    countryCode: "SA",
    mainCities: [
      "Jeddah",
      "Riyadh",
      "Mecca",
      "Medina"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "AST",
    rawFormat: "+03:00 Arabian Time - Jeddah, Riyadh, Mecca, Medina"
  },
  {
    name: "Asia/Aden",
    alternativeName: "Arabian Time",
    group: [
      "Asia/Aden"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Yemen",
    countryCode: "YE",
    mainCities: [
      "Sanaa",
      "Aden",
      "Al \u1E28udaydah",
      "Taiz"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "AST",
    rawFormat: "+03:00 Arabian Time - Sanaa, Aden, Al \u1E28udaydah, Taiz"
  },
  {
    name: "Asia/Amman",
    alternativeName: "Asia/Amman",
    group: [
      "Asia/Amman"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Jordan",
    countryCode: "JO",
    mainCities: [
      "Amman",
      "Zarqa",
      "Irbid",
      "Russeifa"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "GMT+3",
    rawFormat: "+03:00 Asia/Amman - Amman, Zarqa, Irbid, Russeifa"
  },
  {
    name: "Asia/Damascus",
    alternativeName: "Asia/Damascus",
    group: [
      "Asia/Damascus"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Syria",
    countryCode: "SY",
    mainCities: [
      "Aleppo",
      "Damascus",
      "Homs",
      "Latakia"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "GMT+3",
    rawFormat: "+03:00 Asia/Damascus - Aleppo, Damascus, Homs, Latakia"
  },
  {
    name: "Africa/Addis_Ababa",
    alternativeName: "East Africa Time",
    group: [
      "Africa/Addis_Ababa"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Ethiopia",
    countryCode: "ET",
    mainCities: [
      "Addis Ababa",
      "Jijiga",
      "Gonder",
      "Mek'ele"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Addis Ababa, Jijiga, Gonder, Mek'ele"
  },
  {
    name: "Indian/Antananarivo",
    alternativeName: "East Africa Time",
    group: [
      "Indian/Antananarivo"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Madagascar",
    countryCode: "MG",
    mainCities: [
      "Antananarivo",
      "Toamasina",
      "Antsirabe",
      "Mahajanga"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Antananarivo, Toamasina, Antsirabe, Mahajanga"
  },
  {
    name: "Africa/Asmara",
    alternativeName: "East Africa Time",
    group: [
      "Africa/Asmara"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Eritrea",
    countryCode: "ER",
    mainCities: [
      "Asmara",
      "Keren",
      "Himora",
      "Massawa"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Asmara, Keren, Himora, Massawa"
  },
  {
    name: "Africa/Dar_es_Salaam",
    alternativeName: "East Africa Time",
    group: [
      "Africa/Dar_es_Salaam"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Tanzania",
    countryCode: "TZ",
    mainCities: [
      "Dar es Salaam",
      "Mwanza",
      "Arusha",
      "Mbeya"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Dar es Salaam, Mwanza, Arusha, Mbeya"
  },
  {
    name: "Africa/Djibouti",
    alternativeName: "East Africa Time",
    group: [
      "Africa/Djibouti"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Djibouti",
    countryCode: "DJ",
    mainCities: [
      "Djibouti",
      "Ali Sabih",
      "Dikhil",
      "Tadjoura"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Djibouti, Ali Sabih, Dikhil, Tadjoura"
  },
  {
    name: "Africa/Kampala",
    alternativeName: "East Africa Time",
    group: [
      "Africa/Kampala"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Uganda",
    countryCode: "UG",
    mainCities: [
      "Kampala",
      "Gulu",
      "Lira",
      "Mbarara"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Kampala, Gulu, Lira, Mbarara"
  },
  {
    name: "Indian/Mayotte",
    alternativeName: "East Africa Time",
    group: [
      "Indian/Mayotte"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Mayotte",
    countryCode: "YT",
    mainCities: [
      "Mamoudzou",
      "Koungou",
      "Labattoir",
      "Kaou\xE9ni"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Mamoudzou, Koungou, Labattoir, Kaou\xE9ni"
  },
  {
    name: "Africa/Mogadishu",
    alternativeName: "East Africa Time",
    group: [
      "Africa/Mogadishu"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Somalia",
    countryCode: "SO",
    mainCities: [
      "Mogadishu",
      "Borama",
      "Hargeysa",
      "Berbera"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Mogadishu, Borama, Hargeysa, Berbera"
  },
  {
    name: "Indian/Comoro",
    alternativeName: "East Africa Time",
    group: [
      "Indian/Comoro"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Comoros",
    countryCode: "KM",
    mainCities: [
      "Moroni",
      "Moutsamoudou",
      "Fomboni"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Moroni, Moutsamoudou, Fomboni"
  },
  {
    name: "Africa/Nairobi",
    alternativeName: "East Africa Time",
    group: [
      "Africa/Nairobi",
      "Africa/Addis_Ababa",
      "Africa/Asmara",
      "Africa/Dar_es_Salaam",
      "Africa/Djibouti",
      "Africa/Kampala",
      "Africa/Mogadishu",
      "Indian/Antananarivo",
      "Indian/Comoro",
      "Indian/Mayotte",
      "Africa/Asmera"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Kenya",
    countryCode: "KE",
    mainCities: [
      "Nairobi",
      "Kakamega",
      "Mombasa",
      "Nakuru"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "EAT",
    rawFormat: "+03:00 East Africa Time - Nairobi, Kakamega, Mombasa, Nakuru"
  },
  {
    name: "Europe/Minsk",
    alternativeName: "Moscow Time",
    group: [
      "Europe/Minsk"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Belarus",
    countryCode: "BY",
    mainCities: [
      "Minsk",
      "Homyel'",
      "Hrodna",
      "Mahilyow"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "MSK",
    rawFormat: "+03:00 Moscow Time - Minsk, Homyel', Hrodna, Mahilyow"
  },
  {
    name: "Europe/Moscow",
    alternativeName: "Moscow Time",
    group: [
      "Europe/Kirov",
      "Europe/Moscow",
      "Europe/Volgograd",
      "W-SU"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Moscow",
      "Saint Petersburg",
      "Nizhniy Novgorod",
      "Kazan"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "MSK",
    rawFormat: "+03:00 Moscow Time - Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan"
  },
  {
    name: "Europe/Simferopol",
    alternativeName: "Moscow Time",
    group: [
      "Europe/Simferopol"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Ukraine",
    countryCode: "UA",
    mainCities: [
      "Sevastopol",
      "Simferopol",
      "Kerch",
      "Yevpatoriya"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "MSK",
    rawFormat: "+03:00 Moscow Time - Sevastopol, Simferopol, Kerch, Yevpatoriya"
  },
  {
    name: "Antarctica/Syowa",
    alternativeName: "Syowa Time",
    group: [
      "Antarctica/Syowa"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "Antarctica",
    countryCode: "AQ",
    mainCities: [
      "Syowa"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "SYOT",
    rawFormat: "+03:00 Syowa Time - Syowa"
  },
  {
    name: "Europe/Istanbul",
    alternativeName: "Turkey Time",
    group: [
      "Europe/Istanbul",
      "Turkey",
      "Asia/Istanbul"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Turkey",
    countryCode: "TR",
    mainCities: [
      "Istanbul",
      "Ankara",
      "Bursa",
      "\u0130zmir"
    ],
    rawOffsetInMinutes: 180,
    abbreviation: "TRT",
    rawFormat: "+03:00 Turkey Time - Istanbul, Ankara, Bursa, \u0130zmir"
  },
  {
    name: "Asia/Tehran",
    alternativeName: "Iran Time",
    group: [
      "Asia/Tehran",
      "Iran"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Iran",
    countryCode: "IR",
    mainCities: [
      "Tehran",
      "Mashhad",
      "Isfahan",
      "Karaj"
    ],
    rawOffsetInMinutes: 210,
    abbreviation: "IRST",
    rawFormat: "+03:30 Iran Time - Tehran, Mashhad, Isfahan, Karaj"
  },
  {
    name: "Asia/Yerevan",
    alternativeName: "Armenia Time",
    group: [
      "Asia/Yerevan"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Armenia",
    countryCode: "AM",
    mainCities: [
      "Yerevan",
      "Gyumri",
      "Vanadzor",
      "Vagharshapat"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "AMT",
    rawFormat: "+04:00 Armenia Time - Yerevan, Gyumri, Vanadzor, Vagharshapat"
  },
  {
    name: "Asia/Baku",
    alternativeName: "Azerbaijan Time",
    group: [
      "Asia/Baku"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Azerbaijan",
    countryCode: "AZ",
    mainCities: [
      "Baku",
      "Sumqay\u0131t",
      "Ganja",
      "Lankaran"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "AZT",
    rawFormat: "+04:00 Azerbaijan Time - Baku, Sumqay\u0131t, Ganja, Lankaran"
  },
  {
    name: "Asia/Tbilisi",
    alternativeName: "Georgia Time",
    group: [
      "Asia/Tbilisi"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Georgia",
    countryCode: "GE",
    mainCities: [
      "Tbilisi",
      "Batumi",
      "Kutaisi",
      "Rustavi"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "GET",
    rawFormat: "+04:00 Georgia Time - Tbilisi, Batumi, Kutaisi, Rustavi"
  },
  {
    name: "Asia/Dubai",
    alternativeName: "Gulf Time",
    group: [
      "Asia/Dubai",
      "Asia/Muscat",
      "Indian/Mahe",
      "Indian/Reunion"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "United Arab Emirates",
    countryCode: "AE",
    mainCities: [
      "Dubai",
      "Abu Dhabi",
      "Sharjah",
      "Al Ain City"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "GST",
    rawFormat: "+04:00 Gulf Time - Dubai, Abu Dhabi, Sharjah, Al Ain City"
  },
  {
    name: "Asia/Muscat",
    alternativeName: "Gulf Time",
    group: [
      "Asia/Muscat"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Oman",
    countryCode: "OM",
    mainCities: [
      "Muscat",
      "Seeb",
      "Bawshar",
      "\u2018Ibr\u012B"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "GST",
    rawFormat: "+04:00 Gulf Time - Muscat, Seeb, Bawshar, \u2018Ibr\u012B"
  },
  {
    name: "Indian/Mauritius",
    alternativeName: "Mauritius Time",
    group: [
      "Indian/Mauritius"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Mauritius",
    countryCode: "MU",
    mainCities: [
      "Port Louis",
      "Vacoas",
      "Beau Bassin-Rose Hill",
      "Curepipe"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "MUT",
    rawFormat: "+04:00 Mauritius Time - Port Louis, Vacoas, Beau Bassin-Rose Hill, Curepipe"
  },
  {
    name: "Indian/Reunion",
    alternativeName: "R\xE9union Time",
    group: [
      "Indian/Reunion"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Reunion",
    countryCode: "RE",
    mainCities: [
      "Saint-Denis",
      "Saint-Paul",
      "Saint-Pierre",
      "Le Tampon"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "RET",
    rawFormat: "+04:00 R\xE9union Time - Saint-Denis, Saint-Paul, Saint-Pierre, Le Tampon"
  },
  {
    name: "Europe/Samara",
    alternativeName: "Samara Time",
    group: [
      "Europe/Astrakhan",
      "Europe/Samara",
      "Europe/Saratov",
      "Europe/Ulyanovsk"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Samara",
      "Saratov",
      "Tolyatti",
      "Izhevsk"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "SAMT",
    rawFormat: "+04:00 Samara Time - Samara, Saratov, Tolyatti, Izhevsk"
  },
  {
    name: "Indian/Mahe",
    alternativeName: "Seychelles Time",
    group: [
      "Indian/Mahe"
    ],
    continentCode: "AF",
    continentName: "Africa",
    countryName: "Seychelles",
    countryCode: "SC",
    mainCities: [
      "Victoria"
    ],
    rawOffsetInMinutes: 240,
    abbreviation: "SCT",
    rawFormat: "+04:00 Seychelles Time - Victoria"
  },
  {
    name: "Asia/Kabul",
    alternativeName: "Afghanistan Time",
    group: [
      "Asia/Kabul"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Afghanistan",
    countryCode: "AF",
    mainCities: [
      "Kabul",
      "Her\u0101t",
      "Maz\u0101r-e Shar\u012Bf",
      "Kandah\u0101r"
    ],
    rawOffsetInMinutes: 270,
    abbreviation: "AFT",
    rawFormat: "+04:30 Afghanistan Time - Kabul, Her\u0101t, Maz\u0101r-e Shar\u012Bf, Kandah\u0101r"
  },
  {
    name: "Asia/Almaty",
    alternativeName: "East Kazakhstan Time",
    group: [
      "Asia/Almaty",
      "Asia/Qostanay"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Kazakhstan",
    countryCode: "KZ",
    mainCities: [
      "Almaty",
      "Shymkent",
      "Karagandy",
      "Taraz"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "ALMT",
    rawFormat: "+05:00 East Kazakhstan Time - Almaty, Shymkent, Karagandy, Taraz"
  },
  {
    name: "Indian/Kerguelen",
    alternativeName: "French Southern & Antarctic Time",
    group: [
      "Indian/Kerguelen"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "French Southern Territories",
    countryCode: "TF",
    mainCities: [
      "Port-aux-Fran\xE7ais"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "FSAT",
    rawFormat: "+05:00 French Southern & Antarctic Time - Port-aux-Fran\xE7ais"
  },
  {
    name: "Indian/Maldives",
    alternativeName: "Maldives Time",
    group: [
      "Indian/Maldives",
      "Indian/Kerguelen"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Maldives",
    countryCode: "MV",
    mainCities: [
      "Male"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "MVT",
    rawFormat: "+05:00 Maldives Time - Male"
  },
  {
    name: "Antarctica/Mawson",
    alternativeName: "Mawson Time",
    group: [
      "Antarctica/Mawson",
      "Antarctica/Vostok"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "Antarctica",
    countryCode: "AQ",
    mainCities: [
      "Mawson",
      "Vostok"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "MAWT",
    rawFormat: "+05:00 Mawson Time - Mawson, Vostok"
  },
  {
    name: "Asia/Karachi",
    alternativeName: "Pakistan Time",
    group: [
      "Asia/Karachi"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Pakistan",
    countryCode: "PK",
    mainCities: [
      "Karachi",
      "Lahore",
      "Faisalabad",
      "Rawalpindi"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "PKT",
    rawFormat: "+05:00 Pakistan Time - Karachi, Lahore, Faisalabad, Rawalpindi"
  },
  {
    name: "Asia/Dushanbe",
    alternativeName: "Tajikistan Time",
    group: [
      "Asia/Dushanbe"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Tajikistan",
    countryCode: "TJ",
    mainCities: [
      "Dushanbe",
      "Isfara",
      "Istaravshan",
      "K\u016Dlob"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "TJT",
    rawFormat: "+05:00 Tajikistan Time - Dushanbe, Isfara, Istaravshan, K\u016Dlob"
  },
  {
    name: "Asia/Ashgabat",
    alternativeName: "Turkmenistan Time",
    group: [
      "Asia/Ashgabat",
      "Asia/Ashkhabad"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Turkmenistan",
    countryCode: "TM",
    mainCities: [
      "Ashgabat",
      "T\xFCrkmenabat",
      "Da\u015Foguz",
      "Mary"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "TMT",
    rawFormat: "+05:00 Turkmenistan Time - Ashgabat, T\xFCrkmenabat, Da\u015Foguz, Mary"
  },
  {
    name: "Asia/Tashkent",
    alternativeName: "Uzbekistan Time",
    group: [
      "Asia/Samarkand",
      "Asia/Tashkent"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Uzbekistan",
    countryCode: "UZ",
    mainCities: [
      "Tashkent",
      "Namangan",
      "Samarkand",
      "Andijon"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "UZT",
    rawFormat: "+05:00 Uzbekistan Time - Tashkent, Namangan, Samarkand, Andijon"
  },
  {
    name: "Asia/Aqtobe",
    alternativeName: "West Kazakhstan Time",
    group: [
      "Asia/Aqtau",
      "Asia/Aqtobe",
      "Asia/Atyrau",
      "Asia/Oral",
      "Asia/Qyzylorda"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Kazakhstan",
    countryCode: "KZ",
    mainCities: [
      "Aktobe",
      "Kyzylorda",
      "Oral",
      "Atyrau"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "AQTT",
    rawFormat: "+05:00 West Kazakhstan Time - Aktobe, Kyzylorda, Oral, Atyrau"
  },
  {
    name: "Asia/Yekaterinburg",
    alternativeName: "Yekaterinburg Time",
    group: [
      "Asia/Yekaterinburg"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Yekaterinburg",
      "Chelyabinsk",
      "Ufa",
      "Perm"
    ],
    rawOffsetInMinutes: 300,
    abbreviation: "YEKT",
    rawFormat: "+05:00 Yekaterinburg Time - Yekaterinburg, Chelyabinsk, Ufa, Perm"
  },
  {
    name: "Asia/Colombo",
    alternativeName: "India Time",
    group: [
      "Asia/Colombo"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Sri Lanka",
    countryCode: "LK",
    mainCities: [
      "Colombo",
      "Dehiwala-Mount Lavinia",
      "Maharagama",
      "Jaffna"
    ],
    rawOffsetInMinutes: 330,
    abbreviation: "IST",
    rawFormat: "+05:30 India Time - Colombo, Dehiwala-Mount Lavinia, Maharagama, Jaffna"
  },
  {
    name: "Asia/Kolkata",
    alternativeName: "India Time",
    group: [
      "Asia/Kolkata",
      "Asia/Calcutta"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "India",
    countryCode: "IN",
    mainCities: [
      "Mumbai",
      "Delhi",
      "Bengaluru",
      "Hyder\u0101b\u0101d"
    ],
    rawOffsetInMinutes: 330,
    abbreviation: "IST",
    rawFormat: "+05:30 India Time - Mumbai, Delhi, Bengaluru, Hyder\u0101b\u0101d"
  },
  {
    name: "Asia/Kathmandu",
    alternativeName: "Nepal Time",
    group: [
      "Asia/Kathmandu",
      "Asia/Katmandu"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Nepal",
    countryCode: "NP",
    mainCities: [
      "Kathmandu",
      "Bharatpur",
      "P\u0101tan",
      "Birga\xF1j"
    ],
    rawOffsetInMinutes: 345,
    abbreviation: "NPT",
    rawFormat: "+05:45 Nepal Time - Kathmandu, Bharatpur, P\u0101tan, Birga\xF1j"
  },
  {
    name: "Asia/Dhaka",
    alternativeName: "Bangladesh Time",
    group: [
      "Asia/Dhaka",
      "Asia/Dacca"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Bangladesh",
    countryCode: "BD",
    mainCities: [
      "Dhaka",
      "Chattogram",
      "Khulna",
      "Rangpur"
    ],
    rawOffsetInMinutes: 360,
    abbreviation: "BST",
    rawFormat: "+06:00 Bangladesh Time - Dhaka, Chattogram, Khulna, Rangpur"
  },
  {
    name: "Asia/Thimphu",
    alternativeName: "Bhutan Time",
    group: [
      "Asia/Thimphu",
      "Asia/Thimbu"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Bhutan",
    countryCode: "BT",
    mainCities: [
      "Thimphu",
      "Phuntsholing",
      "Tsirang",
      "Pun\u0101kha"
    ],
    rawOffsetInMinutes: 360,
    abbreviation: "BTT",
    rawFormat: "+06:00 Bhutan Time - Thimphu, Phuntsholing, Tsirang, Pun\u0101kha"
  },
  {
    name: "Asia/Urumqi",
    alternativeName: "China Time",
    group: [
      "Asia/Urumqi",
      "Asia/Kashgar"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "China",
    countryCode: "CN",
    mainCities: [
      "\xDCr\xFCmqi",
      "Shihezi",
      "Korla",
      "Aksu"
    ],
    rawOffsetInMinutes: 360,
    abbreviation: "CST",
    rawFormat: "+06:00 China Time - \xDCr\xFCmqi, Shihezi, Korla, Aksu"
  },
  {
    name: "Indian/Chagos",
    alternativeName: "Indian Ocean Time",
    group: [
      "Indian/Chagos"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "British Indian Ocean Territory",
    countryCode: "IO",
    mainCities: [
      "Chagos"
    ],
    rawOffsetInMinutes: 360,
    abbreviation: "IOT",
    rawFormat: "+06:00 Indian Ocean Time - Chagos"
  },
  {
    name: "Asia/Bishkek",
    alternativeName: "Kyrgyzstan Time",
    group: [
      "Asia/Bishkek"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Kyrgyzstan",
    countryCode: "KG",
    mainCities: [
      "Bishkek",
      "Osh",
      "Jalal-Abad",
      "Karakol"
    ],
    rawOffsetInMinutes: 360,
    abbreviation: "KGT",
    rawFormat: "+06:00 Kyrgyzstan Time - Bishkek, Osh, Jalal-Abad, Karakol"
  },
  {
    name: "Asia/Omsk",
    alternativeName: "Omsk Time",
    group: [
      "Asia/Omsk"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Omsk",
      "Tara",
      "Kalachinsk",
      "Isil\u2019kul\u2019"
    ],
    rawOffsetInMinutes: 360,
    abbreviation: "OMST",
    rawFormat: "+06:00 Omsk Time - Omsk, Tara, Kalachinsk, Isil\u2019kul\u2019"
  },
  {
    name: "Indian/Cocos",
    alternativeName: "Cocos Islands Time",
    group: [
      "Indian/Cocos"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Cocos Islands",
    countryCode: "CC",
    mainCities: [
      "West Island"
    ],
    rawOffsetInMinutes: 390,
    abbreviation: "CCT",
    rawFormat: "+06:30 Cocos Islands Time - West Island"
  },
  {
    name: "Asia/Yangon",
    alternativeName: "Myanmar Time",
    group: [
      "Asia/Yangon",
      "Indian/Cocos",
      "Asia/Rangoon"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Myanmar",
    countryCode: "MM",
    mainCities: [
      "Yangon",
      "Mandalay",
      "Nay Pyi Taw",
      "Mawlamyine"
    ],
    rawOffsetInMinutes: 390,
    abbreviation: "MMT",
    rawFormat: "+06:30 Myanmar Time - Yangon, Mandalay, Nay Pyi Taw, Mawlamyine"
  },
  {
    name: "Indian/Christmas",
    alternativeName: "Christmas Island Time",
    group: [
      "Indian/Christmas"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Christmas Island",
    countryCode: "CX",
    mainCities: [
      "Flying Fish Cove"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "CXT",
    rawFormat: "+07:00 Christmas Island Time - Flying Fish Cove"
  },
  {
    name: "Antarctica/Davis",
    alternativeName: "Davis Time",
    group: [
      "Antarctica/Davis"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "Antarctica",
    countryCode: "AQ",
    mainCities: [
      "Davis"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "DAVT",
    rawFormat: "+07:00 Davis Time - Davis"
  },
  {
    name: "Asia/Hovd",
    alternativeName: "Hovd Time",
    group: [
      "Asia/Hovd"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Mongolia",
    countryCode: "MN",
    mainCities: [
      "Ulaangom",
      "Khovd",
      "\xD6lgii",
      "Altai"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "HOVT",
    rawFormat: "+07:00 Hovd Time - Ulaangom, Khovd, \xD6lgii, Altai"
  },
  {
    name: "Asia/Bangkok",
    alternativeName: "Indochina Time",
    group: [
      "Asia/Bangkok",
      "Asia/Phnom_Penh",
      "Asia/Vientiane",
      "Indian/Christmas"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Thailand",
    countryCode: "TH",
    mainCities: [
      "Bangkok",
      "Samut Prakan",
      "Mueang Nonthaburi",
      "Chon Buri"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "ICT",
    rawFormat: "+07:00 Indochina Time - Bangkok, Samut Prakan, Mueang Nonthaburi, Chon Buri"
  },
  {
    name: "Asia/Ho_Chi_Minh",
    alternativeName: "Indochina Time",
    group: [
      "Asia/Ho_Chi_Minh",
      "Asia/Saigon"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Vietnam",
    countryCode: "VN",
    mainCities: [
      "Ho Chi Minh City",
      "Da Nang",
      "Bi\xEAn H\xF2a",
      "C\u1EA7n Th\u01A1"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "ICT",
    rawFormat: "+07:00 Indochina Time - Ho Chi Minh City, Da Nang, Bi\xEAn H\xF2a, C\u1EA7n Th\u01A1"
  },
  {
    name: "Asia/Phnom_Penh",
    alternativeName: "Indochina Time",
    group: [
      "Asia/Phnom_Penh"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Cambodia",
    countryCode: "KH",
    mainCities: [
      "Phnom Penh",
      "Takeo",
      "Siem Reap",
      "Battambang"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "ICT",
    rawFormat: "+07:00 Indochina Time - Phnom Penh, Takeo, Siem Reap, Battambang"
  },
  {
    name: "Asia/Vientiane",
    alternativeName: "Indochina Time",
    group: [
      "Asia/Vientiane"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Laos",
    countryCode: "LA",
    mainCities: [
      "Vientiane",
      "Savannakhet",
      "Pakse",
      "Thakh\xE8k"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "ICT",
    rawFormat: "+07:00 Indochina Time - Vientiane, Savannakhet, Pakse, Thakh\xE8k"
  },
  {
    name: "Asia/Novosibirsk",
    alternativeName: "Novosibirsk Time",
    group: [
      "Asia/Barnaul",
      "Asia/Krasnoyarsk",
      "Asia/Novokuznetsk",
      "Asia/Novosibirsk",
      "Asia/Tomsk"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Novosibirsk",
      "Krasnoyarsk",
      "Barnaul",
      "Tomsk"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "NOVT",
    rawFormat: "+07:00 Novosibirsk Time - Novosibirsk, Krasnoyarsk, Barnaul, Tomsk"
  },
  {
    name: "Asia/Jakarta",
    alternativeName: "Western Indonesia Time",
    group: [
      "Asia/Jakarta",
      "Asia/Pontianak"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Indonesia",
    countryCode: "ID",
    mainCities: [
      "Jakarta",
      "Surabaya",
      "Bekasi",
      "Bandung"
    ],
    rawOffsetInMinutes: 420,
    abbreviation: "WIB",
    rawFormat: "+07:00 Western Indonesia Time - Jakarta, Surabaya, Bekasi, Bandung"
  },
  {
    name: "Antarctica/Casey",
    alternativeName: "Australian Western Time",
    group: [
      "Antarctica/Casey"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "Antarctica",
    countryCode: "AQ",
    mainCities: [
      "Casey"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "AWST",
    rawFormat: "+08:00 Australian Western Time - Casey"
  },
  {
    name: "Australia/Perth",
    alternativeName: "Australian Western Time",
    group: [
      "Australia/Perth",
      "Australia/West"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Australia",
    countryCode: "AU",
    mainCities: [
      "Perth",
      "Mandurah",
      "Bunbury",
      "Baldivis"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "AWST",
    rawFormat: "+08:00 Australian Western Time - Perth, Mandurah, Bunbury, Baldivis"
  },
  {
    name: "Asia/Brunei",
    alternativeName: "Brunei Darussalam Time",
    group: [
      "Asia/Brunei"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Brunei",
    countryCode: "BN",
    mainCities: [
      "Bandar Seri Begawan",
      "Sengkurong",
      "Mentiri",
      "Kuala Belait"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "BNT",
    rawFormat: "+08:00 Brunei Darussalam Time - Bandar Seri Begawan, Sengkurong, Mentiri, Kuala Belait"
  },
  {
    name: "Asia/Makassar",
    alternativeName: "Central Indonesia Time",
    group: [
      "Asia/Makassar",
      "Asia/Ujung_Pandang"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Indonesia",
    countryCode: "ID",
    mainCities: [
      "Makassar",
      "Samarinda",
      "Denpasar",
      "Balikpapan"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "WITA",
    rawFormat: "+08:00 Central Indonesia Time - Makassar, Samarinda, Denpasar, Balikpapan"
  },
  {
    name: "Asia/Macau",
    alternativeName: "China Time",
    group: [
      "Asia/Macau",
      "Asia/Macao"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Macao",
    countryCode: "MO",
    mainCities: [
      "Macau",
      "Taipa",
      "Luhuan",
      "Lai Chi Van"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "CST",
    rawFormat: "+08:00 China Time - Macau, Taipa, Luhuan, Lai Chi Van"
  },
  {
    name: "Asia/Shanghai",
    alternativeName: "China Time",
    group: [
      "Asia/Shanghai",
      "PRC",
      "Asia/Chongqing",
      "Asia/Harbin",
      "Asia/Chungking"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "China",
    countryCode: "CN",
    mainCities: [
      "Shanghai",
      "Beijing",
      "Shenzhen",
      "Guangzhou"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "CST",
    rawFormat: "+08:00 China Time - Shanghai, Beijing, Shenzhen, Guangzhou"
  },
  {
    name: "Asia/Hong_Kong",
    alternativeName: "Hong Kong Time",
    group: [
      "Asia/Hong_Kong",
      "Hongkong"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Hong Kong",
    countryCode: "HK",
    mainCities: [
      "Hong Kong",
      "New Territories",
      "Kowloon",
      "Hong Kong Island"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "HKT",
    rawFormat: "+08:00 Hong Kong Time - Hong Kong, New Territories, Kowloon, Hong Kong Island"
  },
  {
    name: "Asia/Irkutsk",
    alternativeName: "Irkutsk Time",
    group: [
      "Asia/Irkutsk"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Irkutsk",
      "Ulan-Ude",
      "Bratsk",
      "Angarsk"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "IRKT",
    rawFormat: "+08:00 Irkutsk Time - Irkutsk, Ulan-Ude, Bratsk, Angarsk"
  },
  {
    name: "Asia/Kuala_Lumpur",
    alternativeName: "Malaysia Time",
    group: [
      "Asia/Kuala_Lumpur",
      "Asia/Kuching",
      "Asia/Brunei"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Malaysia",
    countryCode: "MY",
    mainCities: [
      "Kuala Lumpur",
      "Petaling Jaya",
      "Klang",
      "Johor Bahru"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "MYT",
    rawFormat: "+08:00 Malaysia Time - Kuala Lumpur, Petaling Jaya, Klang, Johor Bahru"
  },
  {
    name: "Asia/Manila",
    alternativeName: "Philippine Time",
    group: [
      "Asia/Manila"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Philippines",
    countryCode: "PH",
    mainCities: [
      "Quezon City",
      "Davao",
      "Manila",
      "Caloocan City"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "PHT",
    rawFormat: "+08:00 Philippine Time - Quezon City, Davao, Manila, Caloocan City"
  },
  {
    name: "Asia/Singapore",
    alternativeName: "Singapore Time",
    group: [
      "Asia/Singapore",
      "Singapore",
      "Asia/Kuala_Lumpur"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Singapore",
    countryCode: "SG",
    mainCities: [
      "Singapore",
      "Ulu Bedok",
      "Bedok New Town",
      "Tampines Estate"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "SGT",
    rawFormat: "+08:00 Singapore Time - Singapore, Ulu Bedok, Bedok New Town, Tampines Estate"
  },
  {
    name: "Asia/Taipei",
    alternativeName: "Taipei Time",
    group: [
      "Asia/Taipei",
      "ROC"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Taiwan",
    countryCode: "TW",
    mainCities: [
      "Taipei",
      "Kaohsiung",
      "Taichung",
      "Tainan"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "TWT",
    rawFormat: "+08:00 Taipei Time - Taipei, Kaohsiung, Taichung, Tainan"
  },
  {
    name: "Asia/Ulaanbaatar",
    alternativeName: "Ulaanbaatar Time",
    group: [
      "Asia/Choibalsan",
      "Asia/Ulaanbaatar",
      "Asia/Ulan_Bator"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Mongolia",
    countryCode: "MN",
    mainCities: [
      "Ulan Bator",
      "Erdenet",
      "Darhan",
      "M\xF6r\xF6n"
    ],
    rawOffsetInMinutes: 480,
    abbreviation: "ULAT",
    rawFormat: "+08:00 Ulaanbaatar Time - Ulan Bator, Erdenet, Darhan, M\xF6r\xF6n"
  },
  {
    name: "Australia/Eucla",
    alternativeName: "Australian Central Western Time",
    group: [
      "Australia/Eucla"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Australia",
    countryCode: "AU",
    mainCities: [
      "Eucla"
    ],
    rawOffsetInMinutes: 525,
    abbreviation: "ACWST",
    rawFormat: "+08:45 Australian Central Western Time - Eucla"
  },
  {
    name: "Asia/Dili",
    alternativeName: "East Timor Time",
    group: [
      "Asia/Dili"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Timor Leste",
    countryCode: "TL",
    mainCities: [
      "Dili",
      "Maliana",
      "Suai",
      "Likis\xE1"
    ],
    rawOffsetInMinutes: 540,
    abbreviation: "TLT",
    rawFormat: "+09:00 East Timor Time - Dili, Maliana, Suai, Likis\xE1"
  },
  {
    name: "Asia/Jayapura",
    alternativeName: "Eastern Indonesia Time",
    group: [
      "Asia/Jayapura"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Indonesia",
    countryCode: "ID",
    mainCities: [
      "Jayapura",
      "Ambon",
      "Sorong",
      "Ternate"
    ],
    rawOffsetInMinutes: 540,
    abbreviation: "WIT",
    rawFormat: "+09:00 Eastern Indonesia Time - Jayapura, Ambon, Sorong, Ternate"
  },
  {
    name: "Asia/Tokyo",
    alternativeName: "Japan Time",
    group: [
      "Asia/Tokyo",
      "Japan"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "Japan",
    countryCode: "JP",
    mainCities: [
      "Tokyo",
      "Yokohama",
      "Osaka",
      "Nagoya"
    ],
    rawOffsetInMinutes: 540,
    abbreviation: "JST",
    rawFormat: "+09:00 Japan Time - Tokyo, Yokohama, Osaka, Nagoya"
  },
  {
    name: "Asia/Pyongyang",
    alternativeName: "Korean Time",
    group: [
      "Asia/Pyongyang"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "North Korea",
    countryCode: "KP",
    mainCities: [
      "Pyongyang",
      "Hamh\u016Dng",
      "Namp\u2019o",
      "Sunch\u2019\u014Fn"
    ],
    rawOffsetInMinutes: 540,
    abbreviation: "KST",
    rawFormat: "+09:00 Korean Time - Pyongyang, Hamh\u016Dng, Namp\u2019o, Sunch\u2019\u014Fn"
  },
  {
    name: "Asia/Seoul",
    alternativeName: "Korean Time",
    group: [
      "Asia/Seoul",
      "ROK"
    ],
    continentCode: "AS",
    continentName: "Asia",
    countryName: "South Korea",
    countryCode: "KR",
    mainCities: [
      "Seoul",
      "Busan",
      "Incheon",
      "Daegu"
    ],
    rawOffsetInMinutes: 540,
    abbreviation: "KST",
    rawFormat: "+09:00 Korean Time - Seoul, Busan, Incheon, Daegu"
  },
  {
    name: "Pacific/Palau",
    alternativeName: "Palau Time",
    group: [
      "Pacific/Palau"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Palau",
    countryCode: "PW",
    mainCities: [
      "Ngerulmud"
    ],
    rawOffsetInMinutes: 540,
    abbreviation: "PWT",
    rawFormat: "+09:00 Palau Time - Ngerulmud"
  },
  {
    name: "Asia/Chita",
    alternativeName: "Yakutsk Time",
    group: [
      "Asia/Chita",
      "Asia/Khandyga",
      "Asia/Yakutsk"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Chita",
      "Yakutsk",
      "Blagoveshchensk",
      "Belogorsk"
    ],
    rawOffsetInMinutes: 540,
    abbreviation: "YAKT",
    rawFormat: "+09:00 Yakutsk Time - Chita, Yakutsk, Blagoveshchensk, Belogorsk"
  },
  {
    name: "Australia/Adelaide",
    alternativeName: "Australian Central Time",
    group: [
      "Australia/Adelaide",
      "Australia/Broken_Hill",
      "Australia/South",
      "Australia/Yancowinna"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Australia",
    countryCode: "AU",
    mainCities: [
      "Adelaide",
      "Adelaide Hills",
      "Mount Gambier",
      "Morphett Vale"
    ],
    rawOffsetInMinutes: 570,
    abbreviation: "ACST",
    rawFormat: "+09:30 Australian Central Time - Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale"
  },
  {
    name: "Australia/Darwin",
    alternativeName: "Australian Central Time",
    group: [
      "Australia/Darwin",
      "Australia/North"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Australia",
    countryCode: "AU",
    mainCities: [
      "Darwin",
      "Alice Springs",
      "Palmerston"
    ],
    rawOffsetInMinutes: 570,
    abbreviation: "ACST",
    rawFormat: "+09:30 Australian Central Time - Darwin, Alice Springs, Palmerston"
  },
  {
    name: "Australia/Brisbane",
    alternativeName: "Australian Eastern Time",
    group: [
      "Australia/Brisbane",
      "Australia/Lindeman",
      "Australia/Queensland"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Australia",
    countryCode: "AU",
    mainCities: [
      "Brisbane",
      "Gold Coast",
      "Logan City",
      "Townsville"
    ],
    rawOffsetInMinutes: 600,
    abbreviation: "AEST",
    rawFormat: "+10:00 Australian Eastern Time - Brisbane, Gold Coast, Logan City, Townsville"
  },
  {
    name: "Australia/Sydney",
    alternativeName: "Australian Eastern Time",
    group: [
      "Antarctica/Macquarie",
      "Australia/Hobart",
      "Australia/Melbourne",
      "Australia/Sydney",
      "Australia/Tasmania",
      "Australia/Currie",
      "Australia/Victoria",
      "Australia/ACT",
      "Australia/NSW",
      "Australia/Canberra"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Australia",
    countryCode: "AU",
    mainCities: [
      "Sydney",
      "Melbourne",
      "Canberra",
      "Newcastle"
    ],
    rawOffsetInMinutes: 600,
    abbreviation: "AEST",
    rawFormat: "+10:00 Australian Eastern Time - Sydney, Melbourne, Canberra, Newcastle"
  },
  {
    name: "Pacific/Guam",
    alternativeName: "Chamorro Time",
    group: [
      "Pacific/Guam",
      "Pacific/Saipan"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Guam",
    countryCode: "GU",
    mainCities: [
      "Dededo Village",
      "Yigo Village",
      "Tamuning-Tumon-Harmon Village",
      "Tamuning"
    ],
    rawOffsetInMinutes: 600,
    abbreviation: "ChST",
    rawFormat: "+10:00 Chamorro Time - Dededo Village, Yigo Village, Tamuning-Tumon-Harmon Village, Tamuning"
  },
  {
    name: "Pacific/Saipan",
    alternativeName: "Chamorro Time",
    group: [
      "Pacific/Saipan"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Northern Mariana Islands",
    countryCode: "MP",
    mainCities: [
      "Saipan"
    ],
    rawOffsetInMinutes: 600,
    abbreviation: "ChST",
    rawFormat: "+10:00 Chamorro Time - Saipan"
  },
  {
    name: "Pacific/Chuuk",
    alternativeName: "Chuuk Time",
    group: [
      "Pacific/Chuuk",
      "Pacific/Truk",
      "Pacific/Yap"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Micronesia",
    countryCode: "FM",
    mainCities: [
      "Chuuk"
    ],
    rawOffsetInMinutes: 600,
    abbreviation: "CHUT",
    rawFormat: "+10:00 Chuuk Time - Chuuk"
  },
  {
    name: "Antarctica/DumontDUrville",
    alternativeName: "Dumont-d\u2019Urville Time",
    group: [
      "Antarctica/DumontDUrville"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "Antarctica",
    countryCode: "AQ",
    mainCities: [
      "DumontDUrville"
    ],
    rawOffsetInMinutes: 600,
    abbreviation: "DDUT",
    rawFormat: "+10:00 Dumont-d\u2019Urville Time - DumontDUrville"
  },
  {
    name: "Pacific/Port_Moresby",
    alternativeName: "Papua New Guinea Time",
    group: [
      "Pacific/Port_Moresby",
      "Antarctica/DumontDUrville",
      "Pacific/Chuuk",
      "Pacific/Yap",
      "Pacific/Truk"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Papua New Guinea",
    countryCode: "PG",
    mainCities: [
      "Port Moresby",
      "Lae",
      "Mount Hagen",
      "Popondetta"
    ],
    rawOffsetInMinutes: 600,
    abbreviation: "PGT",
    rawFormat: "+10:00 Papua New Guinea Time - Port Moresby, Lae, Mount Hagen, Popondetta"
  },
  {
    name: "Asia/Vladivostok",
    alternativeName: "Vladivostok Time",
    group: [
      "Asia/Ust-Nera",
      "Asia/Vladivostok"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Khabarovsk",
      "Vladivostok",
      "Khabarovsk Vtoroy",
      "Komsomolsk-on-Amur"
    ],
    rawOffsetInMinutes: 600,
    abbreviation: "VLAT",
    rawFormat: "+10:00 Vladivostok Time - Khabarovsk, Vladivostok, Khabarovsk Vtoroy, Komsomolsk-on-Amur"
  },
  {
    name: "Australia/Lord_Howe",
    alternativeName: "Lord Howe Time",
    group: [
      "Australia/Lord_Howe",
      "Australia/LHI"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Australia",
    countryCode: "AU",
    mainCities: [
      "Lord Howe"
    ],
    rawOffsetInMinutes: 630,
    abbreviation: "LHST",
    rawFormat: "+10:30 Lord Howe Time - Lord Howe"
  },
  {
    name: "Pacific/Bougainville",
    alternativeName: "Bougainville Time",
    group: [
      "Pacific/Bougainville"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Papua New Guinea",
    countryCode: "PG",
    mainCities: [
      "Arawa"
    ],
    rawOffsetInMinutes: 660,
    abbreviation: "BST",
    rawFormat: "+11:00 Bougainville Time - Arawa"
  },
  {
    name: "Pacific/Kosrae",
    alternativeName: "Kosrae Time",
    group: [
      "Pacific/Kosrae",
      "Pacific/Pohnpei"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Micronesia",
    countryCode: "FM",
    mainCities: [
      "Kosrae",
      "Palikir - National Government Center"
    ],
    rawOffsetInMinutes: 660,
    abbreviation: "KOST",
    rawFormat: "+11:00 Kosrae Time - Kosrae, Palikir - National Government Center"
  },
  {
    name: "Pacific/Noumea",
    alternativeName: "New Caledonia Time",
    group: [
      "Pacific/Noumea"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "New Caledonia",
    countryCode: "NC",
    mainCities: [
      "Noum\xE9a",
      "Mont-Dore",
      "Dumb\xE9a"
    ],
    rawOffsetInMinutes: 660,
    abbreviation: "NCT",
    rawFormat: "+11:00 New Caledonia Time - Noum\xE9a, Mont-Dore, Dumb\xE9a"
  },
  {
    name: "Pacific/Norfolk",
    alternativeName: "Norfolk Island Time",
    group: [
      "Pacific/Norfolk"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Norfolk Island",
    countryCode: "NF",
    mainCities: [
      "Kingston"
    ],
    rawOffsetInMinutes: 660,
    abbreviation: "NFT",
    rawFormat: "+11:00 Norfolk Island Time - Kingston"
  },
  {
    name: "Asia/Sakhalin",
    alternativeName: "Sakhalin Time",
    group: [
      "Asia/Magadan",
      "Asia/Sakhalin",
      "Asia/Srednekolymsk"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Yuzhno-Sakhalinsk",
      "Magadan",
      "Korsakov",
      "Kholmsk"
    ],
    rawOffsetInMinutes: 660,
    abbreviation: "SAKT",
    rawFormat: "+11:00 Sakhalin Time - Yuzhno-Sakhalinsk, Magadan, Korsakov, Kholmsk"
  },
  {
    name: "Pacific/Guadalcanal",
    alternativeName: "Solomon Islands Time",
    group: [
      "Pacific/Guadalcanal",
      "Pacific/Pohnpei",
      "Pacific/Ponape"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Solomon Islands",
    countryCode: "SB",
    mainCities: [
      "Honiara"
    ],
    rawOffsetInMinutes: 660,
    abbreviation: "SBT",
    rawFormat: "+11:00 Solomon Islands Time - Honiara"
  },
  {
    name: "Pacific/Efate",
    alternativeName: "Vanuatu Time",
    group: [
      "Pacific/Efate"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Vanuatu",
    countryCode: "VU",
    mainCities: [
      "Port-Vila"
    ],
    rawOffsetInMinutes: 660,
    abbreviation: "VUT",
    rawFormat: "+11:00 Vanuatu Time - Port-Vila"
  },
  {
    name: "Pacific/Fiji",
    alternativeName: "Fiji Time",
    group: [
      "Pacific/Fiji"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Fiji",
    countryCode: "FJ",
    mainCities: [
      "Nasinu",
      "Suva",
      "Lautoka",
      "Nadi"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "FJT",
    rawFormat: "+12:00 Fiji Time - Nasinu, Suva, Lautoka, Nadi"
  },
  {
    name: "Pacific/Tarawa",
    alternativeName: "Gilbert Islands Time",
    group: [
      "Pacific/Tarawa",
      "Pacific/Funafuti",
      "Pacific/Majuro",
      "Pacific/Wake",
      "Pacific/Wallis"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Kiribati",
    countryCode: "KI",
    mainCities: [
      "Tarawa"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "GILT",
    rawFormat: "+12:00 Gilbert Islands Time - Tarawa"
  },
  {
    name: "Pacific/Majuro",
    alternativeName: "Marshall Islands Time",
    group: [
      "Pacific/Kwajalein",
      "Pacific/Majuro",
      "Kwajalein"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Marshall Islands",
    countryCode: "MH",
    mainCities: [
      "Majuro",
      "Kwajalein",
      "RMI Capitol"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "MHT",
    rawFormat: "+12:00 Marshall Islands Time - Majuro, Kwajalein, RMI Capitol"
  },
  {
    name: "Pacific/Nauru",
    alternativeName: "Nauru Time",
    group: [
      "Pacific/Nauru"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Nauru",
    countryCode: "NR",
    mainCities: [
      "Yaren"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "NRT",
    rawFormat: "+12:00 Nauru Time - Yaren"
  },
  {
    name: "Pacific/Auckland",
    alternativeName: "New Zealand Time",
    group: [
      "Pacific/Auckland",
      "NZ",
      "Antarctica/McMurdo",
      "Antarctica/South_Pole"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "New Zealand",
    countryCode: "NZ",
    mainCities: [
      "Auckland",
      "Wellington",
      "Christchurch",
      "Manukau City"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "NZST",
    rawFormat: "+12:00 New Zealand Time - Auckland, Wellington, Christchurch, Manukau City"
  },
  {
    name: "Antarctica/McMurdo",
    alternativeName: "New Zealand Time",
    group: [
      "Antarctica/McMurdo"
    ],
    continentCode: "AN",
    continentName: "Antarctica",
    countryName: "Antarctica",
    countryCode: "AQ",
    mainCities: [
      "McMurdo"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "NZST",
    rawFormat: "+12:00 New Zealand Time - McMurdo"
  },
  {
    name: "Asia/Kamchatka",
    alternativeName: "Petropavlovsk-Kamchatski Time",
    group: [
      "Asia/Anadyr",
      "Asia/Kamchatka"
    ],
    continentCode: "EU",
    continentName: "Europe",
    countryName: "Russia",
    countryCode: "RU",
    mainCities: [
      "Petropavlovsk-Kamchatsky",
      "Yelizovo",
      "Vilyuchinsk",
      "Anadyr"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "PETT",
    rawFormat: "+12:00 Petropavlovsk-Kamchatski Time - Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Anadyr"
  },
  {
    name: "Pacific/Funafuti",
    alternativeName: "Tuvalu Time",
    group: [
      "Pacific/Funafuti"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Tuvalu",
    countryCode: "TV",
    mainCities: [
      "Funafuti"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "TVT",
    rawFormat: "+12:00 Tuvalu Time - Funafuti"
  },
  {
    name: "Pacific/Wake",
    alternativeName: "Wake Island Time",
    group: [
      "Pacific/Wake"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "United States Minor Outlying Islands",
    countryCode: "UM",
    mainCities: [
      "Wake"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "WAKT",
    rawFormat: "+12:00 Wake Island Time - Wake"
  },
  {
    name: "Pacific/Wallis",
    alternativeName: "Wallis & Futuna Time",
    group: [
      "Pacific/Wallis"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Wallis and Futuna",
    countryCode: "WF",
    mainCities: [
      "Mata-Utu"
    ],
    rawOffsetInMinutes: 720,
    abbreviation: "WFT",
    rawFormat: "+12:00 Wallis & Futuna Time - Mata-Utu"
  },
  {
    name: "Pacific/Chatham",
    alternativeName: "Chatham Time",
    group: [
      "Pacific/Chatham",
      "NZ-CHAT"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "New Zealand",
    countryCode: "NZ",
    mainCities: [
      "Chatham"
    ],
    rawOffsetInMinutes: 765,
    abbreviation: "CHAST",
    rawFormat: "+12:45 Chatham Time - Chatham"
  },
  {
    name: "Pacific/Apia",
    alternativeName: "Apia Time",
    group: [
      "Pacific/Apia"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Samoa",
    countryCode: "WS",
    mainCities: [
      "Apia"
    ],
    rawOffsetInMinutes: 780,
    abbreviation: "WST",
    rawFormat: "+13:00 Apia Time - Apia"
  },
  {
    name: "Pacific/Kanton",
    alternativeName: "Phoenix Islands Time",
    group: [
      "Pacific/Kanton",
      "Pacific/Enderbury"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Kiribati",
    countryCode: "KI",
    mainCities: [
      "Kanton"
    ],
    rawOffsetInMinutes: 780,
    abbreviation: "PHOT",
    rawFormat: "+13:00 Phoenix Islands Time - Kanton"
  },
  {
    name: "Pacific/Fakaofo",
    alternativeName: "Tokelau Time",
    group: [
      "Pacific/Fakaofo"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Tokelau",
    countryCode: "TK",
    mainCities: [
      "Fakaofo"
    ],
    rawOffsetInMinutes: 780,
    abbreviation: "TKT",
    rawFormat: "+13:00 Tokelau Time - Fakaofo"
  },
  {
    name: "Pacific/Tongatapu",
    alternativeName: "Tonga Time",
    group: [
      "Pacific/Tongatapu"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Tonga",
    countryCode: "TO",
    mainCities: [
      "Nuku\u2018alofa"
    ],
    rawOffsetInMinutes: 780,
    abbreviation: "TOT",
    rawFormat: "+13:00 Tonga Time - Nuku\u2018alofa"
  },
  {
    name: "Pacific/Kiritimati",
    alternativeName: "Line Islands Time",
    group: [
      "Pacific/Kiritimati"
    ],
    continentCode: "OC",
    continentName: "Oceania",
    countryName: "Kiribati",
    countryCode: "KI",
    mainCities: [
      "Kiritimati"
    ],
    rawOffsetInMinutes: 840,
    abbreviation: "LINT",
    rawFormat: "+14:00 Line Islands Time - Kiritimati"
  }
];
function format$1({
  alternativeName,
  mainCities,
  rawOffsetInMinutes,
  currentTimeOffsetInMinutes
}, {
  useCurrentOffset = !1
} = {}) {
  return `${getOffsetString(useCurrentOffset ? currentTimeOffsetInMinutes : rawOffsetInMinutes).padStart(6, "+")} ${alternativeName} - ${mainCities.join(", ")}`;
}
function getOffsetString(offsetInMinutes) {
  const absOffsetInMinutes = Math.abs(offsetInMinutes), [hours, minutes] = [Math.floor(absOffsetInMinutes / 60), absOffsetInMinutes % 60].map((v) => v.toString().padStart(2, "0")), durationInHoursMinutes = `${hours}:${minutes}`;
  return `${offsetInMinutes >= 0 ? "+" : "-"}${durationInHoursMinutes}`;
}
const ianaRegex = /^[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?$/, typeToPos$1 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function isValidIanaSpecifier(s) {
  return !!(s && s.match(ianaRegex));
}
function hackyOffset$1(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
}
function partsOffset$1(dtf, date) {
  const formatted = dtf.formatToParts(date), filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const {
      type,
      value
    } = formatted[i], pos = typeToPos$1[type];
    typeof pos < "u" && (filled[pos] = parseInt(value, 10));
  }
  return filled;
}
function makeDTF(zone) {
  return new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: zone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
}
function objToLocalTS(obj) {
  let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
  return obj.year < 100 && obj.year >= 0 && (d = new Date(d), d.setUTCFullYear(d.getUTCFullYear() - 1900)), +d;
}
function getZoneOffset(timeZoneName) {
  if (!isValidIanaSpecifier(timeZoneName))
    return !1;
  const date = new Date(Date.now());
  let dtf;
  try {
    dtf = makeDTF(timeZoneName);
  } catch {
    return !1;
  }
  const [year, month, day, hour, minute, second] = dtf.formatToParts ? partsOffset$1(dtf, date) : hackyOffset$1(dtf, date), asUTC = objToLocalTS({
    year,
    month,
    day,
    hour,
    minute,
    second,
    millisecond: 0
  });
  let asTS = +date;
  const over = asTS % 1e3;
  return asTS -= over >= 0 ? over : 1e3 + over, (asUTC - asTS) / (60 * 1e3);
}
function getTimeZones(opts) {
  return rawTimeZones.reduce(function(acc, timeZone) {
    const timeZoneName = timeZone.name, currentOffset = getZoneOffset(timeZoneName);
    if (currentOffset === !1)
      return acc;
    const timeZoneWithCurrentTimeData = {
      ...timeZone,
      currentTimeOffsetInMinutes: currentOffset
    };
    return acc.push({
      ...timeZoneWithCurrentTimeData,
      currentTimeFormat: format$1(timeZoneWithCurrentTimeData, {
        useCurrentOffset: !0
      })
    }), acc;
  }, []).sort((a, b) => compareNumbers(a, b) || compareStrings(a.alternativeName, b.alternativeName) || compareStrings(a.mainCities[0], b.mainCities[0]));
}
function compareNumbers(x, y) {
  return x.currentTimeOffsetInMinutes - y.currentTimeOffsetInMinutes;
}
function compareStrings(x, y) {
  return typeof x == "string" && typeof y == "string" ? x.localeCompare(y) : 0;
}
function tzIntlTimeZoneName(length, date, options) {
  var dtf = getDTF(length, options.timeZone, options.locale);
  return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}
function partsTimeZone(dtf, date) {
  for (var formatted = dtf.formatToParts(date), i = formatted.length - 1; i >= 0; --i)
    if (formatted[i].type === "timeZoneName")
      return formatted[i].value;
}
function hackyTimeZone(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, ""), tzNameMatch = / [\w-+ ]+$/.exec(formatted);
  return tzNameMatch ? tzNameMatch[0].substr(1) : "";
}
function getDTF(length, timeZone, locale) {
  if (locale && !locale.code)
    throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
  return new Intl.DateTimeFormat(locale ? [locale.code, "en-US"] : void 0, {
    timeZone,
    timeZoneName: length
  });
}
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function partsOffset(dtf, date) {
  try {
    for (var formatted = dtf.formatToParts(date), filled = [], i = 0; i < formatted.length; i++) {
      var pos = typeToPos[formatted[i].type];
      pos >= 0 && (filled[pos] = parseInt(formatted[i].value, 10));
    }
    return filled;
  } catch (error) {
    if (error instanceof RangeError)
      return [NaN];
    throw error;
  }
}
function hackyOffset(dtf, date) {
  var formatted = dtf.format(date), parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
}
var dtfCache = {};
function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    var testDateFormatted = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
    dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return dtfCache[timeZone];
}
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  var utcDate = /* @__PURE__ */ new Date(0);
  return utcDate.setUTCFullYear(fullYear, month, day), utcDate.setUTCHours(hour, minute, second, millisecond), utcDate;
}
var MILLISECONDS_IN_HOUR$1 = 36e5, MILLISECONDS_IN_MINUTE$2 = 6e4, patterns$1 = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token, absoluteOffset;
  if (!timezoneString || (token = patterns$1.timezoneZ.exec(timezoneString), token))
    return 0;
  var hours;
  if (token = patterns$1.timezoneHH.exec(timezoneString), token)
    return hours = parseInt(token[1], 10), validateTimezone(hours) ? -(hours * MILLISECONDS_IN_HOUR$1) : NaN;
  if (token = patterns$1.timezoneHHMM.exec(timezoneString), token) {
    hours = parseInt(token[2], 10);
    var minutes = parseInt(token[3], 10);
    return validateTimezone(hours, minutes) ? (absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$2, token[1] === "+" ? -absoluteOffset : absoluteOffset) : NaN;
  }
  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now());
    var utcDate = isUtcDate ? date : toUtcDate(date), offset = calcOffset(utcDate, timezoneString), fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
    return -fixedOffset;
  }
  return NaN;
}
function toUtcDate(date) {
  return newDateUTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function calcOffset(date, timezoneString) {
  var tokens = tzTokenizeDate(date, timezoneString), asUTC = newDateUTC(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime(), asTS = date.getTime(), over = asTS % 1e3;
  return asTS -= over >= 0 ? over : 1e3 + over, asUTC - asTS;
}
function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime(), utcGuess = localTS - offset, o2 = calcOffset(new Date(utcGuess), timezoneString);
  if (offset === o2)
    return offset;
  utcGuess -= o2 - offset;
  var o3 = calcOffset(new Date(utcGuess), timezoneString);
  return o2 === o3 ? o2 : Math.max(o2, o3);
}
function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return !0;
  try {
    return new Intl.DateTimeFormat(void 0, {
      timeZone: timeZoneString
    }), validIANATimezoneCache[timeZoneString] = !0, !0;
  } catch {
    return !1;
  }
}
var MILLISECONDS_IN_MINUTE$1 = 60 * 1e3, formatters = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
    if (timezoneOffset === 0)
      return "Z";
    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token, localize, options) {
    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return tzIntlTimeZoneName("short", date, options);
      // Long
      case "zzzz":
      default:
        return tzIntlTimeZoneName("long", date, options);
    }
  }
};
function getTimeZoneOffset(timeZone, originalDate) {
  var timeZoneOffset = timeZone ? tzParseTimezone(timeZone, originalDate, !0) / MILLISECONDS_IN_MINUTE$1 : originalDate.getTimezoneOffset();
  if (Number.isNaN(timeZoneOffset))
    throw new RangeError("Invalid time zone specified: " + timeZone);
  return timeZoneOffset;
}
function addLeadingZeros(number, targetLength) {
  for (var sign = number < 0 ? "-" : "", output = Math.abs(number).toString(); output.length < targetLength; )
    output = "0" + output;
  return sign + output;
}
function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || "", sign = offset > 0 ? "-" : "+", absOffset = Math.abs(offset), hours = addLeadingZeros(Math.floor(absOffset / 60), 2), minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
  return sign + hours + delimeter + minutes;
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimeter);
}
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? "-" : "+", absOffset = Math.abs(offset), hours = Math.floor(absOffset / 60), minutes = absOffset % 60;
  if (minutes === 0)
    return sign + String(hours);
  var delimiter = dirtyDelimiter;
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, MILLISECONDS_IN_HOUR = 36e5, MILLISECONDS_IN_MINUTE = 6e4, DEFAULT_ADDITIONAL_DIGITS = 2, patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: tzPattern
};
function toDate(argument, dirtyOptions) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (argument === null)
    return /* @__PURE__ */ new Date(NaN);
  var options = dirtyOptions || {}, additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (argument instanceof Date || typeof argument == "object" && Object.prototype.toString.call(argument) === "[object Date]")
    return new Date(argument.getTime());
  if (typeof argument == "number" || Object.prototype.toString.call(argument) === "[object Number]")
    return new Date(argument);
  if (!(typeof argument == "string" || Object.prototype.toString.call(argument) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var dateStrings = splitDateString(argument), parseYearResult = parseYear(dateStrings.date, additionalDigits), year = parseYearResult.year, restDateString = parseYearResult.restDateString, date = parseDate$1(restDateString, year);
  if (isNaN(date))
    return /* @__PURE__ */ new Date(NaN);
  if (date) {
    var timestamp = date.getTime(), time = 0, offset;
    if (dateStrings.time && (time = parseTime(dateStrings.time), isNaN(time)))
      return /* @__PURE__ */ new Date(NaN);
    if (dateStrings.timeZone || options.timeZone) {
      if (offset = tzParseTimezone(dateStrings.timeZone || options.timeZone, new Date(timestamp + time)), isNaN(offset))
        return /* @__PURE__ */ new Date(NaN);
    } else
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time)), offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset));
    return new Date(timestamp + time + offset);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function splitDateString(dateString) {
  var dateStrings = {}, parts = patterns.dateTimePattern.exec(dateString), timeString;
  if (parts ? (dateStrings.date = parts[1], timeString = parts[3]) : (parts = patterns.datePattern.exec(dateString), parts ? (dateStrings.date = parts[1], timeString = parts[2]) : (dateStrings.date = null, timeString = dateString)), timeString) {
    var token = patterns.timeZone.exec(timeString);
    token ? (dateStrings.time = timeString.replace(token[1], ""), dateStrings.timeZone = token[1].trim()) : dateStrings.time = timeString;
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits], patternYYYYY = patterns.YYYYY[additionalDigits], token;
  if (token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString), token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  }
  if (token = patterns.YY.exec(dateString) || patternYYY.exec(dateString), token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  }
  return {
    year: null
  };
}
function parseDate$1(dateString, year) {
  if (year === null)
    return null;
  var token, date, month, week;
  if (dateString.length === 0)
    return date = /* @__PURE__ */ new Date(0), date.setUTCFullYear(year), date;
  if (token = patterns.MM.exec(dateString), token)
    return date = /* @__PURE__ */ new Date(0), month = parseInt(token[1], 10) - 1, validateDate(year, month) ? (date.setUTCFullYear(year, month), date) : /* @__PURE__ */ new Date(NaN);
  if (token = patterns.DDD.exec(dateString), token) {
    date = /* @__PURE__ */ new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    return validateDayOfYearDate(year, dayOfYear) ? (date.setUTCFullYear(year, 0, dayOfYear), date) : /* @__PURE__ */ new Date(NaN);
  }
  if (token = patterns.MMDD.exec(dateString), token) {
    date = /* @__PURE__ */ new Date(0), month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    return validateDate(year, month, day) ? (date.setUTCFullYear(year, month, day), date) : /* @__PURE__ */ new Date(NaN);
  }
  if (token = patterns.Www.exec(dateString), token)
    return week = parseInt(token[1], 10) - 1, validateWeekDate(year, week) ? dayOfISOWeekYear(year, week) : /* @__PURE__ */ new Date(NaN);
  if (token = patterns.WwwD.exec(dateString), token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    return validateWeekDate(year, week, dayOfWeek) ? dayOfISOWeekYear(year, week, dayOfWeek) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function parseTime(timeString) {
  var token, hours, minutes;
  if (token = patterns.HH.exec(timeString), token)
    return hours = parseFloat(token[1].replace(",", ".")), validateTime(hours) ? hours % 24 * MILLISECONDS_IN_HOUR : NaN;
  if (token = patterns.HHMM.exec(timeString), token)
    return hours = parseInt(token[1], 10), minutes = parseFloat(token[2].replace(",", ".")), validateTime(hours, minutes) ? hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE : NaN;
  if (token = patterns.HHMMSS.exec(timeString), token) {
    hours = parseInt(token[1], 10), minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(",", "."));
    return validateTime(hours, minutes, seconds) ? hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1e3 : NaN;
  }
  return null;
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0, day = day || 0;
  var date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7, diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  return date.setUTCDate(date.getUTCDate() + diff), date;
}
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  if (month < 0 || month > 11)
    return !1;
  if (date != null) {
    if (date < 1)
      return !1;
    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month] || !isLeapYear && date > DAYS_IN_MONTH[month])
      return !1;
  }
  return !0;
}
function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1)
    return !1;
  var isLeapYear = isLeapYearIndex(year);
  return !(isLeapYear && dayOfYear > 366 || !isLeapYear && dayOfYear > 365);
}
function validateWeekDate(year, week, day) {
  return !(week < 0 || week > 52 || day != null && (day < 0 || day > 6));
}
function validateTime(hours, minutes, seconds) {
  return !(hours != null && (hours < 0 || hours >= 25) || minutes != null && (minutes < 0 || minutes >= 60) || seconds != null && (seconds < 0 || seconds >= 60));
}
var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr), options = dirtyOptions || {}, matches = formatStr.match(tzFormattingTokensRegExp);
  if (matches) {
    var date = toDate(options.originalDate || dirtyDate, options);
    formatStr = matches.reduce(function(result, token) {
      if (token[0] === "'")
        return result;
      var pos = result.indexOf(token), precededByQuotedSection = result[pos - 1] === "'", replaced = result.replace(token, "'" + formatters[token[0]](date, token, null, options) + "'");
      return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
    }, formatStr);
  }
  return dateFnsFormat(dirtyDate, formatStr, options);
}
function utcToZonedTime(dirtyDate, timeZone, options) {
  var date = toDate(dirtyDate, options), offsetMilliseconds = tzParseTimezone(timeZone, date, !0), d = new Date(date.getTime() - offsetMilliseconds), resultDate = /* @__PURE__ */ new Date(0);
  return resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), resultDate;
}
function formatInTimeZone(date, timeZone, formatStr, options) {
  var extendedOptions = cloneObject(options);
  return extendedOptions.timeZone = timeZone, extendedOptions.originalDate = date, format(utcToZonedTime(date, timeZone), formatStr, extendedOptions);
}
function zonedTimeToUtc(date, timeZone, options) {
  if (typeof date == "string" && !date.match(tzPattern)) {
    var extendedOptions = cloneObject(options);
    return extendedOptions.timeZone = timeZone, toDate(date, extendedOptions);
  }
  var d = toDate(date, options), utc = newDateUTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime(), offsetMilliseconds = tzParseTimezone(timeZone, new Date(utc));
  return new Date(utc + offsetMilliseconds);
}
const ToastDescription = (props2) => {
  const $ = c(10), {
    body,
    title
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(CalendarIcon, {}), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== title ? (t1 = title && /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "semibold", children: title }), $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    t0,
    t1
  ] }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== body ? (t3 = body && /* @__PURE__ */ jsx(Text$1, { size: 1, children: body }), $[5] = body, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== t2 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { paddingY: 1, space: 3, children: [
    t2,
    t3
  ] }), $[7] = t2, $[8] = t3, $[9] = t4) : t4 = $[9], t4;
}, LOCAL_STORAGE_TZ_KEY = "scheduled-publishing::time-zone", SCHEDULE_ACTION_DICTIONARY = {
  publish: {
    actionName: "Publishing",
    badgeColor: "primary",
    badgeTone: "positive"
  },
  unpublish: {
    actionName: "Unpublishing",
    badgeColor: "danger",
    badgeTone: "critical"
  }
}, SCHEDULE_STATE_DICTIONARY = {
  scheduled: {
    title: "Upcoming"
  },
  succeeded: {
    title: "Completed"
  },
  cancelled: {
    title: "Failed"
  }
}, SCHEDULE_FILTERS = Object.keys(SCHEDULE_STATE_DICTIONARY).filter((f) => !!f), TOOL_HEADER_HEIGHT = 55, DOCUMENT_HAS_WARNINGS_TEXT = "This document has validation warnings.", DOCUMENT_HAS_ERRORS_TEXT = "This document has validation errors that should be resolved before its publish date.", SCHEDULE_FAILED_TEXT = "This schedule failed to run.", FORBIDDEN_RESPONSE_TEXT = "Forbidden. Please check that your project has access to Scheduled Publishing.", DATE_FORMAT = {
  // 1 Oct 22, 10:00 PM
  SMALL: "d MMM yy',' p",
  // 1 October 2022, 10:00 PM
  MEDIUM: "d MMMM yyyy',' p",
  // Saturday, 1 October 2022, 10:00 PM
  LARGE: "iiii',' d MMMM yyyy',' p"
}, DEFAULT_SCHEDULED_PUBLISH_PLUGIN_OPTIONS = {
  enabled: !0,
  // 25/12/2022 22:00
  inputDateTimeFormat: "dd/MM/yyyy HH:mm",
  showReleasesBanner: !0
}, SCHEDULED_PUBLISHING_TOOL_NAME = "schedules", TOOL_TITLE = "Schedules", RELEASES_DOCS_URL = "https://www.sanity.io/blog/introducing-content-releases", rootName$1 = "scheduled-publishing:";
debug$7(rootName$1);
function debugWithName$1(name) {
  const namespace = `${rootName$1}${name}`;
  return debug$7 && debug$7.enabled(namespace) ? debug$7(namespace) : debug$7(rootName$1);
}
function isClientError(e) {
  return typeof e != "object" || !e ? !1 : "statusCode" in e && "response" in e;
}
function getErrorMessage(err) {
  let message;
  return isClientError(err) ? err.response.statusCode === 403 ? message = FORBIDDEN_RESPONSE_TEXT : message = err.message : (err instanceof Error && (message = err.message), message = String(err)), message;
}
var TimeZoneEvents = /* @__PURE__ */ function(TimeZoneEvents2) {
  return TimeZoneEvents2.update = "timeZoneEventUpdate", TimeZoneEvents2;
}(TimeZoneEvents || {});
const debug$6 = debugWithName$1("useScheduleOperation"), allTimeZones = getTimeZones().map((tz) => ({
  abbreviation: tz.abbreviation,
  alternativeName: tz.alternativeName,
  mainCities: tz.mainCities.join(", "),
  // Main time zone name 'Africa/Dar_es_Salaam'
  name: tz.name,
  // Time zone name with underscores removed
  namePretty: tz.name.replaceAll("_", " "),
  offset: tz.currentTimeFormat.split(" ")[0],
  // all searchable text - this is transformed before being rendered in `<AutoComplete>`
  value: `${tz.currentTimeFormat} ${tz.abbreviation} ${tz.name}`
}));
function getLocalTimeZone() {
  return allTimeZones.find((tz) => tz.name === Intl.DateTimeFormat().resolvedOptions().timeZone) || // Default to GMT-0 if no user timeZone is found
  allTimeZones.find((timeZone) => timeZone.abbreviation === "GMT") || // Return the first time zone as a fallback
  allTimeZones[0];
}
function getStoredTimeZone() {
  const storedTimeZone = localStorage.getItem(LOCAL_STORAGE_TZ_KEY);
  try {
    if (storedTimeZone)
      return JSON.parse(storedTimeZone);
  } catch {
  }
  return getLocalTimeZone();
}
const useTimeZone = () => {
  const [timeZone, setTimeZone] = useState(() => getStoredTimeZone()), toast = useToast();
  useEffect(() => {
    const handler = () => {
      setTimeZone(getStoredTimeZone());
    };
    return window.addEventListener(TimeZoneEvents.update, handler), () => {
      window.removeEventListener(TimeZoneEvents.update, handler);
    };
  }, []);
  const formatDateTz = useCallback(({
    date,
    format: format2 = DATE_FORMAT.LARGE,
    includeTimeZone,
    prefix
  }) => {
    let dateFormat = format2;
    return prefix && (dateFormat = `'${prefix}'${format2}`), includeTimeZone && (dateFormat = `${format2} (zzzz)`), formatInTimeZone(date, timeZone.name, dateFormat);
  }, [timeZone.name]), getCurrentZoneDate = useCallback(() => utcToZonedTime(/* @__PURE__ */ new Date(), timeZone.name), [timeZone.name]), handleNewValue = useCallback((tz) => {
    debug$6("handleNewValue:", tz), setTimeZone((prevTz) => {
      try {
        prevTz.name !== tz.name && (localStorage.setItem(LOCAL_STORAGE_TZ_KEY, JSON.stringify(tz)), window.dispatchEvent(new Event(TimeZoneEvents.update)));
      } catch (err) {
        console.error(err), toast.push({
          closable: !0,
          description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err), title: "Unable to update time zone" }),
          status: "error"
        });
      }
      return tz;
    });
  }, [toast]), utcToCurrentZoneDate = useCallback((date_0) => utcToZonedTime(date_0, timeZone.name), [timeZone.name]), zoneDateToUtc = useCallback((date_1) => zonedTimeToUtc(date_1, timeZone.name), [timeZone.name]);
  return {
    formatDateTz,
    getCurrentZoneDate,
    setTimeZone: handleNewValue,
    timeZone,
    utcToCurrentZoneDate,
    zoneDateToUtc
  };
}, ReleaseAvatarIcon = (t0) => {
  const $ = c(5), {
    tone
  } = t0, t1 = `release-avatar-${tone}`, t2 = `var(--card-badge-${tone}-icon-color)`;
  let t3;
  $[0] !== t2 ? (t3 = {
    "--card-icon-color": t2
  }, $[0] = t2, $[1] = t3) : t3 = $[1];
  const t4 = t3;
  let t5;
  return $[2] !== t1 || $[3] !== t4 ? (t5 = /* @__PURE__ */ jsx(DotIcon, { "data-testid": t1, style: t4 }), $[2] = t1, $[3] = t4, $[4] = t5) : t5 = $[4], t5;
};
function ReleaseAvatar(t0) {
  const $ = c(9), {
    fontSize: t1,
    padding: t2,
    tone
  } = t0, fontSize = t1 === void 0 ? 1 : t1, padding = t2 === void 0 ? 3 : t2;
  let t3;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    borderRadius: 3
  }, $[0] = t3) : t3 = $[0];
  let t4;
  $[1] !== tone ? (t4 = /* @__PURE__ */ jsx(ReleaseAvatarIcon, { tone }), $[1] = tone, $[2] = t4) : t4 = $[2];
  let t5;
  $[3] !== fontSize || $[4] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: fontSize, children: t4 }), $[3] = fontSize, $[4] = t4, $[5] = t5) : t5 = $[5];
  let t6;
  return $[6] !== padding || $[7] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { flex: "none", padding, style: t3, children: t5 }), $[6] = padding, $[7] = t5, $[8] = t6) : t6 = $[8], t6;
}
const TimeZoneAlternativeNameSpan = styled.span(({
  theme
}) => css`
    color: ${theme.sanity.color.base.fg};
    font-weight: 500;
    margin-left: 1em;
  `), TimeZoneMainCitiesSpan = styled.span(({
  theme
}) => css`
    color: ${theme.sanity.color.input.default.readOnly.fg};
    margin-left: 1em;
  `), DialogTimeZone = (props2) => {
  const $ = c(30), {
    onClose
  } = props2, {
    setTimeZone,
    timeZone
  } = useTimeZone(), [selectedTz, setSelectedTz] = useState(timeZone);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = (value) => {
    const tz = allTimeZones.find((v) => v.value === value);
    setSelectedTz(tz);
  }, $[0] = t0) : t0 = $[0];
  const handleTimeZoneChange = t0;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setSelectedTz(getLocalTimeZone());
  }, $[1] = t1) : t1 = $[1];
  const handleTimeZoneSelectLocal = t1;
  let t2;
  $[2] !== onClose || $[3] !== selectedTz || $[4] !== setTimeZone ? (t2 = () => {
    selectedTz && setTimeZone(selectedTz), onClose?.();
  }, $[2] = onClose, $[3] = selectedTz, $[4] = setTimeZone, $[5] = t2) : t2 = $[5];
  const handleTimeZoneUpdate = t2, isDirty = selectedTz?.name !== timeZone.name;
  let t3;
  t3 = selectedTz?.name === getLocalTimeZone().name;
  const isLocalTzSelected = t3, renderOption = _temp$2A, renderValue = _temp2$X, t4 = !isDirty || !selectedTz;
  let t5;
  $[6] !== handleTimeZoneUpdate || $[7] !== t4 ? (t5 = {
    confirmButton: {
      text: "Update time zone",
      disabled: t4,
      onClick: handleTimeZoneUpdate,
      tone: "primary"
    }
  }, $[6] = handleTimeZoneUpdate, $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: "The selected time zone will change how dates are represented in schedules." }), $[9] = t6) : t6 = $[9];
  let t7;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: "Time zone" }), $[10] = t7) : t7 = $[10];
  let t8;
  $[11] !== isLocalTzSelected ? (t8 = isLocalTzSelected && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: "local time" }), $[11] = isLocalTzSelected, $[12] = t8) : t8 = $[12];
  let t9;
  $[13] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    t7,
    t8
  ] }), $[13] = t8, $[14] = t9) : t9 = $[14];
  let t10;
  $[15] !== isLocalTzSelected ? (t10 = !isLocalTzSelected && /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx("a", { onClick: handleTimeZoneSelectLocal, style: {
    cursor: "pointer"
  }, children: "Select local time zone" }) }), $[15] = isLocalTzSelected, $[16] = t10) : t10 = $[16];
  let t11;
  $[17] !== t10 || $[18] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", children: [
    t9,
    t10
  ] }), $[17] = t10, $[18] = t9, $[19] = t11) : t11 = $[19];
  let t12;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    boundaryElement: document.querySelector("body"),
    constrainSize: !0,
    placement: "bottom-start"
  }, $[20] = t12) : t12 = $[20];
  const t13 = selectedTz?.value;
  let t14;
  $[21] !== t13 ? (t14 = /* @__PURE__ */ jsx(Autocomplete, { fontSize: 2, icon: SearchIcon, id: "timezone", onChange: handleTimeZoneChange, openButton: !0, options: allTimeZones, padding: 4, placeholder: "Search for a city or time zone", popover: t12, renderOption, renderValue, tabIndex: -1, value: t13 }), $[21] = t13, $[22] = t14) : t14 = $[22];
  let t15;
  $[23] !== t11 || $[24] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Stack, { padding: 4, space: 5, children: [
    t6,
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t11,
      t14
    ] })
  ] }), $[23] = t11, $[24] = t14, $[25] = t15) : t15 = $[25];
  let t16;
  return $[26] !== onClose || $[27] !== t15 || $[28] !== t5 ? (t16 = /* @__PURE__ */ jsx(Dialog$1, { footer: t5, header: "Select time zone", id: "time-zone", onClose, width: 1, children: t15 }), $[26] = onClose, $[27] = t15, $[28] = t5, $[29] = t16) : t16 = $[29], t16;
};
function _temp$2A(option) {
  return /* @__PURE__ */ jsx(Card, { as: "button", padding: 3, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, textOverflow: "ellipsis", children: [
    /* @__PURE__ */ jsxs("span", { children: [
      "GMT",
      option.offset
    ] }),
    /* @__PURE__ */ jsx(TimeZoneAlternativeNameSpan, { children: option.alternativeName }),
    /* @__PURE__ */ jsx(TimeZoneMainCitiesSpan, { children: option.mainCities })
  ] }) });
}
function _temp2$X(_value, option_0) {
  return option_0 ? `${option_0.alternativeName} (${option_0.namePretty})` : "";
}
function useDialogVisible() {
  const $ = c(4), [dialogVisible, setDialogVisible] = useState(!1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setDialogVisible(!1);
  }, $[0] = t0) : t0 = $[0];
  const hide = t0;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setDialogVisible(!0);
  }, $[1] = t1) : t1 = $[1];
  const show = t1;
  let t2;
  return $[2] !== dialogVisible ? (t2 = {
    visible: dialogVisible,
    show,
    hide
  }, $[2] = dialogVisible, $[3] = t2) : t2 = $[3], t2;
}
function useDialogTimeZone() {
  const $ = c(8), {
    visible,
    show,
    hide
  } = useDialogVisible();
  let t0;
  $[0] !== hide || $[1] !== visible ? (t0 = {
    onClose: hide,
    visible
  }, $[0] = hide, $[1] = visible, $[2] = t0) : t0 = $[2];
  const dialogProps = t0, t1 = visible ? DialogTimeZone : null;
  let t2;
  return $[3] !== dialogProps || $[4] !== hide || $[5] !== show || $[6] !== t1 ? (t2 = {
    DialogTimeZone: t1,
    dialogProps,
    dialogTimeZoneShow: show,
    hide
  }, $[3] = dialogProps, $[4] = hide, $[5] = show, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
const LazyTextInput = forwardRef(function(t0, forwardedRef) {
  const $ = c(22);
  let onBlur, onChange, onKeyPress, rest, value;
  $[0] !== t0 ? ({
    onChange,
    onBlur,
    onKeyPress,
    value,
    ...rest
  } = t0, $[0] = t0, $[1] = onBlur, $[2] = onChange, $[3] = onKeyPress, $[4] = rest, $[5] = value) : (onBlur = $[1], onChange = $[2], onKeyPress = $[3], rest = $[4], value = $[5]);
  const [inputValue, setInputValue] = useState();
  let t1;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t1 = (event) => {
    setInputValue(event.currentTarget.value);
  }, $[6] = t1) : t1 = $[6];
  const handleChange = t1;
  let t2;
  $[7] !== onChange || $[8] !== value ? (t2 = (event_0) => {
    event_0.currentTarget.value !== `${value}` && onChange && onChange(event_0), setInputValue(void 0);
  }, $[7] = onChange, $[8] = value, $[9] = t2) : t2 = $[9];
  const checkEvent = t2;
  let t3;
  $[10] !== checkEvent || $[11] !== onBlur ? (t3 = (e) => {
    checkEvent(e), onBlur && onBlur(e);
  }, $[10] = checkEvent, $[11] = onBlur, $[12] = t3) : t3 = $[12];
  const handleBlur = t3;
  let t4;
  $[13] !== checkEvent || $[14] !== onKeyPress ? (t4 = (e_0) => {
    e_0.key === "Enter" && checkEvent(e_0), onKeyPress && onKeyPress(e_0);
  }, $[13] = checkEvent, $[14] = onKeyPress, $[15] = t4) : t4 = $[15];
  const handleKeyPress = t4, t5 = inputValue === void 0 ? value : inputValue;
  let t6;
  return $[16] !== forwardedRef || $[17] !== handleBlur || $[18] !== handleKeyPress || $[19] !== rest || $[20] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextInput$1, { ...rest, ref: forwardedRef, value: t5, onChange: handleChange, onBlur: handleBlur, onKeyPress: handleKeyPress }), $[16] = forwardedRef, $[17] = handleBlur, $[18] = handleKeyPress, $[19] = rest, $[20] = t5, $[21] = t6) : t6 = $[21], t6;
}), TimeInput = styled(LazyTextInput).attrs(() => ({
  type: "time"
}))`
  line-height: 1;
`;
function CalendarDay$4(props2) {
  const $ = c(27), {
    date,
    focused,
    isCurrentMonth,
    isToday: isToday2,
    onSelect,
    selected,
    isPastDisabled
  } = props2;
  let t0;
  $[0] !== date || $[1] !== onSelect ? (t0 = () => {
    onSelect(date);
  }, $[0] = date, $[1] = onSelect, $[2] = t0) : t0 = $[2];
  const handleClick = t0;
  let t1;
  $[3] !== date ? (t1 = date.toDateString(), $[3] = date, $[4] = t1) : t1 = $[4];
  const t2 = focused ? "true" : "";
  let t3;
  $[5] !== date || $[6] !== isPastDisabled || $[7] !== isToday2 ? (t3 = isPastDisabled && !isToday2 && isPast(date), $[5] = date, $[6] = isPastDisabled, $[7] = isToday2, $[8] = t3) : t3 = $[8];
  const t4 = isToday2 || selected ? "primary" : "default", t5 = !selected && !isCurrentMonth;
  let t6;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    textAlign: "center"
  }, $[9] = t6) : t6 = $[9];
  const t7 = isCurrentMonth ? "medium" : "regular";
  let t8;
  $[10] !== date ? (t8 = date.getDate(), $[10] = date, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== t5 || $[13] !== t7 || $[14] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { muted: t5, size: 1, style: t6, weight: t7, children: t8 }), $[12] = t5, $[13] = t7, $[14] = t8, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== handleClick || $[17] !== selected || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { "aria-label": t1, "aria-pressed": selected, as: "button", __unstable_focusRing: !0, "data-weekday": !0, "data-focused": t2, role: "button", tabIndex: -1, disabled: t3, onClick: handleClick, padding: 2, radius: 2, selected, tone: t4, children: t9 }), $[16] = handleClick, $[17] = selected, $[18] = t1, $[19] = t2, $[20] = t3, $[21] = t4, $[22] = t9, $[23] = t10) : t10 = $[23];
  let t11;
  return $[24] !== selected || $[25] !== t10 ? (t11 = /* @__PURE__ */ jsx("div", { "aria-selected": selected, "data-ui": "CalendarDay", children: t10 }), $[24] = selected, $[25] = t10, $[26] = t11) : t11 = $[26], t11;
}
const DEFAULT_MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], DEFAULT_WEEK_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], ARROW_KEYS$2 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], TAIL_WEEKDAYS$2 = [1, 2, 3, 4, 5, 6], getWeekStartsOfMonth$2 = (date, weekStartsOn) => {
  const firstDay = startOfMonth(date);
  return eachWeekOfInterval({
    start: firstDay,
    end: lastDayOfMonth(firstDay)
  }, {
    weekStartsOn: weekStartsOn === 7 ? 0 : weekStartsOn
  });
}, getWeekDaysFromWeekStarts$2 = (weekStarts) => weekStarts.map((weekStart) => [weekStart, ...TAIL_WEEKDAYS$2.map((d) => addDays(weekStart, d))]), useWeeksOfMonth$1 = (date) => {
  const $ = c(3), {
    weekInfo
  } = useCurrentLocale();
  let t0;
  return $[0] !== date || $[1] !== weekInfo.firstDay ? (t0 = getWeekDaysFromWeekStarts$2(getWeekStartsOfMonth$2(date, weekInfo.firstDay)).map(_temp$2z), $[0] = date, $[1] = weekInfo.firstDay, $[2] = t0) : t0 = $[2], t0;
};
function _temp$2z(days) {
  return {
    number: getWeek(days[0]),
    days
  };
}
function CalendarMonth$3(props2) {
  const $ = c(24), {
    weekInfo: t0
  } = useCurrentLocale(), {
    firstDay: weekStartDay
  } = t0;
  let weekDayNames = props2.weekDayNames;
  if (weekStartDay === 7) {
    let t12;
    $[0] !== props2.weekDayNames ? (t12 = [props2.weekDayNames[6], ...props2.weekDayNames.slice(0, 6)], $[0] = props2.weekDayNames, $[1] = t12) : t12 = $[1], weekDayNames = t12;
  } else if (weekStartDay === 6) {
    let t12;
    $[2] !== props2.weekDayNames ? (t12 = [...props2.weekDayNames.slice(5), ...props2.weekDayNames.slice(0, 5)], $[2] = props2.weekDayNames, $[3] = t12) : t12 = $[3], weekDayNames = t12;
  }
  const t1 = props2.hidden || !1;
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    gridTemplateColumns: "repeat(7, minmax(44px, 46px))"
  }, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== weekDayNames ? (t3 = weekDayNames.map(_temp$2y), $[5] = weekDayNames, $[6] = t3) : t3 = $[6];
  const t4 = useWeeksOfMonth$1(props2.date);
  let t5;
  if ($[7] !== props2.focused || $[8] !== props2.isPastDisabled || $[9] !== props2.onSelect || $[10] !== props2.selected || $[11] !== t4) {
    let t62;
    $[13] !== props2.focused || $[14] !== props2.isPastDisabled || $[15] !== props2.onSelect || $[16] !== props2.selected ? (t62 = (week, weekIdx) => week.days.map((date, dayIdx) => {
      const focused = props2.focused && isSameDay(date, props2.focused), selected = props2.selected && isSameDay(date, props2.selected), isToday2 = isSameDay(date, /* @__PURE__ */ new Date()), isCurrentMonth = props2.focused && isSameMonth(date, props2.focused);
      return /* @__PURE__ */ jsx(CalendarDay$4, { date, focused, isCurrentMonth, isToday: isToday2, onSelect: props2.onSelect, selected, isPastDisabled: props2.isPastDisabled }, `${weekIdx}-${dayIdx}`);
    }), $[13] = props2.focused, $[14] = props2.isPastDisabled, $[15] = props2.onSelect, $[16] = props2.selected, $[17] = t62) : t62 = $[17], t5 = t4.map(t62), $[7] = props2.focused, $[8] = props2.isPastDisabled, $[9] = props2.onSelect, $[10] = props2.selected, $[11] = t4, $[12] = t5;
  } else
    t5 = $[12];
  let t6;
  $[18] !== t3 || $[19] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Grid, { gap: 1, style: t2, children: [
    t3,
    t5
  ] }), $[18] = t3, $[19] = t5, $[20] = t6) : t6 = $[20];
  let t7;
  return $[21] !== t1 || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { "aria-hidden": t1, "data-ui": "CalendarMonth", children: t6 }), $[21] = t1, $[22] = t6, $[23] = t7) : t7 = $[23], t7;
}
function _temp$2y(weekday) {
  return /* @__PURE__ */ jsx(Box, { paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", style: {
    textAlign: "center"
  }, children: weekday }) }, weekday);
}
const features$1 = {
  dayPresets: !1,
  timePresets: !1
}, YearInput$1 = (props2) => {
  const $ = c(8);
  let onChange, restProps;
  $[0] !== props2 ? ({
    onChange,
    ...restProps
  } = props2, $[0] = props2, $[1] = onChange, $[2] = restProps) : (onChange = $[1], restProps = $[2]);
  let t0;
  $[3] !== onChange ? (t0 = (event) => {
    const numericValue = parseInt(event.currentTarget.value, 10);
    isNaN(numericValue) || onChange(numericValue);
  }, $[3] = onChange, $[4] = t0) : t0 = $[4];
  const handleChange = t0;
  let t1;
  return $[5] !== handleChange || $[6] !== restProps ? (t1 = /* @__PURE__ */ jsx(LazyTextInput, { "data-testid": "date-input", ...restProps, fontSize: 1, onChange: handleChange, inputMode: "numeric", padding: 2, radius: 2 }), $[5] = handleChange, $[6] = restProps, $[7] = t1) : t1 = $[7], t1;
}, MONTH_PICKER_VARIANT = {
  carousel: "carousel"
}, PRESERVE_FOCUS_ELEMENT$3 = /* @__PURE__ */ jsx("span", { "data-preserve-focus": !0, style: {
  overflow: "hidden",
  position: "absolute",
  outline: "none"
}, tabIndex: -1 }), CALENDAR_ICON_BUTTON_PROPS = {
  padding: 2
}, Calendar$2 = forwardRef(function(props2, forwardedRef) {
  const {
    selectTime,
    onFocusedDateChange,
    selectedDate = /* @__PURE__ */ new Date(),
    focusedDate = selectedDate,
    timeStep = 1,
    onSelect,
    labels: labels2,
    isPastDisabled,
    monthPickerVariant = "select",
    padding = 2,
    showTimezone = !1,
    ...restProps
  } = props2, {
    timeZone
  } = useTimeZone(), {
    DialogTimeZone: DialogTimeZone2,
    dialogProps,
    dialogTimeZoneShow
  } = useDialogTimeZone(), setFocusedDate = useCallback((date) => onFocusedDateChange(date), [onFocusedDateChange]), setFocusedDateMonth = useCallback((month) => setFocusedDate(setDate(setMonth(focusedDate, month), 1)), [focusedDate, setFocusedDate]), handleFocusedMonthChange = useCallback((e) => setFocusedDateMonth(Number(e.currentTarget.value)), [setFocusedDateMonth]), moveFocusedDate = useCallback((by) => setFocusedDate(addMonths(focusedDate, by)), [focusedDate, setFocusedDate]), setFocusedDateYear = useCallback((year) => setFocusedDate(setYear(focusedDate, year)), [focusedDate, setFocusedDate]), handleDateChange = useCallback((date_0) => {
    onSelect(setMinutes(setHours(date_0, selectedDate.getHours()), selectedDate.getMinutes()));
  }, [onSelect, selectedDate]), handleTimeChange = useCallback((hours, mins) => {
    onSelect(setHours(setMinutes(selectedDate, mins), hours));
  }, [onSelect, selectedDate]), handleTimeChangeInputChange = useCallback((event) => {
    const date_1 = parse(event.currentTarget.value, "HH:mm", /* @__PURE__ */ new Date());
    handleTimeChange(date_1.getHours(), date_1.getMinutes());
  }, [handleTimeChange]), ref = useRef(null);
  useImperativeHandle(forwardedRef, () => ref.current);
  const focusCurrentWeekDay = useCallback(() => {
    ref.current?.querySelector('[data-focused="true"]')?.focus();
  }, [ref]), handleKeyDown = useCallback((event_0) => {
    if (!ARROW_KEYS$2.includes(event_0.key))
      return;
    const target = event_0.currentTarget;
    if (event_0.preventDefault(), target.hasAttribute("data-calendar-grid")) {
      focusCurrentWeekDay();
      return;
    }
    event_0.key === "ArrowUp" && onFocusedDateChange(addDays(focusedDate, -7)), event_0.key === "ArrowDown" && onFocusedDateChange(addDays(focusedDate, 7)), event_0.key === "ArrowLeft" && onFocusedDateChange(addDays(focusedDate, -1)), event_0.key === "ArrowRight" && onFocusedDateChange(addDays(focusedDate, 1)), ref.current?.querySelector("[data-preserve-focus]")?.focus();
  }, [ref, focusCurrentWeekDay, onFocusedDateChange, focusedDate]);
  useEffect(() => {
    focusCurrentWeekDay();
  }, [focusCurrentWeekDay]), useEffect(() => {
    document.activeElement?.matches("[data-calendar-grid], [data-calendar-grid] [data-preserve-focus]") && focusCurrentWeekDay();
  }, [ref, focusCurrentWeekDay, focusedDate]), useCallback(() => handleDateChange(addDays(/* @__PURE__ */ new Date(), -1)), [handleDateChange]), useCallback(() => handleDateChange(/* @__PURE__ */ new Date()), [handleDateChange]), useCallback(() => handleDateChange(addDays(/* @__PURE__ */ new Date(), 1)), [handleDateChange]);
  const monthPicker = useMemo(() => monthPickerVariant === "carousel" ? /* @__PURE__ */ jsx(Flex, { align: "center", paddingLeft: 4, style: {
    borderBottom: "1px solid var(--card-border-color)",
    minHeight: "55px",
    position: "sticky",
    top: 0
  }, children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, justify: "space-between", children: [
    /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, children: /* @__PURE__ */ jsxs(Text$1, { weight: "medium", size: 1, children: [
      labels2.monthNames[(focusedDate || /* @__PURE__ */ new Date())?.getMonth()],
      " ",
      (focusedDate || /* @__PURE__ */ new Date())?.getFullYear()
    ] }) }),
    /* @__PURE__ */ jsx(Flex, { paddingRight: 3, gap: 2, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
      /* @__PURE__ */ jsx(Button, { icon: ChevronLeftIcon, mode: "bleed", onClick: () => moveFocusedDate(-1), "data-testid": "calendar-prev-month", tooltipProps: {
        content: "Previous month"
      } }),
      /* @__PURE__ */ jsx(Button, { icon: ChevronRightIcon, mode: "bleed", onClick: () => moveFocusedDate(1), "data-testid": "calendar-next-month", tooltipProps: {
        content: "Next month"
      } })
    ] }) })
  ] }) }) : /* @__PURE__ */ jsxs(Flex, { children: [
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(CalendarMonthSelect$1, { onChange: handleFocusedMonthChange, monthNames: labels2.monthNames, value: focusedDate?.getMonth() }) }),
    /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(CalendarYearSelect$1, { moveFocusedDate, labels: {
      goToNextYear: labels2.goToNextYear,
      goToPreviousYear: labels2.goToPreviousYear
    }, onChange: setFocusedDateYear, value: focusedDate.getFullYear() }) })
  ] }), [focusedDate, handleFocusedMonthChange, labels2.goToNextYear, labels2.goToPreviousYear, labels2.monthNames, monthPickerVariant, moveFocusedDate, setFocusedDateYear]), handleNowClick = useCallback(() => onSelect(/* @__PURE__ */ new Date()), [onSelect]);
  return /* @__PURE__ */ jsxs(Box, { "data-ui": "Calendar", ...restProps, ref, children: [
    /* @__PURE__ */ jsxs(Box, { padding, children: [
      features$1.dayPresets,
      monthPicker,
      /* @__PURE__ */ jsxs(Box, { "data-calendar-grid": !0, onKeyDown: handleKeyDown, marginY: 2, overflow: "hidden", tabIndex: 0, children: [
        /* @__PURE__ */ jsx(CalendarMonth$3, { weekDayNames: labels2.weekDayNamesShort, date: focusedDate, focused: focusedDate, onSelect: handleDateChange, selected: selectedDate, isPastDisabled }),
        PRESERVE_FOCUS_ELEMENT$3
      ] })
    ] }),
    /* @__PURE__ */ jsx(Box, { padding: 2, style: {
      borderTop: "1px solid var(--card-border-color)"
    }, children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", children: [
      selectTime && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
          /* @__PURE__ */ jsx(TimeInput, { "aria-label": labels2.selectTime, value: format$2(selectedDate, "HH:mm"), onChange: handleTimeChangeInputChange }),
          /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Button, { text: labels2.setToCurrentTime, mode: "bleed", onClick: handleNowClick }) })
        ] }),
        showTimezone && /* @__PURE__ */ jsx(Button, { icon: EarthGlobeIcon, mode: "bleed", size: "default", text: `${timeZone.abbreviation}`, onClick: dialogTimeZoneShow }),
        features$1.timePresets
      ] }),
      showTimezone && DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps })
    ] }) })
  ] });
});
function CalendarMonthSelect$1(props2) {
  const $ = c(6), {
    onChange,
    value,
    monthNames
  } = props2;
  let t0;
  $[0] !== monthNames ? (t0 = monthNames.map(_temp$2x), $[0] = monthNames, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== onChange || $[3] !== t0 || $[4] !== value ? (t1 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Select, { fontSize: 1, radius: 2, value, onChange, padding: 2, children: t0 }) }) }), $[2] = onChange, $[3] = t0, $[4] = value, $[5] = t1) : t1 = $[5], t1;
}
function _temp$2x(monthName, i) {
  return /* @__PURE__ */ jsx("option", { value: i, children: monthName }, i);
}
function CalendarYearSelect$1(props2) {
  const $ = c(20), {
    moveFocusedDate,
    onChange,
    value,
    labels: labels2
  } = props2;
  let t0;
  $[0] !== moveFocusedDate ? (t0 = () => moveFocusedDate(-12), $[0] = moveFocusedDate, $[1] = t0) : t0 = $[1];
  const handlePrevYearClick = t0;
  let t1;
  $[2] !== moveFocusedDate ? (t1 = () => moveFocusedDate(12), $[2] = moveFocusedDate, $[3] = t1) : t1 = $[3];
  const handleNextYearClick = t1;
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    content: "Previous year"
  }, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== handlePrevYearClick || $[6] !== labels2.goToPreviousYear ? (t3 = /* @__PURE__ */ jsx(Button, { "aria-label": labels2.goToPreviousYear, onClick: handlePrevYearClick, mode: "bleed", icon: ChevronLeftIcon, tooltipProps: t2, ...CALENDAR_ICON_BUTTON_PROPS }), $[5] = handlePrevYearClick, $[6] = labels2.goToPreviousYear, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    width: 48
  }, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== onChange || $[10] !== value ? (t5 = /* @__PURE__ */ jsx(YearInput$1, { value, onChange, radius: 0, style: t4 }), $[9] = onChange, $[10] = value, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    content: "Next year"
  }, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== handleNextYearClick || $[14] !== labels2.goToNextYear ? (t7 = /* @__PURE__ */ jsx(Button, { "aria-label": labels2.goToNextYear, onClick: handleNextYearClick, mode: "bleed", icon: ChevronRightIcon, tooltipProps: t6, ...CALENDAR_ICON_BUTTON_PROPS }), $[13] = handleNextYearClick, $[14] = labels2.goToNextYear, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== t3 || $[17] !== t5 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t3,
    t5,
    t7
  ] }), $[16] = t3, $[17] = t5, $[18] = t7, $[19] = t8) : t8 = $[19], t8;
}
const DatePicker$2 = forwardRef(function(props2, ref) {
  const {
    value = /* @__PURE__ */ new Date(),
    onChange,
    calendarLabels,
    padding = 2,
    showTimezone = !1,
    ...rest
  } = props2, [focusedDate, setFocusedDay] = useState(), handleSelect = useCallback((nextDate) => {
    onChange(nextDate), setFocusedDay(void 0);
  }, [onChange]);
  return /* @__PURE__ */ jsx(Calendar$2, { ...rest, labels: calendarLabels, ref, selectedDate: value, onSelect: handleSelect, focusedDate: focusedDate || value, onFocusedDateChange: setFocusedDay, padding, showTimezone });
}), DateTimeInput$3 = forwardRef(function(props2, forwardedRef) {
  const $ = c(51);
  let calendarLabels, disableInput, inputValue, isPastDisabled, monthPickerVariant, onChange, onInputChange, padding, readOnly, rest, selectTime, t0, timeStep, value;
  $[0] !== props2 ? ({
    value,
    inputValue,
    onInputChange,
    onChange,
    selectTime,
    timeStep,
    calendarLabels,
    readOnly,
    constrainSize: t0,
    monthPickerVariant,
    padding,
    disableInput,
    isPastDisabled,
    ...rest
  } = props2, $[0] = props2, $[1] = calendarLabels, $[2] = disableInput, $[3] = inputValue, $[4] = isPastDisabled, $[5] = monthPickerVariant, $[6] = onChange, $[7] = onInputChange, $[8] = padding, $[9] = readOnly, $[10] = rest, $[11] = selectTime, $[12] = t0, $[13] = timeStep, $[14] = value) : (calendarLabels = $[1], disableInput = $[2], inputValue = $[3], isPastDisabled = $[4], monthPickerVariant = $[5], onChange = $[6], onInputChange = $[7], padding = $[8], readOnly = $[9], rest = $[10], selectTime = $[11], t0 = $[12], timeStep = $[13], value = $[14]);
  const constrainSize = t0 === void 0 ? !0 : t0, {
    t
  } = useTranslation(), popoverRef = useRef(null), ref = useRef(null), buttonRef = useRef(null), {
    zoneDateToUtc
  } = useTimeZone(), [referenceElement, setReferenceElement] = useState(null);
  let t1;
  $[15] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => ref.current, $[15] = t1) : t1 = $[15], useImperativeHandle(forwardedRef, t1);
  let t2, t3;
  $[16] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setReferenceElement(ref.current), t3 = [], $[16] = t2, $[17] = t3) : (t2 = $[16], t3 = $[17]), useEffect(t2, t3);
  const [isPickerOpen, setPickerOpen] = useState(!1);
  let t4, t5;
  $[18] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setPickerOpen(!1), t5 = () => [popoverRef.current], $[18] = t4, $[19] = t5) : (t4 = $[18], t5 = $[19]), useClickOutsideEvent(t4, t5);
  let t6;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    ref.current?.focus(), ref.current?.select();
  }, $[20] = t6) : t6 = $[20];
  const handleDeactivation = t6;
  let t7;
  $[21] === Symbol.for("react.memo_cache_sentinel") ? (t7 = (e) => {
    e.key === "Escape" && setPickerOpen(!1);
  }, $[21] = t7) : t7 = $[21];
  const handleKeyUp = t7;
  let t8;
  $[22] === Symbol.for("react.memo_cache_sentinel") ? (t8 = () => setPickerOpen(!0), $[22] = t8) : t8 = $[22];
  const handleClick = t8;
  let t9, t10;
  $[23] !== inputValue || $[24] !== isPastDisabled || $[25] !== zoneDateToUtc ? (t10 = inputValue && isPastDisabled && isPast(zoneDateToUtc(new Date(inputValue))), $[23] = inputValue, $[24] = isPastDisabled, $[25] = zoneDateToUtc, $[26] = t10) : t10 = $[26], t9 = t10;
  const isDateInPastWarningShown = t9;
  let t11;
  $[27] !== calendarLabels || $[28] !== readOnly ? (t11 = readOnly ? null : /* @__PURE__ */ jsx(Flex, { style: {
    padding: "5px"
  }, children: /* @__PURE__ */ jsx(Button, { disabled: readOnly, "aria-label": calendarLabels.ariaLabel, ref: buttonRef, icon: CalendarIcon, mode: "bleed", onClick: handleClick, style: {
    display: "block"
  }, "data-testid": "select-date-button", tooltipProps: {
    content: calendarLabels.tooltipText
  } }) }), $[27] = calendarLabels, $[28] = readOnly, $[29] = t11) : t11 = $[29];
  const suffix = t11, t12 = disableInput || readOnly;
  let t13;
  $[30] !== calendarLabels || $[31] !== constrainSize || $[32] !== isDateInPastWarningShown || $[33] !== isPastDisabled || $[34] !== isPickerOpen || $[35] !== monthPickerVariant || $[36] !== onChange || $[37] !== padding || $[38] !== referenceElement || $[39] !== selectTime || $[40] !== suffix || $[41] !== t || $[42] !== timeStep || $[43] !== value ? (t13 = isPickerOpen ? /* @__PURE__ */ jsx(LayerProvider, { zOffset: 1e3, children: /* @__PURE__ */ jsx(Popover, { constrainSize, "data-testid": "date-input-dialog", referenceElement, portal: !0, content: /* @__PURE__ */ jsx(Box, { overflow: "auto", children: /* @__PURE__ */ jsxs(FocusLock, { onDeactivation: handleDeactivation, children: [
    isDateInPastWarningShown && /* @__PURE__ */ jsx(Card, { margin: 1, padding: 2, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("inputs.dateTime.past-date-warning") }) }),
    /* @__PURE__ */ jsx(DatePicker$2, { monthPickerVariant, calendarLabels, selectTime, timeStep, onKeyUp: handleKeyUp, value, isPastDisabled, onChange, padding })
  ] }) }), open: !0, placement: "bottom", ref: popoverRef, children: /* @__PURE__ */ jsx(Fragment, { children: suffix }) }) }) : suffix, $[30] = calendarLabels, $[31] = constrainSize, $[32] = isDateInPastWarningShown, $[33] = isPastDisabled, $[34] = isPickerOpen, $[35] = monthPickerVariant, $[36] = onChange, $[37] = padding, $[38] = referenceElement, $[39] = selectTime, $[40] = suffix, $[41] = t, $[42] = timeStep, $[43] = value, $[44] = t13) : t13 = $[44];
  let t14;
  return $[45] !== inputValue || $[46] !== onInputChange || $[47] !== rest || $[48] !== t12 || $[49] !== t13 ? (t14 = /* @__PURE__ */ jsx(LazyTextInput, { ref, "data-testid": "date-input", ...rest, readOnly: t12, value: inputValue, onChange: onInputChange, suffix: t13 }), $[45] = inputValue, $[46] = onInputChange, $[47] = rest, $[48] = t12, $[49] = t13, $[50] = t14) : t14 = $[50], t14;
}), SANITY_PATCH_TYPE = Symbol.for("sanity.patch");
function setIfMissing(value, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "setIfMissing",
    path,
    value
  };
}
function insert$1(items, position, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "insert",
    path,
    position,
    items
  };
}
function set(value, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "set",
    path,
    value
  };
}
function unset(path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "unset",
    path
  };
}
function diffMatchPatch(value, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "diffMatchPatch",
    path,
    value
  };
}
function inc(amount = 1, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "inc",
    path,
    value: amount
  };
}
function dec(amount = 1, path = []) {
  return {
    patchType: SANITY_PATCH_TYPE,
    type: "dec",
    path,
    value: amount
  };
}
function prefixPath(patch2, segment) {
  return {
    ...patch2,
    path: [segment, ...patch2.path]
  };
}
function createPatchChannel() {
  const _subscribers = [];
  return {
    publish(msg) {
      for (const subscriber of _subscribers)
        subscriber(msg);
    },
    subscribe(subscriber) {
      return _subscribers.push(subscriber), () => {
        const idx = _subscribers.indexOf(subscriber);
        idx > -1 && _subscribers.splice(idx, 1);
      };
    }
  };
}
class PatchEvent {
  static from(input) {
    return input instanceof PatchEvent ? input : new PatchEvent(Array.isArray(input) ? flatten$1(input) : [input]);
  }
  constructor(patches) {
    this.patches = patches;
  }
  prepend(...patches) {
    return PatchEvent.from([...flatten$1(patches), ...this.patches]);
  }
  append(...patches) {
    return PatchEvent.from([...this.patches, ...flatten$1(patches)]);
  }
  prefixAll(segment) {
    return PatchEvent.from(this.patches.map((patch2) => prefixPath(patch2, segment)));
  }
}
const DEFAULT_PLACEHOLDER_TIME = /* @__PURE__ */ new Date(), CommonDateTimeInput$1 = forwardRef(function(props2, forwardedRef) {
  const $ = c(50);
  let deserialize2, formatInputValue, id2, onChange, parseInputValue, placeholder, readOnly, restProps, selectTime, serialize2, timeStep, value;
  $[0] !== props2 ? ({
    id: id2,
    deserialize: deserialize2,
    formatInputValue,
    onChange,
    parseInputValue,
    placeholder,
    readOnly,
    selectTime,
    serialize: serialize2,
    timeStep,
    value,
    ...restProps
  } = props2, $[0] = props2, $[1] = deserialize2, $[2] = formatInputValue, $[3] = id2, $[4] = onChange, $[5] = parseInputValue, $[6] = placeholder, $[7] = readOnly, $[8] = restProps, $[9] = selectTime, $[10] = serialize2, $[11] = timeStep, $[12] = value) : (deserialize2 = $[1], formatInputValue = $[2], id2 = $[3], onChange = $[4], parseInputValue = $[5], placeholder = $[6], readOnly = $[7], restProps = $[8], selectTime = $[9], serialize2 = $[10], timeStep = $[11], value = $[12]);
  const [localValue, setLocalValue] = useState(null), {
    t
  } = useTranslation();
  let t0;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setLocalValue(null);
  }, $[13] = t0) : t0 = $[13];
  let t1;
  $[14] !== value ? (t1 = [value], $[14] = value, $[15] = t1) : t1 = $[15], useEffect(t0, t1);
  let t2;
  $[16] !== localValue || $[17] !== onChange || $[18] !== parseInputValue || $[19] !== serialize2 || $[20] !== value ? (t2 = (event) => {
    const nextInputValue = event.currentTarget.value, result = nextInputValue === "" ? null : parseInputValue(nextInputValue);
    result === null ? (onChange(null), typeof value > "u" && localValue && setLocalValue(null)) : result.isValid ? onChange(serialize2(result.date)) : setLocalValue(nextInputValue);
  }, $[16] = localValue, $[17] = onChange, $[18] = parseInputValue, $[19] = serialize2, $[20] = value, $[21] = t2) : t2 = $[21];
  const handleDatePickerInputChange = t2;
  let t3;
  $[22] !== onChange || $[23] !== serialize2 ? (t3 = (nextDate) => {
    onChange(nextDate ? serialize2(nextDate) : null);
  }, $[22] = onChange, $[23] = serialize2, $[24] = t3) : t3 = $[24];
  const handleDatePickerChange = t3, ref = useRef(null);
  let t4;
  $[25] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => ref.current, $[25] = t4) : t4 = $[25], useImperativeHandle(forwardedRef, t4);
  let parseResult, t5;
  $[26] !== deserialize2 || $[27] !== formatInputValue || $[28] !== localValue || $[29] !== parseInputValue || $[30] !== value ? (parseResult = localValue ? parseInputValue(localValue) : value ? deserialize2(value) : null, t5 = localValue || (parseResult?.isValid ? formatInputValue(parseResult.date) : value), $[26] = deserialize2, $[27] = formatInputValue, $[28] = localValue, $[29] = parseInputValue, $[30] = value, $[31] = parseResult, $[32] = t5) : (parseResult = $[31], t5 = $[32]);
  const inputValue = t5, t6 = props2.calendarLabels;
  let t7;
  $[33] !== formatInputValue || $[34] !== placeholder || $[35] !== t ? (t7 = placeholder || t("inputs.datetime.placeholder", {
    example: formatInputValue(DEFAULT_PLACEHOLDER_TIME)
  }), $[33] = formatInputValue, $[34] = placeholder, $[35] = t, $[36] = t7) : t7 = $[36];
  const t8 = parseResult?.date, t9 = inputValue || "", t10 = !!readOnly, t11 = parseResult?.error;
  let t12;
  return $[37] !== handleDatePickerChange || $[38] !== handleDatePickerInputChange || $[39] !== id2 || $[40] !== props2.calendarLabels || $[41] !== restProps || $[42] !== selectTime || $[43] !== t10 || $[44] !== t11 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9 || $[48] !== timeStep ? (t12 = /* @__PURE__ */ jsx(DateTimeInput$3, { ...restProps, calendarLabels: t6, id: id2, selectTime, timeStep, placeholder: t7, ref, value: t8, inputValue: t9, readOnly: t10, onInputChange: handleDatePickerInputChange, onChange: handleDatePickerChange, customValidity: t11 }), $[37] = handleDatePickerChange, $[38] = handleDatePickerInputChange, $[39] = id2, $[40] = props2.calendarLabels, $[41] = restProps, $[42] = selectTime, $[43] = t10, $[44] = t11, $[45] = t7, $[46] = t8, $[47] = t9, $[48] = timeStep, $[49] = t12) : t12 = $[49], t12;
});
function isValidDate$1(date) {
  return date instanceof Date && !isNaN(date.valueOf());
}
function getCalendarLabels(t) {
  return {
    ariaLabel: t("calendar.button.aria-label"),
    goToTomorrow: t("calendar.action.go-to-tomorrow"),
    goToToday: t("calendar.action.go-to-today"),
    goToYesterday: t("calendar.action.go-to-yesterday"),
    goToNextMonth: t("calendar.action.go-to-next-month"),
    goToPreviousMonth: t("calendar.action.go-to-previous-month"),
    goToNextYear: t("calendar.action.go-to-next-year"),
    goToPreviousYear: t("calendar.action.go-to-previous-year"),
    setToCurrentTime: t("calendar.action.set-to-current-time"),
    selectTime: t("calendar.action.select-time"),
    tooltipText: t("calendar.button.tooltip-text"),
    monthNames: [t("calendar.month-names.january"), t("calendar.month-names.february"), t("calendar.month-names.march"), t("calendar.month-names.april"), t("calendar.month-names.may"), t("calendar.month-names.june"), t("calendar.month-names.july"), t("calendar.month-names.august"), t("calendar.month-names.september"), t("calendar.month-names.october"), t("calendar.month-names.november"), t("calendar.month-names.december")],
    weekDayNamesShort: [t("calendar.weekday-names.short.monday"), t("calendar.weekday-names.short.tuesday"), t("calendar.weekday-names.short.wednesday"), t("calendar.weekday-names.short.thursday"), t("calendar.weekday-names.short.friday"), t("calendar.weekday-names.short.saturday"), t("calendar.weekday-names.short.sunday")],
    setToTimePreset: (time, date) => t("calendar.action.set-to-time-preset", {
      time,
      date
    })
  };
}
const deserialize$3 = (value) => parse$1(value, DEFAULT_DATE_FORMAT), serialize$5 = (date) => format$3(date, DEFAULT_DATE_FORMAT);
function DateInput(props2) {
  const $ = c(17), {
    readOnly,
    onChange,
    schemaType,
    elementProps,
    value
  } = props2, dateFormat = schemaType.options?.dateFormat || DEFAULT_DATE_FORMAT, {
    t
  } = useTranslation();
  let t0;
  $[0] !== onChange ? (t0 = (nextDate) => {
    onChange(nextDate === null ? unset() : set(nextDate));
  }, $[0] = onChange, $[1] = t0) : t0 = $[1];
  const handleChange = t0;
  let t1;
  $[2] !== dateFormat ? (t1 = (date) => format$3(date, dateFormat), $[2] = dateFormat, $[3] = t1) : t1 = $[3];
  const formatInputValue = t1;
  let t2;
  $[4] !== dateFormat ? (t2 = (inputValue) => parse$1(inputValue, dateFormat), $[4] = dateFormat, $[5] = t2) : t2 = $[5];
  const parseInputValue = t2;
  let t3, t4;
  $[6] !== t ? (t4 = getCalendarLabels(t), $[6] = t, $[7] = t4) : t4 = $[7], t3 = t4;
  const calendarLabels = t3;
  let t5;
  return $[8] !== calendarLabels || $[9] !== elementProps || $[10] !== formatInputValue || $[11] !== handleChange || $[12] !== parseInputValue || $[13] !== readOnly || $[14] !== schemaType.placeholder || $[15] !== value ? (t5 = /* @__PURE__ */ jsx(CommonDateTimeInput$1, { ...elementProps, deserialize: deserialize$3, formatInputValue, onChange: handleChange, parseInputValue, placeholder: schemaType.placeholder, calendarLabels, readOnly, selectTime: !1, serialize: serialize$5, value }), $[8] = calendarLabels, $[9] = elementProps, $[10] = formatInputValue, $[11] = handleChange, $[12] = parseInputValue, $[13] = readOnly, $[14] = schemaType.placeholder, $[15] = value, $[16] = t5) : t5 = $[16], t5;
}
function parseOptions$1(options = {}) {
  return {
    dateFormat: options.dateFormat || DEFAULT_DATE_FORMAT,
    timeFormat: options.timeFormat || DEFAULT_TIME_FORMAT,
    timeStep: "timeStep" in options && Number(options.timeStep) || 1
  };
}
function serialize$4(date) {
  return date.toISOString();
}
function deserialize$2(isoString) {
  const deserialized = new Date(isoString);
  return isValidDate$1(deserialized) ? {
    isValid: !0,
    date: deserialized
  } : {
    isValid: !1,
    error: `Invalid date value: "${isoString}"`
  };
}
function enforceTimeStep$1(dateString, timeStep) {
  if (!timeStep || timeStep === 1)
    return dateString;
  const date = parseISO(dateString), minutes = getMinutes(date), leftOver = minutes % timeStep;
  return serialize$4(leftOver !== 0 ? setMinutes(date, minutes - leftOver) : date);
}
function DateTimeInput$2(props2) {
  const $ = c(22), {
    onChange,
    schemaType,
    value,
    elementProps
  } = props2;
  let t0;
  $[0] !== schemaType.options ? (t0 = parseOptions$1(schemaType.options), $[0] = schemaType.options, $[1] = t0) : t0 = $[1];
  const {
    dateFormat,
    timeFormat,
    timeStep
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[2] !== onChange || $[3] !== timeStep ? (t1 = (nextDate) => {
    let date = nextDate;
    date !== null && timeStep > 1 && (date = enforceTimeStep$1(date, timeStep)), onChange(date === null ? unset() : set(date));
  }, $[2] = onChange, $[3] = timeStep, $[4] = t1) : t1 = $[4];
  const handleChange = t1;
  let t2;
  $[5] !== dateFormat || $[6] !== timeFormat ? (t2 = (date_0) => format$3(date_0, `${dateFormat} ${timeFormat}`), $[5] = dateFormat, $[6] = timeFormat, $[7] = t2) : t2 = $[7];
  const formatInputValue = t2;
  let t3;
  $[8] !== dateFormat || $[9] !== timeFormat ? (t3 = (inputValue) => parse$1(inputValue, `${dateFormat} ${timeFormat}`), $[8] = dateFormat, $[9] = timeFormat, $[10] = t3) : t3 = $[10];
  const parseInputValue = t3;
  let t4, t5;
  $[11] !== t ? (t5 = getCalendarLabels(t), $[11] = t, $[12] = t5) : t5 = $[12], t4 = t5;
  const calendarLabels = t4;
  let t6;
  return $[13] !== calendarLabels || $[14] !== elementProps || $[15] !== formatInputValue || $[16] !== handleChange || $[17] !== parseInputValue || $[18] !== schemaType.placeholder || $[19] !== timeStep || $[20] !== value ? (t6 = /* @__PURE__ */ jsx(CommonDateTimeInput$1, { ...elementProps, calendarLabels, onChange: handleChange, deserialize: deserialize$2, formatInputValue, parseInputValue, placeholder: schemaType.placeholder, selectTime: !0, serialize: serialize$4, timeStep, value }), $[13] = calendarLabels, $[14] = elementProps, $[15] = formatInputValue, $[16] = handleChange, $[17] = parseInputValue, $[18] = schemaType.placeholder, $[19] = timeStep, $[20] = value, $[21] = t6) : t6 = $[21], t6;
}
const inputDateFormat = "PP HH:mm", ScheduleDatePicker = (t0) => {
  const $ = c(50), {
    initialValue: inputValue,
    onChange
  } = t0, {
    t
  } = useTranslation(), {
    timeZone,
    utcToCurrentZoneDate,
    zoneDateToUtc
  } = useTimeZone(), {
    dialogTimeZoneShow,
    DialogTimeZone: DialogTimeZone2,
    dialogProps
  } = useDialogTimeZone();
  let T0, T1, T2, t1, t2, t3, t4, t5, t6, t7, t8, t9;
  if ($[0] !== inputValue || $[1] !== onChange || $[2] !== t || $[3] !== utcToCurrentZoneDate || $[4] !== zoneDateToUtc) {
    const timezoneAdjustedValue = utcToCurrentZoneDate(inputValue);
    let t102;
    $[17] !== onChange || $[18] !== zoneDateToUtc ? (t102 = (date) => {
      date && onChange(zoneDateToUtc(date));
    }, $[17] = onChange, $[18] = zoneDateToUtc, $[19] = t102) : t102 = $[19];
    const handlePublishAtCalendarChange = t102;
    let t112;
    $[20] !== onChange || $[21] !== zoneDateToUtc ? (t112 = (event) => {
      const date_0 = event.currentTarget.value, parsedDate = zoneDateToUtc(parse(date_0, inputDateFormat, /* @__PURE__ */ new Date()));
      isValid(parsedDate) && onChange(parsedDate);
    }, $[20] = onChange, $[21] = zoneDateToUtc, $[22] = t112) : t112 = $[22];
    const handlePublishAtInputChange = t112;
    let t122, t132;
    $[23] !== t ? (t132 = getCalendarLabels(t), $[23] = t, $[24] = t132) : t132 = $[24], t122 = t132;
    const calendarLabels = t122;
    T2 = Flex, t9 = 3, T1 = Box, t8 = 1, T0 = DateTimeInput$3, t1 = !0, t2 = MONTH_PICKER_VARIANT.carousel, t3 = handlePublishAtCalendarChange, t4 = handlePublishAtInputChange, t5 = calendarLabels, t6 = timezoneAdjustedValue, t7 = format$2(timezoneAdjustedValue, inputDateFormat), $[0] = inputValue, $[1] = onChange, $[2] = t, $[3] = utcToCurrentZoneDate, $[4] = zoneDateToUtc, $[5] = T0, $[6] = T1, $[7] = T2, $[8] = t1, $[9] = t2, $[10] = t3, $[11] = t4, $[12] = t5, $[13] = t6, $[14] = t7, $[15] = t8, $[16] = t9;
  } else
    T0 = $[5], T1 = $[6], T2 = $[7], t1 = $[8], t2 = $[9], t3 = $[10], t4 = $[11], t5 = $[12], t6 = $[13], t7 = $[14], t8 = $[15], t9 = $[16];
  let t10;
  $[25] !== T0 || $[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 ? (t10 = /* @__PURE__ */ jsx(T0, { selectTime: t1, monthPickerVariant: t2, onChange: t3, onInputChange: t4, calendarLabels: t5, value: t6, inputValue: t7, constrainSize: !1, padding: 0, isPastDisabled: !0 }), $[25] = T0, $[26] = t1, $[27] = t2, $[28] = t3, $[29] = t4, $[30] = t5, $[31] = t6, $[32] = t7, $[33] = t10) : t10 = $[33];
  let t11;
  $[34] !== T1 || $[35] !== t10 || $[36] !== t8 ? (t11 = /* @__PURE__ */ jsx(T1, { flex: t8, children: t10 }), $[34] = T1, $[35] = t10, $[36] = t8, $[37] = t11) : t11 = $[37];
  const t12 = `${timeZone.abbreviation}`;
  let t13;
  $[38] !== dialogTimeZoneShow || $[39] !== t12 ? (t13 = /* @__PURE__ */ jsx(Button, { icon: EarthGlobeIcon, mode: "bleed", size: "default", text: t12, onClick: dialogTimeZoneShow }), $[38] = dialogTimeZoneShow, $[39] = t12, $[40] = t13) : t13 = $[40];
  let t14;
  $[41] !== DialogTimeZone2 || $[42] !== dialogProps ? (t14 = DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps }), $[41] = DialogTimeZone2, $[42] = dialogProps, $[43] = t14) : t14 = $[43];
  let t15;
  return $[44] !== T2 || $[45] !== t11 || $[46] !== t13 || $[47] !== t14 || $[48] !== t9 ? (t15 = /* @__PURE__ */ jsxs(T2, { gap: t9, children: [
    t11,
    t13,
    t14
  ] }), $[44] = T2, $[45] = t11, $[46] = t13, $[47] = t14, $[48] = t9, $[49] = t15) : t15 = $[49], t15;
}, MAX_DESCRIPTION_HEIGHT = 200, TitleInput$1 = styled.input((props2) => {
  const {
    color,
    font
  } = getTheme_v2(props2.theme);
  return css`
    resize: none;
    overflow: hidden;
    appearance: none;
    background: none;
    border: 0;
    padding: 0;
    border-radius: 0;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: ${font.text.family};
    font-weight: ${font.text.weights.bold};
    font-size: ${font.text.sizes[4].fontSize}px;
    line-height: ${font.text.sizes[4].lineHeight}px;
    margin: 0;
    position: relative;
    z-index: 1;
    display: block;
    transition: height 500ms;
    /* NOTE: This is a hack to disable Chrome’s autofill styles */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: var(--input-fg-color) !important;
      transition: background-color 5000s;
      transition-delay: 86400s /* 24h */;
    }

    color: ${color.input.default.enabled.fg};

    &::placeholder {
      color: ${color.input.default.enabled.placeholder};
    }
  `;
}), DescriptionTextArea = styled.textarea((props2) => {
  const {
    color,
    font
  } = getTheme_v2(props2.theme);
  return css`
    resize: none;
    overflow: hidden;
    appearance: none;
    background: none;
    border: 0;
    padding: 0;
    border-radius: 0;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: ${font.text.family};
    font-weight: ${font.text.weights.regular};
    font-size: ${font.text.sizes[2].fontSize}px;
    height: auto;
    line-height: ${font.text.sizes[2].lineHeight}px;
    margin: 0;
    max-width: 624px;
    position: relative;
    z-index: 1;
    display: block;
    color: ${color.input.default.enabled.fg};

    &::placeholder {
      color: ${color.input.default.enabled.placeholder};
    }
  `;
}), getIsReleaseOpen = (release) => release.state !== "archived" && release.state !== "published";
function TitleDescriptionForm(t0) {
  const $ = c(35), {
    release,
    onChange,
    disabled
  } = t0;
  let t1;
  $[0] !== release ? (t1 = getIsReleaseOpen(release), $[0] = release, $[1] = t1) : t1 = $[1];
  const isReleaseOpen = t1, descriptionRef = useRef(null), [scrollHeight, setScrollHeight] = useState(46);
  let t2;
  $[2] !== release._id || $[3] !== release.metadata ? (t2 = () => ({
    _id: release?._id,
    metadata: {
      title: release?.metadata.title,
      description: release?.metadata.description
    }
  }), $[2] = release._id, $[3] = release.metadata, $[4] = t2) : t2 = $[4];
  const [value, setValue] = useState(t2), {
    t
  } = useTranslation();
  let t3, t4;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    descriptionRef.current && setScrollHeight(descriptionRef.current.scrollHeight);
  }, t4 = [], $[5] = t3, $[6] = t4) : (t3 = $[5], t4 = $[6]), useEffect(t3, t4);
  let t5;
  $[7] !== onChange || $[8] !== release.metadata || $[9] !== value ? (t5 = (event) => {
    event.preventDefault();
    const title = event.target.value;
    onChange({
      ...value,
      metadata: {
        ...release.metadata,
        title
      }
    }), setValue({
      ...value,
      metadata: {
        ...release.metadata,
        title
      }
    });
  }, $[7] = onChange, $[8] = release.metadata, $[9] = value, $[10] = t5) : t5 = $[10];
  const handleTitleChange = t5;
  let t6;
  $[11] !== isReleaseOpen || $[12] !== onChange || $[13] !== release.metadata || $[14] !== value ? (t6 = (event_0) => {
    if (event_0.preventDefault(), !isReleaseOpen)
      return;
    const description = event_0.target.value;
    onChange({
      ...value,
      metadata: {
        ...release.metadata,
        description
      }
    }), setValue({
      ...value,
      metadata: {
        ...release.metadata,
        description
      }
    }), descriptionRef.current && (descriptionRef.current.style.overflow = "hidden", descriptionRef.current.style.height = "auto", descriptionRef.current.style.height = `${descriptionRef.current.scrollHeight}px`, parseInt(descriptionRef.current.style.height, 10) > MAX_DESCRIPTION_HEIGHT && (descriptionRef.current.style.overflow = "auto")), setScrollHeight(event_0.currentTarget.scrollHeight);
  }, $[11] = isReleaseOpen, $[12] = onChange, $[13] = release.metadata, $[14] = value, $[15] = t6) : t6 = $[15];
  const handleDescriptionChange = t6, shouldShowDescription = isReleaseOpen || value.metadata.description, t7 = value.metadata.title;
  let t8;
  $[16] !== t ? (t8 = t("release.placeholder-untitled-release"), $[16] = t, $[17] = t8) : t8 = $[17];
  const t9 = !isReleaseOpen;
  let t10;
  $[18] !== disabled || $[19] !== handleTitleChange || $[20] !== t8 || $[21] !== t9 || $[22] !== value.metadata.title ? (t10 = /* @__PURE__ */ jsx(TitleInput$1, { onChange: handleTitleChange, value: t7, placeholder: t8, "data-testid": "release-form-title", readOnly: t9, disabled }), $[18] = disabled, $[19] = handleTitleChange, $[20] = t8, $[21] = t9, $[22] = value.metadata.title, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== disabled || $[25] !== handleDescriptionChange || $[26] !== isReleaseOpen || $[27] !== scrollHeight || $[28] !== shouldShowDescription || $[29] !== t || $[30] !== value ? (t11 = shouldShowDescription && /* @__PURE__ */ jsx(DescriptionTextArea, { ref: descriptionRef, autoFocus: !value, value: value.metadata.description, placeholder: t("release.form.placeholder-describe-release"), onChange: handleDescriptionChange, style: {
    height: `${scrollHeight}px`,
    maxHeight: MAX_DESCRIPTION_HEIGHT
  }, "data-testid": "release-form-description", disabled, readOnly: !isReleaseOpen }), $[24] = disabled, $[25] = handleDescriptionChange, $[26] = isReleaseOpen, $[27] = scrollHeight, $[28] = shouldShowDescription, $[29] = t, $[30] = value, $[31] = t11) : t11 = $[31];
  let t12;
  return $[32] !== t10 || $[33] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t10,
    t11
  ] }), $[32] = t10, $[33] = t11, $[34] = t12) : t12 = $[34], t12;
}
function ReleaseForm(props2) {
  const $ = c(83), {
    onChange,
    value
  } = props2;
  let t0;
  $[0] !== value.metadata ? (t0 = value.metadata || {}, $[0] = value.metadata, $[1] = t0) : t0 = $[1];
  const {
    releaseType
  } = t0, {
    t
  } = useTranslation(), {
    timeZone,
    utcToCurrentZoneDate
  } = useTimeZone(), [currentTimezone, setCurrentTimezone] = useState(timeZone.name), [buttonReleaseType, setButtonReleaseType] = useState(releaseType ?? "asap"), [intendedPublishAt, setIntendedPublishAt] = useState();
  let t1;
  $[2] !== onChange || $[3] !== value ? (t1 = (date) => {
    setIntendedPublishAt(date), onChange({
      ...value,
      metadata: {
        ...value.metadata,
        intendedPublishAt: date.toISOString()
      }
    });
  }, $[2] = onChange, $[3] = value, $[4] = t1) : t1 = $[4];
  const handleBundlePublishAtCalendarChange = t1;
  let t2;
  $[5] !== onChange || $[6] !== value ? (t2 = (event) => {
    const pickedReleaseType = event.currentTarget.dataset.value;
    if (!isReleaseType(pickedReleaseType))
      return;
    setButtonReleaseType(pickedReleaseType);
    const nextInputValue = startOfHour(addHours(/* @__PURE__ */ new Date(), 1));
    pickedReleaseType === "scheduled" && setIntendedPublishAt(nextInputValue), onChange({
      ...value,
      metadata: {
        ...value.metadata,
        releaseType: pickedReleaseType,
        intendedPublishAt: pickedReleaseType === "scheduled" && nextInputValue.toISOString() || void 0
      }
    });
  }, $[5] = onChange, $[6] = value, $[7] = t2) : t2 = $[7];
  const handleButtonReleaseTypeChange = t2;
  let t3;
  $[8] !== onChange || $[9] !== value ? (t3 = (updatedRelease) => {
    onChange({
      ...value,
      metadata: {
        ...value.metadata,
        title: updatedRelease.metadata.title,
        description: updatedRelease.metadata.description
      }
    });
  }, $[8] = onChange, $[9] = value, $[10] = t3) : t3 = $[10];
  const handleTitleDescriptionChange = t3;
  let t4;
  $[11] !== currentTimezone || $[12] !== intendedPublishAt || $[13] !== timeZone.name || $[14] !== utcToCurrentZoneDate ? (t4 = () => {
    if (timeZone.name !== currentTimezone && (setCurrentTimezone(timeZone.name), intendedPublishAt && isValid(intendedPublishAt))) {
      const currentZoneDate = utcToCurrentZoneDate(intendedPublishAt);
      setIntendedPublishAt(currentZoneDate);
    }
  }, $[11] = currentTimezone, $[12] = intendedPublishAt, $[13] = timeZone.name, $[14] = utcToCurrentZoneDate, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== currentTimezone || $[17] !== intendedPublishAt || $[18] !== timeZone || $[19] !== utcToCurrentZoneDate ? (t5 = [currentTimezone, intendedPublishAt, timeZone, utcToCurrentZoneDate], $[16] = currentTimezone, $[17] = intendedPublishAt, $[18] = timeZone, $[19] = utcToCurrentZoneDate, $[20] = t5) : t5 = $[20], useEffect(t4, t5);
  const menuButtonId = useId(), [menuButton, setMenuButton] = useState(null);
  let t6;
  $[21] !== t ? (t6 = t("release.dialog.tooltip.title"), $[21] = t, $[22] = t6) : t6 = $[22];
  let t7;
  $[23] !== menuButtonId || $[24] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "label", htmlFor: menuButtonId, children: t6 }), $[23] = menuButtonId, $[24] = t6, $[25] = t7) : t7 = $[25];
  let t8;
  $[26] === Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    maxWidth: 304
  }, $[26] = t8) : t8 = $[26];
  let t9;
  $[27] !== t ? (t9 = t("release.dialog.tooltip.description"), $[27] = t, $[28] = t9) : t9 = $[28];
  let t10;
  $[29] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t9 }), $[29] = t9, $[30] = t10) : t10 = $[30];
  let t11;
  $[31] !== t ? (t11 = t("release.dialog.tooltip.note"), $[31] = t, $[32] = t11) : t11 = $[32];
  let t12;
  $[33] !== t11 ? (t12 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t11 }), $[33] = t11, $[34] = t12) : t12 = $[34];
  let t13;
  $[35] !== t10 || $[36] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Stack, { space: 3, style: t8, children: [
    t10,
    t12
  ] }), $[35] = t10, $[36] = t12, $[37] = t13) : t13 = $[37];
  let t14;
  $[38] === Symbol.for("react.memo_cache_sentinel") ? (t14 = /* @__PURE__ */ jsx(InfoOutlineIcon, {}), $[38] = t14) : t14 = $[38];
  let t15;
  $[39] !== t13 ? (t15 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Tooltip, { content: t13, delay: 0, placement: "right-start", portal: !0, children: t14 }) }), $[39] = t13, $[40] = t15) : t15 = $[40];
  let t16;
  $[41] !== t15 || $[42] !== t7 ? (t16 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t7,
    t15
  ] }), $[41] = t15, $[42] = t7, $[43] = t16) : t16 = $[43];
  const t17 = `release.type.${buttonReleaseType}`;
  let t18;
  $[44] !== t || $[45] !== t17 ? (t18 = t(t17), $[44] = t, $[45] = t17, $[46] = t18) : t18 = $[46];
  const t19 = RELEASE_TYPES_TONES[buttonReleaseType];
  let t20;
  $[47] !== t18 || $[48] !== t19.tone ? (t20 = /* @__PURE__ */ jsx(ReleaseTypeOption, { text: t18, tone: t19.tone }), $[47] = t18, $[48] = t19.tone, $[49] = t20) : t20 = $[49];
  let t21;
  $[50] === Symbol.for("react.memo_cache_sentinel") ? (t21 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }), $[50] = t21) : t21 = $[50];
  let t22;
  $[51] !== t20 ? (t22 = /* @__PURE__ */ jsx(Button$1, { mode: "ghost", children: /* @__PURE__ */ jsxs(Flex, { justify: "space-between", align: "center", children: [
    t20,
    t21
  ] }) }), $[51] = t20, $[52] = t22) : t22 = $[52];
  let t23;
  $[53] !== menuButton ? (t23 = {
    placement: "bottom",
    matchReferenceWidth: !0,
    boundaryElement: menuButton
  }, $[53] = menuButton, $[54] = t23) : t23 = $[54];
  let t24;
  $[55] !== handleButtonReleaseTypeChange || $[56] !== t ? (t24 = Object.entries(RELEASE_TYPES_TONES).map((t252) => {
    const [type, t262] = t252, {
      tone
    } = t262;
    return /* @__PURE__ */ jsx(MenuItem, { "data-value": type, onClick: handleButtonReleaseTypeChange, children: /* @__PURE__ */ jsx(ReleaseTypeOption, { text: t(`release.type.${type}`), tone }) }, type);
  }), $[55] = handleButtonReleaseTypeChange, $[56] = t, $[57] = t24) : t24 = $[57];
  let t25;
  $[58] !== t24 ? (t25 = /* @__PURE__ */ jsx(Menu, { children: t24 }), $[58] = t24, $[59] = t25) : t25 = $[59];
  let t26;
  $[60] !== menuButtonId || $[61] !== t22 || $[62] !== t23 || $[63] !== t25 ? (t26 = /* @__PURE__ */ jsx(MenuButton$1, { id: menuButtonId, ref: setMenuButton, button: t22, popover: t23, menu: t25 }), $[60] = menuButtonId, $[61] = t22, $[62] = t23, $[63] = t25, $[64] = t26) : t26 = $[64];
  let t27;
  $[65] !== buttonReleaseType || $[66] !== handleBundlePublishAtCalendarChange || $[67] !== intendedPublishAt ? (t27 = buttonReleaseType === "scheduled" && /* @__PURE__ */ jsx(TabPanel, { "aria-labelledby": "release-timing-at-time-tab", flex: 1, id: "release-timing-at-time", style: {
    outline: "none"
  }, tabIndex: -1, children: /* @__PURE__ */ jsx(ScheduleDatePicker, { initialValue: intendedPublishAt || /* @__PURE__ */ new Date(), onChange: handleBundlePublishAtCalendarChange }) }), $[65] = buttonReleaseType, $[66] = handleBundlePublishAtCalendarChange, $[67] = intendedPublishAt, $[68] = t27) : t27 = $[68];
  let t28;
  $[69] !== t27 ? (t28 = /* @__PURE__ */ jsx(Flex, { gap: 1, children: t27 }), $[69] = t27, $[70] = t28) : t28 = $[70];
  let t29;
  $[71] !== t26 || $[72] !== t28 ? (t29 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t26,
    t28
  ] }), $[71] = t26, $[72] = t28, $[73] = t29) : t29 = $[73];
  let t30;
  $[74] !== t16 || $[75] !== t29 ? (t30 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t16,
    t29
  ] }), $[74] = t16, $[75] = t29, $[76] = t30) : t30 = $[76];
  let t31;
  $[77] !== handleTitleDescriptionChange || $[78] !== value ? (t31 = /* @__PURE__ */ jsx(TitleDescriptionForm, { release: value, onChange: handleTitleDescriptionChange }), $[77] = handleTitleDescriptionChange, $[78] = value, $[79] = t31) : t31 = $[79];
  let t32;
  return $[80] !== t30 || $[81] !== t31 ? (t32 = /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t30,
    t31
  ] }), $[80] = t30, $[81] = t31, $[82] = t32) : t32 = $[82], t32;
}
const ReleaseTypeOption = (t0) => {
  const $ = c(7), {
    tone,
    text
  } = t0;
  let t1;
  $[0] !== tone ? (t1 = /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 1, tone }), $[0] = tone, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== text ? (t2 = /* @__PURE__ */ jsx(Text$1, { children: text }), $[2] = text, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t1 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", children: [
    t1,
    t2
  ] }), $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
};
function createMultiKeyWeakMap() {
  const rootMap = /* @__PURE__ */ new WeakMap(), idCache2 = /* @__PURE__ */ new WeakMap();
  function randomId() {
    return Array.from({
      length: 10
    }).map(() => Math.floor(Math.random() * 255).toString(16).padStart(2, "0")).join("");
  }
  function assignId(key) {
    const cachedId = idCache2.get(key);
    if (cachedId) return cachedId;
    const id2 = randomId();
    return idCache2.set(key, id2), id2;
  }
  function arrangeKeys(keys) {
    return Array.from(new Set(keys)).map((key) => [assignId(key), key]).sort(([a], [b]) => a.localeCompare(b, "en")).map(([, key]) => key);
  }
  function getDeep(keys, map2) {
    if (!keys.length) return;
    const [firstKey, ...restOfKeys] = keys, node = map2.get(firstKey);
    if (node)
      return restOfKeys.length ? getDeep(restOfKeys, node.next) : node.value;
  }
  function setDeep(keys, map2, value) {
    if (!keys.length) return;
    const [firstKey, ...restOfKeys] = keys, node = map2.get(firstKey) || {
      type: "multi-key-weak-map-node",
      value: void 0,
      next: /* @__PURE__ */ new WeakMap()
    };
    if (map2.set(firstKey, node), !restOfKeys.length) {
      node.value = value;
      return;
    }
    setDeep(restOfKeys, node.next, value);
  }
  function get2(keys) {
    return getDeep(arrangeKeys(keys), rootMap);
  }
  function set2(keys, value) {
    setDeep(arrangeKeys(keys), rootMap, value);
  }
  return {
    get: get2,
    set: set2
  };
}
function ResourceCacheProvider(t0) {
  const $ = c(3), {
    children
  } = t0, [resourceCache] = useState(_temp$2w);
  let t1;
  return $[0] !== children || $[1] !== resourceCache ? (t1 = /* @__PURE__ */ jsx(ResourceCacheContext.Provider, { value: resourceCache, children }), $[0] = children, $[1] = resourceCache, $[2] = t1) : t1 = $[2], t1;
}
function _temp$2w() {
  const namespaces = /* @__PURE__ */ new Map(), nullReplacer = {}, emptyDependenciesReplacer = [nullReplacer], removeNullDependencies = (dependencies) => dependencies.length ? dependencies.map((dep) => dep === null ? nullReplacer : dep) : emptyDependenciesReplacer;
  return {
    get: (t0) => {
      const {
        namespace,
        dependencies: dependencies_0
      } = t0, dependenciesWithoutNull = removeNullDependencies(dependencies_0);
      return namespaces.get(namespace)?.get(dependenciesWithoutNull);
    },
    set: (t1) => {
      const {
        namespace: namespace_0,
        dependencies: dependencies_1,
        value
      } = t1, namespaceMap_0 = namespaces.get(namespace_0) || createMultiKeyWeakMap(), dependenciesWithoutNull_0 = removeNullDependencies(dependencies_1);
      namespaces.set(namespace_0, namespaceMap_0), namespaceMap_0.set(dependenciesWithoutNull_0, value);
    }
  };
}
function useResourceCache() {
  const cache2 = useContext(ResourceCacheContext);
  if (!cache2)
    throw new Error("Could not find `cache` context");
  return cache2;
}
function WorkspaceProvider(t0) {
  const $ = c(3), {
    children,
    workspace
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== workspace ? (t1 = /* @__PURE__ */ jsx(WorkspaceContext.Provider, { value: workspace, children }), $[0] = children, $[1] = workspace, $[2] = t1) : t1 = $[2], t1;
}
function useWorkspace() {
  const workspace = useContext(WorkspaceContext);
  if (!workspace)
    throw new Error("Workspace: missing context value");
  return workspace;
}
function memoize(fn, keyGen) {
  const MEMO = /* @__PURE__ */ Object.create(null);
  return (...args) => {
    const key = keyGen(...args);
    return key in MEMO || (MEMO[key] = fn(...args)), MEMO[key];
  };
}
const INITIAL_VALUE$4 = {
  data: [],
  error: null,
  loading: !0
}, getCompanionDocs = memoize((publishedId, client, previewStore) => {
  const companionDocsIdsListener$ = (id2) => previewStore.unstable_observeDocumentIdSet(`_type == "sanity.canvas.link" && (
            studioDocumentId in path("versions.**."+ $publishedId) || 
            studioDocumentId in [$publishedId, "drafts." + $publishedId]
         )`, {
    publishedId: id2
  }), getCompanionDoc$ = (id2) => client.observable.fetch("*[_id == $id][0]{ _id, canvasDocumentId, studioDocumentId}", {
    id: id2
  }, {
    tag: "canvas.companion-docs"
  }).pipe(map$1((response) => {
    if (!response?._id)
      throw new Error("Companion doc not ready");
    return response;
  }), retry({
    count: 2,
    delay: (error) => {
      if (error instanceof Error && error.message === "Companion doc not ready")
        return timer(1e3);
      throw error;
    }
  }));
  return companionDocsIdsListener$(publishedId).pipe(map$1((value) => value.documentIds), mergeMapArray(getCompanionDoc$), map$1((value) => ({
    error: null,
    data: value,
    loading: !1
  })), catchError$1((error) => of({
    error,
    data: [],
    loading: !1
  })), startWith$1(INITIAL_VALUE$4), shareReplay$1(1));
}, (publishedId, client) => `${publishedId}-${client.config().dataset}-${client.config().projectId}`);
function createCanvasCompanionDocsStore({
  client,
  previewStore
}) {
  return {
    getCompanionDocs: (documentId) => getCompanionDocs(getPublishedId(documentId), client, previewStore)
  };
}
function useCanvasCompanionDocsStore() {
  const $ = c(5), resourceCache = useResourceCache(), workspace = useWorkspace(), previewStore = useDocumentPreviewStore(), studioClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0, releaseStore;
  return $[0] !== previewStore || $[1] !== resourceCache || $[2] !== studioClient || $[3] !== workspace ? (releaseStore = resourceCache.get({
    dependencies: [workspace, previewStore],
    namespace: "CompanionDocsStore"
  }) || createCanvasCompanionDocsStore({
    client: studioClient,
    previewStore
  }), resourceCache.set({
    dependencies: [workspace, previewStore],
    namespace: "CompanionDocsStore",
    value: releaseStore
  }), $[0] = previewStore, $[1] = resourceCache, $[2] = studioClient, $[3] = workspace, $[4] = releaseStore) : releaseStore = $[4], t0 = releaseStore, t0;
}
const getUpdatedSnapshot = (bufferedDocument) => {
  const LOCAL = bufferedDocument.LOCAL, HEAD = bufferedDocument.document.HEAD;
  return LOCAL && {
    ...LOCAL,
    _type: (HEAD || LOCAL)._type,
    _rev: (HEAD || LOCAL)._rev,
    _updatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, toSnapshotEvent = (document2) => ({
  type: "snapshot",
  document: document2
}), getDocument = (event) => event.document, createObservableBufferedDocument = (listenerEvent$) => {
  const actions$ = new Subject(), consistency$ = new BehaviorSubject(!0), mutations$ = new Subject(), rebase$ = new Subject(), remoteMutations = new Subject(), commitRequests = new Subject(), createInitialBufferedDocument = (initialSnapshot) => {
    const bufferedDocument = new BufferedDocument(initialSnapshot);
    return bufferedDocument.onMutation = ({
      mutation,
      remote
    }) => {
      mutations$.next({
        type: "mutation",
        document: getUpdatedSnapshot(bufferedDocument),
        mutations: mutation.mutations,
        origin: remote ? "remote" : "local"
      });
    }, bufferedDocument.onRemoteMutation = (mutation) => {
      remoteMutations.next({
        type: "remoteMutation",
        head: bufferedDocument.document.HEAD,
        transactionId: mutation.transactionId,
        timestamp: mutation.timestamp,
        author: mutation.identity,
        effects: mutation.effects
      });
    }, bufferedDocument.onRebase = (edge, nextRemoteMutations, localMutations) => {
      rebase$.next({
        type: "rebase",
        document: edge,
        remoteMutations: nextRemoteMutations,
        localMutations
      });
    }, bufferedDocument.onConsistencyChanged = (isConsistent) => {
      consistency$.next(isConsistent);
    }, bufferedDocument.commitHandler = (commitArg) => commitRequests.next(commitArg), bufferedDocument;
  }, currentBufferedDocument$ = listenerEvent$.pipe(scan((bufferedDocument, listenerEvent) => listenerEvent.type === "snapshot" ? (bufferedDocument && bufferedDocument.commit(), createInitialBufferedDocument(listenerEvent.document || null)) : bufferedDocument === null ? (console.warn('Ignoring event of type "%s" since buffered document has not yet been set up with snapshot', listenerEvent.type), null) : bufferedDocument, null), filter((bufferedDocument) => bufferedDocument !== null), distinctUntilChanged(), publishReplay(1), refCount()), snapshotAfterSync$ = listenerEvent$.pipe(filter((ev) => ev.type === "mutation"), withLatestFrom(currentBufferedDocument$), map(([mutationEvent, bufferedDocument]) => (bufferedDocument.arrive(new Mutation(mutationEvent)), getUpdatedSnapshot(bufferedDocument)))), actionHandler$ = actions$.pipe(
    withLatestFrom(currentBufferedDocument$),
    tap(([action, bufferedDocument]) => {
      action.type === "mutation" && bufferedDocument.add(new Mutation({
        mutations: action.mutations
      })), action.type === "commit" && bufferedDocument.commit();
    }),
    // We subscribe to this only for the side effects
    mergeMapTo(EMPTY$6),
    share()
  ), emitAction = (action) => actions$.next(action), addMutations = (mutations) => emitAction({
    type: "mutation",
    mutations
  }), addMutation = (mutation) => addMutations([mutation]), commit2 = () => {
    currentBufferedDocument$.pipe(take(1), tap((bufferedDocument) => bufferedDocument.commit())).subscribe();
  }, snapshot$ = merge(currentBufferedDocument$.pipe(map((bufferedDocument) => bufferedDocument.LOCAL)), mutations$.pipe(map(getDocument)), rebase$.pipe(map(getDocument)), snapshotAfterSync$).pipe(map(toSnapshotEvent), publishReplay(1), refCount()), remoteSnapshot$ = merge(currentBufferedDocument$.pipe(map((bufferedDocument) => bufferedDocument.document.HEAD), map(toSnapshotEvent)), remoteMutations).pipe(publishReplay(1), refCount());
  return {
    updates$: merge(snapshot$, actionHandler$, mutations$, rebase$),
    consistency$: consistency$.pipe(distinctUntilChanged(), publishReplay(1), refCount()),
    remoteSnapshot$,
    commitRequest$: commitRequests,
    addMutation,
    addMutations,
    commit: commit2
  };
}, prepare = (id2) => (document2) => {
  const {
    _id,
    _rev,
    _updatedAt,
    ...rest
  } = document2;
  return {
    _id: id2,
    ...rest
  };
}, createBufferedDocument = (documentId, listenerEvent$) => {
  const bufferedDocument = createObservableBufferedDocument(listenerEvent$), prepareDoc = prepare(documentId), DELETE = {
    delete: {
      id: documentId
    }
  };
  return {
    events: bufferedDocument.updates$,
    consistency$: bufferedDocument.consistency$,
    remoteSnapshot$: bufferedDocument.remoteSnapshot$,
    commitRequest$: bufferedDocument.commitRequest$,
    patch: (patches) => patches.map((patch2) => ({
      patch: {
        ...patch2,
        id: documentId
      }
    })),
    create: (document2) => ({
      create: prepareDoc(document2)
    }),
    createIfNotExists: (document2) => ({
      createIfNotExists: prepareDoc(document2)
    }),
    createOrReplace: (document2) => ({
      createOrReplace: prepareDoc(document2)
    }),
    delete: () => DELETE,
    mutate: (mutations) => bufferedDocument.addMutations(mutations),
    commit: () => bufferedDocument.commit()
  };
};
function shareReplayLatest(configOrPredicate, config) {
  return _shareReplayLatest(typeof configOrPredicate == "function" ? {
    predicate: configOrPredicate,
    ...config
  } : configOrPredicate);
}
function _shareReplayLatest(config) {
  return (source) => {
    let latest, emitted = !1;
    const {
      predicate,
      ...shareConfig
    } = config, wrapped = source.pipe(tap$1((value) => {
      config.predicate(value) && (emitted = !0, latest = value);
    }), finalize(() => {
      emitted = !1, latest = void 0;
    }), share$1(shareConfig)), emitLatest = new Observable((subscriber) => {
      emitted && subscriber.next(
        // this cast is safe because of the emitted check which asserts that we got T from the source
        latest
      ), subscriber.complete();
    });
    return merge(wrapped, emitLatest);
  };
}
const debug$5 = debug$7("sanity:document-store");
function discardChainTo(chain, revision) {
  const revisionIndex = chain.findIndex((event) => event.resultRev === revision);
  return split(chain, revisionIndex + 1);
}
function split(array, index) {
  return index < 0 ? [[], array] : [array.slice(0, index), array.slice(index)];
}
function toOrderedChains(events2) {
  const parents = {};
  return events2.forEach((event) => {
    parents[event.resultRev] = events2.find((other) => other.resultRev === event.previousRev);
  }), Object.entries(parents).filter(([, parent]) => !parent).map((orphan) => {
    const [headRev] = orphan;
    let current = events2.find((event) => event.resultRev === headRev);
    const sortedList = [];
    for (; current; )
      sortedList.push(current), current = events2.find((event) => event.previousRev === current?.resultRev);
    return sortedList;
  });
}
const DEFAULT_MAX_BUFFER_SIZE = 20, DEFAULT_DEADLINE_MS = 3e4, EMPTY_ARRAY$z = [];
function sequentializeListenerEvents(options) {
  const {
    resolveChainDeadline = DEFAULT_DEADLINE_MS,
    maxBufferSize = DEFAULT_MAX_BUFFER_SIZE
  } = {};
  return (input$) => input$.pipe(scan((state, event) => {
    if (event.type === "mutation" && !state.base)
      throw new Error("Invalid state. Cannot create a sequence without a base");
    if (event.type === "snapshot")
      return {
        base: {
          revision: event.document?._rev
        },
        buffer: EMPTY_ARRAY$z,
        emitEvents: [event]
      };
    if (event.type === "mutation") {
      const orderedChains = toOrderedChains(state.buffer.concat(event)).map((chain) => {
        const [discarded, rest] = discardChainTo(chain, state.base.revision);
        return discarded.length > 0 && debug$5("Discarded %d mutations already applied to document", discarded.length), rest;
      }), [applicableChains, _nextBuffer] = partition(orderedChains, (chain) => state.base.revision === chain[0]?.previousRev), nextBuffer = _nextBuffer.flat();
      if (applicableChains.length > 1)
        throw new Error("Expected at most one applicable chain");
      if (applicableChains.length > 0 && applicableChains[0].length > 0) {
        const lastMutation = applicableChains[0].at(-1);
        return {
          base: {
            revision: (
              // special case: if the mutation deletes the document it technically has  no revision, despite
              // resultRev pointing at a transaction id.
              lastMutation.transition === "disappear" ? void 0 : lastMutation?.resultRev
            )
          },
          emitEvents: applicableChains[0],
          buffer: nextBuffer
        };
      }
      if (nextBuffer.length >= (globalThis.__sanity_debug_maxBufferSize ?? maxBufferSize))
        throw new MaxBufferExceededError(`Too many unchainable mutation events: ${state.buffer.length}`, state);
      return {
        ...state,
        buffer: nextBuffer,
        emitEvents: EMPTY_ARRAY$z
      };
    }
    return {
      ...state,
      emitEvents: [event]
    };
  }, {
    emitEvents: EMPTY_ARRAY$z,
    base: void 0,
    buffer: EMPTY_ARRAY$z
  }), switchMap$1((state) => {
    const deadline = globalThis.__sanity_debug_resolveChainDeadline ?? resolveChainDeadline;
    return state.buffer.length > 0 ? (debug$5("Detected %d listener event(s) that can't be applied in sequence. This could be due to events arriving out of order. Will throw an error if chain can't be resolved within %dms", state.buffer.length, deadline), concat(of(state), timer(deadline).pipe(mergeMap(() => throwError(() => new DeadlineExceededError(`Did not resolve chain within a deadline of ${resolveChainDeadline}ms`, state)))))) : of(state);
  }), mergeMap((state) => state.emitEvents));
}
class OutOfSyncError extends Error {
  /**
   * Attach state to the error for debugging/reporting
   */
  constructor(message, state) {
    super(message), this.name = "OutOfSyncError", this.state = state;
  }
}
class DeadlineExceededError extends OutOfSyncError {
  constructor(message, state) {
    super(message, state), this.name = "DeadlineExceededError";
  }
}
class MaxBufferExceededError extends OutOfSyncError {
  constructor(message, state) {
    super(message, state), this.name = "MaxBufferExceededError";
  }
}
const PENDING_START = {
  type: "pending",
  phase: "begin"
}, PENDING_END = {
  type: "pending",
  phase: "end"
};
function isMutationEvent(msg) {
  return msg.type === "mutation";
}
function isMultiTransactionEvent(msg) {
  return msg.transactionTotalEvents > 1;
}
function allPendingTransactionEventsReceived(listenerEvents) {
  const groupedMutations = groupBy(listenerEvents.filter((ev) => ev.type === "mutation"), (e) => e.transactionId);
  return Object.values(groupedMutations).every((mutations) => mutations.length === mutations[0].transactionTotalEvents);
}
function getPairListener(_client, idPair, options = {}) {
  const {
    publishedId,
    draftId,
    versionId
  } = idPair, client = idPair.versionId ? _client.withConfig(RELEASES_STUDIO_CLIENT_OPTIONS) : _client;
  if (idPair.versionId && getVersionFromId(idPair.versionId) === "published" || idPair.versionId && getVersionFromId(idPair.versionId) === "drafts")
    throw new Error('VersionId cannot be "published" or "drafts"');
  const pairEvents$ = defer(() => client.observable.listen("*[_id in $ids]", {
    ids: [publishedId, draftId, versionId].filter((id2) => typeof id2 < "u")
  }, {
    includeResult: !1,
    includeAllVersions: !0,
    events: ["welcome", "mutation", "reconnect"],
    effectFormat: "mendoza",
    tag: options.tag || "document.pair-listener"
  }).pipe(
    //filter((event) => Math.random() < 0.99 || event.type !== 'mutation'),
    shareReplayLatest({
      predicate: (event) => event.type === "welcome" || event.type === "reconnect"
    })
  )).pipe(
    concatMap$1((event) => event.type === "welcome" ? fetchInitialDocumentSnapshots().pipe(mergeMap(({
      draft,
      published,
      version
    }) => [createSnapshotEvent(draftId, draft), createSnapshotEvent(publishedId, published), ...versionId ? [createSnapshotEvent(versionId, version)] : []])) : of(event)),
    scan((acc, msg) => {
      if (!isMutationEvent(msg))
        return {
          next: [msg],
          buffer: []
        };
      const isBuffering = acc.buffer.length > 0, isMulti = isMultiTransactionEvent(msg);
      if (!isMulti && !isBuffering)
        return {
          next: [msg],
          buffer: []
        };
      if (!isMulti)
        return {
          next: [],
          buffer: acc.buffer.concat(msg)
        };
      const nextBuffer = acc.buffer.concat(msg);
      return allPendingTransactionEventsReceived(nextBuffer) ? {
        next: nextBuffer.concat(PENDING_END),
        buffer: []
      } : {
        next: nextBuffer.length === 1 ? [PENDING_START] : [],
        buffer: nextBuffer
      };
    }, {
      next: [],
      buffer: []
    }),
    // note: this flattens the array, and in the case of an empty array, no event will be pushed downstream
    mergeMap((v) => v.next),
    share()
  ), draftEvents$ = pairEvents$.pipe(filter((event) => event.type === "mutation" || event.type === "snapshot" ? event.documentId === draftId : !0), sequentializeListenerEvents()), publishedEvents$ = pairEvents$.pipe(filter((event) => event.type === "mutation" || event.type === "snapshot" ? event.documentId === publishedId : !0), sequentializeListenerEvents()), versionEvents$ = pairEvents$.pipe(filter((event) => event.type === "mutation" || event.type === "snapshot" ? event.documentId === versionId : !0), sequentializeListenerEvents());
  return merge(draftEvents$, publishedEvents$, versionEvents$).pipe(catchError((err, caught$) => err instanceof OutOfSyncError ? (debug$5("Recovering from OutOfSyncError: %s", OutOfSyncError.name), typeof options?.onSyncErrorRecovery == "function" ? options?.onSyncErrorRecovery(err) : console.error(err), caught$) : throwError(() => err)));
  function fetchInitialDocumentSnapshots() {
    return client.observable.getDocuments([publishedId, draftId, versionId].filter((id2) => typeof id2 == "string"), {
      tag: "document.snapshots"
    }).pipe(map(([published, draft, version]) => ({
      draft,
      published,
      version
    })));
  }
}
function createSnapshotEvent(documentId, document2) {
  return {
    type: "snapshot",
    documentId,
    document: document2
  };
}
const ACTIONS_API_MINIMUM_VERSION = "2025-02-19";
function actionsApiClient(client, idPair) {
  return idPair.versionId ? client.withConfig(RELEASES_STUDIO_CLIENT_OPTIONS) : client.withConfig({
    apiVersion: ACTIONS_API_MINIMUM_VERSION
  });
}
function operationsApiClient(client, idPair) {
  return idPair.versionId ? client.withConfig(RELEASES_STUDIO_CLIENT_OPTIONS) : client;
}
const FETCH_SHARD_TIMEOUT = 2e4, isMutationEventForDocId = (id2) => (event) => event.type !== "reconnect" && event.type !== "pending" && event.documentId === id2;
function setVersion(version) {
  return (ev) => ({
    ...ev,
    version
  });
}
function requireId(value) {
  if (!value._id)
    throw new Error("Expected document to have an _id");
}
function isLiveEditMutation(mutationParams, publishedId) {
  const {
    resultRev,
    ...mutation
  } = mutationParams;
  return mutation.mutations.flatMap((mut) => {
    const mutationPayloads = Object.values(mut);
    if (mutationPayloads.length > 1)
      throw new Error("Did not expect multiple mutations in the same payload");
    return mutationPayloads[0].id || mutationPayloads[0]._id;
  }).every((target) => target === publishedId);
}
function toActions(idPair, mutationParams) {
  const actions = mutationParams.mutations.flatMap((mutations) => {
    if (mutations.createIfNotExists)
      return [];
    if (mutations.create)
      return requireId(mutations.create), {
        actionType: "sanity.action.document.create",
        publishedId: idPair.publishedId,
        attributes: mutations.create,
        ifExists: "fail"
      };
    if (mutations.patch)
      return {
        actionType: "sanity.action.document.edit",
        draftId: idPair.versionId ?? idPair.draftId,
        publishedId: idPair.publishedId,
        patch: omit(mutations.patch, "id")
      };
    throw new Error("Cannot map mutation to action");
  });
  return actions.length === 0 ? [{
    actionType: "sanity.action.document.edit",
    draftId: idPair.draftId,
    publishedId: idPair.publishedId,
    patch: {
      unset: ["_empty_action_guard_pseudo_field_"]
    }
  }] : actions;
}
function commitActions(client, idPair, mutationParams) {
  return isLiveEditMutation(mutationParams, idPair.publishedId) ? commitMutations(client, idPair, mutationParams) : actionsApiClient(client, idPair).observable.action(toActions(idPair, mutationParams), {
    tag: "document.commit",
    transactionId: mutationParams.transactionId
  });
}
function commitMutations(client, idPair, mutationParams) {
  const {
    resultRev,
    ...mutation
  } = mutationParams;
  return operationsApiClient(client, idPair).dataRequest("mutate", mutation, {
    visibility: "async",
    returnDocuments: !1,
    tag: "document.commit",
    // This makes sure the studio doesn't crash when a draft is crated
    // because someone deleted a referenced document in the target dataset
    skipCrossDatasetReferenceValidation: !0
  });
}
function submitCommitRequest(client, idPair, request, serverActionsEnabled) {
  return from(serverActionsEnabled ? commitActions(client, idPair, request.mutation.params) : commitMutations(client, idPair, request.mutation.params)).pipe(tap({
    error: (error) => {
      "statusCode" in error && typeof error.statusCode == "number" && error.statusCode >= 400 && error.statusCode <= 500 ? request.cancel(error) : request.failure(error);
    },
    next: () => request.success()
  }));
}
function checkoutPair(client, idPair, serverActionsEnabled, options = {}) {
  const {
    publishedId,
    draftId,
    versionId
  } = idPair, {
    onReportLatency,
    onSyncErrorRecovery,
    tag
  } = options, listenerEvents$ = getPairListener(client, idPair, {
    onSyncErrorRecovery,
    tag
  }).pipe(share()), reconnect$ = listenerEvents$.pipe(filter((ev) => ev.type === "reconnect")), draft = createBufferedDocument(draftId, listenerEvents$.pipe(filter(isMutationEventForDocId(draftId)))), version = typeof versionId > "u" ? void 0 : createBufferedDocument(versionId, listenerEvents$.pipe(filter(isMutationEventForDocId(versionId)))), published = createBufferedDocument(publishedId, listenerEvents$.pipe(filter(isMutationEventForDocId(publishedId)))), transactionsPendingEvents$ = listenerEvents$.pipe(filter((ev) => ev.type === "pending")), commits$ = merge(draft.commitRequest$, published.commitRequest$, version ? version.commitRequest$ : EMPTY$6).pipe(mergeMap((commitRequest) => serverActionsEnabled.pipe(take(1), mergeMap((canUseServerActions) => submitCommitRequest(client, idPair, commitRequest, canUseServerActions))))), combinedEvents = defer(() => onReportLatency ? reportLatency({
    commits$,
    listenerEvents$,
    client,
    onReportLatency
  }) : merge(commits$, listenerEvents$)).pipe(mergeMap(() => EMPTY$6), share());
  return {
    transactionsPendingEvents$,
    draft: {
      ...draft,
      events: merge(combinedEvents, reconnect$, draft.events).pipe(map(setVersion("draft"))),
      remoteSnapshot$: draft.remoteSnapshot$.pipe(map(setVersion("draft")))
    },
    ...typeof version > "u" ? {} : {
      version: {
        ...version,
        events: merge(combinedEvents, reconnect$, version.events).pipe(map(setVersion("version"))),
        remoteSnapshot$: version.remoteSnapshot$.pipe(map(setVersion("version")))
      }
    },
    published: {
      ...published,
      events: merge(combinedEvents, reconnect$, published.events).pipe(map(setVersion("published"))),
      remoteSnapshot$: published.remoteSnapshot$.pipe(map(setVersion("published")))
    }
  };
}
function reportLatency(options) {
  const {
    client,
    commits$,
    listenerEvents$,
    onReportLatency
  } = options, shardInfo = fetch(client.getUrl(client.getDataUrl("ping")), {
    signal: AbortSignal.timeout(FETCH_SHARD_TIMEOUT)
  }).then((response) => response.headers.get("X-Sanity-Shard") || void 0).catch(() => {
  }), submittedMutations = commits$.pipe(map((ev) => ({
    type: "submit",
    transactionId: ev.transactionId,
    timestamp: /* @__PURE__ */ new Date()
  })), share()), receivedMutations = listenerEvents$.pipe(filter((ev) => ev.type === "mutation"), map((ev) => ({
    type: "receive",
    transactionId: ev.transactionId,
    timestamp: /* @__PURE__ */ new Date()
  })), share());
  return merge(submittedMutations, receivedMutations).pipe(scan((state, event) => {
    const matchingIndex = state.pending.findIndex((e) => e.transactionId === event.transactionId);
    if (matchingIndex > -1) {
      const matching = state.pending[matchingIndex], [submitEvent, receiveEvent] = matching.type == "submit" ? [matching, event] : [event, matching];
      return {
        event: {
          transactionId: event.transactionId,
          submittedAt: submitEvent.timestamp,
          receivedAt: submitEvent.timestamp,
          deltaMs: receiveEvent.timestamp.getTime() - submitEvent.timestamp.getTime()
        },
        pending: state.pending.toSpliced(matchingIndex, 1)
      };
    }
    return {
      event: void 0,
      pending: state.pending.concat(event)
    };
  }, {
    event: void 0,
    pending: []
  }), map((state) => state.event), filter((event) => !!event), withLatestFrom(shardInfo), tap(([event, shard]) => onReportLatency?.({
    latencyMs: event.deltaMs,
    shard,
    transactionId: event.transactionId
  })));
}
function memoizeKeyGen(client, idPair, typeName) {
  const config = client.config();
  return `${config.dataset ?? ""}-${config.projectId ?? ""}-${idPair.publishedId}-${idPair.versionId ?? ""}-${typeName}`;
}
const LISTENER_RESET_DELAY$1 = 1e4, memoizedPair = memoize((client, idPair, _typeName, serverActionsEnabled, pairListenerOptions) => new Observable((subscriber) => {
  const pair = checkoutPair(client, idPair, serverActionsEnabled, pairListenerOptions);
  return merge(
    of(pair),
    // merge in draft, published, and version events to makes sure they receive
    // the events they need for as long as the pair is subscribed to
    pair.draft.events.pipe(mergeMap(() => EMPTY$6)),
    pair.published.events.pipe(mergeMap(() => EMPTY$6)),
    pair.version?.events.pipe(mergeMap(() => EMPTY$6)) ?? EMPTY$6
  ).subscribe(subscriber);
}).pipe(share$1({
  connector: () => new ReplaySubject(1),
  resetOnComplete: !0,
  resetOnRefCountZero: () => timer(LISTENER_RESET_DELAY$1)
})), memoizeKeyGen);
function isSnapshotEvent(event) {
  return event.type === "snapshot";
}
function withSnapshots(pair) {
  return {
    snapshots$: pair.events.pipe(filter(isSnapshotEvent), map((event) => event.document), publishReplay(1), refCount()),
    patch: pair.patch,
    create: pair.create,
    createIfNotExists: pair.createIfNotExists,
    createOrReplace: pair.createOrReplace,
    delete: pair.delete,
    mutate: pair.mutate,
    commit: pair.commit
  };
}
const snapshotPair = memoize((client, idPair, typeName, serverActionsEnabled, pairListenerOptions) => memoizedPair(client, idPair, typeName, serverActionsEnabled, pairListenerOptions).pipe(map(({
  published,
  draft,
  version,
  transactionsPendingEvents$
}) => ({
  transactionsPendingEvents$,
  published: withSnapshots(published),
  draft: withSnapshots(draft),
  ...version ? {
    version: withSnapshots(version)
  } : {}
})), publishReplay(1), refCount()), memoizeKeyGen), isLiveEditEnabled$1 = (schema2, typeName) => schema2.get(typeName)?.liveEdit === !0, swr$1 = createSWR({
  maxSize: 50
}), LOCKED = {
  enabled: !0
}, NOT_LOCKED = {
  enabled: !1
}, editState = memoize((ctx, idPair, typeName) => {
  const liveEditSchemaType = isLiveEditEnabled$1(ctx.schema, typeName), liveEdit = typeof idPair.versionId < "u" || liveEditSchemaType;
  return snapshotPair(ctx.client, idPair, typeName, ctx.serverActionsEnabled, ctx.extraOptions).pipe(switchMap((versions) => combineLatest([versions.draft.snapshots$, versions.published.snapshots$, versions.transactionsPendingEvents$.pipe(map((ev) => ev.phase === "begin" ? LOCKED : NOT_LOCKED), startWith(NOT_LOCKED)), typeof versions.version > "u" ? of(null) : versions.version.snapshots$])), swr$1(`${idPair.publishedId}-${idPair.draftId}-${idPair.versionId}`), map(({
    value: [draftSnapshot, publishedSnapshot, transactionSyncLock, versionSnapshot],
    fromCache
  }) => ({
    id: idPair.publishedId,
    type: typeName,
    draft: draftSnapshot,
    published: publishedSnapshot,
    version: typeof idPair.versionId > "u" ? null : versionSnapshot,
    liveEdit,
    liveEditSchemaType,
    ready: !fromCache,
    transactionSyncLock: fromCache ? null : transactionSyncLock,
    release: idPair.versionId ? getVersionFromId(idPair.versionId) : void 0
  })), startWith({
    id: idPair.publishedId,
    type: typeName,
    draft: null,
    published: null,
    version: null,
    liveEdit,
    liveEditSchemaType,
    ready: !1,
    transactionSyncLock: null,
    release: idPair.versionId ? getVersionFromId(idPair.versionId) : void 0
  }), publishReplay(1), refCount());
}, (ctx, idPair, typeName) => memoizeKeyGen(ctx.client, idPair, typeName)), consistencyStatus = memoize((client, idPair, typeName, serverActionsEnabled, extraOptions) => memoizedPair(client, idPair, typeName, serverActionsEnabled, extraOptions).pipe(switchMap(({
  draft,
  published
}) => combineLatest([draft.consistency$, published.consistency$])), map(([draftIsConsistent, publishedIsConsistent]) => draftIsConsistent && publishedIsConsistent), distinctUntilChanged(), publishReplay(1), refCount()), memoizeKeyGen), operationArgs = memoize((ctx, idPair, typeName) => snapshotPair(ctx.client, idPair, typeName, ctx.serverActionsEnabled, ctx.pairListenerOptions).pipe(switchMap((versions) => combineLatest([versions.draft.snapshots$, versions.published.snapshots$, ctx.serverActionsEnabled, ...typeof versions.version > "u" ? [] : [versions.version.snapshots$]]).pipe(map(([draft, published, canUseServerActions, version]) => ({
  ...ctx,
  serverActionsEnabled: canUseServerActions,
  idPair,
  typeName,
  snapshots: {
    published,
    draft,
    ...version ? {
      version
    } : {}
  },
  ...versions.version ? {
    version: versions.version
  } : {},
  draft: versions.draft,
  published: versions.published
})))), publishReplay(1), refCount()), (ctx, idPair, typeName) => memoizeKeyGen(ctx.client, idPair, typeName)), commit = {
  disabled: () => !1,
  execute: ({
    draft,
    published,
    version
  }) => (version?.commit(), draft.commit(), published.commit(), EMPTY$6)
}, del$1 = {
  disabled: ({
    snapshots
  }) => snapshots.draft || snapshots.published ? !1 : "NOTHING_TO_DELETE",
  execute: ({
    client,
    schema: schema2,
    idPair,
    typeName
  }) => {
    const tx = operationsApiClient(client, idPair).observable.transaction().delete(idPair.publishedId);
    return isLiveEditEnabled$1(schema2, typeName) ? tx.commit({
      tag: "document.delete"
    }) : tx.delete(idPair.draftId).commit({
      tag: "document.delete",
      // this disables referential integrity for cross-dataset references. we
      // have this set because we warn against deletes in the `ConfirmDeleteDialog`
      // UI. This operation is run when "delete anyway" is clicked
      skipCrossDatasetReferenceValidation: !0
    });
  }
}, discardChanges$1 = {
  disabled: ({
    snapshots
  }) => snapshots.draft ? snapshots.published ? !1 : "NOT_PUBLISHED" : "NO_CHANGES",
  execute: ({
    client,
    idPair
  }) => operationsApiClient(client, idPair).observable.transaction().delete(idPair.draftId).commit({
    tag: "document.discard-changes"
  })
}, omitProps = ["_createdAt", "_updatedAt"], getDocumentToDuplicateId = ({
  versionSnapshot,
  dupeId,
  liveEdit
}) => {
  if (versionSnapshot) {
    const versionId = getVersionFromId(versionSnapshot._id);
    if (versionId) return getVersionId(dupeId, versionId);
  }
  return liveEdit ? dupeId : getDraftId(dupeId);
}, duplicate = {
  disabled: ({
    snapshots
  }) => snapshots.published || snapshots.draft || snapshots.version ? !1 : "NOTHING_TO_DUPLICATE",
  execute: ({
    schema: schema2,
    client,
    snapshots,
    typeName,
    idPair
  }, dupeId) => {
    const source = snapshots.version || snapshots.draft || snapshots.published;
    if (!source)
      throw new Error("cannot execute on empty document");
    const _id = getDocumentToDuplicateId({
      versionSnapshot: snapshots.version,
      dupeId,
      liveEdit: isLiveEditEnabled$1(schema2, typeName)
    });
    return operationsApiClient(client, idPair).observable.create({
      ...omit(source, omitProps),
      _id,
      _type: source._type
    }, {
      tag: "document.duplicate"
    });
  }
}, patch$1 = {
  disabled: () => !1,
  execute: ({
    schema: schema2,
    snapshots,
    idPair,
    draft,
    published,
    version,
    typeName
  }, patches = [], initialDocument) => {
    if (version) {
      version.mutate([version.createIfNotExists({
        _type: typeName,
        ...initialDocument
      }), ...version.patch(patches)]);
      return;
    }
    isLiveEditEnabled$1(schema2, typeName) ? published.mutate([published.createIfNotExists({
      _type: typeName,
      ...initialDocument
    }), ...published.patch(patches)]) : draft.mutate([draft.createIfNotExists({
      ...initialDocument,
      ...snapshots.published,
      _id: idPair.draftId,
      _type: typeName
    }), ...draft.patch(patches)]);
  }
};
function strengthenOnPublish(obj) {
  return isReference$1(obj) ? obj._strengthenOnPublish ? omit(obj, ["_strengthenOnPublish"].concat(obj._strengthenOnPublish.weak ? [] : ["_weak"])) : obj : typeof obj != "object" || !obj ? obj : Array.isArray(obj) ? obj.map(strengthenOnPublish) : Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, strengthenOnPublish(value)]));
}
const publish$1 = {
  disabled: ({
    schema: schema2,
    typeName,
    snapshots
  }) => isLiveEditEnabled$1(schema2, typeName) ? "LIVE_EDIT_ENABLED" : snapshots.draft ? !1 : snapshots.published ? "ALREADY_PUBLISHED" : "NO_CHANGES",
  execute: ({
    client,
    idPair,
    snapshots
  }) => {
    if (!snapshots.draft)
      throw new Error('cannot execute "publish" when draft is missing');
    const value = strengthenOnPublish(omit(snapshots.draft, "_updatedAt")), tx = operationsApiClient(client, idPair).observable.transaction();
    if (!snapshots.draft)
      throw new Error('cannot execute "publish" when draft is missing');
    return snapshots.published ? (tx.patch(idPair.publishedId, {
      // Hack until other mutations support revision locking
      unset: ["_revision_lock_pseudo_field_"],
      ifRevisionID: snapshots.published._rev
    }), tx.createOrReplace({
      ...value,
      _id: idPair.publishedId,
      _type: snapshots.draft._type
    })) : tx.create({
      ...value,
      _id: idPair.publishedId,
      _type: snapshots.draft._type
    }), tx.delete(idPair.draftId), tx.commit({
      tag: "document.publish",
      visibility: "async"
    });
  }
}, restore$2 = {
  disabled: () => !1,
  execute: ({
    historyStore,
    schema: schema2,
    idPair,
    typeName
  }, fromRevision) => {
    const targetId = isLiveEditEnabled$1(schema2, typeName) ? idPair.publishedId : idPair.draftId;
    return historyStore.restore(idPair.publishedId, targetId, fromRevision);
  }
}, unpublish$1 = {
  disabled: ({
    schema: schema2,
    snapshots,
    typeName
  }) => isLiveEditEnabled$1(schema2, typeName) ? "LIVE_EDIT_ENABLED" : snapshots.published ? !1 : "NOT_PUBLISHED",
  execute: ({
    client,
    idPair,
    snapshots
  }) => {
    let tx = operationsApiClient(client, idPair).observable.transaction().delete(idPair.publishedId);
    return snapshots.published && (tx = tx.createIfNotExists({
      ...omit(snapshots.published, "_updatedAt"),
      _id: idPair.draftId,
      _type: snapshots.published._type
    })), tx.commit({
      tag: "document.unpublish",
      visibility: "async",
      // this disables referential integrity for cross-dataset references. we
      // have this set because we warn against unpublishes in the `ConfirmDeleteDialog`
      // UI. This operation is run when "unpublish anyway" is clicked
      skipCrossDatasetReferenceValidation: !0
    });
  }
}, del = {
  disabled: ({
    snapshots
  }) => snapshots.draft || snapshots.published ? !1 : "NOTHING_TO_DELETE",
  execute: ({
    client,
    schema: schema2,
    idPair,
    typeName,
    snapshots
  }) => isLiveEditEnabled$1(schema2, typeName) ? client.observable.transaction().delete(idPair.publishedId).commit({
    tag: "document.delete"
  }) : snapshots.published ? actionsApiClient(client, idPair).observable.action({
    actionType: "sanity.action.document.delete",
    includeDrafts: snapshots.draft ? [idPair.draftId] : [],
    publishedId: idPair.publishedId
  }, {
    tag: "document.delete",
    // this disables referential integrity for cross-dataset references. we
    // have this set because we warn against deletes in the `ConfirmDeleteDialog`
    // UI. This operation is run when "delete anyway" is clicked
    skipCrossDatasetReferenceValidation: !0
  }) : actionsApiClient(client, idPair).observable.action({
    actionType: "sanity.action.document.discard",
    draftId: idPair.draftId
  }, {
    tag: "document.delete"
  })
}, discardChanges = {
  disabled: ({
    snapshots
  }) => snapshots.draft ? snapshots.published ? !1 : "NOT_PUBLISHED" : "NO_CHANGES",
  execute: ({
    client,
    idPair
  }) => actionsApiClient(client, idPair).observable.action({
    actionType: "sanity.action.document.discard",
    draftId: idPair.draftId
  }, {
    tag: "document.discard-changes"
  })
}, patch = {
  disabled: () => !1,
  execute: ({
    schema: schema2,
    snapshots,
    idPair,
    draft,
    published,
    version,
    typeName
  }, patches = [], initialDocument) => {
    if (version) {
      const patchMutation2 = version.patch(patches), ensureVersion = snapshots.version ? version.patch([{
        unset: ["_empty_action_guard_pseudo_field_"]
      }]) : [version.create({
        ...initialDocument,
        _id: idPair.draftId,
        _type: typeName
      })];
      version.mutate([...ensureVersion, ...patchMutation2]);
      return;
    }
    if (isLiveEditEnabled$1(schema2, typeName)) {
      const patchMutation2 = published.patch(patches), mutations = snapshots.published ? patchMutation2 : [published.createIfNotExists({
        _type: typeName,
        ...initialDocument
      })];
      published.mutate(mutations);
      return;
    }
    const patchMutation = draft.patch(patches);
    if (snapshots.published) {
      draft.mutate([
        // If there's no draft, the user's edits will be based on the published document in the form in front of them
        // so before patching it we need to make sure it's created based on the current published version first.
        draft.createIfNotExists({
          ...initialDocument,
          ...snapshots.published,
          _id: idPair.draftId,
          _type: typeName
        }),
        ...patchMutation
      ]);
      return;
    }
    const ensureDraft = snapshots.draft ? draft.patch([{
      unset: ["_empty_action_guard_pseudo_field_"]
    }]) : [draft.create({
      ...initialDocument,
      _id: idPair.draftId,
      _type: typeName
    })];
    draft.mutate([...ensureDraft, ...patchMutation]);
  }
}, publish = {
  disabled: ({
    schema: schema2,
    typeName,
    snapshots
  }) => isLiveEditEnabled$1(schema2, typeName) ? "LIVE_EDIT_ENABLED" : snapshots.draft ? !1 : snapshots.published ? "ALREADY_PUBLISHED" : "NO_CHANGES",
  execute: ({
    client,
    idPair,
    snapshots
  }) => {
    if (!snapshots.draft)
      throw new Error('cannot execute "publish" when draft is missing');
    return actionsApiClient(client, idPair).observable.action({
      actionType: "sanity.action.document.publish",
      draftId: idPair.draftId,
      publishedId: idPair.publishedId,
      // Optimistic locking using `ifPublishedRevisionId` ensures that concurrent publish action
      // invocations do not override each other.
      //
      // Note: for custom publish actions, `snapshots.draft._rev` may be stale, which means the
      // `ifDraftRevisionId` optimistic lock cannot currently be used.
      ifPublishedRevisionId: snapshots.published?._rev
    }, {
      tag: "document.publish"
    });
  }
}, restore$1 = {
  disabled: () => !1,
  execute: ({
    snapshots,
    historyStore,
    schema: schema2,
    idPair,
    typeName
  }, fromRevision) => {
    const targetId = isLiveEditEnabled$1(schema2, typeName) ? idPair.publishedId : idPair.draftId;
    return historyStore.restore(idPair.publishedId, targetId, fromRevision, {
      fromDeleted: !snapshots.draft && !snapshots.published,
      useServerDocumentActions: !0
    });
  }
}, unpublish = {
  disabled: ({
    schema: schema2,
    snapshots,
    typeName
  }) => isLiveEditEnabled$1(schema2, typeName) ? "LIVE_EDIT_ENABLED" : snapshots.published ? !1 : "NOT_PUBLISHED",
  execute: ({
    client,
    idPair
  }) => actionsApiClient(client, idPair).observable.action({
    // This operation is run when "unpublish anyway" is clicked
    actionType: "sanity.action.document.unpublish",
    draftId: idPair.draftId,
    publishedId: idPair.publishedId
  }, {
    tag: "document.unpublish",
    // this disables referential integrity for cross-dataset references. we
    // have this set because we warn against unpublishes in the `ConfirmDeleteDialog`
    // UI.
    skipCrossDatasetReferenceValidation: !0
  })
};
function maybeObservable(v) {
  return typeof v > "u" ? of(null) : v;
}
const operationImpls = {
  del: del$1,
  delete: del$1,
  publish: publish$1,
  patch: patch$1,
  commit,
  discardChanges: discardChanges$1,
  unpublish: unpublish$1,
  duplicate,
  restore: restore$2
}, serverOperationImpls = {
  ...operationImpls,
  del,
  delete: del,
  discardChanges,
  patch,
  publish,
  unpublish,
  restore: restore$1
}, execute = (operationName, operationArguments, extraArgs, serverActionsEnabled) => {
  const operation = serverActionsEnabled ? serverOperationImpls[operationName] : operationImpls[operationName];
  return defer(() => merge(of(null), maybeObservable(operation.execute(operationArguments, ...extraArgs)))).pipe(last());
}, operationCalls$ = new Subject();
function emitOperation(operationName, idPair, typeName, extraArgs) {
  operationCalls$.next({
    operationName,
    idPair,
    typeName,
    extraArgs
  });
}
const REQUIRES_CONSISTENCY = ["publish", "unpublish", "discardChanges", "delete"], operationEvents = memoize((ctx) => {
  const result$ = operationCalls$.pipe(groupBy$1((op) => op.idPair.publishedId), mergeMap((groups$) => groups$.pipe(
    // although it might look like a bug, dropping pending async operations here is actually a feature
    // E.g. if the user types `publish` which is async and then starts patching (sync) then the publish
    // should be cancelled
    switchMap((args) => operationArgs(ctx, args.idPair, args.typeName).pipe(take(1), switchMap((operationArguments) => {
      const requiresConsistency = REQUIRES_CONSISTENCY.includes(args.operationName);
      requiresConsistency && (operationArguments.published.commit(), operationArguments.draft.commit());
      const isConsistent$ = consistencyStatus(ctx.client, args.idPair, args.typeName, ctx.serverActionsEnabled, ctx.extraOptions).pipe(filter(Boolean));
      return (requiresConsistency ? isConsistent$.pipe(take(1)) : of(!0)).pipe(switchMap(() => execute(args.operationName, operationArguments, args.extraArgs, operationArguments.serverActionsEnabled)));
    }), map(() => ({
      type: "success",
      args
    })), catchError((err) => of({
      type: "error",
      args,
      error: err
    }))))
  )), share()), autoCommit$ = result$.pipe(filter((result) => result.type === "success" && result.args.operationName === "patch"), throttleTime(1e3, asyncScheduler, {
    leading: !0,
    trailing: !0
  }), concatMap$1((result) => window.SLOW ? timer(1e4).pipe(map(() => result)) : of(result)), tap((result) => {
    emitOperation("commit", result.args.idPair, result.args.typeName, []);
  }));
  return merge(result$, autoCommit$.pipe(mergeMapTo(EMPTY$6)));
}, (ctx) => {
  const config = ctx.client.config();
  return `${config.dataset ?? ""}-${config.projectId ?? ""}${ctx.serverActionsEnabled ? "-serverActionsEnabled" : ""}`;
}), remoteSnapshots = memoize((client, idPair, typeName, serverActionsEnabled, pairListenerOptions) => memoizedPair(client, idPair, typeName, serverActionsEnabled, pairListenerOptions).pipe(switchMap(({
  published,
  draft,
  version
}) => merge(published.remoteSnapshot$, draft.remoteSnapshot$, version?.remoteSnapshot$ ?? EMPTY$6))), memoizeKeyGen);
function pathToString(path = []) {
  return path.reduce((target, segment, i) => {
    const segmentType = typeof segment;
    if (segmentType === "number")
      return `${target}[${segment}]`;
    if (segmentType === "string")
      return `${target}${i === 0 ? "" : "."}${segment}`;
    if (isKeyedObject(segment))
      return `${target}[_key=="${segment._key}"]`;
    throw new Error(`Unsupported path segment "${segment}"`);
  }, "");
}
function isNonNullable$2(t) {
  return t !== null || t !== void 0;
}
function convertToValidationMarker(validatorResult, level, context) {
  if (!context)
    throw new Error("missing context");
  if (validatorResult === !0) return [];
  if (Array.isArray(validatorResult))
    return validatorResult.flatMap((child) => convertToValidationMarker(child, level, context)).filter(isNonNullable$2);
  if (typeof validatorResult == "string")
    return convertToValidationMarker({
      message: validatorResult
    }, level, context);
  if (typeof validatorResult.message != "string")
    throw new Error(`${pathToString(context.path)}: Validator must return 'true' if valid or an error message as a string on errors`);
  const {
    message
  } = validatorResult, normalizedPaths = [];
  validatorResult.path && normalizedPaths.push(validatorResult.path);
  for (const path of validatorResult.paths || [])
    normalizedPaths.push(path);
  return normalizedPaths.length ? normalizedPaths.map((path) => ({
    path: (context.path || []).concat(path),
    level: level || "error",
    item: {
      message
    },
    message
  })) : [{
    level: level || "error",
    item: {
      message
    },
    message,
    path: context.path || []
  }];
}
function escapeRegex(string) {
  return string.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
}
function localizeMessage(message, i18n) {
  const {
    currentLocale
  } = i18n, locale = currentLocale.id;
  if (message[locale])
    return message[locale];
  if (locale.includes("-")) {
    const language = locale.split("-", 1)[0];
    if (message[language])
      return message[language];
  }
  return message["en-US"] || message["en-GB"] || message.en || "Unknown validation error (not localized)";
}
function isLocalizedMessages(message) {
  return message !== !0 && typeof message < "u" && typeof message != "string" && isPlainObject$1(message) && !("message" in message);
}
function deepEqualsIgnoreKey(a, b) {
  if (a === b)
    return !0;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length != b.length) return !1;
    for (let i = 0; i < a.length; i++)
      if (!deepEqualsIgnoreKey(a[i], b[i]))
        return !1;
    return !0;
  }
  if (Array.isArray(a) != Array.isArray(b))
    return !1;
  if (a && b && typeof a == "object" && typeof b == "object") {
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length)
      return !1;
    if (a instanceof Date && b instanceof Date)
      return a.getTime() === b.getTime();
    if (a instanceof Date != b instanceof Date)
      return !1;
    if (a instanceof RegExp && b instanceof RegExp)
      return a.toString() == b.toString();
    if (a instanceof RegExp != b instanceof RegExp)
      return !1;
    for (let i = 0; i < keys.length; i++)
      if (keys[i] !== "_key" && !Object.prototype.hasOwnProperty.call(b, keys[i]))
        return !1;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key !== "_key" && !deepEqualsIgnoreKey(a[key], b[key]))
        return !1;
    }
    return !0;
  }
  return !1;
}
const _toString = {}.toString, builtIns = [Object, Function, Array, String, Boolean, Number, Date, RegExp, Error];
function isBuiltIn(_constructor) {
  for (let i = 0; i < builtIns.length; i++)
    if (builtIns[i] === _constructor) return !0;
  return !1;
}
function typeString(obj) {
  const stringType = _toString.call(obj).slice(8, -1);
  if (obj == null) return stringType.toLowerCase();
  const constructorType = obj.constructor;
  return constructorType && !isBuiltIn(constructorType) ? constructorType.name : stringType;
}
const SLOW_VALIDATOR_TIMEOUT = 5e3, formatValidationErrors = (options) => options.message ? options.message : options.results.length === 1 ? options.results[0]?.message : options.i18n.t("{{messages, list}}", {
  messages: options.results.map((err) => err.message || err.item?.message),
  formatParams: {
    messages: {
      style: "long",
      type: options.operation
    }
  }
}), genericValidators = {
  type: (expectedType, value, message, {
    i18n
  }) => {
    const actualType = typeString(value);
    return actualType !== expectedType && actualType !== "undefined" ? message || i18n.t("validation:generic.incorrect-type", {
      actualType,
      expectedType
    }) : !0;
  },
  presence: (expected, value, message, {
    i18n
  }) => value === void 0 && expected === "required" ? message || i18n.t("validation:generic.required") : !0,
  all: async (children, value, message, context) => {
    const results = (await Promise.all(children.map((child) => child.validate(value, context)))).flat();
    return results.length === 0 ? !0 : formatValidationErrors({
      message,
      results,
      operation: "conjunction",
      i18n: context.i18n
    });
  },
  either: async (children, value, message, context) => {
    const resolved = await Promise.all(children.map((child) => child.validate(value, context))), results = resolved.flat();
    return resolved.find((result) => !result.length) ? !0 : formatValidationErrors({
      message,
      results,
      operation: "disjunction",
      i18n: context.i18n
    });
  },
  valid: (allowedValues, actual, message, {
    i18n
  }) => {
    const valueType = typeof actual;
    if (valueType === "undefined")
      return !0;
    const value = (valueType === "number" || valueType === "string") && `${actual}`, strValue = value && value.length > 30 ? `${value.slice(0, 30)}\u2026` : value;
    return allowedValues.some((expected) => deepEqualsIgnoreKey(expected, actual)) ? !0 : message || i18n.t("validation:generic.not-allowed", value ? {
      context: "hint",
      replace: {
        hint: strValue
      }
    } : {});
  },
  custom: async (fn, value, message, context) => {
    const slowTimer = setTimeout(() => {
      context.environment === "studio" && console.warn(`Custom validator at ${pathToString(context.path)} has taken more than ${SLOW_VALIDATOR_TIMEOUT}ms to respond`);
    }, SLOW_VALIDATOR_TIMEOUT);
    let result;
    try {
      result = await fn(value, context);
    } finally {
      clearTimeout(slowTimer);
    }
    return isLocalizedMessages(result) ? localizeMessage(result, context.i18n) : typeof result == "string" && message || result;
  }
}, arrayValidators = {
  ...genericValidators,
  min: (minLength, value, message, {
    i18n,
    type
  }) => {
    if (!value || value.length >= minLength)
      return !0;
    const context = isArrayOfBlocksSchemaType(type) ? "blocks" : void 0;
    return message || i18n.t("validation:array.minimum-length", {
      minLength,
      context
    });
  },
  max: (maxLength, value, message, {
    i18n,
    type
  }) => {
    if (!value || value.length <= maxLength)
      return !0;
    const context = isArrayOfBlocksSchemaType(type) ? "blocks" : void 0;
    return message || i18n.t("validation:array.maximum-length", {
      maxLength,
      context
    });
  },
  length: (wantedLength, value, message, {
    i18n,
    type
  }) => {
    if (!value || value.length === wantedLength)
      return !0;
    const context = isArrayOfBlocksSchemaType(type) ? "blocks" : void 0;
    return message || i18n.t("validation:array.exact-length", {
      wantedLength,
      context
    });
  },
  presence: (flag, value, message, {
    i18n
  }) => flag === "required" && !value ? message || i18n.t("validation:generic.required", {
    context: "array"
  }) : !0,
  valid: (allowedValues, values2, message, {
    i18n
  }) => {
    if (typeof values2 > "u")
      return !0;
    const paths = [];
    for (let i = 0; i < values2.length; i++) {
      const value = values2[i];
      if (allowedValues.some((expected) => deepEqualsIgnoreKey(expected, value)))
        continue;
      const pathSegment = value && value._key ? {
        _key: value._key
      } : i;
      paths.push([pathSegment]);
    }
    const sharedMessage = message || i18n.t("validation:generic.not-allowed");
    return paths.map((path) => ({
      message: sharedMessage,
      path
    }));
  },
  unique: (_unused, value, message, {
    i18n
  }) => {
    const dupeIndices = [];
    if (!value)
      return !0;
    for (let x = 0; x < value.length; x++)
      for (let y = x + 1; y < value.length; y++) {
        const itemA = value[x], itemB = value[y];
        deepEqualsIgnoreKey(itemA, itemB) && (dupeIndices.indexOf(x) === -1 && dupeIndices.push(x), dupeIndices.indexOf(y) === -1 && dupeIndices.push(y));
      }
    const paths = dupeIndices.map((idx) => {
      const item = value[idx];
      return [item && item._key ? {
        _key: item._key
      } : idx];
    }), sharedMessage = message || i18n.t("validation:array.item-duplicate");
    return paths.map((path) => ({
      message: sharedMessage,
      path
    }));
  }
}, booleanValidators = {
  ...genericValidators,
  presence: (flag, value, message, {
    i18n
  }) => flag === "required" && typeof value != "boolean" ? message || i18n.t("validation:generic.required", {
    context: "boolean"
  }) : !0
};
function isRecord$3(obj) {
  return typeof obj == "object" && obj !== null && !Array.isArray(obj);
}
const isoDate = /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/, getFormattedDate = (type = "", value, options) => {
  const dateFormat = options?.dateFormat || legacyDateFormat.DEFAULT_DATE_FORMAT, timeFormat = options?.timeFormat || legacyDateFormat.DEFAULT_TIME_FORMAT;
  return legacyDateFormat.format(value, type === "date" ? dateFormat : `${dateFormat} ${timeFormat}`, type === "date");
};
function parseDate(date, throwOnError = !1) {
  if (!date) return null;
  if (date === "now") return /* @__PURE__ */ new Date();
  const parsed = new Date(date), isInvalid = isNaN(parsed.getTime());
  if (isInvalid && throwOnError)
    throw new Error(`Unable to parse "${date}" to a date`);
  return isInvalid ? null : parsed;
}
const dateValidators = {
  ...genericValidators,
  type: (_unused, value, message, {
    i18n
  }) => typeof value > "u" || isoDate.test(`${value}`) ? !0 : message || i18n.t("validation:date.invalid-format"),
  min: (minDate, value, message, {
    type,
    i18n
  }) => {
    const dateVal = parseDate(value), minDateVal = parseDate(minDate, !0);
    if (!dateVal || !value || dateVal >= minDateVal)
      return !0;
    if (!type)
      throw new Error("`type` was not provided in validation context.");
    const dateTimeOptions = isRecord$3(type.options) ? type.options : {};
    return message || // Note that the `minDate` passed here is _formatted_, while the raw value provided to the
    // validator is available as `providedMinDate`. This because the formatted date is likely
    // what the developer wants to present to the user
    i18n.t("validation:date.minimum", {
      minDate: getFormattedDate(type.name, minDateVal, dateTimeOptions),
      providedMinDate: minDate
    });
  },
  max: (maxDate, value, message, {
    type,
    i18n
  }) => {
    const dateVal = parseDate(value), maxDateVal = parseDate(maxDate, !0);
    if (!dateVal || !value || dateVal <= maxDateVal)
      return !0;
    if (!type)
      throw new Error("`type` was not provided in validation context.");
    const dateTimeOptions = isRecord$3(type.options) ? type.options : {};
    return message || // Note that the `maxDate` passed here is _formatted_, while the raw value provided to the
    // validator is available as `providedMaxDate`. This because the formatted date is likely
    // what the developer wants to present to the user
    i18n.t("validation:date.maximum", {
      maxDate: getFormattedDate(type.name, maxDateVal, dateTimeOptions),
      providedMaxDate: maxDate
    });
  }
}, precisionRx = /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/, numberValidators = {
  ...genericValidators,
  integer: (_unused, value, message, {
    i18n
  }) => Number.isInteger(value) ? !0 : message || i18n.t("validation:number.non-integer"),
  precision: (limit2, value, message, {
    i18n
  }) => {
    if (value === void 0) return !0;
    const places = value.toString().match(precisionRx);
    return Math.max((places[1] ? places[1].length : 0) - (places[2] ? parseInt(places[2], 10) : 0), 0) > limit2 ? message || i18n.t("validation:number.maximum-precision", {
      limit: limit2
    }) : !0;
  },
  min: (minNumber, value, message, {
    i18n
  }) => value >= minNumber ? !0 : message || i18n.t("validation:number.minimum", {
    minNumber
  }),
  max: (maxNumber, value, message, {
    i18n
  }) => value <= maxNumber ? !0 : message || i18n.t("validation:number.maximum", {
    maxNumber
  }),
  greaterThan: (threshold, value, message, {
    i18n
  }) => value > threshold ? !0 : message || i18n.t("validation:number.greater-than", {
    threshold
  }),
  lessThan: (threshold, value, message, {
    i18n
  }) => value < threshold ? !0 : message || i18n.t("validation:number.less-than", {
    threshold
  })
}, metaKeys = ["_key", "_type", "_weak"], objectValidators = {
  ...genericValidators,
  presence: (expected, value, message, {
    i18n
  }) => {
    if (expected !== "required")
      return !0;
    const keys = value && Object.keys(value).filter((key) => !metaKeys.includes(key));
    return value === void 0 || keys && keys.length === 0 ? message || i18n.t("validation:generic.required", {
      context: "object"
    }) : !0;
  },
  reference: async (_unused, value, message, context) => {
    if (!value)
      return !0;
    const {
      type,
      document: document2,
      getDocumentExists,
      i18n
    } = context;
    if (!isReference$1(value))
      return message || i18n.t("validation:object.not-reference");
    if (!type)
      throw new Error("`type` was not provided in validation context");
    if ("weak" in type && type.weak)
      return !0;
    if (!getDocumentExists)
      throw new Error("`getDocumentExists` was not provided in validation context");
    const documentId = document2?._id;
    return documentId && value._ref == getPublishedId(documentId) || await getDocumentExists({
      id: value._ref
    }) ? !0 : i18n.t("validation:object.reference-not-published", {
      documentId: value._ref
    });
  },
  assetRequired: (flag, value, message, {
    i18n
  }) => !value || !value.asset || !value.asset._ref ? message || i18n.t("validation:object.asset-required", {
    context: flag.assetType || ""
  }) : !0
}, DUMMY_ORIGIN = "http://sanity", isRelativeUrl = (url) => /^\.*\//.test(url), emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, stringValidators = {
  ...genericValidators,
  min: (minLength, value, message, {
    i18n
  }) => !value || value.length >= minLength ? !0 : message || i18n.t("validation:string.minimum-length", {
    minLength
  }),
  max: (maxLength, value, message, {
    i18n
  }) => !value || value.length <= maxLength ? !0 : message || i18n.t("validation:string.maximum-length", {
    maxLength
  }),
  length: (wantedLength, value, message, {
    i18n
  }) => (value || "").length === wantedLength ? !0 : message || i18n.t("validation:string.exact-length", {
    wantedLength
  }),
  uri: (constraints, value, message, {
    i18n
  }) => {
    const strValue = value || "";
    if (!strValue)
      return !0;
    const {
      options
    } = constraints, {
      allowCredentials,
      relativeOnly
    } = options, allowRelative = options.allowRelative || relativeOnly;
    let url;
    try {
      url = allowRelative ? new URL(strValue, DUMMY_ORIGIN) : new URL(strValue);
    } catch {
      return message || i18n.t("validation:string.url.invalid");
    }
    if (relativeOnly && url.origin !== DUMMY_ORIGIN)
      return message || i18n.t("validation:string.url.not-relative");
    if (!allowRelative && url.origin === DUMMY_ORIGIN && isRelativeUrl(strValue))
      return message || i18n.t("validation:string.url.not-absolute");
    if (!allowCredentials && (url.username || url.password))
      return message || i18n.t("validation:string.url.includes-credentials");
    const urlScheme = url.protocol.replace(/:$/, "");
    return options.scheme.some((scheme) => scheme.test(urlScheme)) ? !0 : message || i18n.t("validation:string.url.disallowed-scheme", {
      scheme: urlScheme
    });
  },
  stringCasing: (casing, value, message, {
    i18n
  }) => {
    const strValue = value || "";
    return casing === "uppercase" && strValue !== strValue.toLocaleUpperCase() ? message || i18n.t("validation:string.uppercase") : casing === "lowercase" && strValue !== strValue.toLocaleLowerCase() ? message || i18n.t("validation:string.lowercase") : !0;
  },
  presence: (flag, value, message, {
    i18n
  }) => flag === "required" && !value ? message || i18n.t("validation:generic.required", {
    context: "string"
  }) : !0,
  regex: (options, value, message, {
    i18n
  }) => {
    const {
      pattern,
      name,
      invert
    } = options, regName = name || `${pattern.toString()}`, strValue = value || "";
    pattern.lastIndex = 0;
    const matches = pattern.test(strValue);
    return !invert && !matches || invert && matches ? message || (invert ? i18n.t("validation:string.regex-match", {
      name: regName
    }) : i18n.t("validation:string.regex-does-not-match", {
      name: regName
    })) : !0;
  },
  email: (_unused, value, message, {
    i18n
  }) => {
    const strValue = `${value || ""}`.trim();
    return !strValue || emailRegex.test(strValue) ? !0 : message || i18n.t("validation:string.email");
  }
}, typeValidators = {
  Boolean: booleanValidators,
  Number: numberValidators,
  String: stringValidators,
  Array: arrayValidators,
  Object: objectValidators,
  Date: dateValidators
}, getBaseType = (type) => type && type.type ? getBaseType(type.type) : type, isFieldRef = (constraint) => typeof constraint != "object" || !constraint ? !1 : constraint.type === Rule.FIELD_REF, EMPTY_ARRAY$y = [], FIELD_REF = Symbol("FIELD_REF"), ruleConstraintTypes$1 = ["Array", "Boolean", "Date", "Number", "Object", "String"], Rule = class Rule2 {
  static FIELD_REF = FIELD_REF;
  static array = (def) => new Rule2(def).type("Array");
  static object = (def) => new Rule2(def).type("Object");
  static string = (def) => new Rule2(def).type("String");
  static number = (def) => new Rule2(def).type("Number");
  static boolean = (def) => new Rule2(def).type("Boolean");
  static dateTime = (def) => new Rule2(def).type("Date");
  static valueOfField = (path) => ({
    type: FIELD_REF,
    path
  });
  _type = void 0;
  _level = void 0;
  _required = void 0;
  _typeDef = void 0;
  _message = void 0;
  _rules = [];
  _fieldRules = void 0;
  constructor(typeDef) {
    this._typeDef = typeDef, this.reset();
  }
  _mergeRequired(next) {
    if (this._required === "required" || next._required === "required") return "required";
    if (this._required === "optional" || next._required === "optional") return "optional";
  }
  // Alias to static method, since we often have access to an _instance_ of a rule but not the actual Rule class
  valueOfField = Rule2.valueOfField.bind(Rule2);
  error(message) {
    const rule = this.clone();
    return rule._level = "error", rule._message = message || void 0, rule;
  }
  warning(message) {
    const rule = this.clone();
    return rule._level = "warning", rule._message = message || void 0, rule;
  }
  info(message) {
    const rule = this.clone();
    return rule._level = "info", rule._message = message || void 0, rule;
  }
  reset() {
    return this._type = this._type || void 0, this._rules = (this._rules || []).filter((rule) => rule.flag === "type"), this._message = void 0, this._required = void 0, this._level = "error", this._fieldRules = void 0, this;
  }
  isRequired() {
    return this._required === "required";
  }
  clone() {
    const rule = new Rule2();
    return rule._type = this._type, rule._message = this._message, rule._required = this._required, rule._rules = cloneDeep(this._rules), rule._level = this._level, rule._fieldRules = this._fieldRules, rule._typeDef = this._typeDef, rule;
  }
  cloneWithRules(rules) {
    const rule = this.clone(), newRules = /* @__PURE__ */ new Set();
    return rules.forEach((curr) => {
      curr.flag === "type" && (rule._type = curr.constraint), newRules.add(curr.flag);
    }), rule._rules = rule._rules.filter((curr) => {
      const disallowDuplicate = ["type", "uri", "email"].includes(curr.flag), isDuplicate = newRules.has(curr.flag);
      return !(disallowDuplicate && isDuplicate);
    }).concat(rules), rule;
  }
  merge(rule) {
    if (this._type && rule._type && this._type !== rule._type)
      throw new Error("merge() failed: conflicting types");
    const newRule = this.cloneWithRules(rule._rules);
    return newRule._type = this._type || rule._type, newRule._message = this._message || rule._message, newRule._required = this._mergeRequired(rule), newRule._level = this._level === "error" ? rule._level : this._level, newRule;
  }
  // Validation flag setters
  type(targetType) {
    const type = `${targetType.slice(0, 1).toUpperCase()}${targetType.slice(1)}`;
    if (!ruleConstraintTypes$1.includes(type))
      throw new Error(`Unknown type "${targetType}"`);
    const rule = this.cloneWithRules([{
      flag: "type",
      constraint: type
    }]);
    return rule._type = type, rule;
  }
  all(children) {
    return this.cloneWithRules([{
      flag: "all",
      constraint: children
    }]);
  }
  either(children) {
    return this.cloneWithRules([{
      flag: "either",
      constraint: children
    }]);
  }
  // Shared rules
  optional() {
    const rule = this.cloneWithRules([{
      flag: "presence",
      constraint: "optional"
    }]);
    return rule._required = "optional", rule;
  }
  required() {
    const rule = this.cloneWithRules([{
      flag: "presence",
      constraint: "required"
    }]);
    return rule._required = "required", rule;
  }
  custom(fn, options = {}) {
    return options.bypassConcurrencyLimit && Object.assign(fn, {
      bypassConcurrencyLimit: !0
    }), this.cloneWithRules([{
      flag: "custom",
      constraint: fn
    }]);
  }
  min(len) {
    return this.cloneWithRules([{
      flag: "min",
      constraint: len
    }]);
  }
  max(len) {
    return this.cloneWithRules([{
      flag: "max",
      constraint: len
    }]);
  }
  length(len) {
    return this.cloneWithRules([{
      flag: "length",
      constraint: len
    }]);
  }
  valid(value) {
    const values2 = Array.isArray(value) ? value : [value];
    return this.cloneWithRules([{
      flag: "valid",
      constraint: values2
    }]);
  }
  // Numbers only
  integer() {
    return this.cloneWithRules([{
      flag: "integer"
    }]);
  }
  precision(limit2) {
    return this.cloneWithRules([{
      flag: "precision",
      constraint: limit2
    }]);
  }
  positive() {
    return this.cloneWithRules([{
      flag: "min",
      constraint: 0
    }]);
  }
  negative() {
    return this.cloneWithRules([{
      flag: "lessThan",
      constraint: 0
    }]);
  }
  greaterThan(num) {
    return this.cloneWithRules([{
      flag: "greaterThan",
      constraint: num
    }]);
  }
  lessThan(num) {
    return this.cloneWithRules([{
      flag: "lessThan",
      constraint: num
    }]);
  }
  // String only
  uppercase() {
    return this.cloneWithRules([{
      flag: "stringCasing",
      constraint: "uppercase"
    }]);
  }
  lowercase() {
    return this.cloneWithRules([{
      flag: "stringCasing",
      constraint: "lowercase"
    }]);
  }
  regex(pattern, a, b) {
    const name = typeof a == "string" ? a : a?.name ?? b?.name, invert = typeof a == "string" ? !1 : a?.invert ?? b?.invert, constraint = {
      pattern,
      name,
      invert: invert || !1
    };
    return this.cloneWithRules([{
      flag: "regex",
      constraint
    }]);
  }
  email() {
    return this.cloneWithRules([{
      flag: "email"
    }]);
  }
  uri(opts) {
    const optsScheme = opts?.scheme || ["http", "https"], schemes = Array.isArray(optsScheme) ? optsScheme : [optsScheme];
    if (!schemes.length)
      throw new Error("scheme must have at least 1 scheme specified");
    const constraint = {
      options: {
        scheme: schemes.map((scheme) => {
          if (!(scheme instanceof RegExp) && typeof scheme != "string")
            throw new Error("scheme must be a RegExp or a String");
          return typeof scheme == "string" ? new RegExp(`^${escapeRegex(scheme)}$`) : scheme;
        }),
        allowRelative: opts?.allowRelative || !1,
        relativeOnly: opts?.relativeOnly || !1,
        allowCredentials: opts?.allowCredentials || !1
      }
    };
    return this.cloneWithRules([{
      flag: "uri",
      constraint
    }]);
  }
  // Array only
  unique() {
    return this.cloneWithRules([{
      flag: "unique"
    }]);
  }
  // Objects only
  reference() {
    return this.cloneWithRules([{
      flag: "reference"
    }]);
  }
  fields(rules) {
    if (this._type !== "Object")
      throw new Error("fields() can only be called on an object type");
    const rule = this.cloneWithRules([]);
    return rule._fieldRules = rules, rule;
  }
  assetRequired() {
    const base = getBaseType(this._typeDef);
    let assetType;
    return base && ["image", "file"].includes(base.name) ? assetType = base.name === "image" ? "image" : "file" : assetType = "asset", this.cloneWithRules([{
      flag: "assetRequired",
      constraint: {
        assetType
      }
    }]);
  }
  async validate(value, {
    __internal = {},
    ...context
  }) {
    const {
      customValidationConcurrencyLimiter
    } = __internal, valueIsEmpty = value == null;
    if (valueIsEmpty && this._required === "optional")
      return EMPTY_ARRAY$y;
    const rules = (
      // Run only the _custom_ functions if the rule is not set to required or optional
      this._required === void 0 && valueIsEmpty ? this._rules.filter((curr) => curr.flag === "custom") : this._rules
    ), validators = this._type && typeValidators[this._type] || genericValidators;
    return (await Promise.all(rules.map(async (curr) => {
      if (curr.flag === void 0)
        throw new Error('Invalid rule, did not contain "flag"-property');
      const validator = validators[curr.flag];
      if (!validator) {
        const forType = this._type ? `type "${this._type}"` : "rule without declared type";
        throw new Error(`Validator for flag "${curr.flag}" not found for ${forType}`);
      }
      let specConstraint = "constraint" in curr ? curr.constraint : null;
      if (isFieldRef(specConstraint) && (specConstraint = get(context.parent, specConstraint.path)), curr.flag === "custom" && customValidationConcurrencyLimiter && !specConstraint?.bypassConcurrencyLimit) {
        const customValidator = specConstraint;
        specConstraint = async (...args) => {
          await customValidationConcurrencyLimiter.ready();
          try {
            return await customValidator(...args);
          } finally {
            customValidationConcurrencyLimiter.release();
          }
        };
      }
      const message = isLocalizedMessages(this._message) ? localizeMessage(this._message, context.i18n) : this._message;
      try {
        const result = await validator(specConstraint, value, message, context);
        return convertToValidationMarker(result, this._level, context);
      } catch (err) {
        const errorMessage = `${pathToString(context.path)}: Exception occurred while validating value: ${err.message}`;
        return convertToValidationMarker({
          message: errorMessage
        }, "error", context);
      }
    }))).flat();
  }
}, memoizedWarnOnArraySlug = memoize$1(warnOnArraySlug);
function serializePath(path) {
  return path.reduce((target, part, i) => {
    const isIndex = typeof part == "number", isKey = isKeyedObject(part), add = isIndex || isKey ? "[]" : `${i === 0 ? "" : "."}${part}`;
    return `${target}${add}`;
  }, "");
}
const defaultIsUnique = (slug, context) => {
  const {
    getClient: getClient2,
    document: document2,
    path,
    type
  } = context, schemaOptions = type?.options;
  if (!document2)
    throw new Error("`document` was not provided in validation context.");
  if (!path)
    throw new Error("`path` was not provided in validation context.");
  const disableArrayWarning = schemaOptions?.disableArrayWarning || !1, docType = document2._type, atPath = serializePath(path.concat("current"));
  !disableArrayWarning && atPath.includes("[]") && context.environment === "studio" && memoizedWarnOnArraySlug(serializePath(path));
  const constraints = ["_type == $docType", "!sanity::versionOf($published)", `${atPath} == $slug`].join(" && ");
  return getClient2({
    apiVersion: DEFAULT_STUDIO_CLIENT_OPTIONS.apiVersion
  }).withConfig({
    perspective: "raw"
  }).fetch(`!defined(*[${constraints}][0]._id)`, {
    docType,
    published: getPublishedId(document2._id),
    slug
  }, {
    tag: "validation.slug-is-unique"
  });
};
function warnOnArraySlug(serializedPath) {
  console.warn([`Slug field at path ${serializedPath} is within an array and cannot be automatically checked for uniqueness`, 'If you need to check for uniqueness, provide your own "isUnique" method', "To disable this message, set `disableArrayWarning: true` on the slug `options` field"].join(`
`));
}
const slugValidator = async (value, context) => {
  if (!value)
    return !0;
  const {
    i18n
  } = context;
  if (typeof value != "object" || Array.isArray(value))
    return i18n.t("validation:slug.not-object");
  if (!isSlug(value) || value.current.trim().length === 0)
    return i18n.t("validation:slug.missing-current");
  const isUnique = context?.type?.options?.isUnique || defaultIsUnique, slugContext = {
    ...context,
    parent: context.parent,
    type: context.type,
    defaultIsUnique
  };
  return await isUnique(value.current, slugContext) ? !0 : i18n.t("validation:slug.not-unique", {
    slug: value.current
  });
}, ruleConstraintTypes = {
  array: !0,
  boolean: !0,
  date: !0,
  number: !0,
  object: !0,
  string: !0
}, isRuleConstraint = (typeString2) => typeString2 in ruleConstraintTypes;
function getTypeChain$3(type, visited = /* @__PURE__ */ new Set()) {
  return type ? visited.has(type) ? [] : (visited.add(type), [...type.type ? getTypeChain$3(type.type, visited) : [], type]) : [];
}
function baseRuleReducer(inputRule, type) {
  let baseRule = inputRule;
  isRuleConstraint(type.jsonType) && (baseRule = baseRule.type(type.jsonType));
  const typeOptionsList = (
    // if type.options is truthy
    type?.options && // and type.options is an object (non-null from the previous)
    typeof type.options == "object" && // and if `list` is in options
    "list" in type.options && // then finally access the list
    type.options.list
  );
  return Array.isArray(typeOptionsList) && (baseRule = baseRule.valid(typeOptionsList.map((option) => extractValueFromListOption(option, type)))), type.name === "datetime" || type.name === "date" ? baseRule.type("Date") : type.name === "url" ? baseRule.uri() : type.name === "slug" ? baseRule.custom(slugValidator, {
    bypassConcurrencyLimit: !0
  }) : type.name === "reference" ? baseRule.reference() : type.name === "email" ? baseRule.email() : baseRule;
}
function hasValueField(typeDef) {
  return typeDef ? !("fields" in typeDef) && typeDef.type ? hasValueField(typeDef.type) : !("fields" in typeDef) || !Array.isArray(typeDef.fields) ? !1 : typeDef.fields.some((field) => field.name === "value") : !1;
}
function extractValueFromListOption(option, typeDef) {
  return typeDef.jsonType === "object" && hasValueField(typeDef) || option.value === void 0 ? option : option.value;
}
function normalizeValidationRules(typeDef) {
  if (!typeDef)
    return [];
  const validation2 = typeDef.validation;
  if (Array.isArray(validation2))
    return validation2.flatMap((i) => normalizeValidationRules({
      ...typeDef,
      validation: i
    }));
  if (validation2 && typeof validation2 == "object")
    return [validation2];
  const baseRule = (
    // using an object + Object.values to de-dupe the type chain by type name
    Object.values(getTypeChain$3(typeDef).reduce((acc, type) => (acc[type.name] = type, acc), {})).reduce(baseRuleReducer, new Rule(typeDef))
  );
  return validation2 ? normalizeValidationRules({
    ...typeDef,
    validation: validation2(baseRule)
  }) : [baseRule];
}
function inferFromSchemaType(typeDef) {
  return traverse(typeDef, /* @__PURE__ */ new Set()), typeDef;
}
function traverse(typeDef, visited) {
  if (!visited.has(typeDef)) {
    if (visited.add(typeDef), typeDef.validation = normalizeValidationRules(typeDef), "fields" in typeDef)
      for (const field of typeDef.fields)
        traverse(field.type, visited);
    if ("of" in typeDef)
      for (const candidate of typeDef.of)
        traverse(candidate, visited);
    if (typeDef.annotations)
      for (const annotation of typeDef.annotations)
        traverse(annotation, visited);
  }
}
function inferFromSchema(schema2) {
  return schema2.getLocalTypeNames().forEach((typeName) => {
    const schemaType = schema2.get(typeName);
    schemaType && inferFromSchemaType(schemaType);
  }), schema2;
}
const shouldEscape = typeof window > "u" || typeof document > "u", fallbackLocales = [defaultLocale], getFallbackLocaleSource = memoize$1(function() {
  const i18n = getFallbackI18nInstance();
  return i18n.init(), {
    currentLocale: defaultLocale,
    locales: fallbackLocales,
    loadNamespaces: i18n.loadNamespaces,
    t: i18n.t
  };
});
function getFallbackI18nInstance() {
  const staticResources = {
    [defaultLocale.id]: {}
  }, staticBundles = usEnglishLocale.bundles?.filter(isStaticResourceBundle) || [], namespaces = /* @__PURE__ */ new Set();
  for (const bundle of staticBundles)
    staticResources[defaultLocale.id][bundle.namespace] = bundle.resources, namespaces.add(bundle.namespace);
  return createInstance({
    ns: Array.from(namespaces),
    defaultNS: studioLocaleNamespace,
    initImmediate: !0,
    partialBundledLanguages: !0,
    fallbackLng: defaultLocale.id,
    lng: defaultLocale.id,
    supportedLngs: [defaultLocale.id],
    debug: !1,
    load: "currentOnly",
    resources: staticResources,
    interpolation: {
      // If we're in a browser, assume this is running inside of the studio, eg a React app,
      // and that values returned will be escaped by the framework (eg React) automatically.
      escapeValue: shouldEscape
    }
  });
}
const BUFFER_TIME = 250, MAX_BUFFER_SIZE = 100, MAX_REQUEST_CONCURRENCY = 1;
function createBatchedGetDocumentExists(client) {
  const id$ = new Subject(), limiter = new ConcurrencyLimiter(MAX_REQUEST_CONCURRENCY), existence$ = id$.pipe(bufferTime(BUFFER_TIME, null, MAX_BUFFER_SIZE), map$1((ids) => Array.from(new Set(ids))), mergeMap$1((ids) => from(limiter.ready()).pipe(switchMap$1(() => client.observable.request({
    uri: client.getDataUrl("doc", ids.join(",")),
    json: !0,
    query: {
      excludeContent: "true"
    },
    tag: "documents-availability"
  }).pipe(map$1((availability) => ({
    availability,
    ids
  })))), finalize(limiter.release))), mergeMap$1(({
    availability,
    ids
  }) => ids.map((id2) => {
    const omittedIds = availability.omitted.reduce((acc, next) => (acc[next.id] = next.reason, acc), {});
    return omittedIds[id2] ? omittedIds[id2] === "existence" ? {
      id: id2,
      exists: !1
    } : {
      id: id2,
      exists: !0
    } : {
      id: id2,
      exists: !0
    };
  })), share$1());
  return async function(options) {
    const result = firstValueFrom(existence$.pipe(filter$1(({
      id: id2
    }) => id2 === options.id)));
    id$.next(options.id);
    const {
      exists: exists2
    } = await result;
    return exists2;
  };
}
const requestIdleCallbackShim = function(callback, options) {
  const start = Date.now();
  return window.setTimeout(() => {
    callback({
      didTimeout: !1,
      timeRemaining() {
        return Math.max(0, Date.now() - start);
      }
    });
  }, 0);
}, cancelIdleCallbackShim = function(handle) {
  return window.clearTimeout(handle);
}, win = typeof window > "u" ? void 0 : window, requestIdleCallback = win?.requestIdleCallback || requestIdleCallbackShim, cancelIdleCallback = win?.cancelIdleCallback || cancelIdleCallbackShim, unknownFieldsValidator = (type) => (value) => {
  if (typeof value != "object" || !value) return !0;
  const fieldNames = new Set(type.fields?.map((field) => field.name));
  return Object.keys(value).filter((key) => !key.startsWith("_")).filter((key) => !fieldNames.has(key)).map((unknownField) => ({
    message: `Field '${unknownField}' does not exist on type '${type.name}'`,
    path: [unknownField]
  }));
}, DEFAULT_MAX_FETCH_CONCURRENCY = 25, DEFAULT_MAX_CUSTOM_VALIDATION_CONCURRENCY = 5;
let _limitConcurrency;
const getConcurrencyLimiter = (maxConcurrency) => _limitConcurrency || (_limitConcurrency = createClientConcurrencyLimiter(maxConcurrency), _limitConcurrency), isRecord$2 = (maybeRecord) => typeof maybeRecord == "object" && maybeRecord !== null && !Array.isArray(maybeRecord), isNonNullable$1 = (value) => value != null;
function resolveTypeForArrayItem(item, candidates) {
  if (candidates.length === 1) return candidates[0];
  const itemType = isTypedObject(item) && item._type, primitive = item == null || !itemType && typeString(item).toLowerCase();
  return primitive && primitive !== "object" ? candidates.find((candidate) => candidate.jsonType === primitive) : candidates.find((candidate) => candidate.type?.name === itemType) || candidates.find((candidate) => candidate.name === itemType) || candidates.find((candidate) => candidate.name === "object" && primitive === "object");
}
function validateDocument({
  document: document2,
  workspace,
  environment = "studio",
  maxFetchConcurrency,
  ...options
}) {
  const getClient2 = options.getClient || workspace.getClient, limitConcurrency = getConcurrencyLimiter(maxFetchConcurrency ?? DEFAULT_MAX_FETCH_CONCURRENCY);
  return lastValueFrom(validateDocumentObservable({
    document: document2,
    getClient: (clientOptions2) => limitConcurrency(getClient2(clientOptions2)),
    i18n: workspace.i18n,
    schema: workspace.schema,
    getDocumentExists: options.getDocumentExists || createBatchedGetDocumentExists(getClient2({
      apiVersion: "v2021-03-25"
    })),
    environment
  }));
}
const customValidationConcurrencyLimiters = /* @__PURE__ */ new WeakMap();
function validateDocumentObservable({
  document: document2,
  getClient: getClient2,
  i18n = getFallbackLocaleSource(),
  schema: schema2,
  getDocumentExists,
  environment,
  maxCustomValidationConcurrency
}) {
  if (typeof document2?._type != "string")
    throw new Error("Tried to validated a value without a '_type'");
  const documentType = schema2.get(document2._type);
  if (!documentType)
    return environment === "studio" ? (console.warn('Schema type for object type "%s" not found, skipping validation', document2._type), of([])) : of([{
      level: "warning",
      message: `Could not find schema type for type '${document2._type}', skipping validation`,
      path: []
    }]);
  let customValidationConcurrencyLimiter = customValidationConcurrencyLimiters.get(schema2);
  customValidationConcurrencyLimiter || (customValidationConcurrencyLimiter = new ConcurrencyLimiter(maxCustomValidationConcurrency ?? DEFAULT_MAX_CUSTOM_VALIDATION_CONCURRENCY), customValidationConcurrencyLimiters.set(schema2, customValidationConcurrencyLimiter));
  const validationOptions = {
    getClient: getClient2,
    schema: schema2,
    parent: void 0,
    value: document2,
    path: [],
    document: document2,
    type: documentType,
    i18n,
    getDocumentExists,
    environment,
    customValidationConcurrencyLimiter
  };
  return from(i18n.loadNamespaces(["validation"])).pipe(switchMap(() => validateItemObservable(validationOptions)), catchError((err) => {
    console.error(err);
    const message = err?.message || "Unknown error";
    return of([{
      level: "error",
      message,
      item: {
        message
      },
      path: []
    }]);
  }));
}
function validateItemObservable({
  value,
  type,
  path = [],
  parent,
  customValidationConcurrencyLimiter,
  environment,
  ...restOfContext
}) {
  const addUnknownFieldsValidator = (rule) => (
    // if the schema type is an object type
    type?.jsonType === "object" && // and if somewhere in it's type chain, it inherits from object or document
    getTypeChain$3(type).find((t) => ["object", "document", "file", "image"].includes(t.name)) && // and the environment is not the studio
    environment !== "studio" ? rule.custom(unknownFieldsValidator(type), {
      bypassConcurrencyLimit: !0
    }).warning() : rule
  ), rules = normalizeValidationRules(type), selfChecks = rules.map(addUnknownFieldsValidator).map((rule) => defer(() => rule.validate(value, {
    ...restOfContext,
    environment,
    parent,
    path,
    type,
    __internal: {
      customValidationConcurrencyLimiter
    }
  })));
  let nestedChecks = [];
  const selfIsRequired = rules.some((rule) => rule.isRequired());
  if (
    // run nested validation for objects
    type?.jsonType === "object" && // if the value is truthy
    (value || // or
    // (the value is null or undefined) and the top-level value is required
    value == null && selfIsRequired)
  ) {
    const fieldTypes = type.fields.reduce((acc, field) => (acc[field.name] = field.type, acc), {});
    nestedChecks = nestedChecks.concat(rules.map((rule) => rule._fieldRules).filter(isNonNullable$1).flatMap((fieldResults) => Object.entries(fieldResults)).flatMap(([name, validation2]) => {
      const fieldType = fieldTypes[name];
      return normalizeValidationRules({
        ...fieldType,
        validation: validation2
      }).map(addUnknownFieldsValidator).map((subRule) => {
        const nestedValue = isRecord$2(value) ? value[name] : void 0;
        return defer(() => subRule.validate(nestedValue, {
          ...restOfContext,
          parent: value,
          path: path.concat(name),
          type: fieldType,
          environment,
          __internal: {
            customValidationConcurrencyLimiter
          }
        }));
      });
    })), nestedChecks = nestedChecks.concat(type.fields.map((field) => validateItemObservable({
      ...restOfContext,
      parent: value,
      value: isRecord$2(value) ? value[field.name] : void 0,
      path: path.concat(field.name),
      type: field.type,
      environment,
      customValidationConcurrencyLimiter
    })));
  }
  return type?.jsonType === "array" && Array.isArray(value) && (nestedChecks = nestedChecks.concat(value.map((item, index) => validateItemObservable({
    ...restOfContext,
    parent: value,
    value: item,
    path: path.concat(isKeyedObject(item) ? {
      _key: item._key
    } : index),
    type: resolveTypeForArrayItem(item, type.of),
    environment,
    customValidationConcurrencyLimiter
  })))), defer(() => merge([...selfChecks, ...nestedChecks])).pipe(mergeMap((validateNode) => concat(idle(), validateNode), 40), mergeAll(), toArray$1(), map(flatten$1), map((results) => rules.some((rule) => rule._fieldRules) ? uniqBy(results, (rule) => JSON.stringify(rule)) : results));
}
function idle(timeout2) {
  return new Observable((observer) => {
    const handle = requestIdleCallback(() => {
      observer.complete();
    }, void 0);
    return () => cancelIdleCallback(handle);
  });
}
const INITIAL_VALIDATION_STATUS = {
  isValidating: !0,
  validation: []
};
function findReferenceIds(obj) {
  return reduce(obj, (acc, node) => (isReference$1(node) && !isGlobalDocumentReference(node) && acc.add(node._ref), acc), /* @__PURE__ */ new Set());
}
const EMPTY_VALIDATION = [], listenDocumentExists = (observeDocumentAvailability, id2, versionId) => observeDocumentAvailability(id2, {
  version: versionId
}).pipe(map(({
  published,
  version
}) => !version?.available && version?.reason === "VERSION_DELETED" ? !1 : published.available || version?.available || !1)), REF_UPDATE_DELAY = 1e3;
function shareLatestWithRefCount$1() {
  return shareReplay({
    bufferSize: 1,
    refCount: !0
  });
}
function validateDocumentWithReferences(ctx, document$) {
  const referenceIds$ = document$.pipe(map((document2) => findReferenceIds(document2)), mergeMap((ids) => from(ids))), versionId$ = document$.pipe(map((doc) => ({
    versionId: getVersionFromId(doc?._id || "")
  })), distinctUntilChanged()), referenceExistence$ = combineLatest([versionId$, referenceIds$]).pipe(groupBy$1(([_, id2]) => id2, {
    duration: () => timer(1e3 * 60 * 30)
  }), mergeMap((id$) => id$.pipe(distinct(), mergeMap(([{
    versionId
  }, id2]) => listenDocumentExists(ctx.observeDocumentPairAvailability, id2, versionId).pipe(map(
    // eslint-disable-next-line max-nested-callbacks
    (result) => [id2, result]
  ))))), scan((acc, [id2, result]) => acc[id2] === result ? acc : {
    ...acc,
    [id2]: result
  }, {}), distinctUntilChanged(shallowEquals), shareLatestWithRefCount$1()), getDocumentExists = ({
    id: id2
  }) => lastValueFrom(referenceExistence$.pipe(
    // If the id is not present as key in the `referenceExistence` map it means it's existence status
    // isn't yet loaded, so we want to wait until it is
    first((referenceExistence) => id2 in referenceExistence),
    map((referenceExistence) => referenceExistence[id2])
  )), referenceDocumentUpdates$ = referenceExistence$.pipe(
    // we'll skip the first emission since the document already gets an initial validation pass
    // we're only interested in updates in referenced documents after that
    skip(1),
    throttleTime(REF_UPDATE_DELAY, asyncScheduler, {
      leading: !0,
      trailing: !0
    })
  );
  return combineLatest([document$, concat(of(null), referenceDocumentUpdates$)]).pipe(map(([document2]) => document2), exhaustMapWithTrailing((document2) => defer(() => document2?._type ? concat(of({
    isValidating: !0,
    revision: document2._rev
  }), validateDocumentObservable({
    document: document2,
    getClient: ctx.getClient,
    getDocumentExists,
    i18n: ctx.i18n,
    schema: ctx.schema,
    environment: "studio"
  }).pipe(map((validationMarkers) => ({
    validation: validationMarkers,
    isValidating: !1
  })))) : of({
    validation: EMPTY_VALIDATION,
    isValidating: !1
  }))), scan((acc, next) => ({
    ...acc,
    ...next
  }), INITIAL_VALIDATION_STATUS), shareLatestWithRefCount$1());
}
const DOC_UPDATE_DELAY = 200;
function shareLatestWithRefCount() {
  return shareReplay({
    bufferSize: 1,
    refCount: !0
  });
}
const validation = memoize((ctx, {
  draftId,
  publishedId,
  versionId
}, typeName) => {
  const document$ = editState(ctx, {
    draftId,
    publishedId,
    versionId
  }, typeName).pipe(map(({
    version,
    draft,
    published
  }) => version || draft || published), throttleTime(DOC_UPDATE_DELAY, asyncScheduler, {
    trailing: !0
  }), distinctUntilChanged((prev, next) => prev?._rev === next?._rev ? !0 : shallowEquals(omit(prev, "_rev", "_updatedAt"), omit(next, "_rev", "_updatedAt"))), shareLatestWithRefCount());
  return validateDocumentWithReferences(ctx, document$);
}, (ctx, idPair, typeName) => memoizeKeyGen(ctx.client, idPair, typeName)), documentEvents = memoize((client, idPair, typeName, serverActionsEnabled, pairListenerOptions) => memoizedPair(client, idPair, typeName, serverActionsEnabled, pairListenerOptions).pipe(switchMap(({
  draft,
  published
}) => merge(draft.events, published.events))), memoizeKeyGen);
function createOperationGuard(opName) {
  return {
    disabled: "NOT_READY",
    execute: () => {
      throw new Error(`Called ${opName} before it was ready.`);
    }
  };
}
const GUARDED = {
  commit: createOperationGuard("commit"),
  delete: createOperationGuard("delete"),
  del: createOperationGuard("del"),
  publish: createOperationGuard("publish"),
  patch: createOperationGuard("patch"),
  discardChanges: createOperationGuard("discardChanges"),
  unpublish: createOperationGuard("unpublish"),
  duplicate: createOperationGuard("duplicate"),
  restore: createOperationGuard("restore")
}, createEmitter = (operationName, idPair, typeName) => (...executeArgs) => emitOperation(operationName, idPair, typeName, executeArgs);
function wrap(opName, op, operationArgs2) {
  return {
    disabled: op.disabled(operationArgs2),
    execute: createEmitter(opName, operationArgs2.idPair, operationArgs2.typeName)
  };
}
function createOperationsAPI(args) {
  const operationsAPI = {
    commit: wrap("commit", commit, args),
    delete: wrap("delete", del$1, args),
    del: wrap("delete", del$1, args),
    publish: wrap("publish", publish$1, args),
    patch: wrap("patch", patch$1, args),
    discardChanges: wrap("discardChanges", discardChanges$1, args),
    unpublish: wrap("unpublish", unpublish$1, args),
    duplicate: wrap("duplicate", duplicate, args),
    restore: wrap("restore", restore$2, args)
  };
  return args.serverActionsEnabled ? {
    ...operationsAPI,
    delete: wrap("delete", del, args),
    del: wrap("delete", del, args),
    discardChanges: wrap("discardChanges", discardChanges, args),
    patch: wrap("patch", patch, args),
    publish: wrap("publish", publish, args),
    unpublish: wrap("unpublish", unpublish, args),
    restore: wrap("restore", restore$1, args)
  } : operationsAPI;
}
const editOperations = memoize((ctx, idPair, typeName) => {
  const operationEvents$ = operationEvents(ctx), operations$ = operationArgs(ctx, idPair, typeName).pipe(map(createOperationsAPI));
  return concat(of(GUARDED), merge(operationEvents$.pipe(mergeMap(() => EMPTY$6)), operations$)).pipe(shareReplay({
    refCount: !0,
    bufferSize: 1
  }));
}, (ctx, idPair, typeName) => memoizeKeyGen(ctx.client, idPair, typeName));
function postTask(callback, options = {}) {
  return "scheduler" in window && typeof window.scheduler?.postTask == "function" ? window.scheduler.postTask(callback, options) : callback();
}
function isRecord$1(value) {
  return isPlainObject$1(value);
}
function deepAssign(target, source) {
  const result = {
    ...target,
    ...source
  };
  return Object.keys(result).forEach((key) => {
    const sourceVal = source[key], targetVal = target[key];
    isRecord$1(sourceVal) && isRecord$1(targetVal) && (result[key] = deepAssign(targetVal, sourceVal));
  }), result;
}
const ALLOWED_REF_PROPS = ["_dataset", "_projectId", "_strengthenOnPublish", "_key", "_ref", "_type", "_weak"], REQUIRED_TEMPLATE_PROPS = ["id", "title", "schemaType", "value"];
function templateId(template2, i) {
  return quote(template2.id || template2.title) || typeof i == "number" && `at index ${i}` || "";
}
function quote(str) {
  return str && str.length > 0 ? `"${str}"` : str;
}
function validateTemplates(schema2, templates) {
  const idMap = /* @__PURE__ */ new Map();
  return templates.forEach((template2, i) => {
    const id2 = templateId(template2, i);
    if (typeof template2.values < "u" && !template2.value)
      throw new Error(`Template ${id2} is missing "value" property, but contained "values". Typo?`);
    const missing = REQUIRED_TEMPLATE_PROPS.filter((prop) => !template2[prop]);
    if (missing.length > 0)
      throw new Error(`Template ${id2} is missing required properties: ${missing.join(", ")}`);
    if (typeof template2.value != "function" && !isRecord$1(template2.value))
      throw new Error(`Template ${id2} has an invalid "value" property; should be a function or an object`);
    if (typeof template2.parameters < "u")
      if (Array.isArray(template2.parameters))
        template2.parameters.forEach((param, j) => validateParameter(schema2, param, template2, j));
      else
        throw new Error(`Template ${id2} has an invalid "parameters" property; must be an array`);
    if (idMap.has(template2.id)) {
      const dupeIndex = idMap.get(template2.id), dupe = `${quote(templates[dupeIndex].title)} at index ${dupeIndex}`;
      throw new Error(`Template "${template2.title}" at index ${i} has the same ID ("${template2.id}") as template ${dupe}`);
    }
    idMap.set(template2.id, i);
  }), templates;
}
function validateInitialObjectValue(value, template2) {
  const contextError = (msg) => `Template "${template2.id}" initial value: ${msg}`;
  if (!isRecord$1(value))
    throw new Error(contextError("resolved to a non-object"));
  if (value._type && template2.schemaType !== value._type)
    throw new Error(contextError(`includes "_type"-property (${value._type}) that does not match template (${template2.schemaType})`));
  try {
    return validateValue(value);
  } catch (err) {
    throw err.message = contextError(err.message), err;
  }
}
function validateValue(value, path = [], parentIsArray = !1) {
  if (Array.isArray(value))
    return value.map((item, i) => {
      if (Array.isArray(item))
        throw new Error(`multidimensional arrays are not supported (at path "${toString(path)}")`);
      return validateValue(item, path.concat(i), !0);
    });
  if (!isRecord$1(value))
    return value;
  const initial2 = parentIsArray && !value._key ? {
    _key: randomKey$1()
  } : {};
  return path.length > 0 && !value._type && value._ref && (initial2._type = "reference"), value._ref && validateReference(value, path), Object.keys(value).reduce((acc, key) => (acc[key] = validateValue(value[key], path.concat([key])), acc), initial2);
}
function validateParameter(schema2, parameter, template2, index) {
  if (!parameter.name)
    throw new Error(`Template ${template2.id} has a parameter at index ${index} that is missing its "name"-property`);
  if (parameter.name === "template")
    throw new Error(`Template parameters cannot be named "template", see parameter #${index} for template ${template2.id}`);
  if (!schema2.get(parameter.type))
    throw new Error(`Template parameter "${parameter.name}" has an invalid/unknown type: "${parameter.type}"`);
}
function validateReference(value, path = []) {
  if (!value._type && value.type)
    throw new Error(`Reference is missing "_type", but has a "type" property at path "${toString(path)}"`);
  const disallowed = Object.keys(value).filter((key) => !ALLOWED_REF_PROPS.includes(key));
  if (disallowed.length > 0) {
    const plural = disallowed.length > 1 ? "properties" : "property";
    throw new Error(`Disallowed ${plural} found in reference: ${disallowed.map(quote).join(", ")} at path "${toString(path)}"`);
  }
}
function isBuilder(template2) {
  return isRecord$1(template2) && typeof template2.serialize == "function";
}
const cache$1 = /* @__PURE__ */ new WeakMap();
async function resolveValue(initialValueOpt, params, context, options) {
  const useCache = options?.useCache;
  if (typeof initialValueOpt == "function") {
    const cached = cache$1.get(initialValueOpt), key = JSON.stringify([params, context.projectId, context.dataset, context.currentUser?.id]);
    if (useCache && cached?.[key])
      return cached[key];
    const value = initialValueOpt(params, context);
    return useCache && cache$1.set(initialValueOpt, {
      ...cached,
      [key]: value
    }), value;
  }
  return initialValueOpt;
}
async function resolveInitialValue(schema2, template2, params = {}, context, options) {
  if (isBuilder(template2))
    return resolveInitialValue(schema2, template2.serialize(), params, context, options);
  const {
    id: id2,
    schemaType: schemaTypeName,
    value
  } = template2;
  if (!value)
    throw new Error(`Template "${id2}" has invalid "value" property`);
  let resolvedValue = await resolveValue(value, params, context, options);
  if (!isRecord$1(resolvedValue))
    throw new Error(`Template "${id2}" has invalid "value" property - must be a plain object or a resolver function returning a plain object`);
  isRecord$1(resolvedValue) && !Object.keys(resolvedValue).length && (resolvedValue = {
    _type: schemaTypeName
  }), resolvedValue = validateInitialObjectValue(resolvedValue, template2);
  const schemaType = schema2.get(schemaTypeName);
  if (!schemaType)
    throw new Error(`Could not find schema type with name "${schemaTypeName}".`);
  const newValue = deepAssign(await resolveInitialValueForType(schemaType, params, DEFAULT_MAX_RECURSION_DEPTH, context, options) || {}, resolvedValue);
  return validateInitialObjectValue(newValue, template2);
}
function getItemType$1(arrayType, item) {
  const itemTypeName = resolveTypeName$2(item);
  return itemTypeName === "object" && arrayType.of.length === 1 ? arrayType.of[0] : arrayType.of.find((memberType) => memberType.name === itemTypeName);
}
const DEFAULT_MAX_RECURSION_DEPTH = 10, memoizeResolveInitialValueForType = (fn) => {
  const resolveInitialValueForTypeCache = /* @__PURE__ */ new WeakMap(), stableStringify = (obj) => obj !== null && typeof obj == "object" ? Array.isArray(obj) ? `[${obj.map(stableStringify).join(",")}]` : `{${Object.keys(obj).sort().map((key) => `${JSON.stringify(key)}:${stableStringify(obj[key])}`).join(",")}}` : JSON.stringify(obj), hashParameters = (params, context) => stableStringify({
    params,
    context: {
      schemaName: context.schema.name,
      projectId: context.projectId,
      dataset: context.dataset,
      currentUser: context.currentUser?.id
    }
  });
  return async function(type, params, maxDepth, context, options) {
    if (!options?.useCache) return fn(type, params, maxDepth, context, options);
    let typeCache = resolveInitialValueForTypeCache.get(type);
    typeCache || (typeCache = /* @__PURE__ */ new Map(), resolveInitialValueForTypeCache.set(type, typeCache));
    const hash2 = hashParameters(params, context), cachedResult = typeCache.get(hash2);
    if (cachedResult) return cachedResult;
    const result = await fn(type, params, maxDepth, context, options);
    return typeCache.has(hash2) || typeCache.set(hash2, result), result;
  };
}, resolveInitialValueForType = memoizeResolveInitialValueForType((type, params, maxDepth = DEFAULT_MAX_RECURSION_DEPTH, context, options) => maxDepth <= 0 ? Promise.resolve(void 0) : isObjectSchemaType(type) ? postTask(() => resolveInitialObjectValue(type, params, maxDepth, context, options)) : isArraySchemaType(type) ? postTask(() => resolveInitialArrayValue(type, params, maxDepth, context, options)) : resolveValue(type.initialValue, params, context, options));
async function resolveInitialArrayValue(type, params, maxDepth, context, options) {
  const initialArray = await resolveValue(type.initialValue, void 0, context, options);
  if (Array.isArray(initialArray))
    return Promise.all(initialArray.map(async (initialItem) => {
      const itemType = getItemType$1(type, initialItem);
      return isObjectSchemaType(itemType) ? {
        ...initialItem,
        ...await resolveInitialValueForType(itemType, params, maxDepth - 1, context, options),
        _key: randomKey$1()
      } : initialItem;
    }));
}
async function resolveInitialObjectValue(type, params, maxDepth, context, options) {
  const initialObject = {
    ...await resolveValue(type.initialValue, params, context, options) || {}
  }, fieldValues = {};
  await Promise.all(type.fields.map(async (field) => {
    const initialFieldValue = await resolveInitialValueForType(field.type, params, maxDepth - 1, context, options);
    initialFieldValue != null && (fieldValues[field.name] = initialFieldValue);
  }));
  const merged = deepAssign(fieldValues, initialObject);
  if (!isDeepEmpty(merged))
    return type.name !== "object" && (merged._type = type.name), merged;
}
function maybeSerialize(template2) {
  return isBuilder(template2) ? template2.serialize() : template2;
}
function isNonNullable(t) {
  return !!t;
}
function prepareTemplates(schema2, initialValueTemplates) {
  const serialized = initialValueTemplates.map(maybeSerialize);
  return validateTemplates(schema2, serialized);
}
function defaultTemplateForType(schemaType) {
  return {
    id: schemaType.name,
    schemaType: schemaType.name,
    title: schemaType.title || schemaType.name,
    icon: schemaType.icon,
    value: schemaType.initialValue || {
      _type: schemaType.name
    }
  };
}
function defaultTemplatesForSchema(schema2) {
  const schemaTypes = schema2.getTypeNames().filter((typeName) => !/^sanity\./.test(typeName)).map((typeName) => schema2.get(typeName)).filter(isNonNullable).filter((schemaType) => schemaType.type?.name === "document");
  return prepareTemplates(schema2, schemaTypes.map((schemaType) => defaultTemplateForType(schemaType)));
}
const LOADING_MSG = {
  type: "loading"
};
function getInitialValueStream(schema2, initialValueTemplates, documentPreviewStore, opts, context) {
  const draft$ = documentPreviewStore.observePaths({
    _type: "reference",
    _ref: getDraftId(opts.documentId)
  }, ["_type"]), published$ = documentPreviewStore.observePaths({
    _type: "reference",
    _ref: getPublishedId(opts.documentId)
  }, ["_type"]);
  return merge(draft$.pipe(map((draft) => ({
    draft
  }))), published$.pipe(map((published) => ({
    published
  })))).pipe(
    scan((prev, res) => ({
      ...prev,
      ...res
    }), {}),
    // Wait until we know the state of both draft and published
    filter((res) => "draft" in res && "published" in res),
    map((res) => res.draft || res.published),
    // Only update if we didn't previously have a document but we now do
    distinctUntilChanged((prev, next) => !!prev != !!next),
    // Prevent rapid re-resolving when transitioning between different templates
    debounceTime(25)
  ).pipe(switchMap((document2) => {
    if (document2)
      return of({
        type: "success",
        value: null
      });
    if (!opts.templateName)
      return of({
        isResolving: !1,
        initialValue: void 0,
        type: "success"
      });
    const template2 = initialValueTemplates.find((t) => t.id === opts.templateName);
    if (!template2)
      return console.warn('Template "%s" not defined, using empty initial value', opts.templateName), of({
        isResolving: !1,
        initialValue: void 0,
        type: "success"
      });
    const initialValueWithParams$ = from(resolveInitialValue(schema2, template2, opts.templateParams, context)).pipe(map((initialValue) => ({
      isResolving: !1,
      initialValue
    }))).pipe(catchError((resolveError) => (console.group("Failed to resolve initial value"), console.error(resolveError), console.error("Template ID: %s", opts.templateName), console.error("Parameters: %o", opts.templateParams), console.groupEnd(), of({
      type: "error",
      error: resolveError
    }))));
    return merge(of({
      isResolving: !0
    }), initialValueWithParams$).pipe(switchMap(({
      isResolving,
      initialValue,
      resolveError
    }) => resolveError ? of({
      type: "error",
      message: "Failed to resolve initial value"
    }) : isResolving ? of(LOADING_MSG) : of({
      type: "success",
      value: initialValue
    })));
  }), startWith(LOADING_MSG), distinctUntilChanged());
}
const fetch$1 = (client, query, params, options) => defer(() => client.observable.fetch(query, params, {
  tag: options.tag,
  filterResponse: !0,
  perspective: options.perspective
})), listen = (client, query, params, options) => defer(() => client.listen(query, params, {
  events: ["welcome", "mutation", "reconnect"],
  includeResult: !1,
  visibility: "query",
  includeAllVersions: !0,
  tag: options.tag
}));
function isWelcomeEvent(event) {
  return event.type === "welcome";
}
function listenQuery(client, query, params = {}, options = {}) {
  const fetchQuery = typeof query == "string" ? query : query.fetch, listenerQuery = typeof query == "string" ? query : query.listen, events$ = listen(client, listenerQuery, params, options).pipe(mergeMap((ev, i) => i === 0 && !isWelcomeEvent(ev) ? throwError(() => new Error(ev.type === "reconnect" ? "Could not establish EventSource connection" : `Received unexpected type of first event "${ev.type}"`)) : of(ev)), share()), [welcome$, mutationAndReconnect$] = partition$1(events$, isWelcomeEvent), isRelevantEvent = (event) => !options.transitions || event.type !== "mutation" ? !0 : options.transitions.includes(event.transition), doFetch = () => fetch$1(client, fetchQuery, params, options);
  return merge(welcome$.pipe(take(1)), mutationAndReconnect$.pipe(filter(isRelevantEvent), throttleTime(options.throttleTime || 1e3, asyncScheduler, {
    leading: !0,
    trailing: !0
  }))).pipe(exhaustMapWithTrailing((event) => event.type === "mutation" && event.visibility !== "query" ? timer(1200).pipe(mergeMap(doFetch)) : doFetch()));
}
function resolveTypeForDocument(client, id2, specifiedType = "*") {
  return specifiedType && specifiedType !== "*" ? of(specifiedType) : client.observable.fetch("*[sanity::versionOf($publishedId)][0]._type", {
    publishedId: getPublishedId(id2)
  }, {
    tag: "document.resolve-type"
  });
}
function getIdPairFromPublished(publishedId, version) {
  if (version === "published" || version === "drafts")
    throw new Error('Version Id cannot be "published" or "drafts"');
  if (isVersionId(publishedId))
    throw new Error("editOpsOf does not expect a version id.");
  if (isDraftId(publishedId))
    throw new Error("editOpsOf does not expect a draft id.");
  return getIdPair(publishedId, {
    version
  });
}
function createDocumentStore({
  getClient: getClient2,
  documentPreviewStore,
  historyStore,
  initialValueTemplates,
  schema: schema2,
  i18n,
  serverActionsEnabled,
  extraOptions = {}
}) {
  const observeDocumentPairAvailability = documentPreviewStore.unstable_observeDocumentPairAvailability, client = getClient2(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    onReportLatency,
    onSyncErrorRecovery
  } = extraOptions, ctx = {
    client,
    getClient: getClient2,
    observeDocumentPairAvailability,
    historyStore,
    schema: schema2,
    i18n,
    serverActionsEnabled,
    extraOptions
  };
  return {
    // Public API
    checkoutPair(idPair) {
      return checkoutPair(client, idPair, serverActionsEnabled, {
        onSyncErrorRecovery,
        onReportLatency
      });
    },
    initialValue(opts, context) {
      return getInitialValueStream(schema2, initialValueTemplates, documentPreviewStore, opts, context);
    },
    listenQuery(query, params, listenQueryOptions) {
      return listenQuery(client, query, params, listenQueryOptions);
    },
    resolveTypeForDocument(id2, specifiedType) {
      return resolveTypeForDocument(client, id2, specifiedType);
    },
    pair: {
      consistencyStatus(publishedId, type, version) {
        return consistencyStatus(ctx.client, getIdPairFromPublished(publishedId, version), type, serverActionsEnabled, extraOptions);
      },
      documentEvents(publishedId, type, version) {
        return documentEvents(ctx.client, getIdPairFromPublished(publishedId, version), type, serverActionsEnabled, extraOptions);
      },
      editOperations(publishedId, type, version) {
        return editOperations(ctx, getIdPairFromPublished(publishedId, version), type);
      },
      editState(publishedId, type, version) {
        const idPair = getIdPairFromPublished(publishedId, version);
        return editState(ctx, idPair, type);
      },
      operationEvents(publishedId, type) {
        return operationEvents({
          client,
          historyStore,
          schema: schema2,
          serverActionsEnabled,
          extraOptions
        }).pipe(filter((result) => result.args.idPair.publishedId === publishedId && result.args.typeName === type), map((result) => {
          const {
            operationName,
            idPair: documentIds
          } = result.args;
          return result.type === "success" ? {
            type: "success",
            op: operationName,
            id: documentIds.publishedId
          } : {
            type: "error",
            op: operationName,
            id: documentIds.publishedId,
            error: result.error
          };
        }));
      },
      validation(publishedId, type, version) {
        const idPair = getIdPairFromPublished(publishedId, version);
        return validation(ctx, idPair, type);
      }
    }
  };
}
const LOADING_STATE = {
  isLoaded: !1,
  documentType: void 0
};
function useDocumentType(documentId, t0) {
  const $ = c(14), specifiedType = t0 === void 0 ? "*" : t0, documentStore = useDocumentStore();
  let t1;
  $[0] !== documentId ? (t1 = getPublishedId(documentId), $[0] = documentId, $[1] = t1) : t1 = $[1];
  const publishedId = t1, isResolved = !!(specifiedType && specifiedType !== "*");
  let t2, t3;
  $[2] !== specifiedType ? (t3 = {
    documentType: specifiedType,
    isLoaded: !0
  }, $[2] = specifiedType, $[3] = t3) : t3 = $[3], t2 = t3;
  const SYNC_RESOLVED_STATE = t2, [resolvedState, setDocumentType] = useState(isResolved ? SYNC_RESOLVED_STATE : LOADING_STATE);
  let t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setDocumentType(LOADING_STATE), $[4] = t4) : t4 = $[4];
  let t5;
  $[5] !== publishedId || $[6] !== specifiedType ? (t5 = [publishedId, specifiedType], $[5] = publishedId, $[6] = specifiedType, $[7] = t5) : t5 = $[7], useEffect(t4, t5);
  let t6, t7;
  return $[8] !== documentStore || $[9] !== isResolved || $[10] !== publishedId || $[11] !== specifiedType ? (t6 = () => {
    if (isResolved)
      return;
    const sub2 = documentStore.resolveTypeForDocument(publishedId, specifiedType).subscribe((documentType) => setDocumentType({
      documentType,
      isLoaded: !0
    }));
    return () => sub2.unsubscribe();
  }, t7 = [documentStore, publishedId, specifiedType, isResolved], $[8] = documentStore, $[9] = isResolved, $[10] = publishedId, $[11] = specifiedType, $[12] = t6, $[13] = t7) : (t6 = $[12], t7 = $[13]), useEffect(t6, t7), isResolved ? SYNC_RESOLVED_STATE : resolvedState;
}
function useDocumentValues(documentId, paths) {
  const $ = c(4), documentPreviewStore = useDocumentPreviewStore();
  let t0, t1;
  return $[0] !== documentId || $[1] !== documentPreviewStore || $[2] !== paths ? (t1 = documentId ? documentPreviewStore.observePaths({
    _type: "reference",
    _ref: documentId
  }, paths) : of(void 0), $[0] = documentId, $[1] = documentPreviewStore, $[2] = paths, $[3] = t1) : t1 = $[3], t0 = t1, useLoadable(t0);
}
const useUserViaUserStore = createHookFromObservableFactory(([userStore, userId]) => from(userStore.getUser(userId).catch((err) => (console.error(err), null))));
function useUser(userId) {
  const $ = c(3), userStore = useUserStore();
  let t0, t1;
  return $[0] !== userId || $[1] !== userStore ? (t1 = [userStore, userId], $[0] = userId, $[1] = userStore, $[2] = t1) : t1 = $[2], t0 = t1, useUserViaUserStore(t0);
}
function useCurrentUser() {
  const {
    currentUser
  } = useSource();
  return currentUser;
}
function useInitialValue(props2) {
  const $ = c(17), {
    documentId,
    documentType,
    templateName,
    templateParams: templateParamsRaw,
    version
  } = props2, templateParams = useUnique(templateParamsRaw), documentStore = useDocumentStore(), context = useInitialValueResolverContext();
  let t0, t1;
  $[0] !== documentId || $[1] !== version ? (t1 = version ? getVersionId(documentId, version) : documentId, $[0] = documentId, $[1] = version, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== documentType || $[4] !== t1 ? (t2 = {
    _id: t1,
    _type: documentType
  }, $[3] = documentType, $[4] = t1, $[5] = t2) : t2 = $[5], t0 = t2;
  const defaultValue2 = t0;
  let t3;
  $[6] !== defaultValue2 ? (t3 = {
    loading: !1,
    error: null,
    value: defaultValue2
  }, $[6] = defaultValue2, $[7] = t3) : t3 = $[7];
  const [state, setState] = useState(t3);
  let t4, t5;
  return $[8] !== context || $[9] !== defaultValue2 || $[10] !== documentId || $[11] !== documentStore || $[12] !== documentType || $[13] !== templateName || $[14] !== templateParams ? (t4 = () => {
    const initialValueOptions = {
      documentId,
      documentType,
      templateName,
      templateParams
    }, sub2 = documentStore.initialValue(initialValueOptions, context).subscribe((msg) => {
      msg.type === "loading" && setState({
        loading: !0,
        error: null,
        value: defaultValue2
      }), msg.type === "success" && setState({
        loading: !1,
        error: null,
        value: msg.value ? {
          ...defaultValue2,
          ...msg.value
        } : defaultValue2
      }), msg.type === "error" && setState({
        loading: !1,
        error: msg.error,
        value: defaultValue2
      });
    });
    return setState({
      loading: !0,
      error: null,
      value: defaultValue2
    }), () => sub2.unsubscribe();
  }, t5 = [defaultValue2, documentId, documentStore, documentType, templateName, templateParams, context], $[8] = context, $[9] = defaultValue2, $[10] = documentId, $[11] = documentStore, $[12] = documentType, $[13] = templateName, $[14] = templateParams, $[15] = t4, $[16] = t5) : (t4 = $[15], t5 = $[16]), useEffect(t4, t5), state;
}
function useInitialValueResolverContext() {
  const $ = c(6), source = useSource(), schema2 = useSchema(), currentUser = useCurrentUser(), projectId = useProjectId$1(), dataset = useDataset(), getClient2 = source.getClient;
  let t0, t1;
  return $[0] !== currentUser || $[1] !== dataset || $[2] !== getClient2 || $[3] !== projectId || $[4] !== schema2 ? (t1 = {
    projectId,
    dataset,
    getClient: getClient2,
    schema: schema2,
    currentUser
  }, $[0] = currentUser, $[1] = dataset, $[2] = getClient2, $[3] = projectId, $[4] = schema2, $[5] = t1) : t1 = $[5], t0 = t1, t0;
}
function useResolveInitialValueForType() {
  const $ = c(2), initialValueContext = useInitialValueResolverContext();
  let t0;
  return $[0] !== initialValueContext ? (t0 = (type, params) => resolveInitialValueForType(type, params, DEFAULT_MAX_RECURSION_DEPTH, initialValueContext), $[0] = initialValueContext, $[1] = t0) : t0 = $[1], t0;
}
function getSchemaType(schema2, typeName) {
  const type = schema2.get(typeName);
  if (!type)
    throw new Error(`No such schema type: ${typeName}`);
  return type;
}
function getPairPermissions({
  grantsStore,
  permission,
  draft,
  version,
  published,
  liveEdit
}) {
  const effectiveVersion = version || draft || published, effectiveVersionType = (
    // eslint-disable-next-line no-nested-ternary
    effectiveVersion === version ? version : effectiveVersion === draft ? "draft" : "published"
  ), {
    checkDocumentPermission
  } = grantsStore;
  switch (permission) {
    case "delete":
      return liveEdit ? [["delete published document (live-edit)", checkDocumentPermission("update", published)]] : [["delete draft document", checkDocumentPermission("update", draft)], ["delete published document", checkDocumentPermission("update", published)]];
    case "discardDraft":
      return liveEdit ? [] : [["delete draft document", checkDocumentPermission("update", draft)]];
    case "discardVersion":
      return liveEdit ? [] : [["delete version", checkDocumentPermission("update", version || null)]];
    case "publish":
      return liveEdit ? [] : [
        // precondition
        ["update published document at its current state", checkDocumentPermission("update", published)],
        // post condition
        ["delete draft document", checkDocumentPermission("update", draft)],
        ["create published document from draft", checkDocumentPermission("create", draft && {
          ...draft,
          _id: getPublishedId(draft._id)
        })]
      ];
    case "unpublish":
      return liveEdit ? [] : [
        // precondition
        ["update draft document at its current state", checkDocumentPermission("create", draft)],
        // post condition
        ["delete published document", checkDocumentPermission("update", published)],
        ["create draft document from published version", checkDocumentPermission("create", published && {
          ...published,
          _id: getDraftId(published._id)
        })]
      ];
    case "update":
      return liveEdit ? [["update published document (live-edit)", checkDocumentPermission("update", published)]] : [[`update ${effectiveVersionType} document`, checkDocumentPermission("update", effectiveVersion)]];
    case "duplicate":
      return liveEdit ? [["create new published document from existing document (live-edit)", checkDocumentPermission("create", {
        ...published,
        _id: "dummy-id"
      })]] : [[`create new draft document from existing ${effectiveVersionType} document`, checkDocumentPermission("create", {
        ...effectiveVersion,
        _id: getDraftId("dummy-id")
      })]];
    default:
      throw new Error(`Could not match permission: ${permission}`);
  }
}
function getDocumentPairPermissions({
  client,
  grantsStore,
  schema: schema2,
  id: id2,
  permission,
  type,
  serverActionsEnabled,
  version: v,
  pairListenerOptions
}) {
  if (type === "*")
    return of({
      granted: !1,
      reason: "Type specified was `*`"
    });
  const liveEdit = !!getSchemaType(schema2, type).liveEdit;
  return snapshotPair(client, getIdPair(id2, {
    version: v
  }), type, serverActionsEnabled, pairListenerOptions).pipe(switchMap((pair) => combineLatest([pair.draft.snapshots$, pair.published.snapshots$, pair.version?.snapshots$ || of(null)]).pipe(map(([draft, published, version]) => ({
    draft,
    published,
    version
  })))), switchMap(({
    draft,
    published,
    version
  }) => {
    const pairPermissions = getPairPermissions({
      grantsStore,
      permission,
      draft,
      version,
      published,
      liveEdit
    }).map(([label, observable]) => observable.pipe(map(({
      granted,
      reason
    }) => ({
      granted,
      reason: granted ? "" : `not allowed to ${label}: ${reason}`,
      label,
      permission
    }))));
    return pairPermissions.length ? combineLatest(pairPermissions).pipe(map((permissionResults) => {
      const granted = permissionResults.every((permissionResult) => permissionResult.granted), reason = granted ? "" : `Unable to ${permission}:
	${permissionResults.filter((permissionResult) => !permissionResult.granted).map((permissionResult) => permissionResult.reason).join(`
	`)}`;
      return {
        granted,
        reason
      };
    })) : of({
      granted: !0,
      reason: ""
    });
  }));
}
const useDocumentPairPermissionsFromHookFactory = createHookFromObservableFactory(getDocumentPairPermissions);
function useDocumentPairPermissions(t0) {
  const $ = c(14), {
    id: id2,
    type,
    version,
    permission,
    client: overrideClient,
    schema: overrideSchema,
    grantsStore: overrideGrantsStore,
    pairListenerOptions
  } = t0, defaultClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), defaultSchema = useSchema(), defaultGrantsStore = useGrantsStore(), workspace = useWorkspace();
  let t1;
  t1 = overrideClient || defaultClient;
  const client = t1;
  let t2;
  t2 = overrideSchema || defaultSchema;
  const schema2 = t2;
  let t3;
  t3 = overrideGrantsStore || defaultGrantsStore;
  const grantsStore = t3;
  let t4;
  $[0] !== workspace.__internal_serverDocumentActions?.enabled ? (t4 = () => {
    const configFlag = workspace.__internal_serverDocumentActions?.enabled;
    return typeof configFlag == "boolean" ? of(configFlag) : of(!0);
  }, $[0] = workspace.__internal_serverDocumentActions?.enabled, $[1] = t4) : t4 = $[1];
  let t5;
  $[2] !== t4 ? (t5 = t4(), $[2] = t4, $[3] = t5) : t5 = $[3];
  const serverActionsEnabled = t5;
  let t6, t7;
  return $[4] !== client || $[5] !== grantsStore || $[6] !== id2 || $[7] !== pairListenerOptions || $[8] !== permission || $[9] !== schema2 || $[10] !== serverActionsEnabled || $[11] !== type || $[12] !== version ? (t7 = {
    client,
    schema: schema2,
    grantsStore,
    id: id2,
    permission,
    type,
    serverActionsEnabled,
    pairListenerOptions,
    version
  }, $[4] = client, $[5] = grantsStore, $[6] = id2, $[7] = pairListenerOptions, $[8] = permission, $[9] = schema2, $[10] = serverActionsEnabled, $[11] = type, $[12] = version, $[13] = t7) : t7 = $[13], t6 = t7, useDocumentPairPermissionsFromHookFactory(t6);
}
const EMPTY_ARRAY$x = [], INITIAL_LOADING_STATE$5 = {
  enabled: !0,
  error: null,
  features: EMPTY_ARRAY$x,
  isLoading: !0
};
function fetchFeatures({
  versionedClient: versionedClient2
}) {
  return versionedClient2.observable.request({
    uri: "/features",
    tag: "features"
  });
}
const cachedFeatureRequest = /* @__PURE__ */ new Map();
function useFeatureEnabled(featureKey) {
  const $ = c(5), versionedClient2 = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    projectId
  } = useSource();
  if (!cachedFeatureRequest.get(projectId)) {
    const features2 = fetchFeatures({
      versionedClient: versionedClient2
    }).pipe(shareReplay());
    cachedFeatureRequest.set(projectId, features2);
  }
  let t0, t1;
  if ($[0] !== featureKey || $[1] !== projectId) {
    let t2;
    $[3] !== featureKey ? (t2 = (t3) => {
      const features_0 = t3 === void 0 ? [] : t3;
      return {
        isLoading: !1,
        enabled: !!features_0?.includes(featureKey),
        features: features_0,
        error: null
      };
    }, $[3] = featureKey, $[4] = t2) : t2 = $[4], t1 = (cachedFeatureRequest.get(projectId) || of(EMPTY_ARRAY$x)).pipe(map(t2), startWith(INITIAL_LOADING_STATE$5), catchError(_temp$2v)), $[0] = featureKey, $[1] = projectId, $[2] = t1;
  } else
    t1 = $[2];
  return t0 = t1, useObservable(t0, INITIAL_LOADING_STATE$5);
}
function _temp$2v(error) {
  return of({
    isLoading: !1,
    enabled: !1,
    features: EMPTY_ARRAY$x,
    error
  });
}
const isReleasePermissionError = (error) => isErrorWithDetails(error) && error.details?.type === "insufficientPermissionsError";
function createReleasePermissionsStore(isContentReleasesEnabled) {
  let permissions = {};
  return {
    checkWithPermissionGuard: async (action, ...args) => {
      if (!isContentReleasesEnabled)
        return !0;
      if (permissions[action.name] === void 0)
        try {
          return await action(...args, {
            dryRun: !0,
            skipCrossDatasetReferenceValidation: !0
          }), permissions = {
            ...permissions,
            [action.name]: !0
          }, !0;
        } catch (e) {
          return permissions = {
            ...permissions,
            [action.name]: !1
          }, !isReleasePermissionError(e);
        }
      else
        return permissions[action.name];
    },
    permissions
  };
}
const RELEASE_PERMISSIONS_RESOURCE_CACHE_NAMESPACE = "ReleasePermissions";
function useReleasePermissions() {
  const $ = c(3), resourceCache = useResourceCache(), contentReleasesFeature = useFeatureEnabled("contentReleases");
  let t0, releasePermissionsStore;
  return $[0] !== contentReleasesFeature || $[1] !== resourceCache ? (releasePermissionsStore = resourceCache.get({
    dependencies: [contentReleasesFeature],
    namespace: RELEASE_PERMISSIONS_RESOURCE_CACHE_NAMESPACE
  }) || createReleasePermissionsStore(contentReleasesFeature.enabled), resourceCache.set({
    namespace: RELEASE_PERMISSIONS_RESOURCE_CACHE_NAMESPACE,
    value: releasePermissionsStore,
    dependencies: [contentReleasesFeature]
  }), $[0] = contentReleasesFeature, $[1] = resourceCache, $[2] = releasePermissionsStore) : releasePermissionsStore = $[2], t0 = releasePermissionsStore, t0;
}
function getReleaseTone(release) {
  if (isPublishedPerspective(release)) return "positive";
  if (isDraftPerspective(release)) return "default";
  if (isReleaseDocument(release)) {
    if (release.state === "archived")
      return "default";
    if (release?.metadata?.releaseType === "asap")
      return RELEASE_TYPES_TONES.asap.tone;
    if (release?.metadata?.releaseType === "undecided")
      return RELEASE_TYPES_TONES.undecided.tone;
    if (release?.metadata?.releaseType === "scheduled")
      return RELEASE_TYPES_TONES.scheduled.tone;
  }
  return "default";
}
const VersionContextMenuItem = memo(function(props2) {
  const $ = c(33), {
    release
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== release ? (t0 = isReleaseScheduledOrScheduling(release), $[0] = release, $[1] = t0) : t0 = $[1];
  const isScheduled = t0;
  let t1;
  $[2] !== release ? (t1 = getReleaseTone(release), $[2] = release, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 2, tone: t1 }), $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== release.metadata.title || $[7] !== t ? (t3 = release.metadata?.title || t("release.placeholder-untitled-release"), $[6] = release.metadata.title, $[7] = t, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t3 }), $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== release.metadata.releaseType || $[12] !== t ? (t5 = release.metadata.releaseType === "asap" && /* @__PURE__ */ jsx(Fragment, { children: t("release.type.asap") }), $[11] = release.metadata.releaseType, $[12] = t, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== release || $[15] !== t ? (t6 = release.metadata.releaseType === "scheduled" && (release.metadata.intendedPublishAt ? /* @__PURE__ */ jsx(Fragment, { children: formatRelativeLocalePublishDate(release) }) : /* @__PURE__ */ jsx(Fragment, { children: t("release.chip.tooltip.unknown-date") })), $[14] = release, $[15] = t, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== release.metadata.releaseType || $[18] !== t ? (t7 = release.metadata.releaseType === "undecided" && /* @__PURE__ */ jsx(Fragment, { children: t("release.type.undecided") }), $[17] = release.metadata.releaseType, $[18] = t, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== t5 || $[21] !== t6 || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
    t5,
    t6,
    t7
  ] }), $[20] = t5, $[21] = t6, $[22] = t7, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== t4 || $[25] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t4,
    t8
  ] }), $[24] = t4, $[25] = t8, $[26] = t9) : t9 = $[26];
  let t10;
  $[27] !== isScheduled ? (t10 = isScheduled && /* @__PURE__ */ jsx(LockIcon, {}), $[27] = isScheduled, $[28] = t10) : t10 = $[28];
  let t11;
  return $[29] !== t10 || $[30] !== t2 || $[31] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Flex, { gap: 3, justify: "center", align: "center", children: [
    t2,
    t9,
    t10
  ] }), $[29] = t10, $[30] = t2, $[31] = t9, $[32] = t11) : t11 = $[32], t11;
}), ReleasesList$1 = styled(Stack)`
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
`, VersionContextMenu = memo(function(props2) {
  const $ = c(68), {
    documentId,
    releases: releases2,
    releasesLoading,
    fromRelease,
    isVersion,
    onDiscard,
    onCreateRelease,
    onCreateVersion,
    disabled,
    locked,
    type
  } = props2, {
    t
  } = useTranslation(), {
    mode
  } = useReleasesUpsell();
  let t0;
  $[0] !== documentId || $[1] !== isVersion ? (t0 = isPublishedId(documentId) && !isVersion, $[0] = documentId, $[1] = isVersion, $[2] = t0) : t0 = $[2];
  const isPublished = t0, optionsReleaseList = releases2.filter(_temp$2u), {
    checkWithPermissionGuard
  } = useReleasePermissions(), {
    createRelease
  } = useReleaseOperations(), [hasCreatePermission, setHasCreatePermission] = useState(null);
  let t1;
  $[3] !== documentId ? (t1 = getPublishedId(documentId), $[3] = documentId, $[4] = t1) : t1 = $[4];
  const t2 = isVersion ? fromRelease : void 0, t3 = fromRelease === "draft" ? "discardDraft" : "discardVersion";
  let t4;
  $[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== type ? (t4 = {
    id: t1,
    type,
    version: t2,
    permission: t3
  }, $[5] = t1, $[6] = t2, $[7] = t3, $[8] = type, $[9] = t4) : t4 = $[9];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t4), hasDiscardPermission = !isPermissionsLoading && permissions?.granted, isMounted = useRef(!1);
  let t5, t6;
  $[10] !== checkWithPermissionGuard || $[11] !== createRelease ? (t5 = () => (isMounted.current = !0, checkWithPermissionGuard(createRelease, getReleaseDefaults()).then((hasPermission) => {
    isMounted.current && setHasCreatePermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), t6 = [checkWithPermissionGuard, createRelease], $[10] = checkWithPermissionGuard, $[11] = createRelease, $[12] = t5, $[13] = t6) : (t5 = $[12], t6 = $[13]), useEffect(t5, t6);
  const T0 = Menu;
  let t7;
  $[14] !== disabled || $[15] !== fromRelease || $[16] !== isVersion || $[17] !== t ? (t7 = isVersion && /* @__PURE__ */ jsx(IntentLink, { intent: "release", params: {
    id: fromRelease
  }, rel: "noopener noreferrer", style: {
    textDecoration: "none"
  }, disabled, children: /* @__PURE__ */ jsx(MenuItem$1, { icon: CalendarIcon, text: t("release.action.view-release") }) }), $[14] = disabled, $[15] = fromRelease, $[16] = isVersion, $[17] = t, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== releasesLoading ? (t8 = releasesLoading && /* @__PURE__ */ jsx(Spinner, {}), $[19] = releasesLoading, $[20] = t8) : t8 = $[20];
  const T1 = MenuGroup, t9 = CopyIcon;
  let t10;
  $[21] === Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    placement: "right-start"
  }, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== t ? (t11 = t("release.action.copy-to"), $[22] = t, $[23] = t11) : t11 = $[23];
  const t12 = disabled || !hasCreatePermission, t13 = hasCreatePermission === !0;
  let t14;
  $[24] !== t ? (t14 = t("release.action.permission.error"), $[24] = t, $[25] = t14) : t14 = $[25];
  let t15;
  $[26] !== t13 || $[27] !== t14 ? (t15 = {
    disabled: t13,
    content: t14
  }, $[26] = t13, $[27] = t14, $[28] = t15) : t15 = $[28];
  const T2 = ReleasesList$1, t16 = 1;
  let t17;
  $[29] !== disabled || $[30] !== onCreateVersion || $[31] !== t ? (t17 = (release_0) => /* @__PURE__ */ jsx(MenuItem$1, { as: "a", onClick: () => onCreateVersion(release_0._id), renderMenuItem: () => /* @__PURE__ */ jsx(VersionContextMenuItem, { release: release_0 }), disabled, tooltipProps: {
    content: t("release.tooltip.locked")
  } }, release_0._id), $[29] = disabled, $[30] = onCreateVersion, $[31] = t, $[32] = t17) : t17 = $[32];
  const t18 = optionsReleaseList.map(t17);
  let t19;
  $[33] !== T2 || $[34] !== fromRelease || $[35] !== t18 ? (t19 = /* @__PURE__ */ jsx(T2, { space: t16, children: t18 }, fromRelease), $[33] = T2, $[34] = fromRelease, $[35] = t18, $[36] = t19) : t19 = $[36];
  let t20;
  $[37] !== optionsReleaseList.length ? (t20 = optionsReleaseList.length > 1 && /* @__PURE__ */ jsx(MenuDivider, {}), $[37] = optionsReleaseList.length, $[38] = t20) : t20 = $[38];
  let t21;
  $[39] !== t ? (t21 = t("release.action.new-release"), $[39] = t, $[40] = t21) : t21 = $[40];
  const t22 = mode === "disabled";
  let t23;
  $[41] !== onCreateRelease || $[42] !== t21 || $[43] !== t22 ? (t23 = /* @__PURE__ */ jsx(MenuItem$1, { onClick: onCreateRelease, text: t21, icon: AddIcon, disabled: t22 }), $[41] = onCreateRelease, $[42] = t21, $[43] = t22, $[44] = t23) : t23 = $[44];
  let t24;
  $[45] !== T1 || $[46] !== t10 || $[47] !== t11 || $[48] !== t12 || $[49] !== t15 || $[50] !== t19 || $[51] !== t20 || $[52] !== t23 || $[53] !== t9 ? (t24 = /* @__PURE__ */ jsxs(T1, { icon: t9, popover: t10, text: t11, disabled: t12, tooltipProps: t15, children: [
    t19,
    " ",
    t20,
    t23
  ] }), $[45] = T1, $[46] = t10, $[47] = t11, $[48] = t12, $[49] = t15, $[50] = t19, $[51] = t20, $[52] = t23, $[53] = t9, $[54] = t24) : t24 = $[54];
  let t25;
  $[55] !== disabled || $[56] !== hasDiscardPermission || $[57] !== isPublished || $[58] !== locked || $[59] !== onDiscard || $[60] !== t ? (t25 = !isPublished && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MenuDivider, {}),
    /* @__PURE__ */ jsx(MenuItem$1, { icon: TrashIcon, onClick: onDiscard, text: t("release.action.discard-version"), disabled: disabled || locked || !hasDiscardPermission, tooltipProps: {
      disabled: hasDiscardPermission === !0,
      content: t("release.action.permission.error")
    } })
  ] }), $[55] = disabled, $[56] = hasDiscardPermission, $[57] = isPublished, $[58] = locked, $[59] = onDiscard, $[60] = t, $[61] = t25) : t25 = $[61];
  let t26;
  return $[62] !== T0 || $[63] !== t24 || $[64] !== t25 || $[65] !== t7 || $[66] !== t8 ? (t26 = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(T0, { children: [
    t7,
    t8,
    t24,
    t25
  ] }) }), $[62] = T0, $[63] = t24, $[64] = t25, $[65] = t7, $[66] = t8, $[67] = t26) : t26 = $[67], t26;
});
function _temp$2u(release) {
  return !isReleaseScheduledOrScheduling(release);
}
function useSchema() {
  return useSource().schema;
}
const useCreateReleaseMetadata = () => {
  const $ = c(2), {
    zoneDateToUtc
  } = useTimeZone();
  let t0;
  return $[0] !== zoneDateToUtc ? (t0 = (release) => {
    const {
      metadata
    } = release, intendedPublishAt = metadata.intendedPublishAt ? zoneDateToUtc(new Date(metadata.intendedPublishAt)).toISOString() : void 0;
    return {
      ...release,
      metadata: {
        ...metadata,
        intendedPublishAt,
        title: metadata?.title?.trim()
      }
    };
  }, $[0] = zoneDateToUtc, $[1] = t0) : t0 = $[1], t0;
}, getIsScheduledDateInPast = (value) => !!(value.metadata.releaseType === "scheduled" && value.metadata.intendedPublishAt && isPast(new Date(value.metadata.intendedPublishAt)));
function CopyToNewReleaseDialog(props2) {
  const {
    onClose,
    documentId,
    documentType,
    tone,
    title,
    onCreateVersion
  } = props2, {
    t
  } = useTranslation(), {
    t: tRelease
  } = useTranslation(releasesLocaleNamespace), toast = useToast(), createReleaseMetadata = useCreateReleaseMetadata(), schemaType = useSchema().get(documentType), [newReleaseId] = useState(createReleaseId), [release, setRelease] = useState(() => ({
    _id: newReleaseId,
    metadata: {
      title: "",
      description: "",
      releaseType: DEFAULT_RELEASE_TYPE$1
    }
  })), [isSubmitting, setIsSubmitting] = useState(!1), [, setRerenderDialog] = useState(0), telemetry = useTelemetry(), {
    createRelease
  } = useReleaseOperations(), displayTitle = title || t("release.placeholder-untitled-release"), isScheduledDateInPast = getIsScheduledDateInPast(release), handleOnChange = useCallback((releaseMetadata) => {
    setRelease(releaseMetadata);
  }, []), handleAddVersion = useCallback(async () => {
    onCreateVersion(newReleaseId);
  }, [onCreateVersion, newReleaseId]), handleCreateRelease = useCallback(async () => {
    if (getIsScheduledDateInPast(release)) {
      setRerenderDialog((cur) => cur + 1);
      return;
    }
    try {
      setIsSubmitting(!0);
      const releaseValue = createReleaseMetadata(release);
      await createRelease(releaseValue), await handleAddVersion(), telemetry.log(CreatedRelease, {
        origin: "document-panel"
      });
    } catch (err) {
      isReleaseLimitError(err) ? onClose() : (console.error(err), toast.push({
        closable: !0,
        status: "error",
        title: t("release.toast.create-release-error.title"),
        description: err.message
      }));
    } finally {
      setIsSubmitting(!1);
    }
  }, [release, createReleaseMetadata, createRelease, handleAddVersion, telemetry, onClose, toast, t]);
  return /* @__PURE__ */ jsxs(Dialog$1, { id: "create-release-dialog", header: t("release.dialog.copy-to-release.title"), onClickOutside: onClose, onClose, padding: !1, width: 1, footer: {
    cancelButton: {
      disabled: isSubmitting,
      onClick: onClose
    },
    confirmButton: {
      text: t("release.action.add-to-new-release"),
      onClick: handleCreateRelease,
      disabled: isSubmitting || isScheduledDateInPast,
      tone: "primary"
    }
  }, children: [
    /* @__PURE__ */ jsx(Box, { paddingX: 2, marginBottom: 2, style: {
      borderBottom: "1px solid var(--card-border-color)"
    }, children: /* @__PURE__ */ jsxs(Flex, { align: "center", padding: 4, paddingTop: 1, justify: "space-between", children: [
      schemaType ? /* @__PURE__ */ jsx(Preview$1, { value: {
        _id: documentId
      }, schemaType }) : /* @__PURE__ */ jsx(LoadingBlock, {}),
      /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, padding: 1, paddingRight: 2, style: {
        borderRadius: 999,
        border: "1px solid var(--card-border-color)",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }, children: [
        /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 1, tone }),
        /* @__PURE__ */ jsx(Text$1, { size: 1, title: displayTitle, children: displayTitle })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs(Box, { paddingX: 5, paddingY: 3, children: [
      isScheduledDateInPast && /* @__PURE__ */ jsx(Card, { padding: 3, marginBottom: 3, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: tRelease("schedule-dialog.publish-date-in-past-warning") }) }),
      /* @__PURE__ */ jsx(ReleaseForm, { onChange: handleOnChange, value: release })
    ] })
  ] });
}
const ChipButtonContainer = styled.span`
  display: inline-flex;
  --border-color: var(--card-border-color);
`, ChipButton = styled(Button$1)`
  flex: none;
  transition: none;
  cursor: pointer;
  --card-border-color: var(--border-color);
`, useVersionIsLinked = (documentId, fromRelease) => {
  const $ = c(13);
  let t0;
  bb0: {
    if (fromRelease === "published") {
      let t13;
      $[0] !== documentId ? (t13 = getPublishedId(documentId), $[0] = documentId, $[1] = t13) : t13 = $[1], t0 = t13;
      break bb0;
    }
    if (fromRelease === "draft") {
      let t13;
      $[2] !== documentId ? (t13 = getDraftId(documentId), $[2] = documentId, $[3] = t13) : t13 = $[3], t0 = t13;
      break bb0;
    }
    let t12;
    $[4] !== documentId || $[5] !== fromRelease ? (t12 = getVersionId(documentId, fromRelease), $[4] = documentId, $[5] = fromRelease, $[6] = t12) : t12 = $[6], t0 = t12;
  }
  const versionId = t0, companionDocsStore = useCanvasCompanionDocsStore();
  let t1, t2;
  $[7] !== companionDocsStore || $[8] !== documentId ? (t2 = companionDocsStore.getCompanionDocs(documentId), $[7] = companionDocsStore, $[8] = documentId, $[9] = t2) : t2 = $[9], t1 = t2;
  const companionDocs = useObservable(t1);
  let t3;
  return $[10] !== companionDocs?.data || $[11] !== versionId ? (t3 = companionDocs?.data.some((companion) => companion?.studioDocumentId === versionId), $[10] = companionDocs?.data, $[11] = versionId, $[12] = t3) : t3 = $[12], t3;
}, VersionChip$1 = memo(function(props2) {
  const $ = c(81), {
    disabled,
    selected,
    tooltipContent,
    onClick: onClick2,
    text,
    tone,
    locked: t0,
    contextValues: t1
  } = props2, locked = t0 === void 0 ? !1 : t0, {
    documentId,
    releases: releases2,
    releasesLoading,
    documentType,
    menuReleaseId,
    fromRelease,
    isVersion,
    disabled: t2
  } = t1, contextMenuDisabled = t2 === void 0 ? !1 : t2, isLinked = useVersionIsLinked(documentId, fromRelease), [contextMenuPoint, setContextMenuPoint] = useState(void 0), popoverRef = useRef(null), [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(!1), [isCreateReleaseDialogOpen, setIsCreateReleaseDialogOpen] = useState(!1), {
    guardWithReleaseLimitUpsell
  } = useReleasesUpsell(), chipRef = useRef(null);
  let t3, t4;
  $[0] !== selected ? (t3 = () => {
    selected && chipRef.current?.scrollIntoView({
      inline: "center"
    });
  }, t4 = [selected], $[0] = selected, $[1] = t3, $[2] = t4) : (t3 = $[1], t4 = $[2]), useEffect(t3, t4);
  let t5;
  $[3] !== documentId || $[4] !== fromRelease || $[5] !== isVersion ? (t5 = isVersion ? getVersionId(documentId, fromRelease) : documentId, $[3] = documentId, $[4] = fromRelease, $[5] = isVersion, $[6] = t5) : t5 = $[6];
  const docId = t5, {
    createVersion
  } = useVersionOperations(), toast = useToast(), {
    t
  } = useTranslation();
  let t6;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => setContextMenuPoint(void 0), $[7] = t6) : t6 = $[7];
  const close = t6;
  let t7;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t7 = (event) => {
    event.preventDefault(), setContextMenuPoint({
      x: event.clientX,
      y: event.clientY
    });
  }, $[8] = t7) : t7 = $[8];
  const handleContextMenu = t7;
  let t8;
  $[9] !== contextMenuPoint?.x || $[10] !== contextMenuPoint?.y ? (t8 = () => {
    contextMenuPoint?.x && contextMenuPoint?.y && close();
  }, $[9] = contextMenuPoint?.x, $[10] = contextMenuPoint?.y, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => [popoverRef.current], $[12] = t9) : t9 = $[12], useClickOutsideEvent(t8, t9);
  let t10;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t10 = (event_0) => {
    event_0.key === "Escape" && close();
  }, $[13] = t10) : t10 = $[13], useGlobalKeyDown(t10);
  let t11;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
    setIsDiscardDialogOpen(!0);
  }, $[14] = t11) : t11 = $[14];
  const openDiscardDialog = t11;
  let t12;
  $[15] !== guardWithReleaseLimitUpsell ? (t12 = () => guardWithReleaseLimitUpsell(() => setIsCreateReleaseDialogOpen(!0)), $[15] = guardWithReleaseLimitUpsell, $[16] = t12) : t12 = $[16];
  const openCreateReleaseDialog = t12;
  let t13;
  $[17] !== createVersion || $[18] !== docId || $[19] !== t || $[20] !== toast ? (t13 = async (targetRelease) => {
    try {
      await createVersion(getReleaseIdFromReleaseDocumentId(targetRelease), docId);
    } catch (t142) {
      const err = t142;
      toast.push({
        closable: !0,
        status: "error",
        title: t("release.action.create-version.failure"),
        description: err.message
      });
    }
    close();
  }, $[17] = createVersion, $[18] = docId, $[19] = t, $[20] = toast, $[21] = t13) : t13 = $[21];
  const handleAddVersion = t13;
  let t14;
  bb0: {
    if (!contextMenuPoint) {
      t14 = null;
      break bb0;
    }
    let t152;
    $[22] !== contextMenuPoint ? (t152 = {
      getBoundingClientRect() {
        return {
          x: contextMenuPoint.x,
          y: contextMenuPoint.y,
          left: contextMenuPoint.x,
          top: contextMenuPoint.y,
          right: contextMenuPoint.x,
          bottom: contextMenuPoint.y,
          width: 0,
          height: 0
        };
      }
    }, $[22] = contextMenuPoint, $[23] = t152) : t152 = $[23], t14 = t152;
  }
  const referenceElement = t14, contextMenuHandler = disabled ? void 0 : handleContextMenu;
  let t15;
  $[24] === Symbol.for("react.memo_cache_sentinel") ? (t15 = [], $[24] = t15) : t15 = $[24];
  const t16 = `document-header-${text.replaceAll(" ", "-")}-chip`, t17 = disabled ? "ghost" : "bleed";
  let t18;
  $[25] !== tone ? (t18 = /* @__PURE__ */ jsx(ReleaseAvatarIcon, { tone }), $[25] = tone, $[26] = t18) : t18 = $[26];
  let t19;
  $[27] !== isLinked || $[28] !== locked ? (t19 = isLinked ? /* @__PURE__ */ jsx(ComposeSparklesIcon, {}) : locked && /* @__PURE__ */ jsx(LockIcon, {}), $[27] = isLinked, $[28] = locked, $[29] = t19) : t19 = $[29];
  let t20;
  $[30] !== contextMenuHandler || $[31] !== disabled || $[32] !== onClick2 || $[33] !== selected || $[34] !== t16 || $[35] !== t17 || $[36] !== t18 || $[37] !== t19 || $[38] !== text || $[39] !== tone ? (t20 = /* @__PURE__ */ jsx(ChipButtonContainer, { children: /* @__PURE__ */ jsx(ChipButton, { "data-testid": t16, ref: chipRef, disabled, mode: t17, onClick: onClick2, selected, tone, onContextMenu: contextMenuHandler, paddingY: 2, paddingLeft: 2, paddingRight: 3, space: 2, radius: "full", icon: t18, iconRight: t19, text }) }), $[30] = contextMenuHandler, $[31] = disabled, $[32] = onClick2, $[33] = selected, $[34] = t16, $[35] = t17, $[36] = t18, $[37] = t19, $[38] = text, $[39] = tone, $[40] = t20) : t20 = $[40];
  let t21;
  $[41] !== t20 || $[42] !== tooltipContent ? (t21 = /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, fallbackPlacements: t15, portal: !0, placement: "bottom", children: t20 }), $[41] = t20, $[42] = tooltipContent, $[43] = t21) : t21 = $[43];
  let t22;
  $[44] !== contextMenuDisabled || $[45] !== documentId || $[46] !== documentType || $[47] !== fromRelease || $[48] !== handleAddVersion || $[49] !== isVersion || $[50] !== locked || $[51] !== openCreateReleaseDialog || $[52] !== releases2 || $[53] !== releasesLoading ? (t22 = /* @__PURE__ */ jsx(VersionContextMenu, { documentId, releases: releases2, releasesLoading, fromRelease, isVersion, onDiscard: openDiscardDialog, onCreateRelease: openCreateReleaseDialog, disabled: contextMenuDisabled, onCreateVersion: handleAddVersion, locked, type: documentType }), $[44] = contextMenuDisabled, $[45] = documentId, $[46] = documentType, $[47] = fromRelease, $[48] = handleAddVersion, $[49] = isVersion, $[50] = locked, $[51] = openCreateReleaseDialog, $[52] = releases2, $[53] = releasesLoading, $[54] = t22) : t22 = $[54];
  let t23;
  $[55] === Symbol.for("react.memo_cache_sentinel") ? (t23 = [], $[55] = t23) : t23 = $[55];
  const t24 = !!referenceElement;
  let t25;
  $[56] !== referenceElement || $[57] !== t22 || $[58] !== t24 ? (t25 = /* @__PURE__ */ jsx(Popover, { content: t22, fallbackPlacements: t23, open: t24, portal: !0, placement: "bottom-start", ref: popoverRef, referenceElement, zOffset: 10 }), $[56] = referenceElement, $[57] = t22, $[58] = t24, $[59] = t25) : t25 = $[59];
  let t26;
  $[60] !== documentId || $[61] !== documentType || $[62] !== isDiscardDialogOpen || $[63] !== isVersion || $[64] !== menuReleaseId || $[65] !== text ? (t26 = isDiscardDialogOpen && /* @__PURE__ */ jsx(DiscardVersionDialog, { onClose: () => setIsDiscardDialogOpen(!1), documentId: isVersion ? getVersionId(documentId, getReleaseIdFromReleaseDocumentId(menuReleaseId)) : documentId, fromPerspective: text, documentType }), $[60] = documentId, $[61] = documentType, $[62] = isDiscardDialogOpen, $[63] = isVersion, $[64] = menuReleaseId, $[65] = text, $[66] = t26) : t26 = $[66];
  let t27;
  $[67] !== documentId || $[68] !== documentType || $[69] !== handleAddVersion || $[70] !== isCreateReleaseDialogOpen || $[71] !== isVersion || $[72] !== menuReleaseId || $[73] !== text || $[74] !== tone ? (t27 = isCreateReleaseDialogOpen && /* @__PURE__ */ jsx(CopyToNewReleaseDialog, { onClose: () => setIsCreateReleaseDialogOpen(!1), onCreateVersion: handleAddVersion, documentId: isVersion ? getVersionId(documentId, getReleaseIdFromReleaseDocumentId(menuReleaseId)) : documentId, documentType, tone, title: text }), $[67] = documentId, $[68] = documentType, $[69] = handleAddVersion, $[70] = isCreateReleaseDialogOpen, $[71] = isVersion, $[72] = menuReleaseId, $[73] = text, $[74] = tone, $[75] = t27) : t27 = $[75];
  let t28;
  return $[76] !== t21 || $[77] !== t25 || $[78] !== t26 || $[79] !== t27 ? (t28 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t21,
    t25,
    t26,
    t27
  ] }), $[76] = t21, $[77] = t25, $[78] = t26, $[79] = t27, $[80] = t28) : t28 = $[80], t28;
}), StyledVersionInlineBadge = styled.span((props2) => {
  const {
    $tone
  } = props2;
  return css`
    color: var(--card-badge-${$tone ?? "default"}-fg-color);
    background-color: var(--card-badge-${$tone ?? "default"}-bg-color);
    border-radius: 3px;
    text-decoration: none;
    padding: 0px 2px;
    font-weight: 500;
  `;
}), VersionInlineBadge = (t0) => {
  const $ = c(3), {
    children,
    $tone
  } = t0;
  let t1;
  return $[0] !== $tone || $[1] !== children ? (t1 = /* @__PURE__ */ jsx(StyledVersionInlineBadge, { $tone, children }), $[0] = $tone, $[1] = children, $[2] = t1) : t1 = $[2], t1;
}, getVersionInlineBadge = (release) => {
  const tone = getReleaseTone(release ?? LATEST);
  return (t0) => {
    const $ = c(2), {
      children
    } = t0;
    let t1;
    return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(VersionInlineBadge, { $tone: tone, children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
  };
};
function useAllReleases() {
  const $ = c(7), {
    state$
  } = useReleasesStore(), {
    releases: releases2,
    error,
    state
  } = useObservable(state$);
  let t0, t1;
  $[0] !== releases2 ? (t1 = sortReleases(Array.from(releases2.values())), $[0] = releases2, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = ["loading", "initialising"], $[2] = t2) : t2 = $[2];
  const t3 = t2.includes(state);
  let t4;
  return $[3] !== error || $[4] !== t1 || $[5] !== t3 ? (t4 = {
    data: t1,
    error,
    loading: t3
  }, $[3] = error, $[4] = t1, $[5] = t3, $[6] = t4) : t4 = $[6], t0 = t4, t0;
}
function useArchivedReleases() {
  const $ = c(6), {
    data: releases2,
    error,
    loading
  } = useAllReleases();
  let t0, t1;
  $[0] !== releases2 ? (t1 = Array.from(releases2.values()).filter(_temp$2t), $[0] = releases2, $[1] = t1) : t1 = $[1], t0 = t1;
  const archivedReleases = t0;
  let t2, t3;
  return $[2] !== archivedReleases || $[3] !== error || $[4] !== loading ? (t3 = {
    data: archivedReleases,
    error,
    loading
  }, $[2] = archivedReleases, $[3] = error, $[4] = loading, $[5] = t3) : t3 = $[5], t2 = t3, t2;
}
function _temp$2t(release) {
  return ARCHIVED_RELEASE_STATES.includes(release.state);
}
async function getJsonStream(url, token) {
  const options = token ? {
    headers: {
      Authorization: `Bearer ${token}`
    }
  } : {
    credentials: "include"
  }, response = await fetch(url, options);
  return getStream(response);
}
function getStream(response) {
  const body = response.body;
  if (!body)
    throw new Error("Failed to read body from response");
  let reader, cancelled = !1;
  return new ReadableStream({
    start(controller) {
      reader = body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      reader.read().then(function processResult(result) {
        if (result.done) {
          if (cancelled)
            return;
          if (buffer = buffer.trim(), buffer.length === 0) {
            controller.close();
            return;
          }
          controller.enqueue(JSON.parse(buffer)), controller.close();
          return;
        }
        buffer += decoder.decode(result.value, {
          stream: !0
        });
        const lines = buffer.split(`
`);
        for (let i = 0; i < lines.length - 1; ++i) {
          const line = lines[i].trim();
          if (line.length !== 0)
            try {
              controller.enqueue(JSON.parse(line));
            } catch (err) {
              controller.error(err), cancelled = !0, reader.cancel();
              return;
            }
        }
        return buffer = lines[lines.length - 1], reader.read().then(processResult).catch((err) => controller.error(err));
      }).catch((err) => controller.error(err));
    },
    cancel() {
      cancelled = !0, reader.cancel();
    }
  });
}
function useReleaseHistory(releaseDocumentsIds, releaseId) {
  const client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), {
    dataset,
    token
  } = client.config(), [history2, setHistory] = useState([]), queryParams = "tag=sanity.studio.tasks.history&effectFormat=mendoza&excludeContent=true&includeIdentifiedDocumentsOnly=true", versionIds = releaseDocumentsIds.map((id2) => getVersionId(id2, releaseId)).join(","), transactionsUrl = client.getUrl(`/data/history/${dataset}/transactions/${versionIds}?${queryParams}`), fetchAndParseAll = useCallback(async () => {
    if (!versionIds || !releaseId) return;
    const transactions = [], reader = (await getJsonStream(transactionsUrl, token)).getReader();
    let result;
    for (; result = await reader.read(), !result.done; ) {
      if ("error" in result.value)
        throw new Error(result.value.error.description || result.value.error.type);
      transactions.push(result.value);
    }
    setHistory(transactions);
  }, [versionIds, transactionsUrl, token, releaseId]);
  return useEffect(() => {
    fetchAndParseAll();
  }, [fetchAndParseAll]), useMemo(() => {
    const collaborators = [], documentsHistory = {};
    return history2.length ? (history2.forEach((item) => {
      const documentId = item.documentIDs[0];
      let documentHistory = documentsHistory[documentId];
      collaborators.includes(item.author) || collaborators.push(item.author), documentHistory ? (item.mutations.some((mutation) => "create" in mutation) && (documentHistory.createdBy = item.author), documentHistory.editors.includes(item.author) || documentHistory.editors.push(item.author), documentHistory.lastEditedBy = item.author, documentHistory.history.push(item)) : (documentHistory = {
        history: [item],
        createdBy: item.author,
        lastEditedBy: item.author,
        editors: [item.author]
      }, documentsHistory[documentId] = documentHistory);
    }), {
      documentsHistory,
      collaborators,
      loading: !1
    }) : {
      documentsHistory,
      collaborators,
      loading: !0
    };
  }, [history2]);
}
function SourceProvider(t0) {
  const $ = c(16);
  let children, props2;
  $[0] !== t0 ? ({
    children,
    ...props2
  } = t0, $[0] = t0, $[1] = children, $[2] = props2) : (children = $[1], props2 = $[2]);
  const parentSource = useContext(SourceContext), {
    unstable_sources: sources
  } = useWorkspace();
  if ("source" in props2) {
    const {
      source
    } = props2;
    let t1;
    return $[3] !== children || $[4] !== source ? (t1 = /* @__PURE__ */ jsx(SourceContext.Provider, { value: source, children }), $[3] = children, $[4] = source, $[5] = t1) : t1 = $[5], t1;
  }
  if ("name" in props2) {
    const {
      name
    } = props2;
    let t1;
    if ($[6] !== name || $[7] !== sources) {
      let t22;
      $[9] !== name ? (t22 = (s) => s.name === name, $[9] = name, $[10] = t22) : t22 = $[10], t1 = sources.find(t22), $[6] = name, $[7] = sources, $[8] = t1;
    } else
      t1 = $[8];
    const source_0 = t1;
    if (!source_0)
      throw new Error(`Could not find source with name \`${name}\` in current workspace`);
    if (parentSource === source_0) {
      let t22;
      return $[11] !== children ? (t22 = /* @__PURE__ */ jsx(Fragment, { children }), $[11] = children, $[12] = t22) : t22 = $[12], t22;
    }
    let t2;
    return $[13] !== children || $[14] !== source_0 ? (t2 = /* @__PURE__ */ jsx(SourceContext.Provider, { value: source_0, children }), $[13] = children, $[14] = source_0, $[15] = t2) : t2 = $[15], t2;
  }
  throw new Error("Invalid props passed into SourceProvider. A `name` or a `source` object is required.");
}
function useSource() {
  const source = useContext(SourceContext);
  if (!source)
    throw new Error("Could not find `source` context");
  return source;
}
function getReleaseDocumentIdFromReleaseId(name) {
  return `${RELEASE_DOCUMENTS_PATH}.${name}`;
}
const INITIAL_VALUE$3 = {
  events: [],
  nextCursor: "",
  loading: !0,
  error: null
};
function removeDupes$2(prev, next) {
  const noDupes = [...prev, ...next].reduce((acc, event) => acc.has(event.id) ? acc : acc.set(event.id, event), /* @__PURE__ */ new Map());
  return Array.from(noDupes.values());
}
function addEventData(event) {
  return {
    ...event,
    id: `${event.timestamp}-${event.type}`,
    origin: "events"
  };
}
function getReleaseActivityEvents({
  client,
  releaseId
}) {
  const refetchEventsTrigger$ = new BehaviorSubject({
    cursor: null,
    origin: "initial"
  }), fetchEvents = ({
    limit: limit2,
    nextCursor: nextCursor2
  }) => {
    const params = new URLSearchParams({
      limit: limit2.toString()
    });
    return nextCursor2 && params.append("nextCursor", nextCursor2), client.observable.request({
      url: `/data/history/${client.config().dataset}/events/releases/${getReleaseIdFromReleaseDocumentId(releaseId)}?${params.toString()}`,
      tag: "get-release-events"
    }).pipe(map((response) => ({
      events: response.events.map(addEventData),
      nextCursor: response.nextCursor,
      loading: !1,
      error: null
    })), catchError((error) => (console.error(error), [{
      events: [],
      nextCursor: "",
      loading: !1,
      error
    }])));
  };
  let nextCursor = "";
  return {
    events$: refetchEventsTrigger$.pipe(switchMap(({
      cursor,
      origin
    }) => fetchEvents({
      nextCursor: cursor,
      limit: origin === "reload" ? 10 : 100
    }).pipe(map((response) => ({
      ...response,
      origin
    })), startWith({
      events: [],
      nextCursor: "",
      loading: !0,
      error: null,
      origin
    }))), scan((prev, next) => ({
      events: removeDupes$2(prev.events, next.events).sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()),
      // If we are reloading, we should keep the cursor as it was before.
      nextCursor: next.origin === "reload" ? prev.nextCursor : next.nextCursor,
      loading: next.loading,
      error: next.error
    }), INITIAL_VALUE$3), tap((response) => {
      nextCursor = response.nextCursor;
    }), shareReplay(1)),
    /**
     * Loads new events for the release, fetching the latest events from the API.
     */
    reloadEvents: () => refetchEventsTrigger$.next({
      cursor: null,
      origin: "reload"
    }),
    /**
     * Loads more events for the release, fetching the next batch of events from the API.
     */
    loadMore: () => {
      const lastCursorUsed = refetchEventsTrigger$.getValue().cursor;
      nextCursor && lastCursorUsed !== nextCursor && refetchEventsTrigger$.next({
        origin: "loadMore",
        cursor: nextCursor
      });
    }
  };
}
async function getTransactionsLogs(client, documentIds, params) {
  const clientConfig = client.config(), dataset = clientConfig.dataset, queryParams = new URLSearchParams({
    // Default values
    tag: "sanity.studio.transactions-log",
    excludeContent: "true",
    limit: "50",
    includeIdentifiedDocumentsOnly: "true"
  });
  Object.entries(params).forEach(([key, value]) => {
    value !== void 0 && queryParams.set(key, value.toString());
  });
  const transactionsUrl = client.getUrl(`/data/history/${dataset}/transactions/${Array.isArray(documentIds) ? documentIds.join(",") : documentIds}?${queryParams.toString()}`), stream = await getJsonStream(transactionsUrl, clientConfig.token), transactions = [], reader = stream.getReader();
  for (; ; ) {
    const result = await reader.read();
    if (result.done) break;
    if ("error" in result.value)
      throw new Error(result.value.error.description || result.value.error.type);
    transactions.push(result.value);
  }
  return transactions;
}
function omitRev$2(document2) {
  if (document2 === void 0)
    return;
  const {
    _rev,
    ...doc
  } = document2;
  return doc;
}
function applyMendozaPatch(document2, patch2, baseRev) {
  if (baseRev !== document2?._rev)
    throw new Error("Invalid document revision. The provided patch is calculated from a different revision than the current document");
  const next = applyPatch$1(omitRev$2(document2), patch2);
  return next === null ? void 0 : next;
}
function applyMutationEventEffects(document2, event) {
  if (!event.effects)
    throw new Error("Mutation event is missing effects. Is the listener set up with effectFormat=mendoza?");
  const next = applyMendozaPatch(document2, event.effects.apply, event.previousRev);
  return next ? {
    ...next,
    _rev: event.resultRev
  } : void 0;
}
function buildReleaseEditEvents(transactions, release) {
  if (release._rev !== transactions[0]?.id)
    return console.error("Some transactions are missing, cannot calculate the edit events"), [];
  const releaseEditEvents = [];
  let currentDocument = release;
  for (const transaction of transactions) {
    const effect = transaction.effects[release._id];
    if (!effect) continue;
    const before = applyMendozaPatch(currentDocument, effect.revert, currentDocument._rev), changed = {};
    before?.state !== currentDocument.state && currentDocument.state === "archived" && releaseEditEvents.push({
      type: "archiveRelease",
      timestamp: transaction.timestamp,
      author: transaction.author,
      releaseName: getReleaseIdFromReleaseDocumentId(release._id),
      id: transaction.id,
      origin: "translog"
    }), before?.state !== currentDocument.state && currentDocument.state === "published" && releaseEditEvents.push({
      type: "publishRelease",
      timestamp: transaction.timestamp,
      author: transaction.author,
      releaseName: getReleaseIdFromReleaseDocumentId(release._id),
      id: transaction.id,
      origin: "translog"
    }), before?.state === "unarchiving" && currentDocument.state === "active" && releaseEditEvents.push({
      type: "unarchiveRelease",
      timestamp: transaction.timestamp,
      author: transaction.author,
      releaseName: getReleaseIdFromReleaseDocumentId(release._id),
      id: transaction.id,
      origin: "translog"
    }), before?.metadata.releaseType !== currentDocument.metadata.releaseType && (changed.releaseType = currentDocument.metadata.releaseType), before?.metadata.intendedPublishAt !== currentDocument.metadata.intendedPublishAt && (changed.intendedPublishDate = currentDocument.metadata.intendedPublishAt), Object.values(changed).length >= 1 && releaseEditEvents.push({
      type: before ? "editRelease" : "createRelease",
      origin: "translog",
      author: transaction.author,
      change: changed,
      id: transaction.id,
      timestamp: transaction.timestamp,
      releaseName: getReleaseIdFromReleaseDocumentId(release._id)
    }), before && (currentDocument = before);
  }
  return releaseEditEvents;
}
const TRANSLOG_ENTRY_LIMIT$2 = 100, documentTransactionsCache$1 = /* @__PURE__ */ Object.create(null);
function removeDupes$1(newTransactions, oldTransactions) {
  const seen = /* @__PURE__ */ new Set();
  return newTransactions.concat(oldTransactions).filter((transaction) => seen.has(transaction.id) ? !1 : (seen.add(transaction.id), !0));
}
function getReleaseTransactions({
  documentId,
  client,
  toTransaction
}) {
  const cacheKey = `${documentId}`, cachedTransactions = documentTransactionsCache$1[cacheKey] || [];
  if (cachedTransactions.length > 0 && cachedTransactions[0].id === toTransaction)
    return of(cachedTransactions);
  function fetchLogs(options) {
    return from(getTransactionsLogs(client, documentId, {
      tag: "sanity.studio.release.history",
      effectFormat: "mendoza",
      limit: TRANSLOG_ENTRY_LIMIT$2,
      reverse: !0,
      fromTransaction: options.fromTransaction,
      toTransaction: options.toTransaction
    }));
  }
  return fetchLogs({
    fromTransaction: cachedTransactions[0]?.id,
    toTransaction
  }).pipe(
    expand((response) => response.length === TRANSLOG_ENTRY_LIMIT$2 ? fetchLogs({
      fromTransaction: void 0,
      toTransaction: response[response.length - 1].id
    }) : of()),
    // Combine all batches of transactions into a single array
    reduce$1((allTransactions, batch) => allTransactions.concat(batch), [])
  ).pipe(map$1((transactions) => removeDupes$1(transactions, cachedTransactions)), tap$1((transactions) => {
    documentTransactionsCache$1[cacheKey] = transactions;
  }));
}
const INITIAL_VALUE$2 = {
  editEvents: [],
  loading: !0,
  error: null
};
function getReleaseEditEvents({
  client,
  observeDocument$
}) {
  return observeDocument$.pipe(filter$1(Boolean), distinctUntilChanged$1((prev, next) => prev._rev === next._rev), switchMap$1((release) => getReleaseTransactions({
    client,
    documentId: release._id,
    toTransaction: release._rev
  }).pipe(map$1((transactions) => ({
    editEvents: buildReleaseEditEvents(transactions, release),
    loading: !1,
    error: null
  })), catchError$1((error) => (console.error(error), of({
    editEvents: [],
    loading: !1,
    error
  }))))), startWith$1(INITIAL_VALUE$2), scan$1((acc, current) => {
    const editEvents = current.loading ? acc.editEvents : current.editEvents;
    return {
      ...current,
      editEvents
    };
  }, INITIAL_VALUE$2), shareReplay$1(1));
}
const isCreateReleaseEvent = (event) => event.type === "createRelease", isScheduleReleaseEvent = (event) => event.type === "scheduleRelease", isPublishReleaseEvent = (event) => event.type === "publishRelease", isArchiveReleaseEvent = (event) => event.type === "archiveRelease", isUnarchiveReleaseEvent = (event) => event.type === "unarchiveRelease", isAddDocumentToReleaseEvent = (event) => event.type === "addDocumentToRelease", isDiscardDocumentFromReleaseEvent = (event) => event.type === "discardDocumentFromRelease", isEditReleaseEvent = (event) => event.type === "editRelease", isTranslogEvent = (event) => event.origin === "translog", isEventsAPIEvent = (event) => event.origin === "events", EVENTS_INITIAL_VALUE = {
  events: [],
  hasMore: !1,
  error: null,
  loading: !0
}, notEnabledActivityEvents = {
  events$: of({
    events: [],
    nextCursor: "",
    loading: !1,
    error: null
  }),
  reloadEvents: () => {
  },
  loadMore: () => {
  }
};
function getReleaseEvents({
  client,
  releaseId,
  releasesState$,
  documentPreviewStore,
  eventsAPIEnabled
}) {
  const observeDocument$ = documentPreviewStore.unstable_observeDocument(releaseId, {
    apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
  }), editEvents$ = getReleaseEditEvents({
    client,
    observeDocument$
  }), releaseRev$ = releasesState$.pipe(
    map$1((state) => state.releases.get(releaseId)?._rev),
    filter$1(Boolean),
    distinctUntilChanged$1(),
    // Emit only when rev changes, after first non null value.
    skip$1(1)
  ), activityEvents = eventsAPIEnabled ? getReleaseActivityEvents({
    client,
    releaseId
  }) : notEnabledActivityEvents, documentsCount$ = eventsAPIEnabled ? of(0) : documentPreviewStore.unstable_observeDocumentIdSet("sanity::partOfRelease($releaseId)", {
    releaseId: getReleaseIdFromReleaseDocumentId(releaseId)
  }, {
    apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
  }).pipe(
    filter$1(({
      status
    }) => status === "connected"),
    map$1(({
      documentIds
    }) => documentIds.length),
    distinctUntilChanged$1(),
    // Emit only when count changes, after first non null value.
    skip$1(1)
  ), sideEffects$ = merge(releaseRev$, documentsCount$).pipe(tap$1(() => {
    activityEvents.reloadEvents();
  }), startWith$1(null));
  return {
    events$: combineLatest([activityEvents.events$, editEvents$, sideEffects$]).pipe(map$1(([activity, edit]) => {
      const events2 = [...activity.events, ...edit.editEvents].sort((a, b) => Date.parse(b.timestamp) - Date.parse(a.timestamp)).reduce((acc, event) => {
        if (isCreateReleaseEvent(event)) {
          const creationEvent = acc.find(isCreateReleaseEvent);
          creationEvent ? isEventsAPIEvent(creationEvent) && isTranslogEvent(event) && (acc[acc.indexOf(creationEvent)] = event) : acc.push(event);
        } else acc.push(event);
        return acc;
      }, []);
      return {
        events: deduplicateEvents(events2),
        hasMore: !!activity.nextCursor,
        error: activity.error || edit.error,
        loading: activity.loading || edit.loading
      };
    })),
    loadMore: activityEvents.loadMore
  };
}
const deduplicateEvents = (events2) => events2.filter((event, index) => {
  const nextEvent = events2[index + 1];
  return nextEvent ? !(event.type === nextEvent.type && areTheSameDate(event.timestamp, nextEvent.timestamp)) : !0;
});
function areTheSameDate(date1, date2) {
  const time1 = new Date(date1).getTime(), time2 = new Date(date2).getTime();
  return Math.abs(time1 - time2) <= 1e3;
}
function useReleaseEvents(releaseId) {
  const $ = c(12), client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), documentPreviewStore = useDocumentPreviewStore(), {
    state$: releasesState$
  } = useReleasesStore(), eventsAPIEnabled = !!useSource().beta?.eventsAPI?.releases;
  let t0, t1;
  $[0] !== client || $[1] !== documentPreviewStore || $[2] !== eventsAPIEnabled || $[3] !== releaseId || $[4] !== releasesState$ ? (t1 = getReleaseEvents({
    client,
    releaseId: getReleaseDocumentIdFromReleaseId(releaseId),
    releasesState$,
    documentPreviewStore,
    eventsAPIEnabled
  }), $[0] = client, $[1] = documentPreviewStore, $[2] = eventsAPIEnabled, $[3] = releaseId, $[4] = releasesState$, $[5] = t1) : t1 = $[5], t0 = t1;
  const releaseEvents = t0, events2 = useObservable(releaseEvents.events$, EVENTS_INITIAL_VALUE);
  let t2;
  return $[6] !== events2.error || $[7] !== events2.events || $[8] !== events2.hasMore || $[9] !== events2.loading || $[10] !== releaseEvents.loadMore ? (t2 = {
    events: events2.events,
    hasMore: events2.hasMore,
    loading: events2.loading,
    error: events2.error,
    loadMore: releaseEvents.loadMore
  }, $[6] = events2.error, $[7] = events2.events, $[8] = events2.hasMore, $[9] = events2.loading, $[10] = releaseEvents.loadMore, $[11] = t2) : t2 = $[11], t2;
}
const Root$z = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 9px;
  z-index: 201;
  cursor: ew-resize;

  ${({
  position
}) => position === "right" ? css`
          right: -4px;
        ` : css`
          left: -4px;
        `}

  /* Border */
  & > span:nth-child(1) {
    display: block;
    border-left: 1px solid var(--card-border-color);
    position: absolute;
    top: 0;
    ${({
  position
}) => position === "right" ? css`
            right: 4px;
          ` : css`
            left: 4px;
          `}
    bottom: 0;
    transition: opacity 200ms;
  }

  /* Hover effect */
  & > span:nth-child(2) {
    display: block;
    position: absolute;
    top: 0;
    ${({
  position
}) => position === "right" ? css`
            right: 0px;
          ` : css`
            left: 0px;
          `}
    width: 9px;
    bottom: 0;
    background-color: var(--card-border-color);
    opacity: 0;
    transition: opacity 150ms;
  }

  @media (hover: hover) {
    &:hover > span:nth-child(2) {
      opacity: 0.2;
    }
  }
`;
function Resizer(props2) {
  const $ = c(8), {
    onResize,
    onResizeStart,
    position
  } = props2, mouseXRef = useRef(0);
  let t0;
  $[0] !== onResize || $[1] !== onResizeStart ? (t0 = (event) => {
    event.preventDefault(), mouseXRef.current = event.pageX, onResizeStart();
    const handleMouseMove = (e) => {
      e.preventDefault(), onResize(mouseXRef.current - e.pageX);
    }, handleMouseUp = () => {
      window.removeEventListener("mousemove", handleMouseMove), window.removeEventListener("mouseup", handleMouseUp);
    };
    window.addEventListener("mousemove", handleMouseMove), window.addEventListener("mouseup", handleMouseUp);
  }, $[0] = onResize, $[1] = onResizeStart, $[2] = t0) : t0 = $[2];
  const handleMouseDown = t0;
  let t1, t2;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx("span", {}), t2 = /* @__PURE__ */ jsx("span", {}), $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]);
  let t3;
  return $[5] !== handleMouseDown || $[6] !== position ? (t3 = /* @__PURE__ */ jsxs(Root$z, { onMouseDown: handleMouseDown, position, children: [
    t1,
    t2
  ] }), $[5] = handleMouseDown, $[6] = position, $[7] = t3) : t3 = $[7], t3;
}
const Root$y = styled(Box)`
  position: relative;
  flex: 1;
  padding-left: 1px;
`;
function Resizable(props2) {
  const $ = c(33);
  let children, forwardedAs, initialWidth, maxWidth, minWidth, restProps, t0;
  $[0] !== props2 ? ({
    as: forwardedAs,
    children,
    minWidth,
    maxWidth,
    initialWidth,
    resizerPosition: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = forwardedAs, $[3] = initialWidth, $[4] = maxWidth, $[5] = minWidth, $[6] = restProps, $[7] = t0) : (children = $[1], forwardedAs = $[2], initialWidth = $[3], maxWidth = $[4], minWidth = $[5], restProps = $[6], t0 = $[7]);
  const resizerPosition = t0 === void 0 ? "right" : t0, [element, setElement] = useState(null), elementWidthRef = useRef(void 0), [targetWidth, setTargetWidth] = useState(initialWidth);
  let t1;
  $[8] !== element?.offsetWidth ? (t1 = () => {
    elementWidthRef.current = element?.offsetWidth;
  }, $[8] = element?.offsetWidth, $[9] = t1) : t1 = $[9];
  const handleResizeStart = t1;
  let t2;
  $[10] !== maxWidth || $[11] !== minWidth || $[12] !== resizerPosition ? (t2 = (deltaX) => {
    const w = elementWidthRef.current;
    w && setTargetWidth(Math.min(Math.max(resizerPosition === "right" ? w - deltaX : w + deltaX, minWidth), maxWidth));
  }, $[10] = maxWidth, $[11] = minWidth, $[12] = resizerPosition, $[13] = t2) : t2 = $[13];
  const handleResize = t2;
  let t3, t4;
  $[14] !== maxWidth || $[15] !== minWidth || $[16] !== targetWidth ? (t4 = targetWidth ? {
    flex: "none",
    width: targetWidth
  } : {
    minWidth,
    maxWidth
  }, $[14] = maxWidth, $[15] = minWidth, $[16] = targetWidth, $[17] = t4) : t4 = $[17], t3 = t4;
  const style = t3;
  let t5;
  $[18] !== handleResize || $[19] !== handleResizeStart || $[20] !== resizerPosition ? (t5 = resizerPosition === "left" && /* @__PURE__ */ jsx(Resizer, { onResize: handleResize, onResizeStart: handleResizeStart, position: "left" }), $[18] = handleResize, $[19] = handleResizeStart, $[20] = resizerPosition, $[21] = t5) : t5 = $[21];
  let t6;
  $[22] !== handleResize || $[23] !== handleResizeStart || $[24] !== resizerPosition ? (t6 = resizerPosition === "right" && /* @__PURE__ */ jsx(Resizer, { onResize: handleResize, onResizeStart: handleResizeStart, position: "right" }), $[22] = handleResize, $[23] = handleResizeStart, $[24] = resizerPosition, $[25] = t6) : t6 = $[25];
  let t7;
  return $[26] !== children || $[27] !== forwardedAs || $[28] !== restProps || $[29] !== style || $[30] !== t5 || $[31] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Root$y, { as: forwardedAs, ...restProps, ref: setElement, style, children: [
    t5,
    children,
    t6
  ] }), $[26] = children, $[27] = forwardedAs, $[28] = restProps, $[29] = style, $[30] = t5, $[31] = t6, $[32] = t7) : t7 = $[32], t7;
}
const FIVE_SECONDS = 1e3 * 5, TWENTY_SECONDS = 1e3 * 20, ONE_MINUTE = 1e3 * 60, ONE_HOUR = ONE_MINUTE * 60, NO_YEAR_DATE_ONLY_FORMAT = {
  month: "short",
  day: "numeric"
}, DATE_ONLY_FORMAT = {
  ...NO_YEAR_DATE_ONLY_FORMAT,
  year: "numeric"
}, FULL_DATE_FORMAT = {
  ...DATE_ONLY_FORMAT,
  hour: "numeric",
  minute: "numeric"
};
function useRelativeTime(time, t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, [now, updateNow] = useReducer(_temp$2s, null, _temp2$W), resolved = useFormatRelativeTime(time, options.relativeTo || now, options);
  let t2, t3;
  return $[2] !== resolved.refreshInterval ? (t2 = () => {
    let timerId;
    function tick(interval2) {
      timerId = window.setTimeout(() => {
        updateNow(), timerId = window.setTimeout(() => tick(interval2), interval2);
      }, interval2);
    }
    return resolved.refreshInterval !== null && tick(resolved.refreshInterval), () => {
      timerId !== null && clearTimeout(timerId);
    };
  }, t3 = [resolved.refreshInterval], $[2] = resolved.refreshInterval, $[3] = t2, $[4] = t3) : (t2 = $[3], t3 = $[4]), useEffect(t2, t3), resolved.timestamp;
}
function _temp2$W() {
  return Date.now();
}
function _temp$2s() {
  return Date.now();
}
function useFormatRelativeTime(date, now, t0) {
  const $ = c(51);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const opts = t1, {
    t
  } = useTranslation(), currentLocale = useCurrentLocale().id, {
    timeZone,
    minimal
  } = opts;
  let t2;
  $[2] !== date ? (t2 = date instanceof Date ? date : new Date(date), $[2] = date, $[3] = t2) : t2 = $[3];
  const parsedDate = t2, useTemporalPhrase = !!opts.useTemporalPhrase;
  let t3;
  $[4] !== currentLocale || $[5] !== minimal || $[6] !== useTemporalPhrase ? (t3 = function(count2, unit) {
    const isNextOrPrevDay = unit === "day" && Math.abs(count2) === 1, isNextOrPrevWeek = unit === "week" && Math.abs(count2) === 1;
    return useTemporalPhrase || isNextOrPrevDay ? intlCache.relativeTimeFormat(currentLocale, {
      style: minimal && !isNextOrPrevWeek ? "short" : "long",
      numeric: "auto"
    }).format(count2, unit) : intlCache.numberFormat(currentLocale, {
      style: "unit",
      unit,
      unitDisplay: minimal ? "short" : "long"
    }).format(Math.abs(count2));
  }, $[4] = currentLocale, $[5] = minimal, $[6] = useTemporalPhrase, $[7] = t3) : t3 = $[7];
  const format2 = t3;
  if (!parsedDate.getTime()) {
    let t42;
    return $[8] === Symbol.for("react.memo_cache_sentinel") ? (t42 = {
      timestamp: "",
      refreshInterval: null
    }, $[8] = t42) : t42 = $[8], t42;
  }
  const diffMonths = differenceInMonths(now, parsedDate), diffYears = differenceInYears(now, parsedDate);
  if (diffMonths || diffYears) {
    if (minimal && diffYears === 0) {
      let t43;
      $[9] !== currentLocale || $[10] !== parsedDate || $[11] !== timeZone ? (t43 = intlCache.dateTimeFormat(currentLocale, {
        ...NO_YEAR_DATE_ONLY_FORMAT,
        timeZone
      }).format(parsedDate), $[9] = currentLocale, $[10] = parsedDate, $[11] = timeZone, $[12] = t43) : t43 = $[12];
      let t53;
      return $[13] !== t43 ? (t53 = {
        timestamp: t43,
        refreshInterval: null
      }, $[13] = t43, $[14] = t53) : t53 = $[14], t53;
    }
    if (minimal) {
      let t43;
      $[15] !== currentLocale || $[16] !== parsedDate || $[17] !== timeZone ? (t43 = intlCache.dateTimeFormat(currentLocale, {
        ...DATE_ONLY_FORMAT,
        timeZone
      }).format(parsedDate), $[15] = currentLocale, $[16] = parsedDate, $[17] = timeZone, $[18] = t43) : t43 = $[18];
      let t53;
      return $[19] !== t43 ? (t53 = {
        timestamp: t43,
        refreshInterval: null
      }, $[19] = t43, $[20] = t53) : t53 = $[20], t53;
    }
    let t42;
    $[21] !== currentLocale || $[22] !== parsedDate || $[23] !== timeZone ? (t42 = intlCache.dateTimeFormat(currentLocale, {
      ...FULL_DATE_FORMAT,
      timeZone
    }).format(parsedDate), $[21] = currentLocale, $[22] = parsedDate, $[23] = timeZone, $[24] = t42) : t42 = $[24];
    let t52;
    return $[25] !== t42 ? (t52 = {
      timestamp: t42,
      refreshInterval: null
    }, $[25] = t42, $[26] = t52) : t52 = $[26], t52;
  }
  let t4;
  if ($[27] !== format2 || $[28] !== now || $[29] !== parsedDate) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const diffWeeks = differenceInWeeks(parsedDate, now);
      if (diffWeeks) {
        t4 = {
          timestamp: format2(diffWeeks, "week"),
          refreshInterval: ONE_HOUR
        };
        break bb0;
      }
    }
    $[27] = format2, $[28] = now, $[29] = parsedDate, $[30] = t4;
  } else
    t4 = $[30];
  if (t4 !== Symbol.for("react.early_return_sentinel"))
    return t4;
  let t5;
  if ($[31] !== format2 || $[32] !== now || $[33] !== parsedDate) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb1: {
      const diffDays = differenceInDays(parsedDate, now);
      if (diffDays) {
        t5 = {
          timestamp: format2(diffDays, "day"),
          refreshInterval: ONE_HOUR
        };
        break bb1;
      }
    }
    $[31] = format2, $[32] = now, $[33] = parsedDate, $[34] = t5;
  } else
    t5 = $[34];
  if (t5 !== Symbol.for("react.early_return_sentinel"))
    return t5;
  let t6;
  if ($[35] !== format2 || $[36] !== now || $[37] !== parsedDate) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb2: {
      const diffHours = differenceInHours(parsedDate, now);
      if (diffHours) {
        t6 = {
          timestamp: format2(diffHours, "hour"),
          refreshInterval: ONE_MINUTE
        };
        break bb2;
      }
    }
    $[35] = format2, $[36] = now, $[37] = parsedDate, $[38] = t6;
  } else
    t6 = $[38];
  if (t6 !== Symbol.for("react.early_return_sentinel"))
    return t6;
  let t7;
  if ($[39] !== format2 || $[40] !== now || $[41] !== parsedDate) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb3: {
      const diffMins = differenceInMinutes(parsedDate, now);
      if (diffMins) {
        t7 = {
          timestamp: format2(diffMins, "minute"),
          refreshInterval: TWENTY_SECONDS
        };
        break bb3;
      }
    }
    $[39] = format2, $[40] = now, $[41] = parsedDate, $[42] = t7;
  } else
    t7 = $[42];
  if (t7 !== Symbol.for("react.early_return_sentinel"))
    return t7;
  let t8;
  if ($[43] !== format2 || $[44] !== now || $[45] !== parsedDate) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb4: {
      const diffSeconds = differenceInSeconds(parsedDate, now);
      if (Math.abs(diffSeconds) > 10) {
        t8 = {
          timestamp: format2(diffSeconds, "second"),
          refreshInterval: FIVE_SECONDS
        };
        break bb4;
      }
    }
    $[43] = format2, $[44] = now, $[45] = parsedDate, $[46] = t8;
  } else
    t8 = $[46];
  if (t8 !== Symbol.for("react.early_return_sentinel"))
    return t8;
  let t9;
  $[47] !== t ? (t9 = t("relative-time.just-now"), $[47] = t, $[48] = t9) : t9 = $[48];
  let t10;
  return $[49] !== t9 ? (t10 = {
    timestamp: t9,
    refreshInterval: FIVE_SECONDS
  }, $[49] = t9, $[50] = t10) : t10 = $[50], t10;
}
function RelativeTime(t0) {
  const $ = c(10);
  let options, time;
  $[0] !== t0 ? ({
    time,
    ...options
  } = t0, $[0] = t0, $[1] = options, $[2] = time) : (options = $[1], time = $[2]);
  let t1;
  $[3] !== time ? (t1 = time instanceof Date ? time : new Date(time), $[3] = time, $[4] = t1) : t1 = $[4];
  const timestamp = t1, timeAgo = useRelativeTime(timestamp, options);
  let t2;
  $[5] !== timestamp ? (t2 = timestamp.toISOString(), $[5] = timestamp, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== t2 || $[8] !== timeAgo ? (t3 = /* @__PURE__ */ jsx("time", { dateTime: t2, title: timeAgo, children: timeAgo }), $[7] = t2, $[8] = timeAgo, $[9] = t3) : t3 = $[9], t3;
}
const AvatarSkeleton$1 = styled(Skeleton)((props2) => {
  const theme = getTheme_v2(props2.theme), size = props2.$size ?? 1;
  return css`
    border-radius: 50%;
    width: ${theme.avatar.sizes[size].size}px;
    height: ${theme.avatar.sizes[size].size}px;
  `;
}), symbols = /[^\p{Alpha}\p{White_Space}]/gu, whitespace = new RegExp("\\p{White_Space}+", "u"), LEGACY_TO_UI_AVATAR_SIZES = {
  small: 0,
  medium: 1,
  large: 2
};
function nameToInitials$1(fullName) {
  const namesArray = fullName.replace(symbols, "").split(whitespace);
  return namesArray.length === 1 ? `${namesArray[0].charAt(0)}`.toUpperCase() : `${namesArray[0].charAt(0)}${namesArray[namesArray.length - 1].charAt(0)}`;
}
function UserAvatar(props2) {
  const $ = c(13);
  let restProps, user, withTooltip;
  if ($[0] !== props2 ? ({
    user,
    withTooltip,
    ...restProps
  } = props2, $[0] = props2, $[1] = restProps, $[2] = user, $[3] = withTooltip) : (restProps = $[1], user = $[2], withTooltip = $[3]), isRecord$4(user)) {
    if (withTooltip) {
      const t03 = user;
      let t13;
      return $[4] !== restProps || $[5] !== t03 ? (t13 = /* @__PURE__ */ jsx(TooltipUserAvatar, { ...restProps, user: t03 }), $[4] = restProps, $[5] = t03, $[6] = t13) : t13 = $[6], t13;
    }
    const t02 = user;
    let t12;
    return $[7] !== restProps || $[8] !== t02 ? (t12 = /* @__PURE__ */ jsx(StaticUserAvatar, { ...restProps, user: t02 }), $[7] = restProps, $[8] = t02, $[9] = t12) : t12 = $[9], t12;
  }
  const t0 = user;
  let t1;
  return $[10] !== props2 || $[11] !== t0 ? (t1 = /* @__PURE__ */ jsx(UserAvatarLoader, { ...props2, user: t0 }), $[10] = props2, $[11] = t0, $[12] = t1) : t1 = $[12], t1;
}
function TooltipUserAvatar(props2) {
  const $ = c(6), {
    user: t0
  } = props2, {
    displayName
  } = t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    display: "inline-block"
  }, $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== props2 ? (t2 = /* @__PURE__ */ jsx("div", { style: t1, children: /* @__PURE__ */ jsx(StaticUserAvatar, { ...props2 }) }), $[1] = props2, $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== displayName || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content: displayName, placement: "top", portal: !0, children: t2 }), $[3] = displayName, $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}
const StaticUserAvatar = forwardRef(function(props2, ref) {
  const $ = c(22);
  let animateArrowFrom, position, restProps, size, status, tone, user;
  $[0] !== props2 ? ({
    user,
    animateArrowFrom,
    position,
    size,
    status,
    tone,
    ...restProps
  } = props2, $[0] = props2, $[1] = animateArrowFrom, $[2] = position, $[3] = restProps, $[4] = size, $[5] = status, $[6] = tone, $[7] = user) : (animateArrowFrom = $[1], position = $[2], restProps = $[3], size = $[4], status = $[5], tone = $[6], user = $[7]);
  const [imageLoadError, setImageLoadError] = useState(null), userColor = useUserColor(user.id), imageUrl = imageLoadError ? void 0 : user?.imageUrl;
  let t0;
  $[8] !== user.displayName ? (t0 = user?.displayName && nameToInitials$1(user.displayName), $[8] = user.displayName, $[9] = t0) : t0 = $[9];
  const t1 = typeof size == "string" ? LEGACY_TO_UI_AVATAR_SIZES[size] : size, t2 = user?.displayName;
  let t3;
  return $[10] !== animateArrowFrom || $[11] !== imageUrl || $[12] !== position || $[13] !== ref || $[14] !== restProps || $[15] !== status || $[16] !== t0 || $[17] !== t1 || $[18] !== t2 || $[19] !== tone || $[20] !== userColor.name ? (t3 = /* @__PURE__ */ jsx(Avatar, { __unstable_hideInnerStroke: !0, animateArrowFrom, arrowPosition: position, color: userColor.name, "data-legacy-tone": tone, initials: t0, src: imageUrl, onImageLoadError: setImageLoadError, ref, size: t1, status, title: t2, ...restProps }), $[10] = animateArrowFrom, $[11] = imageUrl, $[12] = position, $[13] = ref, $[14] = restProps, $[15] = status, $[16] = t0, $[17] = t1, $[18] = t2, $[19] = tone, $[20] = userColor.name, $[21] = t3) : t3 = $[21], t3;
});
function UserAvatarLoader(t0) {
  const $ = c(10);
  let loadedProps, user;
  $[0] !== t0 ? ({
    user,
    ...loadedProps
  } = t0, $[0] = t0, $[1] = loadedProps, $[2] = user) : (loadedProps = $[1], user = $[2]);
  const [value, loading] = useUser(user);
  if (loading) {
    let t12;
    return $[3] !== loadedProps.size ? (t12 = /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: loadedProps.size, animated: !0 }), $[3] = loadedProps.size, $[4] = t12) : t12 = $[4], t12;
  }
  if (!value) {
    let t12;
    return $[5] !== loadedProps.size ? (t12 = /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: loadedProps.size, animated: !1 }), $[5] = loadedProps.size, $[6] = t12) : t12 = $[6], t12;
  }
  let t1;
  return $[7] !== loadedProps || $[8] !== value ? (t1 = /* @__PURE__ */ jsx(UserAvatar, { ...loadedProps, user: value }), $[7] = loadedProps, $[8] = value, $[9] = t1) : t1 = $[9], t1;
}
function useDateTimeFormat(t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, currentLocale = useCurrentLocale().id;
  let t2;
  return $[2] !== currentLocale || $[3] !== options ? (t2 = intlCache.dateTimeFormat(currentLocale, options), $[2] = currentLocale, $[3] = options, $[4] = t2) : t2 = $[4], t2;
}
const FIELDS_TO_GROUP = ["title", "status", "assignedTo", "dueBy", "target", "description"];
function groupChanges(changes) {
  const groupedChanges = [];
  for (const change of changes) {
    const lastChangeProcessed = groupedChanges[groupedChanges.length - 1];
    if (!lastChangeProcessed) {
      groupedChanges.push(change);
      continue;
    }
    if (!FIELDS_TO_GROUP.includes(change.field)) {
      groupedChanges.push(change);
      continue;
    }
    if (lastChangeProcessed.author === change.author && lastChangeProcessed.field === change.field) {
      const lastChangeDate = new Date(lastChangeProcessed.timestamp), changeDate = new Date(change.timestamp);
      if (Math.abs(lastChangeDate.getTime() - changeDate.getTime()) <= 12e4) {
        lastChangeProcessed.to = change.to, lastChangeProcessed.timestamp = change.timestamp;
        continue;
      }
    }
    groupedChanges.push(change);
  }
  return groupedChanges;
}
function omitRev$1(document2) {
  const {
    _rev,
    ...doc
  } = document2;
  return doc;
}
function trackFieldChanges(newestDocument, transactions, fieldsToTrack) {
  let currentDocument = omitRev$1(newestDocument);
  const changes = [];
  let previousDocument = currentDocument;
  for (const transaction of transactions) {
    const {
      timestamp,
      effects
    } = transaction, documentId = transaction.documentIDs[0], effect = effects[documentId];
    !effect || !effect.revert || (previousDocument = applyPatch$1(currentDocument, effect.revert), fieldsToTrack.forEach((field) => {
      previousDocument?.[field] !== currentDocument?.[field] && changes.push({
        field,
        from: previousDocument?.[field],
        to: currentDocument?.[field],
        timestamp,
        author: transaction.author
      });
    }), currentDocument = previousDocument);
  }
  const changesSortedByTimestamp = changes.sort((a, b) => a.timestamp.localeCompare(b.timestamp)), createdByUserIndex = changesSortedByTimestamp.findIndex((change) => change.field === "createdByUser");
  return groupChanges(changesSortedByTimestamp.slice(createdByUserIndex + 1));
}
const API_VERSION$3 = "2024-03-05", TASK_STATUS = [{
  value: "open",
  title: "To Do",
  icon: /* @__PURE__ */ jsx(CircleIcon, {})
}, {
  value: "closed",
  title: "Done",
  icon: /* @__PURE__ */ jsx(CheckmarkCircleIcon, {})
}];
function useActivityLog(task) {
  const $ = c(17);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [changes, setChanges] = useState(t0);
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    apiVersion: API_VERSION$3
  }, $[1] = t1) : t1 = $[1];
  const client = useClient(t1), t2 = task?._id ?? "";
  let t3;
  $[2] !== t2 ? (t3 = getPublishedId(t2), $[2] = t2, $[3] = t3) : t3 = $[3];
  const publishedId = t3;
  let t4;
  $[4] !== client || $[5] !== publishedId ? (t4 = async (newestTaskDocument) => {
    try {
      if (!publishedId)
        return;
      const transactions = await getTransactionsLogs(client, publishedId, {
        tag: "sanity.studio.tasks.history",
        effectFormat: "mendoza",
        reverse: !0
      }), fieldsToTrack = ["createdByUser", "title", "description", "dueBy", "assignedTo", "status", "target"], parsedChanges = await trackFieldChanges(newestTaskDocument, [...transactions], fieldsToTrack);
      setChanges(parsedChanges);
    } catch (t52) {
      console.error("Failed to fetch and parse activity log", t52);
    }
  }, $[4] = client, $[5] = publishedId, $[6] = t4) : t4 = $[6];
  const fetchAndParse = t4;
  let t5;
  $[7] !== fetchAndParse || $[8] !== task ? (t5 = (rev) => fetchAndParse(task), $[7] = fetchAndParse, $[8] = task, $[9] = t5) : t5 = $[9];
  const handleFetchAndParse = useEffectEvent(t5);
  let t6;
  $[10] !== handleFetchAndParse || $[11] !== task._rev ? (t6 = () => {
    handleFetchAndParse(task._rev);
  }, $[10] = handleFetchAndParse, $[11] = task._rev, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== task._rev ? (t7 = [task._rev], $[13] = task._rev, $[14] = t7) : t7 = $[14], useEffect(t6, t7);
  let t8;
  return $[15] !== changes ? (t8 = {
    changes
  }, $[15] = changes, $[16] = t8) : t8 = $[16], t8;
}
function useDocumentPreviewValues(options) {
  const {
    documentId,
    documentType
  } = options || {}, schemaType = useSchema().get(documentType), documentPreviewStore = useDocumentPreviewStore(), previewStateObservable = useMemo(() => !documentId || !schemaType ? of(null) : getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId), [documentId, documentPreviewStore, schemaType]), previewState = useObservable(previewStateObservable), isLoading = previewState?.isLoading ?? !0, {
    snapshot: snapshot2
  } = previewState || {}, documentTitle = snapshot2?.title, subtitle = snapshot2?.subtitle, description = snapshot2?.description, media = snapshot2?.media;
  return {
    isLoading,
    value: {
      title: documentTitle,
      subtitle,
      media,
      description
    }
  };
}
function useTaskOperations() {
  const {
    client,
    createAddonDataset
  } = useAddonDataset(), currentUser = useCurrentUser(), handleCreate = useCallback(async (payload) => {
    if (!currentUser)
      throw new Error("No current user found. Unable to create task.");
    const task = {
      ...payload,
      authorId: currentUser.id,
      _type: "tasks.task"
    };
    if (!client)
      try {
        const newCreatedClient = await createAddonDataset();
        if (!newCreatedClient) throw new Error("No addon client found. Unable to create task.");
        return await newCreatedClient.create(task);
      } catch (err) {
        throw err;
      }
    try {
      return await client.create(task);
    } catch (err_0) {
      throw err_0;
    }
  }, [client, createAddonDataset, currentUser]), handleEdit = useCallback(async (id2, set2) => {
    try {
      if (!client)
        throw new Error("No client. Unable to create task.");
      return await client.patch(id2).set(set2).commit();
    } catch (e) {
      throw e;
    }
  }, [client]), handleRemove = useCallback(async (id_0) => {
    try {
      if (!client)
        throw new Error("No client. Unable to create task.");
      await client.delete(id_0);
    } catch (e_0) {
      throw e_0;
    }
  }, [client]);
  return useMemo(() => ({
    create: handleCreate,
    edit: handleEdit,
    remove: handleRemove
  }), [handleCreate, handleEdit, handleRemove]);
}
function useRemoveTask({
  id: id2,
  onError,
  onRemoved
}) {
  const [removeStatus, setRemoveStatus] = useState("idle"), [showDialog, setShowDialog] = useState(!1), [error, setError] = useState(null), operations = useTaskOperations(), handleRemove = useCallback(async () => {
    try {
      setRemoveStatus("loading"), await operations.remove(id2), onRemoved?.(), setRemoveStatus("idle"), await new Promise((resolve) => setTimeout(resolve, 300)), setShowDialog(!1);
    } catch (e) {
      onError?.(e.message), setError(e.message), setRemoveStatus("error");
    } finally {
      setRemoveStatus("idle");
    }
  }, [id2, operations, onError, onRemoved]), handleOpenDialog = useCallback(() => {
    setShowDialog(!0);
  }, [setShowDialog]), handleCloseDialog = useCallback(() => {
    setShowDialog(!1);
  }, [setShowDialog]);
  return {
    removeStatus,
    showDialog,
    error,
    handleRemove,
    handleOpenDialog,
    handleCloseDialog
  };
}
const _previewComponents = {
  block: BlockPreview,
  blockImage: BlockImagePreview,
  compact: CompactPreview,
  default: DefaultPreview,
  detail: DetailPreview,
  inline: InlinePreview,
  media: MediaPreview
};
function FallbackIcon() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(DocumentIcon, { className: "sanity-studio__preview-fallback-icon" }), $[0] = t0) : t0 = $[0], t0;
}
const SanityDefaultPreview = memo(function(props2) {
  const $ = c(33);
  let Icon2, imageUrl, layout, mediaProp, restProps, title, tooltip;
  $[0] !== props2 ? ({
    icon: Icon2,
    layout,
    media: mediaProp,
    imageUrl,
    title,
    tooltip,
    ...restProps
  } = props2, $[0] = props2, $[1] = Icon2, $[2] = imageUrl, $[3] = layout, $[4] = mediaProp, $[5] = restProps, $[6] = title, $[7] = tooltip) : (Icon2 = $[1], imageUrl = $[2], layout = $[3], mediaProp = $[4], restProps = $[5], title = $[6], tooltip = $[7]);
  const client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0, t1;
  $[8] !== client ? (t1 = imageUrlBuilder(client), $[8] = client, $[9] = t1) : t1 = $[9], t0 = t1;
  const imageBuilder = t0;
  let t2;
  $[10] !== imageBuilder || $[11] !== mediaProp || $[12] !== title ? (t2 = (options) => {
    const {
      dimensions
    } = options, width = dimensions.width || 100, height = dimensions.height || 100;
    return /* @__PURE__ */ jsx("img", { alt: isString(title) ? title : void 0, referrerPolicy: "strict-origin-when-cross-origin", src: imageBuilder.image(mediaProp).width(width).height(height).fit(dimensions.fit).dpr(dimensions.dpr || 1).url() || "" });
  }, $[10] = imageBuilder, $[11] = mediaProp, $[12] = title, $[13] = t2) : t2 = $[13];
  const renderMedia2 = t2;
  let t3;
  $[14] !== Icon2 ? (t3 = () => Icon2 ? /* @__PURE__ */ jsx(Icon2, {}) : /* @__PURE__ */ jsx(FallbackIcon, {}), $[14] = Icon2, $[15] = t3) : t3 = $[15];
  const renderIcon = t3;
  let t4;
  bb0: {
    if (Icon2 === !1) {
      t4 = !1;
      break bb0;
    }
    if (isValidElementType(mediaProp)) {
      t4 = mediaProp;
      break bb0;
    }
    if (isValidElement(mediaProp)) {
      t4 = mediaProp;
      break bb0;
    }
    if (isImageSource(mediaProp)) {
      t4 = renderMedia2;
      break bb0;
    }
    if (isString(imageUrl)) {
      const t52 = isString(title) ? title : void 0;
      let t62;
      $[16] !== imageUrl || $[17] !== t52 ? (t62 = /* @__PURE__ */ jsx("img", { src: imageUrl, alt: t52, referrerPolicy: "strict-origin-when-cross-origin" }), $[16] = imageUrl, $[17] = t52, $[18] = t62) : t62 = $[18], t4 = t62;
      break bb0;
    }
    t4 = renderIcon;
  }
  const media = t4;
  let t5;
  const t6 = media;
  let t7;
  $[19] !== restProps || $[20] !== t6 || $[21] !== title ? (t7 = {
    ...restProps,
    media: t6,
    title
  }, $[19] = restProps, $[20] = t6, $[21] = title, $[22] = t7) : t7 = $[22], t5 = t7;
  const previewProps = t5, LayoutComponent = _previewComponents[layout || "default"];
  let t8;
  $[23] !== LayoutComponent || $[24] !== previewProps ? (t8 = /* @__PURE__ */ jsx(LayoutComponent, { ...previewProps }), $[23] = LayoutComponent, $[24] = previewProps, $[25] = t8) : t8 = $[25];
  const children = t8;
  if (tooltip) {
    const t9 = !tooltip;
    let t10;
    $[26] === Symbol.for("react.memo_cache_sentinel") ? (t10 = ["top-end", "bottom-end"], $[26] = t10) : t10 = $[26];
    let t11;
    $[27] !== children ? (t11 = /* @__PURE__ */ jsx("div", { children }), $[27] = children, $[28] = t11) : t11 = $[28];
    let t12;
    return $[29] !== t11 || $[30] !== t9 || $[31] !== tooltip ? (t12 = /* @__PURE__ */ jsx(Tooltip, { content: tooltip, disabled: t9, fallbackPlacements: t10, placement: "right", children: t11 }), $[29] = t11, $[30] = t9, $[31] = tooltip, $[32] = t12) : t12 = $[32], t12;
  }
  return children;
});
SanityDefaultPreview.displayName = "Memo(SanityDefaultPreview)";
const initial$1 = [], fallback$1 = of(initial$1);
function useDocumentPresence(documentId) {
  const $ = c(6), [mounted, mount] = useReducer(_temp$2r, !1);
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => startTransition(mount), t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  const presenceStore = usePresenceStore();
  let t2;
  return $[2] !== documentId || $[3] !== mounted || $[4] !== presenceStore ? (t2 = mounted ? presenceStore.documentPresence(documentId) : fallback$1, $[2] = documentId, $[3] = mounted, $[4] = presenceStore, $[5] = t2) : t2 = $[5], useObservable(t2, initial$1);
}
function _temp$2r() {
  return !0;
}
const isArchivedRelease = (releaseState) => releaseState === "archived" || releaseState === "archiving" || releaseState === "unarchiving";
function ReleaseDocumentPreview(t0) {
  const $ = c(24), {
    documentId,
    documentTypeName,
    releaseId,
    previewValues,
    isLoading,
    releaseState,
    documentRevision,
    layout
  } = t0, documentPresence = useDocumentPresence(documentId);
  let t1;
  bb0: {
    if (releaseState === "published") {
      const t23 = `@release:${getReleaseIdFromReleaseDocumentId(releaseId)}`;
      let t32;
      $[0] !== t23 ? (t32 = {
        rev: t23,
        inspect: "sanity/structure/history"
      }, $[0] = t23, $[1] = t32) : t32 = $[1], t1 = t32;
      break bb0;
    }
    if (releaseState === "archived") {
      let t23;
      $[2] !== releaseId ? (t23 = getReleaseIdFromReleaseDocumentId(releaseId), $[2] = releaseId, $[3] = t23) : t23 = $[3];
      let t32;
      $[4] !== documentRevision || $[5] !== t23 ? (t32 = {
        rev: "@lastEdited",
        inspect: "sanity/structure/history",
        historyEvent: documentRevision,
        historyVersion: t23,
        archivedRelease: "true"
      }, $[4] = documentRevision, $[5] = t23, $[6] = t32) : t32 = $[6], t1 = t32;
      break bb0;
    }
    let t22;
    $[7] === Symbol.for("react.memo_cache_sentinel") ? (t22 = {}, $[7] = t22) : t22 = $[7], t1 = t22;
  }
  const intentParams = t1;
  let t2, t3;
  $[8] !== documentId || $[9] !== documentTypeName || $[10] !== intentParams || $[11] !== releaseId || $[12] !== releaseState ? (t3 = forwardRef(function(linkProps, ref) {
    return /* @__PURE__ */ jsx(IntentLink, { ...linkProps, intent: "edit", params: {
      id: getPublishedId(documentId),
      type: documentTypeName,
      ...intentParams
    }, searchParams: isArchivedRelease(releaseState) ? void 0 : [["perspective", releaseState === "published" ? "published" : getReleaseIdFromReleaseDocumentId(releaseId)]], ref });
  }), $[8] = documentId, $[9] = documentTypeName, $[10] = intentParams, $[11] = releaseId, $[12] = releaseState, $[13] = t3) : t3 = $[13], t2 = t3;
  const LinkComponent2 = t2;
  let t4, t5;
  $[14] !== documentPresence ? (t5 = documentPresence?.length > 0 && /* @__PURE__ */ jsx(DocumentPreviewPresence, { presence: documentPresence }), $[14] = documentPresence, $[15] = t5) : t5 = $[15], t4 = t5;
  const previewPresence = t4;
  let t6;
  $[16] !== isLoading || $[17] !== layout || $[18] !== previewPresence || $[19] !== previewValues ? (t6 = /* @__PURE__ */ jsx(SanityDefaultPreview, { ...previewValues, status: previewPresence, isPlaceholder: isLoading, layout }), $[16] = isLoading, $[17] = layout, $[18] = previewPresence, $[19] = previewValues, $[20] = t6) : t6 = $[20];
  let t7;
  return $[21] !== LinkComponent2 || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsx(Card, { tone: "inherit", as: LinkComponent2, radius: 2, "data-as": "a", children: t6 }), $[21] = LinkComponent2, $[22] = t6, $[23] = t7) : t7 = $[23], t7;
}
const StatusText$1 = styled(Text$1)`
  strong {
    font-weight: 500;
    color: var(--card-fg-color);
  }
  time {
    white-space: nowrap;
  }
`, ACTIVITY_TEXT_118N = {
  addDocumentToRelease: "activity.event.add-document",
  archiveRelease: "activity.event.archive",
  createRelease: "activity.event.create",
  discardDocumentFromRelease: "activity.event.discard-document",
  publishRelease: "activity.event.publish",
  scheduleRelease: "activity.event.schedule",
  unarchiveRelease: "activity.event.unarchive",
  unscheduleRelease: "activity.event.unschedule",
  editRelease: "activity.event.edit"
}, ReleaseEventDocumentPreview = (t0) => {
  const $ = c(11), {
    event,
    releaseId
  } = t0;
  let t1;
  $[0] !== event.documentId || $[1] !== event.documentType ? (t1 = {
    documentId: event.documentId,
    documentType: event.documentType
  }, $[0] = event.documentId, $[1] = event.documentType, $[2] = t1) : t1 = $[2];
  const {
    value,
    isLoading
  } = useDocumentPreviewValues(t1);
  let t2;
  $[3] !== value ? (t2 = {
    ...value,
    subtitle: ""
  }, $[3] = value, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== event.documentId || $[6] !== event.documentType || $[7] !== isLoading || $[8] !== releaseId || $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(Stack, { space: 2, children: /* @__PURE__ */ jsx(ReleaseDocumentPreview, { releaseId, documentId: event.documentId, documentTypeName: event.documentType, isLoading, previewValues: t2, layout: "block" }) }), $[5] = event.documentId, $[6] = event.documentType, $[7] = isLoading, $[8] = releaseId, $[9] = t2, $[10] = t3) : t3 = $[10], t3;
}, ScheduleTarget = (t0) => {
  const $ = c(13), {
    children,
    event
  } = t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    dateStyle: "full",
    timeStyle: "medium"
  }, $[0] = t1) : t1 = $[0];
  const dateTimeFormat = useDateTimeFormat(t1), {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t2;
  bb0: {
    if (isEditReleaseEvent(event)) {
      if (event.change.releaseType === "asap") {
        let t33;
        $[1] !== t ? (t33 = t("activity.event.edit-time-asap"), $[1] = t, $[2] = t33) : t33 = $[2], t2 = t33;
        break bb0;
      }
      if (event.change.releaseType === "undecided") {
        let t33;
        $[3] !== t ? (t33 = t("activity.event.edit-time-undecided"), $[3] = t, $[4] = t33) : t33 = $[4], t2 = t33;
        break bb0;
      }
    }
    let dateString;
    if (isScheduleReleaseEvent(event) ? dateString = event.publishAt : isCreateReleaseEvent(event) ? dateString = event.change?.intendedPublishDate : isEditReleaseEvent(event) && (dateString = event.change.intendedPublishDate), !dateString) {
      t2 = null;
      break bb0;
    }
    let t32;
    $[5] !== dateString || $[6] !== dateTimeFormat ? (t32 = dateTimeFormat.format(new Date(dateString)), $[5] = dateString, $[6] = dateTimeFormat, $[7] = t32) : t32 = $[7], t2 = t32;
  }
  const formattedDate = t2;
  if (!formattedDate && isCreateReleaseEvent(event))
    return null;
  const t3 = formattedDate || "---";
  let t4;
  $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx("strong", { children: t3 }), $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== children || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsxs("span", { children: [
    children,
    " ",
    t4
  ] }), $[10] = children, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}, FadeInCard = motion.create(Card), ReleaseActivityListItem = memo((t0) => {
  const $ = c(28), {
    event,
    releaseId,
    releaseTitle
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1, t2, t3;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    opacity: 0
  }, t2 = {
    opacity: 1
  }, t3 = {
    type: "spring",
    bounce: 0,
    duration: 0.4
  }, $[0] = t1, $[1] = t2, $[2] = t3) : (t1 = $[0], t2 = $[1], t3 = $[2]);
  let t4;
  $[3] !== event.author ? (t4 = /* @__PURE__ */ jsx(UserAvatar, { user: event.author }), $[3] = event.author, $[4] = t4) : t4 = $[4];
  let t5;
  $[5] !== event ? (t5 = {
    ScheduleTarget: (t62) => {
      const {
        children
      } = t62;
      return /* @__PURE__ */ jsx(ScheduleTarget, { event, children });
    }
  }, $[5] = event, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== releaseTitle ? (t6 = {
    releaseTitle
  }, $[7] = releaseTitle, $[8] = t6) : t6 = $[8];
  const t7 = ACTIVITY_TEXT_118N[event.type];
  let t8;
  $[9] !== t || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 ? (t8 = /* @__PURE__ */ jsx(Translate, { t, components: t5, values: t6, i18nKey: t7 }), $[9] = t, $[10] = t5, $[11] = t6, $[12] = t7, $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== event.timestamp ? (t9 = /* @__PURE__ */ jsx(RelativeTime, { time: event.timestamp, useTemporalPhrase: !0, minimal: !0 }), $[14] = event.timestamp, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== t8 || $[17] !== t9 ? (t10 = /* @__PURE__ */ jsx(Flex, { gap: 2, paddingY: 2, children: /* @__PURE__ */ jsxs(StatusText$1, { muted: !0, size: 1, children: [
    t8,
    " ",
    "\xB7 ",
    t9
  ] }) }), $[16] = t8, $[17] = t9, $[18] = t10) : t10 = $[18];
  let t11;
  $[19] !== event || $[20] !== releaseId ? (t11 = isAddDocumentToReleaseEvent(event) || isDiscardDocumentFromReleaseEvent(event) ? /* @__PURE__ */ jsx(ReleaseEventDocumentPreview, { event, releaseId }) : null, $[19] = event, $[20] = releaseId, $[21] = t11) : t11 = $[21];
  let t12;
  $[22] !== t10 || $[23] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Stack, { flex: 1, children: [
    t10,
    t11
  ] }), $[22] = t10, $[23] = t11, $[24] = t12) : t12 = $[24];
  let t13;
  return $[25] !== t12 || $[26] !== t4 ? (t13 = /* @__PURE__ */ jsx(FadeInCard, { paddingX: 1, paddingTop: 1, paddingBottom: 2, overflow: "hidden", initial: t1, animate: t2, transition: t3, children: /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 2, children: [
    t4,
    t12
  ] }) }), $[25] = t12, $[26] = t4, $[27] = t13) : t13 = $[27], t13;
}, (prevProps, nextProps) => prevProps.event.id === nextProps.event.id && prevProps.releaseId === nextProps.releaseId);
ReleaseActivityListItem.displayName = "ReleaseActivityListItem";
const estimateSize = (event) => event ? isAddDocumentToReleaseEvent(event) || isDiscardDocumentFromReleaseEvent(event) ? 70 : 56 : 40, VirtualContainer = styled(Box)`
  height: 100%;
  overflow: scroll;
`, ReleaseActivityList = ({
  events: events2,
  releaseTitle,
  releaseId,
  hasMore,
  loadMore,
  isLoading
}) => {
  const virtualizerContainerRef = useRef(null), listEvents = useMemo(() => {
    if (!hasMore && !isLoading) return events2;
    const lastEventFromEventsAPI = [...events2].reverse().find(isEventsAPIEvent);
    if (!lastEventFromEventsAPI && !isLoading) return events2;
    if (!lastEventFromEventsAPI) return [];
    const lastEventDate = new Date(lastEventFromEventsAPI.timestamp);
    return events2.filter((event) => isTranslogEvent(event) ? new Date(event.timestamp) > lastEventDate : !0);
  }, [events2, hasMore, isLoading]), virtualizer = useVirtualizer({
    // If we have more events, or the events are loading, we add a loader row at the end
    count: hasMore || isLoading ? listEvents.length + 1 : listEvents.length,
    getScrollElement: () => virtualizerContainerRef.current,
    estimateSize: (i) => estimateSize(events2[i]),
    overscan: 10,
    paddingEnd: 24
  }), virtualItems = virtualizer.getVirtualItems();
  return useEffect(() => {
    const lastItem = virtualItems.at(-1);
    lastItem && lastItem.index >= listEvents.length - 1 && hasMore && loadMore();
  }, [listEvents.length, hasMore, loadMore, virtualItems]), /* @__PURE__ */ jsx(VirtualContainer, { id: "virtualizer-container", ref: virtualizerContainerRef, paddingX: 3, children: /* @__PURE__ */ jsx("div", { style: {
    height: `${virtualizer.getTotalSize()}px`,
    width: "100%",
    position: "relative"
  }, children: /* @__PURE__ */ jsx(AnimatePresence, { initial: !1, children: virtualizer.getVirtualItems().map((virtualRow) => {
    const event_0 = listEvents[virtualRow.index], isLoaderRow = !event_0;
    return /* @__PURE__ */ jsx("div", { "data-index": virtualRow.index, ref: virtualizer.measureElement, style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      transform: `translateY(${virtualRow.start}px)`
    }, children: isLoaderRow ? /* @__PURE__ */ jsx(Box, { paddingY: 4, children: /* @__PURE__ */ jsx(LoadingBlock, { fill: !0 }) }) : /* @__PURE__ */ jsx(ReleaseActivityListItem, { event: event_0, releaseId, releaseTitle }) }, virtualRow.key);
  }) }) }) });
}, MotionFlex$1 = motion.create(Flex), FillHeight = styled.div`
  --card-border-color: transparent;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
function ReleaseDashboardActivityPanel({
  events: events2,
  release,
  show
}) {
  const {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation();
  return /* @__PURE__ */ jsx(AnimatePresence, { children: show && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(motion.div, { animate: {
    width: "auto",
    opacity: 1
  }, initial: {
    width: 0,
    opacity: 0
  }, exit: {
    width: 0,
    opacity: 0
  }, transition: {
    type: "spring",
    bounce: 0,
    duration: 0.2
  }, children: /* @__PURE__ */ jsx(Resizable, { as: FillHeight, minWidth: 320, maxWidth: 800, initialWidth: 320, resizerPosition: "left", style: {
    display: "flex",
    flexDirection: "column",
    flex: "none",
    maxHeight: "100%"
  }, children: /* @__PURE__ */ jsxs(MotionFlex$1, { flex: "none", height: "fill", direction: "column", children: [
    /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t("activity.panel.title") }) }),
    events2.error && !events2.events.length && /* @__PURE__ */ jsx(Card, { padding: 3, tone: "caution", children: /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 0, children: t("activity.panel.error") }) }) }),
    events2.loading && !events2.events.length && /* @__PURE__ */ jsx(LoadingBlock, { title: t("activity.panel.loading") }),
    /* @__PURE__ */ jsx(ReleaseActivityList, { releaseTitle: release.metadata.title || tCore("release.placeholder-untitled-release"), releaseId: release._id, events: events2.events, hasMore: events2.hasMore, loadMore: events2.loadMore, isLoading: events2.loading })
  ] }) }) }) }) });
}
const ToneIcon = (t0) => {
  const $ = c(5), {
    tone,
    icon: Icon2
  } = t0, t1 = `var(--card-badge-${tone}-icon-color)`;
  let t2;
  $[0] !== t1 ? (t2 = {
    "--card-icon-color": t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const t3 = t2;
  let t4;
  return $[2] !== Icon2 || $[3] !== t3 ? (t4 = /* @__PURE__ */ jsx(Icon2, { style: t3 }), $[2] = Icon2, $[3] = t3, $[4] = t4) : t4 = $[4], t4;
}, TextWithToneStyle = styled(Text$1)`
  &:not([data-muted]) {
    &[data-tone='default'] {
      --card-fg-color: var(--card-badge-default-fg-color);
    }
    &[data-tone='primary'] {
      --card-fg-color: var(--card-badge-primary-fg-color);
    }
    &[data-tone='positive'] {
      --card-fg-color: var(--card-badge-positive-fg-color);
    }
    &[data-tone='caution'] {
      --card-fg-color: var(--card-badge-caution-fg-color);
    }
    &[data-tone='critical'] {
      --card-fg-color: var(--card-badge-critical-fg-color);
    }
  }

  &[data-dimmed] {
    opacity: 0.3;
  }
`, TextWithTone = forwardRef(function(props2, ref) {
  const $ = c(12);
  let dimmed, muted, rest, tone;
  $[0] !== props2 ? ({
    tone,
    dimmed,
    muted,
    ...rest
  } = props2, $[0] = props2, $[1] = dimmed, $[2] = muted, $[3] = rest, $[4] = tone) : (dimmed = $[1], muted = $[2], rest = $[3], tone = $[4]);
  const t0 = dimmed ? "" : void 0, t1 = muted ? "" : void 0;
  let t2;
  return $[5] !== muted || $[6] !== ref || $[7] !== rest || $[8] !== t0 || $[9] !== t1 || $[10] !== tone ? (t2 = /* @__PURE__ */ jsx(TextWithToneStyle, { "data-ui": "TextWithTone", "data-dimmed": t0, "data-muted": t1, "data-tone": tone, muted, ref, ...rest }), $[5] = muted, $[6] = ref, $[7] = rest, $[8] = t0, $[9] = t1, $[10] = tone, $[11] = t2) : t2 = $[11], t2;
}), HeaderButton = styled.button`
  display: block;
  -webkit-font-smoothing: inherit;
  appearance: none;
  font: inherit;
  background: none;
  width: 100%;
  text-align: left;
  border: 0;
  margin: 0;
  padding: 0;
  outline: none;
`, ToggleArrow = styled(ToggleArrowRightIcon)`
  transform: ${(props2) => props2.open ? "rotate(90deg)" : ""};
`, Header$1 = styled(Flex)`
  cursor: default;
  line-height: 0;
`, IconBox$1 = styled(Flex)`
  & > div > svg {
    transform: rotate(0);
    transition: transform 100ms;
  }

  &[data-open] > div > svg {
    transform: rotate(90deg);
  }
`;
function Details(props2) {
  const $ = c(30);
  let children, icon, openProp, restProps, t0;
  $[0] !== props2 ? ({
    children,
    open: openProp,
    icon,
    title: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = icon, $[3] = openProp, $[4] = restProps, $[5] = t0) : (children = $[1], icon = $[2], openProp = $[3], restProps = $[4], t0 = $[5]);
  const title = t0 === void 0 ? "Details" : t0, [open, setOpen] = useState(openProp || !1);
  let t1;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setOpen(_temp$2q), $[6] = t1) : t1 = $[6];
  const handleToggle = t1;
  let t2, t3;
  $[7] !== openProp ? (t2 = () => setOpen(openProp || !1), t3 = [openProp], $[7] = openProp, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3);
  const t4 = open ? "" : void 0;
  let t5;
  $[10] !== open ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToggleArrow, { open }) }), $[10] = open, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t4 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(IconBox$1, { "data-open": t4, children: t5 }), $[12] = t4, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== icon ? (t7 = icon && /* @__PURE__ */ jsx(Box, { marginLeft: 1, children: icon }), $[15] = icon, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== title ? (t8 = /* @__PURE__ */ jsx(Box, { flex: 1, marginLeft: 1, children: /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", size: 1, weight: "medium", children: title }) }), $[17] = title, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t6 || $[20] !== t7 || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(HeaderButton, { type: "button", onClick: handleToggle, children: /* @__PURE__ */ jsx(Header$1, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t6,
    t7,
    t8
  ] }) }) }), $[19] = t6, $[20] = t7, $[21] = t8, $[22] = t9) : t9 = $[22];
  const t10 = !open;
  let t11;
  $[23] !== children || $[24] !== t10 ? (t11 = /* @__PURE__ */ jsx(Box, { hidden: t10, marginTop: 3, children }), $[23] = children, $[24] = t10, $[25] = t11) : t11 = $[25];
  let t12;
  return $[26] !== restProps || $[27] !== t11 || $[28] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Box, { ...restProps, children: [
    t9,
    t11
  ] }), $[26] = restProps, $[27] = t11, $[28] = t9, $[29] = t12) : t12 = $[29], t12;
}
function _temp$2q(v) {
  return !v;
}
const INITIAL_LOADING_STATE$4 = {
  error: null,
  projectSubscriptions: null,
  isLoading: !0
};
function fetchProjectSubscriptions({
  versionedClient: versionedClient2
}) {
  return versionedClient2.observable.request({
    uri: `/subscriptions/project/${versionedClient2.config().projectId}`,
    tag: "project-subscriptions"
  });
}
const cachedProjectSubscriptionsRequest = /* @__PURE__ */ new Map();
function useProjectSubscriptions() {
  const $ = c(4), versionedClient2 = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    projectId
  } = useSource();
  if (!cachedProjectSubscriptionsRequest.get(projectId)) {
    const projectSubscriptions = fetchProjectSubscriptions({
      versionedClient: versionedClient2
    }).pipe(shareReplay());
    cachedProjectSubscriptionsRequest.set(projectId, projectSubscriptions);
  }
  let t0;
  bb0: {
    let t1;
    if ($[0] !== projectId) {
      const projectSubscriptions$ = cachedProjectSubscriptionsRequest.get(projectId);
      if (!projectSubscriptions$) {
        let t2;
        $[3] === Symbol.for("react.memo_cache_sentinel") ? (t2 = of({
          isLoading: !1,
          error: null,
          projectSubscriptions: null
        }), $[3] = t2) : t2 = $[3], t0 = t2;
        break bb0;
      }
      t1 = projectSubscriptions$.pipe(map(_temp$2p), startWith(INITIAL_LOADING_STATE$4), catchError(_temp2$V)), $[0] = projectId, $[1] = t1, $[2] = t0;
    } else
      t1 = $[1], t0 = $[2];
    t0 = t1;
  }
  return useObservable(t0, INITIAL_LOADING_STATE$4);
}
function _temp2$V(error) {
  return of({
    isLoading: !1,
    projectSubscriptions: null,
    error
  });
}
function _temp$2p(cachedSubscriptions) {
  return {
    isLoading: !1,
    projectSubscriptions: cachedSubscriptions,
    error: null
  };
}
function ReleaseDetailsEditor(t0) {
  const $ = c(13), {
    release
  } = t0, {
    updateRelease
  } = useReleaseOperations(), [timer2, setTimer] = useState(void 0), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasUpdatePermission, setHasUpdatePermission] = useState(null);
  let t1;
  $[0] !== hasUpdatePermission || $[1] !== timer2 || $[2] !== updateRelease ? (t1 = (changedValue) => {
    clearTimeout(timer2);
    const newTimer = setTimeout(() => {
      hasUpdatePermission && updateRelease(changedValue);
    }, 200);
    setTimer(newTimer);
  }, $[0] = hasUpdatePermission, $[1] = timer2, $[2] = updateRelease, $[3] = t1) : t1 = $[3];
  const handleOnChange = t1, isMounted = useRef(!1);
  let t2, t3;
  $[4] !== checkWithPermissionGuard || $[5] !== release || $[6] !== updateRelease ? (t2 = () => (isMounted.current = !0, getIsReleaseOpen(release) && checkWithPermissionGuard(updateRelease, release).then((hasPermission) => {
    isMounted.current && setHasUpdatePermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), t3 = [checkWithPermissionGuard, release, release._id, updateRelease], $[4] = checkWithPermissionGuard, $[5] = release, $[6] = updateRelease, $[7] = t2, $[8] = t3) : (t2 = $[7], t3 = $[8]), useEffect(t2, t3);
  const t4 = release._id, t5 = !hasUpdatePermission;
  let t6;
  return $[9] !== handleOnChange || $[10] !== release || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(TitleDescriptionForm, { release, onChange: handleOnChange, disabled: t5 }, t4), $[9] = handleOnChange, $[10] = release, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
const useReleaseTime = () => {
  const $ = c(6), {
    timeZone,
    utcToCurrentZoneDate
  } = useTimeZone();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = getLocalTimeZone(), $[0] = t0) : t0 = $[0];
  const {
    abbreviation: localeTimeZoneAbbreviation
  } = t0;
  let t1;
  $[1] !== timeZone.abbreviation ? (t1 = () => timeZone.abbreviation === localeTimeZoneAbbreviation ? "" : `(${timeZone.abbreviation})`, $[1] = timeZone.abbreviation, $[2] = t1) : t1 = $[2];
  const getTimezoneAbbreviation = t1;
  let t2;
  return $[3] !== getTimezoneAbbreviation || $[4] !== utcToCurrentZoneDate ? (t2 = (release) => {
    const publishDate = getPublishDateFromRelease(release);
    return publishDate ? `${format$2(utcToCurrentZoneDate(publishDate), "PPpp")} ${getTimezoneAbbreviation()}` : null;
  }, $[3] = getTimezoneAbbreviation, $[4] = utcToCurrentZoneDate, $[5] = t2) : t2 = $[5], t2;
}, ReleaseTime = (t0) => {
  const $ = c(7), {
    release
  } = t0, {
    t
  } = useTranslation(), getReleaseTime = useReleaseTime(), {
    metadata
  } = release;
  if (metadata.releaseType === "asap") {
    let t12;
    return $[0] !== t ? (t12 = t("release.type.asap"), $[0] = t, $[1] = t12) : t12 = $[1], t12;
  }
  if (metadata.releaseType === "undecided") {
    let t12;
    return $[2] !== t ? (t12 = t("release.type.undecided"), $[2] = t, $[3] = t12) : t12 = $[3], t12;
  }
  let t1;
  return $[4] !== getReleaseTime || $[5] !== release ? (t1 = getReleaseTime(release), $[4] = getReleaseTime, $[5] = release, $[6] = t1) : t1 = $[6], t1;
}, dateInputFormat = "PP HH:mm";
function ReleaseTypePicker(props2) {
  const {
    release
  } = props2, popoverRef = useRef(null), buttonRef = useRef(null), inputRef = useRef(null), datePickerRef = useRef(null), {
    t: tRelease
  } = useTranslation(releasesLocaleNamespace), {
    t
  } = useTranslation(), {
    updateRelease
  } = useReleaseOperations(), toast = useToast(), {
    utcToCurrentZoneDate,
    zoneDateToUtc
  } = useTimeZone(), getReleaseTime = useReleaseTime(), [open, setOpen] = useState(!1), [releaseType, setReleaseType] = useState(release.metadata.releaseType), publishDate = useMemo(() => getPublishDateFromRelease(release), [release]), [isUpdating, setIsUpdating] = useState(!1), [isIntendedScheduleDateInPast, setIsIntendedScheduleDateInPast] = useState(publishDate && isBefore(new Date(publishDate), /* @__PURE__ */ new Date())), [intendedPublishAt, setIntendedPublishAt] = useState(publishDate ? new Date(publishDate) : void 0), updatedDate = intendedPublishAt?.toISOString(), intendedPublishAtTimezoneAdjusted = intendedPublishAt && utcToCurrentZoneDate(intendedPublishAt), calendarLabels = useMemo(() => getCalendarLabels(t), [t]), close = useCallback(() => {
    const dialog = document.querySelector("#time-zone");
    if (open && !dialog) {
      const newRelease = {
        ...release,
        metadata: {
          ...release.metadata,
          releaseType,
          ...typeof updatedDate > "u" || releaseType !== "scheduled" ? {} : {
            intendedPublishAt: updatedDate
          }
        }
      };
      isEqual$2(newRelease, release) || (getIsScheduledDateInPast(newRelease) ? (setReleaseType(release.metadata.releaseType), setIntendedPublishAt(release.metadata.intendedPublishAt ? new Date(release.metadata.intendedPublishAt) : void 0), toast.push({
        closable: !0,
        status: "warning",
        title: tRelease("schedule-dialog.publish-date-in-past-warning")
      })) : (setIsUpdating(!0), updateRelease(newRelease).finally(() => {
        setIsUpdating(!1);
      }))), setOpen(!1);
    }
  }, [open, release, updatedDate, releaseType, toast, tRelease, updateRelease]);
  useClickOutsideEvent(close, () => [popoverRef.current, buttonRef.current, inputRef.current, datePickerRef.current]);
  const isPublishDateInPast = !!publishDate && isBefore(new Date(publishDate), /* @__PURE__ */ new Date()), isReleaseScheduled = isReleaseScheduledOrScheduling(release), publishDateLabel = useMemo(() => release.state === "published" ? isPublishDateInPast && publishDate ? tRelease("dashboard.details.published-on", {
    date: getReleaseTime(release)
  }) : tRelease("dashboard.details.published-asap") : /* @__PURE__ */ jsx(ReleaseTime, { release }), [getReleaseTime, isPublishDateInPast, publishDate, release, tRelease]), handleButtonReleaseTypeChange = useCallback((pickedReleaseType) => {
    setReleaseType(pickedReleaseType);
    const nextPublishAt = pickedReleaseType === "scheduled" ? publishDate ?? startOfMinute(/* @__PURE__ */ new Date()) : publishDate ?? void 0;
    setIntendedPublishAt(nextPublishAt), setIsIntendedScheduleDateInPast(!0);
  }, [publishDate]), handlePublishAtCalendarChange = useCallback((date) => {
    if (!date) return;
    const cleanDate = zoneDateToUtc(startOfMinute(new Date(date)));
    setIsIntendedScheduleDateInPast(isBefore(cleanDate, /* @__PURE__ */ new Date())), setIntendedPublishAt(cleanDate);
  }, [zoneDateToUtc]), handlePublishAtInputChange = useCallback((event) => {
    const parsedDate = zoneDateToUtc(parse(event.currentTarget.value, dateInputFormat, /* @__PURE__ */ new Date()));
    isValid(parsedDate) && (setIsIntendedScheduleDateInPast(isBefore(parsedDate, /* @__PURE__ */ new Date())), setIntendedPublishAt(startOfMinute(parsedDate)));
  }, [zoneDateToUtc]), handleOnPickerClick = () => {
    open ? close() : setOpen(!0);
  }, PopoverContent2 = () => /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    /* @__PURE__ */ jsxs(TabList, { space: 0.5, children: [
      /* @__PURE__ */ jsx(Tab, { "aria-controls": "release-timing-asap", id: "release-timing-asap-tab", onClick: () => handleButtonReleaseTypeChange("asap"), label: t("release.type.asap"), selected: releaseType === "asap" }),
      /* @__PURE__ */ jsx(Tab, { "aria-controls": "release-timing-at-time", id: "release-timing-at-time-tab", onClick: () => handleButtonReleaseTypeChange("scheduled"), selected: releaseType === "scheduled", label: t("release.type.scheduled") }),
      /* @__PURE__ */ jsx(Tab, { "aria-controls": "release-timing-undecided", id: "release-timing-undecided-tab", onClick: () => handleButtonReleaseTypeChange("undecided"), selected: releaseType === "undecided", label: t("release.type.undecided") })
    ] }),
    releaseType === "scheduled" && /* @__PURE__ */ jsxs(Fragment, { children: [
      isIntendedScheduleDateInPast && /* @__PURE__ */ jsx(Card, { margin: 1, padding: 2, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: tRelease("schedule-dialog.publish-date-in-past-warning") }) }),
      /* @__PURE__ */ jsx(LazyTextInput, { "data-testid": "date-input", value: intendedPublishAtTimezoneAdjusted ? format$2(intendedPublishAtTimezoneAdjusted, dateInputFormat) : void 0, onChange: handlePublishAtInputChange }),
      /* @__PURE__ */ jsx(DatePicker$2, { ref: datePickerRef, monthPickerVariant: MONTH_PICKER_VARIANT.carousel, calendarLabels, selectTime: !0, padding: 0, value: intendedPublishAtTimezoneAdjusted, onChange: handlePublishAtCalendarChange, isPastDisabled: !0, showTimezone: !0 })
    ] })
  ] }), tone = release.state === "published" ? "positive" : getReleaseTone(release), releaseTypeIcon = useMemo(() => isUpdating ? /* @__PURE__ */ jsx(Spinner, { size: 1, "data-testid": "updating-release-spinner" }) : release.state === "published" ? /* @__PURE__ */ jsx(PublishIcon, {}) : /* @__PURE__ */ jsx(ReleaseAvatar, { tone, padding: 0 }), [isUpdating, release.state, tone]), labelContent = useMemo(() => /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 2, align: "center", children: [
    releaseTypeIcon,
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, "data-testid": "release-type-label", weight: "medium", children: publishDateLabel }),
    isReleaseScheduled && /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(LockIcon, {}) })
  ] }), [isReleaseScheduled, publishDateLabel, releaseTypeIcon]);
  return /* @__PURE__ */ jsx(Popover, { content: /* @__PURE__ */ jsx(PopoverContent2, {}), open, padding: 1, placement: "bottom-start", ref: popoverRef, children: release.state === "published" ? /* @__PURE__ */ jsx(Card, { tone: "default", "data-testid": "published-release-type-label", padding: 2, style: {
    borderRadius: "999px"
  }, children: labelContent }) : /* @__PURE__ */ jsx(Button, { disabled: isReleaseScheduled, mode: "bleed", onClick: handleOnPickerClick, ref: buttonRef, tooltipProps: {
    placement: "bottom",
    content: isReleaseScheduled && tRelease("type-picker.tooltip.scheduled")
  }, selected: open, tone, style: {
    borderRadius: "999px"
  }, "data-testid": "release-type-picker", children: labelContent }) });
}
function ReleaseDashboardDetails(t0) {
  const $ = c(57), {
    release
  } = t0, {
    state
  } = release;
  let t1;
  $[0] !== release._id ? (t1 = getReleaseIdFromReleaseDocumentId(release._id), $[0] = release._id, $[1] = t1) : t1 = $[1];
  const releaseId = t1, {
    checkWithPermissionGuard
  } = useReleasePermissions(), {
    publishRelease,
    schedule
  } = useReleaseOperations(), {
    t: tRelease
  } = useTranslation(releasesLocaleNamespace), {
    selectedReleaseId
  } = usePerspective(), setPerspective = useSetPerspective(), {
    projectSubscriptions
  } = useProjectSubscriptions(), retentionDays = projectSubscriptions?.featureTypes.retention.features[0].attributes.maxRetentionDays, isSelected = releaseId === selectedReleaseId, isAtTimeRelease = release?.metadata?.releaseType === "scheduled", isReleaseOpen = state !== "archived" && state !== "published", isActive = release.state === "active", shouldDisplayError = isActive && typeof release.error < "u", [shouldDisplayPermissionWarning, setShouldDisplayPermissionWarning] = useState(!1), shouldDisplayWarnings = isActive && shouldDisplayPermissionWarning, isMounted = useRef(!1);
  let t2, t3;
  $[2] !== checkWithPermissionGuard || $[3] !== isActive || $[4] !== isAtTimeRelease || $[5] !== publishRelease || $[6] !== release._id || $[7] !== release.metadata.intendedPublishAt || $[8] !== schedule ? (t2 = () => (isMounted.current = !0, isActive && (checkWithPermissionGuard(publishRelease, release._id).then((hasPermission) => {
    isMounted.current && setShouldDisplayPermissionWarning(!hasPermission);
  }), release.metadata.intendedPublishAt && isAtTimeRelease && checkWithPermissionGuard(schedule, release._id, /* @__PURE__ */ new Date()).then((hasPermission_0) => {
    isMounted.current && setShouldDisplayPermissionWarning(!hasPermission_0);
  })), () => {
    isMounted.current = !1;
  }), t3 = [checkWithPermissionGuard, isActive, isAtTimeRelease, publishRelease, release._id, release.metadata.intendedPublishAt, schedule], $[2] = checkWithPermissionGuard, $[3] = isActive, $[4] = isAtTimeRelease, $[5] = publishRelease, $[6] = release._id, $[7] = release.metadata.intendedPublishAt, $[8] = schedule, $[9] = t2, $[10] = t3) : (t2 = $[9], t3 = $[10]), useEffect(t2, t3);
  let t4;
  $[11] !== isSelected || $[12] !== releaseId || $[13] !== setPerspective ? (t4 = () => {
    setPerspective(isSelected ? "drafts" : releaseId);
  }, $[11] = isSelected, $[12] = releaseId, $[13] = setPerspective, $[14] = t4) : t4 = $[14];
  const handlePinRelease = t4;
  let t5;
  $[15] === Symbol.for("react.memo_cache_sentinel") ? (t5 = [3, 3, 4, 5], $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== handlePinRelease || $[17] !== isReleaseOpen || $[18] !== isSelected || $[19] !== release.metadata.title || $[20] !== tRelease ? (t6 = isReleaseOpen && /* @__PURE__ */ jsx(Button, { icon: isSelected ? PinFilledIcon : PinIcon, tooltipProps: {
    placement: "top",
    content: tRelease(isSelected ? "dashboard.details.unpin-release" : "dashboard.details.pin-release")
  }, mode: "bleed", onClick: handlePinRelease, radius: "full", selected: isSelected, "aria-label": isSelected ? `${tRelease("dashboard.details.unpin-release")}: "${release.metadata.title}"` : `${tRelease("dashboard.details.pin-release")}: "${release.metadata.title}"`, "aria-live": "assertive" }), $[16] = handlePinRelease, $[17] = isReleaseOpen, $[18] = isSelected, $[19] = release.metadata.title, $[20] = tRelease, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== release ? (t7 = isNotArchivedRelease(release) && /* @__PURE__ */ jsx(ReleaseTypePicker, { release }), $[22] = release, $[23] = t7) : t7 = $[23];
  let t8;
  $[24] !== isAtTimeRelease || $[25] !== shouldDisplayError || $[26] !== tRelease ? (t8 = shouldDisplayError && /* @__PURE__ */ jsxs(Flex, { gap: 2, padding: 2, "data-testid": "release-error-details", children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }),
    /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", children: tRelease(isAtTimeRelease ? "failed-schedule-title" : "failed-publish-title") })
  ] }), $[24] = isAtTimeRelease, $[25] = shouldDisplayError, $[26] = tRelease, $[27] = t8) : t8 = $[27];
  let t9;
  $[28] !== shouldDisplayWarnings || $[29] !== tRelease ? (t9 = shouldDisplayWarnings && /* @__PURE__ */ jsxs(Flex, { gap: 2, padding: 2, "data-testid": "release-permission-error-details", children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: WarningOutlineIcon, tone: "caution" }) }),
    /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", children: tRelease("permission-missing-title") })
  ] }), $[28] = shouldDisplayWarnings, $[29] = tRelease, $[30] = t9) : t9 = $[30];
  let t10;
  $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t6,
    t7,
    t8,
    t9
  ] }), $[31] = t6, $[32] = t7, $[33] = t8, $[34] = t9, $[35] = t10) : t10 = $[35];
  let t11;
  $[36] !== release ? (t11 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(ReleaseDetailsEditor, { release }) }), $[36] = release, $[37] = t11) : t11 = $[37];
  let t12;
  $[38] !== isAtTimeRelease || $[39] !== release.error?.message || $[40] !== shouldDisplayError || $[41] !== tRelease ? (t12 = shouldDisplayError && /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "critical", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }),
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: tRelease(isAtTimeRelease ? "failed-schedule-title" : "failed-publish-title") }),
      /* @__PURE__ */ jsx(Details, { title: tRelease("error-details-title"), children: /* @__PURE__ */ jsx(Text$1, { size: 1, accent: !0, children: /* @__PURE__ */ jsx("code", { children: release.error?.message }) }) })
    ] })
  ] }) }), $[38] = isAtTimeRelease, $[39] = release.error?.message, $[40] = shouldDisplayError, $[41] = tRelease, $[42] = t12) : t12 = $[42];
  let t13;
  $[43] !== shouldDisplayWarnings || $[44] !== tRelease ? (t13 = shouldDisplayWarnings && /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }),
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: tRelease("permission-missing-title") }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: tRelease("permission-missing-description") })
    ] })
  ] }) }), $[43] = shouldDisplayWarnings, $[44] = tRelease, $[45] = t13) : t13 = $[45];
  let t14;
  $[46] !== isReleaseOpen || $[47] !== retentionDays || $[48] !== state || $[49] !== tRelease ? (t14 = !isReleaseOpen && retentionDays && /* @__PURE__ */ jsx(Card, { padding: 4, radius: 4, tone: "primary", "data-testid": "retention-policy-card", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(InfoOutlineIcon, {}) }),
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: tRelease(state === "archived" ? "archive-info.title" : "publish-info.title") }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, accent: !0, children: tRelease("archive-info.description", {
        retentionDays
      }) })
    ] })
  ] }) }), $[46] = isReleaseOpen, $[47] = retentionDays, $[48] = state, $[49] = tRelease, $[50] = t14) : t14 = $[50];
  let t15;
  return $[51] !== t10 || $[52] !== t11 || $[53] !== t12 || $[54] !== t13 || $[55] !== t14 ? (t15 = /* @__PURE__ */ jsx(Container$2, { width: 3, children: /* @__PURE__ */ jsxs(Stack, { padding: 3, paddingY: t5, children: [
    t10,
    t11,
    t12,
    t13,
    t14
  ] }) }), $[51] = t10, $[52] = t11, $[53] = t12, $[54] = t13, $[55] = t14, $[56] = t15) : t15 = $[56], t15;
}
const ReleasePublishAllButton = ({
  release,
  documents,
  disabled,
  isMenuItem = !1,
  onConfirmDialogOpen,
  onConfirmDialogClose
}) => {
  const toast = useToast(), {
    publishRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), perspective = usePerspective(), setPerspective = useSetPerspective(), telemetry = useTelemetry(), [publishBundleStatus, setPublishBundleStatus] = useState("idle"), [publishPermission, setPublishPermission] = useState(!1), isValidatingDocuments = documents.some(({
    validation: validation2
  }) => validation2.isValidating), hasDocumentValidationErrors = documents.some(({
    validation: validation_0
  }) => validation_0.hasError), isPublishButtonDisabled = disabled || isValidatingDocuments || hasDocumentValidationErrors || !publishPermission, isMounted = useRef(!1);
  useEffect(() => (isMounted.current = !0, checkWithPermissionGuard(publishRelease, release._id).then((hasPermission) => {
    isMounted.current && setPublishPermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), [checkWithPermissionGuard, publishRelease, release._id, release.metadata.intendedPublishAt]);
  const handleConfirmPublishAll = useCallback(async () => {
    if (release)
      try {
        setPublishBundleStatus("publishing"), await publishRelease(release._id), telemetry.log(PublishedRelease), isReleaseDocument(perspective.selectedPerspective) && perspective.selectedPerspective?._id === release._id && setPerspective("drafts");
      } catch (publishingError) {
        toast.push({
          status: "error",
          title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.publish.error", values: {
            title: release.metadata.title || tCore("release.placeholder-untitled-release"),
            error: publishingError.message
          } }) })
        }), console.error(publishingError);
      } finally {
        onConfirmDialogClose?.(), setPublishBundleStatus("idle");
      }
  }, [release, publishRelease, telemetry, toast, t, tCore, perspective.selectedPerspective, setPerspective, onConfirmDialogClose]), confirmPublishDialog = useMemo(() => publishBundleStatus === "idle" ? null : /* @__PURE__ */ jsx(Dialog$1, { id: "confirm-publish-dialog", "data-testid": "confirm-publish-dialog", header: t("publish-dialog.confirm-publish.title"), onClose: () => {
    onConfirmDialogClose?.(), setPublishBundleStatus("idle");
  }, footer: {
    confirmButton: {
      text: t("action.publish-all-documents"),
      tone: "positive",
      onClick: handleConfirmPublishAll,
      loading: publishBundleStatus === "publishing",
      disabled: publishBundleStatus === "publishing"
    }
  }, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "publish-dialog.confirm-publish-description", values: {
    title: release.metadata.title || tCore("release.placeholder-untitled-release"),
    releaseDocumentsLength: documents.length,
    count: documents.length
  } }) }) }), [publishBundleStatus, t, handleConfirmPublishAll, release.metadata.title, tCore, documents.length, onConfirmDialogClose]), publishTooltipContent = useMemo(() => !hasDocumentValidationErrors && !isValidatingDocuments && publishPermission ? null : /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
    /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: isValidatingDocuments ? "default" : "critical" }),
    documents.length === 0 ? t("publish-action.validation.no-documents") : publishPermission ? isValidatingDocuments ? t("publish-dialog.validation.loading") : hasDocumentValidationErrors ? t("publish-dialog.validation.error") : null : t("publish-dialog.validation.no-permission")
  ] }) }), [documents.length, hasDocumentValidationErrors, isValidatingDocuments, publishPermission, t]), handleInitialPublish = useCallback(() => {
    setPublishBundleStatus("confirm"), onConfirmDialogOpen?.();
  }, [onConfirmDialogOpen]), sharedProps = useMemo(() => ({
    icon: PublishIcon,
    disabled: isPublishButtonDisabled || publishBundleStatus === "publishing" || documents.length === 0,
    text: t("action.publish-all-documents"),
    handleOnClick: handleInitialPublish,
    tooltipProps: {
      disabled: !isPublishButtonDisabled,
      content: publishTooltipContent,
      placement: "bottom"
    }
  }), [documents.length, handleInitialPublish, isPublishButtonDisabled, publishBundleStatus, publishTooltipContent, t]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isMenuItem ? /* @__PURE__ */ jsx(MenuItem$1, { tooltipProps: sharedProps.tooltipProps, icon: sharedProps.icon, disabled: sharedProps.disabled, text: sharedProps.text, onClick: sharedProps.handleOnClick, "data-testid": "publish-all-button-menu-item" }) : /* @__PURE__ */ jsx(Button, { tooltipProps: sharedProps.tooltipProps, icon: sharedProps.icon, disabled: sharedProps.disabled, text: sharedProps.text, onClick: sharedProps.handleOnClick, loading: publishBundleStatus === "publishing", "data-testid": "publish-all-button", tone: "positive" }),
    confirmPublishDialog
  ] });
};
function isErrorAtLimits(error) {
  return error.statusCode === 403 && typeof error.response.body != "string" && "data" in error.response.body;
}
function fetchReleaseLimits(client, storeOrigin) {
  const {
    projectId
  } = client.config();
  return client.withConfig({
    apiVersion: "vX"
  }).observable.request({
    uri: `projects/${projectId}/new-content-release-allowed`,
    /**
     * In a particular case when both releaseLimits
     * and orgActiveReleaseCount stores are empty, 2 fetch calls are made
     * to guard the create/archive/revert actions - browsers behave differently.
     *
     * Chromium based browsers will stall the second network request until the first
     * resolves by attaching the store name to the tag, this spoofs 2 unique requests
     * allowing both the fire in parallel.
     */
    tag: `new-content-release-allowed-${storeOrigin}`
  }).pipe(catchError$1((error) => {
    if (console.error(error), isErrorAtLimits(error))
      return of(error.response.body);
    throw error;
  }), map$1(({
    data
  }) => data));
}
const RELEASE_LIMITS_RESOURCE_CACHE_NAMESPACE = "ReleaseLimits";
function createReleaseLimitsStore(client) {
  return {
    releaseLimits$: fetchReleaseLimits(client, "releaseLimits").pipe(map$1((data) => ({
      defaultOrgActiveReleaseLimit: data.defaultOrgActiveReleaseLimit,
      datasetReleaseLimit: data.datasetReleaseLimit,
      orgActiveReleaseLimit: data.orgActiveReleaseLimit
    })), shareReplay$1(1), catchError$1((error) => (console.error("Failed to fetch release limits", error), of(null))))
  };
}
const useReleaseLimits = () => {
  const $ = c(4), resourceCache = useResourceCache();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "v2025-02-19"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1, releaseLimitsStore;
  return $[1] !== client || $[2] !== resourceCache ? (releaseLimitsStore = resourceCache.get({
    dependencies: [client],
    namespace: RELEASE_LIMITS_RESOURCE_CACHE_NAMESPACE
  }) || createReleaseLimitsStore(client), resourceCache.set({
    namespace: RELEASE_LIMITS_RESOURCE_CACHE_NAMESPACE,
    value: releaseLimitsStore,
    dependencies: [client]
  }), $[1] = client, $[2] = resourceCache, $[3] = releaseLimitsStore) : releaseLimitsStore = $[3], t1 = releaseLimitsStore, t1;
}, useIsReleasesPlus = () => {
  const $ = c(3), {
    releaseLimits$
  } = useReleaseLimits(), {
    enabled: isReleasesFeatureEnabled
  } = useFeatureEnabled("contentReleases");
  let t0, t1;
  $[0] !== isReleasesFeatureEnabled || $[1] !== releaseLimits$ ? (t1 = isReleasesFeatureEnabled ? releaseLimits$ : of(null), $[0] = isReleasesFeatureEnabled, $[1] = releaseLimits$, $[2] = t1) : t1 = $[2], t0 = t1;
  const releaseLimit = useObservable(t0, null);
  if (!isReleasesFeatureEnabled)
    return !1;
  const {
    orgActiveReleaseLimit,
    defaultOrgActiveReleaseLimit: t2
  } = releaseLimit || {};
  return !!orgActiveReleaseLimit && orgActiveReleaseLimit > (t2 === void 0 ? 0 : t2);
}, useDocumentRevertStates = (releaseDocuments) => {
  const $ = c(15), client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), observableClient = client.observable, transactionId = releaseDocuments[0]?.document._rev;
  let t0;
  $[0] !== client ? (t0 = client.config(), $[0] = client, $[1] = t0) : t0 = $[1];
  const {
    dataset
  } = t0, resultPromiseRef = useRef(null), resolvedDocumentRevertStatesPromiseRef = useRef(null), resolvedDocumentRevertStatesResultRef = useRef(null);
  let t1, t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    if (!resultPromiseRef.current) {
      const {
        promise,
        resolve
      } = Promise.withResolvers();
      resultPromiseRef.current = promise, resolvedDocumentRevertStatesPromiseRef.current = resolve;
    }
  }, t2 = [], $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  bb0: {
    if (!releaseDocuments.length) {
      let t43;
      $[4] === Symbol.for("react.memo_cache_sentinel") ? (t43 = of(void 0), $[4] = t43) : t43 = $[4], t3 = t43;
      break bb0;
    }
    let t42;
    if ($[5] !== client || $[6] !== dataset || $[7] !== observableClient || $[8] !== releaseDocuments || $[9] !== transactionId) {
      const publishedDocuments = releaseDocuments.map(_temp$2o);
      t42 = from(getTransactionsLogs(client, publishedDocuments.map(_temp2$U), {
        toTransaction: transactionId,
        reverse: !0
      })).pipe(map$1((transactions) => {
        const getDocumentTransaction = (docId) => transactions.find((t52) => {
          const {
            documentIDs
          } = t52;
          return documentIDs.includes(docId);
        })?.id;
        return publishedDocuments.map((document_1) => ({
          docId: document_1._id,
          revisionId: getDocumentTransaction(document_1._id)
        }));
      }), switchMap$1((docRevisionPairs) => docRevisionPairs ? forkJoin(docRevisionPairs.map((t62) => {
        const {
          docId: docId_0,
          revisionId
        } = t62;
        if (!revisionId) {
          const {
            publishedDocumentExists,
            ...unpublishDocument
          } = publishedDocuments.find((document_2) => document_2._id === docId_0) || {};
          return of({
            ...unpublishDocument,
            _system: {
              delete: !0
            }
          });
        }
        return observableClient.request({
          url: `/data/history/${dataset}/documents/${docId_0}?revision=${revisionId}`
        }).pipe(map$1(_temp3$i), catchError$1((err) => (console.error(`Error fetching document ${docId_0}:`, err), of(void 0))));
      })) : of(void 0)), map$1(_temp5$6), catchError$1(_temp6$2)), $[5] = client, $[6] = dataset, $[7] = observableClient, $[8] = releaseDocuments, $[9] = transactionId, $[10] = t42;
    } else
      t42 = $[10];
    t3 = t42;
  }
  const documentRevertStatesResult = useObservable(t3, null);
  let t4, t5;
  $[11] !== documentRevertStatesResult ? (t4 = () => {
    documentRevertStatesResult !== null && (resolvedDocumentRevertStatesResultRef.current = documentRevertStatesResult, resolvedDocumentRevertStatesPromiseRef.current && (resolvedDocumentRevertStatesPromiseRef.current(documentRevertStatesResult), resolvedDocumentRevertStatesPromiseRef.current = null, resultPromiseRef.current = null));
  }, t5 = [documentRevertStatesResult], $[11] = documentRevertStatesResult, $[12] = t4, $[13] = t5) : (t4 = $[12], t5 = $[13]), useEffect(t4, t5);
  let t6;
  return $[14] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => resolvedDocumentRevertStatesResultRef.current ? Promise.resolve(resolvedDocumentRevertStatesResultRef.current) : resultPromiseRef.current, $[14] = t6) : t6 = $[14], t6;
};
function _temp$2o(t0) {
  const {
    document: document2
  } = t0;
  return {
    ...document2,
    _id: getPublishedId(document2._id)
  };
}
function _temp2$U(document_0) {
  return document_0._id;
}
function _temp3$i(t0) {
  const {
    documents: t1
  } = t0, [revertDocument] = t1;
  return revertDocument;
}
function _temp4$b(result) {
  return result !== void 0;
}
function _temp5$6(results) {
  return results?.filter(_temp4$b);
}
function _temp6$2(err_0) {
  return console.error("Error in document revert states pipeline:", err_0), of(void 0);
}
const usePostPublishTransactions = (documents) => {
  const $ = c(5), client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), transactionId = documents[0]?.document._rev;
  let t0;
  bb0: {
    if (!documents.length) {
      let t12;
      $[0] === Symbol.for("react.memo_cache_sentinel") ? (t12 = of(!1), $[0] = t12) : t12 = $[0], t0 = t12;
      break bb0;
    }
    let t1;
    $[1] !== client || $[2] !== documents || $[3] !== transactionId ? (t1 = from(getTransactionsLogs(client, documents.map(_temp$2n), {
      fromTransaction: transactionId,
      limit: 2
    })).pipe(map$1(_temp2$T), catchError$1(_temp3$h)), $[1] = client, $[2] = documents, $[3] = transactionId, $[4] = t1) : t1 = $[4], t0 = t1;
  }
  return useObservable(t0, null);
};
function _temp$2n(t0) {
  const {
    document: document2
  } = t0;
  return getPublishedId(document2._id);
}
function _temp2$T(transactions) {
  return transactions.length > 1;
}
function _temp3$h() {
  return of(null);
}
const ConfirmReleaseDialog = ({
  revertReleaseStatus,
  documents,
  setRevertReleaseStatus,
  release
}) => {
  const {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), hasPostPublishTransactions = usePostPublishTransactions(documents), getDocumentRevertStates = useDocumentRevertStates(documents), [stageNewRevertRelease, setStageNewRevertRelease] = useState(!0), toast = useToast(), telemetry = useTelemetry(), {
    revertRelease
  } = useReleaseOperations(), router = useRouter(), navigateToRevertRelease = useCallback((revertReleaseId) => () => router.navigate({
    releaseId: getReleaseIdFromReleaseDocumentId(revertReleaseId)
  }), [router]), handleRevertRelease = useCallback(async () => {
    setRevertReleaseStatus("reverting");
    const documentRevertStates = await getDocumentRevertStates(), revertReleaseId_0 = createReleaseId();
    try {
      if (!documentRevertStates)
        throw new Error("Unable to find documents to revert");
      await revertRelease(revertReleaseId_0, documentRevertStates, {
        title: t("revert-release.title", {
          title: release.metadata.title || tCore("release.placeholder-untitled-release")
        }),
        description: t("revert-release.description", {
          title: release.metadata.title || tCore("release.placeholder-untitled-release")
        }),
        releaseType: "asap"
      }, stageNewRevertRelease ? "staged" : "immediate"), stageNewRevertRelease ? (telemetry.log(RevertRelease, {
        revertType: "staged"
      }), toast.push({
        closable: !0,
        status: "success",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { components: {
          Link: () => /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", "data-as": "a", onClick: navigateToRevertRelease(revertReleaseId_0), style: {
            cursor: "pointer",
            marginBottom: "0.5rem",
            display: "flex"
          }, "data-testid": "revert-stage-success-link", children: t("toast.revert-stage.success-link") })
        }, t, i18nKey: "toast.revert-stage.success", values: {
          title: release.metadata.title || tCore("release.placeholder-untitled-release")
        } }) })
      })) : (telemetry.log(RevertRelease, {
        revertType: "immediate"
      }), toast.push({
        closable: !0,
        status: "success",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.immediate-revert.success", values: {
          title: release.metadata.title || tCore("release.placeholder-untitled-release")
        } }) })
      }));
    } catch (revertError) {
      if (isReleaseLimitError(revertError)) return;
      toast.push({
        status: "error",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.revert.error", values: {
          error: revertError.message
        } }) })
      }), console.error(revertError);
    } finally {
      setRevertReleaseStatus("idle");
    }
  }, [setRevertReleaseStatus, getDocumentRevertStates, revertRelease, t, tCore, release.metadata.title, stageNewRevertRelease, telemetry, toast, navigateToRevertRelease]), description = documents.length > 1 ? "revert-dialog.confirm-revert-description_other" : "revert-dialog.confirm-revert-description_one";
  return /* @__PURE__ */ jsxs(Dialog$1, { id: "confirm-revert-dialog", header: t("revert-dialog.confirm-revert.title", {
    title: release.metadata.title || tCore("release.placeholder-untitled-release")
  }), onClose: () => setRevertReleaseStatus("idle"), footer: {
    confirmButton: {
      text: t(stageNewRevertRelease ? "action.create-revert-release" : "action.immediate-revert-release"),
      tone: "positive",
      onClick: handleRevertRelease,
      loading: revertReleaseStatus === "reverting",
      disabled: revertReleaseStatus === "reverting"
    }
  }, children: [
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: description, values: {
      releaseDocumentsLength: documents.length
    } }) }),
    /* @__PURE__ */ jsxs(Flex, { align: "center", paddingTop: 4, children: [
      /* @__PURE__ */ jsx(Checkbox$1, { onChange: () => setStageNewRevertRelease((current) => !current), id: "stage-release", style: {
        display: "block"
      }, checked: stageNewRevertRelease }),
      /* @__PURE__ */ jsx(Box, { flex: 1, paddingLeft: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("label", { htmlFor: "stage-release", children: t("revert-dialog.confirm-revert.stage-revert-checkbox-label") }) }) })
    ] }),
    hasPostPublishTransactions && !stageNewRevertRelease && /* @__PURE__ */ jsx(Card, { marginTop: 4, padding: 3, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t("revert-dialog.confirm-revert.warning-card") }) })
  ] });
}, ReleaseRevertButton = (t0) => {
  const $ = c(25), {
    release,
    documents,
    disabled
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    guardWithReleaseLimitUpsell,
    mode
  } = useReleasesUpsell(), [revertReleaseStatus, setRevertReleaseStatus] = useState("idle"), [isPendingGuardResponse, setIsPendingGuardResponse] = useState(!1), {
    createRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasCreatePermission, setHasCreatePermission] = useState(null);
  let t1;
  $[0] !== guardWithReleaseLimitUpsell ? (t1 = async () => {
    setIsPendingGuardResponse(!0), await guardWithReleaseLimitUpsell(() => setRevertReleaseStatus("confirm")), setIsPendingGuardResponse(!1);
  }, $[0] = guardWithReleaseLimitUpsell, $[1] = t1) : t1 = $[1];
  const handleMoveToConfirmStatus = t1, isReleasesPlus = useIsReleasesPlus(), isMounted = useRef(!1);
  let t2, t3;
  if ($[2] !== checkWithPermissionGuard || $[3] !== createRelease ? (t2 = () => (isMounted.current = !0, checkWithPermissionGuard(createRelease, getReleaseDefaults()).then((hasPermissions) => {
    isMounted.current && setHasCreatePermission(hasPermissions);
  }), () => {
    isMounted.current = !1;
  }), t3 = [checkWithPermissionGuard, createRelease], $[2] = checkWithPermissionGuard, $[3] = createRelease, $[4] = t2, $[5] = t3) : (t2 = $[4], t3 = $[5]), useEffect(t2, t3), !isReleasesPlus)
    return null;
  let t4;
  $[6] !== t ? (t4 = t("action.revert"), $[6] = t, $[7] = t4) : t4 = $[7];
  const t5 = hasCreatePermission === !0;
  let t6;
  $[8] !== tCore ? (t6 = tCore("release.action.permission.error"), $[8] = tCore, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t5 || $[11] !== t6 ? (t7 = {
    disabled: t5,
    content: t6
  }, $[10] = t5, $[11] = t6, $[12] = t7) : t7 = $[12];
  const t8 = isPendingGuardResponse || !hasCreatePermission || disabled || mode === "disabled";
  let t9;
  $[13] !== handleMoveToConfirmStatus || $[14] !== t4 || $[15] !== t7 || $[16] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { icon: RestoreIcon, onClick: handleMoveToConfirmStatus, text: t4, tone: "critical", tooltipProps: t7, disabled: t8, "data-testid": "revert-button" }), $[13] = handleMoveToConfirmStatus, $[14] = t4, $[15] = t7, $[16] = t8, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== documents || $[19] !== release || $[20] !== revertReleaseStatus ? (t10 = revertReleaseStatus !== "idle" && /* @__PURE__ */ jsx(ConfirmReleaseDialog, { release, documents, revertReleaseStatus, setRevertReleaseStatus }), $[18] = documents, $[19] = release, $[20] = revertReleaseStatus, $[21] = t10) : t10 = $[21];
  let t11;
  return $[22] !== t10 || $[23] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t9,
    t10
  ] }), $[22] = t10, $[23] = t9, $[24] = t11) : t11 = $[24], t11;
}, ReleaseScheduleButton = ({
  release,
  disabled,
  documents,
  isMenuItem = !1,
  onConfirmDialogOpen,
  onConfirmDialogClose
}) => {
  const toast = useToast(), {
    schedule,
    updateRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [schedulePermission, setSchedulePermission] = useState(!1), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), telemetry = useTelemetry(), {
    utcToCurrentZoneDate,
    zoneDateToUtc
  } = useTimeZone(), [status, setStatus] = useState("idle"), [publishAt, setPublishAt] = useState(), [rerenderDialog, setRerenderDialog] = useState(0), timezoneAdjustedPublishAt = publishAt ? utcToCurrentZoneDate(publishAt) : void 0, isValidatingDocuments = documents.some(({
    validation: validation2
  }) => validation2.isValidating), hasDocumentValidationErrors = documents.some(({
    validation: validation_0
  }) => validation_0.hasError), isScheduleButtonDisabled = disabled || isValidatingDocuments || !schedulePermission || hasDocumentValidationErrors, isMounted = useRef(!1);
  useEffect(() => (isMounted.current = !0, checkWithPermissionGuard(schedule, release._id, /* @__PURE__ */ new Date()).then((hasPermission) => {
    isMounted.current && setSchedulePermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), [checkWithPermissionGuard, release._id, release.metadata.intendedPublishAt, schedule]);
  const isScheduledDateInPast = useCallback(() => isBefore(zoneDateToUtc(publishAt || /* @__PURE__ */ new Date()), /* @__PURE__ */ new Date()), [publishAt, zoneDateToUtc]), handleConfirmSchedule = useCallback(async () => {
    if (publishAt) {
      if (isMenuItem) {
        const newRelease = {
          ...release,
          metadata: {
            ...release.metadata,
            releaseType: "scheduled",
            intendedPublishAt: publishAt.toISOString()
          }
        };
        isEqual$2(newRelease, release) || updateRelease(newRelease);
      }
      if (isScheduledDateInPast()) {
        setRerenderDialog((cur) => cur + 1);
        return;
      }
      try {
        setStatus("scheduling"), await schedule(release._id, publishAt), telemetry.log(ScheduledRelease), toast.push({
          closable: !0,
          status: "info",
          title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.schedule.success", values: {
            title: release.metadata.title || tCore("release.placeholder-untitled-release")
          } }) })
        });
      } catch (schedulingError) {
        toast.push({
          status: "error",
          title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.schedule.error", values: {
            title: release.metadata.title || tCore("release.placeholder-untitled-release"),
            error: schedulingError.message
          } }) })
        }), console.error(schedulingError);
      } finally {
        onConfirmDialogClose?.(), setStatus("idle");
      }
    }
  }, [publishAt, isMenuItem, isScheduledDateInPast, release, updateRelease, schedule, telemetry, toast, t, tCore, onConfirmDialogClose]), calendarLabels = useMemo(() => getCalendarLabels(tCore), [tCore]), handleBundlePublishAtCalendarChange = useCallback((date) => {
    date && setPublishAt(zoneDateToUtc(startOfMinute(date)));
  }, [zoneDateToUtc]), handleBundleInputChange = useCallback((event) => {
    const date_0 = event.currentTarget.value, parsedDate = zoneDateToUtc(parse(date_0, "PP HH:mm", /* @__PURE__ */ new Date()));
    isValid(parsedDate) && setPublishAt(parsedDate);
  }, [zoneDateToUtc]), handleOnDialogClose = useCallback(() => {
    onConfirmDialogClose?.(), status !== "scheduling" && setStatus("idle");
  }, [onConfirmDialogClose, status]), confirmScheduleDialog = useMemo(() => {
    if (status === "idle") return null;
    const _isScheduledDateInPast = isScheduledDateInPast();
    return /* @__PURE__ */ jsx(
      Dialog$1,
      {
        id: "confirm-schedule-dialog",
        "data-testid": "confirm-schedule-dialog",
        header: t("schedule-dialog.confirm-title", {
          documentsLength: documents.length,
          count: documents.length
        }),
        onClose: handleOnDialogClose,
        footer: {
          confirmButton: {
            text: t("schedule-dialog.confirm-button"),
            tone: "default",
            onClick: handleConfirmSchedule,
            loading: status === "scheduling",
            disabled: _isScheduledDateInPast || status === "scheduling"
          },
          cancelButton: {
            disabled: status === "scheduling"
          }
        },
        children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
          _isScheduledDateInPast && /* @__PURE__ */ jsx(Card, { marginBottom: 1, padding: 2, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("schedule-dialog.publish-date-in-past-warning") }) }),
          /* @__PURE__ */ jsx("label", { children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
            /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t("schedule-dialog.select-publish-date-label") }),
            /* @__PURE__ */ jsx(DateTimeInput$3, { selectTime: !0, monthPickerVariant: MONTH_PICKER_VARIANT.carousel, onChange: handleBundlePublishAtCalendarChange, onInputChange: handleBundleInputChange, value: timezoneAdjustedPublishAt, calendarLabels, inputValue: timezoneAdjustedPublishAt ? format$2(timezoneAdjustedPublishAt, "PP HH:mm") : "", constrainSize: !1, isPastDisabled: !0 })
          ] }) }),
          /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "schedule-dialog.confirm-description", values: {
            title: release.metadata.title || tCore("release.placeholder-untitled-release"),
            count: documents.length
          } }) })
        ] })
      },
      rerenderDialog
    );
  }, [status, isScheduledDateInPast, rerenderDialog, t, documents.length, handleOnDialogClose, handleConfirmSchedule, handleBundlePublishAtCalendarChange, handleBundleInputChange, timezoneAdjustedPublishAt, calendarLabels, release.metadata.title, tCore]), handleOnInitialSchedule = useCallback(() => {
    setPublishAt(release.metadata.intendedPublishAt ? new Date(release.metadata.intendedPublishAt) : /* @__PURE__ */ new Date()), setStatus("confirm"), onConfirmDialogOpen?.();
  }, [onConfirmDialogOpen, release.metadata.intendedPublishAt]), tooltipText = useMemo(() => documents.length === 0 ? t("schedule-action.validation.no-documents") : schedulePermission ? isValidatingDocuments ? t("schedule-button-tooltip.validation.loading") : hasDocumentValidationErrors ? t("schedule-button-tooltip.validation.error") : isReleaseScheduledOrScheduling(release) ? t("schedule-button-tooltip.already-scheduled") : null : t("schedule-button-tooltip.validation.no-permission"), [documents.length, hasDocumentValidationErrors, isValidatingDocuments, release, schedulePermission, t]), scheduleTooltipContent = useMemo(() => /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
    /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: isValidatingDocuments ? "default" : "critical" }),
    tooltipText
  ] }) }), [isValidatingDocuments, tooltipText]), sharedProps = useMemo(() => ({
    icon: ClockIcon,
    disabled: isScheduleButtonDisabled || status === "scheduling" || documents.length === 0,
    text: t("action.schedule"),
    handleOnClick: handleOnInitialSchedule,
    tooltipProps: {
      disabled: !tooltipText,
      content: scheduleTooltipContent,
      placement: "bottom"
    }
  }), [documents.length, handleOnInitialSchedule, isScheduleButtonDisabled, scheduleTooltipContent, status, t, tooltipText]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isMenuItem ? /* @__PURE__ */ jsx(MenuItem$1, { tooltipProps: sharedProps.tooltipProps, icon: sharedProps.icon, disabled: sharedProps.disabled, text: sharedProps.text, onClick: sharedProps.handleOnClick, "data-testid": "schedule-button-menu-item" }) : /* @__PURE__ */ jsx(Button, { tooltipProps: sharedProps.tooltipProps, tone: "primary", icon: sharedProps.icon, disabled: sharedProps.disabled, text: sharedProps.text, onClick: sharedProps.handleOnClick, loading: status === "scheduling", "data-testid": "schedule-button" }),
    confirmScheduleDialog
  ] });
}, ReleaseUnscheduleButton = ({
  release,
  disabled,
  documents
}) => {
  const toast = useToast(), {
    unschedule
  } = useReleaseOperations(), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), telemetry = useTelemetry(), [status, setStatus] = useState("idle"), handleConfirmSchedule = useCallback(async () => {
    try {
      setStatus("unscheduling"), await unschedule(release._id), telemetry.log(UnscheduledRelease);
    } catch (schedulingError) {
      toast.push({
        status: "error",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "toast.unschedule.error", values: {
          title: release.metadata.title || tCore("release.placeholder-untitled-release"),
          error: schedulingError.message
        } }) })
      }), console.error(schedulingError);
    } finally {
      setStatus("idle");
    }
  }, [unschedule, release._id, release.metadata.title, telemetry, toast, t, tCore]), confirmScheduleDialog = useMemo(() => status === "idle" ? null : /* @__PURE__ */ jsx(Dialog$1, { id: "confirm-unschedule-dialog", header: t("unschedule-dialog.confirm-title"), onClose: () => status !== "unscheduling" && setStatus("idle"), footer: {
    confirmButton: {
      text: t("action.unschedule"),
      tone: "default",
      onClick: handleConfirmSchedule,
      loading: status === "unscheduling",
      disabled: status === "unscheduling"
    },
    cancelButton: {
      disabled: status === "unscheduling"
    }
  }, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "unschedule-dialog.confirm-description", values: {
    title: release.metadata.title || tCore("release.placeholder-untitled-release"),
    documentsLength: documents.length,
    count: documents.length
  } }) }) }), [release.metadata.title, documents.length, handleConfirmSchedule, status, t, tCore]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Button, { icon: CloseCircleIcon, disabled: disabled || status === "unscheduling", text: t("action.unschedule"), onClick: () => setStatus("confirm"), loading: status === "unscheduling", "data-testid": "schedule-button" }),
    confirmScheduleDialog
  ] });
}, RELEASE_ACTION_MAP = {
  delete: {
    confirmDialog: {
      dialogId: "confirm-delete-dialog",
      dialogHeaderI18nKey: "delete-dialog.confirm-delete.header",
      dialogDescriptionI18nKey: "delete-dialog.confirm-delete-description",
      dialogConfirmButtonI18nKey: "delete-dialog.confirm-delete-button",
      confirmButtonTone: "critical"
    },
    toastSuccessI18nKey: "toast.delete.success",
    toastFailureI18nKey: "toast.delete.error",
    telemetry: DeletedRelease
  },
  archive: {
    confirmDialog: {
      dialogId: "confirm-archive-dialog",
      dialogHeaderI18nKey: "archive-dialog.confirm-archive-header",
      dialogDescriptionI18nKey: "archive-dialog.confirm-archive-description",
      dialogConfirmButtonI18nKey: "archive-dialog.confirm-archive-button",
      confirmButtonTone: "critical"
    },
    toastFailureI18nKey: "toast.archive.error",
    telemetry: ArchivedRelease
  },
  unarchive: {
    confirmDialog: !1,
    toastFailureI18nKey: "toast.unarchive.error",
    telemetry: UnarchivedRelease
  },
  unschedule: {
    confirmDialog: !1,
    toastFailureI18nKey: "toast.unschedule.error",
    telemetry: UnscheduledRelease
  }
};
function useReleasesIds(releases2) {
  const $ = c(4);
  let t0, t1;
  $[0] !== releases2 ? (t1 = releases2.map(_temp$2m), $[0] = releases2, $[1] = t1) : t1 = $[1], t0 = t1;
  const releasesIds = t0;
  let t2, t3;
  return $[2] !== releasesIds ? (t3 = {
    releasesIds
  }, $[2] = releasesIds, $[3] = t3) : t3 = $[3], t2 = t3, t2;
}
function _temp$2m(release) {
  return getReleaseIdFromReleaseDocumentId(release._id);
}
function exists(value) {
  return value?._rev;
}
const DOCUMENT_STUB_PATHS = ["_id", "_type", "_rev", "_createdAt", "_updatedAt"], NO_VERSIONS = {};
function useDocumentVersionInfo(documentId) {
  const documentPreviewStore = useDocumentPreviewStore(), releaseIds = useReleasesIds(useActiveReleases().data).releasesIds, [draftId, publishedId] = [getDraftId(documentId), getPublishedId$1(documentId)], observable = useMemo(() => {
    const releaseVersions = releaseIds.length > 0 ? combineLatest(Object.fromEntries(releaseIds.map((releaseId) => [releaseId, documentPreviewStore.observePaths({
      _id: getVersionId(publishedId, releaseId)
    }, DOCUMENT_STUB_PATHS).pipe(map((value) => exists(value) ? value : void 0))]))) : of(NO_VERSIONS);
    return combineLatest({
      isLoading: of(!1),
      draft: documentPreviewStore.observePaths({
        _id: draftId
      }, DOCUMENT_STUB_PATHS).pipe(map((value_0) => exists(value_0) ? value_0 : void 0)),
      published: documentPreviewStore.observePaths({
        _id: publishedId
      }, DOCUMENT_STUB_PATHS).pipe(map((value_1) => exists(value_1) ? value_1 : void 0)),
      versions: releaseVersions
    });
  }, [draftId, documentPreviewStore, publishedId, releaseIds]);
  return useObservable(observable, {
    isLoading: !0,
    versions: NO_VERSIONS,
    draft: void 0,
    published: void 0
  });
}
const ReleaseMenu = (t0) => {
  const $ = c(99), {
    ignoreCTA,
    disabled,
    release,
    setSelectedAction,
    documents
  } = t0, releaseMenuDisabled = !release || disabled, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    mode
  } = useReleasesUpsell(), {
    archive,
    unarchive,
    deleteRelease,
    publishRelease,
    schedule
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasArchivePermission, setHasArchivePermission] = useState(null), [hasUnarchivePermission, setHasUnarchivePermission] = useState(null), [hasDeletePermission, setHasDeletePermission] = useState(null), [hasPublishPermission, setHasPublishPermission] = useState(null), [hasSchedulePermission, setHasSchedulePermission] = useState(null), isMounted = useRef(!1);
  let t1;
  $[0] !== archive || $[1] !== checkWithPermissionGuard || $[2] !== deleteRelease || $[3] !== publishRelease || $[4] !== release._id || $[5] !== release.state || $[6] !== releaseMenuDisabled || $[7] !== schedule || $[8] !== unarchive ? (t1 = () => (isMounted.current = !0, releaseMenuDisabled || (release.state !== "published" && (release.state === "archived" ? checkWithPermissionGuard(unarchive, release._id).then((hasPermission) => {
    isMounted.current && setHasUnarchivePermission(hasPermission);
  }) : (checkWithPermissionGuard(archive, release._id).then((hasPermission_0) => {
    isMounted.current && setHasArchivePermission(hasPermission_0);
  }), checkWithPermissionGuard(publishRelease, release._id).then((hasPermission_1) => {
    isMounted.current && setHasPublishPermission(hasPermission_1);
  }), checkWithPermissionGuard(schedule, release._id, /* @__PURE__ */ new Date()).then((hasPermission_2) => {
    isMounted.current && setHasSchedulePermission(hasPermission_2);
  }))), (release.state === "archived" || release.state == "published") && checkWithPermissionGuard(deleteRelease, release._id).then((hasPermission_3) => {
    isMounted.current && setHasDeletePermission(hasPermission_3);
  })), () => {
    isMounted.current = !1;
  }), $[0] = archive, $[1] = checkWithPermissionGuard, $[2] = deleteRelease, $[3] = publishRelease, $[4] = release._id, $[5] = release.state, $[6] = releaseMenuDisabled, $[7] = schedule, $[8] = unarchive, $[9] = t1) : t1 = $[9];
  let t2;
  $[10] !== archive || $[11] !== checkWithPermissionGuard || $[12] !== deleteRelease || $[13] !== mode || $[14] !== publishRelease || $[15] !== release._id || $[16] !== release.metadata.releaseType || $[17] !== release.state || $[18] !== releaseMenuDisabled || $[19] !== schedule || $[20] !== unarchive ? (t2 = [release._id, mode, releaseMenuDisabled, release.state, checkWithPermissionGuard, unarchive, archive, deleteRelease, release.metadata.releaseType, publishRelease, schedule], $[10] = archive, $[11] = checkWithPermissionGuard, $[12] = deleteRelease, $[13] = mode, $[14] = publishRelease, $[15] = release._id, $[16] = release.metadata.releaseType, $[17] = release.state, $[18] = releaseMenuDisabled, $[19] = schedule, $[20] = unarchive, $[21] = t2) : t2 = $[21], useEffect(t1, t2);
  let t3;
  $[22] !== setSelectedAction ? (t3 = (event) => {
    const action = event.currentTarget.getAttribute("data-value");
    setSelectedAction(action);
  }, $[22] = setSelectedAction, $[23] = t3) : t3 = $[23];
  const handleOnInitiateAction = t3;
  let t4;
  bb0: {
    if (release.state === "published") {
      t4 = null;
      break bb0;
    }
    if (release.state === "archived") {
      const t53 = mode === "disabled" || !hasUnarchivePermission;
      let t63;
      $[24] !== t ? (t63 = t("action.unarchive"), $[24] = t, $[25] = t63) : t63 = $[25];
      let t73;
      $[26] !== hasUnarchivePermission || $[27] !== t ? (t73 = !hasUnarchivePermission && t("permissions.error.unarchive"), $[26] = hasUnarchivePermission, $[27] = t, $[28] = t73) : t73 = $[28];
      let t83;
      $[29] !== t73 ? (t83 = {
        content: t73
      }, $[29] = t73, $[30] = t83) : t83 = $[30];
      let t93;
      $[31] !== handleOnInitiateAction || $[32] !== t53 || $[33] !== t63 || $[34] !== t83 ? (t93 = /* @__PURE__ */ jsx(MenuItem$1, { "data-value": "unarchive", disabled: t53, onClick: handleOnInitiateAction, icon: UnarchiveIcon, text: t63, "data-testid": "unarchive-release-menu-item", tooltipProps: t83 }), $[31] = handleOnInitiateAction, $[32] = t53, $[33] = t63, $[34] = t83, $[35] = t93) : t93 = $[35], t4 = t93;
      break bb0;
    }
    const t52 = hasArchivePermission ? !["scheduled", "scheduling"].includes(release.state) || disabled : !1;
    let t62;
    $[36] !== hasArchivePermission || $[37] !== t ? (t62 = t(hasArchivePermission ? "action.archive.tooltip" : "permissions.error.archive"), $[36] = hasArchivePermission, $[37] = t, $[38] = t62) : t62 = $[38];
    let t72;
    $[39] !== t52 || $[40] !== t62 ? (t72 = {
      disabled: t52,
      content: t62
    }, $[39] = t52, $[40] = t62, $[41] = t72) : t72 = $[41];
    let t82;
    $[42] !== t ? (t82 = t("action.archive"), $[42] = t, $[43] = t82) : t82 = $[43];
    let t92;
    $[44] !== hasArchivePermission || $[45] !== release.state ? (t92 = ["scheduled", "scheduling"].includes(release.state) || !hasArchivePermission, $[44] = hasArchivePermission, $[45] = release.state, $[46] = t92) : t92 = $[46];
    let t102;
    $[47] !== handleOnInitiateAction || $[48] !== t72 || $[49] !== t82 || $[50] !== t92 ? (t102 = /* @__PURE__ */ jsx(MenuItem$1, { tooltipProps: t72, "data-value": "archive", onClick: handleOnInitiateAction, icon: ArchiveIcon, text: t82, "data-testid": "archive-release-menu-item", disabled: t92 }), $[47] = handleOnInitiateAction, $[48] = t72, $[49] = t82, $[50] = t92, $[51] = t102) : t102 = $[51], t4 = t102;
  }
  const archiveUnarchiveMenuItem = t4;
  let t5;
  bb1: {
    if (release.state !== "archived" && release.state !== "published") {
      t5 = null;
      break bb1;
    }
    const t62 = releaseMenuDisabled || !hasDeletePermission;
    let t72;
    $[52] !== t ? (t72 = t("action.delete-release"), $[52] = t, $[53] = t72) : t72 = $[53];
    let t82;
    $[54] !== hasDeletePermission || $[55] !== t ? (t82 = !hasDeletePermission && t("permissions.error.delete"), $[54] = hasDeletePermission, $[55] = t, $[56] = t82) : t82 = $[56];
    let t92;
    $[57] !== t82 ? (t92 = {
      content: t82
    }, $[57] = t82, $[58] = t92) : t92 = $[58];
    let t102;
    $[59] !== handleOnInitiateAction || $[60] !== t62 || $[61] !== t72 || $[62] !== t92 ? (t102 = /* @__PURE__ */ jsx(MenuItem$1, { "data-value": "delete", onClick: handleOnInitiateAction, disabled: t62, icon: TrashIcon, text: t72, "data-testid": "delete-release-menu-item", tooltipProps: t92 }), $[59] = handleOnInitiateAction, $[60] = t62, $[61] = t72, $[62] = t92, $[63] = t102) : t102 = $[63], t5 = t102;
  }
  const deleteMenuItem = t5;
  let t6;
  bb2: {
    if (ignoreCTA || release.state !== "scheduled" && release.state !== "scheduling") {
      t6 = null;
      break bb2;
    }
    let t72;
    $[64] !== t ? (t72 = t("action.unschedule"), $[64] = t, $[65] = t72) : t72 = $[65];
    let t82;
    $[66] !== handleOnInitiateAction || $[67] !== releaseMenuDisabled || $[68] !== t72 ? (t82 = /* @__PURE__ */ jsx(MenuItem$1, { "data-value": "unschedule", onClick: handleOnInitiateAction, disabled: releaseMenuDisabled, icon: CloseCircleIcon, text: t72, "data-testid": "unschedule-release-menu-item" }), $[66] = handleOnInitiateAction, $[67] = releaseMenuDisabled, $[68] = t72, $[69] = t82) : t82 = $[69], t6 = t82;
  }
  const unscheduleMenuItem = t6;
  let t7;
  bb3: {
    if (release.state !== "active" || ignoreCTA && release.metadata.releaseType === "scheduled") {
      t7 = null;
      break bb3;
    }
    const t82 = releaseMenuDisabled || !hasSchedulePermission;
    let t102, t92;
    $[70] !== setSelectedAction ? (t92 = () => setSelectedAction(void 0), t102 = () => setSelectedAction("schedule"), $[70] = setSelectedAction, $[71] = t102, $[72] = t92) : (t102 = $[71], t92 = $[72]);
    let t11;
    $[73] !== documents || $[74] !== release || $[75] !== t102 || $[76] !== t82 || $[77] !== t92 ? (t11 = /* @__PURE__ */ jsx(ReleaseScheduleButton, { disabled: t82, release, documents, isMenuItem: !0, onConfirmDialogClose: t92, onConfirmDialogOpen: t102 }), $[73] = documents, $[74] = release, $[75] = t102, $[76] = t82, $[77] = t92, $[78] = t11) : t11 = $[78], t7 = t11;
  }
  const scheduleMenuItem = t7;
  let t8;
  bb4: {
    if (release.state !== "active" || ignoreCTA && release.metadata.releaseType !== "scheduled") {
      t8 = null;
      break bb4;
    }
    const t92 = releaseMenuDisabled || !hasPublishPermission;
    let t102, t11;
    $[79] !== setSelectedAction ? (t102 = () => setSelectedAction(void 0), t11 = () => setSelectedAction("publish"), $[79] = setSelectedAction, $[80] = t102, $[81] = t11) : (t102 = $[80], t11 = $[81]);
    let t12;
    $[82] !== documents || $[83] !== release || $[84] !== t102 || $[85] !== t11 || $[86] !== t92 ? (t12 = /* @__PURE__ */ jsx(ReleasePublishAllButton, { release, documents, disabled: t92, isMenuItem: !0, onConfirmDialogClose: t102, onConfirmDialogOpen: t11 }), $[82] = documents, $[83] = release, $[84] = t102, $[85] = t11, $[86] = t92, $[87] = t12) : t12 = $[87], t8 = t12;
  }
  const publishMenuItem = t8;
  let t9;
  bb5: {
    if (release.metadata.releaseType === "scheduled") {
      let t103;
      $[88] !== publishMenuItem || $[89] !== scheduleMenuItem ? (t103 = /* @__PURE__ */ jsxs(Fragment, { children: [
        scheduleMenuItem,
        publishMenuItem
      ] }), $[88] = publishMenuItem, $[89] = scheduleMenuItem, $[90] = t103) : t103 = $[90], t9 = t103;
      break bb5;
    }
    let t102;
    $[91] !== publishMenuItem || $[92] !== scheduleMenuItem ? (t102 = /* @__PURE__ */ jsxs(Fragment, { children: [
      publishMenuItem,
      scheduleMenuItem
    ] }), $[91] = publishMenuItem, $[92] = scheduleMenuItem, $[93] = t102) : t102 = $[93], t9 = t102;
  }
  const ActionsOrder = t9;
  let t10;
  return $[94] !== ActionsOrder || $[95] !== archiveUnarchiveMenuItem || $[96] !== deleteMenuItem || $[97] !== unscheduleMenuItem ? (t10 = /* @__PURE__ */ jsxs(Fragment, { children: [
    unscheduleMenuItem,
    ActionsOrder,
    archiveUnarchiveMenuItem,
    deleteMenuItem
  ] }), $[94] = ActionsOrder, $[95] = archiveUnarchiveMenuItem, $[96] = deleteMenuItem, $[97] = unscheduleMenuItem, $[98] = t10) : t10 = $[98], t10;
};
function ReleasePreviewCard(t0) {
  const $ = c(17), {
    release
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== release ? (t1 = getReleaseTone(release), $[0] = release, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(ReleaseAvatar, { tone: t1, padding: 0 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== release.metadata.title || $[5] !== t ? (t3 = release.metadata.title || t("release.placeholder-untitled-release"), $[4] = release.metadata.title, $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== release ? (t5 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ReleaseTime, { release }) }), $[9] = release, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== t4 || $[12] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t4,
    t5
  ] }), $[11] = t4, $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  return $[14] !== t2 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsx(Card, { border: !0, padding: 1, radius: 2, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, padding: 3, children: [
    t2,
    t6
  ] }) }), $[14] = t2, $[15] = t6, $[16] = t7) : t7 = $[16], t7;
}
const ReleaseMenuButton = ({
  ignoreCTA,
  release,
  documentsCount,
  documents
}) => {
  const toast = useToast(), router = useRouter(), {
    archive,
    unarchive,
    deleteRelease,
    unschedule
  } = useReleaseOperations(), [isPerformingOperation, setIsPerformingOperation] = useState(!1), [selectedAction, setSelectedAction] = useState(), {
    selectedReleaseId
  } = usePerspective(), setPerspective = useSetPerspective(), popoverRef = useRef(null), releaseMenuRef = useRef(null), [openPopover, setOpenPopover] = useState(!1), releaseMenuDisabled = !release, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), telemetry = useTelemetry(), {
    guardWithReleaseLimitUpsell
  } = useReleasesUpsell(), releaseTitle = release.metadata.title || tCore("release.placeholder-untitled-release"), isActionPublishOrSchedule = selectedAction === "publish" || selectedAction === "schedule", handleDelete = useCallback(async () => {
    await deleteRelease(release._id), router.navigate({});
  }, [deleteRelease, release._id, router]), handleUnarchive = useCallback(async () => guardWithReleaseLimitUpsell(() => unarchive(release._id), !0), [guardWithReleaseLimitUpsell, release._id, unarchive]), handleAction = useCallback(async (action) => {
    if (action === "publish" || action === "schedule" || releaseMenuDisabled) return;
    const actionLookup = {
      delete: handleDelete,
      archive,
      unarchive: handleUnarchive,
      unschedule
    }, actionValues = RELEASE_ACTION_MAP[action];
    try {
      (action === "archive" || action === "delete") && selectedReleaseId === getReleaseIdFromReleaseDocumentId(release._id) && setPerspective("drafts"), setIsPerformingOperation(!0), await actionLookup[action](release._id), telemetry.log(actionValues.telemetry), typeof actionValues.toastSuccessI18nKey < "u" && toast.push({
        closable: !0,
        status: "success",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: actionValues.toastSuccessI18nKey, values: {
          title: releaseTitle
        } }) })
      });
    } catch (actionError) {
      if (isReleaseLimitError(actionError)) return;
      typeof actionValues.toastFailureI18nKey < "u" && toast.push({
        status: "error",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: actionValues.toastFailureI18nKey, values: {
          title: releaseTitle,
          error: actionError.toString()
        } }) })
      }), console.error(actionError);
    } finally {
      setIsPerformingOperation(!1), setSelectedAction(void 0);
    }
  }, [releaseMenuDisabled, handleDelete, archive, handleUnarchive, unschedule, telemetry, toast, t, releaseTitle, selectedReleaseId, setPerspective, release._id]);
  useEffect(() => {
    !selectedAction || isActionPublishOrSchedule || RELEASE_ACTION_MAP[selectedAction].confirmDialog || handleAction(selectedAction);
  }, [documentsCount, handleAction, isActionPublishOrSchedule, selectedAction]);
  const confirmActionDialog = useMemo(() => {
    if (!selectedAction || isActionPublishOrSchedule) return null;
    const {
      confirmDialog
    } = RELEASE_ACTION_MAP[selectedAction];
    return confirmDialog ? /* @__PURE__ */ jsx(Dialog$1, { id: confirmDialog.dialogId, "data-testid": confirmDialog.dialogId, header: t(confirmDialog.dialogHeaderI18nKey), onClose: () => !isPerformingOperation && setSelectedAction(void 0), padding: !1, footer: {
      confirmButton: {
        text: t(confirmDialog.dialogConfirmButtonI18nKey),
        tone: confirmDialog.confirmButtonTone,
        onClick: () => handleAction(selectedAction),
        loading: isPerformingOperation,
        disabled: isPerformingOperation
      },
      cancelButton: {
        disabled: isPerformingOperation
      }
    }, children: /* @__PURE__ */ jsxs(Stack, { space: 4, paddingX: 4, paddingBottom: 4, children: [
      /* @__PURE__ */ jsx(ReleasePreviewCard, { release }),
      !!documentsCount && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: confirmDialog.dialogDescriptionI18nKey, values: {
        count: documentsCount
      } }) })
    ] }) }) : null;
  }, [selectedAction, isActionPublishOrSchedule, t, isPerformingOperation, release, documentsCount, handleAction]), handleOnButtonClick = () => {
    openPopover ? closePopover() : setOpenPopover(!0);
  }, closePopover = () => {
    setOpenPopover(!1);
  };
  useClickOutsideEvent(() => {
    isActionPublishOrSchedule || closePopover();
  }, () => [popoverRef.current, releaseMenuRef.current]);
  const handleSetSelectedAction = useCallback((action_0) => {
    action_0 || closePopover(), setSelectedAction(action_0);
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Popover, { content: /* @__PURE__ */ jsx(Menu, { ref: releaseMenuRef, children: /* @__PURE__ */ jsx(ReleaseMenu, { ignoreCTA, release, setSelectedAction: handleSetSelectedAction, disabled: isPerformingOperation, documents: documents ?? [] }) }), open: openPopover, ref: popoverRef, constrainSize: !1, fallbackPlacements: ["top-end"], portal: !0, tone: "default", placement: "bottom", children: /* @__PURE__ */ jsx(Button, { disabled: releaseMenuDisabled || isPerformingOperation, icon: isPerformingOperation ? Spinner : EllipsisHorizontalIcon, mode: "bleed", tooltipProps: {
      content: t("menu.tooltip")
    }, "aria-label": t("menu.label"), "data-testid": "release-menu-button", onClick: handleOnButtonClick }) }),
    confirmActionDialog
  ] });
};
function StatusItem(props2) {
  const $ = c(13), {
    avatar,
    text,
    testId
  } = props2;
  let t0;
  $[0] !== avatar ? (t0 = avatar && /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx("div", { style: {
    margin: -1
  }, children: avatar }) }), $[0] = avatar, $[1] = t0) : t0 = $[1];
  const t1 = avatar ? 1 : void 0;
  let t2;
  $[2] !== text ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: text }), $[2] = text, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t1 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { padding: 2, paddingLeft: t1, children: t2 }), $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t0 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    t3
  ] }), $[7] = t0, $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== t4 || $[11] !== testId ? (t5 = /* @__PURE__ */ jsx(Card, { "data-testid": testId, children: t4 }), $[10] = t4, $[11] = testId, $[12] = t5) : t5 = $[12], t5;
}
const STATUS_TITLE_I18N = {
  createRelease: "footer.status.created",
  publishRelease: "footer.status.published",
  archiveRelease: "footer.status.archived",
  unarchiveRelease: "footer.status.unarchived"
};
function ReleaseStatusItems(t0) {
  const $ = c(13), {
    events: events2,
    release
  } = t0, {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1, t2;
  if ($[0] !== events2) {
    const createEvent = events2.find(isCreateReleaseEvent), extraEvent = events2.find(_temp$2l);
    t2 = [createEvent, extraEvent].filter(isNonNullable$3), $[0] = events2, $[1] = t2;
  } else
    t2 = $[1];
  t1 = t2;
  const footerEvents = t1;
  if (!footerEvents.length) {
    let t32;
    $[2] === Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: 0 }), $[2] = t32) : t32 = $[2];
    let t4;
    $[3] !== t ? (t4 = t(STATUS_TITLE_I18N.createRelease), $[3] = t, $[4] = t4) : t4 = $[4];
    let t5;
    $[5] !== release._createdAt ? (t5 = /* @__PURE__ */ jsx(RelativeTime, { time: release._createdAt, useTemporalPhrase: !0, minimal: !0 }), $[5] = release._createdAt, $[6] = t5) : t5 = $[6];
    let t6;
    return $[7] !== t4 || $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: /* @__PURE__ */ jsx(StatusItem, { avatar: t32, text: /* @__PURE__ */ jsxs(Fragment, { children: [
      t4,
      " ",
      t5
    ] }) }) }), $[7] = t4, $[8] = t5, $[9] = t6) : t6 = $[9], t6;
  }
  let t3;
  return $[10] !== footerEvents || $[11] !== t ? (t3 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: footerEvents.map((event_0) => /* @__PURE__ */ jsx(StatusItem, { testId: `status-${event_0.type}`, avatar: event_0.author && /* @__PURE__ */ jsx(UserAvatar, { size: 0, user: event_0.author }), text: /* @__PURE__ */ jsxs(Fragment, { children: [
    t(STATUS_TITLE_I18N[event_0.type]),
    " ",
    /* @__PURE__ */ jsx(RelativeTime, { time: event_0.timestamp, useTemporalPhrase: !0, minimal: !0 })
  ] }) }, event_0.id)) }), $[10] = footerEvents, $[11] = t, $[12] = t3) : t3 = $[12], t3;
}
function _temp$2l(event) {
  return isPublishReleaseEvent(event) || isArchiveReleaseEvent(event) || isUnarchiveReleaseEvent(event);
}
function ReleaseDashboardFooter(props2) {
  const $ = c(30), {
    documents,
    release,
    events: events2
  } = props2;
  let t0;
  bb0: {
    if (release.state === "archived") {
      t0 = null;
      break bb0;
    }
    if (isReleaseScheduledOrScheduling(release)) {
      const t12 = !documents.length;
      let t22;
      $[0] !== documents || $[1] !== release || $[2] !== t12 ? (t22 = /* @__PURE__ */ jsx(ReleaseUnscheduleButton, { release, documents, disabled: t12 }), $[0] = documents, $[1] = release, $[2] = t12, $[3] = t22) : t22 = $[3], t0 = t22;
      break bb0;
    }
    if (release.state === "active") {
      if (release.metadata.releaseType === "scheduled") {
        const t12 = !documents.length;
        let t22;
        $[4] !== documents || $[5] !== release || $[6] !== t12 ? (t22 = /* @__PURE__ */ jsx(ReleaseScheduleButton, { release, documents, disabled: t12 }), $[4] = documents, $[5] = release, $[6] = t12, $[7] = t22) : t22 = $[7], t0 = t22;
        break bb0;
      }
      if (release.metadata.releaseType === "asap") {
        const t12 = !documents.length;
        let t22;
        $[8] !== documents || $[9] !== release || $[10] !== t12 ? (t22 = /* @__PURE__ */ jsx(ReleasePublishAllButton, { release, documents, disabled: t12 }), $[8] = documents, $[9] = release, $[10] = t12, $[11] = t22) : t22 = $[11], t0 = t22;
        break bb0;
      }
    }
    if (release.state === "published") {
      const t12 = !documents.length;
      let t22;
      $[12] !== documents || $[13] !== release || $[14] !== t12 ? (t22 = /* @__PURE__ */ jsx(ReleaseRevertButton, { release, documents, disabled: t12 }), $[12] = documents, $[13] = release, $[14] = t12, $[15] = t22) : t22 = $[15], t0 = t22;
      break bb0;
    }
    t0 = null;
  }
  const releaseActionButton = t0;
  let t1;
  $[16] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Card, { borderTop: !0, marginX: 2, style: {
    opacity: 0.6
  } }), $[16] = t1) : t1 = $[16];
  let t2;
  $[17] !== events2 || $[18] !== release ? (t2 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: /* @__PURE__ */ jsx(ReleaseStatusItems, { events: events2, release }) }), $[17] = events2, $[18] = release, $[19] = t2) : t2 = $[19];
  const t3 = release.metadata.releaseType !== "undecided";
  let t4;
  $[20] !== documents || $[21] !== release || $[22] !== t3 ? (t4 = /* @__PURE__ */ jsx(ReleaseMenuButton, { release, documentsCount: documents.length, documents, ignoreCTA: t3 }), $[20] = documents, $[21] = release, $[22] = t3, $[23] = t4) : t4 = $[23];
  let t5;
  $[24] !== releaseActionButton || $[25] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { flex: "none", gap: 1, "data-testid": "release-dashboard-footer-actions", children: [
    releaseActionButton,
    t4
  ] }), $[24] = releaseActionButton, $[25] = t4, $[26] = t5) : t5 = $[26];
  let t6;
  return $[27] !== t2 || $[28] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Card, { flex: "none", children: [
    t1,
    /* @__PURE__ */ jsxs(Flex, { padding: 3, children: [
      t2,
      t5
    ] })
  ] }), $[27] = t2, $[28] = t5, $[29] = t6) : t6 = $[29], t6;
}
const DATE_SEARCH_PARAM_KEY = "date", GROUP_SEARCH_PARAM_KEY = "group", getInitialFilterDate = (router) => () => {
  const activeFilterDate = new URLSearchParams(router.state._searchParams).get(DATE_SEARCH_PARAM_KEY);
  return activeFilterDate ? new Date(activeFilterDate) : void 0;
}, getInitialReleaseGroupMode = (router) => () => new URLSearchParams(router.state._searchParams).get(GROUP_SEARCH_PARAM_KEY) === "archived" ? "archived" : "active";
function ReleaseDashboardHeader(props2) {
  const $ = c(34), {
    inspector,
    release,
    setInspector
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation();
  let t0;
  $[0] !== release.metadata.title || $[1] !== tCore ? (t0 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[0] = release.metadata.title, $[1] = tCore, $[2] = t0) : t0 = $[2];
  const title = t0, router = useRouter();
  let t1;
  $[3] !== release.state || $[4] !== router ? (t1 = () => {
    const isReleaseOpen = release.state !== "archived" && release.state !== "published";
    router.navigate({
      _searchParams: isReleaseOpen ? void 0 : [[GROUP_SEARCH_PARAM_KEY, "archived"]]
    });
  }, $[3] = release.state, $[4] = router, $[5] = t1) : t1 = $[5];
  const handleNavigateToReleasesList = t1;
  let t2;
  $[6] !== setInspector ? (t2 = () => {
    setInspector(_temp$2k);
  }, $[6] = setInspector, $[7] = t2) : t2 = $[7];
  const handleActivityClick = t2;
  let t3;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Box, { paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }) }), $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t ? (t4 = t("overview.title"), $[9] = t, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== handleNavigateToReleasesList || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", onClick: handleNavigateToReleasesList, text: t4, textWeight: "regular", padding: 2, "data-testid": "back-to-releases-button" }), $[11] = handleNavigateToReleasesList, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== tCore || $[15] !== title ? (t6 = title || tCore("release.placeholder-untitled-release"), $[14] = tCore, $[15] = title, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== title ? (t7 = title ? void 0 : {
    opacity: 0.5
  }, $[17] = title, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== t6 || $[20] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", text: t6, textWeight: "semibold", padding: 2, style: t7 }), $[19] = t6, $[20] = t7, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] !== t5 || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: /* @__PURE__ */ jsxs(Breadcrumbs, { space: 0, separator: t3, children: [
    t5,
    t8
  ] }) }), $[22] = t5, $[23] = t8, $[24] = t9) : t9 = $[24];
  const t10 = inspector === "activity";
  let t11;
  $[25] !== t ? (t11 = t("dashboard.details.activity"), $[25] = t, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== handleActivityClick || $[28] !== t10 || $[29] !== t11 ? (t12 = /* @__PURE__ */ jsx(Flex, { flex: "none", gap: 2, children: /* @__PURE__ */ jsx(Button$1, { icon: RestoreIcon, mode: "bleed", onClick: handleActivityClick, padding: 2, selected: t10, space: 2, text: t11 }) }), $[27] = handleActivityClick, $[28] = t10, $[29] = t11, $[30] = t12) : t12 = $[30];
  let t13;
  return $[31] !== t12 || $[32] !== t9 ? (t13 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", children: [
    t9,
    t12
  ] }), $[31] = t12, $[32] = t9, $[33] = t13) : t13 = $[33], t13;
}
function _temp$2k(prev) {
  return prev === "activity" ? void 0 : "activity";
}
const TableProvider = (t0) => {
  const $ = c(7), {
    children,
    defaultSort
  } = t0, [searchTerm, setSearchTerm] = useState(null), [sort, setSort] = useState(defaultSort || null);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = (newColumn) => {
    setSort((s) => s?.column === newColumn ? {
      ...s,
      direction: s.direction === "asc" ? "desc" : "asc"
    } : {
      column: String(newColumn),
      direction: "desc"
    });
  }, $[0] = t1) : t1 = $[0];
  const setSortColumn = t1;
  let t2;
  $[1] !== searchTerm || $[2] !== sort ? (t2 = {
    searchTerm,
    setSearchTerm,
    sort,
    setSortColumn
  }, $[1] = searchTerm, $[2] = sort, $[3] = t2) : t2 = $[3];
  const contextValue = t2;
  let t3;
  return $[4] !== children || $[5] !== contextValue ? (t3 = /* @__PURE__ */ jsx(TableContext.Provider, { value: contextValue, children }), $[4] = children, $[5] = contextValue, $[6] = t3) : t3 = $[6], t3;
}, useTableContext = () => {
  const context = useContext(TableContext);
  if (!context)
    throw new Error("useTableContext must be used within a TableProvider");
  return context;
}, MotionIcon = motion.create(ArrowUpIcon), BasicHeader = (t0) => {
  const $ = c(2), {
    text
  } = t0;
  let t1;
  return $[0] !== text ? (t1 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: text }) }), $[0] = text, $[1] = t1) : t1 = $[1], t1;
}, SortHeaderButton = (t0) => {
  const $ = c(12), {
    header,
    text
  } = t0, {
    sort,
    setSortColumn
  } = useTableContext();
  let t1;
  const t2 = sort?.direction === "asc" ? 0 : 180;
  let t3;
  $[0] !== t2 ? (t3 = {
    rotate: t2
  }, $[0] = t2, $[1] = t3) : t3 = $[1];
  let t4;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    duration: 0.25,
    ease: "easeInOut"
  }, $[2] = t4) : t4 = $[2];
  let t5;
  $[3] !== t3 ? (t5 = /* @__PURE__ */ jsx(MotionIcon, { initial: !1, animate: t3, transition: t4 }), $[3] = t3, $[4] = t5) : t5 = $[4], t1 = t5;
  const sortIcon = t1, t6 = header.sorting && sort?.column === header.id ? sortIcon : void 0;
  let t7;
  $[5] !== header.id || $[6] !== setSortColumn ? (t7 = () => setSortColumn(String(header.id)), $[5] = header.id, $[6] = setSortColumn, $[7] = t7) : t7 = $[7];
  let t8;
  return $[8] !== t6 || $[9] !== t7 || $[10] !== text ? (t8 = /* @__PURE__ */ jsx(Button, { iconRight: t6, onClick: t7, mode: "bleed", size: "default", text }), $[8] = t6, $[9] = t7, $[10] = text, $[11] = t8) : t8 = $[11], t8;
}, TableHeaderSearch = (t0) => {
  const $ = c(16), {
    headerProps,
    searchDisabled,
    placeholder
  } = t0, {
    t
  } = useTranslation(), {
    setSearchTerm,
    searchTerm
  } = useTableContext();
  let t1;
  $[0] !== placeholder || $[1] !== t ? (t1 = placeholder || t("search.placeholder"), $[0] = placeholder, $[1] = t, $[2] = t1) : t1 = $[2];
  const t2 = searchTerm || "";
  let t3, t4;
  $[3] !== setSearchTerm ? (t3 = (event) => setSearchTerm(event.currentTarget.value), t4 = () => setSearchTerm(""), $[3] = setSearchTerm, $[4] = t3, $[5] = t4) : (t3 = $[4], t4 = $[5]);
  const t5 = !!searchTerm;
  let t6;
  $[6] !== searchDisabled || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextInput$1, { border: !1, fontSize: 1, icon: SearchIcon, placeholder: t1, radius: 3, value: t2, disabled: searchDisabled, onChange: t3, onClear: t4, clearButton: t5 }), $[6] = searchDisabled, $[7] = t1, $[8] = t2, $[9] = t3, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== headerProps || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(Stack, { ...headerProps, flex: 1, paddingY: 2, paddingRight: 3, sizing: "border", children: t6 }), $[13] = headerProps, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
}, TableHeader = (t0) => {
  const $ = c(8), {
    headers,
    searchDisabled
  } = t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    paddingInline: `max(
          calc((100% - var(--maxInlineSize)) / 2),
          var(--paddingInline)
        )`
  }, $[0] = t1) : t1 = $[0];
  let t2;
  if ($[1] !== headers || $[2] !== searchDisabled) {
    let t32;
    $[4] !== searchDisabled ? (t32 = (t4) => {
      const {
        header: Header2,
        style,
        width,
        id: id2,
        sorting
      } = t4;
      return !!Header2 && /* @__PURE__ */ jsx(Header2, { headerProps: {
        as: "th",
        id: String(id2),
        style: {
          ...style,
          width: width || void 0
        }
      }, header: {
        id: id2,
        sorting
      }, searchDisabled }, String(id2));
    }, $[4] = searchDisabled, $[5] = t32) : t32 = $[5], t2 = headers.map(t32), $[1] = headers, $[2] = searchDisabled, $[3] = t2;
  } else
    t2 = $[3];
  let t3;
  return $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { as: "thead", borderBottom: !0, children: /* @__PURE__ */ jsx(Flex, { as: "tr", style: t1, children: t2 }) }), $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, Headers = {
  SortHeaderButton,
  TableHeaderSearch,
  BasicHeader
}, ITEM_HEIGHT$3 = 59, LOADING_ROW_COUNT = 3, withVirtualizerOffset = ({
  scrollContainerRef,
  virtualizerContainerRef,
  range: range2
}) => {
  const parentOffset = scrollContainerRef.current?.offsetTop ?? 0, virtualizerScrollMargin = (virtualizerContainerRef.current?.offsetTop ?? 0) - parentOffset, topItemsOffset = Math.ceil(virtualizerScrollMargin / ITEM_HEIGHT$3), startIndexWithOffset = range2.startIndex - topItemsOffset;
  return defaultRangeExtractor({
    ...range2,
    // By modifying the startIndex, we are adding more elements to the start of the virtualizer
    startIndex: startIndexWithOffset > 0 ? startIndexWithOffset : 0
  });
}, TableInner = ({
  columnDefs,
  data,
  emptyState,
  searchFilter,
  rowId,
  rowActions,
  loading = !1,
  rowProps = () => ({}),
  scrollContainerRef,
  hideTableInlinePadding = !1
}) => {
  const {
    searchTerm,
    sort
  } = useTableContext(), virtualizerContainerRef = useRef(null), filteredData = useMemo(() => {
    const filteredResult = searchTerm && searchFilter ? searchFilter(data, searchTerm) : data;
    if (!sort) return filteredResult;
    const sortColumn = columnDefs.find((column) => column.id === sort.column);
    return [...filteredResult].sort((a, b) => {
      let order;
      const [aValue, bValue] = [a, b].map((sortValue) => sortColumn?.sortTransform?.(sortValue, sort.direction) ?? get(sortValue, sort.column));
      if (typeof aValue == "string" && typeof bValue == "string" && !isValid(aValue) && !isValid(bValue))
        order = aValue.toLowerCase().localeCompare(bValue.toLowerCase());
      else {
        const parseDate2 = (datum) => sortColumn?.sortTransform && typeof datum == "number" ? datum : typeof datum == "string" ? Date.parse(datum) : 0, [aDate, bDate] = [aValue, bValue].map(parseDate2);
        order = aDate - bDate;
      }
      return sort.direction === "asc" ? order : -order;
    });
  }, [columnDefs, data, searchFilter, searchTerm, sort]), rowVirtualizer = useVirtualizer({
    count: filteredData.length,
    getScrollElement: () => scrollContainerRef.current,
    estimateSize: () => ITEM_HEIGHT$3,
    overscan: 5,
    rangeExtractor: (range2) => withVirtualizerOffset({
      scrollContainerRef,
      virtualizerContainerRef,
      range: range2
    })
  }), rowActionColumnDef = useMemo(() => ({
    id: "actions",
    sorting: !1,
    width: 50,
    header: ({
      headerProps: {
        id: id2
      }
    }) => /* @__PURE__ */ jsx(Flex, { as: "th", id: id2, paddingY: 3, paddingX: 3, sizing: "border", style: {
      width: "50px"
    }, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: "\xA0" }) }),
    cell: ({
      datum: datum_0,
      cellProps: {
        id: id_0
      }
    }) => /* @__PURE__ */ jsx(Flex, { as: "td", id: id_0, align: "center", flex: "none", padding: 3, style: {
      width: "25px"
    }, children: !datum_0.isLoading && rowActions?.({
      datum: datum_0
    }) || /* @__PURE__ */ jsx(Box, { style: {
      width: "25px"
    } }) })
  }), [rowActions]), amalgamatedColumnDefs = useMemo(() => (rowActions ? [...columnDefs, rowActionColumnDef] : columnDefs).filter((column_0) => !column_0.hidden), [columnDefs, rowActionColumnDef, rowActions]), renderRow = useMemo(() => function(datum_1) {
    const cardRowProps = rowProps(datum_1), cardKey = loading ? `skeleton-${datum_1.index}` : String(get(datum_1, rowId));
    return /* @__PURE__ */ jsx(Card, { "data-testid": "table-row", as: "tr", borderBottom: !0, display: "flex", style: {
      height: `${datum_1.virtualRow.size}px`,
      transform: `translateY(${datum_1.virtualRow.start - datum_1.index * datum_1.virtualRow.size}px)`,
      paddingInline: `max(
                calc((100% - var(--maxInlineSize)) / 2),
                var(--paddingInline)
              )`
    }, ...cardRowProps, children: amalgamatedColumnDefs.map(({
      cell: Cell,
      style,
      width,
      id: id_1,
      sorting = !1
    }) => /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(Cell, { datum: {
      ...datum_1,
      isLoading: loading
    }, cellProps: {
      as: "td",
      id: String(id_1),
      style: {
        ...style,
        width: width || void 0
      }
    }, sorting }) }, String(id_1))) }, cardKey);
  }, [amalgamatedColumnDefs, loading, rowId, rowProps]), emptyContent = useMemo(() => typeof emptyState == "string" ? /* @__PURE__ */ jsx(Card, { as: "tr", borderBottom: !0, display: "flex", padding: 4, style: {
    justifyContent: "center"
  }, children: /* @__PURE__ */ jsx(Text$1, { as: "td", muted: !0, size: 1, children: emptyState }) }) : emptyState(), [emptyState]), headers = useMemo(() => amalgamatedColumnDefs.map(({
    cell,
    sortTransform,
    ...header
  }) => ({
    ...header,
    id: String(header.id)
  })), [amalgamatedColumnDefs]), theme = useTheme(), maxInlineSize = !hideTableInlinePadding && theme.sanity.v2?.container[3] || 0, renderLoadingRows = (rowRenderer) => Array.from({
    length: LOADING_ROW_COUNT
  }).map((el, index) => {
    const cardKey_0 = `skeleton-${index}`, virtualRow = {
      index,
      start: index * ITEM_HEIGHT$3,
      size: ITEM_HEIGHT$3,
      lane: 0,
      key: cardKey_0,
      end: index * ITEM_HEIGHT$3 + ITEM_HEIGHT$3
    };
    return rowRenderer({
      _id: cardKey_0,
      isLoading: !0,
      virtualRow,
      index,
      isFirst: index === 0,
      isLast: index === LOADING_ROW_COUNT - 1
    });
  }), tableContent = () => loading ? renderLoadingRows(renderRow) : filteredData.length === 0 ? emptyContent : rowVirtualizer.getVirtualItems().map((virtualRow_0, index_0) => {
    const datum_2 = filteredData[virtualRow_0.index];
    return renderRow({
      ...datum_2,
      virtualRow: virtualRow_0,
      index: index_0,
      isFirst: virtualRow_0.index === 0,
      isLast: virtualRow_0.index === filteredData.length - 1
    });
  });
  return /* @__PURE__ */ jsx("div", { ref: virtualizerContainerRef, children: /* @__PURE__ */ jsx("div", { style: {
    width: "100%",
    position: "relative",
    "--maxInlineSize": rem(maxInlineSize),
    "--paddingInline": rem(theme.sanity.v2?.space[3] ?? 0)
  }, children: /* @__PURE__ */ jsxs(Stack, { as: "table", children: [
    /* @__PURE__ */ jsx(TableHeader, { headers, searchDisabled: loading || !searchTerm && !data.length }),
    /* @__PURE__ */ jsx(Stack, { as: "tbody", children: tableContent() })
  ] }) }) });
}, Table = ({
  defaultSort,
  ...props2
}) => /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsx(TableProvider, { defaultSort, children: /* @__PURE__ */ jsx(TableInner, { ...props2 }) }) }), IS_MAC$1 = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), DEBUG_FRAGMENT = "_debug_search_score", DEBUG_MODE = !1, SEARCH_LIMIT = 1e3, GLOBAL_SEARCH_KEY = "k", GLOBAL_SEARCH_KEY_MODIFIER = IS_MAC$1 ? "Cmd" : "Ctrl", POPOVER_INPUT_PADDING = studioTheme.space[4], POPOVER_MAX_HEIGHT = 735, POPOVER_MAX_WIDTH = 800, POPOVER_VERTICAL_MARGIN = 5, POPOVER_RADIUS$1 = 3;
function useSearchState() {
  const context = useContext(SearchContext);
  if (context === void 0)
    throw new Error("useSearchState must be used within an SearchProvider");
  return context;
}
function hasSearchableTerms({
  allowEmptyQueries,
  terms
}) {
  const hasQuery = allowEmptyQueries ? !0 : terms.query.length > 0, hasFilter = !!terms.filter, hasSelectedTypes = terms.types.length > 0;
  return hasQuery || hasFilter || hasSelectedTypes;
}
const isSearchHotKey = isHotkey(`mod+${GLOBAL_SEARCH_KEY}`), isEscape$1 = isHotkey("escape");
function useSearchHotkeys(t0) {
  const $ = c(7), {
    open,
    onClose,
    onOpen
  } = t0, {
    isTopLayer
  } = useLayer();
  let t1;
  $[0] !== onClose ? (t1 = () => {
    onClose?.();
  }, $[0] = onClose, $[1] = t1) : t1 = $[1];
  const handleClose = t1;
  let t2;
  $[2] !== handleClose || $[3] !== isTopLayer || $[4] !== onOpen || $[5] !== open ? (t2 = (event) => {
    isSearchHotKey(event) && (event.preventDefault(), open ? handleClose() : onOpen?.()), isEscape$1(event) && open && isTopLayer && handleClose();
  }, $[2] = handleClose, $[3] = isTopLayer, $[4] = onOpen, $[5] = open, $[6] = t2) : t2 = $[6], useGlobalKeyDown(t2);
}
function SearchWrapper(t0) {
  const $ = c(24), {
    children,
    hasValidTerms,
    onClose,
    onOpen,
    open
  } = t0, isMountedRef = useRef(!1), {
    dispatch,
    searchCommandList,
    setOnClose,
    state: t1
  } = useSearchState(), {
    result
  } = t1;
  let t2;
  $[0] !== dispatch || $[1] !== onClose || $[2] !== searchCommandList ? (t2 = () => {
    dispatch({
      index: searchCommandList?.getTopIndex() ?? -1,
      type: "LAST_ACTIVE_INDEX_SET"
    }), onClose();
  }, $[0] = dispatch, $[1] = onClose, $[2] = searchCommandList, $[3] = t2) : t2 = $[3];
  const handleClose = t2;
  let t3;
  $[4] !== handleClose || $[5] !== onOpen || $[6] !== open ? (t3 = {
    onClose: handleClose,
    onOpen,
    open
  }, $[4] = handleClose, $[5] = onOpen, $[6] = open, $[7] = t3) : t3 = $[7], useSearchHotkeys(t3);
  let t4, t5;
  $[8] !== handleClose || $[9] !== setOnClose ? (t4 = () => {
    setOnClose(() => handleClose);
  }, t5 = [handleClose, setOnClose], $[8] = handleClose, $[9] = setOnClose, $[10] = t4, $[11] = t5) : (t4 = $[10], t5 = $[11]), useEffect(t4, t5);
  let t6, t7;
  $[12] !== dispatch || $[13] !== hasValidTerms || $[14] !== result.loaded ? (t6 = () => {
    (!hasValidTerms || result.loaded) && isMountedRef.current && dispatch({
      index: 0,
      type: "LAST_ACTIVE_INDEX_SET"
    });
  }, t7 = [dispatch, hasValidTerms, result.loaded], $[12] = dispatch, $[13] = hasValidTerms, $[14] = result.loaded, $[15] = t6, $[16] = t7) : (t6 = $[15], t7 = $[16]), useEffect(t6, t7);
  let t8, t9;
  $[17] !== dispatch || $[18] !== hasValidTerms || $[19] !== open ? (t8 = () => {
    !hasValidTerms && isMountedRef.current && !open && dispatch({
      type: "ORDERING_RESET"
    });
  }, t9 = [dispatch, hasValidTerms, open], $[17] = dispatch, $[18] = hasValidTerms, $[19] = open, $[20] = t8, $[21] = t9) : (t8 = $[20], t9 = $[21]), useEffect(t8, t9);
  let t10, t11;
  return $[22] === Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    isMountedRef?.current || (isMountedRef.current = !0);
  }, t11 = [], $[22] = t10, $[23] = t11) : (t10 = $[22], t11 = $[23]), useEffect(t10, t11), children;
}
function createFilterDefinitionDictionary(filterDefinitions2) {
  return filterDefinitions2.reduce((acc, val) => (acc[val.name] = val, acc), {});
}
function defineSearchFilter(filterDef) {
  return filterDef;
}
function defineSearchFilterOperators(operators) {
  return operators;
}
function getFilterDefinition(definitions, filterName) {
  return definitions[filterName];
}
function getSupportedFieldTypes(filterDefs) {
  return filterDefs.reduce((acc, val) => (val.type === "field" && acc.push(val.fieldType), acc), []);
}
function createOperatorDefinitionDictionary(operatorDefinitions2) {
  return operatorDefinitions2.reduce((acc, val) => (acc[val.type] = val, acc), {});
}
function getOperatorDefinition(operators, operatorType) {
  return operatorType ? operators[operatorType] : void 0;
}
function getOperatorInitialValue(operators, operatorType) {
  return getOperatorDefinition(operators, operatorType)?.initialValue;
}
function buildSearchFilter(filterDefinition, fieldId) {
  return {
    fieldId,
    filterName: filterDefinition.name,
    operatorType: filterDefinition?.operators.find((operator) => operator.type === "item")?.name || ""
  };
}
function generateFilterQuery({
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  filters,
  operatorDefinitions: operatorDefinitions2
}) {
  return filters.filter((filter2) => validateFilter({
    filter: filter2,
    filterDefinitions: filterDefinitions2,
    fieldDefinitions,
    operatorDefinitions: operatorDefinitions2
  })).map((filter2) => getOperatorDefinition(operatorDefinitions2, filter2.operatorType)?.groqFilter({
    fieldPath: resolveFieldPath({
      filter: filter2,
      fieldDefinitions,
      filterDefinitions: filterDefinitions2
    }),
    value: filter2?.value
  })).filter((filter2) => !isEmpty$1(filter2)).filter(isNonNullable$3).join(" && ");
}
function getFieldFromFilter(fields, filter2) {
  return filter2?.fieldId ? fields[filter2.fieldId] : void 0;
}
function getFilterKey(filter2) {
  return [filter2.filterName, ...filter2.fieldId ? [filter2.fieldId] : []].join("-");
}
function narrowDocumentTypes({
  fieldDefinitions,
  filters,
  types
}) {
  const selectedDocumentTypes = types.map((type) => type.name), filteredDocumentTypes = Object.values(fieldDefinitions).filter((field) => filters.map((filter2) => filter2?.fieldId).includes(field.id)).filter((field) => field.documentTypes.length > 0).map((field) => field.documentTypes), intersectingDocumentTypes = intersection(...filteredDocumentTypes), documentTypes = [];
  return selectedDocumentTypes.length > 0 && documentTypes.push(selectedDocumentTypes), intersectingDocumentTypes.length > 0 && documentTypes.push(intersectingDocumentTypes), intersection(...documentTypes).sort();
}
function resolveFieldPath({
  filter: filter2,
  fieldDefinitions,
  filterDefinitions: filterDefinitions2
}) {
  const fieldDefinition = getFieldFromFilter(fieldDefinitions, filter2), filterDefinition = getFilterDefinition(filterDefinitions2, filter2.filterName);
  if (filterDefinition)
    switch (filterDefinition.type) {
      case "field":
        return fieldDefinition?.fieldPath;
      case "pinned":
        return filterDefinition?.fieldPath;
      default:
        return;
    }
}
function validateFilter({
  filter: filter2,
  filterDefinitions: filterDefinitions2,
  fieldDefinitions,
  operatorDefinitions: operatorDefinitions2
}) {
  const filterDef = getFilterDefinition(filterDefinitions2, filter2.filterName), operatorDef = getOperatorDefinition(operatorDefinitions2, filter2.operatorType), fieldDef = getFieldFromFilter(fieldDefinitions, filter2);
  return !(!filterDef || !operatorDef || filter2.fieldId && !fieldDef || filterDef.type === "field" && (!fieldDef?.fieldPath || !filter2.fieldId || !operatorDef.groqFilter({
    fieldPath: fieldDef.fieldPath,
    value: filter2.value
  })) || filterDef.type === "pinned" && !operatorDef.groqFilter({
    fieldPath: filterDef.fieldPath,
    value: filter2.value
  }));
}
const isEscape = isHotkey("escape"), MAX_HEIGHT = 500, HiddenOverlay = styled.div`
  background: transparent;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: -1;
`;
function FilterPopoverWrapper(t0) {
  const $ = c(15), {
    anchorElement,
    children,
    onClose
  } = t0, {
    isTopLayer
  } = useLayer();
  let t1;
  $[0] !== isTopLayer || $[1] !== onClose ? (t1 = (event) => {
    isEscape(event) && isTopLayer && onClose();
  }, $[0] = isTopLayer, $[1] = onClose, $[2] = t1) : t1 = $[2], useGlobalKeyDown(t1);
  const popoverOffset = usePopoverOffset(anchorElement || null);
  let t2;
  $[3] !== onClose ? (t2 = /* @__PURE__ */ jsx(HiddenOverlay, { onClick: onClose }), $[3] = onClose, $[4] = t2) : t2 = $[4];
  const t3 = `min(calc(100vh - ${popoverOffset}px - ${POPOVER_VERTICAL_MARGIN}px - ${POPOVER_INPUT_PADDING}px), ${MAX_HEIGHT}px`;
  let t4;
  $[5] !== t3 ? (t4 = {
    maxHeight: t3,
    zIndex: 1
  }, $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== children ? (t5 = /* @__PURE__ */ jsx(Flex, { children }), $[7] = children, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t4 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsx(FocusLock, { autoFocus: !1, returnFocus: !0, children: /* @__PURE__ */ jsx(Card, { display: "flex", overflow: "hidden", radius: POPOVER_RADIUS$1, style: t4, children: t5 }) }), $[9] = t4, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== t2 || $[13] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t2,
    t6
  ] }), $[12] = t2, $[13] = t6, $[14] = t7) : t7 = $[14], t7;
}
function calcPopoverOffset(element) {
  const rect = element.getBoundingClientRect();
  return rect.y + rect.height + POPOVER_VERTICAL_MARGIN;
}
function usePopoverOffset(element) {
  const $ = c(10);
  let t0;
  $[0] !== element ? (t0 = element && calcPopoverOffset(element), $[0] = element, $[1] = t0) : t0 = $[1];
  const [offset, setOffset] = useState(t0);
  let t1;
  $[2] !== element ? (t1 = () => {
    element && setOffset(calcPopoverOffset(element));
  }, $[2] = element, $[3] = t1) : t1 = $[3];
  const handleWindowResize = t1;
  let t2, t3;
  $[4] !== element ? (t2 = () => {
    element && setOffset(calcPopoverOffset(element));
  }, t3 = [element], $[4] = element, $[5] = t2, $[6] = t3) : (t2 = $[5], t3 = $[6]), useEffect(t2, t3);
  let t4, t5;
  return $[7] !== handleWindowResize ? (t4 = () => (window.addEventListener("resize", handleWindowResize), () => window.removeEventListener("resize", handleWindowResize)), t5 = [handleWindowResize], $[7] = handleWindowResize, $[8] = t4, $[9] = t5) : (t4 = $[8], t5 = $[9]), useEffect(t4, t5), offset;
}
const CustomTextInputBox = styled(Box)(({
  $background,
  $smallClearButton
}) => css`
    width: 100%;

    input + span {
      background: ${({
  theme
}) => $background ? theme.sanity.color.card.disabled.bg2 : "transparent"};
    }

    [data-qa='clear-button'] {
      background: none;
      box-shadow: none;
      display: flex; /* TODO: hack, currently used to vertically center <TextInput>'s clearButton */
      transform: ${$smallClearButton ? "scale(0.8)" : "scale(1)"};
      &:hover {
        opacity: 0.5;
      }
    }
  `), CustomTextInput = forwardRef(function(props2, ref) {
  const $ = c(11);
  let $background, $smallClearButton, rest;
  $[0] !== props2 ? ({
    $background,
    $smallClearButton,
    ...rest
  } = props2, $[0] = props2, $[1] = $background, $[2] = $smallClearButton, $[3] = rest) : ($background = $[1], $smallClearButton = $[2], rest = $[3]);
  let t0;
  $[4] !== ref || $[5] !== rest ? (t0 = /* @__PURE__ */ jsx(TextInput$1, { ...rest, ref }), $[4] = ref, $[5] = rest, $[6] = t0) : t0 = $[6];
  let t1;
  return $[7] !== $background || $[8] !== $smallClearButton || $[9] !== t0 ? (t1 = /* @__PURE__ */ jsx(CustomTextInputBox, { $background, $smallClearButton, children: t0 }), $[7] = $background, $[8] = $smallClearButton, $[9] = t0, $[10] = t1) : t1 = $[10], t1;
}), SearchHeaderBox = styled(Box)`
  border-bottom: 1px solid ${({
  theme
}) => theme.sanity.color.base.border};
  flex-shrink: 0;
`, SearchHeaderContentFlex = styled(Flex)`
  box-sizing: border-box;
`, FilterPopoverContentHeader = forwardRef(function(t0, ref) {
  const $ = c(11), {
    ariaInputLabel,
    onChange,
    onClear,
    typeFilter
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation(), t2 = !!typeFilter, t3 = fullscreen ? 2 : 1;
  let t4;
  $[0] !== t ? (t4 = t("search.filter-placeholder"), $[0] = t, $[1] = t4) : t4 = $[1];
  let t5;
  return $[2] !== ariaInputLabel || $[3] !== onChange || $[4] !== onClear || $[5] !== ref || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== typeFilter ? (t5 = /* @__PURE__ */ jsx(SearchHeaderBox, { children: /* @__PURE__ */ jsx(SearchHeaderContentFlex, { align: "center", flex: 1, padding: 1, children: /* @__PURE__ */ jsx(CustomTextInput, { __unstable_disableFocusRing: !0, $smallClearButton: !0, "aria-label": ariaInputLabel, autoComplete: "off", border: !1, clearButton: t2, fontSize: t3, icon: SearchIcon, muted: !0, onChange, onClear, placeholder: t4, ref, spellCheck: !1, radius: 2, value: typeFilter }) }) }), $[2] = ariaInputLabel, $[3] = onChange, $[4] = onClear, $[5] = ref, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = typeFilter, $[10] = t5) : t5 = $[10], t5;
});
function createFilterMenuItems({
  documentTypesNarrowed,
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  schema: schema2,
  titleFilter,
  types,
  t
}) {
  const fieldFilters = Object.values(fieldDefinitions).filter((fieldDef) => includesTitleInFieldDefinition(fieldDef, titleFilter)).map((fieldDef) => {
    const filterDef = getFilterDefinition(filterDefinitions2, fieldDef.filterName);
    return filterDef ? buildSearchFilter(filterDef, fieldDef.id) : null;
  }).filter(isNonNullable$3), pinnedItems = buildPinnedMenuItems({
    fieldDefinitions,
    filterDefinitions: filterDefinitions2,
    titleFilter
  });
  return documentTypesNarrowed.length === 0 ? [
    ...pinnedItems,
    // All fields
    ...filterGroup({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters: fieldFilters,
      headerTitle: t("search.filter-all-fields-header"),
      id: "field"
    })
  ] : [
    ...pinnedItems,
    // All shared / narrowed items
    ...buildFieldMenuItemsNarrowed({
      documentTypesNarrowed,
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters: fieldFilters,
      schema: schema2,
      types,
      t
    })
  ];
}
function filterGroup({
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  filters,
  id: id2,
  headerTitle,
  tone
}) {
  const header = {
    title: headerTitle || "",
    tone: tone || "default",
    type: "header"
  }, filterItems = filters.map((filter2) => ({
    fieldDefinition: getFieldFromFilter(fieldDefinitions, filter2),
    filterDefinition: getFilterDefinition(filterDefinitions2, filter2.filterName),
    filter: filter2,
    group: id2,
    tone: tone || "default",
    type: "filter"
  }));
  return filterItems.length > 0 ? [
    ...headerTitle ? [header] : [],
    //
    ...filterItems
  ] : [];
}
function buildFieldMenuItemsNarrowed({
  documentTypesNarrowed,
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  filters,
  schema: schema2,
  types,
  t
}) {
  const sharedFilters = filters.filter((filter2) => {
    const fieldDefinition = getFieldFromFilter(fieldDefinitions, filter2);
    return sharesDocumentTypes(documentTypesNarrowed, fieldDefinition);
  }), sharedItems = documentTypesNarrowed.length > 1 && types.length > 1 ? filterGroup({
    fieldDefinitions,
    filterDefinitions: filterDefinitions2,
    filters: sharedFilters,
    headerTitle: t("search.filter-shared-fields-header"),
    id: "shared",
    tone: "primary"
  }) : [], groupedItems = documentTypesNarrowed.map((documentType) => {
    const docType = schema2.get(documentType);
    return {
      // Note: it shouldn't be possible to select document types that do not exist in schema,
      // and there is no way to inject it into state (eg not persisted in URL), thus we leave
      // this fallback (`Unknown type`) only as a edge-case safety net and will not translate it.
      title: docType?.title || startCase(docType?.name) || "(Unknown type)",
      documentType
    };
  }).sort((a, b) => a.title.localeCompare(b.title)).map(({
    documentType,
    title
  }) => {
    const groupFilters = filters.filter((filter2) => {
      const fieldDefinition = getFieldFromFilter(fieldDefinitions, filter2);
      return includesDocumentTypes([documentType], fieldDefinition);
    });
    return filterGroup({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters: groupFilters,
      id: title,
      headerTitle: title
    });
  }).flat();
  return [...sharedItems, ...groupedItems];
}
function buildPinnedMenuItems({
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  titleFilter
}) {
  const ungroupedPinnedFilters = Object.values(filterDefinitions2).filter(isPinnedFilterDefWithoutGroup).filter((filterDef) => includesTitleInPinnedFilterDefinition(filterDef, titleFilter)).map((filterDef) => buildSearchFilter(filterDef)), groupedPinnedFilters = Object.values(filterDefinitions2).filter(isPinnedFilterDefWithGroup).filter((filterDef) => includesTitleInPinnedFilterDefinition(filterDef, titleFilter)).reduce((acc, val) => (acc[val.group] = acc[val.group] || [], acc[val.group].push(buildSearchFilter(val)), acc), {});
  return [
    // Ungrouped
    ...filterGroup({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters: ungroupedPinnedFilters,
      id: "pinned-ungrouped",
      tone: "primary"
    }),
    // Grouped
    ...Object.entries(groupedPinnedFilters).flatMap(([groupTitle, filters]) => filterGroup({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      filters,
      headerTitle: groupTitle,
      id: groupTitle,
      tone: "primary"
    }))
  ];
}
function includesDocumentTypes(documentTypes, fieldDefinition) {
  return fieldDefinition?.documentTypes.some((type) => documentTypes.includes(type));
}
function includesTitleInFieldDefinition(field, currentTitle) {
  return field.titlePath.join("/").toLowerCase().includes(currentTitle.toLowerCase());
}
function includesTitleInPinnedFilterDefinition(filter2, currentTitle) {
  return filter2.title.toLowerCase().includes(currentTitle.toLowerCase());
}
function isPinnedFilterDefWithGroup(filterDef) {
  return filterDef.type === "pinned" && typeof filterDef?.group < "u";
}
function isPinnedFilterDefWithoutGroup(filterDef) {
  return filterDef.type === "pinned" && typeof filterDef?.group > "u";
}
function sharesDocumentTypes(documentTypes, fieldDefinition) {
  return difference(documentTypes, fieldDefinition?.documentTypes || []).length === 0;
}
function FilterTitle({
  filter: filter2,
  maxLength
}) {
  const {
    state: {
      definitions
    }
  } = useSearchState(), title = useMemo(() => {
    const filterDef = getFilterDefinition(definitions.filters, filter2.filterName);
    switch (filterDef?.type) {
      case "field": {
        const fieldDefinition = getFieldFromFilter(definitions.fields, filter2);
        return fieldDefinition?.titlePath ? fieldDefinition.titlePath[fieldDefinition.titlePath.length - 1] : null;
      }
      case "pinned":
        return filterDef.title;
      default:
        return null;
    }
  }, [definitions, filter2]);
  return title ? maxLength && title.length > maxLength ? /* @__PURE__ */ jsxs("span", { children: [
    title.slice(0, maxLength),
    "\u2026"
  ] }) : /* @__PURE__ */ jsx("span", { children: title }) : null;
}
function FilterIcon(t0) {
  const $ = c(6), {
    filter: filter2
  } = t0, {
    state: t1
  } = useSearchState(), {
    definitions
  } = t1;
  let t2;
  $[0] !== definitions.filters || $[1] !== filter2.filterName ? (t2 = getFilterDefinition(definitions.filters, filter2.filterName)?.icon, $[0] = definitions.filters, $[1] = filter2.filterName, $[2] = t2) : t2 = $[2];
  const Icon2 = t2;
  if (Icon2) {
    let t32;
    return $[3] !== Icon2 ? (t32 = /* @__PURE__ */ jsx(Icon2, {}), $[3] = Icon2, $[4] = t32) : t32 = $[4], t32;
  }
  let t3;
  return $[5] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(UnknownIcon, {}), $[5] = t3) : t3 = $[5], t3;
}
function FilterDetails(t0) {
  const $ = c(18), {
    filter: filter2
  } = t0, {
    state: t1
  } = useSearchState(), {
    definitions
  } = t1;
  let T0, t2, t3;
  if ($[0] !== definitions.fields || $[1] !== filter2) {
    const fieldDefinition = getFieldFromFilter(definitions.fields, filter2);
    T0 = Stack, t2 = 2, t3 = fieldDefinition?.titlePath && fieldDefinition.titlePath?.length > 1 && /* @__PURE__ */ jsx(Box, { marginLeft: 4, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 0, children: fieldDefinition.titlePath.slice(0, -1).map((pathTitle, index) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx("span", { children: pathTitle }),
      index !== fieldDefinition.titlePath.length - 2 && /* @__PURE__ */ jsx("span", { style: {
        opacity: 0.75,
        paddingLeft: "0.25em",
        paddingRight: "0.25em"
      }, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) })
    ] }, index)) }) }), $[0] = definitions.fields, $[1] = filter2, $[2] = T0, $[3] = t2, $[4] = t3;
  } else
    T0 = $[2], t2 = $[3], t3 = $[4];
  let t4;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    flexShrink: 0
  }, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== filter2 ? (t5 = /* @__PURE__ */ jsx(Box, { style: t4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(FilterIcon, { filter: filter2 }) }) }), $[6] = filter2, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== filter2 ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(FilterTitle, { filter: filter2 }) }), $[8] = filter2, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t5 || $[11] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t5,
    t6
  ] }), $[10] = t5, $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  return $[13] !== T0 || $[14] !== t2 || $[15] !== t3 || $[16] !== t7 ? (t8 = /* @__PURE__ */ jsxs(T0, { space: t2, children: [
    t3,
    t7
  ] }), $[13] = T0, $[14] = t2, $[15] = t3, $[16] = t7, $[17] = t8) : t8 = $[17], t8;
}
function getSchemaField$3(schemaType, fieldPath) {
  const paths = fieldPath.split("."), firstPath = paths[0];
  if (firstPath && isObjectSchemaType(schemaType)) {
    const field = schemaType.fields.find((f) => f.name === firstPath);
    if (field) {
      const nextPath = paths.slice(1).join(".");
      return nextPath ? getSchemaField$3(field.type, nextPath) : field;
    }
  }
}
function sanitizeFieldValue(name) {
  return isValidElement(name) ? stripHtmlTags(renderToString(name)) : typeof name == "string" ? name : "";
}
function stripHtmlTags(str) {
  return new DOMParser().parseFromString(str, "text/html")?.body.textContent || "";
}
const MAX_VISIBLE_TYPES = 10;
function FilterTooltip({
  children,
  fieldDefinition,
  filterDefinition,
  visible
}) {
  const {
    state: {
      documentTypesNarrowed
    }
  } = useSearchState(), {
    t
  } = useTranslation(), schema2 = useSchema(), fieldDefinitionDocumentTypeTitles = useMemo(() => fieldDefinition?.documentTypes ? fieldDefinition.documentTypes.map((d) => {
    const defType = schema2.get(d);
    return defType?.title || startCase(defType?.name);
  }).filter(isNonNullable$3).sort() : [], [fieldDefinition?.documentTypes, schema2]), fieldDefinitionDescription = useMemo(() => {
    if (fieldDefinition?.documentTypes) {
      const descriptions = fieldDefinition.documentTypes.map((d_0) => {
        const defType_0 = schema2.get(d_0);
        if (defType_0) {
          const field = getSchemaField$3(defType_0, fieldDefinition.fieldPath);
          return field?.type.description && sanitizeFieldValue(field?.type.description);
        }
        return null;
      }).filter(isNonNullable$3).sort(), uniqueDescriptions = uniq(descriptions);
      if (uniqueDescriptions.length === 1)
        return uniqueDescriptions[0];
    }
  }, [fieldDefinition?.documentTypes, fieldDefinition?.fieldPath, schema2]);
  return /* @__PURE__ */ jsx(Tooltip, { content: /* @__PURE__ */ jsx(Card, { tone: "default", radius: 2, style: {
    maxWidth: "250px"
  }, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    fieldDefinition && /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("search.filter-field-tooltip-name") }),
      /* @__PURE__ */ jsx(TextWithTone, { size: 1, style: {
        fontFamily: "monospace"
      }, tone: "primary", textOverflow: "ellipsis", children: fieldDefinition?.name })
    ] }),
    fieldDefinitionDescription && /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("search.filter-field-tooltip-description") }),
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: truncateString(fieldDefinitionDescription, 256) })
    ] }),
    filterDefinition?.description && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: truncateString(filterDefinition.description, 256) }),
    !documentTypesNarrowed.length && fieldDefinitionDocumentTypeTitles.length > 0 && /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
        /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("search.filter-field-tooltip-used-in-document-types") }),
        /* @__PURE__ */ jsx(Card, { padding: 1, radius: 2, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: fieldDefinitionDocumentTypeTitles.length }) })
      ] }),
      /* @__PURE__ */ jsxs(Text$1, { size: 1, weight: "regular", muted: !0, children: [
        fieldDefinitionDocumentTypeTitles.slice(0, MAX_VISIBLE_TYPES).join(", "),
        fieldDefinitionDocumentTypeTitles?.length > MAX_VISIBLE_TYPES ? ` +${fieldDefinitionDocumentTypeTitles.length - MAX_VISIBLE_TYPES} more` : ""
      ] })
    ] })
  ] }) }), disabled: !visible, fallbackPlacements: ["left"], placement: "right", portal: !0, children });
}
const MenuItemFilter = memo(function(t0) {
  const $ = c(24);
  let item, onClose, rest;
  $[0] !== t0 ? ({
    item,
    onClose,
    ...rest
  } = t0, $[0] = t0, $[1] = item, $[2] = onClose, $[3] = rest) : (item = $[1], onClose = $[2], rest = $[3]);
  const {
    dispatch,
    state: t1
  } = useSearchState(), {
    filters
  } = t1;
  let t2;
  $[4] !== dispatch || $[5] !== item.filter || $[6] !== onClose ? (t2 = () => {
    dispatch({
      filter: item.filter,
      type: "TERMS_FILTERS_ADD"
    }), onClose?.();
  }, $[4] = dispatch, $[5] = item.filter, $[6] = onClose, $[7] = t2) : t2 = $[7];
  const handleClick = t2, isAlreadyActive = !!filters.find((f) => getFilterKey(f) === getFilterKey(item.filter)), tooltipEnabled = !!(item.fieldDefinition || item.filterDefinition.description), t3 = isAlreadyActive ? void 0 : handleClick;
  let t4;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    position: "relative",
    whiteSpace: "normal",
    width: "100%"
  }, $[8] = t4) : t4 = $[8];
  const t5 = item?.tone;
  let t6;
  $[9] !== item.filter ? (t6 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(FilterDetails, { filter: item.filter }) }), $[9] = item.filter, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== item.fieldDefinition || $[12] !== item.filterDefinition || $[13] !== t6 || $[14] !== tooltipEnabled ? (t7 = /* @__PURE__ */ jsx(FilterTooltip, { fieldDefinition: item.fieldDefinition, filterDefinition: item.filterDefinition, visible: tooltipEnabled, children: t6 }), $[11] = item.fieldDefinition, $[12] = item.filterDefinition, $[13] = t6, $[14] = tooltipEnabled, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== isAlreadyActive || $[17] !== t3 || $[18] !== t5 || $[19] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button$1, { disabled: isAlreadyActive, fontSize: 1, justify: "flex-start", mode: "bleed", onClick: t3, padding: 0, style: t4, tabIndex: -1, tone: t5, children: t7 }), $[16] = isAlreadyActive, $[17] = t3, $[18] = t5, $[19] = t7, $[20] = t8) : t8 = $[20];
  let t9;
  return $[21] !== rest || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsx(Box, { ...rest, children: t8 }), $[21] = rest, $[22] = t8, $[23] = t9) : t9 = $[23], t9;
}), MenuItemHeader = memo(function(t0) {
  const $ = c(5), {
    item
  } = t0, t1 = item?.tone;
  let t2;
  $[0] !== item.title ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", weight: "medium", children: item.title }), $[0] = item.title, $[1] = t2) : t2 = $[1];
  let t3;
  return $[2] !== t1 || $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { paddingTop: 1, children: /* @__PURE__ */ jsx(Card, { borderBottom: !0, paddingX: 2, paddingY: 3, tone: t1, children: t2 }) }), $[2] = t1, $[3] = t2, $[4] = t3) : t3 = $[4], t3;
}), POPOVER_STYLES$1 = {
  width: "300px"
};
function AddFilterPopoverContent({
  onClose
}) {
  const [inputElement, setInputElement] = useState(null), [titleFilter, setTitleFilter] = useState(""), {
    t
  } = useTranslation(), handleFilterChange = useCallback((e) => setTitleFilter(e.currentTarget.value), [setTitleFilter]), handleFilterClear = useCallback(() => setTitleFilter(""), []), schema2 = useSchema(), {
    state: {
      documentTypesNarrowed,
      definitions,
      filters,
      terms: {
        types
      }
    }
  } = useSearchState(), filteredMenuItems = useMemo(() => createFilterMenuItems({
    documentTypesNarrowed,
    fieldDefinitions: definitions.fields,
    filterDefinitions: definitions.filters,
    schema: schema2,
    titleFilter,
    types,
    t
  }), [documentTypesNarrowed, definitions.fields, definitions.filters, schema2, titleFilter, types, t]), renderItem2 = useCallback((item) => item.type === "filter" ? /* @__PURE__ */ jsx(MenuItemFilter, { item, onClose, paddingBottom: 1 }) : item.type === "header" ? /* @__PURE__ */ jsx(MenuItemHeader, { item }) : null, [onClose]), getItemDisabled = useCallback((index) => {
    const filterItem = filteredMenuItems[index];
    return filterItem.type !== "filter" || !!filters.find((f) => getFilterKey(f) === getFilterKey(filterItem.filter));
  }, [filteredMenuItems, filters]), getItemKey2 = useCallback((index_0) => {
    const menuItem = filteredMenuItems[index_0];
    switch (menuItem.type) {
      case "filter":
        return [
          ...menuItem.group ? [menuItem.group] : [],
          //
          getFilterKey(menuItem.filter)
        ].join("-");
      case "header":
        return `${menuItem.type}-${menuItem.title}`;
      default:
        return index_0;
    }
  }, [filteredMenuItems]);
  return /* @__PURE__ */ jsxs(Flex, { direction: "column", style: POPOVER_STYLES$1, children: [
    /* @__PURE__ */ jsx(FilterPopoverContentHeader, { ariaInputLabel: t("search.filter-by-title-aria-label"), onChange: handleFilterChange, onClear: handleFilterClear, ref: setInputElement, typeFilter: titleFilter }),
    /* @__PURE__ */ jsxs(Flex, { children: [
      filteredMenuItems.length > 0 && /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("search.filters-aria-label", {
        count: filteredMenuItems.length
      }), autoFocus: "input", getItemDisabled, getItemKey: getItemKey2, inputElement, itemHeight: 45, items: filteredMenuItems, overscan: 20, padding: 1, paddingBottom: 0, renderItem: renderItem2 }),
      filteredMenuItems.length == 0 && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: t("search.filter-no-matches-found", {
        filter: titleFilter
      }) }) })
    ] })
  ] });
}
function AddFilterButton() {
  const $ = c(18), [open, setOpen] = useState(!1), [buttonElement, setButtonElement] = useState(null), popoverRef = useRef(null), {
    t
  } = useTranslation(), {
    state: t0
  } = useSearchState(), {
    fullscreen
  } = t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setOpen(!1), $[0] = t1) : t1 = $[0];
  const handleClose = t1;
  let t2;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setOpen(!0), $[1] = t2) : t2 = $[1];
  const handleOpen = t2;
  let t3;
  $[2] !== buttonElement ? (t3 = () => [buttonElement, popoverRef.current], $[2] = buttonElement, $[3] = t3) : t3 = $[3], useClickOutsideEvent(handleClose, t3);
  let t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = [POPOVER_VERTICAL_MARGIN, 0, 0, 0], $[4] = t4) : t4 = $[4];
  let t5;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(AddFilterPopoverContent, { onClose: handleClose }), $[5] = t5) : t5 = $[5];
  let t6;
  $[6] !== buttonElement ? (t6 = /* @__PURE__ */ jsx(FilterPopoverWrapper, { anchorElement: buttonElement, onClose: handleClose, children: t5 }), $[6] = buttonElement, $[7] = t6) : t6 = $[7];
  const t7 = fullscreen ? "large" : "default";
  let t8;
  $[8] !== t ? (t8 = t("search.action.add-filter"), $[8] = t, $[9] = t8) : t8 = $[9];
  let t9;
  $[10] !== open || $[11] !== t7 || $[12] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { icon: AddIcon, mode: "bleed", onClick: handleOpen, size: t7, ref: setButtonElement, selected: open, text: t8 }), $[10] = open, $[11] = t7, $[12] = t8, $[13] = t9) : t9 = $[13];
  let t10;
  return $[14] !== open || $[15] !== t6 || $[16] !== t9 ? (t10 = /* @__PURE__ */ jsx(Popover, { __unstable_margins: t4, content: t6, open, placement: "bottom-start", radius: POPOVER_RADIUS$1, ref: popoverRef, portal: !0, children: t9 }), $[14] = open, $[15] = t6, $[16] = t9, $[17] = t10) : t10 = $[17], t10;
}
function getDocumentTypesTruncated({
  availableCharacters = 40,
  types
}) {
  if (types.length === 0)
    return {
      remainingCount: 0,
      types: []
    };
  const visibleTypes = types.reduce(/* @__PURE__ */ function() {
    let remaining = availableCharacters;
    return function(acc, val, index) {
      const title = typeTitle(val);
      return remaining -= title.length, (index === 0 || availableCharacters > title.length && remaining > title.length) && acc.push(val), acc;
    };
  }(), []);
  return {
    remainingCount: types.length - visibleTypes.length,
    types: visibleTypes.map(typeTitle)
  };
}
function documentTypesTruncated({
  t,
  availableCharacters,
  types
}) {
  if (types.length === 0)
    return t("search.document-type-list-all-types");
  const {
    remainingCount,
    types: visibleTypes
  } = getDocumentTypesTruncated({
    availableCharacters,
    types
  }), key = remainingCount > 0 ? "search.document-type-list-truncated" : "search.document-type-list";
  return t(key, {
    count: remainingCount,
    types: visibleTypes,
    formatParams: {
      types: {
        style: "short",
        type: "unit"
      }
    }
  });
}
function typeTitle(schemaType) {
  return schemaType.title ?? schemaType.name;
}
const CACHE$1 = /* @__PURE__ */ new WeakMap(), PREVIEW_FIELD_WEIGHT_MAP$1 = {
  title: 10,
  subtitle: 5,
  description: 1.5
}, BASE_WEIGHTS$1 = {
  _id: {
    weight: 1,
    type: "string"
  },
  _type: {
    weight: 1,
    type: "string"
  }
}, ignoredBuiltInObjectTypes$1 = ["reference", "crossDatasetReference", "slug"], getTypeChain$2 = (type) => type ? [type, ...getTypeChain$2(type.type)] : [], isPtField$1 = (type) => type?.jsonType === "array" && type.of.some((arrType) => getTypeChain$2(arrType).some(({
  name
}) => name === "block")), isStringField$1 = (schemaType) => schemaType ? schemaType?.jsonType === "string" : !1, isSlugField$1 = (schemaType) => getTypeChain$2(schemaType).some(({
  jsonType,
  name
}) => jsonType === "object" && name === "slug"), isSearchConfiguration$1 = (options) => isRecord$4(options) && "search" in options && isRecord$4(options.search);
function isSchemaType$2(input) {
  return typeof input < "u" && "name" in input;
}
function getFullyQualifiedPath$1(schemaType, path) {
  return isSlugField$1(schemaType) ? [path, "current"].join(".") : path;
}
function getLeafWeights$1(schemaType, maxDepth, getWeight) {
  function traverse2(type, path, depth, accumulator = []) {
    if (!type || depth > maxDepth) return accumulator;
    const typeChain = getTypeChain$2(type);
    if (isStringField$1(type) || isPtField$1(type)) {
      const weight = getWeight(type, path);
      return typeof weight == "number" && accumulator.push({
        path,
        weight,
        type: isPtField$1(type) ? "pt" : "string"
      }), accumulator;
    }
    if (isSlugField$1(type)) {
      const weight = getWeight(type, path);
      return typeof weight == "number" && accumulator.push({
        path: getFullyQualifiedPath$1(type, path),
        weight,
        type: isPtField$1(type) ? "pt" : "string"
      }), accumulator;
    }
    let recursiveResult = accumulator;
    for (const t of typeChain)
      if (t.jsonType === "object" && t.fields?.length && !ignoredBuiltInObjectTypes$1.includes(t.name))
        for (const field of t.fields)
          recursiveResult = traverse2(field.type, toString([path, field.name].filter(Boolean)), depth + 1, recursiveResult);
      else if (t.jsonType === "array" && t.of?.length)
        for (const arrayItemType of t.of)
          recursiveResult = traverse2(arrayItemType, `${path}[]`, depth + 1, recursiveResult);
    return recursiveResult;
  }
  return isSchemaType$2(schemaType) ? traverse2(schemaType, "", 0).reduce((acc, {
    path,
    weight,
    type
  }) => (acc[path] = {
    weight,
    type,
    path
  }, acc), {}) : {};
}
const getUserSetWeight$1 = (schemaType) => {
  const searchOptions = getTypeChain$2(schemaType).map((type) => type.options).find(isSearchConfiguration$1);
  return typeof searchOptions?.search?.weight == "number" ? searchOptions.search.weight : null;
}, getHiddenWeight$1 = (schemaType) => getTypeChain$2(schemaType).some((type) => type.hidden) ? 0 : null, getDefaultWeights$1 = (schemaType) => typeof (getUserSetWeight$1(schemaType) ?? getHiddenWeight$1(schemaType)) == "number" ? null : 1, getPreviewWeights$1 = (schemaType, maxDepth, isCrossDataset) => {
  const select2 = schemaType?.preview?.select;
  if (!select2) return null;
  const selectionKeysBySelectionPath = Object.fromEntries(Object.entries(select2).map(([selectionKey, selectionPath]) => [
    // replace indexed paths with `[]`
    // e.g. `arrayOfObjects.0.myField` becomes `arrayOfObjects[].myField`
    selectionPath.replace(/\.\d+/g, "[]"),
    selectionKey
  ])), defaultWeights = getLeafWeights$1(schemaType, maxDepth, getDefaultWeights$1), nestedWeightsBySelectionPath = Object.fromEntries(Object.entries(defaultWeights).map(([path, {
    type
  }]) => ({
    path,
    type
  })).filter(({
    path
  }) => selectionKeysBySelectionPath[path]).map(({
    path,
    type
  }) => [path, {
    type,
    weight: PREVIEW_FIELD_WEIGHT_MAP$1[selectionKeysBySelectionPath[path]]
  }]));
  return isCrossDataset ? Object.fromEntries(Object.entries(selectionKeysBySelectionPath).map(([path, previewFieldName]) => [path, {
    path,
    type: "string",
    weight: PREVIEW_FIELD_WEIGHT_MAP$1[previewFieldName]
  }])) : getLeafWeights$1(schemaType, maxDepth, (type, path) => {
    const nested = nestedWeightsBySelectionPath[getFullyQualifiedPath$1(type, path)];
    return nested ? nested.weight : null;
  });
};
function deriveSearchWeightsFromType({
  schemaType,
  maxDepth,
  isCrossDataset,
  processPaths = (paths) => paths
}) {
  const cached = CACHE$1.get(schemaType);
  if (cached) return cached;
  const userSetWeights = getLeafWeights$1(schemaType, maxDepth, getUserSetWeight$1), hiddenWeights = getLeafWeights$1(schemaType, maxDepth, getHiddenWeight$1), defaultWeights = getLeafWeights$1(schemaType, maxDepth, getDefaultWeights$1), previewWeights = getPreviewWeights$1(schemaType, maxDepth, isCrossDataset), weights = {
    ...BASE_WEIGHTS$1,
    ...defaultWeights,
    ...hiddenWeights,
    ...previewWeights,
    ...userSetWeights
  }, result = {
    typeName: isSchemaType$2(schemaType) ? schemaType.name : schemaType.type,
    paths: processPaths(Object.entries(weights).map(([path, {
      type,
      weight
    }]) => ({
      path,
      weight,
      ...type === "pt" && {
        mapWith: "pt::text"
      }
    })))
  };
  return CACHE$1.set(schemaType, result), result;
}
const CACHE = /* @__PURE__ */ new WeakMap(), PREVIEW_FIELD_WEIGHT_MAP = {
  title: 10,
  subtitle: 5,
  description: 1.5
}, BASE_WEIGHTS = {
  _id: {
    weight: 1
  },
  _type: {
    weight: 1
  }
}, ignoredBuiltInObjectTypes = ["reference", "crossDatasetReference", "slug", "globalDocumentReference"], getTypeChain$1 = (type) => type ? [type, ...getTypeChain$1(type.type)] : [], isPtField = (type) => type?.jsonType === "array" && type.of.some((arrType) => getTypeChain$1(arrType).some(({
  name
}) => name === "block")), isStringField = (schemaType) => schemaType ? schemaType?.jsonType === "string" : !1, isSlugField = (schemaType) => getTypeChain$1(schemaType).some(({
  jsonType,
  name
}) => jsonType === "object" && name === "slug"), isSearchConfiguration = (options) => isRecord$4(options) && "search" in options && isRecord$4(options.search);
function isSchemaType$1(input) {
  return typeof input < "u" && "name" in input;
}
function getFullyQualifiedPath(schemaType, path) {
  return isSlugField(schemaType) ? [path, "current"].join(".") : path;
}
function getLeafWeights(schemaType, maxDepth, getWeight) {
  function traverse2(type, path, depth, accumulator = []) {
    if (!type || depth > maxDepth) return accumulator;
    const typeChain = getTypeChain$1(type);
    if (isStringField(type) || isPtField(type)) {
      const weight = getWeight(type, path);
      return typeof weight == "number" && accumulator.push({
        path,
        weight
      }), accumulator;
    }
    if (isSlugField(type)) {
      const weight = getWeight(type, path);
      return typeof weight == "number" && accumulator.push({
        path: getFullyQualifiedPath(type, path),
        weight
      }), accumulator;
    }
    let recursiveResult = accumulator;
    for (const t of typeChain)
      if (t.jsonType === "object" && t.fields?.length && !ignoredBuiltInObjectTypes.includes(t.name))
        for (const field of t.fields)
          recursiveResult = traverse2(field.type, toString([path, field.name].filter(Boolean)), depth + 1, recursiveResult);
      else if (t.jsonType === "array" && t.of?.length)
        for (const arrayItemType of t.of)
          recursiveResult = traverse2(arrayItemType, `${path}[]`, depth + 1, recursiveResult);
    return recursiveResult;
  }
  return isSchemaType$1(schemaType) ? traverse2(schemaType, "", 0).reduce((acc, {
    path,
    weight,
    type
  }) => (acc[path] = {
    weight,
    type,
    path
  }, acc), {}) : {};
}
const getUserSetWeight = (schemaType) => {
  const searchOptions = getTypeChain$1(schemaType).map((type) => type.options).find(isSearchConfiguration);
  return typeof searchOptions?.search?.weight == "number" ? searchOptions.search.weight : null;
}, getHiddenWeight = (schemaType) => getTypeChain$1(schemaType).some((type) => type.hidden) ? 0 : null, getDefaultWeights = (schemaType) => typeof (getUserSetWeight(schemaType) ?? getHiddenWeight(schemaType)) == "number" ? null : 1, getPreviewWeights = (schemaType, maxDepth, isCrossDataset) => {
  const select2 = schemaType?.preview?.select;
  if (!select2) return null;
  const selectionKeysBySelectionPath = Object.fromEntries(Object.entries(select2).map(([selectionKey, selectionPath]) => [
    // replace indexed paths with `[]`
    // e.g. `arrayOfObjects.0.myField` becomes `arrayOfObjects[].myField`
    selectionPath.replace(/\.\d+/g, "[]"),
    selectionKey
  ])), defaultWeights = getLeafWeights(schemaType, maxDepth, getDefaultWeights), nestedWeightsBySelectionPath = Object.fromEntries(Object.entries(defaultWeights).map(([path, {
    type
  }]) => ({
    path,
    type
  })).filter(({
    path
  }) => selectionKeysBySelectionPath[path]).map(({
    path,
    type
  }) => [path, {
    type,
    weight: PREVIEW_FIELD_WEIGHT_MAP[selectionKeysBySelectionPath[path]]
  }]));
  return isCrossDataset ? Object.fromEntries(Object.entries(selectionKeysBySelectionPath).map(([path, previewFieldName]) => [path, {
    path,
    type: "string",
    weight: PREVIEW_FIELD_WEIGHT_MAP[previewFieldName]
  }])) : getLeafWeights(schemaType, maxDepth, (type, path) => {
    const nested = nestedWeightsBySelectionPath[getFullyQualifiedPath(type, path)];
    return nested ? nested.weight : null;
  });
};
function deriveSearchWeightsFromType2024({
  schemaType,
  maxDepth,
  isCrossDataset,
  processPaths = (paths) => paths
}) {
  const cached = CACHE.get(schemaType);
  if (cached) return cached;
  const userSetWeights = getLeafWeights(schemaType, maxDepth, getUserSetWeight), hiddenWeights = getLeafWeights(schemaType, maxDepth, getHiddenWeight), defaultWeights = getLeafWeights(schemaType, maxDepth, getDefaultWeights), previewWeights = getPreviewWeights(schemaType, maxDepth, isCrossDataset), weights = {
    ...BASE_WEIGHTS,
    ...defaultWeights,
    ...hiddenWeights,
    ...previewWeights,
    ...userSetWeights
  }, result = {
    typeName: isSchemaType$1(schemaType) ? schemaType.name : schemaType.type,
    paths: processPaths(Object.entries(weights).map(([path, {
      weight
    }]) => ({
      path,
      weight
    })))
  };
  return CACHE.set(schemaType, result), result;
}
const isDocumentType = (type) => !!(type.type && type.type.name === "document"), isObjectType$1 = (type) => type.jsonType === "object", isIgnoredType = (type) => type.name.startsWith("sanity.") && type.name !== "sanity.previewUrlSecret", getSearchableTypes = (schema2, explicitlyAllowedTypes = []) => schema2.getTypeNames().map((typeName) => schema2.get(typeName)).filter(isNonNullable$3).filter((type) => isDocumentType(type) && !isIgnoredType(type) || explicitlyAllowedTypes.includes(type.name)).filter(isObjectType$1);
function isPerspectiveRaw(perspective) {
  return perspective ? isString(perspective) ? perspective === "raw" : perspective.some((p) => p === "raw") : !1;
}
const WILDCARD_TOKEN = "*", NEGATION_TOKEN = "-", TOKEN_REGEX = /(?:[^\s"]+|"[^"]*")+/g;
function isNegationToken(token) {
  return typeof token < "u" && token.trim().at(0) === NEGATION_TOKEN;
}
function isPrefixToken(token) {
  return typeof token < "u" && token.trim().at(-1) === WILDCARD_TOKEN;
}
function isExactMatchToken(token) {
  return [token?.at(0), token?.at(-1)].every((character) => character === '"');
}
function prefixLast(query) {
  const tokens = (query.match(TOKEN_REGEX) ?? []).map((token) => token.trim()), finalIncrementalTokenIndex = tokens.findLastIndex((token) => !isNegationToken(token) && !isExactMatchToken(token)), finalIncrementalToken = tokens[finalIncrementalTokenIndex];
  if (tokens.length === 0)
    return WILDCARD_TOKEN;
  if (isPrefixToken(finalIncrementalToken) || typeof finalIncrementalToken > "u")
    return tokens.join(" ");
  const prefixedTokens = [...tokens];
  return prefixedTokens.splice(finalIncrementalTokenIndex, 1, `${finalIncrementalToken}${WILDCARD_TOKEN}`), prefixedTokens.join(" ");
}
const FINDABILITY_MVI$1 = 5, DEFAULT_LIMIT$1 = 1e3;
function isSchemaType(maybeSchemaType) {
  return typeof maybeSchemaType < "u" && "name" in maybeSchemaType;
}
function toOrderClause$1(orderBy2) {
  function wrapFieldWithFn(ordering) {
    return ordering.mapWith ? `${ordering.mapWith}(${ordering.field})` : ordering.field;
  }
  return (orderBy2 || []).map((ordering) => [wrapFieldWithFn(ordering), (ordering.direction || "").toLowerCase()].map((str) => str.trim()).filter(Boolean).join(" ")).join(",");
}
function createSearchQuery$1(searchTerms, searchParams, {
  includeDrafts = !0,
  perspective,
  ...options
} = {}) {
  const flattenedSpecs = searchTerms.types.map((schemaType) => deriveSearchWeightsFromType2024({
    schemaType,
    maxDepth: options.maxDepth || DEFAULT_MAX_FIELD_DEPTH,
    isCrossDataset: options.isCrossDataset,
    processPaths: (paths) => paths.filter(({
      weight
    }) => weight !== 1)
  })).filter(({
    paths
  }) => paths.length !== 0).map(({
    typeName,
    paths
  }) => paths.map((path) => ({
    ...path,
    typeName
  }))).flat(), groupedSpecs = groupBy(flattenedSpecs, (entry) => [entry.path, entry.weight].join(":")), baseMatch = "[@, _id] match text::query($__query)", score = Object.entries(groupedSpecs).flatMap(([, entries]) => entries.some(({
    weight
  }) => weight === 0) ? [] : `boost(_type in ${JSON.stringify(entries.map((entry) => entry.typeName))} && ${entries[0].path} match text::query($__query), ${entries[0].weight})`).concat(baseMatch), sortOrder = options?.sort ?? [{
    field: "_score",
    direction: "desc"
  }], isScored = sortOrder.some(({
    field
  }) => field === "_score");
  let activePerspective = perspective;
  (typeof perspective > "u" || Array.isArray(perspective) && perspective.length === 0) && (activePerspective = "raw");
  const isRaw = isPerspectiveRaw(activePerspective), filters = [
    "_type in $__types",
    // If the search request doesn't use scoring, directly filter documents.
    isScored ? [] : baseMatch,
    options.filter ? `(${options.filter})` : [],
    searchTerms.filter ? `(${searchTerms.filter})` : [],
    isRaw ? [] : '!(_id in path("versions.**"))',
    includeDrafts === !1 ? "!(_id in path('drafts.**'))" : [],
    options.cursor ?? []
  ].flat(), projection = sortOrder.map(({
    field
  }) => field).concat("_type", "_id", "_originalId").join(", "), query = [`*[${filters.join(" && ")}]`, isScored ? ["|", `score(${score.join(", ")})`] : [], ["|", `order(${toOrderClause$1(sortOrder)})`], isScored ? "[_score > 0]" : [], "[0...$__limit]", `{${projection}}`].flat().join(" "), params = {
    __types: searchTerms.types.map((type) => isSchemaType(type) ? type.name : type.type),
    // Overfetch by 1 to determine whether there is another page to fetch.
    __limit: (options?.limit ?? DEFAULT_LIMIT$1) + 1,
    __query: prefixLast(typeof searchParams == "string" ? searchParams : searchParams.query),
    ...options.params
  };
  return {
    query: [[`findability-mvi:${FINDABILITY_MVI$1}`].concat(options?.comments || []).map((s) => `// ${s}`).join(`
`), query].join(`
`),
    options: {
      tag: options.tag,
      perspective: activePerspective
    },
    params,
    sortOrder
  };
}
function getNextCursor({
  lastResult,
  sortOrder
}) {
  if (!lastResult)
    return;
  const hasIdSort = sortOrder.some(({
    field
  }) => field === "_id");
  return sortOrder.concat(hasIdSort ? [] : {
    field: "_id",
    direction: "asc"
  }).reduce((cursor, sortEntry, index) => {
    const nextPredicate = sortOrder.slice(0, index).map((previousSortEntry) => getCursorPredicate(previousSortEntry, lastResult, "==")).concat(getCursorPredicate(sortEntry, lastResult)).filter((predicate) => typeof predicate < "u").join(" && ");
    return [cursor, `(${nextPredicate})`].filter((segment) => typeof segment < "u").join(" || ");
  }, void 0);
}
const sortComparators = {
  asc: ">",
  desc: "<"
};
function getCursorPredicate(sort, lastEntry, comparator = sortComparators[sort.direction]) {
  if (!(sort.field == "_id" && comparator == "=="))
    return [sort.field, comparator, JSON.stringify(lastEntry[sort.field])].join(" ");
}
function getSearchTerms$1(searchParams, types) {
  return typeof searchParams == "string" ? {
    query: searchParams,
    types
  } : searchParams.types.length ? searchParams : {
    ...searchParams,
    types
  };
}
const createGroq2024Search = (typesFromFactory, client, factoryOptions) => function(searchParams, searchOptions = {}) {
  const searchTerms = getSearchTerms$1(searchParams, typesFromFactory), mergedOptions = {
    ...factoryOptions,
    ...searchOptions
  }, {
    query,
    params,
    options,
    sortOrder
  } = createSearchQuery$1(searchTerms, searchParams, mergedOptions);
  return client.observable.withConfig({
    // The GROQ functions that power `groq2024` are currently only available using API `vX`.
    // TODO: Switch to stable API version before `groq2024` general availability.
    // TODO: When moving to stable API version, consider that the version should work with releases.
    apiVersion: "vX"
  }).fetch(query, params, options).pipe(map$1((hits) => {
    const hasNextPage = typeof searchOptions.limit < "u" && hits.length > searchOptions.limit, lastResult = hasNextPage ? hits.at(-2) : hits.at(-1);
    return {
      type: "groq2024",
      // Search overfetches by 1 to determine whether there is another page to fetch. Therefore,
      // exclude the final result if it's beyond the limit.
      hits: hits.map((hit) => ({
        hit
      })).slice(0, searchOptions.limit),
      nextCursor: hasNextPage ? getNextCursor({
        lastResult,
        sortOrder
      }) : void 0
    };
  }));
}, calculateScore = (searchTerms, value) => {
  const {
    phrases: uniqueSearchPhrases,
    words: uniqueSearchWords
  } = partitionAndSanitizeSearchTerms(searchTerms), [phraseScore, phraseWhy] = calculatePhraseScore(uniqueSearchPhrases, value), [wordScore, wordWhy] = calculateWordScore(uniqueSearchWords, value);
  return [phraseScore + wordScore, [wordWhy, phraseWhy].join(", ")];
}, stringify = (value) => typeof value == "string" ? value : JSON.stringify(value);
function applyWeights(searchSpec, hits, terms = []) {
  const specByType = keyBy(searchSpec, (spec) => spec.typeName);
  return hits.map((hit, index) => {
    const stories = (specByType[hit._type].paths || [])?.map((pathSpec, idx) => {
      const value = stringify(hit[`w${idx}`]);
      if (!value)
        return {
          path: pathSpec.path,
          score: 0,
          why: "No match"
        };
      const [score, why] = calculateScore(terms, value);
      return {
        path: pathSpec.path,
        score: score * pathSpec.weight,
        why: `${why} (*${pathSpec.weight})`
      };
    }), totalScore = stories.reduce((acc, rank) => acc + rank.score, 0);
    return {
      hit,
      resultIndex: hits.length - index,
      score: totalScore,
      stories
    };
  });
}
function calculatePhraseScore(uniqueSearchPhrases, value) {
  const sanitizedValue = value.toLowerCase().trim();
  let fieldScore = 0, matchCount = 0;
  return uniqueSearchPhrases.forEach((term) => {
    sanitizedValue.includes(term) && (fieldScore += term.length / sanitizedValue.length, matchCount += term.length);
  }), fieldScore === 1 ? [1, "[Phrase] Exact match"] : [fieldScore / 2, `[Phrase] Matched ${matchCount} of ${sanitizedValue.length} characters`];
}
function calculateWordScore(uniqueSearchTerms, value) {
  const uniqueValueTerms = uniq(compact(words(toLower(value)))), matches = intersection(uniqueSearchTerms, uniqueValueTerms), all = union(uniqueValueTerms, uniqueSearchTerms), fieldScore = matches.length / all.length;
  return fieldScore === 1 ? [1, "[Word] Exact match"] : [fieldScore / 2, `[Word] Matched ${matches.length} of ${all.length} terms: [${matches.join(", ")}]`];
}
function partitionAndSanitizeSearchTerms(searchTerms) {
  const uniqueSearchTerms = uniq(searchTerms.map(toLower)), [searchPhrases, searchWords] = partition(uniqueSearchTerms, (term) => /^".*"$/.test(term));
  return {
    phrases: uniq(searchPhrases).map(toLower).map(stripWrappingQuotes),
    //
    words: uniq(searchWords.map(toLower))
  };
}
function stripWrappingQuotes(str) {
  return str.replace(/^"(.*)"$/, "$1");
}
const FINDABILITY_MVI = 4, DEFAULT_LIMIT = 1e3, combinePaths = flow([flatten$1, union, compact]), pathWithMapper = ({
  mapWith,
  path
}) => mapWith ? `${mapWith}(${path})` : path;
function createConstraints(terms, specs) {
  const combinedSearchPaths = combinePaths(specs.map((configForType) => (configForType.paths || []).map((opt) => pathWithMapper(opt))));
  return terms.map((_term, i) => combinedSearchPaths.map((joinedPath) => `${joinedPath} match $t${i}`)).filter((constraint) => constraint.length > 0).map((constraint) => `(${constraint.join(" || ")})`);
}
const SPECIAL_CHARS = /([^!@#$%^&*(),\\/?";:{}|[\]+<>\s-])+/g, STRIP_EDGE_CHARS = /(^[.]+)|([.]+$)/;
function tokenize(string) {
  return (string.match(SPECIAL_CHARS) || []).map((token) => token.replace(STRIP_EDGE_CHARS, ""));
}
function extractTermsFromQuery(query) {
  const quotedQueries = [], unquotedQuery = query.replace(/("[^"]*")/g, (match) => words(match).length > 1 ? (quotedQueries.push(match), "") : match), quotedTerms = quotedQueries.map((str) => trim(toLower(str))), remainingTerms = uniq(compact(tokenize(toLower(unquotedQuery))));
  return [...quotedTerms, ...remainingTerms];
}
function toOrderClause(orderBy2) {
  function wrapFieldWithFn(ordering) {
    return ordering.mapWith ? `${ordering.mapWith}(${ordering.field})` : ordering.field;
  }
  return (orderBy2 || []).map((ordering) => [wrapFieldWithFn(ordering), (ordering.direction || "").toLowerCase()].map((str) => str.trim()).filter(Boolean).join(" ")).join(",");
}
function createSearchQuery(searchTerms, searchOpts = {}) {
  const {
    filter: filter2,
    params,
    tag
  } = searchOpts, specs = searchTerms.types.map((schemaType) => deriveSearchWeightsFromType({
    schemaType,
    maxDepth: searchOpts.maxDepth || DEFAULT_MAX_FIELD_DEPTH,
    isCrossDataset: searchOpts.isCrossDataset
  })).filter(({
    paths
  }) => paths.length), terms = extractTermsFromQuery(searchTerms.query), {
    perspective
  } = searchOpts, isRaw = isPerspectiveRaw(perspective), filters = [
    "_type in $__types",
    searchOpts.includeDrafts === !1 && "!(_id in path('drafts.**'))",
    ...createConstraints(terms, specs),
    filter2 ? `(${filter2})` : "",
    searchTerms.filter ? `(${searchTerms.filter})` : "",
    // Versions are collated server-side using the `perspective` option. Therefore, they must
    // not be fetched individually. This should only be added if the search needs to be narrow to the perspective
    isRaw ? "" : '!(_id in path("versions.**"))'
  ].filter(Boolean), selections = specs.map((spec) => {
    const constraint = `_type == "${spec.typeName}" => `, selection2 = `{ ${spec.paths.map((cfg, i) => `"w${i}": ${pathWithMapper(cfg)}`)} }`;
    return `${constraint}${selection2}`;
  }), sortOrder = toOrderClause(searchOpts?.sort || [{
    field: "_id",
    direction: "asc"
  }]), projectionFields = ["_type", "_id", "_originalId"], selection = selections.length > 0 ? `...select(${selections.join(`,
`)})` : "", finalProjection = projectionFields.join(", ") + (selection ? `, ${selection}` : "");
  let query = `*[${filters.join(" && ")}]| order(${sortOrder})[0...$__limit]{${finalProjection}}`;
  if (searchOpts?.__unstable_extendedProjection) {
    const extendedProjection = searchOpts?.__unstable_extendedProjection, firstProjection = projectionFields.concat(extendedProjection).join(", ");
    query = [`*[${filters.join(" && ")}]{${firstProjection}}`, `order(${sortOrder})[0...$__limit]{${finalProjection}}`].join("|");
  }
  const groqComments = [`findability-mvi:${FINDABILITY_MVI}`].concat(searchOpts?.comments || []).map((s) => `// ${s}`).join(`
`), updatedQuery = groqComments ? `${groqComments}
${query}` : query, limit2 = searchOpts?.limit ?? DEFAULT_LIMIT;
  return {
    query: updatedQuery,
    params: {
      ...toGroqParams(terms),
      __types: specs.map((spec) => spec.typeName),
      __limit: limit2,
      ...params || {}
    },
    options: {
      tag,
      perspective: isRaw || !searchOpts.perspective?.length ? "raw" : searchOpts.perspective
    },
    searchSpec: specs,
    terms
  };
}
const toGroqParams = (terms) => {
  const params = {};
  return terms.reduce((acc, term, i) => (acc[`t${i}`] = `${term}*`, acc), params);
};
function getSearchTerms(searchParams, types) {
  return typeof searchParams == "string" ? {
    query: searchParams,
    types
  } : searchParams.types.length ? searchParams : {
    ...searchParams,
    types
  };
}
const createWeightedSearch = (types, client, factoryOptions) => function(searchParams, searchOptions = {}) {
  const searchTerms = getSearchTerms(searchParams, types), {
    query,
    params,
    options,
    searchSpec,
    terms
  } = createSearchQuery(searchTerms, {
    ...factoryOptions,
    ...searchOptions
  }), apiVersion = isReleasePerspective(options?.perspective) ? RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion : void 0;
  return versionedClient(client, apiVersion).observable.fetch(query, params, options).pipe(
    factoryOptions.unique ? map(removeDupes$3) : tap(),
    // Assign weighting and scores based on current search terms.
    // No scores will be assigned when terms are empty.
    map((hits) => applyWeights(searchSpec, hits, terms)),
    // Optionally skip client-side score sorting.
    // This can be relevant when ordering results by specific fields, especially dates.
    searchOptions?.skipSortByScore ? tap() : map((hits) => sortBy(hits, (hit) => -hit.score)),
    map((hits) => ({
      type: "weighted",
      hits
    }))
  );
}, searchStrategies = {
  groqLegacy: createWeightedSearch,
  groq2024: createGroq2024Search
}, DEFAULT_SEARCH_STRATEGY = "groqLegacy", createSearch = (searchableTypes, client, options) => {
  const factory = searchStrategies[options.strategy ?? DEFAULT_SEARCH_STRATEGY];
  return factory(searchableTypes, isReleasePerspective(options?.perspective) ? versionedClient(client, RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion) : client, options);
};
function getSelectableOmnisearchTypes(schema2, typeFilter) {
  return getSearchableOmnisearchTypes(schema2).filter((type) => inTypeFilter(type, typeFilter)).sort(sortTypes);
}
function getSearchableOmnisearchTypes(schema2) {
  return getSearchableTypes(schema2).filter((type) => type.__experimental_omnisearch_visibility !== !1);
}
function sortTypes(a, b) {
  return (a.title ?? a.name).localeCompare(b.title ?? b.name);
}
function inTypeFilter(type, typeFilter) {
  return !typeFilter || (type.title ?? type.name).toLowerCase().includes(typeFilter?.toLowerCase());
}
const DocumentTypeFilterItem = memo(function(t0) {
  const $ = c(23);
  let rest, selected, type;
  $[0] !== t0 ? ({
    selected,
    type,
    ...rest
  } = t0, $[0] = t0, $[1] = rest, $[2] = selected, $[3] = type) : (rest = $[1], selected = $[2], type = $[3]);
  const {
    dispatch
  } = useSearchState();
  let t1;
  $[4] !== dispatch || $[5] !== type ? (t1 = () => {
    dispatch({
      type: "TERMS_TYPE_ADD",
      schemaType: type
    });
  }, $[4] = dispatch, $[5] = type, $[6] = t1) : t1 = $[6];
  const handleTypeAdd = t1;
  let t2;
  $[7] !== dispatch || $[8] !== type ? (t2 = () => {
    dispatch({
      type: "TERMS_TYPE_REMOVE",
      schemaType: type
    });
  }, $[7] = dispatch, $[8] = type, $[9] = t2) : t2 = $[9];
  const handleTypeRemove = t2;
  let t3;
  $[10] !== handleTypeAdd || $[11] !== handleTypeRemove || $[12] !== selected ? (t3 = () => {
    selected ? handleTypeRemove() : handleTypeAdd();
  }, $[10] = handleTypeAdd, $[11] = handleTypeRemove, $[12] = selected, $[13] = t3) : t3 = $[13];
  const handleClick = t3, t4 = selected && CheckmarkIcon, t5 = type.title ?? type.name, t6 = type.title ?? type.name, t7 = selected ? "primary" : "default";
  let t8;
  $[14] !== handleClick || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { iconRight: t4, justify: "flex-start", mode: "bleed", onClick: handleClick, width: "fill", size: "large", tabIndex: -1, text: t6, tone: t7 }, t5), $[14] = handleClick, $[15] = t4, $[16] = t5, $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  return $[20] !== rest || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(Box, { ...rest, children: t8 }), $[20] = rest, $[21] = t8, $[22] = t9) : t9 = $[22], t9;
}), ClearButtonBox = styled(Box)`
  border-top: 1px solid ${({
  theme
}) => theme.sanity.color.base.border};
  flex-shrink: 0;
`, POPOVER_STYLES = {
  width: "250px"
};
function DocumentTypesPopoverContent() {
  const $ = c(37), [inputElement, setInputElement] = useState(null), [typeFilter, setTypeFilter] = useState(""), commandListRef = useRef(null), {
    t
  } = useTranslation(), schema2 = useSchema(), {
    dispatch,
    state: t0
  } = useSearchState(), {
    terms: t1
  } = t0, {
    types: selectedTypes
  } = t1, [selectedTypesSnapshot, setSelectedTypesSnapshot] = useState(selectedTypes), documentTypeItems = useGetDocumentTypeItems(schema2, selectedTypes, selectedTypesSnapshot, typeFilter);
  let t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => setTypeFilter(e.currentTarget.value), $[0] = t2) : t2 = $[0];
  const handleFilterChange = t2;
  let t3;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setTypeFilter(""), $[1] = t3) : t3 = $[1];
  const handleFilterClear = t3;
  let t4;
  $[2] !== dispatch ? (t4 = () => {
    setSelectedTypesSnapshot([]), dispatch({
      type: "TERMS_TYPES_CLEAR"
    }), commandListRef?.current?.focusInputElement(), commandListRef?.current?.scrollToIndex(0);
  }, $[2] = dispatch, $[3] = t4) : t4 = $[3];
  const handleTypesClear = t4;
  let t5;
  $[4] !== documentTypeItems ? (t5 = (index) => {
    const virtualItem = documentTypeItems[index];
    switch (virtualItem.type) {
      case "divider":
        return `${virtualItem.type}-${index}`;
      case "header":
        return `${virtualItem.type}-${virtualItem.title}`;
      case "item":
        return `${virtualItem.type}-${virtualItem.item.name}`;
      default:
        return index;
    }
  }, $[4] = documentTypeItems, $[5] = t5) : t5 = $[5];
  const getItemKey2 = t5, renderItem2 = _temp$2j;
  let t6;
  $[6] !== documentTypeItems ? (t6 = (index_0) => documentTypeItems[index_0].type !== "item", $[6] = documentTypeItems, $[7] = t6) : t6 = $[7];
  const getItemDisabled = t6;
  let t7;
  $[8] !== documentTypeItems ? (t7 = (index_1) => {
    const item_1 = documentTypeItems[index_1];
    return item_1.type === "item" && item_1.selected;
  }, $[8] = documentTypeItems, $[9] = t7) : t7 = $[9];
  const getItemSelected = t7;
  let t8;
  $[10] !== t ? (t8 = t("search.action.filter-by-document-type-aria-label"), $[10] = t, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== t8 || $[13] !== typeFilter ? (t9 = /* @__PURE__ */ jsx(FilterPopoverContentHeader, { ariaInputLabel: t8, onChange: handleFilterChange, onClear: handleFilterClear, ref: setInputElement, typeFilter }), $[12] = t8, $[13] = typeFilter, $[14] = t9) : t9 = $[14];
  let t10;
  $[15] !== documentTypeItems || $[16] !== getItemDisabled || $[17] !== getItemKey2 || $[18] !== getItemSelected || $[19] !== inputElement || $[20] !== t ? (t10 = documentTypeItems.length > 0 && /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("search.document-types-aria-label"), ariaMultiselectable: !0, autoFocus: "input", getItemDisabled, getItemSelected, getItemKey: getItemKey2, inputElement, itemHeight: 37, items: documentTypeItems, overscan: 20, padding: 1, paddingBottom: 0, ref: commandListRef, renderItem: renderItem2 }), $[15] = documentTypeItems, $[16] = getItemDisabled, $[17] = getItemKey2, $[18] = getItemSelected, $[19] = inputElement, $[20] = t, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== documentTypeItems.length || $[23] !== t || $[24] !== typeFilter ? (t11 = !documentTypeItems.length && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: t("search.document-types-no-matches-found", {
    filter: typeFilter
  }) }) }), $[22] = documentTypeItems.length, $[23] = t, $[24] = typeFilter, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== t10 || $[27] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Flex, { children: [
    t10,
    t11
  ] }), $[26] = t10, $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== handleTypesClear || $[30] !== selectedTypes || $[31] !== typeFilter ? (t13 = !typeFilter && selectedTypes.length > 0 && /* @__PURE__ */ jsx(ClearButton, { onClick: handleTypesClear, selectedTypes }), $[29] = handleTypesClear, $[30] = selectedTypes, $[31] = typeFilter, $[32] = t13) : t13 = $[32];
  let t14;
  return $[33] !== t12 || $[34] !== t13 || $[35] !== t9 ? (t14 = /* @__PURE__ */ jsxs(Flex, { direction: "column", style: POPOVER_STYLES, children: [
    t9,
    t12,
    t13
  ] }), $[33] = t12, $[34] = t13, $[35] = t9, $[36] = t14) : t14 = $[36], t14;
}
function _temp$2j(item) {
  return item.type === "divider" ? /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(MenuDivider, {}) }) : item.type === "header" ? /* @__PURE__ */ jsx(Box, { margin: 2, padding: 1, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: item.title }) }) : item.type === "item" ? /* @__PURE__ */ jsx(DocumentTypeFilterItem, { paddingBottom: 1, selected: item.selected, type: item.item }) : null;
}
function ClearButton(t0) {
  const $ = c(9), {
    onClick: onClick2,
    selectedTypes
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("search.action.clear-type-filters-aria-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  const t2 = selectedTypes.length === 0;
  let t3;
  $[2] !== t ? (t3 = t("search.action.clear-type-filters-label"), $[2] = t, $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] !== onClick2 || $[5] !== t1 || $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(ClearButtonBox, { padding: 1, children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Button, { "aria-label": t1, "data-name": "type-filter-button", disabled: t2, mode: "bleed", onClick: onClick2, text: t3, tone: "primary" }) }) }), $[4] = onClick2, $[5] = t1, $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
function useGetDocumentTypeItems(schema2, selectedTypes, selectedTypesSnapshot, typeFilter) {
  const $ = c(5);
  let t0, items;
  if ($[0] !== schema2 || $[1] !== selectedTypes || $[2] !== selectedTypesSnapshot || $[3] !== typeFilter) {
    const [itemsSelected, itemsUnselected] = partition(getSelectableOmnisearchTypes(schema2, typeFilter), (type) => selectedTypesSnapshot.includes(type)), hasSelectedItems = itemsSelected.length > 0, hasUnselectedItems = itemsSelected.length > 0;
    items = [], hasSelectedItems && items.push({
      title: "Selected",
      type: "header"
    }), itemsSelected.forEach((item) => items.push({
      item,
      selected: selectedTypes.includes(item),
      type: "item"
    })), hasSelectedItems && hasUnselectedItems && items.push({
      type: "divider"
    }), itemsUnselected.forEach((item_0) => items.push({
      item: item_0,
      selected: selectedTypes.includes(item_0),
      type: "item"
    })), $[0] = schema2, $[1] = selectedTypes, $[2] = selectedTypesSnapshot, $[3] = typeFilter, $[4] = items;
  } else
    items = $[4];
  return t0 = items, t0;
}
const FALLBACK_PLACEMENTS$3 = ["top-start", "bottom-start"];
function DocumentTypesButton() {
  const $ = c(19), [open, setOpen] = useState(!1), [buttonElement, setButtonElement] = useState(null), popoverRef = useRef(null), {
    state: t0
  } = useSearchState(), {
    fullscreen,
    terms: t1
  } = t0, {
    types
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setOpen(!1), $[0] = t2) : t2 = $[0];
  const handleClose = t2;
  let t3;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setOpen(!0), $[1] = t3) : t3 = $[1];
  const handleOpen = t3;
  let t4;
  $[2] !== buttonElement ? (t4 = () => [buttonElement, popoverRef.current], $[2] = buttonElement, $[3] = t4) : t4 = $[3], useClickOutsideEvent(handleClose, t4);
  let t5, t6;
  $[4] !== t || $[5] !== types ? (t6 = documentTypesTruncated({
    types,
    t
  }), $[4] = t, $[5] = types, $[6] = t6) : t6 = $[6], t5 = t6;
  const title = t5;
  let t7;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t7 = [POPOVER_VERTICAL_MARGIN, 0, 0, 0], $[7] = t7) : t7 = $[7];
  let t8;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t8 = /* @__PURE__ */ jsx(DocumentTypesPopoverContent, {}), $[8] = t8) : t8 = $[8];
  let t9;
  $[9] !== buttonElement ? (t9 = /* @__PURE__ */ jsx(FilterPopoverWrapper, { anchorElement: buttonElement, onClose: handleClose, children: t8 }), $[9] = buttonElement, $[10] = t9) : t9 = $[10];
  const t10 = fullscreen ? "large" : "default";
  let t11;
  $[11] !== open || $[12] !== t10 || $[13] !== title ? (t11 = /* @__PURE__ */ jsx(Button, { iconRight: ChevronDownIcon, mode: "ghost", onClick: handleOpen, size: t10, ref: setButtonElement, selected: open, text: title, tone: "default" }), $[11] = open, $[12] = t10, $[13] = title, $[14] = t11) : t11 = $[14];
  let t12;
  return $[15] !== open || $[16] !== t11 || $[17] !== t9 ? (t12 = /* @__PURE__ */ jsx(Popover, { __unstable_margins: t7, content: t9, open, placement: "bottom-start", fallbackPlacements: FALLBACK_PLACEMENTS$3, portal: !0, radius: POPOVER_RADIUS$1, ref: popoverRef, children: t11 }), $[15] = open, $[16] = t11, $[17] = t9, $[18] = t12) : t12 = $[18], t12;
}
const CustomBox = styled(Box)`
  flex-shrink: ${({
  $flexShrink = 0
}) => $flexShrink};
`;
function FilterLabel(t0) {
  const $ = c(29), {
    filter: filter2,
    fontSize: t1,
    showContent: t2
  } = t0, fontSize = t1 === void 0 ? 1 : t1, showContent = t2 === void 0 ? !0 : t2, {
    t
  } = useTranslation(), {
    state: t3
  } = useSearchState(), {
    definitions,
    fullscreen
  } = t3;
  let t4;
  $[0] !== definitions.operators || $[1] !== filter2.operatorType ? (t4 = getOperatorDefinition(definitions.operators, filter2.operatorType), $[0] = definitions.operators, $[1] = filter2.operatorType, $[2] = t4) : t4 = $[2];
  const operator = t4, ButtonValue = operator?.buttonValueComponent, filterValue = filter2.value;
  let t5, t6;
  $[3] !== filter2 || $[4] !== fontSize || $[5] !== fullscreen ? (t6 = () => /* @__PURE__ */ jsx(CustomBox, { $flexShrink: fullscreen ? 1 : 0, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", size: fontSize, textOverflow: "ellipsis", weight: "medium", children: /* @__PURE__ */ jsx(FilterTitle, { filter: filter2, maxLength: fullscreen ? 25 : 40 }) }) }), $[3] = filter2, $[4] = fontSize, $[5] = fullscreen, $[6] = t6) : t6 = $[6];
  let t7;
  $[7] !== fontSize || $[8] !== showContent ? (t7 = (t82) => {
    const {
      children
    } = t82;
    return showContent ? /* @__PURE__ */ jsx(CustomBox, { $flexShrink: 0, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", size: fontSize, textOverflow: "ellipsis", weight: "regular", children }) }) : null;
  }, $[7] = fontSize, $[8] = showContent, $[9] = t7) : t7 = $[9];
  let t8;
  $[10] !== ButtonValue || $[11] !== filterValue || $[12] !== fontSize || $[13] !== showContent ? (t8 = (t92) => {
    const {
      children: children_0
    } = t92;
    return showContent ? /* @__PURE__ */ jsx(CustomBox, { $flexShrink: 1, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", size: fontSize, textOverflow: "ellipsis", weight: "medium", children: ButtonValue ? /* @__PURE__ */ jsx(ButtonValue, { value: filterValue }) : children_0 }) }) : null;
  }, $[10] = ButtonValue, $[11] = filterValue, $[12] = fontSize, $[13] = showContent, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== t6 || $[16] !== t7 || $[17] !== t8 ? (t9 = {
    Field: t6,
    Operator: t7,
    Value: t8
  }, $[15] = t6, $[16] = t7, $[17] = t8, $[18] = t9) : t9 = $[18], t5 = t9;
  const components2 = t5;
  if (operator?.descriptionKey || console.warn("Missing `descriptionKey` for operator `%s`", filter2.operatorType), !showContent || !operator?.descriptionKey) {
    const Field = components2.Field;
    let t102;
    return $[19] !== Field ? (t102 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 1, children: /* @__PURE__ */ jsx(Field, {}) }), $[19] = Field, $[20] = t102) : t102 = $[20], t102;
  }
  const t10 = operator?.descriptionKey;
  let t11;
  $[21] !== filter2 || $[22] !== t ? (t11 = getFilterValues(filter2, t), $[21] = filter2, $[22] = t, $[23] = t11) : t11 = $[23];
  let t12;
  return $[24] !== components2 || $[25] !== t || $[26] !== t10 || $[27] !== t11 ? (t12 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t10, components: components2, values: t11 }) }), $[24] = components2, $[25] = t, $[26] = t10, $[27] = t11, $[28] = t12) : t12 = $[28], t12;
}
function getFilterValues(filter2, t) {
  const values2 = {};
  return typeof filter2.value == "number" && (values2.count = filter2.value), isStringOrNumber(filter2.value) && (values2.value = filter2.value), typeof filter2.value == "boolean" && (values2.value = filter2.value ? t("search.filter-boolean-true") : t("search.filter-boolean-false")), isRecord$4(filter2.value) && "from" in filter2.value && isStringOrNumber(filter2.value.from) && (values2.from = filter2.value.from), isRecord$4(filter2.value) && "to" in filter2.value && isStringOrNumber(filter2.value.to) && (values2.to = filter2.value.to), values2;
}
function isStringOrNumber(value) {
  return typeof value == "string" || typeof value == "number";
}
function FilterError(props2) {
  const $ = c(15), {
    t
  } = useTranslation();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(TextWithTone, { tone: "critical", children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("search.error.display-filter-title"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", weight: "medium", children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("search.error.display-filter-description"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t2 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      t2,
      t4
    ] })
  ] }), $[9] = t2, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== props2 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { ...props2, children: t5 }), $[12] = props2, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
}
function CustomMenuItem$2(t0) {
  const $ = c(11), {
    onClick: onClick2,
    operator,
    selected
  } = t0;
  let t1;
  $[0] !== onClick2 || $[1] !== operator.type ? (t1 = () => onClick2(operator.type), $[0] = onClick2, $[1] = operator.type, $[2] = t1) : t1 = $[2];
  const handleClick = t1, {
    t
  } = useTranslation();
  let t2;
  $[3] !== operator.nameKey || $[4] !== t ? (t2 = t(operator.nameKey), $[3] = operator.nameKey, $[4] = t, $[5] = t2) : t2 = $[5];
  const t3 = operator?.icon;
  let t4;
  return $[6] !== handleClick || $[7] !== selected || $[8] !== t2 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(MenuItem$1, { onClick: handleClick, pressed: selected, tone: "default", text: t2, iconRight: t3 }), $[6] = handleClick, $[7] = selected, $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function OperatorsMenuButton(t0) {
  const $ = c(38), {
    filter: filter2,
    operator
  } = t0, menuButtonId = useId(), {
    t
  } = useTranslation(), {
    dispatch,
    state
  } = useSearchState();
  let T0, T1, T2, t1, t2, t3, t4;
  if ($[0] !== dispatch || $[1] !== filter2 || $[2] !== menuButtonId || $[3] !== operator || $[4] !== state.definitions.filters || $[5] !== state.definitions.operators || $[6] !== t) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const operatorItems = getFilterDefinition(state.definitions.filters, filter2.filterName)?.operators;
      let t52;
      $[14] !== dispatch || $[15] !== filter2 ? (t52 = (operatorType) => {
        dispatch({
          filterKey: getFilterKey(filter2),
          operatorType,
          type: "TERMS_FILTERS_SET_OPERATOR"
        });
      }, $[14] = dispatch, $[15] = filter2, $[16] = t52) : t52 = $[16];
      const handleClick = t52;
      if (!operator || !operatorItems || operatorItems.length <= 1) {
        t4 = null;
        break bb0;
      }
      T2 = Inline, T1 = MenuButton$1;
      let t62;
      $[17] !== operator.nameKey || $[18] !== t ? (t62 = t(operator.nameKey), $[17] = operator.nameKey, $[18] = t, $[19] = t62) : t62 = $[19], $[20] !== t62 ? (t2 = /* @__PURE__ */ jsx(Button, { mode: "ghost", iconRight: ChevronDownIcon, text: t62 }), $[20] = t62, $[21] = t2) : t2 = $[21], t3 = menuButtonId || "", T0 = Menu;
      let t72;
      $[22] !== handleClick || $[23] !== operator.type || $[24] !== state.definitions.operators ? (t72 = (item, index) => {
        if (item.type === "item") {
          const menuOperator = getOperatorDefinition(state.definitions.operators, item.name);
          return menuOperator ? /* @__PURE__ */ jsx(CustomMenuItem$2, { onClick: handleClick, operator: menuOperator, selected: operator.type === item.name }, index) : null;
        }
        return item.type === "divider" ? /* @__PURE__ */ jsx(MenuDivider, {}, index) : null;
      }, $[22] = handleClick, $[23] = operator.type, $[24] = state.definitions.operators, $[25] = t72) : t72 = $[25], t1 = operatorItems.map(t72);
    }
    $[0] = dispatch, $[1] = filter2, $[2] = menuButtonId, $[3] = operator, $[4] = state.definitions.filters, $[5] = state.definitions.operators, $[6] = t, $[7] = T0, $[8] = T1, $[9] = T2, $[10] = t1, $[11] = t2, $[12] = t3, $[13] = t4;
  } else
    T0 = $[7], T1 = $[8], T2 = $[9], t1 = $[10], t2 = $[11], t3 = $[12], t4 = $[13];
  if (t4 !== Symbol.for("react.early_return_sentinel"))
    return t4;
  let t5;
  $[26] !== T0 || $[27] !== t1 ? (t5 = /* @__PURE__ */ jsx(T0, { children: t1 }), $[26] = T0, $[27] = t1, $[28] = t5) : t5 = $[28];
  let t6;
  $[29] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    constrainSize: !0,
    portal: !1,
    radius: 2
  }, $[29] = t6) : t6 = $[29];
  let t7;
  $[30] !== T1 || $[31] !== t2 || $[32] !== t3 || $[33] !== t5 ? (t7 = /* @__PURE__ */ jsx(T1, { button: t2, id: t3, menu: t5, placement: "bottom-start", popover: t6 }), $[30] = T1, $[31] = t2, $[32] = t3, $[33] = t5, $[34] = t7) : t7 = $[34];
  let t8;
  return $[35] !== T2 || $[36] !== t7 ? (t8 = /* @__PURE__ */ jsx(T2, { children: t7 }), $[35] = T2, $[36] = t7, $[37] = t8) : t8 = $[37], t8;
}
function FilterForm(t0) {
  const $ = c(45), {
    filter: filter2
  } = t0, [errorParams, setErrorParams] = useState(null), {
    dispatch,
    state: t1
  } = useSearchState(), {
    definitions,
    fullscreen
  } = t1;
  let t2;
  $[0] !== definitions.filters || $[1] !== filter2.filterName ? (t2 = getFilterDefinition(definitions.filters, filter2.filterName), $[0] = definitions.filters, $[1] = filter2.filterName, $[2] = t2) : t2 = $[2];
  const filterDefinition = t2;
  let t3;
  $[3] !== definitions.operators || $[4] !== filter2.operatorType ? (t3 = getOperatorDefinition(definitions.operators, filter2.operatorType), $[3] = definitions.operators, $[4] = filter2.operatorType, $[5] = t3) : t3 = $[5];
  const operator = t3;
  let t4;
  $[6] !== definitions.fields || $[7] !== filter2 ? (t4 = getFieldFromFilter(definitions.fields, filter2), $[6] = definitions.fields, $[7] = filter2, $[8] = t4) : t4 = $[8];
  const fieldDefinition = t4;
  let t5;
  $[9] !== filter2 ? (t5 = getFilterKey(filter2), $[9] = filter2, $[10] = t5) : t5 = $[10];
  const filterKey = t5;
  let t6;
  $[11] !== dispatch || $[12] !== filter2 ? (t6 = () => {
    dispatch({
      filterKey: getFilterKey(filter2),
      type: "TERMS_FILTERS_REMOVE"
    });
  }, $[11] = dispatch, $[12] = filter2, $[13] = t6) : t6 = $[13];
  const handleClose = t6;
  let t7;
  $[14] !== dispatch || $[15] !== filterKey ? (t7 = (value) => {
    dispatch({
      filterKey,
      type: "TERMS_FILTERS_SET_VALUE",
      value
    });
  }, $[14] = dispatch, $[15] = filterKey, $[16] = t7) : t7 = $[16];
  const handleValueChange = t7;
  let t8;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t8 = (params) => {
    setErrorParams(params);
  }, $[17] = t8) : t8 = $[17];
  const handleCatchError = t8, Component2 = operator?.inputComponent;
  if (errorParams) {
    let t92;
    return $[18] === Symbol.for("react.memo_cache_sentinel") ? (t92 = /* @__PURE__ */ jsx(FilterError, { padding: 4 }), $[18] = t92) : t92 = $[18], t92;
  }
  let t9;
  $[19] !== Component2 || $[20] !== fieldDefinition || $[21] !== filter2.operatorType || $[22] !== filter2.value || $[23] !== handleValueChange ? (t9 = Component2 && /* @__PURE__ */ jsx(Card, { borderTop: !0, padding: 3, children: /* @__PURE__ */ jsx(Component2, { fieldDefinition, onChange: handleValueChange, value: filter2.value }, filter2.operatorType) }), $[19] = Component2, $[20] = fieldDefinition, $[21] = filter2.operatorType, $[22] = filter2.value, $[23] = handleValueChange, $[24] = t9) : t9 = $[24];
  let t10;
  $[25] !== filter2 ? (t10 = /* @__PURE__ */ jsx(Box, { paddingLeft: 1, paddingRight: 2, paddingY: 1, children: /* @__PURE__ */ jsx(FilterDetails, { filter: filter2 }) }), $[25] = filter2, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== fullscreen || $[28] !== handleClose ? (t11 = fullscreen && /* @__PURE__ */ jsx(Button, { icon: TrashIcon, mode: "bleed", onClick: handleClose, tone: "critical", tooltipProps: {
    content: "Remove filter"
  } }), $[27] = fullscreen, $[28] = handleClose, $[29] = t11) : t11 = $[29];
  let t12;
  $[30] !== t10 || $[31] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, justify: "space-between", children: [
    t10,
    t11
  ] }), $[30] = t10, $[31] = t11, $[32] = t12) : t12 = $[32];
  let t13;
  $[33] !== filterDefinition ? (t13 = filterDefinition?.description && /* @__PURE__ */ jsx(Card, { border: !0, padding: 3, radius: 2, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: filterDefinition.description }) }), $[33] = filterDefinition, $[34] = t13) : t13 = $[34];
  let t14;
  $[35] !== filter2 || $[36] !== operator ? (t14 = /* @__PURE__ */ jsx(OperatorsMenuButton, { filter: filter2, operator }), $[35] = filter2, $[36] = operator, $[37] = t14) : t14 = $[37];
  let t15;
  $[38] !== t12 || $[39] !== t13 || $[40] !== t14 ? (t15 = /* @__PURE__ */ jsx(Card, { padding: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t12,
    t13,
    t14
  ] }) }), $[38] = t12, $[39] = t13, $[40] = t14, $[41] = t15) : t15 = $[41];
  let t16;
  return $[42] !== t15 || $[43] !== t9 ? (t16 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: handleCatchError, children: /* @__PURE__ */ jsx(FocusLock, { autoFocus: !supportsTouch, returnFocus: !0, children: /* @__PURE__ */ jsxs(Flex, { direction: "column-reverse", children: [
    t9,
    t15
  ] }) }) }), $[42] = t15, $[43] = t9, $[44] = t16) : t16 = $[44], t16;
}
const ContainerFlex = styled(Flex)`
  max-width: 480px;
  min-width: 150px;
  overflow: hidden;
  overflow: clip;
  width: 100%;
`;
function FilterPopoverContent(t0) {
  const $ = c(6), {
    filter: filter2
  } = t0;
  let t1, t2;
  $[0] !== filter2 ? (t1 = /* @__PURE__ */ jsx(FilterForm, { filter: filter2 }), t2 = DEBUG_MODE, $[0] = filter2, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]);
  let t3;
  return $[3] !== t1 || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsxs(ContainerFlex, { direction: "column", children: [
    t1,
    t2
  ] }), $[3] = t1, $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}
const CloseButton = styled(Button$1)`
  border-radius: ${({
  theme
}) => `0 ${rem(theme.sanity.radius[2])} ${rem(theme.sanity.radius[2])} 0`};
`, CloseCard = styled(Card)`
  position: absolute;
  right: 0;
`, ContainerDiv = styled.div`
  align-items: center;
  display: inline-flex;
  max-width: 100%;
  position: relative;
`, LabelButton = styled(Button$1)`
  border: none;
  width: 100%;
`;
function FilterButton(t0) {
  const $ = c(45), {
    filter: filter2,
    initialOpen
  } = t0, [open, setOpen] = useState(initialOpen), [buttonElement, setButtonElement] = useState(null), popoverRef = useRef(null), {
    dispatch,
    state: t1
  } = useSearchState(), {
    definitions,
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setOpen(!1), $[0] = t2) : t2 = $[0];
  const handleClose = t2;
  let t3;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setOpen(!0), $[1] = t3) : t3 = $[1];
  const handleOpen = t3;
  let t4;
  $[2] !== dispatch || $[3] !== filter2 ? (t4 = () => dispatch({
    filterKey: getFilterKey(filter2),
    type: "TERMS_FILTERS_REMOVE"
  }), $[2] = dispatch, $[3] = filter2, $[4] = t4) : t4 = $[4];
  const handleRemove = t4;
  let t5;
  $[5] !== handleRemove ? (t5 = (event) => {
    ["Backspace", "Delete"].includes(event.key) && handleRemove();
  }, $[5] = handleRemove, $[6] = t5) : t5 = $[6];
  const handleKeyDown = t5;
  let t6;
  $[7] !== buttonElement ? (t6 = () => [buttonElement, popoverRef.current], $[7] = buttonElement, $[8] = t6) : t6 = $[8], useClickOutsideEvent(handleClose, t6);
  let t7;
  $[9] !== definitions.fields || $[10] !== definitions.filters || $[11] !== definitions.operators || $[12] !== filter2 ? (t7 = validateFilter({
    fieldDefinitions: definitions.fields,
    filter: filter2,
    filterDefinitions: definitions.filters,
    operatorDefinitions: definitions.operators
  }), $[9] = definitions.fields, $[10] = definitions.filters, $[11] = definitions.operators, $[12] = filter2, $[13] = t7) : t7 = $[13];
  const isValid2 = t7;
  let t8;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t8 = [POPOVER_VERTICAL_MARGIN, 0, 0, 0], $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== filter2 ? (t9 = /* @__PURE__ */ jsx(FilterPopoverContent, { filter: filter2 }), $[15] = filter2, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== buttonElement || $[18] !== t9 ? (t10 = /* @__PURE__ */ jsx(FilterPopoverWrapper, { anchorElement: buttonElement, onClose: handleClose, children: t9 }), $[17] = buttonElement, $[18] = t9, $[19] = t10) : t10 = $[19];
  const t11 = isValid2 ? "primary" : "transparent", t12 = fullscreen ? 3 : 2, t13 = fullscreen ? 3 : 5, t14 = fullscreen ? 3 : 2;
  let t15;
  $[20] !== filter2 || $[21] !== isValid2 ? (t15 = /* @__PURE__ */ jsx(FilterLabel, { filter: filter2, showContent: isValid2 }), $[20] = filter2, $[21] = isValid2, $[22] = t15) : t15 = $[22];
  let t16;
  $[23] !== handleKeyDown || $[24] !== t12 || $[25] !== t13 || $[26] !== t14 || $[27] !== t15 ? (t16 = /* @__PURE__ */ jsx(LabelButton, { mode: "bleed", onClick: handleOpen, onKeyDown: handleKeyDown, paddingLeft: t12, paddingRight: t13, paddingY: t14, ref: setButtonElement, children: t15 }), $[23] = handleKeyDown, $[24] = t12, $[25] = t13, $[26] = t14, $[27] = t15, $[28] = t16) : t16 = $[28];
  let t17;
  $[29] !== t11 || $[30] !== t16 ? (t17 = /* @__PURE__ */ jsx(Card, { __unstable_focusRing: !0, display: "flex", radius: 2, tone: t11, children: t16 }), $[29] = t11, $[30] = t16, $[31] = t17) : t17 = $[31];
  let t18;
  $[32] !== fullscreen || $[33] !== handleKeyDown || $[34] !== handleRemove || $[35] !== isValid2 || $[36] !== t ? (t18 = !fullscreen && /* @__PURE__ */ jsx(CloseCard, { __unstable_focusRing: !0, display: "flex", radius: 2, tone: isValid2 ? "primary" : "transparent", children: /* @__PURE__ */ jsx(CloseButton, { "aria-label": t("search.action.remove-filter-aria-label"), fontSize: 1, icon: CloseIcon, mode: "bleed", onClick: handleRemove, onKeyDown: handleKeyDown, padding: 2, radius: 2 }) }), $[32] = fullscreen, $[33] = handleKeyDown, $[34] = handleRemove, $[35] = isValid2, $[36] = t, $[37] = t18) : t18 = $[37];
  let t19;
  $[38] !== t17 || $[39] !== t18 ? (t19 = /* @__PURE__ */ jsxs(ContainerDiv, { children: [
    t17,
    t18
  ] }), $[38] = t17, $[39] = t18, $[40] = t19) : t19 = $[40];
  let t20;
  return $[41] !== open || $[42] !== t10 || $[43] !== t19 ? (t20 = /* @__PURE__ */ jsx(Popover, { __unstable_margins: t8, content: t10, constrainSize: !0, open, overflow: "auto", placement: "bottom-start", portal: !0, radius: POPOVER_RADIUS$1, ref: popoverRef, children: t19 }), $[41] = open, $[42] = t10, $[43] = t19, $[44] = t20) : t20 = $[44], t20;
}
function Filters(t0) {
  const $ = c(38), {
    showTypeFilter: t1
  } = t0, showTypeFilter = t1 === void 0 ? !0 : t1, {
    dispatch,
    state: t2
  } = useSearchState(), {
    filters,
    fullscreen,
    lastAddedFilter,
    terms: t3
  } = t2, {
    types
  } = t3, {
    t
  } = useTranslation(), [isMounted, setIsMounted] = useState(!1);
  let t4;
  $[0] !== dispatch || $[1] !== showTypeFilter ? (t4 = () => {
    showTypeFilter && dispatch({
      type: "TERMS_TYPES_CLEAR"
    }), dispatch({
      type: "TERMS_FILTERS_CLEAR"
    });
  }, $[0] = dispatch, $[1] = showTypeFilter, $[2] = t4) : t4 = $[2];
  const handleClear = t4, clearFiltersButtonVisible = filters.length > 0 || showTypeFilter && types.length > 0;
  let t5, t6;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setIsMounted(!0);
  }, t6 = [], $[3] = t5, $[4] = t6) : (t5 = $[3], t6 = $[4]), useEffect(t5, t6);
  let t7;
  $[5] !== lastAddedFilter ? (t7 = lastAddedFilter && getFilterKey(lastAddedFilter), $[5] = lastAddedFilter, $[6] = t7) : t7 = $[6];
  const lastAddedFilterKey = t7;
  let t8;
  $[7] !== fullscreen || $[8] !== handleClear || $[9] !== t ? (t8 = () => /* @__PURE__ */ jsx(Button, { mode: "bleed", onClick: handleClear, size: fullscreen ? "large" : "default", text: t("search.action.clear-filters"), tone: "critical" }), $[7] = fullscreen, $[8] = handleClear, $[9] = t, $[10] = t8) : t8 = $[10];
  const ClearFiltersButton = t8;
  let t9;
  $[11] !== showTypeFilter ? (t9 = showTypeFilter && /* @__PURE__ */ jsx(DocumentTypesButton, {}), $[11] = showTypeFilter, $[12] = t9) : t9 = $[12];
  let t10;
  $[13] !== filters || $[14] !== isMounted || $[15] !== lastAddedFilterKey ? (t10 = filters?.map((filter2) => {
    const key = getFilterKey(filter2);
    return /* @__PURE__ */ jsx(FilterButton, { filter: filter2, initialOpen: isMounted && lastAddedFilterKey === key }, key);
  }), $[13] = filters, $[14] = isMounted, $[15] = lastAddedFilterKey, $[16] = t10) : t10 = $[16];
  let t11;
  $[17] !== fullscreen ? (t11 = !fullscreen && /* @__PURE__ */ jsx(AddFilterButton, {}), $[17] = fullscreen, $[18] = t11) : t11 = $[18];
  let t12;
  $[19] !== t10 || $[20] !== t11 || $[21] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 2, wrap: "wrap", children: [
    t9,
    t10,
    t11
  ] }), $[19] = t10, $[20] = t11, $[21] = t9, $[22] = t12) : t12 = $[22];
  let t13;
  $[23] !== ClearFiltersButton || $[24] !== clearFiltersButtonVisible || $[25] !== fullscreen ? (t13 = clearFiltersButtonVisible && !fullscreen && /* @__PURE__ */ jsx(ClearFiltersButton, {}), $[23] = ClearFiltersButton, $[24] = clearFiltersButtonVisible, $[25] = fullscreen, $[26] = t13) : t13 = $[26];
  let t14;
  $[27] !== t12 || $[28] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, justify: "space-between", padding: 2, children: [
    t12,
    t13
  ] }), $[27] = t12, $[28] = t13, $[29] = t14) : t14 = $[29];
  let t15;
  $[30] !== ClearFiltersButton || $[31] !== clearFiltersButtonVisible || $[32] !== fullscreen ? (t15 = fullscreen && /* @__PURE__ */ jsxs(Flex, { justify: "space-between", paddingBottom: 2, paddingX: 2, children: [
    /* @__PURE__ */ jsx(AddFilterButton, {}),
    clearFiltersButtonVisible && /* @__PURE__ */ jsx(ClearFiltersButton, {})
  ] }), $[30] = ClearFiltersButton, $[31] = clearFiltersButtonVisible, $[32] = fullscreen, $[33] = t15) : t15 = $[33];
  let t16;
  $[34] === Symbol.for("react.memo_cache_sentinel") ? (t16 = DEBUG_MODE, $[34] = t16) : t16 = $[34];
  let t17;
  return $[35] !== t14 || $[36] !== t15 ? (t17 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t14,
    t15,
    t16
  ] }), $[35] = t14, $[36] = t15, $[37] = t17) : t17 = $[37], t17;
}
const MAX_OBJECT_TRAVERSAL_DEPTH = 3;
function createFieldDefinitions(schema2, filterDefinitions2) {
  const searchableDocumentTypeNames = getSearchableOmnisearchTypes(schema2).map((s) => s.name), {
    documentTypes,
    objectTypes
  } = (schema2._original?.types || []).filter((t) => isDocumentObjectDefinition(t) ? searchableDocumentTypeNames.includes(t.name) : !0).filter((schemaType) => schemaType.name !== "slug").filter((schemaType) => !schemaType.name.startsWith("sanity.")).reduce((acc, schemaType) => (isDocumentObjectDefinition(schemaType) && (acc.documentTypes[schemaType.name] = schemaType), isObjectDefinition(schemaType) && (acc.objectTypes[schemaType.name] = schemaType), acc), {
    documentTypes: {},
    objectTypes: {}
  }) || {
    documentTypes: {},
    objectTypes: {}
  }, supportedFieldTypes = getSupportedFieldTypes(filterDefinitions2);
  return getDocumentFieldDefinitions(supportedFieldTypes, documentTypes, objectTypes);
}
function createFieldDefinitionDictionary(fieldDefinitions) {
  return fieldDefinitions.reduce((acc, val) => (acc[val.id] = val, acc), {});
}
function generateFieldId(field) {
  return [field.type, field.fieldPath, field.filterName, field.documentTypes.join(",")].join("-");
}
function getDocumentFieldDefinitions(supportedFieldTypes, documentTypes, objectTypes) {
  function addFieldDefinitionRecursive({
    acc,
    defType,
    depth = 0,
    documentType,
    prevFieldPath,
    prevTitlePath
  }) {
    const continueRecursion = depth <= MAX_OBJECT_TRAVERSAL_DEPTH, isInternalField = defType.name.startsWith("_"), title = defType?.title ? sanitizeFieldValue(defType.title) : startCase(defType.name), fieldPath = prevFieldPath ? `${prevFieldPath}.${defType.name}` : defType.name, titlePath = prevTitlePath ? [...prevTitlePath, title] : [title];
    if (!continueRecursion) return;
    const existingObject = objectTypes[defType.type], existingDocument = documentTypes[defType.type], inlineObject = isObjectDefinition(defType) ? defType : null, targetObject = existingDocument || existingObject || inlineObject;
    if (targetObject) {
      targetObject?.fields?.forEach((field) => addFieldDefinitionRecursive({
        acc,
        defType: field,
        depth: depth + 1,
        documentType,
        prevFieldPath: fieldPath,
        prevTitlePath: titlePath
      }));
      return;
    }
    supportedFieldTypes.includes(defType.type) && acc.push({
      documentTypes: documentType && !isInternalField ? [documentType] : [],
      fieldPath,
      filterName: resolveFilterName(defType),
      id: "",
      name: defType.name,
      titlePath,
      title,
      type: defType.type
    });
  }
  return Object.values(documentTypes).reduce((acc, documentType) => {
    const documentFields = documentType.fields.reduce((a, field) => (addFieldDefinitionRecursive({
      acc: a,
      defType: field,
      documentType: documentType.name
    }), a), []);
    return acc.push(...documentFields), acc;
  }, []).reduce((acc, val) => {
    const prevIndex = acc.findIndex((v) => v.fieldPath === val.fieldPath && v.title === val.title && v.type === val.type);
    return prevIndex > -1 ? acc[prevIndex] = {
      ...acc[prevIndex],
      documentTypes: [...acc[prevIndex].documentTypes, ...val.documentTypes]
    } : acc.push(val), acc;
  }, []).map(addFieldDefinitionId).sort(sortFieldDefinitions);
}
function addFieldDefinitionId(field) {
  return {
    ...field,
    id: generateFieldId(field)
  };
}
function isArrayOfPrimitives$1(schemaType) {
  return isArrayDefinition(schemaType) ? schemaType.of.every((item) => ["boolean", "number", "string"].includes(item.type)) && (schemaType.options?.list ? schemaType.options.list.length > 0 : !1) : !1;
}
function isArrayDefinition(schemaType) {
  return schemaType.type === "array";
}
function isDocumentObjectDefinition(schemaType) {
  return schemaType.type === "document";
}
function isObjectDefinition(schemaType) {
  return schemaType.type === "object";
}
function isStringDefinition(schemaType) {
  return schemaType.type === "string";
}
function isStringListDefinition(schemaType) {
  return isStringDefinition(schemaType) && schemaType.options?.list ? schemaType.options.list.length > 0 : !1;
}
function resolveFilterName(schemaType) {
  if (isStringListDefinition(schemaType))
    return "stringList";
  if (isArrayDefinition(schemaType)) {
    if (schemaType.of.some((item) => item.type === "reference"))
      return "arrayReferences";
    if (schemaType.of.find((item) => item.type === "block"))
      return "portableText";
    if (isArrayOfPrimitives$1(schemaType))
      return "arrayList";
  }
  return schemaType.type;
}
function sortFieldDefinitions(a, b) {
  const aTitlePath = a.titlePath.slice(0, -1).join("/"), bTitlePath = b.titlePath.slice(0, -1).join("/");
  return a.title.localeCompare(b.title) || aTitlePath.localeCompare(bTitlePath) || a.fieldPath.localeCompare(b.fieldPath);
}
const RECENT_SEARCH_VERSION$1 = 2, STORED_SEARCHES_NAMESPACE = "studio.search.recent", defaultValue = {
  version: RECENT_SEARCH_VERSION$1,
  recentSearches: []
};
function useStoredSearch() {
  const $ = c(14), keyValueStore = useKeyValueStore(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    dataset
  } = client.config();
  let t0;
  t0 = `${STORED_SEARCHES_NAMESPACE}.${dataset}`;
  const keyValueStoreKey = t0, [value, setValue] = useState(defaultValue);
  let t1, t2;
  $[0] !== keyValueStore || $[1] !== keyValueStoreKey ? (t2 = keyValueStore.getKey(keyValueStoreKey), $[0] = keyValueStore, $[1] = keyValueStoreKey, $[2] = t2) : t2 = $[2], t1 = t2;
  const settings = t1;
  let t3, t4;
  $[3] !== keyValueStore || $[4] !== keyValueStoreKey || $[5] !== settings ? (t3 = () => {
    const sub2 = settings.pipe(startWith(defaultValue), map((data) => data ? data?.version !== RECENT_SEARCH_VERSION$1 ? (keyValueStore.setKey(keyValueStoreKey, defaultValue), defaultValue) : data : defaultValue)).subscribe({
      next: setValue
    });
    return () => sub2?.unsubscribe();
  }, t4 = [settings, keyValueStore, keyValueStoreKey], $[3] = keyValueStore, $[4] = keyValueStoreKey, $[5] = settings, $[6] = t3, $[7] = t4) : (t3 = $[6], t4 = $[7]), useEffect(t3, t4);
  let t5;
  $[8] !== keyValueStore || $[9] !== keyValueStoreKey ? (t5 = (newValue) => {
    setValue(newValue), keyValueStore.setKey(keyValueStoreKey, newValue);
  }, $[8] = keyValueStore, $[9] = keyValueStoreKey, $[10] = t5) : t5 = $[10];
  const set2 = t5;
  let t6, t7;
  return $[11] !== set2 || $[12] !== value ? (t7 = [value, set2], $[11] = set2, $[12] = value, $[13] = t7) : t7 = $[13], t6 = t7, t6;
}
const MAX_RECENT_SEARCHES = 5, RECENT_SEARCH_VERSION = 2;
function useRecentSearchesStore() {
  const $ = c(18), [storedSearch, setStoredSearch] = useStoredSearch(), schema2 = useSchema(), {
    search: t0
  } = useSource(), {
    operators,
    filters
  } = t0;
  let t1, t2;
  $[0] !== filters || $[1] !== schema2 ? (t2 = createFieldDefinitionDictionary(createFieldDefinitions(schema2, filters)), $[0] = filters, $[1] = schema2, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== filters ? (t3 = createFilterDefinitionDictionary(filters), $[3] = filters, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== operators ? (t4 = createOperatorDefinitionDictionary(operators), $[5] = operators, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t2 || $[8] !== t3 || $[9] !== t4 ? (t5 = {
    fieldDefinitions: t2,
    filterDefinitions: t3,
    operatorDefinitions: t4
  }, $[7] = t2, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10], t1 = t5;
  const {
    fieldDefinitions,
    filterDefinitions: filterDefinitions2,
    operatorDefinitions: operatorDefinitions2
  } = t1;
  let t6;
  return $[11] !== fieldDefinitions || $[12] !== filterDefinitions2 || $[13] !== operatorDefinitions2 || $[14] !== schema2 || $[15] !== setStoredSearch || $[16] !== storedSearch ? (t6 = {
    addSearch: (searchTerm, searchFilters) => {
      const validStoredFilters = (searchFilters || []).map(_temp$2i).filter((filter_0) => validateFilter({
        fieldDefinitions,
        filter: filter_0,
        filterDefinitions: filterDefinitions2,
        operatorDefinitions: operatorDefinitions2
      })), newSearchItem = {
        created: (/* @__PURE__ */ new Date()).toISOString(),
        filters: validStoredFilters,
        terms: {
          query: searchTerm.query.trim(),
          typeNames: searchTerm.types.map(_temp2$S)
        }
      }, newRecent = {
        version: RECENT_SEARCH_VERSION,
        recentSearches: [newSearchItem, ...storedSearch.recentSearches.filter((r) => !isEqual$2(omit(r, "created"), omit(newSearchItem, "created")))].slice(0, MAX_RECENT_SEARCHES)
      };
      return setStoredSearch(newRecent), getRecentSearchTerms({
        fieldDefinitions,
        filterDefinitions: filterDefinitions2,
        operatorDefinitions: operatorDefinitions2,
        schema: schema2,
        storedSearch: newRecent,
        setStoredSearch
      });
    },
    getRecentSearches: () => getRecentSearchTerms({
      fieldDefinitions,
      filterDefinitions: filterDefinitions2,
      operatorDefinitions: operatorDefinitions2,
      schema: schema2,
      storedSearch,
      setStoredSearch
    }),
    removeSearch: () => {
      const newRecent_0 = {
        ...storedSearch,
        recentSearches: []
      };
      return setStoredSearch(newRecent_0), getRecentSearchTerms({
        fieldDefinitions,
        filterDefinitions: filterDefinitions2,
        operatorDefinitions: operatorDefinitions2,
        schema: schema2,
        storedSearch: newRecent_0,
        setStoredSearch
      });
    },
    removeSearchAtIndex: (index) => {
      if (index < 0 || index > storedSearch.recentSearches.length)
        return getRecentSearchTerms({
          fieldDefinitions,
          filterDefinitions: filterDefinitions2,
          operatorDefinitions: operatorDefinitions2,
          schema: schema2,
          storedSearch,
          setStoredSearch
        });
      const newRecent_1 = {
        ...storedSearch,
        recentSearches: [...storedSearch.recentSearches.slice(0, index), ...storedSearch.recentSearches.slice(index + 1)]
      };
      return setStoredSearch(newRecent_1), getRecentSearchTerms({
        fieldDefinitions,
        filterDefinitions: filterDefinitions2,
        operatorDefinitions: operatorDefinitions2,
        schema: schema2,
        storedSearch: newRecent_1,
        setStoredSearch
      });
    }
  }, $[11] = fieldDefinitions, $[12] = filterDefinitions2, $[13] = operatorDefinitions2, $[14] = schema2, $[15] = setStoredSearch, $[16] = storedSearch, $[17] = t6) : t6 = $[17], t6;
}
function _temp2$S(s) {
  return s.name;
}
function _temp$2i(filter2) {
  return {
    fieldId: filter2.fieldId,
    filterName: filter2.filterName,
    operatorType: filter2.operatorType,
    value: filter2.value
  };
}
function getRecentSearchTerms({
  schema: schema2,
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  operatorDefinitions: operatorDefinitions2,
  storedSearch,
  setStoredSearch
}) {
  return sanitizeStoredSearch({
    studioSchema: schema2,
    filterDefinitions: filterDefinitions2,
    fieldDefinitions,
    operatorDefinitions: operatorDefinitions2,
    storedSearch,
    setStoredSearch
  }).recentSearches.filter((r) => !!r.terms).map((r, index) => ({
    __recent: {
      index,
      timestamp: new Date(r.created).getTime()
    },
    filters: r.filters,
    query: r.terms.query,
    types: r.terms.typeNames.map((typeName) => schema2.get(typeName)).filter((s) => !!(s && s.jsonType === "object"))
  }));
}
function sanitizeStoredSearch({
  fieldDefinitions,
  filterDefinitions: filterDefinitions2,
  operatorDefinitions: operatorDefinitions2,
  studioSchema,
  storedSearch,
  setStoredSearch
}) {
  const searchableTypeNames = getSearchableOmnisearchTypes(studioSchema).map((schema2) => schema2.name), filteredSearch = storedSearch.recentSearches.filter((recentSearch) => (
    // Has valid searchable types (not hidden by omnisearch)
    recentSearch.terms.typeNames.every((typeName) => searchableTypeNames.includes(typeName)) && recentSearch.filters.every((filter2) => validateFilter({
      fieldDefinitions,
      filter: filter2,
      filterDefinitions: filterDefinitions2,
      operatorDefinitions: operatorDefinitions2
    }))
  )), newStoredSearch = {
    version: RECENT_SEARCH_VERSION,
    recentSearches: filteredSearch
  };
  return newStoredSearch.recentSearches.length < storedSearch.recentSearches.length && setStoredSearch(newStoredSearch), newStoredSearch;
}
function Instructions() {
  const $ = c(3), {
    t
  } = useTranslation();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    ControlsIcon: _temp$2h
  }, $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== t ? (t1 = /* @__PURE__ */ jsx(Flex, { align: "center", direction: "column", gap: 4, paddingX: 4, paddingY: 5, children: /* @__PURE__ */ jsx(Inline, { space: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "search.instructions", components: t0 }) }) }) }), $[1] = t, $[2] = t1) : t1 = $[2], t1;
}
function _temp$2h() {
  return /* @__PURE__ */ jsx(ControlsIcon, { style: {
    padding: "0 0.25rem"
  } }, 0);
}
function DocumentTypesPill(t0) {
  const $ = c(6), {
    availableCharacters,
    types
  } = t0, {
    t
  } = useTranslation();
  let t1, t2;
  $[0] !== availableCharacters || $[1] !== t || $[2] !== types ? (t2 = documentTypesTruncated({
    availableCharacters,
    types,
    t
  }), $[0] = availableCharacters, $[1] = t, $[2] = types, $[3] = t2) : t2 = $[3], t1 = t2;
  const title = t1;
  let t3;
  return $[4] !== title ? (t3 = /* @__PURE__ */ jsx(Card, { border: !0, padding: 2, radius: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: title }) }), $[4] = title, $[5] = t3) : t3 = $[5], t3;
}
const FilterPillCard = styled(Card)`
  cursor: default;
`;
function FilterPill(t0) {
  const $ = c(2), {
    filter: filter2
  } = t0;
  let t1;
  return $[0] !== filter2 ? (t1 = /* @__PURE__ */ jsx(FilterPillCard, { border: !0, padding: 2, radius: 2, tone: "primary", children: /* @__PURE__ */ jsx(FilterLabel, { filter: filter2 }) }), $[0] = filter2, $[1] = t1) : t1 = $[1], t1;
}
const DEFAULT_COMBINED_TYPE_COUNT = 40, RecentSearchItemButton = styled(Button$1)`
  border-radius: ${({
  theme
}) => rem(theme.sanity.radius[2])};
  cursor: default;
  width: 100%;
`, SearchItemPillsBox = styled(Box)`
  flex-shrink: 3;
`, SearchItemQueryFlex = styled(Flex)`
  flex-shrink: 2;
`, CloseButtonDiv = styled.div`
  opacity: 0.8;
  visibility: hidden;

  @media (hover: hover) {
    ${RecentSearchItemButton}:hover & {
      visibility: visible;
    }
    &:hover {
      opacity: 0.4;
    }
  }
`;
function RecentSearchItem(t0) {
  const $ = c(36);
  let index, rest, t1, value;
  $[0] !== t0 ? ({
    index,
    maxVisibleTypePillChars: t1,
    value,
    ...rest
  } = t0, $[0] = t0, $[1] = index, $[2] = rest, $[3] = t1, $[4] = value) : (index = $[1], rest = $[2], t1 = $[3], value = $[4]);
  const maxVisibleTypePillChars = t1 === void 0 ? DEFAULT_COMBINED_TYPE_COUNT : t1, {
    dispatch
  } = useSearchState(), recentSearchesStore = useRecentSearchesStore(), availableCharacters = maxVisibleTypePillChars - value.query.length;
  let t2;
  $[5] !== dispatch || $[6] !== recentSearchesStore || $[7] !== value ? (t2 = () => {
    dispatch({
      type: "TERMS_SET",
      filters: value?.filters,
      terms: value
    }), recentSearchesStore && recentSearchesStore?.addSearch(value, value?.filters);
  }, $[5] = dispatch, $[6] = recentSearchesStore, $[7] = value, $[8] = t2) : t2 = $[8];
  const handleClick = t2;
  let t3;
  $[9] !== index || $[10] !== recentSearchesStore ? (t3 = (event) => {
    event.stopPropagation(), recentSearchesStore && recentSearchesStore?.removeSearchAtIndex(index);
  }, $[9] = index, $[10] = recentSearchesStore, $[11] = t3) : t3 = $[11];
  const handleDelete = t3;
  let t4;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsxs(Inline, { paddingY: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ClockIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { children: "\u200B" })
  ] }), $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== value.query ? (t5 = value.query && /* @__PURE__ */ jsx(SearchItemQueryFlex, { align: "center", paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", weight: "medium", children: value.query }) }), $[13] = value.query, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== availableCharacters || $[16] !== value.types ? (t6 = value.types.length > 0 && /* @__PURE__ */ jsx(SearchItemPillsBox, { children: /* @__PURE__ */ jsx(DocumentTypesPill, { availableCharacters, types: value.types }) }), $[15] = availableCharacters, $[16] = value.types, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== value.filters ? (t7 = value?.filters?.map(_temp$2g), $[18] = value.filters, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== t5 || $[21] !== t6 || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "stretch", flex: 1, gap: 2, justify: "flex-start", marginLeft: 3, wrap: "wrap", children: [
    t5,
    t6,
    t7
  ] }), $[20] = t5, $[21] = t6, $[22] = t7, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] === Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(Flex, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(CloseIcon, {}) }) }), $[24] = t9) : t9 = $[24];
  let t10;
  $[25] !== handleDelete ? (t10 = /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(CloseButtonDiv, { onClick: handleDelete, children: t9 }) }), $[25] = handleDelete, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== t10 || $[28] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Flex, { align: "stretch", children: [
    t4,
    t8,
    t10
  ] }), $[27] = t10, $[28] = t8, $[29] = t11) : t11 = $[29];
  let t12;
  $[30] !== handleClick || $[31] !== t11 ? (t12 = /* @__PURE__ */ jsx(RecentSearchItemButton, { mode: "bleed", onClick: handleClick, paddingLeft: 3, paddingRight: 1, paddingY: 1, tabIndex: -1, children: t11 }), $[30] = handleClick, $[31] = t11, $[32] = t12) : t12 = $[32];
  let t13;
  return $[33] !== rest || $[34] !== t12 ? (t13 = /* @__PURE__ */ jsx(Box, { ...rest, children: t12 }), $[33] = rest, $[34] = t12, $[35] = t13) : t13 = $[35], t13;
}
function _temp$2g(filter2, i) {
  return /* @__PURE__ */ jsx(FilterPill, { filter: filter2 }, i);
}
const VIRTUAL_LIST_RECENT_SEARCH_ITEM_HEIGHT = 36, MAX_COMBINED_TYPE_COUNT_SMALL = 20, MAX_COMBINED_TYPE_COUNT_LARGE = 40, RecentSearchesBox = styled(Card)`
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
`;
function RecentSearches(t0) {
  const $ = c(17), {
    inputElement
  } = t0, {
    state: t1
  } = useSearchState(), {
    filtersVisible,
    fullscreen
  } = t1, recentSearchesStore = useRecentSearchesStore();
  let t2, t3;
  $[0] !== recentSearchesStore ? (t3 = recentSearchesStore?.getRecentSearches(), $[0] = recentSearchesStore, $[1] = t3) : t3 = $[1], t2 = t3;
  const recentSearches = t2, commandListRef = useRef(null), {
    t
  } = useTranslation();
  let t4;
  $[2] !== recentSearchesStore ? (t4 = () => {
    recentSearchesStore && recentSearchesStore.removeSearch(), commandListRef?.current?.focusInputElement();
  }, $[2] = recentSearchesStore, $[3] = t4) : t4 = $[3];
  const handleClearRecentSearchesClick = t4, mediaIndex = useMediaIndex();
  let t5;
  t5 = mediaIndex < 2 ? MAX_COMBINED_TYPE_COUNT_SMALL : MAX_COMBINED_TYPE_COUNT_LARGE;
  const maxVisibleTypePillChars = t5;
  let t6;
  $[4] !== maxVisibleTypePillChars ? (t6 = (item, t72) => {
    const {
      virtualIndex
    } = t72;
    return /* @__PURE__ */ jsx(RecentSearchItem, { index: virtualIndex, maxVisibleTypePillChars, paddingBottom: 1, value: item });
  }, $[4] = maxVisibleTypePillChars, $[5] = t6) : t6 = $[5];
  const renderItem2 = t6, hasRecentSearches = !!recentSearches.length, t7 = hasRecentSearches || !hasRecentSearches && !filtersVisible && fullscreen;
  let t8;
  $[6] !== filtersVisible || $[7] !== fullscreen || $[8] !== handleClearRecentSearchesClick || $[9] !== inputElement || $[10] !== recentSearches || $[11] !== renderItem2 || $[12] !== t ? (t8 = recentSearches.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { paddingBottom: 2, paddingTop: 4, paddingX: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("search.recent-searches-label") }) }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("search.recent-searches-aria-label"), inputElement, initialIndex: 0, itemHeight: VIRTUAL_LIST_RECENT_SEARCH_ITEM_HEIGHT, items: recentSearches, paddingX: 2, paddingY: 1, renderItem: renderItem2 }) }),
    /* @__PURE__ */ jsx(Box, { paddingBottom: 2, paddingTop: 1, paddingX: 2, children: /* @__PURE__ */ jsx(Button, { mode: "bleed", onClick: handleClearRecentSearchesClick, tone: "default", text: t("search.action.clear-recent-searches"), muted: !0 }) })
  ] }) : !filtersVisible && fullscreen && /* @__PURE__ */ jsx(Instructions, {}), $[6] = filtersVisible, $[7] = fullscreen, $[8] = handleClearRecentSearchesClick, $[9] = inputElement, $[10] = recentSearches, $[11] = renderItem2, $[12] = t, $[13] = t8) : t8 = $[13];
  let t9;
  return $[14] !== t7 || $[15] !== t8 ? (t9 = /* @__PURE__ */ jsx(RecentSearchesBox, { borderTop: t7, flex: 1, children: t8 }), $[14] = t7, $[15] = t8, $[16] = t9) : t9 = $[16], t9;
}
const rotate$1 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, AnimatedSpinnerIcon = styled(SpinnerIcon)`
  animation: ${rotate$1} 500ms linear infinite;
`, FilterDiv = styled.div`
  line-height: 0;
  position: relative;
`, SearchHeader = forwardRef(function(t0, ref) {
  const $ = c(48), {
    ariaInputLabel,
    onClose
  } = t0, isMountedRef = useRef(!1), {
    t
  } = useTranslation(), {
    dispatch,
    state: t1
  } = useSearchState(), {
    filters,
    filtersVisible,
    fullscreen,
    result: t2,
    terms
  } = t1, {
    loading
  } = t2, {
    types,
    query
  } = terms;
  let t3;
  $[0] !== terms ? (t3 = hasSearchableTerms({
    terms
  }), $[0] = terms, $[1] = t3) : t3 = $[1];
  const hasValidTerms = t3;
  let t4;
  $[2] !== ariaInputLabel || $[3] !== hasValidTerms || $[4] !== t ? (t4 = t(ariaInputLabel || hasValidTerms ? "search.search-results-aria-label" : "search.recent-searches-aria-label"), $[2] = ariaInputLabel, $[3] = hasValidTerms, $[4] = t, $[5] = t4) : t4 = $[5];
  const ariaLabel = t4;
  let t5;
  $[6] !== dispatch || $[7] !== filtersVisible ? (t5 = () => dispatch({
    type: "FILTERS_VISIBLE_SET",
    visible: !filtersVisible
  }), $[6] = dispatch, $[7] = filtersVisible, $[8] = t5) : t5 = $[8];
  const handleFiltersToggle = t5;
  let t6;
  $[9] !== dispatch ? (t6 = (e) => dispatch({
    type: "TERMS_QUERY_SET",
    query: e.currentTarget.value
  }), $[9] = dispatch, $[10] = t6) : t6 = $[10];
  const handleQueryChange = t6;
  let t7;
  $[11] !== dispatch ? (t7 = () => {
    dispatch({
      type: "TERMS_QUERY_SET",
      query: ""
    });
  }, $[11] = dispatch, $[12] = t7) : t7 = $[12];
  const handleQueryClear = t7;
  let t8, t9;
  $[13] !== dispatch || $[14] !== fullscreen ? (t8 = () => {
    fullscreen || dispatch({
      type: "FILTERS_VISIBLE_SET",
      visible: !0
    });
  }, t9 = [dispatch, fullscreen], $[13] = dispatch, $[14] = fullscreen, $[15] = t8, $[16] = t9) : (t8 = $[15], t9 = $[16]), useEffect(t8, t9);
  let t10, t11;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    isMountedRef.current = !0;
  }, t11 = [], $[17] = t10, $[18] = t11) : (t10 = $[17], t11 = $[18]), useEffect(t10, t11);
  const notificationBadgeVisible = filters.length > 0 || types.length > 0, t12 = fullscreen ? 2 : 1, t13 = fullscreen ? 2 : 1;
  let t14;
  $[19] !== fullscreen || $[20] !== onClose || $[21] !== t ? (t14 = fullscreen && /* @__PURE__ */ jsx(Button, { "aria-label": t("search.action.close-search-aria-label"), icon: ArrowLeftIcon, mode: "bleed", onClick: onClose, size: "large", tooltipProps: {
    content: t("search.action.close-search-aria-label")
  } }), $[19] = fullscreen, $[20] = onClose, $[21] = t, $[22] = t14) : t14 = $[22];
  const t15 = !!query;
  let t16;
  $[23] === Symbol.for("react.memo_cache_sentinel") ? (t16 = [2, 2, 1], $[23] = t16) : t16 = $[23];
  const t17 = loading ? AnimatedSpinnerIcon : SearchIcon;
  let t18;
  $[24] !== t ? (t18 = t("search.placeholder"), $[24] = t, $[25] = t18) : t18 = $[25];
  let t19;
  $[26] !== ariaLabel || $[27] !== fullscreen || $[28] !== handleQueryChange || $[29] !== handleQueryClear || $[30] !== query || $[31] !== ref || $[32] !== t15 || $[33] !== t17 || $[34] !== t18 ? (t19 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(CustomTextInput, { __unstable_disableFocusRing: !0, $background: fullscreen, $smallClearButton: fullscreen, "aria-label": ariaLabel, autoComplete: "off", border: !1, clearButton: t15, fontSize: t16, icon: t17, onChange: handleQueryChange, onClear: handleQueryClear, placeholder: t18, radius: 2, ref, spellCheck: !1, value: query }) }), $[26] = ariaLabel, $[27] = fullscreen, $[28] = handleQueryChange, $[29] = handleQueryClear, $[30] = query, $[31] = ref, $[32] = t15, $[33] = t17, $[34] = t18, $[35] = t19) : t19 = $[35];
  let t20;
  $[36] !== filtersVisible || $[37] !== fullscreen || $[38] !== handleFiltersToggle || $[39] !== notificationBadgeVisible || $[40] !== t ? (t20 = fullscreen && /* @__PURE__ */ jsx(FilterDiv, { children: /* @__PURE__ */ jsx(StatusButton, { "aria-expanded": filtersVisible, "aria-label": t("search.action.toggle-filters-aria-label", {
    context: filtersVisible ? "hide" : "show"
  }), icon: ControlsIcon, mode: "bleed", onClick: handleFiltersToggle, selected: filtersVisible, size: "large", tone: notificationBadgeVisible ? "primary" : void 0, tooltipProps: {
    content: t("search.action.toggle-filters-label", {
      context: filtersVisible ? "hide" : "show"
    })
  } }) }), $[36] = filtersVisible, $[37] = fullscreen, $[38] = handleFiltersToggle, $[39] = notificationBadgeVisible, $[40] = t, $[41] = t20) : t20 = $[41];
  let t21;
  return $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t19 || $[46] !== t20 ? (t21 = /* @__PURE__ */ jsx(Card, { flex: "none", children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: t12, padding: t13, children: [
    t14,
    t19,
    t20
  ] }) }), $[42] = t12, $[43] = t13, $[44] = t14, $[45] = t19, $[46] = t20, $[47] = t21) : t21 = $[47], t21;
});
function NoResults() {
  const $ = c(11), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("search.no-results-title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, weight: "medium", children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t ? (t2 = t("search.no-results-help-description"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: t2 }), $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== t1 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Container$2, { width: 0, children: /* @__PURE__ */ jsxs(Stack, { "aria-live": "assertive", space: 4, paddingX: 4, paddingY: 5, children: [
    t1,
    t3
  ] }) }), $[8] = t1, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function SearchError() {
  const $ = c(12), {
    t
  } = useTranslation();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Box, { marginBottom: 1, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "critical", children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("search.error.unspecified-error-title"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(TextWithTone, { size: 2, tone: "critical", weight: "medium", children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("search.error.unspecified-error-help-description"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== t2 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", "aria-live": "assertive", direction: "column", flex: 1, gap: 3, marginY: 2, padding: 4, children: [
    t0,
    t2,
    t4
  ] }), $[9] = t2, $[10] = t4, $[11] = t5) : t5 = $[11], t5;
}
const getOrderings = ({
  searchStrategy
}) => ({
  createdAsc: {
    ignoreScore: !0,
    sort: {
      direction: "asc",
      field: "_createdAt"
    },
    titleKey: "search.ordering.created-ascending-label"
  },
  createdDesc: {
    ignoreScore: !0,
    sort: {
      direction: "desc",
      field: "_createdAt"
    },
    titleKey: "search.ordering.created-descending-label"
  },
  relevance: {
    customMeasurementLabel: "relevance",
    ...searchStrategy === "groqLegacy" ? {
      sort: {
        direction: "desc",
        field: "_updatedAt"
      }
    } : {},
    titleKey: "search.ordering.best-match-label"
  },
  updatedAsc: {
    ignoreScore: !0,
    sort: {
      direction: "asc",
      field: "_updatedAt"
    },
    titleKey: "search.ordering.updated-ascending-label"
  },
  updatedDesc: {
    ignoreScore: !0,
    sort: {
      direction: "desc",
      field: "_updatedAt"
    },
    titleKey: "search.ordering.updated-descending-label"
  }
}), SortMenuContentFlex = styled(Flex)`
  box-sizing: border-box;
`;
function isSearchDivider(item) {
  return item.type === "divider";
}
function CustomMenuItem$1(t0) {
  const $ = c(13), {
    ordering
  } = t0, {
    t
  } = useTranslation(), {
    dispatch,
    state: t1
  } = useSearchState(), {
    ordering: currentOrdering
  } = t1;
  let t2;
  $[0] !== dispatch || $[1] !== ordering ? (t2 = () => {
    dispatch({
      ordering,
      type: "ORDERING_SET"
    });
  }, $[0] = dispatch, $[1] = ordering, $[2] = t2) : t2 = $[2];
  const handleClick = t2;
  let t3, t4;
  $[3] !== currentOrdering || $[4] !== ordering ? (t4 = isEqual$2(currentOrdering, ordering), $[3] = currentOrdering, $[4] = ordering, $[5] = t4) : t4 = $[5], t3 = t4;
  const isSelected = t3;
  let t5;
  $[6] !== ordering.titleKey || $[7] !== t ? (t5 = t(ordering.titleKey), $[6] = ordering.titleKey, $[7] = t, $[8] = t5) : t5 = $[8];
  let t6;
  return $[9] !== handleClick || $[10] !== isSelected || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuItem$1, { onClick: handleClick, pressed: isSelected, tone: "default", text: t5 }), $[9] = handleClick, $[10] = isSelected, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
function SortMenu() {
  const {
    t
  } = useTranslation(), {
    strategy: searchStrategy
  } = useWorkspace().search, {
    state: {
      ordering
    }
  } = useSearchState(), menuButtonId = useId(), menuOrderings = useMemo(() => {
    const orderings = getOrderings({
      searchStrategy
    });
    return [orderings.relevance, {
      type: "divider"
    }, orderings.createdAsc, orderings.createdDesc, {
      type: "divider"
    }, orderings.updatedAsc, orderings.updatedDesc];
  }, [searchStrategy]), currentMenuItem = menuOrderings.find((item) => isEqual$2(ordering, item) && !isSearchDivider(item));
  return currentMenuItem ? /* @__PURE__ */ jsx(Card, { borderBottom: !0, children: /* @__PURE__ */ jsx(SortMenuContentFlex, { align: "center", flex: 1, padding: 2, children: /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(Button, { mode: "bleed", icon: SortIcon, text: t(currentMenuItem.titleKey) }), id: menuButtonId || "", menu: /* @__PURE__ */ jsx(Menu, { children: menuOrderings.map((item_0, index) => isSearchDivider(item_0) ? /* @__PURE__ */ jsx(MenuDivider, {}, index) : /* @__PURE__ */ jsx(
    CustomMenuItem$1,
    {
      ordering: item_0
    },
    index
  )) }), placement: "bottom-start", popover: {
    portal: !0,
    radius: 2
  } }) }) }) : null;
}
const DebugScoreCard = styled(Card)`
  cursor: help;
  left: 0;
  position: absolute;
  top: 0;
`;
function DebugOverlay(t0) {
  const $ = c(18), {
    data
  } = t0, {
    score
  } = data;
  let tone = "default";
  score <= 0.1 ? tone = "critical" : score >= 0.5 && (tone = "primary");
  let T0, T1, t1, t2;
  if ($[0] !== data.stories) {
    const matchingStories = data.stories.filter(_temp$2f);
    T1 = Tooltip, T0 = Stack, t1 = 2, t2 = matchingStories.length ? /* @__PURE__ */ jsx(Fragment, { children: matchingStories.map(_temp2$R) }) : /* @__PURE__ */ jsx(Code, { size: 0, children: "No matches" }), $[0] = data.stories, $[1] = T0, $[2] = T1, $[3] = t1, $[4] = t2;
  } else
    T0 = $[1], T1 = $[2], t1 = $[3], t2 = $[4];
  let t3;
  $[5] !== T0 || $[6] !== t1 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(T0, { space: t1, children: t2 }), $[5] = T0, $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== score ? (t4 = /* @__PURE__ */ jsxs(Code, { size: 0, children: [
    "score: ",
    score
  ] }), $[9] = score, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t4 || $[12] !== tone ? (t5 = /* @__PURE__ */ jsx(DebugScoreCard, { padding: 1, shadow: 1, tone, children: t4 }), $[11] = t4, $[12] = tone, $[13] = t5) : t5 = $[13];
  let t6;
  return $[14] !== T1 || $[15] !== t3 || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(T1, { content: t3, placement: "bottom-start", portal: !0, children: t5 }) }), $[14] = T1, $[15] = t3, $[16] = t5, $[17] = t6) : t6 = $[17], t6;
}
function _temp2$R(story_0) {
  return /* @__PURE__ */ jsxs(Inline, { space: 3, children: [
    /* @__PURE__ */ jsx(Code, { size: 0, weight: "medium", children: story_0.path }),
    /* @__PURE__ */ jsx(Code, { size: 0, children: story_0.why })
  ] }, story_0.path);
}
function _temp$2f(story) {
  return story.score > 0;
}
const INITIAL_STATE$a = {
  isLoading: !0
}, IDLE_STATE = {
  isLoading: !1,
  value: {
    title: void 0,
    description: void 0
  }
};
function useDocumentPreview(props2) {
  const $ = c(9);
  let t0;
  $[0] !== props2 ? (t0 = props2 || {}, $[0] = props2, $[1] = t0) : t0 = $[1];
  const {
    enabled: t1,
    ordering,
    schemaType,
    value: previewValue
  } = t0, enabled = t1 === void 0 ? !0 : t1, {
    observeForPreview
  } = useDocumentPreviewStore(), {
    perspectiveStack
  } = usePerspective();
  let t2;
  bb0: {
    if (!enabled || !previewValue || !schemaType) {
      let t32;
      $[2] === Symbol.for("react.memo_cache_sentinel") ? (t32 = of(IDLE_STATE), $[2] = t32) : t32 = $[2], t2 = t32;
      break bb0;
    }
    const t3 = previewValue;
    let t4;
    $[3] !== observeForPreview || $[4] !== ordering || $[5] !== perspectiveStack || $[6] !== schemaType || $[7] !== t3 ? (t4 = observeForPreview(t3, schemaType, {
      perspective: perspectiveStack,
      viewOptions: {
        ordering
      }
    }).pipe(map(_temp$2e), catchError(_temp2$Q)), $[3] = observeForPreview, $[4] = ordering, $[5] = perspectiveStack, $[6] = schemaType, $[7] = t3, $[8] = t4) : t4 = $[8], t2 = t4;
  }
  return useObservable(t2, INITIAL_STATE$a);
}
function _temp2$Q(error) {
  return of({
    isLoading: !1,
    error
  });
}
function _temp$2e(event) {
  return {
    isLoading: !1,
    value: event.snapshot || void 0
  };
}
const Dot$2 = styled.div((props2) => {
  const {
    $index
  } = props2, tone = {
    asap: RELEASE_TYPES_TONES.asap.tone,
    scheduled: RELEASE_TYPES_TONES.scheduled.tone,
    undecided: RELEASE_TYPES_TONES.undecided.tone
  };
  return css`
    width: 5px;
    height: 5px;
    background-color: var(--card-icon-color);
    border-radius: 999px;
    box-shadow: 0 0 0 1px var(--card-bg-color);
    z-index: ${$index};
    &[data-status='published'] {
      --card-icon-color: var(--card-badge-positive-dot-color);
    }
    &[data-status='draft'] {
      --card-icon-color: var(--card-badge-caution-dot-color);
    }
    &[data-status='asap'] {
      --card-icon-color: var(--card-badge-${tone.asap}-dot-color);
    }
    &[data-status='undecided'] {
      --card-icon-color: var(--card-badge-${tone.undecided}-dot-color);
    }
    &[data-status='scheduled'] {
      --card-icon-color: var(--card-badge-${tone.scheduled}-dot-color);
    }
  `;
});
function DocumentStatusIndicator({
  draft,
  published,
  versions
}) {
  const {
    data: releases2
  } = useActiveReleases(), versionsList = useMemo(() => versions ? Object.entries(versions).map(([versionName, snapshot2]) => snapshot2 ? releases2?.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === versionName)?.metadata.releaseType : void 0) : [], [releases2, versions]), indicators = [{
    status: "published",
    show: !!published
  }, {
    status: "draft",
    show: !!draft
  }, {
    status: "asap",
    show: versionsList.includes("asap")
  }, {
    status: "scheduled",
    show: versionsList.includes("scheduled")
  }, {
    status: "undecided",
    show: versionsList.includes("undecided")
  }];
  return /* @__PURE__ */ jsx(Flex, { children: indicators.filter(({
    show
  }) => show).map(({
    status
  }, index) => /* @__PURE__ */ jsx(Dot$2, { "data-status": status, $index: index + 1 }, status)) });
}
const SearchResultItemPreviewBox = styled(Box)`
  @supports (-webkit-overflow-scrolling: touch) {
    * [data-ui='Box'] {
      background-attachment: scroll;
    }
  }
`;
function SearchResultItemPreview({
  documentId,
  documentType,
  layout,
  presence,
  schemaType,
  showBadge = !0,
  perspective
}) {
  const documentPreviewStore = useDocumentPreviewStore(), observable = useMemo(() => getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId, perspective), [documentPreviewStore, schemaType, documentId, perspective]), documentStub = useMemo(() => ({
    _id: documentId,
    _type: documentType
  }), [documentId, documentType]), {
    isLoading,
    snapshot: snapshot2,
    original
  } = useObservable(observable, {
    snapshot: null,
    isLoading: !0,
    original: null
  }), versionsInfo = useDocumentVersionInfo(documentId), status = useMemo(() => isLoading ? null : /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    presence && presence.length > 0 && /* @__PURE__ */ jsx(DocumentPreviewPresence, { presence }),
    showBadge && /* @__PURE__ */ jsx(Badge, { children: schemaType.title }),
    /* @__PURE__ */ jsx(DocumentStatusIndicator, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions })
  ] }), [isLoading, presence, schemaType.title, showBadge, versionsInfo.draft, versionsInfo.published, versionsInfo.versions]), tooltip = /* @__PURE__ */ jsx(DocumentStatus, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions });
  return /* @__PURE__ */ jsx(SearchResultItemPreviewBox, { children: /* @__PURE__ */ jsx(SanityDefaultPreview, { ...getPreviewValueWithFallback({
    snapshot: snapshot2,
    original,
    fallback: documentStub
  }), isPlaceholder: isLoading ?? !0, layout: layout || "default", icon: schemaType.icon, status, tooltip }) });
}
function SearchResultItem(t0) {
  const $ = c(68);
  let disableIntentLink, documentId, documentType, layout, onClick2, onItemSelect, previewPerspective, rest;
  $[0] !== t0 ? ({
    disableIntentLink,
    documentId,
    documentType,
    layout,
    onClick: onClick2,
    onItemSelect,
    previewPerspective,
    ...rest
  } = t0, $[0] = t0, $[1] = disableIntentLink, $[2] = documentId, $[3] = documentType, $[4] = layout, $[5] = onClick2, $[6] = onItemSelect, $[7] = previewPerspective, $[8] = rest) : (disableIntentLink = $[1], documentId = $[2], documentType = $[3], layout = $[4], onClick2 = $[5], onItemSelect = $[6], previewPerspective = $[7], rest = $[8]);
  const schema2 = useSchema();
  let t1;
  $[9] !== documentType || $[10] !== schema2 ? (t1 = schema2.get(documentType), $[9] = documentType, $[10] = schema2, $[11] = t1) : t1 = $[11];
  const type = t1, documentPresence = useDocumentPresence(documentId);
  let t2, t3;
  $[12] !== documentId ? (t3 = getPublishedId(documentId), $[12] = documentId, $[13] = t3) : t3 = $[13];
  const t4 = type?.name;
  let t5;
  $[14] !== t3 || $[15] !== t4 ? (t5 = {
    id: t3,
    type: t4
  }, $[14] = t3, $[15] = t4, $[16] = t5) : t5 = $[16], t2 = t5;
  const params = t2;
  let t6;
  $[17] !== params ? (t6 = {
    intent: "edit",
    params
  }, $[17] = params, $[18] = t6) : t6 = $[18];
  const {
    onClick: onIntentClick,
    href
  } = useIntentLink(t6), {
    state
  } = useSearchState(), {
    t
  } = useTranslation(), grantsStore = useGrantsStore(), [createPermission, setCreatePermission] = useState(null), hasCreatePermission = createPermission?.granted;
  let t7, t8;
  $[19] !== documentId || $[20] !== documentType || $[21] !== grantsStore || $[22] !== state.canDisableAction ? (t7 = () => {
    state.canDisableAction && grantsStore.checkDocumentPermission("create", {
      _id: documentId,
      _type: documentType
    }).subscribe(setCreatePermission);
  }, t8 = [documentId, documentType, grantsStore, state.canDisableAction], $[19] = documentId, $[20] = documentType, $[21] = grantsStore, $[22] = state.canDisableAction, $[23] = t7, $[24] = t8) : (t7 = $[23], t8 = $[24]), useEffect(t7, t8);
  let t9;
  $[25] !== documentId || $[26] !== state.disabledDocumentIds ? (t9 = state.disabledDocumentIds?.some((id2) => id2.includes(getPublishedId(documentId))), $[25] = documentId, $[26] = state.disabledDocumentIds, $[27] = t9) : t9 = $[27];
  const existsInRelease = t9, disabledAction = !hasCreatePermission && state.canDisableAction || existsInRelease;
  let t10, t11;
  $[28] !== documentId || $[29] !== documentType ? (t11 = {
    _id: documentId,
    _type: documentType
  }, $[28] = documentId, $[29] = documentType, $[30] = t11) : t11 = $[30], t10 = t11;
  const documentStub = t10;
  let t12;
  $[31] !== documentStub || $[32] !== type ? (t12 = {
    enabled: !0,
    schemaType: type,
    value: documentStub
  }, $[31] = documentStub, $[32] = type, $[33] = t12) : t12 = $[33];
  const preview = useDocumentPreview(t12);
  let t13;
  $[34] !== disableIntentLink || $[35] !== documentId || $[36] !== documentType || $[37] !== onClick2 || $[38] !== onIntentClick || $[39] !== onItemSelect || $[40] !== preview ? (t13 = (e) => {
    onItemSelect?.({
      _id: documentId,
      _type: documentType,
      title: preview.value?.title
    }), disableIntentLink || onIntentClick(e), onClick2?.(e);
  }, $[34] = disableIntentLink, $[35] = documentId, $[36] = documentType, $[37] = onClick2, $[38] = onIntentClick, $[39] = onItemSelect, $[40] = preview, $[41] = t13) : t13 = $[41];
  const handleClick = t13;
  if (!type)
    return null;
  const t14 = disabledAction ? void 0 : "a", t15 = disabledAction || disableIntentLink ? void 0 : href, t16 = disabledAction ? "none" : void 0, t17 = disabledAction ? 0.5 : 1;
  let t18;
  $[42] !== t16 || $[43] !== t17 ? (t18 = {
    pointerEvents: t16,
    opacity: t17
  }, $[42] = t16, $[43] = t17, $[44] = t18) : t18 = $[44];
  let t19;
  $[45] !== documentId || $[46] !== documentPresence || $[47] !== documentType || $[48] !== layout || $[49] !== previewPerspective || $[50] !== type ? (t19 = /* @__PURE__ */ jsx(SearchResultItemPreview, { documentId, documentType, layout, perspective: previewPerspective, presence: documentPresence, schemaType: type }), $[45] = documentId, $[46] = documentPresence, $[47] = documentType, $[48] = layout, $[49] = previewPerspective, $[50] = type, $[51] = t19) : t19 = $[51];
  let t20;
  $[52] !== handleClick || $[53] !== t14 || $[54] !== t15 || $[55] !== t18 || $[56] !== t19 ? (t20 = /* @__PURE__ */ jsx(PreviewCard, { as: t14, "data-as": "a", flex: 1, href: t15, onClick: handleClick, radius: 2, tabIndex: -1, style: t18, children: t19 }), $[52] = handleClick, $[53] = t14, $[54] = t15, $[55] = t18, $[56] = t19, $[57] = t20) : t20 = $[57];
  let t21;
  $[58] !== rest || $[59] !== t20 ? (t21 = /* @__PURE__ */ jsx(Box, { ...rest, children: t20 }), $[58] = rest, $[59] = t20, $[60] = t21) : t21 = $[60];
  const content = t21;
  let t22;
  $[61] !== existsInRelease || $[62] !== t ? (t22 = t(existsInRelease ? "search.disabledItem" : "release.action.permission.error"), $[61] = existsInRelease, $[62] = t, $[63] = t22) : t22 = $[63];
  const tooltipContent = t22;
  let t23;
  return $[64] !== content || $[65] !== disabledAction || $[66] !== tooltipContent ? (t23 = disabledAction ? /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, placement: "top", children: content }) : content, $[64] = content, $[65] = disabledAction, $[66] = tooltipContent, $[67] = t23) : t23 = $[67], t23;
}
const VIRTUAL_LIST_SEARCH_RESULT_ITEM_HEIGHT = 57, VIRTUAL_LIST_OVERSCAN = 4, SearchResultsInnerFlex = styled(Flex)`
  opacity: ${({
  $loadingFirstPage
}) => $loadingFirstPage ? 0.5 : 1};
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  transition: 300ms opacity;
  width: 100%;
`;
function SearchResults(t0) {
  const $ = c(36), {
    disableIntentLink,
    inputElement,
    onItemSelect,
    previewPerspective
  } = t0, {
    dispatch,
    onClose,
    setSearchCommandList,
    state: t1
  } = useSearchState(), {
    debug: debug2,
    filters,
    fullscreen,
    lastActiveIndex,
    result,
    terms,
    cursor
  } = t1, {
    t
  } = useTranslation(), recentSearchesStore = useRecentSearchesStore(), hasSearchResults = !!result.hits.length, hasNoSearchResults = !result.hits.length && result.loaded, hasError = result.error;
  let t2;
  $[0] !== filters || $[1] !== onClose || $[2] !== recentSearchesStore || $[3] !== terms ? (t2 = (e) => {
    recentSearchesStore && recentSearchesStore.addSearch(terms, filters), !e.metaKey && !e.ctrlKey && onClose?.();
  }, $[0] = filters, $[1] = onClose, $[2] = recentSearchesStore, $[3] = terms, $[4] = t2) : t2 = $[4];
  const handleSearchResultClick = t2;
  let t3;
  $[5] !== dispatch ? (t3 = () => {
    dispatch({
      type: "PAGE_INCREMENT"
    });
  }, $[5] = dispatch, $[6] = t3) : t3 = $[6];
  const handleEndReached = t3;
  let t4;
  $[7] !== debug2 || $[8] !== disableIntentLink || $[9] !== handleSearchResultClick || $[10] !== onItemSelect || $[11] !== previewPerspective ? (t4 = (item) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SearchResultItem, { disableIntentLink, documentId: item.hit._id || "", documentType: item.hit._type, onClick: handleSearchResultClick, onItemSelect, previewPerspective, paddingY: 1 }),
    debug2 && /* @__PURE__ */ jsx(DebugOverlay, { data: item })
  ] }), $[7] = debug2, $[8] = disableIntentLink, $[9] = handleSearchResultClick, $[10] = onItemSelect, $[11] = previewPerspective, $[12] = t4) : t4 = $[12];
  const renderItem2 = t4, t5 = fullscreen || !!(hasError || hasSearchResults || hasNoSearchResults);
  let t6;
  $[13] !== hasSearchResults ? (t6 = hasSearchResults && /* @__PURE__ */ jsx(SortMenu, {}), $[13] = hasSearchResults, $[14] = t6) : t6 = $[14];
  const t7 = result.loading && cursor === null;
  let t8;
  $[15] !== handleEndReached || $[16] !== hasError || $[17] !== hasNoSearchResults || $[18] !== hasSearchResults || $[19] !== inputElement || $[20] !== lastActiveIndex || $[21] !== renderItem2 || $[22] !== result.hits || $[23] !== setSearchCommandList || $[24] !== t ? (t8 = hasError ? /* @__PURE__ */ jsx(SearchError, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
    hasSearchResults && /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("search.search-results-label"), "data-testid": "search-results", fixedHeight: !0, initialIndex: lastActiveIndex, inputElement, itemHeight: VIRTUAL_LIST_SEARCH_RESULT_ITEM_HEIGHT, items: result.hits, overscan: VIRTUAL_LIST_OVERSCAN, onEndReached: handleEndReached, paddingX: 2, paddingY: 1, ref: setSearchCommandList, renderItem: renderItem2 }),
    hasNoSearchResults && /* @__PURE__ */ jsx(NoResults, {})
  ] }), $[15] = handleEndReached, $[16] = hasError, $[17] = hasNoSearchResults, $[18] = hasSearchResults, $[19] = inputElement, $[20] = lastActiveIndex, $[21] = renderItem2, $[22] = result.hits, $[23] = setSearchCommandList, $[24] = t, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== result.loading || $[27] !== t7 || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsx(SearchResultsInnerFlex, { $loadingFirstPage: t7, "aria-busy": result.loading, flex: 1, children: t8 }), $[26] = result.loading, $[27] = t7, $[28] = t8, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== t6 || $[31] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { direction: "column", height: "fill", children: [
    t6,
    t9
  ] }), $[30] = t6, $[31] = t9, $[32] = t10) : t10 = $[32];
  let t11;
  return $[33] !== t10 || $[34] !== t5 ? (t11 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Card, { borderTop: t5, flex: 1, children: t10 }) }), $[33] = t10, $[34] = t5, $[35] = t11) : t11 = $[35], t11;
}
const ANIMATION_TRANSITION$2 = {
  duration: 0.4,
  type: "spring"
}, CARD_VARIANTS = {
  open: {
    opacity: 1,
    scale: 1,
    x: "-50%"
  },
  closed: {
    opacity: 0,
    scale: 0.99,
    x: "-50%"
  }
}, OVERLAY_VARIANTS = {
  open: {
    opacity: 1
  },
  closed: {
    opacity: 0
  }
}, Y_POSITION = 12, MotionOverlay = styled(motion.create(Card))`
  background-color: var(--card-backdrop-color);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`, SearchMotionCard = styled(motion.create(Card))`
  display: flex !important;
  flex-direction: column;
  left: 50%;
  max-height: min(
    calc(100vh - ${Y_POSITION}vh - ${POPOVER_INPUT_PADDING}px),
    ${POPOVER_MAX_HEIGHT}px
  );
  position: absolute;
  top: ${Y_POSITION}vh;
  width: min(calc(100vw - ${POPOVER_INPUT_PADDING * 2}px), ${POPOVER_MAX_WIDTH}px);
`;
function SearchPopover(t0) {
  const $ = c(22), {
    disableFocusLock,
    disableIntentLink,
    onClose,
    onItemSelect,
    onOpen,
    previewPerspective,
    open
  } = t0, [inputElement, setInputElement] = useState(null), popoverElement = useRef(null), {
    isTopLayer,
    zIndex
  } = useLayer(), {
    onClose: onSearchClose,
    state: t1
  } = useSearchState(), {
    filtersVisible,
    terms
  } = t1;
  let t2;
  $[0] !== terms ? (t2 = hasSearchableTerms({
    terms
  }), $[0] = terms, $[1] = t2) : t2 = $[1];
  const hasValidTerms = t2;
  let t3;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => [popoverElement.current], $[2] = t3) : t3 = $[2], useClickOutsideEvent(isTopLayer && open && !!onSearchClose && onSearchClose, t3);
  let t4;
  $[3] !== disableFocusLock || $[4] !== disableIntentLink || $[5] !== filtersVisible || $[6] !== hasValidTerms || $[7] !== inputElement || $[8] !== onClose || $[9] !== onItemSelect || $[10] !== open || $[11] !== previewPerspective || $[12] !== zIndex ? (t4 = open && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsxs(FocusLock, { autoFocus: !supportsTouch, disabled: disableFocusLock, returnFocus: !0, children: [
    /* @__PURE__ */ jsx(MotionOverlay, { animate: "open", exit: "closed", initial: "closed", style: {
      zIndex
    }, transition: ANIMATION_TRANSITION$2, variants: OVERLAY_VARIANTS }),
    /* @__PURE__ */ jsxs(SearchMotionCard, { animate: "open", exit: "closed", initial: "closed", overflow: "hidden", radius: POPOVER_RADIUS$1, ref: popoverElement, shadow: 2, style: {
      zIndex
    }, transition: ANIMATION_TRANSITION$2, variants: CARD_VARIANTS, children: [
      /* @__PURE__ */ jsx(SearchHeader, { onClose, ref: setInputElement }),
      filtersVisible && /* @__PURE__ */ jsx(Card, { borderTop: !0, flex: "none", children: /* @__PURE__ */ jsx(Filters, {}) }),
      hasValidTerms ? /* @__PURE__ */ jsx(SearchResults, { inputElement, onItemSelect, disableIntentLink, previewPerspective }) : /* @__PURE__ */ jsx(RecentSearches, { inputElement })
    ] })
  ] }) }), $[3] = disableFocusLock, $[4] = disableIntentLink, $[5] = filtersVisible, $[6] = hasValidTerms, $[7] = inputElement, $[8] = onClose, $[9] = onItemSelect, $[10] = open, $[11] = previewPerspective, $[12] = zIndex, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(AnimatePresence, { children: t4 }), $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  return $[16] !== hasValidTerms || $[17] !== onClose || $[18] !== onOpen || $[19] !== open || $[20] !== t5 ? (t6 = /* @__PURE__ */ jsx(SearchWrapper, { hasValidTerms, onClose, onOpen, open, children: t5 }), $[16] = hasValidTerms, $[17] = onClose, $[18] = onOpen, $[19] = open, $[20] = t5, $[21] = t6) : t6 = $[21], t6;
}
const DEFAULT_API_FIELD_DEPTH = 0, INITIAL_LOADING_STATE$3 = {
  isLoading: !0,
  settings: {
    partialIndexSettings: {
      maxFieldDepth: DEFAULT_API_FIELD_DEPTH
    }
  }
};
function fetchMaxDepth({
  client
}) {
  const {
    projectId,
    dataset
  } = client.config();
  return client.observable.request({
    uri: `/projects/${projectId}/datasets/${dataset}/settings/indexing`,
    tag: "search.getPartialIndexSettings"
  });
}
const cachedSettings = /* @__PURE__ */ new Map();
function useSearchMaxFieldDepth(overrideClient) {
  const isEnabled = useWorkspace().search?.unstable_partialIndexing?.enabled, workspaceClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), client = useMemo(() => overrideClient || workspaceClient, [overrideClient, workspaceClient]), dataset = useMemo(() => client.config().dataset, [client]);
  isEnabled || cachedSettings.set(dataset, of(INITIAL_LOADING_STATE$3.settings)), cachedSettings.has(dataset) || cachedSettings.set(dataset, fetchMaxDepth({
    client
  }).pipe(shareReplay()));
  const indexSettingsObservable = useMemo(() => cachedSettings.get(dataset).pipe(map((settings) => ({
    isLoading: !1,
    settings
  })), startWith(INITIAL_LOADING_STATE$3), catchError((err) => (console.error(err), of({
    isLoading: !1,
    enabled: !0,
    settings: {
      partialIndexSettings: {
        maxFieldDepth: DEFAULT_API_FIELD_DEPTH
      }
    }
  })))), [dataset]), maxFieldDepth = useObservable(indexSettingsObservable, INITIAL_LOADING_STATE$3)?.settings?.partialIndexSettings?.maxFieldDepth;
  return isFinite(maxFieldDepth) ? Math.min(maxFieldDepth, DEFAULT_MAX_FIELD_DEPTH) : DEFAULT_MAX_FIELD_DEPTH;
}
const DEFAULT_DEBOUNCE_TIME = 300, INITIAL_SEARCH_STATE$3 = {
  error: null,
  hits: [],
  loading: !1,
  terms: {
    query: "",
    types: []
  }
};
function nonNullable$1(v) {
  return v !== null;
}
function sanitizeRequest(request) {
  return {
    ...request,
    terms: {
      ...request.terms,
      filter: request.terms.filter?.trim(),
      query: request.terms.query.trim()
    }
  };
}
function useSearch(t0) {
  const $ = c(16), {
    allowEmptyQueries,
    initialState: initialState2,
    onComplete,
    onError,
    onStart,
    schema: schema2
  } = t0, [searchState, setSearchState] = useState(initialState2), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), maxFieldDepth = useSearchMaxFieldDepth(), {
    strategy
  } = useWorkspace().search;
  let t1, t2;
  $[0] !== client || $[1] !== maxFieldDepth || $[2] !== schema2 || $[3] !== strategy ? (t2 = createSearch(getSearchableOmnisearchTypes(schema2), client, {
    tag: "search.global",
    unique: !0,
    strategy,
    maxDepth: maxFieldDepth
  }), $[0] = client, $[1] = maxFieldDepth, $[2] = schema2, $[3] = strategy, $[4] = t2) : t2 = $[4], t1 = t2;
  const search2 = t1;
  let t3;
  $[5] !== allowEmptyQueries || $[6] !== onComplete || $[7] !== onError || $[8] !== onStart || $[9] !== search2 ? (t3 = (inputValue$) => inputValue$.pipe(filter(nonNullable$1), map(sanitizeRequest), distinctUntilChanged(isEqual$2), debounce$1(_temp$2d), tap(onStart), switchMap((request_0) => concat(of({
    ...INITIAL_SEARCH_STATE$3,
    loading: !0,
    options: request_0.options,
    terms: request_0.terms
  }), iif(() => hasSearchableTerms({
    allowEmptyQueries,
    terms: request_0.terms
  }), search2(request_0.terms, request_0.options).pipe(tap((t42) => {
    const {
      hits,
      nextCursor
    } = t42;
    return onComplete?.({
      hits,
      nextCursor
    });
  }), catchError((error) => (onError?.(error), of({
    ...INITIAL_SEARCH_STATE$3,
    error,
    loading: !1,
    options: request_0.options,
    terms: request_0.terms
  })))), of(EMPTY$6).pipe(tap(() => onComplete?.({
    hits: [],
    nextCursor: void 0
  })))), of({
    loading: !1
  }))), scan(_temp2$P, INITIAL_SEARCH_STATE$3), tap(setSearchState)), $[5] = allowEmptyQueries, $[6] = onComplete, $[7] = onError, $[8] = onStart, $[9] = search2, $[10] = t3) : t3 = $[10];
  const handleQueryChange = useObservableEvent(t3);
  let t4;
  $[11] !== handleQueryChange ? (t4 = (searchRequest) => handleQueryChange(searchRequest), $[11] = handleQueryChange, $[12] = t4) : t4 = $[12];
  const handleSearch = t4;
  let t5;
  return $[13] !== handleSearch || $[14] !== searchState ? (t5 = {
    handleSearch,
    searchState
  }, $[13] = handleSearch, $[14] = searchState, $[15] = t5) : t5 = $[15], t5;
}
function _temp2$P(prevState, nextState) {
  return {
    ...prevState,
    ...nextState
  };
}
function _temp$2d(request) {
  return timer(request?.debounceTime || DEFAULT_DEBOUNCE_TIME);
}
function isRecentSearchTerms(terms) {
  return typeof terms.__recent < "u";
}
const rootName = "core:studio:navbar:search:";
debug$7(rootName);
function debugWithName(name) {
  const namespace = `${rootName}${name}`;
  return debug$7 && debug$7.enabled(namespace) ? debug$7(namespace) : debug$7(rootName);
}
function isDebugMode() {
  return typeof window > "u" ? !1 : window.location.hash.slice(1).split(";").includes(DEBUG_FRAGMENT);
}
function initialSearchState({
  currentUser,
  fullscreen,
  definitions,
  pagination,
  strategy
}) {
  return {
    currentUser,
    debug: isDebugMode(),
    documentTypesNarrowed: [],
    filters: [],
    filtersVisible: !0,
    fullscreen,
    lastActiveIndex: -1,
    ordering: getOrderings({
      searchStrategy: strategy
    }).relevance,
    ...pagination,
    result: {
      error: null,
      hasLocal: !1,
      hits: [],
      loaded: !1,
      loading: !1
    },
    terms: {
      query: "",
      types: []
    },
    definitions,
    strategy
  };
}
const debug$4 = debugWithName("reducer");
function searchReducer(state, action) {
  let prefix = "\u{1F50D}";
  switch (action.type.startsWith("SEARCH_REQUEST") && (prefix = "\u{1F6A8}"), action.type.startsWith("RECENT_SEARCHES") && (prefix = "\u{1F4BE}"), debug$4(prefix, action), action.type) {
    case "FILTERS_VISIBLE_SET":
      return {
        ...state,
        filtersVisible: action.visible
      };
    case "LAST_ACTIVE_INDEX_SET":
      return {
        ...state,
        lastActiveIndex: action.index
      };
    case "ORDERING_RESET":
      return {
        ...state,
        ordering: getOrderings({
          searchStrategy: state.strategy
        }).relevance,
        terms: stripRecent(state.terms),
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    case "ORDERING_SET":
      return {
        ...state,
        ordering: action.ordering,
        terms: stripRecent(state.terms),
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    case "PAGE_INCREMENT":
      return {
        ...state,
        cursor: state.nextCursor ?? state.cursor,
        nextCursor: null,
        terms: stripRecent(state.terms)
      };
    case "SEARCH_CLEAR":
      return {
        ...state,
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          hasLocal: !1,
          hits: []
        }
      };
    case "SEARCH_REQUEST_COMPLETE":
      return {
        ...state,
        nextCursor: action.nextCursor ?? null,
        result: {
          ...state.result,
          error: null,
          hasLocal: !0,
          hits: state.result.hasLocal ? removeDupes$3([...state.result.hits, ...action.hits].map(({
            hit
          }) => hit)).map((hit) => ({
            hit
          })) : action.hits,
          loaded: !0,
          loading: !1
        }
      };
    case "SEARCH_REQUEST_ERROR":
      return {
        ...state,
        result: {
          ...state.result,
          error: action.error,
          loaded: !1,
          loading: !1
        }
      };
    case "SEARCH_REQUEST_START":
      return {
        ...state,
        result: {
          ...state.result,
          loaded: !1,
          loading: !0
        }
      };
    case "TERMS_FILTERS_ADD": {
      const newFilter = {
        ...action.filter,
        value: getOperatorInitialValue(state.definitions.operators, action.filter.operatorType)
      }, filters = [...state.filters, newFilter];
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters,
          types: state.terms.types
        }),
        filters,
        lastAddedFilter: newFilter,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_FILTERS_CLEAR": {
      const filters = [];
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters,
          types: state.terms.types
        }),
        filters,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_FILTERS_REMOVE": {
      const index = state.filters.findIndex((filter2) => getFilterKey(filter2) === action.filterKey), filters = [
        ...state.filters.slice(0, index),
        //
        ...state.filters.slice(index + 1)
      ];
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters,
          types: state.terms.types
        }),
        filters,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_FILTERS_SET_OPERATOR": {
      const matchedFilter = state.filters.find((filter2) => getFilterKey(filter2) === action.filterKey), currentOperator = getOperatorDefinition(state.definitions.operators, matchedFilter?.operatorType), nextOperator = getOperatorDefinition(state.definitions.operators, action.operatorType), nextInitialValue = nextOperator?.initialValue, inputComponentChanged = currentOperator?.inputComponent != nextOperator?.inputComponent, filters = state.filters.map((filter2) => getFilterKey(filter2) === action.filterKey ? {
        ...filter2,
        operatorType: action.operatorType,
        ...inputComponentChanged ? {
          value: nextInitialValue
        } : {}
      } : filter2);
      return {
        ...state,
        filters,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_FILTERS_SET_VALUE": {
      const filters = state.filters.map((filter2) => getFilterKey(filter2) === action.filterKey ? {
        ...filter2,
        value: action.value
      } : filter2);
      return {
        ...state,
        filters,
        cursor: null,
        nextCursor: null,
        terms: {
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        },
        result: {
          ...state.result,
          hasLocal: !1
        }
      };
    }
    case "TERMS_QUERY_SET":
      return {
        ...state,
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: stripRecent({
          ...state.terms,
          query: action.query
        })
      };
    case "TERMS_SET": {
      const filters = action.filters || [], types = [
        ...state.terms.types || [],
        //
        ...action.terms.types
      ].sort(sortTypes);
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters,
          types
        }),
        filters,
        lastAddedFilter: null,
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: {
          ...action.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            filters,
            operatorDefinitions: state.definitions.operators
          })
        }
      };
    }
    case "TERMS_TYPE_ADD": {
      const types = [
        ...state.terms.types || [],
        //
        action.schemaType
      ].sort(sortTypes), documentTypesNarrowed = narrowDocumentTypes({
        fieldDefinitions: state.definitions.fields,
        filters: [],
        types
      }), filters = state.filters.filter((f) => {
        const fieldDefinition = getFieldFromFilter(state.definitions.fields, f);
        return fieldDefinition ? fieldDefinition.documentTypes.length === 0 ? !0 : documentTypesNarrowed.every((type) => fieldDefinition.documentTypes.findIndex((t) => t === type) > -1) : !0;
      });
      return {
        ...state,
        documentTypesNarrowed,
        filters,
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: stripRecent({
          ...state.terms,
          filter: generateFilterQuery({
            fieldDefinitions: state.definitions.fields,
            filterDefinitions: state.definitions.filters,
            operatorDefinitions: state.definitions.operators,
            filters
          }),
          types
        })
      };
    }
    case "TERMS_TYPE_REMOVE": {
      const types = (state.terms.types || []).filter((s) => s !== action.schemaType);
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters: state.filters,
          types
        }),
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: stripRecent({
          ...state.terms,
          types
        })
      };
    }
    case "TERMS_TYPES_CLEAR": {
      const types = [];
      return {
        ...state,
        documentTypesNarrowed: narrowDocumentTypes({
          fieldDefinitions: state.definitions.fields,
          filters: state.filters,
          types
        }),
        cursor: null,
        nextCursor: null,
        result: {
          ...state.result,
          loaded: !1,
          hasLocal: !1
        },
        terms: stripRecent({
          ...state.terms,
          types: []
        })
      };
    }
    default:
      return state;
  }
}
function stripRecent(terms) {
  if (isRecentSearchTerms(terms)) {
    const {
      __recent,
      ...rest
    } = terms;
    return rest;
  }
  return terms;
}
function SearchProvider({
  children,
  fullscreen,
  disabledDocumentIds,
  canDisableAction
}) {
  const [onClose, setOnClose] = useState(null), [searchCommandList, setSearchCommandList] = useState(null), {
    data: releases2
  } = useActiveReleases(), schema2 = useSchema(), currentUser = useCurrentUser(), {
    search: {
      operators,
      filters,
      strategy
    }
  } = useSource(), {
    fieldDefinitions,
    filterDefinitions: filterDefinitions2,
    operatorDefinitions: operatorDefinitions2
  } = useMemo(() => ({
    fieldDefinitions: createFieldDefinitionDictionary(createFieldDefinitions(schema2, filters)),
    filterDefinitions: createFilterDefinitionDictionary(filters),
    operatorDefinitions: createOperatorDefinitionDictionary(operators)
  }), [filters, operators, schema2]), initialState2 = useMemo(() => initialSearchState({
    currentUser,
    fullscreen,
    definitions: {
      fields: fieldDefinitions,
      operators: operatorDefinitions2,
      filters: filterDefinitions2
    },
    pagination: {
      cursor: null,
      nextCursor: null
    },
    strategy
  }), [currentUser, fullscreen, fieldDefinitions, operatorDefinitions2, filterDefinitions2, strategy]), [state, dispatch] = useReducer(searchReducer, initialState2), {
    documentTypesNarrowed,
    filters: currentFilters,
    ordering,
    cursor,
    result,
    terms
  } = state, isMountedRef = useRef(!1), previousOrderingRef = useRef(initialState2.ordering), previousCursorRef = useRef(initialState2.cursor), previousTermsRef = useRef(initialState2.terms), {
    handleSearch,
    searchState
  } = useSearch({
    initialState: {
      ...result,
      terms
    },
    onComplete: (searchResult) => dispatch({
      ...searchResult,
      type: "SEARCH_REQUEST_COMPLETE"
    }),
    onError: (error) => dispatch({
      error,
      type: "SEARCH_REQUEST_ERROR"
    }),
    onStart: () => dispatch({
      type: "SEARCH_REQUEST_START"
    }),
    schema: schema2
  }), hasValidTerms = hasSearchableTerms({
    terms
  }), documentTypes = documentTypesNarrowed.map((documentType) => schema2.get(documentType)), completeFilters = currentFilters.filter((filter2) => validateFilter({
    fieldDefinitions,
    filter: filter2,
    filterDefinitions: filterDefinitions2,
    operatorDefinitions: operatorDefinitions2
  }));
  useEffect(() => {
    const orderingChanged = !isEqual$2(ordering, previousOrderingRef.current), cursorChanged = cursor !== previousCursorRef.current, termsChanged = !isEqual$2(terms, previousTermsRef.current);
    if (orderingChanged || cursorChanged || termsChanged) {
      let sortLabel = "findability-sort:";
      (ordering?.customMeasurementLabel || ordering.sort) && (sortLabel += ordering?.customMeasurementLabel || `${ordering.sort?.field} ${ordering.sort?.direction}`), handleSearch({
        options: {
          // Comments prepended to each query for future measurement
          comments: [...isRecentSearchTerms(terms) ? [`findability-recent-search:${terms.__recent.index}`] : [], `findability-selected-types:${terms.types.length}`, sortLabel, "findability-source: global", `findability-filter-count:${completeFilters.length}`],
          // `groq2024` supports pagination. Therefore, fetch fewer results.
          limit: strategy === "groq2024" ? 25 : SEARCH_LIMIT,
          skipSortByScore: ordering.ignoreScore,
          ...ordering.sort ? {
            sort: [ordering.sort]
          } : {},
          cursor: cursor || void 0,
          perspective: "raw"
        },
        terms: {
          ...terms,
          // Narrow document type search
          ...documentTypes ? {
            types: documentTypes
          } : {}
        }
      }), cursorChanged && (previousCursorRef.current = cursor);
    }
    previousOrderingRef.current = ordering, previousTermsRef.current = terms;
  }, [completeFilters.length, currentFilters, documentTypes, handleSearch, hasValidTerms, ordering, searchState.terms, terms, cursor, strategy, releases2]), useEffect(() => {
    !hasValidTerms && isMountedRef?.current && result.hits.length > 0 && dispatch({
      type: "SEARCH_CLEAR"
    }), isMountedRef.current = !0;
  }, [dispatch, hasValidTerms, result.hits, terms.query, terms.types]);
  const value = useMemo(() => ({
    dispatch,
    onClose,
    searchCommandList,
    setSearchCommandList,
    setOnClose,
    state: {
      ...state,
      fullscreen,
      disabledDocumentIds,
      canDisableAction
    }
  }), [fullscreen, disabledDocumentIds, canDisableAction, onClose, searchCommandList, state]);
  return /* @__PURE__ */ jsx(SearchContext.Provider, { value, children });
}
function AddDocumentSearch(t0) {
  const $ = c(9), {
    open,
    onClose,
    releaseId,
    idsInRelease
  } = t0;
  let t1;
  $[0] !== releaseId ? (t1 = [releaseId], $[0] = releaseId, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== onClose || $[3] !== open || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(PortalProvider, { children: /* @__PURE__ */ jsx(SearchPopover, { onClose, onItemSelect: onClose, open, previewPerspective: t1, disableIntentLink: !0 }) }), $[2] = onClose, $[3] = open, $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== idsInRelease || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(LayerProvider, { zOffset: 1, children: /* @__PURE__ */ jsx(SearchProvider, { disabledDocumentIds: idsInRelease, canDisableAction: !0, children: t2 }) }), $[6] = idsInRelease, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}
function UnpublishVersionDialog(props2) {
  const {
    onClose,
    documentVersionId,
    documentType
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: coreT
  } = useTranslation(), schema2 = useSchema(), {
    unpublishVersion
  } = useVersionOperations(), [isUnpublishing, setIsUnpublishing] = useState(!1), toast = useToast(), {
    data
  } = useActiveReleases(), {
    data: archivedReleases
  } = useArchivedReleases(), release = data.concat(archivedReleases).find((candidate) => getReleaseIdFromReleaseDocumentId(candidate._id) === getVersionFromId(documentVersionId)), tone = getReleaseTone(release), schemaType = schema2.get(documentType), preview = useDocumentPreview({
    schemaType,
    value: {
      _id: documentVersionId
    }
  }), handleUnpublish = useCallback(async () => {
    setIsUnpublishing(!0);
    try {
      await unpublishVersion(documentVersionId), toast.push({
        closable: !0,
        status: "success",
        description: /* @__PURE__ */ jsx(Translate, { t: coreT, i18nKey: "release.action.unpublish-version.success", values: {
          title: preview?.value?.title || documentVersionId
        } })
      });
    } catch (err) {
      toast.push({
        closable: !0,
        status: "error",
        title: coreT("release.action.unpublish-version.failure"),
        description: err.message
      });
    }
    setIsUnpublishing(!1), onClose();
  }, [coreT, documentVersionId, onClose, preview?.value?.title, toast, unpublishVersion]);
  return /* @__PURE__ */ jsx(Dialog$1, { header: t("unpublish-dialog.header"), id: "document-unpublish-dialog", onClickOutside: onClose, onClose, width: 0, padding: !1, footer: {
    cancelButton: {
      text: t("unpublish-dialog.action.cancel"),
      onClick: onClose
    },
    confirmButton: {
      text: t("unpublish-dialog.action.unpublish"),
      onClick: handleUnpublish,
      tone: "critical",
      disabled: isUnpublishing,
      loading: isUnpublishing
    }
  }, children: /* @__PURE__ */ jsxs(Stack, { space: 4, paddingX: 4, paddingBottom: 4, children: [
    schemaType ? /* @__PURE__ */ jsx(Preview$1, { value: {
      _id: documentVersionId
    }, schemaType }) : /* @__PURE__ */ jsx(LoadingBlock, {}),
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "unpublish-dialog.description.to-draft", values: {
      title: release?.metadata.title || coreT("release.placeholder-untitled-release")
    }, components: {
      Label: ({
        children
      }) => /* @__PURE__ */ jsx("span", { style: {
        color: `var(--card-badge-${tone ?? "default"}-fg-color)`,
        backgroundColor: `var(--card-badge-${tone ?? "default"}-bg-color)`,
        borderRadius: 3,
        textDecoration: "none",
        padding: "0px 2px",
        fontWeight: 500
      }, children })
    } }) }),
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t("unpublish-dialog.description.lost-changes") })
  ] }) });
}
function isGoingToUnpublish(document2) {
  return document2._system?.delete === !0;
}
const DocumentActionsInner = memo(function(t0) {
  const $ = c(66), {
    document: document2,
    releaseTitle
  } = t0, [showDiscardDialog, setShowDiscardDialog] = useState(!1), [showUnpublishDialog, setShowUnpublishDialog] = useState(!1), {
    t: coreT
  } = useTranslation(), {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1;
  $[0] !== document2.document ? (t1 = isGoingToUnpublish(document2.document), $[0] = document2.document, $[1] = t1) : t1 = $[1];
  const isAlreadyUnpublished = t1;
  let t2;
  $[2] !== document2.document._id ? (t2 = getPublishedId(document2.document._id), $[2] = document2.document._id, $[3] = t2) : t2 = $[3];
  const publishedId = t2, type = document2.document._type;
  let t3;
  $[4] !== document2.document._id ? (t3 = getVersionFromId(document2.document._id), $[4] = document2.document._id, $[5] = t3) : t3 = $[5];
  const version = t3;
  let t4;
  $[6] !== publishedId || $[7] !== type || $[8] !== version ? (t4 = {
    id: publishedId,
    type,
    version,
    permission: "discardVersion"
  }, $[6] = publishedId, $[7] = type, $[8] = version, $[9] = t4) : t4 = $[9];
  const [discardVersionPermission, isDiscardVersionPermissionsLoading] = useDocumentPairPermissions(t4);
  let t5;
  $[10] !== publishedId || $[11] !== type || $[12] !== version ? (t5 = {
    id: publishedId,
    type,
    version,
    permission: "unpublish"
  }, $[10] = publishedId, $[11] = type, $[12] = version, $[13] = t5) : t5 = $[13];
  const [unpublishPermission, isUnpublishPermissionsLoading] = useDocumentPairPermissions(t5), isDiscardVersionActionDisabled = !discardVersionPermission?.granted || isDiscardVersionPermissionsLoading, noPermissionToUnpublish = !unpublishPermission?.granted || isUnpublishPermissionsLoading;
  let t6;
  bb0: {
    if (noPermissionToUnpublish) {
      let t72;
      $[14] !== t ? (t72 = t("permissions.error.unpublish"), $[14] = t, $[15] = t72) : t72 = $[15], t6 = t72;
      break bb0;
    }
    if (!document2.document.publishedDocumentExists) {
      let t72;
      $[16] !== t ? (t72 = t("unpublish.no-published-version"), $[16] = t, $[17] = t72) : t72 = $[17], t6 = t72;
      break bb0;
    }
    if (isAlreadyUnpublished) {
      let t72;
      $[18] !== t ? (t72 = t("unpublish.already-unpublished"), $[18] = t, $[19] = t72) : t72 = $[19], t6 = t72;
      break bb0;
    }
    t6 = null;
  }
  const unPublishTooltipContent = t6, isUnpublishActionDisabled = noPermissionToUnpublish || !document2.document.publishedDocumentExists || isAlreadyUnpublished;
  let t7;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== coreT ? (t8 = coreT("release.action.discard-version"), $[21] = coreT, $[22] = t8) : t8 = $[22];
  let t9;
  $[23] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => setShowDiscardDialog(!0), $[23] = t9) : t9 = $[23];
  const t10 = !isDiscardVersionActionDisabled;
  let t11;
  $[24] !== t ? (t11 = t("permissions.error.discard-version"), $[24] = t, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== t10 || $[27] !== t11 ? (t12 = {
    disabled: t10,
    content: t11
  }, $[26] = t10, $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== isDiscardVersionActionDisabled || $[30] !== t12 || $[31] !== t8 ? (t13 = /* @__PURE__ */ jsx(MenuItem$1, { text: t8, icon: CloseIcon, onClick: t9, disabled: isDiscardVersionActionDisabled, tooltipProps: t12 }), $[29] = isDiscardVersionActionDisabled, $[30] = t12, $[31] = t8, $[32] = t13) : t13 = $[32];
  let t14;
  $[33] === Symbol.for("react.memo_cache_sentinel") ? (t14 = /* @__PURE__ */ jsx(MenuDivider, {}), $[33] = t14) : t14 = $[33];
  let t15;
  $[34] !== t ? (t15 = t("menu.group.when-releasing"), $[34] = t, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] !== t15 ? (t16 = /* @__PURE__ */ jsx(Box, { padding: 3, paddingBottom: 2, children: /* @__PURE__ */ jsx(Label, { size: 1, children: t15 }) }), $[36] = t15, $[37] = t16) : t16 = $[37];
  let t17;
  $[38] !== t ? (t17 = t("action.unpublish"), $[38] = t, $[39] = t17) : t17 = $[39];
  const t18 = !isUnpublishActionDisabled;
  let t19;
  $[40] !== t18 || $[41] !== unPublishTooltipContent ? (t19 = {
    disabled: t18,
    content: unPublishTooltipContent
  }, $[40] = t18, $[41] = unPublishTooltipContent, $[42] = t19) : t19 = $[42];
  let t20;
  $[43] === Symbol.for("react.memo_cache_sentinel") ? (t20 = () => setShowUnpublishDialog(!0), $[43] = t20) : t20 = $[43];
  let t21;
  $[44] !== isUnpublishActionDisabled || $[45] !== t17 || $[46] !== t19 ? (t21 = /* @__PURE__ */ jsx(MenuItem$1, { text: t17, icon: UnpublishIcon, disabled: isUnpublishActionDisabled, tooltipProps: t19, onClick: t20 }), $[44] = isUnpublishActionDisabled, $[45] = t17, $[46] = t19, $[47] = t21) : t21 = $[47];
  let t22;
  $[48] !== t13 || $[49] !== t16 || $[50] !== t21 ? (t22 = /* @__PURE__ */ jsx(Card, { tone: "default", display: "flex", children: /* @__PURE__ */ jsx(MenuButton$1, { id: "document-actions", button: t7, menu: /* @__PURE__ */ jsxs(Menu, { children: [
    t13,
    t14,
    t16,
    t21
  ] }) }) }), $[48] = t13, $[49] = t16, $[50] = t21, $[51] = t22) : t22 = $[51];
  let t23;
  $[52] !== document2.document._id || $[53] !== document2.document._type || $[54] !== releaseTitle || $[55] !== showDiscardDialog || $[56] !== t ? (t23 = showDiscardDialog && /* @__PURE__ */ jsx(DiscardVersionDialog, { onClose: () => setShowDiscardDialog(!1), documentId: document2.document._id, documentType: document2.document._type, fromPerspective: releaseTitle || t("release-placeholder.title") }), $[52] = document2.document._id, $[53] = document2.document._type, $[54] = releaseTitle, $[55] = showDiscardDialog, $[56] = t, $[57] = t23) : t23 = $[57];
  let t24;
  $[58] !== document2.document._id || $[59] !== document2.document._type || $[60] !== showUnpublishDialog ? (t24 = showUnpublishDialog && /* @__PURE__ */ jsx(UnpublishVersionDialog, { onClose: () => setShowUnpublishDialog(!1), documentVersionId: document2.document._id, documentType: document2.document._type }), $[58] = document2.document._id, $[59] = document2.document._type, $[60] = showUnpublishDialog, $[61] = t24) : t24 = $[61];
  let t25;
  return $[62] !== t22 || $[63] !== t23 || $[64] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t22,
    t23,
    t24
  ] }), $[62] = t22, $[63] = t23, $[64] = t24, $[65] = t25) : t25 = $[65], t25;
}, (prev, next) => prev.document.memoKey === next.document.memoKey), DocumentActions = memo(function(props2) {
  const $ = c(7), type = useSchema().get(props2.document.document._type), {
    t
  } = useTranslation();
  if (!type) {
    let t02;
    $[0] !== props2.document.document._type || $[1] !== t ? (t02 = t("document.type.not-found", {
      type: props2.document.document._type
    }), $[0] = props2.document.document._type, $[1] = t, $[2] = t02) : t02 = $[2];
    let t1;
    return $[3] !== t02 ? (t1 = /* @__PURE__ */ jsx(ContextMenuButton, { disabled: !0, tooltipProps: {
      content: t02
    } }), $[3] = t02, $[4] = t1) : t1 = $[4], t1;
  }
  let t0;
  return $[5] !== props2 ? (t0 = /* @__PURE__ */ jsx(DocumentActionsInner, { ...props2 }), $[5] = props2, $[6] = t0) : t0 = $[6], t0;
}), MemoReleaseDocumentPreview = memo(function(t0) {
  const $ = c(8), {
    item,
    releaseId,
    releaseState,
    documentRevision
  } = t0;
  let t1;
  return $[0] !== documentRevision || $[1] !== item.document._id || $[2] !== item.document._type || $[3] !== item.previewValues.isLoading || $[4] !== item.previewValues.values || $[5] !== releaseId || $[6] !== releaseState ? (t1 = /* @__PURE__ */ jsx(ReleaseDocumentPreview, { documentId: item.document._id, documentTypeName: item.document._type, releaseId, releaseState, documentRevision, previewValues: item.previewValues.values, isLoading: item.previewValues.isLoading }), $[0] = documentRevision, $[1] = item.document._id, $[2] = item.document._type, $[3] = item.previewValues.isLoading, $[4] = item.previewValues.values, $[5] = releaseId, $[6] = releaseState, $[7] = t1) : t1 = $[7], t1;
}, (prev, next) => prev.item.memoKey === next.item.memoKey && prev.releaseId === next.releaseId), MemoDocumentType = memo(function(t0) {
  const $ = c(5), {
    type
  } = t0, schema2 = useSchema();
  let t1;
  $[0] !== schema2 || $[1] !== type ? (t1 = schema2.get(type), $[0] = schema2, $[1] = type, $[2] = t1) : t1 = $[2];
  const t2 = t1?.title || "Not found";
  let t3;
  return $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4], t3;
}, (prev, next) => prev.type === next.type), documentActionColumn = (t) => ({
  id: "action",
  width: 100,
  header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.BasicHeader, { text: t("table-header.action") }) }),
  cell: ({
    cellProps,
    datum
  }) => /* @__PURE__ */ jsx(Flex, { align: "center", ...cellProps, children: /* @__PURE__ */ jsx(Box, { paddingX: 2, children: datum.isPending || datum.isLoading ? null : isGoingToUnpublish(datum.document) ? /* @__PURE__ */ jsx(Badge, { radius: 2, tone: "critical", "data-testid": `unpublish-badge-${datum.document._id}`, children: t("table-body.action.unpublish") }) : datum.document.publishedDocumentExists ? /* @__PURE__ */ jsx(Badge, { radius: 2, tone: "caution", "data-testid": `change-badge-${datum.document._id}`, children: t("table-body.action.change") }) : /* @__PURE__ */ jsx(Badge, { radius: 2, tone: "positive", "data-testid": `add-badge-${datum.document._id}`, children: t("table-body.action.add") }) }) })
}), getDocumentTableColumnDefs = (releaseId, releaseState, t) => [
  /**
   * Hiding action for archived and published releases of v1.0
   * This will be added once Events API has reverse order lookup supported
   */
  ...releaseState === "archived" || releaseState === "published" ? [] : [documentActionColumn(t)],
  {
    id: "document._type",
    width: 100,
    sorting: !0,
    header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.type"), ...props2 }) }),
    cell: ({
      cellProps,
      datum
    }) => /* @__PURE__ */ jsx(Flex, { align: "center", ...cellProps, children: /* @__PURE__ */ jsx(Box, { paddingX: 2, children: !datum.isLoading && /* @__PURE__ */ jsx(MemoDocumentType, { type: datum.document._type }) }) })
  },
  {
    id: "search",
    width: null,
    style: {
      minWidth: "50%",
      maxWidth: "50%"
    },
    sortTransform(value) {
      return value.previewValues && value.previewValues.values?.title?.toLowerCase() || 0;
    },
    header: (props2) => /* @__PURE__ */ jsx(Headers.TableHeaderSearch, { ...props2, placeholder: t("search-documents-placeholder") }),
    cell: ({
      cellProps,
      datum
    }) => /* @__PURE__ */ jsx(Box, { ...cellProps, flex: 1, padding: 1, paddingRight: 2, sizing: "border", children: datum.isPending || datum.isLoading ? /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0 }) : /* @__PURE__ */ jsx(MemoReleaseDocumentPreview, { item: datum, releaseId, releaseState, documentRevision: datum.document._rev }) })
  },
  {
    id: "document._updatedAt",
    sorting: !0,
    width: 130,
    header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.edited"), ...props2 }) }),
    cell: ({
      cellProps,
      datum: {
        document: document2,
        history: history2,
        isLoading
      }
    }) => /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, style: {
      minWidth: 130
    }, sizing: "border", children: !isLoading && document2._updatedAt && /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
      history2?.lastEditedBy && /* @__PURE__ */ jsx(UserAvatar, { size: 0, user: history2.lastEditedBy }),
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(RelativeTime, { time: document2._updatedAt, useTemporalPhrase: !0, minimal: !0 }) })
    ] }) })
  },
  {
    id: "validation",
    sorting: !1,
    width: 50,
    header: ({
      headerProps
    }) => /* @__PURE__ */ jsx(Flex, { ...headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.BasicHeader, { text: "" }) }),
    cell: ({
      cellProps,
      datum
    }) => {
      if (datum.isLoading) return null;
      const validationErrorCount = datum.validation.validation.filter((validation2) => validation2.level === "error").length;
      return /* @__PURE__ */ jsx(Flex, { ...cellProps, flex: 1, padding: 1, justify: "center", align: "center", sizing: "border", children: datum.validation.hasError && /* @__PURE__ */ jsx(Tooltip, { portal: !0, placement: "bottom-end", content: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
        /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }),
        t(validationErrorCount === 1 ? "document-validation.error_one" : "document-validation.error_other", {
          count: validationErrorCount
        })
      ] }) }), children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }) }) });
    }
  }
], isBundleDocumentRow = (maybeBundleDocumentRow) => !!maybeBundleDocumentRow && typeof maybeBundleDocumentRow == "object" && "memoKey" in maybeBundleDocumentRow && "document" in maybeBundleDocumentRow && "validation" in maybeBundleDocumentRow && "previewValues" in maybeBundleDocumentRow && "history" in maybeBundleDocumentRow;
function ReleaseSummary(props2) {
  const {
    documents,
    documentsHistory,
    isLoading = !1,
    release,
    scrollContainerRef
  } = props2, toast = useToast(), {
    createVersion
  } = useReleaseOperations(), telemetry = useTelemetry(), [openAddDocumentDialog, setAddDocumentDialog] = useState(!1), [pendingAddedDocument, setPendingAddedDocument] = useState([]), {
    t
  } = useTranslation(releasesLocaleNamespace), releaseId = getReleaseIdFromReleaseDocumentId(release._id), aggregatedData = useMemo(() => documents.map((document2) => ({
    ...document2,
    history: documentsHistory[document2.document._id]
  })), [documents, documentsHistory]), renderRowActions = useCallback((rowProps) => release.state !== "active" || !isBundleDocumentRow(rowProps.datum) || rowProps.datum.isPending ? null : /* @__PURE__ */ jsx(DocumentActions, { document: rowProps.datum, releaseTitle: release.metadata.title }), [release.metadata.title, release.state]), documentTableColumnDefs = useMemo(() => getDocumentTableColumnDefs(release._id, release.state, t), [release._id, release.state, t]), filterRows = useCallback((data, searchTerm) => data.filter(({
    previewValues,
    isPending
  }) => {
    const title = typeof previewValues.values?.title == "string" ? previewValues.values?.title : t("release-placeholder.title");
    return isPending || title.toLowerCase().includes(searchTerm.toLowerCase());
  }), [t]), closeAddDialog = useCallback(async (documentToAdd) => {
    if (setAddDocumentDialog(!1), !documentToAdd) return;
    const versionDocumentId = getVersionId(documentToAdd._id, releaseId), pendingAddedDocumentId = `${versionDocumentId}-pending`, pendingDocumentRow = {
      memoKey: versionDocumentId,
      previewValues: {
        isLoading: !0,
        values: {}
      },
      validation: {
        isValidating: !1,
        validation: [],
        hasError: !1
      },
      history: void 0,
      document: {
        ...documentToAdd,
        _id: pendingAddedDocumentId,
        publishedDocumentExists: !1
      },
      isPending: !0
    };
    setPendingAddedDocument((prev) => [...prev, pendingDocumentRow]);
    try {
      await createVersion(releaseId, documentToAdd._id);
      const origin = getDocumentVariantType(documentToAdd._id);
      telemetry.log(AddedVersion, {
        documentOrigin: origin
      });
    } catch (error) {
      setPendingAddedDocument((prev_0) => prev_0.filter(({
        document: document_0
      }) => document_0._id !== pendingAddedDocumentId)), toast.push({
        id: `add-version-to-release-${versionDocumentId}`,
        closable: !0,
        status: "error",
        title: t("toast.create-version.error", {
          error: error.message
        })
      });
    }
  }, [createVersion, releaseId, t, telemetry, toast]);
  useEffect(() => {
    const documentsNoLongerPending = [];
    pendingAddedDocument?.forEach((pendingDocument) => {
      documents.find(({
        document: document_1
      }) => `${document_1._id}-pending` === pendingDocument.document._id) && documentsNoLongerPending.push(pendingDocument.document._id);
    }), documentsNoLongerPending.length && setPendingAddedDocument((prev_1) => prev_1.filter(({
      document: document_2
    }) => !documentsNoLongerPending.includes(document_2._id)));
  }, [documents, pendingAddedDocument, t, toast]);
  const tableData = useMemo(() => pendingAddedDocument.length ? [...aggregatedData, ...pendingAddedDocument] : aggregatedData, [pendingAddedDocument, aggregatedData]);
  return /* @__PURE__ */ jsxs(Card, { borderTop: !0, "data-testid": "document-table-card", ref: scrollContainerRef, children: [
    /* @__PURE__ */ jsx(
      Table,
      {
        loading: isLoading,
        data: tableData,
        emptyState: t("summary.no-documents"),
        rowId: "document._id",
        columnDefs: documentTableColumnDefs,
        rowActions: renderRowActions,
        searchFilter: filterRows,
        scrollContainerRef,
        defaultSort: {
          column: "search",
          direction: "asc"
        }
      }
    ),
    release.state === "active" && /* @__PURE__ */ jsx(Container$2, { width: 3, children: /* @__PURE__ */ jsx(Card, { padding: 3, children: /* @__PURE__ */ jsx(Button, { icon: AddIcon, disabled: isLoading, mode: "bleed", onClick: () => setAddDocumentDialog(!0), text: t("action.add-document") }) }) }),
    /* @__PURE__ */ jsx(AddDocumentSearch, { open: openAddDocumentDialog, onClose: closeAddDialog, releaseId, idsInRelease: aggregatedData.map(({
      document: document_3
    }) => document_3._id) })
  ] });
}
const getActiveReleaseDocumentsObservable = ({
  schema: schema2,
  documentPreviewStore,
  i18n,
  getClient: getClient2,
  releaseId,
  perspectiveStack
}) => {
  const observableClient = getClient2(RELEASES_STUDIO_CLIENT_OPTIONS).observable;
  return documentPreviewStore.unstable_observeDocumentIdSet("sanity::partOfRelease($releaseId)", {
    releaseId
  }, {
    apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
  }).pipe(map((state) => state.documentIds || []), mergeMapArray((id2) => {
    const ctx = {
      observeDocumentPairAvailability: documentPreviewStore.unstable_observeDocumentPairAvailability,
      i18n,
      getClient: getClient2,
      schema: schema2
    }, document$ = documentPreviewStore.unstable_observeDocument(id2, {
      apiVersion: RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion
    }).pipe(filter(Boolean), switchMap((doc) => observableClient.fetch(`*[_id in path("${getPublishedId(doc._id)}")]{_id}`, {}, {
      tag: "release-documents.check-existing"
    }).pipe(switchMap((publishedDocumentExists) => of({
      ...doc,
      publishedDocumentExists: !!publishedDocumentExists.length
    }))))), validation$ = validateDocumentWithReferences(ctx, document$).pipe(map((validationStatus) => ({
      ...validationStatus,
      hasError: validationStatus.validation.some((marker) => isValidationErrorMarker(marker))
    }))), previewValues$ = document$.pipe(map((document2) => {
      const schemaType = schema2.get(document2._type);
      return schemaType ? documentPreviewStore.observeForPreview(document2, schemaType, {
        perspective: [releaseId]
      }).pipe(switchMap((value) => {
        if (value.snapshot)
          return of(value);
        const updatedPerspectiveStack = perspectiveStack.length > 1 ? perspectiveStack.slice(1) : perspectiveStack, previousPerspective = updatedPerspectiveStack[0], docId = previousPerspective === "drafts" ? getDraftId(document2._id) : getVersionId(document2._id, previousPerspective);
        return documentPreviewStore.observeForPreview({
          _id: docId
        }, schemaType, {
          perspective: updatedPerspectiveStack
        });
      }), map(({
        snapshot: snapshot2
      }) => ({
        isLoading: !1,
        values: snapshot2
      })), startWith({
        isLoading: !0,
        values: {}
      })) : (console.error(`Schema type not found for document type ${document2._type} (document ID: ${document2._id})`), of({
        isLoading: !1,
        values: {
          _id: document2._id,
          title: `Document type "${document2._type}" not found`,
          _createdAt: document2._createdAt,
          _updatedAt: document2._updatedAt
        }
      }));
    }), switchAll());
    return combineLatest([document$, validation$, previewValues$]).pipe(map(([document2, validation2, previewValues]) => ({
      document: document2,
      validation: validation2,
      previewValues,
      memoKey: uuid()
    })));
  }), map((results) => ({
    loading: !1,
    results,
    error: null
  })), catchError((error) => of({
    loading: !1,
    results: [],
    error
  })));
}, getPublishedArchivedReleaseDocumentsObservable = ({
  getClient: getClient2,
  schema: schema2,
  documentPreviewStore,
  release
}) => {
  const client = getClient2(RELEASES_STUDIO_CLIENT_OPTIONS), observableClient = client.observable, dataset = client.config().dataset;
  if (!release.finalDocumentStates?.length) return of({
    loading: !1,
    results: [],
    error: null
  });
  function batchRequestDocumentFromHistory(startIndex) {
    const finalIndex = startIndex + 10;
    return observableClient.request({
      url: `/data/history/${dataset}/documents/${release.finalDocumentStates?.slice(startIndex, finalIndex).map((d) => d.id).join(",")}?lastRevision=true`
    }).pipe(map(({
      documents
    }) => ({
      documents,
      finalIndex
    })));
  }
  return batchRequestDocumentFromHistory(0).pipe(expand$1((response) => release.finalDocumentStates && response.finalIndex < release.finalDocumentStates.length ? batchRequestDocumentFromHistory(response.finalIndex) : of()), reduce$2((documents, batch) => documents.concat(batch.documents), [])).pipe(mergeMap((documents) => combineLatest(documents.map((document2) => {
    const schemaType = schema2.get(document2._type);
    if (!schemaType)
      throw new Error(`Schema type not found for document type ${document2._type}`);
    return documentPreviewStore.observeForPreview(document2, schemaType).pipe(take(1), map(({
      snapshot: snapshot2
    }) => ({
      isLoading: !1,
      values: prepareForPreview(snapshot2 || document2, schemaType)
    })), startWith({
      isLoading: !0,
      values: {}
    }), filter(({
      isLoading
    }) => !isLoading)).pipe(map((previewValues) => ({
      document: document2,
      previewValues,
      memoKey: uuid(),
      validation: {
        validation: [],
        hasError: !1,
        isValidating: !1
      }
    })));
  })).pipe(map((results) => ({
    loading: !1,
    results,
    error: null
  })))), catchError((error) => of({
    loading: !1,
    results: [],
    error
  })));
}, getReleaseDocumentsObservable = ({
  schema: schema2,
  documentPreviewStore,
  getClient: getClient2,
  releaseId,
  i18n,
  releasesState$,
  perspectiveStack
}) => releasesState$.pipe(map((releasesState) => releasesState.releases.get(getReleaseDocumentIdFromReleaseId(releaseId))), filter(Boolean), distinctUntilChanged((prev, next) => prev._rev === next._rev), switchMap((release) => release.state === "published" || release.state === "archived" ? getPublishedArchivedReleaseDocumentsObservable({
  schema: schema2,
  documentPreviewStore,
  getClient: getClient2,
  release
}) : getActiveReleaseDocumentsObservable({
  schema: schema2,
  documentPreviewStore,
  i18n,
  getClient: getClient2,
  releaseId,
  perspectiveStack
})), startWith({
  loading: !0,
  results: [],
  error: null
}));
function useBundleDocuments(releaseId) {
  const $ = c(9), documentPreviewStore = useDocumentPreviewStore(), {
    getClient: getClient2,
    i18n
  } = useSource(), schema2 = useSchema(), {
    state$: releasesState$
  } = useReleasesStore(), {
    perspectiveStack
  } = usePerspective();
  let t0, t1;
  $[0] !== documentPreviewStore || $[1] !== getClient2 || $[2] !== i18n || $[3] !== perspectiveStack || $[4] !== releaseId || $[5] !== releasesState$ || $[6] !== schema2 ? (t1 = getReleaseDocumentsObservable({
    schema: schema2,
    documentPreviewStore,
    getClient: getClient2,
    releaseId,
    i18n,
    releasesState$,
    perspectiveStack
  }), $[0] = documentPreviewStore, $[1] = getClient2, $[2] = i18n, $[3] = perspectiveStack, $[4] = releaseId, $[5] = releasesState$, $[6] = schema2, $[7] = t1) : t1 = $[7], t0 = t1;
  const releaseDocumentsObservable = t0;
  let t2;
  return $[8] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    loading: !0,
    results: [],
    error: null
  }, $[8] = t2) : t2 = $[8], useObservable(releaseDocumentsObservable, t2);
}
const MotionCard = motion.create(Card), ReleaseDetail = () => {
  const $ = c(61), router = useRouter(), [inspector, setInspector] = useState(void 0), {
    t
  } = useTranslation(releasesLocaleNamespace), {
    releaseId: releaseIdRaw
  } = router.state, releaseId = decodeURIComponent(releaseIdRaw || ""), {
    data,
    loading
  } = useActiveReleases(), {
    data: archivedReleases
  } = useArchivedReleases(), {
    loading: documentsLoading,
    results,
    error: bundleDocumentsError
  } = useBundleDocuments(releaseId), releaseEvents = useReleaseEvents(releaseId);
  let t0;
  $[0] !== results ? (t0 = results.map(_temp$2c), $[0] = results, $[1] = t0) : t0 = $[1];
  const history2 = useReleaseHistory(t0, releaseId);
  let t1;
  if ($[2] !== archivedReleases || $[3] !== data || $[4] !== releaseId) {
    let t22;
    $[6] !== releaseId ? (t22 = (candidate) => getReleaseIdFromReleaseDocumentId(candidate._id) === releaseId, $[6] = releaseId, $[7] = t22) : t22 = $[7], t1 = data.concat(archivedReleases).find(t22), $[2] = archivedReleases, $[3] = data, $[4] = releaseId, $[5] = t1;
  } else
    t1 = $[5];
  const releaseInDetail = t1, scrollContainerRef = useRef(null);
  let t2;
  bb0: {
    if (bundleDocumentsError) {
      let t33, t42;
      $[8] === Symbol.for("react.memo_cache_sentinel") ? (t33 = {
        opacity: 0
      }, t42 = {
        opacity: 1
      }, $[8] = t33, $[9] = t42) : (t33 = $[8], t42 = $[9]);
      let t5;
      $[10] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[10] = t5) : t5 = $[10];
      let t6;
      $[11] !== t ? (t6 = t("loading-release-documents.error.title"), $[11] = t, $[12] = t6) : t6 = $[12];
      let t7;
      $[13] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t6 }), $[13] = t6, $[14] = t7) : t7 = $[14];
      let t8;
      $[15] !== t ? (t8 = t("loading-release-documents.error.description"), $[15] = t, $[16] = t8) : t8 = $[16];
      let t9;
      $[17] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t8 }), $[17] = t8, $[18] = t9) : t9 = $[18];
      let t10;
      $[19] !== t7 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(MotionCard, { initial: t33, animate: t42, tone: "critical", padding: 4, radius: 4, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
        t5,
        /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
          t7,
          t9
        ] })
      ] }) }) }), $[19] = t7, $[20] = t9, $[21] = t10) : t10 = $[21], t2 = t10;
      break bb0;
    }
    if (!releaseInDetail) {
      t2 = null;
      break bb0;
    }
    let t32;
    $[22] !== documentsLoading || $[23] !== history2.documentsHistory || $[24] !== releaseInDetail || $[25] !== results ? (t32 = /* @__PURE__ */ jsx(ReleaseSummary, { isLoading: documentsLoading, documents: results, release: releaseInDetail, documentsHistory: history2.documentsHistory, scrollContainerRef }), $[22] = documentsLoading, $[23] = history2.documentsHistory, $[24] = releaseInDetail, $[25] = results, $[26] = t32) : t32 = $[26], t2 = t32;
  }
  const detailContent = t2;
  if (loading) {
    let t32;
    $[27] !== t ? (t32 = t("loading-release"), $[27] = t, $[28] = t32) : t32 = $[28];
    let t42;
    return $[29] !== t32 ? (t42 = /* @__PURE__ */ jsx(LoadingBlock, { title: t32, fill: !0, "data-testid": "release-documents-table-loader" }), $[29] = t32, $[30] = t42) : t42 = $[30], t42;
  }
  if (releaseInDetail) {
    let t32;
    $[31] !== inspector || $[32] !== releaseInDetail ? (t32 = /* @__PURE__ */ jsx(Card, { flex: "none", padding: 3, children: /* @__PURE__ */ jsx(ReleaseDashboardHeader, { release: releaseInDetail, inspector, setInspector }) }), $[31] = inspector, $[32] = releaseInDetail, $[33] = t32) : t32 = $[33];
    let t42;
    $[34] !== releaseInDetail ? (t42 = /* @__PURE__ */ jsx(ReleaseDashboardDetails, { release: releaseInDetail }), $[34] = releaseInDetail, $[35] = t42) : t42 = $[35];
    let t5;
    $[36] !== detailContent || $[37] !== t42 ? (t5 = /* @__PURE__ */ jsxs(Card, { flex: 1, overflow: "auto", children: [
      t42,
      detailContent
    ] }), $[36] = detailContent, $[37] = t42, $[38] = t5) : t5 = $[38];
    let t6;
    $[39] !== releaseEvents.events || $[40] !== releaseInDetail || $[41] !== results ? (t6 = /* @__PURE__ */ jsx(ReleaseDashboardFooter, { documents: results, release: releaseInDetail, events: releaseEvents.events }), $[39] = releaseEvents.events, $[40] = releaseInDetail, $[41] = results, $[42] = t6) : t6 = $[42];
    let t7;
    $[43] !== t5 || $[44] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, height: "fill", children: [
      t5,
      t6
    ] }), $[43] = t5, $[44] = t6, $[45] = t7) : t7 = $[45];
    const t8 = inspector === "activity";
    let t9;
    $[46] !== releaseEvents || $[47] !== releaseInDetail || $[48] !== t8 ? (t9 = /* @__PURE__ */ jsx(ReleaseDashboardActivityPanel, { events: releaseEvents, release: releaseInDetail, show: t8 }), $[46] = releaseEvents, $[47] = releaseInDetail, $[48] = t8, $[49] = t9) : t9 = $[49];
    let t10;
    $[50] !== t7 || $[51] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { flex: 1, children: [
      t7,
      t9
    ] }), $[50] = t7, $[51] = t9, $[52] = t10) : t10 = $[52];
    let t11;
    return $[53] !== t10 || $[54] !== t32 ? (t11 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, height: "fill", overflow: "hidden", children: [
      t32,
      t10
    ] }), $[53] = t10, $[54] = t32, $[55] = t11) : t11 = $[55], t11;
  }
  let t3;
  $[56] !== releaseId || $[57] !== t ? (t3 = t("not-found", {
    releaseId
  }), $[56] = releaseId, $[57] = t, $[58] = t3) : t3 = $[58];
  let t4;
  return $[59] !== t3 ? (t4 = /* @__PURE__ */ jsx(Card, { flex: 1, tone: "critical", children: /* @__PURE__ */ jsx(Container$2, { width: 0, children: /* @__PURE__ */ jsx(Stack, { paddingX: 4, paddingY: 6, space: 1, children: /* @__PURE__ */ jsx(Heading, { children: t3 }) }) }) }), $[59] = t3, $[60] = t4) : t4 = $[60], t4;
};
function _temp$2c(result) {
  return result.document?._id;
}
function CalendarDay$3(props2) {
  const $ = c(30), {
    date,
    focused,
    isCurrentMonth,
    isToday: isToday2,
    onSelect,
    selected,
    disabled,
    dateStyles: t0
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const dateStyles = t1;
  let t2;
  $[2] !== date || $[3] !== onSelect || $[4] !== selected ? (t2 = () => {
    onSelect(selected ? void 0 : date);
  }, $[2] = date, $[3] = onSelect, $[4] = selected, $[5] = t2) : t2 = $[5];
  const handleClick = t2;
  let tone;
  isToday2 || selected ? tone = "primary" : (isWeekend(date), tone = "default");
  let t3;
  $[6] !== date ? (t3 = date.toDateString(), $[6] = date, $[7] = t3) : t3 = $[7];
  const t4 = focused ? "true" : "", t5 = isToday2 ? "day-tile-today" : `day-tile-${date.getDate()}-${date.getMonth()}`;
  let t6;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    position: "relative"
  }, $[8] = t6) : t6 = $[8];
  const t7 = !selected && !isCurrentMonth ? 0.35 : 1;
  let t8;
  $[9] !== dateStyles || $[10] !== t7 ? (t8 = {
    opacity: t7,
    textAlign: "center",
    ...dateStyles
  }, $[9] = dateStyles, $[10] = t7, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== date || $[13] !== selected ? (t9 = selected ? /* @__PURE__ */ jsx(CloseIcon, {}) : date.getDate(), $[12] = date, $[13] = selected, $[14] = t9) : t9 = $[14];
  let t10;
  $[15] !== t8 || $[16] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: 1, style: t8, children: t9 }), $[15] = t8, $[16] = t9, $[17] = t10) : t10 = $[17];
  let t11;
  $[18] !== disabled || $[19] !== handleClick || $[20] !== selected || $[21] !== t10 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== tone ? (t11 = /* @__PURE__ */ jsx(Card, { "aria-label": t3, "aria-pressed": selected, as: "button", __unstable_focusRing: !0, "data-weekday": !0, "data-focused": t4, "data-testid": t5, role: "button", tabIndex: -1, onClick: handleClick, paddingX: 3, paddingY: 4, radius: 2, selected, style: t6, tone, disabled, children: t10 }), $[18] = disabled, $[19] = handleClick, $[20] = selected, $[21] = t10, $[22] = t3, $[23] = t4, $[24] = t5, $[25] = tone, $[26] = t11) : t11 = $[26];
  let t12;
  return $[27] !== selected || $[28] !== t11 ? (t12 = /* @__PURE__ */ jsx("div", { "aria-selected": selected, "data-ui": "CalendarDay", children: t11 }), $[27] = selected, $[28] = t11, $[29] = t12) : t12 = $[29], t12;
}
function CalendarMonth$2(props2) {
  const $ = c(24), {
    date,
    renderCalendarDay,
    hidden,
    disabled
  } = props2, {
    getCurrentZoneDate
  } = useTimeZone(), CalendarDay2 = renderCalendarDay || CalendarDay$3, weeksOfMonth = useWeeksOfMonth$1(date), t0 = hidden || !1;
  let t1, t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    gridGap: "1px",
    gridTemplateColumns: "repeat(7, 1fr)"
  }, t2 = DEFAULT_WEEK_DAY_NAMES.map(_temp$2b), $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]);
  let t3;
  if ($[2] !== CalendarDay2 || $[3] !== date || $[4] !== disabled || $[5] !== getCurrentZoneDate || $[6] !== props2.focused || $[7] !== props2.onSelect || $[8] !== props2.selected || $[9] !== weeksOfMonth) {
    let t42;
    $[11] !== CalendarDay2 || $[12] !== date || $[13] !== disabled || $[14] !== getCurrentZoneDate || $[15] !== props2.focused || $[16] !== props2.onSelect || $[17] !== props2.selected ? (t42 = (week, weekIdx) => week.days.map((dayDate, dayIdx) => {
      const focused = props2.focused && isSameDay(dayDate, props2.focused), selected = props2.selected && isSameDay(dayDate, props2.selected), isToday2 = isSameDay(dayDate, getCurrentZoneDate()), isCurrentMonth = isSameMonth(dayDate, props2.focused || date);
      return /* @__PURE__ */ jsx(CalendarDay2, { date: dayDate, focused, isCurrentMonth, isToday: isToday2, onSelect: props2.onSelect, selected, disabled }, `${weekIdx}-${dayIdx}`);
    }), $[11] = CalendarDay2, $[12] = date, $[13] = disabled, $[14] = getCurrentZoneDate, $[15] = props2.focused, $[16] = props2.onSelect, $[17] = props2.selected, $[18] = t42) : t42 = $[18], t3 = weeksOfMonth.map(t42), $[2] = CalendarDay2, $[3] = date, $[4] = disabled, $[5] = getCurrentZoneDate, $[6] = props2.focused, $[7] = props2.onSelect, $[8] = props2.selected, $[9] = weeksOfMonth, $[10] = t3;
  } else
    t3 = $[10];
  let t4;
  $[19] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Grid, { style: t1, children: [
    t2,
    t3
  ] }), $[19] = t3, $[20] = t4) : t4 = $[20];
  let t5;
  return $[21] !== t0 || $[22] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { "aria-hidden": t0, "data-ui": "CalendarMonth", children: t4 }), $[21] = t0, $[22] = t4, $[23] = t5) : t5 = $[23], t5;
}
function _temp$2b(weekday) {
  return /* @__PURE__ */ jsx(Card, { paddingY: 3, children: /* @__PURE__ */ jsx(Label, { size: 1, style: {
    textAlign: "center"
  }, children: weekday.slice(0, 1) }) }, weekday);
}
const PRESERVE_FOCUS_ELEMENT$2 = /* @__PURE__ */ jsx("span", { "data-preserve-focus": !0, style: {
  overflow: "hidden",
  position: "absolute",
  outline: "none"
}, tabIndex: -1 }), CalendarFilter = forwardRef(function(props2, forwardedRef) {
  const $ = c(84);
  let handleOnFocusedDateChange, onSelect, providedFocusedDate, renderCalendarDay, restProps, selectedDate;
  $[0] !== props2 ? ({
    focusedDate: providedFocusedDate,
    onFocusedDateChange: handleOnFocusedDateChange,
    onSelect,
    selectedDate,
    renderCalendarDay,
    ...restProps
  } = props2, $[0] = props2, $[1] = handleOnFocusedDateChange, $[2] = onSelect, $[3] = providedFocusedDate, $[4] = renderCalendarDay, $[5] = restProps, $[6] = selectedDate) : (handleOnFocusedDateChange = $[1], onSelect = $[2], providedFocusedDate = $[3], renderCalendarDay = $[4], restProps = $[5], selectedDate = $[6]);
  let t0;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ new Date(), $[7] = t0) : t0 = $[7];
  const [_focusedDate, _setFocusedDate] = useState(t0), {
    t: tCore
  } = useTranslation(), {
    zoneDateToUtc
  } = useTimeZone(), focusedDate = providedFocusedDate || _focusedDate;
  let t1;
  $[8] !== handleOnFocusedDateChange || $[9] !== providedFocusedDate ? (t1 = (date) => {
    handleOnFocusedDateChange && providedFocusedDate ? handleOnFocusedDateChange(date) : _setFocusedDate(date);
  }, $[8] = handleOnFocusedDateChange, $[9] = providedFocusedDate, $[10] = t1) : t1 = $[10];
  const onFocusedDateChange = t1;
  let t2;
  $[11] !== onFocusedDateChange || $[12] !== zoneDateToUtc ? (t2 = (date_0) => {
    onFocusedDateChange(zoneDateToUtc(date_0));
  }, $[11] = onFocusedDateChange, $[12] = zoneDateToUtc, $[13] = t2) : t2 = $[13];
  const setFocusedDate = t2;
  let t3;
  $[14] !== focusedDate || $[15] !== setFocusedDate ? (t3 = (by) => setFocusedDate(addMonths(focusedDate, by)), $[14] = focusedDate, $[15] = setFocusedDate, $[16] = t3) : t3 = $[16];
  const moveFocusedDate = t3;
  let t4;
  $[17] !== onFocusedDateChange || $[18] !== onSelect || $[19] !== zoneDateToUtc ? (t4 = (date_1) => {
    if (date_1) {
      const targetDate = zoneDateToUtc(setMinutes(setHours(date_1, date_1.getHours()), date_1.getMinutes()));
      onSelect(targetDate), onFocusedDateChange(targetDate);
    } else
      onSelect(void 0);
  }, $[17] = onFocusedDateChange, $[18] = onSelect, $[19] = zoneDateToUtc, $[20] = t4) : t4 = $[20];
  const handleDateChange = t4, ref = useRef(null);
  let t5;
  $[21] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => ref.current, $[21] = t5) : t5 = $[21], useImperativeHandle(forwardedRef, t5);
  let t6;
  $[22] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    ref.current?.querySelector('[data-focused="true"]')?.focus();
  }, $[22] = t6) : t6 = $[22];
  const focusCurrentWeekDay = t6;
  let t7;
  $[23] !== focusedDate || $[24] !== onFocusedDateChange || $[25] !== zoneDateToUtc ? (t7 = (event) => {
    if (ARROW_KEYS$2.includes(event.key)) {
      if (event.preventDefault(), event.currentTarget.hasAttribute("data-calendar-grid")) {
        focusCurrentWeekDay();
        return;
      }
      event.key === "ArrowUp" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, -7))), event.key === "ArrowDown" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, 7))), event.key === "ArrowLeft" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, -1))), event.key === "ArrowRight" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, 1))), ref.current?.querySelector("[data-preserve-focus]")?.focus();
    }
  }, $[23] = focusedDate, $[24] = onFocusedDateChange, $[25] = zoneDateToUtc, $[26] = t7) : t7 = $[26];
  const handleKeyDown = t7;
  let t8, t9;
  $[27] === Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    focusCurrentWeekDay();
  }, t9 = [focusCurrentWeekDay], $[27] = t8, $[28] = t9) : (t8 = $[27], t9 = $[28]), useEffect(t8, t9);
  let t10;
  $[29] === Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    document.activeElement?.matches("[data-calendar-grid], [data-calendar-grid] [data-preserve-focus]") && focusCurrentWeekDay();
  }, $[29] = t10) : t10 = $[29];
  let t11;
  $[30] !== focusedDate ? (t11 = [ref, focusCurrentWeekDay, focusedDate], $[30] = focusedDate, $[31] = t11) : t11 = $[31], useEffect(t10, t11);
  let t12;
  $[32] !== onFocusedDateChange || $[33] !== onSelect ? (t12 = () => {
    const now = /* @__PURE__ */ new Date();
    onSelect(now), onFocusedDateChange(now);
  }, $[32] = onFocusedDateChange, $[33] = onSelect, $[34] = t12) : t12 = $[34];
  const handleNowClick = t12;
  let t13;
  $[35] !== moveFocusedDate ? (t13 = () => moveFocusedDate(-1), $[35] = moveFocusedDate, $[36] = t13) : t13 = $[36];
  const handlePrevMonthClick = t13;
  let t14;
  $[37] !== moveFocusedDate ? (t14 = () => moveFocusedDate(1), $[37] = moveFocusedDate, $[38] = t14) : t14 = $[38];
  const handleNextMonthClick = t14;
  let t15;
  $[39] === Symbol.for("react.memo_cache_sentinel") ? (t15 = {
    borderBottom: "1px solid var(--card-border-color)",
    minHeight: "55px",
    position: "sticky",
    top: 0
  }, $[39] = t15) : t15 = $[39];
  const t16 = DEFAULT_MONTH_NAMES[focusedDate?.getMonth()];
  let t17;
  $[40] !== focusedDate ? (t17 = focusedDate?.getFullYear(), $[40] = focusedDate, $[41] = t17) : t17 = $[41];
  let t18;
  $[42] !== t16 || $[43] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Text$1, { weight: "medium", size: 1, children: [
    t16,
    " ",
    t17
  ] }), $[42] = t16, $[43] = t17, $[44] = t18) : t18 = $[44];
  let t19;
  $[45] === Symbol.for("react.memo_cache_sentinel") ? (t19 = {
    content: "Previous month"
  }, $[45] = t19) : t19 = $[45];
  let t20;
  $[46] !== handlePrevMonthClick || $[47] !== restProps.disabled ? (t20 = /* @__PURE__ */ jsx(Button, { icon: ChevronLeftIcon, mode: "bleed", onClick: handlePrevMonthClick, tooltipProps: t19, disabled: restProps.disabled }), $[46] = handlePrevMonthClick, $[47] = restProps.disabled, $[48] = t20) : t20 = $[48];
  let t21;
  $[49] === Symbol.for("react.memo_cache_sentinel") ? (t21 = {
    content: "Next month"
  }, $[49] = t21) : t21 = $[49];
  let t22;
  $[50] !== handleNextMonthClick || $[51] !== restProps.disabled ? (t22 = /* @__PURE__ */ jsx(Button, { icon: ChevronRightIcon, mode: "bleed", onClick: handleNextMonthClick, tooltipProps: t21, disabled: restProps.disabled }), $[50] = handleNextMonthClick, $[51] = restProps.disabled, $[52] = t22) : t22 = $[52];
  let t23;
  $[53] !== t20 || $[54] !== t22 ? (t23 = /* @__PURE__ */ jsx(Flex, { paddingRight: 3, gap: 2, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    t20,
    t22
  ] }) }), $[53] = t20, $[54] = t22, $[55] = t23) : t23 = $[55];
  let t24;
  $[56] !== t18 || $[57] !== t23 ? (t24 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingLeft: 4, style: t15, children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, justify: "space-between", children: [
    t18,
    t23
  ] }) }), $[56] = t18, $[57] = t23, $[58] = t24) : t24 = $[58];
  let t25;
  $[59] !== focusedDate || $[60] !== handleDateChange || $[61] !== providedFocusedDate || $[62] !== renderCalendarDay || $[63] !== restProps.disabled || $[64] !== selectedDate ? (t25 = /* @__PURE__ */ jsx(CalendarMonth$2, { date: focusedDate, focused: providedFocusedDate, onSelect: handleDateChange, selected: selectedDate, renderCalendarDay, disabled: restProps.disabled }), $[59] = focusedDate, $[60] = handleDateChange, $[61] = providedFocusedDate, $[62] = renderCalendarDay, $[63] = restProps.disabled, $[64] = selectedDate, $[65] = t25) : t25 = $[65];
  let t26;
  $[66] !== handleKeyDown || $[67] !== t25 ? (t26 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Box, { "data-calendar-grid": !0, onKeyDown: handleKeyDown, overflow: "hidden", paddingBottom: 1, paddingX: 1, tabIndex: 0, children: [
    t25,
    PRESERVE_FOCUS_ELEMENT$2
  ] }) }), $[66] = handleKeyDown, $[67] = t25, $[68] = t26) : t26 = $[68];
  let t27;
  $[69] === Symbol.for("react.memo_cache_sentinel") ? (t27 = {
    borderBottom: "1px solid var(--card-border-color)"
  }, $[69] = t27) : t27 = $[69];
  const t28 = restProps.disabled;
  let t29;
  $[70] !== tCore ? (t29 = tCore("calendar.action.go-to-today-aria-label"), $[70] = tCore, $[71] = t29) : t29 = $[71];
  let t30;
  $[72] !== tCore ? (t30 = tCore("calendar.action.go-to-today"), $[72] = tCore, $[73] = t30) : t30 = $[73];
  let t31;
  $[74] !== handleNowClick || $[75] !== restProps.disabled || $[76] !== t29 || $[77] !== t30 ? (t31 = /* @__PURE__ */ jsx(Box, { flex: 1, style: t27, children: /* @__PURE__ */ jsx(Button, { disabled: t28, mode: "bleed", onClick: handleNowClick, width: "fill", "aria-label": t29, text: t30 }) }), $[74] = handleNowClick, $[75] = restProps.disabled, $[76] = t29, $[77] = t30, $[78] = t31) : t31 = $[78];
  let t32;
  return $[79] !== restProps || $[80] !== t24 || $[81] !== t26 || $[82] !== t31 ? (t32 = /* @__PURE__ */ jsxs(Box, { "data-ui": "Calendar", ...restProps, ref, children: [
    t24,
    t26,
    t31
  ] }), $[79] = restProps, $[80] = t24, $[81] = t26, $[82] = t31, $[83] = t32) : t32 = $[83], t32;
});
function CreateReleaseDialog(props2) {
  const {
    onCancel,
    onSubmit,
    origin
  } = props2, toast = useToast(), {
    createRelease
  } = useReleaseOperations(), setPerspective = useSetPerspective(), {
    t
  } = useTranslation(), telemetry = useTelemetry(), createReleaseMetadata = useCreateReleaseMetadata(), [release, setRelease] = useState(getReleaseDefaults), [isSubmitting, setIsSubmitting] = useState(!1), handleOnSubmit = useCallback(async (event) => {
    event.preventDefault();
    try {
      setIsSubmitting(!0);
      const releaseValue = createReleaseMetadata(release);
      await createRelease(releaseValue), telemetry.log(CreatedRelease, {
        origin
      }), await new Promise((resolve) => setTimeout(resolve, 1e3)), setPerspective(getReleaseIdFromReleaseDocumentId(release._id)), onSubmit(getReleaseIdFromReleaseDocumentId(release._id));
    } catch (err) {
      isReleaseLimitError(err) ? onCancel() : (console.error(err), toast.push({
        closable: !0,
        status: "error",
        title: t("release.toast.create-release-error.title")
      }));
    } finally {
      setIsSubmitting(!1);
    }
  }, [release, toast, createReleaseMetadata, createRelease, telemetry, origin, setPerspective, onSubmit, onCancel, t]), handleOnChange = useCallback((releaseMetadata) => {
    setRelease(releaseMetadata);
  }, []), dialogTitle = t("release.dialog.create.title"), dialogConfirm = t("release.dialog.create.confirm");
  return /* @__PURE__ */ jsx(Dialog$1, { onClickOutside: onCancel, header: dialogTitle, id: "create-release-dialog", onClose: onCancel, width: 1, padding: !1, children: /* @__PURE__ */ jsx(Card, { padding: 4, borderTop: !0, children: /* @__PURE__ */ jsxs("form", { onSubmit: handleOnSubmit, children: [
    /* @__PURE__ */ jsx(Box, { paddingBottom: 4, children: /* @__PURE__ */ jsx(ReleaseForm, { onChange: handleOnChange, value: release }) }),
    /* @__PURE__ */ jsx(Flex, { justify: "flex-end", paddingTop: 5, children: /* @__PURE__ */ jsx(Button, { size: "large", disabled: isSubmitting, type: "submit", text: dialogConfirm, loading: isSubmitting, "data-testid": "submit-release-button" }) })
  ] }) }) });
}
const DEFAULT_METADATA_STATE = {
  data: null,
  error: null,
  loading: !1
}, ReleasesMetadataProviderInner = (t0) => {
  const $ = c(15), {
    children
  } = t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const [listenerReleaseIds, setListenerReleaseIds] = useState(t1), {
    getMetadataStateForSlugs$
  } = useReleasesStore(), [releasesMetadata, setReleasesMetadata] = useState(null);
  let t2, t3;
  $[1] !== getMetadataStateForSlugs$ || $[2] !== listenerReleaseIds ? (t3 = getMetadataStateForSlugs$(listenerReleaseIds.map(_temp$2a)), $[1] = getMetadataStateForSlugs$, $[2] = listenerReleaseIds, $[3] = t3) : t3 = $[3], t2 = t3;
  const observedResult = useObservable(t2) || DEFAULT_METADATA_STATE;
  let t4, t5;
  $[4] !== observedResult.data ? (t4 = () => setReleasesMetadata((prevReleaseMetadata) => observedResult.data ? {
    ...prevReleaseMetadata || {},
    ...observedResult.data
  } : prevReleaseMetadata), t5 = [observedResult.data], $[4] = observedResult.data, $[5] = t4, $[6] = t5) : (t4 = $[5], t5 = $[6]), useEffect(t4, t5);
  let t6;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t6 = (addReleaseIds) => {
    setListenerReleaseIds((prevSlugs) => [...prevSlugs, ...addReleaseIds.filter(_temp2$O)]);
  }, $[7] = t6) : t6 = $[7];
  const addReleaseIdsToListener = t6;
  let t7;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t7 = (releaseIds) => {
    setListenerReleaseIds((prevSlugs_0) => {
      const {
        nextSlugs
      } = prevSlugs_0.reduce((acc, slug_0) => {
        const {
          removedSlugs,
          nextSlugs: accNextSlugs
        } = acc;
        return releaseIds.includes(slug_0) && !removedSlugs.includes(slug_0) ? {
          removedSlugs: [...removedSlugs, slug_0],
          nextSlugs: accNextSlugs
        } : {
          removedSlugs,
          nextSlugs: [...accNextSlugs, slug_0]
        };
      }, {
        removedSlugs: [],
        nextSlugs: []
      });
      return nextSlugs;
    });
  }, $[8] = t7) : t7 = $[8];
  const removeReleaseIdsFromListener = t7;
  let t8, t9;
  $[9] !== observedResult || $[10] !== releasesMetadata ? (t9 = {
    addReleaseIdsToListener,
    removeReleaseIdsFromListener,
    state: {
      ...observedResult,
      data: releasesMetadata
    }
  }, $[9] = observedResult, $[10] = releasesMetadata, $[11] = t9) : t9 = $[11], t8 = t9;
  const context = t8;
  let t10;
  return $[12] !== children || $[13] !== context ? (t10 = /* @__PURE__ */ jsx(ReleasesMetadataContext.Provider, { value: context, children }), $[12] = children, $[13] = context, $[14] = t10) : t10 = $[14], t10;
}, ReleasesMetadataProvider = (t0) => {
  const $ = c(2), {
    children
  } = t0;
  if (useContext(ReleasesMetadataContext))
    return children;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(ReleasesMetadataProviderInner, { children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}, useReleasesMetadataProvider = () => {
  const $ = c(2), contextValue = useContext(ReleasesMetadataContext);
  let t0;
  return $[0] !== contextValue ? (t0 = contextValue || {
    state: DEFAULT_METADATA_STATE,
    addReleaseIdsToListener: _temp3$g,
    removeReleaseIdsFromListener: _temp4$a
  }, $[0] = contextValue, $[1] = t0) : t0 = $[1], t0;
};
function _temp$2a(slug) {
  return slug;
}
function _temp2$O(releaseId) {
  return typeof releaseId == "string";
}
function _temp3$g() {
  return null;
}
function _temp4$a() {
  return null;
}
const useReleasesMetadata = (releaseIds) => {
  const $ = c(14), {
    addReleaseIdsToListener: addBundleIdsToListener,
    removeReleaseIdsFromListener: removeBundleIdsFromListener,
    state
  } = useReleasesMetadataProvider(), [responseData, setResponseData] = useState(null);
  let t0, t1;
  $[0] !== addBundleIdsToListener || $[1] !== releaseIds || $[2] !== removeBundleIdsFromListener ? (t0 = () => (releaseIds.length && addBundleIdsToListener([...new Set(releaseIds)]), () => removeBundleIdsFromListener([...new Set(releaseIds)])), t1 = [addBundleIdsToListener, releaseIds, removeBundleIdsFromListener], $[0] = addBundleIdsToListener, $[1] = releaseIds, $[2] = removeBundleIdsFromListener, $[3] = t0, $[4] = t1) : (t0 = $[3], t1 = $[4]), useEffect(t0, t1);
  const {
    data,
    loading
  } = state;
  let t2, t3;
  $[5] !== data || $[6] !== releaseIds || $[7] !== responseData ? (t2 = () => {
    if (data && (!responseData || Object.entries(responseData).some((t42) => {
      const [key, value] = t42;
      return value !== data[key];
    }))) {
      const nextResponseData = Object.fromEntries(releaseIds.map((releaseId) => [releaseId, data[releaseId]]));
      setResponseData(nextResponseData);
    }
  }, t3 = [releaseIds, data, responseData], $[5] = data, $[6] = releaseIds, $[7] = responseData, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3);
  let t4;
  return $[10] !== loading || $[11] !== responseData || $[12] !== state.error ? (t4 = {
    error: state.error,
    loading,
    data: responseData
  }, $[10] = loading, $[11] = responseData, $[12] = state.error, $[13] = t4) : t4 = $[13], t4;
}, ReleaseIllustration = () => {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsxs("svg", { width: "248", height: "201", viewBox: "0 0 248 201", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M175.4 29.8262V98.1738C175.4 103.823 181.346 107.498 186.399 104.971L222.399 86.9714C224.974 85.684 226.6 83.0524 226.6 80.1738V11.8262C226.6 6.17654 220.654 2.50197 215.601 5.02859L179.601 23.0286C177.026 24.316 175.4 26.9476 175.4 29.8262Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M183.4 33.8262V102.174C183.4 107.823 189.346 111.498 194.399 108.971L230.399 90.9714C232.974 89.684 234.6 87.0524 234.6 84.1738V15.8262C234.6 10.1765 228.654 6.50197 223.601 9.02859L187.601 27.0286C185.026 28.316 183.4 30.9476 183.4 33.8262Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M195.4 39.8262V108.174C195.4 113.823 201.346 117.498 206.399 114.971L242.399 96.9714C244.974 95.684 246.6 93.0524 246.6 90.1738V21.8262C246.6 16.1765 240.654 12.502 235.601 15.0286L199.601 33.0286C197.026 34.316 195.4 36.9476 195.4 39.8262Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.6", d: "M109.4 50.8262V119.174C109.4 124.823 115.346 128.498 120.399 125.971L156.399 107.971C158.974 106.684 160.6 104.052 160.6 101.174V32.8262C160.6 27.1765 154.654 23.502 149.601 26.0286L113.601 44.0286C111.026 45.316 109.4 47.9476 109.4 50.8262Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.9", d: "M118 123.174V54.8262C118 52.1748 119.498 49.751 121.87 48.5653L157.87 30.5652C162.524 28.2381 168 31.6226 168 36.8262V105.174C168 107.825 166.502 110.249 164.131 111.435L128.13 129.435C123.476 131.762 118 128.377 118 123.174Z", fill: "#F6F6F8", stroke: "#4E556D", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M121.4 56.8262V125.174C121.4 130.823 127.346 134.498 132.399 131.971L168.399 113.971C170.974 112.684 172.6 110.052 172.6 107.174V38.8262C172.6 33.1765 166.654 29.502 161.601 32.0286L125.601 50.0286C123.026 51.316 121.4 53.9476 121.4 56.8262Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M125.4 58.8262V127.174C125.4 132.823 131.346 136.498 136.399 133.971L172.399 115.971C174.974 114.684 176.6 112.052 176.6 109.174V40.8262C176.6 35.1765 170.654 31.502 165.601 34.0286L129.601 52.0286C127.026 53.316 125.4 55.9476 125.4 58.8262Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M137.4 64.8262V133.174C137.4 138.823 143.346 142.498 148.399 139.971L184.399 121.971C186.974 120.684 188.6 118.052 188.6 115.174V46.8262C188.6 41.1765 182.654 37.502 177.601 40.0286L141.601 58.0286C139.026 59.316 137.4 61.9476 137.4 64.8262Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M145.4 68.8262V137.174C145.4 142.823 151.346 146.498 156.399 143.971L192.399 125.971C194.974 124.684 196.6 122.052 196.6 119.174V50.8262C196.6 45.1765 190.654 41.502 185.601 44.0286L149.601 62.0286C147.026 63.316 145.4 65.9476 145.4 68.8262Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.6", d: "M1.4 104.826V173.174C1.4 178.823 7.34557 182.498 12.3988 179.971L48.3988 161.971C50.9736 160.684 52.6 158.052 52.6 155.174V86.8262C52.6 81.1765 46.6544 77.502 41.6012 80.0286L5.60117 98.0286C3.02641 99.316 1.4 101.948 1.4 104.826Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.6", d: "M56.6 146.174V77.8262C56.6 75.4021 57.9696 73.186 60.1378 72.1019L96.1378 54.1019C100.393 51.9742 105.4 55.0686 105.4 59.8262V128.174C105.4 130.598 104.03 132.814 101.862 133.898L65.8622 151.898C61.6068 154.026 56.6 150.931 56.6 146.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.8", d: "M60.6 148.174V79.8262C60.6 77.4021 61.9696 75.186 64.1378 74.1019L100.138 56.1019C104.393 53.9742 109.4 57.0686 109.4 61.8262V130.174C109.4 132.598 108.03 134.814 105.862 135.898L69.8622 153.898C65.6068 156.026 60.6 152.931 60.6 148.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.9", d: "M64 150.174V81.8262C64 79.1748 65.498 76.751 67.8695 75.5653L103.87 57.5652C108.524 55.2381 114 58.6226 114 63.8262V132.174C114 134.825 112.502 137.249 110.131 138.435L74.1305 156.435C69.4762 158.762 64 155.377 64 150.174Z", fill: "#F6F6F8", stroke: "#4E556D", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M72.6 154.174V85.8262C72.6 83.4021 73.9696 81.186 76.1378 80.1019L112.138 62.1019C116.393 59.9742 121.4 63.0686 121.4 67.8262V136.174C121.4 138.598 120.03 140.814 117.862 141.898L81.8622 159.898C77.6068 162.026 72.6 158.931 72.6 154.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M76.6 156.174V87.8262C76.6 85.4021 77.9696 83.186 80.1378 82.1019L116.138 64.1019C120.393 61.9742 125.4 65.0686 125.4 69.8262V138.174C125.4 140.598 124.03 142.814 121.862 143.898L85.8622 161.898C81.6068 164.026 76.6 160.931 76.6 156.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M84.6 160.174V91.8262C84.6 89.4021 85.9696 87.186 88.1378 86.1019L124.138 68.1019C128.393 65.9742 133.4 69.0686 133.4 73.8262V142.174C133.4 144.598 132.03 146.814 129.862 147.898L93.8622 165.898C89.6068 168.026 84.6 164.931 84.6 160.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M88.6 162.174V93.8262C88.6 91.4021 89.9696 89.186 92.1378 88.1019L128.138 70.1019C132.393 67.9742 137.4 71.0686 137.4 75.8262V144.174C137.4 146.598 136.03 148.814 133.862 149.898L97.8622 167.898C93.6068 170.026 88.6 166.931 88.6 162.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M92.6 164.174V95.8262C92.6 93.4021 93.9696 91.186 96.1378 90.1019L132.138 72.1019C136.393 69.9742 141.4 73.0686 141.4 77.8262V146.174C141.4 148.598 140.03 150.814 137.862 151.898L101.862 169.898C97.6068 172.026 92.6 168.931 92.6 164.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M96.6 166.174V97.8262C96.6 95.4021 97.9696 93.186 100.138 92.1019L136.138 74.1019C140.393 71.9742 145.4 75.0686 145.4 79.8262V148.174C145.4 150.598 144.03 152.814 141.862 153.898L105.862 171.898C101.607 174.026 96.6 170.931 96.6 166.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M104.6 170.174V101.826C104.6 99.4021 105.97 97.186 108.138 96.1019L144.138 78.1019C148.393 75.9742 153.4 79.0686 153.4 83.8262V152.174C153.4 154.598 152.03 156.814 149.862 157.898L113.862 175.898C109.607 178.026 104.6 174.931 104.6 170.174Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.8", d: "M5.4 106.826V175.174C5.4 180.823 11.3456 184.498 16.3988 181.971L52.3988 163.971C54.9736 162.684 56.6 160.052 56.6 157.174V88.8262C56.6 83.1765 50.6544 79.502 45.6012 82.0286L9.60117 100.029C7.02641 101.316 5.4 103.948 5.4 106.826Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.9", d: "M10 177.174V108.826C10 106.175 11.498 103.751 13.8695 102.565L49.8695 84.5652C54.5238 82.2381 60 85.6226 60 90.8262V159.174C60 161.825 58.502 164.249 56.1305 165.435L20.1305 183.435C15.4762 185.762 10 182.377 10 177.174Z", fill: "#F6F6F8", stroke: "#4E556D", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M13.4 110.826V179.174C13.4 184.823 19.3456 188.498 24.3988 185.971L60.3988 167.971C62.9736 166.684 64.6 164.052 64.6 161.174V92.8262C64.6 87.1765 58.6544 83.502 53.6012 86.0286L17.6012 104.029C15.0264 105.316 13.4 107.948 13.4 110.826Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M29.4 118.826V187.174C29.4 192.823 35.3456 196.498 40.3988 193.971L76.3988 175.971C78.9736 174.684 80.6 172.052 80.6 169.174V100.826C80.6 95.1765 74.6544 91.502 69.6012 94.0286L33.6012 112.029C31.0264 113.316 29.4 115.948 29.4 118.826Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" }),
    /* @__PURE__ */ jsx("path", { opacity: "0.2", d: "M33.4 120.826V189.174C33.4 194.823 39.3456 198.498 44.3988 195.971L80.3988 177.971C82.9736 176.684 84.6 174.052 84.6 171.174V102.826C84.6 97.1765 78.6544 93.502 73.6012 96.0286L37.6012 114.029C35.0264 115.316 33.4 117.948 33.4 120.826Z", fill: "white", stroke: "#515870", strokeWidth: "1.2" })
  ] }), $[0] = t0) : t0 = $[0], t0;
};
function CalendarPopover(t0) {
  const $ = c(14), {
    content
  } = t0, buttonRef = useRef(null), popoverRef = useRef(null), [isCalendarOpen, setIsCalendarOpen] = useState(!1), {
    t
  } = useTranslation(releasesLocaleNamespace);
  let t1, t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setIsCalendarOpen(!1), t2 = () => [buttonRef.current, popoverRef.current], $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]), useClickOutsideEvent(t1, t2);
  let t3;
  $[2] !== t ? (t3 = t("overview.calendar.tooltip"), $[2] = t, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setIsCalendarOpen(_temp$29), $[4] = t4) : t4 = $[4];
  let t5;
  $[5] !== isCalendarOpen ? (t5 = /* @__PURE__ */ jsx(Button$1, { name: "calendar", "data-as": "a", icon: CalendarIcon, mode: "bleed", padding: 2, radius: "full", selected: isCalendarOpen, onClick: t4, ref: buttonRef, space: 2 }), $[5] = isCalendarOpen, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== t3 || $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Tooltip, { content: t3, children: t5 }), $[7] = t3, $[8] = t5, $[9] = t6) : t6 = $[9];
  let t7;
  return $[10] !== content || $[11] !== isCalendarOpen || $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Popover, { content, placement: "bottom", open: isCalendarOpen, ref: popoverRef, children: t6 }), $[10] = content, $[11] = isCalendarOpen, $[12] = t6, $[13] = t7) : t7 = $[13], t7;
}
function _temp$29(prev) {
  return !prev;
}
const useTimezoneAdjustedDateTimeRange = () => {
  const $ = c(2), {
    zoneDateToUtc
  } = useTimeZone();
  let t0;
  return $[0] !== zoneDateToUtc ? (t0 = (date) => [startOfDay(date), endOfDay(date)].map(zoneDateToUtc), $[0] = zoneDateToUtc, $[1] = t0) : t0 = $[1], t0;
}, ReleaseCalendarFilterDay = (props2) => {
  const $ = c(12), {
    data: releases2
  } = useActiveReleases(), getTimezoneAdjustedDateTimeRange = useTimezoneAdjustedDateTimeRange(), {
    date
  } = props2;
  let t0;
  $[0] !== date || $[1] !== getTimezoneAdjustedDateTimeRange ? (t0 = getTimezoneAdjustedDateTimeRange(date), $[0] = date, $[1] = getTimezoneAdjustedDateTimeRange, $[2] = t0) : t0 = $[2];
  const [startOfDayForTimeZone, endOfDayForTimeZone] = t0;
  let t1;
  $[3] !== endOfDayForTimeZone || $[4] !== releases2 || $[5] !== startOfDayForTimeZone ? (t1 = releases2?.some((release) => {
    const releasePublishAt = release.publishAt || release.metadata.intendedPublishAt;
    if (!releasePublishAt)
      return !1;
    const publishDateUTC = new Date(releasePublishAt);
    return release.metadata.releaseType === "scheduled" && publishDateUTC >= startOfDayForTimeZone && publishDateUTC <= endOfDayForTimeZone;
  }), $[3] = endOfDayForTimeZone, $[4] = releases2, $[5] = startOfDayForTimeZone, $[6] = t1) : t1 = $[6];
  const dayHasReleases = t1;
  let t2;
  $[7] !== dayHasReleases ? (t2 = dayHasReleases ? {
    fontWeight: 700
  } : {}, $[7] = dayHasReleases, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== props2 || $[10] !== t2 ? (t3 = /* @__PURE__ */ jsx(CalendarDay$3, { ...props2, dateStyles: t2 }), $[9] = props2, $[10] = t2, $[11] = t3) : t3 = $[11], t3;
}, MotionButton$1 = motion.create(Button), DateFilterButton = (t0) => {
  const $ = c(8), {
    filterDate,
    onClear
  } = t0, [isExiting, setIsExiting] = useState(!1);
  let t1, t2;
  $[0] !== onClear ? (t2 = () => {
    setIsExiting(!1), onClear();
  }, $[0] = onClear, $[1] = t2) : t2 = $[1], t1 = t2;
  const handleOnExitComplete = t1;
  if (!filterDate)
    return null;
  let t3;
  $[2] !== filterDate || $[3] !== isExiting ? (t3 = !isExiting && /* @__PURE__ */ jsx(MotionButton$1, { "data-testid": "selected-date-filter", initial: {
    width: 0,
    opacity: 0
  }, animate: {
    width: "auto",
    opacity: 1
  }, exit: {
    width: 0,
    opacity: 0
  }, transition: {
    duration: 0.35,
    ease: "easeInOut"
  }, iconRight: CloseIcon, mode: "bleed", onClick: () => setIsExiting(!0), selected: !0, text: format$2(filterDate, "PPP") }), $[2] = filterDate, $[3] = isExiting, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== handleOnExitComplete || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(AnimatePresence, { onExitComplete: handleOnExitComplete, children: t3 }), $[5] = handleOnExitComplete, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
}, ReleaseMenuButtonWrapper = (t0) => {
  const $ = c(6), {
    release,
    documentsCount
  } = t0;
  let t1;
  $[0] !== release._id ? (t1 = getReleaseIdFromReleaseDocumentId(release._id), $[0] = release._id, $[1] = t1) : t1 = $[1];
  const {
    results: documents
  } = useBundleDocuments(t1);
  let t2;
  return $[2] !== documents || $[3] !== documentsCount || $[4] !== release ? (t2 = /* @__PURE__ */ jsx(ReleaseMenuButton, { release, documentsCount, documents }), $[2] = documents, $[3] = documentsCount, $[4] = release, $[5] = t2) : t2 = $[5], t2;
}, ReleaseDocumentsCounter = (t0) => {
  const $ = c(2), {
    documentCount
  } = t0, t1 = documentCount || "-";
  let t2;
  return $[0] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t1 }), $[0] = t1, $[1] = t2) : t2 = $[1], t2;
}, PREVIEW_SIZES = {
  block: {
    icon: 25,
    media: {
      width: 33,
      height: 33
    }
  },
  blockImage: {
    icon: 25,
    media: {
      width: 600,
      height: 400
    }
  },
  compact: {
    icon: 21,
    media: {
      width: 25,
      height: 25
    }
  },
  default: {
    icon: 21,
    media: {
      width: 33,
      height: 33
    }
  },
  detail: {
    icon: 25,
    media: {
      width: 73,
      height: 73
    }
  },
  inline: {
    icon: 15,
    media: {
      width: 15,
      height: 15
    }
  },
  media: {
    icon: 25,
    media: {
      width: 160,
      height: 160
    }
  }
}, RootFlex$7 = styled(Flex).attrs({
  align: "center"
})`
  height: ${rem(PREVIEW_SIZES.detail.media.height)};
`, StatusBox = styled(Box)`
  white-space: nowrap;
`, MediaSkeleton$1 = styled(Skeleton).attrs({
  animated: !0,
  radius: 2
})`
  width: ${rem(PREVIEW_SIZES.detail.media.width)};
  height: ${rem(PREVIEW_SIZES.detail.media.height)};
`, TitleSkeleton$3 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
})`
  max-width: ${rem(160)}; /* 80% of 200px */
  width: 80%;
`, SubtitleSkeleton$2 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
})`
  max-width: ${rem(120)}; /* 60% of 200px */
  width: 60%;
`, DescriptionSkeleton = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
})`
  max-width: ${rem(180)}; /* 90% of 200px */
  width: 90%;
`, DescriptionText = styled(Text$1)(({
  theme
}) => {
  const {
    fonts
  } = theme.sanity, textSize1 = fonts.text.sizes[1], maxLines = 2, maxHeight = textSize1.lineHeight * maxLines;
  return css`
    & > span {
      max-height: ${rem(maxHeight)};

      /* Multi-line text overflow */
      display: -webkit-box;
      overflow: hidden;
      overflow: clip;
      text-overflow: ellipsis;
      -webkit-line-clamp: ${maxLines};
      -webkit-box-orient: vertical;
    }
  `;
}), ReleaseNameCell = (t0) => {
  const $ = c(59), {
    cellProps,
    datum: release
  } = t0, router = useRouter(), {
    t
  } = useTranslation$1(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation$1(), {
    selectedReleaseId
  } = usePerspective(), setPerspective = useSetPerspective(), {
    state
  } = release;
  let t1;
  $[0] !== release._id || $[1] !== release.isLoading ? (t1 = release.isLoading ? "loading" : getReleaseIdFromReleaseDocumentId(release._id), $[0] = release._id, $[1] = release.isLoading, $[2] = t1) : t1 = $[2];
  const releaseId = t1, isArchived = state === "archived", isReleasePinned = releaseId === selectedReleaseId;
  let t2;
  $[3] !== isReleasePinned || $[4] !== releaseId || $[5] !== setPerspective ? (t2 = () => {
    setPerspective(isReleasePinned ? "drafts" : releaseId);
  }, $[3] = isReleasePinned, $[4] = releaseId, $[5] = setPerspective, $[6] = t2) : t2 = $[6];
  const handlePinRelease = t2;
  let t3;
  $[7] !== cellProps ? (t3 = (t42) => {
    const {
      children
    } = t42;
    return /* @__PURE__ */ jsx(Box, { ...cellProps, paddingLeft: 3, flex: 1, paddingY: 1, paddingRight: 2, sizing: "border", children });
  }, $[7] = cellProps, $[8] = t3) : t3 = $[8];
  const WrapperBox = t3;
  if (release.isLoading) {
    let t42;
    $[9] === Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(Skeleton, { animated: !0, radius: 1, style: PREVIEW_SIZES.default.media }),
      /* @__PURE__ */ jsx(TitleSkeleton$3, {})
    ] }), $[9] = t42) : t42 = $[9];
    let t52;
    return $[10] !== WrapperBox ? (t52 = /* @__PURE__ */ jsx(WrapperBox, { children: t42 }), $[10] = WrapperBox, $[11] = t52) : t52 = $[11], t52;
  }
  let t4;
  $[12] !== release.isDeleted || $[13] !== releaseId || $[14] !== router ? (t4 = release.isDeleted ? {
    tone: "transparent"
  } : {
    as: "a",
    onClick: () => router.navigate({
      releaseId
    }),
    tone: "inherit"
  }, $[12] = release.isDeleted, $[13] = releaseId, $[14] = router, $[15] = t4) : t4 = $[15];
  const cardProps = t4, pinButtonIcon = isReleasePinned ? PinFilledIcon : PinIcon;
  let t5;
  $[16] !== release.metadata.title || $[17] !== tCore ? (t5 = release.metadata.title || tCore("release.placeholder-untitled-release"), $[16] = release.metadata.title, $[17] = tCore, $[18] = t5) : t5 = $[18];
  const displayTitle = t5, t6 = !release.isDeleted;
  let t7;
  $[19] !== displayTitle ? (t7 = {
    title: displayTitle
  }, $[19] = displayTitle, $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== t || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "deleted-release", values: t7 }) }), $[21] = t, $[22] = t7, $[23] = t8) : t8 = $[23];
  const t9 = isArchived || release.state === "published";
  let t10;
  $[24] !== isReleasePinned || $[25] !== t ? (t10 = t(isReleasePinned ? "dashboard.details.unpin-release" : "dashboard.details.pin-release"), $[24] = isReleasePinned, $[25] = t, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== t10 || $[28] !== t9 ? (t11 = {
    disabled: t9,
    content: t10
  }, $[27] = t10, $[28] = t9, $[29] = t11) : t11 = $[29];
  const t12 = isArchived || release.state === "published", t13 = isReleasePinned ? `${t("dashboard.details.unpin-release")}: "${release.metadata.title}"` : `${t("dashboard.details.pin-release")}: "${release.metadata.title}"`;
  let t14;
  $[30] !== handlePinRelease || $[31] !== isReleasePinned || $[32] !== pinButtonIcon || $[33] !== t11 || $[34] !== t12 || $[35] !== t13 ? (t14 = /* @__PURE__ */ jsx(Button, { tooltipProps: t11, disabled: t12, icon: pinButtonIcon, mode: "bleed", "data-testid": "pin-release-button", onClick: handlePinRelease, radius: "full", selected: isReleasePinned, "aria-label": t13, "aria-live": "assertive" }), $[30] = handlePinRelease, $[31] = isReleasePinned, $[32] = pinButtonIcon, $[33] = t11, $[34] = t12, $[35] = t13, $[36] = t14) : t14 = $[36];
  let t15;
  $[37] !== release ? (t15 = getReleaseTone(release), $[37] = release, $[38] = t15) : t15 = $[38];
  let t16;
  $[39] !== t15 ? (t16 = /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(ReleaseAvatar, { tone: t15 }) }), $[39] = t15, $[40] = t16) : t16 = $[40];
  let t17;
  $[41] !== displayTitle ? (t17 = /* @__PURE__ */ jsx(Stack, { flex: 1, space: 2, children: /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: displayTitle }) }) }), $[41] = displayTitle, $[42] = t17) : t17 = $[42];
  let t18;
  $[43] !== t16 || $[44] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t16,
    t17
  ] }), $[43] = t16, $[44] = t17, $[45] = t18) : t18 = $[45];
  let t19;
  $[46] !== cardProps || $[47] !== t18 ? (t19 = /* @__PURE__ */ jsx(Card, { ...cardProps, padding: 2, radius: 2, flex: 1, children: t18 }), $[46] = cardProps, $[47] = t18, $[48] = t19) : t19 = $[48];
  let t20;
  $[49] !== t14 || $[50] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t14,
    t19
  ] }), $[49] = t14, $[50] = t19, $[51] = t20) : t20 = $[51];
  let t21;
  $[52] !== t20 || $[53] !== t6 || $[54] !== t8 ? (t21 = /* @__PURE__ */ jsx(Tooltip, { disabled: t6, content: t8, children: t20 }), $[52] = t20, $[53] = t6, $[54] = t8, $[55] = t21) : t21 = $[55];
  let t22;
  return $[56] !== WrapperBox || $[57] !== t21 ? (t22 = /* @__PURE__ */ jsx(WrapperBox, { children: t21 }), $[56] = WrapperBox, $[57] = t21, $[58] = t22) : t22 = $[58], t22;
}, enableColumnFormMode = (currentMode) => (column, expectedMode) => {
  if (!currentMode) throw new Error("currentMode is required");
  if (expectedMode === "all" || expectedMode === currentMode)
    return column;
}, releasesOverviewColumnDefs = (t, releaseGroupMode) => {
  const checkColumnMode = enableColumnFormMode(releaseGroupMode);
  return [
    checkColumnMode({
      id: "metadata.title",
      sorting: !0,
      width: null,
      style: {
        minWidth: "50%",
        maxWidth: "50%"
      },
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, flex: 1, paddingLeft: 6, width: 3, paddingRight: 2, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { ...props2, text: t("table-header.title") }) }),
      cell: ReleaseNameCell
    }, "all"),
    checkColumnMode({
      id: "publishAt",
      sorting: !0,
      sortTransform: (release) => {
        if (release.metadata.releaseType === "undecided") return 1 / 0;
        const publishDate = getPublishDateFromRelease(release);
        return release.metadata.releaseType === "asap" || !publishDate ? 0 : new Date(publishDate).getTime();
      },
      width: 250,
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.time"), ...props2 }) }),
      cell: ({
        cellProps,
        datum: release
      }) => release.isLoading ? null : /* @__PURE__ */ jsxs(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, gap: 2, sizing: "border", children: [
        /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ReleaseTime, { release }) }),
        isReleaseScheduledOrScheduling(release) && /* @__PURE__ */ jsx(Text$1, { size: 1, "data-testid": "release-lock-icon", children: /* @__PURE__ */ jsx(LockIcon, {}) })
      ] })
    }, "active"),
    // This is a hidden column only used for sorting when
    // no other sort column is selected (the default state)
    checkColumnMode({
      id: "lastActivity",
      hidden: !0,
      sorting: !0,
      width: 100,
      sortTransform: ({
        publishedAt,
        _updatedAt
      }) => {
        const lastActivity = publishedAt ?? _updatedAt;
        return lastActivity ? new Date(lastActivity).getTime() : -1 / 0;
      }
    }, "archived"),
    checkColumnMode({
      id: "publishedAt",
      sorting: !0,
      sortTransform: (release, direction) => release.state !== "published" ? direction === "asc" ? 1 / 0 : -1 / 0 : release.publishedAt ? new Date(release.publishedAt).getTime() : release._updatedAt,
      width: 250,
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.publishedAt"), ...props2 }) }),
      cell: ({
        cellProps,
        datum: release
      }) => /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, gap: 2, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: release.publishedAt ? (
        // Assuming releases are not updated after archiving.
        // If we realize this is miss leading for customers and they have edited the release after archiving
        // we can use the history endpoint to get the archived change.
        /* @__PURE__ */ jsx(RelativeTime, { time: release.publishedAt, useTemporalPhrase: !0, minimal: !0 })
      ) : "-" }) })
    }, "archived"),
    checkColumnMode({
      id: "_updatedAt",
      sorting: !0,
      sortTransform: (release, direction) => release.state !== "archived" ? direction === "asc" ? 1 / 0 : -1 / 0 : new Date(release._updatedAt).getTime(),
      width: 250,
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.archivedAt"), ...props2 }) }),
      cell: ({
        cellProps,
        datum: release
      }) => /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, gap: 2, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: release.state === "archived" ? (
        // Assuming releases are not updated after archiving.
        // If we later realize this is miss leading for customers and they have edited the release after archiving
        // we can use the history endpoint to get the archived change.
        /* @__PURE__ */ jsx(RelativeTime, { time: release._updatedAt, useTemporalPhrase: !0, minimal: !0 })
      ) : "-" }) })
    }, "archived"),
    checkColumnMode({
      id: "documentsMetadata.updatedAt",
      sorting: !0,
      width: 150,
      header: (props2) => /* @__PURE__ */ jsx(Flex, { ...props2.headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.SortHeaderButton, { text: t("table-header.edited"), ...props2 }) }),
      cell: ({
        datum: {
          documentsMetadata,
          _updatedAt
        },
        cellProps
      }) => {
        const updatedAtDate = documentsMetadata?.updatedAt ?? _updatedAt;
        return /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", gap: 2, paddingX: 2, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: updatedAtDate ? /* @__PURE__ */ jsx(RelativeTime, { time: updatedAtDate, useTemporalPhrase: !0, minimal: !0 }) : "-" }) });
      }
    }, "active"),
    checkColumnMode({
      id: "error",
      sorting: !1,
      width: 40,
      header: () => /* @__PURE__ */ jsx(Fragment$1, {}),
      cell: ({
        datum: {
          error,
          state
        },
        cellProps
      }) => /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, sizing: "border", "data-testid": "error-indicator", children: typeof error < "u" && state === "active" && /* @__PURE__ */ jsx(Tooltip, { content: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("failed-publish-title") }), portal: !0, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }) }) })
    }, "all"),
    checkColumnMode({
      id: "documentCount",
      sorting: !1,
      width: 120,
      header: ({
        headerProps
      }) => /* @__PURE__ */ jsx(Flex, { ...headerProps, paddingY: 3, sizing: "border", children: /* @__PURE__ */ jsx(Headers.BasicHeader, { text: t("table-header.documents") }) }),
      cell: ({
        datum: {
          isDeleted,
          state,
          finalDocumentStates,
          documentsMetadata
        },
        cellProps
      }) => /* @__PURE__ */ jsx(Flex, { ...cellProps, align: "center", paddingX: 2, paddingY: 3, sizing: "border", children: !isDeleted && /* @__PURE__ */ jsx(ReleaseDocumentsCounter, { documentCount: state === "archived" || state === "published" ? finalDocumentStates?.length : documentsMetadata?.documentCount }) })
    }, "all")
  ].filter(Boolean);
}, MotionButton = motion.create(Button), DATE_SEARCH_PARAM_VALUE_FORMAT = "yyyy-MM-dd", DEFAULT_RELEASES_OVERVIEW_SORT = {
  column: "publishAt",
  direction: "asc"
}, DEFAULT_ARCHIVED_RELEASES_OVERVIEW_SORT = {
  column: "lastActivity",
  direction: "desc"
};
function ReleasesOverview() {
  const {
    data: releases2,
    loading: loadingReleases
  } = useActiveReleases(), {
    data: archivedReleases
  } = useArchivedReleases(), {
    guardWithReleaseLimitUpsell,
    mode
  } = useReleasesUpsell(), router = useRouter(), [releaseGroupMode, setReleaseGroupMode] = useState(getInitialReleaseGroupMode(router)), [releaseFilterDate, setReleaseFilterDate] = useState(getInitialFilterDate(router)), [isCreateReleaseDialogOpen, setIsCreateReleaseDialogOpen] = useState(!1), releaseIds = useMemo(() => releases2.map((release) => release._id), [releases2]), {
    data: releasesMetadata,
    loading: loadingReleasesMetadata
  } = useReleasesMetadata(releaseIds), loading = loadingReleases || loadingReleasesMetadata && !releasesMetadata, loadingTableData = loading || !releasesMetadata && !!releaseIds.length, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    timeZone,
    utcToCurrentZoneDate
  } = useTimeZone(), {
    selectedPerspective
  } = usePerspective(), {
    DialogTimeZone: DialogTimeZone2,
    dialogProps,
    dialogTimeZoneShow
  } = useDialogTimeZone(), getTimezoneAdjustedDateTimeRange = useTimezoneAdjustedDateTimeRange(), {
    createRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasCreatePermission, setHasCreatePermission] = useState(null), [isPendingGuardResponse, setIsPendingGuardResponse] = useState(!1), mediaIndex = useMediaIndex(), getRowProps = useCallback((datum) => datum.isDeleted ? {
    tone: "transparent"
  } : {
    tone: isReleaseDocument(selectedPerspective) && selectedPerspective._id === datum._id ? getReleaseTone(datum) : "default"
  }, [selectedPerspective]), scrollContainerRef = useRef(null), hasReleases = releases2.length > 0 || archivedReleases.length > 0, loadingOrHasReleases = loading || hasReleases, hasNoReleases = !loading && !hasReleases, tableReleases = useMemo(() => !hasReleases || !releasesMetadata ? [] : [...releases2.map((release_0) => ({
    ...release_0,
    publishAt: release_0.publishAt || release_0.metadata.intendedPublishAt,
    documentsMetadata: releasesMetadata[release_0._id] || {}
  }))], [hasReleases, releasesMetadata, releases2]), isMounted = useRef(!1);
  useEffect(() => (isMounted.current = !0, checkWithPermissionGuard(createRelease, getReleaseDefaults()).then((hasPermissions) => {
    isMounted.current && setHasCreatePermission(hasPermissions);
  }), () => {
    isMounted.current = !1;
  }), [checkWithPermissionGuard, createRelease]), useEffect(() => {
    releaseGroupMode === "archived" && !loadingReleases && !archivedReleases.length && setReleaseGroupMode("active");
  }, [releaseGroupMode, archivedReleases.length, loadingReleases]);
  const handleReleaseGroupModeChange = useCallback(({
    currentTarget: {
      value: groupMode
    }
  }) => {
    setReleaseGroupMode(groupMode);
  }, []), handleSelectFilterDate = useCallback((date) => setReleaseFilterDate((prevFilterDate) => {
    if (!date) return;
    const timeZoneAdjustedDate = utcToCurrentZoneDate(date);
    return prevFilterDate && isSameDay(prevFilterDate, timeZoneAdjustedDate) ? void 0 : timeZoneAdjustedDate;
  }), [utcToCurrentZoneDate]), clearFilterDate = useCallback(() => {
    setReleaseFilterDate(void 0), setReleaseGroupMode("active");
  }, []);
  useEffect(() => {
    const getSearchParams = () => releaseFilterDate ? [[DATE_SEARCH_PARAM_KEY, format$2(releaseFilterDate, DATE_SEARCH_PARAM_VALUE_FORMAT)]] : releaseGroupMode ? [[GROUP_SEARCH_PARAM_KEY, releaseGroupMode]] : [];
    router.navigate({
      _searchParams: getSearchParams()
    });
  }, [releaseFilterDate, releaseGroupMode, router]);
  const [hasMounted, setHasMounted] = useState(!1);
  useEffect(() => {
    setHasMounted(!0);
  }, []);
  const showCalendar = mediaIndex > 2, currentArchivedPicker = useMemo(() => {
    const groupModeButtonBaseProps = {
      disabled: loading || !hasReleases,
      mode: "bleed",
      padding: 2,
      ...hasMounted ? {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        transition: {
          duration: 0.4,
          ease: "easeInOut"
        }
      } : {}
    };
    return /* @__PURE__ */ jsxs(AnimatePresence, { children: [
      /* @__PURE__ */ createElement(MotionButton, { ...groupModeButtonBaseProps, key: "open-group", onClick: handleReleaseGroupModeChange, selected: releaseGroupMode === "active", text: t("action.open"), value: "active" }),
      /* @__PURE__ */ jsx(Tooltip, { disabled: archivedReleases.length !== 0, content: t("no-archived-release"), placement: "bottom", children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ createElement(MotionButton, { ...groupModeButtonBaseProps, key: "archived-group", disabled: groupModeButtonBaseProps.disabled || !archivedReleases.length, onClick: handleReleaseGroupModeChange, selected: releaseGroupMode === "archived", text: t("action.archived"), value: "archived" }) }) })
    ] });
  }, [loading, hasReleases, hasMounted, handleReleaseGroupModeChange, releaseGroupMode, t, archivedReleases.length]), handleOnClickCreateRelease = useCallback(async () => {
    setIsPendingGuardResponse(!0), await guardWithReleaseLimitUpsell(() => {
      setIsCreateReleaseDialogOpen(!0);
    }), setIsPendingGuardResponse(!1);
  }, [guardWithReleaseLimitUpsell]), createReleaseButton = useMemo(() => /* @__PURE__ */ jsx(Button, { icon: AddIcon, disabled: isPendingGuardResponse || !hasCreatePermission || isCreateReleaseDialogOpen || mode === "disabled", onClick: handleOnClickCreateRelease, text: tCore("release.action.create-new"), tooltipProps: {
    disabled: hasCreatePermission === !0,
    content: tCore("release.action.permission.error")
  } }), [isPendingGuardResponse, hasCreatePermission, isCreateReleaseDialogOpen, mode, handleOnClickCreateRelease, tCore]), handleOnCreateRelease = useCallback((createdReleaseId) => {
    setIsCreateReleaseDialogOpen(!1), router.navigate({
      releaseId: createdReleaseId
    }, {
      stickyParams: {
        excludedPerspectives: null,
        perspective: createdReleaseId
      }
    });
  }, [router]), renderCreateReleaseDialog = () => isCreateReleaseDialogOpen ? /* @__PURE__ */ jsx(CreateReleaseDialog, { onCancel: () => setIsCreateReleaseDialogOpen(!1), onSubmit: handleOnCreateRelease, origin: "release-plugin" }) : null, renderRowActions = useCallback(({
    datum: datum_0
  }) => {
    const release_1 = datum_0;
    if (release_1.isDeleted || release_1.isLoading) return null;
    const documentsCount = (releaseGroupMode === "active" ? release_1.documentsMetadata?.documentCount : release_1.finalDocumentStates?.length) ?? 0;
    return /* @__PURE__ */ jsx(ReleaseMenuButtonWrapper, { release: release_1, documentsCount });
  }, [releaseGroupMode]), filteredReleases = useMemo(() => {
    if (!releaseFilterDate) return releaseGroupMode === "active" ? tableReleases : archivedReleases;
    const [startOfDayForTimeZone, endOfDayForTimeZone] = getTimezoneAdjustedDateTimeRange(releaseFilterDate);
    return tableReleases.filter((release_2) => {
      if (!release_2.publishAt || release_2.metadata.releaseType !== "scheduled") return !1;
      const publishDateUTC = new Date(release_2.publishAt);
      return publishDateUTC >= startOfDayForTimeZone && publishDateUTC <= endOfDayForTimeZone;
    });
  }, [releaseFilterDate, releaseGroupMode, tableReleases, archivedReleases, getTimezoneAdjustedDateTimeRange]), renderCalendarFilter = useMemo(() => /* @__PURE__ */ jsx(Flex, { flex: "none", children: /* @__PURE__ */ jsx(Card, { borderRight: !0, flex: "none", disabled: !0, children: /* @__PURE__ */ jsx(CalendarFilter, { disabled: loading || releases2.length === 0, renderCalendarDay: ReleaseCalendarFilterDay, selectedDate: releaseFilterDate, onSelect: handleSelectFilterDate }) }) }), [loading, releases2, releaseFilterDate, handleSelectFilterDate]), tableColumns = useMemo(() => releasesOverviewColumnDefs(t, releaseGroupMode), [releaseGroupMode, t]);
  return /* @__PURE__ */ jsxs(Flex, { direction: "row", flex: 1, style: {
    height: "100%"
  }, children: [
    /* @__PURE__ */ jsxs(Flex, { flex: 1, children: [
      showCalendar && renderCalendarFilter,
      hasNoReleases ? /* @__PURE__ */ jsx(() => /* @__PURE__ */ jsx(Flex, { direction: "column", flex: 1, justify: hasNoReleases ? "center" : "flex-start", align: hasNoReleases ? "center" : "flex-start", style: {
        position: "relative"
      }, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, direction: "column", style: {
        maxWidth: "300px"
      }, children: [
        /* @__PURE__ */ jsx(ReleaseIllustration, {}),
        /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "semibold", "data-testid": "no-releases-info-text", children: t("overview.title") }),
        /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("overview.description") }),
        /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
          createReleaseButton,
          /* @__PURE__ */ jsx(Button, { as: "a", href: "https://www.sanity.io/docs/content-releases", target: "_blank", mode: "ghost", onClick: handleOnClickCreateRelease, text: t("overview.action.documentation") })
        ] })
      ] }) }), {}) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, style: {
        position: "relative"
      }, children: [
        /* @__PURE__ */ jsx(Card, { flex: "none", padding: 3, children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 3, children: [
          /* @__PURE__ */ jsxs(Inline, { children: [
            !showCalendar && /* @__PURE__ */ jsx(CalendarPopover, { content: renderCalendarFilter }),
            /* @__PURE__ */ jsx(Stack, { padding: 2, space: 4, children: /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "semibold", children: t("overview.title") }) })
          ] }),
          /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, children: loadingOrHasReleases && (releaseFilterDate ? /* @__PURE__ */ jsx(DateFilterButton, { filterDate: releaseFilterDate, onClear: clearFilterDate }) : currentArchivedPicker) }),
          /* @__PURE__ */ jsxs(Flex, { flex: "none", gap: 2, children: [
            /* @__PURE__ */ jsx(Button, { icon: EarthGlobeIcon, iconRight: ChevronDownIcon, mode: "bleed", text: `${timeZone.abbreviation} (${timeZone.namePretty})`, onClick: dialogTimeZoneShow }),
            DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps }),
            loadingOrHasReleases && createReleaseButton
          ] })
        ] }) }),
        /* @__PURE__ */ jsx(Box, { ref: scrollContainerRef, marginTop: 3, overflow: "auto", children: (loading || hasReleases) && /* @__PURE__ */ jsx(
          Table,
          {
            defaultSort: releaseGroupMode === "archived" ? DEFAULT_ARCHIVED_RELEASES_OVERVIEW_SORT : DEFAULT_RELEASES_OVERVIEW_SORT,
            loading: loadingTableData,
            data: filteredReleases,
            columnDefs: tableColumns,
            emptyState: t("no-releases"),
            rowId: "_id",
            rowActions: renderRowActions,
            rowProps: getRowProps,
            scrollContainerRef,
            hideTableInlinePadding: !0
          },
          releaseFilterDate ? "by_date" : releaseGroupMode
        ) })
      ] }) })
    ] }),
    renderCreateReleaseDialog()
  ] });
}
function ReleasesTool() {
  const $ = c(3), router = useRouter(), {
    releaseId
  } = router.state;
  if (releaseId) {
    let t02;
    return $[0] !== releaseId ? (t02 = /* @__PURE__ */ jsx(ReleaseDetail, {}, releaseId), $[0] = releaseId, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(ReleasesOverview, {}), $[2] = t0) : t0 = $[2], t0;
}
const EMPTY_ARRAY$w = [];
function InsufficientPermissionsMessage(t0) {
  const $ = c(21), {
    currentUser,
    context
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    style: "short",
    type: "unit"
  }, $[0] = t1) : t1 = $[0];
  const list = useListFormat(t1), roles = currentUser?.roles || EMPTY_ARRAY$w;
  let t2;
  $[1] !== list || $[2] !== roles ? (t2 = () => /* @__PURE__ */ jsx(Fragment, { children: list.formatToParts(roles.map(_temp$28)).map(_temp2$N) }), $[1] = list, $[2] = roles, $[3] = t2) : t2 = $[3];
  const Roles = t2;
  let t3;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: /* @__PURE__ */ jsx(AccessDeniedIcon, {}) }), $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("insufficient-permissions-message.title"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    t3,
    /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t4 })
  ] }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== context || $[10] !== t ? (t6 = /* @__PURE__ */ jsx(Inline, { marginTop: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "insufficient-permissions-message.not-authorized-explanation", t, context }) }) }), $[9] = context, $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== Roles ? (t7 = {
    Roles
  }, $[12] = Roles, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Inline, { marginTop: 4, marginBottom: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "insufficient-permissions-message.roles", t, components: t7 }) }) }), $[14] = t, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t5 || $[18] !== t6 || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Box, { children: [
    t5,
    t6,
    t8
  ] }), $[17] = t5, $[18] = t6, $[19] = t8, $[20] = t9) : t9 = $[20], t9;
}
function _temp2$N(i, index) {
  return i.type === "element" ? /* @__PURE__ */ jsx("code", { children: i.value }, `${i.value}-${index}`) : /* @__PURE__ */ jsx(Fragment$1, { children: i.value }, `${i.value}-${index}`);
}
function _temp$28(role) {
  return role.title || startCase(role.name);
}
const DiscardVersionAction = (props2) => {
  const {
    id: id2,
    type,
    release,
    version
  } = props2, currentUser = useCurrentUser(), {
    t
  } = useTranslation$1(), {
    selectedPerspective
  } = usePerspective(), [permissions, isPermissionsLoading] = useDocumentPairPermissions({
    id: id2,
    type,
    version: release,
    permission: "discardVersion"
  }), [dialogOpen, setDialogOpen] = useState(!1), handleDialogOpen = useCallback(() => {
    setDialogOpen(!0);
  }, []);
  return version ? !isPermissionsLoading && !permissions?.granted ? {
    disabled: !0,
    icon: TrashIcon,
    label: "no permissions",
    title: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "discard-changes" })
  } : {
    disabled: isPermissionsLoading || !permissions?.granted,
    dialog: dialogOpen && {
      type: "custom",
      component: /* @__PURE__ */ jsx(DiscardVersionDialog, { documentId: version._id, documentType: type, onClose: () => setDialogOpen(!1), fromPerspective: selectedPerspective })
    },
    label: t("release.action.discard-version"),
    icon: TrashIcon,
    onHandle: handleDialogOpen,
    title: t("release.action.discard-version")
  } : null;
}, UnpublishVersionAction = (props2) => {
  const {
    id: id2,
    type,
    release,
    published,
    version
  } = props2, currentUser = useCurrentUser(), isPublished = published !== null, {
    t
  } = useTranslation$1(releasesLocaleNamespace), isAlreadyUnpublished = version ? isGoingToUnpublish(version) : !1, [permissions, isPermissionsLoading] = useDocumentPairPermissions({
    id: id2,
    type,
    version: release,
    permission: "unpublish"
  }), [dialogOpen, setDialogOpen] = useState(!1), handleDialogOpen = useCallback(() => {
    setDialogOpen(!0);
  }, []);
  return version ? !isPermissionsLoading && !permissions?.granted ? {
    disabled: !0,
    icon: TrashIcon,
    label: "no permissions",
    title: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { context: "unpublish-document", currentUser })
  } : {
    dialog: dialogOpen && {
      type: "custom",
      component: /* @__PURE__ */ jsx(UnpublishVersionDialog, { documentVersionId: version._id, documentType: type, onClose: () => setDialogOpen(!1) })
    },
    /** @todo should be switched once we have the document actions updated */
    label: t("action.unpublish-doc-actions"),
    icon: UnpublishIcon,
    onHandle: handleDialogOpen,
    disabled: !isPublished || isAlreadyUnpublished,
    /** @todo should be switched once we have the document actions updated */
    title: t("action.unpublish-doc-actions")
  } : null;
};
function resolveDocumentActions$1(existingActions, context) {
  const duplicateAction = existingActions.filter(({
    action
  }) => action === "duplicate");
  return context.versionType === "version" ? duplicateAction.concat(DiscardVersionAction, UnpublishVersionAction) : existingActions;
}
const TEMPLATE_OPTIONS$3 = {
  interpolate: /{{([\s\S]+?)}}/g
}, TRANSFORMATIONS = {
  inlineIcon: (child, idx, block) => {
    if (!isPortableTextTextBlock(block)) return block;
    const hasTextLeft = !!(block.children[idx - 1]?._type === "span" && block.children[idx - 1]?.text), hasTextRight = !!(block.children[idx + 1]?._type === "span" && block.children[idx + 1]?.text);
    return {
      ...child,
      hasTextRight,
      hasTextLeft
    };
  }
}, transformBlocks = (blocks) => blocks.map((block) => {
  if (isPortableTextTextBlock(block) && block._type === "block") {
    const children = block.children.map((child, idx) => TRANSFORMATIONS[child._type] ? TRANSFORMATIONS[child._type](child, idx, block) : child);
    return {
      ...block,
      children
    };
  }
  return block;
}), Divider$2 = styled(Box)`
  height: 1px;
  background: var(--card-border-color);
  width: 100%;
`, SerializerContainer = styled.div`
  // Remove margin top of first element
  > div:first-child {
    margin-top: 0;
  }
  // Remove margin bottom to last box.
  > [data-ui='Box']:last-child {
    margin-bottom: 0;
  }
`, IconTextContainer = styled(Text$1)((props2) => props2.accent ? `
    --card-icon-color: var(--card-accent-fg-color);
    ` : ""), AccentSpan = styled.span`
  color: var(--card-accent-fg-color);
  --card-icon-color: var(--card-accent-fg-color);
`, SemiboldSpan = styled.span(({
  theme
}) => {
  const {
    weights
  } = theme.sanity.fonts.text;
  return css`
    font-weight: ${weights.semibold};
  `;
}), InlineIcon = styled(Icon)`
  &[data-sanity-icon] {
    /* Forces the icon to leave the necessary space to the right or left it has surrounding text */
    margin-left: ${(props2) => props2.$hasTextLeft ? "0" : ""};
    margin-right: ${(props2) => props2.$hasTextRight ? "0" : ""};
  }
`, Link$2 = styled.a`
  font-weight: 600;
  color: ${(props2) => props2.$useTextColor ? "var(--card-muted-fg-color) !important" : ""};
`, DynamicIconContainer = styled.span`
  display: ${({
  $inline
}) => $inline ? "inline-block" : "inline"};
  font-size: calc(21 / 16 * 1rem) !important;
  min-width: calc(21 / 16 * 1rem - 0.375rem);
  line-height: 0;
  > svg {
    height: 1em;
    width: 1em;
    display: inline;
    font-size: 1em !important;
    margin: -0.375rem !important;
    *[stroke] {
      stroke: currentColor;
    }
  }
`, accentSpanWrapper = (children) => /* @__PURE__ */ jsx(AccentSpan, { children }), DynamicIcon = (props2) => {
  const $ = c(8), [__html, setHtml] = useState("");
  let t0, t1;
  $[0] !== props2.icon.url ? (t0 = () => {
    const controller = new AbortController(), signal = controller.signal;
    return fetch(props2.icon.url, {
      signal
    }).then(_temp$27).then((data) => setHtml(data)).catch(_temp2$M), () => {
      controller.abort();
    };
  }, t1 = [props2.icon.url], $[0] = props2.icon.url, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  const t2 = !!props2.inline;
  let t3;
  $[3] !== __html ? (t3 = {
    __html
  }, $[3] = __html, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(DynamicIconContainer, { $inline: t2, dangerouslySetInnerHTML: t3 }), $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
};
function NormalBlock$1(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginBottom: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children }) }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
function H2Block(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginY: 4, children: /* @__PURE__ */ jsx(Heading, { size: 2, as: "h2", children }) }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
function H3Block(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginY: 4, children: /* @__PURE__ */ jsx(Heading, { size: 1, as: "h3", children }) }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
const Image$8 = styled.img((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    object-fit: cover;
    width: 100%;
    border-radius: ${theme.radius[3]}px;
  `;
});
function ImageBlock(props2) {
  const $ = c(2), t0 = props2.value.image?.url;
  let t1;
  return $[0] !== t0 ? (t1 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginY: 4, children: /* @__PURE__ */ jsx(Image$8, { src: t0 }) }), $[0] = t0, $[1] = t1) : t1 = $[1], t1;
}
const interpolateChildrenText = (interpolation) => (children) => !children || !interpolation ? children : (Array.isArray(children) ? children : [children]).map((child) => typeof child == "string" ? template(child, TEMPLATE_OPTIONS$3)(interpolation) : child), createComponents = ({
  onLinkClick,
  interpolation
}) => {
  const interpolateChildren = interpolateChildrenText(interpolation);
  return {
    block: {
      normal: ({
        children
      }) => /* @__PURE__ */ jsx(NormalBlock$1, { children: interpolateChildren(children) }),
      h2: ({
        children
      }) => /* @__PURE__ */ jsx(H2Block, { children: interpolateChildren(children) }),
      h3: ({
        children
      }) => /* @__PURE__ */ jsx(H3Block, { children: interpolateChildren(children) })
    },
    list: {
      bullet: ({
        children
      }) => /* @__PURE__ */ jsx("ul", { children: interpolateChildren(children) }),
      number: ({
        children
      }) => /* @__PURE__ */ jsx("ol", { children: interpolateChildren(children) }),
      checkmarks: ({
        children
      }) => /* @__PURE__ */ jsx(Fragment, { children: interpolateChildren(children) })
    },
    listItem: {
      bullet: ({
        children
      }) => /* @__PURE__ */ jsx(Text$1, { as: "li", size: 1, muted: !0, style: {
        display: "list-item",
        padding: "0.5rem 0"
      }, children: interpolateChildren(children) }),
      number: ({
        children
      }) => /* @__PURE__ */ jsx(Text$1, { as: "li", size: 1, muted: !0, style: {
        display: "list-item",
        padding: "0.5rem 0"
      }, children: interpolateChildren(children) }),
      checkmarks: ({
        children
      }) => /* @__PURE__ */ jsx(Text$1, { children })
    },
    marks: {
      strong: ({
        children
      }) => /* @__PURE__ */ jsx("strong", { children: interpolateChildren(children) }),
      semibold: ({
        children
      }) => /* @__PURE__ */ jsx(SemiboldSpan, { children: interpolateChildren(children) }),
      link: (props2) => /* @__PURE__ */ jsxs(
        Link$2,
        {
          href: props2.value.href,
          rel: "noopener noreferrer",
          target: "_blank",
          $useTextColor: props2.value.useTextColor,
          onClick: onLinkClick ? () => onLinkClick({
            url: props2.value.href,
            linkTitle: props2.text
          }) : void 0,
          children: [
            props2.children,
            props2.value.showIcon && /* @__PURE__ */ jsx(LinkIcon, { style: {
              marginLeft: "2px"
            } })
          ]
        }
      ),
      accent: ({
        children
      }) => /* @__PURE__ */ jsx(AccentSpan, { children: interpolateChildren(children) })
    },
    types: {
      inlineIcon: (props2) => /* @__PURE__ */ jsx(ConditionalWrapper, { condition: props2.value.accent, wrapper: accentSpanWrapper, children: props2.value.sanityIcon ? /* @__PURE__ */ jsx(InlineIcon, { symbol: props2.value.sanityIcon, $hasTextLeft: props2.value.hasTextLeft, $hasTextRight: props2.value.hasTextRight }) : /* @__PURE__ */ jsx(Fragment, { children: props2.value.icon?.url && /* @__PURE__ */ jsx(DynamicIcon, { icon: props2.value.icon, inline: !0 }) }) }),
      divider: () => /* @__PURE__ */ jsx(Box, { marginY: 3, children: /* @__PURE__ */ jsx(Box, { paddingY: 3, children: /* @__PURE__ */ jsx(Divider$2, {}) }) }),
      iconAndText: (props2) => /* @__PURE__ */ jsxs(Flex, { align: "flex-start", paddingX: 2, paddingTop: 1, paddingBottom: 2, marginTop: 2, gap: 2, children: [
        /* @__PURE__ */ jsxs(Flex, { gap: 2, style: {
          flexShrink: 0
        }, children: [
          /* @__PURE__ */ jsx(IconTextContainer, { size: 1, accent: props2.value.accent, children: props2.value.sanityIcon ? /* @__PURE__ */ jsx(Icon, { symbol: props2.value.sanityIcon }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            props2.value.icon?.url && /* @__PURE__ */ jsx(DynamicIcon, { icon: props2.value.icon }),
            " "
          ] }) }),
          /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", accent: props2.value.accent, children: interpolateChildren(props2.value.title) })
        ] }),
        /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, accent: props2.value.accent, children: interpolateChildren(props2.value.text) })
      ] }),
      imageBlock: (props2) => /* @__PURE__ */ jsx(ImageBlock, { ...props2 })
    }
  };
};
function UpsellDescriptionSerializer(props2) {
  const $ = c(8), {
    blocks,
    onLinkClick,
    interpolation
  } = props2;
  let t0, t1;
  $[0] !== blocks ? (t1 = transformBlocks(blocks), $[0] = blocks, $[1] = t1) : t1 = $[1], t0 = t1;
  const value = t0;
  let t2, t3;
  $[2] !== interpolation || $[3] !== onLinkClick ? (t3 = createComponents({
    onLinkClick,
    interpolation
  }), $[2] = interpolation, $[3] = onLinkClick, $[4] = t3) : t3 = $[4], t2 = t3;
  const components2 = t2;
  let t4;
  return $[5] !== components2 || $[6] !== value ? (t4 = /* @__PURE__ */ jsx(Card, { tone: "default", children: /* @__PURE__ */ jsx(SerializerContainer, { children: /* @__PURE__ */ jsx(PortableText$1, { value, components: components2, onMissingComponent: !1 }) }) }), $[5] = components2, $[6] = value, $[7] = t4) : t4 = $[7], t4;
}
function _temp$27(response) {
  if (!response.ok)
    throw new Error(`HTTP error! status: ${response.status}`);
  return response.text();
}
function _temp2$M(error) {
  error.name !== "AbortError" && console.error(error);
}
const StyledButton$4 = styled(Button)(({
  theme
}) => {
  const {
    space
  } = getTheme_v2(theme);
  return `
      position: absolute;
      top: ${space[3]}px;
      right: ${space[3]}px;
      z-index: 20;
      background: transparent;
      border-radius: 9999px;
      box-shadow: none;
      color: ${white.hex};
      --card-fg-color: ${white.hex};
      :hover {
        --card-fg-color: ${white.hex};
      }
    `;
}), Image$7 = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  height: 200px;
`;
function UpsellDialog(props2) {
  const $ = c(25), {
    data,
    onClose,
    onPrimaryClick,
    onSecondaryClick,
    interpolation
  } = props2;
  let t0;
  $[0] !== data.secondaryButton || $[1] !== onSecondaryClick ? (t0 = data.secondaryButton?.text ? {
    text: data.secondaryButton.text,
    mode: "bleed",
    tone: "default",
    iconRight: LaunchIcon,
    ...data.secondaryButton.url && {
      target: "_blank",
      rel: "noopener noreferrer",
      as: "a",
      href: data.secondaryButton.url
    },
    onClick: onSecondaryClick
  } : void 0, $[0] = data.secondaryButton, $[1] = onSecondaryClick, $[2] = t0) : t0 = $[2];
  const t1 = data.ctaButton?.text;
  let t2;
  $[3] !== data.ctaButton.url ? (t2 = data.ctaButton.url && {
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a",
    href: data.ctaButton.url
  }, $[3] = data.ctaButton.url, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== onPrimaryClick || $[6] !== t1 || $[7] !== t2 ? (t3 = {
    text: t1,
    mode: "default",
    tone: "primary",
    ...t2,
    onClick: onPrimaryClick
  }, $[5] = onPrimaryClick, $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t0 || $[10] !== t3 ? (t4 = {
    cancelButton: t0,
    confirmButton: t3
  }, $[9] = t0, $[10] = t3, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== onClose ? (t5 = /* @__PURE__ */ jsx(StyledButton$4, { icon: CloseIcon, mode: "bleed", tone: "default", onClick: onClose, tabIndex: -1, tooltipProps: null }), $[12] = onClose, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== data.image ? (t6 = data.image && /* @__PURE__ */ jsx(Image$7, { src: data.image.asset.url, alt: data.image.asset.altText ?? "" }), $[14] = data.image, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== data.descriptionText || $[17] !== interpolation ? (t7 = /* @__PURE__ */ jsx(Box, { padding: 3, marginTop: 2, children: /* @__PURE__ */ jsx(Stack, { space: 4, paddingBottom: 2, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: data.descriptionText, interpolation }) }) }), $[16] = data.descriptionText, $[17] = interpolation, $[18] = t7) : t7 = $[18];
  let t8;
  return $[19] !== onClose || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Dialog$1, { id: "upsell-dialog", onClose, onClickOutside: onClose, __unstable_hideCloseButton: !0, bodyHeight: "fill", padding: !1, footer: t4, children: [
    t5,
    t6,
    t7
  ] }), $[19] = onClose, $[20] = t4, $[21] = t5, $[22] = t6, $[23] = t7, $[24] = t8) : t8 = $[24], t8;
}
const STATE_TTL_MS = 6e4, ORG_ACTIVE_RELEASE_COUNT_RESOURCE_CACHE_NAMESPACE = "orgActiveReleaseCount";
function createOrgActiveReleaseCountStore(client, activeReleasesCount) {
  const latestFetchState = new BehaviorSubject(null), staleFlag$ = new BehaviorSubject(!1), activeReleaseCountAtFetch = new BehaviorSubject(null);
  return {
    orgActiveReleaseCount$: latestFetchState.pipe(switchMap$1((state) => state === null || staleFlag$.getValue() === !0 || activeReleaseCountAtFetch.getValue() !== activeReleasesCount ? (staleFlag$.next(!1), fetchReleaseLimits(client, "orgActiveReleaseCount").pipe(tap$1(() => activeReleaseCountAtFetch.next(activeReleasesCount)), map$1((data) => data.orgActiveReleaseCount), catchError$1((error) => {
      if (console.error("Failed to fetch org release count", error), !state) throw error;
      return of(state);
    }), switchMap$1((nextState) => (latestFetchState.next(nextState), timer(STATE_TTL_MS).subscribe(() => {
      staleFlag$.next(!0), activeReleaseCountAtFetch.next(null);
    }), of(nextState))))) : of(state)))
  };
}
const useOrgActiveReleaseCount = () => {
  const resourceCache = useResourceCache(), {
    data: activeReleases
  } = useActiveReleases(), client = useClient({
    apiVersion: "v2025-02-19"
  }), activeReleasesCount = activeReleases?.length || 0, count2 = useMemo(() => ({
    activeReleasesCount
  }), [activeReleasesCount]);
  return useMemo(() => {
    const releaseLimitsStore = resourceCache.get({
      dependencies: [client, count2],
      namespace: ORG_ACTIVE_RELEASE_COUNT_RESOURCE_CACHE_NAMESPACE
    }) || createOrgActiveReleaseCountStore(client, count2.activeReleasesCount);
    return resourceCache.set({
      namespace: ORG_ACTIVE_RELEASE_COUNT_RESOURCE_CACHE_NAMESPACE,
      value: releaseLimitsStore,
      dependencies: [client, count2]
    }), releaseLimitsStore;
  }, [client, count2, resourceCache]);
};
class StudioReleaseLimitExceededError extends Error {
  constructor() {
    super("StudioReleaseLimitExceeded"), this.name = "StudioReleaseLimitExceededError", this.details = {
      type: "releaseLimitExceededError"
    };
  }
}
const FEATURE$3 = "content-releases", BASE_URL$3 = "www.sanity.io", API_VERSION$2 = "2024-04-19";
function ReleasesUpsellProvider(props2) {
  const $ = c(44), [upsellDialogOpen, setUpsellDialogOpen] = useState(!1), [upsellData, setUpsellData] = useState(null), projectId = useProjectId$1(), telemetry = useTelemetry();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: API_VERSION$2
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), {
    data: activeReleases
  } = useActiveReleases(), {
    enabled: isReleasesFeatureEnabled
  } = useFeatureEnabled("contentReleases");
  let t1;
  bb0: {
    if (!isReleasesFeatureEnabled && upsellData) {
      t1 = "upsell";
      break bb0;
    }
    if (isReleasesFeatureEnabled && !upsellData) {
      t1 = "disabled";
      break bb0;
    }
    t1 = "default";
  }
  const mode = t1;
  let t2, t3;
  $[1] !== telemetry ? (t3 = {
    dialogSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature: FEATURE$3,
      type: "modal"
    }),
    dialogPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature: FEATURE$3,
      type: "modal"
    }),
    panelViewed: (source) => telemetry.log(UpsellDialogViewed, {
      feature: FEATURE$3,
      type: "inspector",
      source
    }),
    panelDismissed: () => telemetry.log(UpsellDialogDismissed, {
      feature: FEATURE$3,
      type: "inspector"
    }),
    panelPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature: FEATURE$3,
      type: "inspector"
    }),
    panelSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature: FEATURE$3,
      type: "inspector"
    })
  }, $[1] = telemetry, $[2] = t3) : t3 = $[2], t2 = t3;
  const telemetryLogs = t2;
  let t4;
  $[3] !== telemetryLogs ? (t4 = () => {
    telemetryLogs.dialogPrimaryClicked();
  }, $[3] = telemetryLogs, $[4] = t4) : t4 = $[4];
  const handlePrimaryButtonClick = t4;
  let t5;
  $[5] !== telemetryLogs ? (t5 = () => {
    telemetryLogs.dialogSecondaryClicked();
  }, $[5] = telemetryLogs, $[6] = t5) : t5 = $[6];
  const handleSecondaryButtonClick = t5;
  let t6;
  $[7] !== telemetry ? (t6 = () => {
    setUpsellDialogOpen(!1), telemetry.log(UpsellDialogDismissed, {
      feature: FEATURE$3,
      type: "modal"
    });
  }, $[7] = telemetry, $[8] = t6) : t6 = $[8];
  const handleClose = t6;
  let t7;
  $[9] !== client.observable || $[10] !== projectId ? (t7 = () => {
    const sub2 = client.observable.request({
      uri: "/journey/content-releases"
    }).subscribe({
      next: (data) => {
        if (data)
          try {
            const ctaUrl = template(data.ctaButton.url, TEMPLATE_OPTIONS$3);
            data.ctaButton.url = ctaUrl({
              baseUrl: BASE_URL$3,
              projectId
            });
            const secondaryUrl = template(data.secondaryButton.url, TEMPLATE_OPTIONS$3);
            data.secondaryButton.url = secondaryUrl({
              baseUrl: BASE_URL$3,
              projectId
            }), setUpsellData(data);
          } catch {
          }
      },
      error: _temp$26
    });
    return () => {
      sub2.unsubscribe();
    };
  }, $[9] = client.observable, $[10] = projectId, $[11] = t7) : t7 = $[11];
  let t8;
  $[12] !== client || $[13] !== projectId ? (t8 = [client, projectId], $[12] = client, $[13] = projectId, $[14] = t8) : t8 = $[14], useEffect(t7, t8);
  const [releaseCount, setReleaseCount] = useState(null);
  let t9;
  $[15] !== telemetry ? (t9 = (orgActiveReleaseCount) => {
    setUpsellDialogOpen(!0), orgActiveReleaseCount !== void 0 && setReleaseCount(orgActiveReleaseCount), telemetry.log(UpsellDialogViewed, {
      feature: FEATURE$3,
      type: "modal",
      source: "navbar"
    });
  }, $[15] = telemetry, $[16] = t9) : t9 = $[16];
  const handleOpenDialog = t9, {
    releaseLimits$
  } = useReleaseLimits(), {
    orgActiveReleaseCount$
  } = useOrgActiveReleaseCount();
  let t10;
  $[17] !== activeReleases?.length || $[18] !== handleOpenDialog || $[19] !== mode || $[20] !== orgActiveReleaseCount$ || $[21] !== releaseLimits$ ? (t10 = async (cb, t112) => {
    const throwError2 = t112 === void 0 ? !1 : t112, doUpsell = (count2) => {
      if (handleOpenDialog(count2), throwError2)
        throw new StudioReleaseLimitExceededError();
      return !1;
    };
    if (mode === "upsell")
      return doUpsell();
    const result = await (async () => {
      try {
        return await Promise.all([firstValueFrom(orgActiveReleaseCount$), firstValueFrom(releaseLimits$)]);
      } catch (t122) {
        return console.error("Error fetching release limits and org count for upsell:", t122), null;
      }
    })();
    if (result === null)
      return cb();
    const [orgActiveReleaseCount_0, releaseLimits] = result;
    if (releaseLimits === null || orgActiveReleaseCount_0 === null)
      return cb();
    const {
      orgActiveReleaseLimit,
      datasetReleaseLimit
    } = releaseLimits;
    if (orgActiveReleaseCount_0 === null)
      return cb();
    const activeReleasesCount = activeReleases?.length || 0, isCurrentDatasetAtAboveDatasetLimit = activeReleasesCount >= datasetReleaseLimit, isCurrentDatasetAtAboveOrgLimit = orgActiveReleaseLimit !== null && activeReleasesCount >= orgActiveReleaseLimit, isOrgAtAboveOrgLimit = orgActiveReleaseLimit !== null && orgActiveReleaseCount_0 >= orgActiveReleaseLimit;
    return isCurrentDatasetAtAboveDatasetLimit || isCurrentDatasetAtAboveOrgLimit || isOrgAtAboveOrgLimit ? doUpsell(orgActiveReleaseCount_0) : cb();
  }, $[17] = activeReleases?.length, $[18] = handleOpenDialog, $[19] = mode, $[20] = orgActiveReleaseCount$, $[21] = releaseLimits$, $[22] = t10) : t10 = $[22];
  const guardWithReleaseLimitUpsell = t10;
  let t11;
  $[23] !== handleOpenDialog ? (t11 = (limit2) => handleOpenDialog(limit2), $[23] = handleOpenDialog, $[24] = t11) : t11 = $[24];
  const onReleaseLimitReached = t11;
  let t12, t13;
  $[25] !== guardWithReleaseLimitUpsell || $[26] !== mode || $[27] !== onReleaseLimitReached || $[28] !== telemetryLogs || $[29] !== upsellDialogOpen ? (t13 = {
    mode,
    upsellDialogOpen,
    guardWithReleaseLimitUpsell,
    onReleaseLimitReached,
    telemetryLogs
  }, $[25] = guardWithReleaseLimitUpsell, $[26] = mode, $[27] = onReleaseLimitReached, $[28] = telemetryLogs, $[29] = upsellDialogOpen, $[30] = t13) : t13 = $[30], t12 = t13;
  const ctxValue = t12;
  let t14;
  $[31] !== releaseCount ? (t14 = releaseCount === null ? void 0 : {
    releaseLimit: releaseCount
  }, $[31] = releaseCount, $[32] = t14) : t14 = $[32];
  const interpolation = t14;
  let t15;
  $[33] !== handleClose || $[34] !== handlePrimaryButtonClick || $[35] !== handleSecondaryButtonClick || $[36] !== interpolation || $[37] !== upsellData || $[38] !== upsellDialogOpen ? (t15 = upsellData && upsellDialogOpen && /* @__PURE__ */ jsx(UpsellDialog, { interpolation, data: upsellData, onClose: handleClose, onPrimaryClick: handlePrimaryButtonClick, onSecondaryClick: handleSecondaryButtonClick }), $[33] = handleClose, $[34] = handlePrimaryButtonClick, $[35] = handleSecondaryButtonClick, $[36] = interpolation, $[37] = upsellData, $[38] = upsellDialogOpen, $[39] = t15) : t15 = $[39];
  let t16;
  return $[40] !== ctxValue || $[41] !== props2.children || $[42] !== t15 ? (t16 = /* @__PURE__ */ jsxs(ReleasesUpsellContext.Provider, { value: ctxValue, children: [
    props2.children,
    t15
  ] }), $[40] = ctxValue, $[41] = props2.children, $[42] = t15, $[43] = t16) : t16 = $[43], t16;
}
function _temp$26() {
}
function releasesToolAvailable(workspace) {
  return workspace.tools.some(({
    name
  }) => name === RELEASES_TOOL_NAME);
}
function useReleasesToolAvailable() {
  const $ = c(2), workspace = useWorkspace();
  let t0, t1;
  return $[0] !== workspace ? (t1 = releasesToolAvailable(workspace), $[0] = workspace, $[1] = t1) : t1 = $[1], t0 = t1, t0;
}
function ReleasesStudioLayout(props2) {
  const $ = c(6);
  if (!useReleasesToolAvailable()) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== props2 ? (t0 = props2.renderDefault(props2), $[2] = props2, $[3] = t0) : t0 = $[3];
  let t1;
  return $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(ReleasesUpsellProvider, { children: /* @__PURE__ */ jsx(ReleasesMetadataProvider, { children: t0 }) }), $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const RELEASES_NAME = "sanity/releases", RELEASES_TOOL_NAME = "releases", RELEASES_INTENT = "release", releases = definePlugin({
  name: RELEASES_NAME,
  studio: {
    components: {
      layout: ReleasesStudioLayout
    }
  },
  tools: [{
    name: RELEASES_TOOL_NAME,
    title: "Releases",
    component: ReleasesTool,
    router: route.create("/", [route.create("/:releaseId")]),
    canHandleIntent: (intent) => intent === RELEASES_INTENT,
    getIntentState(intent, params) {
      return intent === RELEASES_INTENT ? {
        releaseId: params.id
      } : null;
    }
  }],
  i18n: {
    bundles: [releasesUsEnglishLocaleBundle]
  },
  document: {
    actions: (actions, context) => resolveDocumentActions$1(actions, context)
  }
}), PRESENCE_MENU_POPOVER_PROPS = {
  portal: !0
}, AvatarStackBox = styled.div((props2) => {
  const {
    space
  } = getTheme_v2(props2.theme);
  return css`
    margin: ${0 - space[1]}px;
  `;
});
function DocumentPreviewPresence(props2) {
  const {
    presence
  } = props2, {
    t
  } = useTranslation(releasesLocaleNamespace), {
    data: releases2
  } = useActiveReleases(), uniquePresence = useMemo(() => Array.from(new Set(presence.map((a) => a.user.id))).map((id2) => presence.find((a_0) => a_0.user.id === id2)).filter(isNonNullable$3), [presence]), tooltipContent = useMemo(() => {
    if (uniquePresence.length === 1) {
      const firstPresence = uniquePresence[0], documentId = firstPresence?.documentId, releaseTitle = (documentId ? releases2.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === getVersionFromId(documentId)) : void 0)?.metadata?.title;
      return t("presence.tooltip.one", {
        displayName: firstPresence.user.displayName,
        releaseTitle: releaseTitle || t("release-placeholder.title")
      });
    }
    if (uniquePresence.length > 1)
      return t("presence.tooltip.other", {
        count: uniquePresence.length
      });
  }, [releases2, t, uniquePresence]);
  return /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, ...PRESENCE_MENU_POPOVER_PROPS, children: /* @__PURE__ */ jsx(AvatarStackBox, { children: /* @__PURE__ */ jsx(AvatarStack, { maxLength: 2, "aria-label": tooltipContent, size: 0, children: uniquePresence.map((item) => /* @__PURE__ */ jsx(UserAvatar, { size: 0, user: item.user }, item.user.id)) }) }) });
}
const MAX_AVATARS_DOCK = 3, DEFAULT_MAX_AVATARS_FIELDS = 3, AVATAR_DISTANCE = -4, AVATAR_SIZE = 25, AVATAR_ARROW_HEIGHT = 4, INTERSECTION_THRESHOLDS = [0, 0.25, 0.75, 1], INTERSECTION_ELEMENT_PADDING = 23, SNAP_TO_DOCK_DISTANCE_TOP = 8, SNAP_TO_DOCK_DISTANCE_BOTTOM = 8, SLIDE_RIGHT_THRESHOLD_TOP = 20, SLIDE_RIGHT_THRESHOLD_BOTTOM = 20, DEBUG = !1, FlexWrapper$1 = styled(Flex)`
  & > div:first-child {
    flex: 1;
    min-width: 0;
  }
`, InnerBox = styled(Flex)`
  height: ${AVATAR_SIZE}px;
  min-width: 23px;
  vertical-align: top;
`;
function PresenceTrackerComponent(props2) {
  const $ = c(6), {
    children
  } = props2, {
    store,
    snapshot: snapshot2
  } = useTrackerStore();
  let t0;
  $[0] !== children || $[1] !== snapshot2 ? (t0 = /* @__PURE__ */ jsx(PresenceTrackerContextGetSnapshot.Provider, { value: snapshot2, children }), $[0] = children, $[1] = snapshot2, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== store || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(PresenceTrackerContextStore.Provider, { value: store, children: t0 }), $[3] = store, $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const PresenceTracker = memo(PresenceTrackerComponent), EMPTY_ARRAY$v = [];
function usePresenceReportedValues() {
  const snapshot2 = useContext(PresenceTrackerContextGetSnapshot);
  return snapshot2 === null ? (console.warn(new Error('No context provided for reporter. Make sure that the component calling "usePresenceReportedValues()", is wrapped inside a <PresenceTracker> element')), EMPTY_ARRAY$v) : snapshot2;
}
const usePresenceReporter = (id2, value, isEqual2) => {
  const store = useContext(PresenceTrackerContextStore);
  store === null && console.warn(new Error('No context provided for reporter. Make sure that the component calling "usePresenceReporter()", is wrapped inside a <PresenceTracker> element')), useTrackerStoreReporter(store, id2, value, isEqual2);
};
function PresenceTooltip(props2) {
  const $ = c(7), {
    children,
    items
  } = props2;
  let t0, t1;
  $[0] !== items ? (t1 = items.map(_temp$25), $[0] = items, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Stack, { sizing: "border", children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3], t0 = t2;
  const content = t0;
  let t3;
  return $[4] !== children || $[5] !== content ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content, placement: "top", portal: "documentScrollElement", children }), $[4] = children, $[5] = content, $[6] = t3) : t3 = $[6], t3;
}
function _temp$25(item) {
  return /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(UserAvatar, { user: item.user, status: "online" }) }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: item.user.displayName })
  ] }, item.user.id);
}
const splitRight = (array, max) => {
  const indexFromMax = array.length > max ? max - 1 : max, idx = Math.max(0, array.length - indexFromMax);
  return [array.slice(0, idx), array.slice(idx)];
};
function calcAvatarStackWidth(len) {
  return 4 + (AVATAR_SIZE + AVATAR_DISTANCE) * len;
}
const FieldPresenceInner = memo(function(t0) {
  const $ = c(14), {
    presence,
    position: t1,
    animateArrowFrom: t2,
    maxAvatars: t3,
    stack: t4
  } = t0, position = t1 === void 0 ? "inside" : t1, animateArrowFrom = t2 === void 0 ? "inside" : t2, maxAvatars = t3 === void 0 ? DEFAULT_MAX_AVATARS_FIELDS : t3, stack = t4 === void 0 ? !0 : t4;
  let t5;
  $[0] !== presence ? (t5 = presence || [], $[0] = presence, $[1] = t5) : t5 = $[1];
  let t6;
  if ($[2] !== animateArrowFrom || $[3] !== maxAvatars || $[4] !== position || $[5] !== stack || $[6] !== t5) {
    const uniquePresence = uniqBy(t5, _temp$24), sorted = sortBy(uniquePresence, _temp2$L), [hidden, visible] = stack ? splitRight(sorted, maxAvatars) : [[], sorted];
    let t72;
    $[8] !== animateArrowFrom || $[9] !== position ? (t72 = (_visible) => ({
      key: _visible.user.id,
      element: /* @__PURE__ */ jsx(UserAvatar, { animateArrowFrom, position, status: "online", user: _visible.user })
    }), $[8] = animateArrowFrom, $[9] = position, $[10] = t72) : t72 = $[10], t6 = [...visible.reverse().map(t72), hidden.length >= 2 ? {
      key: "counter",
      element: /* @__PURE__ */ jsx(AvatarCounter, { count: hidden.length })
    } : null].filter(Boolean), $[2] = animateArrowFrom, $[3] = maxAvatars, $[4] = position, $[5] = stack, $[6] = t5, $[7] = t6;
  } else
    t6 = $[7];
  const avatars = t6;
  let t7;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx("div", {}), $[11] = t7) : t7 = $[11];
  let t8;
  return $[12] !== avatars ? (t8 = /* @__PURE__ */ jsxs(FlexWrapper$1, { children: [
    t7,
    /* @__PURE__ */ jsx(InnerBox, { direction: "row-reverse", children: avatars.map(_temp3$f) })
  ] }), $[12] = avatars, $[13] = t8) : t8 = $[13], t8;
});
function FieldPresence(props2) {
  const $ = c(11), contextPresence = useContext(FormFieldPresenceContext), {
    presence: t0,
    maxAvatars: t1
  } = props2, presence = t0 === void 0 ? contextPresence : t0, maxAvatars = t1 === void 0 ? DEFAULT_MAX_AVATARS_FIELDS : t1, [element, setElement] = useState(null), reporterId = useId();
  let t2;
  $[0] !== element || $[1] !== maxAvatars || $[2] !== presence ? (t2 = () => ({
    presence,
    element,
    maxAvatars
  }), $[0] = element, $[1] = maxAvatars, $[2] = presence, $[3] = t2) : t2 = $[3], usePresenceReporter(element ? reporterId : null, t2);
  let t3, t4;
  $[4] !== presence ? (t4 = presence || [], $[4] = presence, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t4 ? (t5 = uniqBy(t4, _temp4$9), $[6] = t4, $[7] = t5) : t5 = $[7], t3 = t5;
  const uniquePresence = t3;
  let t6;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(FlexWrapper$1, { ref: setElement, style: {
    minHeight: AVATAR_SIZE,
    minWidth: AVATAR_SIZE
  } }), $[8] = t6) : t6 = $[8];
  let t7;
  return $[9] !== uniquePresence ? (t7 = /* @__PURE__ */ jsx(PresenceTooltip, { items: uniquePresence, children: t6 }), $[9] = uniquePresence, $[10] = t7) : t7 = $[10], t7;
}
function _temp4$9(item) {
  return item.user.id;
}
const FieldPresenceWithOverlay = FieldPresence;
function _temp$24(item) {
  return item.user.id;
}
function _temp2$L(_presence) {
  return _presence.lastActiveAt;
}
function _temp3$f(av, i) {
  return av && /* @__PURE__ */ jsx("div", { style: {
    position: "absolute",
    transform: `translate3d(${-i * (AVATAR_SIZE + AVATAR_DISTANCE)}px, 0px, 0px)`,
    transitionProperty: "transform",
    transitionDuration: "200ms",
    transitionTimingFunction: "cubic-bezier(0.85, 0, 0.15, 1)",
    zIndex: 100 - i
  }, children: av.element }, av.key);
}
const createIntersectionObserver = (options) => {
  const entries$ = new Subject(), intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entries$.next(entry);
    });
  }, options);
  return {
    observe: (element) => new Observable((subscriber) => {
      const subscription = entries$.pipe(filter((entry) => entry.target === element)).subscribe(subscriber);
      return intersectionObserver.observe(element), () => {
        subscription.unsubscribe(), intersectionObserver.unobserve(element);
      };
    })
  };
}, WithIntersection = (props2) => {
  const $ = c(12);
  let id2, io, onIntersection, rest;
  $[0] !== props2 ? ({
    onIntersection,
    io,
    id: id2,
    ...rest
  } = props2, $[0] = props2, $[1] = id2, $[2] = io, $[3] = onIntersection, $[4] = rest) : (id2 = $[1], io = $[2], onIntersection = $[3], rest = $[4]);
  const element = useRef(null);
  let t0, t1;
  $[5] !== id2 || $[6] !== io || $[7] !== onIntersection ? (t0 = () => {
    const el = element.current;
    if (!el)
      return;
    const subscription = io.observe(el).pipe(tap((entry) => onIntersection(id2, entry))).subscribe();
    return () => subscription.unsubscribe();
  }, t1 = [io, id2, onIntersection], $[5] = id2, $[6] = io, $[7] = onIntersection, $[8] = t0, $[9] = t1) : (t0 = $[8], t1 = $[9]), useEffect(t0, t1);
  let t2;
  return $[10] !== rest ? (t2 = /* @__PURE__ */ jsx("div", { ...rest, ref: element }), $[10] = rest, $[11] = t2) : t2 = $[11], t2;
}, RootWrapper = styled.div`
  position: relative;
`, OverlayWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 13;
`, RegionWrapper = css`
  overflow: hidden;
  overflow: clip;
  pointer-events: none;
  position: absolute;
`, TopRegionWrapper = styled(WithIntersection)(({
  $debug,
  margins
}) => css`
    ${RegionWrapper}

    z-index: 100;
    position: sticky;
    height: 1px;
    top: ${margins ? `${margins[0] - 1}px` : void 0};
    background-color: ${$debug ? "red" : "none"};
  `), MiddleRegionWrapper = styled(WithIntersection)(({
  $debug
}) => css`
    ${RegionWrapper}

    visibility: none;

    ${$debug && css`
      background: rgba(255, 0, 0, 0.25);
      outline: 1px solid #00b;
      visibility: visible;
    `}
  `), BottomRegionWrapper = styled(WithIntersection)(({
  $debug
}) => css`
    ${RegionWrapper}

    position: sticky;
    bottom: -1px;
    height: 1px;
    background-color: ${$debug ? "blue" : "transparent"};
  `), toPx = (num) => `${num}px`, negate = (num) => 0 - num, RegionsWithIntersections = forwardRef(function(props2, ref) {
  const {
    regions,
    render: render2,
    children,
    margins: [mt, mr, mb, ml]
  } = props2, overlayRef = useRef(null), margins = useMemo(() => [mt, mr, mb, ml], [mt, mr, mb, ml]), io = useMemo(() => createIntersectionObserver({
    rootMargin: margins.map(negate).map(toPx).join(" "),
    threshold: INTERSECTION_THRESHOLDS
  }), [margins]), [intersections, setIntersections] = useState({}), onIntersection = useCallback((id2, entry) => {
    setIntersections((current) => ({
      ...current,
      [id2]: entry
    }));
  }, []), [overlayWidth, setOverlayWidth] = useState(0);
  useLayoutEffect(() => {
    if (overlayRef.current)
      return setOverlayWidth(overlayRef.current.offsetWidth), resizeObserver.observe(overlayRef.current, (event) => {
        setOverlayWidth(event.contentRect.width);
      });
  }, []);
  const top = intersections["::top"], bottom2 = intersections["::bottom"], regionsWithIntersectionDetails = useMemo(() => top && bottom2 ? regions.filter((region) => region.presence?.length > 0).map((region_0) => {
    const intersection2 = intersections[region_0.id];
    if (!intersection2)
      return null;
    const {
      bottom: boundsBottom,
      top: boundsTop
    } = intersection2.boundingClientRect, aboveTop = intersection2.boundingClientRect.top < top.boundingClientRect.bottom, belowBottom = intersection2.boundingClientRect.top < bottom2.boundingClientRect.top, distanceTop = intersection2.isIntersecting ? boundsTop - (intersection2.intersectionRect.top - INTERSECTION_ELEMENT_PADDING) : aboveTop ? -top.boundingClientRect.bottom : bottom2.boundingClientRect.top, distanceBottom = intersection2.isIntersecting ? -(boundsBottom - (intersection2.intersectionRect.bottom + INTERSECTION_ELEMENT_PADDING)) : belowBottom ? bottom2.boundingClientRect.top : -top.boundingClientRect.bottom, position = (
      // eslint-disable-next-line no-nested-ternary
      distanceTop <= SNAP_TO_DOCK_DISTANCE_TOP ? "top" : distanceBottom <= SNAP_TO_DOCK_DISTANCE_BOTTOM ? "bottom" : "inside"
    );
    return {
      distanceTop,
      distanceBottom,
      region: region_0,
      position
    };
  }).filter(Boolean) : [], [bottom2, intersections, regions, top]);
  return /* @__PURE__ */ jsxs(RootWrapper, { ref, children: [
    /* @__PURE__ */ jsx(TopRegionWrapper, { $debug: DEBUG, io, id: "::top", onIntersection, margins }),
    /* @__PURE__ */ jsx("div", { children }),
    /* @__PURE__ */ jsx(OverlayWrapper, { ref: overlayRef, children: overlayWidth && render2(regionsWithIntersectionDetails, overlayWidth) }),
    regions.map((region_1) => {
      const forceWidth = region_1.rect.width === 0;
      return /* @__PURE__ */ jsx(MiddleRegionWrapper, { $debug: DEBUG, io, onIntersection, id: region_1.id, style: {
        width: forceWidth ? 1 : region_1.rect.width,
        left: region_1.rect.left - (forceWidth ? 1 : 0),
        top: region_1.rect.top - INTERSECTION_ELEMENT_PADDING,
        height: region_1.rect.height + INTERSECTION_ELEMENT_PADDING * 2
      } }, region_1.id);
    }),
    /* @__PURE__ */ jsx(BottomRegionWrapper, { $debug: DEBUG, id: "::bottom", io, onIntersection })
  ] });
}), ITEM_TRANSITION = {
  transitionProperty: "transform",
  transitionDuration: "200ms",
  transitionTimingFunction: "cubic-bezier(0.85, 0, 0.15, 1)"
}, bottom = (rect) => rect.top + rect.height;
function withSpacerHeight(regionsWithIntersectionDetails) {
  return regionsWithIntersectionDetails.map((withIntersection, idx, _regionsWithIntersectionDetails) => {
    const prevRect = _regionsWithIntersectionDetails[idx - 1]?.region.rect, prevBottom = prevRect ? bottom(prevRect) : 0;
    return {
      ...withIntersection,
      spacerHeight: withIntersection.region.rect.top - prevBottom
    };
  });
}
const orderByTop = (regionsWithIntersectionDetails) => orderBy(regionsWithIntersectionDetails, (withIntersection) => withIntersection.region.rect.top), plus = (a, b) => a + b, sum = (array) => array.reduce(plus, 0);
function group(regionsWithIntersectionDetails) {
  const regionsWithSpacerHeight = withSpacerHeight(orderByTop(regionsWithIntersectionDetails)), grouped = {
    top: [],
    inside: [],
    bottom: [],
    ...groupBy(regionsWithSpacerHeight, (_withSpacerHeight) => _withSpacerHeight.position)
  };
  return {
    top: orderByTop(grouped.top).map((withIntersection, i, grp) => ({
      ...withIntersection,
      indent: grp.slice(i + 1).reduce((w, _withIntersection) => w + _withIntersection.region.rect.width, 0)
    })),
    inside: orderByTop(grouped.inside).map((withIntersection) => ({
      ...withIntersection,
      indent: 0
    })),
    bottom: orderByTop(grouped.bottom).map((withIntersection, i, grp) => ({
      ...withIntersection,
      indent: grp.slice(0, i).reduce((w, _withIntersection) => w + _withIntersection.region.rect.width, 0)
    }))
  };
}
const Spacer$1 = (t0) => {
  const $ = c(6);
  let height, rest;
  $[0] !== t0 ? ({
    height,
    ...rest
  } = t0, $[0] = t0, $[1] = height, $[2] = rest) : (height = $[1], rest = $[2]);
  const t1 = Math.max(0, height), t2 = rest?.style;
  let t3;
  return $[3] !== t1 || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx("div", { style: {
    height: t1,
    ...t2
  } }), $[3] = t1, $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}, DEFAULT_MARGINS$1 = [0, 0, 0, 0], getOffsetsTo = (source, target) => {
  let el = source, top = -el.scrollTop, left = 0;
  for (; el && el !== target; )
    top += el.offsetTop - el.scrollTop, left += el.offsetLeft, el = el.offsetParent instanceof HTMLElement ? el.offsetParent : null;
  return {
    top,
    left
  };
};
function getRelativeRect(element, parent) {
  return {
    ...getOffsetsTo(element, parent),
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}
function regionsWithComputedRects(regions, parent) {
  return regions.map(([id2, region]) => region.element ? {
    ...region,
    id: id2,
    rect: getRelativeRect(region.element, parent)
  } : null).filter(Boolean);
}
function StickyOverlay(props2) {
  const $ = c(10), {
    children,
    margins: t0
  } = props2, margins = t0 === void 0 ? DEFAULT_MARGINS$1 : t0, reportedValues = usePresenceReportedValues(), [element, setElement] = useState(null);
  let t1, t2;
  $[0] !== element || $[1] !== reportedValues ? (t2 = element ? regionsWithComputedRects(reportedValues, element) : EMPTY_ARRAY$u, $[0] = element, $[1] = reportedValues, $[2] = t2) : t2 = $[2], t1 = t2;
  const regions = t1;
  let t3;
  $[3] !== margins ? (t3 = (regionsWithIntersectionDetails, containerWidth) => {
    const grouped = group(regionsWithIntersectionDetails.filter(_temp$23)), topSpacing = sum(grouped.top.map(_temp2$K)), bottomSpacing = sum([...grouped.inside, ...grouped.bottom].map(_temp3$e)), counts = grouped.inside.reduce(_temp4$8, {
      nearTop: 0,
      nearBottom: 0
    });
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(PresenceDock, { closeCount: counts.nearTop, margins, position: "top", regionsWithIntersectionDetails: grouped.top }),
      /* @__PURE__ */ jsx(Spacer$1, { height: topSpacing }),
      /* @__PURE__ */ jsx(PresenceInside, { containerWidth, regionsWithIntersectionDetails: grouped.inside }),
      /* @__PURE__ */ jsx(Spacer$1, { height: bottomSpacing }),
      /* @__PURE__ */ jsx(PresenceDock, { closeCount: counts.nearBottom, margins, position: "bottom", regionsWithIntersectionDetails: grouped.bottom })
    ] });
  }, $[3] = margins, $[4] = t3) : t3 = $[4];
  const renderCallback = t3;
  let t4;
  return $[5] !== children || $[6] !== margins || $[7] !== regions || $[8] !== renderCallback ? (t4 = /* @__PURE__ */ jsx(RegionsWithIntersections, { ref: setElement, margins, regions, render: renderCallback, children }), $[5] = children, $[6] = margins, $[7] = regions, $[8] = renderCallback, $[9] = t4) : t4 = $[9], t4;
}
function _temp4$8(_counts, withIntersection) {
  const {
    distanceTop,
    distanceBottom
  } = withIntersection, nearTop = distanceTop <= SLIDE_RIGHT_THRESHOLD_TOP, nearBottom = distanceBottom <= SLIDE_RIGHT_THRESHOLD_BOTTOM;
  return {
    nearTop: _counts.nearTop + (nearTop ? withIntersection.region.presence.length : 0),
    nearBottom: _counts.nearBottom + (nearBottom ? withIntersection.region.presence.length : 0)
  };
}
function _temp3$e(n_0) {
  return n_0.region.rect.height + n_0.spacerHeight;
}
function _temp2$K(n) {
  return n.region.rect.height + n.spacerHeight;
}
function _temp$23(item) {
  return item.region.presence.length > 0;
}
const EMPTY_ARRAY$u = [], PresenceDock = memo(function(props2) {
  const $ = c(17), {
    closeCount,
    margins,
    position,
    regionsWithIntersectionDetails
  } = props2, dir = position === "top" ? 1 : -1;
  let t0;
  bb0: {
    if (!regionsWithIntersectionDetails.length) {
      t0 = EMPTY_ARRAY$u;
      break bb0;
    }
    let t12;
    $[0] !== dir ? (t12 = (r) => r.region.rect.top * dir, $[0] = dir, $[1] = t12) : t12 = $[1];
    let t22;
    $[2] !== regionsWithIntersectionDetails || $[3] !== t12 ? (t22 = flatten$1(sortBy(regionsWithIntersectionDetails, t12).map(_temp5$5)), $[2] = regionsWithIntersectionDetails, $[3] = t12, $[4] = t22) : t22 = $[4], t0 = t22;
  }
  const allPresenceItems = t0, [topMargin, rightMargin, bottomMargin, leftMargin] = margins, leftOffset = (leftMargin || 0) + (allPresenceItems.length > 0 ? -closeCount * (AVATAR_SIZE + AVATAR_DISTANCE) : 0) - rightMargin, margin = position === "top" ? topMargin : bottomMargin;
  let t1;
  const t2 = `translate3d(${leftOffset}px, 0px, 0px)`, t3 = AVATAR_ARROW_HEIGHT + 1 + margin, t4 = AVATAR_ARROW_HEIGHT + 1 + margin;
  let t5;
  $[5] !== t2 || $[6] !== t3 || $[7] !== t4 ? (t5 = {
    zIndex: 2,
    position: "sticky",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    ...ITEM_TRANSITION,
    transform: t2,
    top: t3,
    bottom: t4
  }, $[5] = t2, $[6] = t3, $[7] = t4, $[8] = t5) : t5 = $[8], t1 = t5;
  const style = t1, t6 = `sticky-${position}`;
  let t7;
  $[9] !== allPresenceItems || $[10] !== position ? (t7 = /* @__PURE__ */ jsx(FieldPresenceInner, { position, maxAvatars: MAX_AVATARS_DOCK, presence: allPresenceItems }), $[9] = allPresenceItems, $[10] = position, $[11] = t7) : t7 = $[11];
  let t8;
  return $[12] !== position || $[13] !== style || $[14] !== t6 || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx("div", { "data-dock": position, style, children: t7 }, t6), $[12] = position, $[13] = style, $[14] = t6, $[15] = t7, $[16] = t8) : t8 = $[16], t8;
});
function PresenceInside(props2) {
  const $ = c(7), {
    regionsWithIntersectionDetails,
    containerWidth
  } = props2;
  let t0;
  if ($[0] !== containerWidth || $[1] !== regionsWithIntersectionDetails) {
    let t12;
    $[3] !== containerWidth ? (t12 = (withIntersection) => {
      const originalLeft = withIntersection.region.rect.left, {
        distanceTop,
        distanceBottom
      } = withIntersection, nearTop = distanceTop <= SLIDE_RIGHT_THRESHOLD_TOP, nearBottom = distanceBottom <= SLIDE_RIGHT_THRESHOLD_BOTTOM, diffRight = containerWidth - originalLeft - withIntersection.region.rect.width, {
        presence,
        maxAvatars
      } = withIntersection.region;
      return /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx("div", { style: {
        zIndex: 2,
        position: "absolute",
        ...ITEM_TRANSITION,
        left: originalLeft,
        transform: `translate3d(${nearTop || nearBottom ? diffRight : 0}px, 0px, 0px)`,
        height: withIntersection.region.rect.height,
        top: withIntersection.region.rect.top
      }, children: /* @__PURE__ */ jsx(DebugValue, { value: () => `\u2912${distanceTop} | ${distanceBottom}\u2913`, children: /* @__PURE__ */ jsx(FieldPresenceInner, { stack: !nearTop && !nearBottom, position: nearTop ? "top" : nearBottom ? "bottom" : "inside", maxAvatars, presence }) }) }) }, withIntersection.region.id);
    }, $[3] = containerWidth, $[4] = t12) : t12 = $[4], t0 = regionsWithIntersectionDetails.map(t12), $[0] = containerWidth, $[1] = regionsWithIntersectionDetails, $[2] = t0;
  } else
    t0 = $[2];
  let t1;
  return $[5] !== t0 ? (t1 = /* @__PURE__ */ jsx(Fragment, { children: t0 }), $[5] = t0, $[6] = t1) : t1 = $[6], t1;
}
const PassThrough = (props2) => props2.children, DebugValue = PassThrough;
function _temp5$5(withIntersection) {
  return withIntersection.region.presence || EMPTY_ARRAY$u;
}
const DEFAULT_MARGINS = [0, 0, 0, 0];
function PresenceOverlay(t0) {
  const $ = c(3), {
    children,
    margins
  } = t0, t1 = margins || DEFAULT_MARGINS;
  let t2;
  return $[0] !== children || $[1] !== t1 ? (t2 = /* @__PURE__ */ jsx(PresenceTracker, { children: /* @__PURE__ */ jsx(StickyOverlay, { margins: t1, children }) }), $[0] = children, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}
const EMPTY_ARRAY$t = [];
function trimChildPath(path, childPath) {
  return PathUtils.startsWith(path, childPath) ? PathUtils.trimLeft(path, childPath) : EMPTY_ARRAY$t;
}
function PresenceScope(props2) {
  const $ = c(7), {
    readOnly,
    path,
    children
  } = props2, contextPresence = useContext(FormFieldPresenceContext);
  let t0, t1;
  $[0] !== contextPresence || $[1] !== path || $[2] !== readOnly ? (t1 = readOnly ? EMPTY_ARRAY$t : (contextPresence || EMPTY_ARRAY$t).filter((presence) => PathUtils.startsWith(path, presence.path)).map((presence_0) => ({
    ...presence_0,
    path: trimChildPath(path, presence_0.path)
  })), $[0] = contextPresence, $[1] = path, $[2] = readOnly, $[3] = t1) : t1 = $[3], t0 = t1;
  const childPresence = t0;
  let t2;
  return $[4] !== childPresence || $[5] !== children ? (t2 = /* @__PURE__ */ jsx(FormFieldPresenceContext.Provider, { value: childPresence, children }), $[4] = childPresence, $[5] = children, $[6] = t2) : t2 = $[6], t2;
}
function VirtualizerScrollInstanceProvider(props2) {
  const $ = c(6), {
    scrollElement,
    containerElement
  } = props2;
  let t0, t1;
  $[0] !== containerElement || $[1] !== scrollElement ? (t1 = {
    scrollElement,
    containerElement
  }, $[0] = containerElement, $[1] = scrollElement, $[2] = t1) : t1 = $[2], t0 = t1;
  const value = t0;
  let t2;
  return $[3] !== props2.children || $[4] !== value ? (t2 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceContext.Provider, { value, children: props2.children }), $[3] = props2.children, $[4] = value, $[5] = t2) : t2 = $[5], t2;
}
const PRESENCE_MARGINS$1 = [0, 0, 1, 0];
function onDragEnter(event) {
  return event.stopPropagation();
}
function onDrop(event) {
  return event.stopPropagation();
}
function EditPortal(props2) {
  const $ = c(21), {
    children,
    header,
    onClose,
    type,
    width
  } = props2, [documentScrollElement, setDocumentScrollElement] = useState(null), containerElement = useRef(null);
  let t0;
  $[0] !== children ? (t0 = /* @__PURE__ */ jsx(PresenceOverlay, { margins: PRESENCE_MARGINS$1, children: /* @__PURE__ */ jsx(Box, { ref: containerElement, children }) }), $[0] = children, $[1] = t0) : t0 = $[1];
  const contents = t0;
  if (type === "dialog") {
    const t12 = props2.id || "";
    let t22;
    $[2] !== contents || $[3] !== header || $[4] !== onClose || $[5] !== props2.autofocus || $[6] !== t12 || $[7] !== width ? (t22 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: props2.autofocus, contentRef: setDocumentScrollElement, "data-testid": "edit-portal-dialog", header, id: t12, onClickOutside: onClose, onClose, onDragEnter, onDrop, width, children: contents }), $[2] = contents, $[3] = header, $[4] = onClose, $[5] = props2.autofocus, $[6] = t12, $[7] = width, $[8] = t22) : t22 = $[8];
    let t3;
    return $[9] !== documentScrollElement || $[10] !== t22 ? (t3 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: documentScrollElement, containerElement, children: t22 }), $[9] = documentScrollElement, $[10] = t22, $[11] = t3) : t3 = $[11], t3;
  }
  let t1;
  $[12] !== contents || $[13] !== documentScrollElement ? (t1 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: documentScrollElement, containerElement, children: contents }), $[12] = contents, $[13] = documentScrollElement, $[14] = t1) : t1 = $[14];
  let t2;
  return $[15] !== header || $[16] !== onClose || $[17] !== props2.legacy_referenceElement || $[18] !== t1 || $[19] !== width ? (t2 = /* @__PURE__ */ jsx(PopoverDialog, { header, onClose, referenceElement: props2.legacy_referenceElement, width, containerRef: setDocumentScrollElement, children: t1 }), $[15] = header, $[16] = onClose, $[17] = props2.legacy_referenceElement, $[18] = t1, $[19] = width, $[20] = t2) : t2 = $[20], t2;
}
const POPOVER_PROPS$6 = {
  placement: "right",
  fallbackPlacements: ["top", "bottom"]
};
function FieldActionMenuGroup(props2) {
  const $ = c(14), {
    group: group2
  } = props2, {
    title
  } = useI18nText(group2);
  if (group2.expanded) {
    let t02;
    $[0] !== title ? (t02 = /* @__PURE__ */ jsx(Box, { padding: 2, paddingTop: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: title }) }), $[0] = title, $[1] = t02) : t02 = $[1];
    let t12;
    $[2] !== group2.children ? (t12 = group2.children.map((item, idx) => /* @__PURE__ */ jsx(FieldActionMenuNode, { action: item, isFirst: idx === 0, prevIsGroup: group2.children[idx - 1]?.type === "group" }, idx)), $[2] = group2.children, $[3] = t12) : t12 = $[3];
    let t22;
    return $[4] !== t02 || $[5] !== t12 ? (t22 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t02,
      t12
    ] }), $[4] = t02, $[5] = t12, $[6] = t22) : t22 = $[6], t22;
  }
  const t0 = group2.icon, t1 = group2.tone;
  let t2;
  $[7] !== group2.children ? (t2 = group2.children.map((item_0, idx_0) => /* @__PURE__ */ jsx(FieldActionMenuNode, { action: item_0, isFirst: idx_0 === 0, prevIsGroup: group2.children[idx_0 - 1]?.type === "group" }, idx_0)), $[7] = group2.children, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== group2.icon || $[10] !== group2.tone || $[11] !== t2 || $[12] !== title ? (t3 = /* @__PURE__ */ jsx(MenuGroup, { icon: t0, popover: POPOVER_PROPS$6, text: title, tone: t1, children: t2 }), $[9] = group2.icon, $[10] = group2.tone, $[11] = t2, $[12] = title, $[13] = t3) : t3 = $[13], t3;
}
function FieldActionMenuItem(props2) {
  const $ = c(15), {
    action
  } = props2, {
    title
  } = useI18nText(action);
  let t0;
  $[0] !== action ? (t0 = () => {
    action.onAction();
  }, $[0] = action, $[1] = t0) : t0 = $[1];
  const handleClick = t0;
  let t1;
  $[2] !== action.disabled ? (t1 = typeof action.disabled == "object" && /* @__PURE__ */ jsx(Text$1, { size: 1, children: action.disabled.reason }), $[2] = action.disabled, $[3] = t1) : t1 = $[3];
  const disabledTooltipContent = t1, t2 = !!action.disabled, t3 = action.iconRight || (action.selected ? CheckmarkIcon : void 0);
  let t4;
  $[4] !== action.icon || $[5] !== action.selected || $[6] !== action.tone || $[7] !== handleClick || $[8] !== t2 || $[9] !== t3 || $[10] !== title ? (t4 = /* @__PURE__ */ jsx(MenuItem$1, { disabled: t2, icon: action.icon, iconRight: t3, onClick: handleClick, pressed: action.selected, text: title, tone: action.tone }), $[4] = action.icon, $[5] = action.selected, $[6] = action.tone, $[7] = handleClick, $[8] = t2, $[9] = t3, $[10] = title, $[11] = t4) : t4 = $[11];
  let t5;
  return $[12] !== disabledTooltipContent || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(TooltipOfDisabled, { content: disabledTooltipContent, placement: "left", children: t4 }), $[12] = disabledTooltipContent, $[13] = t4, $[14] = t5) : t5 = $[14], t5;
}
function FieldActionMenuNode(props2) {
  const $ = c(15), {
    action,
    isFirst,
    prevIsGroup
  } = props2;
  if (action.type === "divider") {
    let t02;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(MenuDivider, {}), $[0] = t02) : t02 = $[0], t02;
  }
  if (action.type === "group") {
    let t02;
    $[1] !== isFirst ? (t02 = !isFirst && /* @__PURE__ */ jsx(MenuDivider, {}), $[1] = isFirst, $[2] = t02) : t02 = $[2];
    let t12;
    $[3] !== action ? (t12 = /* @__PURE__ */ jsx(FieldActionMenuGroup, { group: action }), $[3] = action, $[4] = t12) : t12 = $[4];
    let t22;
    return $[5] !== t02 || $[6] !== t12 ? (t22 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t02,
      t12
    ] }), $[5] = t02, $[6] = t12, $[7] = t22) : t22 = $[7], t22;
  }
  let t0;
  $[8] !== prevIsGroup ? (t0 = prevIsGroup && /* @__PURE__ */ jsx(MenuDivider, {}), $[8] = prevIsGroup, $[9] = t0) : t0 = $[9];
  let t1;
  $[10] !== action ? (t1 = /* @__PURE__ */ jsx(FieldActionMenuItem, { action }), $[10] = action, $[11] = t1) : t1 = $[11];
  let t2;
  return $[12] !== t0 || $[13] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t0,
    t1
  ] }), $[12] = t0, $[13] = t1, $[14] = t2) : t2 = $[14], t2;
}
const STATUS_BUTTON_TOOLTIP_PROPS = {
  placement: "top"
};
function renderAsButton(node) {
  return "renderAsButton" in node && node.renderAsButton;
}
const FieldActionMenu = memo(function(props2) {
  const {
    nodes,
    onMenuOpenChange
  } = props2, [open, setOpen] = useState(!1), handleOpen = useCallback(() => {
    onMenuOpenChange(!0), setOpen(!0);
  }, [onMenuOpenChange]), handleClose = useCallback(() => {
    onMenuOpenChange(!1), setOpen(!1);
  }, [onMenuOpenChange]), buttonNodes = useMemo(() => nodes.filter(renderAsButton), [nodes]), menuNodesProp = useMemo(() => nodes.filter((node) => !renderAsButton(node)), [nodes]), menuNodes = useMemo(() => {
    const len = menuNodesProp.length;
    if (len === 0 || len > 1) return menuNodesProp;
    const node_0 = menuNodesProp[0];
    return node_0.type === "group" ? [{
      ...node_0,
      expanded: !0
    }] : menuNodesProp;
  }, [menuNodesProp]), rootNodes = useMemo(() => [...menuNodes.length ? [{
    type: "group",
    children: menuNodes,
    icon: EllipsisHorizontalIcon,
    title: "Field actions"
  }] : [], ...buttonNodes], [buttonNodes, menuNodes]);
  return /* @__PURE__ */ jsx(Fragment, { children: rootNodes.map((node_1, idx) => /* @__PURE__ */ jsx(
    RootFieldActionMenuNode,
    {
      node: node_1,
      onOpen: handleOpen,
      onClose: handleClose,
      open
    },
    idx
  )) });
}), RootFieldActionMenuNode = memo(function(props2) {
  const $ = c(12), {
    node,
    onOpen,
    onClose,
    open
  } = props2;
  if (node.type === "divider") {
    let t02;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(Card, { borderLeft: !0, flex: "none" }), $[0] = t02) : t02 = $[0], t02;
  }
  if (node.type === "action") {
    let t02;
    $[1] !== node.title ? (t02 = {
      ...STATUS_BUTTON_TOOLTIP_PROPS,
      content: node.title
    }, $[1] = node.title, $[2] = t02) : t02 = $[2];
    let t1;
    return $[3] !== node.icon || $[4] !== node.onAction || $[5] !== t02 ? (t1 = /* @__PURE__ */ jsx(Button, { icon: node.icon, mode: "bleed", onClick: node.onAction, tooltipProps: t02 }), $[3] = node.icon, $[4] = node.onAction, $[5] = t02, $[6] = t1) : t1 = $[6], t1;
  }
  let t0;
  return $[7] !== node || $[8] !== onClose || $[9] !== onOpen || $[10] !== open ? (t0 = /* @__PURE__ */ jsx(RootFieldActionMenuGroup, { node, onOpen, onClose, open }), $[7] = node, $[8] = onClose, $[9] = onOpen, $[10] = open, $[11] = t0) : t0 = $[11], t0;
}), ROOT_MENU_BUTTON_POPOVER_PROPS = {
  constrainSize: !0,
  placement: "right",
  portal: !0,
  fallbackPlacements: ["top", "bottom"]
};
function RootFieldActionMenuGroup(props2) {
  const $ = c(16), {
    node,
    onOpen,
    onClose,
    open
  } = props2, {
    title
  } = useI18nText(node), t0 = open ? void 0 : title;
  let t1;
  $[0] !== node.title ? (t1 = {
    ...STATUS_BUTTON_TOOLTIP_PROPS,
    content: node.title
  }, $[0] = node.title, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== node.icon || $[3] !== t0 || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Button, { "aria-label": t0, "data-testid": "field-actions-trigger", icon: node.icon, mode: "bleed", tabIndex: 0, tooltipProps: t1 }), $[2] = node.icon, $[3] = t0, $[4] = t1, $[5] = t2) : t2 = $[5];
  const t3 = useId();
  let t4;
  $[6] !== node.children ? (t4 = node.children.map((action, idx) => /* @__PURE__ */ jsx(FieldActionMenuNode, { action, isFirst: idx === 0, prevIsGroup: node.children[idx - 1]?.type === "group" }, idx)), $[6] = node.children, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Menu, { children: t4 }), $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== onClose || $[11] !== onOpen || $[12] !== t2 || $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuButton$1, { button: t2, id: t3, menu: t5, onOpen, onClose, popover: ROOT_MENU_BUTTON_POPOVER_PROPS }), $[10] = onClose, $[11] = onOpen, $[12] = t2, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function useHoveredField() {
  return useContext(HoveredFieldContext);
}
const FieldActionsProvider = memo(function(props2) {
  const $ = c(18), {
    actions,
    children,
    path,
    focused
  } = props2, {
    onMouseEnter: onFieldMouseEnter,
    onMouseLeave: onFieldMouseLeave,
    store: hoveredStore
  } = useHoveredField();
  let t0;
  $[0] !== hoveredStore || $[1] !== path ? (t0 = () => {
    const [hoveredPath] = hoveredStore.getSnapshot();
    return supportsTouch || (hoveredPath ? pathToString$1(path) === hoveredPath : !1);
  }, $[0] = hoveredStore, $[1] = path, $[2] = t0) : t0 = $[2];
  const hovered = useSyncExternalStore(hoveredStore.subscribe, t0);
  let t1;
  $[3] !== onFieldMouseEnter || $[4] !== path ? (t1 = () => {
    onFieldMouseEnter(path);
  }, $[3] = onFieldMouseEnter, $[4] = path, $[5] = t1) : t1 = $[5];
  const handleMouseEnter = t1;
  let t2;
  $[6] !== onFieldMouseLeave || $[7] !== path ? (t2 = () => {
    onFieldMouseLeave(path);
  }, $[6] = onFieldMouseLeave, $[7] = path, $[8] = t2) : t2 = $[8];
  const handleMouseLeave = t2;
  let t3, t4;
  $[9] !== actions || $[10] !== focused || $[11] !== handleMouseEnter || $[12] !== handleMouseLeave || $[13] !== hovered ? (t4 = {
    actions,
    focused,
    hovered,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, $[9] = actions, $[10] = focused, $[11] = handleMouseEnter, $[12] = handleMouseLeave, $[13] = hovered, $[14] = t4) : t4 = $[14], t3 = t4;
  const context = t3;
  let t5;
  return $[15] !== children || $[16] !== context ? (t5 = /* @__PURE__ */ jsx(FieldActionsContext.Provider, { value: context, children }), $[15] = children, $[16] = context, $[17] = t5) : t5 = $[17], t5;
});
FieldActionsProvider.displayName = "Memo(FieldActionsProvider)";
function filterActions(actions) {
  return actions.filter(Boolean).filter((node) => "hidden" in node ? node.hidden !== !0 : !0).map((node) => node.type === "group" ? {
    ...node,
    children: filterActions(node.children)
  } : node);
}
const FieldActionsResolver = memo(function(props2) {
  const {
    actions,
    documentId,
    documentType,
    onActions,
    path,
    schemaType
  } = props2, len = actions.length, lenRef = useRef(len), [fieldActions, setFieldActions] = useState(() => Array.from(new Array(len))), fieldActionsRef = useRef(fieldActions), setFieldAction = useCallback((index, node) => {
    setFieldActions((prev) => {
      const next = [...prev];
      return next[index] = node, next;
    });
  }, []);
  useEffect(() => {
    fieldActionsRef.current !== fieldActions && (fieldActionsRef.current = fieldActions, onActions(filterActions(fieldActions)));
  }, [fieldActions, onActions]), useEffect(() => {
    if (lenRef.current !== len) {
      const newFieldActions = Array.from(new Array(len));
      for (let i = 0; i < len; i++)
        newFieldActions[i] = fieldActionsRef.current[i];
      lenRef.current = len, setFieldActions(newFieldActions), fieldActionsRef.current = newFieldActions;
    }
  }, [len]);
  const FieldActions = useMemo(() => actions.map((action, index_0) => defineFieldActionComponent({
    action,
    documentId,
    documentType,
    index: index_0,
    path,
    schemaType,
    setFieldAction
  })), [actions, documentId, documentType, path, schemaType, setFieldAction]);
  return /* @__PURE__ */ jsx(Fragment, { children: FieldActions.map((FieldAction, key) => /* @__PURE__ */ jsx(
    FieldAction,
    {},
    key
  )) });
});
function defineFieldActionComponent({
  action,
  documentId,
  documentType,
  index,
  path,
  schemaType,
  setFieldAction
}) {
  const {
    useAction
  } = action;
  return memo(function() {
    const $ = c(4);
    let t0;
    $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      documentId,
      documentType,
      path,
      schemaType
    }, $[0] = t0) : t0 = $[0];
    const _action = useAction(t0), node = useUnique(_action);
    let t1, t2;
    return $[1] !== node ? (t1 = () => {
      setFieldAction(index, node);
    }, t2 = [node], $[1] = node, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), null;
  });
}
function useFieldActions() {
  return useContext(FieldActionsContext);
}
const HoveredFieldProvider = memo(function(props2) {
  const $ = c(17), {
    children
  } = props2, [listeners] = useState(_temp$22);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const hoveredStackRef = useRef(t0);
  let t1;
  $[1] !== listeners ? (t1 = (path) => {
    const pathString = pathToString$1(path);
    if (!hoveredStackRef.current.includes(pathString)) {
      hoveredStackRef.current = [pathString, ...hoveredStackRef.current];
      for (const listener of listeners)
        listener();
    }
  }, $[1] = listeners, $[2] = t1) : t1 = $[2];
  const handleMouseEnter = t1;
  let t2;
  $[3] !== listeners ? (t2 = (path_0) => {
    const pathString_0 = pathToString$1(path_0);
    if (hoveredStackRef.current.includes(pathString_0)) {
      hoveredStackRef.current = hoveredStackRef.current.filter((item) => item !== pathString_0);
      for (const listener_0 of listeners)
        listener_0();
    }
  }, $[3] = listeners, $[4] = t2) : t2 = $[4];
  const handleMouseLeave = t2;
  let t3, t4;
  $[5] !== listeners ? (t4 = (onStoreChange) => (listeners.add(onStoreChange), () => {
    listeners.delete(onStoreChange);
  }), $[5] = listeners, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => hoveredStackRef.current, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t4 ? (t6 = {
    subscribe: t4,
    getSnapshot: t5
  }, $[8] = t4, $[9] = t6) : t6 = $[9], t3 = t6;
  const store = t3;
  let t7, t8;
  $[10] !== handleMouseEnter || $[11] !== handleMouseLeave || $[12] !== store ? (t8 = {
    store,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, $[10] = handleMouseEnter, $[11] = handleMouseLeave, $[12] = store, $[13] = t8) : t8 = $[13], t7 = t8;
  const context = t7;
  let t9;
  return $[14] !== children || $[15] !== context ? (t9 = /* @__PURE__ */ jsx(HoveredFieldContext.Provider, { value: context, children }), $[14] = children, $[15] = context, $[16] = t9) : t9 = $[16], t9;
});
function _temp$22() {
  return /* @__PURE__ */ new Set();
}
const Root$x = styled(Flex)(({
  theme,
  $floatingCardWidth,
  $slotWidth,
  $floatingCardVisible
}) => {
  const {
    space
  } = theme.sanity;
  return css`
    /* Prevent buttons from taking up extra vertical space */
    line-height: 1;
    width: 100%;
    /* For floating actions menu */
    position: relative;

    [data-ui='PresenceBox'] {
      position: absolute;
      bottom: 0;
      right: ${$slotWidth + $floatingCardWidth + space[1]}px;
    }
    @media (hover: hover) {
      // If hover is supported, we hide the floating card by default, so only add space for it when it's visible.
      [data-ui='PresenceBox'] {
        position: absolute;
        bottom: 0;
        right: ${$slotWidth + ($floatingCardVisible ? $floatingCardWidth : 0) + space[1]}px;
      }
    }
  `;
}), ContentBox = styled(Box)(({
  theme,
  $presenceMaxWidth
}) => {
  const {
    space
  } = theme.sanity;
  return css`
    max-width: calc(100% - ${$presenceMaxWidth + space[1]}px);
    min-width: 75%;
  `;
}), SlotBox = styled(Box)(({
  theme,
  $right,
  $fieldActionsVisible
}) => {
  const {
    space
  } = theme.sanity, right = $fieldActionsVisible ? $right + space[1] : $right;
  return css`
    position: absolute;
    bottom: 0;
    right: ${right}px;
  `;
}), FieldActionsFloatingCard = styled(Card)`
  align-items: center;
  bottom: 0;
  position: absolute;
  right: 0;
  transition: opacity 150ms ease;
  line-height: 1;

  @media (hover: hover) {
    // If hover is supported, we hide the floating card by default
    // and only show it when it has focus within or when the field is hovered or focused.
    opacity: 0;
    pointer-events: none;

    [data-ui='FieldActionsFlex'] {
      opacity: 0;
    }

    &[data-actions-visible='false']:not(:focus-within) {
      // Remove the shadow when the field actions are not visible
      box-shadow: none;

      // Since the field actions always will be present in the DOM (to make them focusable) –
      // they will always affect the width of the floating card, even when they are not visible.
      // Therefore, we remove the background of the floating card when the field actions are not visible.
      background: transparent;
    }

    // Remove the shadow when the field has comments but no actions
    &[data-has-comments='true']:not([data-has-actions='true']) {
      box-shadow: none;
    }

    // Show the floating card when it has focus within (ie when field actions are focused).
    &:focus-within {
      opacity: 1;
      pointer-events: auto;
      width: max-content;

      [data-ui='FieldActionsFlex'] {
        opacity: 1;
        pointer-events: auto;
        width: max-content;
      }
    }
  }

  &[data-visible='true'] {
    opacity: 1;
    pointer-events: auto;
    width: max-content;
  }

  &[data-actions-visible='true'] {
    [data-ui='FieldActionsFlex'] {
      opacity: 1;
      pointer-events: auto;
      width: max-content;
    }
  }
`, FieldActionsFlex = styled(Flex)`
  gap: inherit;
  transition: opacity 150ms ease;
`, MAX_AVATARS = 4;
function FormFieldBaseHeader(props2) {
  const $ = c(44), {
    __internal_comments: comments2,
    __internal_slot: slot,
    actions,
    content,
    fieldFocused,
    fieldHovered,
    presence,
    inputId
  } = props2, [focused, setFocused] = useState(!1), [menuOpen, setMenuOpen] = useState(!1), [floatingCardElement, setFloatingCardElement] = useState(null), [floatingCardWidth, setFloatingCardWidth] = useState(0), [slotElement, setSlotElement] = useState(null), [slotWidth, setSlotWidth] = useState(0);
  let t0;
  $[0] !== comments2 ? (t0 = comments2 || {}, $[0] = comments2, $[1] = t0) : t0 = $[1];
  const {
    hasComments: t1,
    button: t2,
    isAddingComment: t3
  } = t0, hasComments = t1 === void 0 ? !1 : t1, commentButton = t2 === void 0 ? null : t2, isAddingComment = t3 === void 0 ? !1 : t3, hasActions = actions && actions.length > 0, showFieldActions = fieldFocused || fieldHovered || menuOpen || isAddingComment, hasCommentsButtonOrActions = comments2?.button || hasActions, shouldShowFloatingCard = focused || showFieldActions || hasComments;
  let t4;
  $[2] !== floatingCardElement ? (t4 = () => {
    if (floatingCardElement) {
      const {
        width
      } = floatingCardElement.getBoundingClientRect();
      setFloatingCardWidth(width || 0);
    }
  }, $[2] = floatingCardElement, $[3] = t4) : t4 = $[3];
  const handleSetFloatingCardElementWidth = t4;
  let t5;
  $[4] !== handleSetFloatingCardElementWidth ? (t5 = () => {
    handleSetFloatingCardElementWidth(), setFocused(!0);
  }, $[4] = handleSetFloatingCardElementWidth, $[5] = t5) : t5 = $[5];
  const handleFocusCapture = t5;
  let t6;
  $[6] !== handleSetFloatingCardElementWidth ? (t6 = () => {
    handleSetFloatingCardElementWidth(), setFocused(!1);
  }, $[6] = handleSetFloatingCardElementWidth, $[7] = t6) : t6 = $[7];
  const handleBlurCapture = t6;
  let t7;
  $[8] !== handleSetFloatingCardElementWidth ? (t7 = () => {
    handleSetFloatingCardElementWidth();
  }, $[8] = handleSetFloatingCardElementWidth, $[9] = t7) : t7 = $[9];
  let t8;
  $[10] !== handleSetFloatingCardElementWidth || $[11] !== showFieldActions ? (t8 = [handleSetFloatingCardElementWidth, showFieldActions], $[10] = handleSetFloatingCardElementWidth, $[11] = showFieldActions, $[12] = t8) : t8 = $[12], useEffect(t7, t8);
  let t10, t9;
  $[13] !== slotElement ? (t9 = () => {
    if (slotElement) {
      const {
        width: width_0
      } = slotElement.getBoundingClientRect();
      setSlotWidth(width_0 || 0);
    }
  }, t10 = [slotElement], $[13] = slotElement, $[14] = t10, $[15] = t9) : (t10 = $[14], t9 = $[15]), useEffect(t9, t10);
  let t11;
  bb0: {
    if (!slot) {
      t11 = null;
      break bb0;
    }
    const t122 = !!showFieldActions;
    let t132;
    $[16] !== floatingCardWidth || $[17] !== slot || $[18] !== t122 ? (t132 = /* @__PURE__ */ jsx(SlotBox, { $fieldActionsVisible: t122, $right: floatingCardWidth, ref: setSlotElement, children: slot }), $[16] = floatingCardWidth, $[17] = slot, $[18] = t122, $[19] = t132) : t132 = $[19], t11 = t132;
  }
  const slotEl = t11;
  let t12;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t12 = calcAvatarStackWidth(MAX_AVATARS), $[20] = t12) : t12 = $[20];
  let t13;
  $[21] !== content ? (t13 = /* @__PURE__ */ jsx(ContentBox, { "data-ui": "fieldHeaderContentBox", flex: 1, paddingY: 2, $presenceMaxWidth: t12, children: content }), $[21] = content, $[22] = t13) : t13 = $[22];
  let t14;
  $[23] !== presence ? (t14 = presence && presence.length > 0 && /* @__PURE__ */ jsx(Box, { "data-ui": "PresenceBox", flex: "none", children: /* @__PURE__ */ jsx(FieldPresence, { maxAvatars: MAX_AVATARS, presence }) }), $[23] = presence, $[24] = t14) : t14 = $[24];
  let t15;
  $[25] !== actions || $[26] !== commentButton || $[27] !== handleBlurCapture || $[28] !== handleFocusCapture || $[29] !== hasActions || $[30] !== hasComments || $[31] !== hasCommentsButtonOrActions || $[32] !== inputId || $[33] !== shouldShowFloatingCard || $[34] !== showFieldActions ? (t15 = (hasCommentsButtonOrActions || hasComments) && /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(FieldActionsFloatingCard, { "data-actions-visible": showFieldActions ? "true" : "false", "data-has-actions": hasActions ? "true" : "false", "data-has-comments": hasComments ? "true" : "false", "data-visible": shouldShowFloatingCard ? "true" : "false", display: "flex", onBlurCapture: handleBlurCapture, onFocusCapture: handleFocusCapture, ref: setFloatingCardElement, sizing: "border", children: [
    hasActions && /* @__PURE__ */ jsx(FieldActionsFlex, { align: "center", "data-ui": "FieldActionsFlex", "data-testid": inputId ? `field-actions-menu-${inputId}` : "field-actions-menu", children: /* @__PURE__ */ jsx(FieldActionMenu, { nodes: actions, onMenuOpenChange: setMenuOpen }) }),
    commentButton
  ] }) }), $[25] = actions, $[26] = commentButton, $[27] = handleBlurCapture, $[28] = handleFocusCapture, $[29] = hasActions, $[30] = hasComments, $[31] = hasCommentsButtonOrActions, $[32] = inputId, $[33] = shouldShowFloatingCard, $[34] = showFieldActions, $[35] = t15) : t15 = $[35];
  let t16;
  return $[36] !== floatingCardWidth || $[37] !== shouldShowFloatingCard || $[38] !== slotEl || $[39] !== slotWidth || $[40] !== t13 || $[41] !== t14 || $[42] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Root$x, { align: "flex-end", justify: "space-between", $floatingCardVisible: shouldShowFloatingCard, $floatingCardWidth: floatingCardWidth, $slotWidth: slotWidth, children: [
    t13,
    t14,
    slotEl,
    t15
  ] }), $[36] = floatingCardWidth, $[37] = shouldShowFloatingCard, $[38] = slotEl, $[39] = slotWidth, $[40] = t13, $[41] = t14, $[42] = t15, $[43] = t16) : t16 = $[43], t16;
}
function createDescriptionId(id2, description) {
  if (!(!description || !id2))
    return `desc_${id2}`;
}
const StatusIconWrapper = styled.div`
  left: 8px;
  position: relative;
  width: 25px;
`, EMPTY_ARRAY$s = [], VALIDATION_ICONS = {
  error: ValidationErrorIcon,
  warning: ValidationWarningIcon,
  info: ValidationInfoIcon
}, StyledStack = styled(Stack)`
  max-width: 200px;
`, StatusText = styled(Text$1)(({
  $status
}) => $status === "error" ? {
  "--card-icon-color": "var(--card-badge-critical-icon-color)"
} : $status === "warning" ? {
  "--card-icon-color": "var(--card-badge-caution-icon-color)"
} : $status === "info" ? {
  "--card-icon-color": "var(--card-badge-primary-icon-color)"
} : {});
function FormFieldValidationStatus(props2) {
  const $ = c(20), {
    validation: t0,
    __unstable_showSummary: showSummary,
    fontSize,
    placement
  } = props2, validation2 = t0 === void 0 ? EMPTY_ARRAY$s : t0, hasErrors = validation2.some(_temp$21), hasWarnings = validation2.some(_temp2$J), status = hasErrors ? "error" : hasWarnings ? "warning" : "info", StatusIcon = VALIDATION_ICONS[status];
  let t1;
  $[0] !== showSummary || $[1] !== validation2 ? (t1 = showSummary && /* @__PURE__ */ jsx(FormFieldValidationSummary, { validation: validation2 }), $[0] = showSummary, $[1] = validation2, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== showSummary || $[4] !== validation2 ? (t2 = !showSummary && /* @__PURE__ */ jsx(Fragment, { children: validation2.map(_temp3$d) }), $[3] = showSummary, $[4] = validation2, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t1 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsxs(StyledStack, { space: 3, children: [
    t1,
    t2
  ] }), $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t4 = ["bottom", "right", "left"], $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== StatusIcon ? (t5 = StatusIcon && /* @__PURE__ */ jsx(StatusIcon, {}), $[10] = StatusIcon, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== fontSize || $[13] !== status || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(StatusIconWrapper, { children: /* @__PURE__ */ jsx(StatusText, { $status: status, size: fontSize, weight: "medium", children: t5 }) }), $[12] = fontSize, $[13] = status, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  return $[16] !== placement || $[17] !== t3 || $[18] !== t6 ? (t7 = /* @__PURE__ */ jsx(Tooltip, { content: t3, portal: !0, placement, fallbackPlacements: t4, children: t6 }), $[16] = placement, $[17] = t3, $[18] = t6, $[19] = t7) : t7 = $[19], t7;
}
function _temp3$d(item, itemIndex) {
  return /* @__PURE__ */ jsx(FormFieldValidationStatusItem, { validation: item }, itemIndex);
}
function _temp2$J(v_0) {
  return v_0.level === "warning";
}
function _temp$21(v) {
  return v.level === "error";
}
function FormFieldValidationStatusItem(props2) {
  const $ = c(10), {
    validation: validation2
  } = props2, StatusIcon = VALIDATION_ICONS[validation2.level];
  let t0;
  $[0] !== StatusIcon ? (t0 = StatusIcon && /* @__PURE__ */ jsx(StatusIcon, {}), $[0] = StatusIcon, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 || $[3] !== validation2.level ? (t1 = /* @__PURE__ */ jsx(Box, { marginRight: 2, children: /* @__PURE__ */ jsx(StatusText, { $status: validation2.level, size: 1, children: t0 }) }), $[2] = t0, $[3] = validation2.level, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== validation2.message ? (t2 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: validation2.message }) }), $[5] = validation2.message, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== t1 || $[8] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Flex, { children: [
    t1,
    t2
  ] }), $[7] = t1, $[8] = t2, $[9] = t3) : t3 = $[9], t3;
}
function FormFieldValidationSummary(t0) {
  const $ = c(7), {
    validation: validation2
  } = t0, {
    t
  } = useTranslation(), listFormatter = useListFormat(), errorCount = validation2.reduce(_temp4$7, 0), warningCount = validation2.reduce(_temp5$4, 0), hasErrors = errorCount > 0, hasWarnings = warningCount > 0;
  if (!hasErrors && !hasWarnings)
    return null;
  let t1;
  if ($[0] !== errorCount || $[1] !== hasErrors || $[2] !== hasWarnings || $[3] !== listFormatter || $[4] !== t || $[5] !== warningCount) {
    const errorText = hasErrors && t("form.validation.summary.errors-count", {
      count: errorCount
    }), warningText = hasWarnings && t("form.validation.summary.warnings-count", {
      count: warningCount
    });
    t1 = errorText && warningText ? /* @__PURE__ */ jsx(Text$1, { size: 1, children: listFormatter.format([errorText, warningText]) }) : /* @__PURE__ */ jsx(Text$1, { size: 1, children: errorText || warningText }), $[0] = errorCount, $[1] = hasErrors, $[2] = hasWarnings, $[3] = listFormatter, $[4] = t, $[5] = warningCount, $[6] = t1;
  } else
    t1 = $[6];
  return t1;
}
function _temp5$4(count_0, item_0) {
  return item_0.level === "warning" ? count_0 + 1 : count_0;
}
function _temp4$7(count2, item) {
  return item.level === "error" ? count2 + 1 : count2;
}
function ValidationErrorIcon() {
  const $ = c(4), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("form.validation.has-error-aria-label"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(ErrorOutlineIcon, { "data-testid": "input-validation-icon-error", "aria-label": t0, "aria-hidden": !0, role: "presentation" }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
function ValidationWarningIcon() {
  const $ = c(4), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("form.validation.has-warning-aria-label"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(WarningOutlineIcon, { "data-testid": "input-validation-icon-warning", "aria-label": t0, "aria-hidden": !0, role: "presentation" }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
function ValidationInfoIcon() {
  const $ = c(4), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("form.validation.has-info-aria-label"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(InfoOutlineIcon, { "data-testid": "input-validation-icon-info", "aria-label": t0, "aria-hidden": !0, role: "presentation" }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
const LabelSuffix = styled(Flex)`
  /*
   * Prevent the block size of appended elements (such as the deprecated field badge) affecting
   * the intrinsic block size of the label.
   */
  contain: size;
`, EMPTY_ARRAY$r = [], FormFieldHeaderText = memo(function(props2) {
  const $ = c(26), {
    description,
    inputId,
    title,
    deprecated,
    validation: t0
  } = props2, validation2 = t0 === void 0 ? EMPTY_ARRAY$r : t0, {
    t
  } = useTranslation(), hasValidations = validation2.length > 0, hasLabelSuffix = deprecated || hasValidations;
  let t1;
  $[0] !== t || $[1] !== title ? (t1 = title || /* @__PURE__ */ jsx("span", { style: {
    color: "var(--card-muted-fg-color)"
  }, children: t("form.field.untitled-field-label") }), $[0] = t, $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== inputId || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { as: "label", htmlFor: inputId, weight: "medium", size: 1, children: t1 }), $[3] = inputId, $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== deprecated || $[7] !== hasLabelSuffix || $[8] !== hasValidations || $[9] !== t || $[10] !== title || $[11] !== validation2 ? (t3 = hasLabelSuffix && /* @__PURE__ */ jsxs(LabelSuffix, { align: "center", flex: 1, children: [
    deprecated && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Badge, { "data-testid": `deprecated-badge-${title}`, tone: "caution", children: t("form.field.deprecated-label") }) }),
    hasValidations && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { fontSize: 1, placement: "top", validation: validation2 }) })
  ] }), $[6] = deprecated, $[7] = hasLabelSuffix, $[8] = hasValidations, $[9] = t, $[10] = title, $[11] = validation2, $[12] = t3) : t3 = $[12];
  let t4;
  $[13] !== t2 || $[14] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", paddingY: 1, children: [
    t2,
    t3
  ] }), $[13] = t2, $[14] = t3, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== deprecated || $[17] !== title ? (t5 = deprecated && /* @__PURE__ */ jsx(TextWithTone, { "data-testid": `deprecated-message-${title}`, tone: "caution", size: 1, children: deprecated.reason }), $[16] = deprecated, $[17] = title, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== description || $[20] !== inputId ? (t6 = description && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, id: createDescriptionId(inputId, description), children: description }), $[19] = description, $[20] = inputId, $[21] = t6) : t6 = $[21];
  let t7;
  return $[22] !== t4 || $[23] !== t5 || $[24] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t4,
    t5,
    t6
  ] }), $[22] = t4, $[23] = t5, $[24] = t6, $[25] = t7) : t7 = $[25], t7;
}), EMPTY_ARRAY$q = [], FormField = memo(function(props2) {
  const $ = c(34);
  let children, comments2, deprecated, description, inputId, level, restProps, t0, t1, t2, title, validation2;
  $[0] !== props2 ? ({
    __unstable_headerActions: t0,
    __unstable_presence: t1,
    __internal_slot: t2,
    __internal_comments: comments2,
    children,
    description,
    inputId,
    level,
    title,
    validation: validation2,
    deprecated,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = comments2, $[3] = deprecated, $[4] = description, $[5] = inputId, $[6] = level, $[7] = restProps, $[8] = t0, $[9] = t1, $[10] = t2, $[11] = title, $[12] = validation2) : (children = $[1], comments2 = $[2], deprecated = $[3], description = $[4], inputId = $[5], level = $[6], restProps = $[7], t0 = $[8], t1 = $[9], t2 = $[10], title = $[11], validation2 = $[12]);
  const actions = t0 === void 0 ? EMPTY_ARRAY$q : t0, presence = t1 === void 0 ? EMPTY_ARRAY$q : t1, slot = t2 === void 0 ? null : t2, {
    focused,
    hovered,
    onMouseEnter,
    onMouseLeave
  } = useFieldActions();
  let t3;
  $[13] !== actions || $[14] !== comments2 || $[15] !== deprecated || $[16] !== description || $[17] !== focused || $[18] !== hovered || $[19] !== inputId || $[20] !== presence || $[21] !== slot || $[22] !== title || $[23] !== validation2 ? (t3 = title && /* @__PURE__ */ jsx(FormFieldBaseHeader, { __internal_comments: comments2, __internal_slot: slot, actions, fieldFocused: !!focused, fieldHovered: hovered, presence, inputId, content: /* @__PURE__ */ jsx(FormFieldHeaderText, { description, inputId, title, validation: validation2, deprecated }) }), $[13] = actions, $[14] = comments2, $[15] = deprecated, $[16] = description, $[17] = focused, $[18] = hovered, $[19] = inputId, $[20] = presence, $[21] = slot, $[22] = title, $[23] = validation2, $[24] = t3) : t3 = $[24];
  let t4;
  $[25] !== children ? (t4 = /* @__PURE__ */ jsx("div", { children }), $[25] = children, $[26] = t4) : t4 = $[26];
  let t5;
  return $[27] !== level || $[28] !== onMouseEnter || $[29] !== onMouseLeave || $[30] !== restProps || $[31] !== t3 || $[32] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { ...restProps, "data-level": level, onMouseEnter, onMouseLeave, space: 2, children: [
    t3,
    t4
  ] }), $[27] = level, $[28] = onMouseEnter, $[29] = onMouseLeave, $[30] = restProps, $[31] = t3, $[32] = t4, $[33] = t5) : t5 = $[33], t5;
}), Root$w = styled.legend`
  /* See: https://thatemil.com/blog/2015/01/03/reset-your-fieldset/ */
  padding: 0;
  display: table;
`, ToggleButton = styled(Flex).attrs({
  forwardedAs: "button"
})((props2) => {
  const {
    theme
  } = props2, {
    focusRing,
    radius
  } = theme.sanity, {
    base
  } = theme.sanity.color;
  return css`
    appearance: none;
    border: 0;
    background: none;
    color: inherit;
    -webkit-font-smoothing: inherit;
    font: inherit;
    outline: none;
    border-radius: ${rem(radius[2])};
    position: relative;

    &:not([hidden]) {
      display: flex;
    }

    &:focus {
      box-shadow: ${focusRingStyle$2({
    base,
    focusRing
  })};
    }

    &:focus:not(:focus-visible) {
      box-shadow: none;
    }

    /* Added to increase the hit area of the collapsible fieldset */
    &::after {
      content: '';
      position: absolute;
      top: -10px;
      right: -10px;
      bottom: -10px;
      left: -10px;
    }
  `;
}), ToggleIconBox = styled(Box)`
  width: 9px;
  height: 9px;
  margin-right: 3px;

  & svg {
    transition: transform 100ms;
  }
`, FormFieldSetLegend = memo(function(props2) {
  const $ = c(10), {
    collapsed,
    collapsible,
    onClick: onClick2,
    title
  } = props2;
  let t0;
  $[0] !== title ? (t0 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: title }), $[0] = title, $[1] = t0) : t0 = $[1];
  const text = t0;
  if (!collapsible) {
    let t12;
    return $[2] !== text ? (t12 = /* @__PURE__ */ jsx(Root$w, { children: text }), $[2] = text, $[3] = t12) : t12 = $[3], t12;
  }
  const t1 = `rotate(${collapsed ? "0" : "90deg"}) translate3d(0, 0, 0)`;
  let t2;
  $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(ToggleIconBox, { children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ToggleArrowRightIcon, { style: {
    transform: t1
  } }) }) }), $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== onClick2 || $[7] !== t2 || $[8] !== text ? (t3 = /* @__PURE__ */ jsx(Root$w, { children: /* @__PURE__ */ jsxs(ToggleButton, { type: "button", onClick: onClick2, children: [
    t2,
    text
  ] }) }), $[6] = onClick2, $[7] = t2, $[8] = text, $[9] = t3) : t3 = $[9], t3;
});
function getChildren(children) {
  return typeof children == "function" ? children() : children;
}
const Root$v = styled(Stack).attrs({
  forwardedAs: "fieldset"
})`
  border: none;

  /* See: https://thatemil.com/blog/2015/01/03/reset-your-fieldset/ */
  body:not(:-moz-handler-blocked) & {
    display: table-cell;
  }
`, Content$1 = styled(Box)((props2) => {
  const {
    $borderLeft,
    $focused,
    theme
  } = props2, {
    focusRing
  } = theme.sanity, {
    base
  } = theme.sanity.color;
  return css`
    outline: none;
    border-left: ${$borderLeft ? "1px solid var(--card-border-color)" : void 0};
    transition:
      border-color 0.2s ease-in-out,
      box-shadow 0.2s ease-in-out;

    ${$borderLeft && $focused && `border-left: 1px solid var(--card-focus-ring-color);
    box-shadow: inset 1px 0 0 var(--card-focus-ring-color);`}

    ${$borderLeft && !$focused && `
      box-shadow: inset 0 0 0 transparent;
    `}

    &:focus {
      box-shadow: ${focusRingStyle$2({
    base,
    focusRing: {
      ...focusRing,
      offset: 2
    }
  })};
    }

    &:focus:not(:focus-visible) {
      box-shadow: none;
    }
  `;
}), EMPTY_ARRAY$p = [], FormFieldSet = forwardRef(function(props2, forwardedRef) {
  const $ = c(82);
  let children, collapsed, collapsible, columns, comments2, deprecated, description, inputId, onCollapse, onExpand, onFocus, restProps, t0, t1, t2, t3, t4, tabIndex, title;
  $[0] !== props2 ? ({
    __internal_comments: comments2,
    __internal_slot: t0,
    __unstable_headerActions: t1,
    __unstable_presence: t2,
    children,
    collapsed,
    collapsible,
    columns,
    description,
    level: t3,
    onCollapse,
    onExpand,
    onFocus,
    tabIndex,
    title,
    validation: t4,
    inputId,
    deprecated,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = collapsed, $[3] = collapsible, $[4] = columns, $[5] = comments2, $[6] = deprecated, $[7] = description, $[8] = inputId, $[9] = onCollapse, $[10] = onExpand, $[11] = onFocus, $[12] = restProps, $[13] = t0, $[14] = t1, $[15] = t2, $[16] = t3, $[17] = t4, $[18] = tabIndex, $[19] = title) : (children = $[1], collapsed = $[2], collapsible = $[3], columns = $[4], comments2 = $[5], deprecated = $[6], description = $[7], inputId = $[8], onCollapse = $[9], onExpand = $[10], onFocus = $[11], restProps = $[12], t0 = $[13], t1 = $[14], t2 = $[15], t3 = $[16], t4 = $[17], tabIndex = $[18], title = $[19]);
  const slot = t0 === void 0 ? null : t0, actions = t1 === void 0 ? EMPTY_ARRAY$p : t1, presence = t2 === void 0 ? EMPTY_ARRAY$p : t2, level = t3 === void 0 ? 0 : t3, validation2 = t4 === void 0 ? EMPTY_ARRAY$p : t4, {
    focused,
    hovered,
    onMouseEnter,
    onMouseLeave
  } = useFieldActions(), hasValidationMarkers = validation2.length > 0, ref = useRef(null), {
    t
  } = useTranslation();
  let t5;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => ref.current, $[20] = t5) : t5 = $[20], useImperativeHandle(forwardedRef, t5);
  let t6;
  $[21] !== onFocus ? (t6 = (event) => {
    ref.current === event.target && onFocus && onFocus(event);
  }, $[21] = onFocus, $[22] = t6) : t6 = $[22];
  const handleFocus = t6;
  let t7;
  $[23] !== collapsed || $[24] !== onCollapse || $[25] !== onExpand ? (t7 = () => collapsed ? onExpand?.() : onCollapse?.(), $[23] = collapsed, $[24] = onCollapse, $[25] = onExpand, $[26] = t7) : t7 = $[26];
  const handleToggle = t7;
  let t8;
  bb0: {
    if (collapsed) {
      t8 = null;
      break bb0;
    }
    let t92;
    $[27] !== children ? (t92 = getChildren(children), $[27] = children, $[28] = t92) : t92 = $[28];
    let t102;
    $[29] !== columns || $[30] !== t92 ? (t102 = /* @__PURE__ */ jsx(AlignedBottomGrid$1, { columns, gapX: 4, gapY: 5, children: t92 }), $[29] = columns, $[30] = t92, $[31] = t102) : t102 = $[31], t8 = t102;
  }
  const content = t8, t9 = !!focused;
  let t10;
  $[32] !== collapsed || $[33] !== collapsible || $[34] !== handleToggle || $[35] !== title ? (t10 = title && /* @__PURE__ */ jsx(FormFieldSetLegend, { collapsed: !!collapsed, collapsible, onClick: collapsible ? handleToggle : void 0, title }), $[32] = collapsed, $[33] = collapsible, $[34] = handleToggle, $[35] = title, $[36] = t10) : t10 = $[36];
  let t11;
  $[37] !== deprecated || $[38] !== t || $[39] !== title ? (t11 = deprecated && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Badge, { "data-testid": `deprecated-badge-${title}`, tone: "caution", children: t("form.field.deprecated-label") }) }), $[37] = deprecated, $[38] = t, $[39] = title, $[40] = t11) : t11 = $[40];
  let t12;
  $[41] !== hasValidationMarkers || $[42] !== validation2 ? (t12 = hasValidationMarkers && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { fontSize: 1, placement: "top", validation: validation2 }) }), $[41] = hasValidationMarkers, $[42] = validation2, $[43] = t12) : t12 = $[43];
  let t13;
  $[44] !== t10 || $[45] !== t11 || $[46] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t10,
    t11,
    t12
  ] }), $[44] = t10, $[45] = t11, $[46] = t12, $[47] = t13) : t13 = $[47];
  let t14;
  $[48] !== deprecated || $[49] !== title ? (t14 = deprecated && /* @__PURE__ */ jsx(TextWithTone, { "data-testid": `deprecated-message-${title}`, tone: "caution", size: 1, children: deprecated.reason }), $[48] = deprecated, $[49] = title, $[50] = t14) : t14 = $[50];
  let t15;
  $[51] !== description || $[52] !== inputId ? (t15 = description && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, id: createDescriptionId(inputId, description), children: description }), $[51] = description, $[52] = inputId, $[53] = t15) : t15 = $[53];
  let t16;
  $[54] !== t13 || $[55] !== t14 || $[56] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t13,
    t14,
    t15
  ] }), $[54] = t13, $[55] = t14, $[56] = t15, $[57] = t16) : t16 = $[57];
  let t17;
  $[58] !== actions || $[59] !== comments2 || $[60] !== hovered || $[61] !== inputId || $[62] !== presence || $[63] !== slot || $[64] !== t16 || $[65] !== t9 ? (t17 = /* @__PURE__ */ jsx(FormFieldBaseHeader, { __internal_comments: comments2, __internal_slot: slot, actions, fieldFocused: t9, fieldHovered: hovered, presence, inputId, content: t16 }), $[58] = actions, $[59] = comments2, $[60] = hovered, $[61] = inputId, $[62] = presence, $[63] = slot, $[64] = t16, $[65] = t9, $[66] = t17) : t17 = $[66];
  const t18 = level > 0, t19 = !!focused, t20 = level === 0 ? 0 : 3, t21 = typeof tabIndex == "number" && tabIndex > -1 ? handleFocus : void 0, t22 = !collapsed && content;
  let t23;
  $[67] !== collapsed || $[68] !== t18 || $[69] !== t19 || $[70] !== t20 || $[71] !== t21 || $[72] !== t22 || $[73] !== tabIndex ? (t23 = /* @__PURE__ */ jsx(Content$1, { $borderLeft: t18, $focused: t19, hidden: collapsed, paddingLeft: t20, onFocus: t21, ref, tabIndex, children: t22 }), $[67] = collapsed, $[68] = t18, $[69] = t19, $[70] = t20, $[71] = t21, $[72] = t22, $[73] = tabIndex, $[74] = t23) : t23 = $[74];
  let t24;
  return $[75] !== level || $[76] !== onMouseEnter || $[77] !== onMouseLeave || $[78] !== restProps || $[79] !== t17 || $[80] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Root$v, { "data-level": level, ...restProps, onMouseEnter, onMouseLeave, space: 2, children: [
    t17,
    t23
  ] }), $[75] = level, $[76] = onMouseEnter, $[77] = onMouseLeave, $[78] = restProps, $[79] = t17, $[80] = t23, $[81] = t24) : t24 = $[81], t24;
}), Root$u = styled.div`
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  min-height: var(--avatar-height);
  width: 77px;
  margin-left: var(--small-padding);

  &[data-max-avatars='1'] {
    max-width: 23px;
  }

  &[data-position='top'] {
    align-self: flex-start;
  }

  &[data-position='bottom'] {
    align-self: flex-end;
  }
`;
function FormFieldStatus(t0) {
  const $ = c(4), {
    children,
    maxAvatars,
    position: t1
  } = t0, position = t1 === void 0 ? "bottom" : t1;
  let t2;
  return $[0] !== children || $[1] !== maxAvatars || $[2] !== position ? (t2 = /* @__PURE__ */ jsx(Root$u, { "data-max-avatars": maxAvatars, "data-position": position, children }), $[0] = children, $[1] = maxAvatars, $[2] = position, $[3] = t2) : t2 = $[3], t2;
}
function useDidUpdate(current, didUpdate, t0) {
  const $ = c(5), compare2 = t0 === void 0 ? shallowEquals : t0, previous = useRef(void 0);
  let t1, t2;
  $[0] !== compare2 || $[1] !== current || $[2] !== didUpdate ? (t1 = () => {
    compare2(previous.current, current) || (didUpdate(previous.current, current), previous.current = current);
  }, t2 = [compare2, current, didUpdate], $[0] = compare2, $[1] = current, $[2] = didUpdate, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useEffect(t1, t2);
}
const FormCallbacksProvider = memo(function(props2) {
  const $ = c(14), ref = useRef(props2);
  let t0, t1;
  $[0] !== props2 ? (t0 = () => {
    ref.current = props2;
  }, t1 = [props2], $[0] = props2, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (patches) => ref.current?.transformPatches?.(patches) ?? [], $[3] = t2) : t2 = $[3];
  const transformPatches = t2;
  let t3;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (patchEvent) => {
    ref.current.onChange(patchEvent);
  }, $[4] = t3) : t3 = $[4];
  const onChange = t3;
  let t4;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t4 = (path, payload) => {
    ref.current.onPathFocus(path, payload);
  }, $[5] = t4) : t4 = $[5];
  const onPathFocus = t4;
  let t5;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (path_0) => {
    ref.current.onPathBlur(path_0);
  }, $[6] = t5) : t5 = $[6];
  const onPathBlur = t5;
  let t6;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t6 = (path_1) => {
    ref.current.onPathOpen(path_1);
  }, $[7] = t6) : t6 = $[7];
  const onPathOpen = t6;
  let t7;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t7 = (path_2, collapsed) => {
    ref.current.onSetPathCollapsed(path_2, collapsed);
  }, $[8] = t7) : t7 = $[8];
  const onSetPathCollapsed = t7;
  let t8;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t8 = (path_3, collapsed_0) => {
    ref.current.onSetFieldSetCollapsed(path_3, collapsed_0);
  }, $[9] = t8) : t8 = $[9];
  const onSetFieldSetCollapsed = t8;
  let t9;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t9 = (path_4, fieldGroupName) => {
    ref.current.onFieldGroupSelect(path_4, fieldGroupName);
  }, $[10] = t9) : t9 = $[10];
  const onFieldGroupSelect = t9;
  let t10, t11;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t11 = {
    transformPatches,
    onChange,
    onPathFocus,
    onPathBlur,
    onPathOpen,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onFieldGroupSelect
  }, $[11] = t11) : t11 = $[11], t10 = t11;
  const contextValue = t10;
  let t12;
  return $[12] !== props2.children ? (t12 = /* @__PURE__ */ jsx(FormCallbacksContext.Provider, { value: contextValue, children: props2.children }), $[12] = props2.children, $[13] = t12) : t12 = $[13], t12;
});
function useFormCallbacks() {
  const ctx = useContext(FormCallbacksContext);
  if (!ctx)
    throw new Error("Form context not provided");
  return ctx;
}
function createProtoValue(type) {
  if (isObjectSchemaType(type))
    return type.name === "object" ? {} : {
      _type: type.name
    };
  if (isArraySchemaType(type))
    return [];
  if (type.jsonType === "string")
    return "";
  if (type.jsonType === "number")
    return 0;
  if (type.jsonType === "boolean")
    return !1;
}
function whatwgRNG(length = 16) {
  const rnds8 = new Uint8Array(length);
  return getRandomValues(rnds8), rnds8;
}
const getByteHexTable = /* @__PURE__ */ (() => {
  let table2;
  return () => {
    if (table2)
      return table2;
    table2 = [];
    for (let i = 0; i < 256; ++i)
      table2[i] = (i + 256).toString(16).slice(1);
    return table2;
  };
})();
function randomKey(length) {
  const table2 = getByteHexTable();
  return whatwgRNG(length).reduce((str, n) => str + table2[n], "").slice(0, length);
}
function hasKey$1(item) {
  return item._key !== void 0;
}
function ensureKey(item) {
  return hasKey$1(item) ? item : {
    ...item,
    _key: randomKey(12)
  };
}
const getMemberTypeOfItem$2 = (schemaType, item) => {
  const itemTypeName = resolveTypeName$2(item);
  return schemaType.of.find((memberType) => memberType.name === itemTypeName);
};
function assign(values2, path) {
  return Object.entries(values2).map(([key, value]) => set(value, [...path, key]));
}
function resolveInitialArrayValues(items, schemaType, resolver) {
  return from(items).pipe(mergeMap((item) => {
    const itemPathSegment = {
      _key: item._key
    };
    return of(getMemberTypeOfItem$2(schemaType, item)).pipe(mergeMap((memberType) => memberType ? of(memberType) : EMPTY$6), mergeMap((memberType) => !isEmptyItem(item) || !resolver ? EMPTY$6 : concat(of({
      type: "patch",
      patches: [set(!0, [itemPathSegment, "_resolvingInitialValue"])]
    }), defer(() => resolver(memberType, item)).pipe(filter(isNonNullable$3), map((initial2) => ({
      type: "patch",
      patches: assign(initial2, [itemPathSegment])
    })), catchError((error) => of({
      type: "error",
      error,
      item,
      schemaType: memberType
    }))), of({
      type: "patch",
      patches: [unset([itemPathSegment, "_resolvingInitialValue"])]
    }))));
  }));
}
function ArrayOfObjectsItem(props2) {
  const focusRef = useRef(void 0), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, {
    t
  } = useTranslation(), {
    onPathBlur,
    onPathFocus,
    onChange,
    onPathOpen,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onFieldGroupSelect
  } = useFormCallbacks(), resolveInitialValue2 = useResolveInitialValueForType(), getFormValue = useGetFormValue(), {
    onCopy
  } = useCopyPaste();
  useDidUpdate(member.item.focused, (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  });
  const onRemove = useCallback(() => {
    onChange(PatchEvent.from([unset([{
      _key: member.key
    }])]));
  }, [member.key, onChange]), handleOpenItem = useCallback((path) => {
    onPathOpen(path), onSetPathCollapsed(path, !1);
  }, [onPathOpen, onSetPathCollapsed]), toast = useToast(), handleInsert = useCallback((event) => {
    if (event.items.length === 0)
      throw new Error("Insert event should include at least one item");
    const itemsWithKeys = event.items.map((item) => ensureKey(item));
    onChange(PatchEvent.from([insert$1(itemsWithKeys, event.position, [{
      _key: member.key
    }])]));
    const focusItemKey = itemsWithKeys[0]._key, itemPath = [...member.item.path.slice(0, -1), {
      _key: focusItemKey
    }];
    onPathFocus(itemPath);
    const shouldOpen = event.open !== !1;
    event.skipInitialValue ? shouldOpen && handleOpenItem(itemPath) : resolveInitialArrayValues(itemsWithKeys, member.parentSchemaType, resolveInitialValue2).pipe(tap((result) => {
      result.type === "patch" ? onChange(PatchEvent.from(result.patches)) : toast.push({
        title: t("inputs.array.error.cannot-resolve-initial-value-title"),
        description: t("inputs.array.error.cannot-resolve-initial-value-description", {
          schemaTypeTitle: result.schemaType.title,
          errorMessage: result.error.message
        }),
        status: "error"
      });
    })).subscribe({
      complete: () => {
        shouldOpen && handleOpenItem(itemPath);
      }
    });
  }, [handleOpenItem, member.item.path, member.key, member.parentSchemaType, onChange, onPathFocus, resolveInitialValue2, toast, t]), handleCopy = useCallback((_) => {
    const documentValue = getFormValue([]);
    onCopy(member.item.path, documentValue, {
      context: {
        source: "arrayItem"
      },
      patchType: "append"
    });
  }, [getFormValue, onCopy, member.item.path]), handleBlur = useCallback(() => {
    onPathBlur(member.item.path);
  }, [member.item.path, onPathBlur]), handleFocus = useCallback(() => {
    onPathFocus(member.item.path);
  }, [member.item.path, onPathFocus]), handleFocusChildPath = useCallback((path_0) => {
    onPathFocus(member.item.path.concat(path_0));
  }, [member.item.path, onPathFocus]), handleChange = useCallback((event_0) => {
    onChange(PatchEvent.from(event_0).prepend(setIfMissing(createProtoValue(member.item.schemaType))).prefixAll({
      _key: member.key
    }));
  }, [onChange, member.item.schemaType, member.key]), handleCollapse = useCallback(() => {
    onSetPathCollapsed(member.item.path, !0);
  }, [onSetPathCollapsed, member.item.path]), handleExpand = useCallback(() => {
    onSetPathCollapsed(member.item.path, !1);
  }, [onSetPathCollapsed, member.item.path]), handleCollapseField = useCallback((fieldName) => {
    onSetPathCollapsed(member.item.path.concat(fieldName), !0);
  }, [onSetPathCollapsed, member.item.path]), handleExpandField = useCallback((fieldName_0) => {
    onSetPathCollapsed(member.item.path.concat(fieldName_0), !1);
  }, [onSetPathCollapsed, member.item.path]), handleCloseField = useCallback(() => {
    onPathOpen(member.item.path);
  }, [onPathOpen, member.item.path]), handleOpenField = useCallback((fieldName_1) => {
    onPathOpen(member.item.path.concat(fieldName_1));
  }, [onPathOpen, member.item.path]), handleExpandFieldSet = useCallback((fieldsetName) => {
    onSetFieldSetCollapsed(member.item.path.concat(fieldsetName), !1);
  }, [onSetFieldSetCollapsed, member.item.path]), handleCollapseFieldSet = useCallback((fieldsetName_0) => {
    onSetFieldSetCollapsed(member.item.path.concat(fieldsetName_0), !0);
  }, [onSetFieldSetCollapsed, member.item.path]), handleOpen = useCallback(() => {
    onPathOpen(member.item.path);
  }, [onPathOpen, member.item.path]), isEmptyValue2 = !member.item.value || isEmptyItem(member.item.value), handleClose = useCallback(() => {
    isEmptyValue2 && onRemove();
    const parentPath_0 = member.item.path.slice(0, -1);
    onPathOpen(parentPath_0), onPathFocus(parentPath_0);
  }, [isEmptyValue2, onPathOpen, member.item.path, onPathFocus, onRemove]), handleSelectFieldGroup = useCallback((groupName) => {
    onFieldGroupSelect(member.item.path, groupName);
  }, [onFieldGroupSelect, member.item.path]), elementProps = useMemo(() => ({
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: member.item.id,
    ref: focusRef,
    "aria-describedby": createDescriptionId(member.item.id, member.item.schemaType.description)
  }), [handleBlur, handleFocus, member.item.id, member.item.schemaType.description]), inputProps = useMemo(() => ({
    changed: member.item.changed,
    focusPath: member.item.focusPath,
    focused: member.item.focused,
    groups: member.item.groups,
    id: member.item.id,
    level: member.item.level,
    members: member.item.members,
    onChange: handleChange,
    onFieldClose: handleCloseField,
    onFieldCollapse: handleCollapseField,
    onFieldSetCollapse: handleCollapseFieldSet,
    onFieldExpand: handleExpandField,
    onFieldSetExpand: handleExpandFieldSet,
    onFieldGroupSelect: handleSelectFieldGroup,
    onPathFocus: handleFocusChildPath,
    onFieldOpen: handleOpenField,
    path: member.item.path,
    presence: member.item.presence,
    readOnly: member.item.readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType: member.item.schemaType,
    validation: member.item.validation,
    value: member.item.value,
    elementProps
  }), [elementProps, handleChange, handleCloseField, handleCollapseField, handleCollapseFieldSet, handleExpandField, handleExpandFieldSet, handleFocusChildPath, handleOpenField, handleSelectFieldGroup, member.item.changed, member.item.focusPath, member.item.focused, member.item.groups, member.item.id, member.item.level, member.item.members, member.item.path, member.item.presence, member.item.readOnly, member.item.schemaType, member.item.validation, member.item.value, renderAnnotation, renderBlock2, renderField, renderInlineBlock, renderInput, renderItem2, renderPreview]), renderedInput = useMemo(() => renderInput(inputProps), [inputProps, renderInput]), itemProps = useMemo(() => ({
    key: member.key,
    index: member.index,
    level: member.item.level,
    value: member.item.value,
    title: member.item.schemaType.title,
    description: member.item.schemaType.description,
    collapsible: member.collapsible,
    collapsed: member.collapsed,
    schemaType: member.item.schemaType,
    parentSchemaType: member.parentSchemaType,
    onInsert: handleInsert,
    onCopy: handleCopy,
    onRemove,
    presence: member.item.presence,
    validation: member.item.validation,
    open: member.open,
    onOpen: handleOpen,
    onClose: handleClose,
    onExpand: handleExpand,
    onCollapse: handleCollapse,
    readOnly: member.item.readOnly,
    focused: member.item.focused,
    onFocus: handleFocus,
    onBlur: handleBlur,
    inputId: member.item.id,
    path: member.item.path,
    children: renderedInput,
    changed: member.item.changed,
    inputProps
  }), [member.key, member.index, member.item.level, member.item.value, member.item.schemaType, member.item.presence, member.item.validation, member.item.readOnly, member.item.focused, member.item.id, member.item.path, member.item.changed, member.collapsible, member.collapsed, member.parentSchemaType, member.open, handleInsert, handleCopy, onRemove, handleOpen, handleClose, handleExpand, handleCollapse, handleFocus, handleBlur, renderedInput, inputProps]);
  return /* @__PURE__ */ jsx(FormCallbacksProvider, { onFieldGroupSelect, onChange: handleChange, onPathOpen, onSetFieldSetCollapsed, onSetPathCollapsed, onPathBlur, onPathFocus, children: useMemo(() => renderItem2(itemProps), [itemProps, renderItem2]) });
}
const PopoverCard$2 = styled(Card)`
  max-width: ${({
  theme
}) => theme.sanity.container[1]}px;
`;
function IncompatibleItemType$2(props2) {
  const $ = c(60);
  let onFocus, rest, value;
  if ($[0] !== props2) {
    const {
      value: t02,
      onFocus: t110,
      vertical,
      ...t25
    } = props2;
    value = t02, onFocus = t110, rest = t25, $[0] = props2, $[1] = onFocus, $[2] = rest, $[3] = value;
  } else
    onFocus = $[1], rest = $[2], value = $[3];
  const [showDetails, setShowDetails] = useState(!1), popoverRef = useRef(null), {
    t
  } = useTranslation();
  let t0, t1;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setShowDetails(!1), t1 = () => [popoverRef.current], $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useClickOutsideEvent(t0, t1);
  let t2;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => {
    (e.key === "Escape" || e.key === "Tab") && setShowDetails(!1);
  }, $[6] = t2) : t2 = $[6];
  const handleKeyDown = t2;
  let t3;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowDetails(_temp$20);
  }, $[7] = t3) : t3 = $[7];
  const handleShowDetails = t3;
  let t4;
  $[8] !== value ? (t4 = resolveTypeName$2(value), $[8] = value, $[9] = t4) : t4 = $[9];
  const typeName = t4;
  let t5;
  $[10] !== typeName ? (t5 = {
    typeName
  }, $[10] = typeName, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.type-is-incompatible-prompt", values: t5 }) }), $[12] = t, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== t ? (t7 = t("inputs.array.error.type-is-incompatible-title"), $[15] = t, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t7 }), $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== typeName ? (t9 = {
    typeName
  }, $[19] = typeName, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== t || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.current-schema-not-declare-description", values: t9 }) }), $[21] = t, $[22] = t9, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] === Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(BulbOutlineIcon, {}), $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t ? (t12 = t("inputs.array.error.can-delete-but-no-edit-description"), $[25] = t, $[26] = t12) : t12 = $[26];
  let t13;
  $[27] !== t12 ? (t13 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t11,
    " ",
    t12
  ] }) }), $[27] = t12, $[28] = t13) : t13 = $[28];
  let t14;
  $[29] !== t ? (t14 = t("inputs.array.error.json-representation-description"), $[29] = t, $[30] = t14) : t14 = $[30];
  let t15;
  $[31] !== t14 ? (t15 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t14 }), $[31] = t14, $[32] = t15) : t15 = $[32];
  let t16;
  $[33] !== value ? (t16 = JSON.stringify(value, null, 2), $[33] = value, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== t16 ? (t17 = /* @__PURE__ */ jsx(Card, { padding: 2, overflow: "auto", border: !0, children: /* @__PURE__ */ jsx(Code, { size: 1, as: "pre", language: "json", children: t16 }) }), $[35] = t16, $[36] = t17) : t17 = $[36];
  let t18;
  $[37] !== t15 || $[38] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t15,
    t17
  ] }), $[37] = t15, $[38] = t17, $[39] = t18) : t18 = $[39];
  let t19;
  $[40] !== t10 || $[41] !== t13 || $[42] !== t18 || $[43] !== t6 || $[44] !== t8 ? (t19 = /* @__PURE__ */ jsx(PopoverCard$2, { margin: 1, padding: 3, onKeyDown: handleKeyDown, tabIndex: 0, overflow: "auto", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t6,
    t8,
    t10,
    t13,
    t18
  ] }) }), $[40] = t10, $[41] = t13, $[42] = t18, $[43] = t6, $[44] = t8, $[45] = t19) : t19 = $[45];
  let t20;
  $[46] === Symbol.for("react.memo_cache_sentinel") ? (t20 = /* @__PURE__ */ jsx(Box, { marginRight: 3, children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(UnknownIcon, {}) }) }), $[46] = t20) : t20 = $[46];
  let t21;
  $[47] !== typeName ? (t21 = {
    typeName
  }, $[47] = typeName, $[48] = t21) : t21 = $[48];
  let t22;
  $[49] !== t || $[50] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t20,
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.type-is-incompatible-prompt", values: t21 }) }) })
  ] }), $[49] = t, $[50] = t21, $[51] = t22) : t22 = $[51];
  let t23;
  $[52] !== onFocus || $[53] !== rest || $[54] !== t22 ? (t23 = /* @__PURE__ */ jsx(Card, { as: "button", type: "button", radius: 2, tone: "inherit", paddingX: 2, paddingY: 3, flex: 1, onFocus, onClick: handleShowDetails, onKeyDown: handleKeyDown, __unstable_focusRing: !0, ...rest, children: t22 }), $[52] = onFocus, $[53] = rest, $[54] = t22, $[55] = t23) : t23 = $[55];
  let t24;
  return $[56] !== showDetails || $[57] !== t19 || $[58] !== t23 ? (t24 = /* @__PURE__ */ jsx(Popover, { open: showDetails, ref: popoverRef, onKeyDown: handleKeyDown, portal: !0, constrainSize: !0, tone: "default", content: t19, children: t23 }), $[56] = showDetails, $[57] = t19, $[58] = t23, $[59] = t24) : t24 = $[59], t24;
}
function _temp$20(v) {
  return !v;
}
function MemberItemError(props2) {
  const $ = c(7), {
    member
  } = props2, {
    t
  } = useTranslation();
  if (member.error.type === "INVALID_ITEM_TYPE") {
    let t02;
    return $[0] !== member.error.value ? (t02 = /* @__PURE__ */ jsx(IncompatibleItemType$2, { value: member.error.value }), $[0] = member.error.value, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== member.error.type || $[3] !== t ? (t0 = t("inputs.array.error.unexpected-error", {
    error: member.error.type
  }), $[2] = member.error.type, $[3] = t, $[4] = t0) : t0 = $[4];
  let t1;
  return $[5] !== t0 ? (t1 = /* @__PURE__ */ jsx("div", { children: t0 }), $[5] = t0, $[6] = t1) : t1 = $[6], t1;
}
function ArrayOfObjectsInputMember(props2) {
  const $ = c(11), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2;
  if (member.kind === "item") {
    let t0;
    return $[0] !== member || $[1] !== renderAnnotation || $[2] !== renderBlock2 || $[3] !== renderField || $[4] !== renderInlineBlock || $[5] !== renderInput || $[6] !== renderItem2 || $[7] !== renderPreview ? (t0 = /* @__PURE__ */ jsx(ArrayOfObjectsItem, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }, member.key), $[0] = member, $[1] = renderAnnotation, $[2] = renderBlock2, $[3] = renderField, $[4] = renderInlineBlock, $[5] = renderInput, $[6] = renderItem2, $[7] = renderPreview, $[8] = t0) : t0 = $[8], t0;
  }
  if (member.kind === "error") {
    let t0;
    return $[9] !== member ? (t0 = /* @__PURE__ */ jsx(MemberItemError, { member }, member.key), $[9] = member, $[10] = t0) : t0 = $[10], t0;
  }
  return console.warn(new Error(`Unhandled member kind ${member.kind}`)), null;
}
function ArrayOfObjectsInputMembers(props2) {
  const $ = c(10);
  let members, rest;
  $[0] !== props2 ? ({
    members,
    ...rest
  } = props2, $[0] = props2, $[1] = members, $[2] = rest) : (members = $[1], rest = $[2]);
  let t0;
  if ($[3] !== members || $[4] !== rest) {
    let t12;
    $[6] !== rest ? (t12 = (member) => /* @__PURE__ */ jsx(ArrayOfObjectsInputMember, { member, ...rest }, member.key), $[6] = rest, $[7] = t12) : t12 = $[7], t0 = members.map(t12), $[3] = members, $[4] = rest, $[5] = t0;
  } else
    t0 = $[5];
  let t1;
  return $[8] !== t0 ? (t1 = /* @__PURE__ */ jsx(Fragment, { children: t0 }), $[8] = t0, $[9] = t1) : t1 = $[9], t1;
}
function getEmptyValue(type) {
  switch (type.jsonType) {
    case "string":
      return "";
    case "number":
      return -0;
    case "boolean":
      return !1;
    default:
      throw new Error(`Unable to create value from type "${type.jsonType}"`);
  }
}
function resolveNativeNumberInputValue(schemaType, value, localValue) {
  return isNumberSchemaType(schemaType) && typeof localValue == "string" && Number(localValue) === value ? localValue : String(value ?? "");
}
function ArrayOfPrimitivesItem(props2) {
  const focusRef = useRef(void 0), {
    member,
    renderItem: renderItem2,
    renderInput
  } = props2, [localValue, setLocalValue] = useState(), {
    onPathBlur,
    onPathFocus,
    onChange
  } = useFormCallbacks(), getFormValue = useGetFormValue(), {
    onCopy
  } = useCopyPaste();
  useDidUpdate(member.item.focused, (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  });
  const handleBlur = useCallback((event) => {
    onPathBlur(member.item.path);
  }, [member.item.path, onPathBlur]), handleFocus = useCallback((event_0) => {
    onPathFocus(member.item.path);
  }, [member.item.path, onPathFocus]), handleChange = useCallback((event_1) => {
    onChange(PatchEvent.from(event_1).prefixAll(member.index));
  }, [onChange, member.index]), handleNativeChange = useCallback((event_2) => {
    let inputValue = event_2.currentTarget.value;
    if (isNumberSchemaType(member.item.schemaType)) {
      if (inputValue = event_2.currentTarget.valueAsNumber, inputValue > Number.MAX_SAFE_INTEGER || inputValue < Number.MIN_SAFE_INTEGER)
        return;
    } else isBooleanSchemaType(member.item.schemaType) && (inputValue = event_2.currentTarget.checked);
    const hasEmptyValue = inputValue === "" || typeof inputValue == "number" && isNaN(inputValue);
    isNumberSchemaType(member.item.schemaType) && setLocalValue(hasEmptyValue ? void 0 : event_2.currentTarget.value), handleChange(set(hasEmptyValue ? (
      // Map direct unset patches to empty value instead in order to not *remove* elements as the user clears out the value
      // note: this creates the rather curious case where the input renders ´0´ when you try to clear it.
      getEmptyValue(member.item.schemaType)
    ) : inputValue));
  }, [handleChange, member.item.schemaType]), elementProps = useMemo(() => ({
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: member.item.id,
    ref: focusRef,
    onChange: handleNativeChange,
    value: resolveNativeInputValue(member.item.schemaType, member.item.value, localValue),
    readOnly: !!member.item.readOnly,
    placeholder: member.item.schemaType.placeholder,
    "aria-describedby": createDescriptionId(member.item.id, member.item.schemaType.description)
  }), [handleBlur, handleFocus, handleNativeChange, member.item.id, member.item.readOnly, member.item.schemaType, member.item.value, localValue]), inputProps = useMemo(() => ({
    changed: member.item.changed,
    level: member.item.level,
    value: member.item.value,
    readOnly: member.item.readOnly,
    schemaType: member.item.schemaType,
    id: member.item.id,
    path: member.item.path,
    focused: member.item.focused,
    onChange: handleChange,
    validation: member.item.validation,
    presence: member.item.presence,
    elementProps
  }), [member.item.changed, member.item.level, member.item.value, member.item.readOnly, member.item.schemaType, member.item.id, member.item.path, member.item.focused, member.item.validation, member.item.presence, handleChange, elementProps]), renderedInput = useMemo(() => renderInput(inputProps), [inputProps, renderInput]), onRemove = useCallback(() => {
    onChange(PatchEvent.from([unset([member.index])]));
  }, [member.index, onChange]), onInsert = useCallback((event_3) => {
    onChange(PatchEvent.from([insert$1(event_3.items, event_3.position, [member.index])]));
  }, [member.index, onChange]), handleCopy = useCallback((_) => {
    const documentValue = getFormValue([]);
    onCopy(member.item.path, documentValue, {
      context: {
        source: "arrayItem"
      },
      patchType: "append"
    });
  }, [getFormValue, member.item.path, onCopy]), itemProps = useMemo(() => ({
    key: member.key,
    index: member.index,
    level: member.item.level,
    value: member.item.value,
    title: member.item.schemaType.title,
    description: member.item.schemaType.description,
    schemaType: member.item.schemaType,
    parentSchemaType: member.parentSchemaType,
    onInsert,
    onCopy: handleCopy,
    onRemove,
    presence: member.item.presence,
    validation: member.item.validation,
    readOnly: member.item.readOnly,
    focused: member.item.focused,
    onFocus: handleFocus,
    onBlur: handleBlur,
    inputId: member.item.id,
    path: member.item.path,
    children: renderedInput
  }), [member.key, member.index, member.item.level, member.item.value, member.item.schemaType, member.item.presence, member.item.validation, member.item.readOnly, member.item.focused, member.item.id, member.item.path, member.parentSchemaType, onInsert, handleCopy, onRemove, handleFocus, handleBlur, renderedInput]);
  return /* @__PURE__ */ jsx(Fragment, { children: useMemo(() => renderItem2(itemProps), [itemProps, renderItem2]) });
}
function resolveNativeInputValue(schemaType, value, localValue) {
  return Object.is(value, -0) ? "" : resolveNativeNumberInputValue(schemaType, value, localValue);
}
function createProtoArrayValue(type) {
  if (!isObjectSchemaType(type))
    throw new Error(`Invalid item type: "${type.type}". Default array input can only contain objects (for now)`);
  return {
    ...createProtoValue(type),
    _key: randomKey$1(12)
  };
}
const BEFORE = "before", AFTER = "after";
function arrayInsert(array, position, index, ...args) {
  if (position !== BEFORE && position !== AFTER)
    throw new Error(`Invalid position "${position}", must be either ${BEFORE} or ${AFTER}`);
  const items = flatten(...args);
  if (array.length === 0)
    return items;
  const len = array.length, idx = Math.abs((len + index) % len) % len, normalizedIdx = position === "after" ? idx + 1 : idx, copy = array.slice();
  return copy.splice(normalizedIdx, 0, ...flatten(items)), copy;
}
function flatten(...values2) {
  return values2.reduce((prev, item) => prev.concat(item), []);
}
const hasOwn = (obj, property) => Object.prototype.hasOwnProperty.call(obj, property);
function move$1(arr, from2, to) {
  const nextValue = arr.slice(), val = nextValue[from2];
  return nextValue.splice(from2, 1), nextValue.splice(to, 0, val), nextValue;
}
function findTargetIndex(array, pathSegment) {
  if (typeof pathSegment == "number")
    return pathSegment;
  const index = findIndex$1(array, pathSegment);
  return index === -1 ? !1 : index;
}
function _arrayApply(value, patch2) {
  const nextValue = value.slice();
  if (patch2.path.length === 0) {
    if (patch2.type === "setIfMissing") {
      if (!Array.isArray(patch2.value))
        throw new Error("Cannot set value of an array to a non-array");
      return value === void 0 ? patch2.value : value;
    } else if (patch2.type === "set") {
      if (!Array.isArray(patch2.value))
        throw new Error("Cannot set value of an array to a non-array");
      return patch2.value;
    } else {
      if (patch2.type === "unset")
        return;
      if (patch2.type === "move") {
        if (!patch2.value || !hasOwn(patch2.value, "from") || !hasOwn(patch2.value, "to"))
          throw new Error(`Invalid value of 'move' patch. Expected a value with "from" and "to" indexes, instead got: ${JSON.stringify(patch2.value)}`);
        return move$1(nextValue, patch2.value.from, patch2.value.to);
      }
    }
    throw new Error(`Invalid array operation: ${patch2.type}`);
  }
  const [head, ...tail] = patch2.path, index = findTargetIndex(value, head);
  if (index === !1)
    return nextValue;
  if (tail.length === 0) {
    if (patch2.type === "insert") {
      const {
        position,
        items
      } = patch2;
      return arrayInsert(value, position, index, items);
    } else if (patch2.type === "unset") {
      if (typeof index != "number")
        throw new Error(`Expected array index to be a number, instead got "${index}"`);
      return nextValue.splice(index, 1), nextValue;
    }
  }
  return nextValue[index] = applyPatch(nextValue[index], {
    ...patch2,
    path: tail
  }), nextValue;
}
function _objectApply(value, patch2) {
  const nextValue = clone(value);
  if (patch2.path.length === 0) {
    if (patch2.type === "set") {
      if (!isObject(patch2.value))
        throw new Error("Cannot set value of an object to a non-object");
      return patch2.value;
    } else {
      if (patch2.type === "unset")
        return;
      if (patch2.type === "setIfMissing")
        return value === void 0 ? patch2.value : value;
    }
    throw new Error(`Invalid object operation: ${patch2.type}`);
  }
  const [head, ...tail] = patch2.path;
  if (typeof head != "string")
    throw new Error(`Expected field name to be a string, instad got: ${head}`);
  return tail.length === 0 && patch2.type === "unset" ? omit(nextValue, head) : (nextValue[head] = applyPatch(nextValue[head], {
    ...patch2,
    path: tail
  }), nextValue);
}
const OPERATIONS$1 = {
  replace(currentValue, nextValue) {
    return nextValue;
  },
  set(currentValue, nextValue) {
    return nextValue;
  },
  setIfMissing(currentValue, nextValue) {
    return currentValue === void 0 ? nextValue : currentValue;
  },
  unset(currentValue, nextValue) {
  },
  inc(currentValue, nextValue) {
    return currentValue + nextValue;
  },
  dec(currentValue, nextValue) {
    return currentValue - nextValue;
  }
}, SUPPORTED_PATCH_TYPES$1 = Object.keys(OPERATIONS$1);
function _primitiveApply(value, patch2) {
  if (!SUPPORTED_PATCH_TYPES$1.includes(patch2.type))
    throw new Error(`Received patch of unsupported type "${patch2.type}" for primitives. This is most likely a bug.`);
  if (patch2.path.length > 0)
    throw new Error(`Cannot apply deep operations on primitive values. Received patch with type "${patch2.type}" and path "${patch2.path.map((path) => JSON.stringify(path)).join(".")} that targeted the value "${JSON.stringify(value)}"`);
  return OPERATIONS$1[patch2.type](value, patch2.value);
}
const OPERATIONS = {
  replace(currentValue, nextValue) {
    return nextValue;
  },
  set(currentValue, nextValue) {
    return nextValue;
  },
  setIfMissing(currentValue, nextValue) {
    return currentValue === void 0 ? nextValue : currentValue;
  },
  unset(currentValue, nextValue) {
  },
  diffMatchPatch(currentValue, dmpPatch) {
    const [result] = applyPatches(parsePatch(dmpPatch), currentValue, {
      allowExceedingIndices: !0
    });
    return result;
  }
}, SUPPORTED_PATCH_TYPES = Object.keys(OPERATIONS);
function _stringApply(value, patch2) {
  if (!SUPPORTED_PATCH_TYPES.includes(patch2.type))
    throw new Error(`Received patch of unsupported type: "${JSON.stringify(patch2.type)}" for string. This is most likely a bug.`);
  if (patch2.path.length > 0)
    throw new Error(`Cannot apply deep operations on string values. Received patch with type "${patch2.type}" and path "${patch2.path.join(".")} that targeted the value "${JSON.stringify(value)}"`);
  return OPERATIONS[patch2.type](value, patch2.value);
}
function applyAll(value, patches) {
  return patches.reduce(applyPatch, value);
}
function _applyPatch(value, patch2) {
  return Array.isArray(value) ? _arrayApply(value, patch2) : isString$1(value) ? _stringApply(value, patch2) : isObject(value) ? _objectApply(value, patch2) : _primitiveApply(value, patch2);
}
function applyPatch(value, patch2) {
  return _applyPatch(value, patch2);
}
function DocumentFieldActionsProvider(props2) {
  const $ = c(5);
  let t0;
  const t1 = props2.actions || EMPTY_ARRAY$A;
  let t2;
  $[0] !== t1 ? (t2 = {
    actions: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1], t0 = t2;
  const value = t0;
  let t3;
  return $[2] !== props2.children || $[3] !== value ? (t3 = /* @__PURE__ */ jsx(DocumentFieldActionsContext.Provider, { value, children: props2.children }), $[2] = props2.children, $[3] = value, $[4] = t3) : t3 = $[4], t3;
}
function useDocumentFieldActions() {
  const context = useContext(DocumentFieldActionsContext);
  if (!context)
    throw new Error("useDocumentFieldActions must be used within a DocumentFieldActionsProvider");
  return context.actions;
}
function is$1(typeName, type) {
  return type.name === typeName || !!(type.type && is$1(typeName, type.type));
}
function accepts(file, acceptedFiles) {
  if (!file || !acceptedFiles)
    return !0;
  const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(","), fileName = file.name || "", mimeType = (file.type || "").toLowerCase(), baseMimeType = mimeType.replace(/\/.*$/, "");
  return acceptedFilesArray.some((type) => {
    const validType = type.trim().toLowerCase();
    return validType.charAt(0) === "." ? fileName ? fileName.toLowerCase().endsWith(validType) : !0 : validType.endsWith("/*") ? baseMimeType === validType.replace(/\/.*$/, "") : mimeType === validType;
  });
}
const DEFAULT_CONCURRENCY = 4;
function remove(array, item) {
  const index = array.indexOf(item);
  return index > -1 && array.splice(index, 1), array;
}
function withMaxConcurrency(func, concurrency = DEFAULT_CONCURRENCY) {
  const throttler = createThrottler(concurrency);
  return (...args) => from(throttler(func(...args)));
}
function createThrottler(concurrency = DEFAULT_CONCURRENCY) {
  const currentSubscriptions = [], pendingObservables = [], ready$ = new Subject();
  return request;
  function request(observable) {
    return new Observable((observer) => {
      if (currentSubscriptions.length >= concurrency)
        return scheduleAndWait(observable).pipe(mergeMap(request)).subscribe(observer);
      const subscription = observable.subscribe(observer);
      return currentSubscriptions.push(subscription), () => {
        remove(currentSubscriptions, subscription), remove(pendingObservables, observable), subscription.unsubscribe(), check();
      };
    });
  }
  function scheduleAndWait(observable) {
    return pendingObservables.push(observable), ready$.asObservable().pipe(first((obs) => obs === observable));
  }
  function check() {
    for (; pendingObservables.length > 0 && currentSubscriptions.length < concurrency; )
      ready$.next(pendingObservables.shift());
  }
}
const MAX_CONCURRENT_UPLOADS = 4;
function uploadSanityAsset(client, assetType, file, options = {}) {
  const extract = options.metadata, preserveFilename = options.storeOriginalFilename, {
    label,
    title,
    description,
    creditLine,
    source
  } = options;
  return hashFile(file).pipe(catchError(() => (
    // ignore if hashing fails for some reason
    of(null)
  )), mergeMap((hash2) => (
    // note: the sanity api will still dedupe unique files, but this saves us from uploading the asset file entirely
    hash2 ? fetchExisting(client, `sanity.${assetType}Asset`, hash2) : of(null)
  )), mergeMap((existing) => existing ? of({
    // complete with the existing asset document
    type: "complete",
    id: existing._id,
    asset: existing
  }) : client.observable.assets.upload(assetType, file, {
    tag: "asset.upload",
    extract,
    preserveFilename,
    label,
    title,
    description,
    creditLine,
    source
  }).pipe(map((event) => event.type === "response" ? {
    // rewrite to a 'complete' event
    type: "complete",
    id: event.body.document._id,
    asset: event.body.document
  } : event))));
}
const uploadAsset = withMaxConcurrency(uploadSanityAsset, MAX_CONCURRENT_UPLOADS), uploadImageAsset = (client, file, options) => uploadAsset(client, "image", file, options), uploadFileAsset = (client, file, options) => uploadAsset(client, "file", file, options);
function observeAssetDoc(documentPreviewStore, id2) {
  return documentPreviewStore.observePaths({
    _type: "reference",
    _ref: id2
  }, ["originalFilename", "url", "metadata", "label", "title", "description", "creditLine", "source", "size"]);
}
function observeImageAsset(documentPreviewStore, id2) {
  return observeAssetDoc(documentPreviewStore, id2);
}
function observeFileAsset(documentPreviewStore, id2) {
  return observeAssetDoc(documentPreviewStore, id2);
}
function fetchExisting(client, type, hash2) {
  return client.observable.fetch("*[_type == $documentType && sha1hash == $hash][0]", {
    documentType: type,
    hash: hash2
  }, {
    tag: "asset.find-duplicate"
  });
}
function readFile(file) {
  return new Observable((subscriber) => {
    const reader = new FileReader();
    return reader.onload = () => {
      subscriber.next(reader.result), subscriber.complete();
    }, reader.onerror = (err) => {
      subscriber.error(err);
    }, reader.readAsArrayBuffer(file), () => {
      reader.abort();
    };
  });
}
function hashFile(file) {
  return !window.crypto || !window.crypto.subtle || !window.FileReader ? of(null) : readFile(file).pipe(mergeMap((arrayBuffer) => crypto.subtle.digest("SHA-1", arrayBuffer)), map(hexFromBuffer));
}
function hexFromBuffer(buffer) {
  return Array.prototype.map.call(new Uint8Array(buffer), (x) => `00${x.toString(16)}`.slice(-2)).join("");
}
const UPLOAD_STATUS_KEY = "_upload", UNSET_UPLOAD_PATCH = unset([UPLOAD_STATUS_KEY]);
function createUploadEvent(patches = []) {
  return {
    type: "uploadProgress",
    patches
  };
}
const CLEANUP_EVENT = createUploadEvent([UNSET_UPLOAD_PATCH]);
function createInitialUploadEvent(file) {
  return createUploadEvent(createInitialUploadPatches(file));
}
function createInitialUploadPatches(file) {
  const now = (/* @__PURE__ */ new Date()).toISOString(), value = {
    progress: 2,
    createdAt: now,
    updatedAt: now,
    file: {
      name: file.name,
      type: file.type
    }
  };
  return [set(value, [UPLOAD_STATUS_KEY])];
}
function uploadFile(client, file, options) {
  const upload$ = uploadFileAsset(client, file, options).pipe(map((event) => event.type === "complete" ? createUploadEvent([set({
    _type: "reference",
    _ref: event.asset._id
  }, ["asset"]), set(100, [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updated"])]) : createUploadEvent([set(event.percent, [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updated"])])));
  return concat(of(createInitialUploadEvent(file)), upload$, of(CLEANUP_EVENT));
}
function rotated(n) {
  return [5, 6, 7, 8].indexOf(n) > -1;
}
function rotate(ctx, options) {
  const x = options.x, y = options.y, radians = (options.degrees || 0) * (Math.PI / 180);
  ctx?.translate(x, y), ctx?.rotate(radians), ctx?.translate(-x, -y);
}
function flip(canvas, x, y) {
  const ctx = canvas.getContext("2d");
  ctx?.translate(x ? canvas.width : 0, y ? canvas.height : 0), ctx?.scale(x ? -1 : 1, y ? -1 : 1);
}
const ORIENTATION_OPS = [{
  op: "none",
  degrees: 0
}, {
  op: "flip-x",
  degrees: 0
}, {
  op: "none",
  degrees: 180
}, {
  op: "flip-y",
  degrees: 0
}, {
  op: "flip-x",
  degrees: 90
}, {
  op: "none",
  degrees: 90
}, {
  op: "flip-x",
  degrees: -90
}, {
  op: "none",
  degrees: -90
}], ORIENTATIONS = ["top-left", "top-right", "bottom-right", "bottom-left", "left-top", "right-top", "right-bottom", "left-bottom"], DEFAULT_ORIENTATION = "top-left", THUMB_SIZE = 120;
function _orient(img, orientationNumber) {
  const orientation = ORIENTATION_OPS[orientationNumber - 1], ratio = img.height / img.width;
  img.width = THUMB_SIZE / ratio, img.height = img.width * ratio;
  const canvas = document.createElement("canvas"), ctx = canvas.getContext("2d");
  if (rotated(orientationNumber) ? (canvas.height = img.width, canvas.width = img.height) : (canvas.width = img.width, canvas.height = img.height), orientation.op === "flip-x" && flip(canvas, !0, !1), orientation.op === "flip-y" && flip(canvas, !1, !0), orientation.degrees && (rotate(ctx, {
    degrees: orientation.degrees,
    x: canvas.width / 2,
    y: canvas.height / 2
  }), rotated(orientationNumber))) {
    const d = canvas.width - canvas.height;
    ctx?.translate(d / 2, -d / 2);
  }
  return ctx?.drawImage(img, 0, 0, img.width, img.height), canvas;
}
function orient(image, orientationId) {
  return new Observable((observer) => {
    const orientation = ORIENTATIONS.indexOf(orientationId) + 1, canvas = _orient(image, orientation);
    observer.next(canvas.toDataURL("image/jpeg", 0.1)), observer.complete();
  });
}
function readFileAsArrayBuffer(file, length) {
  return new Observable((observer) => {
    const reader = new window.FileReader();
    return reader.onerror = (err) => observer.error(err), reader.onload = () => {
      observer.next(reader.result), observer.complete();
    }, reader.readAsArrayBuffer(file.slice(0, length)), () => reader.abort();
  });
}
const SKIP_EXIF_ERROR_RE = /(invalid image format)|(No exif data)/i, EXIF_BUFFER_LENGTH = 128e3;
function readExif(file) {
  return from(readFileAsArrayBuffer(file, EXIF_BUFFER_LENGTH)).pipe(map((buf) => exif(buf)), catchError((error) => (SKIP_EXIF_ERROR_RE.test(error.message) || console.warn(`Exif read failed, continuing anyway: ${error.message}`), of({}))));
}
function loadImage$1(url) {
  return new Observable((observer) => {
    const image = new window.Image();
    return image.onerror = () => {
      observer.error(new Error(`Could not load image from url "${url}". Image may be of an unsupported format`));
    }, image.onload = () => {
      observer.next(image), observer.complete();
    }, image.src = url, () => {
    };
  });
}
function rotateImage(file, orientation) {
  return loadImage$1(window.URL.createObjectURL(file)).pipe(mergeMap((image) => orient(image, orientation)));
}
function uploadImage(client, file, options) {
  const upload$ = uploadImageAsset(client, file, options).pipe(filter((event) => event.stage !== "download"), map((event) => ({
    ...event,
    progress: 2 + event.percent / 100 * 98
  })), map((event) => event.type === "complete" ? createUploadEvent([set({
    _type: "reference",
    _ref: event.asset._id
  }, ["asset"]), set(100, [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updatedAt"])]) : createUploadEvent([set(event.percent, [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updatedAt"])]))), setPreviewUrl$ = readExif(file).pipe(mergeMap((exifData) => rotateImage(file, exifData.orientation || DEFAULT_ORIENTATION)), catchError((error) => (console.warn('Image preprocessing failed for "%s" with the error: %s', file.name, error.message), of(null))), filter(Boolean), map((imageUrl) => createUploadEvent([set(imageUrl, [UPLOAD_STATUS_KEY, "previewImage"])])));
  return concat(of(createInitialUploadEvent(file)), merge(upload$, setPreviewUrl$), of(CLEANUP_EVENT));
}
const UPLOAD_IMAGE = {
  type: "image",
  accepts: "image/*",
  upload: (client, file, type, options) => uploadImage(client, file, options)
}, UPLOAD_FILE = {
  type: "file",
  accepts: "",
  upload: (client, file, type, options) => uploadFile(client, file, options)
}, UPLOAD_TEXT = {
  type: "string",
  accepts: "text/*",
  upload: (client, file, type, options) => uploadFile(client, file, options).pipe(map((content) => ({
    type: "uploadProgress",
    patches: [set(content)]
  })))
  // Todo: promote this to a "first-class" form-builder abstraction
  // and make it possible to register custom uploaders
}, uploaders = [UPLOAD_IMAGE, UPLOAD_TEXT, UPLOAD_FILE].map((uploader, i) => ({
  ...uploader,
  priority: i
}));
function resolveUploader(type, file) {
  return uploaders.find((uploader) => is$1(uploader.type, type) && accepts(file, uploader.accepts) && accepts(file, type.options?.accept || "")) || null;
}
function ArrayOfObjectsField(props2) {
  const {
    onPathBlur,
    onPathFocus,
    onChange,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onPathOpen,
    onFieldGroupSelect
  } = useFormCallbacks(), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, fieldActions = useDocumentFieldActions(), focusRef = useRef(void 0), uploadSubscriptions = useRef({});
  useDidUpdate(member.field.focused, (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  });
  const handleFocus = useCallback((event) => {
    event.currentTarget === event.target && event.currentTarget === focusRef.current && onPathFocus(member.field.path);
  }, [member.field.path, onPathFocus]), handleBlur = useCallback((event_0) => {
    event_0.currentTarget === event_0.target && event_0.currentTarget === focusRef.current && onPathBlur(member.field.path);
  }, [member.field.path, onPathBlur]), valueRef = useRef(member.field.value);
  useEffect(() => {
    valueRef.current = member.field.value;
  }, [member.field.value]);
  const handleChange = useCallback((event_1) => {
    const patches = PatchEvent.from(event_1).patches;
    if (patches.some((patch2) => patch2.type === "unset" && patch2.path.length === 1) && (valueRef.current = applyAll(valueRef.current || [], patches), Array.isArray(valueRef.current) && !valueRef.current.length)) {
      onChange(PatchEvent.from(unset([member.name])));
      return;
    }
    onChange(PatchEvent.from(event_1).prepend(setIfMissing([])).prefixAll(member.name));
  }, [onChange, member.name, valueRef]), resolveInitialValue2 = useResolveInitialValueForType(), toast = useToast(), handleCollapse = useCallback(() => {
    onSetPathCollapsed(member.field.path, !0);
  }, [onSetPathCollapsed, member.field.path]), handleExpand = useCallback(() => {
    onSetPathCollapsed(member.field.path, !1);
  }, [onSetPathCollapsed, member.field.path]), handleCollapseItem = useCallback((itemKey) => {
    onSetPathCollapsed(member.field.path.concat({
      _key: itemKey
    }), !0);
  }, [onSetPathCollapsed, member.field.path]), handleExpandItem = useCallback((itemKey_0) => {
    onSetPathCollapsed(member.field.path.concat({
      _key: itemKey_0
    }), !1);
  }, [onSetPathCollapsed, member.field.path]), handleOpenItem = useCallback((path) => {
    onPathOpen(path), onSetPathCollapsed(path, !1);
  }, [onPathOpen, onSetPathCollapsed]), handleCloseItem = useCallback(() => {
    onPathOpen(member.field.path), onSetPathCollapsed(member.field.path, !0);
  }, [onPathOpen, member.field.path, onSetPathCollapsed]), handleInsert = useCallback((event_2) => {
    if (event_2.items.length === 0)
      throw new Error("Insert event should include at least one item");
    const itemsWithKeys = event_2.items.map((item) => ensureKey(item));
    handleChange(PatchEvent.from([insert$1(itemsWithKeys, event_2.position, [event_2.referenceItem])]));
    const focusItemKey = itemsWithKeys[0]._key, itemPath = [...member.field.path, {
      _key: focusItemKey
    }];
    onPathFocus(itemPath);
    const shouldOpen = event_2.open !== !1;
    event_2.skipInitialValue ? shouldOpen && handleOpenItem(itemPath) : resolveInitialArrayValues(itemsWithKeys, member.field.schemaType, resolveInitialValue2).pipe(tap((result) => {
      result.type === "patch" ? handleChange(result.patches) : toast.push({
        title: "Could not resolve initial value",
        description: `Unable to resolve initial value for type: ${result.schemaType.title}: ${result.error.message}.`,
        status: "error"
      });
    })).subscribe({
      complete: () => {
        shouldOpen && handleOpenItem(itemPath);
      }
    });
  }, [handleChange, handleOpenItem, member.field.path, member.field.schemaType, onPathFocus, resolveInitialValue2, toast]), handleMoveItem = useCallback((event_3) => {
    const value = member.field.value, item_0 = value?.[event_3.fromIndex], refItem = value?.[event_3.toIndex];
    if (event_3.fromIndex !== event_3.toIndex) {
      if (!item_0?._key || !refItem?._key) {
        console.error("Neither the item you are moving nor the item you are moving to have a key. Cannot continue.");
        return;
      }
      handleChange([unset([{
        _key: item_0._key
      }]), insert$1([item_0], event_3.fromIndex > event_3.toIndex ? "before" : "after", [{
        _key: refItem._key
      }])]);
    }
  }, [handleChange, member.field.value]), handleItemPrepend = useCallback((item_1) => {
    handleInsert({
      items: [item_1],
      position: "before",
      referenceItem: 0
    });
  }, [handleInsert]), handleItemAppend = useCallback((item_2) => {
    handleInsert({
      items: [item_2],
      position: "after",
      referenceItem: -1
    });
  }, [handleInsert]), handleRemoveItem = useCallback((itemKey_1) => {
    uploadSubscriptions.current[itemKey_1] && (uploadSubscriptions.current[itemKey_1].unsubscribe(), delete uploadSubscriptions.current[itemKey_1]), handleChange([unset([{
      _key: itemKey_1
    }])]);
  }, [handleChange]), handleFocusChildPath = useCallback((path_0, payload) => {
    onPathFocus(member.field.path.concat(path_0), payload);
  }, [member.field.path, onPathFocus]), elementProps = useMemo(() => ({
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: member.field.id,
    ref: focusRef,
    "aria-describedby": createDescriptionId(member.field.id, member.field.schemaType.description)
  }), [handleBlur, handleFocus, member.field.id, member.field.schemaType.description]), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), formBuilder = useFormBuilder(), supportsImageUploads = formBuilder.__internal.image.directUploads, supportsFileUploads = formBuilder.__internal.file.directUploads, resolveUploader$1 = useCallback((type, file) => is$1("image", type) && !supportsImageUploads || is$1("file", type) && !supportsFileUploads ? null : resolveUploader(type, file), [supportsFileUploads, supportsImageUploads]), handleUpload = useCallback(({
    file: file_0,
    schemaType,
    uploader
  }) => {
    const item_3 = createProtoArrayValue(schemaType), key = item_3._key;
    handleInsert({
      items: [item_3],
      position: "after",
      referenceItem: -1,
      open: !1
    });
    const options = {
      metadata: get(schemaType, "options.metadata"),
      storeOriginalFilename: get(schemaType, "options.storeOriginalFilename")
    }, events$ = uploader.upload(client, file_0, schemaType, options).pipe(map((uploadProgressEvent) => PatchEvent.from(uploadProgressEvent.patches || []).prefixAll({
      _key: key
    })), tap((event_4) => handleChange(event_4.patches)));
    uploadSubscriptions.current = {
      ...uploadSubscriptions.current,
      [key]: events$.subscribe()
    };
  }, [client, handleChange, handleInsert]), inputProps = useMemo(() => ({
    level: member.field.level,
    members: member.field.members,
    value: member.field.value,
    readOnly: member.field.readOnly,
    schemaType: member.field.schemaType,
    changed: member.field.changed,
    id: member.field.id,
    onItemExpand: handleExpandItem,
    onItemCollapse: handleCollapseItem,
    onItemClose: handleCloseItem,
    onItemOpen: handleOpenItem,
    focusPath: member.field.focusPath,
    focused: member.field.focused,
    path: member.field.path,
    onChange: handleChange,
    onInsert: handleInsert,
    onItemMove: handleMoveItem,
    onItemRemove: handleRemoveItem,
    onItemAppend: handleItemAppend,
    onItemPrepend: handleItemPrepend,
    onPathFocus: handleFocusChildPath,
    resolveInitialValue: resolveInitialValue2,
    onUpload: handleUpload,
    resolveUploader: resolveUploader$1,
    validation: member.field.validation,
    presence: member.field.presence,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderInlineBlock,
    renderInput,
    renderField,
    renderItem: renderItem2,
    renderPreview,
    elementProps
  }), [member.field.level, member.field.members, member.field.value, member.field.readOnly, member.field.schemaType, member.field.changed, member.field.id, member.field.focusPath, member.field.focused, member.field.path, member.field.validation, member.field.presence, handleExpandItem, handleCollapseItem, handleCloseItem, handleOpenItem, handleChange, handleInsert, handleMoveItem, handleRemoveItem, handleItemAppend, handleItemPrepend, handleFocusChildPath, resolveInitialValue2, handleUpload, resolveUploader$1, renderAnnotation, renderBlock2, renderInlineBlock, renderInput, renderField, renderItem2, renderPreview, elementProps]), renderedInput = useMemo(() => renderInput(inputProps), [inputProps, renderInput]), fieldProps = useMemo(() => ({
    actions: fieldActions,
    name: member.name,
    index: member.index,
    level: member.field.level,
    value: member.field.value,
    title: member.field.schemaType.title,
    description: member.field.schemaType.description,
    collapsible: member.collapsible,
    collapsed: member.collapsed,
    changed: member.field.changed,
    onCollapse: handleCollapse,
    onExpand: handleExpand,
    schemaType: member.field.schemaType,
    inputId: member.field.id,
    path: member.field.path,
    presence: member.field.presence,
    validation: member.field.validation,
    children: renderedInput,
    inputProps
  }), [fieldActions, member.name, member.index, member.field.level, member.field.value, member.field.schemaType, member.field.changed, member.field.id, member.field.path, member.field.presence, member.field.validation, member.collapsible, member.collapsed, handleCollapse, handleExpand, renderedInput, inputProps]);
  return /* @__PURE__ */ jsx(FormCallbacksProvider, { onFieldGroupSelect, onChange: handleChange, onSetFieldSetCollapsed, onSetPathCollapsed, onPathOpen, onPathBlur, onPathFocus, children: useMemo(() => renderField(fieldProps), [fieldProps, renderField]) });
}
function readAsText(file, encoding) {
  return new Observable((observer) => {
    const reader = new FileReader();
    return reader.onerror = (error) => observer.error(error), reader.onload = () => {
      observer.next(reader.result), observer.complete();
    }, reader.readAsText(file, encoding), () => {
      reader.abort();
    };
  });
}
function move(arr, from2, to) {
  const copy = arr.slice(), val = copy[from2];
  return copy.splice(from2, 1), copy.splice(to, 0, val), copy;
}
function insertAfter(index, arr, items) {
  const copy = arr.slice();
  return copy.splice(index + 1, 0, ...items), copy;
}
function isStringNumeric(input) {
  return /^\d+$/.test(input);
}
function convertToSchemaType(line, candidates) {
  let acceptsBooleans = !1, acceptsNumbers = !1, acceptsStrings = !1;
  return candidates.forEach((candidate) => {
    isBooleanSchemaType(candidate) && (acceptsBooleans = !0), isStringSchemaType(candidate) && (acceptsStrings = !0), isNumberSchemaType(candidate) && (acceptsNumbers = !0);
  }), acceptsBooleans && (line === "true" || line === "false") ? line === "true" : acceptsNumbers && isStringNumeric(line) ? Number(line) : acceptsStrings ? line : void 0;
}
function createPlainTextUploader(itemTypes) {
  return {
    priority: 0,
    accepts: "text/*",
    type: "string",
    upload(client, file) {
      return readAsText(file, "utf-8").pipe(map((textContent) => textContent?.split(/[\n\r]/).map((value) => convertToSchemaType(value, itemTypes)).filter((v) => v !== void 0)), filter((v) => Array.isArray(v)), map((lines) => ({
        type: "uploadProgress",
        patches: [insert$1(lines, "after", [-1])]
      })));
    }
  };
}
function ArrayOfPrimitivesField(props2) {
  const {
    onPathBlur,
    onPathFocus,
    onChange,
    onPathOpen,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onFieldGroupSelect
  } = useFormCallbacks(), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, fieldActions = useDocumentFieldActions(), focusRef = useRef(void 0), uploadSubscriptions = useRef(void 0), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  useDidUpdate(member.field.focused, (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  });
  const handleFocus = useCallback((event) => {
    event.currentTarget === event.target && event.currentTarget === focusRef.current && onPathFocus(member.field.path);
  }, [member.field.path, onPathFocus]), handleBlur = useCallback((event_0) => {
    event_0.currentTarget === event_0.target && event_0.currentTarget === focusRef.current && onPathBlur(member.field.path);
  }, [member.field.path, onPathBlur]), handleChange = useCallback((event_1) => {
    const patches = PatchEvent.from(event_1).patches;
    if (patches.some((patch2) => patch2.type === "unset" && patch2.path.length === 1)) {
      const result = applyAll(member.field.value || [], patches);
      if (Array.isArray(result) && !result.length) {
        onChange(PatchEvent.from(unset([member.name])));
        return;
      }
    }
    onChange(PatchEvent.from(event_1).prepend(setIfMissing([])).prefixAll(member.name));
  }, [onChange, member.name, member.field.value]), handleSetCollapsed = useCallback((collapsed) => {
    onSetPathCollapsed(member.field.path, collapsed);
  }, [onSetPathCollapsed, member.field.path]), handleCollapse = useCallback(() => {
    onSetPathCollapsed(member.field.path, !0);
  }, [onSetPathCollapsed, member.field.path]), handleExpand = useCallback(() => {
    onSetPathCollapsed(member.field.path, !1);
  }, [onSetPathCollapsed, member.field.path]), setValue = useCallback((nextValue) => {
    handleChange(nextValue.length === 0 ? unset() : set(nextValue));
  }, [handleChange]), handleMoveItem = useCallback((event_2) => {
    const {
      value = []
    } = member.field;
    event_2.fromIndex !== event_2.toIndex && setValue(move(value, event_2.fromIndex, event_2.toIndex));
  }, [member.field, setValue]), handleAppend = useCallback((itemValue) => {
    const {
      value: value_0 = []
    } = member.field;
    setValue(value_0.concat(itemValue));
  }, [member.field, setValue]), handlePrepend = useCallback((itemValue_0) => {
    const {
      value: value_1 = []
    } = member.field;
    setValue([itemValue_0].concat(value_1 || []));
  }, [member.field, setValue]), handleInsert = useCallback((event_3) => {
    const {
      value: value_2 = []
    } = member.field, insertIndex = event_3.referenceIndex + (event_3.position === "before" ? -1 : 0);
    setValue(insertAfter(insertIndex, value_2, event_3.items));
  }, [member.field, setValue]), handleRemoveItem = useCallback((index) => {
    handleChange(unset([index]));
  }, [handleChange]), handleFocusIndex = useCallback((index_0) => {
    onPathFocus(member.field.path.concat([index_0]));
  }, [member.field.path, onPathFocus]), elementProps = useMemo(() => ({
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: member.field.id,
    ref: focusRef,
    "aria-describedby": createDescriptionId(member.field.id, member.field.schemaType.description)
  }), [handleBlur, handleFocus, member.field.id, member.field.schemaType.description]), plainTextUploader = useMemo(() => createPlainTextUploader(member.field.schemaType.of), [member.field.schemaType.of]), resolveUploader2 = useCallback((schemaType, file) => accepts(file, "text/*") ? plainTextUploader : null, [plainTextUploader]), handleUpload = useCallback(({
    file: file_0,
    schemaType: schemaType_0,
    uploader
  }) => {
    const events$ = uploader.upload(client, file_0, schemaType_0).pipe(map((uploadProgressEvent) => PatchEvent.from(uploadProgressEvent.patches || [])), tap((event_4) => handleChange(event_4.patches)));
    uploadSubscriptions.current && uploadSubscriptions.current.unsubscribe(), uploadSubscriptions.current = events$.subscribe();
  }, [client, handleChange]), inputProps = useMemo(() => ({
    level: member.field.level,
    members: member.field.members,
    value: member.field.value,
    readOnly: member.field.readOnly,
    onSetCollapsed: handleSetCollapsed,
    schemaType: member.field.schemaType,
    changed: member.field.changed,
    id: member.field.id,
    elementProps,
    path: member.field.path,
    focusPath: member.field.focusPath,
    focused: member.field.focused,
    onChange: handleChange,
    onInsert: handleInsert,
    onMoveItem: handleMoveItem,
    onItemRemove: handleRemoveItem,
    onItemAppend: handleAppend,
    onItemPrepend: handlePrepend,
    validation: member.field.validation,
    presence: member.field.presence,
    resolveUploader: resolveUploader2,
    onUpload: handleUpload,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    onIndexFocus: handleFocusIndex,
    renderPreview
  }), [member.field.level, member.field.members, member.field.value, member.field.readOnly, member.field.schemaType, member.field.changed, member.field.id, member.field.path, member.field.focusPath, member.field.focused, member.field.validation, member.field.presence, handleSetCollapsed, elementProps, handleChange, handleInsert, handleMoveItem, handleRemoveItem, handleAppend, handlePrepend, resolveUploader2, handleUpload, renderAnnotation, renderBlock2, renderInlineBlock, renderInput, renderItem2, handleFocusIndex, renderPreview]), renderedInput = useMemo(() => renderInput(inputProps), [inputProps, renderInput]), fieldProps = useMemo(() => ({
    actions: fieldActions,
    name: member.name,
    index: member.index,
    level: member.field.level,
    value: member.field.value,
    title: member.field.schemaType.title,
    description: member.field.schemaType.description,
    collapsible: member.collapsible,
    collapsed: member.collapsed,
    onExpand: handleExpand,
    changed: member.field.changed,
    onCollapse: handleCollapse,
    schemaType: member.field.schemaType,
    inputId: member.field.id,
    path: member.field.path,
    presence: member.field.presence,
    validation: member.field.validation,
    children: renderedInput,
    inputProps
  }), [fieldActions, member.name, member.index, member.field.level, member.field.value, member.field.schemaType, member.field.changed, member.field.id, member.field.path, member.field.presence, member.field.validation, member.collapsible, member.collapsed, handleExpand, handleCollapse, renderedInput, inputProps]);
  return /* @__PURE__ */ jsx(FormCallbacksProvider, { onFieldGroupSelect, onChange: handleChange, onPathOpen, onSetFieldSetCollapsed, onSetPathCollapsed, onPathBlur, onPathFocus, children: useMemo(() => renderField(fieldProps), [fieldProps, renderField]) });
}
function isMemberObject(member) {
  return isObjectSchemaType(member.field.schemaType);
}
function isMemberArrayOfPrimitives(member) {
  return isArraySchemaType(member.field.schemaType) && member.field.schemaType.of.every((ofType) => isPrimitiveSchemaType(ofType));
}
function isMemberArrayOfObjects(member) {
  return isArraySchemaType(member.field.schemaType) && member.field.schemaType.of.every((ofType) => isObjectSchemaType(ofType));
}
const ObjectField = function(props2) {
  const {
    onPathBlur,
    onPathFocus,
    onChange,
    onPathOpen,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    onFieldGroupSelect
  } = useFormCallbacks(), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, fieldActions = useDocumentFieldActions(), focusRef = useRef(void 0), pendingValue = useRef(member.field.value);
  useEffect(() => {
    pendingValue.current = member.field.value;
  }, [member.field.value]), useDidUpdate(member.field.focused, (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && focusRef.current?.focus();
  });
  const handleBlur = useCallback(() => {
    onPathBlur(member.field.path);
  }, [member.field.path, onPathBlur]), handleFocus = useCallback(() => {
    onPathFocus(member.field.path);
  }, [member.field.path, onPathFocus]), handleFocusChildPath = useCallback((path) => {
    onPathFocus(member.field.path.concat(path));
  }, [member.field.path, onPathFocus]), handleChange = useCallback((event) => {
    if (member.field.path.length !== 0) {
      const patches = PatchEvent.from(event).patches;
      if (pendingValue.current = applyAll(pendingValue.current || {}, patches), pendingValue.current && isShallowEmptyObject(pendingValue.current)) {
        onChange(PatchEvent.from(unset([member.name])));
        return;
      }
    }
    onChange(PatchEvent.from(event).prepend(setIfMissing(createProtoValue(member.field.schemaType))).prefixAll(member.name));
  }, [onChange, member, pendingValue]), handleCollapse = useCallback(() => {
    onSetPathCollapsed(member.field.path, !0);
  }, [onSetPathCollapsed, member.field.path]), handleExpand = useCallback(() => {
    onSetPathCollapsed(member.field.path, !1);
  }, [onSetPathCollapsed, member.field.path]), handleCollapseField = useCallback((fieldName) => {
    onSetPathCollapsed(member.field.path.concat(fieldName), !0);
  }, [onSetPathCollapsed, member.field.path]), handleExpandField = useCallback((fieldName_0) => {
    onSetPathCollapsed(member.field.path.concat(fieldName_0), !1);
  }, [onSetPathCollapsed, member.field.path]), handleOpenField = useCallback((fieldName_1) => {
    onPathOpen(member.field.path.concat(fieldName_1));
  }, [onPathOpen, member.field.path]), handleCloseField = useCallback(() => {
    onPathOpen(member.field.path);
  }, [onPathOpen, member.field.path]), handleExpandFieldSet = useCallback((fieldsetName) => {
    onSetFieldSetCollapsed(member.field.path.concat(fieldsetName), !1);
  }, [onSetFieldSetCollapsed, member.field.path]), handleCollapseFieldSet = useCallback((fieldsetName_0) => {
    onSetFieldSetCollapsed(member.field.path.concat(fieldsetName_0), !0);
  }, [onSetFieldSetCollapsed, member.field.path]), handleOpen = useCallback(() => {
    onPathOpen(member.field.path);
  }, [onPathOpen, member.field.path]), handleClose = useCallback(() => {
    onPathOpen(member.field.path.slice(0, -1));
  }, [onPathOpen, member.field.path]), handleSelectFieldGroup = useCallback((groupName) => {
    onFieldGroupSelect(member.field.path, groupName);
  }, [onFieldGroupSelect, member.field.path]), elementProps = useMemo(() => ({
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: member.field.id,
    ref: focusRef,
    "aria-describedby": createDescriptionId(member.field.id, member.field.schemaType.description)
  }), [handleBlur, handleFocus, member.field.id, member.field.schemaType.description]), inputProps = useMemo(() => ({
    elementProps,
    level: member.field.level,
    members: member.field.members,
    value: member.field.value,
    readOnly: member.field.readOnly,
    validation: member.field.validation,
    presence: member.field.presence,
    schemaType: member.field.schemaType,
    changed: member.field.changed,
    id: member.field.id,
    onFieldGroupSelect: handleSelectFieldGroup,
    onFieldOpen: handleOpenField,
    onFieldClose: handleCloseField,
    onFieldCollapse: handleCollapseField,
    onFieldExpand: handleExpandField,
    onFieldSetExpand: handleExpandFieldSet,
    onFieldSetCollapse: handleCollapseFieldSet,
    onPathFocus: handleFocusChildPath,
    path: member.field.path,
    focusPath: member.field.focusPath,
    focused: member.field.focused,
    groups: member.field.groups,
    onChange: handleChange,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  }), [elementProps, member.field.level, member.field.members, member.field.value, member.field.readOnly, member.field.validation, member.field.presence, member.field.schemaType, member.field.changed, member.field.id, member.field.path, member.field.focusPath, member.field.focused, member.field.groups, handleSelectFieldGroup, handleOpenField, handleCloseField, handleCollapseField, handleExpandField, handleExpandFieldSet, handleCollapseFieldSet, handleFocusChildPath, handleChange, renderAnnotation, renderBlock2, renderField, renderInlineBlock, renderInput, renderItem2, renderPreview]), renderedInput = useMemo(() => renderInput(inputProps), [inputProps, renderInput]), fieldProps = useMemo(() => ({
    actions: fieldActions,
    name: member.name,
    index: member.index,
    level: member.field.level,
    value: member.field.value,
    validation: member.field.validation,
    presence: member.field.presence,
    title: member.field.schemaType.title,
    description: member.field.schemaType.description,
    collapsible: member.collapsible,
    collapsed: member.collapsed,
    onCollapse: handleCollapse,
    onExpand: handleExpand,
    open: member.open,
    changed: member.field.changed,
    onOpen: handleOpen,
    onClose: handleClose,
    schemaType: member.field.schemaType,
    inputId: member.field.id,
    path: member.field.path,
    children: renderedInput,
    inputProps
  }), [fieldActions, member.name, member.index, member.field.level, member.field.value, member.field.validation, member.field.presence, member.field.schemaType, member.field.changed, member.field.id, member.field.path, member.collapsible, member.collapsed, member.open, handleCollapse, handleExpand, handleOpen, handleClose, renderedInput, inputProps]);
  return /* @__PURE__ */ jsx(FormCallbacksProvider, { onFieldGroupSelect, onChange: handleChange, onSetFieldSetCollapsed, onPathOpen, onSetPathCollapsed, onPathBlur, onPathFocus, children: useMemo(() => renderField(fieldProps), [fieldProps, renderField]) });
};
function PrimitiveField$1(props2) {
  const {
    member,
    renderInput,
    renderField
  } = props2, fieldActions = useDocumentFieldActions(), focusRef = useRef(void 0), [localValue, setLocalValue] = useState(), {
    onPathBlur,
    onPathFocus,
    onChange
  } = useFormCallbacks();
  useEffect(() => {
    member.field.focused && focusRef.current?.focus();
  }, [member.field.focused]);
  const handleBlur = useCallback(() => {
    onPathBlur(member.field.path);
  }, [member.field.path, onPathBlur]), handleFocus = useCallback(() => {
    onPathFocus(member.field.path);
  }, [member.field.path, onPathFocus]), handleChange = useCallback((event) => {
    onChange(PatchEvent.from(event).prefixAll(member.name));
  }, [onChange, member.name]), handleNativeChange = useCallback((event_0) => {
    let inputValue = event_0.currentTarget.value;
    if (isNumberSchemaType(member.field.schemaType)) {
      if (inputValue = event_0.currentTarget.valueAsNumber, inputValue > Number.MAX_SAFE_INTEGER || inputValue < Number.MIN_SAFE_INTEGER)
        return;
    } else isBooleanSchemaType(member.field.schemaType) && (inputValue = event_0.currentTarget.checked);
    const hasEmptyValue = inputValue === "" || typeof inputValue == "number" && isNaN(inputValue);
    isNumberSchemaType(member.field.schemaType) && setLocalValue(hasEmptyValue ? void 0 : event_0.currentTarget.value), onChange(PatchEvent.from(hasEmptyValue ? unset() : set(inputValue)).prefixAll(member.name));
  }, [member.name, member.field.schemaType, onChange]), validationError = useMemo(() => member.field.validation.filter((item) => item.level === "error").map((item_0) => item_0.message).join(`
`), [member.field.validation]) || void 0, elementProps = useMemo(() => ({
    onBlur: handleBlur,
    onFocus: handleFocus,
    id: member.field.id,
    ref: focusRef,
    onChange: handleNativeChange,
    value: resolveNativeNumberInputValue(member.field.schemaType, member.field.value, localValue),
    readOnly: !!member.field.readOnly,
    placeholder: member.field.schemaType.placeholder,
    "aria-describedby": createDescriptionId(member.field.id, member.field.schemaType.description)
  }), [handleBlur, handleFocus, handleNativeChange, member.field.id, member.field.readOnly, member.field.schemaType, member.field.value, localValue]), inputProps = useMemo(() => ({
    value: member.field.value,
    readOnly: member.field.readOnly,
    schemaType: member.field.schemaType,
    changed: member.field.changed,
    id: member.field.id,
    path: member.field.path,
    focused: member.field.focused,
    level: member.field.level,
    onChange: handleChange,
    validation: member.field.validation,
    presence: member.field.presence,
    validationError,
    elementProps
  }), [member.field.value, member.field.readOnly, member.field.schemaType, member.field.changed, member.field.id, member.field.path, member.field.focused, member.field.level, member.field.validation, member.field.presence, handleChange, validationError, elementProps]), renderedInput = useMemo(() => renderInput(inputProps), [inputProps, renderInput]), fieldProps = useMemo(() => ({
    actions: fieldActions,
    changed: member.field.changed,
    children: renderedInput,
    description: member.field.schemaType.description,
    index: member.index,
    inputId: member.field.id,
    inputProps,
    level: member.field.level,
    name: member.name,
    path: member.field.path,
    presence: member.field.presence,
    schemaType: member.field.schemaType,
    title: member.field.schemaType.title,
    validation: member.field.validation,
    value: member.field.value
  }), [fieldActions, member.field.level, member.field.value, member.field.schemaType, member.field.id, member.field.path, member.field.validation, member.field.presence, member.field.changed, member.name, member.index, renderedInput, inputProps]);
  return /* @__PURE__ */ jsx(Fragment, { children: renderField(fieldProps) });
}
const MemberField = memo(function(props2) {
  const $ = c(31), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2;
  if (isMemberObject(member)) {
    let t02;
    return $[0] !== member || $[1] !== renderAnnotation || $[2] !== renderBlock2 || $[3] !== renderField || $[4] !== renderInlineBlock || $[5] !== renderInput || $[6] !== renderItem2 || $[7] !== renderPreview ? (t02 = /* @__PURE__ */ jsx(ObjectField, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }), $[0] = member, $[1] = renderAnnotation, $[2] = renderBlock2, $[3] = renderField, $[4] = renderInlineBlock, $[5] = renderInput, $[6] = renderItem2, $[7] = renderPreview, $[8] = t02) : t02 = $[8], t02;
  }
  if (isMemberArrayOfPrimitives(member)) {
    const t02 = renderItem2;
    let t1;
    return $[9] !== member || $[10] !== renderAnnotation || $[11] !== renderBlock2 || $[12] !== renderField || $[13] !== renderInlineBlock || $[14] !== renderInput || $[15] !== renderPreview || $[16] !== t02 ? (t1 = /* @__PURE__ */ jsx(ArrayOfPrimitivesField, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInput, renderInlineBlock, renderItem: t02, renderPreview }), $[9] = member, $[10] = renderAnnotation, $[11] = renderBlock2, $[12] = renderField, $[13] = renderInlineBlock, $[14] = renderInput, $[15] = renderPreview, $[16] = t02, $[17] = t1) : t1 = $[17], t1;
  }
  if (isMemberArrayOfObjects(member)) {
    let t02;
    return $[18] !== member || $[19] !== renderAnnotation || $[20] !== renderBlock2 || $[21] !== renderField || $[22] !== renderInlineBlock || $[23] !== renderInput || $[24] !== renderItem2 || $[25] !== renderPreview ? (t02 = /* @__PURE__ */ jsx(ArrayOfObjectsField, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }), $[18] = member, $[19] = renderAnnotation, $[20] = renderBlock2, $[21] = renderField, $[22] = renderInlineBlock, $[23] = renderInput, $[24] = renderItem2, $[25] = renderPreview, $[26] = t02) : t02 = $[26], t02;
  }
  let t0;
  return $[27] !== member || $[28] !== renderField || $[29] !== renderInput ? (t0 = /* @__PURE__ */ jsx(PrimitiveField$1, { member, renderField, renderInput }), $[27] = member, $[28] = renderField, $[29] = renderInput, $[30] = t0) : t0 = $[30], t0;
}), STATUS_TONES$1 = {
  warning: "caution",
  error: "critical"
}, SuffixBox = styled(Box)`
  border-top: 1px solid var(--card-border-color);
`;
function Alert(props2) {
  const $ = c(30);
  let children, rest, suffix, t0, title;
  $[0] !== props2 ? ({
    children,
    status: t0,
    suffix,
    title,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = rest, $[3] = suffix, $[4] = t0, $[5] = title) : (children = $[1], rest = $[2], suffix = $[3], t0 = $[4], title = $[5]);
  const status = t0 === void 0 ? "warning" : t0, t1 = STATUS_TONES$1[status];
  let t2;
  $[6] !== status ? (t2 = status === "warning" && /* @__PURE__ */ jsx(WarningOutlineIcon, {}), $[6] = status, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== status ? (t3 = status === "error" && /* @__PURE__ */ jsx(ErrorOutlineIcon, {}), $[8] = status, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t2 || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t2,
    t3
  ] }) }), $[10] = t2, $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== title ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: title }), $[13] = title, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== children ? (t6 = children && /* @__PURE__ */ jsx(Box, { marginTop: 3, children }), $[15] = children, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== t5 || $[18] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Box, { flex: 1, marginLeft: 3, children: [
    t5,
    t6
  ] }), $[17] = t5, $[18] = t6, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== t4 || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { padding: 4, children: [
    t4,
    t7
  ] }), $[20] = t4, $[21] = t7, $[22] = t8) : t8 = $[22];
  let t9;
  $[23] !== suffix ? (t9 = suffix && /* @__PURE__ */ jsx(SuffixBox, { children: suffix }), $[23] = suffix, $[24] = t9) : t9 = $[24];
  let t10;
  return $[25] !== rest || $[26] !== t1 || $[27] !== t8 || $[28] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Card, { radius: 2, tone: t1, ...rest, "data-ui": "Alert", children: [
    t8,
    t9
  ] }), $[25] = rest, $[26] = t1, $[27] = t8, $[28] = t9, $[29] = t10) : t10 = $[29], t10;
}
const TRUTHY_STRINGS = ["yes", "true", "1"], FALSEY_STRINGS = ["false", "no", "false", "0", "null"], BOOL_STRINGS = TRUTHY_STRINGS.concat(FALSEY_STRINGS), TRUE = () => !0, has = (prop) => (val) => val && val[prop], is = (typeName) => (val) => (val && val._type) === typeName;
function toLocalDate(input) {
  const newDate = new Date(input.getTime() + input.getTimezoneOffset() * 60 * 1e3), offset = input.getTimezoneOffset() / 60, hours = input.getHours();
  return newDate.setHours(hours - offset), newDate;
}
function getTZName() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
  }
  return null;
}
const converters = {
  string: {
    number: {
      test: Number,
      convert: Number
    },
    boolean: {
      test: (value) => BOOL_STRINGS.includes(value.toLowerCase()),
      convert: (value) => TRUTHY_STRINGS.includes(value.toLowerCase()) || !FALSEY_STRINGS.includes(value.toLowerCase())
    },
    richDate: {
      test: (value) => isValid(value),
      convert: (value) => ({
        _type: "richDate",
        local: toLocalDate(new Date(value)).toJSON(),
        utc: new Date(value).toJSON(),
        timezone: getTZName(),
        offset: (/* @__PURE__ */ new Date()).getTimezoneOffset()
      })
    }
  },
  date: {
    richDate: {
      test: is("date"),
      convert: (value) => Object.assign({}, value, {
        _type: "richDate"
      })
    }
  },
  richDate: {
    datetime: {
      test: has("utc"),
      convert: (value) => value.utc
    }
  },
  number: {
    string: {
      test: TRUE,
      convert: String
    },
    boolean: {
      test: TRUE,
      convert: Number
    }
  },
  boolean: {
    string: {
      test: TRUE,
      convert: (value) => value ? "Yes" : "No"
    },
    number: {
      test: TRUE,
      convert: Number
    }
  }
};
function SetMissingTypeButton(t0) {
  const $ = c(13), {
    value,
    targetType,
    onChange
  } = t0;
  let t1, t2;
  $[0] !== targetType || $[1] !== value ? (t2 = {
    ...value,
    _type: targetType
  }, $[0] = targetType, $[1] = value, $[2] = t2) : t2 = $[2], t1 = t2;
  const itemValue = t1;
  let t3;
  $[3] !== itemValue || $[4] !== onChange || $[5] !== targetType ? (t3 = () => onChange(PatchEvent.from(setIfMissing(targetType, ["_type"])), itemValue), $[3] = itemValue, $[4] = onChange, $[5] = targetType, $[6] = t3) : t3 = $[6];
  const handleClick = t3, {
    t
  } = useTranslation();
  let t4;
  $[7] !== t || $[8] !== targetType ? (t4 = t("inputs.untyped-value.convert-button.text", {
    targetType
  }), $[7] = t, $[8] = targetType, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== handleClick || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { onClick: handleClick, text: t4 }), $[10] = handleClick, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
function UnsetItemButton(t0) {
  const $ = c(11), {
    value,
    onChange,
    validTypes
  } = t0;
  let t1, t2;
  $[0] !== validTypes[0] || $[1] !== value ? (t2 = {
    ...value,
    _type: validTypes[0]
  }, $[0] = validTypes[0], $[1] = value, $[2] = t2) : t2 = $[2], t1 = t2;
  const itemValue = t1;
  let t3;
  $[3] !== itemValue || $[4] !== onChange ? (t3 = () => onChange(PatchEvent.from(unset()), itemValue), $[3] = itemValue, $[4] = onChange, $[5] = t3) : t3 = $[5];
  const handleClick = t3, {
    t
  } = useTranslation();
  let t4;
  $[6] !== t ? (t4 = t("inputs.untyped-value.unset-item-button.text"), $[6] = t, $[7] = t4) : t4 = $[7];
  let t5;
  return $[8] !== handleClick || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { onClick: handleClick, tone: "critical", text: t4 }), $[8] = handleClick, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}
function UntypedValueInput(t0) {
  const $ = c(56), {
    validTypes,
    value,
    onChange
  } = t0, schema2 = useSchema(), isSingleValidType = validTypes.length === 1;
  let t1;
  $[0] !== schema2 || $[1] !== validTypes[0] ? (t1 = schema2.has(validTypes[0]), $[0] = schema2, $[1] = validTypes[0], $[2] = t1) : t1 = $[2];
  const isHoistedType = t1, {
    t
  } = useTranslation();
  let t2;
  $[3] !== t ? (t2 = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.untyped-value.title" }) }), $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("inputs.untyped-value.details.title"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t ? (t4 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.untyped-value.description" }) }), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== isHoistedType || $[10] !== isSingleValidType || $[11] !== t ? (t5 = isSingleValidType && !isHoistedType && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.untyped-value.details.description" }) }), $[9] = isHoistedType, $[10] = isSingleValidType, $[11] = t, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== isSingleValidType || $[14] !== t ? (t6 = !isSingleValidType && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.untyped-value.details.multi-type-description") }), $[13] = isSingleValidType, $[14] = t, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== isSingleValidType || $[17] !== validTypes ? (t7 = !isSingleValidType && /* @__PURE__ */ jsx(Stack, { as: "ul", space: 2, children: validTypes.map(_temp$1$) }), $[16] = isSingleValidType, $[17] = validTypes, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== t ? (t8 = t("inputs.untyped-value.details.json-dump-prefix"), $[19] = t, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { as: "h4", weight: "medium", size: 1, children: t8 }), $[21] = t8, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== value ? (t10 = JSON.stringify(value, null, 2), $[23] = value, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t10 ? (t11 = /* @__PURE__ */ jsx(Card, { border: !0, overflow: "auto", padding: 2, radius: 2, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { language: "json", children: t10 }) }), $[25] = t10, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== t11 || $[28] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t9,
    t11
  ] }), $[27] = t11, $[28] = t9, $[29] = t12) : t12 = $[29];
  let t13;
  $[30] === Symbol.for("react.memo_cache_sentinel") ? (t13 = [1, 2, 2], $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== isSingleValidType || $[32] !== onChange || $[33] !== validTypes[0] || $[34] !== value ? (t14 = isSingleValidType && /* @__PURE__ */ jsx(SetMissingTypeButton, { onChange, targetType: validTypes[0], value }), $[31] = isSingleValidType, $[32] = onChange, $[33] = validTypes[0], $[34] = value, $[35] = t14) : t14 = $[35];
  let t15;
  $[36] !== onChange || $[37] !== validTypes || $[38] !== value ? (t15 = /* @__PURE__ */ jsx(UnsetItemButton, { onChange, validTypes, value }), $[36] = onChange, $[37] = validTypes, $[38] = value, $[39] = t15) : t15 = $[39];
  let t16;
  $[40] !== t14 || $[41] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Grid, { columns: t13, gap: 1, children: [
    t14,
    t15
  ] }), $[40] = t14, $[41] = t15, $[42] = t16) : t16 = $[42];
  let t17;
  $[43] !== t12 || $[44] !== t16 || $[45] !== t4 || $[46] !== t5 || $[47] !== t6 || $[48] !== t7 ? (t17 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t4,
    t5,
    t6,
    t7,
    t12,
    t16
  ] }), $[43] = t12, $[44] = t16, $[45] = t4, $[46] = t5, $[47] = t6, $[48] = t7, $[49] = t17) : t17 = $[49];
  let t18;
  $[50] !== t17 || $[51] !== t3 ? (t18 = /* @__PURE__ */ jsx(Details, { open: isDev, title: t3, children: t17 }), $[50] = t17, $[51] = t3, $[52] = t18) : t18 = $[52];
  let t19;
  return $[53] !== t18 || $[54] !== t2 ? (t19 = /* @__PURE__ */ jsx(Alert, { status: "warning", title: t2, children: t18 }), $[53] = t18, $[54] = t2, $[55] = t19) : t19 = $[55], t19;
}
function _temp$1$(validType) {
  return /* @__PURE__ */ jsx(Text$1, { as: "li", muted: !0, size: 1, children: /* @__PURE__ */ jsx("code", { children: validType }) }, validType);
}
function getConverters(value, actualType, validTypes) {
  return actualType in converters ? Object.keys(converters[actualType]).filter((targetType) => validTypes.includes(targetType)).map((targetType) => ({
    from: actualType,
    to: targetType,
    ...converters[actualType][targetType]
  })).filter((converter) => converter.test(value)) : [];
}
const InvalidValueInput = forwardRef((props2, ref) => {
  const {
    value,
    actualType,
    validTypes,
    onChange
  } = props2;
  useImperativeHandle(ref, () => ({
    // @todo
    focus: () => {
    }
  }));
  const handleClearClick = useCallback(() => {
    onChange(PatchEvent.from(unset()));
  }, [onChange]), handleConvertTo = useCallback((converted) => {
    onChange(PatchEvent.from(set(converted)));
  }, [onChange]), converters2 = useMemo(() => getConverters(value, actualType, validTypes), [value, actualType, validTypes]), {
    t
  } = useTranslation();
  if (isPlainObject$1(value) && !("_type" in value))
    return /* @__PURE__ */ jsx(UntypedValueInput, { value, validTypes, onChange });
  const suffix = /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { onClick: handleClearClick, tone: "critical", text: t("inputs.invalid-value.reset-button.text") }) });
  return /* @__PURE__ */ jsxs(Alert, { status: "error", suffix, title: t("inputs.invalid-value.title"), children: [
    /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.invalid-value.description") }),
    /* @__PURE__ */ jsx(Details, { marginTop: 4, open: isDev, title: t("inputs.invalid-value.details.title"), children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      validTypes.length === 1 && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.invalid-value.details.description", values: {
        validType: validTypes[0]
      } }) }),
      validTypes.length === 1 && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.invalid-value.details.possible-reason") }),
      validTypes.length !== 1 && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.invalid-value.details.multi-type-description") }),
      validTypes.length !== 1 && /* @__PURE__ */ jsx(Stack, { as: "ul", space: 2, children: validTypes.map((validType) => /* @__PURE__ */ jsx(Text$1, { as: "li", children: /* @__PURE__ */ jsx("code", { children: validType }) }, validType)) }),
      /* @__PURE__ */ jsxs(Stack, { marginTop: 2, space: 2, children: [
        /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.invalid-value.current-type", values: {
          actualType
        } }) }),
        /* @__PURE__ */ jsx(Card, { border: !0, padding: 2, radius: 2, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: JSON.stringify(value, null, 2) }) })
      ] }),
      converters2.length > 0 && /* @__PURE__ */ jsx(Stack, { space: 1, children: converters2.map((converter) => /* @__PURE__ */ jsx(ConvertButton, { converter, onConvert: handleConvertTo, value }, `${converter.from}-${converter.to}`)) })
    ] }) })
  ] });
});
InvalidValueInput.displayName = "ForwardRef(InvalidValueInput)";
function ConvertButton(t0) {
  const $ = c(10), {
    converter,
    onConvert,
    value
  } = t0;
  let t1;
  $[0] !== converter || $[1] !== onConvert || $[2] !== value ? (t1 = () => onConvert(converter.convert(value)), $[0] = converter, $[1] = onConvert, $[2] = value, $[3] = t1) : t1 = $[3];
  const handleClick = t1, {
    t
  } = useTranslation();
  let t2;
  $[4] !== converter.to || $[5] !== t ? (t2 = t("inputs.invalid-value.convert-button.text", {
    targetType: converter.to
  }), $[4] = converter.to, $[5] = t, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== handleClick || $[8] !== t2 ? (t3 = /* @__PURE__ */ jsx(Button, { onClick: handleClick, text: t2 }), $[7] = handleClick, $[8] = t2, $[9] = t3) : t3 = $[9], t3;
}
function DuplicateKeysAlert(props2) {
  const $ = c(35), {
    error,
    onChange
  } = props2;
  let t0;
  $[0] !== error.duplicates || $[1] !== onChange ? (t0 = () => {
    onChange(PatchEvent.from((error.duplicates || []).map(_temp$1_)));
  }, $[0] = error.duplicates, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleFixDuplicateKeys = t0, {
    t
  } = useTranslation(), t1 = error.schemaType.title, t2 = error.schemaType.description;
  let t3;
  $[3] !== t ? (t3 = t("form.error.duplicate-keys-alert.generate-button.text"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== handleFixDuplicateKeys || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { onClick: handleFixDuplicateKeys, text: t3, tone: "caution" }) }), $[5] = handleFixDuplicateKeys, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t ? (t5 = t("form.error.duplicate-keys-alert.title"), $[8] = t, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t ? (t6 = t("form.error.duplicate-keys-alert.summary"), $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t6 }), $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t ? (t8 = t("form.error.duplicate-keys-alert.details.title"), $[14] = t, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== t ? (t9 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.duplicate-keys-alert.details.description" }) }), $[16] = t, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t ? (t10 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.duplicate-keys-alert.details.additional-description" }) }), $[18] = t, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== t10 || $[21] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t9,
    t10
  ] }), $[20] = t10, $[21] = t9, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== t11 || $[24] !== t8 ? (t12 = /* @__PURE__ */ jsx(Details, { marginTop: 4, open: isDev, title: t8, children: t11 }), $[23] = t11, $[24] = t8, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t12 || $[27] !== t4 || $[28] !== t5 || $[29] !== t7 ? (t13 = /* @__PURE__ */ jsxs(Alert, { status: "warning", suffix: t4, title: t5, children: [
    t7,
    t12
  ] }), $[26] = t12, $[27] = t4, $[28] = t5, $[29] = t7, $[30] = t13) : t13 = $[30];
  let t14;
  return $[31] !== error.schemaType.description || $[32] !== error.schemaType.title || $[33] !== t13 ? (t14 = /* @__PURE__ */ jsx(FormField, { title: t1, description: t2, children: t13 }), $[31] = error.schemaType.description, $[32] = error.schemaType.title, $[33] = t13, $[34] = t14) : t14 = $[34], t14;
}
function _temp$1_(t0) {
  const [index, key] = t0;
  return set(`${key}_deduped_${index}`, [index, "_key"]);
}
function MissingKeysAlert(props2) {
  const $ = c(35), {
    error,
    onChange
  } = props2;
  let t0;
  $[0] !== error.value || $[1] !== onChange ? (t0 = () => {
    onChange(PatchEvent.from((error.value || []).map(_temp$1Z)));
  }, $[0] = error.value, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleFixMissingKeys = t0, {
    t
  } = useTranslation(), t1 = error.schemaType.title, t2 = error.schemaType.description;
  let t3;
  $[3] !== t ? (t3 = t("form.error.missing-keys-alert.add-button.text"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== handleFixMissingKeys || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { onClick: handleFixMissingKeys, text: t3, tone: "caution" }) }), $[5] = handleFixMissingKeys, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t ? (t5 = t("form.error.missing-keys-alert.title"), $[8] = t, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t ? (t6 = t("form.error.missing-keys-alert.summary"), $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t6 }), $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t ? (t8 = t("form.error.missing-keys-alert.details.title"), $[14] = t, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== t ? (t9 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.missing-keys-alert.details.description" }) }), $[16] = t, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t ? (t10 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.missing-keys-alert.details.additional-description" }) }), $[18] = t, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== t10 || $[21] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t9,
    t10
  ] }), $[20] = t10, $[21] = t9, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== t11 || $[24] !== t8 ? (t12 = /* @__PURE__ */ jsx(Details, { marginTop: 4, open: isDev, title: t8, children: t11 }), $[23] = t11, $[24] = t8, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t12 || $[27] !== t4 || $[28] !== t5 || $[29] !== t7 ? (t13 = /* @__PURE__ */ jsxs(Alert, { status: "warning", suffix: t4, title: t5, children: [
    t7,
    t12
  ] }), $[26] = t12, $[27] = t4, $[28] = t5, $[29] = t7, $[30] = t13) : t13 = $[30];
  let t14;
  return $[31] !== error.schemaType.description || $[32] !== error.schemaType.title || $[33] !== t13 ? (t14 = /* @__PURE__ */ jsx(FormField, { title: t1, description: t2, children: t13 }), $[31] = error.schemaType.description, $[32] = error.schemaType.title, $[33] = t13, $[34] = t14) : t14 = $[34], t14;
}
function _temp$1Z(val, i) {
  return setIfMissing(randomKey$1(), [i, "_key"]);
}
function MixedArrayAlert(props2) {
  const $ = c(32), {
    error,
    onChange
  } = props2;
  let t0;
  $[0] !== error.value || $[1] !== onChange ? (t0 = () => {
    const patches = (error.value || []).flatMap(_temp$1Y).reverse().map(_temp2$I);
    onChange(PatchEvent.from(patches));
  }, $[0] = error.value, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleRemoveNonObjectValues = t0, {
    t
  } = useTranslation(), t1 = error.schemaType.title, t2 = error.schemaType.description;
  let t3;
  $[3] !== t ? (t3 = t("form.error.mixed-array-alert.remove-button.text"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== handleRemoveNonObjectValues || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { onClick: handleRemoveNonObjectValues, text: t3, tone: "critical" }) }), $[5] = handleRemoveNonObjectValues, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t ? (t5 = t("form.error.mixed-array-alert.title"), $[8] = t, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t ? (t6 = t("form.error.mixed-array-alert.summary"), $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t6 }), $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t ? (t8 = t("form.error.mixed-array-alert.details.title"), $[14] = t, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== t ? (t9 = t("form.error.mixed-array-alert.details.description"), $[16] = t, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t9 ? (t10 = /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t9 }) }), $[18] = t9, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== t10 || $[21] !== t8 ? (t11 = /* @__PURE__ */ jsx(Details, { marginTop: 4, open: isDev, title: t8, children: t10 }), $[20] = t10, $[21] = t8, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== t11 || $[24] !== t4 || $[25] !== t5 || $[26] !== t7 ? (t12 = /* @__PURE__ */ jsxs(Alert, { status: "error", suffix: t4, title: t5, children: [
    t7,
    t11
  ] }), $[23] = t11, $[24] = t4, $[25] = t5, $[26] = t7, $[27] = t12) : t12 = $[27];
  let t13;
  return $[28] !== error.schemaType.description || $[29] !== error.schemaType.title || $[30] !== t12 ? (t13 = /* @__PURE__ */ jsx(FormField, { title: t1, description: t2, children: t12 }), $[28] = error.schemaType.description, $[29] = error.schemaType.title, $[30] = t12, $[31] = t13) : t13 = $[31], t13;
}
function _temp2$I(index_0) {
  return unset([index_0]);
}
function _temp$1Y(item, index) {
  return isPlainObject$1(item) ? [] : [index];
}
function MemberFieldError(props2) {
  const $ = c(24), {
    member
  } = props2, {
    onChange
  } = useFormCallbacks();
  let t0;
  $[0] !== member.fieldName || $[1] !== onChange ? (t0 = (event) => {
    onChange(PatchEvent.from(event).prefixAll(member.fieldName));
  }, $[0] = member.fieldName, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleChange = t0, {
    t
  } = useTranslation();
  if (member.error.type === "INCOMPATIBLE_TYPE") {
    let t12;
    $[3] !== member.error.expectedSchemaType.name ? (t12 = [member.error.expectedSchemaType.name], $[3] = member.error.expectedSchemaType.name, $[4] = t12) : t12 = $[4];
    let t22;
    return $[5] !== handleChange || $[6] !== member.error.resolvedValueType || $[7] !== member.error.value || $[8] !== t12 ? (t22 = /* @__PURE__ */ jsx(InvalidValueInput, { value: member.error.value, onChange: handleChange, actualType: member.error.resolvedValueType, validTypes: t12 }), $[5] = handleChange, $[6] = member.error.resolvedValueType, $[7] = member.error.value, $[8] = t12, $[9] = t22) : t22 = $[9], t22;
  }
  if (member.error.type === "MISSING_KEYS") {
    let t12;
    return $[10] !== handleChange || $[11] !== member.error ? (t12 = /* @__PURE__ */ jsx(MissingKeysAlert, { error: member.error, onChange: handleChange }), $[10] = handleChange, $[11] = member.error, $[12] = t12) : t12 = $[12], t12;
  }
  if (member.error.type === "DUPLICATE_KEYS") {
    let t12;
    return $[13] !== handleChange || $[14] !== member.error ? (t12 = /* @__PURE__ */ jsx(DuplicateKeysAlert, { error: member.error, onChange: handleChange }), $[13] = handleChange, $[14] = member.error, $[15] = t12) : t12 = $[15], t12;
  }
  if (member.error.type === "MIXED_ARRAY") {
    let t12;
    return $[16] !== handleChange || $[17] !== member.error ? (t12 = /* @__PURE__ */ jsx(MixedArrayAlert, { onChange: handleChange, error: member.error }), $[16] = handleChange, $[17] = member.error, $[18] = t12) : t12 = $[18], t12;
  }
  let t1;
  $[19] !== props2.member.error.type || $[20] !== t ? (t1 = t("member-field-error.unexpected-error", {
    error: props2.member.error.type
  }), $[19] = props2.member.error.type, $[20] = t, $[21] = t1) : t1 = $[21];
  let t2;
  return $[22] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { children: t1 }), $[22] = t1, $[23] = t2) : t2 = $[23], t2;
}
const MemberFieldSet = memo(function(props2) {
  const $ = c(40), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview
  } = props2, {
    onSetFieldSetCollapsed
  } = useFormCallbacks();
  let t0;
  $[0] !== member.fieldSet.path || $[1] !== onSetFieldSetCollapsed ? (t0 = () => {
    onSetFieldSetCollapsed(member.fieldSet.path, !0);
  }, $[0] = member.fieldSet.path, $[1] = onSetFieldSetCollapsed, $[2] = t0) : t0 = $[2];
  const handleCollapse = t0;
  let t1;
  $[3] !== member.fieldSet.path || $[4] !== onSetFieldSetCollapsed ? (t1 = () => {
    onSetFieldSetCollapsed(member.fieldSet.path, !1);
  }, $[3] = member.fieldSet.path, $[4] = onSetFieldSetCollapsed, $[5] = t1) : t1 = $[5];
  const handleExpand = t1;
  let t2;
  $[6] !== member.fieldSet.name || $[7] !== member.fieldSet.title ? (t2 = member.fieldSet.title || capitalize(member.fieldSet.name), $[6] = member.fieldSet.name, $[7] = member.fieldSet.title, $[8] = t2) : t2 = $[8];
  const t3 = member.fieldSet.description, t4 = member.fieldSet.level, t5 = member.fieldSet.collapsible, t6 = member.fieldSet.collapsed, t7 = member?.fieldSet?.columns, t8 = `fieldset-${member.fieldSet.name}`, t9 = member.fieldSet.name;
  let t10;
  if ($[9] !== member.fieldSet.members || $[10] !== member.key || $[11] !== renderAnnotation || $[12] !== renderBlock2 || $[13] !== renderField || $[14] !== renderInlineBlock || $[15] !== renderInput || $[16] !== renderItem2 || $[17] !== renderPreview) {
    let t112;
    $[19] !== member.key || $[20] !== renderAnnotation || $[21] !== renderBlock2 || $[22] !== renderField || $[23] !== renderInlineBlock || $[24] !== renderInput || $[25] !== renderItem2 || $[26] !== renderPreview ? (t112 = (fieldsetMember) => fieldsetMember.kind === "error" ? /* @__PURE__ */ jsx(MemberFieldError, { member: fieldsetMember }, member.key) : /* @__PURE__ */ jsx(MemberField, { member: fieldsetMember, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }, fieldsetMember.key), $[19] = member.key, $[20] = renderAnnotation, $[21] = renderBlock2, $[22] = renderField, $[23] = renderInlineBlock, $[24] = renderInput, $[25] = renderItem2, $[26] = renderPreview, $[27] = t112) : t112 = $[27], t10 = member.fieldSet.members.map(t112), $[9] = member.fieldSet.members, $[10] = member.key, $[11] = renderAnnotation, $[12] = renderBlock2, $[13] = renderField, $[14] = renderInlineBlock, $[15] = renderInput, $[16] = renderItem2, $[17] = renderPreview, $[18] = t10;
  } else
    t10 = $[18];
  let t11;
  return $[28] !== handleCollapse || $[29] !== handleExpand || $[30] !== member.fieldSet.collapsed || $[31] !== member.fieldSet.collapsible || $[32] !== member.fieldSet.description || $[33] !== member.fieldSet.level || $[34] !== member.fieldSet.name || $[35] !== t10 || $[36] !== t2 || $[37] !== t7 || $[38] !== t8 ? (t11 = /* @__PURE__ */ jsx(FormFieldSet, { title: t2, description: t3, level: t4, collapsible: t5, collapsed: t6, onCollapse: handleCollapse, onExpand: handleExpand, columns: t7, "data-testid": t8, inputId: t9, children: t10 }), $[28] = handleCollapse, $[29] = handleExpand, $[30] = member.fieldSet.collapsed, $[31] = member.fieldSet.collapsible, $[32] = member.fieldSet.description, $[33] = member.fieldSet.level, $[34] = member.fieldSet.name, $[35] = t10, $[36] = t2, $[37] = t7, $[38] = t8, $[39] = t11) : t11 = $[39], t11;
}), ObjectInputMember = memo(function(props2) {
  const $ = c(20), {
    member,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderInput,
    renderInlineBlock,
    renderField,
    renderItem: renderItem2,
    renderPreview
  } = props2;
  if (member.kind === "field") {
    let t0;
    return $[0] !== member || $[1] !== renderAnnotation || $[2] !== renderBlock2 || $[3] !== renderField || $[4] !== renderInlineBlock || $[5] !== renderInput || $[6] !== renderItem2 || $[7] !== renderPreview ? (t0 = /* @__PURE__ */ jsx(MemberField, { member, renderAnnotation, renderBlock: renderBlock2, renderInlineBlock, renderInput, renderField, renderItem: renderItem2, renderPreview }, member.key), $[0] = member, $[1] = renderAnnotation, $[2] = renderBlock2, $[3] = renderField, $[4] = renderInlineBlock, $[5] = renderInput, $[6] = renderItem2, $[7] = renderPreview, $[8] = t0) : t0 = $[8], t0;
  }
  if (member.kind === "error") {
    let t0;
    return $[9] !== member ? (t0 = /* @__PURE__ */ jsx(MemberFieldError, { member }, member.key), $[9] = member, $[10] = t0) : t0 = $[10], t0;
  }
  if (member.kind === "fieldSet") {
    let t0;
    return $[11] !== member || $[12] !== renderAnnotation || $[13] !== renderBlock2 || $[14] !== renderField || $[15] !== renderInlineBlock || $[16] !== renderInput || $[17] !== renderItem2 || $[18] !== renderPreview ? (t0 = /* @__PURE__ */ jsx(MemberFieldSet, { member, renderAnnotation, renderBlock: renderBlock2, renderInlineBlock, renderInput, renderField, renderItem: renderItem2, renderPreview }, member.key), $[11] = member, $[12] = renderAnnotation, $[13] = renderBlock2, $[14] = renderField, $[15] = renderInlineBlock, $[16] = renderInput, $[17] = renderItem2, $[18] = renderPreview, $[19] = t0) : t0 = $[19], t0;
  }
  return console.warn(new Error(`Unhandled member kind ${member.kind}`)), null;
});
function ObjectInputMembers(props2) {
  const $ = c(19), {
    members,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderInput,
    renderInlineBlock,
    renderField,
    renderItem: renderItem2,
    renderPreview
  } = props2;
  let t0, t1;
  if ($[0] !== members || $[1] !== renderAnnotation || $[2] !== renderBlock2 || $[3] !== renderField || $[4] !== renderInlineBlock || $[5] !== renderInput || $[6] !== renderItem2 || $[7] !== renderPreview) {
    let t22;
    $[9] !== renderAnnotation || $[10] !== renderBlock2 || $[11] !== renderField || $[12] !== renderInlineBlock || $[13] !== renderInput || $[14] !== renderItem2 || $[15] !== renderPreview ? (t22 = (member) => /* @__PURE__ */ jsx(ObjectInputMember, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }, member.key), $[9] = renderAnnotation, $[10] = renderBlock2, $[11] = renderField, $[12] = renderInlineBlock, $[13] = renderInput, $[14] = renderItem2, $[15] = renderPreview, $[16] = t22) : t22 = $[16], t1 = members.map(t22), $[0] = members, $[1] = renderAnnotation, $[2] = renderBlock2, $[3] = renderField, $[4] = renderInlineBlock, $[5] = renderInput, $[6] = renderItem2, $[7] = renderPreview, $[8] = t1;
  } else
    t1 = $[8];
  t0 = t1;
  const renderMembers = t0;
  let t2;
  return $[17] !== renderMembers ? (t2 = /* @__PURE__ */ jsx(Fragment, { children: renderMembers }), $[17] = renderMembers, $[18] = t2) : t2 = $[18], t2;
}
const ObjectMembers = ObjectInputMembers;
function isObjectInputProps$1(inputProps) {
  return isObjectSchemaType(inputProps.schemaType);
}
function isArrayInputProps(inputProps) {
  return isArraySchemaType(inputProps.schemaType);
}
const pass = ({
  children
}) => children;
function hasAbsolutePath(a) {
  return "absolutePath" in a;
}
const FormInput = memo(function(props2) {
  const $ = c(8);
  let t0, t1;
  $[0] !== props2 ? (t1 = hasAbsolutePath(props2) ? props2.absolutePath : props2.path.concat(props2.relativePath), $[0] = props2, $[1] = t1) : t1 = $[1], t0 = t1;
  const absolutePath = t0, nullRender = _temp$1X, t2 = props2.renderAnnotation || nullRender, t3 = props2.renderBlock || nullRender, t4 = props2.renderInlineBlock || nullRender;
  let t5;
  return $[2] !== absolutePath || $[3] !== props2 || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 ? (t5 = /* @__PURE__ */ jsx(FormInputInner, { ...props2, absolutePath, destinationRenderAnnotation: t2, destinationRenderBlock: t3, destinationRenderField: props2.renderField, destinationRenderInlineBlock: t4, destinationRenderInput: props2.renderInput, destinationRenderItem: props2.renderItem, destinationRenderPreview: props2.renderPreview }), $[2] = absolutePath, $[3] = props2, $[4] = t2, $[5] = t3, $[6] = t4, $[7] = t5) : t5 = $[7], t5;
}), FormInputInner = memo(function FormInputInner2(props2) {
  const {
    absolutePath,
    destinationRenderAnnotation,
    destinationRenderBlock,
    destinationRenderField,
    destinationRenderInlineBlock,
    destinationRenderInput,
    destinationRenderItem,
    destinationRenderPreview
  } = props2, {
    t
  } = useTranslation(), renderField = useCallback((fieldProps) => (isEqual$3(absolutePath, fieldProps.path) ? props2.includeField : startsWith(absolutePath, fieldProps.path)) ? destinationRenderField(fieldProps) : pass(fieldProps), [absolutePath, destinationRenderField, props2.includeField]), renderItem2 = useCallback((itemProps) => (isEqual$3(absolutePath, itemProps.path) ? props2.includeItem : startsWith(absolutePath, itemProps.path)) ? destinationRenderItem(itemProps) : pass(itemProps), [absolutePath, destinationRenderItem, props2.includeItem]), renderInput = useCallback((inputProps) => {
    if (isEqual$3(inputProps.path, absolutePath) || startsWith(absolutePath, inputProps.path))
      return destinationRenderInput(inputProps);
    if (!isObjectInputProps$1(inputProps) && !isArrayInputProps(inputProps))
      throw new Error(`Expected either object input props or array input props for: ${JSON.stringify(inputProps.path)}`);
    return /* @__PURE__ */ jsx(FormInputInner2, { ...inputProps, includeField: props2.includeField, includeItem: props2.includeItem, absolutePath, destinationRenderAnnotation, destinationRenderBlock, destinationRenderInput, destinationRenderItem, destinationRenderField, destinationRenderInlineBlock, destinationRenderPreview });
  }, [absolutePath, destinationRenderAnnotation, destinationRenderBlock, destinationRenderField, destinationRenderInlineBlock, destinationRenderInput, destinationRenderItem, destinationRenderPreview, props2.includeField, props2.includeItem]), renderBlock2 = useCallback((blockProps) => startsWith(absolutePath, blockProps.path) && (props2.includeItem || !isEqual$3(absolutePath, blockProps.path)) ? destinationRenderBlock(blockProps) : pass(blockProps), [absolutePath, destinationRenderBlock, props2.includeItem]), renderInlineBlock = useCallback((blockProps_0) => startsWith(absolutePath, blockProps_0.path) && (props2.includeItem || !isEqual$3(absolutePath, blockProps_0.path)) ? destinationRenderInlineBlock(blockProps_0) : pass(blockProps_0), [absolutePath, destinationRenderInlineBlock, props2.includeItem]), renderAnnotation = useCallback((annotationProps) => startsWith(absolutePath, annotationProps.path) && (props2.includeItem || !isEqual$3(absolutePath, annotationProps.path)) ? destinationRenderAnnotation(annotationProps) : pass(annotationProps), [absolutePath, destinationRenderAnnotation, props2.includeItem]);
  if (isArrayInputProps(props2)) {
    const childPath = trimLeft(props2.path, absolutePath), itemMember = props2.members.find((member) => member.kind == "item" && isKeySegment(childPath[0]) && member.key === childPath[0]._key);
    if (!itemMember) {
      const path = pathToString$1(props2.path), relativePath = trimLeft(props2.path, absolutePath);
      if (isKeySegment(relativePath[0])) {
        const key = relativePath[0]._key;
        return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.no-array-item-at-key", values: {
          key,
          path
        } }) });
      }
      const index = isIndexSegment(relativePath[0]) ? relativePath[0] : relativePath[0][0];
      return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "form.error.no-array-item-at-index", values: {
        index,
        path
      } }) });
    }
    return itemMember.kind === "error" ? /* @__PURE__ */ jsx(MemberItemError, { member: itemMember }) : /* @__PURE__ */ jsx(ArrayOfObjectsItem, { member: itemMember, renderAnnotation, renderBlock: renderBlock2, renderInput, renderField, renderInlineBlock, renderItem: renderItem2, renderPreview: destinationRenderPreview });
  }
  if (isObjectInputProps$1(props2)) {
    const childPath_0 = trimLeft(props2.path, absolutePath), fieldMember = props2.members.find((member_0) => member_0.kind == "field" && childPath_0[0] === member_0.name), fieldSetMember = props2.members.filter((member_1) => member_1.kind === "fieldSet").flatMap((member_2) => member_2.kind === "fieldSet" && member_2.fieldSet?.members || []).find((m) => m.kind === "field" && m.name === childPath_0[0]), member_3 = fieldMember || fieldSetMember;
    if (!member_3) {
      const fieldName = typeof childPath_0[0] == "string" ? childPath_0[0] : JSON.stringify(childPath_0[0]);
      return /* @__PURE__ */ jsx("div", { children: t("form.error.field-not-found", {
        fieldName
      }) });
    }
    return /* @__PURE__ */ jsx(MemberField, { member: member_3, renderAnnotation, renderBlock: renderBlock2, renderInput, renderInlineBlock, renderField, renderItem: renderItem2, renderPreview: destinationRenderPreview });
  }
  throw new Error("FormInput can only be used with arrays or objects");
});
function _temp$1X() {
  return /* @__PURE__ */ jsx(Fragment, { children: "Missing destination render function" });
}
function usePortableTextMemberItem(key) {
  const $ = c(5), ctx = useContext(PortableTextMemberItemsContext);
  if (!ctx)
    throw new Error("Form context not provided");
  let t0;
  if ($[0] !== ctx || $[1] !== key) {
    let t1;
    $[3] !== key ? (t1 = (m) => m.key === key, $[3] = key, $[4] = t1) : t1 = $[4], t0 = ctx.find(t1), $[0] = ctx, $[1] = key, $[2] = t0;
  } else
    t0 = $[2];
  return t0;
}
function usePortableTextMemberItems() {
  const ctx = useContext(PortableTextMemberItemsContext);
  if (!ctx)
    throw new Error("Form context not provided");
  return ctx;
}
function usePortableTextMemberItemsFromProps(props2) {
  const {
    members,
    path,
    schemaType,
    renderAnnotation,
    renderField,
    renderBlock: renderBlock2,
    renderInput,
    renderItem: renderItem2,
    renderInlineBlock,
    renderPreview,
    onPathFocus
  } = props2, portableTextMemberItemsRef = useRef([]);
  return useMemo(() => {
    const result = [];
    for (const member of members)
      if (member.kind === "item")
        if (!isBlockType(member.item.schemaType))
          result.push({
            kind: "objectBlock",
            member,
            node: member.item
          });
        else {
          (member.item.validation.length > 0 || member.item.changed || member.item.presence?.length || member.open || member.item.focusPath.length || member.item.focused) && result.push({
            kind: "textBlock",
            member,
            node: member.item
          });
          const childrenField = member.item.members.find((f) => f.kind === "field" && f.name === "children");
          if (childrenField && childrenField.kind === "field" && isMemberArrayOfObjects(childrenField))
            for (const child of childrenField.field.members)
              child.kind === "item" && child.item.schemaType.name !== "span" && result.push({
                kind: "inlineObject",
                member: child,
                node: child.item
              });
          const markDefArrayMember = member.item.members.filter(isArrayOfObjectsFieldMember).find((f_0) => f_0.name === "markDefs");
          if (markDefArrayMember)
            for (const child_0 of markDefArrayMember.field.members)
              child_0.kind === "item" && child_0.item.schemaType.jsonType === "object" && result.push({
                kind: "annotation",
                member: child_0,
                node: child_0.item
              });
        }
    const items = result.map((item) => {
      const key = pathToString$1(item.node.path), existingItem = portableTextMemberItemsRef.current.find((refItem) => refItem.key === key), isObject2 = item.kind !== "textBlock";
      let input = null;
      if (isObject2 && item.member !== existingItem?.member || item.node !== existingItem?.node) {
        const _elementProps = (renderInputProps) => ({
          ...renderInputProps.elementProps,
          onFocus: () => {
          }
        }), _onPathFocus = (focusPath) => {
          const fullPath = item.member.item.path.concat(focusPath);
          focusPath.length !== 0 && onPathFocus(fullPath.slice(path.length, fullPath.length));
        }, _onChangeDisableRemoveSelf = (objectFormRenderInputProps) => (patch2) => {
          if (patch2.type === "unset" && patch2.path.length === 0) {
            objectFormRenderInputProps.onChange(set({
              _type: item.member.item.schemaType.name,
              _key: item.member.key
            }, patch2.path));
            return;
          }
          objectFormRenderInputProps.onChange(patch2);
        }, _renderInput = (renderInputProps_0) => isEqual$3(renderInputProps_0.path, item.member.item.path) ? renderInput({
          ...renderInputProps_0,
          onChange: _onChangeDisableRemoveSelf(renderInputProps_0),
          onPathFocus: _onPathFocus,
          elementProps: _elementProps(renderInputProps_0)
        }) : renderInput(renderInputProps_0), inputProps = {
          absolutePath: pathFor(item.node.path),
          includeField: !1,
          members,
          path: pathFor(path),
          renderAnnotation,
          renderBlock: renderBlock2,
          renderField,
          renderInlineBlock,
          renderInput: _renderInput,
          renderItem: renderItem2,
          renderPreview,
          schemaType
        };
        input = /* @__PURE__ */ jsx(FormInput, { ...inputProps });
      }
      return existingItem ? (existingItem.member = item.member, existingItem.node = item.node, existingItem.input = input || existingItem.input, existingItem) : {
        kind: item.kind,
        key,
        member: item.member,
        node: item.node,
        input
      };
    });
    return portableTextMemberItemsRef.current = items, items;
  }, [members, onPathFocus, path, renderAnnotation, renderBlock2, renderField, renderInlineBlock, renderInput, renderItem2, renderPreview, schemaType]);
}
const Root$t = styled.span((props2) => {
  const {
    $toneKey = "default",
    theme
  } = props2;
  return css`
      text-decoration: none;
      display: inline;
      background-color: ${theme.sanity.color.selectable?.[$toneKey].enabled.bg};
      border-bottom: 1px dashed ${theme.sanity.color.selectable?.[$toneKey].enabled.fg};
      color: ${theme.sanity.color.selectable?.[$toneKey].enabled.fg};

      &[data-link] {
        border-bottom: 1px solid ${theme.sanity.color.selectable?.[$toneKey].enabled.fg};
      }

      &[data-custom-markers] {
        background-color: ${theme.sanity.color.dark ? hues.purple[950].hex : hues.purple[50].hex};
      }

      &[data-warning] {
        background-color: ${theme.sanity.color.muted.caution.hovered.bg};
      }

      &[data-error] {
        background-color: ${theme.sanity.color.muted.critical.hovered.bg};
      }
    `;
}), TooltipBox$3 = styled(Box).attrs({
  forwardedAs: "span"
})`
  max-width: 250px;
`, POPOVER_FALLBACK_PLACEMENTS$8 = ["top", "bottom"];
function AnnotationToolbarPopover(props2) {
  const $ = c(51), {
    annotationOpen,
    annotationTextSelected,
    floatingBoundary,
    onOpenAnnotation,
    onRemoveAnnotation,
    referenceBoundary,
    referenceElement,
    title
  } = props2, [popoverOpen, setPopoverOpen] = useState(!1), [cursorRect, setCursorRect] = useState(null), rangeRef = useRef(null), {
    sanity
  } = useTheme(), {
    t
  } = useTranslation(), editButtonRef = useRef(null), deleteButtonRef = useRef(null), focusTrappedRef = useRef(null), popoverScheme = sanity.color.dark ? "light" : "dark", editor2 = usePortableTextEditor();
  let t0;
  bb0: {
    if (!cursorRect) {
      t0 = null;
      break bb0;
    }
    let t110;
    $[0] !== cursorRect ? (t110 = {
      getBoundingClientRect: () => cursorRect
    }, $[0] = cursorRect, $[1] = t110) : t110 = $[1], t0 = t110;
  }
  const cursorElement = t0;
  let t1;
  $[2] !== editor2 ? (t1 = () => {
    PortableTextEditor.focus(editor2), setPopoverOpen(!1), focusTrappedRef.current = null;
  }, $[2] = editor2, $[3] = t1) : t1 = $[3];
  const handleClosePopover = t1;
  let t2;
  $[4] !== annotationTextSelected || $[5] !== editor2 || $[6] !== handleClosePopover || $[7] !== popoverOpen ? (t2 = (event) => {
    if (popoverOpen) {
      if (event.key === "Tab") {
        if (annotationTextSelected && event.target instanceof HTMLElement && event.target.contentEditable && focusTrappedRef.current === null) {
          event.preventDefault(), editButtonRef.current?.focus(), focusTrappedRef.current = editButtonRef.current;
          return;
        }
        if (event.target === deleteButtonRef.current) {
          event.preventDefault(), event.stopPropagation(), focusTrappedRef.current = null, PortableTextEditor.focus(editor2);
          return;
        }
      }
      event.key === "Escape" && handleClosePopover();
    }
  }, $[4] = annotationTextSelected, $[5] = editor2, $[6] = handleClosePopover, $[7] = popoverOpen, $[8] = t2) : t2 = $[8], useGlobalKeyDown(t2);
  let t3;
  $[9] !== annotationOpen || $[10] !== referenceElement ? (t3 = () => {
    if (annotationOpen) {
      setPopoverOpen(!1), setCursorRect(null);
      return;
    }
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0)
      return;
    focusTrappedRef.current = null;
    const range2 = sel.getRangeAt(0);
    if (!referenceElement?.contains(range2.commonAncestorContainer)) {
      setPopoverOpen(!1), setCursorRect(null);
      return;
    }
    const rect = range2?.getBoundingClientRect();
    rect && (setCursorRect(rect), setPopoverOpen(!0));
  }, $[9] = annotationOpen, $[10] = referenceElement, $[11] = t3) : t3 = $[11];
  const handleSelectionChange = t3;
  let t4, t5;
  $[12] !== handleSelectionChange ? (t4 = () => (document.addEventListener("selectionchange", handleSelectionChange, {
    passive: !0
  }), () => {
    document.removeEventListener("selectionchange", handleSelectionChange);
  }), t5 = [handleSelectionChange], $[12] = handleSelectionChange, $[13] = t4, $[14] = t5) : (t4 = $[13], t5 = $[14]), useEffect(t4, t5);
  let t6;
  $[15] !== onOpenAnnotation ? (t6 = () => {
    setPopoverOpen(!1), onOpenAnnotation();
  }, $[15] = onOpenAnnotation, $[16] = t6) : t6 = $[16];
  const handleEditButtonClicked = t6;
  let t7;
  $[17] !== onRemoveAnnotation ? (t7 = () => {
    setPopoverOpen(!1), onRemoveAnnotation();
  }, $[17] = onRemoveAnnotation, $[18] = t7) : t7 = $[18];
  const handleRemoveButtonClicked = t7;
  let t8;
  $[19] === Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    rangeRef.current && setCursorRect(rangeRef.current.getBoundingClientRect());
  }, $[19] = t8) : t8 = $[19];
  const handleScroll = t8;
  let t9;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
    const sel_0 = window.getSelection();
    sel_0 && sel_0.rangeCount > 0 && (rangeRef.current = sel_0.getRangeAt(0));
  }, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== popoverOpen ? (t10 = [popoverOpen], $[21] = popoverOpen, $[22] = t10) : t10 = $[22], useEffect(t9, t10);
  let t11, t12;
  $[23] !== floatingBoundary || $[24] !== popoverOpen || $[25] !== referenceBoundary ? (t11 = () => (popoverOpen && (floatingBoundary?.addEventListener("scroll", handleScroll), referenceBoundary?.addEventListener("scroll", handleScroll)), () => {
    floatingBoundary?.removeEventListener("scroll", handleScroll), referenceBoundary?.removeEventListener("scroll", handleScroll);
  }), t12 = [popoverOpen, referenceBoundary, floatingBoundary, handleScroll], $[23] = floatingBoundary, $[24] = popoverOpen, $[25] = referenceBoundary, $[26] = t11, $[27] = t12) : (t11 = $[26], t12 = $[27]), useEffect(t11, t12);
  let t13;
  $[28] !== title ? (t13 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: title }) }), $[28] = title, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== t ? (t14 = t("inputs.portable-text.action.edit-annotation-aria-label"), $[30] = t, $[31] = t14) : t14 = $[31];
  let t15;
  $[32] !== handleEditButtonClicked || $[33] !== t14 ? (t15 = /* @__PURE__ */ jsx(Button, { "aria-label": t14, "data-testid": "edit-annotation-button", icon: EditIcon, mode: "bleed", onClick: handleEditButtonClicked, ref: editButtonRef, tabIndex: 0, tooltipProps: null }), $[32] = handleEditButtonClicked, $[33] = t14, $[34] = t15) : t15 = $[34];
  let t16;
  $[35] !== t ? (t16 = t("inputs.portable-text.action.remove-annotation-aria-label"), $[35] = t, $[36] = t16) : t16 = $[36];
  let t17;
  $[37] !== handleRemoveButtonClicked || $[38] !== t16 ? (t17 = /* @__PURE__ */ jsx(Button, { "aria-label": t16, "data-testid": "remove-annotation-button", icon: TrashIcon, mode: "bleed", onClick: handleRemoveButtonClicked, ref: deleteButtonRef, tabIndex: 0, tone: "critical", tooltipProps: null }), $[37] = handleRemoveButtonClicked, $[38] = t16, $[39] = t17) : t17 = $[39];
  let t18;
  $[40] !== t13 || $[41] !== t15 || $[42] !== t17 ? (t18 = /* @__PURE__ */ jsx(Box, { padding: 1, "data-testid": "annotation-toolbar-popover", children: /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t13,
    t15,
    t17
  ] }) }), $[40] = t13, $[41] = t15, $[42] = t17, $[43] = t18) : t18 = $[43];
  let t19;
  return $[44] !== cursorElement || $[45] !== floatingBoundary || $[46] !== popoverOpen || $[47] !== popoverScheme || $[48] !== referenceBoundary || $[49] !== t18 ? (t19 = /* @__PURE__ */ jsx(Popover, { open: popoverOpen, floatingBoundary, constrainSize: !0, content: t18, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$8, placement: "top", portal: !0, preventOverflow: !0, referenceBoundary, referenceElement: cursorElement, scheme: popoverScheme }), $[44] = cursorElement, $[45] = floatingBoundary, $[46] = popoverOpen, $[47] = popoverScheme, $[48] = referenceBoundary, $[49] = t18, $[50] = t19) : t19 = $[50], t19;
}
function Annotation$1(props2) {
  const {
    children,
    editorNodeFocused,
    floatingBoundary,
    focused,
    onItemClose,
    onItemOpen,
    onPathFocus,
    path,
    readOnly,
    referenceBoundary,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderCustomMarkers,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    setElementRef,
    value
  } = props2, {
    Markers = DefaultMarkers
  } = useFormBuilder().__internal.components, editor2 = usePortableTextEditor(), markDefPath = useMemo(() => path.slice(0, path.length - 2).concat(["markDefs", {
    _key: value._key
  }]), [path, value._key]), [spanElement, setSpanElement] = useState(null), memberItem = usePortableTextMemberItem(pathToString$1(markDefPath)), {
    validation: validation2
  } = useMemberValidation(memberItem?.node), markers = usePortableTextMarkers(path), text = useMemo(() => /* @__PURE__ */ jsx("span", { "data-annotation": "", children }), [children]), onOpen = useCallback(() => {
    memberItem && (PortableTextEditor.blur(editor2), onItemOpen(memberItem.node.path));
  }, [editor2, memberItem, onItemOpen]), onClose = useCallback(() => {
    onItemClose(), isEmptyItem(value) && PortableTextEditor.removeAnnotation(editor2, schemaType), PortableTextEditor.focus(editor2);
  }, [editor2, onItemClose, schemaType, value]), onRemove = useCallback(() => {
    PortableTextEditor.removeAnnotation(editor2, schemaType), PortableTextEditor.focus(editor2);
  }, [editor2, schemaType]), markersToolTip = useMemo(() => validation2.length > 0 || markers.length > 0 ? /* @__PURE__ */ jsx(Tooltip, { placement: "bottom", portal: "default", content: /* @__PURE__ */ jsx(TooltipBox$3, { children: /* @__PURE__ */ jsx(Markers, { markers, renderCustomMarkers, validation: validation2 }) }), children: text }) : void 0, [Markers, markers, renderCustomMarkers, text, validation2]), presence = useChildPresence(path, !0), rootPresence = useMemo(() => presence.filter((p) => isEqual$3(p.path, path)), [path, presence]), isOpen = !!memberItem?.member.open, input = memberItem?.input, nodePath = memberItem?.node.path || EMPTY_ARRAY$A, referenceElement = spanElement, componentProps = useMemo(() => ({
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    __unstable_textElementFocus: editorNodeFocused,
    // Is there focus on the related text element for this object?
    children: input,
    focused,
    markers,
    onClose,
    onOpen,
    onPathFocus,
    onRemove,
    open: isOpen,
    parentSchemaType: editor2.schemaTypes.block,
    path: nodePath,
    presence: rootPresence,
    readOnly: !!readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderPreview,
    renderItem: renderItem2,
    renderDefault: DefaultAnnotationComponent,
    schemaType,
    selected,
    textElement: markersToolTip || text,
    validation: validation2,
    value
  }), [editor2.schemaTypes.block, editorNodeFocused, floatingBoundary, focused, input, isOpen, markers, markersToolTip, nodePath, onClose, onOpen, onPathFocus, onRemove, readOnly, referenceBoundary, referenceElement, renderAnnotation, renderBlock2, renderField, renderInlineBlock, renderInput, renderItem2, renderPreview, rootPresence, schemaType, selected, text, validation2, value]), CustomComponent = schemaType.components?.annotation, setRef = useCallback((elm) => {
    memberItem && setElementRef({
      key: memberItem.member.key,
      elementRef: elm
    }), setSpanElement(elm);
  }, [memberItem, setElementRef, setSpanElement]);
  return useMemo(() => /* @__PURE__ */ jsx("span", { ref: setRef, style: void 0, children: CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps }) : /* @__PURE__ */ jsx(DefaultAnnotationComponent, { ...componentProps }) }), [CustomComponent, componentProps, setRef]);
}
const DefaultAnnotationComponent = (props2) => {
  const $ = c(25), {
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    children,
    markers,
    onOpen,
    onRemove,
    open,
    readOnly,
    schemaType,
    selected,
    textElement,
    validation: validation2
  } = props2, isLink = schemaType.name === "link", hasError = validation2.some(_temp$1W), hasWarning = validation2.some(_temp2$H), hasMarkers = markers.length > 0, isReady = !!children, {
    t
  } = useTranslation();
  let t0;
  bb0: {
    if (hasError) {
      t0 = "critical";
      break bb0;
    }
    if (hasWarning) {
      t0 = "caution";
      break bb0;
    }
    if (isLink) {
      t0 = "primary";
      break bb0;
    }
    t0 = "default";
  }
  const toneKey = t0;
  let t1;
  $[0] !== t ? (t1 = t("inputs.portable-text.annotation-aria-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  const t2 = isLink ? "" : void 0, t3 = hasError ? "" : void 0, t4 = hasWarning ? "" : void 0, t5 = hasMarkers || void 0, t6 = readOnly ? onOpen : void 0;
  let t7;
  $[2] !== floatingBoundary || $[3] !== isReady || $[4] !== onOpen || $[5] !== onRemove || $[6] !== open || $[7] !== referenceBoundary || $[8] !== referenceElement || $[9] !== schemaType.i18nTitleKey || $[10] !== schemaType.name || $[11] !== schemaType.title || $[12] !== selected || $[13] !== t ? (t7 = isReady && /* @__PURE__ */ jsx(AnnotationToolbarPopover, { annotationOpen: open, floatingBoundary, onOpenAnnotation: onOpen, onRemoveAnnotation: onRemove, referenceBoundary, referenceElement, annotationTextSelected: selected, title: schemaType.i18nTitleKey ? t(schemaType.i18nTitleKey) : schemaType.title || schemaType.name }), $[2] = floatingBoundary, $[3] = isReady, $[4] = onOpen, $[5] = onRemove, $[6] = open, $[7] = referenceBoundary, $[8] = referenceElement, $[9] = schemaType.i18nTitleKey, $[10] = schemaType.name, $[11] = schemaType.title, $[12] = selected, $[13] = t, $[14] = t7) : t7 = $[14];
  let t8;
  return $[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== textElement || $[23] !== toneKey ? (t8 = /* @__PURE__ */ jsxs(Root$t, { $toneKey: toneKey, "aria-label": t1, "data-link": t2, "data-error": t3, "data-warning": t4, "data-markers": t5, onClick: t6, children: [
    textElement,
    t7
  ] }), $[15] = t1, $[16] = t2, $[17] = t3, $[18] = t4, $[19] = t5, $[20] = t6, $[21] = t7, $[22] = textElement, $[23] = toneKey, $[24] = t8) : t8 = $[24], t8;
};
function _temp$1W(v) {
  return v.level === "error";
}
function _temp2$H(v_0) {
  return v_0.level === "warning";
}
function useReferenceInputOptions() {
  return useContext(ReferenceInputOptionsContext);
}
function ReferenceInputOptionsProvider(props2) {
  const $ = c(9), {
    children,
    activePath,
    EditReferenceLinkComponent,
    onEditReference,
    initialValueTemplateItems,
    disableNew
  } = props2;
  let t0, t1;
  $[0] !== EditReferenceLinkComponent || $[1] !== activePath || $[2] !== disableNew || $[3] !== initialValueTemplateItems || $[4] !== onEditReference ? (t1 = {
    activePath,
    EditReferenceLinkComponent,
    onEditReference,
    initialValueTemplateItems,
    disableNew
  }, $[0] = EditReferenceLinkComponent, $[1] = activePath, $[2] = disableNew, $[3] = initialValueTemplateItems, $[4] = onEditReference, $[5] = t1) : t1 = $[5], t0 = t1;
  const contextValue = t0;
  let t2;
  return $[6] !== children || $[7] !== contextValue ? (t2 = /* @__PURE__ */ jsx(ReferenceInputOptionsContext.Provider, { value: contextValue, children }), $[6] = children, $[7] = contextValue, $[8] = t2) : t2 = $[8], t2;
}
function useReviewChanges() {
  const reviewChanges = useContext(ReviewChangesContext);
  if (!reviewChanges)
    throw new Error("Review changes: missing context value");
  return reviewChanges;
}
function DocumentIdProvider(props2) {
  const $ = c(5);
  let t0, t1;
  $[0] !== props2.id ? (t1 = {
    id: props2.id
  }, $[0] = props2.id, $[1] = t1) : t1 = $[1], t0 = t1;
  const value = t0;
  let t2;
  return $[2] !== props2.children || $[3] !== value ? (t2 = /* @__PURE__ */ jsx(DocumentIdContext.Provider, { value, children: props2.children }), $[2] = props2.children, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
function useGivenDocumentId() {
  const ctx = useContext(DocumentIdContext);
  if (!ctx)
    throw new Error("useDocumentId must be used within a DocumentIdProvider");
  return ctx.id;
}
function usePublishedId$1() {
  const $ = c(2), t0 = useGivenDocumentId();
  let t1;
  return $[0] !== t0 ? (t1 = getPublishedId(t0), $[0] = t0, $[1] = t1) : t1 = $[1], t1;
}
function useScrollIntoViewOnFocusWithin(elementRef, hasFocusWithin) {
  return useDidUpdate(hasFocusWithin, useCallback((hadFocus, hasFocus) => {
    elementRef.current && !hadFocus && hasFocus && scrollIntoView$1(elementRef.current, {
      scrollMode: "always"
    });
  }, [elementRef]));
}
function ReferencePreview$1(props2) {
  const {
    id: id2,
    layout,
    refType,
    renderPreview,
    showTypeLabel
  } = props2, documentPresence = useDocumentPresence(id2), versionsInfo = useDocumentVersionInfo(id2), previewStub = useMemo(() => ({
    _id: id2,
    _type: refType.name
  }), [id2, refType.name]), previewProps = useMemo(() => ({
    children: /* @__PURE__ */ jsx(Box, { paddingLeft: 3, children: /* @__PURE__ */ jsxs(Inline, { space: 3, children: [
      showTypeLabel && /* @__PURE__ */ jsx(Badge, { mode: "outline", children: refType.title }),
      documentPresence && documentPresence.length > 0 && /* @__PURE__ */ jsx(DocumentPreviewPresence, { presence: documentPresence }),
      /* @__PURE__ */ jsx(DocumentStatusIndicator, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions })
    ] }) }),
    layout,
    schemaType: refType,
    tooltip: /* @__PURE__ */ jsx(DocumentStatus, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions }),
    value: previewStub
  }), [documentPresence, layout, previewStub, refType, showTypeLabel, versionsInfo.draft, versionsInfo.published, versionsInfo.versions]);
  return renderPreview(previewProps);
}
function PreviewReferenceValue$2(props2) {
  const $ = c(66), {
    layout: t0,
    referenceInfo,
    renderPreview,
    type,
    value,
    showTypeLabel
  } = props2, layout = t0 === void 0 ? "default" : t0, {
    t
  } = useTranslation();
  if (referenceInfo.isLoading || referenceInfo.error) {
    let t12;
    return $[0] !== layout ? (t12 = /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0, layout }), $[0] = layout, $[1] = t12) : t12 = $[1], t12;
  }
  if (referenceInfo.result?.availability.reason === "NOT_FOUND" && value._strengthenOnPublish) {
    const t12 = type.to;
    let T0, T1, refType, t22, t3, t4, t5;
    if ($[2] !== layout || $[3] !== renderPreview || $[4] !== type.to || $[5] !== value) {
      t5 = Symbol.for("react.early_return_sentinel");
      bb0: {
        let t62;
        if ($[13] !== value._strengthenOnPublish?.type ? (t62 = (toType) => toType.name === value?._strengthenOnPublish?.type, $[13] = value._strengthenOnPublish?.type, $[14] = t62) : t62 = $[14], refType = t12.find(t62), !refType) {
          const t73 = value._ref, t82 = value._strengthenOnPublish?.type;
          let t92;
          $[15] !== type.to ? (t92 = type.to.map(_temp$1V), $[15] = type.to, $[16] = t92) : t92 = $[16];
          let t10;
          $[17] !== t82 || $[18] !== t92 || $[19] !== value._ref ? (t10 = /* @__PURE__ */ jsx(InvalidType, { documentId: t73, actualType: t82, declaredTypes: t92 }), $[17] = t82, $[18] = t92, $[19] = value._ref, $[20] = t10) : t10 = $[20], t5 = t10;
          break bb0;
        }
        let t72;
        $[21] !== value ? (t72 = value._strengthenOnPublish?.type ? {
          _id: value._ref,
          _type: value._strengthenOnPublish?.type
        } : value, $[21] = value, $[22] = t72) : t72 = $[22];
        const stub = t72;
        T1 = Flex, t4 = "center", T0 = Box, t22 = 1, t3 = renderPreview({
          layout,
          schemaType: refType,
          value: stub,
          skipVisibilityCheck: !0
        });
      }
      $[2] = layout, $[3] = renderPreview, $[4] = type.to, $[5] = value, $[6] = T0, $[7] = T1, $[8] = refType, $[9] = t22, $[10] = t3, $[11] = t4, $[12] = t5;
    } else
      T0 = $[6], T1 = $[7], refType = $[8], t22 = $[9], t3 = $[10], t4 = $[11], t5 = $[12];
    if (t5 !== Symbol.for("react.early_return_sentinel"))
      return t5;
    let t6;
    $[23] !== T0 || $[24] !== t22 || $[25] !== t3 ? (t6 = /* @__PURE__ */ jsx(T0, { flex: t22, children: t3 }), $[23] = T0, $[24] = t22, $[25] = t3, $[26] = t6) : t6 = $[26];
    let t7;
    $[27] !== refType || $[28] !== showTypeLabel ? (t7 = showTypeLabel && /* @__PURE__ */ jsx(Badge, { mode: "outline", children: refType.title }), $[27] = refType, $[28] = showTypeLabel, $[29] = t7) : t7 = $[29];
    let t8;
    $[30] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Inline, { space: 4, children: t7 }) }), $[30] = t7, $[31] = t8) : t8 = $[31];
    let t9;
    return $[32] !== T1 || $[33] !== t4 || $[34] !== t6 || $[35] !== t8 ? (t9 = /* @__PURE__ */ jsxs(T1, { align: t4, children: [
      t6,
      t8
    ] }), $[32] = T1, $[33] = t4, $[34] = t6, $[35] = t8, $[36] = t9) : t9 = $[36], t9;
  }
  const availability = referenceInfo.result.availability, notFound = availability.reason === "NOT_FOUND", insufficientPermissions = availability.reason === "PERMISSION_DENIED";
  if (insufficientPermissions || notFound) {
    let t12;
    $[37] !== t ? (t12 = t("inputs.reference.error.document-unavailable-title"), $[37] = t, $[38] = t12) : t12 = $[38];
    let t22;
    $[39] !== t12 ? (t22 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: t12 }) }) }) }), $[39] = t12, $[40] = t22) : t22 = $[40];
    let t3;
    $[41] !== insufficientPermissions || $[42] !== notFound || $[43] !== t || $[44] !== value ? (t3 = insufficientPermissions || notFound ? /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: notFound ? /* @__PURE__ */ jsx(UnavailableMessage, { title: t("inputs.reference.error.nonexistent-document-title"), icon: HelpCircleIcon, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "inputs.reference.error.nonexistent-document-description", t, values: {
      documentId: value._ref
    } }) }) : /* @__PURE__ */ jsx(UnavailableMessage, { title: t("inputs.reference.error.missing-read-permissions-title"), icon: AccessDeniedIcon, children: t("inputs.reference.error.missing-read-permissions-description") }), children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", children: /* @__PURE__ */ jsx(HelpCircleIcon, {}) }) }) }) : null, $[41] = insufficientPermissions, $[42] = notFound, $[43] = t, $[44] = value, $[45] = t3) : t3 = $[45];
    let t4;
    return $[46] !== t22 || $[47] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      t22,
      t3
    ] }), $[46] = t22, $[47] = t3, $[48] = t4) : t4 = $[48], t4;
  }
  const refTypeName = referenceInfo.result?.type;
  let t1;
  if ($[49] !== refTypeName || $[50] !== type.to) {
    let t22;
    $[52] !== refTypeName ? (t22 = (toType_1) => toType_1.name === refTypeName, $[52] = refTypeName, $[53] = t22) : t22 = $[53], t1 = type.to.find(t22), $[49] = refTypeName, $[50] = type.to, $[51] = t1;
  } else
    t1 = $[51];
  const refType_0 = t1;
  if (!refType_0) {
    const t22 = value._ref, t3 = refTypeName || "<unknown>";
    let t4;
    $[54] !== type.to ? (t4 = type.to.map(_temp2$G), $[54] = type.to, $[55] = t4) : t4 = $[55];
    let t5;
    return $[56] !== t3 || $[57] !== t4 || $[58] !== value._ref ? (t5 = /* @__PURE__ */ jsx(InvalidType, { documentId: t22, actualType: t3, declaredTypes: t4 }), $[56] = t3, $[57] = t4, $[58] = value._ref, $[59] = t5) : t5 = $[59], t5;
  }
  let t2;
  return $[60] !== layout || $[61] !== refType_0 || $[62] !== renderPreview || $[63] !== showTypeLabel || $[64] !== value._ref ? (t2 = /* @__PURE__ */ jsx(ReferencePreview$1, { id: value._ref, layout, refType: refType_0, renderPreview, showTypeLabel }), $[60] = layout, $[61] = refType_0, $[62] = renderPreview, $[63] = showTypeLabel, $[64] = value._ref, $[65] = t2) : t2 = $[65], t2;
}
function _temp2$G(toType_2) {
  return toType_2.name;
}
function _temp$1V(toType_0) {
  return toType_0.name;
}
function UnavailableMessage(props2) {
  const $ = c(12), Icon2 = props2.icon;
  let t0;
  $[0] !== Icon2 ? (t0 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Icon2, {}) }), $[0] = Icon2, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== props2.title ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: props2.title }), $[2] = props2.title, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== props2.children ? (t2 = /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: props2.children }) }), $[4] = props2.children, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t1 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Box, { flex: 1, marginLeft: 3, children: [
    t1,
    t2
  ] }), $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== t0 || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    t3
  ] }), $[9] = t0, $[10] = t3, $[11] = t4) : t4 = $[11], t4;
}
function InvalidType(t0) {
  const $ = c(19), {
    declaredTypes,
    documentId,
    actualType
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("inputs.reference.error.invalid-type-title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: t1 }) }) }) }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== actualType || $[5] !== documentId ? (t3 = {
    documentId,
    actualType
  }, $[4] = actualType, $[5] = documentId, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== declaredTypes ? (t4 = {
    AllowedTypes: () => /* @__PURE__ */ jsx(HumanizedList, { values: declaredTypes })
  }, $[7] = declaredTypes, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t || $[10] !== t3 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.error.invalid-type-description", values: t3, components: t4 }) }) }), $[9] = t, $[10] = t3, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", children: /* @__PURE__ */ jsx(HelpCircleIcon, {}) }) }), $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t5 ? (t7 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t5, children: t6 }) }), $[14] = t5, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== t2 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "flex-start", children: [
    t2,
    t7
  ] }), $[16] = t2, $[17] = t7, $[18] = t8) : t8 = $[18], t8;
}
function HumanizedList(props2) {
  const $ = c(8);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    type: "disjunction"
  }, $[0] = t0) : t0 = $[0];
  const listFormat = useListFormat(t0);
  let T0, t1;
  if ($[1] !== listFormat || $[2] !== props2.values) {
    const parts = listFormat.formatToParts(props2.values);
    T0 = Fragment$1, t1 = parts.map(_temp3$c), $[1] = listFormat, $[2] = props2.values, $[3] = T0, $[4] = t1;
  } else
    T0 = $[3], t1 = $[4];
  let t2;
  return $[5] !== T0 || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(T0, { children: t1 }), $[5] = T0, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
function _temp3$c(segment) {
  return segment.type === "element" ? /* @__PURE__ */ jsx("code", { children: segment.value }, segment.value) : segment.value;
}
const STATUS_TONES = {
  warning: "caution",
  error: "critical",
  info: "positive"
}, STATUS_ICONS = {
  warning: /* @__PURE__ */ jsx(WarningOutlineIcon, {}),
  error: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}),
  info: /* @__PURE__ */ jsx(InfoOutlineIcon, {})
};
function AlertStrip(props2) {
  const $ = c(15);
  let children, rest, t0, title;
  $[0] !== props2 ? ({
    children,
    status: t0,
    title,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = rest, $[3] = t0, $[4] = title) : (children = $[1], rest = $[2], t0 = $[3], title = $[4]);
  const status = t0 === void 0 ? "warning" : t0, t1 = STATUS_TONES[status];
  let t2;
  $[5] !== children || $[6] !== status || $[7] !== title ? (t2 = children && /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Details, { icon: STATUS_ICONS[status], title, children: /* @__PURE__ */ jsx(Box, { marginLeft: 3, marginTop: 3, children }) }) }), $[5] = children, $[6] = status, $[7] = title, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(Flex, { padding: 1, children: t2 }), $[9] = t2, $[10] = t3) : t3 = $[10];
  let t4;
  return $[11] !== rest || $[12] !== t1 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(Card, { radius: 2, tone: t1, ...rest, "data-ui": "Alert", children: t3 }), $[11] = rest, $[12] = t1, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
}
function ReferenceFinalizeAlertStrip(t0) {
  const $ = c(17), {
    schemaType,
    handleRemoveStrengthenOnPublish
  } = t0, {
    t
  } = useTranslation(), t1 = schemaType.weak ? "inputs.reference.incomplete-reference.finalize-action-title" : "inputs.reference.incomplete-reference.strengthen-action-title";
  let t2;
  $[0] !== t || $[1] !== t1 ? (t2 = t(t1), $[0] = t, $[1] = t1, $[2] = t2) : t2 = $[2];
  const t3 = schemaType.weak ? "inputs.reference.incomplete-reference.finalize-action-description" : "inputs.reference.incomplete-reference.strengthen-action-description";
  let t4;
  $[3] !== t || $[4] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t3 }) }), $[3] = t, $[4] = t3, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t ? (t5 = t("inputs.reference.incomplete-reference.strengthen-button-label"), $[6] = t, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== handleRemoveStrengthenOnPublish || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleRemoveStrengthenOnPublish, size: "large", text: t5, tone: "positive" }), $[8] = handleRemoveStrengthenOnPublish, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t4 || $[12] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t4,
    t6
  ] }), $[11] = t4, $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  return $[14] !== t2 || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(AlertStrip, { padding: 1, title: t2, status: "info", "data-testid": "alert-reference-published", children: t7 }), $[14] = t2, $[15] = t7, $[16] = t8) : t8 = $[16], t8;
}
const StyledCard$4 = styled(Card)`
  /* this is a hack to avoid layout jumps while previews are loading
     there's probably better ways of solving this */
  min-height: 33px;
  position: relative;

  /* TextWithTone uses its own logic to set color, and we therefore need */
  /* to override this logic in order to set the correct color in different states */
  &[data-selected],
  &[data-pressed],
  &:active {
    [data-ui='TextWithTone'] {
      color: inherit;
    }
  }
`, ReferenceLinkCard = forwardRef(function(props2, ref) {
  const $ = c(13);
  let as, cardProps, documentId, documentType;
  $[0] !== props2 ? ({
    as,
    documentId,
    documentType,
    ...cardProps
  } = props2, $[0] = props2, $[1] = as, $[2] = cardProps, $[3] = documentId, $[4] = documentType) : (as = $[1], cardProps = $[2], documentId = $[3], documentType = $[4]);
  let t0;
  $[5] !== as || $[6] !== documentId || $[7] !== documentType ? (t0 = documentId && documentType && {
    "data-as": "a",
    forwardedAs: as,
    documentId,
    documentType
  }, $[5] = as, $[6] = documentId, $[7] = documentType, $[8] = t0) : t0 = $[8];
  const linkProps = t0, t1 = ref;
  let t2;
  return $[9] !== cardProps || $[10] !== linkProps || $[11] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledCard$4, { ...cardProps, ...linkProps, "data-ui": "ReferenceLinkCard", ref: t1 }), $[9] = cardProps, $[10] = linkProps, $[11] = t1, $[12] = t2) : t2 = $[12], t2;
});
function ReferenceMetadataLoadErrorAlertStrip(t0) {
  const $ = c(15), {
    errorMessage,
    onHandleRetry
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("inputs.reference.metadata-error.title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== errorMessage ? (t2 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: errorMessage }), $[2] = errorMessage, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t ? (t3 = t("inputs.reference.metadata-error.retry-button-label"), $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== onHandleRetry || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: onHandleRetry, size: "large", text: t3, tone: "primary" }), $[6] = onHandleRetry, $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t2 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t2,
    t4
  ] }), $[9] = t2, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== t1 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(AlertStrip, { padding: 1, title: t1, status: "warning", "data-testid": "alert-reference-info-failed", children: t5 }), $[12] = t1, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
}
function ReferenceStrengthMismatchAlertStrip(t0) {
  const $ = c(23), {
    actualStrength,
    handleFixStrengthMismatch
  } = t0, shouldBe = actualStrength === "weak" ? "strong" : "weak", {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("inputs.reference.strength-mismatch.title"), $[0] = t, $[1] = t1) : t1 = $[1];
  const t2 = actualStrength === "weak" ? "inputs.reference.strength-mismatch.is-weak-description" : "inputs.reference.strength-mismatch.is-strong-description";
  let t3;
  $[2] !== t || $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t2 }) }), $[2] = t, $[3] = t2, $[4] = t3) : t3 = $[4];
  const t4 = shouldBe === "weak" ? "inputs.reference.strength-mismatch.is-strong-consquences" : "inputs.reference.strength-mismatch.is-weak-consquences";
  let t5;
  $[5] !== t || $[6] !== t4 ? (t5 = t(t4), $[5] = t, $[6] = t4, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t5 }), $[8] = t5, $[9] = t6) : t6 = $[9];
  const t7 = shouldBe === "weak" ? "inputs.reference.strength-mismatch.weaken-button-label" : "inputs.reference.strength-mismatch.strengthen-button-label";
  let t8;
  $[10] !== t || $[11] !== t7 ? (t8 = t(t7), $[10] = t, $[11] = t7, $[12] = t8) : t8 = $[12];
  let t9;
  $[13] !== handleFixStrengthMismatch || $[14] !== t8 ? (t9 = /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleFixStrengthMismatch, size: "large", text: t8, tone: "caution" }), $[13] = handleFixStrengthMismatch, $[14] = t8, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== t3 || $[17] !== t6 || $[18] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t3,
    t6,
    t9
  ] }), $[16] = t3, $[17] = t6, $[18] = t9, $[19] = t10) : t10 = $[19];
  let t11;
  return $[20] !== t1 || $[21] !== t10 ? (t11 = /* @__PURE__ */ jsx(AlertStrip, { padding: 1, title: t1, status: "warning", "data-testid": "alert-reference-strength-mismatch", children: t10 }), $[20] = t1, $[21] = t10, $[22] = t11) : t11 = $[22], t11;
}
const noop$4 = () => {
}, INITIAL_LOADING_STATE$2 = {
  isLoading: !0,
  result: void 0,
  error: void 0,
  retry: noop$4
}, EMPTY_STATE$2 = {
  isLoading: !1,
  result: void 0,
  error: void 0,
  retry: noop$4
};
function useReferenceInfo$2(id2, getReferenceInfo2) {
  const $ = c(10), [t0] = useState(_temp$1U), [onRetry$2, onRetry2] = t0;
  let t1, t2;
  if ($[0] !== getReferenceInfo2 || $[1] !== id2 || $[2] !== onRetry2 || $[3] !== onRetry$2) {
    let t3;
    $[5] !== id2 ? (t3 = () => id2, $[5] = id2, $[6] = t3) : t3 = $[6];
    let t4;
    $[7] !== getReferenceInfo2 || $[8] !== onRetry2 ? (t4 = (refId) => refId ? getReferenceInfo2(refId).pipe(map((result) => ({
      isLoading: !1,
      result,
      error: void 0,
      retry: onRetry2
    })), startWith(INITIAL_LOADING_STATE$2), catchError((err) => (console.error(err), of({
      isLoading: !1,
      result: void 0,
      error: err,
      retry: onRetry2
    })))) : of(EMPTY_STATE$2), $[7] = getReferenceInfo2, $[8] = onRetry2, $[9] = t4) : t4 = $[9], t2 = concat(of(null), onRetry$2).pipe(map(t3), concatMap$1(t4)), $[0] = getReferenceInfo2, $[1] = id2, $[2] = onRetry2, $[3] = onRetry$2, $[4] = t2;
  } else
    t2 = $[4];
  return t1 = t2, useObservable(t1, INITIAL_LOADING_STATE$2);
}
function _temp$1U() {
  return observableCallback();
}
function FormValueProvider(props2) {
  const $ = c(5);
  let t0, t1;
  $[0] !== props2.value ? (t1 = {
    value: props2.value
  }, $[0] = props2.value, $[1] = t1) : t1 = $[1], t0 = t1;
  const value = t0;
  let t2;
  return $[2] !== props2.children || $[3] !== value ? (t2 = /* @__PURE__ */ jsx(FormValueContext.Provider, { value, children: props2.children }), $[2] = props2.children, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
function useFormValue(path) {
  const uniquePath = pathFor(path), ctx = useContext(FormValueContext);
  if (!ctx)
    throw new Error("useFormValue must be used within a FormValueProvider");
  return getValueAtPath(ctx?.value, uniquePath);
}
const READABLE = {
  available: !0,
  reason: "READABLE"
}, PERMISSION_DENIED = {
  available: !1,
  reason: "PERMISSION_DENIED"
}, NOT_FOUND = {
  available: !1,
  reason: "NOT_FOUND"
};
function getReferenceInfo(documentPreviewStore, id2, referenceType, {
  version,
  perspective
} = {}) {
  const {
    publishedId,
    draftId,
    versionId
  } = getIdPair(id2, {
    version
  });
  return documentPreviewStore.unstable_observeDocumentPairAvailability(id2, {
    version
  }).pipe(switchMap((pairAvailability) => {
    if (!pairAvailability.draft.available && !pairAvailability.published.available && !pairAvailability.version?.available) {
      const availability = pairAvailability.version?.reason === "PERMISSION_DENIED" || pairAvailability.draft.reason === "PERMISSION_DENIED" || pairAvailability.published.reason === "PERMISSION_DENIED" ? PERMISSION_DENIED : NOT_FOUND;
      return of({
        id: id2,
        type: void 0,
        availability,
        isPublished: null,
        preview: {
          snapshot: null,
          original: null
        }
      });
    }
    return combineLatest([documentPreviewStore.observeDocumentTypeFromId(draftId), documentPreviewStore.observeDocumentTypeFromId(publishedId), ...versionId ? [documentPreviewStore.observeDocumentTypeFromId(versionId)] : []]).pipe(
      // assume draft + published + version are always same type
      map(([draftTypeName, publishedTypeName, versionTypeName]) => versionTypeName || draftTypeName || publishedTypeName)
    ).pipe(switchMap((typeName) => {
      if (!typeName)
        return of({
          id: id2,
          type: void 0,
          availability: {
            available: !0,
            reason: "READABLE"
          },
          isPublished: null,
          preview: {
            snapshot: null,
            original: null
          }
        });
      const refSchemaType = referenceType.to.find((memberType) => memberType.name === typeName);
      if (!refSchemaType)
        return of({
          id: id2,
          type: typeName,
          availability: {
            available: !0,
            reason: "READABLE"
          },
          isPublished: null,
          preview: {
            snapshot: null,
            original: null
          }
        });
      const publishedDocumentExists$ = documentPreviewStore.observePaths({
        _id: publishedId
      }, ["_rev"]).pipe(map((res) => !!res?._rev)), previewState$ = getPreviewStateObservable$1(documentPreviewStore, refSchemaType, publishedId, perspective);
      return combineLatest([previewState$, publishedDocumentExists$]).pipe(map(([previewState, publishedDocumentExists]) => {
        const availability = (
          // eslint-disable-next-line no-nested-ternary
          pairAvailability.version?.available || pairAvailability.draft.available || pairAvailability.published.available ? READABLE : pairAvailability.version?.reason === "PERMISSION_DENIED" || pairAvailability.draft.reason === "PERMISSION_DENIED" || pairAvailability.published.reason === "PERMISSION_DENIED" ? PERMISSION_DENIED : NOT_FOUND
        );
        return {
          type: typeName,
          id: publishedId,
          availability,
          isPublished: publishedDocumentExists,
          preview: {
            snapshot: previewState.snapshot,
            original: previewState.original
          }
        };
      }));
    }));
  }));
}
function getCounterpartIds(collatedHits) {
  return collatedHits.filter((collatedHit) => (
    // we're interested in hits where either draft or published is missing
    !collatedHit.draft || !collatedHit.published
  )).map((collatedHit) => (
    // if we have the draft, return the published id or vice versa
    collatedHit.draft ? collatedHit.id : getDraftId(collatedHit.id)
  ));
}
function getExistingCounterparts(client, ids) {
  return ids.length === 0 ? of([]) : client.observable.fetch("*[_id in $ids]._id", {
    ids
  }, {
    tag: "get-counterpart-ids"
  });
}
function referenceSearch(client, textTerm, type, options) {
  return createSearch(type.to, client, {
    ...options,
    maxDepth: options.maxFieldDepth || DEFAULT_MAX_FIELD_DEPTH
  })(textTerm, {
    includeDrafts: !0
  }).pipe(
    map(({
      hits
    }) => hits.map(({
      hit
    }) => hit)),
    map((docs) => docs.map((doc) => ({
      ...doc,
      // Pass the original id if available, it could be a `draftId` or a `versionId` , the _id will be the published one when using perspectives to query the data.
      _id: doc._originalId || doc._id
    }))),
    map((docs) => collate(docs)),
    // pick the 100 best matches
    map((collated) => collated.slice(0, 100)),
    mergeMap((collated) => getExistingCounterparts(client, getCounterpartIds(collated)).pipe(map((existingCounterpartIds) => collated.map((entry) => {
      const draftId = getDraftId(entry.id);
      return {
        id: entry.id,
        type: entry.type,
        draft: entry.draft || existingCounterpartIds.includes(draftId) ? {
          _id: draftId,
          _type: entry.type
        } : void 0,
        published: entry.published || existingCounterpartIds.includes(entry.id) ? {
          _id: entry.id,
          _type: entry.type
        } : void 0
      };
    }))))
  );
}
function useValueRef$3(value) {
  const $ = c(3), ref = useRef(value);
  let t0, t1;
  return $[0] !== value ? (t0 = () => {
    ref.current = value;
  }, t1 = [value], $[0] = value, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), ref;
}
function useReferenceInput(options) {
  const {
    path,
    schemaType,
    version
  } = options, schema2 = useSchema(), perspective = usePerspective(), documentPreviewStore = useDocumentPreviewStore(), {
    EditReferenceLinkComponent,
    onEditReference,
    activePath,
    initialValueTemplateItems,
    ...inheritedOptions
  } = useReferenceInputOptions(), documentValue = useFormValue([]), documentTypeName = useValueRef$3(documentValue).current?._type, isCurrentDocumentLiveEdit = useMemo(() => schema2.get(documentTypeName)?.liveEdit, [documentTypeName, schema2]), disableNew = inheritedOptions.disableNew ?? schemaType.options?.disableNew === !0, template2 = options.value?._strengthenOnPublish?.template, EditReferenceLink = useMemo(() => forwardRef(function(_props, forwardedRef) {
    return EditReferenceLinkComponent ? /* @__PURE__ */ jsx(EditReferenceLinkComponent, { ..._props, ref: forwardedRef, parentRefPath: path, template: template2 }) : null;
  }), [EditReferenceLinkComponent, path, template2]), handleEditReference = useCallback((event) => {
    onEditReference?.({
      parentRefPath: path,
      id: event.id,
      type: event.type,
      template: event.template
    });
  }, [onEditReference, path]), selectedState = PathUtils.startsWith(path, activePath?.path || []) ? activePath?.state : "none", createOptions = useMemo(() => disableNew ? [] : (initialValueTemplateItems || []).filter((i) => schemaType.to.some((refType) => refType.name === i.template?.schemaType)).map((item) => item.template?.schemaType ? {
    id: item.id,
    title: item.title || `${item.template.schemaType} from template ${item.template.id}`,
    type: item.template.schemaType,
    icon: item.icon,
    template: {
      id: item.template.id,
      params: item.parameters
    },
    permission: {
      granted: item.granted,
      reason: item.reason
    }
  } : void 0).filter(isNonNullable$3), [disableNew, initialValueTemplateItems, schemaType.to]), getReferenceInfo$1 = useCallback((id2) => getReferenceInfo(documentPreviewStore, id2, schemaType, {
    version,
    perspective: perspective.perspectiveStack
  }), [documentPreviewStore, schemaType, version, perspective.perspectiveStack]);
  return {
    selectedState,
    isCurrentDocumentLiveEdit,
    handleEditReference,
    EditReferenceLink,
    createOptions,
    getReferenceInfo: getReferenceInfo$1
  };
}
function getTone$3({
  readOnly,
  hasErrors,
  hasWarnings
}) {
  return readOnly ? "transparent" : hasErrors ? "critical" : hasWarnings ? "caution" : "default";
}
const MENU_POPOVER_PROPS$9 = {
  portal: !0,
  tone: "default"
};
function ReferenceField(props2) {
  const $ = c(91), elementRef = useRef(null), {
    schemaType,
    path,
    open,
    inputId,
    children,
    inputProps
  } = props2, {
    readOnly,
    focused,
    renderPreview,
    onChange
  } = props2.inputProps, {
    selectedReleaseId
  } = usePerspective();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [fieldActionsNodes, setFieldActionNodes] = useState(t0), documentId = usePublishedId$1();
  let t1;
  $[1] !== inputProps ? (t1 = () => inputProps.onChange(unset()), $[1] = inputProps, $[2] = t1) : t1 = $[2];
  const handleClear = t1, value = props2.value;
  let t2;
  $[3] !== path || $[4] !== schemaType || $[5] !== selectedReleaseId || $[6] !== value ? (t2 = {
    path,
    schemaType,
    value,
    version: selectedReleaseId
  }, $[3] = path, $[4] = schemaType, $[5] = selectedReleaseId, $[6] = value, $[7] = t2) : t2 = $[7];
  const {
    EditReferenceLink,
    getReferenceInfo: getReferenceInfo2,
    selectedState,
    isCurrentDocumentLiveEdit
  } = useReferenceInput(t2);
  useScrollIntoViewOnFocusWithin(elementRef, open);
  let t3;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && elementRef.current && elementRef.current.focus();
  }, $[8] = t3) : t3 = $[8], useDidUpdate(focused, t3);
  const hasErrors = props2.validation.some(_temp$1T), hasWarnings = props2.validation.some(_temp2$F), loadableReferenceInfo = useReferenceInfo$2(value?._ref, getReferenceInfo2), refTypeName = loadableReferenceInfo.result?.type || value?._strengthenOnPublish?.type;
  let t4;
  $[9] !== refTypeName || $[10] !== schemaType.to ? (t4 = refTypeName ? schemaType.to.find((toType) => toType.name === refTypeName) : void 0, $[9] = refTypeName, $[10] = schemaType.to, $[11] = t4) : t4 = $[11];
  const refType = t4, pressed = selectedState === "pressed", selected = selectedState === "selected", hasRef = value?._ref, publishedReferenceExists = hasRef && loadableReferenceInfo.result?.isPublished;
  let t5;
  $[12] !== onChange || $[13] !== schemaType.weak ? (t5 = () => {
    onChange([schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]), unset(["_strengthenOnPublish"])]);
  }, $[12] = onChange, $[13] = schemaType.weak, $[14] = t5) : t5 = $[14];
  const handleRemoveStrengthenOnPublish = t5;
  let t6;
  $[15] !== onChange || $[16] !== schemaType.weak ? (t6 = () => {
    onChange(schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]));
  }, $[15] = onChange, $[16] = schemaType.weak, $[17] = t6) : t6 = $[17];
  const handleFixStrengthMismatch = t6;
  let t7;
  $[18] !== inputProps ? (t7 = () => {
    inputProps.onPathFocus(["_ref"]);
  }, $[18] = inputProps, $[19] = t7) : t7 = $[19];
  const handleReplace = t7, actualStrength = value?._weak ? "weak" : "strong", weakShouldBe = schemaType.weak === !0 ? "weak" : "strong", weakWarningOverride = hasRef && !loadableReferenceInfo.isLoading && value?._strengthenOnPublish, showWeakRefMismatch = !loadableReferenceInfo.isLoading && loadableReferenceInfo.result?.availability.available && hasRef && actualStrength !== weakShouldBe && !weakWarningOverride, tone = getTone$3({
    readOnly,
    hasErrors,
    hasWarnings
  }), isEditing = !value?._ref || inputProps.focusPath[0] === "_ref", {
    t
  } = useTranslation();
  let t8;
  $[20] !== handleRemoveStrengthenOnPublish || $[21] !== isCurrentDocumentLiveEdit || $[22] !== publishedReferenceExists || $[23] !== schemaType || $[24] !== value ? (t8 = isCurrentDocumentLiveEdit && publishedReferenceExists && value._strengthenOnPublish && /* @__PURE__ */ jsx(ReferenceFinalizeAlertStrip, { schemaType, handleRemoveStrengthenOnPublish }), $[20] = handleRemoveStrengthenOnPublish, $[21] = isCurrentDocumentLiveEdit, $[22] = publishedReferenceExists, $[23] = schemaType, $[24] = value, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== actualStrength || $[27] !== handleFixStrengthMismatch || $[28] !== showWeakRefMismatch ? (t9 = showWeakRefMismatch && /* @__PURE__ */ jsx(ReferenceStrengthMismatchAlertStrip, { actualStrength, handleFixStrengthMismatch }), $[26] = actualStrength, $[27] = handleFixStrengthMismatch, $[28] = showWeakRefMismatch, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== loadableReferenceInfo.error || $[31] !== loadableReferenceInfo.retry ? (t10 = loadableReferenceInfo.error && /* @__PURE__ */ jsx(ReferenceMetadataLoadErrorAlertStrip, { errorMessage: loadableReferenceInfo.error.message, onHandleRetry: loadableReferenceInfo.retry }), $[30] = loadableReferenceInfo.error, $[31] = loadableReferenceInfo.retry, $[32] = t10) : t10 = $[32];
  let t11;
  $[33] !== t10 || $[34] !== t8 || $[35] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t8,
    t9,
    t10
  ] }), $[33] = t10, $[34] = t8, $[35] = t9, $[36] = t11) : t11 = $[36];
  const footer = t11;
  let t12, t13;
  $[37] !== refType?.name || $[38] !== value?._ref ? (t13 = forwardRef(function(restProps, _ref) {
    return /* @__PURE__ */ jsx(IntentLink, { ...restProps, intent: "edit", params: {
      id: value?._ref,
      type: refType?.name
    }, target: "_blank", rel: "noopener noreferrer", ref: _ref });
  }), $[37] = refType?.name, $[38] = value?._ref, $[39] = t13) : t13 = $[39], t12 = t13;
  const OpenLink = t12;
  let t14;
  $[40] !== OpenLink || $[41] !== handleClear || $[42] !== handleReplace || $[43] !== inputId || $[44] !== readOnly || $[45] !== t || $[46] !== value?._ref ? (t14 = () => readOnly ? null : /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(ContextMenuButton, {}), id: `${inputId}-menuButton`, menu: /* @__PURE__ */ jsxs(Menu, { children: [
    !readOnly && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.clear"), tone: "critical", icon: TrashIcon, onClick: handleClear }),
      /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.replace"), icon: SyncIcon, onClick: handleReplace })
    ] }),
    !readOnly && value?._ref && /* @__PURE__ */ jsx(MenuDivider, {}),
    value?._ref && /* @__PURE__ */ jsx(MenuItem$1, { as: OpenLink, "data-as": "a", text: t("inputs.reference.action.open-in-new-tab"), icon: LaunchIcon })
  ] }), popover: MENU_POPOVER_PROPS$9 }) }), $[40] = OpenLink, $[41] = handleClear, $[42] = handleReplace, $[43] = inputId, $[44] = readOnly, $[45] = t, $[46] = value?._ref, $[47] = t14) : t14 = $[47];
  let t15;
  $[48] !== t14 ? (t15 = t14(), $[48] = t14, $[49] = t15) : t15 = $[49];
  const menu = t15;
  let t16;
  $[50] !== inputProps ? (t16 = (event) => {
    event.target === elementRef.current && inputProps.onPathFocus(EMPTY_ARRAY$A);
  }, $[50] = inputProps, $[51] = t16) : t16 = $[51];
  const handleFocus = t16;
  let t17;
  $[52] !== documentId || $[53] !== path || $[54] !== props2.actions || $[55] !== schemaType ? (t17 = documentId && props2.actions && props2.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: props2.actions, documentId, documentType: schemaType.name, onActions: setFieldActionNodes, path, schemaType }), $[52] = documentId, $[53] = path, $[54] = props2.actions, $[55] = schemaType, $[56] = t17) : t17 = $[56];
  const t18 = !!props2.inputProps.focused;
  let t19;
  $[57] !== EditReferenceLink || $[58] !== children || $[59] !== footer || $[60] !== handleFocus || $[61] !== isEditing || $[62] !== loadableReferenceInfo || $[63] !== menu || $[64] !== pressed || $[65] !== refType?.name || $[66] !== renderPreview || $[67] !== schemaType || $[68] !== selected || $[69] !== tone || $[70] !== value ? (t19 = isEditing ? /* @__PURE__ */ jsx(Box, { children }) : /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, padding: 1, tone, children: /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    /* @__PURE__ */ jsx(Flex, { gap: 1, align: "center", style: {
      lineHeight: 0
    }, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
      /* @__PURE__ */ jsx(ReferenceLinkCard, { __unstable_focusRing: !0, as: EditReferenceLink, "data-pressed": pressed ? !0 : void 0, "data-selected": selected ? !0 : void 0, documentId: value?._ref, documentType: refType?.name, flex: 1, pressed, radius: 2, ref: elementRef, selected, tone: "inherit", onFocus: handleFocus, children: /* @__PURE__ */ jsx(PreviewReferenceValue$2, { value, referenceInfo: loadableReferenceInfo, renderPreview, type: schemaType }) }),
      /* @__PURE__ */ jsx(Box, { children: menu })
    ] }) }),
    footer
  ] }) }), $[57] = EditReferenceLink, $[58] = children, $[59] = footer, $[60] = handleFocus, $[61] = isEditing, $[62] = loadableReferenceInfo, $[63] = menu, $[64] = pressed, $[65] = refType?.name, $[66] = renderPreview, $[67] = schemaType, $[68] = selected, $[69] = tone, $[70] = value, $[71] = t19) : t19 = $[71];
  let t20;
  $[72] !== fieldActionsNodes || $[73] !== props2.__internal_comments || $[74] !== props2.__internal_slot || $[75] !== props2.description || $[76] !== props2.level || $[77] !== props2.presence || $[78] !== props2.schemaType.deprecated || $[79] !== props2.title || $[80] !== props2.validation || $[81] !== t19 ? (t20 = /* @__PURE__ */ jsx(FormField, { __internal_comments: props2.__internal_comments, __internal_slot: props2.__internal_slot, __unstable_headerActions: fieldActionsNodes, __unstable_presence: props2.presence, description: props2.description, level: props2.level, title: props2.title, validation: props2.validation, deprecated: props2.schemaType.deprecated, children: t19 }), $[72] = fieldActionsNodes, $[73] = props2.__internal_comments, $[74] = props2.__internal_slot, $[75] = props2.description, $[76] = props2.level, $[77] = props2.presence, $[78] = props2.schemaType.deprecated, $[79] = props2.title, $[80] = props2.validation, $[81] = t19, $[82] = t20) : t20 = $[82];
  let t21;
  $[83] !== fieldActionsNodes || $[84] !== path || $[85] !== t18 || $[86] !== t20 ? (t21 = /* @__PURE__ */ jsx(FieldActionsProvider, { actions: fieldActionsNodes, focused: t18, path, children: t20 }), $[83] = fieldActionsNodes, $[84] = path, $[85] = t18, $[86] = t20, $[87] = t21) : t21 = $[87];
  let t22;
  return $[88] !== t17 || $[89] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t17,
    t21
  ] }), $[88] = t17, $[89] = t21, $[90] = t22) : t22 = $[90], t22;
}
function _temp2$F(v_0) {
  return v_0.level === "warning";
}
function _temp$1T(v) {
  return v.level === "error";
}
function getOption(type, optionName) {
  return get(type.options, optionName);
}
const PSEUDO_OBJECTS = ["array", "file", "image", "reference", "slug"], HIDDEN_FIELDS = ["asset", "crop", "hotspot", "_ref", "_weak", "media"], NO_LEVEL_LAYOUTS = ["tags"], NO_LEVEL_TYPES = ["slug"];
function getTypeChain(type, visited) {
  if (!type) return [];
  if (visited.has(type)) return [];
  visited.add(type);
  const next = type.type ? getTypeChain(type.type, visited) : [];
  return [type, ...next];
}
function getFieldLevel(schemaType, currentLevel) {
  return isArraySchemaType(schemaType) ? getArrayFieldLevel(schemaType, currentLevel) : getObjectFieldLevel(schemaType, currentLevel);
}
function getObjectFieldLevel(schemaType, currentLevel) {
  const {
    type,
    options
  } = schemaType, typeIfRelevant = asType(type, PSEUDO_OBJECTS), fields = schemaType?.jsonType === "object" ? schemaType.fields : void 0, typeName = typeIfRelevant?.name || "";
  if (NO_LEVEL_TYPES.includes(typeName))
    return 0;
  const isPseudoObject = PSEUDO_OBJECTS.includes(typeName), hasVisibleFields = (fields?.filter((f) => !HIDDEN_FIELDS.includes(f.name)).length ?? 0) > 0, hasListOptions2 = (options?.list?.length ?? 0) > 0;
  return hasVisibleFields || hasListOptions2 || !isPseudoObject ? currentLevel : 0;
}
function getArrayFieldLevel(schemaType, currentLevel) {
  const {
    options
  } = schemaType, hasListOptions2 = (options?.list || [])?.length > 0, isNoLevelLayout = NO_LEVEL_LAYOUTS.includes(options?.layout || "");
  return hasListOptions2 && !isNoLevelLayout ? currentLevel : 0;
}
function asType(schemaType, asOneOfTypes) {
  if (schemaType?.name && asOneOfTypes.includes(schemaType?.name))
    return schemaType;
  if (schemaType)
    return asType(schemaType.type, asOneOfTypes);
}
const EMPTY_ARRAY$o = [];
function BooleanField(field) {
  const $ = c(5), t0 = !!field.inputProps.focused;
  let t1;
  return $[0] !== field.children || $[1] !== field.inputProps.changed || $[2] !== field.path || $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(ChangeIndicator, { hasFocus: t0, isChanged: field.inputProps.changed, path: field.path, children: field.children }), $[0] = field.children, $[1] = field.inputProps.changed, $[2] = field.path, $[3] = t0, $[4] = t1) : t1 = $[4], t1;
}
function PrimitiveField(field) {
  const $ = c(31), [fieldActionsNodes, setFieldActionNodes] = useState(EMPTY_ARRAY$o), documentId = usePublishedId$1(), focused = !!field.inputProps.focused;
  let t0;
  $[0] !== documentId || $[1] !== field.actions || $[2] !== field.path || $[3] !== field.schemaType ? (t0 = documentId && field.actions && field.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: field.actions, documentId, documentType: field.schemaType.name, onActions: setFieldActionNodes, path: field.path, schemaType: field.schemaType }), $[0] = documentId, $[1] = field.actions, $[2] = field.path, $[3] = field.schemaType, $[4] = t0) : t0 = $[4];
  const t1 = `field-${field.inputId}`;
  let t2;
  $[5] !== field.children || $[6] !== field.inputProps.changed || $[7] !== field.path || $[8] !== focused ? (t2 = /* @__PURE__ */ jsx(ChangeIndicator, { hasFocus: focused, isChanged: field.inputProps.changed, path: field.path, children: field.children }), $[5] = field.children, $[6] = field.inputProps.changed, $[7] = field.path, $[8] = focused, $[9] = t2) : t2 = $[9];
  let t3;
  $[10] !== field.__internal_comments || $[11] !== field.__internal_slot || $[12] !== field.description || $[13] !== field.inputId || $[14] !== field.level || $[15] !== field.presence || $[16] !== field.schemaType.deprecated || $[17] !== field.title || $[18] !== field.validation || $[19] !== fieldActionsNodes || $[20] !== t1 || $[21] !== t2 ? (t3 = /* @__PURE__ */ jsx(FormField, { __internal_slot: field.__internal_slot, __internal_comments: field.__internal_comments, __unstable_headerActions: fieldActionsNodes, __unstable_presence: field.presence, "data-testid": t1, description: field.description, inputId: field.inputId, level: field.level, title: field.title, validation: field.validation, deprecated: field.schemaType.deprecated, children: t2 }), $[10] = field.__internal_comments, $[11] = field.__internal_slot, $[12] = field.description, $[13] = field.inputId, $[14] = field.level, $[15] = field.presence, $[16] = field.schemaType.deprecated, $[17] = field.title, $[18] = field.validation, $[19] = fieldActionsNodes, $[20] = t1, $[21] = t2, $[22] = t3) : t3 = $[22];
  let t4;
  $[23] !== field.path || $[24] !== fieldActionsNodes || $[25] !== focused || $[26] !== t3 ? (t4 = /* @__PURE__ */ jsx(FieldActionsProvider, { actions: fieldActionsNodes, focused, path: field.path, children: t3 }), $[23] = field.path, $[24] = fieldActionsNodes, $[25] = focused, $[26] = t3, $[27] = t4) : t4 = $[27];
  let t5;
  return $[28] !== t0 || $[29] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t0,
    t4
  ] }), $[28] = t0, $[29] = t4, $[30] = t5) : t5 = $[30], t5;
}
function ObjectOrArrayField(field) {
  const $ = c(34), [fieldActionsNodes, setFieldActionNodes] = useState(EMPTY_ARRAY$o), documentId = usePublishedId$1(), focused = !!field.inputProps.focused, disableActions = field.schemaType.options?.disableActions || EMPTY_ARRAY$o;
  let t0, t1;
  $[0] !== disableActions || $[1] !== field.actions ? (t1 = field.actions?.filter((a) => a.name === "pasteField" ? !disableActions.includes("add") : a.name === "copyField" ? !disableActions.includes("copy") : !0), $[0] = disableActions, $[1] = field.actions, $[2] = t1) : t1 = $[2], t0 = t1;
  const actions = t0;
  let t2;
  $[3] !== actions || $[4] !== documentId || $[5] !== field.actions || $[6] !== field.path || $[7] !== field.schemaType ? (t2 = documentId && field.actions && field.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: actions || EMPTY_ARRAY$o, documentId, documentType: field.schemaType.name, onActions: setFieldActionNodes, path: field.path, schemaType: field.schemaType }), $[3] = actions, $[4] = documentId, $[5] = field.actions, $[6] = field.path, $[7] = field.schemaType, $[8] = t2) : t2 = $[8];
  const t3 = `field-${field.inputId}`;
  let t4;
  $[9] !== field.__internal_comments || $[10] !== field.__internal_slot || $[11] !== field.children || $[12] !== field.collapsed || $[13] !== field.collapsible || $[14] !== field.description || $[15] !== field.inputId || $[16] !== field.level || $[17] !== field.onCollapse || $[18] !== field.onExpand || $[19] !== field.presence || $[20] !== field.schemaType.deprecated || $[21] !== field.title || $[22] !== field.validation || $[23] !== fieldActionsNodes || $[24] !== t3 ? (t4 = /* @__PURE__ */ jsx(FormFieldSet, { __internal_comments: field.__internal_comments, __internal_slot: field.__internal_slot, __unstable_headerActions: fieldActionsNodes, __unstable_presence: field.presence, collapsed: field.collapsed, collapsible: field.collapsible, "data-testid": t3, description: field.description, level: field.level, onCollapse: field.onCollapse, onExpand: field.onExpand, title: field.title, validation: field.validation, inputId: field.inputId, deprecated: field.schemaType.deprecated, children: field.children }), $[9] = field.__internal_comments, $[10] = field.__internal_slot, $[11] = field.children, $[12] = field.collapsed, $[13] = field.collapsible, $[14] = field.description, $[15] = field.inputId, $[16] = field.level, $[17] = field.onCollapse, $[18] = field.onExpand, $[19] = field.presence, $[20] = field.schemaType.deprecated, $[21] = field.title, $[22] = field.validation, $[23] = fieldActionsNodes, $[24] = t3, $[25] = t4) : t4 = $[25];
  let t5;
  $[26] !== field.path || $[27] !== fieldActionsNodes || $[28] !== focused || $[29] !== t4 ? (t5 = /* @__PURE__ */ jsx(FieldActionsProvider, { actions: fieldActionsNodes, focused, path: field.path, children: t4 }), $[26] = field.path, $[27] = fieldActionsNodes, $[28] = focused, $[29] = t4, $[30] = t5) : t5 = $[30];
  let t6;
  return $[31] !== t2 || $[32] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t2,
    t5
  ] }), $[31] = t2, $[32] = t5, $[33] = t6) : t6 = $[33], t6;
}
function ImageOrFileField(field) {
  const $ = c(32), [fieldActionsNodes, setFieldActionNodes] = useState(EMPTY_ARRAY$o), documentId = usePublishedId$1(), focused = !!field.inputProps.focused;
  let t0;
  if ($[0] !== field.inputProps.members || $[1] !== field.presence) {
    const hotspotField = field.inputProps.members.find(_temp$1S);
    t0 = hotspotField?.open ? field.presence : field.presence.concat(hotspotField?.field.presence || EMPTY_ARRAY$o), $[0] = field.inputProps.members, $[1] = field.presence, $[2] = t0;
  } else
    t0 = $[2];
  const presence = t0;
  let t1;
  $[3] !== documentId || $[4] !== field.actions || $[5] !== field.path || $[6] !== field.schemaType ? (t1 = documentId && field.actions && field.actions.length > 0 && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: field.actions, documentId, documentType: field.schemaType.name, onActions: setFieldActionNodes, path: field.path, schemaType: field.schemaType }), $[3] = documentId, $[4] = field.actions, $[5] = field.path, $[6] = field.schemaType, $[7] = t1) : t1 = $[7];
  let t2;
  $[8] !== field.__internal_comments || $[9] !== field.__internal_slot || $[10] !== field.children || $[11] !== field.collapsed || $[12] !== field.collapsible || $[13] !== field.description || $[14] !== field.inputId || $[15] !== field.level || $[16] !== field.onCollapse || $[17] !== field.onExpand || $[18] !== field.schemaType.deprecated || $[19] !== field.title || $[20] !== field.validation || $[21] !== fieldActionsNodes || $[22] !== presence ? (t2 = /* @__PURE__ */ jsx(FormFieldSet, { __internal_comments: field.__internal_comments, __internal_slot: field.__internal_slot, __unstable_headerActions: fieldActionsNodes, __unstable_presence: presence, collapsed: field.collapsed, collapsible: field.collapsible, description: field.description, level: field.level, onCollapse: field.onCollapse, onExpand: field.onExpand, title: field.title, validation: field.validation, inputId: field.inputId, deprecated: field.schemaType.deprecated, children: field.children }), $[8] = field.__internal_comments, $[9] = field.__internal_slot, $[10] = field.children, $[11] = field.collapsed, $[12] = field.collapsible, $[13] = field.description, $[14] = field.inputId, $[15] = field.level, $[16] = field.onCollapse, $[17] = field.onExpand, $[18] = field.schemaType.deprecated, $[19] = field.title, $[20] = field.validation, $[21] = fieldActionsNodes, $[22] = presence, $[23] = t2) : t2 = $[23];
  let t3;
  $[24] !== field.path || $[25] !== fieldActionsNodes || $[26] !== focused || $[27] !== t2 ? (t3 = /* @__PURE__ */ jsx(FieldActionsProvider, { actions: fieldActionsNodes, focused, path: field.path, children: t2 }), $[24] = field.path, $[25] = fieldActionsNodes, $[26] = focused, $[27] = t2, $[28] = t3) : t3 = $[28];
  let t4;
  return $[29] !== t1 || $[30] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t1,
    t3
  ] }), $[29] = t1, $[30] = t3, $[31] = t4) : t4 = $[31], t4;
}
function _temp$1S(member) {
  return member.kind === "field" && member.name === "hotspot";
}
function defaultResolveFieldComponent(schemaType) {
  if (schemaType.components?.field) return schemaType.components.field;
  if (isBooleanSchemaType(schemaType))
    return BooleanField;
  const typeChain = getTypeChain(schemaType, /* @__PURE__ */ new Set());
  return typeChain.some((t) => t.name === "image" || t.name === "file") ? ImageOrFileField : typeChain.some((t) => isCrossDatasetReferenceSchemaType(t)) || typeChain.some((t) => t.name === "slug") ? PrimitiveField : typeChain.some((t) => isReferenceSchemaType(t)) ? ReferenceField : schemaType.jsonType !== "object" && schemaType.jsonType !== "array" ? PrimitiveField : ObjectOrArrayField;
}
const NARROW_LAYOUT = css`
  grid-template-columns: minmax(0px, 1fr);
`, WIDE_LAYOUT = css`
  grid-template-columns: 1fr min-content;
`, Root$s = styled(Grid)((props2) => props2.$narrow ? NARROW_LAYOUT : WIDE_LAYOUT), AutocompleteContainer = forwardRef(function(props2, forwardedRef) {
  const $ = c(6), [rootElement, setRootElement] = useState(null);
  let t0;
  $[0] !== forwardedRef ? (t0 = (element) => {
    setForwardedRef(forwardedRef, element), setRootElement(element);
  }, $[0] = forwardedRef, $[1] = t0) : t0 = $[1];
  const handleNewRef = t0, t1 = (useElementRect(rootElement)?.width || 480) < 480;
  let t2;
  return $[2] !== handleNewRef || $[3] !== props2.children || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Root$s, { ref: handleNewRef, gap: 1, $narrow: t1, children: props2.children }), $[2] = handleNewRef, $[3] = props2.children, $[4] = t1, $[5] = t2) : t2 = $[5], t2;
});
function setForwardedRef(ref, instance) {
  typeof ref == "function" ? ref(instance) : ref && (ref.current = instance);
}
const INLINE_BLOCK_STYLE = {
  display: "inline-flex"
}, FULL_WIDTH = {
  width: "100%"
}, POPOVER_PROPS$5 = {
  portal: !0,
  tone: "default",
  constrainSize: !0,
  fallbackPlacements: ["bottom", "left", "top"],
  placement: "right",
  preventOverflow: !0
};
function CreateButton(props2) {
  const $ = c(25);
  let createOptions, id2, menuRef, onCreate, rest;
  $[0] !== props2 ? ({
    createOptions,
    onCreate,
    id: id2,
    menuRef,
    ...rest
  } = props2, $[0] = props2, $[1] = createOptions, $[2] = id2, $[3] = menuRef, $[4] = onCreate, $[5] = rest) : (createOptions = $[1], id2 = $[2], menuRef = $[3], onCreate = $[4], rest = $[5]);
  const currentUser = useCurrentUser(), {
    t
  } = useTranslation(), getI18nText = useGetI18nText(createOptions);
  if (!createOptions.some(_temp$1R)) {
    let t02;
    $[6] !== currentUser ? (t02 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "create-new-reference" }), $[6] = currentUser, $[7] = t02) : t02 = $[7];
    let t1;
    $[8] !== t ? (t1 = t("inputs.reference.action.create-new-document"), $[8] = t, $[9] = t1) : t1 = $[9];
    let t2;
    $[10] !== t1 ? (t2 = /* @__PURE__ */ jsx("div", { style: INLINE_BLOCK_STYLE, children: /* @__PURE__ */ jsx(Button, { text: t1, mode: "ghost", disabled: !0, icon: AddIcon, style: FULL_WIDTH }) }), $[10] = t1, $[11] = t2) : t2 = $[11];
    let t3;
    return $[12] !== t02 || $[13] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content: t02, children: t2 }), $[12] = t02, $[13] = t2, $[14] = t3) : t3 = $[14], t3;
  }
  let t0;
  return $[15] !== createOptions || $[16] !== currentUser || $[17] !== getI18nText || $[18] !== id2 || $[19] !== menuRef || $[20] !== onCreate || $[21] !== props2.readOnly || $[22] !== rest || $[23] !== t ? (t0 = createOptions.length > 1 ? /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(Button, { ...rest, disabled: props2.readOnly, text: t("inputs.reference.action.create-new-document-select"), mode: "ghost", icon: AddIcon, size: "large" }), id: id2, menu: /* @__PURE__ */ jsx(Menu, { ref: menuRef, children: createOptions.map((createOption) => /* @__PURE__ */ jsx(Tooltip, { disabled: createOption.permission.granted, content: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "create-document-type" }), portal: !0, children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(MenuItem$1, { disabled: !createOption.permission.granted, icon: createOption.icon, text: getI18nText(createOption).title, onClick: () => onCreate(createOption) }) }) }, createOption.id)) }), popover: POPOVER_PROPS$5 }) : /* @__PURE__ */ jsx(Button, { ...rest, text: t("inputs.reference.action.create-new-document-select"), mode: "ghost", disabled: !createOptions[0].permission.granted || props2.readOnly, onClick: () => onCreate(createOptions[0]), icon: AddIcon, size: "large", "data-testid": `create-new-document-select-${id2}` }), $[15] = createOptions, $[16] = currentUser, $[17] = getI18nText, $[18] = id2, $[19] = menuRef, $[20] = onCreate, $[21] = props2.readOnly, $[22] = rest, $[23] = t, $[24] = t0) : t0 = $[24], t0;
}
function _temp$1R(option) {
  return option.permission.granted;
}
function OptionPreview$2(props2) {
  const $ = c(28), {
    getReferenceInfo: getReferenceInfo2,
    id: documentId,
    renderPreview
  } = props2, {
    isLoading,
    result: referenceInfo,
    error
  } = useReferenceInfo$2(documentId, getReferenceInfo2), {
    t
  } = useTranslation();
  if (isLoading) {
    let t02;
    $[0] === Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
      maxWidth: 320
    }, radius: 1, animated: !0 }), $[0] = t02) : t02 = $[0];
    let t12;
    return $[1] === Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t02,
      /* @__PURE__ */ jsx(TextSkeleton, { style: {
        maxWidth: 200
      }, radius: 1, size: 1, animated: !0 })
    ] }), $[1] = t12) : t12 = $[1], t12;
  }
  if (error) {
    let t02;
    $[2] !== t ? (t02 = t("inputs.reference.error.failed-to-load-document-title"), $[2] = t, $[3] = t02) : t02 = $[3];
    let t12;
    $[4] !== error.message ? (t12 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: error.message }), $[4] = error.message, $[5] = t12) : t12 = $[5];
    let t2;
    return $[6] !== t02 || $[7] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: /* @__PURE__ */ jsx(Alert, { title: t02, children: t12 }) }), $[6] = t02, $[7] = t12, $[8] = t2) : t2 = $[8], t2;
  }
  if (!referenceInfo)
    return null;
  if (referenceInfo.availability.reason === "PERMISSION_DENIED") {
    let t02;
    $[9] !== t ? (t02 = t("inputs.reference.error.missing-read-permissions-description"), $[9] = t, $[10] = t02) : t02 = $[10];
    let t12;
    return $[11] !== t02 ? (t12 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t02 }), $[11] = t02, $[12] = t12) : t12 = $[12], t12;
  }
  let t0;
  if ($[13] !== props2.type.to || $[14] !== referenceInfo.type) {
    let t12;
    $[16] !== referenceInfo.type ? (t12 = (toType) => toType.name === referenceInfo.type, $[16] = referenceInfo.type, $[17] = t12) : t12 = $[17], t0 = props2.type.to.find(t12), $[13] = props2.type.to, $[14] = referenceInfo.type, $[15] = t0;
  } else
    t0 = $[15];
  const refType = t0;
  if (!refType) {
    let t12;
    $[18] !== referenceInfo.type || $[19] !== t ? (t12 = t("inputs.reference.error.invalid-search-result-type-title", {
      returnedType: referenceInfo.type
    }), $[18] = referenceInfo.type, $[19] = t, $[20] = t12) : t12 = $[20];
    let t2;
    return $[21] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t12 }), $[21] = t12, $[22] = t2) : t2 = $[22], t2;
  }
  let t1;
  return $[23] !== props2.type.to.length || $[24] !== refType || $[25] !== referenceInfo || $[26] !== renderPreview ? (t1 = referenceInfo && refType && /* @__PURE__ */ jsx(ReferencePreview$1, { id: referenceInfo.id, layout: "default", refType, renderPreview, showTypeLabel: props2.type.to.length > 1 }), $[23] = props2.type.to.length, $[24] = refType, $[25] = referenceInfo, $[26] = renderPreview, $[27] = t1) : t1 = $[27], t1;
}
const StyledPopover$8 = styled(Popover)`
  & > div {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
`, StyledText$6 = styled(Text$1)`
  word-break: break-word;
`, FALLBACK_PLACEMENTS$2 = ["top-start", "bottom-start"], ReferenceAutocomplete$3 = forwardRef(function(props2, ref) {
  const $ = c(18);
  let loading, portalRef, referenceElement, restProps, searchString;
  $[0] !== props2 ? ({
    searchString,
    loading,
    portalRef,
    referenceElement,
    ...restProps
  } = props2, $[0] = props2, $[1] = loading, $[2] = portalRef, $[3] = referenceElement, $[4] = restProps, $[5] = searchString) : (loading = $[1], portalRef = $[2], referenceElement = $[3], restProps = $[4], searchString = $[5]);
  const {
    t
  } = useTranslation(), hasResults = props2.options && props2.options.length > 0;
  let t0;
  $[6] !== hasResults || $[7] !== loading || $[8] !== portalRef || $[9] !== referenceElement || $[10] !== searchString || $[11] !== t ? (t0 = (t12, contentRef) => {
    const {
      content,
      hidden,
      inputElement,
      onMouseEnter,
      onMouseLeave
    } = t12;
    return /* @__PURE__ */ jsx(StyledPopover$8, { "data-testid": "autocomplete-popover", placement: "bottom-start", fallbackPlacements: FALLBACK_PLACEMENTS$2, arrow: !1, constrainSize: !0, onMouseEnter, onMouseLeave, content: /* @__PURE__ */ jsx("div", { ref: contentRef, children: hasResults ? content : /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(StyledText$6, { align: "center", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.no-results-for-query", values: {
      searchTerm: searchString || ""
    } }) }) }) }) }), open: !loading && !hidden, ref: portalRef, portal: !0, referenceElement: referenceElement || inputElement, matchReferenceWidth: !0 });
  }, $[6] = hasResults, $[7] = loading, $[8] = portalRef, $[9] = referenceElement, $[10] = searchString, $[11] = t, $[12] = t0) : t0 = $[12];
  const renderPopover = t0;
  let t1;
  return $[13] !== loading || $[14] !== ref || $[15] !== renderPopover || $[16] !== restProps ? (t1 = /* @__PURE__ */ jsx(Autocomplete, { ...restProps, loading, ref, renderPopover }), $[13] = loading, $[14] = ref, $[15] = renderPopover, $[16] = restProps, $[17] = t1) : t1 = $[17], t1;
});
function useReferenceItemRef() {
  const $ = c(1), ref = useContext(ReferenceItemRefContext);
  if (!ref) {
    let t0;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      menuRef: {
        current: null
      },
      menuButtonRef: {
        current: null
      },
      containerRef: {
        current: null
      }
    }, $[0] = t0) : t0 = $[0], t0;
  }
  return ref;
}
const INITIAL_SEARCH_STATE$2 = {
  hits: [],
  isLoading: !1
}, NO_FILTER$3 = () => !0;
function nonNullable(v) {
  return v !== null;
}
function ReferenceInput(props2) {
  const $ = c(94), {
    createOptions,
    onChange,
    onEditReference,
    onSearch,
    schemaType,
    readOnly,
    id: id2,
    onPathFocus,
    value,
    version,
    renderPreview,
    path,
    elementProps,
    focusPath
  } = props2, {
    selectedReleaseId
  } = usePerspective();
  let t0;
  $[0] !== path || $[1] !== schemaType || $[2] !== value || $[3] !== version ? (t0 = {
    path,
    schemaType,
    value,
    version
  }, $[0] = path, $[1] = schemaType, $[2] = value, $[3] = version, $[4] = t0) : t0 = $[4];
  const {
    getReferenceInfo: getReferenceInfo2
  } = useReferenceInput(t0), [searchState, setSearchState] = useState(INITIAL_SEARCH_STATE$2);
  let t1;
  $[5] !== onChange || $[6] !== onEditReference || $[7] !== onPathFocus || $[8] !== schemaType.name || $[9] !== schemaType.weak || $[10] !== selectedReleaseId ? (t1 = (option) => {
    const newDocumentId = uuid(), strengthenOnPublishPatches = typeof selectedReleaseId > "u" ? [set(!0, ["_weak"])] : [], createInPlaceMetadataPatches = [set({
      type: option.type,
      weak: schemaType.weak,
      template: option.template
    }, ["_strengthenOnPublish"])], patches = [setIfMissing({}), set(schemaType.name, ["_type"]), set(newDocumentId, ["_ref"])].concat(strengthenOnPublishPatches, createInPlaceMetadataPatches).filter(isNonNullable$3);
    onChange(patches), onEditReference({
      id: newDocumentId,
      type: option.type,
      template: option.template,
      version: selectedReleaseId
    }), onPathFocus([]);
  }, $[5] = onChange, $[6] = onEditReference, $[7] = onPathFocus, $[8] = schemaType.name, $[9] = schemaType.weak, $[10] = selectedReleaseId, $[11] = t1) : t1 = $[11];
  const handleCreateNew = t1;
  let t2;
  $[12] !== onChange || $[13] !== onPathFocus || $[14] !== schemaType.name || $[15] !== schemaType.weak || $[16] !== searchState.hits ? (t2 = (nextId) => {
    if (!nextId) {
      onChange(unset()), onPathFocus([]);
      return;
    }
    const hit = searchState.hits.find((h) => h.id === nextId);
    if (!hit)
      throw new Error("Selected an item that wasnt part of the result set");
    const patches_0 = [setIfMissing({}), set(schemaType.name, ["_type"]), set(getPublishedId(nextId), ["_ref"]), hit.published && !schemaType.weak ? unset(["_weak"]) : set(!0, ["_weak"]), hit.published ? unset(["_strengthenOnPublish"]) : set({
      type: hit?.type,
      weak: schemaType.weak
    }, ["_strengthenOnPublish"])].filter(isNonNullable$3);
    onChange(patches_0), onPathFocus([]);
  }, $[12] = onChange, $[13] = onPathFocus, $[14] = schemaType.name, $[15] = schemaType.weak, $[16] = searchState.hits, $[17] = t2) : t2 = $[17];
  const handleChange = t2;
  let t3;
  $[18] !== onChange ? (t3 = () => {
    onChange(unset());
  }, $[18] = onChange, $[19] = t3) : t3 = $[19];
  const handleClear = t3;
  let t4;
  $[20] !== onPathFocus ? (t4 = (event) => {
    event.key === "Escape" && onPathFocus([]);
  }, $[20] = onPathFocus, $[21] = t4) : t4 = $[21];
  const handleAutocompleteKeyDown = t4, loadableReferenceInfo = useReferenceInfo$2(value?._ref, getReferenceInfo2), [autocompletePopoverReferenceElement, setAutocompletePopoverReferenceElement] = useState(null), {
    push
  } = useToast(), {
    t
  } = useTranslation();
  let t5;
  $[22] !== id2 || $[23] !== onSearch || $[24] !== push || $[25] !== t ? (t5 = (inputValue$) => inputValue$.pipe(filter(nonNullable), switchMap((searchString) => concat(of({
    isLoading: !0
  }), onSearch(searchString).pipe(map((hits) => ({
    hits,
    searchString,
    isLoading: !1
  })), catchError((error) => (push({
    title: t("inputs.reference.error.search-failed-title"),
    description: error.message,
    status: "error",
    id: `reference-search-fail-${id2}`
  }), console.error(error), of({
    hits: []
  })))))), scan(_temp$1Q, INITIAL_SEARCH_STATE$2), tap(setSearchState)), $[22] = id2, $[23] = onSearch, $[24] = push, $[25] = t, $[26] = t5) : t5 = $[26];
  const handleQueryChange = useObservableEvent(t5);
  let t6;
  $[27] !== handleQueryChange ? (t6 = () => {
    handleQueryChange("");
  }, $[27] = handleQueryChange, $[28] = t6) : t6 = $[28];
  const handleAutocompleteOpenButtonClick = t6;
  let t7;
  $[29] !== onPathFocus ? (t7 = (e) => {
    e.key === "Escape" && onPathFocus([]);
  }, $[29] = onPathFocus, $[30] = t7) : t7 = $[30];
  const handleCreateButtonKeyDown = t7;
  let t8;
  $[31] !== getReferenceInfo2 || $[32] !== renderPreview || $[33] !== schemaType ? (t8 = (option_0) => {
    const documentId = option_0.hit.draft?._id || option_0.hit.published?._id || option_0.value;
    return /* @__PURE__ */ jsx(ReferenceInputPreviewCard, { forwardedAs: "button", type: "button", radius: 2, tone: "inherit", children: /* @__PURE__ */ jsx(OptionPreview$2, { getReferenceInfo: getReferenceInfo2, id: documentId, renderPreview, type: schemaType }) });
  }, $[31] = getReferenceInfo2, $[32] = renderPreview, $[33] = schemaType, $[34] = t8) : t8 = $[34];
  const renderOption = t8;
  let t9;
  $[35] !== loadableReferenceInfo.result?.preview?.original?.title || $[36] !== loadableReferenceInfo.result?.preview?.snapshot?.title ? (t9 = () => loadableReferenceInfo.result?.preview?.snapshot?.title || loadableReferenceInfo.result?.preview?.original?.title || "", $[35] = loadableReferenceInfo.result?.preview?.original?.title, $[36] = loadableReferenceInfo.result?.preview?.snapshot?.title, $[37] = t9) : t9 = $[37];
  const renderValue = t9;
  let t10;
  $[38] !== onPathFocus ? (t10 = () => onPathFocus(["_ref"]), $[38] = onPathFocus, $[39] = t10) : t10 = $[39];
  const handleFocus = t10;
  let t11;
  $[40] !== autocompletePopoverReferenceElement || $[41] !== props2.elementProps ? (t11 = (event_0) => {
    autocompletePopoverReferenceElement?.contains(event_0.relatedTarget) || props2.elementProps.onBlur(event_0);
  }, $[40] = autocompletePopoverReferenceElement, $[41] = props2.elementProps, $[42] = t11) : t11 = $[42];
  const handleBlur = t11, isWeakRefToNonexistent = loadableReferenceInfo?.result?.availability?.reason === "NOT_FOUND" && !value?._strengthenOnPublish && value?._weak;
  let t12;
  $[43] !== elementProps ? (t12 = (hadFocusAtRef, hasFocusAtRef) => {
    !hadFocusAtRef && hasFocusAtRef && elementProps.ref.current?.focus();
  }, $[43] = elementProps, $[44] = t12) : t12 = $[44], useDidUpdate(focusPath?.[0] === "_ref", t12);
  let t13, t14;
  $[45] !== searchState.hits ? (t14 = searchState.hits.map(_temp2$E), $[45] = searchState.hits, $[46] = t14) : t14 = $[46], t13 = t14;
  const hits_0 = t13, isEditing = focusPath.length === 1 && focusPath[0] === "_ref", {
    menuRef,
    menuButtonRef,
    containerRef
  } = useReferenceItemRef(), clickOutsideBoundaryRef = useRef(null), autoCompletePortalRef = useRef(null), createButtonMenuPortalRef = useRef(null);
  let t15;
  $[47] !== handleClear || $[48] !== isEditing || $[49] !== menuButtonRef.current || $[50] !== value?._ref ? (t15 = !value?._ref && (() => {
    (isEditing || document.activeElement === menuButtonRef.current) && handleClear();
  }), $[47] = handleClear, $[48] = isEditing, $[49] = menuButtonRef.current, $[50] = value?._ref, $[51] = t15) : t15 = $[51];
  let t16;
  $[52] !== containerRef.current || $[53] !== menuButtonRef.current || $[54] !== menuRef.current ? (t16 = () => [menuRef.current, menuButtonRef.current, containerRef.current, clickOutsideBoundaryRef.current, autoCompletePortalRef.current, createButtonMenuPortalRef.current], $[52] = containerRef.current, $[53] = menuButtonRef.current, $[54] = menuRef.current, $[55] = t16) : t16 = $[55], useClickOutsideEvent(t15, t16);
  let t17;
  $[56] !== handleClear || $[57] !== isWeakRefToNonexistent || $[58] !== t || $[59] !== value ? (t17 = isWeakRefToNonexistent ? /* @__PURE__ */ jsx(Alert, { "data-testid": "alert-nonexistent-document", title: t("inputs.reference.error.nonexistent-document-title"), suffix: /* @__PURE__ */ jsx(Stack, { padding: 2, children: /* @__PURE__ */ jsx(Button, { text: t("inputs.reference.error.nonexistent-document.clear-button-label"), onClick: handleClear }) }), children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "inputs.reference.error.nonexistent-document-description", t, values: {
    documentId: value._ref
  } }) }) }) : null, $[56] = handleClear, $[57] = isWeakRefToNonexistent, $[58] = t, $[59] = value, $[60] = t17) : t17 = $[60];
  const t18 = searchState.isLoading;
  let t19;
  $[61] !== t ? (t19 = t("inputs.reference.search-placeholder"), $[61] = t, $[62] = t19) : t19 = $[62];
  const t20 = loadableReferenceInfo.isLoading || readOnly, t21 = renderOption;
  let t22;
  $[63] !== handleAutocompleteOpenButtonClick ? (t22 = {
    onClick: handleAutocompleteOpenButtonClick
  }, $[63] = handleAutocompleteOpenButtonClick, $[64] = t22) : t22 = $[64];
  const t23 = value?._ref;
  let t24;
  $[65] !== autocompletePopoverReferenceElement || $[66] !== elementProps || $[67] !== handleAutocompleteKeyDown || $[68] !== handleBlur || $[69] !== handleChange || $[70] !== handleFocus || $[71] !== handleQueryChange || $[72] !== hits_0 || $[73] !== renderValue || $[74] !== searchState.isLoading || $[75] !== searchState.searchString || $[76] !== t19 || $[77] !== t20 || $[78] !== t21 || $[79] !== t22 || $[80] !== t23 ? (t24 = /* @__PURE__ */ jsx(ReferenceAutocomplete$3, { ...elementProps, onFocus: handleFocus, onBlur: handleBlur, "data-testid": "autocomplete", loading: t18, referenceElement: autocompletePopoverReferenceElement, options: hits_0, radius: 2, placeholder: t19, onKeyDown: handleAutocompleteKeyDown, readOnly: t20, onQueryChange: handleQueryChange, searchString: searchState.searchString, onChange: handleChange, filterOption: NO_FILTER$3, renderOption: t21, renderValue, openButton: t22, portalRef: autoCompletePortalRef, value: t23 }), $[65] = autocompletePopoverReferenceElement, $[66] = elementProps, $[67] = handleAutocompleteKeyDown, $[68] = handleBlur, $[69] = handleChange, $[70] = handleFocus, $[71] = handleQueryChange, $[72] = hits_0, $[73] = renderValue, $[74] = searchState.isLoading, $[75] = searchState.searchString, $[76] = t19, $[77] = t20, $[78] = t21, $[79] = t22, $[80] = t23, $[81] = t24) : t24 = $[81];
  let t25;
  $[82] !== createOptions || $[83] !== handleCreateButtonKeyDown || $[84] !== handleCreateNew || $[85] !== id2 || $[86] !== readOnly ? (t25 = createOptions.length > 0 && /* @__PURE__ */ jsx(CreateButton, { id: `${id2}-selectTypeMenuButton`, readOnly, createOptions, onCreate: handleCreateNew, onKeyDown: handleCreateButtonKeyDown, menuRef: createButtonMenuPortalRef }), $[82] = createOptions, $[83] = handleCreateButtonKeyDown, $[84] = handleCreateNew, $[85] = id2, $[86] = readOnly, $[87] = t25) : t25 = $[87];
  let t26;
  $[88] !== t24 || $[89] !== t25 ? (t26 = /* @__PURE__ */ jsxs(AutocompleteContainer, { ref: setAutocompletePopoverReferenceElement, children: [
    t24,
    t25
  ] }), $[88] = t24, $[89] = t25, $[90] = t26) : t26 = $[90];
  let t27;
  return $[91] !== t17 || $[92] !== t26 ? (t27 = /* @__PURE__ */ jsx(Stack, { space: 1, "data-testid": "reference-input", ref: clickOutsideBoundaryRef, children: /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t17,
    t26
  ] }) }), $[91] = t17, $[92] = t26, $[93] = t27) : t27 = $[93], t27;
}
function _temp2$E(hit_0) {
  return {
    value: hit_0.id,
    hit: hit_0
  };
}
function _temp$1Q(prevState, nextState) {
  return {
    ...prevState,
    ...nextState
  };
}
async function resolveUserDefinedFilter$2(options, document2, valuePath, getClient2) {
  if (!options)
    return {};
  if (typeof options.filter == "function") {
    const parentPath = valuePath.slice(0, -1), parent = get$1(document2, parentPath);
    return await options.filter({
      document: document2,
      parentPath,
      parent,
      getClient: getClient2
    });
  }
  return {
    filter: options.filter,
    params: "filterParams" in options ? options.filterParams : void 0
  };
}
function useValueRef$2(value) {
  const $ = c(3), ref = useRef(value);
  let t0, t1;
  return $[0] !== value ? (t0 = () => {
    ref.current = value;
  }, t1 = [value], $[0] = value, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), ref;
}
function StudioReferenceInput(props2) {
  const source = useSource(), searchClient = source.getClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    perspectiveStack
  } = usePerspective(), schema2 = useSchema(), maxFieldDepth = useSearchMaxFieldDepth(), documentPreviewStore = useDocumentPreviewStore(), {
    selectedReleaseId
  } = usePerspective(), {
    path,
    schemaType
  } = props2, {
    EditReferenceLinkComponent,
    onEditReference,
    activePath,
    initialValueTemplateItems,
    ...inheritedOptions
  } = useReferenceInputOptions(), {
    strategy: searchStrategy
  } = source.search, documentValue = useFormValue([]), documentRef = useValueRef$2(documentValue), documentTypeName = documentRef.current?._type, refType = schema2.get(documentTypeName), isDocumentLiveEdit = useMemo(() => refType?.liveEdit, [refType]), disableNew = inheritedOptions.disableNew ?? schemaType.options?.disableNew === !0, getClient2 = source.getClient, handleSearch = useCallback((searchString) => from(resolveUserDefinedFilter$2(schemaType.options, documentRef.current, path, getClient2)).pipe(mergeMap(({
    filter: filter2,
    params
  }) => referenceSearch(searchClient, searchString, schemaType, {
    ...schemaType.options,
    filter: filter2,
    params,
    tag: "search.reference",
    maxFieldDepth,
    strategy: searchStrategy,
    perspective: perspectiveStack
  })), catchError((err) => {
    const isQueryError = err.details && err.details.type === "queryParseError";
    return schemaType.options?.filter && isQueryError && (err.message = 'Invalid reference filter, please check the custom "filter" option'), throwError(err);
  })), [schemaType, documentRef, path, getClient2, searchClient, maxFieldDepth, searchStrategy, perspectiveStack]), template2 = props2.value?._strengthenOnPublish?.template, EditReferenceLink = useMemo(() => forwardRef(function(_props, forwardedRef) {
    return EditReferenceLinkComponent ? /* @__PURE__ */ jsx(EditReferenceLinkComponent, { ..._props, ref: forwardedRef, parentRefPath: path, template: template2 }) : null;
  }), [EditReferenceLinkComponent, path, template2]), handleEditReference = useCallback((event) => {
    onEditReference?.({
      parentRefPath: path,
      id: event.id,
      type: event.type,
      template: event.template,
      version: event.version
    });
  }, [onEditReference, path]), selectedState = PathUtils.startsWith(path, activePath?.path || []) ? activePath?.state : "none", createOptions = useMemo(() => disableNew ? [] : (initialValueTemplateItems || []).filter((i) => schemaType.to.some((_refType) => _refType.name === i.template?.schemaType)).map((item) => item.template?.schemaType ? {
    id: item.id,
    title: item.title || `${item.template.schemaType} from template ${item.template?.id}`,
    i18n: item.i18n,
    type: item.template.schemaType,
    icon: item.icon,
    template: {
      id: item.template?.id,
      params: item.parameters
    },
    permission: {
      granted: item.granted,
      reason: item.reason
    }
  } : void 0).filter(isNonNullable$3), [disableNew, initialValueTemplateItems, schemaType.to]), getReferenceInfo$1 = useCallback((id2, _type) => getReferenceInfo(documentPreviewStore, id2, _type), [documentPreviewStore]);
  return /* @__PURE__ */ jsx(ReferenceInput, { ...props2, onSearch: handleSearch, liveEdit: isDocumentLiveEdit, getReferenceInfo: getReferenceInfo$1, selectedState, editReferenceLinkComponent: EditReferenceLink, createOptions, onEditReference: handleEditReference, version: selectedReleaseId });
}
function isObjectItemProps(item) {
  return isObjectSchemaType(item.schemaType);
}
function isObjectInputProps(inputProps) {
  return isObjectSchemaType(inputProps.schemaType);
}
function isStringInputProps(inputProps) {
  return isStringSchemaType(inputProps.schemaType);
}
function isNumberInputProps(inputProps) {
  return isNumberSchemaType(inputProps.schemaType);
}
function isBooleanInputProps(inputProps) {
  return isBooleanSchemaType(inputProps.schemaType);
}
function isArrayOfObjectsInputProps(inputProps) {
  return isArrayOfObjectsSchemaType(inputProps.schemaType);
}
function isArrayOfBlocksInputProps(inputProps) {
  return isArrayOfBlocksSchemaType(inputProps.schemaType);
}
function isArrayOfPrimitivesInputProps(inputProps) {
  return isArrayOfPrimitivesSchemaType(inputProps.schemaType);
}
function restrictToBoundingRect(transform, rect, boundingRect, margins) {
  const value = {
    ...transform
  }, marginY = margins.y, marginX = margins.x || 0;
  return rect.top + value.y <= boundingRect.top + marginY ? value.y = boundingRect.top - rect.top + marginY : rect.bottom + value.y >= boundingRect.top + boundingRect.height - marginY && (value.y = boundingRect.top + boundingRect.height - rect.bottom - marginY), rect.left + value.x <= boundingRect.left - marginX ? value.x = boundingRect.left - rect.left + marginX : rect.right + value.x >= boundingRect.left + boundingRect.width + marginX && (value.x = boundingRect.left + boundingRect.width - rect.right + marginX), value;
}
const restrictToParentElementWithMargins = (margins) => ({
  containerNodeRect,
  draggingNodeRect,
  transform
}) => !draggingNodeRect || !containerNodeRect ? transform : restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect, margins), MOVING_ITEM_CLASS_NAME = "moving", ListItem$2 = styled(Box)`
  ${(props2) => props2.$moving && css`
      z-index: 10000;
      /* prevents hover-effects etc on the dragged element  */
      pointer-events: none;
    `}
`, AUTO_SCROLL_OPTIONS = {
  threshold: {
    x: 0,
    y: 0.02
  }
}, SENSOR_OPTIONS = {
  coordinateGetter: sortableKeyboardCoordinates
}, TRANSITION$1 = {
  duration: 200,
  easing: "ease"
};
function restrictToAxis(axis) {
  return axis === "x" ? restrictToHorizontalAxis : restrictToVerticalAxis;
}
function sortingStrategy(axis) {
  return axis === "x" ? horizontalListSortingStrategy : verticalListSortingStrategy;
}
const SortableList = memo(function(props2) {
  const $ = c(29);
  let axis, children, items, onItemMove, onItemMoveEnd, onItemMoveStart, rest;
  $[0] !== props2 ? ({
    items,
    axis,
    onItemMove,
    onItemMoveStart,
    onItemMoveEnd,
    children,
    ...rest
  } = props2, $[0] = props2, $[1] = axis, $[2] = children, $[3] = items, $[4] = onItemMove, $[5] = onItemMoveEnd, $[6] = onItemMoveStart, $[7] = rest) : (axis = $[1], children = $[2], items = $[3], onItemMove = $[4], onItemMoveEnd = $[5], onItemMoveStart = $[6], rest = $[7]);
  const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, SENSOR_OPTIONS));
  let t0;
  $[8] !== onItemMove || $[9] !== onItemMoveEnd ? (t0 = (event) => {
    const {
      active,
      over
    } = event;
    active.id !== over?.id && onItemMove?.({
      fromIndex: active.data.current?.sortable?.index,
      toIndex: over?.data.current?.sortable?.index
    }), onItemMoveEnd?.();
  }, $[8] = onItemMove, $[9] = onItemMoveEnd, $[10] = t0) : t0 = $[10];
  const handleDragEnd = t0;
  let t1, t2;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t2 = restrictToParentElementWithMargins({
    y: 4
  }), $[11] = t2) : t2 = $[11];
  let t3;
  $[12] !== axis ? (t3 = [t2, ...axis ? [restrictToAxis(axis)] : []], $[12] = axis, $[13] = t3) : t3 = $[13], t1 = t3;
  const modifiers = t1;
  let t4;
  $[14] !== axis ? (t4 = axis ? sortingStrategy(axis) : void 0, $[14] = axis, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== children || $[17] !== rest ? (t5 = /* @__PURE__ */ jsx(Grid, { ...rest, children }), $[16] = children, $[17] = rest, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== items || $[20] !== t4 || $[21] !== t5 ? (t6 = /* @__PURE__ */ jsx(SortableContext, { items, strategy: t4, children: t5 }), $[19] = items, $[20] = t4, $[21] = t5, $[22] = t6) : t6 = $[22];
  let t7;
  return $[23] !== handleDragEnd || $[24] !== modifiers || $[25] !== onItemMoveStart || $[26] !== sensors || $[27] !== t6 ? (t7 = /* @__PURE__ */ jsx(DndContext, { sensors, autoScroll: AUTO_SCROLL_OPTIONS, modifiers, collisionDetection: closestCenter, onDragEnd: handleDragEnd, onDragStart: onItemMoveStart, children: t6 }), $[23] = handleDragEnd, $[24] = modifiers, $[25] = onItemMoveStart, $[26] = sensors, $[27] = t6, $[28] = t7) : t7 = $[28], t7;
}), SortableListItem = forwardRef(function(props2, ref) {
  const $ = c(19), {
    id: id2,
    children,
    disableTransition
  } = props2, t0 = disableTransition ? null : TRANSITION$1;
  let t1;
  $[0] !== id2 || $[1] !== t0 ? (t1 = {
    id: id2,
    transition: t0
  }, $[0] = id2, $[1] = t0, $[2] = t1) : t1 = $[2];
  const {
    setNodeRef,
    transform,
    transition,
    active
  } = useSortable(t1), isActive = id2 === active?.id;
  let t2, t3;
  $[3] !== transform ? (t3 = CSS.Translate.toString(transform), $[3] = transform, $[4] = t3) : t3 = $[4];
  const t4 = active ? "none" : void 0;
  let t5;
  $[5] !== t3 || $[6] !== t4 || $[7] !== transition ? (t5 = {
    transform: t3,
    transition,
    pointerEvents: t4
  }, $[5] = t3, $[6] = t4, $[7] = transition, $[8] = t5) : t5 = $[8], t2 = t5;
  const style = t2;
  let t6;
  $[9] !== ref || $[10] !== setNodeRef ? (t6 = (node) => {
    setNodeRef(node), typeof ref == "function" ? ref(node) : ref && (ref.current = node);
  }, $[9] = ref, $[10] = setNodeRef, $[11] = t6) : t6 = $[11];
  const setRef = t6, t7 = isActive ? MOVING_ITEM_CLASS_NAME : "", t8 = props2["data-index"];
  let t9;
  return $[12] !== children || $[13] !== isActive || $[14] !== setRef || $[15] !== style || $[16] !== t7 || $[17] !== t8 ? (t9 = /* @__PURE__ */ jsx(ListItem$2, { ref: setRef, style, $moving: isActive, className: t7, "data-index": t8, children }), $[12] = children, $[13] = isActive, $[14] = setRef, $[15] = style, $[16] = t7, $[17] = t8, $[18] = t9) : t9 = $[18], t9;
});
function List(props2) {
  const $ = c(14);
  let onItemMove, onItemMoveEnd, onItemMoveStart, rest, sortable;
  $[0] !== props2 ? ({
    onItemMove,
    onItemMoveEnd,
    onItemMoveStart,
    sortable,
    ...rest
  } = props2, $[0] = props2, $[1] = onItemMove, $[2] = onItemMoveEnd, $[3] = onItemMoveStart, $[4] = rest, $[5] = sortable) : (onItemMove = $[1], onItemMoveEnd = $[2], onItemMoveStart = $[3], rest = $[4], sortable = $[5]);
  let t0;
  $[6] !== onItemMove ? (t0 = (event) => {
    onItemMove?.(event);
  }, $[6] = onItemMove, $[7] = t0) : t0 = $[7];
  const handleSortEnd = t0;
  let t1;
  return $[8] !== handleSortEnd || $[9] !== onItemMoveEnd || $[10] !== onItemMoveStart || $[11] !== rest || $[12] !== sortable ? (t1 = sortable ? /* @__PURE__ */ jsx(SortableList, { onItemMove: handleSortEnd, onItemMoveStart, onItemMoveEnd, ...rest }) : /* @__PURE__ */ jsx(Grid, { ...rest }), $[8] = handleSortEnd, $[9] = onItemMoveEnd, $[10] = onItemMoveStart, $[11] = rest, $[12] = sortable, $[13] = t1) : t1 = $[13], t1;
}
const Item = forwardRef(function(props2, ref) {
  const $ = c(10);
  let rest, sortable;
  $[0] !== props2 ? ({
    sortable,
    ...rest
  } = props2, $[0] = props2, $[1] = rest, $[2] = sortable) : (rest = $[1], sortable = $[2]);
  let t0;
  $[3] !== ref || $[4] !== rest || $[5] !== sortable ? (t0 = sortable ? /* @__PURE__ */ jsx(SortableListItem, { ref, ...rest }) : /* @__PURE__ */ jsx(ListItem$2, { ref, ...rest }), $[3] = ref, $[4] = rest, $[5] = sortable, $[6] = t0) : t0 = $[6];
  let t1;
  return $[7] !== props2.id || $[8] !== t0 ? (t1 = /* @__PURE__ */ jsx(SortableItemIdContext.Provider, { value: props2.id, children: t0 }), $[7] = props2.id, $[8] = t0, $[9] = t1) : t1 = $[9], t1;
});
function focusRingBorderStyle$2(border) {
  return `inset 0 0 0 ${border.width}px ${border.color}`;
}
function focusRingStyle$1(opts) {
  const {
    base,
    border,
    focusRing
  } = opts, focusRingOutsetWidth = focusRing.offset + focusRing.width, focusRingInsetWidth = 0 - focusRing.offset, bgColor = base ? base.bg : "var(--card-bg-color)";
  return [focusRingInsetWidth > 0 && `inset 0 0 0 ${focusRingInsetWidth}px var(--card-focus-ring-color)`, border && focusRingBorderStyle$2(border), focusRingInsetWidth < 0 && `0 0 0 ${0 - focusRingInsetWidth}px ${bgColor}`, focusRingOutsetWidth > 0 && `0 0 0 ${focusRingOutsetWidth}px var(--card-focus-ring-color)`].filter(Boolean).join(",");
}
function withFocusRing(component) {
  return styled(component)((props2) => {
    const {
      $border,
      $radius
    } = props2, {
      card,
      color,
      radius
    } = getTheme_v2(props2.theme), border = {
      width: $border ? 1 : 0,
      color: "var(--card-border-color)"
    };
    return css`
        --card-focus-box-shadow: ${focusRingBorderStyle$2(border)};

        border-radius: ${rem(radius[$radius ?? 1])};
        outline: none;
        box-shadow: var(--card-focus-box-shadow);

        &:focus {
          --card-focus-box-shadow: ${focusRingStyle$1({
      border,
      base: color,
      focusRing: {
        ...card.focusRing,
        // An offset of 0 is needed to avoid the focus ring overlap the border of the inner items, the theme has an offset of -1
        // Detected in empty array items.
        offset: 0
      }
    })};
        }
      `;
  });
}
function extractPastedFiles(dataTransfer) {
  return dataTransfer.files && dataTransfer.files.length > 0 ? Promise.resolve(Array.from(dataTransfer.files || [])) : normalizeItems$1(Array.from(dataTransfer.items || [])).then(flatten$1);
}
function extractDroppedFiles(dataTransfer) {
  const files = Array.from(dataTransfer.files || []), items = Array.from(dataTransfer.items || []);
  return files && files.length > 0 ? Promise.resolve(files) : normalizeItems$1(items).then(flatten$1);
}
function toArray(v) {
  return v === null ? [] : [v];
}
function normalizeItems$1(items) {
  return Promise.all(items.map((item) => {
    if (item.kind === "file" && item.webkitGetAsEntry) {
      let entry;
      try {
        entry = item.webkitGetAsEntry();
      } catch {
        return toArray(item.getAsFile());
      }
      return entry ? entry.isDirectory ? walk(entry) : toArray(item.getAsFile()) : [];
    }
    if (item.kind === "file") {
      const file = item.getAsFile();
      return Promise.resolve(file ? [file] : []);
    }
    return item.kind === "string" ? (console.warn('DataTransfer with kind="string" is currently not supported'), Promise.resolve([])) : (console.warn("Unknown DataTransferItem.kind: %s", item.kind), Promise.resolve([]));
  }));
}
function walk(entry) {
  if (entry.isFile)
    return new Promise((resolve, reject) => entry.file(resolve, reject)).then((file) => [file]);
  if (entry.isDirectory) {
    const dir = entry.createReader();
    return new Promise((resolve, reject) => dir.readEntries(resolve, reject)).then((entries) => entries.filter((entr) => !entr.name.startsWith("."))).then((entries) => Promise.all(entries.map(walk)).then(flatten$1));
  }
  return Promise.resolve([]);
}
function isPortableTextItem(item) {
  return item.type === "application/portable-text" || item.type === "application/x-portable-text";
}
function imageUrlToBlob(imageUrl, format2 = "image/jpeg", quality = 1) {
  return imageUrl.match(/^webkit-fake-url:\/\//) ? Promise.reject(new Error("Cannot read image contents from webkit fake url")) : new Promise((resolve, reject) => {
    const loader = new Image();
    loader.crossOrigin = "anonymous", loader.referrerPolicy = "strict-origin-when-cross-origin", loader.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = loader.width, canvas.height = loader.height, canvas.getContext("2d")?.drawImage(loader, 0, 0, canvas.width, canvas.height);
      try {
        canvas.toBlob(resolve, format2, quality);
      } catch (error) {
        reject(error);
      }
    }, loader.src = imageUrl;
  });
}
const fileTargetAttributeName = "isFileTarget", fileTargetDataAttribute = {
  "data-is-file-target": "true"
}, isFileTargetElement = (el) => el?.dataset?.[fileTargetAttributeName] === "true", PASTE_INPUT_STYLE = {
  opacity: 0,
  position: "absolute"
};
function fileTarget(Component2) {
  return forwardRef(function(props2, forwardedRef) {
    const $ = c(40);
    let disabled, onFiles, onFilesOut, onFilesOver, rest;
    $[0] !== props2 ? ({
      onFiles,
      onFilesOver,
      onFilesOut,
      disabled,
      ...rest
    } = props2, $[0] = props2, $[1] = disabled, $[2] = onFiles, $[3] = onFilesOut, $[4] = onFilesOver, $[5] = rest) : (disabled = $[1], onFiles = $[2], onFilesOut = $[3], onFilesOver = $[4], rest = $[5]);
    const [showPasteInput, setShowPasteInput] = useState(!1), pasteInput = useRef(null), ref = useRef(null);
    let t0;
    $[6] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => ref.current, $[6] = t0) : t0 = $[6], useImperativeHandle(forwardedRef, t0);
    let t1;
    $[7] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[7] = t1) : t1 = $[7];
    const enteredElements = useRef(t1);
    let t2;
    $[8] !== onFiles ? (t2 = (files) => {
      onFiles?.(files);
    }, $[8] = onFiles, $[9] = t2) : t2 = $[9];
    const emitFiles = t2;
    let t3;
    $[10] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (event) => {
      event.target === ref.current && (event.ctrlKey || event.metaKey) && event.key === "v" && setShowPasteInput(!0);
    }, $[10] = t3) : t3 = $[10];
    const handleKeyDown = t3;
    let t4;
    $[11] !== emitFiles ? (t4 = (event_0) => {
      extractPastedFiles(event_0.clipboardData).then((files_0) => pasteInput.current ? files_0.length > 0 ? files_0 : convertImagesToFilesAndClearContentEditable(pasteInput.current, "image/jpeg") : []).then((files_1) => {
        emitFiles(files_1), setShowPasteInput(!1), ref.current?.focus();
      });
    }, $[11] = emitFiles, $[12] = t4) : t4 = $[12];
    const handlePaste = t4;
    let t5;
    $[13] !== emitFiles || $[14] !== onFiles || $[15] !== onFilesOut ? (t5 = (event_1) => {
      if (enteredElements.current = [], Array.from(event_1.dataTransfer.items).map(_temp$1P).some(_temp2$D))
        return;
      event_1.preventDefault(), event_1.stopPropagation();
      const dataTransfer = event_1.nativeEvent.dataTransfer;
      onFiles && dataTransfer && extractDroppedFiles(dataTransfer).then((files_2) => {
        files_2 && emitFiles(files_2);
      }), onFilesOut?.();
    }, $[13] = emitFiles, $[14] = onFiles, $[15] = onFilesOut, $[16] = t5) : t5 = $[16];
    const handleDrop = t5;
    let t6;
    $[17] !== onFiles ? (t6 = (event_2) => {
      if (onFiles) {
        if (Array.from(event_2.dataTransfer.items).map(_temp3$b).some(_temp4$6))
          return;
        event_2.preventDefault(), event_2.stopPropagation();
      }
    }, $[17] = onFiles, $[18] = t6) : t6 = $[18];
    const handleDragOver = t6;
    let t7;
    $[19] !== onFilesOver ? (t7 = (event_3) => {
      const fileTypes_1 = Array.from(event_3.dataTransfer.items).map(_temp5$3);
      fileTypes_1.some(_temp6$1) || (event_3.stopPropagation(), onFilesOver && ref.current === event_3.currentTarget && (enteredElements.current = [...new Set(enteredElements.current), event_3.currentTarget], onFilesOver(fileTypes_1)));
    }, $[19] = onFilesOver, $[20] = t7) : t7 = $[20];
    const handleDragEnter = t7;
    let t8;
    $[21] !== onFilesOut ? (t8 = (event_4) => {
      if (Array.from(event_4.dataTransfer.items).map(_temp7$1).some(_temp8))
        return;
      event_4.stopPropagation();
      const idx = enteredElements.current.indexOf(event_4.currentTarget);
      idx > -1 && enteredElements.current.splice(idx, 1), enteredElements.current.length === 0 && onFilesOut?.();
    }, $[21] = onFilesOut, $[22] = t8) : t8 = $[22];
    const handleDragLeave = t8, prevShowPasteInput = useRef(!1);
    let t10, t9;
    $[23] !== showPasteInput ? (t9 = () => {
      !prevShowPasteInput.current && showPasteInput && pasteInput.current ? (pasteInput.current.focus(), select(pasteInput.current)) : prevShowPasteInput.current && !showPasteInput && pasteInput.current?.focus(), prevShowPasteInput.current = showPasteInput;
    }, t10 = [showPasteInput], $[23] = showPasteInput, $[24] = t10, $[25] = t9) : (t10 = $[24], t9 = $[25]), useEffect(t9, t10);
    const t11 = rest, t12 = disabled ? void 0 : handleKeyDown, t13 = disabled ? void 0 : handleDragOver, t14 = disabled ? void 0 : handleDragEnter, t15 = disabled ? void 0 : handleDragLeave, t16 = disabled ? void 0 : handleDrop;
    let t17;
    $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15 || $[31] !== t16 ? (t17 = /* @__PURE__ */ jsx(Component2, { ...t11, ref, onKeyDown: t12, onDragOver: t13, onDragEnter: t14, onDragLeave: t15, onDrop: t16, "data-test-id": "file-target", ...fileTargetDataAttribute }), $[26] = t11, $[27] = t12, $[28] = t13, $[29] = t14, $[30] = t15, $[31] = t16, $[32] = t17) : t17 = $[32];
    let t18;
    $[33] !== disabled || $[34] !== handlePaste || $[35] !== showPasteInput ? (t18 = !disabled && showPasteInput && /* @__PURE__ */ jsx("div", { contentEditable: !0, onPaste: handlePaste, ref: pasteInput, style: PASTE_INPUT_STYLE }), $[33] = disabled, $[34] = handlePaste, $[35] = showPasteInput, $[36] = t18) : t18 = $[36];
    let t19;
    return $[37] !== t17 || $[38] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t17,
      t18
    ] }), $[37] = t17, $[38] = t18, $[39] = t19) : t19 = $[39], t19;
  });
}
function convertImagesToFilesAndClearContentEditable(element, targetFormat = "image/jpeg") {
  return element.isContentEditable ? new Promise((resolve) => setTimeout(resolve, 10)).then(() => Array.from(element.querySelectorAll("img"))).then((imageElements) => (element.innerHTML = "", imageElements)).then((images) => Promise.all(images.map((img) => imageUrlToBlob(img.src)))).then((imageBlobs) => imageBlobs.map((blob) => new File([blob], "pasted-image.jpg", {
    type: targetFormat
  }))) : Promise.reject(new Error(`Expected element to be contentEditable="true". Instead found a non contenteditable ${element.tagName}`));
}
function select(el) {
  const range2 = document.createRange();
  range2.selectNodeContents(el);
  const sel = window.getSelection();
  sel?.removeAllRanges(), sel?.addRange(range2);
}
function _temp$1P(item) {
  return {
    type: item.type,
    kind: item.kind
  };
}
function _temp2$D(item_0) {
  return isPortableTextItem(item_0);
}
function _temp3$b(item_1) {
  return {
    type: item_1.type,
    kind: item_1.kind
  };
}
function _temp4$6(item_2) {
  return isPortableTextItem(item_2);
}
function _temp5$3(item_3) {
  return {
    type: item_3.type,
    kind: item_3.kind
  };
}
function _temp6$1(item_4) {
  return isPortableTextItem(item_4);
}
function _temp7$1(item_5) {
  return {
    type: item_5.type,
    kind: item_5.kind
  };
}
function _temp8(item_6) {
  return isPortableTextItem(item_6);
}
function DropMessage(props2) {
  const $ = c(5), {
    hoveringFiles,
    types,
    resolveUploader: resolveUploader2
  } = props2;
  let t0;
  $[0] !== resolveUploader2 || $[1] !== types ? (t0 = (file) => types.some((type) => resolveUploader2(type, file)), $[0] = resolveUploader2, $[1] = types, $[2] = t0) : t0 = $[2];
  const acceptedFiles = hoveringFiles.filter(t0), rejectedFilesCount = hoveringFiles.length - acceptedFiles.length, multiple = types.length > 1, {
    t
  } = useTranslation(), t1 = acceptedFiles.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(UploadIcon, {}) }),
      multiple ? t("inputs.files.common.drop-message.drop-to-upload-multi", {
        count: acceptedFiles.length
      }) : t("inputs.files.common.drop-message.drop-to-upload"),
      /* @__PURE__ */ jsx(Text$1, {})
    ] }),
    rejectedFilesCount > 0 && /* @__PURE__ */ jsx(Box, { marginTop: 4, children: /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(AccessDeniedIcon, {}) }),
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t("inputs.files.common.drop-message.drop-to-upload.rejected-file-message", {
        count: rejectedFilesCount
      }) })
    ] }) })
  ] }) : /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(AccessDeniedIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { children: t("inputs.files.common.drop-message.drop-to-upload.no-accepted-file-message", {
      count: hoveringFiles.length
    }) })
  ] });
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Fragment, { children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
const Overlay$1 = styled(Layer)`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background-color: var(--card-bg-color);
  opacity: 0.8;
`, Root$r = styled.div`
  position: relative;
`;
function getUploadCandidates$1(types, resolveUploader2, file) {
  return types.map((memberType) => ({
    type: memberType,
    uploader: resolveUploader2(memberType, file)
  })).filter((member) => member.uploader);
}
function uploadTarget(Component2) {
  const FileTarget2 = fileTarget(Component2);
  return forwardRef(function(props2, forwardedRef) {
    const $ = c(26);
    let children, onUpload, resolveUploader2, rest, types;
    $[0] !== props2 ? ({
      children,
      resolveUploader: resolveUploader2,
      onUpload,
      types,
      ...rest
    } = props2, $[0] = props2, $[1] = children, $[2] = onUpload, $[3] = resolveUploader2, $[4] = rest, $[5] = types) : (children = $[1], onUpload = $[2], resolveUploader2 = $[3], rest = $[4], types = $[5]);
    const {
      push: pushToast
    } = useToast(), {
      t
    } = useTranslation();
    let t0;
    $[6] !== onUpload ? (t0 = (file, resolvedUploader) => {
      const {
        type,
        uploader
      } = resolvedUploader;
      onUpload?.({
        file,
        schemaType: type,
        uploader
      });
    }, $[6] = onUpload, $[7] = t0) : t0 = $[7];
    const uploadFile2 = t0;
    let t1;
    $[8] !== pushToast || $[9] !== resolveUploader2 || $[10] !== t || $[11] !== types || $[12] !== uploadFile2 ? (t1 = (files) => {
      if (!resolveUploader2)
        return;
      const tasks2 = files.map((file_0) => ({
        file: file_0,
        uploaderCandidates: getUploadCandidates$1(types, resolveUploader2, file_0)
      })), ready = tasks2.filter(_temp$1O), rejected = tasks2.filter(_temp2$C);
      rejected.length > 0 && pushToast({
        closable: !0,
        status: "warning",
        title: t("inputs.array.error.cannot-upload-unable-to-convert", {
          count: rejected.length
        }),
        description: rejected.map(_temp3$a)
      }), ready.forEach((task_2) => {
        uploadFile2(task_2.file, sortBy(task_2.uploaderCandidates, _temp4$5)[0]);
      });
    }, $[8] = pushToast, $[9] = resolveUploader2, $[10] = t, $[11] = types, $[12] = uploadFile2, $[13] = t1) : t1 = $[13];
    const handleFiles = t1;
    let t2;
    $[14] === Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[14] = t2) : t2 = $[14];
    const [hoveringFiles, setHoveringFiles] = useState(t2);
    let t3;
    $[15] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setHoveringFiles([]), $[15] = t3) : t3 = $[15];
    const handleFilesOut = t3;
    let t4;
    $[16] !== hoveringFiles || $[17] !== resolveUploader2 || $[18] !== types ? (t4 = resolveUploader2 && hoveringFiles.length > 0 && /* @__PURE__ */ jsx(Overlay$1, { zOffset: 10, children: /* @__PURE__ */ jsx(DropMessage, { hoveringFiles, types, resolveUploader: resolveUploader2 }) }), $[16] = hoveringFiles, $[17] = resolveUploader2, $[18] = types, $[19] = t4) : t4 = $[19];
    let t5;
    return $[20] !== children || $[21] !== forwardedRef || $[22] !== handleFiles || $[23] !== rest || $[24] !== t4 ? (t5 = /* @__PURE__ */ jsx(Root$r, { children: /* @__PURE__ */ jsxs(FileTarget2, { ...rest, ref: forwardedRef, onFiles: handleFiles, onFilesOver: setHoveringFiles, onFilesOut: handleFilesOut, children: [
      t4,
      children
    ] }) }), $[20] = children, $[21] = forwardedRef, $[22] = handleFiles, $[23] = rest, $[24] = t4, $[25] = t5) : t5 = $[25], t5;
  });
}
function _temp$1O(task) {
  return task.uploaderCandidates.length > 0;
}
function _temp2$C(task_0) {
  return task_0.uploaderCandidates.length === 0;
}
function _temp3$a(task_1, i) {
  return /* @__PURE__ */ jsxs(Flex, { gap: 2, padding: 2, children: [
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: task_1.file.name }) }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
      "(",
      task_1.file.type,
      ")"
    ] }) })
  ] }, i);
}
function _temp4$5(candidate) {
  return candidate.uploader.priority;
}
const StyledCard$3 = styled(Card)`
  height: 100%;
`, UploadTargetCard = withFocusRing(uploadTarget(StyledCard$3));
function popoverReducer(state, event) {
  return event.type === "toggle" ? {
    open: !state.open
  } : {
    open: !1
  };
}
function useInsertMenuPopover(props2) {
  const $ = c(22);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    open: !1
  }, $[0] = t0) : t0 = $[0];
  const [state, send] = useReducer(popoverReducer, t0), popoverRef = useRef(null), referenceElement = props2.popoverProps.referenceElement ?? null;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => send({
    type: "close"
  }), $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== referenceElement ? (t2 = () => [popoverRef.current, referenceElement], $[2] = referenceElement, $[3] = t2) : t2 = $[3], useClickOutsideEvent(t1, t2);
  let t3;
  $[4] !== referenceElement || $[5] !== state.open ? (t3 = (event) => {
    event.key === "Escape" && state.open && (send({
      type: "close"
    }), referenceElement?.focus());
  }, $[4] = referenceElement, $[5] = state.open, $[6] = t3) : t3 = $[6], useGlobalKeyDown(t3);
  let insertMenuProps, onSelect;
  $[7] !== props2.insertMenuProps ? ({
    onSelect,
    ...insertMenuProps
  } = props2.insertMenuProps, $[7] = props2.insertMenuProps, $[8] = insertMenuProps, $[9] = onSelect) : (insertMenuProps = $[8], onSelect = $[9]);
  let t4;
  $[10] !== onSelect ? (t4 = (schemaType) => {
    onSelect(schemaType), send({
      type: "close"
    });
  }, $[10] = onSelect, $[11] = t4) : t4 = $[11];
  const handleOnSelect = t4;
  let t5, t6;
  $[12] !== handleOnSelect || $[13] !== insertMenuProps ? (t6 = /* @__PURE__ */ jsx(InsertMenu$1, { ...insertMenuProps, onSelect: handleOnSelect }), $[12] = handleOnSelect, $[13] = insertMenuProps, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== props2.popoverProps || $[16] !== state.open || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsx(Popover, { ref: popoverRef, open: state.open, constrainSize: !0, overflow: "hidden", portal: !0, content: t6, ...props2.popoverProps }), $[15] = props2.popoverProps, $[16] = state.open, $[17] = t6, $[18] = t7) : t7 = $[18], t5 = t7;
  const popover = t5;
  let t8;
  return $[19] !== popover || $[20] !== state ? (t8 = {
    popover,
    state,
    send
  }, $[19] = popover, $[20] = state, $[21] = t8) : t8 = $[21], t8;
}
function InsertMenu$1(props2) {
  const $ = c(19), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("inputs.array.insert-menu.filter.all-items"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t ? (t1 = t("inputs.array.insert-menu.search.no-results"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t ? (t2 = t("inputs.array.insert-menu.search.placeholder"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t ? (t3 = t("inputs.array.insert-menu.toggle-grid-view.tooltip"), $[6] = t, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t ? (t4 = t("inputs.array.insert-menu.toggle-list-view.tooltip"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 ? (t5 = {
    "insert-menu.filter.all-items": t0,
    "insert-menu.search.no-results": t1,
    "insert-menu.search.placeholder": t2,
    "insert-menu.toggle-grid-view.tooltip": t3,
    "insert-menu.toggle-list-view.tooltip": t4
  }, $[10] = t0, $[11] = t1, $[12] = t2, $[13] = t3, $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  return $[16] !== props2 || $[17] !== t5 ? (t6 = /* @__PURE__ */ jsx(InsertMenu$2, { ...props2, labels: t5 }), $[16] = props2, $[17] = t5, $[18] = t6) : t6 = $[18], t6;
}
function ArrayOfObjectsFunctions(props2) {
  const $ = c(41), {
    schemaType,
    readOnly,
    children,
    onValueCreate,
    onItemAppend
  } = props2, {
    t
  } = useTranslation(), [gridElement, setGridElement] = useState(null), [popoverToggleElement, setPopoverToggleElement] = useState(null);
  let t0;
  $[0] !== onItemAppend || $[1] !== onValueCreate ? (t0 = (itemType) => {
    const item = onValueCreate(itemType);
    onItemAppend(item);
  }, $[0] = onItemAppend, $[1] = onValueCreate, $[2] = t0) : t0 = $[2];
  const insertItem = t0;
  let t1;
  $[3] !== insertItem || $[4] !== schemaType.of[0] ? (t1 = () => {
    insertItem(schemaType.of[0]);
  }, $[3] = insertItem, $[4] = schemaType.of[0], $[5] = t1) : t1 = $[5];
  const handleAddBtnClick = t1, addItemI18nKey = schemaType.of.length > 1 ? "inputs.array.action.add-item-select-type" : "inputs.array.action.add-item";
  let t2;
  $[6] !== addItemI18nKey || $[7] !== t ? (t2 = t(addItemI18nKey), $[6] = addItemI18nKey, $[7] = t, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = {
    icon: AddIcon,
    mode: "ghost",
    size: "large",
    text: t2
  }, $[9] = t2, $[10] = t3) : t3 = $[10];
  const insertButtonProps = t3, t4 = props2.schemaType.options?.insertMenu;
  let t5;
  $[11] !== insertItem || $[12] !== props2.schemaType.of || $[13] !== t4 ? (t5 = {
    ...t4,
    schemaTypes: props2.schemaType.of,
    onSelect: insertItem
  }, $[11] = insertItem, $[12] = props2.schemaType.of, $[13] = t4, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] === Symbol.for("react.memo_cache_sentinel") ? (t6 = ["top"], $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== props2.schemaType.options?.insertMenu?.views ? (t7 = props2.schemaType.options?.insertMenu?.views?.some(_temp$1N), $[16] = props2.schemaType.options?.insertMenu?.views, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== gridElement || $[19] !== popoverToggleElement || $[20] !== t7 ? (t8 = {
    placement: "bottom",
    fallbackPlacements: t6,
    matchReferenceWidth: t7,
    referenceBoundary: gridElement,
    referenceElement: popoverToggleElement
  }, $[18] = gridElement, $[19] = popoverToggleElement, $[20] = t7, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] !== t5 || $[23] !== t8 ? (t9 = {
    insertMenuProps: t5,
    popoverProps: t8
  }, $[22] = t5, $[23] = t8, $[24] = t9) : t9 = $[24];
  const insertMenu = useInsertMenuPopover(t9);
  if (schemaType.options?.disableActions?.includes("add"))
    return null;
  if (readOnly) {
    let t102;
    $[25] !== t ? (t102 = t("inputs.array.read-only-label"), $[25] = t, $[26] = t102) : t102 = $[26];
    let t112;
    $[27] !== insertButtonProps ? (t112 = /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(Button, { ...insertButtonProps, "data-testid": "add-read-object-button", disabled: !0 }) }), $[27] = insertButtonProps, $[28] = t112) : t112 = $[28];
    let t122;
    return $[29] !== t102 || $[30] !== t112 ? (t122 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t102, children: t112 }), $[29] = t102, $[30] = t112, $[31] = t122) : t122 = $[31], t122;
  }
  let t10;
  $[32] === Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))"
  }, $[32] = t10) : t10 = $[32];
  let t11;
  $[33] !== handleAddBtnClick || $[34] !== insertButtonProps || $[35] !== insertMenu || $[36] !== schemaType.of.length ? (t11 = schemaType.of.length === 1 ? /* @__PURE__ */ jsx(Button, { ...insertButtonProps, onClick: handleAddBtnClick, "data-testid": "add-single-object-button" }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Button, { ...insertButtonProps, "data-testid": "add-multiple-object-button", selected: insertMenu.state.open, onClick: () => {
      insertMenu.send({
        type: "toggle"
      });
    }, ref: setPopoverToggleElement }),
    insertMenu.popover
  ] }), $[33] = handleAddBtnClick, $[34] = insertButtonProps, $[35] = insertMenu, $[36] = schemaType.of.length, $[37] = t11) : t11 = $[37];
  let t12;
  return $[38] !== children || $[39] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Grid, { ref: setGridElement, gap: 1, style: t10, children: [
    t11,
    children
  ] }), $[38] = children, $[39] = t11, $[40] = t12) : t12 = $[40], t12;
}
function _temp$1N(view) {
  return view.name === "grid";
}
const DragHandleButton = styled(Button)((props2) => {
  const {
    $grid,
    disabled
  } = props2;
  return disabled ? css`` : css`
    cursor: ${$grid ? "move" : "ns-resize"};
  `;
}), DragHandle = function(props2) {
  const $ = c(20), id2 = useContext(SortableItemIdContext);
  let readOnly, rest, t0;
  $[0] !== props2 ? ({
    mode: t0,
    readOnly,
    ...rest
  } = props2, $[0] = props2, $[1] = readOnly, $[2] = rest, $[3] = t0) : (readOnly = $[1], rest = $[2], t0 = $[3]);
  const mode = t0 === void 0 ? "bleed" : t0;
  let t1;
  $[4] !== id2 || $[5] !== readOnly ? (t1 = {
    id: id2,
    disabled: readOnly
  }, $[4] = id2, $[5] = readOnly, $[6] = t1) : t1 = $[6];
  const {
    listeners,
    attributes
  } = useSortable(t1), {
    t
  } = useTranslation();
  let t2;
  $[7] !== t ? (t2 = t("inputs.array.action.drag.tooltip"), $[7] = t, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    open: 1e3
  }, $[9] = t3) : t3 = $[9];
  const t4 = !!readOnly;
  let t5;
  $[10] !== t2 || $[11] !== t4 ? (t5 = {
    content: t2,
    delay: t3,
    disabled: t4
  }, $[10] = t2, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  return $[13] !== attributes || $[14] !== listeners || $[15] !== mode || $[16] !== readOnly || $[17] !== rest || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(DragHandleButton, { icon: DragHandleIcon, tooltipProps: t5, mode, "data-ui": "DragHandleButton", ...rest, ...attributes, ...listeners, disabled: readOnly }), $[13] = attributes, $[14] = listeners, $[15] = mode, $[16] = readOnly, $[17] = rest, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}, FooterFlex = styled(Flex)`
  min-height: 33px;
`, PresenceFlex = styled(Flex)`
  position: absolute;
  top: 0;
  right: 0;
  height: 33px;
`, DragHandleCard = styled(Card)`
  position: absolute;
  top: 0;
  left: 0;
`, Root$q = styled(Card)`
  transition: border-color 250ms;
  box-sizing: border-box;
  position: relative;

  @media (hover: hover) {
    ${DragHandleCard} {
      opacity: 0;
    }

    &:hover,
    &:focus-within {
      ${DragHandleCard} {
        opacity: 1;
      }
    }
  }

  .${MOVING_ITEM_CLASS_NAME} & {
    box-shadow:
      0 0 0 0,
      0 8px 17px 2px var(--card-shadow-umbra-color),
      0 3px 14px 2px var(--card-shadow-penumbra-color),
      0 5px 5px -3px var(--card-shadow-ambient-color);
  }

  &[aria-selected='true'] {
    box-shadow: 0 0 0 2px var(--card-focus-ring-color);
  }
`;
function CellLayout(props2) {
  const $ = c(32);
  let children, dragHandle, footer, menu, presence, readOnly, rest, selected, tone, validation2;
  $[0] !== props2 ? ({
    validation: validation2,
    selected,
    tone,
    presence,
    children,
    dragHandle,
    menu,
    footer,
    readOnly,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = dragHandle, $[3] = footer, $[4] = menu, $[5] = presence, $[6] = readOnly, $[7] = rest, $[8] = selected, $[9] = tone, $[10] = validation2) : (children = $[1], dragHandle = $[2], footer = $[3], menu = $[4], presence = $[5], readOnly = $[6], rest = $[7], selected = $[8], tone = $[9], validation2 = $[10]);
  let t0;
  $[11] !== dragHandle || $[12] !== readOnly ? (t0 = dragHandle && /* @__PURE__ */ jsx(DragHandleCard, { margin: 1, radius: 2, display: "flex", tone: "inherit", "data-ui": "DragHandleCard", children: /* @__PURE__ */ jsx(DragHandle, { $grid: !0, mode: "ghost", readOnly: !!readOnly }) }), $[11] = dragHandle, $[12] = readOnly, $[13] = t0) : t0 = $[13];
  let t1;
  $[14] !== presence ? (t1 = presence && /* @__PURE__ */ jsx(PresenceFlex, { align: "center", marginX: 1, children: presence }), $[14] = presence, $[15] = t1) : t1 = $[15];
  let t2;
  $[16] !== validation2 ? (t2 = /* @__PURE__ */ jsx(Flex, { children: validation2 }), $[16] = validation2, $[17] = t2) : t2 = $[17];
  let t3;
  $[18] !== footer ? (t3 = /* @__PURE__ */ jsx(Box, { children: footer }), $[18] = footer, $[19] = t3) : t3 = $[19];
  let t4;
  $[20] !== menu || $[21] !== t2 || $[22] !== t3 ? (t4 = /* @__PURE__ */ jsxs(FooterFlex, { align: "center", paddingX: 1, sizing: "border", justify: "space-between", children: [
    t2,
    t3,
    menu
  ] }), $[20] = menu, $[21] = t2, $[22] = t3, $[23] = t4) : t4 = $[23];
  let t5;
  return $[24] !== children || $[25] !== rest || $[26] !== selected || $[27] !== t0 || $[28] !== t1 || $[29] !== t4 || $[30] !== tone ? (t5 = /* @__PURE__ */ jsxs(Root$q, { forwardedAs: Flex, direction: "column", border: !0, selected, "aria-selected": selected, radius: 1, tone, ...rest, children: [
    children,
    t0,
    t1,
    t4
  ] }), $[24] = children, $[25] = rest, $[26] = selected, $[27] = t0, $[28] = t1, $[29] = t4, $[30] = tone, $[31] = t5) : t5 = $[31], t5;
}
const PopoverCard$1 = styled(Card)`
  max-width: ${({
  theme
}) => theme.sanity.container[1]}px;
`;
function IncompatibleItemType$1(props2) {
  const $ = c(55);
  let onFocus, rest, value;
  if ($[0] !== props2) {
    const {
      value: t02,
      onFocus: t110,
      vertical,
      ...t24
    } = props2;
    value = t02, onFocus = t110, rest = t24, $[0] = props2, $[1] = onFocus, $[2] = rest, $[3] = value;
  } else
    onFocus = $[1], rest = $[2], value = $[3];
  const [showDetails, setShowDetails] = useState(!1), popoverRef = useRef(null), {
    t
  } = useTranslation();
  let t0, t1;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setShowDetails(!1), t1 = () => [popoverRef.current], $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useClickOutsideEvent(t0, t1);
  let t2;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => {
    (e.key === "Escape" || e.key === "Tab") && setShowDetails(!1);
  }, $[6] = t2) : t2 = $[6];
  const handleKeyDown = t2;
  let t3;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowDetails(_temp$1M);
  }, $[7] = t3) : t3 = $[7];
  const handleShowDetails = t3;
  let t4;
  $[8] !== value ? (t4 = resolveTypeName$2(value), $[8] = value, $[9] = t4) : t4 = $[9];
  const typeName = t4;
  let t5;
  $[10] !== t ? (t5 = t("inputs.array.error.type-is-incompatible-title"), $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: t5 }) }), $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== typeName ? (t7 = {
    typeName
  }, $[14] = typeName, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.current-schema-not-declare-description", values: t7 }) }), $[16] = t, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] === Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(BulbOutlineIcon, {}), $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== t ? (t10 = t("inputs.array.error.can-delete-but-no-edit-description"), $[20] = t, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== t10 ? (t11 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t9,
    " ",
    t10
  ] }) }), $[22] = t10, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== t ? (t12 = t("inputs.array.error.json-representation-description"), $[24] = t, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t12 ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t12 }), $[26] = t12, $[27] = t13) : t13 = $[27];
  let t14;
  $[28] !== value ? (t14 = JSON.stringify(value, null, 2), $[28] = value, $[29] = t14) : t14 = $[29];
  let t15;
  $[30] !== t14 ? (t15 = /* @__PURE__ */ jsx(Card, { padding: 2, overflow: "auto", border: !0, children: /* @__PURE__ */ jsx(Code, { size: 1, as: "pre", language: "json", children: t14 }) }), $[30] = t14, $[31] = t15) : t15 = $[31];
  let t16;
  $[32] !== t13 || $[33] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t13,
    t15
  ] }), $[32] = t13, $[33] = t15, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== t11 || $[36] !== t16 || $[37] !== t6 || $[38] !== t8 ? (t17 = /* @__PURE__ */ jsx(PopoverCard$1, { margin: 1, padding: 3, onKeyDown: handleKeyDown, tabIndex: 0, overflow: "auto", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t6,
    t8,
    t11,
    t16
  ] }) }), $[35] = t11, $[36] = t16, $[37] = t6, $[38] = t8, $[39] = t17) : t17 = $[39];
  let t18;
  $[40] === Symbol.for("react.memo_cache_sentinel") ? (t18 = {
    height: "100%"
  }, $[40] = t18) : t18 = $[40];
  let t19;
  $[41] === Symbol.for("react.memo_cache_sentinel") ? (t19 = /* @__PURE__ */ jsx(Box, { margin: 1, children: /* @__PURE__ */ jsx(Text$1, { align: "center", size: 4, children: /* @__PURE__ */ jsx(UnknownIcon, {}) }) }), $[41] = t19) : t19 = $[41];
  let t20;
  $[42] !== typeName ? (t20 = {
    typeName
  }, $[42] = typeName, $[43] = t20) : t20 = $[43];
  let t21;
  $[44] !== t || $[45] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Stack, { space: 4, marginTop: 2, children: [
    t19,
    /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.type-is-incompatible-prompt", values: t20 }) })
  ] }), $[44] = t, $[45] = t20, $[46] = t21) : t21 = $[46];
  let t22;
  $[47] !== onFocus || $[48] !== rest || $[49] !== t21 ? (t22 = /* @__PURE__ */ jsx(Card, { as: "button", type: "button", radius: 2, tone: "inherit", paddingX: 2, paddingY: 3, style: t18, onFocus, onClick: handleShowDetails, onKeyDown: handleKeyDown, __unstable_focusRing: !0, ...rest, children: t21 }), $[47] = onFocus, $[48] = rest, $[49] = t21, $[50] = t22) : t22 = $[50];
  let t23;
  return $[51] !== showDetails || $[52] !== t17 || $[53] !== t22 ? (t23 = /* @__PURE__ */ jsx(Popover, { open: showDetails, ref: popoverRef, onKeyDown: handleKeyDown, portal: !0, constrainSize: !0, tone: "default", content: t17, children: t22 }), $[51] = showDetails, $[52] = t17, $[53] = t22, $[54] = t23) : t23 = $[54], t23;
}
function _temp$1M(v) {
  return !v;
}
const MENU_POPOVER_PROPS$8 = {
  portal: !0,
  tone: "default"
};
function ErrorItem$1(props2) {
  const $ = c(22), {
    member,
    sortable,
    readOnly
  } = props2, id2 = useId(), {
    onChange
  } = useFormCallbacks(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== member.key || $[1] !== onChange ? (t0 = () => {
    onChange(PatchEvent.from([unset([{
      _key: member.key
    }])]));
  }, $[0] = member.key, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleRemove = t0;
  let t1;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    height: "100%"
  }, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[4] = t2) : t2 = $[4];
  const t3 = `${id2}-menuButton`;
  let t4;
  $[5] !== t ? (t4 = t("inputs.array.action.remove-invalid-item"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== handleRemove || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsx(MenuItem$1, { text: t4, tone: "critical", icon: TrashIcon, onClick: handleRemove }) }), $[7] = handleRemove, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t3 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuButton$1, { button: t2, id: t3, menu: t5, popover: MENU_POPOVER_PROPS$8 }), $[10] = t3, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== member.error.type || $[14] !== member.error.value || $[15] !== t ? (t7 = member.error.type === "INVALID_ITEM_TYPE" ? /* @__PURE__ */ jsx(IncompatibleItemType$1, { value: member.error.value, vertical: !0 }) : /* @__PURE__ */ jsx("div", { children: t("inputs.array.error.unexpected-error", {
    error: member.error.type
  }) }), $[13] = member.error.type, $[14] = member.error.value, $[15] = t, $[16] = t7) : t7 = $[16];
  let t8;
  return $[17] !== readOnly || $[18] !== sortable || $[19] !== t6 || $[20] !== t7 ? (t8 = /* @__PURE__ */ jsx(CellLayout, { dragHandle: sortable, readOnly, tone: "caution", style: t1, menu: t6, children: t7 }), $[17] = readOnly, $[18] = sortable, $[19] = t6, $[20] = t7, $[21] = t8) : t8 = $[21], t8;
}
const isError$2 = (problem) => problem.severity === "error", builtinSchema = Schema.compile({
  name: "studio",
  types: builtinTypes
});
inferFromSchema(builtinSchema);
function createSchema(schemaDef) {
  const validated = validateSchema(schemaDef.types).getTypes(), validation2 = groupProblems(validated), hasErrors = validation2.some((group2) => group2.problems.some(isError$2)), compiled = Schema.compile({
    name: schemaDef.name,
    types: hasErrors ? [] : schemaDef.types.filter(Boolean),
    parent: builtinSchema
  });
  return compiled._validation = validation2, inferFromSchema(compiled);
}
function getSchemaTypeTitle(type) {
  return typeof type.title == "string" ? type.title : type.type ? getSchemaTypeTitle(type.type) : type.name || type.jsonType;
}
function flattenItems(items) {
  return items.reduce((acc, item) => item?.children ? [...acc, item, ...flattenItems(item.children)] : [...acc, item], []).map(({
    children,
    ...item
  }) => item);
}
function treeEditingSearch(items, query) {
  const flattenItemsList = flattenItems(items), deburredQuery = deburr(query).toLocaleLowerCase();
  return flattenItemsList?.filter((option) => deburr(option.title || "").toLocaleLowerCase().includes(deburredQuery))?.sort((a, b) => {
    const matchA = a.title?.startsWith(deburredQuery), matchB = b.title?.startsWith(deburredQuery);
    return matchA && !matchB ? -1 : !matchA && matchB ? 1 : 0;
  });
}
function useSearchableList(items) {
  const $ = c(8);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [searchableList, setSearchableList] = useState(t0), {
    observeForPreview
  } = useDocumentPreviewStore();
  let t1, t2;
  $[1] !== items ? (t2 = flattenItems(items), $[1] = items, $[2] = t2) : t2 = $[2], t1 = t2;
  const flatList = t1;
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (item) => {
    const path = item.path;
    setSearchableList((prev) => prev.some((prevItem) => isEqual$2(prevItem.path, path)) ? prev.map((prevItem_0) => isEqual$2(prevItem_0.path, path) ? {
      ...item,
      title: item?.title
    } : prevItem_0) : prev.concat(item));
  }, $[3] = t3) : t3 = $[3];
  const handleResult = t3;
  let t4, t5;
  return $[4] !== flatList || $[5] !== observeForPreview ? (t4 = () => {
    setSearchableList([]), flatList.forEach((item_0) => {
      observeForPreview(item_0.value, item_0.schemaType).pipe(map$1((event) => ({
        ...item_0,
        title: event.snapshot?.title
      }))).subscribe(handleResult).unsubscribe();
    });
  }, t5 = [flatList, handleResult, observeForPreview], $[4] = flatList, $[5] = observeForPreview, $[6] = t4, $[7] = t5) : (t4 = $[6], t5 = $[7]), useEffect(t4, t5), searchableList;
}
function useValuePreviewWithFallback(props2) {
  const $ = c(11), preview = useDocumentPreview(props2), {
    t
  } = useTranslation();
  let t0, t1;
  $[0] !== preview?.value ? (t1 = preview?.value || {}, $[0] = preview?.value, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== preview?.value?.title || $[3] !== t ? (t2 = preview?.value?.title || t("preview.default.title-fallback"), $[2] = preview?.value?.title, $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t1 || $[6] !== t2 ? (t3 = {
    ...t1,
    title: t2
  }, $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== preview || $[9] !== t3 ? (t4 = {
    ...preview,
    value: t3
  }, $[8] = preview, $[9] = t3, $[10] = t4) : t4 = $[10], t0 = t4, t0;
}
const ITEM_HEIGHT$2 = 33, MAX_DISPLAYED_ITEMS$2 = 50;
function BreadcrumbsItem(props2) {
  const $ = c(24), {
    item,
    onPathSelect,
    selected,
    isFirst,
    renderMenuItemTitle
  } = props2;
  let t0;
  $[0] !== item.schemaType || $[1] !== item.value ? (t0 = {
    schemaType: item.schemaType,
    value: item.value
  }, $[0] = item.schemaType, $[1] = item.value, $[2] = t0) : t0 = $[2];
  const {
    value
  } = useValuePreviewWithFallback(t0), {
    title
  } = value, t1 = isFirst ? void 0 : 1;
  let t2;
  $[3] !== item.path || $[4] !== onPathSelect ? (t2 = () => onPathSelect(item.path), $[3] = item.path, $[4] = onPathSelect, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== renderMenuItemTitle || $[7] !== value ? (t3 = renderMenuItemTitle(value), $[6] = renderMenuItemTitle, $[7] = value, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Flex, { flex: 1, children: t3 }), $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== selected ? (t5 = selected && /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(CheckmarkIcon, {}) }), $[11] = selected, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== t4 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, justify: "space-between", children: [
    t4,
    t5
  ] }), $[13] = t4, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== selected || $[17] !== t2 || $[18] !== t6 || $[19] !== title ? (t7 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", onClick: t2, selected, title, padding: 2, children: t6 }), $[16] = selected, $[17] = t2, $[18] = t6, $[19] = title, $[20] = t7) : t7 = $[20];
  let t8;
  return $[21] !== t1 || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Stack, { marginTop: t1, children: t7 }), $[21] = t1, $[22] = t7, $[23] = t8) : t8 = $[23], t8;
}
function TreeEditingBreadcrumbsMenu(props2) {
  const $ = c(17), {
    items,
    onPathSelect,
    selectedPath,
    collapsed: t0
  } = props2, collapsed = t0 === void 0 ? !1 : t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== items || $[1] !== selectedPath ? (t1 = (index) => {
    const item = items[index];
    return isEqual$2(item.path, selectedPath);
  }, $[0] = items, $[1] = selectedPath, $[2] = t1) : t1 = $[2];
  const getItemDisabled = t1;
  let t2;
  $[3] !== collapsed ? (t2 = (value) => {
    const {
      title,
      media
    } = value;
    return collapsed ? /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: "/" }),
      /* @__PURE__ */ jsx(SanityDefaultPreview, { title, media, layout: "inline" })
    ] }) : /* @__PURE__ */ jsx(SanityDefaultPreview, { title, media, layout: "inline" });
  }, $[3] = collapsed, $[4] = t2) : t2 = $[4];
  const handleRenderMenuItemTitle = t2;
  let t3;
  $[5] !== handleRenderMenuItemTitle || $[6] !== items[0].path || $[7] !== onPathSelect || $[8] !== selectedPath ? (t3 = (item_0) => {
    const selected = isEqual$2(item_0.path, selectedPath), isFirst = isEqual$2(item_0.path, items[0].path);
    return /* @__PURE__ */ jsx(BreadcrumbsItem, { isFirst, item: item_0, onPathSelect, renderMenuItemTitle: handleRenderMenuItemTitle, selected });
  }, $[5] = handleRenderMenuItemTitle, $[6] = items[0].path, $[7] = onPathSelect, $[8] = selectedPath, $[9] = t3) : t3 = $[9];
  const renderItem2 = t3;
  let t4;
  $[10] !== t ? (t4 = t("tree-editing-dialog.breadcrumbs.menu"), $[10] = t, $[11] = t4) : t4 = $[11];
  let t5;
  return $[12] !== getItemDisabled || $[13] !== items || $[14] !== renderItem2 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t4, autoFocus: supportsTouch ? void 0 : "input", "data-testid": "tree-editing-breadcrumbs-menu", getItemDisabled, itemHeight: ITEM_HEIGHT$2, items, overscan: 5, padding: 1, renderItem: renderItem2 }), $[12] = getItemDisabled, $[13] = items, $[14] = renderItem2, $[15] = t4, $[16] = t5) : t5 = $[16], t5;
}
const POPOVER_FALLBACK_PLACEMENTS$7 = ["bottom-start"], RootFlex$6 = styled(Flex)``, TitleCard = styled(Card)`
  min-height: max-content;
`, PopoverListFlex$2 = styled(Flex)((props2) => {
  const {
    $maxDisplayedItems,
    $itemHeight
  } = props2;
  return css`
    --item-height: ${$itemHeight}px;
    --max-items: ${$maxDisplayedItems};
    --list-padding: 0.5rem;

    position: relative;
    max-height: calc(var(--item-height) * var(--max-items) + var(--list-padding));
    min-height: calc((var(--item-height) * 1));
  `;
}), StyledPopover$7 = styled(Popover)(() => css`
    [data-ui='Popover__wrapper'] {
      width: 250px;
      display: flex;
      flex-direction: column;
      border-radius: ${({
  theme
}) => theme.sanity.radius[3]}px;
      position: relative;
      overflow: hidden;
      overflow: clip;
    }
  `);
function TreeEditingBreadcrumbsMenuButton(props2) {
  const $ = c(32), {
    button,
    collapsed: t0,
    items,
    menuTitle,
    onPathSelect,
    parentElement,
    selectedPath
  } = props2, collapsed = t0 === void 0 ? !1 : t0, [open, setOpen] = useState(!1), rootElementRef = useRef(null), [buttonElement, setButtonElement] = useState(null);
  let t1;
  $[0] !== buttonElement || $[1] !== open ? (t1 = () => {
    open && (setOpen(!1), buttonElement?.focus());
  }, $[0] = buttonElement, $[1] = open, $[2] = t1) : t1 = $[2];
  const closeAndFocus = t1;
  let t2;
  $[3] !== closeAndFocus ? (t2 = (event) => {
    const {
      key,
      shiftKey
    } = event;
    (shiftKey && key === "Tab" || key === "Escape" || key === "Tab") && closeAndFocus();
  }, $[3] = closeAndFocus, $[4] = t2) : t2 = $[4];
  const handlePopoverKeyDown = t2;
  let t3;
  $[5] !== open ? (t3 = () => {
    setOpen(!open);
  }, $[5] = open, $[6] = t3) : t3 = $[6];
  const handleButtonClick = t3;
  let t4;
  $[7] !== onPathSelect ? (t4 = (path) => {
    onPathSelect(path), setOpen(!1);
  }, $[7] = onPathSelect, $[8] = t4) : t4 = $[8];
  const handlePathSelect = t4;
  let t5;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => setOpen(!1), $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== buttonElement ? (t6 = () => [rootElementRef.current, buttonElement], $[10] = buttonElement, $[11] = t6) : t6 = $[11], useClickOutsideEvent(t5, t6);
  let t7;
  $[12] !== menuTitle ? (t7 = menuTitle && /* @__PURE__ */ jsx(TitleCard, { borderBottom: !0, padding: 3, sizing: "border", children: /* @__PURE__ */ jsx(Box, { paddingX: 1, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", weight: "semibold", title: menuTitle, children: menuTitle }) }) }), $[12] = menuTitle, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== collapsed || $[15] !== handlePathSelect || $[16] !== items || $[17] !== selectedPath ? (t8 = /* @__PURE__ */ jsx(TreeEditingBreadcrumbsMenu, { collapsed, items, onPathSelect: handlePathSelect, selectedPath }), $[14] = collapsed, $[15] = handlePathSelect, $[16] = items, $[17] = selectedPath, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t7 || $[20] !== t8 ? (t9 = /* @__PURE__ */ jsx(RootFlex$6, { direction: "column", flex: 1, forwardedAs: FocusLock, height: "fill", returnFocus: !0, children: /* @__PURE__ */ jsxs(PopoverListFlex$2, { $itemHeight: ITEM_HEIGHT$2, $maxDisplayedItems: MAX_DISPLAYED_ITEMS$2, direction: "column", overflow: "hidden", children: [
    t7,
    t8
  ] }) }), $[19] = t7, $[20] = t8, $[21] = t9) : t9 = $[21];
  const content = t9;
  let t10;
  $[22] !== button || $[23] !== handleButtonClick || $[24] !== open ? (t10 = cloneElement(button, {
    "aria-expanded": open,
    "aria-haspopup": "true",
    "data-testid": "tree-editing-breadcrumb-menu-button",
    id: "tree-breadcrumb-menu-button",
    onClick: handleButtonClick,
    ref: setButtonElement,
    selected: open
  }), $[22] = button, $[23] = handleButtonClick, $[24] = open, $[25] = t10) : t10 = $[25];
  const clonedButton = t10;
  let t11;
  return $[26] !== clonedButton || $[27] !== content || $[28] !== handlePopoverKeyDown || $[29] !== open || $[30] !== parentElement ? (t11 = /* @__PURE__ */ jsx(StyledPopover$7, { constrainSize: !0, content, "data-testid": "tree-editing-breadcrumbs-menu-popover", fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$7, onKeyDown: handlePopoverKeyDown, open, placement: "bottom-start", portal: !0, ref: rootElementRef, referenceBoundary: parentElement, children: clonedButton }), $[26] = clonedButton, $[27] = content, $[28] = handlePopoverKeyDown, $[29] = open, $[30] = parentElement, $[31] = t11) : t11 = $[31], t11;
}
const MAX_LENGTH = 5, EMPTY_ARRAY$n = [], SEPARATOR = "/", StyledButton$3 = styled(Button$1)(({
  theme
}) => {
  const {
    bold
  } = getTheme_v2(theme)?.font.text?.weights || {};
  return css`
    max-height: 1rem;
    overflow: hidden;
    min-width: 2ch;

    &[data-active='true'] {
      [data-ui='Text']:first-child {
        font-weight: ${bold};
      }
    }
  `;
}), StyledText$5 = styled(Text$1)`
  overflow: hidden;
  padding: 8px 0;
`, MenuButton = forwardRef(function(props2, ref) {
  const $ = c(26);
  let isSelected, item, onPathSelect, rest;
  $[0] !== props2 ? ({
    item,
    onPathSelect,
    isSelected,
    ...rest
  } = props2, $[0] = props2, $[1] = isSelected, $[2] = item, $[3] = onPathSelect, $[4] = rest) : (isSelected = $[1], item = $[2], onPathSelect = $[3], rest = $[4]);
  let t0;
  $[5] !== item.schemaType || $[6] !== item.value ? (t0 = {
    schemaType: item.schemaType,
    value: item.value
  }, $[5] = item.schemaType, $[6] = item.value, $[7] = t0) : t0 = $[7];
  const {
    value
  } = useValuePreviewWithFallback(t0), title = value.title, hasChildren = item.children && item.children?.length > 1, t1 = isSelected ? "true" : "false";
  let t2;
  $[8] !== item.path || $[9] !== onPathSelect ? (t2 = () => onPathSelect(item.path), $[8] = item.path, $[9] = onPathSelect, $[10] = t2) : t2 = $[10];
  let t3;
  $[11] !== title || $[12] !== value.media ? (t3 = /* @__PURE__ */ jsx(SanityDefaultPreview, { title, media: value.media, layout: "inline" }), $[11] = title, $[12] = value.media, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== hasChildren ? (t4 = hasChildren && /* @__PURE__ */ jsx(Text$1, { size: 0, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }), $[14] = hasChildren, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== t3 || $[17] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { flex: 1, align: "center", justify: "flex-start", gap: 1, overflow: "hidden", children: [
    t3,
    t4
  ] }), $[16] = t3, $[17] = t4, $[18] = t5) : t5 = $[18];
  let t6;
  return $[19] !== ref || $[20] !== rest || $[21] !== t1 || $[22] !== t2 || $[23] !== t5 || $[24] !== title ? (t6 = /* @__PURE__ */ jsx(StyledButton$3, { "data-active": t1, mode: "bleed", onClick: t2, padding: 1, ref, space: 2, title, ...rest, children: t5 }), $[19] = ref, $[20] = rest, $[21] = t1, $[22] = t2, $[23] = t5, $[24] = title, $[25] = t6) : t6 = $[25], t6;
}), SeparatorItem = forwardRef(function(props2, ref) {
  const $ = c(5), {
    children
  } = props2;
  let t0;
  $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Text$1, { size: 1, children }), $[0] = children, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== ref || $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(Box, { ref, children: t0 }), $[2] = ref, $[3] = t0, $[4] = t1) : t1 = $[4], t1;
});
function TreeEditingBreadcrumbs(props2) {
  const $ = c(17), {
    items: t0,
    onPathSelect,
    selectedPath
  } = props2, itemsProp = t0 === void 0 ? EMPTY_ARRAY$n : t0, [rootElement, setRootElement] = useState(null), size = useElementSize(rootElement);
  let t1;
  bb0: {
    const w = size?.border.width;
    if (!w) {
      t1 = MAX_LENGTH;
      break bb0;
    }
    if (w < 500) {
      t1 = 3;
      break bb0;
    }
    if (w < 700) {
      t1 = 4;
      break bb0;
    }
    t1 = MAX_LENGTH;
  }
  const maxLength = t1;
  let t2;
  bb1: {
    const len = itemsProp.length, beforeLength = Math.ceil(maxLength / 2), afterLength = Math.floor(maxLength / 2);
    if (maxLength && len > maxLength) {
      let t32;
      $[0] !== afterLength || $[1] !== beforeLength || $[2] !== itemsProp || $[3] !== len ? (t32 = [...itemsProp.slice(0, beforeLength - 1), itemsProp.slice(beforeLength - 1, len - afterLength), ...itemsProp.slice(len - afterLength)], $[0] = afterLength, $[1] = beforeLength, $[2] = itemsProp, $[3] = len, $[4] = t32) : t32 = $[4], t2 = t32;
      break bb1;
    }
    t2 = itemsProp;
  }
  const items = t2;
  let t3, t4;
  if ($[5] !== items || $[6] !== onPathSelect || $[7] !== rootElement || $[8] !== selectedPath) {
    let t52;
    $[10] !== items.length || $[11] !== onPathSelect || $[12] !== rootElement || $[13] !== selectedPath ? (t52 = (item, index) => {
      const key = `${item}-${index}`, showSeparator = index < items.length - 1;
      if (Array.isArray(item))
        return /* @__PURE__ */ jsxs(Fragment$1, { children: [
          /* @__PURE__ */ jsx(TreeEditingBreadcrumbsMenuButton, { button: /* @__PURE__ */ jsx(StyledButton$3, { mode: "bleed", padding: 1, children: /* @__PURE__ */ jsx(Flex, { overflow: "hidden", children: /* @__PURE__ */ jsx(StyledText$5, { size: 1, weight: "medium", textOverflow: "ellipsis", children: "..." }) }) }), collapsed: !0, items: item, onPathSelect, parentElement: rootElement, selectedPath }),
          showSeparator && /* @__PURE__ */ jsx(SeparatorItem, { children: SEPARATOR })
        ] }, key);
      const hasChildren = item.children && item.children?.length > 1, isSelected = isEqual$2(item.path, selectedPath), button = /* @__PURE__ */ jsx(MenuButton, { item, isSelected, onPathSelect });
      return /* @__PURE__ */ jsxs(Fragment$1, { children: [
        !hasChildren && button,
        hasChildren && /* @__PURE__ */ jsx(TreeEditingBreadcrumbsMenuButton, { button, items: item.children || EMPTY_ARRAY$n, onPathSelect, menuTitle: getSchemaTypeTitle(item.schemaType), parentElement: rootElement, selectedPath: item.path }),
        showSeparator && /* @__PURE__ */ jsx(SeparatorItem, { children: SEPARATOR })
      ] }, key);
    }, $[10] = items.length, $[11] = onPathSelect, $[12] = rootElement, $[13] = selectedPath, $[14] = t52) : t52 = $[14], t4 = items.map(t52), $[5] = items, $[6] = onPathSelect, $[7] = rootElement, $[8] = selectedPath, $[9] = t4;
  } else
    t4 = $[9];
  t3 = t4;
  const nodes = t3;
  let t5;
  return $[15] !== nodes ? (t5 = /* @__PURE__ */ jsx(Flex, { align: "center", as: "ol", gap: 2, ref: setRootElement, children: nodes }), $[15] = nodes, $[16] = t5) : t5 = $[16], t5;
}
const FixedHeightFlex = styled(Flex).attrs({
  padding: 2,
  align: "center",
  sizing: "border"
})`
  height: 40px;
  min-height: 40px;
`, ITEM_HEIGHT$1 = 51, MAX_DISPLAYED_ITEMS$1 = 10;
function ResultItem(props2) {
  const $ = c(22), {
    item,
    onPathSelect,
    isFirst
  } = props2;
  let t0;
  $[0] !== item.schemaType || $[1] !== item.value ? (t0 = {
    value: item.value,
    schemaType: item.schemaType
  }, $[0] = item.schemaType, $[1] = item.value, $[2] = t0) : t0 = $[2];
  const {
    value
  } = useValuePreviewWithFallback(t0), title = value.title, t1 = isFirst ? void 0 : 1;
  let t2;
  $[3] !== item.path || $[4] !== onPathSelect ? (t2 = () => onPathSelect(item.path), $[3] = item.path, $[4] = onPathSelect, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== title || $[7] !== value.media ? (t3 = /* @__PURE__ */ jsx(SanityDefaultPreview, { title, media: value.media, layout: "inline" }), $[6] = title, $[7] = value.media, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== item.parentSchemaType ? (t4 = getSchemaTypeTitle(item.parentSchemaType), $[9] = item.parentSchemaType, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 0, textOverflow: "ellipsis", children: t4 }) }), $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 2, flex: 1, children: [
    t3,
    t5
  ] }), $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== t2 || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", onClick: t2, children: t6 }), $[16] = t2, $[17] = t6, $[18] = t7) : t7 = $[18];
  let t8;
  return $[19] !== t1 || $[20] !== t7 ? (t8 = /* @__PURE__ */ jsx(Stack, { marginTop: t1, children: t7 }), $[19] = t1, $[20] = t7, $[21] = t8) : t8 = $[21], t8;
}
function TreeEditingSearchMenu(props2) {
  const $ = c(10), {
    items,
    onPathSelect,
    textInputElement
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== items[0].path || $[1] !== onPathSelect ? (t0 = (item) => {
    const isFirst = isEqual$2(item.path, items[0].path);
    return /* @__PURE__ */ jsx(ResultItem, { isFirst, item, onPathSelect });
  }, $[0] = items[0].path, $[1] = onPathSelect, $[2] = t0) : t0 = $[2];
  const renderItem2 = t0;
  let t1;
  $[3] !== t ? (t1 = t("tree-editing-dialog.search.menu-label"), $[3] = t, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== items || $[6] !== renderItem2 || $[7] !== t1 || $[8] !== textInputElement ? (t2 = /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t1, autoFocus: supportsTouch ? void 0 : "input", inputElement: textInputElement, itemHeight: ITEM_HEIGHT$1, items, overscan: 5, padding: 1, renderItem: renderItem2 }), $[5] = items, $[6] = renderItem2, $[7] = t1, $[8] = textInputElement, $[9] = t2) : t2 = $[9], t2;
}
const POPOVER_FALLBACK_PLACEMENTS$6 = ["bottom-start"], RootFlex$5 = styled(Flex)``, PopoverListFlex$1 = styled(Flex)((props2) => {
  const {
    $maxDisplayedItems,
    $itemHeight
  } = props2;
  return css`
    --item-height: ${$itemHeight}px;
    --max-items: ${$maxDisplayedItems};
    --list-padding: 0.5rem;

    position: relative;
    max-height: calc(var(--item-height) * var(--max-items) + var(--list-padding));
    min-height: calc((var(--item-height) * 1));
    width: 100%;
  `;
}), StyledPopover$6 = styled(Popover)(() => css`
    [data-ui='Popover__wrapper'] {
      min-width: 250px;
      display: flex;
      flex-direction: column;
      border-radius: ${({
  theme
}) => theme.sanity.radius[3]}px;
      position: relative;
      overflow: hidden;
      overflow: clip;
    }
  `), StyledTextInput = styled(TextInput$1)`
  border-radius: inherit;
`;
function TreeEditingSearch(props2) {
  const $ = c(28), {
    items,
    onPathSelect
  } = props2, [textInputElement, setTextInputElement] = useState(null), [query, setQuery] = useState(""), {
    t
  } = useTranslation(), hasSearchQuery = query.length > 0, searchableList = useSearchableList(items);
  let t0, t1;
  $[0] !== query || $[1] !== searchableList ? (t1 = treeEditingSearch(searchableList, query), $[0] = query, $[1] = searchableList, $[2] = t1) : t1 = $[2], t0 = t1;
  const filteredList = t0;
  let t2;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setQuery(""), $[3] = t2) : t2 = $[3];
  const resetSearch = t2;
  let t3;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (event) => {
    setQuery(event.target.value);
  }, $[4] = t3) : t3 = $[4];
  const handleSearchChange = t3;
  let t4;
  $[5] !== onPathSelect ? (t4 = (path) => {
    onPathSelect(path), resetSearch();
  }, $[5] = onPathSelect, $[6] = t4) : t4 = $[6];
  const handlePathSelect = t4;
  let t5;
  $[7] !== textInputElement ? (t5 = (event_0) => {
    event_0.key === "Escape" && (resetSearch(), textInputElement?.focus());
  }, $[7] = textInputElement, $[8] = t5) : t5 = $[8];
  const handleSearchKeyDown = t5;
  let t6;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    requestAnimationFrame(() => {
      resetSearch();
    });
  }, $[9] = t6) : t6 = $[9];
  const handleSearchBlur = t6;
  let t7;
  bb0: {
    if (filteredList.length === 0) {
      let t83;
      $[10] !== t ? (t83 = t("tree-editing-dialog.search.no-results-title"), $[10] = t, $[11] = t83) : t83 = $[11];
      let t92;
      $[12] !== t83 ? (t92 = /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(Stack, { padding: 4, sizing: "border", space: 3, children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, weight: "medium", children: t83 }) }) }), $[12] = t83, $[13] = t92) : t92 = $[13], t7 = t92;
      break bb0;
    }
    let t82;
    $[14] !== filteredList || $[15] !== handlePathSelect || $[16] !== textInputElement ? (t82 = /* @__PURE__ */ jsx(RootFlex$5, { direction: "column", flex: 1, height: "fill", children: /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(PopoverListFlex$1, { $itemHeight: ITEM_HEIGHT$1, $maxDisplayedItems: MAX_DISPLAYED_ITEMS$1, direction: "column", overflow: "hidden", children: /* @__PURE__ */ jsx(TreeEditingSearchMenu, { items: filteredList, onPathSelect: handlePathSelect, textInputElement }) }) }) }), $[14] = filteredList, $[15] = handlePathSelect, $[16] = textInputElement, $[17] = t82) : t82 = $[17], t7 = t82;
  }
  const content = t7;
  let t8;
  $[18] !== t ? (t8 = t("tree-editing-dialog.search-placeholder"), $[18] = t, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== handleSearchKeyDown || $[21] !== query || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsx(Card, { radius: 3, children: /* @__PURE__ */ jsx(StyledTextInput, { fontSize: 1, icon: SearchIcon, onBlur: handleSearchBlur, onChange: handleSearchChange, onKeyDown: handleSearchKeyDown, placeholder: t8, ref: setTextInputElement, value: query }) }), $[20] = handleSearchKeyDown, $[21] = query, $[22] = t8, $[23] = t9) : t9 = $[23];
  let t10;
  return $[24] !== content || $[25] !== hasSearchQuery || $[26] !== t9 ? (t10 = /* @__PURE__ */ jsx(StyledPopover$6, { constrainSize: !0, content, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$6, matchReferenceWidth: !0, open: hasSearchQuery, placement: "bottom-start", portal: !0, children: t9 }), $[24] = content, $[25] = hasSearchQuery, $[26] = t9, $[27] = t10) : t10 = $[27], t10;
}
function isArrayItemSelected(itemPath, path) {
  return JSON.stringify(itemPath) === JSON.stringify(path);
}
function isArrayItemPath(path) {
  return path.length === 0 ? !1 : path[path.length - 1].hasOwnProperty("_key");
}
function shouldBeInBreadcrumb(itemPath, path) {
  return itemPath.every((segment, index) => isArrayItemSelected(path[index], segment)) && isArrayItemPath(itemPath);
}
function getRelativePath(path) {
  return isArrayItemPath(path) ? path : path.slice(0, path.length - 1);
}
function getSiblingHasChildren(items) {
  return items.some((sibling) => sibling.children && sibling.children.length > 0);
}
function hasOpenChild(item, selectedPath) {
  return item.children?.some((child) => isEqual$2(child.path, selectedPath) || hasOpenChild(child, selectedPath)) || !1;
}
const SCROLL_BEHAVIOR_OPTIONS = {
  block: "center",
  behavior: "smooth",
  scrollMode: "if-needed"
}, AnimateChevronIcon = styled(ChevronRightIcon)`
  transition: transform 0.2s ease;

  &[data-expanded='true'] {
    transform: rotate(90deg);
  }
`, Spacer = styled.div`
  min-width: 23px;
  max-width: 23px;
`, ChildStack = styled(Stack)(({
  theme
}) => {
  const space = getTheme_v2(theme)?.space[3] || 0, isDark = getTheme_v2(theme)?.color._dark, borderColor = hues.gray[isDark ? 900 : 200].hex;
  return css`
    margin-left: ${space + 2}px;
    box-sizing: border-box;
    border-left: 1px solid ${borderColor};
  `;
}), ItemFlex = styled(Flex)(({
  theme
}) => {
  const defaultHoverBg = getTheme_v2(theme)?.color.button.bleed.default.hovered.bg, selectedHoverBg = getTheme_v2(theme)?.color.button.bleed.default.pressed.bg, selectedBg = getTheme_v2(theme)?.color.button.bleed.default.selected.bg;
  return css`
    padding: 2px;
    padding-right: 3px;
    box-sizing: border-box;
    transition: inherit;
    border-radius: ${getTheme_v2(theme).radius[2]}px;

    &[data-selected='true'] {
      background-color: ${selectedBg};
    }

    [data-ui='ExpandButton'],
    [data-ui='NavigateButton'] {
      transition: inherit;
      background-color: inherit;
      box-shadow: unset;
    }

    @media (hover: hover) {
      &:hover {
        &[data-selected='false'] {
          background-color: ${defaultHoverBg};
          border-radius: ${getTheme_v2(theme).radius[2]}px;

          [data-ui='ExpandButton']:hover {
            background-color: ${selectedHoverBg};
          }
        }

        [data-ui='ExpandButton']:hover {
          background-color: ${defaultHoverBg};
        }
      }
    }
  `;
});
function TreeEditingMenuItem(props2) {
  const $ = c(58), {
    item,
    onPathSelect,
    selectedPath,
    siblingHasChildren
  } = props2, {
    children
  } = item, hasChildren = children && children.length > 0, [open, setOpen] = useState(!1), [rootElement, setRootElement] = useState(null), {
    t
  } = useTranslation$1();
  let t0;
  $[0] !== item.schemaType || $[1] !== item.value ? (t0 = {
    schemaType: item.schemaType,
    value: item.value
  }, $[0] = item.schemaType, $[1] = item.value, $[2] = t0) : t0 = $[2];
  const {
    value
  } = useValuePreviewWithFallback(t0);
  let t1, t2;
  $[3] !== item.path || $[4] !== selectedPath ? (t2 = isEqual$2(item.path, selectedPath), $[3] = item.path, $[4] = selectedPath, $[5] = t2) : t2 = $[5], t1 = t2;
  const selected = t1;
  let t3;
  t3 = !isArrayItemPath(item.path);
  const isArrayParent = t3;
  let t4, t5;
  $[6] !== item.path ? (t5 = toString(item.path), $[6] = item.path, $[7] = t5) : t5 = $[7], t4 = t5;
  const stringPath = t4;
  let t6;
  bb0: {
    if (isArrayParent) {
      let t72;
      $[8] !== item.schemaType ? (t72 = getSchemaTypeTitle(item.schemaType), $[8] = item.schemaType, $[9] = t72) : t72 = $[9], t6 = t72;
      break bb0;
    }
    t6 = value.title;
  }
  const title = t6;
  let t7;
  bb1: {
    if (!hasChildren) {
      t7 = null;
      break bb1;
    }
    const t82 = open ? "true" : "false";
    let t92;
    $[10] !== t82 ? (t92 = /* @__PURE__ */ jsx(AnimateChevronIcon, { "data-expanded": t82 }), $[10] = t82, $[11] = t92) : t92 = $[11], t7 = t92;
  }
  const icon = t7;
  let t8;
  bb2: {
    if (isArrayParent) {
      let t92;
      $[12] === Symbol.for("react.memo_cache_sentinel") ? (t92 = /* @__PURE__ */ jsx(StackCompactIcon, {}), $[12] = t92) : t92 = $[12], t8 = t92;
      break bb2;
    }
    t8 = value.media;
  }
  const media = t8;
  let t9;
  $[13] !== item.path || $[14] !== onPathSelect ? (t9 = () => onPathSelect(item.path), $[13] = item.path, $[14] = onPathSelect, $[15] = t9) : t9 = $[15];
  const handleClick = t9;
  let t10;
  $[16] === Symbol.for("react.memo_cache_sentinel") ? (t10 = () => setOpen(_temp$1L), $[16] = t10) : t10 = $[16];
  const handleExpandClick = t10;
  let t11, t12;
  $[17] !== item || $[18] !== selectedPath ? (t11 = () => {
    hasOpenChild(item, selectedPath) && setOpen(!0);
  }, t12 = [item, selectedPath], $[17] = item, $[18] = selectedPath, $[19] = t11, $[20] = t12) : (t11 = $[19], t12 = $[20]), useEffect(t11, t12);
  let t13, t14;
  $[21] !== rootElement || $[22] !== selected ? (t13 = () => {
    !rootElement || !selected || scrollIntoView$1(rootElement, SCROLL_BEHAVIOR_OPTIONS);
  }, t14 = [rootElement, selected], $[21] = rootElement, $[22] = selected, $[23] = t13, $[24] = t14) : (t13 = $[23], t14 = $[24]), useEffect(t13, t14);
  let t15;
  $[25] !== icon || $[26] !== open || $[27] !== stringPath || $[28] !== t || $[29] !== title ? (t15 = icon && /* @__PURE__ */ jsx(Button$1, { "aria-label": `${t(open ? "tree-editing-dialog.sidebar.action.collapse" : "tree-editing-dialog.sidebar.action.expand")} ${title}`, "data-testid": `tree-editing-menu-expand-button-${stringPath}`, "data-ui": "ExpandButton", mode: "bleed", onClick: handleExpandClick, padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 0, muted: !0, children: icon }) }), $[25] = icon, $[26] = open, $[27] = stringPath, $[28] = t, $[29] = title, $[30] = t15) : t15 = $[30];
  let t16;
  $[31] !== icon || $[32] !== siblingHasChildren ? (t16 = !icon && siblingHasChildren && /* @__PURE__ */ jsx(Spacer, {}), $[31] = icon, $[32] = siblingHasChildren, $[33] = t16) : t16 = $[33];
  const t17 = `tree-editing-menu-navigate-button-${stringPath}`;
  let t18;
  $[34] !== media || $[35] !== title ? (t18 = /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(SanityDefaultPreview, { layout: "inline", media, title }) }), $[34] = media, $[35] = title, $[36] = t18) : t18 = $[36];
  let t19;
  $[37] !== handleClick || $[38] !== t17 || $[39] !== t18 || $[40] !== title ? (t19 = /* @__PURE__ */ jsx(Stack, { flex: 1, children: /* @__PURE__ */ jsx(Button$1, { "data-testid": t17, "data-ui": "NavigateButton", mode: "bleed", onClick: handleClick, padding: 1, title, children: t18 }) }), $[37] = handleClick, $[38] = t17, $[39] = t18, $[40] = title, $[41] = t19) : t19 = $[41];
  let t20;
  $[42] !== selected || $[43] !== t15 || $[44] !== t16 || $[45] !== t19 ? (t20 = /* @__PURE__ */ jsx(Card, { "data-as": "button", "data-testid": "tree-editing-menu-item", overflow: "hidden", radius: 2, tone: "inherit", children: /* @__PURE__ */ jsxs(ItemFlex, { align: "center", "data-selected": selected, "data-testid": "tree-editing-menu-item-content", children: [
    t15,
    t16,
    t19
  ] }) }), $[42] = selected, $[43] = t15, $[44] = t16, $[45] = t19, $[46] = t20) : t20 = $[46];
  let t21;
  $[47] !== children || $[48] !== hasChildren || $[49] !== onPathSelect || $[50] !== open || $[51] !== selectedPath ? (t21 = open && hasChildren && /* @__PURE__ */ jsx(ChildStack, { flex: 1, forwardedAs: "ul", paddingLeft: 1, role: "group", space: 1, children: children.map((child) => {
    const childSiblingHasChildren = getSiblingHasChildren(children);
    return /* @__PURE__ */ jsx(TreeEditingMenuItem, { item: child, onPathSelect, selectedPath, siblingHasChildren: childSiblingHasChildren }, toString(child.path));
  }) }), $[47] = children, $[48] = hasChildren, $[49] = onPathSelect, $[50] = open, $[51] = selectedPath, $[52] = t21) : t21 = $[52];
  let t22;
  return $[53] !== open || $[54] !== stringPath || $[55] !== t20 || $[56] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Stack, { "aria-expanded": open, as: "li", ref: setRootElement, role: "treeitem", space: 1, children: [
    t20,
    t21
  ] }, stringPath), $[53] = open, $[54] = stringPath, $[55] = t20, $[56] = t21, $[57] = t22) : t22 = $[57], t22;
}
function _temp$1L(v) {
  return !v;
}
const TreeEditingMenu = memo(function(props2) {
  const $ = c(6), {
    items,
    onPathSelect,
    selectedPath
  } = props2;
  let t0;
  $[0] !== items || $[1] !== onPathSelect || $[2] !== selectedPath ? (t0 = items.map((item) => {
    const siblingHasChildren = getSiblingHasChildren(items);
    return /* @__PURE__ */ jsx(TreeEditingMenuItem, { item, onPathSelect, selectedPath, siblingHasChildren }, toString(item.path));
  }), $[0] = items, $[1] = onPathSelect, $[2] = selectedPath, $[3] = t0) : t0 = $[3];
  let t1;
  return $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(Stack, { as: "ul", "data-testid": "tree-editing-menu", role: "tree", space: 2, children: t0 }), $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}), ANIMATION_VARIANTS$1 = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, SidebarCard = styled(Card)`
  flex-direction: column;
`, SidebarStack = styled(motion.create(Stack))`
  overflow-x: hidden;
`, SearchStack = styled(Stack)`
  min-height: max-content;
`, TreeEditingLayoutSidebar = memo(function(props2) {
  const $ = c(33), {
    items,
    onPathSelect,
    selectedPath,
    onOpenToggle,
    open,
    title
  } = props2, {
    t
  } = useTranslation$1();
  let t0, t1;
  $[0] !== open || $[1] !== t ? (t1 = t(open ? "tree-editing-dialog.sidebar.action.close" : "tree-editing-dialog.sidebar.action.open"), $[0] = open, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = {
    content: t1
  }, $[3] = t1, $[4] = t2) : t2 = $[4], t0 = t2;
  const tooltipProps = t0, t3 = !open;
  let t4;
  $[5] !== onOpenToggle || $[6] !== open || $[7] !== tooltipProps ? (t4 = /* @__PURE__ */ jsx(Button, { "data-testid": "tree-editing-sidebar-toggle", icon: PanelLeftIcon, mode: "bleed", onClick: onOpenToggle, selected: open, tooltipProps }), $[5] = onOpenToggle, $[6] = open, $[7] = tooltipProps, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== open || $[10] !== title ? (t5 = open && /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", textOverflow: "ellipsis", children: title }) }), $[9] = open, $[10] = title, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t4 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsxs(FixedHeightFlex, { align: "center", gap: 2, children: [
    t4,
    t5
  ] }), $[12] = t4, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== items || $[16] !== onPathSelect || $[17] !== open ? (t7 = open && /* @__PURE__ */ jsx(SearchStack, { padding: 2, sizing: "border", children: /* @__PURE__ */ jsx(TreeEditingSearch, { items, onPathSelect }) }), $[15] = items, $[16] = onPathSelect, $[17] = open, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== items || $[20] !== onPathSelect || $[21] !== open || $[22] !== selectedPath ? (t8 = open && /* @__PURE__ */ jsx(SidebarStack, { animate: "animate", exit: "exit", initial: "initial", overflow: "auto", padding: 3, sizing: "border", variants: ANIMATION_VARIANTS$1, children: /* @__PURE__ */ jsx(TreeEditingMenu, { items, onPathSelect, selectedPath }) }), $[19] = items, $[20] = onPathSelect, $[21] = open, $[22] = selectedPath, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== t8 ? (t9 = /* @__PURE__ */ jsx(AnimatePresence, { mode: "wait", children: t8 }), $[24] = t8, $[25] = t9) : t9 = $[25];
  let t10;
  $[26] !== t3 || $[27] !== t6 || $[28] !== t7 || $[29] !== t9 ? (t10 = /* @__PURE__ */ jsxs(SidebarCard, { borderRight: t3, "data-testid": "tree-editing-sidebar", "data-ui": "SidebarCard", display: "flex", forwardedAs: "aside", height: "fill", overflow: "hidden", tone: "transparent", children: [
    t6,
    t7,
    t9
  ] }), $[26] = t3, $[27] = t6, $[28] = t7, $[29] = t9, $[30] = t10) : t10 = $[30];
  const content = t10;
  if (open) {
    let t11;
    return $[31] !== content ? (t11 = /* @__PURE__ */ jsx(Resizable, { maxWidth: 450, minWidth: 150, initialWidth: 250, children: content }), $[31] = content, $[32] = t11) : t11 = $[32], t11;
  }
  return content;
}), PRESENCE_MARGINS = [0, 0, 1, 0], TreeEditingLayout = memo(function(props2) {
  const $ = c(26), {
    breadcrumbs,
    children,
    footer,
    items,
    onPathSelect,
    selectedPath,
    setScrollElement: setParentScrollElement,
    title
  } = props2, [scrollElement, setScrollElement] = useState(null), containerElementRef = useRef(null), [open, setOpen] = useState(!1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setOpen(_temp$1K), $[0] = t0) : t0 = $[0];
  const toggleOpen = t0;
  let t1;
  $[1] !== setParentScrollElement ? (t1 = (el) => {
    setScrollElement(el), setParentScrollElement?.(el);
  }, $[1] = setParentScrollElement, $[2] = t1) : t1 = $[2];
  const handleSetScrollElementRef = t1;
  let t2;
  $[3] !== items || $[4] !== onPathSelect || $[5] !== open || $[6] !== selectedPath || $[7] !== title ? (t2 = /* @__PURE__ */ jsx(TreeEditingLayoutSidebar, { items, onOpenToggle: toggleOpen, onPathSelect, open, selectedPath, title }), $[3] = items, $[4] = onPathSelect, $[5] = open, $[6] = selectedPath, $[7] = title, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== breadcrumbs || $[10] !== onPathSelect || $[11] !== selectedPath ? (t3 = /* @__PURE__ */ jsx(FixedHeightFlex, { align: "center", sizing: "border", gap: 2, paddingX: 4, children: /* @__PURE__ */ jsx(Flex, { flex: 1, children: /* @__PURE__ */ jsx(TreeEditingBreadcrumbs, { items: breadcrumbs, onPathSelect, selectedPath }) }) }), $[9] = breadcrumbs, $[10] = onPathSelect, $[11] = selectedPath, $[12] = t3) : t3 = $[12];
  let t4;
  $[13] !== children || $[14] !== scrollElement ? (t4 = children && /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { containerElement: containerElementRef, scrollElement, children: /* @__PURE__ */ jsx(Container$2, { width: 1, ref: containerElementRef, paddingX: 5, paddingY: 5, sizing: "border", children: /* @__PURE__ */ jsx(PresenceOverlay, { margins: PRESENCE_MARGINS, children }) }) }), $[13] = children, $[14] = scrollElement, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== handleSetScrollElementRef || $[17] !== t4 ? (t5 = /* @__PURE__ */ jsx(Card, { flex: 1, id: "tree-editing-form", overflow: "auto", ref: handleSetScrollElementRef, children: t4 }), $[16] = handleSetScrollElementRef, $[17] = t4, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== footer || $[20] !== t3 || $[21] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, overflow: "hidden", children: [
    t3,
    t5,
    footer
  ] }), $[19] = footer, $[20] = t3, $[21] = t5, $[22] = t6) : t6 = $[22];
  let t7;
  return $[23] !== t2 || $[24] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { height: "fill", overflow: "hidden", children: [
    t2,
    t6
  ] }), $[23] = t2, $[24] = t6, $[25] = t7) : t7 = $[25], t7;
});
function _temp$1K(v) {
  return !v;
}
function getRootPath$1(path) {
  const keyedSegmentIndex = path.findIndex((seg) => seg?.hasOwnProperty("_key"));
  return keyedSegmentIndex === -1 ? path : path.slice(0, keyedSegmentIndex);
}
function getSchemaField$2(schemaType, fieldPath) {
  if (!fieldPath) return;
  const paths = fromString(fieldPath), firstPath = paths[0];
  if (firstPath && isObjectSchemaType(schemaType)) {
    const field = schemaType?.fields?.find((f) => f.name === firstPath);
    if (field) {
      const nextPath = toString(paths.slice(1));
      return nextPath ? getSchemaField$2(field.type, nextPath) : field;
    }
  }
}
function getItemType(arrayType, item) {
  const itemTypeName = resolveTypeName$2(item);
  return itemTypeName === "object" && arrayType.of.length === 1 ? arrayType.of[0] : arrayType.of.find((memberType) => memberType.name === itemTypeName);
}
function getPrimitiveItemType(arrayType, item) {
  const itemTypeName = resolveTypeName$2(item);
  return arrayType?.of.find((memberType) => memberType.name === itemTypeName || memberType.jsonType === itemTypeName);
}
function findArrayTypePaths(fields) {
  const arrayPaths = [];
  let currentPath = [];
  function checkFields(nestedFields) {
    nestedFields.forEach((field) => {
      const newPath = [...currentPath, field.name];
      isArrayOfObjectsSchemaType(field.type) && !isArrayOfBlocksSchemaType(field.type) && arrayPaths.push(newPath), isObjectSchemaType(field.type) && (currentPath = newPath, checkFields(field.type.fields), currentPath = currentPath.slice(0, -1));
    });
  }
  return checkFields(fields), arrayPaths;
}
function buildBreadcrumbsState(props2) {
  const {
    arraySchemaType,
    arrayValue,
    itemPath,
    parentPath
  } = props2, items = arrayValue.map((arrayItem) => {
    const nestedItemPath = [...parentPath, {
      _key: arrayItem._key
    }], itemType = getItemType(arraySchemaType, arrayItem);
    return isReferenceSchemaType(itemType) || !itemType ? null : {
      children: EMPTY_ARRAY$A,
      parentSchemaType: arraySchemaType,
      path: nestedItemPath,
      schemaType: itemType,
      value: arrayItem
    };
  }).filter(Boolean), selectedItem = items.find((item) => isEqual$2(item.path, itemPath));
  return {
    children: items,
    parentSchemaType: arraySchemaType,
    path: itemPath,
    schemaType: selectedItem.schemaType,
    value: selectedItem.value
  };
}
function buildArrayState(props2) {
  const {
    arraySchemaType,
    arrayValue,
    documentValue,
    openPath,
    rootPath,
    recursive
  } = props2;
  let relativePath = [];
  const menuItems = [], breadcrumbs = [];
  return arraySchemaType.options?.treeEditing === !1 ? {
    breadcrumbs,
    menuItems,
    relativePath,
    rootTitle: ""
  } : (arrayValue.forEach((item) => {
    const itemPath = [...rootPath, {
      _key: item._key
    }], itemSchemaField = getItemType(arraySchemaType, item);
    if (!itemSchemaField || isReferenceSchemaType(itemSchemaField) || itemSchemaField?.options?.treeEditing === !1) return;
    const childrenFields = itemSchemaField?.fields || [], childrenMenuItems = [];
    if (shouldBeInBreadcrumb(itemPath, openPath)) {
      const breadcrumbsResult = buildBreadcrumbsState({
        arraySchemaType,
        arrayValue,
        itemPath,
        parentPath: rootPath
      });
      breadcrumbs.push(breadcrumbsResult);
    }
    childrenFields.forEach((childField) => {
      if (childField?.type?.options?.treeEditing === !1) return;
      const childPath = [...itemPath, childField.name], childValue = getValueAtPath(documentValue, childPath);
      if (isArrayItemSelected(childPath, openPath) && (relativePath = getRelativePath(childPath)), isObjectSchemaType(childField.type)) {
        const arrayPaths = findArrayTypePaths(childField.type.fields);
        if (arrayPaths.length === 0) return;
        arrayPaths.forEach((arrayPath) => {
          const fieldPath = [...childPath, ...arrayPath], nestedArrayField = getSchemaField$2(childField.type, toString(arrayPath)), arrayFieldValue_ = getValueAtPath(documentValue, fieldPath), arrayFieldValue = Array.isArray(arrayFieldValue_) ? arrayFieldValue_ : [];
          if (!arrayFieldValue.length || nestedArrayField.type.options?.treeEditing === !1) return;
          isArrayItemSelected(fieldPath, openPath) && (relativePath = getRelativePath(fieldPath));
          const nestedArrayState = recursive({
            documentValue,
            path: fieldPath,
            schemaType: nestedArrayField
          });
          childrenMenuItems.push({
            children: nestedArrayState.menuItems,
            parentSchemaType: childField.type,
            path: fieldPath,
            schemaType: nestedArrayField.type,
            value: arrayFieldValue
          });
        });
      }
      const isPortableText2 = isArrayOfBlocksSchemaType(childField.type);
      if (isArrayOfObjectsSchemaType(childField.type) && childValue && !isPortableText2) {
        if (shouldBeInBreadcrumb(childPath, openPath)) {
          const breadcrumbsResult = buildBreadcrumbsState({
            arraySchemaType: childField.type,
            arrayValue: childValue,
            itemPath: childPath,
            parentPath: itemPath
          });
          breadcrumbs.push(breadcrumbsResult);
        }
        const childState = recursive({
          documentValue,
          path: childPath,
          schemaType: childField
        });
        childrenMenuItems.push({
          children: childState?.menuItems || EMPTY_ARRAY$A,
          parentSchemaType: itemSchemaField,
          path: childPath,
          schemaType: childField,
          value: childValue
        });
        return;
      }
      isPortableText2 && toString(openPath).startsWith(toString(childPath)) && (relativePath = getRelativePath(childPath));
    }), isArrayItemSelected(itemPath, openPath) && (relativePath = getRelativePath(itemPath)), isPrimitiveSchemaType(itemSchemaField?.type) || menuItems.push({
      children: childrenMenuItems,
      parentSchemaType: arraySchemaType,
      path: itemPath,
      schemaType: itemSchemaField,
      value: item
    });
  }), {
    breadcrumbs,
    menuItems,
    relativePath,
    rootTitle: ""
  });
}
const EMPTY_ARRAY$m = [], EMPTY_TREE_STATE = {
  breadcrumbs: EMPTY_ARRAY$m,
  menuItems: EMPTY_ARRAY$m,
  relativePath: EMPTY_ARRAY$m,
  rootTitle: ""
};
function buildTreeEditingState(props2) {
  const {
    openPath
  } = props2, rootPath = getRootPath$1(openPath), rootField = getSchemaField$2(props2.schemaType, toString(rootPath)), rootTitle = getSchemaTypeTitle(rootField?.type);
  if (!isArrayOfObjectsSchemaType(rootField?.type) || rootField?.options?.treeEditing === !1)
    return EMPTY_TREE_STATE;
  let relativePath = [];
  const breadcrumbs = [], result = recursive({
    schemaType: rootField,
    documentValue: props2.documentValue,
    path: rootPath
  });
  function recursive(recursiveProps) {
    const {
      schemaType,
      path,
      documentValue
    } = recursiveProps, value = getValueAtPath(documentValue, path), arrayValue = Array.isArray(value) ? value : EMPTY_ARRAY$m, arraySchemaType = schemaType?.type, arrayState = buildArrayState({
      arraySchemaType,
      arrayValue,
      documentValue,
      openPath,
      // Pass the recursive function to the buildArrayState function
      // to allow for recursive calls in the array items.
      recursive,
      rootPath: path
    });
    return arrayState.relativePath.length > 0 && (relativePath = arrayState.relativePath), breadcrumbs.unshift(...arrayState.breadcrumbs), arrayState;
  }
  return {
    relativePath,
    breadcrumbs,
    menuItems: result.menuItems,
    rootTitle
  };
}
const EMPTY_ARRAY$l = [], ANIMATION_VARIANTS = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, ANIMATION_TRANSITION$1 = {
  duration: 0.2,
  ease: "easeInOut"
};
function renderDefault(props2) {
  return props2.renderDefault(props2);
}
const StyledDialog$2 = styled(Dialog)(({
  theme
}) => {
  const spacing = getTheme_v2(theme)?.space[4];
  return css`
    [data-ui='DialogCard'] {
      padding: ${spacing}px;
      box-sizing: border-box;

      // Make the dialog full height
      & > [data-ui='Card']:first-child {
        flex: 1;
      }
    }
  `;
}), MotionFlex = motion.create(Flex);
function TreeEditingDialog(props2) {
  const $ = c(49), {
    onPathFocus,
    onPathOpen,
    openPath,
    rootInputProps,
    schemaType
  } = props2, {
    value
  } = rootInputProps, {
    t
  } = useTranslation(), [treeState, setTreeState] = useState(EMPTY_TREE_STATE), [layoutScrollElement, setLayoutScrollElement] = useState(null), openPathRef = useRef(void 0), valueRef = useRef(void 0);
  let t0;
  $[0] !== layoutScrollElement ? (t0 = () => {
    layoutScrollElement?.scrollTo(0, 0);
  }, $[0] = layoutScrollElement, $[1] = t0) : t0 = $[1];
  const handleAnimationExitComplete = t0;
  let t1;
  $[2] !== treeState ? (t1 = (opts) => {
    const nextState = buildTreeEditingState(opts);
    if (isEqual$2(nextState, treeState))
      return;
    const builtRelativePath = nextState.relativePath, nextRelativePath = builtRelativePath.length === 0 || !isArrayItemPath(builtRelativePath) ? treeState.relativePath : builtRelativePath;
    setTreeState({
      ...nextState,
      relativePath: nextRelativePath
    });
  }, $[2] = treeState, $[3] = t1) : t1 = $[3];
  const handleBuildTreeEditingState = t1;
  let t2, t3;
  $[4] !== handleBuildTreeEditingState ? (t3 = debounce(handleBuildTreeEditingState, 1e3), $[4] = handleBuildTreeEditingState, $[5] = t3) : t3 = $[5], t2 = t3;
  const debouncedBuildTreeEditingState = t2;
  let t4;
  $[6] !== debouncedBuildTreeEditingState || $[7] !== onPathFocus || $[8] !== onPathOpen || $[9] !== openPath ? (t4 = () => {
    debouncedBuildTreeEditingState.cancel(), onPathOpen(EMPTY_ARRAY$l), setTreeState(EMPTY_TREE_STATE), valueRef.current = void 0, openPathRef.current = void 0;
    const firstKeySegmentIndex = openPath.findIndex(isKeySegment), rootFocusPath = openPath.slice(0, firstKeySegmentIndex + 1);
    onPathFocus(rootFocusPath);
  }, $[6] = debouncedBuildTreeEditingState, $[7] = onPathFocus, $[8] = onPathOpen, $[9] = openPath, $[10] = t4) : t4 = $[10];
  const onClose = t4;
  let t5;
  $[11] !== debouncedBuildTreeEditingState || $[12] !== onPathFocus || $[13] !== onPathOpen ? (t5 = (path) => {
    debouncedBuildTreeEditingState.cancel(), onPathOpen(path), isArrayItemPath(path) || onPathFocus(path);
  }, $[11] = debouncedBuildTreeEditingState, $[12] = onPathFocus, $[13] = onPathOpen, $[14] = t5) : t5 = $[14];
  const onHandlePathSelect = t5;
  let t6, t7;
  if ($[15] !== debouncedBuildTreeEditingState || $[16] !== handleBuildTreeEditingState || $[17] !== openPath || $[18] !== schemaType || $[19] !== value ? (t6 = () => {
    const valueChanged = !isEqual$2(value, valueRef.current), openPathChanged = !isEqual$2(openPath, openPathRef.current);
    if (valueRef.current === void 0 && openPathRef.current === void 0 || openPathChanged) {
      handleBuildTreeEditingState({
        schemaType,
        documentValue: value,
        openPath
      }), openPathRef.current = openPath;
      return;
    }
    if (!(!valueChanged && !openPathChanged))
      return valueRef.current = value, openPathRef.current = openPath, debouncedBuildTreeEditingState({
        schemaType,
        documentValue: value,
        openPath
      }), () => {
        debouncedBuildTreeEditingState.cancel();
      };
  }, t7 = [schemaType, value, debouncedBuildTreeEditingState, openPath, handleBuildTreeEditingState], $[15] = debouncedBuildTreeEditingState, $[16] = handleBuildTreeEditingState, $[17] = openPath, $[18] = schemaType, $[19] = value, $[20] = t6, $[21] = t7) : (t6 = $[20], t7 = $[21]), useEffect(t6, t7), treeState.relativePath.length === 0)
    return null;
  const t8 = treeState.breadcrumbs, t9 = treeState.menuItems, t10 = treeState.relativePath, t11 = treeState.rootTitle;
  let t12;
  $[22] !== t ? (t12 = t("tree-editing-dialog.sidebar.action.done"), $[22] = t, $[23] = t12) : t12 = $[23];
  let t13;
  $[24] !== onClose || $[25] !== t12 ? (t13 = /* @__PURE__ */ jsx(Card, { borderTop: !0, children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "flex-end", paddingX: 3, paddingY: 2, sizing: "border", children: /* @__PURE__ */ jsx(Button, { size: "large", "data-testid": "tree-editing-done", text: t12, onClick: onClose }) }) }), $[24] = onClose, $[25] = t12, $[26] = t13) : t13 = $[26];
  let t14;
  $[27] !== treeState.relativePath ? (t14 = toString(treeState.relativePath), $[27] = treeState.relativePath, $[28] = t14) : t14 = $[28];
  let t15;
  $[29] !== rootInputProps || $[30] !== treeState.relativePath ? (t15 = /* @__PURE__ */ jsx(FormInput, { ...rootInputProps, relativePath: treeState.relativePath, renderDefault }), $[29] = rootInputProps, $[30] = treeState.relativePath, $[31] = t15) : t15 = $[31];
  let t16;
  $[32] !== t14 || $[33] !== t15 ? (t16 = /* @__PURE__ */ jsx(MotionFlex, { animate: "animate", "data-testid": "tree-editing-dialog-content", direction: "column", exit: "exit", height: "fill", initial: "initial", overflow: "hidden", padding: 1, sizing: "border", transition: ANIMATION_TRANSITION$1, variants: ANIMATION_VARIANTS, children: t15 }, t14), $[32] = t14, $[33] = t15, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== handleAnimationExitComplete || $[36] !== t16 ? (t17 = /* @__PURE__ */ jsx(AnimatePresence, { initial: !1, mode: "wait", onExitComplete: handleAnimationExitComplete, children: t16 }), $[35] = handleAnimationExitComplete, $[36] = t16, $[37] = t17) : t17 = $[37];
  let t18;
  $[38] !== onHandlePathSelect || $[39] !== t13 || $[40] !== t17 || $[41] !== treeState.breadcrumbs || $[42] !== treeState.menuItems || $[43] !== treeState.relativePath || $[44] !== treeState.rootTitle ? (t18 = /* @__PURE__ */ jsx(TreeEditingLayout, { breadcrumbs: t8, items: t9, onPathSelect: onHandlePathSelect, selectedPath: t10, title: t11, setScrollElement: setLayoutScrollElement, footer: t13, children: t17 }), $[38] = onHandlePathSelect, $[39] = t13, $[40] = t17, $[41] = treeState.breadcrumbs, $[42] = treeState.menuItems, $[43] = treeState.relativePath, $[44] = treeState.rootTitle, $[45] = t18) : t18 = $[45];
  let t19;
  return $[46] !== onClose || $[47] !== t18 ? (t19 = /* @__PURE__ */ jsx(StyledDialog$2, { __unstable_hideCloseButton: !0, animate: !0, "data-testid": "tree-editing-dialog", id: "tree-editing-dialog", onClickOutside: onClose, onClose, padding: 0, width: 3, children: t18 }), $[46] = onClose, $[47] = t18, $[48] = t19) : t19 = $[48], t19;
}
function useTreeEditingEnabled() {
  return useContext(TreeEditingEnabledContext);
}
function TreeEditingEnabledProvider(props2) {
  const $ = c(5), {
    children,
    legacyEditing: legacyEditingProp
  } = props2, parentContextValue = useTreeEditingEnabled();
  let t0;
  const t1 = !!(parentContextValue.legacyEditing || legacyEditingProp);
  let t2;
  $[0] !== t1 ? (t2 = {
    enabled: !1,
    legacyEditing: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1], t0 = t2;
  const value = t0;
  let t3;
  return $[2] !== children || $[3] !== value ? (t3 = /* @__PURE__ */ jsx(TreeEditingEnabledContext.Provider, { value, children }), $[2] = children, $[3] = value, $[4] = t3) : t3 = $[4], t3;
}
function useInsertMenuMenuItems(props2) {
  const $ = c(53), {
    t
  } = useTranslation(), {
    onInsert,
    schemaTypes: types
  } = props2;
  let t0;
  $[0] !== props2.schemaTypes ? (t0 = props2.schemaTypes ?? [], $[0] = props2.schemaTypes, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== props2 ? (t1 = (insertType) => {
    props2.onInsert("before", insertType);
  }, $[2] = props2, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== props2.insertMenuOptions || $[5] !== t0 || $[6] !== t1 ? (t2 = {
    ...props2.insertMenuOptions,
    schemaTypes: t0,
    onSelect: t1
  }, $[4] = props2.insertMenuOptions, $[5] = t0, $[6] = t1, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t3 = ["bottom-end"], $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== props2.referenceElement ? (t4 = {
    referenceElement: props2.referenceElement,
    placement: "top-end",
    fallbackPlacements: t3
  }, $[9] = props2.referenceElement, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t2 || $[12] !== t4 ? (t5 = {
    insertMenuProps: t2,
    popoverProps: t4
  }, $[11] = t2, $[12] = t4, $[13] = t5) : t5 = $[13];
  const insertBefore = useInsertMenuPopover(t5);
  let t6;
  $[14] !== props2.schemaTypes ? (t6 = props2.schemaTypes ?? [], $[14] = props2.schemaTypes, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== props2 ? (t7 = (insertType_0) => {
    props2.onInsert("after", insertType_0);
  }, $[16] = props2, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== props2.insertMenuOptions || $[19] !== t6 || $[20] !== t7 ? (t8 = {
    ...props2.insertMenuOptions,
    schemaTypes: t6,
    onSelect: t7
  }, $[18] = props2.insertMenuOptions, $[19] = t6, $[20] = t7, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] === Symbol.for("react.memo_cache_sentinel") ? (t9 = ["top-end"], $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== props2.referenceElement ? (t10 = {
    referenceElement: props2.referenceElement,
    placement: "bottom-end",
    fallbackPlacements: t9
  }, $[23] = props2.referenceElement, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t10 || $[26] !== t8 ? (t11 = {
    insertMenuProps: t8,
    popoverProps: t10
  }, $[25] = t10, $[26] = t8, $[27] = t11) : t11 = $[27];
  const insertAfter2 = useInsertMenuPopover(t11);
  let t12;
  $[28] !== insertBefore || $[29] !== onInsert || $[30] !== types ? (t12 = () => {
    types && (types.length === 1 ? onInsert("before", types[0]) : insertBefore.send({
      type: "toggle"
    }));
  }, $[28] = insertBefore, $[29] = onInsert, $[30] = types, $[31] = t12) : t12 = $[31];
  const handleToggleInsertBefore = t12;
  let t13;
  $[32] !== insertAfter2 || $[33] !== onInsert || $[34] !== types ? (t13 = () => {
    types && (types.length === 1 ? onInsert("after", types[0]) : insertAfter2.send({
      type: "toggle"
    }));
  }, $[32] = insertAfter2, $[33] = onInsert, $[34] = types, $[35] = t13) : t13 = $[35];
  const handleToggleInsertAfter = t13;
  let t14, t15;
  $[36] !== handleToggleInsertBefore || $[37] !== t || $[38] !== types ? (t15 = types ? /* @__PURE__ */ jsx(MenuItem$1, { text: types.length === 1 ? t("inputs.array.action.add-before") : `${t("inputs.array.action.add-before")}...`, icon: InsertAboveIcon, onClick: handleToggleInsertBefore }, "insertBefore") : null, $[36] = handleToggleInsertBefore, $[37] = t, $[38] = types, $[39] = t15) : t15 = $[39], t14 = t15;
  const insertBeforeMenuItem = t14;
  let t16, t17;
  $[40] !== handleToggleInsertAfter || $[41] !== t || $[42] !== types ? (t17 = types ? /* @__PURE__ */ jsx(MenuItem$1, { text: types.length === 1 ? t("inputs.array.action.add-after") : `${t("inputs.array.action.add-after")}...`, icon: InsertBelowIcon, onClick: handleToggleInsertAfter }, "insertAfter") : null, $[40] = handleToggleInsertAfter, $[41] = t, $[42] = types, $[43] = t17) : t17 = $[43], t16 = t17;
  const insertAfterMenuItem = t16;
  let t18;
  $[44] !== insertBefore || $[45] !== insertBeforeMenuItem ? (t18 = {
    ...insertBefore,
    menuItem: insertBeforeMenuItem
  }, $[44] = insertBefore, $[45] = insertBeforeMenuItem, $[46] = t18) : t18 = $[46];
  let t19;
  $[47] !== insertAfter2 || $[48] !== insertAfterMenuItem ? (t19 = {
    ...insertAfter2,
    menuItem: insertAfterMenuItem
  }, $[47] = insertAfter2, $[48] = insertAfterMenuItem, $[49] = t19) : t19 = $[49];
  let t20;
  return $[50] !== t18 || $[51] !== t19 ? (t20 = {
    insertBefore: t18,
    insertAfter: t19
  }, $[50] = t18, $[51] = t19, $[52] = t20) : t20 = $[52], t20;
}
const PreviewCard$1 = styled(Card)`
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
  height: 100%;
  position: relative;

  @media (hover: hover) {
    &:hover {
      filter: brightness(95%);
    }
  }

  &:focus:focus-visible {
    box-shadow: 0 0 0 2px var(--card-focus-ring-color);
  }
`;
function getTone$2({
  readOnly,
  hasErrors,
  hasWarnings
}) {
  return readOnly ? "transparent" : hasErrors ? "critical" : hasWarnings ? "caution" : "default";
}
const MENU_POPOVER_PROPS$7 = {
  portal: !0,
  tone: "default"
}, EMPTY_ARRAY$k = [];
function GridItem(props2) {
  const {
    schemaType,
    parentSchemaType,
    path,
    readOnly,
    onRemove,
    value,
    open,
    onInsert,
    onCopy,
    onFocus,
    onOpen,
    onClose,
    changed,
    focused,
    children,
    inputProps: {
      renderPreview
    }
  } = props2, {
    t
  } = useTranslation(), treeEditing = useTreeEditingEnabled(), treeEditingDisabledByOption = parentSchemaType?.options?.treeEditing === !1, legacyEditing = treeEditingDisabledByOption || treeEditing.legacyEditing, openPortal = open && (!treeEditing.enabled || legacyEditing), sortable = parentSchemaType.options?.sortable !== !1, insertableTypes = parentSchemaType.of, [previewCardElement, setPreviewCardElement] = useState(null), previewCardRef = useRef(null);
  useImperativeHandle(previewCardRef, () => previewCardElement, [previewCardElement]), useScrollIntoViewOnFocusWithin(previewCardRef, open), useDidUpdate(focused, (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && previewCardRef.current && previewCardRef.current?.focus();
  });
  const resolvingInitialValue = value._resolvingInitialValue, handleDuplicate = useCallback(() => {
    onInsert({
      items: [{
        ...value,
        _key: randomKey()
      }],
      position: "after"
    });
  }, [onInsert, value]), handleCopy = useCallback(() => {
    onCopy({
      items: [{
        ...value,
        _key: randomKey()
      }]
    });
  }, [onCopy, value]), handleInsert = useCallback((pos, insertType) => {
    onInsert({
      items: [createProtoArrayValue(insertType)],
      position: pos
    });
  }, [onInsert]), childPresence = useChildPresence(path, !0), presence = useMemo(() => childPresence.length === 0 ? null : /* @__PURE__ */ jsx(FieldPresence, { presence: childPresence, maxAvatars: 1 }), [childPresence]), childValidation = useChildValidation(path, !0), validation2 = useMemo(() => childValidation.length === 0 ? null : /* @__PURE__ */ jsx(Box, { paddingX: 1, paddingY: 3, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: childValidation, __unstable_showSummary: !0 }) }), [childValidation]), hasErrors = childValidation.some((v) => v.level === "error"), hasWarnings = childValidation.some((v_0) => v_0.level === "warning"), [contextMenuButtonElement, setContextMenuButtonElement] = useState(null), {
    insertBefore,
    insertAfter: insertAfter2
  } = useInsertMenuMenuItems({
    schemaTypes: insertableTypes,
    insertMenuOptions: parentSchemaType.options?.insertMenu,
    onInsert: handleInsert,
    referenceElement: contextMenuButtonElement
  }), disableActions = parentSchemaType.options?.disableActions || EMPTY_ARRAY$k, menuItems = useMemo(() => [!disableActions.includes("remove") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.remove"), tone: "critical", icon: TrashIcon, onClick: onRemove }), !disableActions.includes("copy") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.copy"), icon: CopyIcon, onClick: handleCopy }), !disableActions.includes("duplicate") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.duplicate"), icon: AddDocumentIcon, onClick: handleDuplicate }), !disableActions.includes("add") && !disableActions.includes("addBefore") && insertBefore.menuItem, !disableActions.includes("add") && !disableActions.includes("addAfter") && insertAfter2.menuItem].filter(Boolean), [disableActions, handleCopy, handleDuplicate, insertAfter2.menuItem, insertBefore.menuItem, onRemove, t]), menu = useMemo(() => readOnly || menuItems.length === 0 ? null : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MenuButton$1, { ref: setContextMenuButtonElement, onOpen: () => {
      insertBefore.send({
        type: "close"
      }), insertAfter2.send({
        type: "close"
      });
    }, button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "array-item-menu-button", selected: insertBefore.state.open || insertAfter2.state.open ? !0 : void 0 }), id: `${props2.inputId}-menuButton`, menu: /* @__PURE__ */ jsx(Menu, { children: menuItems }), popover: MENU_POPOVER_PROPS$7 }),
    insertBefore.popover,
    insertAfter2.popover
  ] }), [readOnly, insertBefore, insertAfter2, props2.inputId, menuItems]), tone = getTone$2({
    readOnly,
    hasErrors,
    hasWarnings
  }), item = /* @__PURE__ */ jsx(CellLayout, { menu, presence, validation: validation2, tone, radius: 2, border: !0, dragHandle: sortable, selected: openPortal, readOnly, children: /* @__PURE__ */ jsxs(PreviewCard$1, { tone: "inherit", overflow: "auto", forwardedAs: "button", "data-ui": "PreviewCard", "data-as": "button", type: "button", flex: 1, tabIndex: 0, disabled: resolvingInitialValue, onClick: onOpen, ref: setPreviewCardElement, onFocus, __unstable_focusRing: !0, children: [
    renderPreview({
      schemaType,
      value,
      layout: "media",
      withBorder: !1,
      withShadow: !1
    }),
    resolvingInitialValue && /* @__PURE__ */ jsx(LoadingBlock, { fill: !0 })
  ] }) }), itemTypeTitle = getSchemaTypeTitle(schemaType);
  return /* @__PURE__ */ jsxs(TreeEditingEnabledProvider, { legacyEditing: treeEditingDisabledByOption, children: [
    /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: item }),
    openPortal && /* @__PURE__ */ jsx(EditPortal, { header: readOnly ? t("inputs.array.action.view", {
      itemTypeTitle
    }) : t("inputs.array.action.edit", {
      itemTypeTitle
    }), type: parentSchemaType?.options?.modal?.type || "dialog", width: parentSchemaType?.options?.modal?.width ?? 1, id: value._key, onClose, autofocus: focused, legacy_referenceElement: previewCardElement, children })
  ] });
}
const EMPTY$4 = [];
function GridArrayInput(props2) {
  const $ = c(38), {
    arrayFunctions: t0,
    elementProps,
    members,
    onChange,
    onItemPrepend,
    onItemAppend,
    onItemMove,
    onUpload,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderPreview,
    resolveUploader: resolveUploader2,
    schemaType,
    value: t1
  } = props2, ArrayFunctions = t0 === void 0 ? ArrayOfObjectsFunctions : t0, value = t1 === void 0 ? EMPTY$4 : t1, {
    t
  } = useTranslation(), sortable = schemaType.options?.sortable !== !1, renderItem2 = _temp$1J;
  let t2, t3;
  $[0] !== members ? (t3 = members.map(_temp2$B), $[0] = members, $[1] = t3) : t3 = $[1], t2 = t3;
  const memberKeys = t2;
  let t4;
  $[2] !== members.length || $[3] !== schemaType.placeholder || $[4] !== t ? (t4 = members?.length === 0 && /* @__PURE__ */ jsx(Card, { padding: 3, border: !0, radius: 2, children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: schemaType.placeholder || /* @__PURE__ */ jsx(Fragment, { children: t("inputs.array.no-items-label") }) }) }), $[2] = members.length, $[3] = schemaType.placeholder, $[4] = t, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== memberKeys || $[7] !== members || $[8] !== onItemMove || $[9] !== readOnly || $[10] !== renderAnnotation || $[11] !== renderBlock2 || $[12] !== renderField || $[13] !== renderInlineBlock || $[14] !== renderInput || $[15] !== renderPreview || $[16] !== sortable ? (t5 = members?.length > 0 && /* @__PURE__ */ jsx(Card, { border: !0, radius: 1, children: /* @__PURE__ */ jsx(List, { columns: [2, 3, 4], gap: 3, padding: 1, margin: 1, items: memberKeys, onItemMove, sortable, children: members.map((member_0) => /* @__PURE__ */ jsxs(Item, { sortable, id: member_0.key, flex: 1, children: [
    member_0.kind === "item" && /* @__PURE__ */ jsx(ArrayOfObjectsItem, { member: member_0, renderAnnotation, renderBlock: renderBlock2, renderInlineBlock, renderItem: renderItem2, renderField, renderInput, renderPreview }),
    member_0.kind === "error" && /* @__PURE__ */ jsx(ErrorItem$1, { sortable, member: member_0, readOnly })
  ] }, member_0.key)) }) }), $[6] = memberKeys, $[7] = members, $[8] = onItemMove, $[9] = readOnly, $[10] = renderAnnotation, $[11] = renderBlock2, $[12] = renderField, $[13] = renderInlineBlock, $[14] = renderInput, $[15] = renderPreview, $[16] = sortable, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== t4 || $[19] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { "data-ui": "ArrayInput__content", space: 2, children: [
    t4,
    t5
  ] }), $[18] = t4, $[19] = t5, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== elementProps || $[22] !== onUpload || $[23] !== resolveUploader2 || $[24] !== schemaType.of || $[25] !== t6 ? (t7 = /* @__PURE__ */ jsx(UploadTargetCard, { types: schemaType.of, resolveUploader: resolveUploader2, onUpload, ...elementProps, tabIndex: 0, children: t6 }), $[21] = elementProps, $[22] = onUpload, $[23] = resolveUploader2, $[24] = schemaType.of, $[25] = t6, $[26] = t7) : t7 = $[26];
  let t8;
  $[27] !== ArrayFunctions || $[28] !== onChange || $[29] !== onItemAppend || $[30] !== onItemPrepend || $[31] !== readOnly || $[32] !== schemaType || $[33] !== value ? (t8 = /* @__PURE__ */ jsx(ArrayFunctions, { onChange, onItemAppend, onItemPrepend, onValueCreate: createProtoArrayValue, readOnly, schemaType, value }), $[27] = ArrayFunctions, $[28] = onChange, $[29] = onItemAppend, $[30] = onItemPrepend, $[31] = readOnly, $[32] = schemaType, $[33] = value, $[34] = t8) : t8 = $[34];
  let t9;
  return $[35] !== t7 || $[36] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t7,
    t8
  ] }), $[35] = t7, $[36] = t8, $[37] = t9) : t9 = $[37], t9;
}
function _temp2$B(member) {
  return member.key;
}
function _temp$1J(t0) {
  const {
    key,
    ...itemProps
  } = t0;
  return /* @__PURE__ */ jsx(GridItem, { ...itemProps }, key);
}
const Root$p = styled(Card)`
  position: relative;
  border: 1px solid transparent;
  transition: border-color 250ms;

  .${MOVING_ITEM_CLASS_NAME} & {
    border-color: var(--card-shadow-umbra-color);
    box-shadow:
      0 0 0 0,
      0 8px 17px 2px var(--card-shadow-umbra-color),
      0 3px 14px 2px var(--card-shadow-penumbra-color),
      0 5px 5px -3px var(--card-shadow-ambient-color);
  }

  &:hover {
    border-color: var(--card-shadow-umbra-color);
  }

  &[aria-selected='true'] {
    border-color: var(--card-focus-ring-color);
  }
`;
function RowLayout(props2) {
  const $ = c(21), {
    validation: validation2,
    selected,
    tone,
    presence,
    focused,
    children,
    dragHandle,
    menu,
    footer,
    readOnly
  } = props2, elementRef = useRef(null);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && elementRef.current?.focus();
  }, $[0] = t0) : t0 = $[0], useDidUpdate(focused, t0);
  let t1;
  $[1] !== dragHandle || $[2] !== readOnly ? (t1 = dragHandle && /* @__PURE__ */ jsx(DragHandle, { paddingY: 3, readOnly }), $[1] = dragHandle, $[2] = readOnly, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== children ? (t2 = /* @__PURE__ */ jsx(Box, { flex: 1, children }), $[4] = children, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== menu || $[7] !== presence || $[8] !== validation2 ? (t3 = (presence || validation2 || menu) && /* @__PURE__ */ jsxs(Flex, { align: "center", flex: "none", gap: 2, style: {
    lineHeight: 0
  }, children: [
    presence && /* @__PURE__ */ jsx(Box, { flex: "none", children: presence }),
    validation2 && /* @__PURE__ */ jsx(Box, { flex: "none", children: validation2 }),
    menu
  ] }), $[6] = menu, $[7] = presence, $[8] = validation2, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t1 || $[11] !== t2 || $[12] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t1,
    t2,
    t3
  ] }), $[10] = t1, $[11] = t2, $[12] = t3, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== footer || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t4,
    footer
  ] }), $[14] = footer, $[15] = t4, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== selected || $[18] !== t5 || $[19] !== tone ? (t6 = /* @__PURE__ */ jsx(Root$p, { ref: elementRef, selected, "aria-selected": selected, radius: 1, padding: 1, tone, children: t5 }), $[17] = selected, $[18] = t5, $[19] = tone, $[20] = t6) : t6 = $[20], t6;
}
const PopoverCard = styled(Card)`
  max-width: ${({
  theme
}) => theme.sanity.container[1]}px;
`;
function IncompatibleItemType(props2) {
  const $ = c(54);
  let onFocus, rest, value;
  if ($[0] !== props2) {
    const {
      value: t02,
      onFocus: t110,
      vertical,
      ...t23
    } = props2;
    value = t02, onFocus = t110, rest = t23, $[0] = props2, $[1] = onFocus, $[2] = rest, $[3] = value;
  } else
    onFocus = $[1], rest = $[2], value = $[3];
  const [showDetails, setShowDetails] = useState(!1), popoverRef = useRef(null), {
    t
  } = useTranslation();
  let t0, t1;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setShowDetails(!1), t1 = () => [popoverRef.current], $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useClickOutsideEvent(t0, t1);
  let t2;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => {
    (e.key === "Escape" || e.key === "Tab") && setShowDetails(!1);
  }, $[6] = t2) : t2 = $[6];
  const handleKeyDown = t2;
  let t3;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowDetails(_temp$1I);
  }, $[7] = t3) : t3 = $[7];
  const handleShowDetails = t3;
  let t4;
  $[8] !== value ? (t4 = resolveTypeName$2(value), $[8] = value, $[9] = t4) : t4 = $[9];
  const typeName = t4;
  let t5;
  $[10] !== t ? (t5 = t("inputs.array.error.type-is-incompatible-title"), $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: t5 }) }), $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== typeName ? (t7 = {
    typeName
  }, $[14] = typeName, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.current-schema-not-declare-description", values: t7 }) }), $[16] = t, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] === Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx(BulbOutlineIcon, {}), $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== t ? (t10 = t("inputs.array.error.can-delete-but-no-edit-description"), $[20] = t, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== t10 ? (t11 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t9,
    " ",
    t10
  ] }) }), $[22] = t10, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== t ? (t12 = t("inputs.array.error.json-representation-description"), $[24] = t, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== t12 ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t12 }), $[26] = t12, $[27] = t13) : t13 = $[27];
  let t14;
  $[28] !== value ? (t14 = JSON.stringify(value, null, 2), $[28] = value, $[29] = t14) : t14 = $[29];
  let t15;
  $[30] !== t14 ? (t15 = /* @__PURE__ */ jsx(Card, { padding: 2, overflow: "auto", border: !0, children: /* @__PURE__ */ jsx(Code, { size: 1, as: "pre", language: "json", children: t14 }) }), $[30] = t14, $[31] = t15) : t15 = $[31];
  let t16;
  $[32] !== t13 || $[33] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t13,
    t15
  ] }), $[32] = t13, $[33] = t15, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== t11 || $[36] !== t16 || $[37] !== t6 || $[38] !== t8 ? (t17 = /* @__PURE__ */ jsx(PopoverCard, { margin: 1, padding: 3, onKeyDown: handleKeyDown, tabIndex: 0, overflow: "auto", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t6,
    t8,
    t11,
    t16
  ] }) }), $[35] = t11, $[36] = t16, $[37] = t6, $[38] = t8, $[39] = t17) : t17 = $[39];
  let t18;
  $[40] === Symbol.for("react.memo_cache_sentinel") ? (t18 = /* @__PURE__ */ jsx(Box, { marginRight: 3, children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(UnknownIcon, {}) }) }), $[40] = t18) : t18 = $[40];
  let t19;
  $[41] !== typeName ? (t19 = {
    typeName
  }, $[41] = typeName, $[42] = t19) : t19 = $[42];
  let t20;
  $[43] !== t || $[44] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t18,
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.array.error.type-is-incompatible-prompt", values: t19 }) }) })
  ] }), $[43] = t, $[44] = t19, $[45] = t20) : t20 = $[45];
  let t21;
  $[46] !== onFocus || $[47] !== rest || $[48] !== t20 ? (t21 = /* @__PURE__ */ jsx(Card, { as: "button", type: "button", radius: 2, tone: "inherit", paddingX: 2, paddingY: 3, flex: 1, onFocus, onClick: handleShowDetails, onKeyDown: handleKeyDown, __unstable_focusRing: !0, ...rest, children: t20 }), $[46] = onFocus, $[47] = rest, $[48] = t20, $[49] = t21) : t21 = $[49];
  let t22;
  return $[50] !== showDetails || $[51] !== t17 || $[52] !== t21 ? (t22 = /* @__PURE__ */ jsx(Popover, { open: showDetails, ref: popoverRef, onKeyDown: handleKeyDown, portal: !0, constrainSize: !0, tone: "default", content: t17, children: t21 }), $[50] = showDetails, $[51] = t17, $[52] = t21, $[53] = t22) : t22 = $[53], t22;
}
function _temp$1I(v) {
  return !v;
}
const MENU_POPOVER_PROPS$6 = {
  portal: !0,
  tone: "default"
};
function ErrorItem(props2) {
  const $ = c(18), {
    member,
    sortable,
    onRemove,
    readOnly
  } = props2, id2 = useId(), {
    t
  } = useTranslation(), t0 = !!readOnly;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[0] = t1) : t1 = $[0];
  const t2 = `${id2}-menuButton`;
  let t3;
  $[1] !== t ? (t3 = t("inputs.array.action.remove-invalid-item"), $[1] = t, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== onRemove || $[4] !== t3 ? (t4 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsx(MenuItem$1, { text: t3, tone: "critical", icon: TrashIcon, onClick: onRemove }) }), $[3] = onRemove, $[4] = t3, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t2 || $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuButton$1, { button: t1, id: t2, menu: t4, popover: MENU_POPOVER_PROPS$6 }), $[6] = t2, $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== member.error.type || $[10] !== member.error.value || $[11] !== t ? (t6 = member.error.type === "INVALID_ITEM_TYPE" ? /* @__PURE__ */ jsx(IncompatibleItemType, { value: member.error.value }) : /* @__PURE__ */ jsx("div", { children: t("inputs.array.error.unexpected-error", {
    error: member.error.type
  }) }), $[9] = member.error.type, $[10] = member.error.value, $[11] = t, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== sortable || $[14] !== t0 || $[15] !== t5 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { paddingX: 1, children: /* @__PURE__ */ jsx(RowLayout, { dragHandle: sortable, readOnly: t0, tone: "caution", menu: t5, children: t6 }) }), $[13] = sortable, $[14] = t0, $[15] = t5, $[16] = t6, $[17] = t7) : t7 = $[17], t7;
}
function useMemoCompare(next, compare2) {
  const [previous, setPrevious] = useState(next);
  return compare2(previous, next) ? previous : (setPrevious(next), next);
}
function useVirtualizerScrollInstance() {
  const ref = useContext(VirtualizerScrollInstanceContext);
  if (!ref)
    throw new Error("VirtualizerScrollInstance: missing context value");
  return ref;
}
const EMPTY$3 = [];
function ListArrayInput(props2) {
  const {
    arrayFunctions: ArrayFunctions = ArrayOfObjectsFunctions,
    elementProps,
    members,
    onChange,
    onItemMove,
    onUpload,
    focusPath,
    readOnly,
    onItemAppend,
    onItemPrepend,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    resolveUploader: resolveUploader2,
    schemaType,
    value = EMPTY$3
  } = props2, {
    t
  } = useTranslation(), [activeDragItemIndex, setActiveDragItemIndex] = useState(null), {
    space
  } = useTheme().sanity, memberKeys = useMemoCompare(useMemo(() => members.map((member) => member.key), [members]), shallowEquals), {
    scrollElement,
    containerElement
  } = useVirtualizerScrollInstance(), parentRef = useRef(null), focusPathKey = useMemo(() => isKeySegment(focusPath[0]) ? focusPath[0]._key : focusPath[0], [focusPath]), rangeExtractor = useCallback((range2) => {
    const newRange = {
      ...range2
    };
    if (activeDragItemIndex !== null && (newRange.startIndex = Math.min(range2.startIndex, activeDragItemIndex), newRange.endIndex = Math.max(range2.endIndex, activeDragItemIndex)), focusPathKey) {
      const index = memberKeys.findIndex((key) => key === focusPathKey);
      index !== -1 && (newRange.startIndex = Math.min(newRange.startIndex, index), newRange.endIndex = Math.max(newRange.endIndex, index));
    }
    return defaultRangeExtractor(newRange);
  }, [activeDragItemIndex, focusPathKey, memberKeys]), observeElementOffset = useCallback((instance, callback) => {
    if (!instance.scrollElement)
      return;
    const scroll = instance.scrollElement, handleScroll = (evt) => {
      const containerElementTop = containerElement.current?.getBoundingClientRect().top ?? 0, parentElementTop = parentRef.current?.getBoundingClientRect().top ?? 0, itemOffset = Math.floor(parentElementTop - containerElementTop);
      callback(scroll.scrollTop - itemOffset, !!evt);
    };
    return handleScroll(), instance.scrollElement.addEventListener("scroll", handleScroll, {
      capture: !1,
      passive: !0
    }), () => {
      scroll.removeEventListener("scroll", handleScroll);
    };
  }, [containerElement]), estimateSize2 = useCallback(() => 53, []), virtualizer = useVirtualizer({
    count: members.length,
    estimateSize: estimateSize2,
    getScrollElement: useCallback(() => scrollElement, [scrollElement]),
    observeElementOffset,
    rangeExtractor,
    getItemKey: useCallback((index_0) => memberKeys[index_0], [memberKeys]),
    scrollToFn: (offset, options, instance_0) => {
      offset !== instance_0.scrollOffset && elementScroll(offset, options, instance_0);
    }
  }), items = virtualizer.getVirtualItems(), handleItemMoveStart = useCallback((event) => {
    const {
      active
    } = event;
    setActiveDragItemIndex(active.data.current?.sortable?.index);
  }, []), handleItemMoveEnd = useCallback(() => {
    setActiveDragItemIndex(null);
  }, []), sortable = schemaType.options?.sortable !== !1, listGridGap = 1, paddingY = 1, radius = 2;
  return /* @__PURE__ */ jsxs(Stack, { space: 2, ref: parentRef, children: [
    /* @__PURE__ */ jsx(UploadTargetCard, { $radius: radius, types: schemaType.of, resolveUploader: resolveUploader2, onUpload, ...elementProps, tabIndex: 0, children: /* @__PURE__ */ jsx(Stack, { "data-ui": "ArrayInput__content", space: 2, children: members.length === 0 ? /* @__PURE__ */ jsx(Card, { padding: 3, border: !0, radius: 2, children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: schemaType.placeholder || /* @__PURE__ */ jsx(Fragment, { children: t("inputs.array.no-items-label") }) }) }) : /* @__PURE__ */ jsx(Card, { border: !0, radius, style: {
      // This is not memoized since it changes on scroll so it will change anyways making memo useless
      // Account for grid gap
      boxSizing: "border-box",
      height: `${virtualizer.getTotalSize() + items.length * space[listGridGap] + space[paddingY]}px`,
      width: "100%",
      position: "relative"
    }, children: /* @__PURE__ */ jsx(List, { axis: "y", gap: listGridGap, paddingY, items: memberKeys, onItemMove, onItemMoveStart: handleItemMoveStart, onItemMoveEnd: handleItemMoveEnd, sortable, style: {
      // This is not memoized since it changes on scroll so it will change anyways making memo useless
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      transform: items.length > 0 ? `translateY(${items[0].start}px)` : void 0
    }, children: items.map((virtualRow) => {
      const member_0 = members[virtualRow.index];
      return /* @__PURE__ */ jsxs(Item, { ref: virtualizer.measureElement, sortable, "data-index": virtualRow.index, id: member_0.key, children: [
        member_0.kind === "item" && /* @__PURE__ */ jsx(ArrayOfObjectsItem, { member: member_0, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }),
        member_0.kind === "error" && /* @__PURE__ */ jsx(ErrorItem, { readOnly, sortable, member: member_0, onRemove: () => props2.onItemRemove(member_0.key) })
      ] }, virtualRow.key);
    }) }) }) }) }),
    /* @__PURE__ */ jsx(ArrayFunctions, { onChange, onItemAppend, onItemPrepend, onValueCreate: createProtoArrayValue, readOnly, schemaType, value })
  ] });
}
function ArrayOfObjectsInput(props2) {
  const $ = c(3), isGrid = props2.schemaType.options?.layout === "grid";
  let t0;
  return $[0] !== isGrid || $[1] !== props2 ? (t0 = isGrid ? /* @__PURE__ */ jsx(GridArrayInput, { ...props2 }) : /* @__PURE__ */ jsx(ListArrayInput, { ...props2 }), $[0] = isGrid, $[1] = props2, $[2] = t0) : t0 = $[2], t0;
}
function isEqual$1(item, otherItem) {
  if (item === otherItem)
    return !0;
  if (typeof item != typeof otherItem)
    return !1;
  if (typeof item != "object" && !Array.isArray(item))
    return item === otherItem;
  if (item._key && item._key === otherItem._key)
    return !0;
  if (Array.isArray(item))
    return !item.length !== otherItem.length ? !1 : item.every((it, i) => isEqual$1(item[i], otherItem[i]));
  const keys = Object.keys(item), otherKeys = Object.keys(item);
  return keys.length !== otherKeys.length ? !1 : keys.every((keyName) => isEqual$1(item[keyName], otherItem[keyName]));
}
function inArray(array, candidate) {
  return array ? array.some((item) => isEqual$1(item, candidate)) : !1;
}
function getMemberTypeOfItem$1(schemaType, item) {
  return schemaType.of.find((memberType) => memberType.name === resolveTypeName$2(item));
}
const EMPTY_ARRAY$j = [];
function ArrayOfObjectOptionsInput(props2) {
  const {
    renderPreview,
    schemaType,
    onChange,
    onPathFocus,
    value = [],
    readOnly,
    elementProps,
    path,
    changed
  } = props2, options = useMemo(() => (schemaType.options?.list || EMPTY_ARRAY$j).map((option, index) => isKeyedObject(option) ? option : {
    ...option,
    _key: `auto-generated-${index}`
  }), [schemaType.options?.list]), handleChange = useCallback((isChecked, changedOption) => {
    if (!isChecked && isKeyedObject(changedOption)) {
      onChange(unset([{
        _key: changedOption._key
      }]));
      return;
    }
    const nextValue = options.filter((option_0) => isEqual$1(changedOption, option_0) ? isChecked : inArray(value, option_0));
    onChange(nextValue.length > 0 ? set(nextValue) : unset());
  }, [onChange, options, value]), handleItemFocus = useCallback((index_0) => {
    onPathFocus([index_0]);
  }, [onPathFocus]), isGrid = schemaType.options?.layout === "grid";
  return /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !1, children: /* @__PURE__ */ jsx(Grid, { gap: 2, columns: isGrid ? Math.min(options.length, 4) : 1, tabIndex: 0, ...elementProps, children: options.map((option_1, index_1) => {
    const optionType = getMemberTypeOfItem$1(schemaType, option_1), checked = inArray(value, option_1), disabled = !optionType;
    return /* @__PURE__ */ jsxs(Flex, { align: "center", as: "label", muted: disabled, children: [
      /* @__PURE__ */ jsx(Checkbox$1, { disabled, checked, onChange: (e) => handleChange(e.currentTarget.checked, option_1), onFocus: () => handleItemFocus(index_1), readOnly }),
      /* @__PURE__ */ jsx(Box, { flex: 1, marginLeft: 2, children: optionType ? renderPreview({
        layout: "default",
        schemaType: optionType,
        value: option_1
      }) : /* @__PURE__ */ jsx(Card, { tone: "caution", radius: 2, children: /* @__PURE__ */ jsx(IncompatibleItemType$2, { value: option_1, onFocus: () => handleItemFocus(index_1) }) }) })
    ] }, index_1);
  }) }) });
}
function isPrimitiveOption(option) {
  return !!(option && typeof option == "object" && "title" in option && "value" in option);
}
function normalizeOptions(options) {
  return options.map((option) => isPrimitiveOption(option) ? {
    title: option.title || startCase(String(option.value)),
    value: option.value
  } : {
    title: startCase(String(option)),
    value: option
  });
}
function getMemberTypeOfItem(schemaType, option) {
  return schemaType.of.find((memberType) => memberType.name === resolveTypeName$2(option.value));
}
function ArrayOfPrimitiveOptionsInput(props2) {
  const {
    schemaType,
    onChange,
    value = [],
    readOnly,
    path,
    changed,
    onIndexFocus,
    elementProps
  } = props2, options = useMemo(() => normalizeOptions(schemaType.options?.list || []), [schemaType.options?.list]), handleChange = (isChecked, changedValue) => {
    const nextValue = options.map((option) => option.value).filter((optionValue) => (
      // note: sparse arrays are not supported here, so multiple options with same value will all be checked
      optionValue === changedValue ? isChecked : value.includes(optionValue)
    ));
    onChange(nextValue.length > 0 ? set(nextValue) : unset());
  }, isGrid = schemaType.options?.layout === "grid";
  return /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !1, children: /* @__PURE__ */ jsx(Grid, { gap: 2, columns: isGrid ? Math.min(options.length, 4) : 1, ...elementProps, children: options.map((option_0, index) => {
    const optionType = getMemberTypeOfItem(schemaType, option_0), checked = value.includes(option_0.value), disabled = !optionType;
    return /* @__PURE__ */ jsxs(Flex, { align: "center", as: "label", muted: disabled, children: [
      /* @__PURE__ */ jsx(Checkbox$1, { disabled, checked, onChange: (e) => handleChange(e.currentTarget.checked, option_0.value), onFocus: () => onIndexFocus(index), readOnly }),
      /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { children: option_0.title }) }),
      !optionType && /* @__PURE__ */ jsx(IncompatibleItemType, { value: option_0, onFocus: () => onIndexFocus(index) })
    ] }, index);
  }) }) });
}
function ArrayOfOptionsInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = isArrayOfObjectsInputProps(props2) ? /* @__PURE__ */ jsx(ArrayOfObjectOptionsInput, { ...props2 }) : /* @__PURE__ */ jsx(ArrayOfPrimitiveOptionsInput, { ...props2 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function ArrayOfPrimitivesFunctions(props2) {
  const $ = c(28), {
    schemaType,
    readOnly,
    children,
    onValueCreate,
    onItemAppend
  } = props2, menuButtonId = useId(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== onItemAppend || $[1] !== onValueCreate ? (t0 = (itemType) => {
    onItemAppend(onValueCreate(itemType));
  }, $[0] = onItemAppend, $[1] = onValueCreate, $[2] = t0) : t0 = $[2];
  const insertItem = t0;
  let t1;
  $[3] !== insertItem || $[4] !== schemaType.of[0] ? (t1 = () => {
    insertItem(schemaType.of[0]);
  }, $[3] = insertItem, $[4] = schemaType.of[0], $[5] = t1) : t1 = $[5];
  const handleAddBtnClick = t1;
  let t2, t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    constrainSize: !0,
    portal: !0
  }, $[6] = t3) : t3 = $[6], t2 = t3;
  const popoverProps = t2, addItemI18nKey = schemaType.of.length > 1 ? "inputs.array.action.add-item-select-type" : "inputs.array.action.add-item";
  if (schemaType.options?.disableActions?.includes("add"))
    return null;
  if (readOnly) {
    let t42;
    $[7] !== t ? (t42 = t("inputs.array.read-only-label"), $[7] = t, $[8] = t42) : t42 = $[8];
    let t52;
    $[9] !== addItemI18nKey || $[10] !== t ? (t52 = t(addItemI18nKey), $[9] = addItemI18nKey, $[10] = t, $[11] = t52) : t52 = $[11];
    let t62;
    $[12] !== t52 ? (t62 = /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(Button, { "data-testid": "add-single-primitive-button", icon: AddIcon, mode: "ghost", disabled: !0, size: "large", text: t52 }) }), $[12] = t52, $[13] = t62) : t62 = $[13];
    let t7;
    return $[14] !== t42 || $[15] !== t62 ? (t7 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t42, children: t62 }), $[14] = t42, $[15] = t62, $[16] = t7) : t7 = $[16], t7;
  }
  let t4;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))"
  }, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== addItemI18nKey || $[19] !== handleAddBtnClick || $[20] !== insertItem || $[21] !== menuButtonId || $[22] !== schemaType.of || $[23] !== t ? (t5 = schemaType.of.length === 1 ? /* @__PURE__ */ jsx(Button, { "data-testid": "add-multiple--primitive-button", icon: AddIcon, mode: "ghost", onClick: handleAddBtnClick, size: "large", text: t(addItemI18nKey) }) : /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(Button, { icon: AddIcon, mode: "ghost", size: "large", text: t(addItemI18nKey) }), id: menuButtonId || "", menu: /* @__PURE__ */ jsx(Menu, { children: schemaType.of.map((memberDef, i) => {
    const referenceIcon = isReferenceSchemaType(memberDef) && (memberDef.to || []).length === 1 && memberDef.to[0].icon, icon = memberDef.icon || memberDef.type?.icon || referenceIcon;
    return /* @__PURE__ */ jsx(MenuItem$1, { text: memberDef.title || memberDef.type?.name, onClick: () => insertItem(memberDef), icon }, i);
  }) }), popover: popoverProps }), $[18] = addItemI18nKey, $[19] = handleAddBtnClick, $[20] = insertItem, $[21] = menuButtonId, $[22] = schemaType.of, $[23] = t, $[24] = t5) : t5 = $[24];
  let t6;
  return $[25] !== children || $[26] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Grid, { gap: 1, style: t4, children: [
    t5,
    children
  ] }), $[25] = children, $[26] = t5, $[27] = t6) : t6 = $[27], t6;
}
const MENU_POPOVER_PROPS$5 = {
  portal: !0,
  tone: "default",
  placement: "left",
  constrainSize: !0
};
memo(function(props2) {
  const $ = c(15), {
    types,
    onInsert
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("inputs.array.action.add-before"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== onInsert || $[3] !== t0 || $[4] !== types ? (t1 = /* @__PURE__ */ jsx(InsertMenuGroup, { pos: "before", types, onInsert, text: t0, icon: InsertAboveIcon }), $[2] = onInsert, $[3] = t0, $[4] = types, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== t ? (t2 = t("inputs.array.action.add-after"), $[6] = t, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== onInsert || $[9] !== t2 || $[10] !== types ? (t3 = /* @__PURE__ */ jsx(InsertMenuGroup, { pos: "after", types, onInsert, text: t2, icon: InsertBelowIcon }), $[8] = onInsert, $[9] = t2, $[10] = types, $[11] = t3) : t3 = $[11];
  let t4;
  return $[12] !== t1 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t1,
    t3
  ] }), $[12] = t1, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
});
function InsertMenuGroup(props2) {
  const $ = c(17), {
    types,
    onInsert,
    pos,
    text,
    icon
  } = props2;
  if (types?.length === 1) {
    let t02;
    $[0] !== onInsert || $[1] !== pos || $[2] !== types[0] ? (t02 = () => onInsert(pos, types[0]), $[0] = onInsert, $[1] = pos, $[2] = types[0], $[3] = t02) : t02 = $[3];
    let t12;
    return $[4] !== icon || $[5] !== pos || $[6] !== t02 || $[7] !== text ? (t12 = /* @__PURE__ */ jsx(MenuItem$1, { text, icon, onClick: t02 }, pos), $[4] = icon, $[5] = pos, $[6] = t02, $[7] = text, $[8] = t12) : t12 = $[8], t12;
  }
  let t0;
  $[9] !== onInsert || $[10] !== pos || $[11] !== types ? (t0 = types?.map((insertableType) => /* @__PURE__ */ jsx(MenuItem$1, { icon: insertableType.icon, text: insertableType.title, onClick: () => onInsert(pos, insertableType) }, insertableType.name)), $[9] = onInsert, $[10] = pos, $[11] = types, $[12] = t0) : t0 = $[12];
  let t1;
  return $[13] !== pos || $[14] !== t0 || $[15] !== text ? (t1 = /* @__PURE__ */ jsx(MenuGroup, { text, popover: MENU_POPOVER_PROPS$5, children: t0 }, pos), $[13] = pos, $[14] = t0, $[15] = text, $[16] = t1) : t1 = $[16], t1;
}
const MENU_BUTTON_POPOVER_PROPS$2 = {
  portal: !0,
  tone: "default"
}, EMPTY_ARRAY$i = [], ItemRow = forwardRef(function(props2, ref) {
  const $ = c(58), {
    sortable,
    value,
    insertableTypes,
    onInsert,
    onCopy,
    onRemove,
    readOnly,
    inputId,
    parentSchemaType,
    validation: validation2,
    children,
    presence,
    schemaType
  } = props2, hasError = validation2.filter(_temp$1H).length > 0, hasWarning = validation2.filter(_temp2$A).length > 0;
  let t0;
  $[0] !== onInsert ? (t0 = (pos, insertType) => {
    onInsert({
      position: pos,
      items: [getEmptyValue(insertType)]
    });
  }, $[0] = onInsert, $[1] = t0) : t0 = $[1];
  const handleInsert = t0;
  let t1;
  $[2] !== onInsert || $[3] !== value ? (t1 = () => {
    value && onInsert({
      position: "after",
      items: [value]
    });
  }, $[2] = onInsert, $[3] = value, $[4] = t1) : t1 = $[4];
  const handleDuplicate = t1;
  let t2;
  $[5] !== onCopy || $[6] !== value ? (t2 = () => {
    onCopy({
      items: [value]
    });
  }, $[5] = onCopy, $[6] = value, $[7] = t2) : t2 = $[7];
  const handleCopy = t2;
  let t3;
  bb0: {
    if (hasError) {
      t3 = "critical";
      break bb0;
    }
    if (hasWarning) {
      t3 = "caution";
      break bb0;
    }
    t3 = void 0;
  }
  const tone = t3, {
    t
  } = useTranslation(), disableActions = parentSchemaType.options?.disableActions || EMPTY_ARRAY$i;
  let t4, t5;
  $[8] !== disableActions || $[9] !== onRemove || $[10] !== t ? (t5 = !disableActions.includes("remove") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.remove"), tone: "critical", icon: TrashIcon, onClick: onRemove }, "remove"), $[8] = disableActions, $[9] = onRemove, $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== disableActions || $[13] !== handleCopy || $[14] !== t ? (t6 = !disableActions.includes("copy") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.copy"), icon: CopyIcon, onClick: handleCopy }, "copy"), $[12] = disableActions, $[13] = handleCopy, $[14] = t, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== disableActions || $[17] !== handleDuplicate || $[18] !== t ? (t7 = !disableActions.includes("duplicate") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.duplicate"), icon: AddDocumentIcon, onClick: handleDuplicate }, "duplicate"), $[16] = disableActions, $[17] = handleDuplicate, $[18] = t, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== disableActions || $[21] !== handleInsert || $[22] !== insertableTypes || $[23] !== t ? (t8 = !(disableActions.includes("add") || disableActions.includes("addBefore")) && /* @__PURE__ */ jsx(InsertMenuGroup, { pos: "before", types: insertableTypes, onInsert: handleInsert, text: t("inputs.array.action.add-before"), icon: InsertAboveIcon }), $[20] = disableActions, $[21] = handleInsert, $[22] = insertableTypes, $[23] = t, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] !== disableActions || $[26] !== handleInsert || $[27] !== insertableTypes || $[28] !== t ? (t9 = !disableActions.includes("add") && !disableActions.includes("addAfter") && /* @__PURE__ */ jsx(InsertMenuGroup, { pos: "after", types: insertableTypes, onInsert: handleInsert, text: t("inputs.array.action.add-after"), icon: InsertBelowIcon }), $[25] = disableActions, $[26] = handleInsert, $[27] = insertableTypes, $[28] = t, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9 ? (t10 = [t5, t6, t7, t8, t9].filter(Boolean), $[30] = t5, $[31] = t6, $[32] = t7, $[33] = t8, $[34] = t9, $[35] = t10) : t10 = $[35], t4 = t10;
  const menuItems = t4;
  let t11, t12;
  $[36] !== inputId || $[37] !== menuItems || $[38] !== readOnly ? (t12 = readOnly || menuItems.length === 0 ? null : /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(ContextMenuButton, {}), id: `${inputId}-menuButton`, popover: MENU_BUTTON_POPOVER_PROPS$2, menu: /* @__PURE__ */ jsx(Menu, { children: menuItems }) }), $[36] = inputId, $[37] = menuItems, $[38] = readOnly, $[39] = t12) : t12 = $[39], t11 = t12;
  const menu = t11, t13 = !!readOnly;
  let t14;
  $[40] !== presence ? (t14 = presence.length === 0 ? null : /* @__PURE__ */ jsx(FieldPresence, { presence, maxAvatars: 1 }), $[40] = presence, $[41] = t14) : t14 = $[41];
  let t15;
  $[42] !== validation2 ? (t15 = validation2.length > 0 ? /* @__PURE__ */ jsx(Box, { paddingX: 1, paddingY: 3, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: validation2 }) }) : null, $[42] = validation2, $[43] = t15) : t15 = $[43];
  const t16 = schemaType ? "flex-end" : "center";
  let t17;
  $[44] !== children ? (t17 = /* @__PURE__ */ jsx(Flex, { align: "flex-end", flex: 1, children: /* @__PURE__ */ jsx(Box, { flex: 1, marginRight: 2, children }) }), $[44] = children, $[45] = t17) : t17 = $[45];
  let t18;
  $[46] !== ref || $[47] !== t16 || $[48] !== t17 ? (t18 = /* @__PURE__ */ jsx(Flex, { align: t16, ref, children: t17 }), $[46] = ref, $[47] = t16, $[48] = t17, $[49] = t18) : t18 = $[49];
  let t19;
  return $[50] !== menu || $[51] !== sortable || $[52] !== t13 || $[53] !== t14 || $[54] !== t15 || $[55] !== t18 || $[56] !== tone ? (t19 = /* @__PURE__ */ jsx(RowLayout, { tone, readOnly: t13, menu, dragHandle: sortable, presence: t14, validation: t15, children: t18 }), $[50] = menu, $[51] = sortable, $[52] = t13, $[53] = t14, $[54] = t15, $[55] = t18, $[56] = tone, $[57] = t19) : t19 = $[57], t19;
});
function _temp$1H(item) {
  return item.level === "error";
}
function _temp2$A(item_0) {
  return item_0.level === "warning";
}
function NoItemsPlaceholder(t0) {
  const $ = c(5), {
    schemaType
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== schemaType.placeholder || $[1] !== t ? (t1 = schemaType.placeholder || t("inputs.array.no-items-label"), $[0] = schemaType.placeholder, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Card, { padding: 3, border: !0, radius: 2, children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: t1 }) }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
function nearestIndexOf(array, startIdx, searchElement) {
  return nearestIndex(array, startIdx, (element) => element === searchElement);
}
function nearestIndex(array, startIdx, predicate) {
  let lowerIdx = startIdx - 1, upperIdx = startIdx;
  const len = array.length;
  for (; lowerIdx > -1 || upperIdx < len; ) {
    const upper = array[upperIdx];
    if (upperIdx < len && predicate(upper, upperIdx))
      return upperIdx;
    const lower = array[lowerIdx];
    if (lowerIdx > -1 && predicate(lower, lowerIdx))
      return lowerIdx;
    lowerIdx--, upperIdx++;
  }
  return -1;
}
class ArrayOfPrimitivesInput extends PureComponent {
  _element = null;
  constructor(props2) {
    super(props2), this.state = {
      disableTransition: !1
    };
  }
  handleAppend = (itemValue) => {
    const {
      value = [],
      onIndexFocus,
      onItemAppend
    } = this.props;
    onItemAppend(itemValue), onIndexFocus(value.length);
  };
  handlePrepend = (itemValue) => {
    const {
      onIndexFocus,
      value = [],
      onItemPrepend
    } = this.props;
    onItemPrepend(itemValue), onIndexFocus(value.length);
  };
  handleSortEnd = (event) => {
    const {
      onIndexFocus,
      onMoveItem,
      value
    } = this.props;
    value && onMoveItem(event), onIndexFocus(event.toIndex);
  };
  // Enable transition when the user starts dragging an item
  handleItemMoveStart = () => {
    this.setState({
      disableTransition: !1
    });
  };
  // Disable transition when the user stops dragging an item.
  // Note: there's an issue with the transition of items when the sorting is completed, so we disable the
  // transition effect when the user stops dragging.
  handleItemMoveEnd = () => {
    this.setState({
      disableTransition: !0
    });
  };
  focus() {
    this._element && this._element.focus();
  }
  getSnapshotBeforeUpdate(prevProps) {
    const {
      focusPath: prevFocusPath = [],
      value: prevValue = []
    } = prevProps, {
      focusPath = [],
      value = []
    } = this.props;
    if (prevFocusPath[0] === focusPath[0] && prevValue.length !== value.length) {
      const focusIndex = focusPath[0], selection = window.getSelection();
      if (!(selection?.focusNode instanceof HTMLElement))
        return null;
      const input = selection.focusNode?.querySelector("input,textarea");
      return input instanceof HTMLInputElement ? {
        prevFocusedIndex: focusIndex,
        restoreSelection: {
          text: selection.toString(),
          start: input.selectionStart,
          end: input.selectionEnd,
          value: input.value
        }
      } : {};
    }
    return null;
  }
  componentDidUpdate(prevProps, prevState, snapshot2) {
    const {
      onIndexFocus
    } = this.props;
    if (snapshot2?.restoreSelection && prevProps.value) {
      const prevFocusedValue = prevProps.value[snapshot2.prevFocusedIndex], nearestIndex2 = nearestIndexOf(this.props.value || [], snapshot2.prevFocusedIndex, prevFocusedValue);
      if (nearestIndex2 === -1)
        return;
      const newInput = this._element?.querySelector(`[data-item-index='${nearestIndex2}'] input,textarea`);
      if (newInput instanceof HTMLInputElement) {
        newInput.focus();
        try {
          newInput.setSelectionRange(snapshot2.restoreSelection.start, snapshot2.restoreSelection.end);
        } catch {
        }
      }
      onIndexFocus(nearestIndex2);
    }
  }
  renderArrayItem = (props2) => {
    const {
      schemaType
    } = this.props, {
      key,
      ...rest
    } = props2, sortable = schemaType.options?.sortable !== !1;
    return /* @__PURE__ */ jsx(ItemRow, { ...rest, sortable, insertableTypes: schemaType.of }, key);
  };
  render() {
    const {
      schemaType,
      members,
      readOnly,
      renderInput,
      onUpload,
      onItemRemove,
      resolveUploader: resolveUploader2,
      elementProps,
      arrayFunctions: ArrayFunctions = ArrayOfPrimitivesFunctions,
      changed
    } = this.props, isSortable = !readOnly && get(schemaType, "options.sortable") !== !1, membersWithSortIds = members.map((member) => ({
      id: `${member.key}-${member.kind === "item" ? member.item.value : "error"}`,
      member
    }));
    return /* @__PURE__ */ jsxs(Stack, { space: 2, "data-testid": "array-primitives-input", children: [
      /* @__PURE__ */ jsx(UploadTargetCard, { types: schemaType.of, resolveUploader: resolveUploader2, onUpload, ...elementProps, tabIndex: 0, children: /* @__PURE__ */ jsx(Stack, { space: 1, children: membersWithSortIds.length === 0 ? /* @__PURE__ */ jsx(NoItemsPlaceholder, { schemaType }) : /* @__PURE__ */ jsx(Card, { padding: 1, border: !0, children: /* @__PURE__ */ jsx(List, { onItemMove: this.handleSortEnd, onItemMoveStart: this.handleItemMoveStart, onItemMoveEnd: this.handleItemMoveEnd, items: membersWithSortIds.map((m) => m.id), sortable: isSortable, gap: 1, children: membersWithSortIds.map(({
        member,
        id: id2
      }, index) => /* @__PURE__ */ jsxs(Item, { id: id2, sortable: isSortable, disableTransition: this.state.disableTransition, children: [
        member.kind === "item" && /* @__PURE__ */ jsx(ChangeIndicator, { path: member.item.path, isChanged: changed, hasFocus: !1, children: /* @__PURE__ */ jsx(ArrayOfPrimitivesItem, { member, renderItem: this.renderArrayItem, renderInput }) }),
        member.kind === "error" && /* @__PURE__ */ jsx(ErrorItem, { readOnly, sortable: isSortable, member, onRemove: () => onItemRemove(index) })
      ] }, member.key)) }) }) }) }),
      /* @__PURE__ */ jsx(ArrayFunctions, { onChange: this.props.onChange, onItemAppend: this.handleAppend, onItemPrepend: this.handlePrepend, onValueCreate: getEmptyValue, readOnly: this.props.readOnly, schemaType: this.props.schemaType, value: this.props.value })
    ] });
  }
}
function UniversalArrayInput(props2) {
  const $ = c(4);
  let t0;
  if (t0 = Array.isArray(props2.schemaType.options?.list), t0) {
    let t12;
    return $[0] !== props2 ? (t12 = /* @__PURE__ */ jsx(ArrayOfOptionsInput, { ...props2 }), $[0] = props2, $[1] = t12) : t12 = $[1], t12;
  }
  let t1;
  return $[2] !== props2 ? (t1 = isArrayOfPrimitivesInputProps(props2) ? /* @__PURE__ */ jsx(ArrayOfPrimitivesInput, { ...props2 }) : /* @__PURE__ */ jsx(ArrayOfObjectsInput, { ...props2 }), $[2] = props2, $[3] = t1) : t1 = $[3], t1;
}
const Root$o = styled(Card)`
  line-height: 1;
`, CenterAlignedBox = styled(Box)`
  align-self: center;
`, ZeroLineHeightBox = styled(Box)`
  line-height: 0;
`;
function BooleanInput(props2) {
  const $ = c(25), {
    t
  } = useTranslation(), {
    id: id2,
    value,
    schemaType,
    readOnly,
    elementProps,
    validation: validation2
  } = props2, layout = schemaType.options?.layout || "switch", indeterminate = typeof value != "boolean", checked = value || !1, LayoutSpecificInput = layout === "checkbox" ? Checkbox$1 : Switch$1, tone = readOnly ? "transparent" : void 0;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    margin: -4
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== LayoutSpecificInput || $[2] !== checked || $[3] !== elementProps || $[4] !== indeterminate || $[5] !== readOnly || $[6] !== schemaType.title ? (t1 = /* @__PURE__ */ jsx(ZeroLineHeightBox, { padding: 3, children: /* @__PURE__ */ jsx(LayoutSpecificInput, { label: schemaType.title, ...elementProps, checked, readOnly, indeterminate, style: t0 }) }), $[1] = LayoutSpecificInput, $[2] = checked, $[3] = elementProps, $[4] = indeterminate, $[5] = readOnly, $[6] = schemaType.title, $[7] = t1) : t1 = $[7];
  const input = t1;
  let t2;
  $[8] !== input || $[9] !== readOnly || $[10] !== t ? (t2 = readOnly ? /* @__PURE__ */ jsx(Tooltip, { content: t("inputs.boolean.disabled"), children: input }) : input, $[8] = input, $[9] = readOnly, $[10] = t, $[11] = t2) : t2 = $[11];
  let t3;
  $[12] !== id2 || $[13] !== schemaType.deprecated || $[14] !== schemaType.description || $[15] !== schemaType.title || $[16] !== validation2 ? (t3 = /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(FormFieldHeaderText, { deprecated: schemaType.deprecated, description: schemaType.description, inputId: id2, validation: validation2, title: schemaType.title }) }), $[12] = id2, $[13] = schemaType.deprecated, $[14] = schemaType.description, $[15] = schemaType.title, $[16] = validation2, $[17] = t3) : t3 = $[17];
  let t4;
  $[18] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(CenterAlignedBox, { paddingX: 3, paddingY: 1, children: /* @__PURE__ */ jsx(FormFieldStatus, { maxAvatars: 1, position: "top" }) }), $[18] = t4) : t4 = $[18];
  let t5;
  $[19] !== t2 || $[20] !== t3 ? (t5 = /* @__PURE__ */ jsxs(Flex, { children: [
    t2,
    t3,
    t4
  ] }), $[19] = t2, $[20] = t3, $[21] = t5) : t5 = $[21];
  let t6;
  return $[22] !== t5 || $[23] !== tone ? (t6 = /* @__PURE__ */ jsx(Root$o, { border: !0, "data-testid": "boolean-input", radius: 2, tone, children: t5 }), $[22] = t5, $[23] = tone, $[24] = t6) : t6 = $[24], t6;
}
function EmailInput(props2) {
  const $ = c(3), {
    validationError,
    elementProps
  } = props2;
  let t0;
  return $[0] !== elementProps || $[1] !== validationError ? (t0 = /* @__PURE__ */ jsx(TextInput$1, { ...elementProps, type: "email", inputMode: "email", customValidity: validationError }), $[0] = elementProps, $[1] = validationError, $[2] = t0) : t0 = $[2], t0;
}
const normalizeRules = (validation2, type) => {
  if (typeof validation2 == "function")
    throw new Error(`Schema type "${type?.name || "<not-found>"}"'s \`validation\` was not run though \`inferFromSchema\``);
  return validation2 ? Array.isArray(validation2) ? validation2 : [validation2] : [];
};
function getValidationRule(type, ruleName) {
  for (const rule of normalizeRules(type?.validation, type))
    for (const ruleSpec of rule._rules)
      if (ruleSpec.flag === ruleName)
        return ruleSpec;
  return null;
}
function getScrollableParent(node) {
  if (!node || !(node instanceof Element)) return null;
  let parent = node.parentElement;
  for (; parent; ) {
    const overflowY = window.getComputedStyle(parent).overflowY;
    if ((overflowY === "auto" || overflowY === "scroll") && parent.scrollHeight > parent.clientHeight)
      return parent;
    parent = parent.parentElement;
  }
  return window;
}
function preventWheel(event) {
  if (event.currentTarget && document.activeElement === event.currentTarget) {
    event.preventDefault();
    const scrollContainer = getScrollableParent(event.currentTarget);
    scrollContainer && scrollContainer.scrollBy({
      top: event.deltaY,
      left: event.deltaX,
      behavior: "instant"
    });
  }
}
function NumberInput(props2) {
  const $ = c(10), {
    schemaType,
    validationError,
    elementProps
  } = props2, minRule = getValidationRule(schemaType, "min"), integerRule = getValidationRule(schemaType, "integer"), precisionRule = getValidationRule(schemaType, "precision"), onlyPositiveNumber = typeof minRule?.constraint == "number" && minRule?.constraint >= 0, onlyIntegers = integerRule || precisionRule?.constraint === 0, inputMode = onlyPositiveNumber ? onlyIntegers ? "numeric" : "decimal" : "text", inputElementRef = elementProps.ref;
  let t0;
  $[0] !== inputElementRef.current ? (t0 = () => {
    const element = inputElementRef.current;
    return element.addEventListener("wheel", preventWheel), () => {
      element.removeEventListener("wheel", preventWheel);
    };
  }, $[0] = inputElementRef.current, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== inputElementRef ? (t1 = [inputElementRef], $[2] = inputElementRef, $[3] = t1) : t1 = $[3], useEffect(t0, t1);
  const t2 = onlyPositiveNumber ? "[d]*" : void 0;
  let t3;
  return $[4] !== elementProps || $[5] !== inputMode || $[6] !== schemaType.placeholder || $[7] !== t2 || $[8] !== validationError ? (t3 = /* @__PURE__ */ jsx(TextInput$1, { ...elementProps, type: "number", step: "any", inputMode, customValidity: validationError, placeholder: schemaType.placeholder, pattern: t2, max: Number.MAX_SAFE_INTEGER, min: Number.MIN_SAFE_INTEGER, "data-testid": "number-input" }), $[4] = elementProps, $[5] = inputMode, $[6] = schemaType.placeholder, $[7] = t2, $[8] = validationError, $[9] = t3) : t3 = $[9], t3;
}
const GroupTab = forwardRef(function(props2, ref) {
  const $ = c(9), {
    onClick: onClick2
  } = props2;
  let t0;
  $[0] !== onClick2 || $[1] !== props2.name ? (t0 = () => {
    onClick2?.(props2.name);
  }, $[0] = onClick2, $[1] = props2.name, $[2] = t0) : t0 = $[2];
  const handleClick = t0, t1 = `group-tab-${props2.name}`, t2 = `${props2.name}-tab`;
  let t3;
  return $[3] !== handleClick || $[4] !== props2 || $[5] !== ref || $[6] !== t1 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tab, { "data-testid": t1, id: t2, label: props2.title, ref, ...props2, onClick: handleClick }), $[3] = handleClick, $[4] = props2, $[5] = ref, $[6] = t1, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}), GroupOption = (props2) => {
  const $ = c(12);
  let name, rest, title;
  $[0] !== props2 ? ({
    name,
    title,
    ...rest
  } = props2, $[0] = props2, $[1] = name, $[2] = rest, $[3] = title) : (name = $[1], rest = $[2], title = $[3]);
  const {
    selected
  } = props2, t0 = `${name}-tab`, t1 = rest["aria-controls"], t2 = `group-select-${name}`, t3 = selected ? "true" : "false", t4 = title || name;
  let t5;
  return $[4] !== name || $[5] !== t0 || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== title ? (t5 = /* @__PURE__ */ jsx("option", { title, value: name, id: t0, "aria-controls": t1, "data-testid": t2, "aria-selected": t3, children: t4 }), $[4] = name, $[5] = t0, $[6] = t1, $[7] = t2, $[8] = t3, $[9] = t4, $[10] = title, $[11] = t5) : t5 = $[11], t5;
}, Root$n = styled(ElementQuery)`
  /* Hide on small screens */
  &[data-eq-max~='0'] [data-ui='TabList'] {
    display: none;
  }

  /* Hide on medium to large screens */
  [data-ui='Select'] {
    display: none;
  }

  /* Show on small screens */
  &[data-eq-max~='0'] [data-ui='Select'] {
    display: block;
  }
`, GroupTabs = (t0) => {
  const $ = c(15), {
    inputId,
    groups,
    onClick: onClick2,
    shouldAutoFocus: t1,
    disabled
  } = t0, shouldAutoFocus = t1 === void 0 ? !0 : t1, {
    t
  } = useTranslation();
  let t2;
  if ($[0] !== disabled || $[1] !== groups || $[2] !== inputId || $[3] !== onClick2 || $[4] !== shouldAutoFocus || $[5] !== t) {
    let t32;
    $[7] !== disabled || $[8] !== inputId || $[9] !== onClick2 || $[10] !== shouldAutoFocus || $[11] !== t ? (t32 = (group2) => {
      const title = group2.i18n?.title ? t(group2.i18n.title.key, {
        ns: group2.i18n.title.ns
      }) : group2.title || group2.name;
      return /* @__PURE__ */ jsx(GroupTab, { "aria-controls": `${inputId}-field-group-fields`, autoFocus: shouldAutoFocus && group2.selected, disabled: disabled || group2.disabled, icon: group2?.icon, name: group2.name, onClick: onClick2, selected: !!group2.selected, title }, `${inputId}-${group2.name}-tab`);
    }, $[7] = disabled, $[8] = inputId, $[9] = onClick2, $[10] = shouldAutoFocus, $[11] = t, $[12] = t32) : t32 = $[12], t2 = groups.map(t32), $[0] = disabled, $[1] = groups, $[2] = inputId, $[3] = onClick2, $[4] = shouldAutoFocus, $[5] = t, $[6] = t2;
  } else
    t2 = $[6];
  let t3;
  return $[13] !== t2 ? (t3 = /* @__PURE__ */ jsx(TabList, { space: 2, "data-testid": "field-group-tabs", children: t2 }), $[13] = t2, $[14] = t3) : t3 = $[14], t3;
}, GroupSelect = (t0) => {
  const $ = c(18), {
    disabled,
    groups,
    inputId,
    onSelect,
    shouldAutoFocus: t1
  } = t0, shouldAutoFocus = t1 === void 0 ? !0 : t1;
  let t2;
  $[0] !== onSelect ? (t2 = (event) => {
    onSelect(event.currentTarget.value);
  }, $[0] = onSelect, $[1] = t2) : t2 = $[1];
  const handleSelect = t2, {
    t
  } = useTranslation();
  let t3;
  $[2] !== t ? (t3 = t("inputs.object.field-group-tabs.aria-label"), $[2] = t, $[3] = t3) : t3 = $[3];
  const t4 = groups.find(_temp$1G)?.name;
  let t5;
  if ($[4] !== groups || $[5] !== inputId || $[6] !== t) {
    let t62;
    $[8] !== inputId || $[9] !== t ? (t62 = (group2) => {
      const title = group2.i18n?.title ? t(group2.i18n.title.key, {
        ns: group2.i18n.title.ns
      }) : group2.title || group2.name;
      return /* @__PURE__ */ jsx(GroupOption, { "aria-controls": `${inputId}-field-group-fields`, disabled: group2.disabled, name: group2.name, selected: !!group2.selected, title }, `${inputId}-${group2.name}-tab`);
    }, $[8] = inputId, $[9] = t, $[10] = t62) : t62 = $[10], t5 = groups.map(t62), $[4] = groups, $[5] = inputId, $[6] = t, $[7] = t5;
  } else
    t5 = $[7];
  let t6;
  return $[11] !== disabled || $[12] !== handleSelect || $[13] !== shouldAutoFocus || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Select, { "aria-label": t3, autoFocus: shouldAutoFocus, "data-testid": "field-group-select", disabled, fontSize: 2, muted: !0, onChange: handleSelect, value: t4, children: t5 }), $[11] = disabled, $[12] = handleSelect, $[13] = shouldAutoFocus, $[14] = t3, $[15] = t4, $[16] = t5, $[17] = t6) : t6 = $[17], t6;
}, FieldGroupTabs = memo(function(t0) {
  const $ = c(10);
  let onClick2, props2, t1;
  $[0] !== t0 ? ({
    disabled: t1,
    onClick: onClick2,
    ...props2
  } = t0, $[0] = t0, $[1] = onClick2, $[2] = props2, $[3] = t1) : (onClick2 = $[1], props2 = $[2], t1 = $[3]);
  const disabled = t1 === void 0 ? !1 : t1;
  let t2;
  $[4] !== onClick2 ? (t2 = (groupName) => {
    onClick2?.(groupName);
  }, $[4] = onClick2, $[5] = t2) : t2 = $[5];
  const handleClick = t2;
  let t3;
  return $[6] !== disabled || $[7] !== handleClick || $[8] !== props2 ? (t3 = /* @__PURE__ */ jsxs(Root$n, { "data-testid": "field-group-root", children: [
    /* @__PURE__ */ jsx(GroupTabs, { ...props2, disabled, onClick: handleClick }),
    /* @__PURE__ */ jsx(GroupSelect, { ...props2, disabled, onSelect: handleClick })
  ] }), $[6] = disabled, $[7] = handleClick, $[8] = props2, $[9] = t3) : t3 = $[9], t3;
});
function _temp$1G(g) {
  return g.selected;
}
const FieldGroupTabsWrapper = styled(Card)`
  margin-bottom: ${({
  $level,
  theme
}) => $level === 0 ? 0 : theme.sanity.space[5] * -1}px;
  padding-bottom: ${({
  $level,
  theme
}) => theme.sanity.space[4]}px;
`, AlignedBottomGrid = styled(Grid)`
  align-items: flex-end;
`;
function UnknownFields(props2) {
  const $ = c(38), {
    fieldNames,
    onChange,
    readOnly,
    value
  } = props2, fieldsLen = fieldNames.length;
  let t0;
  $[0] !== onChange ? (t0 = (fieldName) => {
    onChange(unset([fieldName]));
  }, $[0] = onChange, $[1] = t0) : t0 = $[1];
  const handleUnsetClick = t0, {
    t
  } = useTranslation();
  let t1;
  $[2] !== fieldsLen || $[3] !== t ? (t1 = t("inputs.object.unknown-fields.warning.title", {
    count: fieldsLen
  }), $[2] = fieldsLen, $[3] = t, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== t1 ? (t2 = /* @__PURE__ */ jsx(Fragment, { children: t1 }), $[5] = t1, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== fieldsLen || $[8] !== t ? (t3 = t("inputs.object.unknown-fields.warning.description", {
    count: fieldsLen
  }), $[7] = fieldsLen, $[8] = t, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Fragment, { children: t3 }) }), $[10] = t3, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== t ? (t5 = t("inputs.object.unknown-fields.warning.details.title"), $[12] = t, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== fieldsLen || $[15] !== t ? (t6 = t("inputs.object.unknown-fields.warning.details.description", {
    count: fieldsLen
  }), $[14] = fieldsLen, $[15] = t, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { marginBottom: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Fragment, { children: t6 }) }) }), $[17] = t6, $[18] = t7) : t7 = $[18];
  let t8;
  if ($[19] !== fieldNames || $[20] !== handleUnsetClick || $[21] !== readOnly || $[22] !== value) {
    let t92;
    $[24] !== handleUnsetClick || $[25] !== readOnly || $[26] !== value ? (t92 = (fieldName_0) => /* @__PURE__ */ jsx(UnknownField, { fieldName: fieldName_0, onUnsetClick: handleUnsetClick, readOnly, value: value?.[fieldName_0] }, fieldName_0), $[24] = handleUnsetClick, $[25] = readOnly, $[26] = value, $[27] = t92) : t92 = $[27], t8 = fieldNames.map(t92), $[19] = fieldNames, $[20] = handleUnsetClick, $[21] = readOnly, $[22] = value, $[23] = t8;
  } else
    t8 = $[23];
  let t9;
  $[28] !== t8 ? (t9 = /* @__PURE__ */ jsx(Stack, { as: "ul", space: 3, children: t8 }), $[28] = t8, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== t5 || $[31] !== t7 || $[32] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Details, { marginTop: 4, open: isDev, title: t5, children: [
    t7,
    t9
  ] }), $[30] = t5, $[31] = t7, $[32] = t9, $[33] = t10) : t10 = $[33];
  let t11;
  return $[34] !== t10 || $[35] !== t2 || $[36] !== t4 ? (t11 = /* @__PURE__ */ jsxs(Alert, { status: "warning", title: t2, children: [
    t4,
    t10
  ] }), $[34] = t10, $[35] = t2, $[36] = t4, $[37] = t11) : t11 = $[37], t11;
}
function UnknownField(t0) {
  const $ = c(21), {
    fieldName,
    onUnsetClick,
    readOnly,
    value
  } = t0;
  let t1;
  $[0] !== fieldName || $[1] !== onUnsetClick ? (t1 = () => {
    onUnsetClick(fieldName);
  }, $[0] = fieldName, $[1] = onUnsetClick, $[2] = t1) : t1 = $[2];
  const handleUnsetClick = t1, {
    t
  } = useTranslation();
  let t2;
  $[3] !== fieldName ? (t2 = /* @__PURE__ */ jsx(Card, { padding: 3, shadow: 1, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { size: 1, children: fieldName }) }), $[3] = fieldName, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== value ? (t3 = JSON.stringify(value, null, 2), $[5] = value, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { overflow: "auto", padding: 3, children: /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t3 }) }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== readOnly || $[10] !== t ? (t5 = readOnly && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.object.unknown-fields.read-only.description" }) }) }), $[9] = readOnly, $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== handleUnsetClick || $[13] !== readOnly || $[14] !== t ? (t6 = !readOnly && /* @__PURE__ */ jsx(Card, { padding: 3, shadow: 1, tone: "inherit", children: /* @__PURE__ */ jsx(Button, { icon: TrashIcon, mode: "ghost", onClick: handleUnsetClick, size: "large", tone: "critical", text: t("inputs.object.unknown-fields.remove-field-button.text") }) }), $[12] = handleUnsetClick, $[13] = readOnly, $[14] = t, $[15] = t6) : t6 = $[15];
  let t7;
  return $[16] !== t2 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Card, { as: "li", overflow: "hidden", radius: 2, shadow: 1, tone: "caution", children: [
    t2,
    t4,
    t5,
    t6
  ] }), $[16] = t2, $[17] = t4, $[18] = t5, $[19] = t6, $[20] = t7) : t7 = $[20], t7;
}
const RootStack$2 = styled(Stack)`
  // Disable focus ring for the object block. We instead highlight the left border on the fieldset
  // for level > 0 to signal that you have focused on the object
  &:focus {
    outline: none;
  }
`, ObjectInput = memo(function(props2) {
  const $ = c(43), {
    __internal_arrayEditingModal: t0,
    groups,
    id: id2,
    members,
    onChange,
    onFieldGroupSelect,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    path,
    level,
    value,
    onPathFocus
  } = props2, arrayEditingModal = t0 === void 0 ? null : t0, wrapperRef = useRef(null);
  let t1;
  $[0] !== schemaType.options ? (t1 = schemaType.options || {}, $[0] = schemaType.options, $[1] = t1) : t1 = $[1];
  const {
    columns
  } = t1;
  let t2;
  t2 = id2 !== "root" && !(path.length > 0 && isKeySegment(last$1(path)));
  const isFocusable = t2;
  let t3;
  bb0: {
    if (!schemaType.fields) {
      t3 = null;
      break bb0;
    }
    let t42;
    if ($[2] !== schemaType.fields || $[3] !== value) {
      const knownFieldNames = schemaType.fields.map(_temp$1F);
      t42 = Object.keys(value || {}).filter((key) => !key.startsWith("_") && !knownFieldNames.includes(key)), $[2] = schemaType.fields, $[3] = value, $[4] = t42;
    } else
      t42 = $[4];
    const unknownFields = t42;
    if (unknownFields.length === 0) {
      t3 = null;
      break bb0;
    }
    let t52;
    $[5] !== onChange || $[6] !== unknownFields || $[7] !== value ? (t52 = /* @__PURE__ */ jsx(UnknownFields, { fieldNames: unknownFields, value, onChange }), $[5] = onChange, $[6] = unknownFields, $[7] = value, $[8] = t52) : t52 = $[8], t3 = t52;
  }
  const renderedUnknownFields = t3;
  let t4, t5;
  $[9] !== groups ? (t5 = groups.find(_temp2$z), $[9] = groups, $[10] = t5) : t5 = $[10], t4 = t5;
  const selectedGroup = t4;
  let t6;
  $[11] !== isFocusable || $[12] !== onPathFocus ? (t6 = (event) => {
    isFocusable && event.target === wrapperRef.current && onPathFocus(EMPTY_ARRAY$A);
  }, $[11] = isFocusable, $[12] = onPathFocus, $[13] = t6) : t6 = $[13];
  const handleFocus = t6;
  let t7;
  $[14] !== members || $[15] !== renderAnnotation || $[16] !== renderBlock2 || $[17] !== renderField || $[18] !== renderInlineBlock || $[19] !== renderInput || $[20] !== renderItem2 || $[21] !== renderPreview ? (t7 = () => /* @__PURE__ */ jsx(ObjectInputMembers, { members, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }), $[14] = members, $[15] = renderAnnotation, $[16] = renderBlock2, $[17] = renderField, $[18] = renderInlineBlock, $[19] = renderInput, $[20] = renderItem2, $[21] = renderPreview, $[22] = t7) : t7 = $[22];
  const renderObjectMembers = t7;
  if (members.length === 0)
    return null;
  const t8 = isFocusable ? 0 : void 0;
  let t9;
  $[23] !== groups || $[24] !== id2 || $[25] !== level || $[26] !== onFieldGroupSelect ? (t9 = groups.length > 0 ? /* @__PURE__ */ jsx(FieldGroupTabsWrapper, { $level: level, "data-testid": "field-groups", children: /* @__PURE__ */ jsx(FieldGroupTabs, { groups, inputId: id2, onClick: onFieldGroupSelect, shouldAutoFocus: !1 }) }) : null, $[23] = groups, $[24] = id2, $[25] = level, $[26] = onFieldGroupSelect, $[27] = t9) : t9 = $[27];
  const t10 = selectedGroup?.name;
  let t11;
  $[28] !== columns || $[29] !== renderObjectMembers ? (t11 = columns ? /* @__PURE__ */ jsx(AlignedBottomGrid, { columns, gap: 4, marginTop: 1, children: renderObjectMembers() }) : renderObjectMembers(), $[28] = columns, $[29] = renderObjectMembers, $[30] = t11) : t11 = $[30];
  let t12;
  $[31] !== t10 || $[32] !== t11 ? (t12 = /* @__PURE__ */ jsx(Fragment$1, { children: t11 }, t10), $[31] = t10, $[32] = t11, $[33] = t12) : t12 = $[33];
  let t13;
  $[34] !== handleFocus || $[35] !== renderedUnknownFields || $[36] !== t12 || $[37] !== t8 || $[38] !== t9 ? (t13 = /* @__PURE__ */ jsxs(RootStack$2, { space: 6, tabIndex: t8, onFocus: handleFocus, ref: wrapperRef, children: [
    t9,
    t12,
    renderedUnknownFields
  ] }), $[34] = handleFocus, $[35] = renderedUnknownFields, $[36] = t12, $[37] = t8, $[38] = t9, $[39] = t13) : t13 = $[39];
  let t14;
  return $[40] !== arrayEditingModal || $[41] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Fragment, { children: [
    arrayEditingModal,
    t13
  ] }), $[40] = arrayEditingModal, $[41] = t13, $[42] = t14) : t14 = $[42], t14;
});
function _temp$1F(field) {
  return field.name;
}
function _temp2$z(t0) {
  const {
    selected
  } = t0;
  return selected;
}
const defaultSlugify = (value, type) => {
  const maxLength = type.options?.maxLength;
  return value ? speakingurl(value, {
    truncate: typeof maxLength == "number" ? maxLength : 200,
    symbols: !0
  }) : "";
};
async function slugify(sourceValue, type, context) {
  return sourceValue && (type.options?.slugify || defaultSlugify)(sourceValue, type, context);
}
function useAsync(fn) {
  const $ = c(5), [state, setState] = useState(null), lastId = useRef(0);
  let t0;
  $[0] !== fn ? (t0 = (arg) => {
    const asyncId = lastId.current = lastId.current + 1;
    setState({
      status: "pending"
    }), Promise.resolve().then(() => fn(arg)).then((res) => {
      asyncId === lastId.current && setState({
        status: "complete",
        result: res
      });
    }, (err) => {
      asyncId === lastId.current && setState({
        status: "error",
        error: err
      });
    });
  }, $[0] = fn, $[1] = t0) : t0 = $[1];
  const wrappedCallback = t0;
  let t1;
  return $[2] !== state || $[3] !== wrappedCallback ? (t1 = [state, wrappedCallback], $[2] = state, $[3] = wrappedCallback, $[4] = t1) : t1 = $[4], t1;
}
function useSlugContext() {
  const $ = c(6), {
    getClient: getClient2
  } = useSource(), schema2 = useSchema(), currentUser = useCurrentUser(), projectId = useProjectId$1(), dataset = useDataset();
  let t0, t1;
  return $[0] !== currentUser || $[1] !== dataset || $[2] !== getClient2 || $[3] !== projectId || $[4] !== schema2 ? (t1 = {
    projectId,
    dataset,
    getClient: getClient2,
    schema: schema2,
    currentUser
  }, $[0] = currentUser, $[1] = dataset, $[2] = getClient2, $[3] = projectId, $[4] = schema2, $[5] = t1) : t1 = $[5], t0 = t1, t0;
}
function getSlugSourceContext(valuePath, document2, context) {
  const parentPath = valuePath.slice(0, -1), parent = PathUtils.get(document2, parentPath);
  return {
    parentPath,
    parent,
    ...context
  };
}
async function getNewFromSource(source, document2, context) {
  return typeof source == "function" ? source(document2, context) : PathUtils.get(document2, source);
}
function SlugInput(props2) {
  const $ = c(37), getFormValue = useGetFormValue(), {
    path,
    value,
    schemaType,
    validation: validation2,
    onChange,
    readOnly,
    elementProps
  } = props2, sourceField = schemaType.options?.source;
  let t0, t1;
  $[0] !== validation2 ? (t1 = validation2.filter(_temp$1E), $[0] = validation2, $[1] = t1) : t1 = $[1], t0 = t1;
  const errors = t0, slugContext = useSlugContext(), {
    t
  } = useTranslation();
  let t2;
  $[2] !== onChange || $[3] !== schemaType.name ? (t2 = (nextSlug) => {
    if (!nextSlug) {
      onChange(PatchEvent.from(unset([])));
      return;
    }
    onChange(PatchEvent.from([setIfMissing({
      _type: schemaType.name
    }), set(nextSlug, ["current"])]));
  }, $[2] = onChange, $[3] = schemaType.name, $[4] = t2) : t2 = $[4];
  const updateSlug = t2;
  let t3;
  $[5] !== getFormValue || $[6] !== path || $[7] !== schemaType || $[8] !== slugContext || $[9] !== sourceField || $[10] !== t || $[11] !== updateSlug ? (t3 = () => {
    if (!sourceField)
      return Promise.reject(new Error(t("inputs.slug.error.missing-source", {
        schemaType: schemaType.name
      })));
    const doc = getFormValue([]) || {
      _type: schemaType.name
    }, sourceContext = getSlugSourceContext(path, doc, slugContext);
    return getNewFromSource(sourceField, doc, sourceContext).then((newFromSource) => slugify(newFromSource || "", schemaType, sourceContext)).then((newSlug) => updateSlug(newSlug));
  }, $[5] = getFormValue, $[6] = path, $[7] = schemaType, $[8] = slugContext, $[9] = sourceField, $[10] = t, $[11] = updateSlug, $[12] = t3) : t3 = $[12];
  const handleAsyncGenerateSlug = t3, [generateState, handleGenerateSlug] = useAsync(handleAsyncGenerateSlug), isUpdating = generateState?.status === "pending";
  let t4;
  $[13] !== updateSlug ? (t4 = (event) => updateSlug(event.currentTarget.value), $[13] = updateSlug, $[14] = t4) : t4 = $[14];
  const handleChange = t4, t5 = errors.length > 0 ? errors[0].message : "", t6 = value?.current || "";
  let t7;
  $[15] !== elementProps || $[16] !== handleChange || $[17] !== isUpdating || $[18] !== readOnly || $[19] !== t5 || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsx(TextInput$1, { customValidity: t5, disabled: isUpdating, onChange: handleChange, value: t6, readOnly, ...elementProps }), $[15] = elementProps, $[16] = handleChange, $[17] = isUpdating, $[18] = readOnly, $[19] = t5, $[20] = t6, $[21] = t7) : t7 = $[21];
  let t8;
  $[22] !== generateState ? (t8 = generateState?.status === "error" && /* @__PURE__ */ jsx(Card, { padding: 2, tone: "critical", children: generateState.error.message }), $[22] = generateState, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== t7 || $[25] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Box, { flex: 1, children: [
    t7,
    t8
  ] }), $[24] = t7, $[25] = t8, $[26] = t9) : t9 = $[26];
  let t10;
  $[27] !== generateState?.status || $[28] !== handleGenerateSlug || $[29] !== isUpdating || $[30] !== readOnly || $[31] !== sourceField || $[32] !== t ? (t10 = sourceField && /* @__PURE__ */ jsx(Button, { mode: "ghost", type: "button", disabled: readOnly || isUpdating, onClick: handleGenerateSlug, size: "large", text: generateState?.status === "pending" ? t("inputs.slug.action.generating") : t("inputs.slug.action.generate") }), $[27] = generateState?.status, $[28] = handleGenerateSlug, $[29] = isUpdating, $[30] = readOnly, $[31] = sourceField, $[32] = t, $[33] = t10) : t10 = $[33];
  let t11;
  return $[34] !== t10 || $[35] !== t9 ? (t11 = /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t9,
    t10
  ] }) }), $[34] = t10, $[35] = t9, $[36] = t11) : t11 = $[36], t11;
}
function _temp$1E(item) {
  return item.level === "error";
}
function StringInput(props2) {
  const $ = c(3), {
    validationError,
    elementProps
  } = props2;
  let t0;
  return $[0] !== elementProps || $[1] !== validationError ? (t0 = /* @__PURE__ */ jsx(TextInput$1, { ...elementProps, customValidity: validationError, "data-testid": "string-input" }), $[0] = elementProps, $[1] = validationError, $[2] = t0) : t0 = $[2], t0;
}
const StyledTextArea = styled(TextArea)`
  &[data-as='textarea'] {
    resize: vertical;
  }
`;
function TextInput(props2) {
  const $ = c(6), {
    schemaType,
    validationError,
    value,
    elementProps
  } = props2, t0 = value || "", t1 = typeof schemaType.rows == "number" ? schemaType.rows : 10;
  let t2;
  return $[0] !== elementProps || $[1] !== schemaType.placeholder || $[2] !== t0 || $[3] !== t1 || $[4] !== validationError ? (t2 = /* @__PURE__ */ jsx(StyledTextArea, { customValidity: validationError, value: t0, placeholder: schemaType.placeholder, rows: t1, ...elementProps }), $[0] = elementProps, $[1] = schemaType.placeholder, $[2] = t0, $[3] = t1, $[4] = validationError, $[5] = t2) : t2 = $[5], t2;
}
function UrlInput(props2) {
  const $ = c(4), {
    schemaType,
    validationError,
    elementProps
  } = props2, inputType = getValidationRule(schemaType, "uri")?.constraint?.options?.allowRelative ? "text" : "url";
  let t0;
  return $[0] !== elementProps || $[1] !== inputType || $[2] !== validationError ? (t0 = /* @__PURE__ */ jsx(TextInput$1, { type: inputType, inputMode: "url", customValidity: validationError, ...elementProps }), $[0] = elementProps, $[1] = inputType, $[2] = validationError, $[3] = t0) : t0 = $[3], t0;
}
function DisabledFeatureWarning(t0) {
  const $ = c(29), {
    value,
    onClearValue
  } = t0;
  let t1;
  t1 = !!value?._ref;
  const hasRef = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    DocumentationLink: _temp$1D
  }, $[0] = t2) : t2 = $[0];
  let t3;
  $[1] !== t ? (t3 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.cross-dataset.feature-disabled-description", components: t2 }), $[1] = t, $[2] = t3) : t3 = $[2];
  const description = t3, t4 = hasRef ? 4 : void 0;
  let t5;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[3] = t5) : t5 = $[3];
  let t6;
  $[4] !== t ? (t6 = t("inputs.reference.cross-dataset.feature-unavailable-title"), $[4] = t, $[5] = t6) : t6 = $[5];
  let t7;
  $[6] !== t6 ? (t7 = /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "medium", children: t6 }), $[6] = t6, $[7] = t7) : t7 = $[7];
  let t8;
  $[8] !== description || $[9] !== hasRef || $[10] !== t ? (t8 = hasRef && /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: description }),
    /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: t("inputs.reference.cross-dataset.feature-disabled-actions") })
  ] }), $[8] = description, $[9] = hasRef, $[10] = t, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== description || $[13] !== hasRef ? (t9 = !hasRef && /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: description }), $[12] = description, $[13] = hasRef, $[14] = t9) : t9 = $[14];
  let t10;
  $[15] !== t7 || $[16] !== t8 || $[17] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t7,
    t8,
    t9
  ] }), $[15] = t7, $[16] = t8, $[17] = t9, $[18] = t10) : t10 = $[18];
  let t11;
  $[19] !== t10 || $[20] !== t4 ? (t11 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: t4, children: [
    t5,
    t10
  ] }), $[19] = t10, $[20] = t4, $[21] = t11) : t11 = $[21];
  let t12;
  $[22] !== hasRef || $[23] !== onClearValue || $[24] !== t ? (t12 = onClearValue && hasRef && /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearValue, text: t("inputs.reference.action.clear"), width: "fill" }), $[22] = hasRef, $[23] = onClearValue, $[24] = t, $[25] = t12) : t12 = $[25];
  let t13;
  return $[26] !== t11 || $[27] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Card, { tone: "caution", padding: 4, border: !0, radius: 2, "data-testid": "alert-cross-dataset-reference-feature-disabled", children: [
    t11,
    t12
  ] }), $[26] = t11, $[27] = t12, $[28] = t13) : t13 = $[28], t13;
}
function _temp$1D(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/cross-dataset-references", target: "_blank", rel: "noreferrer", children });
}
const StyledPreviewFlex$1 = styled(Flex)`
  /* this is a hack to avoid layout jumps while previews are loading
  or the message is not tall enough to fill the card
  there's probably better ways of solving this */
  min-height: 36px;
`;
function CrossDatasetReferencePreview(props2) {
  const $ = c(37), {
    refType,
    showStudioUrlIcon,
    hasStudioUrl,
    showTypeLabel,
    availability,
    preview,
    id: id2,
    dataset,
    projectId
  } = props2, notFound = availability?.reason === "NOT_FOUND", insufficientPermissions = availability?.reason === "PERMISSION_DENIED", previewMedia = preview.published?.media, {
    t
  } = useTranslation();
  let t0;
  bb0: {
    if (previewMedia) {
      const isValidImageAsset = typeof previewMedia?.asset < "u" && isImageSource(previewMedia);
      let t13;
      $[0] !== previewMedia ? (t13 = isValidElement(previewMedia), $[0] = previewMedia, $[1] = t13) : t13 = $[1];
      const isValidElement$1 = t13;
      if (!isValidImageAsset && !isValidElement$1) {
        t0 = null;
        break bb0;
      }
      let t22;
      $[2] !== dataset || $[3] !== isValidElement$1 || $[4] !== previewMedia || $[5] !== projectId || $[6] !== t ? (t22 = function(t32) {
        const {
          dimensions
        } = t32;
        return isValidElement$1 ? previewMedia : /* @__PURE__ */ jsx("img", { src: imageUrlBuilder({
          dataset,
          projectId
        }).image(previewMedia).withOptions(dimensions).url(), alt: t("inputs.reference.image-preview-alt-text"), referrerPolicy: "strict-origin-when-cross-origin" });
      }, $[2] = dataset, $[3] = isValidElement$1, $[4] = previewMedia, $[5] = projectId, $[6] = t, $[7] = t22) : t22 = $[7], t0 = t22;
      break bb0;
    }
    if (!refType?.icon) {
      t0 = null;
      break bb0;
    }
    const Icon2 = refType.icon;
    let t12;
    $[8] !== Icon2 ? (t12 = /* @__PURE__ */ jsx(Icon2, {}), $[8] = Icon2, $[9] = t12) : t12 = $[9], t0 = t12;
  }
  const media = t0;
  let t1;
  $[10] !== availability?.available || $[11] !== media || $[12] !== preview.published?.subtitle || $[13] !== preview.published?.title || $[14] !== t ? (t1 = availability?.available ? /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(DefaultPreview, { title: preview.published?.title, subtitle: preview.published?.subtitle, media: media || !1 }) }) : /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: t("inputs.reference.error.document-unavailable-title") }) }) }) }), $[10] = availability?.available, $[11] = media, $[12] = preview.published?.subtitle, $[13] = preview.published?.title, $[14] = t, $[15] = t1) : t1 = $[15];
  let t2;
  $[16] !== refType || $[17] !== showTypeLabel ? (t2 = refType && showTypeLabel && /* @__PURE__ */ jsx(Badge, { mode: "outline", children: refType.title || refType.type }), $[16] = refType, $[17] = showTypeLabel, $[18] = t2) : t2 = $[18];
  let t3;
  $[19] !== id2 || $[20] !== insufficientPermissions || $[21] !== notFound || $[22] !== t ? (t3 = (insufficientPermissions || notFound) && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t(notFound ? "inputs.reference.referenced-document-does-not-exist" : "inputs.reference.referenced-document-insufficient-permissions", {
    documentId: id2
  }), children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", children: insufficientPermissions ? /* @__PURE__ */ jsx(AccessDeniedIcon, {}) : /* @__PURE__ */ jsx(HelpCircleIcon, {}) }) }) }), $[19] = id2, $[20] = insufficientPermissions, $[21] = notFound, $[22] = t, $[23] = t3) : t3 = $[23];
  let t4;
  $[24] !== hasStudioUrl || $[25] !== insufficientPermissions || $[26] !== notFound || $[27] !== showStudioUrlIcon || $[28] !== t ? (t4 = !(notFound || insufficientPermissions) && showStudioUrlIcon && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t(hasStudioUrl ? "inputs.reference.document-opens-in-new-tab" : "input.reference.document-cannot-be-opened.failed-to-resolve-url"), children: /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "default", muted: !hasStudioUrl, children: /* @__PURE__ */ jsx(LaunchIcon, {}) }) }) }), $[24] = hasStudioUrl, $[25] = insufficientPermissions, $[26] = notFound, $[27] = showStudioUrlIcon, $[28] = t, $[29] = t4) : t4 = $[29];
  let t5;
  $[30] !== t2 || $[31] !== t3 || $[32] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { paddingLeft: 3, children: /* @__PURE__ */ jsxs(Inline, { space: 4, children: [
    t2,
    t3,
    t4
  ] }) }), $[30] = t2, $[31] = t3, $[32] = t4, $[33] = t5) : t5 = $[33];
  let t6;
  return $[34] !== t1 || $[35] !== t5 ? (t6 = /* @__PURE__ */ jsxs(StyledPreviewFlex$1, { align: "center", justify: "center", flex: 1, "data-testid": "preview", children: [
    t1,
    t5
  ] }), $[34] = t1, $[35] = t5, $[36] = t6) : t6 = $[36], t6;
}
const noop$3 = () => {
}, INITIAL_LOADING_STATE$1 = {
  isLoading: !0,
  result: void 0,
  error: void 0,
  retry: noop$3
}, EMPTY_STATE$1 = {
  isLoading: !1,
  result: void 0,
  error: void 0,
  retry: noop$3
};
function useReferenceInfo$1(doc, getReferenceInfo2) {
  const [retryAttempt, setRetryAttempt] = useState(0), retry2 = useCallback(() => {
    setRetryAttempt((current) => current + 1);
  }, []), docInfo = useMemo(() => ({
    _id: doc._id,
    _type: doc._type
  }), [doc._id, doc._type]), referenceInfoObservable = useMemo(() => docInfo._id ? getReferenceInfo2(docInfo).pipe(map((result) => ({
    isLoading: !1,
    result,
    error: void 0,
    retry: retry2,
    retryAttempt
  })), startWith(INITIAL_LOADING_STATE$1), catchError((err) => (console.error(err), of({
    isLoading: !1,
    result: void 0,
    error: err,
    retry: retry2,
    retryAttempt
  })))) : of(EMPTY_STATE$1), [docInfo, getReferenceInfo2, retry2, retryAttempt]);
  return useObservable(referenceInfoObservable, INITIAL_LOADING_STATE$1);
}
function useProjectId() {
  const $ = c(2), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  return $[0] !== client ? (t0 = client.config(), $[0] = client, $[1] = t0) : t0 = $[1], t0.projectId;
}
function OptionPreview$1(props2) {
  const $ = c(29), {
    isLoading,
    result: referenceInfo,
    error
  } = useReferenceInfo$1(props2.document, props2.getReferenceInfo), {
    t
  } = useTranslation(), projectId = useProjectId();
  if (isLoading) {
    let t02;
    $[0] === Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
      maxWidth: 320
    }, radius: 1, animated: !0 }), $[0] = t02) : t02 = $[0];
    let t12;
    return $[1] === Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t02,
      /* @__PURE__ */ jsx(TextSkeleton, { style: {
        maxWidth: 200
      }, radius: 1, size: 1, animated: !0 })
    ] }), $[1] = t12) : t12 = $[1], t12;
  }
  if (error) {
    let t02;
    $[2] !== t ? (t02 = t("inputs.reference.error.failed-to-load-document-title"), $[2] = t, $[3] = t02) : t02 = $[3];
    let t12;
    $[4] !== error.message ? (t12 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: error.message }), $[4] = error.message, $[5] = t12) : t12 = $[5];
    let t2;
    return $[6] !== t02 || $[7] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: /* @__PURE__ */ jsx(Alert, { title: t02, children: t12 }) }), $[6] = t02, $[7] = t12, $[8] = t2) : t2 = $[8], t2;
  }
  if (!referenceInfo)
    return null;
  if (referenceInfo.availability?.reason === "PERMISSION_DENIED") {
    let t02;
    $[9] !== t ? (t02 = t("inputs.reference.error.missing-read-permissions-description"), $[9] = t, $[10] = t02) : t02 = $[10];
    let t12;
    return $[11] !== t02 ? (t12 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t02 }), $[11] = t02, $[12] = t12) : t12 = $[12], t12;
  }
  let t0;
  if ($[13] !== props2.referenceType.to || $[14] !== referenceInfo.type) {
    let t12;
    $[16] !== referenceInfo.type ? (t12 = (toEntry) => toEntry.type === referenceInfo.type, $[16] = referenceInfo.type, $[17] = t12) : t12 = $[17], t0 = props2.referenceType.to.find(t12), $[13] = props2.referenceType.to, $[14] = referenceInfo.type, $[15] = t0;
  } else
    t0 = $[15];
  const refType = t0;
  if (!refType) {
    let t12;
    $[18] !== referenceInfo.type || $[19] !== t ? (t12 = t("inputs.reference.error.invalid-search-result-type-title", {
      returnedType: referenceInfo.type
    }), $[18] = referenceInfo.type, $[19] = t, $[20] = t12) : t12 = $[20];
    let t2;
    return $[21] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t12 }), $[21] = t12, $[22] = t2) : t2 = $[22], t2;
  }
  let t1;
  return $[23] !== projectId || $[24] !== props2.referenceType.dataset || $[25] !== props2.referenceType.to.length || $[26] !== refType || $[27] !== referenceInfo ? (t1 = referenceInfo && refType && /* @__PURE__ */ jsx(CrossDatasetReferencePreview, { id: referenceInfo.id, availability: referenceInfo.availability, preview: referenceInfo.preview, refType, dataset: props2.referenceType.dataset, projectId, showTypeLabel: props2.referenceType.to.length > 1 }), $[23] = projectId, $[24] = props2.referenceType.dataset, $[25] = props2.referenceType.to.length, $[26] = refType, $[27] = referenceInfo, $[28] = t1) : t1 = $[28], t1;
}
function PreviewReferenceValue$1(props2) {
  const $ = c(32), {
    value,
    type,
    showStudioUrlIcon,
    hasStudioUrl,
    referenceInfo
  } = props2, {
    t
  } = useTranslation(), projectId = useProjectId();
  if (referenceInfo.isLoading || referenceInfo.error) {
    let t02;
    $[0] === Symbol.for("react.memo_cache_sentinel") ? (t02 = {
      maxWidth: 320
    }, $[0] = t02) : t02 = $[0];
    const t12 = !referenceInfo.error;
    let t2;
    $[1] !== t12 ? (t2 = /* @__PURE__ */ jsx(TextSkeleton, { style: t02, radius: 1, animated: t12 }), $[1] = t12, $[2] = t2) : t2 = $[2];
    let t3;
    $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
      maxWidth: 200
    }, $[3] = t3) : t3 = $[3];
    const t4 = !referenceInfo.error;
    let t5;
    $[4] !== t4 ? (t5 = /* @__PURE__ */ jsx(TextSkeleton, { style: t3, radius: 1, size: 1, animated: t4 }), $[4] = t4, $[5] = t5) : t5 = $[5];
    let t6;
    return $[6] !== t2 || $[7] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t2,
      t5
    ] }), $[6] = t2, $[7] = t5, $[8] = t6) : t6 = $[8], t6;
  }
  const showTypeLabel = type.to.length > 1, refTypeName = referenceInfo.result?.type;
  let t0;
  if ($[9] !== refTypeName || $[10] !== type.to) {
    let t12;
    $[12] !== refTypeName ? (t12 = (toType) => toType.type === refTypeName, $[12] = refTypeName, $[13] = t12) : t12 = $[13], t0 = type.to.find(t12), $[9] = refTypeName, $[10] = type.to, $[11] = t0;
  } else
    t0 = $[11];
  const refType = t0;
  if (referenceInfo.result.availability?.available && !refType) {
    const t12 = refTypeName || "unknown";
    let t2;
    $[14] !== t12 ? (t2 = {
      typeName: t12
    }, $[14] = t12, $[15] = t2) : t2 = $[15];
    let t3;
    $[16] !== value ? (t3 = {
      JsonValue: () => /* @__PURE__ */ jsx("pre", { children: JSON.stringify(value, null, 2) })
    }, $[16] = value, $[17] = t3) : t3 = $[17];
    let t4;
    return $[18] !== t || $[19] !== t2 || $[20] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "p", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.cross-dataset.invalid-type", values: t2, components: t3 }) }) }), $[18] = t, $[19] = t2, $[20] = t3, $[21] = t4) : t4 = $[21], t4;
  }
  let t1;
  return $[22] !== hasStudioUrl || $[23] !== projectId || $[24] !== refType || $[25] !== referenceInfo.result.availability || $[26] !== referenceInfo.result.preview || $[27] !== showStudioUrlIcon || $[28] !== showTypeLabel || $[29] !== type.dataset || $[30] !== value._ref ? (t1 = /* @__PURE__ */ jsx(CrossDatasetReferencePreview, { availability: referenceInfo.result.availability, hasStudioUrl, showStudioUrlIcon, preview: referenceInfo.result.preview, refType, projectId, dataset: type.dataset, id: value._ref, showTypeLabel }), $[22] = hasStudioUrl, $[23] = projectId, $[24] = refType, $[25] = referenceInfo.result.availability, $[26] = referenceInfo.result.preview, $[27] = showStudioUrlIcon, $[28] = showTypeLabel, $[29] = type.dataset, $[30] = value._ref, $[31] = t1) : t1 = $[31], t1;
}
const StyledPopover$5 = styled(Popover)`
  & > div {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
`, StyledText$4 = styled(Text$1)`
  word-break: break-word;
`, FALLBACK_PLACEMENTS$1 = ["top-start", "bottom-start"], ReferenceAutocomplete$2 = forwardRef(function(props2, ref) {
  const $ = c(17);
  let loading, portalRef, referenceElement, restProps, searchString;
  $[0] !== props2 ? ({
    searchString,
    loading,
    portalRef,
    referenceElement,
    ...restProps
  } = props2, $[0] = props2, $[1] = loading, $[2] = portalRef, $[3] = referenceElement, $[4] = restProps, $[5] = searchString) : (loading = $[1], portalRef = $[2], referenceElement = $[3], restProps = $[4], searchString = $[5]);
  const {
    t
  } = useTranslation(), hasResults = props2.options && props2.options.length > 0;
  let t0;
  $[6] !== hasResults || $[7] !== loading || $[8] !== portalRef || $[9] !== referenceElement || $[10] !== searchString || $[11] !== t ? (t0 = (t12, contentRef) => {
    const {
      content,
      hidden,
      inputElement,
      onMouseEnter,
      onMouseLeave
    } = t12;
    return /* @__PURE__ */ jsx(StyledPopover$5, { "data-testid": "autocomplete-popover", placement: "bottom-start", fallbackPlacements: FALLBACK_PLACEMENTS$1, arrow: !1, constrainSize: !0, onMouseEnter, onMouseLeave, content: /* @__PURE__ */ jsx("div", { ref: contentRef, children: hasResults ? content : /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(StyledText$4, { align: "center", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.no-results-for-query", values: {
      searchTerm: searchString || ""
    } }) }) }) }) }), open: !loading && !hidden, ref: portalRef, portal: !0, referenceElement: referenceElement || inputElement, matchReferenceWidth: !0 });
  }, $[6] = hasResults, $[7] = loading, $[8] = portalRef, $[9] = referenceElement, $[10] = searchString, $[11] = t, $[12] = t0) : t0 = $[12];
  const renderPopover = t0;
  let t1;
  return $[13] !== ref || $[14] !== renderPopover || $[15] !== restProps ? (t1 = /* @__PURE__ */ jsx(Autocomplete, { ...restProps, ref, renderPopover }), $[13] = ref, $[14] = renderPopover, $[15] = restProps, $[16] = t1) : t1 = $[16], t1;
}), INITIAL_SEARCH_STATE$1 = {
  hits: [],
  isLoading: !1
}, NO_FILTER$2 = () => !0, REF_PATH$1 = ["_ref"], CROSS_DATASET_FEATUREKEY = "crossDatasetReferences";
function CrossDatasetReferenceInput(props2) {
  const {
    changed,
    focused,
    focusPath,
    getReferenceInfo: getReferenceInfo2,
    onChange,
    onPathFocus,
    onSearch,
    path,
    readOnly,
    schemaType,
    validation: validation2,
    value,
    elementProps
  } = props2, {
    t
  } = useTranslation(), projectId = useProjectId(), [searchState, setSearchState] = useState(INITIAL_SEARCH_STATE$1), handleChange = useCallback((id2) => {
    if (!id2) {
      onChange(unset()), onPathFocus([]);
      return;
    }
    if (!searchState.hits.find((h) => h.id === id2))
      throw new Error("Selected an item that wasnt part of the result set");
    onChange(set({
      _type: schemaType.name,
      _ref: getPublishedId(id2),
      _projectId: projectId,
      _dataset: schemaType.dataset,
      _weak: schemaType.weak,
      // persist _key between mutations if the value is in an array
      _key: value?._key
    })), onPathFocus([]);
  }, [value?._key, searchState.hits, schemaType.name, schemaType.dataset, schemaType.weak, projectId, onChange, onPathFocus]), handleClear = useCallback(() => {
    onChange(unset());
  }, [onChange]), handleAutocompleteKeyDown = useCallback((event) => {
    event.key === "Escape" && onPathFocus?.([]);
  }, [onPathFocus]), getReferenceInfoMemo = useCallback((doc) => getReferenceInfo2(doc, schemaType), [getReferenceInfo2, schemaType]), refDoc = useMemo(() => ({
    _id: value?._ref
  }), [value?._ref]), loadableReferenceInfo = useReferenceInfo$1(refDoc, getReferenceInfoMemo), featureInfo = useFeatureEnabled(CROSS_DATASET_FEATUREKEY), [autocompletePopoverReferenceElement, setAutocompletePopoverReferenceElement] = useState(null), hasFocusAtRef = focusPath.length === 1 && focusPath[0] === "_ref", focusElementRef = elementProps.ref;
  useDidUpdate({
    hasFocusAt: hasFocusAtRef,
    ref: value?._ref
  }, (prev, current) => {
    const refUpdated = prev?.ref !== current.ref;
    (prev?.hasFocusAt !== current.hasFocusAt || refUpdated) && current.hasFocusAt && focusElementRef.current?.focus();
  });
  const actualStrength = value?._weak ? "weak" : "strong", weakShouldBe = schemaType.weak === !0 ? "weak" : "strong", hasRef = !!value?._ref, handleFixStrengthMismatch = useCallback(() => {
    onChange(schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]));
  }, [onChange, schemaType]), {
    push
  } = useToast(), errors = useMemo(() => validation2.filter((item) => item.level === "error"), [validation2]), handleFocus = useCallback((event_0) => {
    event_0.currentTarget === elementProps.ref.current && onPathFocus?.([]);
  }, [elementProps.ref, onPathFocus]), handleBlur = useCallback((event_1) => elementProps.onBlur(event_1), [elementProps]), handleAutocompleteFocus = useCallback((event_2) => {
    event_2.currentTarget === elementProps.ref.current && onPathFocus?.(REF_PATH$1);
  }, [elementProps.ref, onPathFocus]), handleReplace = useCallback(() => {
    onPathFocus?.(REF_PATH$1);
  }, [onPathFocus]), inputId = useId(), handleQueryChange = useObservableEvent((inputValue$) => inputValue$.pipe(filter(isNonNullable$3), distinctUntilChanged(), switchMap((searchString) => concat(of({
    isLoading: !0
  }), onSearch(searchString).pipe(map((hits) => ({
    hits,
    searchString,
    isLoading: !1
  })), catchError((error) => (push({
    title: "Reference search failed",
    description: error.message,
    status: "error",
    id: `reference-search-fail-${inputId}`
  }), console.error(error), of({
    hits: []
  })))))), scan((prevState, nextState) => ({
    ...prevState,
    ...nextState
  }), INITIAL_SEARCH_STATE$1), tap(setSearchState))), handleAutocompleteOpenButtonClick = useCallback(() => {
    handleQueryChange("");
  }, [handleQueryChange]), showWeakRefMismatch = !loadableReferenceInfo.isLoading && hasRef && actualStrength !== weakShouldBe, studioUrl = value?._ref && schemaType.studioUrl?.({
    id: value?._ref,
    type: loadableReferenceInfo?.result?.type
  }) || null, renderOption = useCallback((option) => /* @__PURE__ */ jsx(PreviewCard, { as: "button", type: "button", radius: 2, children: /* @__PURE__ */ jsx(Box, { paddingX: 3, paddingY: 1, children: /* @__PURE__ */ jsx(OptionPreview$1, { referenceType: schemaType, document: option.hit.published, getReferenceInfo: getReferenceInfoMemo }) }) }), [schemaType, getReferenceInfoMemo]), isEditing = hasFocusAtRef || !value?._ref, clickOutsideBoundaryRef = useRef(null), autocompletePortalRef = useRef(null);
  return useClickOutsideEvent(hasFocusAtRef && (() => onPathFocus([])), () => [clickOutsideBoundaryRef.current, autocompletePortalRef.current]), /* @__PURE__ */ jsxs(Fragment, { children: [
    !featureInfo.isLoading && !featureInfo.enabled && /* @__PURE__ */ jsx(DisabledFeatureWarning, { value, onClearValue: handleClear }),
    (featureInfo.isLoading || featureInfo.enabled) && /* @__PURE__ */ jsx(Stack, { space: 1, children: isEditing ? /* @__PURE__ */ jsx(Stack, { space: 2, ref: clickOutsideBoundaryRef, children: /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsx("div", { ref: setAutocompletePopoverReferenceElement, children: /* @__PURE__ */ jsx(ReferenceAutocomplete$2, { ...elementProps, "data-testid": "autocomplete", loading: searchState.isLoading, referenceElement: autocompletePopoverReferenceElement, portalRef: autocompletePortalRef, id: inputId || "", options: searchState.hits.map((hit_0) => ({
      value: hit_0.id,
      hit: hit_0
    })), onFocus: handleAutocompleteFocus, radius: 2, placeholder: t("inputs.reference.search-placeholder"), onKeyDown: handleAutocompleteKeyDown, readOnly, disabled: loadableReferenceInfo.isLoading, onQueryChange: handleQueryChange, searchString: searchState.searchString, onChange: handleChange, filterOption: NO_FILTER$2, renderOption, openButton: {
      onClick: handleAutocompleteOpenButtonClick
    } }) }) }) }) : /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsxs(Card, { padding: 0, border: !0, flex: 1, radius: 1, tone: readOnly ? "transparent" : loadableReferenceInfo.error || errors.length > 0 ? "critical" : "default", children: [
      /* @__PURE__ */ jsxs(Flex, { align: "center", padding: 1, children: [
        studioUrl ? /* @__PURE__ */ jsx(PreviewCard, { as: "a", target: "_blank", rel: "noopener noreferrer", href: studioUrl, "data-as": "a", flex: 1, padding: 1, paddingRight: 3, radius: 2, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, onFocus: handleFocus, onBlur: handleBlur, ref: elementProps.ref, children: /* @__PURE__ */ jsx(PreviewReferenceValue$1, { value, referenceInfo: loadableReferenceInfo, showStudioUrlIcon: !0, hasStudioUrl: !!studioUrl, type: schemaType }) }) : /* @__PURE__ */ jsx(PreviewCard, { flex: 1, padding: 1, paddingRight: 3, radius: 2, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, onFocus: handleFocus, onBlur: handleBlur, ref: elementProps.ref, children: /* @__PURE__ */ jsx(PreviewReferenceValue$1, { value, referenceInfo: loadableReferenceInfo, showStudioUrlIcon: !0, type: schemaType }) }),
        /* @__PURE__ */ jsx(Inline, { paddingX: 1, children: /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "menu-button" }), id: `${inputId}-menuButton`, menu: /* @__PURE__ */ jsx(Menu, { children: !readOnly && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.clear"), tone: "critical", icon: ResetIcon, "data-testid": "menu-item-clear", onClick: handleClear }),
          /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.replace"), icon: SyncIcon, "data-testid": "menu-item-replace", onClick: handleReplace })
        ] }) }), placement: "right", popover: {
          portal: !0,
          tone: "default"
        } }) })
      ] }),
      showWeakRefMismatch && /* @__PURE__ */ jsx(ReferenceStrengthMismatchAlertStrip, { actualStrength, handleFixStrengthMismatch }),
      loadableReferenceInfo.error && /* @__PURE__ */ jsx(ReferenceMetadataLoadErrorAlertStrip, { errorMessage: loadableReferenceInfo.error.message, onHandleRetry: loadableReferenceInfo.retry })
    ] }) }) })
  ] });
}
const REQUEST_TAG_BASE$1 = "cross-dataset-refs", AVAILABILITY_READABLE$2 = {
  available: !0,
  reason: "READABLE"
}, AVAILABILITY_PERMISSION_DENIED$2 = {
  available: !1,
  reason: "PERMISSION_DENIED"
}, AVAILABILITY_NOT_FOUND$2 = {
  available: !1,
  reason: "NOT_FOUND"
};
function createGetReferenceInfo$1(context) {
  const {
    client,
    documentPreviewStore
  } = context, {
    dataset,
    projectId
  } = client.config(), apiConfig = dataset && projectId ? {
    dataset,
    projectId
  } : void 0;
  return function(doc, referenceType) {
    return (doc._type ? of(doc) : documentPreviewStore.observeDocumentTypeFromId(doc._id, apiConfig).pipe(map((docType) => ({
      _id: doc._id,
      _type: docType
    })))).pipe(switchMap((resolvedDoc) => {
      if (!resolvedDoc._type)
        return fetchDocumentAvailability$1(client, doc._id).pipe(map((availability) => ({
          id: doc._id,
          type: void 0,
          availability,
          preview: {
            published: void 0
          }
        })));
      const refSchemaType = referenceType.to.find((candidate) => candidate.type === resolvedDoc._type), previewPaths = getPreviewPaths(refSchemaType?.preview) || [], publishedPreview$ = documentPreviewStore.observePaths(doc, previewPaths, apiConfig).pipe(map((result) => result && prepareForPreview(result, refSchemaType)));
      return combineLatest([publishedPreview$]).pipe(map(([publishedPreview]) => ({
        type: resolvedDoc._type,
        id: doc._id,
        availability: AVAILABILITY_READABLE$2,
        preview: {
          published: isRecord$4(publishedPreview) ? publishedPreview : void 0
        }
      })));
    }));
  };
}
function fetchDocumentAvailability$1(client, id2) {
  const requestOptions = {
    uri: client.getDataUrl("doc", id2),
    json: !0,
    query: {
      excludeContent: "true"
    },
    tag: `${REQUEST_TAG_BASE$1}.availability`
  };
  return client.observable.request(requestOptions).pipe(map((response) => {
    const omittedEntry = keyBy(response.omitted || [], (entry) => entry.id)[id2];
    return omittedEntry ? omittedEntry.reason === "existence" ? AVAILABILITY_NOT_FOUND$2 : omittedEntry.reason === "permission" ? AVAILABILITY_PERMISSION_DENIED$2 : null : AVAILABILITY_READABLE$2;
  }));
}
function search$1(client, textTerm, type, options) {
  return createSearch(type.to, client, {
    ...options,
    maxDepth: options.maxFieldDepth
  })(textTerm, {
    includeDrafts: !1,
    isCrossDataset: !0
  }).pipe(map(({
    hits
  }) => hits.map(({
    hit
  }) => hit)), map((docs) => collate(docs)), map((collated) => collated.map((entry) => ({
    id: entry.id,
    type: entry.type,
    published: entry.published
  }))));
}
async function resolveUserDefinedFilter$1(options, document2, valuePath, getClient2) {
  if (!options)
    return {};
  if (typeof options.filter == "function") {
    const parentPath = valuePath.slice(0, -1), parent = get$1(document2, parentPath);
    return await options.filter({
      document: document2,
      parentPath,
      parent,
      getClient: getClient2
    });
  }
  return {
    filter: options.filter,
    params: "filterParams" in options ? options.filterParams : void 0
  };
}
function useValueRef$1(value) {
  const $ = c(3), ref = useRef(value);
  let t0, t1;
  return $[0] !== value ? (t0 = () => {
    ref.current = value;
  }, t1 = [value], $[0] = value, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), ref;
}
function StudioCrossDatasetReferenceInput(props2) {
  const {
    path,
    schemaType
  } = props2, source = useSource(), client = source.getClient(DEFAULT_STUDIO_CLIENT_OPTIONS), documentPreviewStore = useDocumentPreviewStore(), getClient2 = source.getClient, {
    strategy: searchStrategy
  } = source.search, crossDatasetClient = useMemo(() => client.withConfig({
    dataset: schemaType.dataset,
    apiVersion: "2023-11-13",
    ignoreBrowserTokenWarning: !0
  }).clone(), [client, schemaType.dataset]), maxFieldDepth = useSearchMaxFieldDepth(crossDatasetClient), documentValue = useFormValue([]), documentRef = useValueRef$1(documentValue), handleSearch = useCallback((searchString) => from(resolveUserDefinedFilter$1(schemaType.options, documentRef.current, path, getClient2)).pipe(mergeMap(({
    filter: filter2,
    params
  }) => search$1(crossDatasetClient, searchString, schemaType, {
    ...schemaType.options,
    filter: filter2,
    params,
    tag: "search.cross-dataset-reference",
    maxFieldDepth,
    strategy: searchStrategy
  })), catchError((err) => {
    const isQueryError = err.details && err.details.type === "queryParseError";
    return schemaType.options?.filter && isQueryError && (err.message = 'Invalid reference filter, please check the custom "filter" option'), throwError(err);
  })), [schemaType, documentRef, path, getClient2, crossDatasetClient, maxFieldDepth, searchStrategy]), getReferenceInfo2 = useMemo(() => createGetReferenceInfo$1({
    client: crossDatasetClient,
    documentPreviewStore
  }), [crossDatasetClient, documentPreviewStore]);
  return /* @__PURE__ */ jsx(CrossDatasetReferenceInput, { ...props2, getReferenceInfo: getReferenceInfo2, onSearch: handleSearch });
}
const StyledPreviewFlex = styled(Flex)`
  /* this is a hack to avoid layout jumps while previews are loading
  or the message is not tall enough to fill the card
  there's probably better ways of solving this */
  min-height: 36px;
`;
function resolveProjectDataset(resourceType, resourceId) {
  if (resourceType !== "dataset")
    return null;
  const [projectId, dataset] = resourceId.split(".", 2);
  if (!projectId || !dataset)
    throw new Error(`Invalid resource ID for resource "dataset": ${resourceId}`);
  return {
    projectId,
    dataset
  };
}
function GlobalDocumentReferencePreview(props2) {
  const $ = c(37), {
    refType,
    showStudioUrlIcon,
    hasStudioUrl,
    showTypeLabel,
    availability,
    preview,
    id: id2,
    resourceType,
    resourceId
  } = props2, notFound = availability?.reason === "NOT_FOUND", insufficientPermissions = availability?.reason === "PERMISSION_DENIED", previewMedia = preview.published?.media, {
    t
  } = useTranslation();
  let t0;
  bb0: {
    if (previewMedia) {
      const isValidImageAsset = typeof previewMedia?.asset < "u" && isImageSource(previewMedia);
      let t13;
      $[0] !== previewMedia ? (t13 = isValidElement(previewMedia), $[0] = previewMedia, $[1] = t13) : t13 = $[1];
      const isValidElement$1 = t13;
      if (!isValidImageAsset && !isValidElement$1) {
        t0 = null;
        break bb0;
      }
      let t22;
      $[2] !== isValidElement$1 || $[3] !== previewMedia || $[4] !== resourceId || $[5] !== resourceType || $[6] !== t ? (t22 = function(t32) {
        const {
          dimensions
        } = t32, projectDataset = resolveProjectDataset(resourceType, resourceId);
        return projectDataset ? isValidElement$1 ? previewMedia : /* @__PURE__ */ jsx("img", { src: imageUrlBuilder(projectDataset).image(previewMedia).withOptions(dimensions).url(), alt: t("inputs.reference.image-preview-alt-text"), referrerPolicy: "strict-origin-when-cross-origin" }) : null;
      }, $[2] = isValidElement$1, $[3] = previewMedia, $[4] = resourceId, $[5] = resourceType, $[6] = t, $[7] = t22) : t22 = $[7], t0 = t22;
      break bb0;
    }
    if (!refType?.icon) {
      t0 = null;
      break bb0;
    }
    const Icon2 = refType.icon;
    let t12;
    $[8] !== Icon2 ? (t12 = /* @__PURE__ */ jsx(Icon2, {}), $[8] = Icon2, $[9] = t12) : t12 = $[9], t0 = t12;
  }
  const media = t0;
  let t1;
  $[10] !== availability?.available || $[11] !== media || $[12] !== preview.published?.subtitle || $[13] !== preview.published?.title || $[14] !== t ? (t1 = availability?.available ? /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(DefaultPreview, { title: preview.published?.title, subtitle: preview.published?.subtitle, media: media || !1 }) }) : /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: t("inputs.reference.error.document-unavailable-title") }) }) }) }), $[10] = availability?.available, $[11] = media, $[12] = preview.published?.subtitle, $[13] = preview.published?.title, $[14] = t, $[15] = t1) : t1 = $[15];
  let t2;
  $[16] !== refType || $[17] !== showTypeLabel ? (t2 = refType && showTypeLabel && /* @__PURE__ */ jsx(Badge, { mode: "outline", children: refType.title || refType.type }), $[16] = refType, $[17] = showTypeLabel, $[18] = t2) : t2 = $[18];
  let t3;
  $[19] !== id2 || $[20] !== insufficientPermissions || $[21] !== notFound || $[22] !== t ? (t3 = (insufficientPermissions || notFound) && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t(notFound ? "inputs.reference.referenced-document-does-not-exist" : "inputs.reference.referenced-document-insufficient-permissions", {
    documentId: id2
  }), children: /* @__PURE__ */ jsx(TextWithTone, { tone: "default", children: insufficientPermissions ? /* @__PURE__ */ jsx(AccessDeniedIcon, {}) : /* @__PURE__ */ jsx(HelpCircleIcon, {}) }) }) }), $[19] = id2, $[20] = insufficientPermissions, $[21] = notFound, $[22] = t, $[23] = t3) : t3 = $[23];
  let t4;
  $[24] !== hasStudioUrl || $[25] !== insufficientPermissions || $[26] !== notFound || $[27] !== showStudioUrlIcon || $[28] !== t ? (t4 = !(notFound || insufficientPermissions) && showStudioUrlIcon && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t(hasStudioUrl ? "inputs.reference.document-opens-in-new-tab" : "input.reference.document-cannot-be-opened.failed-to-resolve-url"), children: /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "default", muted: !hasStudioUrl, children: /* @__PURE__ */ jsx(LaunchIcon, {}) }) }) }), $[24] = hasStudioUrl, $[25] = insufficientPermissions, $[26] = notFound, $[27] = showStudioUrlIcon, $[28] = t, $[29] = t4) : t4 = $[29];
  let t5;
  $[30] !== t2 || $[31] !== t3 || $[32] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { paddingLeft: 3, children: /* @__PURE__ */ jsxs(Inline, { space: 4, children: [
    t2,
    t3,
    t4
  ] }) }), $[30] = t2, $[31] = t3, $[32] = t4, $[33] = t5) : t5 = $[33];
  let t6;
  return $[34] !== t1 || $[35] !== t5 ? (t6 = /* @__PURE__ */ jsxs(StyledPreviewFlex, { align: "center", justify: "center", flex: 1, "data-testid": "preview", children: [
    t1,
    t5
  ] }), $[34] = t1, $[35] = t5, $[36] = t6) : t6 = $[36], t6;
}
const noop$2 = () => {
}, INITIAL_LOADING_STATE = {
  isLoading: !0,
  result: void 0,
  error: void 0,
  retry: noop$2
}, EMPTY_STATE = {
  isLoading: !1,
  result: void 0,
  error: void 0,
  retry: noop$2
};
function useReferenceInfo(doc, getReferenceInfo2) {
  const $ = c(10), [retryAttempt, setRetryAttempt] = useState(0);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setRetryAttempt(_temp$1C);
  }, $[0] = t0) : t0 = $[0];
  const retry2 = t0;
  let t1;
  bb0: {
    if (!doc) {
      let t22;
      $[1] === Symbol.for("react.memo_cache_sentinel") ? (t22 = of(EMPTY_STATE), $[1] = t22) : t22 = $[1], t1 = t22;
      break bb0;
    }
    let t2;
    if ($[2] !== doc || $[3] !== getReferenceInfo2 || $[4] !== retryAttempt) {
      let t3;
      $[6] !== retryAttempt ? (t3 = (result) => ({
        isLoading: !1,
        result,
        error: void 0,
        retry: retry2,
        retryAttempt
      }), $[6] = retryAttempt, $[7] = t3) : t3 = $[7];
      let t4;
      $[8] !== retryAttempt ? (t4 = (err) => (console.error(err), of({
        isLoading: !1,
        result: void 0,
        error: err,
        retry: retry2,
        retryAttempt
      })), $[8] = retryAttempt, $[9] = t4) : t4 = $[9], t2 = getReferenceInfo2(doc).pipe(map(t3), startWith(INITIAL_LOADING_STATE), catchError(t4)), $[2] = doc, $[3] = getReferenceInfo2, $[4] = retryAttempt, $[5] = t2;
    } else
      t2 = $[5];
    t1 = t2;
  }
  return useObservable(t1, INITIAL_LOADING_STATE);
}
function _temp$1C(current) {
  return current + 1;
}
function OptionPreview(props2) {
  const $ = c(29), {
    isLoading,
    result: referenceInfo,
    error
  } = useReferenceInfo(props2.document, props2.getReferenceInfo), {
    t
  } = useTranslation();
  if (isLoading) {
    let t02;
    $[0] === Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
      maxWidth: 320
    }, radius: 1, animated: !0 }), $[0] = t02) : t02 = $[0];
    let t12;
    return $[1] === Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t02,
      /* @__PURE__ */ jsx(TextSkeleton, { style: {
        maxWidth: 200
      }, radius: 1, size: 1, animated: !0 })
    ] }), $[1] = t12) : t12 = $[1], t12;
  }
  if (error) {
    let t02;
    $[2] !== t ? (t02 = t("inputs.reference.error.failed-to-load-document-title"), $[2] = t, $[3] = t02) : t02 = $[3];
    let t12;
    $[4] !== error.message ? (t12 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: error.message }), $[4] = error.message, $[5] = t12) : t12 = $[5];
    let t2;
    return $[6] !== t02 || $[7] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: /* @__PURE__ */ jsx(Alert, { title: t02, children: t12 }) }), $[6] = t02, $[7] = t12, $[8] = t2) : t2 = $[8], t2;
  }
  if (!referenceInfo)
    return null;
  if (referenceInfo.availability?.reason === "PERMISSION_DENIED") {
    let t02;
    $[9] !== t ? (t02 = t("inputs.reference.error.missing-read-permissions-description"), $[9] = t, $[10] = t02) : t02 = $[10];
    let t12;
    return $[11] !== t02 ? (t12 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t02 }), $[11] = t02, $[12] = t12) : t12 = $[12], t12;
  }
  let t0;
  if ($[13] !== props2.referenceType.to || $[14] !== referenceInfo.type) {
    let t12;
    $[16] !== referenceInfo.type ? (t12 = (toEntry) => toEntry.type === referenceInfo.type, $[16] = referenceInfo.type, $[17] = t12) : t12 = $[17], t0 = props2.referenceType.to.find(t12), $[13] = props2.referenceType.to, $[14] = referenceInfo.type, $[15] = t0;
  } else
    t0 = $[15];
  const refType = t0;
  if (!refType) {
    let t12;
    $[18] !== referenceInfo.type || $[19] !== t ? (t12 = t("inputs.reference.error.invalid-search-result-type-title", {
      returnedType: referenceInfo.type
    }), $[18] = referenceInfo.type, $[19] = t, $[20] = t12) : t12 = $[20];
    let t2;
    return $[21] !== t12 ? (t2 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 1, children: t12 }), $[21] = t12, $[22] = t2) : t2 = $[22], t2;
  }
  let t1;
  return $[23] !== props2.referenceType.resourceId || $[24] !== props2.referenceType.resourceType || $[25] !== props2.referenceType.to.length || $[26] !== refType || $[27] !== referenceInfo ? (t1 = referenceInfo && refType && /* @__PURE__ */ jsx(GlobalDocumentReferencePreview, { id: referenceInfo.id, availability: referenceInfo.availability, preview: referenceInfo.preview, refType, resourceType: props2.referenceType.resourceType, resourceId: props2.referenceType.resourceId, showTypeLabel: props2.referenceType.to.length > 1 }), $[23] = props2.referenceType.resourceId, $[24] = props2.referenceType.resourceType, $[25] = props2.referenceType.to.length, $[26] = refType, $[27] = referenceInfo, $[28] = t1) : t1 = $[28], t1;
}
function PreviewReferenceValue(props2) {
  const $ = c(32), {
    value,
    type,
    showStudioUrlIcon,
    hasStudioUrl,
    referenceInfo
  } = props2, {
    t
  } = useTranslation();
  if (referenceInfo.isLoading || referenceInfo.error) {
    let t02;
    $[0] === Symbol.for("react.memo_cache_sentinel") ? (t02 = {
      maxWidth: 320
    }, $[0] = t02) : t02 = $[0];
    const t12 = !referenceInfo.error;
    let t2;
    $[1] !== t12 ? (t2 = /* @__PURE__ */ jsx(TextSkeleton, { style: t02, radius: 1, animated: t12 }), $[1] = t12, $[2] = t2) : t2 = $[2];
    let t3;
    $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
      maxWidth: 200
    }, $[3] = t3) : t3 = $[3];
    const t4 = !referenceInfo.error;
    let t5;
    $[4] !== t4 ? (t5 = /* @__PURE__ */ jsx(TextSkeleton, { style: t3, radius: 1, size: 1, animated: t4 }), $[4] = t4, $[5] = t5) : t5 = $[5];
    let t6;
    return $[6] !== t2 || $[7] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 2, padding: 1, children: [
      t2,
      t5
    ] }), $[6] = t2, $[7] = t5, $[8] = t6) : t6 = $[8], t6;
  }
  const showTypeLabel = type.to.length > 1, refTypeName = referenceInfo.result?.type;
  let t0;
  if ($[9] !== refTypeName || $[10] !== type.to) {
    let t12;
    $[12] !== refTypeName ? (t12 = (toType) => toType.type === refTypeName, $[12] = refTypeName, $[13] = t12) : t12 = $[13], t0 = type.to.find(t12), $[9] = refTypeName, $[10] = type.to, $[11] = t0;
  } else
    t0 = $[11];
  const refType = t0;
  if (referenceInfo.result.availability?.available && !refType) {
    const t12 = refTypeName || "unknown";
    let t2;
    $[14] !== t12 ? (t2 = {
      typeName: t12
    }, $[14] = t12, $[15] = t2) : t2 = $[15];
    let t3;
    $[16] !== value ? (t3 = {
      JsonValue: () => /* @__PURE__ */ jsx("pre", { children: JSON.stringify(value, null, 2) })
    }, $[16] = value, $[17] = t3) : t3 = $[17];
    let t4;
    return $[18] !== t || $[19] !== t2 || $[20] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { space: 2, padding: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "p", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.global.invalid-type", values: t2, components: t3 }) }) }), $[18] = t, $[19] = t2, $[20] = t3, $[21] = t4) : t4 = $[21], t4;
  }
  let t1;
  return $[22] !== hasStudioUrl || $[23] !== refType || $[24] !== referenceInfo.result.availability || $[25] !== referenceInfo.result.preview || $[26] !== showStudioUrlIcon || $[27] !== showTypeLabel || $[28] !== type.resourceId || $[29] !== type.resourceType || $[30] !== value._ref ? (t1 = /* @__PURE__ */ jsx(GlobalDocumentReferencePreview, { availability: referenceInfo.result.availability, hasStudioUrl, showStudioUrlIcon, preview: referenceInfo.result.preview, refType, resourceType: type.resourceType, resourceId: type.resourceId, id: value._ref, showTypeLabel }), $[22] = hasStudioUrl, $[23] = refType, $[24] = referenceInfo.result.availability, $[25] = referenceInfo.result.preview, $[26] = showStudioUrlIcon, $[27] = showTypeLabel, $[28] = type.resourceId, $[29] = type.resourceType, $[30] = value._ref, $[31] = t1) : t1 = $[31], t1;
}
const StyledPopover$4 = styled(Popover)`
  & > div {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
`, StyledText$3 = styled(Text$1)`
  word-break: break-word;
`, FALLBACK_PLACEMENTS = ["top-start", "bottom-start"], ReferenceAutocomplete$1 = forwardRef(function(props2, ref) {
  const $ = c(17);
  let loading, portalRef, referenceElement, restProps, searchString;
  $[0] !== props2 ? ({
    searchString,
    loading,
    portalRef,
    referenceElement,
    ...restProps
  } = props2, $[0] = props2, $[1] = loading, $[2] = portalRef, $[3] = referenceElement, $[4] = restProps, $[5] = searchString) : (loading = $[1], portalRef = $[2], referenceElement = $[3], restProps = $[4], searchString = $[5]);
  const {
    t
  } = useTranslation(), hasResults = props2.options && props2.options.length > 0;
  let t0;
  $[6] !== hasResults || $[7] !== loading || $[8] !== portalRef || $[9] !== referenceElement || $[10] !== searchString || $[11] !== t ? (t0 = (t12, contentRef) => {
    const {
      content,
      hidden,
      inputElement,
      onMouseEnter,
      onMouseLeave
    } = t12;
    return /* @__PURE__ */ jsx(StyledPopover$4, { "data-testid": "autocomplete-popover", placement: "bottom-start", fallbackPlacements: FALLBACK_PLACEMENTS, arrow: !1, constrainSize: !0, onMouseEnter, onMouseLeave, content: /* @__PURE__ */ jsx("div", { ref: contentRef, children: hasResults ? content : /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(StyledText$3, { align: "center", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.reference.no-results-for-query", values: {
      searchTerm: searchString || ""
    } }) }) }) }) }), open: !loading && !hidden, ref: portalRef, portal: !0, referenceElement: referenceElement || inputElement, matchReferenceWidth: !0 });
  }, $[6] = hasResults, $[7] = loading, $[8] = portalRef, $[9] = referenceElement, $[10] = searchString, $[11] = t, $[12] = t0) : t0 = $[12];
  const renderPopover = t0;
  let t1;
  return $[13] !== ref || $[14] !== renderPopover || $[15] !== restProps ? (t1 = /* @__PURE__ */ jsx(Autocomplete, { ...restProps, ref, renderPopover }), $[13] = ref, $[14] = renderPopover, $[15] = restProps, $[16] = t1) : t1 = $[16], t1;
}), INITIAL_SEARCH_STATE = {
  hits: [],
  isLoading: !1
}, NO_FILTER$1 = () => !0, REF_PATH = ["_ref"];
function GlobalDocumentReferenceInput(props2) {
  const {
    changed,
    focused,
    focusPath,
    getReferenceInfo: getReferenceInfo2,
    onChange,
    onPathFocus,
    onSearch,
    path,
    readOnly,
    schemaType,
    validation: validation2,
    value,
    elementProps
  } = props2, {
    t
  } = useTranslation(), [searchState, setSearchState] = useState(INITIAL_SEARCH_STATE), handleChange = useCallback((id2) => {
    if (!id2) {
      onChange(unset()), onPathFocus([]);
      return;
    }
    if (!searchState.hits.find((h) => h.id === id2))
      throw new Error("Selected an item that wasnt part of the result set");
    onChange(set({
      _type: schemaType.name,
      _ref: `${schemaType.resourceType}:${schemaType.resourceId}:${getPublishedId(id2)}`,
      _weak: schemaType.weak,
      // persist _key between mutations if the value is in an array
      _key: value?._key
    })), onPathFocus([]);
  }, [value?._key, searchState.hits, schemaType.name, schemaType.resourceType, schemaType.resourceId, schemaType.weak, onChange, onPathFocus]), handleClear = useCallback(() => {
    onChange(unset());
  }, [onChange]), handleAutocompleteKeyDown = useCallback((event) => {
    event.key === "Escape" && onPathFocus?.([]);
  }, [onPathFocus]), getReferenceInfoMemo = useCallback((doc) => getReferenceInfo2(doc, schemaType), [getReferenceInfo2, schemaType]), refDoc = useMemo(() => {
    if (!value?._ref)
      return null;
    const [, , _id] = value._ref.split(":", 3);
    return {
      _id
    };
  }, [value]), loadableReferenceInfo = useReferenceInfo(refDoc, getReferenceInfoMemo), [autocompletePopoverReferenceElement, setAutocompletePopoverReferenceElement] = useState(null), hasFocusAtRef = focusPath.length === 1 && focusPath[0] === "_ref", focusElementRef = elementProps.ref;
  useDidUpdate({
    hasFocusAt: hasFocusAtRef,
    ref: value?._ref
  }, (prev, current) => {
    const refUpdated = prev?.ref !== current.ref;
    (prev?.hasFocusAt !== current.hasFocusAt || refUpdated) && current.hasFocusAt && focusElementRef.current?.focus();
  });
  const actualStrength = value?._weak ? "weak" : "strong", weakShouldBe = schemaType.weak === !0 ? "weak" : "strong", hasRef = !!value?._ref, handleFixStrengthMismatch = useCallback(() => {
    onChange(schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]));
  }, [onChange, schemaType]), {
    push
  } = useToast(), errors = useMemo(() => validation2.filter((item) => item.level === "error"), [validation2]), handleFocus = useCallback((event_0) => {
    event_0.currentTarget === elementProps.ref.current && onPathFocus?.([]);
  }, [elementProps.ref, onPathFocus]), handleBlur = useCallback((event_1) => elementProps.onBlur(event_1), [elementProps]), handleAutocompleteFocus = useCallback((event_2) => {
    event_2.currentTarget === elementProps.ref.current && onPathFocus?.(REF_PATH);
  }, [elementProps.ref, onPathFocus]), handleReplace = useCallback(() => {
    onPathFocus?.(REF_PATH);
  }, [onPathFocus]), inputId = useId(), handleQueryChange = useObservableEvent((inputValue$) => inputValue$.pipe(filter(isNonNullable$3), distinctUntilChanged(), switchMap((searchString) => concat(of({
    isLoading: !0
  }), onSearch(searchString).pipe(map((hits) => ({
    hits,
    searchString,
    isLoading: !1
  })), catchError((error) => (push({
    title: "Reference search failed",
    description: error.message,
    status: "error",
    id: `reference-search-fail-${inputId}`
  }), console.error(error), of({
    hits: []
  })))))), scan((prevState, nextState) => ({
    ...prevState,
    ...nextState
  }), INITIAL_SEARCH_STATE), tap(setSearchState))), handleAutocompleteOpenButtonClick = useCallback(() => {
    handleQueryChange("");
  }, [handleQueryChange]), showWeakRefMismatch = !loadableReferenceInfo.isLoading && hasRef && actualStrength !== weakShouldBe, studioUrl = useMemo(() => {
    if (!value?._ref || !isGlobalDocumentReference(value))
      return null;
    const [, , documentId] = value._ref.split(":");
    return !schemaType.studioUrl || !loadableReferenceInfo?.result?.type ? null : typeof schemaType.studioUrl == "string" ? `${schemaType.studioUrl}/desk/intent/edit/id=${documentId};type=${loadableReferenceInfo.result.type}/` : schemaType.studioUrl({
      id: documentId,
      type: loadableReferenceInfo.result.type
    });
  }, [value, schemaType, loadableReferenceInfo]), renderOption = useCallback((option) => /* @__PURE__ */ jsx(PreviewCard, { as: "button", type: "button", radius: 2, children: /* @__PURE__ */ jsx(Box, { paddingX: 3, paddingY: 1, children: /* @__PURE__ */ jsx(OptionPreview, { referenceType: schemaType, document: option.hit.published, getReferenceInfo: getReferenceInfoMemo }) }) }), [schemaType, getReferenceInfoMemo]), isEditing = hasFocusAtRef || !value?._ref, clickOutsideBoundaryRef = useRef(null), autocompletePortalRef = useRef(null);
  return useClickOutsideEvent(hasFocusAtRef && (() => onPathFocus([])), () => [clickOutsideBoundaryRef.current, autocompletePortalRef.current]), /* @__PURE__ */ jsx(Stack, { space: 1, children: isEditing ? /* @__PURE__ */ jsx(Stack, { space: 2, ref: clickOutsideBoundaryRef, children: /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsx("div", { ref: setAutocompletePopoverReferenceElement, children: /* @__PURE__ */ jsx(ReferenceAutocomplete$1, { ...elementProps, "data-testid": "autocomplete", loading: searchState.isLoading, referenceElement: autocompletePopoverReferenceElement, portalRef: autocompletePortalRef, id: inputId || "", options: searchState.hits.map((hit_0) => ({
    value: hit_0.id,
    hit: hit_0
  })), onFocus: handleAutocompleteFocus, radius: 2, placeholder: t("inputs.reference.search-placeholder"), onKeyDown: handleAutocompleteKeyDown, readOnly, disabled: loadableReferenceInfo.isLoading, onQueryChange: handleQueryChange, searchString: searchState.searchString, onChange: handleChange, filterOption: NO_FILTER$1, renderOption, openButton: {
    onClick: handleAutocompleteOpenButtonClick
  } }) }) }) }) : /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsxs(Card, { padding: 0, border: !0, flex: 1, radius: 1, tone: readOnly ? "transparent" : loadableReferenceInfo.error || errors.length > 0 ? "critical" : "default", children: [
    /* @__PURE__ */ jsxs(Flex, { align: "center", padding: 1, children: [
      studioUrl ? /* @__PURE__ */ jsx(PreviewCard, { as: "a", target: "_blank", rel: "noopener noreferrer", href: studioUrl, "data-as": "a", flex: 1, padding: 1, paddingRight: 3, radius: 2, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, onFocus: handleFocus, onBlur: handleBlur, ref: elementProps.ref, children: /* @__PURE__ */ jsx(PreviewReferenceValue, { value, referenceInfo: loadableReferenceInfo, showStudioUrlIcon: !0, hasStudioUrl: !0, type: schemaType }) }) : /* @__PURE__ */ jsx(PreviewCard, { flex: 1, padding: 1, paddingRight: 3, radius: 2, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, onFocus: handleFocus, onBlur: handleBlur, ref: elementProps.ref, children: /* @__PURE__ */ jsx(PreviewReferenceValue, { value, referenceInfo: loadableReferenceInfo, type: schemaType }) }),
      /* @__PURE__ */ jsx(Inline, { paddingX: 1, children: /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "menu-button" }), id: `${inputId}-menuButton`, menu: /* @__PURE__ */ jsx(Menu, { children: !readOnly && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.clear"), tone: "critical", icon: ResetIcon, "data-testid": "menu-item-clear", onClick: handleClear }),
        /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.replace"), icon: SyncIcon, "data-testid": "menu-item-replace", onClick: handleReplace })
      ] }) }), placement: "right", popover: {
        portal: !0,
        tone: "default"
      } }) })
    ] }),
    showWeakRefMismatch && /* @__PURE__ */ jsx(ReferenceStrengthMismatchAlertStrip, { actualStrength, handleFixStrengthMismatch }),
    loadableReferenceInfo.error && /* @__PURE__ */ jsx(ReferenceMetadataLoadErrorAlertStrip, { errorMessage: loadableReferenceInfo.error.message, onHandleRetry: loadableReferenceInfo.retry })
  ] }) }) });
}
function getReferenceClient(client, schemaType) {
  if (schemaType.resourceType === "dataset") {
    const [projectId, datasetName] = schemaType.resourceId.split(".", 2);
    return client.withConfig({
      apiVersion: "X",
      "~experimental_resource": {
        type: "dataset",
        id: `${projectId}.${datasetName}`
      }
    });
  }
  if (schemaType.resourceType === "media-library" || schemaType.resourceType === "canvas")
    return client.withConfig({
      apiVersion: "2025-02-19",
      "~experimental_resource": {
        type: schemaType.resourceType,
        id: schemaType.resourceId
      }
    });
  throw new Error(`Invalid resource type "${schemaType.resourceType}"`);
}
function keysOf(value) {
  return Object.keys(value);
}
function setKey(source, key, value) {
  return {
    ...source,
    [key]: value
  };
}
function props(options = {}) {
  return (source) => new Observable((observer) => source.subscribe(observer)).pipe(switchMap((object) => {
    const keyObservables = keysOf(object).map((key) => {
      const value = object[key];
      return isObservable(value) ? from(value).pipe(map((val) => [key, val])) : of([key, value]);
    });
    return options.wait ? combineLatest(keyObservables).pipe(map((pairs) => pairs.reduce((acc, [key, value]) => setKey(acc, key, value), {}))) : from(keyObservables).pipe(mergeAll(), scan((acc, [key, value]) => setKey(acc, key, value), {}));
  }));
}
function createEmpty(fields) {
  return fields.reduce((result, field) => (result[field] = void 0, result), {});
}
function resolveMissingHeads(value, paths) {
  return paths.filter((path) => !(path[0] in value));
}
function getDocumentId(value) {
  return isReference$1(value) ? value._ref : "_id" in value ? value._id : void 0;
}
function observePaths(value, paths, observeFields, apiConfig, perspective) {
  if (!value || typeof value != "object")
    return of(value);
  const id2 = getDocumentId(value), currentValue = id2 ? {
    ...value,
    _id: id2
  } : {
    ...value
  };
  currentValue._type === "reference" && (delete currentValue._type, delete currentValue._ref, delete currentValue._weak, delete currentValue._dataset, delete currentValue._projectId, delete currentValue._strengthenOnPublish);
  const pathsWithMissingHeads = resolveMissingHeads(currentValue, paths);
  if (id2 && pathsWithMissingHeads.length > 0) {
    const nextHeads = uniq(pathsWithMissingHeads.map((path) => path[0])), refApiConfig = isCrossDatasetReference(value) ? {
      projectId: value._projectId,
      dataset: value._dataset
    } : apiConfig;
    return observeFields(id2, nextHeads, refApiConfig, perspective).pipe(switchMap((snapshot2) => snapshot2 === null ? of(null) : observePaths({
      ...createEmpty(nextHeads),
      ...isReference$1(value) ? {
        ...value,
        ...refApiConfig
      } : value,
      ...snapshot2
    }, paths, observeFields, refApiConfig, perspective)));
  }
  const leads = {};
  paths.forEach((path) => {
    const [head, ...tail] = path;
    leads[head] || (leads[head] = []), leads[head].push(tail);
  });
  const next = Object.keys(leads).reduce((res, head) => {
    const tails = leads[head].filter((tail) => tail.length > 0);
    return tails.length === 0 ? res[head] = isRecord$4(value) ? value[head] : void 0 : res[head] = observePaths(value[head], tails, observeFields, apiConfig, perspective), res;
  }, currentValue);
  return of(next).pipe(props({
    wait: !0
  }));
}
function normalizePaths(path) {
  return path.map((segment) => typeof segment == "string" ? segment.split(".") : segment);
}
function createPathObserver(options) {
  const {
    observeFields
  } = options;
  return (value, paths, apiConfig, perspective) => observePaths(value, normalizePaths(paths), observeFields, apiConfig, perspective);
}
const REQUEST_TAG_BASE = "gdr", AVAILABILITY_READABLE$1 = {
  available: !0,
  reason: "READABLE"
}, AVAILABILITY_PERMISSION_DENIED$1 = {
  available: !1,
  reason: "PERMISSION_DENIED"
}, AVAILABILITY_NOT_FOUND$1 = {
  available: !1,
  reason: "NOT_FOUND"
};
function createGetReferenceInfo(context) {
  const {
    client
  } = context;
  return function(doc, referenceType) {
    return (doc._type ? of(doc) : client.observable.getDocument(doc._id).pipe(map((res) => ({
      _id: doc._id,
      _type: res?._type
    })))).pipe(switchMap((resolvedDoc) => {
      if (!resolvedDoc._type)
        return fetchDocumentAvailability(client, doc._id).pipe(map((availability) => ({
          id: doc._id,
          type: void 0,
          availability,
          preview: {
            published: void 0
          }
        })));
      const refSchemaType = referenceType.to.find((candidate) => candidate.type === resolvedDoc._type);
      if (!refSchemaType)
        return of({
          id: doc._id,
          type: resolvedDoc._type,
          availability: AVAILABILITY_READABLE$1,
          preview: {
            published: void 0
          }
        });
      const previewPaths = getPreviewPaths(refSchemaType?.preview) || [], listener = client.observable.listen("*", {}, {
        includeResult: !0,
        tag: `${REQUEST_TAG_BASE}.preview`,
        // by default listen only emits the "mutation" event, however we use the initial "welcome" event to trigger the initial state
        events: ["mutation", "welcome"]
      }), observeFields = createObserveFields$1({
        client,
        listener
      }), publishedPreview$ = createPathObserver({
        observeFields
      })(doc, previewPaths).pipe(map((result) => result ? prepareForPreview(result, refSchemaType) : null));
      return combineLatest([publishedPreview$]).pipe(map(([publishedPreview]) => ({
        type: resolvedDoc._type,
        id: doc._id,
        availability: AVAILABILITY_READABLE$1,
        preview: {
          published: isRecord$4(publishedPreview) ? publishedPreview : void 0
        }
      })));
    }));
  };
}
function createObserveFields$1(context) {
  const {
    client,
    listener
  } = context;
  return function(id2, fields) {
    return listener.pipe(switchMap((event) => {
      if (event.type === "welcome")
        return client.observable.getDocument(id2, {
          tag: `${REQUEST_TAG_BASE}.get-document`
        }).pipe(map((doc) => doc || null));
      if (event.type !== "mutation")
        return EMPTY$6;
      const result = event.result;
      return result ? result.documentId !== id2 ? EMPTY$6 : result.transition === "disappear" ? of(null) : of(result) : EMPTY$6;
    }));
  };
}
function fetchDocumentAvailability(client, id2) {
  const requestOptions = {
    uri: client.getDataUrl("doc", id2),
    json: !0,
    excludeContent: "true",
    tag: `${REQUEST_TAG_BASE}.availability`
  };
  return client.observable.request(requestOptions).pipe(map((response) => {
    const omittedEntry = keyBy(response.omitted || [], (entry) => entry.id)[id2];
    return omittedEntry ? omittedEntry.reason === "existence" ? AVAILABILITY_NOT_FOUND$1 : omittedEntry.reason === "permission" ? AVAILABILITY_PERMISSION_DENIED$1 : null : AVAILABILITY_READABLE$1;
  }));
}
const limit = 10;
function doSearch(client, searchTerm, types, searchOptions) {
  const {
    query,
    params,
    sortOrder
  } = createSearchQuery$1({
    types
  }, searchTerm, searchOptions);
  return client.observable.fetch(query, params).pipe(map((hits) => {
    const hasNextPage = hits.length > limit, lastResult = hasNextPage ? hits.at(-2) : hits.at(-1);
    return {
      type: "groq2024",
      // Search overfetches by 1 to determine whether there is another page to fetch. Therefore,
      // exclude the final result if it's beyond the limit.
      hits: hits.map((hit) => ({
        hit
      })).slice(0, limit),
      nextCursor: hasNextPage ? getNextCursor({
        lastResult,
        sortOrder
      }) : void 0
    };
  }));
}
function search(client, textTerm, type, options) {
  return doSearch(client, textTerm, type.to, options).pipe(map(({
    hits
  }) => hits.map(({
    hit
  }) => hit)), map((docs) => collate(docs)), map((collated) => collated.map((entry) => ({
    id: entry.id,
    type: entry.type,
    published: entry.published
  }))));
}
async function resolveUserDefinedFilter(options, document2, valuePath, getClient2) {
  if (!options)
    return {};
  if (typeof options.filter == "function") {
    const parentPath = valuePath.slice(0, -1), parent = get$1(document2, parentPath);
    return await options.filter({
      document: document2,
      parentPath,
      parent,
      getClient: getClient2
    });
  }
  return {
    filter: options.filter,
    params: "filterParams" in options ? options.filterParams : void 0
  };
}
function useValueRef(value) {
  const $ = c(3), ref = useRef(value);
  let t0, t1;
  return $[0] !== value ? (t0 = () => {
    ref.current = value;
  }, t1 = [value], $[0] = value, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), ref;
}
function StudioGlobalDocumentReferenceInput(props2) {
  const {
    path,
    schemaType
  } = props2, source = useSource(), client = source.getClient({
    apiVersion: "2025-02-19"
  }), getClient2 = source.getClient, {
    strategy: searchStrategy
  } = source.search, referenceClient = useMemo(() => getReferenceClient(client, schemaType), [client, schemaType]), documentValue = useFormValue([]), documentRef = useValueRef(documentValue), handleSearch = useCallback((searchString) => from(resolveUserDefinedFilter(schemaType.options, documentRef.current, path, getClient2)).pipe(mergeMap(({
    filter: filter2,
    params
  }) => search(referenceClient, searchString, schemaType, {
    ...schemaType.options,
    filter: filter2,
    params,
    tag: "search.global-document-reference",
    strategy: searchStrategy
  })), catchError((err) => {
    const isQueryError = err.details && err.details.type === "queryParseError";
    return schemaType.options?.filter && isQueryError && (err.message = 'Invalid reference filter, please check the custom "filter" option'), throwError(err);
  })), [schemaType, documentRef, path, getClient2, referenceClient, searchStrategy]), getReferenceInfo2 = useMemo(() => createGetReferenceInfo({
    client: referenceClient
  }), [referenceClient]);
  return /* @__PURE__ */ jsx(GlobalDocumentReferenceInput, { ...props2, getReferenceInfo: getReferenceInfo2, onSearch: handleSearch });
}
function urlToFile(url, filename) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const string = reader.result?.toString(), base64Index = string?.indexOf(";base64");
        if (!string || base64Index === -1) {
          reject(new Error("Could not convert URL to file"));
          return;
        }
        const ext = string.slice(11, base64Index);
        if (!ext && !filename) {
          reject(new Error("Could not find mime type for image"));
          return;
        }
        resolve(dataURLtoFile(reader.result, filename || `${uuid()}.${ext}`));
      }, reader.readAsDataURL(xhr.response);
    }, xhr.onerror = (error) => {
      reject(error);
    }, xhr.open("GET", url), xhr.responseType = "blob", xhr.send();
  });
}
function base64ToFile(base64Data, filename) {
  return new Promise((resolve, reject) => {
    const string = base64Data.toString(), base64Index = string.indexOf(";base64");
    if (!string || base64Index === -1) {
      reject(new Error("Could not convert base64 to file"));
      return;
    }
    const ext = string.slice(11, base64Index);
    if (!ext && !filename) {
      reject(new Error("Could not find mime type for image"));
      return;
    }
    resolve(dataURLtoFile(base64Data, filename || `${uuid()}.${ext}`));
  });
}
function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(","), mime = arr[0].match(/:(.*?);/)?.[1], bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  for (; n--; )
    u8arr[n] = bstr.charCodeAt(n);
  return new File([u8arr], filename, {
    type: mime
  });
}
function handleSelectAssetFromSource({
  assetsFromSource,
  onChange,
  type,
  resolveUploader: resolveUploader2,
  uploadWith,
  isImage: isImage2
}) {
  if (!assetsFromSource)
    throw new Error("No asset given");
  if (!Array.isArray(assetsFromSource) || assetsFromSource.length === 0)
    throw new Error("Returned value must be an array with at least one item (asset)");
  const firstAsset = assetsFromSource[0], assetProps = firstAsset.assetDocumentProps, mediaLibraryProps = firstAsset.mediaLibraryProps, originalFilename = assetProps?.originalFilename, label = assetProps?.label, title = assetProps?.title, description = assetProps?.description, creditLine = assetProps?.creditLine, source = assetProps?.source, assetPatches = isImage2 ? [unset(["hotspot"]), unset(["crop"]), unset(["media"])] : [unset(["media"])];
  if (mediaLibraryProps) {
    const assetContainerRef = {
      _type: "globalDocumentReference",
      _ref: `media-library:${mediaLibraryProps.mediaLibraryId}:${mediaLibraryProps.assetId}`,
      _weak: !0
    };
    assetPatches.push(set(assetContainerRef, ["media"]));
  }
  switch (firstAsset.kind) {
    case "assetDocumentId":
      onChange([setIfMissing({
        _type: type.name
      }), ...assetPatches, set({
        _type: "reference",
        _ref: firstAsset.value
      }, ["asset"])]);
      break;
    case "file": {
      const uploader = resolveUploader2(type, firstAsset.value);
      uploader && uploadWith(uploader, firstAsset.value, {
        label,
        title,
        description,
        creditLine,
        source
      });
      break;
    }
    case "base64":
      base64ToFile(firstAsset.value, originalFilename).then((file) => {
        const uploader = resolveUploader2(type, file);
        uploader && uploadWith(uploader, file, {
          label,
          title,
          description,
          creditLine,
          source
        });
      });
      break;
    case "url":
      urlToFile(firstAsset.value, originalFilename).then((file) => {
        const uploader = resolveUploader2(type, file);
        uploader && uploadWith(uploader, file, {
          label,
          title,
          description,
          creditLine,
          source
        });
      });
      break;
    default:
      throw new Error("Invalid value returned from asset source plugin");
  }
}
const RootFlex$4 = styled(Flex)`
  pointer-events: none;
`;
function PlaceholderText(props2) {
  const $ = c(24), {
    hoveringFiles,
    type,
    readOnly,
    acceptedFiles,
    rejectedFilesCount,
    directUploads
  } = props2, isFileType = type === "file", {
    t
  } = useTranslation();
  let t0;
  bb0: {
    if (readOnly) {
      let t13;
      $[0] === Symbol.for("react.memo_cache_sentinel") ? (t13 = /* @__PURE__ */ jsx(ReadOnlyIcon, {}), $[0] = t13) : t13 = $[0], t0 = t13;
      break bb0;
    }
    if (hoveringFiles && rejectedFilesCount > 0 || directUploads === !1) {
      let t13;
      $[1] === Symbol.for("react.memo_cache_sentinel") ? (t13 = /* @__PURE__ */ jsx(AccessDeniedIcon, {}), $[1] = t13) : t13 = $[1], t0 = t13;
      break bb0;
    }
    let t12;
    $[2] !== isFileType ? (t12 = isFileType ? /* @__PURE__ */ jsx(BinaryDocumentIcon, {}) : /* @__PURE__ */ jsx(ImageIcon, {}), $[2] = isFileType, $[3] = t12) : t12 = $[3], t0 = t12;
  }
  const messageIcon = t0;
  let t1;
  bb1: {
    if (directUploads === !1) {
      let t23;
      $[4] !== t ? (t23 = t("inputs.files.common.placeholder.upload-not-supported"), $[4] = t, $[5] = t23) : t23 = $[5], t1 = t23;
      break bb1;
    }
    if (readOnly) {
      let t23;
      $[6] !== t ? (t23 = t("inputs.files.common.placeholder.read-only"), $[6] = t, $[7] = t23) : t23 = $[7], t1 = t23;
      break bb1;
    }
    if (hoveringFiles && directUploads && !readOnly) {
      if (acceptedFiles.length > 0) {
        let t23;
        $[8] !== t || $[9] !== type ? (t23 = t("inputs.files.common.placeholder.drop-to-upload", {
          context: type
        }), $[8] = t, $[9] = type, $[10] = t23) : t23 = $[10], t1 = t23;
        break bb1;
      }
      if (rejectedFilesCount > 0) {
        let t23;
        $[11] !== rejectedFilesCount || $[12] !== t ? (t23 = t("inputs.files.common.placeholder.cannot-upload-some-files", {
          count: rejectedFilesCount
        }), $[11] = rejectedFilesCount, $[12] = t, $[13] = t23) : t23 = $[13], t1 = t23;
        break bb1;
      }
    }
    let t22;
    $[14] !== t || $[15] !== type ? (t22 = t("inputs.files.common.placeholder.drag-or-paste-to-upload", {
      context: type
    }), $[14] = t, $[15] = type, $[16] = t22) : t22 = $[16], t1 = t22;
  }
  const messageText = t1;
  let t2;
  $[17] !== messageIcon ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: messageIcon }), $[17] = messageIcon, $[18] = t2) : t2 = $[18];
  let t3;
  $[19] !== messageText ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: messageText }), $[19] = messageText, $[20] = t3) : t3 = $[20];
  let t4;
  return $[21] !== t2 || $[22] !== t3 ? (t4 = /* @__PURE__ */ jsxs(RootFlex$4, { align: "center", gap: 3, justify: "center", paddingLeft: 1, children: [
    t2,
    t3
  ] }), $[21] = t2, $[22] = t3, $[23] = t4) : t4 = $[23], t4;
}
const FileTarget = withFocusRing(fileTarget(Card)), TargetButton = styled(Button)`
  * {
    pointer-events: none;
  }
`;
function UploadDestinationPicker(props2) {
  const $ = c(37), {
    assetSources,
    onSelectAssetSource,
    text,
    onClose
  } = props2, {
    t
  } = useTranslation$1(), assetSourcesWithUpload = assetSources.filter(_temp$1B), [modes, setModes] = useState({
    ...assetSourcesWithUpload.reduce(_temp2$y, {})
  });
  let t0;
  $[0] !== assetSources || $[1] !== onSelectAssetSource ? (t0 = (event) => {
    const sourceName2 = event.target.getAttribute("data-asset-source-name");
    setModes((prev) => ({
      ...prev,
      [sourceName2]: "default"
    }));
    const assetSource = assetSources.find((source_0) => source_0.name === sourceName2);
    assetSource && onSelectAssetSource && onSelectAssetSource(assetSource);
  }, $[0] = assetSources, $[1] = onSelectAssetSource, $[2] = t0) : t0 = $[2];
  const handleDragEnter = t0;
  let t1;
  $[3] !== onSelectAssetSource ? (t1 = (event_0) => {
    const sourceName_0 = event_0.target.getAttribute("data-asset-source-name");
    setModes((prev_0) => ({
      ...prev_0,
      [sourceName_0]: "bleed"
    })), onSelectAssetSource && onSelectAssetSource(null);
  }, $[3] = onSelectAssetSource, $[4] = t1) : t1 = $[4];
  const handleDragLeave = t1;
  let t2;
  $[5] !== assetSources || $[6] !== onSelectAssetSource ? (t2 = (event_1) => {
    const sourceName_1 = event_1.currentTarget.getAttribute("data-asset-source-name"), assetSource_0 = assetSources.find((source_1) => source_1.name === sourceName_1);
    assetSource_0 && onSelectAssetSource && onSelectAssetSource(assetSource_0);
  }, $[5] = assetSources, $[6] = onSelectAssetSource, $[7] = t2) : t2 = $[7];
  const handleClick = t2;
  let t3;
  if ($[8] !== onClose ? (t3 = (event_2) => {
    event_2.key === "Escape" && onClose && onClose();
  }, $[8] = onClose, $[9] = t3) : t3 = $[9], useGlobalKeyDown(t3), assetSourcesWithUpload.length === 0)
    return null;
  const T0 = Popover, t4 = !0;
  let t5;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    top: "-0.5rem"
  }, $[10] = t5) : t5 = $[10];
  const t6 = props2.referenceElement, T1 = Box, t7 = 2;
  let t8;
  $[11] !== text ? (t8 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: text }) }), $[11] = text, $[12] = t8) : t8 = $[12];
  let t9;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t9 = {
    content: "Close"
  }, $[13] = t9) : t9 = $[13];
  let t10;
  $[14] !== onClose ? (t10 = /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: onClose, tooltipProps: t9 }), $[14] = onClose, $[15] = t10) : t10 = $[15];
  let t11;
  $[16] !== t10 || $[17] !== t8 ? (t11 = /* @__PURE__ */ jsx(Box, { padding: 2, paddingLeft: 4, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t8,
    t10
  ] }) }), $[16] = t10, $[17] = t8, $[18] = t11) : t11 = $[18];
  const T2 = Flex;
  let t12;
  $[19] !== handleClick || $[20] !== handleDragEnter || $[21] !== handleDragLeave || $[22] !== modes || $[23] !== t ? (t12 = (assetSource_1) => {
    const Icon2 = assetSource_1.icon;
    return /* @__PURE__ */ jsx(TargetButton, { "data-asset-source-name": assetSource_1.name, mode: modes[assetSource_1.name], onClick: handleClick, onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, size: "large", style: {
      padding: "2rem",
      margin: "0.5rem"
    }, tone: "default", tooltipProps: null, children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
      isValidElementType(Icon2) && /* @__PURE__ */ jsx(Icon2, { style: {
        fontSize: "2rem"
      } }),
      /* @__PURE__ */ jsx(Box, { children: assetSource_1.i18nKey ? t(assetSource_1.i18nKey) : assetSource_1.title })
    ] }) }, assetSource_1.name);
  }, $[19] = handleClick, $[20] = handleDragEnter, $[21] = handleDragLeave, $[22] = modes, $[23] = t, $[24] = t12) : t12 = $[24];
  const t13 = assetSourcesWithUpload.map(t12);
  let t14;
  $[25] !== T2 || $[26] !== t13 ? (t14 = /* @__PURE__ */ jsx(T2, { children: t13 }), $[25] = T2, $[26] = t13, $[27] = t14) : t14 = $[27];
  let t15;
  $[28] !== T1 || $[29] !== t11 || $[30] !== t14 ? (t15 = /* @__PURE__ */ jsxs(T1, { padding: t7, children: [
    t11,
    t14
  ] }), $[28] = T1, $[29] = t11, $[30] = t14, $[31] = t15) : t15 = $[31];
  let t16;
  return $[32] !== T0 || $[33] !== props2.referenceElement || $[34] !== t15 || $[35] !== t5 ? (t16 = /* @__PURE__ */ jsx(T0, { open: t4, style: t5, referenceElement: t6, content: t15 }), $[32] = T0, $[33] = props2.referenceElement, $[34] = t15, $[35] = t5, $[36] = t16) : t16 = $[36], t16;
}
function _temp2$y(acc, source) {
  return acc[source.name] = "bleed", acc;
}
function _temp$1B(s) {
  return !!s.uploader;
}
function getSizeDiff(prev, next) {
  if (!prev || !next)
    return 0;
  const increase = next - prev;
  return Math.round(increase / prev * 100);
}
function getHumanFriendlyBytes(bytes, format2) {
  return bytes < 1e3 ? format2(bytes, "byte") : bytes < 1e3 * 1e3 ? format2(bytes / 1e3, "kilobyte") : bytes < 1e3 * 1e3 * 1e3 ? format2(bytes / (1e3 * 1e3), "megabyte") : bytes < 1e3 * 1e3 * 1e3 * 1e3 ? format2(bytes / (1e3 * 1e3 * 1e3), "gigabyte") : format2(bytes / (1e3 * 1e3 * 1e3 * 1e3), "terabyte");
}
const INITIAL_STATE$9 = {
  referringDocuments: [],
  isLoading: !0
}, DEFAULT_FIELDS = ["_id", "_type"];
function useReferringDocuments(id2, t0) {
  const $ = c(6), fields = t0 === void 0 ? DEFAULT_FIELDS : t0, documentStore = useDocumentStore();
  let t1, t2;
  $[0] !== fields ? (t2 = fields.length === 0 ? "" : fields.join(","), $[0] = fields, $[1] = t2) : t2 = $[1], t1 = t2;
  const projection = t1;
  let t3, t4;
  return $[2] !== documentStore || $[3] !== id2 || $[4] !== projection ? (t4 = documentStore.listenQuery(`*[references($docId)] [0...101]${projection}`, {
    docId: id2
  }, {
    tag: "use-referring-documents"
  }).pipe(map(_temp$1A), startWith(INITIAL_STATE$9)), $[2] = documentStore, $[3] = id2, $[4] = projection, $[5] = t4) : t4 = $[5], t3 = t4, useObservable(t3, INITIAL_STATE$9);
}
function _temp$1A(docs) {
  return {
    referringDocuments: docs,
    isLoading: !1
  };
}
const EMPTY_FIELDS = [];
function useLegacyReferringDocuments(id2) {
  return useReferringDocuments(id2, EMPTY_FIELDS);
}
const AssetUsageList = (t0) => {
  const $ = c(16), {
    asset,
    assetType,
    referringDocuments
  } = t0, {
    t
  } = useTranslation(), count2 = referringDocuments.length, t1 = count2 > 0, t2 = `asset-source.usage-list.documents-using-${assetType}`, t3 = asset.originalFilename ? "named" : "unnamed";
  let t4;
  $[0] !== asset.originalFilename || $[1] !== count2 ? (t4 = {
    filename: asset.originalFilename,
    count: count2
  }, $[0] = asset.originalFilename, $[1] = count2, $[2] = t4) : t4 = $[2];
  let t5;
  $[3] !== t || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, as: "h2", weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t2, context: t3, values: t4 }) }), $[3] = t, $[4] = t2, $[5] = t3, $[6] = t4, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t1 || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { borderBottom: t1, marginTop: 2, paddingBottom: 2, marginBottom: 1, children: t5 }), $[8] = t1, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== referringDocuments ? (t7 = referringDocuments.map(_temp$1z), $[11] = referringDocuments, $[12] = t7) : t7 = $[12];
  let t8;
  return $[13] !== t6 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t6,
    t7
  ] }), $[13] = t6, $[14] = t7, $[15] = t8) : t8 = $[15], t8;
}, DocumentLink = (t0) => {
  const $ = c(15), {
    document: document2
  } = t0, schema2 = useSchema();
  let t1;
  $[0] !== document2._id || $[1] !== document2._type ? (t1 = (linkProps) => /* @__PURE__ */ jsx(IntentLink, { ...linkProps, params: {
    id: document2._id,
    type: document2._type
  }, intent: "edit" }), $[0] = document2._id, $[1] = document2._type, $[2] = t1) : t1 = $[2];
  const LinkComponent2 = t1, t2 = document2._id;
  let t3;
  $[3] !== document2._id ? (t3 = {
    _type: "reference",
    _ref: document2._id
  }, $[3] = document2._id, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== document2._type || $[6] !== schema2 ? (t4 = schema2.get(document2._type), $[5] = document2._type, $[6] = schema2, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, children: /* @__PURE__ */ jsx(Preview$1, { layout: "default", value: t3, schemaType: t4 }) }), $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  return $[11] !== LinkComponent2 || $[12] !== document2._id || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { as: LinkComponent2, radius: 2, "data-as": "a", tabIndex: 0, children: t5 }, t2), $[11] = LinkComponent2, $[12] = document2._id, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
};
function _temp$1z(document2) {
  return /* @__PURE__ */ jsx(DocumentLink, { document: document2 }, document2._id);
}
const STYLE_ASSET_IMAGE = {
  maxWidth: "100%",
  height: "120px",
  objectFit: "contain",
  objectPosition: "center"
}, STYLE_CONFIRM_CARD = {
  gridColumn: "span 1",
  overflow: "hidden",
  display: "flex",
  alignSelf: "center",
  justifyContent: "center"
}, STYLE_IMAGE_WRAPPER = {
  height: "100%"
}, ConfirmMessage = (t0) => {
  const $ = c(44), {
    asset,
    assetType,
    hasResults: t1
  } = t0, hasResults = t1 === void 0 ? !1 : t1, isImage2 = assetType === "image", {
    t
  } = useTranslation();
  if (hasResults) {
    let t22;
    $[0] === Symbol.for("react.memo_cache_sentinel") ? (t22 = [3, 3, 4], $[0] = t22) : t22 = $[0];
    let t32;
    $[1] === Symbol.for("react.memo_cache_sentinel") ? (t32 = [2, 3, 4], $[1] = t32) : t32 = $[1];
    let t42;
    $[2] === Symbol.for("react.memo_cache_sentinel") ? (t42 = [3, 4], $[2] = t42) : t42 = $[2];
    const t52 = isImage2 ? "span 2" : "span 3";
    let t62;
    $[3] !== t52 ? (t62 = {
      gridColumn: t52
    }, $[3] = t52, $[4] = t62) : t62 = $[4];
    let t72;
    $[5] === Symbol.for("react.memo_cache_sentinel") ? (t72 = /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[5] = t72) : t72 = $[5];
    const t82 = `asset-source.delete-dialog.usage-list.warning-${assetType}-is-in-use`, t92 = asset.originalFilename ? "named" : "unnamed";
    let t102;
    $[6] !== asset.originalFilename || $[7] !== t || $[8] !== t82 || $[9] !== t92 ? (t102 = t(t82, {
      context: t92,
      filename: asset.originalFilename
    }), $[6] = asset.originalFilename, $[7] = t, $[8] = t82, $[9] = t92, $[10] = t102) : t102 = $[10];
    let t112;
    $[11] !== t102 ? (t112 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t102 }), $[11] = t102, $[12] = t112) : t112 = $[12];
    let t122;
    $[13] !== t112 || $[14] !== t62 ? (t122 = /* @__PURE__ */ jsxs(Flex, { gap: t42, align: "center", style: t62, children: [
      t72,
      t112
    ] }), $[13] = t112, $[14] = t62, $[15] = t122) : t122 = $[15];
    let t13;
    $[16] !== asset.url || $[17] !== isImage2 || $[18] !== t ? (t13 = isImage2 && /* @__PURE__ */ jsx(Card, { __unstable_checkered: !0, border: !0, radius: 1, style: STYLE_CONFIRM_CARD, children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", style: STYLE_IMAGE_WRAPPER, children: /* @__PURE__ */ jsx("img", { src: `${asset.url}?w=200`, style: STYLE_ASSET_IMAGE, alt: t("asset-source.usage-list.image-alt"), referrerPolicy: "strict-origin-when-cross-origin" }) }) }), $[16] = asset.url, $[17] = isImage2, $[18] = t, $[19] = t13) : t13 = $[19];
    let t14;
    return $[20] !== t122 || $[21] !== t13 ? (t14 = /* @__PURE__ */ jsx(Card, { tone: "caution", padding: t22, border: !0, radius: 2, marginBottom: 3, children: /* @__PURE__ */ jsxs(Grid, { columns: 3, gap: t32, children: [
      t122,
      t13
    ] }) }), $[20] = t122, $[21] = t13, $[22] = t14) : t14 = $[22], t14;
  }
  let t2, t3;
  $[23] === Symbol.for("react.memo_cache_sentinel") ? (t2 = [2, 3, 4], t3 = [3, 3, 3, 4], $[23] = t2, $[24] = t3) : (t2 = $[23], t3 = $[24]);
  const t4 = isImage2 ? "span 2" : "span 3";
  let t5;
  $[25] !== t4 ? (t5 = {
    gridColumn: t4
  }, $[25] = t4, $[26] = t5) : t5 = $[26];
  const t6 = `asset-source.delete-dialog.usage-list.confirm-delete-${assetType}`, t7 = asset.originalFilename ? "named" : "unnamed";
  let t8;
  $[27] !== asset.originalFilename ? (t8 = {
    filename: asset.originalFilename
  }, $[27] = asset.originalFilename, $[28] = t8) : t8 = $[28];
  let t9;
  $[29] !== t || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: t6, context: t7, values: t8 }) }), $[29] = t, $[30] = t6, $[31] = t7, $[32] = t8, $[33] = t9) : t9 = $[33];
  let t10;
  $[34] !== t5 || $[35] !== t9 ? (t10 = /* @__PURE__ */ jsx(Flex, { style: t5, align: "center", children: t9 }), $[34] = t5, $[35] = t9, $[36] = t10) : t10 = $[36];
  let t11;
  $[37] !== asset.url || $[38] !== isImage2 || $[39] !== t ? (t11 = isImage2 && /* @__PURE__ */ jsx(Card, { __unstable_checkered: !0, border: !0, radius: 1, style: STYLE_CONFIRM_CARD, children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", style: STYLE_IMAGE_WRAPPER, children: /* @__PURE__ */ jsx("img", { src: `${asset.url}?w=200`, style: STYLE_ASSET_IMAGE, alt: t("asset-source.asset-list.table.preview-alt"), referrerPolicy: "strict-origin-when-cross-origin" }) }) }), $[37] = asset.url, $[38] = isImage2, $[39] = t, $[40] = t11) : t11 = $[40];
  let t12;
  return $[41] !== t10 || $[42] !== t11 ? (t12 = /* @__PURE__ */ jsx(Card, { paddingX: t2, paddingY: t3, children: /* @__PURE__ */ jsxs(Grid, { columns: 3, gap: 3, children: [
    t10,
    t11
  ] }) }), $[41] = t10, $[42] = t11, $[43] = t12) : t12 = $[43], t12;
};
function AssetDeleteDialog(t0) {
  const $ = c(32), {
    asset,
    assetType,
    isDeleting: t1,
    onClose,
    onDelete
  } = t0, isDeleting = t1 === void 0 ? !1 : t1, {
    isLoading,
    referringDocuments
  } = useLegacyReferringDocuments(asset._id);
  let t2, t3;
  if ($[0] !== referringDocuments) {
    const drafts = referringDocuments.reduce(_temp$1y, []);
    t3 = referringDocuments.filter((doc_0) => !drafts.includes(doc_0._id)), $[0] = referringDocuments, $[1] = t3;
  } else
    t3 = $[1];
  t2 = t3;
  const publishedDocuments = t2, hasResults = publishedDocuments.length > 0, {
    t
  } = useTranslation();
  let t4;
  $[2] !== t ? (t4 = t("asset-source.delete-dialog.action.cancel"), $[2] = t, $[3] = t4) : t4 = $[3];
  let t5;
  $[4] !== onClose || $[5] !== t4 ? (t5 = {
    onClick: onClose,
    text: t4
  }, $[4] = onClose, $[5] = t4, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== t ? (t6 = t("asset-source.delete-dialog.action.delete"), $[7] = t, $[8] = t6) : t6 = $[8];
  let t7;
  $[9] !== hasResults || $[10] !== isDeleting || $[11] !== onDelete || $[12] !== t6 ? (t7 = {
    disabled: hasResults,
    icon: TrashIcon,
    loading: isDeleting,
    onClick: onDelete,
    text: t6
  }, $[9] = hasResults, $[10] = isDeleting, $[11] = onDelete, $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t5 || $[15] !== t7 ? (t8 = {
    cancelButton: t5,
    confirmButton: t7
  }, $[14] = t5, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  $[17] !== assetType || $[18] !== t ? (t9 = t("asset-source.delete-dialog.header", {
    context: assetType
  }), $[17] = assetType, $[18] = t, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== asset || $[21] !== assetType || $[22] !== hasResults || $[23] !== isLoading || $[24] !== publishedDocuments ? (t10 = isLoading ? /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }) : /* @__PURE__ */ jsxs(Stack, { paddingX: hasResults ? [2, 3, 4] : 0, paddingY: hasResults ? [3, 3, 3, 4] : 0, space: 1, children: [
    /* @__PURE__ */ jsx(ConfirmMessage, { asset, assetType, hasResults }),
    hasResults && /* @__PURE__ */ jsx(AssetUsageList, { asset, referringDocuments: publishedDocuments, assetType })
  ] }), $[20] = asset, $[21] = assetType, $[22] = hasResults, $[23] = isLoading, $[24] = publishedDocuments, $[25] = t10) : t10 = $[25];
  let t11;
  return $[26] !== isLoading || $[27] !== onClose || $[28] !== t10 || $[29] !== t8 || $[30] !== t9 ? (t11 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: isLoading, footer: t8, header: t9, id: "asset-dialog", onClickOutside: onClose, onClose, width: 1, children: t10 }), $[26] = isLoading, $[27] = onClose, $[28] = t10, $[29] = t8, $[30] = t9, $[31] = t11) : t11 = $[31], t11;
}
function _temp$1y(acc, doc) {
  return doc._id.startsWith("drafts.") ? acc.concat(doc._id.slice(7)) : acc;
}
const MENU_POPOVER_PROPS$4 = {
  portal: !0,
  placement: "right"
};
function AssetMenu(t0) {
  const $ = c(23), {
    isSelected,
    border: t1,
    onAction
  } = t0, border = t1 === void 0 ? !0 : t1, triggerButtonMode = isSelected ? "default" : "bleed", triggerButtonTone = isSelected ? "primary" : "default", {
    t
  } = useTranslation(), t2 = border ? "ghost" : triggerButtonMode, t3 = border ? "default" : triggerButtonTone;
  let t4;
  $[0] !== t2 || $[1] !== t3 ? (t4 = /* @__PURE__ */ jsx(ContextMenuButton, { mode: t2, tone: t3 }), $[0] = t2, $[1] = t3, $[2] = t4) : t4 = $[2];
  let t5;
  $[3] !== t ? (t5 = t("asset-source.asset-list.menu.show-usage"), $[3] = t, $[4] = t5) : t5 = $[4];
  let t6;
  $[5] !== onAction ? (t6 = () => {
    onAction({
      type: "showUsage"
    });
  }, $[5] = onAction, $[6] = t6) : t6 = $[6];
  let t7;
  $[7] !== t5 || $[8] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuItem$1, { text: t5, icon: LinkIcon, onClick: t6 }), $[7] = t5, $[8] = t6, $[9] = t7) : t7 = $[9];
  let t8;
  $[10] !== t ? (t8 = t("asset-source.asset-list.menu.delete"), $[10] = t, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== onAction ? (t9 = () => {
    onAction({
      type: "delete"
    });
  }, $[12] = onAction, $[13] = t9) : t9 = $[13];
  let t10;
  $[14] !== t8 || $[15] !== t9 ? (t10 = /* @__PURE__ */ jsx(MenuItem$1, { text: t8, icon: TrashIcon, tone: "critical", onClick: t9 }), $[14] = t8, $[15] = t9, $[16] = t10) : t10 = $[16];
  let t11;
  $[17] !== t10 || $[18] !== t7 ? (t11 = /* @__PURE__ */ jsxs(Menu, { children: [
    t7,
    t10
  ] }), $[17] = t10, $[18] = t7, $[19] = t11) : t11 = $[19];
  let t12;
  return $[20] !== t11 || $[21] !== t4 ? (t12 = /* @__PURE__ */ jsx(MenuButton$1, { button: t4, id: "asset-menu", menu: t11, popover: MENU_POPOVER_PROPS$4 }), $[20] = t11, $[21] = t4, $[22] = t12) : t12 = $[22], t12;
}
function AssetUsageDialog(t0) {
  const $ = c(14), {
    asset,
    assetType,
    onClose
  } = t0, {
    isLoading,
    referringDocuments
  } = useLegacyReferringDocuments(asset._id);
  let t1, t2;
  if ($[0] !== referringDocuments) {
    const drafts = referringDocuments.reduce(_temp$1x, []);
    t2 = referringDocuments.filter((doc_0) => !drafts.includes(doc_0._id)), $[0] = referringDocuments, $[1] = t2;
  } else
    t2 = $[1];
  t1 = t2;
  const publishedDocuments = t1, {
    t
  } = useTranslation();
  let t3;
  $[2] !== assetType || $[3] !== t ? (t3 = t("asset-source.asset-usage-dialog.header", {
    context: assetType
  }), $[2] = assetType, $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== asset || $[6] !== assetType || $[7] !== isLoading || $[8] !== publishedDocuments ? (t4 = isLoading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) : /* @__PURE__ */ jsx(AssetUsageList, { asset, referringDocuments: publishedDocuments, assetType }), $[5] = asset, $[6] = assetType, $[7] = isLoading, $[8] = publishedDocuments, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== onClose || $[11] !== t3 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: !0, header: t3, id: "asset-dialog", onClickOutside: onClose, onClose, width: 1, children: t4 }), $[10] = onClose, $[11] = t3, $[12] = t4, $[13] = t5) : t5 = $[13], t5;
}
function _temp$1x(acc, doc) {
  return doc._id.startsWith("drafts.") ? acc.concat(doc._id.slice(7)) : acc;
}
const MIME_TYPES = {
  // Images
  "image/bmp": {
    title: "Bitmap Image"
  },
  "image/jpeg": {
    title: "JPEG Image"
  },
  "image/gif": {
    title: "GIF Image"
  },
  "image/vnd.microsoft.icon": {
    title: "Icon"
  },
  "image/png": {
    title: "PNG Image"
  },
  "image/svg+xml": {
    title: "SVG Image"
  },
  "image/webp": {
    title: "WebP Image"
  },
  "image/tiff": {
    title: "TIFF Image"
  },
  "image/heic": {
    title: "HEIC Image"
  },
  // Audio
  "audio/midi": {
    title: "MIDI Audio"
  },
  "audio/midi-x": {
    title: "MIDI Audio"
  },
  "audio/mpeg": {
    title: "MP3 Audio"
  },
  "audio/ogg": {
    title: "OGG Audio"
  },
  "audio/wav": {
    title: "WAV Audio"
  },
  "audio/webm": {
    title: "WebM Audio"
  },
  "audio/aac": {
    title: "AAC Audio"
  },
  // Video
  "video/x-msvideo": {
    title: "AVI Video"
  },
  "video/mp4": {
    title: "MP4 Video"
  },
  "video/mpeg": {
    title: "MPEG Video"
  },
  "video/ogg": {
    title: "OGG Video"
  },
  "video/webm": {
    title: "WebM Video"
  },
  "video/quicktime": {
    title: "QuickTime Video"
  },
  // Documents
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
    title: "Excel Spreadsheet"
  },
  "application/vnd.ms-excel": {
    title: "Excel Spreadsheet"
  },
  "text/plain": {
    title: "Text"
  },
  "text/javascript": {
    title: "JavaScript"
  },
  "text/markdown": {
    title: "Markdown"
  },
  "text/csv": {
    title: "CSV"
  },
  "text/css": {
    title: "CSS"
  },
  "application/pdf": {
    title: "PDF Document"
  },
  "application/xml": {
    title: "XML Document"
  },
  "text/xml": {
    title: "XML Document"
  },
  "application/zip": {
    title: "ZIP Archive"
  },
  "application/vnd.rar": {
    title: "RAR Archive"
  },
  "application/x-7z-compressed": {
    title: "7-zip Archive"
  },
  "application/octet-stream": {
    title: "Binary"
  }
};
function convertMimeTypeToSomethingNice(mimeType) {
  const part = mimeType.replace("x-", "").split("/")[1];
  return part.charAt(0).toUpperCase() + part.slice(1);
}
function formatMimeType(mimeType) {
  return MIME_TYPES?.[mimeType] ? MIME_TYPES[mimeType].title : convertMimeTypeToSomethingNice(mimeType);
}
const CardIconWrapper = styled.span`
  background-color: transparent;
  flex-shrink: 0;
`, CustomFlex = styled(Flex)``, CustomCard$1 = styled(Card)`
  ${(props2) => props2.isSelected && css`
      --card-muted-fg-color: var(--card-bg-color);
      --card-fg-color: var(--card-bg-color);
    `}
`, RowButton = styled(Button$1)`
  box-shadow: none;
  min-width: 0;
  cursor: pointer;
  position: initial;

  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  &:before {
    z-index: 0;
    pointer-events: none;
    border-radius: inherit;
  }

  ${(props2) => props2.isSelected && css`
      --card-muted-fg-color: var(--card-bg-color);
      --card-fg-color: var(--card-bg-color);

      &:before {
        background-color: var(--card-focus-ring-color);
      }

      ${CardIconWrapper} {
        --card-muted-fg-color: var(--card-bg-color);
      }

      ${CustomFlex} {
        --card-muted-fg-color: var(--card-bg-color);
        --card-fg-color: var(--card-bg-color);
      }
    `}

  ${(props2) => !props2.isSelected && css`
      &:hover:before {
        background-color: var(--card-bg-color);
      }

      &:focus:before {
        background-color: var(--card-code-bg-color);
      }

      &:focus-within:before {
        background-color: var(--card-bg-color);
      }
    `}
`, TypeText = styled(Text$1)`
  overflow-wrap: anywhere;
`, STYLES_ROW_CARD = {
  position: "relative"
}, STYLES_ICON_CARD = {
  flexShrink: 0
}, STYLES_BUTTON_TEXT = {
  minWidth: 0
}, STYLES_ASSETMENU_WRAPPER = {
  zIndex: 3,
  marginTop: "-0.5rem",
  marginBottom: "-0.5rem"
}, AssetRow = (props2) => {
  const $ = c(105), versionedClient2 = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), toast = useToast(), deleteRef$ = useRef(void 0), [showUsageDialog, setShowUsageDialog] = useState(!1), [showDeleteDialog, setShowDeleteDialog] = useState(!1), [isDeleting, setIsDeleting] = useState(!1), [isOpen, setIsOpen] = useState(!1), {
    asset,
    onClick: onClick2,
    onKeyPress,
    onDeleteFinished,
    isSelected,
    isMobile
  } = props2, {
    originalFilename,
    _id,
    mimeType,
    size,
    _createdAt
  } = asset;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    useTemporalPhrase: !0
  }, $[0] = t0) : t0 = $[0];
  const formattedTime = useRelativeTime(_createdAt, t0);
  let t1;
  $[1] !== mimeType ? (t1 = formatMimeType(mimeType), $[1] = mimeType, $[2] = t1) : t1 = $[2];
  const formattedMimeType = t1;
  let t2;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    unitDisplay: "short",
    maximumFractionDigits: 2
  }, $[3] = t2) : t2 = $[3];
  const formatUnit = useUnitFormatter(t2);
  let t3;
  $[4] !== formatUnit || $[5] !== size ? (t3 = getHumanFriendlyBytes(size, formatUnit), $[4] = formatUnit, $[5] = size, $[6] = t3) : t3 = $[6];
  const formattedSize = t3, showTooltip = (originalFilename || "").length > 37, {
    t
  } = useTranslation();
  let t4;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setShowDeleteDialog(!0);
  }, $[7] = t4) : t4 = $[7];
  const handleConfirmDelete = t4;
  let t5;
  $[8] !== t || $[9] !== toast ? (t5 = (error) => {
    toast.push({
      closable: !0,
      status: "error",
      title: t("asset-source.file.asset-list.delete-failed"),
      description: error.message
    });
  }, $[8] = t, $[9] = toast, $[10] = t5) : t5 = $[10];
  const handleDeleteError = t5;
  let t6;
  $[11] !== t || $[12] !== toast ? (t6 = () => {
    toast.push({
      status: "success",
      title: t("asset-source.file.asset-list.delete-successful")
    });
  }, $[11] = t, $[12] = toast, $[13] = t6) : t6 = $[13];
  const handleDeleteSuccess = t6;
  let t7;
  $[14] !== asset._id || $[15] !== handleDeleteError || $[16] !== handleDeleteSuccess || $[17] !== onDeleteFinished || $[18] !== versionedClient2.observable ? (t7 = () => {
    setIsDeleting(!0), deleteRef$.current = versionedClient2.observable.delete(asset._id).subscribe({
      next: () => {
        setIsDeleting(!1), onDeleteFinished?.(asset._id), setShowDeleteDialog(!1), handleDeleteSuccess();
      },
      error: (err) => {
        setIsDeleting(!1), handleDeleteError(err), console.error("Could not delete asset", err);
      }
    });
  }, $[14] = asset._id, $[15] = handleDeleteError, $[16] = handleDeleteSuccess, $[17] = onDeleteFinished, $[18] = versionedClient2.observable, $[19] = t7) : t7 = $[19];
  const handleDeleteAsset = t7;
  let t8;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    setShowUsageDialog(!1), setShowDeleteDialog(!1);
  }, $[20] = t8) : t8 = $[20];
  const handleDialogClose = t8;
  let t9;
  $[21] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
    setShowUsageDialog(!0);
  }, $[21] = t9) : t9 = $[21];
  const handleToggleUsageDialog = t9;
  let t10;
  $[22] === Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    setIsOpen(_temp$1w);
  }, $[22] = t10) : t10 = $[22];
  const handleToggleOpen = t10;
  let t11;
  $[23] === Symbol.for("react.memo_cache_sentinel") ? (t11 = (action) => {
    action.type === "delete" && handleConfirmDelete(), action.type === "showUsage" && handleToggleUsageDialog();
  }, $[23] = t11) : t11 = $[23];
  const handleMenuAction = t11;
  let t12, t13;
  $[24] !== asset || $[25] !== showUsageDialog ? (t13 = showUsageDialog && /* @__PURE__ */ jsx(AssetUsageDialog, { assetType: "file", asset, onClose: handleDialogClose }), $[24] = asset, $[25] = showUsageDialog, $[26] = t13) : t13 = $[26], t12 = t13;
  const usageDialog = t12;
  let t14, t15;
  $[27] !== asset || $[28] !== handleDeleteAsset || $[29] !== isDeleting || $[30] !== showDeleteDialog ? (t15 = showDeleteDialog && /* @__PURE__ */ jsx(AssetDeleteDialog, { assetType: "file", asset, onClose: handleDialogClose, onDelete: handleDeleteAsset, isDeleting }), $[27] = asset, $[28] = handleDeleteAsset, $[29] = isDeleting, $[30] = showDeleteDialog, $[31] = t15) : t15 = $[31], t14 = t15;
  const deleteDialog = t14;
  if (isMobile) {
    const t162 = isDeleting ? 0.5 : 1;
    let t172;
    $[32] !== t162 ? (t172 = {
      position: "relative",
      gridTemplateColumns: "1fr 30px",
      opacity: t162
    }, $[32] = t162, $[33] = t172) : t172 = $[33];
    let t182;
    $[34] === Symbol.for("react.memo_cache_sentinel") ? (t182 = /* @__PURE__ */ jsx(Card, { as: CardIconWrapper, padding: 2, tone: "transparent", radius: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 2, style: STYLES_ICON_CARD, children: /* @__PURE__ */ jsx(DocumentIcon, {}) }) }), $[34] = t182) : t182 = $[34];
    let t192;
    $[35] !== originalFilename ? (t192 = /* @__PURE__ */ jsxs(Flex, { gap: 2, flex: 2, align: "center", children: [
      t182,
      /* @__PURE__ */ jsx(Text$1, { size: 1, align: "left", textOverflow: "ellipsis", style: STYLES_BUTTON_TEXT, children: originalFilename })
    ] }), $[35] = originalFilename, $[36] = t192) : t192 = $[36];
    let t202;
    $[37] !== _id || $[38] !== asset || $[39] !== onClick2 || $[40] !== t192 ? (t202 = /* @__PURE__ */ jsx(RowButton, { asset, mode: "bleed", padding: 0, "data-id": _id, onClick: onClick2, paddingY: 1, radius: 2, children: t192 }), $[37] = _id, $[38] = asset, $[39] = onClick2, $[40] = t192, $[41] = t202) : t202 = $[41];
    const t212 = isOpen ? ChevronUpIcon : ChevronDownIcon;
    let t222;
    $[42] !== t212 ? (t222 = /* @__PURE__ */ jsx(Flex, { justify: "flex-end", align: "center", paddingRight: 1, style: STYLES_ASSETMENU_WRAPPER, children: /* @__PURE__ */ jsx(Button$1, { mode: "bleed", fontSize: 1, padding: 2, onClick: handleToggleOpen, icon: t212 }) }), $[42] = t212, $[43] = t222) : t222 = $[43];
    let t232;
    $[44] !== t172 || $[45] !== t202 || $[46] !== t222 ? (t232 = /* @__PURE__ */ jsxs(Grid, { columns: 4, gap: 1, style: t172, children: [
      t202,
      t222
    ] }), $[44] = t172, $[45] = t202, $[46] = t222, $[47] = t232) : t232 = $[47];
    let t242;
    $[48] !== formattedMimeType || $[49] !== formattedSize || $[50] !== formattedTime || $[51] !== isOpen || $[52] !== isSelected || $[53] !== t ? (t242 = isOpen && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Grid, { marginTop: 3, columns: 3, gap: 1, children: [
        /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", children: t("asset-source.file.asset-list.header.size") }),
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedSize })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", children: t("asset-source.file.asset-list.header.type") }),
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedMimeType })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, weight: "medium", children: t("asset-source.file.asset-list.header.date-added") }),
          /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedTime })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { space: 2, marginTop: 3, children: [
        /* @__PURE__ */ jsx(Button$1, { fontSize: 1, tone: "default", mode: "ghost", text: t("asset-source.file.asset-list.action.show-usage.title"), onClick: handleToggleUsageDialog, icon: LinkIcon }),
        /* @__PURE__ */ jsx(Button$1, { fontSize: 1, tone: "critical", mode: "ghost", text: t("asset-source.file.asset-list.action.delete.title"), icon: TrashIcon, disabled: isSelected, title: t(isSelected ? "asset-source.file.asset-list.action.delete.disabled-cannot-delete-current-file" : "asset-source.file.asset-list.action.delete.title"), onClick: handleConfirmDelete })
      ] })
    ] }), $[48] = formattedMimeType, $[49] = formattedSize, $[50] = formattedTime, $[51] = isOpen, $[52] = isSelected, $[53] = t, $[54] = t242) : t242 = $[54];
    const t252 = usageDialog || deleteDialog;
    let t262;
    return $[55] !== t232 || $[56] !== t242 || $[57] !== t252 ? (t262 = /* @__PURE__ */ jsxs(Card, { paddingBottom: 2, style: STYLES_ROW_CARD, children: [
      t232,
      t242,
      t252
    ] }), $[55] = t232, $[56] = t242, $[57] = t252, $[58] = t262) : t262 = $[58], t262;
  }
  const t16 = isDeleting ? 0.5 : 1;
  let t17;
  $[59] !== t16 ? (t17 = {
    position: "relative",
    gridTemplateColumns: "3fr 1fr 1fr 2fr 30px",
    opacity: t16
  }, $[59] = t16, $[60] = t17) : t17 = $[60];
  let t18;
  $[61] !== originalFilename || $[62] !== t ? (t18 = t("asset-source.file.asset-list.item.select-file-tooltip", {
    filename: originalFilename
  }), $[61] = originalFilename, $[62] = t, $[63] = t18) : t18 = $[63];
  let t19;
  $[64] === Symbol.for("react.memo_cache_sentinel") ? (t19 = /* @__PURE__ */ jsx(Card, { as: CardIconWrapper, padding: 2, tone: "transparent", radius: 2, style: STYLES_ICON_CARD, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 2, children: /* @__PURE__ */ jsx(DocumentIcon, {}) }) }), $[64] = t19) : t19 = $[64];
  let t20;
  $[65] !== originalFilename || $[66] !== showTooltip ? (t20 = showTooltip && /* @__PURE__ */ jsx(Tooltip, { content: originalFilename, children: /* @__PURE__ */ jsx(Text$1, { size: 1, align: "left", textOverflow: "ellipsis", style: STYLES_BUTTON_TEXT, children: originalFilename }) }), $[65] = originalFilename, $[66] = showTooltip, $[67] = t20) : t20 = $[67];
  let t21;
  $[68] !== originalFilename || $[69] !== showTooltip ? (t21 = !showTooltip && /* @__PURE__ */ jsx(Text$1, { size: 1, align: "left", textOverflow: "ellipsis", style: STYLES_BUTTON_TEXT, children: originalFilename }), $[68] = originalFilename, $[69] = showTooltip, $[70] = t21) : t21 = $[70];
  let t22;
  $[71] !== _id || $[72] !== onClick2 || $[73] !== onKeyPress || $[74] !== t20 || $[75] !== t21 ? (t22 = /* @__PURE__ */ jsxs(CustomFlex, { gap: 2, flex: 2, paddingRight: 1, align: "center", onClick: onClick2, onKeyPress, "data-id": _id, children: [
    t19,
    t20,
    t21
  ] }), $[71] = _id, $[72] = onClick2, $[73] = onKeyPress, $[74] = t20, $[75] = t21, $[76] = t22) : t22 = $[76];
  let t23;
  $[77] !== _id || $[78] !== asset || $[79] !== isSelected || $[80] !== onClick2 || $[81] !== onKeyPress || $[82] !== t18 || $[83] !== t22 ? (t23 = /* @__PURE__ */ jsx(RowButton, { asset, mode: "bleed", "data-id": _id, onClick: onClick2, padding: 0, onKeyPress, title: t18, isSelected, radius: 2, children: t22 }), $[77] = _id, $[78] = asset, $[79] = isSelected, $[80] = onClick2, $[81] = onKeyPress, $[82] = t18, $[83] = t22, $[84] = t23) : t23 = $[84];
  let t24;
  $[85] !== formattedSize ? (t24 = /* @__PURE__ */ jsx(CustomFlex, { align: "center", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedSize }) }), $[85] = formattedSize, $[86] = t24) : t24 = $[86];
  let t25;
  $[87] !== formattedMimeType ? (t25 = /* @__PURE__ */ jsx(CustomFlex, { align: "center", children: /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(TypeText, { size: 1, muted: !0, textOverflow: "ellipsis", children: formattedMimeType }) }) }), $[87] = formattedMimeType, $[88] = t25) : t25 = $[88];
  let t26;
  $[89] !== _createdAt || $[90] !== formattedTime ? (t26 = /* @__PURE__ */ jsx(CustomFlex, { align: "center", children: /* @__PURE__ */ jsx(Text$1, { as: "time", size: 1, muted: !0, dateTime: _createdAt, children: formattedTime }) }), $[89] = _createdAt, $[90] = formattedTime, $[91] = t26) : t26 = $[91];
  let t27;
  $[92] === Symbol.for("react.memo_cache_sentinel") ? (t27 = /* @__PURE__ */ jsx(CustomFlex, { justify: "flex-end", align: "center", paddingX: 1, paddingY: 1, style: STYLES_ASSETMENU_WRAPPER, children: /* @__PURE__ */ jsx(AssetMenu, { border: !1, isSelected: !1, onAction: handleMenuAction }) }), $[92] = t27) : t27 = $[92];
  let t28;
  $[93] !== _id || $[94] !== t17 || $[95] !== t23 || $[96] !== t24 || $[97] !== t25 || $[98] !== t26 ? (t28 = /* @__PURE__ */ jsxs(Grid, { columns: 4, gap: 1, "data-id": _id, paddingY: 1, style: t17, children: [
    t23,
    t24,
    t25,
    t26,
    t27
  ] }), $[93] = _id, $[94] = t17, $[95] = t23, $[96] = t24, $[97] = t25, $[98] = t26, $[99] = t28) : t28 = $[99];
  const t29 = usageDialog || deleteDialog;
  let t30;
  return $[100] !== asset || $[101] !== isSelected || $[102] !== t28 || $[103] !== t29 ? (t30 = /* @__PURE__ */ jsxs(CustomCard$1, { asset, paddingBottom: 1, style: STYLES_ROW_CARD, radius: 0, overflow: "hidden", isSelected, "aria-selected": "true", children: [
    t28,
    t29
  ] }), $[100] = asset, $[101] = isSelected, $[102] = t28, $[103] = t29, $[104] = t30) : t30 = $[104], t30;
};
function _temp$1w(prev) {
  return !prev;
}
const STYLES_FILENAME = {
  paddingLeft: "2.2rem"
}, STYLES_GRID = {
  gridTemplateColumns: "3fr 1fr 1fr 2fr 30px"
};
function FileListView(props2) {
  const $ = c(25), isMobile = useMediaIndex() < 2, {
    assets,
    onClick: onClick2,
    onKeyPress,
    onDeleteFinished,
    selectedAssets,
    isLoading
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== isMobile || $[1] !== t ? (t0 = /* @__PURE__ */ jsx(Card, { borderBottom: !0, paddingBottom: 2, marginBottom: 1, children: isMobile ? /* @__PURE__ */ jsx(Grid, { style: STYLES_GRID, children: /* @__PURE__ */ jsx(Box, { flex: 2, paddingLeft: 5, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.filename") }) }) }) : /* @__PURE__ */ jsxs(Grid, { gap: 1, style: STYLES_GRID, children: [
    /* @__PURE__ */ jsx(Box, { flex: 2, style: STYLES_FILENAME, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.filename") }) }),
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.size") }) }),
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.type") }) }),
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("asset-source.file.asset-list.header.date-added") }) })
  ] }) }), $[0] = isMobile, $[1] = t, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== assets.length || $[4] !== isLoading ? (t1 = isLoading && assets.length === 0 && /* @__PURE__ */ jsx(Box, { paddingTop: 4, paddingBottom: 2, children: /* @__PURE__ */ jsx(Flex, { justify: "center", children: /* @__PURE__ */ jsx(Spinner, { muted: !0 }) }) }), $[3] = assets.length, $[4] = isLoading, $[5] = t1) : t1 = $[5];
  let t2;
  if ($[6] !== assets || $[7] !== isMobile || $[8] !== onClick2 || $[9] !== onDeleteFinished || $[10] !== onKeyPress || $[11] !== selectedAssets) {
    let t32;
    $[13] !== isMobile || $[14] !== onClick2 || $[15] !== onDeleteFinished || $[16] !== onKeyPress || $[17] !== selectedAssets ? (t32 = (asset) => /* @__PURE__ */ jsx(AssetRow, { asset, isMobile, isSelected: selectedAssets.some((selected) => selected._id === asset._id), onClick: onClick2, onKeyPress, onDeleteFinished }, asset._id), $[13] = isMobile, $[14] = onClick2, $[15] = onDeleteFinished, $[16] = onKeyPress, $[17] = selectedAssets, $[18] = t32) : t32 = $[18], t2 = assets.map(t32), $[6] = assets, $[7] = isMobile, $[8] = onClick2, $[9] = onDeleteFinished, $[10] = onKeyPress, $[11] = selectedAssets, $[12] = t2;
  } else
    t2 = $[12];
  let t3;
  $[19] !== t1 || $[20] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Stack, { children: [
    t1,
    t2
  ] }), $[19] = t1, $[20] = t2, $[21] = t3) : t3 = $[21];
  let t4;
  return $[22] !== t0 || $[23] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Box, { children: [
    t0,
    t3
  ] }), $[22] = t0, $[23] = t3, $[24] = t4) : t4 = $[24], t4;
}
const DPI = typeof window > "u" || !window.devicePixelRatio ? 1 : Math.round(window.devicePixelRatio), Image$6 = styled.img`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
`, Container$1 = styled(Card)`
  position: relative;
  z-index: 1;
  padding-bottom: 100%;
`, Root$m = styled.div`
  position: relative;
  display: inherit;
`, MenuContainer = styled.div`
  box-sizing: border-box;
  position: absolute;
  z-index: 2;
  top: 3px;
  right: 3px;

  & button[data-selected] {
    display: block;
  }

  @media (hover: hover) {
    // If hover is supported, hide the buttons until the user hovers or focuses the asset
    // Use opacity to enable the buttons to still be focusable
    & button {
      opacity: 0;
    }

    ${Root$m}:hover & {
      button {
        opacity: 1;
      }
    }

    ${Root$m}:focus-within & {
      button {
        opacity: 1;
      }
    }
  }
`, AssetThumb = memo(function(props2) {
  const $ = c(48), versionedClient2 = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), toast = useToast(), deleteRef$ = useRef(void 0), {
    asset,
    onClick: onClick2,
    onKeyPress,
    onDeleteFinished,
    isSelected
  } = props2, [showUsageDialog, setShowUsageDialog] = useState(!1), [showDeleteDialog, setShowDeleteDialog] = useState(!1), [isDeleting, setIsDeleting] = useState(!1), {
    t
  } = useTranslation();
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => () => {
    deleteRef$.current && deleteRef$.current.unsubscribe();
  }, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setShowDeleteDialog(!0);
  }, $[2] = t2) : t2 = $[2];
  const handleConfirmDelete = t2;
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setShowUsageDialog(!1), setShowDeleteDialog(!1);
  }, $[3] = t3) : t3 = $[3];
  const handleDialogClose = t3;
  let t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setShowUsageDialog(!0);
  }, $[4] = t4) : t4 = $[4];
  const handleToggleUsageDialog = t4;
  let t5;
  $[5] !== t || $[6] !== toast ? (t5 = (error) => {
    toast.push({
      closable: !0,
      status: "error",
      title: t("asset-source.image.asset-list.delete-failed"),
      description: error.message
    });
  }, $[5] = t, $[6] = toast, $[7] = t5) : t5 = $[7];
  const handleDeleteError = t5;
  let t6;
  $[8] !== t || $[9] !== toast ? (t6 = () => {
    toast.push({
      status: "success",
      title: t("asset-source.image.asset-list.delete-successful")
    });
  }, $[8] = t, $[9] = toast, $[10] = t6) : t6 = $[10];
  const handleDeleteSuccess = t6;
  let t7;
  $[11] !== asset._id || $[12] !== handleDeleteError || $[13] !== handleDeleteSuccess || $[14] !== onDeleteFinished || $[15] !== versionedClient2.observable ? (t7 = () => {
    setIsDeleting(!0), deleteRef$.current = versionedClient2.observable.delete(asset._id).subscribe({
      next: () => {
        setIsDeleting(!1), onDeleteFinished(asset._id), setShowDeleteDialog(!1), handleDeleteSuccess();
      },
      error: (err) => {
        setIsDeleting(!1), handleDeleteError(err), console.error("Could not delete asset", err);
      }
    });
  }, $[11] = asset._id, $[12] = handleDeleteError, $[13] = handleDeleteSuccess, $[14] = onDeleteFinished, $[15] = versionedClient2.observable, $[16] = t7) : t7 = $[16];
  const handleDeleteAsset = t7;
  let t8;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t8 = (action) => {
    action.type === "delete" && handleConfirmDelete(), action.type === "showUsage" && handleToggleUsageDialog();
  }, $[17] = t8) : t8 = $[17];
  const handleMenuAction = t8;
  let t9, t10;
  $[18] !== asset || $[19] !== showUsageDialog ? (t10 = showUsageDialog && /* @__PURE__ */ jsx(AssetUsageDialog, { assetType: "file", asset, onClose: handleDialogClose }), $[18] = asset, $[19] = showUsageDialog, $[20] = t10) : t10 = $[20], t9 = t10;
  const usageDialog = t9;
  let t11, t12;
  $[21] !== asset || $[22] !== handleDeleteAsset || $[23] !== isDeleting || $[24] !== showDeleteDialog ? (t12 = showDeleteDialog && /* @__PURE__ */ jsx(AssetDeleteDialog, { assetType: "file", asset, onClose: handleDialogClose, onDelete: handleDeleteAsset, isDeleting }), $[21] = asset, $[22] = handleDeleteAsset, $[23] = isDeleting, $[24] = showDeleteDialog, $[25] = t12) : t12 = $[25], t11 = t12;
  const deleteDialog = t11, {
    originalFilename,
    _id,
    url
  } = asset, imgH = 200 * Math.max(1, DPI), imageUrl = url.includes(".gif") ? `${url}?h=${imgH}&fit=max&fm=jpg` : `${url}?h=${imgH}&fit=max`;
  let t13;
  $[26] === Symbol.for("react.memo_cache_sentinel") ? (t13 = {
    padding: 2
  }, $[26] = t13) : t13 = $[26];
  let t14;
  $[27] !== _id || $[28] !== imageUrl || $[29] !== onClick2 || $[30] !== originalFilename ? (t14 = /* @__PURE__ */ jsx(Image$6, { alt: originalFilename, src: imageUrl, onClick: onClick2, "data-id": _id }), $[27] = _id, $[28] = imageUrl, $[29] = onClick2, $[30] = originalFilename, $[31] = t14) : t14 = $[31];
  let t15;
  $[32] !== isDeleting ? (t15 = isDeleting && /* @__PURE__ */ jsx(LoadingBlock, {}), $[32] = isDeleting, $[33] = t15) : t15 = $[33];
  let t16;
  $[34] !== t14 || $[35] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Container$1, { __unstable_checkered: !0, children: [
    t14,
    t15
  ] }), $[34] = t14, $[35] = t15, $[36] = t16) : t16 = $[36];
  let t17;
  $[37] !== _id || $[38] !== isSelected || $[39] !== onKeyPress || $[40] !== t16 ? (t17 = /* @__PURE__ */ jsx(Button$1, { selected: isSelected, tabIndex: 0, "data-id": _id, mode: "ghost", onKeyPress, padding: 0, style: t13, children: t16 }), $[37] = _id, $[38] = isSelected, $[39] = onKeyPress, $[40] = t16, $[41] = t17) : t17 = $[41];
  let t18;
  $[42] !== isSelected ? (t18 = /* @__PURE__ */ jsx(MenuContainer, { children: /* @__PURE__ */ jsx(AssetMenu, { isSelected, onAction: handleMenuAction }) }), $[42] = isSelected, $[43] = t18) : t18 = $[43];
  const t19 = usageDialog || deleteDialog;
  let t20;
  return $[44] !== t17 || $[45] !== t18 || $[46] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Root$m, { children: [
    t17,
    t18,
    t19
  ] }), $[44] = t17, $[45] = t18, $[46] = t19, $[47] = t20) : t20 = $[47], t20;
}), ThumbGrid = styled(Grid)`
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
`;
function ImageListView(props2) {
  const $ = c(23), {
    isLoading,
    assets,
    selectedAssets,
    onItemClick,
    onItemKeyPress,
    onDeleteFinished
  } = props2;
  let t0;
  if ($[0] !== assets || $[1] !== onDeleteFinished || $[2] !== onItemClick || $[3] !== onItemKeyPress || $[4] !== selectedAssets) {
    let t12;
    $[6] !== onDeleteFinished || $[7] !== onItemClick || $[8] !== onItemKeyPress || $[9] !== selectedAssets ? (t12 = (asset) => /* @__PURE__ */ jsx(AssetThumb, { asset, isSelected: selectedAssets.some((selected) => selected._id === asset._id), onClick: onItemClick, onKeyPress: onItemKeyPress, onDeleteFinished }, asset._id), $[6] = onDeleteFinished, $[7] = onItemClick, $[8] = onItemKeyPress, $[9] = selectedAssets, $[10] = t12) : t12 = $[10], t0 = assets.map(t12), $[0] = assets, $[1] = onDeleteFinished, $[2] = onItemClick, $[3] = onItemKeyPress, $[4] = selectedAssets, $[5] = t0;
  } else
    t0 = $[5];
  let t1;
  $[11] !== t0 ? (t1 = /* @__PURE__ */ jsx(ThumbGrid, { gap: 2, children: t0 }), $[11] = t0, $[12] = t1) : t1 = $[12];
  let t2;
  $[13] !== assets.length || $[14] !== isLoading ? (t2 = isLoading && assets.length === 0 && /* @__PURE__ */ jsx(Flex, { justify: "center", children: /* @__PURE__ */ jsx(Spinner, { muted: !0 }) }), $[13] = assets.length, $[14] = isLoading, $[15] = t2) : t2 = $[15];
  let t3;
  $[16] !== assets.length || $[17] !== isLoading ? (t3 = !isLoading && assets.length === 0 && /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0 }), $[16] = assets.length, $[17] = isLoading, $[18] = t3) : t3 = $[18];
  let t4;
  return $[19] !== t1 || $[20] !== t2 || $[21] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Box, { padding: 4, children: [
    t1,
    t2,
    t3
  ] }), $[19] = t1, $[20] = t2, $[21] = t3, $[22] = t4) : t4 = $[22], t4;
}
const PER_PAGE = 200, ASSET_TYPE_IMAGE = "sanity.imageAsset", ASSET_TYPE_FILE = "sanity.fileAsset", buildFilterQuery = (acceptParam) => {
  const WILDCARD_ACCEPT = ["image/*", "audio/*", "video/*"], typesForFilter = acceptParam.split(",").map((accept) => accept.trim()).reduce((acceptTypes, acceptValue) => WILDCARD_ACCEPT.includes(acceptValue) ? {
    ...acceptTypes,
    wildcards: `mimeType match '${acceptValue}' || ${acceptTypes.wildcards}`
  } : acceptValue.indexOf(".") === 0 ? {
    ...acceptTypes,
    extensions: `'${acceptValue.replace(".", "")}', ${acceptTypes.extensions}`
  } : {
    ...acceptTypes,
    mimes: `'${acceptValue}', ${acceptTypes.mimes}`
  }, {
    mimes: "",
    extensions: "",
    wildcards: ""
  });
  return `&&
  (
    ${typesForFilter.wildcards}
    extension in [${typesForFilter.extensions}] ||
    mimeType in [${typesForFilter.mimes}]
  )`;
}, buildQuery = (start = 0, end = PER_PAGE, assetType = ASSET_TYPE_IMAGE, acceptParam) => {
  const filterCondition = acceptParam.length > 0 ? buildFilterQuery(acceptParam) : "";
  return `
  *[_type == "${assetType}" ${filterCondition}] | order(_updatedAt desc) [${start}...${end}] {
    _id,
    _updatedAt,
    _createdAt,
    url,
    originalFilename,
    mimeType,
    extension,
    size,
    metadata {dimensions}
  }
`;
}, CardLoadMore = styled(Card)`
  border-top: 1px solid var(--card-border-color);
  position: sticky;
  bottom: 0;
  z-index: 200;
`, SelectAssetsComponent = function(props2, ref) {
  const $ = c(68), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0, t1;
  $[0] !== client ? (t1 = client.withConfig({
    apiVersion: "2023-02-14"
  }), $[0] = client, $[1] = t1) : t1 = $[1], t0 = t1;
  const versionedClient2 = t0, [_elementId] = useState(_temp$1v), currentPageNumber = useRef(0), {
    t
  } = useTranslation(), fetch$ = useRef(void 0);
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[2] = t2) : t2 = $[2];
  const [assets, setAssets] = useState(t2), [isLastPage, setIsLastPage] = useState(!1), [hasResetAutoFocus, setHasResetFocus] = useState(!1), [isLoading, setIsLoading] = useState(!0), {
    selectedAssets,
    assetType: t3,
    dialogHeaderTitle,
    onClose,
    onSelect,
    accept
  } = props2, assetType = t3 === void 0 ? "image" : t3, isImageOnlyWildCard = accept && accept === "image/*" && assetType === "image";
  let t4;
  $[3] !== accept || $[4] !== assetType || $[5] !== versionedClient2 ? (t4 = (pageNumber) => {
    const start = pageNumber * PER_PAGE, end = start + PER_PAGE, isImageAssetType = assetType === "image", tag = isImageAssetType ? "asset.image-list" : "asset.file-list", assetTypeParam = isImageAssetType ? ASSET_TYPE_IMAGE : ASSET_TYPE_FILE;
    setIsLoading(!0), typeof accept < "u" && (fetch$.current = versionedClient2.observable.fetch(buildQuery(start, end, assetTypeParam, accept), {}, {
      tag
    }).subscribe((result) => {
      setIsLastPage(result.length < PER_PAGE), setAssets((prevState) => prevState.concat(result)), setIsLoading(!1);
    }));
  }, $[3] = accept, $[4] = assetType, $[5] = versionedClient2, $[6] = t4) : t4 = $[6];
  const fetchPage = t4;
  let t5;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (id2) => {
    setAssets((prevState_0) => prevState_0.filter((asset) => asset._id !== id2));
  }, $[7] = t5) : t5 = $[7];
  const handleDeleteFinished = t5;
  let t6;
  $[8] !== assets || $[9] !== onSelect ? (t6 = (id_0) => {
    assets.find((doc) => doc._id === id_0) && onSelect([{
      kind: "assetDocumentId",
      value: id_0
    }]);
  }, $[8] = assets, $[9] = onSelect, $[10] = t6) : t6 = $[10];
  const select2 = t6;
  let t7;
  $[11] !== select2 ? (t7 = (event) => {
    event.preventDefault();
    const id_1 = event.currentTarget.getAttribute("data-id");
    if (!id_1)
      throw new Error("Missing data-id attribute on item");
    select2(id_1);
  }, $[11] = select2, $[12] = t7) : t7 = $[12];
  const handleItemClick = t7;
  let t8;
  $[13] !== select2 ? (t8 = (event_0) => {
    if (event_0.key === "Enter") {
      event_0.preventDefault();
      const id_2 = event_0.currentTarget.getAttribute("data-id");
      if (!id_2)
        throw new Error("Missing data-id attribute on item");
      select2(id_2);
    }
  }, $[13] = select2, $[14] = t8) : t8 = $[14];
  const handleItemKeyPress = t8;
  let t9;
  $[15] !== onClose ? (t9 = () => {
    onClose && onClose();
  }, $[15] = onClose, $[16] = t9) : t9 = $[16];
  const handleClose = t9;
  let t10;
  $[17] !== fetchPage ? (t10 = (event_1) => {
    event_1.preventDefault(), fetchPage(currentPageNumber.current = currentPageNumber.current + 1);
  }, $[17] = fetchPage, $[18] = t10) : t10 = $[18];
  const handleFetchNextPage = t10;
  let t11, t12;
  $[19] !== fetchPage ? (t11 = () => (fetchPage(currentPageNumber.current), () => {
    fetch$.current && fetch$.current.unsubscribe();
  }), t12 = [fetchPage], $[19] = fetchPage, $[20] = t11, $[21] = t12) : (t11 = $[20], t12 = $[21]), useEffect(t11, t12);
  let t13, t14;
  $[22] !== isLoading ? (t13 = () => {
    !isLoading && (!currentPageNumber.current || currentPageNumber.current === 0) && setHasResetFocus(!0);
  }, t14 = [isLoading], $[22] = isLoading, $[23] = t13, $[24] = t14) : (t13 = $[23], t14 = $[24]), useEffect(t13, t14);
  let t15;
  $[25] === Symbol.for("react.memo_cache_sentinel") ? (t15 = {
    style: "narrow"
  }, $[25] = t15) : t15 = $[25];
  const listFormat = useListFormat(t15);
  let t16;
  $[26] !== assetType || $[27] !== dialogHeaderTitle || $[28] !== t ? (t16 = dialogHeaderTitle || t("asset-source.dialog.default-title", {
    context: assetType
  }), $[26] = assetType, $[27] = dialogHeaderTitle, $[28] = t, $[29] = t16) : t16 = $[29];
  let t17;
  $[30] !== accept || $[31] !== isImageOnlyWildCard || $[32] !== isLoading || $[33] !== listFormat || $[34] !== t ? (t17 = !isImageOnlyWildCard && !isLoading && accept?.length > 0 && /* @__PURE__ */ jsx(Card, { tone: "primary", padding: 3, border: !0, radius: 2, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(InfoOutlineIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "asset-source.dialog.accept-message", values: {
      acceptTypes: listFormat.format(accept.split(",").map(_temp2$x))
    } }) })
  ] }) }), $[30] = accept, $[31] = isImageOnlyWildCard, $[32] = isLoading, $[33] = listFormat, $[34] = t, $[35] = t17) : t17 = $[35];
  let t18;
  $[36] !== assetType || $[37] !== assets || $[38] !== handleItemClick || $[39] !== handleItemKeyPress || $[40] !== isLoading || $[41] !== selectedAssets ? (t18 = assetType === "file" && /* @__PURE__ */ jsx(FileListView, { assets, onDeleteFinished: handleDeleteFinished, onClick: handleItemClick, onKeyPress: handleItemKeyPress, isLoading, selectedAssets }), $[36] = assetType, $[37] = assets, $[38] = handleItemClick, $[39] = handleItemKeyPress, $[40] = isLoading, $[41] = selectedAssets, $[42] = t18) : t18 = $[42];
  let t19;
  $[43] !== assetType || $[44] !== assets || $[45] !== handleItemClick || $[46] !== handleItemKeyPress || $[47] !== isLoading || $[48] !== selectedAssets ? (t19 = assetType === "image" && /* @__PURE__ */ jsx(ImageListView, { assets, onDeleteFinished: handleDeleteFinished, onItemClick: handleItemClick, onItemKeyPress: handleItemKeyPress, isLoading, selectedAssets }), $[43] = assetType, $[44] = assets, $[45] = handleItemClick, $[46] = handleItemKeyPress, $[47] = isLoading, $[48] = selectedAssets, $[49] = t19) : t19 = $[49];
  let t20;
  $[50] !== assets.length || $[51] !== handleFetchNextPage || $[52] !== isLastPage || $[53] !== isLoading || $[54] !== t ? (t20 = assets.length > 0 && !isLastPage && /* @__PURE__ */ jsx(CardLoadMore, { tone: "default", padding: 4, children: /* @__PURE__ */ jsx(Flex, { direction: "column", children: /* @__PURE__ */ jsx(Button, { type: "button", icon: DownloadIcon, loading: isLoading, onClick: handleFetchNextPage, size: "large", text: t("asset-source.dialog.load-more"), tone: "primary" }) }) }), $[50] = assets.length, $[51] = handleFetchNextPage, $[52] = isLastPage, $[53] = isLoading, $[54] = t, $[55] = t20) : t20 = $[55];
  let t21;
  $[56] !== t17 || $[57] !== t18 || $[58] !== t19 || $[59] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t17,
    t18,
    t19,
    t20
  ] }), $[56] = t17, $[57] = t18, $[58] = t19, $[59] = t20, $[60] = t21) : t21 = $[60];
  let t22;
  return $[61] !== _elementId || $[62] !== handleClose || $[63] !== hasResetAutoFocus || $[64] !== ref || $[65] !== t16 || $[66] !== t21 ? (t22 = /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: hasResetAutoFocus, header: t16, id: _elementId, onClickOutside: handleClose, onClose: handleClose, ref, width: 2, children: t21 }), $[61] = _elementId, $[62] = handleClose, $[63] = hasResetAutoFocus, $[64] = ref, $[65] = t16, $[66] = t21, $[67] = t22) : t22 = $[67], t22;
}, SelectAssetsDialog = memo(forwardRef(SelectAssetsComponent));
function _temp$1v() {
  return `default-asset-source-${uniqueId()}`;
}
function _temp2$x(type) {
  return type.trim();
}
const DatasetAssetSourceComponent = function(props2, ref) {
  const $ = c(3), {
    action: t0
  } = props2;
  if ((t0 === void 0 ? "select" : t0) === "select") {
    let t1;
    return $[0] !== props2 || $[1] !== ref ? (t1 = /* @__PURE__ */ jsx(SelectAssetsDialog, { ...props2, ref }), $[0] = props2, $[1] = ref, $[2] = t1) : t1 = $[2], t1;
  }
  return null;
}, DatasetAssetSource = memo(forwardRef(DatasetAssetSourceComponent));
class DatasetUploader {
  files = [];
  subscribers = /* @__PURE__ */ new Set();
  subscriptions = /* @__PURE__ */ new Map();
  constructor(props2) {
    this.props = props2, this.client = props2.client;
  }
  checkAllComplete() {
    this.files.length > 0 && this.files.every((file) => ["complete", "error", "aborted"].includes(file.status)) && (this.emit({
      type: "all-complete",
      files: this.files
    }), this.reset());
  }
  emit(event) {
    this.subscribers.forEach((fn) => fn(event));
  }
  upload(files, options) {
    const {
      schemaType,
      onChange
    } = options || {};
    for (const file of files) {
      if (!schemaType)
        throw new Error("No schema type provided for file upload");
      if (!onChange)
        throw new Error("No onChange provided for file upload");
      const uploader = resolveUploader(schemaType, file), uploadOptions = {
        metadata: get(schemaType, "options.metadata"),
        storeOriginalFilename: get(schemaType, "options.storeOriginalFilename")
      }, fileId = uuid(), uploadFile2 = {
        id: fileId,
        file,
        progress: 0,
        status: "pending"
      };
      this.files.push(uploadFile2), uploader && this.subscriptions.set(fileId, uploader.upload(this.client, file, schemaType, uploadOptions).subscribe({
        next: (progressEvent) => {
          const {
            patches
          } = progressEvent;
          this.updateFile(uploadFile2.id, {
            status: "uploading"
          }), patches && onChange(patches);
        },
        error: (error) => {
          let _err;
          error instanceof Error ? _err = error : _err = new Error("Unknown error"), this.updateFile(uploadFile2.id, {
            status: "error",
            error: _err
          }), this.emit({
            type: "error",
            files: this.files.filter((erroredFile) => erroredFile.status === "error")
          }), this.subscriptions.get(fileId)?.unsubscribe();
        },
        complete: () => {
          this.updateFile(uploadFile2.id, {
            status: "complete"
          }), this.subscriptions.get(fileId)?.unsubscribe();
        }
      }));
    }
    return this.files;
  }
  abort(file) {
    if (file) {
      const target = this.files.find((f) => f.id === file.id);
      target && ["pending", "uploading"].includes(target.status) && this.updateFile(target.id, {
        status: "aborted"
      });
    } else
      for (const target of this.files)
        ["pending", "uploading"].includes(target.status) && this.updateFile(target.id, {
          status: "aborted"
        });
    this.emit({
      type: "abort",
      files: this.files.filter((abortedFile) => abortedFile.status === "aborted")
    }), this.checkAllComplete();
  }
  updateFile(fileId, data) {
    const target = this.files.find((f) => f.id === fileId);
    target && (data.error && (target.error = data.error), data.progress && data.progress !== target.progress && (target.progress = data.progress, this.emit({
      type: "progress",
      file: target,
      progress: target.progress * 100
    })), data.status && data.status !== target.status && (target.status = data.status, this.emit({
      type: "status",
      file: target,
      status: target.status
    }))), this.checkAllComplete();
  }
  subscribe(subscriber) {
    this.subscribers.add(subscriber);
    for (const file of this.files)
      subscriber({
        type: "status",
        file,
        status: file.status
      }), subscriber({
        type: "progress",
        file,
        progress: file.progress
      });
    return this.checkAllComplete(), () => {
      this.subscribers.delete(subscriber);
    };
  }
  getFiles() {
    return this.files;
  }
  reset() {
    this.files = [];
  }
}
function createDatasetUploader(props2) {
  return new DatasetUploader(props2);
}
const sourceName = "sanity-default";
function createDatasetImageAssetSource(props2) {
  return {
    name: sourceName,
    title: props2.title,
    // i18nKey: 'asset-sources.dataset.image.title',
    component: DatasetAssetSource,
    icon: ImageIcon,
    uploader: createDatasetUploader(props2)
  };
}
function createDatasetFileAssetSource(props2) {
  return {
    name: sourceName,
    title: props2.title,
    // i18nKey: 'asset-sources.dataset.file.title',
    component: DatasetAssetSource,
    icon: DocumentsIcon,
    uploader: createDatasetUploader(props2)
  };
}
const FileButton = styled(Button).attrs({
  forwardedAs: "label"
})(({
  theme
}) => {
  const {
    focusRing
  } = theme.sanity, base = theme.sanity.color.base;
  return css`
      &:not([data-disabled='true']) {
        &:focus-within {
          box-shadow: ${focusRingStyle$1({
    base,
    border: {
      width: 1,
      color: "var(--card-border-color)"
    },
    focusRing
  })};
        }
      }

      // The underlying file input is rendered as children within a Sanity UI <Button> component.
      // The below visibly hides it by targeting the input's parent <span> element, which is
      // added by the <Button> component.
      // TODO: refactor, avoid nth-child selector usage
      & > span:nth-child(2) {
        overflow: hidden;
        overflow: clip;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        min-width: 0;
        display: block;
        appearance: none;
        padding: 0;
        margin: 0;
        border: 0;
        opacity: 0;
      }
    `;
});
styled(MenuItem$1).attrs({
  forwardedAs: "label"
})(({
  theme
}) => {
  const {
    focusRing
  } = theme.sanity, base = theme.sanity.color.base;
  return css`
      &:not([data-disabled='true']) {
        &:focus-within {
          box-shadow: ${focusRingStyle$1({
    base,
    border: {
      width: 1,
      color: "var(--card-border-color)"
    },
    focusRing
  })};
        }
      }

      // The underlying file input is rendered as children within a Sanity UI <Button> component.
      // The below visibly hides it by targeting the input's parent <span> element, which is
      // added by the <Button> component.
      // TODO: refactor, avoid nth-child selector usage
      & > span:nth-child(2) {
        overflow: hidden;
        overflow: clip;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        min-width: 0;
        display: block;
        appearance: none;
        padding: 0;
        margin: 0;
        border: 0;
        opacity: 0;
      }
    `;
});
const FileInputButton = forwardRef(function(props2, forwardedRef) {
  const $ = c(27);
  let accept, capture, disabled, icon, idProp, multiple, onSelect, rest, text;
  $[0] !== props2 ? ({
    icon,
    id: idProp,
    accept,
    capture,
    multiple,
    onSelect,
    text,
    disabled,
    ...rest
  } = props2, $[0] = props2, $[1] = accept, $[2] = capture, $[3] = disabled, $[4] = icon, $[5] = idProp, $[6] = multiple, $[7] = onSelect, $[8] = rest, $[9] = text) : (accept = $[1], capture = $[2], disabled = $[3], icon = $[4], idProp = $[5], multiple = $[6], onSelect = $[7], rest = $[8], text = $[9]);
  const id2 = `${idProp || ""}-${useId()}`;
  let t0;
  $[10] !== onSelect ? (t0 = (event) => {
    onSelect && event.target.files && onSelect(Array.from(event.target.files));
  }, $[10] = onSelect, $[11] = t0) : t0 = $[11];
  const handleChange = t0;
  let t1;
  $[12] !== accept || $[13] !== capture || $[14] !== disabled || $[15] !== forwardedRef || $[16] !== handleChange || $[17] !== id2 || $[18] !== multiple ? (t1 = /* @__PURE__ */ jsx("input", { "data-testid": "file-button-input", accept, capture, id: id2, multiple, onChange: handleChange, ref: forwardedRef, type: "file", value: "", disabled }), $[12] = accept, $[13] = capture, $[14] = disabled, $[15] = forwardedRef, $[16] = handleChange, $[17] = id2, $[18] = multiple, $[19] = t1) : t1 = $[19];
  let t2;
  return $[20] !== disabled || $[21] !== icon || $[22] !== id2 || $[23] !== rest || $[24] !== t1 || $[25] !== text ? (t2 = /* @__PURE__ */ jsx(FileButton, { ...rest, icon, text, htmlFor: id2, disabled, children: t1 }), $[20] = disabled, $[21] = icon, $[22] = id2, $[23] = rest, $[24] = t1, $[25] = text, $[26] = t2) : t2 = $[26], t2;
}), UPLOAD_DROP_DOWN_MENU_POPOVER = {
  portal: !0
}, MENU_GROUP_POPOVER = {
  placement: "right-start",
  fallbackPlacements: ["left-start", "bottom", "top"]
}, ASSET_SOURCE_DATA_ATTRIBUTE = "data-asset-source-name";
function UploadDropDownMenuComponent(props2, forwardedRef) {
  const $ = c(53), {
    accept,
    assetSources,
    capture,
    directUploads,
    multiple,
    onSelectFiles,
    readOnly,
    renderAsMenuGroup: t0
  } = props2, renderAsMenuGroup = t0 === void 0 ? !1 : t0, {
    t
  } = useTranslation();
  let t1, t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = uniqueId(), $[0] = t2) : t2 = $[0], t1 = t2;
  const uniqId = t1, uploadsDisabled = readOnly || directUploads === !1;
  let t3;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (assetSource) => `${uniqId}-${assetSource.name}-upload-button`, $[1] = t3) : t3 = $[1];
  const createAssetSourceInputId = t3;
  let t4;
  $[2] !== assetSources ? (t4 = (event) => {
    const assetSourceName = event.currentTarget.getAttribute(ASSET_SOURCE_DATA_ATTRIBUTE), assetSource_0 = assetSources.find((source) => source.name === assetSourceName);
    if (!assetSource_0)
      return;
    const element = document.getElementById(createAssetSourceInputId(assetSource_0));
    element && document.activeElement !== element && element.click();
  }, $[2] = assetSources, $[3] = t4) : t4 = $[3];
  const handleMenuItemClick = t4;
  let t5;
  $[4] !== assetSources ? (t5 = (menuItemContent) => {
    const assetSourceName_0 = menuItemContent.props[ASSET_SOURCE_DATA_ATTRIBUTE], assetSource_1 = assetSources.find((source_0) => source_0.name === assetSourceName_0);
    return assetSource_1 ? /* @__PURE__ */ jsx("label", { htmlFor: createAssetSourceInputId(assetSource_1), children: menuItemContent }) : menuItemContent;
  }, $[4] = assetSources, $[5] = t5) : t5 = $[5];
  const renderMenuItemLabel = t5;
  let t6;
  $[6] !== assetSources[0] || $[7] !== handleMenuItemClick || $[8] !== renderMenuItemLabel || $[9] !== t || $[10] !== uploadsDisabled ? (t6 = (assetSource_2, index) => {
    const inputId = createAssetSourceInputId(assetSource_2), isDefaultSource = assetSource_2.name === assetSources[0].name;
    return /* @__PURE__ */ jsx(MenuItem$1, { [ASSET_SOURCE_DATA_ATTRIBUTE]: assetSource_2.name, badgeText: isDefaultSource ? t("input.files.common.upload-placeholder.file-input-button.default-source.badge") : void 0, "data-testid": `file-input-upload-button-${index}`, disabled: uploadsDisabled, htmlFor: inputId, icon: assetSource_2.icon, onClick: handleMenuItemClick, renderMenuItem: renderMenuItemLabel, text: (assetSource_2.i18nKey ? t(assetSource_2.i18nKey) : assetSource_2.title) || startCase(assetSource_2.name) }, `${inputId}-menu-button`);
  }, $[6] = assetSources[0], $[7] = handleMenuItemClick, $[8] = renderMenuItemLabel, $[9] = t, $[10] = uploadsDisabled, $[11] = t6) : t6 = $[11];
  const renderMenuItemForAssetSource = t6;
  let t7;
  $[12] !== assetSources || $[13] !== onSelectFiles ? (t7 = (event_0) => {
    const assetSourceName_1 = event_0.target.dataset.assetSourceName, assetSource_3 = assetSources.find((source_1) => source_1.name === assetSourceName_1);
    assetSource_3 && (onSelectFiles && event_0.target.files && onSelectFiles(assetSource_3, Array.from(event_0.target.files)), event_0.stopPropagation(), event_0.preventDefault());
  }, $[12] = assetSources, $[13] = onSelectFiles, $[14] = t7) : t7 = $[14];
  const handleFileInputChange = t7;
  let t8, t9;
  if ($[15] !== accept || $[16] !== assetSources || $[17] !== capture || $[18] !== handleFileInputChange || $[19] !== multiple) {
    let t10;
    $[21] !== accept || $[22] !== capture || $[23] !== handleFileInputChange || $[24] !== multiple ? (t10 = (assetSource_4) => {
      const _id = createAssetSourceInputId(assetSource_4);
      return /* @__PURE__ */ jsx("input", { accept, capture, id: _id, "data-asset-source-name": assetSource_4.name, multiple, onChange: handleFileInputChange, type: "file", value: "", style: {
        display: "none"
      } }, _id);
    }, $[21] = accept, $[22] = capture, $[23] = handleFileInputChange, $[24] = multiple, $[25] = t10) : t10 = $[25], t9 = assetSources.map(t10), $[15] = accept, $[16] = assetSources, $[17] = capture, $[18] = handleFileInputChange, $[19] = multiple, $[20] = t9;
  } else
    t9 = $[20];
  t8 = t9;
  const fileInputs = t8;
  if (assetSources && assetSources.length > 1) {
    let t10;
    if ($[26] !== assetSources || $[27] !== renderMenuItemForAssetSource) {
      let t112;
      $[29] !== renderMenuItemForAssetSource ? (t112 = (assetSource_5, index_0) => renderMenuItemForAssetSource(assetSource_5, index_0), $[29] = renderMenuItemForAssetSource, $[30] = t112) : t112 = $[30], t10 = assetSources.map(t112), $[26] = assetSources, $[27] = renderMenuItemForAssetSource, $[28] = t10;
    } else
      t10 = $[28];
    const menuItems = t10;
    if (renderAsMenuGroup) {
      let t112;
      $[31] !== t ? (t112 = t("input.files.common.upload-placeholder.file-input-button.text"), $[31] = t, $[32] = t112) : t112 = $[32];
      let t122;
      $[33] !== menuItems || $[34] !== t112 ? (t122 = /* @__PURE__ */ jsx(MenuGroup, { icon: UploadIcon, text: t112, popover: MENU_GROUP_POPOVER, children: menuItems }), $[33] = menuItems, $[34] = t112, $[35] = t122) : t122 = $[35];
      let t132;
      return $[36] !== fileInputs || $[37] !== t122 ? (t132 = /* @__PURE__ */ jsxs(Fragment, { children: [
        t122,
        fileInputs
      ] }), $[36] = fileInputs, $[37] = t122, $[38] = t132) : t132 = $[38], t132;
    }
    let t11;
    $[39] !== t ? (t11 = t("input.files.common.upload-placeholder.file-input-button.text"), $[39] = t, $[40] = t11) : t11 = $[40];
    let t12;
    $[41] !== t11 || $[42] !== uploadsDisabled ? (t12 = /* @__PURE__ */ jsx(Button, { "data-testid": "file-input-upload-button-0", icon: UploadIcon, iconRight: ChevronDownIcon, mode: "bleed", disabled: uploadsDisabled, text: t11 }), $[41] = t11, $[42] = uploadsDisabled, $[43] = t12) : t12 = $[43];
    let t13;
    $[44] !== menuItems ? (t13 = /* @__PURE__ */ jsx(Menu, { children: menuItems }), $[44] = menuItems, $[45] = t13) : t13 = $[45];
    let t14;
    $[46] !== forwardedRef || $[47] !== t12 || $[48] !== t13 ? (t14 = /* @__PURE__ */ jsx(MenuButton$1, { id: `${uniqId}_upload-button`, ref: forwardedRef, button: t12, menu: t13, popover: UPLOAD_DROP_DOWN_MENU_POPOVER }), $[46] = forwardedRef, $[47] = t12, $[48] = t13, $[49] = t14) : t14 = $[49];
    let t15;
    return $[50] !== fileInputs || $[51] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t14,
      fileInputs
    ] }), $[50] = fileInputs, $[51] = t14, $[52] = t15) : t15 = $[52], t15;
  }
  return null;
}
const UploadDropDownMenu = memo(forwardRef(UploadDropDownMenuComponent));
function UploadPlaceholderComponent(props2) {
  const $ = c(35), {
    accept,
    acceptedFiles,
    assetSources,
    browse,
    directUploads,
    hoveringFiles,
    onUpload,
    readOnly,
    rejectedFilesCount,
    type
  } = props2, [rootElement, setRootElement] = useState(null), rect = useElementSize(rootElement), collapsed = rect?.border && rect.border.width < 440, {
    t
  } = useTranslation(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), source = useSource();
  let t0, result;
  if ($[0] !== assetSources || $[1] !== client || $[2] !== source || $[3] !== type) {
    if (result = assetSources.filter(_temp$1u), result.length === 0) {
      const options = {
        client,
        title: source.title || source.name
      }, isFileType = type === "file";
      result.push(isFileType ? createDatasetFileAssetSource(options) : createDatasetImageAssetSource(options));
    }
    $[0] = assetSources, $[1] = client, $[2] = source, $[3] = type, $[4] = result;
  } else
    result = $[4];
  t0 = result;
  const assetSourcesWithUpload = t0;
  let t1;
  $[5] !== onUpload ? (t1 = (assetSource, files) => {
    onUpload && onUpload(assetSource, files);
  }, $[5] = onUpload, $[6] = t1) : t1 = $[6];
  const handleSelectFiles = t1;
  let t2;
  bb0: switch (assetSourcesWithUpload.length) {
    case 0: {
      t2 = null;
      break bb0;
    }
    case 1: {
      const t32 = `file-input-upload-button-${assetSourcesWithUpload[0].name}`, t4 = readOnly || directUploads === !1;
      let t5;
      $[7] !== assetSourcesWithUpload[0] || $[8] !== onUpload ? (t5 = (files_0) => {
        onUpload && onUpload(assetSourcesWithUpload[0], files_0);
      }, $[7] = assetSourcesWithUpload[0], $[8] = onUpload, $[9] = t5) : t5 = $[9];
      let t6;
      $[10] !== t ? (t6 = t("input.files.common.upload-placeholder.file-input-button.text"), $[10] = t, $[11] = t6) : t6 = $[11];
      let t7;
      $[12] !== accept || $[13] !== t32 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsx(FileInputButton, { accept, "data-testid": t32, disabled: t4, icon: UploadIcon, mode: "bleed", onSelect: t5, text: t6 }), $[12] = accept, $[13] = t32, $[14] = t4, $[15] = t5, $[16] = t6, $[17] = t7) : t7 = $[17], t2 = t7;
      break bb0;
    }
    default: {
      let t32;
      $[18] !== accept || $[19] !== assetSourcesWithUpload || $[20] !== directUploads || $[21] !== handleSelectFiles || $[22] !== readOnly ? (t32 = /* @__PURE__ */ jsx(UploadDropDownMenu, { accept, assetSources: assetSourcesWithUpload, directUploads, onSelectFiles: handleSelectFiles, readOnly }), $[18] = accept, $[19] = assetSourcesWithUpload, $[20] = directUploads, $[21] = handleSelectFiles, $[22] = readOnly, $[23] = t32) : t32 = $[23], t2 = t32;
    }
  }
  const uploadButton = t2;
  let t3;
  return $[24] !== acceptedFiles || $[25] !== assetSourcesWithUpload.length || $[26] !== browse || $[27] !== collapsed || $[28] !== directUploads || $[29] !== hoveringFiles || $[30] !== readOnly || $[31] !== rejectedFilesCount || $[32] !== type || $[33] !== uploadButton ? (t3 = assetSourcesWithUpload.length === 0 ? null : /* @__PURE__ */ jsxs(Flex, { align: collapsed ? void 0 : "center", direction: collapsed ? "column" : "row", gap: 4, justify: "space-between", paddingY: collapsed ? 1 : void 0, ref: setRootElement, children: [
    /* @__PURE__ */ jsx(Flex, { flex: 1, children: /* @__PURE__ */ jsx(PlaceholderText, { acceptedFiles, directUploads, hoveringFiles, readOnly, rejectedFilesCount, type }) }),
    /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, justify: "center", wrap: "wrap", children: [
      uploadButton,
      browse
    ] })
  ] }), $[24] = acceptedFiles, $[25] = assetSourcesWithUpload.length, $[26] = browse, $[27] = collapsed, $[28] = directUploads, $[29] = hoveringFiles, $[30] = readOnly, $[31] = rejectedFilesCount, $[32] = type, $[33] = uploadButton, $[34] = t3) : t3 = $[34], t3;
}
function _temp$1u(s) {
  return !!s.uploader;
}
const UploadPlaceholder = memo(UploadPlaceholderComponent), STALE_UPLOAD_MS = 12e4, RatioBox$1 = styled(Card)`
  position: relative;
  width: 100%;
  min-height: 3.75rem;
  max-height: min(calc(var(--image-height) * 1px), 30vh);
  aspect-ratio: var(--image-width) / var(--image-height);

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: scale-down;
    object-position: center;
  }
`, Overlay = styled(Card)`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(10px);
  background-color: color-mix(in srgb, transparent, var(--card-bg-color) 80%);
`, FlexOverlay = styled(Flex)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`, CardWrapper = styled(RatioBox$1)`
  box-sizing: border-box;
`, FlexWrapper = styled(Flex)`
  box-sizing: border-box;
  text-overflow: ellipsis;
  overflow: hidden;
  overflow: clip;
`, LeftSection = styled(Stack)`
  position: relative;
  width: 60%;
`, CodeWrapper$1 = styled(Code)`
  position: relative;
  width: 100%;

  code {
    overflow: hidden;
    overflow: clip;
    text-overflow: ellipsis;
    position: relative;
    max-width: 200px;
  }
`, elapsedMs = (date) => (/* @__PURE__ */ new Date()).getTime() - new Date(date).getTime();
function UploadProgress(t0) {
  const $ = c(22), {
    uploadState,
    onCancel,
    onStale
  } = t0, filename = uploadState.file.name;
  let t1, t2;
  $[0] !== onStale || $[1] !== uploadState.updatedAt ? (t1 = () => {
    elapsedMs(uploadState.updatedAt) > STALE_UPLOAD_MS && onStale?.();
  }, t2 = [uploadState.updatedAt, onStale], $[0] = onStale, $[1] = uploadState.updatedAt, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  const {
    t
  } = useTranslation();
  let t3, t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = [3, 3, 2, 2], t4 = ["column", "column", "row"], $[4] = t3, $[5] = t4) : (t3 = $[4], t4 = $[5]);
  let t5;
  $[6] !== filename ? (t5 = {
    FileName: () => /* @__PURE__ */ jsx(CodeWrapper$1, { size: 1, children: filename || "\u2026" })
  }, $[6] = filename, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t || $[9] !== t5 ? (t6 = /* @__PURE__ */ jsx(Flex, { justify: "center", gap: t3, direction: t4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Inline, { space: 2, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "input.files.common.upload-progress", components: t5 }) }) }) }), $[8] = t, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== uploadState.progress ? (t7 = /* @__PURE__ */ jsx(Card, { border: !0, marginTop: 3, radius: 5, children: /* @__PURE__ */ jsx(LinearProgress, { value: uploadState.progress }) }), $[11] = uploadState.progress, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t6 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(LeftSection, { children: [
    t6,
    t7
  ] }), $[13] = t6, $[14] = t7, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== onCancel || $[17] !== t ? (t9 = onCancel ? /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: onCancel, text: t("input.files.common.cancel-upload"), tone: "critical" }) : null, $[16] = onCancel, $[17] = t, $[18] = t9) : t9 = $[18];
  let t10;
  return $[19] !== t8 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsx(CardWrapper, { tone: "primary", border: !0, children: /* @__PURE__ */ jsxs(FlexWrapper, { padding: 4, align: "center", justify: "space-between", height: "fill", direction: "row", gap: 2, children: [
    t8,
    t9
  ] }) }), $[19] = t8, $[20] = t9, $[21] = t10) : t10 = $[21], t10;
}
function UploadWarning(t0) {
  const $ = c(20), {
    onClearStale
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = t("inputs.files.common.stale-upload-warning.title"), $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("inputs.files.common.stale-upload-warning.description", {
    staleThresholdMinutes: Math.ceil(STALE_UPLOAD_MS / 1e3 / 60)
  }), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: 4, children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t3,
      t5
    ] })
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t ? (t7 = t("inputs.files.common.stale-upload-warning.clear"), $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== onClearStale || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearStale, text: t7, width: "fill" }), $[14] = onClearStale, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t6 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Card, { tone: "caution", padding: 4, border: !0, radius: 2, children: [
    t6,
    t8
  ] }), $[17] = t6, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
function Browser(props2) {
  const $ = c(32), {
    assetSources,
    readOnly,
    id: id2,
    browseButtonElementRef,
    schemaType,
    setIsBrowseMenuOpen,
    setSelectedAssetSource
  } = props2, sourcesFromSchema = schemaType.options?.sources, {
    t
  } = useTranslation();
  let t0;
  $[0] !== setIsBrowseMenuOpen || $[1] !== setSelectedAssetSource ? (t0 = (assetSource) => {
    setIsBrowseMenuOpen(!1), setSelectedAssetSource(assetSource);
  }, $[0] = setIsBrowseMenuOpen, $[1] = setSelectedAssetSource, $[2] = t0) : t0 = $[2];
  const handleSelectAssetFromSource2 = t0;
  if (sourcesFromSchema?.length === 0 || assetSources.length === 0)
    return null;
  if (assetSources.length > 1 && !readOnly) {
    const t12 = `${id2}_assetFileButton`;
    let t22;
    $[3] !== t ? (t22 = t("inputs.file.multi-browse-button.text"), $[3] = t, $[4] = t22) : t22 = $[4];
    let t32;
    $[5] !== t22 ? (t32 = /* @__PURE__ */ jsx(Button, { mode: "bleed", text: t22, "data-testid": "file-input-multi-browse-button", icon: SearchIcon, iconRight: ChevronDownIcon }), $[5] = t22, $[6] = t32) : t32 = $[6];
    let t42;
    if ($[7] !== assetSources || $[8] !== handleSelectAssetFromSource2 || $[9] !== t) {
      let t52;
      $[11] !== handleSelectAssetFromSource2 || $[12] !== t ? (t52 = (assetSource_0) => /* @__PURE__ */ jsx(MenuItem$1, { text: (assetSource_0.i18nKey ? t(assetSource_0.i18nKey) : assetSource_0.title) || startCase(assetSource_0.name), onClick: () => handleSelectAssetFromSource2(assetSource_0), icon: assetSource_0.icon || ImageIcon, "data-testid": `file-input-browse-button-${assetSource_0.name}` }, assetSource_0.name), $[11] = handleSelectAssetFromSource2, $[12] = t, $[13] = t52) : t52 = $[13], t42 = assetSources.map(t52), $[7] = assetSources, $[8] = handleSelectAssetFromSource2, $[9] = t, $[10] = t42;
    } else
      t42 = $[10];
    let t5;
    $[14] !== t42 ? (t5 = /* @__PURE__ */ jsx(Menu, { children: t42 }), $[14] = t42, $[15] = t5) : t5 = $[15];
    let t6;
    return $[16] !== browseButtonElementRef || $[17] !== t12 || $[18] !== t32 || $[19] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuButton$1, { id: t12, ref: browseButtonElementRef, button: t32, "data-testid": "input-select-button", menu: t5 }), $[16] = browseButtonElementRef, $[17] = t12, $[18] = t32, $[19] = t5, $[20] = t6) : t6 = $[20], t6;
  }
  let t1;
  $[21] !== t ? (t1 = t("inputs.file.browse-button.text"), $[21] = t, $[22] = t1) : t1 = $[22];
  let t2;
  $[23] !== assetSources[0] || $[24] !== handleSelectAssetFromSource2 ? (t2 = () => handleSelectAssetFromSource2(assetSources[0]), $[23] = assetSources[0], $[24] = handleSelectAssetFromSource2, $[25] = t2) : t2 = $[25];
  const t3 = `file-input-browse-button-${assetSources[0].name}`;
  let t4;
  return $[26] !== browseButtonElementRef || $[27] !== readOnly || $[28] !== t1 || $[29] !== t2 || $[30] !== t3 ? (t4 = /* @__PURE__ */ jsx(Button, { text: t1, icon: SearchIcon, mode: "bleed", onClick: t2, "data-testid": t3, disabled: readOnly, ref: browseButtonElementRef }), $[26] = browseButtonElementRef, $[27] = readOnly, $[28] = t1, $[29] = t2, $[30] = t3, $[31] = t4) : t4 = $[31], t4;
}
function WithReferencedAsset(props2) {
  const $ = c(10), {
    reference,
    children,
    observeAsset,
    waitPlaceholder
  } = props2, documentId = reference?._ref;
  let t0, t1;
  $[0] !== documentId || $[1] !== observeAsset ? (t1 = observeAsset(documentId), $[0] = documentId, $[1] = observeAsset, $[2] = t1) : t1 = $[2], t0 = t1;
  const asset = useObservable(t0);
  let t2;
  $[3] !== asset || $[4] !== children || $[5] !== documentId || $[6] !== waitPlaceholder ? (t2 = documentId && asset ? children(asset) : waitPlaceholder, $[3] = asset, $[4] = children, $[5] = documentId, $[6] = waitPlaceholder, $[7] = t2) : t2 = $[7];
  let t3;
  return $[8] !== t2 ? (t3 = /* @__PURE__ */ jsx(Fragment, { children: t2 }), $[8] = t2, $[9] = t3) : t3 = $[9], t3;
}
function ActionsMenu(props2) {
  const $ = c(32), {
    onReset,
    readOnly,
    browse,
    downloadUrl,
    copyUrl,
    upload
  } = props2, {
    push: pushToast
  } = useToast(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== copyUrl || $[1] !== pushToast || $[2] !== t ? (t0 = () => {
    navigator.clipboard.writeText(copyUrl || ""), pushToast({
      closable: !0,
      status: "success",
      title: t("inputs.files.common.actions-menu.notification.url-copied")
    });
  }, $[0] = copyUrl, $[1] = pushToast, $[2] = t, $[3] = t0) : t0 = $[3];
  const handleCopyURL = t0;
  let t1;
  $[4] !== browse || $[5] !== upload ? (t1 = upload && browse && /* @__PURE__ */ jsx(MenuDivider, {}), $[4] = browse, $[5] = upload, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] !== copyUrl || $[8] !== downloadUrl ? (t2 = (downloadUrl || copyUrl) && /* @__PURE__ */ jsx(MenuDivider, {}), $[7] = copyUrl, $[8] = downloadUrl, $[9] = t2) : t2 = $[9];
  let t3;
  $[10] !== downloadUrl || $[11] !== t ? (t3 = downloadUrl && /* @__PURE__ */ jsx(MenuItem$1, { as: "a", icon: DownloadIcon, text: t("inputs.files.common.actions-menu.download.label"), href: downloadUrl }), $[10] = downloadUrl, $[11] = t, $[12] = t3) : t3 = $[12];
  let t4;
  $[13] !== copyUrl || $[14] !== handleCopyURL || $[15] !== t ? (t4 = copyUrl && /* @__PURE__ */ jsx(MenuItem$1, { icon: CopyIcon, text: t("inputs.files.common.actions-menu.copy-url.label"), onClick: handleCopyURL }), $[13] = copyUrl, $[14] = handleCopyURL, $[15] = t, $[16] = t4) : t4 = $[16];
  let t5;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(MenuDivider, {}), $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== t ? (t6 = t("inputs.files.common.actions-menu.clear-field.label"), $[18] = t, $[19] = t6) : t6 = $[19];
  let t7;
  $[20] !== onReset || $[21] !== readOnly || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuItem$1, { tone: "critical", icon: ResetIcon, text: t6, onClick: onReset, disabled: readOnly, "data-testid": "file-input-clear" }), $[20] = onReset, $[21] = readOnly, $[22] = t6, $[23] = t7) : t7 = $[23];
  let t8;
  return $[24] !== browse || $[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t7 || $[30] !== upload ? (t8 = /* @__PURE__ */ jsxs(Fragment, { children: [
    upload,
    t1,
    browse,
    t2,
    t3,
    t4,
    t5,
    t7
  ] }), $[24] = browse, $[25] = t1, $[26] = t2, $[27] = t3, $[28] = t4, $[29] = t7, $[30] = upload, $[31] = t8) : t8 = $[31], t8;
}
const FileMenuItem = styled(MenuItem$1)`
  position: relative;

  & input {
    overflow: hidden;
    overflow: clip;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    min-width: 0;
    display: block;
    appearance: none;
    padding: 0;
    margin: 0;
    border: 0;
    opacity: 0;
  }
`, FileInputMenuItem = forwardRef(function(props2, forwardedRef) {
  const $ = c(27);
  let accept, capture, disabled, icon, idProp, multiple, onSelect, rest, text;
  $[0] !== props2 ? ({
    icon,
    id: idProp,
    accept,
    capture,
    multiple,
    onSelect,
    text,
    disabled,
    ...rest
  } = props2, $[0] = props2, $[1] = accept, $[2] = capture, $[3] = disabled, $[4] = icon, $[5] = idProp, $[6] = multiple, $[7] = onSelect, $[8] = rest, $[9] = text) : (accept = $[1], capture = $[2], disabled = $[3], icon = $[4], idProp = $[5], multiple = $[6], onSelect = $[7], rest = $[8], text = $[9]);
  const id2 = `${idProp || ""}-${useId()}`;
  let t0;
  $[10] !== onSelect ? (t0 = (event) => {
    onSelect && event.target.files && onSelect(Array.from(event.target.files));
  }, $[10] = onSelect, $[11] = t0) : t0 = $[11];
  const handleChange = t0;
  let t1;
  $[12] !== accept || $[13] !== capture || $[14] !== disabled || $[15] !== handleChange || $[16] !== id2 || $[17] !== multiple ? (t1 = (item) => /* @__PURE__ */ jsxs("div", { children: [
    item,
    /* @__PURE__ */ jsx("input", { "data-testid": "file-menuitem-input", accept, capture, id: id2, multiple, onChange: handleChange, type: "file", value: "", disabled })
  ] }), $[12] = accept, $[13] = capture, $[14] = disabled, $[15] = handleChange, $[16] = id2, $[17] = multiple, $[18] = t1) : t1 = $[18];
  const renderMenuItem = t1;
  let t2;
  return $[19] !== disabled || $[20] !== forwardedRef || $[21] !== icon || $[22] !== id2 || $[23] !== renderMenuItem || $[24] !== rest || $[25] !== text ? (t2 = /* @__PURE__ */ jsx(FileMenuItem, { ...rest, htmlFor: id2, disabled, ref: forwardedRef, icon, text, renderMenuItem }), $[19] = disabled, $[20] = forwardedRef, $[21] = icon, $[22] = id2, $[23] = renderMenuItem, $[24] = rest, $[25] = text, $[26] = t2) : t2 = $[26], t2;
});
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024, dm = decimals < 0 ? 0 : decimals, sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
function FileActionsMenu(props2) {
  const $ = c(52), {
    originalFilename,
    size,
    children,
    muted,
    disabled,
    onClick: onClick2,
    isMenuOpen,
    onMenuOpen,
    setMenuButtonElement
  } = props2, [menuElement, setMenuElement] = useState(null), [buttonElement, setButtonElement] = useState(null);
  let t0;
  $[0] !== onMenuOpen ? (t0 = () => onMenuOpen(!0), $[0] = onMenuOpen, $[1] = t0) : t0 = $[1];
  const handleClick = t0;
  let t1;
  $[2] !== buttonElement || $[3] !== isMenuOpen || $[4] !== onMenuOpen ? (t1 = (event) => {
    isMenuOpen && (event.key === "Escape" || event.key === "Tab") && (onMenuOpen(!1), buttonElement?.focus());
  }, $[2] = buttonElement, $[3] = isMenuOpen, $[4] = onMenuOpen, $[5] = t1) : t1 = $[5], useGlobalKeyDown(t1);
  let t2;
  $[6] !== buttonElement || $[7] !== onMenuOpen ? (t2 = (event_0) => {
    buttonElement?.contains(event_0.target) || onMenuOpen(!1);
  }, $[6] = buttonElement, $[7] = onMenuOpen, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== menuElement ? (t3 = () => [menuElement], $[9] = menuElement, $[10] = t3) : t3 = $[10], useClickOutsideEvent(t2, t3);
  let t4;
  $[11] !== setMenuButtonElement ? (t4 = (el) => {
    setMenuButtonElement(el), setButtonElement(el);
  }, $[11] = setMenuButtonElement, $[12] = t4) : t4 = $[12];
  const setOptionsButtonRef = t4;
  let t5, t6;
  $[13] !== isMenuOpen || $[14] !== menuElement ? (t5 = () => {
    isMenuOpen && menuElement?.focus();
  }, t6 = [isMenuOpen, menuElement], $[13] = isMenuOpen, $[14] = menuElement, $[15] = t5, $[16] = t6) : (t5 = $[15], t6 = $[16]), useEffect(t5, t6);
  const {
    t
  } = useTranslation(), t7 = muted || disabled ? void 0 : "button";
  let t8;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t8 = /* @__PURE__ */ jsx(BinaryDocumentIcon, {}), $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== muted ? (t9 = /* @__PURE__ */ jsx(Card, { padding: 3, tone: "transparent", shadow: 1, radius: 1, children: /* @__PURE__ */ jsx(Text$1, { muted, children: t8 }) }), $[18] = muted, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== muted || $[21] !== originalFilename ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", muted, "data-testid": "file-name", weight: "medium", children: originalFilename }), $[20] = muted, $[21] = originalFilename, $[22] = t10) : t10 = $[22];
  let t11;
  $[23] !== size ? (t11 = formatBytes(size), $[23] = size, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t11 ? (t12 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, "data-testid": "file-size", children: t11 }), $[25] = t11, $[26] = t12) : t12 = $[26];
  let t13;
  $[27] !== t10 || $[28] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, marginLeft: 3, children: [
    t10,
    t12
  ] }), $[27] = t10, $[28] = t12, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== t13 || $[31] !== t9 ? (t14 = /* @__PURE__ */ jsxs(Flex, { wrap: "nowrap", align: "center", children: [
    t9,
    t13
  ] }), $[30] = t13, $[31] = t9, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== onClick2 || $[34] !== t14 || $[35] !== t7 ? (t15 = /* @__PURE__ */ jsx(Card, { as: t7, radius: 2, padding: 2, tone: "inherit", onClick: onClick2, flex: 1, children: t14 }), $[33] = onClick2, $[34] = t14, $[35] = t7, $[36] = t15) : t15 = $[36];
  let t16;
  $[37] !== children ? (t16 = /* @__PURE__ */ jsx(Menu, { ref: setMenuElement, children }), $[37] = children, $[38] = t16) : t16 = $[38];
  let t17;
  $[39] !== t ? (t17 = t("inputs.file.actions-menu.file-options.aria-label"), $[39] = t, $[40] = t17) : t17 = $[40];
  let t18;
  $[41] !== handleClick || $[42] !== setOptionsButtonRef || $[43] !== t17 ? (t18 = /* @__PURE__ */ jsx(ContextMenuButton, { "aria-label": t17, "data-testid": "options-menu-button", onClick: handleClick, ref: setOptionsButtonRef }), $[41] = handleClick, $[42] = setOptionsButtonRef, $[43] = t17, $[44] = t18) : t18 = $[44];
  let t19;
  $[45] !== isMenuOpen || $[46] !== t16 || $[47] !== t18 ? (t19 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Flex, { justify: "center", children: /* @__PURE__ */ jsx(Popover, { content: t16, id: "file-actions-menu", portal: !0, open: isMenuOpen, constrainSize: !0, children: t18 }) }) }), $[45] = isMenuOpen, $[46] = t16, $[47] = t18, $[48] = t19) : t19 = $[48];
  let t20;
  return $[49] !== t15 || $[50] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Flex, { wrap: "nowrap", justify: "space-between", align: "center", children: [
    t15,
    t19
  ] }), $[49] = t15, $[50] = t19, $[51] = t20) : t20 = $[51], t20;
}
function FileSkeleton$1() {
  const $ = c(3);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Skeleton, { padding: 3, radius: 1, animated: !0 }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
    width: "100%"
  }, radius: 1, animated: !0 }), $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "flex-start", padding: 2, children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, marginLeft: 3, children: [
      t1,
      /* @__PURE__ */ jsx(TextSkeleton, { style: {
        width: "100%"
      }, radius: 1, animated: !0 })
    ] })
  ] }), $[2] = t2) : t2 = $[2], t2;
}
function FilePreview$1(props2) {
  const $ = c(57), {
    assetSources,
    clearField,
    directUploads,
    onSelectFiles,
    observeAsset,
    readOnly,
    schemaType,
    setBrowseButtonElement,
    setSelectedAssetSource,
    value
  } = props2, {
    t
  } = useTranslation(), [isMenuOpen, setIsMenuOpen] = useState(!1), asset = value?.asset, sourcesFromSchema = schemaType.options?.sources;
  let t0;
  $[0] !== schemaType ? (t0 = get(schemaType, "options.accept", ""), $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const accept = t0;
  let t1;
  $[2] !== assetSources ? (t1 = assetSources.filter(_temp$1t), $[2] = assetSources, $[3] = t1) : t1 = $[3];
  const assetSourcesWithUpload = t1;
  let t2;
  $[4] !== assetSources || $[5] !== setSelectedAssetSource ? (t2 = (event) => {
    setIsMenuOpen(!1);
    const assetSourceNameData = event.currentTarget.getAttribute("data-asset-source-name"), assetSource = assetSources.find((source) => source.name === assetSourceNameData);
    assetSource ? setSelectedAssetSource(assetSource) : console.warn(`No asset source found for the selected asset source name '${assetSourceNameData}'`);
  }, $[4] = assetSources, $[5] = setSelectedAssetSource, $[6] = t2) : t2 = $[6];
  const handleSelectFileMenuItemClicked = t2;
  let t3;
  $[7] !== onSelectFiles ? (t3 = (assetSource_0, files) => {
    setIsMenuOpen(!1), onSelectFiles(assetSource_0, files);
  }, $[7] = onSelectFiles, $[8] = t3) : t3 = $[8];
  const handleSelectFilesFromAssetSource = t3;
  let t4;
  $[9] !== assetSourcesWithUpload[0] || $[10] !== handleSelectFilesFromAssetSource ? (t4 = (files_0) => {
    handleSelectFilesFromAssetSource(assetSourcesWithUpload[0], files_0);
  }, $[9] = assetSourcesWithUpload[0], $[10] = handleSelectFilesFromAssetSource, $[11] = t4) : t4 = $[11];
  const handleSelectFilesFromAssetSourceSingle = t4;
  let t5;
  bb0: {
    if (sourcesFromSchema?.length === 0) {
      t5 = null;
      break bb0;
    }
    if (assetSources.length === 0) {
      t5 = null;
      break bb0;
    }
    if (assetSources.length === 1) {
      let t63;
      $[12] !== t ? (t63 = t("inputs.file.browse-button.text"), $[12] = t, $[13] = t63) : t63 = $[13];
      const t72 = `file-input-browse-button-${assetSources[0].name}`;
      let t82;
      $[14] !== assetSources[0].name || $[15] !== handleSelectFileMenuItemClicked || $[16] !== readOnly || $[17] !== t63 || $[18] !== t72 ? (t82 = /* @__PURE__ */ jsx(MenuItem$1, { icon: SearchIcon, text: t63, onClick: handleSelectFileMenuItemClicked, disabled: readOnly, "data-testid": t72, "data-asset-source-name": assetSources[0].name }), $[14] = assetSources[0].name, $[15] = handleSelectFileMenuItemClicked, $[16] = readOnly, $[17] = t63, $[18] = t72, $[19] = t82) : t82 = $[19], t5 = t82;
      break bb0;
    }
    let t62;
    if ($[20] !== assetSources || $[21] !== handleSelectFileMenuItemClicked || $[22] !== readOnly || $[23] !== t) {
      let t72;
      $[25] !== handleSelectFileMenuItemClicked || $[26] !== readOnly || $[27] !== t ? (t72 = (assetSource_1) => /* @__PURE__ */ jsx(MenuItem$1, { text: (assetSource_1.i18nKey ? t(assetSource_1.i18nKey) : assetSource_1.title) || startCase(assetSource_1.name), onClick: handleSelectFileMenuItemClicked, icon: assetSource_1.icon || ImageIcon, disabled: readOnly, "data-testid": `file-input-browse-button-${assetSource_1.name}`, "data-asset-source-name": assetSource_1.name }, assetSource_1.name), $[25] = handleSelectFileMenuItemClicked, $[26] = readOnly, $[27] = t, $[28] = t72) : t72 = $[28], t62 = assetSources.map(t72), $[20] = assetSources, $[21] = handleSelectFileMenuItemClicked, $[22] = readOnly, $[23] = t, $[24] = t62;
    } else
      t62 = $[24];
    t5 = t62;
  }
  const browseMenuItem = t5;
  let t6;
  bb1: switch (assetSourcesWithUpload.length) {
    case 0: {
      t6 = null;
      break bb1;
    }
    case 1: {
      const t72 = assetSourcesWithUpload[0].name;
      let t82;
      $[29] !== t ? (t82 = t("inputs.files.common.actions-menu.upload.label"), $[29] = t, $[30] = t82) : t82 = $[30];
      const t92 = `file-input-upload-button-${assetSourcesWithUpload[0].name}`, t10 = readOnly || directUploads === !1;
      let t11;
      $[31] !== accept || $[32] !== assetSourcesWithUpload[0].name || $[33] !== handleSelectFilesFromAssetSourceSingle || $[34] !== t10 || $[35] !== t82 || $[36] !== t92 ? (t11 = /* @__PURE__ */ jsx(FileInputMenuItem, { icon: UploadIcon, onSelect: handleSelectFilesFromAssetSourceSingle, accept, "data-asset-source-name": t72, text: t82, "data-testid": t92, disabled: t10 }), $[31] = accept, $[32] = assetSourcesWithUpload[0].name, $[33] = handleSelectFilesFromAssetSourceSingle, $[34] = t10, $[35] = t82, $[36] = t92, $[37] = t11) : t11 = $[37], t6 = t11;
      break bb1;
    }
    default: {
      let t72;
      $[38] !== accept || $[39] !== assetSourcesWithUpload || $[40] !== directUploads || $[41] !== handleSelectFilesFromAssetSource || $[42] !== readOnly ? (t72 = /* @__PURE__ */ jsx(UploadDropDownMenu, { accept, assetSources: assetSourcesWithUpload, directUploads, onSelectFiles: handleSelectFilesFromAssetSource, readOnly, "data-testid": "file-input-upload-drop-down-menu-button", renderAsMenuGroup: !0 }), $[38] = accept, $[39] = assetSourcesWithUpload, $[40] = directUploads, $[41] = handleSelectFilesFromAssetSource, $[42] = readOnly, $[43] = t72) : t72 = $[43], t6 = t72;
    }
  }
  const uploadMenuItem = t6;
  if (!asset)
    return null;
  let t7;
  $[44] === Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(FileSkeleton$1, {}), $[44] = t7) : t7 = $[44];
  let t8;
  $[45] !== browseMenuItem || $[46] !== clearField || $[47] !== isMenuOpen || $[48] !== readOnly || $[49] !== setBrowseButtonElement || $[50] !== uploadMenuItem || $[51] !== value ? (t8 = (t92) => {
    const {
      originalFilename,
      extension,
      url,
      size
    } = t92, filename = originalFilename || `download.${extension}`;
    let copyUrl, downloadUrl;
    return isFileSource(value) && (downloadUrl = `${url}?dl`, copyUrl = url), /* @__PURE__ */ jsx(FileActionsMenu, { size, originalFilename: filename, muted: !readOnly, onMenuOpen: setIsMenuOpen, isMenuOpen, setMenuButtonElement: setBrowseButtonElement, children: /* @__PURE__ */ jsx(ActionsMenu, { browse: browseMenuItem, upload: uploadMenuItem, onReset: clearField, downloadUrl, copyUrl, readOnly }) });
  }, $[45] = browseMenuItem, $[46] = clearField, $[47] = isMenuOpen, $[48] = readOnly, $[49] = setBrowseButtonElement, $[50] = uploadMenuItem, $[51] = value, $[52] = t8) : t8 = $[52];
  let t9;
  return $[53] !== asset || $[54] !== observeAsset || $[55] !== t8 ? (t9 = /* @__PURE__ */ jsx(WithReferencedAsset, { reference: asset, observeAsset, waitPlaceholder: t7, children: t8 }), $[53] = asset, $[54] = observeAsset, $[55] = t8, $[56] = t9) : t9 = $[56], t9;
}
function _temp$1t(s) {
  return !!s.uploader;
}
function InvalidFileWarning(t0) {
  const $ = c(20), {
    onClearValue
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = t("inputs.file.invalid-file-warning.title"), $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("inputs.file.invalid-file-warning.description"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: 4, children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t3,
      t5
    ] })
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t ? (t7 = t("inputs.file.invalid-file-warning.reset-button.text"), $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== onClearValue || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearValue, text: t7, width: "fill" }), $[14] = onClearValue, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t6 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Card, { tone: "caution", padding: 4, border: !0, radius: 2, children: [
    t6,
    t8
  ] }), $[17] = t6, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
const CardOverlay = styled(Card)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`, FlexContainer$1 = styled(Flex)`
  height: 100%;
`, ASSET_FIELD_PATH$1 = ["asset"];
function FileAsset(props2) {
  const $ = c(76), {
    assetSources,
    changed,
    clearField,
    directUploads,
    elementProps,
    hoveringFiles,
    isStale,
    isUploading,
    onCancelUpload,
    onClearUploadStatus,
    onSelectAssets,
    onSelectFiles,
    onStale,
    path,
    readOnly,
    resolveUploader: resolveUploader2,
    schemaType,
    setHoveringFiles,
    value
  } = props2, {
    t
  } = useTranslation();
  let t0, t1;
  $[0] !== path ? (t1 = path.concat(ASSET_FIELD_PATH$1), $[0] = path, $[1] = t1) : t1 = $[1], t0 = t1;
  const assetFieldPath = t0, [assetSourceDestination, setAssetSourceDestination] = useState(null), [showDestinationSourcePicker, setShowDestinationSourcePicker] = useState(!1);
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[2] = t2) : t2 = $[2];
  const [filesToUploadFromPaste, setFilesToUploadFromPaste] = useState(t2), elementRef = elementProps.ref?.current, hasMultipleUploadSources = assetSources.filter(_temp$1s).length > 1;
  let t3;
  $[3] !== elementProps ? (t3 = (event) => {
    event.currentTarget === event.target && event.currentTarget === elementProps.ref?.current && elementProps.onFocus(event);
  }, $[3] = elementProps, $[4] = t3) : t3 = $[4];
  const handleFileTargetFocus = t3;
  let t4;
  $[5] !== directUploads || $[6] !== hasMultipleUploadSources || $[7] !== resolveUploader2 || $[8] !== schemaType || $[9] !== setHoveringFiles ? (t4 = (fileInfo) => {
    setHoveringFiles(fileInfo.filter(_temp2$w));
    let canUpload = !0;
    const acceptedFiles = fileInfo.filter((file_0) => resolveUploader2?.(schemaType, file_0)), rejectedFilesCount = fileInfo.length - acceptedFiles.length;
    fileInfo.length > 0 && (rejectedFilesCount > 0 || directUploads === !1) && (canUpload = !1), hasMultipleUploadSources && canUpload && setShowDestinationSourcePicker(!0);
  }, $[5] = directUploads, $[6] = hasMultipleUploadSources, $[7] = resolveUploader2, $[8] = schemaType, $[9] = setHoveringFiles, $[10] = t4) : t4 = $[10];
  const handleFilesOver = t4;
  let t5;
  $[11] !== setHoveringFiles ? (t5 = () => {
    setHoveringFiles([]), setShowDestinationSourcePicker(!1);
  }, $[11] = setHoveringFiles, $[12] = t5) : t5 = $[12];
  const handleFilesOut = t5;
  let t6;
  $[13] !== directUploads || $[14] !== handleFilesOut || $[15] !== hoveringFiles.length || $[16] !== onSelectFiles || $[17] !== readOnly || $[18] !== setHoveringFiles ? (t6 = (assetSource, files) => {
    directUploads && !readOnly ? (setHoveringFiles([]), onSelectFiles(assetSource, files)) : hoveringFiles.length > 0 && handleFilesOut();
  }, $[13] = directUploads, $[14] = handleFilesOut, $[15] = hoveringFiles.length, $[16] = onSelectFiles, $[17] = readOnly, $[18] = setHoveringFiles, $[19] = t6) : t6 = $[19];
  const handleSelectFiles = t6;
  let t7;
  $[20] !== directUploads || $[21] !== hoveringFiles || $[22] !== readOnly || $[23] !== resolveUploader2 || $[24] !== schemaType || $[25] !== value?._upload || $[26] !== value?.asset ? (t7 = () => {
    const acceptedFiles_0 = hoveringFiles.filter((file_1) => resolveUploader2?.(schemaType, file_1)), rejectedFilesCount_0 = hoveringFiles.length - acceptedFiles_0.length;
    return hoveringFiles.length > 0 && (rejectedFilesCount_0 > 0 || directUploads === !1) ? "critical" : !value?._upload && !readOnly && hoveringFiles.length > 0 ? "primary" : value?._upload && value?.asset && readOnly ? "transparent" : "default";
  }, $[20] = directUploads, $[21] = hoveringFiles, $[22] = readOnly, $[23] = resolveUploader2, $[24] = schemaType, $[25] = value?._upload, $[26] = value?.asset, $[27] = t7) : t7 = $[27];
  const getFileTone = t7, hasValueOrUpload = !!(value?._upload || value?.asset);
  let t8;
  $[28] !== filesToUploadFromPaste || $[29] !== onSelectFiles ? (t8 = (assetSource_0) => {
    setAssetSourceDestination(assetSource_0), assetSource_0 && filesToUploadFromPaste.length > 0 && (setShowDestinationSourcePicker(!1), onSelectFiles(assetSource_0, filesToUploadFromPaste), setFilesToUploadFromPaste([]), setAssetSourceDestination(null));
  }, $[28] = filesToUploadFromPaste, $[29] = onSelectFiles, $[30] = t8) : t8 = $[30];
  const handleSetAssetSourceDestination = t8;
  let t9;
  $[31] !== assetSourceDestination || $[32] !== assetSources || $[33] !== directUploads || $[34] !== hasMultipleUploadSources || $[35] !== onSelectFiles || $[36] !== resolveUploader2 || $[37] !== schemaType ? (t9 = (files_0) => {
    const acceptedFiles_1 = files_0.filter((file_2) => resolveUploader2?.(schemaType, file_2));
    if (!(files_0.length - acceptedFiles_1.length > 0 || directUploads === !1) && files_0.length !== 0)
      if (hasMultipleUploadSources) {
        if (assetSourceDestination) {
          onSelectFiles(assetSourceDestination, files_0), setShowDestinationSourcePicker(!1), setAssetSourceDestination(null);
          return;
        }
        setShowDestinationSourcePicker(!0), setFilesToUploadFromPaste(files_0);
      } else {
        const firstAssetSourceWithUpload = assetSources.filter(_temp3$9)[0];
        firstAssetSourceWithUpload && onSelectFiles(firstAssetSourceWithUpload, files_0), setShowDestinationSourcePicker(!1), setAssetSourceDestination(null);
      }
  }, $[31] = assetSourceDestination, $[32] = assetSources, $[33] = directUploads, $[34] = hasMultipleUploadSources, $[35] = onSelectFiles, $[36] = resolveUploader2, $[37] = schemaType, $[38] = t9) : t9 = $[38];
  const handleOnFiles = t9;
  let t10;
  $[39] === Symbol.for("react.memo_cache_sentinel") ? (t10 = () => {
    setShowDestinationSourcePicker(!1), setAssetSourceDestination(null);
  }, $[39] = t10) : t10 = $[39];
  const handleUploadDestinationPickerClose = t10;
  if (value && typeof value.asset < "u" && !value?._upload && !isFileSource(value)) {
    let t112;
    return $[40] !== clearField ? (t112 = /* @__PURE__ */ jsx(InvalidFileWarning, { onClearValue: clearField }), $[40] = clearField, $[41] = t112) : t112 = $[41], t112;
  }
  let t11;
  $[42] !== isStale || $[43] !== onClearUploadStatus ? (t11 = isStale && /* @__PURE__ */ jsx(Box, { marginBottom: 2, children: /* @__PURE__ */ jsx(UploadWarning, { onClearStale: onClearUploadStatus }) }), $[42] = isStale, $[43] = onClearUploadStatus, $[44] = t11) : t11 = $[44];
  const t12 = !!props2.focused;
  let t13;
  $[45] !== assetSources || $[46] !== directUploads || $[47] !== elementProps || $[48] !== elementRef || $[49] !== getFileTone || $[50] !== handleFileTargetFocus || $[51] !== handleFilesOut || $[52] !== handleFilesOver || $[53] !== handleOnFiles || $[54] !== handleSelectFiles || $[55] !== handleSetAssetSourceDestination || $[56] !== hasValueOrUpload || $[57] !== hoveringFiles.length || $[58] !== isUploading || $[59] !== onCancelUpload || $[60] !== onSelectAssets || $[61] !== onStale || $[62] !== props2 || $[63] !== readOnly || $[64] !== showDestinationSourcePicker || $[65] !== t || $[66] !== value ? (t13 = value?._upload ? /* @__PURE__ */ jsx(UploadProgress, { uploadState: value._upload, onCancel: isUploading && onCancelUpload ? onCancelUpload : void 0, onStale }) : /* @__PURE__ */ jsx(FileTarget, { ...elementProps, onFocus: handleFileTargetFocus, tabIndex: 0, disabled: readOnly || directUploads === !1, onFiles: handleOnFiles, onFilesOver: handleFilesOver, onFilesOut: handleFilesOut, tone: getFileTone(), $border: hasValueOrUpload || hoveringFiles.length > 0, style: {
    padding: 1
  }, sizing: "border", radius: 2, children: /* @__PURE__ */ jsxs("div", { style: {
    position: "relative"
  }, children: [
    showDestinationSourcePicker && /* @__PURE__ */ jsx(UploadDestinationPicker, { assetSources, onSelectAssetSource: handleSetAssetSourceDestination, referenceElement: elementRef, onClose: handleUploadDestinationPickerClose, text: t("inputs.files.common.placeholder.select-asset-source-upload-destination", {
      context: "file"
    }) }),
    !value?.asset && /* @__PURE__ */ jsx(FileUploadPlaceHolder, { ...props2, onSelectFiles: handleSelectFiles }),
    value?.asset && hoveringFiles.length > 0 ? /* @__PURE__ */ jsx(AssetPlaceholder, { ...props2, tone: getFileTone(), onSelectFiles: handleSelectFiles }) : null,
    !value?._upload && value?.asset && /* @__PURE__ */ jsx(FilePreview$1, { ...props2, onSelectAssets })
  ] }) }), $[45] = assetSources, $[46] = directUploads, $[47] = elementProps, $[48] = elementRef, $[49] = getFileTone, $[50] = handleFileTargetFocus, $[51] = handleFilesOut, $[52] = handleFilesOver, $[53] = handleOnFiles, $[54] = handleSelectFiles, $[55] = handleSetAssetSourceDestination, $[56] = hasValueOrUpload, $[57] = hoveringFiles.length, $[58] = isUploading, $[59] = onCancelUpload, $[60] = onSelectAssets, $[61] = onStale, $[62] = props2, $[63] = readOnly, $[64] = showDestinationSourcePicker, $[65] = t, $[66] = value, $[67] = t13) : t13 = $[67];
  let t14;
  $[68] !== assetFieldPath || $[69] !== changed || $[70] !== t12 || $[71] !== t13 ? (t14 = /* @__PURE__ */ jsx(ChangeIndicator, { path: assetFieldPath, hasFocus: t12, isChanged: changed, children: t13 }), $[68] = assetFieldPath, $[69] = changed, $[70] = t12, $[71] = t13, $[72] = t14) : t14 = $[72];
  let t15;
  return $[73] !== t11 || $[74] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t11,
    t14
  ] }), $[73] = t11, $[74] = t14, $[75] = t15) : t15 = $[75], t15;
}
function _temp3$9(s_0) {
  return s_0.uploader;
}
function _temp2$w(file) {
  return file.kind !== "string";
}
function _temp$1s(s) {
  return !!s.uploader;
}
function FileUploadPlaceHolder(props2) {
  const $ = c(27), {
    assetSources,
    directUploads,
    hoveringFiles,
    onSelectFiles,
    readOnly,
    resolveUploader: resolveUploader2,
    schemaType
  } = props2;
  let t0;
  if ($[0] !== hoveringFiles || $[1] !== resolveUploader2 || $[2] !== schemaType) {
    let t12;
    $[4] !== resolveUploader2 || $[5] !== schemaType ? (t12 = (file) => resolveUploader2?.(schemaType, file), $[4] = resolveUploader2, $[5] = schemaType, $[6] = t12) : t12 = $[6], t0 = hoveringFiles.filter(t12), $[0] = hoveringFiles, $[1] = resolveUploader2, $[2] = schemaType, $[3] = t0;
  } else
    t0 = $[3];
  const acceptedFiles = t0, rejectedFilesCount = hoveringFiles.length - acceptedFiles.length;
  let t1;
  $[7] !== schemaType ? (t1 = get(schemaType, "options.accept", ""), $[7] = schemaType, $[8] = t1) : t1 = $[8];
  const accept = t1, t2 = readOnly ? "transparent" : "inherit";
  let t3;
  $[9] !== hoveringFiles.length ? (t3 = hoveringFiles.length === 0 ? {
    borderStyle: "dashed"
  } : {
    borderStyle: "dashed",
    borderColor: "transparent"
  }, $[9] = hoveringFiles.length, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== props2 ? (t4 = /* @__PURE__ */ jsx(Browser, { ...props2 }), $[11] = props2, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== accept || $[14] !== acceptedFiles || $[15] !== assetSources || $[16] !== directUploads || $[17] !== hoveringFiles || $[18] !== onSelectFiles || $[19] !== readOnly || $[20] !== rejectedFilesCount || $[21] !== t4 ? (t5 = /* @__PURE__ */ jsx(UploadPlaceholder, { accept, acceptedFiles, assetSources, browse: t4, directUploads, hoveringFiles, onUpload: onSelectFiles, readOnly, rejectedFilesCount, type: "file" }), $[13] = accept, $[14] = acceptedFiles, $[15] = assetSources, $[16] = directUploads, $[17] = hoveringFiles, $[18] = onSelectFiles, $[19] = readOnly, $[20] = rejectedFilesCount, $[21] = t4, $[22] = t5) : t5 = $[22];
  let t6;
  return $[23] !== t2 || $[24] !== t3 || $[25] !== t5 ? (t6 = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Card, { tone: t2, border: !0, paddingX: 3, paddingY: 2, radius: 2, style: t3, children: t5 }) }), $[23] = t2, $[24] = t3, $[25] = t5, $[26] = t6) : t6 = $[26], t6;
}
function AssetPlaceholder(props2) {
  const $ = c(16), {
    directUploads,
    schemaType,
    readOnly,
    resolveUploader: resolveUploader2,
    hoveringFiles,
    tone
  } = props2;
  let t0;
  if ($[0] !== hoveringFiles || $[1] !== resolveUploader2 || $[2] !== schemaType) {
    let t12;
    $[4] !== resolveUploader2 || $[5] !== schemaType ? (t12 = (file) => resolveUploader2?.(schemaType, file), $[4] = resolveUploader2, $[5] = schemaType, $[6] = t12) : t12 = $[6], t0 = hoveringFiles.filter(t12), $[0] = hoveringFiles, $[1] = resolveUploader2, $[2] = schemaType, $[3] = t0;
  } else
    t0 = $[3];
  const acceptedFiles = t0, rejectedFilesCount = hoveringFiles.length - acceptedFiles.length;
  let t1;
  $[7] !== acceptedFiles || $[8] !== directUploads || $[9] !== hoveringFiles || $[10] !== readOnly || $[11] !== rejectedFilesCount ? (t1 = /* @__PURE__ */ jsx(FlexContainer$1, { align: "center", justify: "center", gap: 2, flex: 1, children: /* @__PURE__ */ jsx(PlaceholderText, { directUploads, readOnly, hoveringFiles, acceptedFiles, rejectedFilesCount, type: "file" }) }), $[7] = acceptedFiles, $[8] = directUploads, $[9] = hoveringFiles, $[10] = readOnly, $[11] = rejectedFilesCount, $[12] = t1) : t1 = $[12];
  let t2;
  return $[13] !== t1 || $[14] !== tone ? (t2 = /* @__PURE__ */ jsx(CardOverlay, { radius: 2, tone, children: t1 }), $[13] = t1, $[14] = tone, $[15] = t2) : t2 = $[15], t2;
}
function FileAssetSource(props2) {
  const $ = c(30), {
    isUploading,
    observeAsset,
    schemaType,
    selectedAssetSource,
    setSelectedAssetSource,
    onSelectAssets,
    value
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== schemaType ? (t0 = get(schemaType, "options.accept", ""), $[0] = schemaType, $[1] = t0) : t0 = $[1];
  const accept = t0;
  let t1;
  $[2] !== setSelectedAssetSource ? (t1 = () => {
    setSelectedAssetSource(null);
  }, $[2] = setSelectedAssetSource, $[3] = t1) : t1 = $[3];
  const handleAssetSourceClosed = t1;
  if (!selectedAssetSource)
    return null;
  const Component2 = selectedAssetSource.component;
  if (value && value.asset) {
    let t22;
    $[4] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(FileSkeleton$1, {}), $[4] = t22) : t22 = $[4];
    let t32;
    $[5] !== Component2 || $[6] !== accept || $[7] !== handleAssetSourceClosed || $[8] !== isUploading || $[9] !== onSelectAssets || $[10] !== schemaType || $[11] !== selectedAssetSource || $[12] !== t ? (t32 = (fileAsset) => /* @__PURE__ */ jsx(Component2, { accept, action: isUploading ? "upload" : "select", assetSource: selectedAssetSource, assetType: "file", dialogHeaderTitle: t("inputs.file.dialog.title"), onClose: handleAssetSourceClosed, onSelect: onSelectAssets, schemaType, selectedAssets: [fileAsset], selectionType: "single" }), $[5] = Component2, $[6] = accept, $[7] = handleAssetSourceClosed, $[8] = isUploading, $[9] = onSelectAssets, $[10] = schemaType, $[11] = selectedAssetSource, $[12] = t, $[13] = t32) : t32 = $[13];
    let t42;
    return $[14] !== observeAsset || $[15] !== t32 || $[16] !== value.asset ? (t42 = /* @__PURE__ */ jsx(WithReferencedAsset, { observeAsset, reference: value.asset, waitPlaceholder: t22, children: t32 }), $[14] = observeAsset, $[15] = t32, $[16] = value.asset, $[17] = t42) : t42 = $[17], t42;
  }
  const t2 = isUploading ? "upload" : "select";
  let t3;
  $[18] !== t ? (t3 = t("inputs.file.dialog.title"), $[18] = t, $[19] = t3) : t3 = $[19];
  let t4;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t4 = [], $[20] = t4) : t4 = $[20];
  let t5;
  return $[21] !== Component2 || $[22] !== accept || $[23] !== handleAssetSourceClosed || $[24] !== onSelectAssets || $[25] !== schemaType || $[26] !== selectedAssetSource || $[27] !== t2 || $[28] !== t3 ? (t5 = /* @__PURE__ */ jsx(Component2, { accept, action: t2, assetSource: selectedAssetSource, assetType: "file", dialogHeaderTitle: t3, onClose: handleAssetSourceClosed, onSelect: onSelectAssets, schemaType, selectedAssets: t4, selectionType: "single" }), $[21] = Component2, $[22] = accept, $[23] = handleAssetSourceClosed, $[24] = onSelectAssets, $[25] = schemaType, $[26] = selectedAssetSource, $[27] = t2, $[28] = t3, $[29] = t5) : t5 = $[29], t5;
}
function passThrough$1({
  children
}) {
  return children;
}
function BaseFileInput(props2) {
  const $ = c(76), {
    client,
    members,
    onChange,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    value
  } = props2, {
    push
  } = useToast(), {
    t
  } = useTranslation();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [hoveringFiles, setHoveringFiles] = useState(t0), [isStale, setIsStale] = useState(!1), [isUploading, setIsUploading] = useState(!1), [isBrowseMenuOpen, setIsBrowseMenuOpen] = useState(!1), [selectedAssetSource, setSelectedAssetSource] = useState(null), browseButtonElementRef = useRef(null), uploaderRef = useRef(null);
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = (element) => {
    element && (browseButtonElementRef.current = element);
  }, $[1] = t1) : t1 = $[1];
  const setBrowseButtonElement = t1, uploadSubscriptionRef = useRef(null);
  let t2;
  $[2] !== onChange ? (t2 = () => {
    onChange([unset(["asset"]), unset(["media"])]);
  }, $[2] = onChange, $[3] = t2) : t2 = $[3];
  const handleClearField = t2;
  let t3;
  $[4] !== onChange || $[5] !== value?._upload ? (t3 = () => {
    value?._upload && onChange(PatchEvent.from([unset(["_upload"])]));
  }, $[4] = onChange, $[5] = value?._upload, $[6] = t3) : t3 = $[6];
  const handleClearUploadStatus = t3;
  let t4;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setIsStale(!0);
  }, $[7] = t4) : t4 = $[7];
  const handleStaleUpload = t4;
  let t5;
  $[8] !== handleClearUploadStatus ? (t5 = () => {
    uploadSubscriptionRef.current && (uploadSubscriptionRef.current?.unsubscribe(), handleClearUploadStatus());
  }, $[8] = handleClearUploadStatus, $[9] = t5) : t5 = $[9];
  const cancelExternalFileToDatasetUpload = t5;
  let t6;
  $[10] !== cancelExternalFileToDatasetUpload || $[11] !== client || $[12] !== handleClearUploadStatus || $[13] !== onChange || $[14] !== push || $[15] !== schemaType || $[16] !== t ? (t6 = (uploader, file, t72) => {
    const assetDocumentProps = t72 === void 0 ? {} : t72, {
      source
    } = assetDocumentProps, options = {
      metadata: get(schemaType, "options.metadata"),
      storeOriginalFilename: get(schemaType, "options.storeOriginalFilename"),
      source
    };
    cancelExternalFileToDatasetUpload(), setIsUploading(!0), onChange(PatchEvent.from([setIfMissing({
      _type: schemaType.name
    })])), uploadSubscriptionRef.current = uploader.upload(client, file, schemaType, options).subscribe({
      next: (uploadEvent) => {
        uploadEvent.patches && onChange(PatchEvent.from(uploadEvent.patches));
      },
      error: (err) => {
        console.error(err), push({
          status: "error",
          description: t("inputs.file.upload-failed.description"),
          title: t("inputs.file.upload-failed.title")
        }), handleClearUploadStatus();
      },
      complete: () => {
        setIsUploading(!1);
      }
    });
  }, $[10] = cancelExternalFileToDatasetUpload, $[11] = client, $[12] = handleClearUploadStatus, $[13] = onChange, $[14] = push, $[15] = schemaType, $[16] = t, $[17] = t6) : t6 = $[17];
  const uploadExternalFileToDataset = t6;
  let t7;
  $[18] !== onChange || $[19] !== schemaType || $[20] !== uploadExternalFileToDataset ? (t7 = (assetsFromSource) => {
    handleSelectAssetFromSource({
      assetsFromSource,
      onChange,
      type: schemaType,
      resolveUploader,
      uploadWith: uploadExternalFileToDataset
    }), setSelectedAssetSource(null);
  }, $[18] = onChange, $[19] = schemaType, $[20] = uploadExternalFileToDataset, $[21] = t7) : t7 = $[21];
  const handleSelectAssets = t7;
  let t8;
  $[22] !== onChange || $[23] !== push || $[24] !== schemaType || $[25] !== t ? (t8 = (assetSource, files) => {
    if (files.length === 0)
      return;
    setSelectedAssetSource(assetSource);
    const uploader_0 = assetSource.uploader;
    if (uploader_0) {
      uploaderRef.current?.unsubscribe();
      try {
        uploaderRef.current = {
          unsubscribe: uploader_0.subscribe((event) => {
            bb57: switch (event.type) {
              case "progress": {
                onChange(PatchEvent.from([set(Math.max(2, event.progress), [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updatedAt"])]));
                break bb57;
              }
              case "error": {
                event.files.forEach(_temp$1r), push({
                  status: "error",
                  description: t("asset-sources.common.uploader.upload-failed.description"),
                  title: t("asset-sources.common.uploader.upload-failed.title")
                });
                break bb57;
              }
              case "all-complete": {
                onChange(PatchEvent.from([unset([UPLOAD_STATUS_KEY])])), setSelectedAssetSource(null), setIsUploading(!1);
                break bb57;
              }
              default:
            }
          }),
          uploader: assetSource.uploader
        }, setIsUploading(!0), onChange(PatchEvent.from(createInitialUploadPatches(files[0]))), uploader_0.upload(files, {
          schemaType,
          onChange
        });
      } catch (t92) {
        const err_0 = t92;
        onChange(PatchEvent.from([unset([UPLOAD_STATUS_KEY])])), setIsUploading(!1), setSelectedAssetSource(null), uploaderRef.current = null, push({
          status: "error",
          description: t("asset-sources.common.uploader.upload-failed.description"),
          title: t("asset-sources.common.uploader.upload-failed.title")
        }), console.error(err_0);
      }
    }
  }, $[22] = onChange, $[23] = push, $[24] = schemaType, $[25] = t, $[26] = t8) : t8 = $[26];
  const handleSelectFilesToUpload = t8;
  let t10, t9;
  $[27] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => () => {
    uploaderRef.current?.uploader && uploaderRef.current?.uploader.abort(), uploaderRef.current?.unsubscribe && uploaderRef.current?.unsubscribe();
  }, t10 = [], $[27] = t10, $[28] = t9) : (t10 = $[27], t9 = $[28]), useEffect(t9, t10);
  let t11;
  $[29] === Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
    uploaderRef.current?.uploader && uploaderRef.current?.uploader.abort();
  }, $[29] = t11) : t11 = $[29];
  const handleCancelUpload = t11;
  let t12;
  $[30] !== handleClearField || $[31] !== handleClearUploadStatus || $[32] !== handleSelectAssets || $[33] !== handleSelectFilesToUpload || $[34] !== hoveringFiles || $[35] !== isBrowseMenuOpen || $[36] !== isStale || $[37] !== isUploading || $[38] !== props2 || $[39] !== selectedAssetSource ? (t12 = () => /* @__PURE__ */ jsx(FileAsset, { ...props2, browseButtonElementRef, clearField: handleClearField, hoveringFiles, isBrowseMenuOpen, isStale, isUploading, onCancelUpload: handleCancelUpload, onClearUploadStatus: handleClearUploadStatus, onSelectAssets: handleSelectAssets, onSelectFiles: handleSelectFilesToUpload, onStale: handleStaleUpload, selectedAssetSource, setBrowseButtonElement, setHoveringFiles, setIsBrowseMenuOpen, setIsUploading, setSelectedAssetSource }), $[30] = handleClearField, $[31] = handleClearUploadStatus, $[32] = handleSelectAssets, $[33] = handleSelectFilesToUpload, $[34] = hoveringFiles, $[35] = isBrowseMenuOpen, $[36] = isStale, $[37] = isUploading, $[38] = props2, $[39] = selectedAssetSource, $[40] = t12) : t12 = $[40];
  const renderAsset = t12;
  let t13;
  if ($[41] !== members || $[42] !== renderAnnotation || $[43] !== renderAsset || $[44] !== renderBlock2 || $[45] !== renderField || $[46] !== renderInlineBlock || $[47] !== renderInput || $[48] !== renderItem2 || $[49] !== renderPreview || $[50] !== t) {
    let t142;
    $[52] !== renderAnnotation || $[53] !== renderAsset || $[54] !== renderBlock2 || $[55] !== renderField || $[56] !== renderInlineBlock || $[57] !== renderInput || $[58] !== renderItem2 || $[59] !== renderPreview || $[60] !== t ? (t142 = (member) => member.kind === "field" ? /* @__PURE__ */ jsx(MemberField, { member, renderAnnotation, renderBlock: renderBlock2, renderField: member.name === "asset" ? passThrough$1 : renderField, renderInlineBlock, renderInput: member.name === "asset" ? renderAsset : renderInput, renderItem: renderItem2, renderPreview }, member.key) : member.kind === "fieldSet" ? /* @__PURE__ */ jsx(MemberFieldSet, { member, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview }, member.key) : member.kind === "error" ? /* @__PURE__ */ jsx(MemberFieldError, { member }, member.key) : /* @__PURE__ */ jsx(Fragment, { children: t("inputs.file.error.unknown-member-kind", {
      kind: member.kind
    }) }), $[52] = renderAnnotation, $[53] = renderAsset, $[54] = renderBlock2, $[55] = renderField, $[56] = renderInlineBlock, $[57] = renderInput, $[58] = renderItem2, $[59] = renderPreview, $[60] = t, $[61] = t142) : t142 = $[61], t13 = members.map(t142), $[41] = members, $[42] = renderAnnotation, $[43] = renderAsset, $[44] = renderBlock2, $[45] = renderField, $[46] = renderInlineBlock, $[47] = renderInput, $[48] = renderItem2, $[49] = renderPreview, $[50] = t, $[51] = t13;
  } else
    t13 = $[51];
  let t14;
  $[62] !== handleClearField || $[63] !== handleClearUploadStatus || $[64] !== handleSelectAssets || $[65] !== handleSelectFilesToUpload || $[66] !== hoveringFiles || $[67] !== isBrowseMenuOpen || $[68] !== isStale || $[69] !== isUploading || $[70] !== props2 || $[71] !== selectedAssetSource ? (t14 = selectedAssetSource && /* @__PURE__ */ jsx(FileAssetSource, { ...props2, browseButtonElementRef, clearField: handleClearField, hoveringFiles, isBrowseMenuOpen, isStale, isUploading, onClearUploadStatus: handleClearUploadStatus, onStale: handleStaleUpload, onSelectAssets: handleSelectAssets, onSelectFiles: handleSelectFilesToUpload, selectedAssetSource, setBrowseButtonElement, setHoveringFiles, setIsBrowseMenuOpen, setIsUploading, setSelectedAssetSource }), $[62] = handleClearField, $[63] = handleClearUploadStatus, $[64] = handleSelectAssets, $[65] = handleSelectFilesToUpload, $[66] = hoveringFiles, $[67] = isBrowseMenuOpen, $[68] = isStale, $[69] = isUploading, $[70] = props2, $[71] = selectedAssetSource, $[72] = t14) : t14 = $[72];
  let t15;
  return $[73] !== t13 || $[74] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t13,
    t14
  ] }), $[73] = t13, $[74] = t14, $[75] = t15) : t15 = $[75], t15;
}
function _temp$1r(file_0) {
  console.error(file_0.error);
}
function StudioFileInput(props2) {
  const $ = c(11), sourcesFromSchema = props2.schemaType.options?.sources, documentPreviewStore = useDocumentPreviewStore(), {
    file: fileConfig
  } = useFormBuilder().__internal, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[0] !== fileConfig.directUploads ? (t0 = (type, file) => fileConfig.directUploads ? resolveUploader(type, file) : null, $[0] = fileConfig.directUploads, $[1] = t0) : t0 = $[1];
  const resolveUploader$1 = t0, assetSources = sourcesFromSchema || fileConfig.assetSources;
  let t1;
  $[2] !== documentPreviewStore ? (t1 = (id2) => observeFileAsset(documentPreviewStore, id2), $[2] = documentPreviewStore, $[3] = t1) : t1 = $[3];
  const observeAsset = t1;
  let t2;
  return $[4] !== assetSources || $[5] !== client || $[6] !== fileConfig.directUploads || $[7] !== observeAsset || $[8] !== props2 || $[9] !== resolveUploader$1 ? (t2 = /* @__PURE__ */ jsx(BaseFileInput, { ...props2, client, assetSources, directUploads: fileConfig.directUploads, observeAsset, resolveUploader: resolveUploader$1 }), $[4] = assetSources, $[5] = client, $[6] = fileConfig.directUploads, $[7] = observeAsset, $[8] = props2, $[9] = resolveUploader$1, $[10] = t2) : t2 = $[10], t2;
}
function usePreviewImageSource({
  value,
  imageUrlBuilder: imageUrlBuilder2
}) {
  const dpr = useDevicePixelRatio(), url = useMemo(() => value && isImageSource(value) ? imageUrlBuilder2.width(2e3).fit("max").image(value).dpr(dpr).auto("format").url() : void 0, [dpr, imageUrlBuilder2, value]), dimensions = useMemo(() => url ? getImageDimensions(url) : {
    width: 0,
    height: 0,
    aspectRatio: 0
  }, [url]), customProperties = useMemo(() => ({
    "--image-width": dimensions.width,
    "--image-height": dimensions.height
  }), [dimensions.width, dimensions.height]);
  return {
    url,
    dimensions,
    customProperties
  };
}
const ASSET_FIELD_PATH = ["asset"];
function ImageInputAssetComponent(props2) {
  const $ = c(58), {
    assetSources,
    directUploads,
    elementProps,
    handleClearUploadState,
    handleFileTargetFocus,
    onSelectFiles,
    hoveringFiles,
    inputProps,
    isStale,
    readOnly,
    renderAssetMenu,
    renderPreview,
    renderUploadPlaceholder,
    renderUploadState,
    schemaType,
    setHoveringFiles,
    tone,
    value,
    imageUrlBuilder: imageUrlBuilder2
  } = props2, elementRef = elementProps.ref?.current, {
    t
  } = useTranslation(), hasValueOrUpload = !!(value?._upload || value?.asset);
  let t0, t1;
  $[0] !== inputProps.path ? (t1 = inputProps.path.concat(ASSET_FIELD_PATH), $[0] = inputProps.path, $[1] = t1) : t1 = $[1], t0 = t1;
  const path = t0;
  let t2;
  $[2] !== imageUrlBuilder2 || $[3] !== value ? (t2 = {
    value,
    imageUrlBuilder: imageUrlBuilder2
  }, $[2] = imageUrlBuilder2, $[3] = value, $[4] = t2) : t2 = $[4];
  const {
    customProperties
  } = usePreviewImageSource(t2), [assetSourceDestination, setAssetSourceDestination] = useState(null), [showDestinationSourcePicker, setShowDestinationSourcePicker] = useState(!1);
  let t3;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t3 = [], $[5] = t3) : t3 = $[5];
  const [filesToUploadFromPaste, setFilesToUploadFromPaste] = useState(t3), hasMultipleUploadSources = assetSources.filter(_temp$1q).length > 1;
  let t4;
  $[6] !== setHoveringFiles ? (t4 = () => {
    setHoveringFiles([]), setShowDestinationSourcePicker(!1);
  }, $[6] = setHoveringFiles, $[7] = t4) : t4 = $[7];
  const handleFilesOut = t4;
  let t5;
  $[8] !== directUploads || $[9] !== hasMultipleUploadSources || $[10] !== schemaType || $[11] !== setHoveringFiles ? (t5 = (fileInfo) => {
    setHoveringFiles(fileInfo);
    let canUpload = !0;
    const acceptedFiles = fileInfo.filter((file) => resolveUploader?.(schemaType, file)), rejectedFilesCount = fileInfo.length - acceptedFiles.length;
    fileInfo.length > 0 && (rejectedFilesCount > 0 || directUploads === !1) && (canUpload = !1), hasMultipleUploadSources && canUpload && setShowDestinationSourcePicker(!0);
  }, $[8] = directUploads, $[9] = hasMultipleUploadSources, $[10] = schemaType, $[11] = setHoveringFiles, $[12] = t5) : t5 = $[12];
  const handleFilesOver = t5;
  let t6;
  $[13] !== assetSourceDestination || $[14] !== assetSources || $[15] !== directUploads || $[16] !== handleFilesOut || $[17] !== hasMultipleUploadSources || $[18] !== onSelectFiles || $[19] !== readOnly || $[20] !== schemaType ? (t6 = (files) => {
    if (directUploads === !1 || readOnly) {
      handleFilesOut();
      return;
    }
    const acceptedFiles_0 = files.filter((file_0) => resolveUploader?.(schemaType, file_0));
    if (!(files.length - acceptedFiles_0.length > 0) && files.length !== 0)
      if (hasMultipleUploadSources) {
        if (assetSourceDestination) {
          onSelectFiles(assetSourceDestination, files), setShowDestinationSourcePicker(!1), setAssetSourceDestination(null);
          return;
        }
        setShowDestinationSourcePicker(!0), setFilesToUploadFromPaste(files);
      } else {
        const firstAssetSourceWithUpload = assetSources.filter(_temp2$v)[0];
        firstAssetSourceWithUpload && onSelectFiles(firstAssetSourceWithUpload, files), setShowDestinationSourcePicker(!1), setAssetSourceDestination(null);
      }
  }, $[13] = assetSourceDestination, $[14] = assetSources, $[15] = directUploads, $[16] = handleFilesOut, $[17] = hasMultipleUploadSources, $[18] = onSelectFiles, $[19] = readOnly, $[20] = schemaType, $[21] = t6) : t6 = $[21];
  const handleOnFiles = t6;
  let t7;
  $[22] !== filesToUploadFromPaste || $[23] !== onSelectFiles ? (t7 = (assetSource) => {
    setAssetSourceDestination(assetSource), assetSource && filesToUploadFromPaste.length > 0 && (setShowDestinationSourcePicker(!1), onSelectFiles(assetSource, filesToUploadFromPaste), setFilesToUploadFromPaste([]), setAssetSourceDestination(null));
  }, $[22] = filesToUploadFromPaste, $[23] = onSelectFiles, $[24] = t7) : t7 = $[24];
  const handleSetAssetSourceDestination = t7;
  let t8;
  $[25] === Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    setShowDestinationSourcePicker(!1), setAssetSourceDestination(null);
  }, $[25] = t8) : t8 = $[25];
  const handleUploadDestinationPickerClose = t8;
  let t9;
  $[26] !== handleClearUploadState || $[27] !== isStale ? (t9 = isStale && /* @__PURE__ */ jsx(Box, { marginBottom: 2, children: /* @__PURE__ */ jsx(UploadWarning, { onClearStale: handleClearUploadState }) }), $[26] = handleClearUploadState, $[27] = isStale, $[28] = t9) : t9 = $[28];
  const t10 = !!inputProps.focused;
  let t11;
  $[29] !== assetSources || $[30] !== elementProps || $[31] !== elementRef || $[32] !== handleFileTargetFocus || $[33] !== handleFilesOut || $[34] !== handleFilesOver || $[35] !== handleOnFiles || $[36] !== handleSetAssetSourceDestination || $[37] !== hasValueOrUpload || $[38] !== hoveringFiles || $[39] !== readOnly || $[40] !== renderAssetMenu || $[41] !== renderPreview || $[42] !== renderUploadPlaceholder || $[43] !== renderUploadState || $[44] !== showDestinationSourcePicker || $[45] !== t || $[46] !== tone || $[47] !== value ? (t11 = value?._upload ? renderUploadState(value._upload) : /* @__PURE__ */ jsxs(FileTarget, { ...elementProps, onFocus: handleFileTargetFocus, tabIndex: 0, disabled: !!readOnly, onFiles: handleOnFiles, onFilesOver: handleFilesOver, onFilesOut: handleFilesOut, tone, $border: hasValueOrUpload || hoveringFiles.length > 0, sizing: "border", radius: 2, children: [
    showDestinationSourcePicker && /* @__PURE__ */ jsx(UploadDestinationPicker, { assetSources, onSelectAssetSource: handleSetAssetSourceDestination, referenceElement: elementRef, onClose: handleUploadDestinationPickerClose, text: t("inputs.files.common.placeholder.select-asset-source-upload-destination", {
      context: "image"
    }) }),
    !value?.asset && renderUploadPlaceholder(),
    !value?._upload && value?.asset && /* @__PURE__ */ jsxs("div", { style: {
      position: "relative"
    }, children: [
      renderPreview(),
      renderAssetMenu()
    ] })
  ] }), $[29] = assetSources, $[30] = elementProps, $[31] = elementRef, $[32] = handleFileTargetFocus, $[33] = handleFilesOut, $[34] = handleFilesOver, $[35] = handleOnFiles, $[36] = handleSetAssetSourceDestination, $[37] = hasValueOrUpload, $[38] = hoveringFiles, $[39] = readOnly, $[40] = renderAssetMenu, $[41] = renderPreview, $[42] = renderUploadPlaceholder, $[43] = renderUploadState, $[44] = showDestinationSourcePicker, $[45] = t, $[46] = tone, $[47] = value, $[48] = t11) : t11 = $[48];
  let t12;
  $[49] !== inputProps.changed || $[50] !== path || $[51] !== t10 || $[52] !== t11 ? (t12 = /* @__PURE__ */ jsx(ChangeIndicator, { path, hasFocus: t10, isChanged: inputProps.changed, children: t11 }), $[49] = inputProps.changed, $[50] = path, $[51] = t10, $[52] = t11, $[53] = t12) : t12 = $[53];
  let t13;
  return $[54] !== customProperties || $[55] !== t12 || $[56] !== t9 ? (t13 = /* @__PURE__ */ jsxs("div", { style: customProperties, children: [
    t9,
    t12
  ] }), $[54] = customProperties, $[55] = t12, $[56] = t9, $[57] = t13) : t13 = $[57], t13;
}
function _temp2$v(s_0) {
  return s_0.uploader;
}
function _temp$1q(s) {
  return !!s.uploader;
}
const ImageInputAsset = memo(ImageInputAssetComponent), MenuActionsWrapper = styled(Inline)`
  position: absolute;
  top: 0;
  right: 0;
`, ImageActionsMenuWaitPlaceholder = () => {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(MenuActionsWrapper, { padding: 2, children: /* @__PURE__ */ jsx(Skeleton, { style: {
    width: "25px",
    height: "25px"
  }, animated: !0 }) }), $[0] = t0) : t0 = $[0], t0;
};
function ImageActionsMenu(props2) {
  const $ = c(38), {
    onEdit,
    children,
    showEdit,
    setHotspotButtonElement,
    setMenuButtonElement,
    onMenuOpen,
    isMenuOpen
  } = props2, [menuElement, setMenuElement] = useState(null), [buttonElement, setButtonElement] = useState(null);
  let t0;
  $[0] !== isMenuOpen || $[1] !== onMenuOpen ? (t0 = () => onMenuOpen(!isMenuOpen), $[0] = isMenuOpen, $[1] = onMenuOpen, $[2] = t0) : t0 = $[2];
  const handleClick = t0;
  let t1;
  $[3] !== buttonElement || $[4] !== isMenuOpen || $[5] !== onMenuOpen ? (t1 = (event) => {
    isMenuOpen && (event.key === "Escape" || event.key === "Tab") && (onMenuOpen(!1), buttonElement?.focus());
  }, $[3] = buttonElement, $[4] = isMenuOpen, $[5] = onMenuOpen, $[6] = t1) : t1 = $[6], useGlobalKeyDown(t1);
  let t2;
  $[7] !== buttonElement || $[8] !== onMenuOpen ? (t2 = (event_0) => {
    buttonElement?.contains(event_0.target) || onMenuOpen(!1);
  }, $[7] = buttonElement, $[8] = onMenuOpen, $[9] = t2) : t2 = $[9];
  let t3;
  $[10] !== menuElement ? (t3 = () => [menuElement], $[10] = menuElement, $[11] = t3) : t3 = $[11], useClickOutsideEvent(t2, t3);
  let t4;
  $[12] !== setMenuButtonElement ? (t4 = (el) => {
    setMenuButtonElement(el), setButtonElement(el);
  }, $[12] = setMenuButtonElement, $[13] = t4) : t4 = $[13];
  const setOptionsButtonRef = t4;
  let t5, t6;
  $[14] !== isMenuOpen || $[15] !== menuElement ? (t5 = () => {
    isMenuOpen && menuElement?.focus();
  }, t6 = [isMenuOpen, menuElement], $[14] = isMenuOpen, $[15] = menuElement, $[16] = t5, $[17] = t6) : (t5 = $[16], t6 = $[17]), useEffect(t5, t6);
  const {
    t
  } = useTranslation();
  let t7;
  $[18] !== onEdit || $[19] !== setHotspotButtonElement || $[20] !== showEdit || $[21] !== t ? (t7 = showEdit && /* @__PURE__ */ jsx(Button, { "aria-label": t("inputs.image.actions-menu.edit-details.aria-label"), "data-testid": "options-menu-edit-details", icon: CropIcon, mode: "ghost", onClick: onEdit, ref: setHotspotButtonElement, tooltipProps: {
    content: t("inputs.image.actions-menu.crop-image-tooltip")
  } }), $[18] = onEdit, $[19] = setHotspotButtonElement, $[20] = showEdit, $[21] = t, $[22] = t7) : t7 = $[22];
  let t8;
  $[23] !== children ? (t8 = /* @__PURE__ */ jsx(Menu, { ref: setMenuElement, children }), $[23] = children, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] !== t ? (t9 = t("inputs.image.actions-menu.options.aria-label"), $[25] = t, $[26] = t9) : t9 = $[26];
  let t10;
  $[27] !== handleClick || $[28] !== setOptionsButtonRef || $[29] !== t9 ? (t10 = /* @__PURE__ */ jsx(ContextMenuButton, { "aria-label": t9, "data-testid": "options-menu-button", mode: "ghost", onClick: handleClick, ref: setOptionsButtonRef }), $[27] = handleClick, $[28] = setOptionsButtonRef, $[29] = t9, $[30] = t10) : t10 = $[30];
  let t11;
  $[31] !== isMenuOpen || $[32] !== t10 || $[33] !== t8 ? (t11 = /* @__PURE__ */ jsx(Popover, { id: "image-actions-menu", content: t8, portal: !0, open: isMenuOpen, constrainSize: !0, children: t10 }), $[31] = isMenuOpen, $[32] = t10, $[33] = t8, $[34] = t11) : t11 = $[34];
  let t12;
  return $[35] !== t11 || $[36] !== t7 ? (t12 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(MenuActionsWrapper, { "data-buttons": !0, space: 1, padding: 2, children: [
    t7,
    t11
  ] }) }), $[35] = t11, $[36] = t7, $[37] = t12) : t12 = $[37], t12;
}
function ImageInputAssetMenuComponent(props2) {
  const $ = c(38), {
    assetSources,
    directUploads,
    handleOpenDialog,
    handleRemoveButtonClick,
    onSelectFiles,
    handleSelectImageFromAssetSource,
    imageUrlBuilder: imageUrlBuilder2,
    isImageToolEnabled,
    isMenuOpen,
    observeAsset,
    readOnly,
    schemaType,
    setHotspotButtonElement,
    setMenuButtonElement,
    setMenuOpen,
    value
  } = props2, {
    t
  } = useTranslation();
  let t0, t1;
  $[0] !== schemaType ? (t1 = get(schemaType, "options.accept", "image/*"), $[0] = schemaType, $[1] = t1) : t1 = $[1], t0 = t1;
  const accept = t0, asset = value?.asset, showAdvancedEditButton = value && asset && isImageToolEnabled;
  if (!asset)
    return null;
  let t2;
  $[2] !== assetSources || $[3] !== handleSelectImageFromAssetSource || $[4] !== readOnly || $[5] !== setMenuOpen || $[6] !== t ? (t2 = assetSources && assetSources.length === 0 ? null : /* @__PURE__ */ jsx(MenuItem$1, { icon: SearchIcon, text: t("inputs.image.browse-menu.text"), onClick: () => {
    setMenuOpen(!1), handleSelectImageFromAssetSource(assetSources[0]);
  }, disabled: readOnly, "data-testid": "file-input-browse-button" }), $[2] = assetSources, $[3] = handleSelectImageFromAssetSource, $[4] = readOnly, $[5] = setMenuOpen, $[6] = t, $[7] = t2) : t2 = $[7];
  let browseMenuItem = t2;
  if (assetSources && assetSources.length > 1) {
    let t32;
    if ($[8] !== assetSources || $[9] !== handleSelectImageFromAssetSource || $[10] !== readOnly || $[11] !== setMenuOpen || $[12] !== t) {
      let t42;
      $[14] !== handleSelectImageFromAssetSource || $[15] !== readOnly || $[16] !== setMenuOpen || $[17] !== t ? (t42 = (assetSource) => /* @__PURE__ */ jsx(MenuItem$1, { text: (assetSource.i18nKey ? t(assetSource.i18nKey) : assetSource.title) || startCase(assetSource.name), onClick: () => {
        setMenuOpen(!1), handleSelectImageFromAssetSource(assetSource);
      }, icon: assetSource.icon || ImageIcon, "data-testid": `file-input-browse-button-${assetSource.name}`, disabled: readOnly }, assetSource.name), $[14] = handleSelectImageFromAssetSource, $[15] = readOnly, $[16] = setMenuOpen, $[17] = t, $[18] = t42) : t42 = $[18], t32 = assetSources.map(t42), $[8] = assetSources, $[9] = handleSelectImageFromAssetSource, $[10] = readOnly, $[11] = setMenuOpen, $[12] = t, $[13] = t32;
    } else
      t32 = $[13];
    browseMenuItem = t32;
  }
  const t3 = !!showAdvancedEditButton;
  let t4;
  return $[19] !== accept || $[20] !== asset || $[21] !== assetSources || $[22] !== browseMenuItem || $[23] !== directUploads || $[24] !== handleOpenDialog || $[25] !== handleRemoveButtonClick || $[26] !== imageUrlBuilder2 || $[27] !== isMenuOpen || $[28] !== observeAsset || $[29] !== onSelectFiles || $[30] !== readOnly || $[31] !== schemaType || $[32] !== setHotspotButtonElement || $[33] !== setMenuButtonElement || $[34] !== setMenuOpen || $[35] !== t3 || $[36] !== value ? (t4 = /* @__PURE__ */ jsx(ImageInputAssetMenuWithReferenceAsset, { accept, assetSources, browseMenuItem, directUploads, handleOpenDialog, handleRemoveButtonClick, onSelectFiles, imageUrlBuilder: imageUrlBuilder2, isMenuOpen, observeAsset, readOnly, reference: asset, schemaType, setHotspotButtonElement, setMenuButtonElement, setMenuOpen, showAdvancedEditButton: t3, value }), $[19] = accept, $[20] = asset, $[21] = assetSources, $[22] = browseMenuItem, $[23] = directUploads, $[24] = handleOpenDialog, $[25] = handleRemoveButtonClick, $[26] = imageUrlBuilder2, $[27] = isMenuOpen, $[28] = observeAsset, $[29] = onSelectFiles, $[30] = readOnly, $[31] = schemaType, $[32] = setHotspotButtonElement, $[33] = setMenuButtonElement, $[34] = setMenuOpen, $[35] = t3, $[36] = value, $[37] = t4) : t4 = $[37], t4;
}
const ImageInputAssetMenu = memo(ImageInputAssetMenuComponent);
function ImageInputAssetMenuWithReferenceAssetComponent(props2) {
  const $ = c(47), {
    accept,
    assetSources,
    browseMenuItem,
    directUploads,
    handleOpenDialog,
    handleRemoveButtonClick,
    onSelectFiles,
    imageUrlBuilder: imageUrlBuilder2,
    isMenuOpen,
    observeAsset,
    readOnly,
    reference,
    setHotspotButtonElement,
    setMenuButtonElement,
    setMenuOpen,
    showAdvancedEditButton,
    value
  } = props2, {
    t
  } = useTranslation(), documentId = reference?._ref;
  let t0, t1;
  $[0] !== documentId || $[1] !== observeAsset ? (t1 = observeAsset(documentId), $[0] = documentId, $[1] = observeAsset, $[2] = t1) : t1 = $[2], t0 = t1;
  const asset = useObservable(t0);
  let t2;
  $[3] !== assetSources ? (t2 = assetSources.filter(_temp$1p), $[3] = assetSources, $[4] = t2) : t2 = $[4];
  const assetSourcesWithUpload = t2;
  let t3;
  $[5] !== onSelectFiles ? (t3 = (assetSource, files) => {
    onSelectFiles(assetSource, files);
  }, $[5] = onSelectFiles, $[6] = t3) : t3 = $[6];
  const handleSelectFilesFromAssetSource = t3;
  let t4;
  $[7] !== assetSourcesWithUpload[0] || $[8] !== handleSelectFilesFromAssetSource ? (t4 = (files_0) => {
    handleSelectFilesFromAssetSource(assetSourcesWithUpload[0], files_0);
  }, $[7] = assetSourcesWithUpload[0], $[8] = handleSelectFilesFromAssetSource, $[9] = t4) : t4 = $[9];
  const handleSelectFilesFromAssetSourceSingle = t4;
  if (!documentId || !asset) {
    let t52;
    return $[10] === Symbol.for("react.memo_cache_sentinel") ? (t52 = /* @__PURE__ */ jsx(ImageActionsMenuWaitPlaceholder, {}), $[10] = t52) : t52 = $[10], t52;
  }
  const {
    _id,
    originalFilename,
    extension
  } = asset;
  let copyUrl, downloadUrl;
  if (isImageSource(value)) {
    const filename = originalFilename || `download.${extension}`;
    let t52;
    $[11] !== _id || $[12] !== filename || $[13] !== imageUrlBuilder2 ? (t52 = imageUrlBuilder2.image(_id).forceDownload(filename).url(), $[11] = _id, $[12] = filename, $[13] = imageUrlBuilder2, $[14] = t52) : t52 = $[14], downloadUrl = t52;
    let t62;
    $[15] !== _id || $[16] !== imageUrlBuilder2 ? (t62 = imageUrlBuilder2.image(_id).url(), $[15] = _id, $[16] = imageUrlBuilder2, $[17] = t62) : t62 = $[17], copyUrl = t62;
  }
  let uploadMenuItem;
  bb0: switch (assetSourcesWithUpload.length) {
    case 0: {
      uploadMenuItem = null;
      break bb0;
    }
    case 1: {
      const t52 = assetSourcesWithUpload[0].name;
      let t62;
      $[18] !== t ? (t62 = t("inputs.files.common.actions-menu.upload.label"), $[18] = t, $[19] = t62) : t62 = $[19];
      const t72 = readOnly || directUploads === !1;
      let t8;
      $[20] !== accept || $[21] !== assetSourcesWithUpload[0].name || $[22] !== handleSelectFilesFromAssetSourceSingle || $[23] !== t62 || $[24] !== t72 ? (t8 = /* @__PURE__ */ jsx(FileInputMenuItem, { icon: UploadIcon, onSelect: handleSelectFilesFromAssetSourceSingle, accept, "data-asset-source-name": t52, text: t62, "data-testid": "file-input-upload-button", disabled: t72 }), $[20] = accept, $[21] = assetSourcesWithUpload[0].name, $[22] = handleSelectFilesFromAssetSourceSingle, $[23] = t62, $[24] = t72, $[25] = t8) : t8 = $[25], uploadMenuItem = t8;
      break bb0;
    }
    default: {
      let t52;
      $[26] !== accept || $[27] !== assetSourcesWithUpload || $[28] !== directUploads || $[29] !== handleSelectFilesFromAssetSource || $[30] !== readOnly ? (t52 = /* @__PURE__ */ jsx(UploadDropDownMenu, { accept, assetSources: assetSourcesWithUpload, directUploads, onSelectFiles: handleSelectFilesFromAssetSource, readOnly, renderAsMenuGroup: !0 }), $[26] = accept, $[27] = assetSourcesWithUpload, $[28] = directUploads, $[29] = handleSelectFilesFromAssetSource, $[30] = readOnly, $[31] = t52) : t52 = $[31], uploadMenuItem = t52;
    }
  }
  const t5 = !!showAdvancedEditButton;
  let t6;
  $[32] !== browseMenuItem || $[33] !== copyUrl || $[34] !== downloadUrl || $[35] !== handleRemoveButtonClick || $[36] !== readOnly || $[37] !== uploadMenuItem ? (t6 = /* @__PURE__ */ jsx(ActionsMenu, { upload: uploadMenuItem, browse: browseMenuItem, onReset: handleRemoveButtonClick, downloadUrl, copyUrl, readOnly }), $[32] = browseMenuItem, $[33] = copyUrl, $[34] = downloadUrl, $[35] = handleRemoveButtonClick, $[36] = readOnly, $[37] = uploadMenuItem, $[38] = t6) : t6 = $[38];
  let t7;
  return $[39] !== handleOpenDialog || $[40] !== isMenuOpen || $[41] !== setHotspotButtonElement || $[42] !== setMenuButtonElement || $[43] !== setMenuOpen || $[44] !== t5 || $[45] !== t6 ? (t7 = /* @__PURE__ */ jsx(ImageActionsMenu, { isMenuOpen, onEdit: handleOpenDialog, onMenuOpen: setMenuOpen, setHotspotButtonElement, setMenuButtonElement, showEdit: t5, children: t6 }), $[39] = handleOpenDialog, $[40] = isMenuOpen, $[41] = setHotspotButtonElement, $[42] = setMenuButtonElement, $[43] = setMenuOpen, $[44] = t5, $[45] = t6, $[46] = t7) : t7 = $[46], t7;
}
function _temp$1p(s) {
  return !!s.uploader;
}
const ImageInputAssetMenuWithReferenceAsset = memo(ImageInputAssetMenuWithReferenceAssetComponent);
function ImageInputAssetSourceComponent(props2) {
  const $ = c(23), {
    handleAssetSourceClosed,
    handleSelectAssetFromSource: handleSelectAssetFromSource2,
    isUploading,
    observeAsset,
    schemaType,
    selectedAssetSource,
    value
  } = props2;
  let t0, t1;
  $[0] !== schemaType ? (t1 = get(schemaType, "options.accept", "image/*"), $[0] = schemaType, $[1] = t1) : t1 = $[1], t0 = t1;
  const accept = t0;
  if (!selectedAssetSource)
    return null;
  const {
    component: Component2
  } = selectedAssetSource;
  if (value && value.asset) {
    let t22;
    $[2] !== Component2 || $[3] !== accept || $[4] !== handleAssetSourceClosed || $[5] !== handleSelectAssetFromSource2 || $[6] !== isUploading || $[7] !== schemaType || $[8] !== selectedAssetSource ? (t22 = (imageAsset) => /* @__PURE__ */ jsx(Component2, { accept, action: isUploading ? "upload" : "select", assetSource: selectedAssetSource, assetType: "image", onClose: handleAssetSourceClosed, onSelect: handleSelectAssetFromSource2, schemaType, selectedAssets: [imageAsset], selectionType: "single" }), $[2] = Component2, $[3] = accept, $[4] = handleAssetSourceClosed, $[5] = handleSelectAssetFromSource2, $[6] = isUploading, $[7] = schemaType, $[8] = selectedAssetSource, $[9] = t22) : t22 = $[9];
    let t32;
    return $[10] !== observeAsset || $[11] !== t22 || $[12] !== value.asset ? (t32 = /* @__PURE__ */ jsx(WithReferencedAsset, { observeAsset, reference: value.asset, children: t22 }), $[10] = observeAsset, $[11] = t22, $[12] = value.asset, $[13] = t32) : t32 = $[13], t32;
  }
  const t2 = isUploading ? "upload" : "select";
  let t3;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t3 = [], $[14] = t3) : t3 = $[14];
  let t4;
  return $[15] !== Component2 || $[16] !== accept || $[17] !== handleAssetSourceClosed || $[18] !== handleSelectAssetFromSource2 || $[19] !== schemaType || $[20] !== selectedAssetSource || $[21] !== t2 ? (t4 = /* @__PURE__ */ jsx(Component2, { accept, action: t2, assetSource: selectedAssetSource, assetType: "image", onClose: handleAssetSourceClosed, onSelect: handleSelectAssetFromSource2, schemaType, selectedAssets: t3, selectionType: "single" }), $[15] = Component2, $[16] = accept, $[17] = handleAssetSourceClosed, $[18] = handleSelectAssetFromSource2, $[19] = schemaType, $[20] = selectedAssetSource, $[21] = t2, $[22] = t4) : t4 = $[22], t4;
}
const ImageInputAssetSource = memo(ImageInputAssetSourceComponent), ASSET_IMAGE_MENU_POPOVER = {
  portal: !0
};
function ImageInputBrowserComponent(props2, forwardedRef) {
  const $ = c(32), {
    assetSources,
    readOnly,
    id: id2,
    setMenuOpen,
    handleSelectImageFromAssetSource,
    schemaType
  } = props2, sourcesFromSchema = schemaType.options?.sources, {
    t
  } = useTranslation();
  if (sourcesFromSchema?.length === 0 || assetSources && assetSources.length === 0)
    return null;
  if (assetSources && assetSources.length > 1 && !readOnly) {
    const t02 = `${id2}_assetImageButton`;
    let t12;
    $[0] !== t ? (t12 = t("inputs.image.browse-menu.text"), $[0] = t, $[1] = t12) : t12 = $[1];
    let t22;
    $[2] !== t12 ? (t22 = /* @__PURE__ */ jsx(Button, { "data-testid": "file-input-multi-browse-button", icon: SearchIcon, iconRight: ChevronDownIcon, mode: "bleed", text: t12 }), $[2] = t12, $[3] = t22) : t22 = $[3];
    let t3;
    if ($[4] !== assetSources || $[5] !== handleSelectImageFromAssetSource || $[6] !== readOnly || $[7] !== setMenuOpen || $[8] !== t) {
      let t42;
      $[10] !== handleSelectImageFromAssetSource || $[11] !== readOnly || $[12] !== setMenuOpen || $[13] !== t ? (t42 = (assetSource) => /* @__PURE__ */ jsx(MenuItem$1, { text: (assetSource.i18nKey ? t(assetSource.i18nKey) : assetSource.title) || startCase(assetSource.name), onClick: () => {
        setMenuOpen(!1), handleSelectImageFromAssetSource(assetSource);
      }, icon: assetSource.icon || ImageIcon, disabled: readOnly, "data-testid": `file-input-browse-button-${assetSource.name}` }, assetSource.name), $[10] = handleSelectImageFromAssetSource, $[11] = readOnly, $[12] = setMenuOpen, $[13] = t, $[14] = t42) : t42 = $[14], t3 = assetSources.map(t42), $[4] = assetSources, $[5] = handleSelectImageFromAssetSource, $[6] = readOnly, $[7] = setMenuOpen, $[8] = t, $[9] = t3;
    } else
      t3 = $[9];
    let t4;
    $[15] !== t3 ? (t4 = /* @__PURE__ */ jsx(Menu, { children: t3 }), $[15] = t3, $[16] = t4) : t4 = $[16];
    let t5;
    return $[17] !== forwardedRef || $[18] !== t02 || $[19] !== t22 || $[20] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuButton$1, { id: t02, ref: forwardedRef, button: t22, menu: t4, popover: ASSET_IMAGE_MENU_POPOVER }), $[17] = forwardedRef, $[18] = t02, $[19] = t22, $[20] = t4, $[21] = t5) : t5 = $[21], t5;
  }
  let t0;
  $[22] !== t ? (t0 = t("inputs.image.browse-menu.text"), $[22] = t, $[23] = t0) : t0 = $[23];
  let t1;
  $[24] !== assetSources[0] || $[25] !== handleSelectImageFromAssetSource || $[26] !== setMenuOpen ? (t1 = () => {
    setMenuOpen(!1), handleSelectImageFromAssetSource(assetSources[0]);
  }, $[24] = assetSources[0], $[25] = handleSelectImageFromAssetSource, $[26] = setMenuOpen, $[27] = t1) : t1 = $[27];
  let t2;
  return $[28] !== readOnly || $[29] !== t0 || $[30] !== t1 ? (t2 = /* @__PURE__ */ jsx(Button, { text: t0, icon: SearchIcon, mode: "bleed", onClick: t1, "data-testid": "file-input-browse-button", disabled: readOnly }), $[28] = readOnly, $[29] = t0, $[30] = t1, $[31] = t2) : t2 = $[31], t2;
}
const ImageInputBrowser = memo(forwardRef(ImageInputBrowserComponent)), RatioBox = styled(Box)`
  position: relative;
  padding-bottom: calc(${({
  ratio = 3 / 2
}) => 1 / ratio} * 100%);

  & > div {
    position: absolute;
    top: ${({
  padding = 0
}) => padding}px;
    left: ${({
  padding = 0
}) => padding}px;
    right: ${({
  padding = 0
}) => padding}px;
    bottom: ${({
  padding = 0
}) => padding}px;
  }
`, DEFAULT_HOTSPOT = {
  x: 0.5,
  y: 0.5,
  height: 1,
  width: 1
}, DEFAULT_CROP = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
}, HANDLE_VISUAL_SIZE_HOTSPOT = 16, HANDLE_VISUAL_SIZE_CROP = 8, HANDLE_INTERACTIVE_SIZE = 24, MARGIN_SIZE = HANDLE_INTERACTIVE_SIZE / 2, MIN_CROP_SIZE = 0.05, KEYBOARD_MOVEMENT_STEP = 5e-3, KEYBOARD_RESIZE_STEP = 5e-3, KEYBOARD_SHIFT_MULTIPLIER = 5, KEYBOARD_CHANGE_SAVE_DEBOUNCE_MS = 300;
function calculateStyles(options = {}) {
  const imageAspect = readAspectRatio(options.image) || 1, hotspot = options.hotspot || DEFAULT_HOTSPOT, crop = options.crop || DEFAULT_CROP, containerAspect = readAspectRatio(options.container) || imageAspect * readCropAspect(crop), align2 = options.align || {
    x: "center",
    y: "center"
  }, result = calculateHotSpotCrop(imageAspect, {
    hotspot,
    crop
  }, {
    aspect: containerAspect,
    align: align2
  }), containerHeight = styleFormat(round(100 / containerAspect));
  return {
    debug: {
      result
    },
    container: {
      //outline: '1px solid cyan',
      overflow: "hidden",
      position: "relative",
      width: "100%",
      height: containerHeight
    },
    padding: {
      marginTop: containerHeight
    },
    crop: {
      position: "absolute",
      overflow: "hidden",
      height: toStylePercentage(result.crop.height),
      width: toStylePercentage(result.crop.width),
      top: toStylePercentage(result.crop.top),
      left: toStylePercentage(result.crop.left)
    },
    image: {
      position: "absolute",
      height: toStylePercentage(result.image.height),
      width: toStylePercentage(result.image.width),
      top: toStylePercentage(result.image.top),
      left: toStylePercentage(result.image.left)
    }
  };
}
function readAspectRatio(opts) {
  if (!opts)
    return null;
  if ("aspectRatio" in opts)
    return opts.aspectRatio;
  if ("height" in opts || "width" in opts) {
    if (typeof opts.height != "number" && typeof opts.width != "number")
      throw new Error(`Height and width must be numbers, got ${JSON.stringify(opts)}`);
    return opts.width / opts.height;
  }
  return null;
}
function round(num, decimals = 2) {
  const multiplier = Math.pow(10, decimals);
  return Math.round(num * multiplier) / multiplier;
}
function calculateHotSpotCrop(sourceAspect, descriptor, spec) {
  const crop = descriptor.crop, viewportAspect = spec.aspect, alignment = spec.align, netWidth = 1 - crop.left - crop.right, netHeight = 1 - crop.top - crop.bottom, outImg = {
    top: -crop.top / netHeight,
    left: -crop.left / netWidth,
    width: 1 / netWidth,
    height: 1 / netHeight
  }, cropAspect = netWidth / netHeight * sourceAspect, hotspot = {
    x: (descriptor.hotspot.x - crop.left) / netWidth,
    y: (descriptor.hotspot.y - crop.top) / netHeight,
    height: descriptor.hotspot.height / netHeight,
    width: descriptor.hotspot.width / netWidth
  }, maxHotspotXScale = 1 / hotspot.width, maxHotspotYScale = 1 / hotspot.height * cropAspect / viewportAspect, maxScale = Math.min(maxHotspotXScale, maxHotspotYScale);
  let minFullBleedScale;
  const cropIsTaller = cropAspect <= viewportAspect;
  cropIsTaller ? minFullBleedScale = 1 : minFullBleedScale = cropAspect / viewportAspect;
  let method, outCrop;
  if (minFullBleedScale > maxScale) {
    method = "letterbox";
    let letterboxScale;
    const diff = minFullBleedScale - maxScale;
    cropIsTaller ? letterboxScale = 1 - diff : letterboxScale = maxScale, outCrop = {
      width: letterboxScale,
      height: letterboxScale / cropAspect * viewportAspect,
      // Gets overwritten further down
      left: 0,
      top: 0
    };
    const hotspotLeft = hotspot.x * outCrop.width - hotspot.width * outCrop.width / 2;
    switch (alignment.x) {
      case "left":
        outCrop.left = cropIsTaller ? 0 : -hotspotLeft;
        break;
      case "right":
        outCrop.left = cropIsTaller ? 1 - outCrop.width : hotspotLeft;
        break;
      case "center":
        outCrop.left = cropIsTaller ? (1 - outCrop.width) / 2 : -hotspotLeft;
        break;
      default:
        throw new Error(`Invalid x alignment: '${alignment.x}'. Must be either 'left', 'right' or 'center'`);
    }
    const hotspotTop = hotspot.y * outCrop.height - hotspot.height * outCrop.height / 2;
    switch (alignment.y) {
      case "top":
        outCrop.top = cropIsTaller ? -hotspotTop : 0;
        break;
      case "bottom":
        outCrop.top = hotspotTop;
        break;
      case "center":
        outCrop.top = cropIsTaller ? -hotspotTop : (1 - outCrop.height) / 2;
        break;
      default:
        throw new Error(`Invalid y alignment: '${alignment.y}'. Must be either 'top', 'bottom' or 'center'`);
    }
  } else if (cropIsTaller) {
    method = "full_width";
    let top = -hotspot.y / cropAspect * viewportAspect + 0.5;
    const height = minFullBleedScale / cropAspect * viewportAspect;
    top > 0 ? top = 0 : -top > height - 1 && (top = -(height - 1)), outCrop = {
      width: minFullBleedScale,
      height,
      left: 0,
      // Place the Y center of the hotspot near the center of the viewport
      top
    };
  } else {
    method = "full_height";
    const width = minFullBleedScale;
    let left = 0.5 - hotspot.x * minFullBleedScale;
    left > 0 ? left = 0 : -left > width - 1 && (left = -(width - 1)), outCrop = {
      width,
      height: minFullBleedScale / cropAspect * viewportAspect,
      top: 0,
      // Place the X center of the hotspot at the center of the viewport
      left
    };
  }
  return {
    method,
    crop: outCrop,
    image: outImg
  };
}
function readCropAspect(crop) {
  const height = 1 - crop.top - crop.bottom;
  return (1 - crop.left - crop.right) / height;
}
function styleFormat(num) {
  return num === 0 ? 0 : `${num}%`;
}
function toStylePercentage(num) {
  return styleFormat(round(num * 100));
}
const HotspotImageContainer = styled.div`
  position: relative;
  width: 100%;
`, debug$3 = debug$7("sanity-imagetool");
function getCropAspect(crop, srcAspect) {
  const origHeight = 1 / srcAspect, origWidth = srcAspect * origHeight, cropWidth = origWidth - (crop.left + crop.right) * origWidth, cropHeight = origHeight - (crop.top + crop.bottom) * origHeight;
  return cropWidth / cropHeight;
}
const HotspotImage = memo(function(props2) {
  const $ = c(36), {
    alignX: t0,
    alignY: t1,
    alt,
    aspectRatio: t2,
    className: t3,
    crop: t4,
    hotspot: t5,
    onError,
    onLoad,
    src,
    srcAspectRatio,
    srcSet,
    style
  } = props2, alignX = t0 === void 0 ? "center" : t0, alignY = t1 === void 0 ? "center" : t1, aspectRatio = t2 === void 0 ? "none" : t2, className = t3 === void 0 ? "" : t3, crop = t4 === void 0 ? DEFAULT_CROP : t4, hotspot = t5 === void 0 ? DEFAULT_HOTSPOT : t5, [containerAspect, setContainerAspect] = useState(null), containerElementRef = useRef(null), imageElementRef = useRef(null);
  let t6;
  $[0] !== aspectRatio ? (t6 = () => {
    if (containerElementRef.current)
      if (aspectRatio === "auto") {
        const parentNode = containerElementRef.current.parentNode;
        startTransition(() => setContainerAspect(parentNode.offsetWidth / parentNode.offsetHeight));
      } else
        setContainerAspect(null);
  }, $[0] = aspectRatio, $[1] = t6) : t6 = $[1];
  const updateContainerAspect = t6;
  let t7, t8;
  $[2] !== src || $[3] !== updateContainerAspect ? (t7 = () => {
    const imageElement = imageElementRef.current;
    return imageElement && imageElement.src && imageElement.complete && imageElement.naturalWidth !== void 0 && (debug$3("Image '%s' already loaded, refreshing (from cache) to trigger onLoad / onError", src), imageElement.src = imageElement.src), updateContainerAspect(), window.addEventListener("resize", updateContainerAspect), () => {
      window.removeEventListener("resize", updateContainerAspect);
    };
  }, t8 = [src, updateContainerAspect], $[2] = src, $[3] = updateContainerAspect, $[4] = t7, $[5] = t8) : (t7 = $[4], t8 = $[5]), useEffect(t7, t8);
  let t9;
  bb0: {
    if (aspectRatio === "none") {
      let t102;
      $[6] !== crop || $[7] !== srcAspectRatio ? (t102 = crop ? getCropAspect(crop, srcAspectRatio) : srcAspectRatio, $[6] = crop, $[7] = srcAspectRatio, $[8] = t102) : t102 = $[8], t9 = t102;
      break bb0;
    }
    if (aspectRatio === "auto") {
      t9 = containerAspect;
      break bb0;
    }
    t9 = aspectRatio || null;
  }
  const targetAspect = t9;
  let t10;
  const t11 = targetAspect || srcAspectRatio;
  let t12;
  $[9] !== alignX || $[10] !== alignY || $[11] !== crop || $[12] !== hotspot || $[13] !== srcAspectRatio || $[14] !== t11 ? (t12 = calculateStyles({
    container: {
      aspectRatio: t11
    },
    image: {
      aspectRatio: srcAspectRatio
    },
    hotspot,
    crop,
    align: {
      x: alignX,
      y: alignY
    }
  }), $[9] = alignX, $[10] = alignY, $[11] = crop, $[12] = hotspot, $[13] = srcAspectRatio, $[14] = t11, $[15] = t12) : t12 = $[15], t10 = t12;
  const targetStyles = t10, t13 = `${className}`;
  let t14;
  $[16] !== targetStyles.padding ? (t14 = /* @__PURE__ */ jsx("div", { style: targetStyles.padding }), $[16] = targetStyles.padding, $[17] = t14) : t14 = $[17];
  let t15;
  $[18] !== alt || $[19] !== onError || $[20] !== onLoad || $[21] !== src || $[22] !== srcSet || $[23] !== targetStyles.image ? (t15 = /* @__PURE__ */ jsx("img", { ref: imageElementRef, src, alt, srcSet, onLoad, onError, style: targetStyles.image }), $[18] = alt, $[19] = onError, $[20] = onLoad, $[21] = src, $[22] = srcSet, $[23] = targetStyles.image, $[24] = t15) : t15 = $[24];
  let t16;
  $[25] !== t15 || $[26] !== targetStyles.crop ? (t16 = /* @__PURE__ */ jsx("div", { style: targetStyles.crop, children: t15 }), $[25] = t15, $[26] = targetStyles.crop, $[27] = t16) : t16 = $[27];
  let t17;
  $[28] !== t14 || $[29] !== t16 || $[30] !== targetStyles.container ? (t17 = /* @__PURE__ */ jsxs("div", { style: targetStyles.container, children: [
    t14,
    t16
  ] }), $[28] = t14, $[29] = t16, $[30] = targetStyles.container, $[31] = t17) : t17 = $[31];
  let t18;
  return $[32] !== style || $[33] !== t13 || $[34] !== t17 ? (t18 = /* @__PURE__ */ jsx(HotspotImageContainer, { className: t13, style, ref: containerElementRef, children: t17 }), $[32] = style, $[33] = t13, $[34] = t17, $[35] = t18) : t18 = $[35], t18;
});
function ImageLoader(props2) {
  const $ = c(8), {
    src,
    children
  } = props2, [isLoading, setIsLoading] = useState(!0), [image, setImage] = useState(null), [error, setError] = useState(null);
  let t0, t1;
  $[0] !== src ? (t0 = () => {
    setImage(null), setError(null), setIsLoading(!0);
    const image_0 = new Image();
    image_0.onload = () => {
      setImage(image_0), setError(null), setIsLoading(!1);
    }, image_0.onerror = () => {
      setError(new Error(`Could not load image from ${JSON.stringify(src)}`)), setIsLoading(!1);
    }, image_0.referrerPolicy = "strict-origin-when-cross-origin", image_0.src = src;
  }, t1 = [src], $[0] = src, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== children || $[4] !== error || $[5] !== image || $[6] !== isLoading ? (t2 = children({
    image,
    error,
    isLoading
  }), $[3] = children, $[4] = error, $[5] = image, $[6] = isLoading, $[7] = t2) : t2 = $[7], t2;
}
function ResizeSVG(props2) {
  const {
    image,
    maxHeight,
    maxWidth,
    children
  } = props2, ratio = image.width / image.height, landscape = image.width > image.height, targetSize = {
    width: landscape ? maxWidth : maxHeight * ratio,
    height: landscape ? maxWidth / ratio : maxHeight
  };
  return targetSize.width > maxWidth && (targetSize.width = maxWidth, targetSize.height = maxWidth / ratio), targetSize.height > maxHeight && (targetSize.height = maxHeight, targetSize.width = maxHeight * ratio), children(targetSize);
}
const getRectCenterX = (rect) => rect.left + rect.width / 2, getRectCenterY = (rect) => rect.top + rect.height / 2, getRectRight = (rect) => rect.left + rect.width, getRectBottom = (rect) => rect.top + rect.height, getCropDimensions = (crop) => ({
  width: 1 - crop.left - crop.right,
  height: 1 - crop.top - crop.bottom,
  left: crop.left,
  right: 1 - crop.right,
  top: crop.top,
  bottom: 1 - crop.bottom
}), getPointerPosition = (e, svg, size) => {
  const rect = svg.getBoundingClientRect();
  return {
    x: (e.clientX - rect.left) / rect.width * size.width,
    y: (e.clientY - rect.top) / rect.height * size.height
  };
}, calculateDelta = (initialPos, currentPos, rect) => ({
  x: (currentPos.x - initialPos.x) / rect.width,
  y: (currentPos.y - initialPos.y) / rect.height
}), constrainHotspotToCrop = (hotspot, crop) => {
  const cropDimensions = getCropDimensions(crop), adjustedWidth = Math.min(hotspot.width, cropDimensions.width), adjustedHeight = Math.min(hotspot.height, cropDimensions.height), minX = cropDimensions.left + adjustedWidth / 2, maxX = cropDimensions.right - adjustedWidth / 2, minY = cropDimensions.top + adjustedHeight / 2, maxY = cropDimensions.bottom - adjustedHeight / 2;
  return {
    x: Math.min(Math.max(hotspot.x, minX), maxX),
    y: Math.min(Math.max(hotspot.y, minY), maxY),
    width: adjustedWidth,
    height: adjustedHeight
  };
}, applyHotspotMoveBy = (value, delta) => {
  const {
    x,
    y,
    width,
    height
  } = value.hotspot || DEFAULT_HOTSPOT, crop = value.crop || DEFAULT_CROP;
  return constrainHotspotToCrop({
    x: x + delta.x,
    y: y + delta.y,
    width,
    height
  }, crop);
}, handleHotspotMove = (value, initialPosition, pointerPos, innerRect) => {
  const delta = calculateDelta(initialPosition, pointerPos, innerRect);
  return {
    crop: value.crop || DEFAULT_CROP,
    hotspot: applyHotspotMoveBy(value, delta)
  };
}, handleHotspotResize = (params) => {
  const {
    initialHotspot,
    crop,
    initialCursor,
    pointerPos,
    innerRect
  } = params, dimensions = getCropDimensions(crop), netWidth = dimensions.width, netHeight = dimensions.height, cropLeft = dimensions.left, cropRight = dimensions.right, cropTop = dimensions.top, cropBottom = dimensions.bottom, deltaX = pointerPos.x - initialCursor.x, deltaY = pointerPos.y - initialCursor.y, factorX = deltaX, factorY = deltaY, initialWidthPx = initialHotspot.width * innerRect.width, initialHeightPx = initialHotspot.height * innerRect.height, newWidthPx = initialWidthPx + factorX * 2, newHeightPx = initialHeightPx + factorY * 2;
  let newWidth = newWidthPx / innerRect.width, newHeight = newHeightPx / innerRect.height;
  newWidth = Math.max(0, newWidth), newHeight = Math.max(0, newHeight), newWidth = Math.min(newWidth, netWidth), newHeight = Math.min(newHeight, netHeight);
  let newX = initialHotspot.x, newY = initialHotspot.y;
  const minX = cropLeft + newWidth / 2, maxX = cropRight - newWidth / 2;
  newX < minX ? newX = minX : newX > maxX && (newX = maxX);
  const minY = cropTop + newHeight / 2, maxY = cropBottom - newHeight / 2;
  newY < minY ? newY = minY : newY > maxY && (newY = maxY);
  const newHotspot = {
    ...initialHotspot,
    x: newX,
    y: newY,
    width: newWidth,
    height: newHeight
  };
  return {
    crop,
    hotspot: newHotspot
  };
}, handleCropMove = (params) => {
  const {
    initialCrop,
    initialHotspot,
    initialCursor,
    pointerPos,
    innerRect
  } = params, delta = calculateDelta(initialCursor, pointerPos, innerRect), {
    top: initialTop,
    right: initialRight,
    bottom: initialBottom,
    left: initialLeft
  } = initialCrop;
  let newLeft = initialLeft + delta.x, newRight = initialRight - delta.x, newTop = initialTop + delta.y, newBottom = initialBottom - delta.y;
  const dimensions = getCropDimensions(initialCrop), netWidth = dimensions.width, netHeight = dimensions.height;
  newLeft < 0 ? (newLeft = 0, newRight = 1 - netWidth) : newRight < 0 ? (newRight = 0, newLeft = 1 - netWidth) : newLeft + newRight > 1 && (delta.x > 0 ? (newLeft = 1 - netWidth, newRight = 0) : (newLeft = 0, newRight = 1 - netWidth)), newTop < 0 ? (newTop = 0, newBottom = 1 - netHeight) : newBottom < 0 ? (newBottom = 0, newTop = 1 - netHeight) : newTop + newBottom > 1 && (delta.y > 0 ? (newTop = 1 - netHeight, newBottom = 0) : (newTop = 0, newBottom = 1 - netHeight));
  const newCrop = {
    top: newTop,
    right: newRight,
    bottom: newBottom,
    left: newLeft
  }, initialCropCenterX = 0.5 - (initialLeft + initialRight) / 2, initialCropCenterY = 0.5 - (initialTop + initialBottom) / 2, newCropCenterX = 0.5 - (newLeft + newRight) / 2, newCropCenterY = 0.5 - (newTop + newBottom) / 2, cropCenterDeltaX = newCropCenterX - initialCropCenterX, cropCenterDeltaY = newCropCenterY - initialCropCenterY, newHotspot = {
    ...initialHotspot,
    x: initialHotspot.x + cropCenterDeltaX,
    y: initialHotspot.y + cropCenterDeltaY
  }, adjustedHotspot = constrainHotspotToCrop(newHotspot, newCrop);
  return {
    crop: newCrop,
    hotspot: adjustedHotspot
  };
}, handleCropHandleResize = (params) => {
  const {
    initialCrop,
    initialHotspot,
    initialCursor,
    pointerPos,
    innerRect,
    activeHandle
  } = params, handlePosition = activeHandle.startsWith("crop-") ? activeHandle.slice(5) : "", delta = calculateDelta(initialCursor, pointerPos, innerRect);
  let {
    left,
    right,
    top,
    bottom: bottom2
  } = initialCrop;
  const minLeft = 0, minTop = 0;
  switch (handlePosition) {
    case "left":
      left = Math.min(Math.max(initialCrop.left + delta.x, minLeft), 1 - initialCrop.right - MIN_CROP_SIZE);
      break;
    case "right":
      right = Math.min(Math.max(initialCrop.right - delta.x, minLeft), 1 - initialCrop.left - MIN_CROP_SIZE);
      break;
    case "top":
      top = Math.min(Math.max(initialCrop.top + delta.y, minTop), 1 - initialCrop.bottom - MIN_CROP_SIZE);
      break;
    case "bottom":
      bottom2 = Math.min(Math.max(initialCrop.bottom - delta.y, minTop), 1 - initialCrop.top - MIN_CROP_SIZE);
      break;
    case "topLeft":
      left = Math.min(Math.max(initialCrop.left + delta.x, minLeft), 1 - initialCrop.right - MIN_CROP_SIZE), top = Math.min(Math.max(initialCrop.top + delta.y, minTop), 1 - initialCrop.bottom - MIN_CROP_SIZE);
      break;
    case "topRight":
      right = Math.min(Math.max(initialCrop.right - delta.x, minLeft), 1 - initialCrop.left - MIN_CROP_SIZE), top = Math.min(Math.max(initialCrop.top + delta.y, minTop), 1 - initialCrop.bottom - MIN_CROP_SIZE);
      break;
    case "bottomLeft":
      left = Math.min(Math.max(initialCrop.left + delta.x, minLeft), 1 - initialCrop.right - MIN_CROP_SIZE), bottom2 = Math.min(Math.max(initialCrop.bottom - delta.y, minTop), 1 - initialCrop.top - MIN_CROP_SIZE);
      break;
    case "bottomRight":
      right = Math.min(Math.max(initialCrop.right - delta.x, minLeft), 1 - initialCrop.left - MIN_CROP_SIZE), bottom2 = Math.min(Math.max(initialCrop.bottom - delta.y, minTop), 1 - initialCrop.top - MIN_CROP_SIZE);
      break;
  }
  const newCrop = {
    left,
    right,
    top,
    bottom: bottom2
  }, newHotspot = constrainHotspotToCrop(initialHotspot, newCrop);
  return {
    crop: newCrop,
    hotspot: newHotspot
  };
}, HANDLE_CURSOR_MAP = {
  "crop-top": "ns-resize",
  "crop-bottom": "ns-resize",
  "crop-left": "ew-resize",
  "crop-right": "ew-resize",
  "crop-topRight": "nesw-resize",
  "crop-bottomLeft": "nesw-resize",
  "crop-topLeft": "nwse-resize",
  "crop-bottomRight": "nwse-resize"
}, calculateCurrentCursor = (dragTarget, activeHandle, hoverTarget) => dragTarget === "crop" || dragTarget === "hotspot" ? "grabbing" : dragTarget === "hotspotHandle" ? "move" : dragTarget === "cropHandle" && activeHandle ? HANDLE_CURSOR_MAP[activeHandle] || "move" : hoverTarget ? hoverTarget === "crop" || hoverTarget === "hotspot" ? "grab" : hoverTarget === "hotspotHandle" ? "move" : typeof hoverTarget == "string" && hoverTarget in HANDLE_CURSOR_MAP ? HANDLE_CURSOR_MAP[hoverTarget] : "default" : "default", getHotspotHandlePosition = (hotspotRect) => {
  const angle = Math.PI * 0.25, rx = hotspotRect.width / 2, ry = hotspotRect.height / 2;
  return {
    x: getRectCenterX(hotspotRect) + Math.cos(angle) * rx,
    y: getRectCenterY(hotspotRect) + Math.sin(angle) * ry
  };
}, HANDLE_TEMPLATES = {
  CORNER_PATH: (size) => {
    const half = size / 2;
    return `M ${-half} ${size * 1.5} 
            L ${-half} ${-half} 
            L ${size * 1.5} ${-half} 
            L ${size * 1.5} ${half} 
            L ${half} ${half} 
            L ${half} ${size * 1.5} 
            Z`;
  },
  EDGE_DIMENSIONS: {
    top: (size) => ({
      width: size * 2,
      height: size
    }),
    right: (size) => ({
      width: size,
      height: size * 2
    }),
    bottom: (size) => ({
      width: size * 2,
      height: size
    }),
    left: (size) => ({
      width: size,
      height: size * 2
    })
  }
}, HANDLE_PATHS = {
  cornerPath: HANDLE_TEMPLATES.CORNER_PATH(HANDLE_VISUAL_SIZE_CROP),
  edgeDimensions: {
    top: HANDLE_TEMPLATES.EDGE_DIMENSIONS.top(HANDLE_VISUAL_SIZE_CROP),
    right: HANDLE_TEMPLATES.EDGE_DIMENSIONS.right(HANDLE_VISUAL_SIZE_CROP),
    bottom: HANDLE_TEMPLATES.EDGE_DIMENSIONS.bottom(HANDLE_VISUAL_SIZE_CROP),
    left: HANDLE_TEMPLATES.EDGE_DIMENSIONS.left(HANDLE_VISUAL_SIZE_CROP)
  }
}, calculateCropHandles = (cropRect) => {
  const hitAreaSize = HANDLE_INTERACTIVE_SIZE, halfHitAreaSize = hitAreaSize / 2, edgeHitWidth = HANDLE_INTERACTIVE_SIZE, positions = {
    top: {
      x: cropRect.left + cropRect.width / 2,
      y: cropRect.top
    },
    right: {
      x: getRectRight(cropRect),
      y: cropRect.top + cropRect.height / 2
    },
    bottom: {
      x: cropRect.left + cropRect.width / 2,
      y: getRectBottom(cropRect)
    },
    left: {
      x: cropRect.left,
      y: cropRect.top + cropRect.height / 2
    },
    topLeft: {
      x: cropRect.left,
      y: cropRect.top
    },
    topRight: {
      x: getRectRight(cropRect),
      y: cropRect.top
    },
    bottomLeft: {
      x: cropRect.left,
      y: getRectBottom(cropRect)
    },
    bottomRight: {
      x: getRectRight(cropRect),
      y: getRectBottom(cropRect)
    }
  }, rotations = {
    topLeft: 0,
    topRight: 90,
    bottomRight: 180,
    bottomLeft: 270
  }, result = {};
  for (const edge of ["top", "right", "bottom", "left"]) {
    const dims = HANDLE_PATHS.edgeDimensions[edge], pos = positions[edge];
    result[edge] = {
      visual: {
        left: pos.x - dims.width / 2,
        top: pos.y - dims.height / 2,
        width: dims.width,
        height: dims.height
      },
      hit: {
        left: edge === "left" || edge === "right" ? pos.x - edgeHitWidth / 2 : pos.x - HANDLE_INTERACTIVE_SIZE / 2,
        top: edge === "top" || edge === "bottom" ? pos.y - edgeHitWidth / 2 : pos.y - HANDLE_INTERACTIVE_SIZE / 2,
        width: edge === "left" || edge === "right" ? edgeHitWidth : HANDLE_INTERACTIVE_SIZE,
        height: edge === "top" || edge === "bottom" ? edgeHitWidth : HANDLE_INTERACTIVE_SIZE
      }
    };
  }
  for (const corner of ["topLeft", "topRight", "bottomLeft", "bottomRight"]) {
    const pos = positions[corner];
    result[corner] = {
      visual: {
        left: pos.x - HANDLE_INTERACTIVE_SIZE,
        top: pos.y - HANDLE_INTERACTIVE_SIZE,
        width: HANDLE_INTERACTIVE_SIZE * 2,
        height: HANDLE_INTERACTIVE_SIZE * 2
      },
      hit: {
        left: pos.x - halfHitAreaSize,
        top: pos.y - halfHitAreaSize,
        width: hitAreaSize,
        height: hitAreaSize
      },
      path: HANDLE_PATHS.cornerPath,
      position: pos,
      rotation: rotations[corner]
    };
  }
  return result;
};
function useHoverHandlers() {
  const $ = c(8), [hoverTarget, setHoverTarget] = useState(null);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = (target) => {
    setHoverTarget(target);
  }, $[0] = t0) : t0 = $[0];
  const handleMouseEnter = t0;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setHoverTarget(null);
  }, $[1] = t1) : t1 = $[1];
  const handleMouseLeave = t1;
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => handleMouseEnter("hotspot"), $[2] = t2) : t2 = $[2];
  const handleHotspotMouseEnter = t2;
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => handleMouseEnter("hotspotHandle"), $[3] = t3) : t3 = $[3];
  const handleHotspotHandleMouseEnter = t3;
  let t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => handleMouseEnter("crop"), $[4] = t4) : t4 = $[4];
  const handleCropMouseEnter = t4;
  let t5;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (key) => () => handleMouseEnter(`crop-${key}`), $[5] = t5) : t5 = $[5];
  const getCropHandleMouseEnter = t5;
  let t6;
  return $[6] !== hoverTarget ? (t6 = {
    hoverTarget,
    handleMouseEnter,
    handleMouseLeave,
    handleHotspotMouseEnter,
    handleHotspotHandleMouseEnter,
    handleCropMouseEnter,
    getCropHandleMouseEnter
  }, $[6] = hoverTarget, $[7] = t6) : t6 = $[7], t6;
}
function useKeyboardControls(t0) {
  const $ = c(20), {
    value,
    onChange,
    onChangeEnd,
    innerRect,
    focusTarget,
    readOnly
  } = t0, initialCropRef = useRef(null), initialHotspotRef = useRef(null), initialCursorRef = useRef(null), changeEndTimeoutRef = useRef(null);
  let t1;
  $[0] !== onChangeEnd || $[1] !== value ? (t1 = () => {
    (initialCropRef.current || initialHotspotRef.current) && (onChangeEnd({
      crop: value.crop || DEFAULT_CROP,
      hotspot: value.hotspot || DEFAULT_HOTSPOT
    }), initialCropRef.current = null, initialHotspotRef.current = null, initialCursorRef.current = null);
  }, $[0] = onChangeEnd, $[1] = value, $[2] = t1) : t1 = $[2];
  const triggerChangeEnd = t1;
  let t2;
  $[3] !== innerRect ? (t2 = (params) => {
    const {
      e,
      crop,
      hotspot,
      isCtrlOrCmdPressed,
      step,
      resizeStep
    } = params;
    let newValue;
    if (isCtrlOrCmdPressed) {
      const pointerPos = {
        x: initialCursorRef.current.x,
        y: initialCursorRef.current.y
      };
      bb19: switch (e.key) {
        case "ArrowUp": {
          pointerPos.y = pointerPos.y - innerRect.height * resizeStep;
          break bb19;
        }
        case "ArrowDown": {
          pointerPos.y = pointerPos.y + innerRect.height * resizeStep;
          break bb19;
        }
        case "ArrowLeft": {
          pointerPos.x = pointerPos.x - innerRect.width * resizeStep;
          break bb19;
        }
        case "ArrowRight": {
          pointerPos.x = pointerPos.x + innerRect.width * resizeStep;
          break bb19;
        }
        default:
          return null;
      }
      newValue = handleHotspotResize({
        initialHotspot: hotspot,
        crop,
        initialCursor: initialCursorRef.current,
        pointerPos,
        innerRect
      });
    } else {
      const delta = {
        x: 0,
        y: 0
      };
      bb31: switch (e.key) {
        case "ArrowUp": {
          delta.y = -step;
          break bb31;
        }
        case "ArrowDown": {
          delta.y = step;
          break bb31;
        }
        case "ArrowLeft": {
          delta.x = -step;
          break bb31;
        }
        case "ArrowRight": {
          delta.x = step;
          break bb31;
        }
        default:
          return null;
      }
      newValue = {
        hotspot: applyHotspotMoveBy({
          hotspot,
          crop
        }, delta),
        crop
      };
    }
    return newValue;
  }, $[3] = innerRect, $[4] = t2) : t2 = $[4];
  const handleHotspotKeyDown = t2;
  let t3;
  $[5] !== innerRect ? (t3 = (params_0) => {
    const {
      e: e_0,
      crop: crop_0,
      hotspot: hotspot_0,
      isCtrlOrCmdPressed: isCtrlOrCmdPressed_0,
      step: step_0,
      resizeStep: resizeStep_0
    } = params_0;
    if (isCtrlOrCmdPressed_0) {
      let activeHandle;
      const pointerPos_0 = {
        x: initialCursorRef.current.x,
        y: initialCursorRef.current.y
      };
      bb46: switch (e_0.key) {
        case "ArrowUp": {
          activeHandle = "crop-bottom", pointerPos_0.y = pointerPos_0.y - innerRect.height * resizeStep_0;
          break bb46;
        }
        case "ArrowDown": {
          activeHandle = "crop-bottom", pointerPos_0.y = pointerPos_0.y + innerRect.height * resizeStep_0;
          break bb46;
        }
        case "ArrowLeft": {
          activeHandle = "crop-right", pointerPos_0.x = pointerPos_0.x - innerRect.width * resizeStep_0;
          break bb46;
        }
        case "ArrowRight": {
          activeHandle = "crop-right", pointerPos_0.x = pointerPos_0.x + innerRect.width * resizeStep_0;
          break bb46;
        }
        default:
          return null;
      }
      if (activeHandle)
        return handleCropHandleResize({
          initialCrop: crop_0,
          initialHotspot: hotspot_0,
          initialCursor: initialCursorRef.current,
          pointerPos: pointerPos_0,
          innerRect,
          activeHandle
        });
    } else {
      const pointerPos_1 = {
        x: initialCursorRef.current.x,
        y: initialCursorRef.current.y
      };
      bb61: switch (e_0.key) {
        case "ArrowUp": {
          pointerPos_1.y = pointerPos_1.y - innerRect.height * step_0;
          break bb61;
        }
        case "ArrowDown": {
          pointerPos_1.y = pointerPos_1.y + innerRect.height * step_0;
          break bb61;
        }
        case "ArrowLeft": {
          pointerPos_1.x = pointerPos_1.x - innerRect.width * step_0;
          break bb61;
        }
        case "ArrowRight": {
          pointerPos_1.x = pointerPos_1.x + innerRect.width * step_0;
          break bb61;
        }
        default:
          return null;
      }
      return handleCropMove({
        initialCrop: crop_0,
        initialHotspot: hotspot_0,
        initialCursor: initialCursorRef.current,
        pointerPos: pointerPos_1,
        innerRect
      });
    }
    return null;
  }, $[5] = innerRect, $[6] = t3) : t3 = $[6];
  const handleCropKeyDown = t3;
  let t4;
  $[7] !== focusTarget || $[8] !== handleCropKeyDown || $[9] !== handleHotspotKeyDown || $[10] !== innerRect || $[11] !== onChange || $[12] !== readOnly || $[13] !== value ? (t4 = (e_1) => {
    if (changeEndTimeoutRef.current !== null && window.clearTimeout(changeEndTimeoutRef.current), readOnly || !focusTarget || !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e_1.key))
      return;
    const crop_1 = value.crop || DEFAULT_CROP, hotspot_1 = value.hotspot || DEFAULT_HOTSPOT;
    initialCropRef.current = {
      ...crop_1
    }, initialHotspotRef.current = {
      ...hotspot_1
    }, initialCursorRef.current = {
      x: innerRect.width / 2,
      y: innerRect.height / 2
    };
    const isShiftPressed = e_1.shiftKey, isCtrlOrCmdPressed_1 = e_1.ctrlKey || e_1.metaKey, step_1 = isShiftPressed ? KEYBOARD_MOVEMENT_STEP * KEYBOARD_SHIFT_MULTIPLIER : KEYBOARD_MOVEMENT_STEP, resizeStep_1 = isShiftPressed ? KEYBOARD_RESIZE_STEP * KEYBOARD_SHIFT_MULTIPLIER : KEYBOARD_RESIZE_STEP;
    let newValue_0 = null;
    focusTarget === "hotspot" || focusTarget === "hotspotHandle" ? newValue_0 = handleHotspotKeyDown({
      e: e_1,
      crop: crop_1,
      hotspot: hotspot_1,
      isCtrlOrCmdPressed: isCtrlOrCmdPressed_1,
      step: step_1,
      resizeStep: resizeStep_1
    }) : (focusTarget === "crop" || focusTarget === "cropHandle") && (newValue_0 = handleCropKeyDown({
      e: e_1,
      crop: crop_1,
      hotspot: hotspot_1,
      isCtrlOrCmdPressed: isCtrlOrCmdPressed_1,
      step: step_1,
      resizeStep: resizeStep_1
    })), newValue_0 && (onChange(newValue_0), e_1.preventDefault());
  }, $[7] = focusTarget, $[8] = handleCropKeyDown, $[9] = handleHotspotKeyDown, $[10] = innerRect, $[11] = onChange, $[12] = readOnly, $[13] = value, $[14] = t4) : t4 = $[14];
  const handleKeyDown = t4;
  let t5;
  $[15] !== triggerChangeEnd ? (t5 = (e_2) => {
    changeEndTimeoutRef.current !== null && window.clearTimeout(changeEndTimeoutRef.current), changeEndTimeoutRef.current = window.setTimeout(() => {
      triggerChangeEnd(), changeEndTimeoutRef.current = null;
    }, KEYBOARD_CHANGE_SAVE_DEBOUNCE_MS);
  }, $[15] = triggerChangeEnd, $[16] = t5) : t5 = $[16];
  const handleKeyUp = t5;
  let t6;
  return $[17] !== handleKeyDown || $[18] !== handleKeyUp ? (t6 = {
    handleKeyDown,
    handleKeyUp
  }, $[17] = handleKeyDown, $[18] = handleKeyUp, $[19] = t6) : t6 = $[19], t6;
}
function usePointerHandlers({
  value,
  onChange,
  innerRect,
  svgRef,
  size,
  readOnly,
  hotspotRef,
  cropRef
}) {
  const initialCropRef = useRef(null), initialCursorRef = useRef(null), initialHotspotRef = useRef(null), [dragStart, setDragStart] = useState(null), [dragTarget, setDragTarget] = useState(null), [activeHandle, setActiveHandle] = useState(null), handlePointerDown = useCallback((e) => {
    if (readOnly) return;
    const svg = svgRef.current;
    if (!svg) return;
    const rect = svg.getBoundingClientRect(), x = (e.clientX - rect.left) / rect.width * size.width, y = (e.clientY - rect.top) / rect.height * size.height;
    setDragStart({
      x,
      y
    }), initialCursorRef.current = {
      x,
      y
    }, initialCropRef.current = {
      ...value.crop || DEFAULT_CROP
    }, initialHotspotRef.current = {
      ...value.hotspot || DEFAULT_HOTSPOT
    };
    const handle = e.currentTarget.dataset.handle;
    handle === "hotspotHandle" ? (setDragTarget("hotspotHandle"), hotspotRef.current?.focus()) : handle === "hotspot" ? (setDragTarget("hotspot"), hotspotRef.current?.focus()) : handle && handle.startsWith("crop-") ? (setActiveHandle(handle), setDragTarget("cropHandle"), cropRef.current?.focus()) : handle === "crop" && (setDragTarget("crop"), cropRef.current?.focus()), svg.setPointerCapture(e.pointerId), e.preventDefault(), e.stopPropagation();
  }, [readOnly, size.width, size.height, value.crop, value.hotspot, svgRef, hotspotRef, cropRef]), handlePointerMove = useCallback((e_0) => {
    const svg_0 = svgRef.current;
    if (!svg_0 || !dragTarget || !dragStart || !initialCursorRef.current || !initialCropRef.current || !initialHotspotRef.current) return;
    const pointerPos = getPointerPosition(e_0, svg_0, size);
    if (dragTarget === "hotspot") {
      const result = handleHotspotMove({
        crop: value.crop || DEFAULT_CROP,
        hotspot: initialHotspotRef.current
      }, initialCursorRef.current, pointerPos, innerRect);
      onChange(result);
    } else if (dragTarget === "hotspotHandle") {
      const result_0 = handleHotspotResize({
        initialHotspot: initialHotspotRef.current,
        crop: value.crop || DEFAULT_CROP,
        initialCursor: initialCursorRef.current,
        pointerPos,
        innerRect
      });
      onChange(result_0);
    } else if (dragTarget === "crop") {
      const params = {
        initialCrop: initialCropRef.current,
        initialHotspot: initialHotspotRef.current,
        initialCursor: initialCursorRef.current,
        pointerPos,
        innerRect
      }, result_1 = handleCropMove(params);
      onChange(result_1);
    } else if (dragTarget === "cropHandle" && activeHandle) {
      const result_2 = handleCropHandleResize({
        initialCrop: initialCropRef.current,
        initialHotspot: initialHotspotRef.current,
        initialCursor: initialCursorRef.current,
        pointerPos,
        innerRect,
        activeHandle
      });
      onChange(result_2);
    }
  }, [dragStart, dragTarget, activeHandle, innerRect, onChange, value.crop, size, svgRef, initialHotspotRef, initialCropRef, initialCursorRef]), resetDragState = useCallback(() => {
    setDragTarget(null), setActiveHandle(null), setDragStart(null), initialCropRef.current = null, initialCursorRef.current = null, initialHotspotRef.current = null;
  }, []);
  return {
    dragTarget,
    activeHandle,
    dragStart,
    handlePointerDown,
    handlePointerMove,
    resetDragState
  };
}
function useRectCalculations(t0) {
  const $ = c(27), {
    size,
    value
  } = t0;
  let t1, t2;
  $[0] !== size.height || $[1] !== size.width ? (t2 = {
    left: 0,
    top: 0,
    width: size.width,
    height: size.height
  }, $[0] = size.height, $[1] = size.width, $[2] = t2) : t2 = $[2], t1 = t2;
  const imageRect = t1;
  let t3;
  const availableWidth = imageRect.width - MARGIN_SIZE * 2, availableHeight = imageRect.height - MARGIN_SIZE * 2, aspectRatio = imageRect.width / imageRect.height;
  let width, height;
  availableWidth / availableHeight > aspectRatio ? (height = availableHeight, width = height * aspectRatio) : (width = availableWidth, height = width / aspectRatio);
  const left = imageRect.left + (imageRect.width - width) / 2, top = imageRect.top + (imageRect.height - height) / 2;
  let t4;
  $[3] !== height || $[4] !== left || $[5] !== top || $[6] !== width ? (t4 = {
    left,
    top,
    width,
    height
  }, $[3] = height, $[4] = left, $[5] = top, $[6] = width, $[7] = t4) : t4 = $[7], t3 = t4;
  const innerRect = t3;
  let t5;
  const crop = value.crop || DEFAULT_CROP, dimensions = getCropDimensions(crop), t6 = innerRect.left + innerRect.width * crop.left, t7 = innerRect.top + innerRect.height * crop.top, t8 = innerRect.width * dimensions.width, t9 = innerRect.height * dimensions.height;
  let t10;
  $[8] !== t6 || $[9] !== t7 || $[10] !== t8 || $[11] !== t9 ? (t10 = {
    left: t6,
    top: t7,
    width: t8,
    height: t9
  }, $[8] = t6, $[9] = t7, $[10] = t8, $[11] = t9, $[12] = t10) : t10 = $[12], t5 = t10;
  const cropRect = t5;
  let t11;
  const hotspot = value.hotspot || DEFAULT_HOTSPOT, crop_0 = value.crop || DEFAULT_CROP;
  let t12;
  $[13] !== crop_0 || $[14] !== hotspot ? (t12 = constrainHotspotToCrop(hotspot, crop_0), $[13] = crop_0, $[14] = hotspot, $[15] = t12) : t12 = $[15], t11 = t12;
  const constrainedHotspot = t11;
  let t13;
  const t14 = innerRect.left + innerRect.width * (constrainedHotspot.x - constrainedHotspot.width / 2), t15 = innerRect.top + innerRect.height * (constrainedHotspot.y - constrainedHotspot.height / 2), t16 = innerRect.width * constrainedHotspot.width, t17 = innerRect.height * constrainedHotspot.height;
  let t18;
  $[16] !== t14 || $[17] !== t15 || $[18] !== t16 || $[19] !== t17 ? (t18 = {
    left: t14,
    top: t15,
    width: t16,
    height: t17
  }, $[16] = t14, $[17] = t15, $[18] = t16, $[19] = t17, $[20] = t18) : t18 = $[20], t13 = t18;
  const hotspotRect = t13;
  let t19;
  return $[21] !== constrainedHotspot || $[22] !== cropRect || $[23] !== hotspotRect || $[24] !== imageRect || $[25] !== innerRect ? (t19 = {
    imageRect,
    innerRect,
    cropRect,
    constrainedHotspot,
    hotspotRect
  }, $[21] = constrainedHotspot, $[22] = cropRect, $[23] = hotspotRect, $[24] = imageRect, $[25] = innerRect, $[26] = t19) : t19 = $[26], t19;
}
const SVGContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: visible;
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  -webkit-user-select: none;
`, StyledSVG = styled.svg`
  display: block;
  overflow: visible;
  shape-rendering: crispEdges;
`, DarkenedOverlay = styled.rect`
  fill: rgba(0, 0, 0, 0.5);
  pointer-events: none;
`, getCropStrokeColor = (props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return props2.$focused ? color.focusRing : props2.$hovered ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, .5)";
}, getHotspotStrokeColor = (props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return props2.$focused ? color.focusRing : props2.$hovered ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, .5)";
}, getHandleStrokeColor = (props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return props2.$focused ? color.focusRing : "#000";
}, CropRect = styled.rect`
  fill: none;
  stroke: ${getCropStrokeColor};
  stroke-opacity: 1;
  stroke-width: 1px;
  outline: none;
  ${(props2) => props2.$focused && css`
      stroke-width: 2px;
      filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.3));
    `}
`, CropCornerHandle = styled.path`
  fill: #fff;
  stroke: ${getHandleStrokeColor};
  stroke-width: 1;
  outline: none;
`, CropEdgeHandle = styled.rect`
  fill: #fff;
  stroke: ${getHandleStrokeColor};
  stroke-width: 1;
  outline: none;
`, HotspotEllipse = styled.ellipse`
  fill: transparent;
  stroke: ${getHotspotStrokeColor};
  stroke-opacity: 1;
  stroke-width: 1px;
  outline: none;
  ${(props2) => props2.$focused && css`
      stroke-width: 2px;
    `}
`, HotspotHandle = styled.circle`
  fill: #fff;
  stroke: ${getHandleStrokeColor};
  stroke-width: 1;
  outline: none;
`, CropHandleInteractionArea = styled.rect`
  fill: transparent;
  stroke: transparent;
  pointer-events: all;
`, HotspotHandleInteractionArea = styled.circle`
  fill: transparent;
  stroke: transparent;
  pointer-events: all;
`, Guidelines = styled.g`
  ${(props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return css`
      stroke: ${color.fg};
      stroke-opacity: 0.2;
      stroke-width: 1px;
      stroke-dasharray: 3, 3;
      pointer-events: none;
    `;
}}
`;
function ToolSVGComponent(props2) {
  const {
    value,
    image,
    onChange,
    onChangeEnd,
    readOnly,
    size
  } = props2, svgRef = useRef(null), cropRef = useRef(null), hotspotRef = useRef(null), [focusTarget, setFocusTarget] = useState(null), hotspotClipId = useMemo(() => `hotspotClip-${uuid()}`, []);
  useEffect(() => {
    const svgElement = svgRef.current;
    if (!svgElement) return;
    const handleTouchMove = (e) => {
      e.preventDefault();
    };
    return svgElement.addEventListener("touchmove", handleTouchMove, {
      passive: !1
    }), () => {
      svgElement.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);
  const {
    innerRect,
    cropRect,
    constrainedHotspot,
    hotspotRect
  } = useRectCalculations({
    size,
    value
  }), {
    hoverTarget,
    handleMouseEnter,
    handleMouseLeave,
    handleHotspotMouseEnter,
    handleHotspotHandleMouseEnter,
    handleCropMouseEnter,
    getCropHandleMouseEnter
  } = useHoverHandlers(), {
    dragTarget,
    activeHandle,
    handlePointerDown,
    handlePointerMove,
    resetDragState
  } = usePointerHandlers({
    value,
    onChange,
    innerRect,
    svgRef,
    size,
    readOnly,
    hotspotRef,
    cropRef
  }), {
    handleKeyDown,
    handleKeyUp
  } = useKeyboardControls({
    value,
    onChange,
    onChangeEnd,
    innerRect,
    focusTarget,
    readOnly
  }), cropHandles = useMemo(() => calculateCropHandles(cropRect), [cropRect]), hotspotHandlePosition = useMemo(() => ({
    ...getHotspotHandlePosition(hotspotRect),
    radius: HANDLE_VISUAL_SIZE_HOTSPOT / 2,
    hitRadius: HANDLE_INTERACTIVE_SIZE / 2
  }), [hotspotRect]), handleFocus = useCallback((target) => {
    setFocusTarget(target);
  }, []), handleBlur = useCallback(() => {
    setFocusTarget(null);
  }, []), handleHotspotFocus = useCallback(() => handleFocus("hotspot"), [handleFocus]), handleHotspotBlur = useCallback(() => handleBlur(), [handleBlur]), handleCropFocus = useCallback(() => handleFocus("crop"), [handleFocus]), handleCropBlur = useCallback(() => handleBlur(), [handleBlur]), handlePointerUp = useCallback((e_0) => {
    const svg = svgRef.current;
    svg && (dragTarget && (dragTarget === "hotspot" || dragTarget === "hotspotHandle" ? onChangeEnd({
      hotspot: constrainedHotspot,
      crop: value.crop || DEFAULT_CROP
    }) : (dragTarget === "crop" || dragTarget === "cropHandle") && onChangeEnd({
      crop: value.crop || DEFAULT_CROP,
      hotspot: value.hotspot || DEFAULT_HOTSPOT
    })), svg.releasePointerCapture(e_0.pointerId), resetDragState());
  }, [dragTarget, onChangeEnd, value.crop, value.hotspot, constrainedHotspot, resetDragState]), currentCursor = useMemo(() => calculateCurrentCursor(dragTarget, activeHandle, hoverTarget), [dragTarget, activeHandle, hoverTarget]), handleCropEnter = useCallback(() => handleMouseEnter("crop"), [handleMouseEnter]), isHandleHovered = useCallback((handleId) => hoverTarget ? hoverTarget === "crop" ? !0 : hoverTarget === `crop-${handleId}` : !1, [hoverTarget]);
  return /* @__PURE__ */ jsx(SVGContainer, { children: /* @__PURE__ */ jsxs(StyledSVG, { ref: svgRef, viewBox: `0 0 ${size.width} ${size.height}`, preserveAspectRatio: "xMidYMid", onPointerMove: handlePointerMove, onPointerUp: handlePointerUp, style: {
    cursor: readOnly ? "default" : currentCursor,
    width: `${size.width}px`,
    height: `${size.height}px`
  }, children: [
    /* @__PURE__ */ jsx("image", { href: image.src, x: innerRect.left, y: innerRect.top, width: innerRect.width, height: innerRect.height, opacity: 0.25, preserveAspectRatio: "xMidYMid meet" }),
    /* @__PURE__ */ jsxs("svg", { x: cropRect.left, y: cropRect.top, width: cropRect.width, height: cropRect.height, overflow: "hidden", "data-handle": "crop", onPointerDown: handlePointerDown, onMouseEnter: handleCropMouseEnter, onMouseLeave: handleMouseLeave, children: [
      /* @__PURE__ */ jsx("image", { href: image.src, x: -cropRect.left + innerRect.left, y: -cropRect.top + innerRect.top, width: innerRect.width, height: innerRect.height, preserveAspectRatio: "xMidYMid meet" }),
      /* @__PURE__ */ jsx(DarkenedOverlay, { x: "0", y: "0", width: cropRect.width, height: cropRect.height }),
      /* @__PURE__ */ jsx("rect", { x: "0", y: "0", width: cropRect.width, height: cropRect.height, fill: "transparent", "data-handle": "crop", onPointerDown: handlePointerDown, onMouseEnter: handleCropMouseEnter })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: hotspotClipId, children: /* @__PURE__ */ jsx("ellipse", { cx: getRectCenterX(hotspotRect), cy: getRectCenterY(hotspotRect), rx: hotspotRect.width / 2, ry: hotspotRect.height / 2 }) }) }),
    /* @__PURE__ */ jsx("image", { href: image.src, x: innerRect.left, y: innerRect.top, width: innerRect.width, height: innerRect.height, clipPath: `url(#${hotspotClipId})`, preserveAspectRatio: "xMidYMid meet" }),
    /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(HotspotEllipse, { ref: hotspotRef, cx: getRectCenterX(hotspotRect), cy: getRectCenterY(hotspotRect), rx: Math.max(0.01, hotspotRect.width / 2), ry: Math.max(0.01, hotspotRect.height / 2), $hovered: !readOnly && (hoverTarget === "hotspot" || hoverTarget === "hotspotHandle" || dragTarget === "hotspot" || dragTarget === "hotspotHandle"), $focused: !readOnly && focusTarget === "hotspot", "data-handle": "hotspot", onPointerDown: handlePointerDown, tabIndex: readOnly ? -1 : 0, onMouseEnter: handleHotspotMouseEnter, onMouseLeave: handleMouseLeave, onFocus: handleHotspotFocus, onBlur: handleHotspotBlur, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, style: {
        pointerEvents: "visiblePainted"
      } }),
      !readOnly && /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx(HotspotHandleInteractionArea, { cx: hotspotHandlePosition.x, cy: hotspotHandlePosition.y, r: hotspotHandlePosition.hitRadius, "data-handle": "hotspotHandle", onPointerDown: handlePointerDown, onMouseEnter: handleHotspotHandleMouseEnter, onMouseLeave: handleMouseLeave, style: {
          pointerEvents: "visiblePainted"
        } }),
        /* @__PURE__ */ jsx(HotspotHandle, { cx: hotspotHandlePosition.x, cy: hotspotHandlePosition.y, r: hotspotHandlePosition.radius, $hovered: !readOnly && (hoverTarget === "hotspot" || hoverTarget === "hotspotHandle" || dragTarget === "hotspot" || dragTarget === "hotspotHandle"), $focused: !readOnly && focusTarget === "hotspot", pointerEvents: "none" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Guidelines, { children: [
      /* @__PURE__ */ jsx("line", { x1: getRectCenterX(hotspotRect), y1: innerRect.top, x2: getRectCenterX(hotspotRect), y2: getRectBottom(innerRect) }),
      /* @__PURE__ */ jsx("line", { x1: innerRect.left, y1: getRectCenterY(hotspotRect), x2: getRectRight(innerRect), y2: getRectCenterY(hotspotRect) }),
      /* @__PURE__ */ jsx("line", { x1: hotspotRect.left, y1: innerRect.top, x2: hotspotRect.left, y2: getRectBottom(innerRect) }),
      /* @__PURE__ */ jsx("line", { x1: getRectRight(hotspotRect), y1: innerRect.top, x2: getRectRight(hotspotRect), y2: getRectBottom(innerRect) }),
      /* @__PURE__ */ jsx("line", { x1: innerRect.left, y1: hotspotRect.top, x2: getRectRight(innerRect), y2: hotspotRect.top }),
      /* @__PURE__ */ jsx("line", { x1: innerRect.left, y1: getRectBottom(hotspotRect), x2: getRectRight(innerRect), y2: getRectBottom(hotspotRect) })
    ] }),
    /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(CropRect, { ref: cropRef, x: cropRect.left, y: cropRect.top, width: cropRect.width, height: cropRect.height, $hovered: !readOnly && (hoverTarget === "crop" || !!hoverTarget?.startsWith("crop-") || dragTarget === "crop" || dragTarget === "cropHandle"), $focused: !readOnly && focusTarget === "crop", "data-handle": "crop", onPointerDown: handlePointerDown, tabIndex: readOnly ? -1 : 0, onMouseEnter: handleCropEnter, onMouseLeave: handleMouseLeave, onFocus: handleCropFocus, onBlur: handleCropBlur, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }),
      !readOnly && Object.entries(cropHandles).map(([key, handle]) => /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx(CropHandleInteractionArea, { x: handle.hit.left, y: handle.hit.top, width: handle.hit.width, height: handle.hit.height, "data-handle": `crop-${key}`, onPointerDown: handlePointerDown, onMouseEnter: getCropHandleMouseEnter(key), onMouseLeave: handleMouseLeave, style: {
          pointerEvents: "all"
        } }),
        ["topLeft", "topRight", "bottomLeft", "bottomRight"].includes(key) ? /* @__PURE__ */ jsx("g", { transform: `translate(${handle.position?.x ?? 0}, ${handle.position?.y ?? 0}) rotate(${handle.rotation ?? 0})`, children: /* @__PURE__ */ jsx(CropCornerHandle, { d: handle.path, $hovered: !readOnly && isHandleHovered(key), $focused: !readOnly && focusTarget === "crop", pointerEvents: "none" }) }) : /* @__PURE__ */ jsx(CropEdgeHandle, { x: handle.visual.left, y: handle.visual.top, width: handle.visual.width, height: handle.visual.height, $hovered: !readOnly && isHandleHovered(key), $focused: !readOnly && focusTarget === "crop", pointerEvents: "none" })
      ] }, key))
    ] })
  ] }) });
}
const ToolSVG = memo(ToolSVGComponent);
function ImageTool(props2) {
  const $ = c(9), containerRef = useRef(null), [containerWidth, setContainerWidth] = useState(null), [containerHeight, setContainerHeight] = useState(null);
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    if (!containerRef.current)
      return;
    const updateSize = (entry) => {
      setContainerWidth(entry.contentRect.width), setContainerHeight(entry.contentRect.height);
    };
    return containerRef.current && (setContainerWidth(containerRef.current.clientWidth), setContainerHeight(containerRef.current.clientHeight)), resizeObserver.observe(containerRef.current, updateSize);
  }, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useLayoutEffect(t0, t1);
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    position: "relative",
    width: "100%",
    height: "100%"
  }, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== containerHeight || $[4] !== containerWidth || $[5] !== props2 ? (t3 = containerWidth !== null && containerHeight !== null && /* @__PURE__ */ jsx(ImageLoader, { src: props2.src, children: (t42) => {
    const {
      isLoading,
      image,
      error
    } = t42;
    return isLoading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) : error ? /* @__PURE__ */ jsx("div", { children: error.message }) : image ? /* @__PURE__ */ jsx(ResizeSVG, { image, maxHeight: containerHeight, maxWidth: containerWidth, children: (size) => /* @__PURE__ */ jsx(ToolSVG, { ...props2, image, size }) }) : null;
  } }), $[3] = containerHeight, $[4] = containerWidth, $[5] = props2, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx("div", { ref: containerRef, style: t2, children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
const PROBABLY_THE_TINIEST_GIF_EVER = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
function isBlob(src) {
  return src.startsWith("blob:");
}
function loadImage(src) {
  return new Observable((subscriber) => {
    const image = document.createElement("img");
    let completed = !1;
    const onload = () => {
      completed = !0, subscriber.next(image), subscriber.complete();
    }, onerror = () => {
      completed = !0, subscriber.error(new Error(`Could not load image from ${isBlob(src) ? "blob" : src}`));
    };
    return image.onload = onload, image.onerror = onerror, image.src = src, () => {
      image.onload = null, image.onerror = null, completed || (image.src = PROBABLY_THE_TINIEST_GIF_EVER);
    };
  });
}
const INITIAL_STATE$8 = {
  isLoading: !0
};
function useLoadImage(url) {
  const $ = c(3), [state, setState] = useState(INITIAL_STATE$8);
  let t0, t1;
  return $[0] !== url ? (t0 = () => {
    setState(INITIAL_STATE$8);
    const subscription = loadImage(url).subscribe({
      error: (err) => {
        setState({
          isLoading: !1,
          error: err
        });
      },
      next: (image) => {
        setState({
          image,
          isLoading: !1
        });
      }
    });
    return () => {
      subscription.unsubscribe();
    };
  }, t1 = [url], $[0] = url, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), state;
}
const HOTSPOT_PATH = ["hotspot"], DEFAULT_PREVIEWS = [{
  title: "3:4",
  aspectRatio: 3 / 4
}, {
  title: "Square",
  aspectRatio: 1 / 1
}, {
  title: "16:9",
  aspectRatio: 16 / 9
}, {
  title: "Panorama",
  aspectRatio: 4 / 1
}], DEFAULT_VALUE = {
  crop: DEFAULT_CROP,
  hotspot: DEFAULT_HOTSPOT
}, Placeholder$2 = styled.div`
  min-height: 6em;
`;
function LoadStatus(props2) {
  const $ = c(3);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    overflowWrap: "break-word"
  }, $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== props2.children ? (t1 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", padding: 4, style: t0, children: props2.children }), $[1] = props2.children, $[2] = t1) : t1 = $[2], t1;
}
function ImageToolInput(props2) {
  const $ = c(59), {
    imageUrl,
    value,
    changed,
    level,
    path,
    focusPath: t0,
    presence,
    onChange,
    schemaType,
    onPathFocus,
    readOnly,
    elementProps
  } = props2, focusPath = t0 === void 0 ? EMPTY_ARRAY$A : t0, [localValue, setLocalValue] = useState(value || DEFAULT_VALUE), {
    image,
    isLoading: isImageLoading,
    error: imageLoadError
  } = useLoadImage(imageUrl);
  let t1;
  $[0] !== onPathFocus ? (t1 = () => {
    onPathFocus(HOTSPOT_PATH);
  }, $[0] = onPathFocus, $[1] = t1) : t1 = $[1];
  const handleFocus = t1;
  let t2, t3;
  $[2] !== value ? (t2 = () => {
    setLocalValue(value || DEFAULT_VALUE);
  }, t3 = [value], $[2] = value, $[3] = t2, $[4] = t3) : (t2 = $[3], t3 = $[4]), useEffect(t2, t3);
  const hasFocus = focusPath[0] === "hotspot", hotspotPreviews = typeof schemaType.options?.hotspot == "object" && schemaType.options.hotspot.previews || DEFAULT_PREVIEWS;
  let t4;
  $[5] !== elementProps.ref || $[6] !== hasFocus ? (t4 = (hadFocus) => {
    !hadFocus && hasFocus && elementProps.ref.current?.focus();
  }, $[5] = elementProps.ref, $[6] = hasFocus, $[7] = t4) : t4 = $[7], useDidUpdate(hasFocus, t4);
  let t5;
  $[8] !== onChange || $[9] !== readOnly || $[10] !== schemaType.fields ? (t5 = (finalValue) => {
    if (readOnly)
      return;
    const cropField = schemaType.fields.find(_temp$1o), hotspotField = schemaType.fields.find(_temp2$u), crop = cropField ? {
      _type: cropField.type.name,
      ...finalValue.crop || DEFAULT_CROP
    } : finalValue.crop, hotspot = hotspotField ? {
      _type: hotspotField.type.name,
      ...finalValue.hotspot || DEFAULT_HOTSPOT
    } : finalValue.hotspot;
    onChange([set(crop, ["crop"]), set(hotspot, ["hotspot"])]);
  }, $[8] = onChange, $[9] = readOnly, $[10] = schemaType.fields, $[11] = t5) : t5 = $[11];
  const handleChangeEnd = t5;
  let t6;
  t6 = value?.asset?._ref?.split("-").at(-1) === "svg";
  const isSvg = t6, {
    t
  } = useTranslation();
  let t7;
  $[12] !== t ? (t7 = t("inputs.imagetool.title"), $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t ? (t8 = t("inputs.imagetool.description"), $[14] = t, $[15] = t8) : t8 = $[15];
  const t9 = schemaType.deprecated;
  let t10;
  $[16] !== isSvg || $[17] !== t ? (t10 = isSvg ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Card, { padding: 3, marginY: 3, tone: "caution", radius: 2, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("inputs.imagetool.vector-warning.title") }),
    /* @__PURE__ */ jsx(Details, { title: t("inputs.imagetool.vector-warning.expand-developer-info"), children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "inputs.imagetool.vector-warning.developer-info", components: {
      ImageUrlDocumentationLink: _temp3$8,
      ImageUrlPackageDocumentationLink: _temp4$4
    } }) }) })
  ] }) }) }) : null, $[16] = isSvg, $[17] = t, $[18] = t10) : t10 = $[18];
  const t11 = elementProps.ref;
  let t12;
  $[19] !== path ? (t12 = path.concat(HOTSPOT_PATH), $[19] = path, $[20] = t12) : t12 = $[20];
  const t13 = focusPath[0] === "hotspot";
  let t14;
  $[21] !== imageLoadError || $[22] !== isImageLoading || $[23] !== t ? (t14 = (isImageLoading || imageLoadError) && /* @__PURE__ */ jsx(LoadStatus, { children: imageLoadError ? /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, tone: "critical", border: !0, children: /* @__PURE__ */ jsx(Text$1, { children: t("inputs.imagetool.load-error", {
    errorMessage: imageLoadError.message
  }) }) }) : /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }), $[21] = imageLoadError, $[22] = isImageLoading, $[23] = t, $[24] = t14) : t14 = $[24];
  let t15;
  $[25] !== handleChangeEnd || $[26] !== image || $[27] !== isImageLoading || $[28] !== localValue || $[29] !== readOnly ? (t15 = !isImageLoading && image && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(ImageTool, { value: localValue, src: image.src, readOnly: !!readOnly, onChangeEnd: handleChangeEnd, onChange: setLocalValue }) }), $[25] = handleChangeEnd, $[26] = image, $[27] = isImageLoading, $[28] = localValue, $[29] = readOnly, $[30] = t15) : t15 = $[30];
  let t16;
  $[31] !== t14 || $[32] !== t15 ? (t16 = /* @__PURE__ */ jsxs(RatioBox, { ratio: 1.5, children: [
    t14,
    t15
  ] }), $[31] = t14, $[32] = t15, $[33] = t16) : t16 = $[33];
  let t17;
  $[34] !== changed || $[35] !== t12 || $[36] !== t13 || $[37] !== t16 ? (t17 = /* @__PURE__ */ jsx(ChangeIndicator, { path: t12, hasFocus: t13, isChanged: changed, children: t16 }), $[34] = changed, $[35] = t12, $[36] = t13, $[37] = t16, $[38] = t17) : t17 = $[38];
  let t18;
  $[39] !== elementProps.ref || $[40] !== handleFocus || $[41] !== t17 ? (t18 = /* @__PURE__ */ jsx(Card, { __unstable_checkered: !0, __unstable_focusRing: !0, tabIndex: 0, ref: t11, onFocus: handleFocus, border: !0, children: t17 }), $[39] = elementProps.ref, $[40] = handleFocus, $[41] = t17, $[42] = t18) : t18 = $[42];
  let t19;
  $[43] !== hotspotPreviews || $[44] !== image || $[45] !== isImageLoading || $[46] !== localValue ? (t19 = hotspotPreviews.length > 0 ? /* @__PURE__ */ jsx(Box, { marginTop: 2, children: /* @__PURE__ */ jsx(Grid, { columns: 4, gap: 1, children: hotspotPreviews.map((t202) => {
    const {
      title,
      aspectRatio
    } = t202;
    return /* @__PURE__ */ jsxs(Box, { marginTop: 2, children: [
      /* @__PURE__ */ jsx(Heading, { as: "h4", size: 0, children: title }),
      /* @__PURE__ */ jsx(Box, { marginTop: 2, children: /* @__PURE__ */ jsx(RatioBox, { ratio: aspectRatio, children: /* @__PURE__ */ jsx(Card, { __unstable_checkered: !0, border: !0, children: !isImageLoading && image ? /* @__PURE__ */ jsx(HotspotImage, { aspectRatio, src: image.src, srcAspectRatio: image.width / image.height, hotspot: localValue.hotspot || DEFAULT_HOTSPOT, crop: localValue.crop || DEFAULT_CROP }) : /* @__PURE__ */ jsx(Placeholder$2, {}) }) }) })
    ] }, title);
  }) }) }) : null, $[43] = hotspotPreviews, $[44] = image, $[45] = isImageLoading, $[46] = localValue, $[47] = t19) : t19 = $[47];
  let t20;
  $[48] !== t18 || $[49] !== t19 ? (t20 = /* @__PURE__ */ jsxs("div", { children: [
    t18,
    t19
  ] }), $[48] = t18, $[49] = t19, $[50] = t20) : t20 = $[50];
  let t21;
  return $[51] !== level || $[52] !== presence || $[53] !== schemaType.deprecated || $[54] !== t10 || $[55] !== t20 || $[56] !== t7 || $[57] !== t8 ? (t21 = /* @__PURE__ */ jsxs(FormField, { title: t7, level, description: t8, deprecated: t9, __unstable_presence: presence, children: [
    t10,
    t20
  ] }), $[51] = level, $[52] = presence, $[53] = schemaType.deprecated, $[54] = t10, $[55] = t20, $[56] = t7, $[57] = t8, $[58] = t21) : t21 = $[58], t21;
}
function _temp4$4(t0) {
  const {
    children: children_0
  } = t0;
  return /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/image-urls#fm-048ba39d9e88", children: /* @__PURE__ */ jsx("code", { children: children_0 }) });
}
function _temp3$8(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/image-urls#fm-048ba39d9e88", children });
}
function _temp2$u(field_0) {
  return field_0.type.name !== "object" && field_0.name === "hotspot";
}
function _temp$1o(field) {
  return field.name === "crop" && field.type.name !== "object";
}
const ImageInputHotspotInput = memo(function(props2) {
  const {
    handleCloseDialog,
    inputProps,
    imageInputProps,
    isImageToolEnabled
  } = props2, {
    t
  } = useTranslation(), {
    changed,
    id: id2,
    imageUrlBuilder: imageUrlBuilder2,
    value
  } = imageInputProps, withImageTool = isImageToolEnabled && value && value.asset, imageUrl = useMemo(() => value?.asset ? imageUrlBuilder2.image(value.asset).url() : "", [imageUrlBuilder2, value?.asset]);
  return /* @__PURE__ */ jsx(Dialog$1, { __unstable_autoFocus: !1, header: t("inputs.image.hotspot-dialog.title"), id: `${id2}_dialog`, onClickOutside: handleCloseDialog, onClose: handleCloseDialog, width: 1, children: /* @__PURE__ */ jsx(PresenceOverlay, { children: /* @__PURE__ */ jsx(Stack, { space: 5, children: withImageTool && value?.asset && /* @__PURE__ */ jsx(ImageToolInput, { ...imageInputProps, imageUrl, value, presence: inputProps.presence, changed }) }) }) });
});
function ImagePreview$2(props2) {
  const $ = c(26);
  let drag, isRejected, readOnly, rest, src;
  $[0] !== props2 ? ({
    drag,
    readOnly,
    isRejected,
    src,
    ...rest
  } = props2, $[0] = props2, $[1] = drag, $[2] = isRejected, $[3] = readOnly, $[4] = rest, $[5] = src) : (drag = $[1], isRejected = $[2], readOnly = $[3], rest = $[4], src = $[5]);
  const [isLoaded, setLoaded] = useState(!1), tone = drag ? isRejected || readOnly ? "critical" : "primary" : "default";
  let t0;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setLoaded(!1);
  }, $[6] = t0) : t0 = $[6];
  let t1;
  $[7] !== src ? (t1 = [src], $[7] = src, $[8] = t1) : t1 = $[8], useEffect(t0, t1);
  let t2;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setLoaded(!0);
  }, $[9] = t2) : t2 = $[9];
  const onLoadChange = t2, {
    t
  } = useTranslation();
  let t3;
  $[10] !== isLoaded ? (t3 = !isLoaded && /* @__PURE__ */ jsx(OverlayComponent, { cardTone: "transparent", content: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }), $[10] = isLoaded, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== props2.alt || $[13] !== src ? (t4 = /* @__PURE__ */ jsx("img", { src, "data-testid": "hotspot-image-input", alt: props2.alt, onLoad: onLoadChange, referrerPolicy: "strict-origin-when-cross-origin" }), $[12] = props2.alt, $[13] = src, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== drag || $[16] !== isRejected || $[17] !== readOnly || $[18] !== t || $[19] !== tone ? (t5 = drag && /* @__PURE__ */ jsx(OverlayComponent, { cardTone: tone, content: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { marginBottom: 3, children: /* @__PURE__ */ jsx(Heading, { children: /* @__PURE__ */ jsx(HoverIcon, { isRejected, readOnly }) }) }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, children: t(getHoverTextTranslationKey({
      isRejected,
      readOnly
    })) })
  ] }) }), $[15] = drag, $[16] = isRejected, $[17] = readOnly, $[18] = t, $[19] = tone, $[20] = t5) : t5 = $[20];
  let t6;
  return $[21] !== rest || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 ? (t6 = /* @__PURE__ */ jsxs(RatioBox$1, { ...rest, tone: "transparent", children: [
    t3,
    t4,
    t5
  ] }), $[21] = rest, $[22] = t3, $[23] = t4, $[24] = t5, $[25] = t6) : t6 = $[25], t6;
}
function HoverIcon(t0) {
  const $ = c(3), {
    isRejected,
    readOnly
  } = t0;
  if (isRejected) {
    let t12;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(AccessDeniedIcon, {}), $[0] = t12) : t12 = $[0], t12;
  }
  if (readOnly) {
    let t12;
    return $[1] === Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(ReadOnlyIcon, {}), $[1] = t12) : t12 = $[1], t12;
  }
  let t1;
  return $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(ImageIcon, {}), $[2] = t1) : t1 = $[2], t1;
}
function getHoverTextTranslationKey({
  isRejected,
  readOnly
}) {
  return isRejected ? "inputs.image.drag-overlay.cannot-upload-here" : readOnly ? "inputs.image.drag-overlay.this-field-is-read-only" : "inputs.image.drag-overlay.drop-to-upload-image";
}
function OverlayComponent(t0) {
  const $ = c(5), {
    cardTone,
    content
  } = t0;
  let t1;
  $[0] !== content ? (t1 = /* @__PURE__ */ jsx(FlexOverlay, { direction: "column", align: "center", justify: "center", children: content }), $[0] = content, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== cardTone || $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Overlay, { padding: 3, tone: cardTone, children: t1 }), $[2] = cardTone, $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
const ImageInputPreview = memo(function(props2) {
  const $ = c(9), {
    directUploads,
    handleOpenDialog,
    hoveringFiles,
    imageUrlBuilder: imageUrlBuilder2,
    readOnly,
    resolveUploader: resolveUploader2,
    schemaType,
    value
  } = props2;
  let t0;
  return $[0] !== directUploads || $[1] !== handleOpenDialog || $[2] !== hoveringFiles || $[3] !== imageUrlBuilder2 || $[4] !== readOnly || $[5] !== resolveUploader2 || $[6] !== schemaType || $[7] !== value ? (t0 = /* @__PURE__ */ jsx(RenderImageInputPreview, { directUploads, handleOpenDialog, hoveringFiles, imageUrlBuilder: imageUrlBuilder2, readOnly, resolveUploader: resolveUploader2, schemaType, value }), $[0] = directUploads, $[1] = handleOpenDialog, $[2] = hoveringFiles, $[3] = imageUrlBuilder2, $[4] = readOnly, $[5] = resolveUploader2, $[6] = schemaType, $[7] = value, $[8] = t0) : t0 = $[8], t0;
});
function RenderImageInputPreview(props2) {
  const $ = c(12), {
    directUploads,
    handleOpenDialog,
    hoveringFiles,
    imageUrlBuilder: imageUrlBuilder2,
    readOnly,
    resolveUploader: resolveUploader2,
    schemaType,
    value
  } = props2, {
    t
  } = useTranslation();
  let t0;
  t0 = hoveringFiles.filter((file) => resolveUploader2(schemaType, file));
  const acceptedFiles = t0;
  let t1;
  t1 = hoveringFiles.length - acceptedFiles.length;
  const rejectedFilesCount = t1;
  let t2;
  $[0] !== imageUrlBuilder2 || $[1] !== value ? (t2 = {
    value,
    imageUrlBuilder: imageUrlBuilder2
  }, $[0] = imageUrlBuilder2, $[1] = value, $[2] = t2) : t2 = $[2];
  const {
    url
  } = usePreviewImageSource(t2);
  let t3;
  $[3] !== t ? (t3 = t("inputs.image.preview-uploaded-image"), $[3] = t, $[4] = t3) : t3 = $[4];
  const t4 = !value?._upload && hoveringFiles.length > 0, t5 = rejectedFilesCount > 0 || directUploads === !1;
  let t6;
  return $[5] !== handleOpenDialog || $[6] !== readOnly || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== url ? (t6 = /* @__PURE__ */ jsx(ImagePreview$2, { alt: t3, drag: t4, isRejected: t5, onDoubleClick: handleOpenDialog, readOnly, src: url }), $[5] = handleOpenDialog, $[6] = readOnly, $[7] = t3, $[8] = t4, $[9] = t5, $[10] = url, $[11] = t6) : t6 = $[11], t6;
}
function ImageInputUploadPlaceholderComponent(props2) {
  const $ = c(28), {
    assetSources,
    directUploads,
    onSelectFiles,
    hoveringFiles,
    readOnly,
    renderBrowser,
    resolveUploader: resolveUploader2,
    schemaType
  } = props2;
  let t0, t1;
  if ($[0] !== hoveringFiles || $[1] !== resolveUploader2 || $[2] !== schemaType) {
    let t22;
    $[4] !== resolveUploader2 || $[5] !== schemaType ? (t22 = (file) => resolveUploader2(schemaType, file), $[4] = resolveUploader2, $[5] = schemaType, $[6] = t22) : t22 = $[6], t1 = hoveringFiles.filter(t22), $[0] = hoveringFiles, $[1] = resolveUploader2, $[2] = schemaType, $[3] = t1;
  } else
    t1 = $[3];
  t0 = t1;
  const acceptedFiles = t0;
  let t2, t3;
  $[7] !== schemaType ? (t3 = get(schemaType, "options.accept", "image/*"), $[7] = schemaType, $[8] = t3) : t3 = $[8], t2 = t3;
  const accept = t2, rejectedFilesCount = hoveringFiles.length - acceptedFiles.length;
  let t4;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    padding: 1
  }, $[9] = t4) : t4 = $[9];
  const t5 = readOnly ? "transparent" : "inherit";
  let t6;
  $[10] !== hoveringFiles.length ? (t6 = hoveringFiles.length === 0 ? {} : {
    borderColor: "transparent"
  }, $[10] = hoveringFiles.length, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== renderBrowser ? (t7 = renderBrowser(), $[12] = renderBrowser, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== accept || $[15] !== acceptedFiles || $[16] !== assetSources || $[17] !== directUploads || $[18] !== hoveringFiles || $[19] !== onSelectFiles || $[20] !== readOnly || $[21] !== rejectedFilesCount || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(UploadPlaceholder, { accept, acceptedFiles, assetSources, browse: t7, directUploads, hoveringFiles, onUpload: onSelectFiles, readOnly, rejectedFilesCount, type: "image" }), $[14] = accept, $[15] = acceptedFiles, $[16] = assetSources, $[17] = directUploads, $[18] = hoveringFiles, $[19] = onSelectFiles, $[20] = readOnly, $[21] = rejectedFilesCount, $[22] = t7, $[23] = t8) : t8 = $[23];
  let t9;
  return $[24] !== t5 || $[25] !== t6 || $[26] !== t8 ? (t9 = /* @__PURE__ */ jsx("div", { style: t4, children: /* @__PURE__ */ jsx(Card, { tone: t5, border: !0, paddingX: 3, paddingY: 2, radius: 2, style: t6, children: t8 }) }), $[24] = t5, $[25] = t6, $[26] = t8, $[27] = t9) : t9 = $[27], t9;
}
const ImageInputUploadPlaceholder = memo(ImageInputUploadPlaceholderComponent);
function InvalidImageWarning(t0) {
  const $ = c(20), {
    onClearValue
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t ? (t2 = t("inputs.image.invalid-image-warning.title"), $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("inputs.image.invalid-image-warning.description"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 4, marginBottom: 4, children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t3,
      t5
    ] })
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t ? (t7 = t("inputs.image.invalid-image-warning.reset-button.text"), $[12] = t, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== onClearValue || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { icon: ResetIcon, mode: "ghost", onClick: onClearValue, text: t7, width: "fill" }), $[14] = onClearValue, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== t6 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Card, { tone: "caution", padding: 4, border: !0, radius: 2, children: [
    t6,
    t8
  ] }), $[17] = t6, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
function BaseImageInputComponent(props2) {
  const $ = c(163), {
    assetSources,
    client,
    directUploads,
    elementProps,
    focusPath,
    id: id2,
    imageUrlBuilder: imageUrlBuilder2,
    members,
    observeAsset,
    onChange,
    onPathFocus,
    path,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview: renderPreviewProp,
    resolveUploader: resolveUploader2,
    schemaType,
    value
  } = props2, {
    push
  } = useToast(), {
    t
  } = useTranslation(), [selectedAssetSource, setSelectedAssetSource] = useState(null), [isUploading, setIsUploading] = useState(!1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [hoveringFiles, setHoveringFiles] = useState(t0), [isStale, setIsStale] = useState(!1), [hotspotButtonElement, setHotspotButtonElement] = useState(null), [menuButtonElement, setMenuButtonElement] = useState(null), [isMenuOpen, setMenuOpen] = useState(!1), uploadSubscription = useRef(null), uploaderRef = useRef(null);
  let t1;
  $[1] !== directUploads || $[2] !== hoveringFiles || $[3] !== readOnly || $[4] !== resolveUploader2 || $[5] !== schemaType || $[6] !== value?._upload || $[7] !== value?.asset ? (t1 = () => {
    const acceptedFiles = hoveringFiles.filter((file) => resolveUploader2(schemaType, file)), rejectedFilesCount = hoveringFiles.length - acceptedFiles.length;
    return hoveringFiles.length > 0 && (rejectedFilesCount > 0 || directUploads === !1) ? "critical" : !value?._upload && !readOnly && hoveringFiles.length > 0 ? "primary" : readOnly || value?._upload && value?.asset ? "transparent" : "default";
  }, $[1] = directUploads, $[2] = hoveringFiles, $[3] = readOnly, $[4] = resolveUploader2, $[5] = schemaType, $[6] = value?._upload, $[7] = value?.asset, $[8] = t1) : t1 = $[8];
  const getFileTone = t1;
  let t2;
  $[9] !== schemaType ? (t2 = () => {
    const hotspotOptions = get(schemaType, "options.hotspot");
    return typeof hotspotOptions == "object" || hotspotOptions === !0;
  }, $[9] = schemaType, $[10] = t2) : t2 = $[10];
  const isImageToolEnabled = t2;
  let t3;
  $[11] !== path ? (t3 = () => typeof path.slice(-1)[0] != "string", $[11] = path, $[12] = t3) : t3 = $[12];
  const valueIsArrayElement = t3;
  let t4;
  $[13] !== onChange || $[14] !== value?._upload ? (t4 = () => {
    value?._upload && onChange(unset(["_upload"]));
  }, $[13] = onChange, $[14] = value?._upload, $[15] = t4) : t4 = $[15];
  const clearUploadStatus = t4;
  let t5;
  $[16] !== clearUploadStatus ? (t5 = () => {
    uploadSubscription.current && (uploadSubscription.current.unsubscribe(), clearUploadStatus());
  }, $[16] = clearUploadStatus, $[17] = t5) : t5 = $[17];
  const cancelUpload = t5;
  let t6;
  $[18] !== cancelUpload || $[19] !== clearUploadStatus || $[20] !== client || $[21] !== onChange || $[22] !== push || $[23] !== schemaType || $[24] !== t ? (t6 = (uploader, file_0, t72) => {
    const assetDocumentProps = t72 === void 0 ? {} : t72, {
      label,
      title,
      description,
      creditLine,
      source
    } = assetDocumentProps, options = {
      metadata: get(schemaType, "options.metadata"),
      storeOriginalFilename: get(schemaType, "options.storeOriginalFilename"),
      label,
      title,
      description,
      creditLine,
      source
    };
    cancelUpload(), setIsUploading(!0), onChange(setIfMissing({
      _type: schemaType.name
    })), uploadSubscription.current = uploader.upload(client, file_0, schemaType, options).subscribe({
      next: (uploadEvent) => {
        uploadEvent.patches && onChange(uploadEvent.patches);
      },
      error: (err) => {
        console.error(err), push({
          status: "error",
          description: t("inputs.image.upload-error.description"),
          title: t("inputs.image.upload-error.title")
        }), clearUploadStatus();
      },
      complete: () => {
        onChange([unset(["hotspot"]), unset(["crop"]), unset(["media"])]), setIsUploading(!1);
      }
    });
  }, $[18] = cancelUpload, $[19] = clearUploadStatus, $[20] = client, $[21] = onChange, $[22] = push, $[23] = schemaType, $[24] = t, $[25] = t6) : t6 = $[25];
  const uploadWith = t6;
  let t7;
  $[26] !== onChange ? (t7 = () => {
    onChange([unset(["asset"]), unset(["crop"]), unset(["hotspot"]), unset(["media"])]);
  }, $[26] = onChange, $[27] = t7) : t7 = $[27];
  const handleClearField = t7;
  let t8;
  $[28] !== onChange || $[29] !== value || $[30] !== valueIsArrayElement ? (t8 = () => {
    const allKeys = Object.keys(value || {}), isEmpty2 = allKeys.filter(_temp$1n).length === 0, removeKeys = ["asset", "media"].concat(allKeys.filter(_temp2$t)).map(_temp3$7);
    onChange(isEmpty2 && !valueIsArrayElement() ? unset() : removeKeys);
  }, $[28] = onChange, $[29] = value, $[30] = valueIsArrayElement, $[31] = t8) : t8 = $[31];
  const handleRemoveButtonClick = t8;
  let t9;
  $[32] !== onPathFocus ? (t9 = () => {
    onPathFocus(["hotspot"]);
  }, $[32] = onPathFocus, $[33] = t9) : t9 = $[33];
  const handleOpenDialog = t9;
  let t10;
  $[34] !== hotspotButtonElement || $[35] !== onPathFocus ? (t10 = () => {
    onPathFocus([]), hotspotButtonElement?.focus();
  }, $[34] = hotspotButtonElement, $[35] = onPathFocus, $[36] = t10) : t10 = $[36];
  const handleCloseDialog = t10;
  let t11;
  $[37] !== onChange || $[38] !== resolveUploader2 || $[39] !== schemaType || $[40] !== uploadWith ? (t11 = (assetsFromSource) => {
    handleSelectAssetFromSource({
      assetsFromSource,
      onChange,
      type: schemaType,
      resolveUploader: resolveUploader2,
      uploadWith,
      isImage: !0
    }), setSelectedAssetSource(null);
  }, $[37] = onChange, $[38] = resolveUploader2, $[39] = schemaType, $[40] = uploadWith, $[41] = t11) : t11 = $[41];
  const handleSelectAssetFromSource$1 = t11;
  let t12;
  $[42] !== elementProps ? (t12 = (event) => {
    event.currentTarget === event.target && event.currentTarget === elementProps.ref?.current && elementProps.onFocus(event);
  }, $[42] = elementProps, $[43] = t12) : t12 = $[43];
  const handleFileTargetFocus = t12;
  let t13;
  $[44] !== cancelUpload ? (t13 = () => {
    cancelUpload();
  }, $[44] = cancelUpload, $[45] = t13) : t13 = $[45];
  const handleCancelUpload = t13;
  let t14;
  $[46] !== clearUploadStatus ? (t14 = () => {
    setIsStale(!1), clearUploadStatus();
  }, $[46] = clearUploadStatus, $[47] = t14) : t14 = $[47];
  const handleClearUploadState = t14;
  let t15;
  $[48] === Symbol.for("react.memo_cache_sentinel") ? (t15 = () => {
    setIsStale(!0);
  }, $[48] = t15) : t15 = $[48];
  const handleStaleUpload = t15;
  let t16;
  $[49] !== onChange || $[50] !== push || $[51] !== schemaType || $[52] !== t ? (t16 = (assetSource, files) => {
    setSelectedAssetSource(assetSource);
    const uploader_0 = assetSource.uploader;
    if (uploader_0)
      try {
        uploaderRef.current = {
          unsubscribe: uploader_0.subscribe((event_0) => {
            bb141: switch (event_0.type) {
              case "progress": {
                onChange(PatchEvent.from([set(Math.max(2, event_0.progress), [UPLOAD_STATUS_KEY, "progress"]), set((/* @__PURE__ */ new Date()).toISOString(), [UPLOAD_STATUS_KEY, "updatedAt"])]));
                break bb141;
              }
              case "error": {
                event_0.files.forEach(_temp4$3), push({
                  status: "error",
                  description: t("asset-sources.common.uploader.upload-failed.description"),
                  title: t("asset-sources.common.uploader.upload-failed.title")
                });
                break bb141;
              }
              case "all-complete": {
                onChange(PatchEvent.from([unset([UPLOAD_STATUS_KEY])])), setSelectedAssetSource(null), setIsUploading(!1), setMenuOpen(!1), uploaderRef.current = null;
                break bb141;
              }
              default:
            }
          }),
          uploader: assetSource.uploader
        }, setIsUploading(!0), onChange(PatchEvent.from(createInitialUploadPatches(files[0]))), uploader_0.upload(files, {
          schemaType,
          onChange
        });
      } catch (t172) {
        const err_0 = t172;
        onChange(PatchEvent.from([unset([UPLOAD_STATUS_KEY])])), setIsUploading(!1), setSelectedAssetSource(null), uploaderRef.current = null, push({
          status: "error",
          description: t("asset-sources.common.uploader.upload-failed.description"),
          title: t("asset-sources.common.uploader.upload-failed.title")
        }), console.error(err_0);
      }
  }, $[49] = onChange, $[50] = push, $[51] = schemaType, $[52] = t, $[53] = t16) : t16 = $[53];
  const handleSelectFilesToUpload = t16;
  let t17;
  $[54] === Symbol.for("react.memo_cache_sentinel") ? (t17 = (source_0) => {
    setSelectedAssetSource(source_0);
  }, $[54] = t17) : t17 = $[54];
  const handleSelectImageFromAssetSource = t17;
  let t18;
  $[55] !== menuButtonElement ? (t18 = () => {
    setSelectedAssetSource(null), menuButtonElement?.focus();
  }, $[55] = menuButtonElement, $[56] = t18) : t18 = $[56];
  const handleAssetSourceClosed = t18;
  let t19;
  $[57] !== directUploads || $[58] !== handleOpenDialog || $[59] !== hoveringFiles || $[60] !== imageUrlBuilder2 || $[61] !== readOnly || $[62] !== resolveUploader2 || $[63] !== schemaType || $[64] !== value ? (t19 = () => value ? /* @__PURE__ */ jsx(ImageInputPreview, { directUploads, handleOpenDialog, hoveringFiles, imageUrlBuilder: imageUrlBuilder2, readOnly, resolveUploader: resolveUploader2, schemaType, value }) : /* @__PURE__ */ jsx(Fragment, {}), $[57] = directUploads, $[58] = handleOpenDialog, $[59] = hoveringFiles, $[60] = imageUrlBuilder2, $[61] = readOnly, $[62] = resolveUploader2, $[63] = schemaType, $[64] = value, $[65] = t19) : t19 = $[65];
  const renderPreview = t19;
  let t20;
  $[66] !== assetSources || $[67] !== directUploads || $[68] !== handleOpenDialog || $[69] !== handleRemoveButtonClick || $[70] !== handleSelectFilesToUpload || $[71] !== imageUrlBuilder2 || $[72] !== isImageToolEnabled || $[73] !== isMenuOpen || $[74] !== observeAsset || $[75] !== readOnly || $[76] !== schemaType || $[77] !== value ? (t20 = () => /* @__PURE__ */ jsx(ImageInputAssetMenu, { assetSources, directUploads, handleOpenDialog, handleRemoveButtonClick, onSelectFiles: handleSelectFilesToUpload, handleSelectImageFromAssetSource, imageUrlBuilder: imageUrlBuilder2, isImageToolEnabled: isImageToolEnabled(), isMenuOpen, observeAsset, readOnly, schemaType, setHotspotButtonElement, setMenuButtonElement, setMenuOpen, value }), $[66] = assetSources, $[67] = directUploads, $[68] = handleOpenDialog, $[69] = handleRemoveButtonClick, $[70] = handleSelectFilesToUpload, $[71] = imageUrlBuilder2, $[72] = isImageToolEnabled, $[73] = isMenuOpen, $[74] = observeAsset, $[75] = readOnly, $[76] = schemaType, $[77] = value, $[78] = t20) : t20 = $[78];
  const renderAssetMenu = t20;
  let t21;
  $[79] !== assetSources || $[80] !== id2 || $[81] !== readOnly || $[82] !== schemaType ? (t21 = () => /* @__PURE__ */ jsx(ImageInputBrowser, { assetSources, readOnly, id: id2, setMenuOpen, schemaType, handleSelectImageFromAssetSource }), $[79] = assetSources, $[80] = id2, $[81] = readOnly, $[82] = schemaType, $[83] = t21) : t21 = $[83];
  const renderBrowser = t21;
  let t22;
  $[84] !== assetSources || $[85] !== directUploads || $[86] !== handleSelectFilesToUpload || $[87] !== hoveringFiles || $[88] !== readOnly || $[89] !== renderBrowser || $[90] !== resolveUploader2 || $[91] !== schemaType ? (t22 = () => /* @__PURE__ */ jsx(ImageInputUploadPlaceholder, { assetSources, directUploads, onSelectFiles: handleSelectFilesToUpload, hoveringFiles, readOnly, renderBrowser, resolveUploader: resolveUploader2, schemaType }), $[84] = assetSources, $[85] = directUploads, $[86] = handleSelectFilesToUpload, $[87] = hoveringFiles, $[88] = readOnly, $[89] = renderBrowser, $[90] = resolveUploader2, $[91] = schemaType, $[92] = t22) : t22 = $[92];
  const renderUploadPlaceholder = t22;
  let t23;
  $[93] !== handleCancelUpload || $[94] !== isUploading ? (t23 = (uploadState) => /* @__PURE__ */ jsx(UploadProgress, { uploadState, onCancel: isUploading ? handleCancelUpload : void 0, onStale: handleStaleUpload }), $[93] = handleCancelUpload, $[94] = isUploading, $[95] = t23) : t23 = $[95];
  const renderUploadState = t23;
  let t24;
  $[96] !== assetSources || $[97] !== directUploads || $[98] !== elementProps || $[99] !== getFileTone || $[100] !== handleClearField || $[101] !== handleClearUploadState || $[102] !== handleFileTargetFocus || $[103] !== handleSelectFilesToUpload || $[104] !== hoveringFiles || $[105] !== imageUrlBuilder2 || $[106] !== isStale || $[107] !== readOnly || $[108] !== renderAssetMenu || $[109] !== renderPreview || $[110] !== renderUploadPlaceholder || $[111] !== renderUploadState || $[112] !== schemaType || $[113] !== selectedAssetSource || $[114] !== value ? (t24 = () => value && typeof value.asset < "u" && !value?._upload && !isImageSource(value) ? () => /* @__PURE__ */ jsx(InvalidImageWarning, { onClearValue: handleClearField }) : (inputProps) => /* @__PURE__ */ jsx(ImageInputAsset, { assetSources, directUploads: directUploads !== !1, elementProps, handleClearUploadState, handleFileTargetFocus, hoveringFiles, imageUrlBuilder: imageUrlBuilder2, inputProps, isStale, onSelectFiles: handleSelectFilesToUpload, readOnly, renderAssetMenu, renderPreview, renderUploadPlaceholder, renderUploadState, schemaType, setHoveringFiles, selectedAssetSource, tone: getFileTone(), value }), $[96] = assetSources, $[97] = directUploads, $[98] = elementProps, $[99] = getFileTone, $[100] = handleClearField, $[101] = handleClearUploadState, $[102] = handleFileTargetFocus, $[103] = handleSelectFilesToUpload, $[104] = hoveringFiles, $[105] = imageUrlBuilder2, $[106] = isStale, $[107] = readOnly, $[108] = renderAssetMenu, $[109] = renderPreview, $[110] = renderUploadPlaceholder, $[111] = renderUploadState, $[112] = schemaType, $[113] = selectedAssetSource, $[114] = value, $[115] = t24) : t24 = $[115];
  const renderAsset = t24;
  let t25;
  $[116] !== handleCloseDialog || $[117] !== isImageToolEnabled || $[118] !== props2 ? (t25 = (inputProps_0) => /* @__PURE__ */ jsx(ImageInputHotspotInput, { isImageToolEnabled: isImageToolEnabled(), handleCloseDialog, imageInputProps: props2, inputProps: inputProps_0 }), $[116] = handleCloseDialog, $[117] = isImageToolEnabled, $[118] = props2, $[119] = t25) : t25 = $[119];
  const renderHotspotInput = t25;
  let t26;
  $[120] !== handleAssetSourceClosed || $[121] !== handleSelectAssetFromSource$1 || $[122] !== isUploading || $[123] !== observeAsset || $[124] !== schemaType || $[125] !== selectedAssetSource || $[126] !== value ? (t26 = () => /* @__PURE__ */ jsx(ImageInputAssetSource, { handleAssetSourceClosed, handleSelectAssetFromSource: handleSelectAssetFromSource$1, isUploading, observeAsset, schemaType, selectedAssetSource, value }), $[120] = handleAssetSourceClosed, $[121] = handleSelectAssetFromSource$1, $[122] = isUploading, $[123] = observeAsset, $[124] = schemaType, $[125] = selectedAssetSource, $[126] = value, $[127] = t26) : t26 = $[127];
  const renderAssetSource = t26;
  let t27, t28;
  $[128] !== members ? (t28 = members.find(_temp5$2), $[128] = members, $[129] = t28) : t28 = $[129], t27 = t28;
  const hotspotField = t27;
  let t29;
  if ($[130] !== members || $[131] !== renderAnnotation || $[132] !== renderAsset || $[133] !== renderBlock2 || $[134] !== renderField || $[135] !== renderInlineBlock || $[136] !== renderInput || $[137] !== renderItem2 || $[138] !== renderPreviewProp || $[139] !== t) {
    let t302;
    $[141] !== renderAnnotation || $[142] !== renderAsset || $[143] !== renderBlock2 || $[144] !== renderField || $[145] !== renderInlineBlock || $[146] !== renderInput || $[147] !== renderItem2 || $[148] !== renderPreviewProp || $[149] !== t ? (t302 = (member_0) => member_0.kind === "field" && (member_0.name === "crop" || member_0.name === "hotspot") ? null : member_0.kind === "field" ? /* @__PURE__ */ jsx(MemberField, { member: member_0, renderAnnotation, renderBlock: renderBlock2, renderInlineBlock, renderInput: member_0.name === "asset" ? renderAsset() : renderInput, renderField: member_0.name === "asset" ? passThrough : renderField, renderItem: renderItem2, renderPreview: renderPreviewProp }, member_0.key) : member_0.kind === "fieldSet" ? /* @__PURE__ */ jsx(MemberFieldSet, { member: member_0, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview: renderPreviewProp }, member_0.key) : member_0.kind === "error" ? /* @__PURE__ */ jsx(MemberFieldError, { member: member_0 }, member_0.key) : /* @__PURE__ */ jsx(Fragment, { children: t("inputs.image.error.unknown-member-kind", {
      kind: member_0.kind
    }) }), $[141] = renderAnnotation, $[142] = renderAsset, $[143] = renderBlock2, $[144] = renderField, $[145] = renderInlineBlock, $[146] = renderInput, $[147] = renderItem2, $[148] = renderPreviewProp, $[149] = t, $[150] = t302) : t302 = $[150], t29 = members.map(t302), $[130] = members, $[131] = renderAnnotation, $[132] = renderAsset, $[133] = renderBlock2, $[134] = renderField, $[135] = renderInlineBlock, $[136] = renderInput, $[137] = renderItem2, $[138] = renderPreviewProp, $[139] = t, $[140] = t29;
  } else
    t29 = $[140];
  let t30;
  $[151] !== focusPath || $[152] !== hotspotField || $[153] !== props2 || $[154] !== renderHotspotInput ? (t30 = hotspotField && focusPath[0] === "hotspot" && /* @__PURE__ */ jsx(FormInput, { ...props2, absolutePath: hotspotField.field.path, renderInput: renderHotspotInput }), $[151] = focusPath, $[152] = hotspotField, $[153] = props2, $[154] = renderHotspotInput, $[155] = t30) : t30 = $[155];
  let t31;
  $[156] !== renderAssetSource || $[157] !== selectedAssetSource ? (t31 = selectedAssetSource && renderAssetSource(), $[156] = renderAssetSource, $[157] = selectedAssetSource, $[158] = t31) : t31 = $[158];
  let t32;
  return $[159] !== t29 || $[160] !== t30 || $[161] !== t31 ? (t32 = /* @__PURE__ */ jsxs(Stack, { space: 5, "data-testid": "image-input", children: [
    t29,
    t30,
    t31
  ] }), $[159] = t29, $[160] = t30, $[161] = t31, $[162] = t32) : t32 = $[162], t32;
}
function _temp5$2(member) {
  return member.kind === "field" && member.name === "hotspot";
}
function _temp4$3(file_1) {
  console.error(file_1.error);
}
function _temp3$7(key_1) {
  return unset([key_1]);
}
function _temp2$t(key_0) {
  return ["crop", "hotspot", "_upload"].includes(key_0);
}
function _temp$1n(key) {
  return !["_type", "_key", "_upload", "asset", "crop", "hotspot", "media"].includes(key);
}
const BaseImageInput = memo(BaseImageInputComponent);
function passThrough({
  children
}) {
  return children;
}
function StudioImageInput(props2) {
  const $ = c(15), sourcesFromSchema = props2.schemaType.options?.sources, {
    image: imageConfig
  } = useFormBuilder().__internal, documentPreviewStore = useDocumentPreviewStore(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), supportsImageUploads = imageConfig.directUploads;
  let t0;
  $[0] !== supportsImageUploads ? (t0 = (type, file) => supportsImageUploads ? resolveUploader(type, file) : null, $[0] = supportsImageUploads, $[1] = t0) : t0 = $[1];
  const resolveUploader$1 = t0, assetSources = sourcesFromSchema || imageConfig.assetSources;
  let t1, t2;
  $[2] !== client ? (t2 = imageUrlBuilder(client), $[2] = client, $[3] = t2) : t2 = $[3], t1 = t2;
  const builder = t1;
  let t3;
  $[4] !== documentPreviewStore ? (t3 = (id2) => observeImageAsset(documentPreviewStore, id2), $[4] = documentPreviewStore, $[5] = t3) : t3 = $[5];
  const observeAsset = t3, {
    t
  } = useTranslation();
  let t4;
  return $[6] !== assetSources || $[7] !== builder || $[8] !== client || $[9] !== observeAsset || $[10] !== props2 || $[11] !== resolveUploader$1 || $[12] !== supportsImageUploads || $[13] !== t ? (t4 = /* @__PURE__ */ jsx(BaseImageInput, { ...props2, t, client, assetSources, directUploads: supportsImageUploads, imageUrlBuilder: builder, observeAsset, resolveUploader: resolveUploader$1 }), $[6] = assetSources, $[7] = builder, $[8] = client, $[9] = observeAsset, $[10] = props2, $[11] = resolveUploader$1, $[12] = supportsImageUploads, $[13] = t, $[14] = t4) : t4 = $[14], t4;
}
const defaultInputs = {
  document: ObjectInput,
  object: ObjectInput,
  array: UniversalArrayInput,
  boolean: BooleanInput,
  number: NumberInput,
  text: TextInput,
  email: EmailInput,
  datetime: DateTimeInput$2,
  date: DateInput,
  url: UrlInput,
  image: StudioImageInput,
  file: StudioFileInput,
  string: StringInput,
  slug: SlugInput,
  crossDatasetReference: StudioCrossDatasetReferenceInput,
  globalDocumentReference: StudioGlobalDocumentReferenceInput
}, PortableTextInputExpanded = defineEvent({
  version: 1,
  name: "Portable Text Editor Expanded",
  description: "The portable text editor was expanded"
}), PortableTextInputCollapsed = defineEvent({
  version: 1,
  name: "Portable Text Editor Collapsed",
  description: "The portable text editor was collapsed"
}), PortableTextInvalidValueIgnore = defineEvent({
  version: 1,
  name: "Portable Text Editor Invalid Value Ignored",
  description: "The portable text got an invalid value from the form and pressed button to ignore it"
}), PortableTextInvalidValueResolve = defineEvent({
  version: 1,
  name: "Portable Text Editor Invalid Value Resolved",
  description: "The portable text got an invalid value from the form and pressed button to resolve it."
}), CreatedDraft = defineEvent({
  name: "New Draft Created",
  version: 1,
  description: "User created a new draft"
}), OverlayContainer = styled.div`
  position: relative;
`, ContentContainer = styled.div`
  z-index: 13;
  opacity: 0;
  transition: opacity 300ms linear;
`, CardContainer = styled(Card)`
  border: 1px solid var(--card-border-color);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 12;
  transition: opacity 150ms ease-in-out;
  opacity: 0;
  box-sizing: border-box;
`, FlexContainer = styled(Flex)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &:hover,
  &:focus {
    & ${CardContainer} {
      opacity: 0.9;
    }

    & ${ContentContainer} {
      opacity: 1;
    }
  }
`, isTouchDevice = () => typeof window < "u" && "ontouchstart" in window || typeof navigator < "u" && navigator.maxTouchPoints > 0;
function ActivateOnFocus(props2) {
  const $ = c(25), {
    children,
    message,
    onActivate,
    isOverlayActive
  } = props2, [focused, setFocused] = useState(!1), {
    t
  } = useTranslation();
  let t0;
  $[0] !== onActivate ? (t0 = () => {
    onActivate && onActivate();
  }, $[0] = onActivate, $[1] = t0) : t0 = $[1];
  const handleClick = t0;
  let t1;
  $[2] !== isOverlayActive || $[3] !== onActivate ? (t1 = (event) => {
    isOverlayActive && event.code === "Space" && onActivate && (event.preventDefault(), onActivate());
  }, $[2] = isOverlayActive, $[3] = onActivate, $[4] = t1) : t1 = $[4];
  const handleKeyDown = t1;
  let t2;
  $[5] !== isOverlayActive || $[6] !== onActivate ? (t2 = () => {
    isOverlayActive && onActivate && onActivate();
  }, $[5] = isOverlayActive, $[6] = onActivate, $[7] = t2) : t2 = $[7];
  const handleDragEnter = t2;
  let t3;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setFocused(!0);
  }, $[8] = t3) : t3 = $[8];
  const handleOnFocus = t3;
  let t4;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setFocused(!1);
  }, $[9] = t4) : t4 = $[9];
  const handleBlur = t4;
  let t5;
  const isTouch = isTouchDevice();
  let messageContext;
  isTouch ? messageContext = "tap" : focused ? messageContext = "click-focused" : messageContext = "click";
  let t6;
  $[10] !== message || $[11] !== messageContext || $[12] !== t ? (t6 = message || t("inputs.portable-text.activate-on-focus-message", {
    context: messageContext
  }), $[10] = message, $[11] = messageContext, $[12] = t, $[13] = t6) : t6 = $[13];
  const text = t6;
  let t7;
  $[14] !== text ? (t7 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: text }), $[14] = text, $[15] = t7) : t7 = $[15], t5 = t7;
  const msg = t5;
  let t8;
  $[16] !== isOverlayActive || $[17] !== msg ? (t8 = isOverlayActive && /* @__PURE__ */ jsxs(FlexContainer, { "data-testid": "activate-overlay", tabIndex: 0, align: "center", justify: "center", children: [
    /* @__PURE__ */ jsx(CardContainer, { radius: 2 }),
    /* @__PURE__ */ jsx(ContentContainer, { children: msg })
  ] }), $[16] = isOverlayActive, $[17] = msg, $[18] = t8) : t8 = $[18];
  let t9;
  return $[19] !== children || $[20] !== handleClick || $[21] !== handleDragEnter || $[22] !== handleKeyDown || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsxs(OverlayContainer, { onBlur: handleBlur, onClick: handleClick, onFocus: handleOnFocus, onKeyDown: handleKeyDown, onDragEnter: handleDragEnter, children: [
    t8,
    children
  ] }), $[19] = children, $[20] = handleClick, $[21] = handleDragEnter, $[22] = handleKeyDown, $[23] = t8, $[24] = t9) : t9 = $[24], t9;
}
const Root$l = styled.div((props2) => {
  const {
    color,
    input,
    radius
  } = getTheme_v2(props2.theme), border = {
    color: color.input.default.enabled.border,
    width: input.border.width
  };
  return css`
    --input-box-shadow: ${focusRingBorderStyle$2(border)};

    position: relative;

    & [data-wrapper] {
      overflow: hidden;
      overflow: clip;
      position: relative;
      z-index: 1;
      padding: ${input.border.width}px;
    }

    & [data-border] {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      box-shadow: var(--input-box-shadow);
      z-index: 2;
      border-radius: ${radius[2]}px;
      pointer-events: none;
    }

    &:not([data-read-only])[data-focused] [data-border] {
      --input-box-shadow: ${focusRingStyle$1({
    base: color,
    border,
    focusRing: input.text.focusRing
  })};
    }
  `;
}), ExpandedLayer = styled(Layer)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  & > div {
    height: 100%;
  }
`;
function usePortableTextMemberItemElementRefs() {
  const $ = c(1), behaviorSubject = useContext(PortableTextMemberItemElementRefsContext);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0], useObservable(behaviorSubject, t0);
}
function useSetPortableTextMemberItemElementRef() {
  const $ = c(2), behaviorSubject = useContext(PortableTextMemberItemElementRefsContext);
  let t0;
  return $[0] !== behaviorSubject ? (t0 = (t1) => {
    const {
      key,
      elementRef
    } = t1;
    behaviorSubject.next({
      ...behaviorSubject.value,
      [key]: elementRef
    });
  }, $[0] = behaviorSubject, $[1] = t0) : t0 = $[1], t0;
}
const TEXT_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8, 9], TEXT_BULLET_MARKERS = ["\u25CF", "\u25CB", "\u25A0"], TEXT_NUMBER_FORMATS = ["number", "lower-alpha", "lower-roman"], TEXT_DECORATOR_TAGS = {
  em: "em",
  "strike-through": "s",
  underline: "u",
  strong: "strong",
  code: "code"
}, TEXT_STYLE_PADDING = {
  h1: {
    paddingTop: 5,
    paddingBottom: 4
  },
  h2: {
    paddingTop: 4,
    paddingBottom: 4
  },
  h3: {
    paddingTop: 4,
    paddingBottom: 3
  },
  h4: {
    paddingTop: 4,
    paddingBottom: 3
  },
  h5: {
    paddingTop: 4,
    paddingBottom: 3
  },
  h6: {
    paddingTop: 4,
    paddingBottom: 2
  },
  normal: {
    paddingTop: 2,
    paddingBottom: 3
  },
  blockquote: {
    paddingTop: 2,
    paddingBottom: 3
  }
}, Root$k = styled.span(({
  theme
}) => {
  const isDark = theme.sanity.color.dark;
  return css`
    /* Make sure the annotation styling is visible */
    &[data-mark='code'] {
      color: inherit;
      mix-blend-mode: ${isDark ? "screen" : "multiply"};
    }
  `;
});
function Decorator$1(props2) {
  const $ = c(14), {
    value,
    focused,
    selected,
    children,
    schemaType
  } = props2, tag = TEXT_DECORATOR_TAGS[value], CustomComponent = schemaType.component;
  let t0;
  $[0] !== tag || $[1] !== value ? (t0 = (defaultComponentProps) => /* @__PURE__ */ jsx(Root$k, { as: tag, "data-mark": value, children: defaultComponentProps.children }), $[0] = tag, $[1] = value, $[2] = t0) : t0 = $[2];
  const DefaultComponent2 = t0;
  let t1, t2;
  $[3] !== DefaultComponent2 || $[4] !== focused || $[5] !== schemaType || $[6] !== selected || $[7] !== value ? (t2 = {
    focused,
    renderDefault: DefaultComponent2,
    schemaType,
    selected,
    title: schemaType.title,
    value
  }, $[3] = DefaultComponent2, $[4] = focused, $[5] = schemaType, $[6] = selected, $[7] = value, $[8] = t2) : t2 = $[8];
  const componentProps = t2;
  let t3;
  return $[9] !== CustomComponent || $[10] !== DefaultComponent2 || $[11] !== children || $[12] !== componentProps ? (t3 = CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps, children }) : /* @__PURE__ */ jsx(DefaultComponent2, { ...componentProps, children }), $[9] = CustomComponent, $[10] = DefaultComponent2, $[11] = children, $[12] = componentProps, $[13] = t3) : t3 = $[13], t1 = t3, t1;
}
function createListName(level) {
  return `list-level-${level}`;
}
const ReviewChangesHighlightBlock = styled.div(({
  theme
}) => {
  const {
    radius,
    space,
    color
  } = theme.sanity, bg = rgba(color.spot.yellow, 0.2);
  return css`
    position: absolute;
    border-radius: ${radius[3]}px;
    top: -${space[2]}px;
    bottom: -${space[1] + space[1]}px;
    left: ${space[4] + space[1]}px;
    right: ${space[1]}px;
    background-color: ${bg};
    pointer-events: none;
  `;
}), StyledChangeIndicatorWithProvidedFullPath = styled(ChangeIndicator)(() => css`
    width: 1px;
    height: 100%;

    & > div {
      height: 100%;
    }
  `);
function createInsertCallback(options) {
  const {
    allowedDecorators,
    block,
    onChange
  } = options;
  let toInsert;
  return (givenBlock) => {
    toInsert = Array.isArray(givenBlock) ? givenBlock : [givenBlock], toInsert = toInsert.map((blk) => normalizeBlock(blk, {
      allowedDecorators
    }));
    const patches = [insert$1(toInsert, "after", [{
      _key: block._key
    }])];
    return onChange(PatchEvent.from(patches));
  };
}
function createSetCallback(options) {
  const {
    allowedDecorators,
    block,
    onChange
  } = options;
  return (givenBlock) => {
    const patches = [set(normalizeBlock(givenBlock, {
      allowedDecorators
    }), [{
      _key: block._key
    }])];
    return onChange(PatchEvent.from(patches));
  };
}
function createUnsetCallback(options) {
  const {
    block,
    onChange
  } = options;
  return () => {
    const patches = [unset([{
      _key: block._key
    }])];
    return onChange(PatchEvent.from(patches));
  };
}
const Root$j = styled.div`
  display: flex;
  pointer-events: all;
`;
function BlockActions(props2) {
  const editor2 = usePortableTextEditor(), {
    block,
    onChange,
    renderBlockActions
  } = props2, decoratorValues = useMemo(() => editor2.schemaTypes.decorators.map((d) => d.value), [editor2]), blockActions = useMemo(() => {
    if (renderBlockActions) {
      const blockActionProps = {
        block,
        value: PortableTextEditor.getValue(editor2),
        set: createSetCallback({
          allowedDecorators: decoratorValues,
          block,
          onChange
        }),
        unset: createUnsetCallback({
          block,
          onChange
        }),
        insert: createInsertCallback({
          allowedDecorators: decoratorValues,
          block,
          onChange
        })
      };
      return renderBlockActions(blockActionProps);
    }
  }, [renderBlockActions, block, editor2, onChange, decoratorValues]);
  return blockActions ? /* @__PURE__ */ jsx(Root$j, { contentEditable: !1, children: blockActions }) : null;
}
function textBlockStyle(props2) {
  const {
    $level
  } = props2, {
    color,
    font,
    radius,
    space
  } = getTheme_v2(props2.theme), numberMarker = TEXT_NUMBER_FORMATS[($level - 1) % TEXT_NUMBER_FORMATS.length], bulletMarker = TEXT_BULLET_MARKERS[($level - 1) % TEXT_BULLET_MARKERS.length];
  return css`
    --marker-bg-color: transparent;

    mix-blend-mode: ${color._dark ? "screen" : "multiply"};
    position: relative;

    & > [data-ui='TextBlock_inner'] {
      position: relative;
      flex: 1;
    }

    & > div:before {
      content: '';
      position: absolute;
      top: -${space[1]}px;
      bottom: -${space[1]}px;
      left: -${space[1]}px;
      right: -${space[1]}px;
      border-radius: ${radius[2]}px;
      background-color: var(--marker-bg-color);
      // This is to make sure the marker is always behind the text
      z-index: -1;
      pointer-events: none;
    }

    &[data-markers] {
      --marker-bg-color: ${color._dark ? hues.purple[950].hex : hues.purple[50].hex};
    }

    &[data-warning] {
      --card-border-color: ${color.button.ghost.caution.enabled.border};
      --marker-bg-color: ${color.button.ghost.caution.hovered.bg};
    }

    &[data-error] {
      --card-border-color: ${color.button.ghost.critical.enabled.border};
      --marker-bg-color: ${color.button.ghost.critical.hovered.bg};
    }

    & [data-list-prefix] {
      position: absolute;
      margin-left: -4.5rem;
      width: 3.75rem;
      text-align: right;
      box-sizing: border-box;
    }

    &[data-list-item='number'] [data-list-prefix] {
      font-variant-numeric: tabular-nums;

      & > span:before {
        content: counter(${createListName($level)}) '.';
        content: counter(${createListName($level)}, ${numberMarker}) '.';
      }
    }

    &[data-list-item='bullet'] [data-list-prefix] {
      & > span {
        position: relative;
        top: -0.1875em;

        &:before {
          content: '${bulletMarker}';
          font-size: 0.46666em;
        }
      }
    }

    & [data-text] {
      overflow-wrap: anywhere;
      text-transform: none;
      white-space: pre-wrap;
      font-family: ${font.text.family};
      flex: 1;

      *::selection {
        background-color: ${rgba$1(color.focusRing, 0.3)};
      }
    }
  `;
}
const TextRoot = styled.div(textBlockStyle), TextBlockFlexWrapper = styled(Box)`
  position: relative;
  display: flex;
`, ListPrefixWrapper = styled.div`
  user-select: none;
  white-space: nowrap;
`, BlockActionsOuter$1 = styled(Box)`
  line-height: 0;
  width: 25px;
  position: relative;
`, BlockActionsInner$1 = styled(Flex)(({
  theme
}) => {
  const {
    fonts,
    space
  } = theme.sanity, textSize1 = fonts.text.sizes[1], textSize2 = fonts.text.sizes[2], capHeight1 = textSize1.lineHeight - textSize1.ascenderHeight - textSize1.descenderHeight, capHeight2 = textSize2.lineHeight - textSize2.ascenderHeight - textSize2.descenderHeight, negativeTop = 0 - (capHeight1 + space[2] + space[2] - capHeight2) / 2;
  return css`
    user-select: none;
    position: absolute;
    right: 0;
    top: ${negativeTop}px;
  `;
}), TooltipBox$2 = styled(Box)`
  max-width: 250px;
`, TextFlex = styled(Flex)`
  position: relative;
  padding-left: ${({
  $level
}) => $level ? $level * 32 : 0}px;
`, ChangeIndicatorWrapper$1 = styled.div(({
  theme,
  $hasChanges
}) => {
  const {
    space
  } = theme.sanity;
  return css`
      position: absolute;
      width: ${space[2]}px;
      right: 0;
      top: 0;
      bottom: 0;
      padding-left: ${space[1]}px;
      padding-right: ${space[2]}px;
      user-select: none;

      ${!$hasChanges && css`
        display: none;
      `}
    `;
}), TextContainer = styled.div`
  display: block;
`, Normal = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { "data-testid": "text-style--normal", ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading1 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h1", "data-testid": "text-style--h1", size: 5, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading2 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h2", "data-testid": "text-style--h2", size: 4, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading3 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h3", "data-testid": "text-style--h3", size: 3, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading4 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h4", "data-testid": "text-style--h4", size: 2, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading5 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h5", "data-testid": "text-style--h5", size: 1, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, Heading6 = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  let t1;
  $[3] !== children ? (t1 = /* @__PURE__ */ jsx(TextContainer, { children }), $[3] = children, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== rest || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Heading, { as: "h6", "data-testid": "text-style--h6", size: 0, ...rest, children: t1 }), $[5] = rest, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, BlockQuoteRoot = styled.blockquote`
  position: relative;
  display: block;
  margin: 0;
  padding-left: ${({
  theme
}) => theme.sanity.space[3]}px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: -4px;
    bottom: -4px;
    width: 3px;
    background: var(--card-border-color);
  }
`, BlockQuote = (t0) => {
  const $ = c(8);
  let children, rest;
  $[0] !== t0 ? ({
    children,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = rest) : (children = $[1], rest = $[2]);
  const t1 = rest;
  let t2;
  $[3] !== children ? (t2 = /* @__PURE__ */ jsx(Text$1, { as: "p", children }), $[3] = children, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== t1 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(BlockQuoteRoot, { "data-testid": "text-style--blockquote", ...t1, children: t2 }), $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, TEXT_STYLES = {
  normal: Normal,
  h1: Heading1,
  h2: Heading2,
  h3: Heading3,
  h4: Heading4,
  h5: Heading5,
  h6: Heading6,
  blockquote: BlockQuote
};
function TextBlock(props2) {
  const {
    children,
    floatingBoundary,
    focused,
    isFullscreen,
    onItemClose,
    onItemOpen,
    onPathFocus,
    path,
    readOnly,
    referenceBoundary,
    renderBlock: renderBlock2,
    renderAnnotation,
    renderBlockActions,
    renderCustomMarkers,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    setElementRef,
    spellCheck,
    value
  } = props2, {
    Markers
  } = useFormBuilder().__internal.components, [reviewChangesHovered, setReviewChangesHovered] = useState(!1), markers = usePortableTextMarkers(path), [divElement, setDivElement] = useState(null), memberItem = usePortableTextMemberItem(pathToString$1(path)), editor2 = usePortableTextEditor(), {
    onChange
  } = useFormCallbacks(), presence = useChildPresence(path, !0), textPresence = useMemo(() => presence.filter((p) => isEqual$3(p.path, path) || p.path.slice(-3)[1] === "children" && p.path.length - path.length === 2), [path, presence]), handleChangeIndicatorMouseEnter = useCallback(() => setReviewChangesHovered(!0), []), handleChangeIndicatorMouseLeave = useCallback(() => setReviewChangesHovered(!1), []), {
    validation: validation2,
    hasError,
    hasWarning,
    hasInfo
  } = useMemberValidation(memberItem?.node), hasMarkers = !!renderCustomMarkers && markers.length > 0, tooltipEnabled = hasError || hasWarning || hasMarkers || hasInfo, onOpen = useCallback(() => {
    memberItem && onItemOpen(memberItem.node.path);
  }, [onItemOpen, memberItem]), onRemove = useCallback(() => {
    const point = {
      path: path.slice(-1),
      offset: 0
    }, sel = {
      focus: point,
      anchor: point
    };
    PortableTextEditor.delete(editor2, sel, {
      mode: "blocks"
    }), PortableTextEditor.focus(editor2);
  }, [path, editor2]), text = useMemo(() => /* @__PURE__ */ jsxs(TextFlex, { align: "flex-start", $level: value?.level, children: [
    value.listItem && /* @__PURE__ */ jsx(ListPrefixWrapper, { contentEditable: !1, children: /* @__PURE__ */ jsx(Text$1, { "data-list-prefix": "", children: /* @__PURE__ */ jsx(TextContainer, {}) }) }),
    /* @__PURE__ */ jsx("div", { "data-text": "", style: void 0, children })
  ] }), [value.listItem, value.level, children]), innerPaddingProps = useMemo(() => isFullscreen && !renderBlockActions ? {
    paddingX: 5
  } : isFullscreen && renderBlockActions ? {
    paddingLeft: 5,
    paddingRight: 2
  } : renderBlockActions ? {
    paddingLeft: 3,
    paddingRight: 2
  } : {
    paddingX: 3
  }, [isFullscreen, renderBlockActions]), outerPaddingProps = useMemo(() => value.listItem ? {
    paddingY: 2
  } : TEXT_STYLE_PADDING[value.style || "normal"] || {
    paddingY: 2
  }, [value]), isOpen = !!memberItem?.member.open, parentSchemaType = editor2.schemaTypes.portableText, referenceElement = divElement, componentProps = useMemo(() => ({
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    children: text,
    focused,
    markers,
    onClose: onItemClose,
    onOpen,
    onPathFocus,
    onRemove,
    open: isOpen,
    parentSchemaType,
    path: memberItem?.node.path || EMPTY_ARRAY$A,
    presence: textPresence,
    readOnly: !!readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderDefault: DefaultComponent$1,
    renderField,
    renderInput,
    renderInlineBlock,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    validation: validation2,
    value
  }), [floatingBoundary, focused, isOpen, markers, memberItem?.node.path, onItemClose, onOpen, onPathFocus, onRemove, parentSchemaType, readOnly, referenceBoundary, referenceElement, renderAnnotation, renderBlock2, renderField, renderInlineBlock, renderInput, renderItem2, renderPreview, schemaType, selected, text, textPresence, validation2, value]), toolTipContent = useMemo(() => tooltipEnabled && /* @__PURE__ */ jsx(TooltipBox$2, { children: /* @__PURE__ */ jsx(Markers, { markers, renderCustomMarkers, validation: validation2 }) }) || null, [Markers, markers, renderCustomMarkers, tooltipEnabled, validation2]), blockActionsEnabled = renderBlockActions && !readOnly, changeIndicatorVisible = isFullscreen && memberItem, setRef = useCallback((elm) => {
    memberItem && setElementRef({
      key: memberItem.member.key,
      elementRef: elm
    }), setDivElement(elm);
  }, [memberItem, setElementRef, setDivElement]);
  return useMemo(() => /* @__PURE__ */ jsx(Box, { ...outerPaddingProps, "data-testid": "text-block", ref: setRef, style: void 0, children: /* @__PURE__ */ jsx(TextBlockFlexWrapper, { "data-testid": "text-block__wrapper", children: /* @__PURE__ */ jsxs(Flex, { flex: 1, ...innerPaddingProps, children: [
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Tooltip, { content: toolTipContent, disabled: !tooltipEnabled, placement: "top", portal: "editor", children: /* @__PURE__ */ jsx(TextRoot, { $level: value.level || 1, "data-error": hasError ? "" : void 0, "data-list-item": value.listItem, "data-markers": hasMarkers ? "" : void 0, "data-read-only": readOnly, "data-testid": "text-block__text", "data-warning": hasWarning ? "" : void 0, spellCheck, children: renderBlock2 && renderBlock2(componentProps) }) }) }),
    blockActionsEnabled && /* @__PURE__ */ jsx(BlockActionsOuter$1, { contentEditable: !1, marginRight: 3, children: /* @__PURE__ */ jsx(BlockActionsInner$1, { children: focused && /* @__PURE__ */ jsx(BlockActions, { block: value, onChange, renderBlockActions }) }) }),
    changeIndicatorVisible && /* @__PURE__ */ jsx(ChangeIndicatorWrapper$1, { $hasChanges: memberItem.member.item.changed, contentEditable: !1, onMouseEnter: handleChangeIndicatorMouseEnter, onMouseLeave: handleChangeIndicatorMouseLeave, children: /* @__PURE__ */ jsx(StyledChangeIndicatorWithProvidedFullPath, { hasFocus: focused, isChanged: memberItem.member.item.changed, path: memberItem.member.item.path, withHoverEffect: !1 }) }),
    reviewChangesHovered && /* @__PURE__ */ jsx(ReviewChangesHighlightBlock, {})
  ] }) }) }), [blockActionsEnabled, changeIndicatorVisible, componentProps, focused, handleChangeIndicatorMouseEnter, handleChangeIndicatorMouseLeave, hasError, hasMarkers, hasWarning, innerPaddingProps, memberItem, onChange, outerPaddingProps, readOnly, renderBlock2, renderBlockActions, reviewChangesHovered, setRef, spellCheck, toolTipContent, tooltipEnabled, value]);
}
const DefaultComponent$1 = (props2) => {
  const $ = c(2);
  let t0;
  return $[0] !== props2.children ? (t0 = /* @__PURE__ */ jsx(Fragment, { children: props2.children }), $[0] = props2.children, $[1] = t0) : t0 = $[1], t0;
}, Root$i = styled(Card)`
  &[data-fullscreen='true'] {
    height: 100%;
  }

  &[data-fullscreen='false'] {
    min-height: 5em;
    resize: vertical;
    overflow: auto;
    height: 19em;
  }

  &:not([hidden]) {
    display: flex;
  }

  flex-direction: column;
`, ToolbarCard = styled(Card)`
  z-index: 10;
  line-height: 0;
`, EditableCard = styled(Card)`
  position: relative;
  overflow: hidden;
  overflow: clip;

  & > [data-portal] {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;

    & > * {
      pointer-events: initial;
    }
  }

  &::selection,
  *::selection {
    background-color: transparent;
  }
`, Scroller = styled(ScrollContainer)`
  position: relative;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;

  & > * {
    flex: 1;
    min-height: auto;
  }
`, EditableWrapper = styled(Card)`
  height: 100%;
  width: 100%;
  counter-reset: ${TEXT_LEVELS.map((l) => createListName(l)).join(" ")};
  overflow: hidden;
  overflow: clip;

  & > div {
    height: 100%;
  }

  & .pt-editable {
    display: block;
    width: 100%;
    height: 100%;

    ${TEXT_LEVELS.map((l) => css`
        & > .pt-list-item-number[class~='pt-list-item-level-${l}'] {
          counter-increment: ${createListName(l)};
        }
      `)}

    & > .pt-list-item-bullet + .pt-list-item-number,
    & > .pt-list-item-number + .pt-list-item-bullet {
      margin-top: ${({
  theme
}) => theme.sanity.space[3]}px;
    }

    & > :not(.pt-list-item) + .pt-list-item {
      margin-top: ${({
  theme
}) => theme.sanity.space[2]}px;
    }

    /* Reset the list count if the element is not a numbered list item */
    & > :not(.pt-list-item-number) {
      counter-set: ${TEXT_LEVELS.map((l) => createListName(l)).join(" ")};
    }

    /* Reset the list count all the sub-list items */
    & > .pt-list-item-number.pt-list-item-level-${TEXT_LEVELS[0]} {
      counter-set: ${TEXT_LEVELS.slice(1).map((l) => createListName(l)).join(" ")};
    }

    & > .pt-list-item + :not(.pt-list-item) {
      margin-top: ${({
  theme
}) => theme.sanity.space[3]}px;
    }

    & > :first-child {
      padding-top: ${({
  $isFullscreen,
  theme
}) => theme.sanity.space[$isFullscreen ? 5 : 3]}px;
    }

    padding-bottom: ${({
  $isFullscreen,
  theme
}) => theme.sanity.space[$isFullscreen ? 9 : 5]}px;

    & > .pt-block {
      margin: 0 auto;
      max-width: ${(props2) => getTheme_v2(props2.theme).container[1]}px;
    }

    /* & > .pt-block {
      & .pt-inline-object {
      }
    } */

    & .pt-drop-indicator {
      pointer-events: none;
      border: 1px solid var(--card-focus-ring-color) !important;
      height: 0px !important;
      border-radius: ${(props2) => getTheme_v2(props2.theme).radius[2]}px;
      margin-top: -3px;
      left: calc(
        ${({
  $isFullscreen,
  theme
}) => $isFullscreen ? rem(theme.sanity.space[5]) : rem(theme.sanity.space[3])} -
          1px
      );
      right: calc(
        ${({
  $isFullscreen,
  theme
}) => $isFullscreen ? rem(theme.sanity.space[5]) : rem(theme.sanity.space[3])} -
          1px
      );
      width: calc(
        100% -
          ${({
  $isFullscreen,
  theme
}) => $isFullscreen ? rem(theme.sanity.space[5] * 2) : rem(theme.sanity.space[3] * 2)} +
          2px
      ) !important;
    }
  }
`;
function useScrollSelectionIntoView(scrollElement) {
  const $ = c(2);
  let t0, t1;
  return $[0] !== scrollElement ? (t1 = (editor2, domRange) => {
    if (PortableTextEditor.getSelection(editor2)) {
      const leafEl = domRange.startContainer.parentElement;
      if (!leafEl)
        return;
      scrollIntoView$1(leafEl, {
        scrollMode: "if-needed",
        boundary: scrollElement,
        block: "nearest",
        inline: "nearest"
      });
    }
  }, $[0] = scrollElement, $[1] = t1) : t1 = $[1], t0 = t1, t0;
}
function useSpellCheck() {
  const editor2 = usePortableTextEditor();
  let t0;
  const spellCheckOption = editor2.schemaTypes.block.options?.spellCheck, isChrome96 = typeof navigator > "u" ? !1 : /Chrome\/96/.test(navigator.userAgent);
  return t0 = spellCheckOption === void 0 && isChrome96 === !0 ? !1 : spellCheckOption, t0;
}
const DefaultComponent = (dProps) => {
  const $ = c(2);
  let t0;
  return $[0] !== dProps.children ? (t0 = /* @__PURE__ */ jsx(Fragment, { children: dProps.children }), $[0] = dProps.children, $[1] = t0) : t0 = $[1], t0;
}, ListItem$1 = (props2) => {
  const $ = c(12), {
    block,
    children,
    schemaType,
    selected,
    focused,
    level,
    value
  } = props2, {
    title,
    component: CustomComponent
  } = schemaType;
  let t0, t1;
  $[0] !== block || $[1] !== focused || $[2] !== level || $[3] !== schemaType || $[4] !== selected || $[5] !== title || $[6] !== value ? (t1 = {
    block,
    focused,
    level,
    renderDefault: DefaultComponent,
    schemaType,
    selected,
    title,
    value
  }, $[0] = block, $[1] = focused, $[2] = level, $[3] = schemaType, $[4] = selected, $[5] = title, $[6] = value, $[7] = t1) : t1 = $[7];
  const componentProps = t1;
  let t2;
  return $[8] !== CustomComponent || $[9] !== children || $[10] !== componentProps ? (t2 = CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps, children }) : /* @__PURE__ */ jsx(DefaultComponent, { ...componentProps, children }), $[8] = CustomComponent, $[9] = children, $[10] = componentProps, $[11] = t2) : t2 = $[11], t0 = t2, t0;
}, Style = (props2) => {
  const {
    block,
    focused,
    children,
    selected,
    schemaType
  } = props2, DefaultComponentWithFallback = useMemo(() => (block.style && TEXT_STYLES[block.style] ? TEXT_STYLES[block.style] : TEXT_STYLES[0]) || Normal, [block.style]), DefaultComponent2 = useCallback((defaultComponentProps) => /* @__PURE__ */ jsx(DefaultComponentWithFallback, { children: /* @__PURE__ */ jsx(TextContainer, { "data-testid": `text-style--${block.style}`, children: defaultComponentProps.children }) }), [DefaultComponentWithFallback, block.style]);
  return useMemo(() => {
    const CustomComponent = schemaType.component, {
      title,
      value
    } = schemaType, componentProps = {
      block,
      focused,
      renderDefault: DefaultComponent2,
      schemaType,
      selected,
      title,
      value
    };
    return CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { ...componentProps, children }) : /* @__PURE__ */ jsx(DefaultComponent2, { ...componentProps, children });
  }, [DefaultComponent2, block, children, focused, schemaType, selected]);
}, DividerDiv = styled.div`
  border-right: 1px solid var(--card-border-color);
  height: auto;

  &[data-hidden] {
    opacity: 0;
  }
`;
function CollapseMenuDivider(props2) {
  const $ = c(6);
  let hidden, rest;
  $[0] !== props2 ? ({
    hidden,
    ...rest
  } = props2, $[0] = props2, $[1] = hidden, $[2] = rest) : (hidden = $[1], rest = $[2]);
  const t0 = hidden ? "" : void 0;
  let t1;
  return $[3] !== rest || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(DividerDiv, { "data-ui": "CollapseMenuDivider", "data-hidden": t0, ...rest }), $[3] = rest, $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const MENU_BUTTON_POPOVER_PROPS$1 = {
  portal: !0,
  constrainSize: !0
}, CollapseOverflowMenu = forwardRef(function(props2, forwardedRef) {
  const $ = c(11), {
    disableRestoreFocusOnClose,
    menuButton,
    menuButtonProps,
    menuOptions,
    onMenuClose
  } = props2;
  let t0;
  $[0] !== menuOptions ? (t0 = menuOptions.map(_temp$1m), $[0] = menuOptions, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Menu, { children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== disableRestoreFocusOnClose || $[5] !== forwardedRef || $[6] !== menuButton || $[7] !== menuButtonProps || $[8] !== onMenuClose || $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(MenuButton$1, { __unstable_disableRestoreFocusOnClose: disableRestoreFocusOnClose, id: "menu-button", ref: forwardedRef, onClose: onMenuClose, popover: MENU_BUTTON_POPOVER_PROPS$1, ...menuButtonProps, button: menuButton, menu: t1 }), $[4] = disableRestoreFocusOnClose, $[5] = forwardedRef, $[6] = menuButton, $[7] = menuButtonProps, $[8] = onMenuClose, $[9] = t1, $[10] = t2) : t2 = $[10], t2;
});
function _temp$1m(c2, index) {
  const {
    collapsedProps: t0,
    expandedProps: t1,
    tooltipProps: t2,
    tooltipText,
    dividerBefore,
    fontSize,
    padding,
    text,
    icon,
    selected,
    ...rest
  } = c2.props;
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    dividerBefore && index !== 0 && /* @__PURE__ */ jsx(MenuDivider, {}),
    /* @__PURE__ */ jsx(MenuItem$1, { text, icon, pressed: selected, ...rest })
  ] }, c2.key);
}
function ObserveElement(props2) {
  const $ = c(14);
  let children, onIntersectionChange, options, rest;
  $[0] !== props2 ? ({
    onIntersectionChange,
    children,
    options,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = onIntersectionChange, $[3] = options, $[4] = rest) : (children = $[1], onIntersectionChange = $[2], options = $[3], rest = $[4]);
  const [el, setEl] = useState(null);
  let t0, t1;
  $[5] !== el || $[6] !== onIntersectionChange || $[7] !== options ? (t0 = () => {
    const target = el?.closest('[data-ui="Flex"]');
    if (!target)
      return;
    const io = new IntersectionObserver(onIntersectionChange, options);
    return io.observe(target), () => {
      io.unobserve(target), io.disconnect();
    };
  }, t1 = [el, onIntersectionChange, options], $[5] = el, $[6] = onIntersectionChange, $[7] = options, $[8] = t0, $[9] = t1) : (t0 = $[8], t1 = $[9]), useEffect(t0, t1);
  let t2;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx("span", { hidden: !0, ref: setEl }), $[10] = t2) : t2 = $[10];
  let t3;
  return $[11] !== children || $[12] !== rest ? (t3 = /* @__PURE__ */ jsxs(Flex, { ...rest, children: [
    children,
    t2
  ] }), $[11] = children, $[12] = rest, $[13] = t3) : t3 = $[13], t3;
}
const FOCUS_RING_PADDING = 3, OPTION_STYLE = css`
  list-style: none;
  display: flex;
  white-space: nowrap;

  &[data-hidden='true'] {
    opacity: 0;
    visibility: hidden;
  }
`, OuterFlex = styled(Flex)`
  padding: ${FOCUS_RING_PADDING}px;
  margin: -${FOCUS_RING_PADDING}px;
  box-sizing: border-box;
`, RootFlex$3 = styled(Flex)`
  border-radius: inherit;
  position: relative;
`, RowFlex = styled(Flex)`
  width: max-content;
  &[data-hidden='true'] {
    visibility: hidden;
    position: relative;
    margin-top: -1px;
    height: 1px;
  }
`, OptionObserveElement$1 = styled(ObserveElement)`
  ${OPTION_STYLE}
`;
function _isReactElement$1(node) {
  return !!node;
}
const CollapseMenu = forwardRef(function(props2, ref) {
  const $ = c(25);
  let children, collapsed, disableRestoreFocusOnClose, menuButtonProps, onMenuClose, rest;
  $[0] !== props2 ? ({
    children,
    collapsed,
    disableRestoreFocusOnClose,
    onMenuClose,
    menuButtonProps,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = collapsed, $[3] = disableRestoreFocusOnClose, $[4] = menuButtonProps, $[5] = onMenuClose, $[6] = rest) : (children = $[1], collapsed = $[2], disableRestoreFocusOnClose = $[3], menuButtonProps = $[4], onMenuClose = $[5], rest = $[6]);
  let t0, t1;
  $[7] !== children ? (t1 = Children.toArray(children).filter(_isReactElement$1), $[7] = children, $[8] = t1) : t1 = $[8], t0 = t1;
  const menuOptions = t0;
  let t2, t3;
  $[9] !== menuButtonProps?.button ? (t3 = menuButtonProps?.button || /* @__PURE__ */ jsx(ContextMenuButton, {}), $[9] = menuButtonProps?.button, $[10] = t3) : t3 = $[10], t2 = t3;
  const menuButton = t2;
  if (collapsed) {
    let t42;
    return $[11] !== disableRestoreFocusOnClose || $[12] !== menuButton || $[13] !== menuButtonProps || $[14] !== menuOptions || $[15] !== onMenuClose || $[16] !== ref ? (t42 = /* @__PURE__ */ jsx(CollapseOverflowMenu, { ref, disableRestoreFocusOnClose, menuButton, menuButtonProps, menuOptions, onMenuClose }), $[11] = disableRestoreFocusOnClose, $[12] = menuButton, $[13] = menuButtonProps, $[14] = menuOptions, $[15] = onMenuClose, $[16] = ref, $[17] = t42) : t42 = $[17], t42;
  }
  let t4;
  return $[18] !== disableRestoreFocusOnClose || $[19] !== menuButtonProps || $[20] !== menuOptions || $[21] !== onMenuClose || $[22] !== ref || $[23] !== rest ? (t4 = /* @__PURE__ */ jsx(AutoCollapseMenu, { ...rest, ref, disableRestoreFocusOnClose, menuButtonProps, menuOptions, onMenuClose }), $[18] = disableRestoreFocusOnClose, $[19] = menuButtonProps, $[20] = menuOptions, $[21] = onMenuClose, $[22] = ref, $[23] = rest, $[24] = t4) : t4 = $[24], t4;
}), AutoCollapseMenu = forwardRef(function(props2, ref) {
  const {
    collapseText = !0,
    disableRestoreFocusOnClose,
    gap,
    menuOptions,
    menuButtonProps,
    onMenuClose,
    ...rest
  } = props2, [rootEl, setRootEl] = useState(null), [expandedIntersections, setExpandedIntersections] = useState({}), [collapsedIntersections, setCollapsedIntersections] = useState({}), intersectionOptions = useMemo(() => ({
    root: rootEl,
    // safari needs threshold to be < 1
    threshold: 0.99,
    rootMargin: "2px"
  }), [rootEl]), menuOptionKeys = useMemo(() => menuOptions.map((child) => child.key), [menuOptions]), pendingIntersections = useMemo(() => [...difference(menuOptionKeys, Object.keys(expandedIntersections)), ...difference(menuOptionKeys, Object.keys(collapsedIntersections))], [menuOptionKeys, expandedIntersections, collapsedIntersections]), overflowingExpandedElements = useMemo(() => menuOptions.filter((optionElement) => {
    const entry = expandedIntersections[optionElement.key];
    return entry && !entry.intersects;
  }), [expandedIntersections, menuOptions]), handleExpandedIntersection = useCallback((e, element) => {
    setExpandedIntersections((current) => {
      const key = element.key;
      if (key === null)
        throw new Error("Expected element to have a non-null key");
      const nextState = {
        intersects: e.isIntersecting,
        element
      }, currentState = current[key];
      return !currentState || currentState.intersects !== nextState.intersects ? {
        ...current,
        [key]: nextState
      } : current;
    });
  }, []), handleCollapsedIntersection = useCallback((e_0, element_0) => {
    setCollapsedIntersections((current_0) => {
      const key_0 = element_0.key;
      if (key_0 === null)
        throw new Error("Expected child element to have a non-null key");
      const currentElementIntersection = current_0[key_0], nextElementIntersection = {
        intersects: e_0.isIntersecting,
        element: element_0
      };
      return currentElementIntersection?.intersects === nextElementIntersection.intersects ? current_0 : {
        ...current_0,
        [key_0]: nextElementIntersection
      };
    });
  }, []), collapsedElements = useMemo(() => menuOptions.map((optionElement_0) => {
    const {
      collapsedProps
    } = optionElement_0.props, modeProps = collapsedProps, text = collapseText ? void 0 : optionElement_0.props.text;
    return cloneElement(optionElement_0, {
      ...modeProps,
      text
    });
  }), [menuOptions, collapseText]), overflowingCollapsedOptionElements = useMemo(() => menuOptions.filter((optionElement_1) => collapsedIntersections[optionElement_1.key]?.intersects === !1), [menuOptions, collapsedIntersections]), visibleMenuOptions = overflowingExpandedElements.length > 0 ? collapsedElements.filter((optionElement_2) => collapsedIntersections[optionElement_2.key]?.intersects === !0) : menuOptions, menuButton = useMemo(() => menuButtonProps?.button || /* @__PURE__ */ jsx(ContextMenuButton, {}), [menuButtonProps]);
  return /* @__PURE__ */ jsxs(OuterFlex, { align: "center", "data-ui": "CollapseMenu", overflow: "hidden", sizing: "border", ref, ...rest, children: [
    /* @__PURE__ */ jsxs(RootFlex$3, { direction: "column", flex: 1, justify: "center", ref: setRootEl, children: [
      /* @__PURE__ */ jsx(RowFlex, { gap, children: pendingIntersections.length === 0 && visibleMenuOptions.map((optionElement_3, index) => {
        const {
          dividerBefore,
          tooltipText = "",
          tooltipProps = {}
        } = optionElement_3.props, hidden = !optionElement_3.key || !(optionElement_3.key in expandedIntersections) || overflowingCollapsedOptionElements.includes(optionElement_3);
        return /* @__PURE__ */ jsxs(Fragment$1, { children: [
          dividerBefore && index !== 0 && /* @__PURE__ */ jsx(CollapseMenuDivider, { hidden }),
          /* @__PURE__ */ jsx(Tooltip, { portal: !0, disabled: !tooltipText, content: tooltipText, ...tooltipProps, children: /* @__PURE__ */ jsx(Flex, { children: cloneElement(optionElement_3, {
            disabled: optionElement_3.props.disabled || hidden,
            "aria-hidden": hidden
          }) }) })
        ] }, optionElement_3.key);
      }) }),
      /* @__PURE__ */ jsx(RenderHidden, { gap, elements: menuOptions, intersectionOptions, onIntersectionChange: handleExpandedIntersection }),
      /* @__PURE__ */ jsx(RenderHidden, { gap, elements: collapsedElements, intersectionOptions, onIntersectionChange: handleCollapsedIntersection })
    ] }),
    overflowingCollapsedOptionElements.length > 0 && /* @__PURE__ */ jsx(Flex, { marginLeft: gap, children: /* @__PURE__ */ jsx(CollapseOverflowMenu, { disableRestoreFocusOnClose, menuButton, menuButtonProps, menuOptions: overflowingCollapsedOptionElements, onMenuClose }) })
  ] });
}), RenderHidden = memo(function(props2) {
  const $ = c(10), {
    elements,
    gap,
    intersectionOptions,
    onIntersectionChange
  } = props2;
  let t0;
  if ($[0] !== elements || $[1] !== intersectionOptions || $[2] !== onIntersectionChange) {
    let t12;
    $[4] !== intersectionOptions || $[5] !== onIntersectionChange ? (t12 = (element, index) => {
      const {
        dividerBefore
      } = element.props;
      return /* @__PURE__ */ jsxs(Fragment$1, { children: [
        dividerBefore && index !== 0 && /* @__PURE__ */ jsx(CollapseMenuDivider, { hidden: !0 }),
        /* @__PURE__ */ jsx(OptionObserveElement$1, { options: intersectionOptions, onIntersectionChange: (e) => onIntersectionChange(e[0], element), children: /* @__PURE__ */ jsx(Flex, { children: cloneElement(element, {
          disabled: !0,
          "aria-hidden": !0
        }) }) })
      ] }, element.key);
    }, $[4] = intersectionOptions, $[5] = onIntersectionChange, $[6] = t12) : t12 = $[6], t0 = elements.map(t12), $[0] = elements, $[1] = intersectionOptions, $[2] = onIntersectionChange, $[3] = t0;
  } else
    t0 = $[3];
  let t1;
  return $[7] !== gap || $[8] !== t0 ? (t1 = /* @__PURE__ */ jsx(RowFlex, { "data-hidden": !0, "aria-hidden": "true", gap, overflow: "hidden", children: t0 }), $[7] = gap, $[8] = t0, $[9] = t1) : t1 = $[9], t1;
}), CollapseMenuButton = forwardRef(function(props2, ref) {
  const $ = c(8);
  let rest, t0, t1, t2;
  if ($[0] !== props2) {
    const {
      collapsedProps: t32,
      expandedProps: t4,
      tooltipProps: t5,
      tooltipText,
      dividerBefore,
      ...t6
    } = props2;
    t0 = t32, t1 = t4, t2 = t5, rest = t6, $[0] = props2, $[1] = rest, $[2] = t0, $[3] = t1, $[4] = t2;
  } else
    rest = $[1], t0 = $[2], t1 = $[3], t2 = $[4];
  let t3;
  return $[5] !== ref || $[6] !== rest ? (t3 = /* @__PURE__ */ jsx(Button, { "data-ui": "CollapseMenuButton", ...rest, ref }), $[5] = ref, $[6] = rest, $[7] = t3) : t3 = $[7], t3;
}), CustomIconDiv = styled.div`
  width: 1em;
  height: 1em;
  border-radius: inherit;
  background-origin: content-box;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  transform: scale(0.7);
`;
function CustomIcon(props2) {
  const $ = c(5), {
    icon,
    active
  } = props2;
  let t0;
  const t1 = `url(${icon})`, t2 = active ? "invert(100%)" : "invert(0%)";
  let t3;
  $[0] !== t1 || $[1] !== t2 ? (t3 = {
    backgroundImage: t1,
    filter: t2
  }, $[0] = t1, $[1] = t2, $[2] = t3) : t3 = $[2], t0 = t3;
  const inlineStyle = t0;
  let t4;
  return $[3] !== inlineStyle ? (t4 = /* @__PURE__ */ jsx(CustomIconDiv, { style: inlineStyle }), $[3] = inlineStyle, $[4] = t4) : t4 = $[4], t4;
}
function getPTEFormatActions(editor2, disabled, hotkeyOpts, t) {
  return editor2.schemaTypes.decorators.map((decorator) => {
    const shortCutKey = Object.keys(hotkeyOpts.marks || {}).find((key) => hotkeyOpts.marks?.[key] === decorator.value);
    let hotkeys = [];
    return shortCutKey && (hotkeys = [shortCutKey]), {
      type: "format",
      disabled,
      icon: decorator?.icon,
      key: decorator.value,
      handle: () => {
        PortableTextEditor.toggleMark(editor2, decorator.value), PortableTextEditor.focus(editor2);
      },
      hotkeys,
      title: decorator.i18nTitleKey && t ? t(decorator.i18nTitleKey) : decorator.title
    };
  });
}
function getPTEListActions(editor2, disabled, t) {
  return editor2.schemaTypes.lists.map((listItem) => ({
    type: "listStyle",
    key: listItem.value,
    disabled,
    icon: listItem?.icon,
    handle: () => {
      PortableTextEditor.toggleList(editor2, listItem.value);
    },
    title: listItem.i18nTitleKey && t ? t(listItem.i18nTitleKey) : listItem.title
  }));
}
function getAnnotationIcon(type) {
  return get(type, "icon") || get(type, "type.icon") || get(type, "type.to.icon") || get(type, "type.to[0].icon");
}
function getPTEAnnotationActions(editor2, disabled, onInsert, t) {
  const types = editor2.schemaTypes, focusChild = PortableTextEditor.focusChild(editor2), hasText = focusChild && focusChild.text;
  return types.annotations.map((aType) => ({
    type: "annotation",
    disabled: !hasText || disabled,
    icon: getAnnotationIcon(aType),
    key: aType.name,
    handle: (active) => {
      active ? (PortableTextEditor.removeAnnotation(editor2, aType), PortableTextEditor.focus(editor2)) : onInsert(aType);
    },
    title: aType.i18nTitleKey && t ? t(aType.i18nTitleKey) : aType.title || capitalize(aType.name)
  }));
}
function getPTEToolbarActionGroups(editor2, disabled, onInsertAnnotation, hotkeyOpts, t) {
  return [{
    name: "format",
    actions: getPTEFormatActions(editor2, disabled, hotkeyOpts, t)
  }, {
    name: "list",
    actions: getPTEListActions(editor2, disabled, t)
  }, {
    name: "annotation",
    actions: getPTEAnnotationActions(editor2, disabled, onInsertAnnotation, t)
  }];
}
function getBlockStyles(types) {
  return types.styles.map((style) => ({
    key: `style-${style.value}`,
    style: style.value,
    styleComponent: style && style.component,
    title: style.title,
    i18nTitleKey: style.i18nTitleKey
  }));
}
function getInsertMenuIcon(type, fallbackIcon) {
  const referenceIcon = get(type, "to[0].icon");
  return type.icon || type.type && type.type.icon || referenceIcon || fallbackIcon;
}
function getInsertMenuItems(types, disabled, onInsertBlock, onInsertInline) {
  const blockItems = types.blockObjects.map((type, index) => ({
    handle: () => onInsertBlock(type),
    icon: getInsertMenuIcon(type, BlockElementIcon),
    inline: !1,
    key: `block-${index}`,
    type
  })), inlineItems = types.inlineObjects.map((type, index) => ({
    handle: () => onInsertInline(type),
    icon: getInsertMenuIcon(type, InlineElementIcon),
    inline: !0,
    key: `inline-${index}`,
    type
  }));
  return blockItems.concat(inlineItems).filter((item) => !item.type?.hidden);
}
const annotationIcons = {
  link: LinkIcon
}, formatIcons = {
  strong: BoldIcon,
  em: ItalicIcon,
  "strike-through": StrikethroughIcon,
  underline: UnderlineIcon,
  code: CodeIcon
}, listStyleIcons = {
  number: OlistIcon,
  bullet: UlistIcon
};
function getActionIcon(action, active) {
  return action.icon ? typeof action.icon == "string" ? /* @__PURE__ */ jsx(CustomIcon, { active, icon: action.icon }) : action.icon : action.type === "annotation" ? annotationIcons[action.key] || UnknownIcon : action.type === "listStyle" ? listStyleIcons[action.key] || UnknownIcon : formatIcons[action.key] || UnknownIcon;
}
function useFocusBlock() {
  const $ = c(3), editor2 = usePortableTextEditor(), selection = usePortableTextEditorSelection();
  let t0, t1;
  return $[0] !== editor2 || $[1] !== selection ? (t1 = selection ? PortableTextEditor.focusBlock(editor2) : void 0, $[0] = editor2, $[1] = selection, $[2] = t1) : t1 = $[2], t0 = t1, t0;
}
function useActionGroups(t0) {
  const $ = c(10), {
    hotkeys,
    onMemberOpen,
    resolveInitialValue: resolveInitialValue2,
    disabled
  } = t0, editor2 = usePortableTextEditor(), {
    t
  } = useTranslation();
  let t1;
  $[0] !== editor2 || $[1] !== onMemberOpen || $[2] !== resolveInitialValue2 ? (t1 = async (schemaType) => {
    const initialValue = await resolveInitialValue2(schemaType), paths = PortableTextEditor.addAnnotation(editor2, schemaType, initialValue);
    paths && paths.markDefPath && onMemberOpen(paths.markDefPath);
  }, $[0] = editor2, $[1] = onMemberOpen, $[2] = resolveInitialValue2, $[3] = t1) : t1 = $[3];
  const handleInsertAnnotation = t1;
  let t2, t3;
  return $[4] !== disabled || $[5] !== editor2 || $[6] !== handleInsertAnnotation || $[7] !== hotkeys || $[8] !== t ? (t3 = editor2 ? getPTEToolbarActionGroups(editor2, disabled, handleInsertAnnotation, hotkeys, t) : [], $[4] = disabled, $[5] = editor2, $[6] = handleInsertAnnotation, $[7] = hotkeys, $[8] = t, $[9] = t3) : t3 = $[9], t2 = t3, t2;
}
function useActiveActionKeys(t0) {
  const $ = c(4), {
    actions
  } = t0, editor2 = usePortableTextEditor(), selection = usePortableTextEditorSelection();
  let t1, t2;
  return $[0] !== actions || $[1] !== editor2 || $[2] !== selection ? (t2 = selection ? actions.filter((a) => a.type === "annotation" ? PortableTextEditor.isAnnotationActive(editor2, a.key) : a.type === "listStyle" ? PortableTextEditor.hasListStyle(editor2, a.key) : PortableTextEditor.isMarkActive(editor2, a.key)).map(_temp$1l) : [], $[0] = actions, $[1] = editor2, $[2] = selection, $[3] = t2) : t2 = $[3], t1 = t2, useUnique(t1);
}
function _temp$1l(a_0) {
  return a_0.key;
}
function useActiveStyleKeys(t0) {
  const $ = c(5), {
    items
  } = t0, editor2 = usePortableTextEditor(), focusBlock = useFocusBlock(), selection = usePortableTextEditorSelection();
  let t1, t2;
  return $[0] !== editor2 || $[1] !== focusBlock || $[2] !== items || $[3] !== selection ? (t2 = focusBlock && selection ? items.filter((i) => PortableTextEditor.hasBlockStyle(editor2, i.style)).map(_temp2$s) : [], $[0] = editor2, $[1] = focusBlock, $[2] = items, $[3] = selection, $[4] = t2) : t2 = $[4], t1 = t2, useUnique(t1);
}
function _temp2$s(i_0) {
  return i_0.style;
}
const CollapseMenuMemo$1 = memo(CollapseMenu), MENU_POPOVER_PROPS$3 = {
  constrainSize: !0,
  portal: !0
}, ActionMenu = memo(function(props2) {
  const {
    disabled: disabledProp,
    groups,
    isFullscreen,
    collapsed
  } = props2, focusBlock = useFocusBlock(), editor2 = usePortableTextEditor(), selection = usePortableTextEditorSelection(), {
    t
  } = useTranslation(), isSelectingMultipleBlocks = (
    // Path at 0 is the block level, by comparing those we can detect if the user is selecting multiple blocks
    selection && isKeySegment(selection.anchor.path[0]) && isKeySegment(selection.focus.path[0]) ? (
      // In case of keyed segments
      selection.anchor.path[0]._key !== selection?.focus.path[0]._key
    ) : (
      // In case of non-keyed segments
      selection?.anchor.path[0] !== selection?.focus.path[0]
    )
  ), isVoidBlock = focusBlock?._type !== editor2.schemaTypes.block.name, isEmptyTextBlock = !isVoidBlock && Array.isArray(focusBlock.children) && focusBlock.children.length === 1 && focusBlock?.children[0].text === "", disabled = disabledProp || isVoidBlock, actions = useMemo(() => groups.reduce((acc, group2) => acc.concat(group2.actions.map(
    // eslint-disable-next-line max-nested-callbacks
    (action, actionIndex) => actionIndex === 0 ? {
      ...action,
      firstInGroup: !0
    } : action
  )), []), [groups]), activeKeys = useActiveActionKeys({
    actions
  }), handleMenuClose = useCallback(() => {
    PortableTextEditor.focus(editor2);
  }, [editor2]), tooltipPlacement = isFullscreen ? "bottom" : "top", children = useMemo(() => actions.map((action_0) => {
    const annotationDisabled = action_0.type === "annotation" && (isEmptyTextBlock || isSelectingMultipleBlocks), annotationDisabledText = isEmptyTextBlock ? t("user-menu.action.portable-text.annotation-disabled_empty-block", {
      name: action_0.title || action_0.key
    }) : t("user-menu.action.portable-text.annotation-disabled_multiple-blocks", {
      name: action_0.title || action_0.key
    }), active = activeKeys.includes(action_0.key);
    return /* @__PURE__ */ jsx(
      CollapseMenuButton,
      {
        "aria-label": t("toolbar.portable-text.action-button-aria-label", {
          action: action_0.title || action_0.key
        }),
        "data-testid": `action-button-${action_0.key}`,
        disabled: disabled || annotationDisabled,
        mode: "bleed",
        dividerBefore: action_0.firstInGroup,
        icon: getActionIcon(action_0, active),
        onClick: () => action_0.handle(active),
        selected: active,
        text: action_0.title || action_0.key,
        tooltipText: annotationDisabled ? annotationDisabledText : action_0.title || action_0.key,
        tooltipProps: {
          disabled,
          placement: tooltipPlacement,
          portal: "default"
        }
      },
      action_0.key
    );
  }), [actions, activeKeys, disabled, isEmptyTextBlock, isSelectingMultipleBlocks, t, tooltipPlacement]), menuButtonProps = useMemo(() => ({
    button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "action-menu-button", disabled, tooltipProps: {
      placement: tooltipPlacement
    } }),
    popover: MENU_POPOVER_PROPS$3
  }), [disabled, tooltipPlacement]);
  return /* @__PURE__ */ jsx(CollapseMenuMemo$1, { "data-testid": "action-menu-auto-collapse-menu", collapsed, disableRestoreFocusOnClose: !0, gap: 1, menuButtonProps, onMenuClose: handleMenuClose, children });
}), MenuButtonMemo = memo(MenuButton$1), StyledMenuItem = styled(MenuItem)`
  // Change the border color variable used by BlockQuote
  // to make the border visible when the MenuItem is selected
  &[data-selected] {
    [data-option='blockquote'] {
      --card-border-color: var(--card-muted-fg-color);
    }
  }
`, TEXT_STYLE_OPTIONS = {
  h1: (title) => /* @__PURE__ */ jsx(Heading1, { children: title }),
  h2: (title) => /* @__PURE__ */ jsx(Heading2, { children: title }),
  h3: (title) => /* @__PURE__ */ jsx(Heading3, { children: title }),
  h4: (title) => /* @__PURE__ */ jsx(Heading4, { children: title }),
  h5: (title) => /* @__PURE__ */ jsx(Heading5, { children: title }),
  h6: (title) => /* @__PURE__ */ jsx(Heading6, { children: title }),
  normal: (title) => /* @__PURE__ */ jsx(Normal, { children: title }),
  blockquote: (title) => /* @__PURE__ */ jsx(BlockQuote, { "data-option": "blockquote", children: title })
}, preventDefault = (event) => event.preventDefault(), emptyStyle = {
  key: "style-none",
  style: "",
  title: "No style",
  i18nTitleKey: "inputs.portable-text.style.none"
}, BlockStyleSelect = memo(function(props2) {
  const {
    disabled,
    items: itemsProp,
    boundaryElement
  } = props2, editor2 = usePortableTextEditor(), focusBlock = useFocusBlock(), {
    t
  } = useTranslation(), popoverProperties = {
    constrainSize: !0,
    placement: "bottom-start",
    portal: "default",
    referenceBoundary: boundaryElement
  }, _disabled = disabled || (focusBlock ? editor2.schemaTypes.block.name !== focusBlock._type : !1), activeKeys = useActiveStyleKeys({
    items: itemsProp
  }), {
    activeItems,
    items
  } = useMemo(() => {
    const _activeItems = itemsProp.filter((item) => activeKeys.includes(item.style));
    let _items = itemsProp;
    return _activeItems.length === 0 && _items.length > 1 && (_items = _items.concat([emptyStyle]), _activeItems.push(emptyStyle)), {
      activeItems: _activeItems,
      items: _items
    };
  }, [activeKeys, itemsProp]), menuButtonText = useMemo(() => activeItems.length > 1 ? t("inputs.portable-text.style.multiple") : activeItems.length !== 1 ? emptyStyle.i18nTitleKey ? t(emptyStyle.i18nTitleKey) : emptyStyle.title : activeItems[0].i18nTitleKey ? t(activeItems[0].i18nTitleKey) : activeItems[0].title, [activeItems, t]), handleChange = useCallback((item_0) => {
    focusBlock && item_0.style !== focusBlock.style && (PortableTextEditor.toggleBlockStyle(editor2, item_0.style), PortableTextEditor.focus(editor2));
  }, [editor2, focusBlock]), renderOption = useCallback((item_1) => {
    const {
      style,
      styleComponent
    } = item_1, renderStyle2 = TEXT_STYLE_OPTIONS[style], title = item_1.i18nTitleKey ? t(item_1.i18nTitleKey) : item_1?.title || item_1.style, CustomComponent = typeof styleComponent == "function" ? styleComponent : void 0;
    return renderStyle2 && !CustomComponent ? renderStyle2(title) : CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { children: title }) : /* @__PURE__ */ jsx(Text$1, { children: title });
  }, [t]), button = useMemo(() => /* @__PURE__ */ jsx(Button, { disabled: _disabled, iconRight: ChevronDownIcon, justify: "space-between", mode: "bleed", onClick: preventDefault, text: menuButtonText, width: "fill" }), [_disabled, menuButtonText]), menu = useMemo(() => /* @__PURE__ */ jsx(Menu, { disabled: _disabled, children: items.map((item_2) => /* @__PURE__ */ jsx(
    StyledMenuItem,
    {
      pressed: activeItems.includes(item_2),
      onClick: _disabled ? void 0 : () => handleChange(item_2),
      children: renderOption(item_2)
    },
    item_2.key
  )) }), [_disabled, activeItems, handleChange, items, renderOption]);
  return /* @__PURE__ */ jsx(MenuButtonMemo, { popover: popoverProperties, id: "block-style-select", button, menu });
}), CollapseMenuMemo = memo(CollapseMenu), MENU_POPOVER_PROPS$2 = {
  constrainSize: !0,
  portal: !0
}, InsertMenu = memo(function(props2) {
  const $ = c(23), {
    disabled,
    items,
    isFullscreen,
    collapsed
  } = props2, {
    t
  } = useTranslation(), focusBlock = useFocusBlock(), editor2 = usePortableTextEditor(), isVoidFocus = focusBlock && focusBlock._type !== editor2.schemaTypes.block.name;
  let t0;
  $[0] !== editor2 ? (t0 = () => {
    PortableTextEditor.focus(editor2);
  }, $[0] = editor2, $[1] = t0) : t0 = $[1];
  const handleMenuClose = t0, tooltipPlacement = isFullscreen ? "bottom" : "top";
  let t1, t2;
  if ($[2] !== disabled || $[3] !== isVoidFocus || $[4] !== items || $[5] !== t || $[6] !== tooltipPlacement) {
    let t32;
    $[8] !== disabled || $[9] !== isVoidFocus || $[10] !== t || $[11] !== tooltipPlacement ? (t32 = (item) => {
      const title = item.type.title || upperFirst(item.type.name);
      return /* @__PURE__ */ jsx(CollapseMenuButton, { "aria-label": t(item.inline ? "inputs.portable-text.action.insert-inline-object-aria-label" : "inputs.portable-text.action.insert-block-aria-label", {
        typeName: title
      }), mode: "bleed", disabled: disabled || isVoidFocus && item.inline === !0, icon: item.icon, onClick: item.handle, text: title, tooltipText: t(item.inline ? "inputs.portable-text.action.insert-inline-object" : "inputs.portable-text.action.insert-block", {
        typeName: title
      }), tooltipProps: {
        disabled,
        placement: tooltipPlacement,
        portal: "default"
      } }, item.key);
    }, $[8] = disabled, $[9] = isVoidFocus, $[10] = t, $[11] = tooltipPlacement, $[12] = t32) : t32 = $[12], t2 = items.map(t32), $[2] = disabled, $[3] = isVoidFocus, $[4] = items, $[5] = t, $[6] = tooltipPlacement, $[7] = t2;
  } else
    t2 = $[7];
  t1 = t2;
  const children = t1;
  let t3, t4;
  $[13] !== tooltipPlacement ? (t4 = {
    placement: tooltipPlacement
  }, $[13] = tooltipPlacement, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== disabled || $[16] !== t4 ? (t5 = {
    button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "insert-menu-button", disabled, tooltipProps: t4 }),
    popover: MENU_POPOVER_PROPS$2
  }, $[15] = disabled, $[16] = t4, $[17] = t5) : t5 = $[17], t3 = t5;
  const menuButtonProps = t3;
  let t6;
  return $[18] !== children || $[19] !== collapsed || $[20] !== handleMenuClose || $[21] !== menuButtonProps ? (t6 = /* @__PURE__ */ jsx(CollapseMenuMemo, { "data-testid": "insert-menu-auto-collapse-menu", collapsed, collapseText: !1, disableRestoreFocusOnClose: !0, gap: 1, menuButtonProps, onMenuClose: handleMenuClose, children }), $[18] = children, $[19] = collapsed, $[20] = handleMenuClose, $[21] = menuButtonProps, $[22] = t6) : t6 = $[22], t6;
}), RootFlex$2 = styled(Flex)`
  width: 100%;
`, StyleSelectBox = styled(Box)`
  width: 8em;
`, StyleSelectFlex = styled(Flex)`
  border-right: 1px solid var(--card-border-color);
`, ActionMenuBox = styled(Box)`
  ${({
  $withInsertMenu
}) => $withInsertMenu && css`
      max-width: max-content;
      border-right: 1px solid var(--card-border-color);
    `}
`, FullscreenButtonBox = styled(Box)`
  border-left: 1px solid var(--card-border-color);
`, SLOW_INITIAL_VALUE_LIMIT = 300, IS_MAC = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), InnerToolbar = memo(function(t0) {
  const $ = c(46), {
    actionGroups,
    blockStyles,
    collapsible,
    disabled,
    insertMenuItems,
    isFullscreen,
    onToggleFullscreen
  } = t0, {
    t
  } = useTranslation(), showActionMenu = actionGroups.reduce(_temp$1k, 0) > 0, showInsertMenu = insertMenuItems.length > 0, [rootElement, setRootElement] = useState(null), rootElementRect = useElementRect(rootElement), collapsed = collapsible && rootElementRect ? rootElementRect?.width < 400 : !1, showBlockStyleSelect = blockStyles.length > 1;
  let t1;
  $[0] !== rootElement ? (t1 = {
    rootElement
  }, $[0] = rootElement, $[1] = t1) : t1 = $[1], useRovingFocus(t1);
  const preventEditorBlurOnToolbarMouseDown = _temp2$r;
  let t2;
  $[2] !== blockStyles || $[3] !== collapsed || $[4] !== disabled || $[5] !== isFullscreen || $[6] !== rootElement || $[7] !== showBlockStyleSelect ? (t2 = showBlockStyleSelect && /* @__PURE__ */ jsx(StyleSelectFlex, { flex: collapsed ? 1 : void 0, children: /* @__PURE__ */ jsx(StyleSelectBox, { padding: isFullscreen ? 2 : 1, "data-testid": "block-style-select", children: /* @__PURE__ */ jsx(BlockStyleSelect, { disabled, items: blockStyles, boundaryElement: rootElement }) }) }), $[2] = blockStyles, $[3] = collapsed, $[4] = disabled, $[5] = isFullscreen, $[6] = rootElement, $[7] = showBlockStyleSelect, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== actionGroups || $[10] !== collapsed || $[11] !== disabled || $[12] !== isFullscreen || $[13] !== showActionMenu || $[14] !== showInsertMenu ? (t3 = showActionMenu && /* @__PURE__ */ jsx(ActionMenuBox, { flex: collapsed ? void 0 : 1, padding: isFullscreen ? 2 : 1, $withInsertMenu: showInsertMenu, children: /* @__PURE__ */ jsx(ActionMenu, { disabled, collapsed, groups: actionGroups, isFullscreen }) }), $[9] = actionGroups, $[10] = collapsed, $[11] = disabled, $[12] = isFullscreen, $[13] = showActionMenu, $[14] = showInsertMenu, $[15] = t3) : t3 = $[15];
  let t4;
  $[16] !== collapsed || $[17] !== disabled || $[18] !== insertMenuItems || $[19] !== isFullscreen || $[20] !== showInsertMenu ? (t4 = showInsertMenu && /* @__PURE__ */ jsx(Box, { flex: collapsed ? void 0 : 1, padding: isFullscreen ? 2 : 1, children: /* @__PURE__ */ jsx(InsertMenu, { disabled, collapsed, items: insertMenuItems, isFullscreen }) }), $[16] = collapsed, $[17] = disabled, $[18] = insertMenuItems, $[19] = isFullscreen, $[20] = showInsertMenu, $[21] = t4) : t4 = $[21];
  let t5;
  $[22] !== t3 || $[23] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { flex: 1, children: [
    t3,
    t4
  ] }), $[22] = t3, $[23] = t4, $[24] = t5) : t5 = $[24];
  const t6 = isFullscreen ? 2 : 1;
  let t7;
  $[25] !== t ? (t7 = t("inputs.portable-text.action.expand-editor"), $[25] = t, $[26] = t7) : t7 = $[26];
  const t8 = isFullscreen ? CollapseIcon : ExpandIcon, t9 = isFullscreen ? "inputs.portable-text.action.collapse-editor" : "inputs.portable-text.action.expand-editor";
  let t10;
  $[27] !== t || $[28] !== t9 ? (t10 = t(t9), $[27] = t, $[28] = t9, $[29] = t10) : t10 = $[29];
  let t11;
  $[30] === Symbol.for("react.memo_cache_sentinel") ? (t11 = [`${IS_MAC ? "Cmd" : "Ctrl"}`, "Enter"], $[30] = t11) : t11 = $[30];
  const t12 = isFullscreen ? "bottom" : "top";
  let t13;
  $[31] !== t10 || $[32] !== t12 ? (t13 = {
    content: t10,
    hotkeys: t11,
    placement: t12,
    portal: "default"
  }, $[31] = t10, $[32] = t12, $[33] = t13) : t13 = $[33];
  let t14;
  $[34] !== onToggleFullscreen || $[35] !== t13 || $[36] !== t7 || $[37] !== t8 ? (t14 = /* @__PURE__ */ jsx(Button, { "aria-label": t7, icon: t8, mode: "bleed", onClick: onToggleFullscreen, tooltipProps: t13 }), $[34] = onToggleFullscreen, $[35] = t13, $[36] = t7, $[37] = t8, $[38] = t14) : t14 = $[38];
  let t15;
  $[39] !== t14 || $[40] !== t6 ? (t15 = /* @__PURE__ */ jsx(FullscreenButtonBox, { padding: t6, children: t14 }), $[39] = t14, $[40] = t6, $[41] = t15) : t15 = $[41];
  let t16;
  return $[42] !== t15 || $[43] !== t2 || $[44] !== t5 ? (t16 = /* @__PURE__ */ jsxs(RootFlex$2, { align: "center", ref: setRootElement, onMouseDown: preventEditorBlurOnToolbarMouseDown, children: [
    t2,
    t5,
    t15
  ] }), $[42] = t15, $[43] = t2, $[44] = t5, $[45] = t16) : t16 = $[45], t16;
});
function Toolbar(props2) {
  const $ = c(30), {
    collapsible,
    hotkeys,
    isFullscreen,
    readOnly,
    onMemberOpen,
    onToggleFullscreen
  } = props2, editor2 = usePortableTextEditor(), selection = usePortableTextEditorSelection(), resolveInitialValueForType2 = useResolveInitialValueForType(), disabled = readOnly || !selection, {
    push
  } = useToast();
  let t0;
  $[0] !== push || $[1] !== resolveInitialValueForType2 ? (t0 = (type) => {
    let isSlow = !1;
    const slowTimer = setTimeout(() => {
      isSlow = !0, push({
        id: "resolving-initial-value",
        status: "info",
        title: "Resolving initial value\u2026"
      });
    }, SLOW_INITIAL_VALUE_LIMIT);
    return resolveInitialValueForType2(type, {}).then((value) => (isSlow && push({
      id: "resolving-initial-value",
      status: "info",
      duration: 500,
      title: "Initial value resolved"
    }), value)).catch((error) => {
      push({
        title: "Could not resolve initial value",
        id: "resolving-initial-value",
        description: `Unable to resolve initial value for type: ${type.name}: ${error.message}.`,
        status: "error"
      });
    }).finally(() => clearTimeout(slowTimer));
  }, $[0] = push, $[1] = resolveInitialValueForType2, $[2] = t0) : t0 = $[2];
  const resolveInitialValue2 = t0;
  let t1;
  $[3] !== editor2 || $[4] !== onMemberOpen || $[5] !== resolveInitialValue2 ? (t1 = async (type_0) => {
    const initialValue = await resolveInitialValue2(type_0), path = PortableTextEditor.insertBlock(editor2, type_0, initialValue);
    path && onMemberOpen(path);
  }, $[3] = editor2, $[4] = onMemberOpen, $[5] = resolveInitialValue2, $[6] = t1) : t1 = $[6];
  const handleInsertBlock = t1;
  let t2;
  $[7] !== editor2 || $[8] !== onMemberOpen || $[9] !== resolveInitialValue2 ? (t2 = async (type_1) => {
    const initialValue_0 = await resolveInitialValue2(type_1), path_0 = PortableTextEditor.insertChild(editor2, type_1, initialValue_0);
    path_0 && onMemberOpen(path_0);
  }, $[7] = editor2, $[8] = onMemberOpen, $[9] = resolveInitialValue2, $[10] = t2) : t2 = $[10];
  const handleInsertInline = t2;
  let t3;
  $[11] !== hotkeys || $[12] !== onMemberOpen || $[13] !== resolveInitialValue2 ? (t3 = {
    hotkeys,
    onMemberOpen,
    resolveInitialValue: resolveInitialValue2,
    disabled: !0
  }, $[11] = hotkeys, $[12] = onMemberOpen, $[13] = resolveInitialValue2, $[14] = t3) : t3 = $[14];
  const actionGroups = useActionGroups(t3);
  let t4, t5;
  $[15] !== editor2.schemaTypes ? (t5 = getBlockStyles(editor2.schemaTypes), $[15] = editor2.schemaTypes, $[16] = t5) : t5 = $[16], t4 = t5;
  const blockStyles = t4;
  let t6, t7;
  $[17] !== disabled || $[18] !== editor2.schemaTypes || $[19] !== handleInsertBlock || $[20] !== handleInsertInline ? (t7 = getInsertMenuItems(editor2.schemaTypes, disabled, handleInsertBlock, handleInsertInline), $[17] = disabled, $[18] = editor2.schemaTypes, $[19] = handleInsertBlock, $[20] = handleInsertInline, $[21] = t7) : t7 = $[21], t6 = t7;
  const insertMenuItems = t6;
  let t8;
  return $[22] !== actionGroups || $[23] !== blockStyles || $[24] !== collapsible || $[25] !== disabled || $[26] !== insertMenuItems || $[27] !== isFullscreen || $[28] !== onToggleFullscreen ? (t8 = /* @__PURE__ */ jsx(InnerToolbar, { actionGroups, blockStyles, collapsible, disabled, insertMenuItems, isFullscreen, onToggleFullscreen }), $[22] = actionGroups, $[23] = blockStyles, $[24] = collapsible, $[25] = disabled, $[26] = insertMenuItems, $[27] = isFullscreen, $[28] = onToggleFullscreen, $[29] = t8) : t8 = $[29], t8;
}
function _temp$1k(acc, x) {
  return acc + x.actions.length;
}
function _temp2$r(e) {
  e.preventDefault();
}
const noOutlineStyle = {
  outline: "none"
}, FORM_BUILDER_DEFAULT_ID = "root", PlaceholderWrapper$1 = styled.span((props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return css`
    color: ${color.input.default.enabled.placeholder};
  `;
}), renderDecorator = (props2) => /* @__PURE__ */ jsx(Decorator$1, { ...props2 }), renderStyle = (props2) => /* @__PURE__ */ jsx(Style, { ...props2 }), renderListItem = (props2) => /* @__PURE__ */ jsx(ListItem$1, { ...props2 });
function Editor(props2) {
  const $ = c(54), {
    elementRef,
    hideToolbar,
    hotkeys,
    initialSelection,
    isActive,
    isFullscreen,
    onCopy,
    onItemOpen,
    onPaste,
    onToggleFullscreen,
    path,
    readOnly,
    rangeDecorations,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderChild: renderChild2,
    scrollElement,
    setPortalElement,
    setScrollElement,
    ariaDescribedBy
  } = props2, {
    id: id2
  } = useFormBuilder(), {
    t
  } = useTranslation(), {
    isTopLayer
  } = useLayer(), {
    element: boundaryElement
  } = useBoundaryElement();
  let t0;
  $[0] !== isFullscreen || $[1] !== isTopLayer || $[2] !== onToggleFullscreen ? (t0 = (event) => {
    !isTopLayer || !isFullscreen || event.key === "Escape" && onToggleFullscreen();
  }, $[0] = isFullscreen, $[1] = isTopLayer, $[2] = onToggleFullscreen, $[3] = t0) : t0 = $[3], useGlobalKeyDown(t0);
  let t1;
  $[4] !== t ? (t1 = () => /* @__PURE__ */ jsx(PlaceholderWrapper$1, { "data-testid": "pt-input-placeholder", children: t("inputs.portable-text.empty-placeholder") }), $[4] = t, $[5] = t1) : t1 = $[5];
  const renderPlaceholder = t1, spellCheck = useSpellCheck(), scrollSelectionIntoView = useScrollSelectionIntoView(scrollElement);
  let t2, t3;
  $[6] !== ariaDescribedBy || $[7] !== elementRef || $[8] !== hotkeys || $[9] !== initialSelection || $[10] !== onCopy || $[11] !== onPaste || $[12] !== rangeDecorations || $[13] !== renderAnnotation || $[14] !== renderBlock2 || $[15] !== renderChild2 || $[16] !== renderPlaceholder || $[17] !== scrollSelectionIntoView || $[18] !== spellCheck ? (t3 = {
    "aria-describedby": ariaDescribedBy,
    hotkeys,
    onCopy,
    onPaste,
    rangeDecorations,
    ref: elementRef,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderChild: renderChild2,
    renderDecorator,
    renderListItem,
    renderPlaceholder,
    renderStyle,
    scrollSelectionIntoView,
    selection: initialSelection,
    spellCheck,
    style: noOutlineStyle
  }, $[6] = ariaDescribedBy, $[7] = elementRef, $[8] = hotkeys, $[9] = initialSelection, $[10] = onCopy, $[11] = onPaste, $[12] = rangeDecorations, $[13] = renderAnnotation, $[14] = renderBlock2, $[15] = renderChild2, $[16] = renderPlaceholder, $[17] = scrollSelectionIntoView, $[18] = spellCheck, $[19] = t3) : t3 = $[19];
  const editableProps = t3;
  let t4;
  $[20] !== editableProps ? (t4 = /* @__PURE__ */ jsx(PortableTextEditable, { ...editableProps }), $[20] = editableProps, $[21] = t4) : t4 = $[21], t2 = t4;
  const editable = t2;
  let t5;
  $[22] !== onItemOpen || $[23] !== path ? (t5 = (relativePath) => {
    onItemOpen(path.concat(relativePath));
  }, $[22] = onItemOpen, $[23] = path, $[24] = t5) : t5 = $[24];
  const handleToolBarOnMemberOpen = t5, collapsibleToolbar = id2 === FORM_BUILDER_DEFAULT_ID;
  let t6;
  $[25] !== collapsibleToolbar || $[26] !== handleToolBarOnMemberOpen || $[27] !== hideToolbar || $[28] !== hotkeys || $[29] !== isActive || $[30] !== isFullscreen || $[31] !== onToggleFullscreen || $[32] !== readOnly ? (t6 = isActive && !hideToolbar && /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsx(ToolbarCard, { "data-testid": "pt-editor__toolbar-card", shadow: 1, children: /* @__PURE__ */ jsx(Toolbar, { collapsible: collapsibleToolbar, hotkeys, isFullscreen, onMemberOpen: handleToolBarOnMemberOpen, onToggleFullscreen, readOnly }) }) }), $[25] = collapsibleToolbar, $[26] = handleToolBarOnMemberOpen, $[27] = hideToolbar, $[28] = hotkeys, $[29] = isActive, $[30] = isFullscreen, $[31] = onToggleFullscreen, $[32] = readOnly, $[33] = t6) : t6 = $[33];
  const t7 = readOnly ? "transparent" : "default", t8 = readOnly ? "transparent" : "default", t9 = isFullscreen ? scrollElement : boundaryElement;
  let t10;
  $[34] !== editable || $[35] !== t9 ? (t10 = /* @__PURE__ */ jsx(BoundaryElementProvider, { element: t9, children: editable }), $[34] = editable, $[35] = t9, $[36] = t10) : t10 = $[36];
  let t11;
  $[37] !== isFullscreen || $[38] !== t10 || $[39] !== t8 ? (t11 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(EditableWrapper, { $isFullscreen: isFullscreen, tone: t8, children: t10 }) }), $[37] = isFullscreen, $[38] = t10, $[39] = t8, $[40] = t11) : t11 = $[40];
  let t12;
  $[41] !== setScrollElement || $[42] !== t11 ? (t12 = /* @__PURE__ */ jsx(Scroller, { ref: setScrollElement, children: t11 }), $[41] = setScrollElement, $[42] = t11, $[43] = t12) : t12 = $[43];
  let t13;
  $[44] !== setPortalElement ? (t13 = /* @__PURE__ */ jsx("div", { "data-portal": "", ref: setPortalElement }), $[44] = setPortalElement, $[45] = t13) : t13 = $[45];
  let t14;
  $[46] !== t12 || $[47] !== t13 || $[48] !== t7 ? (t14 = /* @__PURE__ */ jsxs(EditableCard, { flex: 1, tone: t7, children: [
    t12,
    t13
  ] }), $[46] = t12, $[47] = t13, $[48] = t7, $[49] = t14) : t14 = $[49];
  let t15;
  return $[50] !== isFullscreen || $[51] !== t14 || $[52] !== t6 ? (t15 = /* @__PURE__ */ jsxs(Root$i, { "data-fullscreen": isFullscreen, "data-testid": "pt-editor", children: [
    t6,
    t14
  ] }), $[50] = isFullscreen, $[51] = t14, $[52] = t6, $[53] = t15) : t15 = $[53], t15;
}
function useHotkeys(hotkeys) {
  const $ = c(12), editor2 = usePortableTextEditor();
  let t0;
  $[0] !== hotkeys ? (t0 = () => hotkeys, $[0] = hotkeys, $[1] = t0) : t0 = $[1];
  const [initialHotkeys] = useState(t0);
  initialHotkeys !== hotkeys && console.warn("Make sure that hotkeys are a stable object across renders, or there will be issues with key handling in the Portable Text Editor.");
  let t1, defaultHotkeys;
  $[2] !== editor2.schemaTypes.decorators ? (defaultHotkeys = {
    marks: {}
  }, editor2.schemaTypes.decorators.forEach((dec2) => {
    bb7: switch (dec2.value) {
      case "strong": {
        defaultHotkeys.marks["mod+b"] = dec2.value;
        break bb7;
      }
      case "em": {
        defaultHotkeys.marks["mod+i"] = dec2.value;
        break bb7;
      }
      case "underline": {
        defaultHotkeys.marks["mod+u"] = dec2.value;
        break bb7;
      }
      case "code": {
        defaultHotkeys.marks["mod+'"] = dec2.value;
        break bb7;
      }
    }
  }), $[2] = editor2.schemaTypes.decorators, $[3] = defaultHotkeys) : defaultHotkeys = $[3];
  let t2;
  $[4] !== initialHotkeys ? (t2 = initialHotkeys || {}, $[4] = initialHotkeys, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== defaultHotkeys.marks || $[7] !== t2.marks ? (t3 = {
    ...defaultHotkeys.marks,
    ...t2.marks
  }, $[6] = defaultHotkeys.marks, $[7] = t2.marks, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== initialHotkeys.custom || $[10] !== t3 ? (t4 = {
    marks: t3,
    custom: initialHotkeys.custom
  }, $[9] = initialHotkeys.custom, $[10] = t3, $[11] = t4) : t4 = $[11], t1 = t4, t1;
}
function useTrackFocusPath(props2) {
  const $ = c(15), {
    focusPath,
    boundaryElement,
    onItemClose
  } = props2, portableTextMemberItems = usePortableTextMemberItems(), elementRefs = usePortableTextMemberItemElementRefs(), editor2 = usePortableTextEditor(), selection = usePortableTextEditorSelection();
  let t0;
  $[0] !== boundaryElement || $[1] !== editor2 || $[2] !== elementRefs || $[3] !== focusPath || $[4] !== portableTextMemberItems || $[5] !== selection ? (t0 = () => {
    if (focusPath.length === 0 || selection?.focus.path && isEqual$3(selection.focus.path, focusPath.slice(0, selection.focus.path.length)))
      return;
    const focusedItem = portableTextMemberItems.find(_temp$1j), openItem = portableTextMemberItems.find(_temp2$q), relatedEditorItem = focusedItem || openItem, elementRef = relatedEditorItem ? elementRefs[relatedEditorItem.member.key] : void 0;
    if (relatedEditorItem && elementRef) {
      boundaryElement && (scrollIntoView$1(boundaryElement, {
        scrollMode: "if-needed",
        block: "start",
        inline: "start"
      }), scrollIntoView$1(elementRef, {
        scrollMode: "if-needed",
        boundary: boundaryElement,
        block: "nearest",
        inline: "start"
      }));
      const isTextBlock = relatedEditorItem.kind === "textBlock", isBlockFocusPath = focusPath.length === 1;
      if (isTextBlock || isBlockFocusPath) {
        const textBlockChildKey = isTextBlock && isKeyedObject(focusPath[2]) ? focusPath[2]._key : void 0, child = textBlockChildKey && Array.isArray(relatedEditorItem.node.value?.children) ? relatedEditorItem.node.value?.children.find((c2) => c2._key === textBlockChildKey) : void 0, isSpanTextFocusPath = child && child._type === "span" && focusPath.length === 4 && focusPath[1] === "children" && focusPath[3] === "text" || !1, isTextChildFocusPath = isTextBlock && (focusPath.length === 3 && focusPath[1] === "children" || isSpanTextFocusPath);
        let path = [];
        isTextChildFocusPath ? path = focusPath.slice(0, 3) : isTextBlock && isBlockFocusPath && Array.isArray(relatedEditorItem.node.value?.children) ? path = [focusPath[0], "children", {
          _key: relatedEditorItem.node.value?.children[0]._key
        }] : isBlockFocusPath && (path = [{
          _key: relatedEditorItem.key
        }]), path.length && (PortableTextEditor.select(editor2, {
          anchor: {
            path,
            offset: 0
          },
          focus: {
            path,
            offset: 0
          }
        }), isTextBlock && PortableTextEditor.focus(editor2));
      }
    }
  }, $[0] = boundaryElement, $[1] = editor2, $[2] = elementRefs, $[3] = focusPath, $[4] = portableTextMemberItems, $[5] = selection, $[6] = t0) : t0 = $[6];
  const t1 = selection?.focus.path;
  let t2;
  $[7] !== boundaryElement || $[8] !== editor2 || $[9] !== elementRefs || $[10] !== focusPath || $[11] !== onItemClose || $[12] !== portableTextMemberItems || $[13] !== t1 ? (t2 = [boundaryElement, editor2, elementRefs, focusPath, onItemClose, portableTextMemberItems, t1], $[7] = boundaryElement, $[8] = editor2, $[9] = elementRefs, $[10] = focusPath, $[11] = onItemClose, $[12] = portableTextMemberItems, $[13] = t1, $[14] = t2) : t2 = $[14], useLayoutEffect(t0, t2);
}
function _temp2$q(m_0) {
  return m_0.member.open;
}
function _temp$1j(m) {
  return m.member.item.focused;
}
const Root$h = styled(Card)(rootStyle), PreviewSpan = styled.span`
  display: block;
  max-width: calc(5em + 80px);
  position: relative;
`, TooltipBox$1 = styled(Box)`
  max-width: 250px;
`;
function rootStyle({
  theme
}) {
  const {
    color,
    radius
  } = theme.sanity;
  return css`
    line-height: 0;
    border-radius: ${radius[2]}px;
    padding: 2px;
    box-shadow: inset 0 0 0 1px var(--card-border-color);
    height: calc(1em - 1px);
    margin-top: 0.0625em;
    cursor: default;

    &:not([hidden]) {
      display: inline-flex;
      align-items: center;
      vertical-align: top;
    }

    &[data-ready-only] {
      cursor: default;
    }

    &[data-focused] {
      box-shadow: inset 0 0 0 1px ${color.selectable?.primary.selected.border};
      color: ${color.selectable?.primary.pressed.fg};
    }

    &[data-selected] {
      background-color: ${color.selectable?.primary.pressed.bg};
    }

    &:not([data-focused]):not([data-selected]) {
      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.input.default.hovered.border};
        }
      }
    }

    &[data-markers] {
      --card-bg-color: ${color.dark ? hues.purple[950].hex : hues.purple[50].hex};
    }

    &[data-warning] {
      --card-bg-color: ${color.muted.caution.hovered.bg};

      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.muted.caution.hovered.border};
        }
      }
    }

    &[data-invalid] {
      --card-bg-color: ${color.input.invalid.enabled.bg};
      --card-border-color: ${color.input.invalid.enabled.border};

      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.input.invalid.hovered.border};
        }
      }
    }
  `;
}
const POPOVER_FALLBACK_PLACEMENTS$5 = ["top", "bottom"];
function InlineObjectToolbarPopover(props2) {
  const $ = c(48), {
    floatingBoundary,
    inlineObjectFocused,
    inlineObjectOpen,
    onOpenInlineObject,
    onRemoveInlineObject,
    referenceBoundary,
    referenceElement,
    title
  } = props2, [popoverOpen, setPopoverOpen] = useState(!1), {
    sanity
  } = useTheme(), {
    t
  } = useTranslation(), editButtonRef = useRef(null), deleteButtonRef = useRef(null), focusTrappedRef = useRef(null), popoverScheme = sanity.color.dark ? "light" : "dark", editor2 = usePortableTextEditor(), contentRef = useRef(null);
  let t0;
  $[0] !== editor2 ? (t0 = () => {
    setPopoverOpen(!1), PortableTextEditor.focus(editor2), focusTrappedRef.current = null;
  }, $[0] = editor2, $[1] = t0) : t0 = $[1];
  const handleClosePopover = t0;
  let t1;
  $[2] !== editor2 || $[3] !== handleClosePopover || $[4] !== inlineObjectFocused || $[5] !== popoverOpen ? (t1 = (event) => {
    if (popoverOpen) {
      if (event.key === "Tab") {
        if (inlineObjectFocused && event.target instanceof HTMLElement && event.target.contentEditable && focusTrappedRef.current === null) {
          event.preventDefault(), editButtonRef.current?.focus(), focusTrappedRef.current = editButtonRef.current;
          return;
        }
        if (event.target === deleteButtonRef.current) {
          event.preventDefault(), event.stopPropagation(), focusTrappedRef.current = null, PortableTextEditor.focus(editor2);
          return;
        }
      }
      event.key === "Escape" && handleClosePopover();
    }
  }, $[2] = editor2, $[3] = handleClosePopover, $[4] = inlineObjectFocused, $[5] = popoverOpen, $[6] = t1) : t1 = $[6], useGlobalKeyDown(t1);
  let t2, t3;
  $[7] !== inlineObjectFocused || $[8] !== inlineObjectOpen ? (t2 = () => {
    if (focusTrappedRef.current = null, inlineObjectOpen) {
      setPopoverOpen(!1);
      return;
    }
    if (inlineObjectFocused) {
      setPopoverOpen(!0);
      return;
    }
    setPopoverOpen(!1);
  }, t3 = [inlineObjectFocused, inlineObjectOpen], $[7] = inlineObjectFocused, $[8] = inlineObjectOpen, $[9] = t2, $[10] = t3) : (t2 = $[9], t3 = $[10]), useEffect(t2, t3);
  let t4;
  $[11] !== onOpenInlineObject ? (t4 = () => {
    setPopoverOpen(!1), onOpenInlineObject();
  }, $[11] = onOpenInlineObject, $[12] = t4) : t4 = $[12];
  const handleEditButtonClicked = t4;
  let t5;
  $[13] !== onRemoveInlineObject ? (t5 = () => {
    setPopoverOpen(!1), onRemoveInlineObject();
  }, $[13] = onRemoveInlineObject, $[14] = t5) : t5 = $[14];
  const handleRemoveButtonClicked = t5, t6 = !inlineObjectOpen && popoverOpen;
  let t7;
  $[15] !== title ? (t7 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: title }) }), $[15] = title, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t ? (t8 = t("inputs.portable-text.inline-object.edit-aria-label"), $[17] = t, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t ? (t9 = t("inputs.portable-text.inline-object.edit"), $[19] = t, $[20] = t9) : t9 = $[20];
  let t10;
  $[21] !== t9 ? (t10 = {
    content: t9
  }, $[21] = t9, $[22] = t10) : t10 = $[22];
  let t11;
  $[23] !== handleEditButtonClicked || $[24] !== t10 || $[25] !== t8 ? (t11 = /* @__PURE__ */ jsx(Button, { "aria-label": t8, "data-testid": "edit-inline-object-button", icon: EditIcon, mode: "bleed", onClick: handleEditButtonClicked, ref: editButtonRef, tabIndex: 0, tooltipProps: t10 }), $[23] = handleEditButtonClicked, $[24] = t10, $[25] = t8, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== t ? (t12 = t("inputs.portable-text.inline-object.remove-aria-label"), $[27] = t, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== t ? (t13 = t("inputs.portable-text.inline-object.remove"), $[29] = t, $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== t13 ? (t14 = {
    content: t13
  }, $[31] = t13, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== handleRemoveButtonClicked || $[34] !== t12 || $[35] !== t14 ? (t15 = /* @__PURE__ */ jsx(Button, { "aria-label": t12, "data-testid": "remove-inline-object-button", icon: TrashIcon, mode: "bleed", onClick: handleRemoveButtonClicked, ref: deleteButtonRef, tabIndex: 0, tone: "critical", tooltipProps: t14 }), $[33] = handleRemoveButtonClicked, $[34] = t12, $[35] = t14, $[36] = t15) : t15 = $[36];
  let t16;
  $[37] !== t11 || $[38] !== t15 || $[39] !== t7 ? (t16 = /* @__PURE__ */ jsx(Box, { padding: 1, "data-testid": "inline-object-toolbar-popover", ref: contentRef, children: /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t7,
    t11,
    t15
  ] }) }), $[37] = t11, $[38] = t15, $[39] = t7, $[40] = t16) : t16 = $[40];
  let t17;
  return $[41] !== floatingBoundary || $[42] !== popoverScheme || $[43] !== referenceBoundary || $[44] !== referenceElement || $[45] !== t16 || $[46] !== t6 ? (t17 = /* @__PURE__ */ jsx(Popover, { open: t6, floatingBoundary, constrainSize: !0, content: t16, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$5, placement: "top", portal: !0, preventOverflow: !0, referenceBoundary, referenceElement, scheme: popoverScheme }), $[41] = floatingBoundary, $[42] = popoverScheme, $[43] = referenceBoundary, $[44] = referenceElement, $[45] = t16, $[46] = t6, $[47] = t17) : t17 = $[47], t17;
}
const parseResponsiveWidth = (value) => Array.isArray(value) ? value.flatMap(parseResponsiveWidth) : typeof value == "number" ? [value] : value === "auto" ? ["auto"] : [], parseModalType = (value) => value === "dialog" || value === "popover" ? value : void 0;
function _getModalOption(schemaType) {
  const raw = schemaType.options?.modal;
  return typeof raw == "object" && raw !== null ? {
    type: parseModalType(raw.type),
    width: parseResponsiveWidth(raw.width)
  } : void 0;
}
function DefaultEditDialog(props2) {
  const $ = c(13), {
    onClose,
    children,
    title,
    width: t0,
    autoFocus
  } = props2, width = t0 === void 0 ? 1 : t0, dialogId = useId(), [contentElement, setContentElement] = useState(null), containerElement = useRef(null);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [0, 0, 1, 0], $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== children ? (t2 = /* @__PURE__ */ jsx(Box, { ref: containerElement, children }), $[1] = children, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== contentElement || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(PresenceOverlay, { margins: t1, children: /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: contentElement, containerElement, children: t2 }) }), $[3] = contentElement, $[4] = t2, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== autoFocus || $[7] !== dialogId || $[8] !== onClose || $[9] !== t3 || $[10] !== title || $[11] !== width ? (t4 = /* @__PURE__ */ jsx(Dialog$1, { header: title, id: dialogId, onClickOutside: onClose, onClose, portal: "default", width, contentRef: setContentElement, "data-testid": "default-edit-object-dialog", __unstable_autoFocus: autoFocus, children: t3 }), $[6] = autoFocus, $[7] = dialogId, $[8] = onClose, $[9] = t3, $[10] = title, $[11] = width, $[12] = t4) : t4 = $[12], t4;
}
const RootPopover = styled(Popover)`
  & > div {
    overflow: hidden;
    overflow: clip;
  }
`, ContentScrollerBox = styled(Box)`
  /* Prevent overflow caused by change indicator */
  overflow-x: hidden;
  overflow-y: auto;
`, ContentHeaderBox = styled(Box)`
  box-shadow: 0 1px 0 var(--card-shadow-outline-color);
  position: relative;
  z-index: 10;
  min-height: auto;
`, POPOVER_FALLBACK_PLACEMENTS$4 = ["top", "bottom"];
function PopoverEditDialog(props2) {
  const $ = c(8), {
    floatingBoundary,
    referenceBoundary,
    referenceElement,
    width: t0
  } = props2, width = t0 === void 0 ? 1 : t0;
  let t1;
  $[0] !== props2 ? (t1 = /* @__PURE__ */ jsx(Content, { ...props2 }), $[0] = props2, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== floatingBoundary || $[3] !== referenceBoundary || $[4] !== referenceElement || $[5] !== t1 || $[6] !== width ? (t2 = /* @__PURE__ */ jsx(RootPopover, { content: t1, constrainSize: !0, "data-testid": "popover-edit-dialog", "data-ui": "PopoverEditDialog", fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$4, floatingBoundary, open: !0, overflow: "auto", placement: "bottom", portal: "default", preventOverflow: !0, referenceBoundary, referenceElement, width, autoFocus: !0 }), $[2] = floatingBoundary, $[3] = referenceBoundary, $[4] = referenceElement, $[5] = t1, $[6] = width, $[7] = t2) : t2 = $[7], t2;
}
function Content(props2) {
  const $ = c(26), {
    onClose,
    referenceBoundary,
    referenceElement,
    title
  } = props2, isClosedRef = useRef(!1);
  let t0;
  $[0] !== onClose ? (t0 = () => {
    isClosedRef.current = !0, onClose();
  }, $[0] = onClose, $[1] = t0) : t0 = $[1];
  const handleClose = t0;
  let t1;
  $[2] !== handleClose ? (t1 = (event) => {
    event.key === "Escape" && handleClose();
  }, $[2] = handleClose, $[3] = t1) : t1 = $[3], useGlobalKeyDown(t1);
  let t2;
  $[4] !== referenceElement ? (t2 = () => [referenceElement], $[4] = referenceElement, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== referenceBoundary ? (t3 = () => referenceBoundary, $[6] = referenceBoundary, $[7] = t3) : t3 = $[7], useClickOutsideEvent(handleClose, t2, t3);
  const [contentElement, setContentElement] = useState(null), containerElement = useRef(null);
  let t4;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t4 = (element) => isClosedRef.current ? !1 : !!element.contentEditable || !!containerElement.current?.contains(element), $[8] = t4) : t4 = $[8];
  const handleFocusLockWhiteList = t4;
  let t5;
  $[9] !== title ? (t5 = /* @__PURE__ */ jsx(Box, { flex: 1, padding: 2, children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: title }) }), $[9] = title, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    content: "Close"
  }, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== handleClose ? (t7 = /* @__PURE__ */ jsx(Button, { autoFocus: !0, icon: CloseIcon, mode: "bleed", onClick: handleClose, tooltipProps: t6 }), $[12] = handleClose, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t5 || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(ContentHeaderBox, { flex: "none", padding: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t5,
    t7
  ] }) }), $[14] = t5, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t9 = [0, 0, 1, 0], $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== props2.children ? (t10 = /* @__PURE__ */ jsx(ContentScrollerBox, { flex: 1, children: /* @__PURE__ */ jsx(PresenceOverlay, { margins: t9, children: /* @__PURE__ */ jsx(Box, { padding: 3, ref: setContentElement, children: props2.children }) }) }), $[18] = props2.children, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== t10 || $[21] !== t8 ? (t11 = /* @__PURE__ */ jsx(FocusLock, { autoFocus: !0, as: Fragment$1, whiteList: handleFocusLockWhiteList, children: /* @__PURE__ */ jsxs(Flex, { ref: containerElement, direction: "column", height: "fill", children: [
    t8,
    t10
  ] }) }), $[20] = t10, $[21] = t8, $[22] = t11) : t11 = $[22];
  let t12;
  return $[23] !== contentElement || $[24] !== t11 ? (t12 = /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement: contentElement, containerElement, children: t11 }), $[23] = contentElement, $[24] = t11, $[25] = t12) : t12 = $[25], t12;
}
function ObjectEditModal(props2) {
  const $ = c(29), {
    autoFocus,
    defaultType,
    floatingBoundary,
    onClose,
    referenceBoundary,
    referenceElement,
    schemaType
  } = props2, {
    t
  } = useTranslation();
  let t0, t1;
  $[0] !== schemaType ? (t1 = _getModalOption(schemaType), $[0] = schemaType, $[1] = t1) : t1 = $[1], t0 = t1;
  const schemaModalOption = t0, modalType = schemaModalOption?.type || defaultType;
  let t2;
  $[2] !== schemaType.i18nTitleKey || $[3] !== schemaType.name || $[4] !== schemaType.title || $[5] !== t ? (t2 = schemaType.i18nTitleKey ? t(schemaType.i18nTitleKey) : schemaType.title || schemaType.name, $[2] = schemaType.i18nTitleKey, $[3] = schemaType.name, $[4] = schemaType.title, $[5] = t, $[6] = t2) : t2 = $[6];
  const schemaTypeTitle = t2;
  let t3;
  $[7] !== schemaTypeTitle || $[8] !== t ? (t3 = t("inputs.portable-text.annotation-editor.title", {
    schemaType: schemaTypeTitle
  }), $[7] = schemaTypeTitle, $[8] = t, $[9] = t3) : t3 = $[9];
  const modalTitle = t3;
  let t4;
  $[10] !== onClose ? (t4 = () => {
    onClose();
  }, $[10] = onClose, $[11] = t4) : t4 = $[11];
  const handleClose = t4, modalWidth = schemaModalOption?.width;
  if (modalType === "popover") {
    let t52;
    $[12] !== modalTitle ? (t52 = /* @__PURE__ */ jsx(Fragment, { children: modalTitle }), $[12] = modalTitle, $[13] = t52) : t52 = $[13];
    let t6;
    return $[14] !== autoFocus || $[15] !== floatingBoundary || $[16] !== handleClose || $[17] !== modalWidth || $[18] !== props2.children || $[19] !== referenceBoundary || $[20] !== referenceElement || $[21] !== t52 ? (t6 = /* @__PURE__ */ jsx(PopoverEditDialog, { autoFocus, floatingBoundary, onClose: handleClose, referenceBoundary, referenceElement, title: t52, width: modalWidth, children: props2.children }), $[14] = autoFocus, $[15] = floatingBoundary, $[16] = handleClose, $[17] = modalWidth, $[18] = props2.children, $[19] = referenceBoundary, $[20] = referenceElement, $[21] = t52, $[22] = t6) : t6 = $[22], t6;
  }
  let t5;
  return $[23] !== autoFocus || $[24] !== handleClose || $[25] !== modalTitle || $[26] !== modalWidth || $[27] !== props2.children ? (t5 = /* @__PURE__ */ jsx(DefaultEditDialog, { onClose: handleClose, title: modalTitle, width: modalWidth, autoFocus, children: props2.children }), $[23] = autoFocus, $[24] = handleClose, $[25] = modalTitle, $[26] = modalWidth, $[27] = props2.children, $[28] = t5) : t5 = $[28], t5;
}
const InlineObject$1 = (props2) => {
  const {
    floatingBoundary,
    focused,
    onItemClose,
    onItemOpen,
    onPathFocus,
    path,
    readOnly,
    referenceBoundary,
    relativePath,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderCustomMarkers,
    renderField,
    renderItem: renderItem2,
    renderInlineBlock,
    renderInput,
    renderPreview,
    schemaType,
    selected,
    setElementRef,
    value
  } = props2, {
    Markers
  } = useFormBuilder().__internal.components, editor2 = usePortableTextEditor(), markers = usePortableTextMarkers(path), [divElement, setDivElement] = useState(null), memberItem = usePortableTextMemberItem(pathToString$1(path)), {
    validation: validation2,
    hasError,
    hasInfo,
    hasWarning
  } = useMemberValidation(memberItem?.node), parentSchemaType = editor2.schemaTypes.block, hasMarkers = markers.length > 0, selfSelection = useMemo(() => ({
    anchor: {
      path: relativePath,
      offset: 0
    },
    focus: {
      path: relativePath,
      offset: 0
    }
  }), [relativePath]), onRemove = useCallback(() => {
    PortableTextEditor.delete(editor2, selfSelection, {
      mode: "children"
    }), PortableTextEditor.focus(editor2);
  }, [selfSelection, editor2]), onOpen = useCallback(() => {
    memberItem && (PortableTextEditor.blur(editor2), onItemOpen(memberItem.node.path));
  }, [onItemOpen, editor2, memberItem]), onClose = useCallback(() => {
    onItemClose(), PortableTextEditor.select(editor2, selfSelection), PortableTextEditor.focus(editor2);
  }, [onItemClose, editor2, selfSelection]), isOpen = !!memberItem?.member.open, input = memberItem?.input, nodePath = memberItem?.node.path || EMPTY_ARRAY$A, referenceElement = divElement, presence = useChildPresence(path, !0), rootPresence = useMemo(() => presence.filter((p) => isEqual$3(p.path, path)), [path, presence]), componentProps = useMemo(() => ({
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    children: input,
    focused,
    onClose,
    onOpen,
    onPathFocus,
    onRemove,
    open: isOpen,
    markers,
    member: memberItem?.member,
    parentSchemaType,
    path: nodePath,
    presence: rootPresence,
    readOnly: !!readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderDefault: DefaultInlineObjectComponent,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    value,
    validation: validation2
  }), [floatingBoundary, focused, input, isOpen, markers, memberItem?.member, nodePath, onClose, onOpen, onPathFocus, onRemove, parentSchemaType, readOnly, referenceBoundary, referenceElement, renderAnnotation, renderBlock2, renderField, renderInlineBlock, renderInput, renderItem2, renderPreview, rootPresence, schemaType, selected, validation2, value]), tooltipEnabled = hasError || hasWarning || hasInfo || hasMarkers, toolTipContent = useMemo(() => tooltipEnabled && /* @__PURE__ */ jsx(TooltipBox$1, { children: /* @__PURE__ */ jsx(Markers, { markers, validation: validation2, renderCustomMarkers }) }) || null, [Markers, markers, renderCustomMarkers, tooltipEnabled, validation2]), setRef = useCallback((elm) => {
    memberItem && setElementRef({
      key: memberItem.member.key,
      elementRef: elm
    }), setDivElement(elm);
  }, [memberItem, setElementRef, setDivElement]);
  return useMemo(() => /* @__PURE__ */ jsx("span", { ref: setRef, contentEditable: !1, children: /* @__PURE__ */ jsx(
    Tooltip,
    {
      placement: "bottom",
      portal: "editor",
      disabled: isOpen ? !0 : !tooltipEnabled,
      content: toolTipContent,
      children: renderInlineBlock && /* @__PURE__ */ jsx("span", { style: {
        position: "relative"
      }, children: renderInlineBlock(componentProps) })
    }
  ) }), [componentProps, renderInlineBlock, setRef, toolTipContent, tooltipEnabled, isOpen]);
}, DefaultInlineObjectComponent = (props2) => {
  const $ = c(41), {
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    children,
    focused,
    markers,
    onClose,
    onOpen,
    onRemove,
    open,
    readOnly,
    renderPreview,
    schemaType,
    selected,
    validation: validation2,
    value
  } = props2, {
    t
  } = useTranslation(), hasMarkers = markers.length > 0, popoverTitle = schemaType?.title || schemaType.name, hasError = validation2.filter(_temp$1i).length > 0, hasWarning = validation2.filter(_temp2$p).length > 0;
  let t0;
  bb0: {
    if (hasError) {
      t0 = "critical";
      break bb0;
    }
    if (hasWarning) {
      t0 = "caution";
      break bb0;
    }
    if (selected || focused) {
      t0 = "primary";
      break bb0;
    }
    t0 = void 0;
  }
  const tone = t0;
  let t1;
  $[0] !== t ? (t1 = t("inputs.portable-text.inline-block.aria-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  const t2 = focused || void 0, t3 = hasError || void 0, t4 = hasMarkers || void 0, t5 = readOnly || void 0, t6 = selected || void 0, t7 = hasWarning || void 0, t8 = readOnly ? onOpen : void 0;
  let t9;
  $[2] !== renderPreview || $[3] !== schemaType || $[4] !== value ? (t9 = renderPreview({
    layout: "inline",
    schemaType,
    skipVisibilityCheck: !0,
    value,
    fallbackTitle: "Click to edit"
  }), $[2] = renderPreview, $[3] = schemaType, $[4] = value, $[5] = t9) : t9 = $[5];
  let t10;
  $[6] !== t9 ? (t10 = /* @__PURE__ */ jsx(PreviewSpan, { children: t9 }), $[6] = t9, $[7] = t10) : t10 = $[7];
  let t11;
  $[8] !== onOpen || $[9] !== t1 || $[10] !== t10 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== tone ? (t11 = /* @__PURE__ */ jsx(Root$h, { "aria-label": t1, "data-focused": t2, "data-invalid": t3, "data-markers": t4, "data-read-only": t5, "data-selected": t6, "data-warning": t7, forwardedAs: "span", onClick: t8, onDoubleClick: onOpen, tone, children: t10 }), $[8] = onOpen, $[9] = t1, $[10] = t10, $[11] = t2, $[12] = t3, $[13] = t4, $[14] = t5, $[15] = t6, $[16] = t7, $[17] = t8, $[18] = tone, $[19] = t11) : t11 = $[19];
  let t12;
  $[20] !== floatingBoundary || $[21] !== focused || $[22] !== onOpen || $[23] !== onRemove || $[24] !== open || $[25] !== popoverTitle || $[26] !== referenceBoundary || $[27] !== referenceElement ? (t12 = referenceElement && /* @__PURE__ */ jsx(InlineObjectToolbarPopover, { floatingBoundary, inlineObjectFocused: focused, inlineObjectOpen: open, onOpenInlineObject: onOpen, onRemoveInlineObject: onRemove, referenceBoundary, referenceElement, title: popoverTitle }), $[20] = floatingBoundary, $[21] = focused, $[22] = onOpen, $[23] = onRemove, $[24] = open, $[25] = popoverTitle, $[26] = referenceBoundary, $[27] = referenceElement, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== children || $[30] !== floatingBoundary || $[31] !== onClose || $[32] !== open || $[33] !== referenceBoundary || $[34] !== referenceElement || $[35] !== schemaType ? (t13 = open && /* @__PURE__ */ jsx(ObjectEditModal, { autoFocus: !0, defaultType: "popover", floatingBoundary, onClose, referenceBoundary, referenceElement, schemaType, children }), $[29] = children, $[30] = floatingBoundary, $[31] = onClose, $[32] = open, $[33] = referenceBoundary, $[34] = referenceElement, $[35] = schemaType, $[36] = t13) : t13 = $[36];
  let t14;
  return $[37] !== t11 || $[38] !== t12 || $[39] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t11,
    t12,
    t13
  ] }), $[37] = t11, $[38] = t12, $[39] = t13, $[40] = t14) : t14 = $[40], t14;
};
function _temp$1i(v) {
  return v.level === "error";
}
function _temp2$p(v_0) {
  return v_0.level === "warning";
}
function AnnotationObjectEditModal(props2) {
  const $ = c(14), editor2 = usePortableTextEditor(), boundaryElement = useBoundaryElement().element, portableTextMemberItems = usePortableTextMemberItems(), elementRefs = usePortableTextMemberItemElementRefs();
  let t0, t1;
  $[0] !== portableTextMemberItems ? (t1 = portableTextMemberItems.find(_temp$1h), $[0] = portableTextMemberItems, $[1] = t1) : t1 = $[1], t0 = t1;
  const openAnnotation = t0;
  let t2;
  $[2] !== editor2 || $[3] !== openAnnotation || $[4] !== props2 ? (t2 = () => {
    openAnnotation && (props2.onItemClose(), openAnnotation.node.value && isEmptyItem(openAnnotation.node.value) && openAnnotation && PortableTextEditor.removeAnnotation(editor2, openAnnotation.node.schemaType), PortableTextEditor.focus(editor2));
  }, $[2] = editor2, $[3] = openAnnotation, $[4] = props2, $[5] = t2) : t2 = $[5];
  const onClose = t2;
  if (!openAnnotation)
    return null;
  const elementRef = elementRefs[openAnnotation.member.key];
  if (!elementRef)
    return null;
  const t3 = !!props2.focused;
  let t4;
  return $[6] !== boundaryElement || $[7] !== elementRef || $[8] !== onClose || $[9] !== openAnnotation.input || $[10] !== openAnnotation.node.schemaType || $[11] !== props2.referenceBoundary || $[12] !== t3 ? (t4 = /* @__PURE__ */ jsx(ObjectEditModal, { defaultType: "popover", floatingBoundary: boundaryElement, onClose, autoFocus: t3, referenceBoundary: props2.referenceBoundary, referenceElement: elementRef, schemaType: openAnnotation.node.schemaType, children: openAnnotation.input }), $[6] = boundaryElement, $[7] = elementRef, $[8] = onClose, $[9] = openAnnotation.input, $[10] = openAnnotation.node.schemaType, $[11] = props2.referenceBoundary, $[12] = t3, $[13] = t4) : t4 = $[13], t4;
}
function _temp$1h(m) {
  return m.kind === "annotation" && m.member.open;
}
function Compositor(props2) {
  const $ = c(155), {
    changed,
    elementRef,
    focused,
    focusPath: t0,
    elementProps,
    hasFocusWithin,
    hideToolbar,
    hotkeys,
    isActive,
    isFullscreen,
    onActivate,
    onCopy,
    onItemClose,
    onItemOpen,
    onItemRemove,
    onPaste,
    onPathFocus,
    onToggleFullscreen,
    onUpload,
    path,
    rangeDecorations,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderBlockActions,
    renderCustomMarkers,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    resolveUploader: resolveUploader2,
    value
  } = props2, focusPath = t0 === void 0 ? EMPTY_ARRAY$A : t0, editor2 = usePortableTextEditor(), setElementRef = useSetPortableTextMemberItemElementRef(), boundaryElement = useBoundaryElement().element, [wrapperElement, setWrapperElement] = useState(null), [scrollElement, setScrollElement] = useState(null);
  let t1;
  $[0] !== onToggleFullscreen ? (t1 = () => {
    onToggleFullscreen();
  }, $[0] = onToggleFullscreen, $[1] = t1) : t1 = $[1];
  const handleToggleFullscreen = t1;
  let t2, t3;
  $[2] !== hotkeys?.custom ? (t3 = hotkeys?.custom || {}, $[2] = hotkeys?.custom, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== onToggleFullscreen || $[5] !== t3 ? (t4 = {
    "mod+enter": onToggleFullscreen,
    ...t3
  }, $[4] = onToggleFullscreen, $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== hotkeys || $[8] !== t4 ? (t5 = {
    ...hotkeys,
    custom: t4
  }, $[7] = hotkeys, $[8] = t4, $[9] = t5) : t5 = $[9], t2 = t5;
  const editorHotkeys = useHotkeys(t2), _renderBlockActions = value && renderBlockActions ? renderBlockActions : void 0, _renderCustomMarkers = value && renderCustomMarkers ? renderCustomMarkers : void 0, [portalElement, setPortalElement] = useState(null);
  let t6;
  $[10] !== _renderBlockActions || $[11] !== _renderCustomMarkers || $[12] !== boundaryElement || $[13] !== isFullscreen || $[14] !== onItemClose || $[15] !== onItemOpen || $[16] !== onItemRemove || $[17] !== onPathFocus || $[18] !== path || $[19] !== readOnly || $[20] !== renderAnnotation || $[21] !== renderBlock2 || $[22] !== renderField || $[23] !== renderInlineBlock || $[24] !== renderInput || $[25] !== renderItem2 || $[26] !== renderPreview || $[27] !== scrollElement || $[28] !== setElementRef ? (t6 = (blockProps) => {
    const {
      children,
      focused: blockFocused,
      path: blockPath,
      selected,
      schemaType: blockSchemaType,
      value: block
    } = blockProps;
    return /* @__PURE__ */ jsx(TextBlock, { floatingBoundary: boundaryElement, focused: blockFocused, isFullscreen, onItemClose, onItemOpen, onItemRemove, onPathFocus, path: path.concat(blockPath), readOnly, referenceBoundary: scrollElement, renderAnnotation, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderBlockActions: _renderBlockActions, renderCustomMarkers: _renderCustomMarkers, renderPreview, renderBlock: renderBlock2, schemaType: blockSchemaType, selected, setElementRef, value: block, children });
  }, $[10] = _renderBlockActions, $[11] = _renderCustomMarkers, $[12] = boundaryElement, $[13] = isFullscreen, $[14] = onItemClose, $[15] = onItemOpen, $[16] = onItemRemove, $[17] = onPathFocus, $[18] = path, $[19] = readOnly, $[20] = renderAnnotation, $[21] = renderBlock2, $[22] = renderField, $[23] = renderInlineBlock, $[24] = renderInput, $[25] = renderItem2, $[26] = renderPreview, $[27] = scrollElement, $[28] = setElementRef, $[29] = t6) : t6 = $[29];
  const renderTextBlock = t6;
  let t7;
  $[30] !== _renderBlockActions || $[31] !== _renderCustomMarkers || $[32] !== boundaryElement || $[33] !== isFullscreen || $[34] !== onItemClose || $[35] !== onItemOpen || $[36] !== onItemRemove || $[37] !== onPathFocus || $[38] !== path || $[39] !== readOnly || $[40] !== renderAnnotation || $[41] !== renderBlock2 || $[42] !== renderField || $[43] !== renderInlineBlock || $[44] !== renderInput || $[45] !== renderItem2 || $[46] !== renderPreview || $[47] !== scrollElement || $[48] !== setElementRef ? (t7 = (blockProps_0) => {
    const {
      focused: blockFocused_0,
      path: blockPath_0,
      selected: blockSelected,
      schemaType: blockSchemaType_0,
      value: blockValue
    } = blockProps_0;
    return /* @__PURE__ */ jsx(BlockObject, { floatingBoundary: boundaryElement, focused: blockFocused_0, isFullscreen, onItemClose, onItemOpen, onItemRemove, onPathFocus, path: path.concat(blockPath_0), readOnly, referenceBoundary: scrollElement, relativePath: blockPath_0, renderAnnotation, renderBlock: renderBlock2, renderBlockActions: _renderBlockActions, renderCustomMarkers: _renderCustomMarkers, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType: blockSchemaType_0, selected: blockSelected, setElementRef, value: blockValue });
  }, $[30] = _renderBlockActions, $[31] = _renderCustomMarkers, $[32] = boundaryElement, $[33] = isFullscreen, $[34] = onItemClose, $[35] = onItemOpen, $[36] = onItemRemove, $[37] = onPathFocus, $[38] = path, $[39] = readOnly, $[40] = renderAnnotation, $[41] = renderBlock2, $[42] = renderField, $[43] = renderInlineBlock, $[44] = renderInput, $[45] = renderItem2, $[46] = renderPreview, $[47] = scrollElement, $[48] = setElementRef, $[49] = t7) : t7 = $[49];
  const renderObjectBlock = t7;
  let t8;
  $[50] !== editor2.schemaTypes.block.name || $[51] !== renderObjectBlock || $[52] !== renderTextBlock ? (t8 = (blockProps_1) => {
    const {
      value: block_0
    } = blockProps_1;
    return block_0._type === editor2.schemaTypes.block.name ? renderTextBlock(blockProps_1) : renderObjectBlock(blockProps_1);
  }, $[50] = editor2.schemaTypes.block.name, $[51] = renderObjectBlock, $[52] = renderTextBlock, $[53] = t8) : t8 = $[53];
  const editorRenderBlock = t8;
  let t9;
  $[54] !== boundaryElement || $[55] !== editor2.schemaTypes.span.name || $[56] !== onItemClose || $[57] !== onItemOpen || $[58] !== onPathFocus || $[59] !== path || $[60] !== readOnly || $[61] !== renderAnnotation || $[62] !== renderBlock2 || $[63] !== renderCustomMarkers || $[64] !== renderField || $[65] !== renderInlineBlock || $[66] !== renderInput || $[67] !== renderItem2 || $[68] !== renderPreview || $[69] !== scrollElement || $[70] !== setElementRef ? (t9 = (childProps) => {
    const {
      children: children_0,
      focused: childFocused,
      path: childPath,
      selected: selected_0,
      schemaType: childSchemaType,
      value: child
    } = childProps;
    return child._type === editor2.schemaTypes.span.name ? children_0 : /* @__PURE__ */ jsx(InlineObject$1, { floatingBoundary: boundaryElement, focused: childFocused, onItemClose, onItemOpen, onPathFocus, path: path.concat(childPath), readOnly, referenceBoundary: scrollElement, relativePath: childPath, renderAnnotation, renderBlock: renderBlock2, renderCustomMarkers, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType: childSchemaType, selected: selected_0, setElementRef, value: child });
  }, $[54] = boundaryElement, $[55] = editor2.schemaTypes.span.name, $[56] = onItemClose, $[57] = onItemOpen, $[58] = onPathFocus, $[59] = path, $[60] = readOnly, $[61] = renderAnnotation, $[62] = renderBlock2, $[63] = renderCustomMarkers, $[64] = renderField, $[65] = renderInlineBlock, $[66] = renderInput, $[67] = renderItem2, $[68] = renderPreview, $[69] = scrollElement, $[70] = setElementRef, $[71] = t9) : t9 = $[71];
  const editorRenderChild = t9;
  let t10;
  $[72] !== boundaryElement || $[73] !== focused || $[74] !== onItemClose || $[75] !== onItemOpen || $[76] !== onPathFocus || $[77] !== path || $[78] !== readOnly || $[79] !== renderAnnotation || $[80] !== renderBlock2 || $[81] !== renderCustomMarkers || $[82] !== renderField || $[83] !== renderInlineBlock || $[84] !== renderInput || $[85] !== renderItem2 || $[86] !== renderPreview || $[87] !== scrollElement || $[88] !== setElementRef ? (t10 = (annotationProps) => {
    const {
      children: children_1,
      focused: editorNodeFocused,
      path: aPath,
      selected: selected_1,
      schemaType: aSchemaType,
      value: aValue
    } = annotationProps;
    return /* @__PURE__ */ jsx(Annotation$1, { editorNodeFocused, floatingBoundary: boundaryElement, focused: !!focused, onItemClose, onItemOpen, onPathFocus, path: path.concat(aPath), readOnly, referenceBoundary: scrollElement, renderAnnotation, renderBlock: renderBlock2, renderCustomMarkers, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType: aSchemaType, selected: selected_1, setElementRef, value: aValue, children: children_1 });
  }, $[72] = boundaryElement, $[73] = focused, $[74] = onItemClose, $[75] = onItemOpen, $[76] = onPathFocus, $[77] = path, $[78] = readOnly, $[79] = renderAnnotation, $[80] = renderBlock2, $[81] = renderCustomMarkers, $[82] = renderField, $[83] = renderInlineBlock, $[84] = renderInput, $[85] = renderItem2, $[86] = renderPreview, $[87] = scrollElement, $[88] = setElementRef, $[89] = t10) : t10 = $[89];
  const editorRenderAnnotation = t10, ariaDescribedBy = elementProps["aria-describedby"];
  let t11;
  $[90] !== focusPath || $[91] !== hasFocusWithin ? (t11 = () => {
    if (hasFocusWithin)
      return {
        anchor: {
          path: focusPath,
          offset: 0
        },
        focus: {
          path: focusPath,
          offset: 0
        }
      };
  }, $[90] = focusPath, $[91] = hasFocusWithin, $[92] = t11) : t11 = $[92];
  const [initialSelection] = useState(t11);
  let t12, t13;
  $[93] !== ariaDescribedBy || $[94] !== editorHotkeys || $[95] !== editorRenderAnnotation || $[96] !== editorRenderBlock || $[97] !== editorRenderChild || $[98] !== elementRef || $[99] !== handleToggleFullscreen || $[100] !== hideToolbar || $[101] !== initialSelection || $[102] !== isActive || $[103] !== isFullscreen || $[104] !== onCopy || $[105] !== onItemOpen || $[106] !== onPaste || $[107] !== path || $[108] !== rangeDecorations || $[109] !== readOnly || $[110] !== scrollElement ? (t13 = /* @__PURE__ */ jsx(Editor, { ariaDescribedBy, elementRef, initialSelection, hideToolbar, hotkeys: editorHotkeys, isActive, isFullscreen, onItemOpen, onCopy, onPaste, onToggleFullscreen: handleToggleFullscreen, path, rangeDecorations, readOnly, renderAnnotation: editorRenderAnnotation, renderBlock: editorRenderBlock, renderChild: editorRenderChild, setPortalElement, scrollElement, setScrollElement }), $[93] = ariaDescribedBy, $[94] = editorHotkeys, $[95] = editorRenderAnnotation, $[96] = editorRenderBlock, $[97] = editorRenderChild, $[98] = elementRef, $[99] = handleToggleFullscreen, $[100] = hideToolbar, $[101] = initialSelection, $[102] = isActive, $[103] = isFullscreen, $[104] = onCopy, $[105] = onItemOpen, $[106] = onPaste, $[107] = path, $[108] = rangeDecorations, $[109] = readOnly, $[110] = scrollElement, $[111] = t13) : t13 = $[111];
  let t14;
  $[112] !== editor2.schemaTypes.portableText.of || $[113] !== onUpload || $[114] !== resolveUploader2 || $[115] !== t13 ? (t14 = /* @__PURE__ */ jsx(UploadTargetCard, { types: editor2.schemaTypes.portableText.of, resolveUploader: resolveUploader2, onUpload, tabIndex: -1, children: t13 }), $[112] = editor2.schemaTypes.portableText.of, $[113] = onUpload, $[114] = resolveUploader2, $[115] = t13, $[116] = t14) : t14 = $[116], t12 = t14;
  const editorNode = t12, portal = usePortal();
  let t15, t16;
  $[117] !== portal.element || $[118] !== portalElement || $[119] !== wrapperElement ? (t16 = {
    collapsed: wrapperElement,
    default: portal.element,
    editor: portalElement,
    expanded: portal.element
  }, $[117] = portal.element, $[118] = portalElement, $[119] = wrapperElement, $[120] = t16) : t16 = $[120], t15 = t16;
  const portalElements = t15;
  let t17;
  $[121] !== focusPath || $[122] !== onItemClose || $[123] !== scrollElement ? (t17 = {
    focusPath,
    boundaryElement: scrollElement,
    onItemClose
  }, $[121] = focusPath, $[122] = onItemClose, $[123] = scrollElement, $[124] = t17) : t17 = $[124], useTrackFocusPath(t17);
  const editorFocused = focused || hasFocusWithin, t18 = portal.element, t19 = !isActive, t20 = !!focused, t21 = editorFocused ? "" : void 0, t22 = readOnly ? "" : void 0, t23 = isFullscreen ? "expanded" : "collapsed";
  let t24;
  $[125] !== editorNode || $[126] !== isFullscreen ? (t24 = isFullscreen ? /* @__PURE__ */ jsx(ExpandedLayer, { children: editorNode }) : editorNode, $[125] = editorNode, $[126] = isFullscreen, $[127] = t24) : t24 = $[127];
  let t25;
  $[128] !== focused || $[129] !== onItemClose || $[130] !== scrollElement ? (t25 = /* @__PURE__ */ jsx(AnnotationObjectEditModal, { focused, onItemClose, referenceBoundary: scrollElement }), $[128] = focused, $[129] = onItemClose, $[130] = scrollElement, $[131] = t25) : t25 = $[131];
  let t26;
  $[132] !== t23 || $[133] !== t24 || $[134] !== t25 ? (t26 = /* @__PURE__ */ jsx(Box, { "data-wrapper": "", ref: setWrapperElement, children: /* @__PURE__ */ jsxs(Portal, { __unstable_name: t23, children: [
    t24,
    t25
  ] }) }), $[132] = t23, $[133] = t24, $[134] = t25, $[135] = t26) : t26 = $[135];
  let t27;
  $[136] === Symbol.for("react.memo_cache_sentinel") ? (t27 = /* @__PURE__ */ jsx("div", { "data-border": "" }), $[136] = t27) : t27 = $[136];
  let t28;
  $[137] !== t21 || $[138] !== t22 || $[139] !== t26 ? (t28 = /* @__PURE__ */ jsxs(Root$l, { "data-focused": t21, "data-read-only": t22, children: [
    t26,
    t27
  ] }), $[137] = t21, $[138] = t22, $[139] = t26, $[140] = t28) : t28 = $[140];
  let t29;
  $[141] !== changed || $[142] !== isFullscreen || $[143] !== path || $[144] !== t20 || $[145] !== t28 ? (t29 = /* @__PURE__ */ jsx(ChangeIndicator, { disabled: isFullscreen, hasFocus: t20, isChanged: changed, path, children: t28 }), $[141] = changed, $[142] = isFullscreen, $[143] = path, $[144] = t20, $[145] = t28, $[146] = t29) : t29 = $[146];
  let t30;
  $[147] !== onActivate || $[148] !== t19 || $[149] !== t29 ? (t30 = /* @__PURE__ */ jsx(ActivateOnFocus, { onActivate, isOverlayActive: t19, children: t29 }), $[147] = onActivate, $[148] = t19, $[149] = t29, $[150] = t30) : t30 = $[150];
  let t31;
  return $[151] !== portal.element || $[152] !== portalElements || $[153] !== t30 ? (t31 = /* @__PURE__ */ jsx(TreeEditingEnabledProvider, { legacyEditing: !0, children: /* @__PURE__ */ jsx(PortalProvider, { __unstable_elements: portalElements, element: t18, children: t30 }) }), $[151] = portal.element, $[152] = portalElements, $[153] = t30, $[154] = t31) : t31 = $[154], t31;
}
function PortableTextMarkersProvider(props2) {
  const $ = c(3);
  let t0;
  return $[0] !== props2.children || $[1] !== props2.markers ? (t0 = /* @__PURE__ */ jsx(PortableTextMarkersContext.Provider, { value: props2.markers, children: props2.children }), $[0] = props2.children, $[1] = props2.markers, $[2] = t0) : t0 = $[2], t0;
}
function PortableTextMemberItemsProvider(props2) {
  const $ = c(3);
  let t0;
  return $[0] !== props2.children || $[1] !== props2.memberItems ? (t0 = /* @__PURE__ */ jsx(PortableTextMemberItemsContext.Provider, { value: props2.memberItems, children: props2.children }), $[0] = props2.children, $[1] = props2.memberItems, $[2] = t0) : t0 = $[2], t0;
}
function InvalidValue(props2) {
  const $ = c(42), {
    onChange,
    onIgnore,
    resolution,
    readOnly
  } = props2, telemetry = useTelemetry(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== onChange || $[1] !== resolution || $[2] !== telemetry ? (t0 = () => {
    resolution && (onChange({
      type: "mutation",
      patches: resolution.patches
    }), telemetry.log(PortableTextInvalidValueResolve, {
      PTEInvalidValueId: resolution.i18n.description,
      PTEInvalidValueDescription: resolution.description
    }));
  }, $[0] = onChange, $[1] = resolution, $[2] = telemetry, $[3] = t0) : t0 = $[3];
  const handleAction = t0;
  let t1;
  $[4] !== onIgnore || $[5] !== telemetry ? (t1 = () => {
    telemetry.log(PortableTextInvalidValueIgnore), onIgnore();
  }, $[4] = onIgnore, $[5] = telemetry, $[6] = t1) : t1 = $[6];
  const handleOnIgnore = t1;
  if (!resolution)
    return null;
  let t2;
  $[7] !== t ? (t2 = t("inputs.portable-text.invalid-value.title"), $[7] = t, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(Fragment, { children: t2 }), $[9] = t2, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== handleAction || $[12] !== handleOnIgnore || $[13] !== readOnly || $[14] !== resolution.action || $[15] !== resolution.i18n.action || $[16] !== resolution.i18n.values || $[17] !== t ? (t4 = resolution.action && /* @__PURE__ */ jsxs(Grid, { columns: [1, 2], gap: 1, children: [
    /* @__PURE__ */ jsx(Button$1, { mode: "ghost", onClick: handleOnIgnore, text: t("inputs.portable-text.invalid-value.ignore-button.text") }),
    !readOnly && /* @__PURE__ */ jsx(Button$1, { onClick: handleAction, text: /* @__PURE__ */ jsx(Translate, { t, i18nKey: resolution.i18n.action, values: resolution.i18n.values }), tone: "caution" })
  ] }), $[11] = handleAction, $[12] = handleOnIgnore, $[13] = readOnly, $[14] = resolution.action, $[15] = resolution.i18n.action, $[16] = resolution.i18n.values, $[17] = t, $[18] = t4) : t4 = $[18];
  let t5;
  $[19] !== resolution.action || $[20] !== t ? (t5 = resolution.action && /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: t("inputs.portable-text.invalid-value.action-disclaimer") }), $[19] = resolution.action, $[20] = t, $[21] = t5) : t5 = $[21];
  let t6;
  $[22] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { padding: 3, children: t5 }), $[22] = t5, $[23] = t6) : t6 = $[23];
  let t7;
  $[24] !== t4 || $[25] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { padding: 2, children: [
    t4,
    t6
  ] }), $[24] = t4, $[25] = t6, $[26] = t7) : t7 = $[26];
  let t8;
  $[27] !== resolution.i18n.description || $[28] !== resolution.i18n.values || $[29] !== t ? (t8 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: resolution.i18n.description, values: resolution.i18n.values }) }), $[27] = resolution.i18n.description, $[28] = resolution.i18n.values, $[29] = t, $[30] = t8) : t8 = $[30];
  let t9;
  $[31] !== resolution.item ? (t9 = JSON.stringify(resolution.item, null, 2), $[31] = resolution.item, $[32] = t9) : t9 = $[32];
  let t10;
  $[33] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { border: !0, overflow: "auto", padding: 2, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { language: "json", children: t9 }) }), $[33] = t9, $[34] = t10) : t10 = $[34];
  let t11;
  $[35] !== t10 || $[36] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t8,
    t10
  ] }), $[35] = t10, $[36] = t8, $[37] = t11) : t11 = $[37];
  let t12;
  return $[38] !== t11 || $[39] !== t3 || $[40] !== t7 ? (t12 = /* @__PURE__ */ jsx(Alert, { title: t3, suffix: t7, children: t11 }), $[38] = t11, $[39] = t3, $[40] = t7, $[41] = t12) : t12 = $[41], t12;
}
const DOT_SIZE = 6, CONTENT_BOX_VARIANTS = {
  animate: {
    opacity: 1,
    scaleX: 1,
    scaleY: 1
  },
  exit: {
    opacity: 0,
    scaleX: 0,
    scaleY: 0.5
  },
  initial: {
    opacity: 0,
    scaleX: 0,
    scaleY: 0.5
  }
}, CONTENT_BOX_TRANSITION = {
  duration: 0.3,
  ease: "easeInOut",
  type: "spring",
  bounce: 0
}, CONTENT_TEXT_VARIANTS = {
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  initial: {
    opacity: 0
  }
}, CONTENT_TEXT_TRANSITION = {
  duration: 0.2,
  delay: 0.15
}, CursorLine = styled.span(({
  theme,
  $tints
}) => {
  const isDark = getTheme_v2(theme)?.color._dark, bg = $tints[isDark ? 400 : 500].hex, fg = $tints[isDark ? 900 : 50].hex;
  return css`
    --presence-cursor-bg: ${bg};
    --presence-cursor-fg: ${fg};

    border-left: 1px solid transparent;
    border-color: var(--presence-cursor-bg);
    margin-left: -1px;
    position: relative;
    word-break: normal;
    white-space: normal;
    mix-blend-mode: unset;
    pointer-events: none;
  `;
}), CursorDot = styled.div`
  background-color: var(--presence-cursor-bg);
  border-radius: 50%;
  width: ${DOT_SIZE}px;
  height: ${DOT_SIZE}px;
  position: absolute;
  top: -${DOT_SIZE - 1}px;
  left: -0.5px;
  transform: translateX(-50%);
  mix-blend-mode: unset;
  z-index: 0;
  pointer-events: all;

  // Increase the hit area of the cursor dot
  &:before {
    content: '';
    position: absolute;
    top: -${DOT_SIZE / 2}px;
    left: 50%;
    transform: translateX(-50%);
    width: ${DOT_SIZE * 2}px;
    height: ${DOT_SIZE * 3}px;
    opacity: 0.5;
  }
`, UserBox = styled(motion.create(Box))(({
  theme
}) => {
  const radius = getTheme_v2(theme)?.radius[4];
  return css`
    position: absolute;
    top: -${DOT_SIZE * 1.5}px;
    left: -${DOT_SIZE * 0.75}px;
    transform-origin: left;
    white-space: nowrap;
    padding: 3px 6px;
    box-sizing: border-box;
    border-radius: ${radius}px;
    background-color: var(--presence-cursor-bg);
    z-index: 1;
    mix-blend-mode: unset;
    user-select: none;
  `;
}), UserText = styled(motion.create(Text$1))`
  color: var(--presence-cursor-fg);
  mix-blend-mode: unset;
`;
function UserPresenceCursor(props2) {
  const $ = c(15), {
    children,
    user
  } = props2, {
    tints
  } = useUserColor(user.id), [hovered, setHovered] = useState(!1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setHovered(!0), $[0] = t0) : t0 = $[0];
  const handleMouseEnter = t0;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setHovered(!1), $[1] = t1) : t1 = $[1];
  const handleMouseLeave = t1;
  let t2;
  t2 = `presence-cursor-${user.displayName?.split(" ").join("-")}`;
  const testId = t2;
  let t3;
  $[2] !== hovered || $[3] !== user.displayName ? (t3 = hovered && /* @__PURE__ */ jsx(UserBox, { animate: "animate", exit: "exit", flex: 1, initial: "initial", transition: CONTENT_BOX_TRANSITION, variants: CONTENT_BOX_VARIANTS, children: /* @__PURE__ */ jsx(UserText, { animate: "animate", exit: "exit", initial: "initial", size: 0, transition: CONTENT_TEXT_TRANSITION, variants: CONTENT_TEXT_VARIANTS, weight: "medium", children: user.displayName }) }), $[2] = hovered, $[3] = user.displayName, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t3 ? (t4 = /* @__PURE__ */ jsx(AnimatePresence, { children: t3 }), $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(CursorDot, {}), $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t4 || $[9] !== testId || $[10] !== tints ? (t6 = /* @__PURE__ */ jsxs(CursorLine, { $tints: tints, contentEditable: !1, "data-testid": testId, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [
    t4,
    t5
  ] }), $[8] = t4, $[9] = testId, $[10] = tints, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== children || $[13] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t6,
    children
  ] }), $[12] = children, $[13] = t6, $[14] = t7) : t7 = $[14], t7;
}
function usePresenceCursorDecorations(props2) {
  const $ = c(10), {
    path
  } = props2, fieldPresence = useFormFieldPresence();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [currentPresence, setCurrentPresence] = useState(t0);
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[1] = t1) : t1 = $[1];
  const [presenceCursorDecorations, setPresenceCursorDecorations] = useState(t1), previousPresence = useRef(currentPresence);
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (details) => {
    const {
      rangeDecoration,
      newSelection
    } = details;
    setPresenceCursorDecorations((prev) => prev.map((p) => p.payload?.sessionId === rangeDecoration.payload?.sessionId ? {
      ...rangeDecoration,
      selection: newSelection
    } : p));
  }, $[2] = t2) : t2 = $[2];
  const handleRangeDecorationMoved = t2;
  let t3, t4;
  $[3] !== fieldPresence || $[4] !== path ? (t3 = () => {
    const nextPresence = fieldPresence.filter((p_0) => startsWith(path, p_0.path) && !isEqual$2(path, p_0.path)), filteredNext = nextPresence.map(_temp$1g), filteredPrevious = previousPresence.current.map(_temp2$o);
    if (!isEqual$2(filteredNext, filteredPrevious)) {
      const value = nextPresence.length > 0 ? nextPresence : EMPTY_ARRAY$A;
      setCurrentPresence(value), previousPresence.current = value;
    }
  }, t4 = [fieldPresence, path], $[3] = fieldPresence, $[4] = path, $[5] = t3, $[6] = t4) : (t3 = $[5], t4 = $[6]), useEffect(t3, t4);
  let t5, t6;
  return $[7] !== currentPresence ? (t5 = () => {
    const decorations = currentPresence.map((presence) => {
      if (!presence.selection)
        return null;
      const cursorPoint = {
        focus: presence.selection.focus,
        anchor: presence.selection.focus
      };
      return {
        component: (t7) => {
          const {
            children
          } = t7;
          return /* @__PURE__ */ jsx(UserPresenceCursor, { user: presence.user, children });
        },
        selection: cursorPoint,
        onMoved: handleRangeDecorationMoved,
        payload: {
          sessionId: presence.sessionId
        }
      };
    });
    setPresenceCursorDecorations(decorations.filter(Boolean));
  }, t6 = [currentPresence, handleRangeDecorationMoved], $[7] = currentPresence, $[8] = t5, $[9] = t6) : (t5 = $[8], t6 = $[9]), useEffect(t5, t6), presenceCursorDecorations;
}
function _temp2$o(d_0) {
  return {
    ...d_0.selection,
    sessionId: d_0.sessionId
  };
}
function _temp$1g(d) {
  return {
    ...d.selection,
    sessionId: d.sessionId
  };
}
function getUploadCandidates(types, resolveUploader2, file) {
  return types.map((memberType) => ({
    type: memberType,
    uploader: resolveUploader2(memberType, file),
    parentType: memberType
  })).filter((member) => member.uploader);
}
function usePatches(props2) {
  const $ = c(5), {
    path
  } = props2, {
    patchChannel
  } = useFormBuilder().__internal;
  let t0;
  $[0] !== patchChannel || $[1] !== path ? (t0 = (subscriber) => patchChannel.subscribe((t12) => {
    const {
      snapshot: snapshot2,
      patches
    } = t12, filteredPatches = patches.filter((patch2) => _startsWith(patch2.path, path)).map((patch_0) => ({
      ...patch_0,
      path: patch_0.path.slice(path.length)
    }));
    filteredPatches.length && subscriber({
      shouldReset: _shouldReset(path, patches),
      snapshot: isRecord$4(snapshot2) ? _getValueAtPath(snapshot2, path) : {},
      patches: filteredPatches
    });
  }), $[0] = patchChannel, $[1] = path, $[2] = t0) : t0 = $[2];
  const subscribe2 = t0;
  let t1;
  return $[3] !== subscribe2 ? (t1 = {
    subscribe: subscribe2
  }, $[3] = subscribe2, $[4] = t1) : t1 = $[4], t1;
}
function _isSegmentEqual(segment1, segment2) {
  const segment1Type = typeof segment1;
  return segment1Type !== typeof segment2 ? !1 : segment1Type === "object" ? shallowEquals(segment1, segment2) : segment1 === segment2;
}
function _startsWith(subjectPath, checkPath2) {
  if (subjectPath === checkPath2)
    return !0;
  if (!Array.isArray(subjectPath) || !Array.isArray(checkPath2) || subjectPath.length < checkPath2.length)
    return !1;
  for (let i = 0, len = checkPath2.length; i < len; i++)
    if (!_isSegmentEqual(checkPath2[i], subjectPath[i]))
      return !1;
  return !0;
}
function _isAncestor(path1, path2) {
  return path1.length === 0 || _startsWith(path2, path1) && !_startsWith(path1, path2);
}
function _shouldReset(path, patches) {
  return patches.some((patch2) => _isAncestor(patch2.path, path) && (patch2.type === "set" || patch2.type === "unset"));
}
function _getValueAtPath(value, path) {
  return path.reduce((result, segment) => typeof segment == "object" ? find(result, segment) : get(result, segment), value);
}
function keyGenerator() {
  return randomKey$1(12);
}
const EditorRefPlugin = forwardRef((_, ref) => {
  const $ = c(2), portableTextEditor = usePortableTextEditor(), portableTextEditorRef = useRef(portableTextEditor);
  let t0, t1;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => portableTextEditorRef.current, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useImperativeHandle(ref, t0, t1), null;
});
EditorRefPlugin.displayName = "EditorRefPlugin";
function PortableTextInput(props2) {
  const {
    editorRef: editorRefProp,
    elementProps,
    hotkeys,
    initialActive,
    initialFullscreen,
    markers = EMPTY_ARRAY$A,
    onChange,
    onCopy,
    onEditorChange,
    onFullScreenChange,
    onInsert,
    onItemRemove,
    onPaste,
    onPathFocus,
    path,
    readOnly,
    rangeDecorations: rangeDecorationsProp,
    renderBlockActions,
    renderCustomMarkers,
    schemaType,
    value,
    resolveUploader: resolveUploader2,
    onUpload
  } = props2, {
    onBlur,
    ref: elementRef
  } = elementProps, defaultEditorRef = useRef(null), editorRef = editorRefProp || defaultEditorRef, presenceCursorDecorations = usePresenceCursorDecorations(useMemo(() => ({
    path: props2.path
  }), [props2.path])), {
    t
  } = useTranslation(), [ignoreValidationError, setIgnoreValidationError] = useState(!1), [invalidValue, setInvalidValue] = useState(null), [isFullscreen, setIsFullscreen] = useState(initialFullscreen ?? !1), [isActive, setIsActive] = useState(initialActive ?? !0), [hasFocusWithin, setHasFocusWithin] = useState(!1), [ready, setReady] = useState(!1), telemetry = useTelemetry(), toast = useToast(), handleToggleFullscreen = useCallback(() => {
    setIsFullscreen((v) => {
      const next = !v;
      return next ? telemetry.log(PortableTextInputExpanded) : telemetry.log(PortableTextInputCollapsed), onFullScreenChange?.(next), next;
    });
  }, [onFullScreenChange, telemetry]);
  useEffect(() => {
    invalidValue && value !== invalidValue.value && setInvalidValue(null);
  }, [invalidValue, value]);
  const portableTextMemberItems = usePortableTextMemberItemsFromProps(props2);
  useEffect(() => {
    hasFocusWithin && setIsActive(!0);
  }, [hasFocusWithin]);
  const setFocusPathFromEditorSelection = useCallback((nextSelection) => {
    const focusPath = nextSelection?.focus.path;
    if (!focusPath) return;
    const nextFocusPath = focusPath.length === 3 && // A span path is always 3 segments long
    focusPath[1] === "children" && // Is a child of a block
    isKeySegment(focusPath[2]) && // Contains the key of the child
    !portableTextMemberItems.some((item) => isKeySegment(focusPath[2]) && item.member.key === focusPath[2]._key) ? focusPath.concat(["text"]) : focusPath;
    startTransition(() => {
      onPathFocus(nextFocusPath, {
        selection: nextSelection
      });
    });
  }, [onPathFocus, portableTextMemberItems]), handleEditorChange = useCallback((change) => {
    switch (change.type) {
      case "mutation":
        onChange(toFormPatches(change.patches));
        break;
      case "selection":
        setFocusPathFromEditorSelection(change.selection);
        break;
      case "focus":
        setIsActive(!0), setHasFocusWithin(!0);
        break;
      case "blur":
        onBlur(change.event), setHasFocusWithin(!1);
        break;
      case "invalidValue":
        setInvalidValue(change);
        break;
      case "error":
        toast.push({
          status: change.level,
          description: change.description
        });
        break;
      case "ready":
        setReady(!0);
        break;
    }
    editorRef.current && onEditorChange && onEditorChange(change, editorRef.current);
  }, [editorRef, onEditorChange, onChange, setFocusPathFromEditorSelection, onBlur, toast]);
  useEffect(() => {
    setIgnoreValidationError(!1);
  }, [value]);
  const handleIgnoreInvalidValue = useCallback(() => {
    setIgnoreValidationError(!0);
  }, []), respondToInvalidContent = useMemo(() => invalidValue && invalidValue.resolution ? /* @__PURE__ */ jsx(Box, { marginBottom: 2, children: /* @__PURE__ */ jsx(InvalidValue, { onChange: handleEditorChange, onIgnore: handleIgnoreInvalidValue, resolution: invalidValue.resolution, readOnly }) }) : null, [handleEditorChange, handleIgnoreInvalidValue, invalidValue, readOnly]), handleActivate = useCallback(() => {
    isActive || (setIsActive(!0), editorRef.current && PortableTextEditor.focus(editorRef.current));
  }, [editorRef, isActive]), previousRangeDecorations = useRef([]), rangeDecorations = useMemo(() => {
    const result = [...rangeDecorationsProp || [], ...presenceCursorDecorations], reconciled = immutableReconcile(previousRangeDecorations.current, result);
    return previousRangeDecorations.current = reconciled, reconciled;
  }, [presenceCursorDecorations, rangeDecorationsProp]), uploadFile2 = useCallback((file, resolvedUploader) => {
    const {
      type,
      uploader
    } = resolvedUploader;
    onUpload?.({
      file,
      schemaType: type,
      uploader
    });
  }, [onUpload]), handleFiles = useCallback((files) => {
    if (!resolveUploader2)
      return;
    const tasks2 = files.map((file_0) => ({
      file: file_0,
      uploaderCandidates: getUploadCandidates(schemaType.of, resolveUploader2, file_0)
    })), readyTasks = tasks2.filter((task) => task.uploaderCandidates.length > 0), rejected = tasks2.filter((task_0) => task_0.uploaderCandidates.length === 0);
    rejected.length > 0 && toast.push({
      closable: !0,
      status: "warning",
      title: t("inputs.array.error.cannot-upload-unable-to-convert", {
        count: rejected.length
      }),
      description: rejected.map((task_1, i) => /* @__PURE__ */ jsxs(Flex, { gap: 2, padding: 2, children: [
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: task_1.file.name }) }),
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
          "(",
          task_1.file.type,
          ")"
        ] }) })
      ] }, i))
    }), readyTasks.forEach((task_2) => {
      uploadFile2(
        task_2.file,
        // eslint-disable-next-line max-nested-callbacks
        sortBy(task_2.uploaderCandidates, (candidate) => candidate.uploader.priority)[0]
      );
    });
  }, [toast, resolveUploader2, schemaType, uploadFile2, t]), handlePaste = useCallback((input) => {
    const {
      event
    } = input, eventType = event.type === "paste" ? "paste" : "drop", hasHtml = !!event.clipboardData.getData("text/html"), hasText = !!event.clipboardData.getData("text/plain");
    return eventType === "paste" && hasHtml && hasText || extractPastedFiles(event.clipboardData).then((files_0) => files_0.length > 0 ? files_0 : []).then((files_1) => {
      handleFiles(files_1);
    }), onPaste?.(input);
  }, [handleFiles, onPaste]);
  return /* @__PURE__ */ jsxs(Box, { children: [
    !ignoreValidationError && respondToInvalidContent,
    (!invalidValue || ignoreValidationError) && /* @__PURE__ */ jsx(PortableTextMarkersProvider, { markers, children: /* @__PURE__ */ jsx(PortableTextMemberItemsProvider, { memberItems: portableTextMemberItems, children: /* @__PURE__ */ jsxs(EditorProvider, { initialConfig: {
      initialValue: value,
      readOnly: readOnly || !ready,
      keyGenerator,
      schema: schemaType
    }, children: [
      /* @__PURE__ */ jsx(EditorChangePlugin, { onChange: handleEditorChange }),
      /* @__PURE__ */ jsx(EditorRefPlugin, { ref: editorRef }),
      /* @__PURE__ */ jsx(PatchesPlugin, { path }),
      /* @__PURE__ */ jsx(UpdateReadOnlyPlugin, { readOnly: readOnly || !ready }),
      /* @__PURE__ */ jsx(UpdateValuePlugin, { value }),
      /* @__PURE__ */ jsx(MarkdownPlugin, { config: {
        boldDecorator: ({
          schema: schema2
        }) => schema2.decorators.find((decorator) => decorator.name === "strong")?.name,
        codeDecorator: ({
          schema: schema_0
        }) => schema_0.decorators.find((decorator_0) => decorator_0.name === "code")?.name,
        italicDecorator: ({
          schema: schema_1
        }) => schema_1.decorators.find((decorator_1) => decorator_1.name === "em")?.name,
        strikeThroughDecorator: ({
          schema: schema_2
        }) => schema_2.decorators.find((decorator_2) => decorator_2.name === "strike-through")?.name,
        defaultStyle: ({
          schema: schema_3
        }) => schema_3.styles.find((style) => style.name === "normal")?.name,
        blockquoteStyle: ({
          schema: schema_4
        }) => schema_4.styles.find((style_0) => style_0.name === "blockquote")?.name,
        headingStyle: ({
          schema: schema_5,
          level
        }) => schema_5.styles.find((style_1) => style_1.name === `h${level}`)?.name,
        orderedListStyle: ({
          schema: schema_6
        }) => schema_6.lists.find((list) => list.name === "number")?.name,
        unorderedListStyle: ({
          schema: schema_7
        }) => schema_7.lists.find((list_0) => list_0.name === "bullet")?.name
      } }),
      /* @__PURE__ */ jsx(Compositor, { ...props2, elementRef, hasFocusWithin, hotkeys, isActive, isFullscreen, onActivate: handleActivate, onItemRemove, onCopy, onInsert, onPaste: handlePaste, onToggleFullscreen: handleToggleFullscreen, rangeDecorations, readOnly: readOnly || !ready, renderBlockActions, renderCustomMarkers })
    ] }) }) })
  ] });
}
function EditorChangePlugin(props2) {
  const $ = c(4);
  let t0;
  $[0] !== props2 ? (t0 = (event) => {
    bb2: switch (event.type) {
      case "blurred": {
        props2.onChange({
          type: "blur",
          event: event.event
        });
        break bb2;
      }
      case "error": {
        props2.onChange({
          type: "error",
          name: event.name,
          level: "warning",
          description: event.description
        });
        break bb2;
      }
      case "focused": {
        props2.onChange({
          type: "focus",
          event: event.event
        });
        break bb2;
      }
      case "loading": {
        props2.onChange({
          type: "loading",
          isLoading: !0
        });
        break bb2;
      }
      case "done loading": {
        props2.onChange({
          type: "loading",
          isLoading: !1
        });
        break bb2;
      }
      case "invalid value": {
        props2.onChange({
          type: "invalidValue",
          resolution: event.resolution,
          value: event.value
        });
        break bb2;
      }
      case "mutation": {
        props2.onChange(event);
        break bb2;
      }
      case "patch": {
        props2.onChange(event);
        break bb2;
      }
      case "ready": {
        props2.onChange(event);
        break bb2;
      }
      case "selection": {
        props2.onChange(event);
        break bb2;
      }
      case "value changed": {
        props2.onChange({
          type: "value",
          value: event.value
        });
        break bb2;
      }
    }
  }, $[0] = props2, $[1] = t0) : t0 = $[1];
  const handleEditorEvent = t0;
  let t1;
  return $[2] !== handleEditorEvent ? (t1 = /* @__PURE__ */ jsx(EventListenerPlugin, { on: handleEditorEvent }), $[2] = handleEditorEvent, $[3] = t1) : t1 = $[3], t1;
}
function PatchesPlugin(props2) {
  const $ = c(6), editor2 = useEditor();
  let t0;
  $[0] !== props2.path ? (t0 = {
    path: props2.path
  }, $[0] = props2.path, $[1] = t0) : t0 = $[1];
  const {
    subscribe: subscribe2
  } = usePatches(t0);
  let t1, t2;
  return $[2] !== editor2 || $[3] !== subscribe2 ? (t1 = () => {
    const unsubscribe = subscribe2((t3) => {
      const {
        patches,
        snapshot: snapshot2
      } = t3;
      editor2.send({
        type: "patches",
        patches,
        snapshot: snapshot2
      });
    });
    return () => unsubscribe();
  }, t2 = [editor2, subscribe2], $[2] = editor2, $[3] = subscribe2, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2), null;
}
function UpdateValuePlugin(props2) {
  const $ = c(4), editor2 = useEditor();
  let t0, t1;
  return $[0] !== editor2 || $[1] !== props2.value ? (t0 = () => {
    editor2.send({
      type: "update value",
      value: props2.value
    });
  }, t1 = [editor2, props2.value], $[0] = editor2, $[1] = props2.value, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), null;
}
function UpdateReadOnlyPlugin(props2) {
  const $ = c(4), editor2 = useEditor();
  let t0, t1;
  return $[0] !== editor2 || $[1] !== props2.readOnly ? (t0 = () => {
    editor2.send({
      type: "update readOnly",
      readOnly: props2.readOnly
    });
  }, t1 = [editor2, props2.readOnly], $[0] = editor2, $[1] = props2.readOnly, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), null;
}
function toFormPatches(patches) {
  return patches.map((p) => ({
    ...p,
    patchType: SANITY_PATCH_TYPE
  }));
}
function focusRingBorderStyle$1(border) {
  return `inset 0 0 0 ${border.width}px ${border.color}`;
}
function focusRingStyle(opts) {
  const {
    base,
    border,
    focusRing
  } = opts, focusRingOutsetWidth = focusRing.offset + focusRing.width, focusRingInsetWidth = 0 - focusRing.offset, bgColor = base ? base.bg : "var(--card-bg-color)";
  return [focusRingInsetWidth > 0 && `inset 0 0 0 ${focusRingInsetWidth}px var(--card-focus-ring-color)`, border && focusRingBorderStyle$1(border), focusRingInsetWidth < 0 && `0 0 0 ${0 - focusRingInsetWidth}px ${bgColor}`, focusRingOutsetWidth > 0 && `0 0 0 ${focusRingOutsetWidth}px var(--card-focus-ring-color)`].filter(Boolean).join(",");
}
const Root$g = styled(Card)((props2) => {
  const {
    theme
  } = props2, {
    focusRing,
    input,
    radius
  } = theme.sanity, color = theme.sanity.color.input, space = rem(theme.sanity.space[1]);
  return {
    position: "relative",
    borderRadius: `${radius[1]}px`,
    color: color.default.enabled.fg,
    boxShadow: focusRingBorderStyle$1({
      color: color.default.enabled.border,
      width: input.border.width
    }),
    "& > .content": {
      position: "relative",
      lineHeight: 0,
      margin: `-${space} 0 0 -${space}`
    },
    "& > .content > div": {
      display: "inline-block",
      verticalAlign: "top",
      padding: `${space} 0 0 ${space}`
    },
    // enabled
    "&:not([data-read-only])": {
      cursor: "text"
    },
    // hovered
    "@media(hover:hover):not([data-disabled]):not([data-read-only]):hover": {
      borderColor: color.default.hovered.border
    },
    // focused
    "&:not([data-disabled]):not([data-read-only])[data-focused]": {
      boxShadow: focusRingStyle({
        border: {
          color: color.default.enabled.border,
          width: input.border.width
        },
        focusRing
      })
    },
    // disabled
    "*:disabled + &": {
      color: color.default.disabled.fg,
      backgroundColor: color.default.disabled.bg,
      boxShadow: focusRingBorderStyle$1({
        color: color.default.disabled.border,
        width: input.border.width
      })
    }
  };
}), Input = styled.input((props2) => {
  const {
    theme
  } = props2, font = theme.sanity.fonts.text, color = theme.sanity.color.input, p = theme.sanity.space[2], size = theme.sanity.fonts.text.sizes[2];
  return {
    appearance: "none",
    background: "none",
    border: 0,
    borderRadius: 0,
    outline: "none",
    fontSize: rem(size.fontSize),
    lineHeight: size.lineHeight / size.fontSize,
    fontFamily: font.family,
    fontWeight: font.weights.regular,
    margin: 0,
    display: "block",
    minWidth: "1px",
    maxWidth: "100%",
    boxSizing: "border-box",
    paddingTop: rem(p - size.ascenderHeight),
    paddingRight: rem(p),
    paddingBottom: rem(p - size.descenderHeight),
    paddingLeft: rem(p),
    // enabled
    "&:not(:invalid):not(:disabled)": {
      color: color.default.enabled.fg
    },
    // disabled
    "&:not(:invalid):disabled": {
      color: color.default.disabled.fg
    }
  };
}), Placeholder$1 = styled(Box)((props2) => {
  const {
    theme
  } = props2, color = theme.sanity.color.input;
  return css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    --card-fg-color: ${color.default.enabled.placeholder};
  `;
}), TagBox = styled(Box)`
  // This is needed to make textOverflow="ellipsis" work properly for the Text primitive
  max-width: 100%;
`, TagInput = forwardRef((props2, forwardedRef) => {
  const $ = c(54);
  let disabled, onChange, onFocus, placeholderProp, readOnly, restProps, t0;
  $[0] !== props2 ? ({
    disabled,
    onChange,
    onFocus,
    placeholder: placeholderProp,
    readOnly,
    value: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = disabled, $[2] = onChange, $[3] = onFocus, $[4] = placeholderProp, $[5] = readOnly, $[6] = restProps, $[7] = t0) : (disabled = $[1], onChange = $[2], onFocus = $[3], placeholderProp = $[4], readOnly = $[5], restProps = $[6], t0 = $[7]);
  let t1;
  $[8] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[8] = t0, $[9] = t1) : t1 = $[9];
  const value = t1, {
    t
  } = useTranslation(studioLocaleNamespace), [inputValue, setInputValue] = useState(""), enabled = !disabled && !readOnly, [focused, setFocused] = useState(!1), ref = useRef(null), rootRef = useRef(null);
  let t2;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => ref.current, $[10] = t2) : t2 = $[10], useImperativeHandle(forwardedRef, t2);
  let t3;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (event) => {
    if (isHTMLElement(event.target) && event.target.closest('[data-ui="Tag"]'))
      return;
    const inputElement = ref.current;
    inputElement && setTimeout(() => inputElement.focus(), 0);
  }, $[11] = t3) : t3 = $[11];
  const handleRootPointerDown = t3;
  let t4;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setFocused(!1);
  }, $[12] = t4) : t4 = $[12];
  const handleInputBlur = t4;
  let t5;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (event_0) => {
    setInputValue(event_0.currentTarget.value);
  }, $[13] = t5) : t5 = $[13];
  const handleInputChange = t5;
  let t6;
  $[14] !== onFocus ? (t6 = (event_1) => {
    setFocused(!0), onFocus && onFocus(event_1);
  }, $[14] = onFocus, $[15] = t6) : t6 = $[15];
  const handleInputFocus = t6;
  let t7;
  $[16] !== inputValue || $[17] !== onChange || $[18] !== value ? (t7 = (event_2) => {
    if (event_2.key === "Enter" && (event_2.preventDefault(), event_2.stopPropagation(), onChange && inputValue)) {
      const newValue = value.concat([{
        value: inputValue
      }]);
      setInputValue(""), onChange && onChange(newValue);
    }
  }, $[16] = inputValue, $[17] = onChange, $[18] = value, $[19] = t7) : t7 = $[19];
  const handleInputKeyDown = t7;
  let t8;
  $[20] !== onChange || $[21] !== value ? (t8 = (index) => {
    if (!onChange)
      return;
    const newValue_0 = value.slice(0);
    newValue_0.splice(index, 1), onChange(newValue_0);
  }, $[20] = onChange, $[21] = value, $[22] = t8) : t8 = $[22];
  const handleTagRemove = t8;
  let t9;
  $[23] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
    const inputElement_0 = ref.current;
    inputElement_0 && (inputElement_0.style.width = "0", inputElement_0.style.width = `${inputElement_0.scrollWidth}px`);
  }, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== inputValue ? (t10 = [inputValue], $[24] = inputValue, $[25] = t10) : t10 = $[25], useEffect(t9, t10);
  const t11 = disabled ? "" : void 0, t12 = focused ? "" : void 0, t13 = readOnly ? "" : void 0;
  let t14;
  $[26] !== enabled || $[27] !== inputValue || $[28] !== placeholderProp || $[29] !== t || $[30] !== value.length ? (t14 = enabled && /* @__PURE__ */ jsx(Placeholder$1, { hidden: !!(inputValue || value.length), padding: 3, children: /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", children: placeholderProp || t("inputs.tags.placeholder", {
    context: typeof window < "u" && "ontouchstart" in window ? "touch" : void 0
  }) }) }), $[26] = enabled, $[27] = inputValue, $[28] = placeholderProp, $[29] = t, $[30] = value.length, $[31] = t14) : t14 = $[31];
  let t15;
  if ($[32] !== enabled || $[33] !== handleTagRemove || $[34] !== value) {
    let t162;
    $[36] !== enabled || $[37] !== handleTagRemove ? (t162 = (tag, tagIndex) => /* @__PURE__ */ jsx(TagBox, { children: /* @__PURE__ */ jsx(Tag, { enabled, index: tagIndex, muted: !enabled, onRemove: handleTagRemove, tag }) }, `tag-${tagIndex}`), $[36] = enabled, $[37] = handleTagRemove, $[38] = t162) : t162 = $[38], t15 = value.map(t162), $[32] = enabled, $[33] = handleTagRemove, $[34] = value, $[35] = t15;
  } else
    t15 = $[35];
  const t16 = !enabled;
  let t17;
  $[39] !== handleInputFocus || $[40] !== handleInputKeyDown || $[41] !== inputValue || $[42] !== restProps || $[43] !== t16 ? (t17 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Input, { ...restProps, disabled: t16, onBlur: handleInputBlur, onChange: handleInputChange, onFocus: handleInputFocus, onKeyDown: handleInputKeyDown, ref, type: "text", value: inputValue }) }, "tag-input"), $[39] = handleInputFocus, $[40] = handleInputKeyDown, $[41] = inputValue, $[42] = restProps, $[43] = t16, $[44] = t17) : t17 = $[44];
  let t18;
  $[45] !== t15 || $[46] !== t17 ? (t18 = /* @__PURE__ */ jsxs("div", { className: "content", children: [
    t15,
    t17
  ] }), $[45] = t15, $[46] = t17, $[47] = t18) : t18 = $[47];
  let t19;
  return $[48] !== t11 || $[49] !== t12 || $[50] !== t13 || $[51] !== t14 || $[52] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Root$g, { "data-disabled": t11, "data-focused": t12, "data-read-only": t13, "data-ui": "TagInput", onPointerDown: handleRootPointerDown, overflow: "auto", padding: 1, ref: rootRef, children: [
    t14,
    t18
  ] }), $[48] = t11, $[49] = t12, $[50] = t13, $[51] = t14, $[52] = t18, $[53] = t19) : t19 = $[53], t19;
});
TagInput.displayName = "ForwardRef(TagInput)";
function Tag(props2) {
  const $ = c(12), {
    enabled,
    index,
    muted,
    onRemove,
    tag
  } = props2;
  let t0;
  $[0] !== index || $[1] !== onRemove ? (t0 = () => {
    onRemove(index);
  }, $[0] = index, $[1] = onRemove, $[2] = t0) : t0 = $[2];
  const handleRemoveClick = t0;
  let t1;
  $[3] !== muted || $[4] !== tag.value ? (t1 = /* @__PURE__ */ jsx(Box, { flex: 1, paddingY: 2, paddingLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { muted, textOverflow: "ellipsis", children: tag.value }) }), $[3] = muted, $[4] = tag.value, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== enabled || $[7] !== handleRemoveClick ? (t2 = enabled && /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: handleRemoveClick, tooltipProps: {
    content: "Remove"
  } }), $[6] = enabled, $[7] = handleRemoveClick, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== t1 || $[10] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { "data-ui": "Tag", radius: 2, tone: "transparent", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t1,
    t2
  ] }) }), $[9] = t1, $[10] = t2, $[11] = t3) : t3 = $[11], t3;
}
function TagsArrayInput(props2) {
  const $ = c(15), {
    onChange,
    readOnly,
    value: t0,
    elementProps,
    path,
    changed
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const value = t1;
  let t2, t3;
  $[2] !== value ? (t3 = value?.map(_temp$1f), $[2] = value, $[3] = t3) : t3 = $[3], t2 = t3;
  const tagInputValue = t2;
  let t4;
  $[4] !== onChange ? (t4 = (nextValue) => {
    onChange(nextValue.length === 0 ? unset() : set(nextValue.map(_temp2$n)));
  }, $[4] = onChange, $[5] = t4) : t4 = $[5];
  const handleChange = t4;
  let t5;
  $[6] !== elementProps || $[7] !== handleChange || $[8] !== readOnly || $[9] !== tagInputValue ? (t5 = /* @__PURE__ */ jsx(TagInput, { onChange: handleChange, readOnly, value: tagInputValue, ...elementProps }), $[6] = elementProps, $[7] = handleChange, $[8] = readOnly, $[9] = tagInputValue, $[10] = t5) : t5 = $[10];
  let t6;
  return $[11] !== changed || $[12] !== path || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !1, children: t5 }), $[11] = changed, $[12] = path, $[13] = t5, $[14] = t6) : t6 = $[14], t6;
}
function _temp2$n(v_0) {
  return v_0.value;
}
function _temp$1f(v) {
  return {
    value: v
  };
}
const PRIMITIVES = ["string", "number", "boolean"];
function isArrayOfPrimitives(type) {
  return type.of.every((ofType) => PRIMITIVES.includes(ofType.jsonType));
}
function isStringArray(type) {
  return type.of.length === 1 && is$1("string", type.of[0]);
}
function isTagsArray(type) {
  return type.options?.layout === "tags";
}
function isPortableText(type) {
  return type.of.some((memberType) => is$1("block", memberType));
}
function hasListOptions(type) {
  return !!type.options?.list;
}
function resolveArrayInput(type) {
  return isStringArray(type) && isTagsArray(type) ? TagsArrayInput : hasListOptions(type) ? ArrayOfOptionsInput : isArrayOfPrimitives(type) ? ArrayOfPrimitivesInput : isPortableText(type) ? PortableTextInput : ArrayOfObjectsInput;
}
function toSelectItem$1(option) {
  return isTitledListValue(option) ? option : {
    title: capitalize(`${option}`),
    value: option
  };
}
const EMPTY_ITEM = {
  title: "",
  value: void 0
};
function SelectInput(props2) {
  const {
    value,
    readOnly,
    validationError,
    schemaType,
    onChange,
    path,
    changed,
    focused,
    elementProps
  } = props2, items = useMemo(() => (schemaType.options?.list || []).map(toSelectItem$1), [schemaType.options?.list]), currentItem = items.find((item) => item.value === value), isRadio = schemaType.options && schemaType.options.layout === "radio", itemFromOptionValue = useCallback((optionValue) => {
    const index = Number(optionValue);
    return items[index];
  }, [items]), optionValueFromItem = useCallback((item_0) => String(items.indexOf(item_0)), [items]), inputId = useId(), handleChange = useCallback((nextItem) => {
    onChange(PatchEvent.from(typeof nextItem?.value > "u" ? unset() : set(nextItem.value)));
  }, [onChange]), handleSelectChange = useCallback((event) => {
    const nextItem_0 = itemFromOptionValue(event.currentTarget.value);
    if (!nextItem_0) {
      handleChange(EMPTY_ITEM);
      return;
    }
    handleChange(nextItem_0);
  }, [handleChange, itemFromOptionValue]), content = isRadio ? /* @__PURE__ */ jsx(RadioSelect, { ...elementProps, value: currentItem, inputId, items, direction: schemaType.options?.direction || "vertical", customValidity: validationError, onChange: handleChange, readOnly }) : /* @__PURE__ */ jsx(Select, { ...elementProps, customValidity: validationError, value: optionValueFromItem(currentItem), readOnly, onChange: handleSelectChange, children: [EMPTY_ITEM, ...items].map((item_1, i) => /* @__PURE__ */ jsx("option", { value: i - 1, children: item_1.title }, `${i - 1}`)) });
  return /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: content });
}
const RadioSelect = forwardRef(function(props2, ref) {
  const $ = c(12), {
    items,
    value,
    onChange,
    onFocus,
    readOnly,
    customValidity,
    direction,
    inputId
  } = props2, Layout2 = direction === "horizontal" ? Inline : Stack;
  let t0;
  $[0] !== customValidity || $[1] !== inputId || $[2] !== items || $[3] !== onChange || $[4] !== onFocus || $[5] !== readOnly || $[6] !== ref || $[7] !== value ? (t0 = items.map((item, index) => /* @__PURE__ */ jsx(RadioSelectItem, { customValidity, inputId, item, onChange, onFocus, readOnly, ref: index === 0 ? ref : null, value }, index)), $[0] = customValidity, $[1] = inputId, $[2] = items, $[3] = onChange, $[4] = onFocus, $[5] = readOnly, $[6] = ref, $[7] = value, $[8] = t0) : t0 = $[8];
  let t1;
  return $[9] !== Layout2 || $[10] !== t0 ? (t1 = /* @__PURE__ */ jsx(Card, { border: !0, padding: 3, radius: 2, children: /* @__PURE__ */ jsx(Layout2, { space: 3, role: "group", children: t0 }) }), $[9] = Layout2, $[10] = t0, $[11] = t1) : t1 = $[11], t1;
}), RadioSelectItem = forwardRef(function(props2, ref) {
  const $ = c(16), {
    customValidity,
    inputId,
    item,
    onChange,
    onFocus,
    readOnly,
    value
  } = props2;
  let t0;
  $[0] !== item || $[1] !== onChange ? (t0 = () => {
    onChange(item);
  }, $[0] = item, $[1] = onChange, $[2] = t0) : t0 = $[2];
  const handleChange = t0, t1 = value === item;
  let t2;
  $[3] !== customValidity || $[4] !== handleChange || $[5] !== inputId || $[6] !== onFocus || $[7] !== readOnly || $[8] !== ref || $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(Radio, { ref, checked: t1, onChange: handleChange, onFocus, readOnly, customValidity, name: inputId }), $[3] = customValidity, $[4] = handleChange, $[5] = inputId, $[6] = onFocus, $[7] = readOnly, $[8] = ref, $[9] = t1, $[10] = t2) : t2 = $[10];
  let t3;
  $[11] !== item.title ? (t3 = /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: item.title }) }), $[11] = item.title, $[12] = t3) : t3 = $[12];
  let t4;
  return $[13] !== t2 || $[14] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { as: "label", align: "center", children: [
    t2,
    t3
  ] }), $[13] = t2, $[14] = t3, $[15] = t4) : t4 = $[15], t4;
});
function resolveNumberInput(type) {
  return getOption(type, "list") ? SelectInput : NumberInput;
}
function resolveStringInput(type) {
  return getOption(type, "list") ? SelectInput : StringInput;
}
function resolveComponentFromTypeVariants(type) {
  if (is$1("array", type))
    return resolveArrayInput(type);
  if (is$1("reference", type))
    return StudioReferenceInput;
  if (is$1("string", type))
    return resolveStringInput(type);
  if (is$1("number", type))
    return resolveNumberInput(type);
}
function defaultResolveInputComponent(schemaType) {
  if (schemaType.components?.input) return schemaType.components.input;
  const componentFromTypeVariants = resolveComponentFromTypeVariants(schemaType);
  if (componentFromTypeVariants)
    return componentFromTypeVariants;
  const deduped = getTypeChain(schemaType, /* @__PURE__ */ new Set()).reduce((acc, type) => (acc[type.name] = type, acc), {}), subType = Object.values(deduped).find((t) => defaultInputs[t.name]);
  if (subType)
    return defaultInputs[subType.name];
  throw new Error(`Could not find input component for schema type \`${schemaType.name}\``);
}
function defaultResolvePreviewComponent(schemaType) {
  return schemaType.components?.preview ? schemaType.components.preview : SanityDefaultPreview;
}
function getTone$1({
  readOnly,
  hasErrors,
  hasWarnings
}) {
  return readOnly ? "transparent" : hasErrors ? "critical" : hasWarnings ? "caution" : "default";
}
const MENU_POPOVER_PROPS$1 = {
  portal: !0,
  tone: "default"
}, BUTTON_CARD_STYLE = {
  position: "relative"
}, EMPTY_ARRAY$h = [];
function PreviewItem(props2) {
  const {
    schemaType,
    parentSchemaType,
    path,
    readOnly,
    onRemove,
    value,
    open,
    onInsert,
    onCopy,
    onFocus,
    onOpen,
    onClose,
    changed,
    focused,
    children,
    inputProps: {
      renderPreview
    }
  } = props2, {
    t
  } = useTranslation(), treeEditing = useTreeEditingEnabled(), treeEditingDisabledByOption = parentSchemaType?.options?.treeEditing === !1, legacyEditing = treeEditingDisabledByOption || treeEditing.legacyEditing, openPortal = open && (!treeEditing.enabled || legacyEditing), sortable = parentSchemaType.options?.sortable !== !1, insertableTypes = parentSchemaType.of, [previewCardElement, setPreviewCardElement] = useState(null), previewCardRef = useRef(null);
  useImperativeHandle(previewCardRef, () => previewCardElement, [previewCardElement]), useScrollIntoViewOnFocusWithin(previewCardRef, open), useDidUpdate(focused, (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && previewCardRef.current && previewCardRef.current?.focus();
  });
  const resolvingInitialValue = value._resolvingInitialValue, handleDuplicate = useCallback(() => {
    onInsert({
      items: [{
        ...value,
        _key: randomKey()
      }],
      position: "after"
    });
  }, [onInsert, value]), handleCopy = useCallback(() => {
    onCopy({
      items: [{
        ...value,
        _key: randomKey()
      }]
    });
  }, [onCopy, value]), handleInsert = useCallback((pos, insertType) => {
    onInsert({
      items: [createProtoArrayValue(insertType)],
      position: pos
    });
  }, [onInsert]), childPresence = useChildPresence(path, !0), presence = useMemo(() => childPresence.length === 0 ? null : /* @__PURE__ */ jsx(FieldPresence, { presence: childPresence, maxAvatars: 1 }), [childPresence]), childValidation = useChildValidation(path, !0), validation2 = useMemo(() => childValidation.length === 0 ? null : /* @__PURE__ */ jsx(Box, { paddingX: 1, paddingY: 3, children: /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: childValidation, __unstable_showSummary: !0 }) }), [childValidation]), hasErrors = childValidation.some((v) => v.level === "error"), hasWarnings = childValidation.some((v_0) => v_0.level === "warning"), [contextMenuButtonElement, setContextMenuButtonElement] = useState(null), {
    insertBefore,
    insertAfter: insertAfter2
  } = useInsertMenuMenuItems({
    schemaTypes: insertableTypes,
    insertMenuOptions: parentSchemaType.options?.insertMenu,
    onInsert: handleInsert,
    referenceElement: contextMenuButtonElement
  }), disableActions = parentSchemaType.options?.disableActions || EMPTY_ARRAY$h, menuItems = useMemo(() => [!disableActions.includes("remove") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.remove"), tone: "critical", icon: TrashIcon, onClick: onRemove }, "remove"), !disableActions.includes("copy") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.copy"), icon: CopyIcon, onClick: handleCopy }, "copy"), !disableActions.includes("duplicate") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.array.action.duplicate"), icon: AddDocumentIcon, onClick: handleDuplicate }, "duplicate"), !disableActions.includes("add") && !disableActions.includes("addBefore") && insertBefore.menuItem, !disableActions.includes("add") && !disableActions.includes("addAfter") && insertAfter2.menuItem].filter(Boolean), [disableActions, handleCopy, handleDuplicate, insertAfter2.menuItem, insertBefore.menuItem, onRemove, t]), menu = useMemo(() => readOnly || menuItems.length === 0 ? null : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MenuButton$1, { ref: setContextMenuButtonElement, onOpen: () => {
      insertBefore.send({
        type: "close"
      }), insertAfter2.send({
        type: "close"
      });
    }, button: /* @__PURE__ */ jsx(ContextMenuButton, { "data-testid": "array-item-menu-button", selected: insertBefore.state.open || insertAfter2.state.open ? !0 : void 0 }), id: `${props2.inputId}-menuButton`, menu: /* @__PURE__ */ jsx(Menu, { children: menuItems }), popover: MENU_POPOVER_PROPS$1 }),
    insertBefore.popover,
    insertAfter2.popover
  ] }), [menuItems, readOnly, insertBefore, insertAfter2, props2.inputId]), tone = getTone$1({
    readOnly,
    hasErrors,
    hasWarnings
  }), item = /* @__PURE__ */ jsx(RowLayout, { menu, presence, validation: validation2, tone, focused, dragHandle: sortable, selected: open, readOnly: !!readOnly, children: /* @__PURE__ */ jsxs(Card, { as: "button", type: "button", tone: "inherit", radius: 1, disabled: resolvingInitialValue, onClick: onOpen, ref: setPreviewCardElement, onFocus, __unstable_focusRing: !0, style: BUTTON_CARD_STYLE, children: [
    renderPreview({
      schemaType: props2.schemaType,
      value: props2.value,
      layout: "default",
      // Don't do visibility check for virtualized items as the calculation will be incorrect causing it to scroll
      skipVisibilityCheck: !0
    }),
    resolvingInitialValue && /* @__PURE__ */ jsx(LoadingBlock, { fill: !0 })
  ] }) }), itemTypeTitle = getSchemaTypeTitle(schemaType);
  return /* @__PURE__ */ jsxs(TreeEditingEnabledProvider, { legacyEditing: treeEditingDisabledByOption, children: [
    /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsx(Box, { paddingX: 1, children: item }) }),
    openPortal && /* @__PURE__ */ jsx(EditPortal, { header: readOnly ? t("inputs.array.action.view", {
      itemTypeTitle
    }) : t("inputs.array.action.edit", {
      itemTypeTitle
    }), type: parentSchemaType?.options?.modal?.type || "dialog", width: parentSchemaType?.options?.modal?.width ?? 1, id: value._key, onClose, autofocus: focused, legacy_referenceElement: previewCardElement, children })
  ] });
}
function ReferenceItemRefProvider(props2) {
  const $ = c(7), {
    menuRef,
    menuButtonRef,
    containerRef
  } = props2;
  let t0, t1;
  $[0] !== containerRef || $[1] !== menuButtonRef || $[2] !== menuRef ? (t1 = {
    menuRef,
    menuButtonRef,
    containerRef
  }, $[0] = containerRef, $[1] = menuButtonRef, $[2] = menuRef, $[3] = t1) : t1 = $[3], t0 = t1;
  const value = t0;
  let t2;
  return $[4] !== props2.children || $[5] !== value ? (t2 = /* @__PURE__ */ jsx(ReferenceItemRefContext.Provider, { value, children: props2.children }), $[4] = props2.children, $[5] = value, $[6] = t2) : t2 = $[6], t2;
}
function getTone({
  readOnly,
  hasErrors,
  hasWarnings
}) {
  return readOnly ? "transparent" : hasErrors ? "critical" : hasWarnings ? "caution" : "default";
}
const MENU_POPOVER_PROPS = {
  portal: !0,
  tone: "default"
};
function ReferenceItem(props2) {
  const {
    schemaType,
    parentSchemaType,
    path,
    readOnly,
    onRemove,
    value,
    open,
    onInsert,
    onCopy,
    presence,
    validation: validation2,
    inputId,
    changed,
    focused,
    children,
    inputProps: {
      onChange,
      focusPath,
      onPathFocus,
      renderPreview,
      elementProps
    }
  } = props2, sortable = parentSchemaType.options?.sortable !== !1, insertableTypes = parentSchemaType.of, elementRef = useRef(null), menuRef = useRef(null), menuButtonRef = useRef(null), containerRef = useRef(null), {
    EditReferenceLink,
    getReferenceInfo: getReferenceInfo2,
    selectedState,
    isCurrentDocumentLiveEdit
  } = useReferenceInput({
    path,
    schemaType,
    value
  });
  useScrollIntoViewOnFocusWithin(elementRef, open), useDidUpdate(focused, (hadFocus, hasFocus) => {
    !hadFocus && hasFocus && elementRef.current && elementRef.current?.focus();
  });
  const hasErrors = props2.validation.some((v) => v.level === "error"), hasWarnings = props2.validation.some((v_0) => v_0.level === "warning"), resolvingInitialValue = value._resolvingInitialValue, handleDuplicate = useCallback(() => {
    onInsert({
      items: [{
        ...value,
        _key: randomKey()
      }],
      position: "after"
    });
  }, [onInsert, value]), handleCopy = useCallback(() => {
    onCopy({
      items: [{
        ...value,
        _key: randomKey()
      }]
    });
  }, [onCopy, value]), handleInsert = useCallback((pos, insertType) => {
    onInsert({
      items: [{
        ...createProtoArrayValue(insertType),
        _key: randomKey()
      }],
      position: pos
    });
  }, [onInsert]), loadableReferenceInfo = useReferenceInfo$2(value?._ref, getReferenceInfo2), hasRef = value._ref, refTypeName = loadableReferenceInfo.result?.type || value?._strengthenOnPublish?.type, publishedReferenceExists = hasRef && loadableReferenceInfo.result?.isPublished, handleRemoveStrengthenOnPublish = useCallback(() => {
    onChange([schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]), unset(["_strengthenOnPublish"])]);
  }, [onChange, schemaType.weak]), refType = refTypeName ? schemaType.to.find((toType) => toType.name === refTypeName) : void 0, pressed = selectedState === "pressed", selected = selectedState === "selected", tone = getTone({
    readOnly,
    hasErrors,
    hasWarnings
  }), isEditing = !hasRef || focusPath[0] === "_ref", {
    t
  } = useTranslation(), OpenLink = useMemo(() => (
    // eslint-disable-next-line @typescript-eslint/no-shadow
    forwardRef(function(restProps, _ref) {
      return /* @__PURE__ */ jsx(IntentLink, { ...restProps, intent: "edit", params: {
        id: value?._ref,
        type: refType?.name
      }, target: "_blank", rel: "noopener noreferrer", ref: _ref });
    })
  ), [refType?.name, value?._ref]), handleReplace = useCallback(() => {
    onPathFocus(hasRef && isEditing ? [] : ["_ref"]);
  }, [hasRef, isEditing, onPathFocus]), [contextMenuButtonElement, setContextMenuButtonElement] = useState(null), setMenuButtonRef = useCallback((element) => {
    setContextMenuButtonElement(element), menuButtonRef.current = element;
  }, []), {
    insertBefore,
    insertAfter: insertAfter2
  } = useInsertMenuMenuItems({
    schemaTypes: insertableTypes,
    insertMenuOptions: parentSchemaType.options?.insertMenu,
    onInsert: handleInsert,
    referenceElement: contextMenuButtonElement
  }), disableActions = parentSchemaType.options?.disableActions || EMPTY_ARRAY$A, menu = useMemo(() => readOnly ? null : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MenuButton$1, { ref: setMenuButtonRef, onOpen: () => {
      insertBefore.send({
        type: "close"
      }), insertAfter2.send({
        type: "close"
      });
    }, button: /* @__PURE__ */ jsx(ContextMenuButton, { selected: insertBefore.state.open || insertAfter2.state.open ? !0 : void 0, tooltipProps: {
      fallbackPlacements: ["top", "bottom"],
      placement: "right"
    } }), id: `${inputId}-menuButton`, menu: /* @__PURE__ */ jsxs(Menu, { ref: menuRef, children: [
      !readOnly && /* @__PURE__ */ jsxs(Fragment, { children: [
        !disableActions.includes("remove") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.remove"), tone: "critical", icon: TrashIcon, onClick: onRemove }),
        /* @__PURE__ */ jsx(MenuItem$1, { text: t(hasRef && isEditing ? "inputs.reference.action.replace-cancel" : "inputs.reference.action.replace"), icon: hasRef && isEditing ? CloseIcon : SyncIcon, onClick: handleReplace }),
        !disableActions.includes("copy") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.copy"), icon: CopyIcon, onClick: handleCopy }),
        !disableActions.includes("duplicate") && /* @__PURE__ */ jsx(MenuItem$1, { text: t("inputs.reference.action.duplicate"), icon: AddDocumentIcon, onClick: handleDuplicate }),
        !(disableActions.includes("add") || disableActions.includes("addBefore")) && insertBefore.menuItem,
        !disableActions.includes("add") && !disableActions.includes("addAfter") && insertAfter2.menuItem
      ] }),
      !readOnly && !isEditing && hasRef && /* @__PURE__ */ jsx(MenuDivider, {}),
      !isEditing && hasRef && /* @__PURE__ */ jsx(MenuItem$1, { as: OpenLink, "data-as": "a", text: t("inputs.reference.action.open-in-new-tab"), icon: LaunchIcon })
    ] }), popover: MENU_POPOVER_PROPS }),
    insertBefore.popover,
    insertAfter2.popover
  ] }), [OpenLink, disableActions, handleCopy, handleDuplicate, handleReplace, hasRef, inputId, insertAfter2, insertBefore, isEditing, onRemove, readOnly, setMenuButtonRef, t]), handleFixStrengthMismatch = useCallback(() => {
    onChange(schemaType.weak === !0 ? set(!0, ["_weak"]) : unset(["_weak"]));
  }, [onChange, schemaType]), actualStrength = value?._weak ? "weak" : "strong", weakShouldBe = schemaType.weak === !0 ? "weak" : "strong", weakWarningOverride = hasRef && !loadableReferenceInfo.isLoading && value?._strengthenOnPublish, showWeakRefMismatch = !loadableReferenceInfo.isLoading && loadableReferenceInfo.result?.availability.available && hasRef && actualStrength !== weakShouldBe && !weakWarningOverride, issues = /* @__PURE__ */ jsxs(Fragment, { children: [
    isCurrentDocumentLiveEdit && publishedReferenceExists && value._strengthenOnPublish && /* @__PURE__ */ jsx(ReferenceFinalizeAlertStrip, { schemaType, handleRemoveStrengthenOnPublish }),
    showWeakRefMismatch && /* @__PURE__ */ jsx(ReferenceStrengthMismatchAlertStrip, { actualStrength, handleFixStrengthMismatch }),
    loadableReferenceInfo.error && /* @__PURE__ */ jsx(ReferenceMetadataLoadErrorAlertStrip, { errorMessage: loadableReferenceInfo.error.message, onHandleRetry: loadableReferenceInfo.retry })
  ] }), item = /* @__PURE__ */ jsx(ReferenceItemRefProvider, { menuRef, menuButtonRef, containerRef, children: /* @__PURE__ */ jsx(RowLayout, { dragHandle: sortable, readOnly: !!readOnly, presence: !isEditing && presence.length > 0 && /* @__PURE__ */ jsx(FieldPresence, { presence, maxAvatars: 1 }), validation: !isEditing && validation2.length > 0 && /* @__PURE__ */ jsx(FormFieldValidationStatus, { validation: validation2 }), menu, footer: isEditing ? void 0 : issues, tone: isEditing ? void 0 : tone, focused, children: isEditing ? /* @__PURE__ */ jsx(Box, { padding: 1, ref: containerRef, children: /* @__PURE__ */ jsx(FormFieldSet, { title: schemaType.title, description: schemaType.description, __unstable_presence: presence, validation: validation2, inputId, deprecated: schemaType.deprecated, children }) }) : /* @__PURE__ */ jsxs(ReferenceLinkCard, { as: EditReferenceLink, tone: "inherit", radius: 2, documentId: value?._ref, documentType: refType?.name, disabled: resolvingInitialValue, __unstable_focusRing: !0, selected, pressed, "data-selected": selected ? !0 : void 0, "data-pressed": pressed ? !0 : void 0, ...elementProps, children: [
    /* @__PURE__ */ jsx(PreviewReferenceValue$2, { value, referenceInfo: loadableReferenceInfo, renderPreview, type: schemaType }),
    resolvingInitialValue && /* @__PURE__ */ jsx(LoadingBlock, { fill: !0 })
  ] }) }) });
  return /* @__PURE__ */ jsx(ChangeIndicator, { path, isChanged: changed, hasFocus: !!focused, children: /* @__PURE__ */ jsx(Box, { paddingX: 1, children: item }) });
}
function defaultResolveItemComponent(schemaType) {
  return schemaType.components?.item ? schemaType.components.item : isReferenceSchemaType(schemaType) ? ReferenceItem : PreviewItem;
}
const defaultRenderAnnotation = (props2) => {
  const Annotation2 = defaultResolveAnnotationComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Annotation2, { ...props2 });
}, defaultRenderBlock = (props2) => {
  const Block2 = defaultResolveBlockComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Block2, { ...props2 });
}, defaultRenderInlineBlock = (props2) => {
  const InlineBlock = defaultResolveInlineBlockComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(InlineBlock, { ...props2 });
}, defaultRenderField = (props2) => {
  const Field = defaultResolveFieldComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Field, { ...props2 });
}, defaultRenderInput = (props2) => {
  const Input2 = defaultResolveInputComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Input2, { ...props2 });
}, defaultRenderItem = (props2) => {
  const Item2 = defaultResolveItemComponent(props2.schemaType);
  return /* @__PURE__ */ jsx(Item2, { ...props2 });
}, defaultRenderPreview = (props2) => /* @__PURE__ */ jsx(Preview$1, { ...props2 });
function FormBuilderInputErrorBoundary(props2) {
  const $ = c(7), {
    children
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    error: null,
    info: {}
  }, $[0] = t0) : t0 = $[0];
  const [t1, setError] = useState(t0), {
    error,
    info
  } = t1;
  let t2;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setError({
    error: null,
    info: {}
  }), $[1] = t2) : t2 = $[1];
  const handleRetry = t2;
  if (!error) {
    let t32;
    return $[2] !== children ? (t32 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: setError, children }), $[2] = children, $[3] = t32) : t32 = $[3], t32;
  }
  let t3;
  return $[4] !== error || $[5] !== info ? (t3 = /* @__PURE__ */ jsx(ErrorCard, { error, info, onRetry: handleRetry }), $[4] = error, $[5] = info, $[6] = t3) : t3 = $[6], t3;
}
function ErrorCard(props2) {
  const {
    error,
    info,
    onRetry: onRetry2
  } = props2;
  if (error instanceof CorsOriginError || error instanceof SchemaError)
    throw error;
  const {
    t
  } = useTranslation(), message = useMemo(() => isRecord$4(error) && typeof error.message == "string" && error.message, [error]), callStack = useMemo(() => isRecord$4(error) && typeof error.stack == "string" && error.stack, [error]), componentStack = useMemo(() => typeof info?.componentStack == "string" && info.componentStack, [info?.componentStack]);
  return useHotModuleReload(onRetry2), /* @__PURE__ */ jsx(Alert, { status: "error", title: /* @__PURE__ */ jsx(Fragment, { children: t("form.error.unhandled-runtime-error.title") }), children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Fragment, { children: t("form.error.unhandled-runtime-error.error-message", {
      message
    }) }) }),
    callStack && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: /* @__PURE__ */ jsx(Fragment, { children: t("form.error.unhandled-runtime-error.call-stack.title") }) }),
      /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "inherit", children: callStack && /* @__PURE__ */ jsx(Code, { size: 1, style: {
        maxHeight: "40vh"
      }, children: callStack }) })
    ] }) }, "call-stack"),
    isDev && componentStack && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: /* @__PURE__ */ jsx(Fragment, { children: t("form.error.unhandled-runtime-error.component-stack.title") }) }),
      /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "inherit", children: componentStack && /* @__PURE__ */ jsx(Code, { size: 1, style: {
        maxHeight: "40vh"
      }, children: componentStack }) })
    ] }) }, "component-stack")
  ] }) });
}
const orientationChange$ = typeof window > "u" ? EMPTY$6 : fromEvent(window, "orientationchange").pipe(shareReplay(1)), resize$ = typeof window > "u" ? EMPTY$6 : fromEvent(window, "resize").pipe(shareReplay(1)), scroll$ = typeof window > "u" ? EMPTY$6 : fromEvent(window, "scroll", {
  passive: !0,
  capture: !0
}).pipe(shareReplay(1)), ROOT_MARGIN_PX = 150;
function isIntersectionObserverSupported() {
  return typeof window < "u" && "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in IntersectionObserverEntry.prototype ? ("isIntersecting" in IntersectionObserverEntry.prototype || Object.defineProperty(IntersectionObserverEntry.prototype, "isIntersecting", {
    get() {
      return this.intersectionRatio > 0;
    }
  }), !0) : !1;
}
const intersectionObservableFor = isIntersectionObserverSupported() ? createIntersectionObserverBased() : createLegacyBased();
function createIntersectionObserverBased() {
  const intersectionObserverEntriesSubject = new Subject(), intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      intersectionObserverEntriesSubject.next(entry);
    });
  }, {
    threshold: 0,
    rootMargin: `${ROOT_MARGIN_PX}px`
  });
  return function(element) {
    return new Observable((observer) => (intersectionObserver.observe(element), observer.next(), () => intersectionObserver.unobserve(element))).pipe(mergeMap(() => intersectionObserverEntriesSubject.asObservable()), filter((entry) => entry.target === element), map((ev) => ({
      isIntersecting: ev.isIntersecting
    })));
  };
}
function createLegacyBased() {
  function getViewport() {
    return {
      left: 0,
      right: window.innerWidth,
      top: 0,
      bottom: window.innerHeight
    };
  }
  function intersects(rect, viewport, margin) {
    return rect.left <= viewport.right + margin && rect.right >= viewport.left - margin && rect.top <= viewport.bottom + margin && rect.bottom >= viewport.top - margin;
  }
  function inViewport(element) {
    return () => intersects(element.getBoundingClientRect(), getViewport(), ROOT_MARGIN_PX);
  }
  return function(element) {
    const isElementInViewport = inViewport(element);
    return merge(of(isElementInViewport()), resize$, scroll$, orientationChange$).pipe(
      // @todo: consider "faking" more of the IntersectionObserverEntry api if possible
      map(isElementInViewport),
      map((isIntersecting) => ({
        isIntersecting
      }))
    );
  };
}
const visibilityChange$ = typeof window > "u" ? EMPTY$6 : fromEvent(document, "visibilitychange").pipe(shareReplay(1));
function useVisibility(props2) {
  const $ = c(5), {
    element,
    hideDelay: t0,
    disabled
  } = props2, hideDelay = t0 === void 0 ? 0 : t0, [visible, setVisible] = useState(!1);
  let t1, t2;
  return $[0] !== disabled || $[1] !== element || $[2] !== hideDelay ? (t1 = () => {
    if (!element || disabled)
      return;
    element && "checkVisibility" in element && setVisible(element.checkVisibility());
    const isDocumentVisible$ = concat(of(!document.hidden), visibilityChange$.pipe(map(_temp$1e))).pipe(distinctUntilChanged()), inViewport$ = intersectionObservableFor(element).pipe(map(_temp2$m)), sub2 = isDocumentVisible$.pipe(switchMap((isDocumentVisible) => isDocumentVisible ? inViewport$ : of(!1)), switchMap((isVisible2) => isVisible2 ? of(!0) : of(!1).pipe(delay(hideDelay))), distinctUntilChanged()).subscribe(setVisible);
    return () => sub2.unsubscribe();
  }, t2 = [element, hideDelay, disabled], $[0] = disabled, $[1] = element, $[2] = hideDelay, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useLayoutEffect(t1, t2), disabled ? !1 : visible;
}
function _temp2$m(event_0) {
  return event_0.isIntersecting;
}
function _temp$1e(event) {
  return event.target instanceof Document ? !event?.target?.hidden : !1;
}
const _HIDE_DELAY = 2e3;
function _extractUploadState(value) {
  return _resolveUploadValue(value?._upload);
}
function getStringOrUndefined(value) {
  return isString(value) ? value : void 0;
}
function _resolveUploadValue(value) {
  if (!isRecord$4(value)) return;
  const progress = typeof value.progress == "number" ? value.progress : 0, createdAt = getStringOrUndefined(value.initiated || value.createdAt), updatedAt = getStringOrUndefined(value.updated || value.updatedAt), fileName = getStringOrUndefined(value?.file?.name), fileType = getStringOrUndefined(value?.file?.type), previewImage = getStringOrUndefined(value.previewImage);
  if (createdAt && updatedAt && fileName && fileType)
    return {
      progress,
      createdAt,
      updatedAt,
      file: {
        name: fileName,
        type: fileType
      },
      previewImage
    };
}
function PreviewLoader(props2) {
  const $ = c(37);
  let Component2, layout, restProps, schemaType, skipVisibilityCheck, styleProp, value;
  $[0] !== props2 ? ({
    layout,
    value,
    component: Component2,
    style: styleProp,
    schemaType,
    skipVisibilityCheck,
    ...restProps
  } = props2, $[0] = props2, $[1] = Component2, $[2] = layout, $[3] = restProps, $[4] = schemaType, $[5] = skipVisibilityCheck, $[6] = styleProp, $[7] = value) : (Component2 = $[1], layout = $[2], restProps = $[3], schemaType = $[4], skipVisibilityCheck = $[5], styleProp = $[6], value = $[7]);
  const {
    t
  } = useTranslation(), [element, setElement] = useState(null), isVisible2 = useVisibility({
    disabled: skipVisibilityCheck,
    element,
    hideDelay: _HIDE_DELAY
  }) || skipVisibilityCheck, t0 = skipVisibilityCheck || isVisible2;
  let t1;
  $[8] !== schemaType || $[9] !== t0 || $[10] !== value ? (t1 = {
    enabled: t0,
    schemaType,
    value
  }, $[8] = schemaType, $[9] = t0, $[10] = value, $[11] = t1) : t1 = $[11];
  const preview = useDocumentPreview(t1);
  let t2;
  const t3 = styleProp?.minWidth || 1, t4 = styleProp?.minHeight || 1;
  let t5;
  $[12] !== styleProp || $[13] !== t3 || $[14] !== t4 ? (t5 = {
    ...styleProp,
    minWidth: t3,
    minHeight: t4
  }, $[12] = styleProp, $[13] = t3, $[14] = t4, $[15] = t5) : t5 = $[15], t2 = t5;
  const style = t2;
  let t6, t7;
  $[16] !== value ? (t7 = _extractUploadState(value), $[16] = value, $[17] = t7) : t7 = $[17], t6 = t7;
  const uploadState = t6;
  let t8;
  bb0: {
    if (uploadState?.previewImage) {
      let t92;
      $[18] !== t ? (t92 = t("preview.image.file-is-being-uploaded.alt-text"), $[18] = t, $[19] = t92) : t92 = $[19];
      let t102;
      $[20] !== t92 || $[21] !== uploadState.previewImage ? (t102 = /* @__PURE__ */ jsx("img", { alt: t92, src: uploadState.previewImage }), $[20] = t92, $[21] = uploadState.previewImage, $[22] = t102) : t102 = $[22], t8 = t102;
      break bb0;
    }
    if (!preview?.value?.media) {
      t8 = schemaType.icon;
      break bb0;
    }
    t8 = preview?.value?.media;
  }
  const media = t8;
  let t9;
  $[23] !== preview?.value ? (t9 = preview?.value || {}, $[23] = preview?.value, $[24] = t9) : t9 = $[24];
  const t10 = preview?.error, t11 = preview?.isLoading;
  let t12;
  $[25] !== Component2 || $[26] !== layout || $[27] !== media || $[28] !== restProps || $[29] !== schemaType || $[30] !== t10 || $[31] !== t11 || $[32] !== t9 ? (t12 = /* @__PURE__ */ jsx(Component2, { ...restProps, ...t9, media, error: t10, isPlaceholder: t11, layout, schemaType }), $[25] = Component2, $[26] = layout, $[27] = media, $[28] = restProps, $[29] = schemaType, $[30] = t10, $[31] = t11, $[32] = t9, $[33] = t12) : t12 = $[33];
  let t13;
  return $[34] !== style || $[35] !== t12 ? (t13 = /* @__PURE__ */ jsx("div", { ref: setElement, style, children: t12 }), $[34] = style, $[35] = t12, $[36] = t13) : t13 = $[36], t13;
}
function DefaultCustomMarkers() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    "This is a example custom marker, please implement ",
    /* @__PURE__ */ jsx("code", { children: "renderCustomMarkers" }),
    " function."
  ] }), $[0] = t0) : t0 = $[0], t0;
}
const missingPatchChannel = {
  publish: () => {
  },
  subscribe: () => (console.warn("No patch channel provided to form-builder. If you need input based patch updates, please provide one"), () => {
  })
};
function FormBuilderProvider(props2) {
  const $ = c(61), {
    __internal_fieldActions: t0,
    __internal_patchChannel: t1,
    autoFocus,
    changesOpen,
    children,
    collapsedFieldSets,
    collapsedPaths,
    file,
    filterField,
    focusPath,
    focused,
    groups,
    id: id2,
    image,
    onChange,
    onFieldGroupSelect,
    onPathBlur,
    onPathFocus,
    onPathOpen,
    onSetFieldSetCollapsed,
    onSetPathCollapsed,
    presence,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    unstable,
    validation: validation2
  } = props2, fieldActions = t0 === void 0 ? EMPTY_ARRAY$A : t0, patchChannel = t1 === void 0 ? missingPatchChannel : t1;
  let t2;
  const t3 = unstable?.CustomMarkers || DefaultCustomMarkers, t4 = unstable?.Markers || DefaultMarkers;
  let t5;
  $[0] !== t3 || $[1] !== t4 ? (t5 = {
    ArrayFunctions: ArrayOfObjectsFunctions,
    CustomMarkers: t3,
    Markers: t4
  }, $[0] = t3, $[1] = t4, $[2] = t5) : t5 = $[2];
  let t6;
  $[3] !== fieldActions ? (t6 = {
    actions: fieldActions
  }, $[3] = fieldActions, $[4] = t6) : t6 = $[4];
  const t7 = file?.directUploads !== !1;
  let t8;
  $[5] !== file.assetSources || $[6] !== t7 ? (t8 = {
    assetSources: file.assetSources,
    directUploads: t7
  }, $[5] = file.assetSources, $[6] = t7, $[7] = t8) : t8 = $[7];
  const t9 = filterField || _temp$1d, t10 = image?.directUploads !== !1;
  let t11;
  $[8] !== image.assetSources || $[9] !== t10 ? (t11 = {
    assetSources: image.assetSources,
    directUploads: t10
  }, $[8] = image.assetSources, $[9] = t10, $[10] = t11) : t11 = $[10];
  let t12;
  $[11] !== onChange || $[12] !== patchChannel || $[13] !== t11 || $[14] !== t5 || $[15] !== t6 || $[16] !== t8 || $[17] !== t9 ? (t12 = {
    patchChannel,
    components: t5,
    field: t6,
    file: t8,
    filterField: t9,
    image: t11,
    onChange
  }, $[11] = onChange, $[12] = patchChannel, $[13] = t11, $[14] = t5, $[15] = t6, $[16] = t8, $[17] = t9, $[18] = t12) : t12 = $[18], t2 = t12;
  const __internal = t2;
  let t13, t14;
  $[19] !== __internal || $[20] !== autoFocus || $[21] !== changesOpen || $[22] !== collapsedFieldSets || $[23] !== collapsedPaths || $[24] !== focusPath || $[25] !== focused || $[26] !== groups || $[27] !== id2 || $[28] !== readOnly || $[29] !== renderAnnotation || $[30] !== renderBlock2 || $[31] !== renderField || $[32] !== renderInlineBlock || $[33] !== renderInput || $[34] !== renderItem2 || $[35] !== renderPreview || $[36] !== schemaType ? (t14 = {
    __internal,
    autoFocus,
    changesOpen,
    collapsedFieldSets,
    collapsedPaths,
    focusPath,
    focused,
    groups,
    id: id2,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType
  }, $[19] = __internal, $[20] = autoFocus, $[21] = changesOpen, $[22] = collapsedFieldSets, $[23] = collapsedPaths, $[24] = focusPath, $[25] = focused, $[26] = groups, $[27] = id2, $[28] = readOnly, $[29] = renderAnnotation, $[30] = renderBlock2, $[31] = renderField, $[32] = renderInlineBlock, $[33] = renderInput, $[34] = renderItem2, $[35] = renderPreview, $[36] = schemaType, $[37] = t14) : t14 = $[37], t13 = t14;
  const formBuilder = t13;
  let t15;
  $[38] !== children ? (t15 = /* @__PURE__ */ jsx(HoveredFieldProvider, { children }), $[38] = children, $[39] = t15) : t15 = $[39];
  let t16;
  $[40] !== t15 || $[41] !== validation2 ? (t16 = /* @__PURE__ */ jsx(ValidationProvider, { validation: validation2, children: t15 }), $[40] = t15, $[41] = validation2, $[42] = t16) : t16 = $[42];
  let t17;
  $[43] !== presence || $[44] !== t16 ? (t17 = /* @__PURE__ */ jsx(PresenceProvider, { presence, children: t16 }), $[43] = presence, $[44] = t16, $[45] = t17) : t17 = $[45];
  let t18;
  $[46] !== id2 || $[47] !== t17 ? (t18 = /* @__PURE__ */ jsx(DocumentIdProvider, { id: id2, children: t17 }), $[46] = id2, $[47] = t17, $[48] = t18) : t18 = $[48];
  let t19;
  $[49] !== onChange || $[50] !== onFieldGroupSelect || $[51] !== onPathBlur || $[52] !== onPathFocus || $[53] !== onPathOpen || $[54] !== onSetFieldSetCollapsed || $[55] !== onSetPathCollapsed || $[56] !== t18 ? (t19 = /* @__PURE__ */ jsx(FormCallbacksProvider, { onChange, onFieldGroupSelect, onPathBlur, onPathFocus, onPathOpen, onSetPathCollapsed, onSetFieldSetCollapsed, children: t18 }), $[49] = onChange, $[50] = onFieldGroupSelect, $[51] = onPathBlur, $[52] = onPathFocus, $[53] = onPathOpen, $[54] = onSetFieldSetCollapsed, $[55] = onSetPathCollapsed, $[56] = t18, $[57] = t19) : t19 = $[57];
  let t20;
  return $[58] !== formBuilder || $[59] !== t19 ? (t20 = /* @__PURE__ */ jsx(FormBuilderContext.Provider, { value: formBuilder, children: t19 }), $[58] = formBuilder, $[59] = t19, $[60] = t20) : t20 = $[60], t20;
}
function _temp$1d() {
  return !0;
}
function FormProvider(props2) {
  const $ = c(46), {
    __internal_fieldActions: fieldActions,
    __internal_patchChannel: patchChannel,
    autoFocus,
    changesOpen,
    children,
    collapsedFieldSets,
    collapsedPaths,
    focusPath,
    focused,
    groups,
    id: id2,
    onChange,
    onPathBlur,
    onPathFocus,
    onPathOpen,
    onFieldGroupSelect,
    onSetPathCollapsed,
    onSetFieldSetCollapsed,
    presence,
    readOnly,
    schemaType,
    validation: validation2
  } = props2, {
    file,
    image
  } = useSource().form, Input2 = useInputComponent(), Field = useFieldComponent(), Preview2 = usePreviewComponent(), Item2 = useItemComponent(), Block2 = useBlockComponent(), InlineBlock = useInlineBlockComponent(), Annotation2 = useAnnotationComponent();
  let t0;
  $[0] !== Input2 ? (t0 = (inputProps) => /* @__PURE__ */ jsx(Input2, { ...inputProps }), $[0] = Input2, $[1] = t0) : t0 = $[1];
  const renderInput = t0;
  let t1;
  $[2] !== Field ? (t1 = (fieldProps) => /* @__PURE__ */ jsx(Field, { ...fieldProps }), $[2] = Field, $[3] = t1) : t1 = $[3];
  const renderField = t1;
  let t2;
  $[4] !== Item2 ? (t2 = (t32) => {
    const {
      key,
      ...itemProps
    } = t32;
    return /* @__PURE__ */ jsx(Item2, { ...itemProps }, key);
  }, $[4] = Item2, $[5] = t2) : t2 = $[5];
  const renderItem2 = t2;
  let t3;
  $[6] !== Preview2 ? (t3 = (previewProps) => /* @__PURE__ */ jsx(PreviewLoader, { component: Preview2, ...previewProps }), $[6] = Preview2, $[7] = t3) : t3 = $[7];
  const renderPreview = t3;
  let t4;
  $[8] !== Block2 ? (t4 = (blockProps) => /* @__PURE__ */ jsx(Block2, { ...blockProps }), $[8] = Block2, $[9] = t4) : t4 = $[9];
  const renderBlock2 = t4;
  let t5;
  $[10] !== InlineBlock ? (t5 = (blockProps_0) => /* @__PURE__ */ jsx(InlineBlock, { ...blockProps_0 }), $[10] = InlineBlock, $[11] = t5) : t5 = $[11];
  const renderInlineBlock = t5;
  let t6;
  $[12] !== Annotation2 ? (t6 = (annotationProps) => /* @__PURE__ */ jsx(Annotation2, { ...annotationProps }), $[12] = Annotation2, $[13] = t6) : t6 = $[13];
  const renderAnnotation = t6;
  let t7;
  return $[14] !== autoFocus || $[15] !== changesOpen || $[16] !== children || $[17] !== collapsedFieldSets || $[18] !== collapsedPaths || $[19] !== fieldActions || $[20] !== file || $[21] !== focusPath || $[22] !== focused || $[23] !== groups || $[24] !== id2 || $[25] !== image || $[26] !== onChange || $[27] !== onFieldGroupSelect || $[28] !== onPathBlur || $[29] !== onPathFocus || $[30] !== onPathOpen || $[31] !== onSetFieldSetCollapsed || $[32] !== onSetPathCollapsed || $[33] !== patchChannel || $[34] !== presence || $[35] !== readOnly || $[36] !== renderAnnotation || $[37] !== renderBlock2 || $[38] !== renderField || $[39] !== renderInlineBlock || $[40] !== renderInput || $[41] !== renderItem2 || $[42] !== renderPreview || $[43] !== schemaType || $[44] !== validation2 ? (t7 = /* @__PURE__ */ jsx(FormBuilderProvider, { __internal_fieldActions: fieldActions, __internal_patchChannel: patchChannel, autoFocus, changesOpen, collapsedFieldSets, collapsedPaths, file, focusPath, focused, groups, id: id2, image, onChange, onPathBlur, onPathFocus, onPathOpen, onFieldGroupSelect, onSetPathCollapsed, onSetFieldSetCollapsed, presence, readOnly, renderAnnotation, renderBlock: renderBlock2, renderField, renderInlineBlock, renderInput, renderItem: renderItem2, renderPreview, schemaType, validation: validation2, children }), $[14] = autoFocus, $[15] = changesOpen, $[16] = children, $[17] = collapsedFieldSets, $[18] = collapsedPaths, $[19] = fieldActions, $[20] = file, $[21] = focusPath, $[22] = focused, $[23] = groups, $[24] = id2, $[25] = image, $[26] = onChange, $[27] = onFieldGroupSelect, $[28] = onPathBlur, $[29] = onPathFocus, $[30] = onPathOpen, $[31] = onSetFieldSetCollapsed, $[32] = onSetPathCollapsed, $[33] = patchChannel, $[34] = presence, $[35] = readOnly, $[36] = renderAnnotation, $[37] = renderBlock2, $[38] = renderField, $[39] = renderInlineBlock, $[40] = renderInput, $[41] = renderItem2, $[42] = renderPreview, $[43] = schemaType, $[44] = validation2, $[45] = t7) : t7 = $[45], t7;
}
function FormBuilder(props2) {
  const $ = c(104), {
    __internal_fieldActions: fieldActions,
    __internal_patchChannel: patchChannel,
    autoFocus,
    changesOpen,
    collapsedFieldSets,
    collapsedPaths,
    focused,
    focusPath,
    groups,
    id: id2,
    members,
    onChange,
    onFieldGroupSelect,
    onPathBlur,
    onPathFocus,
    onPathOpen,
    onSetFieldSetCollapsed,
    onSetPathCollapsed,
    openPath: t0,
    presence,
    readOnly,
    schemaType,
    validation: validation2,
    value
  } = props2, openPath = t0 === void 0 ? EMPTY_ARRAY$A : t0;
  let t1;
  $[0] !== onSetPathCollapsed ? (t1 = (fieldName) => onSetPathCollapsed([fieldName], !0), $[0] = onSetPathCollapsed, $[1] = t1) : t1 = $[1];
  const handleCollapseField = t1;
  let t2;
  $[2] !== onSetPathCollapsed ? (t2 = (fieldName_0) => onSetPathCollapsed([fieldName_0], !1), $[2] = onSetPathCollapsed, $[3] = t2) : t2 = $[3];
  const handleExpandField = t2;
  let t3;
  $[4] !== onPathBlur ? (t3 = () => onPathBlur(EMPTY_ARRAY$A), $[4] = onPathBlur, $[5] = t3) : t3 = $[5];
  const handleBlur = t3;
  let t4;
  $[6] !== onPathFocus ? (t4 = () => onPathFocus(EMPTY_ARRAY$A), $[6] = onPathFocus, $[7] = t4) : t4 = $[7];
  const handleFocus = t4;
  let t5;
  $[8] !== onChange ? (t5 = (patch2) => onChange(PatchEvent.from(patch2)), $[8] = onChange, $[9] = t5) : t5 = $[9];
  const handleChange = t5, focusRef = useRef(null);
  let t6;
  $[10] !== onFieldGroupSelect ? (t6 = (groupName) => onFieldGroupSelect(EMPTY_ARRAY$A, groupName), $[10] = onFieldGroupSelect, $[11] = t6) : t6 = $[11];
  const handleSelectFieldGroup = t6;
  let t7;
  $[12] !== onPathOpen ? (t7 = (fieldName_1) => onPathOpen([fieldName_1]), $[12] = onPathOpen, $[13] = t7) : t7 = $[13];
  const handleOpenField = t7;
  let t8;
  $[14] !== onPathOpen ? (t8 = () => onPathOpen([]), $[14] = onPathOpen, $[15] = t8) : t8 = $[15];
  const handleCloseField = t8;
  let t9;
  $[16] !== onSetFieldSetCollapsed ? (t9 = (fieldSetName) => onSetFieldSetCollapsed([fieldSetName], !0), $[16] = onSetFieldSetCollapsed, $[17] = t9) : t9 = $[17];
  const handleCollapseFieldSet = t9;
  let t10;
  $[18] !== onSetFieldSetCollapsed ? (t10 = (fieldSetName_0) => onSetFieldSetCollapsed([fieldSetName_0], !1), $[18] = onSetFieldSetCollapsed, $[19] = t10) : t10 = $[19];
  const handleExpandFieldSet = t10, Input2 = useInputComponent(), Field = useFieldComponent(), Preview2 = usePreviewComponent(), Item2 = useItemComponent(), Block2 = useBlockComponent(), InlineBlock = useInlineBlockComponent(), Annotation2 = useAnnotationComponent();
  let t11;
  $[20] !== Input2 ? (t11 = (inputProps) => /* @__PURE__ */ jsx(FormBuilderInputErrorBoundary, { children: /* @__PURE__ */ jsx(Input2, { ...inputProps }) }), $[20] = Input2, $[21] = t11) : t11 = $[21];
  const renderInput = t11;
  let t12;
  $[22] !== Field ? (t12 = (fieldProps) => /* @__PURE__ */ jsx(Field, { ...fieldProps }), $[22] = Field, $[23] = t12) : t12 = $[23];
  const renderField = t12;
  let t13;
  $[24] !== Item2 ? (t13 = (t142) => {
    const {
      key,
      ...itemProps
    } = t142;
    return /* @__PURE__ */ jsx(Item2, { ...itemProps }, key);
  }, $[24] = Item2, $[25] = t13) : t13 = $[25];
  const renderItem2 = t13;
  let t14;
  $[26] !== Preview2 ? (t14 = (previewProps) => /* @__PURE__ */ jsx(PreviewLoader, { component: Preview2, ...previewProps }), $[26] = Preview2, $[27] = t14) : t14 = $[27];
  const renderPreview = t14;
  let t15;
  $[28] !== Block2 ? (t15 = (blockProps) => /* @__PURE__ */ jsx(Block2, { ...blockProps }), $[28] = Block2, $[29] = t15) : t15 = $[29];
  const renderBlock2 = t15;
  let t16;
  $[30] !== InlineBlock ? (t16 = (blockProps_0) => /* @__PURE__ */ jsx(InlineBlock, { ...blockProps_0 }), $[30] = InlineBlock, $[31] = t16) : t16 = $[31];
  const renderInlineBlock = t16;
  let t17;
  $[32] !== Annotation2 ? (t17 = (annotationProps) => /* @__PURE__ */ jsx(Annotation2, { ...annotationProps }), $[32] = Annotation2, $[33] = t17) : t17 = $[33];
  const renderAnnotation = t17;
  let t18, t19;
  $[34] !== handleBlur || $[35] !== handleFocus || $[36] !== id2 ? (t19 = {
    ref: focusRef,
    id: id2,
    onBlur: handleBlur,
    onFocus: handleFocus,
    "aria-describedby": void 0
  }, $[34] = handleBlur, $[35] = handleFocus, $[36] = id2, $[37] = t19) : t19 = $[37];
  let t20;
  $[38] !== members ? (t20 = members.some(_temp$1c), $[38] = members, $[39] = t20) : t20 = $[39];
  let t21;
  $[40] !== focusPath || $[41] !== focused || $[42] !== groups || $[43] !== handleChange || $[44] !== handleCloseField || $[45] !== handleCollapseField || $[46] !== handleCollapseFieldSet || $[47] !== handleExpandField || $[48] !== handleExpandFieldSet || $[49] !== handleOpenField || $[50] !== handleSelectFieldGroup || $[51] !== id2 || $[52] !== members || $[53] !== onPathFocus || $[54] !== readOnly || $[55] !== renderAnnotation || $[56] !== renderBlock2 || $[57] !== renderField || $[58] !== renderInlineBlock || $[59] !== renderInput || $[60] !== renderItem2 || $[61] !== renderPreview || $[62] !== schemaType || $[63] !== t19 || $[64] !== t20 || $[65] !== value ? (t21 = {
    focusPath,
    elementProps: t19,
    changed: t20,
    focused,
    groups,
    id: id2,
    level: 0,
    members,
    onChange: handleChange,
    onFieldClose: handleCloseField,
    onFieldCollapse: handleCollapseField,
    onFieldSetCollapse: handleCollapseFieldSet,
    onFieldExpand: handleExpandField,
    onFieldSetExpand: handleExpandFieldSet,
    onPathFocus,
    onFieldOpen: handleOpenField,
    onFieldGroupSelect: handleSelectFieldGroup,
    path: EMPTY_ARRAY$A,
    presence: EMPTY_ARRAY$A,
    readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    validation: EMPTY_ARRAY$A,
    value
  }, $[40] = focusPath, $[41] = focused, $[42] = groups, $[43] = handleChange, $[44] = handleCloseField, $[45] = handleCollapseField, $[46] = handleCollapseFieldSet, $[47] = handleExpandField, $[48] = handleExpandFieldSet, $[49] = handleOpenField, $[50] = handleSelectFieldGroup, $[51] = id2, $[52] = members, $[53] = onPathFocus, $[54] = readOnly, $[55] = renderAnnotation, $[56] = renderBlock2, $[57] = renderField, $[58] = renderInlineBlock, $[59] = renderInput, $[60] = renderItem2, $[61] = renderPreview, $[62] = schemaType, $[63] = t19, $[64] = t20, $[65] = value, $[66] = t21) : t21 = $[66], t18 = t21;
  const rootInputProps = t18;
  let t22;
  $[67] !== onPathOpen || $[68] !== openPath || $[69] !== renderInput || $[70] !== rootInputProps ? (t22 = /* @__PURE__ */ jsx(TreeEditingEnabledProvider, { children: /* @__PURE__ */ jsx(RootInput, { rootInputProps, onPathOpen, openPath, renderInput }) }), $[67] = onPathOpen, $[68] = openPath, $[69] = renderInput, $[70] = rootInputProps, $[71] = t22) : t22 = $[71];
  let t23;
  $[72] !== fieldActions || $[73] !== t22 ? (t23 = /* @__PURE__ */ jsx(DocumentFieldActionsProvider, { actions: fieldActions, children: t22 }), $[72] = fieldActions, $[73] = t22, $[74] = t23) : t23 = $[74];
  let t24;
  $[75] !== t23 || $[76] !== value ? (t24 = /* @__PURE__ */ jsx(FormValueProvider, { value, children: t23 }), $[75] = t23, $[76] = value, $[77] = t24) : t24 = $[77];
  let t25;
  $[78] !== t24 || $[79] !== value ? (t25 = /* @__PURE__ */ jsx(GetFormValueProvider, { value, children: t24 }), $[78] = t24, $[79] = value, $[80] = t25) : t25 = $[80];
  let t26;
  return $[81] !== autoFocus || $[82] !== changesOpen || $[83] !== collapsedFieldSets || $[84] !== collapsedPaths || $[85] !== fieldActions || $[86] !== focusPath || $[87] !== focused || $[88] !== groups || $[89] !== id2 || $[90] !== onChange || $[91] !== onFieldGroupSelect || $[92] !== onPathBlur || $[93] !== onPathFocus || $[94] !== onPathOpen || $[95] !== onSetFieldSetCollapsed || $[96] !== onSetPathCollapsed || $[97] !== patchChannel || $[98] !== presence || $[99] !== readOnly || $[100] !== schemaType || $[101] !== t25 || $[102] !== validation2 ? (t26 = /* @__PURE__ */ jsx(FormProvider, { __internal_fieldActions: fieldActions, __internal_patchChannel: patchChannel, autoFocus, changesOpen, collapsedFieldSets, collapsedPaths, focusPath, focused, groups, id: id2, onChange, onPathBlur, onPathFocus, onPathOpen, onFieldGroupSelect, onSetPathCollapsed, onSetFieldSetCollapsed, presence, validation: validation2, readOnly, schemaType, children: t25 }), $[81] = autoFocus, $[82] = changesOpen, $[83] = collapsedFieldSets, $[84] = collapsedPaths, $[85] = fieldActions, $[86] = focusPath, $[87] = focused, $[88] = groups, $[89] = id2, $[90] = onChange, $[91] = onFieldGroupSelect, $[92] = onPathBlur, $[93] = onPathFocus, $[94] = onPathOpen, $[95] = onSetFieldSetCollapsed, $[96] = onSetPathCollapsed, $[97] = patchChannel, $[98] = presence, $[99] = readOnly, $[100] = schemaType, $[101] = t25, $[102] = validation2, $[103] = t26) : t26 = $[103], t26;
}
function _temp$1c(m) {
  return m.kind === "field" && m.field.changed;
}
function RootInput(props2) {
  const $ = c(10), {
    rootInputProps,
    onPathOpen,
    openPath,
    renderInput
  } = props2, treeEditing = useTreeEditingEnabled(), isRoot = rootInputProps.id === "root";
  let t0;
  $[0] !== isRoot || $[1] !== onPathOpen || $[2] !== openPath || $[3] !== rootInputProps || $[4] !== treeEditing.enabled ? (t0 = treeEditing.enabled && isRoot && /* @__PURE__ */ jsx(TreeEditingDialog, { onPathFocus: rootInputProps.onPathFocus, onPathOpen, openPath, rootInputProps, schemaType: rootInputProps.schemaType }), $[0] = isRoot, $[1] = onPathOpen, $[2] = openPath, $[3] = rootInputProps, $[4] = treeEditing.enabled, $[5] = t0) : t0 = $[5];
  const arrayEditingModal = t0;
  let t1;
  return $[6] !== arrayEditingModal || $[7] !== renderInput || $[8] !== rootInputProps ? (t1 = renderInput({
    ...rootInputProps,
    __internal_arrayEditingModal: arrayEditingModal
  }), $[6] = arrayEditingModal, $[7] = renderInput, $[8] = rootInputProps, $[9] = t1) : t1 = $[9], t1;
}
const Root$f = styled(Card)((props2) => {
  const {
    color,
    radius,
    space
  } = props2.theme.sanity, overlay = css`
    pointer-events: none;
    content: '';
    position: absolute;
    top: -${space[1]}px;
    bottom: -${space[1]}px;
    left: -${space[1]}px;
    right: -${space[1]}px;
    border-radius: ${radius[2]}px;
    mix-blend-mode: ${color.dark ? "screen" : "multiply"};
  `;
  return css`
    box-shadow: 0 0 0 1px var(--card-border-color);
    border-radius: ${radius[1]}px;
    pointer-events: all;
    position: relative;

    &[data-focused] {
      --card-border-color: var(--card-focus-ring-color);
    }

    &:not([data-focused]):not([data-selected]) {
      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.input.default.hovered.border};
        }
      }
    }

    &[data-markers] {
      &:after {
        ${overlay}
        background-color: ${color.dark ? hues.purple[950].hex : hues.purple[50].hex};
      }
    }

    &[data-warning] {
      &:after {
        ${overlay}
        background-color: ${color.muted.caution.hovered.bg};
      }

      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.muted.caution.hovered.border};
        }
      }
    }

    &[data-invalid] {
      &:after {
        ${overlay}
        background-color: ${color.input.invalid.enabled.bg};
      }

      @media (hover: hover) {
        &:hover {
          --card-border-color: ${color.input.invalid.hovered.border};
        }
      }
    }
  `;
}), PreviewContainer$1 = styled(Flex)`
  display: block;
  position: relative;
  width: 100%;
  user-select: none;
  pointer-events: all;
`, ChangeIndicatorWrapper = styled.div(({
  theme,
  $hasChanges
}) => {
  const {
    space
  } = theme.sanity;
  return css`
      position: absolute;
      width: ${space[2]}px;
      right: 0;
      top: 0;
      bottom: 0;
      padding-left: ${space[1]}px;
      padding-right: ${space[2]}px;
      user-select: none;

      ${!$hasChanges && css`
        display: none;
      `}

      [data-dragged] & {
        visibility: hidden;
      }
    `;
});
styled(Flex)`
  position: relative;

  [data-dragged] > & {
    opacity: 0.5;
  }
`;
const BlockActionsOuter = styled(Box)`
  width: 25px;
  position: relative;
  flex-shrink: 0;
  user-select: none;

  [data-dragged] & {
    visibility: hidden;
  }
`, BlockActionsInner = styled(Flex)`
  position: absolute;
  right: 0;
  [data-dragged] & {
    visibility: hidden;
  }
`, TooltipBox = styled(Box)`
  max-width: 250px;
`, POPOVER_PROPS$4 = {
  constrainSize: !0,
  placement: "bottom",
  portal: "default",
  tone: "default"
};
function BlockObjectActionsMenu(props2) {
  const $ = c(42), {
    children,
    focused,
    isOpen,
    onOpen,
    onRemove,
    readOnly,
    value
  } = props2, {
    t
  } = useTranslation(), menuButtonId = useId(), menuButton = useRef(null), isTabbing = useRef(!1);
  let t0, t1;
  $[0] !== value ? (t1 = isReference$1(value) ? forwardRef(function(linkProps, ref) {
    return /* @__PURE__ */ jsx(IntentLink, { ...linkProps, intent: "edit", params: {
      id: value._ref
    }, ref });
  }) : void 0, $[0] = value, $[1] = t1) : t1 = $[1], t0 = t1;
  const referenceLink = t0;
  let t2, t3;
  $[2] !== isOpen ? (t2 = () => {
    isOpen && (isTabbing.current = !1);
  }, t3 = [isOpen], $[2] = isOpen, $[3] = t2, $[4] = t3) : (t2 = $[3], t3 = $[4]), useEffect(t2, t3);
  let t4;
  $[5] !== focused || $[6] !== isOpen ? (t4 = (event) => {
    focused && event.key === "Tab" && menuButton.current && !isTabbing.current && !isOpen && (event.preventDefault(), event.stopPropagation(), menuButton.current.focus(), isTabbing.current = !0);
  }, $[5] = focused, $[6] = isOpen, $[7] = t4) : t4 = $[7], useGlobalKeyDown(t4);
  let t5;
  $[8] !== onRemove ? (t5 = (event_0) => {
    event_0.preventDefault(), event_0.stopPropagation(), onRemove();
  }, $[8] = onRemove, $[9] = t5) : t5 = $[9];
  const handleDelete = t5;
  let t6;
  $[10] !== children ? (t6 = /* @__PURE__ */ jsx(Box, { flex: 1, children }), $[10] = children, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t ? (t7 = t("inputs.portable-text.block.open-menu-aria-label"), $[12] = t, $[13] = t7) : t7 = $[13];
  const t8 = focused ? 0 : 1;
  let t9;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t9 = {
    content: "Open menu"
  }, $[14] = t9) : t9 = $[14];
  let t10;
  $[15] !== t7 || $[16] !== t8 ? (t10 = /* @__PURE__ */ jsx(Button, { "aria-label": t7, icon: EllipsisHorizontalIcon, mode: "bleed", paddingY: 3, tabIndex: t8, tooltipProps: t9 }), $[15] = t7, $[16] = t8, $[17] = t10) : t10 = $[17];
  let t11;
  $[18] !== referenceLink || $[19] !== t || $[20] !== value ? (t11 = "_ref" in value && !!value._ref && /* @__PURE__ */ jsx(MenuItem$1, { as: referenceLink, "data-as": "a", icon: LinkIcon, text: t("inputs.portable-text.block.open-reference") }), $[18] = referenceLink, $[19] = t, $[20] = value, $[21] = t11) : t11 = $[21];
  let t12;
  $[22] !== onOpen || $[23] !== readOnly || $[24] !== t ? (t12 = readOnly && /* @__PURE__ */ jsx(MenuItem$1, { icon: EyeOpenIcon, onClick: onOpen, text: t("inputs.portable-text.block.view") }), $[22] = onOpen, $[23] = readOnly, $[24] = t, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== handleDelete || $[27] !== onOpen || $[28] !== readOnly || $[29] !== t ? (t13 = !readOnly && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MenuItem$1, { icon: EditIcon, onClick: onOpen, text: t("inputs.portable-text.block.edit") }),
    /* @__PURE__ */ jsx(MenuItem$1, { icon: TrashIcon, onClick: handleDelete, text: t("inputs.portable-text.block.remove"), tone: "critical" })
  ] }), $[26] = handleDelete, $[27] = onOpen, $[28] = readOnly, $[29] = t, $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== t11 || $[32] !== t12 || $[33] !== t13 ? (t14 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsxs(Fragment, { children: [
    t11,
    t12,
    t13
  ] }) }), $[31] = t11, $[32] = t12, $[33] = t13, $[34] = t14) : t14 = $[34];
  let t15;
  $[35] !== menuButtonId || $[36] !== t10 || $[37] !== t14 ? (t15 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(MenuButton$1, { button: t10, ref: menuButton, id: menuButtonId, menu: t14, popover: POPOVER_PROPS$4 }) }), $[35] = menuButtonId, $[36] = t10, $[37] = t14, $[38] = t15) : t15 = $[38];
  let t16;
  return $[39] !== t15 || $[40] !== t6 ? (t16 = /* @__PURE__ */ jsxs(Flex, { children: [
    t6,
    t15
  ] }), $[39] = t15, $[40] = t6, $[41] = t16) : t16 = $[41], t16;
}
function BlockObject(props2) {
  const {
    floatingBoundary,
    focused,
    isFullscreen,
    onItemClose,
    onItemOpen,
    onPathFocus,
    path,
    readOnly,
    referenceBoundary,
    relativePath,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderBlockActions,
    renderCustomMarkers,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    setElementRef,
    value
  } = props2, {
    onChange
  } = useFormCallbacks(), {
    Markers
  } = useFormBuilder().__internal.components, [reviewChangesHovered, setReviewChangesHovered] = useState(!1), markers = usePortableTextMarkers(path), editor2 = usePortableTextEditor(), [divElement, setDivElement] = useState(null), memberItem = usePortableTextMemberItem(pathToString$1(path)), isDeleting = useRef(!1), selfSelection = useMemo(() => ({
    anchor: {
      path: relativePath,
      offset: 0
    },
    focus: {
      path: relativePath,
      offset: 0
    }
  }), [relativePath]), handleChangeIndicatorMouseEnter = useCallback(() => setReviewChangesHovered(!0), []), handleChangeIndicatorMouseLeave = useCallback(() => setReviewChangesHovered(!1), []), onOpen = useCallback(() => {
    memberItem && (PortableTextEditor.blur(editor2), onItemOpen(memberItem.node.path));
  }, [editor2, memberItem, onItemOpen]), onClose = useCallback(() => {
    onItemClose(), PortableTextEditor.select(editor2, selfSelection), PortableTextEditor.focus(editor2);
  }, [onItemClose, editor2, selfSelection]), onRemove = useCallback(() => {
    if (!isDeleting.current)
      try {
        PortableTextEditor.delete(editor2, selfSelection, {
          mode: "blocks"
        });
      } catch (err) {
        console.error(err);
      } finally {
        isDeleting.current = !0;
      }
  }, [editor2, selfSelection]);
  useEffect(() => () => {
    isDeleting.current && PortableTextEditor.focus(editor2);
  }, [editor2]);
  const innerPaddingProps = useMemo(() => isFullscreen && !renderBlockActions ? {
    paddingX: 5
  } : isFullscreen && renderBlockActions ? {
    paddingLeft: 5,
    paddingRight: 2
  } : renderBlockActions ? {
    paddingLeft: 3,
    paddingRight: 2
  } : {
    paddingX: 3
  }, [isFullscreen, renderBlockActions]), {
    validation: validation2,
    hasError,
    hasWarning,
    hasInfo
  } = useMemberValidation(memberItem?.node), parentSchemaType = editor2.schemaTypes.portableText, hasMarkers = markers.length > 0, presence = useChildPresence(path, !0), rootPresence = useMemo(() => presence.filter((p) => isEqual$3(p.path, path)), [path, presence]), tooltipEnabled = hasError || hasWarning || hasInfo || hasMarkers, toolTipContent = useMemo(() => tooltipEnabled && /* @__PURE__ */ jsx(TooltipBox, { children: /* @__PURE__ */ jsx(Markers, { markers, validation: validation2, renderCustomMarkers }) }) || null, [Markers, markers, renderCustomMarkers, tooltipEnabled, validation2]), isOpen = !!memberItem?.member.open, input = memberItem?.input, nodePath = memberItem?.node.path || EMPTY_ARRAY$A, referenceElement = divElement, componentProps = useMemo(() => ({
    __unstable_floatingBoundary: floatingBoundary,
    __unstable_referenceBoundary: referenceBoundary,
    __unstable_referenceElement: referenceElement,
    children: input,
    focused,
    markers,
    onClose,
    onOpen,
    onPathFocus,
    onRemove,
    open: isOpen,
    parentSchemaType,
    path: nodePath,
    presence: rootPresence,
    readOnly: !!readOnly,
    renderAnnotation,
    renderBlock: renderBlock2,
    renderDefault: DefaultBlockObjectComponent,
    renderField,
    renderInlineBlock,
    renderInput,
    renderItem: renderItem2,
    renderPreview,
    schemaType,
    selected,
    validation: validation2,
    value
  }), [floatingBoundary, referenceElement, input, focused, markers, onClose, onOpen, onPathFocus, onRemove, isOpen, parentSchemaType, nodePath, rootPresence, readOnly, referenceBoundary, renderAnnotation, renderBlock2, renderField, renderInlineBlock, renderInput, renderItem2, renderPreview, schemaType, selected, validation2, value]), blockActionsEnabled = renderBlockActions && value && !readOnly, changeIndicatorVisible = isFullscreen && memberItem, setRef = useCallback((elm) => {
    memberItem && setElementRef({
      key: memberItem.member.key,
      elementRef: elm
    }), setDivElement(elm);
  }, [memberItem, setElementRef, setDivElement]);
  return useMemo(() => /* @__PURE__ */ jsx(Box, { ref: setRef, contentEditable: !1, children: /* @__PURE__ */ jsx(Flex, { paddingBottom: 1, marginY: 3, style: void 0, children: /* @__PURE__ */ jsxs(PreviewContainer$1, { ...innerPaddingProps, children: [
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(
      Tooltip,
      {
        placement: "top",
        portal: "editor",
        disabled: isOpen ? !0 : !tooltipEnabled,
        content: toolTipContent,
        children: /* @__PURE__ */ jsx("div", { children: renderBlock2 && renderBlock2(componentProps) })
      }
    ) }),
    blockActionsEnabled && /* @__PURE__ */ jsx(BlockActionsOuter, { contentEditable: !1, marginRight: 3, children: /* @__PURE__ */ jsx(BlockActionsInner, { children: focused && /* @__PURE__ */ jsx(BlockActions, { block: value, onChange, renderBlockActions }) }) }),
    changeIndicatorVisible && /* @__PURE__ */ jsx(ChangeIndicatorWrapper, { $hasChanges: memberItem.member.item.changed, contentEditable: !1, onMouseEnter: handleChangeIndicatorMouseEnter, onMouseLeave: handleChangeIndicatorMouseLeave, children: /* @__PURE__ */ jsx(StyledChangeIndicatorWithProvidedFullPath, { hasFocus: focused, isChanged: memberItem.member.item.changed, path: memberItem.member.item.path, withHoverEffect: !1 }) }),
    reviewChangesHovered && /* @__PURE__ */ jsx(ReviewChangesHighlightBlock, {})
  ] }) }) }), [blockActionsEnabled, changeIndicatorVisible, componentProps, focused, handleChangeIndicatorMouseLeave, handleChangeIndicatorMouseEnter, innerPaddingProps, memberItem, onChange, renderBlock2, renderBlockActions, reviewChangesHovered, setRef, toolTipContent, tooltipEnabled, value, isOpen]);
}
const DefaultBlockObjectComponent = (props2) => {
  const $ = c(41), {
    __unstable_floatingBoundary,
    __unstable_referenceBoundary,
    __unstable_referenceElement,
    children,
    focused,
    markers,
    onClose,
    onOpen,
    onRemove,
    open,
    readOnly,
    renderPreview,
    schemaType,
    selected,
    value,
    validation: validation2
  } = props2, {
    t
  } = useTranslation(), isImagePreview = isImage(value), hasError = validation2.filter(_temp$1b).length > 0, hasWarning = validation2.filter(_temp2$l).length > 0, hasMarkers = markers.length > 0, tone = selected || focused ? "primary" : "default";
  let t0;
  $[0] !== onOpen ? (t0 = (e) => {
    e.preventDefault(), e.stopPropagation(), onOpen();
  }, $[0] = onOpen, $[1] = t0) : t0 = $[1];
  const handleDoubleClickToOpen = t0;
  let t1;
  $[2] !== t ? (t1 = t("inputs.portable-text.block.aria-label"), $[2] = t, $[3] = t1) : t1 = $[3];
  const t2 = focused ? "" : void 0, t3 = isImagePreview ? "" : void 0, t4 = hasError ? "" : void 0, t5 = hasMarkers ? "" : void 0, t6 = readOnly ? "" : void 0, t7 = selected ? "" : void 0, t8 = hasWarning ? "" : void 0, t9 = isImagePreview ? 0 : 1;
  let t10;
  $[4] !== focused || $[5] !== onOpen || $[6] !== onRemove || $[7] !== open || $[8] !== readOnly || $[9] !== value ? (t10 = /* @__PURE__ */ jsx(BlockObjectActionsMenu, { isOpen: open, focused, onOpen, onRemove, readOnly, value }), $[4] = focused, $[5] = onOpen, $[6] = onRemove, $[7] = open, $[8] = readOnly, $[9] = value, $[10] = t10) : t10 = $[10];
  const t11 = isImagePreview ? "blockImage" : "block";
  let t12;
  $[11] !== renderPreview || $[12] !== schemaType || $[13] !== t10 || $[14] !== t11 || $[15] !== value ? (t12 = renderPreview({
    actions: t10,
    layout: t11,
    schemaType,
    skipVisibilityCheck: !0,
    value
  }), $[11] = renderPreview, $[12] = schemaType, $[13] = t10, $[14] = t11, $[15] = value, $[16] = t12) : t12 = $[16];
  let t13;
  $[17] !== handleDoubleClickToOpen || $[18] !== t1 || $[19] !== t12 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9 || $[28] !== tone ? (t13 = /* @__PURE__ */ jsx(Root$f, { "aria-label": t1, "data-focused": t2, "data-image-preview": t3, "data-invalid": t4, "data-markers": t5, "data-read-only": t6, "data-selected": t7, "data-testid": "pte-block-object", "data-warning": t8, flex: 1, onDoubleClick: handleDoubleClickToOpen, padding: t9, tone, children: t12 }), $[17] = handleDoubleClickToOpen, $[18] = t1, $[19] = t12, $[20] = t2, $[21] = t3, $[22] = t4, $[23] = t5, $[24] = t6, $[25] = t7, $[26] = t8, $[27] = t9, $[28] = tone, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== __unstable_floatingBoundary || $[31] !== __unstable_referenceBoundary || $[32] !== __unstable_referenceElement || $[33] !== children || $[34] !== onClose || $[35] !== open || $[36] !== schemaType ? (t14 = open && /* @__PURE__ */ jsx(ObjectEditModal, { floatingBoundary: __unstable_floatingBoundary, defaultType: "dialog", onClose, autoFocus: !0, schemaType, referenceBoundary: __unstable_referenceBoundary, referenceElement: __unstable_referenceElement, children }), $[30] = __unstable_floatingBoundary, $[31] = __unstable_referenceBoundary, $[32] = __unstable_referenceElement, $[33] = children, $[34] = onClose, $[35] = open, $[36] = schemaType, $[37] = t14) : t14 = $[37];
  let t15;
  return $[38] !== t13 || $[39] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t13,
    t14
  ] }), $[38] = t13, $[39] = t14, $[40] = t15) : t15 = $[40], t15;
};
function _temp$1b(v) {
  return v.level === "error";
}
function _temp2$l(v_0) {
  return v_0.level === "warning";
}
function defaultResolveBlockComponent(schemaType) {
  return schemaType.components?.block ? schemaType.components.block : isBlockType(schemaType) ? DefaultComponent$1 : DefaultBlockObjectComponent;
}
function defaultResolveInlineBlockComponent(schemaType) {
  return schemaType.components?.inlineBlock ? schemaType.components.inlineBlock : DefaultInlineObjectComponent;
}
function defaultResolveAnnotationComponent(schemaType) {
  return schemaType.components?.annotation ? schemaType.components.annotation : DefaultAnnotationComponent;
}
function useResolveDefaultComponent(props2) {
  const $ = c(9), {
    componentResolver,
    componentProps
  } = props2;
  if (!componentProps.schemaType)
    throw new Error("the `schemaType` property must be defined");
  let t0;
  $[0] !== componentProps.schemaType || $[1] !== componentResolver ? (t0 = componentResolver(componentProps.schemaType), $[0] = componentProps.schemaType, $[1] = componentResolver, $[2] = t0) : t0 = $[2];
  const DefaultResolvedComponent = t0;
  let t1;
  $[3] !== componentResolver ? (t1 = (parentTypeProps) => {
    if (!parentTypeProps.schemaType?.type)
      throw new Error("Attempted to render form component of non-existent parent type");
    const {
      components: components2,
      ...restSchemaType
    } = parentTypeProps.schemaType, ParentTypeResolvedComponent = componentResolver(restSchemaType);
    return /* @__PURE__ */ jsx(ParentTypeResolvedComponent, { ...parentTypeProps });
  }, $[3] = componentResolver, $[4] = t1) : t1 = $[4];
  const renderDefault2 = t1;
  let t2;
  return $[5] !== DefaultResolvedComponent || $[6] !== componentProps || $[7] !== renderDefault2 ? (t2 = /* @__PURE__ */ jsx(DefaultResolvedComponent, { ...componentProps, renderDefault: renderDefault2 }), $[5] = DefaultResolvedComponent, $[6] = componentProps, $[7] = renderDefault2, $[8] = t2) : t2 = $[8], t2;
}
function DefaultInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveInputComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultField(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveFieldComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultItem(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveItemComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultPreview$1(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolvePreviewComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultBlock(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveBlockComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultInlineBlock(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveInlineBlockComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function DefaultAnnotation(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = {
    componentProps: props2,
    componentResolver: defaultResolveAnnotationComponent
  }, $[0] = props2, $[1] = t0) : t0 = $[1], useResolveDefaultComponent(t0);
}
function pickInputComponent(plugin) {
  return plugin.form?.components?.input;
}
function pickFieldComponent(plugin) {
  return plugin.form?.components?.field;
}
function pickPreviewComponent(plugin) {
  return plugin.form?.components?.preview;
}
function pickItemComponent(plugin) {
  return plugin.form?.components?.item;
}
function pickBlockComponent(plugin) {
  return plugin.form?.components?.block;
}
function pickInlineBlockComponent(plugin) {
  return plugin.form?.components?.inlineBlock;
}
function pickAnnotationComponent(plugin) {
  return plugin.form?.components?.annotation;
}
function useInputComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultInput,
    pick: pickInputComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useFieldComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultField,
    pick: pickFieldComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function usePreviewComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultPreview$1,
    pick: pickPreviewComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useItemComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultItem,
    pick: pickItemComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useBlockComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultBlock,
    pick: pickBlockComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useInlineBlockComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultInlineBlock,
    pick: pickInlineBlockComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useAnnotationComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: DefaultAnnotation,
    pick: pickAnnotationComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function Preview$1(props2) {
  const $ = c(3), PreviewComponent = usePreviewComponent();
  let t0;
  return $[0] !== PreviewComponent || $[1] !== props2 ? (t0 = /* @__PURE__ */ jsx(PreviewLoader, { ...props2, component: PreviewComponent }), $[0] = PreviewComponent, $[1] = props2, $[2] = t0) : t0 = $[2], t0;
}
const INCLUDE_FIELDS_QUERY = ["_id", "_rev", "_type"], INCLUDE_FIELDS = [...INCLUDE_FIELDS_QUERY, "_key"], LISTENER_RESET_DELAY = 1e4, AVAILABILITY_READABLE = {
  available: !0,
  reason: "READABLE"
}, AVAILABILITY_PERMISSION_DENIED = {
  available: !1,
  reason: "PERMISSION_DENIED"
}, AVAILABILITY_NOT_FOUND = {
  available: !1,
  reason: "NOT_FOUND"
}, AVAILABILITY_VERSION_DELETED = {
  available: !1,
  reason: "VERSION_DELETED"
}, INVALID_PREVIEW_FALLBACK = {
  title: "Invalid preview config",
  subtitle: "Check the error log in the console",
  media: /* @__PURE__ */ jsx(WarningOutlineIcon, {})
};
function debounceCollect(fn, wait) {
  let timer2, queue = {}, idx = 0;
  return function(...args) {
    return new Observable((obs) => {
      clearTimeout(timer2), timer2 = setTimeout(flush, wait);
      const queueItem = {
        args,
        observer: obs,
        completed: !1
      }, id2 = idx++;
      return queue[id2] = queueItem, () => {
        queueItem.completed = !0;
      };
    });
  };
  function flush() {
    const currentlyFlushingQueue = queue;
    queue = {};
    const queueItemIds = Object.keys(currentlyFlushingQueue).filter((id2) => {
      const queueItem = currentlyFlushingQueue[id2];
      return queueItem && !queueItem.completed;
    });
    if (queueItemIds.length === 0)
      return;
    const collectedArgs = queueItemIds.map((id2) => {
      const queueItem = currentlyFlushingQueue[id2];
      return queueItem && queueItem.args;
    }).filter(isNonNullable$3);
    fn(collectedArgs).subscribe({
      next(results) {
        results.forEach((result, i) => {
          const queueItem = currentlyFlushingQueue[queueItemIds[i]];
          queueItem && !queueItem.completed && queueItem.observer.next(results[i]);
        });
      },
      complete() {
        queueItemIds.forEach((id2) => {
          const entry = currentlyFlushingQueue[id2];
          entry && !entry.completed && entry.observer.complete();
        });
      },
      error(err) {
        queueItemIds.forEach((id2) => {
          const entry = currentlyFlushingQueue[id2];
          entry && !entry.completed && entry.observer.error(err);
        });
      }
    });
  }
}
const MAX_DOCUMENT_ID_CHUNK_SIZE = 11164, swr = createSWR({
  maxSize: 1e3
});
function chunkDocumentIds(documentIds) {
  let chunk = [], chunkSize = 0;
  const chunks = [];
  for (const documentId of documentIds)
    chunkSize + documentId.length + 1 >= MAX_DOCUMENT_ID_CHUNK_SIZE && (chunks.push(chunk), chunk = [], chunkSize = 0), chunkSize += documentId.length + 1, chunk.push(documentId);
  return chunks.includes(chunk) || chunks.push(chunk), chunks;
}
function mutConcat(array, chunks) {
  return array.push(...chunks), array;
}
function createPreviewAvailabilityObserver(versionedClient2, observePaths2) {
  function observeDocumentAvailability(id2) {
    return observePaths2({
      _ref: id2
    }, [["_rev"], ["_system"]]).pipe(map((res) => ({
      hasRev: isRecord$4(res) && !!("_rev" in res && res?._rev),
      isDeleted: isRecord$4(res) && res._system?.delete === !0
    })), distinctUntilChanged(), switchMap(({
      hasRev,
      isDeleted
    }) => isDeleted ? of(AVAILABILITY_VERSION_DELETED) : hasRev ? (
      // short circuit: if we can read the _rev field we know it both exists and is readable
      of(AVAILABILITY_READABLE)
    ) : (
      // we can't read the _rev field for two possible reasons: 1) the document isn't readable or 2) the document doesn't exist
      fetchDocumentReadability(id2)
    )), swr(id2), map((ev) => ev.value));
  }
  const fetchDocumentReadability = debounceCollect(function(args) {
    const uniqueIds = [...new Set(flatten$1(args))];
    return from(chunkDocumentIds(uniqueIds)).pipe(mergeMap(fetchDocumentReadabilityChunked, 10), reduce$2(mutConcat, []), map((res) => args.map(([id2]) => res[uniqueIds.indexOf(id2)])));
  }, 1);
  function fetchDocumentReadabilityChunked(ids) {
    return defer(() => {
      const requestOptions = {
        uri: versionedClient2.getDataUrl("doc", ids.join(",")),
        json: !0,
        query: {
          excludeContent: "true"
        },
        tag: "preview.documents-availability"
      };
      return versionedClient2.observable.request(requestOptions).pipe(map((response) => {
        const omitted = keyBy(response.omitted || [], (entry) => entry.id);
        return ids.map((id2) => {
          const omittedEntry = omitted[id2];
          if (!omittedEntry)
            return AVAILABILITY_READABLE;
          if (omittedEntry.reason === "existence")
            return AVAILABILITY_NOT_FOUND;
          if (omittedEntry.reason === "permission")
            return AVAILABILITY_PERMISSION_DENIED;
          throw new Error(`Unexpected reason for omission: "${omittedEntry.reason}"`);
        });
      }));
    });
  }
  return function(id2, {
    version
  } = {}) {
    const draftId = getDraftId(id2), publishedId = getPublishedId(id2), versionId = version ? getVersionId(id2, version) : void 0;
    return combineLatest([observeDocumentAvailability(draftId), observeDocumentAvailability(publishedId), ...versionId ? [observeDocumentAvailability(versionId)] : []]).pipe(distinctUntilChanged(shallowEquals), map(([draftReadability, publishedReadability, versionReadability]) => ({
      draft: draftReadability,
      published: publishedReadability,
      ...versionReadability ? {
        version: versionReadability
      } : {}
    })));
  };
}
function createGlobalListener(client) {
  return client.listen("*", {}, {
    events: ["welcome", "mutation", "reconnect"],
    includeResult: !1,
    includePreviousRevision: !1,
    includeMutations: !1,
    includeAllVersions: !0,
    visibility: "query",
    effectFormat: "mendoza",
    tag: "preview.global"
  }).pipe(shareReplayLatest({
    predicate: (event) => event.type === "welcome" || event.type === "reconnect",
    resetOnRefCountZero: () => timer(LISTENER_RESET_DELAY)
  }));
}
function createObserveDocument({
  mutationChannel,
  client
}) {
  const getBatchFetcher = memoize$1(function(apiConfig) {
    const _client = client.withConfig(apiConfig);
    function batchFetchDocuments(ids) {
      return _client.observable.fetch("*[_id in $ids]", {
        ids: uniq(ids.flat())
      }, {
        tag: "preview.observe-document"
      }).pipe(
        // eslint-disable-next-line max-nested-callbacks
        map((result) => ids.map(([id2]) => result.find((r) => r._id === id2)))
      );
    }
    return debounceCollect(batchFetchDocuments, 100);
  }, (apiConfig) => apiConfig.dataset + apiConfig.projectId + apiConfig.apiVersion), MEMO = {};
  function observeDocument(id2, apiConfig) {
    const _apiConfig = {
      dataset: apiConfig?.dataset || client.config().dataset,
      projectId: apiConfig?.projectId || client.config().projectId,
      apiVersion: apiConfig?.apiVersion || client.config().apiVersion
    }, fetchDocument = getBatchFetcher(_apiConfig);
    return mutationChannel.pipe(concatMap$1((event) => event.type === "welcome" ? fetchDocument(id2).pipe(map((document2) => ({
      type: "sync",
      document: document2
    }))) : event.documentId === id2 ? of(event) : EMPTY$6), scan((current, event) => {
      if (event.type === "sync")
        return event.document;
      if (event.type === "mutation")
        return applyMutationEvent(current, event);
      throw new Error(`Unexpected event type: "${event.type}"`);
    }, void 0));
  }
  return function(id2, apiConfig) {
    const key = apiConfig ? `${id2}-${JSON.stringify(apiConfig)}` : id2;
    return key in MEMO || (MEMO[key] = observeDocument(id2, apiConfig).pipe(finalize(() => delete MEMO[key]), shareReplay({
      bufferSize: 1,
      refCount: !0
    }))), MEMO[key];
  };
}
function applyMutationEvent(current, event) {
  if (event.previousRev !== current?._rev)
    return console.warn("Document out of sync, skipping mutation"), current;
  if (!event.effects)
    throw new Error("Mutation event is missing effects. Is the listener set up with effectFormat=mendoza?");
  return applyMutationEventEffects(current, event);
}
const DEFAULT_PREVIEW_PATHS = [["_createdAt"], ["_updatedAt"]];
function getPreviewPaths(preview) {
  const selection = preview?.select;
  return selection ? (Object.values(selection).map((value) => String(value).split(".")) || []).concat(DEFAULT_PREVIEW_PATHS) : void 0;
}
function isPortableTextPreviewValue(value) {
  return Array.isArray(value) && (value.length === 0 || value.some(isPortableTextTextBlock));
}
function extractTextFromBlocks(blocks) {
  const firstBlock = Array.isArray(blocks) && blocks.find(isPortableTextTextBlock);
  return !firstBlock || !firstBlock.children ? "" : firstBlock.children.filter(isPortableTextSpan).map((span) => span.text).join("");
}
const PRESERVE_KEYS = ["_id", "_type", "_upload", "_createdAt", "_updatedAt"], EMPTY$2 = [], errorCollector = /* @__PURE__ */ (() => {
  let errorsByType = {};
  return {
    add: (type, value, error) => {
      const typeName = "name" in type ? type.name : type.type;
      errorsByType[typeName] || (errorsByType[typeName] = []), errorsByType[typeName].push({
        error,
        type,
        value
      });
    },
    getAll() {
      return errorsByType;
    },
    clear() {
      errorsByType = {};
    }
  };
})(), reportErrors = debounce(() => {
  const errorsByType = errorCollector.getAll(), errorCount = flatten$1(Object.keys(errorsByType).map((typeName) => {
    const entries = errorsByType[typeName];
    return uniqBy(entries, (entry) => entry.error.message);
  })).length;
  errorCount !== 0 && (console.groupCollapsed(`%cHeads up! Got ${errorCount === 1 ? "error" : `${errorCount} errors`} while preparing data for preview. Click for details.`, "color: #ff7e7c"), Object.keys(errorsByType).forEach((typeName) => {
    const entries = errorsByType[typeName], first2 = entries[0];
    console.group(`Check the preview config for schema type "${typeName}": %o`, first2.type.preview), uniqBy(entries, (entry) => entry.error.message).forEach((entry) => {
      if (entry.error.type === "returnValueError") {
        const hasPrepare = typeof entry.type.preview?.prepare == "function", {
          value,
          error
        } = entry;
        console.log(`Encountered an invalid ${hasPrepare ? "return value when calling prepare(%o)" : "value targeted by preview.select"}:`, value), console.error(error);
      }
      if (entry.error.type === "prepareError") {
        const {
          value,
          error
        } = entry;
        console.log("Encountered an error when calling prepare(%o):", value), console.error(error);
      }
    }), console.groupEnd();
  }), console.groupEnd(), errorCollector.clear());
}, 1e3), isRenderable = (fieldName) => (value) => {
  const type = typeof value;
  return value === null || type === "undefined" || type === "string" || type === "number" || type === "boolean" ? EMPTY$2 : [assignType("returnValueError", new Error(`The "${fieldName}" field should be a string, number, boolean, undefined or null, instead saw ${inspect(value)}`))];
}, FIELD_NAME_VALIDATORS = {
  media: () => EMPTY$2,
  title: isRenderable("title"),
  subtitle: isRenderable("subtitle"),
  description: isRenderable("description"),
  imageUrl: isRenderable("imageUrl"),
  date: isRenderable("date")
};
function inspect(val, prefixType = !0) {
  if (isRecord$4(val)) {
    const keys = Object.keys(val), ellipse = keys.length > 3 ? "..." : "";
    return `${prefixType ? "object with keys " : ""}{${keys.slice(0, 3).join(", ")}${ellipse}}`;
  }
  if (Array.isArray(val)) {
    const ellipse = val.length > 3 ? "..." : "";
    return `${prefixType ? "array with " : ""}[${val.map((v) => inspect(v, !1))}${ellipse}]`;
  }
  return `the ${typeof val} ${val}`;
}
function validateFieldValue(fieldName, fieldValue) {
  if (typeof fieldValue > "u")
    return EMPTY$2;
  const validator = FIELD_NAME_VALIDATORS[fieldName];
  return validator && validator(fieldValue) || EMPTY$2;
}
function assignType(type, error) {
  return Object.assign(error, {
    type
  });
}
function validatePreparedValue(preparedValue) {
  return !isPlainObject$1(preparedValue) || preparedValue === null ? [assignType("returnValueError", new Error(`Invalid return value. Expected a plain object with at least a 'title' field, instead saw ${inspect(preparedValue)}`))] : Object.entries(preparedValue).reduce((acc, [fieldName, fieldValue]) => [...acc, ...validateFieldValue(fieldName, fieldValue)], EMPTY$2);
}
function validateReturnedPreview(result) {
  return {
    ...result,
    errors: [...result.errors || [], ...validatePreparedValue(result.returnValue)]
  };
}
function defaultPrepare(value) {
  return keysOf(value).reduce((acc, fieldName) => {
    const val = value[fieldName];
    return {
      ...acc,
      [fieldName]: isPortableTextPreviewValue(val) ? extractTextFromBlocks(val) : val
    };
  }, {});
}
function invokePrepare(type, value, viewOptions = {}) {
  const prepare2 = type.preview?.prepare;
  try {
    return {
      returnValue: prepare2 ? prepare2(value, viewOptions) : defaultPrepare(value),
      errors: EMPTY$2
    };
  } catch (error) {
    return {
      returnValue: null,
      errors: [assignType("prepareError", error)]
    };
  }
}
function withErrors(result, type, selectedValue) {
  return result.errors.forEach((error) => errorCollector.add(type, selectedValue, error)), reportErrors(), INVALID_PREVIEW_FALLBACK;
}
function hasEnumListOptions(type) {
  const options = type.options && typeof type.options == "object" ? type.options : !1;
  if (!options || !("list" in options))
    return !1;
  const listOptions = options.list;
  return Array.isArray(listOptions);
}
function getListOptions(type) {
  return hasEnumListOptions(type) ? type.options.list.map((option) => isTitledListValue(option) ? option : {
    title: option,
    value: option
  }) : void 0;
}
function prepareForPreview(rawValue, type, viewOptions = {}) {
  const hasCustomPrepare = typeof type.preview?.prepare == "function", selection = type.preview?.select || {}, selectedValue = Object.keys(selection).reduce((acc, key) => {
    const typeWithFields = "fields" in type ? type : null, targetFieldName = selection[key], valueField = typeWithFields?.fields?.find((f) => f.name === targetFieldName), listOptions = valueField && getListOptions(valueField.type);
    if (!hasCustomPrepare && listOptions) {
      const selectedOption = listOptions && listOptions.find((opt) => opt.value === get(rawValue, selection[key]));
      acc[key] = selectedOption ? selectedOption.value : get(rawValue, selection[key]);
    } else
      acc[key] = get(rawValue, selection[key]);
    return acc;
  }, {}), prepareResult = invokePrepare(type, selectedValue, viewOptions);
  if (prepareResult.errors.length > 0)
    return withErrors(prepareResult, type, selectedValue);
  const returnValueResult = validateReturnedPreview(prepareResult);
  return returnValueResult.errors.length > 0 ? withErrors(returnValueResult, type, selectedValue) : {
    ...pick(rawValue, PRESERVE_KEYS),
    ...prepareResult.returnValue
  };
}
function isRecord(value) {
  return isPlainObject$1(value);
}
function isReference(value) {
  return isPlainObject$1(value);
}
function createPreviewObserver(context) {
  const {
    observeDocumentTypeFromId,
    observePaths: observePaths2
  } = context;
  return function observeForPreview(value, type, options = {}) {
    const {
      viewOptions = {},
      apiConfig,
      perspective
    } = options;
    if (isCrossDatasetReferenceSchemaType(type)) {
      if (!isCrossDatasetReference(value))
        return of({
          snapshot: void 0
        });
      const refApiConfig = {
        projectId: value._projectId,
        dataset: value._dataset
      };
      return observeDocumentTypeFromId(value._ref, refApiConfig, perspective).pipe(switchMap((typeName) => {
        if (typeName) {
          const refType = type.to.find((toType) => toType.type === typeName);
          if (refType)
            return observeForPreview(value, refType, {
              apiConfig: refApiConfig,
              viewOptions,
              perspective
            });
        }
        return of({
          snapshot: void 0
        });
      }));
    }
    if (isReferenceSchemaType(type))
      return isReference(value) ? observeDocumentTypeFromId(value._ref).pipe(switchMap((typeName) => {
        if (typeName) {
          const refType = type.to.find((toType) => toType.name === typeName);
          if (refType)
            return observeForPreview(value, refType, {
              perspective
            });
        }
        return of({
          snapshot: void 0
        });
      })) : of({
        snapshot: void 0
      });
    const paths = getPreviewPaths(type.preview);
    return paths ? observePaths2(value, paths, apiConfig, perspective).pipe(map((snapshot2) => ({
      type,
      snapshot: snapshot2 ? prepareForPreview(snapshot2, type, viewOptions) : null
    }))) : of({
      type,
      snapshot: value && isRecord(value) ? invokePrepare(type, value, viewOptions).returnValue : null
    });
  };
}
function createObservePathsDocumentPair(options) {
  const {
    observeDocumentPairAvailability,
    observePaths: observePaths2
  } = options, ALWAYS_INCLUDED_SNAPSHOT_PATHS = [["_updatedAt"], ["_createdAt"], ["_type"]];
  return function(id2, paths, {
    version
  } = {}) {
    const {
      draftId,
      publishedId,
      versionId
    } = getIdPair(id2, {
      version
    });
    return observeDocumentPairAvailability(draftId, {
      version
    }).pipe(switchMap((availability) => {
      if (!availability.draft.available && !availability.published.available && !availability.version?.available)
        return of({
          id: publishedId,
          type: null,
          draft: {
            availability: availability.draft,
            snapshot: void 0
          },
          published: {
            availability: availability.published,
            snapshot: void 0
          },
          ...availability.version ? {
            version: {
              availability: availability.version,
              snapshot: void 0
            }
          } : {}
        });
      const snapshotPaths = [...paths, ...ALWAYS_INCLUDED_SNAPSHOT_PATHS];
      return combineLatest([observePaths2({
        _type: "reference",
        _ref: draftId
      }, snapshotPaths), observePaths2({
        _type: "reference",
        _ref: publishedId
      }, snapshotPaths), ...version ? [observePaths2({
        _type: "reference",
        _ref: versionId
      }, snapshotPaths)] : []]).pipe(map(([draftSnapshot, publishedSnapshot, versionSnapshot]) => {
        const type = isRecord$4(versionSnapshot) && "_type" in versionSnapshot && versionSnapshot._type || isRecord$4(draftSnapshot) && "_type" in draftSnapshot && draftSnapshot._type || isRecord$4(publishedSnapshot) && "_type" in publishedSnapshot && publishedSnapshot._type || null;
        return {
          id: publishedId,
          type: typeof type == "string" ? type : null,
          draft: {
            availability: availability.draft,
            snapshot: draftSnapshot
          },
          published: {
            availability: availability.published,
            snapshot: publishedSnapshot
          },
          ...availability.version ? {
            version: {
              availability: availability.version,
              snapshot: versionSnapshot
            }
          } : {}
        };
      }));
    }));
  };
}
function createDocumentIdSetObserver(client) {
  return function(queryFilter, params, options = {}) {
    const {
      insert: insertOption = "sorted",
      apiVersion
    } = options, query = `*[${queryFilter}]._id`;
    function fetchFilter() {
      return versionedClient(client, apiVersion).observable.fetch(query, params, {
        tag: "preview.observe-document-set.fetch"
      }).pipe(tap((result) => {
        if (!Array.isArray(result))
          throw new Error(`Expected query to return array of documents, but got ${typeof result}`);
      }));
    }
    return versionedClient(client, apiVersion).observable.listen(`*[${queryFilter}]`, params, {
      visibility: "transaction",
      events: ["welcome", "mutation", "reconnect"],
      includeResult: !1,
      includeMutations: !1,
      includeAllVersions: !0,
      tag: "preview.observe-document-set.listen"
    }).pipe(mergeMap((event) => event.type === "welcome" ? fetchFilter().pipe(map((result) => ({
      type: "fetch",
      result
    }))) : of(event)), scan((state, event) => {
      if (event.type === "reconnect")
        return {
          documentIds: state?.documentIds || [],
          ...state,
          status: "reconnecting"
        };
      if (event.type === "fetch")
        return {
          ...state,
          status: "connected",
          documentIds: event.result
        };
      if (event.type === "mutation") {
        if (event.transition === "update")
          return state;
        if (event.transition === "appear")
          return {
            status: "connected",
            documentIds: insert(state?.documentIds || [], event.documentId, insertOption)
          };
        if (event.transition === "disappear")
          return {
            status: "connected",
            documentIds: state?.documentIds ? state.documentIds.filter((id2) => id2 !== event.documentId) : []
          };
      }
      return state;
    }, void 0), distinctUntilChanged(), filter((state) => state !== void 0));
  };
}
function insert(array, element, strategy) {
  let index;
  return strategy === "prepend" ? index = 0 : strategy === "append" ? index = array.length : index = sortedIndex(array, element), array.toSpliced(index, 0, element);
}
function hasEqualFields(fields) {
  return (object, otherObject) => object === otherObject ? !0 : !object || !otherObject || typeof object != "object" || typeof otherObject != "object" ? !1 : fields.every((field) => object[field] === otherObject[field]);
}
const id = (value) => value;
function isUniqueBy(array, itemSelector = id) {
  let prevItem, currItem;
  for (let i = 0; i < array.length; i++) {
    if (i === 0) {
      prevItem = itemSelector(array[i]);
      continue;
    }
    if (currItem = itemSelector(array[i]), prevItem !== currItem)
      return !1;
    prevItem = currItem;
  }
  return !0;
}
function combineSelections(selections) {
  return values(selections.reduce((output, [id2, fields], index) => {
    const key = sortBy(fields.join(","), identity$2).join(".");
    output[key] || (output[key] = {
      fields,
      ids: [],
      map: []
    });
    const idx = output[key].ids.length;
    return output[key].ids[idx] = id2, output[key].map[idx] = index, output;
  }, {}));
}
function stringifyId(id2) {
  return JSON.stringify(id2);
}
const maybeEscape = (fieldName) => fieldNeedsEscape(fieldName) ? `"${fieldName}": @${escapeField(fieldName)}` : fieldName;
function toSubQuery({
  ids,
  fields
}) {
  const allFields = [...INCLUDE_FIELDS_QUERY, ...fields];
  return `*[_id in [${ids.map(stringifyId).join(",")}]][0...${ids.length}]{${allFields.map(maybeEscape).join(",")}}`;
}
function toQuery(combinedSelections) {
  return `[${combinedSelections.map(toSubQuery).join(",")}][0...${combinedSelections.length}]`;
}
function reassemble(queryResult, combinedSelections) {
  return queryResult.reduce((reprojected, subResult, index) => (combinedSelections[index].map.forEach((resultIdx, i) => {
    const id2 = combinedSelections[index].ids[i], found = subResult.find((doc) => doc._id === id2);
    reprojected[resultIdx] = found || null;
  }), reprojected), []);
}
function createObserveFields(options) {
  const {
    client: currentDatasetClient,
    invalidationChannel
  } = options;
  function fetchAllDocumentPathsWith(client, perspective) {
    return function(selections) {
      const combinedSelections = combineSelections(selections), useReleaseVersion = perspective && perspective.length > 0 || combinedSelections.some((selection) => selection.ids.some(isVersionId));
      return versionedClient(client, useReleaseVersion ? RELEASES_STUDIO_CLIENT_OPTIONS.apiVersion : void 0).observable.fetch(toQuery(combinedSelections), {}, {
        tag: "preview.document-paths",
        perspective
      }).pipe(retry({
        delay: (_, attempt) => timer(Math.min(3e4, attempt * 1e3))
      }), map((result) => reassemble(result, combinedSelections)));
    };
  }
  const batchFetchersCache = /* @__PURE__ */ new Map();
  function getBatchFetchersForPerspective(perspective) {
    const key = perspective?.join("-") || "raw";
    if (batchFetchersCache.has(key))
      return batchFetchersCache.get(key);
    const batchFetchers = {
      fast: debounceCollect(fetchAllDocumentPathsWith(currentDatasetClient, perspective), 100),
      slow: debounceCollect(fetchAllDocumentPathsWith(currentDatasetClient, perspective), 1e3)
    };
    return batchFetchersCache.set(key, batchFetchers), batchFetchers;
  }
  function currentDatasetListenFields(documentId, fields, perspective) {
    const {
      fast: fetchDocumentPathsFast,
      slow: fetchDocumentPathsSlow
    } = getBatchFetchersForPerspective(perspective), hasPerspective = perspective && perspective.length > 0, fetchId = hasPerspective ? getPublishedId(documentId) : documentId;
    return invalidationChannel.pipe(filter((event) => event.type === "connected" ? !0 : hasPerspective ? idMatchesPerspective(perspective, documentId) : event.documentId === documentId), switchMap((event) => event.type === "connected" || event.visibility === "query" ? fetchDocumentPathsFast(fetchId, fields).pipe(mergeMap((result) => concat(of(result), result === null ? (
      // just been created and is not yet indexed. We therefore need to wait a bit
      // and then re-fetch.
      fetchDocumentPathsSlow(fetchId, fields)
    ) : []))) : fetchDocumentPathsSlow(fetchId, fields)));
  }
  const CACHE2 = {}, getBatchFetcherForDataset = memoize$1(function(apiConfig) {
    const client = currentDatasetClient.withConfig(apiConfig), fetchAll = fetchAllDocumentPathsWith(client, ["published"]);
    return debounceCollect(fetchAll, 10);
  }, (apiConfig) => apiConfig.dataset + apiConfig.projectId), CROSS_DATASET_PREVIEW_POLL_INTERVAL = 1e4, visiblePoll$ = fromEvent(document, "visibilitychange").pipe(startWith(0), map(() => document.visibilityState === "visible"), switchMap((visible) => visible ? timer(0, CROSS_DATASET_PREVIEW_POLL_INTERVAL) : EMPTY$6), share());
  function crossDatasetListenFields(id2, fields, apiConfig) {
    return visiblePoll$.pipe(startWith(0)).pipe(switchMap(() => getBatchFetcherForDataset(apiConfig)(id2, fields)));
  }
  function createCachedFieldObserver(id2, fields, apiConfig, perspective) {
    let latest;
    const changes$ = merge(defer(() => latest === void 0 ? EMPTY$6 : of(latest)), apiConfig ? crossDatasetListenFields(id2, fields, apiConfig) : currentDatasetListenFields(id2, fields, perspective)).pipe(tap((v) => latest = v), shareReplay({
      refCount: !0,
      bufferSize: 1
    }));
    return {
      id: id2,
      fields,
      changes$
    };
  }
  function cachedObserveFields(id2, fields, apiConfig, perspective) {
    const cacheKey = apiConfig ? `${apiConfig.projectId}:${apiConfig.dataset}:${id2}` : `$current$-${id2}-${perspective?.join("-") || "raw"}`;
    cacheKey in CACHE2 || (CACHE2[cacheKey] = []);
    const existingObservers = CACHE2[cacheKey];
    difference(fields, flatten$1(existingObservers.map((cachedFieldObserver) => cachedFieldObserver.fields))).length > 0 && existingObservers.push(createCachedFieldObserver(id2, fields, apiConfig, perspective));
    const cachedFieldObservers = existingObservers.filter((observer) => observer.fields.some((fieldName) => fields.includes(fieldName))).map((cached) => cached.changes$);
    return combineLatest(cachedFieldObservers).pipe(
      // in the event that a document gets deleted, the cached values will be updated to store `undefined`
      // if this happens, we should not pick any fields from it, but rather just return null
      map((snapshots) => snapshots.filter(Boolean)),
      // make sure all snapshots agree on same revision
      filter((snapshots) => isUniqueBy(snapshots, (snapshot2) => snapshot2._rev)),
      // pass on value with the requested fields (or null if value is deleted)
      map((snapshots) => snapshots.length === 0 ? null : pickFrom(snapshots, fields)),
      // emit values only if changed
      distinctUntilChanged(hasEqualFields(fields))
    );
  }
  return cachedObserveFields;
  function pickFrom(objects, fields) {
    return [...INCLUDE_FIELDS, ...fields].reduce((result, fieldName) => {
      const value = getFirstFieldValue(objects, fieldName);
      return value !== void 0 && (result[fieldName] = value), result;
    }, {});
  }
  function getFirstFieldValue(objects, fieldName) {
    let value;
    return objects.some((object) => fieldName in object ? (value = object[fieldName], !0) : !1), value;
  }
}
function createDocumentPreviewStore({
  client
}) {
  const versionedClient2 = client.withConfig({
    apiVersion: "2025-02-19"
  }), globalListener = createGlobalListener(versionedClient2).pipe(filter((event) => (
    // ignore reconnect events for now until we've verified that downstream consumers can handle them
    event.type === "mutation" || event.type === "welcome"
  ))), invalidationChannel = globalListener.pipe(map((event) => event.type === "welcome" ? {
    type: "connected"
  } : event)), observeDocument = createObserveDocument({
    client,
    mutationChannel: globalListener
  }), observeFields = createObserveFields({
    client: versionedClient2,
    invalidationChannel
  }), observePaths2 = createPathObserver({
    observeFields
  });
  function observeDocumentTypeFromId(id2, apiConfig, perspective) {
    return observePaths2({
      _type: "reference",
      _ref: id2
    }, ["_type"], apiConfig, perspective).pipe(map((res) => isRecord$4(res) && typeof res._type == "string" ? res._type : void 0), distinctUntilChanged());
  }
  const observeDocumentIdSet = createDocumentIdSetObserver(versionedClient2), observeForPreview = createPreviewObserver({
    observeDocumentTypeFromId,
    observePaths: observePaths2
  }), observeDocumentPairAvailability = createPreviewAvailabilityObserver(versionedClient2, observePaths2), observePathsDocumentPair = createObservePathsDocumentPair({
    observeDocumentPairAvailability,
    observePaths: observePaths2
  });
  return {
    observePaths: observePaths2,
    observeForPreview,
    observeDocumentTypeFromId,
    unstable_observeDocumentIdSet: observeDocumentIdSet,
    unstable_observeDocument: observeDocument,
    unstable_observeDocuments: (ids) => combineLatest(ids.map((id2) => observeDocument(id2))),
    unstable_observeDocumentPairAvailability: observeDocumentPairAvailability,
    unstable_observePathsDocumentPair: observePathsDocumentPair
  };
}
const INITIAL_STATE$7 = {
  loading: !0,
  document: null
};
function useObserveDocument(documentId, apiConfig) {
  const $ = c(4), documentPreviewStore = useDocumentPreviewStore();
  let t0, t1;
  return $[0] !== apiConfig || $[1] !== documentId || $[2] !== documentPreviewStore ? (t1 = documentPreviewStore.unstable_observeDocument(documentId, apiConfig).pipe(map(_temp$1a)), $[0] = apiConfig, $[1] = documentId, $[2] = documentPreviewStore, $[3] = t1) : t1 = $[3], t0 = t1, useObservable(t0, INITIAL_STATE$7);
}
function _temp$1a(document2) {
  return {
    loading: !1,
    document: document2
  };
}
function getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId, perspective) {
  const perspectiveSnapshot = documentPreviewStore.observeForPreview({
    _id: getPublishedId(documentId)
  }, schemaType, {
    perspective
  }), versionOrDraftId = isVersionId(documentId) ? getVersionFromId(documentId) : "drafts", preparedVersionSnapshot = versionOrDraftId ? documentPreviewStore.observeForPreview({
    _id: getPublishedId(documentId)
  }, schemaType, {
    perspective: [versionOrDraftId]
  }) : of(null);
  return combineLatest([perspectiveSnapshot, preparedVersionSnapshot]).pipe(map(([main, version]) => ({
    isLoading: !1,
    snapshot: main?.snapshot || null,
    original: version?.snapshot || null
  })), startWith({
    isLoading: !0,
    snapshot: null,
    original: null
  }));
}
function getMissingDocumentFallback(document2) {
  return {
    title: /* @__PURE__ */ jsx("em", { children: document2.title ? String(document2.title) : "Missing document" }),
    subtitle: /* @__PURE__ */ jsx("em", { children: document2.title ? `Missing document ID: ${document2._id}` : `Document ID: ${document2._id}` }),
    media: () => /* @__PURE__ */ jsx(WarningOutlineIcon, {})
  };
}
const EMPTY$1 = {};
function getPreviewValueWithFallback({
  snapshot: snapshot2,
  original,
  fallback: fallback2
}) {
  return snapshot2 || original || getMissingDocumentFallback(fallback2 || EMPTY$1);
}
const SDK_CHANNEL_NAME = "dashboard/channels/sdk", SDK_NODE_NAME = "dashboard/nodes/sdk";
function createComlinkStore({
  capabilities
}) {
  if (!capabilities.comlink)
    return {};
  const node = createNode({
    name: SDK_NODE_NAME,
    connectTo: SDK_CHANNEL_NAME
  });
  return node.start(), {
    node
  };
}
function isCoreUiRenderingContext(maybeCoreUiRenderingContext) {
  return typeof maybeCoreUiRenderingContext == "object" && maybeCoreUiRenderingContext !== null && "name" in maybeCoreUiRenderingContext && maybeCoreUiRenderingContext.name === "coreUi" && "metadata" in maybeCoreUiRenderingContext && typeof maybeCoreUiRenderingContext.metadata == "object" && maybeCoreUiRenderingContext.metadata !== null && "environment" in maybeCoreUiRenderingContext.metadata && typeof maybeCoreUiRenderingContext.metadata.environment == "string";
}
const INITIAL_URL_SEARCH = typeof location == "object" ? location.search : "", CORE_UI_MODE_NAME = "core-ui", CORE_UI_CONTEXT_SEARCH_PARAM = "_context";
function coreUiRenderingContext(urlSearch = INITIAL_URL_SEARCH) {
  return pipe(switchMap$1((renderingContext) => renderingContext ? of(renderingContext) : of(urlSearch).pipe(distinctUntilChanged$1(), map$1((search2) => new URLSearchParams(search2).get(CORE_UI_CONTEXT_SEARCH_PARAM)), map$1((serializedContext) => {
    if (serializedContext === null)
      return;
    const {
      mode,
      env
    } = JSON.parse(serializedContext), coreUirenderingContext = {
      name: mode === CORE_UI_MODE_NAME ? "coreUi" : void 0,
      metadata: {
        environment: env
      }
    };
    if (isCoreUiRenderingContext(coreUirenderingContext))
      return coreUirenderingContext;
  }), catchError$1((error) => (console.warn("Error parsing rendering context:", error), of(void 0))))));
}
const DEFAULT_RENDERING_CONTEXT = {
  name: "default",
  metadata: {}
};
function defaultRenderingContext() {
  return map$1((renderingContext) => renderingContext ?? DEFAULT_RENDERING_CONTEXT);
}
const capabilitiesByRenderingContext = {
  coreUi: {
    globalUserMenu: !0,
    globalWorkspaceControl: !0,
    comlink: !0
  },
  default: {}
};
function listCapabilities() {
  return map$1((renderingContext) => capabilitiesByRenderingContext[renderingContext.name]);
}
function createRenderingContextStore() {
  const renderingContext = of(void 0).pipe(coreUiRenderingContext(), defaultRenderingContext(), shareReplay$1(1)), capabilities = renderingContext.pipe(listCapabilities(), shareReplay$1(1));
  return {
    renderingContext,
    capabilities
  };
}
const DocumentDesynced = defineEvent({
  name: "Document Desynced",
  version: 1,
  description: 'Occurs when a "hole" in events from the document pair listener is detected and recovered from.'
}), HighListenerLatencyOccurred = defineEvent({
  name: "High Listener Latency Detected",
  version: 1,
  description: "Emits when a high listener latency is detected"
});
function getDocumentValuePermissions({
  grantsStore,
  document: document2,
  permission
}) {
  const {
    checkDocumentPermission
  } = grantsStore;
  return checkDocumentPermission(permission, document2);
}
const INITIAL_STATE$6 = [void 0, !0];
function stateReducer(prev, action) {
  const [prevResult, prevIsLoading] = prev;
  switch (action.type) {
    // Keep the old value around while loading a new one. Prevents "jittering" UIs, and permissions
    // usually don't change _that_ rapidly (this hook runs on every single document change).
    case "loading":
      return [prevResult, !0];
    case "value":
      return !prevIsLoading && isEqual$2(action.value, prevResult) ? prev : [action.value, !1];
    case "error":
      throw action.error;
    default:
      throw new Error(`Invalid action type: ${action}`);
  }
}
function useDocumentValuePermissions(t0) {
  const $ = c(5), {
    document: document2,
    permission,
    grantsStore: specifiedGrantsStore
  } = t0, defaultGrantsStore = useGrantsStore(), grantsStore = specifiedGrantsStore || defaultGrantsStore, [state, dispatch] = useReducer(stateReducer, INITIAL_STATE$6), subscriptionRef = useRef(null);
  let t1, t2;
  return $[0] !== document2 || $[1] !== grantsStore || $[2] !== permission ? (t1 = () => {
    dispatch({
      type: "loading"
    }), subscriptionRef.current && subscriptionRef.current.unsubscribe();
    const permissions$ = getDocumentValuePermissions({
      grantsStore,
      document: document2,
      permission
    });
    return subscriptionRef.current = permissions$.pipe(distinctUntilChanged$1(_temp$19)).subscribe({
      next: (value) => dispatch({
        type: "value",
        value
      }),
      error: (error) => dispatch({
        type: "error",
        error
      })
    }), () => {
      subscriptionRef.current && (subscriptionRef.current.unsubscribe(), subscriptionRef.current = null);
    };
  }, t2 = [grantsStore, document2, permission], $[0] = document2, $[1] = grantsStore, $[2] = permission, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useEffect(t1, t2), state;
}
function _temp$19(prev, next) {
  return isEqual$2(prev, next);
}
function refCountDelay(duration, scheduler = asapScheduler) {
  return (source) => {
    const connectable = source;
    let connectableSubscription = null, connectorSubscription = null;
    const notifier = new Subject(), connector = notifier.pipe(scan((count2, step) => count2 + step, 0), switchMap((count2) => count2 === 0 ? timer(duration, scheduler).pipe(tap(() => {
      connectableSubscription && (connectableSubscription.unsubscribe(), connectableSubscription = null), connectorSubscription && (connectorSubscription.unsubscribe(), connectorSubscription = null);
    })) : !connectableSubscription && count2 > 0 ? timer(0, scheduler).pipe(tap(() => {
      connectableSubscription || (connectableSubscription = connectable.connect());
    })) : NEVER));
    return using(() => (connectorSubscription || (connectorSubscription = connector.subscribe()), notifier.next(1), {
      unsubscribe: () => notifier.next(-1)
    }), () => source);
  };
}
const DEBUG_PREFIX = "_debug_", hashchange$ = typeof window > "u" ? of({}) : fromEvent(window, "hashchange"), debugParams$ = concat(of(0), hashchange$).pipe(map(() => typeof document > "u" ? "#" : document.location.hash), distinctUntilChanged(), map((hash2) => hash2.slice(1).split(";").filter((p) => p.toLowerCase().startsWith(DEBUG_PREFIX)).map((param) => param.slice(DEBUG_PREFIX.length)))), debugRolesParam$ = debugParams$.pipe(map((args) => args.find((arg) => arg.startsWith("roles="))), map((arg) => arg?.split("roles=")[1].split(",").map((r) => r.trim()) || [])), administrator = [{
  filter: '_id in path("**")',
  permissions: ["read", "create", "history", "update"]
}], editor = [{
  filter: '_id in path("**")',
  permissions: ["read", "create", "history", "update"]
}], developer = [{
  filter: '_id in path("**")',
  permissions: ["read", "create", "history", "update"]
}], contributor = [{
  filter: '_id in path("**")',
  permissions: ["read"]
}, {
  filter: '_id in path("drafts.**")',
  permissions: ["create", "history", "update"]
}], viewer = [{
  filter: '_id in path("**")',
  permissions: ["read", "history"]
}], requiresApproval = [{
  filter: "!locked",
  permissions: ["read", "create", "update"]
}], restricted = [{
  filter: '_id in path("drafts.**") && _type in ["stringsTest", "book", "author", "referenceTest"]',
  permissions: ["read", "create", "history", "update"]
}, {
  filter: '_id in path("**")',
  permissions: ["read"]
}], DEBUG_ROLE_GRANTS_MAP = {
  // basic
  administrator,
  editor,
  developer,
  contributor,
  viewer,
  // custom
  restricted,
  requiresApproval,
  // legacy
  read: viewer,
  write: editor
}, debugGrants$ = debugRolesParam$.pipe(map((roles) => roles.length ? roles.filter((value) => !!value && value in DEBUG_ROLE_GRANTS_MAP).flatMap((roleName) => DEBUG_ROLE_GRANTS_MAP[roleName] || []) : null));
async function getDatasetGrants(client, projectId, dataset) {
  return await client.request({
    uri: `/projects/${projectId}/datasets/${dataset}/acl`,
    tag: "acl.get"
  });
}
function getParams(userId) {
  const params = {};
  return userId !== null && (params.identity = userId), params;
}
const PARSED_FILTERS_MEMO = /* @__PURE__ */ new Map();
async function matchesFilter(userId, filter2, document2) {
  PARSED_FILTERS_MEMO.has(filter2) || PARSED_FILTERS_MEMO.set(filter2, parse$2(`*[${filter2}]`));
  const parsed = PARSED_FILTERS_MEMO.get(filter2), evalParams = getParams(userId), {
    identity: identity2
  } = evalParams, params = {
    ...evalParams
  };
  return (await (await evaluate(parsed, {
    dataset: [document2],
    identity: identity2,
    params
  })).get())?.length === 1;
}
function createGrantsStore(opts) {
  const {
    client
  } = opts, versionedClient2 = client.withConfig({
    apiVersion: "2021-06-07"
  }), userId = "userId" in opts ? opts.userId : opts?.currentUser?.id || null, datasetGrants$ = defer(() => of(versionedClient2.config())).pipe(switchMap(({
    projectId,
    dataset
  }) => {
    if (!projectId || !dataset)
      throw new Error("Missing projectId or dataset");
    return getDatasetGrants(versionedClient2, projectId, dataset);
  })), currentUserDatasetGrants = debugGrants$.pipe(switchMap((debugGrants) => debugGrants ? of(debugGrants) : datasetGrants$), publishReplay(1), refCountDelay(1e3));
  return {
    checkDocumentPermission(permission, document2) {
      return currentUserDatasetGrants.pipe(switchMap((grants) => grantsPermissionOn(userId, grants, permission, document2)), distinctUntilChanged(shallowEquals));
    }
  };
}
async function grantsPermissionOn(userId, grants, permission, document2) {
  if (!document2)
    return {
      granted: !0,
      reason: "Null document, nothing to check"
    };
  if (!grants.length)
    return {
      granted: !1,
      reason: "No document grants"
    };
  const matchingGrants = [];
  for (const grant of grants)
    await matchesFilter(userId, grant.filter, document2) && matchingGrants.push(grant);
  const foundMatch = matchingGrants.some((grant) => grant.permissions.some((p) => p === permission));
  return {
    granted: foundMatch,
    reason: foundMatch ? "Matching grant" : "No matching grants found"
  };
}
function serialize$3(item) {
  return typeof item == "object" && item !== null && "serialize" in item ? serialize$3(item.serialize()) : item;
}
function getTemplatePermissions({
  grantsStore,
  templateItems,
  templates,
  schema: schema2,
  context
}) {
  return templateItems?.length ? defer(() => from(templateItems).pipe(
    // Serialize and resolve each item one at a time
    concatMap$1(async (item) => {
      const serializedItem = serialize$3(item), template2 = templates.find((t) => t.id === serializedItem.templateId);
      if (!template2)
        throw new Error(`template not found: "${serializedItem.templateId}"`);
      const resolvedInitialValue = await resolveInitialValue(schema2, template2, serializedItem.parameters, context, {
        useCache: !0
      });
      return {
        item: serializedItem,
        template: template2,
        resolvedInitialValue
      };
    }),
    // Convert each resolved item into a permission check observable
    map(({
      item,
      template: template2,
      resolvedInitialValue
    }) => {
      const schemaType = schema2.get(template2.schemaType);
      if (!schemaType)
        throw new Error(`schema type not found: "${template2.schemaType}"`);
      const liveEdit = schemaType?.liveEdit, {
        initialDocumentId = "dummy-id"
      } = item, documentId = liveEdit ? getPublishedId(initialDocumentId) : getDraftId(initialDocumentId);
      return getDocumentValuePermissions({
        grantsStore,
        permission: "create",
        document: {
          _id: documentId,
          ...resolvedInitialValue
        }
      }).pipe(map(({
        granted,
        reason
      }) => ({
        ...item,
        granted,
        reason,
        resolvedInitialValue,
        template: template2,
        i18n: item.i18n || template2.i18n,
        title: item.title || template2.title,
        subtitle: schemaType.title === (item.title || template2.title) ? void 0 : schemaType.title,
        description: item.description || template2.description,
        icon: item.icon || template2.icon
      })));
    }),
    // Collect all permission check observables
    toArray$1(),
    // Switch to combined observable of all permission checks
    switchMap((observables) => combineLatest(observables))
  )) : of([]);
}
const useTemplatePermissionsFromHookFactory = createHookFromObservableFactory(getTemplatePermissions);
function useTemplatePermissions(t0) {
  const $ = c(9);
  let rest, templateItems;
  $[0] !== t0 ? ({
    templateItems,
    ...rest
  } = t0, $[0] = t0, $[1] = rest, $[2] = templateItems) : (rest = $[1], templateItems = $[2]);
  const schema2 = useSchema(), templates = useTemplates(), grantsStore = useGrantsStore(), initialValueContext = useInitialValueResolverContext();
  let t1;
  const t2 = rest.grantsStore || grantsStore, t3 = rest.schema || schema2, t4 = rest.templates || templates;
  let t5;
  return $[3] !== initialValueContext || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== templateItems ? (t5 = {
    templateItems,
    grantsStore: t2,
    schema: t3,
    templates: t4,
    context: initialValueContext
  }, $[3] = initialValueContext, $[4] = t2, $[5] = t3, $[6] = t4, $[7] = templateItems, $[8] = t5) : t5 = $[8], t1 = t5, useTemplatePermissionsFromHookFactory(t1);
}
function canMergeEdit(type) {
  return type === "create" || type === "editDraft";
}
const CHUNK_WINDOW = 5 * 60 * 1e3;
function isWithinMergeWindow$1(a, b) {
  return Date.parse(b) - Date.parse(a) < CHUNK_WINDOW;
}
function mergeChunk(left, right) {
  if (left.end !== right.start) throw new Error("chunks are not next to each other");
  const draftState = combineState(left.draftState, right.draftState), publishedState = combineState(left.publishedState, right.publishedState);
  if (left.type === "delete" && right.type === "editDraft")
    return [left, {
      ...right,
      type: "create",
      draftState,
      publishedState
    }];
  if (right.type === "delete") {
    if (draftState === "missing" && publishedState === "present")
      return [left, {
        ...right,
        type: "discardDraft",
        draftState,
        publishedState
      }];
    if (draftState === "present" && publishedState === "missing")
      return [left, {
        ...right,
        type: "unpublish",
        draftState,
        publishedState
      }];
  }
  if (canMergeEdit(left.type) && right.type === "editDraft" && isWithinMergeWindow$1(left.endTimestamp, right.startTimestamp)) {
    const authors = /* @__PURE__ */ new Set();
    for (const author of left.authors) authors.add(author);
    for (const author of right.authors) authors.add(author);
    return {
      index: 0,
      id: right.id,
      type: left.type,
      start: left.start,
      end: right.end,
      startTimestamp: left.startTimestamp,
      endTimestamp: right.endTimestamp,
      authors,
      draftState,
      publishedState
    };
  }
  return [left, {
    ...right,
    draftState,
    publishedState
  }];
}
function getChunkState(effect) {
  const modified = !!effect;
  return effect && isDeletePatch$1(effect?.apply) ? "deleted" : modified ? "upsert" : "unedited";
}
function getChunkType(transaction) {
  const draftState = getChunkState(transaction.draftEffect), publishedState = getChunkState(transaction.publishedEffect);
  if (publishedState === "unedited") {
    if (draftState === "deleted")
      return "delete";
    if (draftState === "upsert")
      return "editDraft";
  }
  if (publishedState === "deleted")
    return "delete";
  if (publishedState === "upsert") {
    if (draftState === "unedited")
      return "editLive";
    if (draftState === "deleted")
      return "publish";
    if (draftState === "upsert")
      return "editLive";
  }
  return "editLive";
}
function chunkFromTransaction(transaction) {
  const modifiedDraft = !!transaction.draftEffect, modifiedPublished = !!transaction.publishedEffect, draftDeleted = transaction.draftEffect && isDeletePatch$1(transaction.draftEffect.apply), publishedDeleted = transaction.publishedEffect && isDeletePatch$1(transaction.publishedEffect.apply), type = getChunkType(transaction);
  return {
    index: 0,
    id: transaction.id,
    type,
    start: transaction.index,
    end: transaction.index + 1,
    startTimestamp: transaction.timestamp,
    endTimestamp: transaction.timestamp,
    authors: /* @__PURE__ */ new Set([transaction.author]),
    draftState: modifiedDraft ? draftDeleted ? "missing" : "present" : "unknown",
    publishedState: modifiedPublished ? publishedDeleted ? "missing" : "present" : "unknown"
  };
}
function combineState(left, right) {
  return right === "unknown" ? left : right;
}
function isDeletePatch$1(patch2) {
  return patch2[0] === 0 && patch2[1] === null;
}
function isSameAnnotation(a, b) {
  return a && b ? a.author === b.author && a.timestamp === b.timestamp : !a && !b;
}
function getAttrs$1(doc) {
  return doc.draft || doc.published;
}
class ArrayContentWrapper {
  type = "array";
  elements = [];
  constructor(content, value, annotation, extractor) {
    this.content = content, this.value = value, this.annotation = annotation, this.extractor = extractor, this.length = content.elements.length;
  }
  at(idx) {
    if (idx >= this.length) throw new Error("out of bounds");
    return this.elements[idx] || (this.elements[idx] = wrapValue(this.content.elements[idx], this.value[idx], this.extractor));
  }
  annotationAt(idx) {
    const meta = this.content.metas[idx];
    return this.extractor.fromMeta(meta);
  }
}
class ObjectContentWrapper {
  type = "object";
  fields = {};
  constructor(content, value, annotation, extractor) {
    this.content = content, this.value = value, this.annotation = annotation, this.extractor = extractor, this.keys = Object.keys(content.fields);
  }
  get(key) {
    const input = this.fields[key];
    if (input)
      return input;
    const value = this.content.fields[key];
    if (value)
      return this.fields[key] = wrapValue(value, this.value[key], this.extractor);
  }
}
class StringContentWrapper {
  type = "string";
  constructor(content, value, annotation, extractor) {
    this.content = content, this.value = value, this.annotation = annotation, this.extractor = extractor;
  }
  sliceAnnotation(start, end) {
    const result = [];
    let idx = 0;
    function push(text, annotation) {
      if (result.length > 0) {
        const lst = result[result.length - 1];
        if (isSameAnnotation(lst.annotation, annotation)) {
          lst.text += text;
          return;
        }
      }
      result.push({
        text,
        annotation
      });
    }
    for (const part of this.content.parts) {
      const length = part.value.length, subStart = Math.max(0, start - idx);
      if (subStart < length) {
        const subEnd = Math.min(length, end - idx);
        if (subEnd <= 0) break;
        push(part.value.slice(subStart, subEnd), this.extractor.fromValue(part));
      }
      idx += length;
    }
    return result;
  }
}
function wrapValue(value, raw, extractor) {
  const annotation = extractor.fromValue(value);
  if (value.content)
    switch (value.content.type) {
      case "array":
        return new ArrayContentWrapper(value.content, raw, annotation, extractor);
      case "object":
        return new ObjectContentWrapper(value.content, raw, annotation, extractor);
      case "string":
        return new StringContentWrapper(value.content, raw, annotation, extractor);
    }
  return wrap$1(raw, annotation);
}
function extractAnnotationForFromInput$1(timeline, firstChunk, meta) {
  return meta ? annotationForTransactionIndex$1(timeline, meta.transactionIndex + 1, meta.chunk.index) : firstChunk ? annotationForTransactionIndex$1(timeline, firstChunk.start, firstChunk.index) : null;
}
function extractAnnotationForToInput$1(timeline, meta) {
  return meta ? annotationForTransactionIndex$1(timeline, meta.transactionIndex, meta.chunk.index) : null;
}
function annotationForTransactionIndex$1(timeline, idx, chunkIdx) {
  const tx = timeline.transactionByIndex(idx);
  if (!tx) return null;
  const chunk = timeline.chunkByTransactionIndex(idx, chunkIdx);
  return chunk ? {
    chunk,
    timestamp: tx.timestamp,
    author: tx.author
  } : null;
}
function diffValue$1(timeline, firstChunk, from2, fromRaw, to, toRaw) {
  const fromInput = wrapValue(from2, fromRaw, {
    fromValue(value) {
      return extractAnnotationForFromInput$1(timeline, firstChunk, value.endMeta);
    },
    fromMeta(meta) {
      return extractAnnotationForFromInput$1(timeline, firstChunk, meta);
    }
  }), toInput = wrapValue(to, toRaw, {
    fromValue(value) {
      return extractAnnotationForToInput$1(timeline, value.startMeta);
    },
    fromMeta(meta) {
      return extractAnnotationForToInput$1(timeline, meta);
    }
  });
  return diffInput(fromInput, toInput);
}
class TwoEndedArray {
  _postive = [];
  _negative = [];
  addToEnd(elem) {
    elem.index = this._postive.length, this._postive.push(elem);
  }
  addToBeginning(elem) {
    if (this.length == 0) {
      this.addToEnd(elem);
      return;
    }
    elem.index = -(this._negative.length + 1), this._negative.push(elem);
  }
  mergeAtEnd(value, merger) {
    if (this.length === 0) {
      this.addToEnd(value);
      return;
    }
    const idx = this.lastIdx, result = merger(this.get(idx), value);
    Array.isArray(result) ? (this.set(idx, result[0]), this.addToEnd(result[1])) : this.set(idx, result);
  }
  mergeAtBeginning(value, merger) {
    if (this.length === 0) {
      this.addToEnd(value);
      return;
    }
    const idx = this.firstIdx, result = merger(value, this.get(idx));
    Array.isArray(result) ? (this.set(idx, result[1]), this.addToBeginning(result[0])) : this.set(idx, result);
  }
  removeFromEnd() {
    this._postive.length === 0 ? this._negative.shift() : this._postive.pop();
  }
  has(idx) {
    return idx >= 0 ? idx < this._postive.length : -(idx + 1) < this._negative.length;
  }
  get(idx) {
    return idx >= 0 ? this._postive[idx] : this._negative[-(idx + 1)];
  }
  set(idx, value) {
    idx >= 0 ? (value.index = idx, this._postive[idx] = value) : (value.index = idx, this._negative[-(idx + 1)] = value);
  }
  get lastIdx() {
    return this._postive.length - 1;
  }
  get last() {
    return this.get(this.lastIdx);
  }
  get firstIdx() {
    return -this._negative.length;
  }
  get first() {
    return this.get(this.firstIdx);
  }
  get length() {
    return this._postive.length + this._negative.length;
  }
}
class Timeline {
  reachedEarliestEntry = !1;
  _transactions = new TwoEndedArray();
  _chunks = new TwoEndedArray();
  // These two properties are here to handle the case
  _possiblePendingTransactions = /* @__PURE__ */ new Map();
  constructor(opts) {
    this.publishedId = opts.publishedId, this.draftId = `drafts.${opts.publishedId}`, opts.enableTrace && (this._trace = [], this._trace.push({
      type: "initial",
      publishedId: opts.publishedId
    }), window.__sanityTimelineTrace = this._trace);
  }
  get chunkCount() {
    return this._chunks.length;
  }
  /** Maps over the chunk from newest to oldest. */
  mapChunks(mapper) {
    const result = [], firstIdx = this._chunks.firstIdx, lastIdx = this._chunks.lastIdx;
    for (let idx = lastIdx; idx >= firstIdx; idx--)
      result.push(mapper(this._chunks.get(idx), idx));
    return result;
  }
  reset() {
    this._transactions = new TwoEndedArray(), this._chunks = new TwoEndedArray(), this._possiblePendingTransactions = /* @__PURE__ */ new Map(), this._recreateTransactionsFrom = void 0, this.reachedEarliestEntry = !1;
  }
  /**
   * Adds a remote mutation to the timeline. This methods assumes that the remote mutations
   * come in correct order for their respective version, but has no ordering requirements
   * across draft/published.
   *
   * Example: [D1, D2, P1] (where D1 and P1 were mutations done to the draft and published
   * version in the same transaction) is a valid input. [P1, D2, D1] is _not_ valid since
   * the mutation for the draft is out of order.
   */
  addRemoteMutation(entry) {
    this._trace && this._trace.push({
      type: "addRemoteMutation",
      event: entry
    });
    const pending = this._possiblePendingTransactions.get(entry.transactionId), transaction = pending ? pending.transaction : {
      index: 0,
      id: entry.transactionId,
      timestamp: entry.timestamp.toISOString(),
      author: entry.author
    };
    entry.version === "draft" ? transaction.draftEffect = entry.effects : transaction.publishedEffect = entry.effects, pending ? (this._possiblePendingTransactions.delete(entry.transactionId), this._invalidateTransactionFrom(pending.idx)) : (this._transactions.addToEnd(transaction), this._possiblePendingTransactions.set(entry.transactionId, {
      transaction,
      idx: this._transactions.lastIdx
    }));
  }
  addTranslogEntry(event) {
    this._trace && this._trace.push({
      type: "addTranslogEntry",
      event
    }), this._transactions.addToBeginning({
      index: 0,
      id: event.id,
      author: event.author,
      timestamp: event.timestamp,
      draftEffect: event.effects[this.draftId],
      publishedEffect: event.effects[this.publishedId]
    });
  }
  /** Mark that we've reached the earliest entry. */
  didReachEarliestEntry() {
    this._trace && this._trace.push({
      type: "didReachEarliestEntry"
    }), this.reachedEarliestEntry = !0;
  }
  /**
   * updateChunks synchronizes the chunks to match the current state
   * of the transactions array. After calling this method you need
   * to invalidate all Chunks.
   */
  updateChunks() {
    this._trace && this._trace.push({
      type: "updateChunks"
    }), this._removeInvalidatedChunks(), this._addChunksFromTransactions(), this._createInitialChunk();
  }
  _removeInvalidatedChunks() {
    if (this._recreateTransactionsFrom) {
      for (; this._chunks.length > 0; ) {
        const chunk = this._chunks.last;
        if (this._recreateTransactionsFrom < chunk.end)
          this._chunks.removeFromEnd();
        else
          break;
      }
      this._recreateTransactionsFrom = void 0;
    }
  }
  _addChunksFromTransactions() {
    const firstIdx = this._transactions.firstIdx, lastIdx = this._transactions.lastIdx, nextTransactionToChunk = this._chunks.length > 0 ? this._chunks.last.end : firstIdx;
    for (let idx = nextTransactionToChunk; idx <= lastIdx; idx++) {
      const transaction = this._transactions.get(idx);
      this._chunks.mergeAtEnd(chunkFromTransaction(transaction), mergeChunk);
    }
    if (this._chunks.length == 0) return;
    const firstTransactionChunked = this._chunks.first.start;
    for (let idx = firstTransactionChunked - 1; idx >= firstIdx; idx--) {
      const transaction = this._transactions.get(idx);
      this._chunks.mergeAtBeginning(chunkFromTransaction(transaction), mergeChunk);
    }
  }
  _invalidateTransactionFrom(idx) {
    (this._recreateTransactionsFrom === void 0 || idx < this._recreateTransactionsFrom) && (this._recreateTransactionsFrom = idx);
  }
  _createInitialChunk() {
    if (this.reachedEarliestEntry) {
      if (this._chunks.first?.type === "initial") return;
      const firstTx = this._transactions.first;
      if (!firstTx) return;
      const initialChunk = chunkFromTransaction(firstTx);
      initialChunk.type = "initial", initialChunk.id = "@initial", initialChunk.end = initialChunk.start, this._chunks.addToBeginning(initialChunk);
    }
  }
  /**
   * Resolves a time reference.
   *
   * Note that the chunk returned is only valid if the timeline stays constant.
   * Once the timeline is updated, you must re-parse all references.
   */
  parseTimeId(id2) {
    if (this._chunks.length === 0)
      return this.reachedEarliestEntry ? "invalid" : "loading";
    const idSegments = id2.split("/", 3), timestampStr = idSegments.shift(), chunkId = idSegments.shift(), timestamp = Number(timestampStr);
    for (let idx = this._chunks.lastIdx; idx >= this._chunks.firstIdx; idx--) {
      const chunk = this._chunks.get(idx);
      if (chunk.id === chunkId)
        return chunk;
      if (Date.parse(chunk.endTimestamp) + 60 * 60 * 1e3 < timestamp)
        return "invalid";
    }
    return this.reachedEarliestEntry ? "invalid" : "loading";
  }
  findLastPublishedBefore(chunk) {
    for (let chunkIdx = chunk ? chunk.index - 1 : this._chunks.lastIdx; chunkIdx >= this._chunks.firstIdx; chunkIdx--) {
      const currentChunk = this._chunks.get(chunkIdx);
      if (currentChunk.type === "publish" || currentChunk.type === "initial")
        return currentChunk;
    }
    return this.reachedEarliestEntry ? this._chunks.first : "loading";
  }
  isLatestChunk(chunk) {
    return chunk === this._chunks.last;
  }
  // eslint-disable-next-line class-methods-use-this
  createTimeId(chunk) {
    return `${chunk.endTimestamp.valueOf()}/${chunk.id}`;
  }
  lastChunk() {
    return this._chunks.last;
  }
  transactionByIndex(idx) {
    return this._transactions.has(idx) ? this._transactions.get(idx) : null;
  }
  chunkByTransactionIndex(idx, startChunkIdx = 0) {
    let chunkIdx = startChunkIdx;
    for (; ; ) {
      const chunk = this._chunks.get(chunkIdx);
      if (!chunk) throw new Error("transaction does not belong in any chunk");
      if (idx >= chunk.end)
        chunkIdx++;
      else if (idx < chunk.start)
        chunkIdx--;
      else
        return chunk;
    }
  }
  replayBackwardsBetween(firstIdx, lastIdx, doc) {
    let draft = doc.draft, published = doc.published;
    for (let idx = lastIdx; idx >= firstIdx; idx--) {
      const transaction = this._transactions.get(idx);
      transaction.draftEffect && (draft = applyPatch$1(draft, transaction.draftEffect.revert)), transaction.publishedEffect && (published = applyPatch$1(published, transaction.publishedEffect.revert));
    }
    return {
      draft,
      published
    };
  }
  replayBackwardsUntil(firstIdx, doc) {
    return this.replayBackwardsBetween(firstIdx, this._transactions.lastIdx, doc);
  }
  calculateDiff(initialDoc, finalDoc, firstIdx, lastIdx) {
    let draftValue = incremental.wrap(initialDoc.draft, null), publishedValue = incremental.wrap(initialDoc.published, null);
    const initialValue = getValue$1(draftValue, publishedValue), initialAttributes = getAttrs$1(initialDoc);
    let firstChunk = null;
    for (let chunkIdx = firstIdx; chunkIdx <= lastIdx; chunkIdx++) {
      const chunk = this._chunks.get(chunkIdx);
      firstChunk || (firstChunk = chunk);
      for (let idx = chunk.start; idx < chunk.end; idx++) {
        const transaction = this._transactions.get(idx), meta = {
          chunk,
          transactionIndex: idx
        }, preDraftValue = draftValue, prePublishedValue = publishedValue;
        transaction.draftEffect && (draftValue = incremental.applyPatch(draftValue, transaction.draftEffect.apply, meta)), transaction.publishedEffect && (publishedValue = incremental.applyPatch(publishedValue, transaction.publishedEffect.apply, meta));
        const didHaveDriaft = incremental.getType(preDraftValue) !== "null", haveDraft = incremental.getType(draftValue) !== "null";
        incremental.getType(publishedValue) !== "null" && !haveDraft && (publishedValue = incremental.rebaseValue(preDraftValue, publishedValue)), haveDraft && !didHaveDriaft && (draftValue = incremental.rebaseValue(prePublishedValue, draftValue));
      }
    }
    const finalValue = incremental.getType(draftValue) === "null" ? publishedValue : draftValue, finalAttributes = getAttrs$1(finalDoc);
    return diffValue$1(this, firstChunk, initialValue, initialAttributes, finalValue, finalAttributes);
  }
}
function getValue$1(draftValue, publishedValue) {
  return incremental.getType(draftValue) === "null" ? publishedValue : draftValue;
}
function emptyVersionState(id2) {
  return {
    id: id2,
    hasAttrs: !1,
    attrs: null,
    rev: null,
    events: [],
    aligned: !1
  };
}
function align(history2, state) {
  const idx = state.events.findIndex((evt) => history2.id === evt.transactionId);
  return idx >= 0 ? idx + 1 : state.rev ? state.rev === history2.id ? 0 : -1 : 0;
}
function startFromSnapshot(state, doc) {
  if (state.hasAttrs = !0, doc) {
    if (state.attrs = {
      ...doc
    }, typeof state.attrs._rev != "string") throw new Error("snapshot has no _rev");
    state.rev = state.attrs._rev, delete state.attrs._rev;
  } else
    state.attrs = null, state.rev = null;
  state.events = [];
}
class Aligner {
  earliestTransactionId = null;
  constructor(timeline) {
    this.timeline = timeline, this._states = {
      draft: emptyVersionState(timeline.draftId),
      published: emptyVersionState(timeline.publishedId)
    };
  }
  appendRemoteSnapshotEvent(evt) {
    if (evt.version === "version")
      return;
    const state = this._states[evt.version];
    if (evt.type === "snapshot") {
      this._maybeInvalidateHistory(), startFromSnapshot(state, evt.document);
      return;
    }
    evt.type === "remoteMutation" && (state.aligned ? (this._apply(state, evt), this.timeline.addRemoteMutation(evt)) : state.hasAttrs ? state.events.push(evt) : startFromSnapshot(state, evt.head));
  }
  prependHistoryEvent(evt) {
    if (!this.acceptsHistory) throw new Error("cannot prepend history at this point");
    for (const state of Object.values(this._states))
      if (!state.aligned) {
        const idx = align(evt, state);
        idx >= 0 && this._alignAtIndex(state, idx);
      }
    this.timeline.addTranslogEntry(evt), this.earliestTransactionId = evt.id;
  }
  didReachEarliestEntry() {
    for (const state of Object.values(this._states))
      if (!state.aligned) {
        if (state.attrs !== null) throw new Error("unable to find translog entry to align to");
        this._alignAtIndex(state, 0);
      }
    this.timeline.didReachEarliestEntry();
  }
  get isAligned() {
    return Object.values(this._states).every((state) => state.aligned);
  }
  get acceptsHistory() {
    return this._isComplete;
  }
  get currentDocument() {
    return {
      draft: this._states.draft.attrs,
      published: this._states.published.attrs
    };
  }
  _alignAtIndex(state, idx) {
    for (const mutEvt of state.events.slice(0, idx))
      this._apply(state, mutEvt);
    for (const mutEvt of state.events.slice(idx))
      this._apply(state, mutEvt), this.timeline.addRemoteMutation(mutEvt);
    state.events = [], state.aligned = !0;
  }
  get _isComplete() {
    return Object.values(this._states).every((state) => state.hasAttrs);
  }
  // eslint-disable-next-line class-methods-use-this
  _apply(state, evt) {
    state.attrs = applyPatch$1(state.attrs, evt.effects.apply), state.rev = evt.transactionId;
  }
  _maybeInvalidateHistory() {
    if (this._isComplete) {
      for (const state of Object.values(this._states))
        state.aligned = !1;
      this.earliestTransactionId = null, this.timeline.reset();
    }
  }
}
class Reconstruction {
  constructor(timeline, doc, start, end) {
    this.timeline = timeline, this.start = start, this.end = end, this.doc = doc;
  }
  same(start, end) {
    return this.start === start && this.end === end;
  }
  /** Returns the attributes as seen at the end of the range. */
  endAttributes() {
    return getAttrs(this.endDocument());
  }
  endDocument() {
    return this._endDocument || (this._endDocument = this.timeline.replayBackwardsUntil(this.end.end, this.doc)), this._endDocument;
  }
  /** Returns the attributes as seen at the end of the range. */
  startAttributes() {
    return getAttrs(this.startDocument());
  }
  startDocument() {
    if (!this.start) throw new Error("start required");
    return this._startDocument || (this._startDocument = this.timeline.replayBackwardsBetween(this.start.end, this.end.end - 1, this.endDocument())), this._startDocument;
  }
  diff() {
    if (!this._diff) {
      if (!this.start) throw new Error("start required");
      this._diff = this.timeline.calculateDiff(this.startDocument(), this.endDocument(), this.start.index + 1, this.end.index);
    }
    return this._diff;
  }
}
function getAttrs(doc) {
  return doc.draft || doc.published;
}
const TRANSLOG_ENTRY_LIMIT$1 = 50;
class TimelineController {
  version = 0;
  /**
   * The selection state represents the  different states of the current selection:
   * - inactive: No selection is active.
   * - rev: A selection is active for a single revision.
   * - range: A selection is active for a range and we have all the data needed to render it.
   * - loading: A selection is active, but we don't have the entries yet.
   * - invalid: The selection picked is invalid.
   */
  selectionState = "inactive";
  constructor(options) {
    this.timeline = options.timeline, this.client = options.client, this.handler = options.handler, this._aligner = new Aligner(this.timeline), this.markChange();
  }
  _fetchMore = !1;
  _fetchAtLeast = 0;
  _isRunning = !1;
  _isSuspended = !1;
  _didErr = !1;
  _since = null;
  _sinceTime = null;
  _rev = null;
  _revTime = null;
  clearRange() {
    this.setRange(null, null);
  }
  setRange(since, rev) {
    rev !== this._rev && this.setRevTime(rev), since !== this._since && this.setSinceTime(since);
    let _fetchAtLeast = 10;
    if (this._sinceTime === "loading" || this._revTime === "loading" || !this._aligner.isAligned)
      this.selectionState = "loading";
    else if (this._sinceTime === "invalid" || this._revTime === "invalid")
      this.selectionState = "invalid";
    else if (this._sinceTime) {
      this.selectionState = "range";
      const targetRev = this._revTime || this.timeline.lastChunk();
      this._sinceTime.index > targetRev.index ? (this._revTime = "invalid", this.selectionState = "invalid") : this.setReconstruction(this._sinceTime, targetRev);
    } else this._revTime ? (this.selectionState = "rev", this.setReconstruction(null, this._revTime)) : (this.selectionState = "inactive", _fetchAtLeast = 0);
    this._fetchAtLeast = _fetchAtLeast, this.start();
  }
  setLoadMore(flag) {
    this._fetchMore = flag, this.start();
  }
  get sinceTime() {
    return this._sinceTime && typeof this._sinceTime == "object" ? this._sinceTime : null;
  }
  get revTime() {
    return this._revTime && typeof this._revTime == "object" ? this._revTime : null;
  }
  get isLoading() {
    return this._isRunning;
  }
  get realRevChunk() {
    return this.revTime || this.timeline.lastChunk();
  }
  /** Returns true when there's an older revision we want to render. */
  onOlderRevision() {
    return !!this._rev && (this.selectionState === "range" || this.selectionState === "rev");
  }
  findRangeForNewRev(rev) {
    const revTimeId = this.timeline.isLatestChunk(rev) ? null : this.timeline.createTimeId(rev);
    if (!this._since)
      return [null, revTimeId];
    const sinceChunk = this.sinceTime;
    return sinceChunk && sinceChunk.index < rev.index ? [this._since, revTimeId] : ["@lastPublished", revTimeId];
  }
  findRangeForNewSince(since) {
    const revChunk = this.revTime;
    return revChunk && since.index < revChunk.index ? [this.timeline.createTimeId(since), this._rev] : [this.timeline.createTimeId(since), null];
  }
  setRevTime(rev) {
    this._rev = rev, this._revTime = rev ? this.timeline.parseTimeId(rev) : null, this._since === "@lastPublished" && (this._since = null, this._sinceTime = null);
  }
  setSinceTime(since) {
    since === "@lastPublished" ? typeof this._revTime == "string" ? this._sinceTime = this._revTime : this._sinceTime = this.timeline.findLastPublishedBefore(this._revTime) : this._sinceTime = since ? this.timeline.parseTimeId(since) : null, this._since = since;
  }
  sinceAttributes() {
    return this._sinceTime && this._reconstruction ? this._reconstruction.startAttributes() : null;
  }
  displayed() {
    return this._revTime && this._reconstruction ? this._reconstruction.endAttributes() : null;
  }
  setReconstruction(since, rev) {
    this._reconstruction && this._reconstruction.same(since, rev) || (this._reconstruction = new Reconstruction(this.timeline, this._aligner.currentDocument, since, rev));
  }
  currentDiff() {
    return this._reconstruction ? this._reconstruction.diff() : null;
  }
  currentObjectDiff() {
    const diff = this.currentDiff();
    if (diff) {
      if (diff.type === "null") return null;
      if (diff.type !== "object") throw new Error(`ObjectDiff expected, got ${diff.type}`);
    }
    return diff;
  }
  handleRemoteMutation(ev) {
    this._aligner.appendRemoteSnapshotEvent(ev), this.markChange(), this._aligner.acceptsHistory && this.start();
  }
  start() {
    this._didErr || this._isRunning || (this._isRunning = !0, this.tick().then(() => {
      this._isRunning = !1;
    }));
  }
  resume() {
    this._isSuspended = !1;
  }
  suspend() {
    this._isSuspended = !0;
  }
  async tick() {
    if (!(this._aligner.acceptsHistory && !this.timeline.reachedEarliestEntry && (this.selectionState === "loading" || this._fetchMore || this.timeline.chunkCount <= this._fetchAtLeast) && !this._isSuspended)) {
      this._isRunning = !1;
      return;
    }
    try {
      await this.fetchMoreTransactions();
    } catch (err) {
      this._didErr = !0, this.handler?.(err, this);
      return;
    }
    await this.tick();
  }
  async fetchMoreTransactions() {
    const publishedId = this.timeline.publishedId, draftId = this.timeline.draftId, clientConfig = this.client.config(), limit2 = TRANSLOG_ENTRY_LIMIT$1;
    let queryParams = `tag=sanity.studio.structure.history&effectFormat=mendoza&excludeContent=true&excludeMutations=true&includeIdentifiedDocumentsOnly=true&reverse=true&limit=${limit2}`, tid = this._aligner.earliestTransactionId;
    tid && (queryParams += `&toTransaction=${tid}`);
    const transactionsUrl = this.client.getUrl(`/data/history/${clientConfig.dataset}/transactions/${publishedId},${draftId}?${queryParams}`), reader = (await getJsonStream(transactionsUrl, clientConfig.token)).getReader();
    let count2 = 0;
    for (; ; ) {
      const result = await reader.read();
      if (result.done) break;
      if ("error" in result.value)
        throw new Error(result.value.error.description || result.value.error.type);
      if (count2++, result.value.id !== tid) {
        if (this._aligner.earliestTransactionId !== tid || !this._aligner.acceptsHistory)
          return;
        this._aligner.prependHistoryEvent(result.value), tid = this._aligner.earliestTransactionId;
      }
    }
    this._aligner.earliestTransactionId !== tid || !this._aligner.acceptsHistory || (count2 < limit2 && this._aligner.didReachEarliestEntry(), this.markChange());
  }
  markChange() {
    this.timeline.updateChunks(), this.setRevTime(this._rev), this.setSinceTime(this._rev), this.version++, this.handler?.(null, this);
  }
}
const documentRevisionCache$1 = /* @__PURE__ */ Object.create(null), getHistory = (client, documentIds, options = {}) => {
  const ids = Array.isArray(documentIds) ? documentIds : [documentIds], {
    time,
    revision
  } = options;
  if (time && revision)
    throw new Error("getHistory can't handle both time and revision parameters");
  let url = `/data/history/${client.config().dataset}/documents/${ids.join(",")}`;
  if (revision)
    url = `${url}?revision=${revision}`;
  else {
    const timestamp = time || (/* @__PURE__ */ new Date()).toISOString();
    url = `${url}?time=${timestamp}`;
  }
  return client.request({
    url
  });
}, getDocumentAtRevision$1 = (client, documentId, revision) => {
  const publishedId = getPublishedId(documentId), draftId = getDraftId(documentId), cacheKey = `${publishedId}@${revision}`, cached = documentRevisionCache$1[cacheKey];
  if (cached)
    return cached;
  const url = `/data/history/${client.config().dataset}/documents/${publishedId},${draftId}?revision=${revision}`, entry = client.request({
    url
  }).then((result) => {
    const documents = result.documents || [], published = documents.find((res) => res._id === publishedId);
    return documents.find((res) => res._id === draftId) || published;
  });
  return documentRevisionCache$1[cacheKey] = entry, entry;
}, getTimelineController = ({
  client,
  documentId,
  documentType
}) => {
  const timeline = new Timeline({
    enableTrace: isDev,
    publishedId: documentId
  });
  return new TimelineController({
    client,
    documentId,
    documentType,
    timeline
  });
}, getTransactions = async (client, documentIds) => {
  const ids = Array.isArray(documentIds) ? documentIds : [documentIds], dataset = client.config().dataset, query = {
    excludeContent: "true",
    includeIdentifiedDocumentsOnly: "true"
  }, url = `/data/history/${dataset}/transactions/${ids.join(",")}`;
  return (await client.request({
    url,
    query
  })).toString("utf8").split(`
`).filter(Boolean).map((line) => JSON.parse(line));
}, getAllRefIds = (doc) => reduce(doc, (acc, node) => isReference$1(node) && !acc.includes(node._ref) ? [...acc, node._ref] : acc, []);
function jsonMap(value, mapFn) {
  return Array.isArray(value) ? mapFn(value.map((item) => jsonMap(item, mapFn)).filter((item) => typeof item < "u")) : isRecord$4(value) ? mapFn(Object.keys(value).reduce((res, key) => {
    const mappedValue = jsonMap(value[key], mapFn);
    return typeof mappedValue < "u" && (res[key] = mappedValue), res;
  }, {})) : mapFn(value);
}
const mapRefNodes = (doc, mapFn) => jsonMap(doc, (node) => isReference$1(node) ? mapFn(node) : node), removeMissingReferences = (doc, existingIds) => mapRefNodes(doc, (refNode) => existingIds[refNode._ref] ? refNode : void 0);
function restore(client, documentId, targetDocumentId, rev, options) {
  return from(getDocumentAtRevision$1(client, documentId, rev)).pipe(mergeMap((documentAtRevision) => {
    if (!documentAtRevision)
      throw new Error(`Unable to find document with ID ${documentId} at revision ${rev}`);
    const existingIdsQuery = getAllRefIds(documentAtRevision).map((refId) => `"${refId}": defined(*[_id=="${refId}"]._id)`).join(",");
    return client.observable.fetch(`{${existingIdsQuery}}`).pipe(map((existingIds) => removeMissingReferences(documentAtRevision, existingIds)));
  }), map((documentAtRevision) => {
    const {
      _updatedAt,
      ...document2
    } = documentAtRevision;
    return {
      ...document2,
      _id: targetDocumentId
    };
  }), mergeMap((restoredDraft) => {
    if (options?.useServerDocumentActions) {
      const replaceDraftAction = {
        actionType: "sanity.action.document.replaceDraft",
        publishedId: documentId,
        attributes: restoredDraft
      };
      return actionsApiClient(client, getIdPair(documentId, {
        version: getVersionFromId(documentId)
      })).observable.action(options.fromDeleted ? [{
        actionType: "sanity.action.document.create",
        publishedId: documentId,
        attributes: restoredDraft,
        // This will guard against a race where someone else restores a deleted document at the same time
        ifExists: "fail"
      }, replaceDraftAction] : replaceDraftAction);
    }
    return client.observable.createOrReplace(restoredDraft, {
      visibility: "async"
    });
  }), map(() => {
  }));
}
function createHistoryStore({
  client
}) {
  return {
    getDocumentAtRevision: (documentId, revision) => getDocumentAtRevision$1(client, documentId, revision),
    getHistory: (documentIds, options) => getHistory(client, documentIds, options),
    getTransactions: (documentIds) => getTransactions(client, documentIds),
    restore: (id2, targetId, rev, options) => restore(client, id2, targetId, rev, options),
    getTimelineController
  };
}
function useTimelineSelector(timelineStore, selector) {
  if (!timelineStore)
    throw new Error("Passed timelineStore is undefined, if your are using the events timeline, call useEvents() instead. If you need to use this hook, opt in by setting the beta.eventsAPI.enabled feature flag to false");
  return useSyncExternalStoreWithSelector(timelineStore.subscribe, timelineStore.getSnapshot, null, selector);
}
const INITIAL_TIMELINE_STATE = {
  chunks: [],
  diff: null,
  hasMoreChunks: null,
  isLoading: !1,
  isPristine: null,
  lastNonDeletedRevId: null,
  onOlderRevision: !1,
  realRevChunk: null,
  revTime: null,
  selectionState: "inactive",
  sinceAttributes: null,
  sinceTime: null,
  timelineDisplayed: null,
  timelineReady: !1
};
function useTimelineStore({
  documentId,
  documentType,
  onError,
  rev,
  since
}) {
  const historyStore = useHistoryStore(), snapshotsSubscriptionRef = useRef(null), timelineStateRef = useRef(INITIAL_TIMELINE_STATE), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), workspace = useWorkspace(), controller = useMemo(() => historyStore.getTimelineController({
    client,
    documentId,
    documentType
  }), [client, documentId, documentType, historyStore]), timelineController$ = useMemo(() => new BehaviorSubject(controller), [controller]);
  useEffect(() => (controller.setRange(since || null, rev || null), timelineController$.next(controller), controller.handler = (err, innerController) => {
    err ? timelineController$.error(err) : setTimeout(() => {
      innerController.setRange(since || null, rev || null), timelineController$.next(innerController);
    }, 0);
  }, controller.resume(), () => controller.suspend()), [rev, since, controller, timelineController$]);
  const serverActionsEnabled = useMemo(() => {
    const configFlag = workspace.__internal_serverDocumentActions?.enabled;
    return typeof configFlag == "boolean" ? of(configFlag) : of(!0);
  }, [workspace.__internal_serverDocumentActions?.enabled]);
  return useEffect(() => (snapshotsSubscriptionRef.current || (snapshotsSubscriptionRef.current = remoteSnapshots(client, {
    draftId: `drafts.${documentId}`,
    publishedId: documentId
  }, documentType, serverActionsEnabled).subscribe((ev) => {
    controller.handleRemoteMutation(ev);
  })), () => {
    snapshotsSubscriptionRef.current && (snapshotsSubscriptionRef.current.unsubscribe(), snapshotsSubscriptionRef.current = null);
  }), [client, controller, documentId, documentType, serverActionsEnabled]), useMemo(() => ({
    findRangeForRev: (chunk) => controller.findRangeForNewRev(chunk),
    findRangeForSince: (chunk_0) => controller.findRangeForNewSince(chunk_0),
    loadMore: () => {
      controller.setLoadMore(!0);
    },
    getSnapshot: () => timelineStateRef.current,
    subscribe: (callback) => {
      const subscription = timelineController$.pipe(
        map$1((innerController_0) => {
          const chunks = innerController_0.timeline.mapChunks((c2) => c2), lastNonDeletedChunk = chunks.filter((chunk_1) => !["delete", "initial"].includes(chunk_1.type)), hasMoreChunks = !innerController_0.timeline.reachedEarliestEntry;
          hasMoreChunks && chunks.length > 16 && innerController_0.setLoadMore(!1);
          const timelineReady = !["invalid", "loading"].includes(innerController_0.selectionState);
          return {
            chunks,
            diff: innerController_0.sinceTime ? innerController_0.currentObjectDiff() : null,
            isLoading: innerController_0.isLoading,
            isPristine: timelineReady ? chunks.length === 0 && hasMoreChunks === !1 : null,
            hasMoreChunks: !innerController_0.timeline.reachedEarliestEntry,
            lastNonDeletedRevId: lastNonDeletedChunk?.[0]?.id,
            onOlderRevision: innerController_0.onOlderRevision(),
            realRevChunk: innerController_0.realRevChunk,
            revTime: innerController_0.revTime,
            selectionState: innerController_0.selectionState,
            sinceAttributes: innerController_0.sinceAttributes(),
            sinceTime: innerController_0.sinceTime,
            timelineDisplayed: innerController_0.displayed(),
            timelineReady
          };
        }),
        // Only emit (and in turn, re-render) when values have changed
        distinctUntilChanged$1(deepEquals),
        // Emit initial timeline state whenever we encounter an error in TimelineController's `handler` callback.
        // A little ham-fisted, but also reflects how we handle timeline errors in the UI
        // (i.e. no timeline state or diffs are rendered and we revert to the current editable document)
        catchError$1((err_0) => (onError?.(err_0), of(INITIAL_TIMELINE_STATE))),
        tap$1((timelineState) => {
          timelineStateRef.current = timelineState;
        }),
        // Trigger callback function required by `useSyncExternalStore` to denote when to re-render
        tap$1(callback)
      ).subscribe();
      return () => subscription.unsubscribe();
    }
  }), [controller, onError, timelineController$]);
}
const handleIncomingMessage = (event) => {
  if (event.type === "rollCall")
    return {
      type: "rollCall",
      userId: event.i,
      sessionId: event.session
    };
  if (event.type === "state") {
    const {
      sessionId: sessionId2,
      locations
    } = event.m;
    return {
      type: "state",
      userId: event.i,
      sessionId: sessionId2,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      locations
    };
  }
  if (event.type === "disconnect")
    return {
      type: "disconnect",
      userId: event.i,
      sessionId: event.m.session,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
  throw new Error(`Got unknown presence event: ${JSON.stringify(event)}`);
}, createBifurTransport = (bifur, sessionId2) => {
  const incomingEvents$ = bifur.listen("presence").pipe(map(handleIncomingMessage)), dispatchMessage = (message) => message.type === "rollCall" ? bifur.request("presence_rollcall", {
    session: sessionId2
  }) : message.type === "state" ? bifur.request("presence_announce", {
    data: {
      locations: message.locations,
      sessionId: sessionId2
    }
  }) : message.type === "disconnect" ? bifur.request("presence_disconnect", {
    session: sessionId2
  }) : EMPTY$6;
  return [incomingEvents$.pipe(share()), dispatchMessage];
}, USERIDS = [
  "pqSMwf6hH",
  "pnLYqNfv5",
  "priDVVmy8",
  "p0NFOU0j8",
  "pTDl2jw8d",
  "pHMeQnTse",
  "pDQYzJbyS",
  "pZyoPHKUs",
  "p4Tyi2Be5",
  "pb9vii060",
  "pE8yhOisw",
  "p7Fd2C6Cj",
  "p3exSgYCx",
  "pbIQRYViC",
  "p8GJaTEhN",
  "p27ewL8aM",
  "pYg97z75S",
  "pdLr4quHv",
  "pkJXiDgg6",
  "pkl4UAKcA",
  // Included to ensure we handle the case when a user profile cannot
  // be fetched due to insufficient privileges or similar
  "pNoExists"
], PATHS = [["nested", "first"], ["nested", "second"], ["nestedArray", {
  _key: "565c867c8dac"
}, "arrayNo1", {
  _key: "a645548a8f01"
}, "arrayNo1", {
  _key: "1685e372c40f"
}, "fieldNo0"], ["nestedArray", {
  _key: "565c867c8dac"
}, "fieldNo0"], ["nestedArray", {
  _key: "565c867c8dac"
}, "arrayNo19", {
  _key: "a02e7a93e2a2"
}, "fieldNo0"], ["nestedArray", {
  _key: "565c867c8dac"
}, "arrayNo19", {
  _key: "a02e7a93e2a2"
}, "fieldNo19"], ["address", "country"], ["address", "street"], ["customInputWithDefaultPresence", "row3", "cell3"]], mock$ = defer(() => timer(0, 1e4)).pipe(mergeMapTo(USERIDS), map((id2, n) => ({
  type: "state",
  userId: id2,
  sessionId: id2 + n,
  timestamp: (/* @__PURE__ */ new Date()).toISOString(),
  locations: [{
    type: "document",
    documentId: "presence-debug",
    lastActiveAt: (/* @__PURE__ */ new Date()).toISOString(),
    path: sample(PATHS)
  }]
})), shareReplay()), KEY$1 = "presence_session_id", generate = () => nanoid(16);
function getSessionId() {
  try {
    return window.sessionStorage.getItem(KEY$1);
  } catch {
  }
  return null;
}
function setSessionId(id2) {
  try {
    window.sessionStorage.setItem(KEY$1, id2);
  } catch {
  }
  return id2;
}
const SESSION_ID = getSessionId() || setSessionId(generate());
function createPresenceStore(context) {
  const {
    bifur,
    connectionStatusStore,
    userStore
  } = context, [presenceEvents$, sendMessage] = createBifurTransport(bifur, SESSION_ID), currentLocation$ = new BehaviorSubject([]), locationChange$ = currentLocation$.pipe(distinctUntilChanged()), setLocation = (nextLocation) => {
    currentLocation$.next(nextLocation);
  }, reportLocations = (locations) => sendMessage({
    type: "state",
    locations
  }), requestRollCall = () => sendMessage({
    type: "rollCall"
  }), rollCallRequests$ = presenceEvents$.pipe(
    filter((event) => event.type === "rollCall"),
    // do not respond to my own rollcall requests
    filter((event) => event.sessionId !== SESSION_ID)
  ), reportLocationInterval$ = timer(0, 3e4), reportLocation$ = defer(() => merge(locationChange$, rollCallRequests$)).pipe(switchMap(() => reportLocationInterval$), withLatestFrom(currentLocation$), map(([, locations]) => locations), auditTime(200), switchMap((locations) => reportLocations(locations)), mergeMapTo(EMPTY$6), share()), myRollCall$ = defer(() => requestRollCall()).pipe(mergeMapTo(EMPTY$6)), connectionChange$ = connectionStatusStore.connectionStatus$.pipe(map((status) => status.type), filter((statusType) => statusType === "connected" || statusType === "error"), distinctUntilChanged()), debugPresenceParam$ = debugParams$.pipe(map((args) => args.find((arg) => arg.startsWith("presence="))), map((arg) => arg?.split("presence=")[1].split(",").map((r) => r.trim()) || [])), useMock$ = debugPresenceParam$.pipe(filter((args) => args.includes("fake_others")), tap(() => {
    console.log('Faking other users present in the studio. They will hang out in the document with _type: "presence" and _id: "presence-debug"');
  }), switchMapTo(mock$)), debugIntrospect$ = debugPresenceParam$.pipe(map((args) => args.includes("show_own"))), syncEvent$ = merge(myRollCall$, presenceEvents$).pipe(filter((event) => event.type === "state" || event.type === "disconnect")), stateEventToSession = (stateEvent) => ({
    lastActiveAt: stateEvent.timestamp,
    locations: stateEvent.locations,
    sessionId: stateEvent.sessionId,
    userId: stateEvent.userId
  }), states$ = merge(syncEvent$, useMock$).pipe(scan((keyed, event) => event.type === "disconnect" ? omit(keyed, event.sessionId) : {
    ...keyed,
    [event.sessionId]: stateEventToSession(event)
  }, {})), allSessions$ = connectionChange$.pipe(switchMap((status) => status === "connected" ? merge(states$, reportLocation$) : NEVER), map((keyedSessions) => Object.values(keyedSessions)), switchMap((sessions) => {
    const userIds = uniq(sessions.map((sess) => sess.userId));
    return from(userStore.getUsers(userIds)).pipe(map((users) => sessions.map((session) => ({
      // eslint-disable-next-line max-nested-callbacks
      user: users.find((res) => res.id === session.userId),
      session
    })).filter(userSessionPairHasUser)));
  }), takeUntil(fromEvent(window, "beforeunload").pipe(switchMap(() => sendMessage({
    type: "disconnect"
  })))), shareReplay({
    refCount: !0,
    bufferSize: 1
  }));
  function userSessionPairHasUser(pair) {
    return !!(pair.user && pair.session);
  }
  const globalPresence$ = allSessions$.pipe(map((sessions) => {
    const grouped = groupBy(sessions.map((s) => s.session), (e) => e.userId);
    return Object.keys(grouped).map((userId) => ({
      user: sessions.find((s) => s.user.id === userId)?.user,
      sessions: grouped[userId]
    }));
  }), withLatestFrom(debugIntrospect$), map(([userAndSessions, debugIntrospect]) => userAndSessions), map((userAndSessions) => userAndSessions.map((userAndSession) => ({
    user: userAndSession.user,
    status: "online",
    lastActiveAt: userAndSession.sessions.sort()[0]?.lastActiveAt,
    locations: flatten$1((userAndSession.sessions || []).map((session) => session.locations || [])).map((location2) => ({
      type: location2.type,
      documentId: location2.documentId,
      path: location2.path,
      lastActiveAt: location2.lastActiveAt
    })).reduce((prev, curr) => prev.concat(curr), [])
  })))), allDocumentsPresence$ = combineLatest([allSessions$, debugIntrospect$]).pipe(map(([userAndSessions, debugIntrospect]) => userAndSessions.flatMap((userAndSession) => (userAndSession.session.locations || []).map((location2) => ({
    documentId: location2.documentId,
    presence: {
      user: userAndSession.user,
      lastActiveAt: userAndSession.session.lastActiveAt,
      path: location2.path || [],
      sessionId: userAndSession.session.sessionId,
      selection: location2?.selection
    }
  }))).filter((item) => debugIntrospect || item.presence.sessionId !== SESSION_ID)), shareReplay(1));
  return {
    setLocation,
    reportLocations,
    debugPresenceParam$,
    globalPresence$,
    documentPresence: (documentId, options) => allDocumentsPresence$.pipe(
      map((allPresence) => allPresence.filter((item) => options?.excludeVersions ? item.documentId === documentId : documentIdEquals(item.documentId, documentId)).map((item) => ({
        ...item.presence,
        //documentId: getPublishedId(item.documentId),
        documentId: item.documentId
      }))),
      // Only emit if the presence has changed for this document id
      distinctUntilChanged((prev, curr) => isEqual$2(prev, curr))
    )
  };
}
const REFETCH_INTERVAL = 5 * 60 * 1e3, getOrganizationId = memoize((client) => client.observable.request({
  url: `/projects/${client.config().projectId}`,
  tag: "get-org-id",
  query: {
    includeMembers: "false",
    includeFeatures: "false",
    includeOrganization: "true"
  }
}).pipe(map$1((res) => res.organizationId), repeat({
  delay: REFETCH_INTERVAL
}), shareReplay$1(1), catchError$1(() => of(null))), (client) => `${client.config().projectId}-${client.config().dataset}`);
function createProjectStore(context) {
  const {
    client
  } = context, projectId = client.config().projectId, versionedClient2 = client.withConfig({
    apiVersion: "2021-12-15"
  });
  function get2() {
    return versionedClient2.observable.request({
      url: `/projects/${projectId}`
    });
  }
  function getDatasets() {
    return versionedClient2.observable.request({
      url: `/projects/${projectId}/datasets`
    });
  }
  return {
    get: get2,
    getDatasets,
    getOrganizationId: () => getOrganizationId(versionedClient2)
  };
}
function useProject() {
  const $ = c(5), projectStore = useProjectStore(), [value, setValue] = useState(null);
  let t0, t1;
  $[0] !== projectStore ? (t0 = () => {
    const sub2 = projectStore.get().subscribe(setValue);
    return () => sub2.unsubscribe();
  }, t1 = [projectStore], $[0] = projectStore, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== value ? (t2 = {
    value
  }, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
function useProjectDatasets() {
  const $ = c(5), projectStore = useProjectStore(), [value, setValue] = useState(null);
  let t0, t1;
  $[0] !== projectStore ? (t0 = () => {
    const sub2 = projectStore.getDatasets().subscribe(setValue);
    return () => sub2.unsubscribe();
  }, t1 = [projectStore], $[0] = projectStore, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== value ? (t2 = {
    value
  }, $[3] = value, $[4] = t2) : t2 = $[4], t2;
}
const INTERNAL_USER_IDS = [{
  id: "<system>",
  displayName: "Sanity",
  imageUrl: "https://public.sanity.io/logos/favicon-192.png"
}];
function createUserStore({
  client: _client,
  currentUser
}) {
  const client = _client.withConfig({
    apiVersion: "2021-06-07"
  }), userLoader = new DataLoader(async (userIds) => {
    const value = await client.request({
      uri: `/users/${userIds.join(",")}`,
      tag: "users.get"
    }), users = (Array.isArray(value) ? value : [value]).reduce((acc, next) => (next?.id && (acc[next.id] = next), acc), {});
    return userIds.map((id2) => users[id2] || null);
  }, {
    batchScheduleFn: (cb) => raf(cb),
    /**
     * User IDs are generally 9 bytes long, but external user IDs may be longer.
     * In order to keep the HTTP header size below ~8KB, we limit the batch size.
     * ~4kB for user IDs in paths should allow for plenty of headers, if need be.
     */
    maxBatchSize: 400
  }), userFromCurrentUser = currentUser && {
    id: currentUser.id,
    displayName: currentUser.name,
    imageUrl: currentUser.profileImage
  };
  return userLoader.prime("me", userFromCurrentUser), userFromCurrentUser?.id && userLoader.prime(userFromCurrentUser.id, userFromCurrentUser), INTERNAL_USER_IDS.forEach((user) => userLoader.prime(user.id, user)), {
    getUser: async (userId) => {
      if (!userId) return Promise.resolve(null);
      try {
        return await userLoader.load(userId);
      } catch (err) {
        if (err.statusCode === 403)
          return Promise.resolve(null);
        throw err;
      }
    },
    getUsers: async (userIds) => (await userLoader.loadMany(userIds)).filter((result) => isRecord$4(result) && typeof result.id == "string")
  };
}
const IGNORE_LATENCY_BELOW_MS = 1e3;
function useUserStore() {
  const {
    getClient: getClient2,
    currentUser
  } = useSource(), resourceCache = useResourceCache(), client = getClient2(DEFAULT_STUDIO_CLIENT_OPTIONS);
  return useMemo(() => {
    const userStore = resourceCache.get({
      namespace: "userStore",
      dependencies: [client, currentUser]
    }) || createUserStore({
      client,
      currentUser
    });
    return resourceCache.set({
      namespace: "userStore",
      dependencies: [client, currentUser],
      value: userStore
    }), userStore;
  }, [client, currentUser, resourceCache]);
}
function useGrantsStore() {
  const {
    getClient: getClient2
  } = useSource(), client = getClient2(DEFAULT_STUDIO_CLIENT_OPTIONS), currentUser = useCurrentUser(), resourceCache = useResourceCache();
  return useMemo(() => {
    const grantsStore = resourceCache.get({
      namespace: "grantsStore",
      dependencies: [client, currentUser]
    }) || createGrantsStore({
      client,
      userId: currentUser?.id || null
    });
    return resourceCache.set({
      namespace: "grantsStore",
      dependencies: [client, currentUser],
      value: grantsStore
    }), grantsStore;
  }, [client, currentUser, resourceCache]);
}
function useHistoryStore() {
  const $ = c(3), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), resourceCache = useResourceCache();
  let t0, historyStore;
  return $[0] !== client || $[1] !== resourceCache ? (historyStore = resourceCache.get({
    namespace: "historyStore",
    dependencies: [client]
  }) || createHistoryStore({
    client
  }), resourceCache.set({
    namespace: "historyStore",
    dependencies: [client],
    value: historyStore
  }), $[0] = client, $[1] = resourceCache, $[2] = historyStore) : historyStore = $[2], t0 = historyStore, t0;
}
function useDocumentPreviewStore() {
  const $ = c(3), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), resourceCache = useResourceCache();
  let t0, documentPreviewStore;
  return $[0] !== client || $[1] !== resourceCache ? (documentPreviewStore = resourceCache.get({
    namespace: "documentPreviewStore",
    dependencies: [client]
  }) || createDocumentPreviewStore({
    client
  }), resourceCache.set({
    namespace: "documentPreviewStore",
    dependencies: [client],
    value: documentPreviewStore
  }), $[0] = client, $[1] = resourceCache, $[2] = documentPreviewStore) : documentPreviewStore = $[2], t0 = documentPreviewStore, t0;
}
function useDocumentStore() {
  const {
    getClient: getClient2,
    i18n
  } = useSource(), schema2 = useSchema(), templates = useTemplates(), resourceCache = useResourceCache(), historyStore = useHistoryStore(), documentPreviewStore = useDocumentPreviewStore(), workspace = useWorkspace(), serverActionsEnabled = useMemo(() => {
    const configFlag = workspace.__internal_serverDocumentActions?.enabled;
    return typeof configFlag == "boolean" ? of(configFlag) : of(!0);
  }, [workspace.__internal_serverDocumentActions?.enabled]), telemetry = useTelemetry(), handleSyncErrorRecovery = useCallback((error) => {
    telemetry.log(DocumentDesynced, {
      errorName: error.name
    });
  }, [telemetry]), handleReportLatency = useCallback((event) => {
    event.latencyMs > IGNORE_LATENCY_BELOW_MS && telemetry.log(HighListenerLatencyOccurred, {
      latency: event.latencyMs,
      shard: event.shard,
      transactionId: event.transactionId
    });
  }, [telemetry]);
  return useMemo(() => {
    const documentStore = resourceCache.get({
      namespace: "documentStore",
      dependencies: [getClient2, documentPreviewStore, historyStore, schema2, i18n, workspace]
    }) || createDocumentStore({
      getClient: getClient2,
      documentPreviewStore,
      historyStore,
      initialValueTemplates: templates,
      schema: schema2,
      i18n,
      serverActionsEnabled,
      extraOptions: {
        onReportLatency: handleReportLatency,
        onSyncErrorRecovery: handleSyncErrorRecovery
      }
    });
    return resourceCache.set({
      namespace: "documentStore",
      dependencies: [getClient2, documentPreviewStore, historyStore, schema2, i18n, workspace],
      value: documentStore
    }), documentStore;
  }, [resourceCache, getClient2, documentPreviewStore, historyStore, schema2, i18n, workspace, templates, serverActionsEnabled, handleReportLatency, handleSyncErrorRecovery]);
}
function useConnectionStatusStore() {
  const $ = c(3), {
    bifur
  } = useSource().__internal, resourceCache = useResourceCache();
  let t0, connectionStatusStore;
  return $[0] !== bifur || $[1] !== resourceCache ? (connectionStatusStore = resourceCache.get({
    namespace: "connectionStatusStore",
    dependencies: [bifur]
  }) || createConnectionStatusStore({
    bifur
  }), resourceCache.set({
    namespace: "connectionStatusStore",
    dependencies: [bifur],
    value: connectionStatusStore
  }), $[0] = bifur, $[1] = resourceCache, $[2] = connectionStatusStore) : connectionStatusStore = $[2], t0 = connectionStatusStore, t0;
}
function usePresenceStore() {
  const $ = c(5), {
    __internal: t0
  } = useSource(), {
    bifur
  } = t0, resourceCache = useResourceCache(), userStore = useUserStore(), connectionStatusStore = useConnectionStatusStore();
  let t1, presenceStore;
  return $[0] !== bifur || $[1] !== connectionStatusStore || $[2] !== resourceCache || $[3] !== userStore ? (presenceStore = resourceCache.get({
    namespace: "presenceStore",
    dependencies: [bifur, connectionStatusStore, userStore]
  }) || createPresenceStore({
    bifur,
    connectionStatusStore,
    userStore
  }), resourceCache.set({
    namespace: "presenceStore",
    dependencies: [bifur, connectionStatusStore, userStore],
    value: presenceStore
  }), $[0] = bifur, $[1] = connectionStatusStore, $[2] = resourceCache, $[3] = userStore, $[4] = presenceStore) : presenceStore = $[4], t1 = presenceStore, t1;
}
function useProjectStore() {
  const $ = c(3), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), resourceCache = useResourceCache();
  let t0, projectStore;
  return $[0] !== client || $[1] !== resourceCache ? (projectStore = resourceCache.get({
    namespace: "projectStore",
    dependencies: [client]
  }) || createProjectStore({
    client
  }), resourceCache.set({
    namespace: "projectStore",
    dependencies: [client],
    value: projectStore
  }), $[0] = client, $[1] = resourceCache, $[2] = projectStore) : projectStore = $[2], t0 = projectStore, t0;
}
function useKeyValueStore() {
  const $ = c(4), resourceCache = useResourceCache(), workspace = useWorkspace(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0, keyValueStore;
  return $[0] !== client || $[1] !== resourceCache || $[2] !== workspace ? (keyValueStore = resourceCache.get({
    dependencies: [workspace],
    namespace: "KeyValueStore"
  }) || createKeyValueStore({
    client
  }), resourceCache.set({
    dependencies: [workspace],
    namespace: "KeyValueStore",
    value: keyValueStore
  }), $[0] = client, $[1] = resourceCache, $[2] = workspace, $[3] = keyValueStore) : keyValueStore = $[3], t0 = keyValueStore, t0;
}
function useRenderingContextStore() {
  const $ = c(2), resourceCache = useResourceCache();
  let t0, renderingContextStore;
  return $[0] !== resourceCache ? (renderingContextStore = resourceCache.get({
    dependencies: [],
    namespace: "RenderingContextStore"
  }) || createRenderingContextStore(), resourceCache.set({
    dependencies: [],
    namespace: "RenderingContextStore",
    value: renderingContextStore
  }), $[0] = resourceCache, $[1] = renderingContextStore) : renderingContextStore = $[1], t0 = renderingContextStore, t0;
}
function useComlinkStore() {
  const $ = c(4), resourceCache = useResourceCache(), renderingContext = useRenderingContextStore();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const capabilities = useObservable(renderingContext.capabilities, t0);
  let t1, comlinkStore;
  return $[1] !== capabilities || $[2] !== resourceCache ? (comlinkStore = resourceCache.get({
    dependencies: [capabilities],
    namespace: "ComlinkStore"
  }) || createComlinkStore({
    capabilities
  }), resourceCache.set({
    dependencies: [capabilities],
    namespace: "ComlinkStore",
    value: comlinkStore
  }), $[1] = capabilities, $[2] = resourceCache, $[3] = comlinkStore) : comlinkStore = $[3], t1 = comlinkStore, t1;
}
const initial = [], fallback = of(initial);
function useGlobalPresence() {
  const $ = c(2), [mounted, mount] = useReducer(_temp$18, !1);
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => startTransition(mount), t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  const presenceStore = usePresenceStore();
  return useObservable(mounted ? presenceStore.globalPresence$ : fallback, initial);
}
function _temp$18() {
  return !0;
}
function EventsProvider(t0) {
  const $ = c(3), {
    value,
    children
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== value ? (t1 = /* @__PURE__ */ jsx(EventsContext.Provider, { value, children }), $[0] = children, $[1] = value, $[2] = t1) : t1 = $[2], t1;
}
function useEvents() {
  const context = useContext(EventsContext);
  if (context === null)
    throw new Error("useEvents must be used within a EventsProvider");
  return context;
}
const isCreateDocumentVersionEvent = (event) => event.type === "createDocumentVersion", isDeleteDocumentVersionEvent = (event) => event.type === "deleteDocumentVersion", isPublishDocumentVersionEvent = (event) => event.type === "publishDocumentVersion", isUnpublishDocumentEvent = (event) => event.type === "unpublishDocument", isScheduleDocumentVersionEvent = (event) => event.type === "scheduleDocumentVersion", isUnscheduleDocumentVersionEvent = (event) => event.type === "unscheduleDocumentVersion", isDeleteDocumentGroupEvent = (event) => event.type === "deleteDocumentGroup", isCreateLiveDocumentEvent = (event) => event.type === "createLiveDocument", isUpdateLiveDocumentEvent = (event) => event.type === "updateLiveDocument", isEditDocumentVersionEvent = (event) => event.type === "editDocumentVersion";
function removeDupes(events2, newEvents) {
  const noDupes = [...events2, ...newEvents].reduce((acc, event) => {
    if (acc.has(event.id)) {
      const existingEvent = acc.get(event.id);
      return isEditDocumentVersionEvent(existingEvent) && !isEditDocumentVersionEvent(event) && acc.set(event.id, event), existingEvent.type !== event.type && acc.set(`${event.id}-${event.type}`, event), acc;
    }
    return acc.set(event.id, event);
  }, /* @__PURE__ */ new Map());
  return Array.from(noDupes.values());
}
function addEventId(event, documentVariantType) {
  let id2 = "";
  return isCreateDocumentVersionEvent(event) ? id2 = documentVariantType === "published" ? event.revisionId || `publishCreation--${event.timestamp}` : event.versionRevisionId : isDeleteDocumentVersionEvent(event) ? id2 = documentVariantType === "published" ? `deleteAt-${event.timestamp}` : event.versionRevisionId : isPublishDocumentVersionEvent(event) ? id2 = documentVariantType === "published" ? event.revisionId : event.versionRevisionId || event.revisionId : isUnpublishDocumentEvent(event) ? id2 = documentVariantType === "published" ? `unpublishAt-${event.timestamp}` : "" : isScheduleDocumentVersionEvent(event) || isUnscheduleDocumentVersionEvent(event) ? id2 = documentVariantType === "published" ? "" : event.versionRevisionId : isDeleteDocumentGroupEvent(event) ? id2 = `deleted-${event.timestamp}` : (isCreateLiveDocumentEvent(event) || isUpdateLiveDocumentEvent(event) || isEditDocumentVersionEvent(event)) && (id2 = event.revisionId), {
    ...event,
    id: id2
  };
}
function addParentToEvents(events2) {
  const eventsWithParent = JSON.parse(JSON.stringify(events2));
  return eventsWithParent.forEach((event, index) => {
    if (isPublishDocumentVersionEvent(event) || isDeleteDocumentVersionEvent(event)) {
      event.documentId = event.versionId;
      for (let i = index; i < eventsWithParent.length; i++) {
        const nextEvent = eventsWithParent[i];
        if (isEditDocumentVersionEvent(nextEvent) && (nextEvent.parentId = event.id), isCreateDocumentVersionEvent(nextEvent)) {
          event.creationEvent = nextEvent, nextEvent.parentId = event.id;
          break;
        }
      }
    }
    isEditDocumentVersionEvent(event) && event.parentId === event.id && event.transactions[1]?.revisionId && (event.id = event.transactions[1].revisionId);
  }), eventsWithParent;
}
const MERGE_WINDOW = 5 * 60 * 1e3;
function isWithinMergeWindow(a, b) {
  return Math.abs(Date.parse(a) - Date.parse(b)) < MERGE_WINDOW;
}
function squashLiveEditEvents(events2) {
  return events2.reduce((acc, event) => {
    if (isUpdateLiveDocumentEvent(event)) {
      const previousEvent = acc[acc.length - 1];
      if (previousEvent && isUpdateLiveDocumentEvent(previousEvent) && isWithinMergeWindow(previousEvent.timestamp, event.timestamp) && previousEvent.author === event.author)
        return acc;
    }
    return acc.push(event), acc;
  }, []);
}
function remoteMutationToTransaction(event) {
  return {
    author: event.author,
    documentIDs: [],
    id: event.transactionId,
    timestamp: event.timestamp.toISOString(),
    effects: {
      [event.head._id]: {
        apply: event.effects.apply,
        revert: event.effects.revert
      }
    }
  };
}
function updateVersionEvents(events2) {
  return events2.map((event) => isPublishDocumentVersionEvent(event) ? {
    ...event,
    documentId: event.versionId
  } : event);
}
function updatePublishedEvents(events2, releases2) {
  return events2.map((event) => {
    if (isPublishDocumentVersionEvent(event)) {
      const releaseId = getVersionFromId(event.versionId);
      if (releaseId) {
        const releaseDocumentId = getReleaseDocumentIdFromReleaseId(releaseId), release = releases2.releases.get(releaseDocumentId);
        return {
          ...event,
          release: release || {
            _id: releaseDocumentId
          }
        };
      }
      return event;
    }
    return event;
  });
}
function sortEvents({
  remoteEdits,
  events: events2,
  expandedEvents
}) {
  return [...remoteEdits, ...events2, ...expandedEvents].sort(
    // Sort by timestamp, newest first unless is an edit event that has a corresponding publish event
    (a, b) => isPublishDocumentVersionEvent(a) && isEditDocumentVersionEvent(b) && a.versionRevisionId === b.revisionId ? -1 : isPublishDocumentVersionEvent(b) && isEditDocumentVersionEvent(a) && b.versionRevisionId === a.revisionId ? 1 : Date.parse(b.timestamp) - Date.parse(a.timestamp)
  );
}
const addDocumentVariantTypeToEvents = (events2, documentVariantType) => events2.map((event) => ({
  ...event,
  documentVariantType
}));
function createEventsObservable({
  releases$,
  events$,
  remoteEdits$,
  expandedEvents$,
  documentId
}) {
  const documentVariantType = getDocumentVariantType(documentId);
  return combineLatest([releases$, events$, remoteEdits$, expandedEvents$]).pipe(
    map$1(([releases2, {
      events: events2,
      nextCursor,
      loading,
      error
    }, remoteEdits, expandedEvents]) => {
      const eventsWithRemoteEdits = sortEvents({
        remoteEdits,
        events: events2,
        expandedEvents
      });
      return documentVariantType === "published" ? {
        events: updatePublishedEvents(eventsWithRemoteEdits, releases2),
        nextCursor,
        loading,
        error
      } : documentVariantType === "draft" ? {
        events: addParentToEvents(eventsWithRemoteEdits),
        nextCursor,
        loading,
        error
      } : {
        events: updateVersionEvents(eventsWithRemoteEdits),
        nextCursor,
        loading,
        error
      };
    }),
    map$1((value) => ({
      ...value,
      events: addDocumentVariantTypeToEvents(value.events, documentVariantType)
    })),
    // TODO: This is temporal - liveEditEvents will be squashed in the API
    map$1((value) => ({
      ...value,
      events: squashLiveEditEvents(value.events)
    }))
  );
}
const TRANSLOG_ENTRY_LIMIT = 50, documentTransactionsCache = /* @__PURE__ */ Object.create(null);
async function getDocumentTransactions({
  documentId,
  client,
  toTransaction,
  fromTransaction
}) {
  const cacheKey = `${documentId}-${toTransaction}-${fromTransaction}`;
  if (documentTransactionsCache[cacheKey] && typeof toTransaction < "u")
    return documentTransactionsCache[cacheKey];
  const skipFromTransaction = fromTransaction !== toTransaction;
  let transactions = await getTransactionsLogs(client, documentId, {
    tag: "sanity.studio.documents.history",
    effectFormat: "mendoza",
    excludeContent: !0,
    includeIdentifiedDocumentsOnly: !0,
    limit: TRANSLOG_ENTRY_LIMIT,
    fromTransaction,
    toTransaction
  });
  if (skipFromTransaction && (transactions = transactions.filter((transaction) => transaction.id !== fromTransaction)), (skipFromTransaction ? (
    // The transaction received with the id fromTransaction is not included in the list but it's returned by the API; remove that from the count
    transactions.length === TRANSLOG_ENTRY_LIMIT - 1
  ) : transactions.length === TRANSLOG_ENTRY_LIMIT) && (toTransaction && transactions[transactions.length - 1].id !== toTransaction || !toTransaction)) {
    const nextTransactions = await getDocumentTransactions({
      documentId,
      client,
      toTransaction,
      fromTransaction: transactions[transactions.length - 1].id
    });
    return transactions.concat(nextTransactions);
  }
  return documentTransactionsCache[cacheKey] = transactions, transactions;
}
function getEffectState(effect) {
  const modified = !!effect, deleted = effect && isDeletePatch(effect?.apply), created = effect && isDeletePatch(effect?.revert);
  return deleted ? "deleted" : created ? "created" : modified ? "modified" : "noop";
}
function isDeletePatch(patch2) {
  return patch2[0] === 0 && patch2[1] === null;
}
const getEditTransaction = (transaction) => ({
  type: "editTransaction",
  author: transaction.author,
  timestamp: transaction.timestamp,
  revisionId: transaction.id
});
function getEditEvents(transactions, documentId, liveEdit) {
  const editTransactions = transactions.filter((tx) => getEffectState(tx.effects[documentId]) === "modified").sort((a, b) => Date.parse(b.timestamp) - Date.parse(a.timestamp)), result = [];
  for (const transaction of editTransactions) {
    const event = liveEdit ? {
      id: transaction.id,
      timestamp: transaction.timestamp,
      type: "updateLiveDocument",
      documentId,
      revisionId: transaction.id,
      author: transaction.author,
      documentVariantType: getDocumentVariantType(documentId)
    } : {
      type: "editDocumentVersion",
      documentId,
      id: transaction.id,
      timestamp: transaction.timestamp,
      author: transaction.author,
      contributors: [transaction.author],
      releaseId: getVersionFromId(documentId),
      revisionId: transaction.id,
      transactions: [getEditTransaction(transaction)],
      documentVariantType: getDocumentVariantType(documentId)
    };
    if (result.length === 0) {
      result.push(event);
      continue;
    }
    const lastEvent = result[result.length - 1];
    isWithinMergeWindow(lastEvent.timestamp, event.timestamp) ? isEditDocumentVersionEvent(lastEvent) && (lastEvent.transactions.push(getEditTransaction(transaction)), !lastEvent.contributors.includes(event.author) && lastEvent.author !== event.author && lastEvent.contributors.push(event.author)) : result.push(event);
  }
  return result;
}
const HISTORY_CLEARED_EVENT_ID = "history-cleared", INITIAL_VALUE$1 = {
  events: [],
  nextCursor: "",
  loading: !0,
  error: null
};
function getInitialFetchEvents({
  client,
  documentId
}) {
  const documentVariantType = getDocumentVariantType(documentId), refetchEventsTrigger$ = new BehaviorSubject({
    cursor: null,
    origin: "initial"
  }), fetchEvents = ({
    limit: limit2,
    nextCursor: nextCursor2
  }) => {
    const params = new URLSearchParams({
      limit: limit2.toString()
    });
    return nextCursor2 && params.append("nextCursor", nextCursor2), client.observable.request({
      url: `/data/history/${client.config().dataset}/events/documents/${documentId}?${params.toString()}`,
      tag: "get-document-events"
    }).pipe(map((response) => ({
      events: response.events[documentId]?.map((ev) => addEventId(ev, documentVariantType)) || [],
      nextCursor: response.nextCursor,
      loading: !1,
      error: null
    })));
  }, fetchEditEvents = (events2) => {
    const eventWithRevision = documentVariantType === "version" ? events2.find(isCreateDocumentVersionEvent) : events2.find((event) => "versionRevisionId" in event && event.versionRevisionId), revisionId = eventWithRevision && "versionRevisionId" in eventWithRevision && eventWithRevision.versionRevisionId;
    return from(getDocumentTransactions({
      client,
      documentId,
      fromTransaction: revisionId || "",
      toTransaction: void 0
      // We need to get up to the present moment
    })).pipe(map((transactions) => {
      const editEvents = getEditEvents(transactions, documentId, !1);
      if (events2.length === 0 && transactions.length > 0) {
        const newTimestamp = new Date(editEvents[0].timestamp).getTime() - 1;
        editEvents.unshift({
          type: "historyCleared",
          documentId,
          id: HISTORY_CLEARED_EVENT_ID,
          timestamp: new Date(newTimestamp).toISOString(),
          author: "",
          documentVariantType
        });
      }
      return editEvents;
    }));
  };
  let nextCursor = "";
  return {
    events$: refetchEventsTrigger$.pipe(switchMap(({
      cursor,
      origin
    }) => fetchEvents({
      nextCursor: cursor,
      limit: origin === "reload" ? 10 : 100
    }).pipe(switchMap((response) => documentVariantType === "published" || origin === "loadMore" ? of({
      ...response,
      origin
    }) : fetchEditEvents(response.events).pipe(map((editEvents) => ({
      ...response,
      events: [...editEvents, ...response.events],
      origin
    })))), catchError((error) => (console.error("Error fetching events", error), [{
      events: [],
      nextCursor: "",
      loading: !1,
      error,
      origin
    }])), startWith({
      events: [],
      nextCursor: "",
      loading: !0,
      error: null,
      origin
    }))), scan((prev, next) => ({
      events: removeDupes(prev.events, next.events),
      // If we are reloading, we should keep the cursor as it was before.
      nextCursor: next.origin === "reload" ? prev.nextCursor : next.nextCursor,
      loading: next.loading,
      error: next.error
    }), INITIAL_VALUE$1), tap((response) => {
      nextCursor = response.nextCursor;
    }), shareReplay(1)),
    /**
     * Loads new events for the document, fetching the latest events from the API.
     */
    reloadEvents: () => refetchEventsTrigger$.next({
      cursor: null,
      origin: "reload"
    }),
    /**
     * Loads more events for the document, fetching the next batch of events from the API.
     */
    loadMore: () => {
      const lastCursorUsed = refetchEventsTrigger$.getValue().cursor;
      nextCursor && lastCursorUsed !== nextCursor && refetchEventsTrigger$.next({
        origin: "loadMore",
        cursor: nextCursor
      });
    }
  };
}
const buildDocumentForDiffInput$1 = (document2) => {
  if (!document2) return {};
  const {
    _id,
    _rev,
    _createdAt,
    _updatedAt,
    _type,
    ...rest
  } = JSON.parse(JSON.stringify(document2));
  return rest;
};
function omitRev(document2) {
  const {
    _rev,
    ...doc
  } = document2;
  return doc;
}
function annotationForTransactionIndex(transactions, idx, event) {
  const tx = transactions[idx];
  return tx ? {
    timestamp: tx.timestamp,
    author: tx.author,
    event
  } : null;
}
function extractAnnotationForFromInput(transactions, meta) {
  return meta ? annotationForTransactionIndex(transactions, meta.transactionIndex + 1, meta.event) : null;
}
function extractAnnotationForToInput(transactions, meta) {
  return meta ? annotationForTransactionIndex(transactions, meta.transactionIndex, meta.event) : null;
}
function diffValue({
  transactions,
  fromValue,
  fromRaw,
  toValue,
  toRaw
}) {
  const fromInput = wrapValue(fromValue, fromRaw, {
    fromValue(value) {
      return extractAnnotationForFromInput(transactions, value.endMeta);
    },
    fromMeta(meta) {
      return extractAnnotationForFromInput(transactions, meta);
    }
  }), toInput = wrapValue(toValue, toRaw, {
    fromValue(value) {
      return extractAnnotationForToInput(transactions, value.startMeta);
    },
    fromMeta(meta) {
      return extractAnnotationForToInput(transactions, meta);
    }
  });
  return diffInput(fromInput, toInput);
}
function calculateDiff({
  initialDoc,
  documentId,
  transactions,
  events: events2 = []
}) {
  const initialValue = incremental.wrap(omitRev(initialDoc), null);
  let document2 = incremental.wrap(omitRev(initialDoc), null), finalDocument = omitRev(initialDoc);
  return transactions.forEach((transaction, index) => {
    const meta = {
      transactionIndex: index,
      event: events2.find((event) => !isEditDocumentVersionEvent(event) && "revisionId" in event && event.revisionId === transaction.id)
    }, effect = transaction.effects[documentId];
    effect && (document2 = incremental.applyPatch(document2, effect.apply, meta), finalDocument = applyPatch$1(finalDocument, effect.apply));
  }), diffValue({
    transactions,
    fromValue: initialValue,
    fromRaw: initialDoc,
    toValue: document2,
    toRaw: finalDocument
  });
}
function removeDuplicatedTransactions(transactions) {
  const seen = /* @__PURE__ */ new Set();
  return transactions.filter((tx) => seen.has(tx.id) ? !1 : (seen.add(tx.id), !0));
}
class MissingSinceDocumentError extends Error {
  constructor(revisionId) {
    super(`Missing since document for revision ${revisionId}`), this.name = "MissingSinceDocumentError", this.revisionId = revisionId;
  }
}
function getDocumentChanges({
  eventsObservable$,
  documentId,
  client,
  to$,
  since$,
  remoteTransactions$
}) {
  let lastResolvedSince = null, lastResolvedTo = null, lastTransactions = [];
  return combineLatest(to$, since$, eventsObservable$).pipe(switchMap$1(([toObs, since, {
    events: events2
  }]) => {
    const to = toObs?.document;
    let sinceDoc;
    if (since?.document)
      sinceDoc = since?.document;
    else {
      const selectedToEvent = events2.find((event) => event.id === to?._rev);
      selectedToEvent && isCreateDocumentVersionEvent(selectedToEvent) && to && (sinceDoc = {
        _type: to._type,
        _id: to._id,
        _rev: to._rev
      });
    }
    return sinceDoc ? remoteTransactions$.pipe(switchMap$1((remoteTx) => {
      const viewingLatest = !to?._rev;
      return (sinceDoc._rev === HISTORY_CLEARED_EVENT_ID ? of([]) : viewingLatest && lastResolvedSince === sinceDoc._rev ? of(removeDuplicatedTransactions(lastTransactions.concat(remoteTx))) : lastResolvedSince && lastResolvedSince === sinceDoc._rev && lastResolvedTo && lastResolvedTo === to?._rev ? of(lastTransactions) : from(getDocumentTransactions({
        documentId,
        client,
        toTransaction: to?._rev,
        fromTransaction: sinceDoc._rev
      }))).pipe(tap$1((transactions) => {
        lastResolvedSince = sinceDoc._rev, lastTransactions = transactions, to?._rev && (lastResolvedTo = to._rev);
      }), map$1((transactions) => ({
        loading: !1,
        diff: calculateDiff({
          documentId,
          initialDoc: sinceDoc,
          transactions,
          events: events2
        }),
        error: null
      })));
    }), catchError$1((error) => (console.error(error), of({
      loading: !1,
      diff: null,
      error
    }))), startWith$1({
      loading: !0,
      error: null,
      diff: sinceDoc && to ? diffInput(wrap$1(buildDocumentForDiffInput$1(sinceDoc), null), wrap$1(buildDocumentForDiffInput$1(to), null)) : null
    }), shareReplay$1(1)) : of({
      loading: !1,
      diff: null,
      error: since && !since.loading && since.revisionId ? (
        /**
         * In some cases, depending on history retention, we will get documents in the events api with a revision
         * that may not exist anymore in the /history/documents endpoint.
         *
         * In those cases, we cannot show the comparison, because we don't have a "from" document to select, so we will show an error to the users.
         */
        new MissingSinceDocumentError(since?.revisionId)
      ) : null
    });
  }));
}
function getExpandEvents({
  documentId,
  client
}) {
  const expandedEventsMap$ = new BehaviorSubject(/* @__PURE__ */ new Map()), expandedEvents$ = expandedEventsMap$.pipe(map$1((expandedEventsMap) => Array.from(expandedEventsMap.values()).flatMap((v) => v)));
  return {
    handleExpandEvent: async (event) => {
      if (!expandedEventsMap$.getValue().has(event.id))
        if ((isPublishDocumentVersionEvent(event) || isDeleteDocumentVersionEvent(event)) && event.versionRevisionId && event.creationEvent) {
          const transactions = await getDocumentTransactions({
            client,
            documentId,
            fromTransaction: event.creationEvent.versionRevisionId,
            toTransaction: event.versionRevisionId
          }), editEvents = getEditEvents(transactions, documentId, !1).map((editEvent) => ({
            ...editEvent,
            parentId: event.id
          })), value = expandedEventsMap$.getValue();
          value.set(event.id, editEvents), expandedEventsMap$.next(value);
        } else
          console.error("This event can't be expanded", event);
    },
    expandedEvents$
  };
}
function getRemoteTransactionsSubscription({
  client,
  isLiveEdit,
  documentId,
  documentType,
  serverActionsEnabled,
  onRefetch
}) {
  const remoteTransactions$ = new BehaviorSubject([]), remoteEdits$ = remoteTransactions$.pipe(map$1((transactions) => getEditEvents(transactions, documentId, isLiveEdit))), documentVariantType = getDocumentVariantType(documentId), onMutationReceived = (remoteMutation) => {
    if (!remoteMutation) return;
    const variant = remoteMutation.version;
    if (variant !== documentVariantType)
      return;
    if (variant === "published" && !isLiveEdit) {
      onRefetch();
      return;
    }
    const effectState = getEffectState({
      apply: remoteMutation.effects.apply,
      revert: remoteMutation.effects.revert
    });
    if (effectState === "created" || effectState === "deleted") {
      onRefetch(), remoteTransactions$.next([]);
      return;
    }
    remoteTransactions$.next([...remoteTransactions$.value, remoteMutationToTransaction(remoteMutation)]);
  }, subscription = remoteSnapshots(client, {
    draftId: getDraftId(documentId),
    publishedId: getPublishedId(documentId),
    ...isVersionId(documentId) ? {
      versionId: documentId
    } : {}
  }, documentType, serverActionsEnabled).pipe(filter$1((event) => event.type === "remoteMutation"));
  return {
    remoteTransactions$,
    remoteEdits$,
    subscribe: () => subscription.subscribe(onMutationReceived)
  };
}
function createEventsStore({
  client,
  documentId,
  documentType,
  releases$,
  serverActionsEnabled,
  isLiveEdit
}) {
  const initialEvents = getInitialFetchEvents({
    client,
    documentId
  }), {
    expandedEvents$,
    handleExpandEvent
  } = getExpandEvents({
    client,
    documentId
  }), {
    remoteEdits$,
    remoteTransactions$,
    subscribe: subscribe2
  } = getRemoteTransactionsSubscription({
    client,
    documentId,
    documentType,
    isLiveEdit,
    serverActionsEnabled,
    onRefetch: initialEvents.reloadEvents
  }), eventsObservable$ = createEventsObservable({
    documentId,
    events$: initialEvents.events$,
    remoteEdits$,
    expandedEvents$,
    releases$
  });
  return {
    eventsObservable$,
    getDocumentChanges: (revision$, since$) => getDocumentChanges({
      client,
      eventsObservable$,
      documentId,
      remoteTransactions$,
      to$: revision$,
      since$
    }),
    handleExpandEvent,
    loadMoreEvents: initialEvents.loadMore,
    reloadEvents: initialEvents.reloadEvents,
    remoteTransactionsListener: subscribe2
  };
}
const documentRevisionCache = /* @__PURE__ */ Object.create(null);
function getDocumentAtRevision({
  client,
  documentId,
  revisionId
}) {
  if (revisionId === HISTORY_CLEARED_EVENT_ID)
    return of({
      document: null,
      loading: !1,
      revisionId
    });
  const cacheKey = `${documentId}@${revisionId}`, dataset = client.config().dataset;
  return documentRevisionCache[cacheKey] || (documentRevisionCache[cacheKey] = client.observable.request({
    url: `/data/history/${dataset}/documents/${documentId}?revision=${revisionId}`,
    tag: "get-document-revision"
  }).pipe(map((response) => ({
    document: response.documents[0],
    loading: !1,
    revisionId
  })), catchError((error) => (console.error("Error fetching document at revision", error), [{
    document: null,
    loading: !1,
    revisionId
  }])), startWith({
    document: null,
    loading: !0,
    revisionId
  }), shareReplay(1))), documentRevisionCache[cacheKey];
}
const INITIAL_VALUE = {
  events: [],
  nextCursor: "",
  loading: !0,
  error: null
};
function useEventsStore({
  documentId,
  documentType,
  rev,
  since
}) {
  const client = useClient(RELEASES_STUDIO_CLIENT_OPTIONS), {
    state$: releases$
  } = useReleasesStore(), workspace = useWorkspace(), serverActionsEnabled = useMemo(() => {
    const configFlag = workspace.__internal_serverDocumentActions?.enabled;
    return typeof configFlag == "boolean" ? of(configFlag) : of(!0);
  }, [workspace.__internal_serverDocumentActions?.enabled]), isLiveEdit = !!useSchema().get(documentType)?.liveEdit, eventsStore = useMemo(() => createEventsStore({
    client,
    documentId,
    documentType,
    releases$,
    serverActionsEnabled,
    isLiveEdit
  }), [client, documentId, documentType, releases$, serverActionsEnabled, isLiveEdit]), {
    events: events2,
    loading,
    error,
    nextCursor
  } = useObservable(eventsStore.eventsObservable$, INITIAL_VALUE);
  useEffect(() => {
    const subscription = eventsStore.remoteTransactionsListener();
    return () => {
      subscription.unsubscribe();
    };
  }, [eventsStore]);
  const revisionId = useMemo(() => {
    if (rev === "@lastPublished")
      return events2.find(isPublishDocumentVersionEvent)?.id || null;
    if (rev === "@lastEdited") {
      const editEvent = events2.find(isEditDocumentVersionEvent);
      if (editEvent) return editEvent.revisionId;
    }
    if (rev?.startsWith("@release:")) {
      const releaseId = rev.split(":")[1], releaseEvent = events2.find((event) => isPublishDocumentVersionEvent(event) && event.releaseId === releaseId);
      if (releaseEvent) return releaseEvent.id;
      events2.length > 0 && !loading && eventsStore.loadMoreEvents();
    }
    if (!rev) {
      const [lastEvent] = events2;
      if (lastEvent && isPublishDocumentVersionEvent(lastEvent))
        return lastEvent.id;
    }
    return rev;
  }, [events2, rev, eventsStore, loading]), revision$ = useMemo(() => revisionId ? getDocumentAtRevision({
    client,
    documentId,
    revisionId
  }) : of(null), [client, documentId, revisionId]), revision = useObservable(revision$, null), sinceId = useMemo(() => {
    if (since && since !== "@lastPublished") return since;
    if (!events2) return null;
    if (since === "@lastPublished" || !since) {
      const revisionIndex = events2.findIndex((e) => e.id === revisionId), lastPublishedId = events2.slice(revisionIndex + 1).find(isPublishDocumentVersionEvent)?.id;
      if (lastPublishedId) return lastPublishedId;
      const creationEvent = events2.find(isCreateDocumentVersionEvent);
      if (creationEvent) return creationEvent.id;
    }
    if (!revisionId) return events2[1]?.id;
    const revisionEventIndex = events2.findIndex((e_0) => e_0.id === revisionId);
    return revisionEventIndex === -1 ? null : events2[revisionEventIndex + 1]?.id || null;
  }, [events2, revisionId, since]), since$ = useMemo(() => sinceId ? getDocumentAtRevision({
    client,
    documentId,
    revisionId: sinceId
  }) : of(null), [sinceId, client, documentId]), getChangesList = useCallback(() => eventsStore.getDocumentChanges(revision$, since$), [eventsStore, revision$, since$]), sinceRevision = useObservable(since$, null), documentVariantType = getDocumentVariantType(documentId), findRangeForRevision = useCallback((nextRev) => {
    if (!events2) return [null, null];
    const revisionIndex_0 = events2.findIndex((event_0) => event_0.id === nextRev);
    if (revisionIndex_0 === 0)
      return documentVariantType === "version" && isPublishDocumentVersionEvent(events2[0]) ? [since || null, nextRev] : [since || null, null];
    if (!since) {
      const currentRevisionIndex = events2.findIndex((event_1) => event_1.id === revisionId);
      return currentRevisionIndex === -1 || revisionIndex_0 === -1 || revisionIndex_0 > currentRevisionIndex ? [null, nextRev] : [revisionId || null, nextRev];
    }
    const sinceIndex = events2.findIndex((event_2) => event_2.id === since);
    return sinceIndex === -1 || revisionIndex_0 === -1 ? [null, nextRev] : sinceIndex < revisionIndex_0 ? [null, nextRev] : sinceIndex === revisionIndex_0 ? [null, nextRev] : [since, nextRev];
  }, [events2, since, documentVariantType, revisionId]), findRangeForSince = useCallback((nextSince) => {
    if (!events2) return [null, null];
    if (!rev || !revisionId) return [nextSince, null];
    const revisionIndex_1 = events2.findIndex((event_3) => event_3.id === revisionId), sinceIndex_0 = events2.findIndex((event_4) => event_4.id === nextSince);
    return sinceIndex_0 === -1 || revisionIndex_1 === -1 ? [nextSince, null] : sinceIndex_0 < revisionIndex_1 ? [nextSince, null] : sinceIndex_0 === revisionIndex_1 ? [nextSince, null] : [nextSince, revisionId];
  }, [events2, rev, revisionId]);
  return {
    events: events2,
    nextCursor,
    loading,
    error,
    revision,
    sinceRevision,
    findRangeForRevision,
    findRangeForSince,
    loadMoreEvents: eventsStore.loadMoreEvents,
    expandEvent: eventsStore.handleExpandEvent,
    getChangesList
  };
}
const TIMELINE_ICON_COMPONENTS = {
  historyCleared: TimelineIcon,
  createDocumentVersion: AddCircleIcon,
  createLiveDocument: AddCircleIcon,
  deleteDocumentGroup: TrashIcon,
  deleteDocumentVersion: CloseIcon,
  editDocumentVersion: EditIcon,
  updateLiveDocument: EditIcon,
  publishDocumentVersion: PublishIcon,
  unpublishDocument: UnpublishIcon,
  scheduleDocumentVersion: CalendarIcon,
  unscheduleDocumentVersion: CircleIcon
}, TIMELINE_ITEM_EVENT_TONE = {
  historyCleared: "orange",
  createDocumentVersion: "green",
  createLiveDocument: "blue",
  updateLiveDocument: "green",
  editDocumentVersion: "yellow",
  unpublishDocument: "orange",
  deleteDocumentVersion: "orange",
  deleteDocumentGroup: "orange",
  scheduleDocumentVersion: "cyan",
  unscheduleDocumentVersion: "cyan",
  publishDocumentVersion: "green"
}, TIMELINE_ITEM_I18N_KEY_MAPPING = {
  published: {
    createDocumentVersion: "timeline.operation.created",
    historyCleared: "timeline.operation.history-cleared",
    publishDocumentVersion: "timeline.operation.published",
    updateLiveDocument: "timeline.operation.edited-live",
    editDocumentVersion: "timeline.operation.edited-draft",
    unpublishDocument: "timeline.operation.unpublished",
    deleteDocumentVersion: "timeline.operation.draft-discarded",
    deleteDocumentGroup: "timeline.operation.deleted",
    scheduleDocumentVersion: "timeline.operation.published",
    unscheduleDocumentVersion: "timeline.operation.published",
    createLiveDocument: "timeline.operation.created"
  },
  draft: {
    createDocumentVersion: "timeline.operation.draft-created",
    historyCleared: "timeline.operation.history-cleared",
    publishDocumentVersion: "timeline.operation.published",
    updateLiveDocument: "timeline.operation.edited-live",
    editDocumentVersion: "timeline.operation.edited-draft",
    unpublishDocument: "timeline.operation.unpublished",
    deleteDocumentVersion: "timeline.operation.draft-discarded",
    deleteDocumentGroup: "timeline.operation.deleted",
    scheduleDocumentVersion: "timeline.operation.published",
    unscheduleDocumentVersion: "timeline.operation.published",
    createLiveDocument: "timeline.operation.created"
  },
  version: {
    createDocumentVersion: "timeline.operation.version-created",
    historyCleared: "timeline.operation.history-cleared",
    publishDocumentVersion: "timeline.operation.published",
    updateLiveDocument: "timeline.operation.edited-live",
    editDocumentVersion: "timeline.operation.edited-draft",
    unpublishDocument: "timeline.operation.unpublished",
    deleteDocumentVersion: "timeline.operation.version-discarded",
    deleteDocumentGroup: "timeline.operation.deleted",
    scheduleDocumentVersion: "timeline.operation.published",
    unscheduleDocumentVersion: "timeline.operation.published",
    createLiveDocument: "timeline.operation.created"
  }
};
function UserAvatarStack(t0) {
  const $ = c(9), {
    maxLength,
    userIds,
    size,
    withTooltip: t1
  } = t0, withTooltip = t1 === void 0 ? !0 : t1;
  let t2;
  if ($[0] !== userIds || $[1] !== withTooltip) {
    let t32;
    $[3] !== withTooltip ? (t32 = (userId) => /* @__PURE__ */ jsx(UserAvatar, { user: userId, withTooltip }, userId), $[3] = withTooltip, $[4] = t32) : t32 = $[4], t2 = userIds.map(t32), $[0] = userIds, $[1] = withTooltip, $[2] = t2;
  } else
    t2 = $[2];
  let t3;
  return $[5] !== maxLength || $[6] !== size || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(AvatarStack, { maxLength, size, children: t2 }), $[5] = maxLength, $[6] = size, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}
const IconBox = styled(Flex)((props2) => {
  const theme = getTheme_v2(props2.theme), color = props2.$color;
  return css`
    --card-icon-color: ${theme.color.avatar[color].fg};
    background-color: ${theme.color.avatar[color].bg};
    box-shadow: 0 0 0 1px var(--card-bg-color);

    position: absolute;
    width: ${theme.avatar.sizes[0].size}px;
    height: ${theme.avatar.sizes[0].size}px;
    right: -3px;
    bottom: -3px;
    border-radius: 50%;
  `;
}), RELATIVE_TIME_OPTIONS$2 = {
  minimal: !0,
  useTemporalPhrase: !0
}, AvatarSkeleton = styled(Skeleton)((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    border-radius: 50%;
    width: ${theme.avatar.sizes[1].size}px;
    height: ${theme.avatar.sizes[1].size}px;
  `;
}), NameSkeleton = styled(Skeleton)((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    width: 6ch;
    height: ${theme.font.text.sizes[0].lineHeight}px;
  `;
}), UserLine = (t0) => {
  const $ = c(10), {
    userId
  } = t0, [user, loading] = useUser(userId);
  let t1;
  $[0] !== loading || $[1] !== user ? (t1 = /* @__PURE__ */ jsx(Box, { children: loading || !user ? /* @__PURE__ */ jsx(AvatarSkeleton, { animated: !0 }) : /* @__PURE__ */ jsx(UserAvatar, { user }) }), $[0] = loading, $[1] = user, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== loading || $[4] !== user ? (t2 = /* @__PURE__ */ jsx(Box, { children: loading || !user?.displayName ? /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(NameSkeleton, { animated: !0 }) }) : /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: user.displayName }) }), $[3] = loading, $[4] = user, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t1 || $[7] !== t2 || $[8] !== userId ? (t3 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, padding: 1, children: [
    t1,
    t2
  ] }, userId), $[6] = t1, $[7] = t2, $[8] = userId, $[9] = t3) : t3 = $[9], t3;
}, ChangesBy = (t0) => {
  const $ = c(9), {
    collaborators
  } = t0, {
    t
  } = useTranslation("studio");
  let t1;
  $[0] !== t ? (t1 = t("timeline.changes.title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 1, paddingBottom: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t1 }) }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== collaborators ? (t3 = collaborators.map(_temp$17), $[4] = collaborators, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { paddingBottom: 1, children: [
    t2,
    t3
  ] }), $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
};
function Event$1(t0) {
  const $ = c(55), {
    event,
    showChangesBy: t1
  } = t0, showChangesBy = t1 === void 0 ? "tooltip" : t1, {
    t
  } = useTranslation("studio"), {
    type,
    timestamp,
    documentVariantType
  } = event, IconComponent = TIMELINE_ICON_COMPONENTS[type];
  let t2;
  $[0] !== event ? (t2 = "contributors" in event ? event.contributors || [] : [], $[0] = event, $[1] = t2) : t2 = $[1];
  const contributors = t2;
  let t3;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    dateStyle: "medium",
    timeStyle: "short"
  }, $[2] = t3) : t3 = $[2];
  const dateFormat = useDateTimeFormat(t3);
  let t4;
  $[3] !== timestamp ? (t4 = new Date(timestamp), $[3] = timestamp, $[4] = t4) : t4 = $[4];
  const updatedTimeAgo = useRelativeTime(t4 || "", RELATIVE_TIME_OPTIONS$2);
  let t5, t6;
  if ($[5] !== dateFormat || $[6] !== timestamp) {
    const parsedDate = new Date(timestamp);
    t6 = dateFormat.format(parsedDate), $[5] = dateFormat, $[6] = timestamp, $[7] = t6;
  } else
    t6 = $[7];
  t5 = t6;
  const formattedTimestamp = t5;
  let t7;
  $[8] !== event ? (t7 = isEditDocumentVersionEvent(event) ? event.contributors : [event.author], $[8] = event, $[9] = t7) : t7 = $[9];
  const userIds = t7;
  let t8;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    position: "relative"
  }, $[10] = t8) : t8 = $[10];
  let t9;
  $[11] !== userIds ? (t9 = userIds.filter(Boolean), $[11] = userIds, $[12] = t9) : t9 = $[12];
  let t10;
  $[13] !== t9 ? (t10 = /* @__PURE__ */ jsx(UserAvatarStack, { maxLength: 3, userIds: t9, size: 2 }), $[13] = t9, $[14] = t10) : t10 = $[14];
  const t11 = TIMELINE_ITEM_EVENT_TONE[type];
  let t12;
  $[15] !== IconComponent ? (t12 = IconComponent && /* @__PURE__ */ jsx(IconComponent, {}), $[15] = IconComponent, $[16] = t12) : t12 = $[16];
  let t13;
  $[17] !== t12 ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: t12 }), $[17] = t12, $[18] = t13) : t13 = $[18];
  let t14;
  $[19] !== t11 || $[20] !== t13 ? (t14 = /* @__PURE__ */ jsx(IconBox, { align: "center", justify: "center", $color: t11, children: t13 }), $[19] = t11, $[20] = t13, $[21] = t14) : t14 = $[21];
  let t15;
  $[22] !== t10 || $[23] !== t14 ? (t15 = /* @__PURE__ */ jsxs("div", { style: t8, children: [
    t10,
    t14
  ] }), $[22] = t10, $[23] = t14, $[24] = t15) : t15 = $[24];
  const t16 = TIMELINE_ITEM_I18N_KEY_MAPPING[documentVariantType][type];
  let t17;
  $[25] !== t || $[26] !== t16 ? (t17 = t(t16), $[25] = t, $[26] = t16, $[27] = t17) : t17 = $[27];
  let t18;
  $[28] !== documentVariantType || $[29] !== event || $[30] !== t ? (t18 = isPublishDocumentVersionEvent(event) && documentVariantType === "published" && /* @__PURE__ */ jsxs(Fragment, { children: [
    " ",
    event.release ? /* @__PURE__ */ jsx(VersionInlineBadge, { $tone: isReleaseDocument(event.release) ? getReleaseTone(event.release) : "default", children: event.release.metadata?.title || t("release.placeholder-untitled-release") }) : /* @__PURE__ */ jsx(VersionInlineBadge, { $tone: "caution", children: t("changes.versions.draft") })
  ] }), $[28] = documentVariantType, $[29] = event, $[30] = t, $[31] = t18) : t18 = $[31];
  let t19;
  $[32] !== t17 || $[33] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Text$1, { size: 1, weight: "medium", children: [
    t17,
    t18
  ] }), $[32] = t17, $[33] = t18, $[34] = t19) : t19 = $[34];
  let t20;
  $[35] !== formattedTimestamp || $[36] !== timestamp || $[37] !== updatedTimeAgo ? (t20 = /* @__PURE__ */ jsx(Text$1, { as: "time", size: 1, muted: !0, dateTime: timestamp, title: formattedTimestamp, children: updatedTimeAgo }), $[35] = formattedTimestamp, $[36] = timestamp, $[37] = updatedTimeAgo, $[38] = t20) : t20 = $[38];
  let t21;
  $[39] !== t19 || $[40] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t19,
    t20
  ] }), $[39] = t19, $[40] = t20, $[41] = t21) : t21 = $[41];
  let t22;
  $[42] !== contributors || $[43] !== showChangesBy ? (t22 = contributors.length > 0 && showChangesBy == "tooltip" && /* @__PURE__ */ jsx(Flex, { flex: 1, justify: "flex-end", align: "center", children: /* @__PURE__ */ jsx(Tooltip, { placement: "top", content: /* @__PURE__ */ jsx(ChangesBy, { collaborators: contributors }), portal: !0, children: /* @__PURE__ */ jsx(Box, { paddingLeft: 2, paddingY: 2, children: /* @__PURE__ */ jsx(UserAvatarStack, { maxLength: 3, userIds: contributors, size: 0, withTooltip: !1 }) }) }) }), $[42] = contributors, $[43] = showChangesBy, $[44] = t22) : t22 = $[44];
  let t23;
  $[45] !== t15 || $[46] !== t21 || $[47] !== t22 ? (t23 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t15,
    t21,
    t22
  ] }), $[45] = t15, $[46] = t21, $[47] = t22, $[48] = t23) : t23 = $[48];
  let t24;
  $[49] !== contributors || $[50] !== showChangesBy ? (t24 = contributors.length > 0 && showChangesBy === "inline" && /* @__PURE__ */ jsx(Box, { paddingTop: 2, children: /* @__PURE__ */ jsx(ChangesBy, { collaborators: contributors }) }), $[49] = contributors, $[50] = showChangesBy, $[51] = t24) : t24 = $[51];
  let t25;
  return $[52] !== t23 || $[53] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t23,
    t24
  ] }), $[52] = t23, $[53] = t24, $[54] = t25) : t25 = $[54], t25;
}
function _temp$17(userId) {
  return /* @__PURE__ */ jsx(UserLine, { userId }, userId);
}
function DiffTooltip(props2) {
  const $ = c(16);
  if (!("diff" in props2)) {
    let t02;
    return $[0] !== props2 ? (t02 = /* @__PURE__ */ jsx(DiffTooltipWithAnnotation, { ...props2 }), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let diff, restProps, t0;
  $[2] !== props2 ? ({
    diff,
    path: t0,
    ...restProps
  } = props2, $[2] = props2, $[3] = diff, $[4] = restProps, $[5] = t0) : (diff = $[3], restProps = $[4], t0 = $[5]);
  let t1;
  $[6] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[6] = t0, $[7] = t1) : t1 = $[7];
  const path = t1;
  let t2;
  $[8] !== diff || $[9] !== path ? (t2 = getAnnotationAtPath(diff, path), $[8] = diff, $[9] = path, $[10] = t2) : t2 = $[10];
  const annotation = t2;
  let t3;
  $[11] !== annotation ? (t3 = annotation ? [annotation] : [], $[11] = annotation, $[12] = t3) : t3 = $[12];
  let t4;
  return $[13] !== restProps || $[14] !== t3 ? (t4 = /* @__PURE__ */ jsx(DiffTooltipWithAnnotation, { ...restProps, annotations: t3 }), $[13] = restProps, $[14] = t3, $[15] = t4) : t4 = $[15], t4;
}
function DiffTooltipWithAnnotation(props2) {
  const $ = c(22);
  let annotations, children, description, restProps;
  $[0] !== props2 ? ({
    annotations,
    children,
    description,
    ...restProps
  } = props2, $[0] = props2, $[1] = annotations, $[2] = children, $[3] = description, $[4] = restProps) : (annotations = $[1], children = $[2], description = $[3], restProps = $[4]);
  const {
    t
  } = useTranslation();
  if (!annotations)
    return children;
  let t0;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    minWidth: "240px"
  }, $[5] = t0) : t0 = $[5];
  let t1;
  $[6] !== description || $[7] !== t ? (t1 = description || t("changes.changed-label"), $[6] = description, $[7] = t, $[8] = t1) : t1 = $[8];
  let t2;
  $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t1 }), $[9] = t1, $[10] = t2) : t2 = $[10];
  let t3;
  $[11] !== annotations ? (t3 = annotations.map(_temp$16), $[11] = annotations, $[12] = t3) : t3 = $[12];
  let t4;
  $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { space: 2, children: t3 }), $[13] = t3, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== t2 || $[16] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 2, style: t0, paddingTop: 1, children: [
    t2,
    t4
  ] }), $[15] = t2, $[16] = t4, $[17] = t5) : t5 = $[17];
  const content = t5;
  let t6;
  return $[18] !== children || $[19] !== content || $[20] !== restProps ? (t6 = /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "paneFooter", children: /* @__PURE__ */ jsx(Tooltip, { content, portal: !0, ...restProps, children }) }), $[18] = children, $[19] = content, $[20] = restProps, $[21] = t6) : t6 = $[21], t6;
}
function _temp$16(annotation, idx) {
  return /* @__PURE__ */ jsx(AnnotationItem, { annotation }, idx);
}
function AnnotationItem(t0) {
  const $ = c(9), {
    annotation
  } = t0, {
    author,
    timestamp
  } = annotation, [user] = useUser(author), color = useAnnotationColor(annotation);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    minimal: !0
  }, $[0] = t1) : t1 = $[0];
  const timeAgo = useRelativeTime(timestamp, t1), {
    t
  } = useTranslation();
  let t2;
  return $[1] !== annotation.event || $[2] !== author || $[3] !== color || $[4] !== t || $[5] !== timeAgo || $[6] !== timestamp || $[7] !== user ? (t2 = /* @__PURE__ */ jsx(Fragment, { children: annotation.event ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Card, { borderBottom: !0, marginBottom: 2 }),
    /* @__PURE__ */ jsx(Event$1, { event: annotation.event, showChangesBy: "inline" })
  ] }) : /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    /* @__PURE__ */ jsx(Flex, { align: "center", paddingRight: 3, style: {
      backgroundColor: color.background,
      color: color.text,
      borderRadius: "calc(23px / 2)"
    }, children: author && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(UserAvatar, { user: author }),
      /* @__PURE__ */ jsx(Inline, { paddingLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, style: {
        color: color.text
      }, children: user ? user.displayName : t("changes.loading-author") }) })
    ] }) }),
    /* @__PURE__ */ jsx(Text$1, { as: "time", muted: !0, size: 1, dateTime: timestamp, children: timeAgo })
  ] }) }), $[1] = annotation.event, $[2] = author, $[3] = color, $[4] = t, $[5] = timeAgo, $[6] = timestamp, $[7] = user, $[8] = t2) : t2 = $[8], t2;
}
const StyledCard$2 = styled(Card)`
  --diff-card-radius: ${({
  theme
}) => rem(theme.sanity.radius[2])};
  --diff-card-bg-color: ${({
  theme
}) => theme.sanity.color.card.enabled.bg};

  max-width: 100%;
  position: relative;
  border-radius: var(--diff-card-radius);
  background-color: ${({
  $annotationColor
}) => $annotationColor.backgroundColor};
  color: ${({
  $annotationColor
}) => $annotationColor.color};

  &:not(del) {
    text-decoration: none;
  }

  &[data-hover] {
    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &:hover {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      &::after {
        bottom: -3px;
        border-top: 1px solid var(---diff-card-bg-color);
        border-bottom: 2px solid currentColor;
        border-bottom-left-radius: var(--diff-card-radius);
        border-bottom-right-radius: var(--diff-card-radius);
      }
    }

    [data-from-to-layout]:hover & {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      &::after {
        bottom: -3px;
        border-top: 1px solid var(---diff-card-bg-color);
        border-bottom: 2px solid currentColor;
        border-bottom-left-radius: var(--diff-card-radius);
        border-bottom-right-radius: var(--diff-card-radius);
      }
    }
  }
`, EMPTY_PATH$1 = [], DiffCard = forwardRef(function(props2, ref) {
  const $ = c(35);
  let annotationProp, children, className, diff, disableHoverEffect, restProps, t0, t1, t2, tooltip;
  $[0] !== props2 ? ({
    annotation: annotationProp,
    as: t0,
    children,
    className,
    diff,
    disableHoverEffect,
    path: t1,
    style: t2,
    tooltip,
    ...restProps
  } = props2, $[0] = props2, $[1] = annotationProp, $[2] = children, $[3] = className, $[4] = diff, $[5] = disableHoverEffect, $[6] = restProps, $[7] = t0, $[8] = t1, $[9] = t2, $[10] = tooltip) : (annotationProp = $[1], children = $[2], className = $[3], diff = $[4], disableHoverEffect = $[5], restProps = $[6], t0 = $[7], t1 = $[8], t2 = $[9], tooltip = $[10]);
  const as = t0 === void 0 ? "div" : t0, path = t1 === void 0 ? EMPTY_PATH$1 : t1;
  let t3;
  $[11] !== t2 ? (t3 = t2 === void 0 ? {} : t2, $[11] = t2, $[12] = t3) : t3 = $[12];
  const style = t3;
  let t4, t5;
  $[13] !== annotationProp || $[14] !== diff || $[15] !== path ? (t5 = annotationProp || getAnnotationAtPath(diff, path), $[13] = annotationProp, $[14] = diff, $[15] = path, $[16] = t5) : t5 = $[16], t4 = t5;
  const annotation = t4, color = useAnnotationColor(annotation), t6 = disableHoverEffect || !annotation ? void 0 : "";
  let t7;
  $[17] !== color.background || $[18] !== color.text ? (t7 = {
    backgroundColor: color.background,
    color: color.text
  }, $[17] = color.background, $[18] = color.text, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== as || $[21] !== children || $[22] !== className || $[23] !== ref || $[24] !== restProps || $[25] !== style || $[26] !== t6 || $[27] !== t7 ? (t8 = /* @__PURE__ */ jsx(StyledCard$2, { ...restProps, as, className, "data-hover": t6, "data-ui": "diff-card", ref, radius: 1, $annotationColor: t7, style, children }), $[20] = as, $[21] = children, $[22] = className, $[23] = ref, $[24] = restProps, $[25] = style, $[26] = t6, $[27] = t7, $[28] = t8) : t8 = $[28];
  const element = t8;
  if (tooltip && annotation) {
    let t9;
    $[29] !== annotation ? (t9 = [annotation], $[29] = annotation, $[30] = t9) : t9 = $[30];
    const t10 = tooltip && typeof tooltip == "object" && tooltip.description;
    let t11;
    return $[31] !== element || $[32] !== t10 || $[33] !== t9 ? (t11 = /* @__PURE__ */ jsx(DiffTooltip, { annotations: t9, description: t10, children: element }), $[31] = element, $[32] = t10, $[33] = t9, $[34] = t11) : t11 = $[34], t11;
  }
  return element;
}), RoundedCard$1 = styled.div`
  border-radius: ${({
  theme
}) => rem(theme.sanity.radius[2])};
  padding: ${({
  theme
}) => rem(theme.sanity.space[1])};
`, AnnotationText = styled(Text$1)`
  &:not([hidden]) {
    color: inherit;
  }
`;
function ChangeTitleSegment(props2) {
  const $ = c(15), {
    change,
    segment
  } = props2;
  if (typeof segment == "string") {
    let t02;
    return $[0] !== segment ? (t02 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { title: segment, size: 1, weight: "medium", textOverflow: "ellipsis", children: segment }) }), $[0] = segment, $[1] = t02) : t02 = $[1], t02;
  }
  const {
    hasMoved,
    fromIndex,
    toIndex,
    annotation
  } = segment, created = typeof fromIndex > "u", deleted = typeof toIndex > "u";
  if (created) {
    let t02;
    return $[2] !== annotation || $[3] !== change || $[4] !== toIndex ? (t02 = /* @__PURE__ */ jsx(CreatedTitleSegment, { annotation, change, toIndex }), $[2] = annotation, $[3] = change, $[4] = toIndex, $[5] = t02) : t02 = $[5], t02;
  }
  if (deleted) {
    let t02;
    return $[6] !== annotation || $[7] !== fromIndex ? (t02 = /* @__PURE__ */ jsx(DeletedTitleSegment, { annotation, fromIndex }), $[6] = annotation, $[7] = fromIndex, $[8] = t02) : t02 = $[8], t02;
  }
  if (hasMoved && typeof toIndex < "u" && typeof fromIndex < "u") {
    let t02;
    return $[9] !== annotation || $[10] !== fromIndex || $[11] !== toIndex ? (t02 = /* @__PURE__ */ jsx(MovedTitleSegment, { annotation, fromIndex, toIndex }), $[9] = annotation, $[10] = fromIndex, $[11] = toIndex, $[12] = t02) : t02 = $[12], t02;
  }
  const readableIndex = (toIndex || 0) + 1;
  let t0;
  return $[13] !== readableIndex ? (t0 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, weight: "medium", children: [
    "#",
    readableIndex
  ] }) }), $[13] = readableIndex, $[14] = t0) : t0 = $[14], t0;
}
function CreatedTitleSegment(props2) {
  const $ = c(18), {
    annotation: annotationProp,
    change,
    toIndex: t0
  } = props2, toIndex = t0 === void 0 ? 0 : t0, {
    t
  } = useTranslation(), readableIndex = toIndex + 1;
  let t1;
  $[0] !== readableIndex || $[1] !== t ? (t1 = t("changes.array.item-added-in-position", {
    position: readableIndex
  }), $[0] = readableIndex, $[1] = t, $[2] = t1) : t1 = $[2];
  const description = t1;
  let t2;
  $[3] !== readableIndex ? (t2 = /* @__PURE__ */ jsxs(Fragment, { children: [
    "#",
    readableIndex
  ] }), $[3] = readableIndex, $[4] = t2) : t2 = $[4];
  const content = t2;
  let t3;
  $[5] !== change ? (t3 = change?.diff ? getAnnotationAtPath(change.diff, []) : void 0, $[5] = change, $[6] = t3) : t3 = $[6];
  const annotation = t3 || annotationProp;
  if (annotation) {
    let t42;
    $[7] !== description ? (t42 = {
      description
    }, $[7] = description, $[8] = t42) : t42 = $[8];
    let t5;
    $[9] === Symbol.for("react.memo_cache_sentinel") ? (t5 = {
      textDecoration: "none"
    }, $[9] = t5) : t5 = $[9];
    let t6;
    $[10] !== content ? (t6 = /* @__PURE__ */ jsx(AnnotationText, { size: 1, weight: "medium", forwardedAs: "ins", style: t5, children: content }), $[10] = content, $[11] = t6) : t6 = $[11];
    let t7;
    return $[12] !== annotation || $[13] !== t42 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(DiffCard, { annotation, tooltip: t42, as: RoundedCard$1, children: t6 }), $[12] = annotation, $[13] = t42, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
  }
  let t4;
  return $[16] !== content ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: content }), $[16] = content, $[17] = t4) : t4 = $[17], t4;
}
function DeletedTitleSegment(props2) {
  const $ = c(11), {
    annotation,
    fromIndex: t0
  } = props2, fromIndex = t0 === void 0 ? 0 : t0, {
    t
  } = useTranslation(), readableIndex = fromIndex + 1;
  let t1;
  $[0] !== readableIndex || $[1] !== t ? (t1 = t("changes.array.item-removed-from-position", {
    position: readableIndex
  }), $[0] = readableIndex, $[1] = t, $[2] = t1) : t1 = $[2];
  const description = t1, t2 = annotation || null;
  let t3;
  $[3] !== description ? (t3 = {
    description
  }, $[3] = description, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== readableIndex ? (t4 = /* @__PURE__ */ jsxs(AnnotationText, { size: 1, weight: "medium", forwardedAs: "del", children: [
    "#",
    readableIndex
  ] }), $[5] = readableIndex, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== t2 || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(DiffCard, { annotation: t2, as: RoundedCard$1, tooltip: t3, children: t4 }), $[7] = t2, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}
function MovedTitleSegment(props2) {
  const $ = c(19), {
    annotation,
    fromIndex,
    toIndex
  } = props2, {
    t
  } = useTranslation(), indexDiff = toIndex - fromIndex, indexSymbol = indexDiff < 0 ? "\u2191" : "\u2193";
  let t0;
  if ($[0] !== indexDiff || $[1] !== t) {
    const positions = Math.abs(indexDiff), direction = indexDiff < 0 ? "up" : "down";
    t0 = t("changes.array.item-moved", {
      count: positions,
      context: direction
    }), $[0] = indexDiff, $[1] = t, $[2] = t0;
  } else
    t0 = $[2];
  const description = t0, t1 = toIndex + 1;
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsxs(AnnotationText, { size: 1, weight: "medium", children: [
    "#",
    t1
  ] }) }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== description ? (t3 = {
    description
  }, $[5] = description, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== indexDiff ? (t4 = Math.abs(indexDiff), $[7] = indexDiff, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== indexSymbol || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsxs(AnnotationText, { size: 1, weight: "medium", children: [
    indexSymbol,
    t4
  ] }), $[9] = indexSymbol, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== annotation || $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(DiffCard, { annotation, as: RoundedCard$1, tooltip: t3, children: t5 }), $[12] = annotation, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  return $[16] !== t2 || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t2,
    t6
  ] }), $[16] = t2, $[17] = t6, $[18] = t7) : t7 = $[18], t7;
}
function ChangeBreadcrumb(props2) {
  const $ = c(8), {
    change,
    titlePath
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  if ($[1] !== change || $[2] !== titlePath) {
    let t22;
    $[4] !== change ? (t22 = (titleSegment, idx) => typeof titleSegment == "string" || !change || change.showIndex ? /* @__PURE__ */ jsx(ChangeTitleSegment, { change, segment: titleSegment }, idx) : null, $[4] = change, $[5] = t22) : t22 = $[5], t1 = titlePath.map(t22), $[1] = change, $[2] = titlePath, $[3] = t1;
  } else
    t1 = $[3];
  let t2;
  return $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Breadcrumbs, { maxLength: 4, separator: t0, children: t1 }), $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
function isThenable(value) {
  return isRecord$4(value) && typeof value?.then == "function";
}
function useCheckCondition(checkProperty, checkPropertyName, context) {
  const {
    currentUser,
    document: document2,
    parent,
    value
  } = context;
  return useMemo(() => {
    let isTrueIsh = !1;
    if (typeof checkProperty == "boolean" || checkProperty === void 0)
      return checkProperty || !1;
    try {
      isTrueIsh = checkProperty({
        document: document2,
        parent,
        value,
        currentUser
      });
    } catch (err) {
      return console.error(`An error occurred while running the callback from \`${checkPropertyName}\`: ${err.message}`), !1;
    }
    return isThenable(isTrueIsh) ? (console.warn(`The \`${checkPropertyName}\` option is either a promise or a promise returning function. Async callbacks for \`${checkPropertyName}\` option is not currently supported.`), !1) : (typeof isTrueIsh > "u" && console.warn(`The \`${checkPropertyName}\` option is or returned \`undefined\`. \`${checkPropertyName}\` should return a boolean.`), isTrueIsh);
  }, [checkProperty, document2, parent, value, currentUser, checkPropertyName]);
}
const useConditionalProperty = (props2) => {
  const $ = c(5), {
    checkProperty: t0,
    checkPropertyKey,
    document: document2,
    parent,
    value: valueProp
  } = props2, checkProperty = t0 === void 0 ? !1 : t0, value = useUnique(valueProp), currentUser = useCurrentUser();
  let t1;
  return $[0] !== currentUser || $[1] !== document2 || $[2] !== parent || $[3] !== value ? (t1 = {
    currentUser,
    document: document2,
    parent,
    value
  }, $[0] = currentUser, $[1] = document2, $[2] = parent, $[3] = value, $[4] = t1) : t1 = $[4], useCheckCondition(checkProperty, checkPropertyKey, t1);
};
function resolveTypeName$1(value) {
  return isTypedObject(value) ? value._type : resolveJSType$1(value);
}
function getArrayDiffItemType(diff, schemaType) {
  return diff.action === "added" ? {
    toType: resolveArrayMemberType(schemaType, diff.toValue)
  } : diff.action === "changed" ? {
    fromType: resolveArrayMemberType(schemaType, diff.fromValue),
    toType: resolveArrayMemberType(schemaType, diff.toValue)
  } : diff.action === "removed" ? {
    fromType: resolveArrayMemberType(schemaType, diff.fromValue)
  } : {
    toType: resolveArrayMemberType(schemaType, diff.toValue)
  };
}
function resolveArrayMemberType(schemaType, value) {
  const typeName = resolveTypeName$1(value);
  return schemaType.of.find((candidate) => candidate.name === typeName) || (schemaType.of.length === 1 ? schemaType.of[0] : void 0);
}
function resolveJSType$1(val) {
  return Array.isArray(val) ? "array" : val === null ? "null" : typeof val;
}
const ANNOTATION_SYMBOLS = [
  // [startTag, endTag]
  ["\uF050", "\uF051"],
  ["\uF052", "\uF053"],
  ["\uF054", "\uF055"],
  ["\uF056", "\uF057"],
  ["\uF058", "\uF059"],
  ["\uF05A", "\uF05B"],
  ["\uF05C", "\uF05D"],
  ["\uF05F", "\uF060"],
  ["\uF061", "\uF062"],
  ["\uF063", "\uF064"],
  ["\uF065", "\uF066"],
  ["\uF067", "\uF068"],
  ["\uF069", "\uF06A"],
  ["\uF06B", "\uF06C"],
  ["\uF06E", "\uF06F"],
  ["\uF070", "\uF071"],
  ["\uF072", "\uF073"],
  ["\uF074", "\uF075"],
  ["\uF076", "\uF077"],
  ["\uF078", "\uF079"],
  ["\uF07A", "\uF07B"],
  ["\uF07C", "\uF07D"],
  ["\uF07E", "\uF07F"],
  ["\uF080", "\uF081"],
  ["\uF082", "\uF083"],
  ["\uF084", "\uF085"],
  ["\uF086", "\uF087"],
  ["\uF088", "\uF089"],
  ["\uF08A", "\uF08B"],
  ["\uF08C", "\uF08D"],
  ["\uF08E", "\uF08F"]
], CHILD_SYMBOL$1 = "\uF0D0", DECORATOR_SYMBOLS = [
  // [startTag, endTag]
  ["\uF000", "\uF001"],
  ["\uF002", "\uF003"],
  ["\uF004", "\uF005"],
  ["\uF006", "\uF007"],
  ["\uF008", "\uF009"],
  ["\uF00A", "\uF00B"],
  ["\uF00C", "\uF00D"],
  ["\uF00F", "\uF010"],
  ["\uF011", "\uF012"],
  ["\uF013", "\uF014"],
  ["\uF015", "\uF016"],
  ["\uF017", "\uF018"],
  ["\uF019", "\uF01A"],
  ["\uF01B", "\uF01C"],
  ["\uF01E", "\uF01F"],
  ["\uF020", "\uF021"]
], EMPTY_BLOCK_SYMBOL = "\u21B2", INLINE_SYMBOLS = ["\uF090", "\uF091", "\uF092", "\uF093", "\uF094", "\uF095", "\uF096", "\uF097", "\uF098", "\uF099", "\uF09A", "\uF09B", "\uF09C", "\uF09D", "\uF09E", "\uF09F", "\uF0A0", "\uF0A1", "\uF0A2", "\uF0A3", "\uF0A4", "\uF0A5", "\uF0A6", "\uF0A7", "\uF0A8", "\uF0A9", "\uF0AA", "\uF0AB", "\uF0AC", "\uF0AD", "\uF0AE", "\uF0AF", "\uF0B0", "\uF0B1", "\uF0B2", "\uF0B3", "\uF0B4", "\uF0B5", "\uF0B6", "\uF0B7", "\uF0B8", "\uF0B9", "\uF0BA", "\uF0BB", "\uF0BC", "\uF0BD", "\uF0BE", "\uF0BF"], TRAILING_SPACE_SYMBOL = "\u205F", SEGMENT_START_SYMBOL = "\u2060";
function hasPTMemberType(schemaType) {
  return schemaType.of.some(isPTSchemaType);
}
const startMarkSymbols = DECORATOR_SYMBOLS.map((set2) => set2[0]).concat(ANNOTATION_SYMBOLS.map((set2) => set2[0])), endMarkSymbols = DECORATOR_SYMBOLS.map((set2) => set2[1]).concat(ANNOTATION_SYMBOLS.map((set2) => set2[1])), allSymbols = startMarkSymbols.concat(endMarkSymbols).concat(INLINE_SYMBOLS).concat(CHILD_SYMBOL$1).concat(SEGMENT_START_SYMBOL), symbolRegex = new RegExp(`${allSymbols.join("|")}`, "g"), segmentRegex = new RegExp(`${allSymbols.join("|")}|
`, "g");
function isPTSchemaType(schemaType) {
  return schemaType.jsonType === "object" && schemaType.name === "block";
}
function isHeader(node) {
  return isPortableTextTextBlock(node) && !!node.style && ["h1", "h2", "h3", "h4", "h5", "h6"].includes(node.style);
}
function findChildDiff(diff, child) {
  return diff.fields.children.items.filter((item) => item.diff.isChanged && (item.diff.toValue === child || item.diff.fromValue === child)).map((item) => item.diff).map((childDiff) => childDiff)[0];
}
function getChildSchemaType(fields, child) {
  const childrenField = fields.find((f) => f.name === "children");
  return childrenField && childrenField.type && childrenField.type.jsonType === "array" && childrenField.type.of.find((type) => type.name === child._type) || void 0;
}
function getDecorators(spanSchemaType) {
  return spanSchemaType.decorators ? orderBy(spanSchemaType.decorators, ["value"], ["asc"]) : [];
}
function isDecorator(name, schemaType) {
  return getDecorators(schemaType).some((dec2) => dec2.value === name);
}
function blockToSymbolizedText(diff, block, decoratorMap, annotationMap, inlineMap) {
  return block ? block.children.map((child) => {
    let returned = isPortableTextSpan(child) ? child.text?.replace(symbolRegex, "") : "";
    if (isPortableTextSpan(child)) {
      const textDiff = findSpanDiffFromChild(diff, child)?.fields.text;
      textDiff && textDiff.toValue === child.text && textDiff.type === "string" && textDiff.action !== "unchanged" && (returned = textDiff.segments.filter((seg) => seg.action !== "removed").map((seg) => seg.text.replace(symbolRegex, "")).join(SEGMENT_START_SYMBOL)), child.marks && child.marks.forEach((mark) => {
        decoratorMap[mark] ? returned = `${decoratorMap[mark][0]}${returned}${decoratorMap[mark][1]}` : annotationMap[mark] && (returned = `${annotationMap[mark][0]}${returned}${annotationMap[mark][1]}`);
      });
    } else
      returned = inlineMap[child._key];
    return `${CHILD_SYMBOL$1}${returned}`;
  }).join("") : "";
}
function createPortableTextDiff(diff, schemaType) {
  const displayValue = diff.action === "removed" ? diff.fromValue : diff.toValue, _diff = {
    ...diff,
    origin: diff
  };
  if (displayValue) {
    const annotationMap = {}, decoratorMap = {}, inlineMap = {}, spanSchemaType = getChildSchemaType(schemaType.fields, {
      _type: "span"
    });
    spanSchemaType && getDecorators(spanSchemaType).forEach((dec2, index) => {
      decoratorMap[dec2.value] = DECORATOR_SYMBOLS[index];
    }), getAllMarkDefs(_diff.origin).forEach((markDef, index) => {
      annotationMap[markDef._key] = ANNOTATION_SYMBOLS[index];
    }), getInlineObjects(_diff.origin).forEach((inline, index) => {
      inlineMap[inline._key] = INLINE_SYMBOLS[index];
    });
    const fromText = blockToSymbolizedText(_diff.origin, _diff.fromValue, decoratorMap, annotationMap, inlineMap), toText = blockToSymbolizedText(_diff.origin, _diff.toValue, decoratorMap, annotationMap, inlineMap), toPseudoValue = {
      ...displayValue,
      children: [{
        _type: "span",
        _key: "pseudoSpanKey",
        text: toText,
        marks: []
      }]
    }, fromPseudoValue = {
      displayValue,
      children: [{
        _type: "span",
        _key: "pseudoSpanKey",
        text: fromText,
        marks: []
      }]
    };
    return {
      origin: diff,
      action: "changed",
      type: "object",
      displayValue: toPseudoValue,
      fromValue: fromPseudoValue,
      toValue: toPseudoValue,
      isChanged: !0,
      fields: {
        children: {
          action: "changed",
          type: "array",
          isChanged: !0,
          items: [{
            diff: {
              action: "changed",
              type: "object",
              isChanged: !0,
              fields: {
                text: {
                  type: "string",
                  action: "changed",
                  isChanged: !0,
                  fromValue: fromText,
                  toValue: toText,
                  segments: buildSegments(fromText, toText).map((seg) => ({
                    ...seg,
                    ..._diff.action !== "unchanged" && _diff.annotation ? {
                      annotation: _diff.annotation
                    } : {}
                  }))
                }
              },
              fromValue: fromPseudoValue.children[0],
              toValue: toPseudoValue.children[0]
            },
            annotation: null,
            fromIndex: 0,
            toIndex: 0,
            hasMoved: !1
          }],
          fromValue: fromPseudoValue.children,
          toValue: toPseudoValue.children
        }
      }
    };
  }
  throw new Error("Can not display this diff");
}
function buildSegments(fromInput, toInput) {
  const segments = [], dmpDiffs = cleanupEfficiency(makeDiff(fromInput, toInput));
  let fromIdx = 0, toIdx = 0;
  for (const [op, text] of dmpDiffs)
    switch (op) {
      case DIFF_EQUAL:
        segments.push({
          type: "stringSegment",
          action: "unchanged",
          text
        }), fromIdx += text.length, toIdx += text.length;
        break;
      case DIFF_DELETE:
        segments.push({
          type: "stringSegment",
          action: "removed",
          text: fromInput.slice(fromIdx, fromIdx + text.length),
          annotation: null
        }), fromIdx += text.length;
        break;
      case DIFF_INSERT:
        segments.push({
          type: "stringSegment",
          action: "added",
          text: toInput.slice(toIdx, toIdx + text.length),
          annotation: null
        }), toIdx += text.length;
        break;
    }
  return flatten$1(segments.map((seg) => {
    const newSegments = [];
    if (seg.text.length > 1) {
      const markMatches = [...seg.text.matchAll(segmentRegex)];
      let lastIndex = -1;
      markMatches.forEach((match) => {
        const index = match.index || 0;
        index > lastIndex && (newSegments.push({
          ...seg,
          text: seg.text.slice(lastIndex + 1, index)
        }), newSegments.push({
          ...seg,
          text: match[0]
        })), match === markMatches[markMatches.length - 1] && newSegments.push({
          ...seg,
          text: seg.text.slice(Math.max(0, index + 1))
        }), lastIndex = index;
      }), markMatches.length === 0 && newSegments.push(seg);
    } else
      newSegments.push(seg);
    return newSegments;
  }));
}
function getInlineObjects(diff) {
  const allChildren = [...diff.toValue ? diff.toValue.children.filter((cld) => cld._type !== "span") : []];
  return (diff.fromValue ? diff.fromValue.children.filter((cld) => cld._type !== "span") : []).forEach((oCld) => {
    allChildren.some((cld) => oCld._key === cld._key) || allChildren.push(oCld);
  }), orderBy(allChildren, ["_key"], ["asc"]);
}
function findSpanDiffFromChild(diff, child) {
  const candidate = diff.fields.children && diff.fields.children.action !== "unchanged" && diff.fields.children.type === "array" && diff.fields.children.items.find((item) => item.diff && item.diff.type === "object" && (item.diff.action === "removed" ? item.diff.fromValue && item.diff.fromValue._key === child._key : (item.diff.toValue && item.diff.toValue._key) === child._key));
  if (candidate)
    return candidate.diff;
}
function findAnnotationDiff(diff, markDefKey) {
  return diff.fields.markDefs && diff.fields.markDefs.isChanged && diff.fields.markDefs.type === "array" && diff.fields.markDefs.items.find((item) => item.diff && item.diff.type === "object" && (item.diff.toValue && item.diff.toValue._key && item.diff.toValue._key === markDefKey || item.diff.fromValue && item.diff.fromValue._key && item.diff.fromValue._key === markDefKey))?.diff || void 0;
}
function isEmptyObject(object) {
  return object && isEqual$2(Object.keys(object), ["_key", "_type"]) || !1;
}
function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
function getAllMarkDefs(diff) {
  const allDefs = [...diff.toValue && diff.toValue.markDefs ? diff.toValue.markDefs : []];
  return (diff.fromValue && diff.fromValue.markDefs ? diff.fromValue.markDefs : []).forEach((oDef) => {
    allDefs.some((def) => oDef._key === def._key) || allDefs.push(oDef);
  }), orderBy(allDefs, ["_key"], ["asc"]);
}
function getPrintableType(value) {
  const nativeType = typeof value;
  if (nativeType === "object") {
    if (value === null) return "null";
    if (Array.isArray(value)) return "array";
    if (value instanceof Object && value.constructor.name !== "Object")
      return value.constructor.name;
  }
  return nativeType;
}
function getValueError(value, schemaType) {
  const {
    jsonType
  } = schemaType, valueType = Array.isArray(value) ? "array" : typeof value;
  if (!(value === null || valueType === "undefined")) {
    if (valueType !== jsonType)
      return {
        messageKey: "changes.error.incorrect-type-message",
        value,
        expectedType: jsonType,
        actualType: getPrintableType(value)
      };
    if (isObjectType(schemaType) && isObjectValue(value))
      for (const field of schemaType.fields) {
        const fieldError = getValueError(value[field.name], field.type);
        if (fieldError)
          return fieldError;
      }
  }
}
function isObjectType(schemaType) {
  return schemaType.jsonType === "object";
}
function isObjectValue(value) {
  return value !== null && !Array.isArray(value) && typeof value == "object";
}
function noop$1() {
}
function isFieldChange(change) {
  return change.type === "field";
}
function isGroupChange(change) {
  return change.type === "group";
}
function isAddedItemDiff(item) {
  return item.diff.action === "added";
}
function isRemovedItemDiff(item) {
  return item.diff.action === "removed";
}
function isUnchangedDiff(diff) {
  return diff.action === "unchanged";
}
const diffResolvers = [];
function Checkbox(t0) {
  const $ = c(11), {
    checked,
    color
  } = t0, t1 = color?.background;
  let t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx("rect", { x: "0", y: "0", width: "17", height: "17", rx: "2.5" }), $[0] = t2) : t2 = $[0];
  let t3;
  $[1] !== checked || $[2] !== color?.text ? (t3 = typeof checked > "u" && /* @__PURE__ */ jsx("path", { d: "M4.07996 8.5H12.92", stroke: color?.text, strokeWidth: "2" }), $[1] = checked, $[2] = color?.text, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== checked || $[5] !== color?.text ? (t4 = checked && /* @__PURE__ */ jsx("path", { d: "M3.5 8L7 11.5L13.5 5", stroke: color?.text, strokeWidth: "2" }), $[4] = checked, $[5] = color?.text, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== t1 || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsxs("svg", { width: "17", height: "17", viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg", fill: t1, children: [
    t2,
    t3,
    t4
  ] }), $[7] = t1, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}
function Switch(t0) {
  const $ = c(13), {
    checked,
    color
  } = t0, t1 = checked ? color?.border : color?.background;
  let t2;
  $[0] !== t1 ? (t2 = /* @__PURE__ */ jsx("rect", { width: "38", height: "22", rx: "11", fill: t1 }), $[0] = t1, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== checked ? (t3 = typeof checked > "u" && /* @__PURE__ */ jsx("rect", { x: "11", y: "3", width: "16", height: "16", rx: "8", fill: "white" }), $[2] = checked, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== checked ? (t4 = checked && /* @__PURE__ */ jsx("rect", { x: "18", y: "3", width: "16", height: "16", rx: "8", fill: "white" }), $[4] = checked, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== checked ? (t5 = typeof checked == "boolean" && !checked && /* @__PURE__ */ jsx("rect", { x: "4", y: "3", width: "16", height: "16", rx: "8", fill: "white" }), $[6] = checked, $[7] = t5) : t5 = $[7];
  let t6;
  return $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs("svg", { width: "38", height: "22", viewBox: "0 0 38 22", xmlns: "http://www.w3.org/2000/svg", children: [
    t2,
    t3,
    t4,
    t5
  ] }), $[8] = t2, $[9] = t3, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
const BooleanFieldDiff = (t0) => {
  const $ = c(24), {
    diff,
    schemaType
  } = t0, {
    fromValue,
    toValue
  } = diff, {
    title,
    options
  } = schemaType, Preview2 = options?.layout === "checkbox" ? Checkbox : Switch;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[0] = t1) : t1 = $[0];
  const userColor = useDiffAnnotationColor(diff, t1), {
    showFromValue
  } = useDocumentChange(), showToValue = toValue != null;
  let t2;
  $[1] !== Preview2 || $[2] !== fromValue || $[3] !== showFromValue || $[4] !== userColor ? (t2 = showFromValue && /* @__PURE__ */ jsx(Preview2, { checked: fromValue, color: userColor }), $[1] = Preview2, $[2] = fromValue, $[3] = showFromValue, $[4] = userColor, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== Preview2 || $[7] !== showFromValue || $[8] !== showToValue || $[9] !== toValue || $[10] !== userColor ? (t3 = showToValue && /* @__PURE__ */ jsxs(Fragment, { children: [
    showFromValue && /* @__PURE__ */ jsx(Box, { marginX: 2, children: /* @__PURE__ */ jsx(FromToArrow, {}) }),
    /* @__PURE__ */ jsx(Preview2, { checked: toValue, color: userColor })
  ] }), $[6] = Preview2, $[7] = showFromValue, $[8] = showToValue, $[9] = toValue, $[10] = userColor, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== t2 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t2,
    t3
  ] }), $[12] = t2, $[13] = t3, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== diff || $[16] !== t4 ? (t5 = /* @__PURE__ */ jsx(DiffTooltip, { diff, children: t4 }), $[15] = diff, $[16] = t4, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== showToValue || $[19] !== title ? (t6 = showToValue && title && /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: title }) }), $[18] = showToValue, $[19] = title, $[20] = t6) : t6 = $[20];
  let t7;
  return $[21] !== t5 || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t5,
    t6
  ] }), $[21] = t5, $[22] = t6, $[23] = t7) : t7 = $[23], t7;
}, DatetimeWrapper = styled.div`
  display: inline-block;
  word-wrap: break-word;
`, DatetimePreview = function(t0) {
  const $ = c(5), {
    value,
    schemaType
  } = t0;
  let t1;
  $[0] !== schemaType || $[1] !== value ? (t1 = formatDateTime(value, schemaType), $[0] = schemaType, $[1] = value, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { as: DatetimeWrapper, paddingX: 2, paddingY: 1, children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
};
function formatDateTime(value, schemaType) {
  const {
    options,
    name
  } = schemaType, dateFormat = options?.dateFormat || legacyDateFormat.DEFAULT_DATE_FORMAT, timeFormat = options?.timeFormat || legacyDateFormat.DEFAULT_TIME_FORMAT;
  return legacyDateFormat.format(new Date(value), name === "date" ? dateFormat : `${dateFormat} ${timeFormat}`);
}
const DatetimeFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { align: "center", diff, layout: "grid", previewComponent: DatetimePreview, schemaType }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
};
function useDocumentChange() {
  const documentChange = useContext(DocumentChangeContext);
  if (!documentChange)
    throw new Error("DocumentChange: missing context value");
  return documentChange;
}
function useRefValue(refId) {
  const $ = c(4), [value, setValue] = useState(void 0), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0, t1;
  return $[0] !== client || $[1] !== refId ? (t0 = () => {
    if (!refId)
      return;
    const subscription = client.observable.getDocument(refId).subscribe(setValue);
    return () => {
      subscription.unsubscribe();
    };
  }, t1 = [client, refId], $[0] = client, $[1] = refId, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), refId ? value : void 0;
}
const SizeDiff = styled.div`
  ${({
  theme
}) => `
    --size-diff-positive: ${theme.sanity.color.solid.positive.enabled.bg};
    --size-diff-negative: ${theme.sanity.color.solid.critical.enabled.bg};
  `}
  &:not([hidden]) {
    display: inline-block;
  }

  [data-number='positive'] {
    color: var(--size-diff-positive);
  }

  [data-number='negative'] {
    color: var(--size-diff-negative);
  }
`, FileFieldDiff = (t0) => {
  const $ = c(51), {
    diff,
    schemaType
  } = t0, {
    fromValue,
    toValue,
    fields
  } = diff, fromAsset = fromValue?.asset, toAsset = toValue?.asset, {
    t
  } = useTranslation(), prev = useRefValue(fromAsset?._ref), next = useRefValue(toAsset?._ref);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    unitDisplay: "short",
    maximumFractionDigits: 2
  }, $[0] = t1) : t1 = $[0];
  const formatUnit = useUnitFormatter(t1);
  let t2;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t2 = ["_type", "media"], $[1] = t2) : t2 = $[1];
  const ignoredFields = t2;
  let didAssetChange, t3;
  if ($[2] !== fields || $[3] !== schemaType.fields) {
    let t42;
    $[6] === Symbol.for("react.memo_cache_sentinel") ? (t42 = (t52) => {
      const [name, field] = t52;
      return field.isChanged && !ignoredFields.includes(name);
    }, $[6] = t42) : t42 = $[6];
    const changedFields = Object.entries(fields).filter(t42).map(_temp$15);
    didAssetChange = changedFields.includes("asset"), t3 = schemaType.fields.filter((field_0) => field_0.name !== "asset" && changedFields.includes(field_0.name)).map(_temp2$k), $[2] = fields, $[3] = schemaType.fields, $[4] = didAssetChange, $[5] = t3;
  } else
    didAssetChange = $[4], t3 = $[5];
  const nestedFields = t3, pctDiff = getSizeDiff(prev?.size, next?.size);
  let t4;
  $[7] !== formatUnit || $[8] !== prev ? (t4 = prev?.size && getHumanFriendlyBytes(prev.size, formatUnit), $[7] = formatUnit, $[8] = prev, $[9] = t4) : t4 = $[9];
  const prevSize = t4;
  let t5;
  $[10] !== formatUnit || $[11] !== next ? (t5 = next?.size && getHumanFriendlyBytes(next.size, formatUnit), $[10] = formatUnit, $[11] = next, $[12] = t5) : t5 = $[12];
  const nextSize = t5;
  let t6, t7;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    display: "block",
    flex: 1
  }, $[13] = t7) : t7 = $[13], t6 = t7;
  const cardStyles2 = t6;
  let t8;
  $[14] !== diff || $[15] !== prev || $[16] !== prevSize || $[17] !== t ? (t8 = prev && /* @__PURE__ */ jsx(DiffCard, { as: "del", diff, path: "asset._ref", style: cardStyles2, children: /* @__PURE__ */ jsx(MetaInfo, { title: prev.originalFilename || t("changes.file.meta-info-fallback-title"), icon: DocumentIcon, children: /* @__PURE__ */ jsx(Text$1, { size: 0, style: {
    color: "inherit"
  }, children: prevSize }) }) }), $[14] = diff, $[15] = prev, $[16] = prevSize, $[17] = t, $[18] = t8) : t8 = $[18];
  const from2 = t8;
  let t9;
  $[19] !== diff || $[20] !== next || $[21] !== nextSize || $[22] !== pctDiff || $[23] !== t ? (t9 = next && /* @__PURE__ */ jsx(DiffCard, { as: "ins", diff, path: "asset._ref", style: cardStyles2, children: /* @__PURE__ */ jsx(MetaInfo, { title: next.originalFilename || t("changes.file.meta-info-fallback-title"), icon: DocumentIcon, children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    /* @__PURE__ */ jsx(Text$1, { size: 0, style: {
      color: "inherit"
    }, children: nextSize }),
    pctDiff !== 0 && /* @__PURE__ */ jsx(Card, { radius: 2, padding: 1, as: SizeDiff, marginLeft: 2, children: /* @__PURE__ */ jsxs(Text$1, { size: 0, "data-number": pctDiff > 0 ? "positive" : "negative", children: [
      pctDiff > 0 ? "+" : "-",
      pctDiff,
      "%"
    ] }) })
  ] }) }) }), $[19] = diff, $[20] = next, $[21] = nextSize, $[22] = pctDiff, $[23] = t, $[24] = t9) : t9 = $[24];
  const to = t9;
  let t10;
  $[25] !== diff || $[26] !== from2 || $[27] !== t || $[28] !== to ? (t10 = from2 && !to && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "asset._ref", description: t("changes.removed-label"), children: from2 }), $[25] = diff, $[26] = from2, $[27] = t, $[28] = to, $[29] = t10) : t10 = $[29];
  let t11;
  $[30] !== diff || $[31] !== from2 || $[32] !== to ? (t11 = from2 && to && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "asset._ref", children: /* @__PURE__ */ jsx(FromTo, { from: from2, layout: "grid", to }) }), $[30] = diff, $[31] = from2, $[32] = to, $[33] = t11) : t11 = $[33];
  let t12;
  $[34] !== diff || $[35] !== from2 || $[36] !== t || $[37] !== to ? (t12 = !from2 && to && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "asset._ref", description: t("changes.added-label"), children: to }), $[34] = diff, $[35] = from2, $[36] = t, $[37] = to, $[38] = t12) : t12 = $[38];
  let t13;
  $[39] !== t10 || $[40] !== t11 || $[41] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t10,
    t11,
    t12
  ] }), $[39] = t10, $[40] = t11, $[41] = t12, $[42] = t13) : t13 = $[42];
  const t14 = didAssetChange && t13;
  let t15;
  $[43] !== didAssetChange || $[44] !== diff || $[45] !== nestedFields || $[46] !== schemaType ? (t15 = nestedFields.length > 0 && /* @__PURE__ */ jsx(Box, { marginTop: didAssetChange ? 4 : 3, children: /* @__PURE__ */ jsx(ChangeList, { diff, schemaType, fields: nestedFields }) }), $[43] = didAssetChange, $[44] = diff, $[45] = nestedFields, $[46] = schemaType, $[47] = t15) : t15 = $[47];
  let t16;
  return $[48] !== t14 || $[49] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t14,
    t15
  ] }), $[48] = t14, $[49] = t15, $[50] = t16) : t16 = $[50], t16;
};
function _temp$15(t0) {
  const [name_0] = t0;
  return name_0;
}
function _temp2$k(field_1) {
  return field_1.name;
}
function hexToRgba(hex, opacity) {
  return `rgba(${(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex) || []).slice(1).map((num) => parseInt(num, 16)).concat(opacity).join(", ")})`;
}
function simpleHash(str) {
  let hash2 = 0;
  if (str.length == 0)
    return hash2.toString();
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash2 = (hash2 << 5) - hash2 + char, hash2 &= hash2;
  }
  return hash2.toString();
}
function getDeviceDpr() {
  const base = Math.ceil(window.devicePixelRatio || 1);
  return Math.min(3, Math.max(1, base));
}
function HotspotCropSVG(props2) {
  const $ = c(40);
  let crop, diff, hash2, hotspot, restProps, t0, t1;
  $[0] !== props2 ? ({
    crop,
    diff,
    hash: hash2,
    hotspot,
    width: t0,
    height: t1,
    ...restProps
  } = props2, $[0] = props2, $[1] = crop, $[2] = diff, $[3] = hash2, $[4] = hotspot, $[5] = restProps, $[6] = t0, $[7] = t1) : (crop = $[1], diff = $[2], hash2 = $[3], hotspot = $[4], restProps = $[5], t0 = $[6], t1 = $[7]);
  const width = t0 === void 0 ? 100 : t0, height = t1 === void 0 ? 100 : t1, {
    t
  } = useTranslation(), cropColor = useDiffAnnotationColor(diff, "crop"), hotspotColor = useDiffAnnotationColor(diff, "hotspot"), t2 = `0 0 ${width} ${height}`;
  let t3;
  $[8] !== crop || $[9] !== hash2 || $[10] !== height || $[11] !== hotspot || $[12] !== width ? (t3 = crop && hotspot && /* @__PURE__ */ jsxs("mask", { id: `mask-hotspot-${hash2}`, children: [
    /* @__PURE__ */ jsx("rect", { x: 0, y: 0, width, height, fill: "#fff" }),
    /* @__PURE__ */ jsx(HotspotSVG, { hotspot, fill: "#000", offset: 1, width, height, stroke: "#000", strokeWidth: 3 })
  ] }), $[8] = crop, $[9] = hash2, $[10] = height, $[11] = hotspot, $[12] = width, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== t3 ? (t4 = /* @__PURE__ */ jsx("defs", { children: t3 }), $[14] = t3, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== crop || $[17] !== cropColor || $[18] !== diff || $[19] !== hash2 || $[20] !== height || $[21] !== hotspot || $[22] !== t || $[23] !== width ? (t5 = crop && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "crop", description: t("changes.image.crop-changed"), children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(CropSVG, { crop, fill: hexToRgba(cropColor.border, 0.25), mask: hotspot ? `url(#mask-hotspot-${hash2})` : void 0, stroke: cropColor.border, strokeWidth: 1, width, height }) }) }), $[16] = crop, $[17] = cropColor, $[18] = diff, $[19] = hash2, $[20] = height, $[21] = hotspot, $[22] = t, $[23] = width, $[24] = t5) : t5 = $[24];
  let t6;
  $[25] !== diff || $[26] !== height || $[27] !== hotspot || $[28] !== hotspotColor || $[29] !== t || $[30] !== width ? (t6 = hotspot && /* @__PURE__ */ jsx(DiffTooltip, { diff, path: "hotspot", description: t("changes.image.crop-changed"), children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(HotspotSVG, { hotspot, fill: hexToRgba(hotspotColor.border, 0.25), stroke: hotspotColor.border, strokeWidth: 1, width, height }) }) }), $[25] = diff, $[26] = height, $[27] = hotspot, $[28] = hotspotColor, $[29] = t, $[30] = width, $[31] = t6) : t6 = $[31];
  let t7;
  return $[32] !== height || $[33] !== restProps || $[34] !== t2 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 || $[38] !== width ? (t7 = /* @__PURE__ */ jsxs("svg", { ...restProps, fill: "none", width, height, viewBox: t2, children: [
    t4,
    t5,
    t6
  ] }), $[32] = height, $[33] = restProps, $[34] = t2, $[35] = t4, $[36] = t5, $[37] = t6, $[38] = width, $[39] = t7) : t7 = $[39], t7;
}
function CropSVG(t0) {
  const $ = c(14);
  let crop, height, restProps, width;
  $[0] !== t0 ? ({
    crop,
    width,
    height,
    ...restProps
  } = t0, $[0] = t0, $[1] = crop, $[2] = height, $[3] = restProps, $[4] = width) : (crop = $[1], height = $[2], restProps = $[3], width = $[4]);
  const t1 = crop.left * width, t2 = crop.top * height, t3 = (1 - crop.right - crop.left) * width, t4 = (1 - crop.bottom - crop.top) * height;
  let t5;
  $[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 ? (t5 = {
    x: t1,
    y: t2,
    width: t3,
    height: t4
  }, $[5] = t1, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  const rectProps = t5;
  let t6;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    vectorEffect: "non-scaling-stroke"
  }, $[10] = t6) : t6 = $[10];
  let t7;
  return $[11] !== rectProps || $[12] !== restProps ? (t7 = /* @__PURE__ */ jsx("rect", { ...restProps, ...rectProps, style: t6 }), $[11] = rectProps, $[12] = restProps, $[13] = t7) : t7 = $[13], t7;
}
function HotspotSVG(t0) {
  const $ = c(15);
  let height, hotspot, restProps, t1, width;
  $[0] !== t0 ? ({
    hotspot,
    offset: t1,
    width,
    height,
    ...restProps
  } = t0, $[0] = t0, $[1] = height, $[2] = hotspot, $[3] = restProps, $[4] = t1, $[5] = width) : (height = $[1], hotspot = $[2], restProps = $[3], t1 = $[4], width = $[5]);
  const offset = t1 === void 0 ? 0 : t1, t2 = hotspot.x * width, t3 = hotspot.y * height, t4 = hotspot.width / 2 * width + offset, t5 = hotspot.height / 2 * height + offset;
  let t6;
  $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 ? (t6 = {
    cx: t2,
    cy: t3,
    rx: t4,
    ry: t5
  }, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5, $[10] = t6) : t6 = $[10];
  const ellipseProps = t6;
  let t7;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    vectorEffect: "non-scaling-stroke"
  }, $[11] = t7) : t7 = $[11];
  let t8;
  return $[12] !== ellipseProps || $[13] !== restProps ? (t8 = /* @__PURE__ */ jsx("ellipse", { ...restProps, ...ellipseProps, style: t7 }), $[12] = ellipseProps, $[13] = restProps, $[14] = t8) : t8 = $[14], t8;
}
const ASSET_FIELDS = ["originalFilename"], NoImagePreview = () => {
  const $ = c(4), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("changes.image.no-image-placeholder"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Card, { flex: 1, tone: "transparent", padding: 4, radius: 2, height: "stretch", children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", height: "fill", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t0 }) }) }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}, ImageWrapper = styled.div`
  height: 100%;
  max-height: 190px;
  position: relative;

  /* Ideally the checkerboard component currently in the form builder should be made available and used here */
  background-color: ${hues.gray[100].hex};
  background-image:
    linear-gradient(45deg, ${hues.gray[50].hex} 25%, transparent 25%),
    linear-gradient(-45deg, ${hues.gray[50].hex} 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, ${hues.gray[50].hex} 75%),
    linear-gradient(-45deg, transparent 75%, ${hues.gray[50].hex} 75%);
  background-size: 16px 16px;
  background-position:
    0 0,
    0 8px,
    8px -8px,
    -8px 0;

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: inset 0 0 0 1px var(--card-border-color);
    pointer-events: none;
  }

  &[data-changed] {
    opacity: 0.45;
  }
`, Image$5 = styled.img`
  display: block;
  flex: 1;
  min-height: 0;
  object-fit: contain;
  width: 100%;
  height: 100%;

  &[data-action='removed'] {
    opacity: 0.45;
  }
`, HotspotDiff = styled.div`
  svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
function ImagePreview$1(props2) {
  const {
    id: id2,
    action,
    diff,
    hotspot,
    crop,
    is: is2
  } = props2, {
    t
  } = useTranslation(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [imageError, setImageError] = useState(), {
    value: asset
  } = useDocumentValues(id2, ASSET_FIELDS), dimensions = getImageDimensions(id2), imageBuilder = useMemo(() => imageUrlBuilder(client), [client]), assetIsDeleted = asset === null, title = asset && asset.originalFilename, imageSource = imageBuilder.image(id2).height(190).dpr(getDeviceDpr()).fit("max"), assetChanged = diff.fromValue?.asset?._ref !== diff.toValue?.asset?._ref;
  let printAction;
  action && action !== "changed" && (printAction = t(action === "added" ? "changes.added-label" : "changes.removed-label"));
  const metaAction = action === "changed" ? void 0 : action;
  return /* @__PURE__ */ jsxs(Flex, { direction: "column", height: "fill", flex: 1, children: [
    /* @__PURE__ */ jsx(Box, { flex: 1, padding: 2, paddingBottom: 0, children: /* @__PURE__ */ jsxs(Flex, { as: ImageWrapper, direction: "column", "data-changed": is2 === "from" && assetChanged ? "" : void 0, "data-error": imageError ? "" : void 0, children: [
      !assetIsDeleted && !imageError && /* @__PURE__ */ jsx(Image$5, { src: imageSource.toString() || "", alt: title, "data-action": metaAction, onError: setImageError, width: dimensions.width, height: dimensions.height }),
      (assetIsDeleted || imageError) && /* @__PURE__ */ jsx(Box, { paddingY: 5, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, align: "center", children: t(assetIsDeleted ? "changes.image.deleted" : "changes.image.error-loading-image") }) }),
      /* @__PURE__ */ jsx(HotspotDiff, { children: /* @__PURE__ */ jsx(HotspotCropSVG, { crop: crop && !isDefaultCrop(crop) ? crop : void 0, diff, hash: simpleHash(`${imageSource.toString() || ""}-${is2}`), hotspot: hotspot && !isDefaultHotspot(hotspot) ? hotspot : void 0, width: dimensions.width, height: dimensions.height }) })
    ] }) }),
    /* @__PURE__ */ jsx(MetaInfo, { title: title || t("changes.image.meta-info-fallback-title"), icon: ImageIcon, markRemoved: assetChanged && is2 === "from", children: printAction ? /* @__PURE__ */ jsx("div", { children: printAction }) : /* @__PURE__ */ jsxs("div", { children: [
      dimensions.width,
      " \xD7 ",
      dimensions.height
    ] }) })
  ] });
}
const IMAGE_META_FIELDS = ["crop", "hotspot"], BASE_IMAGE_FIELDS = ["asset", "media", ...IMAGE_META_FIELDS], CARD_STYLES = {
  flex: 1
}, ImageFieldDiff = (t0) => {
  const $ = c(55), {
    diff,
    schemaType
  } = t0, {
    t
  } = useTranslation(), {
    showFromValue
  } = useDocumentChange(), {
    fromValue,
    toValue,
    fields,
    isChanged
  } = diff, fromRef = fromValue?.asset?._ref, toRef = toValue?.asset?._ref;
  let t1;
  $[0] !== diff ? (t1 = getAnnotationAtPath(diff, ["asset", "_ref"]), $[0] = diff, $[1] = t1) : t1 = $[1];
  const assetAnnotation = t1;
  let t2;
  $[2] !== fields ? (t2 = Object.keys(fields), $[2] = fields, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== fields || $[5] !== t2 ? (t3 = t2.filter((name) => fields[name].isChanged && name !== "_type"), $[4] = fields, $[5] = t2, $[6] = t3) : t3 = $[6];
  const changedFields = t3;
  let t4;
  if ($[7] !== changedFields || $[8] !== schemaType.fields) {
    let t52;
    $[10] !== changedFields ? (t52 = (field) => !BASE_IMAGE_FIELDS.includes(field.name) && changedFields.includes(field.name), $[10] = changedFields, $[11] = t52) : t52 = $[11], t4 = schemaType.fields.filter(t52).map(_temp$14), $[7] = changedFields, $[8] = schemaType.fields, $[9] = t4;
  } else
    t4 = $[9];
  const nestedFields = t4;
  let assetAction = "changed";
  !fromRef && toRef ? assetAction = "added" : !toRef && fromRef && (assetAction = "removed");
  const didAssetChange = changedFields.includes("asset"), didCropChange = changedFields.includes("crop"), didHotspotChange = changedFields.includes("hotspot"), didMetaChange = didCropChange || didHotspotChange, showImageDiff = didAssetChange || didMetaChange, showMetaChange = didMetaChange && !didAssetChange;
  let t5;
  $[12] !== assetAction || $[13] !== assetAnnotation || $[14] !== didCropChange || $[15] !== didHotspotChange || $[16] !== diff || $[17] !== fromRef || $[18] !== fromValue || $[19] !== showMetaChange ? (t5 = fromValue && fromRef ? /* @__PURE__ */ jsx(DiffCard, { annotation: assetAnnotation, style: CARD_STYLES, children: /* @__PURE__ */ jsx(ImagePreview$1, { is: "from", id: fromRef, diff, action: assetAction, hotspot: showMetaChange && didHotspotChange ? fromValue.hotspot : void 0, crop: showMetaChange && didCropChange ? fromValue.crop : void 0 }) }) : /* @__PURE__ */ jsx(NoImagePreview, {}), $[12] = assetAction, $[13] = assetAnnotation, $[14] = didCropChange, $[15] = didHotspotChange, $[16] = diff, $[17] = fromRef, $[18] = fromValue, $[19] = showMetaChange, $[20] = t5) : t5 = $[20];
  const from2 = t5;
  let t6;
  $[21] !== assetAnnotation || $[22] !== didCropChange || $[23] !== didHotspotChange || $[24] !== diff || $[25] !== showMetaChange || $[26] !== toRef || $[27] !== toValue ? (t6 = toValue && toRef ? /* @__PURE__ */ jsx(DiffCard, { annotation: assetAnnotation, style: CARD_STYLES, children: /* @__PURE__ */ jsx(ImagePreview$1, { is: "to", id: toRef, diff, hotspot: showMetaChange && didHotspotChange ? toValue.hotspot : void 0, crop: showMetaChange && didCropChange ? toValue.crop : void 0 }) }) : /* @__PURE__ */ jsx(NoImagePreview, {}), $[21] = assetAnnotation, $[22] = didCropChange, $[23] = didHotspotChange, $[24] = diff, $[25] = showMetaChange, $[26] = toRef, $[27] = toValue, $[28] = t6) : t6 = $[28];
  const to = t6;
  if (!from2 && !to) {
    let t72;
    $[29] !== t ? (t72 = t("changes.image.no-asset-set"), $[29] = t, $[30] = t72) : t72 = $[30];
    let t82;
    return $[31] !== t72 ? (t82 = /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, align: "center", children: t72 }) }), $[31] = t72, $[32] = t82) : t82 = $[32], t82;
  }
  if (!isChanged) {
    let t72;
    return $[33] !== assetAnnotation || $[34] !== diff || $[35] !== toRef ? (t72 = toRef ? /* @__PURE__ */ jsx(DiffCard, { annotation: assetAnnotation, style: CARD_STYLES, children: /* @__PURE__ */ jsx(ImagePreview$1, { id: toRef, is: "to", diff }) }) : null, $[33] = assetAnnotation, $[34] = diff, $[35] = toRef, $[36] = t72) : t72 = $[36], t72;
  }
  const t7 = showFromValue ? from2 : void 0;
  let t8;
  $[37] !== t7 || $[38] !== to ? (t8 = /* @__PURE__ */ jsx(FromTo, { align: "center", from: t7, layout: "grid", to }), $[37] = t7, $[38] = to, $[39] = t8) : t8 = $[39];
  const imageDiff = t8;
  let t9;
  $[40] !== assetAction || $[41] !== assetAnnotation || $[42] !== didAssetChange || $[43] !== imageDiff || $[44] !== showImageDiff || $[45] !== t ? (t9 = showImageDiff && (didAssetChange ? /* @__PURE__ */ jsx(DiffTooltip, { annotations: assetAnnotation ? [assetAnnotation] : [], description: getChangeDescription(assetAction, t), children: imageDiff }) : imageDiff), $[40] = assetAction, $[41] = assetAnnotation, $[42] = didAssetChange, $[43] = imageDiff, $[44] = showImageDiff, $[45] = t, $[46] = t9) : t9 = $[46];
  let t10;
  $[47] !== diff || $[48] !== nestedFields || $[49] !== schemaType || $[50] !== showImageDiff ? (t10 = nestedFields.length > 0 && /* @__PURE__ */ jsx(Box, { marginTop: showImageDiff ? 4 : 3, children: /* @__PURE__ */ jsx(ChangeList, { diff, schemaType, fields: nestedFields }) }), $[47] = diff, $[48] = nestedFields, $[49] = schemaType, $[50] = showImageDiff, $[51] = t10) : t10 = $[51];
  let t11;
  return $[52] !== t10 || $[53] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t9,
    t10
  ] }), $[52] = t10, $[53] = t9, $[54] = t11) : t11 = $[54], t11;
};
function getChangeDescription(action, t) {
  switch (action) {
    case "changed":
      return t("changes.changed-label");
    case "added":
      return t("changes.added-label");
    case "removed":
      return t("changes.removed-label");
    default:
      return "Unknown change";
  }
}
function _temp$14(field_0) {
  return field_0.name;
}
const NumberWrapper = styled.div`
  display: inline-block;
  word-break: break-all;
`, NumberPreview = (props2) => {
  const $ = c(2), {
    value
  } = props2;
  let t0;
  return $[0] !== value ? (t0 = /* @__PURE__ */ jsx(Box, { as: NumberWrapper, paddingX: 2, paddingY: 1, children: value }), $[0] = value, $[1] = t0) : t0 = $[1], t0;
}, NumberFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { diff, schemaType, previewComponent: NumberPreview, layout: "inline" }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
}, InlineBox$1 = styled(Box)`
  &:not([hidden]) {
    display: inline;
    align-items: center;

    &[data-changed] {
      cursor: pointer;
    }
  }
`, InlineText$1 = styled(Text$1)`
  &:not([hidden]) {
    display: inline;
    color: inherit;
  }
`, PreviewContainer = styled(Box)`
  &:not([hidden]) {
    display: inline-flex;
    align-items: center;

    ${InlineBox$1} [data-ui="Text"] {
      opacity: 0.5;
    }
  }
`, PopoverContainer$1 = styled(Box)`
  min-width: 160px;
  max-height: 40vh;
  overflow-y: auto;
`, AnnotationWrapper = styled.div`
  text-decoration: none;
  display: inline;
  position: relative;
  border: 0;
  padding: 0;
  border-bottom: 2px dotted currentColor;
  box-shadow: inset 0 0 0 1px var(--card-border-color);
  white-space: nowrap;
  align-items: center;
  background-color: color(var(--card-fg-color) a(10%));

  &[data-changed] {
    cursor: pointer;
  }

  &[data-removed] {
    text-decoration: line-through;
  }

  &:hover ${PreviewContainer} {
    opacity: 1;
  }
`;
function Annotation(t0) {
  const $ = c(21);
  let children, diff, object, path, restProps, schemaType;
  $[0] !== t0 ? ({
    children,
    diff,
    object,
    schemaType,
    path,
    ...restProps
  } = t0, $[0] = t0, $[1] = children, $[2] = diff, $[3] = object, $[4] = path, $[5] = restProps, $[6] = schemaType) : (children = $[1], diff = $[2], object = $[3], path = $[4], restProps = $[5], schemaType = $[6]);
  const {
    t
  } = useTranslation();
  if (!schemaType) {
    let t12;
    $[7] !== t ? (t12 = t("changes.portable-text.unknown-annotation-schema-type"), $[7] = t, $[8] = t12) : t12 = $[8];
    let t2;
    return $[9] !== restProps || $[10] !== t12 ? (t2 = /* @__PURE__ */ jsx(AnnotationWrapper, { ...restProps, children: t12 }), $[9] = restProps, $[10] = t12, $[11] = t2) : t2 = $[11], t2;
  }
  if (diff && diff.action !== "unchanged") {
    let t12;
    return $[12] !== children || $[13] !== diff || $[14] !== object || $[15] !== path || $[16] !== restProps || $[17] !== schemaType ? (t12 = /* @__PURE__ */ jsx(AnnnotationWithDiff, { ...restProps, diff, object, schemaType, path, children }), $[12] = children, $[13] = diff, $[14] = object, $[15] = path, $[16] = restProps, $[17] = schemaType, $[18] = t12) : t12 = $[18], t12;
  }
  let t1;
  return $[19] !== children ? (t1 = /* @__PURE__ */ jsx(AnnotationWrapper, { children }), $[19] = children, $[20] = t1) : t1 = $[20], t1;
}
function AnnnotationWithDiff({
  diff,
  children,
  object,
  schemaType,
  path,
  ...restProps
}) {
  const {
    onSetFocus
  } = useContext(ConnectorContext), {
    path: fullPath
  } = useContext(DiffContext), popoverRef = useRef(null), {
    t
  } = useTranslation(), color = useDiffAnnotationColor(diff, []), style = useMemo(() => color ? {
    background: color.background,
    color: color.text
  } : {}, [color]), isRemoved = diff.action === "removed", [open, setOpen] = useState(!1), emptyObject = object && isEmptyObject(object), markDefPath = useMemo(() => [path[0]].concat(["markDefs", {
    _key: object._key
  }]), [object._key, path]), prefix = useMemo(() => fullPath.slice(0, fullPath.findIndex((seg) => isKeySegment(seg) && seg._key === object._key)), [fullPath, object._key]), annotationPath = useMemo(() => prefix.concat(path), [path, prefix]), myPath = useMemo(() => prefix.concat(markDefPath), [markDefPath, prefix]), myValue = `field-${toString(myPath)}`, values2 = useChangeIndicatorsReportedValues(), isEditing = useMemo(() => values2.filter(([p]) => p.startsWith(myValue)).length > 0, [myValue, values2]);
  useEffect(() => {
    !open && isEditing && (setOpen(!0), onSetFocus(myPath));
  }, [isEditing, myPath, onSetFocus, open]);
  const handleOpenPopup = useCallback((event) => {
    event.stopPropagation(), setOpen(!0), isRemoved || (event.preventDefault(), onSetFocus(annotationPath), setTimeout(() => onSetFocus(myPath), 10));
  }, [annotationPath, isRemoved, myPath, onSetFocus]);
  useClickOutsideEvent(!isEditing && (() => setOpen(!1)), () => [popoverRef.current]);
  const annotation = diff.action !== "unchanged" && diff.annotation || null, annotations = useMemo(() => annotation ? [annotation] : [], [annotation]), value = useMemo(() => ({
    path: myPath
  }), [myPath]), popoverContent = /* @__PURE__ */ jsx(DiffContext.Provider, { value, children: /* @__PURE__ */ jsx(PopoverContainer$1, { padding: 3, children: /* @__PURE__ */ jsxs("div", { children: [
    emptyObject && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("changes.portable-text.empty-object-annotation", {
      annotationType: schemaType.title || schemaType.name
    }) }),
    !emptyObject && /* @__PURE__ */ jsx(ChangeList, { diff, schemaType })
  ] }) }) });
  return /* @__PURE__ */ jsx(AnnotationWrapper, { ...restProps, onClick: handleOpenPopup, style, "data-changed": "", "data-removed": diff.action === "removed" ? "" : void 0, children: /* @__PURE__ */ jsx(Popover, { content: popoverContent, open, ref: popoverRef, portal: !0, children: /* @__PURE__ */ jsx(PreviewContainer, { paddingLeft: 1, children: /* @__PURE__ */ jsx(DiffTooltip, { annotations, description: t("changes.portable-text.annotation", {
    context: diff.action
  }), children: /* @__PURE__ */ jsxs(InlineBox$1, { style: {
    display: "inline-flex"
  }, children: [
    /* @__PURE__ */ jsx("span", { children }),
    /* @__PURE__ */ jsx(Flex, { align: "center", paddingX: 1, children: /* @__PURE__ */ jsx(InlineText$1, { size: 0, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }) })
  ] }) }) }) }) });
}
const Quote = styled.blockquote`
  margin: 0;
`;
function Blockquote(t0) {
  const $ = c(2), {
    children
  } = t0;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Quote, { children }) }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}
const headingSizes = {
  h1: 2,
  h2: 1,
  h3: 0,
  h4: 0,
  h5: 0,
  h6: 0
}, StyledHeading = styled(Heading)`
  &:not([hidden]) {
    display: inline;
    text-transform: none;
    margin: 0;

    &::before,
    &::after {
      content: unset;
    }
  }
`;
function Header(t0) {
  const $ = c(3), {
    style,
    children
  } = t0, t1 = headingSizes[style];
  let t2;
  return $[0] !== children || $[1] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledHeading, { size: t1, children }), $[0] = children, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}
const StyledParagraph = styled.div`
  text-transform: none;
  white-space: wrap;
  overflow-wrap: break-word;
  margin: 0;
`;
function Paragraph(t0) {
  const $ = c(2), {
    children
  } = t0;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(StyledParagraph, { children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}
const EMPTY_PATH = [];
function Block(props2) {
  const $ = c(41), {
    diff,
    block,
    children
  } = props2, color = useDiffAnnotationColor(diff, EMPTY_PATH), {
    path: fullPath
  } = useContext(DiffContext), {
    onSetFocus
  } = useContext(ConnectorContext), {
    t
  } = useTranslation(), isRemoved = diff.action === "removed";
  let returned = children, t0;
  $[0] !== fullPath || $[1] !== isRemoved || $[2] !== onSetFocus ? (t0 = (event) => {
    event.stopPropagation(), isRemoved || onSetFocus(fullPath);
  }, $[0] = fullPath, $[1] = isRemoved, $[2] = onSetFocus, $[3] = t0) : t0 = $[3];
  const handleClick = t0;
  if (block.style === "blockquote") {
    let t12;
    $[4] !== returned ? (t12 = /* @__PURE__ */ jsx(Blockquote, { children: returned }), $[4] = returned, $[5] = t12) : t12 = $[5], returned = t12;
  } else if (block.style && isHeader(block)) {
    let t12;
    $[6] !== block.style || $[7] !== returned ? (t12 = /* @__PURE__ */ jsx(Header, { style: block.style, children: returned }), $[6] = block.style, $[7] = returned, $[8] = t12) : t12 = $[8], returned = t12;
  } else {
    let t12;
    $[9] !== returned ? (t12 = /* @__PURE__ */ jsx(Paragraph, { children: returned }), $[9] = returned, $[10] = t12) : t12 = $[10], returned = t12;
  }
  let fromStyle;
  if (diff.origin.action === "changed" && diff.origin.fields.style && diff.origin.fields.style.action === "changed" && diff.origin.fields.style.annotation) {
    fromStyle = diff?.origin?.fromValue?.style;
    let t12;
    $[11] !== color ? (t12 = color ? {
      background: color.background,
      color: color.text
    } : {}, $[11] = color, $[12] = t12) : t12 = $[12];
    const style = t12;
    let t22;
    $[13] === Symbol.for("react.memo_cache_sentinel") ? (t22 = {
      borderStyle: "dotted"
    }, $[13] = t22) : t22 = $[13];
    const t3 = diff.action, t4 = `changed_from_style_${fromStyle || "undefined"}`, t5 = diff.origin.fields.style?.annotation;
    let t6;
    $[14] !== t5 ? (t6 = [t5], $[14] = t5, $[15] = t6) : t6 = $[15];
    const t7 = diff.origin.fields.style;
    let t8;
    $[16] !== block.style || $[17] !== fromStyle || $[18] !== t ? (t8 = t("changes.portable-text.block-style-changed", {
      fromStyle,
      toStyle: block.style
    }), $[16] = block.style, $[17] = fromStyle, $[18] = t, $[19] = t8) : t8 = $[19];
    let t9;
    $[20] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: t8 }), $[20] = t8, $[21] = t9) : t9 = $[21];
    let t10;
    $[22] !== diff.origin.fields.style || $[23] !== t6 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsx(DiffTooltip, { annotations: t6, diff: t7, children: t9 }), $[22] = diff.origin.fields.style, $[23] = t6, $[24] = t9, $[25] = t10) : t10 = $[25];
    let t11;
    $[26] !== returned || $[27] !== style ? (t11 = /* @__PURE__ */ jsx(Box, { style, children: returned }), $[26] = returned, $[27] = style, $[28] = t11) : t11 = $[28];
    let t122;
    $[29] !== t10 || $[30] !== t11 ? (t122 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      t10,
      t11
    ] }), $[29] = t10, $[30] = t11, $[31] = t122) : t122 = $[31];
    let t13;
    $[32] !== diff.action || $[33] !== t122 || $[34] !== t4 ? (t13 = /* @__PURE__ */ jsx(Card, { padding: 3, border: !0, radius: 2, style: t22, "diff-block-action": t3, "data-block-note": t4, children: t122 }), $[32] = diff.action, $[33] = t122, $[34] = t4, $[35] = t13) : t13 = $[35], returned = t13;
  }
  const t1 = `changed_from_style_${fromStyle || "undefined"}`;
  let t2;
  return $[36] !== diff.action || $[37] !== handleClick || $[38] !== returned || $[39] !== t1 ? (t2 = /* @__PURE__ */ jsx("div", { onClick: handleClick, "data-diff-block-action": diff.action, "data-block-note": t1, children: returned }), $[36] = diff.action, $[37] = handleClick, $[38] = returned, $[39] = t1, $[40] = t2) : t2 = $[40], t2;
}
const DecoratorWrapper = styled.span`
  display: inline;
  ${({
  theme,
  decoration
}) => {
  switch (decoration) {
    case "strong":
      return "font-weight: bold;";
    case "em":
      return "font-style: italic;";
    case "underline":
      return "text-decoration: underline;";
    case "overline":
      return "text-decoration: overline;";
    case "strike-through":
      return "text-decoration: line-through;";
    case "code":
      return `
          font-family: ${theme.sanity.fonts.code.family};
          background: ${theme.sanity.color.muted.default.enabled.bg};
        `;
    default:
      return "";
  }
}}
`;
function Decorator(t0) {
  const $ = c(3), {
    mark,
    children
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== mark ? (t1 = /* @__PURE__ */ jsx(DecoratorWrapper, { decoration: mark, children }), $[0] = children, $[1] = mark, $[2] = t1) : t1 = $[2], t1;
}
const InlineObjectWrapper = styled(Card)`
  &:not([hidden]) {
    display: inline;
    cursor: pointer;
    white-space: nowrap;
    align-items: center;

    &[data-removed] {
      text-decoration: line-through;
    }

    ${InlineBox$1} {
      display: inline-flex;
    }
  }
`;
function InlineObject(t0) {
  const $ = c(19);
  let diff, object, restProps, schemaType;
  $[0] !== t0 ? ({
    diff,
    object,
    schemaType,
    ...restProps
  } = t0, $[0] = t0, $[1] = diff, $[2] = object, $[3] = restProps, $[4] = schemaType) : (diff = $[1], object = $[2], restProps = $[3], schemaType = $[4]);
  const {
    t
  } = useTranslation();
  if (!schemaType) {
    let t12;
    $[5] !== object._type || $[6] !== t ? (t12 = t("changes.portable-text.unknown-inline-object-schema-type", {
      schemaType: object._type
    }), $[5] = object._type, $[6] = t, $[7] = t12) : t12 = $[7];
    let t2;
    return $[8] !== restProps || $[9] !== t12 ? (t2 = /* @__PURE__ */ jsx(InlineObjectWrapper, { ...restProps, border: !0, radius: 1, children: t12 }), $[8] = restProps, $[9] = t12, $[10] = t2) : t2 = $[10], t2;
  }
  if (diff) {
    let t12;
    return $[11] !== diff || $[12] !== object || $[13] !== restProps || $[14] !== schemaType ? (t12 = /* @__PURE__ */ jsx(InlineObjectWithDiff, { ...restProps, diff, object, schemaType }), $[11] = diff, $[12] = object, $[13] = restProps, $[14] = schemaType, $[15] = t12) : t12 = $[15], t12;
  }
  let t1;
  return $[16] !== object || $[17] !== schemaType ? (t1 = /* @__PURE__ */ jsx(InlineObjectWrapper, { children: /* @__PURE__ */ jsx(Preview$1, { schemaType, value: object, layout: "inline" }) }), $[16] = object, $[17] = schemaType, $[18] = t1) : t1 = $[18], t1;
}
function InlineObjectWithDiff(t0) {
  const $ = c(65);
  let diff, object, path, restProps, schemaType;
  $[0] !== t0 ? ({
    diff,
    object,
    path,
    schemaType,
    ...restProps
  } = t0, $[0] = t0, $[1] = diff, $[2] = object, $[3] = path, $[4] = restProps, $[5] = schemaType) : (diff = $[1], object = $[2], path = $[3], restProps = $[4], schemaType = $[5]);
  const {
    path: fullPath
  } = useContext(DiffContext), {
    onSetFocus
  } = useContext(ConnectorContext), {
    t
  } = useTranslation();
  let t1;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[6] = t1) : t1 = $[6];
  const color = useDiffAnnotationColor(diff, t1);
  let t2, t3;
  $[7] !== color ? (t3 = color ? {
    background: color.background,
    color: color.text
  } : {}, $[7] = color, $[8] = t3) : t3 = $[8], t2 = t3;
  const style = t2, [open, setOpen] = useState(!1);
  let t4;
  $[9] !== object ? (t4 = object && isEmptyObject(object), $[9] = object, $[10] = t4) : t4 = $[10];
  const emptyObject = t4, isRemoved = diff.action === "removed";
  let myPath, t5;
  if ($[11] !== fullPath || $[12] !== object || $[13] !== path) {
    let t6;
    $[16] !== object ? (t6 = (seg) => isKeySegment(seg) && seg._key === object._key, $[16] = object, $[17] = t6) : t6 = $[17], myPath = fullPath.slice(0, fullPath.findIndex(t6)).concat(path), t5 = toString(myPath), $[11] = fullPath, $[12] = object, $[13] = path, $[14] = myPath, $[15] = t5;
  } else
    myPath = $[14], t5 = $[15];
  const myValue = `field-${t5}`, isEditing = useChangeIndicatorsReportedValues().filter((t6) => {
    const [p] = t6;
    return p.startsWith(myValue);
  }).length > 0;
  let t7;
  $[18] !== fullPath || $[19] !== path ? (t7 = fullPath.slice(0, -1).concat(path).concat([FOCUS_TERMINATOR]), $[18] = fullPath, $[19] = path, $[20] = t7) : t7 = $[20];
  const focusPath = t7;
  let t8, t9;
  $[21] !== focusPath || $[22] !== isEditing || $[23] !== onSetFocus ? (t8 = () => {
    isEditing && (setOpen(!0), onSetFocus(focusPath));
  }, t9 = [focusPath, isEditing, onSetFocus], $[21] = focusPath, $[22] = isEditing, $[23] = onSetFocus, $[24] = t8, $[25] = t9) : (t8 = $[24], t9 = $[25]), useEffect(t8, t9);
  let t10;
  $[26] !== focusPath || $[27] !== isRemoved || $[28] !== onSetFocus ? (t10 = (event) => {
    if (event.stopPropagation(), setOpen(!0), !isRemoved) {
      onSetFocus(focusPath);
      return;
    }
    event.preventDefault();
  }, $[26] = focusPath, $[27] = isRemoved, $[28] = onSetFocus, $[29] = t10) : t10 = $[29];
  const handleOpenPopup = t10;
  let t11;
  $[30] === Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
    setOpen(!1);
  }, $[30] = t11) : t11 = $[30];
  const handleClose = t11;
  let t12, t13;
  $[31] !== myPath ? (t13 = {
    path: myPath
  }, $[31] = myPath, $[32] = t13) : t13 = $[32], t12 = t13;
  const value = t12;
  let t14;
  $[33] !== diff || $[34] !== emptyObject || $[35] !== schemaType ? (t14 = /* @__PURE__ */ jsx(PopoverContent$1, { diff, emptyObject, onClose: handleClose, schemaType }), $[33] = diff, $[34] = emptyObject, $[35] = schemaType, $[36] = t14) : t14 = $[36];
  let t15;
  $[37] !== t14 || $[38] !== value ? (t15 = /* @__PURE__ */ jsx(DiffContext.Provider, { value, children: t14 }), $[37] = t14, $[38] = value, $[39] = t15) : t15 = $[39];
  const popoverContent = t15, annotation = diff.action !== "unchanged" && diff.annotation || null;
  let t16;
  $[40] !== annotation ? (t16 = annotation ? [annotation] : [], $[40] = annotation, $[41] = t16) : t16 = $[41];
  const annotations = t16, t17 = diff.action === "removed" ? "" : void 0;
  let t18;
  $[42] !== diff.action || $[43] !== t ? (t18 = t("changes.portable-text.inline-object", {
    context: diff.action
  }), $[42] = diff.action, $[43] = t, $[44] = t18) : t18 = $[44];
  let t19;
  $[45] !== object || $[46] !== schemaType ? (t19 = /* @__PURE__ */ jsx(Preview$1, { schemaType, value: object, layout: "inline" }), $[45] = object, $[46] = schemaType, $[47] = t19) : t19 = $[47];
  let t20;
  $[48] === Symbol.for("react.memo_cache_sentinel") ? (t20 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingX: 1, children: /* @__PURE__ */ jsx(InlineText$1, { size: 0, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }) }), $[48] = t20) : t20 = $[48];
  let t21;
  $[49] !== t19 ? (t21 = /* @__PURE__ */ jsxs(InlineBox$1, { children: [
    t19,
    t20
  ] }), $[49] = t19, $[50] = t21) : t21 = $[50];
  let t22;
  $[51] !== annotations || $[52] !== t18 || $[53] !== t21 ? (t22 = /* @__PURE__ */ jsx(PreviewContainer, { children: /* @__PURE__ */ jsx(DiffTooltip, { annotations, description: t18, children: t21 }) }), $[51] = annotations, $[52] = t18, $[53] = t21, $[54] = t22) : t22 = $[54];
  let t23;
  $[55] !== open || $[56] !== popoverContent || $[57] !== t22 ? (t23 = /* @__PURE__ */ jsx(Popover, { content: popoverContent, open, portal: !0, children: t22 }), $[55] = open, $[56] = popoverContent, $[57] = t22, $[58] = t23) : t23 = $[58];
  let t24;
  return $[59] !== handleOpenPopup || $[60] !== restProps || $[61] !== style || $[62] !== t17 || $[63] !== t23 ? (t24 = /* @__PURE__ */ jsx(InlineObjectWrapper, { ...restProps, onClick: handleOpenPopup, style, "data-removed": t17, border: !0, radius: 2, children: t23 }), $[59] = handleOpenPopup, $[60] = restProps, $[61] = style, $[62] = t17, $[63] = t23, $[64] = t24) : t24 = $[64], t24;
}
function PopoverContent$1(t0) {
  const $ = c(12), {
    diff,
    emptyObject,
    onClose,
    schemaType
  } = t0, {
    t
  } = useTranslation(), popoverRef = useRef(null);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => [popoverRef.current], $[0] = t1) : t1 = $[0], useClickOutsideEvent(onClose, t1);
  let t2;
  $[1] !== emptyObject || $[2] !== schemaType || $[3] !== t ? (t2 = emptyObject && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: t("changes.portable-text.empty-inline-object", {
    inlineObjectType: schemaType.title || schemaType.name
  }) }), $[1] = emptyObject, $[2] = schemaType, $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== diff || $[6] !== emptyObject || $[7] !== schemaType ? (t3 = !emptyObject && /* @__PURE__ */ jsx(ChangeList, { diff, schemaType }), $[5] = diff, $[6] = emptyObject, $[7] = schemaType, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== t2 || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsxs(PopoverContainer$1, { ref: popoverRef, padding: 3, children: [
    t2,
    t3
  ] }), $[9] = t2, $[10] = t3, $[11] = t4) : t4 = $[11], t4;
}
function Text(t0) {
  const $ = c(16);
  let childDiff, children, diff, path, restProps, segment;
  $[0] !== t0 ? ({
    diff,
    childDiff,
    children,
    path,
    segment,
    ...restProps
  } = t0, $[0] = t0, $[1] = childDiff, $[2] = children, $[3] = diff, $[4] = path, $[5] = restProps, $[6] = segment) : (childDiff = $[1], children = $[2], diff = $[3], path = $[4], restProps = $[5], segment = $[6]);
  const diffWithFallback = diff || childDiff;
  if (diffWithFallback && diffWithFallback.action !== "unchanged" && segment.action !== "unchanged") {
    let t12;
    return $[7] !== childDiff || $[8] !== children || $[9] !== diff || $[10] !== path || $[11] !== restProps || $[12] !== segment ? (t12 = /* @__PURE__ */ jsx(TextWithDiff, { ...restProps, childDiff, diff, segment, path, children }), $[7] = childDiff, $[8] = children, $[9] = diff, $[10] = path, $[11] = restProps, $[12] = segment, $[13] = t12) : t12 = $[13], t12;
  }
  let t1;
  return $[14] !== children ? (t1 = /* @__PURE__ */ jsx(InlineBox$1, { children }), $[14] = children, $[15] = t1) : t1 = $[15], t1;
}
function TextWithDiff({
  diff,
  childDiff,
  children,
  path,
  segment,
  ...restProps
}) {
  const {
    onSetFocus
  } = useContext(ConnectorContext), {
    path: fullPath
  } = useContext(DiffContext), spanSegment = useMemo(() => path.slice(-2, 1)[0], [path]), {
    t
  } = useTranslation(), isRemoved = diff && diff.action === "removed", focusPath = fullPath.slice(0, fullPath.findIndex((seg) => isKeySegment(seg) && isKeySegment(spanSegment) && seg._key === spanSegment._key)).concat(path), handleClick = useCallback((event) => {
    event.stopPropagation(), isRemoved || (event.preventDefault(), onSetFocus(focusPath));
  }, [focusPath, isRemoved, onSetFocus]), diffWithFallback = diff && diff.segments.find((rSeg) => rSeg.text === segment.text) || diff || childDiff, annotation = diffWithFallback && diffWithFallback.action !== "unchanged" && diffWithFallback.annotation || null, diffCard = annotation && segment.action !== "unchanged" ? /* @__PURE__ */ jsx(DiffCard, { annotation, as: segment.action === "removed" ? "del" : "ins", tooltip: {
    description: t("changes.portable-text.text", {
      context: segment.action
    })
  }, children }) : null;
  return /* @__PURE__ */ jsx(InlineBox$1, { ...restProps, onClick: handleClick, "data-changed": "", children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(Fragment, { children: diffCard || children }) }) });
}
const decoratorSymbolsStart = DECORATOR_SYMBOLS.map((set2) => set2[0]), decoratorSymbolsEnd = DECORATOR_SYMBOLS.map((set2) => set2[1]), annotationSymbolsStart = ANNOTATION_SYMBOLS.map((set2) => set2[0]), annotationSymbolsEnd = ANNOTATION_SYMBOLS.map((set2) => set2[1]), allSymbolsStart = decoratorSymbolsStart.concat(annotationSymbolsStart), allSymbolsEnd = decoratorSymbolsEnd.concat(annotationSymbolsEnd), allDecoratorSymbols = decoratorSymbolsStart.concat(decoratorSymbolsEnd), markRegex = new RegExp(`${allDecoratorSymbols.concat(allSymbolsEnd).join("|")}`, "g");
function PortableText(props2) {
  const {
    diff,
    schemaType
  } = props2, block = diff.origin.toValue || diff.origin.fromValue, {
    t
  } = useTranslation(), inlineObjects = useMemo(() => diff.origin.toValue ? getInlineObjects(diff.origin) : [], [diff.origin]), renderChild2 = useCallback((ptDiffChild) => {
    const spanSchemaType = getChildSchemaType(schemaType.fields, ptDiffChild);
    let decoratorTypes = [];
    if (spanSchemaType) {
      decoratorTypes = getDecorators(spanSchemaType);
      const childrenDiff = diff.fields.children, segments = childrenDiff.items[0].diff && childrenDiff.items[0].diff.type === "object" && childrenDiff.items[0].diff.fields.text.type === "string" && childrenDiff.items[0].diff.fields.text.segments || [], returnedChildren = [], annotationSegments = {};
      if (isEmptyTextChange(block, diff) && (diff.origin.action === "added" || diff.origin.action === "removed")) {
        const textDiff = findChildDiff(diff.origin, block.children[0]) || diff.origin;
        if (textDiff && textDiff.action !== "unchanged")
          return /* @__PURE__ */ jsx(DiffCard, { annotation: textDiff.annotation, as: textDiff.action === "removed" ? "del" : "ins", tooltip: {
            description: t("changes.portable-text.empty-text", {
              context: textDiff.action
            })
          }, children: /* @__PURE__ */ jsx("span", { children: EMPTY_BLOCK_SYMBOL }) }, `empty-block-${block._key}`);
      }
      let childToIndex = -1, segIndex = -1;
      const activeAnnotations = [];
      let endedAnnotation;
      const allMarkDefs = getAllMarkDefs(diff.origin);
      return segments.forEach((seg) => {
        segIndex++;
        const isInline = INLINE_SYMBOLS.includes(seg.text), isMarkStart = allSymbolsStart.includes(seg.text), isMarkEnd = allSymbolsEnd.includes(seg.text), isChildStart = seg.text === CHILD_SYMBOL$1, isRemoved = seg.action === "removed";
        if (isChildStart)
          isRemoved || childToIndex++;
        else if (isMarkStart || isMarkEnd) {
          if (isMarkStart && annotationSymbolsStart.includes(seg.text)) {
            const object = allMarkDefs[annotationSymbolsStart.indexOf(seg.text)];
            object && activeAnnotations.push({
              mark: object._key,
              symbols: [seg.text, annotationSymbolsEnd[annotationSymbolsStart.indexOf(seg.text)]],
              object
            });
          }
          isMarkEnd && annotationSymbolsEnd.includes(seg.text) && (endedAnnotation = activeAnnotations.pop());
        } else if (isInline) {
          const indexOfSymbol = INLINE_SYMBOLS.findIndex((sym) => sym === seg.text), key = inlineObjects[indexOfSymbol]?._key, originChild = inlineObjects[indexOfSymbol];
          if (key) {
            const objectSchemaType = getChildSchemaType(schemaType.fields, originChild), objectDiff = findChildDiff(diff.origin, originChild);
            returnedChildren.push(/* @__PURE__ */ jsx(InlineObject, { object: originChild, path: [{
              _key: block._key
            }, "children", {
              _key: originChild._key
            }], diff: objectDiff, schemaType: objectSchemaType }, `inline-object-${originChild._key}`));
          }
        } else if (seg.text) {
          const getChildFromFromValue = () => diff.origin.fromValue?.children.find((cld) => cld.text && cld.text.match(escapeRegExp(seg.text))), child = block.children[childToIndex] || getChildFromFromValue(), childDiff = child && findSpanDiffFromChild(diff.origin, child);
          if (!child)
            throw new Error("Could not find child");
          const textDiff_0 = childDiff?.fields?.text ? childDiff?.fields?.text : void 0, text = /* @__PURE__ */ jsx(Text, { diff: textDiff_0, path: [{
            _key: block._key
          }, "children", {
            _key: child._key
          }], childDiff, segment: seg, children: renderTextSegment({
            diff,
            child,
            decoratorTypes,
            seg,
            segIndex,
            spanSchemaType,
            t
          }) }, `text-${child._key}-${segIndex}`);
          if (activeAnnotations.length > 0 && activeAnnotations.forEach((active) => {
            annotationSegments[active.mark] = annotationSegments[active.mark] || [], annotationSegments[active.mark].push(text);
          }), endedAnnotation) {
            const key_0 = `annotation-${endedAnnotation.object._key}`, lastChild = returnedChildren[returnedChildren.length - 1];
            if (lastChild && lastChild.key !== key_0) {
              const annotationDiff = findAnnotationDiff(diff.origin, endedAnnotation.mark), objectSchemaType_0 = endedAnnotation && spanSchemaType.annotations && spanSchemaType.annotations.find((type) => endedAnnotation && endedAnnotation.object && type.name === endedAnnotation.object._type);
              returnedChildren.push(/* @__PURE__ */ jsx(Annotation, { object: endedAnnotation.object, diff: annotationDiff, path: [{
                _key: block._key
              }, "children", {
                _key: child._key
              }], schemaType: objectSchemaType_0, children: /* @__PURE__ */ jsx(Fragment, { children: annotationSegments[endedAnnotation.mark] }) }, key_0));
            }
            endedAnnotation = void 0;
          }
          activeAnnotations.length === 0 && returnedChildren.push(text);
        }
      }), /* @__PURE__ */ jsx("div", { children: returnedChildren }, block._key);
    }
    throw new Error("'span' schemaType not found");
  }, [block, diff, inlineObjects, schemaType, t]);
  return /* @__PURE__ */ jsx(Block, { block: diff.displayValue, diff, children: /* @__PURE__ */ jsx(Fragment, { children: (diff.displayValue.children || []).map((child_0) => renderChild2(child_0)) }) });
}
function renderTextSegment({
  diff,
  child,
  decoratorTypes,
  seg,
  segIndex,
  spanSchemaType,
  t
}) {
  if (seg.text === `
`)
    return /* @__PURE__ */ jsx("br", {});
  let children = /* @__PURE__ */ jsx("span", { children: seg.text.replace(/ /g, TRAILING_SPACE_SYMBOL) }, `text-${segIndex}`);
  const spanDiff = child && findSpanDiffFromChild(diff.origin, child), activeMarks = isPortableTextSpan(child) ? child.marks || [] : [];
  return spanDiff && (children = renderDecorators({
    activeMarks,
    decoratorTypes,
    diff,
    children,
    seg,
    segIndex,
    spanDiff,
    spanSchemaType,
    t
  })), activeMarks && activeMarks.length > 0 && activeMarks.forEach((mark) => {
    isDecorator(mark, spanSchemaType) && (children = // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ jsx(Decorator, { mark, children }, `decorator-${mark}-${child._key}-${segIndex}`));
  }), children;
}
function renderDecorators({
  activeMarks,
  decoratorTypes,
  diff,
  children,
  seg,
  segIndex,
  spanDiff,
  spanSchemaType,
  t
}) {
  let returned = /* @__PURE__ */ jsx("span", { children }, `text-segment-${segIndex}`);
  const fromPtDiffText = diff.origin.fromValue && diff.fromValue && diff.fromValue.children[0].text || "", indirectMarksAnnotation = spanDiff && spanDiff.action !== "unchanged" && spanDiff.annotation || void 0, marksDiff = spanDiff?.fields?.marks, marksAnnotation = marksDiff && marksDiff.action !== "unchanged" && marksDiff.annotation || indirectMarksAnnotation;
  let marksChanged = [];
  const ptDiffMatchString = fromPtDiffText.split(CHILD_SYMBOL$1).filter((text) => !!text).join(""), controlString = ptDiffMatchString.slice(0, Math.max(0, ptDiffMatchString.indexOf(seg.text) + seg.text.length)), toTest = controlString.slice(0, Math.max(0, controlString.indexOf(seg.text))), marks = [];
  return [...toTest.matchAll(markRegex)].forEach((match) => {
    const sym = match[0], set2 = DECORATOR_SYMBOLS.concat(ANNOTATION_SYMBOLS).find((aSet) => aSet.indexOf(sym) > -1);
    if (set2) {
      const isMarkStart = sym === set2[0], mark = decoratorTypes[isMarkStart ? decoratorSymbolsStart.indexOf(sym) : decoratorSymbolsEnd.indexOf(sym)]?.value || sym;
      toTest.lastIndexOf(sym) > toTest.lastIndexOf(set2[1]) && marks.push(mark);
    }
  }), marksChanged = xor(activeMarks, uniq(marks)), marksAnnotation && marksChanged.length > 0 && marksChanged.some((m) => isDecorator(m, spanSchemaType)) && (returned = /* @__PURE__ */ jsx(DiffCard, { annotation: marksAnnotation, as: "ins", tooltip: {
    description: t("changes.portable-text.changed-formatting")
  }, children: returned }, `diffcard-annotation-${segIndex}-${marksChanged.join("-")}`)), returned;
}
function isEmptyTextChange(block, diff) {
  return block.children.length === 1 && block.children[0]._type === "span" && typeof block.children[0].text == "string" && block.children[0].text === "" && diff.origin.action !== "unchanged";
}
const PTDiff = (props2) => {
  const $ = c(9), {
    diff,
    schemaType
  } = props2;
  let t0, t1;
  $[0] !== diff || $[1] !== schemaType ? (t1 = createPortableTextDiff(diff, schemaType), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t0 = t1;
  const ptDiff = t0;
  let t2;
  $[3] !== ptDiff || $[4] !== schemaType ? (t2 = /* @__PURE__ */ jsx(PortableText, { diff: ptDiff, schemaType }), $[3] = ptDiff, $[4] = schemaType, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== diff.action || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx("div", { "data-diff-action": diff.action, children: t2 }), $[6] = diff.action, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}, ReferenceWrapper = styled.div`
  word-wrap: break-word;
`, ReferencePreview = (t0) => {
  const $ = c(3), {
    value,
    schemaType
  } = t0;
  let t1;
  return $[0] !== schemaType || $[1] !== value ? (t1 = /* @__PURE__ */ jsx(Box, { as: ReferenceWrapper, padding: 2, children: /* @__PURE__ */ jsx(Preview$1, { schemaType, value, layout: "default" }) }), $[0] = schemaType, $[1] = value, $[2] = t1) : t1 = $[2], t1;
}, ReferenceFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { align: "center", diff, layout: "grid", path: "_ref", previewComponent: ReferencePreview, schemaType }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
}, StringWrapper$1 = styled.div`
  display: inline-block;
  word-break: break-all;
  white-space: pre-wrap;
`, StringPreview = (props2) => {
  const $ = c(2), {
    value
  } = props2;
  let t0;
  return $[0] !== value ? (t0 = /* @__PURE__ */ jsx(Box, { as: StringWrapper$1, paddingX: 2, paddingY: 1, children: value }), $[0] = value, $[1] = t0) : t0 = $[1], t0;
}, StringWrapper = styled.div`
  white-space: pre-wrap;
  word-wrap: break-word;
`, StringFieldDiff = (t0) => {
  const $ = c(5), {
    diff,
    schemaType
  } = t0, {
    options
  } = schemaType;
  if (options?.list) {
    let t12;
    return $[0] !== diff || $[1] !== schemaType ? (t12 = /* @__PURE__ */ jsx(DiffFromTo, { diff, previewComponent: StringPreview, schemaType }), $[0] = diff, $[1] = schemaType, $[2] = t12) : t12 = $[2], t12;
  }
  let t1;
  return $[3] !== diff ? (t1 = /* @__PURE__ */ jsx(StringWrapper, { children: /* @__PURE__ */ jsx(DiffString, { diff }) }), $[3] = diff, $[4] = t1) : t1 = $[4], t1;
}, defaultComponents = {
  block: PTDiff,
  boolean: {
    component: BooleanFieldDiff,
    showHeader: !1
  },
  date: DatetimeFieldDiff,
  datetime: DatetimeFieldDiff,
  file: FileFieldDiff,
  image: ImageFieldDiff,
  number: NumberFieldDiff,
  reference: ReferenceFieldDiff,
  string: StringFieldDiff
};
function resolveDiffComponent(type, parentSchemaType) {
  let itType = type;
  for (; itType; ) {
    const resolved = itType?.components?.diff || tryResolve(itType, parentSchemaType) || defaultComponents[itType.name];
    if (resolved)
      return resolved;
    itType = itType.type;
  }
  const defaultComponentKey = ["date", "datetime"].includes(type.name) ? type.name : type.jsonType;
  return defaultComponents[defaultComponentKey];
}
function tryResolve(schemaType, parentSchemaType) {
  const resolvers = diffResolvers;
  let resolved;
  for (const resolver of resolvers) {
    if (typeof resolver != "function") {
      console.error("Diff component resolver is not a function: ", resolver);
      continue;
    }
    if (resolved = resolver({
      schemaType,
      parentSchemaType
    }), resolved)
      return resolved;
  }
}
function buildChangeList(schemaType, diff, path = [], titlePath = [], context = {}) {
  if (!resolveDiffComponent(schemaType, context.parentSchema)) {
    if (schemaType.jsonType === "object" && diff.type === "object")
      return buildObjectChangeList(schemaType, diff, path, titlePath, context);
    if (schemaType.jsonType === "array" && diff.type === "array")
      return buildArrayChangeList(schemaType, diff, path, titlePath);
  }
  return getFieldChange(schemaType, diff, path, titlePath, context);
}
function buildObjectChangeList(schemaType, diff, path = [], titlePath = [], diffContext = {}) {
  const changes = [], childContext = {
    ...diffContext,
    parentSchema: schemaType
  }, fieldSets = schemaType.fieldsets || schemaType.fields.map((field) => ({
    single: !0,
    field
  }));
  for (const fieldSet of fieldSets)
    fieldSet.single ? changes.push(...buildFieldChange(fieldSet.field, diff, path, titlePath, childContext)) : changes.push(...buildFieldsetChangeList(fieldSet, diff, path, titlePath, childContext));
  return changes.length < 2 ? changes : [{
    type: "group",
    key: pathToString$1(path) || "root",
    path,
    titlePath,
    changes: reduceTitlePaths(changes, titlePath.length),
    schemaType
  }];
}
function buildFieldChange(field, diff, path, titlePath, diffContext = {}) {
  const {
    fieldFilter,
    ...context
  } = diffContext, fieldDiff = diff.fields[field.name];
  if (!fieldDiff || !fieldDiff.isChanged || fieldFilter && !fieldFilter.includes(field.name))
    return [];
  const fieldPath = path.concat([field.name]), fieldTitlePath = titlePath.concat([field.type.title || field.name]);
  return buildChangeList(field.type, fieldDiff, fieldPath, fieldTitlePath, context);
}
function buildFieldsetChangeList(fieldSet, diff, path, titlePath, diffContext = {}) {
  const {
    fields,
    name,
    title,
    readOnly,
    hidden
  } = fieldSet, {
    fieldFilter,
    ...context
  } = diffContext, fieldSetHidden = hidden, fieldsetReadOnly = readOnly, fieldSetTitlePath = titlePath.concat([title || name]), changes = [];
  for (const field of fields) {
    const fieldDiff = diff.fields[field.name];
    if (!fieldDiff || !fieldDiff.isChanged || fieldFilter && !fieldFilter.includes(field.name))
      continue;
    const fieldPath = path.concat([field.name]), fieldTitlePath = fieldSetTitlePath.concat([field.type.title || field.name]);
    changes.push(...buildChangeList({
      readOnly: fieldsetReadOnly,
      hidden: fieldSetHidden,
      ...field.type
    }, fieldDiff, fieldPath, fieldTitlePath, context));
  }
  return changes.length < 2 ? changes : [{
    type: "group",
    key: pathToString$1(path) || "root",
    fieldsetName: name,
    path,
    titlePath: fieldSetTitlePath,
    changes: reduceTitlePaths(changes, fieldSetTitlePath.length),
    readOnly: fieldsetReadOnly,
    hidden: fieldSetHidden
  }];
}
function buildArrayChangeList(schemaType, diff, path = [], titlePath = []) {
  const changedOrMoved = diff.items.filter((item) => item.hasMoved && item.fromIndex !== item.toIndex || item.diff.action !== "unchanged");
  if (changedOrMoved.length === 0)
    return [];
  const isPortableText2 = hasPTMemberType(schemaType), list = [], changes = changedOrMoved.reduce((acc, itemDiff) => {
    const memberTypes = getArrayDiffItemType(itemDiff.diff, schemaType), memberType = memberTypes.toType || memberTypes.fromType;
    if (!memberType)
      return console.warn("Could not determine schema type for item at %s", pathToString$1(path)), acc;
    const segment = getItemKeySegment(itemDiff.diff.fromValue) || getItemKeySegment(itemDiff.diff.toValue) || diff.items.indexOf(itemDiff), itemPath = path.concat(segment), itemContext = {
      itemDiff,
      parentDiff: diff,
      parentSchema: schemaType
    }, itemTitlePath = titlePath.concat({
      hasMoved: itemDiff.hasMoved,
      toIndex: itemDiff.toIndex,
      fromIndex: itemDiff.fromIndex,
      annotation: itemDiff.diff.action === "unchanged" ? itemDiff.annotation : itemDiff.diff.annotation
    }), attachItemDiff = (change) => (change.type === "field" && pathsAreEqual(itemPath, change.path) && (change.itemDiff = itemDiff), change), children = buildChangeList(memberType, itemDiff.diff, itemPath, itemTitlePath, itemContext).map(attachItemDiff);
    return isPortableText2 && children.filter(isFieldChange).forEach((field, index, siblings) => {
      field.showHeader = siblings.length === 1, field.showIndex = itemDiff.fromIndex !== itemDiff.toIndex && itemDiff.hasMoved;
    }), children.length === 0 ? acc.push(...getFieldChange(memberType, itemDiff.diff, itemPath, itemTitlePath, itemContext)) : acc.push(...children), acc;
  }, list);
  return changes.length > 1 ? [{
    type: "group",
    key: pathToString$1(path) || "root",
    path,
    titlePath,
    changes: reduceTitlePaths(changes, titlePath.length),
    schemaType
  }] : changes;
}
function getFieldChange(schemaType, diff, path, titlePath, {
  itemDiff,
  parentDiff,
  parentSchema
} = {}) {
  const {
    fromValue,
    toValue,
    type
  } = diff;
  if (type === "array" && isEmpty(fromValue) && isEmpty(toValue))
    return [];
  let error;
  typeof fromValue < "u" && (error = getValueError(fromValue, schemaType)), !error && typeof toValue < "u" && (error = getValueError(toValue, schemaType));
  let showHeader = !0, component;
  const diffComponent = resolveDiffComponent(schemaType, parentSchema);
  return diffComponent && typeof diffComponent == "function" ? component = diffComponent : diffComponent && (component = diffComponent.component, showHeader = typeof diffComponent.showHeader > "u" ? showHeader : diffComponent.showHeader), [{
    type: "field",
    diff,
    path,
    error,
    itemDiff,
    parentDiff,
    titlePath,
    schemaType,
    showHeader,
    showIndex: !0,
    key: pathToString$1(path) || "root",
    diffComponent: error ? void 0 : component,
    parentSchema
  }];
}
function reduceTitlePaths(changes, byLength = 1) {
  return changes.map((change) => (change.titlePath = change.titlePath.slice(byLength), change));
}
function isEmpty(item) {
  return Array.isArray(item) && item.length === 0 || item === null || typeof item > "u";
}
const isAddedAction = (change) => change.type === "field" && change.diff.action === "added", flattenChangeNode = (changeNode) => {
  if (changeNode.type !== "group")
    return [changeNode];
  const newSubChanges = [];
  return changeNode.changes.forEach((cChange) => {
    newSubChanges.push(...flattenChangeNode(cChange));
  }), newSubChanges;
}, isSubpathOf = (subPath, parentPath) => {
  if (parentPath.length >= subPath.length)
    return !1;
  for (let i = 0; i < parentPath.length; i++)
    if (parentPath[i] !== subPath[i])
      return !1;
  return !0;
}, pathSegmentOfCorrectType = (item, child) => {
  const nextItem = item[child], key = getItemKey$1(nextItem);
  return key ? {
    _key: key
  } : Array.isArray(item) ? parseInt(child, 10) : child;
}, diffOptions = {
  diffMatchPatch: {
    enabled: !1,
    lengthThresholdAbsolute: 30,
    lengthThresholdRelative: 1.2
  }
};
function undoChange(change, rootDiff, documentOperations) {
  if (!rootDiff)
    return;
  const patches = [];
  if (change.type === "group") {
    const allChanges = flattenChangeNode(change), unsetChanges = allChanges.filter(isAddedAction);
    allChanges.filter((child) => !isAddedAction(child)).forEach((child) => undoChange(child, rootDiff, documentOperations)), patches.push(...buildUnsetPatches(rootDiff, unsetChanges.map((unsetChange) => unsetChange.path).reverse()));
  } else change.diff.action === "added" ? patches.push(...buildUnsetPatches(rootDiff, [change.path])) : change.type === "field" && change.itemDiff && change.parentDiff && change.parentDiff.type === "array" && change.itemDiff.hasMoved ? patches.push(...buildMovePatches(change.itemDiff, change.parentDiff, change.path)) : patches.push(...buildUndoPatches(change.diff, rootDiff, change.path));
  documentOperations.patch.execute(patches);
}
function buildUnsetPatch(rootDiff, path, concurrentUnsetPaths) {
  const previousValue = rootDiff.toValue;
  return furthestEmptyAncestor(previousValue, path, concurrentUnsetPaths);
}
function buildUnsetPatches(rootDiff, paths) {
  const patches = [];
  for (let i = 0; i < paths.length; i++)
    patches.some((patch2) => isSubpathOf(paths[i], patch2)) || patches.push(buildUnsetPatch(rootDiff, paths[i], paths));
  return [{
    unset: [...new Set(patches.map(pathToString$1))]
  }];
}
function furthestEmptyAncestor(previousValue, currentPath, ignorePaths = [], initialPath) {
  if (currentPath.length <= 0)
    throw new Error("Root has no ancestor");
  const ancestorPath = currentPath.slice(0, -1), ancestorValue = getValueAtPath(previousValue, ancestorPath), updatedIgnorePaths = [
    ancestorPath,
    /*
     * We can filter out all the subpaths from under this ancestor
     * because since we ignore it higher up in the tree it doesn't
     * matter anymore what the values of subpaths are.
     */
    ...ignorePaths.filter((path) => !isSubpathOf(path, ancestorPath))
  ];
  return isStub(ancestorValue, ancestorPath, ignorePaths) ? furthestEmptyAncestor(previousValue, ancestorPath, updatedIgnorePaths) : currentPath;
}
function buildMovePatches(itemDiff, parentDiff, path) {
  const basePath = path.slice(0, -1), {
    parentValue,
    fromIndex,
    fromValue
  } = getFromItem(parentDiff, itemDiff);
  let insertLocation;
  if (fromIndex === 0)
    insertLocation = {
      before: pathToString$1([...basePath, 0])
    };
  else {
    const prevIndex = fromIndex - 1, prevSegment = getItemKeySegment(parentValue[prevIndex]) || prevIndex;
    insertLocation = {
      after: pathToString$1([...basePath, prevSegment])
    };
  }
  return [{
    unset: [pathToString$1(path)]
  }, {
    insert: {
      ...insertLocation,
      items: [fromValue]
    }
  }];
}
function buildUndoPatches(diff, rootDiff, path) {
  const patches = diffItem(diff.toValue, diff.fromValue, diffOptions, path), inserts = patches.filter((patch2) => patch2.op === "insert").map(({
    after,
    items
  }) => ({
    insert: {
      after: pathToString$1(after),
      items
    }
  })), unsets = patches.filter((patch2) => patch2.op === "unset").reduce((acc, patch2) => acc.concat(pathToString$1(patch2.path)), []), stubbedPaths = /* @__PURE__ */ new Set(), stubs = [];
  let hasSets = !1;
  const sets = patches.filter((patch2) => patch2.op === "set").reduce((acc, patch2) => (hasSets = !0, stubs.push(...getParentStubs(patch2.path, rootDiff, stubbedPaths)), acc[pathToString$1(patch2.path)] = patch2.value, acc), {});
  return [...stubs, ...inserts, ...unsets.length > 0 ? [{
    unset: unsets
  }] : [], ...hasSets ? [{
    set: sets
  }] : []];
}
function getParentStubs(path, rootDiff, stubbed) {
  const value = rootDiff.fromValue, nextValue = rootDiff.toValue, stubs = [];
  for (let i = 1; i <= path.length; i++) {
    const subPath = path.slice(0, i), pathStr = pathToString$1(subPath);
    if (stubbed.has(pathStr))
      continue;
    const nextSegment = path[i], nextIsArrayElement = isKeySegment(nextSegment) || isIndexSegment(nextSegment), itemValue = getValueAtPath(value, subPath), stub = getStubValue(itemValue);
    if (nextIsArrayElement && Array.isArray(itemValue) && !getValueAtPath(nextValue, path.slice(0, i + 1))) {
      const indexAtPrev = findIndex(itemValue, nextSegment), prevItem = itemValue[indexAtPrev - 1], nextItem = getValueAtPath(value, subPath.concat(nextSegment)), prevSeg = isKeyedObject(prevItem) ? {
        _key: prevItem._key
      } : indexAtPrev - 1, after = pathToString$1(subPath.concat(indexAtPrev < 1 ? 0 : prevSeg));
      stubs.push({
        setIfMissing: {
          [pathStr]: []
        }
      }), stubs.push({
        insert: {
          after,
          items: [getStubValue(nextItem)]
        }
      }), i++;
      continue;
    }
    typeof stub > "u" || (stubbed.add(pathStr), stubs.push({
      setIfMissing: {
        [pathStr]: stub
      }
    }));
  }
  return stubs;
}
function onlyContainsStubs(item, path, ignorePaths) {
  if (!isRecord$4(item) || !Array.isArray(item))
    return !1;
  for (const child in item) {
    if (!Object.prototype.hasOwnProperty.call(item, child) || child === "_type" || child === "_key")
      continue;
    const nextPath = [...path, pathSegmentOfCorrectType(item, child)];
    if (!isStub(item[child], nextPath, ignorePaths))
      return !1;
  }
  return !0;
}
function isStub(item, path, ignorePaths) {
  const isIgnoredPath = ignorePaths?.some((ignorePath) => pathToString$1(ignorePath) === pathToString$1(path)), isEmptyArray2 = Array.isArray(item) && item.length <= 0;
  return isIgnoredPath || item === void 0 || item === null || isEmptyArray2 || isEmptyObject$1(item) || onlyContainsStubs(item, path, ignorePaths);
}
function getStubValue(item) {
  if (Array.isArray(item))
    return [];
  if (typeof item != "object" || item === null)
    return;
  const props2 = {};
  return isKeyedObject(item) && (props2._key = item._key), isTypedObject(item) && (props2._type = item._type), props2;
}
function getFromItem(parentDiff, itemDiff) {
  if (parentDiff.fromValue && typeof itemDiff.fromIndex == "number") {
    const fromValue = parentDiff.fromValue[itemDiff.fromIndex];
    return {
      parentValue: parentDiff.fromValue,
      fromIndex: itemDiff.fromIndex,
      fromValue
    };
  }
  throw new Error(`Failed to find item at index ${itemDiff.fromIndex}`);
}
const ChangeListWrapper$1 = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
`;
class DiffErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  state = {};
  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error) {
    console.error("Error rendering diff component: "), console.error(error);
  }
  render() {
    const {
      t
    } = this.props, {
      error
    } = this.state;
    return error ? /* @__PURE__ */ jsx(Card, { padding: 3, radius: 2, tone: "critical", children: /* @__PURE__ */ jsxs(Flex, { children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }),
      /* @__PURE__ */ jsxs(Box, { paddingLeft: 3, children: [
        /* @__PURE__ */ jsx(Text$1, { as: "h3", size: 1, weight: "medium", children: t("changes.error-boundary.title") }),
        isDev && /* @__PURE__ */ jsx(Box, { marginTop: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, children: t("changes.error-boundary.developer-info") }) })
      ] })
    ] }) }) : this.props.children;
  }
}
const arrowComponents = {
  down: ArrowDownIcon,
  right: ArrowRightIcon
};
function FromToArrow(props2) {
  const $ = c(8);
  let restProps, t0;
  $[0] !== props2 ? ({
    direction: t0,
    ...restProps
  } = props2, $[0] = props2, $[1] = restProps, $[2] = t0) : (restProps = $[1], t0 = $[2]);
  const ArrowComponent = arrowComponents[t0 === void 0 ? "right" : t0];
  let t1;
  $[3] !== ArrowComponent ? (t1 = /* @__PURE__ */ jsx(ArrowComponent, {}), $[3] = ArrowComponent, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== restProps || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, ...restProps, children: t1 }), $[5] = restProps, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
const CodeWrapper = styled.pre`
  overflow-x: auto;
  position: relative;
`, Meta = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;
function DiffInspectWrapper(props2) {
  const $ = c(18);
  let as, change, children, restProps;
  $[0] !== props2 ? ({
    children,
    as,
    change,
    ...restProps
  } = props2, $[0] = props2, $[1] = as, $[2] = change, $[3] = children, $[4] = restProps) : (as = $[1], change = $[2], children = $[3], restProps = $[4]);
  const isHovering = useRef(!1), [isInspecting, setIsInspecting] = useState(!1);
  let t0;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setIsInspecting(_temp$13), $[5] = t0) : t0 = $[5];
  const toggleInspect = t0;
  let t1;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => isHovering.current = !0, $[6] = t1) : t1 = $[6];
  const handleMouseEnter = t1;
  let t2;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => isHovering.current = !1, $[7] = t2) : t2 = $[7];
  const handleMouseLeave = t2;
  let t3, t4;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    const onKeyDown = function(evt) {
      const {
        metaKey,
        key
      } = evt;
      metaKey && key === "i" && isHovering.current && toggleInspect();
    };
    return window.addEventListener("keydown", onKeyDown, !1), () => window.removeEventListener("keydown", onKeyDown, !1);
  }, t4 = [toggleInspect], $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5;
  $[10] !== change || $[11] !== children || $[12] !== isInspecting ? (t5 = isInspecting ? /* @__PURE__ */ jsx(DiffInspector, { change }) : children, $[10] = change, $[11] = children, $[12] = isInspecting, $[13] = t5) : t5 = $[13];
  let t6;
  return $[14] !== as || $[15] !== restProps || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { as, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ...restProps, children: t5 }), $[14] = as, $[15] = restProps, $[16] = t5, $[17] = t6) : t6 = $[17], t6;
}
function _temp$13(state) {
  return !state;
}
const MetaLabel = (t0) => {
  const $ = c(2), {
    title
  } = t0;
  let t1;
  return $[0] !== title ? (t1 = /* @__PURE__ */ jsx(Box, { padding: 3, display: "inline-block", as: Meta, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: title }) }), $[0] = title, $[1] = t1) : t1 = $[1], t1;
};
function DiffInspector(t0) {
  const $ = c(43), {
    change
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("changes.inspector.meta-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(MetaLabel, { title: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== change.diff.action || $[5] !== change.diff.isChanged || $[6] !== change.itemDiff?.fromIndex || $[7] !== change.itemDiff?.hasMoved || $[8] !== change.itemDiff?.toIndex || $[9] !== change.path ? (t3 = printMeta({
    path: pathToString$1(change.path),
    fromIndex: change.itemDiff?.fromIndex,
    toIndex: change.itemDiff?.toIndex,
    hasMoved: change.itemDiff?.hasMoved,
    action: change.diff.action,
    isChanged: change.diff.isChanged
  }), $[4] = change.diff.action, $[5] = change.diff.isChanged, $[6] = change.itemDiff?.fromIndex, $[7] = change.itemDiff?.hasMoved, $[8] = change.itemDiff?.toIndex, $[9] = change.path, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== t3 ? (t4 = /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t3 }), $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== t2 || $[14] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Card, { padding: 3, tone: "transparent", as: CodeWrapper, radius: 1, children: [
    t2,
    t4
  ] }), $[13] = t2, $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== t ? (t6 = t("changes.inspector.from-label"), $[16] = t, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== t6 ? (t7 = /* @__PURE__ */ jsx(MetaLabel, { title: t6 }), $[18] = t6, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== change.diff.fromValue ? (t8 = jsonify(change.diff.fromValue), $[20] = change.diff.fromValue, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] !== t8 ? (t9 = /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t8 }), $[22] = t8, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== t7 || $[25] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Card, { as: CodeWrapper, tone: "critical", padding: 3, radius: 1, children: [
    t7,
    t9
  ] }), $[24] = t7, $[25] = t9, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] === Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(FromToArrow, { direction: "down", align: "center" }) }), $[27] = t11) : t11 = $[27];
  let t12;
  $[28] !== t ? (t12 = t("changes.inspector.to-label"), $[28] = t, $[29] = t12) : t12 = $[29];
  let t13;
  $[30] !== t12 ? (t13 = /* @__PURE__ */ jsx(MetaLabel, { title: t12 }), $[30] = t12, $[31] = t13) : t13 = $[31];
  let t14;
  $[32] !== change.diff.toValue ? (t14 = jsonify(change.diff.toValue), $[32] = change.diff.toValue, $[33] = t14) : t14 = $[33];
  let t15;
  $[34] !== t14 ? (t15 = /* @__PURE__ */ jsx(Code, { language: "json", size: 1, children: t14 }), $[34] = t14, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] !== t13 || $[37] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Card, { as: CodeWrapper, tone: "positive", padding: 3, radius: 1, children: [
    t13,
    t15
  ] }), $[36] = t13, $[37] = t15, $[38] = t16) : t16 = $[38];
  let t17;
  return $[39] !== t10 || $[40] !== t16 || $[41] !== t5 ? (t17 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t5,
    t10,
    t11,
    t16
  ] }), $[39] = t10, $[40] = t16, $[41] = t5, $[42] = t17) : t17 = $[42], t17;
}
function jsonify(value) {
  return typeof value > "u" ? "undefined" : JSON.stringify(value, null, 2);
}
function printMeta(keys) {
  const lines = [];
  return Object.entries(keys).forEach(([key, value]) => {
    typeof value < "u" && value !== null && lines.push(`${key}: ${value}`);
  }), lines.join(`
`);
}
function useChangeVerb(diff) {
  const $ = c(6), {
    t
  } = useTranslation(), hadPrevValue = hasValue(diff.fromValue), hasNextValue = hasValue(diff.toValue);
  if (!hadPrevValue && hasNextValue) {
    let t02;
    return $[0] !== t ? (t02 = t("changes.added-label"), $[0] = t, $[1] = t02) : t02 = $[1], t02;
  }
  if (!hasNextValue && hadPrevValue) {
    let t02;
    return $[2] !== t ? (t02 = t("changes.removed-label"), $[2] = t, $[3] = t02) : t02 = $[3], t02;
  }
  let t0;
  return $[4] !== t ? (t0 = t("changes.changed-label"), $[4] = t, $[5] = t0) : t0 = $[5], t0;
}
function hasValue(value) {
  return value !== null && typeof value < "u" && value !== "";
}
const INLINE_COLUMN_STYLES = {
  flexShrink: 0
}, BLOCK_COLUMN_STYLES = {
  alignItems: "stretch"
}, FLEX_ALIGN = {
  top: "flex-start",
  center: "center",
  bottom: "flex-end",
  default: "flex-start"
}, FromTo = forwardRef(function(props2, ref) {
  const $ = c(28);
  let from2, restProps, style, t0, t1, to;
  $[0] !== props2 ? ({
    align: t0,
    layout: t1,
    from: from2,
    to,
    style,
    ...restProps
  } = props2, $[0] = props2, $[1] = from2, $[2] = restProps, $[3] = style, $[4] = t0, $[5] = t1, $[6] = to) : (from2 = $[1], restProps = $[2], style = $[3], t0 = $[4], t1 = $[5], to = $[6]);
  const align2 = t0 === void 0 ? "top" : t0, layout = t1 === void 0 ? "inline" : t1, theme = useTheme(), Layout2 = layout === "inline" ? Flex : Grid;
  let t2, t3;
  $[7] !== layout || $[8] !== theme ? (t3 = layout === "inline" ? {
    maxWidth: "100%",
    display: "inline-flex"
  } : {
    gridTemplateColumns: `minmax(0, 1fr) ${rem(theme.sanity.space[5])} minmax(0, 1fr)`
  }, $[7] = layout, $[8] = theme, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== style || $[11] !== t3 ? (t4 = {
    ...style,
    ...t3
  }, $[10] = style, $[11] = t3, $[12] = t4) : t4 = $[12], t2 = t4;
  const layoutStyles = t2, columnStyles = layout === "inline" ? INLINE_COLUMN_STYLES : BLOCK_COLUMN_STYLES;
  let t5;
  $[13] !== align2 || $[14] !== columnStyles || $[15] !== from2 ? (t5 = from2 && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Flex, { align: FLEX_ALIGN[align2], style: columnStyles, children: from2 }),
    /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", padding: 2, children: /* @__PURE__ */ jsx(FromToArrow, {}) })
  ] }), $[13] = align2, $[14] = columnStyles, $[15] = from2, $[16] = t5) : t5 = $[16];
  const t6 = FLEX_ALIGN[align2];
  let t7;
  $[17] !== columnStyles || $[18] !== t6 || $[19] !== to ? (t7 = /* @__PURE__ */ jsx(Flex, { align: t6, style: columnStyles, children: to }), $[17] = columnStyles, $[18] = t6, $[19] = to, $[20] = t7) : t7 = $[20];
  let t8;
  return $[21] !== Layout2 || $[22] !== layoutStyles || $[23] !== ref || $[24] !== restProps || $[25] !== t5 || $[26] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Layout2, { ...restProps, ref, style: layoutStyles, "data-from-to-layout": !0, children: [
    t5,
    t7
  ] }), $[21] = Layout2, $[22] = layoutStyles, $[23] = ref, $[24] = restProps, $[25] = t5, $[26] = t7, $[27] = t8) : t8 = $[27], t8;
}), cardStyles = {
  flex: 1,
  minWidth: 0,
  display: "block",
  whiteSpace: "break-spaces"
};
function DiffFromTo(props2) {
  const $ = c(39), {
    align: align2,
    cardClassName,
    diff,
    layout,
    path,
    previewComponent: PreviewComponent,
    schemaType
  } = props2, {
    action
  } = diff, changeVerb = useChangeVerb(diff);
  if (action === "unchanged") {
    let t02;
    $[0] !== PreviewComponent || $[1] !== diff.toValue || $[2] !== schemaType ? (t02 = /* @__PURE__ */ jsx(PreviewComponent, { schemaType, value: diff.toValue }), $[0] = PreviewComponent, $[1] = diff.toValue, $[2] = schemaType, $[3] = t02) : t02 = $[3];
    let t12;
    return $[4] !== cardClassName || $[5] !== t02 ? (t12 = /* @__PURE__ */ jsx(DiffCard, { className: cardClassName, style: cardStyles, children: t02 }), $[4] = cardClassName, $[5] = t02, $[6] = t12) : t12 = $[6], t12;
  }
  let t0;
  $[7] !== PreviewComponent || $[8] !== cardClassName || $[9] !== diff || $[10] !== path || $[11] !== schemaType ? (t0 = diff.fromValue !== void 0 && diff.fromValue !== null && /* @__PURE__ */ jsx(DiffCard, { as: "del", className: cardClassName, diff, path, style: cardStyles, children: /* @__PURE__ */ jsx(PreviewComponent, { schemaType, value: diff.fromValue }) }), $[7] = PreviewComponent, $[8] = cardClassName, $[9] = diff, $[10] = path, $[11] = schemaType, $[12] = t0) : t0 = $[12];
  const from2 = t0;
  let t1;
  $[13] !== PreviewComponent || $[14] !== cardClassName || $[15] !== diff || $[16] !== path || $[17] !== schemaType ? (t1 = diff.toValue !== void 0 && diff.toValue !== null && /* @__PURE__ */ jsx(DiffCard, { as: "ins", className: cardClassName, diff, path, style: cardStyles, children: /* @__PURE__ */ jsx(PreviewComponent, { schemaType, value: diff.toValue }) }), $[13] = PreviewComponent, $[14] = cardClassName, $[15] = diff, $[16] = path, $[17] = schemaType, $[18] = t1) : t1 = $[18];
  const to = t1;
  if (from2 && !to) {
    let t22;
    return $[19] !== changeVerb || $[20] !== diff || $[21] !== from2 || $[22] !== path ? (t22 = /* @__PURE__ */ jsx(DiffTooltip, { description: changeVerb, diff, path, children: from2 }), $[19] = changeVerb, $[20] = diff, $[21] = from2, $[22] = path, $[23] = t22) : t22 = $[23], t22;
  }
  if (!from2 && to) {
    let t22;
    return $[24] !== changeVerb || $[25] !== diff || $[26] !== path || $[27] !== to ? (t22 = /* @__PURE__ */ jsx(DiffTooltip, { description: changeVerb, diff, path, children: to }), $[24] = changeVerb, $[25] = diff, $[26] = path, $[27] = to, $[28] = t22) : t22 = $[28], t22;
  }
  let t2;
  $[29] !== align2 || $[30] !== from2 || $[31] !== layout || $[32] !== to ? (t2 = /* @__PURE__ */ jsx(FromTo, { align: align2, from: from2, layout, to }), $[29] = align2, $[30] = from2, $[31] = layout, $[32] = to, $[33] = t2) : t2 = $[33];
  let t3;
  return $[34] !== changeVerb || $[35] !== diff || $[36] !== path || $[37] !== t2 ? (t3 = /* @__PURE__ */ jsx(DiffTooltip, { description: changeVerb, diff, path, children: t2 }), $[34] = changeVerb, $[35] = diff, $[36] = path, $[37] = t2, $[38] = t3) : t3 = $[38], t3;
}
const FallbackPreview = (t0) => {
  const $ = c(3), {
    value,
    schemaType
  } = t0, t1 = value;
  let t2;
  return $[0] !== schemaType || $[1] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Preview$1, { schemaType, value: t1, layout: "default" }) }), $[0] = schemaType, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}, FallbackDiff = (props2) => {
  const $ = c(3), {
    diff,
    schemaType
  } = props2;
  let t0;
  return $[0] !== diff || $[1] !== schemaType ? (t0 = /* @__PURE__ */ jsx(DiffFromTo, { diff, schemaType, previewComponent: FallbackPreview, layout: "grid" }), $[0] = diff, $[1] = schemaType, $[2] = t0) : t0 = $[2], t0;
}, FieldChangeContainer = styled.div`
  --field-change-error: ${({
  theme
}) => theme.sanity.color.solid.critical.enabled.bg};
  &[data-revert-all-changes-hover] [data-revert-all-hover]::before {
    border-left: 2px solid var(--field-change-error);
  }
`, DiffBorder = styled.div`
  --field-change-error: ${({
  theme
}) => theme.sanity.color.solid.critical.enabled.bg};
  --diff-inspect-padding-xsmall: ${({
  theme
}) => rem(theme.sanity.space[1])};
  --diff-inspect-padding-small: ${({
  theme
}) => rem(theme.sanity.space[2])};

  position: relative;
  padding: var(--diff-inspect-padding-xsmall) 0 var(--diff-inspect-padding-xsmall)
    var(--diff-inspect-padding-small);

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    border-left: 1px solid var(--card-border-color);
  }

  &[data-error]:hover::before,
  &[data-revert-field-hover]:hover::before {
    border-left: 2px solid var(--field-change-error);
  }
`, Root$e = styled(Button)`
  [data-ui='Text'] {
    font-weight: normal;
  }

  div[data-ui='Box'] {
    display: none;
  }

  &:not([data-disabled='true']):hover,
  &:not([data-disabled='true']):focus {
    --card-fg-color: ${({
  theme
}) => theme.sanity.color.solid.critical.enabled.bg};
    --card-bg-color: transparent;
    --card-border-color: transparent;

    div[data-ui='Box'] {
      display: block;
    }
  }
`, RevertChangesButton = forwardRef(function(props2, ref) {
  const $ = c(12);
  let changeCount, restProps, selected;
  $[0] !== props2 ? ({
    selected,
    changeCount,
    ...restProps
  } = props2, $[0] = props2, $[1] = changeCount, $[2] = restProps, $[3] = selected) : (changeCount = $[1], restProps = $[2], selected = $[3]);
  const {
    t
  } = useTranslation();
  let t0;
  $[4] !== changeCount || $[5] !== t ? (t0 = t("changes.action.revert-changes-confirm-change", {
    count: changeCount
  }), $[4] = changeCount, $[5] = t, $[6] = t0) : t0 = $[6];
  let t1;
  return $[7] !== ref || $[8] !== restProps || $[9] !== selected || $[10] !== t0 ? (t1 = /* @__PURE__ */ jsx(Root$e, { icon: RevertIcon, selected, text: t0, mode: "bleed", ref, tooltipProps: null, ...restProps }), $[7] = ref, $[8] = restProps, $[9] = selected, $[10] = t0, $[11] = t1) : t1 = $[11], t1;
});
function ValueError(t0) {
  const $ = c(8), {
    error
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== error.actualType || $[2] !== error.expectedType || $[3] !== error.messageKey || $[4] !== t ? (t2 = t(error.messageKey, {
    expectedType: error.expectedType,
    actualType: error.actualType
  }), $[1] = error.actualType, $[2] = error.expectedType, $[3] = error.messageKey, $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { tone: "critical", padding: 3, children: /* @__PURE__ */ jsxs(Flex, { align: "flex-start", children: [
    t1,
    /* @__PURE__ */ jsx(Box, { flex: 1, paddingLeft: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, as: "p", children: t2 }) })
  ] }) }), $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}
function FieldChange(props2) {
  const $ = c(35), {
    change,
    hidden,
    readOnly
  } = props2, DiffComponent = change.diffComponent || FallbackDiff, {
    documentId,
    schemaType,
    rootDiff,
    isComparingCurrent,
    FieldWrapper: t0
  } = useDocumentChange(), FieldWrapper2 = t0 === void 0 ? Fragment$1 : t0, ops = useDocumentOperation(documentId, schemaType.name), [confirmRevertOpen, setConfirmRevertOpen] = useState(!1), [revertHovered, setRevertHovered] = useState(!1), popoverRef = useRef(null), {
    t
  } = useTranslation();
  let t1;
  $[0] !== documentId || $[1] !== schemaType.name ? (t1 = {
    id: documentId,
    type: schemaType.name,
    permission: "update"
  }, $[0] = documentId, $[1] = schemaType.name, $[2] = t1) : t1 = $[2];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t1);
  let t2;
  $[3] !== change || $[4] !== ops || $[5] !== rootDiff ? (t2 = () => {
    undoChange(change, rootDiff, ops);
  }, $[3] = change, $[4] = ops, $[5] = rootDiff, $[6] = t2) : t2 = $[6];
  const handleRevertChanges = t2;
  let t3;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setConfirmRevertOpen(!0);
  }, $[7] = t3) : t3 = $[7];
  const handleRevertChangesConfirm = t3;
  let t4;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setConfirmRevertOpen(!1);
  }, $[8] = t4) : t4 = $[8];
  const closeRevertChangesConfirmDialog = t4;
  let t5;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setRevertHovered(!0);
  }, $[9] = t5) : t5 = $[9];
  const handleRevertButtonMouseEnter = t5;
  let t6;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    setRevertHovered(!1);
  }, $[10] = t6) : t6 = $[10];
  const handleRevertButtonMouseLeave = t6;
  let t7, t8;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t7 = () => setConfirmRevertOpen(!1), t8 = () => [popoverRef.current], $[11] = t7, $[12] = t8) : (t7 = $[11], t8 = $[12]), useClickOutsideEvent(t7, t8);
  const isArray2 = change.parentSchema?.jsonType === "array";
  let t9;
  $[13] !== change.path || $[14] !== isArray2 ? (t9 = isArray2 ? change.path.slice(0, -1) : change.path, $[13] = change.path, $[14] = isArray2, $[15] = t9) : t9 = $[15];
  const fieldPath = t9;
  let t10, t11;
  $[16] !== change.path ? (t11 = {
    path: change.path
  }, $[16] = change.path, $[17] = t11) : t11 = $[17], t10 = t11;
  const value = t10;
  let t12;
  $[18] !== DiffComponent || $[19] !== FieldWrapper2 || $[20] !== change || $[21] !== confirmRevertOpen || $[22] !== fieldPath || $[23] !== handleRevertChanges || $[24] !== hidden || $[25] !== isComparingCurrent || $[26] !== isPermissionsLoading || $[27] !== permissions?.granted || $[28] !== readOnly || $[29] !== revertHovered || $[30] !== t || $[31] !== value ? (t12 = () => hidden ? null : /* @__PURE__ */ jsxs(Stack, { space: 1, as: FieldChangeContainer, children: [
    change.showHeader && /* @__PURE__ */ jsx(ChangeBreadcrumb, { change, titlePath: change.titlePath }),
    /* @__PURE__ */ jsx(FieldWrapper2, { path: fieldPath, hasHover: revertHovered, children: /* @__PURE__ */ jsxs(DiffInspectWrapper, { change, as: DiffBorder, "data-revert-field-hover": revertHovered ? "" : void 0, "data-error": change.error ? "" : void 0, "data-revert-all-hover": !0, "data-ui": "field-diff-inspect-wrapper", children: [
      change.error ? /* @__PURE__ */ jsx(ValueError, { error: change.error }) : /* @__PURE__ */ jsx(DiffErrorBoundary, { t, children: /* @__PURE__ */ jsx(DiffContext.Provider, { value, children: /* @__PURE__ */ jsx(DiffComponent, { diff: change.diff, schemaType: change.schemaType }) }) }),
      isComparingCurrent && !isPermissionsLoading && permissions?.granted && /* @__PURE__ */ jsx(Popover, { content: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
        /* @__PURE__ */ jsx(Box, { paddingY: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("changes.action.revert-changes-description", {
          count: 1
        }) }) }),
        /* @__PURE__ */ jsxs(Flex, { gap: 3, justify: "flex-end", children: [
          /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: closeRevertChangesConfirmDialog, text: t("changes.action.revert-all-cancel") }),
          /* @__PURE__ */ jsx(Button, { tone: "critical", onClick: handleRevertChanges, text: t("changes.action.revert-changes-confirm-change", {
            count: 1
          }) })
        ] })
      ] }), open: confirmRevertOpen, padding: 3, portal: !0, placement: "left", ref: popoverRef, children: /* @__PURE__ */ jsx(RevertChangesButton, { changeCount: 1, onClick: handleRevertChangesConfirm, onMouseEnter: handleRevertButtonMouseEnter, onMouseLeave: handleRevertButtonMouseLeave, selected: confirmRevertOpen, disabled: readOnly, "data-testid": `single-change-revert-button-${change?.key}` }) })
    ] }) })
  ] }), $[18] = DiffComponent, $[19] = FieldWrapper2, $[20] = change, $[21] = confirmRevertOpen, $[22] = fieldPath, $[23] = handleRevertChanges, $[24] = hidden, $[25] = isComparingCurrent, $[26] = isPermissionsLoading, $[27] = permissions?.granted, $[28] = readOnly, $[29] = revertHovered, $[30] = t, $[31] = value, $[32] = t12) : t12 = $[32];
  let t13;
  return $[33] !== t12 ? (t13 = t12(), $[33] = t12, $[34] = t13) : t13 = $[34], t13;
}
function useHover() {
  const $ = c(4), ref = useRef(null), [value, setValue] = useState(!1);
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    const node = ref.current;
    if (!node)
      return _temp$12;
    const handleMouseOver = () => setValue(!0), handleMouseOut = () => setValue(!1);
    return node.addEventListener("mouseover", handleMouseOver), node.addEventListener("mouseout", handleMouseOut), () => {
      node.removeEventListener("mouseover", handleMouseOver), node.removeEventListener("mouseout", handleMouseOut);
    };
  }, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  let t2;
  return $[2] !== value ? (t2 = [ref, value], $[2] = value, $[3] = t2) : t2 = $[3], t2;
}
function _temp$12() {
}
const ChangeListWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
`, GroupChangeContainer = styled.div`
  --field-change-error: ${({
  theme
}) => theme.sanity.color.solid.critical.enabled.bg};
  --diff-inspect-padding-xsmall: ${({
  theme
}) => rem(theme.sanity.space[1])};
  --diff-inspect-padding-small: ${({
  theme
}) => rem(theme.sanity.space[2])};

  position: relative;
  padding: var(--diff-inspect-padding-xsmall) var(--diff-inspect-padding-small);

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    border-left: 1px solid var(--card-border-color);
  }

  &[data-error]:hover::before,
  &[data-revert-group-hover]:hover::before,
  &[data-revert-all-groups-hover]::before {
    border-left: 2px solid var(--field-change-error);
  }
`;
function GroupChange(props2) {
  const $ = c(44);
  let group2, hidden, readOnly, restProps;
  $[0] !== props2 ? ({
    change: group2,
    readOnly,
    hidden,
    ...restProps
  } = props2, $[0] = props2, $[1] = group2, $[2] = hidden, $[3] = readOnly, $[4] = restProps) : (group2 = $[1], hidden = $[2], readOnly = $[3], restProps = $[4]);
  const {
    titlePath,
    changes,
    path: groupPath
  } = group2, {
    path: diffPath
  } = useContext(DiffContext), {
    documentId,
    schemaType,
    FieldWrapper: FieldWrapper2,
    rootDiff,
    isComparingCurrent
  } = useDocumentChange(), {
    t
  } = useTranslation();
  let t0;
  $[5] !== changes ? (t0 = changes.every(_temp$11), $[5] = changes, $[6] = t0) : t0 = $[6];
  const isPortableText2 = t0;
  let t1;
  $[7] !== diffPath || $[8] !== groupPath ? (t1 = pathsAreEqual(diffPath, groupPath), $[7] = diffPath, $[8] = groupPath, $[9] = t1) : t1 = $[9];
  const isNestedInDiff = t1, [revertButtonRef, isRevertButtonHovered] = useHover(), docOperations = useDocumentOperation(documentId, schemaType.name), [confirmRevertOpen, setConfirmRevertOpen] = useState(!1), popoverRef = useRef(null);
  let t2;
  $[10] !== documentId || $[11] !== schemaType.name ? (t2 = {
    id: documentId,
    type: schemaType.name,
    permission: "update"
  }, $[10] = documentId, $[11] = schemaType.name, $[12] = t2) : t2 = $[12];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t2);
  let t3;
  $[13] !== docOperations || $[14] !== group2 || $[15] !== rootDiff ? (t3 = () => undoChange(group2, rootDiff, docOperations), $[13] = docOperations, $[14] = group2, $[15] = rootDiff, $[16] = t3) : t3 = $[16];
  const handleRevertChanges = t3;
  let t4;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setConfirmRevertOpen(!0);
  }, $[17] = t4) : t4 = $[17];
  const handleRevertChangesConfirm = t4;
  let t5;
  $[18] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setConfirmRevertOpen(!1);
  }, $[18] = t5) : t5 = $[18];
  const closeRevertChangesConfirmDialog = t5;
  let t6, t7;
  $[19] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => setConfirmRevertOpen(!1), t7 = () => [popoverRef.current], $[19] = t6, $[20] = t7) : (t6 = $[19], t7 = $[20]), useClickOutsideEvent(t6, t7);
  let t8, t9;
  $[21] !== changes || $[22] !== confirmRevertOpen || $[23] !== group2.fieldsetName || $[24] !== handleRevertChanges || $[25] !== hidden || $[26] !== isComparingCurrent || $[27] !== isPermissionsLoading || $[28] !== isPortableText2 || $[29] !== isRevertButtonHovered || $[30] !== permissions?.granted || $[31] !== readOnly || $[32] !== revertButtonRef || $[33] !== t ? (t9 = hidden ? null : /* @__PURE__ */ jsxs(Stack, { space: 1, as: GroupChangeContainer, "data-ui": "group-change-content", "data-revert-group-hover": isRevertButtonHovered ? "" : void 0, "data-portable-text": isPortableText2 ? "" : void 0, children: [
    /* @__PURE__ */ jsx(Stack, { as: ChangeListWrapper, space: 5, "data-ui": "group-change-list", children: changes.map((change_0) => /* @__PURE__ */ jsx(ChangeResolver, { change: change_0, readOnly, hidden }, change_0.key)) }),
    isComparingCurrent && !isPermissionsLoading && permissions?.granted && /* @__PURE__ */ jsx(Popover, { content: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Box, { paddingY: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("changes.action.revert-changes-description", {
        count: changes.length
      }) }) }),
      /* @__PURE__ */ jsxs(Flex, { gap: 3, justify: "flex-end", children: [
        /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: closeRevertChangesConfirmDialog, text: t("changes.action.revert-all-cancel") }),
        /* @__PURE__ */ jsx(Button, { tone: "critical", onClick: handleRevertChanges, text: t("changes.action.revert-changes-confirm-change", {
          count: 1
        }) })
      ] })
    ] }), padding: 3, portal: !0, placement: "left", open: confirmRevertOpen, ref: popoverRef, children: /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(RevertChangesButton, { changeCount: changes.length, onClick: handleRevertChangesConfirm, ref: revertButtonRef, selected: confirmRevertOpen, disabled: readOnly, "data-testid": `group-change-revert-button-${group2.fieldsetName}` }) }) })
  ] }), $[21] = changes, $[22] = confirmRevertOpen, $[23] = group2.fieldsetName, $[24] = handleRevertChanges, $[25] = hidden, $[26] = isComparingCurrent, $[27] = isPermissionsLoading, $[28] = isPortableText2, $[29] = isRevertButtonHovered, $[30] = permissions?.granted, $[31] = readOnly, $[32] = revertButtonRef, $[33] = t, $[34] = t9) : t9 = $[34], t8 = t9;
  const content = t8;
  let t10;
  return $[35] !== FieldWrapper2 || $[36] !== content || $[37] !== group2.path || $[38] !== hidden || $[39] !== isNestedInDiff || $[40] !== isRevertButtonHovered || $[41] !== restProps || $[42] !== titlePath ? (t10 = hidden ? null : /* @__PURE__ */ jsxs(Stack, { space: 1, ...restProps, children: [
    /* @__PURE__ */ jsx(ChangeBreadcrumb, { titlePath }),
    isNestedInDiff || !FieldWrapper2 ? content : /* @__PURE__ */ jsx(FieldWrapper2, { hasHover: isRevertButtonHovered, path: group2.path, children: content })
  ] }), $[35] = FieldWrapper2, $[36] = content, $[37] = group2.path, $[38] = hidden, $[39] = isNestedInDiff, $[40] = isRevertButtonHovered, $[41] = restProps, $[42] = titlePath, $[43] = t10) : t10 = $[43], t10;
}
function _temp$11(change) {
  return isFieldChange(change) && isPTSchemaType(change.schemaType);
}
function ChangeResolver(props2) {
  const $ = c(17), {
    change,
    hidden,
    readOnly
  } = props2, {
    value
  } = useDocumentChange(), t0 = value, t1 = hidden || change.schemaType?.hidden, t2 = change.type === "field" ? change.diff.toValue : void 0;
  let t3;
  $[0] !== t0 || $[1] !== t1 || $[2] !== t2 ? (t3 = {
    document: t0,
    checkProperty: t1,
    checkPropertyKey: "hidden",
    value: t2
  }, $[0] = t0, $[1] = t1, $[2] = t2, $[3] = t3) : t3 = $[3];
  const isHidden = useConditionalProperty(t3), t4 = value, t5 = readOnly || change.schemaType?.readOnly, t6 = change.type === "field" ? change.diff.toValue : void 0;
  let t7;
  $[4] !== t4 || $[5] !== t5 || $[6] !== t6 ? (t7 = {
    document: t4,
    checkProperty: t5,
    checkPropertyKey: "readOnly",
    value: t6
  }, $[4] = t4, $[5] = t5, $[6] = t6, $[7] = t7) : t7 = $[7];
  const isReadOnly = useConditionalProperty(t7);
  if (isHidden)
    return null;
  if (change.type === "field") {
    let t82;
    return $[8] !== change || $[9] !== isReadOnly ? (t82 = /* @__PURE__ */ jsx(FieldChange, { change, readOnly: isReadOnly }), $[8] = change, $[9] = isReadOnly, $[10] = t82) : t82 = $[10], t82;
  }
  if (change.type === "group") {
    const t82 = `group-change-${change.fieldsetName}`;
    let t92;
    return $[11] !== change || $[12] !== isReadOnly || $[13] !== t82 ? (t92 = /* @__PURE__ */ jsx(GroupChange, { change, "data-testid": t82, readOnly: isReadOnly }), $[11] = change, $[12] = isReadOnly, $[13] = t82, $[14] = t92) : t92 = $[14], t92;
  }
  const t8 = change.type || "undefined";
  let t9;
  return $[15] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Text$1, { children: [
    "Unknown change type: ",
    /* @__PURE__ */ jsx("code", { children: t8 })
  ] }), $[15] = t8, $[16] = t9) : t9 = $[16], t9;
}
function NoChanges() {
  const $ = c(11), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("changes.no-changes-title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", as: "h3", children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t ? (t2 = t("changes.no-changes-description"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, muted: !0, children: t2 }), $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== t1 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { space: 3, paddingTop: 2, children: [
    t1,
    t3
  ] }), $[8] = t1, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
}
function ChangeList({
  diff,
  fields,
  schemaType
}) {
  const {
    documentId,
    isComparingCurrent,
    value
  } = useDocumentChange(), docOperations = useDocumentOperation(documentId, schemaType.name), {
    path
  } = useContext(DiffContext), isRoot = path.length === 0, [confirmRevertAllOpen, setConfirmRevertAllOpen] = useState(!1), [confirmRevertAllHover, setConfirmRevertAllHover] = useState(!1), {
    t
  } = useTranslation(), isReadOnly = useConditionalProperty({
    document: value,
    value: void 0,
    checkProperty: schemaType.readOnly,
    checkPropertyKey: "readOnly"
  });
  if (schemaType.jsonType !== "object")
    throw new Error("Only object schema types are allowed in ChangeList");
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions({
    id: documentId,
    type: schemaType.name,
    permission: "update"
  }), allChanges = useMemo(() => buildObjectChangeList(schemaType, diff, path, [], {
    fieldFilter: fields
  }), [schemaType, fields, path, diff]), changes = useMemo(() => fields && fields.length === 0 ? [] : maybeFlatten(allChanges), [allChanges, fields]), rootChange = allChanges[0], revertAllChanges = useCallback(() => {
    undoChange(rootChange, diff, docOperations), setConfirmRevertAllOpen(!1);
  }, [rootChange, diff, docOperations]), handleRevertAllChangesClick = useCallback(() => {
    setConfirmRevertAllOpen(!0);
  }, []), handleRevertAllChangesMouseEnter = useCallback(() => {
    setConfirmRevertAllHover(!0);
  }, []), handleRevertAllChangesMouseLeave = useCallback(() => {
    setConfirmRevertAllHover(!1);
  }, []), closeRevertAllChangesConfirmDialog = useCallback(() => {
    setConfirmRevertAllOpen(!1);
  }, []), revertAllContainerElementRef = useRef(null);
  if (useClickOutsideEvent(() => setConfirmRevertAllOpen(!1), () => [revertAllContainerElementRef.current]), changes.length === 0)
    return isRoot ? /* @__PURE__ */ jsx(NoChanges, {}) : null;
  const showFooter = isRoot && changes.length > 1;
  return /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    /* @__PURE__ */ jsx(Stack, { as: ChangeListWrapper$1, space: 5, children: changes.map((change) => /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ChangeResolver, { change, "data-revert-all-changes-hover": confirmRevertAllHover ? "" : void 0, readOnly: isReadOnly || change?.readOnly, hidden: change?.hidden }, change.key) }, change.key)) }),
    showFooter && isComparingCurrent && !isPermissionsLoading && permissions?.granted && /* @__PURE__ */ jsx(Popover, { content: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Box, { paddingY: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("changes.action.revert-all-description", {
        count: changes.length
      }) }) }),
      /* @__PURE__ */ jsxs(Flex, { gap: 3, justify: "flex-end", children: [
        /* @__PURE__ */ jsx(Button, { mode: "ghost", text: t("changes.action.revert-all-cancel"), onClick: closeRevertAllChangesConfirmDialog }),
        /* @__PURE__ */ jsx(Button, { tone: "critical", text: t("changes.action.revert-all-confirm"), onClick: revertAllChanges })
      ] })
    ] }), open: confirmRevertAllOpen, padding: 3, placement: "left", portal: !0, ref: revertAllContainerElementRef, children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Button, { tone: "critical", mode: "ghost", text: t("changes.action.revert-all-confirm"), icon: RevertIcon, onClick: handleRevertAllChangesClick, onMouseEnter: handleRevertAllChangesMouseEnter, onMouseLeave: handleRevertAllChangesMouseLeave, disabled: isReadOnly, size: "large" }) }) })
  ] }) });
}
function maybeFlatten(changes) {
  return changes.length === 1 && changes[0].type === "group" && changes[0].path.length === 0 ? changes[0].changes : changes;
}
function ChangesError(t0) {
  const $ = c(16), {
    error
  } = t0, {
    t
  } = useTranslation(), revisionNotFoundError = error instanceof MissingSinceDocumentError;
  let t1;
  $[0] !== t ? (t1 = t("changes.error-title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", as: "h3", children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t ? (t3 = t("changes.error-description"), $[4] = t, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, muted: !0, children: t3 }), $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== error || $[9] !== revisionNotFoundError || $[10] !== t ? (t5 = revisionNotFoundError && /* @__PURE__ */ jsx(Box, { paddingTop: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "p", size: 1, muted: !0, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "changes.missing-since-document-error", t, values: {
    revisionId: error.revisionId
  }, components: {
    Break: _temp$10
  } }) }) }), $[8] = error, $[9] = revisionNotFoundError, $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== t2 || $[13] !== t4 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { tone: "caution", padding: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t2,
    t4,
    t5
  ] }) }), $[12] = t2, $[13] = t4, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function _temp$10() {
  return /* @__PURE__ */ jsx("br", {});
}
const RoundedCard = styled.span`
  border-radius: ${({
  theme
}) => rem(theme.sanity.radius[1])};
`, ChangeSegment = styled(Text$1)`
  &:not([hidden]) {
    display: inline;
    line-height: calc(1.25em + 2px);
  }

  &:hover {
    background-color: none !important;
    background-image: linear-gradient(
      to bottom,
      var(--card-bg-color) 0,
      var(--card-bg-color) 33.333%,
      currentColor 33.333%,
      currentColor 100%
    );
    background-size: 1px 3px;
    background-repeat: repeat-x;
    background-position-y: bottom;
    padding-bottom: 3px;
    box-shadow: 0 0 0 1px var(--card-bg-color);
    z-index: 1;
  }
`;
function DiffStringSegment(props2) {
  const $ = c(24), {
    segment
  } = props2, {
    text
  } = segment, {
    t
  } = useTranslation();
  if (segment.action === "added") {
    const t02 = segment.annotation;
    let t12;
    $[0] !== t ? (t12 = t("changes.added-label"), $[0] = t, $[1] = t12) : t12 = $[1];
    let t2;
    $[2] !== t12 ? (t2 = {
      description: t12
    }, $[2] = t12, $[3] = t2) : t2 = $[3];
    let t3;
    $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
      textDecoration: "none"
    }, $[4] = t3) : t3 = $[4];
    let t4;
    $[5] !== text ? (t4 = /* @__PURE__ */ jsx(ChangeSegment, { as: "ins", style: t3, children: text }), $[5] = text, $[6] = t4) : t4 = $[6];
    let t5;
    return $[7] !== segment.annotation || $[8] !== t2 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(DiffCard, { annotation: t02, disableHoverEffect: !0, tooltip: t2, as: RoundedCard, children: t4 }), $[7] = segment.annotation, $[8] = t2, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
  }
  if (segment.action === "removed") {
    const t02 = segment.annotation;
    let t12;
    $[11] !== t ? (t12 = t("changes.removed-label"), $[11] = t, $[12] = t12) : t12 = $[12];
    let t2;
    $[13] !== t12 ? (t2 = {
      description: t12
    }, $[13] = t12, $[14] = t2) : t2 = $[14];
    let t3;
    $[15] !== text ? (t3 = /* @__PURE__ */ jsx(ChangeSegment, { as: "del", children: text }), $[15] = text, $[16] = t3) : t3 = $[16];
    let t4;
    return $[17] !== segment.annotation || $[18] !== t2 || $[19] !== t3 ? (t4 = /* @__PURE__ */ jsx(DiffCard, { annotation: t02, as: RoundedCard, disableHoverEffect: !0, tooltip: t2, children: t3 }), $[17] = segment.annotation, $[18] = t2, $[19] = t3, $[20] = t4) : t4 = $[20], t4;
  }
  let t0;
  $[21] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    display: "inline"
  }, $[21] = t0) : t0 = $[21];
  let t1;
  return $[22] !== text ? (t1 = /* @__PURE__ */ jsx(Card, { as: "span", radius: 2, style: t0, children: text }), $[22] = text, $[23] = t1) : t1 = $[23], t1;
}
function DiffString(props2) {
  const $ = c(6), {
    diff
  } = props2;
  let t0;
  $[0] !== diff.segments ? (t0 = diff.segments || [], $[0] = diff.segments, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t0 ? (t1 = t0.map(_temp$$), $[2] = t0, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Fragment, { children: t1 }), $[4] = t1, $[5] = t2) : t2 = $[5], t2;
}
function _temp$$(segment, segmentIndex) {
  return /* @__PURE__ */ jsx(DiffStringSegment, { segment }, segmentIndex);
}
const MetaText = styled(Text$1)`
  color: inherit;
`;
function MetaInfo(props2) {
  const $ = c(17), {
    title,
    action,
    icon: Icon2,
    children,
    markRemoved
  } = props2;
  let t0;
  $[0] !== Icon2 || $[1] !== markRemoved ? (t0 = Icon2 && /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(MetaText, { size: 4, forwardedAs: markRemoved ? "del" : "div", children: /* @__PURE__ */ jsx(Icon2, {}) }) }), $[0] = Icon2, $[1] = markRemoved, $[2] = t0) : t0 = $[2];
  const t1 = markRemoved ? "del" : "h3";
  let t2;
  $[3] !== t1 || $[4] !== title ? (t2 = /* @__PURE__ */ jsx(MetaText, { size: 1, weight: "medium", forwardedAs: t1, textOverflow: "ellipsis", children: title }), $[3] = t1, $[4] = title, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== action ? (t3 = action && /* @__PURE__ */ jsx("div", { children: action }), $[6] = action, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== children ? (t4 = /* @__PURE__ */ jsx(MetaText, { size: 0, textOverflow: "ellipsis", children }), $[8] = children, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t2 || $[11] !== t3 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 2, paddingLeft: 2, children: [
    t2,
    t3,
    t4
  ] }), $[10] = t2, $[11] = t3, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  return $[14] !== t0 || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { padding: 2, align: "center", children: [
    t0,
    t5
  ] }), $[14] = t0, $[15] = t5, $[16] = t6) : t6 = $[16], t6;
}
function isEqual(item, otherItem) {
  if (item === otherItem)
    return !0;
  if (typeof item != typeof otherItem)
    return !1;
  if (typeof item != "object" && !Array.isArray(item))
    return item === otherItem;
  if (isKeyedObject(item) && isKeyedObject(otherItem) && item._key === otherItem._key)
    return !0;
  if (Array.isArray(item) && Array.isArray(otherItem))
    return item.length !== otherItem.length ? !1 : item.every((child, i) => isEqual(child, otherItem[i]));
  if (item === null || otherItem === null)
    return item === otherItem;
  const obj = item, otherObj = otherItem, keys = Object.keys(obj), otherKeys = Object.keys(otherObj);
  return keys.length !== otherKeys.length ? !1 : keys.every((keyName) => isEqual(obj[keyName], otherObj[keyName]));
}
const ArrayOfOptionsFieldDiff = (t0) => {
  const $ = c(14), {
    diff,
    schemaType
  } = t0, options = schemaType.options?.list, colorManager = useUserColorManager(), {
    t
  } = useTranslation();
  if (!Array.isArray(options))
    return null;
  let t1;
  if ($[0] !== colorManager || $[1] !== diff || $[2] !== schemaType || $[3] !== t) {
    let t22;
    $[5] !== diff || $[6] !== schemaType ? (t22 = (item) => normalizeItems(item, diff, schemaType), $[5] = diff, $[6] = schemaType, $[7] = t22) : t22 = $[7];
    let t3;
    $[8] !== colorManager || $[9] !== diff || $[10] !== t ? (t3 = (item_1, index) => {
      const {
        annotation,
        isPresent,
        value,
        memberType,
        title
      } = item_1, color = getAnnotationColor(colorManager, annotation), action = t(isPresent ? "changes.added-label" : "changes.removed-label");
      return /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
        /* @__PURE__ */ jsx(DiffTooltip, { annotations: annotation ? [annotation] : [], description: action, children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
          /* @__PURE__ */ jsx(Checkbox, { checked: !isPresent, color }),
          /* @__PURE__ */ jsx(Box, { margin: 2, children: /* @__PURE__ */ jsx(FromToArrow, {}) }),
          /* @__PURE__ */ jsx(Checkbox, { checked: isPresent, color })
        ] }) }),
        /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(ItemPreview, { value: title || value, memberType }) })
      ] }, getItemKey(diff, index));
    }, $[8] = colorManager, $[9] = diff, $[10] = t, $[11] = t3) : t3 = $[11], t1 = diff.items.map(t22).filter(_temp$_).sort(sortItems).map(t3), $[0] = colorManager, $[1] = diff, $[2] = schemaType, $[3] = t, $[4] = t1;
  } else
    t1 = $[4];
  let t2;
  return $[12] !== t1 ? (t2 = /* @__PURE__ */ jsx("div", { children: t1 }), $[12] = t1, $[13] = t2) : t2 = $[13], t2;
};
function normalizeItems(item, parentDiff, schemaType) {
  if (item.diff.action === "unchanged")
    return null;
  const {
    fromValue,
    toValue
  } = parentDiff, value = getValue(item.diff), wasPresent = isInArray(value, fromValue), isPresent = isInArray(value, toValue);
  return wasPresent === isPresent ? null : {
    title: getItemTitle(value, schemaType),
    memberType: resolveMemberType(getValue(item.diff), schemaType),
    itemIndex: getOptionIndex(value, schemaType),
    annotation: item.annotation,
    isPresent,
    value
  };
}
function sortItems(itemA, itemB) {
  return itemA.itemIndex - itemB.itemIndex;
}
function ItemPreview(t0) {
  const $ = c(5), {
    value,
    memberType
  } = t0;
  let t1;
  $[0] !== memberType || $[1] !== value ? (t1 = typeof value == "string" || typeof value == "number" ? value : /* @__PURE__ */ jsx(Preview$1, { schemaType: memberType, value, layout: "default" }), $[0] = memberType, $[1] = value, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { marginX: 2, marginY: 1, children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
function isInArray(value, parent) {
  const array = parent || [];
  return typeof value == "object" && value !== null ? array.some((item) => isEqual(item, value)) : array.includes(value);
}
function getItemKey(diff, index) {
  const value = diff.toValue || diff.fromValue;
  return isKeyedObject(value) ? value._key : index;
}
function getValue(diff) {
  return typeof diff.toValue > "u" ? diff.fromValue : diff.toValue;
}
function resolveMemberType(item, schemaType) {
  const itemTypeName = resolveTypeName(item);
  return schemaType.of.find((memberType) => memberType.name === itemTypeName);
}
function resolveTypeName(value) {
  const jsType = resolveJSType(value);
  if (jsType !== "object")
    return jsType;
  const obj = value;
  return "_type" in obj && obj._type || jsType;
}
function resolveJSType(val) {
  return val === null ? "null" : Array.isArray(val) ? "array" : typeof val;
}
function isNamedOption(item) {
  return typeof item == "object" && item !== null && "title" in item;
}
function getOptionIndex(item, schemaType) {
  return (schemaType.options?.list || []).findIndex((opt) => isEqual(isNamedOption(opt) ? opt.value : opt, item));
}
function getItemTitle(item, schemaType) {
  const list = schemaType.options?.list || [], index = getOptionIndex(item, schemaType);
  return index === -1 ? void 0 : list[index].title || void 0;
}
function _temp$_(item_0) {
  return item_0 !== null;
}
const SlugWrapper = styled.div`
  display: inline-block;
  word-break: break-all;
  white-space: pre-wrap;
`, SlugPreview = (props2) => {
  const $ = c(2), {
    value
  } = props2;
  let t0;
  return $[0] !== value.current ? (t0 = /* @__PURE__ */ jsx(Box, { as: SlugWrapper, paddingX: 2, paddingY: 1, children: value.current }), $[0] = value.current, $[1] = t0) : t0 = $[1], t0;
}, SlugFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { layout: "inline", diff, schemaType, previewComponent: SlugPreview }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
}, UrlFieldDiff = (t0) => {
  const $ = c(3), {
    diff,
    schemaType
  } = t0;
  let t1;
  return $[0] !== diff || $[1] !== schemaType ? (t1 = /* @__PURE__ */ jsx(DiffFromTo, { diff, schemaType, previewComponent: StringPreview }), $[0] = diff, $[1] = schemaType, $[2] = t1) : t1 = $[2], t1;
}, diffResolver = ({
  schemaType
}) => {
  if (["datetime", "date"].includes(schemaType.name))
    return DatetimeFieldDiff;
  if (schemaType.name === "url")
    return UrlFieldDiff;
  if (schemaType.name === "slug")
    return SlugFieldDiff;
  if (schemaType.jsonType === "array" && Array.isArray(schemaType.options?.list))
    return ArrayOfOptionsFieldDiff;
}, GetFormValueProvider = function(props2) {
  const $ = c(6), valueRef = useRef(props2.value);
  let t0, t1;
  $[0] !== props2.value ? (t0 = () => {
    valueRef.current = props2.value;
  }, t1 = [props2.value], $[0] = props2.value, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (path) => getValueAtPath(valueRef.current, path), $[3] = t2) : t2 = $[3];
  const getValue2 = t2;
  let t3;
  return $[4] !== props2.children ? (t3 = /* @__PURE__ */ jsx(GetFormValueContext.Provider, { value: getValue2, children: props2.children }), $[4] = props2.children, $[5] = t3) : t3 = $[5], t3;
};
GetFormValueProvider.displayName = "GetFormValueProvider";
function useGetFormValue() {
  const ctx = useContext(GetFormValueContext);
  if (!ctx)
    throw new Error("useGetFormValue must be used within a GetFormValueProvider");
  return ctx;
}
const copyAction = {
  name: "copyField",
  useAction({
    path
  }) {
    const getFormValue = useGetFormValue(), {
      onCopy
    } = useCopyPaste(), {
      t
    } = useTranslation("copy-paste"), isDocument = path.length === 0, documentTitle = t("copy-paste.field-action-copy-button.document.title"), fieldTitle = t("copy-paste.field-action-copy-button.field.title"), title = isDocument ? documentTitle : fieldTitle, onAction = useCallback(() => {
      const value = getFormValue([]);
      onCopy(path, value, {
        context: {
          source: isDocument ? "documentFieldAction" : "fieldAction"
        }
      });
    }, [path, isDocument, onCopy, getFormValue]);
    return {
      type: "action",
      icon: CopyIcon,
      onAction,
      title
    };
  }
}, pasteAction = {
  name: "pasteField",
  useAction({
    path
  }) {
    const {
      t
    } = useTranslation("copy-paste"), getFormValue = useGetFormValue(), isDocument = path.length === 0, documentTitle = t("copy-paste.field-action-paste-button.document.title"), fieldTitle = t("copy-paste.field-action-paste-button.field.title"), title = isDocument ? documentTitle : fieldTitle, {
      onPaste
    } = useCopyPaste(), onAction = useCallback(() => {
      const value = getFormValue([]);
      onPaste(path, value, {
        context: {
          source: isDocument ? "documentFieldAction" : "fieldAction"
        }
      });
    }, [getFormValue, onPaste, path, isDocument]);
    return {
      type: "action",
      icon: ClipboardIcon,
      onAction,
      title
    };
  }
}, documentFieldActionsReducer = (prev, {
  document: document2
}, context) => {
  const documentFieldActions = document2?.unstable_fieldActions;
  if (!documentFieldActions) return prev;
  if (typeof documentFieldActions == "function") return documentFieldActions(prev, context);
  if (Array.isArray(documentFieldActions)) return [...prev, ...documentFieldActions];
  throw new Error(`Expected \`document.unstable_fieldActions\` to be an array or a function, but received ${typeof documentFieldActions}`);
}, initialDocumentFieldActions = [copyAction, pasteAction];
function defineDocumentInspector(inspector) {
  return inspector;
}
function SchedulePublishingStudioLayout$1(props2) {
  const $ = c(5), toast = useToast();
  let t0, t1;
  $[0] !== toast ? (t0 = () => {
    console.error(`Scheduled publishing plugin is added by default, please remove this plugin from your config. 
        
If you have a custom date config, you can use the scheduledPublishing API to customize the date input.
        
See: https://www.sanity.io/docs/scheduled-publishing.
        `), toast.push({
      id: "scheduled-publishing-deprecated",
      closable: !0,
      duration: 6e4,
      status: "error",
      title: "Scheduled publishing plugin is deprecated",
      description: "The scheduled publishing plugin is now deprecated, you should remove the plugin from your configuration. If you have a custom date config, you can use the scheduledPublishing API to customize the date input. See: https://www.sanity.io/docs/scheduled-publishing."
    });
  }, t1 = [toast], $[0] = toast, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  let t2;
  return $[3] !== props2 ? (t2 = props2.renderDefault(props2), $[3] = props2, $[4] = t2) : t2 = $[4], t2;
}
const deprecatedScheduledPublishingPlugin = definePlugin({
  name: "sanity/deprecated/scheduled-publishing",
  studio: {
    components: {
      layout: SchedulePublishingStudioLayout$1
    }
  }
}), DEPRECATED_PLUGINS = [
  // Scheduled publishing is added by default, we are filtering to avoid duplicates
  "scheduled-publishing"
], flattenConfig = ({
  plugins = [],
  ...currentConfig
}, path) => {
  const rootConfig = {
    config: currentConfig,
    path: [...path, currentConfig.name]
  }, allPlugins = plugins.flatMap((plugin) => flattenConfig(plugin, [...path, currentConfig.name])), deprecatedScheduledPublishing = allPlugins.find((p) => p.config.name === "scheduled-publishing");
  return deprecatedScheduledPublishing && allPlugins.push({
    path: deprecatedScheduledPublishing.path,
    config: deprecatedScheduledPublishingPlugin()
  }), [...allPlugins.filter((plugin) => !DEPRECATED_PLUGINS.includes(plugin.config.name)), rootConfig];
}, initialDocumentBadges = [], initialDocumentActions = [], initialLanguageFilter = [], schemaTypesReducer = (prev, {
  schema: schema2
}, context) => {
  const schemaTypes = schema2?.types;
  if (!schemaTypes) return prev;
  if (typeof schemaTypes == "function") return schemaTypes(prev, context);
  if (Array.isArray(schemaTypes)) return [...prev, ...schemaTypes];
  throw new Error(`Expected \`schema.types\` to be an array or a function, but received ${getPrintableType(schemaTypes)}`);
}, resolveProductionUrlReducer = async (prev, {
  document: document2
}, context) => {
  const resolveProductionUrl = document2?.productionUrl;
  return resolveProductionUrl ? await resolveProductionUrl(prev, context) : prev;
}, toolsReducer = (prev, {
  tools
}, context) => {
  if (!tools) return prev;
  if (typeof tools == "function") return tools(prev, context);
  if (Array.isArray(tools)) return [...prev, ...tools];
  throw new Error(`Expected \`tools\` to be an array or a function, but received ${getPrintableType(tools)}`);
}, schemaTemplatesReducer = (prev, {
  schema: schema2
}, context) => {
  const schemaTemplates = schema2?.templates;
  if (!schemaTemplates) return prev;
  if (typeof schemaTemplates == "function") return schemaTemplates(prev, context);
  if (Array.isArray(schemaTemplates)) return [...prev, ...schemaTemplates];
  throw new Error(`Expected \`schema.templates\` to be an array or a function, but received ${getPrintableType(schemaTemplates)}`);
}, localeDefReducer = (prev, {
  i18n
}, context) => {
  const locales = i18n?.locales;
  if (!locales) return prev;
  if (typeof locales == "function") return locales(prev, context);
  if (Array.isArray(locales)) return [...prev, ...locales];
  throw new Error(`Expected \`i18n.locales\` to be an array or a function, but received ${getPrintableType(locales)}`);
}, localeBundlesReducer = (prev, {
  i18n
}, context) => {
  const bundles = i18n?.bundles;
  if (!bundles) return prev;
  if (Array.isArray(bundles)) return [...prev, ...bundles];
  if (typeof bundles == "function") return bundles(prev, context);
  throw new Error(`Expected \`i18n.bundles\` to be an array or a function, but received ${typeof bundles}`);
}, documentBadgesReducer = (prev, {
  document: document2
}, context) => {
  const documentBadges = document2?.badges;
  if (!documentBadges) return prev;
  if (typeof documentBadges == "function") return documentBadges(prev, context);
  if (Array.isArray(documentBadges)) return [...prev, ...documentBadges];
  throw new Error(`Expected \`document.badges\` to be an array or a function, but received ${getPrintableType(documentBadges)}`);
}, documentActionsReducer = (prev, {
  document: document2
}, context) => {
  const documentActions = document2?.actions;
  if (!documentActions) return prev;
  if (typeof documentActions == "function") return documentActions(prev, context);
  if (Array.isArray(documentActions)) return [...prev, ...documentActions];
  throw new Error(`Expected \`document.actions\` to be an array or a function, but received ${getPrintableType(documentActions)}`);
}, newDocumentOptionsResolver = (prev, {
  document: document2
}, context) => {
  const resolveNewDocumentOptions = document2?.newDocumentOptions;
  if (!resolveNewDocumentOptions) return prev;
  if (typeof resolveNewDocumentOptions != "function")
    throw new Error(`Expected \`document.resolveNewDocumentOptions\` to be a function, but received ${getPrintableType(resolveNewDocumentOptions)}`);
  return resolveNewDocumentOptions(prev, context);
}, fileAssetSourceResolver = (prev, {
  form
}, context) => {
  const assetSources = form?.file?.assetSources;
  if (!assetSources) return prev;
  if (typeof assetSources == "function") return assetSources(prev, context);
  if (Array.isArray(assetSources)) return [...prev, ...assetSources];
  throw new Error(`Expected \`form.file.assetSources\` to be an array or a function, but received ${getPrintableType(assetSources)}`);
}, directUploadsReducer = (opts) => {
  const {
    config,
    schemaTypeName
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.form?.[schemaTypeName]?.directUploads;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`form.${schemaTypeName}.directUploads\` to be a boolean, but received ${getPrintableType(resolver)}`);
  }, !0);
}, imageAssetSourceResolver = (prev, {
  form
}, context) => {
  const assetSources = form?.image?.assetSources;
  if (!assetSources) return prev;
  if (typeof assetSources == "function") return assetSources(prev, context);
  if (Array.isArray(assetSources)) return [...prev, ...assetSources];
  throw new Error(`Expected \`form.image.assetSources\` to be an array or a function, but received ${getPrintableType(assetSources)}`);
}, documentLanguageFilterReducer = (prev, {
  document: document2
}, context) => {
  const resolveDocumentLanguageFilter = document2?.unstable_languageFilter;
  if (!resolveDocumentLanguageFilter) return prev;
  if (typeof resolveDocumentLanguageFilter == "function") return resolveDocumentLanguageFilter(prev, context);
  if (Array.isArray(resolveDocumentLanguageFilter)) return [...prev, ...resolveDocumentLanguageFilter];
  throw new Error(`Expected \`document.unstable_languageFilter\` to be an array or a function, but received ${getPrintableType(resolveDocumentLanguageFilter)}`);
}, documentInspectorsReducer = (prev, {
  document: document2
}, context) => {
  const resolveInspectorsFilter = document2?.inspectors;
  if (!resolveInspectorsFilter) return prev;
  if (typeof resolveInspectorsFilter == "function") return resolveInspectorsFilter(prev, context);
  if (Array.isArray(resolveInspectorsFilter)) return [...prev, ...resolveInspectorsFilter];
  throw new Error(`Expected \`document.inspectors\` to be an array or a function, but received ${getPrintableType(resolveInspectorsFilter)}`);
}, documentCommentsEnabledReducer = (opts) => {
  const {
    config,
    context,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.document?.comments?.enabled ?? innerConfig.document?.unstable_comments?.enabled;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "function") return resolver(context);
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`document.comments.enabled\` to be a boolean or a function, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, onUncaughtErrorResolver = (opts) => {
  const {
    config,
    context
  } = opts;
  flattenConfig(config, []).forEach(({
    config: pluginConfig
  }) => {
    const resolver = pluginConfig.onUncaughtError;
    if (typeof resolver == "function") return resolver(context.error, context.errorInfo);
    if (resolver)
      throw new Error(`Expected \`document.onUncaughtError\` to be a a function, but received ${getPrintableType(resolver)}`);
  });
}, internalTasksReducer = (opts) => {
  const {
    config
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.__internal_tasks;
    if (!resolver) return acc;
    if (typeof resolver == "object" && resolver.footerAction) return resolver;
    throw new Error(`Expected \`__internal__tasks\` to be an object with footerAction, but received ${getPrintableType(resolver)}`);
  }, void 0);
}, eventsAPIReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    if (innerConfig.beta?.eventsAPI?.enabled)
      throw new Error(`The \`beta.eventsAPI.enabled\` option has been removed. Use \`beta.eventsAPI.${opts.key}\` instead.`);
    const enabled = innerConfig.beta?.eventsAPI?.[opts.key];
    if (typeof enabled > "u") return acc;
    if (typeof enabled == "boolean") return enabled;
    throw new Error(`Expected \`beta.eventsAPI.${opts.key}\` to be a boolean, but received ${getPrintableType(enabled)}`);
  }, initialValue);
}, mediaLibraryEnabledReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.mediaLibrary?.enabled;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`mediaLibrary.enabled\` to be a boolean, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, mediaLibraryLibraryIdReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.mediaLibrary?.libraryId;
    if (!resolver && typeof resolver != "string") return acc;
    if (typeof resolver == "string") return resolver;
    throw new Error(`Expected \`mediaLibrary.libraryId\` to be a string, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, serverDocumentActionsReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const enabled = innerConfig.__internal_serverDocumentActions?.enabled;
    if (typeof enabled > "u") return acc;
    if (typeof enabled == "boolean") return enabled;
    throw new Error(`Expected \`__internal_serverDocumentActions\` to be a boolean, but received ${getPrintableType(enabled)}`);
  }, initialValue);
}, partialIndexingEnabledReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.search?.unstable_partialIndexing?.enabled;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`search.unstable_partialIndexing.enabled\` to be a boolean, but received ${getPrintableType(resolver)}`);
  }, initialValue);
}, legacySearchEnabledReducer = (prev, {
  search: search2
}) => typeof search2?.enableLegacySearch < "u" ? search2.enableLegacySearch : prev, searchStrategyReducer = ({
  config,
  initialValue
}) => {
  const flattenedConfig = flattenConfig(config, []), [implicit, explicit] = flattenedConfig.reduce(([currentImplicit, currentExplicit], entry) => {
    const {
      enableLegacySearch,
      strategy
    } = entry.config.search ?? {};
    if (typeof strategy < "u") {
      if (!isSearchStrategy(strategy)) {
        const options = new Intl.ListFormat("en-US", {
          type: "disjunction"
        }).format(searchStrategies$1.map((value) => `"${value}"`)), received = typeof strategy == "string" ? `"${strategy}"` : getPrintableType(strategy);
        throw new Error(`Expected \`search.strategy\` to be ${options}, but received ${received}`);
      }
      return [currentImplicit, strategy];
    }
    return typeof enableLegacySearch == "boolean" ? [enableLegacySearch ? "groqLegacy" : "groq2024", currentExplicit] : [currentImplicit, currentExplicit];
  }, [void 0, void 0]);
  return explicit ?? implicit ?? initialValue;
}, announcementsEnabledReducer = (opts) => {
  const {
    config,
    initialValue
  } = opts;
  return flattenConfig(config, []).reduce((acc, {
    config: innerConfig
  }) => {
    const resolver = innerConfig.announcements?.enabled;
    if (!resolver && typeof resolver != "boolean") return acc;
    if (typeof resolver == "boolean") return resolver;
    throw new Error(`Expected \`announcements.enabled\` to be a boolean, but received ${getPrintableType(resolver)}`);
  }, initialValue);
};
function resolveConfigProperty({
  config: inputConfig,
  context,
  initialValue,
  propertyName,
  ...reducers
}) {
  const configs = flattenConfig(inputConfig, []);
  if ("reducer" in reducers)
    return configs.reduce((acc, {
      config,
      path
    }) => {
      try {
        return reducers.reducer(acc, config, context);
      } catch (e) {
        throw new ConfigPropertyError({
          propertyName,
          path,
          cause: e
        });
      }
    }, initialValue);
  const reducer2 = reducers.asyncReducer;
  return (async () => {
    let current = initialValue;
    for (const {
      config,
      path
    } of configs)
      try {
        current = await reducer2(current, config, context);
      } catch (e) {
        throw new ConfigPropertyError({
          propertyName,
          path,
          cause: e
        });
      }
    return current;
  })();
}
function createSanityI18nBackend(options) {
  const {
    bundles
  } = options;
  function init2() {
  }
  function read(locale, namespace, callback) {
    const loadable = bundles.filter((bundle) => bundle.locale === locale && bundle.namespace === namespace);
    if (loadable.length === 0) {
      callback(
        `No translations found for namespace "${namespace}", language "${locale}"`,
        void 0
        // Returning undefined here will i18next _not_ retry
      );
      return;
    }
    loadBundles(loadable).then((resources) => callback(null, resources)).catch((err) => callback(err, !0));
  }
  return {
    type: "backend",
    init: init2,
    read
  };
}
async function loadBundles(bundles) {
  const resolved = await Promise.all(bundles.map(async (bundle) => ({
    ...bundle,
    resources: await loadBundleResources(bundle)
  }))), base = {};
  for (const item of resolved) {
    const deep = item.deep ?? !0, overwrite = item.overwrite ?? !0;
    deep ? deepExtend(base, item.resources, overwrite) : overwrite ? Object.assign(base, item.resources) : Object.assign({}, item.resources, base);
  }
  return base;
}
async function loadBundleResources(bundle) {
  if (typeof bundle.resources != "function")
    return bundle.resources;
  const resources = await bundle.resources();
  return maybeUnwrapModule(resources);
}
function deepExtend(target, source, overwrite = !1) {
  for (const prop in source) {
    if (prop === "__proto__" || prop === "constructor")
      continue;
    if (!(prop in target)) {
      target[prop] = source[prop];
      continue;
    }
    const targetLeaf = target[prop], sourceLeaf = source[prop], targetIsString = isStringLeaf(targetLeaf), sourceIsString = isStringLeaf(sourceLeaf);
    if ((targetIsString || sourceIsString) && overwrite) {
      target[prop] = source[prop];
      continue;
    }
    if (targetIsString || sourceIsString)
      continue;
    const sourceIsArray = Array.isArray(sourceLeaf), targetIsArray = Array.isArray(targetLeaf);
    if (sourceIsArray || targetIsArray) {
      overwrite && (target[prop] = sourceLeaf);
      continue;
    }
    deepExtend(targetLeaf, sourceLeaf, overwrite);
  }
  return target;
}
function isStringLeaf(target) {
  return typeof target == "string" || target instanceof String;
}
function maybeUnwrapModule(maybeModule) {
  return isWrappedModule(maybeModule) ? maybeModule.default : maybeModule;
}
function isWrappedModule(mod) {
  return "default" in mod && typeof mod.default == "object" && isPlainObject$1(mod.default);
}
function prepareI18n(source) {
  const {
    projectId,
    dataset,
    name: sourceName2
  } = source, context = {
    projectId,
    dataset
  }, locales = resolveConfigProperty({
    config: source,
    context,
    propertyName: "i18n.locales",
    reducer: localeDefReducer,
    initialValue: [defaultLocale]
  }), bundles = resolveConfigProperty({
    config: source,
    context,
    propertyName: "i18n.bundles",
    reducer: localeBundlesReducer,
    initialValue: normalizeResourceBundles(locales)
  });
  return createI18nApi({
    locales,
    bundles,
    projectId,
    sourceName: sourceName2
  });
}
function createI18nApi({
  locales,
  bundles,
  projectId,
  sourceName: sourceName2
}) {
  const namespaceNames = new Set(bundles.map((bundle) => bundle.namespace)), options = getI18NextOptions(projectId, sourceName2, locales, namespaceNames), i18nInstance = createInstance().use(createSanityI18nBackend({
    bundles
  })).use(initReactI18next);
  i18nInstance.init(options).catch((err) => {
    console.error("Failed to initialize i18n backend: %s", err);
  });
  const reducedLocales = locales.map(reduceLocaleDefinition);
  return {
    /** @public */
    source: {
      get currentLocale() {
        return reducedLocales.find((locale) => locale.id === i18nInstance.language) ?? defaultLocale;
      },
      loadNamespaces(namespaces) {
        const missing = namespaces.filter((ns) => !i18nInstance.hasLoadedNamespace(ns));
        return missing.length === 0 ? Promise.resolve() : i18nInstance.loadNamespaces(missing);
      },
      locales: reducedLocales,
      t: maybeWrapT(i18nInstance.t)
    },
    /** @internal */
    i18next: i18nInstance
  };
}
function normalizeResourceBundles(locales) {
  const normalized = [];
  for (const lang of locales) {
    if (lang.bundles && !Array.isArray(lang.bundles))
      throw new Error(`Resource bundle for locale ${lang.id} is not an array`);
    if (lang.bundles)
      for (const bundle of lang.bundles) {
        if ("locale" in bundle && bundle.locale !== lang.id)
          throw new Error(`Resource bundle inside locale ${lang.id} has mismatching locale id`);
        if (!bundle.namespace)
          throw new Error(`Resource bundle for locale ${lang.id} is missing namespace`);
        normalized.push("locale" in bundle ? bundle : {
          ...bundle,
          locale: lang.id
        });
      }
  }
  return normalized;
}
const defaultOptions = {
  /**
   * Even though we're only defining the studio namespace, i18next will still load requested
   * namespaces through the backend. The reason why we're defining the namespace at all is to
   * prevent i18next from (trying) to load the i18next default `translation` namespace.
   */
  ns: [studioLocaleNamespace],
  defaultNS: studioLocaleNamespace,
  partialBundledLanguages: !0,
  // Fall back to English (US) locale
  fallbackLng: defaultLocale.id,
  // This will be overriden with the users detected/preferred locale before initing,
  // but to satisfy the init options and prevent mistakes, we include a default here.
  lng: defaultLocale.id,
  // In rare cases we'll want to be able to debug i18next - there is a `debug` option
  // in the studio i18n configuration for that, which will override this value.
  debug: DEBUG_I18N,
  // When specifying language 'en-US', do not load 'en-US', 'en', 'dev' - only `en-US`.
  load: "currentOnly",
  // We always use our "backend" for loading translations, allowing us to handle i18n resources
  // in a single place with a single approach. This means we shouldn't need to wait for the init,
  // as any missing translations will be loaded async (through react suspense).
  initImmediate: !0,
  // Because we use i18next-react, we do not need to escale values
  interpolation: {
    escapeValue: !1
  },
  // Theoretically, if the framework somehow gets new translations added, re-render.
  // Note that this shouldn't actually happen, as we only use the Sanity backend
  react: {
    bindI18nStore: "added"
  }
};
function getI18NextOptions(projectId, sourceName2, locales, namespaces) {
  const preferredLocaleId = getPreferredLocale(projectId, sourceName2), preferredLocale = locales.find((l) => l.id === preferredLocaleId), lastLocale = locales[locales.length - 1], locale = preferredLocale?.id ?? lastLocale.id ?? defaultOptions.lng;
  return {
    ...defaultOptions,
    ns: Array.from(namespaces),
    // For now, let us load all namespaces. We can optimize later.
    lng: locale,
    supportedLngs: locales.map((def) => def.id)
  };
}
function reduceLocaleDefinition(definition) {
  const {
    bundles,
    ...locale
  } = definition;
  return locale;
}
const filterDefinitions = [
  // 'Pinned' filters
  {
    fieldPath: "_updatedAt",
    icon: CalendarIcon,
    operators: [{
      name: "dateTimeLast",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeRange",
      type: "item"
    }, {
      name: "dateTimeAfter",
      type: "item"
    }, {
      name: "dateTimeBefore",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeEqual",
      type: "item"
    }, {
      name: "dateTimeNotEqual",
      type: "item"
    }],
    title: "Edited at",
    name: "updatedAt",
    type: "pinned"
  },
  {
    fieldPath: "_createdAt",
    icon: CalendarIcon,
    operators: [{
      name: "dateTimeLast",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeRange",
      type: "item"
    }, {
      name: "dateTimeAfter",
      type: "item"
    }, {
      name: "dateTimeBefore",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeEqual",
      type: "item"
    }, {
      name: "dateTimeNotEqual",
      type: "item"
    }],
    title: "Created at",
    name: "createdAt",
    type: "pinned"
  },
  {
    icon: LinkIcon,
    operators: [{
      name: "referencesDocument",
      type: "item"
    }, {
      name: "referencesAssetImage",
      type: "item"
    }, {
      name: "referencesAssetFile",
      type: "item"
    }],
    title: "Contains document, image or file",
    name: "references",
    type: "pinned"
  },
  // 'Field' filters
  {
    fieldType: "array",
    icon: UlistIcon,
    name: "array",
    operators: [{
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountEqual",
      type: "item"
    }, {
      name: "arrayCountNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountGt",
      type: "item"
    }, {
      name: "arrayCountGte",
      type: "item"
    }, {
      name: "arrayCountLt",
      type: "item"
    }, {
      name: "arrayCountLte",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountRange",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "array",
    icon: UlistIcon,
    name: "arrayList",
    operators: [{
      name: "arrayListIncludes",
      type: "item"
    }, {
      name: "arrayListNotIncludes",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountEqual",
      type: "item"
    }, {
      name: "arrayCountNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountGt",
      type: "item"
    }, {
      name: "arrayCountGte",
      type: "item"
    }, {
      name: "arrayCountLt",
      type: "item"
    }, {
      name: "arrayCountLte",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountRange",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "array",
    icon: UlistIcon,
    name: "arrayReferences",
    operators: [{
      name: "arrayReferenceIncludes",
      type: "item"
    }, {
      name: "arrayReferenceNotIncludes",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountEqual",
      type: "item"
    }, {
      name: "arrayCountNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountGt",
      type: "item"
    }, {
      name: "arrayCountGte",
      type: "item"
    }, {
      name: "arrayCountLt",
      type: "item"
    }, {
      name: "arrayCountLte",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "arrayCountRange",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "boolean",
    icon: CheckmarkCircleIcon,
    name: "boolean",
    operators: [{
      name: "booleanEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "date",
    icon: CalendarIcon,
    name: "date",
    operators: [{
      name: "dateLast",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateRange",
      type: "item"
    }, {
      name: "dateAfter",
      type: "item"
    }, {
      name: "dateBefore",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateEqual",
      type: "item"
    }, {
      name: "dateNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "datetime",
    icon: CalendarIcon,
    name: "datetime",
    operators: [{
      name: "dateTimeLast",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeRange",
      type: "item"
    }, {
      name: "dateTimeAfter",
      type: "item"
    }, {
      name: "dateTimeBefore",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "dateTimeEqual",
      type: "item"
    }, {
      name: "dateTimeNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "email",
    icon: StringIcon,
    name: "email",
    operators: [{
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringEqual",
      type: "item"
    }, {
      name: "stringNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "file",
    icon: DocumentIcon,
    name: "file",
    operators: [{
      name: "assetFileEqual",
      type: "item"
    }, {
      name: "assetFileNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "image",
    icon: ImageIcon,
    name: "image",
    operators: [{
      name: "assetImageEqual",
      type: "item"
    }, {
      name: "assetImageNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "number",
    icon: NumberIcon,
    name: "number",
    operators: [{
      name: "numberEqual",
      type: "item"
    }, {
      name: "numberNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "numberGt",
      type: "item"
    }, {
      name: "numberGte",
      type: "item"
    }, {
      name: "numberLt",
      type: "item"
    }, {
      name: "numberLte",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "numberRange",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "array",
    icon: BlockContentIcon,
    name: "portableText",
    operators: [{
      name: "portableTextMatches",
      type: "item"
    }, {
      name: "portableTextNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "portableTextEqual",
      type: "item"
    }, {
      name: "portableTextNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "reference",
    icon: LinkIcon,
    name: "reference",
    operators: [{
      name: "referenceEqual",
      type: "item"
    }, {
      name: "referenceNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "slug",
    icon: StringIcon,
    name: "slug",
    operators: [{
      name: "slugMatches",
      type: "item"
    }, {
      name: "slugNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "slugEqual",
      type: "item"
    }, {
      name: "slugNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "string",
    icon: StringIcon,
    name: "string",
    operators: [{
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringEqual",
      type: "item"
    }, {
      name: "stringNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "string",
    icon: ChevronDownIcon,
    name: "stringList",
    operators: [{
      name: "stringListEqual",
      type: "item"
    }, {
      name: "stringListNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "text",
    icon: StringIcon,
    name: "text",
    operators: [{
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringEqual",
      type: "item"
    }, {
      name: "stringNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  },
  {
    fieldType: "url",
    icon: StringIcon,
    name: "url",
    operators: [{
      name: "stringMatches",
      type: "item"
    }, {
      name: "stringNotMatches",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "stringEqual",
      type: "item"
    }, {
      name: "stringNotEqual",
      type: "item"
    }, {
      type: "divider"
    }, {
      name: "defined",
      type: "item"
    }, {
      name: "notDefined",
      type: "item"
    }],
    type: "field"
  }
];
function useUnitFormatter(t0) {
  const $ = c(7);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, currentLocale = useCurrentLocale().id;
  let t2;
  $[2] !== options ? (t2 = {
    unitDisplay: "long",
    ...options,
    style: "unit"
  }, $[2] = options, $[3] = t2) : t2 = $[3];
  const defaultOptions2 = t2;
  let t3;
  return $[4] !== currentLocale || $[5] !== defaultOptions2 ? (t3 = function(value, unit) {
    return intlCache.numberFormat(currentLocale, {
      ...defaultOptions2,
      unit
    }).format(value);
  }, $[4] = currentLocale, $[5] = defaultOptions2, $[6] = t3) : t3 = $[6], t3;
}
function ReferencePreviewTitle(t0) {
  const $ = c(12), {
    documentId,
    schemaType
  } = t0, documentPreviewStore = useDocumentPreviewStore();
  let t1, t2;
  $[0] !== documentId || $[1] !== documentPreviewStore || $[2] !== schemaType ? (t2 = getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId), $[0] = documentId, $[1] = documentPreviewStore, $[2] = schemaType, $[3] = t2) : t2 = $[3], t1 = t2;
  const observable = t1;
  let t3;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    isLoading: !0,
    snapshot: null,
    original: null
  }, $[4] = t3) : t3 = $[4];
  const {
    snapshot: snapshot2,
    original,
    isLoading
  } = useObservable(observable, t3);
  if (isLoading) {
    let t42;
    return $[5] === Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(Skeleton, { animated: !0, marginLeft: 1, radius: 2, style: {
      width: "10ch",
      height: "1em"
    } }), $[5] = t42) : t42 = $[5], t42;
  }
  let t4;
  $[6] !== documentId || $[7] !== original?.title || $[8] !== snapshot2?.title ? (t4 = snapshot2?.title || original?.title || documentId.slice(0, 8), $[6] = documentId, $[7] = original?.title, $[8] = snapshot2?.title, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(Fragment, { children: t4 }), $[10] = t4, $[11] = t5) : t5 = $[11], t5;
}
function SearchButtonValueDate(t0) {
  const $ = c(8), {
    value
  } = t0, t1 = value.includeTime ? "short" : void 0;
  let t2;
  $[0] !== t1 ? (t2 = {
    dateStyle: "medium",
    timeStyle: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const dateFormat = useDateTimeFormat(t2);
  let t3, t4;
  if ($[2] !== dateFormat || $[3] !== value.date) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const date = value?.date ? new Date(value.date) : null;
      if (!date || !isValid(date)) {
        t4 = null;
        break bb0;
      }
      t3 = dateFormat.format(date);
    }
    $[2] = dateFormat, $[3] = value.date, $[4] = t3, $[5] = t4;
  } else
    t3 = $[4], t4 = $[5];
  if (t4 !== Symbol.for("react.early_return_sentinel"))
    return t4;
  let t5;
  return $[6] !== t3 ? (t5 = /* @__PURE__ */ jsx(Fragment, { children: t3 }), $[6] = t3, $[7] = t5) : t5 = $[7], t5;
}
function SearchButtonValueDateLast(t0) {
  const $ = c(6), {
    value
  } = t0, formatUnit = useUnitFormatter(), t1 = Math.floor(value?.unitValue ?? 0);
  let t2;
  $[0] !== formatUnit || $[1] !== t1 || $[2] !== value.unit ? (t2 = formatUnit(t1, value.unit), $[0] = formatUnit, $[1] = t1, $[2] = value.unit, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(Fragment, { children: t2 }), $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}
function SearchButtonValueDateRange(t0) {
  const $ = c(4), {
    value
  } = t0, t1 = value.includeTime ? "short" : void 0;
  let t2;
  $[0] !== t1 ? (t2 = {
    dateStyle: "medium",
    timeStyle: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const dateFormat = useDateTimeFormat(t2), startDate = value?.from ? new Date(value.from) : null, endDate = value?.to ? new Date(value.to) : null;
  if (!endDate || !startDate || !isValid(endDate) || !isValid(startDate))
    return null;
  const from2 = dateFormat.format(startDate), to = dateFormat.format(endDate), t3 = `${from2} \u2192 ${to}`;
  let t4;
  return $[2] !== t3 ? (t4 = /* @__PURE__ */ jsx(Fragment, { children: t3 }), $[2] = t3, $[3] = t4) : t4 = $[3], t4;
}
function SearchButtonValueReference(t0) {
  const $ = c(6), {
    value
  } = t0, schema2 = useSchema(), documentId = value._ref;
  let t1;
  $[0] !== schema2 || $[1] !== value._type ? (t1 = schema2.get(value._type), $[0] = schema2, $[1] = value._type, $[2] = t1) : t1 = $[2];
  const schemaType = t1;
  if (!schemaType)
    return null;
  let t2;
  return $[3] !== documentId || $[4] !== schemaType ? (t2 = /* @__PURE__ */ jsx(ReferencePreviewTitle, { documentId, schemaType }), $[3] = documentId, $[4] = schemaType, $[5] = t2) : t2 = $[5], t2;
}
function SearchFilterNumberInput(t0) {
  const $ = c(9), {
    value,
    onChange
  } = t0, [uncontrolledValue, setUncontrolledValue] = useState(value ?? ""), {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange ? (t2 = (event) => {
    setUncontrolledValue(event.currentTarget.value);
    const numValue = parseFloat(event.currentTarget.value);
    onChange(Number.isFinite(numValue) ? numValue : null);
  }, $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2, t3 = fullscreen ? 2 : 1;
  let t4;
  $[2] !== t ? (t4 = t("search.filter-number-value-placeholder"), $[2] = t, $[3] = t4) : t4 = $[3];
  let t5;
  return $[4] !== handleChange || $[5] !== t3 || $[6] !== t4 || $[7] !== uncontrolledValue ? (t5 = /* @__PURE__ */ jsx(TextInput$1, { fontSize: t3, onChange: handleChange, placeholder: t4, radius: 2, step: "any", type: "number", value: uncontrolledValue }), $[4] = handleChange, $[5] = t3, $[6] = t4, $[7] = uncontrolledValue, $[8] = t5) : t5 = $[8], t5;
}
function SearchFilterNumberRangeInput(t0) {
  const $ = c(23), {
    onChange,
    value
  } = t0, [to, setTo] = useState(value?.to ?? ""), [from2, setFrom] = useState(value?.from ?? ""), {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange || $[1] !== value?.from ? (t2 = (event) => {
    setTo(event.currentTarget.value);
    const numValue = parseFloat(event.currentTarget.value);
    onChange({
      to: Number.isFinite(numValue) ? numValue : null,
      from: value?.from ?? null
    });
  }, $[0] = onChange, $[1] = value?.from, $[2] = t2) : t2 = $[2];
  const handleToChange = t2;
  let t3;
  $[3] !== onChange || $[4] !== value?.to ? (t3 = (event_0) => {
    setFrom(event_0.currentTarget.value);
    const numValue_0 = parseFloat(event_0.currentTarget.value);
    onChange({
      to: value?.to ?? null,
      from: Number.isFinite(numValue_0) ? numValue_0 : null
    });
  }, $[3] = onChange, $[4] = value?.to, $[5] = t3) : t3 = $[5];
  const handleFromChange = t3, t4 = fullscreen ? 2 : 1;
  let t5;
  $[6] !== t ? (t5 = t("search.filter-number-min-value-placeholder"), $[6] = t, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== from2 || $[9] !== handleFromChange || $[10] !== t4 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(TextInput$1, { fontSize: t4, onChange: handleFromChange, placeholder: t5, radius: 2, step: "any", type: "number", value: from2 }) }), $[8] = from2, $[9] = handleFromChange, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12];
  const t7 = fullscreen ? 2 : 1;
  let t8;
  $[13] !== t ? (t8 = t("search.filter-number-max-value-placeholder"), $[13] = t, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== handleToChange || $[16] !== t7 || $[17] !== t8 || $[18] !== to ? (t9 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(TextInput$1, { fontSize: t7, onChange: handleToChange, placeholder: t8, radius: 2, step: "any", type: "number", value: to }) }), $[15] = handleToChange, $[16] = t7, $[17] = t8, $[18] = to, $[19] = t9) : t9 = $[19];
  let t10;
  return $[20] !== t6 || $[21] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { gap: 2, children: [
    t6,
    t9
  ] }), $[20] = t6, $[21] = t9, $[22] = t10) : t10 = $[22], t10;
}
const NO_FILTER = () => !0, StyledText$2 = styled(Text$1)`
  word-break: break-word;
`, ReferenceAutocomplete = forwardRef(function({
  onSelect,
  types = [],
  value
}, ref) {
  const autocompletePopoverReferenceElementRef = useRef(null), schema2 = useSchema(), {
    state: {
      fullscreen
    }
  } = useSearchState(), {
    t
  } = useTranslation(), autocompleteId = useId(), [hits, setHits] = useState([]), {
    handleSearch,
    searchState
  } = useSearch({
    allowEmptyQueries: !0,
    initialState: {
      hits: [],
      loading: !1,
      error: null,
      terms: {
        query: "",
        types
      }
    },
    onComplete: (result) => {
      setHits(result.hits.map(({
        hit
      }) => ({
        value: hit._id,
        hit
      })));
    },
    schema: schema2
  }), handleAutocompleteOpenButtonClick = useCallback(() => {
    handleSearch({
      debounceTime: 0,
      options: {
        limit: 100
      },
      terms: {
        query: "",
        types
      }
    });
  }, [handleSearch, types]), handleQueryChange = useCallback((query) => {
    handleSearch(query ? {
      options: {
        limit: 100
      },
      terms: {
        query: query || "",
        types
      }
    } : {
      debounceTime: 0,
      options: {
        limit: 0
      },
      terms: {
        query: "",
        types
      }
    });
  }, [handleSearch, types]), handleSelect = useCallback((val) => {
    const hit_0 = hits.find((h) => h.value === val)?.hit;
    hit_0 && onSelect?.({
      _ref: getPublishedId(hit_0._id),
      _type: hit_0._type
    });
  }, [hits, onSelect]), placeholderText = useMemo(() => {
    if (types.length === 0)
      return t("search.action.search-all-types");
    const {
      remainingCount,
      types: visibleTypes
    } = getDocumentTypesTruncated({
      types
    }), key = remainingCount > 0 ? "search.action.search-specific-types-truncated" : "search.action.search-specific-types";
    return t(key, {
      count: remainingCount,
      types: visibleTypes,
      formatParams: {
        types: {
          style: "short",
          type: "unit"
        }
      }
    });
  }, [types, t]), renderOption = useCallback((option) => /* @__PURE__ */ jsx(SearchResultItem, { disableIntentLink: !0, documentId: option.value, documentType: option.hit._type, layout: "compact" }), []), renderPopover = useCallback((props2, contentRef) => {
    const {
      content,
      hidden,
      onMouseEnter,
      onMouseLeave
    } = props2, hasResults = hits && hits.length > 0;
    return /* @__PURE__ */ jsx(Popover, { constrainSize: !0, content: /* @__PURE__ */ jsx("div", { ref: contentRef, children: hasResults ? content : searchState.terms.query && /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(StyledText$2, { align: "center", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "new-document.no-results", values: {
      searchQuery: searchState.terms.query
    } }) }) }) }) }), fallbackPlacements: ["bottom", "bottom-end"], matchReferenceWidth: !0, onMouseEnter, onMouseLeave, open: !searchState.loading && !hidden, overflow: "auto", placement: "bottom-start", radius: POPOVER_RADIUS$1, referenceElement: autocompletePopoverReferenceElementRef.current });
  }, [hits, searchState.loading, searchState.terms.query, t]);
  return /* @__PURE__ */ jsx("div", { ref: autocompletePopoverReferenceElementRef, children: /* @__PURE__ */ jsx(Autocomplete, { "aria-label": placeholderText, filterOption: NO_FILTER, fontSize: fullscreen ? 2 : 1, id: autocompleteId, loading: searchState.loading, openButton: {
    onClick: handleAutocompleteOpenButtonClick
  }, options: hits, onQueryChange: handleQueryChange, onSelect: handleSelect, placeholder: placeholderText, radius: 2, ref, renderOption, renderPopover, value: value?._ref }) });
});
function SearchFilterReferenceInput(t0) {
  const $ = c(25), {
    fieldDefinition,
    onChange,
    value
  } = t0, {
    onClose,
    state: t1
  } = useSearchState(), {
    documentTypesNarrowed
  } = t1, schema2 = useSchema(), {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange ? (t2 = (referenceValue) => onChange(referenceValue), $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2;
  let t3;
  bb0: {
    if (!fieldDefinition) {
      let t43;
      $[2] === Symbol.for("react.memo_cache_sentinel") ? (t43 = [], $[2] = t43) : t43 = $[2], t3 = t43;
      break bb0;
    }
    let t42;
    if ($[3] !== documentTypesNarrowed || $[4] !== fieldDefinition.documentTypes || $[5] !== fieldDefinition.fieldPath || $[6] !== schema2) {
      let t52;
      $[8] !== documentTypesNarrowed ? (t52 = (d) => documentTypesNarrowed.includes(d), $[8] = documentTypesNarrowed, $[9] = t52) : t52 = $[9];
      let t62;
      $[10] !== fieldDefinition.fieldPath || $[11] !== schema2 ? (t62 = (type) => {
        const schemaType = schema2.get(type);
        if (schemaType) {
          const field = getSchemaField$3(schemaType, fieldDefinition.fieldPath);
          if (isArraySchemaType(field?.type))
            return field?.type.of.filter(isReferenceSchemaType).flatMap(_temp$Z);
          if (isReferenceSchemaType(field?.type))
            return field?.type.to;
        }
        return [];
      }, $[10] = fieldDefinition.fieldPath, $[11] = schema2, $[12] = t62) : t62 = $[12], t42 = fieldDefinition.documentTypes.filter(t52).flatMap(t62).reduce(_temp2$j, []), $[3] = documentTypesNarrowed, $[4] = fieldDefinition.documentTypes, $[5] = fieldDefinition.fieldPath, $[6] = schema2, $[7] = t42;
    } else
      t42 = $[7];
    t3 = t42;
  }
  const searchableTypes = t3;
  let t4;
  $[13] !== handleChange ? (t4 = () => handleChange(null), $[13] = handleChange, $[14] = t4) : t4 = $[14];
  const handleClear = t4;
  let t5;
  $[15] !== onClose ? (t5 = () => {
    onClose?.();
  }, $[15] = onClose, $[16] = t5) : t5 = $[16];
  const handleClick = t5;
  let t6;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    width: "min(calc(100vw - 40px), 420px)"
  }, $[17] = t6) : t6 = $[17];
  let t7;
  return $[18] !== handleChange || $[19] !== handleClear || $[20] !== handleClick || $[21] !== searchableTypes || $[22] !== t || $[23] !== value ? (t7 = /* @__PURE__ */ jsx(Box, { style: t6, children: value?._ref && value?._type ? /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    /* @__PURE__ */ jsx(Card, { padding: 1, radius: 1, shadow: 1, children: /* @__PURE__ */ jsx(SearchResultItem, { documentId: value._ref, documentType: value._type, layout: "compact", onClick: handleClick }) }),
    /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleClear, text: t("search.filter-reference-clear"), tone: "critical" })
  ] }) : /* @__PURE__ */ jsx(ReferenceAutocomplete, { onSelect: handleChange, types: searchableTypes, value }) }), $[18] = handleChange, $[19] = handleClear, $[20] = handleClick, $[21] = searchableTypes, $[22] = t, $[23] = value, $[24] = t7) : t7 = $[24], t7;
}
function _temp2$j(acc, val) {
  return acc.findIndex((v) => v.name === val?.name) < 0 && acc.push(val), acc;
}
function _temp$Z(i) {
  return i.to;
}
function CustomMenuItem(t0) {
  const $ = c(7), {
    onClick: onClick2,
    selected,
    title,
    value
  } = t0;
  let t1;
  $[0] !== onClick2 || $[1] !== value ? (t1 = () => onClick2(value), $[0] = onClick2, $[1] = value, $[2] = t1) : t1 = $[2];
  const handleClick = t1;
  let menuItemText = `${title}`;
  typeof value < "u" && title !== value && (menuItemText = menuItemText + ` (${value})`);
  let t2;
  return $[3] !== handleClick || $[4] !== menuItemText || $[5] !== selected ? (t2 = /* @__PURE__ */ jsx(MenuItem$1, { onClick: handleClick, pressed: selected, tone: "default", text: menuItemText }), $[3] = handleClick, $[4] = menuItemText, $[5] = selected, $[6] = t2) : t2 = $[6], t2;
}
function SearchFilterStringListInput({
  fieldDefinition,
  onChange,
  value
}) {
  const menuButtonId = useId(), {
    state: {
      documentTypesNarrowed
    }
  } = useSearchState(), {
    t
  } = useTranslation(), schema2 = useSchema(), items = useMemo(() => fieldDefinition ? fieldDefinition.documentTypes.filter((d) => documentTypesNarrowed.includes(d)).map((type) => {
    const schemaType = schema2.get(type);
    return schemaType ? getSchemaField$3(schemaType, fieldDefinition.fieldPath)?.type.options : null;
  }).filter(isNonNullable$3).map((o) => o.list).flatMap((list) => list?.map((l) => toSelectItem(l))).filter(isNonNullable$3).reduce((acc, val) => {
    const prevIndex = acc.findIndex((v) => v.value === val?.value);
    if (prevIndex > -1) {
      const prevValue = acc[prevIndex];
      acc[prevIndex] = {
        ...acc[prevIndex],
        title: uniq([...prevValue.title, val.title]).sort()
      };
    } else
      acc.push({
        ...val,
        title: [val.title]
      });
    return acc;
  }, []) : [], [documentTypesNarrowed, fieldDefinition, schema2]), handleClick = useCallback((v_0) => {
    onChange(v_0);
  }, [onChange]);
  return /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(Button, { mode: "ghost", iconRight: ChevronDownIcon, text: value ? String(value) : t("search.filter-string-value-select-predefined-value") }), id: menuButtonId || "", menu: /* @__PURE__ */ jsx(Menu, { children: items.map((item, index) => /* @__PURE__ */ jsx(
    CustomMenuItem,
    {
      onClick: handleClick,
      selected: item.value === value,
      title: item.title.join(", "),
      value: item.value || ""
    },
    index
  )) }), popover: {
    constrainSize: !0,
    placement: "bottom-start",
    portal: !1,
    radius: 2
  } });
}
function toSelectItem(option) {
  return isTitledListValue(option) ? option : {
    title: capitalize(`${option}`),
    value: option
  };
}
const GteIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M7.04 19V17.512H17.36V19H7.04ZM7.04 15.328V13.624L12.08 11.872L15.32 10.816V10.72L12.08 9.664L7.04 7.912V6.208L17.36 9.88V11.656L7.04 15.328Z", fill: "currentColor" }) }), $[0] = t0) : t0 = $[0], t0;
}, GtIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M7.568 18.848V16.952L14.792 12.08V11.984L7.568 7.112V5.216L16.52 11.288V12.776L7.568 18.848Z", fill: "currentColor" }) }), $[0] = t0) : t0 = $[0], t0;
}, LteIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M7.04 19V17.512H17.36V19H7.04ZM17.36 15.328L7.04 11.656V9.88L17.36 6.208V7.912L12.32 9.664L9.08 10.72V10.816L12.32 11.872L17.36 13.624V15.328Z", fill: "currentColor" }) }), $[0] = t0) : t0 = $[0], t0;
}, LtIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M16.952 19.632L8 13.56V12.072L16.952 6V7.896L9.728 12.768V12.864L16.952 17.736V19.632Z", fill: "currentColor" }) }), $[0] = t0) : t0 = $[0], t0;
};
function defineSearchOperator(definition) {
  return definition;
}
function toJSON(val) {
  return JSON.stringify(val);
}
const arrayOperators = {
  arrayCountEqual: {
    nameKey: "search.operator.array-count-equal.name",
    descriptionKey: "search.operator.array-count-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountEqual"
  },
  arrayCountGt: {
    nameKey: "search.operator.array-count-gt.name",
    descriptionKey: "search.operator.array-count-gt.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) > ${toJSON(value)}` : null,
    icon: GtIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountGt"
  },
  arrayCountGte: {
    nameKey: "search.operator.array-count-gte.name",
    descriptionKey: "search.operator.array-count-gte.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) >= ${toJSON(value)}` : null,
    icon: GteIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountGte"
  },
  arrayCountLt: {
    nameKey: "search.operator.array-count-lt.name",
    descriptionKey: "search.operator.array-count-lt.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) < ${toJSON(value)}` : null,
    icon: LtIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountLt"
  },
  arrayCountLte: {
    nameKey: "search.operator.array-count-lte.name",
    descriptionKey: "search.operator.array-count-lte.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) <= ${toJSON(value)}` : null,
    icon: LteIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountLte"
  },
  arrayCountNotEqual: {
    nameKey: "search.operator.array-count-not-equal.name",
    descriptionKey: "search.operator.array-count-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `count(${fieldPath}) != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "arrayCountNotEqual"
  },
  arrayCountRange: {
    nameKey: "search.operator.array-count-range.name",
    descriptionKey: "search.operator.array-count-range.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value?.to) && Number.isFinite(value?.from) && fieldPath ? `count(${fieldPath}) > ${toJSON(value?.from)} && count(${fieldPath}) < ${toJSON(value?.to)}` : "",
    initialValue: null,
    inputComponent: SearchFilterNumberRangeInput,
    type: "arrayCountRange"
  },
  arrayListIncludes: {
    nameKey: "search.operator.array-list-includes.name",
    descriptionKey: "search.operator.array-list-includes.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${toJSON(value)} in ${fieldPath}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringListInput,
    type: "arrayListIncludes"
  },
  arrayListNotIncludes: {
    nameKey: "search.operator.array-list-not-includes.name",
    descriptionKey: "search.operator.array-list-not-includes.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `!(${toJSON(value)} in ${fieldPath})` : null,
    initialValue: null,
    inputComponent: SearchFilterStringListInput,
    type: "arrayListNotIncludes"
  },
  arrayReferenceIncludes: {
    nameKey: "search.operator.array-reference-includes.name",
    descriptionKey: "search.operator.array-reference-includes.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${toJSON(value._ref)} in ${fieldPath}[]._ref` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "arrayReferenceIncludes"
  },
  arrayReferenceNotIncludes: {
    nameKey: "search.operator.array-reference-not-includes.name",
    descriptionKey: "search.operator.array-reference-not-includes.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `!(${toJSON(value._ref)} in ${fieldPath}[]._ref)` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "arrayReferenceNotIncludes"
  }
};
function AssetSourceError(props2) {
  const $ = c(20), {
    t
  } = useTranslation();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(TextWithTone, { tone: "caution", children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== t ? (t1 = t("search.error.no-valid-asset-source-title"), $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", weight: "medium", children: t1 }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("search.error.no-valid-asset-source-only-default-description"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t ? (t5 = t("search.error.no-valid-asset-source-check-config-description"), $[9] = t, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "caution", children: t5 }), $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t2 || $[14] !== t4 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      t2,
      t4,
      t6
    ] })
  ] }), $[13] = t2, $[14] = t4, $[15] = t6, $[16] = t7) : t7 = $[16];
  let t8;
  return $[17] !== props2 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { ...props2, children: t7 }), $[17] = props2, $[18] = t7, $[19] = t8) : t8 = $[19], t8;
}
function FileReferencePreview(t0) {
  const $ = c(6), {
    reference
  } = t0, documentPreviewStore = useDocumentPreviewStore();
  let t1;
  $[0] !== documentPreviewStore ? (t1 = (id2) => observeFileAsset(documentPreviewStore, id2), $[0] = documentPreviewStore, $[1] = t1) : t1 = $[1];
  const observeAsset = t1;
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(FileSkeleton, {}), $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== observeAsset || $[4] !== reference ? (t3 = /* @__PURE__ */ jsx(WithReferencedAsset, { observeAsset, reference, waitPlaceholder: t2, children: _temp$Y }), $[3] = observeAsset, $[4] = reference, $[5] = t3) : t3 = $[5], t3;
}
function _temp$Y(asset) {
  return /* @__PURE__ */ jsx(FilePreview, { asset });
}
function FilePreview(t0) {
  const $ = c(10), {
    asset
  } = t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Card, { padding: 3, radius: 1, shadow: 1, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(BinaryDocumentIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  const t2 = asset?.originalFilename || asset._id;
  let t3;
  $[1] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", weight: "medium", children: t2 }), $[1] = t2, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== asset.size ? (t4 = formatBytes(asset.size), $[3] = asset.size, $[4] = t4) : t4 = $[4];
  let t5;
  $[5] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t4 }), $[5] = t4, $[6] = t5) : t5 = $[6];
  let t6;
  return $[7] !== t3 || $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { padding: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", wrap: "nowrap", children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, marginLeft: 3, children: [
      t3,
      t5
    ] })
  ] }) }), $[7] = t3, $[8] = t5, $[9] = t6) : t6 = $[9], t6;
}
function FileSkeleton() {
  const $ = c(3);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Card, { padding: 3, radius: 1, shadow: 1, tone: "transparent", children: /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(BinaryDocumentIcon, {}) }) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(TextSkeleton, { animated: !0, style: {
    width: "100%"
  }, radius: 1 }), $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Card, { padding: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "flex-start", children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, marginLeft: 3, children: [
      t1,
      /* @__PURE__ */ jsx(TextSkeleton, { animated: !0, style: {
        width: "100%"
      }, radius: 1 })
    ] })
  ] }) }), $[2] = t2) : t2 = $[2], t2;
}
const Container = styled(Card)`
  position: relative;
  padding-bottom: 100%;
`, Image$4 = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
`;
function ImageReferencePreview(t0) {
  const $ = c(5), {
    reference
  } = t0, documentPreviewStore = useDocumentPreviewStore();
  let t1;
  $[0] !== documentPreviewStore ? (t1 = (id2) => observeImageAsset(documentPreviewStore, id2), $[0] = documentPreviewStore, $[1] = t1) : t1 = $[1];
  const observeAsset = t1;
  let t2;
  return $[2] !== observeAsset || $[3] !== reference ? (t2 = /* @__PURE__ */ jsx(WithReferencedAsset, { observeAsset, reference, children: _temp$X }), $[2] = observeAsset, $[3] = reference, $[4] = t2) : t2 = $[4], t2;
}
function _temp$X(asset) {
  return /* @__PURE__ */ jsx(ImagePreview, { asset });
}
function ImagePreview(t0) {
  const $ = c(8), {
    asset
  } = t0, [loaded, setLoaded] = useState(!1), imageUrl = `${asset.url}?h=800&fit=max`;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setLoaded(!0), $[0] = t1) : t1 = $[0];
  const handleLoad = t1;
  let t2;
  $[1] !== loaded ? (t2 = !loaded && /* @__PURE__ */ jsx(LoadingBlock, { fill: !0, showText: !0 }), $[1] = loaded, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== imageUrl ? (t3 = /* @__PURE__ */ jsx(Image$4, { onLoad: handleLoad, src: imageUrl }), $[3] = imageUrl, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Container, { __unstable_checkered: !0, border: !0, children: [
    t2,
    t3
  ] }), $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
}
function AssetPreview(t0) {
  const $ = c(4), {
    reference
  } = t0;
  if (!reference)
    return null;
  if (reference._type.startsWith("sanity.fileAsset")) {
    let t1;
    return $[0] !== reference ? (t1 = /* @__PURE__ */ jsx(FileReferencePreview, { reference }), $[0] = reference, $[1] = t1) : t1 = $[1], t1;
  }
  if (reference._type.startsWith("sanity.imageAsset")) {
    let t1;
    return $[2] !== reference ? (t1 = /* @__PURE__ */ jsx(ImageReferencePreview, { reference }), $[2] = reference, $[3] = t1) : t1 = $[3], t1;
  }
  return null;
}
const ASSET_TYPE = {
  file: "sanity.fileAsset",
  image: "sanity.imageAsset"
}, ContainerBox = styled(Box)`
  width: min(calc(100vw - 40px), 320px);
`;
function SearchFilterAssetInput(type) {
  return function({
    onChange,
    value
  }) {
    const [selectedAssetSource, setSelectedAssetSource] = useState(null), [selectedAssetFromSource, setSelectedAssetFromSource] = useState(null);
    useSearchState();
    const {
      file,
      image
    } = useSource().form, {
      t
    } = useTranslation(), assetSources = useMemo(() => {
      switch (type) {
        case "file":
          return file.assetSources.filter((a) => a.name === sourceName);
        case "image":
          return image.assetSources.filter((a) => a.name === sourceName);
        default:
          throw Error("Unknown asset source found");
      }
    }, [file.assetSources, image.assetSources]), menuButtonId = useId(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), handleClear = useCallback(() => {
      setSelectedAssetFromSource(null), onChange(null);
    }, [onChange]), handleCloseAssetSource = useCallback(() => {
      setSelectedAssetSource(null);
    }, []), handleSelectAssetFromSource2 = useCallback((assetFromSource) => {
      const firstAsset = assetFromSource[0];
      setSelectedAssetFromSource(firstAsset), handleCloseAssetSource();
    }, [handleCloseAssetSource]), handleSelectAssetSource = useCallback((source) => setSelectedAssetSource(source), []);
    useEffect(() => {
      selectedAssetFromSource?.kind === "assetDocumentId" && typeof selectedAssetFromSource?.value == "string" && type && onChange({
        _ref: selectedAssetFromSource.value,
        _type: ASSET_TYPE[type]
      });
    }, [client, onChange, selectedAssetFromSource]);
    const AssetSourceComponent = selectedAssetSource?.component, buttonText = t(value ? "search.filter-asset-change" : "search.filter-asset-select", {
      context: type
    }), accept = get(type, "options.accept", type === "image" ? "image/*" : "");
    return /* @__PURE__ */ jsx(ContainerBox, { children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      selectedAssetSource && AssetSourceComponent && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(AssetSourceComponent, { assetType: type, assetSource: selectedAssetSource, dialogHeaderTitle: t("search.action.select-asset", {
        context: type
      }), onClose: handleCloseAssetSource, onSelect: handleSelectAssetFromSource2, selectedAssets: [], selectionType: "single", accept }) }),
      value && /* @__PURE__ */ jsx(AssetPreview, { reference: value }),
      /* @__PURE__ */ jsxs(Flex, { gap: 2, children: [
        assetSources.length === 0 && /* @__PURE__ */ jsx(AssetSourceError, { padding: 2 }),
        assetSources.length > 0 && /* @__PURE__ */ jsx(Fragment, { children: assetSources.length > 1 ? /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(Button, { icon: value ? UndoIcon : SearchIcon, iconRight: ChevronDownIcon, mode: "ghost", width: value ? "fill" : void 0, text: buttonText }), id: menuButtonId, menu: /* @__PURE__ */ jsx(Menu, { children: assetSources.map((source) => /* @__PURE__ */ jsx(
          MenuItem$1,
          {
            icon: source.icon || ImageIcon,
            onClick: () => handleSelectAssetSource(source),
            text: (source.i18nKey ? t(source.i18nKey) : source.title) || startCase(source.name)
          },
          source.name
        )) }), popover: {
          constrainSize: !0,
          portal: !1,
          radius: 2
        } }) : /* @__PURE__ */ jsx(
          Button,
          {
            icon: value ? UndoIcon : SearchIcon,
            mode: "ghost",
            onClick: () => handleSelectAssetSource(assetSources[0]),
            width: value ? "fill" : void 0,
            text: buttonText
          }
        ) }),
        value && /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: handleClear, width: "fill", text: t("search.filter-asset-clear"), tone: "critical" })
      ] })
    ] }) });
  };
}
const assetOperators = {
  assetFileEqual: {
    nameKey: "search.operator.asset-file-equal.name",
    descriptionKey: "search.operator.asset-file-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}.asset._ref == ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("file"),
    label: "is",
    type: "assetFileEqual"
  },
  assetFileNotEqual: {
    nameKey: "search.operator.asset-file-not-equal.name",
    descriptionKey: "search.operator.asset-file-not-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}.asset._ref != ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("file"),
    label: "is not",
    type: "assetFileNotEqual"
  },
  assetImageEqual: {
    nameKey: "search.operator.asset-image-equal.name",
    descriptionKey: "search.operator.asset-image-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}.asset._ref == ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("image"),
    label: "is",
    type: "assetImageEqual"
  },
  assetImageNotEqual: {
    nameKey: "search.operator.asset-image-not-equal.name",
    descriptionKey: "search.operator.asset-image-not-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}.asset._ref != ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("image"),
    label: "is not",
    type: "assetImageNotEqual"
  }
};
function SearchFilterBooleanInput(t0) {
  const $ = c(16), {
    onChange,
    value
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange ? (t2 = (event) => {
    onChange(event.currentTarget.value === "true");
  }, $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2, t3 = fullscreen ? 2 : 1, t4 = String(value ?? !0);
  let t5;
  $[2] !== t ? (t5 = t("search.filter-boolean-true"), $[2] = t, $[3] = t5) : t5 = $[3];
  let t6;
  $[4] !== t5 ? (t6 = /* @__PURE__ */ jsx("option", { value: "true", children: t5 }), $[4] = t5, $[5] = t6) : t6 = $[5];
  let t7;
  $[6] !== t ? (t7 = t("search.filter-boolean-false"), $[6] = t, $[7] = t7) : t7 = $[7];
  let t8;
  $[8] !== t7 ? (t8 = /* @__PURE__ */ jsx("option", { value: "false", children: t7 }), $[8] = t7, $[9] = t8) : t8 = $[9];
  let t9;
  return $[10] !== handleChange || $[11] !== t3 || $[12] !== t4 || $[13] !== t6 || $[14] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Select, { fontSize: t3, onChange: handleChange, radius: 2, value: t4, children: [
    t6,
    t8
  ] }), $[10] = handleChange, $[11] = t3, $[12] = t4, $[13] = t6, $[14] = t8, $[15] = t9) : t9 = $[15], t9;
}
const booleanOperators = {
  booleanEqual: {
    nameKey: "search.operator.boolean-equal.name",
    descriptionKey: "search.operator.boolean-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => typeof value < "u" && fieldPath ? `${fieldPath} == ${toJSON(value)}` : null,
    initialValue: !0,
    inputComponent: SearchFilterBooleanInput,
    type: "booleanEqual"
  }
}, TimeLabelText = styled(Text$1)`
  cursor: default;
`;
function DateIncludeTimeFooter(t0) {
  const $ = c(14), {
    onChange,
    value
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("calendar.action.include-time-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== onChange || $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(TimeLabelText, { muted: !0, onClick: onChange, size: 1, weight: "medium", children: t1 }) }), $[2] = onChange, $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("calendar.action.include-time-label"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== onChange || $[8] !== t3 || $[9] !== value ? (t4 = /* @__PURE__ */ jsx(Switch$1, { checked: value, label: t3, onChange }), $[7] = onChange, $[8] = t3, $[9] = value, $[10] = t4) : t4 = $[10];
  let t5;
  return $[11] !== t2 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, justify: "flex-end", marginTop: 1, children: [
    t2,
    t4
  ] }), $[11] = t2, $[12] = t4, $[13] = t5) : t5 = $[13], t5;
}
function useCalendar() {
  const context = useContext(CalendarContext);
  if (context === void 0)
    throw new Error("useCalendar must be used within an CalendarContext.Provider");
  return context;
}
function CalendarHeader(props2) {
  const $ = c(39), {
    t
  } = useTranslation();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    month: "long",
    year: "numeric"
  }, $[0] = t0) : t0 = $[0];
  const monthFormatter = useDateTimeFormat(t0), {
    focusedDate
  } = useCalendar(), {
    moveFocusedDate,
    onNowClick
  } = props2;
  let t1;
  $[1] !== moveFocusedDate ? (t1 = () => moveFocusedDate(-1), $[1] = moveFocusedDate, $[2] = t1) : t1 = $[2];
  const handlePrevMonthClick = t1;
  let t2;
  $[3] !== moveFocusedDate ? (t2 = () => moveFocusedDate(1), $[3] = moveFocusedDate, $[4] = t2) : t2 = $[4];
  const handleNextMonthClick = t2;
  let t3;
  $[5] !== focusedDate || $[6] !== monthFormatter ? (t3 = upperFirst(monthFormatter.format(focusedDate)), $[5] = focusedDate, $[6] = monthFormatter, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Inline, { paddingLeft: 2, space: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t3 }) }), $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t ? (t5 = t("calendar.action.go-to-today-aria-label"), $[10] = t, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t ? (t6 = t("calendar.action.go-to-today"), $[12] = t, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== onNowClick || $[15] !== t5 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsx(Button, { "aria-label": t5, mode: "bleed", onClick: onNowClick, text: t6 }), $[14] = onNowClick, $[15] = t5, $[16] = t6, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== t ? (t8 = t("calendar.action.go-to-previous-month"), $[18] = t, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== t8 ? (t9 = {
    content: t8
  }, $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== handlePrevMonthClick || $[23] !== t9 ? (t10 = /* @__PURE__ */ jsx(Button, { icon: ChevronLeftIcon, mode: "bleed", onClick: handlePrevMonthClick, tooltipProps: t9 }), $[22] = handlePrevMonthClick, $[23] = t9, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t ? (t11 = t("calendar.action.go-to-next-month"), $[25] = t, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== t11 ? (t12 = {
    content: t11
  }, $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== handleNextMonthClick || $[30] !== t12 ? (t13 = /* @__PURE__ */ jsx(Button, { icon: ChevronRightIcon, mode: "bleed", onClick: handleNextMonthClick, tooltipProps: t12 }), $[29] = handleNextMonthClick, $[30] = t12, $[31] = t13) : t13 = $[31];
  let t14;
  $[32] !== t10 || $[33] !== t13 || $[34] !== t7 ? (t14 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t7,
    t10,
    t13
  ] }), $[32] = t10, $[33] = t13, $[34] = t7, $[35] = t14) : t14 = $[35];
  let t15;
  return $[36] !== t14 || $[37] !== t4 ? (t15 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, justify: "space-between", children: [
    t4,
    t14
  ] }), $[36] = t14, $[37] = t4, $[38] = t15) : t15 = $[38], t15;
}
const CircleSvg = styled.svg(({
  theme
}) => css`
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;

    circle {
      stroke: ${theme.sanity.color.card.enabled.border};
      stroke-width: 3;
      fill: none;
    }
  `), CustomCard = styled(Card)`
  position: relative;

  &[data-focused='true'] {
    z-index: 1;
  }

  &[data-start-date='true'] {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &[data-end-date='true'] {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &[data-within-range='true'] {
    border-radius: 0;
  }
`;
function CalendarDay$2(t0) {
  const $ = c(38), {
    date,
    onSelect
  } = t0;
  let t1;
  $[0] !== date || $[1] !== onSelect ? (t1 = () => {
    onSelect(date);
  }, $[0] = date, $[1] = onSelect, $[2] = t1) : t1 = $[2];
  const handleClick = t1, {
    date: selectedDate,
    endDate: selectedEndDate,
    focusedDate,
    selectRange
  } = useCalendar();
  let t2;
  $[3] !== date || $[4] !== selectedDate ? (t2 = selectedDate && isSameDay(date, selectedDate), $[3] = date, $[4] = selectedDate, $[5] = t2) : t2 = $[5];
  const isSelected = t2;
  let t3;
  $[6] !== date || $[7] !== selectRange || $[8] !== selectedDate ? (t3 = selectRange && selectedDate && isSameDay(date, selectedDate), $[6] = date, $[7] = selectRange, $[8] = selectedDate, $[9] = t3) : t3 = $[9];
  const isStartDate = t3;
  let t4;
  $[10] !== date || $[11] !== selectRange || $[12] !== selectedEndDate ? (t4 = selectRange && selectedEndDate && isSameDay(date, selectedEndDate), $[10] = date, $[11] = selectRange, $[12] = selectedEndDate, $[13] = t4) : t4 = $[13];
  const isEndDate = t4, isCurrentMonth = isSameMonth(date, focusedDate), isFocused = focusedDate && isSameDay(date, focusedDate);
  let t5;
  $[14] !== date ? (t5 = isSameDay(date, /* @__PURE__ */ new Date()), $[14] = date, $[15] = t5) : t5 = $[15];
  const isToday2 = t5, isWithinRange = selectedDate && selectedEndDate && !isStartDate && !isEndDate && isAfter(date, selectedDate) && isBefore(date, selectedEndDate);
  let t6;
  $[16] !== date ? (t6 = date.toDateString(), $[16] = date, $[17] = t6) : t6 = $[17];
  const t7 = isEndDate ? !0 : void 0, t8 = isFocused ? "true" : "", t9 = isStartDate ? !0 : void 0, t10 = isWithinRange ? !0 : void 0, t11 = isSelected || isStartDate || isEndDate, t12 = isWithinRange ? "primary" : "default";
  let t13;
  $[18] !== isToday2 ? (t13 = isToday2 && /* @__PURE__ */ jsx(CircleSvg, { height: "100%", preserveAspectRatio: "xMidYMid meet", vectorEffect: "non-scaling-stroke", viewBox: "0 0 100 100", width: "100%", children: /* @__PURE__ */ jsx("circle", { cx: "50", cy: "50", r: "40%" }) }), $[18] = isToday2, $[19] = t13) : t13 = $[19];
  const t14 = !isSelected && !isCurrentMonth, t15 = isCurrentMonth ? "medium" : "regular";
  let t16;
  $[20] !== date ? (t16 = date.getDate(), $[20] = date, $[21] = t16) : t16 = $[21];
  let t17;
  $[22] !== t14 || $[23] !== t15 || $[24] !== t16 ? (t17 = /* @__PURE__ */ jsx(Text$1, { align: "center", muted: t14, size: 1, weight: t15, children: t16 }), $[22] = t14, $[23] = t15, $[24] = t16, $[25] = t17) : t17 = $[25];
  let t18;
  return $[26] !== handleClick || $[27] !== isSelected || $[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t17 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9 ? (t18 = /* @__PURE__ */ jsxs(CustomCard, { __unstable_focusRing: !0, "aria-label": t6, "aria-pressed": isSelected, "data-end-date": t7, "data-focused": t8, "data-ui": "CalendarDay", "aria-selected": isSelected, "data-start-date": t9, "data-within-range": t10, forwardedAs: "button", onClick: handleClick, paddingX: 3, paddingY: 2, radius: 2, role: "button", selected: t11, tabIndex: -1, tone: t12, children: [
    t13,
    t17
  ] }), $[26] = handleClick, $[27] = isSelected, $[28] = t10, $[29] = t11, $[30] = t12, $[31] = t13, $[32] = t17, $[33] = t6, $[34] = t7, $[35] = t8, $[36] = t9, $[37] = t18) : t18 = $[37], t18;
}
const SHORT_WEEK_DAY_KEYS = ["calendar.weekday-names.short.monday", "calendar.weekday-names.short.tuesday", "calendar.weekday-names.short.wednesday", "calendar.weekday-names.short.thursday", "calendar.weekday-names.short.friday", "calendar.weekday-names.short.saturday", "calendar.weekday-names.short.sunday"];
range(0, 24);
const ARROW_KEYS$1 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], TAIL_WEEKDAYS$1 = [1, 2, 3, 4, 5, 6], getWeekStartsOfMonth$1 = (date, weekStartsOn) => {
  const firstDay = startOfMonth(date);
  return eachWeekOfInterval({
    start: firstDay,
    end: lastDayOfMonth(firstDay)
  }, {
    weekStartsOn: weekStartsOn === 7 ? 0 : weekStartsOn
  });
}, getWeekDaysFromWeekStarts$1 = (weekStarts) => weekStarts.map((weekStart) => [weekStart, ...TAIL_WEEKDAYS$1.map((d) => addDays(weekStart, d))]), useWeeksOfMonth = (date) => {
  const $ = c(3), {
    weekInfo
  } = useCurrentLocale();
  let t0;
  return $[0] !== date || $[1] !== weekInfo.firstDay ? (t0 = getWeekDaysFromWeekStarts$1(getWeekStartsOfMonth$1(date, weekInfo.firstDay)).map(_temp$W), $[0] = date, $[1] = weekInfo.firstDay, $[2] = t0) : t0 = $[2], t0;
};
function _temp$W(days) {
  return {
    number: getWeek(days[0]),
    days
  };
}
const WEEK_DAY_NAME_KEYS = {
  // Monday is start of the week
  1: SHORT_WEEK_DAY_KEYS,
  // Saturday is start of week
  6: [...SHORT_WEEK_DAY_KEYS.slice(5), ...SHORT_WEEK_DAY_KEYS.slice(0, 5)],
  // Sunday is start of the week
  7: [SHORT_WEEK_DAY_KEYS[6], ...SHORT_WEEK_DAY_KEYS.slice(0, 6)]
}, CustomGrid = styled(Grid)`
  grid-template-columns: repeat(7, minmax(44px, auto));
`;
function CalendarMonth$1(t0) {
  const $ = c(16), {
    hidden,
    onSelect
  } = t0, {
    focusedDate,
    firstWeekDay
  } = useCalendar(), {
    t
  } = useTranslation(), t1 = hidden || !1, t2 = WEEK_DAY_NAME_KEYS[firstWeekDay];
  let t3;
  if ($[0] !== t || $[1] !== t2) {
    let t42;
    $[3] !== t ? (t42 = (weekdayDay) => /* @__PURE__ */ jsx(Box, { paddingBottom: 3, paddingTop: 2, children: /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, weight: "medium", children: t(weekdayDay) }) }, weekdayDay), $[3] = t, $[4] = t42) : t42 = $[4], t3 = t2.map(t42), $[0] = t, $[1] = t2, $[2] = t3;
  } else
    t3 = $[2];
  const t4 = useWeeksOfMonth(focusedDate);
  let t5;
  if ($[5] !== onSelect || $[6] !== t4) {
    let t62;
    $[8] !== onSelect ? (t62 = (week, weekIdx) => week.days.map((weekDayDate, dayIdx) => /* @__PURE__ */ jsx(CalendarDay$2, { date: weekDayDate, onSelect }, `${weekIdx}-${dayIdx}`)), $[8] = onSelect, $[9] = t62) : t62 = $[9], t5 = t4.map(t62), $[5] = onSelect, $[6] = t4, $[7] = t5;
  } else
    t5 = $[7];
  let t6;
  $[10] !== t3 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs(CustomGrid, { gapY: 1, children: [
    t3,
    t5
  ] }), $[10] = t3, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== t1 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { "aria-hidden": t1, "data-ui": "CalendarMonth", children: t6 }), $[13] = t1, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
}
const PRESERVE_FOCUS_ELEMENT$1 = /* @__PURE__ */ jsx("span", { "data-preserve-focus": !0, style: {
  overflow: "hidden",
  position: "absolute",
  outline: "none"
}, tabIndex: -1 });
function Calendar$1(props2) {
  const $ = c(53), {
    date,
    endDate,
    onSelect,
    selectRange,
    selectTime
  } = props2, [calendarElement, setCalendarElement] = useState(null), [selectEndValue, setSelectEndValue] = useState(!1);
  let t0;
  $[0] !== date ? (t0 = date || /* @__PURE__ */ new Date(), $[0] = date, $[1] = t0) : t0 = $[1];
  const [focusedDate, setFocusedDate] = useState(t0), previousDate = useRef(date || null), previousEndDate = useRef(endDate || null), {
    weekInfo: t1
  } = useCurrentLocale(), {
    firstDay: firstWeekDay
  } = t1;
  let t2;
  $[2] !== calendarElement ? (t2 = () => {
    calendarElement?.querySelector('[data-focused="true"]')?.focus();
  }, $[2] = calendarElement, $[3] = t2) : t2 = $[3];
  const focusCurrentWeekDay = t2;
  let t3;
  $[4] !== date || $[5] !== endDate || $[6] !== onSelect || $[7] !== selectEndValue || $[8] !== selectRange ? (t3 = (d) => {
    const selectedDate = set$1(d, {
      hours: d.getHours(),
      minutes: d.getMinutes(),
      seconds: 0,
      milliseconds: 0
    }), dateIsBeforeStartDate = date && isBefore(selectedDate, date), dateIsAfterEndDate = endDate && isAfter(selectedDate, endDate);
    if (selectRange) {
      if (dateIsBeforeStartDate || dateIsAfterEndDate) {
        onSelect({
          date: selectedDate,
          endDate: null
        });
        return;
      }
      onSelect(selectEndValue ? {
        date: date || null,
        endDate: selectedDate
      } : {
        date: selectedDate,
        endDate: date ? null : endDate || null
      });
    } else
      onSelect({
        date: selectedDate
      });
  }, $[4] = date, $[5] = endDate, $[6] = onSelect, $[7] = selectEndValue, $[8] = selectRange, $[9] = t3) : t3 = $[9];
  const handleDateChange = t3;
  let t4;
  $[10] !== onSelect || $[11] !== selectRange ? (t4 = () => {
    const now = /* @__PURE__ */ new Date();
    selectRange ? setFocusedDate(now) : onSelect({
      date: now
    });
  }, $[10] = onSelect, $[11] = selectRange, $[12] = t4) : t4 = $[12];
  const handleNowClick = t4;
  let t5;
  $[13] !== calendarElement || $[14] !== focusCurrentWeekDay || $[15] !== focusedDate ? (t5 = (event) => {
    if (ARROW_KEYS$1.includes(event.key)) {
      if (event.preventDefault(), event.target.hasAttribute("data-calendar-grid")) {
        focusCurrentWeekDay();
        return;
      }
      event.key === "ArrowUp" && setFocusedDate(addDays(focusedDate, -7)), event.key === "ArrowDown" && setFocusedDate(addDays(focusedDate, 7)), event.key === "ArrowLeft" && setFocusedDate(addDays(focusedDate, -1)), event.key === "ArrowRight" && setFocusedDate(addDays(focusedDate, 1)), calendarElement?.querySelector("[data-preserve-focus]")?.focus();
    }
  }, $[13] = calendarElement, $[14] = focusCurrentWeekDay, $[15] = focusedDate, $[16] = t5) : t5 = $[16];
  const handleKeyDown = t5;
  let t6;
  $[17] !== focusedDate ? (t6 = (by) => setFocusedDate(addMonths(focusedDate, by)), $[17] = focusedDate, $[18] = t6) : t6 = $[18];
  const moveFocusedDate = t6;
  let t7, t8;
  $[19] !== focusCurrentWeekDay ? (t7 = () => {
    focusCurrentWeekDay();
  }, t8 = [focusCurrentWeekDay], $[19] = focusCurrentWeekDay, $[20] = t7, $[21] = t8) : (t7 = $[20], t8 = $[21]), useEffect(t7, t8);
  let t9;
  $[22] !== focusCurrentWeekDay ? (t9 = () => {
    document.activeElement?.matches("[data-calendar-grid], [data-calendar-grid] [data-preserve-focus]") && focusCurrentWeekDay();
  }, $[22] = focusCurrentWeekDay, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== focusCurrentWeekDay || $[25] !== focusedDate ? (t10 = [focusCurrentWeekDay, focusedDate], $[24] = focusCurrentWeekDay, $[25] = focusedDate, $[26] = t10) : t10 = $[26], useEffect(t9, t10);
  let t11, t12;
  $[27] !== date || $[28] !== endDate || $[29] !== onSelect ? (t11 = () => {
    const dateChanged = date?.getTime() !== previousDate.current?.getTime(), endDateChanged = endDate?.getTime() !== previousEndDate.current?.getTime(), onlyDateChanged = dateChanged && !endDateChanged, onlyEndDateChanged = !dateChanged && endDateChanged, dateIsAfterEndDate_0 = date && endDate && isAfter(date, endDate);
    onlyDateChanged && (dateIsAfterEndDate_0 && (setSelectEndValue(!0), onSelect({
      date,
      endDate: null
    })), setSelectEndValue(!!date), date && setFocusedDate(date)), onlyEndDateChanged && (dateIsAfterEndDate_0 && (setSelectEndValue(!0), onSelect({
      date: endDate,
      endDate: null
    })), setSelectEndValue(!!date && !endDate), endDate && setFocusedDate(endDate)), dateChanged && endDateChanged && (setSelectEndValue(!0), date && setFocusedDate(date)), previousDate.current = date || null, previousEndDate.current = endDate || null;
  }, t12 = [date, endDate, onSelect], $[27] = date, $[28] = endDate, $[29] = onSelect, $[30] = t11, $[31] = t12) : (t11 = $[30], t12 = $[31]), useEffect(t11, t12);
  let t13, t14;
  $[32] !== date || $[33] !== endDate || $[34] !== firstWeekDay || $[35] !== focusedDate || $[36] !== selectRange || $[37] !== selectTime ? (t14 = {
    date,
    endDate,
    focusedDate,
    selectRange,
    selectTime,
    firstWeekDay
  }, $[32] = date, $[33] = endDate, $[34] = firstWeekDay, $[35] = focusedDate, $[36] = selectRange, $[37] = selectTime, $[38] = t14) : t14 = $[38], t13 = t14;
  const value = t13;
  let t15;
  $[39] !== handleNowClick || $[40] !== moveFocusedDate ? (t15 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(CalendarHeader, { moveFocusedDate, onNowClick: handleNowClick }) }) }), $[39] = handleNowClick, $[40] = moveFocusedDate, $[41] = t15) : t15 = $[41];
  let t16;
  $[42] !== handleDateChange ? (t16 = /* @__PURE__ */ jsx(CalendarMonth$1, { onSelect: handleDateChange }), $[42] = handleDateChange, $[43] = t16) : t16 = $[43];
  let t17;
  $[44] !== handleKeyDown || $[45] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Box, { "data-calendar-grid": !0, onKeyDown: handleKeyDown, marginTop: 2, overflow: "hidden", tabIndex: 0, children: [
    t16,
    PRESERVE_FOCUS_ELEMENT$1
  ] }), $[44] = handleKeyDown, $[45] = t16, $[46] = t17) : t17 = $[46];
  let t18;
  $[47] !== t15 || $[48] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Box, { "data-ui": "Calendar", ref: setCalendarElement, children: [
    t15,
    t17
  ] }), $[47] = t15, $[48] = t17, $[49] = t18) : t18 = $[49];
  let t19;
  return $[50] !== t18 || $[51] !== value ? (t19 = /* @__PURE__ */ jsx(CalendarContext.Provider, { value, children: t18 }), $[50] = t18, $[51] = value, $[52] = t19) : t19 = $[52], t19;
}
function DatePicker$1(t0) {
  const $ = c(8), {
    date,
    endDate,
    onChange,
    selectRange,
    selectTime
  } = t0;
  let t1;
  $[0] !== onChange ? (t1 = (dates) => {
    onChange(dates);
  }, $[0] = onChange, $[1] = t1) : t1 = $[1];
  const handleSelect = t1;
  let t2;
  return $[2] !== date || $[3] !== endDate || $[4] !== handleSelect || $[5] !== selectRange || $[6] !== selectTime ? (t2 = /* @__PURE__ */ jsx(Calendar$1, { date, endDate, onSelect: handleSelect, selectRange, selectTime }), $[2] = date, $[3] = endDate, $[4] = handleSelect, $[5] = selectRange, $[6] = selectTime, $[7] = t2) : t2 = $[7], t2;
}
function getDateISOString({
  date,
  dateOnly,
  roundDay
}) {
  let adjustedDate;
  switch (roundDay) {
    case "end":
      adjustedDate = endOfDay(date);
      break;
    case "start":
      adjustedDate = startOfDay(date);
      break;
    default:
      adjustedDate = date;
      break;
  }
  return dateOnly ? adjustedDate.toISOString().split("T")[0] : adjustedDate.toISOString();
}
const FORMAT = {
  date: {
    exampleDate: "Jan 1, 2000",
    pattern: "MMM d, yyyy"
  },
  datetime: {
    exampleDate: "Jan 1, 2000 12:00 AM",
    pattern: "MMM d, yyyy p"
  }
};
function ParsedDateTextInput(t0) {
  const $ = c(53);
  let isDateTime, isDateTimeFormat, onChange, placeholderDate, rest, value;
  $[0] !== t0 ? ({
    isDateTime,
    onChange,
    placeholderDate,
    isDateTimeFormat,
    value,
    ...rest
  } = t0, $[0] = t0, $[1] = isDateTime, $[2] = isDateTimeFormat, $[3] = onChange, $[4] = placeholderDate, $[5] = rest, $[6] = value) : (isDateTime = $[1], isDateTimeFormat = $[2], onChange = $[3], placeholderDate = $[4], rest = $[5], value = $[6]);
  const {
    t
  } = useTranslation(), dateFormat = isDateTimeFormat ? FORMAT.datetime.pattern : FORMAT.date.pattern, [customValidity, setCustomValidity] = useState(void 0);
  let t1;
  $[7] !== dateFormat || $[8] !== value ? (t1 = () => {
    if (!value)
      return "";
    const inputValueDate = new Date(value);
    return format$2(inputValueDate, dateFormat);
  }, $[7] = dateFormat, $[8] = value, $[9] = t1) : t1 = $[9];
  const [inputValue, setInputValue] = useState(t1);
  let t2, t3;
  $[10] !== placeholderDate ? (t3 = placeholderDate || /* @__PURE__ */ new Date(), $[10] = placeholderDate, $[11] = t3) : t3 = $[11];
  const date = t3;
  let t4;
  $[12] !== date || $[13] !== dateFormat ? (t4 = format$2(date, dateFormat), $[12] = date, $[13] = dateFormat, $[14] = t4) : t4 = $[14], t2 = t4;
  const formattedPlaceholder = t2;
  let t5;
  $[15] !== dateFormat || $[16] !== isDateTime || $[17] !== onChange ? (t5 = (t62) => {
    const {
      dateString,
      triggerOnChange
    } = t62;
    if (!dateString)
      return;
    const dateParsed = parse(dateString, dateFormat, /* @__PURE__ */ new Date()), validDate = isValid(dateParsed);
    validDate && (triggerOnChange && onChange(getDateISOString({
      date: dateParsed,
      dateOnly: !isDateTime
    })), setInputValue(format$2(dateParsed, dateFormat))), setCustomValidity(validDate ? void 0 : `Invalid ${isDateTime ? "datetime" : "date"}`);
  }, $[15] = dateFormat, $[16] = isDateTime, $[17] = onChange, $[18] = t5) : t5 = $[18];
  const processInputString = t5;
  let t6;
  $[19] !== inputValue || $[20] !== processInputString ? (t6 = () => {
    processInputString({
      dateString: inputValue,
      triggerOnChange: !0
    });
  }, $[19] = inputValue, $[20] = processInputString, $[21] = t6) : t6 = $[21];
  const handleTextInputBlur = t6;
  let t7;
  $[22] === Symbol.for("react.memo_cache_sentinel") ? (t7 = (event) => {
    setInputValue(event.currentTarget.value);
  }, $[22] = t7) : t7 = $[22];
  const handleTextInputChange = t7;
  let t8;
  $[23] !== onChange ? (t8 = () => {
    onChange(null), setCustomValidity(void 0), setInputValue("");
  }, $[23] = onChange, $[24] = t8) : t8 = $[24];
  const handleTextInputClear = t8;
  let t9;
  $[25] !== inputValue || $[26] !== processInputString ? (t9 = (event_0) => {
    event_0.key === "Enter" && processInputString({
      dateString: inputValue,
      triggerOnChange: !0
    });
  }, $[25] = inputValue, $[26] = processInputString, $[27] = t9) : t9 = $[27];
  const handleTextInputKeyDown = t9;
  let t10;
  $[28] !== dateFormat || $[29] !== processInputString || $[30] !== value ? (t10 = () => {
    const updatedDate = value && new Date(value);
    updatedDate && processInputString({
      dateString: format$2(updatedDate, dateFormat),
      triggerOnChange: !1
    });
  }, $[28] = dateFormat, $[29] = processInputString, $[30] = value, $[31] = t10) : t10 = $[31];
  let t11;
  $[32] !== dateFormat || $[33] !== isDateTimeFormat || $[34] !== processInputString || $[35] !== value ? (t11 = [dateFormat, processInputString, isDateTimeFormat, value], $[32] = dateFormat, $[33] = isDateTimeFormat, $[34] = processInputString, $[35] = value, $[36] = t11) : t11 = $[36], useEffect(t10, t11);
  const t12 = isDateTimeFormat ? FORMAT.datetime.exampleDate : FORMAT.date.exampleDate;
  let t13;
  $[37] !== t || $[38] !== t12 ? (t13 = t("calendar.error.must-be-in-format", {
    exampleDate: t12
  }), $[37] = t, $[38] = t12, $[39] = t13) : t13 = $[39];
  const t14 = !customValidity, t15 = !!inputValue;
  let t16;
  $[40] !== customValidity || $[41] !== formattedPlaceholder || $[42] !== handleTextInputBlur || $[43] !== handleTextInputClear || $[44] !== handleTextInputKeyDown || $[45] !== inputValue || $[46] !== rest || $[47] !== t15 ? (t16 = /* @__PURE__ */ jsx(CustomTextInput, { ...rest, clearButton: t15, customValidity, onBlur: handleTextInputBlur, onChange: handleTextInputChange, onClear: handleTextInputClear, onKeyDown: handleTextInputKeyDown, placeholder: formattedPlaceholder, value: inputValue }), $[40] = customValidity, $[41] = formattedPlaceholder, $[42] = handleTextInputBlur, $[43] = handleTextInputClear, $[44] = handleTextInputKeyDown, $[45] = inputValue, $[46] = rest, $[47] = t15, $[48] = t16) : t16 = $[48];
  let t17;
  return $[49] !== t13 || $[50] !== t14 || $[51] !== t16 ? (t17 = /* @__PURE__ */ jsx(Tooltip, { content: t13, disabled: t14, placement: "top", portal: !0, children: t16 }), $[49] = t13, $[50] = t14, $[51] = t16, $[52] = t17) : t17 = $[52], t17;
}
function CommonDateDirectionInput(t0) {
  const $ = c(36), {
    direction,
    isDateTime,
    onChange,
    value
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  bb0: switch (direction) {
    case "after": {
      t2 = "end";
      break bb0;
    }
    case "before": {
      t2 = "start";
      break bb0;
    }
    default:
      t2 = void 0;
  }
  const roundDay = t2;
  let t3;
  $[0] !== isDateTime || $[1] !== onChange || $[2] !== roundDay || $[3] !== value?.includeTime ? (t3 = (t42) => {
    const {
      date
    } = t42;
    let dateISOString = null;
    date && (dateISOString = getDateISOString({
      date,
      dateOnly: !isDateTime,
      roundDay: value?.includeTime ? void 0 : roundDay
    })), onChange({
      includeTime: value?.includeTime,
      date: dateISOString
    });
  }, $[0] = isDateTime, $[1] = onChange, $[2] = roundDay, $[3] = value?.includeTime, $[4] = t3) : t3 = $[4];
  const handleDatePickerChange = t3;
  let t4;
  $[5] !== isDateTime || $[6] !== onChange || $[7] !== roundDay || $[8] !== value ? (t4 = () => {
    const includeTime = !value?.includeTime, date_0 = value?.date ? new Date(value.date) : null;
    let dateISOString_0 = null;
    date_0 && (dateISOString_0 = getDateISOString({
      date: date_0,
      dateOnly: !isDateTime,
      roundDay: includeTime ? "start" : roundDay
    })), onChange({
      includeTime,
      date: dateISOString_0
    });
  }, $[5] = isDateTime, $[6] = onChange, $[7] = roundDay, $[8] = value, $[9] = t4) : t4 = $[9];
  const handleIncludeTimeChange = t4;
  let t5;
  $[10] !== onChange || $[11] !== value?.includeTime ? (t5 = (date_1) => {
    onChange({
      includeTime: value?.includeTime,
      date: date_1 || null
    });
  }, $[10] = onChange, $[11] = value?.includeTime, $[12] = t5) : t5 = $[12];
  const handleTextDateChange = t5;
  let t6;
  $[13] !== t ? (t6 = t("search.filter-date-aria-label"), $[13] = t, $[14] = t6) : t6 = $[14];
  const t7 = fullscreen ? 2 : 1, t8 = isDateTime && value?.includeTime, t9 = value?.date;
  let t10;
  $[15] !== handleTextDateChange || $[16] !== isDateTime || $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsx(ParsedDateTextInput, { "aria-label": t6, fontSize: t7, isDateTime, isDateTimeFormat: t8, onChange: handleTextDateChange, radius: 2, value: t9 }), $[15] = handleTextDateChange, $[16] = isDateTime, $[17] = t6, $[18] = t7, $[19] = t8, $[20] = t9, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== value ? (t11 = value?.date ? new Date(value.date) : void 0, $[22] = value, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== handleDatePickerChange || $[25] !== isDateTime || $[26] !== t11 ? (t12 = /* @__PURE__ */ jsx(DatePicker$1, { date: t11, onChange: handleDatePickerChange, selectTime: isDateTime }), $[24] = handleDatePickerChange, $[25] = isDateTime, $[26] = t11, $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== handleIncludeTimeChange || $[29] !== isDateTime || $[30] !== value?.includeTime ? (t13 = isDateTime && /* @__PURE__ */ jsx(DateIncludeTimeFooter, { onChange: handleIncludeTimeChange, value: !!value?.includeTime }), $[28] = handleIncludeTimeChange, $[29] = isDateTime, $[30] = value?.includeTime, $[31] = t13) : t13 = $[31];
  let t14;
  return $[32] !== t10 || $[33] !== t12 || $[34] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t10,
    t12,
    t13
  ] }), $[32] = t10, $[33] = t12, $[34] = t13, $[35] = t14) : t14 = $[35], t14;
}
function SearchFilterDateAfterInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateDirectionInput, { ...props2, direction: "after", isDateTime: !1 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateBeforeInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateDirectionInput, { ...props2, direction: "before", isDateTime: !1 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function CommonDateEqualInput(t0) {
  const $ = c(34), {
    isDateTime,
    onChange,
    value
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== isDateTime || $[1] !== onChange || $[2] !== value?.includeTime ? (t2 = (t32) => {
    const {
      date
    } = t32;
    if (date) {
      const dateISOString = getDateISOString({
        date,
        dateOnly: !isDateTime
      });
      onChange({
        includeTime: value?.includeTime,
        date: dateISOString
      });
    } else
      onChange(null);
  }, $[0] = isDateTime, $[1] = onChange, $[2] = value?.includeTime, $[3] = t2) : t2 = $[3];
  const handleDatePickerChange = t2;
  let t3;
  $[4] !== isDateTime || $[5] !== onChange || $[6] !== value ? (t3 = () => {
    const includeTime = !value?.includeTime, date_0 = value?.date ? new Date(value.date) : null;
    let dateISOString_0 = null;
    date_0 && (dateISOString_0 = getDateISOString({
      date: date_0,
      dateOnly: !isDateTime
    })), onChange({
      includeTime,
      date: dateISOString_0
    });
  }, $[4] = isDateTime, $[5] = onChange, $[6] = value, $[7] = t3) : t3 = $[7];
  const handleIncludeTimeChange = t3;
  let t4;
  $[8] !== onChange || $[9] !== value?.includeTime ? (t4 = (date_1) => {
    onChange({
      includeTime: value?.includeTime,
      date: date_1 || null
    });
  }, $[8] = onChange, $[9] = value?.includeTime, $[10] = t4) : t4 = $[10];
  const handleTextDateChange = t4;
  let t5;
  $[11] !== t ? (t5 = t("search.filter-date-aria-label"), $[11] = t, $[12] = t5) : t5 = $[12];
  const t6 = fullscreen ? 2 : 1, t7 = isDateTime && value?.includeTime, t8 = value?.date;
  let t9;
  $[13] !== handleTextDateChange || $[14] !== isDateTime || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsx(ParsedDateTextInput, { "aria-label": t5, fontSize: t6, isDateTime, isDateTimeFormat: t7, onChange: handleTextDateChange, radius: 2, value: t8 }), $[13] = handleTextDateChange, $[14] = isDateTime, $[15] = t5, $[16] = t6, $[17] = t7, $[18] = t8, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== value ? (t10 = value?.date ? new Date(value.date) : void 0, $[20] = value, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== handleDatePickerChange || $[23] !== isDateTime || $[24] !== t10 ? (t11 = /* @__PURE__ */ jsx(DatePicker$1, { date: t10, onChange: handleDatePickerChange, selectTime: isDateTime }), $[22] = handleDatePickerChange, $[23] = isDateTime, $[24] = t10, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== handleIncludeTimeChange || $[27] !== isDateTime || $[28] !== value?.includeTime ? (t12 = isDateTime && /* @__PURE__ */ jsx(DateIncludeTimeFooter, { onChange: handleIncludeTimeChange, value: !!value?.includeTime }), $[26] = handleIncludeTimeChange, $[27] = isDateTime, $[28] = value?.includeTime, $[29] = t12) : t12 = $[29];
  let t13;
  return $[30] !== t11 || $[31] !== t12 || $[32] !== t9 ? (t13 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t9,
    t11,
    t12
  ] }), $[30] = t11, $[31] = t12, $[32] = t9, $[33] = t13) : t13 = $[33], t13;
}
function SearchFilterDateEqualInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateEqualInput, { ...props2, isDateTime: !1 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const UNIT_CHOICES = [{
  unit: "day",
  key: "search.filter-date-unit_days"
}, {
  unit: "month",
  key: "search.filter-date-unit_months"
}, {
  unit: "year",
  key: "search.filter-date-unit_years"
}];
function SearchFilterDateLastInput(t0) {
  const $ = c(26), {
    onChange,
    value
  } = t0, [uncontrolledValue, setUncontrolledValue] = useState(value?.unitValue || ""), dateUnit = useRef("day"), dateValue = useRef(value?.unitValue || null), {
    t
  } = useTranslation(), {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1;
  let t2;
  $[0] !== onChange ? (t2 = () => {
    onChange({
      unit: dateUnit?.current,
      unitValue: dateValue?.current
    });
  }, $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2;
  let t3;
  $[2] !== handleChange ? (t3 = (event) => {
    dateUnit.current = event.currentTarget.value, handleChange();
  }, $[2] = handleChange, $[3] = t3) : t3 = $[3];
  const handleUnitChange = t3;
  let t4;
  $[4] !== handleChange ? (t4 = (event_0) => {
    setUncontrolledValue(event_0.currentTarget.value);
    const numValue = parseFloat(event_0.currentTarget.value);
    dateValue.current = Number.isFinite(numValue) ? numValue : null, handleChange();
  }, $[4] = handleChange, $[5] = t4) : t4 = $[5];
  const handleValueChange = t4;
  let t5;
  $[6] !== t ? (t5 = t("search.filter-date-value-aria-label"), $[6] = t, $[7] = t5) : t5 = $[7];
  const t6 = fullscreen ? 2 : 1;
  let t7;
  $[8] !== handleValueChange || $[9] !== t5 || $[10] !== t6 || $[11] !== uncontrolledValue ? (t7 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(TextInput$1, { "aria-label": t5, fontSize: t6, onChange: handleValueChange, pattern: "\\d*", radius: 2, step: "1", type: "number", value: uncontrolledValue }) }), $[8] = handleValueChange, $[9] = t5, $[10] = t6, $[11] = uncontrolledValue, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t ? (t8 = t("search.filter-date-unit-aria-label"), $[13] = t, $[14] = t8) : t8 = $[14];
  const t9 = fullscreen ? 2 : 1, t10 = value?.unit;
  let t11;
  $[15] !== t ? (t11 = UNIT_CHOICES.map((choice) => /* @__PURE__ */ jsx("option", { value: choice.unit, children: t(choice.key) }, choice.key)), $[15] = t, $[16] = t11) : t11 = $[16];
  let t12;
  $[17] !== handleUnitChange || $[18] !== t10 || $[19] !== t11 || $[20] !== t8 || $[21] !== t9 ? (t12 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Select, { "aria-label": t8, fontSize: t9, onChange: handleUnitChange, radius: 2, value: t10, children: t11 }) }), $[17] = handleUnitChange, $[18] = t10, $[19] = t11, $[20] = t8, $[21] = t9, $[22] = t12) : t12 = $[22];
  let t13;
  return $[23] !== t12 || $[24] !== t7 ? (t13 = /* @__PURE__ */ jsxs(Flex, { gap: 2, children: [
    t7,
    t12
  ] }), $[23] = t12, $[24] = t7, $[25] = t13) : t13 = $[25], t13;
}
const PLACEHOLDER_START_DATE_OFFSET = -7;
function CommonDateRangeInput(t0) {
  const $ = c(56), {
    isDateTime,
    onChange,
    value
  } = t0, {
    t
  } = useTranslation(), {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, [placeholderStartDate] = useState(_temp$V), [placeholderEndDate] = useState(_temp2$i);
  let t2;
  $[0] !== isDateTime || $[1] !== onChange || $[2] !== value?.includeTime ? (t2 = (t32) => {
    const {
      date,
      endDate
    } = t32;
    onChange(getStartAndEndDate({
      date,
      endDate,
      includeTime: value?.includeTime,
      isDateTime
    }));
  }, $[0] = isDateTime, $[1] = onChange, $[2] = value?.includeTime, $[3] = t2) : t2 = $[3];
  const handleDatePickerChange = t2;
  let t3;
  $[4] !== isDateTime || $[5] !== onChange || $[6] !== value ? (t3 = () => {
    const includeTime = !value?.includeTime;
    onChange(getStartAndEndDate({
      date: value?.from ? new Date(value.from) : null,
      endDate: value?.to ? new Date(value.to) : null,
      includeTime,
      isDateTime
    }));
  }, $[4] = isDateTime, $[5] = onChange, $[6] = value, $[7] = t3) : t3 = $[7];
  const handleIncludeTimeChange = t3;
  let t4;
  $[8] !== onChange || $[9] !== value?.from || $[10] !== value?.includeTime ? (t4 = (date_0) => {
    onChange({
      includeTime: value?.includeTime,
      to: date_0 || null,
      from: value?.from || null
    });
  }, $[8] = onChange, $[9] = value?.from, $[10] = value?.includeTime, $[11] = t4) : t4 = $[11];
  const handleTextEndDateChange = t4;
  let t5;
  $[12] !== onChange || $[13] !== value?.includeTime || $[14] !== value?.to ? (t5 = (date_1) => {
    onChange({
      includeTime: value?.includeTime,
      to: value?.to || null,
      from: date_1 || null
    });
  }, $[12] = onChange, $[13] = value?.includeTime, $[14] = value?.to, $[15] = t5) : t5 = $[15];
  const handleTextStartDateChange = t5;
  let t6;
  $[16] !== t ? (t6 = t("search.filter-date-range-start-date-aria-label"), $[16] = t, $[17] = t6) : t6 = $[17];
  const t7 = fullscreen ? 2 : 1, t8 = isDateTime && value?.includeTime, t9 = value?.from;
  let t10;
  $[18] !== handleTextStartDateChange || $[19] !== isDateTime || $[20] !== placeholderStartDate || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsx(ParsedDateTextInput, { "aria-label": t6, fontSize: t7, isDateTime, isDateTimeFormat: t8, onChange: handleTextStartDateChange, placeholderDate: placeholderStartDate, radius: 2, value: t9 }), $[18] = handleTextStartDateChange, $[19] = isDateTime, $[20] = placeholderStartDate, $[21] = t6, $[22] = t7, $[23] = t8, $[24] = t9, $[25] = t10) : t10 = $[25];
  let t11;
  $[26] !== t ? (t11 = t("search.filter-date-range-end-date-aria-label"), $[26] = t, $[27] = t11) : t11 = $[27];
  const t12 = fullscreen ? 2 : 1, t13 = isDateTime && value?.includeTime, t14 = value?.to;
  let t15;
  $[28] !== handleTextEndDateChange || $[29] !== isDateTime || $[30] !== placeholderEndDate || $[31] !== t11 || $[32] !== t12 || $[33] !== t13 || $[34] !== t14 ? (t15 = /* @__PURE__ */ jsx(ParsedDateTextInput, { "aria-label": t11, fontSize: t12, isDateTime, isDateTimeFormat: t13, onChange: handleTextEndDateChange, placeholderDate: placeholderEndDate, radius: 2, value: t14 }), $[28] = handleTextEndDateChange, $[29] = isDateTime, $[30] = placeholderEndDate, $[31] = t11, $[32] = t12, $[33] = t13, $[34] = t14, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] !== t10 || $[37] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 3, children: [
    t10,
    t15
  ] }), $[36] = t10, $[37] = t15, $[38] = t16) : t16 = $[38];
  let t17;
  $[39] !== value ? (t17 = value?.from ? new Date(value.from) : void 0, $[39] = value, $[40] = t17) : t17 = $[40];
  let t18;
  $[41] !== value ? (t18 = value?.to ? new Date(value.to) : void 0, $[41] = value, $[42] = t18) : t18 = $[42];
  let t19;
  $[43] !== handleDatePickerChange || $[44] !== isDateTime || $[45] !== t17 || $[46] !== t18 ? (t19 = /* @__PURE__ */ jsx(DatePicker$1, { date: t17, endDate: t18, onChange: handleDatePickerChange, selectRange: !0, selectTime: isDateTime }), $[43] = handleDatePickerChange, $[44] = isDateTime, $[45] = t17, $[46] = t18, $[47] = t19) : t19 = $[47];
  let t20;
  $[48] !== handleIncludeTimeChange || $[49] !== isDateTime || $[50] !== value?.includeTime ? (t20 = isDateTime && /* @__PURE__ */ jsx(DateIncludeTimeFooter, { onChange: handleIncludeTimeChange, value: !!value?.includeTime }), $[48] = handleIncludeTimeChange, $[49] = isDateTime, $[50] = value?.includeTime, $[51] = t20) : t20 = $[51];
  let t21;
  return $[52] !== t16 || $[53] !== t19 || $[54] !== t20 ? (t21 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t16,
    t19,
    t20
  ] }) }), $[52] = t16, $[53] = t19, $[54] = t20, $[55] = t21) : t21 = $[55], t21;
}
function _temp2$i() {
  return /* @__PURE__ */ new Date();
}
function _temp$V() {
  return addDays(/* @__PURE__ */ new Date(), PLACEHOLDER_START_DATE_OFFSET);
}
function getStartAndEndDate({
  date,
  endDate,
  includeTime,
  isDateTime
}) {
  return includeTime ? {
    includeTime,
    to: endDate ? getDateISOString({
      date: endDate,
      dateOnly: !isDateTime,
      roundDay: "start"
    }) : null,
    from: date ? getDateISOString({
      date,
      dateOnly: !isDateTime,
      roundDay: "start"
    }) : null
  } : {
    includeTime,
    to: endDate ? getDateISOString({
      date: endDate,
      dateOnly: !isDateTime,
      roundDay: "end"
    }) : null,
    from: date ? getDateISOString({
      date,
      dateOnly: !isDateTime,
      roundDay: "start"
    }) : null
  };
}
function SearchFilterDateRangeInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateRangeInput, { ...props2, isDateTime: !1 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateTimeAfterInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateDirectionInput, { ...props2, direction: "after", isDateTime: !0 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateTimeBeforeInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateDirectionInput, { ...props2, direction: "before", isDateTime: !0 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateTimeEqualInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateEqualInput, { ...props2, isDateTime: !0 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function SearchFilterDateTimeRangeInput(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommonDateRangeInput, { ...props2, isDateTime: !0 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const COMMON = {
  dateAfter: {
    buttonValueComponent: SearchButtonValueDate,
    initialValue: null
  },
  dateBefore: {
    buttonValueComponent: SearchButtonValueDate,
    initialValue: null
  },
  dateEqual: {
    buttonValueComponent: SearchButtonValueDate,
    initialValue: {
      date: null,
      includeTime: !1
    }
  },
  dateLast: {
    buttonValueComponent: SearchButtonValueDateLast
  },
  dateNotEqual: {
    buttonValueComponent: SearchButtonValueDate,
    initialValue: {
      date: null,
      includeTime: !1
    }
  },
  dateRange: {
    initialValue: null
  }
}, dateOperators = {
  dateAfter: {
    ...COMMON.dateAfter,
    nameKey: "search.operator.date-after.name",
    descriptionKey: "search.operator.date-after.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `${fieldPath} > ${toJSON(value?.date)}` : null,
    inputComponent: SearchFilterDateAfterInput,
    type: "dateAfter"
  },
  dateBefore: {
    ...COMMON.dateBefore,
    nameKey: "search.operator.date-before.name",
    descriptionKey: "search.operator.date-before.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `${fieldPath} < ${toJSON(value?.date)}` : null,
    inputComponent: SearchFilterDateBeforeInput,
    type: "dateBefore"
  },
  dateEqual: {
    ...COMMON.dateEqual,
    nameKey: "search.operator.date-equal.name",
    descriptionKey: "search.operator.date-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `${fieldPath} == ${toJSON(value.date)}` : null,
    inputComponent: SearchFilterDateEqualInput,
    type: "dateEqual"
  },
  dateLast: {
    ...COMMON.dateLast,
    nameKey: "search.operator.date-last.name",
    descriptionKey: "search.operator.date-last.description",
    groqFilter: ({
      fieldPath,
      value
    }) => {
      const flooredValue = typeof value?.unitValue == "number" ? Math.floor(value.unitValue) : void 0, timestampAgo = Number.isFinite(flooredValue) ? sub(/* @__PURE__ */ new Date(), {
        days: value?.unit === "day" ? flooredValue : 0,
        months: value?.unit === "month" ? flooredValue : 0,
        years: value?.unit === "year" ? flooredValue : 0
      }).toISOString().split("T")[0] : null;
      return timestampAgo && fieldPath ? `${fieldPath} > ${toJSON(timestampAgo)}` : null;
    },
    inputComponent: SearchFilterDateLastInput,
    initialValue: {
      unit: "day",
      unitValue: 7
    },
    type: "dateLast"
  },
  dateNotEqual: {
    ...COMMON.dateNotEqual,
    nameKey: "search.operator.date-not-equal.name",
    descriptionKey: "search.operator.date-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `${fieldPath} != ${toJSON(value.date)}` : null,
    inputComponent: SearchFilterDateEqualInput,
    type: "dateNotEqual"
  },
  dateRange: {
    ...COMMON.dateRange,
    nameKey: "search.operator.date-range.name",
    descriptionKey: "search.operator.date-range.description",
    buttonValueComponent: SearchButtonValueDateRange,
    groqFilter: ({
      fieldPath,
      value
    }) => value?.to && value?.from && fieldPath ? `${fieldPath} >= ${toJSON(value.from)} && ${fieldPath} <= ${toJSON(value.to)}` : null,
    initialValue: {
      includeTime: !1,
      to: startOfToday().toISOString(),
      from: null
    },
    inputComponent: SearchFilterDateRangeInput,
    type: "dateRange"
  },
  dateTimeAfter: {
    ...COMMON.dateAfter,
    nameKey: "search.operator.date-time-after.name",
    descriptionKey: "search.operator.date-time-after.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `dateTime(${fieldPath}) > dateTime(${toJSON(value.date)})` : null,
    inputComponent: SearchFilterDateTimeAfterInput,
    type: "dateTimeAfter"
  },
  dateTimeBefore: {
    ...COMMON.dateBefore,
    nameKey: "search.operator.date-time-before.name",
    descriptionKey: "search.operator.date-time-before.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value?.date && fieldPath ? `dateTime(${fieldPath}) < dateTime(${toJSON(value.date)})` : null,
    inputComponent: SearchFilterDateTimeBeforeInput,
    type: "dateTimeBefore"
  },
  dateTimeEqual: {
    ...COMMON.dateEqual,
    nameKey: "search.operator.date-time-equal.name",
    descriptionKey: "search.operator.date-time-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => {
      const date = value?.date && new Date(value.date);
      if (!date || !isValid(date) || !fieldPath)
        return null;
      const dateStart = (value?.includeTime ? startOfMinute(date) : startOfDay(date)).toISOString(), dateEnd = (value?.includeTime ? endOfMinute(date) : endOfDay(date)).toISOString();
      return `dateTime(${fieldPath}) > dateTime(${toJSON(dateStart)}) && dateTime(${fieldPath}) < dateTime(${toJSON(dateEnd)})`;
    },
    inputComponent: SearchFilterDateTimeEqualInput,
    type: "dateTimeEqual"
  },
  dateTimeLast: {
    ...COMMON.dateLast,
    nameKey: "search.operator.date-time-last.name",
    descriptionKey: "search.operator.date-time-last.description",
    groqFilter: ({
      fieldPath,
      value
    }) => {
      const flooredValue = typeof value?.unitValue == "number" ? Math.floor(value.unitValue) : void 0, timestampAgo = Number.isFinite(flooredValue) ? sub(/* @__PURE__ */ new Date(), {
        days: value?.unit === "day" ? flooredValue : 0,
        months: value?.unit === "month" ? flooredValue : 0,
        years: value?.unit === "year" ? flooredValue : 0
      }).toISOString() : null;
      return timestampAgo && fieldPath ? `dateTime(${fieldPath}) > dateTime(${toJSON(timestampAgo)})` : null;
    },
    initialValue: {
      unit: "day",
      unitValue: 7
    },
    inputComponent: SearchFilterDateLastInput,
    type: "dateTimeLast"
  },
  dateTimeNotEqual: {
    ...COMMON.dateNotEqual,
    nameKey: "search.operator.date-time-not-equal.name",
    descriptionKey: "search.operator.date-time-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => {
      const date = value?.date && new Date(value.date);
      if (!date || !isValid(date) || !fieldPath)
        return null;
      const dateStart = (value?.includeTime ? startOfMinute(date) : startOfDay(date)).toISOString(), dateEnd = (value?.includeTime ? endOfMinute(date) : endOfDay(date)).toISOString();
      return `dateTime(${fieldPath}) < dateTime(${toJSON(dateStart)}) || dateTime(${fieldPath}) > dateTime(${toJSON(dateEnd)})`;
    },
    inputComponent: SearchFilterDateTimeEqualInput,
    type: "dateTimeNotEqual"
  },
  dateTimeRange: {
    ...COMMON.dateRange,
    nameKey: "search.operator.date-time-range.name",
    descriptionKey: "search.operator.date-time-range.description",
    buttonValueComponent: SearchButtonValueDateRange,
    groqFilter: ({
      fieldPath,
      value
    }) => value?.to && value?.from && fieldPath ? `dateTime(${fieldPath}) >= dateTime(${toJSON(value.from)}) && dateTime(${fieldPath}) <= dateTime(${toJSON(value.to)})` : null,
    initialValue: {
      includeTime: !1,
      to: startOfToday().toISOString(),
      from: null
    },
    inputComponent: SearchFilterDateTimeRangeInput,
    type: "dateTimeRange"
  }
}, definedOperators = {
  defined: {
    nameKey: "search.operator.defined.name",
    descriptionKey: "search.operator.defined.description",
    groqFilter: ({
      fieldPath
    }) => fieldPath ? `defined(${fieldPath})` : null,
    type: "defined"
  },
  notDefined: {
    nameKey: "search.operator.not-defined.name",
    descriptionKey: "search.operator.not-defined.description",
    i18nKey: "search.operator.not-defined",
    groqFilter: ({
      fieldPath
    }) => fieldPath ? `!defined(${fieldPath})` : null,
    type: "notDefined"
  }
}, numberOperators = {
  numberEqual: {
    nameKey: "search.operator.number-equal.name",
    descriptionKey: "search.operator.number-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberEqual"
  },
  numberGt: {
    nameKey: "search.operator.number-gt.name",
    descriptionKey: "search.operator.number-gt.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} > ${toJSON(value)}` : null,
    icon: GtIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberGt"
  },
  numberGte: {
    nameKey: "search.operator.number-gte.name",
    descriptionKey: "search.operator.number-gte.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} >= ${toJSON(value)}` : null,
    icon: GteIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberGte"
  },
  numberLt: {
    nameKey: "search.operator.number-lt.name",
    descriptionKey: "search.operator.number-lt.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} < ${toJSON(value)}` : null,
    icon: LtIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberLt"
  },
  numberLte: {
    nameKey: "search.operator.number-lte.name",
    descriptionKey: "search.operator.number-lte.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} <= ${toJSON(value)}` : null,
    icon: LteIcon,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberLte"
  },
  numberNotEqual: {
    nameKey: "search.operator.number-not-equal.name",
    descriptionKey: "search.operator.number-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value) && fieldPath ? `${fieldPath} != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterNumberInput,
    type: "numberNotEqual"
  },
  numberRange: {
    nameKey: "search.operator.number-range.name",
    descriptionKey: "search.operator.number-range.description",
    groqFilter: ({
      fieldPath,
      value
    }) => Number.isFinite(value?.to) && Number.isFinite(value?.from) && fieldPath ? `${fieldPath} > ${toJSON(value?.from)} && ${fieldPath} < ${toJSON(value?.to)}` : "",
    initialValue: null,
    inputComponent: SearchFilterNumberRangeInput,
    type: "numberRange"
  }
};
function SearchFilterStringInput(t0) {
  const $ = c(9), {
    onChange,
    value
  } = t0, {
    state: t1
  } = useSearchState(), {
    fullscreen
  } = t1, {
    t
  } = useTranslation();
  let t2;
  $[0] !== onChange ? (t2 = (event) => onChange(event.currentTarget.value || null), $[0] = onChange, $[1] = t2) : t2 = $[1];
  const handleChange = t2, t3 = fullscreen ? 2 : 1;
  let t4;
  $[2] !== t ? (t4 = t("search.filter-string-value-placeholder"), $[2] = t, $[3] = t4) : t4 = $[3];
  const t5 = value || "";
  let t6;
  return $[4] !== handleChange || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextInput$1, { fontSize: t3, onChange: handleChange, placeholder: t4, radius: 2, value: t5 }), $[4] = handleChange, $[5] = t3, $[6] = t4, $[7] = t5, $[8] = t6) : t6 = $[8], t6;
}
const portableTextOperators = {
  portableTextEqual: {
    nameKey: "search.operator.portable-text-equal.name",
    descriptionKey: "search.operator.portable-text-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `pt::text(${fieldPath}) == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "portableTextEqual"
  },
  portableTextMatches: {
    nameKey: "search.operator.portable-text-contains.name",
    descriptionKey: "search.operator.portable-text-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `pt::text(${fieldPath}) match ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "portableTextMatches"
  },
  portableTextNotEqual: {
    nameKey: "search.operator.portable-text-not-equal.name",
    descriptionKey: "search.operator.portable-text-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `pt::text(${fieldPath}) != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "portableTextNotEqual"
  },
  portableTextNotMatches: {
    nameKey: "search.operator.portable-text-not-contains.name",
    descriptionKey: "search.operator.portable-text-not-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `!(pt::text(${fieldPath}) match ${toJSON(value)})` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "portableTextNotMatches"
  }
}, referenceOperators = {
  referenceEqual: {
    nameKey: "search.operator.reference-equal.name",
    descriptionKey: "search.operator.reference-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}._ref == ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "referenceEqual"
  },
  referenceNotEqual: {
    nameKey: "search.operator.reference-not-equal.name",
    descriptionKey: "search.operator.reference-not-equal.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      fieldPath,
      value
    }) => value?._ref && fieldPath ? `${fieldPath}._ref != ${toJSON(value._ref)}` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "referenceNotEqual"
  },
  referencesAssetFile: {
    nameKey: "search.operator.reference-asset-file.name",
    descriptionKey: "search.operator.reference-asset-file.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      value
    }) => value?._ref ? `references(${toJSON(value._ref)})` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("file"),
    type: "referencesAssetFile"
  },
  referencesAssetImage: {
    nameKey: "search.operator.reference-asset-image.name",
    descriptionKey: "search.operator.reference-asset-image.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      value
    }) => value?._ref ? `references(${toJSON(value._ref)})` : null,
    initialValue: null,
    inputComponent: SearchFilterAssetInput("image"),
    type: "referencesAssetImage"
  },
  referencesDocument: {
    nameKey: "search.operator.reference-document.name",
    descriptionKey: "search.operator.reference-document.description",
    buttonValueComponent: SearchButtonValueReference,
    groqFilter: ({
      value
    }) => value?._ref ? `references(${toJSON(value._ref)})` : null,
    initialValue: null,
    inputComponent: SearchFilterReferenceInput,
    type: "referencesDocument"
  }
}, slugOperators = {
  slugEqual: {
    nameKey: "search.operator.slug-equal.name",
    descriptionKey: "search.operator.slug-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath}.current == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "slugEqual"
  },
  slugMatches: {
    nameKey: "search.operator.slug-contains.name",
    descriptionKey: "search.operator.slug-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath}.current match ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    label: "contains",
    type: "slugMatches"
  },
  slugNotEqual: {
    nameKey: "search.operator.slug-not-equal.name",
    descriptionKey: "search.operator.slug-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath}.current != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "slugNotEqual"
  },
  slugNotMatches: {
    nameKey: "search.operator.slug-not-contains.name",
    descriptionKey: "search.operator.slug-not-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `!(${fieldPath}.current match ${toJSON(value)})` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "slugNotMatches"
  }
}, stringOperators = {
  stringEqual: {
    nameKey: "search.operator.string-equal.name",
    descriptionKey: "search.operator.string-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "stringEqual"
  },
  stringListEqual: {
    nameKey: "search.operator.string-list-equal.name",
    descriptionKey: "search.operator.string-list-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} == ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringListInput,
    type: "stringListEqual"
  },
  stringListNotEqual: {
    nameKey: "search.operator.string-list-not-equal.name",
    descriptionKey: "search.operator.string-list-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringListInput,
    type: "stringListNotEqual"
  },
  stringMatches: {
    nameKey: "search.operator.string-contains.name",
    descriptionKey: "search.operator.string-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} match "*${value}*"` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "stringMatches"
  },
  stringNotEqual: {
    nameKey: "search.operator.string-not-equal.name",
    descriptionKey: "search.operator.string-not-equal.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `${fieldPath} != ${toJSON(value)}` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "stringNotEqual"
  },
  stringNotMatches: {
    nameKey: "search.operator.string-not-contains.name",
    descriptionKey: "search.operator.string-not-contains.description",
    groqFilter: ({
      fieldPath,
      value
    }) => value && fieldPath ? `!(${fieldPath} match "*${value}*")` : null,
    initialValue: null,
    inputComponent: SearchFilterStringInput,
    type: "stringNotMatches"
  }
}, searchOperators = {
  ...arrayOperators,
  ...assetOperators,
  ...booleanOperators,
  ...dateOperators,
  ...definedOperators,
  ...numberOperators,
  ...portableTextOperators,
  ...referenceOperators,
  ...slugOperators,
  ...stringOperators
}, operatorDefinitions = Object.values(searchOperators), canvasLocaleNamespace = "canvas", canvasUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: canvasLocaleNamespace,
  resources: () => import("./_chunks-es/resources4.mjs")
}, INITIAL_STATE$5 = {
  value: null,
  loading: !0
};
function useProjectOrganizationId() {
  const $ = c(2), projectStore = useProjectStore();
  let t0, t1;
  return $[0] !== projectStore ? (t1 = projectStore.getOrganizationId().pipe(map$1(_temp$U), startWith$1({
    value: null,
    loading: !0
  })), $[0] = projectStore, $[1] = t1) : t1 = $[1], t0 = t1, useObservable(t0, INITIAL_STATE$5);
}
function _temp$U(res) {
  return {
    value: res,
    loading: !1
  };
}
function useRenderingContext() {
  const renderingContextStore = useRenderingContextStore();
  return useObservable(renderingContextStore.renderingContext);
}
const CanvasLinkCtaClicked = defineEvent({
  name: "Canvas Link CTA Clicked",
  version: 1,
  description: 'The "Link to Canvas" button is clicked.'
}), CanvasLinkRedirected = defineEvent({
  name: "Canvas Link Redirected",
  version: 1,
  description: "The user is redirected to the canvas studio-import page"
}), CanvasLinkDialogDiffsShown = defineEvent({
  name: "Canvas Link Dialog Diffs Shown",
  version: 1,
  description: "The diffs dialog is shown"
}), CanvasLinkDialogRejected = defineEvent({
  name: "Canvas Link Dialog Rejected",
  version: 1,
  description: 'User clicked "Cancel" in the "Link to Canvas" dialog after seeing the diffs'
}), CanvasUnlinkCtaClicked = defineEvent({
  name: "Canvas Unlink CTA Clicked",
  version: 1,
  description: 'User clicked "Unlink" action'
}), CanvasUnlinkApproved = defineEvent({
  name: "Canvas Unlink Approved",
  version: 1,
  description: "User confirmed that they want the Studio document unlinked"
}), CanvasOpened = defineEvent({
  name: "Canvas Opened from studio",
  version: 1,
  description: 'User clicked "Edit in Canvas"'
}), getDiffTypesCount = (diffs) => diffs.reduce((acc, diff) => (acc[diff.type] = (acc[diff.type] || 0) + 1, acc), {});
function useCanvasTelemetry() {
  const $ = c(2), telemetry = useTelemetry();
  let t0, t1;
  return $[0] !== telemetry ? (t1 = {
    linkCtaClicked: () => telemetry.log(CanvasLinkCtaClicked),
    linkRedirected: (origin, diffs) => telemetry.log(CanvasLinkRedirected, {
      origin,
      diffs: diffs ? getDiffTypesCount(diffs) : void 0
    }),
    linkDialogDiffsShown: () => telemetry.log(CanvasLinkDialogDiffsShown),
    linkDialogRejected: (diffs_0) => telemetry.log(CanvasLinkDialogRejected, {
      diffs: getDiffTypesCount(diffs_0)
    }),
    unlinkCtaClicked: () => telemetry.log(CanvasUnlinkCtaClicked),
    unlinkApproved: () => telemetry.log(CanvasUnlinkApproved),
    canvasOpened: (origin_0) => telemetry.log(CanvasOpened, {
      origin: origin_0
    })
  }, $[0] = telemetry, $[1] = t1) : t1 = $[1], t0 = t1, t0;
}
const useNavigateToCanvasDoc = (canvasDocId, origin) => {
  const $ = c(10), {
    value: organizationId
  } = useProjectOrganizationId(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    node
  } = useComlinkStore(), isInDashboard = useRenderingContext()?.name === "coreUi", {
    canvasOpened
  } = useCanvasTelemetry(), toast = useToast(), {
    t
  } = useTranslation(canvasLocaleNamespace);
  let t0;
  return $[0] !== canvasDocId || $[1] !== canvasOpened || $[2] !== client || $[3] !== isInDashboard || $[4] !== node || $[5] !== organizationId || $[6] !== origin || $[7] !== t || $[8] !== toast ? (t0 = () => {
    if (canvasDocId)
      if (canvasOpened(origin), isInDashboard && node) {
        const message = {
          type: "dashboard/v1/bridge/navigate-to-resource",
          data: {
            resourceId: "",
            resourceType: "canvas",
            path: `doc/${canvasDocId}`
          }
        };
        node.post(message.type, message.data);
      } else {
        if (!organizationId) {
          toast.push({
            status: "error",
            title: t("navigate-to-canvas-doc.error.missing-permissions")
          });
          return;
        }
        const isStaging2 = client.config().apiHost === "https://api.sanity.work";
        window.open(`https://www.sanity.${isStaging2 ? "work" : "io"}/@${organizationId}/canvas/doc/${canvasDocId}`, "_blank");
      }
  }, $[0] = canvasDocId, $[1] = canvasOpened, $[2] = client, $[3] = isInDashboard, $[4] = node, $[5] = organizationId, $[6] = origin, $[7] = t, $[8] = toast, $[9] = t0) : t0 = $[9], t0;
}, useCanvasCompanionDoc = (documentId) => {
  const companionDocsStore = useCanvasCompanionDocsStore(), publishedId = getPublishedId(documentId), companionDocs$ = useMemo(() => companionDocsStore.getCompanionDocs(publishedId), [publishedId, companionDocsStore]), companionDocs = useObservable(companionDocs$), companionDoc = useMemo(() => companionDocs?.data.find((companion) => companion?.studioDocumentId === documentId), [companionDocs, documentId]);
  return {
    isLinked: !!companionDoc,
    companionDoc,
    loading: companionDocs?.loading
  };
}, EditInCanvasAction = (props2) => {
  const {
    t
  } = useTranslation(canvasLocaleNamespace), {
    isLinked,
    companionDoc,
    loading
  } = useCanvasCompanionDoc(props2.liveEditSchemaType ? getPublishedId(props2.id) : getDraftId(props2.id)), navigateToCanvas = useNavigateToCanvasDoc(companionDoc?.canvasDocumentId, "action");
  return !isLinked || loading ? null : {
    icon: ComposeSparklesIcon,
    label: t("action.edit-document"),
    onHandle: navigateToCanvas
  };
};
EditInCanvasAction.action = "editInCanvas";
EditInCanvasAction.displayName = "EditInCanvasAction";
const buildDocumentForDiffInput = (document2) => {
  const {
    _id,
    _rev,
    _createdAt,
    _updatedAt,
    ...rest
  } = JSON.parse(JSON.stringify(document2));
  return rest;
};
function DocumentDiff(t0) {
  const $ = c(22), {
    baseDocument,
    document: document2
  } = t0, schema2 = useSchema();
  let t1;
  $[0] !== document2._type || $[1] !== schema2 ? (t1 = schema2.get(document2._type), $[0] = document2._type, $[1] = schema2, $[2] = t1) : t1 = $[2];
  const schemaType = t1, {
    currentUser
  } = useSource();
  let t2, t3;
  $[3] !== baseDocument ? (t3 = baseDocument ?? {}, $[3] = baseDocument, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== currentUser?.id || $[6] !== document2 || $[7] !== t3 ? (t4 = diffInput(wrap$1(buildDocumentForDiffInput(t3), {
    author: currentUser?.id
  }), wrap$1(buildDocumentForDiffInput(document2), {
    author: currentUser?.id
  })), $[5] = currentUser?.id, $[6] = document2, $[7] = t3, $[8] = t4) : t4 = $[8], t2 = t4;
  const rootDiff = t2;
  let t5;
  $[9] !== document2._id ? (t5 = getPublishedId(document2._id), $[9] = document2._id, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== document2 || $[12] !== rootDiff || $[13] !== schemaType || $[14] !== t5 ? (t6 = {
    documentId: t5,
    schemaType,
    rootDiff,
    isComparingCurrent: !1,
    FieldWrapper: _temp$T,
    value: document2,
    showFromValue: !0
  }, $[11] = document2, $[12] = rootDiff, $[13] = schemaType, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== rootDiff || $[17] !== schemaType ? (t7 = /* @__PURE__ */ jsx(ChangeList, { diff: rootDiff, schemaType }), $[16] = rootDiff, $[17] = schemaType, $[18] = t7) : t7 = $[18];
  let t8;
  return $[19] !== t6 || $[20] !== t7 ? (t8 = /* @__PURE__ */ jsx(DocumentChangeContext.Provider, { value: t6, children: t7 }), $[19] = t6, $[20] = t7, $[21] = t8) : t8 = $[21], t8;
}
function _temp$T(props2) {
  return props2.children;
}
const ChipCard = styled(Card)((props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return css`
    --card-fg-color: ${color.button.ghost[props2.tone].enabled.fg};
  `;
}), VersionChip = (t0) => {
  const $ = c(13), {
    id: id2,
    showSparkles
  } = t0, documentVariantType = getDocumentVariantType(id2), badgeTitle = documentVariantType === "published" ? "Published" : "Draft", badgeTone = documentVariantType === "published" ? "positive" : "caution", t1 = documentVariantType === "published" ? "positive" : "caution";
  let t2;
  $[0] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ReleaseAvatarIcon, { tone: t1 }) }), $[0] = t1, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== badgeTitle ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: badgeTitle }), $[2] = badgeTitle, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== showSparkles ? (t4 = showSparkles && /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ComposeSparklesIcon, {}) }), $[4] = showSparkles, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t2 || $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t2,
    t3,
    t4
  ] }), $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== badgeTone || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(ChipCard, { tone: badgeTone, padding: 2, paddingRight: 3, radius: "full", children: t5 }), $[10] = badgeTone, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
};
function LinkToCanvasDiff(t0) {
  const $ = c(34), {
    originalDocument,
    mappedDocument
  } = t0, {
    t
  } = useTranslation(canvasLocaleNamespace);
  let t1, t2, t3, t4;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    opacity: 0
  }, t2 = {
    opacity: 1
  }, t3 = {
    opacity: 0
  }, t4 = {
    duration: 0.3
  }, $[0] = t1, $[1] = t2, $[2] = t3, $[3] = t4) : (t1 = $[0], t2 = $[1], t3 = $[2], t4 = $[3]);
  let t5;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 2, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[4] = t5) : t5 = $[4];
  let t6;
  $[5] !== t ? (t6 = t("dialog.confirm-document-changes.title"), $[5] = t, $[6] = t6) : t6 = $[6];
  let t7;
  $[7] !== t6 ? (t7 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t6 }) }), $[7] = t6, $[8] = t7) : t7 = $[8];
  let t8;
  $[9] !== t ? (t8 = t("dialog.confirm-document-changes.description"), $[9] = t, $[10] = t8) : t8 = $[10];
  let t9;
  $[11] !== t8 ? (t9 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t8 }) }), $[11] = t8, $[12] = t9) : t9 = $[12];
  let t10;
  $[13] !== t7 || $[14] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { tone: "critical", padding: 2, radius: 3, children: /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "flex-start", children: [
    t5,
    /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      t7,
      t9
    ] })
  ] }) }), $[13] = t7, $[14] = t9, $[15] = t10) : t10 = $[15];
  const t11 = originalDocument?._id || "";
  let t12;
  $[16] !== t11 ? (t12 = /* @__PURE__ */ jsx(VersionChip, { id: t11 }), $[16] = t11, $[17] = t12) : t12 = $[17];
  let t13;
  $[18] === Symbol.for("react.memo_cache_sentinel") ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 2, children: /* @__PURE__ */ jsx(ArrowRightIcon, {}) }), $[18] = t13) : t13 = $[18];
  const t14 = mappedDocument?._id || "";
  let t15;
  $[19] !== t14 ? (t15 = /* @__PURE__ */ jsx(VersionChip, { id: t14, showSparkles: !0 }), $[19] = t14, $[20] = t15) : t15 = $[20];
  let t16;
  $[21] !== t12 || $[22] !== t15 ? (t16 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t12,
    t13,
    t15
  ] }) }), $[21] = t12, $[22] = t15, $[23] = t16) : t16 = $[23];
  let t17;
  $[24] === Symbol.for("react.memo_cache_sentinel") ? (t17 = /* @__PURE__ */ jsx(Card, { borderBottom: !0 }), $[24] = t17) : t17 = $[24];
  let t18;
  $[25] !== mappedDocument || $[26] !== originalDocument ? (t18 = originalDocument && mappedDocument && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(DocumentDiff, { baseDocument: originalDocument, document: mappedDocument }) }), $[25] = mappedDocument, $[26] = originalDocument, $[27] = t18) : t18 = $[27];
  let t19;
  $[28] !== t16 || $[29] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Card, { radius: 3, border: !0, marginTop: 3, children: [
    t16,
    t17,
    t18
  ] }), $[28] = t16, $[29] = t18, $[30] = t19) : t19 = $[30];
  let t20;
  return $[31] !== t10 || $[32] !== t19 ? (t20 = /* @__PURE__ */ jsxs(motion.div, { initial: t1, animate: t2, exit: t3, transition: t4, children: [
    t10,
    t19
  ] }), $[31] = t10, $[32] = t19, $[33] = t20) : t20 = $[33], t20;
}
function createAppIdCache() {
  const appIdCache = {};
  return {
    get: async (args) => {
      const {
        projectId,
        appIdFetcher
      } = args;
      let cacheElement = appIdCache[projectId];
      return cacheElement || (cacheElement = (async () => {
        try {
          return await appIdFetcher(projectId);
        } catch (error) {
          console.error(error), appIdCache[projectId] = void 0;
          return;
        }
      })(), appIdCache[projectId] = cacheElement, cacheElement);
    }
  };
}
function AppIdCacheProvider(props2) {
  const $ = c(5), {
    children
  } = props2, parentCache = useContext(AppIdCacheContext);
  let t0, t1;
  $[0] !== parentCache ? (t1 = parentCache || createAppIdCache(), $[0] = parentCache, $[1] = t1) : t1 = $[1], t0 = t1;
  const cache2 = t0;
  let t2;
  return $[2] !== cache2 || $[3] !== children ? (t2 = /* @__PURE__ */ jsx(AppIdCacheContext.Provider, { value: cache2, children }), $[2] = cache2, $[3] = children, $[4] = t2) : t2 = $[4], t2;
}
function useAppIdCache() {
  const cache2 = useContext(AppIdCacheContext);
  if (!cache2)
    throw new Error("AppIdCache: missing context value. Ensure the component is wrapped in a AppIdCacheProvider.");
  return cache2;
}
async function checkStudioManifestExists(studioHostUrl) {
  const url = `${studioHostUrl}/static/create-manifest.json`;
  try {
    const response = await fetch(url, {
      method: "HEAD"
    });
    return response.status == 404 ? !1 : response.status > 299 ? (console.error(`Failed to get manifest from ${url}`, response), !1) : !0;
  } catch (e) {
    return console.error(`Failed to fetch from ${url}`, e), !1;
  }
}
const isStaging$2 = typeof __SANITY_STAGING__ < "u" && __SANITY_STAGING__ === !0, internalUrlSuffix = isStaging$2 ? "studio.sanity.work" : "sanity.studio";
async function fetchStudiosWithUrl(client, projectId, internalSuffix) {
  return (await client.request({
    method: "GET",
    url: `/projects/${projectId}/user-applications`
  })).map((app) => ({
    ...app,
    studioUrl: getStudioUrl(app, internalSuffix)
  }));
}
async function fetchCreateCompatibleAppId(args) {
  const {
    projectId,
    client,
    fallbackOrigin,
    internalSuffix = internalUrlSuffix,
    checkStudioManifest = checkStudioManifestExists,
    origin = window.location?.origin
  } = args, appsWithStudioUrl = await fetchStudiosWithUrl(client, projectId, internalSuffix), appMatchingOrigin = appsWithStudioUrl.find((app) => app && origin && app.studioUrl?.startsWith(origin));
  return appMatchingOrigin?.appHost && await checkStudioManifest(getStudioUrl(appMatchingOrigin, internalSuffix)) ? {
    appId: appMatchingOrigin.id,
    studioApps: appsWithStudioUrl
  } : {
    appId: appsWithStudioUrl.find((app) => app && fallbackOrigin && app.studioUrl?.startsWith(`https://${fallbackOrigin}`))?.id,
    studioApps: appsWithStudioUrl
  };
}
function getStudioUrl(app, internalSuffix) {
  return app.urlType === "internal" ? `https://${app.appHost}.${internalSuffix}` : app.appHost;
}
function useStudioAppIdStore(config) {
  const $ = c(9);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2024-09-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), cache2 = useAppIdCache(), {
    projectId
  } = useSource();
  let t1, t2;
  $[1] !== client || $[2] !== config.fallbackStudioOrigin ? (t2 = (pId) => fetchCreateCompatibleAppId({
    projectId: pId,
    client,
    fallbackOrigin: config.fallbackStudioOrigin
  }), $[1] = client, $[2] = config.fallbackStudioOrigin, $[3] = t2) : t2 = $[3], t1 = t2;
  const appIdFetcher = t1;
  let t3;
  return $[4] !== appIdFetcher || $[5] !== cache2 || $[6] !== config.enabled || $[7] !== projectId ? (t3 = {
    projectId,
    cache: cache2,
    appIdFetcher,
    enabled: config.enabled
  }, $[4] = appIdFetcher, $[5] = cache2, $[6] = config.enabled, $[7] = projectId, $[8] = t3) : t3 = $[8], useStudioAppIdStoreInner(t3);
}
function useStudioAppIdStoreInner(props2) {
  const {
    cache: cache2,
    enabled,
    appIdFetcher,
    projectId
  } = props2, [loading, setLoading] = useState(!1), [studioApp, setStudioApp] = useState();
  return useEffect(() => {
    let mounted = !0;
    async function getAppId() {
      if (projectId) {
        setLoading(!0);
        try {
          const entry = await cache2.get({
            projectId,
            appIdFetcher
          });
          mounted && setStudioApp(entry);
        } catch {
          mounted && setStudioApp(void 0);
        } finally {
          mounted && setLoading(!1);
        }
      }
    }
    return enabled && getAppId().catch(console.error), () => {
      mounted = !1, setLoading(!1);
    };
  }, [setLoading, appIdFetcher, cache2, enabled, projectId]), {
    loading,
    studioApp
  };
}
const useWorkspaceSchemaId = () => `_.schemas.${useWorkspace().name || "default"}`, localeSettings = Intl.DateTimeFormat().resolvedOptions(), initialState$1 = {
  status: "validating"
}, CANVAS_CLIENT_CONFIG = {
  apiVersion: "v2025-04-29"
}, canvasPreflight = ({
  client,
  document: document2,
  schemaId
}) => {
  const dataset = client.config().dataset;
  return client.observable.request({
    url: `/assist/studio-to-canvas/${dataset}`,
    tag: "sanity.canvas",
    method: "POST",
    body: {
      document: document2,
      schemaId,
      localeSettings: {
        locale: localeSettings.locale,
        timeZone: localeSettings.timeZone
      }
    }
  });
};
function useLinkToCanvas(t0) {
  const $ = c(25), {
    document: document2
  } = t0, workspace = useWorkspace(), projectStore = useProjectStore(), renderContext = useRenderingContext(), {
    node
  } = useComlinkStore(), isInDashboard = renderContext?.name === "coreUi", {
    linkRedirected,
    linkDialogDiffsShown
  } = useCanvasTelemetry(), t1 = workspace.apps?.canvas?.fallbackStudioOrigin;
  let t2;
  $[0] !== t1 ? (t2 = {
    enabled: !0,
    fallbackStudioOrigin: t1
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const {
    studioApp,
    loading: appIdLoading
  } = useStudioAppIdStore(t2), schemaId = useWorkspaceSchemaId(), client = useClient(CANVAS_CLIENT_CONFIG);
  let t3;
  bb0: {
    if (appIdLoading) {
      let t42;
      $[2] === Symbol.for("react.memo_cache_sentinel") ? (t42 = of({
        status: "validating"
      }), $[2] = t42) : t42 = $[2], t3 = t42;
      break bb0;
    }
    if (!studioApp?.appId) {
      let t42;
      $[3] === Symbol.for("react.memo_cache_sentinel") ? (t42 = of({
        status: "error",
        error: "Studio app not found, try deploying it or set the fallbackStudioOrigin"
      }), $[3] = t42) : t42 = $[3], t3 = t42;
      break bb0;
    }
    if (!document2?._id) {
      let t42;
      $[4] === Symbol.for("react.memo_cache_sentinel") ? (t42 = of({
        status: "missing-document-id",
        error: "Missing document ID"
      }), $[4] = t42) : t42 = $[4], t3 = t42;
      break bb0;
    }
    let t4;
    $[5] !== client || $[6] !== document2._id || $[7] !== document2._type || $[8] !== isInDashboard || $[9] !== node || $[10] !== projectStore || $[11] !== studioApp?.appId || $[12] !== workspace.name ? (t4 = () => {
      const dataset = client.config().dataset || "", projectId = client.config().projectId || "", path = `studio-import?${new URLSearchParams({
        projectId,
        dataset,
        documentType: document2._type,
        documentId: document2._id,
        workspaceName: workspace.name,
        applicationId: studioApp?.appId || ""
      }).toString()}`;
      if (isInDashboard && node) {
        const message = {
          type: "dashboard/v1/bridge/navigate-to-resource",
          data: {
            resourceId: "",
            resourceType: "canvas",
            path
          }
        };
        return of(() => node.post(message.type, message.data));
      }
      return projectStore.getOrganizationId().pipe(map$1((organizationId) => {
        if (!organizationId)
          return _temp$S;
        const canvasLinkUrl = `https://www.sanity.${client.config().apiHost === "https://api.sanity.work" ? "work" : "io"}/@${organizationId}/canvas/${path}`;
        return () => window.open(canvasLinkUrl, "_blank");
      }));
    }, $[5] = client, $[6] = document2._id, $[7] = document2._type, $[8] = isInDashboard, $[9] = node, $[10] = projectStore, $[11] = studioApp?.appId, $[12] = workspace.name, $[13] = t4) : t4 = $[13];
    const getNavigateToCanvas = t4;
    let t5;
    if ($[14] !== client || $[15] !== document2 || $[16] !== getNavigateToCanvas || $[17] !== linkDialogDiffsShown || $[18] !== linkRedirected || $[19] !== schemaId) {
      let t6;
      $[21] !== linkRedirected ? (t6 = (t72) => {
        const [preflight, navigateToCanvas] = t72;
        if (!preflight.error) {
          const status = preflight.diff?.length ? "diff" : "redirecting";
          return {
            status,
            error: null,
            response: preflight,
            navigateToCanvas: () => {
              linkRedirected(status === "diff" ? "diff-dialog" : "redirect", preflight.diff), navigateToCanvas();
            }
          };
        }
        return {
          status: "error",
          error: preflight.error,
          response: preflight,
          redirectUrl: void 0
        };
      }, $[21] = linkRedirected, $[22] = t6) : t6 = $[22];
      let t7;
      $[23] !== linkDialogDiffsShown ? (t7 = (t8) => {
        const {
          status: status_0,
          navigateToCanvas: navigateToCanvas_0
        } = t8;
        status_0 === "redirecting" && setTimeout(() => {
          navigateToCanvas_0();
        }, 1e3), status_0 === "diff" && linkDialogDiffsShown();
      }, $[23] = linkDialogDiffsShown, $[24] = t7) : t7 = $[24], t5 = combineLatest([canvasPreflight({
        client,
        document: document2,
        schemaId
      }), getNavigateToCanvas()]).pipe(map$1(t6), tap$1(t7), catchError$1(_temp2$h)), $[14] = client, $[15] = document2, $[16] = getNavigateToCanvas, $[17] = linkDialogDiffsShown, $[18] = linkRedirected, $[19] = schemaId, $[20] = t5;
    } else
      t5 = $[20];
    t3 = t5;
  }
  return useObservable(t3, initialState$1);
}
function _temp2$h(error) {
  return of({
    status: "error",
    error: error.message
  });
}
function _temp$S() {
}
const LinkToCanvasDialog = (t0) => {
  const $ = c(35), {
    document: document2,
    onClose
  } = t0, {
    t
  } = useTranslation(canvasLocaleNamespace), id2 = useId();
  let t1;
  $[0] !== document2 ? (t1 = {
    document: document2
  }, $[0] = document2, $[1] = t1) : t1 = $[1];
  const {
    status,
    error,
    navigateToCanvas,
    response
  } = useLinkToCanvas(t1), {
    linkDialogRejected
  } = useCanvasTelemetry();
  let t2;
  $[2] !== linkDialogRejected || $[3] !== onClose || $[4] !== response?.diff || $[5] !== status ? (t2 = () => {
    onClose(), status === "diff" && linkDialogRejected(response?.diff || []);
  }, $[2] = linkDialogRejected, $[3] = onClose, $[4] = response?.diff, $[5] = status, $[6] = t2) : t2 = $[6];
  const handleClose = t2, t3 = `dialog-link-to-canvas-${id2}`;
  let t4;
  $[7] !== t ? (t4 = t("dialog.link-to-canvas.title"), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== navigateToCanvas || $[10] !== onClose || $[11] !== status || $[12] !== t ? (t5 = status === "diff" ? {
    description: t("dialog.confirm-document-changes.footer-description"),
    confirmButton: {
      text: t("dialog.confirm-document-changes.confirm"),
      icon: ComposeSparklesIcon,
      tone: "default",
      onClick: navigateToCanvas,
      space: 2
    },
    cancelButton: {
      text: t("dialog.confirm-document-changes.cancel"),
      onClick: onClose
    }
  } : void 0, $[9] = navigateToCanvas, $[10] = onClose, $[11] = status, $[12] = t, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== status || $[15] !== t ? (t6 = (status === "validating" || status === "redirecting") && /* @__PURE__ */ jsx(Box, { paddingY: 5, children: /* @__PURE__ */ jsx(LoadingBlock, { title: t(status === "validating" ? "dialog.link-to-canvas.validating" : "dialog.link-to-canvas.redirecting"), showText: !0 }) }), $[14] = status, $[15] = t, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== error || $[18] !== status || $[19] !== t ? (t7 = (status === "error" || status === "missing-document-id") && /* @__PURE__ */ jsx(motion.div, { initial: {
    opacity: 0
  }, animate: {
    opacity: 1
  }, exit: {
    opacity: 0
  }, transition: {
    duration: 0.3
  }, children: /* @__PURE__ */ jsx(Card, { border: !0, tone: "critical", padding: 4, radius: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: error || t("dialog.link-to-canvas.error") }) }) }), $[17] = error, $[18] = status, $[19] = t, $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== document2 || $[22] !== response || $[23] !== status ? (t8 = status === "diff" && response && /* @__PURE__ */ jsx(LinkToCanvasDiff, { originalDocument: document2, mappedDocument: response.mappedDocument }), $[21] = document2, $[22] = response, $[23] = status, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] !== t6 || $[26] !== t7 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Box, { padding: 3, children: [
    t6,
    t7,
    t8
  ] }), $[25] = t6, $[26] = t7, $[27] = t8, $[28] = t9) : t9 = $[28];
  let t10;
  return $[29] !== handleClose || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t9 ? (t10 = /* @__PURE__ */ jsx(Dialog$1, { id: t3, header: t4, onClose: handleClose, width: 1, bodyHeight: "stretch", padding: !1, footer: t5, children: t9 }), $[29] = handleClose, $[30] = t3, $[31] = t4, $[32] = t5, $[33] = t9, $[34] = t10) : t10 = $[34], t10;
}, useIsExcludedType = (type) => {
  const $ = c(3), schema2 = useSchema();
  let t0;
  return $[0] !== schema2 || $[1] !== type ? (t0 = schema2.get(type)?.options?.sanityCreate?.exclude, $[0] = schema2, $[1] = type, $[2] = t0) : t0 = $[2], t0;
}, LinkToCanvasAction = (props2) => {
  const {
    t
  } = useTranslation(canvasLocaleNamespace), [isDialogOpen, setIsDialogOpen] = useState(!1), {
    selectedPerspective
  } = usePerspective(), {
    isLinked,
    loading
  } = useCanvasCompanionDoc(props2.liveEditSchemaType ? getPublishedId(props2.id) : getDraftId(props2.id)), {
    value: organizationId
  } = useProjectOrganizationId(), {
    linkCtaClicked
  } = useCanvasTelemetry(), isExcludedType = useIsExcludedType(props2.type), handleCloseDialog = useCallback(() => setIsDialogOpen(!1), []), isInDashboard = useRenderingContext()?.name === "coreUi", isVersionDocument = !!props2.release, getFormValue = useGetFormValue(), [formValue, setFormValue] = useState(), handleOpenDialog = useCallback(() => {
    linkCtaClicked();
    const value = getFormValue([]);
    setFormValue({
      ...value,
      _id: props2.liveEditSchemaType ? getPublishedId(value._id) : getDraftId(value._id)
    }), setIsDialogOpen(!0);
  }, [getFormValue, props2.liveEditSchemaType, linkCtaClicked]), disabled = useMemo(() => organizationId ? isInDashboard ? isVersionDocument ? {
    disabled: !0,
    reason: t("action.link-document-disabled.version-document")
  } : props2.initialValueResolved ? {
    disabled: !1,
    reason: void 0
  } : {
    disabled: !0,
    reason: t("action.link-document-disabled.initial-value-not-resolved")
  } : {
    disabled: !0,
    reason: t("action.link-document-disabled.not-in-dashboard")
  } : {
    disabled: !0,
    reason: t("action.link-document-disabled.missing-permissions")
  }, [isVersionDocument, t, props2.initialValueResolved, isInDashboard, organizationId]);
  return useEffect(() => {
    isLinked && handleCloseDialog();
  }, [isLinked, handleCloseDialog]), isLinked || loading || isExcludedType || selectedPerspective === "published" && !props2.liveEditSchemaType || isReleaseDocument(selectedPerspective) || !isInDashboard ? null : {
    disabled: disabled.disabled,
    icon: ComposeSparklesIcon,
    dialog: isDialogOpen && formValue ? {
      type: "custom",
      component: /* @__PURE__ */ jsx(LinkToCanvasDialog, { onClose: handleCloseDialog, document: formValue })
    } : void 0,
    label: t("action.link-document"),
    title: disabled.reason,
    onHandle: handleOpenDialog
  };
};
LinkToCanvasAction.action = "linkToCanvas";
LinkToCanvasAction.displayName = "LinkToCanvasAction";
const useDocumentTitle = (t0) => {
  const $ = c(11), {
    document: document2
  } = t0, schema2 = useSchema();
  let t1;
  $[0] !== document2._type || $[1] !== schema2 ? (t1 = schema2.get(document2._type), $[0] = document2._type, $[1] = schema2, $[2] = t1) : t1 = $[2];
  const schemaType = t1, t2 = !!document2;
  let t3;
  $[3] !== document2 || $[4] !== schemaType || $[5] !== t2 ? (t3 = {
    enabled: t2,
    schemaType,
    value: document2
  }, $[3] = document2, $[4] = schemaType, $[5] = t2, $[6] = t3) : t3 = $[6];
  const {
    error,
    value
  } = useDocumentPreview(t3);
  if (!schemaType) {
    let t42;
    return $[7] === Symbol.for("react.memo_cache_sentinel") ? (t42 = {
      error: "Schema type not found"
    }, $[7] = t42) : t42 = $[7], t42;
  }
  const t4 = value?.title;
  let t5;
  return $[8] !== error || $[9] !== t4 ? (t5 = {
    error,
    title: t4
  }, $[8] = error, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}, UnlinkFromCanvasDialog = (t0) => {
  const $ = c(50), {
    document: document2,
    onClose,
    status,
    error,
    handleUnlink
  } = t0, {
    t
  } = useTranslation(canvasLocaleNamespace), {
    t: coreT
  } = useTranslation();
  let t1;
  $[0] !== document2 ? (t1 = {
    document: document2
  }, $[0] = document2, $[1] = t1) : t1 = $[1];
  const {
    title
  } = useDocumentTitle(t1), t2 = `dialog-unlink-from-canvas-${useId()}`;
  let t3;
  $[2] !== t ? (t3 = t("dialog.unlink-from-canvas.title"), $[2] = t, $[3] = t3) : t3 = $[3];
  const t4 = status === "loading" ? void 0 : onClose;
  let t5;
  $[4] !== t ? (t5 = t("dialog.unlink-from-canvas.cancel"), $[4] = t, $[5] = t5) : t5 = $[5];
  const t6 = status != "idle";
  let t7;
  $[6] !== onClose || $[7] !== t5 || $[8] !== t6 ? (t7 = {
    text: t5,
    onClick: onClose,
    disabled: t6
  }, $[6] = onClose, $[7] = t5, $[8] = t6, $[9] = t7) : t7 = $[9];
  let t8;
  $[10] !== t ? (t8 = t("dialog.unlink-from-canvas.unlink-action"), $[10] = t, $[11] = t8) : t8 = $[11];
  const t9 = status === "loading", t10 = status != "idle";
  let t11;
  $[12] !== handleUnlink || $[13] !== t10 || $[14] !== t8 || $[15] !== t9 ? (t11 = {
    text: t8,
    onClick: handleUnlink,
    tone: "default",
    loading: t9,
    disabled: t10
  }, $[12] = handleUnlink, $[13] = t10, $[14] = t8, $[15] = t9, $[16] = t11) : t11 = $[16];
  let t12;
  $[17] !== t11 || $[18] !== t7 ? (t12 = {
    cancelButton: t7,
    confirmButton: t11
  }, $[17] = t11, $[18] = t7, $[19] = t12) : t12 = $[19];
  let t13;
  $[20] !== coreT || $[21] !== title ? (t13 = title || coreT("preview.default.title-fallback"), $[20] = coreT, $[21] = title, $[22] = t13) : t13 = $[22];
  let t14;
  $[23] !== t13 ? (t14 = {
    documentTitle: t13
  }, $[23] = t13, $[24] = t14) : t14 = $[24];
  let t15;
  $[25] !== t || $[26] !== t14 ? (t15 = /* @__PURE__ */ jsx(Box, { paddingBottom: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "dialog.unlink-from-canvas.unlinking", values: t14 }) }) }), $[25] = t, $[26] = t14, $[27] = t15) : t15 = $[27];
  let t16;
  $[28] !== t ? (t16 = t("dialog.unlink-from-canvas.description"), $[28] = t, $[29] = t16) : t16 = $[29];
  let t17;
  $[30] !== t16 ? (t17 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t16 }) }), $[30] = t16, $[31] = t17) : t17 = $[31];
  let t18;
  $[32] !== t15 || $[33] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t15,
    t17
  ] }), $[32] = t15, $[33] = t17, $[34] = t18) : t18 = $[34];
  let t19;
  $[35] !== error || $[36] !== status || $[37] !== t ? (t19 = status === "error" && /* @__PURE__ */ jsx(motion.div, { initial: {
    opacity: 0,
    scale: 0.9
  }, animate: {
    opacity: 1,
    scale: 1
  }, children: /* @__PURE__ */ jsx(Card, { tone: "critical", padding: 2, radius: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: error || t("dialog.unlink-from-canvas.error") }) }) }, "error"), $[35] = error, $[36] = status, $[37] = t, $[38] = t19) : t19 = $[38];
  let t20;
  $[39] !== t19 ? (t20 = /* @__PURE__ */ jsx(AnimatePresence, { children: t19 }), $[39] = t19, $[40] = t20) : t20 = $[40];
  let t21;
  $[41] !== t18 || $[42] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t18,
    t20
  ] }), $[41] = t18, $[42] = t20, $[43] = t21) : t21 = $[43];
  let t22;
  return $[44] !== t12 || $[45] !== t2 || $[46] !== t21 || $[47] !== t3 || $[48] !== t4 ? (t22 = /* @__PURE__ */ jsx(Dialog$1, { id: t2, header: t3, onClose: t4, bodyHeight: "stretch", footer: t12, children: t21 }), $[44] = t12, $[45] = t2, $[46] = t21, $[47] = t3, $[48] = t4, $[49] = t22) : t22 = $[49], t22;
}, UnlinkFromCanvasAction = (props2) => {
  const {
    t
  } = useTranslation(canvasLocaleNamespace), {
    isLinked,
    companionDoc,
    loading
  } = useCanvasCompanionDoc(props2.liveEditSchemaType ? getPublishedId(props2.id) : getDraftId(props2.id)), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    unlinkCtaClicked,
    unlinkApproved
  } = useCanvasTelemetry(), toast = useToast(), [isDialogOpen, setIsDialogOpen] = useState(!1), [status, setStatus] = useState("idle"), [error, setError] = useState(null), handleCloseDialog = useCallback(() => setIsDialogOpen(!1), []), handleOpenDialog = useCallback(() => {
    unlinkCtaClicked(), setIsDialogOpen(!0);
  }, [unlinkCtaClicked]), handleUnlink = useCallback(async () => {
    try {
      if (!companionDoc?._id)
        throw new Error("Companion doc not found");
      setStatus("loading"), unlinkApproved(), await client.delete(companionDoc?._id), setStatus("idle"), handleCloseDialog(), toast.push({
        status: "success",
        title: t("dialog.unlink-from-canvas.success")
      });
    } catch (e) {
      console.error(e), setError(e.message), setStatus("error");
    }
  }, [client, companionDoc?._id, handleCloseDialog, unlinkApproved, toast, t]), document2 = props2.version || props2.draft || props2.published;
  return !document2 || !isLinked || loading ? null : {
    icon: UnlinkIcon,
    dialog: isDialogOpen ? {
      type: "custom",
      component: /* @__PURE__ */ jsx(UnlinkFromCanvasDialog, { onClose: handleCloseDialog, document: document2, status, error, handleUnlink })
    } : void 0,
    label: t("action.unlink-document"),
    onHandle: handleOpenDialog
  };
};
UnlinkFromCanvasAction.action = "unlinkFromCanvas";
UnlinkFromCanvasAction.displayName = "UnlinkFromCanvasAction";
const CANVAS_INTEGRATION_NAME = "sanity/canvas-integration", canvasIntegration = definePlugin(() => ({
  name: CANVAS_INTEGRATION_NAME,
  i18n: {
    bundles: [canvasUsEnglishLocaleBundle]
  },
  document: {
    actions: (prev) => prev.flatMap((action) => action.action === "publish" ? [action, LinkToCanvasAction, UnlinkFromCanvasAction, EditInCanvasAction] : action)
  }
})), commentsLocaleNamespace = "comments", commentsUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: commentsLocaleNamespace,
  resources: () => import("./_chunks-es/resources.mjs")
};
function CommentsAuthoringPathProvider(props2) {
  const $ = c(6), {
    children
  } = props2, [authoringPath, setAuthoringPath] = useState(null);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = (nextAuthoringPath) => {
    setAuthoringPath(nextAuthoringPath);
  }, $[0] = t0) : t0 = $[0];
  const handleSetAuthoringPath = t0;
  let t1, t2;
  $[1] !== authoringPath ? (t2 = {
    authoringPath,
    setAuthoringPath: handleSetAuthoringPath
  }, $[1] = authoringPath, $[2] = t2) : t2 = $[2], t1 = t2;
  const value = t1;
  let t3;
  return $[3] !== children || $[4] !== value ? (t3 = /* @__PURE__ */ jsx(CommentsAuthoringPathContext.Provider, { value, children }), $[3] = children, $[4] = value, $[5] = t3) : t3 = $[5], t3;
}
function useCommentsIntent() {
  return useContext(CommentsIntentContext);
}
function useNotificationTarget(opts) {
  const {
    documentId,
    documentType,
    getCommentLink
  } = opts || {}, schemaType = useSchema().get(documentType), {
    title: workspaceTitle
  } = useWorkspace(), documentPreviewStore = useDocumentPreviewStore(), previewStateObservable = useMemo(() => !documentId || !schemaType ? of(null) : getPreviewStateObservable$1(documentPreviewStore, schemaType, documentId), [documentId, documentPreviewStore, schemaType]), previewState = useObservable(previewStateObservable), {
    snapshot: snapshot2,
    original
  } = previewState || {}, documentTitle = snapshot2?.title || original?.title || "Sanity document";
  return {
    getNotificationValue: useCallback(({
      commentId
    }) => ({
      documentTitle,
      url: getCommentLink?.(commentId),
      workspaceTitle
    }), [documentTitle, getCommentLink, workspaceTitle])
  };
}
function TelephoneInput(props2) {
  const $ = c(5), {
    schemaType,
    validationError,
    value,
    elementProps
  } = props2, t0 = value || "";
  let t1;
  return $[0] !== elementProps || $[1] !== schemaType.placeholder || $[2] !== t0 || $[3] !== validationError ? (t1 = /* @__PURE__ */ jsx(TextInput$1, { type: "tel", inputMode: "tel", customValidity: validationError, value: t0, placeholder: schemaType.placeholder, ...elementProps }), $[0] = elementProps, $[1] = schemaType.placeholder, $[2] = t0, $[3] = validationError, $[4] = t1) : t1 = $[4], t1;
}
function resolveConditionalProperty(property, context) {
  const {
    currentUser,
    document: document2,
    parent,
    value
  } = context;
  return typeof property == "boolean" || property === void 0 ? !!property : property({
    document: document2,
    parent,
    value,
    currentUser
  }) === !0;
}
function setAtPath(currentTree, path, value) {
  if (path.length === 0)
    return {
      ...currentTree || {},
      value
    };
  const [head, ...tail] = path, key = isKeySegment(head) ? head._key : String(head), children = currentTree?.children ?? {};
  return {
    value: currentTree?.value,
    children: {
      ...children,
      [key]: setAtPath(children[key] || {}, tail, value)
    }
  };
}
const MAX_FIELD_DEPTH = 20, AUTO_COLLAPSE_DEPTH = 3, ALL_FIELDS_GROUP = {
  name: "all-fields",
  title: "All fields",
  hidden: !1,
  i18n: {
    title: {
      key: "inputs.object.field-group-tabs.all-fields-title",
      ns: studioLocaleNamespace
    }
  }
}, idCache = /* @__PURE__ */ new WeakMap(), undefinedKey = {
  key: "GetIdUndefined"
}, nullKey = {
  key: "GetIdNull"
};
function getId(value) {
  switch (typeof value) {
    case "undefined":
      return getId(undefinedKey);
    case "function":
    case "object":
    case "symbol": {
      if (value === null) return getId(nullKey);
      const cached = idCache.get(value);
      if (cached) return cached;
      const id2 = nanoid();
      return idCache.set(value, id2), id2;
    }
    default:
      return `${value}`;
  }
}
function resolveCallbackState({
  value,
  parent,
  document: document2,
  currentUser,
  schemaType,
  level,
  property
}) {
  const context = {
    value,
    parent,
    document: document2,
    currentUser
  }, selfValue = resolveConditionalProperty(schemaType[property], context);
  if (selfValue || level === MAX_FIELD_DEPTH)
    return {
      value: selfValue
    };
  const children = {};
  if (schemaType.jsonType === "object") {
    const normalizedSchemaMembers = schemaType.fieldsets ? schemaType.fieldsets : schemaType.fields.map((field) => ({
      single: !0,
      field
    }));
    for (const fieldset of normalizedSchemaMembers) {
      if (fieldset.single) {
        const childResult = resolveCallbackState({
          currentUser,
          document: document2,
          parent: value,
          value: value?.[fieldset.field.name],
          schemaType: fieldset.field.type,
          level: level + 1,
          property
        });
        if (!childResult) continue;
        children[fieldset.field.name] = childResult;
        continue;
      }
      const fieldsetValue = resolveConditionalProperty(fieldset.hidden, context);
      fieldsetValue && (children[`fieldset:${fieldset.name}`] = {
        value: fieldsetValue
      });
      for (const field of fieldset.fields) {
        const childResult = resolveCallbackState({
          currentUser,
          document: document2,
          parent: value,
          value: value?.[field.name],
          schemaType: field.type,
          level: level + 1,
          property
        });
        childResult && (children[field.name] = childResult);
      }
    }
    for (const group2 of schemaType.groups ?? EMPTY_ARRAY$A)
      if (property in group2) {
        const groupResult = resolveConditionalProperty(group2[property], context);
        if (!groupResult) continue;
        children[`group:${group2.name}`] = {
          value: groupResult
        };
      }
  }
  if (schemaType.jsonType === "array" && Array.isArray(value) && value.every(isKeyedObject))
    for (const item of value) {
      const itemType = getItemType(schemaType, item);
      if (!itemType) continue;
      const childResult = resolveCallbackState({
        currentUser,
        document: document2,
        level: level + 1,
        value: item,
        parent: value,
        schemaType: itemType,
        property
      });
      childResult && (children[item._key] = childResult);
    }
  if (Object.keys(children).length) return {
    children
  };
}
function createCallbackResolver({
  property
}) {
  const stableTrue = {
    value: !0
  };
  let last2 = null;
  function callbackResult({
    currentUser,
    documentValue,
    schemaType,
    ...options
  }) {
    const hash2 = {
      currentUser: getId(currentUser),
      schemaType: getId(schemaType),
      document: getId(documentValue)
    }, serializedHash = JSON.stringify(hash2);
    if (property in options && options[property] === !0)
      return stableTrue;
    if (last2?.serializedHash === serializedHash) return last2.result;
    const result = immutableReconcile(last2?.result ?? null, resolveCallbackState({
      currentUser,
      document: documentValue,
      level: 0,
      parent: null,
      schemaType,
      value: documentValue,
      property
    }));
    return last2 = {
      result,
      serializedHash
    }, result;
  }
  return callbackResult;
}
function identity(t) {
  return t;
}
function createMemoizer({
  getPath,
  hashInput,
  decorator = identity
}) {
  const cache2 = /* @__PURE__ */ new Map();
  function memoizer(fn) {
    function memoizedFn(...args) {
      const path = toString(getPath(...args)), hashed = hashInput(...args), serializedHash = JSON.stringify(hashed), cached = cache2.get(path);
      if (serializedHash === cached?.serializedHash) return cached.result;
      const result = fn(...args);
      return cache2.set(path, {
        serializedHash,
        result
      }), result;
    }
    return decorator(memoizedFn);
  }
  return memoizer;
}
function getCollapsedWithDefaults(options = {}, level) {
  if (options?.collapsible === !1 || options?.collapsable === !1)
    return {
      collapsible: !1,
      collapsed: !1
    };
  const collapsed = (
    // eslint-disable-next-line no-nested-ternary
    typeof options?.collapsed == "boolean" ? options.collapsed : level >= AUTO_COLLAPSE_DEPTH ? !0 : void 0
  );
  return {
    collapsible: options?.collapsible === !0 || options?.collapsable === !0 || collapsed === !0 ? !0 : void 0,
    collapsed
  };
}
function isFieldEnabledByGroupFilter(groupsConfig, fieldGroup, selectedGroup) {
  return selectedGroup ? selectedGroup.name === ALL_FIELDS_GROUP.name ? !0 : fieldGroup === void 0 ? !1 : groupsConfig.length === 0 && selectedGroup.name === ALL_FIELDS_GROUP.name ? !0 : castArray(fieldGroup).includes(selectedGroup.name) : !1;
}
function isAcceptedObjectValue(value) {
  return typeof value > "u" || isRecord$4(value);
}
function isValidArrayOfObjectsValue(value) {
  return typeof value > "u" || Array.isArray(value);
}
function isValidArrayOfPrimitivesValue(value) {
  return typeof value > "u" || Array.isArray(value);
}
function everyItemIsObject(value) {
  return value.length === 0 || value.every((item) => isRecord$4(item));
}
function findDuplicateKeyEntries(array) {
  const seenKeys = /* @__PURE__ */ new Set();
  return array.reduce((acc, item, index) => (seenKeys.has(item._key) && acc.push([index, item._key]), seenKeys.add(item._key), acc), []);
}
function hasKey(value) {
  return "_key" in value;
}
function everyItemHasKey(array) {
  return array?.every((item) => isRecord$4(item) && hasKey(item));
}
function isChangedValue(value, comparisonValue) {
  return Array.isArray(value) && typeof comparisonValue > "u" || Array.isArray(comparisonValue) && typeof value > "u" ? !1 : value && !comparisonValue ? !0 : !isEqual$2(value, comparisonValue);
}
function createPrepareFormState({
  decorators = {}
} = {}) {
  const memoizePrepareFieldMember = createMemoizer({
    decorator: decorators.prepareFieldMember,
    getPath: ({
      parent,
      field
    }) => [...parent.path, field.name],
    hashInput: ({
      parent,
      field
    }) => {
      const path = [...parent.path, field.name];
      return {
        changesOpen: parent.changesOpen,
        presence: parent.presence.filter((p) => startsWith(path, p.path)),
        validation: parent.validation.filter((v) => startsWith(path, v.path)),
        focusPath: startsWith(path, parent.focusPath) ? parent.focusPath : [],
        openPath: startsWith(path, parent.openPath) ? parent.openPath : [],
        value: getId(parent.value?.[field.name]),
        comparisonValue: getId(parent.comparisonValue?.[field.name]),
        collapsedFieldSets: getId(parent.collapsedFieldSets?.children?.[field.name]),
        collapsedPaths: getId(parent.collapsedPaths?.children?.[field.name]),
        currentUser: getId(parent.currentUser),
        fieldGroupState: getId(parent.fieldGroupState),
        hidden: parent.hidden === !0 || parent.hidden?.value || getId(parent.hidden?.children?.[field.name]),
        readOnly: parent.readOnly === !0 || parent.readOnly?.value || getId(parent.readOnly?.children?.[field.name]),
        schemaType: getId(parent.schemaType)
      };
    }
  }), memoizePrepareObjectInputState = createMemoizer({
    decorator: decorators.prepareObjectInputState,
    getPath: ({
      path
    }) => path,
    hashInput: (state) => ({
      changesOpen: state.changesOpen,
      presence: state.presence.filter((p) => startsWith(state.path, p.path)),
      validation: state.validation.filter((v) => startsWith(state.path, v.path)),
      focusPath: startsWith(state.path, state.focusPath) ? state.focusPath : [],
      openPath: startsWith(state.path, state.openPath) ? state.openPath : [],
      value: getId(state.value),
      comparisonValue: getId(state.comparisonValue),
      collapsedFieldSets: getId(state.collapsedFieldSets),
      collapsedPaths: state.collapsedPaths,
      currentUser: getId(state.currentUser),
      fieldGroupState: getId(state.fieldGroupState),
      hidden: state.hidden === !0 || state.hidden?.value || getId(state.hidden),
      readOnly: state.readOnly === !0 || state.readOnly?.value || getId(state.readOnly),
      schemaType: getId(state.schemaType)
    })
  }), memoizePrepareArrayOfPrimitivesInputState = createMemoizer({
    decorator: decorators.prepareArrayOfPrimitivesInputState,
    getPath: ({
      path
    }) => path,
    hashInput: (state) => ({
      changesOpen: state.changesOpen,
      presence: state.presence.filter((p) => startsWith(state.path, p.path)),
      validation: state.validation.filter((v) => startsWith(state.path, v.path)),
      focusPath: startsWith(state.path, state.focusPath) ? state.focusPath : [],
      openPath: startsWith(state.path, state.openPath) ? state.openPath : [],
      value: getId(state.value),
      comparisonValue: getId(state.comparisonValue),
      collapsedFieldSets: getId(state.collapsedFieldSets),
      collapsedPaths: state.collapsedPaths,
      currentUser: getId(state.currentUser),
      fieldGroupState: getId(state.fieldGroupState),
      hidden: state.hidden === !0 || state.hidden?.value || getId(state.hidden),
      readOnly: state.readOnly === !0 || state.readOnly?.value || getId(state.readOnly),
      schemaType: getId(state.schemaType)
    })
  }), memoizePrepareArrayOfObjectsInputState = createMemoizer({
    decorator: decorators.prepareArrayOfObjectsInputState,
    getPath: ({
      path
    }) => path,
    hashInput: (state) => ({
      changesOpen: state.changesOpen,
      presence: state.presence.filter((p) => startsWith(state.path, p.path)),
      validation: state.validation.filter((v) => startsWith(state.path, v.path)),
      focusPath: startsWith(state.path, state.focusPath) ? state.focusPath : [],
      openPath: startsWith(state.path, state.openPath) ? state.openPath : [],
      value: getId(state.value),
      comparisonValue: getId(state.comparisonValue),
      collapsedFieldSets: getId(state.collapsedFieldSets),
      collapsedPaths: state.collapsedPaths,
      currentUser: getId(state.currentUser),
      fieldGroupState: getId(state.fieldGroupState),
      hidden: state.hidden === !0 || state.hidden?.value || getId(state.hidden),
      readOnly: state.readOnly === !0 || state.readOnly?.value || getId(state.readOnly),
      schemaType: getId(state.schemaType)
    })
  }), memoizePrepareArrayOfObjectsMember = createMemoizer({
    decorator: decorators.prepareArrayOfObjectsMember,
    getPath: ({
      parent,
      arrayItem
    }) => [...parent.path, {
      _key: arrayItem._key
    }],
    hashInput: ({
      parent,
      arrayItem
    }) => {
      const comparisonValue = Array.isArray(parent.comparisonValue) ? parent.comparisonValue.find((item) => isKeyedObject(item) && item._key === arrayItem._key) : void 0, key = arrayItem._key, path = [...parent.path, {
        _key: key
      }];
      return {
        changesOpen: parent.changesOpen,
        presence: parent.presence.filter((p) => startsWith(path, p.path)),
        validation: parent.validation.filter((v) => startsWith(path, v.path)),
        focusPath: startsWith(path, parent.focusPath) ? parent.focusPath : [],
        openPath: startsWith(path, parent.openPath) ? parent.openPath : [],
        value: getId(arrayItem),
        comparisonValue: getId(comparisonValue),
        collapsedFieldSets: getId(parent.collapsedFieldSets?.children?.[key]),
        collapsedPaths: getId(parent.collapsedPaths?.children?.[key]),
        currentUser: getId(parent.currentUser),
        fieldGroupState: getId(parent.fieldGroupState?.children?.[key]),
        hidden: parent.hidden === !0 || parent.hidden?.value || getId(parent.hidden?.children?.[key]),
        readOnly: parent.readOnly === !0 || parent.readOnly?.value || getId(parent.readOnly?.children?.[key]),
        schemaType: getId(parent.schemaType)
      };
    }
  }), memoizePrepareArrayOfPrimitivesMember = createMemoizer({
    decorator: decorators.prepareArrayOfPrimitivesMember,
    getPath: ({
      parent,
      index
    }) => [...parent.path, index],
    hashInput: ({
      parent,
      index,
      arrayItem
    }) => {
      const comparisonValue = Array.isArray(parent.comparisonValue) ? parent.comparisonValue[index] : void 0, path = [...parent.path, index];
      return {
        changesOpen: parent.changesOpen,
        presence: parent.presence.filter((p) => startsWith(path, p.path)),
        validation: parent.validation.filter((v) => startsWith(path, v.path)),
        focusPath: startsWith(path, parent.focusPath) ? parent.focusPath : [],
        openPath: startsWith(path, parent.openPath) ? parent.openPath : [],
        collapsedFieldSets: getId(parent.collapsedFieldSets?.children?.[index]),
        collapsedPaths: getId(parent.collapsedPaths?.children?.[index]),
        currentUser: getId(parent.currentUser),
        fieldGroupState: getId(parent.fieldGroupState?.children?.[index]),
        hidden: parent.hidden === !0 || parent.hidden?.value || getId(parent.hidden?.children?.[index]),
        readOnly: parent.readOnly === !0 || parent.readOnly?.value || getId(parent.readOnly?.children?.[index]),
        schemaType: getId(parent.schemaType),
        value: `${arrayItem}`,
        comparisonValue: `${comparisonValue}`
      };
    }
  }), memoizePreparePrimitiveInputState = createMemoizer({
    decorator: decorators.preparePrimitiveInputState,
    getPath: ({
      path
    }) => path,
    hashInput: (state) => ({
      changesOpen: state.changesOpen,
      presence: state.presence.filter((p) => startsWith(state.path, p.path)),
      validation: state.validation.filter((v) => startsWith(state.path, v.path)),
      focusPath: startsWith(state.path, state.focusPath) ? state.focusPath : [],
      openPath: startsWith(state.path, state.openPath) ? state.openPath : [],
      value: getId(state.value),
      comparisonValue: getId(state.comparisonValue),
      collapsedFieldSets: getId(state.collapsedFieldSets),
      collapsedPaths: state.collapsedPaths,
      currentUser: getId(state.currentUser),
      fieldGroupState: getId(state.fieldGroupState),
      hidden: state.hidden === !0 || state.hidden?.value || getId(state.hidden),
      readOnly: state.readOnly === !0 || state.readOnly?.value || getId(state.readOnly),
      schemaType: getId(state.schemaType)
    })
  }), prepareFieldMember = memoizePrepareFieldMember(function(props2) {
    const {
      field,
      index,
      parent
    } = props2, fieldPath = pathFor([...parent.path, field.name]), fieldLevel = getFieldLevel(field.type, parent.level + 1), parentValue = parent.value, parentComparisonValue = parent.comparisonValue;
    if (!isAcceptedObjectValue(parentValue))
      throw new Error("Unexpected non-object value");
    const normalizedFieldGroupNames = field.group ? castArray(field.group) : [], inSelectedGroup = isFieldEnabledByGroupFilter(parent.groups, field.group, parent.selectedGroup);
    if (isObjectSchemaType(field.type)) {
      const fieldValue = parentValue?.[field.name], fieldComparisonValue = isRecord$4(parentComparisonValue) ? parentComparisonValue?.[field.name] : void 0;
      if (!isAcceptedObjectValue(fieldValue))
        return {
          kind: "error",
          key: field.name,
          fieldName: field.name,
          error: {
            type: "INCOMPATIBLE_TYPE",
            expectedSchemaType: field.type,
            resolvedValueType: resolveTypeName$2(fieldValue),
            value: fieldValue
          }
        };
      if (parent.hidden === !0 || parent?.hidden?.value || parent.hidden?.children?.[field.name]?.value)
        return {
          kind: "hidden",
          key: `field-${field.name}`,
          name: field.name,
          index
        };
      const fieldGroupState = parent.fieldGroupState?.children?.[field.name], scopedCollapsedPaths = parent.collapsedPaths?.children?.[field.name], scopedCollapsedFieldsets = parent.collapsedFieldSets?.children?.[field.name], scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[field.name], inputState = prepareObjectInputState({
        schemaType: field.type,
        currentUser: parent.currentUser,
        value: fieldValue,
        changed: isChangedValue(fieldValue, fieldComparisonValue),
        comparisonValue: fieldComparisonValue,
        presence: parent.presence,
        validation: parent.validation,
        fieldGroupState,
        path: fieldPath,
        level: fieldLevel,
        focusPath: parent.focusPath,
        openPath: parent.openPath,
        collapsedPaths: scopedCollapsedPaths,
        collapsedFieldSets: scopedCollapsedFieldsets,
        hidden: scopedHidden,
        readOnly: scopedReadOnly,
        changesOpen: parent.changesOpen
      });
      if (inputState === null)
        return null;
      const defaultCollapsedState = getCollapsedWithDefaults(field.type.options, fieldLevel), collapsed = scopedCollapsedPaths ? scopedCollapsedPaths.value : defaultCollapsedState.collapsed;
      return {
        kind: "field",
        key: `field-${field.name}`,
        name: field.name,
        index,
        inSelectedGroup,
        groups: normalizedFieldGroupNames,
        open: startsWith(fieldPath, parent.openPath),
        field: inputState,
        collapsed,
        collapsible: defaultCollapsedState.collapsible
      };
    } else if (isArraySchemaType(field.type)) {
      const fieldValue = parentValue?.[field.name], fieldComparisonValue = isRecord$4(parentComparisonValue) ? parentComparisonValue?.[field.name] : void 0;
      if (isArrayOfObjectsSchemaType(field.type)) {
        const hasValue2 = typeof fieldValue < "u";
        if (hasValue2 && !isValidArrayOfObjectsValue(fieldValue)) {
          const resolvedValueType = resolveTypeName$2(fieldValue);
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            error: {
              type: "INCOMPATIBLE_TYPE",
              expectedSchemaType: field.type,
              resolvedValueType,
              value: fieldValue
            }
          };
        }
        if (hasValue2 && !everyItemIsObject(fieldValue))
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            error: {
              type: "MIXED_ARRAY",
              schemaType: field.type,
              value: fieldValue
            }
          };
        if (hasValue2 && !everyItemHasKey(fieldValue))
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            error: {
              type: "MISSING_KEYS",
              value: fieldValue,
              schemaType: field.type
            }
          };
        const duplicateKeyEntries = hasValue2 ? findDuplicateKeyEntries(fieldValue) : [];
        if (duplicateKeyEntries.length > 0)
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            error: {
              type: "DUPLICATE_KEYS",
              duplicates: duplicateKeyEntries,
              schemaType: field.type
            }
          };
        const fieldGroupState = parent.fieldGroupState?.children?.[field.name], scopedCollapsedPaths = parent.collapsedPaths?.children?.[field.name], scopedCollapsedFieldSets = parent.collapsedFieldSets?.children?.[field.name], scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[field.name], fieldState = prepareArrayOfObjectsInputState({
          schemaType: field.type,
          currentUser: parent.currentUser,
          value: fieldValue,
          changed: isChangedValue(fieldValue, fieldComparisonValue),
          comparisonValue: fieldComparisonValue,
          fieldGroupState,
          focusPath: parent.focusPath,
          openPath: parent.openPath,
          presence: parent.presence,
          validation: parent.validation,
          collapsedPaths: scopedCollapsedPaths,
          collapsedFieldSets: scopedCollapsedFieldSets,
          level: fieldLevel,
          path: fieldPath,
          readOnly: scopedReadOnly,
          hidden: scopedHidden,
          changesOpen: parent.changesOpen
        });
        return fieldState === null ? null : {
          kind: "field",
          key: `field-${field.name}`,
          name: field.name,
          index,
          open: startsWith(fieldPath, parent.openPath),
          inSelectedGroup,
          groups: normalizedFieldGroupNames,
          collapsible: !1,
          collapsed: !1,
          // note: this is what we actually end up passing down as to the next input component
          field: fieldState
        };
      } else {
        if (!isValidArrayOfPrimitivesValue(fieldValue)) {
          const resolvedValueType = resolveTypeName$2(fieldValue);
          return {
            kind: "error",
            key: field.name,
            fieldName: field.name,
            error: {
              type: "INCOMPATIBLE_TYPE",
              expectedSchemaType: field.type,
              resolvedValueType,
              value: fieldValue
            }
          };
        }
        const fieldGroupState = parent.fieldGroupState?.children?.[field.name], scopedCollapsedPaths = parent.collapsedPaths?.children?.[field.name], scopedCollapsedFieldSets = parent.collapsedFieldSets?.children?.[field.name], scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[field.name], fieldState = prepareArrayOfPrimitivesInputState({
          changed: isChangedValue(fieldValue, fieldComparisonValue),
          comparisonValue: fieldComparisonValue,
          schemaType: field.type,
          currentUser: parent.currentUser,
          value: fieldValue,
          fieldGroupState,
          focusPath: parent.focusPath,
          openPath: parent.openPath,
          presence: parent.presence,
          validation: parent.validation,
          collapsedPaths: scopedCollapsedPaths,
          collapsedFieldSets: scopedCollapsedFieldSets,
          level: fieldLevel,
          path: fieldPath,
          readOnly: scopedReadOnly,
          hidden: scopedHidden,
          changesOpen: parent.changesOpen
        });
        return fieldState === null ? null : {
          kind: "field",
          key: `field-${field.name}`,
          name: field.name,
          index,
          inSelectedGroup,
          groups: normalizedFieldGroupNames,
          open: startsWith(fieldPath, parent.openPath),
          // todo: consider support for collapsible arrays
          collapsible: !1,
          collapsed: !1,
          // note: this is what we actually end up passing down as to the next input component
          field: fieldState
        };
      }
    } else {
      const fieldValue = parentValue?.[field.name], fieldComparisonValue = isRecord$4(parentComparisonValue) ? parentComparisonValue?.[field.name] : void 0;
      if (parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name]?.value)
        return null;
      const scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[field.name], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[field.name], fieldState = preparePrimitiveInputState({
        ...parent,
        comparisonValue: fieldComparisonValue,
        value: fieldValue,
        schemaType: field.type,
        path: fieldPath,
        readOnly: scopedReadOnly,
        hidden: scopedHidden
      });
      return {
        kind: "field",
        key: `field-${field.name}`,
        name: field.name,
        index,
        open: startsWith(fieldPath, parent.openPath),
        inSelectedGroup,
        groups: normalizedFieldGroupNames,
        // todo: consider support for collapsible primitive fields
        collapsible: !1,
        collapsed: !1,
        field: fieldState
      };
    }
  }), prepareObjectInputState = memoizePrepareObjectInputState(function(props2, enableHiddenCheck = !0) {
    if (props2.level === MAX_FIELD_DEPTH)
      return null;
    const readOnly = props2.readOnly === !0 || props2.readOnly?.value, schemaTypeGroupConfig = props2.schemaType.groups || [], defaultGroupName = (schemaTypeGroupConfig.find((g) => g.default) || ALL_FIELDS_GROUP)?.name, groups = [ALL_FIELDS_GROUP, ...schemaTypeGroupConfig].flatMap((group2) => {
      const groupHidden = props2.hidden === !0 || props2.hidden?.value || props2.hidden?.children?.[`group:${group2.name}`]?.value, isSelected = group2.name === (props2.fieldGroupState?.value || defaultGroupName), selected = props2.changesOpen ? group2.name === ALL_FIELDS_GROUP.name : isSelected, disabled = props2.changesOpen ? !selected : !1;
      return groupHidden ? [] : [{
        disabled,
        icon: group2?.icon,
        name: group2.name,
        selected,
        title: group2.title,
        i18n: group2.i18n
      }];
    }), selectedGroup = groups.find((group2) => group2.selected), members = (props2.schemaType.fieldsets ? props2.schemaType.fieldsets : props2.schemaType.fields.map((field) => ({
      single: !0,
      field
    }))).flatMap((fieldSet, index) => {
      if (fieldSet.single) {
        const field = fieldSet.field, fieldMember = prepareFieldMember({
          field,
          parent: {
            ...props2,
            groups,
            selectedGroup
          },
          index
        });
        return fieldMember ? [fieldMember] : [];
      }
      const fieldsetHidden = props2.hidden === !0 || props2.hidden?.value || props2.hidden?.children?.[`fieldset:${fieldSet.name}`]?.value, fieldsetMembers = fieldSet.fields.flatMap((field) => {
        if (fieldsetHidden)
          return [{
            kind: "hidden",
            key: `field-${field.name}`,
            name: field.name,
            index
          }];
        const fieldMember = prepareFieldMember({
          field,
          parent: {
            ...props2,
            groups,
            selectedGroup
          },
          index
        });
        return fieldMember ? [fieldMember] : [];
      }), defaultCollapsedState = getCollapsedWithDefaults(fieldSet.options, props2.level), collapsed = (props2.collapsedFieldSets?.children || {})[fieldSet.name]?.value ?? defaultCollapsedState.collapsed;
      return [{
        kind: "fieldSet",
        key: `fieldset-${fieldSet.name}`,
        _inSelectedGroup: isFieldEnabledByGroupFilter(groups, fieldSet.group, selectedGroup),
        groups: fieldSet.group ? castArray(fieldSet.group) : [],
        fieldSet: {
          path: pathFor(props2.path.concat(fieldSet.name)),
          name: fieldSet.name,
          title: fieldSet.title,
          description: fieldSet.description,
          hidden: !1,
          level: props2.level + 1,
          members: fieldsetMembers.filter((member) => member.kind !== "hidden"),
          collapsible: defaultCollapsedState?.collapsible,
          collapsed,
          columns: fieldSet?.options?.columns
        }
      }];
    }), hasFieldGroups = schemaTypeGroupConfig.length > 0, filteredPresence = props2.presence.filter((item) => isEqual$3(item.path, props2.path)), presence = filteredPresence.length ? filteredPresence : EMPTY_ARRAY$A, validation2 = props2.validation.filter((item) => isEqual$3(item.path, props2.path)).map((v) => ({
      level: v.level,
      message: v.message,
      path: v.path
    })), visibleMembers = members.filter((member) => member.kind !== "hidden");
    if (visibleMembers.length === 0 && enableHiddenCheck)
      return null;
    const visibleGroups = hasFieldGroups ? groups.flatMap((group2) => group2.name === ALL_FIELDS_GROUP.name || visibleMembers.some((member) => member.kind === "error" ? !1 : member.kind === "field" ? member.groups.includes(group2.name) : member.groups.includes(group2.name) || member.fieldSet.members.some((fieldsetMember) => fieldsetMember.kind !== "error" && fieldsetMember.groups.includes(group2.name))) ? group2 : []) : [], filtereredMembers = visibleMembers.flatMap((member) => {
      if (member.kind === "error")
        return [member];
      if (member.kind === "field")
        return member.inSelectedGroup ? [member] : [];
      const filteredFieldsetMembers = member.fieldSet.members.filter((fieldsetMember) => fieldsetMember.kind !== "field" || fieldsetMember.inSelectedGroup);
      return filteredFieldsetMembers.length > 0 ? [{
        ...member,
        fieldSet: {
          ...member.fieldSet,
          members: filteredFieldsetMembers
        }
      }] : [];
    }), node = {
      value: props2.value,
      changed: isChangedValue(props2.value, props2.comparisonValue),
      schemaType: props2.schemaType,
      readOnly,
      path: props2.path,
      id: toString(props2.path),
      level: props2.level,
      focused: isEqual$3(props2.path, props2.focusPath),
      focusPath: trimChildPath$1(props2.path, props2.focusPath),
      presence,
      validation: validation2,
      // this is currently needed by getExpandOperations which needs to know about hidden members
      // (e.g. members not matching current group filter) in order to determine what to expand
      members: filtereredMembers,
      groups: visibleGroups
    };
    return Object.defineProperty(node, "_allMembers", {
      value: members,
      enumerable: !1
    }), node;
  }), prepareArrayOfPrimitivesInputState = memoizePrepareArrayOfPrimitivesInputState(function(props2) {
    if (props2.level === MAX_FIELD_DEPTH || props2.hidden === !0 || props2.hidden?.value)
      return null;
    const items = Array.isArray(props2.value) ? props2.value : [], filteredPresence = props2.presence.filter((item) => isEqual$3(item.path, props2.path)), presence = filteredPresence.length ? filteredPresence : EMPTY_ARRAY$A, validation2 = props2.validation.filter((item) => isEqual$3(item.path, props2.path)).map((v) => ({
      level: v.level,
      message: v.message,
      path: v.path
    })), members = items.flatMap((item, index) => prepareArrayOfPrimitivesMember({
      arrayItem: item,
      parent: props2,
      index
    }));
    return {
      // checks for changes not only on the array itself, but also on any of its items
      changed: props2.changed || members.some((m) => m.kind === "item" && m.item.changed),
      value: props2.value,
      readOnly: props2.readOnly === !0 || props2.readOnly?.value,
      schemaType: props2.schemaType,
      focused: isEqual$3(props2.path, props2.focusPath),
      focusPath: trimChildPath$1(props2.path, props2.focusPath),
      path: props2.path,
      id: toString(props2.path),
      level: props2.level,
      validation: validation2,
      presence,
      members
    };
  }), prepareArrayOfObjectsInputState = memoizePrepareArrayOfObjectsInputState(function(props2) {
    if (props2.level === MAX_FIELD_DEPTH || props2.hidden === !0 || props2.hidden?.value)
      return null;
    const items = Array.isArray(props2.value) ? props2.value : [], filteredPresence = props2.presence.filter((item) => isEqual$3(item.path, props2.path)), presence = filteredPresence.length ? filteredPresence : EMPTY_ARRAY$A, validation2 = props2.validation.filter((item) => isEqual$3(item.path, props2.path)).map((v) => ({
      level: v.level,
      message: v.message,
      path: v.path
    })), members = items.flatMap((item, index) => prepareArrayOfObjectsMember({
      arrayItem: item,
      parent: props2,
      index
    }));
    return {
      // checks for changes not only on the array itself, but also on any of its items
      changed: props2.changed || members.some((m) => m.kind === "item" && m.item.changed),
      value: props2.value,
      readOnly: props2.readOnly === !0 || props2.readOnly?.value,
      schemaType: props2.schemaType,
      focused: isEqual$3(props2.path, props2.focusPath),
      focusPath: trimChildPath$1(props2.path, props2.focusPath),
      path: props2.path,
      id: toString(props2.path),
      level: props2.level,
      validation: validation2,
      presence,
      members
    };
  }), prepareArrayOfObjectsMember = memoizePrepareArrayOfObjectsMember(function(props2) {
    const {
      arrayItem,
      parent,
      index
    } = props2, itemType = getItemType(parent.schemaType, arrayItem), key = arrayItem._key;
    if (!itemType) {
      const itemTypeName = resolveTypeName$2(arrayItem);
      return {
        kind: "error",
        key,
        index,
        error: {
          type: "INVALID_ITEM_TYPE",
          resolvedValueType: itemTypeName,
          value: arrayItem,
          validTypes: parent.schemaType.of
        }
      };
    }
    const itemPath = pathFor([...parent.path, {
      _key: key
    }]), itemLevel = parent.level + 1, fieldGroupState = parent.fieldGroupState?.children?.[key], scopedCollapsedPaths = parent.collapsedPaths?.children?.[key], scopedCollapsedFieldsets = parent.collapsedFieldSets?.children?.[key], scopedHidden = parent.hidden === !0 || parent.hidden?.value || parent.hidden?.children?.[key], scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[key], comparisonValue = Array.isArray(parent.comparisonValue) && parent.comparisonValue.find((i) => i._key === arrayItem._key) || void 0, itemState = prepareObjectInputState({
      schemaType: itemType,
      level: itemLevel,
      value: arrayItem,
      comparisonValue,
      changed: isChangedValue(arrayItem, comparisonValue),
      path: itemPath,
      focusPath: parent.focusPath,
      openPath: parent.openPath,
      currentUser: parent.currentUser,
      collapsedPaths: scopedCollapsedPaths,
      collapsedFieldSets: scopedCollapsedFieldsets,
      presence: parent.presence,
      validation: parent.validation,
      fieldGroupState,
      readOnly: scopedReadOnly,
      hidden: scopedHidden
    }, !1), defaultCollapsedState = getCollapsedWithDefaults(itemType.options, itemLevel), collapsed = scopedCollapsedPaths?.value ?? defaultCollapsedState.collapsed;
    return {
      kind: "item",
      key,
      index,
      open: startsWith(itemPath, parent.openPath),
      collapsed,
      collapsible: !0,
      parentSchemaType: parent.schemaType,
      item: itemState
    };
  }), prepareArrayOfPrimitivesMember = memoizePrepareArrayOfPrimitivesMember(function(props2) {
    const {
      arrayItem,
      parent,
      index
    } = props2, itemType = getPrimitiveItemType(parent.schemaType, arrayItem), itemPath = pathFor([...parent.path, index]), itemValue = parent.value?.[index], itemComparisonValue = parent.comparisonValue?.[index], itemLevel = parent.level + 1, key = `${itemType?.name || "invalid-type"}-${String(index)}`;
    if (!itemType)
      return {
        kind: "error",
        key,
        index,
        error: {
          type: "INVALID_ITEM_TYPE",
          validTypes: parent.schemaType.of,
          resolvedValueType: resolveTypeName$2(itemType),
          value: itemValue
        }
      };
    const scopedReadOnly = parent.readOnly === !0 || parent.readOnly?.value || parent.readOnly?.children?.[index], item = preparePrimitiveInputState({
      ...parent,
      path: itemPath,
      schemaType: itemType,
      level: itemLevel,
      value: itemValue,
      comparisonValue: itemComparisonValue,
      readOnly: scopedReadOnly
    });
    return {
      kind: "item",
      key,
      index,
      parentSchemaType: parent.schemaType,
      open: isEqual$3(itemPath, parent.openPath),
      item
    };
  }), preparePrimitiveInputState = memoizePreparePrimitiveInputState(function(props2) {
    const filteredPresence = props2.presence.filter((item) => isEqual$3(item.path, props2.path)), presence = filteredPresence.length ? filteredPresence : EMPTY_ARRAY$A, validation2 = props2.validation.filter((item) => isEqual$3(item.path, props2.path)).map((v) => ({
      level: v.level,
      message: v.message,
      path: v.path
    }));
    return {
      schemaType: props2.schemaType,
      changed: isChangedValue(props2.value, props2.comparisonValue),
      value: props2.value,
      level: props2.level,
      id: toString(props2.path),
      readOnly: props2.readOnly === !0 || props2.readOnly?.value,
      focused: isEqual$3(props2.path, props2.focusPath),
      path: props2.path,
      presence,
      validation: validation2
    };
  });
  function prepareFormState({
    collapsedFieldSets,
    collapsedPaths,
    comparisonValue,
    currentUser,
    documentValue,
    fieldGroupState,
    focusPath,
    hidden,
    openPath,
    presence,
    readOnly,
    schemaType,
    validation: validation2,
    changesOpen
  }) {
    return prepareObjectInputState({
      collapsedFieldSets,
      collapsedPaths,
      comparisonValue,
      currentUser,
      value: documentValue,
      fieldGroupState,
      focusPath,
      hidden: hidden === !1 ? EMPTY_OBJECT : hidden,
      openPath,
      presence,
      readOnly: readOnly === !1 ? EMPTY_OBJECT : readOnly,
      schemaType,
      validation: validation2,
      changesOpen,
      level: 0,
      path: []
    });
  }
  return prepareFormState._prepareFieldMember = prepareFieldMember, prepareFormState._prepareFieldMember = prepareFieldMember, prepareFormState._prepareObjectInputState = prepareObjectInputState, prepareFormState._prepareArrayOfPrimitivesInputState = prepareArrayOfPrimitivesInputState, prepareFormState._prepareArrayOfObjectsInputState = prepareArrayOfObjectsInputState, prepareFormState._prepareArrayOfObjectsMember = prepareArrayOfObjectsMember, prepareFormState._prepareArrayOfPrimitivesMember = prepareArrayOfPrimitivesMember, prepareFormState._preparePrimitiveInputState = preparePrimitiveInputState, prepareFormState;
}
function useFormState({
  comparisonValue,
  documentValue,
  fieldGroupState,
  collapsedFieldSets,
  collapsedPaths,
  focusPath,
  openPath,
  presence,
  validation: validation2,
  readOnly: inputReadOnly,
  changesOpen,
  schemaType
}) {
  const currentUser = useCurrentUser(), [prepareHiddenState] = useState(() => createCallbackResolver({
    property: "hidden"
  })), [prepareReadOnlyState] = useState(() => createCallbackResolver({
    property: "readOnly"
  })), [prepareFormState] = useState(() => createPrepareFormState()), [reconcileFieldGroupState] = useState(() => {
    let last2;
    return (state) => {
      const result = immutableReconcile(last2 ?? null, state);
      return last2 = result, result;
    };
  }), reconciledFieldGroupState = useMemo(() => reconcileFieldGroupState(fieldGroupState), [fieldGroupState, reconcileFieldGroupState]), [reconcileCollapsedPaths] = useState(() => {
    let last_0;
    return (state_0) => {
      const result_0 = immutableReconcile(last_0 ?? null, state_0);
      return last_0 = result_0, result_0;
    };
  }), reconciledCollapsedPaths = useMemo(() => reconcileCollapsedPaths(collapsedPaths), [collapsedPaths, reconcileCollapsedPaths]), [reconcileCollapsedFieldsets] = useState(() => {
    let last_1;
    return (state_1) => {
      const result_1 = immutableReconcile(last_1 ?? null, state_1);
      return last_1 = result_1, result_1;
    };
  }), reconciledCollapsedFieldsets = useMemo(() => reconcileCollapsedFieldsets(collapsedFieldSets), [collapsedFieldSets, reconcileCollapsedFieldsets]), {
    hidden,
    readOnly
  } = useMemo(() => ({
    hidden: prepareHiddenState({
      currentUser,
      documentValue,
      schemaType
    }),
    readOnly: prepareReadOnlyState({
      currentUser,
      documentValue,
      schemaType,
      readOnly: inputReadOnly
    })
  }), [prepareHiddenState, currentUser, documentValue, schemaType, prepareReadOnlyState, inputReadOnly]);
  return useMemo(() => prepareFormState({
    schemaType,
    fieldGroupState: reconciledFieldGroupState,
    collapsedFieldSets: reconciledCollapsedFieldsets,
    collapsedPaths: reconciledCollapsedPaths,
    documentValue,
    comparisonValue,
    focusPath,
    openPath,
    readOnly,
    hidden,
    currentUser,
    presence,
    validation: validation2,
    changesOpen
  }), [prepareFormState, schemaType, reconciledFieldGroupState, reconciledCollapsedFieldsets, reconciledCollapsedPaths, documentValue, comparisonValue, focusPath, openPath, readOnly, hidden, currentUser, presence, validation2, changesOpen]);
}
function isObjectFormNode(formNode) {
  return isObjectSchemaType(formNode.schemaType);
}
function isArrayOfObjectsFormNode(formNode) {
  return isArrayOfObjectsSchemaType(formNode.schemaType);
}
function hasAllMembers(value) {
  return "_allMembers" in value && Array.isArray(value._allMembers);
}
function getExpandOperations(node, path) {
  return [
    // make sure to expand all intermediate paths
    ...path.map((p, i) => ({
      type: "expandPath",
      path: path.slice(0, i + 1)
    })),
    // make sure to expand all fieldsets and selects the groups that includes the intermediate nodes
    ...getFieldsetAndFieldGroupOperations(node, path)
  ];
}
function getFieldsetAndFieldGroupOperations(node, path) {
  return path.length === 0 ? [] : isObjectFormNode(node) && hasAllMembers(node) ? getObjectFieldsetAndFieldGroupOperations(node, path) : isArrayOfObjectsFormNode(node) ? getArrayFieldsetAndFieldGroupOperations(node, path) : [];
}
function getObjectFieldsetAndFieldGroupOperations(node, path) {
  if (path.length === 0)
    return [];
  const [fieldName, ...tail] = path, fieldsetMember = node._allMembers.find((member) => member.kind === "fieldSet" && member.fieldSet.members.some((field) => field.kind === "field" && field.name === fieldName)), fieldMember = (fieldsetMember ? fieldsetMember.fieldSet.members : (
    // Note: we need to use the internal `_allMembers` array here instead of members since hidden/collapsed members are omitted from members
    node._allMembers
  )).find((member) => member !== null && member.kind === "field" && member.name === fieldName), schemaField = node.schemaType.fields.find((field) => field.name === fieldName), selectedGroupName = node.groups.find((group2) => group2.selected)?.name, schemaFieldGroup = schemaField && castArray(schemaField.group) || [], inSelectedGroup = selectedGroupName && (selectedGroupName === ALL_FIELDS_GROUP.name || schemaFieldGroup.includes(selectedGroupName)), ops = [];
  if (!inSelectedGroup) {
    const groupName = node.groups.find((group2) => schemaFieldGroup.includes(group2.name))?.name || ALL_FIELDS_GROUP.name;
    ops.push({
      type: "setSelectedGroup",
      path: node.path,
      groupName
    });
  }
  return fieldsetMember && ops.push({
    type: "expandFieldSet",
    path: fieldsetMember.fieldSet.path
  }), fieldMember && hasAllMembers(fieldMember.field) && (isMemberArrayOfObjects(fieldMember) ? ops.push(...getArrayFieldsetAndFieldGroupOperations(fieldMember.field, tail)) : isMemberObject(fieldMember) && ops.push(...getObjectFieldsetAndFieldGroupOperations(fieldMember.field, tail))), ops;
}
function getArrayFieldsetAndFieldGroupOperations(state, path) {
  if (path.length === 0)
    return [];
  const [segment, ...rest] = path;
  if (!isKeySegment(segment))
    throw new Error("Expected path segment to be an object with a _key property");
  const foundMember = state.members.find((member) => member.key === segment._key);
  return foundMember ? getFieldsetAndFieldGroupOperations(foundMember.item, rest) : [];
}
function getSanityCreateLinkMetadata(doc) {
  return doc?._create;
}
function isSanityCreateLinked(metadata) {
  return metadata?.ejected === !1;
}
function isSanityCreateLinkedDocument(doc) {
  return isSanityCreateLinked(getSanityCreateLinkMetadata(doc));
}
function isSanityCreateExcludedType(schemaType) {
  const options = schemaType.options;
  return typeof options?.sanityCreate?.exclude == "boolean" ? options?.sanityCreate?.exclude : schemaType?.type ? isSanityCreateExcludedType(schemaType?.type) : !1;
}
function isSanityCreateStartCompatibleDoc(doc) {
  return !Object.entries(doc).filter(([key]) => !key.startsWith("_")).filter(([, value]) => value != null).length;
}
const INITIAL$1 = "connecting";
function useConnectionState(publishedDocId, docTypeName, version) {
  const $ = c(5), documentStore = useDocumentStore();
  let t0, t1;
  return $[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId || $[3] !== version ? (t1 = documentStore.pair.documentEvents(publishedDocId, docTypeName, version).pipe(map(_temp$R), map(_temp2$g), switchMap(_temp3$6), startWith(INITIAL$1), distinctUntilChanged()), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = version, $[4] = t1) : t1 = $[4], t0 = t1, useObservable(t0, INITIAL$1);
}
function _temp3$6(isConnected) {
  return isConnected ? of("connected") : timer(200).pipe(mapTo("reconnecting"));
}
function _temp2$g(eventType) {
  return eventType !== "reconnect";
}
function _temp$R(ev) {
  return ev.type;
}
function useActiveWorkspace() {
  const value = useContext(ActiveWorkspaceMatcherContext);
  if (!value)
    throw new Error("Could not find `ActiveWorkspaceMatcher` context");
  return value;
}
function useRecordDocumentHistoryEvent({
  documentId,
  documentType,
  resourceType,
  resourceId,
  schemaName
}) {
  const {
    node
  } = useComlinkStore();
  if (resourceType !== "studio" && !resourceId)
    throw new Error("resourceId is required for media-library and canvas resources");
  return {
    recordEvent: useCallback((eventType) => {
      try {
        const message = {
          type: "dashboard/v1/events/history",
          data: {
            eventType,
            document: {
              id: documentId,
              type: documentType,
              resource: {
                id: resourceId,
                type: resourceType,
                schemaName
              }
            }
          }
        };
        node?.post?.(message.type, message.data);
      } catch (error) {
        throw console.error("Failed to record history event:", error), error;
      }
    }, [documentId, documentType, resourceId, resourceType, schemaName, node])
  };
}
function useDocumentOperationWithComlinkHistory({
  api,
  publishedDocId,
  docTypeName,
  version
}) {
  const {
    activeWorkspace
  } = useActiveWorkspace(), {
    recordEvent
  } = useRecordDocumentHistoryEvent({
    resourceType: "studio",
    documentId: version ? getVersionId(publishedDocId, version) : publishedDocId,
    documentType: docTypeName,
    resourceId: [activeWorkspace.projectId, activeWorkspace.dataset].join("."),
    schemaName: activeWorkspace.name
  }), renderingContextStore = useRenderingContextStore(), capabilities = useObservable(renderingContextStore.capabilities), [hasRecordedEdit, setHasRecordedEdit] = useState(!1), preRecordPatch = useCallback((next) => {
    hasRecordedEdit || (next(), setHasRecordedEdit(!0));
  }, [hasRecordedEdit]), comlinkContext = useMemo(() => ({
    hasComlink: capabilities?.comlink,
    recordEvent
  }), [capabilities?.comlink, recordEvent]), withComlinkDelete = useMemo(() => withComlinkEvent({
    ...comlinkContext,
    operationName: "delete",
    comlinkEventType: "deleted"
  }), [comlinkContext]), withComlinkDel = useMemo(() => withComlinkEvent({
    ...comlinkContext,
    operationName: "del",
    comlinkEventType: "deleted"
  }), [comlinkContext]), withComlinkPatch = useMemo(() => withComlinkEvent({
    ...comlinkContext,
    operationName: "patch",
    comlinkEventType: "edited",
    preRecordEvent: preRecordPatch
  }), [comlinkContext, preRecordPatch]);
  return withComlinkDelete(withComlinkDel(withComlinkPatch(api)));
}
function withComlinkEvent({
  operationName,
  comlinkEventType,
  hasComlink,
  recordEvent,
  preRecordEvent = (next) => next()
}) {
  return function(api) {
    return hasComlink ? {
      ...api,
      [operationName]: {
        ...api[operationName],
        execute: (...args) => {
          preRecordEvent(() => recordEvent(comlinkEventType)), api[operationName].execute(...args);
        }
      }
    } : api;
  };
}
function useDocumentOperation(publishedDocId, docTypeName, version) {
  const $ = c(9), documentStore = useDocumentStore();
  let t0, t1;
  $[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId || $[3] !== version ? (t1 = documentStore.pair.editOperations(publishedDocId, docTypeName, version), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = version, $[4] = t1) : t1 = $[4], t0 = t1;
  const api = useObservable(t0);
  let t2;
  return $[5] !== api || $[6] !== docTypeName || $[7] !== publishedDocId ? (t2 = {
    api,
    docTypeName,
    publishedDocId
  }, $[5] = api, $[6] = docTypeName, $[7] = publishedDocId, $[8] = t2) : t2 = $[8], useDocumentOperationWithComlinkHistory(t2);
}
function useEditState(publishedDocId, docTypeName, t0, version) {
  const $ = c(10), priority = t0 === void 0 ? "default" : t0;
  if (version === "published" || version === "draft")
    throw new Error("Version cannot be published or draft");
  const documentStore = useDocumentStore();
  let t1;
  bb0: {
    if (priority === "low") {
      let t22;
      if ($[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId || $[3] !== version) {
        const base = documentStore.pair.editState(publishedDocId, docTypeName, version).pipe(share$1());
        t22 = merge(base.pipe(take$1(1)), base.pipe(skip$1(1), debounce$2(_temp$Q))), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = version, $[4] = t22;
      } else
        t22 = $[4];
      t1 = t22;
      break bb0;
    }
    let t2;
    $[5] !== docTypeName || $[6] !== documentStore.pair || $[7] !== publishedDocId || $[8] !== version ? (t2 = documentStore.pair.editState(publishedDocId, docTypeName, version), $[5] = docTypeName, $[6] = documentStore.pair, $[7] = publishedDocId, $[8] = version, $[9] = t2) : t2 = $[9], t1 = t2;
  }
  return useObservable(t1);
}
function _temp$Q() {
  return timer(1e3);
}
const INITIAL = {
  validation: [],
  isValidating: !1
};
function useValidationStatus(publishedDocId, docTypeName, version) {
  const $ = c(5), documentStore = useDocumentStore();
  let t0, t1;
  return $[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId || $[3] !== version ? (t1 = documentStore.pair.validation(publishedDocId, docTypeName, version), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = version, $[4] = t1) : t1 = $[4], t0 = t1, useObservable(t0, INITIAL);
}
function getSelectedPerspective(selectedPerspectiveName, releases2) {
  return selectedPerspectiveName ? selectedPerspectiveName === "published" ? "published" : releases2.find((release) => getReleaseIdFromReleaseDocumentId(release._id) === selectedPerspectiveName) || "drafts" : "drafts";
}
function useComlinkViewHistory(t0) {
  const $ = c(18), {
    editState: editState2
  } = t0, renderingContextStore = useRenderingContextStore(), capabilities = useObservable(renderingContextStore.capabilities), {
    activeWorkspace
  } = useActiveWorkspace(), displayed = editState2.version ?? editState2.draft ?? editState2.published, t1 = displayed?._id ?? editState2.id, t2 = editState2.type;
  let t3;
  $[0] !== activeWorkspace.dataset || $[1] !== activeWorkspace.projectId ? (t3 = [activeWorkspace.projectId, activeWorkspace.dataset], $[0] = activeWorkspace.dataset, $[1] = activeWorkspace.projectId, $[2] = t3) : t3 = $[2];
  const t4 = t3.join(".");
  let t5;
  $[3] !== activeWorkspace.name || $[4] !== editState2.type || $[5] !== t1 || $[6] !== t4 ? (t5 = {
    resourceType: "studio",
    documentId: t1,
    documentType: t2,
    resourceId: t4,
    schemaName: activeWorkspace.name
  }, $[3] = activeWorkspace.name, $[4] = editState2.type, $[5] = t1, $[6] = t4, $[7] = t5) : t5 = $[7];
  const {
    recordEvent
  } = useRecordDocumentHistoryEvent(t5), hasRecordedView = useRef(!1);
  let t6;
  $[8] !== capabilities?.comlink || $[9] !== displayed || $[10] !== editState2.ready || $[11] !== recordEvent ? (t6 = () => {
    const documentExists = editState2.ready && displayed !== null;
    capabilities?.comlink && documentExists && !hasRecordedView.current && (hasRecordedView.current = !0, recordEvent("viewed"));
  }, $[8] = capabilities?.comlink, $[9] = displayed, $[10] = editState2.ready, $[11] = recordEvent, $[12] = t6) : t6 = $[12];
  const t7 = capabilities?.comlink;
  let t8;
  $[13] !== displayed || $[14] !== editState2.ready || $[15] !== recordEvent || $[16] !== t7 ? (t8 = [t7, displayed, editState2.ready, recordEvent], $[13] = displayed, $[14] = editState2.ready, $[15] = recordEvent, $[16] = t7, $[17] = t8) : t8 = $[17], useEffect(t6, t8);
}
function useDocumentForm(options) {
  const {
    documentType,
    getFormDocumentValue,
    documentId,
    initialValue,
    changesOpen = !1,
    comparisonValue: comparisonValueRaw,
    releaseId,
    initialFocusPath,
    selectedPerspectiveName,
    readOnly: readOnlyProp,
    onFocusPath
  } = options, schema2 = useSchema(), presenceStore = usePresenceStore(), {
    data: releases2
  } = useActiveReleases(), {
    data: documentVersions
  } = useDocumentVersions({
    documentId
  }), {
    selectedReleaseId
  } = usePerspective(), schemaType = schema2.get(documentType);
  if (!schemaType)
    throw new Error(`Schema type for '${documentType}' not found`);
  const liveEdit = !!schemaType.liveEdit, publishedId = getPublishedId(documentId), telemetry = useTelemetry(), {
    validation: validationRaw
  } = useValidationStatus(documentId, documentType, releaseId), validation2 = useUnique(validationRaw), {
    sortedDocumentList
  } = useDocumentVersionTypeSortedList({
    documentId
  }), onlyHasVersions = useOnlyHasVersions({
    documentId
  }), firstVersion = sortedDocumentList.length > 0 ? documentVersions.find((id2) => getVersionFromId(id2) === getReleaseIdFromReleaseDocumentId(sortedDocumentList[0]._id)) : void 0, activeDocumentReleaseId = useMemo(() => documentVersions.some((id_0) => getVersionFromId(id_0) === selectedReleaseId) || selectedReleaseId && (!documentVersions || !onlyHasVersions) ? selectedReleaseId : getVersionFromId(firstVersion ?? ""), [documentVersions, onlyHasVersions, selectedReleaseId, firstVersion]), editState2 = useEditState(documentId, documentType, "default", activeDocumentReleaseId), connectionState = useConnectionState(documentId, documentType, releaseId);
  useReconnectingToast(connectionState === "reconnecting");
  const [focusPath, setFocusPath] = useState(initialFocusPath || EMPTY_ARRAY$A), comparisonValue = useMemo(() => typeof comparisonValueRaw == "function" ? comparisonValueRaw(editState2) : comparisonValueRaw, [comparisonValueRaw, editState2]), value = useMemo(() => {
    const baseValue = initialValue?.value || {
      _id: documentId,
      _type: documentType
    };
    return releaseId ? editState2.version || editState2.draft || editState2.published || baseValue : selectedPerspectiveName && isPublishedPerspective(selectedPerspectiveName) ? editState2.published || (liveEdit ? (
      // If it's live edit and published perspective, add the initialValue
      baseValue
    ) : (
      // If it's not live edit, the form needs to be empty in the draft state, don't show the initialValue
      {
        _id: documentId,
        _type: documentType
      }
    )) : !selectedPerspectiveName && onlyHasVersions ? editState2.version || editState2.draft || editState2.published || baseValue : editState2?.draft || editState2?.published || baseValue;
  }, [documentId, documentType, editState2.draft, editState2.published, editState2.version, initialValue, liveEdit, releaseId, selectedPerspectiveName, onlyHasVersions]), [presence, setPresence] = useState([]);
  useEffect(() => {
    const subscription = presenceStore.documentPresence(value._id, {
      excludeVersions: !0
    }).subscribe((nextPresence) => {
      setPresence(nextPresence);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [presenceStore, value._id]);
  const [openPath, onSetOpenPath] = useState(EMPTY_ARRAY$A), [fieldGroupState, onSetFieldGroupState] = useState(), [collapsedPaths, onSetCollapsedPath] = useState(), [collapsedFieldSets, onSetCollapsedFieldSets] = useState(), handleOnSetCollapsedPath = useCallback((path, collapsed) => {
    onSetCollapsedPath((prevState) => setAtPath(prevState, path, collapsed));
  }, []), handleOnSetCollapsedFieldSet = useCallback((path_0, collapsed_0) => {
    onSetCollapsedFieldSets((prevState_0) => setAtPath(prevState_0, path_0, collapsed_0));
  }, []), handleSetActiveFieldGroup = useCallback((path_1, groupName) => onSetFieldGroupState((prevState_1) => setAtPath(prevState_1, path_1, groupName)), []), requiredPermission = value._createdAt ? "update" : "create", targetDocumentId = useMemo(() => releaseId ? getVersionId(publishedId, releaseId) : liveEdit ? editState2?.draft?._id || publishedId : getDraftId(documentId), [documentId, editState2?.draft?._id, liveEdit, publishedId, releaseId]), docPermissionsInput = useMemo(() => ({
    ...value,
    _id: targetDocumentId
  }), [value, targetDocumentId]), [permissions, isPermissionsLoading] = useDocumentValuePermissions({
    document: docPermissionsInput,
    permission: requiredPermission
  }), isNonExistent = !value?._id, isCreateLinked = isSanityCreateLinkedDocument(value), ready = connectionState === "connected" && editState2.ready && !initialValue?.loading, selectedPerspective = useMemo(() => getSelectedPerspective(selectedPerspectiveName, releases2), [selectedPerspectiveName, releases2]), isReleaseLocked = useMemo(() => isReleaseDocument(selectedPerspective) ? isReleaseScheduledOrScheduling(selectedPerspective) : !1, [selectedPerspective]), {
    isLinked
  } = useCanvasCompanionDoc(value._id), readOnly = useMemo(() => {
    const hasNoPermission = !isPermissionsLoading && !permissions?.granted, updateActionDisabled = !isActionEnabled(schemaType, "update"), createActionDisabled = isNonExistent && !isActionEnabled(schemaType, "create"), reconnecting = connectionState === "reconnecting", isLocked = editState2.transactionSyncLock?.enabled, willBeUnpublished = value ? isGoingToUnpublish(value) : !1;
    return editState2.version && !editState2.draft && !editState2.published && onlyHasVersions && selectedPerspectiveName !== getVersionFromId(editState2.version._id) || liveEdit && editState2.draft?._id || !liveEdit && selectedPerspectiveName === "published" || releaseId && getVersionFromId(value._id) !== releaseId || !ready || isLinked || hasNoPermission || updateActionDisabled || createActionDisabled || reconnecting || isLocked || isCreateLinked || willBeUnpublished || isReleaseLocked ? !0 : typeof readOnlyProp == "function" ? readOnlyProp(editState2) : !!readOnlyProp;
  }, [isPermissionsLoading, isLinked, permissions?.granted, schemaType, isNonExistent, connectionState, editState2, value, onlyHasVersions, selectedPerspectiveName, liveEdit, releaseId, ready, isCreateLinked, isReleaseLocked, readOnlyProp]), {
    patch: patch2
  } = useDocumentOperation(documentId, documentType, releaseId), patchRef = useRef(() => {
    throw new Error("Attempted to patch the Sanity document during initial render or in an `useInsertionEffect`. Input components should only call `onChange()` in a useEffect or an event handler.");
  }), handleChange = useCallback((event) => patchRef.current(event), []);
  useInsertionEffect(() => {
    readOnly && !isCreateLinked ? patchRef.current = () => {
      throw new Error("Attempted to patch a read-only document");
    } : patchRef.current = (event_0) => {
      !editState2.draft && !editState2.published && telemetry.log(CreatedDraft), patch2.execute(toMutationPatches(event_0.patches), initialValue?.value);
    };
  }, [editState2.draft, editState2.published, initialValue, patch2, telemetry, readOnly, isCreateLinked]);
  const formDocumentValue = useMemo(() => getFormDocumentValue ? getFormDocumentValue(value) : value, [getFormDocumentValue, value]), formState = useFormState({
    schemaType,
    documentValue: formDocumentValue,
    readOnly,
    comparisonValue: comparisonValue || value,
    focusPath,
    openPath,
    collapsedPaths,
    presence,
    validation: validation2,
    collapsedFieldSets,
    fieldGroupState,
    changesOpen
  }), formStateRef = useRef(formState);
  useEffect(() => {
    formStateRef.current = formState;
  }, [formState]), useComlinkViewHistory({
    editState: editState2
  });
  const handleSetOpenPath = useCallback((path_2) => {
    getExpandOperations(formStateRef.current, path_2).forEach((op) => {
      op.type === "expandPath" && onSetCollapsedPath((prevState_2) => setAtPath(prevState_2, op.path, !1)), op.type === "expandFieldSet" && onSetCollapsedFieldSets((prevState_3) => setAtPath(prevState_3, op.path, !1)), op.type === "setSelectedGroup" && onSetFieldGroupState((prevState_4) => setAtPath(prevState_4, op.path, op.groupName));
    }), onSetOpenPath(path_2);
  }, [formStateRef]), updatePresence = useCallback((nextFocusPath, payload) => {
    presenceStore.setLocation([{
      type: "document",
      documentId: value._id,
      path: nextFocusPath,
      lastActiveAt: (/* @__PURE__ */ new Date()).toISOString(),
      selection: payload?.selection
    }]);
  }, [presenceStore, value._id]), updatePresenceThrottled = useMemo(() => throttle(updatePresence, 1e3, {
    leading: !0,
    trailing: !0
  }), [updatePresence]), focusPathRef = useRef([]), handleFocus = useCallback((_nextFocusPath, payload_0) => {
    const nextFocusPath_0 = pathFor(_nextFocusPath);
    nextFocusPath_0 !== focusPathRef.current && (setFocusPath(pathFor(nextFocusPath_0)), handleSetOpenPath(pathFor(nextFocusPath_0.slice(0, -1))), focusPathRef.current = nextFocusPath_0, onFocusPath?.(nextFocusPath_0)), updatePresenceThrottled(nextFocusPath_0, payload_0);
  }, [onFocusPath, setFocusPath, handleSetOpenPath, updatePresenceThrottled]), disableBlurRef = useRef(!1), handleBlur = useCallback((_blurredPath) => {
    disableBlurRef.current || (setFocusPath(EMPTY_ARRAY$A), focusPathRef.current !== EMPTY_ARRAY$A && (focusPathRef.current = EMPTY_ARRAY$A, onFocusPath?.(EMPTY_ARRAY$A)));
  }, [onFocusPath, setFocusPath]), handleProgrammaticFocus = useCallback((nextPath) => {
    disableBlurRef.current = !0, deepEquals(focusPathRef.current, nextPath) || (setFocusPath(nextPath), handleSetOpenPath(nextPath), onFocusPath?.(nextPath), focusPathRef.current = nextPath);
    const timeout2 = setTimeout(() => {
      disableBlurRef.current = !1;
    }, 0);
    return () => clearTimeout(timeout2);
  }, [onFocusPath, handleSetOpenPath]);
  return {
    editState: editState2,
    connectionState,
    focusPath,
    validation: validation2,
    ready,
    value,
    formState,
    permissions,
    isPermissionsLoading,
    formStateRef,
    collapsedFieldSets,
    collapsedPaths,
    openPath,
    schemaType,
    onChange: handleChange,
    onPathOpen: handleSetOpenPath,
    onProgrammaticFocus: handleProgrammaticFocus,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onSetActiveFieldGroup: handleSetActiveFieldGroup,
    onSetCollapsedPath: handleOnSetCollapsedPath,
    onSetCollapsedFieldSet: handleOnSetCollapsedFieldSet
  };
}
const IS_NUMERIC = /^\d+$/;
function unquote(str) {
  return str.replace(/^['"]/, "").replace(/['"]$/, "");
}
function splitAttr(segment) {
  const [attr, key] = segment.split("==");
  return {
    [attr]: unquote(key)
  };
}
function coerce(segment) {
  return IS_NUMERIC.test(segment) ? Number(segment) : segment;
}
function parseGradientPath(focusPathStr) {
  return focusPathStr.split(/[[.\]]/g).filter(Boolean).map((seg) => seg.includes("==") ? splitAttr(seg) : coerce(seg));
}
function encodePath(formBuilderPath) {
  return arrayToJSONMatchPath(formBuilderPath);
}
function decodePath(gradientPath) {
  return parseGradientPath(gradientPath);
}
function toMutationPatches(patches) {
  return patches.map(toMutationPatch);
}
function fromMutationPatches(origin, patches) {
  return flatten$1(patches.map((patch2) => toFormBuilderPatches(origin, patch2)));
}
const notIn = (values2) => (value) => !values2.includes(value);
function toFormBuilderPatches(origin, patch2) {
  return flatten$1(Object.keys(patch2).filter(notIn(["id", "ifRevisionID", "query"])).map((type) => {
    if (type === "unset")
      return patch2.unset.map((path) => ({
        type: "unset",
        path: decodePath(path),
        origin
      }));
    if (type === "insert") {
      const position = "before" in patch2.insert ? "before" : "after";
      return {
        type: "insert",
        position,
        path: decodePath(patch2.insert[position]),
        items: patch2.insert.items,
        origin
      };
    }
    return Object.keys(patch2[type]).map((gradientPath) => type === "set" ? {
      type: "set",
      path: decodePath(gradientPath),
      value: patch2[type][gradientPath],
      origin
    } : type === "inc" || type === "dec" ? {
      type,
      path: decodePath(gradientPath),
      value: patch2[type][gradientPath],
      origin
    } : type === "setIfMissing" ? {
      type: "setIfMissing",
      path: decodePath(gradientPath),
      value: patch2[type][gradientPath],
      origin
    } : type === "diffMatchPatch" ? {
      type,
      path: decodePath(gradientPath),
      value: patch2[type][gradientPath],
      origin
    } : (console.warn(new Error(`Unsupported patch type: ${type}`)), null)).filter(Boolean);
  }));
}
function toMutationPatch(patch2) {
  if (patch2.patchType !== SANITY_PATCH_TYPE && patch2.type)
    throw new Error(`Patch is missing "patchType" - import and use "${patch2.type}()" from "sanity/form"`);
  if (patch2.patchType !== SANITY_PATCH_TYPE)
    throw new Error('Patch is missing "patchType" - import and use the patch method helpers from "sanity/form"');
  const matchPath = arrayToJSONMatchPath(patch2.path || []);
  if (patch2.type === "insert") {
    const {
      position,
      items
    } = patch2;
    return {
      insert: {
        [position]: matchPath,
        items
      }
    };
  }
  if (patch2.type === "unset")
    return {
      unset: [matchPath]
    };
  if (!patch2.type)
    throw new Error(`Missing patch type in patch ${JSON.stringify(patch2)}`);
  return matchPath ? {
    [patch2.type]: {
      [matchPath]: patch2.value
    }
  } : {
    [patch2.type]: patch2.value
  };
}
const TransformPatches = memo(function(props2) {
  const $ = c(9), {
    transform
  } = props2, callbacks = useFormCallbacks();
  let t0;
  $[0] !== callbacks || $[1] !== transform ? (t0 = (patchEvent) => {
    const patches = patchEvent.patches, transformedPatches = transform(patches);
    callbacks.onChange(PatchEvent.from(transformedPatches));
  }, $[0] = callbacks, $[1] = transform, $[2] = t0) : t0 = $[2];
  const handleChange = t0;
  let t1, t2;
  $[3] !== callbacks || $[4] !== handleChange ? (t2 = {
    ...callbacks,
    onChange: handleChange
  }, $[3] = callbacks, $[4] = handleChange, $[5] = t2) : t2 = $[5], t1 = t2;
  const contextValue = t1;
  let t3;
  return $[6] !== contextValue || $[7] !== props2.children ? (t3 = /* @__PURE__ */ jsx(FormCallbacksContext.Provider, { value: contextValue, children: props2.children }), $[6] = contextValue, $[7] = props2.children, $[8] = t3) : t3 = $[8], t3;
});
function getSchemaField$1(schemaType, fieldPath) {
  const paths = PathUtils.fromString(fieldPath), firstPath = paths[0];
  if (firstPath && isObjectSchemaType(schemaType)) {
    const field = schemaType?.fields?.find((f) => f.name === firstPath);
    if (field) {
      const nextPath = PathUtils.toString(paths.slice(1));
      return nextPath ? getSchemaField$1(field.type, nextPath) : field;
    }
  }
}
function findArrayItemIndex(array, pathSegment) {
  if (typeof pathSegment == "number")
    return pathSegment;
  const index = findIndex$1(array, pathSegment);
  return index === -1 ? !1 : index;
}
function buildCommentBreadcrumbs(props2) {
  const {
    currentUser,
    schemaType,
    fieldPath,
    documentValue
  } = props2, paths = PathUtils.fromString(fieldPath), fieldPaths = [];
  let currentSchemaType = null;
  return paths.forEach((seg, index) => {
    const currentPath = paths.slice(0, index + 1), previousPath = paths.slice(0, index), field = getSchemaField$1(schemaType, PathUtils.toString(currentPath)), isKeySegment2 = seg.hasOwnProperty("_key"), parentValue = getValueAtPath(documentValue, previousPath), currentValue = getValueAtPath(documentValue, currentPath), conditionalContext = {
      document: documentValue,
      currentUser,
      parent: parentValue,
      value: currentValue
    };
    if (isKeySegment2 && Array.isArray(parentValue)) {
      const arrayItemIndex = findArrayItemIndex(parentValue, seg), isNumber = typeof arrayItemIndex == "number";
      fieldPaths.push({
        invalid: arrayItemIndex === !1,
        isArrayItem: !0,
        title: isNumber ? `#${Number(arrayItemIndex) + 1}` : "Unknown array item"
      });
      return;
    }
    if (field?.type) {
      const hidden = resolveConditionalProperty(field.type.hidden, conditionalContext);
      fieldPaths.push({
        invalid: hidden,
        isArrayItem: !1,
        title: getSchemaTypeTitle(field.type)
      }), currentSchemaType = field.type;
      return;
    }
    if (isArraySchemaType(currentSchemaType)) {
      const objectType = getValueAtPath(documentValue, previousPath)?._type, objectField = currentSchemaType?.of?.find((type) => type.name === objectType), currentField = objectField?.fields?.find((f) => f.name === seg);
      if (!objectType && currentValue) {
        const anonymousField = currentSchemaType?.of?.map((o) => o?.fields).filter(Boolean).flat()?.find((f) => f?.name === seg), hidden = resolveConditionalProperty(anonymousField?.type?.hidden, conditionalContext);
        anonymousField && (fieldPaths.push({
          invalid: hidden,
          isArrayItem: !1,
          title: getSchemaTypeTitle(anonymousField?.type)
        }), currentSchemaType = anonymousField?.type);
        return;
      }
      if (!currentField) {
        fieldPaths.push({
          invalid: !0,
          isArrayItem: !1,
          title: "Unknown field"
        });
        return;
      }
      const currentTitle = getSchemaTypeTitle(currentField?.type), objectFieldHidden = resolveConditionalProperty(objectField?.type?.hidden, conditionalContext), currentFieldHidden = resolveConditionalProperty(currentField?.type.hidden, conditionalContext), isHidden = objectFieldHidden || currentFieldHidden;
      fieldPaths.push({
        invalid: isHidden,
        isArrayItem: !1,
        title: currentTitle
      }), currentSchemaType = currentField?.type;
      return;
    }
    fieldPaths.push({
      invalid: !0,
      isArrayItem: !1,
      title: "Unknown field"
    });
  }), fieldPaths;
}
function useCommentHasChanged(message) {
  const [prevMessage] = useState(message);
  let t0;
  return t0 = !isEqual$2(prevMessage, message), t0;
}
function hasCommentMessageValue(value) {
  return value ? value?.some((block) => isPortableTextTextBlock(block) && (block?.children || [])?.some((c2) => isPortableTextSpan(c2) ? c2.text : c2.userId)) : !1;
}
function commentIntentIfDiffers(parent, comment) {
  const parentIntent = parent?.context?.intent, intent = comment?.context?.intent;
  if (intent && (!parentIntent || "preview" in intent.params && "preview" in parentIntent.params && intent.params.preview !== parentIntent.params.preview))
    return intent;
}
function isTextSelectionComment(comment) {
  return comment ? !!(comment?.target?.path?.selection?.type === "text" && comment?.target?.path?.selection?.value) : !1;
}
const EMPTY_ARRAY$g = [];
function buildCommentThreadItems(props2) {
  const {
    comments: comments2,
    currentUser,
    documentValue,
    schemaType,
    type
  } = props2, parentComments = comments2?.filter((c2) => !c2.parentCommentId);
  return type === "task" ? parentComments.map((parentComment) => {
    const replies = comments2?.filter((r) => r.parentCommentId === parentComment._id);
    return {
      commentsCount: [parentComment, ...replies].length,
      parentComment,
      replies,
      threadId: parentComment.threadId,
      hasReferencedValue: !1,
      breadcrumbs: EMPTY_ARRAY$g,
      fieldPath: ""
    };
  }) : type === "field" ? parentComments.map((parentComment) => {
    const crumbs = buildCommentBreadcrumbs({
      currentUser,
      documentValue,
      fieldPath: parentComment.target.path?.field || "",
      schemaType
    });
    let hasTextSelection = !1;
    if (isTextSelectionComment(parentComment) && (hasTextSelection = !!(parentComment.target.path?.selection && parentComment.target.path.selection.value.some((v) => v.text))), crumbs.some((bc) => bc.invalid)) return;
    const replies = comments2?.filter((r) => r.parentCommentId === parentComment._id), commentsCount = [parentComment, ...replies].length, hasReferencedValue = hasTextSelection;
    return {
      breadcrumbs: crumbs,
      commentsCount,
      fieldPath: parentComment.target.path?.field || "",
      parentComment,
      replies,
      threadId: parentComment.threadId,
      hasReferencedValue
    };
  }).filter(Boolean) : EMPTY_ARRAY$g;
}
const DMP_MARGIN = 15;
function diffText(current, next) {
  const diff = makeDiff(current, next), diffs = cleanupEfficiency(diff), levenshtein = diffsLevenshtein(diffs);
  return {
    patches: makePatches(current, diffs, {
      margin: DMP_MARGIN
    }),
    levenshtein
  };
}
function diffApply(current, patches) {
  return applyPatches(patches, current, {
    allowExceedingIndices: !0,
    margin: DMP_MARGIN
  })[0];
}
const CHILD_SYMBOL = "\uF0D0";
function toPlainTextWithChildSeparators(inputBlock) {
  return inputBlock.children.map((child) => isPortableTextSpan(child) ? child.text.replaceAll(CHILD_SYMBOL, " ") : "").join(CHILD_SYMBOL);
}
const COMMENT_INDICATORS = ["\uF000", "\uF001"], COMMENT_INDICATORS_REGEX = new RegExp(`[${COMMENT_INDICATORS.join("")}]`, "g"), EMPTY_ARRAY$f = [];
function buildRangeDecorationSelectionsFromComments(props2) {
  const {
    value,
    comments: comments2
  } = props2;
  if (!value || value.length === 0) return EMPTY_ARRAY$f;
  const textSelections = comments2.filter(isTextSelectionComment), decorators = [];
  return textSelections.forEach((comment) => {
    comment.target.path?.selection?.value.forEach((selectionMember) => {
      const matchedBlock = value.find((block) => block._key === selectionMember._key);
      if (!matchedBlock || !isPortableTextTextBlock(matchedBlock))
        return;
      const selectionText = selectionMember.text.replaceAll(COMMENT_INDICATORS_REGEX, ""), textWithChildSeparators = toPlainTextWithChildSeparators(matchedBlock), {
        patches
      } = diffText(selectionText, selectionMember.text), diffedText = diffApply(textWithChildSeparators, patches), startIndex = diffedText.indexOf(COMMENT_INDICATORS[0]), endIndex = diffedText.replaceAll(COMMENT_INDICATORS[0], "").indexOf(COMMENT_INDICATORS[1]), textWithoutCommentTags = diffedText.replaceAll(COMMENT_INDICATORS_REGEX, ""), oldCommentedText = selectionMember.text.slice(selectionMember.text.indexOf(COMMENT_INDICATORS[0]) + 1, selectionMember.text.indexOf(COMMENT_INDICATORS[1])), newCommentedText = textWithoutCommentTags.slice(startIndex, endIndex), {
        levenshtein
      } = diffText(newCommentedText, oldCommentedText), threshold = Math.round(newCommentedText.length + oldCommentedText.length / 2);
      let nullSelection = !1;
      if (newCommentedText.length === 0 && (nullSelection = !0), levenshtein > threshold && (nullSelection = !0), startIndex + 1 === endIndex && (nullSelection = !0), startIndex !== -1 && endIndex !== -1) {
        let childIndexAnchor = 0, anchorOffset = 0, childIndexFocus = 0, focusOffset = 0;
        for (let i = 0; i < textWithoutCommentTags.length && (textWithoutCommentTags[i] === CHILD_SYMBOL && (i <= startIndex && (anchorOffset = -1, childIndexAnchor++), focusOffset = -1, childIndexFocus++), i < startIndex && anchorOffset++, i < startIndex + newCommentedText.length && focusOffset++, i !== startIndex + newCommentedText.length); i++)
          ;
        decorators.push({
          selection: {
            anchor: {
              path: [{
                _key: matchedBlock._key
              }, "children", {
                _key: matchedBlock.children[childIndexAnchor]._key
              }],
              offset: anchorOffset
            },
            focus: {
              path: [{
                _key: matchedBlock._key
              }, "children", {
                _key: matchedBlock.children[childIndexFocus]._key
              }],
              offset: focusOffset
            }
          },
          comment,
          range: {
            _key: matchedBlock._key,
            text: nullSelection ? "" : diffedText
          }
        });
      }
    });
  }), decorators.length === 0 ? EMPTY_ARRAY$f : decorators;
}
function diffsLevenshtein(diffs) {
  let levenshtein = 0, insertions = 0, deletions = 0;
  for (let x = 0; x < diffs.length; x++) {
    const op = diffs[x][0], data = diffs[x][1];
    switch (op) {
      case DIFF_INSERT:
        insertions += data.length;
        break;
      case DIFF_DELETE:
        deletions += data.length;
        break;
      case DIFF_EQUAL:
        levenshtein += Math.max(insertions, deletions), insertions = 0, deletions = 0;
        break;
    }
  }
  return levenshtein += Math.max(insertions, deletions), levenshtein;
}
const CommentRangeDecoration = memo(function(props2) {
  const $ = c(20), {
    children,
    commentId,
    currentHoveredCommentId,
    onClick: onClick2,
    onHoverEnd,
    onHoverStart,
    selectedThreadId,
    threadId
  } = props2, decoratorRef = useRef(null), [isNested, setIsNested] = useState(!1), [parentCommentId, setParentCommentId] = useState(null);
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    const prevEl = decoratorRef.current?.previousSibling, nextEl = decoratorRef.current?.nextSibling;
    if (!prevEl || !nextEl) {
      setIsNested(!1);
      return;
    }
    const [key] = Object.keys(applyInlineCommentIdAttr("")), prevId = prevEl.getAttribute(key), nextId = nextEl.getAttribute(key), isNestedDecorator = !!(prevId && nextId && prevId === nextId);
    setParentCommentId(isNestedDecorator ? prevId : null), setIsNested(isNestedDecorator);
  }, t1 = [], $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]), useEffect(t0, t1);
  let t2;
  $[2] !== commentId || $[3] !== onHoverStart ? (t2 = () => onHoverStart(commentId), $[2] = commentId, $[3] = onHoverStart, $[4] = t2) : t2 = $[4];
  const handleMouseEnter = t2;
  let t3;
  $[5] !== onHoverEnd ? (t3 = () => onHoverEnd(null), $[5] = onHoverEnd, $[6] = t3) : t3 = $[6];
  const handleMouseLeave = t3;
  let t4;
  $[7] !== commentId || $[8] !== onClick2 ? (t4 = () => onClick2(commentId), $[7] = commentId, $[8] = onClick2, $[9] = t4) : t4 = $[9];
  const handleClick = t4, t5 = currentHoveredCommentId === commentId || currentHoveredCommentId === parentCommentId && isNested || selectedThreadId === threadId;
  let t6;
  $[10] !== threadId ? (t6 = applyInlineCommentIdAttr(threadId), $[10] = threadId, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== children || $[13] !== handleClick || $[14] !== handleMouseEnter || $[15] !== handleMouseLeave || $[16] !== isNested || $[17] !== t5 || $[18] !== t6 ? (t7 = /* @__PURE__ */ jsx(CommentInlineHighlightSpan, { isAdded: !0, isHovered: t5, isNested, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ref: decoratorRef, ...t6, children }), $[12] = children, $[13] = handleClick, $[14] = handleMouseEnter, $[15] = handleMouseLeave, $[16] = isNested, $[17] = t5, $[18] = t6, $[19] = t7) : t7 = $[19], t7;
});
CommentRangeDecoration.displayName = "Memo(CommentRangeDecoration)";
function buildCommentRangeDecorations(props2) {
  const {
    comments: comments2,
    currentHoveredCommentId,
    onDecorationClick,
    onDecorationHoverEnd,
    onDecorationHoverStart,
    onDecorationMoved,
    selectedThreadId,
    value
  } = props2;
  return buildRangeDecorationSelectionsFromComments({
    comments: comments2,
    value
  }).map(({
    selection,
    comment,
    range: range2
  }) => ({
    component: ({
      children
    }) => /* @__PURE__ */ jsx(CommentRangeDecoration, { commentId: comment._id, currentHoveredCommentId, onClick: onDecorationClick, onHoverEnd: onDecorationHoverEnd, onHoverStart: onDecorationHoverStart, selectedThreadId, threadId: comment.threadId, children }),
    onMoved: onDecorationMoved,
    selection,
    payload: {
      commentId: comment._id,
      range: range2
    }
  }));
}
function buildTextSelectionFromFragment(props2) {
  const {
    fragment,
    value,
    selection
  } = props2;
  if (!selection)
    throw new Error("Selection is required");
  const normalizedSelection = selection.backward ? {
    anchor: selection.focus,
    focus: selection.anchor
  } : selection;
  return {
    type: "text",
    value: fragment.map((fragmentBlock) => {
      const originalBlock = value.find((b) => b._key === fragmentBlock._key);
      if (!isPortableTextTextBlock(originalBlock))
        return {
          _key: fragmentBlock._key,
          text: ""
        };
      const anchorBlockKey = isKeySegment(normalizedSelection.anchor.path[0]) && normalizedSelection.anchor.path[0]._key, focusBlockKey = isKeySegment(normalizedSelection.focus.path[0]) && normalizedSelection.focus.path[0]._key, fragmentBlockText = toPlainText([fragmentBlock]), fragmentStartSpan = isPortableTextTextBlock(fragmentBlock) ? fragmentBlock.children[0] : void 0, fragmentEndSpan = isPortableTextTextBlock(fragmentBlock) ? fragmentBlock.children[fragmentBlock.children.length - 1] : void 0;
      let originalTextBeforeSelection = "", startChildIndex = -1;
      if (anchorBlockKey === originalBlock._key)
        for (const child of originalBlock.children) {
          if (startChildIndex++, child._key === fragmentStartSpan?._key) {
            originalTextBeforeSelection += isPortableTextSpan(child) && child.text.slice(0, Math.max(0, normalizedSelection.anchor.offset)) || "";
            break;
          }
          originalTextBeforeSelection += child.text;
        }
      let originalTextAfterSelection = "";
      if (focusBlockKey === originalBlock._key)
        for (const child of originalBlock.children.slice(startChildIndex).reverse()) {
          if (child._key === fragmentEndSpan?._key) {
            originalTextAfterSelection = (isPortableTextSpan(child) && child.text.slice(normalizedSelection.focus.offset, child.text.length) || "") + originalTextAfterSelection;
            break;
          }
          originalTextAfterSelection = child.text + originalTextAfterSelection;
        }
      return {
        _key: originalBlock._key,
        text: `${originalTextBeforeSelection}${COMMENT_INDICATORS[0]}${fragmentBlockText}${COMMENT_INDICATORS[1]}${originalTextAfterSelection}`
      };
    })
  };
}
function mergeCommentReactions(reactionsA, reactionsB) {
  const mergedReactions = {};
  for (const reaction of reactionsA)
    mergedReactions[reaction._key] = {
      ...reaction
    };
  for (const reaction of reactionsB)
    mergedReactions[reaction._key] = {
      ...mergedReactions[reaction._key],
      ...reaction
    };
  return Object.values(mergedReactions);
}
const URL_REGEX = /\b(https?:\/\/[^\s,()]+(?:\.[^\s,()]+)*|www\.[^\s,()]+\.[^\s,()]{2,})\b/g;
function onClick(event) {
  event.stopPropagation();
}
function createLinkElement(url) {
  const href = url.startsWith("http") ? url : `https://${url}`;
  return /* @__PURE__ */ jsx("a", { href, target: "_blank", rel: "noopener noreferrer", onClick, children: url }, url);
}
const linkMiddleware = (node) => typeof node == "string" ? node.split(URL_REGEX).flatMap((part) => part.match(URL_REGEX) ? createLinkElement(part) : part) : node, middlewares = [linkMiddleware];
function transformChildren(node) {
  return Array.isArray(node) ? node.flatMap((item) => {
    let transformedItem = [item];
    for (const middleware2 of middlewares)
      transformedItem = transformedItem.flatMap(middleware2);
    return transformedItem;
  }) : node;
}
function weakenReferences(node) {
  if (node && typeof node == "object" && node.hasOwnProperty("_ref"))
    return {
      ...node,
      _weak: !0
    };
  if (Array.isArray(node))
    return node.map((item) => weakenReferences(item));
  if (node && typeof node == "object") {
    const result = {};
    return Object.keys(node).forEach((key) => {
      const value = node[key];
      typeof value == "object" && value !== null ? result[key] = weakenReferences(value) : result[key] = value;
    }), result;
  }
  return node;
}
function weakenReferencesInContentSnapshot(snapshot2) {
  return weakenReferences(snapshot2);
}
async function createOperation(props2) {
  const {
    activeTool,
    client,
    comment,
    currentUser,
    dataset,
    documentId,
    documentRevisionId,
    documentType,
    documentVersionId,
    getIntent,
    getNotificationValue,
    getThreadLength,
    onCreate,
    onCreateError,
    projectId,
    createAddonDataset,
    workspace
  } = props2, commentId = comment?.id || uuid(), authorId = currentUser.id, currentThreadLength = (getThreadLength?.(comment.threadId) || 0) + 1;
  let nextComment;
  if (comment.type === "task" && (nextComment = {
    _id: commentId,
    _type: "comment",
    authorId,
    message: comment.message,
    lastEditedAt: void 0,
    parentCommentId: comment.parentCommentId,
    status: comment.status,
    threadId: comment.threadId,
    reactions: comment.reactions,
    context: {
      payload: {
        workspace
      },
      notification: comment.context.notification,
      tool: activeTool?.name || ""
    },
    target: {
      document: {
        _ref: documentId,
        _type: "reference",
        _weak: !0
      },
      documentVersionId,
      documentType
    }
  }), comment.type === "field") {
    const {
      documentTitle = "",
      url = "",
      workspaceTitle = ""
    } = getNotificationValue({
      commentId
    }) || {}, notification = {
      currentThreadLength,
      documentTitle,
      url,
      workspaceTitle
    }, intent = getIntent?.({
      id: documentId,
      type: documentType,
      path: comment.fieldPath
    }), contentSnapshot = weakenReferencesInContentSnapshot(comment.contentSnapshot);
    nextComment = {
      _id: commentId,
      _type: "comment",
      authorId,
      message: comment.message,
      lastEditedAt: void 0,
      parentCommentId: comment.parentCommentId,
      status: comment.status,
      threadId: comment.threadId,
      reactions: comment.reactions,
      context: {
        payload: {
          workspace
        },
        intent,
        notification,
        tool: activeTool?.name || ""
      },
      contentSnapshot,
      target: {
        documentRevisionId: documentRevisionId || "",
        path: {
          field: comment.fieldPath,
          selection: comment.selection
        },
        document: {
          _dataset: dataset,
          _projectId: projectId,
          _ref: documentId,
          _type: "crossDatasetReference",
          _weak: !0
        },
        documentType,
        documentVersionId
      }
    };
  }
  if (nextComment) {
    if (onCreate?.(nextComment), !client) {
      try {
        const newAddonClient = await createAddonDataset();
        if (!newAddonClient)
          throw new Error("Failed to create addon dataset client");
        await newAddonClient.create(nextComment);
      } catch (err) {
        throw onCreateError?.(nextComment._id, err), err;
      }
      return;
    }
    try {
      await client.create(nextComment);
    } catch (err) {
      throw onCreateError?.(nextComment._id, err), err;
    }
  }
}
function createReactionKey(userId, shortName) {
  return `${userId}-${shortName}`;
}
async function reactOperation(props2) {
  const {
    client,
    currentUser,
    id: id2,
    reaction,
    getComment,
    onUpdate
  } = props2, reactions = getComment?.(id2)?.reactions || [], currentUserReactions = reactions.filter((r) => r.userId === currentUser.id), _key = createReactionKey(currentUser.id, reaction.shortName), currentReaction = currentUserReactions.find((r) => r._key === _key && r._optimisticState !== "removed");
  if (currentReaction) {
    const next = reactions.map((r) => r._key === currentReaction._key ? {
      ...r,
      _optimisticState: "removed"
    } : r);
    onUpdate?.(id2, {
      reactions: next
    }), await client.patch(id2).unset([`reactions[_key=="${_key}"]`]).commit();
    return;
  }
  if (!currentReaction) {
    const reactionItem = {
      _key,
      addedAt: (/* @__PURE__ */ new Date()).toISOString(),
      shortName: reaction.shortName,
      userId: currentUser.id
    }, optimisticReactionItem = {
      ...reactionItem,
      _optimisticState: "added"
    }, next = reactions.concat(optimisticReactionItem).filter((r) => !(r._key === reactionItem._key && r._optimisticState === "removed"));
    onUpdate?.(id2, {
      reactions: next
    }), await client.patch(id2).setIfMissing({
      reactions: []
    }).append("reactions", [reactionItem]).commit();
  }
}
async function removeOperation(props2) {
  const {
    client,
    id: id2,
    onRemove
  } = props2;
  onRemove?.(id2), await Promise.all([client.delete({
    query: `*[_type == "comment" && parentCommentId == "${id2}"]`
  }), client.delete(id2)]);
}
const THROTTLE_TIME_MS = 1e3, THROTTLE_SETTINGS = {
  trailing: !0,
  leading: !1
}, throttleFunctionsMap = /* @__PURE__ */ new Map();
function getThrottledFunction(id2) {
  if (!throttleFunctionsMap.has(id2)) {
    const throttledFunction = throttle(postCommentUpdate, THROTTLE_TIME_MS, THROTTLE_SETTINGS);
    return throttleFunctionsMap.set(id2, throttledFunction), throttledFunction;
  }
  return throttleFunctionsMap.get(id2);
}
async function postCommentUpdate(props2) {
  const {
    client,
    id: id2,
    comment,
    transactionId: transactionIdProp,
    onUpdate
  } = props2, transactionId = transactionIdProp || uuid(), patch2 = client?.patch(id2).set(comment), transaction = client.transaction().transactionId(transactionId).patch(patch2);
  onUpdate?.(id2, comment), comment.status ? (await transaction.commit(), await client.patch({
    query: `*[_type == "comment" && parentCommentId == "${id2}"]`
  }).set({
    status: comment.status
  }).commit()) : await transaction.commit(), throttleFunctionsMap.delete(id2);
}
async function updateOperation(props2) {
  const {
    id: id2,
    comment,
    throttled: throttledProp
  } = props2, hasEditedMessage = "message" in comment, editedComment = {
    ...comment,
    lastEditedAt: (/* @__PURE__ */ new Date()).toISOString()
  }, nextComment = hasEditedMessage ? editedComment : comment;
  if (!throttledProp) {
    await postCommentUpdate({
      ...props2,
      comment: nextComment
    });
    return;
  }
  await getThrottledFunction(id2)({
    ...props2,
    comment: nextComment
  });
}
function useCommentOperations(opts) {
  const $ = c(45), {
    client,
    currentUser,
    dataset,
    documentId,
    documentRevisionId,
    documentType,
    documentVersionId,
    getComment,
    getThreadLength,
    onCreate,
    onCreateError,
    onRemove,
    onTransactionStart,
    onUpdate,
    projectId,
    createAddonDataset,
    workspace,
    getCommentLink
  } = opts, getIntent = useCommentsIntent(), activeToolName = useRouterState(_temp$P), tools = useTools();
  let t0, t1;
  if ($[0] !== activeToolName || $[1] !== tools) {
    let t22;
    $[3] !== activeToolName ? (t22 = (tool) => tool.name === activeToolName, $[3] = activeToolName, $[4] = t22) : t22 = $[4], t1 = tools.find(t22), $[0] = activeToolName, $[1] = tools, $[2] = t1;
  } else
    t1 = $[2];
  t0 = t1;
  const activeTool = t0;
  let t2;
  $[5] !== documentId || $[6] !== documentType || $[7] !== getCommentLink ? (t2 = {
    documentId,
    documentType,
    getCommentLink
  }, $[5] = documentId, $[6] = documentType, $[7] = getCommentLink, $[8] = t2) : t2 = $[8];
  const {
    getNotificationValue
  } = useNotificationTarget(t2);
  let t3;
  $[9] !== activeTool || $[10] !== client || $[11] !== createAddonDataset || $[12] !== currentUser || $[13] !== dataset || $[14] !== documentId || $[15] !== documentRevisionId || $[16] !== documentType || $[17] !== documentVersionId || $[18] !== getIntent || $[19] !== getNotificationValue || $[20] !== getThreadLength || $[21] !== onCreate || $[22] !== onCreateError || $[23] !== projectId || $[24] !== workspace ? (t3 = async (comment) => {
    currentUser?.id && await createOperation({
      activeTool,
      client,
      comment,
      currentUser,
      dataset,
      documentId,
      documentRevisionId,
      documentType,
      documentVersionId,
      getIntent,
      getNotificationValue,
      getThreadLength,
      onCreate,
      onCreateError,
      projectId,
      createAddonDataset,
      workspace
    });
  }, $[9] = activeTool, $[10] = client, $[11] = createAddonDataset, $[12] = currentUser, $[13] = dataset, $[14] = documentId, $[15] = documentRevisionId, $[16] = documentType, $[17] = documentVersionId, $[18] = getIntent, $[19] = getNotificationValue, $[20] = getThreadLength, $[21] = onCreate, $[22] = onCreateError, $[23] = projectId, $[24] = workspace, $[25] = t3) : t3 = $[25];
  const handleCreate = t3;
  let t4;
  $[26] !== client || $[27] !== onRemove ? (t4 = async (id2) => {
    client && await removeOperation({
      client,
      id: id2,
      onRemove
    });
  }, $[26] = client, $[27] = onRemove, $[28] = t4) : t4 = $[28];
  const handleRemove = t4;
  let t5;
  $[29] !== client || $[30] !== onTransactionStart || $[31] !== onUpdate ? (t5 = async (id_0, comment_0, updateOpts) => {
    if (!client)
      return;
    const {
      throttled
    } = updateOpts || {}, nextTransactionId = uuid();
    onTransactionStart(id_0, nextTransactionId), await updateOperation({
      client,
      comment: comment_0,
      throttled,
      id: id_0,
      onUpdate,
      transactionId: nextTransactionId
    });
  }, $[29] = client, $[30] = onTransactionStart, $[31] = onUpdate, $[32] = t5) : t5 = $[32];
  const handleUpdate = t5;
  let t6;
  $[33] !== client || $[34] !== currentUser || $[35] !== getComment || $[36] !== onUpdate ? (t6 = async (id_1, reaction) => {
    !client || !currentUser?.id || await reactOperation({
      client,
      currentUser,
      id: id_1,
      reaction,
      getComment,
      onUpdate
    });
  }, $[33] = client, $[34] = currentUser, $[35] = getComment, $[36] = onUpdate, $[37] = t6) : t6 = $[37];
  const handleReact = t6;
  let t7, t8;
  $[38] !== handleCreate || $[39] !== handleReact || $[40] !== handleRemove || $[41] !== handleUpdate ? (t8 = {
    create: handleCreate,
    react: handleReact,
    remove: handleRemove,
    update: handleUpdate
  }, $[38] = handleCreate, $[39] = handleReact, $[40] = handleRemove, $[41] = handleUpdate, $[42] = t8) : t8 = $[42];
  const t9 = t8;
  let t10;
  return $[43] !== t9 ? (t10 = {
    operation: t9
  }, $[43] = t9, $[44] = t10) : t10 = $[44], t7 = t10, t7;
}
function _temp$P(routerState) {
  return typeof routerState.tool == "string" ? routerState.tool : void 0;
}
function useComments() {
  const value = useContext(CommentsContext);
  if (!value)
    throw new Error("useComments must be used within a CommentsProvider");
  return value;
}
function useCommentsAuthoringPath() {
  const value = useContext(CommentsAuthoringPathContext);
  if (!value)
    throw new Error("useCommentsAuthoringPath: missing context value");
  return value;
}
function useCommentsEnabled() {
  return useContext(CommentsEnabledContext);
}
function useCommentsOnboarding() {
  const ctx = useContext(CommentsOnboardingContext);
  if (!ctx)
    throw new Error("useCommentsOnboarding: missing context value");
  return ctx;
}
const BASE_SCROLL_OPTIONS = {
  behavior: "smooth",
  inline: "center",
  scrollMode: "if-needed"
}, GROUP_SCROLL_OPTIONS = {
  ...BASE_SCROLL_OPTIONS,
  block: "start"
}, INLINE_COMMENT_SCROLL_OPTIONS = {
  ...BASE_SCROLL_OPTIONS,
  block: "center"
}, SCROLL_TO_FIELD_OPTIONS = {
  ...BASE_SCROLL_OPTIONS,
  block: "center"
}, SCROLL_TO_COMMENT_OPTIONS = {
  ...BASE_SCROLL_OPTIONS,
  block: "center"
}, SCROLL_OPTIONS_BY_TYPE = {
  comment: SCROLL_TO_COMMENT_OPTIONS,
  field: SCROLL_TO_FIELD_OPTIONS,
  group: GROUP_SCROLL_OPTIONS,
  "inline-comment": INLINE_COMMENT_SCROLL_OPTIONS
};
function generateValidAttrValue(id2) {
  const symbolsToRemove = /[[\]_"_=.]/g;
  return id2.replace(symbolsToRemove, "");
}
function applyCommentIdAttr(id2) {
  return {
    "data-comments-comment-id": generateValidAttrValue(id2)
  };
}
function applyCommentsFieldAttr(id2) {
  return {
    "data-comments-field-id": generateValidAttrValue(id2)
  };
}
function applyCommentsGroupAttr(id2) {
  return {
    "data-comments-group-id": generateValidAttrValue(id2)
  };
}
function applyInlineCommentIdAttr(id2) {
  return {
    "data-comments-inline-comment-id": generateValidAttrValue(id2)
  };
}
function useCommentsScroll(opts) {
  const $ = c(14);
  let t0;
  $[0] !== opts ? (t0 = opts || {}, $[0] = opts, $[1] = t0) : t0 = $[1];
  const {
    boundaryElement
  } = t0, [scrollTarget, setScrollTarget] = useState(null);
  let t1;
  const options = SCROLL_OPTIONS_BY_TYPE[scrollTarget?.type || "comment"];
  let t2;
  $[2] !== boundaryElement || $[3] !== options ? (t2 = {
    ...options,
    boundary: boundaryElement
  }, $[2] = boundaryElement, $[3] = options, $[4] = t2) : t2 = $[4], t1 = t2;
  const scrollOpts = t1;
  let t3;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (commentId) => {
    setScrollTarget({
      type: "comment",
      id: commentId
    });
  }, $[5] = t3) : t3 = $[5];
  const handleScrollToComment = t3;
  let t4;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t4 = (threadId) => {
    setScrollTarget({
      type: "group",
      id: threadId
    });
  }, $[6] = t4) : t4 = $[6];
  const handleScrollToGroup = t4;
  let t5;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (fieldPath) => {
    setScrollTarget({
      type: "field",
      id: fieldPath
    });
  }, $[7] = t5) : t5 = $[7];
  const handleScrollToField = t5;
  let t6;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t6 = (commentId_0) => {
    setScrollTarget({
      type: "inline-comment",
      id: commentId_0
    });
  }, $[8] = t6) : t6 = $[8];
  const handleScrollToInlineComment = t6;
  let t7, t8;
  $[9] !== scrollOpts || $[10] !== scrollTarget ? (t7 = () => {
    const raf2 = requestAnimationFrame(() => {
      if (!scrollTarget)
        return;
      const {
        type,
        id: id2
      } = scrollTarget, element = document?.querySelector(`[data-comments-${type}-id="${generateValidAttrValue(id2)}"]`);
      element && scrollIntoView$1(element, scrollOpts);
    });
    return () => {
      cancelAnimationFrame(raf2);
    };
  }, t8 = [scrollOpts, scrollTarget], $[9] = scrollOpts, $[10] = scrollTarget, $[11] = t7, $[12] = t8) : (t7 = $[11], t8 = $[12]), useEffect(t7, t8);
  let t9, t10;
  return $[13] === Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    scrollToComment: handleScrollToComment,
    scrollToField: handleScrollToField,
    scrollToGroup: handleScrollToGroup,
    scrollToInlineComment: handleScrollToInlineComment
  }, $[13] = t10) : t10 = $[13], t9 = t10, t9;
}
function useCommentsSelectedPath() {
  const ctx = useContext(CommentsSelectedPathContext);
  if (!ctx)
    throw new Error("useCommentsSelectedPath: missing context value");
  return ctx;
}
const CommentLinkCopied = defineEvent({
  name: "Comment Link Copied",
  version: 1,
  description: "The link to a comment is copied"
}), CommentViewedFromLink = defineEvent({
  name: "Comment Viewed From Link",
  version: 1,
  description: "A comment is viewed from a link"
}), CommentListViewChanged = defineEvent({
  name: "Comment List View Changed",
  version: 1,
  description: "The view of the comment list is changed"
});
function useCommentsTelemetry() {
  const $ = c(10), telemetry = useTelemetry();
  let t0;
  $[0] !== telemetry ? (t0 = () => {
    telemetry.log(CommentLinkCopied);
  }, $[0] = telemetry, $[1] = t0) : t0 = $[1];
  const commentLinkCopied = t0;
  let t1;
  $[2] !== telemetry ? (t1 = () => {
    telemetry.log(CommentViewedFromLink);
  }, $[2] = telemetry, $[3] = t1) : t1 = $[3];
  const commentViewedFromLink = t1;
  let t2;
  $[4] !== telemetry ? (t2 = (view) => {
    telemetry.log(CommentListViewChanged, {
      view
    });
  }, $[4] = telemetry, $[5] = t2) : t2 = $[5];
  const commentListViewChanged = t2;
  let t3, t4;
  return $[6] !== commentLinkCopied || $[7] !== commentListViewChanged || $[8] !== commentViewedFromLink ? (t4 = {
    commentLinkCopied,
    commentListViewChanged,
    commentViewedFromLink
  }, $[6] = commentLinkCopied, $[7] = commentListViewChanged, $[8] = commentViewedFromLink, $[9] = t4) : t4 = $[9], t3 = t4, t3;
}
function useCommentsUpsell() {
  const $ = c(1), value = useContext(CommentsUpsellContext);
  if (!value) {
    let t0;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      upsellData: null,
      handleOpenDialog: _temp$O,
      upsellDialogOpen: !1,
      telemetryLogs: {
        dialogSecondaryClicked: _temp2$f,
        dialogPrimaryClicked: _temp3$5,
        panelViewed: _temp4$2,
        panelDismissed: _temp5$1,
        panelPrimaryClicked: _temp6,
        panelSecondaryClicked: _temp7
      }
    }, $[0] = t0) : t0 = $[0], t0;
  }
  return value;
}
function _temp7() {
  return null;
}
function _temp6() {
  return null;
}
function _temp5$1() {
  return null;
}
function _temp4$2() {
  return null;
}
function _temp3$5() {
  return null;
}
function _temp2$f() {
  return null;
}
function _temp$O() {
  return null;
}
function useResolveCommentsEnabled(documentId, documentType) {
  const $ = c(3), {
    enabled: featureEnabled,
    isLoading,
    error
  } = useFeatureEnabled("studioComments"), {
    enabled
  } = useSource().document.comments;
  let t0;
  t0 = enabled({
    documentType,
    documentId: getPublishedId(documentId)
  });
  const enabledFromConfig = t0;
  let t1;
  bb0: {
    if (isLoading || !enabledFromConfig || error) {
      let t22;
      $[0] === Symbol.for("react.memo_cache_sentinel") ? (t22 = {
        enabled: !1,
        mode: null
      }, $[0] = t22) : t22 = $[0], t1 = t22;
      break bb0;
    }
    const t2 = featureEnabled ? "default" : "upsell";
    let t3;
    $[1] !== t2 ? (t3 = {
      enabled: !0,
      mode: t2
    }, $[1] = t2, $[2] = t3) : t3 = $[2], t1 = t3;
  }
  return t1;
}
function createCommentsSet(comments2) {
  return comments2.reduce((acc, comment) => ({
    ...acc,
    [comment._id]: comment
  }), {});
}
function commentsReducer(state, action) {
  switch (action.type) {
    case "COMMENTS_SET": {
      const commentsById = createCommentsSet(action.comments);
      return {
        ...state,
        comments: commentsById
      };
    }
    case "COMMENT_ADDED": {
      const nextCommentResult = action.payload, nextCommentValue = nextCommentResult, nextComment = {
        [nextCommentResult._id]: {
          ...state.comments[nextCommentResult._id],
          ...nextCommentValue,
          _state: nextCommentResult._state || void 0,
          // If the comment is created optimistically, it won't have a createdAt date as this is set on the server.
          // However, we need to set a createdAt date to be able to sort the comments correctly.
          // Therefore, we set the createdAt date to the current date here if it's missing while creating the comment.
          // Once the comment is created and received from the server, the createdAt date will be updated to the correct value.
          _createdAt: nextCommentResult._createdAt || (/* @__PURE__ */ new Date()).toISOString()
        }
      };
      return {
        ...state,
        comments: {
          ...state.comments,
          ...nextComment
        }
      };
    }
    case "COMMENT_RECEIVED": {
      const nextCommentResult = action.payload;
      return {
        ...state,
        comments: {
          ...state.comments,
          [nextCommentResult._id]: nextCommentResult
        }
      };
    }
    case "COMMENT_DELETED": {
      const {
        [action.id]: _,
        ...restComments
      } = state.comments;
      return Object.keys(restComments).forEach((commentId) => {
        restComments[commentId].parentCommentId === action.id && delete restComments[commentId];
      }), {
        ...state,
        comments: restComments
      };
    }
    case "COMMENT_UPDATED": {
      const updatedComment = action.payload, id2 = updatedComment._id, comment = state.comments[id2], optimisticReactions = comment?.reactions?.filter((v) => v?._optimisticState) || [], incomingReactions = updatedComment.reactions || [], nextReactions = mergeCommentReactions(optimisticReactions, incomingReactions), nextComment = {
        // Add existing comment data
        ...comment,
        // Add incoming comment data
        ...updatedComment,
        // Add reactions merged with optimistic reactions
        reactions: nextReactions
      };
      return {
        ...state,
        comments: {
          ...state.comments,
          [id2]: nextComment
        }
      };
    }
    default:
      return state;
  }
}
const INITIAL_STATE$4 = {
  comments: {}
}, LISTEN_OPTIONS$1 = {
  events: ["welcome", "mutation", "reconnect"],
  includeResult: !0,
  includeAllVersions: !0,
  visibility: "query",
  tag: "comments-store"
}, SORT_FIELD$1 = "_createdAt", SORT_ORDER$1 = "desc", QUERY_FILTERS$1 = ['_type == "comment"', "target.document._ref == $documentId"], VERSION_FILTER = "target.documentVersionId==$documentVersionId", NO_VERSION_FILTER = "!defined(target.documentVersionId)", QUERY_PROJECTION$1 = `{
  _createdAt,
  _id,
  authorId,
  contentSnapshot,
  context,
  lastEditedAt,
  message,
  parentCommentId,
  reactions,
  status,
  target,
  threadId
}`, QUERY_SORT_ORDER$1 = `order(${SORT_FIELD$1} ${SORT_ORDER$1})`;
function useCommentsStore(opts) {
  const {
    client,
    documentId,
    onLatestTransactionIdReceived,
    transactionsIdMap,
    releaseId
  } = opts, filters = [...QUERY_FILTERS$1, releaseId ? VERSION_FILTER : NO_VERSION_FILTER].join(" && "), query = useMemo(() => `*[${filters}] ${QUERY_PROJECTION$1} | ${QUERY_SORT_ORDER$1}`, [filters]), [state, dispatch] = useReducer(commentsReducer, INITIAL_STATE$4), [loading, setLoading] = useState(client !== null), [error, setError] = useState(null), didInitialFetch = useRef(!1), params = useMemo(() => ({
    documentId: getPublishedId(documentId),
    ...releaseId ? {
      documentVersionId: releaseId
    } : {}
  }), [documentId, releaseId]), initialFetch = useCallback(async () => {
    if (!client) {
      setLoading(!1);
      return;
    }
    try {
      const res = await client.fetch(query, params);
      dispatch({
        type: "COMMENTS_SET",
        comments: res
      }), setLoading(!1);
    } catch (err) {
      setError(err);
    }
  }, [client, params, query]), handleListenerEvent = useCallback(async (event) => {
    if (event.type === "welcome" && !didInitialFetch.current && (setLoading(!0), await initialFetch(), setLoading(!1), didInitialFetch.current = !0), event.type === "reconnect" && (setLoading(!0), didInitialFetch.current = !1), event.type === "mutation") {
      if (event.transition === "appear") {
        const nextComment = event.result;
        nextComment && dispatch({
          type: "COMMENT_RECEIVED",
          payload: nextComment
        });
      }
      if (event.transition === "disappear" && dispatch({
        type: "COMMENT_DELETED",
        id: event.documentId
      }), event.transition === "update") {
        const updatedComment = event.result, id2 = event.result?._id || "", transactionId = event.transactionId, latestTransactionId = transactionsIdMap.get(id2), isLatestTransaction = transactionId === latestTransactionId;
        if (!isLatestTransaction && latestTransactionId) return;
        updatedComment && (dispatch({
          type: "COMMENT_UPDATED",
          payload: updatedComment
        }), isLatestTransaction && onLatestTransactionIdReceived(id2));
      }
    }
  }, [initialFetch, onLatestTransactionIdReceived, transactionsIdMap]), listener$ = useMemo(() => client ? client.observable.listen(`*[${filters}]`, params, LISTEN_OPTIONS$1).pipe(catchError$1((err_0) => (setError(err_0), of(err_0)))) : of(), [client, filters, params]);
  return useEffect(() => {
    const sub2 = listener$.subscribe(handleListenerEvent);
    return () => {
      sub2?.unsubscribe();
    };
  }, [handleListenerEvent, listener$]), {
    data: useMemo(() => Object.values(state.comments), [state.comments]),
    dispatch,
    error,
    loading
  };
}
const EMPTY_ARRAY$e = [], EMPTY_COMMENTS_DATA = {
  open: EMPTY_ARRAY$e,
  resolved: EMPTY_ARRAY$e
}, CommentsProvider = memo(function(props2) {
  const {
    children,
    documentId,
    documentType,
    isCommentsOpen,
    onCommentsOpen,
    sortOrder,
    type,
    getCommentLink,
    onClearSelectedComment,
    selectedCommentId,
    isConnecting,
    onPathOpen,
    releaseId,
    mentionsDisabled
  } = props2, commentsEnabled = useCommentsEnabled(), [status, setStatus] = useState("open"), {
    client,
    createAddonDataset,
    isCreatingDataset
  } = useAddonDataset(), publishedId = getPublishedId(documentId), editState2 = useEditState(publishedId, documentType, "low", releaseId), schemaType = useSchema().get(documentType), currentUser = useCurrentUser(), {
    name: workspaceName,
    dataset,
    projectId
  } = useWorkspace(), documentValue = useMemo(() => releaseId ? editState2.version : editState2.draft || editState2.published, [editState2.version, editState2.draft, editState2.published, releaseId]), documentRevisionId = useMemo(() => documentValue?._rev, [documentValue]), transactionsIdMap = useMemo(() => /* @__PURE__ */ new Map(), []), handleOnLatestTransactionIdReceived = useCallback((commentDocumentId) => {
    transactionsIdMap.delete(commentDocumentId);
  }, [transactionsIdMap]), {
    dispatch,
    data = EMPTY_ARRAY$e,
    error,
    loading
  } = useCommentsStore({
    documentId,
    releaseId,
    client,
    transactionsIdMap,
    onLatestTransactionIdReceived: handleOnLatestTransactionIdReceived
  }), handleOnTransactionStart = useCallback((commentDocumentId_0, transactionId) => {
    transactionsIdMap.set(commentDocumentId_0, transactionId);
  }, [transactionsIdMap]), handleSetStatus = useCallback((newStatus) => commentsEnabled.mode === "upsell" && newStatus === "resolved" ? null : setStatus(newStatus), [setStatus, commentsEnabled]), mentionOptions = useUserListWithPermissions(useMemo(() => ({
    documentValue,
    permission: "read"
  }), [documentValue])), threadItemsByStatus = useMemo(() => {
    if (!schemaType || !currentUser) return EMPTY_COMMENTS_DATA;
    const sorted = orderBy(data, ["_createdAt"], [sortOrder]), items = buildCommentThreadItems({
      comments: sorted,
      currentUser,
      documentValue,
      schemaType,
      type
    });
    return {
      open: items.filter((item) => item.parentComment.status === "open"),
      resolved: items.filter((item_0) => item_0.parentComment.status === "resolved")
    };
  }, [currentUser, data, documentValue, schemaType, sortOrder, type]), getThreadLength = useCallback((threadId) => threadItemsByStatus.open.filter((item_1) => item_1.threadId === threadId).length, [threadItemsByStatus.open]), getComment = useCallback((id2) => data?.find((c2) => c2._id === id2), [data]), handleOnCreate = useCallback((payload) => {
    const hasError = data?.find((c_0) => c_0._id === payload._id)?._state?.type === "createError";
    dispatch({
      type: "COMMENT_ADDED",
      payload: {
        ...payload,
        _state: hasError ? {
          type: "createRetrying"
        } : void 0
      }
    });
  }, [data, dispatch]), handleOnUpdate = useCallback((id_0, payload_0) => {
    dispatch({
      type: "COMMENT_UPDATED",
      payload: {
        _id: id_0,
        ...payload_0
      }
    });
  }, [dispatch]), handleOnCreateError = useCallback((id_1, err) => {
    dispatch({
      type: "COMMENT_UPDATED",
      payload: {
        _id: id_1,
        _state: {
          error: err,
          type: "createError"
        }
      }
    });
  }, [dispatch]), {
    operation
  } = useCommentOperations(useMemo(() => ({
    client,
    currentUser,
    dataset,
    documentId: publishedId,
    // use the current release id as document version id of the target
    documentVersionId: releaseId,
    documentRevisionId,
    documentType,
    getComment,
    getThreadLength,
    projectId,
    schemaType,
    workspace: workspaceName,
    // This function runs when the first comment creation is executed.
    // It is used to create the addon dataset and configure a client for
    // the addon dataset.
    createAddonDataset,
    // The following callbacks runs when the comment operation are executed.
    // They are used to update the local state of the comments immediately after
    // a comment operation has been executed. This is done to avoid waiting for
    // the real time listener to update the comments and make the UI feel more
    // responsive. The comment will be updated again when we receive an mutation
    // event from the real time listener.
    onCreate: handleOnCreate,
    onCreateError: handleOnCreateError,
    onUpdate: handleOnUpdate,
    onTransactionStart: handleOnTransactionStart,
    getCommentLink
  }), [client, currentUser, dataset, publishedId, releaseId, documentRevisionId, documentType, getComment, getThreadLength, projectId, schemaType, workspaceName, createAddonDataset, handleOnCreate, handleOnCreateError, handleOnUpdate, handleOnTransactionStart, getCommentLink])), ctxValue = useMemo(() => ({
    documentId,
    documentType,
    isCreatingDataset,
    status,
    setStatus: handleSetStatus,
    getComment,
    getCommentLink,
    onClearSelectedComment,
    selectedCommentId,
    isCommentsOpen,
    onCommentsOpen,
    isConnecting,
    onPathOpen,
    comments: {
      data: threadItemsByStatus,
      error,
      loading: loading || isCreatingDataset || isConnecting || !1
    },
    operation: {
      create: operation.create,
      react: operation.react,
      remove: operation.remove,
      update: operation.update
    },
    mentionOptions: {
      ...mentionOptions,
      disabled: mentionsDisabled
    }
  }), [documentId, documentType, isCreatingDataset, status, handleSetStatus, getComment, getCommentLink, onClearSelectedComment, selectedCommentId, isCommentsOpen, onCommentsOpen, isConnecting, onPathOpen, threadItemsByStatus, error, loading, operation.create, operation.react, operation.remove, operation.update, mentionOptions, mentionsDisabled]);
  return /* @__PURE__ */ jsx(CommentsContext.Provider, { value: ctxValue, children });
}), CommentsEnabledProvider = memo(function(props2) {
  const $ = c(3), {
    children,
    documentId,
    documentType
  } = props2, value = useResolveCommentsEnabled(documentId, documentType);
  let t0;
  return $[0] !== children || $[1] !== value ? (t0 = /* @__PURE__ */ jsx(CommentsEnabledContext.Provider, { value, children }), $[0] = children, $[1] = value, $[2] = t0) : t0 = $[2], t0;
}), CommentsIntentProvider = memo(function(props2) {
  const $ = c(3), {
    children,
    getIntent
  } = props2;
  let t0;
  return $[0] !== children || $[1] !== getIntent ? (t0 = /* @__PURE__ */ jsx(CommentsIntentContext.Provider, { value: getIntent, children }), $[0] = children, $[1] = getIntent, $[2] = t0) : t0 = $[2], t0;
}), VERSION = 1, LOCAL_STORAGE_KEY$2 = `sanityStudio:comments:inspector:onboarding:dismissed:v${VERSION}`, setLocalStorage = (value) => {
  try {
    window.localStorage.setItem(LOCAL_STORAGE_KEY$2, JSON.stringify(value));
  } catch {
  }
}, getLocalStorage = () => {
  try {
    const value = window.localStorage.getItem(LOCAL_STORAGE_KEY$2);
    return value ? JSON.parse(value) : !1;
  } catch {
    return !1;
  }
};
function CommentsOnboardingProvider(props2) {
  const $ = c(7), {
    children
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = getLocalStorage(), $[0] = t0) : t0 = $[0];
  const [dismissed, setDismissed] = useState(t0);
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setDismissed(!0), setLocalStorage(!0);
  }, $[1] = t1) : t1 = $[1];
  const handleDismiss = t1;
  let t2, t3;
  $[2] !== dismissed ? (t3 = {
    setDismissed: handleDismiss,
    isDismissed: dismissed
  }, $[2] = dismissed, $[3] = t3) : t3 = $[3], t2 = t3;
  const ctxValue = t2;
  let t4;
  return $[4] !== children || $[5] !== ctxValue ? (t4 = /* @__PURE__ */ jsx(CommentsOnboardingContext.Provider, { value: ctxValue, children }), $[4] = children, $[5] = ctxValue, $[6] = t4) : t4 = $[6], t4;
}
const CommentsSelectedPathProvider = memo(function(props2) {
  const $ = c(8), {
    children
  } = props2, [selectedPath, setSelectedPath] = useState(null);
  let t0;
  $[0] !== selectedPath ? (t0 = (nextPath) => {
    isEqual$2(selectedPath, nextPath) || setSelectedPath(nextPath);
  }, $[0] = selectedPath, $[1] = t0) : t0 = $[1];
  const handleSelectPath = t0;
  let t1, t2;
  $[2] !== handleSelectPath || $[3] !== selectedPath ? (t2 = {
    selectedPath,
    setSelectedPath: handleSelectPath
  }, $[2] = handleSelectPath, $[3] = selectedPath, $[4] = t2) : t2 = $[4], t1 = t2;
  const ctxValue = t1;
  let t3;
  return $[5] !== children || $[6] !== ctxValue ? (t3 = /* @__PURE__ */ jsx(CommentsSelectedPathContext.Provider, { value: ctxValue, children }), $[5] = children, $[6] = ctxValue, $[7] = t3) : t3 = $[7], t3;
}), FEATURE$2 = "comments", TEMPLATE_OPTIONS$2 = {
  interpolate: /{{([\s\S]+?)}}/g
}, BASE_URL$2 = "www.sanity.io";
function CommentsUpsellProvider(props2) {
  const $ = c(31), [upsellDialogOpen, setUpsellDialogOpen] = useState(!1), [upsellData, setUpsellData] = useState(null), projectId = useProjectId$1(), telemetry = useTelemetry(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0, t1;
  $[0] !== telemetry ? (t1 = {
    dialogSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature: FEATURE$2,
      type: "modal"
    }),
    dialogPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature: FEATURE$2,
      type: "modal"
    }),
    panelViewed: (source) => telemetry.log(UpsellDialogViewed, {
      feature: FEATURE$2,
      type: "inspector",
      source
    }),
    panelDismissed: () => telemetry.log(UpsellDialogDismissed, {
      feature: FEATURE$2,
      type: "inspector"
    }),
    panelPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature: FEATURE$2,
      type: "inspector"
    }),
    panelSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature: FEATURE$2,
      type: "inspector"
    })
  }, $[0] = telemetry, $[1] = t1) : t1 = $[1], t0 = t1;
  const telemetryLogs = t0;
  let t2;
  $[2] !== telemetryLogs ? (t2 = () => {
    telemetryLogs.dialogPrimaryClicked();
  }, $[2] = telemetryLogs, $[3] = t2) : t2 = $[3];
  const handlePrimaryButtonClick = t2;
  let t3;
  $[4] !== telemetryLogs ? (t3 = () => {
    telemetryLogs.dialogSecondaryClicked();
  }, $[4] = telemetryLogs, $[5] = t3) : t3 = $[5];
  const handleSecondaryButtonClick = t3;
  let t4;
  $[6] !== telemetry ? (t4 = () => {
    setUpsellDialogOpen(!1), telemetry.log(UpsellDialogDismissed, {
      feature: FEATURE$2,
      type: "modal"
    });
  }, $[6] = telemetry, $[7] = t4) : t4 = $[7];
  const handleClose = t4;
  let t5;
  $[8] !== client.observable || $[9] !== projectId ? (t5 = () => {
    const sub2 = client.observable.request({
      uri: "/journey/comments"
    }).subscribe({
      next: (data) => {
        if (data)
          try {
            const ctaUrl = template(data.ctaButton.url, TEMPLATE_OPTIONS$2);
            data.ctaButton.url = ctaUrl({
              baseUrl: BASE_URL$2,
              projectId
            });
            const secondaryUrl = template(data.secondaryButton.url, TEMPLATE_OPTIONS$2);
            data.secondaryButton.url = secondaryUrl({
              baseUrl: BASE_URL$2,
              projectId
            }), setUpsellData(data);
          } catch {
          }
      },
      error: _temp$N
    });
    return () => {
      sub2.unsubscribe();
    };
  }, $[8] = client.observable, $[9] = projectId, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== client || $[12] !== projectId ? (t6 = [client, projectId], $[11] = client, $[12] = projectId, $[13] = t6) : t6 = $[13], useEffect(t5, t6);
  let t7;
  $[14] !== telemetry ? (t7 = (source_0) => {
    setUpsellDialogOpen(!0), telemetry.log(UpsellDialogViewed, {
      feature: FEATURE$2,
      type: "modal",
      source: source_0
    });
  }, $[14] = telemetry, $[15] = t7) : t7 = $[15];
  const handleOpenDialog = t7;
  let t8, t9;
  $[16] !== handleOpenDialog || $[17] !== telemetryLogs || $[18] !== upsellData || $[19] !== upsellDialogOpen ? (t9 = {
    upsellDialogOpen,
    handleOpenDialog,
    upsellData,
    telemetryLogs
  }, $[16] = handleOpenDialog, $[17] = telemetryLogs, $[18] = upsellData, $[19] = upsellDialogOpen, $[20] = t9) : t9 = $[20], t8 = t9;
  const ctxValue = t8;
  let t10;
  $[21] !== handleClose || $[22] !== handlePrimaryButtonClick || $[23] !== handleSecondaryButtonClick || $[24] !== upsellData || $[25] !== upsellDialogOpen ? (t10 = upsellData && upsellDialogOpen && /* @__PURE__ */ jsx(UpsellDialog, { data: upsellData, onClose: handleClose, onPrimaryClick: handlePrimaryButtonClick, onSecondaryClick: handleSecondaryButtonClick }), $[21] = handleClose, $[22] = handlePrimaryButtonClick, $[23] = handleSecondaryButtonClick, $[24] = upsellData, $[25] = upsellDialogOpen, $[26] = t10) : t10 = $[26];
  let t11;
  return $[27] !== ctxValue || $[28] !== props2.children || $[29] !== t10 ? (t11 = /* @__PURE__ */ jsxs(CommentsUpsellContext.Provider, { value: ctxValue, children: [
    props2.children,
    t10
  ] }), $[27] = ctxValue, $[28] = props2.children, $[29] = t10, $[30] = t11) : t11 = $[30], t11;
}
function _temp$N() {
}
function CommentsDocumentLayout(props2) {
  const $ = c(8), {
    documentId,
    documentType
  } = props2;
  if (useCommentsEnabled().mode !== null) {
    let t02;
    return $[0] !== props2 ? (t02 = /* @__PURE__ */ jsx(CommentsDocumentLayoutInner, { ...props2 }), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommentsDocumentLayoutInner, { ...props2 }), $[2] = props2, $[3] = t0) : t0 = $[3];
  let t1;
  return $[4] !== documentId || $[5] !== documentType || $[6] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentsEnabledProvider, { documentId, documentType, children: t0 }), $[4] = documentId, $[5] = documentType, $[6] = t0, $[7] = t1) : t1 = $[7], t1;
}
function CommentsDocumentLayoutInner(props2) {
  const $ = c(6);
  if (!useCommentsEnabled().enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== props2 ? (t0 = props2.renderDefault(props2), $[2] = props2, $[3] = t0) : t0 = $[3];
  let t1;
  return $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentsSelectedPathProvider, { children: /* @__PURE__ */ jsx(CommentsAuthoringPathProvider, { children: t0 }) }), $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const COMMENTS_INSPECTOR_NAME = "sanity/comments", COMMENTS_HIGHLIGHT_HUE_KEY = "yellow", COMMENT_REACTION_OPTIONS = [{
  shortName: ":+1:",
  title: "Thumbs up"
}, {
  shortName: ":-1:",
  title: "Thumbs down"
}, {
  shortName: ":heart:",
  title: "Heart"
}, {
  shortName: ":rocket:",
  title: "Rocket"
}, {
  shortName: ":heavy_plus_sign:",
  title: "Heavy plus sign"
}, {
  shortName: ":eyes:",
  title: "Eyes"
}], COMMENT_REACTION_EMOJIS = {
  ":-1:": "\u{1F44E}",
  ":+1:": "\u{1F44D}",
  ":eyes:": "\u{1F440}",
  ":heart:": "\u2764\uFE0F",
  ":heavy_plus_sign:": "\u2795",
  ":rocket:": "\u{1F680}"
}, ContentStack$1 = styled(Stack)`
  width: 320px;
`;
function CommentsFieldButton(props2) {
  const $ = c(69), {
    count: count2,
    currentUser,
    fieldTitle,
    isCreatingDataset,
    mentionOptions,
    onChange,
    onClick: onClick2,
    onClose,
    onCommentAdd,
    onDiscard,
    onInputKeyDown,
    open,
    value
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace), popoverRef = useRef(null), [addCommentButtonElement, setAddCommentButtonElement] = useState(null), commentInputHandle = useRef(null), hasComments = count2 > 0;
  let t0;
  $[0] !== addCommentButtonElement || $[1] !== onClose || $[2] !== open ? (t0 = () => {
    open && (onClose(), addCommentButtonElement?.focus());
  }, $[0] = addCommentButtonElement, $[1] = onClose, $[2] = open, $[3] = t0) : t0 = $[3];
  const closePopover = t0;
  let t1;
  $[4] !== closePopover || $[5] !== onCommentAdd ? (t1 = () => {
    onCommentAdd(), closePopover();
  }, $[4] = closePopover, $[5] = onCommentAdd, $[6] = t1) : t1 = $[6];
  const handleSubmit = t1;
  let t2, t3;
  $[7] !== value ? (t3 = hasCommentMessageValue(value), $[7] = value, $[8] = t3) : t3 = $[8], t2 = t3;
  const hasValue2 = t2;
  let t4;
  $[9] !== closePopover || $[10] !== hasValue2 ? (t4 = () => {
    if (!hasValue2) {
      closePopover();
      return;
    }
    commentInputHandle.current?.discardDialogController.open();
  }, $[9] = closePopover, $[10] = hasValue2, $[11] = t4) : t4 = $[11];
  const startDiscard = t4;
  let t5;
  $[12] !== onInputKeyDown ? (t5 = (event) => {
    event.isDefaultPrevented() || onInputKeyDown && onInputKeyDown(event);
  }, $[12] = onInputKeyDown, $[13] = t5) : t5 = $[13];
  const handleInputKeyDown = t5;
  let t6;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    commentInputHandle.current?.discardDialogController.close();
  }, $[14] = t6) : t6 = $[14];
  const handleDiscardCancel = t6;
  let t7;
  $[15] !== closePopover || $[16] !== onDiscard ? (t7 = () => {
    commentInputHandle.current?.discardDialogController.close(), closePopover(), onDiscard();
  }, $[15] = closePopover, $[16] = onDiscard, $[17] = t7) : t7 = $[17];
  const handleDiscardConfirm = t7;
  let t8;
  $[18] !== startDiscard ? (t8 = (event_0) => {
    event_0.key === "Escape" && (event_0.preventDefault(), event_0.stopPropagation(), startDiscard());
  }, $[18] = startDiscard, $[19] = t8) : t8 = $[19];
  const handlePopoverKeyDown = t8;
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => [popoverRef.current], $[20] = t9) : t9 = $[20], useClickOutsideEvent(!open && startDiscard, t9), !hasComments) {
    let t102;
    $[21] !== fieldTitle ? (t102 = {
      field: fieldTitle
    }, $[21] = fieldTitle, $[22] = t102) : t102 = $[22];
    let t112;
    $[23] !== t || $[24] !== t102 ? (t112 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: "compose.add-comment-input-placeholder", values: t102 }), $[23] = t, $[24] = t102, $[25] = t112) : t112 = $[25];
    const placeholder = t112;
    let t122;
    $[26] !== currentUser || $[27] !== handleDiscardConfirm || $[28] !== handleInputKeyDown || $[29] !== handleSubmit || $[30] !== isCreatingDataset || $[31] !== mentionOptions || $[32] !== onChange || $[33] !== placeholder || $[34] !== value ? (t122 = /* @__PURE__ */ jsx(ContentStack$1, { padding: 2, space: 4, children: /* @__PURE__ */ jsx(CommentInput, { currentUser, focusLock: !0, focusOnMount: !0, mentionOptions, onChange, onDiscardCancel: handleDiscardCancel, onDiscardConfirm: handleDiscardConfirm, onKeyDown: handleInputKeyDown, onSubmit: handleSubmit, placeholder, readOnly: isCreatingDataset, ref: commentInputHandle, value }) }), $[26] = currentUser, $[27] = handleDiscardConfirm, $[28] = handleInputKeyDown, $[29] = handleSubmit, $[30] = isCreatingDataset, $[31] = mentionOptions, $[32] = onChange, $[33] = placeholder, $[34] = value, $[35] = t122) : t122 = $[35];
    const content = t122;
    let t132;
    $[36] === Symbol.for("react.memo_cache_sentinel") ? (t132 = ["bottom-end"], $[36] = t132) : t132 = $[36];
    let t142;
    $[37] !== t ? (t142 = t("field-button.aria-label-add"), $[37] = t, $[38] = t142) : t142 = $[38];
    let t152;
    $[39] !== t ? (t152 = t("field-button.title"), $[39] = t, $[40] = t152) : t152 = $[40];
    let t162;
    $[41] !== t152 ? (t162 = {
      content: t152,
      placement: "top"
    }, $[41] = t152, $[42] = t162) : t162 = $[42];
    let t17;
    $[43] !== isCreatingDataset || $[44] !== onClick2 || $[45] !== open || $[46] !== t142 || $[47] !== t162 ? (t17 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { "aria-label": t142, disabled: isCreatingDataset, icon: AddCommentIcon, mode: "bleed", onClick: onClick2, ref: setAddCommentButtonElement, selected: open, tooltipProps: t162 }) }), $[43] = isCreatingDataset, $[44] = onClick2, $[45] = open, $[46] = t142, $[47] = t162, $[48] = t17) : t17 = $[48];
    let t18;
    return $[49] !== content || $[50] !== handlePopoverKeyDown || $[51] !== open || $[52] !== t17 ? (t18 = /* @__PURE__ */ jsx(Popover, { constrainSize: !0, content, fallbackPlacements: t132, open, placement: "right-start", portal: !0, ref: popoverRef, onKeyDown: handlePopoverKeyDown, children: t17 }), $[49] = content, $[50] = handlePopoverKeyDown, $[51] = open, $[52] = t17, $[53] = t18) : t18 = $[53], t18;
  }
  let t10;
  $[54] !== count2 || $[55] !== t ? (t10 = t("field-button.content", {
    count: count2
  }), $[54] = count2, $[55] = t, $[56] = t10) : t10 = $[56];
  let t11;
  $[57] !== t ? (t11 = t("field-button.aria-label-open"), $[57] = t, $[58] = t11) : t11 = $[58];
  let t12;
  $[59] === Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(CommentIcon, {}) }), $[59] = t12) : t12 = $[59];
  const t13 = count2 > 9 ? "9+" : count2;
  let t14;
  $[60] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t12,
    /* @__PURE__ */ jsx(Text$1, { size: 0, children: t13 })
  ] }), $[60] = t13, $[61] = t14) : t14 = $[61];
  let t15;
  $[62] !== onClick2 || $[63] !== t11 || $[64] !== t14 ? (t15 = /* @__PURE__ */ jsx(Button$1, { "aria-label": t11, mode: "bleed", onClick: onClick2, padding: 2, space: 2, children: t14 }), $[62] = onClick2, $[63] = t11, $[64] = t14, $[65] = t15) : t15 = $[65];
  let t16;
  return $[66] !== t10 || $[67] !== t15 ? (t16 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, placement: "top", content: t10, children: t15 }), $[66] = t10, $[67] = t15, $[68] = t16) : t16 = $[68], t16;
}
const messageCache = /* @__PURE__ */ new Map(), EMPTY_ARRAY$d = [], HIGHLIGHT_BLOCK_VARIANTS = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};
function CommentsField(props2) {
  const $ = c(5), {
    enabled,
    mode
  } = useCommentsEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== mode || $[3] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommentFieldInner, { ...props2, mode }), $[2] = mode, $[3] = props2, $[4] = t0) : t0 = $[4], t0;
}
const HighlightDiv = styled(motion.div)(({
  theme
}) => {
  const {
    radius,
    space,
    color
  } = theme.sanity, bg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][color.dark ? 900 : 50].hex;
  return css`
    mix-blend-mode: ${color.dark ? "screen" : "multiply"};
    border-radius: ${radius[3]}px;
    top: -${space[2]}px;
    left: -${space[2]}px;
    bottom: -${space[2]}px;
    right: -${space[2]}px;
    pointer-events: none;
    position: absolute;
    z-index: 1;
    width: calc(100% + ${space[2] * 2}px);
    height: calc(100% + ${space[2] * 2}px);
    background-color: ${bg};
  `;
}), FieldStack = styled(Stack)`
  position: relative;
`;
function CommentFieldInner(props2) {
  const {
    mode
  } = props2, currentUser = useCurrentUser(), {
    element: boundaryElement
  } = useBoundaryElement(), rootRef = useRef(null), {
    comments: comments2,
    isCommentsOpen,
    isCreatingDataset,
    mentionOptions,
    onCommentsOpen,
    operation,
    setStatus,
    status
  } = useComments(), {
    upsellData,
    handleOpenDialog
  } = useCommentsUpsell(), {
    selectedPath,
    setSelectedPath
  } = useCommentsSelectedPath(), {
    authoringPath,
    setAuthoringPath
  } = useCommentsAuthoringPath(), {
    scrollToGroup
  } = useCommentsScroll({
    boundaryElement
  }), fieldTitle = useMemo(() => getSchemaTypeTitle(props2.schemaType), [props2.schemaType]), stringPath = useMemo(() => PathUtils.toString(props2.path), [props2.path]), cachedValue = messageCache.get(stringPath) || null, [value, setValue] = useState(cachedValue), isOpen = useMemo(() => authoringPath === stringPath, [authoringPath, stringPath]), isSelected = useMemo(() => !isCommentsOpen || selectedPath?.origin === "form" || selectedPath?.origin === "url" ? !1 : selectedPath?.fieldPath === stringPath, [isCommentsOpen, selectedPath?.fieldPath, selectedPath?.origin, stringPath]), isInlineCommentThread = useMemo(() => comments2.data.open.filter((c2) => c2.threadId === selectedPath?.threadId).some((x) => isTextSelectionComment(x.parentComment)), [comments2.data.open, selectedPath?.threadId]), count2 = useMemo(() => comments2.data.open.map((c_0) => c_0.fieldPath === stringPath ? c_0.commentsCount : 0).reduce((acc, val) => acc + val, 0) || 0, [comments2.data.open, stringPath]), hasComments = count2 > 0, resetMessageValue = useCallback(() => {
    setValue(null), messageCache.delete(stringPath);
  }, [stringPath]), handleClick = useCallback(() => {
    if (hasComments) {
      status === "resolved" && setStatus("open"), setAuthoringPath(null), onCommentsOpen?.();
      const scrollToThreadId = comments2.data.open.find((c_1) => c_1.fieldPath === PathUtils.toString(props2.path))?.threadId;
      scrollToThreadId && (setSelectedPath({
        threadId: scrollToThreadId,
        origin: "form",
        fieldPath: PathUtils.toString(props2.path)
      }), scrollToGroup(scrollToThreadId));
      return;
    }
    if (mode === "upsell") {
      upsellData ? handleOpenDialog("field_action") : onCommentsOpen?.();
      return;
    }
    setAuthoringPath(isOpen ? null : stringPath);
  }, [comments2.data.open, handleOpenDialog, hasComments, isOpen, mode, onCommentsOpen, props2.path, scrollToGroup, setAuthoringPath, setSelectedPath, setStatus, status, stringPath, upsellData]), handleCommentAdd = useCallback(() => {
    if (value) {
      const newThreadId = uuid(), nextComment = {
        type: "field",
        fieldPath: PathUtils.toString(props2.path),
        message: value,
        parentCommentId: void 0,
        status: "open",
        threadId: newThreadId,
        // New comments have no reactions
        reactions: EMPTY_ARRAY$d
      };
      operation.create(nextComment), onCommentsOpen?.(), status === "resolved" && setStatus("open"), resetMessageValue(), setSelectedPath({
        threadId: newThreadId,
        origin: "form",
        fieldPath: PathUtils.toString(props2.path)
      }), scrollToGroup(newThreadId);
    }
  }, [onCommentsOpen, operation, props2.path, resetMessageValue, scrollToGroup, setSelectedPath, setStatus, status, value]), handleClose = useCallback(() => setAuthoringPath(null), [setAuthoringPath]), handleOnChange = useCallback((nextValue) => {
    setValue(nextValue), messageCache.set(stringPath, nextValue);
  }, [stringPath]), internalComments = useMemo(() => ({
    button: currentUser && /* @__PURE__ */ jsx(CommentsFieldButton, { count: Number(count2), currentUser, fieldTitle, isCreatingDataset, mentionOptions, onChange: handleOnChange, onClick: handleClick, onClose: handleClose, onCommentAdd: handleCommentAdd, onDiscard: resetMessageValue, open: isOpen, value }),
    hasComments,
    isAddingComment: isOpen
  }), [currentUser, count2, fieldTitle, isCreatingDataset, mentionOptions, handleOnChange, handleClick, handleClose, handleCommentAdd, resetMessageValue, isOpen, value, hasComments]);
  return /* @__PURE__ */ jsxs(FieldStack, { ...applyCommentsFieldAttr(PathUtils.toString(props2.path)), ref: rootRef, children: [
    props2.renderDefault({
      ...props2,
      // eslint-disable-next-line camelcase
      __internal_comments: internalComments
    }),
    /* @__PURE__ */ jsx(AnimatePresence, { children: isSelected && !isInlineCommentThread && /* @__PURE__ */ jsx(HighlightDiv, { animate: "animate", exit: "exit", initial: "initial", variants: HIGHLIGHT_BLOCK_VARIANTS }) })
  ] });
}
function createDomRectFromElements(elements) {
  if (!elements || !elements.length) return null;
  const rects = elements.map((el) => el.getBoundingClientRect()), minX = Math.min(...rects.map((r) => r.x)) || 0, minY = Math.min(...rects.map((r) => r.y)) || 0, maxRight = Math.max(...rects.map((r) => r.right)) || 0, maxBottom = Math.max(...rects.map((r) => r.bottom)) || 0;
  return {
    x: minX,
    y: minY,
    width: maxRight - minX,
    height: maxBottom - minY,
    top: minY,
    right: maxRight,
    bottom: maxBottom,
    left: minX
  };
}
function useRectFromElements(props2) {
  const $ = c(10), {
    scrollElement,
    disabled,
    selector
  } = props2, [rect, setRect] = useState(null);
  let t0;
  $[0] !== disabled || $[1] !== selector ? (t0 = () => {
    if (disabled)
      return;
    const elements = document?.querySelectorAll(selector);
    if (!elements)
      return;
    const nextRect = createDomRectFromElements(Array.from(elements));
    setRect(nextRect);
  }, $[0] = disabled, $[1] = selector, $[2] = t0) : t0 = $[2];
  const handleSetRect = t0;
  let t1;
  $[3] !== handleSetRect ? (t1 = [handleSetRect], $[3] = handleSetRect, $[4] = t1) : t1 = $[4], useEffect(handleSetRect, t1);
  let t2, t3;
  return $[5] !== disabled || $[6] !== handleSetRect || $[7] !== scrollElement ? (t2 = () => {
    if (!(disabled || !scrollElement))
      return scrollElement.addEventListener("wheel", handleSetRect), () => {
        scrollElement.removeEventListener("wheel", handleSetRect);
      };
  }, t3 = [handleSetRect, disabled, scrollElement], $[5] = disabled, $[6] = handleSetRect, $[7] = scrollElement, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3), rect;
}
function useAuthoringReferenceElement(props2) {
  const $ = c(6), {
    scrollElement,
    disabled,
    selector
  } = props2;
  let t0;
  $[0] !== disabled || $[1] !== scrollElement || $[2] !== selector ? (t0 = {
    scrollElement,
    disabled,
    selector
  }, $[0] = disabled, $[1] = scrollElement, $[2] = selector, $[3] = t0) : t0 = $[3];
  const rect = useRectFromElements(t0);
  let t1;
  bb0: {
    if (!rect) {
      t1 = null;
      break bb0;
    }
    let t2;
    $[4] !== rect ? (t2 = {
      getBoundingClientRect: () => rect
    }, $[4] = rect, $[5] = t2) : t2 = $[5], t1 = t2;
  }
  return t1;
}
function getSelectionBoundingRect() {
  const selection = window.getSelection();
  let range2 = null;
  return selection && selection.rangeCount > 0 && (range2 = selection.getRangeAt(0)), range2?.getBoundingClientRect() || null;
}
const MotionPopover$1 = styled(motion.create(Popover))`
  user-select: none;
`, POPOVER_FALLBACK_PLACEMENTS$3 = ["bottom", "top"], VARIANTS$4 = {
  hidden: {
    opacity: 0,
    y: -4
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
function FloatingButtonPopover(props2) {
  const $ = c(13), {
    disabled,
    onClick: onClick2,
    onClickOutside,
    referenceElement
  } = props2, buttonRef = useRef(null), {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => [buttonRef.current], $[0] = t0) : t0 = $[0], useClickOutsideEvent(onClickOutside, t0);
  let t1;
  $[1] !== t ? (t1 = t("inline-add-comment-button.disabled-overlap-title"), $[1] = t, $[2] = t1) : t1 = $[2];
  const disabledText = t1;
  let t2;
  $[3] !== t ? (t2 = t("inline-add-comment-button.title"), $[3] = t, $[4] = t2) : t2 = $[4];
  const text = disabled ? disabledText : t2, t3 = disabled ? CommentDisabledIcon : AddCommentIcon;
  let t4;
  $[5] !== disabled || $[6] !== onClick2 || $[7] !== t3 || $[8] !== text ? (t4 = /* @__PURE__ */ jsx(Button, { "data-testid": "inline-comment-button", disabled, icon: t3, mode: "bleed", onClick: onClick2, ref: buttonRef, text }), $[5] = disabled, $[6] = onClick2, $[7] = t3, $[8] = text, $[9] = t4) : t4 = $[9];
  const content = t4;
  let t5;
  return $[10] !== content || $[11] !== referenceElement ? (t5 = /* @__PURE__ */ jsx(MotionPopover$1, { animate: "visible", content, contentEditable: !1, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$3, initial: "hidden", open: !0, padding: 1, placement: "bottom", portal: !0, referenceElement, variants: VARIANTS$4 }), $[10] = content, $[11] = referenceElement, $[12] = t5) : t5 = $[12], t5;
}
const POPOVER_FALLBACK_PLACEMENTS$2 = ["bottom", "top"], MotionPopover = motion.create(Popover), RootStack$1 = styled(Stack)`
  width: 250px;
`, VARIANTS$3 = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  }
};
function InlineCommentInputPopover(props2) {
  const $ = c(17), {
    currentUser,
    mentionOptions,
    onChange,
    onClickOutside,
    onDiscardConfirm,
    onSubmit,
    referenceElement,
    value
  } = props2, commentInputRef = useRef(null), contentElementRef = useRef(null);
  let t0;
  $[0] !== onDiscardConfirm ? (t0 = () => {
    commentInputRef.current?.discardDialogController.close(), onDiscardConfirm();
  }, $[0] = onDiscardConfirm, $[1] = t0) : t0 = $[1];
  const handleDiscardConfirm = t0;
  let t1;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    commentInputRef.current?.discardDialogController.close();
  }, $[2] = t1) : t1 = $[2];
  const handleDiscardCancel = t1;
  let t2;
  $[3] !== onClickOutside || $[4] !== value ? (t2 = () => {
    if (hasCommentMessageValue(value)) {
      commentInputRef.current?.discardDialogController.open();
      return;
    }
    onClickOutside();
  }, $[3] = onClickOutside, $[4] = value, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => [contentElementRef.current], $[6] = t3) : t3 = $[6], useClickOutsideEvent(t2, t3);
  let t4;
  $[7] !== currentUser || $[8] !== handleDiscardConfirm || $[9] !== mentionOptions || $[10] !== onChange || $[11] !== onSubmit || $[12] !== value ? (t4 = /* @__PURE__ */ jsx(RootStack$1, { padding: 2, ref: contentElementRef, children: /* @__PURE__ */ jsx(CommentInput, { currentUser, focusLock: !0, focusOnMount: !0, mentionOptions, onChange, onDiscardCancel: handleDiscardCancel, onDiscardConfirm: handleDiscardConfirm, onSubmit, ref: commentInputRef, value }) }), $[7] = currentUser, $[8] = handleDiscardConfirm, $[9] = mentionOptions, $[10] = onChange, $[11] = onSubmit, $[12] = value, $[13] = t4) : t4 = $[13];
  const content = t4;
  let t5;
  return $[14] !== content || $[15] !== referenceElement ? (t5 = /* @__PURE__ */ jsx(MotionPopover, { animate: "visible", content, "data-ui": "InlineCommentInputPopover", fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$2, initial: "hidden", open: !0, placement: "bottom", portal: !0, referenceElement, variants: VARIANTS$3 }), $[14] = content, $[15] = referenceElement, $[16] = t5) : t5 = $[16], t5;
}
const EMPTY_ARRAY$c = [], AI_ASSIST_TYPE = "sanity.assist.instruction.prompt";
function CommentsPortableTextInput(props2) {
  const $ = c(5), {
    enabled,
    mode
  } = useCommentsEnabled(), isAiAssist = props2.schemaType.name === AI_ASSIST_TYPE;
  if (!enabled || isAiAssist) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== mode || $[3] !== props2 ? (t0 = /* @__PURE__ */ jsx(CommentsPortableTextInputInner, { ...props2, mode }), $[2] = mode, $[3] = props2, $[4] = t0) : t0 = $[4], t0;
}
const CommentsPortableTextInputInner = memo(function(props2) {
  const {
    mode
  } = props2, currentUser = useCurrentUser(), portal = usePortal(), {
    comments: comments2,
    getComment,
    mentionOptions,
    onCommentsOpen,
    operation,
    setStatus,
    status
  } = useComments(), {
    setSelectedPath,
    selectedPath
  } = useCommentsSelectedPath(), {
    scrollToComment,
    scrollToGroup
  } = useCommentsScroll(), {
    handleOpenDialog
  } = useCommentsUpsell(), editorRef = useRef(null), mouseDownRef = useRef(!1), [authoringDecorationElement, setAuthoringDecorationElement] = useState(null), [nextCommentValue, setNextCommentValue] = useState(null), [nextCommentSelection, setNextCommentSelection] = useState(null), [currentSelection, setCurrentSelection] = useState(null), [currentSelectionRect, setCurrenSelectionRect] = useState(null), [currentHoveredCommentId, setCurrentHoveredCommentId] = useState(null), [canSubmit, setCanSubmit] = useState(!1), [rootElement, setRootElement] = useState(null), [isFullScreen, setIsFullScreen] = useState(!1), [addedCommentsDecorations, setAddedCommentsDecorations] = useState(EMPTY_ARRAY$c), stringFieldPath = useMemo(() => PathUtils.toString(props2.path), [props2.path]), handleSetCurrentSelectionRect = useCallback(() => {
    const rect = getSelectionBoundingRect();
    setCurrenSelectionRect(rect);
  }, []), resetStates = useCallback(() => {
    setCurrentSelection(null), setCurrenSelectionRect(null), setNextCommentSelection(null), setNextCommentValue(null), setCanSubmit(!1), setAuthoringDecorationElement(null);
  }, []), handleSelectCurrentSelection = useCallback(() => {
    if (mode === "upsell") {
      handleOpenDialog("pte");
      return;
    }
    setNextCommentSelection(currentSelection);
  }, [currentSelection, handleOpenDialog, mode]), handleCommentDiscardConfirm = useCallback(() => {
    resetStates();
  }, [resetStates]), textComments = useMemo(() => comments2.data.open.filter((comment) => comment.fieldPath === stringFieldPath).filter((c2) => isTextSelectionComment(c2.parentComment)).map((c_0) => c_0.parentComment), [comments2.data.open, stringFieldPath]), getFragment = useCallback(() => editorRef.current ? PortableTextEditor.getFragment(editorRef.current) : EMPTY_ARRAY$c, []), handleSubmit = useCallback(() => {
    if (!nextCommentSelection || !editorRef.current) return;
    const fragment = getFragment() || EMPTY_ARRAY$c, editorValue = PortableTextEditor.getValue(editorRef.current);
    if (!editorValue) return;
    const textSelection = buildTextSelectionFromFragment({
      fragment,
      selection: nextCommentSelection,
      value: editorValue
    }), threadId = uuid();
    operation.create({
      type: "field",
      contentSnapshot: fragment,
      fieldPath: stringFieldPath,
      message: nextCommentValue,
      parentCommentId: void 0,
      reactions: EMPTY_ARRAY$c,
      selection: textSelection,
      status: "open",
      threadId
    }), onCommentsOpen?.(), status === "resolved" && setStatus("open"), setSelectedPath({
      fieldPath: stringFieldPath,
      threadId,
      origin: "form"
    }), scrollToGroup(threadId), resetStates();
  }, [nextCommentSelection, getFragment, operation, stringFieldPath, nextCommentValue, onCommentsOpen, status, setSelectedPath, scrollToGroup, resetStates, setStatus]), handleDecoratorClick = useCallback((commentId) => {
    const comment_0 = getComment(commentId);
    comment_0 && (setSelectedPath({
      fieldPath: comment_0.target.path?.field || "",
      threadId: comment_0.threadId,
      origin: "form"
    }), onCommentsOpen?.(), scrollToComment(comment_0._id));
  }, [getComment, onCommentsOpen, scrollToComment, setSelectedPath]), blurred = useRef(!1), handleSelectionChange = useCallback((selection) => {
    const isRangeSelected = selection?.anchor.offset !== selection?.focus.offset;
    if (!getFragment()?.every(isPortableTextTextBlock) || !isRangeSelected) {
      setCanSubmit(!1);
      return;
    }
    if (blurred.current) {
      blurred.current = !1;
      return;
    }
    mouseDownRef.current || handleSetCurrentSelectionRect(), setCurrentSelection(selection), setCanSubmit(!0);
  }, [getFragment, handleSetCurrentSelectionRect]), debounceSelectionChange = useMemo(() => debounce(handleSelectionChange, 200), [handleSelectionChange]), handleMouseDown = useCallback(() => {
    mouseDownRef.current = !0;
  }, []), handleMouseUp = useCallback(() => {
    mouseDownRef.current = !1, handleSetCurrentSelectionRect();
  }, [handleSetCurrentSelectionRect]), handleRangeDecorationMoved = useCallback((details) => {
    const {
      rangeDecoration,
      newSelection
    } = details, commentId_0 = rangeDecoration.payload?.commentId;
    setAddedCommentsDecorations((prev) => prev.map((p) => p.payload?.commentId === commentId_0 ? {
      ...rangeDecoration,
      selection: newSelection,
      payload: {
        ...rangeDecoration.payload,
        dirty: !0
      }
    } : p));
  }, []), updateCommentRange = useCallback(() => {
    const decoratorsToUpdate = addedCommentsDecorations.filter((decorator) => decorator.payload?.dirty);
    decoratorsToUpdate.length !== 0 && (decoratorsToUpdate.forEach((decorator_0) => {
      const commentId_1 = decorator_0.payload?.commentId, comment_1 = getComment(commentId_1 || "");
      if (!comment_1 || !editorRef.current) return;
      const editorValue_0 = PortableTextEditor.getValue(editorRef.current) || EMPTY_ARRAY$c, [updatedDecoration] = buildRangeDecorationSelectionsFromComments({
        comments: [comment_1],
        value: editorValue_0
      }), nextRange = updatedDecoration?.range ? [updatedDecoration.range] : EMPTY_ARRAY$c, nextValue = updatedDecoration ? [...comment_1.target.path?.selection?.value.filter((r) => r._key !== nextRange[0]?._key).concat(nextRange).flat() || EMPTY_ARRAY$c] : EMPTY_ARRAY$c, nextComment = {
        target: {
          ...comment_1.target,
          path: {
            ...comment_1.target?.path || {},
            field: comment_1.target.path?.field || "",
            selection: {
              type: "text",
              value: nextValue
            }
          }
        }
      };
      operation.update(comment_1._id, nextComment);
    }), setAddedCommentsDecorations((prev_0) => prev_0.map((p_0) => decoratorsToUpdate.find((d) => d.payload?.commentId === p_0.payload?.commentId)?.payload?.dirty ? {
      ...p_0,
      payload: {
        ...p_0.payload,
        dirty: !1
      }
    } : p_0).filter((p_1) => p_1.selection !== null)));
  }, [addedCommentsDecorations, getComment, operation]), handleBuildRangeDecorations = useCallback((commentsToDecorate) => {
    if (!editorRef.current) return EMPTY_ARRAY$c;
    const editorValue_1 = PortableTextEditor.getValue(editorRef.current) || EMPTY_ARRAY$c;
    return buildCommentRangeDecorations({
      comments: commentsToDecorate,
      currentHoveredCommentId,
      onDecorationClick: handleDecoratorClick,
      onDecorationHoverEnd: setCurrentHoveredCommentId,
      onDecorationHoverStart: setCurrentHoveredCommentId,
      onDecorationMoved: handleRangeDecorationMoved,
      selectedThreadId: selectedPath?.threadId || null,
      value: editorValue_1
    });
  }, [currentHoveredCommentId, handleDecoratorClick, handleRangeDecorationMoved, selectedPath?.threadId]), onEditorChange = useCallback((change) => {
    change.type === "mutation" && updateCommentRange(), change.type === "blur" && (blurred.current = !0), change.type === "selection" && debounceSelectionChange(change.selection);
  }, [debounceSelectionChange, updateCommentRange]), authoringDecoration = useMemo(() => nextCommentSelection ? {
    component: ({
      children
    }) => /* @__PURE__ */ jsx(CommentInlineHighlightSpan, { isAuthoring: !0, ref: setAuthoringDecorationElement, children }),
    selection: nextCommentSelection
  } : null, [nextCommentSelection]), rangeDecorations = useMemo(() => [
    // Existing range decorations
    ...props2?.rangeDecorations || EMPTY_ARRAY$c,
    // The range decoration when adding a comment
    ...authoringDecoration ? [authoringDecoration] : EMPTY_ARRAY$c,
    // The range decorations for existing comments
    ...addedCommentsDecorations
  ], [addedCommentsDecorations, authoringDecoration, props2?.rangeDecorations]), currentSelectionIsOverlapping = useMemo(() => !currentSelection || addedCommentsDecorations.length === 0 ? !1 : addedCommentsDecorations.some((d_0) => {
    if (!editorRef.current) return !1;
    const testA = PortableTextEditor.isSelectionsOverlapping(editorRef.current, currentSelection, d_0.selection), testB = PortableTextEditor.isSelectionsOverlapping(editorRef.current, d_0.selection, currentSelection);
    return testA || testB;
  }), [addedCommentsDecorations, currentSelection]), scrollElement = isFullScreen ? document.body : portal.elements?.documentScrollElement || document.body, boundaryElement = isFullScreen ? portal.elements?.documentScrollElement || document.body : rootElement, popoverAuthoringReferenceElement = useAuthoringReferenceElement({
    scrollElement,
    disabled: !nextCommentSelection || !authoringDecorationElement,
    selector: '[data-inline-comment-state="authoring"]'
  }), selectionReferenceElement = useMemo(() => currentSelectionRect ? {
    getBoundingClientRect: () => currentSelectionRect
  } : null, [currentSelectionRect]);
  useEffect(() => {
    if (currentSelection)
      return scrollElement?.addEventListener("wheel", handleSetCurrentSelectionRect), () => {
        scrollElement?.removeEventListener("wheel", handleSetCurrentSelectionRect);
      };
  }, [currentSelection, scrollElement, handleSetCurrentSelectionRect]), useEffect(() => {
    const nextDecorations = handleBuildRangeDecorations(textComments);
    setAddedCommentsDecorations((current) => nextDecorations.map((nextDecoration_1) => {
      const prevDecoration = current.find((p_2) => p_2.payload?.commentId === nextDecoration_1.payload?.commentId);
      return prevDecoration?.payload?.dirty ? {
        ...nextDecoration_1,
        payload: {
          ...nextDecoration_1.payload,
          dirty: prevDecoration.payload.dirty
        }
      } : nextDecoration_1;
    }));
  }, [handleBuildRangeDecorations, textComments]);
  const showFloatingButton = !!(currentSelection && canSubmit && selectionReferenceElement && !mouseDownRef.current), showFloatingInput = !!(nextCommentSelection && popoverAuthoringReferenceElement);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(BoundaryElementProvider, { element: boundaryElement, children: /* @__PURE__ */ jsxs(AnimatePresence, { children: [
      showFloatingInput && currentUser && /* @__PURE__ */ jsx(InlineCommentInputPopover, { currentUser, mentionOptions, onChange: setNextCommentValue, onClickOutside: resetStates, onDiscardConfirm: handleCommentDiscardConfirm, onSubmit: handleSubmit, referenceElement: popoverAuthoringReferenceElement, value: nextCommentValue }),
      showFloatingButton && !showFloatingInput && /* @__PURE__ */ jsx(FloatingButtonPopover, { disabled: currentSelectionIsOverlapping, onClick: handleSelectCurrentSelection, onClickOutside: resetStates, referenceElement: selectionReferenceElement })
    ] }) }),
    /* @__PURE__ */ jsx(Stack, { ref: setRootElement, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, children: props2.renderDefault({
      ...props2,
      onEditorChange,
      editorRef,
      rangeDecorations,
      onFullScreenChange: setIsFullScreen
    }) })
  ] });
});
function isPortableTextInputProps(inputProps) {
  return isArrayOfBlocksSchemaType(inputProps.schemaType);
}
function CommentsInput(props2) {
  const $ = c(4);
  if (isPortableTextInputProps(props2)) {
    let t02;
    return $[0] !== props2 ? (t02 = /* @__PURE__ */ jsx(CommentsPortableTextInput, { ...props2 }), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== props2 ? (t0 = props2.renderDefault(props2), $[2] = props2, $[3] = t0) : t0 = $[3], t0;
}
const FEEDBACK_FORM_LINK$1 = "https://snty.link/comments-beta-feedback", Span$2 = styled.span`
  margin-right: 0.2em;
`, Link$1 = styled.a`
  white-space: nowrap;
`, FooterCard = styled(Card)({
  position: "relative",
  zIndex: 1
});
function CommentsInspectorFeedbackFooter() {
  const $ = c(12), {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = t("feature-feedback.title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t ? (t1 = t("feature-feedback.link"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Span$2, { children: [
    t1,
    " "
  ] }), $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(LaunchIcon, {}), $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t2 ? (t4 = /* @__PURE__ */ jsxs(Link$1, { href: FEEDBACK_FORM_LINK$1, target: "_blank", rel: "noreferrer", children: [
    t2,
    " ",
    t3
  ] }), $[7] = t2, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== t0 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(FooterCard, { padding: 4, children: /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
    t0,
    " ",
    t4
  ] }) }), $[9] = t0, $[10] = t4, $[11] = t5) : t5 = $[11], t5;
}
const Root$d = styled(Card)({
  position: "relative",
  zIndex: 1,
  lineHeight: 0
}), CommentsInspectorHeader = forwardRef(function(props2, ref) {
  const $ = c(57), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    onClose,
    onViewChange,
    view,
    mode
  } = props2;
  let t0;
  $[0] !== onViewChange ? (t0 = () => onViewChange("open"), $[0] = onViewChange, $[1] = t0) : t0 = $[1];
  const handleSetOpenView = t0;
  let t1;
  $[2] !== onViewChange ? (t1 = () => onViewChange("resolved"), $[2] = onViewChange, $[3] = t1) : t1 = $[3];
  const handleSetResolvedView = t1;
  let t2;
  $[4] !== t ? (t2 = t("feature-name"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, gap: 2, paddingY: 2, padding: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "medium", children: t2 }) }), $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t || $[9] !== view ? (t4 = t(view === "open" ? "status-filter.status-open" : "status-filter.status-resolved"), $[8] = t, $[9] = view, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { text: t4, mode: "bleed", iconRight: ChevronDownIcon }), $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    width: "180px"
  }, $[13] = t6) : t6 = $[13];
  const t7 = view === "open" ? CheckmarkIcon : void 0;
  let t8;
  $[14] !== t ? (t8 = t("status-filter.status-open-full"), $[14] = t, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== handleSetOpenView || $[17] !== t7 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsx(MenuItem$1, { iconRight: t7, onClick: handleSetOpenView, text: t8 }), $[16] = handleSetOpenView, $[17] = t7, $[18] = t8, $[19] = t9) : t9 = $[19];
  const t10 = view === "resolved" ? CheckmarkIcon : void 0;
  let t11;
  $[20] !== t ? (t11 = t("status-filter.status-resolved-full"), $[20] = t, $[21] = t11) : t11 = $[21];
  let t12;
  $[22] !== mode || $[23] !== t ? (t12 = mode === "upsell" ? {
    content: t("status-filter.status-resolved-full-upsell")
  } : void 0, $[22] = mode, $[23] = t, $[24] = t12) : t12 = $[24];
  const t13 = mode === "upsell";
  let t14;
  $[25] !== handleSetResolvedView || $[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 ? (t14 = /* @__PURE__ */ jsx(MenuItem$1, { iconRight: t10, onClick: handleSetResolvedView, text: t11, tooltipProps: t12, disabled: t13 }), $[25] = handleSetResolvedView, $[26] = t10, $[27] = t11, $[28] = t12, $[29] = t13, $[30] = t14) : t14 = $[30];
  let t15;
  $[31] !== t14 || $[32] !== t9 ? (t15 = /* @__PURE__ */ jsxs(Menu, { style: t6, children: [
    t9,
    t14
  ] }), $[31] = t14, $[32] = t9, $[33] = t15) : t15 = $[33];
  let t16;
  $[34] === Symbol.for("react.memo_cache_sentinel") ? (t16 = {
    placement: "bottom-end"
  }, $[34] = t16) : t16 = $[34];
  let t17;
  $[35] !== t15 || $[36] !== t5 ? (t17 = /* @__PURE__ */ jsx(MenuButton$1, { id: "comment-status-menu-button", button: t5, menu: t15, popover: t16 }), $[35] = t15, $[36] = t5, $[37] = t17) : t17 = $[37];
  let t18;
  $[38] !== t ? (t18 = t("close-pane-button-text-aria-label"), $[38] = t, $[39] = t18) : t18 = $[39];
  let t19;
  $[40] !== t ? (t19 = t("close-pane-button-text"), $[40] = t, $[41] = t19) : t19 = $[41];
  let t20;
  $[42] !== t19 ? (t20 = {
    content: t19
  }, $[42] = t19, $[43] = t20) : t20 = $[43];
  let t21;
  $[44] !== onClose || $[45] !== t18 || $[46] !== t20 ? (t21 = /* @__PURE__ */ jsx(Button, { "aria-label": t18, icon: CloseIcon, mode: "bleed", onClick: onClose, tooltipProps: t20 }), $[44] = onClose, $[45] = t18, $[46] = t20, $[47] = t21) : t21 = $[47];
  let t22;
  $[48] !== t17 || $[49] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { flex: "none", padding: 1, gap: 2, children: [
    t17,
    t21
  ] }), $[48] = t17, $[49] = t21, $[50] = t22) : t22 = $[50];
  let t23;
  $[51] !== t22 || $[52] !== t3 ? (t23 = /* @__PURE__ */ jsxs(Flex, { padding: 2, children: [
    t3,
    t22
  ] }), $[51] = t22, $[52] = t3, $[53] = t23) : t23 = $[53];
  let t24;
  return $[54] !== ref || $[55] !== t23 ? (t24 = /* @__PURE__ */ jsx(Root$d, { ref, children: t23 }), $[54] = ref, $[55] = t23, $[56] = t24) : t24 = $[56], t24;
}), RootLayer$1 = styled(Layer)`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;
function CommentsInspector(props2) {
  const $ = c(3), {
    enabled,
    mode
  } = useCommentsEnabled();
  if (!enabled)
    return null;
  let t0;
  return $[0] !== mode || $[1] !== props2 ? (t0 = /* @__PURE__ */ jsx(RootLayer$1, { children: /* @__PURE__ */ jsx(CommentsInspectorInner, { ...props2, mode }) }), $[0] = mode, $[1] = props2, $[2] = t0) : t0 = $[2], t0;
}
function CommentsInspectorInner(props2) {
  const {
    t
  } = useTranslation(commentsLocaleNamespace), {
    onClose,
    mode
  } = props2, [showDeleteDialog, setShowDeleteDialog] = useState(!1), [commentToDelete, setCommentToDelete] = useState(null), [deleteLoading, setDeleteLoading] = useState(!1), [deleteError, setDeleteError] = useState(null), rootRef = useRef(null), currentUser = useCurrentUser(), {
    comments: comments2,
    getComment,
    isCreatingDataset,
    mentionOptions,
    setStatus,
    status,
    operation,
    selectedCommentId,
    getCommentLink,
    onClearSelectedComment,
    onPathOpen
  } = useComments(), commentIdParamRef = useRef(selectedCommentId), didScrollToCommentFromParam = useRef(!1), pushToast = useToast().push, {
    isTopLayer
  } = useLayer(), {
    scrollToComment,
    scrollToField,
    scrollToInlineComment
  } = useCommentsScroll(), {
    selectedPath,
    setSelectedPath
  } = useCommentsSelectedPath(), {
    isDismissed,
    setDismissed
  } = useCommentsOnboarding(), telemetry = useCommentsTelemetry(), {
    upsellData,
    telemetryLogs: upsellTelemetryLogs
  } = useCommentsUpsell(), currentComments = useMemo(() => comments2.data[status], [comments2, status]), {
    loading
  } = comments2, handleChangeView = useCallback((nextView) => {
    setStatus(nextView), setSelectedPath(null), telemetry.commentListViewChanged(nextView);
  }, [setSelectedPath, setStatus, telemetry]), handleCloseInspector = useCallback(() => {
    onClose(), setSelectedPath(null);
  }, [onClose, setSelectedPath]), handleCopyLink = useMemo(() => getCommentLink ? (id2) => {
    navigator.clipboard.writeText(getCommentLink(id2)).catch(() => {
      pushToast({
        closable: !0,
        status: "error",
        title: t("copy-link-error-message")
      });
    }), telemetry.commentLinkCopied();
  } : void 0, [getCommentLink, pushToast, t, telemetry]), handleCreateRetry = useCallback((id_0) => {
    const comment = getComment(id_0);
    comment && operation.create({
      type: "field",
      fieldPath: comment.target.path?.field || "",
      id: comment._id,
      message: comment.message,
      parentCommentId: comment.parentCommentId,
      reactions: comment.reactions || [],
      status: comment.status,
      threadId: comment.threadId
    });
  }, [getComment, operation]), closeDeleteDialog = useCallback(() => {
    deleteLoading || (setShowDeleteDialog(!1), setCommentToDelete(null));
  }, [deleteLoading]), handlePathSelect = useCallback((nextPath) => {
    if (setSelectedPath(nextPath), nextPath?.fieldPath) {
      const path = PathUtils.fromString(nextPath.fieldPath);
      onPathOpen?.(path), scrollToField(nextPath.fieldPath), comments2.data.open.filter((c2) => c2.threadId === nextPath?.threadId).some((x) => isTextSelectionComment(x.parentComment)) && nextPath.threadId && scrollToInlineComment(nextPath.threadId);
    }
  }, [comments2.data.open, onPathOpen, scrollToField, scrollToInlineComment, setSelectedPath]), handleNewThreadCreate = useCallback((nextComment) => {
    const fieldPath = nextComment?.payload?.fieldPath || "";
    operation.create({
      type: "field",
      fieldPath,
      message: nextComment.message,
      parentCommentId: nextComment.parentCommentId,
      reactions: nextComment.reactions,
      status: nextComment.status,
      threadId: nextComment.threadId
    }), setSelectedPath({
      fieldPath,
      origin: "inspector",
      threadId: nextComment.threadId
    });
  }, [operation, setSelectedPath]), handleReply = useCallback((nextComment_0) => {
    operation.create({
      ...nextComment_0,
      type: "field",
      fieldPath: nextComment_0?.payload?.fieldPath || ""
    });
  }, [operation]), handleEdit = useCallback((id_1, nextComment_1) => {
    operation.update(id_1, nextComment_1);
  }, [operation]), onDeleteStart = useCallback((id_2) => {
    const parent = currentComments.find((c_0) => c_0.parentComment?._id === id_2), isParent = !!(parent && parent?.replies?.length > 0);
    setShowDeleteDialog(!0), setCommentToDelete({
      commentId: id_2,
      isParent
    });
  }, [currentComments]), handleDeleteConfirm = useCallback(async (id_3) => {
    try {
      setDeleteLoading(!0), await operation.remove(id_3), closeDeleteDialog();
    } catch (err) {
      setDeleteError(err);
    } finally {
      setDeleteLoading(!1);
    }
  }, [closeDeleteDialog, operation]), handleStatusChange = useCallback((id_4, nextStatus) => {
    if (operation.update(id_4, {
      status: nextStatus
    }), nextStatus === "open") {
      setStatus("open");
      const comment_0 = getComment(id_4);
      if (!comment_0) return;
      setSelectedPath({
        fieldPath: comment_0.target.path?.field || null,
        origin: "inspector",
        threadId: comment_0.threadId || null
      }), scrollToComment(id_4);
    }
  }, [getComment, operation, scrollToComment, setSelectedPath, setStatus]), handleReactionSelect = useCallback((id_5, reaction) => {
    operation.react(id_5, reaction);
  }, [operation]), handleDeselectPath = useCallback(() => {
    selectedPath && isTopLayer && setSelectedPath(null);
  }, [isTopLayer, selectedPath, setSelectedPath]);
  useClickOutsideEvent((event) => {
    event.target instanceof HTMLElement && event.target?.hasAttribute("data-slate-string") || handleDeselectPath();
  }, () => [rootRef.current]);
  const [loggedTelemetry, setLoggedTelemetry] = useState(!1);
  useEffect(() => {
    if (!(loggedTelemetry || mode !== "upsell"))
      return setLoggedTelemetry(!0), selectedPath?.origin === "form" ? upsellTelemetryLogs.panelViewed("field_action") : commentIdParamRef.current ? upsellTelemetryLogs.panelViewed("link") : upsellTelemetryLogs.panelViewed("document_action"), () => {
        upsellTelemetryLogs.panelDismissed();
      };
  }, [loggedTelemetry, mode, selectedPath?.origin, upsellTelemetryLogs]), useEffect(() => {
    const commentToScrollTo = getComment(commentIdParamRef.current || "");
    !loading && commentToScrollTo && didScrollToCommentFromParam.current === !1 && (setStatus(commentToScrollTo.status || "open"), setSelectedPath({
      fieldPath: commentToScrollTo.target.path?.field || null,
      origin: "url",
      threadId: commentToScrollTo.threadId || null
    }), scrollToComment(commentToScrollTo._id), didScrollToCommentFromParam.current = !0, commentIdParamRef.current = void 0, onClearSelectedComment?.(), telemetry.commentViewedFromLink());
  }, [getComment, loading, onClearSelectedComment, scrollToComment, setSelectedPath, setStatus, telemetry]);
  const beforeListNode = useMemo(() => mode === "upsell" && upsellData ? /* @__PURE__ */ jsx(
    CommentsUpsellPanel,
    {
      data: upsellData,
      onPrimaryClick: upsellTelemetryLogs.panelPrimaryClicked,
      onSecondaryClick: upsellTelemetryLogs.panelSecondaryClicked
    }
  ) : null, [mode, upsellTelemetryLogs.panelPrimaryClicked, upsellTelemetryLogs.panelSecondaryClicked, upsellData]);
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    commentToDelete && showDeleteDialog && /* @__PURE__ */ jsx(CommentDeleteDialog, { ...commentToDelete, error: deleteError, loading: deleteLoading, onClose: closeDeleteDialog, onConfirm: handleDeleteConfirm }),
    /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, height: "fill", onClick: handleDeselectPath, overflow: "hidden", ref: rootRef, children: [
      /* @__PURE__ */ jsx(CommentsOnboardingPopover, { onDismiss: setDismissed, open: !isDismissed, placement: "left-start", children: /* @__PURE__ */ jsx(CommentsInspectorHeader, { onClose: handleCloseInspector, onViewChange: handleChangeView, view: status, mode }) }),
      currentUser && /* @__PURE__ */ jsx(CommentsList, { beforeListNode, comments: currentComments, currentUser, error: comments2.error, loading, mentionOptions, mode, onCopyLink: handleCopyLink, onCreateRetry: handleCreateRetry, onDelete: onDeleteStart, onEdit: handleEdit, onNewThreadCreate: handleNewThreadCreate, onPathSelect: handlePathSelect, onReactionSelect: handleReactionSelect, onReply: handleReply, onStatusChange: handleStatusChange, readOnly: isCreatingDataset, selectedPath, status }),
      mode === "default" && /* @__PURE__ */ jsx(CommentsInspectorFeedbackFooter, {})
    ] })
  ] });
}
function useMenuItem() {
  const $ = c(5), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    enabled
  } = useCommentsEnabled(), t0 = !enabled;
  let t1;
  $[0] !== t ? (t1 = t("feature-name"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t0 || $[3] !== t1 ? (t2 = {
    hidden: t0,
    icon: CommentIcon,
    showAsAction: !0,
    title: t1
  }, $[2] = t0, $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
const commentsInspector = {
  name: COMMENTS_INSPECTOR_NAME,
  component: CommentsInspector,
  useMenuItem
};
function CommentsStudioLayout(props2) {
  const $ = c(5), {
    enabled,
    isLoading
  } = useFeatureEnabled("studioComments"), t0 = !enabled && !isLoading;
  let t1;
  $[0] !== props2 ? (t1 = props2.renderDefault(props2), $[0] = props2, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t0 || $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(AddonDatasetProvider, { children: /* @__PURE__ */ jsx(CommentsOnboardingProvider, { children: /* @__PURE__ */ jsx(ConditionalWrapper, { condition: t0, wrapper: _temp$M, children: t1 }) }) }), $[2] = t0, $[3] = t1, $[4] = t2) : t2 = $[4], t2;
}
function _temp$M(children) {
  return /* @__PURE__ */ jsx(CommentsUpsellProvider, { children });
}
const comments = definePlugin({
  name: "sanity/comments",
  document: {
    inspectors: [commentsInspector],
    components: {
      unstable_layout: CommentsDocumentLayout
    }
  },
  form: {
    components: {
      field: CommentsField,
      input: CommentsInput
    }
  },
  studio: {
    components: {
      layout: CommentsStudioLayout
    }
  },
  i18n: {
    bundles: [commentsUsEnglishLocaleBundle]
  }
}), isStaging$1 = typeof __SANITY_STAGING__ < "u" && __SANITY_STAGING__ === !0;
function getCreateBaseUrl(customHost) {
  return `https://${customHost ?? isStaging$1 ? "create-staging.sanity.build" : "www.sanity.io"}/app/create`;
}
function getCreateDocumentUrl(create) {
  return `${getCreateBaseUrl(create.host)}/${create.dataset}/${create._id}`;
}
const createLocaleNamespace = "create", createUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: createLocaleNamespace,
  resources: () => import("./_chunks-es/resources5.mjs")
}, CreateDocumentLinkCtaClicked = defineEvent({
  name: "Create Document Link CTA Clicked",
  version: 1,
  description: 'The "Start in Sanity Create" button is clicked.'
}), CreateDocumentLinkAccepted = defineEvent({
  name: "Create Document Link Accepted",
  version: 1,
  description: 'Continue in the "Start in Sanity Create" dialog was pressed, or auto-confirm was enabled.'
}), CreateDocumentUnlinkCtaClicked = defineEvent({
  name: "Create Document Unlink CTA Clicked",
  version: 1,
  description: "The Unlink action was clicked"
}), CreateDocumentUnlinkApproved = defineEvent({
  name: "Create Document Unlink Approved",
  version: 1,
  description: "User confirmed that they want the Studio document unlinked"
}), CreateDocumentOpened = defineEvent({
  name: "Create Document Opened",
  version: 1,
  description: 'User clicked "Edit in Create"'
});
function useSanityCreateTelemetry() {
  const $ = c(16), telemetry = useTelemetry();
  let t0;
  $[0] !== telemetry ? (t0 = () => telemetry.log(CreateDocumentLinkCtaClicked), $[0] = telemetry, $[1] = t0) : t0 = $[1];
  const startInCreateClicked = t0;
  let t1;
  $[2] !== telemetry ? (t1 = () => telemetry.log(CreateDocumentLinkAccepted), $[2] = telemetry, $[3] = t1) : t1 = $[3];
  const startInCreateAccepted = t1;
  let t2;
  $[4] !== telemetry ? (t2 = () => telemetry.log(CreateDocumentUnlinkCtaClicked), $[4] = telemetry, $[5] = t2) : t2 = $[5];
  const unlinkClicked = t2;
  let t3;
  $[6] !== telemetry ? (t3 = () => telemetry.log(CreateDocumentUnlinkApproved), $[6] = telemetry, $[7] = t3) : t3 = $[7];
  const unlinkAccepted = t3;
  let t4;
  $[8] !== telemetry ? (t4 = () => telemetry.log(CreateDocumentOpened), $[8] = telemetry, $[9] = t4) : t4 = $[9];
  const editInCreateClicked = t4;
  let t5, t6;
  return $[10] !== editInCreateClicked || $[11] !== startInCreateAccepted || $[12] !== startInCreateClicked || $[13] !== unlinkAccepted || $[14] !== unlinkClicked ? (t6 = {
    linkCtaClicked: startInCreateClicked,
    linkAccepted: startInCreateAccepted,
    unlinkCtaClicked: unlinkClicked,
    unlinkApproved: unlinkAccepted,
    documentOpened: editInCreateClicked
  }, $[10] = editInCreateClicked, $[11] = startInCreateAccepted, $[12] = startInCreateClicked, $[13] = unlinkAccepted, $[14] = unlinkClicked, $[15] = t6) : t6 = $[15], t5 = t6, t5;
}
function CreateUnlinkConfirmDialog(props2) {
  const $ = c(40), {
    onClose,
    onDocumentChange,
    documentTitle
  } = props2, id2 = useId(), [unlinking, setUnlinking] = useState(!1), {
    t
  } = useTranslation(createLocaleNamespace), telemetry = useSanityCreateTelemetry();
  let t0;
  $[0] !== onDocumentChange || $[1] !== telemetry ? (t0 = () => {
    setUnlinking(!0), onDocumentChange(PatchEvent.from(unset(["_create"]))), telemetry.unlinkApproved();
  }, $[0] = onDocumentChange, $[1] = telemetry, $[2] = t0) : t0 = $[2];
  const unlink = t0;
  let t1;
  $[3] !== t ? (t1 = t("unlink-from-create-dialog.cancel.text"), $[3] = t, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== onClose || $[6] !== t1 ? (t2 = {
    onClick: onClose,
    text: t1
  }, $[5] = onClose, $[6] = t1, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== t ? (t3 = t("unlink-from-create-dialog.unlink.text"), $[8] = t, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t3 || $[11] !== unlink || $[12] !== unlinking ? (t4 = {
    disabled: unlinking,
    onClick: unlink,
    text: t3,
    tone: "primary"
  }, $[10] = t3, $[11] = unlink, $[12] = unlinking, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== t2 || $[15] !== t4 ? (t5 = {
    cancelButton: t2,
    confirmButton: t4
  }, $[14] = t2, $[15] = t4, $[16] = t5) : t5 = $[16];
  let t6;
  $[17] !== t ? (t6 = t("unlink-from-create-dialog.header"), $[17] = t, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== documentTitle || $[20] !== t ? (t7 = documentTitle || t("unlink-from-create-dialog.document.untitled.text"), $[19] = documentTitle, $[20] = t, $[21] = t7) : t7 = $[21];
  let t8;
  $[22] !== t7 ? (t8 = {
    title: t7
  }, $[22] = t7, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== t || $[25] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "unlink-from-create-dialog.first-paragraph", values: t8 }) }), $[24] = t, $[25] = t8, $[26] = t9) : t9 = $[26];
  let t10;
  $[27] !== t ? (t10 = t("unlink-from-create-dialog.second-paragraph"), $[27] = t, $[28] = t10) : t10 = $[28];
  let t11;
  $[29] !== t10 ? (t11 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t10 }), $[29] = t10, $[30] = t11) : t11 = $[30];
  let t12;
  $[31] !== t11 || $[32] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t9,
    t11
  ] }), $[31] = t11, $[32] = t9, $[33] = t12) : t12 = $[33];
  let t13;
  return $[34] !== id2 || $[35] !== onClose || $[36] !== t12 || $[37] !== t5 || $[38] !== t6 ? (t13 = /* @__PURE__ */ jsx(Dialog$1, { footer: t5, id: id2, header: t6, onClose, children: t12 }), $[34] = id2, $[35] = onClose, $[36] = t12, $[37] = t5, $[38] = t6, $[39] = t13) : t13 = $[39], t13;
}
function DialogPortalProvider(props2) {
  const $ = c(3), {
    children,
    portalElementId
  } = props2, {
    element,
    elements
  } = usePortal(), portalElement = elements?.[portalElementId] || element;
  let t0;
  return $[0] !== children || $[1] !== portalElement ? (t0 = /* @__PURE__ */ jsx(PortalProvider, { element: portalElement, children }), $[0] = children, $[1] = portalElement, $[2] = t0) : t0 = $[2], t0;
}
function CreateLinkedActions(props2) {
  const $ = c(27), {
    metadata,
    panelPortalElementId,
    onDocumentChange,
    documentTitle
  } = props2, {
    t
  } = useTranslation(createLocaleNamespace);
  let t0;
  $[0] !== metadata ? (t0 = getCreateDocumentUrl(metadata), $[0] = metadata, $[1] = t0) : t0 = $[1];
  const href = t0, telemetry = useSanityCreateTelemetry();
  let t1;
  $[2] !== telemetry ? (t1 = () => telemetry.documentOpened(), $[2] = telemetry, $[3] = t1) : t1 = $[3];
  const onEditInCreateClicked = t1, [unlinkConfirm, setUnlinkConfirm] = useState(!1);
  let t2;
  $[4] !== telemetry ? (t2 = () => {
    setUnlinkConfirm(!0), telemetry.unlinkCtaClicked();
  }, $[4] = telemetry, $[5] = t2) : t2 = $[5];
  const confirmUnlink = t2;
  let t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setUnlinkConfirm(!1), $[6] = t3) : t3 = $[6];
  const cancelUnlink = t3;
  let t4;
  $[7] !== t ? (t4 = t("edit-in-create-button.text"), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== href || $[10] !== onEditInCreateClicked || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { as: "a", text: t4, iconRight: LaunchIcon, mode: "ghost", href, target: "_blank", onClick: onEditInCreateClicked }), $[9] = href, $[10] = onEditInCreateClicked, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== t ? (t6 = t("unlink-from-create-button.text"), $[13] = t, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== confirmUnlink || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsx(Button, { text: t6, onClick: confirmUnlink }), $[15] = confirmUnlink, $[16] = t6, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== documentTitle || $[19] !== onDocumentChange || $[20] !== panelPortalElementId || $[21] !== unlinkConfirm ? (t8 = unlinkConfirm && /* @__PURE__ */ jsx(DialogPortalProvider, { portalElementId: panelPortalElementId, children: /* @__PURE__ */ jsx(CreateUnlinkConfirmDialog, { onClose: cancelUnlink, onDocumentChange, documentTitle }) }), $[18] = documentTitle, $[19] = onDocumentChange, $[20] = panelPortalElementId, $[21] = unlinkConfirm, $[22] = t8) : t8 = $[22];
  let t9;
  return $[23] !== t5 || $[24] !== t7 || $[25] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { gap: 2, children: [
    t5,
    t7,
    t8
  ] }), $[23] = t5, $[24] = t7, $[25] = t8, $[26] = t9) : t9 = $[26], t9;
}
const createUserDocumentationUrl = "https://snty.link/create-docs?ref=studio", CreateLearnMoreButton = forwardRef(function(props2, ref) {
  const $ = c(5), {
    t
  } = useTranslation(createLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = t("start-in-create-dialog.cta.learn-more"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== ref || $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(Button, { as: "a", href: createUserDocumentationUrl, target: "_blank", ref, text: t0, mode: "bleed", tone: "primary", iconRight: LaunchIcon }), $[2] = ref, $[3] = t0, $[4] = t1) : t1 = $[4], t1;
});
function CreateSvg() {
  const $ = c(7);
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    display: "block"
  }, t1 = /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("rect", { width: "307", height: "201", fill: "url(#paint0_radial_38_7016)" }),
    /* @__PURE__ */ jsx("path", { d: "M168.5 -0.5V-1H167.5V-0.5H168.5ZM167.646 174.854C167.842 175.049 168.158 175.049 168.354 174.854L171.536 171.672C171.731 171.476 171.731 171.16 171.536 170.964C171.34 170.769 171.024 170.769 170.828 170.964L168 173.793L165.172 170.964C164.976 170.769 164.66 170.769 164.464 170.964C164.269 171.16 164.269 171.476 164.464 171.672L167.646 174.854ZM167.5 -0.5V174.5H168.5V-0.5H167.5Z", fill: "url(#paint1_linear_38_7016)" }),
    /* @__PURE__ */ jsx("path", { d: "M251 37.5H352C353.381 37.5 354.5 38.6193 354.5 40V64C354.5 65.3807 353.381 66.5 352 66.5H251C249.619 66.5 248.5 65.3807 248.5 64V40C248.5 38.6193 249.619 37.5 251 37.5Z", fill: "#181410", stroke: "#F9BC15" }),
    /* @__PURE__ */ jsx("path", { d: "M251 104.5H352C353.381 104.5 354.5 105.619 354.5 107V210C354.5 211.381 353.381 212.5 352 212.5H251C249.619 212.5 248.5 211.381 248.5 210V107C248.5 105.619 249.619 104.5 251 104.5Z", fill: "#071715", stroke: "#0FF0A1" }),
    /* @__PURE__ */ jsx("path", { d: "M58.7803 20C58.7803 16.6863 61.4666 14 64.7803 14H135.484C138.797 14 141.484 16.6863 141.484 20V23.1429C141.484 26.4566 138.797 29.1429 135.484 29.1429H64.7803C61.4666 29.1429 58.7803 26.4566 58.7803 23.1429V20Z", fill: "#0FF0A1" }),
    /* @__PURE__ */ jsx("path", { d: "M25 50.2857C25 46.972 27.6863 44.2857 31 44.2857H148.297C151.61 44.2857 154.297 46.972 154.297 50.2857V53.4286C154.297 56.7423 151.61 59.4286 148.297 59.4286H31C27.6863 59.4286 25 56.7423 25 53.4286V50.2857Z", fill: "#F9BC15" }),
    /* @__PURE__ */ jsx("path", { d: "M25 80.5714C25 77.2577 27.6863 74.5714 31 74.5714H141.308C144.621 74.5714 147.308 77.2577 147.308 80.5714V114C147.308 117.314 144.621 120 141.308 120H31C27.6863 120 25 117.314 25 114V80.5714Z", fill: "#0FF0A1" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 21.5714C28.4941 19.3198 30.3194 17.4945 32.5711 17.4945H51.2084C53.46 17.4945 55.2853 19.3198 55.2853 21.5714V21.5714C55.2853 23.8231 53.46 25.6484 51.2084 25.6484H32.5711C30.3194 25.6484 28.4941 23.8231 28.4941 21.5714V21.5714Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 82.1429C28.4941 79.8912 30.3194 78.0659 32.5711 78.0659H46.5491C48.8007 78.0659 50.626 79.8912 50.626 82.1429V82.1429C50.626 84.3945 48.8007 86.2198 46.5491 86.2198H32.5711C30.3194 86.2198 28.4941 84.3945 28.4941 82.1429V82.1429Z", fill: "#015133" }),
    /* @__PURE__ */ jsx("path", { d: "M62.2744 21.5714C62.2744 19.3198 64.0997 17.4945 66.3513 17.4945H100.132C102.383 17.4945 104.208 19.3198 104.208 21.5714V21.5714C104.208 23.8231 102.383 25.6484 100.132 25.6484H66.3513C64.0997 25.6484 62.2744 23.8231 62.2744 21.5714V21.5714Z", fill: "#015133" }),
    /* @__PURE__ */ jsx("path", { d: "M111.198 21.5714C111.198 19.3198 113.024 17.4945 115.275 17.4945H133.913C136.164 17.4945 137.989 19.3198 137.989 21.5714V21.5714C137.989 23.8231 136.164 25.6484 133.913 25.6484H115.275C113.024 25.6484 111.198 23.8231 111.198 21.5714V21.5714Z", fill: "#015133" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 36.7143C28.4941 34.4627 30.3194 32.6374 32.5711 32.6374H86.1535C88.4051 32.6374 90.2304 34.4627 90.2304 36.7143V36.7143C90.2304 38.9659 88.4051 40.7912 86.1535 40.7912H32.5711C30.3194 40.7912 28.4941 38.9659 28.4941 36.7143V36.7143Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M97.2197 36.7143C97.2197 34.4627 99.045 32.6374 101.297 32.6374H131.582C133.834 32.6374 135.659 34.4627 135.659 36.7143V36.7143C135.659 38.9659 133.834 40.7912 131.582 40.7912H101.297C99.045 40.7912 97.2197 38.9659 97.2197 36.7143V36.7143Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 51.8571C28.4941 49.6055 30.3194 47.7802 32.5711 47.7802H66.3513C68.6029 47.7802 70.4282 49.6055 70.4282 51.8571V51.8571C70.4282 54.1088 68.6029 55.9341 66.3513 55.9341H32.5711C30.3194 55.9341 28.4941 54.1088 28.4941 51.8571V51.8571Z", fill: "#965908" }),
    /* @__PURE__ */ jsx("path", { d: "M77.418 51.8571C77.418 49.6055 79.2433 47.7802 81.4949 47.7802H146.726C148.977 47.7802 150.803 49.6055 150.803 51.8571V51.8571C150.803 54.1088 148.977 55.9341 146.726 55.9341H81.4949C79.2433 55.9341 77.418 54.1088 77.418 51.8571V51.8571Z", fill: "#965908" }),
    /* @__PURE__ */ jsx("path", { d: "M57.6152 82.1429C57.6152 79.8912 59.4405 78.0659 61.6922 78.0659H126.923C129.175 78.0659 131 79.8912 131 82.1429V82.1429C131 84.3945 129.175 86.2198 126.923 86.2198H61.6922C59.4405 86.2198 57.6152 84.3945 57.6152 82.1429V82.1429Z", fill: "#015133" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 67C28.4941 64.7484 30.3194 62.9231 32.5711 62.9231H57.0326C59.2842 62.9231 61.1095 64.7484 61.1095 67V67C61.1095 69.2516 59.2842 71.0769 57.0326 71.0769H32.5711C30.3194 71.0769 28.4941 69.2516 28.4941 67V67Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 97.2857C28.4941 95.0341 30.3194 93.2088 32.5711 93.2088H93.1425C95.3941 93.2088 97.2194 95.0341 97.2194 97.2857V97.2857C97.2194 99.5373 95.3941 101.363 93.1425 101.363H32.5711C30.3194 101.363 28.4941 99.5373 28.4941 97.2857V97.2857Z", fill: "#015133" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 112.429C28.4941 110.177 30.3194 108.352 32.5711 108.352H135.077C137.328 108.352 139.153 110.177 139.153 112.429V112.429C139.153 114.68 137.328 116.505 135.077 116.505H32.5711C30.3194 116.505 28.4941 114.68 28.4941 112.429V112.429Z", fill: "#015133" }),
    /* @__PURE__ */ jsx("path", { d: "M68.0986 67C68.0986 64.7484 69.9239 62.9231 72.1756 62.9231H109.45C111.702 62.9231 113.527 64.7484 113.527 67V67C113.527 69.2516 111.702 71.0769 109.45 71.0769H72.1756C69.9239 71.0769 68.0986 69.2516 68.0986 67V67Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M104.209 97.2857C104.209 95.0341 106.034 93.2088 108.286 93.2088H139.736C141.988 93.2088 143.813 95.0341 143.813 97.2857V97.2857C143.813 99.5373 141.988 101.363 139.736 101.363H108.286C106.034 101.363 104.209 99.5373 104.209 97.2857V97.2857Z", fill: "#015133" }),
    /* @__PURE__ */ jsx("path", { d: "M120.517 67C120.517 64.7484 122.342 62.9231 124.594 62.9231H140.901C143.153 62.9231 144.978 64.7484 144.978 67V67C144.978 69.2516 143.153 71.0769 140.901 71.0769H124.594C122.342 71.0769 120.517 69.2516 120.517 67V67Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 203.143C28.4941 200.891 30.3194 199.066 32.5711 199.066H46.5491C48.8007 199.066 50.626 200.891 50.626 203.143V203.143C50.626 205.394 48.8007 207.22 46.5491 207.22H32.5711C30.3194 207.22 28.4941 205.394 28.4941 203.143V203.143Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 142.571C28.4941 140.32 30.3194 138.495 32.5711 138.495H133.912C136.163 138.495 137.988 140.32 137.988 142.571V142.571C137.988 144.823 136.163 146.648 133.912 146.648H32.5711C30.3194 146.648 28.4941 144.823 28.4941 142.571V142.571Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 157.714C28.4941 155.463 30.3194 153.637 32.5711 153.637H51.2082C53.4599 153.637 55.2852 155.463 55.2852 157.714V157.714C55.2852 159.966 53.4599 161.791 51.2082 161.791H32.5711C30.3194 161.791 28.4941 159.966 28.4941 157.714V157.714Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M63.1094 157.714C63.1094 155.463 64.9347 153.637 67.1863 153.637H140.902C143.153 153.637 144.979 155.463 144.979 157.714V157.714C144.979 159.966 143.153 161.791 140.902 161.791H67.1863C64.9347 161.791 63.1094 159.966 63.1094 157.714V157.714Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 172.857C28.4941 170.606 30.3194 168.78 32.5711 168.78H41.4231C43.6747 168.78 45.5 170.606 45.5 172.857V172.857C45.5 175.109 43.6747 176.934 41.4231 176.934H32.5711C30.3194 176.934 28.4941 175.109 28.4941 172.857V172.857Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M52.875 172.857C52.875 170.606 54.7003 168.78 56.9519 168.78H146.725C148.976 168.78 150.802 170.606 150.802 172.857V172.857C150.802 175.109 148.976 176.934 146.725 176.934H56.9519C54.7003 176.934 52.875 175.109 52.875 172.857V172.857Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M57.6152 203.143C57.6152 200.891 59.4405 199.066 61.6922 199.066H126.923C129.175 199.066 131 200.891 131 203.143V203.143C131 205.394 129.175 207.22 126.923 207.22H61.6922C59.4405 207.22 57.6152 205.394 57.6152 203.143V203.143Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M28.4941 188C28.4941 185.748 30.3194 183.923 32.5711 183.923H86.1537C88.4053 183.923 90.2306 185.748 90.2306 188V188C90.2306 190.252 88.4053 192.077 86.1537 192.077H32.5711C30.3194 192.077 28.4941 190.252 28.4941 188V188Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M97.2197 188C97.2197 185.748 99.045 183.923 101.297 183.923H138.571C140.823 183.923 142.648 185.748 142.648 188V188C142.648 190.252 140.823 192.077 138.571 192.077H101.297C99.045 192.077 97.2197 190.252 97.2197 188V188Z", fill: "#383D51" }),
    /* @__PURE__ */ jsx("path", { d: "M254.062 29H251.145V19.5455H254.192C255.109 19.5455 255.894 19.7347 256.546 20.1133C257.199 20.4888 257.699 21.0289 258.047 21.7337C258.394 22.4354 258.568 23.2756 258.568 24.2543C258.568 25.2391 258.393 26.087 258.042 26.7979C257.691 27.5058 257.18 28.0505 256.509 28.4322C255.838 28.8107 255.023 29 254.062 29ZM252.29 27.9844H253.989C254.77 27.9844 255.418 27.8336 255.932 27.532C256.446 27.2304 256.829 26.801 257.082 26.244C257.334 25.6869 257.46 25.0237 257.46 24.2543C257.46 23.491 257.336 22.8339 257.086 22.283C256.837 21.729 256.465 21.3043 255.969 21.0089C255.474 20.7103 254.857 20.5611 254.118 20.5611H252.29V27.9844ZM263.314 29.1477C262.631 29.1477 262.041 28.9969 261.546 28.6953C261.053 28.3906 260.673 27.9659 260.406 27.4212C260.141 26.8733 260.009 26.2363 260.009 25.5099C260.009 24.7836 260.141 24.1435 260.406 23.5895C260.673 23.0324 261.046 22.5985 261.523 22.2876C262.003 21.9737 262.563 21.8168 263.203 21.8168C263.572 21.8168 263.937 21.8783 264.297 22.0014C264.657 22.1245 264.985 22.3246 265.281 22.6016C265.576 22.8755 265.811 23.2386 265.987 23.6911C266.162 24.1435 266.25 24.7005 266.25 25.3622V25.8239H260.784V24.8821H265.142C265.142 24.482 265.062 24.125 264.902 23.8111C264.745 23.4972 264.52 23.2494 264.228 23.0678C263.939 22.8862 263.597 22.7955 263.203 22.7955C262.769 22.7955 262.394 22.9032 262.077 23.1186C261.763 23.331 261.521 23.608 261.352 23.9496C261.183 24.2912 261.098 24.6574 261.098 25.0483V25.6761C261.098 26.2116 261.19 26.6656 261.375 27.038C261.563 27.4073 261.823 27.6889 262.155 27.8828C262.488 28.0736 262.874 28.169 263.314 28.169C263.6 28.169 263.859 28.129 264.089 28.049C264.323 27.9659 264.525 27.8428 264.694 27.6797C264.864 27.5135 264.994 27.3073 265.087 27.0611L266.139 27.3565C266.028 27.7135 265.842 28.0275 265.581 28.2983C265.319 28.5661 264.996 28.7753 264.611 28.9261C264.226 29.0739 263.794 29.1477 263.314 29.1477ZM272.93 23.4972L271.951 23.7741C271.89 23.611 271.799 23.4525 271.679 23.2987C271.562 23.1417 271.402 23.0124 271.199 22.9109C270.996 22.8093 270.736 22.7585 270.419 22.7585C269.985 22.7585 269.623 22.8585 269.334 23.0586C269.048 23.2556 268.904 23.5064 268.904 23.8111C268.904 24.0819 269.003 24.2958 269.2 24.4528C269.397 24.6097 269.705 24.7405 270.123 24.8452L271.176 25.1037C271.81 25.2576 272.282 25.493 272.593 25.81C272.904 26.1239 273.059 26.5286 273.059 27.0241C273.059 27.4304 272.942 27.7936 272.708 28.1136C272.478 28.4337 272.154 28.6861 271.739 28.8707C271.324 29.0554 270.84 29.1477 270.289 29.1477C269.566 29.1477 268.968 28.9908 268.494 28.6768C268.02 28.3629 267.72 27.9044 267.593 27.3011L268.627 27.0426C268.726 27.4242 268.912 27.7105 269.186 27.9013C269.463 28.0921 269.825 28.1875 270.271 28.1875C270.779 28.1875 271.182 28.0798 271.48 27.8643C271.782 27.6458 271.933 27.3842 271.933 27.0795C271.933 26.8333 271.847 26.6271 271.674 26.4609C271.502 26.2917 271.237 26.1655 270.88 26.0824L269.699 25.8054C269.049 25.6515 268.572 25.413 268.267 25.0898C267.966 24.7636 267.815 24.3558 267.815 23.8665C267.815 23.4664 267.927 23.1125 268.152 22.8047C268.38 22.4969 268.689 22.2553 269.08 22.0799C269.474 21.9045 269.92 21.8168 270.419 21.8168C271.12 21.8168 271.671 21.9706 272.071 22.2784C272.475 22.5862 272.761 22.9924 272.93 23.4972ZM277.58 29.1477C276.915 29.1477 276.343 28.9908 275.863 28.6768C275.383 28.3629 275.013 27.9305 274.755 27.3796C274.496 26.8287 274.367 26.1993 274.367 25.4915C274.367 24.7713 274.499 24.1358 274.764 23.5849C275.032 23.0309 275.404 22.5985 275.881 22.2876C276.361 21.9737 276.921 21.8168 277.562 21.8168C278.06 21.8168 278.509 21.9091 278.91 22.0938C279.31 22.2784 279.637 22.5369 279.893 22.8693C280.148 23.2017 280.307 23.5895 280.368 24.0327H279.279C279.196 23.7095 279.011 23.4233 278.725 23.174C278.442 22.9216 278.06 22.7955 277.58 22.7955C277.155 22.7955 276.783 22.9062 276.463 23.1278C276.146 23.3464 275.898 23.6557 275.72 24.0558C275.544 24.4528 275.456 24.919 275.456 25.4545C275.456 26.0024 275.543 26.4794 275.715 26.8857C275.89 27.2919 276.137 27.6074 276.454 27.832C276.774 28.0567 277.149 28.169 277.58 28.169C277.863 28.169 278.12 28.1198 278.351 28.0213C278.582 27.9228 278.777 27.7812 278.937 27.5966C279.097 27.4119 279.211 27.1903 279.279 26.9318H280.368C280.307 27.3504 280.154 27.7274 279.911 28.0629C279.671 28.3952 279.353 28.6599 278.956 28.8569C278.562 29.0508 278.103 29.1477 277.58 29.1477ZM281.961 29V21.9091H283.014V22.9801H283.087C283.217 22.6293 283.451 22.3446 283.789 22.1261C284.128 21.9076 284.509 21.7983 284.934 21.7983C285.014 21.7983 285.114 21.7998 285.234 21.8029C285.354 21.806 285.445 21.8106 285.506 21.8168V22.9247C285.47 22.9155 285.385 22.9016 285.253 22.8832C285.123 22.8616 284.986 22.8509 284.842 22.8509C284.497 22.8509 284.189 22.9232 283.918 23.0678C283.651 23.2094 283.438 23.4064 283.281 23.6587C283.127 23.908 283.051 24.1927 283.051 24.5128V29H281.961ZM286.798 29V21.9091H287.887V29H286.798ZM287.352 20.7273C287.14 20.7273 286.956 20.6549 286.803 20.5103C286.652 20.3656 286.576 20.1918 286.576 19.9886C286.576 19.7855 286.652 19.6116 286.803 19.467C286.956 19.3223 287.14 19.25 287.352 19.25C287.564 19.25 287.746 19.3223 287.897 19.467C288.051 19.6116 288.127 19.7855 288.127 19.9886C288.127 20.1918 288.051 20.3656 287.897 20.5103C287.746 20.6549 287.564 20.7273 287.352 20.7273ZM289.883 31.6591V21.9091H290.935V23.0355H291.065C291.145 22.9124 291.256 22.7554 291.397 22.5646C291.542 22.3707 291.748 22.1984 292.016 22.0476C292.287 21.8937 292.653 21.8168 293.114 21.8168C293.711 21.8168 294.238 21.966 294.693 22.2646C295.149 22.5631 295.504 22.9863 295.76 23.5341C296.015 24.0819 296.143 24.7282 296.143 25.473C296.143 26.224 296.015 26.8749 295.76 27.4258C295.504 27.9736 295.15 28.3983 294.698 28.6999C294.245 28.9985 293.724 29.1477 293.133 29.1477C292.677 29.1477 292.313 29.0723 292.039 28.9215C291.765 28.7676 291.554 28.5937 291.406 28.3999C291.259 28.2029 291.145 28.0398 291.065 27.9105H290.972V31.6591H289.883ZM290.954 25.4545C290.954 25.9901 291.032 26.4625 291.189 26.8718C291.346 27.2781 291.576 27.5966 291.877 27.8274C292.179 28.0552 292.548 28.169 292.985 28.169C293.441 28.169 293.821 28.049 294.125 27.8089C294.433 27.5658 294.664 27.2396 294.818 26.8303C294.975 26.4179 295.053 25.9593 295.053 25.4545C295.053 24.956 294.976 24.5066 294.823 24.1065C294.672 23.7034 294.442 23.3848 294.135 23.1509C293.83 22.9139 293.447 22.7955 292.985 22.7955C292.542 22.7955 292.17 22.9078 291.868 23.1325C291.566 23.354 291.339 23.6649 291.185 24.065C291.031 24.462 290.954 24.9252 290.954 25.4545ZM300.889 21.9091V22.8324H297.214V21.9091H300.889ZM298.285 20.2102H299.374V26.9688C299.374 27.2765 299.419 27.5073 299.508 27.6612C299.601 27.812 299.718 27.9136 299.859 27.9659C300.004 28.0152 300.156 28.0398 300.316 28.0398C300.436 28.0398 300.535 28.0336 300.612 28.0213C300.689 28.0059 300.75 27.9936 300.796 27.9844L301.018 28.9631C300.944 28.9908 300.841 29.0185 300.709 29.0462C300.576 29.0769 300.408 29.0923 300.205 29.0923C299.898 29.0923 299.596 29.0262 299.301 28.8938C299.008 28.7615 298.765 28.5599 298.571 28.2891C298.38 28.0182 298.285 27.6766 298.285 27.2642V20.2102ZM302.527 29V21.9091H303.617V29H302.527ZM303.081 20.7273C302.869 20.7273 302.686 20.6549 302.532 20.5103C302.381 20.3656 302.306 20.1918 302.306 19.9886C302.306 19.7855 302.381 19.6116 302.532 19.467C302.686 19.3223 302.869 19.25 303.081 19.25C303.294 19.25 303.475 19.3223 303.626 19.467C303.78 19.6116 303.857 19.7855 303.857 19.9886C303.857 20.1918 303.78 20.3656 303.626 20.5103C303.475 20.6549 303.294 20.7273 303.081 20.7273ZM308.493 29.1477C307.853 29.1477 307.291 28.9954 306.808 28.6907C306.328 28.386 305.952 27.9598 305.682 27.4119C305.414 26.8641 305.28 26.224 305.28 25.4915C305.28 24.7528 305.414 24.1081 305.682 23.5572C305.952 23.0063 306.328 22.5785 306.808 22.2738C307.291 21.9691 307.853 21.8168 308.493 21.8168C309.133 21.8168 309.693 21.9691 310.173 22.2738C310.657 22.5785 311.032 23.0063 311.3 23.5572C311.571 24.1081 311.706 24.7528 311.706 25.4915C311.706 26.224 311.571 26.8641 311.3 27.4119C311.032 27.9598 310.657 28.386 310.173 28.6907C309.693 28.9954 309.133 29.1477 308.493 29.1477ZM308.493 28.169C308.979 28.169 309.379 28.0444 309.693 27.7951C310.007 27.5458 310.24 27.218 310.39 26.8118C310.541 26.4055 310.617 25.9654 310.617 25.4915C310.617 25.0175 310.541 24.5759 310.39 24.1665C310.24 23.7572 310.007 23.4264 309.693 23.174C309.379 22.9216 308.979 22.7955 308.493 22.7955C308.007 22.7955 307.607 22.9216 307.293 23.174C306.979 23.4264 306.747 23.7572 306.596 24.1665C306.445 24.5759 306.369 25.0175 306.369 25.4915C306.369 25.9654 306.445 26.4055 306.596 26.8118C306.747 27.218 306.979 27.5458 307.293 27.7951C307.607 28.0444 308.007 28.169 308.493 28.169ZM314.459 24.7344V29H313.369V21.9091H314.422V23.017H314.514C314.68 22.657 314.933 22.3677 315.271 22.1491C315.61 21.9276 316.047 21.8168 316.582 21.8168C317.062 21.8168 317.483 21.9152 317.843 22.1122C318.203 22.3061 318.483 22.6016 318.683 22.9986C318.883 23.3925 318.983 23.8911 318.983 24.4943V29H317.893V24.5682C317.893 24.0111 317.749 23.5772 317.459 23.2663C317.17 22.9524 316.773 22.7955 316.268 22.7955C315.921 22.7955 315.61 22.8709 315.336 23.0217C315.065 23.1725 314.851 23.3925 314.694 23.6818C314.537 23.9711 314.459 24.322 314.459 24.7344Z", fill: "#F9BC15" }),
    /* @__PURE__ */ jsx("path", { d: "M251.145 96V86.5455H254.45C255.109 86.5455 255.652 86.6593 256.08 86.8871C256.508 87.1117 256.826 87.4149 257.036 87.7965C257.245 88.1751 257.349 88.5952 257.349 89.0568C257.349 89.4631 257.277 89.7985 257.132 90.0632C256.991 90.3279 256.803 90.5372 256.569 90.6911C256.338 90.8449 256.088 90.9588 255.817 91.0327V91.125C256.106 91.1435 256.397 91.245 256.689 91.4297C256.982 91.6143 257.226 91.879 257.423 92.2237C257.62 92.5684 257.719 92.9901 257.719 93.4886C257.719 93.9626 257.611 94.3888 257.396 94.7674C257.18 95.146 256.84 95.446 256.375 95.6676C255.911 95.8892 255.306 96 254.561 96H251.145ZM252.29 94.9844H254.561C255.309 94.9844 255.84 94.8397 256.154 94.5504C256.471 94.258 256.629 93.9041 256.629 93.4886C256.629 93.1686 256.548 92.8731 256.385 92.6023C256.221 92.3284 255.989 92.1098 255.688 91.9467C255.386 91.7805 255.029 91.6974 254.616 91.6974H252.29V94.9844ZM252.29 90.7003H254.413C254.758 90.7003 255.069 90.6326 255.346 90.4972C255.626 90.3617 255.848 90.1709 256.011 89.9247C256.177 89.6785 256.26 89.3892 256.26 89.0568C256.26 88.6413 256.115 88.2889 255.826 87.9996C255.537 87.7073 255.078 87.5611 254.45 87.5611H252.29V90.7003ZM262.333 96.1477C261.693 96.1477 261.131 95.9954 260.648 95.6907C260.168 95.386 259.792 94.9598 259.521 94.4119C259.254 93.8641 259.12 93.224 259.12 92.4915C259.12 91.7528 259.254 91.1081 259.521 90.5572C259.792 90.0063 260.168 89.5785 260.648 89.2738C261.131 88.9691 261.693 88.8168 262.333 88.8168C262.973 88.8168 263.533 88.9691 264.013 89.2738C264.497 89.5785 264.872 90.0063 265.14 90.5572C265.411 91.1081 265.546 91.7528 265.546 92.4915C265.546 93.224 265.411 93.8641 265.14 94.4119C264.872 94.9598 264.497 95.386 264.013 95.6907C263.533 95.9954 262.973 96.1477 262.333 96.1477ZM262.333 95.169C262.819 95.169 263.219 95.0444 263.533 94.7951C263.847 94.5458 264.079 94.218 264.23 93.8118C264.381 93.4055 264.456 92.9654 264.456 92.4915C264.456 92.0175 264.381 91.5759 264.23 91.1665C264.079 90.7572 263.847 90.4264 263.533 90.174C263.219 89.9216 262.819 89.7955 262.333 89.7955C261.847 89.7955 261.447 89.9216 261.133 90.174C260.819 90.4264 260.586 90.7572 260.436 91.1665C260.285 91.5759 260.209 92.0175 260.209 92.4915C260.209 92.9654 260.285 93.4055 260.436 93.8118C260.586 94.218 260.819 94.5458 261.133 94.7951C261.447 95.0444 261.847 95.169 262.333 95.169ZM269.887 96.1477C269.296 96.1477 268.774 95.9985 268.322 95.6999C267.869 95.3983 267.515 94.9736 267.26 94.4258C267.004 93.8749 266.877 93.224 266.877 92.473C266.877 91.7282 267.004 91.0819 267.26 90.5341C267.515 89.9863 267.871 89.5631 268.326 89.2646C268.782 88.966 269.308 88.8168 269.905 88.8168C270.367 88.8168 270.731 88.8937 270.999 89.0476C271.27 89.1984 271.476 89.3707 271.618 89.5646C271.762 89.7554 271.875 89.9124 271.955 90.0355H272.047V86.5455H273.137V96H272.084V94.9105H271.955C271.875 95.0398 271.761 95.2029 271.613 95.3999C271.465 95.5937 271.255 95.7676 270.981 95.9215C270.707 96.0723 270.342 96.1477 269.887 96.1477ZM270.034 95.169C270.471 95.169 270.841 95.0552 271.142 94.8274C271.444 94.5966 271.673 94.2781 271.83 93.8718C271.987 93.4625 272.066 92.9901 272.066 92.4545C272.066 91.9252 271.989 91.462 271.835 91.065C271.681 90.6649 271.453 90.354 271.152 90.1325C270.85 89.9078 270.478 89.7955 270.034 89.7955C269.573 89.7955 269.188 89.9139 268.88 90.1509C268.576 90.3848 268.346 90.7034 268.192 91.1065C268.042 91.5066 267.966 91.956 267.966 92.4545C267.966 92.9593 268.043 93.4179 268.197 93.8303C268.354 94.2396 268.585 94.5658 268.889 94.8089C269.197 95.049 269.579 95.169 270.034 95.169ZM275.985 98.6591C275.8 98.6591 275.636 98.6437 275.491 98.6129C275.346 98.5852 275.246 98.5575 275.191 98.5298L275.468 97.5696C275.733 97.6373 275.967 97.6619 276.17 97.6435C276.373 97.625 276.553 97.5342 276.71 97.3711C276.87 97.2111 277.016 96.951 277.148 96.5909L277.351 96.0369L274.729 88.9091H275.911L277.869 94.5597H277.942L279.9 88.9091H281.082L278.072 97.0341C277.936 97.4003 277.768 97.7035 277.568 97.9435C277.368 98.1867 277.136 98.3667 276.871 98.4837C276.61 98.6006 276.314 98.6591 275.985 98.6591Z", fill: "#04B97A" }),
    /* @__PURE__ */ jsx("path", { d: "M164 22C164 24.2091 165.791 26 168 26C170.209 26 172 24.2091 172 22C172 19.7909 170.209 18 168 18C165.791 18 164 19.7909 164 22ZM238.53 -14.9697C238.823 -15.2626 238.823 -15.7374 238.53 -16.0303L233.757 -20.8033C233.464 -21.0962 232.99 -21.0962 232.697 -20.8033C232.404 -20.5104 232.404 -20.0355 232.697 -19.7426L236.939 -15.5L232.697 -11.2574C232.404 -10.9645 232.404 -10.4896 232.697 -10.1967C232.99 -9.90381 233.464 -9.90381 233.757 -10.1967L238.53 -14.9697ZM168 22.75C168.007 22.75 168.013 22.75 168.02 22.75C168.026 22.75 168.033 22.75 168.039 22.75C168.046 22.75 168.052 22.75 168.059 22.75C168.066 22.75 168.072 22.75 168.079 22.75C168.086 22.75 168.092 22.75 168.099 22.75C168.106 22.75 168.112 22.75 168.119 22.75C168.126 22.75 168.133 22.75 168.139 22.75C168.146 22.75 168.153 22.75 168.16 22.75C168.167 22.75 168.173 22.75 168.18 22.75C168.187 22.75 168.194 22.75 168.201 22.75C168.208 22.75 168.215 22.75 168.222 22.75C168.229 22.75 168.235 22.75 168.242 22.75C168.249 22.75 168.256 22.75 168.263 22.75C168.27 22.75 168.277 22.75 168.284 22.75C168.291 22.75 168.298 22.75 168.306 22.75C168.313 22.75 168.32 22.75 168.327 22.75C168.334 22.75 168.341 22.75 168.348 22.75C168.355 22.75 168.362 22.75 168.37 22.75C168.377 22.75 168.384 22.75 168.391 22.75C168.398 22.75 168.406 22.75 168.413 22.75C168.42 22.75 168.427 22.75 168.435 22.75C168.442 22.75 168.449 22.75 168.457 22.75C168.464 22.75 168.471 22.75 168.479 22.75C168.486 22.75 168.493 22.75 168.501 22.75C168.508 22.75 168.516 22.75 168.523 22.75C168.53 22.75 168.538 22.75 168.545 22.75C168.553 22.75 168.56 22.75 168.568 22.75C168.575 22.75 168.583 22.75 168.59 22.75C168.598 22.75 168.605 22.75 168.613 22.75C168.621 22.75 168.628 22.75 168.636 22.75C168.643 22.75 168.651 22.75 168.659 22.75C168.666 22.75 168.674 22.75 168.682 22.75C168.689 22.75 168.697 22.75 168.705 22.75C168.712 22.75 168.72 22.75 168.728 22.75C168.736 22.75 168.743 22.75 168.751 22.75C168.759 22.75 168.767 22.75 168.775 22.75C168.782 22.75 168.79 22.75 168.798 22.75C168.806 22.75 168.814 22.75 168.822 22.75C168.83 22.75 168.838 22.75 168.845 22.75C168.853 22.75 168.861 22.75 168.869 22.75C168.877 22.75 168.885 22.75 168.893 22.75C168.901 22.75 168.909 22.75 168.917 22.75C168.925 22.75 168.933 22.75 168.941 22.75C168.949 22.75 168.958 22.75 168.966 22.75C168.974 22.75 168.982 22.75 168.99 22.75C168.998 22.75 169.006 22.75 169.014 22.75C169.023 22.75 169.031 22.75 169.039 22.75C169.047 22.75 169.055 22.75 169.064 22.75C169.072 22.75 169.08 22.75 169.088 22.75C169.097 22.75 169.105 22.75 169.113 22.75C169.122 22.75 169.13 22.75 169.138 22.75C169.147 22.75 169.155 22.75 169.163 22.75C169.172 22.75 169.18 22.75 169.188 22.75C169.197 22.75 169.205 22.75 169.214 22.75C169.222 22.75 169.231 22.75 169.239 22.75C169.248 22.75 169.256 22.75 169.265 22.75C169.273 22.75 169.282 22.75 169.29 22.75C169.299 22.75 169.307 22.75 169.316 22.75C169.324 22.75 169.333 22.75 169.342 22.75C169.35 22.75 169.359 22.75 169.367 22.75C169.376 22.75 169.385 22.75 169.393 22.75C169.402 22.75 169.411 22.75 169.419 22.75C169.428 22.75 169.437 22.75 169.446 22.75C169.454 22.75 169.463 22.75 169.472 22.75C169.481 22.75 169.489 22.75 169.498 22.75C169.507 22.75 169.516 22.75 169.525 22.75C169.534 22.75 169.542 22.75 169.551 22.75C169.56 22.75 169.569 22.75 169.578 22.75C169.587 22.75 169.596 22.75 169.605 22.75C169.614 22.75 169.623 22.75 169.632 22.75C169.641 22.75 169.65 22.75 169.659 22.75C169.668 22.75 169.677 22.75 169.686 22.75C169.695 22.75 169.704 22.75 169.713 22.75C169.722 22.75 169.731 22.75 169.74 22.75C169.749 22.75 169.758 22.75 169.767 22.75C169.776 22.75 169.786 22.75 169.795 22.75C169.804 22.75 169.813 22.75 169.822 22.75C169.832 22.75 169.841 22.75 169.85 22.75C169.859 22.75 169.868 22.75 169.878 22.75C169.887 22.75 169.896 22.75 169.906 22.75C169.915 22.75 169.924 22.75 169.933 22.75C169.943 22.75 169.952 22.75 169.961 22.75C169.971 22.75 169.98 22.75 169.99 22.75C169.999 22.75 170.008 22.75 170.018 22.75C170.027 22.75 170.037 22.75 170.046 22.75C170.056 22.75 170.065 22.75 170.075 22.75C170.084 22.75 170.093 22.75 170.103 22.75C170.113 22.75 170.122 22.75 170.132 22.75C170.141 22.75 170.151 22.75 170.16 22.75C170.17 22.75 170.179 22.75 170.189 22.75C170.199 22.75 170.208 22.75 170.218 22.75C170.228 22.75 170.237 22.75 170.247 22.75C170.257 22.75 170.266 22.75 170.276 22.75C170.286 22.75 170.295 22.75 170.305 22.75C170.315 22.75 170.325 22.75 170.334 22.75C170.344 22.75 170.354 22.75 170.364 22.75C170.373 22.75 170.383 22.75 170.393 22.75C170.403 22.75 170.413 22.75 170.423 22.75C170.432 22.75 170.442 22.75 170.452 22.75C170.462 22.75 170.472 22.75 170.482 22.75C170.492 22.75 170.502 22.75 170.512 22.75C170.522 22.75 170.532 22.75 170.542 22.75C170.552 22.75 170.562 22.75 170.572 22.75C170.582 22.75 170.592 22.75 170.602 22.75C170.612 22.75 170.622 22.75 170.632 22.75C170.642 22.75 170.652 22.75 170.662 22.75C170.672 22.75 170.682 22.75 170.692 22.75C170.703 22.75 170.713 22.75 170.723 22.75C170.733 22.75 170.743 22.75 170.753 22.75C170.764 22.75 170.774 22.75 170.784 22.75C170.794 22.75 170.804 22.75 170.815 22.75C170.825 22.75 170.835 22.75 170.845 22.75C170.856 22.75 170.866 22.75 170.876 22.75C170.887 22.75 170.897 22.75 170.907 22.75C170.918 22.75 170.928 22.75 170.938 22.75C170.949 22.75 170.959 22.75 170.969 22.75C170.98 22.75 170.99 22.75 171.001 22.75C171.011 22.75 171.022 22.75 171.032 22.75C171.042 22.75 171.053 22.75 171.063 22.75C171.074 22.75 171.084 22.75 171.095 22.75C171.105 22.75 171.116 22.75 171.127 22.75C171.137 22.75 171.148 22.75 171.158 22.75C171.169 22.75 171.179 22.75 171.19 22.75C171.201 22.75 171.211 22.75 171.222 22.75C171.232 22.75 171.243 22.75 171.254 22.75C171.264 22.75 171.275 22.75 171.286 22.75C171.296 22.75 171.307 22.75 171.318 22.75C171.329 22.75 171.339 22.75 171.35 22.75C171.361 22.75 171.371 22.75 171.382 22.75C171.393 22.75 171.404 22.75 171.415 22.75C171.425 22.75 171.436 22.75 171.447 22.75C171.458 22.75 171.469 22.75 171.48 22.75C171.49 22.75 171.501 22.75 171.512 22.75C171.523 22.75 171.534 22.75 171.545 22.75C171.556 22.75 171.567 22.75 171.578 22.75C171.589 22.75 171.6 22.75 171.611 22.75C171.621 22.75 171.632 22.75 171.643 22.75C171.654 22.75 171.665 22.75 171.677 22.75C171.688 22.75 171.699 22.75 171.71 22.75C171.721 22.75 171.732 22.75 171.743 22.75C171.754 22.75 171.765 22.75 171.776 22.75C171.787 22.75 171.798 22.75 171.809 22.75C171.821 22.75 171.832 22.75 171.843 22.75C171.854 22.75 171.865 22.75 171.876 22.75C171.888 22.75 171.899 22.75 171.91 22.75C171.921 22.75 171.932 22.75 171.944 22.75C171.955 22.75 171.966 22.75 171.977 22.75C171.989 22.75 172 22.75 172.011 22.75C172.023 22.75 172.034 22.75 172.045 22.75C172.057 22.75 172.068 22.75 172.079 22.75C172.091 22.75 172.102 22.75 172.113 22.75C172.125 22.75 172.136 22.75 172.148 22.75C172.159 22.75 172.17 22.75 172.182 22.75C172.193 22.75 172.205 22.75 172.216 22.75C172.228 22.75 172.239 22.75 172.251 22.75C172.262 22.75 172.274 22.75 172.285 22.75C172.297 22.75 172.308 22.75 172.32 22.75C172.331 22.75 172.343 22.75 172.354 22.75C172.366 22.75 172.377 22.75 172.389 22.75C172.401 22.75 172.412 22.75 172.424 22.75C172.435 22.75 172.447 22.75 172.459 22.75C172.47 22.75 172.482 22.75 172.494 22.75C172.505 22.75 172.517 22.75 172.529 22.75C172.54 22.75 172.552 22.75 172.564 22.75C172.576 22.75 172.587 22.75 172.599 22.75C172.611 22.75 172.623 22.75 172.634 22.75C172.646 22.75 172.658 22.75 172.67 22.75C172.681 22.75 172.693 22.75 172.705 22.75C172.717 22.75 172.729 22.75 172.741 22.75C172.752 22.75 172.764 22.75 172.776 22.75C172.788 22.75 172.8 22.75 172.812 22.75C172.824 22.75 172.836 22.75 172.848 22.75C172.86 22.75 172.872 22.75 172.883 22.75C172.895 22.75 172.907 22.75 172.919 22.75C172.931 22.75 172.943 22.75 172.955 22.75C172.967 22.75 172.979 22.75 172.991 22.75C173.003 22.75 173.015 22.75 173.027 22.75C173.04 22.75 173.052 22.75 173.064 22.75C173.076 22.75 173.088 22.75 173.1 22.75C173.112 22.75 173.124 22.75 173.136 22.75C173.148 22.75 173.161 22.75 173.173 22.75C173.185 22.75 173.197 22.75 173.209 22.75C173.221 22.75 173.234 22.75 173.246 22.75C173.258 22.75 173.27 22.75 173.282 22.75C173.295 22.75 173.307 22.75 173.319 22.75C173.331 22.75 173.344 22.75 173.356 22.75C173.368 22.75 173.38 22.75 173.393 22.75C173.405 22.75 173.417 22.75 173.43 22.75C173.442 22.75 173.454 22.75 173.467 22.75C173.479 22.75 173.491 22.75 173.504 22.75C173.516 22.75 173.529 22.75 173.541 22.75C173.553 22.75 173.566 22.75 173.578 22.75C173.591 22.75 173.603 22.75 173.615 22.75C173.628 22.75 173.64 22.75 173.653 22.75C173.665 22.75 173.678 22.75 173.69 22.75C173.703 22.75 173.715 22.75 173.728 22.75C173.74 22.75 173.753 22.75 173.765 22.75C173.778 22.75 173.79 22.75 173.803 22.75C173.816 22.75 173.828 22.75 173.841 22.75C173.853 22.75 173.866 22.75 173.878 22.75C173.891 22.75 173.904 22.75 173.916 22.75C173.929 22.75 173.942 22.75 173.954 22.75C173.967 22.75 173.98 22.75 173.992 22.75C174.005 22.75 174.018 22.75 174.03 22.75C174.043 22.75 174.056 22.75 174.068 22.75C174.081 22.75 174.094 22.75 174.107 22.75C174.119 22.75 174.132 22.75 174.145 22.75C174.158 22.75 174.17 22.75 174.183 22.75C174.196 22.75 174.209 22.75 174.222 22.75C174.234 22.75 174.247 22.75 174.26 22.75C174.273 22.75 174.286 22.75 174.299 22.75C174.312 22.75 174.324 22.75 174.337 22.75C174.35 22.75 174.363 22.75 174.376 22.75C174.389 22.75 174.402 22.75 174.415 22.75C174.428 22.75 174.441 22.75 174.454 22.75C174.466 22.75 174.479 22.75 174.492 22.75C174.505 22.75 174.518 22.75 174.531 22.75C174.544 22.75 174.557 22.75 174.57 22.75C174.583 22.75 174.596 22.75 174.609 22.75C174.623 22.75 174.636 22.75 174.649 22.75C174.662 22.75 174.675 22.75 174.688 22.75C174.701 22.75 174.714 22.75 174.727 22.75C174.74 22.75 174.753 22.75 174.766 22.75C174.78 22.75 174.793 22.75 174.806 22.75C174.819 22.75 174.832 22.75 174.845 22.75C174.859 22.75 174.872 22.75 174.885 22.75C174.898 22.75 174.911 22.75 174.924 22.75C174.938 22.75 174.951 22.75 174.964 22.75C174.977 22.75 174.991 22.75 175.004 22.75C175.017 22.75 175.03 22.75 175.044 22.75C175.057 22.75 175.07 22.75 175.084 22.75C175.097 22.75 175.11 22.75 175.123 22.75C175.137 22.75 175.15 22.75 175.163 22.75C175.177 22.75 175.19 22.75 175.203 22.75C175.217 22.75 175.23 22.75 175.244 22.75C175.257 22.75 175.27 22.75 175.284 22.75C175.297 22.75 175.311 22.75 175.324 22.75C175.337 22.75 175.351 22.75 175.364 22.75C175.378 22.75 175.391 22.75 175.405 22.75C175.418 22.75 175.432 22.75 175.445 22.75C175.459 22.75 175.472 22.75 175.486 22.75C175.499 22.75 175.513 22.75 175.526 22.75C175.54 22.75 175.553 22.75 175.567 22.75C175.58 22.75 175.594 22.75 175.607 22.75C175.621 22.75 175.635 22.75 175.648 22.75C175.662 22.75 175.675 22.75 175.689 22.75C175.702 22.75 175.716 22.75 175.73 22.75C175.743 22.75 175.757 22.75 175.771 22.75C175.784 22.75 175.798 22.75 175.812 22.75C175.825 22.75 175.839 22.75 175.853 22.75C175.866 22.75 175.88 22.75 175.894 22.75C175.907 22.75 175.921 22.75 175.935 22.75C175.949 22.75 175.962 22.75 175.976 22.75C175.99 22.75 176.004 22.75 176.017 22.75C176.031 22.75 176.045 22.75 176.059 22.75C176.072 22.75 176.086 22.75 176.1 22.75C176.114 22.75 176.128 22.75 176.141 22.75C176.155 22.75 176.169 22.75 176.183 22.75C176.197 22.75 176.211 22.75 176.224 22.75C176.238 22.75 176.252 22.75 176.266 22.75C176.28 22.75 176.294 22.75 176.308 22.75C176.322 22.75 176.336 22.75 176.349 22.75C176.363 22.75 176.377 22.75 176.391 22.75C176.405 22.75 176.419 22.75 176.433 22.75C176.447 22.75 176.461 22.75 176.475 22.75C176.489 22.75 176.503 22.75 176.517 22.75C176.531 22.75 176.545 22.75 176.559 22.75C176.573 22.75 176.587 22.75 176.601 22.75C176.615 22.75 176.629 22.75 176.643 22.75C176.657 22.75 176.671 22.75 176.685 22.75C176.699 22.75 176.713 22.75 176.727 22.75C176.742 22.75 176.756 22.75 176.77 22.75C176.784 22.75 176.798 22.75 176.812 22.75C176.826 22.75 176.84 22.75 176.854 22.75C176.869 22.75 176.883 22.75 176.897 22.75C176.911 22.75 176.925 22.75 176.939 22.75C176.954 22.75 176.968 22.75 176.982 22.75C176.996 22.75 177.01 22.75 177.025 22.75C177.039 22.75 177.053 22.75 177.067 22.75C177.081 22.75 177.096 22.75 177.11 22.75C177.124 22.75 177.138 22.75 177.153 22.75C177.167 22.75 177.181 22.75 177.196 22.75C177.21 22.75 177.224 22.75 177.238 22.75C177.253 22.75 177.267 22.75 177.281 22.75C177.296 22.75 177.31 22.75 177.324 22.75C177.339 22.75 177.353 22.75 177.367 22.75C177.382 22.75 177.396 22.75 177.41 22.75C177.425 22.75 177.439 22.75 177.454 22.75C177.468 22.75 177.482 22.75 177.497 22.75C177.511 22.75 177.526 22.75 177.54 22.75C177.554 22.75 177.569 22.75 177.583 22.75C177.598 22.75 177.612 22.75 177.627 22.75C177.641 22.75 177.655 22.75 177.67 22.75C177.684 22.75 177.699 22.75 177.713 22.75C177.728 22.75 177.742 22.75 177.757 22.75C177.771 22.75 177.786 22.75 177.8 22.75C177.815 22.75 177.829 22.75 177.844 22.75C177.858 22.75 177.873 22.75 177.888 22.75C177.902 22.75 177.917 22.75 177.931 22.75C177.946 22.75 177.96 22.75 177.975 22.75C177.99 22.75 178.004 22.75 178.019 22.75C178.033 22.75 178.048 22.75 178.063 22.75C178.077 22.75 178.092 22.75 178.106 22.75C178.121 22.75 178.136 22.75 178.15 22.75C178.165 22.75 178.18 22.75 178.194 22.75C178.209 22.75 178.224 22.75 178.238 22.75C178.253 22.75 178.268 22.75 178.282 22.75C178.297 22.75 178.312 22.75 178.326 22.75C178.341 22.75 178.356 22.75 178.371 22.75C178.385 22.75 178.4 22.75 178.415 22.75C178.43 22.75 178.444 22.75 178.459 22.75C178.474 22.75 178.489 22.75 178.503 22.75C178.518 22.75 178.533 22.75 178.548 22.75C178.563 22.75 178.577 22.75 178.592 22.75C178.607 22.75 178.622 22.75 178.637 22.75C178.651 22.75 178.666 22.75 178.681 22.75C178.696 22.75 178.711 22.75 178.726 22.75C178.74 22.75 178.755 22.75 178.77 22.75C178.785 22.75 178.8 22.75 178.815 22.75C178.83 22.75 178.844 22.75 178.859 22.75C178.874 22.75 178.889 22.75 178.904 22.75C178.919 22.75 178.934 22.75 178.949 22.75C178.964 22.75 178.979 22.75 178.994 22.75C179.009 22.75 179.023 22.75 179.038 22.75C179.053 22.75 179.068 22.75 179.083 22.75C179.098 22.75 179.113 22.75 179.128 22.75C179.143 22.75 179.158 22.75 179.173 22.75C179.188 22.75 179.203 22.75 179.218 22.75C179.233 22.75 179.248 22.75 179.263 22.75C179.278 22.75 179.293 22.75 179.308 22.75C179.323 22.75 179.338 22.75 179.353 22.75C179.369 22.75 179.384 22.75 179.399 22.75C179.414 22.75 179.429 22.75 179.444 22.75C179.459 22.75 179.474 22.75 179.489 22.75C179.504 22.75 179.519 22.75 179.534 22.75C179.55 22.75 179.565 22.75 179.58 22.75C179.595 22.75 179.61 22.75 179.625 22.75C179.64 22.75 179.655 22.75 179.671 22.75C179.686 22.75 179.701 22.75 179.716 22.75C179.731 22.75 179.746 22.75 179.761 22.75C179.777 22.75 179.792 22.75 179.807 22.75C179.822 22.75 179.837 22.75 179.853 22.75C179.868 22.75 179.883 22.75 179.898 22.75C179.913 22.75 179.929 22.75 179.944 22.75C179.959 22.75 179.974 22.75 179.99 22.75C180.005 22.75 180.02 22.75 180.035 22.75C180.051 22.75 180.066 22.75 180.081 22.75C180.096 22.75 180.112 22.75 180.127 22.75C180.142 22.75 180.157 22.75 180.173 22.75C180.188 22.75 180.203 22.75 180.219 22.75C180.234 22.75 180.249 22.75 180.265 22.75C180.28 22.75 180.295 22.75 180.311 22.75C180.326 22.75 180.341 22.75 180.357 22.75C180.372 22.75 180.387 22.75 180.403 22.75C180.418 22.75 180.433 22.75 180.449 22.75C180.464 22.75 180.479 22.75 180.495 22.75C180.51 22.75 180.526 22.75 180.541 22.75C180.556 22.75 180.572 22.75 180.587 22.75C180.603 22.75 180.618 22.75 180.633 22.75C180.649 22.75 180.664 22.75 180.68 22.75C180.695 22.75 180.71 22.75 180.726 22.75C180.741 22.75 180.757 22.75 180.772 22.75C180.788 22.75 180.803 22.75 180.819 22.75C180.834 22.75 180.85 22.75 180.865 22.75C180.88 22.75 180.896 22.75 180.911 22.75C180.927 22.75 180.942 22.75 180.958 22.75C180.973 22.75 180.989 22.75 181.004 22.75C181.02 22.75 181.035 22.75 181.051 22.75C181.066 22.75 181.082 22.75 181.097 22.75C181.113 22.75 181.129 22.75 181.144 22.75C181.16 22.75 181.175 22.75 181.191 22.75C181.206 22.75 181.222 22.75 181.237 22.75C181.253 22.75 181.269 22.75 181.284 22.75C181.3 22.75 181.315 22.75 181.331 22.75C181.346 22.75 181.362 22.75 181.378 22.75C181.393 22.75 181.409 22.75 181.424 22.75C181.44 22.75 181.456 22.75 181.471 22.75C181.487 22.75 181.503 22.75 181.518 22.75C181.534 22.75 181.549 22.75 181.565 22.75C181.581 22.75 181.596 22.75 181.612 22.75C181.628 22.75 181.643 22.75 181.659 22.75C181.675 22.75 181.69 22.75 181.706 22.75C181.722 22.75 181.737 22.75 181.753 22.75C181.769 22.75 181.784 22.75 181.8 22.75C181.816 22.75 181.831 22.75 181.847 22.75C181.863 22.75 181.878 22.75 181.894 22.75C181.91 22.75 181.926 22.75 181.941 22.75C181.957 22.75 181.973 22.75 181.989 22.75C182.004 22.75 182.02 22.75 182.036 22.75C182.051 22.75 182.067 22.75 182.083 22.75C182.099 22.75 182.114 22.75 182.13 22.75C182.146 22.75 182.162 22.75 182.178 22.75C182.193 22.75 182.209 22.75 182.225 22.75C182.241 22.75 182.256 22.75 182.272 22.75C182.288 22.75 182.304 22.75 182.32 22.75C182.335 22.75 182.351 22.75 182.367 22.75C182.383 22.75 182.399 22.75 182.414 22.75C182.43 22.75 182.446 22.75 182.462 22.75C182.478 22.75 182.494 22.75 182.509 22.75C182.525 22.75 182.541 22.75 182.557 22.75C182.573 22.75 182.589 22.75 182.604 22.75C182.62 22.75 182.636 22.75 182.652 22.75C182.668 22.75 182.684 22.75 182.7 22.75C182.715 22.75 182.731 22.75 182.747 22.75C182.763 22.75 182.779 22.75 182.795 22.75C182.811 22.75 182.827 22.75 182.843 22.75C182.858 22.75 182.874 22.75 182.89 22.75C182.906 22.75 182.922 22.75 182.938 22.75C182.954 22.75 182.97 22.75 182.986 22.75C183.002 22.75 183.018 22.75 183.034 22.75C183.049 22.75 183.065 22.75 183.081 22.75C183.097 22.75 183.113 22.75 183.129 22.75C183.145 22.75 183.161 22.75 183.177 22.75C183.193 22.75 183.209 22.75 183.225 22.75C183.241 22.75 183.257 22.75 183.273 22.75C183.289 22.75 183.305 22.75 183.321 22.75C183.337 22.75 183.353 22.75 183.369 22.75C183.385 22.75 183.401 22.75 183.417 22.75C183.433 22.75 183.449 22.75 183.465 22.75C183.481 22.75 183.497 22.75 183.513 22.75C183.529 22.75 183.545 22.75 183.561 22.75C183.577 22.75 183.593 22.75 183.609 22.75C183.625 22.75 183.641 22.75 183.657 22.75C183.673 22.75 183.689 22.75 183.705 22.75C183.721 22.75 183.737 22.75 183.753 22.75C183.769 22.75 183.785 22.75 183.801 22.75C183.817 22.75 183.833 22.75 183.849 22.75C183.865 22.75 183.882 22.75 183.898 22.75C183.914 22.75 183.93 22.75 183.946 22.75C183.962 22.75 183.978 22.75 183.994 22.75C184.01 22.75 184.026 22.75 184.042 22.75C184.058 22.75 184.074 22.75 184.091 22.75C184.107 22.75 184.123 22.75 184.139 22.75C184.155 22.75 184.171 22.75 184.187 22.75C184.203 22.75 184.219 22.75 184.236 22.75C184.252 22.75 184.268 22.75 184.284 22.75C184.3 22.75 184.316 22.75 184.332 22.75C184.348 22.75 184.365 22.75 184.381 22.75C184.397 22.75 184.413 22.75 184.429 22.75C184.445 22.75 184.461 22.75 184.478 22.75C184.494 22.75 184.51 22.75 184.526 22.75C184.542 22.75 184.558 22.75 184.574 22.75C184.591 22.75 184.607 22.75 184.623 22.75C184.639 22.75 184.655 22.75 184.671 22.75C184.688 22.75 184.704 22.75 184.72 22.75C184.736 22.75 184.752 22.75 184.768 22.75C184.785 22.75 184.801 22.75 184.817 22.75C184.833 22.75 184.849 22.75 184.866 22.75C184.882 22.75 184.898 22.75 184.914 22.75C184.93 22.75 184.947 22.75 184.963 22.75C184.979 22.75 184.995 22.75 185.011 22.75C185.028 22.75 185.044 22.75 185.06 22.75C185.076 22.75 185.093 22.75 185.109 22.75C185.125 22.75 185.141 22.75 185.157 22.75C185.174 22.75 185.19 22.75 185.206 22.75C185.222 22.75 185.239 22.75 185.255 22.75C185.271 22.75 185.287 22.75 185.304 22.75C185.32 22.75 185.336 22.75 185.352 22.75C185.369 22.75 185.385 22.75 185.401 22.75C185.417 22.75 185.434 22.75 185.45 22.75C185.466 22.75 185.482 22.75 185.499 22.75C185.515 22.75 185.531 22.75 185.547 22.75C185.564 22.75 185.58 22.75 185.596 22.75C185.612 22.75 185.629 22.75 185.645 22.75C185.661 22.75 185.678 22.75 185.694 22.75C185.71 22.75 185.726 22.75 185.743 22.75C185.759 22.75 185.775 22.75 185.792 22.75C185.808 22.75 185.824 22.75 185.84 22.75C185.857 22.75 185.873 22.75 185.889 22.75C185.906 22.75 185.922 22.75 185.938 22.75C185.954 22.75 185.971 22.75 185.987 22.75C186.003 22.75 186.02 22.75 186.036 22.75C186.052 22.75 186.069 22.75 186.085 22.75C186.101 22.75 186.118 22.75 186.134 22.75C186.15 22.75 186.166 22.75 186.183 22.75C186.199 22.75 186.215 22.75 186.232 22.75C186.248 22.75 186.264 22.75 186.281 22.75C186.297 22.75 186.313 22.75 186.33 22.75C186.346 22.75 186.362 22.75 186.379 22.75C186.395 22.75 186.411 22.75 186.428 22.75C186.444 22.75 186.46 22.75 186.477 22.75C186.493 22.75 186.509 22.75 186.526 22.75C186.542 22.75 186.558 22.75 186.575 22.75C186.591 22.75 186.608 22.75 186.624 22.75C186.64 22.75 186.657 22.75 186.673 22.75C186.689 22.75 186.706 22.75 186.722 22.75C186.738 22.75 186.755 22.75 186.771 22.75C186.787 22.75 186.804 22.75 186.82 22.75C186.836 22.75 186.853 22.75 186.869 22.75C186.886 22.75 186.902 22.75 186.918 22.75C186.935 22.75 186.951 22.75 186.967 22.75C186.984 22.75 187 22.75 187.017 22.75C187.033 22.75 187.049 22.75 187.066 22.75C187.082 22.75 187.098 22.75 187.115 22.75C187.131 22.75 187.148 22.75 187.164 22.75C187.18 22.75 187.197 22.75 187.213 22.75C187.229 22.75 187.246 22.75 187.262 22.75C187.279 22.75 187.295 22.75 187.311 22.75C187.328 22.75 187.344 22.75 187.36 22.75C187.377 22.75 187.393 22.75 187.41 22.75C187.426 22.75 187.442 22.75 187.459 22.75C187.475 22.75 187.492 22.75 187.508 22.75C187.524 22.75 187.541 22.75 187.557 22.75C187.574 22.75 187.59 22.75 187.606 22.75C187.623 22.75 187.639 22.75 187.656 22.75C187.672 22.75 187.688 22.75 187.705 22.75C187.721 22.75 187.738 22.75 187.754 22.75C187.77 22.75 187.787 22.75 187.803 22.75C187.82 22.75 187.836 22.75 187.852 22.75C187.869 22.75 187.885 22.75 187.902 22.75C187.918 22.75 187.934 22.75 187.951 22.75C187.967 22.75 187.984 22.75 188 22.75V21.25C187.984 21.25 187.967 21.25 187.951 21.25C187.934 21.25 187.918 21.25 187.902 21.25C187.885 21.25 187.869 21.25 187.852 21.25C187.836 21.25 187.82 21.25 187.803 21.25C187.787 21.25 187.77 21.25 187.754 21.25C187.738 21.25 187.721 21.25 187.705 21.25C187.688 21.25 187.672 21.25 187.656 21.25C187.639 21.25 187.623 21.25 187.606 21.25C187.59 21.25 187.574 21.25 187.557 21.25C187.541 21.25 187.524 21.25 187.508 21.25C187.492 21.25 187.475 21.25 187.459 21.25C187.442 21.25 187.426 21.25 187.41 21.25C187.393 21.25 187.377 21.25 187.36 21.25C187.344 21.25 187.328 21.25 187.311 21.25C187.295 21.25 187.279 21.25 187.262 21.25C187.246 21.25 187.229 21.25 187.213 21.25C187.197 21.25 187.18 21.25 187.164 21.25C187.148 21.25 187.131 21.25 187.115 21.25C187.098 21.25 187.082 21.25 187.066 21.25C187.049 21.25 187.033 21.25 187.017 21.25C187 21.25 186.984 21.25 186.967 21.25C186.951 21.25 186.935 21.25 186.918 21.25C186.902 21.25 186.886 21.25 186.869 21.25C186.853 21.25 186.836 21.25 186.82 21.25C186.804 21.25 186.787 21.25 186.771 21.25C186.755 21.25 186.738 21.25 186.722 21.25C186.706 21.25 186.689 21.25 186.673 21.25C186.657 21.25 186.64 21.25 186.624 21.25C186.608 21.25 186.591 21.25 186.575 21.25C186.558 21.25 186.542 21.25 186.526 21.25C186.509 21.25 186.493 21.25 186.477 21.25C186.46 21.25 186.444 21.25 186.428 21.25C186.411 21.25 186.395 21.25 186.379 21.25C186.362 21.25 186.346 21.25 186.33 21.25C186.313 21.25 186.297 21.25 186.281 21.25C186.264 21.25 186.248 21.25 186.232 21.25C186.215 21.25 186.199 21.25 186.183 21.25C186.166 21.25 186.15 21.25 186.134 21.25C186.118 21.25 186.101 21.25 186.085 21.25C186.069 21.25 186.052 21.25 186.036 21.25C186.02 21.25 186.003 21.25 185.987 21.25C185.971 21.25 185.954 21.25 185.938 21.25C185.922 21.25 185.906 21.25 185.889 21.25C185.873 21.25 185.857 21.25 185.84 21.25C185.824 21.25 185.808 21.25 185.792 21.25C185.775 21.25 185.759 21.25 185.743 21.25C185.726 21.25 185.71 21.25 185.694 21.25C185.678 21.25 185.661 21.25 185.645 21.25C185.629 21.25 185.612 21.25 185.596 21.25C185.58 21.25 185.564 21.25 185.547 21.25C185.531 21.25 185.515 21.25 185.499 21.25C185.482 21.25 185.466 21.25 185.45 21.25C185.434 21.25 185.417 21.25 185.401 21.25C185.385 21.25 185.369 21.25 185.352 21.25C185.336 21.25 185.32 21.25 185.304 21.25C185.287 21.25 185.271 21.25 185.255 21.25C185.239 21.25 185.222 21.25 185.206 21.25C185.19 21.25 185.174 21.25 185.157 21.25C185.141 21.25 185.125 21.25 185.109 21.25C185.093 21.25 185.076 21.25 185.06 21.25C185.044 21.25 185.028 21.25 185.011 21.25C184.995 21.25 184.979 21.25 184.963 21.25C184.947 21.25 184.93 21.25 184.914 21.25C184.898 21.25 184.882 21.25 184.866 21.25C184.849 21.25 184.833 21.25 184.817 21.25C184.801 21.25 184.785 21.25 184.768 21.25C184.752 21.25 184.736 21.25 184.72 21.25C184.704 21.25 184.688 21.25 184.671 21.25C184.655 21.25 184.639 21.25 184.623 21.25C184.607 21.25 184.591 21.25 184.574 21.25C184.558 21.25 184.542 21.25 184.526 21.25C184.51 21.25 184.494 21.25 184.478 21.25C184.461 21.25 184.445 21.25 184.429 21.25C184.413 21.25 184.397 21.25 184.381 21.25C184.365 21.25 184.348 21.25 184.332 21.25C184.316 21.25 184.3 21.25 184.284 21.25C184.268 21.25 184.252 21.25 184.236 21.25C184.219 21.25 184.203 21.25 184.187 21.25C184.171 21.25 184.155 21.25 184.139 21.25C184.123 21.25 184.107 21.25 184.091 21.25C184.074 21.25 184.058 21.25 184.042 21.25C184.026 21.25 184.01 21.25 183.994 21.25C183.978 21.25 183.962 21.25 183.946 21.25C183.93 21.25 183.914 21.25 183.898 21.25C183.882 21.25 183.865 21.25 183.849 21.25C183.833 21.25 183.817 21.25 183.801 21.25C183.785 21.25 183.769 21.25 183.753 21.25C183.737 21.25 183.721 21.25 183.705 21.25C183.689 21.25 183.673 21.25 183.657 21.25C183.641 21.25 183.625 21.25 183.609 21.25C183.593 21.25 183.577 21.25 183.561 21.25C183.545 21.25 183.529 21.25 183.513 21.25C183.497 21.25 183.481 21.25 183.465 21.25C183.449 21.25 183.433 21.25 183.417 21.25C183.401 21.25 183.385 21.25 183.369 21.25C183.353 21.25 183.337 21.25 183.321 21.25C183.305 21.25 183.289 21.25 183.273 21.25C183.257 21.25 183.241 21.25 183.225 21.25C183.209 21.25 183.193 21.25 183.177 21.25C183.161 21.25 183.145 21.25 183.129 21.25C183.113 21.25 183.097 21.25 183.081 21.25C183.065 21.25 183.049 21.25 183.034 21.25C183.018 21.25 183.002 21.25 182.986 21.25C182.97 21.25 182.954 21.25 182.938 21.25C182.922 21.25 182.906 21.25 182.89 21.25C182.874 21.25 182.858 21.25 182.843 21.25C182.827 21.25 182.811 21.25 182.795 21.25C182.779 21.25 182.763 21.25 182.747 21.25C182.731 21.25 182.715 21.25 182.7 21.25C182.684 21.25 182.668 21.25 182.652 21.25C182.636 21.25 182.62 21.25 182.604 21.25C182.589 21.25 182.573 21.25 182.557 21.25C182.541 21.25 182.525 21.25 182.509 21.25C182.494 21.25 182.478 21.25 182.462 21.25C182.446 21.25 182.43 21.25 182.414 21.25C182.399 21.25 182.383 21.25 182.367 21.25C182.351 21.25 182.335 21.25 182.32 21.25C182.304 21.25 182.288 21.25 182.272 21.25C182.256 21.25 182.241 21.25 182.225 21.25C182.209 21.25 182.193 21.25 182.178 21.25C182.162 21.25 182.146 21.25 182.13 21.25C182.114 21.25 182.099 21.25 182.083 21.25C182.067 21.25 182.051 21.25 182.036 21.25C182.02 21.25 182.004 21.25 181.989 21.25C181.973 21.25 181.957 21.25 181.941 21.25C181.926 21.25 181.91 21.25 181.894 21.25C181.878 21.25 181.863 21.25 181.847 21.25C181.831 21.25 181.816 21.25 181.8 21.25C181.784 21.25 181.769 21.25 181.753 21.25C181.737 21.25 181.722 21.25 181.706 21.25C181.69 21.25 181.675 21.25 181.659 21.25C181.643 21.25 181.628 21.25 181.612 21.25C181.596 21.25 181.581 21.25 181.565 21.25C181.549 21.25 181.534 21.25 181.518 21.25C181.503 21.25 181.487 21.25 181.471 21.25C181.456 21.25 181.44 21.25 181.424 21.25C181.409 21.25 181.393 21.25 181.378 21.25C181.362 21.25 181.346 21.25 181.331 21.25C181.315 21.25 181.3 21.25 181.284 21.25C181.269 21.25 181.253 21.25 181.237 21.25C181.222 21.25 181.206 21.25 181.191 21.25C181.175 21.25 181.16 21.25 181.144 21.25C181.129 21.25 181.113 21.25 181.097 21.25C181.082 21.25 181.066 21.25 181.051 21.25C181.035 21.25 181.02 21.25 181.004 21.25C180.989 21.25 180.973 21.25 180.958 21.25C180.942 21.25 180.927 21.25 180.911 21.25C180.896 21.25 180.88 21.25 180.865 21.25C180.85 21.25 180.834 21.25 180.819 21.25C180.803 21.25 180.788 21.25 180.772 21.25C180.757 21.25 180.741 21.25 180.726 21.25C180.71 21.25 180.695 21.25 180.68 21.25C180.664 21.25 180.649 21.25 180.633 21.25C180.618 21.25 180.603 21.25 180.587 21.25C180.572 21.25 180.556 21.25 180.541 21.25C180.526 21.25 180.51 21.25 180.495 21.25C180.479 21.25 180.464 21.25 180.449 21.25C180.433 21.25 180.418 21.25 180.403 21.25C180.387 21.25 180.372 21.25 180.357 21.25C180.341 21.25 180.326 21.25 180.311 21.25C180.295 21.25 180.28 21.25 180.265 21.25C180.249 21.25 180.234 21.25 180.219 21.25C180.203 21.25 180.188 21.25 180.173 21.25C180.157 21.25 180.142 21.25 180.127 21.25C180.112 21.25 180.096 21.25 180.081 21.25C180.066 21.25 180.051 21.25 180.035 21.25C180.02 21.25 180.005 21.25 179.99 21.25C179.974 21.25 179.959 21.25 179.944 21.25C179.929 21.25 179.913 21.25 179.898 21.25C179.883 21.25 179.868 21.25 179.853 21.25C179.837 21.25 179.822 21.25 179.807 21.25C179.792 21.25 179.777 21.25 179.761 21.25C179.746 21.25 179.731 21.25 179.716 21.25C179.701 21.25 179.686 21.25 179.671 21.25C179.655 21.25 179.64 21.25 179.625 21.25C179.61 21.25 179.595 21.25 179.58 21.25C179.565 21.25 179.55 21.25 179.534 21.25C179.519 21.25 179.504 21.25 179.489 21.25C179.474 21.25 179.459 21.25 179.444 21.25C179.429 21.25 179.414 21.25 179.399 21.25C179.384 21.25 179.369 21.25 179.353 21.25C179.338 21.25 179.323 21.25 179.308 21.25C179.293 21.25 179.278 21.25 179.263 21.25C179.248 21.25 179.233 21.25 179.218 21.25C179.203 21.25 179.188 21.25 179.173 21.25C179.158 21.25 179.143 21.25 179.128 21.25C179.113 21.25 179.098 21.25 179.083 21.25C179.068 21.25 179.053 21.25 179.038 21.25C179.023 21.25 179.009 21.25 178.994 21.25C178.979 21.25 178.964 21.25 178.949 21.25C178.934 21.25 178.919 21.25 178.904 21.25C178.889 21.25 178.874 21.25 178.859 21.25C178.844 21.25 178.83 21.25 178.815 21.25C178.8 21.25 178.785 21.25 178.77 21.25C178.755 21.25 178.74 21.25 178.726 21.25C178.711 21.25 178.696 21.25 178.681 21.25C178.666 21.25 178.651 21.25 178.637 21.25C178.622 21.25 178.607 21.25 178.592 21.25C178.577 21.25 178.563 21.25 178.548 21.25C178.533 21.25 178.518 21.25 178.503 21.25C178.489 21.25 178.474 21.25 178.459 21.25C178.444 21.25 178.43 21.25 178.415 21.25C178.4 21.25 178.385 21.25 178.371 21.25C178.356 21.25 178.341 21.25 178.326 21.25C178.312 21.25 178.297 21.25 178.282 21.25C178.268 21.25 178.253 21.25 178.238 21.25C178.224 21.25 178.209 21.25 178.194 21.25C178.18 21.25 178.165 21.25 178.15 21.25C178.136 21.25 178.121 21.25 178.106 21.25C178.092 21.25 178.077 21.25 178.063 21.25C178.048 21.25 178.033 21.25 178.019 21.25C178.004 21.25 177.99 21.25 177.975 21.25C177.96 21.25 177.946 21.25 177.931 21.25C177.917 21.25 177.902 21.25 177.888 21.25C177.873 21.25 177.858 21.25 177.844 21.25C177.829 21.25 177.815 21.25 177.8 21.25C177.786 21.25 177.771 21.25 177.757 21.25C177.742 21.25 177.728 21.25 177.713 21.25C177.699 21.25 177.684 21.25 177.67 21.25C177.655 21.25 177.641 21.25 177.627 21.25C177.612 21.25 177.598 21.25 177.583 21.25C177.569 21.25 177.554 21.25 177.54 21.25C177.526 21.25 177.511 21.25 177.497 21.25C177.482 21.25 177.468 21.25 177.454 21.25C177.439 21.25 177.425 21.25 177.41 21.25C177.396 21.25 177.382 21.25 177.367 21.25C177.353 21.25 177.339 21.25 177.324 21.25C177.31 21.25 177.296 21.25 177.281 21.25C177.267 21.25 177.253 21.25 177.238 21.25C177.224 21.25 177.21 21.25 177.196 21.25C177.181 21.25 177.167 21.25 177.153 21.25C177.138 21.25 177.124 21.25 177.11 21.25C177.096 21.25 177.081 21.25 177.067 21.25C177.053 21.25 177.039 21.25 177.025 21.25C177.01 21.25 176.996 21.25 176.982 21.25C176.968 21.25 176.954 21.25 176.939 21.25C176.925 21.25 176.911 21.25 176.897 21.25C176.883 21.25 176.869 21.25 176.854 21.25C176.84 21.25 176.826 21.25 176.812 21.25C176.798 21.25 176.784 21.25 176.77 21.25C176.756 21.25 176.742 21.25 176.727 21.25C176.713 21.25 176.699 21.25 176.685 21.25C176.671 21.25 176.657 21.25 176.643 21.25C176.629 21.25 176.615 21.25 176.601 21.25C176.587 21.25 176.573 21.25 176.559 21.25C176.545 21.25 176.531 21.25 176.517 21.25C176.503 21.25 176.489 21.25 176.475 21.25C176.461 21.25 176.447 21.25 176.433 21.25C176.419 21.25 176.405 21.25 176.391 21.25C176.377 21.25 176.363 21.25 176.349 21.25C176.336 21.25 176.322 21.25 176.308 21.25C176.294 21.25 176.28 21.25 176.266 21.25C176.252 21.25 176.238 21.25 176.224 21.25C176.211 21.25 176.197 21.25 176.183 21.25C176.169 21.25 176.155 21.25 176.141 21.25C176.128 21.25 176.114 21.25 176.1 21.25C176.086 21.25 176.072 21.25 176.059 21.25C176.045 21.25 176.031 21.25 176.017 21.25C176.004 21.25 175.99 21.25 175.976 21.25C175.962 21.25 175.949 21.25 175.935 21.25C175.921 21.25 175.907 21.25 175.894 21.25C175.88 21.25 175.866 21.25 175.853 21.25C175.839 21.25 175.825 21.25 175.812 21.25C175.798 21.25 175.784 21.25 175.771 21.25C175.757 21.25 175.743 21.25 175.73 21.25C175.716 21.25 175.702 21.25 175.689 21.25C175.675 21.25 175.662 21.25 175.648 21.25C175.635 21.25 175.621 21.25 175.607 21.25C175.594 21.25 175.58 21.25 175.567 21.25C175.553 21.25 175.54 21.25 175.526 21.25C175.513 21.25 175.499 21.25 175.486 21.25C175.472 21.25 175.459 21.25 175.445 21.25C175.432 21.25 175.418 21.25 175.405 21.25C175.391 21.25 175.378 21.25 175.364 21.25C175.351 21.25 175.337 21.25 175.324 21.25C175.311 21.25 175.297 21.25 175.284 21.25C175.27 21.25 175.257 21.25 175.244 21.25C175.23 21.25 175.217 21.25 175.203 21.25C175.19 21.25 175.177 21.25 175.163 21.25C175.15 21.25 175.137 21.25 175.123 21.25C175.11 21.25 175.097 21.25 175.084 21.25C175.07 21.25 175.057 21.25 175.044 21.25C175.03 21.25 175.017 21.25 175.004 21.25C174.991 21.25 174.977 21.25 174.964 21.25C174.951 21.25 174.938 21.25 174.924 21.25C174.911 21.25 174.898 21.25 174.885 21.25C174.872 21.25 174.859 21.25 174.845 21.25C174.832 21.25 174.819 21.25 174.806 21.25C174.793 21.25 174.78 21.25 174.766 21.25C174.753 21.25 174.74 21.25 174.727 21.25C174.714 21.25 174.701 21.25 174.688 21.25C174.675 21.25 174.662 21.25 174.649 21.25C174.636 21.25 174.623 21.25 174.609 21.25C174.596 21.25 174.583 21.25 174.57 21.25C174.557 21.25 174.544 21.25 174.531 21.25C174.518 21.25 174.505 21.25 174.492 21.25C174.479 21.25 174.466 21.25 174.454 21.25C174.441 21.25 174.428 21.25 174.415 21.25C174.402 21.25 174.389 21.25 174.376 21.25C174.363 21.25 174.35 21.25 174.337 21.25C174.324 21.25 174.312 21.25 174.299 21.25C174.286 21.25 174.273 21.25 174.26 21.25C174.247 21.25 174.234 21.25 174.222 21.25C174.209 21.25 174.196 21.25 174.183 21.25C174.17 21.25 174.158 21.25 174.145 21.25C174.132 21.25 174.119 21.25 174.107 21.25C174.094 21.25 174.081 21.25 174.068 21.25C174.056 21.25 174.043 21.25 174.03 21.25C174.018 21.25 174.005 21.25 173.992 21.25C173.98 21.25 173.967 21.25 173.954 21.25C173.942 21.25 173.929 21.25 173.916 21.25C173.904 21.25 173.891 21.25 173.878 21.25C173.866 21.25 173.853 21.25 173.841 21.25C173.828 21.25 173.816 21.25 173.803 21.25C173.79 21.25 173.778 21.25 173.765 21.25C173.753 21.25 173.74 21.25 173.728 21.25C173.715 21.25 173.703 21.25 173.69 21.25C173.678 21.25 173.665 21.25 173.653 21.25C173.64 21.25 173.628 21.25 173.615 21.25C173.603 21.25 173.591 21.25 173.578 21.25C173.566 21.25 173.553 21.25 173.541 21.25C173.529 21.25 173.516 21.25 173.504 21.25C173.491 21.25 173.479 21.25 173.467 21.25C173.454 21.25 173.442 21.25 173.43 21.25C173.417 21.25 173.405 21.25 173.393 21.25C173.38 21.25 173.368 21.25 173.356 21.25C173.344 21.25 173.331 21.25 173.319 21.25C173.307 21.25 173.295 21.25 173.282 21.25C173.27 21.25 173.258 21.25 173.246 21.25C173.234 21.25 173.221 21.25 173.209 21.25C173.197 21.25 173.185 21.25 173.173 21.25C173.161 21.25 173.148 21.25 173.136 21.25C173.124 21.25 173.112 21.25 173.1 21.25C173.088 21.25 173.076 21.25 173.064 21.25C173.052 21.25 173.04 21.25 173.027 21.25C173.015 21.25 173.003 21.25 172.991 21.25C172.979 21.25 172.967 21.25 172.955 21.25C172.943 21.25 172.931 21.25 172.919 21.25C172.907 21.25 172.895 21.25 172.883 21.25C172.872 21.25 172.86 21.25 172.848 21.25C172.836 21.25 172.824 21.25 172.812 21.25C172.8 21.25 172.788 21.25 172.776 21.25C172.764 21.25 172.752 21.25 172.741 21.25C172.729 21.25 172.717 21.25 172.705 21.25C172.693 21.25 172.681 21.25 172.67 21.25C172.658 21.25 172.646 21.25 172.634 21.25C172.623 21.25 172.611 21.25 172.599 21.25C172.587 21.25 172.576 21.25 172.564 21.25C172.552 21.25 172.54 21.25 172.529 21.25C172.517 21.25 172.505 21.25 172.494 21.25C172.482 21.25 172.47 21.25 172.459 21.25C172.447 21.25 172.435 21.25 172.424 21.25C172.412 21.25 172.401 21.25 172.389 21.25C172.377 21.25 172.366 21.25 172.354 21.25C172.343 21.25 172.331 21.25 172.32 21.25C172.308 21.25 172.297 21.25 172.285 21.25C172.274 21.25 172.262 21.25 172.251 21.25C172.239 21.25 172.228 21.25 172.216 21.25C172.205 21.25 172.193 21.25 172.182 21.25C172.17 21.25 172.159 21.25 172.148 21.25C172.136 21.25 172.125 21.25 172.113 21.25C172.102 21.25 172.091 21.25 172.079 21.25C172.068 21.25 172.057 21.25 172.045 21.25C172.034 21.25 172.023 21.25 172.011 21.25C172 21.25 171.989 21.25 171.977 21.25C171.966 21.25 171.955 21.25 171.944 21.25C171.932 21.25 171.921 21.25 171.91 21.25C171.899 21.25 171.888 21.25 171.876 21.25C171.865 21.25 171.854 21.25 171.843 21.25C171.832 21.25 171.821 21.25 171.809 21.25C171.798 21.25 171.787 21.25 171.776 21.25C171.765 21.25 171.754 21.25 171.743 21.25C171.732 21.25 171.721 21.25 171.71 21.25C171.699 21.25 171.688 21.25 171.677 21.25C171.665 21.25 171.654 21.25 171.643 21.25C171.632 21.25 171.621 21.25 171.611 21.25C171.6 21.25 171.589 21.25 171.578 21.25C171.567 21.25 171.556 21.25 171.545 21.25C171.534 21.25 171.523 21.25 171.512 21.25C171.501 21.25 171.49 21.25 171.48 21.25C171.469 21.25 171.458 21.25 171.447 21.25C171.436 21.25 171.425 21.25 171.415 21.25C171.404 21.25 171.393 21.25 171.382 21.25C171.371 21.25 171.361 21.25 171.35 21.25C171.339 21.25 171.329 21.25 171.318 21.25C171.307 21.25 171.296 21.25 171.286 21.25C171.275 21.25 171.264 21.25 171.254 21.25C171.243 21.25 171.232 21.25 171.222 21.25C171.211 21.25 171.201 21.25 171.19 21.25C171.179 21.25 171.169 21.25 171.158 21.25C171.148 21.25 171.137 21.25 171.127 21.25C171.116 21.25 171.105 21.25 171.095 21.25C171.084 21.25 171.074 21.25 171.063 21.25C171.053 21.25 171.042 21.25 171.032 21.25C171.022 21.25 171.011 21.25 171.001 21.25C170.99 21.25 170.98 21.25 170.969 21.25C170.959 21.25 170.949 21.25 170.938 21.25C170.928 21.25 170.918 21.25 170.907 21.25C170.897 21.25 170.887 21.25 170.876 21.25C170.866 21.25 170.856 21.25 170.845 21.25C170.835 21.25 170.825 21.25 170.815 21.25C170.804 21.25 170.794 21.25 170.784 21.25C170.774 21.25 170.764 21.25 170.753 21.25C170.743 21.25 170.733 21.25 170.723 21.25C170.713 21.25 170.703 21.25 170.692 21.25C170.682 21.25 170.672 21.25 170.662 21.25C170.652 21.25 170.642 21.25 170.632 21.25C170.622 21.25 170.612 21.25 170.602 21.25C170.592 21.25 170.582 21.25 170.572 21.25C170.562 21.25 170.552 21.25 170.542 21.25C170.532 21.25 170.522 21.25 170.512 21.25C170.502 21.25 170.492 21.25 170.482 21.25C170.472 21.25 170.462 21.25 170.452 21.25C170.442 21.25 170.432 21.25 170.423 21.25C170.413 21.25 170.403 21.25 170.393 21.25C170.383 21.25 170.373 21.25 170.364 21.25C170.354 21.25 170.344 21.25 170.334 21.25C170.325 21.25 170.315 21.25 170.305 21.25C170.295 21.25 170.286 21.25 170.276 21.25C170.266 21.25 170.257 21.25 170.247 21.25C170.237 21.25 170.228 21.25 170.218 21.25C170.208 21.25 170.199 21.25 170.189 21.25C170.179 21.25 170.17 21.25 170.16 21.25C170.151 21.25 170.141 21.25 170.132 21.25C170.122 21.25 170.113 21.25 170.103 21.25C170.093 21.25 170.084 21.25 170.075 21.25C170.065 21.25 170.056 21.25 170.046 21.25C170.037 21.25 170.027 21.25 170.018 21.25C170.008 21.25 169.999 21.25 169.99 21.25C169.98 21.25 169.971 21.25 169.961 21.25C169.952 21.25 169.943 21.25 169.933 21.25C169.924 21.25 169.915 21.25 169.906 21.25C169.896 21.25 169.887 21.25 169.878 21.25C169.868 21.25 169.859 21.25 169.85 21.25C169.841 21.25 169.832 21.25 169.822 21.25C169.813 21.25 169.804 21.25 169.795 21.25C169.786 21.25 169.776 21.25 169.767 21.25C169.758 21.25 169.749 21.25 169.74 21.25C169.731 21.25 169.722 21.25 169.713 21.25C169.704 21.25 169.695 21.25 169.686 21.25C169.677 21.25 169.668 21.25 169.659 21.25C169.65 21.25 169.641 21.25 169.632 21.25C169.623 21.25 169.614 21.25 169.605 21.25C169.596 21.25 169.587 21.25 169.578 21.25C169.569 21.25 169.56 21.25 169.551 21.25C169.542 21.25 169.534 21.25 169.525 21.25C169.516 21.25 169.507 21.25 169.498 21.25C169.489 21.25 169.481 21.25 169.472 21.25C169.463 21.25 169.454 21.25 169.446 21.25C169.437 21.25 169.428 21.25 169.419 21.25C169.411 21.25 169.402 21.25 169.393 21.25C169.385 21.25 169.376 21.25 169.367 21.25C169.359 21.25 169.35 21.25 169.342 21.25C169.333 21.25 169.324 21.25 169.316 21.25C169.307 21.25 169.299 21.25 169.29 21.25C169.282 21.25 169.273 21.25 169.265 21.25C169.256 21.25 169.248 21.25 169.239 21.25C169.231 21.25 169.222 21.25 169.214 21.25C169.205 21.25 169.197 21.25 169.188 21.25C169.18 21.25 169.172 21.25 169.163 21.25C169.155 21.25 169.147 21.25 169.138 21.25C169.13 21.25 169.122 21.25 169.113 21.25C169.105 21.25 169.097 21.25 169.088 21.25C169.08 21.25 169.072 21.25 169.064 21.25C169.055 21.25 169.047 21.25 169.039 21.25C169.031 21.25 169.023 21.25 169.014 21.25C169.006 21.25 168.998 21.25 168.99 21.25C168.982 21.25 168.974 21.25 168.966 21.25C168.958 21.25 168.949 21.25 168.941 21.25C168.933 21.25 168.925 21.25 168.917 21.25C168.909 21.25 168.901 21.25 168.893 21.25C168.885 21.25 168.877 21.25 168.869 21.25C168.861 21.25 168.853 21.25 168.845 21.25C168.838 21.25 168.83 21.25 168.822 21.25C168.814 21.25 168.806 21.25 168.798 21.25C168.79 21.25 168.782 21.25 168.775 21.25C168.767 21.25 168.759 21.25 168.751 21.25C168.743 21.25 168.736 21.25 168.728 21.25C168.72 21.25 168.712 21.25 168.705 21.25C168.697 21.25 168.689 21.25 168.682 21.25C168.674 21.25 168.666 21.25 168.659 21.25C168.651 21.25 168.643 21.25 168.636 21.25C168.628 21.25 168.621 21.25 168.613 21.25C168.605 21.25 168.598 21.25 168.59 21.25C168.583 21.25 168.575 21.25 168.568 21.25C168.56 21.25 168.553 21.25 168.545 21.25C168.538 21.25 168.53 21.25 168.523 21.25C168.516 21.25 168.508 21.25 168.501 21.25C168.493 21.25 168.486 21.25 168.479 21.25C168.471 21.25 168.464 21.25 168.457 21.25C168.449 21.25 168.442 21.25 168.435 21.25C168.427 21.25 168.42 21.25 168.413 21.25C168.406 21.25 168.398 21.25 168.391 21.25C168.384 21.25 168.377 21.25 168.37 21.25C168.362 21.25 168.355 21.25 168.348 21.25C168.341 21.25 168.334 21.25 168.327 21.25C168.32 21.25 168.313 21.25 168.306 21.25C168.298 21.25 168.291 21.25 168.284 21.25C168.277 21.25 168.27 21.25 168.263 21.25C168.256 21.25 168.249 21.25 168.242 21.25C168.235 21.25 168.229 21.25 168.222 21.25C168.215 21.25 168.208 21.25 168.201 21.25C168.194 21.25 168.187 21.25 168.18 21.25C168.173 21.25 168.167 21.25 168.16 21.25C168.153 21.25 168.146 21.25 168.139 21.25C168.133 21.25 168.126 21.25 168.119 21.25C168.112 21.25 168.106 21.25 168.099 21.25C168.092 21.25 168.086 21.25 168.079 21.25C168.072 21.25 168.066 21.25 168.059 21.25C168.052 21.25 168.046 21.25 168.039 21.25C168.033 21.25 168.026 21.25 168.02 21.25C168.013 21.25 168.007 21.25 168 21.25V22.75ZM188 22.75C190.117 22.75 191.864 22.2192 193.061 20.8733C194.239 19.5478 194.75 17.5766 194.75 15H193.25C193.25 17.4234 192.761 18.9522 191.939 19.8767C191.136 20.7808 189.883 21.25 188 21.25V22.75ZM194.75 15C194.75 14.9902 194.75 14.9804 194.75 14.9706C194.75 14.9608 194.75 14.9509 194.75 14.941C194.75 14.9312 194.75 14.9213 194.75 14.9113C194.75 14.9014 194.75 14.8914 194.75 14.8814C194.75 14.8714 194.75 14.8614 194.75 14.8514C194.75 14.8413 194.75 14.8312 194.75 14.8211C194.75 14.811 194.75 14.8009 194.75 14.7907C194.75 14.7806 194.75 14.7704 194.75 14.7602C194.75 14.7499 194.75 14.7397 194.75 14.7294C194.75 14.7192 194.75 14.7089 194.75 14.6985C194.75 14.6882 194.75 14.6778 194.75 14.6675C194.75 14.6571 194.75 14.6467 194.75 14.6362C194.75 14.6258 194.75 14.6153 194.75 14.6048C194.75 14.5943 194.75 14.5838 194.75 14.5733C194.75 14.5627 194.75 14.5521 194.75 14.5415C194.75 14.5309 194.75 14.5203 194.75 14.5097C194.75 14.499 194.75 14.4883 194.75 14.4776C194.75 14.4669 194.75 14.4562 194.75 14.4454C194.75 14.4346 194.75 14.4238 194.75 14.413C194.75 14.4022 194.75 14.3914 194.75 14.3805C194.75 14.3696 194.75 14.3587 194.75 14.3478C194.75 14.3369 194.75 14.3259 194.75 14.3149C194.75 14.304 194.75 14.293 194.75 14.2819C194.75 14.2709 194.75 14.2598 194.75 14.2488C194.75 14.2377 194.75 14.2266 194.75 14.2154C194.75 14.2043 194.75 14.1931 194.75 14.1819C194.75 14.1708 194.75 14.1595 194.75 14.1483C194.75 14.1371 194.75 14.1258 194.75 14.1145C194.75 14.1032 194.75 14.0919 194.75 14.0806C194.75 14.0692 194.75 14.0578 194.75 14.0464C194.75 14.0351 194.75 14.0236 194.75 14.0122C194.75 14.0007 194.75 13.9893 194.75 13.9778C194.75 13.9663 194.75 13.9547 194.75 13.9432C194.75 13.9317 194.75 13.9201 194.75 13.9085C194.75 13.8969 194.75 13.8853 194.75 13.8736C194.75 13.862 194.75 13.8503 194.75 13.8386C194.75 13.8269 194.75 13.8152 194.75 13.8034C194.75 13.7917 194.75 13.7799 194.75 13.7681C194.75 13.7563 194.75 13.7445 194.75 13.7326C194.75 13.7208 194.75 13.7089 194.75 13.697C194.75 13.6851 194.75 13.6732 194.75 13.6612C194.75 13.6493 194.75 13.6373 194.75 13.6253C194.75 13.6133 194.75 13.6013 194.75 13.5892C194.75 13.5772 194.75 13.5651 194.75 13.553C194.75 13.5409 194.75 13.5288 194.75 13.5166C194.75 13.5045 194.75 13.4923 194.75 13.4801C194.75 13.4679 194.75 13.4557 194.75 13.4435C194.75 13.4312 194.75 13.419 194.75 13.4067C194.75 13.3944 194.75 13.3821 194.75 13.3698C194.75 13.3574 194.75 13.3451 194.75 13.3327C194.75 13.3203 194.75 13.3079 194.75 13.2954C194.75 13.283 194.75 13.2706 194.75 13.2581C194.75 13.2456 194.75 13.2331 194.75 13.2206C194.75 13.208 194.75 13.1955 194.75 13.1829C194.75 13.1704 194.75 13.1578 194.75 13.1451C194.75 13.1325 194.75 13.1199 194.75 13.1072C194.75 13.0945 194.75 13.0818 194.75 13.0691C194.75 13.0564 194.75 13.0437 194.75 13.0309C194.75 13.0182 194.75 13.0054 194.75 12.9926C194.75 12.9798 194.75 12.967 194.75 12.9541C194.75 12.9413 194.75 12.9284 194.75 12.9155C194.75 12.9026 194.75 12.8897 194.75 12.8767C194.75 12.8638 194.75 12.8508 194.75 12.8378C194.75 12.8249 194.75 12.8118 194.75 12.7988C194.75 12.7858 194.75 12.7727 194.75 12.7597C194.75 12.7466 194.75 12.7335 194.75 12.7204C194.75 12.7072 194.75 12.6941 194.75 12.6809C194.75 12.6678 194.75 12.6546 194.75 12.6414C194.75 12.6282 194.75 12.6149 194.75 12.6017C194.75 12.5884 194.75 12.5752 194.75 12.5619C194.75 12.5486 194.75 12.5352 194.75 12.5219C194.75 12.5086 194.75 12.4952 194.75 12.4818C194.75 12.4684 194.75 12.455 194.75 12.4416C194.75 12.4282 194.75 12.4147 194.75 12.4013C194.75 12.3878 194.75 12.3743 194.75 12.3608C194.75 12.3473 194.75 12.3337 194.75 12.3202C194.75 12.3066 194.75 12.2931 194.75 12.2795C194.75 12.2659 194.75 12.2522 194.75 12.2386C194.75 12.225 194.75 12.2113 194.75 12.1976C194.75 12.1839 194.75 12.1702 194.75 12.1565C194.75 12.1428 194.75 12.129 194.75 12.1153C194.75 12.1015 194.75 12.0877 194.75 12.0739C194.75 12.0601 194.75 12.0463 194.75 12.0324C194.75 12.0186 194.75 12.0047 194.75 11.9908C194.75 11.9769 194.75 11.963 194.75 11.9491C194.75 11.9352 194.75 11.9212 194.75 11.9073C194.75 11.8933 194.75 11.8793 194.75 11.8653C194.75 11.8513 194.75 11.8372 194.75 11.8232C194.75 11.8091 194.75 11.7951 194.75 11.781C194.75 11.7669 194.75 11.7528 194.75 11.7386C194.75 11.7245 194.75 11.7104 194.75 11.6962C194.75 11.682 194.75 11.6678 194.75 11.6536C194.75 11.6394 194.75 11.6252 194.75 11.6109C194.75 11.5967 194.75 11.5824 194.75 11.5681C194.75 11.5538 194.75 11.5395 194.75 11.5252C194.75 11.5109 194.75 11.4965 194.75 11.4822C194.75 11.4678 194.75 11.4534 194.75 11.439C194.75 11.4246 194.75 11.4102 194.75 11.3957C194.75 11.3813 194.75 11.3668 194.75 11.3523C194.75 11.3379 194.75 11.3234 194.75 11.3088C194.75 11.2943 194.75 11.2798 194.75 11.2652C194.75 11.2507 194.75 11.2361 194.75 11.2215C194.75 11.2069 194.75 11.1923 194.75 11.1777C194.75 11.163 194.75 11.1484 194.75 11.1337C194.75 11.119 194.75 11.1044 194.75 11.0897C194.75 11.0749 194.75 11.0602 194.75 11.0455C194.75 11.0307 194.75 11.016 194.75 11.0012C194.75 10.9864 194.75 10.9716 194.75 10.9568C194.75 10.942 194.75 10.9272 194.75 10.9123C194.75 10.8975 194.75 10.8826 194.75 10.8677C194.75 10.8528 194.75 10.8379 194.75 10.823C194.75 10.8081 194.75 10.7931 194.75 10.7782C194.75 10.7632 194.75 10.7482 194.75 10.7332C194.75 10.7182 194.75 10.7032 194.75 10.6882C194.75 10.6732 194.75 10.6581 194.75 10.643C194.75 10.628 194.75 10.6129 194.75 10.5978C194.75 10.5827 194.75 10.5676 194.75 10.5524C194.75 10.5373 194.75 10.5222 194.75 10.507C194.75 10.4918 194.75 10.4766 194.75 10.4614C194.75 10.4462 194.75 10.431 194.75 10.4158C194.75 10.4005 194.75 10.3853 194.75 10.37C194.75 10.3547 194.75 10.3394 194.75 10.3241C194.75 10.3088 194.75 10.2935 194.75 10.2782C194.75 10.2628 194.75 10.2475 194.75 10.2321C194.75 10.2167 194.75 10.2014 194.75 10.1859C194.75 10.1705 194.75 10.1551 194.75 10.1397C194.75 10.1242 194.75 10.1088 194.75 10.0933C194.75 10.0779 194.75 10.0624 194.75 10.0469C194.75 10.0314 194.75 10.0158 194.75 10.0003C194.75 9.98477 194.75 9.96922 194.75 9.95365C194.75 9.93808 194.75 9.9225 194.75 9.9069C194.75 9.8913 194.75 9.87569 194.75 9.86005C194.75 9.84442 194.75 9.82878 194.75 9.81311C194.75 9.79745 194.75 9.78177 194.75 9.76608C194.75 9.75038 194.75 9.73468 194.75 9.71895C194.75 9.70322 194.75 9.68748 194.75 9.67173C194.75 9.65597 194.75 9.6402 194.75 9.62441C194.75 9.60863 194.75 9.59282 194.75 9.57701C194.75 9.56119 194.75 9.54536 194.75 9.52951C194.75 9.51366 194.75 9.4978 194.75 9.48192C194.75 9.46604 194.75 9.45015 194.75 9.43424C194.75 9.41833 194.75 9.40241 194.75 9.38647C194.75 9.37053 194.75 9.35458 194.75 9.33861C194.75 9.32265 194.75 9.30666 194.75 9.29067C194.75 9.27467 194.75 9.25866 194.75 9.24263C194.75 9.22661 194.75 9.21057 194.75 9.19451C194.75 9.17845 194.75 9.16239 194.75 9.1463C194.75 9.13022 194.75 9.11412 194.75 9.09801C194.75 9.08189 194.75 9.06577 194.75 9.04963C194.75 9.03348 194.75 9.01733 194.75 9.00116C194.75 8.98499 194.75 8.96881 194.75 8.95261C194.75 8.93641 194.75 8.9202 194.75 8.90397C194.75 8.88775 194.75 8.87151 194.75 8.85526C194.75 8.839 194.75 8.82274 194.75 8.80646C194.75 8.79018 194.75 8.77388 194.75 8.75757C194.75 8.74127 194.75 8.72495 194.75 8.70861C194.75 8.69228 194.75 8.67593 194.75 8.65957C194.75 8.6432 194.75 8.62683 194.75 8.61044C194.75 8.59405 194.75 8.57765 194.75 8.56123C194.75 8.54482 194.75 8.52839 194.75 8.51195C194.75 8.49551 194.75 8.47905 194.75 8.46259C194.75 8.44612 194.75 8.42964 194.75 8.41315C194.75 8.39665 194.75 8.38015 194.75 8.36363C194.75 8.34711 194.75 8.33058 194.75 8.31403C194.75 8.29749 194.75 8.28093 194.75 8.26436C194.75 8.24779 194.75 8.23121 194.75 8.21461C194.75 8.19802 194.75 8.18141 194.75 8.16479C194.75 8.14817 194.75 8.13153 194.75 8.11489C194.75 8.09824 194.75 8.08159 194.75 8.06492C194.75 8.04825 194.75 8.03157 194.75 8.01487C194.75 7.99818 194.75 7.98147 194.75 7.96475C194.75 7.94804 194.75 7.93131 194.75 7.91456C194.75 7.89782 194.75 7.88107 194.75 7.8643C194.75 7.84754 194.75 7.83076 194.75 7.81397C194.75 7.79718 194.75 7.78038 194.75 7.76357C194.75 7.74675 194.75 7.72993 194.75 7.71309C194.75 7.69626 194.75 7.67941 194.75 7.66255C194.75 7.64569 194.75 7.62882 194.75 7.61194C194.75 7.59505 194.75 7.57816 194.75 7.56126C194.75 7.54435 194.75 7.52744 194.75 7.51051C194.75 7.49358 194.75 7.47664 194.75 7.45969C194.75 7.44274 194.75 7.42578 194.75 7.40881C194.75 7.39184 194.75 7.37486 194.75 7.35787C194.75 7.34087 194.75 7.32387 194.75 7.30685C194.75 7.28984 194.75 7.27281 194.75 7.25578C194.75 7.23874 194.75 7.22169 194.75 7.20463C194.75 7.18758 194.75 7.17051 194.75 7.15343C194.75 7.13635 194.75 7.11926 194.75 7.10216C194.75 7.08506 194.75 7.06795 194.75 7.05083C194.75 7.03371 194.75 7.01658 194.75 6.99944C194.75 6.9823 194.75 6.96515 194.75 6.94799C194.75 6.93083 194.75 6.91365 194.75 6.89647C194.75 6.87929 194.75 6.8621 194.75 6.8449C194.75 6.8277 194.75 6.81049 194.75 6.79326C194.75 6.77604 194.75 6.75881 194.75 6.74157C194.75 6.72433 194.75 6.70708 194.75 6.68982C194.75 6.67256 194.75 6.65529 194.75 6.63801C194.75 6.62073 194.75 6.60344 194.75 6.58615C194.75 6.56885 194.75 6.55154 194.75 6.53422C194.75 6.51691 194.75 6.49958 194.75 6.48225C194.75 6.46491 194.75 6.44757 194.75 6.43021C194.75 6.41286 194.75 6.3955 194.75 6.37812C194.75 6.36075 194.75 6.34337 194.75 6.32598C194.75 6.30859 194.75 6.29119 194.75 6.27378C194.75 6.25638 194.75 6.23896 194.75 6.22153C194.75 6.20411 194.75 6.18667 194.75 6.16923C194.75 6.15179 194.75 6.13434 194.75 6.11688C194.75 6.09942 194.75 6.08195 194.75 6.06447C194.75 6.04699 194.75 6.02951 194.75 6.01202C194.75 5.99452 194.75 5.97702 194.75 5.95951C194.75 5.942 194.75 5.92448 194.75 5.90695C194.75 5.88943 194.75 5.87189 194.75 5.85435C194.75 5.8368 194.75 5.81925 194.75 5.80169C194.75 5.78413 194.75 5.76657 194.75 5.74899C194.75 5.73142 194.75 5.71383 194.75 5.69624C194.75 5.67865 194.75 5.66105 194.75 5.64345C194.75 5.62584 194.75 5.60823 194.75 5.59061C194.75 5.57298 194.75 5.55536 194.75 5.53772C194.75 5.52008 194.75 5.50244 194.75 5.48479C194.75 5.46714 194.75 5.44948 194.75 5.43181C194.75 5.41414 194.75 5.39647 194.75 5.37879C194.75 5.36111 194.75 5.34342 194.75 5.32573C194.75 5.30803 194.75 5.29033 194.75 5.27262C194.75 5.25491 194.75 5.23719 194.75 5.21947C194.75 5.20175 194.75 5.18402 194.75 5.16628C194.75 5.14854 194.75 5.1308 194.75 5.11305C194.75 5.0953 194.75 5.07754 194.75 5.05978C194.75 5.04202 194.75 5.02425 194.75 5.00647C194.75 4.98869 194.75 4.97091 194.75 4.95312C194.75 4.93533 194.75 4.91753 194.75 4.89973C194.75 4.88193 194.75 4.86412 194.75 4.8463C194.75 4.82849 194.75 4.81067 194.75 4.79284C194.75 4.77501 194.75 4.75718 194.75 4.73934C194.75 4.7215 194.75 4.70365 194.75 4.6858C194.75 4.66795 194.75 4.65009 194.75 4.63223C194.75 4.61437 194.75 4.5965 194.75 4.57862C194.75 4.56075 194.75 4.54287 194.75 4.52498C194.75 4.50709 194.75 4.4892 194.75 4.4713C194.75 4.4534 194.75 4.4355 194.75 4.41759C194.75 4.39968 194.75 4.38177 194.75 4.36385C194.75 4.34593 194.75 4.32801 194.75 4.31008C194.75 4.29215 194.75 4.27421 194.75 4.25627C194.75 4.23833 194.75 4.22038 194.75 4.20243C194.75 4.18448 194.75 4.16653 194.75 4.14856C194.75 4.1306 194.75 4.11264 194.75 4.09467C194.75 4.0767 194.75 4.05872 194.75 4.04074C194.75 4.02276 194.75 4.00477 194.75 3.98678C194.75 3.96879 194.75 3.9508 194.75 3.9328C194.75 3.9148 194.75 3.8968 194.75 3.87879C194.75 3.86078 194.75 3.84277 194.75 3.82475C194.75 3.80673 194.75 3.78871 194.75 3.77069C194.75 3.75266 194.75 3.73463 194.75 3.7166C194.75 3.69856 194.75 3.68052 194.75 3.66248C194.75 3.64444 194.75 3.62639 194.75 3.60834C194.75 3.59029 194.75 3.57224 194.75 3.55418C194.75 3.53612 194.75 3.51806 194.75 3.49999C194.75 3.48192 194.75 3.46385 194.75 3.44578C194.75 3.42771 194.75 3.40963 194.75 3.39155C194.75 3.37347 194.75 3.35538 194.75 3.33729C194.75 3.3192 194.75 3.30111 194.75 3.28302C194.75 3.26492 194.75 3.24682 194.75 3.22872C194.75 3.21062 194.75 3.19251 194.75 3.1744C194.75 3.15629 194.75 3.13818 194.75 3.12007C194.75 3.10195 194.75 3.08383 194.75 3.06571C194.75 3.04759 194.75 3.02947 194.75 3.01134C194.75 2.99321 194.75 2.97508 194.75 2.95695C194.75 2.93882 194.75 2.92068 194.75 2.90254C194.75 2.8844 194.75 2.86626 194.75 2.84812C194.75 2.82997 194.75 2.81183 194.75 2.79368C194.75 2.77553 194.75 2.75738 194.75 2.73922C194.75 2.72107 194.75 2.70291 194.75 2.68475C194.75 2.66659 194.75 2.64843 194.75 2.63027C194.75 2.61211 194.75 2.59394 194.75 2.57577C194.75 2.5576 194.75 2.53943 194.75 2.52126C194.75 2.50309 194.75 2.48491 194.75 2.46674C194.75 2.44856 194.75 2.43038 194.75 2.4122C194.75 2.39402 194.75 2.37584 194.75 2.35766C194.75 2.33947 194.75 2.32129 194.75 2.3031C194.75 2.28491 194.75 2.26672 194.75 2.24853C194.75 2.23034 194.75 2.21215 194.75 2.19396C194.75 2.17576 194.75 2.15757 194.75 2.13937C194.75 2.12117 194.75 2.10298 194.75 2.08478C194.75 2.06658 194.75 2.04838 194.75 2.03018C194.75 2.01197 194.75 1.99377 194.75 1.97557C194.75 1.95736 194.75 1.93916 194.75 1.92095C194.75 1.90274 194.75 1.88454 194.75 1.86633C194.75 1.84812 194.75 1.82991 194.75 1.8117C194.75 1.79349 194.75 1.77528 194.75 1.75707C194.75 1.73886 194.75 1.72065 194.75 1.70243C194.75 1.68422 194.75 1.66601 194.75 1.64779C194.75 1.62958 194.75 1.61137 194.75 1.59315C194.75 1.57494 194.75 1.55672 194.75 1.53851C194.75 1.52029 194.75 1.50207 194.75 1.48386C194.75 1.46564 194.75 1.44743 194.75 1.42921C194.75 1.41099 194.75 1.39278 194.75 1.37456C194.75 1.35634 194.75 1.33813 194.75 1.31991C194.75 1.30169 194.75 1.28348 194.75 1.26526C194.75 1.24704 194.75 1.22883 194.75 1.21061C194.75 1.1924 194.75 1.17418 194.75 1.15597C194.75 1.13775 194.75 1.11953 194.75 1.10132C194.75 1.08311 194.75 1.06489 194.75 1.04668C194.75 1.02846 194.75 1.01025 194.75 0.992039C194.75 0.973827 194.75 0.955615 194.75 0.937404C194.75 0.919193 194.75 0.900983 194.75 0.882773C194.75 0.864564 194.75 0.846355 194.75 0.828147C194.75 0.80994 194.75 0.791733 194.75 0.773527C194.75 0.755321 194.75 0.737117 194.75 0.718913C194.75 0.70071 194.75 0.682507 194.75 0.664306C194.75 0.646105 194.75 0.627905 194.75 0.609706C194.75 0.591507 194.75 0.57331 194.75 0.555114C194.75 0.536918 194.75 0.518724 194.75 0.500531C194.75 0.482338 194.75 0.464146 194.75 0.445956C194.75 0.427766 194.75 0.409578 194.75 0.391391C194.75 0.373205 194.75 0.35502 194.75 0.336837C194.75 0.318654 194.75 0.300473 194.75 0.282293C194.75 0.264114 194.75 0.245936 194.75 0.227761C194.75 0.209585 194.75 0.191412 194.75 0.173241C194.75 0.155069 194.75 0.1369 194.75 0.118733C194.75 0.100566 194.75 0.0824007 194.75 0.0642381C194.75 0.0460755 194.75 0.0279152 194.75 0.00975721C194.75 -0.00840074 194.75 -0.0265563 194.75 -0.0447094C194.75 -0.0628625 194.75 -0.0810131 194.75 -0.0991611C194.75 -0.117309 194.75 -0.135455 194.75 -0.153597C194.75 -0.17174 194.75 -0.18988 194.75 -0.208018C194.75 -0.226155 194.75 -0.244289 194.75 -0.262421C194.75 -0.280553 194.75 -0.298682 194.75 -0.316807C194.75 -0.334933 194.75 -0.353056 194.75 -0.371176C194.75 -0.389296 194.75 -0.407413 194.75 -0.425526C194.75 -0.44364 194.75 -0.46175 194.75 -0.479857C194.75 -0.497965 194.75 -0.516069 194.75 -0.534169C194.75 -0.55227 194.75 -0.570367 194.75 -0.588461C194.75 -0.606555 194.75 -0.624645 194.75 -0.642732C194.75 -0.660818 194.75 -0.678902 194.75 -0.696981C194.75 -0.715061 194.75 -0.733137 194.75 -0.751209C194.75 -0.769281 194.75 -0.78735 194.75 -0.805414C194.75 -0.823479 194.75 -0.84154 194.75 -0.859597C194.75 -0.877653 194.75 -0.895706 194.75 -0.913755C194.75 -0.931804 194.75 -0.949849 194.75 -0.96789C194.75 -0.985931 194.75 -1.00397 194.75 -1.022C194.75 -1.04003 194.75 -1.05806 194.75 -1.07608C194.75 -1.09411 194.75 -1.11213 194.75 -1.13014C194.75 -1.14816 194.75 -1.16617 194.75 -1.18417C194.75 -1.20218 194.75 -1.22018 194.75 -1.23818C194.75 -1.25618 194.75 -1.27417 194.75 -1.29216C194.75 -1.31014 194.75 -1.32813 194.75 -1.34611C194.75 -1.36408 194.75 -1.38206 194.75 -1.40003C194.75 -1.41799 194.75 -1.43596 194.75 -1.45392C194.75 -1.47187 194.75 -1.48983 194.75 -1.50778C194.75 -1.52573 194.75 -1.54367 194.75 -1.56161C194.75 -1.57955 194.75 -1.59748 194.75 -1.61541C194.75 -1.63333 194.75 -1.65126 194.75 -1.66917C194.75 -1.68709 194.75 -1.705 194.75 -1.72291C194.75 -1.74081 194.75 -1.75871 194.75 -1.77661C194.75 -1.79451 194.75 -1.81239 194.75 -1.83028C194.75 -1.84816 194.75 -1.86604 194.75 -1.88391C194.75 -1.90179 194.75 -1.91965 194.75 -1.93751C194.75 -1.95537 194.75 -1.97323 194.75 -1.99108C194.75 -2.00893 194.75 -2.02677 194.75 -2.04461C194.75 -2.06244 194.75 -2.08027 194.75 -2.0981C194.75 -2.11592 194.75 -2.13374 194.75 -2.15155C194.75 -2.16937 194.75 -2.18717 194.75 -2.20497C194.75 -2.22277 194.75 -2.24056 194.75 -2.25835C194.75 -2.27614 194.75 -2.29392 194.75 -2.31169C194.75 -2.32947 194.75 -2.34723 194.75 -2.36499C194.75 -2.38275 194.75 -2.40051 194.75 -2.41826C194.75 -2.436 194.75 -2.45374 194.75 -2.47148C194.75 -2.48921 194.75 -2.50694 194.75 -2.52466C194.75 -2.54238 194.75 -2.56009 194.75 -2.5778C194.75 -2.5955 194.75 -2.6132 194.75 -2.63089C194.75 -2.64858 194.75 -2.66627 194.75 -2.68395C194.75 -2.70162 194.75 -2.71929 194.75 -2.73696C194.75 -2.75462 194.75 -2.77228 194.75 -2.78992C194.75 -2.80757 194.75 -2.82521 194.75 -2.84285C194.75 -2.86048 194.75 -2.8781 194.75 -2.89572C194.75 -2.91334 194.75 -2.93095 194.75 -2.94855C194.75 -2.96616 194.75 -2.98375 194.75 -3.00134C194.75 -3.01893 194.75 -3.0365 194.75 -3.05408C194.75 -3.07165 194.75 -3.08921 194.75 -3.10677C194.75 -3.12432 194.75 -3.14187 194.75 -3.15941C194.75 -3.17695 194.75 -3.19448 194.75 -3.212C194.75 -3.22953 194.75 -3.24704 194.75 -3.26455C194.75 -3.28205 194.75 -3.29955 194.75 -3.31704C194.75 -3.33453 194.75 -3.35201 194.75 -3.36949C194.75 -3.38696 194.75 -3.40443 194.75 -3.42188C194.75 -3.43934 194.75 -3.45679 194.75 -3.47422C194.75 -3.49166 194.75 -3.50909 194.75 -3.52651C194.75 -3.54394 194.75 -3.56135 194.75 -3.57875C194.75 -3.59616 194.75 -3.61355 194.75 -3.63094C194.75 -3.64832 194.75 -3.6657 194.75 -3.68307C194.75 -3.70043 194.75 -3.71779 194.75 -3.73514C194.75 -3.75249 194.75 -3.76983 194.75 -3.78716C194.75 -3.8045 194.75 -3.82182 194.75 -3.83913C194.75 -3.85644 194.75 -3.87375 194.75 -3.89104C194.75 -3.90833 194.75 -3.92562 194.75 -3.94289C194.75 -3.96017 194.75 -3.97743 194.75 -3.99469C194.75 -4.01194 194.75 -4.02919 194.75 -4.04642C194.75 -4.06366 194.75 -4.08089 194.75 -4.0981C194.75 -4.11532 194.75 -4.13253 194.75 -4.14972C194.75 -4.16692 194.75 -4.18411 194.75 -4.20128C194.75 -4.21846 194.75 -4.23563 194.75 -4.25278C194.75 -4.26994 194.75 -4.28709 194.75 -4.30422C194.75 -4.32136 194.75 -4.33849 194.75 -4.3556C194.75 -4.37272 194.75 -4.38982 194.75 -4.40692C194.75 -4.42401 194.75 -4.4411 194.75 -4.45817C194.75 -4.47524 194.75 -4.49231 194.75 -4.50936C194.75 -4.52641 194.75 -4.54346 194.75 -4.56049C194.75 -4.57752 194.75 -4.59454 194.75 -4.61155C194.75 -4.62856 194.75 -4.64556 194.75 -4.66255C194.75 -4.67954 194.75 -4.69651 194.75 -4.71348C194.75 -4.73045 194.75 -4.7474 194.75 -4.76434C194.75 -4.78129 194.75 -4.79822 194.75 -4.81514C194.75 -4.83207 194.75 -4.84898 194.75 -4.86588C194.75 -4.88278 194.75 -4.89966 194.75 -4.91654C194.75 -4.93342 194.75 -4.95028 194.75 -4.96714C194.75 -4.98399 194.75 -5.00083 194.75 -5.01766C194.75 -5.03449 194.75 -5.05131 194.75 -5.06812C194.75 -5.08493 194.75 -5.10172 194.75 -5.11851C194.75 -5.13529 194.75 -5.15207 194.75 -5.16883C194.75 -5.18559 194.75 -5.20233 194.75 -5.21907C194.75 -5.23581 194.75 -5.25253 194.75 -5.26925C194.75 -5.28596 194.75 -5.30266 194.75 -5.31935C194.75 -5.33603 194.75 -5.35271 194.75 -5.36937C194.75 -5.38604 194.75 -5.40269 194.75 -5.41933C194.75 -5.43597 194.75 -5.4526 194.75 -5.46921C194.75 -5.48582 194.75 -5.50243 194.75 -5.51902C194.75 -5.53561 194.75 -5.55218 194.75 -5.56875C194.75 -5.58531 194.75 -5.60186 194.75 -5.6184C194.75 -5.63494 194.75 -5.65147 194.75 -5.66798C194.75 -5.68449 194.75 -5.70099 194.75 -5.71748C194.75 -5.73397 194.75 -5.75044 194.75 -5.7669C194.75 -5.78336 194.75 -5.79981 194.75 -5.81625C194.75 -5.83268 194.75 -5.84911 194.75 -5.86551C194.75 -5.88192 194.75 -5.89832 194.75 -5.9147C194.75 -5.93108 194.75 -5.94745 194.75 -5.96381C194.75 -5.98016 194.75 -5.99651 194.75 -6.01284C194.75 -6.02916 194.75 -6.04548 194.75 -6.06178C194.75 -6.07808 194.75 -6.09437 194.75 -6.11064C194.75 -6.12692 194.75 -6.14318 194.75 -6.15943C194.75 -6.17567 194.75 -6.1919 194.75 -6.20812C194.75 -6.22434 194.75 -6.24055 194.75 -6.25674C194.75 -6.27293 194.75 -6.28911 194.75 -6.30527C194.75 -6.32143 194.75 -6.33758 194.75 -6.35372C194.75 -6.36985 194.75 -6.38597 194.75 -6.40208C194.75 -6.41818 194.75 -6.43427 194.75 -6.45035C194.75 -6.46643 194.75 -6.48249 194.75 -6.49854C194.75 -6.51459 194.75 -6.53062 194.75 -6.54664C194.75 -6.56266 194.75 -6.57867 194.75 -6.59466C194.75 -6.61065 194.75 -6.62662 194.75 -6.64258C194.75 -6.65854 194.75 -6.67449 194.75 -6.69042C194.75 -6.70635 194.75 -6.72227 194.75 -6.73817C194.75 -6.75407 194.75 -6.76996 194.75 -6.78583C194.75 -6.8017 194.75 -6.81756 194.75 -6.8334C194.75 -6.84924 194.75 -6.86506 194.75 -6.88087C194.75 -6.89668 194.75 -6.91248 194.75 -6.92826C194.75 -6.94404 194.75 -6.9598 194.75 -6.97555C194.75 -6.9913 194.75 -7.00703 194.75 -7.02275C194.75 -7.03847 194.75 -7.05417 194.75 -7.06986C194.75 -7.08555 194.75 -7.10122 194.75 -7.11687C194.75 -7.13253 194.75 -7.14817 194.75 -7.16379C194.75 -7.17942 194.75 -7.19502 194.75 -7.21062C194.75 -7.22621 194.75 -7.24178 194.75 -7.25734C194.75 -7.2729 194.75 -7.28845 194.75 -7.30398C194.75 -7.3195 194.75 -7.33501 194.75 -7.35051C194.75 -7.36601 194.75 -7.38148 194.75 -7.39695C194.75 -7.41241 194.75 -7.42786 194.75 -7.44329C194.75 -7.45872 194.75 -7.47413 194.75 -7.48953C194.75 -7.50493 194.75 -7.52031 194.75 -7.53567C194.75 -7.55103 194.75 -7.56638 194.75 -7.58171C194.75 -7.59704 194.75 -7.61236 194.75 -7.62765C194.75 -7.64295 194.75 -7.65823 194.75 -7.67349C194.75 -7.68876 194.75 -7.704 194.75 -7.71923C194.75 -7.73446 194.75 -7.74968 194.75 -7.76487C194.75 -7.78007 194.75 -7.79524 194.75 -7.81041C194.75 -7.82557 194.75 -7.84071 194.75 -7.85584C194.75 -7.87096 194.75 -7.88607 194.75 -7.90117C194.75 -7.91626 194.75 -7.93133 194.75 -7.94639C194.75 -7.96145 194.75 -7.97648 194.75 -7.99151C194.75 -8.00653 194.75 -8.02153 194.75 -8.03652C194.75 -8.05151 194.75 -8.06647 194.75 -8.08143C194.75 -8.09638 194.75 -8.11131 194.75 -8.12623C194.75 -8.14114 194.75 -8.15604 194.75 -8.17092C194.75 -8.1858 194.75 -8.20066 194.75 -8.2155C194.75 -8.23035 194.75 -8.24517 194.75 -8.25998C194.75 -8.27479 194.75 -8.28958 194.75 -8.30435C194.75 -8.31912 194.75 -8.33387 194.75 -8.3486C194.75 -8.36334 194.75 -8.37805 194.75 -8.39275C194.75 -8.40745 194.75 -8.42213 194.75 -8.43679C194.75 -8.45145 194.75 -8.46609 194.75 -8.48071C194.75 -8.49534 194.75 -8.50994 194.75 -8.52453C194.75 -8.53911 194.75 -8.55368 194.75 -8.56823C194.75 -8.58278 194.75 -8.59731 194.75 -8.61182C194.75 -8.62633 194.75 -8.64082 194.75 -8.65529C194.75 -8.66976 194.75 -8.68422 194.75 -8.69865C194.75 -8.71308 194.75 -8.7275 194.75 -8.7419C194.75 -8.75629 194.75 -8.77067 194.75 -8.78503C194.75 -8.79938 194.75 -8.81372 194.75 -8.82804C194.75 -8.84236 194.75 -8.85666 194.75 -8.87094C194.75 -8.88522 194.75 -8.89948 194.75 -8.91372C194.75 -8.92796 194.75 -8.94218 194.75 -8.95638C194.75 -8.97058 194.75 -8.98476 194.75 -8.99892C194.75 -9.01308 194.75 -9.02722 194.75 -9.04135C194.75 -9.05547 194.75 -9.06957 194.75 -9.08365C194.75 -9.09773 194.75 -9.1118 194.75 -9.12584C194.75 -9.13988 194.75 -9.1539 194.75 -9.1679C194.75 -9.1819 194.75 -9.19588 194.75 -9.20984C194.75 -9.22381 194.75 -9.23775 194.75 -9.25167C194.75 -9.26559 194.75 -9.27949 194.75 -9.29337C194.75 -9.30724 194.75 -9.3211 194.75 -9.33494C194.75 -9.34878 194.75 -9.3626 194.75 -9.37639C194.75 -9.39019 194.75 -9.40397 194.75 -9.41772C194.75 -9.43148 194.75 -9.44521 194.75 -9.45893C194.75 -9.47264 194.75 -9.48633 194.75 -9.50001H193.25C193.25 -9.48633 193.25 -9.47264 193.25 -9.45893C193.25 -9.44521 193.25 -9.43148 193.25 -9.41772C193.25 -9.40397 193.25 -9.39019 193.25 -9.37639C193.25 -9.3626 193.25 -9.34878 193.25 -9.33494C193.25 -9.3211 193.25 -9.30724 193.25 -9.29337C193.25 -9.27949 193.25 -9.26559 193.25 -9.25167C193.25 -9.23775 193.25 -9.22381 193.25 -9.20984C193.25 -9.19588 193.25 -9.1819 193.25 -9.1679C193.25 -9.1539 193.25 -9.13988 193.25 -9.12584C193.25 -9.1118 193.25 -9.09773 193.25 -9.08365C193.25 -9.06957 193.25 -9.05547 193.25 -9.04135C193.25 -9.02722 193.25 -9.01308 193.25 -8.99892C193.25 -8.98476 193.25 -8.97058 193.25 -8.95638C193.25 -8.94218 193.25 -8.92796 193.25 -8.91372C193.25 -8.89948 193.25 -8.88522 193.25 -8.87094C193.25 -8.85666 193.25 -8.84236 193.25 -8.82804C193.25 -8.81372 193.25 -8.79938 193.25 -8.78503C193.25 -8.77067 193.25 -8.75629 193.25 -8.7419C193.25 -8.7275 193.25 -8.71308 193.25 -8.69865C193.25 -8.68422 193.25 -8.66976 193.25 -8.65529C193.25 -8.64082 193.25 -8.62633 193.25 -8.61182C193.25 -8.59731 193.25 -8.58278 193.25 -8.56823C193.25 -8.55368 193.25 -8.53911 193.25 -8.52453C193.25 -8.50994 193.25 -8.49534 193.25 -8.48071C193.25 -8.46609 193.25 -8.45145 193.25 -8.43679C193.25 -8.42213 193.25 -8.40745 193.25 -8.39275C193.25 -8.37805 193.25 -8.36334 193.25 -8.3486C193.25 -8.33387 193.25 -8.31912 193.25 -8.30435C193.25 -8.28958 193.25 -8.27479 193.25 -8.25998C193.25 -8.24517 193.25 -8.23035 193.25 -8.2155C193.25 -8.20066 193.25 -8.1858 193.25 -8.17092C193.25 -8.15604 193.25 -8.14114 193.25 -8.12623C193.25 -8.11131 193.25 -8.09638 193.25 -8.08143C193.25 -8.06647 193.25 -8.05151 193.25 -8.03652C193.25 -8.02153 193.25 -8.00653 193.25 -7.99151C193.25 -7.97648 193.25 -7.96145 193.25 -7.94639C193.25 -7.93133 193.25 -7.91626 193.25 -7.90117C193.25 -7.88607 193.25 -7.87096 193.25 -7.85584C193.25 -7.84071 193.25 -7.82557 193.25 -7.81041C193.25 -7.79524 193.25 -7.78007 193.25 -7.76487C193.25 -7.74968 193.25 -7.73446 193.25 -7.71923C193.25 -7.704 193.25 -7.68876 193.25 -7.67349C193.25 -7.65823 193.25 -7.64295 193.25 -7.62765C193.25 -7.61236 193.25 -7.59704 193.25 -7.58171C193.25 -7.56638 193.25 -7.55103 193.25 -7.53567C193.25 -7.52031 193.25 -7.50493 193.25 -7.48953C193.25 -7.47413 193.25 -7.45872 193.25 -7.44329C193.25 -7.42786 193.25 -7.41241 193.25 -7.39695C193.25 -7.38148 193.25 -7.36601 193.25 -7.35051C193.25 -7.33501 193.25 -7.3195 193.25 -7.30398C193.25 -7.28845 193.25 -7.2729 193.25 -7.25734C193.25 -7.24178 193.25 -7.22621 193.25 -7.21062C193.25 -7.19502 193.25 -7.17942 193.25 -7.16379C193.25 -7.14817 193.25 -7.13253 193.25 -7.11687C193.25 -7.10122 193.25 -7.08555 193.25 -7.06986C193.25 -7.05417 193.25 -7.03847 193.25 -7.02275C193.25 -7.00703 193.25 -6.9913 193.25 -6.97555C193.25 -6.9598 193.25 -6.94404 193.25 -6.92826C193.25 -6.91248 193.25 -6.89668 193.25 -6.88087C193.25 -6.86506 193.25 -6.84924 193.25 -6.8334C193.25 -6.81756 193.25 -6.8017 193.25 -6.78583C193.25 -6.76996 193.25 -6.75407 193.25 -6.73817C193.25 -6.72227 193.25 -6.70635 193.25 -6.69042C193.25 -6.67449 193.25 -6.65854 193.25 -6.64258C193.25 -6.62662 193.25 -6.61065 193.25 -6.59466C193.25 -6.57867 193.25 -6.56266 193.25 -6.54664C193.25 -6.53062 193.25 -6.51459 193.25 -6.49854C193.25 -6.48249 193.25 -6.46643 193.25 -6.45035C193.25 -6.43427 193.25 -6.41818 193.25 -6.40208C193.25 -6.38597 193.25 -6.36985 193.25 -6.35372C193.25 -6.33758 193.25 -6.32143 193.25 -6.30527C193.25 -6.28911 193.25 -6.27293 193.25 -6.25674C193.25 -6.24055 193.25 -6.22434 193.25 -6.20812C193.25 -6.1919 193.25 -6.17567 193.25 -6.15943C193.25 -6.14318 193.25 -6.12692 193.25 -6.11064C193.25 -6.09437 193.25 -6.07808 193.25 -6.06178C193.25 -6.04548 193.25 -6.02916 193.25 -6.01284C193.25 -5.99651 193.25 -5.98016 193.25 -5.96381C193.25 -5.94745 193.25 -5.93108 193.25 -5.9147C193.25 -5.89832 193.25 -5.88192 193.25 -5.86551C193.25 -5.84911 193.25 -5.83268 193.25 -5.81625C193.25 -5.79981 193.25 -5.78336 193.25 -5.7669C193.25 -5.75044 193.25 -5.73397 193.25 -5.71748C193.25 -5.70099 193.25 -5.68449 193.25 -5.66798C193.25 -5.65147 193.25 -5.63494 193.25 -5.6184C193.25 -5.60186 193.25 -5.58531 193.25 -5.56875C193.25 -5.55218 193.25 -5.53561 193.25 -5.51902C193.25 -5.50243 193.25 -5.48582 193.25 -5.46921C193.25 -5.4526 193.25 -5.43597 193.25 -5.41933C193.25 -5.40269 193.25 -5.38604 193.25 -5.36937C193.25 -5.35271 193.25 -5.33603 193.25 -5.31935C193.25 -5.30266 193.25 -5.28596 193.25 -5.26925C193.25 -5.25253 193.25 -5.23581 193.25 -5.21907C193.25 -5.20233 193.25 -5.18559 193.25 -5.16883C193.25 -5.15207 193.25 -5.13529 193.25 -5.11851C193.25 -5.10172 193.25 -5.08493 193.25 -5.06812C193.25 -5.05131 193.25 -5.03449 193.25 -5.01766C193.25 -5.00083 193.25 -4.98399 193.25 -4.96714C193.25 -4.95028 193.25 -4.93342 193.25 -4.91654C193.25 -4.89966 193.25 -4.88278 193.25 -4.86588C193.25 -4.84898 193.25 -4.83207 193.25 -4.81514C193.25 -4.79822 193.25 -4.78129 193.25 -4.76434C193.25 -4.7474 193.25 -4.73045 193.25 -4.71348C193.25 -4.69651 193.25 -4.67954 193.25 -4.66255C193.25 -4.64556 193.25 -4.62856 193.25 -4.61155C193.25 -4.59454 193.25 -4.57752 193.25 -4.56049C193.25 -4.54346 193.25 -4.52641 193.25 -4.50936C193.25 -4.49231 193.25 -4.47524 193.25 -4.45817C193.25 -4.4411 193.25 -4.42401 193.25 -4.40692C193.25 -4.38982 193.25 -4.37272 193.25 -4.3556C193.25 -4.33849 193.25 -4.32136 193.25 -4.30422C193.25 -4.28709 193.25 -4.26994 193.25 -4.25278C193.25 -4.23563 193.25 -4.21846 193.25 -4.20128C193.25 -4.18411 193.25 -4.16692 193.25 -4.14972C193.25 -4.13253 193.25 -4.11532 193.25 -4.0981C193.25 -4.08089 193.25 -4.06366 193.25 -4.04642C193.25 -4.02919 193.25 -4.01194 193.25 -3.99469C193.25 -3.97743 193.25 -3.96017 193.25 -3.94289C193.25 -3.92562 193.25 -3.90833 193.25 -3.89104C193.25 -3.87375 193.25 -3.85644 193.25 -3.83913C193.25 -3.82182 193.25 -3.8045 193.25 -3.78716C193.25 -3.76983 193.25 -3.75249 193.25 -3.73514C193.25 -3.71779 193.25 -3.70043 193.25 -3.68307C193.25 -3.6657 193.25 -3.64832 193.25 -3.63094C193.25 -3.61355 193.25 -3.59616 193.25 -3.57875C193.25 -3.56135 193.25 -3.54394 193.25 -3.52651C193.25 -3.50909 193.25 -3.49166 193.25 -3.47422C193.25 -3.45679 193.25 -3.43934 193.25 -3.42188C193.25 -3.40443 193.25 -3.38696 193.25 -3.36949C193.25 -3.35201 193.25 -3.33453 193.25 -3.31704C193.25 -3.29955 193.25 -3.28205 193.25 -3.26455C193.25 -3.24704 193.25 -3.22953 193.25 -3.212C193.25 -3.19448 193.25 -3.17695 193.25 -3.15941C193.25 -3.14187 193.25 -3.12432 193.25 -3.10677C193.25 -3.08921 193.25 -3.07165 193.25 -3.05408C193.25 -3.0365 193.25 -3.01893 193.25 -3.00134C193.25 -2.98375 193.25 -2.96616 193.25 -2.94855C193.25 -2.93095 193.25 -2.91334 193.25 -2.89572C193.25 -2.8781 193.25 -2.86048 193.25 -2.84285C193.25 -2.82521 193.25 -2.80757 193.25 -2.78992C193.25 -2.77228 193.25 -2.75462 193.25 -2.73696C193.25 -2.71929 193.25 -2.70162 193.25 -2.68395C193.25 -2.66627 193.25 -2.64858 193.25 -2.63089C193.25 -2.6132 193.25 -2.5955 193.25 -2.5778C193.25 -2.56009 193.25 -2.54238 193.25 -2.52466C193.25 -2.50694 193.25 -2.48921 193.25 -2.47148C193.25 -2.45374 193.25 -2.436 193.25 -2.41826C193.25 -2.40051 193.25 -2.38275 193.25 -2.36499C193.25 -2.34723 193.25 -2.32947 193.25 -2.31169C193.25 -2.29392 193.25 -2.27614 193.25 -2.25835C193.25 -2.24056 193.25 -2.22277 193.25 -2.20497C193.25 -2.18717 193.25 -2.16937 193.25 -2.15155C193.25 -2.13374 193.25 -2.11592 193.25 -2.0981C193.25 -2.08027 193.25 -2.06244 193.25 -2.04461C193.25 -2.02677 193.25 -2.00893 193.25 -1.99108C193.25 -1.97323 193.25 -1.95537 193.25 -1.93751C193.25 -1.91965 193.25 -1.90179 193.25 -1.88391C193.25 -1.86604 193.25 -1.84816 193.25 -1.83028C193.25 -1.81239 193.25 -1.79451 193.25 -1.77661C193.25 -1.75871 193.25 -1.74081 193.25 -1.72291C193.25 -1.705 193.25 -1.68709 193.25 -1.66917C193.25 -1.65126 193.25 -1.63333 193.25 -1.61541C193.25 -1.59748 193.25 -1.57955 193.25 -1.56161C193.25 -1.54367 193.25 -1.52573 193.25 -1.50778C193.25 -1.48983 193.25 -1.47187 193.25 -1.45392C193.25 -1.43596 193.25 -1.41799 193.25 -1.40003C193.25 -1.38206 193.25 -1.36408 193.25 -1.34611C193.25 -1.32813 193.25 -1.31014 193.25 -1.29216C193.25 -1.27417 193.25 -1.25618 193.25 -1.23818C193.25 -1.22018 193.25 -1.20218 193.25 -1.18417C193.25 -1.16617 193.25 -1.14816 193.25 -1.13014C193.25 -1.11213 193.25 -1.09411 193.25 -1.07608C193.25 -1.05806 193.25 -1.04003 193.25 -1.022C193.25 -1.00397 193.25 -0.985931 193.25 -0.96789C193.25 -0.949849 193.25 -0.931804 193.25 -0.913755C193.25 -0.895706 193.25 -0.877653 193.25 -0.859597C193.25 -0.84154 193.25 -0.823479 193.25 -0.805414C193.25 -0.78735 193.25 -0.769281 193.25 -0.751209C193.25 -0.733137 193.25 -0.715061 193.25 -0.696981C193.25 -0.678902 193.25 -0.660818 193.25 -0.642732C193.25 -0.624645 193.25 -0.606555 193.25 -0.588461C193.25 -0.570367 193.25 -0.55227 193.25 -0.534169C193.25 -0.516069 193.25 -0.497965 193.25 -0.479857C193.25 -0.46175 193.25 -0.44364 193.25 -0.425526C193.25 -0.407413 193.25 -0.389296 193.25 -0.371176C193.25 -0.353056 193.25 -0.334933 193.25 -0.316807C193.25 -0.298682 193.25 -0.280553 193.25 -0.262421C193.25 -0.244289 193.25 -0.226155 193.25 -0.208018C193.25 -0.18988 193.25 -0.17174 193.25 -0.153597C193.25 -0.135455 193.25 -0.117309 193.25 -0.0991611C193.25 -0.0810131 193.25 -0.0628625 193.25 -0.0447094C193.25 -0.0265563 193.25 -0.00840074 193.25 0.00975721C193.25 0.0279152 193.25 0.0460755 193.25 0.0642381C193.25 0.0824007 193.25 0.100566 193.25 0.118733C193.25 0.1369 193.25 0.155069 193.25 0.173241C193.25 0.191412 193.25 0.209585 193.25 0.227761C193.25 0.245936 193.25 0.264114 193.25 0.282293C193.25 0.300473 193.25 0.318654 193.25 0.336837C193.25 0.35502 193.25 0.373205 193.25 0.391391C193.25 0.409578 193.25 0.427766 193.25 0.445956C193.25 0.464146 193.25 0.482338 193.25 0.500531C193.25 0.518724 193.25 0.536918 193.25 0.555114C193.25 0.57331 193.25 0.591507 193.25 0.609706C193.25 0.627905 193.25 0.646105 193.25 0.664306C193.25 0.682507 193.25 0.70071 193.25 0.718913C193.25 0.737117 193.25 0.755321 193.25 0.773527C193.25 0.791733 193.25 0.80994 193.25 0.828147C193.25 0.846355 193.25 0.864564 193.25 0.882773C193.25 0.900983 193.25 0.919193 193.25 0.937404C193.25 0.955615 193.25 0.973827 193.25 0.992039C193.25 1.01025 193.25 1.02846 193.25 1.04668C193.25 1.06489 193.25 1.08311 193.25 1.10132C193.25 1.11953 193.25 1.13775 193.25 1.15597C193.25 1.17418 193.25 1.1924 193.25 1.21061C193.25 1.22883 193.25 1.24704 193.25 1.26526C193.25 1.28348 193.25 1.30169 193.25 1.31991C193.25 1.33813 193.25 1.35634 193.25 1.37456C193.25 1.39278 193.25 1.41099 193.25 1.42921C193.25 1.44743 193.25 1.46564 193.25 1.48386C193.25 1.50207 193.25 1.52029 193.25 1.53851C193.25 1.55672 193.25 1.57494 193.25 1.59315C193.25 1.61137 193.25 1.62958 193.25 1.64779C193.25 1.66601 193.25 1.68422 193.25 1.70243C193.25 1.72065 193.25 1.73886 193.25 1.75707C193.25 1.77528 193.25 1.79349 193.25 1.8117C193.25 1.82991 193.25 1.84812 193.25 1.86633C193.25 1.88454 193.25 1.90274 193.25 1.92095C193.25 1.93916 193.25 1.95736 193.25 1.97557C193.25 1.99377 193.25 2.01197 193.25 2.03018C193.25 2.04838 193.25 2.06658 193.25 2.08478C193.25 2.10298 193.25 2.12117 193.25 2.13937C193.25 2.15757 193.25 2.17576 193.25 2.19396C193.25 2.21215 193.25 2.23034 193.25 2.24853C193.25 2.26672 193.25 2.28491 193.25 2.3031C193.25 2.32129 193.25 2.33947 193.25 2.35766C193.25 2.37584 193.25 2.39402 193.25 2.4122C193.25 2.43038 193.25 2.44856 193.25 2.46674C193.25 2.48491 193.25 2.50309 193.25 2.52126C193.25 2.53943 193.25 2.5576 193.25 2.57577C193.25 2.59394 193.25 2.61211 193.25 2.63027C193.25 2.64843 193.25 2.66659 193.25 2.68475C193.25 2.70291 193.25 2.72107 193.25 2.73922C193.25 2.75738 193.25 2.77553 193.25 2.79368C193.25 2.81183 193.25 2.82997 193.25 2.84812C193.25 2.86626 193.25 2.8844 193.25 2.90254C193.25 2.92068 193.25 2.93882 193.25 2.95695C193.25 2.97508 193.25 2.99321 193.25 3.01134C193.25 3.02947 193.25 3.04759 193.25 3.06571C193.25 3.08383 193.25 3.10195 193.25 3.12007C193.25 3.13818 193.25 3.15629 193.25 3.1744C193.25 3.19251 193.25 3.21062 193.25 3.22872C193.25 3.24682 193.25 3.26492 193.25 3.28302C193.25 3.30111 193.25 3.3192 193.25 3.33729C193.25 3.35538 193.25 3.37347 193.25 3.39155C193.25 3.40963 193.25 3.42771 193.25 3.44578C193.25 3.46385 193.25 3.48192 193.25 3.49999C193.25 3.51806 193.25 3.53612 193.25 3.55418C193.25 3.57224 193.25 3.59029 193.25 3.60834C193.25 3.62639 193.25 3.64444 193.25 3.66248C193.25 3.68052 193.25 3.69856 193.25 3.7166C193.25 3.73463 193.25 3.75266 193.25 3.77069C193.25 3.78871 193.25 3.80673 193.25 3.82475C193.25 3.84277 193.25 3.86078 193.25 3.87879C193.25 3.8968 193.25 3.9148 193.25 3.9328C193.25 3.9508 193.25 3.96879 193.25 3.98678C193.25 4.00477 193.25 4.02276 193.25 4.04074C193.25 4.05872 193.25 4.0767 193.25 4.09467C193.25 4.11264 193.25 4.1306 193.25 4.14856C193.25 4.16653 193.25 4.18448 193.25 4.20243C193.25 4.22038 193.25 4.23833 193.25 4.25627C193.25 4.27421 193.25 4.29215 193.25 4.31008C193.25 4.32801 193.25 4.34593 193.25 4.36385C193.25 4.38177 193.25 4.39968 193.25 4.41759C193.25 4.4355 193.25 4.4534 193.25 4.4713C193.25 4.4892 193.25 4.50709 193.25 4.52498C193.25 4.54287 193.25 4.56075 193.25 4.57862C193.25 4.5965 193.25 4.61437 193.25 4.63223C193.25 4.65009 193.25 4.66795 193.25 4.6858C193.25 4.70365 193.25 4.7215 193.25 4.73934C193.25 4.75718 193.25 4.77501 193.25 4.79284C193.25 4.81067 193.25 4.82849 193.25 4.8463C193.25 4.86412 193.25 4.88193 193.25 4.89973C193.25 4.91753 193.25 4.93533 193.25 4.95312C193.25 4.97091 193.25 4.98869 193.25 5.00647C193.25 5.02425 193.25 5.04202 193.25 5.05978C193.25 5.07754 193.25 5.0953 193.25 5.11305C193.25 5.1308 193.25 5.14854 193.25 5.16628C193.25 5.18402 193.25 5.20175 193.25 5.21947C193.25 5.23719 193.25 5.25491 193.25 5.27262C193.25 5.29033 193.25 5.30803 193.25 5.32573C193.25 5.34342 193.25 5.36111 193.25 5.37879C193.25 5.39647 193.25 5.41414 193.25 5.43181C193.25 5.44948 193.25 5.46714 193.25 5.48479C193.25 5.50244 193.25 5.52008 193.25 5.53772C193.25 5.55536 193.25 5.57298 193.25 5.59061C193.25 5.60823 193.25 5.62584 193.25 5.64345C193.25 5.66105 193.25 5.67865 193.25 5.69624C193.25 5.71383 193.25 5.73142 193.25 5.74899C193.25 5.76657 193.25 5.78413 193.25 5.80169C193.25 5.81925 193.25 5.8368 193.25 5.85435C193.25 5.87189 193.25 5.88943 193.25 5.90695C193.25 5.92448 193.25 5.942 193.25 5.95951C193.25 5.97702 193.25 5.99452 193.25 6.01202C193.25 6.02951 193.25 6.04699 193.25 6.06447C193.25 6.08195 193.25 6.09942 193.25 6.11688C193.25 6.13434 193.25 6.15179 193.25 6.16923C193.25 6.18667 193.25 6.20411 193.25 6.22153C193.25 6.23896 193.25 6.25638 193.25 6.27378C193.25 6.29119 193.25 6.30859 193.25 6.32598C193.25 6.34337 193.25 6.36075 193.25 6.37812C193.25 6.3955 193.25 6.41286 193.25 6.43021C193.25 6.44757 193.25 6.46491 193.25 6.48225C193.25 6.49958 193.25 6.51691 193.25 6.53422C193.25 6.55154 193.25 6.56885 193.25 6.58615C193.25 6.60344 193.25 6.62073 193.25 6.63801C193.25 6.65529 193.25 6.67256 193.25 6.68982C193.25 6.70708 193.25 6.72433 193.25 6.74157C193.25 6.75881 193.25 6.77604 193.25 6.79326C193.25 6.81049 193.25 6.8277 193.25 6.8449C193.25 6.8621 193.25 6.87929 193.25 6.89647C193.25 6.91365 193.25 6.93083 193.25 6.94799C193.25 6.96515 193.25 6.9823 193.25 6.99944C193.25 7.01658 193.25 7.03371 193.25 7.05083C193.25 7.06795 193.25 7.08506 193.25 7.10216C193.25 7.11926 193.25 7.13635 193.25 7.15343C193.25 7.17051 193.25 7.18758 193.25 7.20463C193.25 7.22169 193.25 7.23874 193.25 7.25578C193.25 7.27281 193.25 7.28984 193.25 7.30685C193.25 7.32387 193.25 7.34087 193.25 7.35787C193.25 7.37486 193.25 7.39184 193.25 7.40881C193.25 7.42578 193.25 7.44274 193.25 7.45969C193.25 7.47664 193.25 7.49358 193.25 7.51051C193.25 7.52744 193.25 7.54435 193.25 7.56126C193.25 7.57816 193.25 7.59505 193.25 7.61194C193.25 7.62882 193.25 7.64569 193.25 7.66255C193.25 7.67941 193.25 7.69626 193.25 7.71309C193.25 7.72993 193.25 7.74675 193.25 7.76357C193.25 7.78038 193.25 7.79718 193.25 7.81397C193.25 7.83076 193.25 7.84754 193.25 7.8643C193.25 7.88107 193.25 7.89782 193.25 7.91456C193.25 7.93131 193.25 7.94804 193.25 7.96475C193.25 7.98147 193.25 7.99818 193.25 8.01487C193.25 8.03157 193.25 8.04825 193.25 8.06492C193.25 8.08159 193.25 8.09824 193.25 8.11489C193.25 8.13153 193.25 8.14817 193.25 8.16479C193.25 8.18141 193.25 8.19802 193.25 8.21461C193.25 8.23121 193.25 8.24779 193.25 8.26436C193.25 8.28093 193.25 8.29749 193.25 8.31403C193.25 8.33058 193.25 8.34711 193.25 8.36363C193.25 8.38015 193.25 8.39665 193.25 8.41315C193.25 8.42964 193.25 8.44612 193.25 8.46259C193.25 8.47905 193.25 8.49551 193.25 8.51195C193.25 8.52839 193.25 8.54482 193.25 8.56123C193.25 8.57765 193.25 8.59405 193.25 8.61044C193.25 8.62683 193.25 8.6432 193.25 8.65957C193.25 8.67593 193.25 8.69228 193.25 8.70861C193.25 8.72495 193.25 8.74127 193.25 8.75757C193.25 8.77388 193.25 8.79018 193.25 8.80646C193.25 8.82274 193.25 8.839 193.25 8.85526C193.25 8.87151 193.25 8.88775 193.25 8.90397C193.25 8.9202 193.25 8.93641 193.25 8.95261C193.25 8.96881 193.25 8.98499 193.25 9.00116C193.25 9.01733 193.25 9.03348 193.25 9.04963C193.25 9.06577 193.25 9.08189 193.25 9.09801C193.25 9.11412 193.25 9.13022 193.25 9.1463C193.25 9.16239 193.25 9.17845 193.25 9.19451C193.25 9.21057 193.25 9.22661 193.25 9.24263C193.25 9.25866 193.25 9.27467 193.25 9.29067C193.25 9.30666 193.25 9.32265 193.25 9.33861C193.25 9.35458 193.25 9.37053 193.25 9.38647C193.25 9.40241 193.25 9.41833 193.25 9.43424C193.25 9.45015 193.25 9.46604 193.25 9.48192C193.25 9.4978 193.25 9.51366 193.25 9.52951C193.25 9.54536 193.25 9.56119 193.25 9.57701C193.25 9.59282 193.25 9.60863 193.25 9.62441C193.25 9.6402 193.25 9.65597 193.25 9.67173C193.25 9.68748 193.25 9.70322 193.25 9.71895C193.25 9.73468 193.25 9.75038 193.25 9.76608C193.25 9.78177 193.25 9.79745 193.25 9.81311C193.25 9.82878 193.25 9.84442 193.25 9.86005C193.25 9.87569 193.25 9.8913 193.25 9.9069C193.25 9.9225 193.25 9.93808 193.25 9.95365C193.25 9.96922 193.25 9.98477 193.25 10.0003C193.25 10.0158 193.25 10.0314 193.25 10.0469C193.25 10.0624 193.25 10.0779 193.25 10.0933C193.25 10.1088 193.25 10.1242 193.25 10.1397C193.25 10.1551 193.25 10.1705 193.25 10.1859C193.25 10.2014 193.25 10.2167 193.25 10.2321C193.25 10.2475 193.25 10.2628 193.25 10.2782C193.25 10.2935 193.25 10.3088 193.25 10.3241C193.25 10.3394 193.25 10.3547 193.25 10.37C193.25 10.3853 193.25 10.4005 193.25 10.4158C193.25 10.431 193.25 10.4462 193.25 10.4614C193.25 10.4766 193.25 10.4918 193.25 10.507C193.25 10.5222 193.25 10.5373 193.25 10.5524C193.25 10.5676 193.25 10.5827 193.25 10.5978C193.25 10.6129 193.25 10.628 193.25 10.643C193.25 10.6581 193.25 10.6732 193.25 10.6882C193.25 10.7032 193.25 10.7182 193.25 10.7332C193.25 10.7482 193.25 10.7632 193.25 10.7782C193.25 10.7931 193.25 10.8081 193.25 10.823C193.25 10.8379 193.25 10.8528 193.25 10.8677C193.25 10.8826 193.25 10.8975 193.25 10.9123C193.25 10.9272 193.25 10.942 193.25 10.9568C193.25 10.9716 193.25 10.9864 193.25 11.0012C193.25 11.016 193.25 11.0307 193.25 11.0455C193.25 11.0602 193.25 11.0749 193.25 11.0897C193.25 11.1044 193.25 11.119 193.25 11.1337C193.25 11.1484 193.25 11.163 193.25 11.1777C193.25 11.1923 193.25 11.2069 193.25 11.2215C193.25 11.2361 193.25 11.2507 193.25 11.2652C193.25 11.2798 193.25 11.2943 193.25 11.3088C193.25 11.3234 193.25 11.3379 193.25 11.3523C193.25 11.3668 193.25 11.3813 193.25 11.3957C193.25 11.4102 193.25 11.4246 193.25 11.439C193.25 11.4534 193.25 11.4678 193.25 11.4822C193.25 11.4965 193.25 11.5109 193.25 11.5252C193.25 11.5395 193.25 11.5538 193.25 11.5681C193.25 11.5824 193.25 11.5967 193.25 11.6109C193.25 11.6252 193.25 11.6394 193.25 11.6536C193.25 11.6678 193.25 11.682 193.25 11.6962C193.25 11.7104 193.25 11.7245 193.25 11.7386C193.25 11.7528 193.25 11.7669 193.25 11.781C193.25 11.7951 193.25 11.8091 193.25 11.8232C193.25 11.8372 193.25 11.8513 193.25 11.8653C193.25 11.8793 193.25 11.8933 193.25 11.9073C193.25 11.9212 193.25 11.9352 193.25 11.9491C193.25 11.963 193.25 11.9769 193.25 11.9908C193.25 12.0047 193.25 12.0186 193.25 12.0324C193.25 12.0463 193.25 12.0601 193.25 12.0739C193.25 12.0877 193.25 12.1015 193.25 12.1153C193.25 12.129 193.25 12.1428 193.25 12.1565C193.25 12.1702 193.25 12.1839 193.25 12.1976C193.25 12.2113 193.25 12.225 193.25 12.2386C193.25 12.2522 193.25 12.2659 193.25 12.2795C193.25 12.2931 193.25 12.3066 193.25 12.3202C193.25 12.3337 193.25 12.3473 193.25 12.3608C193.25 12.3743 193.25 12.3878 193.25 12.4013C193.25 12.4147 193.25 12.4282 193.25 12.4416C193.25 12.455 193.25 12.4684 193.25 12.4818C193.25 12.4952 193.25 12.5086 193.25 12.5219C193.25 12.5352 193.25 12.5486 193.25 12.5619C193.25 12.5752 193.25 12.5884 193.25 12.6017C193.25 12.6149 193.25 12.6282 193.25 12.6414C193.25 12.6546 193.25 12.6678 193.25 12.6809C193.25 12.6941 193.25 12.7072 193.25 12.7204C193.25 12.7335 193.25 12.7466 193.25 12.7597C193.25 12.7727 193.25 12.7858 193.25 12.7988C193.25 12.8118 193.25 12.8249 193.25 12.8378C193.25 12.8508 193.25 12.8638 193.25 12.8767C193.25 12.8897 193.25 12.9026 193.25 12.9155C193.25 12.9284 193.25 12.9413 193.25 12.9541C193.25 12.967 193.25 12.9798 193.25 12.9926C193.25 13.0054 193.25 13.0182 193.25 13.0309C193.25 13.0437 193.25 13.0564 193.25 13.0691C193.25 13.0818 193.25 13.0945 193.25 13.1072C193.25 13.1199 193.25 13.1325 193.25 13.1451C193.25 13.1578 193.25 13.1704 193.25 13.1829C193.25 13.1955 193.25 13.208 193.25 13.2206C193.25 13.2331 193.25 13.2456 193.25 13.2581C193.25 13.2706 193.25 13.283 193.25 13.2954C193.25 13.3079 193.25 13.3203 193.25 13.3327C193.25 13.3451 193.25 13.3574 193.25 13.3698C193.25 13.3821 193.25 13.3944 193.25 13.4067C193.25 13.419 193.25 13.4312 193.25 13.4435C193.25 13.4557 193.25 13.4679 193.25 13.4801C193.25 13.4923 193.25 13.5045 193.25 13.5166C193.25 13.5288 193.25 13.5409 193.25 13.553C193.25 13.5651 193.25 13.5772 193.25 13.5892C193.25 13.6013 193.25 13.6133 193.25 13.6253C193.25 13.6373 193.25 13.6493 193.25 13.6612C193.25 13.6732 193.25 13.6851 193.25 13.697C193.25 13.7089 193.25 13.7208 193.25 13.7326C193.25 13.7445 193.25 13.7563 193.25 13.7681C193.25 13.7799 193.25 13.7917 193.25 13.8034C193.25 13.8152 193.25 13.8269 193.25 13.8386C193.25 13.8503 193.25 13.862 193.25 13.8736C193.25 13.8853 193.25 13.8969 193.25 13.9085C193.25 13.9201 193.25 13.9317 193.25 13.9432C193.25 13.9547 193.25 13.9663 193.25 13.9778C193.25 13.9893 193.25 14.0007 193.25 14.0122C193.25 14.0236 193.25 14.0351 193.25 14.0464C193.25 14.0578 193.25 14.0692 193.25 14.0806C193.25 14.0919 193.25 14.1032 193.25 14.1145C193.25 14.1258 193.25 14.1371 193.25 14.1483C193.25 14.1595 193.25 14.1708 193.25 14.1819C193.25 14.1931 193.25 14.2043 193.25 14.2154C193.25 14.2266 193.25 14.2377 193.25 14.2488C193.25 14.2598 193.25 14.2709 193.25 14.2819C193.25 14.293 193.25 14.304 193.25 14.3149C193.25 14.3259 193.25 14.3369 193.25 14.3478C193.25 14.3587 193.25 14.3696 193.25 14.3805C193.25 14.3914 193.25 14.4022 193.25 14.413C193.25 14.4238 193.25 14.4346 193.25 14.4454C193.25 14.4562 193.25 14.4669 193.25 14.4776C193.25 14.4883 193.25 14.499 193.25 14.5097C193.25 14.5203 193.25 14.5309 193.25 14.5415C193.25 14.5521 193.25 14.5627 193.25 14.5733C193.25 14.5838 193.25 14.5943 193.25 14.6048C193.25 14.6153 193.25 14.6258 193.25 14.6362C193.25 14.6467 193.25 14.6571 193.25 14.6675C193.25 14.6778 193.25 14.6882 193.25 14.6985C193.25 14.7089 193.25 14.7192 193.25 14.7294C193.25 14.7397 193.25 14.7499 193.25 14.7602C193.25 14.7704 193.25 14.7806 193.25 14.7907C193.25 14.8009 193.25 14.811 193.25 14.8211C193.25 14.8312 193.25 14.8413 193.25 14.8514C193.25 14.8614 193.25 14.8714 193.25 14.8814C193.25 14.8914 193.25 14.9014 193.25 14.9113C193.25 14.9213 193.25 14.9312 193.25 14.941C193.25 14.9509 193.25 14.9608 193.25 14.9706C193.25 14.9804 193.25 14.9902 193.25 15H194.75ZM194.75 -9.50001C194.75 -11.1105 195.208 -12.3974 196.093 -13.2822C196.976 -14.1655 198.387 -14.75 200.5 -14.75V-16.25C198.113 -16.25 196.274 -15.5845 195.032 -14.3428C193.792 -13.1026 193.25 -11.3895 193.25 -9.50001H194.75ZM200.5 -14.75C200.511 -14.75 200.522 -14.75 200.533 -14.75C200.544 -14.75 200.555 -14.75 200.566 -14.75C200.578 -14.75 200.589 -14.75 200.6 -14.75C200.611 -14.75 200.623 -14.75 200.634 -14.75C200.646 -14.75 200.657 -14.75 200.669 -14.75C200.68 -14.75 200.692 -14.75 200.703 -14.75C200.715 -14.75 200.727 -14.75 200.739 -14.75C200.75 -14.75 200.762 -14.75 200.774 -14.75C200.786 -14.75 200.798 -14.75 200.81 -14.75C200.822 -14.75 200.834 -14.75 200.846 -14.75C200.859 -14.75 200.871 -14.75 200.883 -14.75C200.895 -14.75 200.908 -14.75 200.92 -14.75C200.932 -14.75 200.945 -14.75 200.957 -14.75C200.97 -14.75 200.982 -14.75 200.995 -14.75C201.008 -14.75 201.02 -14.75 201.033 -14.75C201.046 -14.75 201.059 -14.75 201.071 -14.75C201.084 -14.75 201.097 -14.75 201.11 -14.75C201.123 -14.75 201.136 -14.75 201.149 -14.75C201.162 -14.75 201.175 -14.75 201.189 -14.75C201.202 -14.75 201.215 -14.75 201.228 -14.75C201.242 -14.75 201.255 -14.75 201.269 -14.75C201.282 -14.75 201.295 -14.75 201.309 -14.75C201.323 -14.75 201.336 -14.75 201.35 -14.75C201.364 -14.75 201.377 -14.75 201.391 -14.75C201.405 -14.75 201.419 -14.75 201.432 -14.75C201.446 -14.75 201.46 -14.75 201.474 -14.75C201.488 -14.75 201.502 -14.75 201.516 -14.75C201.531 -14.75 201.545 -14.75 201.559 -14.75C201.573 -14.75 201.587 -14.75 201.602 -14.75C201.616 -14.75 201.631 -14.75 201.645 -14.75C201.659 -14.75 201.674 -14.75 201.688 -14.75C201.703 -14.75 201.718 -14.75 201.732 -14.75C201.747 -14.75 201.762 -14.75 201.776 -14.75C201.791 -14.75 201.806 -14.75 201.821 -14.75C201.836 -14.75 201.851 -14.75 201.866 -14.75C201.881 -14.75 201.896 -14.75 201.911 -14.75C201.926 -14.75 201.941 -14.75 201.956 -14.75C201.972 -14.75 201.987 -14.75 202.002 -14.75C202.017 -14.75 202.033 -14.75 202.048 -14.75C202.064 -14.75 202.079 -14.75 202.095 -14.75C202.11 -14.75 202.126 -14.75 202.141 -14.75C202.157 -14.75 202.173 -14.75 202.189 -14.75C202.204 -14.75 202.22 -14.75 202.236 -14.75C202.252 -14.75 202.268 -14.75 202.284 -14.75C202.3 -14.75 202.316 -14.75 202.332 -14.75C202.348 -14.75 202.364 -14.75 202.38 -14.75C202.396 -14.75 202.412 -14.75 202.429 -14.75C202.445 -14.75 202.461 -14.75 202.478 -14.75C202.494 -14.75 202.51 -14.75 202.527 -14.75C202.543 -14.75 202.56 -14.75 202.576 -14.75C202.593 -14.75 202.61 -14.75 202.626 -14.75C202.643 -14.75 202.66 -14.75 202.676 -14.75C202.693 -14.75 202.71 -14.75 202.727 -14.75C202.744 -14.75 202.761 -14.75 202.778 -14.75C202.795 -14.75 202.812 -14.75 202.829 -14.75C202.846 -14.75 202.863 -14.75 202.88 -14.75C202.897 -14.75 202.915 -14.75 202.932 -14.75C202.949 -14.75 202.967 -14.75 202.984 -14.75C203.001 -14.75 203.019 -14.75 203.036 -14.75C203.054 -14.75 203.071 -14.75 203.089 -14.75C203.106 -14.75 203.124 -14.75 203.142 -14.75C203.159 -14.75 203.177 -14.75 203.195 -14.75C203.213 -14.75 203.231 -14.75 203.248 -14.75C203.266 -14.75 203.284 -14.75 203.302 -14.75C203.32 -14.75 203.338 -14.75 203.356 -14.75C203.374 -14.75 203.392 -14.75 203.411 -14.75C203.429 -14.75 203.447 -14.75 203.465 -14.75C203.483 -14.75 203.502 -14.75 203.52 -14.75C203.538 -14.75 203.557 -14.75 203.575 -14.75C203.594 -14.75 203.612 -14.75 203.631 -14.75C203.649 -14.75 203.668 -14.75 203.687 -14.75C203.705 -14.75 203.724 -14.75 203.743 -14.75C203.761 -14.75 203.78 -14.75 203.799 -14.75C203.818 -14.75 203.837 -14.75 203.856 -14.75C203.874 -14.75 203.893 -14.75 203.912 -14.75C203.931 -14.75 203.95 -14.75 203.97 -14.75C203.989 -14.75 204.008 -14.75 204.027 -14.75C204.046 -14.75 204.065 -14.75 204.085 -14.75C204.104 -14.75 204.123 -14.75 204.143 -14.75C204.162 -14.75 204.182 -14.75 204.201 -14.75C204.22 -14.75 204.24 -14.75 204.259 -14.75C204.279 -14.75 204.299 -14.75 204.318 -14.75C204.338 -14.75 204.358 -14.75 204.377 -14.75C204.397 -14.75 204.417 -14.75 204.437 -14.75C204.457 -14.75 204.476 -14.75 204.496 -14.75C204.516 -14.75 204.536 -14.75 204.556 -14.75C204.576 -14.75 204.596 -14.75 204.616 -14.75C204.636 -14.75 204.656 -14.75 204.677 -14.75C204.697 -14.75 204.717 -14.75 204.737 -14.75C204.758 -14.75 204.778 -14.75 204.798 -14.75C204.819 -14.75 204.839 -14.75 204.859 -14.75C204.88 -14.75 204.9 -14.75 204.921 -14.75C204.941 -14.75 204.962 -14.75 204.982 -14.75C205.003 -14.75 205.024 -14.75 205.044 -14.75C205.065 -14.75 205.086 -14.75 205.107 -14.75C205.127 -14.75 205.148 -14.75 205.169 -14.75C205.19 -14.75 205.211 -14.75 205.232 -14.75C205.253 -14.75 205.274 -14.75 205.295 -14.75C205.316 -14.75 205.337 -14.75 205.358 -14.75C205.379 -14.75 205.4 -14.75 205.421 -14.75C205.442 -14.75 205.464 -14.75 205.485 -14.75C205.506 -14.75 205.527 -14.75 205.549 -14.75C205.57 -14.75 205.591 -14.75 205.613 -14.75C205.634 -14.75 205.656 -14.75 205.677 -14.75C205.699 -14.75 205.72 -14.75 205.742 -14.75C205.764 -14.75 205.785 -14.75 205.807 -14.75C205.829 -14.75 205.85 -14.75 205.872 -14.75C205.894 -14.75 205.915 -14.75 205.937 -14.75C205.959 -14.75 205.981 -14.75 206.003 -14.75C206.025 -14.75 206.047 -14.75 206.069 -14.75C206.091 -14.75 206.113 -14.75 206.135 -14.75C206.157 -14.75 206.179 -14.75 206.201 -14.75C206.223 -14.75 206.245 -14.75 206.268 -14.75C206.29 -14.75 206.312 -14.75 206.334 -14.75C206.357 -14.75 206.379 -14.75 206.401 -14.75C206.424 -14.75 206.446 -14.75 206.469 -14.75C206.491 -14.75 206.513 -14.75 206.536 -14.75C206.558 -14.75 206.581 -14.75 206.604 -14.75C206.626 -14.75 206.649 -14.75 206.671 -14.75C206.694 -14.75 206.717 -14.75 206.74 -14.75C206.762 -14.75 206.785 -14.75 206.808 -14.75C206.831 -14.75 206.854 -14.75 206.876 -14.75C206.899 -14.75 206.922 -14.75 206.945 -14.75C206.968 -14.75 206.991 -14.75 207.014 -14.75C207.037 -14.75 207.06 -14.75 207.083 -14.75C207.106 -14.75 207.13 -14.75 207.153 -14.75C207.176 -14.75 207.199 -14.75 207.222 -14.75C207.246 -14.75 207.269 -14.75 207.292 -14.75C207.315 -14.75 207.339 -14.75 207.362 -14.75C207.386 -14.75 207.409 -14.75 207.432 -14.75C207.456 -14.75 207.479 -14.75 207.503 -14.75C207.526 -14.75 207.55 -14.75 207.574 -14.75C207.597 -14.75 207.621 -14.75 207.644 -14.75C207.668 -14.75 207.692 -14.75 207.716 -14.75C207.739 -14.75 207.763 -14.75 207.787 -14.75C207.811 -14.75 207.834 -14.75 207.858 -14.75C207.882 -14.75 207.906 -14.75 207.93 -14.75C207.954 -14.75 207.978 -14.75 208.002 -14.75C208.026 -14.75 208.05 -14.75 208.074 -14.75C208.098 -14.75 208.122 -14.75 208.146 -14.75C208.17 -14.75 208.194 -14.75 208.219 -14.75C208.243 -14.75 208.267 -14.75 208.291 -14.75C208.316 -14.75 208.34 -14.75 208.364 -14.75C208.389 -14.75 208.413 -14.75 208.437 -14.75C208.462 -14.75 208.486 -14.75 208.511 -14.75C208.535 -14.75 208.559 -14.75 208.584 -14.75C208.608 -14.75 208.633 -14.75 208.658 -14.75C208.682 -14.75 208.707 -14.75 208.731 -14.75C208.756 -14.75 208.781 -14.75 208.805 -14.75C208.83 -14.75 208.855 -14.75 208.88 -14.75C208.904 -14.75 208.929 -14.75 208.954 -14.75C208.979 -14.75 209.004 -14.75 209.028 -14.75C209.053 -14.75 209.078 -14.75 209.103 -14.75C209.128 -14.75 209.153 -14.75 209.178 -14.75C209.203 -14.75 209.228 -14.75 209.253 -14.75C209.278 -14.75 209.303 -14.75 209.328 -14.75C209.354 -14.75 209.379 -14.75 209.404 -14.75C209.429 -14.75 209.454 -14.75 209.479 -14.75C209.505 -14.75 209.53 -14.75 209.555 -14.75C209.581 -14.75 209.606 -14.75 209.631 -14.75C209.657 -14.75 209.682 -14.75 209.707 -14.75C209.733 -14.75 209.758 -14.75 209.784 -14.75C209.809 -14.75 209.835 -14.75 209.86 -14.75C209.886 -14.75 209.911 -14.75 209.937 -14.75C209.962 -14.75 209.988 -14.75 210.014 -14.75C210.039 -14.75 210.065 -14.75 210.091 -14.75C210.116 -14.75 210.142 -14.75 210.168 -14.75C210.193 -14.75 210.219 -14.75 210.245 -14.75C210.271 -14.75 210.297 -14.75 210.322 -14.75C210.348 -14.75 210.374 -14.75 210.4 -14.75C210.426 -14.75 210.452 -14.75 210.478 -14.75C210.504 -14.75 210.53 -14.75 210.556 -14.75C210.582 -14.75 210.608 -14.75 210.634 -14.75C210.66 -14.75 210.686 -14.75 210.712 -14.75C210.738 -14.75 210.764 -14.75 210.79 -14.75C210.817 -14.75 210.843 -14.75 210.869 -14.75C210.895 -14.75 210.921 -14.75 210.948 -14.75C210.974 -14.75 211 -14.75 211.027 -14.75C211.053 -14.75 211.079 -14.75 211.106 -14.75C211.132 -14.75 211.158 -14.75 211.185 -14.75C211.211 -14.75 211.238 -14.75 211.264 -14.75C211.29 -14.75 211.317 -14.75 211.343 -14.75C211.37 -14.75 211.396 -14.75 211.423 -14.75C211.45 -14.75 211.476 -14.75 211.503 -14.75C211.529 -14.75 211.556 -14.75 211.583 -14.75C211.609 -14.75 211.636 -14.75 211.663 -14.75C211.689 -14.75 211.716 -14.75 211.743 -14.75C211.769 -14.75 211.796 -14.75 211.823 -14.75C211.85 -14.75 211.877 -14.75 211.903 -14.75C211.93 -14.75 211.957 -14.75 211.984 -14.75C212.011 -14.75 212.038 -14.75 212.065 -14.75C212.092 -14.75 212.119 -14.75 212.146 -14.75C212.172 -14.75 212.199 -14.75 212.226 -14.75C212.253 -14.75 212.28 -14.75 212.308 -14.75C212.335 -14.75 212.362 -14.75 212.389 -14.75C212.416 -14.75 212.443 -14.75 212.47 -14.75C212.497 -14.75 212.524 -14.75 212.552 -14.75C212.579 -14.75 212.606 -14.75 212.633 -14.75C212.66 -14.75 212.688 -14.75 212.715 -14.75C212.742 -14.75 212.769 -14.75 212.797 -14.75C212.824 -14.75 212.851 -14.75 212.879 -14.75C212.906 -14.75 212.933 -14.75 212.961 -14.75C212.988 -14.75 213.016 -14.75 213.043 -14.75C213.07 -14.75 213.098 -14.75 213.125 -14.75C213.153 -14.75 213.18 -14.75 213.208 -14.75C213.235 -14.75 213.263 -14.75 213.29 -14.75C213.318 -14.75 213.345 -14.75 213.373 -14.75C213.4 -14.75 213.428 -14.75 213.456 -14.75C213.483 -14.75 213.511 -14.75 213.539 -14.75C213.566 -14.75 213.594 -14.75 213.622 -14.75C213.649 -14.75 213.677 -14.75 213.705 -14.75C213.732 -14.75 213.76 -14.75 213.788 -14.75C213.816 -14.75 213.843 -14.75 213.871 -14.75C213.899 -14.75 213.927 -14.75 213.955 -14.75C213.982 -14.75 214.01 -14.75 214.038 -14.75C214.066 -14.75 214.094 -14.75 214.122 -14.75C214.15 -14.75 214.178 -14.75 214.206 -14.75C214.233 -14.75 214.261 -14.75 214.289 -14.75C214.317 -14.75 214.345 -14.75 214.373 -14.75C214.401 -14.75 214.429 -14.75 214.457 -14.75C214.485 -14.75 214.513 -14.75 214.541 -14.75C214.57 -14.75 214.598 -14.75 214.626 -14.75C214.654 -14.75 214.682 -14.75 214.71 -14.75C214.738 -14.75 214.766 -14.75 214.794 -14.75C214.823 -14.75 214.851 -14.75 214.879 -14.75C214.907 -14.75 214.935 -14.75 214.964 -14.75C214.992 -14.75 215.02 -14.75 215.048 -14.75C215.076 -14.75 215.105 -14.75 215.133 -14.75C215.161 -14.75 215.19 -14.75 215.218 -14.75C215.246 -14.75 215.275 -14.75 215.303 -14.75C215.331 -14.75 215.36 -14.75 215.388 -14.75C215.416 -14.75 215.445 -14.75 215.473 -14.75C215.501 -14.75 215.53 -14.75 215.558 -14.75C215.587 -14.75 215.615 -14.75 215.643 -14.75C215.672 -14.75 215.7 -14.75 215.729 -14.75C215.757 -14.75 215.786 -14.75 215.814 -14.75C215.843 -14.75 215.871 -14.75 215.9 -14.75C215.928 -14.75 215.957 -14.75 215.985 -14.75C216.014 -14.75 216.042 -14.75 216.071 -14.75C216.1 -14.75 216.128 -14.75 216.157 -14.75C216.185 -14.75 216.214 -14.75 216.243 -14.75C216.271 -14.75 216.3 -14.75 216.328 -14.75C216.357 -14.75 216.386 -14.75 216.414 -14.75C216.443 -14.75 216.472 -14.75 216.5 -14.75C216.529 -14.75 216.558 -14.75 216.586 -14.75C216.615 -14.75 216.644 -14.75 216.673 -14.75C216.701 -14.75 216.73 -14.75 216.759 -14.75C216.788 -14.75 216.816 -14.75 216.845 -14.75C216.874 -14.75 216.903 -14.75 216.931 -14.75C216.96 -14.75 216.989 -14.75 217.018 -14.75C217.047 -14.75 217.076 -14.75 217.104 -14.75C217.133 -14.75 217.162 -14.75 217.191 -14.75C217.22 -14.75 217.249 -14.75 217.277 -14.75C217.306 -14.75 217.335 -14.75 217.364 -14.75C217.393 -14.75 217.422 -14.75 217.451 -14.75C217.48 -14.75 217.509 -14.75 217.537 -14.75C217.566 -14.75 217.595 -14.75 217.624 -14.75C217.653 -14.75 217.682 -14.75 217.711 -14.75C217.74 -14.75 217.769 -14.75 217.798 -14.75C217.827 -14.75 217.856 -14.75 217.885 -14.75C217.914 -14.75 217.943 -14.75 217.972 -14.75C218.001 -14.75 218.03 -14.75 218.059 -14.75C218.088 -14.75 218.117 -14.75 218.146 -14.75C218.175 -14.75 218.204 -14.75 218.233 -14.75C218.262 -14.75 218.291 -14.75 218.32 -14.75C218.349 -14.75 218.379 -14.75 218.408 -14.75C218.437 -14.75 218.466 -14.75 218.495 -14.75C218.524 -14.75 218.553 -14.75 218.582 -14.75C218.611 -14.75 218.64 -14.75 218.669 -14.75C218.699 -14.75 218.728 -14.75 218.757 -14.75C218.786 -14.75 218.815 -14.75 218.844 -14.75C218.873 -14.75 218.902 -14.75 218.932 -14.75C218.961 -14.75 218.99 -14.75 219.019 -14.75C219.048 -14.75 219.077 -14.75 219.107 -14.75C219.136 -14.75 219.165 -14.75 219.194 -14.75C219.223 -14.75 219.252 -14.75 219.282 -14.75C219.311 -14.75 219.34 -14.75 219.369 -14.75C219.398 -14.75 219.428 -14.75 219.457 -14.75C219.486 -14.75 219.515 -14.75 219.544 -14.75C219.574 -14.75 219.603 -14.75 219.632 -14.75C219.661 -14.75 219.691 -14.75 219.72 -14.75C219.749 -14.75 219.778 -14.75 219.807 -14.75C219.837 -14.75 219.866 -14.75 219.895 -14.75C219.924 -14.75 219.954 -14.75 219.983 -14.75C220.012 -14.75 220.041 -14.75 220.071 -14.75C220.1 -14.75 220.129 -14.75 220.158 -14.75C220.188 -14.75 220.217 -14.75 220.246 -14.75C220.276 -14.75 220.305 -14.75 220.334 -14.75C220.363 -14.75 220.393 -14.75 220.422 -14.75C220.451 -14.75 220.48 -14.75 220.51 -14.75C220.539 -14.75 220.568 -14.75 220.598 -14.75C220.627 -14.75 220.656 -14.75 220.685 -14.75C220.715 -14.75 220.744 -14.75 220.773 -14.75C220.803 -14.75 220.832 -14.75 220.861 -14.75C220.89 -14.75 220.92 -14.75 220.949 -14.75C220.978 -14.75 221.008 -14.75 221.037 -14.75C221.066 -14.75 221.095 -14.75 221.125 -14.75C221.154 -14.75 221.183 -14.75 221.213 -14.75C221.242 -14.75 221.271 -14.75 221.3 -14.75C221.33 -14.75 221.359 -14.75 221.388 -14.75C221.418 -14.75 221.447 -14.75 221.476 -14.75C221.505 -14.75 221.535 -14.75 221.564 -14.75C221.593 -14.75 221.623 -14.75 221.652 -14.75C221.681 -14.75 221.71 -14.75 221.74 -14.75C221.769 -14.75 221.798 -14.75 221.828 -14.75C221.857 -14.75 221.886 -14.75 221.915 -14.75C221.945 -14.75 221.974 -14.75 222.003 -14.75C222.033 -14.75 222.062 -14.75 222.091 -14.75C222.12 -14.75 222.15 -14.75 222.179 -14.75C222.208 -14.75 222.237 -14.75 222.267 -14.75C222.296 -14.75 222.325 -14.75 222.354 -14.75C222.384 -14.75 222.413 -14.75 222.442 -14.75C222.471 -14.75 222.501 -14.75 222.53 -14.75C222.559 -14.75 222.588 -14.75 222.618 -14.75C222.647 -14.75 222.676 -14.75 222.705 -14.75C222.735 -14.75 222.764 -14.75 222.793 -14.75C222.822 -14.75 222.851 -14.75 222.881 -14.75C222.91 -14.75 222.939 -14.75 222.968 -14.75C222.998 -14.75 223.027 -14.75 223.056 -14.75C223.085 -14.75 223.114 -14.75 223.144 -14.75C223.173 -14.75 223.202 -14.75 223.231 -14.75C223.26 -14.75 223.289 -14.75 223.319 -14.75C223.348 -14.75 223.377 -14.75 223.406 -14.75C223.435 -14.75 223.464 -14.75 223.494 -14.75C223.523 -14.75 223.552 -14.75 223.581 -14.75C223.61 -14.75 223.639 -14.75 223.668 -14.75C223.698 -14.75 223.727 -14.75 223.756 -14.75C223.785 -14.75 223.814 -14.75 223.843 -14.75C223.872 -14.75 223.901 -14.75 223.93 -14.75C223.96 -14.75 223.989 -14.75 224.018 -14.75C224.047 -14.75 224.076 -14.75 224.105 -14.75C224.134 -14.75 224.163 -14.75 224.192 -14.75C224.221 -14.75 224.25 -14.75 224.279 -14.75C224.308 -14.75 224.337 -14.75 224.366 -14.75C224.395 -14.75 224.424 -14.75 224.453 -14.75C224.482 -14.75 224.511 -14.75 224.54 -14.75C224.569 -14.75 224.598 -14.75 224.627 -14.75C224.656 -14.75 224.685 -14.75 224.714 -14.75C224.743 -14.75 224.772 -14.75 224.801 -14.75C224.83 -14.75 224.859 -14.75 224.888 -14.75C224.917 -14.75 224.946 -14.75 224.975 -14.75C225.004 -14.75 225.033 -14.75 225.062 -14.75C225.09 -14.75 225.119 -14.75 225.148 -14.75C225.177 -14.75 225.206 -14.75 225.235 -14.75C225.264 -14.75 225.292 -14.75 225.321 -14.75C225.35 -14.75 225.379 -14.75 225.408 -14.75C225.437 -14.75 225.465 -14.75 225.494 -14.75C225.523 -14.75 225.552 -14.75 225.581 -14.75C225.609 -14.75 225.638 -14.75 225.667 -14.75C225.696 -14.75 225.724 -14.75 225.753 -14.75C225.782 -14.75 225.811 -14.75 225.839 -14.75C225.868 -14.75 225.897 -14.75 225.925 -14.75C225.954 -14.75 225.983 -14.75 226.011 -14.75C226.04 -14.75 226.069 -14.75 226.097 -14.75C226.126 -14.75 226.155 -14.75 226.183 -14.75C226.212 -14.75 226.241 -14.75 226.269 -14.75C226.298 -14.75 226.326 -14.75 226.355 -14.75C226.384 -14.75 226.412 -14.75 226.441 -14.75C226.469 -14.75 226.498 -14.75 226.526 -14.75C226.555 -14.75 226.583 -14.75 226.612 -14.75C226.64 -14.75 226.669 -14.75 226.697 -14.75C226.726 -14.75 226.754 -14.75 226.783 -14.75C226.811 -14.75 226.84 -14.75 226.868 -14.75C226.896 -14.75 226.925 -14.75 226.953 -14.75C226.982 -14.75 227.01 -14.75 227.038 -14.75C227.067 -14.75 227.095 -14.75 227.123 -14.75C227.152 -14.75 227.18 -14.75 227.208 -14.75C227.237 -14.75 227.265 -14.75 227.293 -14.75C227.322 -14.75 227.35 -14.75 227.378 -14.75C227.406 -14.75 227.435 -14.75 227.463 -14.75C227.491 -14.75 227.519 -14.75 227.547 -14.75C227.576 -14.75 227.604 -14.75 227.632 -14.75C227.66 -14.75 227.688 -14.75 227.716 -14.75C227.745 -14.75 227.773 -14.75 227.801 -14.75C227.829 -14.75 227.857 -14.75 227.885 -14.75C227.913 -14.75 227.941 -14.75 227.969 -14.75C227.997 -14.75 228.025 -14.75 228.053 -14.75C228.081 -14.75 228.109 -14.75 228.137 -14.75C228.165 -14.75 228.193 -14.75 228.221 -14.75C228.249 -14.75 228.277 -14.75 228.305 -14.75C228.333 -14.75 228.361 -14.75 228.389 -14.75C228.417 -14.75 228.444 -14.75 228.472 -14.75C228.5 -14.75 228.528 -14.75 228.556 -14.75C228.584 -14.75 228.611 -14.75 228.639 -14.75C228.667 -14.75 228.695 -14.75 228.722 -14.75C228.75 -14.75 228.778 -14.75 228.805 -14.75C228.833 -14.75 228.861 -14.75 228.889 -14.75C228.916 -14.75 228.944 -14.75 228.971 -14.75C228.999 -14.75 229.027 -14.75 229.054 -14.75C229.082 -14.75 229.109 -14.75 229.137 -14.75C229.165 -14.75 229.192 -14.75 229.22 -14.75C229.247 -14.75 229.275 -14.75 229.302 -14.75C229.33 -14.75 229.357 -14.75 229.384 -14.75C229.412 -14.75 229.439 -14.75 229.467 -14.75C229.494 -14.75 229.521 -14.75 229.549 -14.75C229.576 -14.75 229.603 -14.75 229.631 -14.75C229.658 -14.75 229.685 -14.75 229.713 -14.75C229.74 -14.75 229.767 -14.75 229.794 -14.75C229.822 -14.75 229.849 -14.75 229.876 -14.75C229.903 -14.75 229.93 -14.75 229.958 -14.75C229.985 -14.75 230.012 -14.75 230.039 -14.75C230.066 -14.75 230.093 -14.75 230.12 -14.75C230.147 -14.75 230.174 -14.75 230.201 -14.75C230.228 -14.75 230.255 -14.75 230.282 -14.75C230.309 -14.75 230.336 -14.75 230.363 -14.75C230.39 -14.75 230.417 -14.75 230.444 -14.75C230.471 -14.75 230.498 -14.75 230.525 -14.75C230.551 -14.75 230.578 -14.75 230.605 -14.75C230.632 -14.75 230.659 -14.75 230.685 -14.75C230.712 -14.75 230.739 -14.75 230.766 -14.75C230.792 -14.75 230.819 -14.75 230.846 -14.75C230.872 -14.75 230.899 -14.75 230.926 -14.75C230.952 -14.75 230.979 -14.75 231.005 -14.75C231.032 -14.75 231.059 -14.75 231.085 -14.75C231.112 -14.75 231.138 -14.75 231.165 -14.75C231.191 -14.75 231.217 -14.75 231.244 -14.75C231.27 -14.75 231.297 -14.75 231.323 -14.75C231.35 -14.75 231.376 -14.75 231.402 -14.75C231.429 -14.75 231.455 -14.75 231.481 -14.75C231.507 -14.75 231.534 -14.75 231.56 -14.75C231.586 -14.75 231.612 -14.75 231.638 -14.75C231.665 -14.75 231.691 -14.75 231.717 -14.75C231.743 -14.75 231.769 -14.75 231.795 -14.75C231.821 -14.75 231.847 -14.75 231.873 -14.75C231.899 -14.75 231.925 -14.75 231.951 -14.75C231.977 -14.75 232.003 -14.75 232.029 -14.75C232.055 -14.75 232.081 -14.75 232.107 -14.75C232.133 -14.75 232.159 -14.75 232.184 -14.75C232.21 -14.75 232.236 -14.75 232.262 -14.75C232.288 -14.75 232.313 -14.75 232.339 -14.75C232.365 -14.75 232.39 -14.75 232.416 -14.75C232.442 -14.75 232.467 -14.75 232.493 -14.75C232.518 -14.75 232.544 -14.75 232.57 -14.75C232.595 -14.75 232.621 -14.75 232.646 -14.75C232.672 -14.75 232.697 -14.75 232.722 -14.75C232.748 -14.75 232.773 -14.75 232.799 -14.75C232.824 -14.75 232.849 -14.75 232.875 -14.75C232.9 -14.75 232.925 -14.75 232.951 -14.75C232.976 -14.75 233.001 -14.75 233.026 -14.75C233.051 -14.75 233.077 -14.75 233.102 -14.75C233.127 -14.75 233.152 -14.75 233.177 -14.75C233.202 -14.75 233.227 -14.75 233.252 -14.75C233.277 -14.75 233.302 -14.75 233.327 -14.75C233.352 -14.75 233.377 -14.75 233.402 -14.75C233.427 -14.75 233.452 -14.75 233.477 -14.75C233.501 -14.75 233.526 -14.75 233.551 -14.75C233.576 -14.75 233.601 -14.75 233.625 -14.75C233.65 -14.75 233.675 -14.75 233.699 -14.75C233.724 -14.75 233.749 -14.75 233.773 -14.75C233.798 -14.75 233.822 -14.75 233.847 -14.75C233.872 -14.75 233.896 -14.75 233.921 -14.75C233.945 -14.75 233.969 -14.75 233.994 -14.75C234.018 -14.75 234.043 -14.75 234.067 -14.75C234.091 -14.75 234.116 -14.75 234.14 -14.75C234.164 -14.75 234.188 -14.75 234.213 -14.75C234.237 -14.75 234.261 -14.75 234.285 -14.75C234.309 -14.75 234.333 -14.75 234.358 -14.75C234.382 -14.75 234.406 -14.75 234.43 -14.75C234.454 -14.75 234.478 -14.75 234.502 -14.75C234.526 -14.75 234.55 -14.75 234.573 -14.75C234.597 -14.75 234.621 -14.75 234.645 -14.75C234.669 -14.75 234.693 -14.75 234.716 -14.75C234.74 -14.75 234.764 -14.75 234.788 -14.75C234.811 -14.75 234.835 -14.75 234.858 -14.75C234.882 -14.75 234.906 -14.75 234.929 -14.75C234.953 -14.75 234.976 -14.75 235 -14.75C235.023 -14.75 235.047 -14.75 235.07 -14.75C235.094 -14.75 235.117 -14.75 235.14 -14.75C235.164 -14.75 235.187 -14.75 235.21 -14.75C235.233 -14.75 235.257 -14.75 235.28 -14.75C235.303 -14.75 235.326 -14.75 235.349 -14.75C235.372 -14.75 235.396 -14.75 235.419 -14.75C235.442 -14.75 235.465 -14.75 235.488 -14.75C235.511 -14.75 235.534 -14.75 235.557 -14.75C235.579 -14.75 235.602 -14.75 235.625 -14.75C235.648 -14.75 235.671 -14.75 235.694 -14.75C235.716 -14.75 235.739 -14.75 235.762 -14.75C235.784 -14.75 235.807 -14.75 235.83 -14.75C235.852 -14.75 235.875 -14.75 235.897 -14.75C235.92 -14.75 235.942 -14.75 235.965 -14.75C235.987 -14.75 236.01 -14.75 236.032 -14.75C236.055 -14.75 236.077 -14.75 236.099 -14.75C236.122 -14.75 236.144 -14.75 236.166 -14.75C236.188 -14.75 236.211 -14.75 236.233 -14.75C236.255 -14.75 236.277 -14.75 236.299 -14.75C236.321 -14.75 236.343 -14.75 236.365 -14.75C236.387 -14.75 236.409 -14.75 236.431 -14.75C236.453 -14.75 236.475 -14.75 236.497 -14.75C236.519 -14.75 236.541 -14.75 236.562 -14.75C236.584 -14.75 236.606 -14.75 236.628 -14.75C236.649 -14.75 236.671 -14.75 236.693 -14.75C236.714 -14.75 236.736 -14.75 236.757 -14.75C236.779 -14.75 236.8 -14.75 236.822 -14.75C236.843 -14.75 236.865 -14.75 236.886 -14.75C236.907 -14.75 236.929 -14.75 236.95 -14.75C236.971 -14.75 236.993 -14.75 237.014 -14.75C237.035 -14.75 237.056 -14.75 237.077 -14.75C237.098 -14.75 237.12 -14.75 237.141 -14.75C237.162 -14.75 237.183 -14.75 237.204 -14.75C237.225 -14.75 237.246 -14.75 237.266 -14.75C237.287 -14.75 237.308 -14.75 237.329 -14.75C237.35 -14.75 237.371 -14.75 237.391 -14.75C237.412 -14.75 237.433 -14.75 237.453 -14.75C237.474 -14.75 237.495 -14.75 237.515 -14.75C237.536 -14.75 237.556 -14.75 237.577 -14.75C237.597 -14.75 237.617 -14.75 237.638 -14.75C237.658 -14.75 237.679 -14.75 237.699 -14.75C237.719 -14.75 237.739 -14.75 237.76 -14.75C237.78 -14.75 237.8 -14.75 237.82 -14.75C237.84 -14.75 237.86 -14.75 237.88 -14.75C237.9 -14.75 237.92 -14.75 237.94 -14.75C237.96 -14.75 237.98 -14.75 238 -14.75V-16.25C237.98 -16.25 237.96 -16.25 237.94 -16.25C237.92 -16.25 237.9 -16.25 237.88 -16.25C237.86 -16.25 237.84 -16.25 237.82 -16.25C237.8 -16.25 237.78 -16.25 237.76 -16.25C237.739 -16.25 237.719 -16.25 237.699 -16.25C237.679 -16.25 237.658 -16.25 237.638 -16.25C237.617 -16.25 237.597 -16.25 237.577 -16.25C237.556 -16.25 237.536 -16.25 237.515 -16.25C237.495 -16.25 237.474 -16.25 237.453 -16.25C237.433 -16.25 237.412 -16.25 237.391 -16.25C237.371 -16.25 237.35 -16.25 237.329 -16.25C237.308 -16.25 237.287 -16.25 237.266 -16.25C237.246 -16.25 237.225 -16.25 237.204 -16.25C237.183 -16.25 237.162 -16.25 237.141 -16.25C237.12 -16.25 237.098 -16.25 237.077 -16.25C237.056 -16.25 237.035 -16.25 237.014 -16.25C236.993 -16.25 236.971 -16.25 236.95 -16.25C236.929 -16.25 236.907 -16.25 236.886 -16.25C236.865 -16.25 236.843 -16.25 236.822 -16.25C236.8 -16.25 236.779 -16.25 236.757 -16.25C236.736 -16.25 236.714 -16.25 236.693 -16.25C236.671 -16.25 236.649 -16.25 236.628 -16.25C236.606 -16.25 236.584 -16.25 236.562 -16.25C236.541 -16.25 236.519 -16.25 236.497 -16.25C236.475 -16.25 236.453 -16.25 236.431 -16.25C236.409 -16.25 236.387 -16.25 236.365 -16.25C236.343 -16.25 236.321 -16.25 236.299 -16.25C236.277 -16.25 236.255 -16.25 236.233 -16.25C236.211 -16.25 236.188 -16.25 236.166 -16.25C236.144 -16.25 236.122 -16.25 236.099 -16.25C236.077 -16.25 236.055 -16.25 236.032 -16.25C236.01 -16.25 235.987 -16.25 235.965 -16.25C235.942 -16.25 235.92 -16.25 235.897 -16.25C235.875 -16.25 235.852 -16.25 235.83 -16.25C235.807 -16.25 235.784 -16.25 235.762 -16.25C235.739 -16.25 235.716 -16.25 235.694 -16.25C235.671 -16.25 235.648 -16.25 235.625 -16.25C235.602 -16.25 235.579 -16.25 235.557 -16.25C235.534 -16.25 235.511 -16.25 235.488 -16.25C235.465 -16.25 235.442 -16.25 235.419 -16.25C235.396 -16.25 235.372 -16.25 235.349 -16.25C235.326 -16.25 235.303 -16.25 235.28 -16.25C235.257 -16.25 235.233 -16.25 235.21 -16.25C235.187 -16.25 235.164 -16.25 235.14 -16.25C235.117 -16.25 235.094 -16.25 235.07 -16.25C235.047 -16.25 235.023 -16.25 235 -16.25C234.976 -16.25 234.953 -16.25 234.929 -16.25C234.906 -16.25 234.882 -16.25 234.858 -16.25C234.835 -16.25 234.811 -16.25 234.788 -16.25C234.764 -16.25 234.74 -16.25 234.716 -16.25C234.693 -16.25 234.669 -16.25 234.645 -16.25C234.621 -16.25 234.597 -16.25 234.573 -16.25C234.55 -16.25 234.526 -16.25 234.502 -16.25C234.478 -16.25 234.454 -16.25 234.43 -16.25C234.406 -16.25 234.382 -16.25 234.358 -16.25C234.333 -16.25 234.309 -16.25 234.285 -16.25C234.261 -16.25 234.237 -16.25 234.213 -16.25C234.188 -16.25 234.164 -16.25 234.14 -16.25C234.116 -16.25 234.091 -16.25 234.067 -16.25C234.043 -16.25 234.018 -16.25 233.994 -16.25C233.969 -16.25 233.945 -16.25 233.921 -16.25C233.896 -16.25 233.872 -16.25 233.847 -16.25C233.822 -16.25 233.798 -16.25 233.773 -16.25C233.749 -16.25 233.724 -16.25 233.699 -16.25C233.675 -16.25 233.65 -16.25 233.625 -16.25C233.601 -16.25 233.576 -16.25 233.551 -16.25C233.526 -16.25 233.501 -16.25 233.477 -16.25C233.452 -16.25 233.427 -16.25 233.402 -16.25C233.377 -16.25 233.352 -16.25 233.327 -16.25C233.302 -16.25 233.277 -16.25 233.252 -16.25C233.227 -16.25 233.202 -16.25 233.177 -16.25C233.152 -16.25 233.127 -16.25 233.102 -16.25C233.077 -16.25 233.051 -16.25 233.026 -16.25C233.001 -16.25 232.976 -16.25 232.951 -16.25C232.925 -16.25 232.9 -16.25 232.875 -16.25C232.849 -16.25 232.824 -16.25 232.799 -16.25C232.773 -16.25 232.748 -16.25 232.722 -16.25C232.697 -16.25 232.672 -16.25 232.646 -16.25C232.621 -16.25 232.595 -16.25 232.57 -16.25C232.544 -16.25 232.518 -16.25 232.493 -16.25C232.467 -16.25 232.442 -16.25 232.416 -16.25C232.39 -16.25 232.365 -16.25 232.339 -16.25C232.313 -16.25 232.288 -16.25 232.262 -16.25C232.236 -16.25 232.21 -16.25 232.184 -16.25C232.159 -16.25 232.133 -16.25 232.107 -16.25C232.081 -16.25 232.055 -16.25 232.029 -16.25C232.003 -16.25 231.977 -16.25 231.951 -16.25C231.925 -16.25 231.899 -16.25 231.873 -16.25C231.847 -16.25 231.821 -16.25 231.795 -16.25C231.769 -16.25 231.743 -16.25 231.717 -16.25C231.691 -16.25 231.665 -16.25 231.638 -16.25C231.612 -16.25 231.586 -16.25 231.56 -16.25C231.534 -16.25 231.507 -16.25 231.481 -16.25C231.455 -16.25 231.429 -16.25 231.402 -16.25C231.376 -16.25 231.35 -16.25 231.323 -16.25C231.297 -16.25 231.27 -16.25 231.244 -16.25C231.217 -16.25 231.191 -16.25 231.165 -16.25C231.138 -16.25 231.112 -16.25 231.085 -16.25C231.059 -16.25 231.032 -16.25 231.005 -16.25C230.979 -16.25 230.952 -16.25 230.926 -16.25C230.899 -16.25 230.872 -16.25 230.846 -16.25C230.819 -16.25 230.792 -16.25 230.766 -16.25C230.739 -16.25 230.712 -16.25 230.685 -16.25C230.659 -16.25 230.632 -16.25 230.605 -16.25C230.578 -16.25 230.551 -16.25 230.525 -16.25C230.498 -16.25 230.471 -16.25 230.444 -16.25C230.417 -16.25 230.39 -16.25 230.363 -16.25C230.336 -16.25 230.309 -16.25 230.282 -16.25C230.255 -16.25 230.228 -16.25 230.201 -16.25C230.174 -16.25 230.147 -16.25 230.12 -16.25C230.093 -16.25 230.066 -16.25 230.039 -16.25C230.012 -16.25 229.985 -16.25 229.958 -16.25C229.93 -16.25 229.903 -16.25 229.876 -16.25C229.849 -16.25 229.822 -16.25 229.794 -16.25C229.767 -16.25 229.74 -16.25 229.713 -16.25C229.685 -16.25 229.658 -16.25 229.631 -16.25C229.603 -16.25 229.576 -16.25 229.549 -16.25C229.521 -16.25 229.494 -16.25 229.467 -16.25C229.439 -16.25 229.412 -16.25 229.384 -16.25C229.357 -16.25 229.33 -16.25 229.302 -16.25C229.275 -16.25 229.247 -16.25 229.22 -16.25C229.192 -16.25 229.165 -16.25 229.137 -16.25C229.109 -16.25 229.082 -16.25 229.054 -16.25C229.027 -16.25 228.999 -16.25 228.971 -16.25C228.944 -16.25 228.916 -16.25 228.889 -16.25C228.861 -16.25 228.833 -16.25 228.805 -16.25C228.778 -16.25 228.75 -16.25 228.722 -16.25C228.695 -16.25 228.667 -16.25 228.639 -16.25C228.611 -16.25 228.584 -16.25 228.556 -16.25C228.528 -16.25 228.5 -16.25 228.472 -16.25C228.444 -16.25 228.417 -16.25 228.389 -16.25C228.361 -16.25 228.333 -16.25 228.305 -16.25C228.277 -16.25 228.249 -16.25 228.221 -16.25C228.193 -16.25 228.165 -16.25 228.137 -16.25C228.109 -16.25 228.081 -16.25 228.053 -16.25C228.025 -16.25 227.997 -16.25 227.969 -16.25C227.941 -16.25 227.913 -16.25 227.885 -16.25C227.857 -16.25 227.829 -16.25 227.801 -16.25C227.773 -16.25 227.745 -16.25 227.716 -16.25C227.688 -16.25 227.66 -16.25 227.632 -16.25C227.604 -16.25 227.576 -16.25 227.547 -16.25C227.519 -16.25 227.491 -16.25 227.463 -16.25C227.435 -16.25 227.406 -16.25 227.378 -16.25C227.35 -16.25 227.322 -16.25 227.293 -16.25C227.265 -16.25 227.237 -16.25 227.208 -16.25C227.18 -16.25 227.152 -16.25 227.123 -16.25C227.095 -16.25 227.067 -16.25 227.038 -16.25C227.01 -16.25 226.982 -16.25 226.953 -16.25C226.925 -16.25 226.896 -16.25 226.868 -16.25C226.84 -16.25 226.811 -16.25 226.783 -16.25C226.754 -16.25 226.726 -16.25 226.697 -16.25C226.669 -16.25 226.64 -16.25 226.612 -16.25C226.583 -16.25 226.555 -16.25 226.526 -16.25C226.498 -16.25 226.469 -16.25 226.441 -16.25C226.412 -16.25 226.384 -16.25 226.355 -16.25C226.326 -16.25 226.298 -16.25 226.269 -16.25C226.241 -16.25 226.212 -16.25 226.183 -16.25C226.155 -16.25 226.126 -16.25 226.097 -16.25C226.069 -16.25 226.04 -16.25 226.011 -16.25C225.983 -16.25 225.954 -16.25 225.925 -16.25C225.897 -16.25 225.868 -16.25 225.839 -16.25C225.811 -16.25 225.782 -16.25 225.753 -16.25C225.724 -16.25 225.696 -16.25 225.667 -16.25C225.638 -16.25 225.609 -16.25 225.581 -16.25C225.552 -16.25 225.523 -16.25 225.494 -16.25C225.465 -16.25 225.437 -16.25 225.408 -16.25C225.379 -16.25 225.35 -16.25 225.321 -16.25C225.292 -16.25 225.264 -16.25 225.235 -16.25C225.206 -16.25 225.177 -16.25 225.148 -16.25C225.119 -16.25 225.09 -16.25 225.062 -16.25C225.033 -16.25 225.004 -16.25 224.975 -16.25C224.946 -16.25 224.917 -16.25 224.888 -16.25C224.859 -16.25 224.83 -16.25 224.801 -16.25C224.772 -16.25 224.743 -16.25 224.714 -16.25C224.685 -16.25 224.656 -16.25 224.627 -16.25C224.598 -16.25 224.569 -16.25 224.54 -16.25C224.511 -16.25 224.482 -16.25 224.453 -16.25C224.424 -16.25 224.395 -16.25 224.366 -16.25C224.337 -16.25 224.308 -16.25 224.279 -16.25C224.25 -16.25 224.221 -16.25 224.192 -16.25C224.163 -16.25 224.134 -16.25 224.105 -16.25C224.076 -16.25 224.047 -16.25 224.018 -16.25C223.989 -16.25 223.96 -16.25 223.93 -16.25C223.901 -16.25 223.872 -16.25 223.843 -16.25C223.814 -16.25 223.785 -16.25 223.756 -16.25C223.727 -16.25 223.698 -16.25 223.668 -16.25C223.639 -16.25 223.61 -16.25 223.581 -16.25C223.552 -16.25 223.523 -16.25 223.494 -16.25C223.464 -16.25 223.435 -16.25 223.406 -16.25C223.377 -16.25 223.348 -16.25 223.319 -16.25C223.289 -16.25 223.26 -16.25 223.231 -16.25C223.202 -16.25 223.173 -16.25 223.144 -16.25C223.114 -16.25 223.085 -16.25 223.056 -16.25C223.027 -16.25 222.998 -16.25 222.968 -16.25C222.939 -16.25 222.91 -16.25 222.881 -16.25C222.851 -16.25 222.822 -16.25 222.793 -16.25C222.764 -16.25 222.735 -16.25 222.705 -16.25C222.676 -16.25 222.647 -16.25 222.618 -16.25C222.588 -16.25 222.559 -16.25 222.53 -16.25C222.501 -16.25 222.471 -16.25 222.442 -16.25C222.413 -16.25 222.384 -16.25 222.354 -16.25C222.325 -16.25 222.296 -16.25 222.267 -16.25C222.237 -16.25 222.208 -16.25 222.179 -16.25C222.15 -16.25 222.12 -16.25 222.091 -16.25C222.062 -16.25 222.033 -16.25 222.003 -16.25C221.974 -16.25 221.945 -16.25 221.915 -16.25C221.886 -16.25 221.857 -16.25 221.828 -16.25C221.798 -16.25 221.769 -16.25 221.74 -16.25C221.71 -16.25 221.681 -16.25 221.652 -16.25C221.623 -16.25 221.593 -16.25 221.564 -16.25C221.535 -16.25 221.505 -16.25 221.476 -16.25C221.447 -16.25 221.418 -16.25 221.388 -16.25C221.359 -16.25 221.33 -16.25 221.3 -16.25C221.271 -16.25 221.242 -16.25 221.213 -16.25C221.183 -16.25 221.154 -16.25 221.125 -16.25C221.095 -16.25 221.066 -16.25 221.037 -16.25C221.008 -16.25 220.978 -16.25 220.949 -16.25C220.92 -16.25 220.89 -16.25 220.861 -16.25C220.832 -16.25 220.803 -16.25 220.773 -16.25C220.744 -16.25 220.715 -16.25 220.685 -16.25C220.656 -16.25 220.627 -16.25 220.598 -16.25C220.568 -16.25 220.539 -16.25 220.51 -16.25C220.48 -16.25 220.451 -16.25 220.422 -16.25C220.393 -16.25 220.363 -16.25 220.334 -16.25C220.305 -16.25 220.276 -16.25 220.246 -16.25C220.217 -16.25 220.188 -16.25 220.158 -16.25C220.129 -16.25 220.1 -16.25 220.071 -16.25C220.041 -16.25 220.012 -16.25 219.983 -16.25C219.954 -16.25 219.924 -16.25 219.895 -16.25C219.866 -16.25 219.837 -16.25 219.807 -16.25C219.778 -16.25 219.749 -16.25 219.72 -16.25C219.691 -16.25 219.661 -16.25 219.632 -16.25C219.603 -16.25 219.574 -16.25 219.544 -16.25C219.515 -16.25 219.486 -16.25 219.457 -16.25C219.428 -16.25 219.398 -16.25 219.369 -16.25C219.34 -16.25 219.311 -16.25 219.282 -16.25C219.252 -16.25 219.223 -16.25 219.194 -16.25C219.165 -16.25 219.136 -16.25 219.107 -16.25C219.077 -16.25 219.048 -16.25 219.019 -16.25C218.99 -16.25 218.961 -16.25 218.932 -16.25C218.902 -16.25 218.873 -16.25 218.844 -16.25C218.815 -16.25 218.786 -16.25 218.757 -16.25C218.728 -16.25 218.699 -16.25 218.669 -16.25C218.64 -16.25 218.611 -16.25 218.582 -16.25C218.553 -16.25 218.524 -16.25 218.495 -16.25C218.466 -16.25 218.437 -16.25 218.408 -16.25C218.379 -16.25 218.349 -16.25 218.32 -16.25C218.291 -16.25 218.262 -16.25 218.233 -16.25C218.204 -16.25 218.175 -16.25 218.146 -16.25C218.117 -16.25 218.088 -16.25 218.059 -16.25C218.03 -16.25 218.001 -16.25 217.972 -16.25C217.943 -16.25 217.914 -16.25 217.885 -16.25C217.856 -16.25 217.827 -16.25 217.798 -16.25C217.769 -16.25 217.74 -16.25 217.711 -16.25C217.682 -16.25 217.653 -16.25 217.624 -16.25C217.595 -16.25 217.566 -16.25 217.537 -16.25C217.509 -16.25 217.48 -16.25 217.451 -16.25C217.422 -16.25 217.393 -16.25 217.364 -16.25C217.335 -16.25 217.306 -16.25 217.277 -16.25C217.249 -16.25 217.22 -16.25 217.191 -16.25C217.162 -16.25 217.133 -16.25 217.104 -16.25C217.076 -16.25 217.047 -16.25 217.018 -16.25C216.989 -16.25 216.96 -16.25 216.931 -16.25C216.903 -16.25 216.874 -16.25 216.845 -16.25C216.816 -16.25 216.788 -16.25 216.759 -16.25C216.73 -16.25 216.701 -16.25 216.673 -16.25C216.644 -16.25 216.615 -16.25 216.586 -16.25C216.558 -16.25 216.529 -16.25 216.5 -16.25C216.472 -16.25 216.443 -16.25 216.414 -16.25C216.386 -16.25 216.357 -16.25 216.328 -16.25C216.3 -16.25 216.271 -16.25 216.243 -16.25C216.214 -16.25 216.185 -16.25 216.157 -16.25C216.128 -16.25 216.1 -16.25 216.071 -16.25C216.042 -16.25 216.014 -16.25 215.985 -16.25C215.957 -16.25 215.928 -16.25 215.9 -16.25C215.871 -16.25 215.843 -16.25 215.814 -16.25C215.786 -16.25 215.757 -16.25 215.729 -16.25C215.7 -16.25 215.672 -16.25 215.643 -16.25C215.615 -16.25 215.587 -16.25 215.558 -16.25C215.53 -16.25 215.501 -16.25 215.473 -16.25C215.445 -16.25 215.416 -16.25 215.388 -16.25C215.36 -16.25 215.331 -16.25 215.303 -16.25C215.275 -16.25 215.246 -16.25 215.218 -16.25C215.19 -16.25 215.161 -16.25 215.133 -16.25C215.105 -16.25 215.076 -16.25 215.048 -16.25C215.02 -16.25 214.992 -16.25 214.964 -16.25C214.935 -16.25 214.907 -16.25 214.879 -16.25C214.851 -16.25 214.823 -16.25 214.794 -16.25C214.766 -16.25 214.738 -16.25 214.71 -16.25C214.682 -16.25 214.654 -16.25 214.626 -16.25C214.598 -16.25 214.57 -16.25 214.541 -16.25C214.513 -16.25 214.485 -16.25 214.457 -16.25C214.429 -16.25 214.401 -16.25 214.373 -16.25C214.345 -16.25 214.317 -16.25 214.289 -16.25C214.261 -16.25 214.233 -16.25 214.206 -16.25C214.178 -16.25 214.15 -16.25 214.122 -16.25C214.094 -16.25 214.066 -16.25 214.038 -16.25C214.01 -16.25 213.982 -16.25 213.955 -16.25C213.927 -16.25 213.899 -16.25 213.871 -16.25C213.843 -16.25 213.816 -16.25 213.788 -16.25C213.76 -16.25 213.732 -16.25 213.705 -16.25C213.677 -16.25 213.649 -16.25 213.622 -16.25C213.594 -16.25 213.566 -16.25 213.539 -16.25C213.511 -16.25 213.483 -16.25 213.456 -16.25C213.428 -16.25 213.4 -16.25 213.373 -16.25C213.345 -16.25 213.318 -16.25 213.29 -16.25C213.263 -16.25 213.235 -16.25 213.208 -16.25C213.18 -16.25 213.153 -16.25 213.125 -16.25C213.098 -16.25 213.07 -16.25 213.043 -16.25C213.016 -16.25 212.988 -16.25 212.961 -16.25C212.933 -16.25 212.906 -16.25 212.879 -16.25C212.851 -16.25 212.824 -16.25 212.797 -16.25C212.769 -16.25 212.742 -16.25 212.715 -16.25C212.688 -16.25 212.66 -16.25 212.633 -16.25C212.606 -16.25 212.579 -16.25 212.552 -16.25C212.524 -16.25 212.497 -16.25 212.47 -16.25C212.443 -16.25 212.416 -16.25 212.389 -16.25C212.362 -16.25 212.335 -16.25 212.308 -16.25C212.28 -16.25 212.253 -16.25 212.226 -16.25C212.199 -16.25 212.172 -16.25 212.146 -16.25C212.119 -16.25 212.092 -16.25 212.065 -16.25C212.038 -16.25 212.011 -16.25 211.984 -16.25C211.957 -16.25 211.93 -16.25 211.903 -16.25C211.877 -16.25 211.85 -16.25 211.823 -16.25C211.796 -16.25 211.769 -16.25 211.743 -16.25C211.716 -16.25 211.689 -16.25 211.663 -16.25C211.636 -16.25 211.609 -16.25 211.583 -16.25C211.556 -16.25 211.529 -16.25 211.503 -16.25C211.476 -16.25 211.45 -16.25 211.423 -16.25C211.396 -16.25 211.37 -16.25 211.343 -16.25C211.317 -16.25 211.29 -16.25 211.264 -16.25C211.238 -16.25 211.211 -16.25 211.185 -16.25C211.158 -16.25 211.132 -16.25 211.106 -16.25C211.079 -16.25 211.053 -16.25 211.027 -16.25C211 -16.25 210.974 -16.25 210.948 -16.25C210.921 -16.25 210.895 -16.25 210.869 -16.25C210.843 -16.25 210.817 -16.25 210.79 -16.25C210.764 -16.25 210.738 -16.25 210.712 -16.25C210.686 -16.25 210.66 -16.25 210.634 -16.25C210.608 -16.25 210.582 -16.25 210.556 -16.25C210.53 -16.25 210.504 -16.25 210.478 -16.25C210.452 -16.25 210.426 -16.25 210.4 -16.25C210.374 -16.25 210.348 -16.25 210.322 -16.25C210.297 -16.25 210.271 -16.25 210.245 -16.25C210.219 -16.25 210.193 -16.25 210.168 -16.25C210.142 -16.25 210.116 -16.25 210.091 -16.25C210.065 -16.25 210.039 -16.25 210.014 -16.25C209.988 -16.25 209.962 -16.25 209.937 -16.25C209.911 -16.25 209.886 -16.25 209.86 -16.25C209.835 -16.25 209.809 -16.25 209.784 -16.25C209.758 -16.25 209.733 -16.25 209.707 -16.25C209.682 -16.25 209.657 -16.25 209.631 -16.25C209.606 -16.25 209.581 -16.25 209.555 -16.25C209.53 -16.25 209.505 -16.25 209.479 -16.25C209.454 -16.25 209.429 -16.25 209.404 -16.25C209.379 -16.25 209.354 -16.25 209.328 -16.25C209.303 -16.25 209.278 -16.25 209.253 -16.25C209.228 -16.25 209.203 -16.25 209.178 -16.25C209.153 -16.25 209.128 -16.25 209.103 -16.25C209.078 -16.25 209.053 -16.25 209.028 -16.25C209.004 -16.25 208.979 -16.25 208.954 -16.25C208.929 -16.25 208.904 -16.25 208.88 -16.25C208.855 -16.25 208.83 -16.25 208.805 -16.25C208.781 -16.25 208.756 -16.25 208.731 -16.25C208.707 -16.25 208.682 -16.25 208.658 -16.25C208.633 -16.25 208.608 -16.25 208.584 -16.25C208.559 -16.25 208.535 -16.25 208.511 -16.25C208.486 -16.25 208.462 -16.25 208.437 -16.25C208.413 -16.25 208.389 -16.25 208.364 -16.25C208.34 -16.25 208.316 -16.25 208.291 -16.25C208.267 -16.25 208.243 -16.25 208.219 -16.25C208.194 -16.25 208.17 -16.25 208.146 -16.25C208.122 -16.25 208.098 -16.25 208.074 -16.25C208.05 -16.25 208.026 -16.25 208.002 -16.25C207.978 -16.25 207.954 -16.25 207.93 -16.25C207.906 -16.25 207.882 -16.25 207.858 -16.25C207.834 -16.25 207.811 -16.25 207.787 -16.25C207.763 -16.25 207.739 -16.25 207.716 -16.25C207.692 -16.25 207.668 -16.25 207.644 -16.25C207.621 -16.25 207.597 -16.25 207.574 -16.25C207.55 -16.25 207.526 -16.25 207.503 -16.25C207.479 -16.25 207.456 -16.25 207.432 -16.25C207.409 -16.25 207.386 -16.25 207.362 -16.25C207.339 -16.25 207.315 -16.25 207.292 -16.25C207.269 -16.25 207.246 -16.25 207.222 -16.25C207.199 -16.25 207.176 -16.25 207.153 -16.25C207.13 -16.25 207.106 -16.25 207.083 -16.25C207.06 -16.25 207.037 -16.25 207.014 -16.25C206.991 -16.25 206.968 -16.25 206.945 -16.25C206.922 -16.25 206.899 -16.25 206.876 -16.25C206.854 -16.25 206.831 -16.25 206.808 -16.25C206.785 -16.25 206.762 -16.25 206.74 -16.25C206.717 -16.25 206.694 -16.25 206.671 -16.25C206.649 -16.25 206.626 -16.25 206.604 -16.25C206.581 -16.25 206.558 -16.25 206.536 -16.25C206.513 -16.25 206.491 -16.25 206.469 -16.25C206.446 -16.25 206.424 -16.25 206.401 -16.25C206.379 -16.25 206.357 -16.25 206.334 -16.25C206.312 -16.25 206.29 -16.25 206.268 -16.25C206.245 -16.25 206.223 -16.25 206.201 -16.25C206.179 -16.25 206.157 -16.25 206.135 -16.25C206.113 -16.25 206.091 -16.25 206.069 -16.25C206.047 -16.25 206.025 -16.25 206.003 -16.25C205.981 -16.25 205.959 -16.25 205.937 -16.25C205.915 -16.25 205.894 -16.25 205.872 -16.25C205.85 -16.25 205.829 -16.25 205.807 -16.25C205.785 -16.25 205.764 -16.25 205.742 -16.25C205.72 -16.25 205.699 -16.25 205.677 -16.25C205.656 -16.25 205.634 -16.25 205.613 -16.25C205.591 -16.25 205.57 -16.25 205.549 -16.25C205.527 -16.25 205.506 -16.25 205.485 -16.25C205.464 -16.25 205.442 -16.25 205.421 -16.25C205.4 -16.25 205.379 -16.25 205.358 -16.25C205.337 -16.25 205.316 -16.25 205.295 -16.25C205.274 -16.25 205.253 -16.25 205.232 -16.25C205.211 -16.25 205.19 -16.25 205.169 -16.25C205.148 -16.25 205.127 -16.25 205.107 -16.25C205.086 -16.25 205.065 -16.25 205.044 -16.25C205.024 -16.25 205.003 -16.25 204.982 -16.25C204.962 -16.25 204.941 -16.25 204.921 -16.25C204.9 -16.25 204.88 -16.25 204.859 -16.25C204.839 -16.25 204.819 -16.25 204.798 -16.25C204.778 -16.25 204.758 -16.25 204.737 -16.25C204.717 -16.25 204.697 -16.25 204.677 -16.25C204.656 -16.25 204.636 -16.25 204.616 -16.25C204.596 -16.25 204.576 -16.25 204.556 -16.25C204.536 -16.25 204.516 -16.25 204.496 -16.25C204.476 -16.25 204.457 -16.25 204.437 -16.25C204.417 -16.25 204.397 -16.25 204.377 -16.25C204.358 -16.25 204.338 -16.25 204.318 -16.25C204.299 -16.25 204.279 -16.25 204.259 -16.25C204.24 -16.25 204.22 -16.25 204.201 -16.25C204.182 -16.25 204.162 -16.25 204.143 -16.25C204.123 -16.25 204.104 -16.25 204.085 -16.25C204.065 -16.25 204.046 -16.25 204.027 -16.25C204.008 -16.25 203.989 -16.25 203.97 -16.25C203.95 -16.25 203.931 -16.25 203.912 -16.25C203.893 -16.25 203.874 -16.25 203.856 -16.25C203.837 -16.25 203.818 -16.25 203.799 -16.25C203.78 -16.25 203.761 -16.25 203.743 -16.25C203.724 -16.25 203.705 -16.25 203.687 -16.25C203.668 -16.25 203.649 -16.25 203.631 -16.25C203.612 -16.25 203.594 -16.25 203.575 -16.25C203.557 -16.25 203.538 -16.25 203.52 -16.25C203.502 -16.25 203.483 -16.25 203.465 -16.25C203.447 -16.25 203.429 -16.25 203.411 -16.25C203.392 -16.25 203.374 -16.25 203.356 -16.25C203.338 -16.25 203.32 -16.25 203.302 -16.25C203.284 -16.25 203.266 -16.25 203.248 -16.25C203.231 -16.25 203.213 -16.25 203.195 -16.25C203.177 -16.25 203.159 -16.25 203.142 -16.25C203.124 -16.25 203.106 -16.25 203.089 -16.25C203.071 -16.25 203.054 -16.25 203.036 -16.25C203.019 -16.25 203.001 -16.25 202.984 -16.25C202.967 -16.25 202.949 -16.25 202.932 -16.25C202.915 -16.25 202.897 -16.25 202.88 -16.25C202.863 -16.25 202.846 -16.25 202.829 -16.25C202.812 -16.25 202.795 -16.25 202.778 -16.25C202.761 -16.25 202.744 -16.25 202.727 -16.25C202.71 -16.25 202.693 -16.25 202.676 -16.25C202.66 -16.25 202.643 -16.25 202.626 -16.25C202.61 -16.25 202.593 -16.25 202.576 -16.25C202.56 -16.25 202.543 -16.25 202.527 -16.25C202.51 -16.25 202.494 -16.25 202.478 -16.25C202.461 -16.25 202.445 -16.25 202.429 -16.25C202.412 -16.25 202.396 -16.25 202.38 -16.25C202.364 -16.25 202.348 -16.25 202.332 -16.25C202.316 -16.25 202.3 -16.25 202.284 -16.25C202.268 -16.25 202.252 -16.25 202.236 -16.25C202.22 -16.25 202.204 -16.25 202.189 -16.25C202.173 -16.25 202.157 -16.25 202.141 -16.25C202.126 -16.25 202.11 -16.25 202.095 -16.25C202.079 -16.25 202.064 -16.25 202.048 -16.25C202.033 -16.25 202.017 -16.25 202.002 -16.25C201.987 -16.25 201.972 -16.25 201.956 -16.25C201.941 -16.25 201.926 -16.25 201.911 -16.25C201.896 -16.25 201.881 -16.25 201.866 -16.25C201.851 -16.25 201.836 -16.25 201.821 -16.25C201.806 -16.25 201.791 -16.25 201.776 -16.25C201.762 -16.25 201.747 -16.25 201.732 -16.25C201.718 -16.25 201.703 -16.25 201.688 -16.25C201.674 -16.25 201.659 -16.25 201.645 -16.25C201.631 -16.25 201.616 -16.25 201.602 -16.25C201.587 -16.25 201.573 -16.25 201.559 -16.25C201.545 -16.25 201.531 -16.25 201.516 -16.25C201.502 -16.25 201.488 -16.25 201.474 -16.25C201.46 -16.25 201.446 -16.25 201.432 -16.25C201.419 -16.25 201.405 -16.25 201.391 -16.25C201.377 -16.25 201.364 -16.25 201.35 -16.25C201.336 -16.25 201.323 -16.25 201.309 -16.25C201.295 -16.25 201.282 -16.25 201.269 -16.25C201.255 -16.25 201.242 -16.25 201.228 -16.25C201.215 -16.25 201.202 -16.25 201.189 -16.25C201.175 -16.25 201.162 -16.25 201.149 -16.25C201.136 -16.25 201.123 -16.25 201.11 -16.25C201.097 -16.25 201.084 -16.25 201.071 -16.25C201.059 -16.25 201.046 -16.25 201.033 -16.25C201.02 -16.25 201.008 -16.25 200.995 -16.25C200.982 -16.25 200.97 -16.25 200.957 -16.25C200.945 -16.25 200.932 -16.25 200.92 -16.25C200.908 -16.25 200.895 -16.25 200.883 -16.25C200.871 -16.25 200.859 -16.25 200.846 -16.25C200.834 -16.25 200.822 -16.25 200.81 -16.25C200.798 -16.25 200.786 -16.25 200.774 -16.25C200.762 -16.25 200.75 -16.25 200.739 -16.25C200.727 -16.25 200.715 -16.25 200.703 -16.25C200.692 -16.25 200.68 -16.25 200.669 -16.25C200.657 -16.25 200.646 -16.25 200.634 -16.25C200.623 -16.25 200.611 -16.25 200.6 -16.25C200.589 -16.25 200.578 -16.25 200.566 -16.25C200.555 -16.25 200.544 -16.25 200.533 -16.25C200.522 -16.25 200.511 -16.25 200.5 -16.25V-14.75Z", fill: "url(#paint2_linear_38_7016)" }),
    /* @__PURE__ */ jsx("path", { d: "M164 82C164 79.7909 165.791 78 168 78C170.209 78 172 79.7909 172 82C172 84.2091 170.209 86 168 86C165.791 86 164 84.2091 164 82ZM238.53 118.97C238.823 119.263 238.823 119.737 238.53 120.03L233.757 124.803C233.464 125.096 232.99 125.096 232.697 124.803C232.404 124.51 232.404 124.036 232.697 123.743L236.939 119.5L232.697 115.257C232.404 114.964 232.404 114.49 232.697 114.197C232.99 113.904 233.464 113.904 233.757 114.197L238.53 118.97ZM168 81.25C168.006 81.25 168.013 81.25 168.019 81.25C168.026 81.25 168.033 81.25 168.039 81.25C168.046 81.25 168.052 81.25 168.059 81.25C168.065 81.25 168.072 81.25 168.079 81.25C168.085 81.25 168.092 81.25 168.099 81.25C168.105 81.25 168.112 81.25 168.119 81.25C168.125 81.25 168.132 81.25 168.139 81.25C168.146 81.25 168.152 81.25 168.159 81.25C168.166 81.25 168.173 81.25 168.18 81.25C168.186 81.25 168.193 81.25 168.2 81.25C168.207 81.25 168.214 81.25 168.221 81.25C168.228 81.25 168.235 81.25 168.242 81.25C168.249 81.25 168.256 81.25 168.263 81.25C168.27 81.25 168.277 81.25 168.284 81.25C168.291 81.25 168.298 81.25 168.305 81.25C168.312 81.25 168.319 81.25 168.326 81.25C168.333 81.25 168.34 81.25 168.347 81.25C168.355 81.25 168.362 81.25 168.369 81.25C168.376 81.25 168.383 81.25 168.391 81.25C168.398 81.25 168.405 81.25 168.412 81.25C168.42 81.25 168.427 81.25 168.434 81.25C168.442 81.25 168.449 81.25 168.456 81.25C168.464 81.25 168.471 81.25 168.478 81.25C168.486 81.25 168.493 81.25 168.501 81.25C168.508 81.25 168.515 81.25 168.523 81.25C168.53 81.25 168.538 81.25 168.545 81.25C168.553 81.25 168.56 81.25 168.568 81.25C168.575 81.25 168.583 81.25 168.591 81.25C168.598 81.25 168.606 81.25 168.613 81.25C168.621 81.25 168.629 81.25 168.636 81.25C168.644 81.25 168.652 81.25 168.659 81.25C168.667 81.25 168.675 81.25 168.683 81.25C168.69 81.25 168.698 81.25 168.706 81.25C168.714 81.25 168.721 81.25 168.729 81.25C168.737 81.25 168.745 81.25 168.753 81.25C168.761 81.25 168.768 81.25 168.776 81.25C168.784 81.25 168.792 81.25 168.8 81.25C168.808 81.25 168.816 81.25 168.824 81.25C168.832 81.25 168.84 81.25 168.848 81.25C168.856 81.25 168.864 81.25 168.872 81.25C168.88 81.25 168.888 81.25 168.896 81.25C168.904 81.25 168.912 81.25 168.92 81.25C168.928 81.25 168.937 81.25 168.945 81.25C168.953 81.25 168.961 81.25 168.969 81.25C168.977 81.25 168.986 81.25 168.994 81.25C169.002 81.25 169.01 81.25 169.019 81.25C169.027 81.25 169.035 81.25 169.043 81.25C169.052 81.25 169.06 81.25 169.068 81.25C169.077 81.25 169.085 81.25 169.093 81.25C169.102 81.25 169.11 81.25 169.119 81.25C169.127 81.25 169.135 81.25 169.144 81.25C169.152 81.25 169.161 81.25 169.169 81.25C169.178 81.25 169.186 81.25 169.195 81.25C169.203 81.25 169.212 81.25 169.22 81.25C169.229 81.25 169.238 81.25 169.246 81.25C169.255 81.25 169.263 81.25 169.272 81.25C169.281 81.25 169.289 81.25 169.298 81.25C169.307 81.25 169.315 81.25 169.324 81.25C169.333 81.25 169.341 81.25 169.35 81.25C169.359 81.25 169.368 81.25 169.376 81.25C169.385 81.25 169.394 81.25 169.403 81.25C169.412 81.25 169.42 81.25 169.429 81.25C169.438 81.25 169.447 81.25 169.456 81.25C169.465 81.25 169.474 81.25 169.483 81.25C169.492 81.25 169.5 81.25 169.509 81.25C169.518 81.25 169.527 81.25 169.536 81.25C169.545 81.25 169.554 81.25 169.563 81.25C169.572 81.25 169.581 81.25 169.59 81.25C169.6 81.25 169.609 81.25 169.618 81.25C169.627 81.25 169.636 81.25 169.645 81.25C169.654 81.25 169.663 81.25 169.672 81.25C169.682 81.25 169.691 81.25 169.7 81.25C169.709 81.25 169.718 81.25 169.728 81.25C169.737 81.25 169.746 81.25 169.755 81.25C169.765 81.25 169.774 81.25 169.783 81.25C169.793 81.25 169.802 81.25 169.811 81.25C169.821 81.25 169.83 81.25 169.839 81.25C169.849 81.25 169.858 81.25 169.867 81.25C169.877 81.25 169.886 81.25 169.896 81.25C169.905 81.25 169.915 81.25 169.924 81.25C169.934 81.25 169.943 81.25 169.953 81.25C169.962 81.25 169.972 81.25 169.981 81.25C169.991 81.25 170 81.25 170.01 81.25C170.019 81.25 170.029 81.25 170.039 81.25C170.048 81.25 170.058 81.25 170.068 81.25C170.077 81.25 170.087 81.25 170.097 81.25C170.106 81.25 170.116 81.25 170.126 81.25C170.135 81.25 170.145 81.25 170.155 81.25C170.165 81.25 170.174 81.25 170.184 81.25C170.194 81.25 170.204 81.25 170.213 81.25C170.223 81.25 170.233 81.25 170.243 81.25C170.253 81.25 170.263 81.25 170.273 81.25C170.282 81.25 170.292 81.25 170.302 81.25C170.312 81.25 170.322 81.25 170.332 81.25C170.342 81.25 170.352 81.25 170.362 81.25C170.372 81.25 170.382 81.25 170.392 81.25C170.402 81.25 170.412 81.25 170.422 81.25C170.432 81.25 170.442 81.25 170.452 81.25C170.462 81.25 170.472 81.25 170.482 81.25C170.493 81.25 170.503 81.25 170.513 81.25C170.523 81.25 170.533 81.25 170.543 81.25C170.553 81.25 170.564 81.25 170.574 81.25C170.584 81.25 170.594 81.25 170.605 81.25C170.615 81.25 170.625 81.25 170.635 81.25C170.646 81.25 170.656 81.25 170.666 81.25C170.676 81.25 170.687 81.25 170.697 81.25C170.707 81.25 170.718 81.25 170.728 81.25C170.739 81.25 170.749 81.25 170.759 81.25C170.77 81.25 170.78 81.25 170.791 81.25C170.801 81.25 170.811 81.25 170.822 81.25C170.832 81.25 170.843 81.25 170.853 81.25C170.864 81.25 170.874 81.25 170.885 81.25C170.895 81.25 170.906 81.25 170.916 81.25C170.927 81.25 170.938 81.25 170.948 81.25C170.959 81.25 170.969 81.25 170.98 81.25C170.991 81.25 171.001 81.25 171.012 81.25C171.023 81.25 171.033 81.25 171.044 81.25C171.055 81.25 171.065 81.25 171.076 81.25C171.087 81.25 171.097 81.25 171.108 81.25C171.119 81.25 171.13 81.25 171.14 81.25C171.151 81.25 171.162 81.25 171.173 81.25C171.184 81.25 171.194 81.25 171.205 81.25C171.216 81.25 171.227 81.25 171.238 81.25C171.249 81.25 171.26 81.25 171.27 81.25C171.281 81.25 171.292 81.25 171.303 81.25C171.314 81.25 171.325 81.25 171.336 81.25C171.347 81.25 171.358 81.25 171.369 81.25C171.38 81.25 171.391 81.25 171.402 81.25C171.413 81.25 171.424 81.25 171.435 81.25C171.446 81.25 171.457 81.25 171.468 81.25C171.479 81.25 171.49 81.25 171.502 81.25C171.513 81.25 171.524 81.25 171.535 81.25C171.546 81.25 171.557 81.25 171.568 81.25C171.58 81.25 171.591 81.25 171.602 81.25C171.613 81.25 171.624 81.25 171.636 81.25C171.647 81.25 171.658 81.25 171.669 81.25C171.681 81.25 171.692 81.25 171.703 81.25C171.714 81.25 171.726 81.25 171.737 81.25C171.748 81.25 171.76 81.25 171.771 81.25C171.782 81.25 171.794 81.25 171.805 81.25C171.816 81.25 171.828 81.25 171.839 81.25C171.851 81.25 171.862 81.25 171.873 81.25C171.885 81.25 171.896 81.25 171.908 81.25C171.919 81.25 171.931 81.25 171.942 81.25C171.954 81.25 171.965 81.25 171.977 81.25C171.988 81.25 172 81.25 172.011 81.25C172.023 81.25 172.034 81.25 172.046 81.25C172.058 81.25 172.069 81.25 172.081 81.25C172.092 81.25 172.104 81.25 172.116 81.25C172.127 81.25 172.139 81.25 172.151 81.25C172.162 81.25 172.174 81.25 172.186 81.25C172.197 81.25 172.209 81.25 172.221 81.25C172.232 81.25 172.244 81.25 172.256 81.25C172.268 81.25 172.279 81.25 172.291 81.25C172.303 81.25 172.315 81.25 172.326 81.25C172.338 81.25 172.35 81.25 172.362 81.25C172.374 81.25 172.386 81.25 172.397 81.25C172.409 81.25 172.421 81.25 172.433 81.25C172.445 81.25 172.457 81.25 172.469 81.25C172.481 81.25 172.493 81.25 172.505 81.25C172.516 81.25 172.528 81.25 172.54 81.25C172.552 81.25 172.564 81.25 172.576 81.25C172.588 81.25 172.6 81.25 172.612 81.25C172.624 81.25 172.636 81.25 172.648 81.25C172.66 81.25 172.673 81.25 172.685 81.25C172.697 81.25 172.709 81.25 172.721 81.25C172.733 81.25 172.745 81.25 172.757 81.25C172.769 81.25 172.781 81.25 172.794 81.25C172.806 81.25 172.818 81.25 172.83 81.25C172.842 81.25 172.854 81.25 172.867 81.25C172.879 81.25 172.891 81.25 172.903 81.25C172.916 81.25 172.928 81.25 172.94 81.25C172.952 81.25 172.965 81.25 172.977 81.25C172.989 81.25 173.002 81.25 173.014 81.25C173.026 81.25 173.038 81.25 173.051 81.25C173.063 81.25 173.075 81.25 173.088 81.25C173.1 81.25 173.113 81.25 173.125 81.25C173.137 81.25 173.15 81.25 173.162 81.25C173.175 81.25 173.187 81.25 173.199 81.25C173.212 81.25 173.224 81.25 173.237 81.25C173.249 81.25 173.262 81.25 173.274 81.25C173.287 81.25 173.299 81.25 173.312 81.25C173.324 81.25 173.337 81.25 173.349 81.25C173.362 81.25 173.374 81.25 173.387 81.25C173.4 81.25 173.412 81.25 173.425 81.25C173.437 81.25 173.45 81.25 173.463 81.25C173.475 81.25 173.488 81.25 173.501 81.25C173.513 81.25 173.526 81.25 173.539 81.25C173.551 81.25 173.564 81.25 173.577 81.25C173.589 81.25 173.602 81.25 173.615 81.25C173.627 81.25 173.64 81.25 173.653 81.25C173.666 81.25 173.678 81.25 173.691 81.25C173.704 81.25 173.717 81.25 173.729 81.25C173.742 81.25 173.755 81.25 173.768 81.25C173.781 81.25 173.794 81.25 173.806 81.25C173.819 81.25 173.832 81.25 173.845 81.25C173.858 81.25 173.871 81.25 173.884 81.25C173.897 81.25 173.909 81.25 173.922 81.25C173.935 81.25 173.948 81.25 173.961 81.25C173.974 81.25 173.987 81.25 174 81.25C174.013 81.25 174.026 81.25 174.039 81.25C174.052 81.25 174.065 81.25 174.078 81.25C174.091 81.25 174.104 81.25 174.117 81.25C174.13 81.25 174.143 81.25 174.156 81.25C174.169 81.25 174.182 81.25 174.195 81.25C174.208 81.25 174.222 81.25 174.235 81.25C174.248 81.25 174.261 81.25 174.274 81.25C174.287 81.25 174.3 81.25 174.313 81.25C174.327 81.25 174.34 81.25 174.353 81.25C174.366 81.25 174.379 81.25 174.392 81.25C174.406 81.25 174.419 81.25 174.432 81.25C174.445 81.25 174.459 81.25 174.472 81.25C174.485 81.25 174.498 81.25 174.512 81.25C174.525 81.25 174.538 81.25 174.551 81.25C174.565 81.25 174.578 81.25 174.591 81.25C174.605 81.25 174.618 81.25 174.631 81.25C174.645 81.25 174.658 81.25 174.671 81.25C174.685 81.25 174.698 81.25 174.711 81.25C174.725 81.25 174.738 81.25 174.752 81.25C174.765 81.25 174.778 81.25 174.792 81.25C174.805 81.25 174.819 81.25 174.832 81.25C174.846 81.25 174.859 81.25 174.873 81.25C174.886 81.25 174.9 81.25 174.913 81.25C174.926 81.25 174.94 81.25 174.954 81.25C174.967 81.25 174.981 81.25 174.994 81.25C175.008 81.25 175.021 81.25 175.035 81.25C175.048 81.25 175.062 81.25 175.075 81.25C175.089 81.25 175.103 81.25 175.116 81.25C175.13 81.25 175.143 81.25 175.157 81.25C175.171 81.25 175.184 81.25 175.198 81.25C175.212 81.25 175.225 81.25 175.239 81.25C175.253 81.25 175.266 81.25 175.28 81.25C175.294 81.25 175.307 81.25 175.321 81.25C175.335 81.25 175.348 81.25 175.362 81.25C175.376 81.25 175.39 81.25 175.403 81.25C175.417 81.25 175.431 81.25 175.445 81.25C175.458 81.25 175.472 81.25 175.486 81.25C175.5 81.25 175.514 81.25 175.527 81.25C175.541 81.25 175.555 81.25 175.569 81.25C175.583 81.25 175.597 81.25 175.61 81.25C175.624 81.25 175.638 81.25 175.652 81.25C175.666 81.25 175.68 81.25 175.694 81.25C175.708 81.25 175.722 81.25 175.735 81.25C175.749 81.25 175.763 81.25 175.777 81.25C175.791 81.25 175.805 81.25 175.819 81.25C175.833 81.25 175.847 81.25 175.861 81.25C175.875 81.25 175.889 81.25 175.903 81.25C175.917 81.25 175.931 81.25 175.945 81.25C175.959 81.25 175.973 81.25 175.987 81.25C176.001 81.25 176.015 81.25 176.029 81.25C176.043 81.25 176.057 81.25 176.071 81.25C176.085 81.25 176.1 81.25 176.114 81.25C176.128 81.25 176.142 81.25 176.156 81.25C176.17 81.25 176.184 81.25 176.198 81.25C176.212 81.25 176.227 81.25 176.241 81.25C176.255 81.25 176.269 81.25 176.283 81.25C176.297 81.25 176.312 81.25 176.326 81.25C176.34 81.25 176.354 81.25 176.368 81.25C176.383 81.25 176.397 81.25 176.411 81.25C176.425 81.25 176.44 81.25 176.454 81.25C176.468 81.25 176.482 81.25 176.497 81.25C176.511 81.25 176.525 81.25 176.539 81.25C176.554 81.25 176.568 81.25 176.582 81.25C176.597 81.25 176.611 81.25 176.625 81.25C176.64 81.25 176.654 81.25 176.668 81.25C176.683 81.25 176.697 81.25 176.711 81.25C176.726 81.25 176.74 81.25 176.754 81.25C176.769 81.25 176.783 81.25 176.798 81.25C176.812 81.25 176.826 81.25 176.841 81.25C176.855 81.25 176.87 81.25 176.884 81.25C176.898 81.25 176.913 81.25 176.927 81.25C176.942 81.25 176.956 81.25 176.971 81.25C176.985 81.25 177 81.25 177.014 81.25C177.029 81.25 177.043 81.25 177.058 81.25C177.072 81.25 177.087 81.25 177.101 81.25C177.116 81.25 177.13 81.25 177.145 81.25C177.159 81.25 177.174 81.25 177.188 81.25C177.203 81.25 177.218 81.25 177.232 81.25C177.247 81.25 177.261 81.25 177.276 81.25C177.29 81.25 177.305 81.25 177.32 81.25C177.334 81.25 177.349 81.25 177.364 81.25C177.378 81.25 177.393 81.25 177.407 81.25C177.422 81.25 177.437 81.25 177.451 81.25C177.466 81.25 177.481 81.25 177.495 81.25C177.51 81.25 177.525 81.25 177.539 81.25C177.554 81.25 177.569 81.25 177.584 81.25C177.598 81.25 177.613 81.25 177.628 81.25C177.642 81.25 177.657 81.25 177.672 81.25C177.687 81.25 177.701 81.25 177.716 81.25C177.731 81.25 177.746 81.25 177.76 81.25C177.775 81.25 177.79 81.25 177.805 81.25C177.82 81.25 177.834 81.25 177.849 81.25C177.864 81.25 177.879 81.25 177.894 81.25C177.909 81.25 177.923 81.25 177.938 81.25C177.953 81.25 177.968 81.25 177.983 81.25C177.998 81.25 178.012 81.25 178.027 81.25C178.042 81.25 178.057 81.25 178.072 81.25C178.087 81.25 178.102 81.25 178.117 81.25C178.132 81.25 178.146 81.25 178.161 81.25C178.176 81.25 178.191 81.25 178.206 81.25C178.221 81.25 178.236 81.25 178.251 81.25C178.266 81.25 178.281 81.25 178.296 81.25C178.311 81.25 178.326 81.25 178.341 81.25C178.356 81.25 178.371 81.25 178.386 81.25C178.401 81.25 178.416 81.25 178.431 81.25C178.446 81.25 178.461 81.25 178.476 81.25C178.491 81.25 178.506 81.25 178.521 81.25C178.536 81.25 178.551 81.25 178.566 81.25C178.581 81.25 178.596 81.25 178.611 81.25C178.626 81.25 178.641 81.25 178.657 81.25C178.672 81.25 178.687 81.25 178.702 81.25C178.717 81.25 178.732 81.25 178.747 81.25C178.762 81.25 178.777 81.25 178.793 81.25C178.808 81.25 178.823 81.25 178.838 81.25C178.853 81.25 178.868 81.25 178.883 81.25C178.899 81.25 178.914 81.25 178.929 81.25C178.944 81.25 178.959 81.25 178.974 81.25C178.99 81.25 179.005 81.25 179.02 81.25C179.035 81.25 179.05 81.25 179.066 81.25C179.081 81.25 179.096 81.25 179.111 81.25C179.126 81.25 179.142 81.25 179.157 81.25C179.172 81.25 179.187 81.25 179.203 81.25C179.218 81.25 179.233 81.25 179.248 81.25C179.264 81.25 179.279 81.25 179.294 81.25C179.31 81.25 179.325 81.25 179.34 81.25C179.355 81.25 179.371 81.25 179.386 81.25C179.401 81.25 179.417 81.25 179.432 81.25C179.447 81.25 179.463 81.25 179.478 81.25C179.493 81.25 179.509 81.25 179.524 81.25C179.539 81.25 179.555 81.25 179.57 81.25C179.585 81.25 179.601 81.25 179.616 81.25C179.632 81.25 179.647 81.25 179.662 81.25C179.678 81.25 179.693 81.25 179.709 81.25C179.724 81.25 179.739 81.25 179.755 81.25C179.77 81.25 179.786 81.25 179.801 81.25C179.816 81.25 179.832 81.25 179.847 81.25C179.863 81.25 179.878 81.25 179.894 81.25C179.909 81.25 179.925 81.25 179.94 81.25C179.955 81.25 179.971 81.25 179.986 81.25C180.002 81.25 180.017 81.25 180.033 81.25C180.048 81.25 180.064 81.25 180.079 81.25C180.095 81.25 180.11 81.25 180.126 81.25C180.141 81.25 180.157 81.25 180.172 81.25C180.188 81.25 180.203 81.25 180.219 81.25C180.234 81.25 180.25 81.25 180.266 81.25C180.281 81.25 180.297 81.25 180.312 81.25C180.328 81.25 180.343 81.25 180.359 81.25C180.374 81.25 180.39 81.25 180.406 81.25C180.421 81.25 180.437 81.25 180.452 81.25C180.468 81.25 180.484 81.25 180.499 81.25C180.515 81.25 180.53 81.25 180.546 81.25C180.562 81.25 180.577 81.25 180.593 81.25C180.608 81.25 180.624 81.25 180.64 81.25C180.655 81.25 180.671 81.25 180.687 81.25C180.702 81.25 180.718 81.25 180.734 81.25C180.749 81.25 180.765 81.25 180.781 81.25C180.796 81.25 180.812 81.25 180.828 81.25C180.843 81.25 180.859 81.25 180.875 81.25C180.89 81.25 180.906 81.25 180.922 81.25C180.937 81.25 180.953 81.25 180.969 81.25C180.985 81.25 181 81.25 181.016 81.25C181.032 81.25 181.047 81.25 181.063 81.25C181.079 81.25 181.095 81.25 181.11 81.25C181.126 81.25 181.142 81.25 181.158 81.25C181.173 81.25 181.189 81.25 181.205 81.25C181.221 81.25 181.236 81.25 181.252 81.25C181.268 81.25 181.284 81.25 181.3 81.25C181.315 81.25 181.331 81.25 181.347 81.25C181.363 81.25 181.378 81.25 181.394 81.25C181.41 81.25 181.426 81.25 181.442 81.25C181.457 81.25 181.473 81.25 181.489 81.25C181.505 81.25 181.521 81.25 181.537 81.25C181.552 81.25 181.568 81.25 181.584 81.25C181.6 81.25 181.616 81.25 181.632 81.25C181.647 81.25 181.663 81.25 181.679 81.25C181.695 81.25 181.711 81.25 181.727 81.25C181.743 81.25 181.758 81.25 181.774 81.25C181.79 81.25 181.806 81.25 181.822 81.25C181.838 81.25 181.854 81.25 181.87 81.25C181.886 81.25 181.901 81.25 181.917 81.25C181.933 81.25 181.949 81.25 181.965 81.25C181.981 81.25 181.997 81.25 182.013 81.25C182.029 81.25 182.045 81.25 182.061 81.25C182.076 81.25 182.092 81.25 182.108 81.25C182.124 81.25 182.14 81.25 182.156 81.25C182.172 81.25 182.188 81.25 182.204 81.25C182.22 81.25 182.236 81.25 182.252 81.25C182.268 81.25 182.284 81.25 182.3 81.25C182.316 81.25 182.332 81.25 182.348 81.25C182.364 81.25 182.38 81.25 182.396 81.25C182.412 81.25 182.428 81.25 182.444 81.25C182.46 81.25 182.476 81.25 182.492 81.25C182.508 81.25 182.524 81.25 182.54 81.25C182.556 81.25 182.572 81.25 182.588 81.25C182.604 81.25 182.62 81.25 182.636 81.25C182.652 81.25 182.668 81.25 182.684 81.25C182.7 81.25 182.716 81.25 182.732 81.25C182.748 81.25 182.764 81.25 182.78 81.25C182.796 81.25 182.812 81.25 182.828 81.25C182.844 81.25 182.86 81.25 182.876 81.25C182.892 81.25 182.908 81.25 182.924 81.25C182.94 81.25 182.956 81.25 182.973 81.25C182.989 81.25 183.005 81.25 183.021 81.25C183.037 81.25 183.053 81.25 183.069 81.25C183.085 81.25 183.101 81.25 183.117 81.25C183.133 81.25 183.149 81.25 183.166 81.25C183.182 81.25 183.198 81.25 183.214 81.25C183.23 81.25 183.246 81.25 183.262 81.25C183.278 81.25 183.294 81.25 183.311 81.25C183.327 81.25 183.343 81.25 183.359 81.25C183.375 81.25 183.391 81.25 183.407 81.25C183.423 81.25 183.439 81.25 183.456 81.25C183.472 81.25 183.488 81.25 183.504 81.25C183.52 81.25 183.536 81.25 183.552 81.25C183.569 81.25 183.585 81.25 183.601 81.25C183.617 81.25 183.633 81.25 183.649 81.25C183.666 81.25 183.682 81.25 183.698 81.25C183.714 81.25 183.73 81.25 183.746 81.25C183.763 81.25 183.779 81.25 183.795 81.25C183.811 81.25 183.827 81.25 183.843 81.25C183.86 81.25 183.876 81.25 183.892 81.25C183.908 81.25 183.924 81.25 183.94 81.25C183.957 81.25 183.973 81.25 183.989 81.25C184.005 81.25 184.021 81.25 184.038 81.25C184.054 81.25 184.07 81.25 184.086 81.25C184.102 81.25 184.119 81.25 184.135 81.25C184.151 81.25 184.167 81.25 184.183 81.25C184.2 81.25 184.216 81.25 184.232 81.25C184.248 81.25 184.265 81.25 184.281 81.25C184.297 81.25 184.313 81.25 184.329 81.25C184.346 81.25 184.362 81.25 184.378 81.25C184.394 81.25 184.411 81.25 184.427 81.25C184.443 81.25 184.459 81.25 184.476 81.25C184.492 81.25 184.508 81.25 184.524 81.25C184.541 81.25 184.557 81.25 184.573 81.25C184.589 81.25 184.605 81.25 184.622 81.25C184.638 81.25 184.654 81.25 184.671 81.25C184.687 81.25 184.703 81.25 184.719 81.25C184.736 81.25 184.752 81.25 184.768 81.25C184.784 81.25 184.801 81.25 184.817 81.25C184.833 81.25 184.849 81.25 184.866 81.25C184.882 81.25 184.898 81.25 184.914 81.25C184.931 81.25 184.947 81.25 184.963 81.25C184.98 81.25 184.996 81.25 185.012 81.25C185.028 81.25 185.045 81.25 185.061 81.25C185.077 81.25 185.094 81.25 185.11 81.25C185.126 81.25 185.142 81.25 185.159 81.25C185.175 81.25 185.191 81.25 185.208 81.25C185.224 81.25 185.24 81.25 185.256 81.25C185.273 81.25 185.289 81.25 185.305 81.25C185.322 81.25 185.338 81.25 185.354 81.25C185.371 81.25 185.387 81.25 185.403 81.25C185.419 81.25 185.436 81.25 185.452 81.25C185.468 81.25 185.485 81.25 185.501 81.25C185.517 81.25 185.534 81.25 185.55 81.25C185.566 81.25 185.582 81.25 185.599 81.25C185.615 81.25 185.631 81.25 185.648 81.25C185.664 81.25 185.68 81.25 185.697 81.25C185.713 81.25 185.729 81.25 185.746 81.25C185.762 81.25 185.778 81.25 185.795 81.25C185.811 81.25 185.827 81.25 185.844 81.25C185.86 81.25 185.876 81.25 185.893 81.25C185.909 81.25 185.925 81.25 185.941 81.25C185.958 81.25 185.974 81.25 185.99 81.25C186.007 81.25 186.023 81.25 186.039 81.25C186.056 81.25 186.072 81.25 186.088 81.25C186.105 81.25 186.121 81.25 186.137 81.25C186.154 81.25 186.17 81.25 186.186 81.25C186.203 81.25 186.219 81.25 186.235 81.25C186.252 81.25 186.268 81.25 186.284 81.25C186.301 81.25 186.317 81.25 186.333 81.25C186.35 81.25 186.366 81.25 186.382 81.25C186.399 81.25 186.415 81.25 186.431 81.25C186.448 81.25 186.464 81.25 186.48 81.25C186.497 81.25 186.513 81.25 186.529 81.25C186.546 81.25 186.562 81.25 186.578 81.25C186.595 81.25 186.611 81.25 186.627 81.25C186.644 81.25 186.66 81.25 186.676 81.25C186.693 81.25 186.709 81.25 186.726 81.25C186.742 81.25 186.758 81.25 186.775 81.25C186.791 81.25 186.807 81.25 186.824 81.25C186.84 81.25 186.856 81.25 186.873 81.25C186.889 81.25 186.905 81.25 186.922 81.25C186.938 81.25 186.954 81.25 186.971 81.25C186.987 81.25 187.003 81.25 187.02 81.25C187.036 81.25 187.052 81.25 187.069 81.25C187.085 81.25 187.101 81.25 187.118 81.25C187.134 81.25 187.15 81.25 187.167 81.25C187.183 81.25 187.199 81.25 187.216 81.25C187.232 81.25 187.248 81.25 187.265 81.25C187.281 81.25 187.297 81.25 187.314 81.25C187.33 81.25 187.346 81.25 187.363 81.25C187.379 81.25 187.395 81.25 187.412 81.25C187.428 81.25 187.444 81.25 187.461 81.25C187.477 81.25 187.493 81.25 187.51 81.25C187.526 81.25 187.542 81.25 187.559 81.25C187.575 81.25 187.591 81.25 187.608 81.25C187.624 81.25 187.64 81.25 187.657 81.25C187.673 81.25 187.689 81.25 187.706 81.25C187.722 81.25 187.738 81.25 187.755 81.25C187.771 81.25 187.787 81.25 187.804 81.25C187.82 81.25 187.836 81.25 187.853 81.25C187.869 81.25 187.885 81.25 187.902 81.25C187.918 81.25 187.934 81.25 187.95 81.25C187.967 81.25 187.983 81.25 187.999 81.25C188.016 81.25 188.032 81.25 188.048 81.25C188.065 81.25 188.081 81.25 188.097 81.25C188.114 81.25 188.13 81.25 188.146 81.25C188.163 81.25 188.179 81.25 188.195 81.25C188.212 81.25 188.228 81.25 188.244 81.25C188.26 81.25 188.277 81.25 188.293 81.25C188.309 81.25 188.326 81.25 188.342 81.25V82.75C188.326 82.75 188.309 82.75 188.293 82.75C188.277 82.75 188.26 82.75 188.244 82.75C188.228 82.75 188.212 82.75 188.195 82.75C188.179 82.75 188.163 82.75 188.146 82.75C188.13 82.75 188.114 82.75 188.097 82.75C188.081 82.75 188.065 82.75 188.048 82.75C188.032 82.75 188.016 82.75 187.999 82.75C187.983 82.75 187.967 82.75 187.95 82.75C187.934 82.75 187.918 82.75 187.902 82.75C187.885 82.75 187.869 82.75 187.853 82.75C187.836 82.75 187.82 82.75 187.804 82.75C187.787 82.75 187.771 82.75 187.755 82.75C187.738 82.75 187.722 82.75 187.706 82.75C187.689 82.75 187.673 82.75 187.657 82.75C187.64 82.75 187.624 82.75 187.608 82.75C187.591 82.75 187.575 82.75 187.559 82.75C187.542 82.75 187.526 82.75 187.51 82.75C187.493 82.75 187.477 82.75 187.461 82.75C187.444 82.75 187.428 82.75 187.412 82.75C187.395 82.75 187.379 82.75 187.363 82.75C187.346 82.75 187.33 82.75 187.314 82.75C187.297 82.75 187.281 82.75 187.265 82.75C187.248 82.75 187.232 82.75 187.216 82.75C187.199 82.75 187.183 82.75 187.167 82.75C187.15 82.75 187.134 82.75 187.118 82.75C187.101 82.75 187.085 82.75 187.069 82.75C187.052 82.75 187.036 82.75 187.02 82.75C187.003 82.75 186.987 82.75 186.971 82.75C186.954 82.75 186.938 82.75 186.922 82.75C186.905 82.75 186.889 82.75 186.873 82.75C186.856 82.75 186.84 82.75 186.824 82.75C186.807 82.75 186.791 82.75 186.775 82.75C186.758 82.75 186.742 82.75 186.726 82.75C186.709 82.75 186.693 82.75 186.676 82.75C186.66 82.75 186.644 82.75 186.627 82.75C186.611 82.75 186.595 82.75 186.578 82.75C186.562 82.75 186.546 82.75 186.529 82.75C186.513 82.75 186.497 82.75 186.48 82.75C186.464 82.75 186.448 82.75 186.431 82.75C186.415 82.75 186.399 82.75 186.382 82.75C186.366 82.75 186.35 82.75 186.333 82.75C186.317 82.75 186.301 82.75 186.284 82.75C186.268 82.75 186.252 82.75 186.235 82.75C186.219 82.75 186.203 82.75 186.186 82.75C186.17 82.75 186.154 82.75 186.137 82.75C186.121 82.75 186.105 82.75 186.088 82.75C186.072 82.75 186.056 82.75 186.039 82.75C186.023 82.75 186.007 82.75 185.99 82.75C185.974 82.75 185.958 82.75 185.941 82.75C185.925 82.75 185.909 82.75 185.893 82.75C185.876 82.75 185.86 82.75 185.844 82.75C185.827 82.75 185.811 82.75 185.795 82.75C185.778 82.75 185.762 82.75 185.746 82.75C185.729 82.75 185.713 82.75 185.697 82.75C185.68 82.75 185.664 82.75 185.648 82.75C185.631 82.75 185.615 82.75 185.599 82.75C185.582 82.75 185.566 82.75 185.55 82.75C185.534 82.75 185.517 82.75 185.501 82.75C185.485 82.75 185.468 82.75 185.452 82.75C185.436 82.75 185.419 82.75 185.403 82.75C185.387 82.75 185.371 82.75 185.354 82.75C185.338 82.75 185.322 82.75 185.305 82.75C185.289 82.75 185.273 82.75 185.256 82.75C185.24 82.75 185.224 82.75 185.208 82.75C185.191 82.75 185.175 82.75 185.159 82.75C185.142 82.75 185.126 82.75 185.11 82.75C185.094 82.75 185.077 82.75 185.061 82.75C185.045 82.75 185.028 82.75 185.012 82.75C184.996 82.75 184.98 82.75 184.963 82.75C184.947 82.75 184.931 82.75 184.914 82.75C184.898 82.75 184.882 82.75 184.866 82.75C184.849 82.75 184.833 82.75 184.817 82.75C184.801 82.75 184.784 82.75 184.768 82.75C184.752 82.75 184.736 82.75 184.719 82.75C184.703 82.75 184.687 82.75 184.671 82.75C184.654 82.75 184.638 82.75 184.622 82.75C184.605 82.75 184.589 82.75 184.573 82.75C184.557 82.75 184.541 82.75 184.524 82.75C184.508 82.75 184.492 82.75 184.476 82.75C184.459 82.75 184.443 82.75 184.427 82.75C184.411 82.75 184.394 82.75 184.378 82.75C184.362 82.75 184.346 82.75 184.329 82.75C184.313 82.75 184.297 82.75 184.281 82.75C184.265 82.75 184.248 82.75 184.232 82.75C184.216 82.75 184.2 82.75 184.183 82.75C184.167 82.75 184.151 82.75 184.135 82.75C184.119 82.75 184.102 82.75 184.086 82.75C184.07 82.75 184.054 82.75 184.038 82.75C184.021 82.75 184.005 82.75 183.989 82.75C183.973 82.75 183.957 82.75 183.94 82.75C183.924 82.75 183.908 82.75 183.892 82.75C183.876 82.75 183.86 82.75 183.843 82.75C183.827 82.75 183.811 82.75 183.795 82.75C183.779 82.75 183.763 82.75 183.746 82.75C183.73 82.75 183.714 82.75 183.698 82.75C183.682 82.75 183.666 82.75 183.649 82.75C183.633 82.75 183.617 82.75 183.601 82.75C183.585 82.75 183.569 82.75 183.552 82.75C183.536 82.75 183.52 82.75 183.504 82.75C183.488 82.75 183.472 82.75 183.456 82.75C183.439 82.75 183.423 82.75 183.407 82.75C183.391 82.75 183.375 82.75 183.359 82.75C183.343 82.75 183.327 82.75 183.311 82.75C183.294 82.75 183.278 82.75 183.262 82.75C183.246 82.75 183.23 82.75 183.214 82.75C183.198 82.75 183.182 82.75 183.166 82.75C183.149 82.75 183.133 82.75 183.117 82.75C183.101 82.75 183.085 82.75 183.069 82.75C183.053 82.75 183.037 82.75 183.021 82.75C183.005 82.75 182.989 82.75 182.973 82.75C182.956 82.75 182.94 82.75 182.924 82.75C182.908 82.75 182.892 82.75 182.876 82.75C182.86 82.75 182.844 82.75 182.828 82.75C182.812 82.75 182.796 82.75 182.78 82.75C182.764 82.75 182.748 82.75 182.732 82.75C182.716 82.75 182.7 82.75 182.684 82.75C182.668 82.75 182.652 82.75 182.636 82.75C182.62 82.75 182.604 82.75 182.588 82.75C182.572 82.75 182.556 82.75 182.54 82.75C182.524 82.75 182.508 82.75 182.492 82.75C182.476 82.75 182.46 82.75 182.444 82.75C182.428 82.75 182.412 82.75 182.396 82.75C182.38 82.75 182.364 82.75 182.348 82.75C182.332 82.75 182.316 82.75 182.3 82.75C182.284 82.75 182.268 82.75 182.252 82.75C182.236 82.75 182.22 82.75 182.204 82.75C182.188 82.75 182.172 82.75 182.156 82.75C182.14 82.75 182.124 82.75 182.108 82.75C182.092 82.75 182.076 82.75 182.061 82.75C182.045 82.75 182.029 82.75 182.013 82.75C181.997 82.75 181.981 82.75 181.965 82.75C181.949 82.75 181.933 82.75 181.917 82.75C181.901 82.75 181.886 82.75 181.87 82.75C181.854 82.75 181.838 82.75 181.822 82.75C181.806 82.75 181.79 82.75 181.774 82.75C181.758 82.75 181.743 82.75 181.727 82.75C181.711 82.75 181.695 82.75 181.679 82.75C181.663 82.75 181.647 82.75 181.632 82.75C181.616 82.75 181.6 82.75 181.584 82.75C181.568 82.75 181.552 82.75 181.537 82.75C181.521 82.75 181.505 82.75 181.489 82.75C181.473 82.75 181.457 82.75 181.442 82.75C181.426 82.75 181.41 82.75 181.394 82.75C181.378 82.75 181.363 82.75 181.347 82.75C181.331 82.75 181.315 82.75 181.3 82.75C181.284 82.75 181.268 82.75 181.252 82.75C181.236 82.75 181.221 82.75 181.205 82.75C181.189 82.75 181.173 82.75 181.158 82.75C181.142 82.75 181.126 82.75 181.11 82.75C181.095 82.75 181.079 82.75 181.063 82.75C181.047 82.75 181.032 82.75 181.016 82.75C181 82.75 180.985 82.75 180.969 82.75C180.953 82.75 180.937 82.75 180.922 82.75C180.906 82.75 180.89 82.75 180.875 82.75C180.859 82.75 180.843 82.75 180.828 82.75C180.812 82.75 180.796 82.75 180.781 82.75C180.765 82.75 180.749 82.75 180.734 82.75C180.718 82.75 180.702 82.75 180.687 82.75C180.671 82.75 180.655 82.75 180.64 82.75C180.624 82.75 180.608 82.75 180.593 82.75C180.577 82.75 180.562 82.75 180.546 82.75C180.53 82.75 180.515 82.75 180.499 82.75C180.484 82.75 180.468 82.75 180.452 82.75C180.437 82.75 180.421 82.75 180.406 82.75C180.39 82.75 180.374 82.75 180.359 82.75C180.343 82.75 180.328 82.75 180.312 82.75C180.297 82.75 180.281 82.75 180.266 82.75C180.25 82.75 180.234 82.75 180.219 82.75C180.203 82.75 180.188 82.75 180.172 82.75C180.157 82.75 180.141 82.75 180.126 82.75C180.11 82.75 180.095 82.75 180.079 82.75C180.064 82.75 180.048 82.75 180.033 82.75C180.017 82.75 180.002 82.75 179.986 82.75C179.971 82.75 179.955 82.75 179.94 82.75C179.925 82.75 179.909 82.75 179.894 82.75C179.878 82.75 179.863 82.75 179.847 82.75C179.832 82.75 179.816 82.75 179.801 82.75C179.786 82.75 179.77 82.75 179.755 82.75C179.739 82.75 179.724 82.75 179.709 82.75C179.693 82.75 179.678 82.75 179.662 82.75C179.647 82.75 179.632 82.75 179.616 82.75C179.601 82.75 179.585 82.75 179.57 82.75C179.555 82.75 179.539 82.75 179.524 82.75C179.509 82.75 179.493 82.75 179.478 82.75C179.463 82.75 179.447 82.75 179.432 82.75C179.417 82.75 179.401 82.75 179.386 82.75C179.371 82.75 179.355 82.75 179.34 82.75C179.325 82.75 179.31 82.75 179.294 82.75C179.279 82.75 179.264 82.75 179.248 82.75C179.233 82.75 179.218 82.75 179.203 82.75C179.187 82.75 179.172 82.75 179.157 82.75C179.142 82.75 179.126 82.75 179.111 82.75C179.096 82.75 179.081 82.75 179.066 82.75C179.05 82.75 179.035 82.75 179.02 82.75C179.005 82.75 178.99 82.75 178.974 82.75C178.959 82.75 178.944 82.75 178.929 82.75C178.914 82.75 178.899 82.75 178.883 82.75C178.868 82.75 178.853 82.75 178.838 82.75C178.823 82.75 178.808 82.75 178.793 82.75C178.777 82.75 178.762 82.75 178.747 82.75C178.732 82.75 178.717 82.75 178.702 82.75C178.687 82.75 178.672 82.75 178.657 82.75C178.641 82.75 178.626 82.75 178.611 82.75C178.596 82.75 178.581 82.75 178.566 82.75C178.551 82.75 178.536 82.75 178.521 82.75C178.506 82.75 178.491 82.75 178.476 82.75C178.461 82.75 178.446 82.75 178.431 82.75C178.416 82.75 178.401 82.75 178.386 82.75C178.371 82.75 178.356 82.75 178.341 82.75C178.326 82.75 178.311 82.75 178.296 82.75C178.281 82.75 178.266 82.75 178.251 82.75C178.236 82.75 178.221 82.75 178.206 82.75C178.191 82.75 178.176 82.75 178.161 82.75C178.146 82.75 178.132 82.75 178.117 82.75C178.102 82.75 178.087 82.75 178.072 82.75C178.057 82.75 178.042 82.75 178.027 82.75C178.012 82.75 177.998 82.75 177.983 82.75C177.968 82.75 177.953 82.75 177.938 82.75C177.923 82.75 177.909 82.75 177.894 82.75C177.879 82.75 177.864 82.75 177.849 82.75C177.834 82.75 177.82 82.75 177.805 82.75C177.79 82.75 177.775 82.75 177.76 82.75C177.746 82.75 177.731 82.75 177.716 82.75C177.701 82.75 177.687 82.75 177.672 82.75C177.657 82.75 177.642 82.75 177.628 82.75C177.613 82.75 177.598 82.75 177.584 82.75C177.569 82.75 177.554 82.75 177.539 82.75C177.525 82.75 177.51 82.75 177.495 82.75C177.481 82.75 177.466 82.75 177.451 82.75C177.437 82.75 177.422 82.75 177.407 82.75C177.393 82.75 177.378 82.75 177.364 82.75C177.349 82.75 177.334 82.75 177.32 82.75C177.305 82.75 177.29 82.75 177.276 82.75C177.261 82.75 177.247 82.75 177.232 82.75C177.218 82.75 177.203 82.75 177.188 82.75C177.174 82.75 177.159 82.75 177.145 82.75C177.13 82.75 177.116 82.75 177.101 82.75C177.087 82.75 177.072 82.75 177.058 82.75C177.043 82.75 177.029 82.75 177.014 82.75C177 82.75 176.985 82.75 176.971 82.75C176.956 82.75 176.942 82.75 176.927 82.75C176.913 82.75 176.898 82.75 176.884 82.75C176.87 82.75 176.855 82.75 176.841 82.75C176.826 82.75 176.812 82.75 176.798 82.75C176.783 82.75 176.769 82.75 176.754 82.75C176.74 82.75 176.726 82.75 176.711 82.75C176.697 82.75 176.683 82.75 176.668 82.75C176.654 82.75 176.64 82.75 176.625 82.75C176.611 82.75 176.597 82.75 176.582 82.75C176.568 82.75 176.554 82.75 176.539 82.75C176.525 82.75 176.511 82.75 176.497 82.75C176.482 82.75 176.468 82.75 176.454 82.75C176.44 82.75 176.425 82.75 176.411 82.75C176.397 82.75 176.383 82.75 176.368 82.75C176.354 82.75 176.34 82.75 176.326 82.75C176.312 82.75 176.297 82.75 176.283 82.75C176.269 82.75 176.255 82.75 176.241 82.75C176.227 82.75 176.212 82.75 176.198 82.75C176.184 82.75 176.17 82.75 176.156 82.75C176.142 82.75 176.128 82.75 176.114 82.75C176.1 82.75 176.085 82.75 176.071 82.75C176.057 82.75 176.043 82.75 176.029 82.75C176.015 82.75 176.001 82.75 175.987 82.75C175.973 82.75 175.959 82.75 175.945 82.75C175.931 82.75 175.917 82.75 175.903 82.75C175.889 82.75 175.875 82.75 175.861 82.75C175.847 82.75 175.833 82.75 175.819 82.75C175.805 82.75 175.791 82.75 175.777 82.75C175.763 82.75 175.749 82.75 175.735 82.75C175.722 82.75 175.708 82.75 175.694 82.75C175.68 82.75 175.666 82.75 175.652 82.75C175.638 82.75 175.624 82.75 175.61 82.75C175.597 82.75 175.583 82.75 175.569 82.75C175.555 82.75 175.541 82.75 175.527 82.75C175.514 82.75 175.5 82.75 175.486 82.75C175.472 82.75 175.458 82.75 175.445 82.75C175.431 82.75 175.417 82.75 175.403 82.75C175.39 82.75 175.376 82.75 175.362 82.75C175.348 82.75 175.335 82.75 175.321 82.75C175.307 82.75 175.294 82.75 175.28 82.75C175.266 82.75 175.253 82.75 175.239 82.75C175.225 82.75 175.212 82.75 175.198 82.75C175.184 82.75 175.171 82.75 175.157 82.75C175.143 82.75 175.13 82.75 175.116 82.75C175.103 82.75 175.089 82.75 175.075 82.75C175.062 82.75 175.048 82.75 175.035 82.75C175.021 82.75 175.008 82.75 174.994 82.75C174.981 82.75 174.967 82.75 174.954 82.75C174.94 82.75 174.926 82.75 174.913 82.75C174.9 82.75 174.886 82.75 174.873 82.75C174.859 82.75 174.846 82.75 174.832 82.75C174.819 82.75 174.805 82.75 174.792 82.75C174.778 82.75 174.765 82.75 174.752 82.75C174.738 82.75 174.725 82.75 174.711 82.75C174.698 82.75 174.685 82.75 174.671 82.75C174.658 82.75 174.645 82.75 174.631 82.75C174.618 82.75 174.605 82.75 174.591 82.75C174.578 82.75 174.565 82.75 174.551 82.75C174.538 82.75 174.525 82.75 174.512 82.75C174.498 82.75 174.485 82.75 174.472 82.75C174.459 82.75 174.445 82.75 174.432 82.75C174.419 82.75 174.406 82.75 174.392 82.75C174.379 82.75 174.366 82.75 174.353 82.75C174.34 82.75 174.327 82.75 174.313 82.75C174.3 82.75 174.287 82.75 174.274 82.75C174.261 82.75 174.248 82.75 174.235 82.75C174.222 82.75 174.208 82.75 174.195 82.75C174.182 82.75 174.169 82.75 174.156 82.75C174.143 82.75 174.13 82.75 174.117 82.75C174.104 82.75 174.091 82.75 174.078 82.75C174.065 82.75 174.052 82.75 174.039 82.75C174.026 82.75 174.013 82.75 174 82.75C173.987 82.75 173.974 82.75 173.961 82.75C173.948 82.75 173.935 82.75 173.922 82.75C173.909 82.75 173.897 82.75 173.884 82.75C173.871 82.75 173.858 82.75 173.845 82.75C173.832 82.75 173.819 82.75 173.806 82.75C173.794 82.75 173.781 82.75 173.768 82.75C173.755 82.75 173.742 82.75 173.729 82.75C173.717 82.75 173.704 82.75 173.691 82.75C173.678 82.75 173.666 82.75 173.653 82.75C173.64 82.75 173.627 82.75 173.615 82.75C173.602 82.75 173.589 82.75 173.577 82.75C173.564 82.75 173.551 82.75 173.539 82.75C173.526 82.75 173.513 82.75 173.501 82.75C173.488 82.75 173.475 82.75 173.463 82.75C173.45 82.75 173.437 82.75 173.425 82.75C173.412 82.75 173.4 82.75 173.387 82.75C173.374 82.75 173.362 82.75 173.349 82.75C173.337 82.75 173.324 82.75 173.312 82.75C173.299 82.75 173.287 82.75 173.274 82.75C173.262 82.75 173.249 82.75 173.237 82.75C173.224 82.75 173.212 82.75 173.199 82.75C173.187 82.75 173.175 82.75 173.162 82.75C173.15 82.75 173.137 82.75 173.125 82.75C173.113 82.75 173.1 82.75 173.088 82.75C173.075 82.75 173.063 82.75 173.051 82.75C173.038 82.75 173.026 82.75 173.014 82.75C173.002 82.75 172.989 82.75 172.977 82.75C172.965 82.75 172.952 82.75 172.94 82.75C172.928 82.75 172.916 82.75 172.903 82.75C172.891 82.75 172.879 82.75 172.867 82.75C172.854 82.75 172.842 82.75 172.83 82.75C172.818 82.75 172.806 82.75 172.794 82.75C172.781 82.75 172.769 82.75 172.757 82.75C172.745 82.75 172.733 82.75 172.721 82.75C172.709 82.75 172.697 82.75 172.685 82.75C172.673 82.75 172.66 82.75 172.648 82.75C172.636 82.75 172.624 82.75 172.612 82.75C172.6 82.75 172.588 82.75 172.576 82.75C172.564 82.75 172.552 82.75 172.54 82.75C172.528 82.75 172.516 82.75 172.505 82.75C172.493 82.75 172.481 82.75 172.469 82.75C172.457 82.75 172.445 82.75 172.433 82.75C172.421 82.75 172.409 82.75 172.397 82.75C172.386 82.75 172.374 82.75 172.362 82.75C172.35 82.75 172.338 82.75 172.326 82.75C172.315 82.75 172.303 82.75 172.291 82.75C172.279 82.75 172.268 82.75 172.256 82.75C172.244 82.75 172.232 82.75 172.221 82.75C172.209 82.75 172.197 82.75 172.186 82.75C172.174 82.75 172.162 82.75 172.151 82.75C172.139 82.75 172.127 82.75 172.116 82.75C172.104 82.75 172.092 82.75 172.081 82.75C172.069 82.75 172.058 82.75 172.046 82.75C172.034 82.75 172.023 82.75 172.011 82.75C172 82.75 171.988 82.75 171.977 82.75C171.965 82.75 171.954 82.75 171.942 82.75C171.931 82.75 171.919 82.75 171.908 82.75C171.896 82.75 171.885 82.75 171.873 82.75C171.862 82.75 171.851 82.75 171.839 82.75C171.828 82.75 171.816 82.75 171.805 82.75C171.794 82.75 171.782 82.75 171.771 82.75C171.76 82.75 171.748 82.75 171.737 82.75C171.726 82.75 171.714 82.75 171.703 82.75C171.692 82.75 171.681 82.75 171.669 82.75C171.658 82.75 171.647 82.75 171.636 82.75C171.624 82.75 171.613 82.75 171.602 82.75C171.591 82.75 171.58 82.75 171.568 82.75C171.557 82.75 171.546 82.75 171.535 82.75C171.524 82.75 171.513 82.75 171.502 82.75C171.49 82.75 171.479 82.75 171.468 82.75C171.457 82.75 171.446 82.75 171.435 82.75C171.424 82.75 171.413 82.75 171.402 82.75C171.391 82.75 171.38 82.75 171.369 82.75C171.358 82.75 171.347 82.75 171.336 82.75C171.325 82.75 171.314 82.75 171.303 82.75C171.292 82.75 171.281 82.75 171.27 82.75C171.26 82.75 171.249 82.75 171.238 82.75C171.227 82.75 171.216 82.75 171.205 82.75C171.194 82.75 171.184 82.75 171.173 82.75C171.162 82.75 171.151 82.75 171.14 82.75C171.13 82.75 171.119 82.75 171.108 82.75C171.097 82.75 171.087 82.75 171.076 82.75C171.065 82.75 171.055 82.75 171.044 82.75C171.033 82.75 171.023 82.75 171.012 82.75C171.001 82.75 170.991 82.75 170.98 82.75C170.969 82.75 170.959 82.75 170.948 82.75C170.938 82.75 170.927 82.75 170.916 82.75C170.906 82.75 170.895 82.75 170.885 82.75C170.874 82.75 170.864 82.75 170.853 82.75C170.843 82.75 170.832 82.75 170.822 82.75C170.811 82.75 170.801 82.75 170.791 82.75C170.78 82.75 170.77 82.75 170.759 82.75C170.749 82.75 170.739 82.75 170.728 82.75C170.718 82.75 170.707 82.75 170.697 82.75C170.687 82.75 170.676 82.75 170.666 82.75C170.656 82.75 170.646 82.75 170.635 82.75C170.625 82.75 170.615 82.75 170.605 82.75C170.594 82.75 170.584 82.75 170.574 82.75C170.564 82.75 170.553 82.75 170.543 82.75C170.533 82.75 170.523 82.75 170.513 82.75C170.503 82.75 170.493 82.75 170.482 82.75C170.472 82.75 170.462 82.75 170.452 82.75C170.442 82.75 170.432 82.75 170.422 82.75C170.412 82.75 170.402 82.75 170.392 82.75C170.382 82.75 170.372 82.75 170.362 82.75C170.352 82.75 170.342 82.75 170.332 82.75C170.322 82.75 170.312 82.75 170.302 82.75C170.292 82.75 170.282 82.75 170.273 82.75C170.263 82.75 170.253 82.75 170.243 82.75C170.233 82.75 170.223 82.75 170.213 82.75C170.204 82.75 170.194 82.75 170.184 82.75C170.174 82.75 170.165 82.75 170.155 82.75C170.145 82.75 170.135 82.75 170.126 82.75C170.116 82.75 170.106 82.75 170.097 82.75C170.087 82.75 170.077 82.75 170.068 82.75C170.058 82.75 170.048 82.75 170.039 82.75C170.029 82.75 170.019 82.75 170.01 82.75C170 82.75 169.991 82.75 169.981 82.75C169.972 82.75 169.962 82.75 169.953 82.75C169.943 82.75 169.934 82.75 169.924 82.75C169.915 82.75 169.905 82.75 169.896 82.75C169.886 82.75 169.877 82.75 169.867 82.75C169.858 82.75 169.849 82.75 169.839 82.75C169.83 82.75 169.821 82.75 169.811 82.75C169.802 82.75 169.793 82.75 169.783 82.75C169.774 82.75 169.765 82.75 169.755 82.75C169.746 82.75 169.737 82.75 169.728 82.75C169.718 82.75 169.709 82.75 169.7 82.75C169.691 82.75 169.682 82.75 169.672 82.75C169.663 82.75 169.654 82.75 169.645 82.75C169.636 82.75 169.627 82.75 169.618 82.75C169.609 82.75 169.6 82.75 169.59 82.75C169.581 82.75 169.572 82.75 169.563 82.75C169.554 82.75 169.545 82.75 169.536 82.75C169.527 82.75 169.518 82.75 169.509 82.75C169.5 82.75 169.492 82.75 169.483 82.75C169.474 82.75 169.465 82.75 169.456 82.75C169.447 82.75 169.438 82.75 169.429 82.75C169.42 82.75 169.412 82.75 169.403 82.75C169.394 82.75 169.385 82.75 169.376 82.75C169.368 82.75 169.359 82.75 169.35 82.75C169.341 82.75 169.333 82.75 169.324 82.75C169.315 82.75 169.307 82.75 169.298 82.75C169.289 82.75 169.281 82.75 169.272 82.75C169.263 82.75 169.255 82.75 169.246 82.75C169.238 82.75 169.229 82.75 169.22 82.75C169.212 82.75 169.203 82.75 169.195 82.75C169.186 82.75 169.178 82.75 169.169 82.75C169.161 82.75 169.152 82.75 169.144 82.75C169.135 82.75 169.127 82.75 169.119 82.75C169.11 82.75 169.102 82.75 169.093 82.75C169.085 82.75 169.077 82.75 169.068 82.75C169.06 82.75 169.052 82.75 169.043 82.75C169.035 82.75 169.027 82.75 169.019 82.75C169.01 82.75 169.002 82.75 168.994 82.75C168.986 82.75 168.977 82.75 168.969 82.75C168.961 82.75 168.953 82.75 168.945 82.75C168.937 82.75 168.928 82.75 168.92 82.75C168.912 82.75 168.904 82.75 168.896 82.75C168.888 82.75 168.88 82.75 168.872 82.75C168.864 82.75 168.856 82.75 168.848 82.75C168.84 82.75 168.832 82.75 168.824 82.75C168.816 82.75 168.808 82.75 168.8 82.75C168.792 82.75 168.784 82.75 168.776 82.75C168.768 82.75 168.761 82.75 168.753 82.75C168.745 82.75 168.737 82.75 168.729 82.75C168.721 82.75 168.714 82.75 168.706 82.75C168.698 82.75 168.69 82.75 168.683 82.75C168.675 82.75 168.667 82.75 168.659 82.75C168.652 82.75 168.644 82.75 168.636 82.75C168.629 82.75 168.621 82.75 168.613 82.75C168.606 82.75 168.598 82.75 168.591 82.75C168.583 82.75 168.575 82.75 168.568 82.75C168.56 82.75 168.553 82.75 168.545 82.75C168.538 82.75 168.53 82.75 168.523 82.75C168.515 82.75 168.508 82.75 168.501 82.75C168.493 82.75 168.486 82.75 168.478 82.75C168.471 82.75 168.464 82.75 168.456 82.75C168.449 82.75 168.442 82.75 168.434 82.75C168.427 82.75 168.42 82.75 168.412 82.75C168.405 82.75 168.398 82.75 168.391 82.75C168.383 82.75 168.376 82.75 168.369 82.75C168.362 82.75 168.355 82.75 168.347 82.75C168.34 82.75 168.333 82.75 168.326 82.75C168.319 82.75 168.312 82.75 168.305 82.75C168.298 82.75 168.291 82.75 168.284 82.75C168.277 82.75 168.27 82.75 168.263 82.75C168.256 82.75 168.249 82.75 168.242 82.75C168.235 82.75 168.228 82.75 168.221 82.75C168.214 82.75 168.207 82.75 168.2 82.75C168.193 82.75 168.186 82.75 168.18 82.75C168.173 82.75 168.166 82.75 168.159 82.75C168.152 82.75 168.146 82.75 168.139 82.75C168.132 82.75 168.125 82.75 168.119 82.75C168.112 82.75 168.105 82.75 168.099 82.75C168.092 82.75 168.085 82.75 168.079 82.75C168.072 82.75 168.065 82.75 168.059 82.75C168.052 82.75 168.046 82.75 168.039 82.75C168.033 82.75 168.026 82.75 168.019 82.75C168.013 82.75 168.006 82.75 168 82.75V81.25ZM188.342 81.25C190.447 81.25 192.186 81.7816 193.375 83.1285C194.546 84.4539 195.053 86.4243 195.053 89H193.553C193.553 86.5757 193.067 85.0461 192.251 84.1215C191.453 83.2184 190.211 82.75 188.342 82.75V81.25ZM195.053 89C195.053 89.75 195.053 95.25 195.053 100.875C195.053 106.5 195.053 112.25 195.053 113.5H193.553C193.553 112.25 193.553 106.5 193.553 100.875C193.553 95.25 193.553 89.75 193.553 89H195.053ZM195.053 113.5C195.053 115.112 195.509 116.399 196.388 117.284C197.264 118.166 198.664 118.75 200.761 118.75V120.25C198.388 120.25 196.558 119.584 195.324 118.341C194.091 117.101 193.553 115.388 193.553 113.5H195.053ZM200.761 118.75C200.772 118.75 200.783 118.75 200.794 118.75C200.805 118.75 200.816 118.75 200.827 118.75C200.838 118.75 200.85 118.75 200.861 118.75C200.872 118.75 200.883 118.75 200.895 118.75C200.906 118.75 200.917 118.75 200.929 118.75C200.94 118.75 200.952 118.75 200.964 118.75C200.975 118.75 200.987 118.75 200.999 118.75C201.01 118.75 201.022 118.75 201.034 118.75C201.046 118.75 201.058 118.75 201.07 118.75C201.081 118.75 201.093 118.75 201.106 118.75C201.118 118.75 201.13 118.75 201.142 118.75C201.154 118.75 201.166 118.75 201.179 118.75C201.191 118.75 201.203 118.75 201.216 118.75C201.228 118.75 201.241 118.75 201.253 118.75C201.266 118.75 201.278 118.75 201.291 118.75C201.304 118.75 201.316 118.75 201.329 118.75C201.342 118.75 201.355 118.75 201.368 118.75C201.38 118.75 201.393 118.75 201.406 118.75C201.419 118.75 201.432 118.75 201.446 118.75C201.459 118.75 201.472 118.75 201.485 118.75C201.498 118.75 201.512 118.75 201.525 118.75C201.538 118.75 201.552 118.75 201.565 118.75C201.579 118.75 201.592 118.75 201.606 118.75C201.619 118.75 201.633 118.75 201.647 118.75C201.66 118.75 201.674 118.75 201.688 118.75C201.702 118.75 201.715 118.75 201.729 118.75C201.743 118.75 201.757 118.75 201.771 118.75C201.785 118.75 201.799 118.75 201.813 118.75C201.828 118.75 201.842 118.75 201.856 118.75C201.87 118.75 201.884 118.75 201.899 118.75C201.913 118.75 201.928 118.75 201.942 118.75C201.956 118.75 201.971 118.75 201.986 118.75C202 118.75 202.015 118.75 202.029 118.75C202.044 118.75 202.059 118.75 202.074 118.75C202.088 118.75 202.103 118.75 202.118 118.75C202.133 118.75 202.148 118.75 202.163 118.75C202.178 118.75 202.193 118.75 202.208 118.75C202.223 118.75 202.238 118.75 202.254 118.75C202.269 118.75 202.284 118.75 202.299 118.75C202.315 118.75 202.33 118.75 202.345 118.75C202.361 118.75 202.376 118.75 202.392 118.75C202.407 118.75 202.423 118.75 202.439 118.75C202.454 118.75 202.47 118.75 202.486 118.75C202.501 118.75 202.517 118.75 202.533 118.75C202.549 118.75 202.565 118.75 202.581 118.75C202.597 118.75 202.613 118.75 202.629 118.75C202.645 118.75 202.661 118.75 202.677 118.75C202.693 118.75 202.709 118.75 202.726 118.75C202.742 118.75 202.758 118.75 202.775 118.75C202.791 118.75 202.807 118.75 202.824 118.75C202.84 118.75 202.857 118.75 202.873 118.75C202.89 118.75 202.907 118.75 202.923 118.75C202.94 118.75 202.957 118.75 202.973 118.75C202.99 118.75 203.007 118.75 203.024 118.75C203.041 118.75 203.058 118.75 203.075 118.75C203.092 118.75 203.109 118.75 203.126 118.75C203.143 118.75 203.16 118.75 203.177 118.75C203.194 118.75 203.211 118.75 203.229 118.75C203.246 118.75 203.263 118.75 203.281 118.75C203.298 118.75 203.315 118.75 203.333 118.75C203.35 118.75 203.368 118.75 203.385 118.75C203.403 118.75 203.42 118.75 203.438 118.75C203.456 118.75 203.474 118.75 203.491 118.75C203.509 118.75 203.527 118.75 203.545 118.75C203.562 118.75 203.58 118.75 203.598 118.75C203.616 118.75 203.634 118.75 203.652 118.75C203.67 118.75 203.688 118.75 203.707 118.75C203.725 118.75 203.743 118.75 203.761 118.75C203.779 118.75 203.798 118.75 203.816 118.75C203.834 118.75 203.853 118.75 203.871 118.75C203.889 118.75 203.908 118.75 203.926 118.75C203.945 118.75 203.963 118.75 203.982 118.75C204.001 118.75 204.019 118.75 204.038 118.75C204.057 118.75 204.075 118.75 204.094 118.75C204.113 118.75 204.132 118.75 204.151 118.75C204.17 118.75 204.188 118.75 204.207 118.75C204.226 118.75 204.245 118.75 204.264 118.75C204.284 118.75 204.303 118.75 204.322 118.75C204.341 118.75 204.36 118.75 204.379 118.75C204.399 118.75 204.418 118.75 204.437 118.75C204.457 118.75 204.476 118.75 204.495 118.75C204.515 118.75 204.534 118.75 204.554 118.75C204.573 118.75 204.593 118.75 204.612 118.75C204.632 118.75 204.652 118.75 204.671 118.75C204.691 118.75 204.711 118.75 204.73 118.75C204.75 118.75 204.77 118.75 204.79 118.75C204.81 118.75 204.83 118.75 204.85 118.75C204.87 118.75 204.89 118.75 204.91 118.75C204.93 118.75 204.95 118.75 204.97 118.75C204.99 118.75 205.01 118.75 205.03 118.75C205.05 118.75 205.071 118.75 205.091 118.75C205.111 118.75 205.132 118.75 205.152 118.75C205.172 118.75 205.193 118.75 205.213 118.75C205.234 118.75 205.254 118.75 205.275 118.75C205.295 118.75 205.316 118.75 205.336 118.75C205.357 118.75 205.378 118.75 205.398 118.75C205.419 118.75 205.44 118.75 205.461 118.75C205.481 118.75 205.502 118.75 205.523 118.75C205.544 118.75 205.565 118.75 205.586 118.75C205.607 118.75 205.628 118.75 205.649 118.75C205.67 118.75 205.691 118.75 205.712 118.75C205.733 118.75 205.754 118.75 205.776 118.75C205.797 118.75 205.818 118.75 205.839 118.75C205.861 118.75 205.882 118.75 205.903 118.75C205.925 118.75 205.946 118.75 205.967 118.75C205.989 118.75 206.01 118.75 206.032 118.75C206.053 118.75 206.075 118.75 206.097 118.75C206.118 118.75 206.14 118.75 206.161 118.75C206.183 118.75 206.205 118.75 206.227 118.75C206.248 118.75 206.27 118.75 206.292 118.75C206.314 118.75 206.336 118.75 206.357 118.75C206.379 118.75 206.401 118.75 206.423 118.75C206.445 118.75 206.467 118.75 206.489 118.75C206.511 118.75 206.534 118.75 206.556 118.75C206.578 118.75 206.6 118.75 206.622 118.75C206.644 118.75 206.667 118.75 206.689 118.75C206.711 118.75 206.733 118.75 206.756 118.75C206.778 118.75 206.801 118.75 206.823 118.75C206.845 118.75 206.868 118.75 206.89 118.75C206.913 118.75 206.935 118.75 206.958 118.75C206.981 118.75 207.003 118.75 207.026 118.75C207.049 118.75 207.071 118.75 207.094 118.75C207.117 118.75 207.139 118.75 207.162 118.75C207.185 118.75 207.208 118.75 207.231 118.75C207.254 118.75 207.276 118.75 207.299 118.75C207.322 118.75 207.345 118.75 207.368 118.75C207.391 118.75 207.414 118.75 207.437 118.75C207.46 118.75 207.484 118.75 207.507 118.75C207.53 118.75 207.553 118.75 207.576 118.75C207.599 118.75 207.623 118.75 207.646 118.75C207.669 118.75 207.693 118.75 207.716 118.75C207.739 118.75 207.763 118.75 207.786 118.75C207.81 118.75 207.833 118.75 207.857 118.75C207.88 118.75 207.904 118.75 207.927 118.75C207.951 118.75 207.974 118.75 207.998 118.75C208.021 118.75 208.045 118.75 208.069 118.75C208.093 118.75 208.116 118.75 208.14 118.75C208.164 118.75 208.188 118.75 208.211 118.75C208.235 118.75 208.259 118.75 208.283 118.75C208.307 118.75 208.331 118.75 208.355 118.75C208.379 118.75 208.403 118.75 208.427 118.75C208.451 118.75 208.475 118.75 208.499 118.75C208.523 118.75 208.547 118.75 208.571 118.75C208.595 118.75 208.62 118.75 208.644 118.75C208.668 118.75 208.692 118.75 208.716 118.75C208.741 118.75 208.765 118.75 208.789 118.75C208.814 118.75 208.838 118.75 208.862 118.75C208.887 118.75 208.911 118.75 208.936 118.75C208.96 118.75 208.985 118.75 209.009 118.75C209.034 118.75 209.058 118.75 209.083 118.75C209.107 118.75 209.132 118.75 209.157 118.75C209.181 118.75 209.206 118.75 209.231 118.75C209.255 118.75 209.28 118.75 209.305 118.75C209.33 118.75 209.354 118.75 209.379 118.75C209.404 118.75 209.429 118.75 209.454 118.75C209.479 118.75 209.504 118.75 209.529 118.75C209.554 118.75 209.578 118.75 209.603 118.75C209.628 118.75 209.653 118.75 209.679 118.75C209.704 118.75 209.729 118.75 209.754 118.75C209.779 118.75 209.804 118.75 209.829 118.75C209.854 118.75 209.88 118.75 209.905 118.75C209.93 118.75 209.955 118.75 209.981 118.75C210.006 118.75 210.031 118.75 210.056 118.75C210.082 118.75 210.107 118.75 210.133 118.75C210.158 118.75 210.183 118.75 210.209 118.75C210.234 118.75 210.26 118.75 210.285 118.75C210.311 118.75 210.336 118.75 210.362 118.75C210.387 118.75 210.413 118.75 210.439 118.75C210.464 118.75 210.49 118.75 210.515 118.75C210.541 118.75 210.567 118.75 210.593 118.75C210.618 118.75 210.644 118.75 210.67 118.75C210.696 118.75 210.721 118.75 210.747 118.75C210.773 118.75 210.799 118.75 210.825 118.75C210.851 118.75 210.876 118.75 210.902 118.75C210.928 118.75 210.954 118.75 210.98 118.75C211.006 118.75 211.032 118.75 211.058 118.75C211.084 118.75 211.11 118.75 211.136 118.75C211.162 118.75 211.189 118.75 211.215 118.75C211.241 118.75 211.267 118.75 211.293 118.75C211.319 118.75 211.345 118.75 211.372 118.75C211.398 118.75 211.424 118.75 211.45 118.75C211.477 118.75 211.503 118.75 211.529 118.75C211.556 118.75 211.582 118.75 211.608 118.75C211.635 118.75 211.661 118.75 211.687 118.75C211.714 118.75 211.74 118.75 211.767 118.75C211.793 118.75 211.82 118.75 211.846 118.75C211.873 118.75 211.899 118.75 211.926 118.75C211.952 118.75 211.979 118.75 212.005 118.75C212.032 118.75 212.059 118.75 212.085 118.75C212.112 118.75 212.139 118.75 212.165 118.75C212.192 118.75 212.219 118.75 212.245 118.75C212.272 118.75 212.299 118.75 212.326 118.75C212.352 118.75 212.379 118.75 212.406 118.75C212.433 118.75 212.46 118.75 212.487 118.75C212.513 118.75 212.54 118.75 212.567 118.75C212.594 118.75 212.621 118.75 212.648 118.75C212.675 118.75 212.702 118.75 212.729 118.75C212.756 118.75 212.783 118.75 212.81 118.75C212.837 118.75 212.864 118.75 212.891 118.75C212.918 118.75 212.945 118.75 212.972 118.75C212.999 118.75 213.026 118.75 213.054 118.75C213.081 118.75 213.108 118.75 213.135 118.75C213.162 118.75 213.189 118.75 213.217 118.75C213.244 118.75 213.271 118.75 213.298 118.75C213.326 118.75 213.353 118.75 213.38 118.75C213.408 118.75 213.435 118.75 213.462 118.75C213.49 118.75 213.517 118.75 213.544 118.75C213.572 118.75 213.599 118.75 213.626 118.75C213.654 118.75 213.681 118.75 213.709 118.75C213.736 118.75 213.764 118.75 213.791 118.75C213.819 118.75 213.846 118.75 213.874 118.75C213.901 118.75 213.929 118.75 213.956 118.75C213.984 118.75 214.011 118.75 214.039 118.75C214.067 118.75 214.094 118.75 214.122 118.75C214.15 118.75 214.177 118.75 214.205 118.75C214.232 118.75 214.26 118.75 214.288 118.75C214.316 118.75 214.343 118.75 214.371 118.75C214.399 118.75 214.426 118.75 214.454 118.75C214.482 118.75 214.51 118.75 214.538 118.75C214.565 118.75 214.593 118.75 214.621 118.75C214.649 118.75 214.677 118.75 214.705 118.75C214.732 118.75 214.76 118.75 214.788 118.75C214.816 118.75 214.844 118.75 214.872 118.75C214.9 118.75 214.928 118.75 214.956 118.75C214.984 118.75 215.012 118.75 215.04 118.75C215.068 118.75 215.096 118.75 215.124 118.75C215.152 118.75 215.18 118.75 215.208 118.75C215.236 118.75 215.264 118.75 215.292 118.75C215.32 118.75 215.348 118.75 215.376 118.75C215.404 118.75 215.432 118.75 215.46 118.75C215.489 118.75 215.517 118.75 215.545 118.75C215.573 118.75 215.601 118.75 215.629 118.75C215.658 118.75 215.686 118.75 215.714 118.75C215.742 118.75 215.77 118.75 215.799 118.75C215.827 118.75 215.855 118.75 215.883 118.75C215.912 118.75 215.94 118.75 215.968 118.75C215.997 118.75 216.025 118.75 216.053 118.75C216.081 118.75 216.11 118.75 216.138 118.75C216.166 118.75 216.195 118.75 216.223 118.75C216.252 118.75 216.28 118.75 216.308 118.75C216.337 118.75 216.365 118.75 216.394 118.75C216.422 118.75 216.45 118.75 216.479 118.75C216.507 118.75 216.536 118.75 216.564 118.75C216.593 118.75 216.621 118.75 216.65 118.75C216.678 118.75 216.707 118.75 216.735 118.75C216.764 118.75 216.792 118.75 216.821 118.75C216.849 118.75 216.878 118.75 216.906 118.75C216.935 118.75 216.963 118.75 216.992 118.75C217.02 118.75 217.049 118.75 217.078 118.75C217.106 118.75 217.135 118.75 217.163 118.75C217.192 118.75 217.221 118.75 217.249 118.75C217.278 118.75 217.306 118.75 217.335 118.75C217.364 118.75 217.392 118.75 217.421 118.75C217.45 118.75 217.478 118.75 217.507 118.75C217.536 118.75 217.564 118.75 217.593 118.75C217.622 118.75 217.651 118.75 217.679 118.75C217.708 118.75 217.737 118.75 217.765 118.75C217.794 118.75 217.823 118.75 217.852 118.75C217.88 118.75 217.909 118.75 217.938 118.75C217.967 118.75 217.995 118.75 218.024 118.75C218.053 118.75 218.082 118.75 218.111 118.75C218.139 118.75 218.168 118.75 218.197 118.75C218.226 118.75 218.255 118.75 218.284 118.75C218.312 118.75 218.341 118.75 218.37 118.75C218.399 118.75 218.428 118.75 218.457 118.75C218.485 118.75 218.514 118.75 218.543 118.75C218.572 118.75 218.601 118.75 218.63 118.75C218.659 118.75 218.688 118.75 218.716 118.75C218.745 118.75 218.774 118.75 218.803 118.75C218.832 118.75 218.861 118.75 218.89 118.75C218.919 118.75 218.948 118.75 218.977 118.75C219.006 118.75 219.035 118.75 219.063 118.75C219.092 118.75 219.121 118.75 219.15 118.75C219.179 118.75 219.208 118.75 219.237 118.75C219.266 118.75 219.295 118.75 219.324 118.75C219.353 118.75 219.382 118.75 219.411 118.75C219.44 118.75 219.469 118.75 219.498 118.75C219.527 118.75 219.556 118.75 219.585 118.75C219.614 118.75 219.643 118.75 219.672 118.75C219.701 118.75 219.73 118.75 219.759 118.75C219.788 118.75 219.817 118.75 219.846 118.75C219.875 118.75 219.904 118.75 219.933 118.75C219.962 118.75 219.991 118.75 220.02 118.75C220.049 118.75 220.078 118.75 220.107 118.75C220.136 118.75 220.165 118.75 220.194 118.75C220.224 118.75 220.253 118.75 220.282 118.75C220.311 118.75 220.34 118.75 220.369 118.75C220.398 118.75 220.427 118.75 220.456 118.75C220.485 118.75 220.514 118.75 220.543 118.75C220.572 118.75 220.601 118.75 220.63 118.75C220.659 118.75 220.688 118.75 220.718 118.75C220.747 118.75 220.776 118.75 220.805 118.75C220.834 118.75 220.863 118.75 220.892 118.75C220.921 118.75 220.95 118.75 220.979 118.75C221.008 118.75 221.037 118.75 221.066 118.75C221.096 118.75 221.125 118.75 221.154 118.75C221.183 118.75 221.212 118.75 221.241 118.75C221.27 118.75 221.299 118.75 221.328 118.75C221.357 118.75 221.386 118.75 221.415 118.75C221.445 118.75 221.474 118.75 221.503 118.75C221.532 118.75 221.561 118.75 221.59 118.75C221.619 118.75 221.648 118.75 221.677 118.75C221.706 118.75 221.735 118.75 221.764 118.75C221.794 118.75 221.823 118.75 221.852 118.75C221.881 118.75 221.91 118.75 221.939 118.75C221.968 118.75 221.997 118.75 222.026 118.75C222.055 118.75 222.084 118.75 222.113 118.75C222.142 118.75 222.171 118.75 222.201 118.75C222.23 118.75 222.259 118.75 222.288 118.75C222.317 118.75 222.346 118.75 222.375 118.75C222.404 118.75 222.433 118.75 222.462 118.75C222.491 118.75 222.52 118.75 222.549 118.75C222.578 118.75 222.607 118.75 222.636 118.75C222.665 118.75 222.694 118.75 222.723 118.75C222.752 118.75 222.781 118.75 222.81 118.75C222.839 118.75 222.869 118.75 222.898 118.75C222.927 118.75 222.956 118.75 222.985 118.75C223.014 118.75 223.043 118.75 223.072 118.75C223.101 118.75 223.13 118.75 223.159 118.75C223.188 118.75 223.217 118.75 223.246 118.75C223.275 118.75 223.304 118.75 223.333 118.75C223.361 118.75 223.39 118.75 223.419 118.75C223.448 118.75 223.477 118.75 223.506 118.75C223.535 118.75 223.564 118.75 223.593 118.75C223.622 118.75 223.651 118.75 223.68 118.75C223.709 118.75 223.738 118.75 223.767 118.75C223.796 118.75 223.825 118.75 223.854 118.75C223.882 118.75 223.911 118.75 223.94 118.75C223.969 118.75 223.998 118.75 224.027 118.75C224.056 118.75 224.085 118.75 224.114 118.75C224.142 118.75 224.171 118.75 224.2 118.75C224.229 118.75 224.258 118.75 224.287 118.75C224.316 118.75 224.344 118.75 224.373 118.75C224.402 118.75 224.431 118.75 224.46 118.75C224.489 118.75 224.517 118.75 224.546 118.75C224.575 118.75 224.604 118.75 224.633 118.75C224.661 118.75 224.69 118.75 224.719 118.75C224.748 118.75 224.777 118.75 224.805 118.75C224.834 118.75 224.863 118.75 224.892 118.75C224.92 118.75 224.949 118.75 224.978 118.75C225.006 118.75 225.035 118.75 225.064 118.75C225.093 118.75 225.121 118.75 225.15 118.75C225.179 118.75 225.207 118.75 225.236 118.75C225.265 118.75 225.293 118.75 225.322 118.75C225.351 118.75 225.379 118.75 225.408 118.75C225.437 118.75 225.465 118.75 225.494 118.75C225.522 118.75 225.551 118.75 225.58 118.75C225.608 118.75 225.637 118.75 225.665 118.75C225.694 118.75 225.723 118.75 225.751 118.75C225.78 118.75 225.808 118.75 225.837 118.75C225.865 118.75 225.894 118.75 225.922 118.75C225.951 118.75 225.979 118.75 226.008 118.75C226.036 118.75 226.065 118.75 226.093 118.75C226.122 118.75 226.15 118.75 226.179 118.75C226.207 118.75 226.236 118.75 226.264 118.75C226.292 118.75 226.321 118.75 226.349 118.75C226.378 118.75 226.406 118.75 226.434 118.75C226.463 118.75 226.491 118.75 226.519 118.75C226.548 118.75 226.576 118.75 226.604 118.75C226.633 118.75 226.661 118.75 226.689 118.75C226.718 118.75 226.746 118.75 226.774 118.75C226.803 118.75 226.831 118.75 226.859 118.75C226.887 118.75 226.916 118.75 226.944 118.75C226.972 118.75 227 118.75 227.028 118.75C227.057 118.75 227.085 118.75 227.113 118.75C227.141 118.75 227.169 118.75 227.197 118.75C227.226 118.75 227.254 118.75 227.282 118.75C227.31 118.75 227.338 118.75 227.366 118.75C227.394 118.75 227.422 118.75 227.45 118.75C227.478 118.75 227.506 118.75 227.534 118.75C227.563 118.75 227.591 118.75 227.619 118.75C227.647 118.75 227.675 118.75 227.702 118.75C227.73 118.75 227.758 118.75 227.786 118.75C227.814 118.75 227.842 118.75 227.87 118.75C227.898 118.75 227.926 118.75 227.954 118.75C227.982 118.75 228.01 118.75 228.037 118.75C228.065 118.75 228.093 118.75 228.121 118.75C228.149 118.75 228.176 118.75 228.204 118.75C228.232 118.75 228.26 118.75 228.288 118.75C228.315 118.75 228.343 118.75 228.371 118.75C228.398 118.75 228.426 118.75 228.454 118.75C228.482 118.75 228.509 118.75 228.537 118.75C228.564 118.75 228.592 118.75 228.62 118.75C228.647 118.75 228.675 118.75 228.702 118.75C228.73 118.75 228.758 118.75 228.785 118.75C228.813 118.75 228.84 118.75 228.868 118.75C228.895 118.75 228.923 118.75 228.95 118.75C228.978 118.75 229.005 118.75 229.033 118.75C229.06 118.75 229.087 118.75 229.115 118.75C229.142 118.75 229.17 118.75 229.197 118.75C229.224 118.75 229.252 118.75 229.279 118.75C229.306 118.75 229.334 118.75 229.361 118.75C229.388 118.75 229.415 118.75 229.443 118.75C229.47 118.75 229.497 118.75 229.524 118.75C229.552 118.75 229.579 118.75 229.606 118.75C229.633 118.75 229.66 118.75 229.687 118.75C229.714 118.75 229.742 118.75 229.769 118.75C229.796 118.75 229.823 118.75 229.85 118.75C229.877 118.75 229.904 118.75 229.931 118.75C229.958 118.75 229.985 118.75 230.012 118.75C230.039 118.75 230.066 118.75 230.093 118.75C230.12 118.75 230.147 118.75 230.173 118.75C230.2 118.75 230.227 118.75 230.254 118.75C230.281 118.75 230.308 118.75 230.334 118.75C230.361 118.75 230.388 118.75 230.415 118.75C230.442 118.75 230.468 118.75 230.495 118.75C230.522 118.75 230.548 118.75 230.575 118.75C230.602 118.75 230.628 118.75 230.655 118.75C230.682 118.75 230.708 118.75 230.735 118.75C230.761 118.75 230.788 118.75 230.814 118.75C230.841 118.75 230.867 118.75 230.894 118.75C230.92 118.75 230.947 118.75 230.973 118.75C231 118.75 231.026 118.75 231.052 118.75C231.079 118.75 231.105 118.75 231.132 118.75C231.158 118.75 231.184 118.75 231.211 118.75C231.237 118.75 231.263 118.75 231.289 118.75C231.316 118.75 231.342 118.75 231.368 118.75C231.394 118.75 231.42 118.75 231.446 118.75C231.473 118.75 231.499 118.75 231.525 118.75C231.551 118.75 231.577 118.75 231.603 118.75C231.629 118.75 231.655 118.75 231.681 118.75C231.707 118.75 231.733 118.75 231.759 118.75C231.785 118.75 231.811 118.75 231.837 118.75C231.863 118.75 231.889 118.75 231.914 118.75C231.94 118.75 231.966 118.75 231.992 118.75C232.018 118.75 232.043 118.75 232.069 118.75C232.095 118.75 232.121 118.75 232.146 118.75C232.172 118.75 232.198 118.75 232.223 118.75C232.249 118.75 232.275 118.75 232.3 118.75C232.326 118.75 232.351 118.75 232.377 118.75C232.402 118.75 232.428 118.75 232.453 118.75C232.479 118.75 232.504 118.75 232.53 118.75C232.555 118.75 232.58 118.75 232.606 118.75C232.631 118.75 232.657 118.75 232.682 118.75C232.707 118.75 232.732 118.75 232.758 118.75C232.783 118.75 232.808 118.75 232.833 118.75C232.859 118.75 232.884 118.75 232.909 118.75C232.934 118.75 232.959 118.75 232.984 118.75C233.009 118.75 233.034 118.75 233.059 118.75C233.084 118.75 233.109 118.75 233.134 118.75C233.159 118.75 233.184 118.75 233.209 118.75C233.234 118.75 233.259 118.75 233.284 118.75C233.309 118.75 233.334 118.75 233.358 118.75C233.383 118.75 233.408 118.75 233.433 118.75C233.457 118.75 233.482 118.75 233.507 118.75C233.531 118.75 233.556 118.75 233.581 118.75C233.605 118.75 233.63 118.75 233.654 118.75C233.679 118.75 233.704 118.75 233.728 118.75C233.752 118.75 233.777 118.75 233.801 118.75C233.826 118.75 233.85 118.75 233.875 118.75C233.899 118.75 233.923 118.75 233.948 118.75C233.972 118.75 233.996 118.75 234.02 118.75C234.045 118.75 234.069 118.75 234.093 118.75C234.117 118.75 234.141 118.75 234.165 118.75C234.19 118.75 234.214 118.75 234.238 118.75C234.262 118.75 234.286 118.75 234.31 118.75C234.334 118.75 234.358 118.75 234.382 118.75C234.406 118.75 234.429 118.75 234.453 118.75C234.477 118.75 234.501 118.75 234.525 118.75C234.549 118.75 234.572 118.75 234.596 118.75C234.62 118.75 234.644 118.75 234.667 118.75C234.691 118.75 234.714 118.75 234.738 118.75C234.762 118.75 234.785 118.75 234.809 118.75C234.832 118.75 234.856 118.75 234.879 118.75C234.903 118.75 234.926 118.75 234.949 118.75C234.973 118.75 234.996 118.75 235.02 118.75C235.043 118.75 235.066 118.75 235.089 118.75C235.113 118.75 235.136 118.75 235.159 118.75C235.182 118.75 235.205 118.75 235.229 118.75C235.252 118.75 235.275 118.75 235.298 118.75C235.321 118.75 235.344 118.75 235.367 118.75C235.39 118.75 235.413 118.75 235.436 118.75C235.458 118.75 235.481 118.75 235.504 118.75C235.527 118.75 235.55 118.75 235.573 118.75C235.595 118.75 235.618 118.75 235.641 118.75C235.663 118.75 235.686 118.75 235.709 118.75C235.731 118.75 235.754 118.75 235.776 118.75C235.799 118.75 235.821 118.75 235.844 118.75C235.866 118.75 235.889 118.75 235.911 118.75C235.934 118.75 235.956 118.75 235.978 118.75C236.001 118.75 236.023 118.75 236.045 118.75C236.067 118.75 236.09 118.75 236.112 118.75C236.134 118.75 236.156 118.75 236.178 118.75C236.2 118.75 236.222 118.75 236.244 118.75C236.266 118.75 236.288 118.75 236.31 118.75C236.332 118.75 236.354 118.75 236.376 118.75C236.398 118.75 236.42 118.75 236.441 118.75C236.463 118.75 236.485 118.75 236.507 118.75C236.528 118.75 236.55 118.75 236.572 118.75C236.593 118.75 236.615 118.75 236.637 118.75C236.658 118.75 236.68 118.75 236.701 118.75C236.723 118.75 236.744 118.75 236.765 118.75C236.787 118.75 236.808 118.75 236.829 118.75C236.851 118.75 236.872 118.75 236.893 118.75C236.915 118.75 236.936 118.75 236.957 118.75C236.978 118.75 236.999 118.75 237.02 118.75C237.041 118.75 237.062 118.75 237.083 118.75C237.104 118.75 237.125 118.75 237.146 118.75C237.167 118.75 237.188 118.75 237.209 118.75C237.23 118.75 237.25 118.75 237.271 118.75C237.292 118.75 237.313 118.75 237.333 118.75C237.354 118.75 237.375 118.75 237.395 118.75C237.416 118.75 237.436 118.75 237.457 118.75C237.477 118.75 237.498 118.75 237.518 118.75C237.539 118.75 237.559 118.75 237.579 118.75C237.6 118.75 237.62 118.75 237.64 118.75C237.66 118.75 237.681 118.75 237.701 118.75C237.721 118.75 237.741 118.75 237.761 118.75C237.781 118.75 237.801 118.75 237.821 118.75C237.841 118.75 237.861 118.75 237.881 118.75C237.901 118.75 237.921 118.75 237.941 118.75C237.96 118.75 237.98 118.75 238 118.75V120.25C237.98 120.25 237.96 120.25 237.941 120.25C237.921 120.25 237.901 120.25 237.881 120.25C237.861 120.25 237.841 120.25 237.821 120.25C237.801 120.25 237.781 120.25 237.761 120.25C237.741 120.25 237.721 120.25 237.701 120.25C237.681 120.25 237.66 120.25 237.64 120.25C237.62 120.25 237.6 120.25 237.579 120.25C237.559 120.25 237.539 120.25 237.518 120.25C237.498 120.25 237.477 120.25 237.457 120.25C237.436 120.25 237.416 120.25 237.395 120.25C237.375 120.25 237.354 120.25 237.333 120.25C237.313 120.25 237.292 120.25 237.271 120.25C237.25 120.25 237.23 120.25 237.209 120.25C237.188 120.25 237.167 120.25 237.146 120.25C237.125 120.25 237.104 120.25 237.083 120.25C237.062 120.25 237.041 120.25 237.02 120.25C236.999 120.25 236.978 120.25 236.957 120.25C236.936 120.25 236.915 120.25 236.893 120.25C236.872 120.25 236.851 120.25 236.829 120.25C236.808 120.25 236.787 120.25 236.765 120.25C236.744 120.25 236.723 120.25 236.701 120.25C236.68 120.25 236.658 120.25 236.637 120.25C236.615 120.25 236.593 120.25 236.572 120.25C236.55 120.25 236.528 120.25 236.507 120.25C236.485 120.25 236.463 120.25 236.441 120.25C236.42 120.25 236.398 120.25 236.376 120.25C236.354 120.25 236.332 120.25 236.31 120.25C236.288 120.25 236.266 120.25 236.244 120.25C236.222 120.25 236.2 120.25 236.178 120.25C236.156 120.25 236.134 120.25 236.112 120.25C236.09 120.25 236.067 120.25 236.045 120.25C236.023 120.25 236.001 120.25 235.978 120.25C235.956 120.25 235.934 120.25 235.911 120.25C235.889 120.25 235.866 120.25 235.844 120.25C235.821 120.25 235.799 120.25 235.776 120.25C235.754 120.25 235.731 120.25 235.709 120.25C235.686 120.25 235.663 120.25 235.641 120.25C235.618 120.25 235.595 120.25 235.573 120.25C235.55 120.25 235.527 120.25 235.504 120.25C235.481 120.25 235.458 120.25 235.436 120.25C235.413 120.25 235.39 120.25 235.367 120.25C235.344 120.25 235.321 120.25 235.298 120.25C235.275 120.25 235.252 120.25 235.229 120.25C235.205 120.25 235.182 120.25 235.159 120.25C235.136 120.25 235.113 120.25 235.089 120.25C235.066 120.25 235.043 120.25 235.02 120.25C234.996 120.25 234.973 120.25 234.949 120.25C234.926 120.25 234.903 120.25 234.879 120.25C234.856 120.25 234.832 120.25 234.809 120.25C234.785 120.25 234.762 120.25 234.738 120.25C234.714 120.25 234.691 120.25 234.667 120.25C234.644 120.25 234.62 120.25 234.596 120.25C234.572 120.25 234.549 120.25 234.525 120.25C234.501 120.25 234.477 120.25 234.453 120.25C234.429 120.25 234.406 120.25 234.382 120.25C234.358 120.25 234.334 120.25 234.31 120.25C234.286 120.25 234.262 120.25 234.238 120.25C234.214 120.25 234.19 120.25 234.165 120.25C234.141 120.25 234.117 120.25 234.093 120.25C234.069 120.25 234.045 120.25 234.02 120.25C233.996 120.25 233.972 120.25 233.948 120.25C233.923 120.25 233.899 120.25 233.875 120.25C233.85 120.25 233.826 120.25 233.801 120.25C233.777 120.25 233.752 120.25 233.728 120.25C233.704 120.25 233.679 120.25 233.654 120.25C233.63 120.25 233.605 120.25 233.581 120.25C233.556 120.25 233.531 120.25 233.507 120.25C233.482 120.25 233.457 120.25 233.433 120.25C233.408 120.25 233.383 120.25 233.358 120.25C233.334 120.25 233.309 120.25 233.284 120.25C233.259 120.25 233.234 120.25 233.209 120.25C233.184 120.25 233.159 120.25 233.134 120.25C233.109 120.25 233.084 120.25 233.059 120.25C233.034 120.25 233.009 120.25 232.984 120.25C232.959 120.25 232.934 120.25 232.909 120.25C232.884 120.25 232.859 120.25 232.833 120.25C232.808 120.25 232.783 120.25 232.758 120.25C232.732 120.25 232.707 120.25 232.682 120.25C232.657 120.25 232.631 120.25 232.606 120.25C232.58 120.25 232.555 120.25 232.53 120.25C232.504 120.25 232.479 120.25 232.453 120.25C232.428 120.25 232.402 120.25 232.377 120.25C232.351 120.25 232.326 120.25 232.3 120.25C232.275 120.25 232.249 120.25 232.223 120.25C232.198 120.25 232.172 120.25 232.146 120.25C232.121 120.25 232.095 120.25 232.069 120.25C232.043 120.25 232.018 120.25 231.992 120.25C231.966 120.25 231.94 120.25 231.914 120.25C231.889 120.25 231.863 120.25 231.837 120.25C231.811 120.25 231.785 120.25 231.759 120.25C231.733 120.25 231.707 120.25 231.681 120.25C231.655 120.25 231.629 120.25 231.603 120.25C231.577 120.25 231.551 120.25 231.525 120.25C231.499 120.25 231.473 120.25 231.446 120.25C231.42 120.25 231.394 120.25 231.368 120.25C231.342 120.25 231.316 120.25 231.289 120.25C231.263 120.25 231.237 120.25 231.211 120.25C231.184 120.25 231.158 120.25 231.132 120.25C231.105 120.25 231.079 120.25 231.052 120.25C231.026 120.25 231 120.25 230.973 120.25C230.947 120.25 230.92 120.25 230.894 120.25C230.867 120.25 230.841 120.25 230.814 120.25C230.788 120.25 230.761 120.25 230.735 120.25C230.708 120.25 230.682 120.25 230.655 120.25C230.628 120.25 230.602 120.25 230.575 120.25C230.548 120.25 230.522 120.25 230.495 120.25C230.468 120.25 230.442 120.25 230.415 120.25C230.388 120.25 230.361 120.25 230.334 120.25C230.308 120.25 230.281 120.25 230.254 120.25C230.227 120.25 230.2 120.25 230.173 120.25C230.147 120.25 230.12 120.25 230.093 120.25C230.066 120.25 230.039 120.25 230.012 120.25C229.985 120.25 229.958 120.25 229.931 120.25C229.904 120.25 229.877 120.25 229.85 120.25C229.823 120.25 229.796 120.25 229.769 120.25C229.742 120.25 229.714 120.25 229.687 120.25C229.66 120.25 229.633 120.25 229.606 120.25C229.579 120.25 229.552 120.25 229.524 120.25C229.497 120.25 229.47 120.25 229.443 120.25C229.415 120.25 229.388 120.25 229.361 120.25C229.334 120.25 229.306 120.25 229.279 120.25C229.252 120.25 229.224 120.25 229.197 120.25C229.17 120.25 229.142 120.25 229.115 120.25C229.087 120.25 229.06 120.25 229.033 120.25C229.005 120.25 228.978 120.25 228.95 120.25C228.923 120.25 228.895 120.25 228.868 120.25C228.84 120.25 228.813 120.25 228.785 120.25C228.758 120.25 228.73 120.25 228.702 120.25C228.675 120.25 228.647 120.25 228.62 120.25C228.592 120.25 228.564 120.25 228.537 120.25C228.509 120.25 228.482 120.25 228.454 120.25C228.426 120.25 228.398 120.25 228.371 120.25C228.343 120.25 228.315 120.25 228.288 120.25C228.26 120.25 228.232 120.25 228.204 120.25C228.176 120.25 228.149 120.25 228.121 120.25C228.093 120.25 228.065 120.25 228.037 120.25C228.01 120.25 227.982 120.25 227.954 120.25C227.926 120.25 227.898 120.25 227.87 120.25C227.842 120.25 227.814 120.25 227.786 120.25C227.758 120.25 227.73 120.25 227.702 120.25C227.675 120.25 227.647 120.25 227.619 120.25C227.591 120.25 227.563 120.25 227.534 120.25C227.506 120.25 227.478 120.25 227.45 120.25C227.422 120.25 227.394 120.25 227.366 120.25C227.338 120.25 227.31 120.25 227.282 120.25C227.254 120.25 227.226 120.25 227.197 120.25C227.169 120.25 227.141 120.25 227.113 120.25C227.085 120.25 227.057 120.25 227.028 120.25C227 120.25 226.972 120.25 226.944 120.25C226.916 120.25 226.887 120.25 226.859 120.25C226.831 120.25 226.803 120.25 226.774 120.25C226.746 120.25 226.718 120.25 226.689 120.25C226.661 120.25 226.633 120.25 226.604 120.25C226.576 120.25 226.548 120.25 226.519 120.25C226.491 120.25 226.463 120.25 226.434 120.25C226.406 120.25 226.378 120.25 226.349 120.25C226.321 120.25 226.292 120.25 226.264 120.25C226.236 120.25 226.207 120.25 226.179 120.25C226.15 120.25 226.122 120.25 226.093 120.25C226.065 120.25 226.036 120.25 226.008 120.25C225.979 120.25 225.951 120.25 225.922 120.25C225.894 120.25 225.865 120.25 225.837 120.25C225.808 120.25 225.78 120.25 225.751 120.25C225.723 120.25 225.694 120.25 225.665 120.25C225.637 120.25 225.608 120.25 225.58 120.25C225.551 120.25 225.522 120.25 225.494 120.25C225.465 120.25 225.437 120.25 225.408 120.25C225.379 120.25 225.351 120.25 225.322 120.25C225.293 120.25 225.265 120.25 225.236 120.25C225.207 120.25 225.179 120.25 225.15 120.25C225.121 120.25 225.093 120.25 225.064 120.25C225.035 120.25 225.006 120.25 224.978 120.25C224.949 120.25 224.92 120.25 224.892 120.25C224.863 120.25 224.834 120.25 224.805 120.25C224.777 120.25 224.748 120.25 224.719 120.25C224.69 120.25 224.661 120.25 224.633 120.25C224.604 120.25 224.575 120.25 224.546 120.25C224.517 120.25 224.489 120.25 224.46 120.25C224.431 120.25 224.402 120.25 224.373 120.25C224.344 120.25 224.316 120.25 224.287 120.25C224.258 120.25 224.229 120.25 224.2 120.25C224.171 120.25 224.142 120.25 224.114 120.25C224.085 120.25 224.056 120.25 224.027 120.25C223.998 120.25 223.969 120.25 223.94 120.25C223.911 120.25 223.882 120.25 223.854 120.25C223.825 120.25 223.796 120.25 223.767 120.25C223.738 120.25 223.709 120.25 223.68 120.25C223.651 120.25 223.622 120.25 223.593 120.25C223.564 120.25 223.535 120.25 223.506 120.25C223.477 120.25 223.448 120.25 223.419 120.25C223.39 120.25 223.361 120.25 223.333 120.25C223.304 120.25 223.275 120.25 223.246 120.25C223.217 120.25 223.188 120.25 223.159 120.25C223.13 120.25 223.101 120.25 223.072 120.25C223.043 120.25 223.014 120.25 222.985 120.25C222.956 120.25 222.927 120.25 222.898 120.25C222.869 120.25 222.839 120.25 222.81 120.25C222.781 120.25 222.752 120.25 222.723 120.25C222.694 120.25 222.665 120.25 222.636 120.25C222.607 120.25 222.578 120.25 222.549 120.25C222.52 120.25 222.491 120.25 222.462 120.25C222.433 120.25 222.404 120.25 222.375 120.25C222.346 120.25 222.317 120.25 222.288 120.25C222.259 120.25 222.23 120.25 222.201 120.25C222.171 120.25 222.142 120.25 222.113 120.25C222.084 120.25 222.055 120.25 222.026 120.25C221.997 120.25 221.968 120.25 221.939 120.25C221.91 120.25 221.881 120.25 221.852 120.25C221.823 120.25 221.794 120.25 221.764 120.25C221.735 120.25 221.706 120.25 221.677 120.25C221.648 120.25 221.619 120.25 221.59 120.25C221.561 120.25 221.532 120.25 221.503 120.25C221.474 120.25 221.445 120.25 221.415 120.25C221.386 120.25 221.357 120.25 221.328 120.25C221.299 120.25 221.27 120.25 221.241 120.25C221.212 120.25 221.183 120.25 221.154 120.25C221.125 120.25 221.096 120.25 221.066 120.25C221.037 120.25 221.008 120.25 220.979 120.25C220.95 120.25 220.921 120.25 220.892 120.25C220.863 120.25 220.834 120.25 220.805 120.25C220.776 120.25 220.747 120.25 220.718 120.25C220.688 120.25 220.659 120.25 220.63 120.25C220.601 120.25 220.572 120.25 220.543 120.25C220.514 120.25 220.485 120.25 220.456 120.25C220.427 120.25 220.398 120.25 220.369 120.25C220.34 120.25 220.311 120.25 220.282 120.25C220.253 120.25 220.224 120.25 220.194 120.25C220.165 120.25 220.136 120.25 220.107 120.25C220.078 120.25 220.049 120.25 220.02 120.25C219.991 120.25 219.962 120.25 219.933 120.25C219.904 120.25 219.875 120.25 219.846 120.25C219.817 120.25 219.788 120.25 219.759 120.25C219.73 120.25 219.701 120.25 219.672 120.25C219.643 120.25 219.614 120.25 219.585 120.25C219.556 120.25 219.527 120.25 219.498 120.25C219.469 120.25 219.44 120.25 219.411 120.25C219.382 120.25 219.353 120.25 219.324 120.25C219.295 120.25 219.266 120.25 219.237 120.25C219.208 120.25 219.179 120.25 219.15 120.25C219.121 120.25 219.092 120.25 219.063 120.25C219.035 120.25 219.006 120.25 218.977 120.25C218.948 120.25 218.919 120.25 218.89 120.25C218.861 120.25 218.832 120.25 218.803 120.25C218.774 120.25 218.745 120.25 218.716 120.25C218.688 120.25 218.659 120.25 218.63 120.25C218.601 120.25 218.572 120.25 218.543 120.25C218.514 120.25 218.485 120.25 218.457 120.25C218.428 120.25 218.399 120.25 218.37 120.25C218.341 120.25 218.312 120.25 218.284 120.25C218.255 120.25 218.226 120.25 218.197 120.25C218.168 120.25 218.139 120.25 218.111 120.25C218.082 120.25 218.053 120.25 218.024 120.25C217.995 120.25 217.967 120.25 217.938 120.25C217.909 120.25 217.88 120.25 217.852 120.25C217.823 120.25 217.794 120.25 217.765 120.25C217.737 120.25 217.708 120.25 217.679 120.25C217.651 120.25 217.622 120.25 217.593 120.25C217.564 120.25 217.536 120.25 217.507 120.25C217.478 120.25 217.45 120.25 217.421 120.25C217.392 120.25 217.364 120.25 217.335 120.25C217.306 120.25 217.278 120.25 217.249 120.25C217.221 120.25 217.192 120.25 217.163 120.25C217.135 120.25 217.106 120.25 217.078 120.25C217.049 120.25 217.02 120.25 216.992 120.25C216.963 120.25 216.935 120.25 216.906 120.25C216.878 120.25 216.849 120.25 216.821 120.25C216.792 120.25 216.764 120.25 216.735 120.25C216.707 120.25 216.678 120.25 216.65 120.25C216.621 120.25 216.593 120.25 216.564 120.25C216.536 120.25 216.507 120.25 216.479 120.25C216.45 120.25 216.422 120.25 216.394 120.25C216.365 120.25 216.337 120.25 216.308 120.25C216.28 120.25 216.252 120.25 216.223 120.25C216.195 120.25 216.166 120.25 216.138 120.25C216.11 120.25 216.081 120.25 216.053 120.25C216.025 120.25 215.997 120.25 215.968 120.25C215.94 120.25 215.912 120.25 215.883 120.25C215.855 120.25 215.827 120.25 215.799 120.25C215.77 120.25 215.742 120.25 215.714 120.25C215.686 120.25 215.658 120.25 215.629 120.25C215.601 120.25 215.573 120.25 215.545 120.25C215.517 120.25 215.489 120.25 215.46 120.25C215.432 120.25 215.404 120.25 215.376 120.25C215.348 120.25 215.32 120.25 215.292 120.25C215.264 120.25 215.236 120.25 215.208 120.25C215.18 120.25 215.152 120.25 215.124 120.25C215.096 120.25 215.068 120.25 215.04 120.25C215.012 120.25 214.984 120.25 214.956 120.25C214.928 120.25 214.9 120.25 214.872 120.25C214.844 120.25 214.816 120.25 214.788 120.25C214.76 120.25 214.732 120.25 214.705 120.25C214.677 120.25 214.649 120.25 214.621 120.25C214.593 120.25 214.565 120.25 214.538 120.25C214.51 120.25 214.482 120.25 214.454 120.25C214.426 120.25 214.399 120.25 214.371 120.25C214.343 120.25 214.316 120.25 214.288 120.25C214.26 120.25 214.232 120.25 214.205 120.25C214.177 120.25 214.15 120.25 214.122 120.25C214.094 120.25 214.067 120.25 214.039 120.25C214.011 120.25 213.984 120.25 213.956 120.25C213.929 120.25 213.901 120.25 213.874 120.25C213.846 120.25 213.819 120.25 213.791 120.25C213.764 120.25 213.736 120.25 213.709 120.25C213.681 120.25 213.654 120.25 213.626 120.25C213.599 120.25 213.572 120.25 213.544 120.25C213.517 120.25 213.49 120.25 213.462 120.25C213.435 120.25 213.408 120.25 213.38 120.25C213.353 120.25 213.326 120.25 213.298 120.25C213.271 120.25 213.244 120.25 213.217 120.25C213.189 120.25 213.162 120.25 213.135 120.25C213.108 120.25 213.081 120.25 213.054 120.25C213.026 120.25 212.999 120.25 212.972 120.25C212.945 120.25 212.918 120.25 212.891 120.25C212.864 120.25 212.837 120.25 212.81 120.25C212.783 120.25 212.756 120.25 212.729 120.25C212.702 120.25 212.675 120.25 212.648 120.25C212.621 120.25 212.594 120.25 212.567 120.25C212.54 120.25 212.513 120.25 212.487 120.25C212.46 120.25 212.433 120.25 212.406 120.25C212.379 120.25 212.352 120.25 212.326 120.25C212.299 120.25 212.272 120.25 212.245 120.25C212.219 120.25 212.192 120.25 212.165 120.25C212.139 120.25 212.112 120.25 212.085 120.25C212.059 120.25 212.032 120.25 212.005 120.25C211.979 120.25 211.952 120.25 211.926 120.25C211.899 120.25 211.873 120.25 211.846 120.25C211.82 120.25 211.793 120.25 211.767 120.25C211.74 120.25 211.714 120.25 211.687 120.25C211.661 120.25 211.635 120.25 211.608 120.25C211.582 120.25 211.556 120.25 211.529 120.25C211.503 120.25 211.477 120.25 211.45 120.25C211.424 120.25 211.398 120.25 211.372 120.25C211.345 120.25 211.319 120.25 211.293 120.25C211.267 120.25 211.241 120.25 211.215 120.25C211.189 120.25 211.162 120.25 211.136 120.25C211.11 120.25 211.084 120.25 211.058 120.25C211.032 120.25 211.006 120.25 210.98 120.25C210.954 120.25 210.928 120.25 210.902 120.25C210.876 120.25 210.851 120.25 210.825 120.25C210.799 120.25 210.773 120.25 210.747 120.25C210.721 120.25 210.696 120.25 210.67 120.25C210.644 120.25 210.618 120.25 210.593 120.25C210.567 120.25 210.541 120.25 210.515 120.25C210.49 120.25 210.464 120.25 210.439 120.25C210.413 120.25 210.387 120.25 210.362 120.25C210.336 120.25 210.311 120.25 210.285 120.25C210.26 120.25 210.234 120.25 210.209 120.25C210.183 120.25 210.158 120.25 210.133 120.25C210.107 120.25 210.082 120.25 210.056 120.25C210.031 120.25 210.006 120.25 209.981 120.25C209.955 120.25 209.93 120.25 209.905 120.25C209.88 120.25 209.854 120.25 209.829 120.25C209.804 120.25 209.779 120.25 209.754 120.25C209.729 120.25 209.704 120.25 209.679 120.25C209.653 120.25 209.628 120.25 209.603 120.25C209.578 120.25 209.554 120.25 209.529 120.25C209.504 120.25 209.479 120.25 209.454 120.25C209.429 120.25 209.404 120.25 209.379 120.25C209.354 120.25 209.33 120.25 209.305 120.25C209.28 120.25 209.255 120.25 209.231 120.25C209.206 120.25 209.181 120.25 209.157 120.25C209.132 120.25 209.107 120.25 209.083 120.25C209.058 120.25 209.034 120.25 209.009 120.25C208.985 120.25 208.96 120.25 208.936 120.25C208.911 120.25 208.887 120.25 208.862 120.25C208.838 120.25 208.814 120.25 208.789 120.25C208.765 120.25 208.741 120.25 208.716 120.25C208.692 120.25 208.668 120.25 208.644 120.25C208.62 120.25 208.595 120.25 208.571 120.25C208.547 120.25 208.523 120.25 208.499 120.25C208.475 120.25 208.451 120.25 208.427 120.25C208.403 120.25 208.379 120.25 208.355 120.25C208.331 120.25 208.307 120.25 208.283 120.25C208.259 120.25 208.235 120.25 208.211 120.25C208.188 120.25 208.164 120.25 208.14 120.25C208.116 120.25 208.093 120.25 208.069 120.25C208.045 120.25 208.021 120.25 207.998 120.25C207.974 120.25 207.951 120.25 207.927 120.25C207.904 120.25 207.88 120.25 207.857 120.25C207.833 120.25 207.81 120.25 207.786 120.25C207.763 120.25 207.739 120.25 207.716 120.25C207.693 120.25 207.669 120.25 207.646 120.25C207.623 120.25 207.599 120.25 207.576 120.25C207.553 120.25 207.53 120.25 207.507 120.25C207.484 120.25 207.46 120.25 207.437 120.25C207.414 120.25 207.391 120.25 207.368 120.25C207.345 120.25 207.322 120.25 207.299 120.25C207.276 120.25 207.254 120.25 207.231 120.25C207.208 120.25 207.185 120.25 207.162 120.25C207.139 120.25 207.117 120.25 207.094 120.25C207.071 120.25 207.049 120.25 207.026 120.25C207.003 120.25 206.981 120.25 206.958 120.25C206.935 120.25 206.913 120.25 206.89 120.25C206.868 120.25 206.845 120.25 206.823 120.25C206.801 120.25 206.778 120.25 206.756 120.25C206.733 120.25 206.711 120.25 206.689 120.25C206.667 120.25 206.644 120.25 206.622 120.25C206.6 120.25 206.578 120.25 206.556 120.25C206.534 120.25 206.511 120.25 206.489 120.25C206.467 120.25 206.445 120.25 206.423 120.25C206.401 120.25 206.379 120.25 206.357 120.25C206.336 120.25 206.314 120.25 206.292 120.25C206.27 120.25 206.248 120.25 206.227 120.25C206.205 120.25 206.183 120.25 206.161 120.25C206.14 120.25 206.118 120.25 206.097 120.25C206.075 120.25 206.053 120.25 206.032 120.25C206.01 120.25 205.989 120.25 205.967 120.25C205.946 120.25 205.925 120.25 205.903 120.25C205.882 120.25 205.861 120.25 205.839 120.25C205.818 120.25 205.797 120.25 205.776 120.25C205.754 120.25 205.733 120.25 205.712 120.25C205.691 120.25 205.67 120.25 205.649 120.25C205.628 120.25 205.607 120.25 205.586 120.25C205.565 120.25 205.544 120.25 205.523 120.25C205.502 120.25 205.481 120.25 205.461 120.25C205.44 120.25 205.419 120.25 205.398 120.25C205.378 120.25 205.357 120.25 205.336 120.25C205.316 120.25 205.295 120.25 205.275 120.25C205.254 120.25 205.234 120.25 205.213 120.25C205.193 120.25 205.172 120.25 205.152 120.25C205.132 120.25 205.111 120.25 205.091 120.25C205.071 120.25 205.05 120.25 205.03 120.25C205.01 120.25 204.99 120.25 204.97 120.25C204.95 120.25 204.93 120.25 204.91 120.25C204.89 120.25 204.87 120.25 204.85 120.25C204.83 120.25 204.81 120.25 204.79 120.25C204.77 120.25 204.75 120.25 204.73 120.25C204.711 120.25 204.691 120.25 204.671 120.25C204.652 120.25 204.632 120.25 204.612 120.25C204.593 120.25 204.573 120.25 204.554 120.25C204.534 120.25 204.515 120.25 204.495 120.25C204.476 120.25 204.457 120.25 204.437 120.25C204.418 120.25 204.399 120.25 204.379 120.25C204.36 120.25 204.341 120.25 204.322 120.25C204.303 120.25 204.284 120.25 204.264 120.25C204.245 120.25 204.226 120.25 204.207 120.25C204.188 120.25 204.17 120.25 204.151 120.25C204.132 120.25 204.113 120.25 204.094 120.25C204.075 120.25 204.057 120.25 204.038 120.25C204.019 120.25 204.001 120.25 203.982 120.25C203.963 120.25 203.945 120.25 203.926 120.25C203.908 120.25 203.889 120.25 203.871 120.25C203.853 120.25 203.834 120.25 203.816 120.25C203.798 120.25 203.779 120.25 203.761 120.25C203.743 120.25 203.725 120.25 203.707 120.25C203.688 120.25 203.67 120.25 203.652 120.25C203.634 120.25 203.616 120.25 203.598 120.25C203.58 120.25 203.562 120.25 203.545 120.25C203.527 120.25 203.509 120.25 203.491 120.25C203.474 120.25 203.456 120.25 203.438 120.25C203.42 120.25 203.403 120.25 203.385 120.25C203.368 120.25 203.35 120.25 203.333 120.25C203.315 120.25 203.298 120.25 203.281 120.25C203.263 120.25 203.246 120.25 203.229 120.25C203.211 120.25 203.194 120.25 203.177 120.25C203.16 120.25 203.143 120.25 203.126 120.25C203.109 120.25 203.092 120.25 203.075 120.25C203.058 120.25 203.041 120.25 203.024 120.25C203.007 120.25 202.99 120.25 202.973 120.25C202.957 120.25 202.94 120.25 202.923 120.25C202.907 120.25 202.89 120.25 202.873 120.25C202.857 120.25 202.84 120.25 202.824 120.25C202.807 120.25 202.791 120.25 202.775 120.25C202.758 120.25 202.742 120.25 202.726 120.25C202.709 120.25 202.693 120.25 202.677 120.25C202.661 120.25 202.645 120.25 202.629 120.25C202.613 120.25 202.597 120.25 202.581 120.25C202.565 120.25 202.549 120.25 202.533 120.25C202.517 120.25 202.501 120.25 202.486 120.25C202.47 120.25 202.454 120.25 202.439 120.25C202.423 120.25 202.407 120.25 202.392 120.25C202.376 120.25 202.361 120.25 202.345 120.25C202.33 120.25 202.315 120.25 202.299 120.25C202.284 120.25 202.269 120.25 202.254 120.25C202.238 120.25 202.223 120.25 202.208 120.25C202.193 120.25 202.178 120.25 202.163 120.25C202.148 120.25 202.133 120.25 202.118 120.25C202.103 120.25 202.088 120.25 202.074 120.25C202.059 120.25 202.044 120.25 202.029 120.25C202.015 120.25 202 120.25 201.986 120.25C201.971 120.25 201.956 120.25 201.942 120.25C201.928 120.25 201.913 120.25 201.899 120.25C201.884 120.25 201.87 120.25 201.856 120.25C201.842 120.25 201.828 120.25 201.813 120.25C201.799 120.25 201.785 120.25 201.771 120.25C201.757 120.25 201.743 120.25 201.729 120.25C201.715 120.25 201.702 120.25 201.688 120.25C201.674 120.25 201.66 120.25 201.647 120.25C201.633 120.25 201.619 120.25 201.606 120.25C201.592 120.25 201.579 120.25 201.565 120.25C201.552 120.25 201.538 120.25 201.525 120.25C201.512 120.25 201.498 120.25 201.485 120.25C201.472 120.25 201.459 120.25 201.446 120.25C201.432 120.25 201.419 120.25 201.406 120.25C201.393 120.25 201.38 120.25 201.368 120.25C201.355 120.25 201.342 120.25 201.329 120.25C201.316 120.25 201.304 120.25 201.291 120.25C201.278 120.25 201.266 120.25 201.253 120.25C201.241 120.25 201.228 120.25 201.216 120.25C201.203 120.25 201.191 120.25 201.179 120.25C201.166 120.25 201.154 120.25 201.142 120.25C201.13 120.25 201.118 120.25 201.106 120.25C201.093 120.25 201.081 120.25 201.07 120.25C201.058 120.25 201.046 120.25 201.034 120.25C201.022 120.25 201.01 120.25 200.999 120.25C200.987 120.25 200.975 120.25 200.964 120.25C200.952 120.25 200.94 120.25 200.929 120.25C200.917 120.25 200.906 120.25 200.895 120.25C200.883 120.25 200.872 120.25 200.861 120.25C200.85 120.25 200.838 120.25 200.827 120.25C200.816 120.25 200.805 120.25 200.794 120.25C200.783 120.25 200.772 120.25 200.761 120.25V118.75Z", fill: "url(#paint3_linear_38_7016)" }),
    /* @__PURE__ */ jsx("path", { d: "M164 52C164 49.7909 165.791 48 168 48C170.209 48 172 49.7909 172 52C172 54.2091 170.209 56 168 56C165.791 56 164 54.2091 164 52ZM238.53 51.4697C238.823 51.7626 238.823 52.2374 238.53 52.5303L233.757 57.3033C233.464 57.5962 232.99 57.5962 232.697 57.3033C232.404 57.0104 232.404 56.5355 232.697 56.2426L236.939 52L232.697 47.7574C232.404 47.4645 232.404 46.9896 232.697 46.6967C232.99 46.4038 233.464 46.4038 233.757 46.6967L238.53 51.4697ZM168 51.25C168.006 51.25 168.013 51.25 168.02 51.25C168.027 51.25 168.034 51.25 168.041 51.25C168.049 51.25 168.056 51.25 168.064 51.25C168.072 51.25 168.08 51.25 168.088 51.25C168.096 51.25 168.104 51.25 168.113 51.25C168.121 51.25 168.13 51.25 168.139 51.25C168.148 51.25 168.157 51.25 168.166 51.25C168.176 51.25 168.185 51.25 168.195 51.25C168.205 51.25 168.215 51.25 168.225 51.25C168.235 51.25 168.246 51.25 168.256 51.25C168.267 51.25 168.278 51.25 168.289 51.25C168.3 51.25 168.311 51.25 168.322 51.25C168.334 51.25 168.345 51.25 168.357 51.25C168.369 51.25 168.381 51.25 168.393 51.25C168.405 51.25 168.418 51.25 168.43 51.25C168.443 51.25 168.456 51.25 168.469 51.25C168.481 51.25 168.495 51.25 168.508 51.25C168.521 51.25 168.535 51.25 168.549 51.25C168.563 51.25 168.577 51.25 168.591 51.25C168.605 51.25 168.619 51.25 168.634 51.25C168.648 51.25 168.663 51.25 168.678 51.25C168.693 51.25 168.708 51.25 168.723 51.25C168.739 51.25 168.754 51.25 168.77 51.25C168.786 51.25 168.802 51.25 168.818 51.25C168.834 51.25 168.85 51.25 168.867 51.25C168.883 51.25 168.9 51.25 168.917 51.25C168.933 51.25 168.95 51.25 168.968 51.25C168.985 51.25 169.002 51.25 169.02 51.25C169.038 51.25 169.055 51.25 169.073 51.25C169.091 51.25 169.109 51.25 169.128 51.25C169.146 51.25 169.165 51.25 169.183 51.25C169.202 51.25 169.221 51.25 169.24 51.25C169.259 51.25 169.279 51.25 169.298 51.25C169.318 51.25 169.337 51.25 169.357 51.25C169.377 51.25 169.397 51.25 169.417 51.25C169.437 51.25 169.458 51.25 169.478 51.25C169.499 51.25 169.52 51.25 169.541 51.25C169.561 51.25 169.583 51.25 169.604 51.25C169.625 51.25 169.647 51.25 169.668 51.25C169.69 51.25 169.712 51.25 169.734 51.25C169.756 51.25 169.778 51.25 169.8 51.25C169.823 51.25 169.845 51.25 169.868 51.25C169.891 51.25 169.914 51.25 169.937 51.25C169.96 51.25 169.983 51.25 170.006 51.25C170.03 51.25 170.053 51.25 170.077 51.25C170.101 51.25 170.125 51.25 170.149 51.25C170.173 51.25 170.198 51.25 170.222 51.25C170.246 51.25 170.271 51.25 170.296 51.25C170.321 51.25 170.346 51.25 170.371 51.25C170.396 51.25 170.421 51.25 170.447 51.25C170.472 51.25 170.498 51.25 170.524 51.25C170.55 51.25 170.576 51.25 170.602 51.25C170.628 51.25 170.654 51.25 170.681 51.25C170.708 51.25 170.734 51.25 170.761 51.25C170.788 51.25 170.815 51.25 170.842 51.25C170.869 51.25 170.897 51.25 170.924 51.25C170.952 51.25 170.979 51.25 171.007 51.25C171.035 51.25 171.063 51.25 171.091 51.25C171.12 51.25 171.148 51.25 171.176 51.25C171.205 51.25 171.234 51.25 171.262 51.25C171.291 51.25 171.32 51.25 171.349 51.25C171.379 51.25 171.408 51.25 171.437 51.25C171.467 51.25 171.497 51.25 171.526 51.25C171.556 51.25 171.586 51.25 171.616 51.25C171.646 51.25 171.677 51.25 171.707 51.25C171.738 51.25 171.768 51.25 171.799 51.25C171.83 51.25 171.861 51.25 171.892 51.25C171.923 51.25 171.954 51.25 171.986 51.25C172.017 51.25 172.049 51.25 172.08 51.25C172.112 51.25 172.144 51.25 172.176 51.25C172.208 51.25 172.24 51.25 172.272 51.25C172.305 51.25 172.337 51.25 172.37 51.25C172.402 51.25 172.435 51.25 172.468 51.25C172.501 51.25 172.534 51.25 172.568 51.25C172.601 51.25 172.634 51.25 172.668 51.25C172.701 51.25 172.735 51.25 172.769 51.25C172.803 51.25 172.837 51.25 172.871 51.25C172.905 51.25 172.939 51.25 172.974 51.25C173.008 51.25 173.043 51.25 173.078 51.25C173.112 51.25 173.147 51.25 173.182 51.25C173.217 51.25 173.253 51.25 173.288 51.25C173.323 51.25 173.359 51.25 173.394 51.25C173.43 51.25 173.466 51.25 173.502 51.25C173.538 51.25 173.574 51.25 173.61 51.25C173.646 51.25 173.683 51.25 173.719 51.25C173.756 51.25 173.792 51.25 173.829 51.25C173.866 51.25 173.903 51.25 173.94 51.25C173.977 51.25 174.014 51.25 174.051 51.25C174.089 51.25 174.126 51.25 174.164 51.25C174.201 51.25 174.239 51.25 174.277 51.25C174.315 51.25 174.353 51.25 174.391 51.25C174.43 51.25 174.468 51.25 174.506 51.25C174.545 51.25 174.583 51.25 174.622 51.25C174.661 51.25 174.7 51.25 174.739 51.25C174.778 51.25 174.817 51.25 174.856 51.25C174.896 51.25 174.935 51.25 174.975 51.25C175.014 51.25 175.054 51.25 175.094 51.25C175.134 51.25 175.173 51.25 175.214 51.25C175.254 51.25 175.294 51.25 175.334 51.25C175.375 51.25 175.415 51.25 175.456 51.25C175.496 51.25 175.537 51.25 175.578 51.25C175.619 51.25 175.66 51.25 175.701 51.25C175.742 51.25 175.784 51.25 175.825 51.25C175.866 51.25 175.908 51.25 175.95 51.25C175.991 51.25 176.033 51.25 176.075 51.25C176.117 51.25 176.159 51.25 176.201 51.25C176.243 51.25 176.286 51.25 176.328 51.25C176.37 51.25 176.413 51.25 176.456 51.25C176.498 51.25 176.541 51.25 176.584 51.25C176.627 51.25 176.67 51.25 176.713 51.25C176.757 51.25 176.8 51.25 176.843 51.25C176.887 51.25 176.93 51.25 176.974 51.25C177.018 51.25 177.061 51.25 177.105 51.25C177.149 51.25 177.193 51.25 177.237 51.25C177.282 51.25 177.326 51.25 177.37 51.25C177.415 51.25 177.459 51.25 177.504 51.25C177.548 51.25 177.593 51.25 177.638 51.25C177.683 51.25 177.728 51.25 177.773 51.25C177.818 51.25 177.863 51.25 177.909 51.25C177.954 51.25 178 51.25 178.045 51.25C178.091 51.25 178.136 51.25 178.182 51.25C178.228 51.25 178.274 51.25 178.32 51.25C178.366 51.25 178.412 51.25 178.459 51.25C178.505 51.25 178.551 51.25 178.598 51.25C178.644 51.25 178.691 51.25 178.738 51.25C178.784 51.25 178.831 51.25 178.878 51.25C178.925 51.25 178.972 51.25 179.019 51.25C179.066 51.25 179.114 51.25 179.161 51.25C179.208 51.25 179.256 51.25 179.304 51.25C179.351 51.25 179.399 51.25 179.447 51.25C179.495 51.25 179.542 51.25 179.59 51.25C179.639 51.25 179.687 51.25 179.735 51.25C179.783 51.25 179.832 51.25 179.88 51.25C179.928 51.25 179.977 51.25 180.026 51.25C180.074 51.25 180.123 51.25 180.172 51.25C180.221 51.25 180.27 51.25 180.319 51.25C180.368 51.25 180.417 51.25 180.467 51.25C180.516 51.25 180.565 51.25 180.615 51.25C180.664 51.25 180.714 51.25 180.764 51.25C180.813 51.25 180.863 51.25 180.913 51.25C180.963 51.25 181.013 51.25 181.063 51.25C181.113 51.25 181.163 51.25 181.214 51.25C181.264 51.25 181.314 51.25 181.365 51.25C181.415 51.25 181.466 51.25 181.517 51.25C181.567 51.25 181.618 51.25 181.669 51.25C181.72 51.25 181.771 51.25 181.822 51.25C181.873 51.25 181.924 51.25 181.976 51.25C182.027 51.25 182.078 51.25 182.13 51.25C182.181 51.25 182.233 51.25 182.284 51.25C182.336 51.25 182.388 51.25 182.44 51.25C182.492 51.25 182.544 51.25 182.596 51.25C182.648 51.25 182.7 51.25 182.752 51.25C182.804 51.25 182.856 51.25 182.909 51.25C182.961 51.25 183.014 51.25 183.066 51.25C183.119 51.25 183.171 51.25 183.224 51.25C183.277 51.25 183.33 51.25 183.383 51.25C183.436 51.25 183.489 51.25 183.542 51.25C183.595 51.25 183.648 51.25 183.701 51.25C183.755 51.25 183.808 51.25 183.861 51.25C183.915 51.25 183.968 51.25 184.022 51.25C184.076 51.25 184.129 51.25 184.183 51.25C184.237 51.25 184.291 51.25 184.345 51.25C184.399 51.25 184.453 51.25 184.507 51.25C184.561 51.25 184.615 51.25 184.669 51.25C184.724 51.25 184.778 51.25 184.832 51.25C184.887 51.25 184.941 51.25 184.996 51.25C185.05 51.25 185.105 51.25 185.16 51.25C185.215 51.25 185.27 51.25 185.324 51.25C185.379 51.25 185.434 51.25 185.489 51.25C185.545 51.25 185.6 51.25 185.655 51.25C185.71 51.25 185.765 51.25 185.821 51.25C185.876 51.25 185.932 51.25 185.987 51.25C186.043 51.25 186.098 51.25 186.154 51.25C186.21 51.25 186.265 51.25 186.321 51.25C186.377 51.25 186.433 51.25 186.489 51.25C186.545 51.25 186.601 51.25 186.657 51.25C186.713 51.25 186.769 51.25 186.826 51.25C186.882 51.25 186.938 51.25 186.995 51.25C187.051 51.25 187.108 51.25 187.164 51.25C187.221 51.25 187.277 51.25 187.334 51.25C187.391 51.25 187.447 51.25 187.504 51.25C187.561 51.25 187.618 51.25 187.675 51.25C187.732 51.25 187.789 51.25 187.846 51.25C187.903 51.25 187.96 51.25 188.018 51.25C188.075 51.25 188.132 51.25 188.189 51.25C188.247 51.25 188.304 51.25 188.362 51.25C188.419 51.25 188.477 51.25 188.534 51.25C188.592 51.25 188.65 51.25 188.707 51.25C188.765 51.25 188.823 51.25 188.881 51.25C188.939 51.25 188.997 51.25 189.055 51.25C189.113 51.25 189.171 51.25 189.229 51.25C189.287 51.25 189.345 51.25 189.403 51.25C189.462 51.25 189.52 51.25 189.578 51.25C189.637 51.25 189.695 51.25 189.753 51.25C189.812 51.25 189.87 51.25 189.929 51.25C189.988 51.25 190.046 51.25 190.105 51.25C190.164 51.25 190.222 51.25 190.281 51.25C190.34 51.25 190.399 51.25 190.458 51.25C190.517 51.25 190.576 51.25 190.635 51.25C190.694 51.25 190.753 51.25 190.812 51.25C190.871 51.25 190.93 51.25 190.989 51.25C191.049 51.25 191.108 51.25 191.167 51.25C191.227 51.25 191.286 51.25 191.346 51.25C191.405 51.25 191.465 51.25 191.524 51.25C191.584 51.25 191.643 51.25 191.703 51.25C191.763 51.25 191.822 51.25 191.882 51.25C191.942 51.25 192.002 51.25 192.061 51.25C192.121 51.25 192.181 51.25 192.241 51.25C192.301 51.25 192.361 51.25 192.421 51.25C192.481 51.25 192.541 51.25 192.601 51.25C192.661 51.25 192.722 51.25 192.782 51.25C192.842 51.25 192.902 51.25 192.963 51.25C193.023 51.25 193.083 51.25 193.144 51.25C193.204 51.25 193.265 51.25 193.325 51.25C193.385 51.25 193.446 51.25 193.507 51.25C193.567 51.25 193.628 51.25 193.688 51.25C193.749 51.25 193.81 51.25 193.87 51.25C193.931 51.25 193.992 51.25 194.053 51.25C194.114 51.25 194.174 51.25 194.235 51.25C194.296 51.25 194.357 51.25 194.418 51.25C194.479 51.25 194.54 51.25 194.601 51.25C194.662 51.25 194.723 51.25 194.784 51.25C194.845 51.25 194.907 51.25 194.968 51.25C195.029 51.25 195.09 51.25 195.151 51.25C195.213 51.25 195.274 51.25 195.335 51.25C195.397 51.25 195.458 51.25 195.519 51.25C195.581 51.25 195.642 51.25 195.704 51.25C195.765 51.25 195.826 51.25 195.888 51.25C195.949 51.25 196.011 51.25 196.073 51.25C196.134 51.25 196.196 51.25 196.257 51.25C196.319 51.25 196.381 51.25 196.442 51.25C196.504 51.25 196.566 51.25 196.628 51.25C196.689 51.25 196.751 51.25 196.813 51.25C196.875 51.25 196.937 51.25 196.998 51.25C197.06 51.25 197.122 51.25 197.184 51.25C197.246 51.25 197.308 51.25 197.37 51.25C197.432 51.25 197.494 51.25 197.556 51.25C197.618 51.25 197.68 51.25 197.742 51.25C197.804 51.25 197.866 51.25 197.928 51.25C197.991 51.25 198.053 51.25 198.115 51.25C198.177 51.25 198.239 51.25 198.301 51.25C198.364 51.25 198.426 51.25 198.488 51.25C198.55 51.25 198.613 51.25 198.675 51.25C198.737 51.25 198.799 51.25 198.862 51.25C198.924 51.25 198.986 51.25 199.049 51.25C199.111 51.25 199.174 51.25 199.236 51.25C199.298 51.25 199.361 51.25 199.423 51.25C199.486 51.25 199.548 51.25 199.61 51.25C199.673 51.25 199.735 51.25 199.798 51.25C199.86 51.25 199.923 51.25 199.985 51.25C200.048 51.25 200.111 51.25 200.173 51.25C200.236 51.25 200.298 51.25 200.361 51.25C200.423 51.25 200.486 51.25 200.549 51.25C200.611 51.25 200.674 51.25 200.736 51.25C200.799 51.25 200.862 51.25 200.924 51.25C200.987 51.25 201.05 51.25 201.112 51.25C201.175 51.25 201.238 51.25 201.3 51.25C201.363 51.25 201.426 51.25 201.488 51.25C201.551 51.25 201.614 51.25 201.677 51.25C201.739 51.25 201.802 51.25 201.865 51.25C201.927 51.25 201.99 51.25 202.053 51.25C202.116 51.25 202.178 51.25 202.241 51.25C202.304 51.25 202.367 51.25 202.429 51.25C202.492 51.25 202.555 51.25 202.618 51.25C202.68 51.25 202.743 51.25 202.806 51.25C202.869 51.25 202.932 51.25 202.994 51.25C203.057 51.25 203.12 51.25 203.183 51.25C203.246 51.25 203.308 51.25 203.371 51.25C203.434 51.25 203.497 51.25 203.559 51.25C203.622 51.25 203.685 51.25 203.748 51.25C203.811 51.25 203.873 51.25 203.936 51.25C203.999 51.25 204.062 51.25 204.124 51.25C204.187 51.25 204.25 51.25 204.313 51.25C204.376 51.25 204.438 51.25 204.501 51.25C204.564 51.25 204.627 51.25 204.689 51.25C204.752 51.25 204.815 51.25 204.878 51.25C204.94 51.25 205.003 51.25 205.066 51.25C205.128 51.25 205.191 51.25 205.254 51.25C205.317 51.25 205.379 51.25 205.442 51.25C205.505 51.25 205.567 51.25 205.63 51.25C205.693 51.25 205.755 51.25 205.818 51.25C205.881 51.25 205.943 51.25 206.006 51.25C206.069 51.25 206.131 51.25 206.194 51.25C206.257 51.25 206.319 51.25 206.382 51.25C206.444 51.25 206.507 51.25 206.569 51.25C206.632 51.25 206.695 51.25 206.757 51.25C206.82 51.25 206.882 51.25 206.945 51.25C207.007 51.25 207.07 51.25 207.132 51.25C207.195 51.25 207.257 51.25 207.32 51.25C207.382 51.25 207.444 51.25 207.507 51.25C207.569 51.25 207.632 51.25 207.694 51.25C207.756 51.25 207.819 51.25 207.881 51.25C207.943 51.25 208.006 51.25 208.068 51.25C208.13 51.25 208.193 51.25 208.255 51.25C208.317 51.25 208.379 51.25 208.442 51.25C208.504 51.25 208.566 51.25 208.628 51.25C208.691 51.25 208.753 51.25 208.815 51.25C208.877 51.25 208.939 51.25 209.001 51.25C209.063 51.25 209.125 51.25 209.187 51.25C209.249 51.25 209.311 51.25 209.373 51.25C209.435 51.25 209.497 51.25 209.559 51.25C209.621 51.25 209.683 51.25 209.745 51.25C209.807 51.25 209.869 51.25 209.931 51.25C209.993 51.25 210.054 51.25 210.116 51.25C210.178 51.25 210.24 51.25 210.301 51.25C210.363 51.25 210.425 51.25 210.487 51.25C210.548 51.25 210.61 51.25 210.671 51.25C210.733 51.25 210.795 51.25 210.856 51.25C210.918 51.25 210.979 51.25 211.041 51.25C211.102 51.25 211.164 51.25 211.225 51.25C211.287 51.25 211.348 51.25 211.409 51.25C211.471 51.25 211.532 51.25 211.593 51.25C211.655 51.25 211.716 51.25 211.777 51.25C211.838 51.25 211.899 51.25 211.961 51.25C212.022 51.25 212.083 51.25 212.144 51.25C212.205 51.25 212.266 51.25 212.327 51.25C212.388 51.25 212.449 51.25 212.51 51.25C212.571 51.25 212.632 51.25 212.693 51.25C212.753 51.25 212.814 51.25 212.875 51.25C212.936 51.25 212.997 51.25 213.057 51.25C213.118 51.25 213.179 51.25 213.239 51.25C213.3 51.25 213.36 51.25 213.421 51.25C213.481 51.25 213.542 51.25 213.602 51.25C213.663 51.25 213.723 51.25 213.784 51.25C213.844 51.25 213.904 51.25 213.964 51.25C214.025 51.25 214.085 51.25 214.145 51.25C214.205 51.25 214.265 51.25 214.325 51.25C214.386 51.25 214.446 51.25 214.506 51.25C214.566 51.25 214.626 51.25 214.685 51.25C214.745 51.25 214.805 51.25 214.865 51.25C214.925 51.25 214.985 51.25 215.044 51.25C215.104 51.25 215.164 51.25 215.223 51.25C215.283 51.25 215.342 51.25 215.402 51.25C215.461 51.25 215.521 51.25 215.58 51.25C215.64 51.25 215.699 51.25 215.758 51.25C215.818 51.25 215.877 51.25 215.936 51.25C215.995 51.25 216.054 51.25 216.114 51.25C216.173 51.25 216.232 51.25 216.291 51.25C216.35 51.25 216.409 51.25 216.467 51.25C216.526 51.25 216.585 51.25 216.644 51.25C216.703 51.25 216.761 51.25 216.82 51.25C216.879 51.25 216.937 51.25 216.996 51.25C217.054 51.25 217.113 51.25 217.171 51.25C217.23 51.25 217.288 51.25 217.346 51.25C217.404 51.25 217.463 51.25 217.521 51.25C217.579 51.25 217.637 51.25 217.695 51.25C217.753 51.25 217.811 51.25 217.869 51.25C217.927 51.25 217.985 51.25 218.043 51.25C218.101 51.25 218.158 51.25 218.216 51.25C218.274 51.25 218.331 51.25 218.389 51.25C218.447 51.25 218.504 51.25 218.561 51.25C218.619 51.25 218.676 51.25 218.734 51.25C218.791 51.25 218.848 51.25 218.905 51.25C218.962 51.25 219.02 51.25 219.077 51.25C219.134 51.25 219.191 51.25 219.247 51.25C219.304 51.25 219.361 51.25 219.418 51.25C219.475 51.25 219.531 51.25 219.588 51.25C219.645 51.25 219.701 51.25 219.758 51.25C219.814 51.25 219.871 51.25 219.927 51.25C219.983 51.25 220.04 51.25 220.096 51.25C220.152 51.25 220.208 51.25 220.264 51.25C220.32 51.25 220.376 51.25 220.432 51.25C220.488 51.25 220.544 51.25 220.6 51.25C220.655 51.25 220.711 51.25 220.767 51.25C220.822 51.25 220.878 51.25 220.933 51.25C220.989 51.25 221.044 51.25 221.099 51.25C221.155 51.25 221.21 51.25 221.265 51.25C221.32 51.25 221.375 51.25 221.43 51.25C221.485 51.25 221.54 51.25 221.595 51.25C221.65 51.25 221.705 51.25 221.759 51.25C221.814 51.25 221.869 51.25 221.923 51.25C221.978 51.25 222.032 51.25 222.087 51.25C222.141 51.25 222.195 51.25 222.249 51.25C222.304 51.25 222.358 51.25 222.412 51.25C222.466 51.25 222.52 51.25 222.574 51.25C222.628 51.25 222.681 51.25 222.735 51.25C222.789 51.25 222.842 51.25 222.896 51.25C222.949 51.25 223.003 51.25 223.056 51.25C223.11 51.25 223.163 51.25 223.216 51.25C223.269 51.25 223.322 51.25 223.375 51.25C223.428 51.25 223.481 51.25 223.534 51.25C223.587 51.25 223.64 51.25 223.692 51.25C223.745 51.25 223.798 51.25 223.85 51.25C223.903 51.25 223.955 51.25 224.007 51.25C224.06 51.25 224.112 51.25 224.164 51.25C224.216 51.25 224.268 51.25 224.32 51.25C224.372 51.25 224.424 51.25 224.476 51.25C224.527 51.25 224.579 51.25 224.631 51.25C224.682 51.25 224.734 51.25 224.785 51.25C224.836 51.25 224.888 51.25 224.939 51.25C224.99 51.25 225.041 51.25 225.092 51.25C225.143 51.25 225.194 51.25 225.245 51.25C225.296 51.25 225.346 51.25 225.397 51.25C225.448 51.25 225.498 51.25 225.549 51.25C225.599 51.25 225.649 51.25 225.699 51.25C225.75 51.25 225.8 51.25 225.85 51.25C225.9 51.25 225.95 51.25 226 51.25C226.049 51.25 226.099 51.25 226.149 51.25C226.198 51.25 226.248 51.25 226.297 51.25C226.347 51.25 226.396 51.25 226.445 51.25C226.494 51.25 226.544 51.25 226.593 51.25C226.642 51.25 226.69 51.25 226.739 51.25C226.788 51.25 226.837 51.25 226.885 51.25C226.934 51.25 226.982 51.25 227.031 51.25C227.079 51.25 227.127 51.25 227.175 51.25C227.224 51.25 227.272 51.25 227.32 51.25C227.368 51.25 227.415 51.25 227.463 51.25C227.511 51.25 227.558 51.25 227.606 51.25C227.653 51.25 227.701 51.25 227.748 51.25C227.795 51.25 227.843 51.25 227.89 51.25C227.937 51.25 227.984 51.25 228.031 51.25C228.077 51.25 228.124 51.25 228.171 51.25C228.217 51.25 228.264 51.25 228.31 51.25C228.357 51.25 228.403 51.25 228.449 51.25C228.495 51.25 228.541 51.25 228.587 51.25C228.633 51.25 228.679 51.25 228.725 51.25C228.77 51.25 228.816 51.25 228.862 51.25C228.907 51.25 228.952 51.25 228.998 51.25C229.043 51.25 229.088 51.25 229.133 51.25C229.178 51.25 229.223 51.25 229.268 51.25C229.312 51.25 229.357 51.25 229.402 51.25C229.446 51.25 229.491 51.25 229.535 51.25C229.579 51.25 229.623 51.25 229.667 51.25C229.711 51.25 229.755 51.25 229.799 51.25C229.843 51.25 229.887 51.25 229.93 51.25C229.974 51.25 230.017 51.25 230.06 51.25C230.104 51.25 230.147 51.25 230.19 51.25C230.233 51.25 230.276 51.25 230.319 51.25C230.362 51.25 230.404 51.25 230.447 51.25C230.49 51.25 230.532 51.25 230.574 51.25C230.617 51.25 230.659 51.25 230.701 51.25C230.743 51.25 230.785 51.25 230.827 51.25C230.869 51.25 230.91 51.25 230.952 51.25C230.993 51.25 231.035 51.25 231.076 51.25C231.117 51.25 231.158 51.25 231.199 51.25C231.241 51.25 231.281 51.25 231.322 51.25C231.363 51.25 231.404 51.25 231.444 51.25C231.485 51.25 231.525 51.25 231.565 51.25C231.605 51.25 231.646 51.25 231.686 51.25C231.726 51.25 231.765 51.25 231.805 51.25C231.845 51.25 231.884 51.25 231.924 51.25C231.963 51.25 232.003 51.25 232.042 51.25C232.081 51.25 232.12 51.25 232.159 51.25C232.198 51.25 232.236 51.25 232.275 51.25C232.314 51.25 232.352 51.25 232.391 51.25C232.429 51.25 232.467 51.25 232.505 51.25C232.543 51.25 232.581 51.25 232.619 51.25C232.657 51.25 232.694 51.25 232.732 51.25C232.769 51.25 232.807 51.25 232.844 51.25C232.881 51.25 232.918 51.25 232.955 51.25C232.992 51.25 233.029 51.25 233.066 51.25C233.102 51.25 233.139 51.25 233.175 51.25C233.212 51.25 233.248 51.25 233.284 51.25C233.32 51.25 233.356 51.25 233.392 51.25C233.427 51.25 233.463 51.25 233.499 51.25C233.534 51.25 233.569 51.25 233.605 51.25C233.64 51.25 233.675 51.25 233.71 51.25C233.745 51.25 233.78 51.25 233.814 51.25C233.849 51.25 233.883 51.25 233.918 51.25C233.952 51.25 233.986 51.25 234.02 51.25C234.054 51.25 234.088 51.25 234.122 51.25C234.155 51.25 234.189 51.25 234.222 51.25C234.256 51.25 234.289 51.25 234.322 51.25C234.355 51.25 234.388 51.25 234.421 51.25C234.454 51.25 234.486 51.25 234.519 51.25C234.551 51.25 234.584 51.25 234.616 51.25C234.648 51.25 234.68 51.25 234.712 51.25C234.744 51.25 234.776 51.25 234.807 51.25C234.839 51.25 234.87 51.25 234.902 51.25C234.933 51.25 234.964 51.25 234.995 51.25C235.026 51.25 235.057 51.25 235.087 51.25C235.118 51.25 235.148 51.25 235.179 51.25C235.209 51.25 235.239 51.25 235.269 51.25C235.299 51.25 235.329 51.25 235.358 51.25C235.388 51.25 235.418 51.25 235.447 51.25C235.476 51.25 235.506 51.25 235.535 51.25C235.564 51.25 235.592 51.25 235.621 51.25C235.65 51.25 235.678 51.25 235.707 51.25C235.735 51.25 235.763 51.25 235.791 51.25C235.819 51.25 235.847 51.25 235.875 51.25C235.903 51.25 235.93 51.25 235.958 51.25C235.985 51.25 236.012 51.25 236.039 51.25C236.066 51.25 236.093 51.25 236.12 51.25C236.146 51.25 236.173 51.25 236.199 51.25C236.226 51.25 236.252 51.25 236.278 51.25C236.304 51.25 236.33 51.25 236.356 51.25C236.381 51.25 236.407 51.25 236.432 51.25C236.457 51.25 236.483 51.25 236.508 51.25C236.533 51.25 236.557 51.25 236.582 51.25C236.607 51.25 236.631 51.25 236.656 51.25C236.68 51.25 236.704 51.25 236.728 51.25C236.752 51.25 236.776 51.25 236.799 51.25C236.823 51.25 236.846 51.25 236.87 51.25C236.893 51.25 236.916 51.25 236.939 51.25C236.962 51.25 236.985 51.25 237.007 51.25C237.03 51.25 237.052 51.25 237.074 51.25C237.097 51.25 237.119 51.25 237.14 51.25C237.162 51.25 237.184 51.25 237.205 51.25C237.227 51.25 237.248 51.25 237.269 51.25C237.29 51.25 237.311 51.25 237.332 51.25C237.353 51.25 237.373 51.25 237.394 51.25C237.414 51.25 237.435 51.25 237.455 51.25C237.475 51.25 237.494 51.25 237.514 51.25C237.534 51.25 237.553 51.25 237.573 51.25C237.592 51.25 237.611 51.25 237.63 51.25C237.649 51.25 237.668 51.25 237.686 51.25C237.705 51.25 237.723 51.25 237.741 51.25C237.759 51.25 237.777 51.25 237.795 51.25C237.813 51.25 237.831 51.25 237.848 51.25C237.866 51.25 237.883 51.25 237.9 51.25C237.917 51.25 237.934 51.25 237.951 51.25C237.967 51.25 237.984 51.25 238 51.25V52.75C237.984 52.75 237.967 52.75 237.951 52.75C237.934 52.75 237.917 52.75 237.9 52.75C237.883 52.75 237.866 52.75 237.848 52.75C237.831 52.75 237.813 52.75 237.795 52.75C237.777 52.75 237.759 52.75 237.741 52.75C237.723 52.75 237.705 52.75 237.686 52.75C237.668 52.75 237.649 52.75 237.63 52.75C237.611 52.75 237.592 52.75 237.573 52.75C237.553 52.75 237.534 52.75 237.514 52.75C237.494 52.75 237.475 52.75 237.455 52.75C237.435 52.75 237.414 52.75 237.394 52.75C237.373 52.75 237.353 52.75 237.332 52.75C237.311 52.75 237.29 52.75 237.269 52.75C237.248 52.75 237.227 52.75 237.205 52.75C237.184 52.75 237.162 52.75 237.14 52.75C237.119 52.75 237.097 52.75 237.074 52.75C237.052 52.75 237.03 52.75 237.007 52.75C236.985 52.75 236.962 52.75 236.939 52.75C236.916 52.75 236.893 52.75 236.87 52.75C236.846 52.75 236.823 52.75 236.799 52.75C236.776 52.75 236.752 52.75 236.728 52.75C236.704 52.75 236.68 52.75 236.656 52.75C236.631 52.75 236.607 52.75 236.582 52.75C236.557 52.75 236.533 52.75 236.508 52.75C236.483 52.75 236.457 52.75 236.432 52.75C236.407 52.75 236.381 52.75 236.356 52.75C236.33 52.75 236.304 52.75 236.278 52.75C236.252 52.75 236.226 52.75 236.199 52.75C236.173 52.75 236.146 52.75 236.12 52.75C236.093 52.75 236.066 52.75 236.039 52.75C236.012 52.75 235.985 52.75 235.958 52.75C235.93 52.75 235.903 52.75 235.875 52.75C235.847 52.75 235.819 52.75 235.791 52.75C235.763 52.75 235.735 52.75 235.707 52.75C235.678 52.75 235.65 52.75 235.621 52.75C235.592 52.75 235.564 52.75 235.535 52.75C235.506 52.75 235.476 52.75 235.447 52.75C235.418 52.75 235.388 52.75 235.358 52.75C235.329 52.75 235.299 52.75 235.269 52.75C235.239 52.75 235.209 52.75 235.179 52.75C235.148 52.75 235.118 52.75 235.087 52.75C235.057 52.75 235.026 52.75 234.995 52.75C234.964 52.75 234.933 52.75 234.902 52.75C234.87 52.75 234.839 52.75 234.807 52.75C234.776 52.75 234.744 52.75 234.712 52.75C234.68 52.75 234.648 52.75 234.616 52.75C234.584 52.75 234.551 52.75 234.519 52.75C234.486 52.75 234.454 52.75 234.421 52.75C234.388 52.75 234.355 52.75 234.322 52.75C234.289 52.75 234.256 52.75 234.222 52.75C234.189 52.75 234.155 52.75 234.122 52.75C234.088 52.75 234.054 52.75 234.02 52.75C233.986 52.75 233.952 52.75 233.918 52.75C233.883 52.75 233.849 52.75 233.814 52.75C233.78 52.75 233.745 52.75 233.71 52.75C233.675 52.75 233.64 52.75 233.605 52.75C233.569 52.75 233.534 52.75 233.499 52.75C233.463 52.75 233.427 52.75 233.392 52.75C233.356 52.75 233.32 52.75 233.284 52.75C233.248 52.75 233.212 52.75 233.175 52.75C233.139 52.75 233.102 52.75 233.066 52.75C233.029 52.75 232.992 52.75 232.955 52.75C232.918 52.75 232.881 52.75 232.844 52.75C232.807 52.75 232.769 52.75 232.732 52.75C232.694 52.75 232.657 52.75 232.619 52.75C232.581 52.75 232.543 52.75 232.505 52.75C232.467 52.75 232.429 52.75 232.391 52.75C232.352 52.75 232.314 52.75 232.275 52.75C232.236 52.75 232.198 52.75 232.159 52.75C232.12 52.75 232.081 52.75 232.042 52.75C232.003 52.75 231.963 52.75 231.924 52.75C231.884 52.75 231.845 52.75 231.805 52.75C231.765 52.75 231.726 52.75 231.686 52.75C231.646 52.75 231.605 52.75 231.565 52.75C231.525 52.75 231.485 52.75 231.444 52.75C231.404 52.75 231.363 52.75 231.322 52.75C231.281 52.75 231.241 52.75 231.199 52.75C231.158 52.75 231.117 52.75 231.076 52.75C231.035 52.75 230.993 52.75 230.952 52.75C230.91 52.75 230.869 52.75 230.827 52.75C230.785 52.75 230.743 52.75 230.701 52.75C230.659 52.75 230.617 52.75 230.574 52.75C230.532 52.75 230.49 52.75 230.447 52.75C230.404 52.75 230.362 52.75 230.319 52.75C230.276 52.75 230.233 52.75 230.19 52.75C230.147 52.75 230.104 52.75 230.06 52.75C230.017 52.75 229.974 52.75 229.93 52.75C229.887 52.75 229.843 52.75 229.799 52.75C229.755 52.75 229.711 52.75 229.667 52.75C229.623 52.75 229.579 52.75 229.535 52.75C229.491 52.75 229.446 52.75 229.402 52.75C229.357 52.75 229.312 52.75 229.268 52.75C229.223 52.75 229.178 52.75 229.133 52.75C229.088 52.75 229.043 52.75 228.998 52.75C228.952 52.75 228.907 52.75 228.862 52.75C228.816 52.75 228.77 52.75 228.725 52.75C228.679 52.75 228.633 52.75 228.587 52.75C228.541 52.75 228.495 52.75 228.449 52.75C228.403 52.75 228.357 52.75 228.31 52.75C228.264 52.75 228.217 52.75 228.171 52.75C228.124 52.75 228.077 52.75 228.031 52.75C227.984 52.75 227.937 52.75 227.89 52.75C227.843 52.75 227.795 52.75 227.748 52.75C227.701 52.75 227.653 52.75 227.606 52.75C227.558 52.75 227.511 52.75 227.463 52.75C227.415 52.75 227.368 52.75 227.32 52.75C227.272 52.75 227.224 52.75 227.175 52.75C227.127 52.75 227.079 52.75 227.031 52.75C226.982 52.75 226.934 52.75 226.885 52.75C226.837 52.75 226.788 52.75 226.739 52.75C226.69 52.75 226.642 52.75 226.593 52.75C226.544 52.75 226.494 52.75 226.445 52.75C226.396 52.75 226.347 52.75 226.297 52.75C226.248 52.75 226.198 52.75 226.149 52.75C226.099 52.75 226.049 52.75 226 52.75C225.95 52.75 225.9 52.75 225.85 52.75C225.8 52.75 225.75 52.75 225.699 52.75C225.649 52.75 225.599 52.75 225.549 52.75C225.498 52.75 225.448 52.75 225.397 52.75C225.346 52.75 225.296 52.75 225.245 52.75C225.194 52.75 225.143 52.75 225.092 52.75C225.041 52.75 224.99 52.75 224.939 52.75C224.888 52.75 224.836 52.75 224.785 52.75C224.734 52.75 224.682 52.75 224.631 52.75C224.579 52.75 224.527 52.75 224.476 52.75C224.424 52.75 224.372 52.75 224.32 52.75C224.268 52.75 224.216 52.75 224.164 52.75C224.112 52.75 224.06 52.75 224.007 52.75C223.955 52.75 223.903 52.75 223.85 52.75C223.798 52.75 223.745 52.75 223.692 52.75C223.64 52.75 223.587 52.75 223.534 52.75C223.481 52.75 223.428 52.75 223.375 52.75C223.322 52.75 223.269 52.75 223.216 52.75C223.163 52.75 223.11 52.75 223.056 52.75C223.003 52.75 222.949 52.75 222.896 52.75C222.842 52.75 222.789 52.75 222.735 52.75C222.681 52.75 222.628 52.75 222.574 52.75C222.52 52.75 222.466 52.75 222.412 52.75C222.358 52.75 222.304 52.75 222.249 52.75C222.195 52.75 222.141 52.75 222.087 52.75C222.032 52.75 221.978 52.75 221.923 52.75C221.869 52.75 221.814 52.75 221.759 52.75C221.705 52.75 221.65 52.75 221.595 52.75C221.54 52.75 221.485 52.75 221.43 52.75C221.375 52.75 221.32 52.75 221.265 52.75C221.21 52.75 221.155 52.75 221.099 52.75C221.044 52.75 220.989 52.75 220.933 52.75C220.878 52.75 220.822 52.75 220.767 52.75C220.711 52.75 220.655 52.75 220.6 52.75C220.544 52.75 220.488 52.75 220.432 52.75C220.376 52.75 220.32 52.75 220.264 52.75C220.208 52.75 220.152 52.75 220.096 52.75C220.04 52.75 219.983 52.75 219.927 52.75C219.871 52.75 219.814 52.75 219.758 52.75C219.701 52.75 219.645 52.75 219.588 52.75C219.531 52.75 219.475 52.75 219.418 52.75C219.361 52.75 219.304 52.75 219.247 52.75C219.191 52.75 219.134 52.75 219.077 52.75C219.02 52.75 218.962 52.75 218.905 52.75C218.848 52.75 218.791 52.75 218.734 52.75C218.676 52.75 218.619 52.75 218.561 52.75C218.504 52.75 218.447 52.75 218.389 52.75C218.331 52.75 218.274 52.75 218.216 52.75C218.158 52.75 218.101 52.75 218.043 52.75C217.985 52.75 217.927 52.75 217.869 52.75C217.811 52.75 217.753 52.75 217.695 52.75C217.637 52.75 217.579 52.75 217.521 52.75C217.463 52.75 217.404 52.75 217.346 52.75C217.288 52.75 217.23 52.75 217.171 52.75C217.113 52.75 217.054 52.75 216.996 52.75C216.937 52.75 216.879 52.75 216.82 52.75C216.761 52.75 216.703 52.75 216.644 52.75C216.585 52.75 216.526 52.75 216.467 52.75C216.409 52.75 216.35 52.75 216.291 52.75C216.232 52.75 216.173 52.75 216.114 52.75C216.054 52.75 215.995 52.75 215.936 52.75C215.877 52.75 215.818 52.75 215.758 52.75C215.699 52.75 215.64 52.75 215.58 52.75C215.521 52.75 215.461 52.75 215.402 52.75C215.342 52.75 215.283 52.75 215.223 52.75C215.164 52.75 215.104 52.75 215.044 52.75C214.985 52.75 214.925 52.75 214.865 52.75C214.805 52.75 214.745 52.75 214.685 52.75C214.626 52.75 214.566 52.75 214.506 52.75C214.446 52.75 214.386 52.75 214.325 52.75C214.265 52.75 214.205 52.75 214.145 52.75C214.085 52.75 214.025 52.75 213.964 52.75C213.904 52.75 213.844 52.75 213.784 52.75C213.723 52.75 213.663 52.75 213.602 52.75C213.542 52.75 213.481 52.75 213.421 52.75C213.36 52.75 213.3 52.75 213.239 52.75C213.179 52.75 213.118 52.75 213.057 52.75C212.997 52.75 212.936 52.75 212.875 52.75C212.814 52.75 212.753 52.75 212.693 52.75C212.632 52.75 212.571 52.75 212.51 52.75C212.449 52.75 212.388 52.75 212.327 52.75C212.266 52.75 212.205 52.75 212.144 52.75C212.083 52.75 212.022 52.75 211.961 52.75C211.899 52.75 211.838 52.75 211.777 52.75C211.716 52.75 211.655 52.75 211.593 52.75C211.532 52.75 211.471 52.75 211.409 52.75C211.348 52.75 211.287 52.75 211.225 52.75C211.164 52.75 211.102 52.75 211.041 52.75C210.979 52.75 210.918 52.75 210.856 52.75C210.795 52.75 210.733 52.75 210.671 52.75C210.61 52.75 210.548 52.75 210.487 52.75C210.425 52.75 210.363 52.75 210.301 52.75C210.24 52.75 210.178 52.75 210.116 52.75C210.054 52.75 209.993 52.75 209.931 52.75C209.869 52.75 209.807 52.75 209.745 52.75C209.683 52.75 209.621 52.75 209.559 52.75C209.497 52.75 209.435 52.75 209.373 52.75C209.311 52.75 209.249 52.75 209.187 52.75C209.125 52.75 209.063 52.75 209.001 52.75C208.939 52.75 208.877 52.75 208.815 52.75C208.753 52.75 208.691 52.75 208.628 52.75C208.566 52.75 208.504 52.75 208.442 52.75C208.379 52.75 208.317 52.75 208.255 52.75C208.193 52.75 208.13 52.75 208.068 52.75C208.006 52.75 207.943 52.75 207.881 52.75C207.819 52.75 207.756 52.75 207.694 52.75C207.632 52.75 207.569 52.75 207.507 52.75C207.444 52.75 207.382 52.75 207.32 52.75C207.257 52.75 207.195 52.75 207.132 52.75C207.07 52.75 207.007 52.75 206.945 52.75C206.882 52.75 206.82 52.75 206.757 52.75C206.695 52.75 206.632 52.75 206.569 52.75C206.507 52.75 206.444 52.75 206.382 52.75C206.319 52.75 206.257 52.75 206.194 52.75C206.131 52.75 206.069 52.75 206.006 52.75C205.943 52.75 205.881 52.75 205.818 52.75C205.755 52.75 205.693 52.75 205.63 52.75C205.567 52.75 205.505 52.75 205.442 52.75C205.379 52.75 205.317 52.75 205.254 52.75C205.191 52.75 205.128 52.75 205.066 52.75C205.003 52.75 204.94 52.75 204.878 52.75C204.815 52.75 204.752 52.75 204.689 52.75C204.627 52.75 204.564 52.75 204.501 52.75C204.438 52.75 204.376 52.75 204.313 52.75C204.25 52.75 204.187 52.75 204.124 52.75C204.062 52.75 203.999 52.75 203.936 52.75C203.873 52.75 203.811 52.75 203.748 52.75C203.685 52.75 203.622 52.75 203.559 52.75C203.497 52.75 203.434 52.75 203.371 52.75C203.308 52.75 203.246 52.75 203.183 52.75C203.12 52.75 203.057 52.75 202.994 52.75C202.932 52.75 202.869 52.75 202.806 52.75C202.743 52.75 202.68 52.75 202.618 52.75C202.555 52.75 202.492 52.75 202.429 52.75C202.367 52.75 202.304 52.75 202.241 52.75C202.178 52.75 202.116 52.75 202.053 52.75C201.99 52.75 201.927 52.75 201.865 52.75C201.802 52.75 201.739 52.75 201.677 52.75C201.614 52.75 201.551 52.75 201.488 52.75C201.426 52.75 201.363 52.75 201.3 52.75C201.238 52.75 201.175 52.75 201.112 52.75C201.05 52.75 200.987 52.75 200.924 52.75C200.862 52.75 200.799 52.75 200.736 52.75C200.674 52.75 200.611 52.75 200.549 52.75C200.486 52.75 200.423 52.75 200.361 52.75C200.298 52.75 200.236 52.75 200.173 52.75C200.111 52.75 200.048 52.75 199.985 52.75C199.923 52.75 199.86 52.75 199.798 52.75C199.735 52.75 199.673 52.75 199.61 52.75C199.548 52.75 199.486 52.75 199.423 52.75C199.361 52.75 199.298 52.75 199.236 52.75C199.174 52.75 199.111 52.75 199.049 52.75C198.986 52.75 198.924 52.75 198.862 52.75C198.799 52.75 198.737 52.75 198.675 52.75C198.613 52.75 198.55 52.75 198.488 52.75C198.426 52.75 198.364 52.75 198.301 52.75C198.239 52.75 198.177 52.75 198.115 52.75C198.053 52.75 197.991 52.75 197.928 52.75C197.866 52.75 197.804 52.75 197.742 52.75C197.68 52.75 197.618 52.75 197.556 52.75C197.494 52.75 197.432 52.75 197.37 52.75C197.308 52.75 197.246 52.75 197.184 52.75C197.122 52.75 197.06 52.75 196.998 52.75C196.937 52.75 196.875 52.75 196.813 52.75C196.751 52.75 196.689 52.75 196.628 52.75C196.566 52.75 196.504 52.75 196.442 52.75C196.381 52.75 196.319 52.75 196.257 52.75C196.196 52.75 196.134 52.75 196.073 52.75C196.011 52.75 195.949 52.75 195.888 52.75C195.826 52.75 195.765 52.75 195.704 52.75C195.642 52.75 195.581 52.75 195.519 52.75C195.458 52.75 195.397 52.75 195.335 52.75C195.274 52.75 195.213 52.75 195.151 52.75C195.09 52.75 195.029 52.75 194.968 52.75C194.907 52.75 194.845 52.75 194.784 52.75C194.723 52.75 194.662 52.75 194.601 52.75C194.54 52.75 194.479 52.75 194.418 52.75C194.357 52.75 194.296 52.75 194.235 52.75C194.174 52.75 194.114 52.75 194.053 52.75C193.992 52.75 193.931 52.75 193.87 52.75C193.81 52.75 193.749 52.75 193.688 52.75C193.628 52.75 193.567 52.75 193.507 52.75C193.446 52.75 193.385 52.75 193.325 52.75C193.265 52.75 193.204 52.75 193.144 52.75C193.083 52.75 193.023 52.75 192.963 52.75C192.902 52.75 192.842 52.75 192.782 52.75C192.722 52.75 192.661 52.75 192.601 52.75C192.541 52.75 192.481 52.75 192.421 52.75C192.361 52.75 192.301 52.75 192.241 52.75C192.181 52.75 192.121 52.75 192.061 52.75C192.002 52.75 191.942 52.75 191.882 52.75C191.822 52.75 191.763 52.75 191.703 52.75C191.643 52.75 191.584 52.75 191.524 52.75C191.465 52.75 191.405 52.75 191.346 52.75C191.286 52.75 191.227 52.75 191.167 52.75C191.108 52.75 191.049 52.75 190.989 52.75C190.93 52.75 190.871 52.75 190.812 52.75C190.753 52.75 190.694 52.75 190.635 52.75C190.576 52.75 190.517 52.75 190.458 52.75C190.399 52.75 190.34 52.75 190.281 52.75C190.222 52.75 190.164 52.75 190.105 52.75C190.046 52.75 189.988 52.75 189.929 52.75C189.87 52.75 189.812 52.75 189.753 52.75C189.695 52.75 189.637 52.75 189.578 52.75C189.52 52.75 189.462 52.75 189.403 52.75C189.345 52.75 189.287 52.75 189.229 52.75C189.171 52.75 189.113 52.75 189.055 52.75C188.997 52.75 188.939 52.75 188.881 52.75C188.823 52.75 188.765 52.75 188.707 52.75C188.65 52.75 188.592 52.75 188.534 52.75C188.477 52.75 188.419 52.75 188.362 52.75C188.304 52.75 188.247 52.75 188.189 52.75C188.132 52.75 188.075 52.75 188.018 52.75C187.96 52.75 187.903 52.75 187.846 52.75C187.789 52.75 187.732 52.75 187.675 52.75C187.618 52.75 187.561 52.75 187.504 52.75C187.447 52.75 187.391 52.75 187.334 52.75C187.277 52.75 187.221 52.75 187.164 52.75C187.108 52.75 187.051 52.75 186.995 52.75C186.938 52.75 186.882 52.75 186.826 52.75C186.769 52.75 186.713 52.75 186.657 52.75C186.601 52.75 186.545 52.75 186.489 52.75C186.433 52.75 186.377 52.75 186.321 52.75C186.265 52.75 186.21 52.75 186.154 52.75C186.098 52.75 186.043 52.75 185.987 52.75C185.932 52.75 185.876 52.75 185.821 52.75C185.765 52.75 185.71 52.75 185.655 52.75C185.6 52.75 185.545 52.75 185.489 52.75C185.434 52.75 185.379 52.75 185.324 52.75C185.27 52.75 185.215 52.75 185.16 52.75C185.105 52.75 185.05 52.75 184.996 52.75C184.941 52.75 184.887 52.75 184.832 52.75C184.778 52.75 184.724 52.75 184.669 52.75C184.615 52.75 184.561 52.75 184.507 52.75C184.453 52.75 184.399 52.75 184.345 52.75C184.291 52.75 184.237 52.75 184.183 52.75C184.129 52.75 184.076 52.75 184.022 52.75C183.968 52.75 183.915 52.75 183.861 52.75C183.808 52.75 183.755 52.75 183.701 52.75C183.648 52.75 183.595 52.75 183.542 52.75C183.489 52.75 183.436 52.75 183.383 52.75C183.33 52.75 183.277 52.75 183.224 52.75C183.171 52.75 183.119 52.75 183.066 52.75C183.014 52.75 182.961 52.75 182.909 52.75C182.856 52.75 182.804 52.75 182.752 52.75C182.7 52.75 182.648 52.75 182.596 52.75C182.544 52.75 182.492 52.75 182.44 52.75C182.388 52.75 182.336 52.75 182.284 52.75C182.233 52.75 182.181 52.75 182.13 52.75C182.078 52.75 182.027 52.75 181.976 52.75C181.924 52.75 181.873 52.75 181.822 52.75C181.771 52.75 181.72 52.75 181.669 52.75C181.618 52.75 181.567 52.75 181.517 52.75C181.466 52.75 181.415 52.75 181.365 52.75C181.314 52.75 181.264 52.75 181.214 52.75C181.163 52.75 181.113 52.75 181.063 52.75C181.013 52.75 180.963 52.75 180.913 52.75C180.863 52.75 180.813 52.75 180.764 52.75C180.714 52.75 180.664 52.75 180.615 52.75C180.565 52.75 180.516 52.75 180.467 52.75C180.417 52.75 180.368 52.75 180.319 52.75C180.27 52.75 180.221 52.75 180.172 52.75C180.123 52.75 180.074 52.75 180.026 52.75C179.977 52.75 179.928 52.75 179.88 52.75C179.832 52.75 179.783 52.75 179.735 52.75C179.687 52.75 179.639 52.75 179.59 52.75C179.542 52.75 179.495 52.75 179.447 52.75C179.399 52.75 179.351 52.75 179.304 52.75C179.256 52.75 179.208 52.75 179.161 52.75C179.114 52.75 179.066 52.75 179.019 52.75C178.972 52.75 178.925 52.75 178.878 52.75C178.831 52.75 178.784 52.75 178.738 52.75C178.691 52.75 178.644 52.75 178.598 52.75C178.551 52.75 178.505 52.75 178.459 52.75C178.412 52.75 178.366 52.75 178.32 52.75C178.274 52.75 178.228 52.75 178.182 52.75C178.136 52.75 178.091 52.75 178.045 52.75C178 52.75 177.954 52.75 177.909 52.75C177.863 52.75 177.818 52.75 177.773 52.75C177.728 52.75 177.683 52.75 177.638 52.75C177.593 52.75 177.548 52.75 177.504 52.75C177.459 52.75 177.415 52.75 177.37 52.75C177.326 52.75 177.282 52.75 177.237 52.75C177.193 52.75 177.149 52.75 177.105 52.75C177.061 52.75 177.018 52.75 176.974 52.75C176.93 52.75 176.887 52.75 176.843 52.75C176.8 52.75 176.757 52.75 176.713 52.75C176.67 52.75 176.627 52.75 176.584 52.75C176.541 52.75 176.498 52.75 176.456 52.75C176.413 52.75 176.37 52.75 176.328 52.75C176.286 52.75 176.243 52.75 176.201 52.75C176.159 52.75 176.117 52.75 176.075 52.75C176.033 52.75 175.991 52.75 175.95 52.75C175.908 52.75 175.866 52.75 175.825 52.75C175.784 52.75 175.742 52.75 175.701 52.75C175.66 52.75 175.619 52.75 175.578 52.75C175.537 52.75 175.496 52.75 175.456 52.75C175.415 52.75 175.375 52.75 175.334 52.75C175.294 52.75 175.254 52.75 175.214 52.75C175.173 52.75 175.134 52.75 175.094 52.75C175.054 52.75 175.014 52.75 174.975 52.75C174.935 52.75 174.896 52.75 174.856 52.75C174.817 52.75 174.778 52.75 174.739 52.75C174.7 52.75 174.661 52.75 174.622 52.75C174.583 52.75 174.545 52.75 174.506 52.75C174.468 52.75 174.43 52.75 174.391 52.75C174.353 52.75 174.315 52.75 174.277 52.75C174.239 52.75 174.201 52.75 174.164 52.75C174.126 52.75 174.089 52.75 174.051 52.75C174.014 52.75 173.977 52.75 173.94 52.75C173.903 52.75 173.866 52.75 173.829 52.75C173.792 52.75 173.756 52.75 173.719 52.75C173.683 52.75 173.646 52.75 173.61 52.75C173.574 52.75 173.538 52.75 173.502 52.75C173.466 52.75 173.43 52.75 173.394 52.75C173.359 52.75 173.323 52.75 173.288 52.75C173.253 52.75 173.217 52.75 173.182 52.75C173.147 52.75 173.112 52.75 173.078 52.75C173.043 52.75 173.008 52.75 172.974 52.75C172.939 52.75 172.905 52.75 172.871 52.75C172.837 52.75 172.803 52.75 172.769 52.75C172.735 52.75 172.701 52.75 172.668 52.75C172.634 52.75 172.601 52.75 172.568 52.75C172.534 52.75 172.501 52.75 172.468 52.75C172.435 52.75 172.402 52.75 172.37 52.75C172.337 52.75 172.305 52.75 172.272 52.75C172.24 52.75 172.208 52.75 172.176 52.75C172.144 52.75 172.112 52.75 172.08 52.75C172.049 52.75 172.017 52.75 171.986 52.75C171.954 52.75 171.923 52.75 171.892 52.75C171.861 52.75 171.83 52.75 171.799 52.75C171.768 52.75 171.738 52.75 171.707 52.75C171.677 52.75 171.646 52.75 171.616 52.75C171.586 52.75 171.556 52.75 171.526 52.75C171.497 52.75 171.467 52.75 171.437 52.75C171.408 52.75 171.379 52.75 171.349 52.75C171.32 52.75 171.291 52.75 171.262 52.75C171.234 52.75 171.205 52.75 171.176 52.75C171.148 52.75 171.12 52.75 171.091 52.75C171.063 52.75 171.035 52.75 171.007 52.75C170.979 52.75 170.952 52.75 170.924 52.75C170.897 52.75 170.869 52.75 170.842 52.75C170.815 52.75 170.788 52.75 170.761 52.75C170.734 52.75 170.708 52.75 170.681 52.75C170.654 52.75 170.628 52.75 170.602 52.75C170.576 52.75 170.55 52.75 170.524 52.75C170.498 52.75 170.472 52.75 170.447 52.75C170.421 52.75 170.396 52.75 170.371 52.75C170.346 52.75 170.321 52.75 170.296 52.75C170.271 52.75 170.246 52.75 170.222 52.75C170.198 52.75 170.173 52.75 170.149 52.75C170.125 52.75 170.101 52.75 170.077 52.75C170.053 52.75 170.03 52.75 170.006 52.75C169.983 52.75 169.96 52.75 169.937 52.75C169.914 52.75 169.891 52.75 169.868 52.75C169.845 52.75 169.823 52.75 169.8 52.75C169.778 52.75 169.756 52.75 169.734 52.75C169.712 52.75 169.69 52.75 169.668 52.75C169.647 52.75 169.625 52.75 169.604 52.75C169.583 52.75 169.561 52.75 169.541 52.75C169.52 52.75 169.499 52.75 169.478 52.75C169.458 52.75 169.437 52.75 169.417 52.75C169.397 52.75 169.377 52.75 169.357 52.75C169.337 52.75 169.318 52.75 169.298 52.75C169.279 52.75 169.259 52.75 169.24 52.75C169.221 52.75 169.202 52.75 169.183 52.75C169.165 52.75 169.146 52.75 169.128 52.75C169.109 52.75 169.091 52.75 169.073 52.75C169.055 52.75 169.038 52.75 169.02 52.75C169.002 52.75 168.985 52.75 168.968 52.75C168.95 52.75 168.933 52.75 168.917 52.75C168.9 52.75 168.883 52.75 168.867 52.75C168.85 52.75 168.834 52.75 168.818 52.75C168.802 52.75 168.786 52.75 168.77 52.75C168.754 52.75 168.739 52.75 168.723 52.75C168.708 52.75 168.693 52.75 168.678 52.75C168.663 52.75 168.648 52.75 168.634 52.75C168.619 52.75 168.605 52.75 168.591 52.75C168.577 52.75 168.563 52.75 168.549 52.75C168.535 52.75 168.521 52.75 168.508 52.75C168.495 52.75 168.481 52.75 168.469 52.75C168.456 52.75 168.443 52.75 168.43 52.75C168.418 52.75 168.405 52.75 168.393 52.75C168.381 52.75 168.369 52.75 168.357 52.75C168.345 52.75 168.334 52.75 168.322 52.75C168.311 52.75 168.3 52.75 168.289 52.75C168.278 52.75 168.267 52.75 168.256 52.75C168.246 52.75 168.235 52.75 168.225 52.75C168.215 52.75 168.205 52.75 168.195 52.75C168.185 52.75 168.176 52.75 168.166 52.75C168.157 52.75 168.148 52.75 168.139 52.75C168.13 52.75 168.121 52.75 168.113 52.75C168.104 52.75 168.096 52.75 168.088 52.75C168.08 52.75 168.072 52.75 168.064 52.75C168.056 52.75 168.049 52.75 168.041 52.75C168.034 52.75 168.027 52.75 168.02 52.75C168.013 52.75 168.006 52.75 168 52.75V51.25Z", fill: "url(#paint4_linear_38_7016)" }),
    /* @__PURE__ */ jsx("path", { d: "M258.724 115.263V114.091H266.906V115.263H263.476V125H262.155V115.263H258.724ZM270.912 125.17C270.173 125.17 269.525 124.995 268.968 124.643C268.414 124.292 267.98 123.8 267.668 123.168C267.359 122.536 267.205 121.797 267.205 120.952C267.205 120.099 267.359 119.355 267.668 118.72C267.98 118.084 268.414 117.591 268.968 117.239C269.525 116.887 270.173 116.712 270.912 116.712C271.651 116.712 272.297 116.887 272.851 117.239C273.408 117.591 273.842 118.084 274.151 118.72C274.463 119.355 274.619 120.099 274.619 120.952C274.619 121.797 274.463 122.536 274.151 123.168C273.842 123.8 273.408 124.292 272.851 124.643C272.297 124.995 271.651 125.17 270.912 125.17ZM270.912 124.041C271.473 124.041 271.935 123.897 272.297 123.61C272.659 123.322 272.927 122.944 273.101 122.475C273.275 122.006 273.362 121.499 273.362 120.952C273.362 120.405 273.275 119.895 273.101 119.423C272.927 118.951 272.659 118.569 272.297 118.278C271.935 117.987 271.473 117.841 270.912 117.841C270.351 117.841 269.889 117.987 269.527 118.278C269.165 118.569 268.897 118.951 268.723 119.423C268.549 119.895 268.462 120.405 268.462 120.952C268.462 121.499 268.549 122.006 268.723 122.475C268.897 122.944 269.165 123.322 269.527 123.61C269.889 123.897 270.351 124.041 270.912 124.041ZM279.628 125.17C278.946 125.17 278.344 124.998 277.822 124.654C277.3 124.306 276.892 123.816 276.597 123.184C276.302 122.548 276.155 121.797 276.155 120.93C276.155 120.071 276.302 119.325 276.597 118.693C276.892 118.061 277.302 117.573 277.827 117.228C278.353 116.884 278.96 116.712 279.649 116.712C280.182 116.712 280.603 116.8 280.911 116.978C281.224 117.152 281.462 117.351 281.625 117.575C281.792 117.795 281.922 117.976 282.014 118.118H282.121V114.091H283.378V125H282.163V123.743H282.014C281.922 123.892 281.79 124.08 281.62 124.308C281.449 124.531 281.206 124.732 280.89 124.909C280.574 125.083 280.153 125.17 279.628 125.17ZM279.798 124.041C280.302 124.041 280.729 123.91 281.077 123.647C281.425 123.381 281.689 123.013 281.87 122.544C282.051 122.072 282.142 121.527 282.142 120.909C282.142 120.298 282.053 119.764 281.876 119.306C281.698 118.844 281.435 118.485 281.087 118.23C280.739 117.971 280.31 117.841 279.798 117.841C279.266 117.841 278.822 117.978 278.467 118.251C278.115 118.521 277.85 118.888 277.673 119.354C277.499 119.815 277.412 120.334 277.412 120.909C277.412 121.491 277.501 122.021 277.678 122.496C277.859 122.969 278.126 123.345 278.477 123.626C278.832 123.903 279.273 124.041 279.798 124.041ZM288.262 125.192C287.744 125.192 287.273 125.094 286.851 124.899C286.428 124.7 286.093 124.414 285.844 124.041C285.595 123.665 285.471 123.21 285.471 122.678C285.471 122.209 285.563 121.829 285.748 121.538C285.933 121.243 286.18 121.012 286.489 120.845C286.797 120.678 287.138 120.554 287.511 120.472C287.888 120.387 288.266 120.32 288.646 120.27C289.143 120.206 289.546 120.158 289.855 120.126C290.168 120.091 290.395 120.032 290.537 119.95C290.682 119.869 290.755 119.727 290.755 119.524V119.482C290.755 118.956 290.611 118.548 290.324 118.256C290.04 117.965 289.608 117.82 289.029 117.82C288.429 117.82 287.959 117.951 287.618 118.214C287.277 118.477 287.037 118.757 286.899 119.055L285.706 118.629C285.919 118.132 286.203 117.745 286.558 117.468C286.916 117.187 287.307 116.992 287.73 116.882C288.156 116.768 288.575 116.712 288.987 116.712C289.25 116.712 289.551 116.744 289.892 116.808C290.237 116.868 290.569 116.994 290.888 117.186C291.212 117.377 291.48 117.667 291.693 118.054C291.906 118.441 292.012 118.96 292.012 119.609V125H290.755V123.892H290.691C290.606 124.07 290.464 124.26 290.265 124.462C290.066 124.664 289.802 124.837 289.472 124.979C289.141 125.121 288.738 125.192 288.262 125.192ZM288.454 124.062C288.951 124.062 289.37 123.965 289.711 123.77C290.056 123.574 290.315 123.322 290.489 123.013C290.666 122.704 290.755 122.379 290.755 122.038V120.888C290.702 120.952 290.585 121.01 290.404 121.064C290.226 121.113 290.02 121.158 289.786 121.197C289.555 121.232 289.329 121.264 289.109 121.293C288.893 121.317 288.717 121.339 288.582 121.357C288.255 121.399 287.95 121.468 287.666 121.564C287.385 121.657 287.158 121.797 286.984 121.985C286.813 122.17 286.728 122.422 286.728 122.741C286.728 123.178 286.89 123.509 287.213 123.732C287.54 123.952 287.953 124.062 288.454 124.062ZM294.824 128.068C294.61 128.068 294.42 128.05 294.254 128.015C294.087 127.983 293.971 127.951 293.907 127.919L294.227 126.811C294.532 126.889 294.802 126.918 295.037 126.896C295.271 126.875 295.479 126.77 295.66 126.582C295.844 126.397 296.013 126.097 296.166 125.682L296.4 125.043L293.375 116.818H294.738L296.997 123.338H297.082L299.341 116.818H300.704L297.231 126.193C297.075 126.616 296.881 126.966 296.651 127.243C296.42 127.523 296.152 127.731 295.846 127.866C295.544 128.001 295.203 128.068 294.824 128.068ZM303.726 123.509L303.641 124.084C303.58 124.489 303.488 124.922 303.364 125.384C303.243 125.845 303.117 126.28 302.985 126.689C302.854 127.097 302.746 127.422 302.66 127.663H301.702C301.748 127.436 301.808 127.136 301.883 126.763C301.957 126.39 302.032 125.973 302.106 125.511C302.185 125.053 302.248 124.585 302.298 124.105L302.362 123.509H303.726ZM312.127 125L309.634 116.818H310.955L312.724 123.082H312.809L314.556 116.818H315.899L317.624 123.061H317.71L319.478 116.818H320.799L318.306 125H317.07L315.281 118.714H315.153L313.363 125H312.127ZM325.613 125.17C324.825 125.17 324.145 124.996 323.573 124.648C323.005 124.297 322.566 123.807 322.257 123.178C321.952 122.546 321.799 121.811 321.799 120.973C321.799 120.135 321.952 119.396 322.257 118.757C322.566 118.114 322.996 117.614 323.546 117.255C324.1 116.893 324.747 116.712 325.485 116.712C325.911 116.712 326.332 116.783 326.748 116.925C327.163 117.067 327.541 117.298 327.882 117.617C328.223 117.933 328.495 118.352 328.697 118.874C328.9 119.396 329.001 120.039 329.001 120.803V121.335H322.694V120.249H327.723C327.723 119.787 327.63 119.375 327.446 119.013C327.264 118.651 327.005 118.365 326.668 118.155C326.334 117.946 325.94 117.841 325.485 117.841C324.985 117.841 324.551 117.965 324.186 118.214C323.823 118.459 323.545 118.778 323.349 119.173C323.154 119.567 323.056 119.989 323.056 120.44V121.165C323.056 121.783 323.163 122.306 323.376 122.736C323.593 123.162 323.893 123.487 324.276 123.711C324.66 123.931 325.105 124.041 325.613 124.041C325.943 124.041 326.242 123.995 326.508 123.903C326.778 123.807 327.011 123.665 327.206 123.477C327.401 123.285 327.552 123.047 327.659 122.763L328.873 123.104C328.745 123.516 328.53 123.878 328.229 124.19C327.927 124.499 327.554 124.741 327.11 124.915C326.666 125.085 326.167 125.17 325.613 125.17ZM332.021 114.091V115.05C332.021 115.341 331.968 115.652 331.861 115.982C331.758 116.309 331.606 116.626 331.403 116.935C331.204 117.241 330.963 117.507 330.679 117.734L329.997 117.18C330.221 116.861 330.414 116.529 330.578 116.184C330.745 115.836 330.828 115.465 330.828 115.071V114.091H332.021ZM333.36 125V116.818H334.574V118.054H334.659C334.808 117.649 335.078 117.321 335.469 117.069C335.86 116.816 336.3 116.69 336.79 116.69C336.882 116.69 336.998 116.692 337.136 116.696C337.275 116.699 337.379 116.705 337.45 116.712V117.99C337.408 117.979 337.31 117.963 337.157 117.942C337.008 117.917 336.85 117.905 336.683 117.905C336.286 117.905 335.931 117.988 335.618 118.155C335.309 118.319 335.064 118.546 334.883 118.837C334.705 119.125 334.617 119.453 334.617 119.822V125H333.36ZM342.122 125.17C341.334 125.17 340.654 124.996 340.082 124.648C339.514 124.297 339.075 123.807 338.766 123.178C338.461 122.546 338.308 121.811 338.308 120.973C338.308 120.135 338.461 119.396 338.766 118.757C339.075 118.114 339.505 117.614 340.055 117.255C340.609 116.893 341.256 116.712 341.994 116.712C342.42 116.712 342.841 116.783 343.257 116.925C343.672 117.067 344.05 117.298 344.391 117.617C344.732 117.933 345.004 118.352 345.206 118.874C345.409 119.396 345.51 120.039 345.51 120.803V121.335H339.203V120.249H344.231C344.231 119.787 344.139 119.375 343.954 119.013C343.773 118.651 343.514 118.365 343.177 118.155C342.843 117.946 342.449 117.841 341.994 117.841C341.493 117.841 341.06 117.965 340.694 118.214C340.332 118.459 340.053 118.778 339.858 119.173C339.663 119.567 339.565 119.989 339.565 120.44V121.165C339.565 121.783 339.672 122.306 339.885 122.736C340.101 123.162 340.401 123.487 340.785 123.711C341.169 123.931 341.614 124.041 342.122 124.041C342.452 124.041 342.751 123.995 343.017 123.903C343.287 123.807 343.519 123.665 343.715 123.477C343.91 123.285 344.061 123.047 344.167 122.763L345.382 123.104C345.254 123.516 345.039 123.878 344.737 124.19C344.436 124.499 344.063 124.741 343.619 124.915C343.175 125.085 342.676 125.17 342.122 125.17ZM354.048 125.192C353.53 125.192 353.059 125.094 352.637 124.899C352.214 124.7 351.879 124.414 351.63 124.041C351.382 123.665 351.257 123.21 351.257 122.678C351.257 122.209 351.35 121.829 351.534 121.538C351.719 121.243 351.966 121.012 352.275 120.845C352.584 120.678 352.925 120.554 353.297 120.472C353.674 120.387 354.052 120.32 354.432 120.27C354.929 120.206 355.332 120.158 355.641 120.126C355.954 120.091 356.181 120.032 356.323 119.95C356.469 119.869 356.541 119.727 356.541 119.524V119.482C356.541 118.956 356.398 118.548 356.11 118.256C355.826 117.965 355.394 117.82 354.816 117.82C354.215 117.82 353.745 117.951 353.404 118.214C353.063 118.477 352.823 118.757 352.685 119.055L351.492 118.629C351.705 118.132 351.989 117.745 352.344 117.468C352.703 117.187 353.093 116.992 353.516 116.882C353.942 116.768 354.361 116.712 354.773 116.712C355.036 116.712 355.338 116.744 355.678 116.808C356.023 116.868 356.355 116.994 356.675 117.186C356.998 117.377 357.266 117.667 357.479 118.054C357.692 118.441 357.798 118.96 357.798 119.609V125H356.541V123.892H356.477C356.392 124.07 356.25 124.26 356.051 124.462C355.852 124.664 355.588 124.837 355.258 124.979C354.927 125.121 354.524 125.192 354.048 125.192ZM354.24 124.062C354.737 124.062 355.156 123.965 355.497 123.77C355.842 123.574 356.101 123.322 356.275 123.013C356.453 122.704 356.541 122.379 356.541 122.038V120.888C356.488 120.952 356.371 121.01 356.19 121.064C356.012 121.113 355.806 121.158 355.572 121.197C355.341 121.232 355.116 121.264 354.895 121.293C354.679 121.317 354.503 121.339 354.368 121.357C354.041 121.399 353.736 121.468 353.452 121.564C353.171 121.657 352.944 121.797 352.77 121.985C352.6 122.17 352.514 122.422 352.514 122.741C352.514 123.178 352.676 123.509 352.999 123.732C353.326 123.952 353.74 124.062 354.24 124.062ZM361.35 120.078V125H360.093V116.818H361.307V118.097H361.414C361.606 117.681 361.897 117.347 362.288 117.095C362.678 116.839 363.182 116.712 363.8 116.712C364.354 116.712 364.839 116.825 365.255 117.053C365.67 117.276 365.993 117.617 366.224 118.075C366.455 118.53 366.57 119.105 366.57 119.801V125H365.313V119.886C365.313 119.244 365.146 118.743 364.812 118.384C364.479 118.022 364.021 117.841 363.438 117.841C363.037 117.841 362.678 117.928 362.362 118.102C362.05 118.276 361.803 118.53 361.622 118.864C361.441 119.197 361.35 119.602 361.35 120.078ZM262.453 151.239C261.846 151.239 261.324 151.161 260.887 151.004C260.45 150.852 260.086 150.649 259.795 150.397C259.507 150.148 259.278 149.882 259.108 149.598L260.109 148.895C260.223 149.044 260.367 149.214 260.541 149.406C260.715 149.602 260.953 149.77 261.255 149.912C261.56 150.058 261.96 150.131 262.453 150.131C263.114 150.131 263.659 149.971 264.088 149.651C264.518 149.332 264.733 148.831 264.733 148.149V146.487H264.626C264.534 146.636 264.403 146.821 264.232 147.041C264.065 147.258 263.824 147.451 263.508 147.622C263.195 147.789 262.773 147.872 262.24 147.872C261.58 147.872 260.987 147.716 260.461 147.403C259.939 147.091 259.525 146.636 259.22 146.04C258.918 145.443 258.767 144.719 258.767 143.866C258.767 143.028 258.914 142.299 259.209 141.677C259.504 141.052 259.914 140.569 260.44 140.228C260.965 139.884 261.572 139.712 262.261 139.712C262.794 139.712 263.217 139.8 263.529 139.978C263.845 140.152 264.087 140.351 264.254 140.575C264.424 140.795 264.555 140.976 264.648 141.118H264.776V139.818H265.99V148.234C265.99 148.938 265.83 149.509 265.511 149.95C265.195 150.393 264.768 150.718 264.232 150.924C263.7 151.134 263.107 151.239 262.453 151.239ZM262.411 146.743C262.915 146.743 263.341 146.627 263.689 146.397C264.037 146.166 264.301 145.834 264.483 145.401C264.664 144.967 264.754 144.449 264.754 143.845C264.754 143.256 264.665 142.735 264.488 142.284C264.31 141.833 264.048 141.48 263.7 141.224C263.352 140.969 262.922 140.841 262.411 140.841C261.878 140.841 261.434 140.976 261.079 141.246C260.727 141.516 260.463 141.878 260.285 142.332C260.111 142.787 260.024 143.291 260.024 143.845C260.024 144.413 260.113 144.916 260.29 145.353C260.472 145.786 260.738 146.127 261.089 146.375C261.445 146.62 261.885 146.743 262.411 146.743ZM268.291 148V139.818H269.548V148H268.291ZM268.93 138.455C268.685 138.455 268.474 138.371 268.297 138.204C268.123 138.037 268.036 137.837 268.036 137.602C268.036 137.368 268.123 137.167 268.297 137C268.474 136.833 268.685 136.75 268.93 136.75C269.175 136.75 269.385 136.833 269.559 137C269.737 137.167 269.825 137.368 269.825 137.602C269.825 137.837 269.737 138.037 269.559 138.204C269.385 138.371 269.175 138.455 268.93 138.455ZM278.541 139.818L275.516 148H274.237L271.212 139.818H272.575L274.834 146.338H274.919L277.177 139.818H278.541ZM280.2 148V139.818H281.457V148H280.2ZM280.84 138.455C280.595 138.455 280.383 138.371 280.206 138.204C280.032 138.037 279.945 137.837 279.945 137.602C279.945 137.368 280.032 137.167 280.206 137C280.383 136.833 280.595 136.75 280.84 136.75C281.085 136.75 281.294 136.833 281.468 137C281.646 137.167 281.734 137.368 281.734 137.602C281.734 137.837 281.646 138.037 281.468 138.204C281.294 138.371 281.085 138.455 280.84 138.455ZM285.017 143.078V148H283.76V139.818H284.974V141.097H285.081C285.273 140.681 285.564 140.347 285.955 140.095C286.345 139.839 286.849 139.712 287.467 139.712C288.021 139.712 288.506 139.825 288.922 140.053C289.337 140.276 289.66 140.617 289.891 141.075C290.122 141.53 290.237 142.105 290.237 142.801V148H288.98V142.886C288.98 142.244 288.813 141.743 288.479 141.384C288.146 141.022 287.688 140.841 287.105 140.841C286.704 140.841 286.345 140.928 286.029 141.102C285.717 141.276 285.47 141.53 285.289 141.864C285.108 142.197 285.017 142.602 285.017 143.078ZM295.837 151.239C295.23 151.239 294.708 151.161 294.271 151.004C293.834 150.852 293.47 150.649 293.179 150.397C292.891 150.148 292.662 149.882 292.492 149.598L293.493 148.895C293.607 149.044 293.751 149.214 293.925 149.406C294.099 149.602 294.337 149.77 294.638 149.912C294.944 150.058 295.343 150.131 295.837 150.131C296.497 150.131 297.043 149.971 297.472 149.651C297.902 149.332 298.117 148.831 298.117 148.149V146.487H298.01C297.918 146.636 297.786 146.821 297.616 147.041C297.449 147.258 297.208 147.451 296.892 147.622C296.579 147.789 296.157 147.872 295.624 147.872C294.963 147.872 294.37 147.716 293.845 147.403C293.323 147.091 292.909 146.636 292.604 146.04C292.302 145.443 292.151 144.719 292.151 143.866C292.151 143.028 292.298 142.299 292.593 141.677C292.888 141.052 293.298 140.569 293.823 140.228C294.349 139.884 294.956 139.712 295.645 139.712C296.178 139.712 296.6 139.8 296.913 139.978C297.229 140.152 297.47 140.351 297.637 140.575C297.808 140.795 297.939 140.976 298.032 141.118H298.159V139.818H299.374V148.234C299.374 148.938 299.214 149.509 298.894 149.95C298.578 150.393 298.152 150.718 297.616 150.924C297.083 151.134 296.49 151.239 295.837 151.239ZM295.794 146.743C296.299 146.743 296.725 146.627 297.073 146.397C297.421 146.166 297.685 145.834 297.866 145.401C298.047 144.967 298.138 144.449 298.138 143.845C298.138 143.256 298.049 142.735 297.872 142.284C297.694 141.833 297.431 141.48 297.083 141.224C296.735 140.969 296.306 140.841 295.794 140.841C295.262 140.841 294.818 140.976 294.463 141.246C294.111 141.516 293.847 141.878 293.669 142.332C293.495 142.787 293.408 143.291 293.408 143.845C293.408 144.413 293.497 144.916 293.674 145.353C293.855 145.786 294.122 146.127 294.473 146.375C294.828 146.62 295.269 146.743 295.794 146.743ZM309.452 139.818V140.884H305.212V139.818H309.452ZM306.448 137.858H307.705V145.656C307.705 146.011 307.756 146.278 307.859 146.455C307.966 146.629 308.101 146.746 308.264 146.807C308.431 146.864 308.607 146.892 308.791 146.892C308.93 146.892 309.044 146.885 309.132 146.871C309.221 146.853 309.292 146.839 309.345 146.828L309.601 147.957C309.516 147.989 309.397 148.021 309.244 148.053C309.092 148.089 308.898 148.107 308.664 148.107C308.309 148.107 307.96 148.03 307.62 147.877C307.282 147.725 307.002 147.492 306.778 147.18C306.558 146.867 306.448 146.473 306.448 145.997V137.858ZM312.776 143.078V148H311.519V137.091H312.776V141.097H312.882C313.074 140.674 313.362 140.338 313.745 140.09C314.132 139.838 314.647 139.712 315.29 139.712C315.848 139.712 316.336 139.824 316.755 140.047C317.174 140.267 317.499 140.607 317.73 141.065C317.964 141.519 318.081 142.098 318.081 142.801V148H316.824V142.886C316.824 142.237 316.655 141.734 316.318 141.379C315.984 141.02 315.521 140.841 314.928 140.841C314.516 140.841 314.147 140.928 313.82 141.102C313.497 141.276 313.241 141.53 313.053 141.864C312.868 142.197 312.776 142.602 312.776 143.078ZM323.811 148.17C323.023 148.17 322.343 147.996 321.771 147.648C321.203 147.297 320.765 146.807 320.456 146.178C320.15 145.546 319.998 144.811 319.998 143.973C319.998 143.135 320.15 142.396 320.456 141.757C320.765 141.114 321.194 140.614 321.745 140.255C322.299 139.893 322.945 139.712 323.684 139.712C324.11 139.712 324.531 139.783 324.946 139.925C325.362 140.067 325.74 140.298 326.081 140.617C326.422 140.933 326.693 141.352 326.896 141.874C327.098 142.396 327.199 143.039 327.199 143.803V144.335H320.892V143.249H325.921C325.921 142.787 325.828 142.375 325.644 142.013C325.463 141.651 325.203 141.365 324.866 141.155C324.532 140.946 324.138 140.841 323.684 140.841C323.183 140.841 322.75 140.965 322.384 141.214C322.022 141.459 321.743 141.778 321.548 142.173C321.352 142.567 321.255 142.989 321.255 143.44V144.165C321.255 144.783 321.361 145.306 321.574 145.736C321.791 146.162 322.091 146.487 322.474 146.711C322.858 146.931 323.304 147.041 323.811 147.041C324.142 147.041 324.44 146.995 324.706 146.903C324.976 146.807 325.209 146.665 325.404 146.477C325.599 146.285 325.75 146.047 325.857 145.763L327.071 146.104C326.944 146.516 326.729 146.878 326.427 147.19C326.125 147.499 325.752 147.741 325.308 147.915C324.864 148.085 324.365 148.17 323.811 148.17ZM262.709 162.818V163.884H258.469V162.818H262.709ZM259.705 160.858H260.962V168.656C260.962 169.011 261.013 169.278 261.116 169.455C261.223 169.629 261.358 169.746 261.521 169.807C261.688 169.864 261.864 169.892 262.048 169.892C262.187 169.892 262.3 169.885 262.389 169.871C262.478 169.853 262.549 169.839 262.602 169.828L262.858 170.957C262.773 170.989 262.654 171.021 262.501 171.053C262.348 171.089 262.155 171.107 261.92 171.107C261.565 171.107 261.217 171.03 260.876 170.877C260.539 170.725 260.259 170.492 260.035 170.18C259.815 169.867 259.705 169.473 259.705 168.997V160.858ZM264.6 171V162.818H265.814V164.054H265.9C266.049 163.649 266.319 163.321 266.709 163.069C267.1 162.816 267.54 162.69 268.03 162.69C268.123 162.69 268.238 162.692 268.376 162.696C268.515 162.699 268.62 162.705 268.691 162.712V163.99C268.648 163.979 268.55 163.963 268.398 163.942C268.249 163.917 268.091 163.905 267.924 163.905C267.526 163.905 267.171 163.988 266.858 164.155C266.549 164.319 266.304 164.546 266.123 164.837C265.946 165.125 265.857 165.453 265.857 165.822V171H264.6ZM275.337 167.655V162.818H276.594V171H275.337V169.615H275.252C275.06 170.031 274.762 170.384 274.357 170.675C273.952 170.963 273.441 171.107 272.823 171.107C272.312 171.107 271.857 170.995 271.459 170.771C271.062 170.544 270.749 170.203 270.522 169.748C270.294 169.29 270.181 168.713 270.181 168.017V162.818H271.438V167.932C271.438 168.528 271.605 169.004 271.939 169.359C272.276 169.714 272.706 169.892 273.228 169.892C273.54 169.892 273.858 169.812 274.181 169.652C274.508 169.493 274.781 169.248 275.002 168.917C275.225 168.587 275.337 168.166 275.337 167.655ZM284.692 164.651L283.563 164.97C283.492 164.782 283.387 164.599 283.249 164.422C283.114 164.24 282.929 164.091 282.695 163.974C282.46 163.857 282.16 163.798 281.794 163.798C281.294 163.798 280.876 163.914 280.543 164.145C280.212 164.372 280.047 164.661 280.047 165.013C280.047 165.325 280.161 165.572 280.388 165.753C280.615 165.934 280.971 166.085 281.453 166.206L282.668 166.504C283.4 166.682 283.945 166.953 284.303 167.319C284.662 167.681 284.841 168.148 284.841 168.72C284.841 169.189 284.706 169.608 284.436 169.977C284.17 170.347 283.797 170.638 283.318 170.851C282.838 171.064 282.281 171.17 281.645 171.17C280.811 171.17 280.12 170.989 279.573 170.627C279.026 170.265 278.68 169.736 278.534 169.04L279.728 168.741C279.841 169.182 280.056 169.512 280.372 169.732C280.692 169.952 281.109 170.062 281.624 170.062C282.21 170.062 282.675 169.938 283.02 169.69C283.368 169.437 283.542 169.136 283.542 168.784C283.542 168.5 283.442 168.262 283.243 168.07C283.044 167.875 282.739 167.729 282.327 167.634L280.963 167.314C280.214 167.136 279.664 166.861 279.312 166.488C278.964 166.112 278.79 165.641 278.79 165.077C278.79 164.615 278.92 164.207 279.179 163.852C279.442 163.496 279.799 163.218 280.25 163.015C280.704 162.813 281.219 162.712 281.794 162.712C282.604 162.712 283.24 162.889 283.701 163.244C284.167 163.599 284.497 164.068 284.692 164.651ZM290.292 162.818V163.884H286.052V162.818H290.292ZM287.288 160.858H288.545V168.656C288.545 169.011 288.596 169.278 288.699 169.455C288.806 169.629 288.941 169.746 289.104 169.807C289.271 169.864 289.447 169.892 289.631 169.892C289.77 169.892 289.883 169.885 289.972 169.871C290.061 169.853 290.132 169.839 290.185 169.828L290.441 170.957C290.356 170.989 290.237 171.021 290.084 171.053C289.931 171.089 289.738 171.107 289.503 171.107C289.148 171.107 288.8 171.03 288.459 170.877C288.122 170.725 287.842 170.492 287.618 170.18C287.398 169.867 287.288 169.473 287.288 168.997V160.858ZM294.036 171L291.544 162.818H292.865L294.633 169.082H294.718L296.465 162.818H297.808L299.534 169.061H299.619L301.387 162.818H302.708L300.215 171H298.98L297.19 164.714H297.062L295.272 171H294.036ZM307.416 171.17C306.677 171.17 306.029 170.995 305.472 170.643C304.918 170.292 304.484 169.8 304.172 169.168C303.863 168.536 303.708 167.797 303.708 166.952C303.708 166.099 303.863 165.355 304.172 164.72C304.484 164.084 304.918 163.591 305.472 163.239C306.029 162.887 306.677 162.712 307.416 162.712C308.154 162.712 308.801 162.887 309.355 163.239C309.912 163.591 310.346 164.084 310.654 164.72C310.967 165.355 311.123 166.099 311.123 166.952C311.123 167.797 310.967 168.536 310.654 169.168C310.346 169.8 309.912 170.292 309.355 170.643C308.801 170.995 308.154 171.17 307.416 171.17ZM307.416 170.041C307.977 170.041 308.439 169.897 308.801 169.61C309.163 169.322 309.431 168.944 309.605 168.475C309.779 168.006 309.866 167.499 309.866 166.952C309.866 166.405 309.779 165.895 309.605 165.423C309.431 164.951 309.163 164.569 308.801 164.278C308.439 163.987 307.977 163.841 307.416 163.841C306.855 163.841 306.393 163.987 306.031 164.278C305.669 164.569 305.401 164.951 305.227 165.423C305.053 165.895 304.966 166.405 304.966 166.952C304.966 167.499 305.053 168.006 305.227 168.475C305.401 168.944 305.669 169.322 306.031 169.61C306.393 169.897 306.855 170.041 307.416 170.041ZM313.042 171V162.818H314.257V164.054H314.342C314.491 163.649 314.761 163.321 315.152 163.069C315.542 162.816 315.983 162.69 316.473 162.69C316.565 162.69 316.68 162.692 316.819 162.696C316.957 162.699 317.062 162.705 317.133 162.712V163.99C317.09 163.979 316.993 163.963 316.84 163.942C316.691 163.917 316.533 163.905 316.366 163.905C315.968 163.905 315.613 163.988 315.301 164.155C314.992 164.319 314.747 164.546 314.566 164.837C314.388 165.125 314.299 165.453 314.299 165.822V171H313.042ZM322.694 162.818V163.884H318.454V162.818H322.694ZM319.69 160.858H320.947V168.656C320.947 169.011 320.998 169.278 321.101 169.455C321.208 169.629 321.343 169.746 321.506 169.807C321.673 169.864 321.849 169.892 322.034 169.892C322.172 169.892 322.286 169.885 322.375 169.871C322.463 169.853 322.534 169.839 322.588 169.828L322.843 170.957C322.758 170.989 322.639 171.021 322.486 171.053C322.334 171.089 322.14 171.107 321.906 171.107C321.551 171.107 321.203 171.03 320.862 170.877C320.524 170.725 320.244 170.492 320.02 170.18C319.8 169.867 319.69 169.473 319.69 168.997V160.858ZM326.018 166.078V171H324.761V160.091H326.018V164.097H326.125C326.316 163.674 326.604 163.338 326.987 163.09C327.375 162.838 327.889 162.712 328.532 162.712C329.09 162.712 329.578 162.824 329.997 163.047C330.416 163.267 330.741 163.607 330.972 164.065C331.206 164.519 331.323 165.098 331.323 165.801V171H330.066V165.886C330.066 165.237 329.898 164.734 329.56 164.379C329.226 164.02 328.763 163.841 328.17 163.841C327.758 163.841 327.389 163.928 327.062 164.102C326.739 164.276 326.483 164.53 326.295 164.864C326.11 165.197 326.018 165.602 326.018 166.078ZM262.474 194.17C261.736 194.17 261.088 193.995 260.53 193.643C259.976 193.292 259.543 192.8 259.23 192.168C258.922 191.536 258.767 190.797 258.767 189.952C258.767 189.099 258.922 188.355 259.23 187.72C259.543 187.084 259.976 186.591 260.53 186.239C261.088 185.887 261.736 185.712 262.474 185.712C263.213 185.712 263.859 185.887 264.413 186.239C264.971 186.591 265.404 187.084 265.713 187.72C266.026 188.355 266.182 189.099 266.182 189.952C266.182 190.797 266.026 191.536 265.713 192.168C265.404 192.8 264.971 193.292 264.413 193.643C263.859 193.995 263.213 194.17 262.474 194.17ZM262.474 193.041C263.036 193.041 263.497 192.897 263.859 192.61C264.222 192.322 264.49 191.944 264.664 191.475C264.838 191.006 264.925 190.499 264.925 189.952C264.925 189.405 264.838 188.895 264.664 188.423C264.49 187.951 264.222 187.569 263.859 187.278C263.497 186.987 263.036 186.841 262.474 186.841C261.913 186.841 261.452 186.987 261.089 187.278C260.727 187.569 260.459 187.951 260.285 188.423C260.111 188.895 260.024 189.405 260.024 189.952C260.024 190.499 260.111 191.006 260.285 191.475C260.459 191.944 260.727 192.322 261.089 192.61C261.452 192.897 261.913 193.041 262.474 193.041ZM268.101 197.068V185.818H269.315V187.118H269.464C269.557 186.976 269.685 186.795 269.848 186.575C270.015 186.351 270.253 186.152 270.562 185.978C270.874 185.8 271.297 185.712 271.829 185.712C272.518 185.712 273.126 185.884 273.651 186.228C274.177 186.573 274.587 187.061 274.882 187.693C275.176 188.325 275.324 189.071 275.324 189.93C275.324 190.797 275.176 191.548 274.882 192.184C274.587 192.816 274.179 193.306 273.657 193.654C273.134 193.998 272.533 194.17 271.851 194.17C271.325 194.17 270.904 194.083 270.588 193.909C270.272 193.732 270.029 193.531 269.859 193.308C269.688 193.08 269.557 192.892 269.464 192.743H269.358V197.068H268.101ZM269.337 189.909C269.337 190.527 269.427 191.072 269.608 191.544C269.789 192.013 270.054 192.381 270.402 192.647C270.75 192.91 271.176 193.041 271.68 193.041C272.206 193.041 272.644 192.903 272.996 192.626C273.351 192.345 273.617 191.969 273.795 191.496C273.976 191.021 274.067 190.491 274.067 189.909C274.067 189.334 273.978 188.815 273.8 188.354C273.626 187.888 273.362 187.521 273.007 187.251C272.655 186.978 272.213 186.841 271.68 186.841C271.169 186.841 270.739 186.971 270.391 187.23C270.043 187.485 269.78 187.844 269.603 188.306C269.425 188.764 269.337 189.298 269.337 189.909ZM280.672 194.17C279.883 194.17 279.203 193.996 278.632 193.648C278.063 193.297 277.625 192.807 277.316 192.178C277.011 191.546 276.858 190.811 276.858 189.973C276.858 189.135 277.011 188.396 277.316 187.757C277.625 187.114 278.055 186.614 278.605 186.255C279.159 185.893 279.805 185.712 280.544 185.712C280.97 185.712 281.391 185.783 281.806 185.925C282.222 186.067 282.6 186.298 282.941 186.617C283.282 186.933 283.554 187.352 283.756 187.874C283.958 188.396 284.06 189.039 284.06 189.803V190.335H277.753V189.249H282.781C282.781 188.787 282.689 188.375 282.504 188.013C282.323 187.651 282.064 187.365 281.726 187.155C281.393 186.946 280.998 186.841 280.544 186.841C280.043 186.841 279.61 186.965 279.244 187.214C278.882 187.459 278.603 187.778 278.408 188.173C278.213 188.567 278.115 188.989 278.115 189.44V190.165C278.115 190.783 278.222 191.306 278.435 191.736C278.651 192.162 278.951 192.487 279.335 192.711C279.718 192.931 280.164 193.041 280.672 193.041C281.002 193.041 281.3 192.995 281.567 192.903C281.837 192.807 282.069 192.665 282.264 192.477C282.46 192.285 282.611 192.047 282.717 191.763L283.932 192.104C283.804 192.516 283.589 192.878 283.287 193.19C282.985 193.499 282.612 193.741 282.169 193.915C281.725 194.085 281.226 194.17 280.672 194.17ZM285.972 194V185.818H287.186V187.054H287.272C287.421 186.649 287.691 186.321 288.081 186.069C288.472 185.816 288.912 185.69 289.402 185.69C289.495 185.69 289.61 185.692 289.748 185.696C289.887 185.699 289.992 185.705 290.063 185.712V186.99C290.02 186.979 289.922 186.963 289.77 186.942C289.621 186.917 289.463 186.905 289.296 186.905C288.898 186.905 288.543 186.988 288.23 187.155C287.921 187.319 287.676 187.546 287.495 187.837C287.318 188.125 287.229 188.453 287.229 188.822V194H285.972ZM293.961 194.192C293.442 194.192 292.972 194.094 292.549 193.899C292.126 193.7 291.791 193.414 291.542 193.041C291.294 192.665 291.169 192.21 291.169 191.678C291.169 191.209 291.262 190.829 291.446 190.538C291.631 190.243 291.878 190.012 292.187 189.845C292.496 189.678 292.837 189.554 293.21 189.472C293.586 189.387 293.964 189.32 294.344 189.27C294.841 189.206 295.244 189.158 295.553 189.126C295.866 189.091 296.093 189.032 296.235 188.95C296.381 188.869 296.453 188.727 296.453 188.524V188.482C296.453 187.956 296.31 187.548 296.022 187.256C295.738 186.965 295.306 186.82 294.728 186.82C294.127 186.82 293.657 186.951 293.316 187.214C292.975 187.477 292.735 187.757 292.597 188.055L291.404 187.629C291.617 187.132 291.901 186.745 292.256 186.468C292.615 186.187 293.005 185.992 293.428 185.882C293.854 185.768 294.273 185.712 294.685 185.712C294.948 185.712 295.25 185.744 295.591 185.808C295.935 185.868 296.267 185.994 296.587 186.186C296.91 186.377 297.178 186.667 297.391 187.054C297.604 187.441 297.711 187.96 297.711 188.609V194H296.453V192.892H296.39C296.304 193.07 296.162 193.26 295.963 193.462C295.765 193.664 295.5 193.837 295.17 193.979C294.839 194.121 294.436 194.192 293.961 194.192ZM294.152 193.062C294.65 193.062 295.069 192.965 295.409 192.77C295.754 192.574 296.013 192.322 296.187 192.013C296.365 191.704 296.453 191.379 296.453 191.038V189.888C296.4 189.952 296.283 190.01 296.102 190.064C295.924 190.113 295.718 190.158 295.484 190.197C295.253 190.232 295.028 190.264 294.808 190.293C294.591 190.317 294.415 190.339 294.28 190.357C293.953 190.399 293.648 190.468 293.364 190.564C293.083 190.657 292.856 190.797 292.682 190.985C292.512 191.17 292.426 191.422 292.426 191.741C292.426 192.178 292.588 192.509 292.911 192.732C293.238 192.952 293.652 193.062 294.152 193.062ZM303.563 185.818V186.884H299.323V185.818H303.563ZM300.559 183.858H301.816V191.656C301.816 192.011 301.868 192.278 301.971 192.455C302.077 192.629 302.212 192.746 302.375 192.807C302.542 192.864 302.718 192.892 302.903 192.892C303.041 192.892 303.155 192.885 303.244 192.871C303.332 192.853 303.403 192.839 303.457 192.828L303.712 193.957C303.627 193.989 303.508 194.021 303.356 194.053C303.203 194.089 303.009 194.107 302.775 194.107C302.42 194.107 302.072 194.03 301.731 193.877C301.394 193.725 301.113 193.492 300.889 193.18C300.669 192.867 300.559 192.473 300.559 191.997V183.858ZM305.454 194V185.818H306.711V194H305.454ZM306.093 184.455C305.848 184.455 305.637 184.371 305.46 184.204C305.286 184.037 305.199 183.837 305.199 183.602C305.199 183.368 305.286 183.167 305.46 183C305.637 182.833 305.848 182.75 306.093 182.75C306.339 182.75 306.548 182.833 306.722 183C306.9 183.167 306.988 183.368 306.988 183.602C306.988 183.837 306.9 184.037 306.722 184.204C306.548 184.371 306.339 184.455 306.093 184.455ZM312.338 194.17C311.599 194.17 310.951 193.995 310.393 193.643C309.839 193.292 309.406 192.8 309.094 192.168C308.785 191.536 308.63 190.797 308.63 189.952C308.63 189.099 308.785 188.355 309.094 187.72C309.406 187.084 309.839 186.591 310.393 186.239C310.951 185.887 311.599 185.712 312.338 185.712C313.076 185.712 313.723 185.887 314.277 186.239C314.834 186.591 315.267 187.084 315.576 187.72C315.889 188.355 316.045 189.099 316.045 189.952C316.045 190.797 315.889 191.536 315.576 192.168C315.267 192.8 314.834 193.292 314.277 193.643C313.723 193.995 313.076 194.17 312.338 194.17ZM312.338 193.041C312.899 193.041 313.36 192.897 313.723 192.61C314.085 192.322 314.353 191.944 314.527 191.475C314.701 191.006 314.788 190.499 314.788 189.952C314.788 189.405 314.701 188.895 314.527 188.423C314.353 187.951 314.085 187.569 313.723 187.278C313.36 186.987 312.899 186.841 312.338 186.841C311.777 186.841 311.315 186.987 310.953 187.278C310.591 187.569 310.322 187.951 310.148 188.423C309.974 188.895 309.887 189.405 309.887 189.952C309.887 190.499 309.974 191.006 310.148 191.475C310.322 191.944 310.591 192.322 310.953 192.61C311.315 192.897 311.777 193.041 312.338 193.041ZM319.221 189.078V194H317.964V185.818H319.179V187.097H319.285C319.477 186.681 319.768 186.347 320.159 186.095C320.549 185.839 321.054 185.712 321.671 185.712C322.225 185.712 322.71 185.825 323.126 186.053C323.541 186.276 323.864 186.617 324.095 187.075C324.326 187.53 324.441 188.105 324.441 188.801V194H323.184V188.886C323.184 188.244 323.017 187.743 322.684 187.384C322.35 187.022 321.892 186.841 321.309 186.841C320.908 186.841 320.549 186.928 320.233 187.102C319.921 187.276 319.674 187.53 319.493 187.864C319.312 188.197 319.221 188.602 319.221 189.078Z", fill: "#04B97A" }),
    /* @__PURE__ */ jsx("path", { d: "M259.321 57V46.0909H265.905V47.2628H260.642V50.9489H265.564V52.1207H260.642V55.8281H265.99V57H259.321ZM273.698 60.0682V55.7429H273.591C273.499 55.892 273.368 56.0803 273.197 56.3075C273.027 56.5312 272.783 56.7319 272.467 56.9094C272.151 57.0835 271.73 57.1705 271.205 57.1705C270.523 57.1705 269.921 56.9982 269.399 56.6538C268.877 56.3058 268.469 55.8157 268.174 55.1836C267.879 54.5479 267.732 53.7969 267.732 52.9304C267.732 52.071 267.879 51.3253 268.174 50.6932C268.469 50.0611 268.879 49.5728 269.404 49.2283C269.93 48.8839 270.537 48.7116 271.226 48.7116C271.759 48.7116 272.18 48.8004 272.489 48.978C272.801 49.152 273.039 49.3509 273.202 49.5746C273.369 49.7947 273.499 49.9759 273.591 50.1179H273.74V48.8182H274.955V60.0682H273.698ZM271.375 56.0412C271.88 56.0412 272.306 55.9098 272.654 55.647C273.002 55.3807 273.266 55.0131 273.447 54.5444C273.629 54.0721 273.719 53.527 273.719 52.9091C273.719 52.2983 273.63 51.7638 273.453 51.3058C273.275 50.8441 273.012 50.4854 272.664 50.2298C272.316 49.9705 271.887 49.8409 271.375 49.8409C270.843 49.8409 270.399 49.9776 270.044 50.2511C269.692 50.521 269.428 50.8885 269.25 51.3537C269.076 51.8153 268.989 52.3338 268.989 52.9091C268.989 53.4915 269.078 54.0206 269.255 54.4964C269.436 54.9687 269.703 55.3452 270.054 55.6257C270.409 55.9027 270.85 56.0412 271.375 56.0412ZM282.412 53.6548V48.8182H283.669V57H282.412V55.6151H282.327C282.135 56.0305 281.837 56.3839 281.432 56.6751C281.027 56.9627 280.516 57.1065 279.898 57.1065C279.387 57.1065 278.932 56.9947 278.534 56.771C278.137 56.5437 277.824 56.2028 277.597 55.7482C277.37 55.2901 277.256 54.7131 277.256 54.017V48.8182H278.513V53.9318C278.513 54.5284 278.68 55.0043 279.014 55.3594C279.351 55.7145 279.781 55.892 280.303 55.892C280.615 55.892 280.933 55.8121 281.256 55.6523C281.583 55.4925 281.857 55.2475 282.077 54.9173C282.3 54.587 282.412 54.1662 282.412 53.6548ZM285.972 57V48.8182H287.229V57H285.972ZM286.611 47.4545C286.366 47.4545 286.155 47.3711 285.977 47.2042C285.803 47.0373 285.716 46.8366 285.716 46.6023C285.716 46.3679 285.803 46.1673 285.977 46.0004C286.155 45.8335 286.366 45.75 286.611 45.75C286.856 45.75 287.066 45.8335 287.24 46.0004C287.417 46.1673 287.506 46.3679 287.506 46.6023C287.506 46.8366 287.417 47.0373 287.24 47.2042C287.066 47.3711 286.856 47.4545 286.611 47.4545ZM289.531 60.0682V48.8182H290.746V50.1179H290.895C290.987 49.9759 291.115 49.7947 291.279 49.5746C291.445 49.3509 291.683 49.152 291.992 48.978C292.305 48.8004 292.727 48.7116 293.26 48.7116C293.949 48.7116 294.556 48.8839 295.082 49.2283C295.607 49.5728 296.018 50.0611 296.312 50.6932C296.607 51.3253 296.754 52.071 296.754 52.9304C296.754 53.7969 296.607 54.5479 296.312 55.1836C296.018 55.8157 295.609 56.3058 295.087 56.6538C294.565 56.9982 293.963 57.1705 293.281 57.1705C292.756 57.1705 292.335 57.0835 292.019 56.9094C291.703 56.7319 291.46 56.5312 291.289 56.3075C291.119 56.0803 290.987 55.892 290.895 55.7429H290.789V60.0682H289.531ZM290.767 52.9091C290.767 53.527 290.858 54.0721 291.039 54.5444C291.22 55.0131 291.485 55.3807 291.833 55.647C292.181 55.9098 292.607 56.0412 293.111 56.0412C293.637 56.0412 294.075 55.9027 294.427 55.6257C294.782 55.3452 295.048 54.9687 295.226 54.4964C295.407 54.0206 295.497 53.4915 295.497 52.9091C295.497 52.3338 295.409 51.8153 295.231 51.3537C295.057 50.8885 294.792 50.521 294.437 50.2511C294.086 49.9776 293.644 49.8409 293.111 49.8409C292.6 49.8409 292.17 49.9705 291.822 50.2298C291.474 50.4854 291.211 50.8441 291.034 51.3058C290.856 51.7638 290.767 52.2983 290.767 52.9091ZM298.672 60.0682V48.8182H299.887V50.1179H300.036C300.128 49.9759 300.256 49.7947 300.419 49.5746C300.586 49.3509 300.824 49.152 301.133 48.978C301.445 48.8004 301.868 48.7116 302.401 48.7116C303.09 48.7116 303.697 48.8839 304.222 49.2283C304.748 49.5728 305.158 50.0611 305.453 50.6932C305.748 51.3253 305.895 52.071 305.895 52.9304C305.895 53.7969 305.748 54.5479 305.453 55.1836C305.158 55.8157 304.75 56.3058 304.228 56.6538C303.706 56.9982 303.104 57.1705 302.422 57.1705C301.896 57.1705 301.476 57.0835 301.16 56.9094C300.844 56.7319 300.6 56.5312 300.43 56.3075C300.259 56.0803 300.128 55.892 300.036 55.7429H299.929V60.0682H298.672ZM299.908 52.9091C299.908 53.527 299.998 54.0721 300.18 54.5444C300.361 55.0131 300.625 55.3807 300.973 55.647C301.321 55.9098 301.747 56.0412 302.252 56.0412C302.777 56.0412 303.216 55.9027 303.567 55.6257C303.922 55.3452 304.189 54.9687 304.366 54.4964C304.547 54.0206 304.638 53.4915 304.638 52.9091C304.638 52.3338 304.549 51.8153 304.372 51.3537C304.198 50.8885 303.933 50.521 303.578 50.2511C303.226 49.9776 302.784 49.8409 302.252 49.8409C301.74 49.8409 301.311 49.9705 300.963 50.2298C300.615 50.4854 300.352 50.8441 300.174 51.3058C299.997 51.7638 299.908 52.2983 299.908 52.9091ZM311.243 57.1705C310.455 57.1705 309.775 56.9964 309.203 56.6484C308.635 56.2969 308.196 55.8068 307.887 55.1783C307.582 54.5462 307.429 53.8111 307.429 52.973C307.429 52.1349 307.582 51.3963 307.887 50.7571C308.196 50.1143 308.626 49.6136 309.176 49.255C309.73 48.8928 310.377 48.7116 311.115 48.7116C311.541 48.7116 311.962 48.7827 312.378 48.9247C312.793 49.0668 313.171 49.2976 313.512 49.6172C313.853 49.9332 314.125 50.3523 314.327 50.8743C314.53 51.3963 314.631 52.0391 314.631 52.8026V53.3352H308.324V52.2486H313.352C313.352 51.7869 313.26 51.375 313.075 51.0128C312.894 50.6506 312.635 50.3647 312.298 50.1552C311.964 49.9457 311.57 49.8409 311.115 49.8409C310.615 49.8409 310.181 49.9652 309.816 50.2138C309.453 50.4588 309.175 50.7784 308.979 51.1726C308.784 51.5668 308.686 51.9893 308.686 52.4403V53.1648C308.686 53.7827 308.793 54.3065 309.006 54.7362C309.222 55.1623 309.523 55.4872 309.906 55.7109C310.29 55.9311 310.735 56.0412 311.243 56.0412C311.573 56.0412 311.872 55.995 312.138 55.9027C312.408 55.8068 312.64 55.6648 312.836 55.4766C313.031 55.2848 313.182 55.0469 313.289 54.7628L314.503 55.1037C314.375 55.5156 314.16 55.8778 313.858 56.1903C313.557 56.4993 313.184 56.7408 312.74 56.9148C312.296 57.0852 311.797 57.1705 311.243 57.1705ZM319.633 57.1705C318.951 57.1705 318.349 56.9982 317.827 56.6538C317.305 56.3058 316.896 55.8157 316.602 55.1836C316.307 54.5479 316.16 53.7969 316.16 52.9304C316.16 52.071 316.307 51.3253 316.602 50.6932C316.896 50.0611 317.307 49.5728 317.832 49.2283C318.358 48.8839 318.965 48.7116 319.654 48.7116C320.187 48.7116 320.607 48.8004 320.916 48.978C321.229 49.152 321.467 49.3509 321.63 49.5746C321.797 49.7947 321.927 49.9759 322.019 50.1179H322.126V46.0909H323.383V57H322.168V55.7429H322.019C321.927 55.892 321.795 56.0803 321.625 56.3075C321.454 56.5312 321.211 56.7319 320.895 56.9094C320.579 57.0835 320.158 57.1705 319.633 57.1705ZM319.803 56.0412C320.307 56.0412 320.733 55.9098 321.081 55.647C321.43 55.3807 321.694 55.0131 321.875 54.5444C322.056 54.0721 322.147 53.527 322.147 52.9091C322.147 52.2983 322.058 51.7638 321.881 51.3058C321.703 50.8441 321.44 50.4854 321.092 50.2298C320.744 49.9705 320.314 49.8409 319.803 49.8409C319.27 49.8409 318.827 49.9776 318.471 50.2511C318.12 50.521 317.855 50.8885 317.678 51.3537C317.504 51.8153 317.417 52.3338 317.417 52.9091C317.417 53.4915 317.506 54.0206 317.683 54.4964C317.864 54.9687 318.131 55.3452 318.482 55.6257C318.837 55.9027 319.278 56.0412 319.803 56.0412Z", fill: "#D28A04" })
  ] }), $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]);
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsxs("radialGradient", { id: "paint0_radial_38_7016", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(153.5 100.5) rotate(90) scale(158.5 242.087)", children: [
    /* @__PURE__ */ jsx("stop", { stopColor: "#252837" }),
    /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#0D0E12" })
  ] }), $[2] = t2) : t2 = $[2];
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsxs("linearGradient", { id: "paint1_linear_38_7016", x1: "168.5", y1: "-21.875", x2: "168.5", y2: "183", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ jsx("stop", { stopColor: "#13141B" }),
    /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#9499AD" })
  ] }), $[3] = t3) : t3 = $[3];
  let t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsxs("linearGradient", { id: "paint2_linear_38_7016", x1: "241", y1: "3.25", x2: "163.5", y2: "3.25", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ jsx("stop", { stopColor: "#A9F9DC" }),
    /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#0FF0A1" })
  ] }), $[4] = t4) : t4 = $[4];
  let t5;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsxs("linearGradient", { id: "paint3_linear_38_7016", x1: "241", y1: "108.25", x2: "168", y2: "108.25", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ jsx("stop", { stopColor: "#A9F9DC" }),
    /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#0FF0A1" })
  ] }), $[5] = t5) : t5 = $[5];
  let t6;
  return $[6] === Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsxs("svg", { height: "auto", width: "100%", viewBox: "0 0 307 201", fill: "none", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMinYMin", style: t0, children: [
    t1,
    /* @__PURE__ */ jsxs("defs", { children: [
      t2,
      t3,
      t4,
      t5,
      /* @__PURE__ */ jsxs("linearGradient", { id: "paint4_linear_38_7016", x1: "241", y1: "63.25", x2: "168", y2: "63.25", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#F9E994" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#F9BC15" })
      ] })
    ] })
  ] }), $[6] = t6) : t6 = $[6], t6;
}
const POPOVER_RADIUS = 3;
function CreateLinkedDocumentBannerContent(props2) {
  const $ = c(51), {
    metadata
  } = props2, [infoOpen, setInfoOpen] = useState(!1), popoverRef = useRef(null), infoButtonRef = useRef(null), {
    t
  } = useTranslation(createLocaleNamespace);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setInfoOpen(_temp$L), $[0] = t0) : t0 = $[0];
  const toggleOpen = t0;
  let t1, t2;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setInfoOpen(!1), t2 = () => [popoverRef.current, infoButtonRef.current], $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useClickOutsideEvent(t1, t2);
  let t3;
  if ($[3] !== infoOpen ? (t3 = (event) => {
    event.key === "Escape" && infoOpen && setInfoOpen(!1);
  }, $[3] = infoOpen, $[4] = t3) : t3 = $[4], useGlobalKeyDown(t3), metadata?.ejected !== !1)
    return null;
  let t4;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(CreateSvg, {}), $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t ? (t5 = t("create-link-info-popover.eyebrow-title"), $[6] = t, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t5 }), $[8] = t5, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t ? (t7 = t("create-link-info-popover.eyebrow-badge"), $[10] = t, $[11] = t7) : t7 = $[11];
  let t8;
  $[12] !== t7 ? (t8 = /* @__PURE__ */ jsx(Badge, { fontSize: 1, children: t7 }), $[12] = t7, $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== t6 || $[15] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t6,
    t8
  ] }), $[14] = t6, $[15] = t8, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== t ? (t10 = t("create-link-info-popover.header"), $[17] = t, $[18] = t10) : t10 = $[18];
  let t11;
  $[19] !== t10 ? (t11 = /* @__PURE__ */ jsx(Heading, { size: 2, children: t10 }), $[19] = t10, $[20] = t11) : t11 = $[20];
  let t12;
  $[21] !== t ? (t12 = t("create-link-info-popover.text"), $[21] = t, $[22] = t12) : t12 = $[22];
  let t13;
  $[23] !== t12 ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t12 }), $[23] = t12, $[24] = t13) : t13 = $[24];
  let t14;
  $[25] === Symbol.for("react.memo_cache_sentinel") ? (t14 = /* @__PURE__ */ jsx(Flex, { flex: 1, justify: "flex-end", children: /* @__PURE__ */ jsx(CreateLearnMoreButton, {}) }), $[25] = t14) : t14 = $[25];
  let t15;
  $[26] !== t11 || $[27] !== t13 ? (t15 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t11,
    t13,
    t14
  ] }), $[26] = t11, $[27] = t13, $[28] = t15) : t15 = $[28];
  let t16;
  $[29] !== t15 || $[30] !== t9 ? (t16 = /* @__PURE__ */ jsxs(Card, { overflow: "hidden", radius: POPOVER_RADIUS, ref: popoverRef, children: [
    t4,
    /* @__PURE__ */ jsxs(Stack, { space: 3, paddingX: 4, paddingY: 3, children: [
      t9,
      t15
    ] })
  ] }), $[29] = t15, $[30] = t9, $[31] = t16) : t16 = $[31];
  const popoverContent = t16;
  let t17;
  $[32] === Symbol.for("react.memo_cache_sentinel") ? (t17 = /* @__PURE__ */ jsx(Text$1, { size: 0, weight: "medium", children: /* @__PURE__ */ jsx(ReadOnlyIcon, {}) }), $[32] = t17) : t17 = $[32];
  let t18;
  $[33] !== t ? (t18 = t("studio-create-link-banner.text"), $[33] = t, $[34] = t18) : t18 = $[34];
  let t19;
  $[35] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t17,
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t18 }) })
  ] }), $[35] = t18, $[36] = t19) : t19 = $[36];
  let t20;
  $[37] === Symbol.for("react.memo_cache_sentinel") ? (t20 = {
    width: 320
  }, $[37] = t20) : t20 = $[37];
  let t21;
  $[38] === Symbol.for("react.memo_cache_sentinel") ? (t21 = ["bottom", "bottom-end", "right-start", "right", "right-end"], $[38] = t21) : t21 = $[38];
  let t22;
  $[39] === Symbol.for("react.memo_cache_sentinel") ? (t22 = {
    marginBottom: "-0.5em",
    marginTop: "-0.5em"
  }, $[39] = t22) : t22 = $[39];
  let t23;
  $[40] !== t ? (t23 = t("create-link-info.tooltip"), $[40] = t, $[41] = t23) : t23 = $[41];
  let t24;
  $[42] !== t23 ? (t24 = /* @__PURE__ */ jsx(Button, { ref: infoButtonRef, icon: InfoOutlineIcon, mode: "bleed", onClick: toggleOpen, style: t22, tooltipProps: {
    content: t23
  } }), $[42] = t23, $[43] = t24) : t24 = $[43];
  let t25;
  $[44] !== infoOpen || $[45] !== popoverContent || $[46] !== t24 ? (t25 = /* @__PURE__ */ jsx(Popover, { content: popoverContent, open: infoOpen, radius: POPOVER_RADIUS, style: t20, tone: "default", placement: "bottom-start", fallbackPlacements: t21, children: t24 }), $[44] = infoOpen, $[45] = popoverContent, $[46] = t24, $[47] = t25) : t25 = $[47];
  let t26;
  return $[48] !== t19 || $[49] !== t25 ? (t26 = /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t19,
    t25
  ] }), $[48] = t19, $[49] = t25, $[50] = t26) : t26 = $[50], t26;
}
function _temp$L(current) {
  return !current;
}
function SanityCreateConfigProvider(props2) {
  const $ = c(8), {
    children
  } = props2, {
    beta
  } = useSource(), appIdCache = useAppIdCache();
  let t0;
  const t1 = beta?.create, t2 = !!beta?.create?.startInCreateEnabled;
  let t3;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    documentLinkedBannerContent: CreateLinkedDocumentBannerContent,
    documentLinkedActions: CreateLinkedActions
  }, $[0] = t3) : t3 = $[0];
  let t4;
  $[1] !== appIdCache || $[2] !== t1 || $[3] !== t2 ? (t4 = {
    ...t1,
    startInCreateEnabled: t2,
    appIdCache,
    components: t3
  }, $[1] = appIdCache, $[2] = t1, $[3] = t2, $[4] = t4) : t4 = $[4], t0 = t4;
  const value = t0;
  let t5;
  return $[5] !== children || $[6] !== value ? (t5 = /* @__PURE__ */ jsx(SanityCreateConfigContext.Provider, { value, children }), $[5] = children, $[6] = value, $[7] = t5) : t5 = $[7], t5;
}
function CreateIntegrationWrapper(props2) {
  const $ = c(4);
  let t0;
  $[0] !== props2 ? (t0 = props2.renderDefault(props2), $[0] = props2, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(SanityCreateConfigProvider, { children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
const createIntegration = definePlugin(() => ({
  name: "sanity/create-integration",
  studio: {
    components: {
      layout: CreateIntegrationWrapper
    }
  },
  i18n: {
    bundles: [createUsEnglishLocaleBundle]
  }
})), ErrorCallout = (props2) => {
  const $ = c(8), {
    description,
    title
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Text$1, { size: 2, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== title ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: title }), $[1] = title, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== description ? (t2 = description && /* @__PURE__ */ jsx(Text$1, { size: 1, children: description }), $[3] = description, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== t1 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { overflow: "hidden", padding: 4, radius: 2, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 4, children: [
    t0,
    /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
      t1,
      t2
    ] })
  ] }) }), $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, InfoCallout = () => {
  const $ = c(5);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Text$1, { size: 2, children: /* @__PURE__ */ jsx(InfoOutlineIcon, {}) }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: "Schedule Publishing is not enabled" }), $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    "We recommend using",
    " ",
    /* @__PURE__ */ jsx("a", { target: "_blank", href: RELEASES_DOCS_URL, rel: "noreferrer", children: "Releases" }),
    "."
  ] }), $[2] = t2) : t2 = $[2];
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    "Scheduled Publishing is not enabled by default. It can be enabled in the config by setting ",
    /* @__PURE__ */ jsx("code", { children: "scheduledPublishing.enabled = true" })
  ] }), $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Card, { overflow: "hidden", padding: 4, radius: 2, shadow: 1, tone: "suggest", children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 4, children: [
    t0,
    /* @__PURE__ */ jsxs(Inline, { space: 3, children: [
      t1,
      /* @__PURE__ */ jsxs(Stack, { space: 3, marginTop: 2, children: [
        t2,
        t3,
        /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx("a", { target: "_blank", href: "https://www.sanity.io/docs/scheduled-publishing", rel: "noreferrer", children: "Read the docs" }) })
      ] })
    ] })
  ] }) }), $[4] = t4) : t4 = $[4], t4;
}, ButtonTimeZone = (props2) => {
  const $ = c(15), {
    useElementQueries
  } = props2, {
    timeZone
  } = useTimeZone(), {
    DialogTimeZone: DialogTimeZone2,
    dialogProps,
    dialogTimeZoneShow
  } = useDialogTimeZone();
  let t0;
  $[0] !== DialogTimeZone2 || $[1] !== dialogProps ? (t0 = DialogTimeZone2 && /* @__PURE__ */ jsx(DialogTimeZone2, { ...dialogProps }), $[0] = DialogTimeZone2, $[1] = dialogProps, $[2] = t0) : t0 = $[2];
  const t1 = `Displaying schedules in ${timeZone.alternativeName} (GMT${timeZone.offset})`;
  let t2;
  $[3] !== dialogTimeZoneShow || $[4] !== timeZone.abbreviation || $[5] !== timeZone.alternativeName || $[6] !== timeZone.namePretty || $[7] !== useElementQueries ? (t2 = /* @__PURE__ */ jsx("div", { children: useElementQueries ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { className: "button-small", children: /* @__PURE__ */ jsx(Button, { icon: EarthAmericasIcon, mode: "bleed", onClick: dialogTimeZoneShow, text: `${timeZone.abbreviation}` }) }),
    /* @__PURE__ */ jsx(Box, { className: "button-large", children: /* @__PURE__ */ jsx(Button, { icon: EarthAmericasIcon, mode: "bleed", onClick: dialogTimeZoneShow, text: `${timeZone.alternativeName} (${timeZone.namePretty})` }) })
  ] }) : /* @__PURE__ */ jsx(Button, { icon: EarthAmericasIcon, mode: "bleed", onClick: dialogTimeZoneShow, text: `${timeZone.alternativeName} (${timeZone.namePretty})` }) }), $[3] = dialogTimeZoneShow, $[4] = timeZone.abbreviation, $[5] = timeZone.alternativeName, $[6] = timeZone.namePretty, $[7] = useElementQueries, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t1 || $[10] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content: t1, portal: !0, children: t2 }), $[9] = t1, $[10] = t2, $[11] = t3) : t3 = $[11];
  let t4;
  return $[12] !== t0 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t0,
    t3
  ] }), $[12] = t0, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
}, ButtonTimeZoneElementQuery = styled(ElementQuery)`
  .button-small {
    display: block;
  }
  .button-large {
    display: none;
  }

  &[data-eq-min~='2'] {
    .button-small {
      display: none;
    }
    .button-large {
      display: block;
    }
  }
`, SmallIcon = styled(ArrowRightIcon)((props2) => {
  const {
    font
  } = getTheme_v2(props2.theme), {
    ascenderHeight,
    descenderHeight,
    lineHeight,
    iconSize
  } = font.text.sizes[0], negHeight = ascenderHeight + descenderHeight, iconOffset = (lineHeight - negHeight - iconSize) / 2;
  return css`
    &[data-sanity-icon] {
      color: var(--card-link-color);
      font-size: calc(${iconSize} / 16 * 1rem);
      margin: ${rem(iconOffset)};
      margin-bottom: ${rem(iconOffset)};
    }
  `;
});
function WarningBanner() {
  const $ = c(8), t0 = !(useMediaIndex() >= 2);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(WarningOutlineIcon, {}), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t0 ? (t2 = /* @__PURE__ */ jsx(Text$1, { hidden: t0, children: t1 }), $[1] = t0, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: "You are running both the new Releases and Scheduled Publishing" }), $[3] = t3) : t3 = $[3];
  let t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    whiteSpace: "nowrap"
  }, $[4] = t4) : t4 = $[4];
  let t5;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, style: t4, children: /* @__PURE__ */ jsxs("a", { href: RELEASES_DOCS_URL, target: "_blank", rel: "noreferrer", children: [
    "Read more ",
    " ",
    /* @__PURE__ */ jsx(SmallIcon, {})
  ] }) }), $[5] = t5) : t5 = $[5];
  let t6;
  return $[6] !== t2 ? (t6 = /* @__PURE__ */ jsx(Card, { padding: 4, tone: "caution", width: "fill", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", justify: "center", children: [
    t2,
    t3,
    t5
  ] }) }), $[6] = t2, $[7] = t6) : t6 = $[7], t6;
}
const noop = () => {
}, UNDEFINED = (
  /*#__NOINLINE__*/
  noop()
), OBJECT = Object, isUndefined = (v) => v === UNDEFINED, isFunction = (v) => typeof v == "function", mergeObjects = (a, b) => ({
  ...a,
  ...b
}), isPromiseLike = (x) => isFunction(x.then), table = /* @__PURE__ */ new WeakMap();
let counter$1 = 0;
const stableHash = (arg) => {
  const type = typeof arg, constructor = arg && arg.constructor, isDate = constructor == Date;
  let result, index;
  if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
    if (result = table.get(arg), result) return result;
    if (result = ++counter$1 + "~", table.set(arg, result), constructor == Array) {
      for (result = "@", index = 0; index < arg.length; index++)
        result += stableHash(arg[index]) + ",";
      table.set(arg, result);
    }
    if (constructor == OBJECT) {
      result = "#";
      const keys = OBJECT.keys(arg).sort();
      for (; !isUndefined(index = keys.pop()); )
        isUndefined(arg[index]) || (result += index + ":" + stableHash(arg[index]) + ",");
      table.set(arg, result);
    }
  } else
    result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
  return result;
}, SWRGlobalState = /* @__PURE__ */ new WeakMap(), EMPTY_CACHE = {}, INITIAL_CACHE = {}, STR_UNDEFINED = "undefined", isWindowDefined = typeof window != STR_UNDEFINED, isDocumentDefined = typeof document != STR_UNDEFINED, hasRequestAnimationFrame = () => isWindowDefined && typeof window.requestAnimationFrame != STR_UNDEFINED, createCacheHelper = (cache2, key) => {
  const state = SWRGlobalState.get(cache2);
  return [
    // Getter
    () => !isUndefined(key) && cache2.get(key) || EMPTY_CACHE,
    // Setter
    (info) => {
      if (!isUndefined(key)) {
        const prev = cache2.get(key);
        key in INITIAL_CACHE || (INITIAL_CACHE[key] = prev), state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
      }
    },
    // Subscriber
    state[6],
    // Get server cache snapshot
    () => !isUndefined(key) && key in INITIAL_CACHE ? INITIAL_CACHE[key] : !isUndefined(key) && cache2.get(key) || EMPTY_CACHE
  ];
};
let online = !0;
const isOnline = () => online, [onWindowEvent, offWindowEvent] = isWindowDefined && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  noop,
  noop
], isVisible = () => {
  const visibilityState = isDocumentDefined && document.visibilityState;
  return isUndefined(visibilityState) || visibilityState !== "hidden";
}, initFocus = (callback) => (isDocumentDefined && document.addEventListener("visibilitychange", callback), onWindowEvent("focus", callback), () => {
  isDocumentDefined && document.removeEventListener("visibilitychange", callback), offWindowEvent("focus", callback);
}), initReconnect = (callback) => {
  const onOnline = () => {
    online = !0, callback();
  }, onOffline = () => {
    online = !1;
  };
  return onWindowEvent("online", onOnline), onWindowEvent("offline", onOffline), () => {
    offWindowEvent("online", onOnline), offWindowEvent("offline", onOffline);
  };
}, preset = {
  isOnline,
  isVisible
}, defaultConfigOptions = {
  initFocus,
  initReconnect
}, IS_REACT_LEGACY = !React.useId, IS_SERVER = !isWindowDefined || "Deno" in window, rAF = (f) => hasRequestAnimationFrame() ? window.requestAnimationFrame(f) : setTimeout(f, 1), useIsomorphicLayoutEffect = IS_SERVER ? useEffect : useLayoutEffect, navigatorConnection = typeof navigator < "u" && navigator.connection, slowConnection = !IS_SERVER && navigatorConnection && ([
  "slow-2g",
  "2g"
].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData), serialize$2 = (key) => {
  if (isFunction(key))
    try {
      key = key();
    } catch {
      key = "";
    }
  const args = key;
  return key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : "", [
    key,
    args
  ];
};
let __timestamp = 0;
const getTimestamp = () => ++__timestamp, FOCUS_EVENT = 0, RECONNECT_EVENT = 1, MUTATE_EVENT = 2, ERROR_REVALIDATE_EVENT = 3;
var events = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT,
  FOCUS_EVENT,
  MUTATE_EVENT,
  RECONNECT_EVENT
};
async function internalMutate(...args) {
  const [cache2, _key, _data, _opts] = args, options = mergeObjects({
    populateCache: !0,
    throwOnError: !0
  }, typeof _opts == "boolean" ? {
    revalidate: _opts
  } : _opts || {});
  let populateCache = options.populateCache;
  const rollbackOnErrorOption = options.rollbackOnError;
  let optimisticData = options.optimisticData;
  const rollbackOnError = (error) => typeof rollbackOnErrorOption == "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== !1, throwOnError = options.throwOnError;
  if (isFunction(_key)) {
    const keyFilter = _key, matchedKeys = [], it = cache2.keys();
    for (const key of it)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(key) && keyFilter(cache2.get(key)._k) && matchedKeys.push(key);
    return Promise.all(matchedKeys.map(mutateByKey));
  }
  return mutateByKey(_key);
  async function mutateByKey(_k) {
    const [key] = serialize$2(_k);
    if (!key) return;
    const [get2, set2] = createCacheHelper(cache2, key), [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = SWRGlobalState.get(cache2), startRevalidate = () => {
      const revalidators = EVENT_REVALIDATORS[key];
      return (isFunction(options.revalidate) ? options.revalidate(get2().data, _k) : options.revalidate !== !1) && (delete FETCH[key], delete PRELOAD[key], revalidators && revalidators[0]) ? revalidators[0](MUTATE_EVENT).then(() => get2().data) : get2().data;
    };
    if (args.length < 3)
      return startRevalidate();
    let data = _data, error;
    const beforeMutationTs = getTimestamp();
    MUTATION[key] = [
      beforeMutationTs,
      0
    ];
    const hasOptimisticData = !isUndefined(optimisticData), state = get2(), displayedData = state.data, currentData = state._c, committedData = isUndefined(currentData) ? displayedData : currentData;
    if (hasOptimisticData && (optimisticData = isFunction(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData, set2({
      data: optimisticData,
      _c: committedData
    })), isFunction(data))
      try {
        data = data(committedData);
      } catch (err) {
        error = err;
      }
    if (data && isPromiseLike(data))
      if (data = await data.catch((err) => {
        error = err;
      }), beforeMutationTs !== MUTATION[key][0]) {
        if (error) throw error;
        return data;
      } else error && hasOptimisticData && rollbackOnError(error) && (populateCache = !0, set2({
        data: committedData,
        _c: UNDEFINED
      }));
    if (populateCache && !error)
      if (isFunction(populateCache)) {
        const populateCachedData = populateCache(data, committedData);
        set2({
          data: populateCachedData,
          error: UNDEFINED,
          _c: UNDEFINED
        });
      } else
        set2({
          data,
          error: UNDEFINED,
          _c: UNDEFINED
        });
    if (MUTATION[key][1] = getTimestamp(), Promise.resolve(startRevalidate()).then(() => {
      set2({
        _c: UNDEFINED
      });
    }), error) {
      if (throwOnError) throw error;
      return;
    }
    return data;
  }
}
const revalidateAllKeys = (revalidators, type) => {
  for (const key in revalidators)
    revalidators[key][0] && revalidators[key][0](type);
}, initCache = (provider, options) => {
  if (!SWRGlobalState.has(provider)) {
    const opts = mergeObjects(defaultConfigOptions, options), EVENT_REVALIDATORS = {}, mutate2 = internalMutate.bind(UNDEFINED, provider);
    let unmount = noop;
    const subscriptions = {}, subscribe2 = (key, callback) => {
      const subs = subscriptions[key] || [];
      return subscriptions[key] = subs, subs.push(callback), () => subs.splice(subs.indexOf(callback), 1);
    }, setter = (key, value, prev) => {
      provider.set(key, value);
      const subs = subscriptions[key];
      if (subs)
        for (const fn of subs)
          fn(value, prev);
    }, initProvider = () => {
      if (!SWRGlobalState.has(provider) && (SWRGlobalState.set(provider, [
        EVENT_REVALIDATORS,
        {},
        {},
        {},
        mutate2,
        setter,
        subscribe2
      ]), !IS_SERVER)) {
        const releaseFocus = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT))), releaseReconnect = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
        unmount = () => {
          releaseFocus && releaseFocus(), releaseReconnect && releaseReconnect(), SWRGlobalState.delete(provider);
        };
      }
    };
    return initProvider(), [
      provider,
      mutate2,
      initProvider,
      unmount
    ];
  }
  return [
    provider,
    SWRGlobalState.get(provider)[4]
  ];
}, onErrorRetry = (_, __, config, revalidate, opts) => {
  const maxRetryCount = config.errorRetryCount, currentRetryCount = opts.retryCount, timeout2 = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
  !isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount || setTimeout(revalidate, timeout2, opts);
}, compare = (currentData, newData) => stableHash(currentData) == stableHash(newData), [cache, mutate] = initCache(/* @__PURE__ */ new Map()), defaultConfig = mergeObjects(
  {
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: slowConnection ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: slowConnection ? 5e3 : 3e3,
    // providers
    compare,
    isPaused: () => !1,
    cache,
    mutate,
    fallback: {}
  },
  // use web preset by default
  preset
), mergeConfigs = (a, b) => {
  const v = mergeObjects(a, b);
  if (b) {
    const { use: u1, fallback: f1 } = a, { use: u2, fallback: f2 } = b;
    u1 && u2 && (v.use = u1.concat(u2)), f1 && f2 && (v.fallback = mergeObjects(f1, f2));
  }
  return v;
}, SWRConfigContext = createContext$1({}), INFINITE_PREFIX = "$inf$", enableDevtools = isWindowDefined && window.__SWR_DEVTOOLS_USE__, use$1 = enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [], setupDevTools = () => {
  enableDevtools && (window.__SWR_DEVTOOLS_REACT__ = React);
}, normalize = (args) => isFunction(args[1]) ? [
  args[0],
  args[1],
  args[2] || {}
] : [
  args[0],
  null,
  (args[1] === null ? args[2] : args[1]) || {}
], useSWRConfig = () => mergeObjects(defaultConfig, useContext(SWRConfigContext)), middleware = (useSWRNext) => (key_, fetcher_, config) => useSWRNext(key_, fetcher_ && ((...args) => {
  const [key] = serialize$2(key_), [, , , PRELOAD] = SWRGlobalState.get(cache);
  if (key.startsWith(INFINITE_PREFIX))
    return fetcher_(...args);
  const req = PRELOAD[key];
  return isUndefined(req) ? fetcher_(...args) : (delete PRELOAD[key], req);
}), config), BUILT_IN_MIDDLEWARE = use$1.concat(middleware), withArgs = (hook) => function(...args) {
  const fallbackConfig = useSWRConfig(), [key, fn, _config] = normalize(args), config = mergeConfigs(fallbackConfig, _config);
  let next = hook;
  const { use: use2 } = config, middleware2 = (use2 || []).concat(BUILT_IN_MIDDLEWARE);
  for (let i = middleware2.length; i--; )
    next = middleware2[i](next);
  return next(key, fn || config.fetcher || null, config);
}, subscribeCallback = (key, callbacks, callback) => {
  const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
  return keyedRevalidators.push(callback), () => {
    const index = keyedRevalidators.indexOf(callback);
    index >= 0 && (keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1], keyedRevalidators.pop());
  };
};
setupDevTools();
const use = React.use || ((promise) => {
  if (promise.status === "pending")
    throw promise;
  if (promise.status === "fulfilled")
    return promise.value;
  throw promise.status === "rejected" ? promise.reason : (promise.status = "pending", promise.then((v) => {
    promise.status = "fulfilled", promise.value = v;
  }, (e) => {
    promise.status = "rejected", promise.reason = e;
  }), promise);
}), WITH_DEDUPE = {
  dedupe: !0
}, useSWRHandler = (_key, fetcher, config) => {
  const { cache: cache2, compare: compare2, suspense, fallbackData, revalidateOnMount, revalidateIfStale, refreshInterval, refreshWhenHidden, refreshWhenOffline, keepPreviousData } = config, [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = SWRGlobalState.get(cache2), [key, fnArg] = serialize$2(_key), initialMountedRef = useRef(!1), unmountedRef = useRef(!1), keyRef = useRef(key), fetcherRef = useRef(fetcher), configRef = useRef(config), getConfig = () => configRef.current, isActive = () => getConfig().isVisible() && getConfig().isOnline(), [getCache, setCache, subscribeCache, getInitialCache] = createCacheHelper(cache2, key), stateDependencies = useRef({}).current, fallback2 = isUndefined(fallbackData) ? config.fallback[key] : fallbackData, isEqual2 = (prev, current) => {
    for (const _ in stateDependencies) {
      const t = _;
      if (t === "data") {
        if (!compare2(prev[t], current[t]) && (!isUndefined(prev[t]) || !compare2(returnedData, current[t])))
          return !1;
      } else if (current[t] !== prev[t])
        return !1;
    }
    return !0;
  }, getSnapshot2 = useMemo(() => {
    const shouldStartRequest = !key || !fetcher ? !1 : isUndefined(revalidateOnMount) ? getConfig().isPaused() || suspense ? !1 : isUndefined(revalidateIfStale) ? !0 : revalidateIfStale : revalidateOnMount, getSelectedCache = (state) => {
      const snapshot2 = mergeObjects(state);
      return delete snapshot2._k, shouldStartRequest ? {
        isValidating: !0,
        isLoading: !0,
        ...snapshot2
      } : snapshot2;
    }, cachedData2 = getCache(), initialData = getInitialCache(), clientSnapshot = getSelectedCache(cachedData2), serverSnapshot = cachedData2 === initialData ? clientSnapshot : getSelectedCache(initialData);
    let memorizedSnapshot = clientSnapshot;
    return [
      () => {
        const newSnapshot = getSelectedCache(getCache());
        return isEqual2(newSnapshot, memorizedSnapshot) ? (memorizedSnapshot.data = newSnapshot.data, memorizedSnapshot.isLoading = newSnapshot.isLoading, memorizedSnapshot.isValidating = newSnapshot.isValidating, memorizedSnapshot.error = newSnapshot.error, memorizedSnapshot) : (memorizedSnapshot = newSnapshot, newSnapshot);
      },
      () => serverSnapshot
    ];
  }, [
    cache2,
    key
  ]), cached = useSyncExternalStore$1(useCallback(
    (callback) => subscribeCache(key, (current, prev) => {
      isEqual2(prev, current) || callback();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      cache2,
      key
    ]
  ), getSnapshot2[0], getSnapshot2[1]), isInitialMount = !initialMountedRef.current, hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0, cachedData = cached.data, data = isUndefined(cachedData) ? fallback2 : cachedData, error = cached.error, laggyDataRef = useRef(data), returnedData = keepPreviousData ? isUndefined(cachedData) ? laggyDataRef.current : cachedData : data, shouldDoInitialRevalidation = hasRevalidator && !isUndefined(error) ? !1 : isInitialMount && !isUndefined(revalidateOnMount) ? revalidateOnMount : getConfig().isPaused() ? !1 : suspense ? isUndefined(data) ? !1 : revalidateIfStale : isUndefined(data) || revalidateIfStale, defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation), isValidating = isUndefined(cached.isValidating) ? defaultValidatingState : cached.isValidating, isLoading = isUndefined(cached.isLoading) ? defaultValidatingState : cached.isLoading, revalidate = useCallback(
    async (revalidateOpts) => {
      const currentFetcher = fetcherRef.current;
      if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused())
        return !1;
      let newData, startAt, loading = !0;
      const opts = revalidateOpts || {}, shouldStartNewRequest = !FETCH[key] || !opts.dedupe, callbackSafeguard = () => IS_REACT_LEGACY ? !unmountedRef.current && key === keyRef.current && initialMountedRef.current : key === keyRef.current, finalState = {
        isValidating: !1,
        isLoading: !1
      }, finishRequestAndUpdateState = () => {
        setCache(finalState);
      }, cleanupState = () => {
        const requestInfo = FETCH[key];
        requestInfo && requestInfo[1] === startAt && delete FETCH[key];
      }, initialState2 = {
        isValidating: !0
      };
      isUndefined(getCache().data) && (initialState2.isLoading = !0);
      try {
        if (shouldStartNewRequest && (setCache(initialState2), config.loadingTimeout && isUndefined(getCache().data) && setTimeout(() => {
          loading && callbackSafeguard() && getConfig().onLoadingSlow(key, config);
        }, config.loadingTimeout), FETCH[key] = [
          currentFetcher(fnArg),
          getTimestamp()
        ]), [newData, startAt] = FETCH[key], newData = await newData, shouldStartNewRequest && setTimeout(cleanupState, config.dedupingInterval), !FETCH[key] || FETCH[key][1] !== startAt)
          return shouldStartNewRequest && callbackSafeguard() && getConfig().onDiscarded(key), !1;
        finalState.error = UNDEFINED;
        const mutationInfo = MUTATION[key];
        if (!isUndefined(mutationInfo) && // case 1
        (startAt <= mutationInfo[0] || // case 2
        startAt <= mutationInfo[1] || // case 3
        mutationInfo[1] === 0))
          return finishRequestAndUpdateState(), shouldStartNewRequest && callbackSafeguard() && getConfig().onDiscarded(key), !1;
        const cacheData = getCache().data;
        finalState.data = compare2(cacheData, newData) ? cacheData : newData, shouldStartNewRequest && callbackSafeguard() && getConfig().onSuccess(newData, key, config);
      } catch (err) {
        cleanupState();
        const currentConfig = getConfig(), { shouldRetryOnError } = currentConfig;
        currentConfig.isPaused() || (finalState.error = err, shouldStartNewRequest && callbackSafeguard() && (currentConfig.onError(err, key, currentConfig), (shouldRetryOnError === !0 || isFunction(shouldRetryOnError) && shouldRetryOnError(err)) && (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) && currentConfig.onErrorRetry(err, key, currentConfig, (_opts) => {
          const revalidators = EVENT_REVALIDATORS[key];
          revalidators && revalidators[0] && revalidators[0](events.ERROR_REVALIDATE_EVENT, _opts);
        }, {
          retryCount: (opts.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return loading = !1, finishRequestAndUpdateState(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      key,
      cache2
    ]
  ), boundMutate = useCallback(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...args) => internalMutate(cache2, keyRef.current, ...args),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (useIsomorphicLayoutEffect(() => {
    fetcherRef.current = fetcher, configRef.current = config, isUndefined(cachedData) || (laggyDataRef.current = cachedData);
  }), useIsomorphicLayoutEffect(() => {
    if (!key) return;
    const softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
    let nextFocusRevalidatedAt = 0;
    const unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, (type, opts = {}) => {
      if (type == events.FOCUS_EVENT) {
        const now = Date.now();
        getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive() && (nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval, softRevalidate());
      } else if (type == events.RECONNECT_EVENT)
        getConfig().revalidateOnReconnect && isActive() && softRevalidate();
      else {
        if (type == events.MUTATE_EVENT)
          return revalidate();
        if (type == events.ERROR_REVALIDATE_EVENT)
          return revalidate(opts);
      }
    });
    return unmountedRef.current = !1, keyRef.current = key, initialMountedRef.current = !0, setCache({
      _k: fnArg
    }), shouldDoInitialRevalidation && (isUndefined(data) || IS_SERVER ? softRevalidate() : rAF(softRevalidate)), () => {
      unmountedRef.current = !0, unsubEvents();
    };
  }, [
    key
  ]), useIsomorphicLayoutEffect(() => {
    let timer2;
    function next() {
      const interval2 = isFunction(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
      interval2 && timer2 !== -1 && (timer2 = setTimeout(execute2, interval2));
    }
    function execute2() {
      !getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline()) ? revalidate(WITH_DEDUPE).then(next) : next();
    }
    return next(), () => {
      timer2 && (clearTimeout(timer2), timer2 = -1);
    };
  }, [
    refreshInterval,
    refreshWhenHidden,
    refreshWhenOffline,
    key
  ]), useDebugValue(returnedData), suspense && isUndefined(data) && key) {
    if (!IS_REACT_LEGACY && IS_SERVER)
      throw new Error("Fallback data is required when using suspense in SSR.");
    fetcherRef.current = fetcher, configRef.current = config, unmountedRef.current = !1;
    const req = PRELOAD[key];
    if (!isUndefined(req)) {
      const promise = boundMutate(req);
      use(promise);
    }
    if (isUndefined(error)) {
      const promise = revalidate(WITH_DEDUPE);
      isUndefined(returnedData) || (promise.status = "fulfilled", promise.value = !0), use(promise);
    } else
      throw error;
  }
  return {
    mutate: boundMutate,
    get data() {
      return stateDependencies.data = !0, returnedData;
    },
    get error() {
      return stateDependencies.error = !0, error;
    },
    get isValidating() {
      return stateDependencies.isValidating = !0, isValidating;
    },
    get isLoading() {
      return stateDependencies.isLoading = !0, isLoading;
    }
  };
}, useSWR = withArgs(useSWRHandler), HAS_USED_SCHEDULED_PUBLISHING = {
  used: !1,
  loading: !0
}, cachedUsedScheduledPublishing = /* @__PURE__ */ new Map();
function fetchUsedScheduledPublishing(client) {
  const {
    dataset,
    projectId
  } = client.config();
  return client.observable.request({
    uri: `/schedules/${projectId}/${dataset}?limit=1`,
    tag: "scheduled-publishing-used"
  }).pipe(map$1((res) => ({
    used: res.schedules?.length > 0,
    loading: !1
  })), catchError$1(() => of({
    used: !1,
    loading: !1
  })));
}
function useHasUsedScheduledPublishing(t0) {
  const $ = c(4), {
    explicitEnabled,
    isWorkspaceEnabled
  } = t0, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), {
    projectId,
    dataset
  } = useWorkspace(), key = `${projectId}-${dataset}`;
  if (!cachedUsedScheduledPublishing.get(key)) {
    const hasUsed = fetchUsedScheduledPublishing(client).pipe(shareReplay$1());
    cachedUsedScheduledPublishing.set(key, hasUsed);
  }
  let t1;
  bb0: {
    if (explicitEnabled) {
      let t22;
      $[0] === Symbol.for("react.memo_cache_sentinel") ? (t22 = of({
        used: !0,
        loading: !1
      }), $[0] = t22) : t22 = $[0], t1 = t22;
      break bb0;
    }
    if (!isWorkspaceEnabled) {
      let t22;
      $[1] === Symbol.for("react.memo_cache_sentinel") ? (t22 = of({
        used: !1,
        loading: !1
      }), $[1] = t22) : t22 = $[1], t1 = t22;
      break bb0;
    }
    let t2;
    $[2] !== key ? (t2 = cachedUsedScheduledPublishing.get(key) || of(HAS_USED_SCHEDULED_PUBLISHING), $[2] = key, $[3] = t2) : t2 = $[3], t1 = t2;
  }
  return useObservable(t1, HAS_USED_SCHEDULED_PUBLISHING);
}
function ScheduledPublishingEnabledProvider(t0) {
  const $ = c(16), {
    children
  } = t0, {
    enabled,
    isLoading,
    error
  } = useFeatureEnabled("scheduledPublishing"), {
    scheduledPublishing: scheduledPublishing2
  } = useWorkspace(), isWorkspaceEnabled = scheduledPublishing2.enabled, explicitEnabled = scheduledPublishing2.__internal__workspaceEnabled;
  let t1;
  $[0] !== explicitEnabled || $[1] !== isWorkspaceEnabled ? (t1 = {
    explicitEnabled,
    isWorkspaceEnabled
  }, $[0] = explicitEnabled, $[1] = isWorkspaceEnabled, $[2] = t1) : t1 = $[2];
  const hasUsedScheduledPublishing = useHasUsedScheduledPublishing(t1);
  let t2;
  bb0: {
    if (!isWorkspaceEnabled || isLoading || error) {
      let t33;
      $[3] !== hasUsedScheduledPublishing ? (t33 = {
        enabled: !1,
        mode: null,
        hasUsedScheduledPublishing
      }, $[3] = hasUsedScheduledPublishing, $[4] = t33) : t33 = $[4], t2 = t33;
      break bb0;
    }
    if (explicitEnabled) {
      const t33 = enabled ? "default" : "upsell";
      let t42;
      $[5] !== hasUsedScheduledPublishing || $[6] !== t33 ? (t42 = {
        enabled: !0,
        mode: t33,
        hasUsedScheduledPublishing
      }, $[5] = hasUsedScheduledPublishing, $[6] = t33, $[7] = t42) : t42 = $[7], t2 = t42;
      break bb0;
    }
    if (!hasUsedScheduledPublishing.used) {
      let t33;
      $[8] !== hasUsedScheduledPublishing ? (t33 = {
        enabled: !1,
        mode: null,
        hasUsedScheduledPublishing
      }, $[8] = hasUsedScheduledPublishing, $[9] = t33) : t33 = $[9], t2 = t33;
      break bb0;
    }
    const t32 = enabled ? "default" : "upsell";
    let t4;
    $[10] !== hasUsedScheduledPublishing || $[11] !== t32 ? (t4 = {
      enabled: !0,
      mode: t32,
      hasUsedScheduledPublishing
    }, $[10] = hasUsedScheduledPublishing, $[11] = t32, $[12] = t4) : t4 = $[12], t2 = t4;
  }
  const value = t2;
  let t3;
  return $[13] !== children || $[14] !== value ? (t3 = /* @__PURE__ */ jsx(ScheduledPublishingEnabledContext.Provider, { value, children }), $[13] = children, $[14] = value, $[15] = t3) : t3 = $[15], t3;
}
function useScheduledPublishingEnabled() {
  return useContext(ScheduledPublishingEnabledContext);
}
function getLastExecuteDate(schedule) {
  return schedule?.executedAt || schedule?.executeAt;
}
function sortByExecuteDate({
  reverseOrder
} = {
  reverseOrder: !1
}) {
  return function(a, b) {
    const aExecuteDate = getLastExecuteDate(a), bExecuteDate = getLastExecuteDate(b);
    return aExecuteDate === bExecuteDate ? 0 : aExecuteDate === null ? 1 : bExecuteDate === null ? -1 : (aExecuteDate > bExecuteDate ? 1 : -1) * (reverseOrder ? -1 : 1);
  };
}
const debug$2 = debugWithName$1("useScheduleOperation");
function useScheduleApi() {
  const $ = c(3);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2022-09-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1, t2;
  return $[1] !== client ? (t2 = createScheduleApi(client), $[1] = client, $[2] = t2) : t2 = $[2], t1 = t2, t1;
}
function createScheduleApi(client) {
  const {
    dataset,
    projectId
  } = client.config();
  function _create({
    date,
    documentId
  }) {
    debug$2("_create:", documentId);
    const roundedDate = new Date(date);
    return roundedDate.setSeconds(0), roundedDate.setMilliseconds(0), client.request({
      body: {
        documents: [{
          documentId
        }],
        executeAt: roundedDate,
        name: roundedDate
      },
      method: "POST",
      uri: `/schedules/${projectId}/${dataset}`
    });
  }
  function _delete({
    scheduleId
  }) {
    return debug$2("_delete:", scheduleId), client.request({
      method: "DELETE",
      uri: `/schedules/${projectId}/${dataset}/${scheduleId}`
    });
  }
  function _deleteMultiple({
    scheduleIds
  }) {
    debug$2("_deleteMultiple:", scheduleIds);
    const requests = scheduleIds.map((scheduleId) => _delete({
      scheduleId
    }));
    return Promise.allSettled(requests);
  }
  function _publish({
    scheduleId
  }) {
    return debug$2("_publish:", scheduleId), client.request({
      method: "POST",
      uri: `/schedules/${projectId}/${dataset}/${scheduleId}/publish`
    });
  }
  function _update({
    documentSchedule,
    scheduleId
  }) {
    return debug$2("_update:", scheduleId, documentSchedule), client.request({
      body: documentSchedule,
      method: "PATCH",
      uri: `/schedules/${projectId}/${dataset}/${scheduleId}`
    });
  }
  return {
    create: _create,
    delete: _delete,
    deleteMultiple: _deleteMultiple,
    publish: _publish,
    update: _update
  };
}
let ScheduleEvents = /* @__PURE__ */ function(ScheduleEvents2) {
  return ScheduleEvents2.create = "scheduleCreate", ScheduleEvents2.delete = "scheduleDelete", ScheduleEvents2.deleteMultiple = "scheduleDeleteMultiple", ScheduleEvents2.publish = "schedulePublish", ScheduleEvents2.update = "scheduleUpdate", ScheduleEvents2;
}({});
function pluralize(word, count2) {
  return `${count2} ${word}${count2 === 1 ? "" : "s"}`;
}
const scheduleCustomEvent = (name, payload) => new CustomEvent(name, payload);
function useScheduleOperation() {
  const toast = useToast(), {
    formatDateTz
  } = useTimeZone(), api = useScheduleApi();
  async function createSchedule({
    date,
    displayToast = !0,
    documentId
  }) {
    try {
      const data = await api.create({
        date,
        documentId
      });
      window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.create, {
        detail: {
          date,
          documentId
        }
      })), displayToast && data?.executeAt && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: formatDateTz({
          date: new Date(data.executeAt),
          includeTimeZone: !0,
          prefix: "Publishing on "
        }), title: "Schedule created" }),
        duration: 15e3,
        // 15s
        status: "success"
      });
    } catch (err) {
      displayToast && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err), title: "Unable to create schedule" }),
        duration: 15e3,
        // 15s
        status: "error"
      });
    }
  }
  async function deleteSchedule({
    displayToast: displayToast_0 = !0,
    schedule
  }) {
    try {
      await api.delete({
        scheduleId: schedule?.id
      }), window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.delete, {
        detail: {
          scheduleId: schedule?.id
        }
      })), displayToast_0 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { title: "Schedule deleted" }),
        status: "success"
      });
    } catch (err_0) {
      displayToast_0 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err_0), title: "Unable to delete schedule" }),
        duration: 15e3,
        // 15s
        status: "error"
      });
    }
  }
  async function deleteSchedules({
    displayToast: displayToast_1 = !0,
    schedules
  }) {
    try {
      const scheduleIds = schedules.map((schedule_0) => schedule_0.id), response = await api.deleteMultiple({
        scheduleIds
      }), {
        fulfilledIds,
        rejectedReasons
      } = response.reduce((acc, v, index) => (v.status === "fulfilled" && acc.fulfilledIds.push(schedules[index].id), v.status === "rejected" && acc.rejectedReasons.push(`[${schedules[index].id}]: ${v.reason}`), acc), {
        fulfilledIds: [],
        rejectedReasons: []
      }), numFulfilledIds = fulfilledIds.length, numRejectedReasons = rejectedReasons.length;
      fulfilledIds?.length > 0 && window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.deleteMultiple, {
        detail: {
          scheduleIds: fulfilledIds
        }
      })), displayToast_1 && (fulfilledIds?.length > 0 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { title: `${pluralize("schedule", numFulfilledIds)} deleted` }),
        status: "success"
      }), rejectedReasons?.length > 0 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: rejectedReasons?.toString(), title: `Unable to delete ${pluralize("schedule", numRejectedReasons)}` }),
        duration: 15e3,
        // 15s
        status: "error"
      }));
    } catch (err_1) {
      displayToast_1 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err_1), title: "Unable to delete schedules" }),
        duration: 15e3,
        // 15s
        status: "error"
      });
    }
  }
  async function publishSchedule({
    displayToast: displayToast_2 = !0,
    schedule: schedule_1
  }) {
    try {
      const scheduleId = schedule_1.id;
      await api.publish({
        scheduleId
      }), window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.publish, {
        detail: {
          scheduleId
        }
      })), displayToast_2 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { title: "Document published" }),
        status: "success"
      });
    } catch (err_2) {
      displayToast_2 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err_2), title: "Unable to publish schedule" }),
        duration: 15e3,
        // 15s
        status: "error"
      });
    }
  }
  async function updateSchedule({
    date: date_0,
    displayToast: displayToast_3 = !0,
    scheduleId: scheduleId_0
  }) {
    try {
      await api.update({
        documentSchedule: {
          executeAt: date_0
        },
        scheduleId: scheduleId_0
      }), window.dispatchEvent(scheduleCustomEvent(ScheduleEvents.update, {
        detail: {
          date: date_0,
          scheduleId: scheduleId_0
        }
      })), displayToast_3 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: formatDateTz({
          date: new Date(date_0),
          includeTimeZone: !0,
          prefix: "Publishing on "
        }), title: "Schedule updated" }),
        duration: 15e3,
        // 15s
        status: "success"
      });
    } catch (err_3) {
      displayToast_3 && toast.push({
        closable: !0,
        description: /* @__PURE__ */ jsx(ToastDescription, { body: getErrorMessage(err_3), title: "Unable to update schedule" }),
        duration: 15e3,
        // 15s
        status: "error"
      });
    }
  }
  return {
    createSchedule,
    deleteSchedule,
    deleteSchedules,
    publishSchedule,
    updateSchedule
  };
}
function useScheduleBaseUrl() {
  const $ = c(1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2022-09-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), {
    dataset,
    projectId
  } = client.config();
  return `/schedules/${projectId}/${dataset}`;
}
function useFetcher(queryKey) {
  const $ = c(5);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2022-09-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1;
  return $[1] !== client || $[2] !== queryKey.params || $[3] !== queryKey.url ? (t1 = () => client.request({
    query: queryKey.params,
    method: "GET",
    uri: queryKey.url
  }), $[1] = client, $[2] = queryKey.params, $[3] = queryKey.url, $[4] = t1) : t1 = $[4], t1;
}
const NO_SCHEDULES = [];
function usePollSchedules(t0) {
  const $ = c(32);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const {
    documentId,
    state
  } = t1, {
    mode,
    enabled
  } = useScheduledPublishingEnabled();
  let t2;
  const t3 = mode === "default" ? 1e4 : void 0, t4 = mode === "default", t5 = mode === "default";
  let t6;
  $[2] !== t3 || $[3] !== t4 || $[4] !== t5 ? (t6 = {
    refreshWhenHidden: !1,
    refreshWhenOffline: !1,
    revalidateOnFocus: !1,
    shouldRetryOnError: !1,
    refreshInterval: t3,
    revalidateIfStale: t4,
    revalidateOnReconnect: t5
  }, $[2] = t3, $[3] = t4, $[4] = t5, $[5] = t6) : t6 = $[5], t2 = t6;
  const swrOptions = t2, url = useScheduleBaseUrl();
  let t7, t8;
  $[6] !== documentId || $[7] !== state ? (t8 = {
    documentIds: documentId,
    state
  }, $[6] = documentId, $[7] = state, $[8] = t8) : t8 = $[8];
  let t9;
  $[9] !== t8 || $[10] !== url ? (t9 = {
    params: t8,
    url
  }, $[9] = t8, $[10] = url, $[11] = t9) : t9 = $[11], t7 = t9;
  const queryKey = t7, fetcher = useFetcher(queryKey), {
    data,
    error,
    mutate: mutate2
  } = useSWR(enabled ? queryKey : null, fetcher, swrOptions);
  let t10;
  $[12] !== mutate2 ? (t10 = (event) => {
    mutate2((currentData) => ({
      schedules: currentData?.schedules?.filter((schedule) => schedule.id !== event.detail.scheduleId)
    }), !0);
  }, $[12] = mutate2, $[13] = t10) : t10 = $[13];
  const handleDelete = t10;
  let t11;
  $[14] !== mutate2 ? (t11 = (event_0) => {
    mutate2((currentData_0) => ({
      schedules: currentData_0?.schedules?.filter((schedule_0) => !event_0.detail.scheduleIds.includes(schedule_0.id))
    }), !0);
  }, $[14] = mutate2, $[15] = t11) : t11 = $[15];
  const handleDeleteMultiple = t11;
  let t12;
  $[16] !== mutate2 ? (t12 = (event_1) => {
    mutate2((currentData_1) => {
      const currentSchedules = currentData_1?.schedules || [], index = currentSchedules.findIndex((schedule_1) => schedule_1.id === event_1.detail.scheduleId);
      return {
        schedules: [...currentSchedules.slice(0, index), {
          ...currentSchedules[index],
          executeAt: (/* @__PURE__ */ new Date()).toISOString(),
          state: "succeeded"
        }, ...currentSchedules.slice(index + 1)]
      };
    }, !0);
  }, $[16] = mutate2, $[17] = t12) : t12 = $[17];
  const handlePublish = t12;
  let t13;
  $[18] !== mutate2 ? (t13 = (event_2) => {
    mutate2((currentData_2) => {
      const currentSchedules_0 = currentData_2?.schedules || [], index_0 = currentSchedules_0.findIndex((schedule_2) => schedule_2.id === event_2.detail.scheduleId);
      return {
        schedules: [...currentSchedules_0.slice(0, index_0), {
          ...currentSchedules_0[index_0],
          executeAt: event_2.detail.date
        }, ...currentSchedules_0.slice(index_0 + 1)]
      };
    }, !0);
  }, $[18] = mutate2, $[19] = t13) : t13 = $[19];
  const handleUpdate = t13;
  let t14, t15;
  $[20] !== handleDelete || $[21] !== handleDeleteMultiple || $[22] !== handlePublish || $[23] !== handleUpdate ? (t14 = () => (window.addEventListener(ScheduleEvents.delete, handleDelete), window.addEventListener(ScheduleEvents.deleteMultiple, handleDeleteMultiple), window.addEventListener(ScheduleEvents.publish, handlePublish), window.addEventListener(ScheduleEvents.update, handleUpdate), () => {
    window.removeEventListener(ScheduleEvents.delete, handleDelete), window.removeEventListener(ScheduleEvents.deleteMultiple, handleDeleteMultiple), window.removeEventListener(ScheduleEvents.publish, handlePublish), window.removeEventListener(ScheduleEvents.update, handleUpdate);
  }), t15 = [handleDelete, handleDeleteMultiple, handlePublish, handleUpdate], $[20] = handleDelete, $[21] = handleDeleteMultiple, $[22] = handlePublish, $[23] = handleUpdate, $[24] = t14, $[25] = t15) : (t14 = $[24], t15 = $[25]), useEffect(t14, t15);
  let t16, t17;
  $[26] !== data?.schedules ? (t17 = data?.schedules?.sort(sortByExecuteDate()), $[26] = data?.schedules, $[27] = t17) : t17 = $[27], t16 = t17;
  const sortedSchedules = t16, t18 = !error && !data, t19 = sortedSchedules || NO_SCHEDULES;
  let t20;
  return $[28] !== error || $[29] !== t18 || $[30] !== t19 ? (t20 = {
    error,
    isInitialLoading: t18,
    schedules: t19
  }, $[28] = error, $[29] = t18, $[30] = t19, $[31] = t20) : t20 = $[31], t20;
}
const EMPTY_SCHEDULE = [];
function SchedulesProvider(t0) {
  const $ = c(21), {
    children,
    value
  } = t0, [sortBy2, setSortBy] = useState(value.sortBy || "executeAt"), {
    utcToCurrentZoneDate
  } = useTimeZone();
  let t1;
  $[0] !== utcToCurrentZoneDate ? (t1 = (wallDate) => function(schedule) {
    const executeDate = getLastExecuteDate(schedule);
    if (!executeDate)
      return !1;
    const scheduleDate = new Date(executeDate), zonedScheduleDate = utcToCurrentZoneDate(scheduleDate);
    return isSameDay(zonedScheduleDate, wallDate);
  }, $[0] = utcToCurrentZoneDate, $[1] = t1) : t1 = $[1];
  const filterByDate = t1, filterByState = _temp$K;
  let t2, t3;
  $[2] !== filterByDate || $[3] !== sortBy2 || $[4] !== value.scheduleState || $[5] !== value.schedules || $[6] !== value.selectedDate ? (t3 = value.schedules.filter((scheduleState_0) => value.selectedDate ? filterByDate(value.selectedDate)(scheduleState_0) : filterByState(value.scheduleState)(scheduleState_0)).sort((a, b) => {
    if (sortBy2 === "createdAt")
      return a[sortBy2] < b[sortBy2] ? 1 : -1;
    if (sortBy2 === "executeAt") {
      const reverseOrder = !(value.scheduleState === "scheduled" || value.selectedDate);
      return sortByExecuteDate({
        reverseOrder
      })(a, b);
    }
    return 1;
  }) || [], $[2] = filterByDate, $[3] = sortBy2, $[4] = value.scheduleState, $[5] = value.schedules, $[6] = value.selectedDate, $[7] = t3) : t3 = $[7], t2 = t3;
  const activeSchedules = t2;
  let t4;
  $[8] !== filterByDate || $[9] !== value.schedules ? (t4 = (wallDate_0) => value.schedules.filter(filterByDate(wallDate_0)).sort(sortByExecuteDate()), $[8] = filterByDate, $[9] = value.schedules, $[10] = t4) : t4 = $[10];
  const schedulesByDate = t4;
  let t5;
  const t6 = value.schedules || EMPTY_SCHEDULE;
  let t7;
  $[11] !== activeSchedules || $[12] !== schedulesByDate || $[13] !== sortBy2 || $[14] !== t6 || $[15] !== value.scheduleState || $[16] !== value.selectedDate ? (t7 = {
    activeSchedules,
    schedules: t6,
    schedulesByDate,
    scheduleState: value.scheduleState,
    selectedDate: value.selectedDate,
    setSortBy,
    sortBy: sortBy2
  }, $[11] = activeSchedules, $[12] = schedulesByDate, $[13] = sortBy2, $[14] = t6, $[15] = value.scheduleState, $[16] = value.selectedDate, $[17] = t7) : t7 = $[17], t5 = t7;
  const context = t5;
  let t8;
  return $[18] !== children || $[19] !== context ? (t8 = /* @__PURE__ */ jsx(SchedulesContext.Provider, { value: context, children }), $[18] = children, $[19] = context, $[20] = t8) : t8 = $[20], t8;
}
function _temp$K(scheduleState) {
  return function(schedule_0) {
    return schedule_0.state === scheduleState;
  };
}
function useSchedules() {
  const context = useContext(SchedulesContext);
  if (context === void 0)
    throw new Error("useSchedules must be used within a SchedulesProvider");
  return context;
}
function useFilteredSchedules(schedules, filter2) {
  const $ = c(5);
  let t0, t1;
  if ($[0] !== filter2 || $[1] !== schedules) {
    let t2;
    $[3] !== filter2 ? (t2 = (schedule) => schedule.state === filter2, $[3] = filter2, $[4] = t2) : t2 = $[4], t1 = schedules.filter(t2), $[0] = filter2, $[1] = schedules, $[2] = t1;
  } else
    t1 = $[2];
  return t0 = t1, t0;
}
const ScheduleFilter = (props2) => {
  const $ = c(16), {
    selected,
    schedules,
    state
  } = props2, count2 = useFilteredSchedules(schedules, state).length, hasItems = count2 > 0, critical = state === "cancelled";
  let t0;
  $[0] !== state ? (t0 = {
    state: {
      state
    }
  }, $[0] = state, $[1] = t0) : t0 = $[1];
  const {
    href,
    onClick: onClick2
  } = useStateLink(t0), t1 = critical ? "critical" : "default", t2 = SCHEDULE_STATE_DICTIONARY[state];
  let t3;
  $[2] !== t2.title ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t2.title }), $[2] = t2.title, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== count2 || $[5] !== hasItems ? (t4 = hasItems && /* @__PURE__ */ jsx(Text$1, { size: 0, children: count2 }), $[4] = count2, $[5] = hasItems, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "center", children: [
    t3,
    t4
  ] }), $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== href || $[11] !== onClick2 || $[12] !== selected || $[13] !== t1 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button$1, { as: "a", href, mode: "bleed", onClick: onClick2, selected, tone: t1, padding: 2, children: t5 }), $[10] = href, $[11] = onClick2, $[12] = selected, $[13] = t1, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}, ScheduleFilters = (props2) => {
  const $ = c(26), {
    onClearDate,
    selectedDate
  } = props2, {
    navigate
  } = useRouter(), {
    schedules,
    scheduleState
  } = useSchedules();
  let t0;
  $[0] !== navigate ? (t0 = (state) => {
    navigate(state);
  }, $[0] = navigate, $[1] = t0) : t0 = $[1];
  const handleMenuClick = t0, currentSchedules = useFilteredSchedules(schedules, scheduleState);
  let t1;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = ["block", "block", "none"], $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== onClearDate || $[4] !== selectedDate ? (t2 = selectedDate && /* @__PURE__ */ jsx(Button, { iconRight: CloseIcon, onClick: onClearDate, text: format$2(selectedDate, "d MMMM yyyy"), tone: "primary" }), $[3] = onClearDate, $[4] = selectedDate, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== currentSchedules?.length || $[7] !== handleMenuClick || $[8] !== scheduleState ? (t3 = scheduleState && /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(Button, { iconRight: SelectIcon, mode: "ghost", text: `${SCHEDULE_STATE_DICTIONARY[scheduleState].title} (${currentSchedules?.length || 0})`, tone: "default" }), id: "state", menu: /* @__PURE__ */ jsx(Menu, { style: {
    minWidth: "175px"
  }, children: SCHEDULE_FILTERS.map((filter2) => /* @__PURE__ */ jsx(MenuItem$1, { iconRight: filter2 === scheduleState ? CheckmarkIcon : void 0, onClick: handleMenuClick.bind(void 0, {
    state: filter2
  }), text: SCHEDULE_STATE_DICTIONARY[filter2].title }, filter2)) }), placement: "bottom" }), $[6] = currentSchedules?.length, $[7] = handleMenuClick, $[8] = scheduleState, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t2 || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Box, { display: t1, children: [
    t2,
    t3
  ] }), $[10] = t2, $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t5 = ["none", "none", "block"], $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== onClearDate || $[15] !== selectedDate ? (t6 = selectedDate && /* @__PURE__ */ jsx(Button, { iconRight: CloseIcon, onClick: onClearDate, text: format$2(selectedDate, "d MMMM yyyy"), tone: "primary" }), $[14] = onClearDate, $[15] = selectedDate, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== scheduleState || $[18] !== schedules ? (t7 = scheduleState && /* @__PURE__ */ jsx(Flex, { gap: 2, children: SCHEDULE_FILTERS.map((filter_0) => /* @__PURE__ */ jsx(ScheduleFilter, { schedules, selected: scheduleState === filter_0, state: filter_0 }, filter_0)) }), $[17] = scheduleState, $[18] = schedules, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== t6 || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Box, { display: t5, children: [
    t6,
    t7
  ] }), $[20] = t6, $[21] = t7, $[22] = t8) : t8 = $[22];
  let t9;
  return $[23] !== t4 || $[24] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t4,
    t8
  ] }), $[23] = t4, $[24] = t8, $[25] = t9) : t9 = $[25], t9;
}, Image$3 = styled.img((props2) => {
  const {
    media
  } = getTheme_v2(props2.theme), responsiveStyles = _responsive(media, props2.$direction, (val) => ({
    width: val === "row" ? "50%" : "100%",
    height: val === "row" ? "auto" : "180px"
  }));
  return css`
    object-fit: cover;
    ${responsiveStyles}
  `;
}), DescriptionRoot = styled(Box)`
  margin: auto 0;
`, HORIZONTAL_PADDING_Y = [3, 3, 5];
function UpsellPanel(props2) {
  const $ = c(28), {
    data,
    onPrimaryClick,
    onSecondaryClick,
    layout: t0
  } = props2, layout = t0 === void 0 ? "vertical" : t0, t1 = layout === "horizontal" ? "row" : "column";
  let t2;
  $[0] !== t1 ? (t2 = ["column", "column", t1], $[0] = t1, $[1] = t2) : t2 = $[1];
  const direction = t2;
  let t3;
  $[2] !== data.image || $[3] !== direction ? (t3 = data.image && /* @__PURE__ */ jsx(Image$3, { src: data.image.asset.url, alt: data.image.asset.altText ?? "", $direction: direction }), $[2] = data.image, $[3] = direction, $[4] = t3) : t3 = $[4];
  const t4 = layout === "horizontal" ? HORIZONTAL_PADDING_Y : 3;
  let t5;
  $[5] !== data.descriptionText ? (t5 = /* @__PURE__ */ jsx(Stack, { space: 4, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: data.descriptionText }) }), $[5] = data.descriptionText, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== data.secondaryButton.text || $[8] !== data.secondaryButton.url || $[9] !== onSecondaryClick ? (t6 = data.secondaryButton.text && /* @__PURE__ */ jsx(Button, { mode: "bleed", text: data.secondaryButton.text, tone: "primary", iconRight: LaunchIcon, ...data.secondaryButton.url && {
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a",
    href: data.secondaryButton.url
  }, onClick: onSecondaryClick }), $[7] = data.secondaryButton.text, $[8] = data.secondaryButton.url, $[9] = onSecondaryClick, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== data.ctaButton.url ? (t7 = data.ctaButton.url && {
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a",
    href: data.ctaButton.url
  }, $[11] = data.ctaButton.url, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== data.ctaButton.text || $[14] !== onPrimaryClick || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { text: data.ctaButton.text, tone: "primary", ...t7, onClick: onPrimaryClick }), $[13] = data.ctaButton.text, $[14] = onPrimaryClick, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  $[17] !== t6 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { gap: 2, justify: "flex-end", marginTop: 5, children: [
    t6,
    t8
  ] }), $[17] = t6, $[18] = t8, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] !== t4 || $[21] !== t5 || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsxs(DescriptionRoot, { paddingX: 3, paddingY: t4, children: [
    t5,
    t9
  ] }), $[20] = t4, $[21] = t5, $[22] = t9, $[23] = t10) : t10 = $[23];
  let t11;
  return $[24] !== direction || $[25] !== t10 || $[26] !== t3 ? (t11 = /* @__PURE__ */ jsx(Card, { radius: 3, overflow: "hidden", border: !0, children: /* @__PURE__ */ jsxs(Flex, { direction, gap: 2, children: [
    t3,
    t10
  ] }) }), $[24] = direction, $[25] = t10, $[26] = t3, $[27] = t11) : t11 = $[27], t11;
}
const UpsellDialogViewed = defineEvent({
  name: "Upsell Dialog Viewed",
  version: 1,
  description: "User viewed the upsell dialog"
}), UpsellDialogDismissed = defineEvent({
  name: "Upsell Dialog Dismissed",
  version: 1,
  description: "User dismissed the upsell dialog"
}), UpsellDialogUpgradeCtaClicked = defineEvent({
  name: "Upsell Dialog Upgrade CTA Clicked",
  version: 1,
  description: 'User clicked the "Upgrade" CTA in the upsell dialog'
}), UpsellDialogLearnMoreCtaClicked = defineEvent({
  name: "Upsell Dialog Learn More CTA Clicked",
  version: 1,
  description: 'User clicked the "Learn More" CTA in the upsell dialog'
}), FEATURE$1 = "scheduled_publishing", TEMPLATE_OPTIONS$1 = {
  interpolate: /{{([\s\S]+?)}}/g
}, BASE_URL$1 = "www.sanity.io";
function SchedulePublishingUpsellProvider(props2) {
  const $ = c(31), [upsellDialogOpen, setUpsellDialogOpen] = useState(!1), [upsellData, setUpsellData] = useState(null), projectId = useProjectId$1(), telemetry = useTelemetry(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0, t1;
  $[0] !== telemetry ? (t1 = {
    dialogSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature: FEATURE$1,
      type: "modal"
    }),
    dialogPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature: FEATURE$1,
      type: "modal"
    }),
    panelViewed: (source) => telemetry.log(UpsellDialogViewed, {
      feature: FEATURE$1,
      type: "inspector",
      source
    }),
    panelDismissed: () => telemetry.log(UpsellDialogDismissed, {
      feature: FEATURE$1,
      type: "inspector"
    }),
    panelPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature: FEATURE$1,
      type: "inspector"
    }),
    panelSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature: FEATURE$1,
      type: "inspector"
    })
  }, $[0] = telemetry, $[1] = t1) : t1 = $[1], t0 = t1;
  const telemetryLogs = t0;
  let t2;
  $[2] !== telemetryLogs ? (t2 = () => {
    telemetryLogs.dialogPrimaryClicked();
  }, $[2] = telemetryLogs, $[3] = t2) : t2 = $[3];
  const handlePrimaryButtonClick = t2;
  let t3;
  $[4] !== telemetryLogs ? (t3 = () => {
    telemetryLogs.dialogSecondaryClicked();
  }, $[4] = telemetryLogs, $[5] = t3) : t3 = $[5];
  const handleSecondaryButtonClick = t3;
  let t4;
  $[6] !== telemetry ? (t4 = () => {
    setUpsellDialogOpen(!1), telemetry.log(UpsellDialogDismissed, {
      feature: FEATURE$1,
      type: "modal"
    });
  }, $[6] = telemetry, $[7] = t4) : t4 = $[7];
  const handleClose = t4;
  let t5;
  $[8] !== client.observable || $[9] !== projectId ? (t5 = () => {
    const sub2 = client.observable.request({
      uri: "/journey/scheduled-publishing"
    }).subscribe({
      next: (data) => {
        if (data)
          try {
            const ctaUrl = template(data.ctaButton.url, TEMPLATE_OPTIONS$1);
            data.ctaButton.url = ctaUrl({
              baseUrl: BASE_URL$1,
              projectId
            });
            const secondaryUrl = template(data.secondaryButton.url, TEMPLATE_OPTIONS$1);
            data.secondaryButton.url = secondaryUrl({
              baseUrl: BASE_URL$1,
              projectId
            }), setUpsellData(data);
          } catch {
          }
      },
      error: _temp$J
    });
    return () => {
      sub2.unsubscribe();
    };
  }, $[8] = client.observable, $[9] = projectId, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== client || $[12] !== projectId ? (t6 = [client, projectId], $[11] = client, $[12] = projectId, $[13] = t6) : t6 = $[13], useEffect(t5, t6);
  let t7;
  $[14] !== telemetry ? (t7 = (source_0) => {
    setUpsellDialogOpen(!0), telemetry.log(UpsellDialogViewed, {
      feature: FEATURE$1,
      type: "modal",
      source: source_0
    });
  }, $[14] = telemetry, $[15] = t7) : t7 = $[15];
  const handleOpenDialog = t7;
  let t8, t9;
  $[16] !== handleOpenDialog || $[17] !== telemetryLogs || $[18] !== upsellData || $[19] !== upsellDialogOpen ? (t9 = {
    upsellDialogOpen,
    handleOpenDialog,
    upsellData,
    telemetryLogs
  }, $[16] = handleOpenDialog, $[17] = telemetryLogs, $[18] = upsellData, $[19] = upsellDialogOpen, $[20] = t9) : t9 = $[20], t8 = t9;
  const ctxValue = t8;
  let t10;
  $[21] !== handleClose || $[22] !== handlePrimaryButtonClick || $[23] !== handleSecondaryButtonClick || $[24] !== upsellData || $[25] !== upsellDialogOpen ? (t10 = upsellData && upsellDialogOpen && /* @__PURE__ */ jsx(UpsellDialog, { data: upsellData, onClose: handleClose, onPrimaryClick: handlePrimaryButtonClick, onSecondaryClick: handleSecondaryButtonClick }), $[21] = handleClose, $[22] = handlePrimaryButtonClick, $[23] = handleSecondaryButtonClick, $[24] = upsellData, $[25] = upsellDialogOpen, $[26] = t10) : t10 = $[26];
  let t11;
  return $[27] !== ctxValue || $[28] !== props2.children || $[29] !== t10 ? (t11 = /* @__PURE__ */ jsxs(SchedulePublishUpsellContext.Provider, { value: ctxValue, children: [
    props2.children,
    t10
  ] }), $[27] = ctxValue, $[28] = props2.children, $[29] = t10, $[30] = t11) : t11 = $[30], t11;
}
function _temp$J() {
}
function useSchedulePublishingUpsell() {
  return useContext(SchedulePublishUpsellContext);
}
const BigIconComingSoon = (props2) => {
  const $ = c(15);
  let t0, t1, t10, t11, t12, t2, t3, t4, t5, t6, t7, t8, t9;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M54 26C54 28.7614 49.0751 31 43 31C36.9249 31 32 28.7614 32 26C32 23.2386 36.9249 7 43 7C49.0751 7 54 23.2386 54 26Z", stroke: "#7B8CA8", strokeWidth: "1.2" }), t1 = /* @__PURE__ */ jsx("path", { d: "M65 71.5V57M65 71.5L60.5789 69.0132M65 71.5L60.5789 73.9868M65 57L57 52.5L54 54.1875M65 57V42.5M65 57L57 47M65 57L58.1586 60.8483M65 57L60.5789 67.5M65 42.5L57 38L54 39.6875M65 42.5L57 47M65 42.5V27.5M57 47L65 27.5M57 47L54 39.6875M57 47L54 45.3125M57 47L54 50.75M57 23L65 27.5M57 23L54 24.6875V39.6875M57 23V60M65 27.5L57 32L54 30.3125", stroke: "#7B8CA8", strokeWidth: "1.2" }), t2 = /* @__PURE__ */ jsx("path", { d: "M54 76C54 78.7614 49.0751 81 43 81C36.9249 81 32 78.7614 32 76M54 76H60.5V63L54 57M54 76V57M32 76H25V63L32 57M32 76V57M32 26V57M54 26V57M54 45C54 47.7614 49.0751 50 43 50V35C49.0751 35 54 32.7614 54 30", stroke: "#7B8CA8", strokeWidth: "1.2" }), t3 = /* @__PURE__ */ jsx("path", { d: "M43 45.5701H44.8976L45.8465 43.1981L46.9679 42.7335L49.3162 43.7399L50.658 42.3981L49.6516 40.0499L50.1161 38.9284L52.4882 37.9795V36.0819L50.1161 35.1331L49.6516 34.0116M47.1334 34.9653C47.5197 35.5597 47.7441 36.269 47.7441 37.0307C47.7441 39.1268 46.0449 40.826 43.9488 40.826C43.6212 40.826 43.3033 40.7845 43 40.7064", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinejoin: "round" }), t4 = /* @__PURE__ */ jsx("path", { d: "M63.5464 78.6739L64.9606 78.0321L67.4355 78.5135L68.6174 78.2913L69.6174 77.1566H71.6174L72.6174 78.2913L73.7994 78.5135L76.2743 78.0321L77.6885 78.6739M63.5464 78.6739L64.607 79.7972L64.1174 80.3336L63.5464 80.4373M63.5464 78.6739V80.4373M77.6885 78.6739L76.6278 79.7972L77.1174 80.3336L77.6885 80.4373M77.6885 78.6739V80.4373M63.5464 80.4373L61.6174 80.7875V81.6952L64.1174 82.1491L64.607 82.6855L63.5464 83.8088L64.9606 84.4506L67.4355 83.9693L68.6174 84.1915L69.6174 85.3261H71.6174L72.6174 84.1915L73.7994 83.9693L76.2743 84.4506L77.6885 83.8088L76.6278 82.6855L77.1174 82.1491L79.6174 81.6952V80.7875L77.6885 80.4373", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t5 = /* @__PURE__ */ jsx("path", { d: "M79.6174 81.4647V84.7162L77.6885 85.0664M76.2743 87.4716L77.6885 86.8298V85.0664M76.2743 87.4716L73.7994 86.9902L72.6174 87.2124L71.6174 88.3471M76.2743 87.4716V84.7162M61.6174 81.4647V84.7162L63.5464 85.0664M71.6174 88.3471H69.6174M71.6174 88.3471V85.3261M69.6174 88.3471L68.6174 87.2124L67.4355 86.9902L64.9606 87.4716M69.6174 88.3471V85.3261M64.9606 87.4716L64.2535 87.1507L63.5464 86.8298V85.0664M64.9606 87.4716V84.6825M63.5464 84.039V85.0664M77.6885 84.039V85.0664", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t6 = /* @__PURE__ */ jsx("path", { d: "M73.6174 81.2412C73.6174 81.9932 72.2743 82.6028 70.6174 82.6028C68.9606 82.6028 67.6174 81.9932 67.6174 81.2412C67.6174 80.4892 68.9606 79.8796 70.6174 79.8796C72.2743 79.8796 73.6174 80.4892 73.6174 81.2412Z", stroke: "#7B8CA8", strokeWidth: "1.2" }), t7 = /* @__PURE__ */ jsx("path", { d: "M90 85.3616C90 86.1136 88.6569 86.7232 87 86.7232C85.3431 86.7232 84 86.1136 84 85.3616M90 85.3616C90 84.6096 88.6569 84 87 84C85.3431 84 84 84.6096 84 85.3616M90 85.3616V87.3616C90 88.1136 88.6569 88.7232 87 88.7232C85.3431 88.7232 84 88.1136 84 87.3616V85.3616", stroke: "#7B8CA8", strokeWidth: "1.2" }), t8 = /* @__PURE__ */ jsx("path", { d: "M82 89.8648C82 90.3425 81.3284 90.7297 80.5 90.7297C79.6716 90.7297 79 90.3425 79 89.8648M82 89.8648C82 89.3872 81.3284 89 80.5 89C79.6716 89 79 89.3872 79 89.8648M82 89.8648V91.1352C82 91.6128 81.3284 92 80.5 92C79.6716 92 79 91.6128 79 91.1352V89.8648", stroke: "#7B8CA8", strokeWidth: "1.2" }), t9 = /* @__PURE__ */ jsx("path", { d: "M52.7555 46.7289L52.5381 45.0136L51.2951 44.6903L50.2695 46.0824L49.4558 46.1956L48.0892 45.1364L46.9817 45.7867L47.2408 47.4962L46.7455 48.1517L45.0302 48.3691L44.7069 49.612M51.1084 47.9593C49.8968 47.6442 48.6622 48.2485 48.1434 49.3385", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t10 = /* @__PURE__ */ jsx("path", { d: "M39 80.5L38 83.5C38 84.8807 40.2386 86 43 86C45.7614 86 48 84.8807 48 83.5L47 80.5", stroke: "#7B8CA8", strokeWidth: "1.2" }), t11 = /* @__PURE__ */ jsx("path", { d: "M32 77L31 80C31 81.3807 33.2386 82.5 36 82.5C36.9107 82.5 37.7646 82.3783 38.5 82.1655", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t12 = /* @__PURE__ */ jsx("path", { d: "M54 77L55 80C55 81.3807 52.7614 82.5 50 82.5C49.0893 82.5 48.2354 82.3783 47.5 82.1655", stroke: "#7B8CA8", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), $[0] = t0, $[1] = t1, $[2] = t10, $[3] = t11, $[4] = t12, $[5] = t2, $[6] = t3, $[7] = t4, $[8] = t5, $[9] = t6, $[10] = t7, $[11] = t8, $[12] = t9) : (t0 = $[0], t1 = $[1], t10 = $[2], t11 = $[3], t12 = $[4], t2 = $[5], t3 = $[6], t4 = $[7], t5 = $[8], t6 = $[9], t7 = $[10], t8 = $[11], t9 = $[12]);
  let t13;
  return $[13] !== props2 ? (t13 = /* @__PURE__ */ jsxs("svg", { width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1,
    t2,
    t3,
    t4,
    t5,
    t6,
    t7,
    t8,
    t9,
    t10,
    t11,
    t12
  ] }), $[13] = props2, $[14] = t13) : t13 = $[14], t13;
}, BigIconScreen = (props2) => {
  const $ = c(9);
  let t0, t1, t2, t3, t4, t5, t6;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M35 84.5L41.7308 67H50V69.5M65 84.5L58.2692 67M32 65H42.5H50H57.5H81V23H19V65H24", stroke: "#7B8CA8", strokeWidth: "1.2" }), t1 = /* @__PURE__ */ jsx("path", { d: "M84 16V23H16V16M84 16H16M84 16L82 14H18L16 16", stroke: "#7B8CA8", strokeWidth: "1.2" }), t2 = /* @__PURE__ */ jsx("path", { d: "M24 65H18L17 67H83L82 65H32", stroke: "#7B8CA8", strokeWidth: "1.2" }), t3 = /* @__PURE__ */ jsx("circle", { cx: "50", cy: "72", r: "2", stroke: "#7B8CA8", strokeWidth: "1.2" }), t4 = /* @__PURE__ */ jsx("path", { d: "M24 63C24 61.8954 24.8954 61 26 61H30C31.1046 61 32 61.8954 32 63V67H24V63Z", stroke: "#7B8CA8", strokeWidth: "1.2" }), t5 = /* @__PURE__ */ jsx("path", { d: "M24 65C24 63.8954 24.8954 63 26 63H30C31.1046 63 32 63.8954 32 65V67H24V65Z", stroke: "#7B8CA8", strokeWidth: "1.2" }), t6 = /* @__PURE__ */ jsx("path", { d: "M28 44.9975C31.0617 44.62 33.5601 42.4793 35.2478 39.995C36.199 38.5947 36.9116 37.0761 36.9653 35.3597C36.9973 34.3355 36.8332 33.1459 35.8944 32.5454C35.3035 32.1675 34.4935 32.0285 33.8044 32.0022C32.7788 31.9631 32.1643 32.4357 31.8489 33.4197C30.3123 38.2145 33.0184 42.7025 36.3911 45.8977C38.1152 47.531 40.0746 48.9275 42.1179 50.1294C43.9867 51.2287 46.003 52.2595 48.1189 52.7885C48.9466 52.9954 50.4951 53.3913 51.3211 52.954C52.3579 52.4051 51.8285 49.7323 51.7091 48.9809C51.3862 46.9486 50.7293 45.0311 49.8726 43.1662C49.3791 42.0918 48.7948 40.8004 47.9999 39.8967C47.4959 39.3237 47.1331 39.4889 47.1101 40.2278C47.0699 41.5204 47.5768 42.7535 48.3103 43.7973C50.633 47.1024 54.4924 49.4656 58.2792 50.6985C59.9643 51.2471 61.8953 51.7306 63.6853 51.6193C65.3845 51.5137 65.6225 50.1321 65.7287 48.655C65.9958 44.9405 64.9629 40.7695 62.6403 37.7963C61.615 36.4839 60.3547 35.6334 58.6879 35.4476C57.7554 35.3437 56.665 35.3303 55.7391 35.5097C54.8073 35.6903 54.0162 36.297 54.3371 37.3462C54.6464 38.3572 55.8044 39.0666 56.6444 39.5759C57.983 40.3876 59.4813 40.9898 61.0262 41.2624C63.2658 41.6576 65.1745 41.1715 67.141 40.1346C67.9966 39.6835 68.8825 39.1795 69.4379 38.3861", stroke: "#7B8CA8", strokeWidth: "1.2" }), $[0] = t0, $[1] = t1, $[2] = t2, $[3] = t3, $[4] = t4, $[5] = t5, $[6] = t6) : (t0 = $[0], t1 = $[1], t2 = $[2], t3 = $[3], t4 = $[4], t5 = $[5], t6 = $[6]);
  let t7;
  return $[7] !== props2 ? (t7 = /* @__PURE__ */ jsxs("svg", { width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1,
    t2,
    t3,
    t4,
    t5,
    t6
  ] }), $[7] = props2, $[8] = t7) : t7 = $[8], t7;
}, BigIconSuccess = (props2) => {
  const $ = c(16);
  let t0, t1, t10, t11, t12, t13, t2, t3, t4, t5, t6, t7, t8, t9;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M35.5034 34.5961C35.6531 34.1763 35.8628 33.792 36.1352 33.4478C37.6813 31.4827 40.9503 31.2145 44.9898 32.3554M35.5034 34.5961L24.12 78.5806C23.4656 81.1092 26.1309 83.2083 28.4357 81.9796L68.4485 60.6484M35.5034 34.5961C34.2315 38.1622 37.2902 44.2842 43.0792 50.0342M68.4485 60.6484C68.8174 60.4078 69.1391 60.118 69.4084 59.7777C70.9736 57.7883 70.4521 54.4677 68.3472 50.7308M68.4485 60.6484C65.1795 62.7806 58.1999 61.0522 51.0413 56.4338M49.3164 55.2667C48.6043 54.7622 47.8933 54.2299 47.1867 53.6707C46.3331 52.9953 45.5161 52.3044 44.7387 51.6037M49.3164 55.2667C49.8913 55.674 50.4669 56.0632 51.0413 56.4338M49.3164 55.2667C52.3445 53.1871 58.7283 49.8329 66.4965 47.8874M51.0413 56.4338C55.9305 53.432 62.4593 51.6876 68.3472 50.7308M43.0792 50.0342C43.6098 50.5612 44.1634 51.0852 44.7387 51.6037M43.0792 50.0342C44.4006 45.7138 45.8116 38.387 44.9898 32.3554M44.7387 51.6037C47.6743 44.2968 48.7135 38.3712 48.6643 33.6916M63.9622 36.487C63.2905 34.23 62.35 29.5386 63.9622 28.8293C65.9774 27.9426 68.5569 33.5045 70.8139 32.2148C73.0709 30.9251 69.4435 27.7814 70.8139 25.2019C72.1842 22.6224 79.6002 28.4262 81.2123 23.4285C82.502 19.4304 79.7614 16.6574 78.2298 15.7708M66.4965 47.8874C70.7697 46.8171 75.462 46.1731 80.2449 46.4019L80.2449 49.7068C77.5329 49.6936 73.1535 49.9498 68.3472 50.7308M66.4965 47.8874C64.45 45.1054 61.6564 42.2264 58.3003 39.5859C55.0633 37.039 51.7429 35.0416 48.6643 33.6916M48.6643 33.6916C48.5822 25.8794 45.4671 21.5396 43.0792 20.043L39.941 23.4285C42.9851 25.0774 44.4569 28.4441 44.9898 32.3554", stroke: "#7B8CA8", strokeWidth: "1.2" }), t1 = /* @__PURE__ */ jsx("path", { d: "M32.2094 47.3001C31.0515 50.5465 34.6857 56.6214 40.9597 61.5862C47.2404 66.5562 53.9958 68.696 56.8839 66.8122", stroke: "#7B8CA8", strokeWidth: "1.2" }), t2 = /* @__PURE__ */ jsx("path", { d: "M28.8867 60.1903C28.1245 62.3275 30.5169 66.3267 34.6472 69.595C38.7818 72.8669 43.229 74.2755 45.1303 73.0354", stroke: "#7B8CA8", strokeWidth: "1.2" }), t3 = /* @__PURE__ */ jsx("path", { d: "M26.2718 70.2225C25.8147 71.5039 27.2491 73.9016 29.7254 75.8611C32.2044 77.8228 34.8707 78.6673 36.0106 77.9238", stroke: "#7B8CA8", strokeWidth: "1.2" }), t4 = /* @__PURE__ */ jsx("path", { d: "M28.0529 44.1724C29.5354 43.1981 32.3735 40.6904 31.8652 38.4538C31.2298 35.6581 22.8425 38.9622 22.7155 36.5477C22.5884 34.1331 27.0361 30.575 26.909 28.6688C26.7819 26.7626 18.6489 30.8291 18.6489 26.8896C18.6489 23.738 21.36 22.1029 22.7155 21.6793", stroke: "#7B8CA8", strokeWidth: "1.2" }), t5 = /* @__PURE__ */ jsx("rect", { x: "21.8833", y: "50.1122", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 21.8833 50.1122)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t6 = /* @__PURE__ */ jsx("rect", { x: "16.0527", y: "36.722", width: "3.03077", height: "3.03077", transform: "rotate(4.36851 16.0527 36.722)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t7 = /* @__PURE__ */ jsx("rect", { x: "27.9448", y: "22.8353", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 27.9448 22.8353)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t8 = /* @__PURE__ */ jsx("rect", { x: "53.7065", y: "33.443", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 53.7065 33.443)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t9 = /* @__PURE__ */ jsx("rect", { x: "67.3447", y: "13.743", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 67.3447 13.743)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t10 = /* @__PURE__ */ jsx("rect", { x: "74.9219", y: "54.6584", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 74.9219 54.6584)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t11 = /* @__PURE__ */ jsx("rect", { x: "70.3755", y: "66.7814", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 70.3755 66.7814)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t12 = /* @__PURE__ */ jsx("rect", { x: "77.9526", y: "78.9045", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 77.9526 78.9045)", stroke: "#7B8CA8", strokeWidth: "1.2" }), t13 = /* @__PURE__ */ jsx("rect", { x: "82.4985", y: "62.2353", width: "3.03077", height: "3.03077", transform: "rotate(-24.7154 82.4985 62.2353)", stroke: "#7B8CA8", strokeWidth: "1.2" }), $[0] = t0, $[1] = t1, $[2] = t10, $[3] = t11, $[4] = t12, $[5] = t13, $[6] = t2, $[7] = t3, $[8] = t4, $[9] = t5, $[10] = t6, $[11] = t7, $[12] = t8, $[13] = t9) : (t0 = $[0], t1 = $[1], t10 = $[2], t11 = $[3], t12 = $[4], t13 = $[5], t2 = $[6], t3 = $[7], t4 = $[8], t5 = $[9], t6 = $[10], t7 = $[11], t8 = $[12], t9 = $[13]);
  let t14;
  return $[14] !== props2 ? (t14 = /* @__PURE__ */ jsxs("svg", { width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1,
    t2,
    t3,
    t4,
    t5,
    t6,
    t7,
    t8,
    t9,
    t10,
    t11,
    t12,
    t13
  ] }), $[14] = props2, $[15] = t14) : t14 = $[15], t14;
}, EmptySchedules = (props2) => {
  const $ = c(16), {
    scheduleState,
    selectedDate
  } = props2;
  let BigIcon, description, heading;
  bb0: switch (scheduleState) {
    case "succeeded": {
      description = "When a scheduled document is successfully published it moves to this list view.", heading = "No completed scheduled publications ... yet", BigIcon = BigIconComingSoon;
      break bb0;
    }
    case "cancelled": {
      description = "Schedules can fail for several reasons, for example when their documents are deleted. When they do, they show up here.", heading = "No failed scheduled publications", BigIcon = BigIconSuccess;
      break bb0;
    }
    case "scheduled": {
      description = "When editing a document, create a new scheduled publication from the menu next to the Publish button.", heading = "No upcoming scheduled publications", BigIcon = BigIconScreen;
      break bb0;
    }
  }
  if (selectedDate) {
    description = "No schedules for this date.";
    let t02;
    $[0] !== selectedDate ? (t02 = format$2(selectedDate, "d MMMM yyyy"), $[0] = selectedDate, $[1] = t02) : t02 = $[1], heading = t02, BigIcon = BigIconScreen;
  }
  let t0;
  $[2] !== BigIcon ? (t0 = BigIcon && /* @__PURE__ */ jsx(BigIcon, {}), $[2] = BigIcon, $[3] = t0) : t0 = $[3];
  let t1;
  $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(Flex, { justify: "center", children: t0 }), $[4] = t0, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== heading ? (t2 = heading && /* @__PURE__ */ jsx(Heading, { align: "center", size: 1, children: heading }), $[6] = heading, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== description ? (t3 = description && /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, children: description }), $[8] = description, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t2 || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t2,
    t3
  ] }), $[10] = t2, $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  return $[13] !== t1 || $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(Card, { paddingX: 6, paddingBottom: 8, paddingTop: 7, radius: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t1,
    t4
  ] }) }), $[13] = t1, $[14] = t4, $[15] = t5) : t5 = $[15], t5;
}, isLiveEditEnabled = (schemaType) => schemaType.liveEdit === !0;
function getPreviewStateObservable(documentPreviewStore, schemaType, documentId, title) {
  const draft$ = isLiveEditEnabled(schemaType) ? of({
    snapshot: null
  }) : documentPreviewStore.observeForPreview({
    _type: "reference",
    _ref: getDraftId(documentId)
  }, schemaType), published$ = documentPreviewStore.observeForPreview({
    _type: "reference",
    _ref: getPublishedId(documentId)
  }, schemaType);
  return combineLatest([draft$, published$]).pipe(map(([draft, published]) => ({
    draft: draft.snapshot ? {
      title,
      ...draft.snapshot || {}
    } : null,
    isLoading: !1,
    published: published.snapshot ? {
      title,
      ...published.snapshot || {}
    } : null
  })), startWith({
    draft: null,
    isLoading: !0,
    published: null
  }));
}
function getScheduledDocument(schedule) {
  return schedule.documents?.[0];
}
function getScheduledDocumentId(schedule) {
  return getScheduledDocument(schedule)?.documentId.replaceAll("drafts.", "");
}
function usePreviewState(documentId, schemaType) {
  const $ = c(6), documentPreviewStore = useDocumentPreviewStore();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const [paneItemPreview, setPaneItemPreview] = useState(t0);
  let t1, t2;
  return $[1] !== documentId || $[2] !== documentPreviewStore || $[3] !== schemaType ? (t1 = () => {
    if (!schemaType)
      return;
    const subscription = getPreviewStateObservable(documentPreviewStore, schemaType, documentId, "").subscribe((state) => {
      setPaneItemPreview(state);
    });
    return () => {
      subscription?.unsubscribe();
    };
  }, t2 = [documentPreviewStore, schemaType, documentId], $[1] = documentId, $[2] = documentPreviewStore, $[3] = schemaType, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2), paneItemPreview;
}
function useScheduleSchemaType(schedule) {
  const firstDocument = getScheduledDocument(schedule), schema2 = useSchema(), schemaName = firstDocument.documentType;
  return useMemo(() => {
    if (schemaName)
      return schema2.get(schemaName);
  }, [schemaName, schema2]);
}
function useSchemaType(schemaName) {
  const $ = c(3), schema2 = useSchema();
  let t0, t1;
  return $[0] !== schema2 || $[1] !== schemaName ? (t1 = schema2.get(schemaName), $[0] = schema2, $[1] = schemaName, $[2] = t1) : t1 = $[2], t0 = t1, t0;
}
const DateWithTooltipElementQuery = styled(ElementQuery)`
  .date-small {
    display: inline;
  }
  .date-medium {
    display: none;
  }
  .date-large {
    display: none;
  }

  &[data-eq-min~='1'] {
    .date-small {
      display: none;
    }
    .date-medium {
      display: inline;
    }
    .date-large {
      display: none;
    }
  }

  &[data-eq-min~='2'] {
    .date-small {
      display: none;
    }
    .date-medium {
      display: none;
    }
    .date-large {
      display: inline;
    }
  }
`;
function DocumentActionPropsProvider(t0) {
  const $ = c(3), {
    children,
    value
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== value ? (t1 = /* @__PURE__ */ jsx(DocumentActionPropsContext.Provider, { value, children }), $[0] = children, $[1] = value, $[2] = t1) : t1 = $[2], t1;
}
function useDocumentActionProps() {
  const context = useContext(DocumentActionPropsContext);
  if (context === void 0)
    throw new Error("useDocumentActionProps must be used within a DocumentActionPropsProvider");
  return context;
}
function useScheduleForm(schedule) {
  const [isDirty, setIsDirty] = useState(!1), [formData, setFormData] = useState(schedule && schedule?.executeAt ? {
    date: schedule.executeAt
  } : null), handleFormChange = useCallback((form) => {
    const equalDates = schedule?.executeAt && new Date(schedule.executeAt).getTime() === new Date(form?.date).getTime();
    setFormData(form), setIsDirty(!equalDates);
  }, [schedule?.executeAt]);
  return {
    formData,
    isDirty,
    onFormChange: handleFormChange
  };
}
function CalendarDay$1(props2) {
  const $ = c(27), {
    date,
    focused,
    isCurrentMonth,
    isToday: isToday2,
    customValidation,
    onSelect,
    selected
  } = props2;
  let t0;
  bb0: {
    if (!customValidation) {
      t0 = !0;
      break bb0;
    }
    let t13;
    $[0] !== customValidation || $[1] !== date ? (t13 = customValidation(endOfDay(date)), $[0] = customValidation, $[1] = date, $[2] = t13) : t13 = $[2], t0 = t13;
  }
  const isValid2 = t0;
  let t1;
  $[3] !== date || $[4] !== isValid2 || $[5] !== onSelect ? (t1 = () => {
    isValid2 && onSelect(date);
  }, $[3] = date, $[4] = isValid2, $[5] = onSelect, $[6] = t1) : t1 = $[6];
  const handleClick = t1;
  let t2;
  $[7] !== date ? (t2 = date.toDateString(), $[7] = date, $[8] = t2) : t2 = $[8];
  const t3 = focused ? "true" : "", t4 = !isValid2, t5 = isToday2 || selected ? "primary" : "default", t6 = !selected && !isCurrentMonth;
  let t7;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    textAlign: "center"
  }, $[9] = t7) : t7 = $[9];
  const t8 = isCurrentMonth ? "medium" : "regular";
  let t9;
  $[10] !== date ? (t9 = date.getDate(), $[10] = date, $[11] = t9) : t9 = $[11];
  let t10;
  $[12] !== t6 || $[13] !== t8 || $[14] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text$1, { muted: t6, style: t7, weight: t8, children: t9 }), $[12] = t6, $[13] = t8, $[14] = t9, $[15] = t10) : t10 = $[15];
  let t11;
  $[16] !== handleClick || $[17] !== selected || $[18] !== t10 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 ? (t11 = /* @__PURE__ */ jsx(Card, { "aria-label": t2, "aria-pressed": selected, as: "button", __unstable_focusRing: !0, "data-weekday": !0, "data-focused": t3, disabled: t4, role: "button", tabIndex: -1, onClick: handleClick, padding: 3, radius: 2, selected, tone: t5, children: t10 }), $[16] = handleClick, $[17] = selected, $[18] = t10, $[19] = t2, $[20] = t3, $[21] = t4, $[22] = t5, $[23] = t11) : t11 = $[23];
  let t12;
  return $[24] !== selected || $[25] !== t11 ? (t12 = /* @__PURE__ */ jsx("div", { "aria-selected": selected, "data-ui": "CalendarDay", children: t11 }), $[24] = selected, $[25] = t11, $[26] = t12) : t12 = $[26], t12;
}
const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], WEEK_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], HOURS_24 = range(0, 24), ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], TAIL_WEEKDAYS = [1, 2, 3, 4, 5, 6], getWeekStartsOfMonth = (date) => {
  const firstDay = startOfMonth(date);
  return eachWeekOfInterval({
    start: firstDay,
    end: lastDayOfMonth(firstDay)
  });
}, getWeekDaysFromWeekStarts = (weekStarts) => weekStarts.map((weekStart) => [weekStart, ...TAIL_WEEKDAYS.map((d) => addDays(weekStart, d))]), getWeeksOfMonth = (date) => getWeekDaysFromWeekStarts(getWeekStartsOfMonth(date)).map((days) => ({
  number: getWeek(days[0]),
  days
}));
function CalendarMonth(props2) {
  const $ = c(20), {
    getCurrentZoneDate
  } = useTimeZone(), {
    customValidation
  } = props2, t0 = props2.hidden || !1;
  let t1, t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    gridTemplateColumns: "repeat(7, minmax(44px, 46px))"
  }, t2 = WEEK_DAY_NAMES.map(_temp$I), $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]);
  let t3;
  if ($[2] !== customValidation || $[3] !== getCurrentZoneDate || $[4] !== props2.date || $[5] !== props2.focused || $[6] !== props2.onSelect || $[7] !== props2.selected) {
    let t42;
    $[9] !== customValidation || $[10] !== getCurrentZoneDate || $[11] !== props2.focused || $[12] !== props2.onSelect || $[13] !== props2.selected ? (t42 = (week, weekIdx) => week.days.map((date, dayIdx) => {
      const focused = props2.focused && isSameDay(date, props2.focused), selected = props2.selected && isSameDay(date, props2.selected), isToday2 = isSameDay(date, getCurrentZoneDate()), isCurrentMonth = props2.focused && isSameMonth(date, props2.focused);
      return /* @__PURE__ */ jsx(CalendarDay$1, { date, focused, isCurrentMonth, isToday: isToday2, customValidation, onSelect: props2.onSelect, selected }, `${weekIdx}-${dayIdx}`);
    }), $[9] = customValidation, $[10] = getCurrentZoneDate, $[11] = props2.focused, $[12] = props2.onSelect, $[13] = props2.selected, $[14] = t42) : t42 = $[14], t3 = getWeeksOfMonth(props2.date).map(t42), $[2] = customValidation, $[3] = getCurrentZoneDate, $[4] = props2.date, $[5] = props2.focused, $[6] = props2.onSelect, $[7] = props2.selected, $[8] = t3;
  } else
    t3 = $[8];
  let t4;
  $[15] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Grid, { gap: 1, style: t1, children: [
    t2,
    t3
  ] }), $[15] = t3, $[16] = t4) : t4 = $[16];
  let t5;
  return $[17] !== t0 || $[18] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { "aria-hidden": t0, "data-ui": "CalendarMonth", children: t4 }), $[17] = t0, $[18] = t4, $[19] = t5) : t5 = $[19], t5;
}
function _temp$I(weekday) {
  return /* @__PURE__ */ jsx(Box, { paddingY: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", style: {
    textAlign: "center"
  }, children: weekday }) }, weekday);
}
const features = {
  timePresets: !1
}, YearInput = (t0) => {
  const $ = c(8);
  let onChange, props2;
  $[0] !== t0 ? ({
    onChange,
    ...props2
  } = t0, $[0] = t0, $[1] = onChange, $[2] = props2) : (onChange = $[1], props2 = $[2]);
  let t1;
  $[3] !== onChange ? (t1 = (event) => {
    const numericValue = parseInt(event.currentTarget.value, 10);
    isNaN(numericValue) || onChange(numericValue);
  }, $[3] = onChange, $[4] = t1) : t1 = $[4];
  const handleChange = t1;
  let t2;
  return $[5] !== handleChange || $[6] !== props2 ? (t2 = /* @__PURE__ */ jsx(LazyTextInput, { "data-testid": "date-input", ...props2, onChange: handleChange, inputMode: "numeric" }), $[5] = handleChange, $[6] = props2, $[7] = t2) : t2 = $[7], t2;
}, PRESERVE_FOCUS_ELEMENT = /* @__PURE__ */ jsx("span", { "data-preserve-focus": !0, style: {
  overflow: "hidden",
  position: "absolute",
  outline: "none"
}, tabIndex: -1 }), Calendar = forwardRef(function(props2, forwardedRef) {
  const $ = c(93), {
    getCurrentZoneDate,
    zoneDateToUtc
  } = useTimeZone();
  let customValidation, onFocusedDateChange, onSelect, restProps, selectTime, t0, t1, t2;
  $[0] !== props2 ? ({
    selectTime,
    onFocusedDateChange,
    selectedDate: t0,
    focusedDate: t1,
    timeStep: t2,
    onSelect,
    customValidation,
    ...restProps
  } = props2, $[0] = props2, $[1] = customValidation, $[2] = onFocusedDateChange, $[3] = onSelect, $[4] = restProps, $[5] = selectTime, $[6] = t0, $[7] = t1, $[8] = t2) : (customValidation = $[1], onFocusedDateChange = $[2], onSelect = $[3], restProps = $[4], selectTime = $[5], t0 = $[6], t1 = $[7], t2 = $[8]);
  let t3;
  $[9] !== getCurrentZoneDate || $[10] !== t0 ? (t3 = t0 === void 0 ? getCurrentZoneDate() : t0, $[9] = getCurrentZoneDate, $[10] = t0, $[11] = t3) : t3 = $[11];
  const selectedDate = t3, focusedDate = t1 === void 0 ? selectedDate : t1, timeStep = t2 === void 0 ? 1 : t2;
  let t4;
  $[12] !== onFocusedDateChange || $[13] !== zoneDateToUtc ? (t4 = (date) => onFocusedDateChange(zoneDateToUtc(date)), $[12] = onFocusedDateChange, $[13] = zoneDateToUtc, $[14] = t4) : t4 = $[14];
  const setFocusedDate = t4;
  let t5;
  $[15] !== focusedDate || $[16] !== setFocusedDate ? (t5 = (month) => setFocusedDate(setDate(setMonth(focusedDate, month), 1)), $[15] = focusedDate, $[16] = setFocusedDate, $[17] = t5) : t5 = $[17];
  const setFocusedDateMonth = t5;
  let t6;
  $[18] !== setFocusedDateMonth ? (t6 = (e) => setFocusedDateMonth(Number(e.currentTarget.value)), $[18] = setFocusedDateMonth, $[19] = t6) : t6 = $[19];
  const handleFocusedMonthChange = t6;
  let t7;
  $[20] !== focusedDate || $[21] !== setFocusedDate ? (t7 = (by) => setFocusedDate(addMonths(focusedDate, by)), $[20] = focusedDate, $[21] = setFocusedDate, $[22] = t7) : t7 = $[22];
  const moveFocusedDate = t7;
  let t8;
  $[23] !== focusedDate || $[24] !== setFocusedDate ? (t8 = (year) => setFocusedDate(setYear(focusedDate, year)), $[23] = focusedDate, $[24] = setFocusedDate, $[25] = t8) : t8 = $[25];
  const setFocusedDateYear = t8;
  let t9;
  $[26] !== onSelect || $[27] !== selectedDate || $[28] !== zoneDateToUtc ? (t9 = (date_0) => {
    onSelect(zoneDateToUtc(setMinutes(setHours(date_0, selectedDate.getHours()), selectedDate.getMinutes())));
  }, $[26] = onSelect, $[27] = selectedDate, $[28] = zoneDateToUtc, $[29] = t9) : t9 = $[29];
  const handleDateChange = t9;
  let t10;
  $[30] !== onSelect || $[31] !== selectedDate || $[32] !== zoneDateToUtc ? (t10 = (event) => {
    const m = Number(event.currentTarget.value);
    onSelect(zoneDateToUtc(setMinutes(selectedDate, m)));
  }, $[30] = onSelect, $[31] = selectedDate, $[32] = zoneDateToUtc, $[33] = t10) : t10 = $[33];
  const handleMinutesChange = t10;
  let t11;
  $[34] !== onSelect || $[35] !== selectedDate || $[36] !== zoneDateToUtc ? (t11 = (event_0) => {
    const m_0 = Number(event_0.currentTarget.value);
    onSelect(zoneDateToUtc(setHours(selectedDate, m_0)));
  }, $[34] = onSelect, $[35] = selectedDate, $[36] = zoneDateToUtc, $[37] = t11) : t11 = $[37];
  const handleHoursChange = t11;
  let t12;
  $[38] !== onSelect || $[39] !== selectedDate || $[40] !== zoneDateToUtc ? (t12 = (hours, mins) => {
    onSelect(zoneDateToUtc(setHours(setMinutes(selectedDate, mins), hours)));
  }, $[38] = onSelect, $[39] = selectedDate, $[40] = zoneDateToUtc, $[41] = t12) : t12 = $[41];
  const handleTimeChange = t12, ref = useRef(null);
  let t13;
  $[42] === Symbol.for("react.memo_cache_sentinel") ? (t13 = () => ref.current, $[42] = t13) : t13 = $[42], useImperativeHandle(forwardedRef, t13);
  let t14;
  $[43] === Symbol.for("react.memo_cache_sentinel") ? (t14 = () => {
    ref.current?.querySelector('[data-focused="true"]')?.focus();
  }, $[43] = t14) : t14 = $[43];
  const focusCurrentWeekDay = t14;
  let t15;
  $[44] !== focusedDate || $[45] !== onFocusedDateChange || $[46] !== zoneDateToUtc ? (t15 = (event_1) => {
    if (ARROW_KEYS.includes(event_1.key)) {
      if (event_1.preventDefault(), event_1.currentTarget.hasAttribute("data-calendar-grid")) {
        focusCurrentWeekDay();
        return;
      }
      event_1.key === "ArrowUp" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, -7))), event_1.key === "ArrowDown" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, 7))), event_1.key === "ArrowLeft" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, -1))), event_1.key === "ArrowRight" && onFocusedDateChange(zoneDateToUtc(addDays(focusedDate, 1))), ref.current?.querySelector("[data-preserve-focus]")?.focus();
    }
  }, $[44] = focusedDate, $[45] = onFocusedDateChange, $[46] = zoneDateToUtc, $[47] = t15) : t15 = $[47];
  const handleKeyDown = t15;
  let t16, t17;
  $[48] === Symbol.for("react.memo_cache_sentinel") ? (t16 = () => {
    focusCurrentWeekDay();
  }, t17 = [focusCurrentWeekDay], $[48] = t16, $[49] = t17) : (t16 = $[48], t17 = $[49]), useEffect(t16, t17);
  let t18;
  $[50] === Symbol.for("react.memo_cache_sentinel") ? (t18 = () => {
    document.activeElement?.matches("[data-calendar-grid], [data-calendar-grid] [data-preserve-focus]") && focusCurrentWeekDay();
  }, $[50] = t18) : t18 = $[50];
  let t19;
  $[51] !== focusedDate ? (t19 = [ref, focusCurrentWeekDay, focusedDate], $[51] = focusedDate, $[52] = t19) : t19 = $[52], useEffect(t18, t19);
  let t20;
  $[53] !== onSelect ? (t20 = () => onSelect(/* @__PURE__ */ new Date()), $[53] = onSelect, $[54] = t20) : t20 = $[54];
  const handleNowClick = t20;
  let t21;
  $[55] !== focusedDate ? (t21 = focusedDate?.getMonth(), $[55] = focusedDate, $[56] = t21) : t21 = $[56];
  let t22;
  $[57] !== handleFocusedMonthChange || $[58] !== moveFocusedDate || $[59] !== t21 ? (t22 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(CalendarMonthSelect, { moveFocusedDate, onChange: handleFocusedMonthChange, value: t21 }) }), $[57] = handleFocusedMonthChange, $[58] = moveFocusedDate, $[59] = t21, $[60] = t22) : t22 = $[60];
  let t23;
  $[61] !== focusedDate ? (t23 = focusedDate.getFullYear(), $[61] = focusedDate, $[62] = t23) : t23 = $[62];
  let t24;
  $[63] !== moveFocusedDate || $[64] !== setFocusedDateYear || $[65] !== t23 ? (t24 = /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(CalendarYearSelect, { moveFocusedDate, onChange: setFocusedDateYear, value: t23 }) }), $[63] = moveFocusedDate, $[64] = setFocusedDateYear, $[65] = t23, $[66] = t24) : t24 = $[66];
  let t25;
  $[67] !== t22 || $[68] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Flex, { children: [
    t22,
    t24
  ] }), $[67] = t22, $[68] = t24, $[69] = t25) : t25 = $[69];
  let t26;
  $[70] !== customValidation || $[71] !== focusedDate || $[72] !== handleDateChange || $[73] !== selectedDate ? (t26 = /* @__PURE__ */ jsx(CalendarMonth, { date: focusedDate, focused: focusedDate, customValidation, onSelect: handleDateChange, selected: selectedDate }), $[70] = customValidation, $[71] = focusedDate, $[72] = handleDateChange, $[73] = selectedDate, $[74] = t26) : t26 = $[74];
  let t27;
  $[75] !== handleKeyDown || $[76] !== t26 ? (t27 = /* @__PURE__ */ jsxs(Box, { "data-calendar-grid": !0, onKeyDown: handleKeyDown, marginTop: 2, overflow: "hidden", tabIndex: 0, children: [
    t26,
    PRESERVE_FOCUS_ELEMENT
  ] }), $[75] = handleKeyDown, $[76] = t26, $[77] = t27) : t27 = $[77];
  let t28;
  $[78] !== t25 || $[79] !== t27 ? (t28 = /* @__PURE__ */ jsxs(Box, { padding: 2, children: [
    t25,
    t27
  ] }), $[78] = t25, $[79] = t27, $[80] = t28) : t28 = $[80];
  let t29;
  $[81] !== handleHoursChange || $[82] !== handleMinutesChange || $[83] !== handleNowClick || $[84] !== handleTimeChange || $[85] !== selectTime || $[86] !== selectedDate || $[87] !== timeStep ? (t29 = selectTime && /* @__PURE__ */ jsxs(Box, { padding: 2, style: {
    borderTop: "1px solid var(--card-border-color)"
  }, children: [
    /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
      /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, children: [
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Select, { "aria-label": "Select hour", value: selectedDate?.getHours(), onChange: handleHoursChange, children: HOURS_24.map(_temp$H) }) }),
        /* @__PURE__ */ jsx(Box, { paddingX: 1, children: /* @__PURE__ */ jsx(Text$1, { children: ":" }) }),
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Select, { "aria-label": "Select minutes", value: selectedDate?.getMinutes(), onChange: handleMinutesChange, children: range(0, 60, timeStep).map(_temp2$e) }) })
      ] }),
      /* @__PURE__ */ jsx(Box, { marginLeft: 2, children: /* @__PURE__ */ jsx(Button$1, { text: "Set to current time", mode: "bleed", onClick: handleNowClick }) })
    ] }),
    features.timePresets
  ] }), $[81] = handleHoursChange, $[82] = handleMinutesChange, $[83] = handleNowClick, $[84] = handleTimeChange, $[85] = selectTime, $[86] = selectedDate, $[87] = timeStep, $[88] = t29) : t29 = $[88];
  let t30;
  return $[89] !== restProps || $[90] !== t28 || $[91] !== t29 ? (t30 = /* @__PURE__ */ jsxs(Box, { "data-ui": "Calendar", ...restProps, ref, children: [
    t28,
    t29
  ] }), $[89] = restProps, $[90] = t28, $[91] = t29, $[92] = t30) : t30 = $[92], t30;
});
function CalendarMonthSelect(props2) {
  const $ = c(16), {
    moveFocusedDate,
    onChange,
    value
  } = props2;
  let t0;
  $[0] !== moveFocusedDate ? (t0 = () => moveFocusedDate(-1), $[0] = moveFocusedDate, $[1] = t0) : t0 = $[1];
  const handlePrevMonthClick = t0;
  let t1;
  $[2] !== moveFocusedDate ? (t1 = () => moveFocusedDate(1), $[2] = moveFocusedDate, $[3] = t1) : t1 = $[3];
  const handleNextMonthClick = t1;
  let t2;
  $[4] !== handlePrevMonthClick ? (t2 = /* @__PURE__ */ jsx(Button$1, { "aria-label": "Go to previous month", onClick: handlePrevMonthClick, mode: "bleed", icon: ChevronLeftIcon, paddingX: 2, radius: 0 }), $[4] = handlePrevMonthClick, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = MONTH_NAMES.map(_temp3$4), $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== onChange || $[8] !== value ? (t4 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Select, { radius: 0, value, onChange, children: t3 }) }), $[7] = onChange, $[8] = value, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== handleNextMonthClick ? (t5 = /* @__PURE__ */ jsx(Button$1, { "aria-label": "Go to next month", mode: "bleed", icon: ChevronRightIcon, onClick: handleNextMonthClick, paddingX: 2, radius: 0 }), $[10] = handleNextMonthClick, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== t2 || $[13] !== t4 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { flex: 1, children: [
    t2,
    t4,
    t5
  ] }), $[12] = t2, $[13] = t4, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function _temp3$4(m, i) {
  return /* @__PURE__ */ jsx("option", { value: i, children: m }, i);
}
function CalendarYearSelect(props2) {
  const $ = c(16), {
    moveFocusedDate,
    onChange,
    value
  } = props2;
  let t0;
  $[0] !== moveFocusedDate ? (t0 = () => moveFocusedDate(-12), $[0] = moveFocusedDate, $[1] = t0) : t0 = $[1];
  const handlePrevYearClick = t0;
  let t1;
  $[2] !== moveFocusedDate ? (t1 = () => moveFocusedDate(12), $[2] = moveFocusedDate, $[3] = t1) : t1 = $[3];
  const handleNextYearClick = t1;
  let t2;
  $[4] !== handlePrevYearClick ? (t2 = /* @__PURE__ */ jsx(Button$1, { "aria-label": "Previous year", onClick: handlePrevYearClick, mode: "bleed", icon: ChevronLeftIcon, paddingX: 2, radius: 0 }), $[4] = handlePrevYearClick, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    width: 65
  }, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== onChange || $[8] !== value ? (t4 = /* @__PURE__ */ jsx(YearInput, { value, onChange, radius: 0, style: t3 }), $[7] = onChange, $[8] = value, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== handleNextYearClick ? (t5 = /* @__PURE__ */ jsx(Button$1, { "aria-label": "Next year", onClick: handleNextYearClick, mode: "bleed", icon: ChevronRightIcon, paddingX: 2, radius: 0 }), $[10] = handleNextYearClick, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== t2 || $[13] !== t4 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { children: [
    t2,
    t4,
    t5
  ] }), $[12] = t2, $[13] = t4, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function _temp$H(h) {
  return /* @__PURE__ */ jsx("option", { value: h, children: `${h}`.padStart(2, "0") }, h);
}
function _temp2$e(m_1) {
  return /* @__PURE__ */ jsx("option", { value: m_1, children: `${m_1}`.padStart(2, "0") }, m_1);
}
const DatePicker = forwardRef(function(props2, ref) {
  const {
    utcToCurrentZoneDate
  } = useTimeZone(), {
    value = /* @__PURE__ */ new Date(),
    onChange,
    customValidation,
    ...rest
  } = props2, [focusedDate, setFocusedDay] = useState(), handleSelect = useCallback((nextDate) => {
    onChange(nextDate), setFocusedDay(void 0);
  }, [onChange]);
  return /* @__PURE__ */ jsx(Calendar, { ...rest, ref, selectedDate: utcToCurrentZoneDate(value), onSelect: handleSelect, focusedDate: utcToCurrentZoneDate(focusedDate || value), onFocusedDateChange: setFocusedDay, customValidation });
}), DateTimeInput$1 = forwardRef(function(props2, forwardedRef) {
  const $ = c(30);
  let customValidation, inputValue, onChange, onInputChange, rest, selectTime, timeStep, value;
  $[0] !== props2 ? ({
    value,
    inputValue,
    customValidation,
    onInputChange,
    onChange,
    selectTime,
    timeStep,
    ...rest
  } = props2, $[0] = props2, $[1] = customValidation, $[2] = inputValue, $[3] = onChange, $[4] = onInputChange, $[5] = rest, $[6] = selectTime, $[7] = timeStep, $[8] = value) : (customValidation = $[1], inputValue = $[2], onChange = $[3], onInputChange = $[4], rest = $[5], selectTime = $[6], timeStep = $[7], value = $[8]);
  const popoverRef = useRef(null), inputRef = useRef(null), buttonRef = useRef(null);
  let t0;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => inputRef.current, $[9] = t0) : t0 = $[9], useImperativeHandle(forwardedRef, t0);
  const [isPickerOpen, setPickerOpen] = useState(!1), portal = usePortal();
  let t1, t2;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setPickerOpen(!1), t2 = () => [popoverRef.current], $[10] = t1, $[11] = t2) : (t1 = $[10], t2 = $[11]), useClickOutsideEvent(t1, t2);
  let t3;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    inputRef.current?.focus(), inputRef.current?.select();
  }, $[12] = t3) : t3 = $[12];
  const handleDeactivation = t3;
  let t4;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t4 = (e) => {
    e.key === "Escape" && setPickerOpen(!1);
  }, $[13] = t4) : t4 = $[13];
  const handleKeyUp = t4;
  let t5;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => setPickerOpen(!0), $[14] = t5) : t5 = $[14];
  const handleClick = t5;
  let t6;
  $[15] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    padding: "5px"
  }, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] === Symbol.for("react.memo_cache_sentinel") ? (t7 = /* @__PURE__ */ jsx(Box, { style: t6, children: /* @__PURE__ */ jsx(Button$1, { ref: buttonRef, icon: CalendarIcon, mode: "bleed", padding: 2, onClick: handleClick, style: {
    display: "block"
  }, "data-testid": "select-date-button" }) }), $[16] = t7) : t7 = $[16];
  const suffix = t7;
  let t8;
  $[17] !== customValidation || $[18] !== isPickerOpen || $[19] !== onChange || $[20] !== portal || $[21] !== selectTime || $[22] !== timeStep || $[23] !== value ? (t8 = isPickerOpen ? /* @__PURE__ */ jsx(LayerProvider, { zOffset: 1e3, children: /* @__PURE__ */ jsx(Popover, { constrainSize: !0, content: /* @__PURE__ */ jsx(Box, { overflow: "auto", children: /* @__PURE__ */ jsx(FocusLock, { onDeactivation: handleDeactivation, children: /* @__PURE__ */ jsx(DatePicker, { selectTime, timeStep, onKeyUp: handleKeyUp, value, onChange, customValidation }) }) }), "data-testid": "date-input-dialog", fallbackPlacements: ["bottom", "bottom-start", "top-end", "top", "top-start"], floatingBoundary: portal.element, open: !0, placement: "bottom-end", portal: !0, radius: 2, ref: popoverRef, children: suffix }) }) : suffix, $[17] = customValidation, $[18] = isPickerOpen, $[19] = onChange, $[20] = portal, $[21] = selectTime, $[22] = timeStep, $[23] = value, $[24] = t8) : t8 = $[24];
  let t9;
  return $[25] !== inputValue || $[26] !== onInputChange || $[27] !== rest || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsx(LazyTextInput, { "data-testid": "date-input", ref: inputRef, ...rest, value: inputValue, onChange: onInputChange, suffix: t8 }), $[25] = inputValue, $[26] = onInputChange, $[27] = rest, $[28] = t8, $[29] = t9) : t9 = $[29], t9;
}), CommonDateTimeInput = forwardRef(function(props2, forwardedRef) {
  const {
    value,
    markers,
    title,
    description,
    placeholder,
    parseInputValue,
    formatInputValue,
    deserialize: deserialize2,
    serialize: serialize2,
    selectTime,
    timeStep,
    readOnly,
    level,
    onChange,
    customValidation,
    ...rest
  } = props2, [localValue, setLocalValue] = useState(null);
  useEffect(() => {
    setLocalValue(null);
  }, [value]);
  const {
    zoneDateToUtc
  } = useTimeZone(), undefinedValue = typeof value > "u", handleDatePickerInputChange = useCallback((event) => {
    const nextInputValue = event.currentTarget.value, result = nextInputValue === "" ? null : parseInputValue(nextInputValue);
    result === null ? (onChange(null), undefinedValue && localValue && setLocalValue(null)) : result.isValid ? onChange(serialize2(zoneDateToUtc(result.date))) : setLocalValue(nextInputValue);
  }, [undefinedValue, zoneDateToUtc, localValue, serialize2, onChange, parseInputValue]), handleDatePickerChange = useCallback((nextDate) => {
    onChange(nextDate ? serialize2(nextDate) : null);
  }, [serialize2, onChange]), inputRef = useRef(null);
  useImperativeHandle(forwardedRef, () => inputRef.current);
  const id2 = useId(), parseResult = localValue ? parseInputValue(localValue) : value ? deserialize2(value) : null, inputValue = localValue || (parseResult?.isValid ? formatInputValue(parseResult.date) : value), nodeValidations = useMemo(() => markers.map((m) => ({
    level: m.level,
    path: m.path,
    message: m.message ?? m.item?.message
  })), [markers]);
  return /* @__PURE__ */ jsx(FormField, { validation: parseResult?.error ? [
    ...nodeValidations,
    {
      level: "error",
      message: parseResult.error,
      path: []
    }
    // casting to marker to avoid having to implement cloneWithMessage on item
  ] : nodeValidations, title, level, description, inputId: id2, children: readOnly ? /* @__PURE__ */ jsx(TextInput$1, { value: inputValue, readOnly: !0 }) : /* @__PURE__ */ jsx(DateTimeInput$1, { ...rest, id: id2, selectTime, timeStep, placeholder: placeholder || `e.g. ${formatInputValue(/* @__PURE__ */ new Date())}`, ref: inputRef, value: parseResult?.date, inputValue: inputValue || "", readOnly: !!readOnly, onInputChange: handleDatePickerInputChange, onChange: handleDatePickerChange, customValidity: parseResult?.error, customValidation }) });
});
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.valueOf());
}
function parseOptions(options = {}) {
  return {
    customValidation: options.customValidation || function() {
      return !0;
    },
    customValidationMessage: options.customValidationMessage || "Invalid date.",
    calendarTodayLabel: options.calendarTodayLabel || "Today",
    timeStep: "timeStep" in options && Number(options.timeStep) || 1
  };
}
function serialize$1(date) {
  return date.toISOString();
}
function deserialize$1(isoString) {
  const deserialized = new Date(isoString);
  return isValidDate(deserialized) ? {
    isValid: !0,
    date: deserialized
  } : {
    isValid: !1,
    error: `Invalid date value: "${isoString}"`
  };
}
function enforceTimeStep(dateString, timeStep) {
  if (!timeStep || timeStep === 1)
    return dateString;
  const date = parseISO(dateString), minutes = getMinutes(date), leftOver = minutes % timeStep;
  return serialize$1(leftOver !== 0 ? setMinutes(date, minutes - leftOver) : date);
}
const DateTimeInput = forwardRef(function(props2, forwardedRef) {
  const $ = c(28);
  let onChange, rest, type;
  $[0] !== props2 ? ({
    type,
    onChange,
    ...rest
  } = props2, $[0] = props2, $[1] = onChange, $[2] = rest, $[3] = type) : (onChange = $[1], rest = $[2], type = $[3]);
  const {
    title,
    description,
    placeholder
  } = type, {
    scheduledPublishing: scheduledPublishing2
  } = useWorkspace(), inputDateTimeFormat = scheduledPublishing2.inputDateTimeFormat, {
    getCurrentZoneDate,
    timeZone
  } = useTimeZone();
  let t0;
  $[4] !== type.options ? (t0 = parseOptions(type.options), $[4] = type.options, $[5] = t0) : t0 = $[5];
  const {
    customValidation,
    customValidationMessage,
    timeStep
  } = t0;
  let t1;
  $[6] !== onChange || $[7] !== timeStep ? (t1 = (nextDate) => {
    let date = nextDate;
    date !== null && timeStep > 1 && (date = enforceTimeStep(date, timeStep)), onChange(date);
  }, $[6] = onChange, $[7] = timeStep, $[8] = t1) : t1 = $[8];
  const handleChange = t1;
  let t2;
  $[9] !== inputDateTimeFormat || $[10] !== timeZone.name ? (t2 = (date_0) => formatInTimeZone(date_0, timeZone.name, `${inputDateTimeFormat}`), $[9] = inputDateTimeFormat, $[10] = timeZone.name, $[11] = t2) : t2 = $[11];
  const formatInputValue = t2;
  let t3;
  $[12] !== customValidation || $[13] !== customValidationMessage || $[14] !== getCurrentZoneDate || $[15] !== inputDateTimeFormat ? (t3 = (inputValue) => {
    const parsed = parse(inputValue, `${inputDateTimeFormat}`, getCurrentZoneDate());
    return isValid(parsed) ? customValidation(parsed) ? {
      isValid: !0,
      date: parsed
    } : {
      isValid: !1,
      error: customValidationMessage
    } : {
      isValid: !1,
      error: `Invalid date. Must be in the format "${inputDateTimeFormat}"`
    };
  }, $[12] = customValidation, $[13] = customValidationMessage, $[14] = getCurrentZoneDate, $[15] = inputDateTimeFormat, $[16] = t3) : t3 = $[16];
  const parseInputValue = t3;
  let t4;
  return $[17] !== customValidation || $[18] !== description || $[19] !== formatInputValue || $[20] !== forwardedRef || $[21] !== handleChange || $[22] !== parseInputValue || $[23] !== placeholder || $[24] !== rest || $[25] !== timeStep || $[26] !== title ? (t4 = /* @__PURE__ */ jsx(CommonDateTimeInput, { ...rest, onChange: handleChange, ref: forwardedRef, selectTime: !0, timeStep, title, description, placeholder, serialize: serialize$1, deserialize: deserialize$1, formatInputValue, customValidation, parseInputValue }), $[17] = customValidation, $[18] = description, $[19] = formatInputValue, $[20] = forwardedRef, $[21] = handleChange, $[22] = parseInputValue, $[23] = placeholder, $[24] = rest, $[25] = timeStep, $[26] = title, $[27] = t4) : t4 = $[27], t4;
}), ScheduleForm = (props2) => {
  const $ = c(11), {
    onChange,
    value
  } = props2, {
    getCurrentZoneDate
  } = useTimeZone(), [inputValue, setInputValue] = useState();
  let t0;
  $[0] !== onChange ? (t0 = (date) => {
    date && onChange && (onChange({
      date
    }), setInputValue(date));
  }, $[0] = onChange, $[1] = t0) : t0 = $[1];
  const handleChange = t0;
  let t1;
  $[2] !== getCurrentZoneDate ? (t1 = (selectedDate) => selectedDate > getCurrentZoneDate(), $[2] = getCurrentZoneDate, $[3] = t1) : t1 = $[3];
  const handleCustomValidation = t1;
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== handleCustomValidation ? (t3 = {
    name: "date",
    options: {
      customValidation: handleCustomValidation,
      customValidationMessage: "Date cannot be in the past."
    },
    title: "Date and time"
  }, $[5] = handleCustomValidation, $[6] = t3) : t3 = $[6];
  const t4 = inputValue === void 0 ? value?.date : inputValue;
  let t5;
  return $[7] !== handleChange || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(Stack, { space: 4, children: /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(DateTimeInput, { level: 0, markers: t2, onChange: handleChange, type: t3, value: t4 }) }) }), $[7] = handleChange, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
};
function EditScheduleForm(props2) {
  const $ = c(6), {
    onChange,
    value
  } = props2;
  let t0;
  $[0] !== onChange || $[1] !== value ? (t0 = /* @__PURE__ */ jsx(ScheduleForm, { onChange, value }), $[0] = onChange, $[1] = value, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== props2.children || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    props2.children,
    t0
  ] }), $[3] = props2.children, $[4] = t0, $[5] = t1) : t1 = $[5], t1;
}
const DialogHeader$1 = (props2) => {
  const $ = c(4), {
    title
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("input", { style: {
    opacity: 0,
    position: "absolute",
    width: 0
  }, tabIndex: -1, type: "button" }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { marginLeft: 2, style: {
    marginTop: "-1em",
    marginBottom: "-1em"
  }, children: /* @__PURE__ */ jsx(ButtonTimeZone, { useElementQueries: !0 }) }), $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== title ? (t2 = /* @__PURE__ */ jsx(ButtonTimeZoneElementQuery, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    title,
    t0,
    t1
  ] }) }), $[2] = title, $[3] = t2) : t2 = $[3], t2;
}, DialogScheduleEdit = (props2) => {
  const {
    onClose,
    schedule
  } = props2, {
    updateSchedule
  } = useScheduleOperation(), {
    formData,
    isDirty,
    onFormChange
  } = useScheduleForm(schedule), handleScheduleUpdate = useCallback(() => {
    formData?.date && updateSchedule({
      date: formData.date,
      scheduleId: schedule.id
    }).then(onClose);
  }, [schedule.id, updateSchedule, onClose, formData?.date]);
  return /* @__PURE__ */ jsx(Dialog$1, { footer: {
    confirmButton: {
      text: "Update",
      disabled: !isDirty,
      onClick: handleScheduleUpdate
    }
  }, header: /* @__PURE__ */ jsx(DialogHeader$1, { title: "Edit schedule" }), id: "time-zone", onClose, width: 1, children: /* @__PURE__ */ jsx(EditScheduleForm, { onChange: onFormChange, value: formData }) });
};
function useDialogScheduleEdit(schedule) {
  const $ = c(9), {
    visible,
    show,
    hide
  } = useDialogVisible();
  let t0;
  $[0] !== hide || $[1] !== schedule || $[2] !== visible ? (t0 = {
    onClose: hide,
    schedule,
    visible
  }, $[0] = hide, $[1] = schedule, $[2] = visible, $[3] = t0) : t0 = $[3];
  const dialogProps = t0, t1 = visible ? DialogScheduleEdit : null;
  let t2;
  return $[4] !== dialogProps || $[5] !== hide || $[6] !== show || $[7] !== t1 ? (t2 = {
    DialogScheduleEdit: t1,
    dialogProps,
    dialogScheduleEditShow: show,
    hide
  }, $[4] = dialogProps, $[5] = hide, $[6] = show, $[7] = t1, $[8] = t2) : t2 = $[8], t2;
}
const MenuItemWithPermissionsTooltip = (props2) => {
  const $ = c(13), {
    currentUser,
    hasPermission,
    icon,
    onClick: onClick2,
    permissionsOperationLabel,
    title,
    tone,
    disabled
  } = props2;
  let t0;
  $[0] !== currentUser || $[1] !== permissionsOperationLabel ? (t0 = /* @__PURE__ */ jsx(Box, { paddingX: 2, paddingY: 1, children: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: permissionsOperationLabel }) }), $[0] = currentUser, $[1] = permissionsOperationLabel, $[2] = t0) : t0 = $[2];
  const t1 = !hasPermission || disabled;
  let t2;
  $[3] !== icon || $[4] !== onClick2 || $[5] !== t1 || $[6] !== title || $[7] !== tone ? (t2 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(MenuItem$1, { disabled: t1, icon, onClick: onClick2, text: title, tone }) }), $[3] = icon, $[4] = onClick2, $[5] = t1, $[6] = title, $[7] = tone, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== hasPermission || $[10] !== t0 || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content: t0, disabled: hasPermission, placement: "left", portal: !0, children: t2 }), $[9] = hasPermission, $[10] = t0, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}, ContextMenuItems = (props2) => {
  const $ = c(43), {
    actions,
    onDelete,
    onEdit,
    schedule,
    schemaType
  } = props2, {
    mode
  } = useScheduledPublishingEnabled();
  let t0;
  $[0] !== schedule ? (t0 = getScheduledDocument(schedule), $[0] = schedule, $[1] = t0) : t0 = $[1];
  const firstDocument = t0, currentUser = useCurrentUser(), t1 = schemaType?.name;
  let t2;
  $[2] !== firstDocument.documentId || $[3] !== t1 ? (t2 = {
    id: firstDocument.documentId,
    type: t1,
    permission: "publish"
  }, $[2] = firstDocument.documentId, $[3] = t1, $[4] = t2) : t2 = $[4];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t2), {
    deleteSchedule,
    publishSchedule
  } = useScheduleOperation(), insufficientPermissions = !isPermissionsLoading && !permissions?.granted;
  let t3;
  $[5] !== onEdit ? (t3 = () => {
    onEdit?.();
  }, $[5] = onEdit, $[6] = t3) : t3 = $[6];
  const handleEdit = t3;
  let t4;
  $[7] !== deleteSchedule || $[8] !== onDelete || $[9] !== schedule ? (t4 = () => {
    deleteSchedule({
      schedule
    }).then(() => onDelete?.());
  }, $[7] = deleteSchedule, $[8] = onDelete, $[9] = schedule, $[10] = t4) : t4 = $[10];
  const handleDelete = t4;
  let t5;
  $[11] !== publishSchedule || $[12] !== schedule ? (t5 = () => {
    publishSchedule({
      schedule
    });
  }, $[11] = publishSchedule, $[12] = schedule, $[13] = t5) : t5 = $[13];
  const handleExecute = t5;
  if (!currentUser)
    return null;
  let t6;
  $[14] !== actions?.edit || $[15] !== currentUser || $[16] !== handleEdit || $[17] !== insufficientPermissions || $[18] !== mode ? (t6 = actions?.edit && /* @__PURE__ */ jsx(MenuItemWithPermissionsTooltip, { currentUser, hasPermission: !insufficientPermissions, icon: CalendarIcon, onClick: handleEdit, permissionsOperationLabel: "edit-schedules", title: "Edit schedule", disabled: mode === "upsell" }), $[14] = actions?.edit, $[15] = currentUser, $[16] = handleEdit, $[17] = insufficientPermissions, $[18] = mode, $[19] = t6) : t6 = $[19];
  let t7;
  $[20] !== actions?.execute || $[21] !== currentUser || $[22] !== handleExecute || $[23] !== insufficientPermissions || $[24] !== mode ? (t7 = actions?.execute && /* @__PURE__ */ jsx(MenuItemWithPermissionsTooltip, { currentUser, hasPermission: !insufficientPermissions, icon: PublishIcon, onClick: handleExecute, permissionsOperationLabel: "execute-schedules", title: "Publish now", disabled: mode === "upsell" }), $[20] = actions?.execute, $[21] = currentUser, $[22] = handleExecute, $[23] = insufficientPermissions, $[24] = mode, $[25] = t7) : t7 = $[25];
  let t8;
  $[26] !== actions?.delete || $[27] !== currentUser || $[28] !== handleDelete || $[29] !== insufficientPermissions || $[30] !== mode ? (t8 = actions?.delete && /* @__PURE__ */ jsx(MenuItemWithPermissionsTooltip, { currentUser, hasPermission: !insufficientPermissions, icon: TrashIcon, onClick: handleDelete, permissionsOperationLabel: "delete-schedules", title: "Delete schedule", tone: "critical", disabled: mode === "upsell" }), $[26] = actions?.delete, $[27] = currentUser, $[28] = handleDelete, $[29] = insufficientPermissions, $[30] = mode, $[31] = t8) : t8 = $[31];
  let t9;
  $[32] !== actions?.clear || $[33] !== currentUser || $[34] !== handleDelete || $[35] !== insufficientPermissions || $[36] !== mode ? (t9 = actions?.clear && /* @__PURE__ */ jsx(MenuItemWithPermissionsTooltip, { currentUser, hasPermission: !insufficientPermissions, icon: CheckmarkCircleIcon, onClick: handleDelete, permissionsOperationLabel: "delete-schedules", title: "Clear completed schedule", disabled: mode === "upsell" }), $[32] = actions?.clear, $[33] = currentUser, $[34] = handleDelete, $[35] = insufficientPermissions, $[36] = mode, $[37] = t9) : t9 = $[37];
  let t10;
  return $[38] !== t6 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t6,
    t7,
    t8,
    t9
  ] }), $[38] = t6, $[39] = t7, $[40] = t8, $[41] = t9, $[42] = t10) : t10 = $[42], t10;
}, ScheduleContextMenu = (props2) => {
  const $ = c(10), {
    actions,
    onDelete,
    onEdit,
    schedule,
    schemaType
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== actions || $[2] !== onDelete || $[3] !== onEdit || $[4] !== schedule || $[5] !== schemaType ? (t1 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsx(ContextMenuItems, { actions, onDelete, onEdit, schedule, schemaType }) }), $[1] = actions, $[2] = onDelete, $[3] = onEdit, $[4] = schedule, $[5] = schemaType, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    portal: !0,
    tone: "default"
  }, $[7] = t2) : t2 = $[7];
  let t3;
  return $[8] !== t1 ? (t3 = /* @__PURE__ */ jsx(MenuButton$1, { button: t0, id: "contextMenu", menu: t1, placement: "left", popover: t2 }), $[8] = t1, $[9] = t3) : t3 = $[9], t3;
}, EMPTY_VALIDATION_STATUS = {
  validation: [],
  isValidating: !1
};
function getValidationState(validationMarkers = EMPTY_VALIDATION_STATUS.validation) {
  const hasError = validationMarkers.filter(isValidationErrorMarker).length > 0, hasWarning = validationMarkers.filter(isValidationWarningMarker).length > 0;
  let validationTone = "default";
  return hasWarning && (validationTone = "default"), hasError && (validationTone = "critical"), {
    markers: validationMarkers,
    validationTone,
    hasError,
    hasWarning
  };
}
function useValidationState(markers) {
  const $ = c(2);
  let t0, t1;
  return $[0] !== markers ? (t1 = getValidationState(markers), $[0] = markers, $[1] = t1) : t1 = $[1], t0 = t1, t0;
}
const VALIDATION_DELAY_MS = 1500;
function ValidateScheduleDoc(t0) {
  const $ = c(6), {
    schedule,
    updateValidation
  } = t0, schemaType = useScheduleSchemaType(schedule);
  let t1;
  $[0] !== schedule ? (t1 = getScheduledDocumentId(schedule), $[0] = schedule, $[1] = t1) : t1 = $[1];
  const id2 = t1;
  if (!id2 || !schemaType?.name)
    return null;
  let t2;
  return $[2] !== id2 || $[3] !== schemaType.name || $[4] !== updateValidation ? (t2 = /* @__PURE__ */ jsx(DelayedValidationRunner, { id: id2, schemaName: schemaType.name, updateValidation }), $[2] = id2, $[3] = schemaType.name, $[4] = updateValidation, $[5] = t2) : t2 = $[5], t2;
}
function DelayedValidationRunner(t0) {
  const $ = c(6), {
    id: id2,
    schemaName,
    updateValidation
  } = t0, [ready, setReady] = useState(!1);
  let t1, t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    const timeout2 = setTimeout(() => {
      setReady(!0);
    }, VALIDATION_DELAY_MS);
    return () => {
      clearTimeout(timeout2);
    };
  }, t2 = [], $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]), useEffect(t1, t2), !ready)
    return null;
  let t3;
  return $[2] !== id2 || $[3] !== schemaName || $[4] !== updateValidation ? (t3 = /* @__PURE__ */ jsx(ValidationRunner, { id: id2, schemaName, updateValidation }), $[2] = id2, $[3] = schemaName, $[4] = updateValidation, $[5] = t3) : t3 = $[5], t3;
}
function ValidationRunner(t0) {
  const $ = c(4), {
    id: id2,
    schemaName,
    updateValidation
  } = t0, validationStatus = useValidationStatus(id2, schemaName);
  let t1, t2;
  return $[0] !== updateValidation || $[1] !== validationStatus ? (t1 = () => {
    validationStatus.isValidating || updateValidation(validationStatus);
  }, t2 = [updateValidation, validationStatus], $[0] = updateValidation, $[1] = validationStatus, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), null;
}
function usePublishedId(id2) {
  const $ = c(2);
  let t0, t1;
  return $[0] !== id2 ? (t1 = id2 ? id2.replaceAll("drafts.", "") : void 0, $[0] = id2, $[1] = t1) : t1 = $[1], t0 = t1, t0;
}
const StyledText$1 = styled(Text$1)`
  white-space: initial;
`, MENU_ITEM_TONES = {
  error: "critical",
  warning: "caution",
  info: "primary"
};
function ValidationListItem(props2) {
  const $ = c(30), {
    marker,
    onClick: onClick2,
    path,
    truncate: truncate2
  } = props2;
  let t0;
  $[0] !== marker.path || $[1] !== onClick2 ? (t0 = () => {
    onClick2 && onClick2(marker.path);
  }, $[0] = marker.path, $[1] = onClick2, $[2] = t0) : t0 = $[2];
  const handleClick = t0, menuItemTone = MENU_ITEM_TONES[marker?.level] || void 0, message = marker.message ?? marker.item?.message;
  let t1;
  $[3] !== marker.level ? (t1 = marker.level === "error" && /* @__PURE__ */ jsx(ErrorOutlineIcon, {}), $[3] = marker.level, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== marker.level ? (t2 = marker.level === "warning" && /* @__PURE__ */ jsx(WarningOutlineIcon, {}), $[5] = marker.level, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== marker.level ? (t3 = marker.level === "info" && /* @__PURE__ */ jsx(InfoOutlineIcon, {}), $[7] = marker.level, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t1 || $[10] !== t2 || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t1,
    t2,
    t3
  ] }) }), $[9] = t1, $[10] = t2, $[11] = t3, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== path ? (t5 = path && /* @__PURE__ */ jsx(StyledText$1, { size: 1, weight: "semibold", children: path }), $[13] = path, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== message || $[16] !== truncate2 ? (t6 = message && /* @__PURE__ */ jsx(StyledText$1, { muted: !0, size: 1, textOverflow: truncate2 ? "ellipsis" : void 0, children: message }), $[15] = message, $[16] = truncate2, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== t5 || $[19] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 2, flex: 1, paddingLeft: 3, children: [
    t5,
    t6
  ] }), $[18] = t5, $[19] = t6, $[20] = t7) : t7 = $[20];
  let t8;
  $[21] !== t4 || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { children: [
    t4,
    t7
  ] }), $[21] = t4, $[22] = t7, $[23] = t8) : t8 = $[23];
  const children = t8;
  let t9;
  $[24] !== children ? (t9 = /* @__PURE__ */ jsx(Box, { padding: 2, children }), $[24] = children, $[25] = t9) : t9 = $[25];
  let t10;
  return $[26] !== handleClick || $[27] !== menuItemTone || $[28] !== t9 ? (t10 = /* @__PURE__ */ jsx(MenuItem, { padding: 1, onClick: handleClick, radius: 2, tone: menuItemTone, children: t9 }), $[26] = handleClick, $[27] = menuItemTone, $[28] = t9, $[29] = t10) : t10 = $[29], t10;
}
function ValidationList(props2) {
  const $ = c(27), {
    documentType,
    kind,
    validation: validation2,
    onFocus,
    onClose,
    truncate: truncate2
  } = props2;
  let T0, t0, t1, t2, t3, t4, t5, t6;
  if ($[0] !== documentType || $[1] !== kind || $[2] !== onClose || $[3] !== onFocus || $[4] !== truncate2 || $[5] !== validation2) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const errors = validation2.filter(isValidationErrorMarker), warnings = validation2.filter(isValidationWarningMarker), info = validation2.filter(isValidationInfoMarker);
      let t72;
      $[14] !== onClose || $[15] !== onFocus ? (t72 = (t82) => {
        onFocus && onFocus(t82 === void 0 ? [] : t82), onClose && onClose();
      }, $[14] = onClose, $[15] = onFocus, $[16] = t72) : t72 = $[16];
      const handleClick = t72;
      let t8;
      $[17] !== documentType ? (t8 = (path_0) => {
        const fields = documentType && documentType.fields, field = fields && fields.find((curr) => curr.name === path_0[0]);
        return field && field.type.title || "";
      }, $[17] = documentType, $[18] = t8) : t8 = $[18];
      const resolvePathTitle = t8, hasErrors = errors.length > 0, hasWarnings = warnings.length > 0, hasInfo = info.length > 0;
      if (!hasErrors && !hasWarnings && !hasInfo) {
        t6 = null;
        break bb0;
      }
      T0 = Container$2, t0 = 0, t1 = kind, t2 = "validation-list", t3 = hasErrors && errors.map((_error, i) => /* @__PURE__ */ jsx(ValidationListItem, { truncate: truncate2, path: resolvePathTitle(_error.path), marker: _error, onClick: handleClick }, i)), t4 = hasWarnings && warnings.map((_warning, i_0) => /* @__PURE__ */ jsx(ValidationListItem, { truncate: truncate2, path: resolvePathTitle(_warning.path), marker: _warning, onClick: handleClick }, i_0)), t5 = hasInfo && info.map((_info, i_1) => /* @__PURE__ */ jsx(ValidationListItem, { truncate: truncate2, path: resolvePathTitle(_info.path), marker: _info, onClick: handleClick }, i_1));
    }
    $[0] = documentType, $[1] = kind, $[2] = onClose, $[3] = onFocus, $[4] = truncate2, $[5] = validation2, $[6] = T0, $[7] = t0, $[8] = t1, $[9] = t2, $[10] = t3, $[11] = t4, $[12] = t5, $[13] = t6;
  } else
    T0 = $[6], t0 = $[7], t1 = $[8], t2 = $[9], t3 = $[10], t4 = $[11], t5 = $[12], t6 = $[13];
  if (t6 !== Symbol.for("react.early_return_sentinel"))
    return t6;
  let t7;
  return $[19] !== T0 || $[20] !== t0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 ? (t7 = /* @__PURE__ */ jsxs(T0, { width: t0, "data-kind": t1, "data-testid": t2, children: [
    t3,
    t4,
    t5
  ] }), $[19] = T0, $[20] = t0, $[21] = t1, $[22] = t2, $[23] = t3, $[24] = t4, $[25] = t5, $[26] = t7) : t7 = $[26], t7;
}
const POPOVER_PROPS$3 = {
  portal: !0,
  constrainSize: !0,
  preventOverflow: !0,
  tone: "default",
  width: 0,
  placement: "bottom-end"
};
function ValidationInfo(props2) {
  const $ = c(21), {
    type,
    markers,
    menuHeader,
    documentId
  } = props2, router = useRouter(), {
    hasError,
    hasWarning
  } = useValidationState(markers), visibility = hasError || hasWarning ? "visible" : "hidden", id2 = useId() || "", publishId = usePublishedId(documentId);
  let t0;
  $[0] !== publishId || $[1] !== router ? (t0 = (path) => {
    publishId && router.navigateIntent("edit", {
      id: publishId,
      path: encodeURIComponent(PathUtils.toString(path))
    });
  }, $[0] = publishId, $[1] = router, $[2] = t0) : t0 = $[2];
  const onFocus = t0, t1 = id2 || "";
  let t2;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    content: "Show validation issues"
  }, $[3] = t2) : t2 = $[3];
  const t3 = hasError ? ErrorOutlineIcon : WarningOutlineIcon;
  let t4;
  $[4] !== visibility ? (t4 = {
    visibility
  }, $[4] = visibility, $[5] = t4) : t4 = $[5];
  const t5 = hasError ? "critical" : "default";
  let t6;
  $[6] !== t3 || $[7] !== t4 || $[8] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button, { tooltipProps: t2, mode: "bleed", "data-testid": "schedule-validation-list-button", icon: t3, style: t4, tone: t5 }), $[6] = t3, $[7] = t4, $[8] = t5, $[9] = t6) : t6 = $[9];
  const t7 = menuHeader ?? null, t8 = type;
  let t9;
  $[10] !== markers || $[11] !== onFocus || $[12] !== t8 ? (t9 = /* @__PURE__ */ jsx(ValidationList, { documentType: t8, validation: markers, onFocus }), $[10] = markers, $[11] = onFocus, $[12] = t8, $[13] = t9) : t9 = $[13];
  let t10;
  $[14] !== t7 || $[15] !== t9 ? (t10 = /* @__PURE__ */ jsx(Menu, { padding: 1, children: /* @__PURE__ */ jsx(Container$2, { width: 0, children: /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t7,
    t9
  ] }) }) }), $[14] = t7, $[15] = t9, $[16] = t10) : t10 = $[16];
  let t11;
  return $[17] !== t1 || $[18] !== t10 || $[19] !== t6 ? (t11 = /* @__PURE__ */ jsx(MenuButton$1, { id: t1, button: t6, menu: t10, popover: POPOVER_PROPS$3 }), $[17] = t1, $[18] = t10, $[19] = t6, $[20] = t11) : t11 = $[20], t11;
}
const DateWithTooltip = (props2) => {
  const $ = c(21), {
    date,
    useElementQueries
  } = props2, {
    formatDateTz
  } = useTimeZone();
  let t0;
  $[0] !== date ? (t0 = formatDistance(date, /* @__PURE__ */ new Date(), {
    addSuffix: !0
  }), $[0] = date, $[1] = t0) : t0 = $[1];
  const distance = t0;
  let t1;
  $[2] !== date || $[3] !== formatDateTz ? (t1 = formatDateTz({
    date,
    format: DATE_FORMAT.LARGE
  }), $[2] = date, $[3] = formatDateTz, $[4] = t1) : t1 = $[4];
  const dateTimeLarge = t1;
  let t2;
  $[5] !== date || $[6] !== formatDateTz ? (t2 = formatDateTz({
    date,
    format: DATE_FORMAT.MEDIUM
  }), $[5] = date, $[6] = formatDateTz, $[7] = t2) : t2 = $[7];
  const dateTimeMedium = t2;
  let t3;
  $[8] !== date || $[9] !== formatDateTz ? (t3 = formatDateTz({
    date,
    format: DATE_FORMAT.SMALL
  }), $[8] = date, $[9] = formatDateTz, $[10] = t3) : t3 = $[10];
  const dateTimeSmall = t3;
  let t4;
  $[11] !== dateTimeLarge || $[12] !== dateTimeMedium || $[13] !== dateTimeSmall || $[14] !== useElementQueries ? (t4 = useElementQueries ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("span", { className: "date-small", children: dateTimeSmall }),
    /* @__PURE__ */ jsx("span", { className: "date-medium", children: dateTimeMedium }),
    /* @__PURE__ */ jsx("span", { className: "date-large", children: dateTimeLarge })
  ] }) : dateTimeLarge, $[11] = dateTimeLarge, $[12] = dateTimeMedium, $[13] = dateTimeSmall, $[14] = useElementQueries, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== t4 ? (t5 = /* @__PURE__ */ jsx("span", { children: t4 }), $[16] = t4, $[17] = t5) : t5 = $[17];
  let t6;
  return $[18] !== distance || $[19] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Tooltip, { content: distance, portal: !0, children: t5 }) }), $[18] = distance, $[19] = t5, $[20] = t6) : t6 = $[20], t6;
}, POPOVER_PROPS$2 = {
  portal: !0,
  constrainSize: !0,
  preventOverflow: !0,
  tone: "default",
  width: 0
}, StateReasonFailedInfo = (props2) => {
  const $ = c(6), {
    stateReason
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Button, { tooltipProps: {
    content: "Schedule failed"
  }, mode: "bleed", "data-testid": "schedule-validation-list-button", icon: ErrorOutlineIcon, tone: "critical" }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: SCHEDULE_FAILED_TEXT }), $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, style: {
    color: red[700].hex
  }, children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[2] = t2) : t2 = $[2];
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    color: red[700].hex
  }, $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] !== stateReason ? (t4 = /* @__PURE__ */ jsx(MenuButton$1, { id: "stateReason", button: t0, menu: /* @__PURE__ */ jsx(Menu, { padding: 1, children: /* @__PURE__ */ jsxs(Container$2, { padding: 2, width: 0, children: [
    t1,
    /* @__PURE__ */ jsxs(Flex, { gap: 3, marginTop: 4, padding: 1, children: [
      t2,
      /* @__PURE__ */ jsx(Text$1, { size: 1, style: t3, weight: "medium", children: stateReason })
    ] })
  ] }) }), popover: POPOVER_PROPS$2 }), $[4] = stateReason, $[5] = t4) : t4 = $[5], t4;
}, User = (props2) => {
  const $ = c(2), {
    id: id2
  } = props2;
  let t0;
  return $[0] !== id2 ? (t0 = /* @__PURE__ */ jsx(UserAvatar, { user: id2, withTooltip: !0 }), $[0] = id2, $[1] = t0) : t0 = $[1], t0;
}, StatusDotPlaceholder = styled(Box)`
  width: 9px;
`, PreviewWrapper = (props2) => {
  const $ = c(162), {
    children,
    contextMenu,
    linkComponent,
    onClick: onClick2,
    previewState,
    publishedDocumentId,
    schedule,
    schemaType,
    useElementQueries
  } = props2, {
    mode
  } = useScheduledPublishingEnabled(), [validationStatus, setValidationStatus] = useState(EMPTY_VALIDATION_STATUS), {
    validation: validation2
  } = validationStatus, {
    hasError,
    validationTone
  } = useValidationState(validation2), {
    formatDateTz
  } = useTimeZone();
  let T0, T1, T2, T3, T4, T5, T6, scheduleDate, t0, t1, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t2, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29, t3, t30, t4, t5, t6, t7, t8, t9;
  if ($[0] !== children || $[1] !== formatDateTz || $[2] !== linkComponent || $[3] !== mode || $[4] !== onClick2 || $[5] !== previewState?.draft || $[6] !== previewState?.published || $[7] !== schedule || $[8] !== validationTone) {
    const executeDate = getLastExecuteDate(schedule);
    scheduleDate = executeDate ? new Date(executeDate) : null, T6 = Card, t26 = 1, t27 = 2, t28 = 1, t29 = validationTone, $[48] !== mode || $[49] !== schedule.state ? (t30 = mode === "upsell" && schedule.state === "scheduled" ? {
      opacity: 0.7
    } : void 0, $[48] = mode, $[49] = schedule.state, $[50] = t30) : t30 = $[50], T5 = Flex, t23 = "center", t24 = 1, t25 = "space-between", T4 = Tooltip, $[51] === Symbol.for("react.memo_cache_sentinel") ? (t19 = {
      open: 400
    }, $[51] = t19) : t19 = $[51], t20 = "bottom-end";
    const t312 = previewState?.draft, t322 = previewState?.published;
    $[52] !== t312 || $[53] !== t322 ? (t21 = /* @__PURE__ */ jsx(DocumentStatus, { draft: t312, published: t322 }), $[52] = t312, $[53] = t322, $[54] = t21) : t21 = $[54], t22 = !previewState?.draft && !previewState?.published, T3 = Card, t10 = !0, t11 = linkComponent || void 0, t12 = onClick2 || linkComponent ? "a" : void 0, t13 = 1, t14 = onClick2, t15 = 1, t16 = 2, t17 = 0, t18 = validationTone, T2 = Flex, t4 = "center", t5 = 3, t6 = "flex-start", $[55] !== children ? (t7 = children ? 0 : [1, 2], $[55] = children, $[56] = t7) : t7 = $[56], $[57] !== children ? (t8 = children && /* @__PURE__ */ jsx(Box, { style: {
      flexBasis: "auto",
      flexGrow: 1
    }, children }), $[57] = children, $[58] = t8) : t8 = $[58], $[59] !== schedule.action ? (t9 = schedule.action === "unpublish" && /* @__PURE__ */ jsx(Flex, { style: {
      flexShrink: 0
    }, children: /* @__PURE__ */ jsx(Badge, { fontSize: 0, mode: "outline", tone: SCHEDULE_ACTION_DICTIONARY[schedule.action].badgeTone, children: schedule.action }) }), $[59] = schedule.action, $[60] = t9) : t9 = $[60], T1 = Box, $[61] === Symbol.for("react.memo_cache_sentinel") ? (t2 = ["block", "none"], t3 = {
      flexShrink: 0,
      width: "90px"
    }, $[61] = t2, $[62] = t3) : (t2 = $[61], t3 = $[62]), T0 = Stack, t0 = 2, t1 = scheduleDate ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: formatDateTz({
        date: scheduleDate,
        format: "dd/MM/yyyy"
      }) }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: formatDateTz({
        date: scheduleDate,
        format: "p"
      }) })
    ] }) : /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("em", { children: "No date specified" }) }), $[0] = children, $[1] = formatDateTz, $[2] = linkComponent, $[3] = mode, $[4] = onClick2, $[5] = previewState?.draft, $[6] = previewState?.published, $[7] = schedule, $[8] = validationTone, $[9] = T0, $[10] = T1, $[11] = T2, $[12] = T3, $[13] = T4, $[14] = T5, $[15] = T6, $[16] = scheduleDate, $[17] = t0, $[18] = t1, $[19] = t10, $[20] = t11, $[21] = t12, $[22] = t13, $[23] = t14, $[24] = t15, $[25] = t16, $[26] = t17, $[27] = t18, $[28] = t19, $[29] = t2, $[30] = t20, $[31] = t21, $[32] = t22, $[33] = t23, $[34] = t24, $[35] = t25, $[36] = t26, $[37] = t27, $[38] = t28, $[39] = t29, $[40] = t3, $[41] = t30, $[42] = t4, $[43] = t5, $[44] = t6, $[45] = t7, $[46] = t8, $[47] = t9;
  } else
    T0 = $[9], T1 = $[10], T2 = $[11], T3 = $[12], T4 = $[13], T5 = $[14], T6 = $[15], scheduleDate = $[16], t0 = $[17], t1 = $[18], t10 = $[19], t11 = $[20], t12 = $[21], t13 = $[22], t14 = $[23], t15 = $[24], t16 = $[25], t17 = $[26], t18 = $[27], t19 = $[28], t2 = $[29], t20 = $[30], t21 = $[31], t22 = $[32], t23 = $[33], t24 = $[34], t25 = $[35], t26 = $[36], t27 = $[37], t28 = $[38], t29 = $[39], t3 = $[40], t30 = $[41], t4 = $[42], t5 = $[43], t6 = $[44], t7 = $[45], t8 = $[46], t9 = $[47];
  let t31;
  $[63] !== T0 || $[64] !== t0 || $[65] !== t1 ? (t31 = /* @__PURE__ */ jsx(T0, { space: t0, children: t1 }), $[63] = T0, $[64] = t0, $[65] = t1, $[66] = t31) : t31 = $[66];
  let t32;
  $[67] !== T1 || $[68] !== t2 || $[69] !== t3 || $[70] !== t31 ? (t32 = /* @__PURE__ */ jsx(T1, { display: t2, style: t3, children: t31 }), $[67] = T1, $[68] = t2, $[69] = t3, $[70] = t31, $[71] = t32) : t32 = $[71];
  let t33;
  $[72] === Symbol.for("react.memo_cache_sentinel") ? (t33 = ["none", "block"], $[72] = t33) : t33 = $[72];
  const t34 = children ? "35%" : "auto";
  let t35;
  $[73] !== t34 ? (t35 = {
    flexShrink: 0,
    maxWidth: "250px",
    width: t34
  }, $[73] = t34, $[74] = t35) : t35 = $[74];
  let t36;
  $[75] !== scheduleDate || $[76] !== useElementQueries ? (t36 = scheduleDate ? /* @__PURE__ */ jsx(DateWithTooltip, { date: scheduleDate, useElementQueries }) : /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("em", { children: "No date specified" }) }), $[75] = scheduleDate, $[76] = useElementQueries, $[77] = t36) : t36 = $[77];
  let t37;
  $[78] !== t35 || $[79] !== t36 ? (t37 = /* @__PURE__ */ jsx(Box, { display: t33, style: t35, children: t36 }), $[78] = t35, $[79] = t36, $[80] = t37) : t37 = $[80];
  let t38;
  $[81] !== children ? (t38 = !children && /* @__PURE__ */ jsx(Box, { style: {
    visibility: "hidden"
  }, children: /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0 }) }), $[81] = children, $[82] = t38) : t38 = $[82];
  let t39;
  $[83] === Symbol.for("react.memo_cache_sentinel") ? (t39 = {
    flexShrink: 0,
    marginLeft: "auto"
  }, $[83] = t39) : t39 = $[83];
  let t40;
  $[84] === Symbol.for("react.memo_cache_sentinel") ? (t40 = ["none", "none", "block"], $[84] = t40) : t40 = $[84];
  let t41;
  $[85] === Symbol.for("react.memo_cache_sentinel") ? (t41 = {
    flexShrink: 0
  }, $[85] = t41) : t41 = $[85];
  const t42 = schedule?.author;
  let t43;
  $[86] !== t42 ? (t43 = /* @__PURE__ */ jsx(Box, { display: t40, marginX: 3, style: t41, children: /* @__PURE__ */ jsx(User, { id: t42 }) }), $[86] = t42, $[87] = t43) : t43 = $[87];
  let t44, t45, t46;
  $[88] === Symbol.for("react.memo_cache_sentinel") ? (t44 = ["none", "block"], t45 = [2, 2, 3], t46 = {
    flexShrink: 0
  }, $[88] = t44, $[89] = t45, $[90] = t46) : (t44 = $[88], t45 = $[89], t46 = $[90]);
  let t47;
  $[91] !== publishedDocumentId ? (t47 = /* @__PURE__ */ jsx(Box, { display: t44, marginX: t45, style: t46, children: publishedDocumentId ? /* @__PURE__ */ jsx(DocumentVersionsStatus, { publishedDocumentId }) : /* @__PURE__ */ jsx(StatusDotPlaceholder, {}) }), $[91] = publishedDocumentId, $[92] = t47) : t47 = $[92];
  let t48;
  $[93] !== t43 || $[94] !== t47 ? (t48 = /* @__PURE__ */ jsxs(Flex, { align: "center", style: t39, children: [
    t43,
    t47
  ] }), $[93] = t43, $[94] = t47, $[95] = t48) : t48 = $[95];
  let t49;
  $[96] !== T2 || $[97] !== t32 || $[98] !== t37 || $[99] !== t38 || $[100] !== t4 || $[101] !== t48 || $[102] !== t5 || $[103] !== t6 || $[104] !== t7 || $[105] !== t8 || $[106] !== t9 ? (t49 = /* @__PURE__ */ jsxs(T2, { align: t4, gap: t5, justify: t6, paddingLeft: t7, children: [
    t8,
    t9,
    t32,
    t37,
    t38,
    t48
  ] }), $[96] = T2, $[97] = t32, $[98] = t37, $[99] = t38, $[100] = t4, $[101] = t48, $[102] = t5, $[103] = t6, $[104] = t7, $[105] = t8, $[106] = t9, $[107] = t49) : t49 = $[107];
  let t50;
  $[108] !== T3 || $[109] !== t10 || $[110] !== t11 || $[111] !== t12 || $[112] !== t13 || $[113] !== t14 || $[114] !== t15 || $[115] !== t16 || $[116] !== t17 || $[117] !== t18 || $[118] !== t49 ? (t50 = /* @__PURE__ */ jsx(T3, { __unstable_focusRing: t10, as: t11, "data-as": t12, flex: t13, onClick: t14, padding: t15, radius: t16, tabIndex: t17, tone: t18, children: t49 }), $[108] = T3, $[109] = t10, $[110] = t11, $[111] = t12, $[112] = t13, $[113] = t14, $[114] = t15, $[115] = t16, $[116] = t17, $[117] = t18, $[118] = t49, $[119] = t50) : t50 = $[119];
  let t51;
  $[120] !== T4 || $[121] !== t19 || $[122] !== t20 || $[123] !== t21 || $[124] !== t22 || $[125] !== t50 ? (t51 = /* @__PURE__ */ jsx(T4, { delay: t19, placement: t20, content: t21, disabled: t22, children: t50 }), $[120] = T4, $[121] = t19, $[122] = t20, $[123] = t21, $[124] = t22, $[125] = t50, $[126] = t51) : t51 = $[126];
  let t52;
  $[127] === Symbol.for("react.memo_cache_sentinel") ? (t52 = {
    width: "38px"
  }, $[127] = t52) : t52 = $[127];
  let t53;
  $[128] !== hasError || $[129] !== publishedDocumentId || $[130] !== schedule || $[131] !== schemaType || $[132] !== validation2 ? (t53 = schedule.state === "scheduled" && /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(ValidateScheduleDoc, { schedule, updateValidation: setValidationStatus }),
    /* @__PURE__ */ jsx(ValidationInfo, { markers: validation2, type: schemaType, documentId: publishedDocumentId, menuHeader: /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: hasError ? DOCUMENT_HAS_ERRORS_TEXT : DOCUMENT_HAS_WARNINGS_TEXT }) }) })
  ] }), $[128] = hasError, $[129] = publishedDocumentId, $[130] = schedule, $[131] = schemaType, $[132] = validation2, $[133] = t53) : t53 = $[133];
  let t54;
  $[134] !== schedule.state || $[135] !== schedule.stateReason ? (t54 = schedule.state === "cancelled" && /* @__PURE__ */ jsx(StateReasonFailedInfo, { stateReason: schedule.stateReason }), $[134] = schedule.state, $[135] = schedule.stateReason, $[136] = t54) : t54 = $[136];
  let t55;
  $[137] !== t53 || $[138] !== t54 ? (t55 = /* @__PURE__ */ jsxs(Flex, { justify: "center", style: t52, children: [
    t53,
    t54
  ] }), $[137] = t53, $[138] = t54, $[139] = t55) : t55 = $[139];
  let t56;
  $[140] !== schedule.state || $[141] !== schedule.stateReason ? (t56 = schedule.state === "cancelled" && /* @__PURE__ */ jsx(StateReasonFailedInfo, { stateReason: schedule.stateReason }), $[140] = schedule.state, $[141] = schedule.stateReason, $[142] = t56) : t56 = $[142];
  let t57;
  $[143] !== contextMenu ? (t57 = contextMenu && /* @__PURE__ */ jsx(Box, { style: {
    flexShrink: 0
  }, paddingRight: 2, children: contextMenu }), $[143] = contextMenu, $[144] = t57) : t57 = $[144];
  let t58;
  $[145] !== T5 || $[146] !== t23 || $[147] !== t24 || $[148] !== t25 || $[149] !== t51 || $[150] !== t55 || $[151] !== t56 || $[152] !== t57 ? (t58 = /* @__PURE__ */ jsxs(T5, { align: t23, gap: t24, justify: t25, children: [
    t51,
    t55,
    t56,
    t57
  ] }), $[145] = T5, $[146] = t23, $[147] = t24, $[148] = t25, $[149] = t51, $[150] = t55, $[151] = t56, $[152] = t57, $[153] = t58) : t58 = $[153];
  let t59;
  return $[154] !== T6 || $[155] !== t26 || $[156] !== t27 || $[157] !== t28 || $[158] !== t29 || $[159] !== t30 || $[160] !== t58 ? (t59 = /* @__PURE__ */ jsx(T6, { padding: t26, radius: t27, shadow: t28, tone: t29, style: t30, children: t58 }), $[154] = T6, $[155] = t26, $[156] = t27, $[157] = t28, $[158] = t29, $[159] = t30, $[160] = t58, $[161] = t59) : t59 = $[161], t59;
};
function DocumentVersionsStatus(t0) {
  const $ = c(3), {
    publishedDocumentId
  } = t0, versionsInfo = useDocumentVersionInfo(publishedDocumentId);
  let t1;
  return $[0] !== versionsInfo.draft || $[1] !== versionsInfo.published ? (t1 = /* @__PURE__ */ jsx(DocumentStatusIndicator, { draft: versionsInfo.draft, published: versionsInfo.published }), $[0] = versionsInfo.draft, $[1] = versionsInfo.published, $[2] = t1) : t1 = $[2], t1;
}
const DocumentPreview$1 = (props2) => {
  const $ = c(20), {
    schedule,
    schemaType
  } = props2, {
    DialogScheduleEdit: DialogScheduleEdit2,
    dialogProps,
    dialogScheduleEditShow
  } = useDialogScheduleEdit(schedule), {
    onComplete
  } = useDocumentActionProps();
  let t0, t1;
  $[0] !== schedule ? (t1 = getScheduledDocumentId(schedule), $[0] = schedule, $[1] = t1) : t1 = $[1], t0 = t1;
  const publishedId = t0;
  let t2;
  $[2] !== DialogScheduleEdit2 || $[3] !== dialogProps ? (t2 = DialogScheduleEdit2 && /* @__PURE__ */ jsx(DialogScheduleEdit2, { ...dialogProps }), $[2] = DialogScheduleEdit2, $[3] = dialogProps, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    delete: !0,
    edit: !0
  }, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== dialogScheduleEditShow || $[7] !== onComplete || $[8] !== schedule || $[9] !== schemaType ? (t4 = /* @__PURE__ */ jsx(ScheduleContextMenu, { actions: t3, onDelete: onComplete, onEdit: dialogScheduleEditShow, schedule, schemaType }), $[6] = dialogScheduleEditShow, $[7] = onComplete, $[8] = schedule, $[9] = schemaType, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== dialogScheduleEditShow || $[12] !== publishedId || $[13] !== schedule || $[14] !== schemaType || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(PreviewWrapper, { contextMenu: t4, onClick: dialogScheduleEditShow, publishedDocumentId: publishedId, schedule, schemaType }), $[11] = dialogScheduleEditShow, $[12] = publishedId, $[13] = schedule, $[14] = schemaType, $[15] = t4, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== t2 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t2,
    t5
  ] }), $[17] = t2, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}, FallbackContextMenu = (props2) => {
  const $ = c(10), {
    onDelete,
    schedule
  } = props2, {
    deleteSchedule
  } = useScheduleOperation();
  let t0;
  $[0] !== deleteSchedule || $[1] !== onDelete || $[2] !== schedule ? (t0 = () => {
    deleteSchedule({
      schedule
    }).then(() => onDelete?.());
  }, $[0] = deleteSchedule, $[1] = onDelete, $[2] = schedule, $[3] = t0) : t0 = $[3];
  const handleDelete = t0;
  let t1;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== handleDelete ? (t2 = /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsx(MenuItem$1, { icon: TrashIcon, onClick: handleDelete, text: "Delete schedule", tone: "critical" }) }), $[5] = handleDelete, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    portal: !0,
    tone: "default"
  }, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== t2 ? (t4 = /* @__PURE__ */ jsx(MenuButton$1, { button: t1, id: "contextMenu", menu: t2, placement: "left", popover: t3 }), $[8] = t2, $[9] = t4) : t4 = $[9], t4;
}, NoSchemaItem = (t0) => {
  const $ = c(6), {
    schedule
  } = t0;
  let t1;
  $[0] !== schedule ? (t1 = /* @__PURE__ */ jsx(FallbackContextMenu, { schedule }), $[0] = schedule, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(SanityDefaultPreview, { icon: UnknownIcon, layout: "default", subtitle: /* @__PURE__ */ jsx("em", { children: "It may have been deleted" }), title: /* @__PURE__ */ jsx("em", { style: {
    color: red[600].hex
  }, children: "Document not found" }) }), $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== schedule || $[4] !== t1 ? (t3 = /* @__PURE__ */ jsx(PreviewWrapper, { contextMenu: t1, schedule, useElementQueries: !0, children: t2 }), $[3] = schedule, $[4] = t1, $[5] = t3) : t3 = $[5], t3;
}, ToolPreview = (props2) => {
  const $ = c(30), {
    previewState,
    schedule,
    schemaType
  } = props2, visibleDocument = previewState.draft || previewState.published, isCompleted = schedule.state === "succeeded", isScheduled = schedule.state === "scheduled", {
    DialogScheduleEdit: DialogScheduleEdit2,
    dialogProps,
    dialogScheduleEditShow
  } = useDialogScheduleEdit(schedule), publishedId = usePublishedId(visibleDocument?._id);
  let t0, Component2;
  $[0] !== schemaType || $[1] !== visibleDocument ? (Component2 = forwardRef((linkProps, ref) => /* @__PURE__ */ jsx(IntentLink, { ...linkProps, intent: "edit", params: {
    type: schemaType.name,
    id: visibleDocument && getPublishedId(visibleDocument?._id)
  }, ref })), Component2.displayName = "ForwardRef(LinkComponent)", $[0] = schemaType, $[1] = visibleDocument, $[2] = Component2) : Component2 = $[2], t0 = Component2;
  const LinkComponent2 = t0;
  let t1;
  $[3] !== DialogScheduleEdit2 || $[4] !== dialogProps ? (t1 = DialogScheduleEdit2 && /* @__PURE__ */ jsx(DialogScheduleEdit2, { ...dialogProps }), $[3] = DialogScheduleEdit2, $[4] = dialogProps, $[5] = t1) : t1 = $[5];
  const t2 = !isCompleted;
  let t3;
  $[6] !== isCompleted || $[7] !== isScheduled || $[8] !== t2 ? (t3 = {
    clear: isCompleted,
    delete: t2,
    edit: isScheduled,
    execute: isScheduled
  }, $[6] = isCompleted, $[7] = isScheduled, $[8] = t2, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== dialogScheduleEditShow || $[11] !== schedule || $[12] !== schemaType || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(ScheduleContextMenu, { actions: t3, onEdit: dialogScheduleEditShow, schedule, schemaType }), $[10] = dialogScheduleEditShow, $[11] = schedule, $[12] = schemaType, $[13] = t3, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== previewState.isLoading || $[16] !== schemaType || $[17] !== visibleDocument ? (t5 = previewState.isLoading ? /* @__PURE__ */ jsx(SanityDefaultPreview, { icon: schemaType?.icon, isPlaceholder: previewState.isLoading, layout: "default" }) : /* @__PURE__ */ jsx(Preview$1, { layout: "default", schemaType, value: visibleDocument }), $[15] = previewState.isLoading, $[16] = schemaType, $[17] = visibleDocument, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== LinkComponent2 || $[20] !== previewState || $[21] !== publishedId || $[22] !== schedule || $[23] !== schemaType || $[24] !== t4 || $[25] !== t5 ? (t6 = /* @__PURE__ */ jsx(PreviewWrapper, { contextMenu: t4, linkComponent: LinkComponent2, previewState, publishedDocumentId: publishedId, schedule, schemaType, useElementQueries: !0, children: t5 }), $[19] = LinkComponent2, $[20] = previewState, $[21] = publishedId, $[22] = schedule, $[23] = schemaType, $[24] = t4, $[25] = t5, $[26] = t6) : t6 = $[26];
  let t7;
  return $[27] !== t1 || $[28] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t1,
    t6
  ] }), $[27] = t1, $[28] = t6, $[29] = t7) : t7 = $[29], t7;
}, ScheduleItem = (props2) => {
  const $ = c(13), {
    schedule,
    type
  } = props2;
  let t0;
  $[0] !== schedule ? (t0 = getScheduledDocument(schedule), $[0] = schedule, $[1] = t0) : t0 = $[1];
  const firstDocument = t0, schemaType = useScheduleSchemaType(schedule), previewState = usePreviewState(firstDocument?.documentId, schemaType), invalidDocument = !(previewState.draft || previewState.published) && !previewState.isLoading;
  let t1;
  bb0: {
    if (!schemaType || invalidDocument) {
      let t22;
      $[2] !== schedule ? (t22 = /* @__PURE__ */ jsx(NoSchemaItem, { schedule }), $[2] = schedule, $[3] = t22) : t22 = $[3], t1 = t22;
      break bb0;
    }
    if (type === "document") {
      let t22;
      $[4] !== schedule || $[5] !== schemaType ? (t22 = /* @__PURE__ */ jsx(DocumentPreview$1, { schedule, schemaType }), $[4] = schedule, $[5] = schemaType, $[6] = t22) : t22 = $[6], t1 = t22;
      break bb0;
    }
    if (type === "tool") {
      let t22;
      $[7] !== previewState || $[8] !== schedule || $[9] !== schemaType ? (t22 = /* @__PURE__ */ jsx(ToolPreview, { previewState, schedule, schemaType }), $[7] = previewState, $[8] = schedule, $[9] = schemaType, $[10] = t22) : t22 = $[10], t1 = t22;
      break bb0;
    }
    t1 = null;
  }
  const preview = t1;
  let t2;
  return $[11] !== preview ? (t2 = /* @__PURE__ */ jsx(DateWithTooltipElementQuery, { children: preview }), $[11] = preview, $[12] = t2) : t2 = $[12], t2;
}, SCHEDULE_RENDER_DELAY_MS = 200;
function VirtualListItem(props2) {
  const {
    item: {
      content,
      virtualRow
    },
    measureElement
  } = props2, style = useMemo(() => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    transform: `translateY(${virtualRow.start}px)`
  }), [virtualRow]);
  return /* @__PURE__ */ jsx(Box, { "data-index": virtualRow.index, paddingBottom: 2, ref: measureElement, style, children: typeof content == "string" ? /* @__PURE__ */ jsx(MonthHeading, { content }) : /* @__PURE__ */ jsx(DelayedScheduleItem, { schedule: content }) }, virtualRow.key);
}
function DelayedScheduleItem({
  schedule
}) {
  const [delayedScheduleItem, setDelayedScheduleItem] = useState(/* @__PURE__ */ jsx(PlaceholderScheduleItem, {}));
  return useEffect(() => {
    let canUpdate = !0;
    const timeout2 = setTimeout(() => {
      canUpdate && setDelayedScheduleItem(/* @__PURE__ */ jsx(ScheduleItem, { schedule, type: "tool" }));
    }, SCHEDULE_RENDER_DELAY_MS);
    return () => {
      canUpdate = !1, clearTimeout(timeout2);
    };
  }, [schedule]), delayedScheduleItem;
}
function MonthHeading({
  content
}) {
  return /* @__PURE__ */ jsx(Flex, { align: "flex-end", paddingBottom: 2, paddingTop: 4, children: /* @__PURE__ */ jsx(Label, { muted: !0, size: 1, children: content }) });
}
function PlaceholderScheduleItem() {
  return /* @__PURE__ */ jsx(Card, { padding: 1, radius: 2, shadow: 1, children: /* @__PURE__ */ jsx(Card, { padding: 1, children: /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0 }) }) });
}
function getLocalizedDate(date) {
  return new Date(date).toLocaleString("default", {
    month: "long",
    year: "numeric"
  });
}
const VirtualList = () => {
  const {
    activeSchedules,
    scheduleState,
    sortBy: sortBy2
  } = useSchedules(), {
    measureElement,
    virtualList,
    totalSize,
    containerRef
  } = useVirtualizedSchedules(activeSchedules, sortBy2), {
    deleteSchedules
  } = useScheduleOperation(), handleClearSchedules = () => {
    deleteSchedules({
      schedules: activeSchedules || []
    });
  };
  return useEffect(() => {
    containerRef?.current?.scrollTo(0, 0);
  }, [scheduleState, sortBy2, containerRef]), /* @__PURE__ */ jsxs(Box, { paddingBottom: 6, paddingTop: 1, paddingX: 4, ref: containerRef, overflow: "hidden", children: [
    /* @__PURE__ */ jsx(Box, { style: {
      height: `${totalSize}px`,
      width: "100%",
      position: "relative"
    }, children: virtualList.map((item) => /* @__PURE__ */ jsx(VirtualListItem, { item, measureElement }, item.key)) }),
    scheduleState === "succeeded" && /* @__PURE__ */ jsx(Flex, { justify: "center", marginTop: 6, children: /* @__PURE__ */ jsx(Button, { icon: CheckmarkCircleIcon, mode: "ghost", onClick: handleClearSchedules, text: "Clear all completed schedules" }) })
  ] });
};
function useVirtualizedSchedules(activeSchedules, sortBy2) {
  const containerRef = useRef(null), listSourceItems = useMemo(() => {
    const items = [];
    return activeSchedules.forEach((schedule, index) => {
      if (sortBy2 == "executeAt") {
        const previousSchedule = activeSchedules[index - 1], previousExecuteDate = getLastExecuteDate(previousSchedule), datePrevious = index > 0 && previousExecuteDate ? getLocalizedDate(previousExecuteDate) : null, currentExecuteDate = getLastExecuteDate(schedule), dateCurrent = currentExecuteDate ? getLocalizedDate(currentExecuteDate) : null;
        dateCurrent !== datePrevious && items.push(dateCurrent || "No date specified");
      }
      items.push(schedule);
    }), items;
  }, [activeSchedules, sortBy2]), virtualizer = useVirtualizer({
    count: listSourceItems.length,
    getScrollElement: () => containerRef.current,
    estimateSize: () => 50,
    overscan: 5
  }), virtualList = virtualizer.getVirtualItems().map((virtualRow) => {
    const item = listSourceItems[virtualRow.index];
    return {
      content: item,
      key: typeof item == "string" ? item : item.id,
      virtualRow
    };
  });
  return {
    containerRef,
    measureElement: virtualizer.measureElement,
    totalSize: virtualizer.getTotalSize(),
    virtualList
  };
}
const Panel = styled(Container$2)`
  width: auto;
`, Schedules$1 = () => {
  const $ = c(13), {
    activeSchedules,
    selectedDate,
    scheduleState
  } = useSchedules(), {
    upsellData,
    telemetryLogs
  } = useSchedulePublishingUpsell(), {
    mode
  } = useScheduledPublishingEnabled(), showWarning = mode === "upsell" && scheduleState === "scheduled";
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    height: "100%"
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== mode || $[2] !== telemetryLogs || $[3] !== upsellData ? (t1 = mode === "upsell" && upsellData && /* @__PURE__ */ jsx(Panel, { width: 1, padding: 4, paddingBottom: 1, children: /* @__PURE__ */ jsx(UpsellPanel, { layout: "horizontal", data: upsellData, onPrimaryClick: telemetryLogs.panelPrimaryClicked, onSecondaryClick: telemetryLogs.panelSecondaryClicked }) }), $[1] = mode, $[2] = telemetryLogs, $[3] = upsellData, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== activeSchedules.length || $[6] !== scheduleState || $[7] !== selectedDate || $[8] !== showWarning ? (t2 = activeSchedules.length === 0 ? /* @__PURE__ */ jsx(Panel, { width: 1, padding: 4, paddingTop: 4, children: /* @__PURE__ */ jsx(EmptySchedules, { scheduleState, selectedDate }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    showWarning && /* @__PURE__ */ jsx(Card, { margin: 4, marginBottom: 2, padding: 3, tone: "caution", radius: 3, shadow: 1, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", children: [
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }),
      /* @__PURE__ */ jsx(Text$1, { size: 1, children: "Your scheduled documents won't be published automatically unless you upgrade your plan. You can still publish them manually." })
    ] }) }),
    /* @__PURE__ */ jsx(Box, { paddingTop: showWarning ? 0 : 4, children: /* @__PURE__ */ jsx(VirtualList, {}) })
  ] }), $[5] = activeSchedules.length, $[6] = scheduleState, $[7] = selectedDate, $[8] = showWarning, $[9] = t2) : t2 = $[9];
  let t3;
  return $[10] !== t1 || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Box, { style: t0, children: [
    t1,
    t2
  ] }), $[10] = t1, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}, SchedulesContextMenu = () => {
  const $ = c(15), {
    setSortBy,
    sortBy: sortBy2
  } = useSchedules();
  let t0;
  $[0] !== setSortBy ? (t0 = () => setSortBy("createdAt"), $[0] = setSortBy, $[1] = t0) : t0 = $[1];
  const handleSortByCreateAt = t0;
  let t1;
  $[2] !== setSortBy ? (t1 = () => setSortBy("executeAt"), $[2] = setSortBy, $[3] = t1) : t1 = $[3];
  const handleSortByExecuteAt = t1;
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[4] = t2) : t2 = $[4];
  let t3;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    minWidth: "250px"
  }, $[5] = t3) : t3 = $[5];
  const t4 = sortBy2 === "createdAt" ? CheckmarkIcon : void 0;
  let t5;
  $[6] !== handleSortByCreateAt || $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuItem$1, { icon: SortIcon, iconRight: t4, onClick: handleSortByCreateAt, text: "Sort by time added" }), $[6] = handleSortByCreateAt, $[7] = t4, $[8] = t5) : t5 = $[8];
  const t6 = sortBy2 === "executeAt" ? CheckmarkIcon : void 0;
  let t7;
  $[9] !== handleSortByExecuteAt || $[10] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuItem$1, { icon: SortIcon, iconRight: t6, onClick: handleSortByExecuteAt, text: "Sort by time scheduled" }), $[9] = handleSortByExecuteAt, $[10] = t6, $[11] = t7) : t7 = $[11];
  let t8;
  return $[12] !== t5 || $[13] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuButton$1, { button: t2, id: "sort", menu: /* @__PURE__ */ jsxs(Menu, { style: t3, children: [
    t5,
    t7
  ] }) }), $[12] = t5, $[13] = t7, $[14] = t8) : t8 = $[14], t8;
}, Pip = (props2) => {
  const $ = c(8), {
    mode: t0,
    selected
  } = props2, mode = t0 === void 0 ? "default" : t0;
  let t1;
  $[0] !== mode || $[1] !== selected ? (t1 = mode === "default" ? {
    background: gray[selected ? 100 : 300].hex
  } : {}, $[0] = mode, $[1] = selected, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== mode ? (t2 = mode === "failed" ? {
    background: red[500].hex
  } : {}, $[3] = mode, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== t1 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { style: {
    ...t1,
    ...t2,
    borderRadius: "2px",
    height: "2px",
    width: "100%"
  } }), $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
};
function CalendarDay(props2) {
  const {
    date,
    focused,
    isCurrentMonth,
    isToday: isToday2,
    onSelect,
    selected
  } = props2, {
    schedulesByDate
  } = useSchedules(), schedules = schedulesByDate(date), handleClick = useCallback(() => {
    onSelect(selected ? void 0 : date);
  }, [date, onSelect, selected]);
  let tone;
  isToday2 || selected ? tone = "primary" : (isWeekend(date), tone = "default");
  const hasSchedules = schedules.length > 0, {
    completed,
    failed,
    upcoming
  } = useMemo(() => ({
    completed: schedules.filter((s) => s.state === "succeeded"),
    failed: schedules.filter((s_0) => s_0.state === "cancelled"),
    upcoming: schedules.filter((s_1) => s_1.state === "scheduled")
  }), [schedules]);
  return /* @__PURE__ */ jsx("div", { "aria-selected": selected, "data-ui": "CalendarDay", children: /* @__PURE__ */ jsx(Tooltip, { content: /* @__PURE__ */ jsx(TooltipContent, { date, schedules }), disabled: !hasSchedules, portal: !0, children: /* @__PURE__ */ jsxs(Card, { "aria-label": date.toDateString(), "aria-pressed": selected, as: "button", __unstable_focusRing: !0, "data-weekday": !0, "data-focused": focused ? "true" : "", role: "button", tabIndex: -1, onClick: handleClick, paddingX: 3, paddingY: 4, radius: 2, selected, style: {
    position: "relative"
  }, tone, children: [
    /* @__PURE__ */ jsx(Text$1, { size: 1, style: {
      opacity: !selected && !isCurrentMonth ? 0.35 : 1,
      textAlign: "center"
    }, children: selected ? /* @__PURE__ */ jsx(CloseIcon, {}) : date.getDate() }),
    /* @__PURE__ */ jsx(Box, { style: {
      bottom: 2,
      left: 2,
      position: "absolute",
      right: 2
    }, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, justify: "center", children: [
      completed.length > 0 && /* @__PURE__ */ jsx(Pip, { selected }),
      upcoming.length > 0 && /* @__PURE__ */ jsx(Pip, { selected }),
      failed.length > 0 && /* @__PURE__ */ jsx(Pip, { mode: "failed", selected })
    ] }) })
  ] }) }) });
}
function TooltipContent(props2) {
  const $ = c(24), {
    date,
    schedules: t0
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const schedules = t1, {
    formatDateTz
  } = useTimeZone();
  let T0, T1, t2, t3, t4, t5;
  if ($[2] !== date || $[3] !== formatDateTz || $[4] !== schedules) {
    const schedulesByState = schedules.reduce(_temp4$1, {
      cancelled: [],
      succeeded: [],
      scheduled: []
    });
    T1 = Box, t4 = 3;
    let t62;
    $[11] !== date ? (t62 = format$2(date, "d MMMM yyyy"), $[11] = date, $[12] = t62) : t62 = $[12], $[13] !== t62 ? (t5 = /* @__PURE__ */ jsx(Box, { marginBottom: 4, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: t62 }) }), $[13] = t62, $[14] = t5) : t5 = $[14], T0 = Stack, t2 = 3, t3 = Object.keys(schedulesByState).map((key) => {
      const stateSchedules = schedulesByState[key];
      return stateSchedules.length === 0 ? null : /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
        /* @__PURE__ */ jsx(Label, { muted: !0, size: 0, children: SCHEDULE_STATE_DICTIONARY[key].title }),
        /* @__PURE__ */ jsx(Stack, { space: 1, children: stateSchedules.filter(_temp5).map((schedule_0) => {
          const executeDate = getLastExecuteDate(schedule_0);
          return executeDate ? /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
            /* @__PURE__ */ jsx(Box, { style: {
              width: "60px"
            }, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "regular", children: formatDateTz({
              date: new Date(executeDate),
              format: "p"
            }) }) }),
            /* @__PURE__ */ jsx(Flex, { align: "center", style: {
              flexShrink: 0,
              opacity: schedule_0.action === "unpublish" ? 1 : 0
            }, children: /* @__PURE__ */ jsx(Badge, { fontSize: 0, mode: "outline", tone: SCHEDULE_ACTION_DICTIONARY[schedule_0.action].badgeTone, children: schedule_0.action }) })
          ] }, schedule_0.id) : null;
        }) })
      ] }, key);
    }), $[2] = date, $[3] = formatDateTz, $[4] = schedules, $[5] = T0, $[6] = T1, $[7] = t2, $[8] = t3, $[9] = t4, $[10] = t5;
  } else
    T0 = $[5], T1 = $[6], t2 = $[7], t3 = $[8], t4 = $[9], t5 = $[10];
  let t6;
  $[15] !== T0 || $[16] !== t2 || $[17] !== t3 ? (t6 = /* @__PURE__ */ jsx(T0, { space: t2, children: t3 }), $[15] = T0, $[16] = t2, $[17] = t3, $[18] = t6) : t6 = $[18];
  let t7;
  return $[19] !== T1 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsxs(T1, { padding: t4, children: [
    t5,
    t6
  ] }), $[19] = T1, $[20] = t4, $[21] = t5, $[22] = t6, $[23] = t7) : t7 = $[23], t7;
}
function _temp5(schedule) {
  return schedule.executeAt;
}
function _temp4$1(acc, val) {
  return acc[val.state].push(val), acc;
}
const ToolCalendar = (props2) => {
  const $ = c(10), {
    onSelect,
    selectedDate
  } = props2, {
    getCurrentZoneDate,
    utcToCurrentZoneDate
  } = useTimeZone();
  let t0;
  $[0] !== getCurrentZoneDate || $[1] !== selectedDate ? (t0 = selectedDate || getCurrentZoneDate(), $[0] = getCurrentZoneDate, $[1] = selectedDate, $[2] = t0) : t0 = $[2];
  const [focusedDate, setFocusedDate] = useState(t0);
  let t1;
  $[3] !== utcToCurrentZoneDate ? (t1 = (date) => {
    setFocusedDate(utcToCurrentZoneDate(date));
  }, $[3] = utcToCurrentZoneDate, $[4] = t1) : t1 = $[4];
  const handleFocusDateChange = t1;
  let t2;
  return $[5] !== focusedDate || $[6] !== handleFocusDateChange || $[7] !== onSelect || $[8] !== selectedDate ? (t2 = /* @__PURE__ */ jsx(CalendarFilter, { focusedDate, onFocusedDateChange: handleFocusDateChange, onSelect, selectedDate, renderCalendarDay: CalendarDay }), $[5] = focusedDate, $[6] = handleFocusDateChange, $[7] = onSelect, $[8] = selectedDate, $[9] = t2) : t2 = $[9], t2;
}, Column = styled(Box)`
  flex-direction: column;
  &:not(:last-child) {
    border-right: 1px solid var(--card-border-color);
  }
`, NO_SCHEDULE = [], DATE_SLUG_FORMAT = "yyyy-MM-dd";
function Tool() {
  const $ = c(54), router = useRouter(), {
    scheduledPublishing: scheduledPublishing2
  } = useWorkspace(), releasesToolAvailable2 = useReleasesToolAvailable(), {
    sanity: theme
  } = useTheme(), {
    error,
    isInitialLoading,
    schedules: t0
  } = usePollSchedules(), schedules = t0 === void 0 ? NO_SCHEDULE : t0, {
    enabled,
    hasUsedScheduledPublishing
  } = useScheduledPublishingEnabled(), lastScheduleState = useRef(void 0), scheduleState = router.state.state;
  let t1;
  $[0] !== router.state.date ? (t1 = router.state.date ? parse(router.state.date, DATE_SLUG_FORMAT, /* @__PURE__ */ new Date()) : void 0, $[0] = router.state.date, $[1] = t1) : t1 = $[1];
  const selectedDate = t1;
  let t2, t3;
  $[2] !== router.state.state ? (t2 = () => {
    router.state.state && (lastScheduleState.current = router.state.state);
  }, t3 = [router.state.state], $[2] = router.state.state, $[3] = t2, $[4] = t3) : (t2 = $[3], t3 = $[4]), useEffect(t2, t3), useFallbackNavigation(router, scheduleState, selectedDate);
  const {
    formatDateTz
  } = useTimeZone();
  let t4, t5;
  $[5] !== scheduleState || $[6] !== schedules || $[7] !== selectedDate ? (t5 = {
    schedules,
    scheduleState,
    selectedDate
  }, $[5] = scheduleState, $[6] = schedules, $[7] = selectedDate, $[8] = t5) : t5 = $[8], t4 = t5;
  const schedulesContext = t4;
  let t6;
  $[9] !== router ? (t6 = () => {
    router.navigate({
      state: lastScheduleState?.current || SCHEDULE_FILTERS[0]
    });
  }, $[9] = router, $[10] = t6) : t6 = $[10];
  const handleClearDate = t6;
  let t7;
  $[11] !== formatDateTz || $[12] !== router ? (t7 = (date) => {
    date ? router.navigate({
      date: formatDateTz({
        date,
        format: DATE_SLUG_FORMAT
      })
    }) : router.navigate({
      state: lastScheduleState?.current || SCHEDULE_FILTERS[0]
    });
  }, $[11] = formatDateTz, $[12] = router, $[13] = t7) : t7 = $[13];
  const handleSelectDate = t7;
  if (!enabled) {
    if (scheduledPublishing2.__internal__workspaceEnabled) {
      let t83;
      return $[14] === Symbol.for("react.memo_cache_sentinel") ? (t83 = /* @__PURE__ */ jsx(Container$2, { width: 1, paddingTop: 4, children: /* @__PURE__ */ jsx(Box, { paddingTop: 4, paddingX: 4, children: /* @__PURE__ */ jsx(ErrorCallout, { description: "Something went wrong loading permissions, please try again.", title: "Permissions check failed" }) }) }), $[14] = t83) : t83 = $[14], t83;
    }
    let t82;
    return $[15] !== hasUsedScheduledPublishing.loading ? (t82 = /* @__PURE__ */ jsx(Container$2, { width: 1, paddingTop: 4, children: /* @__PURE__ */ jsx(Box, { paddingTop: 4, paddingX: 4, children: hasUsedScheduledPublishing.loading ? /* @__PURE__ */ jsx(LoadingBlock, {}) : /* @__PURE__ */ jsx(InfoCallout, {}) }) }), $[15] = hasUsedScheduledPublishing.loading, $[16] = t82) : t82 = $[16], t82;
  }
  let t8;
  $[17] !== releasesToolAvailable2 || $[18] !== scheduledPublishing2 ? (t8 = releasesToolAvailable2 && scheduledPublishing2.showReleasesBanner && /* @__PURE__ */ jsx(WarningBanner, {}), $[17] = releasesToolAvailable2, $[18] = scheduledPublishing2, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t9 = ["none", null, null, "flex"], $[20] = t9) : t9 = $[20];
  let t10;
  $[21] === Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    position: "sticky",
    top: 0,
    width: "350px"
  }, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== handleSelectDate || $[23] !== selectedDate ? (t11 = /* @__PURE__ */ jsx(Column, { display: t9, style: t10, children: /* @__PURE__ */ jsx(ToolCalendar, { onSelect: handleSelectDate, selectedDate }) }), $[22] = handleSelectDate, $[23] = selectedDate, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== theme.color.card.enabled.bg ? (t12 = {
    background: theme.color.card.enabled.bg,
    position: "sticky",
    top: 0,
    zIndex: 1
  }, $[25] = theme.color.card.enabled.bg, $[26] = t12) : t12 = $[26];
  let t13;
  $[27] === Symbol.for("react.memo_cache_sentinel") ? (t13 = {
    borderBottom: "1px solid var(--card-border-color)",
    minHeight: `${TOOL_HEADER_HEIGHT}px`
  }, $[27] = t13) : t13 = $[27];
  let t14;
  $[28] !== handleClearDate || $[29] !== selectedDate ? (t14 = /* @__PURE__ */ jsx(ScheduleFilters, { onClearDate: handleClearDate, selectedDate }), $[28] = handleClearDate, $[29] = selectedDate, $[30] = t14) : t14 = $[30];
  let t15;
  $[31] === Symbol.for("react.memo_cache_sentinel") ? (t15 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    /* @__PURE__ */ jsx(ButtonTimeZone, { useElementQueries: !0 }),
    /* @__PURE__ */ jsx(SchedulesContextMenu, {})
  ] }), $[31] = t15) : t15 = $[31];
  let t16;
  $[32] !== t14 ? (t16 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingLeft: 4, paddingRight: 3, style: t13, children: /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, justify: "space-between", children: [
    t14,
    t15
  ] }) }), $[32] = t14, $[33] = t16) : t16 = $[33];
  let t17;
  $[34] !== t12 || $[35] !== t16 ? (t17 = /* @__PURE__ */ jsx(ButtonTimeZoneElementQuery, { style: t12, children: t16 }), $[34] = t12, $[35] = t16, $[36] = t17) : t17 = $[36];
  let t18;
  $[37] !== error ? (t18 = error && /* @__PURE__ */ jsx(Box, { paddingTop: 4, paddingX: 4, children: /* @__PURE__ */ jsx(ErrorCallout, { description: "More information in the developer console.", title: "Something went wrong, unable to retrieve schedules." }) }), $[37] = error, $[38] = t18) : t18 = $[38];
  let t19;
  $[39] !== isInitialLoading ? (t19 = /* @__PURE__ */ jsx(Box, { flex: 1, overflow: "auto", children: isInitialLoading ? /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, children: "Loading..." }) }) : /* @__PURE__ */ jsx(Schedules$1, {}) }), $[39] = isInitialLoading, $[40] = t19) : t19 = $[40];
  let t20;
  $[41] !== t18 || $[42] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, children: [
    t18,
    t19
  ] }), $[41] = t18, $[42] = t19, $[43] = t20) : t20 = $[43];
  let t21;
  $[44] !== t17 || $[45] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Column, { display: "flex", flex: 1, overflow: "hidden", children: [
    t17,
    t20
  ] }), $[44] = t17, $[45] = t20, $[46] = t21) : t21 = $[46];
  let t22;
  $[47] !== t11 || $[48] !== t21 ? (t22 = /* @__PURE__ */ jsx(Flex, { direction: "column", height: "fill", flex: 1, overflow: "hidden", children: /* @__PURE__ */ jsxs(Flex, { flex: 1, height: "fill", children: [
    t11,
    t21
  ] }) }), $[47] = t11, $[48] = t21, $[49] = t22) : t22 = $[49];
  let t23;
  return $[50] !== schedulesContext || $[51] !== t22 || $[52] !== t8 ? (t23 = /* @__PURE__ */ jsxs(SchedulesProvider, { value: schedulesContext, children: [
    t8,
    t22
  ] }), $[50] = schedulesContext, $[51] = t22, $[52] = t8, $[53] = t23) : t23 = $[53], t23;
}
function useFallbackNavigation(router, filter2, selectedDate) {
  const $ = c(5);
  let t0, t1;
  $[0] !== filter2 || $[1] !== router || $[2] !== selectedDate ? (t0 = () => {
    !filter2 && !selectedDate && router.navigate({
      state: SCHEDULE_FILTERS[0]
    }, {
      replace: !0
    });
  }, t1 = [selectedDate, router, filter2], $[0] = filter2, $[1] = router, $[2] = selectedDate, $[3] = t0, $[4] = t1) : (t0 = $[3], t1 = $[4]), useEffect(t0, t1);
}
const DialogFooter = (props2) => {
  const $ = c(11), {
    buttonText: t0,
    disabled,
    icon,
    onAction,
    onComplete,
    tone: t1
  } = props2, buttonText = t0 === void 0 ? "Action" : t0, tone = t1 === void 0 ? "positive" : t1;
  let t2;
  $[0] !== onComplete ? (t2 = /* @__PURE__ */ jsx(Button, { mode: "bleed", onClick: onComplete, text: "Cancel" }), $[0] = onComplete, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== buttonText || $[3] !== disabled || $[4] !== icon || $[5] !== onAction || $[6] !== tone ? (t3 = onAction && /* @__PURE__ */ jsx(Button, { disabled, icon, onClick: onAction, text: buttonText, tone }), $[2] = buttonText, $[3] = disabled, $[4] = icon, $[5] = onAction, $[6] = tone, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== t2 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { width: "full", gap: 3, justify: "flex-end", children: [
    t2,
    t3
  ] }), $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10], t4;
};
function NewScheduleInfo(t0) {
  const $ = c(5), {
    id: id2,
    schemaType
  } = t0;
  let t1, t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    "Schedule this document to be published at any time in the future.",
    /* @__PURE__ */ jsx("br", {}),
    "Any edits in the meantime will be added to the scheduled document."
  ] }), t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: "Visit the Schedules page to get an overview of all schedules." }), $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]);
  let t3;
  return $[2] !== id2 || $[3] !== schemaType ? (t3 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t1,
    t2,
    /* @__PURE__ */ jsx(ValidationWarning, { id: id2, type: schemaType })
  ] }), $[2] = id2, $[3] = schemaType, $[4] = t3) : t3 = $[4], t3;
}
function ValidationWarning(t0) {
  const $ = c(7), {
    id: id2,
    type
  } = t0, publishedId = usePublishedId(id2), schema2 = useSchemaType(type), validationStatus = useValidationStatus(publishedId, type), {
    hasError
  } = useValidationState(validationStatus.validation);
  if (!hasError)
    return null;
  let t1;
  $[0] !== publishedId || $[1] !== schema2 || $[2] !== validationStatus.validation ? (t1 = /* @__PURE__ */ jsx(ValidationInfo, { markers: validationStatus.validation, type: schema2, documentId: publishedId }), $[0] = publishedId, $[1] = schema2, $[2] = validationStatus.validation, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: DOCUMENT_HAS_ERRORS_TEXT }), $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== t1 ? (t3 = /* @__PURE__ */ jsx(Card, { padding: 2, radius: 1, shadow: 1, tone: "critical", children: /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t1,
    t2
  ] }) }), $[5] = t1, $[6] = t3) : t3 = $[6], t3;
}
const Schedules = (props2) => {
  const $ = c(2), {
    schedules
  } = props2;
  let t0;
  return $[0] !== schedules ? (t0 = /* @__PURE__ */ jsx(Stack, { space: 4, children: schedules.length === 0 ? /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: "No schedules" }) }) : /* @__PURE__ */ jsx(Stack, { space: 2, children: schedules.map(_temp$G) }) }), $[0] = schedules, $[1] = t0) : t0 = $[1], t0;
};
function _temp$G(schedule) {
  return /* @__PURE__ */ jsx(ScheduleItem, { schedule, type: "document" }, schedule.id);
}
const debug$1 = debugWithName$1("ScheduleAction"), ScheduleAction = (props2) => {
  const {
    draft,
    id: id2,
    liveEdit,
    onComplete,
    published,
    type
  } = props2, currentUser = useCurrentUser(), [permissions, isPermissionsLoading] = useDocumentPairPermissions({
    id: id2,
    type,
    permission: "publish"
  }), {
    createSchedule
  } = useScheduleOperation(), {
    enabled,
    mode
  } = useScheduledPublishingEnabled(), {
    handleOpenDialog
  } = useSchedulePublishingUpsell(), [dialogOpen, setDialogOpen] = useState(!1), {
    formData,
    onFormChange
  } = useScheduleForm(), {
    error: fetchError,
    isInitialLoading,
    schedules
  } = usePollSchedules({
    documentId: id2,
    state: "scheduled"
  });
  debug$1("schedules", schedules);
  const hasExistingSchedules = schedules && schedules.length > 0, documentExists = draft !== null || published !== null, insufficientPermissions = !isPermissionsLoading && !permissions?.granted, handleDialogOpen = useCallback(() => {
    mode === "upsell" ? handleOpenDialog("document_action") : setDialogOpen(!0);
  }, [mode, handleOpenDialog]), handleScheduleCreate = useCallback(() => {
    formData?.date && createSchedule({
      date: formData.date,
      documentId: id2
    }).then(onComplete);
  }, [onComplete, createSchedule, id2, formData?.date]), title = hasExistingSchedules ? "Edit Schedule" : "Schedule";
  if (insufficientPermissions)
    return {
      disabled: !0,
      icon: CalendarIcon,
      label: title,
      title: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "edit-schedules" })
    };
  let tooltip = "This document doesn't exist yet";
  documentExists && (tooltip = null), isInitialLoading && (tooltip = "Loading schedules"), liveEdit && (tooltip = "Live Edit is enabled for this content type and publishing happens automatically as you make changes");
  const dialog = {
    content: fetchError ? /* @__PURE__ */ jsx(ErrorCallout, { description: "More information in the developer console.", title: "Something went wrong, unable to retrieve schedules." }) : /* @__PURE__ */ jsx(DocumentActionPropsProvider, { value: props2, children: hasExistingSchedules ? /* @__PURE__ */ jsx(Schedules, { schedules }) : /* @__PURE__ */ jsx(EditScheduleForm, { onChange: onFormChange, value: formData, children: /* @__PURE__ */ jsx(NewScheduleInfo, { id: id2, schemaType: type }) }) }),
    footer: !hasExistingSchedules && /* @__PURE__ */ jsx(DialogFooter, { buttonText: "Schedule", disabled: !formData?.date, icon: ClockIcon, onAction: handleScheduleCreate, onComplete, tone: "primary" }),
    header: /* @__PURE__ */ jsx(DialogHeader$1, { title }),
    onClose: onComplete,
    type: "dialog"
  };
  return enabled ? {
    dialog: dialogOpen && dialog,
    disabled: isInitialLoading || !documentExists || liveEdit,
    label: title,
    icon: CalendarIcon,
    onHandle: handleDialogOpen,
    title: tooltip && /* @__PURE__ */ jsx(Box, { style: {
      maxWidth: "315px"
    }, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: tooltip }) })
  } : null;
};
ScheduleAction.action = "schedule";
function resolveDocumentActions(existingActions, context) {
  return context.versionType === "published" ? existingActions : existingActions.findIndex((a) => a.action === "publish") < 0 ? [ScheduleAction, ...existingActions] : existingActions.flatMap((action) => action.action === "publish" ? [action, ScheduleAction] : action);
}
const debug = debugWithName$1("ScheduledBadge"), ScheduledBadge = (props2) => {
  const {
    schedules
  } = usePollSchedules({
    documentId: props2.id,
    state: "scheduled"
  });
  debug("schedules", schedules);
  const upcomingSchedule = schedules?.[0];
  if (!upcomingSchedule || !upcomingSchedule.executeAt || !upcomingSchedule.action)
    return null;
  const formattedDateTime = format$2(new Date(upcomingSchedule.executeAt), DATE_FORMAT.LARGE);
  return {
    color: SCHEDULE_ACTION_DICTIONARY[upcomingSchedule.action].badgeColor,
    label: "Scheduled",
    title: `${SCHEDULE_ACTION_DICTIONARY[upcomingSchedule.action].actionName} on ${formattedDateTime} (local time)`
  };
};
function resolveDocumentBadges(existingBadges) {
  return [...existingBadges, ScheduledBadge];
}
function ScheduleBanner(props2) {
  const $ = c(24), {
    id: id2,
    markers
  } = props2, publishedId = usePublishedId(id2), {
    hasError
  } = useValidationState(markers);
  let t0;
  $[0] !== publishedId ? (t0 = {
    documentId: publishedId,
    state: "scheduled"
  }, $[0] = publishedId, $[1] = t0) : t0 = $[1];
  const {
    schedules
  } = usePollSchedules(t0), {
    mode
  } = useScheduledPublishingEnabled();
  if (!(schedules.length > 0))
    return null;
  let t1;
  $[2] !== mode ? (t1 = mode === "upsell" && /* @__PURE__ */ jsx(Card, { tone: "caution", padding: 3, radius: 3, shadow: 1, marginBottom: 3, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, padding: 1, children: [
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }),
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "medium", children: "Scheduled publishing is not available on your current plan" })
  ] }) }), $[2] = mode, $[3] = t1) : t1 = $[3];
  const t2 = hasError ? "critical" : "primary";
  let t3;
  $[4] !== mode ? (t3 = mode === "upsell" ? {
    opacity: 0.7
  } : void 0, $[4] = mode, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(CalendarIcon, {}) }), $[6] = t4) : t4 = $[6];
  let t5;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, marginBottom: 1, padding: 1, children: [
    t4,
    /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
      /* @__PURE__ */ jsx("span", { style: {
        fontWeight: 600
      }, children: "Upcoming schedule" }),
      " (local time)"
    ] })
  ] }), $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== schedules ? (t6 = schedules.map(_temp$F), $[8] = schedules, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t6 ? (t7 = /* @__PURE__ */ jsx(Stack, { space: 2, children: t6 }), $[10] = t6, $[11] = t7) : t7 = $[11];
  let t8;
  $[12] !== hasError ? (t8 = hasError && /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, weight: "regular", children: DOCUMENT_HAS_ERRORS_TEXT }) }), $[12] = hasError, $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== t7 || $[15] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t5,
    t7,
    t8
  ] }), $[14] = t7, $[15] = t8, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== t2 || $[18] !== t3 || $[19] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { padding: 3, radius: 1, shadow: 1, tone: t2, style: t3, children: t9 }), $[17] = t2, $[18] = t3, $[19] = t9, $[20] = t10) : t10 = $[20];
  let t11;
  return $[21] !== t1 || $[22] !== t10 ? (t11 = /* @__PURE__ */ jsxs(Box, { marginBottom: 4, children: [
    t1,
    t10
  ] }), $[21] = t1, $[22] = t10, $[23] = t11) : t11 = $[23], t11;
}
function _temp$F(schedule) {
  if (!schedule.executeAt)
    return null;
  const formattedDateTime = format$2(new Date(schedule.executeAt), DATE_FORMAT.LARGE);
  return /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: formattedDateTime }),
    /* @__PURE__ */ jsx(Flex, { style: {
      opacity: schedule.action === "unpublish" ? 1 : 0
    }, children: /* @__PURE__ */ jsx(Badge, { fontSize: 0, mode: "outline", children: schedule.action }) })
  ] }, schedule.id);
}
function ScheduledDocumentInput(props2) {
  const $ = c(8), {
    value,
    validation: validation2,
    children
  } = props2, doc = value;
  let t0, t1;
  $[0] !== validation2 ? (t1 = validation2.map(_temp$E), $[0] = validation2, $[1] = t1) : t1 = $[1], t0 = t1;
  const markers = t0;
  let t2;
  $[2] !== doc || $[3] !== markers ? (t2 = doc?._id ? /* @__PURE__ */ jsx(ScheduleBanner, { id: doc._id, markers }) : null, $[2] = doc, $[3] = markers, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== children || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t2,
    children
  ] }), $[5] = children, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}
function _temp$E(v) {
  return {
    level: v.level,
    path: v.path,
    item: {
      message: v.message
    },
    message: v.message
  };
}
const DocumentBannerInput = (props2) => {
  const $ = c(7), {
    schemaType
  } = props2;
  if (getRootType(schemaType).name === "document") {
    let t02;
    $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1];
    let t1;
    return $[2] !== props2 || $[3] !== t02 ? (t1 = /* @__PURE__ */ jsx(ScheduledDocumentInput, { ...props2, children: t02 }), $[2] = props2, $[3] = t02, $[4] = t1) : t1 = $[4], t1;
  }
  let t0;
  return $[5] !== props2 ? (t0 = props2.renderDefault(props2), $[5] = props2, $[6] = t0) : t0 = $[6], t0;
};
function getRootType(type) {
  return type.type ? getRootType(type.type) : type;
}
function SchedulePublishingStudioLayoutInner(props2) {
  const $ = c(7), {
    enabled,
    mode
  } = useScheduledPublishingEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  const t0 = mode === "upsell";
  let t1;
  $[2] !== props2 ? (t1 = props2.renderDefault(props2), $[2] = props2, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== t0 || $[5] !== t1 ? (t2 = /* @__PURE__ */ jsx(ConditionalWrapper, { condition: t0, wrapper: _temp$D, children: t1 }), $[4] = t0, $[5] = t1, $[6] = t2) : t2 = $[6], t2;
}
function _temp$D(children) {
  return /* @__PURE__ */ jsx(SchedulePublishingUpsellProvider, { children });
}
function SchedulePublishingStudioLayout(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(ScheduledPublishingEnabledProvider, { children: /* @__PURE__ */ jsx(SchedulePublishingStudioLayoutInner, { ...props2 }) }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const SCHEDULED_PUBLISHING_NAME = "sanity/scheduled-publishing", scheduledPublishing = definePlugin({
  // Renamed from 'scheduled-publishing' to 'sanity/scheduled-publishing' to avoid duplicates, see packages/sanity/src/core/config/flattenConfig.ts - DEPRECATED_PLUGINS.
  name: SCHEDULED_PUBLISHING_NAME,
  document: {
    actions: (prev, context) => resolveDocumentActions(prev, context),
    badges: (prev) => resolveDocumentBadges(prev)
  },
  form: {
    components: {
      input: DocumentBannerInput
    }
  },
  studio: {
    components: {
      layout: SchedulePublishingStudioLayout
    }
  },
  tools: (prev) => [...prev, {
    name: SCHEDULED_PUBLISHING_TOOL_NAME,
    title: TOOL_TITLE,
    icon: CalendarIcon,
    component: Tool,
    router: route.create("/", [route.create("/state/:state"), route.create("/date/:date")]),
    __internalApplicationType: "sanity/scheduled-publishing"
  }]
}), tasksLocaleNamespace = "tasks", tasksUsEnglishLocaleBundle = {
  locale: "en-US",
  namespace: tasksLocaleNamespace,
  resources: () => import("./_chunks-es/resources3.mjs")
};
function TasksEnabledProvider(t0) {
  const $ = c(6), {
    children
  } = t0, {
    enabled,
    isLoading,
    error
  } = useFeatureEnabled("sanityTasks"), isWorkspaceEnabled = useWorkspace().tasks?.enabled;
  let t1;
  bb0: {
    if (!isWorkspaceEnabled || isLoading || error) {
      let t23;
      $[0] === Symbol.for("react.memo_cache_sentinel") ? (t23 = {
        enabled: !1,
        mode: null
      }, $[0] = t23) : t23 = $[0], t1 = t23;
      break bb0;
    }
    const t22 = enabled ? "default" : "upsell";
    let t3;
    $[1] !== t22 ? (t3 = {
      enabled: !0,
      mode: t22
    }, $[1] = t22, $[2] = t3) : t3 = $[2], t1 = t3;
  }
  const value = t1;
  let t2;
  return $[3] !== children || $[4] !== value ? (t2 = /* @__PURE__ */ jsx(TasksEnabledContext.Provider, { value, children }), $[3] = children, $[4] = value, $[5] = t2) : t2 = $[5], t2;
}
function useTasksEnabled() {
  return useContext(TasksEnabledContext);
}
function IsLastPaneProvider(t0) {
  const $ = c(3), {
    children,
    isLastPane
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== isLastPane ? (t1 = /* @__PURE__ */ jsx(IsLastPaneContext.Provider, { value: isLastPane, children }), $[0] = children, $[1] = isLastPane, $[2] = t1) : t1 = $[2], t1;
}
function useIsLastPane() {
  return useContext(IsLastPaneContext);
}
function MentionUserProvider(props2) {
  const $ = c(8), [selectedDocument, setSelectedDocument] = useState(null);
  let t0;
  $[0] !== selectedDocument ? (t0 = {
    documentValue: selectedDocument,
    permission: "read"
  }, $[0] = selectedDocument, $[1] = t0) : t0 = $[1];
  const mentionOptions = useUserListWithPermissions(t0);
  let t1, t2;
  $[2] !== mentionOptions || $[3] !== selectedDocument ? (t2 = {
    mentionOptions,
    selectedDocument,
    setSelectedDocument
  }, $[2] = mentionOptions, $[3] = selectedDocument, $[4] = t2) : t2 = $[4], t1 = t2;
  const value = t1;
  let t3;
  return $[5] !== props2.children || $[6] !== value ? (t3 = /* @__PURE__ */ jsx(MentionUserContext.Provider, { value, children: props2.children }), $[5] = props2.children, $[6] = value, $[7] = t3) : t3 = $[7], t3;
}
function useMentionUser() {
  const context = useContext(MentionUserContext);
  if (!context)
    throw new Error("useMentionUser must be used within a MentionUserProvider");
  return context;
}
const TaskCreated = defineEvent({
  name: "Task Created",
  version: 1,
  description: "A task is created"
}), TaskStatusChanged = defineEvent({
  name: "Task Status Changed",
  version: 1,
  description: "Task status changed"
}), TaskDuplicated = defineEvent({
  name: "Task Duplicated",
  version: 1,
  description: "A task is duplicated"
}), TaskRemoved = defineEvent({
  name: "Task Removed",
  version: 1,
  description: "A task is removed"
}), TaskLinkCopied = defineEvent({
  name: "Task Link Copied",
  version: 1,
  description: "The link to a task is copied"
}), TaskLinkOpened = defineEvent({
  name: "Task Link Opened",
  version: 1,
  description: "User visited the studio through a link with a task"
}), initialState = {
  viewMode: "list",
  selectedTask: null,
  activeTabId: "assigned",
  duplicateTaskValues: null,
  isOpen: !1
};
function reducer$1(state, action) {
  switch (action.type) {
    case "TOGGLE_TASKS_VIEW":
      return action.payload === !1 ? {
        ...initialState,
        isOpen: action.payload
      } : {
        ...state,
        isOpen: action.payload
      };
    case "CREATE_TASK":
      return {
        ...state,
        viewMode: "create",
        selectedTask: uuid()
      };
    case "EDIT_TASK":
      return {
        ...state,
        viewMode: "edit",
        selectedTask: action.payload.id
      };
    case "EDIT_DRAFT":
      return {
        ...state,
        viewMode: "draft",
        selectedTask: action.payload.id
      };
    case "DUPLICATE_TASK":
      return {
        ...state,
        viewMode: "duplicate",
        selectedTask: uuid(),
        duplicateTaskValues: action.payload.duplicateTaskValues
      };
    case "SET_ACTIVE_TAB":
      return {
        ...state,
        viewMode: "list",
        activeTabId: action.payload
      };
    case "NAVIGATE_TO_LIST":
      return {
        ...state,
        viewMode: "list"
      };
    default:
      return state;
  }
}
const TasksNavigationProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(reducer$1, initialState), router = useRouter(), toast = useToast(), telemetry = useTelemetry(), setViewMode = useCallback((viewMode) => {
    switch (viewMode.type) {
      case "list":
        dispatch({
          type: "NAVIGATE_TO_LIST"
        });
        break;
      case "create":
        dispatch({
          type: "CREATE_TASK"
        });
        break;
      case "edit":
        dispatch({
          type: "EDIT_TASK",
          payload: {
            id: viewMode.id
          }
        });
        break;
      case "duplicate":
        dispatch({
          type: "DUPLICATE_TASK",
          payload: {
            duplicateTaskValues: viewMode.duplicateTaskValues
          }
        });
        break;
      case "draft":
        dispatch({
          type: "EDIT_DRAFT",
          payload: {
            id: viewMode.id
          }
        });
        break;
    }
  }, []), setActiveTab = useCallback((tabId) => {
    dispatch({
      type: "SET_ACTIVE_TAB",
      payload: tabId
    });
  }, []), handleCloseTasks = useCallback(() => {
    dispatch({
      type: "TOGGLE_TASKS_VIEW",
      payload: !1
    });
  }, []), handleOpenTasks = useCallback(() => {
    dispatch({
      type: "TOGGLE_TASKS_VIEW",
      payload: !0
    });
  }, []), handleCopyLinkToTask = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.set("sidebar", "tasks"), url.searchParams.set("viewMode", state.viewMode), state.selectedTask && url.searchParams.set("selectedTask", state.selectedTask), navigator.clipboard.writeText(url.toString()).then(() => {
      telemetry.log(TaskLinkCopied);
    }).catch(() => {
      toast.push({
        closable: !0,
        status: "error",
        title: "Failed to copy link to clipboard"
      });
    });
  }, [state.selectedTask, state.viewMode, telemetry, toast]), searchParams = new URLSearchParams(router.state._searchParams), sidebar = searchParams.get("sidebar"), viewMode_0 = searchParams.get("viewMode"), selectedTask = searchParams.get("selectedTask");
  useEffect(() => {
    sidebar === "tasks" && (dispatch({
      type: "TOGGLE_TASKS_VIEW",
      payload: !0
    }), viewMode_0 === "edit" && selectedTask && (dispatch({
      type: "EDIT_TASK",
      payload: {
        id: selectedTask
      }
    }), telemetry.log(TaskLinkOpened)));
  }, [selectedTask, sidebar, telemetry, viewMode_0]);
  const value = useMemo(() => ({
    state,
    setViewMode,
    setActiveTab,
    handleCloseTasks,
    handleOpenTasks,
    handleCopyLinkToTask
  }), [handleCloseTasks, handleCopyLinkToTask, handleOpenTasks, setActiveTab, setViewMode, state]);
  return /* @__PURE__ */ jsx(TasksNavigationContext.Provider, { value, children });
};
function useTasksNavigation() {
  return useContext(TasksNavigationContext) || FALLBACK_CONTEXT_VALUE$1;
}
const FALLBACK_CONTEXT_VALUE$1 = {
  state: {
    activeTabId: "assigned",
    viewMode: "list",
    selectedTask: null,
    isOpen: !1,
    duplicateTaskValues: null
  },
  setActiveTab: () => null,
  setViewMode: () => null,
  handleCloseTasks: () => null,
  handleCopyLinkToTask: () => null,
  handleOpenTasks: () => null
};
function createTasksSet(tasks2) {
  return tasks2.reduce((acc, task) => ({
    ...acc,
    [task._id]: task
  }), {});
}
function tasksReducer(state, action) {
  switch (action.type) {
    case "TASKS_SET": {
      const tasksById = createTasksSet(action.tasks);
      return {
        ...state,
        tasks: tasksById
      };
    }
    case "TASK_ADDED": {
      const nextTaskResult = action.payload, nextTaskValue = nextTaskResult, nextTask = {
        [nextTaskResult._id]: {
          ...state.tasks[nextTaskResult._id],
          ...nextTaskValue,
          _state: nextTaskResult._state || void 0,
          // If the task is created optimistically, it won't have a createdAt date as this is set on the server.
          // However, we need to set a createdAt date to be able to sort the tasks correctly.
          // Therefore, we set the createdAt date to the current date here if it's missing while creating the task.
          // Once the task is created and received from the server, the createdAt date will be updated to the correct value.
          _createdAt: nextTaskResult._createdAt || (/* @__PURE__ */ new Date()).toISOString()
        }
      };
      return {
        ...state,
        tasks: {
          ...state.tasks,
          ...nextTask
        }
      };
    }
    case "TASK_RECEIVED": {
      const nextTaskResult = action.payload;
      return {
        ...state,
        tasks: {
          ...state.tasks,
          [nextTaskResult._id]: nextTaskResult
        }
      };
    }
    case "TASK_DELETED": {
      const {
        [action.id]: _,
        ...restTasks
      } = state.tasks;
      return {
        ...state,
        tasks: restTasks
      };
    }
    case "TASK_UPDATED": {
      const updatedTask = action.payload, id2 = updatedTask._id, nextTask = {
        // Add existing task data
        ...state.tasks[id2],
        // Add incoming task data
        ...updatedTask
      };
      return {
        ...state,
        tasks: {
          ...state.tasks,
          [id2]: nextTask
        }
      };
    }
    default:
      return state;
  }
}
const INITIAL_STATE$3 = {
  tasks: {}
}, LISTEN_OPTIONS = {
  events: ["welcome", "mutation", "reconnect"],
  includeResult: !0,
  visibility: "query",
  includeAllVersions: !0,
  tag: "tasks-store"
}, SORT_FIELD = "_createdAt", SORT_ORDER = "desc", QUERY_FILTERS = ['_type == "tasks.task"'], QUERY_PROJECTION = `{
  ...,
}`, QUERY_SORT_ORDER = `order(${SORT_FIELD} ${SORT_ORDER})`, QUERY = `*[${QUERY_FILTERS.join(" && ")}] ${QUERY_PROJECTION} | ${QUERY_SORT_ORDER}`;
function useTasksStore(opts) {
  const {
    client
  } = useAddonDataset(), {
    documentId
  } = opts, [state, dispatch] = useReducer(tasksReducer, INITIAL_STATE$3), [isLoading, setIsLoading] = useState(client !== null), [error, setError] = useState(null), params = useMemo(() => ({
    documentId: documentId ? getPublishedId(documentId) : null
  }), [documentId]), initialFetch = useCallback(async () => {
    if (!client) {
      setIsLoading(!1);
      return;
    }
    try {
      const res = await client.fetch(QUERY, params);
      dispatch({
        type: "TASKS_SET",
        tasks: res
      }), setIsLoading(!1);
    } catch (err) {
      setError(err);
    }
  }, [client, params]), handleListenerEvent = useCallback(async (event) => {
    if (event.type === "welcome" && (setIsLoading(!0), await initialFetch(), setIsLoading(!1)), event.type === "reconnect" && setIsLoading(!0), event.type === "mutation") {
      if (event.transition === "appear") {
        const nextTask = event.result;
        nextTask && dispatch({
          type: "TASK_RECEIVED",
          payload: nextTask
        });
      }
      if (event.transition === "disappear" && dispatch({
        type: "TASK_DELETED",
        id: event.documentId
      }), event.transition === "update") {
        const updatedTask = event.result;
        updatedTask && dispatch({
          type: "TASK_UPDATED",
          payload: updatedTask
        });
      }
    }
  }, [initialFetch]), listener$ = useMemo(() => client ? client.observable.listen(QUERY, params, LISTEN_OPTIONS).pipe(catchError$1((err_0) => (setError(err_0), of(err_0)))) : of(), [client, params]);
  return useEffect(() => {
    const sub2 = listener$.subscribe(handleListenerEvent);
    return () => {
      sub2?.unsubscribe();
    };
  }, [handleListenerEvent, listener$]), {
    data: useMemo(() => Object.values(state.tasks), [state.tasks]),
    dispatch,
    error,
    isLoading
  };
}
const EMPTY_ARRAY$b = [];
function TasksProvider(props2) {
  const $ = c(11), {
    children
  } = props2, [activeDocument, setActiveDocument] = useState(null);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const {
    data: t1,
    isLoading
  } = useTasksStore(t0), data = t1 === void 0 ? EMPTY_ARRAY$b : t1;
  let t2, t3;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t3 = debounce(setActiveDocument, 1e3), $[1] = t3) : t3 = $[1], t2 = t3;
  const debouncedSetActiveDocument = t2;
  let t4, t5;
  $[2] !== data ? (t5 = data ?? [], $[2] = data, $[3] = t5) : t5 = $[3];
  let t6;
  $[4] !== activeDocument || $[5] !== isLoading || $[6] !== t5 ? (t6 = {
    activeDocument,
    setActiveDocument: debouncedSetActiveDocument,
    isLoading,
    data: t5
  }, $[4] = activeDocument, $[5] = isLoading, $[6] = t5, $[7] = t6) : t6 = $[7], t4 = t6;
  const value = t4;
  let t7;
  return $[8] !== children || $[9] !== value ? (t7 = /* @__PURE__ */ jsx(TasksContext.Provider, { value, children }), $[8] = children, $[9] = value, $[10] = t7) : t7 = $[10], t7;
}
function useTasks() {
  const $ = c(1), context = useContext(TasksContext);
  if (!context) {
    let t0;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      activeDocument: null,
      setActiveDocument: _temp$C,
      data: [],
      isLoading: !1
    }, $[0] = t0) : t0 = $[0], t0;
  }
  return context;
}
function _temp$C() {
  return null;
}
const FEATURE = "tasks", TEMPLATE_OPTIONS = {
  interpolate: /{{([\s\S]+?)}}/g
}, BASE_URL = "www.sanity.io", API_VERSION$1 = "2024-04-19";
function TasksUpsellProvider(props2) {
  const $ = c(32), [upsellDialogOpen, setUpsellDialogOpen] = useState(!1), [upsellData, setUpsellData] = useState(null), projectId = useProjectId$1(), telemetry = useTelemetry();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: API_VERSION$1
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0);
  let t1, t2;
  $[1] !== telemetry ? (t2 = {
    dialogSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature: FEATURE,
      type: "modal"
    }),
    dialogPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature: FEATURE,
      type: "modal"
    }),
    panelViewed: (source) => telemetry.log(UpsellDialogViewed, {
      feature: FEATURE,
      type: "inspector",
      source
    }),
    panelDismissed: () => telemetry.log(UpsellDialogDismissed, {
      feature: FEATURE,
      type: "inspector"
    }),
    panelPrimaryClicked: () => telemetry.log(UpsellDialogUpgradeCtaClicked, {
      feature: FEATURE,
      type: "inspector"
    }),
    panelSecondaryClicked: () => telemetry.log(UpsellDialogLearnMoreCtaClicked, {
      feature: FEATURE,
      type: "inspector"
    })
  }, $[1] = telemetry, $[2] = t2) : t2 = $[2], t1 = t2;
  const telemetryLogs = t1;
  let t3;
  $[3] !== telemetryLogs ? (t3 = () => {
    telemetryLogs.dialogPrimaryClicked();
  }, $[3] = telemetryLogs, $[4] = t3) : t3 = $[4];
  const handlePrimaryButtonClick = t3;
  let t4;
  $[5] !== telemetryLogs ? (t4 = () => {
    telemetryLogs.dialogSecondaryClicked();
  }, $[5] = telemetryLogs, $[6] = t4) : t4 = $[6];
  const handleSecondaryButtonClick = t4;
  let t5;
  $[7] !== telemetry ? (t5 = () => {
    setUpsellDialogOpen(!1), telemetry.log(UpsellDialogDismissed, {
      feature: FEATURE,
      type: "modal"
    });
  }, $[7] = telemetry, $[8] = t5) : t5 = $[8];
  const handleClose = t5;
  let t6;
  $[9] !== client.observable || $[10] !== projectId ? (t6 = () => {
    const sub2 = client.observable.request({
      uri: "/journey/tasks"
    }).subscribe({
      next: (data) => {
        if (data)
          try {
            const ctaUrl = template(data.ctaButton.url, TEMPLATE_OPTIONS);
            data.ctaButton.url = ctaUrl({
              baseUrl: BASE_URL,
              projectId
            });
            const secondaryUrl = template(data.secondaryButton.url, TEMPLATE_OPTIONS);
            data.secondaryButton.url = secondaryUrl({
              baseUrl: BASE_URL,
              projectId
            }), setUpsellData(data);
          } catch {
          }
      },
      error: _temp$B
    });
    return () => {
      sub2.unsubscribe();
    };
  }, $[9] = client.observable, $[10] = projectId, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== client || $[13] !== projectId ? (t7 = [client, projectId], $[12] = client, $[13] = projectId, $[14] = t7) : t7 = $[14], useEffect(t6, t7);
  let t8;
  $[15] !== telemetry ? (t8 = (source_0) => {
    setUpsellDialogOpen(!0), telemetry.log(UpsellDialogViewed, {
      feature: FEATURE,
      type: "modal",
      source: source_0
    });
  }, $[15] = telemetry, $[16] = t8) : t8 = $[16];
  const handleOpenDialog = t8;
  let t9, t10;
  $[17] !== handleOpenDialog || $[18] !== telemetryLogs || $[19] !== upsellData || $[20] !== upsellDialogOpen ? (t10 = {
    upsellDialogOpen,
    handleOpenDialog,
    upsellData,
    telemetryLogs
  }, $[17] = handleOpenDialog, $[18] = telemetryLogs, $[19] = upsellData, $[20] = upsellDialogOpen, $[21] = t10) : t10 = $[21], t9 = t10;
  const ctxValue = t9;
  let t11;
  $[22] !== handleClose || $[23] !== handlePrimaryButtonClick || $[24] !== handleSecondaryButtonClick || $[25] !== upsellData || $[26] !== upsellDialogOpen ? (t11 = upsellData && upsellDialogOpen && /* @__PURE__ */ jsx(UpsellDialog, { data: upsellData, onClose: handleClose, onPrimaryClick: handlePrimaryButtonClick, onSecondaryClick: handleSecondaryButtonClick }), $[22] = handleClose, $[23] = handlePrimaryButtonClick, $[24] = handleSecondaryButtonClick, $[25] = upsellData, $[26] = upsellDialogOpen, $[27] = t11) : t11 = $[27];
  let t12;
  return $[28] !== ctxValue || $[29] !== props2.children || $[30] !== t11 ? (t12 = /* @__PURE__ */ jsxs(TasksUpsellContext.Provider, { value: ctxValue, children: [
    props2.children,
    t11
  ] }), $[28] = ctxValue, $[29] = props2.children, $[30] = t11, $[31] = t12) : t12 = $[31], t12;
}
function _temp$B() {
}
function useTasksUpsell() {
  return useContext(TasksUpsellContext) || FALLBACK_CONTEXT_VALUE;
}
const FALLBACK_CONTEXT_VALUE = {
  upsellData: null,
  handleOpenDialog: () => null,
  upsellDialogOpen: !1,
  telemetryLogs: {
    dialogSecondaryClicked: () => null,
    dialogPrimaryClicked: () => null,
    panelViewed: () => null,
    panelDismissed: () => null,
    panelPrimaryClicked: () => null,
    panelSecondaryClicked: () => null
  }
};
function TaskCreateAction() {
  const $ = c(14), {
    handleOpenTasks,
    setViewMode
  } = useTasksNavigation(), {
    enabled,
    mode
  } = useTasksEnabled(), {
    handleOpenDialog
  } = useTasksUpsell();
  let t0;
  $[0] !== handleOpenDialog || $[1] !== handleOpenTasks || $[2] !== mode || $[3] !== setViewMode ? (t0 = () => {
    mode === "upsell" ? handleOpenDialog("document_action") : (handleOpenTasks(), setViewMode({
      type: "create"
    }));
  }, $[0] = handleOpenDialog, $[1] = handleOpenTasks, $[2] = mode, $[3] = setViewMode, $[4] = t0) : t0 = $[4];
  const handleCreateTaskFromDocument = t0, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  bb0: {
    if (!enabled) {
      t1 = null;
      break bb0;
    }
    let t2;
    $[5] !== t ? (t2 = t("actions.create.text"), $[5] = t, $[6] = t2) : t2 = $[6];
    let t3;
    $[7] !== t ? (t3 = t("actions.create.text"), $[7] = t, $[8] = t3) : t3 = $[8];
    let t4;
    $[9] === Symbol.for("react.memo_cache_sentinel") ? (t4 = ["paneActions"], $[9] = t4) : t4 = $[9];
    let t5;
    $[10] !== handleCreateTaskFromDocument || $[11] !== t2 || $[12] !== t3 ? (t5 = {
      icon: TaskIcon,
      label: t2,
      title: t3,
      group: t4,
      onHandle: handleCreateTaskFromDocument
    }, $[10] = handleCreateTaskFromDocument, $[11] = t2, $[12] = t3, $[13] = t5) : t5 = $[13], t1 = t5;
  }
  return t1;
}
TaskCreateAction.displayName = "TaskCreateAction";
function SetActiveDocumentInner(document2) {
  const $ = c(6), {
    documentId,
    documentType
  } = document2, isLast = useIsLastPane(), {
    setActiveDocument
  } = useTasks();
  let t0, t1;
  return $[0] !== documentId || $[1] !== documentType || $[2] !== isLast || $[3] !== setActiveDocument ? (t0 = () => (documentId && isLast && documentType && setActiveDocument?.({
    documentId: isVersionId(documentId) ? documentId : getPublishedId(documentId),
    documentType
  }), () => {
    isLast && setActiveDocument?.(null);
  }), t1 = [documentId, documentType, isLast, setActiveDocument], $[0] = documentId, $[1] = documentType, $[2] = isLast, $[3] = setActiveDocument, $[4] = t0, $[5] = t1) : (t0 = $[4], t1 = $[5]), useEffect(t0, t1), null;
}
function SetActiveDocument(document2) {
  const $ = c(2), {
    enabled
  } = useTasksEnabled();
  if (!enabled)
    return null;
  let t0;
  return $[0] !== document2 ? (t0 = /* @__PURE__ */ jsx(SetActiveDocumentInner, { ...document2 }), $[0] = document2, $[1] = t0) : t0 = $[1], t0;
}
function TasksDocumentInputLayout(props2) {
  const $ = c(8), documentId = props2.value?._id, documentType = props2.value?._type;
  let t0;
  $[0] !== documentId || $[1] !== documentType ? (t0 = /* @__PURE__ */ jsx(SetActiveDocument, { documentId, documentType }), $[0] = documentId, $[1] = documentType, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== props2 ? (t1 = props2.renderDefault(props2), $[3] = props2, $[4] = t1) : t1 = $[4];
  let t2;
  return $[5] !== t0 || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t0,
    t1
  ] }), $[5] = t0, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
const ButtonContainer = styled.div`
  position: relative;
  [data-ui='Badge'] {
    position: absolute;
    top: -2px;
    right: -2px;
  }
`;
function TasksFooterOpenTasks() {
  const {
    data,
    activeDocument
  } = useTasks(), {
    handleOpenTasks,
    setActiveTab
  } = useTasksNavigation(), mediaIndex = useMediaIndex(), pendingTasks = useMemo(() => activeDocument?.documentId ? data.filter((item) => item.target?.document._ref === activeDocument.documentId && item.status === "open" && item.createdByUser) : [], [activeDocument, data]), handleOnClick = useCallback(() => {
    handleOpenTasks(), setActiveTab("document");
  }, [handleOpenTasks, setActiveTab]), {
    t
  } = useTranslation(tasksLocaleNamespace);
  return pendingTasks.length === 0 ? null : mediaIndex < 3 ? /* @__PURE__ */ jsxs(ButtonContainer, { children: [
    /* @__PURE__ */ jsx(Button, { mode: "bleed", icon: TaskIcon, size: "large", onClick: handleOnClick, tooltipProps: {
      content: t("document.footer.open-tasks.placeholder", {
        count: pendingTasks.length
      })
    } }),
    /* @__PURE__ */ jsx(Badge, { "data-testid": "tasks-badge", tone: "primary", fontSize: 0, children: pendingTasks.length })
  ] }) : /* @__PURE__ */ jsx(Button, { mode: "bleed", tooltipProps: {
    content: t("document.footer.open-tasks.placeholder", {
      count: pendingTasks.length
    })
  }, text: t("document.footer.open-tasks.text", {
    count: pendingTasks.length
  }), onClick: handleOnClick });
}
function getTargetValue({
  documentId,
  documentType,
  dataset,
  projectId
}) {
  return {
    documentType,
    document: {
      _ref: getPublishedId(documentId),
      _type: "crossDatasetReference",
      _dataset: dataset,
      _projectId: projectId,
      _weak: !0
    }
  };
}
function getMentionedUsers(description) {
  if (!description) return [];
  const subscribers2 = [];
  return description?.forEach((block) => {
    isPortableTextTextBlock(block) && block.children.forEach((child) => {
      child._type === "mention" && typeof child.userId == "string" && !subscribers2.includes(child.userId) && subscribers2.push(child.userId);
    });
  }), subscribers2;
}
const DATE_FORMAT_OPTIONS$1 = {
  month: "long",
  day: "2-digit",
  minute: "2-digit",
  hour: "2-digit",
  second: "2-digit"
}, RELATIVE_TIME_OPTIONS$1 = {
  minimal: !0,
  useTemporalPhrase: !0
}, Strong = styled.strong`
  font-weight: 600;
`, NoWrap = styled.span`
  white-space: nowrap;
`;
function useUpdatedTimeAgo(timestamp) {
  const $ = c(3), date = new Date(timestamp), formattedDate = useDateTimeFormat(DATE_FORMAT_OPTIONS$1).format(date), updatedTimeAgo = useRelativeTime(date || "", RELATIVE_TIME_OPTIONS$1);
  let t0;
  return $[0] !== formattedDate || $[1] !== updatedTimeAgo ? (t0 = {
    timeAgo: updatedTimeAgo,
    formattedDate
  }, $[0] = formattedDate, $[1] = updatedTimeAgo, $[2] = t0) : t0 = $[2], t0;
}
function UserName(t0) {
  const $ = c(3), {
    userId
  } = t0, [user, isLoading] = useUser(userId);
  let t1;
  return $[0] !== isLoading || $[1] !== user?.displayName ? (t1 = isLoading ? /* @__PURE__ */ jsx(TextSkeleton, { style: {
    width: "15ch"
  } }) : /* @__PURE__ */ jsx(Strong, { children: user?.displayName }), $[0] = isLoading, $[1] = user?.displayName, $[2] = t1) : t1 = $[2], t1;
}
const DUE_BY_DATE_OPTIONS = {
  month: "short",
  day: "numeric"
};
function DueByChange(t0) {
  const $ = c(2), {
    date
  } = t0, dueBy = new Date(date), formattedDate = useDateTimeFormat(DUE_BY_DATE_OPTIONS).format(dueBy);
  let t1;
  return $[0] !== formattedDate ? (t1 = /* @__PURE__ */ jsx(Strong, { children: /* @__PURE__ */ jsx(NoWrap, { children: formattedDate }) }), $[0] = formattedDate, $[1] = t1) : t1 = $[1], t1;
}
const LinkWrapper = styled.span`
  > a {
    color: var(--card-fg-muted-color);
    text-decoration: underline;
    text-underline-offset: 1px;
    font-weight: 600;
  }
`;
function TargetContentChange(t0) {
  const $ = c(10), {
    target
  } = t0, schema2 = useSchema(), documentId = target.document._ref, documentType = target.documentType, documentSchema = schema2.get(documentType);
  let t1;
  $[0] !== documentId || $[1] !== documentType ? (t1 = {
    documentId,
    documentType
  }, $[0] = documentId, $[1] = documentType, $[2] = t1) : t1 = $[2];
  const {
    isLoading,
    value
  } = useDocumentPreviewValues(t1);
  if (isLoading) {
    let t22;
    return $[3] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(TextSkeleton, { style: {
      width: "15ch"
    } }), $[3] = t22) : t22 = $[3], t22;
  }
  if (!documentSchema)
    return null;
  let t2;
  $[4] !== documentId || $[5] !== documentType ? (t2 = {
    id: documentId,
    type: documentType
  }, $[4] = documentId, $[5] = documentType, $[6] = t2) : t2 = $[6];
  const t3 = value?.title;
  let t4;
  return $[7] !== t2 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(LinkWrapper, { children: /* @__PURE__ */ jsx(IntentLink, { intent: "edit", params: t2, children: t3 }) }), $[7] = t2, $[8] = t3, $[9] = t4) : t4 = $[9], t4;
}
function getChangeDetails(activity) {
  switch (activity.field) {
    case "status": {
      const statusTitle = TASK_STATUS.find((s) => s.value === activity.to)?.title;
      return {
        text: "changed status to",
        icon: TASK_STATUS.find((s) => s.value === activity.to)?.icon || /* @__PURE__ */ jsx(CircleIcon, {}),
        changeTo: /* @__PURE__ */ jsx(Strong, { children: statusTitle })
      };
    }
    case "target":
      return activity.to ? {
        text: "set target content to",
        icon: /* @__PURE__ */ jsx(LinkIcon, {}),
        changeTo: /* @__PURE__ */ jsx(TargetContentChange, { target: activity.to })
      } : {
        text: "removed target content",
        icon: /* @__PURE__ */ jsx(LinkIcon, {}),
        changeTo: void 0
      };
    case "dueBy":
      return activity.from ? activity.to ? {
        text: "changed the due date to",
        icon: /* @__PURE__ */ jsx(CalendarIcon, {}),
        changeTo: /* @__PURE__ */ jsx(DueByChange, { date: activity.to })
      } : {
        text: "removed the due date",
        icon: /* @__PURE__ */ jsx(CalendarIcon, {}),
        changeTo: void 0
      } : {
        text: "set the due date to",
        icon: /* @__PURE__ */ jsx(CalendarIcon, {}),
        changeTo: /* @__PURE__ */ jsx(DueByChange, { date: activity.to })
      };
    case "assignedTo":
      return activity.to ? {
        text: "assigned to",
        icon: /* @__PURE__ */ jsx(UserIcon, {}),
        changeTo: /* @__PURE__ */ jsx(UserName, { userId: activity.to })
      } : {
        text: "unassigned this task",
        icon: /* @__PURE__ */ jsx(UserIcon, {}),
        changeTo: void 0
      };
    case "description":
      return {
        text: "updated the task description",
        icon: /* @__PURE__ */ jsx(EditIcon, {}),
        changeTo: void 0
      };
    case "title":
      return {
        text: "updated the task title",
        icon: /* @__PURE__ */ jsx(EditIcon, {}),
        changeTo: void 0
      };
    default:
      return {
        text: "",
        icon: /* @__PURE__ */ jsx(CircleIcon, {})
      };
  }
}
const EditedAt = memo(function(props2) {
  const $ = c(20), {
    activity
  } = props2, {
    formattedDate,
    timeAgo
  } = useUpdatedTimeAgo(activity.timestamp);
  let t0;
  $[0] !== activity ? (t0 = getChangeDetails(activity), $[0] = activity, $[1] = t0) : t0 = $[1];
  const {
    icon,
    text,
    changeTo
  } = t0;
  let t1;
  $[2] !== icon ? (t1 = /* @__PURE__ */ jsx(Box, { marginTop: 1, marginLeft: 1, marginRight: 3, children: /* @__PURE__ */ jsx(Box, { marginRight: 1, children: /* @__PURE__ */ jsx(Text$1, { children: icon }) }) }), $[2] = icon, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== activity.author ? (t2 = /* @__PURE__ */ jsx(UserName, { userId: activity.author }), $[4] = activity.author, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== formattedDate || $[7] !== timeAgo ? (t3 = /* @__PURE__ */ jsx(NoWrap, { children: /* @__PURE__ */ jsx("time", { dateTime: formattedDate, children: timeAgo }) }), $[6] = formattedDate, $[7] = timeAgo, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== formattedDate || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(Tooltip, { content: formattedDate, placement: "top-end", children: t3 }), $[9] = formattedDate, $[10] = t3, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== changeTo || $[13] !== t2 || $[14] !== t4 || $[15] !== text ? (t5 = /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
    t2,
    " ",
    text,
    " ",
    changeTo,
    " \u2022",
    " ",
    t4
  ] }), $[12] = changeTo, $[13] = t2, $[14] = t4, $[15] = text, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== t1 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t1,
    t5
  ] }), $[17] = t1, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}, (prevProps, nextProps) => prevProps.activity.timestamp === nextProps.activity.timestamp), AvatarRoot = styled.div((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
      min-height: ${theme.avatar.sizes[props2.$size]?.size}px;
      min-width: ${theme.avatar.sizes[props2.$size]?.size}px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      ${props2.$border ? "box-shadow: inset 0 0 0 1px var(--card-border-color);" : ""};
      ${props2.$removeBg ? "--card-avatar-gray-bg-color: transparent;" : ""}
    `;
});
function TasksUserAvatar(props2) {
  const $ = c(27), {
    user,
    size: t0,
    border: t1
  } = props2, size = t0 === void 0 ? 0 : t0, border = t1 === void 0 ? !0 : t1, [loadedUser, loading] = useUser(user?.id || "");
  if (loading) {
    let t22;
    return $[0] !== size ? (t22 = /* @__PURE__ */ jsx(AvatarSkeleton$1, { $size: size, animated: !0 }), $[0] = size, $[1] = t22) : t22 = $[1], t22;
  }
  if (!user || !loadedUser) {
    let t22;
    $[2] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(UserIcon, {}), $[2] = t22) : t22 = $[2];
    let t32;
    $[3] !== size ? (t32 = /* @__PURE__ */ jsx(Text$1, { size, children: t22 }), $[3] = size, $[4] = t32) : t32 = $[4];
    let t42;
    return $[5] !== border || $[6] !== size || $[7] !== t32 ? (t42 = /* @__PURE__ */ jsx(AvatarRoot, { $size: size, $border: border, children: t32 }), $[5] = border, $[6] = size, $[7] = t32, $[8] = t42) : t42 = $[8], t42;
  }
  const t2 = !props2.withTooltip;
  let t3;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t3 = ["top", "top-start"], $[9] = t3) : t3 = $[9];
  const t4 = !!loadedUser?.imageUrl;
  let t5;
  $[10] !== loadedUser.imageUrl ? (t5 = loadedUser?.imageUrl ? {
    color: void 0
  } : {}, $[10] = loadedUser.imageUrl, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== props2.withTooltip ? (t6 = props2.withTooltip ? {
    title: null
  } : {}, $[12] = props2.withTooltip, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== loadedUser || $[15] !== size || $[16] !== t5 || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsx(UserAvatar, { user: loadedUser, size, ...t5, ...t6 }), $[14] = loadedUser, $[15] = size, $[16] = t5, $[17] = t6, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== size || $[20] !== t4 || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsx(AvatarRoot, { $size: size, $removeBg: t4, children: t7 }), $[19] = size, $[20] = t4, $[21] = t7, $[22] = t8) : t8 = $[22];
  let t9;
  return $[23] !== loadedUser.displayName || $[24] !== t2 || $[25] !== t8 ? (t9 = /* @__PURE__ */ jsx(Tooltip, { content: loadedUser.displayName, disabled: t2, portal: !0, fallbackPlacements: t3, placement: "top-end", children: t8 }), $[23] = loadedUser.displayName, $[24] = t2, $[25] = t8, $[26] = t9) : t9 = $[26], t9;
}
const ActivityChildrenRoot = styled(Flex)`
  height: 100%;
`, ActivityItemChildrenContainer = styled.div`
  width: 100%;
`;
function ActivityItem(t0) {
  const $ = c(10), {
    avatarPaddingTop: t1,
    userId,
    children
  } = t0, avatarPaddingTop = t1 === void 0 ? 1 : t1;
  let t2;
  $[0] !== userId ? (t2 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: {
    id: userId
  }, size: 0 }), $[0] = userId, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== avatarPaddingTop || $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { marginRight: 3, paddingTop: avatarPaddingTop, children: t2 }), $[2] = avatarPaddingTop, $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== children ? (t4 = /* @__PURE__ */ jsx(ActivityChildrenRoot, { align: "center", flex: 1, children: /* @__PURE__ */ jsx(ActivityItemChildrenContainer, { children }) }), $[5] = children, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { children: [
    t3,
    t4
  ] }), $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9], t5;
}
function TasksActivityCommentInput(props2) {
  const $ = c(25), {
    mentionOptions,
    currentUser,
    onSubmit
  } = props2, {
    mode
  } = useTasksEnabled(), [value, setValue] = useState(null), editorRef = useRef(null);
  let t0, t1;
  $[0] !== value ? (t1 = hasCommentMessageValue(value), $[0] = value, $[1] = t1) : t1 = $[1], t0 = t1;
  const hasValue2 = t0;
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (nextValue) => {
    setValue(nextValue);
  }, $[2] = t2) : t2 = $[2];
  const handleChange = t2;
  let t3;
  $[3] !== hasValue2 || $[4] !== onSubmit || $[5] !== value ? (t3 = () => {
    hasValue2 && (onSubmit(value), setValue(null));
  }, $[3] = hasValue2, $[4] = onSubmit, $[5] = value, $[6] = t3) : t3 = $[6];
  const handleSubmit = t3;
  let t4;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    editorRef.current?.discardDialogController.close();
  }, $[7] = t4) : t4 = $[7];
  const handleDiscardCancel = t4;
  let t5;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    editorRef.current?.discardDialogController.close(), setValue(null);
  }, $[8] = t5) : t5 = $[8];
  const handleDiscardConfirm = t5;
  let t6;
  $[9] !== hasValue2 ? (t6 = (e) => {
    e.key === "Escape" && (e.preventDefault(), e.stopPropagation(), hasValue2 ? editorRef.current?.discardDialogController.open() : (editorRef.current?.discardDialogController.close(), setValue(null)));
  }, $[9] = hasValue2, $[10] = t6) : t6 = $[10];
  const handleKeyDown = t6, {
    t
  } = useTranslation(tasksLocaleNamespace), t7 = mode === "upsell";
  let t8;
  $[11] !== mode || $[12] !== t ? (t8 = t(mode === "upsell" ? "panel.comment.placeholder.upsell" : "panel.comment.placeholder"), $[11] = mode, $[12] = t, $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== currentUser || $[15] !== handleKeyDown || $[16] !== handleSubmit || $[17] !== mentionOptions || $[18] !== t7 || $[19] !== t8 || $[20] !== value ? (t9 = /* @__PURE__ */ jsx(Card, { tone: "transparent", radius: 3, padding: 2, children: /* @__PURE__ */ jsx(CommentInput, { withAvatar: !1, currentUser, expandOnFocus: !0, mentionOptions, onChange: handleChange, onDiscardConfirm: handleDiscardConfirm, onDiscardCancel: handleDiscardCancel, onKeyDown: handleKeyDown, onSubmit: handleSubmit, readOnly: t7, placeholder: t8, ref: editorRef, value }) }), $[14] = currentUser, $[15] = handleKeyDown, $[16] = handleSubmit, $[17] = mentionOptions, $[18] = t7, $[19] = t8, $[20] = value, $[21] = t9) : t9 = $[21];
  let t10;
  return $[22] !== currentUser.id || $[23] !== t9 ? (t10 = /* @__PURE__ */ jsx(ActivityItem, { userId: currentUser.id, avatarPaddingTop: 3, children: t9 }), $[22] = currentUser.id, $[23] = t9, $[24] = t10) : t10 = $[24], t10;
}
const COMMENTS_LIST_ITEM_AVATAR_CONFIG = {
  parentCommentAvatar: !1,
  threadCommentsAvatar: !0,
  replyAvatar: !0,
  avatarSize: 0
}, CommentListItemRoot = styled.div((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    [data-ui='CommentsListItem'] {
      padding-right: ${theme.space[2]}px;
    }

    // Increase the padding when the comment input is focused
    [data-ui='CommentInputEditableWrap']:focus-within {
      padding-bottom: ${theme.space[2]}px;
    }
  `;
});
function TasksActivityCommentItem(props2) {
  const $ = c(6), {
    parentComment
  } = props2, {
    mode
  } = useTasksEnabled(), t0 = mode ?? "default";
  let t1;
  $[0] !== props2 || $[1] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentListItemRoot, { children: /* @__PURE__ */ jsx(CommentsListItem, { ...props2, avatarConfig: COMMENTS_LIST_ITEM_AVATAR_CONFIG, canReply: !0, isSelected: !1, mode: t0 }) }), $[0] = props2, $[1] = t0, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== parentComment.authorId || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(ActivityItem, { userId: parentComment.authorId, avatarPaddingTop: 3, children: t1 }), $[3] = parentComment.authorId, $[4] = t1, $[5] = t2) : t2 = $[5], t2;
}
const UserSkeleton = styled(TextSkeleton)`
  max-width: 15ch;
  width: '100%';
`, TasksActivityCreatedAt = memo(function(props2) {
  const $ = c(22), {
    createdAt,
    authorId
  } = props2, [user, loading] = useUser(authorId), {
    timeAgo,
    formattedDate
  } = useUpdatedTimeAgo(createdAt), {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    fontWeight: 600
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== loading || $[2] !== t || $[3] !== user?.displayName ? (t1 = loading ? /* @__PURE__ */ jsx(UserSkeleton, {}) : user?.displayName ?? t("panel.activity.unknown-user"), $[1] = loading, $[2] = t, $[3] = user?.displayName, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== t1 ? (t2 = /* @__PURE__ */ jsxs("strong", { style: t0, children: [
    t1,
    " "
  ] }), $[5] = t1, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== t ? (t3 = t("panel.activity.created-fragment"), $[7] = t, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== createdAt || $[10] !== timeAgo ? (t4 = /* @__PURE__ */ jsx(NoWrap, { children: /* @__PURE__ */ jsx("time", { dateTime: createdAt, children: timeAgo }) }), $[9] = createdAt, $[10] = timeAgo, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== formattedDate || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(Tooltip, { content: formattedDate, placement: "top-end", children: t4 }), $[12] = formattedDate, $[13] = t4, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== t2 || $[16] !== t3 || $[17] !== t5 ? (t6 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingTop: 1, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, muted: !0, children: [
    t2,
    t3,
    " \u2022",
    " ",
    t5
  ] }) }), $[15] = t2, $[16] = t3, $[17] = t5, $[18] = t6) : t6 = $[18];
  let t7;
  return $[19] !== authorId || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsx(ActivityItem, { userId: authorId, children: t6 }), $[19] = authorId, $[20] = t6, $[21] = t7) : t7 = $[21], t7;
}, (prevProps, nextProps) => prevProps.createdAt === nextProps.createdAt);
function TasksSubscribers(props2) {
  const $ = c(13), {
    value,
    onChange,
    path,
    currentUserId
  } = props2, buttonText = value.subscribers?.includes(currentUserId) ? "Unsubscribe" : "Subscribe";
  let t0;
  $[0] !== currentUserId || $[1] !== onChange || $[2] !== path || $[3] !== value.subscribers ? (t0 = () => {
    const subscribers2 = value.subscribers || [];
    subscribers2.includes(currentUserId) || onChange(set(subscribers2.concat(currentUserId), path)), subscribers2.includes(currentUserId) && onChange(set(subscribers2.filter((subscriberId) => subscriberId !== currentUserId), path));
  }, $[0] = currentUserId, $[1] = onChange, $[2] = path, $[3] = value.subscribers, $[4] = t0) : t0 = $[4];
  const handleToggleSubscribe = t0;
  let t1;
  $[5] !== buttonText || $[6] !== handleToggleSubscribe ? (t1 = /* @__PURE__ */ jsx(Button, { mode: "bleed", text: buttonText, onClick: handleToggleSubscribe }), $[5] = buttonText, $[6] = handleToggleSubscribe, $[7] = t1) : t1 = $[7];
  let t2;
  $[8] !== value.subscribers ? (t2 = value.subscribers && value.subscribers?.length > 0 && /* @__PURE__ */ jsx(TasksSubscriberAvatars, { subscriberIds: value.subscribers }), $[8] = value.subscribers, $[9] = t2) : t2 = $[9];
  let t3;
  return $[10] !== t1 || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t1,
    t2
  ] }), $[10] = t1, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}
const EMPTY_ARRAY$a = [];
function TasksSubscriberAvatars(props2) {
  const {
    subscriberIds: subscriberIdsProp
  } = props2, subscriberIds = useMemo(() => subscriberIdsProp?.filter(Boolean) || EMPTY_ARRAY$a, [subscriberIdsProp]);
  return /* @__PURE__ */ jsx(AnimatePresence, { initial: !1, children: /* @__PURE__ */ jsx(AvatarStack, { maxLength: 3, size: 0, children: subscriberIds.map((subscriberId) => /* @__PURE__ */ jsx(motion.div, { exit: {
    opacity: 0,
    translateX: "2px",
    scale: 0.9
  }, animate: {
    opacity: 1,
    translateX: 0,
    scale: 1,
    transition: {
      type: "just",
      duration: 0.2
    }
  }, initial: {
    opacity: 0,
    translateX: "2px",
    scale: 0.9
  }, children: /* @__PURE__ */ jsx(TasksUserAvatar, { user: {
    id: subscriberId
  }, size: 0 }) }, subscriberId)) }) });
}
const EMPTY_ARRAY$9 = [], VARIANTS$2 = {
  hidden: {
    opacity: 0,
    x: 0
  },
  visible: {
    opacity: 1,
    x: 0
  }
}, MotionStack = styled(motion.create(Stack))``;
function TasksActivityLog(props2) {
  const {
    value,
    onChange,
    path,
    activityData = []
  } = props2, currentUser = useCurrentUser(), {
    title: workspaceTitle,
    basePath
  } = useWorkspace(), {
    comments: comments2,
    mentionOptions,
    operation,
    getComment
  } = useComments(), [commentToDeleteId, setCommentToDeleteId] = useState(null), [commentDeleteError, setCommentDeleteError] = useState(null), [commentDeleteLoading, setCommentDeleteLoading] = useState(!1), loading = comments2.loading, taskComments = comments2.data.open, handleGetNotificationValue = useCallback((message, commentId) => {
    const studioUrl = new URL(`${window.location.origin}${basePath ? `${basePath}/` : ""}`);
    studioUrl.searchParams.set("sidebar", "tasks"), studioUrl.searchParams.set("selectedTask", value?._id), studioUrl.searchParams.set("viewMode", "edit"), studioUrl.searchParams.set("commentId", commentId);
    const mentionedUsers = getMentionedUsers(message), subscribers2 = Array.from(/* @__PURE__ */ new Set([...value.subscribers || [], ...mentionedUsers]));
    return {
      documentTitle: value.title || "Sanity task",
      url: studioUrl.toString(),
      workspaceTitle,
      subscribers: subscribers2
    };
  }, [basePath, value?._id, value.title, workspaceTitle, value.subscribers]), handleCommentCreate = useCallback((message_0) => {
    const commentId_0 = uuid(), notification = handleGetNotificationValue(message_0, commentId_0), nextComment = {
      id: commentId_0,
      type: "task",
      message: message_0,
      parentCommentId: void 0,
      reactions: EMPTY_ARRAY$9,
      status: "open",
      threadId: uuid(),
      context: {
        notification
      }
    };
    onChange(set(notification.subscribers, ["subscribers"])), operation.create(nextComment);
  }, [operation, handleGetNotificationValue, onChange]), handleCommentReply = useCallback((nextComment_0) => {
    const commentId_1 = uuid(), notification_0 = handleGetNotificationValue(nextComment_0.message, commentId_1);
    onChange(set(notification_0.subscribers, ["subscribers"])), operation.create({
      id: commentId_1,
      type: "task",
      message: nextComment_0.message,
      parentCommentId: nextComment_0.parentCommentId,
      reactions: EMPTY_ARRAY$9,
      status: "open",
      threadId: nextComment_0.threadId,
      context: {
        notification: notification_0
      }
    });
  }, [operation, handleGetNotificationValue, onChange]), handleCommentCreateRetry = useCallback((id2) => {
    const comment = getComment(id2);
    if (!comment) return;
    const notification_1 = handleGetNotificationValue(comment.message, comment._id);
    onChange(set(notification_1.subscribers, ["subscribers"])), operation.create({
      type: "task",
      id: comment._id,
      message: comment.message,
      parentCommentId: comment.parentCommentId,
      reactions: comment.reactions || EMPTY_ARRAY$9,
      status: comment.status,
      threadId: comment.threadId,
      context: {
        notification: notification_1
      }
    });
  }, [getComment, operation, handleGetNotificationValue, onChange]), handleCommentReact = useCallback((id_0, reaction) => {
    operation.react(id_0, reaction);
  }, [operation]), handleDeleteCommentStart = useCallback((id_1) => setCommentToDeleteId(id_1), []), handleDeleteCommentCancel = useCallback(() => setCommentToDeleteId(null), []), handleDeleteCommentConfirm = useCallback(async (id_2) => {
    try {
      setCommentDeleteLoading(!0), setCommentDeleteError(null), await operation.remove(id_2), setCommentToDeleteId(null);
    } catch (err) {
      setCommentDeleteError(err);
    } finally {
      setCommentDeleteLoading(!1);
    }
  }, [operation]), handleCommentEdit = useCallback((id_3, next) => {
    operation.update(id_3, next);
  }, [operation]), activity = useMemo(() => {
    const taskActivity = activityData.map((item) => ({
      _type: "activity",
      payload: item,
      timestamp: item.timestamp
    })), commentsActivity = taskComments.map((comment_0) => ({
      _type: "comment",
      payload: comment_0,
      timestamp: comment_0.parentComment._createdAt
    }));
    return taskActivity.concat(commentsActivity).sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
  }, [activityData, taskComments]), {
    t
  } = useTranslation(tasksLocaleNamespace), commentToDeleteIsParent = useMemo(() => {
    const parent = taskComments.find((c2) => c2.parentComment?._id === commentToDeleteId);
    return !!(parent && parent?.replies?.length > 0);
  }, [commentToDeleteId, taskComments]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    commentToDeleteId && /* @__PURE__ */ jsx(CommentDeleteDialog, { commentId: commentToDeleteId, error: commentDeleteError, isParent: commentToDeleteIsParent, loading: commentDeleteLoading, onClose: handleDeleteCommentCancel, onConfirm: handleDeleteCommentConfirm }),
    /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
      /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
        /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "semibold", children: t("panel.activity.title") }) }),
        currentUser?.id && /* @__PURE__ */ jsx(TasksSubscribers, { currentUserId: currentUser.id, value, onChange, path })
      ] }),
      loading && /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: "Loading activity" }),
      /* @__PURE__ */ jsx(AnimatePresence, { children: !loading && /* @__PURE__ */ jsxs(MotionStack, { animate: "visible", initial: "hidden", space: 4, variants: VARIANTS$2, children: [
        value.createdByUser && /* @__PURE__ */ jsx(Stack, { paddingBottom: 1, children: /* @__PURE__ */ jsx(TasksActivityCreatedAt, { createdAt: value.createdByUser, authorId: value.authorId }) }),
        currentUser && /* @__PURE__ */ jsxs(Stack, { space: 4, marginTop: 1, children: [
          activity.map((item_0) => item_0._type === "activity" ? /* @__PURE__ */ jsx(EditedAt, { activity: item_0.payload }, item_0.timestamp) : /* @__PURE__ */ jsx(TasksActivityCommentItem, { currentUser, mentionOptions, onCreateRetry: handleCommentCreateRetry, onDelete: handleDeleteCommentStart, onEdit: handleCommentEdit, onReactionSelect: handleCommentReact, onReply: handleCommentReply, parentComment: item_0.payload.parentComment, replies: item_0.payload.replies }, item_0.payload.parentComment._id)),
          /* @__PURE__ */ jsx(TasksActivityCommentInput, { currentUser, mentionOptions, onSubmit: handleCommentCreate })
        ] })
      ] }) })
    ] })
  ] });
}
function MentionUserMenuItem(props2) {
  const $ = c(21), {
    user,
    onSelect,
    pressed
  } = props2, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t0;
  $[0] !== onSelect || $[1] !== user.id ? (t0 = () => onSelect(user.id), $[0] = onSelect, $[1] = user.id, $[2] = t0) : t0 = $[2];
  const handleSelect = t0, t1 = !user.granted, t2 = user.id ? user : void 0;
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: t2, size: 1 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== user.displayName ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", title: user.displayName, children: user.displayName }), $[5] = user.displayName, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t3 || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, flex: 1, children: [
    t3,
    t4
  ] }), $[7] = t3, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t || $[11] !== user.granted ? (t6 = !user.granted && /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", children: t("form.input.assignee.unauthorized.text") }), $[10] = t, $[11] = user.granted, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t5 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t5,
    t6
  ] }), $[13] = t5, $[14] = t6, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== handleSelect || $[17] !== pressed || $[18] !== t1 || $[19] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuItem, { onClick: handleSelect, padding: 1, disabled: t1, pressed, children: t7 }), $[16] = handleSelect, $[17] = pressed, $[18] = t1, $[19] = t7, $[20] = t8) : t8 = $[20], t8;
}
const StyledMenu$6 = styled(Menu)`
  width: 308px;
  border-radius: 3px;
`, IGNORED_KEYS = ["Control", "Shift", "Alt", "Enter", "Home", "End", "PageUp", "PageDown", "Meta", "Tab", "CapsLock"], NO_ASSIGNEE_OPTION = {
  id: "",
  displayName: "No assignee",
  granted: !0
};
function MentionsMenu$1({
  onSelect,
  value = ""
}) {
  const [searchTerm, setSearchTerm] = useState(""), {
    mentionOptions
  } = useMentionUser(), inputRef = useRef(null), options = [NO_ASSIGNEE_OPTION].concat(mentionOptions.data || []), handleSearchChange = useCallback((event) => {
    setSearchTerm(event.currentTarget.value);
  }, []), filteredOptions = useMemo(() => {
    if (!searchTerm) return options || [];
    const deburredSearchTerm = deburr(searchTerm).toLocaleLowerCase();
    return options?.map((option) => ({
      ...option,
      searchName: deburr(option.displayName || "").toLocaleLowerCase()
    }))?.filter((option_0) => option_0?.searchName.includes(deburredSearchTerm))?.sort((a, b) => {
      const matchA = a.searchName.startsWith(deburredSearchTerm), matchB = b.searchName.startsWith(deburredSearchTerm);
      return matchA && !matchB ? -1 : !matchA && matchB ? 1 : 0;
    }) || [];
  }, [options, searchTerm]), renderItem2 = useCallback((user) => /* @__PURE__ */ jsx(MentionUserMenuItem, { user, onSelect, pressed: user.id === value }, user.id), [onSelect, value]), handleKeyDown = useCallback((event_0) => {
    event_0.target !== inputRef.current && (IGNORED_KEYS.includes(event_0.key) || inputRef.current?.focus());
  }, []), {
    t
  } = useTranslation(tasksLocaleNamespace);
  return mentionOptions.loading ? /* @__PURE__ */ jsx(Container$2, { width: 0, children: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }) : /* @__PURE__ */ jsxs("div", { onKeyDown: handleKeyDown, children: [
    /* @__PURE__ */ jsx(TextInput$1, { placeholder: t("form.input.assignee.search.placeholder"), autoFocus: !0, border: !1, onChange: handleSearchChange, value: searchTerm, fontSize: 1, icon: UserIcon, ref: inputRef, name: "assigneeSearch", autoComplete: "off" }),
    /* @__PURE__ */ jsx("div", { style: {
      maxHeight: "320px",
      overflowY: "scroll",
      paddingTop: "8px"
    }, children: filteredOptions.length === 0 ? /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, muted: !0, children: t("form.input.assignee.search.no-users.text") }) }) : /* @__PURE__ */ jsx(VirtualList$1, { items: filteredOptions, renderItem: renderItem2 }) })
  ] });
}
function AssigneeSelectionMenu(props2) {
  const $ = c(7), {
    onSelect,
    menuButton,
    value
  } = props2;
  let t0;
  $[0] !== onSelect || $[1] !== value ? (t0 = /* @__PURE__ */ jsx(StyledMenu$6, { children: /* @__PURE__ */ jsx(MentionsMenu$1, { onSelect, value }) }), $[0] = onSelect, $[1] = value, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    placement: "bottom",
    fallbackPlacements: ["bottom"],
    portal: !0,
    constrainSize: !0
  }, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== menuButton || $[5] !== t0 ? (t2 = /* @__PURE__ */ jsx(MenuButton$1, { button: menuButton, id: "assign-user-menu", menu: t0, popover: t1 }), $[4] = menuButton, $[5] = t0, $[6] = t2) : t2 = $[6], t2;
}
const FocusableCard = styled(Card)((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    &[data-as='button'] {
      border: 1px solid var(--card-border-color);
      &:focus-within {
        border: 1px solid var(--card-focus-ring-color);
      }
      --card-muted-fg-color: ${theme.color.input.default.enabled.placeholder};
    }
  `;
});
function AssigneeCreateFormField(props2) {
  const $ = c(29), {
    value,
    onChange
  } = props2, {
    mentionOptions
  } = useMentionUser();
  let t0, t1;
  $[0] !== mentionOptions.data || $[1] !== value ? (t1 = mentionOptions.data?.find((u) => u.id === value), $[0] = mentionOptions.data, $[1] = value, $[2] = t1) : t1 = $[2], t0 = t1;
  const mentionedUser = t0;
  let t2;
  $[3] !== onChange ? (t2 = (userId) => onChange(set(userId)), $[3] = onChange, $[4] = t2) : t2 = $[4];
  const onSelect = t2, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t3;
  bb0: {
    if (value) {
      if (mentionOptions.loading) {
        let t43;
        $[5] === Symbol.for("react.memo_cache_sentinel") ? (t43 = /* @__PURE__ */ jsx(TextSkeleton, { animated: !0, style: {
          width: "10ch"
        } }), $[5] = t43) : t43 = $[5], t3 = t43;
        break bb0;
      }
      if (mentionedUser) {
        t3 = mentionedUser.displayName || mentionedUser.email;
        break bb0;
      }
      if (!mentionedUser) {
        let t43;
        $[6] !== t ? (t43 = t("form.input.assignee.user-not-found.text"), $[6] = t, $[7] = t43) : t43 = $[7], t3 = t43;
        break bb0;
      }
    }
    let t42;
    $[8] !== t ? (t42 = t("form.input.assignee.search.placeholder"), $[8] = t, $[9] = t42) : t42 = $[9], t3 = t42;
  }
  const displayText = t3;
  let t4;
  $[10] !== mentionedUser ? (t4 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: mentionedUser, size: 1, border: !1 }), $[10] = mentionedUser, $[11] = t4) : t4 = $[11];
  const t5 = !mentionedUser;
  let t6;
  $[12] !== displayText || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", muted: t5, children: displayText }), $[12] = displayText, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== t4 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, flex: 1, children: [
    t4,
    t6
  ] }), $[15] = t4, $[16] = t6, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== mentionedUser || $[19] !== t || $[20] !== value ? (t8 = value && mentionedUser && !mentionedUser.granted && /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", children: t("form.input.assignee.unauthorized.text") }), $[18] = mentionedUser, $[19] = t, $[20] = value, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] !== t7 || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsx(FocusableCard, { "data-as": "button", padding: 1, radius: 2, tabIndex: 0, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t7,
    t8
  ] }) }), $[22] = t7, $[23] = t8, $[24] = t9) : t9 = $[24];
  let t10;
  return $[25] !== onSelect || $[26] !== t9 || $[27] !== value ? (t10 = /* @__PURE__ */ jsx(AssigneeSelectionMenu, { onSelect, value, menuButton: t9 }), $[25] = onSelect, $[26] = t9, $[27] = value, $[28] = t10) : t10 = $[28], t10;
}
const StyledButton$2 = styled(Button$1)`
  padding: 3px 6px;
`;
function AssigneeEditFormField(props2) {
  const $ = c(37), {
    value,
    onChange,
    path
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = ["subscribers"], $[0] = t0) : t0 = $[0];
  const subscribers2 = useFormValue(t0), {
    mentionOptions
  } = useMentionUser();
  let t1, t2;
  $[1] !== mentionOptions.data || $[2] !== value ? (t2 = mentionOptions.data?.find((u) => u.id === value), $[1] = mentionOptions.data, $[2] = value, $[3] = t2) : t2 = $[3], t1 = t2;
  const mentionedUser = t1, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t3;
  $[4] !== onChange || $[5] !== path || $[6] !== subscribers2 ? (t3 = (userId) => {
    onChange(set(userId, path)), subscribers2 && !subscribers2.includes(userId) && userId && onChange(set([...subscribers2, userId], ["subscribers"]));
  }, $[4] = onChange, $[5] = path, $[6] = subscribers2, $[7] = t3) : t3 = $[7];
  const onSelect = t3;
  let t4;
  bb0: {
    if (value) {
      if (mentionOptions.loading) {
        let t53;
        $[8] === Symbol.for("react.memo_cache_sentinel") ? (t53 = /* @__PURE__ */ jsx(TextSkeleton, { animated: !0, style: {
          width: "10ch"
        } }), $[8] = t53) : t53 = $[8], t4 = t53;
        break bb0;
      }
      if (mentionedUser) {
        t4 = mentionedUser.displayName || mentionedUser.email;
        break bb0;
      }
      if (!mentionedUser) {
        let t53;
        $[9] !== t ? (t53 = t("form.input.assignee.user-not-found.text"), $[9] = t, $[10] = t53) : t53 = $[10], t4 = t53;
        break bb0;
      }
    }
    let t52;
    $[11] !== t ? (t52 = t("form.input.assignee.no-user-assigned.text"), $[11] = t, $[12] = t52) : t52 = $[12], t4 = t52;
  }
  const displayText = t4;
  let t5;
  $[13] !== t || $[14] !== value ? (t5 = t(value ? "form.input.assignee.user-assigned.tooltip" : "form.input.assignee.no-user-assigned.tooltip"), $[13] = t, $[14] = value, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== mentionedUser ? (t6 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: mentionedUser, size: 0 }), $[16] = mentionedUser, $[17] = t6) : t6 = $[17];
  let t7;
  $[18] !== displayText ? (t7 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: displayText }) }), $[18] = displayText, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== t6 || $[21] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, flex: 1, children: [
    t6,
    t7
  ] }), $[20] = t6, $[21] = t7, $[22] = t8) : t8 = $[22];
  let t9;
  $[23] !== mentionedUser || $[24] !== t || $[25] !== value ? (t9 = value && mentionedUser && !mentionedUser.granted && /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", children: t("form.input.assignee.unauthorized.text") }), $[23] = mentionedUser, $[24] = t, $[25] = value, $[26] = t9) : t9 = $[26];
  let t10;
  $[27] !== t8 || $[28] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t8,
    t9
  ] }), $[27] = t8, $[28] = t9, $[29] = t10) : t10 = $[29];
  let t11;
  $[30] !== t10 || $[31] !== t5 ? (t11 = /* @__PURE__ */ jsx(StyledButton$2, { mode: "ghost", padding: 0, children: /* @__PURE__ */ jsx(Tooltip, { content: t5, children: t10 }) }), $[30] = t10, $[31] = t5, $[32] = t11) : t11 = $[32];
  let t12;
  return $[33] !== onSelect || $[34] !== t11 || $[35] !== value ? (t12 = /* @__PURE__ */ jsx(AssigneeSelectionMenu, { onSelect, value, menuButton: t11 }), $[33] = onSelect, $[34] = t11, $[35] = value, $[36] = t12) : t12 = $[36], t12;
}
const serialize = (date) => format$3(date, DEFAULT_DATE_FORMAT), deserialize = (value) => parse$1(value, DEFAULT_DATE_FORMAT);
function DateEditFormField(props2) {
  const {
    value,
    onChange,
    path
  } = props2, {
    t: coreT
  } = useTranslation(), {
    t
  } = useTranslation(tasksLocaleNamespace), [pickerOpen, setPickerOpen] = useState(!1), popoverRef = useRef(null), buttonRef = useRef(null), dateFormatter = useDateTimeFormat({
    dateStyle: "long"
  }), dueByeDisplayValue = useMemo(() => {
    if (!value) return {
      short: "----",
      full: "----"
    };
    const dueFormated = dateFormatter.format(new Date(value)), [monthAndDay] = dueFormated.split(",");
    return {
      short: monthAndDay,
      full: dueFormated
    };
  }, [dateFormatter, value]);
  useClickOutsideEvent(() => setPickerOpen(!1), () => [popoverRef.current]);
  const handleKeyUp = useCallback((e) => {
    e.key === "Escape" && setPickerOpen(!1);
  }, []), handleClick = useCallback(() => setPickerOpen((p) => !p), []), calendarLabels = useMemo(() => getCalendarLabels(coreT), [coreT]), handleChange = useCallback((nextDate) => {
    onChange(nextDate ? set(serialize(nextDate), path) : unset(path)), setPickerOpen(!1);
  }, [onChange, path]), deserializedValue = deserialize(value), handleDeactivation = useCallback(() => {
    buttonRef.current?.focus();
  }, [buttonRef]), dueDateIsThisYear = deserializedValue?.date?.getFullYear() === (/* @__PURE__ */ new Date()).getFullYear();
  return /* @__PURE__ */ jsx(Popover, { constrainSize: !0, "data-testid": "date-input-dialog", portal: !0, ref: popoverRef, content: /* @__PURE__ */ jsx(Box, { overflow: "auto", children: /* @__PURE__ */ jsxs(FocusLock, { onDeactivation: handleDeactivation, children: [
    /* @__PURE__ */ jsx(DatePicker$2, { calendarLabels, selectTime: !1, timeStep: 1, onKeyUp: handleKeyUp, value: deserializedValue.date, onChange: handleChange }),
    value && /* @__PURE__ */ jsx(Flex, { justify: "flex-start", padding: 3, paddingTop: 0, children: /* @__PURE__ */ jsx(Button, { mode: "bleed", text: t("form.input.date.buttons.remove.text"), onClick: () => handleChange(null), tone: "critical" }) })
  ] }) }), open: pickerOpen, placement: "bottom", fallbackPlacements: ["bottom-start", "bottom-end"], children: /* @__PURE__ */ jsx(Button, { icon: CalendarIcon, mode: "ghost", text: dueDateIsThisYear ? dueByeDisplayValue.short : dueByeDisplayValue.full, onClick: handleClick, ref: buttonRef, tooltipProps: {
    content: t(value ? "form.input.date.buttons.tooltip" : "form.input.date.buttons.empty.tooltip")
  } }) });
}
const NormalText$1 = styled(Text$1)`
  word-break: break-word;
`;
function DescriptionInputBlock(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(Box, { paddingTop: 2, paddingBottom: 3, children: /* @__PURE__ */ jsx(NormalText$1, { size: 1, children }) }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
const renderBlock$1 = (blockProps) => {
  const {
    children
  } = blockProps;
  return /* @__PURE__ */ jsx(DescriptionInputBlock, { children });
}, DescriptionInputRoot = styled.div((props2) => {
  const theme = getTheme_v2(props2.theme), verticalPadding = props2.$mode === "edit" ? theme.space[1] : theme.space[3], minHeight = props2.$mode === "edit" ? 120 : 200;
  return css`
    /* select CommentInputEditableWrap and change the padding */
    [data-ui='CommentInputEditableWrap'] {
      overflow: hidden;
      padding: ${props2.$mode === "edit" ? `${verticalPadding}px 0px` : `${verticalPadding}px ${theme.space[2]}px`};
      min-height: ${Math.max(props2.$minHeight + verticalPadding, minHeight)}px !important;
    }
    #comment-input-root {
      box-shadow: ${props2.$mode === "edit" ? "none" : ""};
    }
    [data-ui='CommentInputActions'] {
      display: none !important;
    }
  `;
});
function DescriptionInput(props2) {
  const $ = c(23), {
    value: _propValue,
    mode,
    inputProps: t0
  } = props2, {
    onChange
  } = t0, value = _propValue, currentUser = useCurrentUser(), {
    mentionOptions
  } = useMentionUser();
  let t1;
  $[0] !== onChange ? (t1 = (next) => onChange(set(next)), $[0] = onChange, $[1] = t1) : t1 = $[1];
  const handleChange = t1, [rootRef, setRootRef] = useState(null), [textBoxScrollHeight, setTextBoxScrollHeight] = useState(200);
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (ref) => {
    const textBox = ref.querySelector('[role="textbox"]');
    if (!textBox)
      return;
    const height = textBox.scrollHeight;
    setTextBoxScrollHeight(height);
  }, $[2] = t2) : t2 = $[2];
  const setTextboxHeight = t2;
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (ref_0) => {
    ref_0 && startTransition(() => {
      setRootRef(ref_0);
    });
  }, $[3] = t3) : t3 = $[3];
  const handleSetRootRef = t3, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t4;
  $[4] !== rootRef ? (t4 = () => {
    rootRef && setTextboxHeight(rootRef);
  }, $[4] = rootRef, $[5] = t4) : t4 = $[5];
  let t5;
  if ($[6] !== rootRef || $[7] !== value ? (t5 = [value, setTextboxHeight, rootRef], $[6] = rootRef, $[7] = value, $[8] = t5) : t5 = $[8], useEffect(t4, t5), !currentUser)
    return null;
  let t6;
  $[9] !== value ? (t6 = value ?? [], $[9] = value, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t ? (t7 = t("form.input.description.placeholder"), $[11] = t, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== currentUser || $[14] !== handleChange || $[15] !== mentionOptions || $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(CommentInput, { expandOnFocus: !1, currentUser, mentionOptions, onChange: handleChange, value: t6, withAvatar: !1, placeholder: t7, onDiscardConfirm: _temp$A, renderBlock: renderBlock$1 }), $[13] = currentUser, $[14] = handleChange, $[15] = mentionOptions, $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  return $[19] !== mode || $[20] !== t8 || $[21] !== textBoxScrollHeight ? (t9 = /* @__PURE__ */ jsx(DescriptionInputRoot, { $mode: mode, ref: handleSetRootRef, $minHeight: textBoxScrollHeight, children: t8 }), $[19] = mode, $[20] = t8, $[21] = textBoxScrollHeight, $[22] = t9) : t9 = $[22], t9;
}
function _temp$A() {
  return null;
}
const FieldWrapperRoot = styled.div((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    // Reset the padding of the field header content box
    [data-ui='fieldHeaderContentBox'] {
      padding: 0;
      label {
        font-weight: ${theme.font.text.weights.regular};
      }
    }
  `;
});
function FieldWrapper(props2) {
  const $ = c(4);
  let t0;
  $[0] !== props2 ? (t0 = props2.renderDefault(props2), $[0] = props2, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(FieldWrapperRoot, { children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
const StatusMenuButton = forwardRef(function(props2, ref) {
  const $ = c(21), {
    t
  } = useTranslation(tasksLocaleNamespace);
  let options, rest, value;
  $[0] !== props2 ? ({
    value,
    options,
    ...rest
  } = props2, $[0] = props2, $[1] = options, $[2] = rest, $[3] = value) : (options = $[1], rest = $[2], value = $[3]);
  let t0;
  if ($[4] !== options || $[5] !== value) {
    let t12;
    $[7] !== value ? (t12 = (option) => option.value === value, $[7] = value, $[8] = t12) : t12 = $[8], t0 = options.find(t12), $[4] = options, $[5] = value, $[6] = t0;
  } else
    t0 = $[6];
  const selectedOption = t0;
  let t1;
  $[9] !== value ? (t1 = TASK_STATUS.find((status) => status.value === value)?.icon, $[9] = value, $[10] = t1) : t1 = $[10];
  const icon = t1;
  let t2;
  $[11] !== t ? (t2 = t("form.input.status.button.tooltip"), $[11] = t, $[12] = t2) : t2 = $[12];
  let t3;
  $[13] !== t2 ? (t3 = {
    content: t2
  }, $[13] = t2, $[14] = t3) : t3 = $[14];
  const t4 = selectedOption?.title || value;
  let t5;
  return $[15] !== icon || $[16] !== ref || $[17] !== rest || $[18] !== t3 || $[19] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { ...rest, ref, tooltipProps: t3, icon, text: t4, tone: "default", mode: "ghost" }), $[15] = icon, $[16] = ref, $[17] = rest, $[18] = t3, $[19] = t4, $[20] = t5) : t5 = $[20], t5;
});
function StatusSelector(props2) {
  const $ = c(20), {
    value,
    onChange,
    options,
    path
  } = props2, telemetry = useTelemetry();
  let t0;
  $[0] !== onChange || $[1] !== path || $[2] !== telemetry || $[3] !== value ? (t0 = (next) => {
    onChange(set(next, path)), telemetry.log(TaskStatusChanged, {
      from: value,
      to: next
    });
  }, $[0] = onChange, $[1] = path, $[2] = telemetry, $[3] = value, $[4] = t0) : t0 = $[4];
  const handleStatusChange = t0;
  let t1;
  $[5] !== options || $[6] !== value ? (t1 = /* @__PURE__ */ jsx(StatusMenuButton, { value, options }), $[5] = options, $[6] = value, $[7] = t1) : t1 = $[7];
  let t2;
  if ($[8] !== handleStatusChange || $[9] !== options || $[10] !== value) {
    let t32;
    $[12] !== handleStatusChange || $[13] !== value ? (t32 = (option) => {
      const isSelected = value === option.value, icon = TASK_STATUS.find((status) => status.value === option.value)?.icon;
      return /* @__PURE__ */ jsx(MenuItem$1, { icon: typeof option.value == "string" ? icon || CircleIcon : CircleIcon, text: option.title || option.value, pressed: isSelected, iconRight: isSelected && /* @__PURE__ */ jsx(CheckmarkIcon, {}), onClick: () => handleStatusChange(option.value) }, option.title);
    }, $[12] = handleStatusChange, $[13] = value, $[14] = t32) : t32 = $[14], t2 = options.map(t32), $[8] = handleStatusChange, $[9] = options, $[10] = value, $[11] = t2;
  } else
    t2 = $[11];
  let t3;
  $[15] !== t2 ? (t3 = /* @__PURE__ */ jsx(Menu, { children: t2 }), $[15] = t2, $[16] = t3) : t3 = $[16];
  let t4;
  return $[17] !== t1 || $[18] !== t3 ? (t4 = /* @__PURE__ */ jsx(MenuButton$1, { button: t1, id: "reference-menuButton", menu: t3 }), $[17] = t1, $[18] = t3, $[19] = t4) : t4 = $[19], t4;
}
function ConfigErrorsScreen$1() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("div", { children: "Config errors" }), $[0] = t0) : t0 = $[0], t0;
}
function CurrentWorkspaceProvider(t0) {
  const $ = c(2), {
    children
  } = t0;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(WorkspaceLoaderBoundary, { LoadingComponent: LoadingBlock, ConfigErrorsComponent: ConfigErrorsScreen$1, children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}
const EmptyReferenceRoot = styled(Card)((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    &:focus {
      border: 1px solid var(--card-focus-ring-color);
    }
    &:focus-visible {
      outline: none;
      border: 1px solid var(--card-focus-ring-color);
    }
    &:hover {
      border-color: ${theme.color.input.default.hovered.border};
    }
  `;
}), Placeholder = styled(Text$1)((props2) => `
      color: ${getTheme_v2(props2.theme).color.input.default.enabled.placeholder};
      margin-left: 3px;
  `), TargetRoot = styled(Card)`
  position: relative;
  [data-ui='show-on-hover'] {
    opacity: 0;
    position: absolute;
    right: 6px;
    top: 4px;
    display: flex;
  }
  &:focus-within,
  &:hover {
    padding-right: 36px;
    /* Hides the preview status dot, the button will take it's position. */
    [data-testid='compact-preview__status'] {
      opacity: 0;
    }
    [data-ui='show-on-hover'] {
      transition: opacity 200ms;
      opacity: 1;
    }
  }
`, StyledIntentLink$1 = styled(IntentLink)(() => css`
    text-decoration: none;
    width: 100%;
    overflow: hidden;
    cursor: pointer;
    &:focus {
      box-shadow: 0 0 0 1px var(--card-focus-ring-color);
    }
    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 1px var(--card-focus-ring-color);
    }
  `);
function Preview(props2) {
  const $ = c(28), {
    value,
    handleRemove
  } = props2, documentId = value.document._ref, documentType = value.documentType, schema2 = useSchema();
  let t0;
  $[0] !== schema2 || $[1] !== value.documentType ? (t0 = schema2.get(value.documentType), $[0] = schema2, $[1] = value.documentType, $[2] = t0) : t0 = $[2];
  const schemaType = t0, documentPresence = useDocumentPresence(documentId), {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1, t2;
  $[3] !== documentId || $[4] !== documentType ? (t2 = forwardRef(function(linkProps, ref) {
    const versionId = getVersionFromId(documentId);
    return /* @__PURE__ */ jsx(StyledIntentLink$1, { ...linkProps, intent: "edit", params: {
      id: getPublishedId(documentId),
      type: documentType
    }, ref, searchParams: versionId ? [["perspective", versionId]] : void 0 });
  }), $[3] = documentId, $[4] = documentType, $[5] = t2) : t2 = $[5], t1 = t2;
  const CardLink = t1;
  if (!schemaType) {
    let t32;
    $[6] !== t ? (t32 = t("form.input.target.error.schema-not-found"), $[6] = t, $[7] = t32) : t32 = $[7];
    let t42;
    return $[8] !== t32 ? (t42 = /* @__PURE__ */ jsx(Text$1, { children: t32 }), $[8] = t32, $[9] = t42) : t42 = $[9], t42;
  }
  let t3;
  $[10] !== documentPresence || $[11] !== documentType || $[12] !== schemaType || $[13] !== value.document._ref ? (t3 = /* @__PURE__ */ jsx(SearchResultItemPreview, { documentType, documentId: value.document._ref, layout: "compact", presence: documentPresence, schemaType, showBadge: !1 }), $[10] = documentPresence, $[11] = documentType, $[12] = schemaType, $[13] = value.document._ref, $[14] = t3) : t3 = $[14];
  let t4;
  $[15] !== CardLink || $[16] !== t3 ? (t4 = /* @__PURE__ */ jsx(Card, { as: CardLink, radius: 2, "data-as": "button", children: t3 }), $[15] = CardLink, $[16] = t3, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== t ? (t5 = t("form.input.target.buttons.remove.text"), $[18] = t, $[19] = t5) : t5 = $[19];
  let t6;
  $[20] !== t5 ? (t6 = {
    content: t5
  }, $[20] = t5, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== handleRemove || $[23] !== t6 ? (t7 = /* @__PURE__ */ jsx("div", { "data-ui": "show-on-hover", children: /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: handleRemove, tooltipProps: t6 }) }), $[22] = handleRemove, $[23] = t6, $[24] = t7) : t7 = $[24];
  let t8;
  return $[25] !== t4 || $[26] !== t7 ? (t8 = /* @__PURE__ */ jsx(TargetRoot, { border: !0, radius: 2, children: /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", justify: "space-between", children: [
    t4,
    t7
  ] }) }), $[25] = t4, $[26] = t7, $[27] = t8) : t8 = $[27], t8;
}
function TargetField(props2) {
  const $ = c(32), [open, setOpen] = useState(!1), {
    dataset,
    projectId
  } = useWorkspace(), {
    mode,
    inputProps: t0,
    value: _propValue
  } = props2, {
    onChange
  } = t0, value = _propValue;
  let t1;
  $[0] !== dataset || $[1] !== onChange || $[2] !== projectId ? (t1 = (item) => {
    onChange(set(getTargetValue({
      documentId: item._id,
      documentType: item._type,
      dataset,
      projectId
    })));
  }, $[0] = dataset, $[1] = onChange, $[2] = projectId, $[3] = t1) : t1 = $[3];
  const handleItemSelect = t1;
  let t2;
  $[4] !== onChange ? (t2 = () => {
    onChange(unset());
  }, $[4] = onChange, $[5] = t2) : t2 = $[5];
  const handleRemove = t2;
  let t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setOpen(!0);
  }, $[6] = t3) : t3 = $[6];
  const handleOpenSearch = t3;
  let t4;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setOpen(!1);
  }, $[7] = t4) : t4 = $[7];
  const handleCloseSearch = t4;
  let t5;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (event) => {
    (event.key === "Enter" || event.key === " ") && setOpen(!0);
  }, $[8] = t5) : t5 = $[8];
  const handleKeyDown = t5, {
    t
  } = useTranslation(tasksLocaleNamespace), t6 = mode === "edit", t7 = mode === "edit" ? 4 : 0;
  let t8;
  $[9] !== mode || $[10] !== props2.description || $[11] !== props2.inputId || $[12] !== props2.title || $[13] !== props2.validation ? (t8 = mode === "create" && /* @__PURE__ */ jsx(Box, { "data-ui": "fieldHeaderContentBox", children: /* @__PURE__ */ jsx(FormFieldHeaderText, { description: props2.description, inputId: props2.inputId, title: props2.title, validation: props2.validation, deprecated: void 0 }) }), $[9] = mode, $[10] = props2.description, $[11] = props2.inputId, $[12] = props2.title, $[13] = props2.validation, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== handleRemove || $[16] !== t || $[17] !== value ? (t9 = value ? /* @__PURE__ */ jsx(Preview, { value, handleRemove }) : /* @__PURE__ */ jsx(EmptyReferenceRoot, { border: !0, radius: 2, paddingX: 2, paddingY: 3, onClick: handleOpenSearch, onKeyDown: handleKeyDown, tabIndex: 0, children: /* @__PURE__ */ jsxs(Flex, { gap: 1, justify: "flex-start", align: "center", children: [
    /* @__PURE__ */ jsx(Box, { paddingX: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(DocumentIcon, {}) }) }),
    /* @__PURE__ */ jsx(Placeholder, { size: 1, children: t("form.input.target.search.placeholder") })
  ] }) }), $[15] = handleRemove, $[16] = t, $[17] = value, $[18] = t9) : t9 = $[18];
  let t10;
  $[19] !== t8 || $[20] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t8,
    t9
  ] }), $[19] = t8, $[20] = t9, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== handleItemSelect || $[23] !== open ? (t11 = /* @__PURE__ */ jsx(SearchPopover, { open, onClose: handleCloseSearch, onItemSelect: handleItemSelect, disableIntentLink: !0 }), $[22] = handleItemSelect, $[23] = open, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t10 || $[26] !== t11 ? (t12 = /* @__PURE__ */ jsx(FieldWrapperRoot, { children: /* @__PURE__ */ jsx(LayerProvider, { zOffset: 100, children: /* @__PURE__ */ jsx(CurrentWorkspaceProvider, { children: /* @__PURE__ */ jsxs(SearchProvider, { children: [
    t10,
    t11
  ] }) }) }) }), $[25] = t10, $[26] = t11, $[27] = t12) : t12 = $[27];
  let t13;
  return $[28] !== t12 || $[29] !== t6 || $[30] !== t7 ? (t13 = /* @__PURE__ */ jsx(Card, { borderBottom: t6, paddingBottom: t7, children: t12 }), $[28] = t12, $[29] = t6, $[30] = t7, $[31] = t13) : t13 = $[31], t13;
}
const Root$c = styled.div((props2) => `
      display: grid;
      grid-template-columns: 1fr;
      padding-top: ${getTheme_v2(props2.theme).space[3]}px;
    `), TitleInput = styled.textarea((props2) => {
  const {
    color,
    font
  } = getTheme_v2(props2.theme);
  return css`
    resize: none;
    overflow: hidden;
    appearance: none;
    background: none;
    border: 0;
    padding: 0;
    border-radius: 0;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: ${font.text.family};
    font-weight: ${font.text.weights.semibold};
    font-size: ${font.text.sizes[3].fontSize}px;
    line-height: ${font.text.sizes[3].lineHeight}px;
    margin: 0;
    position: relative;
    z-index: 1;
    display: block;
    transition: height 500ms;
    /* NOTE: This is a hack to disable Chrome’s autofill styles */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: var(--input-fg-color) !important;
      transition: background-color 5000s;
      transition-delay: 86400s /* 24h */;
    }

    color: ${color.input.default.enabled.fg};

    &::placeholder {
      color: ${color.input.default.enabled.placeholder};
    }
  `;
});
function Title(props2) {
  const $ = c(11), {
    value,
    onChange,
    placeholder,
    path
  } = props2, ref = useRef(null);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    ref.current && (ref.current.style.height = "auto", ref.current.style.height = `${ref.current.scrollHeight}px`);
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== value ? (t1 = [value], $[1] = value, $[2] = t1) : t1 = $[2], useEffect(t0, t1);
  let t2;
  $[3] !== onChange || $[4] !== path ? (t2 = (event) => {
    const inputValue = event.currentTarget.value;
    return inputValue || onChange(unset(path)), onChange(set(inputValue.replace(/\n/g, ""), path));
  }, $[3] = onChange, $[4] = path, $[5] = t2) : t2 = $[5];
  const handleChange = t2, t3 = !value;
  let t4;
  return $[6] !== handleChange || $[7] !== placeholder || $[8] !== t3 || $[9] !== value ? (t4 = /* @__PURE__ */ jsx(Root$c, { children: /* @__PURE__ */ jsx(TitleInput, { ref, autoFocus: t3, value, placeholder, onChange: handleChange, rows: 1 }) }), $[6] = handleChange, $[7] = placeholder, $[8] = t3, $[9] = value, $[10] = t4) : t4 = $[10], t4;
}
function TitleField(props2) {
  const $ = c(4), {
    value,
    inputProps
  } = props2, {
    onChange,
    schemaType
  } = inputProps;
  let t0;
  return $[0] !== onChange || $[1] !== schemaType.placeholder || $[2] !== value ? (t0 = /* @__PURE__ */ jsx(Title, { value, onChange, placeholder: schemaType.placeholder }), $[0] = onChange, $[1] = schemaType.placeholder, $[2] = value, $[3] = t0) : t0 = $[3], t0;
}
const getTaskSubscribers = (task) => {
  const subscribers2 = task.subscribers || [];
  return getMentionedUsers(task.description).forEach((user) => {
    subscribers2.includes(user) || subscribers2.push(user);
  }), task.assignedTo && (subscribers2.includes(task.assignedTo) || subscribers2.push(task.assignedTo)), subscribers2;
};
function FormCreate(props2) {
  const $ = c(67), [creating, setCreating] = useState(!1), {
    onChange
  } = props2, {
    setViewMode,
    setActiveTab
  } = useTasksNavigation(), toast = useToast(), telemetry = useTelemetry(), [createMore, setCreateMore] = useState(!1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setCreateMore(_temp$z), $[0] = t0) : t0 = $[0];
  const handleCreateMore = t0, value = props2.value;
  let t1;
  $[1] !== setViewMode ? (t1 = () => {
    setViewMode({
      type: "list"
    });
  }, $[1] = setViewMode, $[2] = t1) : t1 = $[2];
  const onRemove = t1;
  let t2;
  $[3] !== onRemove || $[4] !== value._id ? (t2 = {
    id: value._id,
    onRemoved: onRemove
  }, $[3] = onRemove, $[4] = value._id, $[5] = t2) : t2 = $[5];
  const {
    handleRemove,
    removeStatus
  } = useRemoveTask(t2), {
    t
  } = useTranslation(tasksLocaleNamespace), {
    data
  } = useTasks();
  let t3;
  if ($[6] !== data || $[7] !== value._id) {
    let t42;
    $[9] !== value._id ? (t42 = (task) => task._id === value._id, $[9] = value._id, $[10] = t42) : t42 = $[10], t3 = data.find(t42), $[6] = data, $[7] = value._id, $[8] = t3;
  } else
    t3 = $[8];
  const savedTask = t3;
  let t4;
  $[11] !== createMore || $[12] !== setActiveTab || $[13] !== setViewMode || $[14] !== t || $[15] !== telemetry || $[16] !== toast ? (t4 = () => {
    telemetry.log(TaskCreated), toast.push({
      closable: !0,
      status: "success",
      title: t("form.status.success")
    }), setCreating(!1), createMore ? setViewMode({
      type: "create"
    }) : setActiveTab("subscribed");
  }, $[11] = createMore, $[12] = setActiveTab, $[13] = setViewMode, $[14] = t, $[15] = telemetry, $[16] = toast, $[17] = t4) : t4 = $[17];
  const handleCreatingSuccess = useEffectEvent(t4);
  let t5;
  $[18] !== creating || $[19] !== handleCreatingSuccess || $[20] !== savedTask?.createdByUser ? (t5 = () => {
    creating && savedTask?.createdByUser && handleCreatingSuccess();
  }, $[18] = creating, $[19] = handleCreatingSuccess, $[20] = savedTask?.createdByUser, $[21] = t5) : t5 = $[21];
  const t6 = savedTask?.createdByUser;
  let t7;
  $[22] !== creating || $[23] !== t6 ? (t7 = [creating, t6], $[22] = creating, $[23] = t6, $[24] = t7) : t7 = $[24], useEffect(t5, t7);
  let t8;
  $[25] !== t || $[26] !== toast ? (t8 = () => {
    setCreating(!1), toast.push({
      closable: !0,
      status: "error",
      title: t("form.status.error.creation-failed")
    });
  }, $[25] = t, $[26] = toast, $[27] = t8) : t8 = $[27];
  const handleCreatingTimeout = useEffectEvent(t8);
  let t9;
  $[28] !== creating || $[29] !== handleCreatingTimeout ? (t9 = () => {
    let timeoutId = null;
    return creating && (timeoutId = setTimeout(() => handleCreatingTimeout(), 1e4)), () => {
      timeoutId && clearTimeout(timeoutId);
    };
  }, $[28] = creating, $[29] = handleCreatingTimeout, $[30] = t9) : t9 = $[30];
  let t10;
  $[31] !== creating ? (t10 = [creating], $[31] = creating, $[32] = t10) : t10 = $[32], useEffect(t9, t10);
  let t11;
  $[33] !== onChange || $[34] !== t || $[35] !== toast || $[36] !== value ? (t11 = async () => {
    if (setCreating(!0), !value?.title) {
      toast.push({
        closable: !0,
        status: "error",
        title: t("form.status.error.title-required")
      });
      return;
    }
    onChange([set(getTaskSubscribers(value), ["subscribers"]), set((/* @__PURE__ */ new Date()).toISOString(), ["createdByUser"])]);
  }, $[33] = onChange, $[34] = t, $[35] = toast, $[36] = value, $[37] = t11) : t11 = $[37];
  const handleCreate = t11;
  let t12;
  $[38] !== props2 ? (t12 = props2.renderDefault(props2), $[38] = props2, $[39] = t12) : t12 = $[39];
  let t13;
  $[40] !== handleRemove || $[41] !== removeStatus || $[42] !== t || $[43] !== value._rev ? (t13 = value._rev && /* @__PURE__ */ jsx(Button, { onClick: handleRemove, mode: "bleed", icon: TrashIcon, tooltipProps: {
    content: t("buttons.discard.text")
  }, disabled: removeStatus === "loading", loading: removeStatus === "loading" }), $[40] = handleRemove, $[41] = removeStatus, $[42] = t, $[43] = value._rev, $[44] = t13) : t13 = $[44];
  let t14;
  $[45] !== createMore ? (t14 = /* @__PURE__ */ jsx(Switch$1, { onChange: handleCreateMore, checked: createMore }), $[45] = createMore, $[46] = t14) : t14 = $[46];
  let t15;
  $[47] !== t ? (t15 = t("form.input.create-more.text"), $[47] = t, $[48] = t15) : t15 = $[48];
  let t16;
  $[49] !== t15 ? (t16 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t15 }), $[49] = t15, $[50] = t16) : t16 = $[50];
  let t17;
  $[51] !== t14 || $[52] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, justify: "flex-end", flex: 1, children: [
    t14,
    t16
  ] }), $[51] = t14, $[52] = t16, $[53] = t17) : t17 = $[53];
  let t18;
  $[54] !== t ? (t18 = t("buttons.create.text"), $[54] = t, $[55] = t18) : t18 = $[55];
  let t19;
  $[56] !== creating || $[57] !== handleCreate || $[58] !== t18 ? (t19 = /* @__PURE__ */ jsx(Button, { text: t18, onClick: handleCreate, disabled: creating, loading: creating }), $[56] = creating, $[57] = handleCreate, $[58] = t18, $[59] = t19) : t19 = $[59];
  let t20;
  $[60] !== t13 || $[61] !== t17 || $[62] !== t19 ? (t20 = /* @__PURE__ */ jsx(Box, { paddingY: 5, children: /* @__PURE__ */ jsxs(Flex, { paddingTop: 1, gap: 4, children: [
    t13,
    t17,
    t19
  ] }) }), $[60] = t13, $[61] = t17, $[62] = t19, $[63] = t20) : t20 = $[63];
  let t21;
  return $[64] !== t12 || $[65] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t12,
    t20
  ] }), $[64] = t12, $[65] = t20, $[66] = t21) : t21 = $[66], t21;
}
function _temp$z(p) {
  return !p;
}
function RemoveTaskDialog(props2) {
  const $ = c(25), {
    handleCloseDialog,
    handleRemove,
    removeStatus,
    showDialog
  } = props2, {
    t
  } = useTranslation(tasksLocaleNamespace);
  if (showDialog) {
    let t0;
    $[0] !== t ? (t0 = t("dialog.remove-task.title"), $[0] = t, $[1] = t0) : t0 = $[1];
    let t1;
    $[2] !== t ? (t1 = t("dialog.remove-task.buttons.cancel.text"), $[2] = t, $[3] = t1) : t1 = $[3];
    let t2;
    $[4] !== handleCloseDialog || $[5] !== t1 ? (t2 = {
      text: t1,
      onClick: handleCloseDialog
    }, $[4] = handleCloseDialog, $[5] = t1, $[6] = t2) : t2 = $[6];
    let t3;
    $[7] !== t ? (t3 = t("dialog.remove-task.buttons.confirm.text"), $[7] = t, $[8] = t3) : t3 = $[8];
    const t4 = removeStatus === "loading";
    let t5;
    $[9] !== handleRemove || $[10] !== t3 || $[11] !== t4 ? (t5 = {
      text: t3,
      tone: "critical",
      onClick: handleRemove,
      loading: t4
    }, $[9] = handleRemove, $[10] = t3, $[11] = t4, $[12] = t5) : t5 = $[12];
    let t6;
    $[13] !== t2 || $[14] !== t5 ? (t6 = {
      cancelButton: t2,
      confirmButton: t5
    }, $[13] = t2, $[14] = t5, $[15] = t6) : t6 = $[15];
    let t7;
    $[16] !== t ? (t7 = t("dialog.remove-task.body"), $[16] = t, $[17] = t7) : t7 = $[17];
    let t8;
    $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Stack, { space: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "p", children: t7 }) }), $[18] = t7, $[19] = t8) : t8 = $[19];
    let t9;
    return $[20] !== handleCloseDialog || $[21] !== t0 || $[22] !== t6 || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsx(Dialog$1, { id: "remove-task", header: t0, onClose: handleCloseDialog, footer: t6, children: t8 }), $[20] = handleCloseDialog, $[21] = t0, $[22] = t6, $[23] = t8, $[24] = t9) : t9 = $[24], t9;
  }
  return null;
}
const FirstRow = styled(Flex)((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    column-gap: ${theme.space[2]}px;
    row-gap: ${theme.space[3]}px;
  `;
});
function FormActionsMenu(t0) {
  const $ = c(42), {
    id: id2,
    value
  } = t0, {
    setViewMode,
    handleCopyLinkToTask
  } = useTasksNavigation(), {
    mode
  } = useTasksEnabled(), telemetry = useTelemetry();
  let t1;
  $[0] !== setViewMode || $[1] !== telemetry ? (t1 = () => {
    setViewMode({
      type: "list"
    }), telemetry.log(TaskRemoved);
  }, $[0] = setViewMode, $[1] = telemetry, $[2] = t1) : t1 = $[2];
  const onTaskRemoved = t1;
  let t2;
  $[3] !== id2 || $[4] !== onTaskRemoved ? (t2 = {
    id: id2,
    onRemoved: onTaskRemoved
  }, $[3] = id2, $[4] = onTaskRemoved, $[5] = t2) : t2 = $[5];
  const removeTask = useRemoveTask(t2);
  let t3;
  $[6] !== setViewMode || $[7] !== telemetry || $[8] !== value ? (t3 = () => {
    setViewMode({
      type: "duplicate",
      duplicateTaskValues: value
    }), telemetry.log(TaskDuplicated);
  }, $[6] = setViewMode, $[7] = telemetry, $[8] = value, $[9] = t3) : t3 = $[9];
  const duplicateTask = t3, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t4;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(ContextMenuButton, {}), $[10] = t4) : t4 = $[10];
  let t5;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    placement: "bottom",
    fallbackPlacements: ["bottom-end", "bottom-start"]
  }, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t ? (t6 = t("menuitem.duplicate.text"), $[12] = t, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== mode || $[15] !== t ? (t7 = mode === "upsell" ? {
    content: t("menuitem.duplicate.upsell-tooltip")
  } : void 0, $[14] = mode, $[15] = t, $[16] = t7) : t7 = $[16];
  const t8 = mode === "upsell";
  let t9;
  $[17] !== duplicateTask || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 ? (t9 = /* @__PURE__ */ jsx(MenuItem$1, { text: t6, icon: CopyIcon, onClick: duplicateTask, tooltipProps: t7, disabled: t8 }), $[17] = duplicateTask, $[18] = t6, $[19] = t7, $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== t ? (t10 = t("menuitem.copylink.text"), $[22] = t, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== handleCopyLinkToTask || $[25] !== t10 ? (t11 = /* @__PURE__ */ jsx(MenuItem$1, { text: t10, icon: LinkIcon, onClick: handleCopyLinkToTask }), $[24] = handleCopyLinkToTask, $[25] = t10, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] === Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(MenuDivider, {}), $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== t ? (t13 = t("menuitem.delete.text"), $[28] = t, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== removeTask.handleOpenDialog || $[31] !== t13 ? (t14 = /* @__PURE__ */ jsx(MenuItem$1, { text: t13, icon: TrashIcon, onClick: removeTask.handleOpenDialog, tone: "critical" }), $[30] = removeTask.handleOpenDialog, $[31] = t13, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== t11 || $[34] !== t14 || $[35] !== t9 ? (t15 = /* @__PURE__ */ jsx(Box, { paddingTop: 3, children: /* @__PURE__ */ jsx(MenuButton$1, { id: "edit-task-menu", button: t4, popover: t5, menu: /* @__PURE__ */ jsxs(Menu, { children: [
    t9,
    t11,
    t12,
    t14
  ] }) }) }), $[33] = t11, $[34] = t14, $[35] = t9, $[36] = t15) : t15 = $[36];
  let t16;
  $[37] !== removeTask ? (t16 = /* @__PURE__ */ jsx(RemoveTaskDialog, { ...removeTask }), $[37] = removeTask, $[38] = t16) : t16 = $[38];
  let t17;
  return $[39] !== t15 || $[40] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t15,
    t16
  ] }), $[39] = t15, $[40] = t16, $[41] = t17) : t17 = $[41], t17;
}
function FormEditInner(props2) {
  const $ = c(52);
  let t0;
  $[0] !== props2.schemaType.fields ? (t0 = props2.schemaType.fields.find(_temp$y), $[0] = props2.schemaType.fields, $[1] = t0) : t0 = $[1];
  const statusField = t0, value = props2.value, currentUser = useCurrentUser(), {
    t
  } = useTranslation(tasksLocaleNamespace), activityData = useActivityLog(value).changes;
  let t1;
  $[2] !== currentUser || $[3] !== props2 || $[4] !== value.subscribers ? (t1 = (patch2) => {
    const subscribers2 = value.subscribers || [];
    props2.onChange(patch2), currentUser && (subscribers2.includes(currentUser.id) || props2.onChange(set([...subscribers2, currentUser.id], ["subscribers"])));
  }, $[2] = currentUser, $[3] = props2, $[4] = value.subscribers, $[5] = t1) : t1 = $[5];
  const handleChangeAndSubscribe = t1;
  if (!statusField)
    throw new Error("Status field not found");
  if (!props2.value?._id) {
    let t24;
    return $[6] === Symbol.for("react.memo_cache_sentinel") ? (t24 = /* @__PURE__ */ jsx(LoadingBlock, {}), $[6] = t24) : t24 = $[6], t24;
  }
  const t2 = props2.value?.title;
  let t3;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t3 = ["title"], $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t ? (t4 = t("form.input.title.placeholder"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== handleChangeAndSubscribe || $[11] !== t2 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Stack, { flex: 1, children: /* @__PURE__ */ jsx(Title, { onChange: handleChangeAndSubscribe, value: t2, path: t3, placeholder: t4 }) }), $[10] = handleChangeAndSubscribe, $[11] = t2, $[12] = t4, $[13] = t5) : t5 = $[13];
  const t6 = props2.value?._id;
  let t7;
  $[14] !== t6 || $[15] !== value ? (t7 = /* @__PURE__ */ jsx(FormActionsMenu, { id: t6, value }), $[14] = t6, $[15] = value, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t5 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t5,
    t7
  ] }), $[17] = t5, $[18] = t7, $[19] = t8) : t8 = $[19];
  const t9 = props2.value?.status;
  let t10;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t10 = ["status"], $[20] = t10) : t10 = $[20];
  let t11;
  $[21] !== handleChangeAndSubscribe || $[22] !== statusField.type.options.list || $[23] !== t9 ? (t11 = /* @__PURE__ */ jsx(StatusSelector, { value: t9, path: t10, onChange: handleChangeAndSubscribe, options: statusField.type.options.list }), $[21] = handleChangeAndSubscribe, $[22] = statusField.type.options.list, $[23] = t9, $[24] = t11) : t11 = $[24];
  const t12 = props2.value?.assignedTo;
  let t13;
  $[25] === Symbol.for("react.memo_cache_sentinel") ? (t13 = ["assignedTo"], $[25] = t13) : t13 = $[25];
  let t14;
  $[26] !== handleChangeAndSubscribe || $[27] !== t12 ? (t14 = /* @__PURE__ */ jsx(AssigneeEditFormField, { value: t12, onChange: handleChangeAndSubscribe, path: t13 }), $[26] = handleChangeAndSubscribe, $[27] = t12, $[28] = t14) : t14 = $[28];
  const t15 = props2.value?.dueBy;
  let t16;
  $[29] === Symbol.for("react.memo_cache_sentinel") ? (t16 = ["dueBy"], $[29] = t16) : t16 = $[29];
  let t17;
  $[30] !== handleChangeAndSubscribe || $[31] !== t15 ? (t17 = /* @__PURE__ */ jsx(DateEditFormField, { value: t15, onChange: handleChangeAndSubscribe, path: t16 }), $[30] = handleChangeAndSubscribe, $[31] = t15, $[32] = t17) : t17 = $[32];
  let t18;
  $[33] !== t11 || $[34] !== t14 || $[35] !== t17 ? (t18 = /* @__PURE__ */ jsx(Card, { borderTop: !0, marginTop: 3, children: /* @__PURE__ */ jsx(FirstRow, { paddingBottom: 3, paddingTop: 4, align: "flex-start", justify: "flex-start", wrap: "wrap", children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    t11,
    t14,
    t17
  ] }) }) }), $[33] = t11, $[34] = t14, $[35] = t17, $[36] = t18) : t18 = $[36];
  let t19;
  $[37] !== props2 ? (t19 = props2.renderDefault(props2), $[37] = props2, $[38] = t19) : t19 = $[38];
  let t20;
  $[39] === Symbol.for("react.memo_cache_sentinel") ? (t20 = ["subscribers"], $[39] = t20) : t20 = $[39];
  let t21;
  $[40] !== activityData || $[41] !== props2.onChange || $[42] !== value ? (t21 = /* @__PURE__ */ jsx(CurrentWorkspaceProvider, { children: /* @__PURE__ */ jsx(Card, { borderTop: !0, paddingTop: 4, marginTop: 4, paddingBottom: 6, children: /* @__PURE__ */ jsx(TasksActivityLog, { value, onChange: props2.onChange, path: t20, activityData }) }) }), $[40] = activityData, $[41] = props2.onChange, $[42] = value, $[43] = t21) : t21 = $[43];
  let t22;
  $[44] !== t21 || $[45] !== value._id ? (t22 = /* @__PURE__ */ jsx(CommentsProvider, { documentId: value._id, documentType: "tasks.task", sortOrder: "asc", type: "task", children: t21 }), $[44] = t21, $[45] = value._id, $[46] = t22) : t22 = $[46];
  let t23;
  return $[47] !== t18 || $[48] !== t19 || $[49] !== t22 || $[50] !== t8 ? (t23 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t8,
    t18,
    t19,
    t22
  ] }), $[47] = t18, $[48] = t19, $[49] = t22, $[50] = t8, $[51] = t23) : t23 = $[51], t23;
}
function _temp$y(f) {
  return f.name === "status";
}
function FormEdit(props2) {
  const value = props2.value, currentUser = useCurrentUser(), transformPatches = useCallback((patches) => {
    if (!currentUser || patches.some((patch2) => patch2.path[0] === "subscribers") || patches.some((patch_0) => patch_0.path[0] === "context" && patch_0.path[1] === "notification"))
      return patches;
    const subscribers2 = value.subscribers || [], newSubscribers = [...subscribers2], changeAssigneePatch = patches.find((patch_1) => patch_1.path[0] === "assignedTo");
    changeAssigneePatch && changeAssigneePatch.type === "set" && typeof changeAssigneePatch.value == "string" && !newSubscribers.includes(changeAssigneePatch.value) && newSubscribers.push(changeAssigneePatch.value), newSubscribers.includes(currentUser.id) || newSubscribers.push(currentUser.id);
    const changedDescriptionPatch = patches.find((patch_2) => patch_2.path[0] === "description" && patch_2.type === "set");
    if (changedDescriptionPatch) {
      const prevMentionedUser = getMentionedUsers(value.description), newDescription = changedDescriptionPatch.type === "set" ? changedDescriptionPatch.value : void 0;
      getMentionedUsers(newDescription).filter((user) => !prevMentionedUser.includes(user)).forEach((user_0) => {
        newSubscribers.includes(user_0) || newSubscribers.push(user_0);
      });
    }
    return newSubscribers.length !== subscribers2.length && patches.push(set(newSubscribers, ["subscribers"])), patches;
  }, [currentUser, value.subscribers, value.description]);
  return /* @__PURE__ */ jsx(TransformPatches, { transform: transformPatches, children: /* @__PURE__ */ jsx(FormEditInner, { ...props2 }) });
}
function getTaskURL(taskId, basePath, toolName = "") {
  let path = window.location.origin;
  basePath && (path += basePath), toolName && (path += `/${toolName}`);
  const currentUrl = new URL(`${path}/`);
  return currentUrl.searchParams.set("sidebar", "tasks"), currentUrl.searchParams.set("selectedTask", taskId), currentUrl.searchParams.set("viewMode", "edit"), currentUrl.toString();
}
function TasksNotificationTargetInner(props2) {
  const {
    inputProps
  } = props2, {
    onChange
  } = inputProps, activeToolName = useRouterState(useCallback((routerState) => typeof routerState.tool == "string" ? routerState.tool : void 0, [])), {
    target,
    _id,
    context,
    _rev
  } = useFormValue([]), {
    title: workspaceTitle,
    basePath
  } = useWorkspace(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), imageBuilder = useMemo(() => imageUrlBuilder(client), [client]), documentId = target?.document?._ref ?? "", documentType = target?.documentType ?? "", {
    isLoading: previewValuesLoading,
    value
  } = useDocumentPreviewValues({
    documentId,
    documentType
  }), targetContentTitle = value?.title || null, imageUrl = isImageSource(value?.media) ? imageBuilder.image(value.media).width(96).height(96).url() : null, notificationTarget = useMemo(() => {
    const contextUrl = context?.notification?.url;
    return {
      url: (
        // Avoid updating the contextURL in dev mode if it already exists, persist the deployed one.
        contextUrl && isDev ? contextUrl : getTaskURL(_id, basePath, activeToolName)
      ),
      workspaceTitle,
      targetContentImageUrl: imageUrl,
      targetContentTitle
    };
  }, [context?.notification?.url, _id, basePath, activeToolName, workspaceTitle, imageUrl, targetContentTitle]);
  return useEffect(() => {
    documentId && documentType && previewValuesLoading || _rev && (deepEquals(context?.notification, notificationTarget) || onChange(set(notificationTarget, ["notification"])));
  }, [_rev, context, documentId, documentType, notificationTarget, previewValuesLoading, onChange]), null;
}
function TasksNotificationTarget(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(CurrentWorkspaceProvider, { children: /* @__PURE__ */ jsx(TasksNotificationTargetInner, { ...props2 }) }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const targetContentField = (mode) => defineField({
  type: "object",
  name: "target",
  title: "Target",
  components: {
    field: (props2) => /* @__PURE__ */ jsx(TargetField, { ...props2, mode })
  },
  fields: [{
    name: "document",
    type: "crossDatasetReference",
    dataset: "playground",
    weak: !0,
    studioUrl: ({
      id: id2,
      type
    }) => `intent/edit/id=${id2};type=${type}/`,
    to: [{
      type: "any_document",
      preview: {
        select: {
          title: "title"
        }
      }
    }]
  }, {
    name: "documentType",
    type: "string",
    title: "Document type"
  }]
}), descriptionInputField = (mode) => defineField({
  type: "array",
  name: "description",
  title: "Description",
  components: {
    field: (props2) => /* @__PURE__ */ jsx(DescriptionInput, { ...props2, mode })
  },
  of: [{
    type: "block",
    name: "block",
    of: [{
      name: "mention",
      type: "object",
      fields: [{
        name: "userId",
        type: "string"
      }]
    }],
    marks: {
      annotations: []
    },
    styles: [{
      title: "Normal",
      value: "normal"
    }],
    lists: []
  }]
}), taskSchema = (mode) => defineType({
  type: "document",
  name: "tasks.task",
  liveEdit: !0,
  components: {
    input: mode === "edit" ? FormEdit : FormCreate
  },
  fields: [{
    type: "string",
    title: "Title",
    name: "title",
    placeholder: "Task title",
    components: {
      field: TitleField
    },
    hidden: mode === "edit"
  }, ...mode === "edit" ? [targetContentField(mode), descriptionInputField(mode)] : [descriptionInputField(mode), targetContentField(mode)], {
    type: "string",
    name: "assignedTo",
    title: "Assign to",
    placeholder: "Select assignee",
    components: {
      field: FieldWrapper,
      input: AssigneeCreateFormField
    },
    hidden: mode === "edit"
  }, {
    type: "date",
    name: "dueBy",
    title: "Deadline",
    placeholder: "yyyy-mm-dd",
    components: {
      field: FieldWrapper
    },
    hidden: mode === "edit"
  }, {
    type: "string",
    name: "authorId",
    hidden: !0
  }, {
    type: "string",
    name: "createdByUser",
    hidden: !0
  }, {
    type: "array",
    of: [{
      type: "string"
    }],
    name: "subscribers",
    hidden: !0
  }, {
    type: "string",
    name: "status",
    title: "Status",
    options: {
      list: TASK_STATUS.map((s) => ({
        value: s.value,
        title: s.title
      }))
    },
    hidden: !0
  }, {
    type: "object",
    name: "context",
    components: {
      field: TasksNotificationTarget
    },
    fields: [{
      type: "object",
      name: "notification",
      fields: [{
        type: "string",
        name: "url"
      }, {
        type: "string",
        name: "workspaceTitle"
      }, {
        type: "string",
        name: "targetContentImageUrl"
      }, {
        type: "string",
        name: "targetContentTitle"
      }]
    }]
  }]
});
function TasksAddonWorkspaceProviderInner({
  children,
  mode,
  addonDataset
}) {
  const apiHost = useClient({
    apiVersion: API_VERSION$3
  }).config().apiHost, basePath = "", source = useSource(), addonDatasetConfig = useMemo(() => ({
    basePath,
    dataset: addonDataset,
    name: `addon-dataset-${addonDataset}`,
    projectId: source.projectId,
    apiHost,
    schema: {
      types: [taskSchema(mode)]
    }
  }), [source.projectId, mode, apiHost, addonDataset, basePath]), {
    workspaces
  } = useMemo(() => prepareConfig(addonDatasetConfig, {
    basePath
  }), [addonDatasetConfig, basePath]), addonWorkspace = useWorkspaceLoader(workspaces[0]);
  return addonWorkspace ? /* @__PURE__ */ jsx(WorkspaceProvider, { workspace: addonWorkspace, children: /* @__PURE__ */ jsx(SourceProvider, { source: addonWorkspace.unstable_sources[0], children: /* @__PURE__ */ jsx(ResourceCacheProvider, { children }) }) }) : null;
}
function TasksAddonWorkspaceProvider(props2) {
  const $ = c(11), {
    client: addonDatasetClient,
    ready,
    createAddonDataset
  } = useAddonDataset();
  let t0;
  $[0] !== addonDatasetClient ? (t0 = addonDatasetClient?.config().dataset, $[0] = addonDatasetClient, $[1] = t0) : t0 = $[1];
  const addonDataset = t0;
  let t1, t2;
  if ($[2] !== addonDataset || $[3] !== createAddonDataset || $[4] !== ready ? (t1 = () => {
    !addonDataset && ready && createAddonDataset();
  }, t2 = [addonDataset, ready, createAddonDataset], $[2] = addonDataset, $[3] = createAddonDataset, $[4] = ready, $[5] = t1, $[6] = t2) : (t1 = $[5], t2 = $[6]), useEffect(t1, t2), !addonDataset) {
    let t32;
    return $[7] === Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(LoadingBlock, {}), $[7] = t32) : t32 = $[7], t32;
  }
  let t3;
  return $[8] !== addonDataset || $[9] !== props2 ? (t3 = /* @__PURE__ */ jsx(TasksAddonWorkspaceProviderInner, { ...props2, addonDataset }), $[8] = addonDataset, $[9] = props2, $[10] = t3) : t3 = $[10], t3;
}
const VARIANTS$1 = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.2,
      delay: 0.2
    }
  }
}, FormBuilderRoot = styled(motion.div)((props2) => {
  const theme = getTheme_v2(props2.theme);
  return `
    // Update spacing for the form builder
    & > [data-ui='Stack'] {
      grid-gap: ${rem(theme.space[4])};
    }
`;
}), TasksFormBuilderInner = (t0) => {
  const $ = c(25), {
    documentId,
    initialValue
  } = t0, [patchChannel] = useState(_temp$x);
  let t1;
  $[0] !== initialValue ? (t1 = initialValue ? {
    loading: !1,
    value: initialValue,
    error: null
  } : void 0, $[0] = initialValue, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== documentId || $[3] !== t1 ? (t2 = {
    documentId,
    documentType: "tasks.task",
    initialValue: t1
  }, $[2] = documentId, $[3] = t1, $[4] = t2) : t2 = $[4];
  const {
    formState,
    onChange,
    onPathOpen,
    onFocus,
    onBlur,
    onSetActiveFieldGroup,
    onSetCollapsedFieldSet,
    onSetCollapsedPath,
    collapsedFieldSets,
    ready,
    collapsedPaths,
    schemaType,
    value
  } = useDocumentForm(t2), isLoading = formState === null || !ready, {
    setSelectedDocument
  } = useMentionUser(), target = isLoading ? void 0 : value?.target, targetId = target?.document?._ref, targetType = target?.documentType;
  let t3, t4;
  $[5] !== setSelectedDocument || $[6] !== targetId || $[7] !== targetType ? (t3 = () => {
    setSelectedDocument(targetId && targetType ? {
      _id: targetId,
      _type: targetType
    } : null);
  }, t4 = [targetId, targetType, setSelectedDocument], $[5] = setSelectedDocument, $[6] = targetId, $[7] = targetType, $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5;
  return $[10] !== collapsedFieldSets || $[11] !== collapsedPaths || $[12] !== formState || $[13] !== isLoading || $[14] !== onBlur || $[15] !== onChange || $[16] !== onFocus || $[17] !== onPathOpen || $[18] !== onSetActiveFieldGroup || $[19] !== onSetCollapsedFieldSet || $[20] !== onSetCollapsedPath || $[21] !== patchChannel || $[22] !== schemaType || $[23] !== value ? (t5 = /* @__PURE__ */ jsx(Box, { children: isLoading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) : /* @__PURE__ */ jsx(FormBuilderRoot, { id: "wrapper", initial: "hidden", animate: "visible", variants: VARIANTS$1, children: /* @__PURE__ */ jsx(FormBuilder, { __internal_patchChannel: patchChannel, id: "root", onChange, onPathFocus: onFocus, onPathOpen, onPathBlur: onBlur, onFieldGroupSelect: onSetActiveFieldGroup, onSetFieldSetCollapsed: onSetCollapsedFieldSet, onSetPathCollapsed: onSetCollapsedPath, collapsedPaths, collapsedFieldSets, focusPath: formState.focusPath, changed: formState.changed, focused: formState.focused, groups: formState.groups, validation: formState.validation, members: formState.members, presence: formState.presence, schemaType, value }) }) }), $[10] = collapsedFieldSets, $[11] = collapsedPaths, $[12] = formState, $[13] = isLoading, $[14] = onBlur, $[15] = onChange, $[16] = onFocus, $[17] = onPathOpen, $[18] = onSetActiveFieldGroup, $[19] = onSetCollapsedFieldSet, $[20] = onSetCollapsedPath, $[21] = patchChannel, $[22] = schemaType, $[23] = value, $[24] = t5) : t5 = $[24], t5;
};
function TasksFormBuilder() {
  const $ = c(23), currentUser = useCurrentUser(), {
    activeDocument
  } = useTasks(), {
    dataset,
    projectId
  } = useWorkspace(), {
    state: t0
  } = useTasksNavigation(), {
    selectedTask,
    viewMode,
    duplicateTaskValues
  } = t0;
  let t1;
  bb0: {
    if (!currentUser) {
      t1 = void 0;
      break bb0;
    }
    if (!selectedTask) {
      t1 = void 0;
      break bb0;
    }
    if (viewMode === "duplicate") {
      const t22 = `${duplicateTaskValues?.title} (copy)`;
      let t32;
      $[0] !== currentUser.id || $[1] !== duplicateTaskValues || $[2] !== selectedTask || $[3] !== t22 ? (t32 = {
        ...duplicateTaskValues,
        title: t22,
        createdByUser: void 0,
        _id: selectedTask,
        _type: "tasks.task",
        authorId: currentUser.id,
        status: "open"
      }, $[0] = currentUser.id, $[1] = duplicateTaskValues, $[2] = selectedTask, $[3] = t22, $[4] = t32) : t32 = $[4], t1 = t32;
      break bb0;
    }
    if (viewMode === "create") {
      let t22;
      $[5] !== currentUser.id ? (t22 = [currentUser.id], $[5] = currentUser.id, $[6] = t22) : t22 = $[6];
      let t32;
      $[7] !== activeDocument || $[8] !== dataset || $[9] !== projectId ? (t32 = activeDocument ? getTargetValue({
        documentId: activeDocument.documentId,
        documentType: activeDocument.documentType,
        dataset,
        projectId
      }) : void 0, $[7] = activeDocument, $[8] = dataset, $[9] = projectId, $[10] = t32) : t32 = $[10];
      let t42;
      $[11] !== currentUser.id || $[12] !== selectedTask || $[13] !== t22 || $[14] !== t32 ? (t42 = {
        _id: selectedTask,
        _type: "tasks.task",
        authorId: currentUser.id,
        status: "open",
        subscribers: t22,
        target: t32
      }, $[11] = currentUser.id, $[12] = selectedTask, $[13] = t22, $[14] = t32, $[15] = t42) : t42 = $[15], t1 = t42;
      break bb0;
    }
    t1 = void 0;
  }
  const initialValue = t1;
  if (!currentUser) {
    let t22;
    return $[16] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: "Loading current user" }), $[16] = t22) : t22 = $[16], t22;
  }
  if (!selectedTask)
    return null;
  const t2 = viewMode === "edit" ? "edit" : "create";
  let t3;
  $[17] !== initialValue || $[18] !== selectedTask ? (t3 = /* @__PURE__ */ jsx(TasksFormBuilderInner, { documentId: selectedTask, initialValue }), $[17] = initialValue, $[18] = selectedTask, $[19] = t3) : t3 = $[19];
  let t4;
  return $[20] !== t2 || $[21] !== t3 ? (t4 = /* @__PURE__ */ jsx(MentionUserProvider, { children: /* @__PURE__ */ jsx(TasksAddonWorkspaceProvider, { mode: t2, children: t3 }) }), $[20] = t2, $[21] = t3, $[22] = t4) : t4 = $[22], t4;
}
function _temp$x() {
  return createPatchChannel();
}
const HEADING_BY_STATUS = {
  open: {
    assigned: {
      heading: "empty-state.status.list.open.assigned.heading",
      text: "empty-state.status.list.open.assigned.text"
    },
    document: {
      heading: "empty-state.status.list.open.document.heading",
      text: ""
    },
    subscribed: {
      heading: "empty-state.status.list.open.subscribed.heading",
      text: "empty-state.status.list.open.subscribed.text"
    }
  },
  closed: {
    assigned: {
      heading: "empty-state.status.list.closed.assigned.heading",
      text: "empty-state.status.list.closed.assigned.text"
    },
    document: {
      heading: "empty-state.status.list.closed.document.heading",
      text: ""
    },
    subscribed: {
      heading: "empty-state.status.list.closed.subscribed.heading",
      text: "empty-state.status.list.closed.subscribed.text"
    }
  }
};
function EmptyStatusListState(t0) {
  const $ = c(13), {
    status
  } = t0, {
    state: t1
  } = useTasksNavigation(), {
    activeTabId
  } = t1, {
    t
  } = useTranslation(tasksLocaleNamespace), {
    heading,
    text
  } = HEADING_BY_STATUS[status][activeTabId];
  let t2;
  $[0] !== heading || $[1] !== t ? (t2 = t(heading), $[0] = heading, $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t2 }), $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t || $[6] !== text ? (t4 = t(text), $[5] = t, $[6] = text, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t4 }), $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== t3 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t3,
    t5
  ] }), $[10] = t3, $[11] = t5, $[12] = t6) : t6 = $[12], t6;
}
const EMPTY_TASK_LIST = {
  assigned: {
    heading: "empty-state.list.assigned.heading",
    text: "empty-state.list.assigned.text"
  },
  subscribed: {
    heading: "empty-state.list.subscribed.heading",
    text: "empty-state.list.subscribed.text"
  },
  document: {
    heading: "empty-state.list.document.heading",
    text: "empty-state.list.document.text"
  },
  noActiveDocument: {
    heading: "empty-state.list.no-active-document.heading",
    text: "empty-state.list.no-active-document.text"
  }
}, Root$b = styled.div`
  max-width: 268px;
  margin: 0 auto;
  height: 100%;
  margin-top: 40%;
`, AnimatedText = styled(Text$1)`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  animation: fadeIn 0.2s ease-in-out;
`;
function EmptyTasksListState() {
  const $ = c(22), {
    activeDocument
  } = useTasks(), {
    mode
  } = useTasksEnabled(), {
    state: t0,
    setViewMode
  } = useTasksNavigation(), {
    activeTabId
  } = t0, key = !activeDocument && activeTabId === "document" ? "noActiveDocument" : activeTabId, {
    heading,
    text
  } = EMPTY_TASK_LIST[key], {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  $[0] !== setViewMode ? (t1 = () => {
    setViewMode({
      type: "create"
    });
  }, $[0] = setViewMode, $[1] = t1) : t1 = $[1];
  const handleTaskCreate = t1;
  let t2;
  $[2] !== heading || $[3] !== t ? (t2 = t(heading), $[2] = heading, $[3] = t, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== key || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(AnimatedText, { size: 1, weight: "semibold", children: t2 }, key), $[5] = key, $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t || $[9] !== text ? (t4 = t(text), $[8] = t, $[9] = text, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== key || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { paddingBottom: 6, paddingTop: 1, children: /* @__PURE__ */ jsx(AnimatedText, { size: 1, align: "center", children: t4 }, key) }), $[11] = key, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== handleTaskCreate || $[15] !== mode || $[16] !== t ? (t6 = mode !== "upsell" && /* @__PURE__ */ jsx(Button, { icon: AddIcon, text: t("empty-state.list.create-new"), onClick: handleTaskCreate }), $[14] = handleTaskCreate, $[15] = mode, $[16] = t, $[17] = t6) : t6 = $[17];
  let t7;
  return $[18] !== t3 || $[19] !== t5 || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsx(Root$b, { children: /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 3, align: "center", flex: 1, justify: "center", children: [
    t3,
    t5,
    t6
  ] }) }), $[18] = t3, $[19] = t5, $[20] = t6, $[21] = t7) : t7 = $[21], t7;
}
const StyledIntentLink = styled(IntentLink)((props2) => `
  text-decoration: underline;
  text-decoration-color: ${getTheme_v2(props2.theme).color.input.default.enabled.border};
  text-underline-offset: 2px;
`);
function DocumentPreview(t0) {
  const $ = c(11), {
    documentId,
    documentType
  } = t0, documentSchema = useSchema().get(documentType);
  let t1;
  $[0] !== documentId || $[1] !== documentType ? (t1 = {
    documentId,
    documentType
  }, $[0] = documentId, $[1] = documentType, $[2] = t1) : t1 = $[2];
  const {
    isLoading,
    value
  } = useDocumentPreviewValues(t1);
  let t2, t3;
  $[3] !== documentId || $[4] !== documentType ? (t3 = forwardRef(function(linkProps, ref) {
    return /* @__PURE__ */ jsx(StyledIntentLink, { ...linkProps, intent: "edit", params: {
      id: documentId,
      type: documentType
    }, ref });
  }), $[3] = documentId, $[4] = documentType, $[5] = t3) : t3 = $[5], t2 = t3;
  const Link2 = t2;
  if (!documentSchema)
    return null;
  let t4;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(DocumentIcon, {}) }), $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== Link2 || $[8] !== isLoading || $[9] !== value?.title ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t4,
    isLoading ? /* @__PURE__ */ jsx(TextSkeleton, { size: 1, muted: !0 }) : /* @__PURE__ */ jsx(Text$1, { size: 1, as: Link2, weight: "medium", style: {
      maxWidth: "20ch"
    }, textOverflow: "ellipsis", children: value?.title || "Untitled" })
  ] }), $[7] = Link2, $[8] = isLoading, $[9] = value?.title, $[10] = t5) : t5 = $[10], t5;
}
function TasksStatus(props2) {
  const operations = useTaskOperations(), {
    documentId,
    status
  } = props2, [checkboxValue, setCheckboxValue] = useState(status === "closed"), [isLoading, setIsLoading] = useState(!1), handleCheckboxChange = useCallback(async (event) => {
    const isChecked = event.target.checked;
    setCheckboxValue(isChecked), setIsLoading(!0);
    try {
      isChecked ? await operations.edit(documentId, {
        status: "closed"
      }) : isChecked || await operations.edit(documentId, {
        status: "open"
      });
    } catch (error) {
      console.error("An error occurred while updating the task status", error);
    } finally {
      setIsLoading(!1);
    }
  }, [documentId, operations]);
  return /* @__PURE__ */ jsx(Flex, { children: isLoading ? /* @__PURE__ */ jsx("div", { style: {
    height: "17px",
    width: "17px"
  }, children: /* @__PURE__ */ jsx(Spinner, { style: {
    marginLeft: "3.5px",
    marginRight: "3.5px",
    marginTop: "3.5px"
  } }) }) : /* @__PURE__ */ jsx(Checkbox$1, { onChange: handleCheckboxChange, checked: checkboxValue, disabled: isLoading }) });
}
const TitleButton = styled(Button$1)`
  width: 100%;
  max-width: 100%;
`, TaskDetailsRoot = styled(Flex)`
  /* Checkbox width is 17px and first row gap is 12px. */
  margin-left: 29px;
`;
function getTargetDocumentMeta(target) {
  if (target?.document?._ref)
    return {
      _ref: target?.document._ref,
      _type: target?.documentType
    };
}
function TaskDueDate(t0) {
  const $ = c(27), {
    dueBy
  } = t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    dateStyle: "medium"
  }, $[0] = t1) : t1 = $[0];
  const fullDateFormatter = useDateTimeFormat(t1);
  let t2;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    month: "short",
    day: "numeric"
  }, $[1] = t2) : t2 = $[1];
  const monthAndDayFormatter = useDateTimeFormat(t2);
  let t3;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    weekday: "long"
  }, $[2] = t3) : t3 = $[2];
  const dayFormatter = useDateTimeFormat(t3);
  let t4, t5, t6, t7, t8, t9;
  if ($[3] !== dayFormatter || $[4] !== dueBy || $[5] !== fullDateFormatter || $[6] !== monthAndDayFormatter) {
    const date = new Date(dueBy);
    t5 = fullDateFormatter.format(date), t6 = monthAndDayFormatter.format(date), t7 = dayFormatter.format(date), t8 = isToday(date), t9 = isThisISOWeek(date), $[3] = dayFormatter, $[4] = dueBy, $[5] = fullDateFormatter, $[6] = monthAndDayFormatter, $[7] = t5, $[8] = t6, $[9] = t7, $[10] = t8, $[11] = t9;
  } else
    t5 = $[7], t6 = $[8], t7 = $[9], t8 = $[10], t9 = $[11];
  let t10;
  $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9 ? (t10 = {
    fullDate: t5,
    monthAndDay: t6,
    day: t7,
    isDueByToday: t8,
    isDueThisWeek: t9
  }, $[12] = t5, $[13] = t6, $[14] = t7, $[15] = t8, $[16] = t9, $[17] = t10) : t10 = $[17], t4 = t10;
  const dateOptions = t4, {
    fullDate,
    monthAndDay,
    day,
    isDueByToday,
    isDueThisWeek
  } = dateOptions, t11 = isDueByToday ? "critical" : "transparent", t12 = isDueByToday ? "Today" : isDueThisWeek ? day : monthAndDay;
  let t13;
  $[18] !== dueBy || $[19] !== t12 ? (t13 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, children: /* @__PURE__ */ jsx(Text$1, { as: "time", size: 1, dateTime: dueBy, muted: !0, children: t12 }) }), $[18] = dueBy, $[19] = t12, $[20] = t13) : t13 = $[20];
  let t14;
  $[21] !== t11 || $[22] !== t13 ? (t14 = /* @__PURE__ */ jsx(Card, { tone: t11, padding: 1, radius: 2, children: t13 }), $[21] = t11, $[22] = t13, $[23] = t14) : t14 = $[23];
  let t15;
  return $[24] !== fullDate || $[25] !== t14 ? (t15 = /* @__PURE__ */ jsx(Tooltip, { content: fullDate, children: t14 }), $[24] = fullDate, $[25] = t14, $[26] = t15) : t15 = $[26], t15;
}
function TasksListItem(props2) {
  const $ = c(24), {
    assignedTo,
    title,
    dueBy,
    target,
    onSelect,
    documentId,
    status
  } = props2;
  let t0, t1;
  $[0] !== target ? (t1 = getTargetDocumentMeta(target), $[0] = target, $[1] = t1) : t1 = $[1], t0 = t1;
  const targetDocument = t0;
  let t2;
  $[2] !== documentId || $[3] !== status ? (t2 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(TasksStatus, { documentId, status }) }), $[2] = documentId, $[3] = status, $[4] = t2) : t2 = $[4];
  const t3 = title || "Untitled";
  let t4;
  $[5] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "semibold", children: t3 }), $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== onSelect || $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { flex: 1, children: /* @__PURE__ */ jsx(TitleButton, { onClick: onSelect, mode: "bleed", padding: 2, children: t4 }) }), $[7] = onSelect, $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== assignedTo ? (t6 = assignedTo ? {
    id: assignedTo
  } : void 0, $[10] = assignedTo, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(TasksUserAvatar, { user: t6, withTooltip: !0 }), $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] !== t2 || $[15] !== t5 || $[16] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t2,
    t5,
    t7
  ] }), $[14] = t2, $[15] = t5, $[16] = t7, $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== dueBy || $[19] !== targetDocument ? (t9 = (dueBy || targetDocument) && /* @__PURE__ */ jsxs(TaskDetailsRoot, { align: "center", gap: 2, paddingX: 0, children: [
    dueBy && /* @__PURE__ */ jsx(TaskDueDate, { dueBy }),
    targetDocument && /* @__PURE__ */ jsx(Box, { marginLeft: 1, children: /* @__PURE__ */ jsx(DocumentPreview, { documentId: targetDocument._ref, documentType: targetDocument._type }) })
  ] }), $[18] = dueBy, $[19] = targetDocument, $[20] = t9) : t9 = $[20];
  let t10;
  return $[21] !== t8 || $[22] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t8,
    t9
  ] }), $[21] = t8, $[22] = t9, $[23] = t10) : t10 = $[23], t10;
}
const EMPTY_ARRAY$8 = [], getLabelForStatus = (status) => TASK_STATUS.find((item) => item.value === status)?.title, DetailsFlex = styled(Flex)`
  [data-ui='summary-icon'] {
    transition: transform 0.2s;
    transform: rotate(-90deg);
  }
  &[open] [data-ui='summary-icon'] {
    transform: rotate(0);
  }
  > summary::-webkit-details-marker {
    display: none;
  }
`, SummaryBox = styled(Box)`
  list-style: none;
`;
function TaskList(props2) {
  const $ = c(17), {
    status,
    tasks: tasks2,
    onTaskSelect
  } = props2, t0 = status === "open";
  let t1;
  $[0] !== status ? (t1 = getLabelForStatus(status), $[0] = status, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", muted: !0, children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ChevronDownIcon, { "data-ui": "summary-icon" }) }), $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t2 ? (t4 = /* @__PURE__ */ jsx(SummaryBox, { forwardedAs: "summary", paddingY: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, paddingY: 1, children: [
    t2,
    t3
  ] }) }), $[5] = t2, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== onTaskSelect || $[8] !== status || $[9] !== tasks2 ? (t5 = tasks2?.length > 0 ? tasks2.map((task, index) => {
    const showDivider = index < tasks2.length - 1;
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(TasksListItem, { documentId: task._id, title: task.title, dueBy: task.dueBy, assignedTo: task.assignedTo, target: task.target, onSelect: () => onTaskSelect(task._id), status: task.status }),
      showDivider && /* @__PURE__ */ jsx(MenuDivider, {})
    ] }, task._id);
  }) : /* @__PURE__ */ jsx(EmptyStatusListState, { status }), $[7] = onTaskSelect, $[8] = status, $[9] = tasks2, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(Stack, { space: 4, marginTop: 3, paddingBottom: 5, children: t5 }), $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== t0 || $[14] !== t4 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(DetailsFlex, { forwardedAs: "details", direction: "column", open: t0, children: [
    t4,
    t6
  ] }), $[13] = t0, $[14] = t4, $[15] = t6, $[16] = t7) : t7 = $[16], t7;
}
function TasksList(props2) {
  const $ = c(8), {
    items: t0,
    onTaskSelect
  } = props2, items = t0 === void 0 ? EMPTY_ARRAY$8 : t0;
  let t1, t2;
  $[0] !== items ? (t2 = items.reduce(_temp$w, {}), $[0] = items, $[1] = t2) : t2 = $[1], t1 = t2;
  const tasksByStatus = t1, hasOpenTasks = tasksByStatus.open?.length > 0, hasClosedTasks = tasksByStatus.closed?.length > 0;
  let t3;
  return $[2] !== hasClosedTasks || $[3] !== hasOpenTasks || $[4] !== onTaskSelect || $[5] !== tasksByStatus.closed || $[6] !== tasksByStatus.open ? (t3 = /* @__PURE__ */ jsx(Stack, { space: 4, flex: 1, children: !hasOpenTasks && !hasClosedTasks ? /* @__PURE__ */ jsx(EmptyTasksListState, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(TaskList, { status: "open", tasks: tasksByStatus.open, onTaskSelect }),
    /* @__PURE__ */ jsx(TaskList, { status: "closed", tasks: tasksByStatus.closed, onTaskSelect })
  ] }) }), $[2] = hasClosedTasks, $[3] = hasOpenTasks, $[4] = onTaskSelect, $[5] = tasksByStatus.closed, $[6] = tasksByStatus.open, $[7] = t3) : t3 = $[7], t3;
}
function _temp$w(acc, task) {
  return acc[task.status] || (acc[task.status] = []), acc[task.status].push(task), acc;
}
function TasksUpsellPanel() {
  const $ = c(4), {
    upsellData: data,
    telemetryLogs: t0
  } = useTasksUpsell(), {
    panelPrimaryClicked: onPrimaryClick,
    panelSecondaryClicked: onSecondaryClick
  } = t0;
  if (!data)
    return null;
  let t1;
  return $[0] !== data || $[1] !== onPrimaryClick || $[2] !== onSecondaryClick ? (t1 = /* @__PURE__ */ jsx(Container$2, { width: 1, children: /* @__PURE__ */ jsx(Box, { marginBottom: 6, children: /* @__PURE__ */ jsx(UpsellPanel, { data, onPrimaryClick, onSecondaryClick }) }) }), $[0] = data, $[1] = onPrimaryClick, $[2] = onSecondaryClick, $[3] = t1) : t1 = $[3], t1;
}
const FEEDBACK_FORM_LINK = "https://snty.link/tasks-feedback", Span$1 = styled.span`
  margin-right: 0.2em;
`, Link = styled.a`
  white-space: nowrap;
  > [data-sanity-icon] {
    --card-icon-color: var(--card-link-color);
  }
`;
function LinkComponent(props2) {
  const $ = c(5);
  let t0;
  $[0] !== props2.children ? (t0 = /* @__PURE__ */ jsx(Span$1, { children: props2.children }), $[0] = props2.children, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(LaunchIcon, {}), $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== t0 ? (t2 = /* @__PURE__ */ jsxs(Link, { href: FEEDBACK_FORM_LINK, target: "_blank", rel: "noreferrer", children: [
    t0,
    " ",
    t1
  ] }), $[3] = t0, $[4] = t2) : t2 = $[4], t2;
}
function TasksListFeedbackFooter() {
  const $ = c(3), {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    Link: LinkComponent
  }, $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== t ? (t1 = /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "list.feedback.text", t, components: t0 }) }) }), $[1] = t, $[2] = t1) : t1 = $[2], t1;
}
const LIST_STYLES = {
  marginLeft: "-0.5em",
  justifyContent: "space-between",
  display: "flex"
};
function TasksListTabs(t0) {
  const $ = c(22), {
    activeTabId,
    onChange
  } = t0, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1, t2;
  $[0] !== t ? (t2 = t("tab.assigned.label"), $[0] = t, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== t2 ? (t3 = {
    id: "assigned",
    label: t2
  }, $[2] = t2, $[3] = t3) : t3 = $[3];
  let t4;
  $[4] !== t ? (t4 = t("tab.subscribed.label"), $[4] = t, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t4 ? (t5 = {
    id: "subscribed",
    label: t4
  }, $[6] = t4, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== t ? (t6 = t("tab.document.label"), $[8] = t, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== t6 ? (t7 = {
    id: "document",
    label: t6
  }, $[10] = t6, $[11] = t7) : t7 = $[11];
  let t8;
  $[12] !== t3 || $[13] !== t5 || $[14] !== t7 ? (t8 = [t3, t5, t7], $[12] = t3, $[13] = t5, $[14] = t7, $[15] = t8) : t8 = $[15], t1 = t8;
  const tabs = t1;
  let t9;
  $[16] !== onChange ? (t9 = (tab) => {
    onChange(tab.id);
  }, $[16] = onChange, $[17] = t9) : t9 = $[17];
  const handleTabChange = t9;
  let t10;
  return $[18] !== activeTabId || $[19] !== handleTabChange || $[20] !== tabs ? (t10 = /* @__PURE__ */ jsx(TabList, { space: 2, style: LIST_STYLES, children: tabs.map((tab_0) => /* @__PURE__ */ jsx(Tab, { "aria-controls": `${tab_0.id}-panel`, id: `${tab_0.id}-tab`, onClick: () => handleTabChange(tab_0), selected: tab_0.id === activeTabId, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: tab_0.label }) }, `${tab_0.id}-tab`)) }), $[18] = activeTabId, $[19] = handleTabChange, $[20] = tabs, $[21] = t10) : t10 = $[21], t10;
}
const Divider$1 = styled.div((props2) => `
    height: 25px;
    width: 1px;
    background-color: ${getTheme_v2(props2.theme).color.input.default.enabled.border};
  `);
function TasksActiveTabNavigation(props2) {
  const $ = c(41), {
    items: allItems
  } = props2, {
    state,
    setViewMode
  } = useTasksNavigation(), {
    selectedTask
  } = state;
  let items, t0;
  if ($[0] !== allItems || $[1] !== selectedTask) {
    items = allItems.filter(_temp$v);
    let t15;
    $[4] !== selectedTask ? (t15 = (item) => item._id === selectedTask, $[4] = selectedTask, $[5] = t15) : t15 = $[5], t0 = items.findIndex(t15), $[0] = allItems, $[1] = selectedTask, $[2] = items, $[3] = t0;
  } else
    items = $[2], t0 = $[3];
  const currentItemIndex = t0;
  let t1;
  $[6] !== currentItemIndex || $[7] !== items || $[8] !== setViewMode ? (t1 = () => {
    const prevTaskId = currentItemIndex > 0 ? items[currentItemIndex - 1]._id : items[items.length - 1]._id;
    setViewMode({
      type: "edit",
      id: prevTaskId
    });
  }, $[6] = currentItemIndex, $[7] = items, $[8] = setViewMode, $[9] = t1) : t1 = $[9];
  const goToPreviousTask = t1;
  let t2;
  $[10] !== currentItemIndex || $[11] !== items || $[12] !== setViewMode ? (t2 = () => {
    const nextTaskId = currentItemIndex < items.length - 1 ? items[currentItemIndex + 1]._id : items[0]._id;
    setViewMode({
      type: "edit",
      id: nextTaskId
    });
  }, $[10] = currentItemIndex, $[11] = items, $[12] = setViewMode, $[13] = t2) : t2 = $[13];
  const goToNextTask = t2, {
    t: t_0
  } = useTranslation(tasksLocaleNamespace);
  if (!items.length)
    return null;
  let t3;
  $[14] !== t_0 ? (t3 = t_0("buttons.previous.tooltip"), $[14] = t_0, $[15] = t3) : t3 = $[15];
  let t4;
  $[16] !== t3 ? (t4 = {
    content: t3
  }, $[16] = t3, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== goToPreviousTask || $[19] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { tooltipProps: t4, mode: "bleed", icon: ChevronLeftIcon, onClick: goToPreviousTask }), $[18] = goToPreviousTask, $[19] = t4, $[20] = t5) : t5 = $[20];
  let t6;
  $[21] !== t_0 ? (t6 = t_0("panel.navigation.tooltip"), $[21] = t_0, $[22] = t6) : t6 = $[22];
  const t7 = currentItemIndex + 1;
  let t8;
  $[23] !== items.length || $[24] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { paddingY: 2, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t7,
    " / ",
    items.length
  ] }) }), $[23] = items.length, $[24] = t7, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== t6 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsx(Tooltip, { content: t6, children: t8 }), $[26] = t6, $[27] = t8, $[28] = t9) : t9 = $[28];
  let t10;
  $[29] !== t_0 ? (t10 = t_0("buttons.next.tooltip"), $[29] = t_0, $[30] = t10) : t10 = $[30];
  let t11;
  $[31] !== t10 ? (t11 = {
    content: t10
  }, $[31] = t10, $[32] = t11) : t11 = $[32];
  let t12;
  $[33] !== goToNextTask || $[34] !== t11 ? (t12 = /* @__PURE__ */ jsx(Button, { tooltipProps: t11, mode: "bleed", icon: ChevronRightIcon, onClick: goToNextTask }), $[33] = goToNextTask, $[34] = t11, $[35] = t12) : t12 = $[35];
  let t13;
  $[36] === Symbol.for("react.memo_cache_sentinel") ? (t13 = /* @__PURE__ */ jsx(Divider$1, {}), $[36] = t13) : t13 = $[36];
  let t14;
  return $[37] !== t12 || $[38] !== t5 || $[39] !== t9 ? (t14 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(Flex, { gap: 1, align: "center", children: [
    t5,
    t9,
    t12,
    t13
  ] }) }), $[37] = t12, $[38] = t5, $[39] = t9, $[40] = t14) : t14 = $[40], t14;
}
function _temp$v(t) {
  return t.status === "open";
}
const MENU_BUTTON_POPOVER_PROPS = {
  constrainSize: !0,
  fallbackPlacements: ["bottom-end"],
  placement: "bottom-end",
  portal: !0
}, StyledMenu$5 = styled(Menu)`
  width: 220px;
`;
function TasksDraftsMenuItem(props2) {
  const $ = c(8), {
    isSelected,
    item,
    onSelect
  } = props2;
  let t0;
  $[0] !== item._id || $[1] !== onSelect ? (t0 = () => {
    onSelect(item._id);
  }, $[0] = item._id, $[1] = onSelect, $[2] = t0) : t0 = $[2];
  const handleClick = t0, iconRight = isSelected ? CheckmarkIcon : void 0, text = item.title || "Untitled";
  let t1;
  return $[3] !== handleClick || $[4] !== iconRight || $[5] !== isSelected || $[6] !== text ? (t1 = /* @__PURE__ */ jsx(MenuItem$1, { iconRight, onClick: handleClick, pressed: isSelected, selected: isSelected, text }), $[3] = handleClick, $[4] = iconRight, $[5] = isSelected, $[6] = text, $[7] = t1) : t1 = $[7], t1;
}
function TasksHeaderDraftsMenu() {
  const {
    data
  } = useTasks(), {
    state,
    setViewMode
  } = useTasksNavigation(), {
    viewMode,
    selectedTask
  } = state, currentUser = useCurrentUser(), draftTasks = useMemo(() => currentUser?.id ? data.filter((task) => {
    const isAuthoredByUser = task.authorId === currentUser.id, isDraft2 = !task.createdByUser, hasEdits = task._updatedAt !== task._createdAt, isNotTheTaskBeingCreated = viewMode === "create" ? task._id !== selectedTask : !0;
    return isAuthoredByUser && isDraft2 && isNotTheTaskBeingCreated && hasEdits;
  }) : [], [data, selectedTask, currentUser?.id, viewMode]), handleSelectTask = useCallback((id2) => {
    setViewMode({
      type: "draft",
      id: id2
    });
  }, [setViewMode]), {
    t
  } = useTranslation(tasksLocaleNamespace);
  return draftTasks.length ? /* @__PURE__ */ jsx(MenuButton$1, { button: /* @__PURE__ */ jsx(Button, { text: t("buttons.draft.text"), mode: "ghost", iconRight: ChevronDownIcon }), id: "edit-task-menu", menu: /* @__PURE__ */ jsxs(StyledMenu$5, { children: [
    /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", children: t("panel.drafts.title") }) }),
    /* @__PURE__ */ jsx(MenuDivider, {}),
    draftTasks?.map((task_0) => /* @__PURE__ */ jsx(TasksDraftsMenuItem, { isSelected: selectedTask === task_0._id, item: task_0, onSelect: handleSelectTask }, task_0._id))
  ] }), popover: MENU_BUTTON_POPOVER_PROPS }) : null;
}
function TasksSidebarHeader(props2) {
  const $ = c(34), {
    items: allItems
  } = props2, {
    mode
  } = useTasksEnabled(), {
    state,
    setViewMode,
    handleCloseTasks
  } = useTasksNavigation(), {
    viewMode,
    activeTabId
  } = state;
  let t0;
  $[0] !== setViewMode ? (t0 = () => {
    setViewMode({
      type: "create"
    });
  }, $[0] = setViewMode, $[1] = t0) : t0 = $[1];
  const handleTaskCreate = t0;
  let t1;
  $[2] !== setViewMode ? (t1 = () => {
    setViewMode({
      type: "list"
    });
  }, $[2] = setViewMode, $[3] = t1) : t1 = $[3];
  const handleGoBack = t1, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t2;
  $[4] !== activeTabId || $[5] !== handleGoBack || $[6] !== t || $[7] !== viewMode ? (t2 = /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, children: viewMode === "list" ? /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 2, weight: "semibold", children: t("panel.title") }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Button$1, { mode: "bleed", space: 2, padding: 2, onClick: handleGoBack, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("panel.title") }) }),
    /* @__PURE__ */ jsx(ChevronRightIcon, {}),
    /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "semibold", style: {
      textTransform: "capitalize"
    }, children: viewMode === "create" || viewMode === "draft" ? t("panel.create.title") : activeTabId }) })
  ] }) }), $[4] = activeTabId, $[5] = handleGoBack, $[6] = t, $[7] = viewMode, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== viewMode ? (t3 = (viewMode === "create" || viewMode === "draft") && /* @__PURE__ */ jsx(TasksHeaderDraftsMenu, {}), $[9] = viewMode, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== allItems || $[12] !== viewMode ? (t4 = viewMode === "edit" && /* @__PURE__ */ jsx(TasksActiveTabNavigation, { items: allItems }), $[11] = allItems, $[12] = viewMode, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== handleTaskCreate || $[15] !== mode || $[16] !== t || $[17] !== viewMode ? (t5 = viewMode === "list" && /* @__PURE__ */ jsx(Button, { icon: AddIcon, onClick: handleTaskCreate, mode: "bleed", text: t("buttons.new.text"), disabled: mode === "upsell", tooltipProps: mode === "upsell" ? {
    content: t("buttons.new.upsell-tooltip")
  } : void 0 }), $[14] = handleTaskCreate, $[15] = mode, $[16] = t, $[17] = viewMode, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== t ? (t6 = t("panel.close.tooltip"), $[19] = t, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== t6 ? (t7 = {
    content: t6
  }, $[21] = t6, $[22] = t7) : t7 = $[22];
  let t8;
  $[23] !== handleCloseTasks || $[24] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { tooltipProps: t7, iconRight: CloseIcon, mode: "bleed", onClick: handleCloseTasks }), $[23] = handleCloseTasks, $[24] = t7, $[25] = t8) : t8 = $[25];
  let t9;
  $[26] !== t5 || $[27] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t5,
    t8
  ] }), $[26] = t5, $[27] = t8, $[28] = t9) : t9 = $[28];
  let t10;
  return $[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { justify: "space-between", align: "center", gap: 1, children: [
    t2,
    t3,
    t4,
    t9
  ] }), $[29] = t2, $[30] = t3, $[31] = t4, $[32] = t9, $[33] = t10) : t10 = $[33], t10;
}
const RootCard$2 = styled(Card)`
  flex: 1;
  flex-direction: column;
`, HeaderStack = styled(Stack)`
  border-bottom: 1px solid var(--card-border-color);
`, ContentFlex$1 = styled(Flex)`
  overflow-y: scroll;
  overflow-x: hidden;
`;
function TasksStudioSidebarInner() {
  const {
    mode
  } = useTasksEnabled(), {
    activeDocument,
    data,
    isLoading
  } = useTasks(), {
    state,
    setActiveTab,
    setViewMode
  } = useTasksNavigation(), {
    activeTabId,
    viewMode,
    selectedTask
  } = state, currentUser = useCurrentUser(), onTaskSelect = useCallback((id2) => setViewMode({
    type: "edit",
    id: id2
  }), [setViewMode]), filteredList = useMemo(() => data.filter((item) => item.createdByUser ? activeTabId === "assigned" ? item.assignedTo === currentUser?.id : activeTabId === "subscribed" ? currentUser?.id && item.subscribers?.includes(currentUser.id) : activeTabId === "document" ? activeDocument?.documentId && item.target?.document._ref === activeDocument.documentId : !1 : !1), [activeDocument?.documentId, activeTabId, data, currentUser]), content = useMemo(() => viewMode !== "list" ? /* @__PURE__ */ jsx(TasksFormBuilder, {}, selectedTask) : isLoading ? /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", children: /* @__PURE__ */ jsx(Spinner, {}) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    mode === "upsell" && /* @__PURE__ */ jsx(TasksUpsellPanel, {}),
    /* @__PURE__ */ jsx(TasksList, { items: filteredList, onTaskSelect })
  ] }), [filteredList, isLoading, onTaskSelect, selectedTask, viewMode, mode]);
  return /* @__PURE__ */ jsxs(RootCard$2, { display: "flex", height: "fill", flex: 1, overflow: "hidden", children: [
    /* @__PURE__ */ jsxs(HeaderStack, { space: 3, padding: 3, sizing: "border", children: [
      /* @__PURE__ */ jsx(TasksSidebarHeader, { items: filteredList }),
      viewMode === "list" && !isLoading && /* @__PURE__ */ jsx(TasksListTabs, { activeTabId, onChange: setActiveTab })
    ] }),
    /* @__PURE__ */ jsx(ContentFlex$1, { direction: "column", flex: 1, overflow: "auto", padding: 3, paddingTop: 4, paddingX: 4, sizing: "border", children: content }),
    viewMode === "list" && /* @__PURE__ */ jsx(TasksListFeedbackFooter, {})
  ] });
}
function TasksStudioSidebar() {
  const $ = c(1), {
    enabled
  } = useTasksEnabled();
  if (!enabled)
    return null;
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(TasksStudioSidebarInner, {}), $[0] = t0) : t0 = $[0], t0;
}
const VARIANTS = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  }
}, TRANSITION = {
  duration: 0.2
}, FULLSCREEN_MEDIA_INDEX = 1, POSITION_ABSOLUTE_MEDIA_INDEX = 3, RootFlex$1 = styled(Flex)(({
  theme
}) => {
  const media = theme.sanity.media;
  return css`
    min-height: 100%;

    @media (max-width: ${media[POSITION_ABSOLUTE_MEDIA_INDEX]}px) {
      position: relative;
    }
  `;
}), SidebarMotionLayer = styled(motion.create(Layer))(({
  theme
}) => {
  const media = theme.sanity.media;
  return css`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 360px;
    border-left: 1px solid var(--card-border-color);
    box-sizing: border-box;
    overflow: hidden;

    box-shadow:
      0px 6px 8px -4px var(--card-shadow-umbra-color),
      0px 12px 17px -1px var(--card-shadow-penumbra-color);

    @media (max-width: ${media[POSITION_ABSOLUTE_MEDIA_INDEX]}px) {
      bottom: 0;
      position: absolute;
      right: 0;
      top: 0;
    }

    @media (max-width: ${media[FULLSCREEN_MEDIA_INDEX]}px) {
      border-left: 0;
      min-width: 100%;
      left: 0;
    }
  `;
});
function TasksStudioActiveToolLayoutInner(props2) {
  const $ = c(12), mediaIndex = useMediaIndex(), {
    state: t0
  } = useTasksNavigation(), {
    isOpen
  } = t0, t1 = mediaIndex <= FULLSCREEN_MEDIA_INDEX && isOpen ? "hidden" : "auto";
  let t2;
  $[0] !== props2 ? (t2 = props2.renderDefault(props2), $[0] = props2, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== t1 || $[3] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { flex: 1, height: "fill", overflow: t1, children: t2 }), $[2] = t1, $[3] = t2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== isOpen ? (t4 = isOpen && /* @__PURE__ */ jsx(SidebarMotionLayer, { animate: "visible", zOffset: 100, height: "fill", initial: "hidden", transition: TRANSITION, variants: VARIANTS, children: /* @__PURE__ */ jsx(TasksStudioSidebar, {}) }), $[5] = isOpen, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(AnimatePresence, { initial: !1, children: t4 }), $[7] = t4, $[8] = t5) : t5 = $[8];
  let t6;
  return $[9] !== t3 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(RootFlex$1, { sizing: "border", height: "fill", children: [
    t3,
    t5
  ] }), $[9] = t3, $[10] = t5, $[11] = t6) : t6 = $[11], t6;
}
function TasksStudioActiveToolLayout(props2) {
  const $ = c(4), {
    enabled
  } = useTasksEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== props2 ? (t0 = /* @__PURE__ */ jsx(TasksStudioActiveToolLayoutInner, { ...props2 }), $[2] = props2, $[3] = t0) : t0 = $[3], t0;
}
const TasksStudioLayoutInner = (props2) => {
  const $ = c(9), {
    enabled,
    mode
  } = useTasksEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  const t0 = mode === "upsell";
  let t1;
  $[2] !== props2 ? (t1 = props2.renderDefault(props2), $[2] = props2, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(TasksProvider, { children: /* @__PURE__ */ jsx(TasksNavigationProvider, { children: t1 }) }), $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t0 || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(AddonDatasetProvider, { children: /* @__PURE__ */ jsx(ConditionalWrapper, { condition: t0, wrapper: _temp$u, children: t2 }) }), $[6] = t0, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
};
function TasksStudioLayout(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(TasksEnabledProvider, { children: /* @__PURE__ */ jsx(TasksStudioLayoutInner, { ...props2 }) }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function _temp$u(children) {
  return /* @__PURE__ */ jsx(TasksUpsellProvider, { children });
}
const EMPTY_ARRAY$7 = [], TasksToolbar = (t0) => {
  const $ = c(8), {
    onClick: onClick2,
    isOpen
  } = t0, {
    t
  } = useTranslation(tasksLocaleNamespace);
  let t1;
  $[0] !== t ? (t1 = t("toolbar.tooltip"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = {
    content: t1
  }, $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== isOpen || $[5] !== onClick2 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Button, { tooltipProps: t2, icon: CheckmarkCircleIcon, mode: "bleed", onClick: onClick2, selected: isOpen, "data-testid": "tasks-toolbar" }), $[4] = isOpen, $[5] = onClick2, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
};
function TasksStudioNavbarInner(props2) {
  const {
    handleOpenTasks,
    handleCloseTasks,
    state: {
      isOpen
    }
  } = useTasksNavigation(), {
    t
  } = useTranslation(tasksLocaleNamespace), handleClick = useCallback(() => {
    isOpen ? handleCloseTasks() : handleOpenTasks();
  }, [isOpen, handleOpenTasks, handleCloseTasks]), renderTasksNav = useCallback(() => /* @__PURE__ */ jsx(TasksToolbar, { onClick: handleClick, isOpen }), [handleClick, isOpen]), actions = useMemo(() => [...props2?.__internal_actions || EMPTY_ARRAY$7, {
    location: "topbar",
    name: "tasks-topbar",
    render: renderTasksNav
  }, {
    icon: CheckmarkCircleIcon,
    location: "sidebar",
    name: "tasks-sidebar",
    onAction: handleClick,
    selected: isOpen,
    title: t("actions.open.text")
  }], [handleClick, isOpen, props2?.__internal_actions, renderTasksNav, t]);
  return props2.renderDefault({
    ...props2,
    // eslint-disable-next-line camelcase
    __internal_actions: actions
  });
}
function TasksStudioNavbar(props2) {
  const $ = c(4), {
    enabled
  } = useTasksEnabled();
  if (!enabled) {
    let t02;
    return $[0] !== props2 ? (t02 = props2.renderDefault(props2), $[0] = props2, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== props2 ? (t0 = /* @__PURE__ */ jsx(TasksStudioNavbarInner, { ...props2 }), $[2] = props2, $[3] = t0) : t0 = $[3], t0;
}
const TASKS_NAME = "sanity/tasks", tasks = definePlugin({
  name: TASKS_NAME,
  // eslint-disable-next-line camelcase
  __internal_tasks: {
    footerAction: /* @__PURE__ */ jsx(TasksFooterOpenTasks, {})
  },
  document: {
    actions: (prev) => [...prev, TaskCreateAction].filter(Boolean)
  },
  studio: {
    components: {
      layout: TasksStudioLayout,
      navbar: TasksStudioNavbar,
      activeToolLayout: TasksStudioActiveToolLayout
    }
  },
  form: {
    components: {
      input: (props2) => props2.id === "root" && props2.schemaType.type?.name === "document" ? /* @__PURE__ */ jsx(TasksDocumentInputLayout, { ...props2 }) : props2.renderDefault(props2)
    }
  },
  i18n: {
    bundles: [tasksUsEnglishLocaleBundle]
  }
}), defaultPlugins = [comments(), tasks(), scheduledPublishing(), createIntegration(), releases(), canvasIntegration()];
function getDefaultPlugins(options, plugins) {
  return defaultPlugins.filter((plugin) => plugin.name === SCHEDULED_PUBLISHING_NAME ? options.scheduledPublishing.enabled && !!plugins?.length : plugin.name === TASKS_NAME ? options.tasks.enabled : plugin.name === RELEASES_NAME ? options.releases.enabled : plugin.name === CANVAS_INTEGRATION_NAME ? options.apps?.canvas?.enabled ?? !1 : !0);
}
function getDefaultPluginsOptions(workspace) {
  return {
    tasks: {
      enabled: !0,
      ...workspace.unstable_tasks,
      ...workspace.tasks
    },
    scheduledPublishing: {
      ...DEFAULT_SCHEDULED_PUBLISH_PLUGIN_OPTIONS,
      ...workspace.scheduledPublishing,
      // If the user has explicitly enabled scheduled publishing, we should respect that
      // eslint-disable-next-line camelcase
      __internal__workspaceEnabled: workspace.scheduledPublishing?.enabled ?? !1
    },
    releases: {
      ...workspace.releases,
      enabled: workspace.releases?.enabled ?? !0
    },
    apps: {
      canvas: {
        // By default canvas app is enabled
        enabled: !0,
        ...workspace.apps?.canvas
      }
    }
  };
}
function resolveSchemaTypes({
  config,
  context
}) {
  return resolveConfigProperty({
    propertyName: "schema.types",
    config,
    context,
    initialValue: [],
    reducer: schemaTypesReducer
  });
}
class SchemaError extends Error {
  constructor(schema2) {
    super("SchemaError"), this.schema = schema2, this.name = "SchemaError";
  }
}
const isError$1 = (p) => p.severity === "error";
function normalizeIcon(Icon2, title, subtitle = "") {
  return isValidElementType(Icon2) ? /* @__PURE__ */ jsx(Icon2, {}) : isValidElement(Icon2) ? Icon2 : createDefaultIcon(title, subtitle);
}
const preparedWorkspaces = /* @__PURE__ */ new WeakMap(), createMediaLibraryAssetSources = (config) => {
  const libraryId = mediaLibraryLibraryIdReducer({
    config,
    initialValue: void 0
  });
  if (!mediaLibraryEnabledReducer({
    config,
    initialValue: !1
  }))
    return {
      fileSource: null,
      imageSource: null
    };
  const fileSource = createSanityMediaLibraryFileSource({
    libraryId: libraryId || null
  }), imageSource = createSanityMediaLibraryImageSource({
    libraryId: libraryId || null
  });
  return {
    fileSource,
    imageSource
  };
}, createDatasetAssetSources = (config, client) => {
  const fileSource = createDatasetFileAssetSource({
    client,
    title: config.title || config.name
  }), imageSource = createDatasetImageAssetSource({
    client,
    title: config.title || config.name
  });
  return {
    fileSource,
    imageSource
  };
};
function prepareConfig(config, options) {
  if (!Array.isArray(config) && "missingConfigFile" in config)
    throw new ConfigResolutionError({
      name: "",
      type: "configuration file",
      causes: ["No `sanity.config.ts` file found", "No `sanity.config.js` file found"]
    });
  const rootPath = getRootPath(options?.basePath), workspaceOptions = Array.isArray(config) ? config : [{
    ...config,
    name: config.name ?? "default"
  }];
  try {
    validateWorkspaces({
      workspaces: workspaceOptions
    });
  } catch (e) {
    throw new ConfigResolutionError({
      name: "",
      type: "workspace",
      causes: [e.message]
    });
  }
  return {
    type: "prepared-config",
    workspaces: workspaceOptions.map((rawWorkspace) => {
      if (preparedWorkspaces.has(rawWorkspace))
        return preparedWorkspaces.get(rawWorkspace);
      const defaultPluginsOptions = getDefaultPluginsOptions(rawWorkspace), {
        unstable_sources: nestedSources = [],
        ...rootSource
      } = rawWorkspace, resolvedSources = [rootSource, ...nestedSources].map(({
        plugins,
        ...source
      }) => ({
        ...source,
        plugins: [...plugins ?? [], ...getDefaultPlugins(defaultPluginsOptions, plugins)].filter((plugin) => {
          const validPlugin = plugin.name !== "@sanity/assist" || plugin.handlesGDR;
          return validPlugin || console.warn(`Found an incompatible version of @sanity/assist plugin. It has been disabled.
To re-enable the plugin, please upgrade to https://github.com/sanity-io/assist/releases/tag/v3.2.2 or later.`), validPlugin;
        })
      })).map((source) => {
        const {
          projectId,
          dataset
        } = source;
        let schemaTypes;
        try {
          schemaTypes = resolveSchemaTypes({
            config: source,
            context: {
              projectId,
              dataset
            }
          });
        } catch (e) {
          throw new ConfigResolutionError({
            name: source.name,
            type: "source",
            causes: [e]
          });
        }
        const schema2 = createSchema({
          name: source.name,
          types: schemaTypes
        }), schemaValidationProblemGroups = schema2._validation, schemaErrors = schemaValidationProblemGroups?.filter((msg) => msg.problems.some(isError$1));
        if (schemaValidationProblemGroups && schemaErrors?.length)
          throw new SchemaError(schema2);
        const auth = getAuthStore(source), i18n = prepareI18n(source), source$ = auth.state.pipe(map(({
          client,
          authenticated,
          currentUser
        }) => resolveSource({
          config: source,
          client,
          currentUser,
          schema: schema2,
          authenticated,
          auth,
          i18n
        })), shareReplay(1));
        return {
          name: source.name,
          projectId: source.projectId,
          dataset: source.dataset,
          title: source.title || startCase(source.name),
          auth,
          schema: schema2,
          i18n: i18n.source,
          source: source$
        };
      }), title = rootSource.title || startCase(rootSource.name), workspaceSummary = {
        type: "workspace-summary",
        auth: resolvedSources[0].auth,
        basePath: joinBasePath(rootPath, rootSource.basePath),
        dataset: rootSource.dataset,
        schema: resolvedSources[0].schema,
        i18n: resolvedSources[0].i18n,
        customIcon: !!rootSource.icon,
        icon: normalizeIcon(rootSource.icon, title, `${rootSource.projectId} ${rootSource.dataset}`),
        name: rootSource.name || "default",
        projectId: rootSource.projectId,
        theme: rootSource.theme || studioTheme,
        title,
        subtitle: rootSource.subtitle,
        __internal: {
          sources: resolvedSources
        },
        ...defaultPluginsOptions
      };
      return preparedWorkspaces.set(rawWorkspace, workspaceSummary), workspaceSummary;
    })
  };
}
function getAuthStore(source) {
  if (isAuthStore(source.auth))
    return source.auth;
  const clientFactory = source.unstable_clientFactory || createClient, {
    projectId,
    dataset,
    apiHost
  } = source;
  return createAuthStore({
    apiHost,
    ...source.auth,
    clientFactory,
    dataset,
    projectId
  });
}
function getBifurClient(client, auth) {
  const bifurVersionedClient = client.withConfig({
    apiVersion: "2022-06-30"
  }), {
    dataset,
    url: baseUrl,
    requestTagPrefix = "sanity.studio"
  } = bifurVersionedClient.config(), urlWithTag = `${`${baseUrl.replace(/\/+$/, "")}/socket/${dataset}`.replace(/^http/, "ws")}?tag=${requestTagPrefix}`, options = auth.token ? {
    token$: auth.token
  } : {};
  return fromUrl(urlWithTag, options);
}
function resolveSource({
  config,
  client,
  currentUser,
  schema: schema2,
  authenticated,
  auth,
  i18n
}) {
  const {
    dataset,
    projectId
  } = config, bifur = getBifurClient(client, auth), errors = [], clients = {}, getClient2 = (options) => {
    if (!options || !options.apiVersion)
      throw new Error("Missing required `apiVersion` option");
    return clients[options.apiVersion] || (clients[options.apiVersion] = client.withConfig(options)), clients[options.apiVersion];
  }, context = {
    client,
    getClient: getClient2,
    currentUser,
    dataset,
    projectId,
    schema: schema2,
    i18n: i18n.source
  }, wrappedClient = client;
  context.client = [...Object.keys(client), ...Object.keys(wrappedClient.__proto__)].reduce((acc, key) => {
    const original = Object.hasOwnProperty.call(client, key) ? wrappedClient[key] : wrappedClient.__proto__[key];
    return Object.defineProperty(acc, key, {
      get() {
        return console.warn('`configContext.client` is deprecated and will be removed in the next release! Use `context.getClient({apiVersion: "2021-06-07"})` instead'), original;
      }
    });
  }, {});
  const defaultAssetSources = createDatasetAssetSources(config, context.client), mediaLibraryAssetSources = createMediaLibraryAssetSources(config);
  let templates;
  try {
    templates = resolveConfigProperty({
      config,
      context,
      propertyName: "schema.templates",
      reducer: schemaTemplatesReducer,
      initialValue: schema2.getTypeNames().filter((typeName) => !/^sanity\./.test(typeName)).map((typeName) => schema2.get(typeName)).filter(isNonNullable$3).filter((schemaType) => schemaType.type?.name === "document").map((schemaType) => ({
        id: schemaType.name,
        schemaType: schemaType.name,
        title: schemaType.title || schemaType.name,
        icon: schemaType.icon,
        value: schemaType.initialValue || {
          _type: schemaType.name
        }
      }))
    });
  } catch (e) {
    throw new ConfigResolutionError({
      name: config.name,
      type: "source",
      causes: [e]
    });
  }
  let tools;
  try {
    tools = resolveConfigProperty({
      config,
      context,
      initialValue: [],
      propertyName: "tools",
      reducer: toolsReducer
    });
  } catch (e) {
    throw new ConfigResolutionError({
      name: config.name,
      type: "source",
      causes: [e]
    });
  }
  if (tools.some(({
    name
  }) => name === "tool"))
    throw new Error('A tool cannot have the name "tool". Please enter a different name.');
  const initialTemplatesResponses = templates.filter((template2) => !template2.parameters?.length).map((template2) => ({
    templateId: template2.id,
    description: template2.description,
    icon: template2.icon,
    title: template2.title
  })), templateMap = templates.reduce((acc, template2) => (acc.set(template2.id, template2), acc), /* @__PURE__ */ new Map()), resolveNewDocumentOptions = (creationContext) => {
    const {
      schemaType: schemaTypeName
    } = creationContext, templateResponses = resolveConfigProperty({
      config,
      context: {
        ...context,
        creationContext
      },
      initialValue: initialTemplatesResponses,
      propertyName: "document.resolveNewDocumentOptions",
      reducer: newDocumentOptionsResolver
    }), templateErrors = [];
    if (templateErrors.length)
      throw new ConfigResolutionError({
        name: config.name,
        type: "source",
        causes: templateErrors
      });
    return templateResponses.map((response, index) => {
      const template2 = templateMap.get(response.templateId);
      if (!template2)
        throw new Error(`Could not find template with ID \`${response.templateId}\``);
      const schemaType = schema2.get(template2.schemaType);
      if (!schemaType)
        throw new Error(`Could not find matching schema type \`${template2.schemaType}\` for template \`${template2.id}\``);
      const title = response.title || template2.title, defaultSubtitle = schemaType?.title === title ? void 0 : schemaType?.title;
      return {
        id: `${response.templateId}-${index}`,
        templateId: response.templateId,
        type: "initialValueTemplateItem",
        title,
        i18n: response.i18n || template2.i18n,
        subtitle: response.subtitle || defaultSubtitle,
        description: response.description || template2.description,
        icon: response.icon || template2.icon || schemaType?.icon,
        initialDocumentId: response.initialDocumentId,
        parameters: response.parameters,
        schemaType: template2.schemaType
      };
    }).filter((item) => !schemaTypeName || creationContext.type === "document" ? !0 : schemaTypeName === templateMap.get(item.templateId)?.schemaType);
  };
  let staticInitialValueTemplateItems;
  try {
    staticInitialValueTemplateItems = resolveNewDocumentOptions({
      type: "global"
    });
  } catch (e) {
    errors.push(e);
  }
  if (errors.length)
    throw new ConfigResolutionError({
      name: config.name,
      type: "source",
      causes: errors
    });
  return {
    type: "source",
    name: config.name,
    title: config.title || startCase(config.name),
    schema: schema2,
    getClient: getClient2,
    dataset,
    projectId,
    tools,
    currentUser,
    authenticated,
    templates,
    auth,
    i18n: i18n.source,
    // eslint-disable-next-line camelcase
    __internal_tasks: internalTasksReducer({
      config
    }),
    document: {
      actions: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: initialDocumentActions,
        propertyName: "document.actions",
        reducer: documentActionsReducer
      }),
      badges: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: initialDocumentBadges,
        propertyName: "document.badges",
        reducer: documentBadgesReducer
      }),
      unstable_fieldActions: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: initialDocumentFieldActions,
        propertyName: "document.unstable_fieldActions",
        reducer: documentFieldActionsReducer
      }),
      inspectors: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: EMPTY_ARRAY$A,
        propertyName: "document.inspectors",
        reducer: documentInspectorsReducer
      }),
      resolveProductionUrl: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: void 0,
        propertyName: "resolveProductionUrl",
        asyncReducer: resolveProductionUrlReducer
      }),
      resolveNewDocumentOptions,
      unstable_languageFilter: (partialContext) => resolveConfigProperty({
        config,
        context: {
          ...context,
          ...partialContext
        },
        initialValue: initialLanguageFilter,
        propertyName: "document.unstable_languageFilter",
        reducer: documentLanguageFilterReducer
      }),
      /** @todo this is deprecated so it will eventually be removed */
      unstable_comments: {
        enabled: (partialContext) => documentCommentsEnabledReducer({
          context: partialContext,
          config,
          initialValue: !0
        })
      },
      comments: {
        enabled: (partialContext) => documentCommentsEnabledReducer({
          context: partialContext,
          config,
          initialValue: !0
        })
      }
    },
    form: {
      file: {
        assetSources: resolveConfigProperty({
          config,
          context,
          initialValue: mediaLibraryAssetSources.fileSource ? [mediaLibraryAssetSources.fileSource, defaultAssetSources.fileSource] : [defaultAssetSources.fileSource],
          propertyName: "formBuilder.file.assetSources",
          reducer: fileAssetSourceResolver
        }),
        directUploads: directUploadsReducer({
          config,
          schemaTypeName: "file"
        })
      },
      image: {
        assetSources: resolveConfigProperty({
          config,
          context,
          initialValue: mediaLibraryAssetSources.imageSource ? [mediaLibraryAssetSources.imageSource, defaultAssetSources.imageSource] : [defaultAssetSources.imageSource],
          propertyName: "formBuilder.image.assetSources",
          reducer: imageAssetSourceResolver
        }),
        directUploads: directUploadsReducer({
          config,
          schemaTypeName: "image"
        })
      }
    },
    search: {
      filters: filterDefinitions,
      operators: operatorDefinitions,
      unstable_partialIndexing: {
        enabled: partialIndexingEnabledReducer({
          config,
          initialValue: config.search?.unstable_partialIndexing?.enabled ?? !1
        })
      },
      strategy: searchStrategyReducer({
        config,
        initialValue: "groqLegacy"
      }),
      enableLegacySearch: resolveConfigProperty({
        config,
        context,
        reducer: legacySearchEnabledReducer,
        propertyName: "enableLegacySearch",
        initialValue: !0
      })
      // we will use this when we add search config to PluginOptions
      /*filters: resolveConfigProperty({
        config,
        context: context,
        initialValue: filterDefinitions,
        propertyName: 'search.filters',
        reducer: searchFilterReducer,
      }),
      operators: resolveConfigProperty({
        config,
        context: context,
        initialValue: operatorDefinitions as SearchOperatorDefinition[],
        propertyName: 'search.operators',
        reducer: searchOperatorsReducer,
      }),*/
    },
    __internal: {
      bifur,
      i18next: i18n.i18next,
      staticInitialValueTemplateItems,
      options: config
    },
    onUncaughtError: (error, errorInfo) => onUncaughtErrorResolver({
      config,
      context: {
        error,
        errorInfo
      }
    }),
    beta: {
      eventsAPI: {
        documents: eventsAPIReducer({
          config,
          initialValue: !0,
          key: "documents"
        }),
        releases: eventsAPIReducer({
          config,
          initialValue: !1,
          key: "releases"
        })
      },
      treeArrayEditing: {
        // This beta feature is no longer available.
        enabled: !1
      },
      create: {
        startInCreateEnabled: !1,
        fallbackStudioOrigin: void 0
      }
    },
    // eslint-disable-next-line camelcase
    __internal_serverDocumentActions: {
      enabled: serverDocumentActionsReducer({
        config,
        initialValue: void 0
      })
    },
    announcements: {
      enabled: announcementsEnabledReducer({
        config,
        initialValue: !0
      })
    },
    mediaLibrary: {
      enabled: mediaLibraryEnabledReducer({
        config,
        initialValue: !1
      }),
      libraryId: mediaLibraryLibraryIdReducer({
        config,
        initialValue: void 0
      })
    }
  };
}
function getRootPath(basePath) {
  const rootPath = basePath || "";
  if (typeof rootPath != "string" || rootPath.length > 0 && !rootPath.startsWith("/"))
    throw new ConfigResolutionError({
      name: "",
      type: "options",
      causes: ["basePath must be a string, and must start with a slash"]
    });
  return rootPath === "/" ? "" : rootPath;
}
function joinBasePath(rootPath, basePath) {
  return `/${[rootPath, basePath || ""].map((path) => path.replace(/^\/+/g, "").replace(/\/+$/g, "")).filter(Boolean).join("/")}`;
}
function resolveConfig(config) {
  const {
    workspaces
  } = prepareConfig(config);
  return combineLatest(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    workspaces.flatMap((workspaceSummary) => combineLatest(workspaceSummary.__internal.sources.map(({
      source
    }) => source)).pipe(map((sources) => ({
      ...workspaceSummary,
      ...sources[0],
      unstable_sources: sources,
      type: "workspace"
    }))))
  );
}
async function createWorkspaceFromConfig(options) {
  const client = "getClient" in options ? options.getClient({
    apiVersion: "2023-11-13"
  }) : void 0, [workspace] = await firstValueFrom(resolveConfig({
    ...options,
    ...client && "currentUser" in options && {
      auth: createMockAuthStore({
        ...options,
        client
      })
    }
  }));
  return workspace;
}
async function createSourceFromConfig(options) {
  return (await createWorkspaceFromConfig(options)).unstable_sources[0];
}
function useConfigContextFromSource(source) {
  const $ = c(7), {
    projectId,
    dataset,
    schema: schema2,
    currentUser,
    getClient: getClient2,
    i18n
  } = source;
  let t0, t1;
  return $[0] !== currentUser || $[1] !== dataset || $[2] !== getClient2 || $[3] !== i18n || $[4] !== projectId || $[5] !== schema2 ? (t1 = {
    projectId,
    dataset,
    schema: schema2,
    currentUser,
    getClient: getClient2,
    i18n
  }, $[0] = currentUser, $[1] = dataset, $[2] = getClient2, $[3] = i18n, $[4] = projectId, $[5] = schema2, $[6] = t1) : t1 = $[6], t0 = t1, t0;
}
function getConfigContextFromSource(source) {
  const {
    projectId,
    dataset,
    schema: schema2,
    currentUser,
    getClient: getClient2,
    i18n
  } = source;
  return {
    projectId,
    dataset,
    schema: schema2,
    currentUser,
    getClient: getClient2,
    i18n
  };
}
function WorkspacesProvider(t0) {
  const $ = c(9), {
    config,
    children,
    basePath,
    LoadingComponent
  } = t0, [workspaces, setWorkspaces] = useState(null);
  let t1, t2;
  if ($[0] !== basePath || $[1] !== config ? (t1 = () => {
    setWorkspaces(prepareConfig(config, {
      basePath
    }).workspaces);
  }, t2 = [basePath, config], $[0] = basePath, $[1] = config, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), workspaces === null) {
    let t32;
    return $[4] !== LoadingComponent ? (t32 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[4] = LoadingComponent, $[5] = t32) : t32 = $[5], t32;
  }
  let t3;
  return $[6] !== children || $[7] !== workspaces ? (t3 = /* @__PURE__ */ jsx(WorkspacesContext.Provider, { value: workspaces, children }), $[6] = children, $[7] = workspaces, $[8] = t3) : t3 = $[8], t3;
}
function RouterHistoryProvider(t0) {
  const $ = c(3), {
    children,
    history: history2
  } = t0;
  let t1;
  return $[0] !== children || $[1] !== history2 ? (t1 = /* @__PURE__ */ jsx(RouterHistoryContext.Provider, { value: history2, children }), $[0] = children, $[1] = history2, $[2] = t1) : t1 = $[2], t1;
}
function useRouterHistory() {
  const value = useContext(RouterHistoryContext);
  if (!value)
    throw new Error("Could not find `RouterHistoryProvider` context");
  return value;
}
const ActiveWorkspaceMatcherProvider = memo(function(t0) {
  const $ = c(9), {
    children,
    history: history2,
    activeWorkspace,
    setActiveWorkspace
  } = t0;
  let t1, t2;
  $[0] !== activeWorkspace || $[1] !== setActiveWorkspace ? (t2 = {
    activeWorkspace,
    setActiveWorkspace
  }, $[0] = activeWorkspace, $[1] = setActiveWorkspace, $[2] = t2) : t2 = $[2], t1 = t2;
  const value = t1;
  let t3;
  $[3] !== children || $[4] !== history2 ? (t3 = /* @__PURE__ */ jsx(RouterHistoryProvider, { history: history2, children }), $[3] = children, $[4] = history2, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== t3 || $[7] !== value ? (t4 = /* @__PURE__ */ jsx(ActiveWorkspaceMatcherContext.Provider, { value, children: t3 }), $[6] = t3, $[7] = value, $[8] = t4) : t4 = $[8], t4;
});
function createCommonBasePathRegex(workspaces) {
  const commonBasePath = workspaces.map((workspace) => (
    // gets the segments from the basePath
    workspace.basePath.slice(1).split("/")
  )).reduce((commonSegments, segments) => {
    for (let i = 0; i < commonSegments.length; i++) {
      const commonSegment = commonSegments[i], segment = segments[i].toLowerCase();
      if (commonSegment !== segment)
        return commonSegments.slice(0, i);
    }
    return commonSegments;
  });
  function createCommonBasePathRegexRecursively([first2, ...rest]) {
    return first2 ? `(\\/${escapeRegExp$1(first2)}${createCommonBasePathRegexRecursively(rest)}(\\/|$))?` : "";
  }
  return new RegExp(`^${createCommonBasePathRegexRecursively(commonBasePath)}$`, "i");
}
function matchWorkspace({
  pathname,
  workspaces,
  basePathRegex
}) {
  const [firstWorkspace] = workspaces;
  for (const {
    workspace,
    basePath,
    basePathRegex: basePathRegex2
  } of workspaces)
    if (basePathRegex2.test(pathname) || basePath === "/")
      return {
        type: "match",
        workspace
      };
  return pathname === "/" ? {
    type: "redirect",
    pathname: firstWorkspace.basePath
  } : basePathRegex.test(pathname) ? {
    type: "redirect",
    pathname: firstWorkspace.basePath
  } : {
    type: "not-found"
  };
}
function useNormalizedWorkspaces(workspaces) {
  const $ = c(2);
  let t0, t1;
  return $[0] !== workspaces ? (t1 = normalizedWorkspaces(workspaces), $[0] = workspaces, $[1] = t1) : t1 = $[1], t0 = t1, t0;
}
function normalizedWorkspaces(workspaces) {
  return workspaces.map((workspace) => {
    const basePath = workspace.basePath || "/";
    return {
      workspace,
      name: workspace.name,
      basePath,
      // this regex ends with a `(\\/|$)` (forward slash or end) to prevent false
      // matches where the pathname is a false subset of the current pathname.
      // e.g. if the `workspace.basePath` is `/base/foobar` and the current
      // pathname is `/base/foo`, then that should not be a match
      basePathRegex: new RegExp(`^${escapeRegExp$1(basePath)}(\\/|$)`, "i")
    };
  });
}
function useSyncPathnameWithWorkspace(history2, _workspaces) {
  const $ = c(18), workspaces = useNormalizedWorkspaces(_workspaces);
  let t0, t1;
  $[0] !== workspaces ? (t1 = createCommonBasePathRegex(workspaces), $[0] = workspaces, $[1] = t1) : t1 = $[1], t0 = t1;
  const basePathRegex = t0;
  let t2;
  $[2] !== history2.location.pathname ? (t2 = () => history2.location.pathname, $[2] = history2.location.pathname, $[3] = t2) : t2 = $[3];
  const [serverSnapshot] = useState(t2);
  let t3, t4;
  $[4] !== history2 ? (t4 = (onStoreChange) => history2.listen(onStoreChange), $[4] = history2, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== history2.location.pathname ? (t5 = () => history2.location.pathname, $[6] = history2.location.pathname, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== serverSnapshot ? (t6 = () => serverSnapshot, $[8] = serverSnapshot, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== basePathRegex || $[11] !== workspaces ? (t7 = (pathname) => matchWorkspace({
    basePathRegex,
    pathname,
    workspaces
  }), $[10] = basePathRegex, $[11] = workspaces, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 ? (t8 = {
    subscribe: t4,
    getSnapshot: t5,
    getServerSnapshot: t6,
    selector: t7,
    isEqual: _temp$t
  }, $[13] = t4, $[14] = t5, $[15] = t6, $[16] = t7, $[17] = t8) : t8 = $[17], t3 = t8;
  const store = t3;
  return useSyncExternalStoreWithSelector(store.subscribe, store.getSnapshot, store.getServerSnapshot, store.selector, store.isEqual);
}
function _temp$t(a, b) {
  if (a.type !== b.type)
    return !1;
  switch (a.type) {
    case "match":
      return a.workspace === b.workspace;
    case "redirect":
      return a.pathname === b.pathname;
    case "not-found":
      return !0;
    default:
      throw new Error(`Unknown type: ${a.type}`);
  }
}
const createHistory = () => typeof document > "u" ? createMemoryHistory() : createBrowserHistory();
function ActiveWorkspaceMatcher(t0) {
  const $ = c(25), {
    children,
    LoadingComponent,
    NotFoundComponent,
    unstable_history: historyProp
  } = t0, workspaces = useWorkspaces();
  let t1, t2;
  $[0] !== historyProp ? (t2 = historyProp || createHistory(), $[0] = historyProp, $[1] = t2) : t2 = $[1], t1 = t2;
  const history2 = t1;
  let t3;
  $[2] !== history2 || $[3] !== workspaces ? (t3 = (workspaceName) => {
    const foundWorkspace = workspaces.find((workspace) => workspace.name === workspaceName);
    foundWorkspace && history2.push(foundWorkspace.basePath);
  }, $[2] = history2, $[3] = workspaces, $[4] = t3) : t3 = $[4];
  const setActiveWorkspaceName = t3;
  let t4;
  $[5] !== setActiveWorkspaceName || $[6] !== workspaces[0].name ? (t4 = () => {
    setActiveWorkspaceName(workspaces[0].name);
  }, $[5] = setActiveWorkspaceName, $[6] = workspaces[0].name, $[7] = t4) : t4 = $[7];
  const handleNavigateToDefaultWorkspace = t4, result = useSyncPathnameWithWorkspace(history2, workspaces);
  let t5;
  $[8] !== history2 || $[9] !== result.pathname || $[10] !== result.type ? (t5 = () => {
    result.type === "redirect" && history2.replace(result.pathname);
  }, $[8] = history2, $[9] = result.pathname, $[10] = result.type, $[11] = t5) : t5 = $[11];
  let t6;
  switch ($[12] !== history2 || $[13] !== result ? (t6 = [history2, result], $[12] = history2, $[13] = result, $[14] = t6) : t6 = $[14], useEffect(t5, t6), result.type) {
    case "match": {
      let t7;
      return $[15] !== children || $[16] !== history2 || $[17] !== result.workspace || $[18] !== setActiveWorkspaceName ? (t7 = /* @__PURE__ */ jsx(ActiveWorkspaceMatcherProvider, { activeWorkspace: result.workspace, history: history2, setActiveWorkspace: setActiveWorkspaceName, children }), $[15] = children, $[16] = history2, $[17] = result.workspace, $[18] = setActiveWorkspaceName, $[19] = t7) : t7 = $[19], t7;
    }
    case "redirect": {
      let t7;
      return $[20] !== LoadingComponent ? (t7 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[20] = LoadingComponent, $[21] = t7) : t7 = $[21], t7;
    }
    case "not-found": {
      let t7;
      return $[22] !== NotFoundComponent || $[23] !== handleNavigateToDefaultWorkspace ? (t7 = /* @__PURE__ */ jsx(NotFoundComponent, { onNavigateToDefaultWorkspace: handleNavigateToDefaultWorkspace }), $[22] = NotFoundComponent, $[23] = handleNavigateToDefaultWorkspace, $[24] = t7) : t7 = $[24], t7;
    }
    default:
      throw new Error(`Unknown type: ${result.type}`);
  }
}
const API_VERSION = "v2023-11-13";
function AddonDatasetProviderInner(props2) {
  const {
    children
  } = props2, {
    dataset,
    projectId
  } = useWorkspace(), originalClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [addonDatasetClient, setAddonDatasetClient] = useState(null), [isCreatingDataset, setIsCreatingDataset] = useState(!1), [ready, setReady] = useState(!1), getAddonDatasetName = useCallback(async () => (await originalClient.withConfig({
    apiVersion: API_VERSION
  }).request({
    uri: `/projects/${projectId}/datasets?datasetProfile=comments&addonFor=${dataset}`,
    tag: "sanity.studio"
  }))?.[0]?.name, [dataset, originalClient, projectId]), handleCreateClient = useCallback((addonDatasetName) => originalClient.withConfig({
    apiVersion: API_VERSION,
    dataset: addonDatasetName,
    projectId,
    requestTagPrefix: "sanity.studio",
    useCdn: !1
  }), [originalClient, projectId]), handleCreateAddonDataset = useCallback(async () => {
    setIsCreatingDataset(!0);
    try {
      const addonDatasetName_0 = await getAddonDatasetName();
      if (addonDatasetName_0) {
        const client_0 = handleCreateClient(addonDatasetName_0);
        return setAddonDatasetClient(client_0), setIsCreatingDataset(!1), client_0;
      }
    } catch {
    }
    try {
      const datasetName = (await originalClient.withConfig({
        apiVersion: API_VERSION
      }).request({
        uri: `/comments/${dataset}/setup`,
        method: "POST"
      }))?.datasetName;
      if (!datasetName)
        return setIsCreatingDataset(!1), null;
      const client_1 = handleCreateClient(datasetName);
      return setAddonDatasetClient(client_1), client_1;
    } catch (err) {
      throw err;
    } finally {
      setIsCreatingDataset(!1);
    }
  }, [dataset, getAddonDatasetName, handleCreateClient, originalClient]);
  useEffect(() => {
    getAddonDatasetName().then((addonDatasetName_1) => {
      if (!addonDatasetName_1) return;
      const client_2 = handleCreateClient(addonDatasetName_1);
      setAddonDatasetClient(client_2);
    }).finally(() => {
      setReady(!0);
    });
  }, [getAddonDatasetName, handleCreateClient]);
  const ctxValue = useMemo(() => ({
    client: addonDatasetClient,
    createAddonDataset: handleCreateAddonDataset,
    isCreatingDataset,
    ready
  }), [addonDatasetClient, handleCreateAddonDataset, isCreatingDataset, ready]);
  return /* @__PURE__ */ jsx(AddonDatasetContext.Provider, { value: ctxValue, children });
}
function AddonDatasetProvider(props2) {
  const $ = c(2);
  if (useContext(AddonDatasetContext))
    return props2.children;
  let t0;
  return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(AddonDatasetProviderInner, { ...props2 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
function useAddonDataset() {
  const ctx = useContext(AddonDatasetContext);
  if (!ctx)
    throw new Error("useAddonDataset: missing context value");
  return ctx;
}
function getScheme(scheme) {
  switch (scheme) {
    case "dark":
    case "light":
      return scheme;
    default:
      return "system";
  }
}
const LOCAL_STORAGE_KEY$1 = "sanityStudio:ui:colorScheme";
let snapshot;
const subscribers = /* @__PURE__ */ new Set(), subscribe = (onStoreChange) => (snapshot || (snapshot = getScheme(localStorage.getItem(LOCAL_STORAGE_KEY$1)) || "system"), subscribers.add(onStoreChange), () => {
  subscribers.delete(onStoreChange);
});
function getSnapshot() {
  return snapshot;
}
function setSnapshot(nextScheme) {
  snapshot = getScheme(nextScheme);
  for (const subscription of subscribers)
    subscription();
}
function useSystemScheme() {
  return usePrefersDark() ? "dark" : "light";
}
function ColorThemeProvider(t0) {
  const $ = c(3), {
    children,
    scheme: _scheme
  } = t0, systemScheme = useSystemScheme(), scheme = _scheme === "system" ? systemScheme : _scheme;
  let t1;
  return $[0] !== children || $[1] !== scheme ? (t1 = /* @__PURE__ */ jsx(ThemeProvider, { scheme, theme: studioTheme, children }), $[0] = children, $[1] = scheme, $[2] = t1) : t1 = $[2], t1;
}
const LOCAL_STORAGE_KEY = "sanityStudio:ui:colorScheme";
function ColorSchemeProvider(t0) {
  const $ = c(7), {
    children,
    onSchemeChange,
    scheme: schemeProp
  } = t0;
  if (schemeProp) {
    let t12;
    return $[0] !== children || $[1] !== onSchemeChange || $[2] !== schemeProp ? (t12 = /* @__PURE__ */ jsx(ColorSchemeCustomProvider, { scheme: schemeProp, onSchemeChange, children }), $[0] = children, $[1] = onSchemeChange, $[2] = schemeProp, $[3] = t12) : t12 = $[3], t12;
  }
  let t1;
  return $[4] !== children || $[5] !== onSchemeChange ? (t1 = /* @__PURE__ */ jsx(ColorSchemeLocalStorageProvider, { onSchemeChange, children }), $[4] = children, $[5] = onSchemeChange, $[6] = t1) : t1 = $[6], t1;
}
function ColorSchemeLocalStorageProvider(t0) {
  const $ = c(10), {
    children,
    onSchemeChange
  } = t0, scheme = useSyncExternalStore(subscribe, getSnapshot, _temp$s);
  let t1, t2;
  $[0] !== onSchemeChange || $[1] !== scheme ? (t1 = () => {
    typeof onSchemeChange == "function" && onSchemeChange(scheme), localStorage.setItem(LOCAL_STORAGE_KEY, scheme);
  }, t2 = [onSchemeChange, scheme], $[0] = onSchemeChange, $[1] = scheme, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  $[4] !== children || $[5] !== scheme ? (t3 = /* @__PURE__ */ jsx(ColorThemeProvider, { scheme, children }), $[4] = children, $[5] = scheme, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== scheme || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(ColorSchemeSetValueContext.Provider, { value: setSnapshot, children: /* @__PURE__ */ jsx(ColorSchemeValueContext.Provider, { value: scheme, children: t3 }) }), $[7] = scheme, $[8] = t3, $[9] = t4) : t4 = $[9], t4;
}
function _temp$s() {
  return "system";
}
function ColorSchemeCustomProvider(t0) {
  const $ = c(9), {
    children,
    onSchemeChange,
    scheme
  } = t0, t1 = typeof onSchemeChange == "function" ? onSchemeChange : !1;
  let t2;
  $[0] !== children || $[1] !== scheme ? (t2 = /* @__PURE__ */ jsx(ColorThemeProvider, { scheme, children }), $[0] = children, $[1] = scheme, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== scheme || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(ColorSchemeValueContext.Provider, { value: scheme, children: t2 }), $[3] = scheme, $[4] = t2, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== t1 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(ColorSchemeSetValueContext.Provider, { value: t1, children: t3 }), $[6] = t1, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
}
function useColorSchemeSetValue() {
  const setValue = useContext(ColorSchemeSetValueContext);
  if (setValue === null)
    throw new Error("Could not find `ColorSchemeSetValueContext` context");
  return setValue;
}
function useColorSchemeInternalValue() {
  const value = useContext(ColorSchemeValueContext);
  if (value === null)
    throw new Error("Could not find `ColorSchemeValueContext` context");
  return value;
}
function useColorSchemeValue() {
  const scheme = useColorSchemeInternalValue(), systemScheme = useSystemScheme();
  return scheme === "system" ? systemScheme : scheme;
}
function useColorScheme() {
  const $ = c(4);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0], useEffect(_temp2$d, t0);
  const scheme = useColorSchemeValue(), setScheme = useColorSchemeSetValue();
  let t1, t2;
  return $[1] !== scheme || $[2] !== setScheme ? (t2 = {
    scheme,
    setScheme
  }, $[1] = scheme, $[2] = setScheme, $[3] = t2) : t2 = $[3], t1 = t2, t1;
}
function _temp2$d() {
  console.warn("useColorScheme() is deprecated, use useColorSchemeValue() or useColorSchemeSetValue() instead");
}
function useColorSchemeOptions(setScheme, t) {
  const $ = c(37), scheme = useColorSchemeInternalValue();
  let t0, t1;
  $[0] !== t ? (t1 = t("user-menu.color-scheme.system-title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t ? (t2 = t("user-menu.color-scheme.system-description"), $[2] = t, $[3] = t2) : t2 = $[3];
  const t3 = scheme === "system";
  let t4;
  $[4] !== setScheme ? (t4 = () => setScheme("system"), $[4] = setScheme, $[5] = t4) : t4 = $[5];
  let t5;
  $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 ? (t5 = {
    title: t1,
    name: "system",
    label: t2,
    selected: t3,
    onSelect: t4,
    icon: DesktopIcon
  }, $[6] = t1, $[7] = t2, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== t ? (t6 = t("user-menu.color-scheme.dark-title"), $[11] = t, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t ? (t7 = t("user-menu.color-scheme.dark-description"), $[13] = t, $[14] = t7) : t7 = $[14];
  const t8 = scheme === "dark";
  let t9;
  $[15] !== setScheme ? (t9 = () => setScheme("dark"), $[15] = setScheme, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9 ? (t10 = {
    title: t6,
    name: "dark",
    label: t7,
    selected: t8,
    onSelect: t9,
    icon: MoonIcon
  }, $[17] = t6, $[18] = t7, $[19] = t8, $[20] = t9, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== t ? (t11 = t("user-menu.color-scheme.light-title"), $[22] = t, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== t ? (t12 = t("user-menu.color-scheme.light-description"), $[24] = t, $[25] = t12) : t12 = $[25];
  const t13 = scheme === "light";
  let t14;
  $[26] !== setScheme ? (t14 = () => setScheme("light"), $[26] = setScheme, $[27] = t14) : t14 = $[27];
  let t15;
  $[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t14 ? (t15 = {
    title: t11,
    name: "light",
    label: t12,
    selected: t13,
    onSelect: t14,
    icon: SunIcon
  }, $[28] = t11, $[29] = t12, $[30] = t13, $[31] = t14, $[32] = t15) : t15 = $[32];
  let t16;
  return $[33] !== t10 || $[34] !== t15 || $[35] !== t5 ? (t16 = [t5, t10, t15], $[33] = t10, $[34] = t15, $[35] = t5, $[36] = t16) : t16 = $[36], t0 = t16, t0;
}
const SearchButton = forwardRef(function(t0, ref) {
  const $ = c(12), {
    onClick: onClick2
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== t ? (t1 = t("search.action-open-aria-label"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t ? (t2 = t("search.button.tooltip"), $[2] = t, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = [GLOBAL_SEARCH_KEY_MODIFIER, GLOBAL_SEARCH_KEY.toUpperCase()], $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t2 ? (t4 = {
    content: t2,
    hotkeys: t3,
    portal: !0
  }, $[5] = t2, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== onClick2 || $[8] !== ref || $[9] !== t1 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button, { "aria-label": t1, "data-testid": "studio-search", icon: SearchIcon, tooltipProps: t4, onClick: onClick2, mode: "bleed", ref }), $[7] = onClick2, $[8] = ref, $[9] = t1, $[10] = t4, $[11] = t5) : t5 = $[11], t5;
}), InnerCard = styled(Card)`
  flex-direction: column;
  overflow: hidden;
  overflow: clip;
  pointer-events: all;
  position: relative;
`, SearchDialogBox = styled(Box)`
  height: 100%;
  left: 0;
  overflow: hidden;
  overflow: clip;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
`;
function SearchDialog(t0) {
  const $ = c(15), {
    onClose,
    onOpen,
    open
  } = t0, [inputElement, setInputElement] = useState(null), scheme = useColorSchemeValue(), {
    state: t1
  } = useSearchState(), {
    filtersVisible,
    terms
  } = t1;
  let t2;
  $[0] !== terms ? (t2 = hasSearchableTerms({
    terms
  }), $[0] = terms, $[1] = t2) : t2 = $[1];
  const hasValidTerms = t2;
  let t3;
  $[2] !== filtersVisible || $[3] !== hasValidTerms || $[4] !== inputElement || $[5] !== onClose || $[6] !== open || $[7] !== scheme ? (t3 = open && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(FocusLock, { autoFocus: !supportsTouch, returnFocus: !0, children: /* @__PURE__ */ jsx(SearchDialogBox, { children: /* @__PURE__ */ jsxs(InnerCard, { display: "flex", height: "fill", scheme, tone: "default", children: [
    /* @__PURE__ */ jsx(SearchHeader, { onClose, ref: setInputElement }),
    filtersVisible && /* @__PURE__ */ jsx(Card, { borderTop: !0, flex: "none", children: /* @__PURE__ */ jsx(Filters, {}) }),
    hasValidTerms ? /* @__PURE__ */ jsx(SearchResults, { inputElement }) : /* @__PURE__ */ jsx(RecentSearches, { inputElement })
  ] }) }) }) }), $[2] = filtersVisible, $[3] = hasValidTerms, $[4] = inputElement, $[5] = onClose, $[6] = open, $[7] = scheme, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== hasValidTerms || $[10] !== onClose || $[11] !== onOpen || $[12] !== open || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsx(SearchWrapper, { hasValidTerms, onClose, onOpen, open, children: t3 }), $[9] = hasValidTerms, $[10] = onClose, $[11] = onOpen, $[12] = open, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
}
function StudioLogo(props2) {
  const $ = c(2), {
    title
  } = props2;
  let t0;
  return $[0] !== title ? (t0 = /* @__PURE__ */ jsx(Box, { padding: 3, "data-testid": "studio-logo", children: /* @__PURE__ */ jsx(Text$1, { weight: "medium", children: title }) }), $[0] = title, $[1] = t0) : t0 = $[1], t0;
}
const CapabilityGate = (t0) => {
  const $ = c(1), {
    children,
    capability,
    condition: t1
  } = t0, condition = t1 === void 0 ? "unavailable" : t1, renderingContextStore = useRenderingContextStore();
  let t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {}, $[0] = t2) : t2 = $[0];
  const renderingContextHasCapability = useObservable(renderingContextStore.capabilities, t2)[capability] === !0;
  return condition === "available" && !renderingContextHasCapability || condition === "unavailable" && renderingContextHasCapability ? null : children;
}, ToolLink = forwardRef(function(props2, ref) {
  const $ = c(9);
  let name, rest;
  $[0] !== props2 ? ({
    name,
    ...rest
  } = props2, $[0] = props2, $[1] = name, $[2] = rest) : (name = $[1], rest = $[2]);
  let t0;
  $[3] !== name ? (t0 = () => ({
    tool: name,
    [name]: void 0
  }), $[3] = name, $[4] = t0) : t0 = $[4];
  const state = useRouterState(t0);
  let t1;
  return $[5] !== ref || $[6] !== rest || $[7] !== state ? (t1 = /* @__PURE__ */ jsx(StateLink, { state, ...rest, ref }), $[5] = ref, $[6] = rest, $[7] = state, $[8] = t1) : t1 = $[8], t1;
}), oversizedButtonStyle = css`
  position: relative;
  cursor: default;
  &::before {
    content: '';
    position: absolute;
    display: block;
    inset: -4px;
    border-radius: 9999px;
  }
`, Dot$1 = styled.div({
  width: 4,
  height: 4,
  borderRadius: 3,
  boxShadow: "0 0 0 1px var(--card-bg-color)"
}), OversizedButton$2 = styled(ToolLink)`
  ${oversizedButtonStyle}
`;
function ReleasesToolLink() {
  const $ = c(10), {
    t
  } = useTranslation$1(), {
    errorCount$
  } = useReleasesStore(), hasError = useObservable(errorCount$) !== 0, activeToolName = useRouterState(_temp$r);
  let t0;
  $[0] !== t ? (t0 = t("release.navbar.tooltip"), $[0] = t, $[1] = t0) : t0 = $[1];
  const t1 = activeToolName === RELEASES_TOOL_NAME;
  let t2;
  $[2] !== hasError ? (t2 = hasError && /* @__PURE__ */ jsx(Dot$1, { "data-ui": "error-status-icon", style: {
    backgroundColor: "var(--card-badge-critical-dot-color)"
  } }), $[2] = hasError, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t1 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsx(Button$1, { as: OversizedButton$2, name: RELEASES_TOOL_NAME, "data-as": "a", icon: CalendarIcon, mode: "bleed", padding: 2, radius: "full", "data-testid": "releases-tool-link", selected: t1, children: t2 }), $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6];
  let t4;
  return $[7] !== t0 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Tooltip, { content: t0, children: t3 }), $[7] = t0, $[8] = t3, $[9] = t4) : t4 = $[9], t4;
}
function _temp$r(routerState) {
  return typeof routerState.tool == "string" ? routerState.tool : void 0;
}
const OversizedButton$1 = styled(IntentLink)`
  ${oversizedButtonStyle}
`;
function AnimatedTextWidth(t0) {
  const $ = c(18), {
    children,
    text
  } = t0, textRef = useRef(null), [containerWidth, setContainerWidth] = useState(null), [isAnimating, setIsAnimating] = useState(!1);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    if (!textRef.current)
      return;
    const newWidth = textRef.current.offsetWidth;
    setContainerWidth(newWidth);
  }, $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== text ? (t2 = [text], $[1] = text, $[2] = t2) : t2 = $[2], useLayoutEffect(t1, t2);
  let t3;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = () => {
    setIsAnimating(!0);
  }, $[3] = t3) : t3 = $[3];
  const onAnimationStart = t3;
  let t4;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setIsAnimating(!1);
  }, $[4] = t4) : t4 = $[4];
  const onAnimationComplete = t4, t5 = containerWidth === null ? "auto" : containerWidth, t6 = isAnimating ? "hidden" : "visible";
  let t7;
  $[5] !== t5 || $[6] !== t6 ? (t7 = {
    display: "inline-block",
    width: t5,
    overflow: t6
  }, $[5] = t5, $[6] = t6, $[7] = t7) : t7 = $[7];
  const t8 = containerWidth || "auto";
  let t9;
  $[8] !== t8 ? (t9 = {
    width: t8
  }, $[8] = t8, $[9] = t9) : t9 = $[9];
  let t10;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    type: "spring",
    bounce: 0,
    duration: 0.3
  }, $[10] = t10) : t10 = $[10];
  let t11;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t11 = {
    display: "inline-block",
    whiteSpace: "nowrap"
  }, $[11] = t11) : t11 = $[11];
  let t12;
  $[12] !== children ? (t12 = /* @__PURE__ */ jsx("div", { ref: textRef, style: t11, children }), $[12] = children, $[13] = t12) : t12 = $[13];
  let t13;
  return $[14] !== t12 || $[15] !== t7 || $[16] !== t9 ? (t13 = /* @__PURE__ */ jsx(motion.div, { style: t7, animate: t9, transition: t10, onAnimationStart, onAnimationComplete, children: t12 }), $[14] = t12, $[15] = t7, $[16] = t9, $[17] = t13) : t13 = $[17], t13;
}
const ReleasesLink = (t0) => {
  const $ = c(9), {
    selectedPerspective
  } = t0, {
    t
  } = useTranslation();
  let t1, t2;
  $[0] !== selectedPerspective._id ? (t2 = forwardRef(function(t32, linkRef) {
    const {
      children,
      ...intentProps
    } = t32;
    return /* @__PURE__ */ jsx(OversizedButton$1, { ...intentProps, ref: linkRef, intent: RELEASES_INTENT, params: {
      id: getReleaseIdFromReleaseDocumentId(selectedPerspective._id)
    }, children });
  }), $[0] = selectedPerspective._id, $[1] = t2) : t2 = $[1], t1 = t2;
  const ReleasesIntentLink = t1;
  let t3;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    maxWidth: "180px",
    textOverflow: "ellipsis"
  }, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== selectedPerspective.metadata?.title || $[4] !== t ? (t4 = selectedPerspective.metadata?.title || t("release.placeholder-untitled-release"), $[3] = selectedPerspective.metadata?.title, $[4] = t, $[5] = t4) : t4 = $[5];
  let t5;
  return $[6] !== ReleasesIntentLink || $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button$1, { as: ReleasesIntentLink, "data-as": "a", rel: "noopener noreferrer", mode: "bleed", padding: 2, radius: "full", style: t3, text: t4 }), $[6] = ReleasesIntentLink, $[7] = t4, $[8] = t5) : t5 = $[8], t5;
};
function CurrentGlobalPerspectiveLabel(t0) {
  const $ = c(6), {
    selectedPerspective
  } = t0, {
    t
  } = useTranslation(), t1 = isReleaseDocument(selectedPerspective) ? selectedPerspective._id : selectedPerspective;
  let t2;
  $[0] !== selectedPerspective || $[1] !== t ? (t2 = isPublishedPerspective(selectedPerspective) || isDraftPerspective(selectedPerspective) ? /* @__PURE__ */ jsx(Box, { padding: 2, style: {
    userSelect: "none",
    overflow: "hidden"
  }, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: isPublishedPerspective(selectedPerspective) ? t("release.chip.published") : t("release.chip.global.drafts") }) }) : /* @__PURE__ */ jsx(ReleasesLink, { selectedPerspective }), $[0] = selectedPerspective, $[1] = t, $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== t1 || $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(AnimatedTextWidth, { text: t1, children: t2 }), $[3] = t1, $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}
function useExcludedPerspective() {
  const $ = c(9), {
    navigate
  } = useRouter(), {
    excludedPerspectives
  } = usePerspective();
  let t0;
  $[0] !== excludedPerspectives || $[1] !== navigate ? (t0 = (excluded) => {
    const existingPerspectives = excludedPerspectives || [], nextExcludedPerspectives = existingPerspectives.includes(excluded) ? existingPerspectives.filter((id2) => id2 !== excluded) : [...existingPerspectives, excluded];
    navigate({
      stickyParams: {
        excludedPerspectives: nextExcludedPerspectives.toString()
      }
    });
  }, $[0] = excludedPerspectives, $[1] = navigate, $[2] = t0) : t0 = $[2];
  const toggleExcludedPerspective = t0;
  let t1;
  $[3] !== excludedPerspectives ? (t1 = (perspectiveId) => !!excludedPerspectives?.includes(perspectiveId), $[3] = excludedPerspectives, $[4] = t1) : t1 = $[4];
  const isPerspectiveExcluded = t1;
  let t2, t3;
  return $[5] !== excludedPerspectives || $[6] !== isPerspectiveExcluded || $[7] !== toggleExcludedPerspective ? (t3 = {
    excludedPerspectives,
    toggleExcludedPerspective,
    isPerspectiveExcluded
  }, $[5] = excludedPerspectives, $[6] = isPerspectiveExcluded, $[7] = toggleExcludedPerspective, $[8] = t3) : t3 = $[8], t2 = t3, t2;
}
const INDICATOR_LEFT_OFFSET = 18, INDICATOR_WIDTH = 5, INDICATOR_COLOR_VAR_NAME = "--card-border-color", INDICATOR_BOTTOM_OFFSET = 4, GlobalPerspectiveMenuItemIndicator = styled.div(({
  $inRange,
  $last,
  $first,
  $isDraft
}) => css`
    position: relative;

    --indicator-left: ${INDICATOR_LEFT_OFFSET}px;
    --indicator-width: ${INDICATOR_WIDTH}px;
    --indicator-color: var(${INDICATOR_COLOR_VAR_NAME});
    --indicator-bottom: ${INDICATOR_BOTTOM_OFFSET}px;

    --indicator-in-range-height: 16.5px;

    ${$inRange && !$last && css`
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: var(--indicator-left);
        bottom: -var(--indicator-bottom);
        width: var(--indicator-width);
        height: ${$isDraft ? "calc(var(--indicator-bottom) + 12px)" : "var(--indicator-bottom)"};
        background-color: var(--card-border-color);
      }
    `}

    ${$inRange && css`
      > [data-ui='MenuItem'] {
        position: relative;

        &:before,
        &:after {
          content: '';
          display: block;
          position: absolute;
          left: var(--indicator-left);
          width: var(--indicator-width);
          background-color: var(--card-border-color);
        }

        &:before {
          top: 0;
          height: var(--indicator-in-range-height);
        }

        &:after {
          top: var(--indicator-in-range-height);
          bottom: 0;
        }
      }
    `}

    ${$first && css`
      > [data-ui='MenuItem']:after {
        margin-top: -3px;
        border-top-left-radius: ${INDICATOR_WIDTH}px;
        border-top-right-radius: ${INDICATOR_WIDTH}px;
      }
      > [data-ui='MenuItem']:before {
        display: none;
      }
    `}

    ${$last && css`
      > [data-ui='MenuItem']:before {
        // dot diameter (5px) - 1.6px stroke divided by 2
        padding-bottom: 1.7px;
        border-bottom-left-radius: ${INDICATOR_WIDTH}px;
        border-bottom-right-radius: ${INDICATOR_WIDTH}px;
      }
      > [data-ui='MenuItem']:after {
        display: none;
      }
    `}
  `), GlobalPerspectiveMenuLabelIndicator = styled(Box)(({
  $withinRange
}) => css`
    position: relative;
    // 4px padding + 33px release indicator width + 4px gap
    padding-left: 41px;

    ${$withinRange && css`
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: ${INDICATOR_LEFT_OFFSET}px;
        top: 0;
        bottom: -${INDICATOR_BOTTOM_OFFSET}px;
        width: ${INDICATOR_WIDTH}px;
        background-color: var(${INDICATOR_COLOR_VAR_NAME});
      }
    `}
  `), ToggleLayerButton = styled(Button$1)(({
  $visible
}) => css`
    --card-fg-color: inherit;
    --card-icon-color: inherit;

    background-color: inherit;
    opacity: ${$visible ? 0 : 1};

    @media (hover: hover) {
      &:not([data-disabled='true']):hover {
        --card-fg-color: inherit;
        --card-icon-color: inherit;
      }
    }

    [data-ui='MenuItem']:hover & {
      opacity: 1;
    }
  `), ExcludedLayerDot = () => {
  const $ = c(2);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    opacity: 0
  }, $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(DotIcon, { style: t0 }) }) }), $[1] = t1) : t1 = $[1], t1;
};
function getRangePosition(range2, index) {
  const {
    lastIndex
  } = range2;
  if (lastIndex !== 0) {
    if (index === 0) return "first";
    if (index === lastIndex) return "last";
    if (index > 0 && index < lastIndex) return "within";
  }
}
const GlobalPerspectiveMenuItem = forwardRef((props2, ref) => {
  const $ = c(73), {
    release,
    rangePosition
  } = props2, {
    selectedPerspective,
    selectedPerspectiveName
  } = usePerspective(), setPerspective = useSetPerspective(), {
    toggleExcludedPerspective,
    isPerspectiveExcluded
  } = useExcludedPerspective();
  let t0;
  $[0] !== release ? (t0 = isReleaseDocument(release) ? getReleaseIdFromReleaseDocumentId(release._id) : release, $[0] = release, $[1] = t0) : t0 = $[1];
  const releaseId = t0;
  let t1;
  $[2] !== release || $[3] !== releaseId || $[4] !== selectedPerspectiveName ? (t1 = selectedPerspectiveName ? releaseId === selectedPerspectiveName : isDraftPerspective(release), $[2] = release, $[3] = releaseId, $[4] = selectedPerspectiveName, $[5] = t1) : t1 = $[5];
  const active = t1;
  let t2;
  $[6] !== isPerspectiveExcluded || $[7] !== releaseId ? (t2 = isPerspectiveExcluded(releaseId), $[6] = isPerspectiveExcluded, $[7] = releaseId, $[8] = t2) : t2 = $[8];
  const isReleasePerspectiveExcluded = t2, {
    t
  } = useTranslation();
  let t3;
  bb0: {
    if (isPublishedPerspective(release)) {
      let t43;
      $[9] !== t ? (t43 = t("release.navbar.published"), $[9] = t, $[10] = t43) : t43 = $[10], t3 = t43;
      break bb0;
    }
    if (isDraftPerspective(release)) {
      let t43;
      $[11] !== t ? (t43 = t("release.navbar.drafts"), $[11] = t, $[12] = t43) : t43 = $[12], t3 = t43;
      break bb0;
    }
    let t42;
    $[13] !== release.metadata.title || $[14] !== t ? (t42 = release.metadata.title || t("release.placeholder-untitled-release"), $[13] = release.metadata.title, $[14] = t, $[15] = t42) : t42 = $[15], t3 = t42;
  }
  const displayTitle = t3;
  let t4;
  $[16] !== releaseId || $[17] !== toggleExcludedPerspective ? (t4 = (event) => {
    event.stopPropagation(), toggleExcludedPerspective(releaseId);
  }, $[16] = releaseId, $[17] = toggleExcludedPerspective, $[18] = t4) : t4 = $[18];
  const handleToggleReleaseVisibility = t4;
  let t5;
  $[19] !== releaseId || $[20] !== setPerspective ? (t5 = () => setPerspective(releaseId), $[19] = releaseId, $[20] = setPerspective, $[21] = t5) : t5 = $[21];
  const handleOnReleaseClick = t5;
  let t6;
  bb1: {
    if (release === "published") {
      t6 = !1;
      break bb1;
    }
    if (isDraftPerspective(release)) {
      let t73;
      $[22] !== selectedPerspective ? (t73 = isReleaseDocument(selectedPerspective), $[22] = selectedPerspective, $[23] = t73) : t73 = $[23], t6 = t73;
      break bb1;
    }
    if (isReleaseScheduledOrScheduling(release)) {
      t6 = !1;
      break bb1;
    }
    let t72;
    $[24] !== rangePosition ? (t72 = rangePosition && ["first", "within"].includes(rangePosition), $[24] = rangePosition, $[25] = t72) : t72 = $[25], t6 = t72;
  }
  const canReleaseBeExcluded = t6;
  let t7;
  $[26] !== release ? (t7 = isDraftPerspective(release), $[26] = release, $[27] = t7) : t7 = $[27];
  const t8 = rangePosition === "first", t9 = rangePosition === "last", t10 = !!rangePosition, t11 = `release-${releaseId}`;
  let t12;
  $[28] === Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    position: "relative",
    zIndex: 1
  }, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== isReleasePerspectiveExcluded || $[30] !== release ? (t13 = /* @__PURE__ */ jsx(Box, { flex: "none", style: t12, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: isReleasePerspectiveExcluded ? /* @__PURE__ */ jsx(ExcludedLayerDot, {}) : /* @__PURE__ */ jsx(ReleaseAvatar, { tone: getReleaseTone(release) }) }) }), $[29] = isReleasePerspectiveExcluded, $[30] = release, $[31] = t13) : t13 = $[31];
  const t14 = isReleasePerspectiveExcluded ? 0.5 : void 0;
  let t15;
  $[32] !== t14 ? (t15 = {
    opacity: t14
  }, $[32] = t14, $[33] = t15) : t15 = $[33];
  let t16;
  $[34] !== displayTitle ? (t16 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: displayTitle }), $[34] = displayTitle, $[35] = t16) : t16 = $[35];
  let t17;
  $[36] !== release ? (t17 = isReleaseDocument(release) && typeof release.error < "u" && release.state === "active" && /* @__PURE__ */ jsx(Text$1, { size: 1, "data-testid": "release-error-icon", children: /* @__PURE__ */ jsx(ToneIcon, { icon: ErrorOutlineIcon, tone: "critical" }) }), $[36] = release, $[37] = t17) : t17 = $[37];
  let t18;
  $[38] !== t16 || $[39] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Flex, { gap: 3, align: "center", children: [
    t16,
    t17
  ] }), $[38] = t16, $[39] = t17, $[40] = t18) : t18 = $[40];
  let t19;
  $[41] !== release ? (t19 = isReleaseDocument(release) && release.metadata.releaseType === "scheduled" && (release.publishAt || release.metadata.intendedPublishAt) && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: formatRelativeLocalePublishDate(release) }), $[41] = release, $[42] = t19) : t19 = $[42];
  let t20;
  $[43] !== t15 || $[44] !== t18 || $[45] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Stack, { flex: 1, paddingY: 2, paddingRight: 2, space: 2, style: t15, children: [
    t18,
    t19
  ] }), $[43] = t15, $[44] = t18, $[45] = t19, $[46] = t20) : t20 = $[46];
  let t21;
  $[47] !== canReleaseBeExcluded || $[48] !== handleToggleReleaseVisibility || $[49] !== isReleasePerspectiveExcluded || $[50] !== t ? (t21 = canReleaseBeExcluded && /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t("release.layer.hide"), placement: "bottom", children: /* @__PURE__ */ jsx(ToggleLayerButton, { $visible: !isReleasePerspectiveExcluded, forwardedAs: "div", icon: isReleasePerspectiveExcluded ? EyeClosedIcon : EyeOpenIcon, mode: "bleed", onClick: handleToggleReleaseVisibility, padding: 2, "data-testid": "release-toggle-visibility" }) }), $[47] = canReleaseBeExcluded, $[48] = handleToggleReleaseVisibility, $[49] = isReleasePerspectiveExcluded, $[50] = t, $[51] = t21) : t21 = $[51];
  let t22;
  $[52] !== release ? (t22 = isReleaseDocument(release) && isReleaseScheduledOrScheduling(release) && /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, "data-testid": "release-lock-icon", children: /* @__PURE__ */ jsx(LockIcon, {}) }) }), $[52] = release, $[53] = t22) : t22 = $[53];
  let t23;
  $[54] !== t21 || $[55] !== t22 ? (t23 = /* @__PURE__ */ jsxs(Box, { flex: "none", children: [
    t21,
    t22
  ] }), $[54] = t21, $[55] = t22, $[56] = t23) : t23 = $[56];
  let t24;
  $[57] !== t13 || $[58] !== t20 || $[59] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 1, children: [
    t13,
    t20,
    t23
  ] }), $[57] = t13, $[58] = t20, $[59] = t23, $[60] = t24) : t24 = $[60];
  let t25;
  $[61] !== active || $[62] !== handleOnReleaseClick || $[63] !== t11 || $[64] !== t24 ? (t25 = /* @__PURE__ */ jsx(MenuItem, { onClick: handleOnReleaseClick, padding: 1, pressed: active, "data-testid": t11, children: t24 }), $[61] = active, $[62] = handleOnReleaseClick, $[63] = t11, $[64] = t24, $[65] = t25) : t25 = $[65];
  let t26;
  return $[66] !== ref || $[67] !== t10 || $[68] !== t25 || $[69] !== t7 || $[70] !== t8 || $[71] !== t9 ? (t26 = /* @__PURE__ */ jsx(GlobalPerspectiveMenuItemIndicator, { $isDraft: t7, $first: t8, $last: t9, $inRange: t10, ref, children: t25 }), $[66] = ref, $[67] = t10, $[68] = t25, $[69] = t7, $[70] = t8, $[71] = t9, $[72] = t26) : t26 = $[72], t26;
});
GlobalPerspectiveMenuItem.displayName = "GlobalPerspectiveMenuItem";
const RELEASE_TYPE_LABELS = {
  asap: "release.type.asap",
  scheduled: "release.type.scheduled",
  undecided: "release.type.undecided"
};
function ReleaseTypeMenuSection(t0) {
  const $ = c(27), {
    releaseType,
    releases: releases2,
    range: range2,
    currentGlobalBundleMenuItemRef
  } = t0, {
    t
  } = useTranslation(), {
    selectedReleaseId
  } = usePerspective();
  let t1;
  $[0] !== currentGlobalBundleMenuItemRef || $[1] !== selectedReleaseId ? (t1 = (releaseId) => selectedReleaseId === releaseId ? currentGlobalBundleMenuItemRef : void 0, $[0] = currentGlobalBundleMenuItemRef, $[1] = selectedReleaseId, $[2] = t1) : t1 = $[2];
  const getMenuItemRef = t1;
  if (releases2.length === 0)
    return null;
  const {
    lastIndex,
    offsets
  } = range2, releaseTypeOffset = offsets[releaseType], t2 = releaseTypeOffset > 0 && lastIndex >= releaseTypeOffset, t3 = releaseType === "asap" ? 1 : 4;
  let t4;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    textTransform: "uppercase"
  }, $[3] = t4) : t4 = $[3];
  const t5 = RELEASE_TYPE_LABELS[releaseType];
  let t6;
  $[4] !== t || $[5] !== t5 ? (t6 = t(t5), $[4] = t, $[5] = t5, $[6] = t6) : t6 = $[6];
  let t7;
  $[7] !== t6 ? (t7 = /* @__PURE__ */ jsx(Label, { muted: !0, style: t4, size: 1, children: t6 }), $[7] = t6, $[8] = t7) : t7 = $[8];
  let t8;
  $[9] !== t2 || $[10] !== t3 || $[11] !== t7 ? (t8 = /* @__PURE__ */ jsx(GlobalPerspectiveMenuLabelIndicator, { $withinRange: t2, paddingRight: 2, paddingTop: t3, paddingBottom: 2, children: t7 }), $[9] = t2, $[10] = t3, $[11] = t7, $[12] = t8) : t8 = $[12];
  let t9;
  if ($[13] !== getMenuItemRef || $[14] !== range2 || $[15] !== releaseTypeOffset || $[16] !== releases2) {
    let t102;
    $[18] !== getMenuItemRef || $[19] !== range2 || $[20] !== releaseTypeOffset ? (t102 = (release, index) => /* @__PURE__ */ jsx(GlobalPerspectiveMenuItem, { release, ref: getMenuItemRef(getReleaseIdFromReleaseDocumentId(release._id)), rangePosition: getRangePosition(range2, releaseTypeOffset + index) }, release._id), $[18] = getMenuItemRef, $[19] = range2, $[20] = releaseTypeOffset, $[21] = t102) : t102 = $[21], t9 = releases2.map(t102), $[13] = getMenuItemRef, $[14] = range2, $[15] = releaseTypeOffset, $[16] = releases2, $[17] = t9;
  } else
    t9 = $[17];
  let t10;
  $[22] !== t9 ? (t10 = /* @__PURE__ */ jsx(Flex, { direction: "column", gap: 1, children: t9 }), $[22] = t9, $[23] = t10) : t10 = $[23];
  let t11;
  return $[24] !== t10 || $[25] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t8,
    t10
  ] }), $[24] = t10, $[25] = t8, $[26] = t11) : t11 = $[26], t11;
}
const orderedReleaseTypes = ["asap", "scheduled", "undecided"], ASAP_RANGE_OFFSET = 2, StyledBox = styled(Box)`
  overflow: auto;
  max-height: 75vh;
`, StyledPublishedBox = styled(Box)(({
  $reducePadding,
  $removePadding
}) => css`
    position: sticky;
    top: 0;
    background-color: var(--card-bg-color);
    z-index: 10;
    padding-bottom: ${$removePadding ? "0px" : $reducePadding ? "4px" : "16px"};
  `);
function ReleasesList({
  areReleasesEnabled,
  setScrollContainer,
  onScroll,
  isRangeVisible,
  selectedReleaseId,
  setCreateBundleDialogOpen,
  scrollElementRef
}) {
  const {
    guardWithReleaseLimitUpsell,
    mode
  } = useReleasesUpsell(), {
    loading,
    data: releases2
  } = useActiveReleases(), {
    createRelease
  } = useReleaseOperations(), {
    checkWithPermissionGuard
  } = useReleasePermissions(), [hasCreatePermission, setHasCreatePermission] = useState(null), createReleaseMetadata = useCreateReleaseMetadata(), {
    selectedPerspectiveName
  } = usePerspective(), {
    t
  } = useTranslation(), isMounted = useRef(!1);
  useEffect(() => (isMounted.current = !0, checkWithPermissionGuard(createRelease, createReleaseMetadata(getReleaseDefaults())).then((hasPermission) => {
    isMounted.current && setHasCreatePermission(hasPermission);
  }), () => {
    isMounted.current = !1;
  }), [checkWithPermissionGuard, createRelease, createReleaseMetadata]);
  const handleCreateBundleClick = useCallback(() => guardWithReleaseLimitUpsell(() => setCreateBundleDialogOpen(!0)), [guardWithReleaseLimitUpsell, setCreateBundleDialogOpen]), sortedReleaseTypeReleases = useMemo(() => orderedReleaseTypes.reduce((ReleaseTypeReleases, releaseType) => ({
    ...ReleaseTypeReleases,
    [releaseType]: releases2.filter(({
      metadata
    }) => metadata.releaseType === releaseType)
  }), {}), [releases2]), range2 = useMemo(() => {
    let lastIndex = typeof selectedPerspectiveName > "u" ? 1 : 0;
    const {
      asap,
      scheduled
    } = sortedReleaseTypeReleases, countAsapReleases = asap.length, countScheduledReleases = scheduled.length, offsets = {
      asap: ASAP_RANGE_OFFSET,
      scheduled: ASAP_RANGE_OFFSET + countAsapReleases,
      undecided: ASAP_RANGE_OFFSET + countAsapReleases + countScheduledReleases
    }, adjustIndexForReleaseType = (type) => {
      const groupSubsetReleases = sortedReleaseTypeReleases[type], offset = offsets[type];
      groupSubsetReleases.forEach((release, groupReleaseIndex) => {
        const index = offset + groupReleaseIndex;
        selectedReleaseId === getReleaseIdFromReleaseDocumentId(release._id) && (lastIndex = index);
      });
    };
    return orderedReleaseTypes.forEach(adjustIndexForReleaseType), {
      lastIndex,
      offsets
    };
  }, [selectedPerspectiveName, selectedReleaseId, sortedReleaseTypeReleases]);
  return loading ? /* @__PURE__ */ jsx(Flex, { padding: 4, justify: "center", "data-testid": "spinner", children: /* @__PURE__ */ jsx(Spinner, { muted: !0 }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(StyledBox, { ref: setScrollContainer, onScroll, children: [
      /* @__PURE__ */ jsxs(StyledPublishedBox, { $reducePadding: !releases2.length || !areReleasesEnabled, $removePadding: !areReleasesEnabled, children: [
        /* @__PURE__ */ jsx(GlobalPerspectiveMenuItem, { rangePosition: isRangeVisible ? getRangePosition(range2, 0) : void 0, release: "published" }),
        /* @__PURE__ */ jsx(GlobalPerspectiveMenuItem, { rangePosition: isRangeVisible ? getRangePosition(range2, 1) : void 0, release: LATEST })
      ] }),
      areReleasesEnabled && /* @__PURE__ */ jsx(Fragment, { children: orderedReleaseTypes.map((releaseType_0) => /* @__PURE__ */ jsx(ReleaseTypeMenuSection, { releaseType: releaseType_0, releases: sortedReleaseTypeReleases[releaseType_0], range: range2, currentGlobalBundleMenuItemRef: scrollElementRef }, releaseType_0)) })
    ] }),
    areReleasesEnabled && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(MenuDivider, {}),
      /* @__PURE__ */ jsx(MenuItem$1, { icon: AddIcon, disabled: !hasCreatePermission || mode === "disabled", onClick: handleCreateBundleClick, text: t("release.action.create-new"), "data-testid": "create-new-release-button", tooltipProps: {
        disabled: hasCreatePermission === !0,
        content: t("release.action.permission.error")
      } })
    ] })
  ] });
}
function isElementVisibleInContainer(container, element) {
  if (!container || !element) return !0;
  const containerRect = container.getBoundingClientRect();
  return element.getBoundingClientRect().top >= containerRect.top + 32.5 * 2;
}
const useScrollIndicatorVisibility = () => {
  const $ = c(5), scrollContainerRef = useRef(null), scrollElementRef = useRef(null), [isRangeVisible, setIsRangeVisible] = useState(!0);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setIsRangeVisible(isElementVisibleInContainer(scrollContainerRef.current, scrollElementRef.current)), $[0] = t0) : t0 = $[0];
  const handleScroll = t0;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = (container) => {
    scrollContainerRef.current = container;
  }, $[1] = t1) : t1 = $[1];
  const setScrollContainer = t1;
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setIsRangeVisible(!0), $[2] = t2) : t2 = $[2];
  const resetRangeVisibility = t2;
  let t3, t4;
  return $[3] !== isRangeVisible ? (t4 = {
    resetRangeVisibility,
    onScroll: handleScroll,
    isRangeVisible,
    setScrollContainer,
    scrollElementRef
  }, $[3] = isRangeVisible, $[4] = t4) : t4 = $[4], t3 = t4, t3;
}, StyledMenu$4 = styled(Menu)`
  min-width: 200px;
  max-width: 320px;
`, OversizedButton = styled(Button$1)`
  ${oversizedButtonStyle}
`;
function GlobalPerspectiveMenu(t0) {
  const $ = c(18), {
    selectedReleaseId,
    areReleasesEnabled: t1
  } = t0, areReleasesEnabled = t1 === void 0 ? !0 : t1, [createBundleDialogOpen, setCreateBundleDialogOpen] = useState(!1), styledMenuRef = useRef(null), {
    isRangeVisible,
    onScroll,
    resetRangeVisibility,
    setScrollContainer,
    scrollElementRef
  } = useScrollIndicatorVisibility();
  let t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setCreateBundleDialogOpen(!1);
  }, $[0] = t2) : t2 = $[0];
  const handleClose = t2;
  let t3;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(OversizedButton, { "data-testid": "global-perspective-menu-button", iconRight: ChevronDownIcon, mode: "bleed", padding: 2, radius: "full" }), $[1] = t3) : t3 = $[1];
  let t4;
  $[2] !== areReleasesEnabled || $[3] !== isRangeVisible || $[4] !== onScroll || $[5] !== scrollElementRef || $[6] !== selectedReleaseId || $[7] !== setScrollContainer ? (t4 = /* @__PURE__ */ jsx(StyledMenu$4, { "data-testid": "release-menu", ref: styledMenuRef, children: /* @__PURE__ */ jsx(ReleasesList, { areReleasesEnabled, setScrollContainer, onScroll, isRangeVisible, scrollElementRef, selectedReleaseId, setCreateBundleDialogOpen }) }), $[2] = areReleasesEnabled, $[3] = isRangeVisible, $[4] = onScroll, $[5] = scrollElementRef, $[6] = selectedReleaseId, $[7] = setScrollContainer, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    constrainSize: !0,
    fallbackPlacements: ["bottom-end"],
    placement: "bottom-end",
    portal: !0,
    tone: "default",
    zOffset: 3e3
  }, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== resetRangeVisibility || $[11] !== t4 ? (t6 = /* @__PURE__ */ jsx(MenuButton$1, { button: t3, id: "releases-menu", onClose: resetRangeVisibility, menu: t4, popover: t5 }), $[10] = resetRangeVisibility, $[11] = t4, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== createBundleDialogOpen ? (t7 = createBundleDialogOpen && /* @__PURE__ */ jsx(CreateReleaseDialog, { onCancel: handleClose, onSubmit: handleClose, origin: "structure" }), $[13] = createBundleDialogOpen, $[14] = t7) : t7 = $[14];
  let t8;
  return $[15] !== t6 || $[16] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t6,
    t7
  ] }), $[15] = t6, $[16] = t7, $[17] = t8) : t8 = $[17], t8;
}
const ReleasesNavContainer = styled(Card)`
  position: relative;
  display: flex;
  &:not([hidden]) {
    display: flex;
  }
  align-items: center;
  gap: 2px;
  padding: 2px;
  margin: -3px 0;

  // The children in button is rendered inside a span, we need to absolutely position the dot for the error.
  span:has(> [data-ui='error-status-icon']) {
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 0;
  }

  a:hover,
  button:hover {
    position: relative;
    z-index: 2;
  }
`;
function ReleasesNav() {
  const $ = c(11), releasesToolAvailable2 = useReleasesToolAvailable(), {
    selectedPerspective,
    selectedReleaseId
  } = usePerspective();
  let t0;
  $[0] !== releasesToolAvailable2 ? (t0 = releasesToolAvailable2 && /* @__PURE__ */ jsx(ReleasesToolLink, {}), $[0] = releasesToolAvailable2, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== selectedPerspective ? (t1 = /* @__PURE__ */ jsx(CurrentGlobalPerspectiveLabel, { selectedPerspective }), $[2] = selectedPerspective, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== releasesToolAvailable2 || $[5] !== selectedReleaseId ? (t2 = /* @__PURE__ */ jsx(GlobalPerspectiveMenu, { selectedReleaseId, areReleasesEnabled: releasesToolAvailable2 }), $[4] = releasesToolAvailable2, $[5] = selectedReleaseId, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== t0 || $[8] !== t1 || $[9] !== t2 ? (t3 = /* @__PURE__ */ jsxs(ReleasesNavContainer, { flex: "none", tone: "inherit", radius: "full", "data-ui": "ReleasesNav", border: !0, children: [
    t0,
    t1,
    t2
  ] }), $[7] = t0, $[8] = t1, $[9] = t2, $[10] = t3) : t3 = $[10], t3;
}
function StudioActiveToolLayout(props2) {
  const $ = c(3), {
    activeTool
  } = props2, Component2 = activeTool.component;
  let t0;
  return $[0] !== Component2 || $[1] !== activeTool ? (t0 = /* @__PURE__ */ jsx(Component2, { tool: activeTool }), $[0] = Component2, $[1] = activeTool, $[2] = t0) : t0 = $[2], t0;
}
const checkPath = "/ping", checkRequestTag = "protocol-check";
function isUsingLegacyHttp(client) {
  return getProtocolForApi(client).pipe(map((protocol) => {
    if (protocol)
      return protocol.startsWith("http/0") || protocol.startsWith("http/1");
  }));
}
function getProtocolForApi(client) {
  return typeof PerformanceObserver > "u" || typeof PerformanceResourceTiming > "u" ? of(void 0) : detectProtocol(`${client.getUrl(checkPath)}?tag=sanity.studio.${checkRequestTag}`);
}
function detectProtocol(checkUrl) {
  const timingEntry = firstValueFrom(listenBufferedPerformanceEntries().pipe(filter((entry) => entry instanceof PerformanceResourceTiming && entry.name === checkUrl), take$1(1), map((entry) => localStorage._sanity_debugProtocol ?? entry.nextHopProtocol)));
  return defer(() => fetch(checkUrl)).pipe(
    // when the request is over, we map it to the corresponding timing entry
    mergeMap(() => timingEntry),
    // Race the actual timing detection against a 2.5s timer.
    // If the timer wins, we emit undefined to indicate we couldn’t detect the protocol.
    timeout({
      first: 2500,
      with: () => of(void 0)
    })
  );
}
function listenBufferedPerformanceEntries() {
  return new Observable((subscriber) => {
    const perfObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries())
        subscriber.next(entry);
    });
    return perfObserver.observe({
      type: "resource",
      buffered: !0
    }), () => perfObserver.disconnect();
  });
}
const HTTP_HELP_URL = generateHelpUrl("http1-performance-issues"), SNOOZE_DURATION_HOURS = 24;
function useNetworkProtocolCheck() {
  const {
    push: pushToast
  } = useToast(), {
    t
  } = useTranslation(), client = useClient({
    apiVersion: "2025-03-01"
  }), title = t("network-check.slow-protocol-warning.title"), [isOnLegacyHttp, setIsOnLegacyHttp] = useState(), [warningSnoozedAtRaw, setWarningSnoozedAt] = useSessionStorageState("sanity-studio.network.check.snooze"), warningDismissedAt = useMemo(() => warningSnoozedAtRaw ? new Date(warningSnoozedAtRaw) : void 0, [warningSnoozedAtRaw]), isWarningSnoozed = useMemo(() => warningDismissedAt && (/* @__PURE__ */ new Date()).getTime() - warningDismissedAt.getTime() < 1e3 * 60 * 60 * SNOOZE_DURATION_HOURS, [warningDismissedAt]);
  useEffect(() => {
    const sub2 = (isWarningSnoozed ? of(void 0) : isUsingLegacyHttp(client)).subscribe((result) => setIsOnLegacyHttp(result));
    return () => sub2.unsubscribe();
  }, [client, isWarningSnoozed, pushToast, title, warningDismissedAt]);
  const handleSnooze = useCallback(() => setWarningSnoozedAt((/* @__PURE__ */ new Date()).toISOString()), [setWarningSnoozedAt]);
  useConditionalToast({
    id: "network-protocol-check",
    status: "warning",
    enabled: isOnLegacyHttp && !isWarningSnoozed,
    title,
    description: /* @__PURE__ */ jsxs(Stack, { space: 4, paddingY: 1, children: [
      /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
        t("network-check.slow-protocol-warning.description"),
        " "
      ] }) }),
      /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
        /* @__PURE__ */ jsx(Button, { as: "a", href: HTTP_HELP_URL, target: "_blank", rel: "noreferrer", mode: "ghost", tone: "primary", size: "default", icon: LaunchIcon, tooltipProps: {
          content: t("network-check.slow-protocol-warning.learn-more-button.tooltip")
        }, text: t("network-check.slow-protocol-warning.learn-more-button.text") }),
        /* @__PURE__ */ jsx(Button, { mode: "bleed", tone: "neutral", size: "default", text: t("network-check.slow-protocol-warning.snooze-button.text"), onClick: handleSnooze })
      ] })
    ] })
  });
}
function useSessionStorageState(key) {
  const $ = c(7);
  let t0;
  $[0] !== key ? (t0 = () => {
    const stored = sessionStorage.getItem(key);
    return typeof stored == "string" ? stored : void 0;
  }, $[0] = key, $[1] = t0) : t0 = $[1];
  const [state, setState] = useState(t0);
  let t1;
  $[2] !== key ? (t1 = (value) => {
    setState(value), value === void 0 ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, value);
  }, $[2] = key, $[3] = t1) : t1 = $[3];
  const setValue = t1, t2 = typeof state == "string" ? state : void 0;
  let t3;
  return $[4] !== setValue || $[5] !== t2 ? (t3 = [t2, setValue], $[4] = setValue, $[5] = t2, $[6] = t3) : t3 = $[6], t3;
}
function NoToolsScreen() {
  const $ = c(4);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t0) : t0 = $[0];
  let t1, t2;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "medium", children: "No configured tools" }), t2 = /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: "Please configure a tool in your Studio configuration." }), $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]);
  let t3;
  return $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Container$2, { width: 0, children: /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, shadow: 1, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    /* @__PURE__ */ jsxs(Stack, { flex: 1, marginLeft: 3, space: 3, children: [
      t1,
      t2,
      /* @__PURE__ */ jsx(Text$1, { as: "p", muted: !0, size: 1, children: /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/studio-tools", rel: "noreferrer", target: "_blank", children: "Learn how to add a tool \u2192" }) })
    ] })
  ] }) }) }) }) }), $[3] = t3) : t3 = $[3], t3;
}
function RedirectingScreen(props2) {
  const $ = c(3), {
    reason: t0
  } = props2, reason = t0 === void 0 ? "Redirecting\u2026" : t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(DoubleChevronRightIcon, {}) }) }), $[0] = t1) : t1 = $[0];
  let t2;
  return $[1] !== reason ? (t2 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Container$2, { width: 0, children: /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, shadow: 1, tone: "primary", children: /* @__PURE__ */ jsxs(Flex, { children: [
    t1,
    /* @__PURE__ */ jsx(Stack, { flex: 1, marginLeft: 3, space: 3, children: /* @__PURE__ */ jsx(Text$1, { as: "h1", size: 1, weight: "bold", children: reason }) })
  ] }) }) }) }) }), $[1] = reason, $[2] = t2) : t2 = $[2], t2;
}
function ToolNotFoundScreen(props2) {
  const $ = c(3), {
    toolName
  } = props2;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }), $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== toolName ? (t1 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Container$2, { width: 0, children: /* @__PURE__ */ jsx(Card, { padding: 4, radius: 2, shadow: 1, tone: "caution", children: /* @__PURE__ */ jsxs(Flex, { children: [
    t0,
    /* @__PURE__ */ jsx(Stack, { flex: 1, marginLeft: 3, space: 3, children: /* @__PURE__ */ jsxs(Text$1, { as: "h1", size: 1, weight: "medium", children: [
      "Tool not found: ",
      /* @__PURE__ */ jsx("code", { children: toolName })
    ] }) })
  ] }) }) }) }) }), $[1] = toolName, $[2] = t1) : t1 = $[2], t1;
}
const hasSanityPackageInImportMap = () => {
  if (typeof document > "u" || !("querySelectorAll" in document))
    return !1;
  const importMapEntries = document.querySelectorAll('script[type="importmap"]');
  return Array.from(importMapEntries).some((entry) => entry.textContent ? "sanity" in (JSON.parse(entry.textContent).imports || {}) : !1);
};
function makeBufferedTransport(options) {
  let buffer = [], consentGiven;
  const fetchTransport = makeFetchTransport(options), send = async (event) => consentGiven ? sendImmediately(event) : (typeof consentGiven > "u" && buffer.push(event), {}), sendImmediately = async (event) => fetchTransport.send(event), setConsent = async (consent) => {
    consentGiven = consent, consent && await flushBuffer(), buffer = [];
  }, flushBuffer = async () => {
    await Promise.all(buffer.map(sendImmediately)).catch((err) => {
      console.error("Failed to send buffered events from transport: ", err);
    });
  };
  return {
    flush: async () => fetchTransport.flush(),
    send,
    setConsent
  };
}
const SANITY_DSN = "https://8914c8dde7e1ebce191f15af8bf6b7b9@sentry.sanity.io/4507342122123264", IS_EMBEDDED_STUDIO = !("__sanityErrorChannel" in globalScope), DEBUG_ERROR_REPORTING = supportsLocalStorage && !!localStorage.getItem("SANITY_DEBUG_ERROR_REPORTING"), IS_BROWSER = typeof window < "u", clientOptions = {
  dsn: SANITY_DSN,
  release: SANITY_VERSION,
  environment: isDev ? "development" : "production",
  debug: DEBUG_ERROR_REPORTING,
  enabled: IS_BROWSER && (!isDev || DEBUG_ERROR_REPORTING),
  transport: makeBufferedTransport
}, integrations = [inboundFiltersIntegration(), functionToStringIntegration(), browserApiErrorsIntegration({
  eventTarget: !1
}), breadcrumbsIntegration({
  console: !1
}), globalHandlersIntegration({
  onerror: !0,
  onunhandledrejection: !0
}), linkedErrorsIntegration(), dedupeIntegration(), sanityDedupeIntegration(), httpContextIntegration()];
function getSentryErrorReporter() {
  let client, scope;
  const preInitErrors = [];
  function _initialize() {
    if (client || !DEBUG_ERROR_REPORTING && !hasSanityPackageInImportMap() || !DEBUG_ERROR_REPORTING && IS_EMBEDDED_STUDIO)
      return;
    const isSentryInitialized = isInitialized(), hasThirdPartySentry = isSentryInitialized && getClient()?.getOptions().dsn === SANITY_DSN;
    if (isSentryInitialized && !hasThirdPartySentry) {
      client = getClient(), scope = getCurrentScope();
      return;
    }
    if (hasThirdPartySentry) {
      client = new BrowserClient({
        ...clientOptions,
        stackParser: defaultStackParser,
        integrations,
        beforeSend,
        transport: makeBufferedTransport
      }), scope = new Scope(), scope.setClient(client), client.init();
      return;
    }
    init({
      ...clientOptions,
      defaultIntegrations: !1,
      integrations,
      beforeSend
    }), client = getClient(), scope = getCurrentScope();
  }
  function initialize() {
    _initialize(), client && preInitErrors.length > 0 && (preInitErrors.forEach(({
      error,
      options
    }) => reportError(error, options)), preInitErrors.length = 0);
  }
  function reportError(error, options = {}) {
    if (!client)
      return preInitErrors.push({
        error,
        options
      }), null;
    const {
      reactErrorInfo = {},
      errorBoundary
    } = options, {
      componentStack
    } = reactErrorInfo, contexts = {};
    componentStack && (contexts.react = {
      componentStack
    });
    const tags = {
      handled: "no"
    };
    errorBoundary && (tags.errorBoundary = errorBoundary);
    let eventId = null;
    return withScope(() => {
      if (componentStack && isError(error)) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `${errorBoundary || "ErrorBoundary"} ${error.name}`, errorBoundaryError.stack = componentStack, setCause(error, errorBoundaryError);
      }
      eventId = captureException(error, {
        mechanism: {
          handled: !1
        },
        captureContext: {
          contexts,
          tags
        }
      });
    }), eventId ? {
      eventId
    } : null;
  }
  function isBufferedTransport(transport) {
    return !!transport && "setConsent" in transport && typeof transport.setConsent == "function";
  }
  function enable() {
    const transport = client?.getTransport();
    isBufferedTransport(transport) && transport.setConsent(!0);
  }
  function disable() {
    const transport = client?.getTransport();
    isBufferedTransport(transport) && transport.setConsent(!1);
  }
  return {
    initialize,
    reportError,
    enable,
    disable
  };
}
const objectToString = Object.prototype.toString;
function isError(thing) {
  switch (objectToString.call(thing)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return isInstanceOf(thing, Error);
  }
}
function isInstanceOf(thing, base) {
  try {
    return thing instanceof base;
  } catch {
    return !1;
  }
}
function setCause(error, cause) {
  const seenErrors = /* @__PURE__ */ new WeakMap();
  function recurse(err, subCause) {
    if (!seenErrors.has(err)) {
      if (isError(err.cause)) {
        seenErrors.set(err, !0), recurse(err.cause, subCause);
        return;
      }
      err.cause = subCause;
    }
  }
  recurse(error, cause);
}
function setAsUnhandled(event) {
  for (const exception of event.exception?.values || [])
    exception.mechanism && (exception.mechanism.handled = !1);
}
function beforeSend(event) {
  return setAsUnhandled(event), event;
}
function sanityDedupeIntegration() {
  const previousEvents = [];
  return {
    name: "SanityDedupe",
    processEvent(currentEvent) {
      if (currentEvent.type)
        return currentEvent;
      try {
        if (shouldDropEvent(currentEvent, previousEvents))
          return DEBUG_ERROR_REPORTING && console.warn("[sanity/sentry] Dropping error from being reported because it is a duplicate"), null;
      } catch {
      }
      return previousEvents.length > 10 && previousEvents.shift(), previousEvents.push(currentEvent), currentEvent;
    }
  };
}
function shouldDropEvent(currentEvent, previousEvents) {
  for (const previousEvent of previousEvents) {
    const currentMessage = getMessageFromEvent(currentEvent), previousMessage = getMessageFromEvent(previousEvent);
    if (currentMessage && previousMessage && currentMessage !== previousMessage)
      continue;
    const currentTimestamp = Math.floor(currentEvent.timestamp || 0), previousTimestamp = Math.floor(previousEvent.timestamp || 0);
    if (Math.abs(currentTimestamp - previousTimestamp) < 300)
      return !0;
  }
  return !1;
}
function getMessageFromEvent(event) {
  if (event.message)
    return event.message;
  if (event.exception) {
    for (const exception of event.exception.values || [])
      if (exception.value)
        return exception.value;
  }
}
const errorReporter = getSentryErrorReporter(), MESSAGES = [
  // chromium
  "Failed to fetch dynamically imported module:",
  // safari
  "Importing a module script failed.",
  // firefox
  "error loading dynamically imported module"
];
function isImportError(error) {
  return error.name === "TypeError" && MESSAGES.some((msg) => error.message.toLowerCase().startsWith(msg.toLowerCase()));
}
const WORKSPACES_DOCS_URL = "https://www.sanity.io/docs/workspaces", useWorkspaceAuthStates = createHookFromObservableFactory((workspaces) => combineLatest(workspaces.map((workspace) => (
  // eslint-disable-next-line max-nested-callbacks
  workspace.auth.state.pipe(map((state) => [workspace.name, state]))
))).pipe(map((entries) => Object.fromEntries(entries)))), STATE_TITLES = {
  "logged-in": "",
  "logged-out": "Signed out",
  "no-access": ""
}, Media$1 = styled.div`
  width: ${(props2) => props2.$size === "small" ? "25px" : "41px"};
  height: ${(props2) => props2.$size === "small" ? "25px" : "41px"};

  svg {
    width: 100%;
    height: 100%;
  }
`, WorkspacePreviewIcon = (t0) => {
  const $ = c(5), {
    icon,
    size: t1
  } = t0, size = t1 === void 0 ? "small" : t1;
  let t2, t3;
  $[0] !== icon ? (t3 = createIcon(icon), $[0] = icon, $[1] = t3) : t3 = $[1], t2 = t3;
  const iconComponent = t2;
  let t4;
  return $[2] !== iconComponent || $[3] !== size ? (t4 = /* @__PURE__ */ jsx(Media$1, { $size: size, children: iconComponent }), $[2] = iconComponent, $[3] = size, $[4] = t4) : t4 = $[4], t4;
}, createIcon = (Icon2) => {
  if (isValidElementType(Icon2)) return /* @__PURE__ */ jsx(Icon2, {});
  if (isValidElement(Icon2)) return Icon2;
};
function WorkspacePreview(props2) {
  const $ = c(21), {
    state,
    subtitle,
    selected,
    title,
    icon,
    iconRight
  } = props2;
  let t0, t1;
  $[0] !== iconRight ? (t1 = createIcon(iconRight), $[0] = iconRight, $[1] = t1) : t1 = $[1], t0 = t1;
  const iconRightComponent = t0;
  let t2;
  $[2] !== icon ? (t2 = /* @__PURE__ */ jsx(WorkspacePreviewIcon, { icon, size: "small" }), $[2] = icon, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== title ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: title }), $[4] = title, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== subtitle ? (t4 = subtitle && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: subtitle }), $[6] = subtitle, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t3,
    t4
  ] }), $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== state ? (t6 = state && STATE_TITLES[state] && /* @__PURE__ */ jsx(Box, { paddingLeft: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, textOverflow: "ellipsis", children: STATE_TITLES[state] }) }), $[11] = state, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== iconRightComponent || $[14] !== selected ? (t7 = (selected || iconRightComponent) && /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 4, paddingLeft: 3, paddingRight: 2, children: [
    selected && /* @__PURE__ */ jsx(Text$1, { children: /* @__PURE__ */ jsx(CheckmarkIcon, {}) }),
    iconRightComponent && /* @__PURE__ */ jsx(Text$1, { muted: !0, children: iconRightComponent })
  ] }), $[13] = iconRightComponent, $[14] = selected, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== t2 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: "none", gap: 3, children: [
    t2,
    t5,
    t6,
    t7
  ] }), $[16] = t2, $[17] = t5, $[18] = t6, $[19] = t7, $[20] = t8) : t8 = $[20], t8;
}
const LINKS = [{
  url: "https://slack.sanity.io/",
  i18nKey: "workspaces.community-title",
  title: "Community"
}, {
  url: "https://www.sanity.io/docs",
  i18nKey: "workspaces.docs-title",
  title: "Docs"
}, {
  url: "https://www.sanity.io/legal/privacy",
  i18nKey: "workspaces.privacy-title",
  title: "Privacy"
}, {
  url: "https://www.sanity.io",
  i18nKey: "workspaces.sanity-io-title",
  title: "sanity.io"
}], StyledText = styled(Text$1)`
  a {
    color: inherit;
  }
`;
function Layout(props2) {
  const $ = c(23), {
    children,
    footer,
    header
  } = props2, prefersDark = usePrefersDark();
  let t0;
  $[0] !== header ? (t0 = typeof header == "object" && /* @__PURE__ */ jsx(Box, { children: header }), $[0] = header, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== header ? (t1 = typeof header == "string" && /* @__PURE__ */ jsx(Box, { paddingY: 4, children: /* @__PURE__ */ jsx(Heading, { align: "center", size: 1, children: header }) }), $[2] = header, $[3] = t1) : t1 = $[3];
  const t2 = !!header, t3 = !!footer;
  let t4;
  $[4] !== children || $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box, { paddingX: 1, children: /* @__PURE__ */ jsx(Card, { borderTop: t2, borderBottom: t3, children }) }), $[4] = children, $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== footer ? (t5 = footer && /* @__PURE__ */ jsx(Box, { children: footer }), $[8] = footer, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t0 || $[11] !== t1 || $[12] !== t4 || $[13] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { border: !0, radius: 3, overflow: "auto", children: /* @__PURE__ */ jsxs(Stack, { children: [
    t0,
    t1,
    t4,
    t5
  ] }) }), $[10] = t0, $[11] = t1, $[12] = t4, $[13] = t5, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== prefersDark ? (t7 = /* @__PURE__ */ jsx(Text$1, { size: 3, children: /* @__PURE__ */ jsx(SanityLogo, { dark: prefersDark }) }), $[15] = prefersDark, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t8 = /* @__PURE__ */ jsx(Flex, { align: "center", gap: 2, children: LINKS.map(_temp$q) }), $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== t7 ? (t9 = /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 4, justify: "center", align: "center", paddingBottom: 4, children: [
    t7,
    t8
  ] }), $[18] = t7, $[19] = t9) : t9 = $[19];
  let t10;
  return $[20] !== t6 || $[21] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 6, children: [
    t6,
    t9
  ] }), $[20] = t6, $[21] = t9, $[22] = t10) : t10 = $[22], t10;
}
function _temp$q(link, index) {
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(StyledText, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("a", { href: link.url, target: "_blank", rel: "noopener noreferrer", children: link.title }) }),
    index < LINKS.length - 1 && /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: "\u2022" })
  ] }, link.title);
}
function WorkspaceAuth() {
  const $ = c(46), workspaces = useWorkspaces(), {
    activeWorkspace,
    setActiveWorkspace
  } = useActiveWorkspace(), [authStates] = useWorkspaceAuthStates(workspaces), [selectedWorkspaceName, setSelectedWorkspaceName] = useState(activeWorkspace?.name || null);
  let t0;
  $[0] !== selectedWorkspaceName || $[1] !== workspaces ? (t0 = workspaces.length === 1 ? workspaces[0] : workspaces.find((workspace) => workspace.name === selectedWorkspaceName), $[0] = selectedWorkspaceName, $[1] = workspaces, $[2] = t0) : t0 = $[2];
  const selectedWorkspace = t0, LoginComponent = selectedWorkspace?.auth?.LoginComponent;
  let t1;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setSelectedWorkspaceName(null), $[3] = t1) : t1 = $[3];
  const handleBack = t1, {
    t
  } = useTranslation();
  if (!authStates) {
    let t22;
    return $[4] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[4] = t22) : t22 = $[4], t22;
  }
  if (LoginComponent && selectedWorkspace) {
    let t22;
    $[5] !== t || $[6] !== workspaces.length ? (t22 = workspaces.length > 1 && /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Button, { icon: ArrowLeftIcon, mode: "bleed", onClick: handleBack, text: t("workspaces.action.choose-another-workspace") }) }), $[5] = t, $[6] = workspaces.length, $[7] = t22) : t22 = $[7];
    const t32 = selectedWorkspace?.subtitle;
    let t42;
    $[8] !== selectedWorkspace.icon || $[9] !== selectedWorkspace.title || $[10] !== t32 ? (t42 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsx(WorkspacePreview, { icon: selectedWorkspace.icon, title: selectedWorkspace.title, subtitle: t32 }) }), $[8] = selectedWorkspace.icon, $[9] = selectedWorkspace.title, $[10] = t32, $[11] = t42) : t42 = $[11];
    let t52;
    $[12] !== selectedWorkspace.basePath ? (t52 = window.location.pathname.startsWith(selectedWorkspace.basePath) ? `${window.location.pathname}${window.location.search}` : selectedWorkspace.basePath, $[12] = selectedWorkspace.basePath, $[13] = t52) : t52 = $[13];
    let t62;
    $[14] !== LoginComponent || $[15] !== selectedWorkspace.projectId || $[16] !== selectedWorkspaceName || $[17] !== t52 ? (t62 = /* @__PURE__ */ jsx(Stack, { padding: 2, paddingBottom: 3, paddingTop: 4, children: /* @__PURE__ */ jsx(LoginComponent, { projectId: selectedWorkspace.projectId, redirectPath: t52 }, selectedWorkspaceName) }), $[14] = LoginComponent, $[15] = selectedWorkspace.projectId, $[16] = selectedWorkspaceName, $[17] = t52, $[18] = t62) : t62 = $[18];
    let t72;
    $[19] !== t42 || $[20] !== t62 ? (t72 = /* @__PURE__ */ jsx(Layout, { header: t42, children: t62 }), $[19] = t42, $[20] = t62, $[21] = t72) : t72 = $[21];
    let t8;
    return $[22] !== t22 || $[23] !== t72 ? (t8 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      t22,
      t72
    ] }), $[22] = t22, $[23] = t72, $[24] = t8) : t8 = $[24], t8;
  }
  let t2;
  $[25] !== t ? (t2 = t("workspaces.choose-your-workspace-label"), $[25] = t, $[26] = t2) : t2 = $[26];
  let t3;
  $[27] !== t ? (t3 = t("workspaces.action.add-workspace"), $[27] = t, $[28] = t3) : t3 = $[28];
  let t4;
  $[29] !== t3 ? (t4 = /* @__PURE__ */ jsx(Stack, { padding: 1, children: /* @__PURE__ */ jsx(Button, { as: "a", href: WORKSPACES_DOCS_URL, icon: AddIcon, mode: "bleed", rel: "noopener noreferrer", size: "large", target: "__blank", text: t3 }) }), $[29] = t3, $[30] = t4) : t4 = $[30];
  let t5;
  if ($[31] !== activeWorkspace || $[32] !== authStates || $[33] !== setActiveWorkspace || $[34] !== workspaces) {
    let t62;
    $[36] !== activeWorkspace || $[37] !== authStates || $[38] !== setActiveWorkspace ? (t62 = (workspace_0) => {
      const state = authStates[workspace_0.name].authenticated ? "logged-in" : workspace_0.auth.LoginComponent ? "logged-out" : "no-access";
      return /* @__PURE__ */ jsx(Card, { as: "button", radius: 2, padding: 2, onClick: () => {
        state === "logged-in" && workspace_0.name !== activeWorkspace.name && setActiveWorkspace(workspace_0.name), state === "logged-out" && setSelectedWorkspaceName(workspace_0.name);
      }, children: /* @__PURE__ */ jsx(WorkspacePreview, { icon: workspace_0?.icon, iconRight: ChevronRightIcon, state, subtitle: workspace_0?.subtitle, title: workspace_0?.title || workspace_0.name }) }, workspace_0.name);
    }, $[36] = activeWorkspace, $[37] = authStates, $[38] = setActiveWorkspace, $[39] = t62) : t62 = $[39], t5 = workspaces.map(t62), $[31] = activeWorkspace, $[32] = authStates, $[33] = setActiveWorkspace, $[34] = workspaces, $[35] = t5;
  } else
    t5 = $[35];
  let t6;
  $[40] !== t5 ? (t6 = /* @__PURE__ */ jsx(Stack, { space: 1, paddingX: 1, paddingY: 2, children: t5 }), $[40] = t5, $[41] = t6) : t6 = $[41];
  let t7;
  return $[42] !== t2 || $[43] !== t4 || $[44] !== t6 ? (t7 = /* @__PURE__ */ jsx(Layout, { header: t2, footer: t4, children: t6 }), $[42] = t2, $[43] = t4, $[44] = t6, $[45] = t7) : t7 = $[45], t7;
}
const StyledMenu$3 = styled(Menu)`
  max-width: 350px;
  min-width: 250px;
`, POPOVER_PROPS$1 = {
  constrainSize: !0,
  fallbackPlacements: ["bottom-end", "bottom"],
  placement: "bottom-end",
  tone: "default"
};
function WorkspaceMenuButton() {
  const $ = c(22), workspaces = useWorkspaces(), {
    activeWorkspace
  } = useActiveWorkspace(), [authStates] = useWorkspaceAuthStates(workspaces), {
    t
  } = useTranslation();
  if (!(workspaces.length > 1))
    return null;
  const disabled = !authStates;
  let t0;
  $[0] !== t ? (t0 = t("workspaces.select-workspace-tooltip"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== activeWorkspace.title ? (t1 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: activeWorkspace.title }) }), $[2] = activeWorkspace.title, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(CapabilityGate, { capability: "globalWorkspaceControl", children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }) }), $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t1 ? (t3 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t1,
    t2
  ] }), $[5] = t1, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== disabled || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Button$1, { disabled, mode: "bleed", padding: 2, width: "fill", children: t3 }), $[7] = disabled, $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== disabled || $[11] !== t0 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Tooltip, { content: t0, disabled, portal: !0, children: t4 }) }), $[10] = disabled, $[11] = t0, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== activeWorkspace.name || $[15] !== authStates || $[16] !== disabled || $[17] !== workspaces ? (t6 = !disabled && authStates ? /* @__PURE__ */ jsx(CapabilityGate, { capability: "globalWorkspaceControl", children: /* @__PURE__ */ jsx(StyledMenu$3, { children: workspaces.map((workspace) => {
    const state = authStates[workspace.name].authenticated ? "logged-in" : workspace.auth.LoginComponent ? "logged-out" : "no-access", isSelected = workspace.name === activeWorkspace.name;
    return /* @__PURE__ */ jsx(MenuItem$1, { as: "a", href: workspace.basePath, badgeText: STATE_TITLES[state], iconRight: isSelected ? CheckmarkIcon : void 0, pressed: isSelected, preview: /* @__PURE__ */ jsx(WorkspacePreviewIcon, { icon: workspace.icon, size: "small" }), selected: isSelected, __unstable_subtitle: workspace.subtitle, __unstable_space: 1, text: workspace?.title || workspace.name }, workspace.name);
  }) }) }) : void 0, $[14] = activeWorkspace.name, $[15] = authStates, $[16] = disabled, $[17] = workspaces, $[18] = t6) : t6 = $[18];
  let t7;
  return $[19] !== t5 || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuButton$1, { button: t5, id: "workspace-menu", menu: t6, popover: POPOVER_PROPS$1 }), $[19] = t5, $[20] = t6, $[21] = t7) : t7 = $[21], t7;
}
function AuthenticateScreen() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingX: 4, children: /* @__PURE__ */ jsx(Flex, { height: "fill", direction: "column", align: "center", justify: "center", paddingTop: 4, children: /* @__PURE__ */ jsx(Container$2, { width: 0, children: /* @__PURE__ */ jsx(WorkspaceAuth, {}) }) }) }), $[0] = t0) : t0 = $[0], t0;
}
function ConfigErrorsScreen() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Fragment, { children: "TODO: implement config errors screen" }), $[0] = t0) : t0 = $[0], t0;
}
const ScreenReaderLabel = styled.label`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  overflow: clip;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
function CorsOriginErrorScreen(props2) {
  const $ = c(8), {
    projectId
  } = props2, origin = window.location.origin;
  let t0;
  const t1 = `https://sanity.io/manage/project/${projectId}/api`;
  let t2;
  if ($[0] !== t1) {
    const url = new URL(t1);
    url.searchParams.set("cors", "add"), url.searchParams.set("origin", origin), url.searchParams.set("credentials", ""), t2 = url.toString(), $[0] = t1, $[1] = t2;
  } else
    t2 = $[1];
  t0 = t2;
  const corsUrl = t0;
  let t3;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t3 = [], $[2] = t3) : t3 = $[2], useEffect(_temp2$c, t3);
  let t4;
  $[3] !== corsUrl ? (t4 = {
    confirmButton: {
      text: "Continue",
      iconRight: LaunchIcon,
      as: "a",
      href: corsUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      tone: "primary"
    }
  }, $[3] = corsUrl, $[4] = t4) : t4 = $[4];
  let t5;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    /* @__PURE__ */ jsxs(Text$1, { children: [
      "To access your content, you need to ",
      /* @__PURE__ */ jsx("b", { children: "add the following URL as a CORS origin" }),
      " to your Sanity project."
    ] }),
    /* @__PURE__ */ jsx(ScreenReaderLabel, { "aria-hidden": "true", children: "CORS URL to be added" }),
    /* @__PURE__ */ jsx(TextInput$1, { value: origin, readOnly: !0 })
  ] }), $[5] = t5) : t5 = $[5];
  let t6;
  return $[6] !== t4 ? (t6 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Dialog$1, { id: "cors-error-dialog", header: "Before you continue...", width: 1, footer: t4, children: t5 }) }), $[6] = t4, $[7] = t6) : t6 = $[7], t6;
}
function _temp2$c() {
  const handleFocus = _temp$p;
  return window.addEventListener("focus", handleFocus), () => {
    window.removeEventListener("focus", handleFocus);
  };
}
function _temp$p() {
  window.location.reload();
}
function NotAuthenticatedScreen() {
  const $ = c(18), [currentUser, setCurrentUser] = useState(null), [error, handleError] = useState(null);
  if (error)
    throw error;
  const {
    activeWorkspace
  } = useActiveWorkspace();
  let t0;
  $[0] !== activeWorkspace.auth ? (t0 = () => {
    activeWorkspace.auth.logout?.();
  }, $[0] = activeWorkspace.auth, $[1] = t0) : t0 = $[1];
  const handleLogout = t0;
  let t1;
  $[2] !== activeWorkspace.auth.state ? (t1 = () => {
    const subscription = activeWorkspace.auth.state.subscribe({
      next: (t22) => {
        const {
          currentUser: user
        } = t22;
        setCurrentUser(user);
      },
      error: handleError
    });
    return () => {
      subscription.unsubscribe();
    };
  }, $[2] = activeWorkspace.auth.state, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== activeWorkspace ? (t2 = [activeWorkspace], $[4] = activeWorkspace, $[5] = t2) : t2 = $[5], useEffect(t1, t2);
  const providerTitle = getProviderTitle(currentUser?.provider), providerHelp = providerTitle ? ` through ${providerTitle}` : "";
  let t3;
  $[6] !== handleLogout ? (t3 = {
    confirmButton: {
      text: "Sign out",
      onClick: handleLogout,
      tone: "default"
    }
  }, $[6] = handleLogout, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Text$1, { children: "You are not authorized to access this studio. Please contact someone with access to invite you to this project." }), $[8] = t4) : t4 = $[8];
  const t5 = currentUser?.name, t6 = currentUser?.email;
  let t7;
  $[9] !== t5 || $[10] !== t6 ? (t7 = /* @__PURE__ */ jsxs("strong", { children: [
    t5,
    " (",
    t6,
    ")"
  ] }), $[9] = t5, $[10] = t6, $[11] = t7) : t7 = $[11];
  let t8;
  $[12] !== providerHelp || $[13] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t4,
    /* @__PURE__ */ jsxs(Text$1, { children: [
      "If you think this is an error, verify that you are signed in with the correct account. You are currently signed in as",
      " ",
      t7,
      providerHelp,
      "."
    ] })
  ] }), $[12] = providerHelp, $[13] = t7, $[14] = t8) : t8 = $[14];
  let t9;
  return $[15] !== t3 || $[16] !== t8 ? (t9 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Dialog$1, { id: "not-authorized-dialog", header: "Not authorized", width: 1, footer: t3, children: t8 }) }), $[15] = t3, $[16] = t8, $[17] = t9) : t9 = $[17], t9;
}
function NotFoundScreen(props2) {
  const $ = c(3);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(Heading, { as: "h1", children: "Workspace not found" }), $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== props2.onNavigateToDefaultWorkspace ? (t1 = /* @__PURE__ */ jsx(Card, { height: "fill", sizing: "border", tone: "caution", display: "flex", children: /* @__PURE__ */ jsx(Flex, { direction: "row", justify: "center", flex: 1, align: "center", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t0,
    /* @__PURE__ */ jsx(Inline, { children: /* @__PURE__ */ jsx(Button, { text: "Go to default workspace", onClick: props2.onNavigateToDefaultWorkspace, mode: "ghost" }) })
  ] }) }) }), $[1] = props2.onNavigateToDefaultWorkspace, $[2] = t1) : t1 = $[2], t1;
}
const MAX_NOTE_LENGTH = 150;
function RequestAccessScreen() {
  const $ = c(50), [currentUser, setCurrentUser] = useState(null), [client, setClient] = useState(), [projectId, setProjectId] = useState(), toast = useToast(), [error, setError] = useState(null), [msgError, setMsgError] = useState(), [loading, setLoading] = useState(!0), [isSubmitting, setIsSubmitting] = useState(!1), [hasPendingRequest, setHasPendingRequest] = useState(!1), [hasExpiredPendingRequest, setExpiredHasPendingRequest] = useState(!1), [hasTooManyRequests, setHasTooManyRequests] = useState(!1), [hasBeenDenied, setHasBeenDenied] = useState(!1), [note, setNote] = useState(), [noteLength, setNoteLength] = useState(0), {
    activeWorkspace
  } = useActiveWorkspace();
  let t0;
  $[0] !== activeWorkspace.auth ? (t0 = () => {
    activeWorkspace.auth.logout?.();
  }, $[0] = activeWorkspace.auth, $[1] = t0) : t0 = $[1];
  const handleLogout = t0;
  let t1;
  $[2] !== activeWorkspace.auth.state ? (t1 = () => {
    const subscription = activeWorkspace.auth.state.subscribe({
      next: (t22) => {
        const {
          client: sanityClient,
          currentUser: user
        } = t22;
        setProjectId(sanityClient.config().projectId), setClient(sanityClient.withConfig({
          apiVersion: "2024-07-01"
        })), setCurrentUser(user);
      },
      error: setError
    });
    return () => {
      subscription.unsubscribe();
    };
  }, $[2] = activeWorkspace.auth.state, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== activeWorkspace ? (t2 = [activeWorkspace], $[4] = activeWorkspace, $[5] = t2) : t2 = $[5], useEffect(t1, t2);
  let t3, t4;
  $[6] !== client || $[7] !== projectId ? (t3 = () => {
    if (!client || !projectId)
      return _temp$o;
    const request$ = client.observable.request({
      url: "/access/requests/me",
      tag: "request-access"
    }).pipe(finalize(() => setLoading(!1))).subscribe({
      next: (requests) => {
        if (!requests || !requests.length)
          return;
        const projectRequests = requests.filter((request) => request.resourceId === projectId), declinedRequest = projectRequests.find(_temp2$b);
        if (declinedRequest && isAfter(addWeeks(new Date(declinedRequest.createdAt), 2), /* @__PURE__ */ new Date())) {
          setHasBeenDenied(!0);
          return;
        }
        if (projectRequests.find(_temp3$3)) {
          setHasPendingRequest(!0);
          return;
        }
        projectRequests.find(_temp4) && setExpiredHasPendingRequest(!0);
      },
      error: (err) => {
        console.error(err), setError(!0);
      }
    });
    return () => {
      request$.unsubscribe();
    };
  }, t4 = [client, projectId], $[6] = client, $[7] = projectId, $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5;
  $[10] !== client || $[11] !== note || $[12] !== projectId || $[13] !== toast ? (t5 = () => {
    !client || !projectId || (setIsSubmitting(!0), client.request({
      url: `/access/project/${projectId}/requests`,
      method: "post",
      body: {
        note,
        requestUrl: window?.location.href,
        type: "access"
      }
    }).then((request_3) => {
      request_3 && setHasPendingRequest(!0);
    }).catch((err_0) => {
      const statusCode = err_0?.response?.statusCode, errMessage = err_0?.response?.body?.message;
      statusCode === 429 && (setHasTooManyRequests(!0), setMsgError(errMessage)), statusCode === 409 ? (setHasBeenDenied(!0), setMsgError(errMessage)) : toast.push({
        title: "There was a problem submitting your request.",
        status: "error"
      });
    }).finally(() => {
      setIsSubmitting(!1);
    }));
  }, $[10] = client, $[11] = note, $[12] = projectId, $[13] = toast, $[14] = t5) : t5 = $[14];
  const handleSubmitRequest = t5, providerTitle = getProviderTitle(currentUser?.provider), providerHelp = providerTitle ? ` through ${providerTitle}` : "";
  if (loading) {
    let t62;
    return $[15] === Symbol.for("react.memo_cache_sentinel") ? (t62 = /* @__PURE__ */ jsx(LoadingBlock, {}), $[15] = t62) : t62 = $[15], t62;
  }
  if (error) {
    let t62;
    return $[16] === Symbol.for("react.memo_cache_sentinel") ? (t62 = /* @__PURE__ */ jsx(NotAuthenticatedScreen, {}), $[16] = t62) : t62 = $[16], t62;
  }
  const t6 = currentUser?.name, t7 = currentUser?.email;
  let t8;
  $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs("strong", { children: [
    t6,
    " (",
    t7,
    ")"
  ] }), $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== providerHelp || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Text$1, { children: [
    "You are not authorized to access this studio (currently signed in as",
    " ",
    t8,
    providerHelp,
    ")."
  ] }), $[20] = providerHelp, $[21] = t8, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== handleSubmitRequest || $[24] !== hasBeenDenied || $[25] !== hasExpiredPendingRequest || $[26] !== hasPendingRequest || $[27] !== hasTooManyRequests || $[28] !== isSubmitting || $[29] !== msgError || $[30] !== note || $[31] !== noteLength ? (t10 = hasTooManyRequests || hasPendingRequest || hasBeenDenied ? /* @__PURE__ */ jsx(Card, { tone: hasPendingRequest ? "transparent" : "caution", padding: 3, radius: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    hasTooManyRequests && !hasPendingRequest && /* @__PURE__ */ jsx(Fragment, { children: msgError ?? `You've reached the limit for access requests across all projects. Please wait
                      before submitting more requests or contact an admin for assistance.` }),
    hasPendingRequest && /* @__PURE__ */ jsx(Fragment, { children: "Your request to access this project is pending approval." }),
    hasBeenDenied && /* @__PURE__ */ jsx(Fragment, { children: msgError ?? "Your request to access this project has been declined." })
  ] }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Text$1, { children: hasExpiredPendingRequest ? /* @__PURE__ */ jsx(Fragment, { children: "Your previous request has expired. You may again request access below with an optional note. The administrator(s) will receive an email letting them know that you are requesting access." }) : /* @__PURE__ */ jsx(Fragment, { children: "You can request access below with an optional note. The administrator(s) will receive an email letting them know that you are requesting access." }) }),
    /* @__PURE__ */ jsxs(Stack, { space: 3, paddingBottom: 0, children: [
      /* @__PURE__ */ jsx(TextInput$1, { maxLength: MAX_NOTE_LENGTH, disabled: isSubmitting, onKeyDown: (e) => {
        e.key === "Enter" && handleSubmitRequest();
      }, onChange: (e_0) => {
        setNote(e_0.currentTarget.value), setNoteLength(e_0.currentTarget.value.length);
      }, value: note, placeholder: "Add your note\u2026" }),
      /* @__PURE__ */ jsx(Text$1, { align: "right", muted: !0, size: 1, children: `${noteLength}/${MAX_NOTE_LENGTH}` })
    ] })
  ] }), $[23] = handleSubmitRequest, $[24] = hasBeenDenied, $[25] = hasExpiredPendingRequest, $[26] = hasPendingRequest, $[27] = hasTooManyRequests, $[28] = isSubmitting, $[29] = msgError, $[30] = note, $[31] = noteLength, $[32] = t10) : t10 = $[32];
  let t11;
  $[33] !== t10 || $[34] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t9,
    t10
  ] }), $[33] = t10, $[34] = t9, $[35] = t11) : t11 = $[35];
  let t12;
  $[36] !== handleLogout ? (t12 = /* @__PURE__ */ jsx(Button, { mode: "bleed", text: "Sign out", tone: "default", onClick: handleLogout, size: "large" }), $[36] = handleLogout, $[37] = t12) : t12 = $[37];
  let t13;
  $[38] !== handleSubmitRequest || $[39] !== hasBeenDenied || $[40] !== hasPendingRequest || $[41] !== hasTooManyRequests || $[42] !== isSubmitting ? (t13 = !hasTooManyRequests && !hasBeenDenied && /* @__PURE__ */ jsx(Button, { mode: "default", text: hasPendingRequest ? "Request sent" : "Request access", disabled: hasPendingRequest || isSubmitting, loading: isSubmitting, tone: "default", onClick: handleSubmitRequest, size: "large" }), $[38] = handleSubmitRequest, $[39] = hasBeenDenied, $[40] = hasPendingRequest, $[41] = hasTooManyRequests, $[42] = isSubmitting, $[43] = t13) : t13 = $[43];
  let t14;
  $[44] !== t12 || $[45] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", paddingTop: 4, children: [
    t12,
    t13
  ] }), $[44] = t12, $[45] = t13, $[46] = t14) : t14 = $[46];
  let t15;
  return $[47] !== t11 || $[48] !== t14 ? (t15 = /* @__PURE__ */ jsx(Card, { height: "fill", children: /* @__PURE__ */ jsx(Dialog$1, { id: "not-authorized-dialog", header: "Not authorized", width: 1, children: /* @__PURE__ */ jsxs(Box, { children: [
    t11,
    t14
  ] }) }) }), $[47] = t11, $[48] = t14, $[49] = t15) : t15 = $[49], t15;
}
function _temp4(request_2) {
  return request_2.status === "pending" && isBefore(addWeeks(new Date(request_2.createdAt), 2), /* @__PURE__ */ new Date());
}
function _temp3$3(request_1) {
  return request_1.status === "pending" && isAfter(addWeeks(new Date(request_1.createdAt), 2), /* @__PURE__ */ new Date());
}
function _temp2$b(request_0) {
  return request_0.status === "declined";
}
function _temp$o() {
}
function renderPath(path) {
  return path.map((segment) => segment.kind === "type" ? `${segment.name || "<unnamed>"}(${segment.type})` : segment.kind === "property" ? segment.name : null).filter(Boolean).join(" > ");
}
function reportWarnings(schema2) {
  const groupsWithWarnings = schema2._validation?.filter((group2) => group2.problems.some((problem) => problem.severity === "warning"));
  groupsWithWarnings?.length !== 0 && (console.groupCollapsed(`\u26A0\uFE0F Schema has ${groupsWithWarnings?.length} warnings`), groupsWithWarnings?.forEach((group2) => {
    const path = renderPath(group2.path);
    console.group(`%cAt ${path}`, "color: #FF7636"), group2.problems.forEach((problem) => {
      console.log(problem.message);
    }), console.groupEnd();
  }), console.groupEnd());
}
const TONES = {
  error: "critical",
  warning: "caution"
}, SegmentSpan = styled.code`
  && {
    background: none;
    color: inherit;
  }
`, ErrorMessageText = styled(Text$1)`
  white-space: pre-line;
`;
function SchemaProblemGroups(props2) {
  const {
    problemGroups
  } = props2;
  useTranslation();
  const items = useMemo(() => {
    const ret = [];
    for (const problemGroup of problemGroups)
      for (const problem of problemGroup.problems)
        ret.push({
          group: problemGroup,
          problem
        });
    return ret;
  }, [problemGroups]);
  return /* @__PURE__ */ jsx(Stack, { as: "ul", space: 4, children: items.map(({
    group: group2,
    problem: problem_0
  }, i) => {
    const isError2 = problem_0.severity === "error", isWarning = problem_0.severity === "warning", schemaType = getTypeInfo(group2);
    return /* @__PURE__ */ jsxs(Card, { border: !0, padding: 4, radius: 2, tone: TONES[problem_0.severity], children: [
      /* @__PURE__ */ jsxs(Flex, { children: [
        /* @__PURE__ */ jsx(Box, { marginRight: 3, children: /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
          isError2 && /* @__PURE__ */ jsx(ErrorOutlineIcon, {}),
          isWarning && /* @__PURE__ */ jsx(WarningOutlineIcon, {})
        ] }) }),
        /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: schemaType ? /* @__PURE__ */ jsxs(Fragment, { children: [
          capitalize(schemaType.type),
          ' type "',
          schemaType.name,
          '"'
        ] }) : null }) })
      ] }),
      /* @__PURE__ */ jsx(Box, { marginTop: 4, children: /* @__PURE__ */ jsx(Card, { border: !0, overflow: "auto", padding: 2, tone: "inherit", children: /* @__PURE__ */ jsx(Breadcrumbs, { separator: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: "\u2192" }), children: group2.path.map((segment, j) => {
        if (segment.kind === "type") {
          const text = `${_renderSegmentName(segment.name || `<anonymous ${segment.type}>`)}:${segment.type}`;
          return /* @__PURE__ */ jsx(Text$1, { title: text, size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(SegmentSpan, { children: text }) }, j);
        }
        return segment.kind === "property" ? /* @__PURE__ */ jsx(Text$1, { title: segment.name, size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(SegmentSpan, { children: segment.name }) }, j) : null;
      }) }) }) }),
      /* @__PURE__ */ jsx(Box, { as: "ul", marginTop: 4, children: /* @__PURE__ */ jsx(Box, { as: "li", children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
        /* @__PURE__ */ jsx(ErrorMessageText, { muted: !0, size: 1, children: problem_0.message }),
        problem_0.helpId && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx("a", { href: generateHelpUrl(problem_0.helpId), target: "_blank", rel: "noopener noreferrer", children: "View documentation \u2192" }) })
      ] }) }) })
    ] }, i);
  }) });
}
function getTypeInfo(problem) {
  const first2 = problem.path[0];
  return first2.kind === "type" ? {
    name: first2.name || `<anonymous ${first2.type}>`,
    type: first2.type
  } : null;
}
function _renderSegmentName(str) {
  return str?.startsWith("<unnamed_type_@_index") ? `[${str.slice(1, -1).split("_")[4]}]` : str;
}
function SchemaErrorsScreen(t0) {
  const $ = c(9), {
    schema: schema2
  } = t0;
  let t1;
  $[0] !== schema2._validation ? (t1 = schema2._validation?.filter(_temp2$a) || [], $[0] = schema2._validation, $[1] = t1) : t1 = $[1];
  const groupsWithErrors = t1;
  let t2, t3;
  $[2] !== schema2 ? (t2 = () => reportWarnings(schema2), t3 = [schema2], $[2] = schema2, $[3] = t2, $[4] = t3) : (t2 = $[3], t3 = $[4]), useEffect(t2, t3);
  let t4;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t4 = [4, 5, 6, 7], $[5] = t4) : t4 = $[5];
  let t5;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Heading, { as: "h1", children: "Schema errors" }), $[6] = t5) : t5 = $[6];
  let t6;
  return $[7] !== groupsWithErrors ? (t6 = /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingY: t4, paddingX: 4, sizing: "border", children: /* @__PURE__ */ jsx(Container$2, { width: 1, children: /* @__PURE__ */ jsxs(Stack, { space: 5, children: [
    t5,
    /* @__PURE__ */ jsx(SchemaProblemGroups, { problemGroups: groupsWithErrors })
  ] }) }) }), $[7] = groupsWithErrors, $[8] = t6) : t6 = $[8], t6;
}
function _temp2$a(group2) {
  return group2.problems.some(_temp$n);
}
function _temp$n(problem) {
  return problem.severity === "error";
}
const View$1 = styled(Box)`
  align-items: center;
`;
function FallbackErrorScreen(props2) {
  const $ = c(19), {
    error,
    eventId,
    heading: t0,
    onReset
  } = props2, heading = t0 === void 0 ? "An error occurred" : t0, message = error?.message, stack = error?.stack === "string" && error?.stack;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [4, 5, 6, 7], $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== heading ? (t2 = /* @__PURE__ */ jsx(Heading, { children: heading }), $[1] = heading, $[2] = t2) : t2 = $[2];
  let t3, t4;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { children: "An error occurred that Sanity Studio was unable to recover from." }), t4 = isProd && /* @__PURE__ */ jsxs(Text$1, { children: [
    /* @__PURE__ */ jsx("strong", { children: "To report this error," }),
    " copy the error details and share them with your development team or Sanity Support."
  ] }), $[3] = t3, $[4] = t4) : (t3 = $[3], t4 = $[4]);
  let t5;
  $[5] !== eventId || $[6] !== message || $[7] !== stack ? (t5 = isDev && /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "critical", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    message && /* @__PURE__ */ jsx(Code, { weight: "bold", size: 1, children: message }),
    stack && /* @__PURE__ */ jsx(Code, { size: 1, children: stack }),
    eventId && /* @__PURE__ */ jsxs(Code, { size: 1, children: [
      "Event ID: ",
      eventId
    ] })
  ] }) }), $[5] = eventId, $[6] = message, $[7] = stack, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t2 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t2,
    t3,
    t4,
    t5
  ] }), $[9] = t2, $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== error || $[13] !== eventId || $[14] !== onReset ? (t7 = /* @__PURE__ */ jsx(ErrorActions, { error, eventId, onRetry: onReset, size: "large" }), $[12] = error, $[13] = eventId, $[14] = onReset, $[15] = t7) : t7 = $[15];
  let t8;
  return $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingY: t1, paddingX: 4, sizing: "border", children: /* @__PURE__ */ jsx(View$1, { display: "flex", height: "fill", children: /* @__PURE__ */ jsx(Container$2, { width: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 6, children: [
    t6,
    t7
  ] }) }) }) }), $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18], t8;
}
const View = styled(Box)`
  align-items: center;
`;
function reloadPage() {
  window.location.reload();
}
function ImportErrorScreen(props2) {
  const $ = c(25), {
    error,
    eventId,
    autoReload
  } = props2, [reloadAt] = useState(_temp$m), [, tick] = useReducer(_temp2$9, 0), countdownSeconds = Math.floor((reloadAt - Date.now()) / 1e3);
  let t0;
  $[0] !== autoReload || $[1] !== tick ? (t0 = () => {
    if (!autoReload)
      return _temp3$2;
    const interval2 = setInterval(() => tick(), 500);
    return () => clearInterval(interval2);
  }, $[0] = autoReload, $[1] = tick, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== autoReload ? (t1 = [autoReload], $[3] = autoReload, $[4] = t1) : t1 = $[4], useEffect(t0, t1);
  let t2;
  $[5] !== countdownSeconds ? (t2 = () => {
    countdownSeconds <= 0 && reloadPage();
  }, $[5] = countdownSeconds, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== autoReload || $[8] !== countdownSeconds ? (t3 = [autoReload, countdownSeconds], $[7] = autoReload, $[8] = countdownSeconds, $[9] = t3) : t3 = $[9], useEffect(t2, t3);
  let t4;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t4 = [4, 5, 6, 7], $[10] = t4) : t4 = $[10];
  let t5, t6;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Heading, { children: "Import error" }), t6 = /* @__PURE__ */ jsx(Text$1, { children: "An error occurred during dynamic import." }), $[11] = t5, $[12] = t6) : (t5 = $[11], t6 = $[12]);
  let t7;
  $[13] !== error || $[14] !== eventId ? (t7 = isDev && /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "critical", children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    error.message && /* @__PURE__ */ jsx(Code, { weight: "bold", size: 1, children: error.message }),
    error.stack && /* @__PURE__ */ jsx(Code, { size: 1, children: error.stack }),
    eventId && /* @__PURE__ */ jsxs(Code, { size: 1, children: [
      "Event ID: ",
      eventId
    ] })
  ] }) }), $[13] = error, $[14] = eventId, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== autoReload || $[17] !== countdownSeconds ? (t8 = autoReload ? /* @__PURE__ */ jsxs(Text$1, { muted: !0, children: [
    "Reloading ",
    countdownSeconds <= 0 ? "now" : `in ${countdownSeconds.toFixed()}s`,
    "\u2026"
  ] }) : null, $[16] = autoReload, $[17] = countdownSeconds, $[18] = t8) : t8 = $[18];
  const t9 = autoReload ? "Reload now" : "Reload";
  let t10;
  $[19] !== t9 ? (t10 = /* @__PURE__ */ jsx(Inline, { space: 3, children: /* @__PURE__ */ jsx(Button, { onClick: reloadPage, text: t9, tone: "primary", icon: SyncIcon, size: "large" }) }), $[19] = t9, $[20] = t10) : t10 = $[20];
  let t11;
  return $[21] !== t10 || $[22] !== t7 || $[23] !== t8 ? (t11 = /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingY: t4, paddingX: 4, sizing: "border", children: /* @__PURE__ */ jsx(View, { display: "flex", height: "fill", children: /* @__PURE__ */ jsx(Container$2, { width: 3, children: /* @__PURE__ */ jsx(Stack, { space: 6, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t5,
    t6,
    t7,
    t8,
    t10
  ] }) }) }) }) }), $[21] = t10, $[22] = t7, $[23] = t8, $[24] = t11) : t11 = $[24], t11;
}
function _temp3$2() {
}
function _temp2$9(state) {
  return state + 1;
}
function _temp$m() {
  return Date.now() + 5e3;
}
const DevServerStoppedErrorScreen = lazy(() => import("./_chunks-es/ViteDevServerStopped.mjs").then((DevServerStopped) => ({
  default: DevServerStopped.DevServerStoppedErrorScreen
})));
function StudioErrorBoundary(props2) {
  const {
    children,
    heading = "An error occurred"
  } = props2, [caughtError, setCaughtError] = useState(), handleResetError = useCallback(() => setCaughtError(void 0), []), handleCatchError = useCallback((params) => {
    let eventId;
    try {
      eventId = errorReporter.reportError(params.error, {
        reactErrorInfo: params.info,
        errorBoundary: "StudioErrorBoundary"
      })?.eventId;
    } catch (e) {
      e.message = `Encountered an additional error when reporting error: ${e.message}`, console.error(e);
    }
    setCaughtError({
      error: params.error,
      componentStack: params.info.componentStack,
      eventId
    });
  }, []);
  return useHotModuleReload(handleResetError), caughtError?.error ? caughtError.error instanceof CorsOriginError ? /* @__PURE__ */ jsx(CorsOriginErrorScreen, { projectId: caughtError.error.projectId }) : caughtError.error instanceof SchemaError ? /* @__PURE__ */ jsx(SchemaErrorsScreen, { schema: caughtError.error.schema }) : "ViteDevServerStoppedError" in caughtError.error && caughtError.error.ViteDevServerStoppedError ? /* @__PURE__ */ jsx(DevServerStoppedErrorScreen, {}) : isImportError(caughtError.error) ? /* @__PURE__ */ jsx(ImportErrorScreen, { error: caughtError.error, eventId: caughtError.eventId, autoReload: !0 }) : /* @__PURE__ */ jsx(FallbackErrorScreen, { heading, error: caughtError.error, eventId: caughtError.eventId, onReset: handleResetError }) : /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: handleCatchError, children });
}
const DetectViteDevServerStopped = lazy(() => import("./_chunks-es/ViteDevServerStopped.mjs").then((DevServerStopped) => ({
  default: DevServerStopped.DetectViteDevServerStopped
}))), detectViteDevServerStopped = import.meta.hot && process.env.NODE_ENV === "development", SearchFullscreenPortalCard = styled(Card)`
  height: 100%;
  left: 0;
  overflow: hidden;
  overflow: clip;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;
`;
function StudioLayout() {
  const $ = c(2), Layout2 = useLayoutComponent();
  let t0;
  return $[0] !== Layout2 ? (t0 = /* @__PURE__ */ jsx(Layout2, {}), $[0] = Layout2, $[1] = t0) : t0 = $[1], t0;
}
function StudioLayoutComponent() {
  const $ = c(61), {
    name,
    title,
    tools
  } = useWorkspace();
  useNetworkProtocolCheck();
  const router = useRouter(), activeToolName = useRouterState(_temp$l);
  let t0, t1;
  if ($[0] !== activeToolName || $[1] !== tools) {
    let t25;
    $[3] !== activeToolName ? (t25 = (tool) => tool.name === activeToolName, $[3] = activeToolName, $[4] = t25) : t25 = $[4], t1 = tools.find(t25), $[0] = activeToolName, $[1] = tools, $[2] = t1;
  } else
    t1 = $[2];
  t0 = t1;
  const activeTool = t0, [searchFullscreenOpen, setSearchFullscreenOpen] = useState(!1), [searchFullscreenPortalEl, setSearchFullscreenPortalEl] = useState(null), [searchOpen, setSearchOpen] = useState(!1);
  let t2;
  bb0: {
    let t32;
    $[5] !== name || $[6] !== title ? (t32 = title || startCase(name), $[5] = name, $[6] = title, $[7] = t32) : t32 = $[7];
    const mainTitle = t32;
    if (activeToolName) {
      t2 = `${startCase(activeToolName)} | ${mainTitle}`;
      break bb0;
    }
    t2 = mainTitle;
  }
  const documentTitle = t2, toolControlsDocumentTitle = !!activeTool?.controlsDocumentTitle;
  let t3, t4;
  $[8] !== documentTitle || $[9] !== toolControlsDocumentTitle ? (t3 = () => {
    toolControlsDocumentTitle || (document.title = documentTitle);
  }, t4 = [documentTitle, toolControlsDocumentTitle], $[8] = documentTitle, $[9] = toolControlsDocumentTitle, $[10] = t3, $[11] = t4) : (t3 = $[10], t4 = $[11]), useEffect(t3, t4);
  let t5;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (open) => {
    setSearchFullscreenOpen(open);
  }, $[12] = t5) : t5 = $[12];
  const handleSearchFullscreenOpenChange = t5;
  let t6;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t6 = (open_0) => {
    setSearchOpen(open_0);
  }, $[13] = t6) : t6 = $[13];
  const handleSearchOpenChange = t6;
  let t7, t8;
  $[14] !== searchFullscreenOpen || $[15] !== searchFullscreenPortalEl || $[16] !== searchOpen ? (t8 = {
    searchFullscreenOpen,
    searchFullscreenPortalEl,
    searchOpen,
    onSearchFullscreenOpenChange: handleSearchFullscreenOpenChange,
    onSearchOpenChange: handleSearchOpenChange
  }, $[14] = searchFullscreenOpen, $[15] = searchFullscreenPortalEl, $[16] = searchOpen, $[17] = t8) : t8 = $[17], t7 = t8;
  const navbarContextValue = t7, Navbar = useNavbarComponent(), ActiveToolLayout = useActiveToolLayoutComponent();
  let t9;
  $[18] !== activeTool || $[19] !== activeToolName || $[20] !== tools ? (t9 = !activeTool && (activeToolName === "desk" || !activeToolName) && typeof window < "u" && /\/desk(\/|$)/.test(window.location.pathname) && tools.some(_temp2$8), $[18] = activeTool, $[19] = activeToolName, $[20] = tools, $[21] = t9) : t9 = $[21];
  const isLegacyDeskRedirect = t9;
  let t10, t11;
  $[22] !== isLegacyDeskRedirect || $[23] !== router ? (t10 = () => {
    isLegacyDeskRedirect && router.navigateUrl({
      path: window.location.pathname.replace(/\/desk/, "/structure"),
      replace: !0
    });
  }, t11 = [isLegacyDeskRedirect, router], $[22] = isLegacyDeskRedirect, $[23] = router, $[24] = t10, $[25] = t11) : (t10 = $[24], t11 = $[25]), useEffect(t10, t11);
  let t12;
  $[26] !== Navbar ? (t12 = /* @__PURE__ */ jsx(Navbar, {}), $[26] = Navbar, $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== navbarContextValue || $[29] !== t12 ? (t13 = /* @__PURE__ */ jsx(NavbarContext.Provider, { value: navbarContextValue, children: t12 }), $[28] = navbarContextValue, $[29] = t12, $[30] = t13) : t13 = $[30];
  let t14;
  $[31] !== isLegacyDeskRedirect ? (t14 = isLegacyDeskRedirect && /* @__PURE__ */ jsx(RedirectingScreen, {}), $[31] = isLegacyDeskRedirect, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== tools.length ? (t15 = tools.length === 0 && /* @__PURE__ */ jsx(NoToolsScreen, {}), $[33] = tools.length, $[34] = t15) : t15 = $[34];
  let t16;
  $[35] !== activeTool || $[36] !== activeToolName || $[37] !== isLegacyDeskRedirect || $[38] !== tools.length ? (t16 = tools.length > 0 && !activeTool && activeToolName && !isLegacyDeskRedirect && /* @__PURE__ */ jsx(ToolNotFoundScreen, { toolName: activeToolName }), $[35] = activeTool, $[36] = activeToolName, $[37] = isLegacyDeskRedirect, $[38] = tools.length, $[39] = t16) : t16 = $[39];
  let t17;
  $[40] !== searchFullscreenOpen ? (t17 = searchFullscreenOpen && /* @__PURE__ */ jsx(SearchFullscreenPortalCard, { ref: setSearchFullscreenPortalEl, overflow: "auto" }), $[40] = searchFullscreenOpen, $[41] = t17) : t17 = $[41];
  const t18 = activeTool?.name, t19 = `The ${activeTool?.name} tool crashed`;
  let t20;
  $[42] === Symbol.for("react.memo_cache_sentinel") ? (t20 = detectViteDevServerStopped && /* @__PURE__ */ jsx(DetectViteDevServerStopped, {}), $[42] = t20) : t20 = $[42];
  let t21;
  $[43] !== ActiveToolLayout || $[44] !== activeTool || $[45] !== activeToolName ? (t21 = activeTool && activeToolName && /* @__PURE__ */ jsx(RouteScope, { scope: activeToolName, __unsafe_disableScopedSearchParams: activeTool.router?.__unsafe_disableScopedSearchParams, children: /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), children: /* @__PURE__ */ jsx(ActiveToolLayout, { activeTool }) }) }), $[43] = ActiveToolLayout, $[44] = activeTool, $[45] = activeToolName, $[46] = t21) : t21 = $[46];
  let t22;
  $[47] !== searchFullscreenOpen || $[48] !== t21 ? (t22 = /* @__PURE__ */ jsx(Card, { flex: 1, hidden: searchFullscreenOpen, children: t21 }), $[47] = searchFullscreenOpen, $[48] = t21, $[49] = t22) : t22 = $[49];
  let t23;
  $[50] !== t18 || $[51] !== t19 || $[52] !== t22 ? (t23 = /* @__PURE__ */ jsxs(StudioErrorBoundary, { heading: t19, children: [
    t20,
    t22
  ] }, t18), $[50] = t18, $[51] = t19, $[52] = t22, $[53] = t23) : t23 = $[53];
  let t24;
  return $[54] !== t13 || $[55] !== t14 || $[56] !== t15 || $[57] !== t16 || $[58] !== t17 || $[59] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Flex, { "data-ui": "ToolScreen", direction: "column", height: "fill", "data-testid": "studio-layout", children: [
    t13,
    t14,
    t15,
    t16,
    t17,
    t23
  ] }), $[54] = t13, $[55] = t14, $[56] = t15, $[57] = t16, $[58] = t17, $[59] = t23, $[60] = t24) : t24 = $[60], t24;
}
function _temp2$8(tool_0) {
  return tool_0.name === "structure";
}
function _temp$l(routerState) {
  return typeof routerState.tool == "string" ? routerState.tool : void 0;
}
function pickToolMenuComponent(plugin) {
  return plugin.studio?.components?.toolMenu;
}
function pickNavbarComponent(plugin) {
  return plugin.studio?.components?.navbar;
}
function pickLayoutComponent(plugin) {
  return plugin.studio?.components?.layout;
}
function pickActiveToolLayoutComponent(plugin) {
  return plugin.studio?.components?.activeToolLayout;
}
function useToolMenuComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: StudioToolMenu,
    pick: pickToolMenuComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useNavbarComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: StudioNavbar,
    pick: pickNavbarComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useLayoutComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: StudioLayoutComponent,
    pick: pickLayoutComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function useActiveToolLayoutComponent() {
  const $ = c(1);
  let t0;
  return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    defaultComponent: StudioActiveToolLayout,
    pick: pickActiveToolLayoutComponent
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
function ConfigIssuesButton() {
  const $ = c(25), schema2 = useSchema();
  let t0;
  $[0] !== schema2._validation ? (t0 = schema2._validation?.filter(_temp2$7) || [], $[0] = schema2._validation, $[1] = t0) : t0 = $[1];
  const groupsWithWarnings = t0, scheme = useColorSchemeValue(), {
    t
  } = useTranslation(), dialogId = useId(), [isDialogOpen, setDialogOpen] = useState(!1), [buttonElement, setButtonElement] = useState(null);
  let t1;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => setDialogOpen(!0), $[2] = t1) : t1 = $[2];
  const handleOpen = t1;
  let t2;
  $[3] !== buttonElement ? (t2 = () => {
    setDialogOpen(!1), buttonElement && buttonElement.focus();
  }, $[3] = buttonElement, $[4] = t2) : t2 = $[4];
  const handleClose = t2;
  if (groupsWithWarnings.length === 0)
    return null;
  let t3;
  $[5] !== t ? (t3 = t("configuration-issues.button.label"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t ? (t4 = t("configuration-issues.button.tooltip"), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== scheme || $[10] !== t4 ? (t5 = {
    scheme,
    content: t4
  }, $[9] = scheme, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== isDialogOpen || $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(StatusButton, { icon: WarningOutlineIcon, mode: "bleed", onClick: handleOpen, ref: setButtonElement, selected: isDialogOpen, tone: "caution", "aria-label": t3, tooltipProps: t5 }), $[12] = isDialogOpen, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== dialogId || $[17] !== groupsWithWarnings || $[18] !== handleClose || $[19] !== isDialogOpen || $[20] !== scheme ? (t7 = isDialogOpen && /* @__PURE__ */ jsx(Dialog$1, { header: "Configuration issues", width: 2, onClickOutside: handleClose, onClose: handleClose, scheme, id: dialogId, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsxs(Text$1, { as: "h2", size: 1, weight: "medium", children: [
        "Found ",
        groupsWithWarnings.length,
        " schema warnings"
      ] }),
      " ",
      /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: "Configuration checks are only performed during development and will not be visible in production builds" })
    ] }),
    /* @__PURE__ */ jsx(SchemaProblemGroups, { problemGroups: groupsWithWarnings })
  ] }) }), $[16] = dialogId, $[17] = groupsWithWarnings, $[18] = handleClose, $[19] = isDialogOpen, $[20] = scheme, $[21] = t7) : t7 = $[21];
  let t8;
  return $[22] !== t6 || $[23] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t6,
    t7
  ] }), $[22] = t6, $[23] = t7, $[24] = t8) : t8 = $[24], t8;
}
function _temp2$7(group2) {
  return group2.problems.some(_temp$k);
}
function _temp$k(problem) {
  return problem.severity === "warning";
}
const TrialDialogViewed = defineEvent({
  name: "Trial Dialog Viewed",
  version: 1,
  description: "User viewed a dialog or popover related to free trial"
}), TrialDialogDismissed = defineEvent({
  name: "Trial Dialog Dismissed",
  version: 1,
  description: "User dismissed a dialog or popover related to free trial"
}), TrialDialogCTAClicked = defineEvent({
  name: "Trial Dialog CTA Clicked",
  version: 1,
  description: "User clicked a CTA in a dialog or popover related to free trial"
});
function getTrialStage({
  showOnLoad,
  dialogId
}) {
  return showOnLoad && dialogId.toLowerCase() === "free-upgrade-popover" ? "trialStarted" : showOnLoad && dialogId.toLowerCase() === "trial-ending-popover" ? "trialEndingSoon" : showOnLoad && dialogId.toLowerCase() === "project-downgraded-to-free" ? "trialEnded" : !showOnLoad && dialogId.toLowerCase() === "after-trial-upgrade" ? "postTrial" : "trialActive";
}
const StyledButton$1 = styled(Button)`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 20;
  background: transparent;
  border-radius: 9999px;
  box-shadow: none;
  color: white;
  --card-fg-color: white;
  :hover {
    --card-fg-color: white;
  }
`, Image$2 = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  height: 196px;
`, StyledDialog$1 = styled(Dialog$1)`
  > [data-ui='DialogCard'] {
    max-width: 22.5rem;
  }
`;
function DialogContent(t0) {
  const $ = c(39), {
    onClose,
    onOpenNext,
    onOpenUrlCallback,
    content,
    open
  } = t0;
  let t1;
  $[0] !== onClose ? (t1 = function() {
    onClose("xClick");
  }, $[0] = onClose, $[1] = t1) : t1 = $[1];
  const handleClose = t1;
  let t2;
  $[2] !== onClose ? (t2 = function() {
    onClose("outsideClick");
  }, $[2] = onClose, $[3] = t2) : t2 = $[3];
  const handleClickOutside = t2;
  let t3;
  $[4] !== onClose ? (t3 = function() {
    onClose("ctaClicked");
  }, $[4] = onClose, $[5] = t3) : t3 = $[5];
  const handleCTAClose = t3, schemeValue = useColorSchemeValue();
  if (!open)
    return null;
  let t4;
  $[6] !== content.secondaryButton || $[7] !== handleClose ? (t4 = content.secondaryButton?.text ? {
    text: content.secondaryButton.text,
    mode: "bleed",
    tone: "default",
    onClick: handleClose
  } : void 0, $[6] = content.secondaryButton, $[7] = handleClose, $[8] = t4) : t4 = $[8];
  const t5 = content.ctaButton?.text;
  let t6;
  $[9] !== content.ctaButton || $[10] !== handleCTAClose || $[11] !== onOpenNext || $[12] !== onOpenUrlCallback ? (t6 = content.ctaButton?.action === "openUrl" ? {
    href: content.ctaButton.url,
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a",
    onClick: onOpenUrlCallback
  } : {
    onClick: content.ctaButton?.action === "openNext" ? onOpenNext : handleCTAClose
  }, $[9] = content.ctaButton, $[10] = handleCTAClose, $[11] = onOpenNext, $[12] = onOpenUrlCallback, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t5 || $[15] !== t6 ? (t7 = {
    text: t5,
    mode: "default",
    tone: "primary",
    ...t6
  }, $[14] = t5, $[15] = t6, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t4 || $[18] !== t7 ? (t8 = {
    cancelButton: t4,
    confirmButton: t7
  }, $[17] = t4, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== handleClose ? (t9 = /* @__PURE__ */ jsx(StyledButton$1, { icon: CloseIcon, mode: "bleed", tone: "default", onClick: handleClose, tabIndex: -1, tooltipProps: null }), $[20] = handleClose, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== content.image ? (t10 = content.image && /* @__PURE__ */ jsx(Image$2, { src: content.image.asset.url, alt: content.image.asset.altText ?? "" }), $[22] = content.image, $[23] = t10) : t10 = $[23];
  let t11;
  $[24] !== content.headingText ? (t11 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginTop: 3, children: /* @__PURE__ */ jsx(Heading, { size: 2, children: content.headingText }) }), $[24] = content.headingText, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== content.descriptionText ? (t12 = /* @__PURE__ */ jsx(Box, { marginTop: 4, paddingBottom: 3, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: content.descriptionText }) }), $[26] = content.descriptionText, $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== t11 || $[29] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Flex, { padding: 3, direction: "column", children: [
    t11,
    t12
  ] }), $[28] = t11, $[29] = t12, $[30] = t13) : t13 = $[30];
  let t14;
  return $[31] !== handleClickOutside || $[32] !== onClose || $[33] !== schemeValue || $[34] !== t10 || $[35] !== t13 || $[36] !== t8 || $[37] !== t9 ? (t14 = /* @__PURE__ */ jsxs(StyledDialog$1, { id: "free-trial-modal", onClose, onClickOutside: handleClickOutside, padding: !1, __unstable_hideCloseButton: !0, scheme: schemeValue, footer: t8, children: [
    t9,
    t10,
    t13
  ] }), $[31] = handleClickOutside, $[32] = onClose, $[33] = schemeValue, $[34] = t10, $[35] = t13, $[36] = t8, $[37] = t9, $[38] = t14) : t14 = $[38], t14;
}
const CenteredStroke = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`, SvgFilledOutline = (t0) => {
  const $ = c(8), {
    daysLeft,
    totalDays
  } = t0, progress = totalDays - daysLeft, percentage = Math.round(progress / totalDays * 100), strokeDasharray = 2 * Math.PI * 10, strokeDashOffset = strokeDasharray * ((100 - percentage) / 100);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    transform: "rotate(-90deg)"
  }, $[0] = t1) : t1 = $[0];
  const t2 = percentage > 75 ? yellow[600].hex : purple[400].hex;
  let t3;
  $[1] !== t2 ? (t3 = /* @__PURE__ */ jsx("circle", { r: 10, cx: 10.6, cy: 10.6, fill: "transparent", strokeWidth: 1.2, stroke: t2 }), $[1] = t2, $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== strokeDashOffset ? (t4 = /* @__PURE__ */ jsx("circle", { r: 10, cx: 10.6, cy: 10.6, fill: "transparent", strokeWidth: 1.2, stroke: "var(--card-border-color)", strokeDasharray, strokeDashoffset: strokeDashOffset }), $[3] = strokeDashOffset, $[4] = t4) : t4 = $[4];
  let t5;
  return $[5] !== t3 || $[6] !== t4 ? (t5 = /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(CenteredStroke, { children: /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21.2, height: 21.2, viewBox: "0 0 21.2 21.2", style: t1, children: [
    t3,
    t4
  ] }) }) }), $[5] = t3, $[6] = t4, $[7] = t5) : t5 = $[7], t5;
}, FreeTrialButtonTopbar = forwardRef(function(t0, ref) {
  const $ = c(14), {
    toggleShowContent,
    daysLeft,
    totalDays
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== daysLeft || $[1] !== t ? (t1 = daysLeft ? t("free-trial.tooltip.days-count", {
    count: daysLeft
  }) : t("free-trial.tooltip.trial-finished"), $[0] = daysLeft, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = {
    content: t1
  }, $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 0, children: /* @__PURE__ */ jsx(BoltIcon, {}) }), $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== daysLeft || $[7] !== totalDays ? (t4 = daysLeft > 0 && /* @__PURE__ */ jsx(SvgFilledOutline, { daysLeft, totalDays }), $[6] = daysLeft, $[7] = totalDays, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== ref || $[10] !== t2 || $[11] !== t4 || $[12] !== toggleShowContent ? (t5 = /* @__PURE__ */ jsxs(Button, { mode: "bleed", onClick: toggleShowContent, ref, tooltipProps: t2, children: [
    t3,
    t4
  ] }), $[9] = ref, $[10] = t2, $[11] = t4, $[12] = toggleShowContent, $[13] = t5) : t5 = $[13], t5;
}), FreeTrialButtonSidebar = forwardRef(function(t0, ref) {
  const $ = c(7), {
    toggleShowContent,
    daysLeft
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== daysLeft || $[1] !== t ? (t1 = daysLeft ? t("user-menu.action.free-trial", {
    count: daysLeft
  }) : t("user-menu.action.free-trial-finished"), $[0] = daysLeft, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== ref || $[4] !== t1 || $[5] !== toggleShowContent ? (t2 = /* @__PURE__ */ jsx(Button, { ref, icon: BoltIcon, justify: "flex-start", mode: "bleed", size: "large", onClick: toggleShowContent, text: t1 }), $[3] = ref, $[4] = t1, $[5] = toggleShowContent, $[6] = t2) : t2 = $[6], t2;
}), useFreeTrialContext = () => {
  const context = useContext(FreeTrialContext);
  if (!context)
    throw new Error("useFreeTrial must be used within a FreeTrialProvider");
  return context;
}, Image$1 = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  height: 180px;
`;
function PopoverContent(t0) {
  const $ = c(26), {
    content,
    handleClose,
    handleOpenNext
  } = t0;
  let t1;
  $[0] !== content.image ? (t1 = content.image && /* @__PURE__ */ jsx(Image$1, { src: content.image.asset.url, alt: content.image.asset.altText ?? "" }), $[0] = content.image, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== content.headingText ? (t2 = /* @__PURE__ */ jsx(Box, { paddingX: 2, marginTop: 3, children: /* @__PURE__ */ jsx(Heading, { size: 1, children: content.headingText }) }), $[2] = content.headingText, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== content.descriptionText ? (t3 = /* @__PURE__ */ jsx(Box, { marginTop: 4, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: content.descriptionText }) }), $[4] = content.descriptionText, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { padding: 3, direction: "column", children: [
    t2,
    t3
  ] }), $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== content.secondaryButton || $[10] !== handleClose ? (t5 = content.secondaryButton?.text && /* @__PURE__ */ jsx(Button, { mode: "bleed", text: content.secondaryButton.text, tone: "default", onClick: () => handleClose("xClick") }), $[9] = content.secondaryButton, $[10] = handleClose, $[11] = t5) : t5 = $[11];
  const t6 = content.ctaButton?.text;
  let t7;
  $[12] !== content.ctaButton || $[13] !== handleClose || $[14] !== handleOpenNext ? (t7 = content.ctaButton?.action === "openUrl" ? {
    href: content.ctaButton.url,
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a"
  } : {
    onClick: content.ctaButton?.action === "openNext" ? handleOpenNext : () => handleClose("ctaClicked")
  }, $[12] = content.ctaButton, $[13] = handleClose, $[14] = handleOpenNext, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { mode: "default", tooltipProps: null, text: t6, autoFocus: !0, tone: "primary", ...t7 }), $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t5 || $[20] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { width: "full", gap: 3, justify: "flex-end", padding: 3, children: [
    t5,
    t8
  ] }), $[19] = t5, $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  return $[22] !== t1 || $[23] !== t4 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { radius: 3, overflow: "hidden", width: 0, children: /* @__PURE__ */ jsxs(Container$2, { width: 0, children: [
    t1,
    t4,
    t9
  ] }) }), $[22] = t1, $[23] = t4, $[24] = t9, $[25] = t10) : t10 = $[25], t10;
}
function FreeTrial({
  type
}) {
  const {
    data,
    showDialog,
    showOnLoad,
    toggleShowContent
  } = useFreeTrialContext(), scheme = useColorSchemeValue(), telemetry = useTelemetry(), [ref, setRef] = useState(null), [showPopover, setShowPopover] = useState(!1);
  useEffect(() => {
    ref && setShowPopover(!0);
  }, [ref]);
  const closeAndReOpen = useCallback(() => toggleShowContent(!0), [toggleShowContent]), toggleDialog = useCallback(() => {
    ref?.focus(), toggleShowContent(!1);
  }, [toggleShowContent, ref]), handleClose = useCallback((dialogType) => (action) => {
    const dialog = data?.showOnLoad || data?.showOnClick;
    dialog && telemetry.log(TrialDialogDismissed, {
      dialogId: dialog.id,
      dialogRevision: dialog._rev,
      dialogType,
      source: "studio",
      trialDaysLeft: data.daysLeft,
      dialogTrialStage: getTrialStage({
        showOnLoad,
        dialogId: dialog.id
      }),
      dialogDismissAction: action
    }), toggleDialog();
  }, [data, toggleDialog, showOnLoad, telemetry]), handleDialogCTAClick = useCallback((action_0) => () => {
    const dialog_0 = data?.showOnLoad || data?.showOnClick;
    dialog_0 && telemetry.log(TrialDialogCTAClicked, {
      dialogId: dialog_0.id,
      dialogRevision: dialog_0._rev,
      dialogType: "modal",
      source: "studio",
      trialDaysLeft: data.daysLeft,
      dialogTrialStage: getTrialStage({
        showOnLoad,
        dialogId: dialog_0.id
      }),
      dialogCtaType: action_0 === "openURL" ? "upgrade" : "learnMore"
    }), closeAndReOpen();
  }, [data, closeAndReOpen, telemetry, showOnLoad]), handlePopoverCTAClick = useCallback(() => {
    data?.showOnLoad && telemetry.log(TrialDialogCTAClicked, {
      dialogId: data.showOnLoad.id,
      dialogRevision: data.showOnLoad._rev,
      dialogType: "popover",
      source: "studio",
      trialDaysLeft: data.daysLeft,
      dialogTrialStage: getTrialStage({
        showOnLoad: !0,
        dialogId: data.showOnLoad.id
      }),
      dialogCtaType: "learnMore"
    }), closeAndReOpen();
  }, [data?.showOnLoad, data?.daysLeft, closeAndReOpen, telemetry]), handleOnTrialButtonClick = useCallback(() => {
    data?.showOnClick && telemetry.log(TrialDialogViewed, {
      dialogId: data.showOnClick.id,
      dialogRevision: data.showOnClick._rev,
      dialogTrigger: "fromClick",
      dialogType: "modal",
      source: "studio",
      trialDaysLeft: data.daysLeft,
      dialogTrialStage: getTrialStage({
        showOnLoad: !0,
        dialogId: data.showOnClick.id
      })
    }), closeAndReOpen();
  }, [data?.showOnClick, data?.daysLeft, telemetry, closeAndReOpen]);
  if (!data?.id) return null;
  const dialogToRender = showOnLoad ? data.showOnLoad : data.showOnClick;
  if (!dialogToRender) return null;
  const button = type === "sidebar" ? /* @__PURE__ */ jsx(FreeTrialButtonSidebar, { toggleShowContent: handleOnTrialButtonClick, daysLeft: data.daysLeft, ref: setRef }) : /* @__PURE__ */ jsx(FreeTrialButtonTopbar, { toggleShowContent: handleOnTrialButtonClick, daysLeft: data.daysLeft, totalDays: data.totalDays, ref: setRef });
  return dialogToRender?.dialogType === "popover" ? /* @__PURE__ */ jsx(Popover, { open: showDialog && showPopover, size: 0, scheme, radius: 3, tone: "default", portal: !0, placement: type === "sidebar" ? "top" : "bottom-end", content: /* @__PURE__ */ jsx(PopoverContent, { content: dialogToRender, handleClose: handleClose("popover"), handleOpenNext: handlePopoverCTAClick }), children: button }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    button,
    /* @__PURE__ */ jsx(DialogContent, { content: dialogToRender, onClose: handleClose("modal"), onOpenNext: handleDialogCTAClick("openNext"), onOpenUrlCallback: handleDialogCTAClick("openURL"), open: showDialog })
  ] });
}
const FreeTrialProvider = ({
  children
}) => {
  const router = useRouter(), [data, setData] = useState(null), [showDialog, setShowDialog] = useState(!1), [showOnLoad, setShowOnLoad] = useState(!1), client = useClient({
    apiVersion: "2023-12-11"
  }), telemetry = useTelemetry();
  useEffect(() => {
    const dialog = data?.showOnLoad;
    showDialog && showOnLoad && dialog && telemetry.log(TrialDialogViewed, {
      dialogId: dialog.id,
      dialogRevision: dialog._rev,
      dialogTrialStage: getTrialStage({
        showOnLoad,
        dialogId: dialog.id
      }),
      dialogTrigger: showOnLoad ? "auto" : "fromClick",
      dialogType: dialog.dialogType,
      source: "studio",
      trialDaysLeft: data.daysLeft
    });
  }, [showDialog, data, showOnLoad, telemetry]);
  const searchParams = new URLSearchParams(router.state._searchParams), trialState = searchParams.get("trialState"), seenBefore = searchParams.get("seenBefore");
  useEffect(() => {
    const queryParams = new URLSearchParams();
    queryParams.append("studioVersion", SANITY_VERSION), trialState && queryParams.append("trialState", trialState), seenBefore && queryParams.append("seenBefore", seenBefore);
    const queryURL = queryParams.get("trialState") ? "/journey/trial/override" : "/journey/trial", request = client.observable.request({
      url: `${queryURL}?${queryParams.toString()}`
    }).subscribe((response) => {
      setData(response), response?.showOnLoad && (setShowOnLoad(!0), setShowDialog(!0));
    }, () => {
    });
    return () => {
      request.unsubscribe();
    };
  }, [client, seenBefore, trialState]);
  const toggleShowContent = useCallback((closeAndReOpen = !1) => {
    showOnLoad ? (setShowOnLoad(!1), setShowDialog(closeAndReOpen), data?.showOnLoad?.id && client.request({
      url: `/journey/trial/${data?.showOnLoad.id}`,
      method: "POST"
    })) : setShowDialog((p) => !p);
  }, [client, showOnLoad, data?.showOnLoad?.id]), value = useMemo(() => ({
    data,
    showDialog,
    toggleShowContent,
    showOnLoad
  }), [data, showDialog, showOnLoad, toggleShowContent]);
  return /* @__PURE__ */ jsx(FreeTrialContext.Provider, { value, children });
}, LOGO_MARK_SIZE = 25, RADIUS = 2, LogoMarkContainer = styled(Card).attrs({
  overflow: "hidden",
  radius: RADIUS
})`
  height: ${LOGO_MARK_SIZE}px;
  width: ${LOGO_MARK_SIZE}px;
`, StyledCard$1 = styled(Card)`
  border-radius: ${({
  theme
}) => rem(theme.sanity.radius[RADIUS])};
  display: flex;
  outline: none;
  text-decoration: none;
  &:focus-visible {
    box-shadow: ${({
  theme
}) => focusRingStyle$1({
  base: theme.sanity.color.base,
  focusRing: {
    ...theme.sanity.focusRing,
    offset: 1
  }
})};
  }
`;
function HomeButton() {
  const $ = c(12), workspaces = useWorkspaces(), {
    activeWorkspace
  } = useActiveWorkspace();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    state: {}
  }, $[0] = t0) : t0 = $[0];
  const {
    href: rootHref,
    onClick: handleRootClick
  } = useStateLink(t0), multipleWorkspaces = workspaces.length > 1;
  let t1, t2;
  $[1] !== activeWorkspace || $[2] !== multipleWorkspaces ? (t1 = /* @__PURE__ */ jsx(LogoMarkContainer, { children: /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: multipleWorkspaces || activeWorkspace.customIcon ? /* @__PURE__ */ jsx(WorkspacePreviewIcon, { icon: activeWorkspace.icon, size: "small" }) : /* @__PURE__ */ jsx(SanityMonogram, { width: "100%", height: "100%" }) }) }), t2 = !multipleWorkspaces && /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: activeWorkspace.title }) }), $[1] = activeWorkspace, $[2] = multipleWorkspaces, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]);
  let t3;
  $[5] !== t1 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
    t1,
    t2
  ] }), $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  return $[8] !== handleRootClick || $[9] !== rootHref || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(StyledCard$1, { as: "a", href: rootHref, onClick: handleRootClick, children: t3 }), $[8] = handleRootClick, $[9] = rootHref, $[10] = t3, $[11] = t4) : t4 = $[11], t4;
}
function AppearanceMenu$1(t0) {
  const $ = c(4), {
    setScheme
  } = t0, {
    t
  } = useTranslation(), options = useColorSchemeOptions(setScheme, t);
  let t1;
  $[0] !== options ? (t1 = options.map(_temp$j), $[0] = options, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Card, { borderTop: !0, flex: "none", padding: 2, overflow: "auto", children: /* @__PURE__ */ jsx(Stack, { as: "ul", space: 1, children: t1 }) }), $[2] = t1, $[3] = t2) : t2 = $[3], t2;
}
function _temp$j(t0) {
  const {
    icon,
    label,
    name,
    onSelect,
    selected,
    title
  } = t0;
  return /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(Button, { "aria-label": label, icon, iconRight: selected && /* @__PURE__ */ jsx(CheckmarkIcon, {}), justify: "flex-start", mode: "bleed", onClick: onSelect, selected, size: "large", text: title }) }, name);
}
function LocaleMenu$1() {
  return c(9), useLocale(), null;
}
function ManageMenu$1() {
  const $ = c(18), {
    currentUser,
    projectId
  } = useWorkspace();
  let t0;
  $[0] !== currentUser ? (t0 = currentUser && userHasRole(currentUser, "administrator"), $[0] = currentUser, $[1] = t0) : t0 = $[1];
  const isAdmin = !!t0, {
    t
  } = useTranslation();
  let t1;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(FreeTrial, { type: "sidebar" }) }), $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t ? (t2 = t("user-menu.action.manage-project-aria-label"), $[3] = t, $[4] = t2) : t2 = $[4];
  const t3 = `https://sanity.io/manage/project/${projectId}`;
  let t4;
  $[5] !== t ? (t4 = t("user-menu.action.manage-project"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t2 || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(Button, { "aria-label": t2, as: "a", href: t3, icon: CogIcon, justify: "flex-start", mode: "bleed", size: "large", target: "_blank", text: t4 }) }), $[7] = t2, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== isAdmin || $[12] !== projectId || $[13] !== t ? (t6 = isAdmin && /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(Button, { "aria-label": t("user-menu.action.invite-members-aria-label"), as: "a", href: `https://www.sanity.io/manage/project/${projectId}/members?invite=true`, icon: AddUserIcon, justify: "flex-start", mode: "bleed", size: "large", target: "_blank", text: t("user-menu.action.invite-members") }) }), $[11] = isAdmin, $[12] = projectId, $[13] = t, $[14] = t6) : t6 = $[14];
  let t7;
  return $[15] !== t5 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsx(Card, { borderTop: !0, flex: "none", padding: 2, children: /* @__PURE__ */ jsxs(Stack, { as: "ul", space: 1, children: [
    t1,
    t5,
    t6
  ] }) }), $[15] = t5, $[16] = t6, $[17] = t7) : t7 = $[17], t7;
}
const ANIMATION_TRANSITION = {
  bounce: 0,
  damping: 20,
  mass: 0.5,
  stiffness: 200,
  type: "spring"
}, BACKDROP_VARIANTS = {
  open: {
    opacity: 1
  },
  closed: {
    opacity: 0
  }
}, INNER_CARD_VARIANTS = {
  open: {
    x: "0%"
  },
  closed: {
    x: "-100%"
  }
}, Root$a = styled(Layer)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`, BackdropMotion = styled(motion.create(Card))`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--card-shadow-penumbra-color);
`, InnerCardMotion = styled(motion.create(Card))`
  position: relative;
  pointer-events: all;
  flex-direction: column;
  height: 100%;
  min-width: 200px;
  max-width: 280px;
  overflow: auto;
`, NavDrawer = memo(function(props2) {
  const $ = c(23), {
    __internal_actions: actions,
    activeToolName,
    isOpen,
    onClose,
    tools
  } = props2, setScheme = useColorSchemeSetValue(), {
    auth,
    currentUser
  } = useWorkspace(), workspaces = useWorkspaces(), ToolMenu = useToolMenuComponent(), {
    t
  } = useTranslation();
  let t0;
  $[0] !== onClose ? (t0 = (event) => {
    event.key === "Escape" && onClose();
  }, $[0] = onClose, $[1] = t0) : t0 = $[1];
  const handleKeyDown = t0;
  let t1;
  $[2] !== onClose ? (t1 = (action) => {
    action?.(), onClose();
  }, $[2] = onClose, $[3] = t1) : t1 = $[3];
  const handleActionClick = t1;
  let t2, t3;
  $[4] !== actions || $[5] !== handleActionClick ? (t3 = actions?.filter(_temp$i)?.map((action_0) => {
    const {
      render: ActionComponent
    } = action_0;
    return ActionComponent ? /* @__PURE__ */ jsx(ActionComponent, {}, action_0.name) : /* @__PURE__ */ jsx(Button, { icon: action_0?.icon, justify: "flex-start", mode: "bleed", onClick: () => handleActionClick(action_0.onAction), selected: action_0.selected, size: "large", text: action_0.title, width: "fill" }, action_0.name);
  }), $[4] = actions, $[5] = handleActionClick, $[6] = t3) : t3 = $[6], t2 = t3;
  const actionNodes = t2;
  let t4;
  $[7] !== ToolMenu || $[8] !== actionNodes || $[9] !== activeToolName || $[10] !== auth || $[11] !== currentUser?.email || $[12] !== currentUser?.name || $[13] !== handleKeyDown || $[14] !== isOpen || $[15] !== onClose || $[16] !== setScheme || $[17] !== t || $[18] !== tools || $[19] !== workspaces ? (t4 = isOpen && /* @__PURE__ */ jsx(FocusLock, { returnFocus: !0, children: /* @__PURE__ */ jsxs(Root$a, { onKeyDown: handleKeyDown, children: [
    /* @__PURE__ */ jsx(BackdropMotion, { animate: "open", "data-open": isOpen, exit: "closed", initial: "closed", onClick: onClose, transition: ANIMATION_TRANSITION, variants: BACKDROP_VARIANTS }),
    /* @__PURE__ */ jsxs(InnerCardMotion, { animate: "open", "data-open": isOpen, display: "flex", exit: "closed", height: "fill", initial: "closed", shadow: 1, transition: ANIMATION_TRANSITION, variants: INNER_CARD_VARIANTS, children: [
      /* @__PURE__ */ jsx(Card, { borderBottom: !0, children: /* @__PURE__ */ jsxs(Stack, { space: 3, padding: 3, children: [
        /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
          /* @__PURE__ */ jsx(Flex, { flex: 1, align: "center", paddingRight: 2, children: /* @__PURE__ */ jsx(CapabilityGate, { capability: "globalUserMenu", children: /* @__PURE__ */ jsxs(Flex, { flex: 1, align: "center", children: [
            /* @__PURE__ */ jsx(UserAvatar, { size: 1, user: "me" }),
            /* @__PURE__ */ jsx(Box, { flex: 1, marginLeft: 3, title: currentUser?.name || currentUser?.email, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: currentUser?.name || currentUser?.email }) })
          ] }) }) }),
          /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: onClose, tooltipProps: {
            content: t("user-menu.close-menu")
          } })
        ] }),
        workspaces.length > 1 && /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 1, children: [
          /* @__PURE__ */ jsx(HomeButton, {}),
          /* @__PURE__ */ jsx(WorkspaceMenuButton, {})
        ] })
      ] }) }),
      /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, justify: "space-between", overflow: "auto", children: [
        /* @__PURE__ */ jsx(Card, { flex: "none", padding: 2, children: /* @__PURE__ */ jsx(ToolMenu, { activeToolName, closeSidebar: onClose, context: "sidebar", isSidebarOpen: isOpen, tools }) }),
        /* @__PURE__ */ jsxs(Flex, { direction: "column", children: [
          actionNodes && /* @__PURE__ */ jsx(Card, { flex: "none", padding: 2, children: /* @__PURE__ */ jsx(Stack, { space: 1, children: actionNodes }) }),
          setScheme && /* @__PURE__ */ jsx(AppearanceMenu$1, { setScheme }),
          /* @__PURE__ */ jsx(LocaleMenu$1, {}),
          /* @__PURE__ */ jsx(ManageMenu$1, {})
        ] })
      ] }),
      auth.logout && /* @__PURE__ */ jsx(Card, { flex: "none", padding: 2, borderTop: !0, children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Button, { iconRight: LeaveIcon, justify: "flex-start", mode: "bleed", onClick: auth.logout, size: "large", text: t("user-menu.action.sign-out") }) }) })
    ] })
  ] }) }), $[7] = ToolMenu, $[8] = actionNodes, $[9] = activeToolName, $[10] = auth, $[11] = currentUser?.email, $[12] = currentUser?.name, $[13] = handleKeyDown, $[14] = isOpen, $[15] = onClose, $[16] = setScheme, $[17] = t, $[18] = tools, $[19] = workspaces, $[20] = t4) : t4 = $[20];
  let t5;
  return $[21] !== t4 ? (t5 = /* @__PURE__ */ jsx(AnimatePresence, { children: t4 }), $[21] = t4, $[22] = t5) : t5 = $[22], t5;
});
function _temp$i(v) {
  return v.location === "sidebar";
}
function isQueryMatch(query, option) {
  const lowercaseTitle = option.title.toLowerCase();
  return query.trim().toLowerCase().split(/[\s\-_]+/).every((word) => lowercaseTitle.includes(word));
}
function sortResultRelevance(query, a, b) {
  const titleA = a.title.toLowerCase(), titleB = b.title.toLowerCase(), lowercaseQuery = query.trim().toLowerCase();
  return titleA.startsWith(lowercaseQuery) && !titleB.startsWith(lowercaseQuery) ? -1 : titleB.startsWith(lowercaseQuery) && !titleA.startsWith(lowercaseQuery) ? 1 : titleA.includes(lowercaseQuery) && !titleB.includes(lowercaseQuery) ? -1 : titleB.includes(lowercaseQuery) && !titleA.includes(lowercaseQuery) ? 1 : 0;
}
function filterOptions(options, query, getI18nText) {
  return options.map((option) => ({
    ...option,
    title: getI18nText({
      ...option,
      title: option?.title || option.id
    }).title
  })).sort((a, b) => a.title.localeCompare(b.title)).filter((option) => isQueryMatch(query, option)).sort((a, b) => sortResultRelevance(query, a, b));
}
const StyledPopover$3 = styled(Popover)(() => css`
    [data-ui='Popover__wrapper'] {
      width: 320px;
      display: flex;
      flex-direction: column;
      border-radius: ${({
  theme
}) => theme.sanity.radius[3]}px;
      position: relative;
      overflow: hidden;
      overflow: clip;
    }
  `), StyledDialog = styled(Dialog$1)(() => css`
    [data-ui='DialogCard'] {
      justify-content: flex-start;
    }
  `), RootFlex = styled(Flex)``, PopoverHeaderCard = styled(Card)`
  min-height: max-content;
`, DialogHeaderCard = styled(Card)`
  min-height: max-content;
`, PopoverListFlex = styled(Flex)((props2) => {
  const {
    $maxDisplayedItems,
    $itemHeight
  } = props2;
  return css`
    --item-height: ${$itemHeight}px;
    --max-items: ${$maxDisplayedItems};
    --list-padding: 0.5rem;

    position: relative;
    max-height: calc(var(--item-height) * var(--max-items) + var(--list-padding));
    min-height: calc((var(--item-height) * 1));
  `;
}), INLINE_PREVIEW_HEIGHT = 33;
function NewDocumentListOption(props2) {
  const $ = c(28), {
    option,
    currentUser,
    onClick: onClick2,
    preview
  } = props2, {
    selectedReleaseId
  } = usePerspective();
  let t0, t1;
  $[0] !== option.schemaType || $[1] !== option.templateId || $[2] !== selectedReleaseId ? (t1 = {
    template: option.templateId,
    type: option.schemaType,
    version: selectedReleaseId
  }, $[0] = option.schemaType, $[1] = option.templateId, $[2] = selectedReleaseId, $[3] = t1) : t1 = $[3], t0 = t1;
  const params = t0;
  let t2;
  $[4] !== params ? (t2 = {
    intent: "create",
    params
  }, $[4] = params, $[5] = t2) : t2 = $[5];
  const {
    onClick: onIntentClick,
    href
  } = useIntentLink(t2);
  let t3;
  $[6] !== onClick2 || $[7] !== onIntentClick || $[8] !== option ? (t3 = (event) => {
    onIntentClick(event), onClick2(option);
  }, $[6] = onClick2, $[7] = onIntentClick, $[8] = option, $[9] = t3) : t3 = $[9];
  const handleDocumentClick = t3, {
    title
  } = useI18nText(option);
  let t4;
  $[10] !== currentUser ? (t4 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "create-document" }), $[10] = currentUser, $[11] = t4) : t4 = $[11];
  const t5 = option.hasPermission ? "a" : "button", t6 = `create-new-${option.templateId}`, t7 = !option.hasPermission, t8 = preview === "inline" ? 3 : 4, t9 = preview === "inline" ? 1 : void 0;
  let t10;
  $[12] !== t9 || $[13] !== title ? (t10 = /* @__PURE__ */ jsx(Text$1, { size: t9, children: title }), $[12] = t9, $[13] = title, $[14] = t10) : t10 = $[14];
  let t11;
  $[15] !== handleDocumentClick || $[16] !== href || $[17] !== t10 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 ? (t11 = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Card, { as: t5, "data-testid": t6, disabled: t7, href, marginBottom: 1, onClick: handleDocumentClick, padding: t8, radius: 2, children: t10 }) }), $[15] = handleDocumentClick, $[16] = href, $[17] = t10, $[18] = t5, $[19] = t6, $[20] = t7, $[21] = t8, $[22] = t11) : t11 = $[22];
  let t12;
  return $[23] !== option.hasPermission || $[24] !== option.id || $[25] !== t11 || $[26] !== t4 ? (t12 = /* @__PURE__ */ jsx(Tooltip, { disabled: option.hasPermission, portal: !0, content: t4, children: t11 }, option.id), $[23] = option.hasPermission, $[24] = option.id, $[25] = t11, $[26] = t4, $[27] = t12) : t12 = $[27], t12;
}
const ContentFlex = styled(Flex)`
  min-height: 100px;
`;
function NewDocumentList(props2) {
  const $ = c(27), {
    currentUser,
    loading,
    onDocumentClick,
    options,
    preview,
    searchQuery,
    textInputElement
  } = props2, {
    t
  } = useTranslation(), hasOptions = options.length > 0 && !loading;
  let t0;
  $[0] !== onDocumentClick ? (t0 = () => {
    onDocumentClick();
  }, $[0] = onDocumentClick, $[1] = t0) : t0 = $[1];
  const handleDocumentClick = t0;
  let t1;
  $[2] !== options ? (t1 = (index) => options[index]?.hasPermission === !1, $[2] = options, $[3] = t1) : t1 = $[3];
  const getItemDisabled = t1;
  let t2;
  $[4] !== currentUser || $[5] !== handleDocumentClick || $[6] !== preview ? (t2 = (item) => /* @__PURE__ */ jsx(NewDocumentListOption, { currentUser, onClick: handleDocumentClick, option: item, preview }, item.id), $[4] = currentUser, $[5] = handleDocumentClick, $[6] = preview, $[7] = t2) : t2 = $[7];
  const renderItem2 = t2;
  if (loading) {
    let t32;
    return $[8] === Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[8] = t32) : t32 = $[8], t32;
  }
  if (!hasOptions && searchQuery) {
    let t32;
    $[9] !== searchQuery ? (t32 = {
      searchQuery
    }, $[9] = searchQuery, $[10] = t32) : t32 = $[10];
    let t42;
    return $[11] !== t || $[12] !== t32 ? (t42 = /* @__PURE__ */ jsx(ContentFlex, { align: "center", flex: 1, height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "new-document.no-results", values: t32 }) }) }), $[11] = t, $[12] = t32, $[13] = t42) : t42 = $[13], t42;
  }
  if (!hasOptions) {
    let t32;
    $[14] !== t ? (t32 = t("new-document.no-document-types-found"), $[14] = t, $[15] = t32) : t32 = $[15];
    let t42;
    return $[16] !== t32 ? (t42 = /* @__PURE__ */ jsx(ContentFlex, { align: "center", flex: 1, height: "fill", justify: "center", padding: 4, sizing: "border", children: /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: t32 }) }), $[16] = t32, $[17] = t42) : t42 = $[17], t42;
  }
  let t3;
  $[18] !== t ? (t3 = t("new-document.new-document"), $[18] = t, $[19] = t3) : t3 = $[19];
  const t4 = preview === "inline" ? 1 : 2;
  let t5;
  return $[20] !== getItemDisabled || $[21] !== options || $[22] !== renderItem2 || $[23] !== t3 || $[24] !== t4 || $[25] !== textInputElement ? (t5 = /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t3, autoFocus: supportsTouch ? void 0 : "input", getItemDisabled, inputElement: textInputElement, itemHeight: INLINE_PREVIEW_HEIGHT, items: options, overscan: 5, padding: t4, paddingBottom: 0, renderItem: renderItem2 }), $[20] = getItemDisabled, $[21] = options, $[22] = renderItem2, $[23] = t3, $[24] = t4, $[25] = textInputElement, $[26] = t5) : t5 = $[26], t5;
}
const MAX_DISPLAYED_ITEMS = 10;
function NewDocumentButton(props2) {
  const {
    canCreateDocument,
    modal = "popover",
    loading,
    options
  } = props2, isReleaseActive = useIsReleaseActive(), {
    selectedPerspective
  } = usePerspective(), [open, setOpen] = useState(!1), [searchQuery, setSearchQuery] = useState(""), popoverRef = useRef(null), dialogRef = useRef(null), [buttonElement, setButtonElement] = useState(null), [searchInputElement, setSearchInputElement] = useState(null), {
    t
  } = useTranslation(), getI18nText = useGetI18nText(options), scheme = useColorSchemeValue(), currentUser = useCurrentUser(), schema2 = useSchema(), hasNewDocumentOptions = options.length > 0, disabled = !canCreateDocument || !hasNewDocumentOptions || !isReleaseActive, placeholder = t("new-document.filter-placeholder"), title = t("new-document.title"), openDialogAriaLabel = t("new-document.open-dialog-aria-label"), validOptions = useMemo(() => options.filter((option) => {
    const optionSchema = schema2.get(option.schemaType);
    return optionSchema && !isDeprecatedSchemaType(optionSchema);
  }), [options, schema2]), filteredOptions = useMemo(() => filterOptions(validOptions, searchQuery, getI18nText), [validOptions, searchQuery, getI18nText]), handleSearchChange = useCallback((event) => {
    setSearchQuery(event.currentTarget.value);
  }, []), handleToggleOpen = useCallback(() => setOpen((v) => !v), []), handleClose = useCallback(() => {
    setOpen(!1), setSearchQuery(""), buttonElement?.focus();
  }, [buttonElement]), handleOpenButtonKeyDown = useCallback((e) => {
    e.key === "ArrowDown" && !open && setOpen(!0);
  }, [open]), handlePopoverKeyDown = useCallback((e_0) => {
    (e_0.key === "Escape" || e_0.key === "Tab") && open && handleClose();
  }, [handleClose, open]);
  useClickOutsideEvent(open && handleClose, () => [buttonElement, dialogRef.current, popoverRef.current]);
  const sharedListProps = useMemo(() => ({
    currentUser,
    loading,
    onDocumentClick: handleToggleOpen,
    options: filteredOptions,
    searchQuery,
    preview: modal === "popover" ? "inline" : "default",
    textInputElement: searchInputElement
  }), [currentUser, filteredOptions, handleToggleOpen, loading, modal, searchInputElement, searchQuery]), sharedTextInputProps = useMemo(() => ({
    __unstable_disableFocusRing: !0,
    border: !1,
    "data-testid": "new-document-button-search-input",
    defaultValue: searchQuery,
    disabled: loading,
    icon: SearchIcon,
    onChange: handleSearchChange,
    placeholder,
    ref: setSearchInputElement
  }), [handleSearchChange, loading, placeholder, searchQuery]), sharedOpenButtonProps = useMemo(() => ({
    "aria-label": openDialogAriaLabel,
    "data-testid": "new-document-button",
    disabled: disabled || loading,
    icon: AddIcon,
    text: "",
    mode: "bleed",
    onClick: handleToggleOpen,
    ref: setButtonElement,
    selected: open
  }), [disabled, handleToggleOpen, loading, open, openDialogAriaLabel]), tooltipContent = useMemo(() => {
    if (!isReleaseActive) {
      const tooltipText = isPublishedPerspective(selectedPerspective) ? t("new-document.disabled-published.tooltip") : t("new-document.disabled-release.tooltip");
      return /* @__PURE__ */ jsx(Text$1, { size: 1, children: tooltipText });
    }
    return hasNewDocumentOptions ? canCreateDocument ? /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("new-document.create-new-document-label") }) : /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { currentUser, context: "create-any-document" }) : /* @__PURE__ */ jsx(Text$1, { size: 1, children: t("new-document.no-document-types-label") });
  }, [canCreateDocument, currentUser, hasNewDocumentOptions, isReleaseActive, selectedPerspective, t]), sharedTooltipProps = useMemo(() => ({
    content: tooltipContent,
    disabled: loading || open,
    scheme
  }), [loading, open, scheme, tooltipContent]);
  return modal === "dialog" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Tooltip, { ...sharedTooltipProps, children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { ...sharedOpenButtonProps }) }) }),
    open && /* @__PURE__ */ jsx(StyledDialog, { header: title, id: "create-new-document-dialog", onClickOutside: handleClose, onClose: handleClose, ref: dialogRef, scheme, width: 1, children: /* @__PURE__ */ jsxs(RootFlex, { direction: "column", flex: 1, height: "fill", children: [
      /* @__PURE__ */ jsx(DialogHeaderCard, { padding: 2, borderBottom: !0, children: /* @__PURE__ */ jsx(TextInput$1, { "data-testid": "new-document-button-search-input", ...sharedTextInputProps }) }),
      /* @__PURE__ */ jsx(Flex, { direction: "column", overflow: "hidden", children: /* @__PURE__ */ jsx(NewDocumentList, { ...sharedListProps }) })
    ] }) })
  ] }) : /* @__PURE__ */ jsx(StyledPopover$3, { constrainSize: !0, onKeyDown: handlePopoverKeyDown, open, tone: "default", portal: !0, radius: 3, ref: popoverRef, scheme, content: /* @__PURE__ */ jsxs(RootFlex, { direction: "column", flex: 1, forwardedAs: FocusLock, height: "fill", returnFocus: !0, children: [
    /* @__PURE__ */ jsx(PopoverHeaderCard, { sizing: "border", children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Card, { borderBottom: !0, padding: 1, children: /* @__PURE__ */ jsx(TextInput$1, { ...sharedTextInputProps, fontSize: 1, radius: 1 }) }) }) }),
    /* @__PURE__ */ jsx(PopoverListFlex, { $itemHeight: INLINE_PREVIEW_HEIGHT, $maxDisplayedItems: MAX_DISPLAYED_ITEMS, direction: "column", overflow: "hidden", children: /* @__PURE__ */ jsx(NewDocumentList, { ...sharedListProps }) })
  ] }), children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Tooltip, { ...sharedTooltipProps, children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { ...sharedOpenButtonProps, "aria-expanded": open, "aria-haspopup": "true", onKeyDown: handleOpenButtonKeyDown }) }) }) }) });
}
function useNewDocumentOptions() {
  const $ = c(14), {
    __internal: t0
  } = useSource(), {
    staticInitialValueTemplateItems
  } = t0;
  let t1;
  $[0] !== staticInitialValueTemplateItems ? (t1 = {
    templateItems: staticInitialValueTemplateItems
  }, $[0] = staticInitialValueTemplateItems, $[1] = t1) : t1 = $[1];
  const [permissions, loading] = useTemplatePermissions(t1);
  let t2;
  $[2] !== permissions || $[3] !== staticInitialValueTemplateItems ? (t2 = permissions?.some((p) => staticInitialValueTemplateItems.some((t) => t.id === p.id)) || !1, $[2] = permissions, $[3] = staticInitialValueTemplateItems, $[4] = t2) : t2 = $[4];
  const canCreateDocument = t2;
  let t3, t4;
  if ($[5] !== permissions || $[6] !== staticInitialValueTemplateItems) {
    let t52;
    $[8] !== permissions ? (t52 = (item) => ({
      ...item,
      title: item?.title || item.id,
      hasPermission: permissions?.find((p_0) => p_0.id === item.id)?.granted || !1
    }), $[8] = permissions, $[9] = t52) : t52 = $[9], t4 = staticInitialValueTemplateItems.map(t52), $[5] = permissions, $[6] = staticInitialValueTemplateItems, $[7] = t4;
  } else
    t4 = $[7];
  t3 = t4;
  const optionsWithPermissions = t3;
  let t5;
  return $[10] !== canCreateDocument || $[11] !== loading || $[12] !== optionsWithPermissions ? (t5 = {
    canCreateDocument,
    loading,
    options: optionsWithPermissions
  }, $[10] = canCreateDocument, $[11] = loading, $[12] = optionsWithPermissions, $[13] = t5) : t5 = $[13], t5;
}
const PresenceMenuItem = memo(function(props2) {
  const $ = c(35), {
    locations,
    user,
    focused,
    onFocus
  } = props2, [menuItemElement, setMenuItemElement] = useState(null), {
    t
  } = useTranslation();
  let t0, t1;
  $[0] !== focused || $[1] !== menuItemElement ? (t0 = () => {
    focused && menuItemElement && (menuItemElement.focus(), menuItemElement.setAttribute("data-selected", "")), focused || menuItemElement?.removeAttribute("data-selected");
  }, t1 = [menuItemElement, focused], $[0] = focused, $[1] = menuItemElement, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
  let t2;
  $[4] !== onFocus || $[5] !== user.id ? (t2 = () => {
    onFocus(user.id);
  }, $[4] = onFocus, $[5] = user.id, $[6] = t2) : t2 = $[6];
  const handleFocus = t2;
  let t3;
  $[7] !== locations ? (t3 = locations || [], $[7] = locations, $[8] = t3) : t3 = $[8];
  let hasLink, t4;
  if ($[9] !== handleFocus || $[10] !== t3 || $[11] !== user) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const lastActiveLocation = orderBy(t3, ["lastActiveAt"], ["desc"]).find(_temp$h);
      if (hasLink = !!lastActiveLocation?.documentId, lastActiveLocation) {
        const perspective = getVersionFromId(lastActiveLocation.documentId), t52 = {
          id: getPublishedId(lastActiveLocation.documentId),
          path: PathUtils.toString(lastActiveLocation.path)
        };
        let t62;
        $[14] !== perspective ? (t62 = perspective ? [["perspective", perspective]] : [], $[14] = perspective, $[15] = t62) : t62 = $[15];
        let t72;
        $[16] !== user ? (t72 = /* @__PURE__ */ jsx(UserAvatar, { size: 1, user }), $[16] = user, $[17] = t72) : t72 = $[17];
        let t82;
        $[18] !== handleFocus || $[19] !== t52 || $[20] !== t62 || $[21] !== t72 || $[22] !== user.displayName ? (t82 = /* @__PURE__ */ jsx(MenuItem$1, { as: IntentLink, intent: "edit", params: t52, searchParams: t62, "data-as": "a", onFocus: handleFocus, preview: t72, ref: setMenuItemElement, text: user.displayName }), $[18] = handleFocus, $[19] = t52, $[20] = t62, $[21] = t72, $[22] = user.displayName, $[23] = t82) : t82 = $[23], t4 = t82;
        break bb0;
      }
    }
    $[9] = handleFocus, $[10] = t3, $[11] = user, $[12] = hasLink, $[13] = t4;
  } else
    hasLink = $[12], t4 = $[13];
  if (t4 !== Symbol.for("react.early_return_sentinel"))
    return t4;
  const t5 = !hasLink;
  let t6;
  $[24] !== hasLink || $[25] !== t ? (t6 = hasLink ? void 0 : {
    content: t("presence.not-in-a-document"),
    placement: "left"
  }, $[24] = hasLink, $[25] = t, $[26] = t6) : t6 = $[26];
  let t7;
  $[27] !== user ? (t7 = /* @__PURE__ */ jsx(UserAvatar, { size: 1, user }), $[27] = user, $[28] = t7) : t7 = $[28];
  let t8;
  return $[29] !== handleFocus || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== user.displayName ? (t8 = /* @__PURE__ */ jsx(MenuItem$1, { as: "div", disabled: t5, tooltipProps: t6, "data-as": "a", onFocus: handleFocus, preview: t7, ref: setMenuItemElement, text: user.displayName }), $[29] = handleFocus, $[30] = t5, $[31] = t6, $[32] = t7, $[33] = user.displayName, $[34] = t8) : t8 = $[34], t8;
});
function _temp$h(location2) {
  return location2.documentId;
}
const StyledMenu$2 = styled(Menu)`
  max-width: 260px;
`, FooterStack = styled(Stack)`
  position: sticky;
  bottom: 0;
  background-color: var(--card-bg-color);
`;
function PresenceMenu() {
  const $ = c(40), presence = useGlobalPresence(), {
    projectId
  } = useWorkspace(), scheme = useColorSchemeValue(), {
    t
  } = useTranslation(), hasPresence = presence.length > 0, [focusedId, setFocusedId] = useState();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = (id2) => {
    setFocusedId(id2);
  }, $[0] = t0) : t0 = $[0];
  const handleItemFocus = t0;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setFocusedId("");
  }, $[1] = t1) : t1 = $[1];
  const handleClearFocusedItem = t1;
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setFocusedId("");
  }, $[2] = t2) : t2 = $[2];
  const handleClose = t2;
  let t3, t4;
  $[3] !== t ? (t4 = t("presence.aria-label"), $[3] = t, $[4] = t4) : t4 = $[4];
  const t5 = hasPresence ? "positive" : void 0;
  let t6;
  $[5] !== t ? (t6 = t("presence.tooltip-content"), $[5] = t, $[6] = t6) : t6 = $[6];
  let t7;
  $[7] !== t6 ? (t7 = {
    content: t6
  }, $[7] = t6, $[8] = t7) : t7 = $[8];
  let t8;
  $[9] !== t4 || $[10] !== t5 || $[11] !== t7 ? (t8 = /* @__PURE__ */ jsx(StatusButton, { icon: UsersIcon, "aria-label": t4, mode: "bleed", tone: t5, tooltipProps: t7 }), $[9] = t4, $[10] = t5, $[11] = t7, $[12] = t8) : t8 = $[12], t3 = t8;
  const button = t3;
  let t9, t10;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t10 = ["bottom"], $[13] = t10) : t10 = $[13];
  let t11;
  $[14] !== scheme ? (t11 = {
    constrainSize: !0,
    fallbackPlacements: t10,
    placement: "bottom",
    portal: !0,
    scheme,
    tone: "default"
  }, $[14] = scheme, $[15] = t11) : t11 = $[15], t9 = t11;
  const popoverProps = t9;
  let t12;
  $[16] !== t ? (t12 = t("presence.aria-label"), $[16] = t, $[17] = t12) : t12 = $[17];
  let t13;
  $[18] !== focusedId || $[19] !== hasPresence || $[20] !== presence ? (t13 = hasPresence && presence.map((item) => /* @__PURE__ */ jsx(PresenceMenuItem, { focused: focusedId === item.user.id, onFocus: handleItemFocus, locations: item.locations, user: item.user }, item.user.id)), $[18] = focusedId, $[19] = hasPresence, $[20] = presence, $[21] = t13) : t13 = $[21];
  let t14;
  $[22] !== hasPresence || $[23] !== t ? (t14 = !hasPresence && /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: t("presence.no-one-else-title") }),
    /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("presence.no-one-else-description") })
  ] }) }), $[22] = hasPresence, $[23] = t, $[24] = t14) : t14 = $[24];
  let t15;
  $[25] === Symbol.for("react.memo_cache_sentinel") ? (t15 = /* @__PURE__ */ jsx(MenuDivider, {}), $[25] = t15) : t15 = $[25];
  const t16 = `https://www.sanity.io/manage/project/${projectId}/members?invite=true`;
  let t17;
  $[26] !== t ? (t17 = t("presence.action.manage-members"), $[26] = t, $[27] = t17) : t17 = $[27];
  let t18;
  $[28] !== t16 || $[29] !== t17 ? (t18 = /* @__PURE__ */ jsxs(FooterStack, { space: 1, children: [
    t15,
    /* @__PURE__ */ jsx(MenuItem$1, { as: "a", href: t16, icon: AddUserIcon, onFocus: handleClearFocusedItem, rel: "noopener noreferrer", target: "_blank", text: t17 })
  ] }), $[28] = t16, $[29] = t17, $[30] = t18) : t18 = $[30];
  let t19;
  $[31] !== t13 || $[32] !== t14 || $[33] !== t18 ? (t19 = /* @__PURE__ */ jsxs(StyledMenu$2, { children: [
    t13,
    t14,
    t18
  ] }), $[31] = t13, $[32] = t14, $[33] = t18, $[34] = t19) : t19 = $[34];
  let t20;
  return $[35] !== button || $[36] !== popoverProps || $[37] !== t12 || $[38] !== t19 ? (t20 = /* @__PURE__ */ jsx(MenuButton$1, { button, "aria-label": t12, id: "global-presence-menu", menu: t19, onClose: handleClose, popover: popoverProps }), $[35] = button, $[36] = popoverProps, $[37] = t12, $[38] = t19, $[39] = t20) : t20 = $[39], t20;
}
function AboutDialog(props2) {
  const $ = c(70), {
    t
  } = useTranslation(), {
    latestVersion,
    onClose,
    currentVersion
  } = props2, aboutDialogId = useId(), [copySuccess, setCopySuccess] = useState(!1), {
    push
  } = useToast();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = hasSanityPackageInImportMap(), $[0] = t0) : t0 = $[0];
  const isAutoUpdating = t0, text = `## Current version
${currentVersion}

## Latest version
${latestVersion}

## Auto updates
${isAutoUpdating ? "Enabled" : "Disabled"}

## Page URL
${document.location.href}

## User agent
${navigator.userAgent}
`;
  let t1;
  $[1] !== push || $[2] !== text ? (t1 = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopySuccess(!0);
    }, (err) => {
      push({
        status: "warning",
        title: `Unable to write to clipboard: ${err && typeof err == "object" && "message" in err && err.message || "unknown error"}`
      });
    });
  }, $[1] = push, $[2] = text, $[3] = t1) : t1 = $[3];
  const handleCopyDetails = t1;
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    const timer2 = setTimeout(() => setCopySuccess(!1), 3e3);
    return () => clearTimeout(timer2);
  }, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== copySuccess ? (t3 = [copySuccess], $[5] = copySuccess, $[6] = t3) : t3 = $[6], useEffect(t2, t3);
  let t4;
  $[7] !== t ? (t4 = t("about-dialog.version-info.current-version.header"), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "medium", children: t4 }), $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== currentVersion ? (t6 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: currentVersion }), $[11] = currentVersion, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t5 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t5,
    t6
  ] }), $[13] = t5, $[14] = t6, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t ? (t8 = t("about-dialog.version-info.current-version.header"), $[16] = t, $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "medium", children: t8 }), $[18] = t8, $[19] = t9) : t9 = $[19];
  let t10;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t10 = {}, $[20] = t10) : t10 = $[20];
  let t11;
  $[21] !== t ? (t11 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: "", components: t10 }), $[21] = t, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== latestVersion || $[24] !== t ? (t12 = t("about-dialog.version-info.latest-version.text", {
    latestVersion
  }), $[23] = latestVersion, $[24] = t, $[25] = t12) : t12 = $[25];
  let t13;
  $[26] !== currentVersion || $[27] !== latestVersion || $[28] !== t ? (t13 = latestVersion === currentVersion ? /* @__PURE__ */ jsxs(Fragment, { children: [
    "(",
    t("about-dialog.version-info.up-to-date"),
    ")"
  ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    "(",
    /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/upgrade", children: t("about-dialog.version-info.how-to-upgrade") }),
    ")"
  ] }), $[26] = currentVersion, $[27] = latestVersion, $[28] = t, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== t11 || $[31] !== t12 || $[32] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
    t11,
    t12,
    " ",
    t13
  ] }), $[30] = t11, $[31] = t12, $[32] = t13, $[33] = t14) : t14 = $[33];
  let t15;
  $[34] !== t14 || $[35] !== t9 ? (t15 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t9,
    t14
  ] }), $[34] = t14, $[35] = t9, $[36] = t15) : t15 = $[36];
  let t16;
  $[37] !== t ? (t16 = t("about-dialog.version-info.auto-updates.header"), $[37] = t, $[38] = t16) : t16 = $[38];
  let t17;
  $[39] !== t16 ? (t17 = /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "medium", children: t16 }), $[39] = t16, $[40] = t17) : t17 = $[40];
  let t18;
  $[41] !== t ? (t18 = isAutoUpdating ? /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: t("about-dialog.version-info.auto-updates.enabled") }) : /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
    t("about-dialog.version-info.auto-updates.disabled"),
    " (",
    /* @__PURE__ */ jsx("a", { href: "https://www.sanity.io/docs/auto-updating-studios", children: t("about-dialog.version-info.auto-updates.how-to-enable") }),
    ")"
  ] }), $[41] = t, $[42] = t18) : t18 = $[42];
  let t19;
  $[43] !== t17 || $[44] !== t18 ? (t19 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t17,
    t18
  ] }), $[43] = t17, $[44] = t18, $[45] = t19) : t19 = $[45];
  let t20;
  $[46] !== t ? (t20 = t("about-dialog.version-info.user-agent.header"), $[46] = t, $[47] = t20) : t20 = $[47];
  let t21;
  $[48] !== t20 ? (t21 = /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "medium", children: t20 }), $[48] = t20, $[49] = t21) : t21 = $[49];
  let t22;
  $[50] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: navigator.userAgent }), $[50] = t22) : t22 = $[50];
  let t23;
  $[51] !== t21 ? (t23 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t21,
    t22
  ] }), $[51] = t21, $[52] = t23) : t23 = $[52];
  const t24 = copySuccess ? CheckmarkCircleIcon : CopyIcon;
  let t25;
  $[53] !== copySuccess || $[54] !== t ? (t25 = t(copySuccess ? "about-dialog.version-info.copy-to-clipboard-button.copied-text" : "about-dialog.version-info.copy-to-clipboard-button.text"), $[53] = copySuccess, $[54] = t, $[55] = t25) : t25 = $[55];
  let t26;
  $[56] !== handleCopyDetails || $[57] !== t24 || $[58] !== t25 ? (t26 = /* @__PURE__ */ jsx(Button, { icon: t24, mode: "bleed", text: t25, paddingY: 3, onClick: handleCopyDetails }), $[56] = handleCopyDetails, $[57] = t24, $[58] = t25, $[59] = t26) : t26 = $[59];
  let t27;
  $[60] !== t15 || $[61] !== t19 || $[62] !== t23 || $[63] !== t26 || $[64] !== t7 ? (t27 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t7,
    t15,
    t19,
    t23,
    t26
  ] }), $[60] = t15, $[61] = t19, $[62] = t23, $[63] = t26, $[64] = t7, $[65] = t27) : t27 = $[65];
  let t28;
  return $[66] !== aboutDialogId || $[67] !== onClose || $[68] !== t27 ? (t28 = /* @__PURE__ */ jsx(Dialog$1, { header: "About", width: 1, onClickOutside: onClose, onClose, id: aboutDialogId, children: t27 }), $[66] = aboutDialogId, $[67] = onClose, $[68] = t27, $[69] = t28) : t28 = $[69], t28;
}
function getHelpResources(client, locale) {
  return client.withConfig({
    apiVersion: "1"
  }).observable.request({
    url: "/help",
    /*
      query and tag is used by analytics for tracking.
      Builds to: `{m: ['sanity@3.0.2']}' and serializes to: `?m=sanity@3.0.2`.
      Final format will be e.g. https://api.sanity.io/v1/help?tag=sanity.studio.module.version-check&m=sanity%403.0.2
      */
    query: {
      m: [`sanity@${SANITY_VERSION}`],
      locale
    },
    tag: "module.version-check",
    json: !0
  });
}
function useGetHelpResources() {
  const $ = c(4);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "1"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), locale = useCurrentLocale().id;
  let t1, t2;
  return $[1] !== client || $[2] !== locale ? (t2 = getHelpResources(client, locale), $[1] = client, $[2] = locale, $[3] = t2) : t2 = $[3], t1 = t2, useLoadable(t1);
}
const ProductAnnouncementCardSeen = defineEvent({
  name: "Product Announcement Card Seen",
  version: 1,
  description: "User viewed the product announcement card"
}), ProductAnnouncementCardClicked = defineEvent({
  name: "Product Announcement Card Clicked",
  version: 1,
  description: "User clicked the product announcement card"
}), ProductAnnouncementCardDismissed = defineEvent({
  name: "Product Announcement Card Dismissed",
  version: 1,
  description: "User dismissed the product announcement card"
}), ProductAnnouncementViewed = defineEvent({
  name: "Product Announcement Viewed",
  version: 1,
  description: "User viewed the product announcement"
}), ProductAnnouncementLinkClicked = defineEvent({
  name: "Product Announcement Link Clicked",
  version: 1,
  description: "User clicked the link in the product announcement "
}), ProductAnnouncementModalDismissed = defineEvent({
  name: "Product Announcement Dismissed",
  version: 1,
  description: "User dismissed the product announcement modal "
}), WhatsNewHelpMenuItemClicked = defineEvent({
  name: "Whats New Help Menu Item Clicked",
  version: 1,
  description: 'User clicked the "Whats new" help menu item'
});
function useStudioAnnouncements() {
  const $ = c(1), context = useContext(StudioAnnouncementContext);
  if (!context) {
    let t0;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      studioAnnouncements: [],
      unseenAnnouncements: [],
      onDialogOpen: _temp$g
    }, $[0] = t0) : t0 = $[0], t0;
  }
  return context;
}
function _temp$g() {
}
function StudioAnnouncementsMenuItem(t0) {
  const $ = c(9), {
    text
  } = t0, {
    onDialogOpen,
    studioAnnouncements
  } = useStudioAnnouncements(), telemetry = useTelemetry();
  let t1;
  $[0] !== onDialogOpen || $[1] !== studioAnnouncements[0]?._id || $[2] !== studioAnnouncements[0]?.name || $[3] !== studioAnnouncements[0]?.title || $[4] !== telemetry ? (t1 = () => {
    onDialogOpen("help_menu"), telemetry.log(WhatsNewHelpMenuItemClicked, {
      source: "studio",
      announcement_id: studioAnnouncements[0]?._id,
      announcement_title: studioAnnouncements[0]?.title,
      announcement_internal_name: studioAnnouncements[0]?.name,
      studio_version: SANITY_VERSION
    });
  }, $[0] = onDialogOpen, $[1] = studioAnnouncements[0]?._id, $[2] = studioAnnouncements[0]?.name, $[3] = studioAnnouncements[0]?.title, $[4] = telemetry, $[5] = t1) : t1 = $[5];
  const handleOpenDialog = t1;
  if (studioAnnouncements.length === 0)
    return null;
  let t2;
  return $[6] !== handleOpenDialog || $[7] !== text ? (t2 = /* @__PURE__ */ jsx(MenuItem$1, { tone: "default", text, onClick: handleOpenDialog }), $[6] = handleOpenDialog, $[7] = text, $[8] = t2) : t2 = $[8], t2;
}
function ResourcesMenuItems(t0) {
  const $ = c(44), {
    error,
    isLoading,
    value,
    onAboutDialogOpen
  } = t0, sections = value?.resources?.sectionArray, latestVersion = value?.latestVersion;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = hasSanityPackageInImportMap(), $[0] = t1) : t1 = $[0];
  const isAutoUpdating = t1, {
    t
  } = useTranslation();
  if (isLoading) {
    let t22;
    return $[1] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[1] = t22) : t22 = $[1], t22;
  }
  let t2;
  $[2] !== t ? (t2 = t("help-resources.action.join-our-community"), $[2] = t, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(MenuItem$1, { as: "a", text: t2, href: "https://www.sanity.io/exchange/community", target: "_blank" }), $[4] = t2, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t ? (t4 = t("help-resources.action.help-and-support"), $[6] = t, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuItem$1, { as: "a", text: t4, href: "https://www.sanity.io/contact/support", target: "_blank" }), $[8] = t4, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t ? (t6 = t("help-resources.action.contact-sales"), $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuItem$1, { as: "a", text: t6, href: "https://www.sanity.io/contact/sales?ref=studio", target: "_blank" }), $[12] = t6, $[13] = t7) : t7 = $[13];
  let t8;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t8 = /* @__PURE__ */ jsx(MenuDivider, {}), $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== t3 || $[16] !== t5 || $[17] !== t7 ? (t9 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t3,
    t5,
    t7,
    t8
  ] }), $[15] = t3, $[16] = t5, $[17] = t7, $[18] = t9) : t9 = $[18];
  const fallbackLinks = t9;
  let t10;
  $[19] !== error || $[20] !== fallbackLinks || $[21] !== value ? (t10 = (value === void 0 || error) && /* @__PURE__ */ jsx("div", { children: fallbackLinks }), $[19] = error, $[20] = fallbackLinks, $[21] = value, $[22] = t10) : t10 = $[22];
  let t11;
  $[23] !== error || $[24] !== sections ? (t11 = !error && sections?.map(_temp$f), $[23] = error, $[24] = sections, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== t ? (t12 = t("help-resources.studio-version", {
    studioVersion: SANITY_VERSION
  }), $[26] = t, $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== t12 ? (t13 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", textOverflow: "ellipsis", children: t12 }), $[28] = t12, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== error || $[31] !== latestVersion || $[32] !== t ? (t14 = !error && latestVersion && !isAutoUpdating && /* @__PURE__ */ jsx(Box, { paddingTop: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", children: t("help-resources.latest-sanity-version", {
    latestVersion
  }) }) }), $[30] = error, $[31] = latestVersion, $[32] = t, $[33] = t14) : t14 = $[33];
  let t15;
  $[34] !== t13 || $[35] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Stack, { space: 1, children: [
    t13,
    t14
  ] }), $[34] = t13, $[35] = t14, $[36] = t15) : t15 = $[36];
  let t16;
  $[37] !== onAboutDialogOpen || $[38] !== t15 ? (t16 = /* @__PURE__ */ jsx(MenuItem, { onClick: onAboutDialogOpen, children: t15 }), $[37] = onAboutDialogOpen, $[38] = t15, $[39] = t16) : t16 = $[39];
  let t17;
  return $[40] !== t10 || $[41] !== t11 || $[42] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t10,
    t11,
    t16
  ] }), $[40] = t10, $[41] = t11, $[42] = t16, $[43] = t17) : t17 = $[43], t17;
}
function _temp$f(subSection) {
  return subSection ? /* @__PURE__ */ jsx(SubSection, { subSection }, subSection._key) : null;
}
function SubSection(t0) {
  const $ = c(5), {
    subSection
  } = t0;
  let t1;
  $[0] !== subSection?.items ? (t1 = subSection?.items?.map(_temp2$6), $[0] = subSection?.items, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(MenuDivider, {}), $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== t1 ? (t3 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t1,
    t2
  ] }), $[3] = t1, $[4] = t3) : t3 = $[4], t3;
}
function _temp2$6(item) {
  if (!item || !item.title)
    return null;
  switch (item._type) {
    case "externalLink":
      return item.url ? /* @__PURE__ */ jsx(MenuItem$1, { as: "a", tone: "default", text: item.title, href: item.url, target: "_blank" }, item._key) : null;
    case "internalAction":
      return item.type ? item.type === "studio-announcements-modal" ? /* @__PURE__ */ jsx(StudioAnnouncementsMenuItem, { text: item.title }, item._key) : item.type === "show-welcome-modal" && /* @__PURE__ */ jsx(MenuItem$1, { text: item.title }, item._key) : null;
    default:
      return null;
  }
}
const StyledMenu$1 = styled(Menu)`
  max-width: 300px;
  min-width: 200px;
`;
function ResourcesButton() {
  const $ = c(25), {
    t
  } = useTranslation(), {
    value,
    error,
    isLoading
  } = useGetHelpResources(), [aboutDialogOpen, setAboutDialogOpen] = useState(!1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => {
    setAboutDialogOpen(!1);
  }, $[0] = t0) : t0 = $[0];
  const handleAboutDialogClose = t0;
  let t1;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setAboutDialogOpen(!0);
  }, $[1] = t1) : t1 = $[1];
  const handleAboutDialogOpen = t1;
  let t2;
  $[2] !== aboutDialogOpen || $[3] !== value?.latestVersion ? (t2 = aboutDialogOpen && /* @__PURE__ */ jsx(AboutDialog, { currentVersion: SANITY_VERSION, latestVersion: value?.latestVersion || "unknown", onClose: handleAboutDialogClose }), $[2] = aboutDialogOpen, $[3] = value?.latestVersion, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== t ? (t3 = t("help-resources.title"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t ? (t4 = t("help-resources.title"), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t4 ? (t5 = {
    content: t4
  }, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== t3 || $[12] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button, { "aria-label": t3, icon: HelpCircleIcon, mode: "bleed", tooltipProps: t5 }), $[11] = t3, $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== error || $[15] !== isLoading || $[16] !== value ? (t7 = /* @__PURE__ */ jsx(StyledMenu$1, { "data-testid": "menu-button-resources", children: /* @__PURE__ */ jsx(ResourcesMenuItems, { error, isLoading, value, onAboutDialogOpen: handleAboutDialogOpen }) }), $[14] = error, $[15] = isLoading, $[16] = value, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] === Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    constrainSize: !0,
    tone: "default"
  }, $[18] = t8) : t8 = $[18];
  let t9;
  $[19] !== t6 || $[20] !== t7 ? (t9 = /* @__PURE__ */ jsx(MenuButton$1, { button: t6, id: "menu-button-resources", menu: t7, popover: t8 }), $[19] = t6, $[20] = t7, $[21] = t9) : t9 = $[21];
  let t10;
  return $[22] !== t2 || $[23] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t2,
    t9
  ] }), $[22] = t2, $[23] = t9, $[24] = t10) : t10 = $[24], t10;
}
function LocaleMenu() {
  return c(10), useLocale(), null;
}
function AppearanceMenu(t0) {
  const $ = c(5), {
    setScheme
  } = t0, {
    t
  } = useTranslation(), options = useColorSchemeOptions(setScheme, t);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(MenuDivider, {}), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== options ? (t2 = options.map(_temp$e), $[1] = options, $[2] = t2) : t2 = $[2];
  let t3;
  return $[3] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t1,
    t2
  ] }), $[3] = t2, $[4] = t3) : t3 = $[4], t3;
}
function _temp$e(t0) {
  const {
    icon,
    label,
    name,
    onSelect,
    selected,
    title
  } = t0;
  return /* @__PURE__ */ jsx(MenuItem$1, { "aria-label": label, icon, onClick: onSelect, pressed: selected, text: title, iconRight: selected && /* @__PURE__ */ jsx(CheckmarkIcon, {}), "data-testid": `color-scheme-${name}` }, name);
}
const Root$9 = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  background: var(--card-bg-color);
  bottom: -4px;
  right: -4px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--card-bg-color);
  box-sizing: content-box;

  svg {
    box-sizing: content-box;
    border: 1px solid var(--card-hairline-soft-color);
    border-radius: 50%;
    padding: 2px;
    width: 12px;
    height: 12px;
  }

  &[data-logo='github'] {
    svg {
      path {
        fill: var(--card-fg-color);
      }
    }
  }

  &[data-logo='saml'] {
    svg {
      path {
        fill: var(--card-fg-color);
      }
    }
  }
`, Google = /* @__PURE__ */ jsxs("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0)", children: [
    /* @__PURE__ */ jsx("path", { d: "M12 6.13764C12 5.72977 11.9663 5.31971 11.8943 4.91846H6.12036V7.22895H9.42684C9.28963 7.97412 8.84876 8.63332 8.20322 9.05221V10.5514H10.1759C11.3342 9.50637 12 7.9631 12 6.13764Z", fill: "#4285F4" }),
    /* @__PURE__ */ jsx("path", { d: "M6.12019 12.0002C7.77118 12.0002 9.16349 11.4688 10.1779 10.5517L8.20529 9.05253C7.65646 9.41851 6.94793 9.62574 6.12244 9.62574C4.52544 9.62574 3.17136 8.56971 2.68552 7.1499H0.649902V8.69537C1.68908 10.7215 3.80567 12.0002 6.12019 12.0002V12.0002Z", fill: "#34A853" }),
    /* @__PURE__ */ jsx("path", { d: "M2.68332 7.14986C2.4269 6.40469 2.4269 5.59778 2.68332 4.8526V3.30713H0.649951C-0.218278 5.00252 -0.218278 6.99995 0.649951 8.69533L2.68332 7.14986V7.14986Z", fill: "#FBBC04" }),
    /* @__PURE__ */ jsx("path", { d: "M6.12019 2.37483C6.99291 2.3616 7.8364 2.68348 8.46845 3.27433L10.2161 1.56131C9.1095 0.542752 7.64071 -0.017233 6.12019 0.000404333C3.80566 0.000404333 1.68908 1.27911 0.649902 3.3074L2.68326 4.85288C3.16686 3.43087 4.52319 2.37483 6.12019 2.37483V2.37483Z", fill: "#EA4335" })
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ jsx("rect", { width: "12", height: "12", fill: "white" }) }) })
] }), GitHub = /* @__PURE__ */ jsxs("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0)", children: /* @__PURE__ */ jsx("path", { d: "M11.195 3.13503C10.6711 2.22838 9.91808 1.47537 9.01144 0.951471C8.09222 0.414976 7.08837 0.146729 5.99987 0.146729C4.91137 0.146729 3.90752 0.414976 2.98831 0.951471C2.08163 1.47534 1.32862 2.22836 0.804744 3.13503C0.268248 4.05497 0 5.05883 0 6.14659C0 7.45399 0.381531 8.62978 1.14459 9.67394C1.90765 10.7181 2.89327 11.4408 4.10143 11.8419C4.24208 11.868 4.34624 11.8497 4.41392 11.7872C4.44666 11.7577 4.47263 11.7215 4.49006 11.681C4.50749 11.6405 4.51595 11.5967 4.51488 11.5527C4.51488 11.537 4.51361 11.3963 4.51105 11.1307C4.5085 10.8651 4.50722 10.6334 4.50722 10.4355L4.32745 10.4666C4.18407 10.4895 4.03885 10.4986 3.89375 10.494C3.71159 10.4908 3.53001 10.4725 3.35087 10.4393C3.16049 10.4045 2.98119 10.3246 2.82796 10.2064C2.66705 10.0846 2.54715 9.91661 2.48428 9.72484L2.40602 9.54506C2.34022 9.40286 2.25754 9.2691 2.15976 9.14666C2.04775 9.00072 1.93447 8.90176 1.81991 8.84977L1.76518 8.81064C1.72769 8.78356 1.6936 8.75205 1.66367 8.71679C1.63479 8.6841 1.61108 8.64719 1.59334 8.60734C1.57766 8.57085 1.5907 8.54085 1.63247 8.51731C1.67461 8.49405 1.75123 8.48256 1.86068 8.48256L2.01692 8.50582C2.12108 8.52662 2.24996 8.5891 2.40356 8.69326C2.5585 8.79876 2.68797 8.93748 2.78254 9.09932C2.90239 9.31294 3.04695 9.47575 3.21624 9.58775C3.38552 9.69976 3.55609 9.75576 3.72793 9.75576C3.87725 9.7578 4.02641 9.74479 4.17312 9.7169C4.29459 9.69195 4.41264 9.65254 4.52473 9.59952C4.57162 9.25037 4.69931 8.98212 4.90782 8.79477C4.63684 8.76849 4.36827 8.72157 4.10444 8.6544C3.84797 8.58382 3.60133 8.48141 3.37029 8.34958C3.12825 8.218 2.91442 8.04015 2.74095 7.82613C2.57421 7.6178 2.4374 7.34417 2.3305 7.00524C2.2236 6.6663 2.1707 6.27584 2.1718 5.83383C2.1718 5.20357 2.37757 4.66708 2.7891 4.22435C2.59629 3.75006 2.61453 3.21885 2.84383 2.63073C2.99487 2.58385 3.21879 2.61897 3.51559 2.73608C3.81239 2.85319 4.02983 2.95352 4.16792 3.03707C4.30601 3.12025 4.41665 3.19058 4.49983 3.24804C5.48153 2.9773 6.51821 2.9773 7.49991 3.24804L7.79679 3.0606C8.0249 2.92356 8.26549 2.80849 8.51535 2.71693C8.79135 2.61276 9.00231 2.58412 9.14825 2.63101C9.38248 3.21949 9.40327 3.7507 9.21064 4.22462C9.62199 4.66735 9.82776 5.20385 9.82795 5.83411C9.82795 6.27684 9.77459 6.66904 9.66787 7.01071C9.56116 7.35238 9.42325 7.62601 9.25415 7.8316C9.07785 8.04326 8.86311 8.21966 8.62124 8.35149C8.39008 8.48329 8.14337 8.5857 7.88682 8.65632C7.62412 8.72277 7.35674 8.76915 7.087 8.79505C7.35698 9.02927 7.49206 9.3994 7.49225 9.90543V11.5527C7.49115 11.5964 7.49929 11.6398 7.51612 11.6802C7.53295 11.7206 7.5581 11.7569 7.58993 11.7869C7.65505 11.8493 7.75794 11.8675 7.89858 11.8416C9.10693 11.4403 10.0926 10.7177 10.8557 9.67367C11.6188 8.62968 12.0003 7.4539 12.0003 6.14632C11.9997 5.05873 11.7313 4.05497 11.195 3.13503V3.13503Z", fill: "black" }) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ jsx("rect", { width: "12", height: "12", fill: "white" }) }) })
] }), Saml = /* @__PURE__ */ jsxs("svg", { width: "17", height: "9", viewBox: "0 0 17 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("path", { d: "M0.0691681 5.98162C0.115833 7.24157 1.07247 8.00221 2.59841 8.00221C4.17102 8.00221 5.12299 7.19957 5.12299 5.86962C5.12299 4.83832 4.55367 4.25501 3.25172 3.96569L2.56108 3.80703C1.8331 3.64837 1.53445 3.38704 1.53445 2.91106C1.53445 2.40708 1.94977 2.09442 2.61708 2.09442C3.27505 2.09442 3.6997 2.43508 3.75103 2.99039H5.00166C4.95966 1.78643 4.01236 0.997795 2.60308 0.997795C1.14713 0.997795 0.218496 1.79577 0.218496 3.05105C0.218496 4.04968 0.815808 4.69366 2.03376 4.96898L2.73374 5.13231C3.51304 5.30497 3.8117 5.54763 3.8117 6.00495C3.8117 6.55093 3.34972 6.90092 2.62174 6.90092C1.85644 6.90092 1.38045 6.56493 1.31979 5.98162H0.0691681Z" }),
  /* @__PURE__ */ jsx("path", { d: "M5.97695 5.98162C6.02362 7.24157 6.98025 8.00221 8.5062 8.00221C10.0788 8.00221 11.0308 7.19957 11.0308 5.86962C11.0308 4.83832 10.4615 4.25501 9.15951 3.96569L8.46886 3.80703C7.74089 3.64837 7.44223 3.38704 7.44223 2.91106C7.44223 2.40708 7.85755 2.09442 8.52486 2.09442C9.18284 2.09442 9.60749 2.43508 9.65882 2.99039H10.9094C10.8674 1.78643 9.92015 0.997795 8.51086 0.997795C7.05492 0.997795 6.12628 1.79577 6.12628 3.05105C6.12628 4.04968 6.72359 4.69366 7.94155 4.96898L8.64153 5.13231C9.42083 5.30497 9.71949 5.54763 9.71949 6.00495C9.71949 6.55093 9.2575 6.90092 8.52953 6.90092C7.76422 6.90092 7.28824 6.56493 7.22758 5.98162H5.97695Z" }),
  /* @__PURE__ */ jsx("path", { d: "M16.9852 5.01565V3.98435C16.9852 2.11309 16.0099 0.997795 14.3953 0.997795C12.7807 0.997795 11.8054 2.11309 11.8054 3.98435V5.01565C11.8054 6.88692 12.7807 8.00221 14.3953 8.00221C16.0099 8.00221 16.9852 6.88692 16.9852 5.01565ZM14.3953 6.82625C13.5833 6.82625 13.154 6.21494 13.154 5.00165V3.99835C13.154 2.78506 13.5833 2.17375 14.3953 2.17375C15.2073 2.17375 15.6366 2.78506 15.6366 3.99835V5.00165C15.6366 6.21494 15.2073 6.82625 14.3953 6.82625Z" })
] }), LoginProviderLogo = (t0) => {
  const $ = c(10), {
    provider
  } = t0;
  let t1;
  $[0] !== provider ? (t1 = provider?.startsWith("saml-"), $[0] = provider, $[1] = t1) : t1 = $[1];
  const isSaml = t1, logoName = isSaml ? "saml" : provider, t2 = provider === "google" && Google, t3 = provider === "github" && GitHub;
  let t4;
  $[2] !== provider ? (t4 = provider === "sanity" && /* @__PURE__ */ jsx(SanityMonogram, {}), $[2] = provider, $[3] = t4) : t4 = $[3];
  const t5 = isSaml && Saml;
  let t6;
  return $[4] !== logoName || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Root$9, { "data-logo": logoName, children: [
    t2,
    t3,
    t4,
    t5
  ] }), $[4] = logoName, $[5] = t2, $[6] = t3, $[7] = t4, $[8] = t5, $[9] = t6) : t6 = $[9], t6;
};
function ManageMenu() {
  const $ = c(18), {
    currentUser,
    projectId
  } = useWorkspace();
  let t0;
  $[0] !== currentUser ? (t0 = currentUser && userHasRole(currentUser, "administrator"), $[0] = currentUser, $[1] = t0) : t0 = $[1];
  const isAdmin = !!t0, {
    t
  } = useTranslation();
  let t1;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(MenuDivider, {}), $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t ? (t2 = t("user-menu.action.manage-project-aria-label"), $[3] = t, $[4] = t2) : t2 = $[4];
  const t3 = `https://sanity.io/manage/project/${projectId}`;
  let t4;
  $[5] !== t ? (t4 = t("user-menu.action.manage-project"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t2 || $[8] !== t3 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuItem$1, { as: "a", "aria-label": t2, href: t3, target: "_blank", text: t4, icon: CogIcon }), $[7] = t2, $[8] = t3, $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== isAdmin || $[12] !== projectId || $[13] !== t ? (t6 = isAdmin && /* @__PURE__ */ jsx(MenuItem$1, { as: "a", "aria-label": t("user-menu.action.invite-members-aria-label"), href: `https://www.sanity.io/manage/project/${projectId}/members?invite=true`, target: "_blank", text: t("user-menu.action.invite-members"), icon: AddUserIcon }), $[11] = isAdmin, $[12] = projectId, $[13] = t, $[14] = t6) : t6 = $[14];
  let t7;
  return $[15] !== t5 || $[16] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t1,
    t5,
    t6
  ] }), $[15] = t5, $[16] = t6, $[17] = t7) : t7 = $[17], t7;
}
const StyledMenu = styled(Menu)`
  min-width: 200px;
  max-width: 300px;
`, AvatarBox = styled(Box)`
  position: relative;
  min-width: ${({
  theme
}) => theme.sanity.avatar.sizes[2].size}px;
  min-height: ${({
  theme
}) => theme.sanity.avatar.sizes[2].size}px;
`;
function UserMenu() {
  const $ = c(44), {
    currentUser,
    auth
  } = useWorkspace(), scheme = useColorSchemeValue(), setScheme = useColorSchemeSetValue(), providerTitle = getProviderTitle(currentUser?.provider), {
    t
  } = useTranslation();
  let t0, t1;
  $[0] !== scheme ? (t1 = {
    placement: "bottom",
    portal: !0,
    preventOverflow: !0,
    scheme,
    constrainSize: !0,
    tone: "default"
  }, $[0] = scheme, $[1] = t1) : t1 = $[1], t0 = t1;
  const popoverProps = t0, T0 = MenuButton$1;
  let t2;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", padding: 0, radius: "full", children: /* @__PURE__ */ jsx(UserAvatar, { size: 1, user: "me" }) }), $[2] = t2) : t2 = $[2];
  const t3 = "user-menu", T1 = StyledMenu, t4 = "user-menu", T2 = Card, t5 = 2, T3 = Flex, t6 = "center", T4 = Tooltip, t7 = !providerTitle, t8 = !0, t9 = t("user-menu.login-provider", {
    providerTitle
  });
  let t10;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t10 = /* @__PURE__ */ jsx(UserAvatar, { size: 2, user: "me" }), $[3] = t10) : t10 = $[3];
  let t11;
  $[4] !== currentUser ? (t11 = currentUser?.provider && /* @__PURE__ */ jsx(LoginProviderLogo, { provider: currentUser.provider }), $[4] = currentUser, $[5] = t11) : t11 = $[5];
  let t12;
  $[6] !== t11 ? (t12 = /* @__PURE__ */ jsxs(AvatarBox, { marginRight: 3, children: [
    t10,
    t11
  ] }), $[6] = t11, $[7] = t12) : t12 = $[7];
  let t13;
  $[8] !== T4 || $[9] !== t12 || $[10] !== t7 || $[11] !== t9 ? (t13 = /* @__PURE__ */ jsx(T4, { disabled: t7, portal: t8, content: t9, children: t12 }), $[8] = T4, $[9] = t12, $[10] = t7, $[11] = t9, $[12] = t13) : t13 = $[12];
  const t14 = currentUser?.name;
  let t15;
  $[13] !== t14 ? (t15 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", textOverflow: "ellipsis", children: t14 }), $[13] = t14, $[14] = t15) : t15 = $[14];
  const t16 = currentUser?.email;
  let t17;
  $[15] !== t16 ? (t17 = /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, textOverflow: "ellipsis", children: t16 }), $[15] = t16, $[16] = t17) : t17 = $[16];
  let t18;
  $[17] !== t15 || $[18] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Stack, { space: 2, flex: 1, children: [
    t15,
    t17
  ] }), $[17] = t15, $[18] = t17, $[19] = t18) : t18 = $[19];
  let t19;
  $[20] !== T3 || $[21] !== t13 || $[22] !== t18 ? (t19 = /* @__PURE__ */ jsxs(T3, { align: t6, children: [
    t13,
    t18
  ] }), $[20] = T3, $[21] = t13, $[22] = t18, $[23] = t19) : t19 = $[23];
  let t20;
  $[24] !== T2 || $[25] !== t19 ? (t20 = /* @__PURE__ */ jsx(T2, { padding: t5, children: t19 }), $[24] = T2, $[25] = t19, $[26] = t20) : t20 = $[26];
  let t21;
  $[27] !== setScheme ? (t21 = setScheme && /* @__PURE__ */ jsx(AppearanceMenu, { setScheme }), $[27] = setScheme, $[28] = t21) : t21 = $[28];
  let t22, t23;
  $[29] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(LocaleMenu, {}), t23 = /* @__PURE__ */ jsx(ManageMenu, {}), $[29] = t22, $[30] = t23) : (t22 = $[29], t23 = $[30]);
  let t24;
  $[31] !== auth.logout || $[32] !== t ? (t24 = auth.logout && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MenuDivider, {}),
    /* @__PURE__ */ jsx(MenuItem$1, { iconRight: LeaveIcon, text: t("user-menu.action.sign-out"), disabled: !auth.logout, ...auth.logout && {
      onClick: auth.logout
    } })
  ] }), $[31] = auth.logout, $[32] = t, $[33] = t24) : t24 = $[33];
  let t25;
  $[34] !== T1 || $[35] !== t20 || $[36] !== t21 || $[37] !== t24 ? (t25 = /* @__PURE__ */ jsxs(T1, { "data-testid": t4, children: [
    t20,
    t21,
    t22,
    t23,
    t24
  ] }), $[34] = T1, $[35] = t20, $[36] = t21, $[37] = t24, $[38] = t25) : t25 = $[38];
  let t26;
  return $[39] !== T0 || $[40] !== popoverProps || $[41] !== t2 || $[42] !== t25 ? (t26 = /* @__PURE__ */ jsx(T0, { button: t2, id: t3, menu: t25, popover: popoverProps }), $[39] = T0, $[40] = popoverProps, $[41] = t2, $[42] = t25, $[43] = t26) : t26 = $[43], t26;
}
const EMPTY_ARRAY$6 = [], RootLayer = styled(Layer)`
  min-height: auto;
  position: relative;

  &[data-search-open='true'] {
    top: 0;
    position: sticky;
  }
`, RootCard$1 = styled(Card)`
  line-height: 0;
`, NavGrid = styled(Grid)`
  grid-template-columns: auto auto auto;
  @media screen and (min-width: ${({
  theme
}) => `${theme.sanity.media[4]}px`}) {
    grid-template-columns: 1fr auto 1fr;
  }
`;
function StudioNavbar(props2) {
  const $ = c(113), {
    __internal_actions: t0
  } = props2, actions = t0 === void 0 ? EMPTY_ARRAY$6 : t0, {
    name,
    tools
  } = useWorkspace(), routerState = useRouterState(), mediaIndex = useMediaIndex(), activeToolName = typeof routerState.tool == "string" ? routerState.tool : void 0, newDocumentOptions = useNewDocumentOptions(), {
    t
  } = useTranslation(), {
    onSearchFullscreenOpenChange,
    onSearchOpenChange,
    searchFullscreenOpen,
    searchFullscreenPortalEl,
    searchOpen
  } = useContext(NavbarContext), {
    selectedPerspective,
    perspectiveStack
  } = usePerspective(), ToolMenu = useToolMenuComponent(), [drawerOpen, setDrawerOpen] = useState(!1), routerStateRef = useRef(routerState), workspaceNameRef = useRef(name);
  let t1, t2;
  $[0] !== name || $[1] !== routerState ? (t1 = () => {
    (routerStateRef.current.tool !== routerState.tool || name !== workspaceNameRef.current) && setDrawerOpen(!1), routerStateRef.current = routerState, workspaceNameRef.current = name;
  }, t2 = [name, routerState], $[0] = name, $[1] = routerState, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  const [drawerButtonEl, setDrawerButtonEl] = useState(null), [searchOpenButtonEl, setSearchOpenButtonEl] = useState(null);
  let t3;
  const t4 = mediaIndex > 1, t5 = mediaIndex <= 1, t6 = mediaIndex > 1, t7 = mediaIndex <= 1, t8 = mediaIndex > 1 && isDev, t9 = mediaIndex <= 1, t10 = mediaIndex >= 3;
  let t11;
  $[4] !== t10 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6 || $[8] !== t7 || $[9] !== t8 || $[10] !== t9 ? (t11 = {
    resources: t4,
    collapsedPresenceMenu: t5,
    loginStatus: t6,
    searchFullscreen: t7,
    configIssues: t8,
    newDocumentFullscreen: t9,
    tools: t10
  }, $[4] = t10, $[5] = t4, $[6] = t5, $[7] = t6, $[8] = t7, $[9] = t8, $[10] = t9, $[11] = t11) : t11 = $[11], t3 = t11;
  const shouldRender = t3;
  let t12, t13;
  $[12] !== onSearchFullscreenOpenChange || $[13] !== searchFullscreenOpen ? (t12 = () => {
    onSearchFullscreenOpenChange(searchFullscreenOpen);
  }, t13 = [searchFullscreenOpen, onSearchFullscreenOpenChange], $[12] = onSearchFullscreenOpenChange, $[13] = searchFullscreenOpen, $[14] = t12, $[15] = t13) : (t12 = $[14], t13 = $[15]), useEffect(t12, t13);
  let t14, t15;
  $[16] !== onSearchFullscreenOpenChange || $[17] !== onSearchOpenChange || $[18] !== shouldRender.searchFullscreen ? (t14 = () => {
    shouldRender.searchFullscreen ? onSearchOpenChange(!1) : onSearchFullscreenOpenChange(!1);
  }, t15 = [onSearchFullscreenOpenChange, onSearchOpenChange, shouldRender.searchFullscreen], $[16] = onSearchFullscreenOpenChange, $[17] = onSearchOpenChange, $[18] = shouldRender.searchFullscreen, $[19] = t14, $[20] = t15) : (t14 = $[19], t15 = $[20]), useEffect(t14, t15);
  let t16;
  $[21] !== onSearchOpenChange ? (t16 = () => {
    onSearchOpenChange(!0);
  }, $[21] = onSearchOpenChange, $[22] = t16) : t16 = $[22];
  const handleOpenSearch = t16;
  let t17;
  $[23] !== onSearchFullscreenOpenChange ? (t17 = () => {
    onSearchFullscreenOpenChange(!0);
  }, $[23] = onSearchFullscreenOpenChange, $[24] = t17) : t17 = $[24];
  const handleOpenSearchFullscreen = t17;
  let t18;
  $[25] !== onSearchOpenChange ? (t18 = () => {
    onSearchOpenChange(!1);
  }, $[25] = onSearchOpenChange, $[26] = t18) : t18 = $[26];
  const handleCloseSearch = t18;
  let t19;
  $[27] !== onSearchFullscreenOpenChange || $[28] !== searchOpenButtonEl ? (t19 = () => {
    onSearchFullscreenOpenChange(!1), searchOpenButtonEl?.focus();
  }, $[27] = onSearchFullscreenOpenChange, $[28] = searchOpenButtonEl, $[29] = t19) : t19 = $[29];
  const handleCloseSearchFullscreen = t19;
  let t20;
  $[30] !== drawerButtonEl ? (t20 = () => {
    setDrawerOpen(!1), drawerButtonEl?.focus();
  }, $[30] = drawerButtonEl, $[31] = t20) : t20 = $[31];
  const handleCloseDrawer = t20;
  let t21;
  $[32] === Symbol.for("react.memo_cache_sentinel") ? (t21 = () => {
    setDrawerOpen(!0);
  }, $[32] = t21) : t21 = $[32];
  const handleOpenDrawer = t21;
  let t22;
  bb0: {
    if (!shouldRender.tools) {
      t22 = null;
      break bb0;
    }
    let t232;
    $[33] !== actions ? (t232 = actions?.filter(_temp$d)?.map(_temp2$5), $[33] = actions, $[34] = t232) : t232 = $[34], t22 = t232;
  }
  const actionNodes = t22;
  let t23;
  $[35] !== selectedPerspective ? (t23 = getReleaseTone(selectedPerspective), $[35] = selectedPerspective, $[36] = t23) : t23 = $[36];
  let t24;
  $[37] !== shouldRender.tools || $[38] !== t ? (t24 = !shouldRender.tools && /* @__PURE__ */ jsx(Button, { mode: "bleed", icon: MenuIcon, onClick: handleOpenDrawer, ref: setDrawerButtonEl, tooltipProps: {
    content: t("user-menu.open-menu"),
    placement: "bottom"
  } }), $[37] = shouldRender.tools, $[38] = t, $[39] = t24) : t24 = $[39];
  let t25;
  $[40] === Symbol.for("react.memo_cache_sentinel") ? (t25 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    /* @__PURE__ */ jsx(HomeButton, {}),
    /* @__PURE__ */ jsx(WorkspaceMenuButton, {})
  ] }), $[40] = t25) : t25 = $[40];
  let t26;
  $[41] !== t24 ? (t26 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t24,
    t25
  ] }), $[41] = t24, $[42] = t26) : t26 = $[42];
  const t27 = shouldRender.newDocumentFullscreen ? "dialog" : "popover";
  let t28;
  $[43] !== newDocumentOptions || $[44] !== t27 ? (t28 = /* @__PURE__ */ jsx(NewDocumentButton, { ...newDocumentOptions, modal: t27 }), $[43] = newDocumentOptions, $[44] = t27, $[45] = t28) : t28 = $[45];
  let t29;
  $[46] !== handleOpenSearch || $[47] !== shouldRender.searchFullscreen ? (t29 = !shouldRender.searchFullscreen && /* @__PURE__ */ jsx(SearchButton, { onClick: handleOpenSearch, ref: setSearchOpenButtonEl }), $[46] = handleOpenSearch, $[47] = shouldRender.searchFullscreen, $[48] = t29) : t29 = $[48];
  let t30;
  $[49] !== t26 || $[50] !== t28 || $[51] !== t29 ? (t30 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, justify: "flex-start", children: [
    t26,
    t28,
    t29
  ] }) }), $[49] = t26, $[50] = t28, $[51] = t29, $[52] = t30) : t30 = $[52];
  let t31;
  $[53] !== ToolMenu || $[54] !== activeToolName || $[55] !== handleCloseDrawer || $[56] !== shouldRender.tools || $[57] !== tools ? (t31 = shouldRender.tools && /* @__PURE__ */ jsx(ToolMenu, { activeToolName, closeSidebar: handleCloseDrawer, context: "topbar", isSidebarOpen: !1, tools }), $[53] = ToolMenu, $[54] = activeToolName, $[55] = handleCloseDrawer, $[56] = shouldRender.tools, $[57] = tools, $[58] = t31) : t31 = $[58];
  let t32;
  $[59] !== t31 ? (t32 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", children: t31 }), $[59] = t31, $[60] = t32) : t32 = $[60];
  let t33;
  $[61] !== handleCloseSearch || $[62] !== handleCloseSearchFullscreen || $[63] !== handleOpenSearch || $[64] !== handleOpenSearchFullscreen || $[65] !== perspectiveStack || $[66] !== searchFullscreenOpen || $[67] !== searchFullscreenPortalEl || $[68] !== searchOpen || $[69] !== shouldRender.searchFullscreen ? (t33 = /* @__PURE__ */ jsx(BoundaryElementProvider, { element: document.body, children: shouldRender.searchFullscreen ? /* @__PURE__ */ jsx(PortalProvider, { element: searchFullscreenPortalEl, children: /* @__PURE__ */ jsx(SearchDialog, { onClose: handleCloseSearchFullscreen, onOpen: handleOpenSearchFullscreen, open: searchFullscreenOpen }) }) : /* @__PURE__ */ jsx(SearchPopover, { onClose: handleCloseSearch, onOpen: handleOpenSearch, open: searchOpen, previewPerspective: perspectiveStack }) }), $[61] = handleCloseSearch, $[62] = handleCloseSearchFullscreen, $[63] = handleOpenSearch, $[64] = handleOpenSearchFullscreen, $[65] = perspectiveStack, $[66] = searchFullscreenOpen, $[67] = searchFullscreenPortalEl, $[68] = searchOpen, $[69] = shouldRender.searchFullscreen, $[70] = t33) : t33 = $[70];
  let t34;
  $[71] !== shouldRender.searchFullscreen || $[72] !== t33 ? (t34 = /* @__PURE__ */ jsx(LayerProvider, { children: /* @__PURE__ */ jsx(SearchProvider, { fullscreen: shouldRender.searchFullscreen, children: t33 }) }), $[71] = shouldRender.searchFullscreen, $[72] = t33, $[73] = t34) : t34 = $[73];
  let t35;
  $[74] === Symbol.for("react.memo_cache_sentinel") ? (t35 = /* @__PURE__ */ jsx(ReleasesNav, {}), $[74] = t35) : t35 = $[74];
  let t36;
  $[75] !== shouldRender.tools ? (t36 = shouldRender.tools && /* @__PURE__ */ jsx(FreeTrial, { type: "topbar" }), $[75] = shouldRender.tools, $[76] = t36) : t36 = $[76];
  let t37;
  $[77] === Symbol.for("react.memo_cache_sentinel") ? (t37 = /* @__PURE__ */ jsx(PresenceMenu, {}), $[77] = t37) : t37 = $[77];
  let t38;
  $[78] !== shouldRender.configIssues ? (t38 = shouldRender.configIssues && /* @__PURE__ */ jsx(ConfigIssuesButton, {}), $[78] = shouldRender.configIssues, $[79] = t38) : t38 = $[79];
  let t39;
  $[80] !== shouldRender.resources ? (t39 = shouldRender.resources && /* @__PURE__ */ jsx(ResourcesButton, {}), $[80] = shouldRender.resources, $[81] = t39) : t39 = $[81];
  let t40;
  $[82] !== handleOpenSearchFullscreen || $[83] !== shouldRender.searchFullscreen ? (t40 = shouldRender.searchFullscreen && /* @__PURE__ */ jsx(SearchButton, { onClick: handleOpenSearchFullscreen, ref: setSearchOpenButtonEl }), $[82] = handleOpenSearchFullscreen, $[83] = shouldRender.searchFullscreen, $[84] = t40) : t40 = $[84];
  let t41;
  $[85] !== shouldRender.tools ? (t41 = shouldRender.tools && /* @__PURE__ */ jsx(CapabilityGate, { capability: "globalUserMenu", children: /* @__PURE__ */ jsx(Box, { flex: "none", marginLeft: 1, children: /* @__PURE__ */ jsx(UserMenu, {}) }) }), $[85] = shouldRender.tools, $[86] = t41) : t41 = $[86];
  let t42;
  $[87] !== actionNodes || $[88] !== t34 || $[89] !== t36 || $[90] !== t38 || $[91] !== t39 || $[92] !== t40 || $[93] !== t41 ? (t42 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, justify: "flex-end", children: [
    t34,
    t35,
    actionNodes,
    t36,
    t37,
    t38,
    t39,
    t40,
    t41
  ] }) }), $[87] = actionNodes, $[88] = t34, $[89] = t36, $[90] = t38, $[91] = t39, $[92] = t40, $[93] = t41, $[94] = t42) : t42 = $[94];
  let t43;
  $[95] !== t30 || $[96] !== t32 || $[97] !== t42 ? (t43 = /* @__PURE__ */ jsxs(NavGrid, { gap: 1, children: [
    t30,
    t32,
    t42
  ] }), $[95] = t30, $[96] = t32, $[97] = t42, $[98] = t43) : t43 = $[98];
  let t44;
  $[99] !== t23 || $[100] !== t43 ? (t44 = /* @__PURE__ */ jsx(RootCard$1, { tone: t23, borderBottom: !0, "data-testid": "studio-navbar", "data-ui": "Navbar", padding: 3, sizing: "border", children: t43 }), $[99] = t23, $[100] = t43, $[101] = t44) : t44 = $[101];
  let t45;
  $[102] !== actions || $[103] !== activeToolName || $[104] !== drawerOpen || $[105] !== handleCloseDrawer || $[106] !== shouldRender.tools || $[107] !== tools ? (t45 = !shouldRender.tools && /* @__PURE__ */ jsx(NavDrawer, { __internal_actions: actions, activeToolName, isOpen: drawerOpen, onClose: handleCloseDrawer, tools }), $[102] = actions, $[103] = activeToolName, $[104] = drawerOpen, $[105] = handleCloseDrawer, $[106] = shouldRender.tools, $[107] = tools, $[108] = t45) : t45 = $[108];
  let t46;
  return $[109] !== searchFullscreenOpen || $[110] !== t44 || $[111] !== t45 ? (t46 = /* @__PURE__ */ jsx(FreeTrialProvider, { children: /* @__PURE__ */ jsxs(RootLayer, { zOffset: 100, "data-search-open": searchFullscreenOpen, children: [
    t44,
    t45
  ] }) }), $[109] = searchFullscreenOpen, $[110] = t44, $[111] = t45, $[112] = t46) : t46 = $[112], t46;
}
function _temp2$5(action) {
  const {
    render: ActionComponent
  } = action;
  return ActionComponent ? /* @__PURE__ */ jsx(ActionComponent, {}, action.name) : /* @__PURE__ */ jsx(Button, { iconRight: action?.icon, mode: "bleed", onClick: action?.onAction, selected: action.selected, text: action.title }, action.name);
}
function _temp$d(v) {
  return v.location === "topbar";
}
function _isReactElement(node) {
  return !!node;
}
const OptionObserveElement = styled(ObserveElement)`
  list-style: none;
  white-space: nowrap;
  flex-shrink: 0;
  opacity: 0;
  visibility: hidden;
`, HiddenRow = styled(Flex)`
  opacity: 0;
  height: 0.1px;
  overflow: hidden;
`, CollapseTabList = forwardRef(function(props2, ref) {
  const {
    children: childrenProp,
    gap,
    menuButtonProps,
    disableRestoreFocusOnClose,
    onMenuClose,
    collapsed,
    ...rest
  } = props2, [rootEl, setRootEl] = useState(null), [hiddenElements, setHiddenElements] = useState([]), [showChildren, setShowChildren] = useState(!1), children = useMemo(() => Children.toArray(childrenProp).filter(_isReactElement), [childrenProp]), displayChildren = useMemo(() => collapsed || !showChildren ? null : children.filter((c2) => !hiddenElements.some((h) => h.key === c2.key)), [children, collapsed, hiddenElements, showChildren]), intersectionOptions = useMemo(() => ({
    root: rootEl,
    threshold: 1,
    rootMargin: "1px"
  }), [rootEl]), menuButton = useMemo(() => menuButtonProps?.button || /* @__PURE__ */ jsx(ContextMenuButton, {}), [menuButtonProps]), menuOptionsArray = useMemo(() => collapsed ? children : children.filter(({
    key
  }) => (
    // eslint-disable-next-line max-nested-callbacks
    hiddenElements.find((o) => o.key === key)
  )), [children, hiddenElements, collapsed]), handleIntersection = useCallback((e, child) => {
    const isHidden = hiddenElements.some((el) => el.key === child.key);
    showChildren || setShowChildren(!0);
    const isIntersecting = e.isIntersecting;
    !isHidden && !isIntersecting && setHiddenElements((prev) => [...prev, child]), isHidden && isIntersecting && setHiddenElements((prev_0) => prev_0.filter((el_0) => el_0.key !== child.key));
  }, [hiddenElements, showChildren, setShowChildren, setHiddenElements]);
  return /* @__PURE__ */ jsxs(Flex, { direction: "column", ref, sizing: "border", style: {
    position: "relative"
  }, ...rest, children: [
    /* @__PURE__ */ jsxs(Flex, { justify: "center", gap, flex: 1, children: [
      displayChildren,
      (hiddenElements.length > 0 || collapsed) && /* @__PURE__ */ jsx(CollapseOverflowMenu, { disableRestoreFocusOnClose, menuButton, menuButtonProps, menuOptions: menuOptionsArray, onMenuClose })
    ] }),
    /* @__PURE__ */ jsxs(HiddenRow, { justify: "flex-start", gap, ref: setRootEl, "data-hidden": !0, "aria-hidden": "true", children: [
      cloneElement(menuButton, {
        disabled: !0,
        "aria-hidden": !0
      }),
      children?.map((child_0) => /* @__PURE__ */ jsx(
        OptionObserveElement,
        {
          options: intersectionOptions,
          onIntersectionChange: (e_0) => handleIntersection(e_0[0], child_0),
          children: cloneElement(child_0, {
            disabled: !0,
            "aria-hidden": !0,
            tabIndex: -1
          })
        },
        `${child_0.key}_observer`
      ))
    ] })
  ] });
});
function ToolCollapseMenu(props2) {
  const $ = c(13), {
    activeToolName,
    tools
  } = props2, scheme = useColorSchemeValue(), [collapseMenuEl, setCollapseMenuEl] = useState(null);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = ["arrows"], $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== collapseMenuEl ? (t1 = {
    rootElement: collapseMenuEl,
    navigation: t0
  }, $[1] = collapseMenuEl, $[2] = t1) : t1 = $[2], useRovingFocus(t1);
  let t2, t3;
  $[3] !== scheme ? (t3 = {
    popover: {
      constrainSize: !0,
      portal: !0,
      scheme,
      tone: "default"
    }
  }, $[3] = scheme, $[4] = t3) : t3 = $[4], t2 = t3;
  const menuButtonProps = t2;
  let t4, t5;
  if ($[5] !== activeToolName || $[6] !== tools) {
    let t62;
    $[8] !== activeToolName ? (t62 = (tool, index) => {
      const title = tool?.title || startCase(tool.name), Link2 = forwardRef(function(linkProps, ref) {
        return /* @__PURE__ */ jsx(ToolLink, { ...linkProps, ref, name: tool.name, children: linkProps.children });
      });
      return /* @__PURE__ */ jsx(Button, { as: Link2, "data-as": "a", mode: "bleed", selected: activeToolName === tool.name, text: title }, `${tool.name}-${index}`);
    }, $[8] = activeToolName, $[9] = t62) : t62 = $[9], t5 = tools.map(t62), $[5] = activeToolName, $[6] = tools, $[7] = t5;
  } else
    t5 = $[7];
  t4 = t5;
  const children = t4;
  let t6;
  return $[10] !== children || $[11] !== menuButtonProps ? (t6 = /* @__PURE__ */ jsx(Flex, { justify: "center", marginX: 4, children: /* @__PURE__ */ jsx(CollapseTabList, { "data-testid": "tool-collapse-menu", gap: 1, menuButtonProps, ref: setCollapseMenuEl, children }) }), $[10] = children, $[11] = menuButtonProps, $[12] = t6) : t6 = $[12], t6;
}
function ToolVerticalMenu(props2) {
  const $ = c(9), {
    activeToolName,
    isVisible: isVisible2,
    tools
  } = props2;
  let t0, t1;
  if ($[0] !== activeToolName || $[1] !== isVisible2 || $[2] !== tools) {
    let t22;
    $[4] !== activeToolName || $[5] !== isVisible2 ? (t22 = (tool) => {
      const title = tool?.title || startCase(tool.name), Link2 = forwardRef(function(linkProps, ref) {
        return /* @__PURE__ */ jsx(ToolLink, { ...linkProps, ref, name: tool.name, children: linkProps.children });
      });
      return /* @__PURE__ */ jsx(Stack, { as: "li", children: /* @__PURE__ */ jsx(Button, { as: Link2, justify: "flex-start", mode: "bleed", selected: activeToolName === tool.name, size: "large", tabIndex: isVisible2 ? 0 : -1, text: title }) }, tool.name);
    }, $[4] = activeToolName, $[5] = isVisible2, $[6] = t22) : t22 = $[6], t1 = tools.map(t22), $[0] = activeToolName, $[1] = isVisible2, $[2] = tools, $[3] = t1;
  } else
    t1 = $[3];
  let t2;
  return $[7] !== t1 ? (t2 = /* @__PURE__ */ jsx(Stack, { as: "ul", space: 1, children: t1 }), $[7] = t1, $[8] = t2) : t2 = $[8], t0 = t2, t0;
}
const HIDDEN_STUDIO_MENU_TOOLS = ["releases"];
function StudioToolMenu(props2) {
  const $ = c(17);
  let context, isSidebarOpen, restProps, tools;
  $[0] !== props2 ? ({
    context,
    isSidebarOpen,
    tools,
    ...restProps
  } = props2, $[0] = props2, $[1] = context, $[2] = isSidebarOpen, $[3] = restProps, $[4] = tools) : (context = $[1], isSidebarOpen = $[2], restProps = $[3], tools = $[4]);
  const {
    enabled: scheduledPublishingEnabled
  } = useScheduledPublishingEnabled();
  let t0, t1;
  if ($[5] !== scheduledPublishingEnabled || $[6] !== tools) {
    let t22;
    $[8] !== scheduledPublishingEnabled ? (t22 = (tool) => tool.name === SCHEDULED_PUBLISHING_TOOL_NAME && !scheduledPublishingEnabled ? !1 : !HIDDEN_STUDIO_MENU_TOOLS.includes(tool.name), $[8] = scheduledPublishingEnabled, $[9] = t22) : t22 = $[9], t1 = tools.filter(t22), $[5] = scheduledPublishingEnabled, $[6] = tools, $[7] = t1;
  } else
    t1 = $[7];
  t0 = t1;
  const visibleTools = t0;
  if (visibleTools.length <= 1)
    return null;
  if (context === "sidebar") {
    let t22;
    return $[10] !== isSidebarOpen || $[11] !== restProps || $[12] !== visibleTools ? (t22 = /* @__PURE__ */ jsx(ToolVerticalMenu, { isVisible: isSidebarOpen, tools: visibleTools, ...restProps }), $[10] = isSidebarOpen, $[11] = restProps, $[12] = visibleTools, $[13] = t22) : t22 = $[13], t22;
  }
  let t2;
  return $[14] !== restProps || $[15] !== visibleTools ? (t2 = /* @__PURE__ */ jsx(ToolCollapseMenu, { tools: visibleTools, ...restProps }), $[14] = restProps, $[15] = visibleTools, $[16] = t2) : t2 = $[16], t2;
}
const FieldCopied = defineEvent({
  name: "Field Copied",
  version: 1,
  description: 'User clicked the "Copy field" button in the field action menu or used the Ctrl+C shortcut'
}), FieldPasted = defineEvent({
  name: "Field Pasted",
  version: 1,
  description: 'User clicked the "Paste field" button in the field action menu or used the Ctrl+V shortcut'
});
function getSchemaField(schemaType, fieldPath) {
  if (!fieldPath) return;
  const paths = fromString(fieldPath), firstPath = paths[0];
  if (firstPath && isObjectSchemaType(schemaType)) {
    const field = schemaType?.fields?.find((f) => f.name === firstPath);
    if (field) {
      const nextPath = toString(paths.slice(1));
      return nextPath ? getSchemaField(field.type, nextPath) : field;
    }
  }
}
function resolveSchemaTypeForPath(baseType, path, documentValue) {
  if (!baseType) return;
  let currentField = baseType;
  return path.forEach((segment, index) => {
    const nextPath = path.slice(0, index + 1);
    if (isKeySegment(segment) || isIndexSegment(segment)) {
      const arraySchemaType = currentField, itemValue = getValueAtPath(documentValue, nextPath), item = getItemType(arraySchemaType, itemValue);
      if (item) {
        currentField = item;
        return;
      }
    }
    const nextField = getSchemaField(currentField, toString(nextPath.length > 1 ? nextPath.slice(-1) : nextPath));
    nextField?.type && (currentField = nextField.type);
  }), currentField;
}
const MIMETYPE_SANITY_CLIPBOARD = "web application/vnd.sanity-clipboard-item+json", MIMETYPE_HTML = "text/html", MIMETYPE_PLAINTEXT = "text/plain", SUPPORTS_SANITY_CLIPBOARD_MIMETYPE = typeof ClipboardItem < "u" && "supports" in ClipboardItem && ClipboardItem.supports(MIMETYPE_SANITY_CLIPBOARD), BASE64_ATTR = "sanity-clipboard-base64";
async function getClipboardItem() {
  const items = await navigator.clipboard.read();
  for (const item of items) {
    const sanityClipboardItem = await parseClipboardItem(item);
    if (sanityClipboardItem)
      return sanityClipboardItem;
  }
  return null;
}
async function writeClipboardItem(copyActionResult) {
  const textValue = transformValueToText(copyActionResult.value), escapedTextValue = escapeHtml(textValue), base64SanityClipboardItem = utf8ToBase64(JSON.stringify(copyActionResult)), clipboardItem = new ClipboardItem({
    ...SUPPORTS_SANITY_CLIPBOARD_MIMETYPE && {
      [MIMETYPE_SANITY_CLIPBOARD]: new Blob([JSON.stringify(copyActionResult)], {
        type: MIMETYPE_SANITY_CLIPBOARD
      })
    },
    [MIMETYPE_HTML]: new Blob(
      // we store the data within a data attribute because safari will sanitize
      // and mangle the HTML written to the clipboard
      // https://stackoverflow.com/a/68958287/5776910
      [`<p data-${BASE64_ATTR}="${base64SanityClipboardItem}">${escapedTextValue}</p>`],
      {
        type: MIMETYPE_HTML
      }
    ),
    [MIMETYPE_PLAINTEXT]: new Blob([textValue], {
      type: MIMETYPE_PLAINTEXT
    })
  });
  try {
    return await navigator.clipboard.write([clipboardItem]), !0;
  } catch (error) {
    return console.error(`Failed to write to clipboard: ${error.message}`, error), !1;
  }
}
async function parseClipboardItem(item) {
  if (item.types.includes(MIMETYPE_SANITY_CLIPBOARD)) {
    const text = await (await item.getType(MIMETYPE_SANITY_CLIPBOARD)).text();
    return JSON.parse(text);
  }
  if (!item.types.includes(MIMETYPE_HTML)) return null;
  const html = await (await item.getType(MIMETYPE_HTML)).text(), doc = new DOMParser().parseFromString(html, "text/html");
  try {
    const el = doc.querySelector(`[data-${BASE64_ATTR}]`);
    if (!el) return null;
    const {
      sanityClipboardBase64
    } = el.dataset;
    return sanityClipboardBase64 ? JSON.parse(base64ToUtf8(sanityClipboardBase64)) : null;
  } catch {
    return null;
  }
}
function utf8ToBase64(text) {
  const uint8Array = new TextEncoder().encode(text);
  let binary = "";
  for (let i = 0; i < uint8Array.byteLength; i++)
    binary += String.fromCharCode(uint8Array[i]);
  return btoa(binary);
}
function base64ToUtf8(base64String) {
  const binary = atob(base64String), uint8Array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++)
    uint8Array[i] = binary.charCodeAt(i);
  return new TextDecoder().decode(uint8Array);
}
function escapeHtml(text) {
  return new DOMParser().parseFromString(text, "text/html").documentElement.textContent;
}
function transformValueToText(value) {
  return value ? isString(value) ? value : Number.isFinite(value) ? value.toString() : Array.isArray(value) ? value.map(transformValueToText).filter(Boolean).join(", ") : typeof value == "object" ? Object.entries(value).map(([key, subValue]) => key.startsWith("_") ? "" : transformValueToText(subValue)).filter(Boolean).join(", ") : "" : "";
}
function isEmptyValue(value) {
  return !!(value == null || Array.isArray(value) && value.length === 0);
}
function isNativeEditableElement(el) {
  return !!(el instanceof HTMLElement && el.isContentEditable || el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement);
}
function hasSelection() {
  if (typeof window > "u" || !window.getSelection) return !1;
  const selection = window.getSelection();
  return selection !== null && !selection.isCollapsed;
}
function isEmptyFocusPath(path) {
  return path.length === 0 || path.length === 1 && path[0] === "";
}
async function documentMatchesGroqFilter(rootDocumentValue, referencedDocument, schemaTypeOptions, targetRootPath, getClient2) {
  if (!schemaTypeOptions.filter)
    return !0;
  const options = await resolveUserDefinedFilter$2(schemaTypeOptions, rootDocumentValue, targetRootPath, getClient2);
  if (!options.filter)
    return !0;
  try {
    const params = options.params || {}, query = `*[${options.filter}]`, tree = parse$2(query, params), result = await (await evaluate(tree, {
      params,
      dataset: [referencedDocument]
    })).get();
    return !isEmptyValue(result);
  } catch (error) {
    return console.error("Error evaluating GROQ filter:", error), !1;
  }
}
function getObjectTypeFromPath(path) {
  if (path.length === 0)
    return "object";
  const lastPathSegment = path[path.length - 1];
  return isKeySegment(lastPathSegment) || isIndexSegment(lastPathSegment) || isIndexTuple(lastPathSegment) ? "object" : lastPathSegment;
}
function isCompatiblePrimitiveType(value, targetJsonTypes) {
  return !!(typeof value == "string" && targetJsonTypes.includes("string") || typeof value == "number" && (targetJsonTypes.includes("number") || targetJsonTypes.includes("string")) || typeof value == "boolean" && targetJsonTypes.includes("boolean"));
}
function isNumberToStringSchemaType(a, b) {
  return isRecord$4(a) && isRecord$4(b) && (a.jsonType === "number" && b.jsonType === "string" || isNumberToStringSchemaType(a.type, b.type));
}
function arrayJsonTypes(schemaType) {
  return schemaType.of.map((type) => type.jsonType);
}
function isNumberToArrayOfStrings(a, b) {
  return isRecord$4(a) && isRecord$4(b) && (a.jsonType === "number" && isArrayOfPrimitivesSchemaType(b) && arrayJsonTypes(b).includes("string") || isNumberToArrayOfStrings(a.type, b.type));
}
const defaultKeyGenerator = () => randomKey(12);
function resolveReadOnlyAncestor({
  path,
  value,
  schemaType,
  currentUser
}) {
  return !!path.find((_, index) => {
    const currentPath = path.slice(0, index + 1), schemaTypeAtPath = resolveSchemaTypeForPath(schemaType, currentPath, value);
    if (!schemaTypeAtPath)
      throw new Error(`Could not find target schema type at path ${path.join(".")}`);
    return resolveConditionalProperty(schemaTypeAtPath.readOnly, {
      value,
      parent: null,
      document: value,
      currentUser
    });
  });
}
async function transferValue({
  sourceRootSchemaType,
  sourcePath,
  sourceValue,
  sourceRootPath = [],
  targetRootSchemaType,
  targetRootValue,
  targetRootPath,
  targetValue,
  targetPath,
  keyGenerator: keyGenerator2 = defaultKeyGenerator,
  targetDocumentSchemaType,
  currentUser,
  options = {
    validateReferences: !0,
    validateAssets: !0,
    client: void 0
  }
}) {
  const errors = [];
  if (!sourceRootSchemaType)
    throw new Error("Source root schema type is not defined");
  if (!targetRootSchemaType)
    throw new Error("Target root schema type is not defined");
  const sourceSchemaTypeAtPath = resolveSchemaTypeForPath(sourceRootSchemaType, sourcePath, sourceValue), targetSchemaTypeAtPath = resolveSchemaTypeForPath(targetRootSchemaType, targetPath, targetValue);
  if (!sourceSchemaTypeAtPath)
    throw new Error("Could not find source schema type at path");
  if (!targetSchemaTypeAtPath)
    throw new Error("Could not find target schema type at path");
  const targetRootSchemaTypeReadOnly = resolveConditionalProperty(targetRootSchemaType.readOnly, {
    value: targetRootValue,
    parent: null,
    document: targetRootValue,
    currentUser
  }), targetSchemaTypeAtPathReadOnly = resolveConditionalProperty(targetSchemaTypeAtPath.readOnly, {
    value: targetValue,
    parent: null,
    document: targetRootValue,
    currentUser
  }), isAncestorReadOnly = resolveReadOnlyAncestor({
    path: targetRootPath,
    value: targetRootValue,
    schemaType: targetDocumentSchemaType,
    currentUser
  });
  if (targetRootSchemaTypeReadOnly || targetSchemaTypeAtPathReadOnly || isAncestorReadOnly)
    return {
      targetValue: void 0,
      errors: [{
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.read-only-target.description"
        }
      }]
    };
  if (isFileSchemaType(sourceSchemaTypeAtPath) && isImageSchemaType(targetSchemaTypeAtPath) || isImageSchemaType(sourceSchemaTypeAtPath) && isFileSchemaType(targetSchemaTypeAtPath))
    return {
      targetValue: void 0,
      errors: [{
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.image-file-incompatible.description",
          args: {
            sourceSchemaType: sourceRootSchemaType.name,
            targetSchemaType: targetRootSchemaType.name
          }
        }
      }]
    };
  const sourceJsonType = sourceSchemaTypeAtPath.jsonType, targetJsonType = targetSchemaTypeAtPath.jsonType, lastSourcePathSegment = last$1(sourceRootPath), isIndexSourcePathSegmentKey = typeof lastSourcePathSegment < "u" && isIndexSegment(lastSourcePathSegment), isSourceSinglePrimitiveArrayItem = sourcePath.length === 0 && sourceJsonType === "array" && !Array.isArray(sourceValue) && isIndexSourcePathSegmentKey, isPrimitiveSourceAndPrimitiveArrayTarget = (["number", "string", "boolean"].includes(sourceJsonType) || isSourceSinglePrimitiveArrayItem) && isArrayOfPrimitivesSchemaType(targetSchemaTypeAtPath), isObjectSourceAndArrayOfObjectsTarget = sourceJsonType === "object" && isArrayOfObjectsSchemaType(targetSchemaTypeAtPath);
  if (!(sourceJsonType === targetJsonType || isNumberToStringSchemaType(sourceSchemaTypeAtPath, targetSchemaTypeAtPath) || isNumberToArrayOfStrings(sourceSchemaTypeAtPath, targetSchemaTypeAtPath) || isPrimitiveSourceAndPrimitiveArrayTarget || isObjectSourceAndArrayOfObjectsTarget))
    return {
      targetValue: void 0,
      errors: [{
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.schema-type-incompatible.description"
        }
      }]
    };
  const sourceValueAtPath = getValueAtPath(sourceValue, sourcePath);
  if (sourceSchemaTypeAtPath.jsonType === "object" && targetSchemaTypeAtPath.jsonType === "object")
    return collateObjectValue({
      sourceValue: sourceValueAtPath,
      targetSchemaType: targetSchemaTypeAtPath,
      targetRootValue,
      targetRootPath,
      targetPath: [],
      errors,
      keyGenerator: keyGenerator2,
      options
    });
  if (sourceSchemaTypeAtPath.jsonType === "array" && targetSchemaTypeAtPath.jsonType === "array") {
    const wrappedSourceValueAtPath = isSourceSinglePrimitiveArrayItem && !Array.isArray(sourceValueAtPath) ? [sourceValueAtPath] : sourceValueAtPath;
    return collateArrayValue({
      sourceValue: wrappedSourceValueAtPath,
      targetSchemaType: targetSchemaTypeAtPath,
      targetRootValue,
      targetRootPath,
      errors,
      options,
      keyGenerator: keyGenerator2
    });
  }
  if (isPrimitiveSourceAndPrimitiveArrayTarget || isObjectSourceAndArrayOfObjectsTarget) {
    let objectType;
    isObjectSourceAndArrayOfObjectsTarget && isTypedObject(sourceValueAtPath) && sourceValueAtPath._type === "object" || !isTypedObject(sourceValueAtPath) ? objectType = getObjectTypeFromPath(sourceRootPath) : isTypedObject(sourceValueAtPath) ? objectType = sourceValueAtPath._type : objectType = "object";
    const wrappedSourceValue = isObjectSourceAndArrayOfObjectsTarget && !Array.isArray(sourceValueAtPath) ? [{
      ...sourceValueAtPath,
      _type: objectType,
      _key: keyGenerator2()
    }] : [sourceValueAtPath];
    return collateArrayValue({
      sourceValue: Array.isArray(sourceValueAtPath) ? sourceValueAtPath : wrappedSourceValue,
      targetSchemaType: targetSchemaTypeAtPath,
      targetRootValue,
      targetRootPath,
      errors,
      options,
      keyGenerator: keyGenerator2
    });
  }
  return collatePrimitiveValue({
    sourceValue: sourceValueAtPath,
    targetSchemaType: targetSchemaTypeAtPath,
    errors
  });
}
async function collateObjectValue({
  sourceValue,
  targetSchemaType,
  targetPath,
  targetRootValue,
  targetRootPath,
  errors,
  keyGenerator: keyGenerator2,
  options
}) {
  if (isEmptyValue(sourceValue))
    return {
      targetValue: void 0,
      errors
    };
  const targetValue = {
    _type: targetSchemaType.name,
    ...sourceValue && typeof sourceValue == "object" && "_key" in sourceValue ? {
      _key: keyGenerator2()
    } : {}
  }, sourceValueRef = isAssetObjectStub(sourceValue) && isReference$1(sourceValue.asset) ? sourceValue.asset._ref : void 0, sourceValueType = isTypedObject(sourceValue) ? sourceValue._type : void 0, isImageRef = sourceValueRef && isImageAssetId(sourceValueRef), isFileRef = sourceValueRef && isFileAssetId(sourceValueRef), isIncompatibleImageRef = (sourceValueType === "image" || isImageRef) && !isImageSchemaType(targetSchemaType), isIncompatibleFileRef = (sourceValueType === "file" || isFileRef) && !isFileSchemaType(targetSchemaType);
  if (isTypedObject(sourceValue) && (isIncompatibleImageRef || isIncompatibleFileRef))
    return errors.push({
      level: "error",
      sourceValue,
      i18n: {
        key: "copy-paste.on-paste.validation.image-file-incompatible.description",
        args: {
          sourceSchemaType: sourceValueType,
          targetSchemaType: targetSchemaType.name
        }
      }
    }), {
      targetValue: void 0,
      errors
    };
  if (options?.validateAssets && options.client && (isImageSchemaType(targetSchemaType) || isFileSchemaType(targetSchemaType)) && targetSchemaType.options?.accept && isAssetObjectStub(sourceValue) && isReference$1(sourceValue.asset)) {
    const sourceRef = sourceValue.asset?._ref;
    if (!sourceRef)
      return {
        targetValue: void 0,
        errors
      };
    try {
      const assetType = isImageSchemaType(targetSchemaType) ? "sanity.imageAsset" : "sanity.fileAsset", asset = await options.client.fetch("*[_type == $type &&_id == $ref][0]{mimeType, originalFilename}", {
        ref: sourceRef,
        type: assetType
      });
      if (!asset)
        return {
          targetValue: void 0,
          errors
        };
      const fileLike = {
        type: asset.mimeType,
        name: asset.originalFilename
      }, mimeType = asset.mimeType;
      if (!accepts(fileLike, targetSchemaType.options.accept))
        return errors.push({
          level: "error",
          sourceValue,
          i18n: {
            key: "copy-paste.on-paste.validation.mime-type-incompatible.description",
            args: {
              mimeType
            }
          }
        }), {
          targetValue: void 0,
          errors
        };
    } catch (error) {
      return console.error("Error fetching asset document:", error), errors.push({
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.mime-type-validation-failed.description"
        }
      }), {
        targetValue: void 0,
        errors
      };
    }
  }
  if (isReferenceSchemaType(targetSchemaType)) {
    const targetReferenceTypes = targetSchemaType.to.map((type) => type.name);
    if (options?.validateReferences && options.client && isReference$1(sourceValue))
      try {
        const query = targetSchemaType.options?.filter ? "*[_id in $ids]|order(_updatedAt)[0]" : "*[_id in $ids]|order(_updatedAt)[0]{_id, _type}", {
          publishedId,
          draftId
        } = getIdPair(sourceValue._ref), reference = await options.client.fetch(query, {
          ids: [publishedId, draftId]
        });
        if (!reference && !targetSchemaType.weak)
          return errors.push({
            level: "error",
            sourceValue,
            i18n: {
              key: "copy-paste.on-paste.validation.reference-validation-failed.description",
              args: {
                ref: sourceValue._ref
              }
            }
          }), {
            targetValue: void 0,
            errors
          };
        if (reference && !targetReferenceTypes.includes(reference._type))
          return errors.push({
            level: "error",
            sourceValue,
            i18n: {
              key: "copy-paste.on-paste.validation.reference-type-incompatible.description",
              args: {
                sourceReferenceType: reference._type,
                targetReferenceTypes: targetReferenceTypes.join(", ")
              }
            }
          }), {
            targetValue: void 0,
            errors
          };
        if (options.client && targetSchemaType.options?.filter) {
          const getClient2 = (clientOptions2) => options.client.withConfig(clientOptions2);
          if (!await documentMatchesGroqFilter(targetRootValue || {}, reference, targetSchemaType.options, targetRootPath, getClient2))
            return errors.push({
              level: "error",
              sourceValue,
              i18n: {
                key: "copy-paste.on-paste.validation.reference-filter-incompatible.description"
              }
            }), {
              targetValue: void 0,
              errors
            };
        }
      } catch (error) {
        return console.error("Error fetching reference document:", error), errors.push({
          level: "error",
          sourceValue: targetValue,
          i18n: {
            key: "copy-paste.on-paste.validation.reference-validation-failed.description",
            args: {
              ref: sourceValue._ref
            }
          }
        }), {
          targetValue: void 0,
          errors
        };
      }
  }
  const markDefKeyMap = {}, isPortableTextBlockWithMarkdefs = isBlockSchemaType(targetSchemaType) && isPortableTextTextBlock(sourceValue) && !isEmptyValue(sourceValue.markDefs);
  if (isPortableTextBlockWithMarkdefs) {
    const markDefs = sourceValue.markDefs || [];
    markDefs.filter((item) => item._key).forEach((item) => {
      markDefKeyMap[item._key] = keyGenerator2();
    }), targetValue.markDefs = markDefs.map((item) => ({
      ...item,
      _key: markDefKeyMap[item._key]
    }));
  }
  const objectMembers = targetSchemaType.fields;
  for (const member of objectMembers) {
    const memberSchemaType = member.type, memberIsArray = isArraySchemaType(memberSchemaType), memberIsObject = isObjectSchemaType(memberSchemaType);
    if (isPrimitiveSchemaType(memberSchemaType)) {
      const genericValue = sourceValue ? sourceValue[member.name] : void 0, collated = collatePrimitiveValue({
        sourceValue: genericValue,
        targetSchemaType: memberSchemaType,
        errors
      });
      isEmptyValue(collated.targetValue) || (targetValue[member.name] = collated.targetValue);
    } else if (memberIsObject) {
      const collated = await collateObjectValue({
        sourceValue: getValueAtPath(sourceValue, targetPath.concat(member.name)),
        targetPath: [],
        targetSchemaType: memberSchemaType,
        targetRootValue,
        targetRootPath,
        errors,
        options,
        keyGenerator: keyGenerator2
      });
      isEmptyValue(collated.targetValue) || (targetValue[member.name] = cleanObjectKeys(collated.targetValue));
    } else if (memberIsArray) {
      const genericValue = sourceValue ? sourceValue[member.name] : void 0, collated = await collateArrayValue({
        sourceValue: genericValue,
        targetSchemaType: memberSchemaType,
        targetRootValue,
        targetRootPath,
        errors,
        options,
        keyGenerator: keyGenerator2
      });
      if (isPortableTextBlockWithMarkdefs && member.name === "markDefs" && !isEmptyValue(targetValue.markDefs))
        continue;
      isEmptyValue(collated.targetValue) || (targetValue[member.name] = collated.targetValue);
    }
  }
  const valueAtTargetPath = getValueAtPath(targetValue, targetPath), resultingValue = cleanObjectKeys(valueAtTargetPath);
  return Object.keys(markDefKeyMap).length > 0 && isPortableTextTextBlock(resultingValue) && (resultingValue.children = resultingValue.children.map((child) => isPortableTextSpan(child) && child.marks ? {
    ...child,
    marks: [...child.marks.map((markKey) => markDefKeyMap[markKey] || markKey)]
  } : child)), isReferenceSchemaType(targetSchemaType) && (targetSchemaType.weak ? resultingValue._weak = !0 : delete resultingValue._weak), isReferenceSchemaType(targetSchemaType) && isReference$1(sourceValue) && sourceValue._strengthenOnPublish && (resultingValue._weak = !0, resultingValue._strengthenOnPublish = sourceValue._strengthenOnPublish), {
    targetValue: resultingValue,
    errors
  };
}
async function collateArrayValue({
  sourceValue,
  targetSchemaType,
  targetRootValue,
  targetRootPath,
  errors,
  options,
  keyGenerator: keyGenerator2
}) {
  let targetValue;
  const genericValue = sourceValue;
  if (!genericValue || !Array.isArray(genericValue))
    return {
      targetValue: void 0,
      errors: [{
        level: "error",
        sourceValue,
        i18n: {
          key: "copy-paste.on-paste.validation.array-type-incompatible.description",
          args: {
            type: typeof genericValue
          }
        }
      }]
    };
  const isArrayOfPrimitivesMember = isArrayOfPrimitivesSchemaType(targetSchemaType), isArrayOfObjectsMember = isArrayOfObjectsSchemaType(targetSchemaType);
  if (isArrayOfPrimitivesMember) {
    const jsonTypes = targetSchemaType.of.map((type) => type.jsonType), isNumberCompatible = jsonTypes.includes("number"), transferredItems = genericValue.filter((item) => isCompatiblePrimitiveType(item, jsonTypes)).map((item) => !isNumberCompatible && typeof item == "number" ? `${item}` : item), nonTransferredItems = genericValue.filter((item) => !transferredItems.includes(!isNumberCompatible && typeof item == "number" ? `${item}` : item));
    nonTransferredItems.length > 0 && nonTransferredItems.forEach((item) => {
      errors.push({
        level: transferredItems.length > 0 ? "warning" : "error",
        sourceValue: item,
        i18n: {
          key: "copy-paste.on-paste.validation.array-value-incompatible.description",
          args: {
            type: typeof item
          }
        }
      });
    }), transferredItems.length > 0 && (targetValue = transferredItems);
  }
  if (isArrayOfObjectsMember) {
    const value = sourceValue, transferredItems = value.filter((item) => targetSchemaType.of.some((type) => type.name === item._type)), nonTransferredItems = value.filter((item) => !targetSchemaType.of.some((type) => type.name === item._type));
    transferredItems.length === 0 ? targetValue = void 0 : targetValue = (await Promise.all(transferredItems.map((item) => collateObjectValue({
      sourceValue: item,
      targetSchemaType: targetSchemaType.of.find((type) => type.name === item._type),
      targetPath: [],
      targetRootValue,
      targetRootPath,
      errors,
      options,
      keyGenerator: keyGenerator2
    })))).map((item) => item.targetValue).filter((item) => !isEmptyValue(item)), nonTransferredItems.length > 0 && nonTransferredItems.forEach((item) => {
      errors.push({
        level: transferredItems.length > 0 ? "warning" : "error",
        sourceValue: item,
        i18n: {
          key: "copy-paste.on-paste.validation.array-value-incompatible.description",
          args: {
            type: item._type || typeof item
          }
        }
      });
    });
  }
  return {
    targetValue,
    errors
  };
}
function collatePrimitiveValue({
  sourceValue,
  targetSchemaType,
  errors
}) {
  let targetValue;
  const primitiveValue = sourceValue;
  if (typeof primitiveValue > "u")
    return {
      targetValue: void 0,
      errors
    };
  const isSamePrimitiveType = targetSchemaType.jsonType === typeof primitiveValue, isNumberToString = typeof primitiveValue == "number" && targetSchemaType.jsonType === "string";
  if (isSamePrimitiveType || isNumberToString) {
    const isNumberOrString = typeof primitiveValue == "string" || typeof primitiveValue == "number";
    if ((isNumberSchemaType(targetSchemaType) || isStringSchemaType(targetSchemaType)) && isNumberOrString) {
      const allowedStrings = targetSchemaType.options?.list?.map((item) => typeof item == "string" || typeof item == "number" ? item : item.value) || [];
      allowedStrings.length > 0 && !allowedStrings.includes(primitiveValue) && errors.push({
        level: "error",
        sourceValue: primitiveValue,
        i18n: {
          key: "copy-paste.on-paste.validation.string-value-incompatible.description",
          args: {
            value: primitiveValue,
            allowedStrings
          }
        }
      });
    }
    targetValue = isNumberToString ? `${primitiveValue}` : primitiveValue;
  } else
    errors.push({
      level: "error",
      sourceValue: primitiveValue,
      i18n: {
        key: "copy-paste.on-paste.validation.primitive-type-incompatible.description",
        args: {
          type: typeof primitiveValue
        }
      }
    });
  return {
    targetValue,
    errors
  };
}
function cleanObjectKeys(obj) {
  const disallowedKeys = ["_id", "_createdAt", "_updatedAt", "_rev"];
  return Object.keys(obj).reduce((acc, key) => disallowedKeys.includes(key) ? acc : {
    ...acc,
    [key]: obj[key]
  }, {});
}
const CopyPasteProvider = ({
  children
}) => {
  const toast = useToast(), telemetry = useTelemetry(), schema2 = useSchema(), currentUser = useCurrentUser(), {
    t
  } = useTranslation("copy-paste"), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [documentMeta, setDocumentMetaState] = useState(null), setDocumentMeta = useCallback(({
    documentId,
    documentType,
    schemaType,
    onChange
  }) => {
    const processedMeta = {
      documentId: getPublishedId(documentId),
      documentType,
      schemaType,
      onChange
    };
    setDocumentMetaState((prevMeta) => isEqual$2(prevMeta, processedMeta) ? prevMeta : processedMeta);
  }, []), onCopy = useCallback(async (path, value, options) => {
    if (!documentMeta) return;
    const {
      documentId: documentId_0,
      documentType: documentType_0,
      schemaType: schemaType_0
    } = documentMeta, schemaTypeAtPath = resolveSchemaTypeForPath(schemaType_0, path, value);
    if (!schemaTypeAtPath) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-copy.validation.schema-type-incompatible.title", {
          path: PathUtils.toString(path)
        })
      });
      return;
    }
    const isDocument = schemaTypeAtPath.type?.name === "document", valueAtPath = getValueAtPath(value, path);
    if (isEmptyValue(valueAtPath)) {
      toast.push({
        status: "warning",
        title: t("copy-paste.on-copy.validation.no-value.title")
      });
      return;
    }
    const lastSegment = path.length > 0 ? last$1(path) : void 0, isLastSegmentKeyOrIndex = lastSegment && (isKeySegment(lastSegment) || isIndexSegment(lastSegment)), isAppend = options.context.source === "arrayItem" || isLastSegmentKeyOrIndex || options.patchType === "append", normalizedPath = isAppend && isLastSegmentKeyOrIndex ? path.slice(0, -1) : path, patchType = isAppend ? "append" : "replace", shouldWrapInArray = isLastSegmentKeyOrIndex && !Array.isArray(valueAtPath), payloadValue = {
      type: "sanityClipboardItem",
      documentId: documentId_0,
      documentType: documentType_0,
      isDocument,
      schemaTypeName: schemaTypeAtPath.name,
      valuePath: normalizedPath,
      value: shouldWrapInArray ? [valueAtPath] : valueAtPath,
      patchType
    };
    telemetry.log(FieldCopied, {
      context: options?.context?.source || "unknown",
      schemaTypes: [schemaTypeAtPath.jsonType]
    }), await writeClipboardItem(payloadValue) || toast.push({
      status: "error",
      title: t("copy-paste.on-copy.validation.clipboard-not-supported.title")
    });
  }, [documentMeta, telemetry, toast, t]), onPaste = useCallback(async (targetPath, value_0, options_0) => {
    if (!documentMeta) return;
    const {
      schemaType: targetDocumentSchemaType,
      onChange: onChange_0
    } = documentMeta, targetSchemaType = resolveSchemaTypeForPath(targetDocumentSchemaType, targetPath, value_0), clipboardItem = await getClipboardItem();
    if (!clipboardItem) {
      toast.push({
        status: "info",
        title: t("copy-paste.on-paste.validation.clipboard-empty.title")
      });
      return;
    }
    if (!clipboardItem.documentType) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-paste.validation.clipboard-invalid.title")
      });
      return;
    }
    const sourceDocumentSchemaType = schema2.get(clipboardItem.documentType);
    if (!sourceDocumentSchemaType) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-paste.validation.clipboard-invalid.title")
      });
      return;
    }
    const updateItems = [], copiedJsonTypes = [], sourceSchemaType = resolveSchemaTypeForPath(sourceDocumentSchemaType, clipboardItem.valuePath, value_0);
    if (!sourceSchemaType) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-paste.validation.schema-type-incompatible.title", {
          path: PathUtils.toString(clipboardItem.valuePath)
        })
      });
      return;
    }
    if (!targetDocumentSchemaType) {
      toast.push({
        status: "error",
        title: t("copy-paste.on-paste.validation.schema-type-incompatible.title", {
          path: PathUtils.toString(targetPath)
        })
      });
      return;
    }
    const targetSchemaTypeTitle = targetSchemaType.title || targetSchemaType.name, transferValueOptions = {
      targetDocumentSchemaType,
      sourceRootSchemaType: sourceSchemaType,
      sourcePath: [],
      sourceRootPath: clipboardItem.valuePath,
      sourceValue: clipboardItem.value,
      targetRootSchemaType: targetSchemaType,
      targetPath: [],
      // This will mainly be used for validating references with filter callback that
      // needs the document and absolute path to the field
      targetRootPath: targetPath,
      targetRootValue: value_0,
      currentUser,
      options: {
        validateAssets: !0,
        validateReferences: !0,
        client
      }
    };
    copiedJsonTypes.push(sourceSchemaType.jsonType);
    try {
      const {
        targetValue,
        errors
      } = await transferValue(transferValueOptions), nonWarningErrors = errors.filter((error_0) => error_0.level !== "warning"), _isEmptyValue = isEmptyValue(targetValue);
      if (nonWarningErrors.length > 0) {
        const description = t(nonWarningErrors[0].i18n.key, nonWarningErrors[0].i18n.args);
        toast.push({
          status: "error",
          title: t("copy-paste.on-paste.validation.clipboard-invalid.title"),
          description
        });
        return;
      }
      if (errors.length > 0 && !_isEmptyValue) {
        const description_0 = errors.map((error_1) => t(error_1.i18n.key, error_1.i18n.args)).join(", ");
        toast.push({
          status: "warning",
          title: t("copy-paste.on-paste.validation.partial-warning.title"),
          description: description_0
        });
      }
      if (_isEmptyValue) {
        toast.push({
          status: "warning",
          title: t("copy-paste.on-paste.validation.clipboard-empty.title")
        });
        return;
      }
      const patchType_0 = clipboardItem?.patchType || "replace", isAppendable = clipboardItem.schemaTypeName !== "array" && targetSchemaType.jsonType === "array" || patchType_0 === "append", isAppendArray = isAppendable && targetPath.length > 0 && targetSchemaType.jsonType === "array", insertPath = isAppendable && targetPath.length > 0 ? [...targetPath.slice(0, -1), `${targetPath.slice(-1)?.[0]}[-1]`] : targetPath, prefixPatches = targetSchemaType.jsonType === "array" ? [setIfMissing([], targetPath)] : [];
      updateItems.push({
        patches: isAppendArray ? [...prefixPatches, insert$1(targetValue, "after", insertPath)] : [...prefixPatches, set(targetValue, targetPath)],
        targetSchemaTypeTitle
      });
    } catch (error) {
      toast.push({
        status: "error",
        title: error.message
      });
      return;
    }
    if (telemetry.log(FieldPasted, {
      context: options_0?.context?.source || "unknown",
      schemaTypes: copiedJsonTypes
    }), updateItems.length) {
      const allPatches = flatten$1(updateItems.map(({
        patches
      }) => patches));
      onChange_0(PatchEvent.from(allPatches));
    }
  }, [documentMeta, schema2, currentUser, client, telemetry, toast, t]), contextValue = useMemo(() => ({
    setDocumentMeta,
    onCopy,
    onPaste
  }), [onCopy, onPaste, setDocumentMeta]);
  return /* @__PURE__ */ jsx(CopyPasteContext.Provider, { value: contextValue, children });
}, useCopyPaste = () => {
  const context = useContext(CopyPasteContext);
  if (!context)
    throw new Error("useCopyPaste must be used within a CopyPasteProvider");
  return context;
}, SCROLLBAR_SIZE = 12, SCROLLBAR_BORDER_SIZE = 4;
function buildResizeHandleDataUri(hexColor) {
  const encodedStrokeColor = encodeURIComponent(hexColor);
  return `url("data:image/svg+xml,${`%3Csvg width='9' height='9' viewBox='0 0 9 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 8L8 1' stroke='${encodedStrokeColor}' stroke-linecap='round'/%3E%3Cpath d='M5 8L8 5' stroke='${encodedStrokeColor}' stroke-linecap='round'/%3E%3C/svg%3E%0A`}")`;
}
const GlobalStyle = createGlobalStyle((props2) => {
  const {
    color,
    font
  } = getTheme_v2(props2.theme);
  return css`
    ::-webkit-resizer {
      background-image: ${buildResizeHandleDataUri(color.icon)};
      background-repeat: no-repeat;
      background-position: bottom right;
    }

    ::-webkit-scrollbar {
      width: ${SCROLLBAR_SIZE}px;
      height: ${SCROLLBAR_SIZE}px;
    }

    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-clip: content-box;
      background-color: var(--card-border-color, ${color.border});
      border: ${SCROLLBAR_BORDER_SIZE}px solid transparent;
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: var(--card-muted-fg-color, ${color.muted.fg});
    }

    ::-webkit-scrollbar-track {
      background: transparent;
    }

    *::selection {
      background-color: ${rgba$1(color.focusRing, 0.3)};
    }

    html {
      background-color: ${color.bg};
    }

    body {
      scrollbar-gutter: stable;
    }

    #sanity {
      font-family: ${font.text.family};
    }

    b {
      font-weight: ${font.text.weights.medium};
    }

    strong {
      font-weight: ${font.text.weights.medium};
    }
  `;
});
function PerspectiveProvider(t0) {
  const $ = c(16), {
    children,
    selectedPerspectiveName,
    excludedPerspectives: t1
  } = t0, excludedPerspectives = t1 === void 0 ? EMPTY_ARRAY$A : t1, {
    data: releases2
  } = useActiveReleases();
  let t2, t3;
  $[0] !== releases2 || $[1] !== selectedPerspectiveName ? (t3 = getSelectedPerspective(selectedPerspectiveName, releases2), $[0] = releases2, $[1] = selectedPerspectiveName, $[2] = t3) : t3 = $[2], t2 = t3;
  const selectedPerspective = t2;
  let t4, t5;
  $[3] !== excludedPerspectives || $[4] !== releases2 || $[5] !== selectedPerspectiveName ? (t5 = getReleasesPerspectiveStack({
    releases: releases2,
    selectedPerspectiveName,
    excludedPerspectives
  }), $[3] = excludedPerspectives, $[4] = releases2, $[5] = selectedPerspectiveName, $[6] = t5) : t5 = $[6], t4 = t5;
  const perspectiveStack = t4;
  let t6;
  const t7 = isSystemBundleName(selectedPerspectiveName) ? void 0 : selectedPerspectiveName;
  let t8;
  $[7] !== excludedPerspectives || $[8] !== perspectiveStack || $[9] !== selectedPerspective || $[10] !== selectedPerspectiveName || $[11] !== t7 ? (t8 = {
    selectedPerspective,
    selectedPerspectiveName,
    selectedReleaseId: t7,
    perspectiveStack,
    excludedPerspectives
  }, $[7] = excludedPerspectives, $[8] = perspectiveStack, $[9] = selectedPerspective, $[10] = selectedPerspectiveName, $[11] = t7, $[12] = t8) : t8 = $[12], t6 = t8;
  const value = t6;
  let t9;
  return $[13] !== children || $[14] !== value ? (t9 = /* @__PURE__ */ jsx(PerspectiveContext.Provider, { value, children }), $[13] = children, $[14] = value, $[15] = t9) : t9 = $[15], t9;
}
const getToastTitleAndDescription = (archived) => archived ? archived.state === "published" ? {
  title: "release.toast.published-release.title",
  description: "release.toast.published-release.description"
} : {
  title: "release.toast.archived-release.title",
  description: "release.toast.archived-release.description"
} : {
  title: "release.toast.not-found-release.title"
}, ResetPerspectiveHandler = () => {
  const $ = c(9), toast = useToast(), {
    t
  } = useTranslation(), {
    data: releases2,
    loading: releasesLoading
  } = useActiveReleases(), {
    data: archivedReleases
  } = useArchivedReleases(), {
    selectedPerspectiveName
  } = usePerspective(), setPerspective = useSetPerspective();
  let t0, t1;
  return $[0] !== archivedReleases || $[1] !== releases2 || $[2] !== releasesLoading || $[3] !== selectedPerspectiveName || $[4] !== setPerspective || $[5] !== t || $[6] !== toast ? (t0 = () => {
    if (!(releasesLoading || !selectedPerspectiveName || isPublishedPerspective(selectedPerspectiveName)) && !releases2.some((release) => getReleaseIdFromReleaseDocumentId(release._id) === selectedPerspectiveName)) {
      setPerspective(LATEST);
      const archived = archivedReleases.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === selectedPerspectiveName), {
        title,
        description
      } = getToastTitleAndDescription(archived);
      toast.push({
        id: `bundle-deleted-toast-${selectedPerspectiveName}`,
        status: "warning",
        title: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: title, values: {
          title: archived?.metadata?.title || selectedPerspectiveName
        } }) }),
        description: description && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: description }) }),
        duration: 1e4
      });
    }
  }, t1 = [archivedReleases, selectedPerspectiveName, releases2, releasesLoading, setPerspective, toast, t], $[0] = archivedReleases, $[1] = releases2, $[2] = releasesLoading, $[3] = selectedPerspectiveName, $[4] = setPerspective, $[5] = t, $[6] = toast, $[7] = t0, $[8] = t1) : (t0 = $[7], t1 = $[8]), useEffect(t0, t1), null;
};
function GlobalPerspectiveProvider(t0) {
  const $ = c(7), {
    children
  } = t0, router = useRouter(), selectedPerspectiveName = router.stickyParams.perspective;
  let t1, t2;
  $[0] !== router.stickyParams.excludedPerspectives ? (t2 = router.stickyParams.excludedPerspectives?.split(",") || EMPTY_ARRAY$A, $[0] = router.stickyParams.excludedPerspectives, $[1] = t2) : t2 = $[1], t1 = t2;
  const excludedPerspectives = t1;
  let t3;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(ResetPerspectiveHandler, {}), $[2] = t3) : t3 = $[2];
  let t4;
  return $[3] !== children || $[4] !== excludedPerspectives || $[5] !== selectedPerspectiveName ? (t4 = /* @__PURE__ */ jsxs(PerspectiveProvider, { selectedPerspectiveName, excludedPerspectives, children: [
    children,
    t3
  ] }), $[3] = children, $[4] = excludedPerspectives, $[5] = selectedPerspectiveName, $[6] = t4) : t4 = $[6], t4;
}
function AuthBoundary(t0) {
  const $ = c(16), {
    children,
    AuthenticateComponent: t1,
    LoadingComponent: t2,
    NotAuthenticatedComponent: t3
  } = t0, AuthenticateComponent = t1 === void 0 ? AuthenticateScreen : t1, LoadingComponent = t2 === void 0 ? LoadingBlock : t2, NotAuthenticatedComponent = t3 === void 0 ? NotAuthenticatedScreen : t3, [error, handleError] = useState(null);
  if (error)
    throw error;
  const [loggedIn, setLoggedIn] = useState("loading"), [loginProvider, setLoginProvider] = useState(), {
    activeWorkspace
  } = useActiveWorkspace();
  let t4, t5;
  $[0] !== activeWorkspace.auth ? (t4 = () => {
    activeWorkspace.auth.handleCallbackUrl?.().catch(handleError);
  }, t5 = [activeWorkspace.auth], $[0] = activeWorkspace.auth, $[1] = t4, $[2] = t5) : (t4 = $[1], t5 = $[2]), useEffect(t4, t5);
  let t6;
  $[3] !== activeWorkspace.auth.state ? (t6 = () => {
    const subscription = activeWorkspace.auth.state.subscribe({
      next: (t72) => {
        const {
          authenticated,
          currentUser
        } = t72;
        if (currentUser?.roles?.length === 0) {
          setLoggedIn("unauthorized"), currentUser?.provider && setLoginProvider(currentUser.provider);
          return;
        }
        setLoggedIn(authenticated ? "logged-in" : "logged-out");
      },
      error: handleError
    });
    return () => {
      subscription.unsubscribe();
    };
  }, $[3] = activeWorkspace.auth.state, $[4] = t6) : t6 = $[4];
  let t7;
  if ($[5] !== activeWorkspace ? (t7 = [activeWorkspace], $[5] = activeWorkspace, $[6] = t7) : t7 = $[6], useEffect(t6, t7), loggedIn === "loading") {
    let t82;
    return $[7] !== LoadingComponent ? (t82 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[7] = LoadingComponent, $[8] = t82) : t82 = $[8], t82;
  }
  if (loggedIn === "unauthorized") {
    if (!loginProvider || loginProvider === "sanity") {
      let t83;
      return $[9] !== NotAuthenticatedComponent ? (t83 = /* @__PURE__ */ jsx(NotAuthenticatedComponent, {}), $[9] = NotAuthenticatedComponent, $[10] = t83) : t83 = $[10], t83;
    }
    let t82;
    return $[11] === Symbol.for("react.memo_cache_sentinel") ? (t82 = /* @__PURE__ */ jsx(RequestAccessScreen, {}), $[11] = t82) : t82 = $[11], t82;
  }
  if (loggedIn === "logged-out") {
    let t82;
    return $[12] !== AuthenticateComponent ? (t82 = /* @__PURE__ */ jsx(AuthenticateComponent, {}), $[12] = AuthenticateComponent, $[13] = t82) : t82 = $[13], t82;
  }
  let t8;
  return $[14] !== children ? (t8 = /* @__PURE__ */ jsx(Fragment, { children }), $[14] = children, $[15] = t8) : t8 = $[15], t8;
}
function useComlinkRouteHandler() {
  const $ = c(4), {
    node
  } = useComlinkStore(), {
    navigateUrl
  } = useRouter();
  let t0, t1;
  $[0] !== navigateUrl || $[1] !== node ? (t0 = () => node?.on("dashboard/v1/history/change-path", (t2) => {
    const {
      path
    } = t2;
    navigateUrl({
      path: sanitizePath(path),
      replace: !1
    });
  }), t1 = [navigateUrl, node], $[0] = navigateUrl, $[1] = node, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
}
function sanitizePath(path) {
  return path.replace(/^\/+/, "/");
}
const ComlinkRouteHandler = () => (useComlinkRouteHandler(), null), Z_OFFSET$1 = {
  toast: [100, 11e3]
}, CONSENT_CLIENT_OPTIONS = {
  apiVersion: "2023-12-18"
};
function MaybeEnableErrorReporting(props2) {
  const $ = c(6), {
    errorReporter: errorReporter2
  } = props2, client = useClient(CONSENT_CLIENT_OPTIONS);
  let t0;
  $[0] !== client.observable || $[1] !== errorReporter2 ? (t0 = () => {
    const request = client.observable.request({
      uri: "/intake/telemetry-status",
      tag: "telemetry-consent.error-reporting"
    }).subscribe({
      next: (res) => {
        res?.status === "granted" ? errorReporter2.enable() : errorReporter2.disable();
      },
      error: _temp$c
    });
    return () => request.unsubscribe();
  }, $[0] = client.observable, $[1] = errorReporter2, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== client || $[4] !== errorReporter2 ? (t1 = [client, errorReporter2], $[3] = client, $[4] = errorReporter2, $[5] = t1) : t1 = $[5], useEffect(t0, t1), null;
}
function _temp$c(err) {
  console.error("Error fetching telemetry status", err);
}
const isStaging = typeof __SANITY_STAGING__ < "u" && __SANITY_STAGING__ === !0, MODULES_URL_VERSION = "v1", MODULES_HOST = isStaging ? "https://sanity-cdn.work" : "https://sanity-cdn.com", MODULES_URL = `${MODULES_HOST}/${MODULES_URL_VERSION}/modules/`, fetchLatestVersionForPackage = async (pkg, version) => {
  try {
    const timestamp = `t${Math.floor(Date.now() / 1e3)}`;
    return (await fetch(`${MODULES_URL}${pkg}/default/^${version}/${timestamp}`, {
      headers: {
        accept: "application/json"
      }
    })).json().then((data) => data.packageVersion);
  } catch (err) {
    console.error("Failed to fetch latest version for package", pkg, "Error:", err);
    return;
  }
}, checkForLatestVersions = async (packages) => {
  const results = await Promise.all(Object.entries(packages).map(async ([pkg, version]) => [pkg, await fetchLatestVersionForPackage(pkg, version)]));
  return Object.fromEntries(results);
}, REFRESH_INTERVAL = 1e3 * 30, SHOW_TOAST_FREQUENCY = 1e3 * 60 * 30, currentPackageVersions = {
  sanity: SANITY_VERSION
};
function PackageVersionStatusProvider(t0) {
  const $ = c(9), {
    children
  } = t0, toast = useToast(), {
    t
  } = useTranslation(), lastCheckedTimeRef = useRef(null);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = hasSanityPackageInImportMap(), $[0] = t1) : t1 = $[0];
  const autoUpdatingPackages = t1;
  let t2;
  $[1] !== t || $[2] !== toast ? (t2 = () => {
    const onClick2 = _temp$b;
    toast.push({
      id: "new-package-available",
      title: t("package-version.new-package-available.title"),
      description: /* @__PURE__ */ jsx(Box, { paddingTop: 2, children: /* @__PURE__ */ jsx(Button, { size: "large", "aria-label": t("package-version.new-package-available.reload-button"), onClick: onClick2, text: t("package-version.new-package-available.reload-button"), tone: "primary" }) }),
      closable: !0,
      status: "info",
      duration: 20736e5
    });
  }, $[1] = t, $[2] = toast, $[3] = t2) : t2 = $[3];
  const showNewPackageAvailableToast = t2;
  let t3, t4;
  $[4] !== showNewPackageAvailableToast ? (t3 = () => {
    if (!autoUpdatingPackages)
      return;
    const fetchLatestVersions = () => {
      lastCheckedTimeRef.current && lastCheckedTimeRef.current + SHOW_TOAST_FREQUENCY > Date.now() || checkForLatestVersions(currentPackageVersions).then((latestPackageVersions) => {
        lastCheckedTimeRef.current = Date.now(), latestPackageVersions && Object.entries(latestPackageVersions).some(_temp2$4) && showNewPackageAvailableToast();
      });
    };
    fetchLatestVersions();
    const intervalId = setInterval(fetchLatestVersions, REFRESH_INTERVAL);
    return () => clearInterval(intervalId);
  }, t4 = [autoUpdatingPackages, showNewPackageAvailableToast], $[4] = showNewPackageAvailableToast, $[5] = t3, $[6] = t4) : (t3 = $[5], t4 = $[6]), useEffect(t3, t4);
  let t5;
  return $[7] !== children ? (t5 = /* @__PURE__ */ jsx(Fragment, { children }), $[7] = children, $[8] = t5) : t5 = $[8], t5;
}
function _temp2$4(t0) {
  const [pkg, version] = t0;
  return !version || !currentPackageVersions[pkg] ? !1 : semver.gt(version, currentPackageVersions[pkg]);
}
function _temp$b() {
  window.location.reload();
}
const keyframe = keyframes`
  0% {
    background-position: 100%;
  }
  100% {
    background-position: -100%;
  }
`, Root$8 = styled.div((props2) => {
  const theme = getTheme_v2(props2.theme), cardHoverBg = theme.color.selectable.default.hovered.bg, cardNormalBg = theme.color.selectable.default.enabled.bg;
  return css`
    position: relative;
    cursor: pointer;
    // hide the close button
    #close-floating-button {
      opacity: 0;
      transition: opacity 0.2s;
    }

    &:hover {
      > [data-ui='whats-new-card'] {
        --card-bg-color: ${cardHoverBg};
        box-shadow: inset 0 0 2px 1px var(--card-skeleton-color-to);
        background-image: linear-gradient(
          to right,
          var(--card-bg-color),
          var(--card-bg-color),
          ${cardNormalBg},
          var(--card-bg-color),
          var(--card-bg-color),
          var(--card-bg-color)
        );
        background-position: 100%;
        background-size: 200% 100%;
        background-attachment: fixed;
        animation-name: ${keyframe};
        animation-timing-function: ease-in;
        animation-iteration-count: infinite;
        animation-duration: 2000ms;
      }
      #close-floating-button {
        opacity: 1;
        background: transparent;

        &:hover {
          transition: all 0.2s;
          box-shadow: 0 0 0 1px ${theme.color.selectable.default.hovered.border};
        }
      }
    }
  `;
}), ButtonRoot = styled.div`
  z-index: 1;
  position: absolute;
  top: 0px;
  right: 6px;
`;
function StudioAnnouncementsCard(t0) {
  const $ = c(37), {
    title,
    id: id2,
    isOpen,
    name,
    preHeader,
    onCardClick,
    onCardDismiss
  } = t0, {
    t
  } = useTranslation(), telemetry = useTelemetry();
  let t1, t2;
  $[0] !== id2 || $[1] !== isOpen || $[2] !== name || $[3] !== telemetry || $[4] !== title ? (t1 = () => {
    isOpen && telemetry.log(ProductAnnouncementCardSeen, {
      announcement_id: id2,
      announcement_title: title,
      announcement_internal_name: name,
      source: "studio",
      studio_version: SANITY_VERSION
    });
  }, t2 = [telemetry, id2, title, isOpen, name], $[0] = id2, $[1] = isOpen, $[2] = name, $[3] = telemetry, $[4] = title, $[5] = t1, $[6] = t2) : (t1 = $[5], t2 = $[6]), useEffect(t1, t2);
  let t3;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    bottom: 12,
    left: 12,
    top: "none"
  }, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t ? (t4 = t("announcement.floating-button.open-label"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== preHeader ? (t5 = /* @__PURE__ */ jsx(Box, { marginRight: 6, children: /* @__PURE__ */ jsx(Text$1, { as: "h3", size: 1, muted: !0, children: preHeader }) }), $[10] = preHeader, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== title ? (t6 = /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", children: title }), $[12] = title, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== t5 || $[15] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t5,
    t6
  ] }), $[14] = t5, $[15] = t6, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== onCardClick || $[18] !== t4 || $[19] !== t7 ? (t8 = /* @__PURE__ */ jsx(Card, { "data-ui": "whats-new-card", padding: 3, radius: 3, onClick: onCardClick, role: "button", "aria-label": t4, children: t7 }), $[17] = onCardClick, $[18] = t4, $[19] = t7, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== t ? (t9 = t("announcement.floating-button.dismiss-label"), $[21] = t, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== t ? (t10 = t("announcement.floating-button.dismiss"), $[23] = t, $[24] = t10) : t10 = $[24];
  let t11;
  $[25] !== t10 ? (t11 = {
    content: t10
  }, $[25] = t10, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== onCardDismiss || $[28] !== t11 || $[29] !== t9 ? (t12 = /* @__PURE__ */ jsx(ButtonRoot, { children: /* @__PURE__ */ jsx(Button, { id: "close-floating-button", mode: "bleed", onClick: onCardDismiss, icon: CloseIcon, tone: "default", "aria-label": t9, tooltipProps: t11 }) }), $[27] = onCardDismiss, $[28] = t11, $[29] = t9, $[30] = t12) : t12 = $[30];
  let t13;
  $[31] !== t12 || $[32] !== t8 ? (t13 = /* @__PURE__ */ jsxs(Root$8, { "data-ui": "whats-new-root", children: [
    t8,
    t12
  ] }), $[31] = t12, $[32] = t8, $[33] = t13) : t13 = $[33];
  let t14;
  return $[34] !== isOpen || $[35] !== t13 ? (t14 = /* @__PURE__ */ jsx(Popover, { open: isOpen, shadow: 3, portal: !0, style: t3, width: 0, placement: "bottom-start", content: t13 }), $[34] = isOpen, $[35] = t13, $[36] = t14) : t14 = $[36], t14;
}
const Hr = styled.hr`
  height: 1px;
  background: var(--card-border-color);
  width: 100%;
  opacity: ${({
  $show
}) => $show ? 1 : 0};
  transition: opacity 0.3s ease;
  margin: 0;
  border: none;
`, DIVIDER_FADE_THRESHOLD = "-60px 0px 0px 0px";
function Divider(t0) {
  const $ = c(6), {
    parentRef
  } = t0, itemRef = useRef(null), [show, setShow] = useState(!0);
  let t1;
  $[0] !== parentRef.current ? (t1 = () => {
    const item = itemRef.current, parent = parentRef.current;
    if (!item || !parent)
      return;
    const observer = new IntersectionObserver((t22) => {
      const [entry] = t22;
      setShow(entry.isIntersecting);
    }, {
      root: parent,
      threshold: 0,
      rootMargin: DIVIDER_FADE_THRESHOLD
    });
    return observer.observe(item), () => {
      observer.disconnect();
    };
  }, $[0] = parentRef.current, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== parentRef ? (t2 = [parentRef], $[2] = parentRef, $[3] = t2) : t2 = $[3], useEffect(t1, t2);
  let t3;
  return $[4] !== show ? (t3 = /* @__PURE__ */ jsx(Box, { paddingBottom: 4, children: /* @__PURE__ */ jsx(Box, { paddingY: 3, paddingX: 3, children: /* @__PURE__ */ jsx(Hr, { ref: itemRef, $show: show }) }) }), $[4] = show, $[5] = t3) : t3 = $[5], t3;
}
const DATE_FORMAT_OPTIONS = {
  month: "short",
  day: "2-digit"
}, Root$7 = styled(Box)`
  overflow: auto;
  max-height: 75vh;
`, DialogHeader = styled(Grid)`
  position: sticky;
  display: grid;
  grid-template-columns: 64px 1fr 64px;
  top: 0;
  z-index: 1;
  background: var(--card-bg-color);
`, FloatingButtonBox = styled(Box)`
  position: absolute;
  top: 12px;
  right: 24px;
  z-index: 2;
`, FloatingButton = styled(Button)``;
function Announcement(t0) {
  const $ = c(35), {
    announcement,
    mode,
    isFirst,
    parentRef
  } = t0, telemetry = useTelemetry(), dateFormatter = useDateTimeFormat(DATE_FORMAT_OPTIONS), logViewedItemRef = useRef(null);
  let t1;
  bb0: {
    if (!announcement.publishedDate) {
      t1 = "";
      break bb0;
    }
    let t22;
    $[0] !== announcement.publishedDate || $[1] !== dateFormatter ? (t22 = dateFormatter.format(new Date(announcement.publishedDate)), $[0] = announcement.publishedDate, $[1] = dateFormatter, $[2] = t22) : t22 = $[2], t1 = t22;
  }
  const formattedDate = t1;
  let t2;
  $[3] !== announcement._id || $[4] !== announcement.name || $[5] !== announcement.title || $[6] !== mode || $[7] !== telemetry ? (t2 = (t32) => {
    const {
      url,
      linkTitle
    } = t32;
    telemetry.log(ProductAnnouncementLinkClicked, {
      announcement_id: announcement._id,
      announcement_title: announcement.title,
      announcement_internal_name: announcement.name,
      source: "studio",
      studio_version: SANITY_VERSION,
      origin: mode,
      link_url: url,
      link_title: linkTitle
    });
  }, $[3] = announcement._id, $[4] = announcement.name, $[5] = announcement.title, $[6] = mode, $[7] = telemetry, $[8] = t2) : t2 = $[8];
  const handleLinkClick = t2;
  let t3;
  $[9] !== announcement._id || $[10] !== announcement.name || $[11] !== announcement.title || $[12] !== mode || $[13] !== telemetry ? (t3 = (scrolledIntoView) => {
    telemetry.log(ProductAnnouncementViewed, {
      announcement_id: announcement._id,
      announcement_title: announcement.title,
      announcement_internal_name: announcement.name,
      source: "studio",
      studio_version: SANITY_VERSION,
      scrolled_into_view: scrolledIntoView,
      origin: mode
    });
  }, $[9] = announcement._id, $[10] = announcement.name, $[11] = announcement.title, $[12] = mode, $[13] = telemetry, $[14] = t3) : t3 = $[14];
  const logViewed = t3;
  let t4, t5;
  $[15] !== isFirst || $[16] !== logViewed || $[17] !== parentRef ? (t4 = () => {
    if (isFirst) {
      logViewed(!1);
      return;
    }
    const item = logViewedItemRef.current, parent = parentRef.current;
    if (!item || !parent)
      return;
    const observer = new IntersectionObserver((t62) => {
      const [entry] = t62;
      entry.isIntersecting && (logViewed(!0), observer.disconnect());
    }, {
      root: parent,
      threshold: 1,
      rootMargin: "0px 0px -100px 0px"
    });
    return observer.observe(item), () => {
      observer.disconnect();
    };
  }, t5 = [logViewed, parentRef, isFirst], $[15] = isFirst, $[16] = logViewed, $[17] = parentRef, $[18] = t4, $[19] = t5) : (t4 = $[18], t5 = $[19]), useEffect(t4, t5);
  let t6;
  $[20] !== formattedDate ? (t6 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 2, paddingRight: 0, children: /* @__PURE__ */ jsx(Box, { paddingLeft: 2, children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: formattedDate }) }) }), $[20] = formattedDate, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== announcement.title ? (t7 = /* @__PURE__ */ jsx(Flex, { flex: 1, padding: 2, justify: "center", ref: logViewedItemRef, children: /* @__PURE__ */ jsx(Text$1, { as: "h2", size: 1, weight: "semibold", children: announcement.title }) }), $[22] = announcement.title, $[23] = t7) : t7 = $[23];
  let t8;
  $[24] !== t6 || $[25] !== t7 ? (t8 = /* @__PURE__ */ jsxs(DialogHeader, { padding: 3, children: [
    t6,
    t7
  ] }), $[24] = t6, $[25] = t7, $[26] = t8) : t8 = $[26];
  let t9;
  $[27] !== announcement.body ? (t9 = announcement.body || [], $[27] = announcement.body, $[28] = t9) : t9 = $[28];
  let t10;
  $[29] !== handleLinkClick || $[30] !== t9 ? (t10 = /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(UpsellDescriptionSerializer, { blocks: t9, onLinkClick: handleLinkClick }) }), $[29] = handleLinkClick, $[30] = t9, $[31] = t10) : t10 = $[31];
  let t11;
  return $[32] !== t10 || $[33] !== t8 ? (t11 = /* @__PURE__ */ jsxs(Box, { children: [
    t8,
    t10
  ] }), $[32] = t10, $[33] = t8, $[34] = t11) : t11 = $[34], t11;
}
function StudioAnnouncementsDialog(t0) {
  const $ = c(21), {
    announcements: t1,
    onClose,
    mode
  } = t0;
  let t2;
  $[0] !== t1 ? (t2 = t1 === void 0 ? [] : t1, $[0] = t1, $[1] = t2) : t2 = $[1];
  const announcements = t2, dialogRef = useRef(null), {
    t
  } = useTranslation$1();
  let t3;
  $[2] !== announcements || $[3] !== mode ? (t3 = announcements.map((announcement, index) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(Announcement, { announcement, mode, isFirst: index === 0, parentRef: dialogRef }),
    index < announcements.length - 1 && /* @__PURE__ */ jsx(Divider, { parentRef: dialogRef })
  ] }, announcement._id)), $[2] = announcements, $[3] = mode, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t ? (t4 = t("announcement.dialog.close-label"), $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t ? (t5 = t("announcement.dialog.close"), $[7] = t, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t5 ? (t6 = {
    content: t5
  }, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== onClose || $[12] !== t4 || $[13] !== t6 ? (t7 = /* @__PURE__ */ jsx(FloatingButtonBox, { children: /* @__PURE__ */ jsx(FloatingButton, { "aria-label": t4, icon: CloseIcon, mode: "bleed", onClick: onClose, tooltipProps: t6 }) }), $[11] = onClose, $[12] = t4, $[13] = t6, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== t3 || $[16] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Root$7, { ref: dialogRef, height: "fill", children: [
    t3,
    t7
  ] }), $[15] = t3, $[16] = t7, $[17] = t8) : t8 = $[17];
  let t9;
  return $[18] !== onClose || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsx(Dialog$1, { id: "in-app-communication-dialog", onClose, onClickOutside: onClose, width: 1, bodyHeight: "fill", padding: !1, __unstable_hideCloseButton: !0, __unstable_autoFocus: !1, children: t8 }), $[18] = onClose, $[19] = t8, $[20] = t9) : t9 = $[20], t9;
}
const KEY = "studio.announcement.seen", RESET_PARAM = "reset-announcements", INITIAL_STATE$2 = {
  value: null,
  error: null,
  loading: !0
};
function useSeenAnnouncements() {
  const $ = c(13), router = useRouter(), keyValueStore = useKeyValueStore();
  let t0, t1;
  $[0] !== keyValueStore ? (t1 = keyValueStore.getKey(KEY).pipe(map$1(_temp$a), startWith$1(INITIAL_STATE$2), catchError$1(_temp2$3)), $[0] = keyValueStore, $[1] = t1) : t1 = $[1], t0 = t1;
  const seenAnnouncements$ = t0;
  let t2;
  $[2] !== keyValueStore ? (t2 = (seen) => {
    keyValueStore.setKey(KEY, seen);
  }, $[2] = keyValueStore, $[3] = t2) : t2 = $[3];
  const setSeenAnnouncements = t2;
  let t3;
  $[4] !== router.state._searchParams ? (t3 = new URLSearchParams(router.state._searchParams)?.get(RESET_PARAM), $[4] = router.state._searchParams, $[5] = t3) : t3 = $[5];
  const resetAnnouncementsParams = t3;
  let t4, t5;
  $[6] !== resetAnnouncementsParams || $[7] !== setSeenAnnouncements ? (t4 = () => {
    if (resetAnnouncementsParams !== null) {
      const resetValue = resetAnnouncementsParams ? resetAnnouncementsParams.split(",") : [];
      setSeenAnnouncements(resetValue);
    }
  }, t5 = [resetAnnouncementsParams, setSeenAnnouncements], $[6] = resetAnnouncementsParams, $[7] = setSeenAnnouncements, $[8] = t4, $[9] = t5) : (t4 = $[8], t5 = $[9]), useEffect(t4, t5);
  let t6;
  return $[10] !== seenAnnouncements$ || $[11] !== setSeenAnnouncements ? (t6 = [seenAnnouncements$, setSeenAnnouncements], $[10] = seenAnnouncements$, $[11] = setSeenAnnouncements, $[12] = t6) : t6 = $[12], t6;
}
function _temp2$3(error) {
  return of({
    value: null,
    error,
    loading: !1
  });
}
function _temp$a(value) {
  return {
    value,
    error: null,
    loading: !1
  };
}
const audienceRoles = ["administrator", "editor", "viewer", "contributor", "developer", "custom"];
function isValidAnnouncementAudience(document2, sanityVersion) {
  switch (document2.audience) {
    case "everyone":
      return !0;
    case "specific-version":
      return satisfies(sanityVersion, `= ${document2.studioVersion}`, {
        includePrerelease: !0
      });
    case "greater-than-or-equal-version":
      return satisfies(sanityVersion, `>= ${document2.studioVersion}`, {
        includePrerelease: !0
      });
    case "less-than-or-equal-version":
      return satisfies(sanityVersion, `<= ${document2.studioVersion}`, {
        includePrerelease: !0
      });
    default:
      return !0;
  }
}
function isValidAnnouncementRole(audience, userRoles) {
  return !audience || !audience.length ? !0 : !userRoles || !userRoles.length ? !1 : userRoles.some((role) => audience.includes(role.name)) ? !0 : userRoles.some((role) => !audienceRoles.includes(role.name)) ? audience.includes("custom") : !1;
}
const CLIENT_OPTIONS = {
  apiVersion: "v2024-09-19"
};
function StudioAnnouncementsProviderInner(t0) {
  const $ = c(47), {
    children
  } = t0, telemetry = useTelemetry(), [dialogMode, setDialogMode] = useState(null), [isCardDismissed, setIsCardDismissed] = useState(!1), [seenAnnouncements$, setSeenAnnouncements] = useSeenAnnouncements(), {
    currentUser
  } = useWorkspace(), client = useClient(CLIENT_OPTIONS);
  let t1, t2;
  if ($[0] !== client.observable || $[1] !== currentUser?.roles || $[2] !== seenAnnouncements$) {
    let t32;
    $[4] !== currentUser?.roles ? (t32 = (docs) => docs ? docs.filter((doc) => isValidAnnouncementAudience({
      audience: doc.audience,
      studioVersion: doc.studioVersion
    }, SANITY_VERSION) && isValidAnnouncementRole(doc.audienceRole, currentUser?.roles)) : [], $[4] = currentUser?.roles, $[5] = t32) : t32 = $[5];
    const allAnnouncements$ = client.observable.request({
      url: "/journey/announcements"
    }).pipe(map$1(t32), catchError$1(_temp$9), startWith$1([]));
    t2 = combineLatest([allAnnouncements$, seenAnnouncements$]).pipe(map$1(_temp2$2)), $[0] = client.observable, $[1] = currentUser?.roles, $[2] = seenAnnouncements$, $[3] = t2;
  } else
    t2 = $[3];
  t1 = t2;
  const getAnnouncements$ = t1;
  let t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    unseen: [],
    all: []
  }, $[6] = t3) : t3 = $[6];
  const announcements = useObservable(getAnnouncements$, t3), unseenAnnouncements = announcements.unseen, studioAnnouncements = announcements.all;
  let t4;
  $[7] !== setSeenAnnouncements || $[8] !== studioAnnouncements ? (t4 = () => {
    setSeenAnnouncements(studioAnnouncements.map(_temp3$1));
  }, $[7] = setSeenAnnouncements, $[8] = studioAnnouncements, $[9] = t4) : t4 = $[9];
  const saveSeenAnnouncements = t4;
  let t5;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t5 = (mode) => {
    setDialogMode(mode), setIsCardDismissed(!0);
  }, $[10] = t5) : t5 = $[10];
  const handleOpenDialog = t5;
  let t6;
  $[11] !== saveSeenAnnouncements || $[12] !== telemetry || $[13] !== unseenAnnouncements[0]?._id || $[14] !== unseenAnnouncements[0]?.name || $[15] !== unseenAnnouncements[0]?.title ? (t6 = () => {
    saveSeenAnnouncements(), setIsCardDismissed(!0), telemetry.log(ProductAnnouncementCardDismissed, {
      announcement_id: unseenAnnouncements[0]?._id,
      announcement_title: unseenAnnouncements[0]?.title,
      announcement_internal_name: unseenAnnouncements[0]?.name,
      source: "studio",
      studio_version: SANITY_VERSION
    });
  }, $[11] = saveSeenAnnouncements, $[12] = telemetry, $[13] = unseenAnnouncements[0]?._id, $[14] = unseenAnnouncements[0]?.name, $[15] = unseenAnnouncements[0]?.title, $[16] = t6) : t6 = $[16];
  const handleCardDismiss = t6;
  let t7;
  $[17] !== telemetry || $[18] !== unseenAnnouncements[0]?._id || $[19] !== unseenAnnouncements[0]?.name || $[20] !== unseenAnnouncements[0]?.title ? (t7 = () => {
    handleOpenDialog("card"), telemetry.log(ProductAnnouncementCardClicked, {
      announcement_id: unseenAnnouncements[0]?._id,
      announcement_title: unseenAnnouncements[0]?.title,
      announcement_internal_name: unseenAnnouncements[0]?.name,
      source: "studio",
      studio_version: SANITY_VERSION
    });
  }, $[17] = telemetry, $[18] = unseenAnnouncements[0]?._id, $[19] = unseenAnnouncements[0]?.name, $[20] = unseenAnnouncements[0]?.title, $[21] = t7) : t7 = $[21];
  const handleCardClick = t7;
  let t8;
  $[22] !== dialogMode || $[23] !== saveSeenAnnouncements || $[24] !== studioAnnouncements[0] || $[25] !== telemetry || $[26] !== unseenAnnouncements[0] ? (t8 = () => {
    const firstAnnouncement = dialogMode === "help_menu" ? studioAnnouncements[0] : unseenAnnouncements[0];
    telemetry.log(ProductAnnouncementModalDismissed, {
      announcement_id: firstAnnouncement?._id,
      announcement_title: firstAnnouncement?.title,
      announcement_internal_name: firstAnnouncement?.name,
      source: "studio",
      studio_version: SANITY_VERSION,
      origin: dialogMode ?? "card"
    }), setDialogMode(null), saveSeenAnnouncements();
  }, $[22] = dialogMode, $[23] = saveSeenAnnouncements, $[24] = studioAnnouncements[0], $[25] = telemetry, $[26] = unseenAnnouncements[0], $[27] = t8) : t8 = $[27];
  const handleDialogClose = t8;
  let t9, t10;
  $[28] !== studioAnnouncements || $[29] !== unseenAnnouncements ? (t10 = {
    studioAnnouncements,
    unseenAnnouncements,
    onDialogOpen: handleOpenDialog
  }, $[28] = studioAnnouncements, $[29] = unseenAnnouncements, $[30] = t10) : t10 = $[30], t9 = t10;
  const contextValue = t9;
  let t11;
  $[31] !== handleCardClick || $[32] !== handleCardDismiss || $[33] !== isCardDismissed || $[34] !== unseenAnnouncements[0] || $[35] !== unseenAnnouncements.length ? (t11 = unseenAnnouncements.length > 0 && /* @__PURE__ */ jsx(StudioAnnouncementsCard, { preHeader: unseenAnnouncements[0].preHeader, title: unseenAnnouncements[0].title, name: unseenAnnouncements[0].name, id: unseenAnnouncements[0]._id, onCardClick: handleCardClick, isOpen: !isCardDismissed, onCardDismiss: handleCardDismiss }), $[31] = handleCardClick, $[32] = handleCardDismiss, $[33] = isCardDismissed, $[34] = unseenAnnouncements[0], $[35] = unseenAnnouncements.length, $[36] = t11) : t11 = $[36];
  let t12;
  $[37] !== dialogMode || $[38] !== handleDialogClose || $[39] !== studioAnnouncements || $[40] !== unseenAnnouncements ? (t12 = dialogMode && /* @__PURE__ */ jsx(StudioAnnouncementsDialog, { mode: dialogMode, announcements: dialogMode === "help_menu" ? studioAnnouncements : unseenAnnouncements, onClose: handleDialogClose }), $[37] = dialogMode, $[38] = handleDialogClose, $[39] = studioAnnouncements, $[40] = unseenAnnouncements, $[41] = t12) : t12 = $[41];
  let t13;
  return $[42] !== children || $[43] !== contextValue || $[44] !== t11 || $[45] !== t12 ? (t13 = /* @__PURE__ */ jsxs(StudioAnnouncementContext.Provider, { value: contextValue, children: [
    children,
    t11,
    t12
  ] }), $[42] = children, $[43] = contextValue, $[44] = t11, $[45] = t12, $[46] = t13) : t13 = $[46], t13;
}
function _temp3$1(doc_1) {
  return doc_1._id;
}
function _temp2$2(t0) {
  const [all, seen] = t0;
  return seen.loading || seen.error ? {
    unseen: [],
    all
  } : seen.value ? {
    unseen: all.filter((doc_0) => !seen.value?.includes(doc_0._id)),
    all
  } : {
    unseen: all,
    all
  };
}
function _temp$9() {
  return [];
}
function StudioAnnouncementsProvider(props2) {
  const $ = c(2);
  if (useSource().announcements?.enabled) {
    let t0;
    return $[0] !== props2 ? (t0 = /* @__PURE__ */ jsx(StudioAnnouncementsProviderInner, { ...props2 }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
  }
  return props2.children;
}
function isKnownError(err) {
  return !!(err instanceof SchemaError || err instanceof CorsOriginError || err instanceof ConfigResolutionError || isObject(err) && "ViteDevServerStoppedError" in err && err.ViteDevServerStoppedError);
}
const errorChannel = globalScope.__sanityErrorChannel;
function StudioRootErrorHandler(props2) {
  const {
    children
  } = props2, [errorState, setErrorState] = useState(), handleResetError = useCallback(() => setErrorState(void 0), []), toast = useToast();
  return useHotModuleReload(handleResetError), useEffect(() => {
    if (errorChannel)
      return errorChannel.subscribe((event) => {
        if (!event.error || !(event.error instanceof Error))
          return;
        if (isKnownError(event.error)) {
          setErrorState({
            error: event.error
          });
          return;
        }
        let eventId;
        try {
          eventId = errorReporter.reportError(event.error)?.eventId;
        } catch (e) {
          e.message = `Encountered an additional error when reporting error: ${e.message}`, console.error(e);
        }
        if (isImportError(event.error)) {
          setErrorState({
            error: event.error,
            eventId
          });
          return;
        }
        toast.push({
          // Use the error message as the ID in order to prevent duplicates from showing
          // A bit of a hack, but serves
          id: event.error.message,
          closable: !0,
          description: event.error.message,
          duration: 5e3,
          title: "Uncaught error",
          status: "error"
        });
      });
  }, [toast]), errorState?.error ? errorState.error instanceof CorsOriginError ? /* @__PURE__ */ jsx(CorsOriginErrorScreen, { projectId: errorState.error.projectId }) : errorState.error instanceof SchemaError ? /* @__PURE__ */ jsx(SchemaErrorsScreen, { schema: errorState.error.schema }) : isImportError(errorState.error) ? /* @__PURE__ */ jsx(ImportErrorScreen, { error: errorState.error, eventId: errorState.eventId }) : /* @__PURE__ */ jsx(FallbackErrorScreen, { error: errorState.error, eventId: errorState.eventId, onReset: handleResetError }) : children;
}
function _buildTints(bg, mid, fg) {
  return {
    50: mix(0.1, mid, bg),
    100: mix(0.2, mid, bg),
    200: mix(0.4, mid, bg),
    300: mix(0.6, mid, bg),
    400: mix(0.8, mid, bg),
    500: mid,
    600: mix(0.8, mid, fg),
    700: mix(0.6, mid, fg),
    800: mix(0.4, mid, fg),
    900: mix(0.2, mid, fg),
    950: mix(0.1, mid, fg)
  };
}
function _toHex(color) {
  const {
    red: red2,
    green: green2,
    blue: blue2
  } = parseToRgb(color);
  return rgb(red2, green2, blue2);
}
function _isDark(bg, fg) {
  return getLuminance(bg) < getLuminance(fg);
}
function _multiply(bg, fg) {
  const b = parseColor(bg), s = parseColor(fg);
  return rgbToHex(multiply(b, s));
}
function _screen(bg, fg) {
  const b = parseColor(bg), s = parseColor(fg);
  return rgbToHex(screen(b, s));
}
const NEUTRAL_TONES = ["default", "transparent"];
function buildColor(legacyPalette, legacyTones) {
  return createColorTheme({
    base: ({
      dark: navbar,
      name
    }) => {
      const stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, dark = stateTones.dark, blend = navbar ? _screen : _multiply, tints = stateTones[name] || stateTones.default;
      if (name === "default") {
        const skeletonFrom2 = stateTones.default[100];
        return {
          fg: stateTones.fg,
          bg: stateTones.bg,
          border: stateTones.default[200],
          focusRing: legacyPalette.focus.base,
          shadow: {
            outline: rgba$1(stateTones.default[500], 0.4),
            umbra: rgba$1(dark ? legacyPalette.black : stateTones.default[500], 0.2),
            penumbra: rgba$1(dark ? legacyPalette.black : stateTones.default[500], 0.14),
            ambient: rgba$1(dark ? legacyPalette.black : stateTones.default[500], 0.12)
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (name === "transparent") {
        const bg2 = tints[50], skeletonFrom2 = blend(bg2, tints[100]);
        return {
          fg: tints[900],
          bg: bg2,
          border: tints[300],
          focusRing: legacyPalette.focus.base,
          shadow: {
            outline: rgba$1(tints[500], dark ? 0.2 : 0.4),
            umbra: rgba$1(dark ? legacyPalette.black : tints[500], 0.2),
            penumbra: rgba$1(dark ? legacyPalette.black : tints[500], 0.14),
            ambient: rgba$1(dark ? legacyPalette.black : tints[500], 0.12)
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      const bg = tints[50], skeletonFrom = blend(bg, tints[100]);
      return {
        fg: tints[900],
        bg,
        border: tints[200],
        focusRing: tints[500],
        shadow: {
          outline: rgba$1(tints[500], dark ? 0.2 : 0.4),
          umbra: rgba$1(dark ? legacyPalette.black : tints[500], 0.2),
          penumbra: rgba$1(dark ? legacyPalette.black : tints[500], 0.14),
          ambient: rgba$1(dark ? legacyPalette.black : tints[500], 0.12)
        },
        skeleton: {
          from: skeletonFrom,
          to: rgba$1(skeletonFrom, 0.5)
        }
      };
    },
    solid: ({
      base,
      dark: navbar,
      name,
      state,
      tone
    }) => {
      const buttonTones = navbar ? legacyTones.button.navbar : legacyTones.button.default, dark = buttonTones.dark, blend = dark ? _screen : _multiply, blendInvert = dark ? _multiply : _screen, defaultTints = buttonTones[name] || buttonTones.default, isNeutral = NEUTRAL_TONES.includes(name) && NEUTRAL_TONES.includes(tone);
      let tints = buttonTones[tone === "default" ? name : tone] || defaultTints;
      if (state === "disabled") {
        tints = defaultTints;
        const bg2 = blend(base.bg, tints[200]), skeletonFrom2 = blendInvert(bg2, tints[800]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[200]),
          fg: blend(base.bg, buttonTones.bg),
          icon: blend(base.bg, buttonTones.bg),
          muted: {
            fg: blend(base.bg, tints[50])
          },
          accent: {
            fg: blend(base.bg, tints[50])
          },
          link: {
            fg: blend(base.bg, tints[50])
          },
          code: {
            bg: bg2,
            fg: blend(base.bg, tints[50])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "hovered") {
        const bg2 = blend(base.bg, tints[600]), skeletonFrom2 = blendInvert(bg2, tints[800]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[600]),
          fg: blend(base.bg, buttonTones.bg),
          icon: blend(base.bg, buttonTones.bg),
          muted: {
            fg: blend(base.bg, tints[200])
          },
          accent: {
            fg: blendInvert(bg2, buttonTones.critical[300])
          },
          link: {
            fg: blendInvert(bg2, buttonTones.primary[200])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(base.bg, tints[200])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "pressed") {
        const bg2 = blend(base.bg, tints[800]), skeletonFrom2 = blendInvert(bg2, tints[800]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[800]),
          fg: blend(base.bg, buttonTones.bg),
          icon: blend(base.bg, buttonTones.bg),
          muted: {
            fg: blend(base.bg, tints[200])
          },
          accent: {
            fg: blendInvert(bg2, buttonTones.critical[300])
          },
          link: {
            fg: blendInvert(bg2, buttonTones.primary[200])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(base.bg, tints[200])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "selected") {
        isNeutral && (tints = buttonTones.primary);
        const bg2 = blend(base.bg, tints[800]), skeletonFrom2 = blendInvert(bg2, tints[800]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[800]),
          fg: blend(base.bg, buttonTones.bg),
          icon: blend(base.bg, buttonTones.bg),
          muted: {
            fg: blend(base.bg, tints[200])
          },
          accent: {
            fg: blendInvert(bg2, buttonTones.critical[300])
          },
          link: {
            fg: blendInvert(bg2, buttonTones.primary[200])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(base.bg, tints[200])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      const bg = blend(base.bg, tints[500]), skeletonFrom = blendInvert(bg, tints[800]);
      return {
        bg,
        border: blend(base.bg, tints[500]),
        fg: blend(base.bg, buttonTones.bg),
        icon: blend(base.bg, buttonTones.bg),
        muted: {
          fg: blend(base.bg, tints[100])
        },
        accent: {
          fg: blendInvert(bg, buttonTones.critical[200])
        },
        link: {
          fg: blendInvert(bg, buttonTones.primary[100])
        },
        code: {
          bg: blend(bg, tints[50]),
          fg: blend(base.bg, tints[100])
        },
        skeleton: {
          from: skeletonFrom,
          to: rgba$1(skeletonFrom, 0.5)
        }
      };
    },
    muted: ({
      base,
      dark: navbar,
      name,
      state,
      tone
    }) => {
      const stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, blend = stateTones.dark ? _screen : _multiply, defaultTints = stateTones[name] || stateTones.default, isNeutral = NEUTRAL_TONES.includes(name) && NEUTRAL_TONES.includes(tone);
      let tints = stateTones[tone === "default" ? name : tone] || defaultTints;
      if (state === "disabled") {
        tints = defaultTints;
        const bg2 = base.bg, skeletonFrom2 = blend(bg2, tints[100]);
        return {
          bg: bg2,
          border: blend(base.bg, tints[50]),
          fg: blend(base.bg, tints[200]),
          icon: blend(base.bg, tints[200]),
          muted: {
            fg: blend(bg2, tints[100])
          },
          accent: {
            fg: blend(bg2, tints[100])
          },
          link: {
            fg: blend(bg2, tints[100])
          },
          code: {
            bg: bg2,
            fg: blend(bg2, tints[100])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "hovered") {
        const bg2 = blend(base.bg, tints[50]), skeletonFrom2 = blend(bg2, tints[100]);
        return {
          bg: bg2,
          border: blend(bg2, tints[100]),
          fg: blend(base.bg, tints[900]),
          icon: blend(base.bg, tints[900]),
          muted: {
            fg: blend(base.bg, tints[600])
          },
          accent: {
            fg: blend(base.bg, stateTones.critical[500])
          },
          link: {
            fg: blend(base.bg, stateTones.primary[600])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(base.bg, tints[600])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "pressed") {
        isNeutral && (tints = stateTones.primary);
        const bg2 = blend(base.bg, tints[100]), skeletonFrom2 = blend(bg2, tints[100]);
        return {
          bg: bg2,
          border: blend(bg2, tints[100]),
          fg: blend(base.bg, tints[800]),
          icon: blend(base.bg, tints[800]),
          muted: {
            fg: blend(base.bg, tints[600])
          },
          accent: {
            fg: blend(bg2, stateTones.critical[500])
          },
          link: {
            fg: blend(bg2, stateTones.primary[600])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(bg2, tints[600])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      if (state === "selected") {
        isNeutral && (tints = stateTones.primary);
        const bg2 = blend(base.bg, tints[100]), skeletonFrom2 = blend(bg2, tints[100]);
        return {
          bg: bg2,
          border: blend(bg2, tints[100]),
          fg: blend(bg2, tints[800]),
          icon: blend(bg2, tints[800]),
          muted: {
            fg: blend(bg2, tints[600])
          },
          accent: {
            fg: blend(bg2, stateTones.critical[500])
          },
          link: {
            fg: blend(bg2, stateTones.primary[600])
          },
          code: {
            bg: blend(bg2, tints[50]),
            fg: blend(bg2, tints[600])
          },
          skeleton: {
            from: skeletonFrom2,
            to: rgba$1(skeletonFrom2, 0.5)
          }
        };
      }
      const bg = base.bg, skeletonFrom = blend(base.bg, tints[100]);
      return {
        bg,
        border: blend(bg, tints[100]),
        fg: blend(bg, tints[700]),
        icon: blend(bg, tints[700]),
        muted: {
          fg: blend(bg, tints[600])
        },
        accent: {
          fg: blend(bg, stateTones.critical[500])
        },
        link: {
          fg: blend(bg, stateTones.primary[600])
        },
        code: {
          bg: blend(bg, tints[50]),
          fg: blend(bg, tints[600])
        },
        skeleton: {
          from: skeletonFrom,
          to: rgba$1(skeletonFrom, 0.5)
        }
      };
    },
    button: ({
      base,
      mode,
      muted,
      solid
    }) => mode === "bleed" ? {
      enabled: {
        ...muted.enabled,
        border: muted.enabled.bg
      },
      hovered: {
        ...muted.hovered,
        border: muted.hovered.bg
      },
      pressed: {
        ...muted.pressed,
        border: muted.pressed.bg
      },
      selected: {
        ...muted.selected,
        border: muted.selected.bg
      },
      disabled: {
        ...muted.disabled,
        border: muted.disabled.bg
      }
    } : mode === "ghost" ? {
      ...solid,
      enabled: {
        ...muted.enabled,
        border: base.border
      },
      disabled: muted.disabled
    } : solid,
    card: ({
      base,
      dark: navbar,
      muted,
      name,
      solid,
      state
    }) => {
      if (state === "hovered")
        return muted[name].hovered;
      if (state === "disabled")
        return muted[name].disabled;
      const isNeutral = NEUTRAL_TONES.includes(name), stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, tints = stateTones[name] || stateTones.default, dark = stateTones.dark, blend = dark ? _screen : _multiply;
      if (state === "pressed")
        return isNeutral ? muted.primary.pressed : muted[name].pressed;
      if (state === "selected")
        return isNeutral ? solid.primary.enabled : solid[name].enabled;
      const bg = base.bg, skeletonFrom = blend(base.bg, tints[dark ? 900 : 100]);
      return {
        bg,
        fg: base.fg,
        icon: base.fg,
        border: base.border,
        muted: {
          fg: blend(base.bg, tints[dark ? 400 : 600])
        },
        accent: {
          fg: blend(base.bg, stateTones.critical[dark ? 400 : 500])
        },
        link: {
          fg: blend(base.bg, stateTones.primary[dark ? 400 : 600])
        },
        code: {
          bg: blend(base.bg, tints[dark ? 950 : 50]),
          fg: tints[dark ? 400 : 600]
        },
        skeleton: {
          from: skeletonFrom,
          to: rgba$1(skeletonFrom, 0.5)
        }
      };
    },
    input: ({
      base,
      dark: navbar,
      mode,
      state
    }) => {
      const stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, blend = stateTones.dark ? _screen : _multiply;
      if (mode === "invalid") {
        const tints = stateTones.critical;
        return {
          bg: blend(base.bg, tints[50]),
          bg2: blend(base.bg, tints[50]),
          fg: blend(base.bg, tints[700]),
          border: blend(base.bg, tints[200]),
          placeholder: blend(base.bg, tints[400])
        };
      }
      return state === "hovered" ? {
        bg: base.bg,
        bg2: base.bg,
        fg: base.fg,
        border: blend(base.bg, hues.gray[300].hex),
        placeholder: blend(base.bg, hues.gray[400].hex)
      } : state === "disabled" ? {
        bg: blend(base.bg, hues.gray[50].hex),
        bg2: blend(base.bg, hues.gray[50].hex),
        fg: blend(base.bg, hues.gray[200].hex),
        border: blend(base.bg, hues.gray[100].hex),
        placeholder: blend(base.bg, hues.gray[100].hex)
      } : state === "readOnly" ? {
        bg: blend(base.bg, hues.gray[50].hex),
        bg2: blend(base.bg, hues.gray[50].hex),
        fg: blend(base.bg, hues.gray[800].hex),
        border: blend(base.bg, hues.gray[200].hex),
        placeholder: blend(base.bg, hues.gray[400].hex)
      } : {
        bg: base.bg,
        bg2: base.bg,
        fg: base.fg,
        border: base.border,
        placeholder: blend(base.bg, hues.gray[700].hex)
      };
    },
    selectable: ({
      base,
      muted,
      tone,
      solid,
      state
    }) => state === "enabled" ? {
      ...muted[tone].enabled,
      bg: base.bg
    } : state === "pressed" ? tone === "default" ? muted.primary.pressed : muted[tone].pressed : state === "selected" ? tone === "default" ? solid.primary.enabled : solid[tone].enabled : state === "disabled" ? {
      ...muted[tone].disabled,
      bg: base.bg
    } : muted[tone][state],
    spot: ({
      base,
      key
    }) => {
      const dark = _isDark(base.bg, base.fg);
      return (dark ? _screen : _multiply)(base.bg, hues[key][dark ? 400 : 500].hex);
    },
    syntax: ({
      base,
      dark: navbar
    }) => {
      const stateTones = navbar ? legacyTones.state.navbar : legacyTones.state.default, blend = stateTones.dark ? _screen : _multiply, mainShade = 600, secondaryShade = 400;
      return {
        atrule: blend(base.bg, hues.purple[mainShade].hex),
        attrName: blend(base.bg, stateTones.positive[mainShade]),
        attrValue: blend(base.bg, stateTones.caution[mainShade]),
        attribute: blend(base.bg, stateTones.caution[mainShade]),
        boolean: blend(base.bg, hues.purple[mainShade].hex),
        builtin: blend(base.bg, hues.purple[mainShade].hex),
        cdata: blend(base.bg, stateTones.caution[mainShade]),
        char: blend(base.bg, stateTones.caution[mainShade]),
        class: blend(base.bg, hues.orange[mainShade].hex),
        className: blend(base.bg, hues.cyan[mainShade].hex),
        comment: blend(base.bg, stateTones.default[secondaryShade]),
        constant: blend(base.bg, hues.purple[mainShade].hex),
        deleted: blend(base.bg, stateTones.critical[mainShade]),
        doctype: blend(base.bg, stateTones.default[secondaryShade]),
        entity: blend(base.bg, stateTones.critical[mainShade]),
        function: blend(base.bg, stateTones.positive[mainShade]),
        hexcode: blend(base.bg, stateTones.primary[mainShade]),
        id: blend(base.bg, hues.purple[mainShade].hex),
        important: blend(base.bg, hues.purple[mainShade].hex),
        inserted: blend(base.bg, stateTones.caution[mainShade]),
        keyword: blend(base.bg, hues.magenta[mainShade].hex),
        number: blend(base.bg, hues.purple[mainShade].hex),
        operator: blend(base.bg, hues.magenta[mainShade].hex),
        prolog: blend(base.bg, stateTones.default[secondaryShade]),
        property: blend(base.bg, stateTones.primary[mainShade]),
        pseudoClass: blend(base.bg, stateTones.caution[mainShade]),
        pseudoElement: blend(base.bg, stateTones.caution[mainShade]),
        punctuation: blend(base.bg, stateTones.default[mainShade]),
        regex: blend(base.bg, stateTones.primary[mainShade]),
        selector: blend(base.bg, stateTones.critical[mainShade]),
        string: blend(base.bg, stateTones.caution[mainShade]),
        symbol: blend(base.bg, hues.purple[mainShade].hex),
        tag: blend(base.bg, stateTones.critical[mainShade]),
        unit: blend(base.bg, hues.orange[mainShade].hex),
        url: blend(base.bg, stateTones.critical[mainShade]),
        variable: blend(base.bg, stateTones.critical[mainShade])
      };
    }
  });
}
function buildFonts(cssCustomProperties) {
  return {
    ...studioTheme.fonts,
    code: {
      ...studioTheme.fonts.code,
      family: cssCustomProperties["--font-family-monospace"] || studioTheme.fonts.code.family
    },
    heading: {
      ...studioTheme.fonts.heading,
      family: cssCustomProperties["--font-family-base"] || studioTheme.fonts.code.family
    },
    label: {
      ...studioTheme.fonts.label,
      family: cssCustomProperties["--font-family-base"] || studioTheme.fonts.code.family
    },
    text: {
      ...studioTheme.fonts.text,
      family: cssCustomProperties["--font-family-base"] || studioTheme.fonts.code.family
    }
  };
}
function buildLegacyPalette(cssCustomProperties) {
  return {
    black: _toHex(cssCustomProperties["--black"]),
    component: {
      bg: _toHex(cssCustomProperties["--component-bg"]),
      fg: _toHex(cssCustomProperties["--component-text-color"])
    },
    defaultButton: {
      default: {
        base: _toHex(cssCustomProperties["--default-button-color"])
      },
      primary: {
        base: _toHex(cssCustomProperties["--default-button-primary-color"])
      },
      success: {
        base: _toHex(cssCustomProperties["--default-button-success-color"])
      },
      warning: {
        base: _toHex(cssCustomProperties["--default-button-warning-color"])
      },
      danger: {
        base: _toHex(cssCustomProperties["--default-button-danger-color"])
      }
    },
    focus: {
      base: _toHex(cssCustomProperties["--focus-color"])
    },
    gray: {
      base: _toHex(cssCustomProperties["--gray-base"])
    },
    mainNavigation: {
      bg: _toHex(cssCustomProperties["--main-navigation-color"]),
      fg: _toHex(cssCustomProperties["--main-navigation-color--inverted"])
    },
    state: {
      info: {
        fg: _toHex(cssCustomProperties["--state-info-color"])
      },
      success: {
        fg: _toHex(cssCustomProperties["--state-success-color"])
      },
      warning: {
        fg: _toHex(cssCustomProperties["--state-warning-color"])
      },
      danger: {
        fg: _toHex(cssCustomProperties["--state-danger-color"])
      }
    }
  };
}
function buildLegacyTones(legacyPalette) {
  return {
    state: {
      default: {
        bg: legacyPalette.component.bg,
        fg: legacyPalette.component.fg,
        dark: _isDark(legacyPalette.component.bg, legacyPalette.component.fg),
        default: _buildTints(legacyPalette.component.bg, legacyPalette.gray.base, legacyPalette.component.fg),
        transparent: _buildTints(legacyPalette.component.bg, legacyPalette.gray.base, legacyPalette.component.fg),
        primary: _buildTints(legacyPalette.component.bg, legacyPalette.state.info.fg, legacyPalette.component.fg),
        positive: _buildTints(legacyPalette.component.bg, legacyPalette.state.success.fg, legacyPalette.component.fg),
        caution: _buildTints(legacyPalette.component.bg, legacyPalette.state.warning.fg, legacyPalette.component.fg),
        critical: _buildTints(legacyPalette.component.bg, legacyPalette.state.danger.fg, legacyPalette.component.fg)
      },
      navbar: {
        bg: legacyPalette.mainNavigation.bg,
        fg: legacyPalette.mainNavigation.fg,
        dark: _isDark(legacyPalette.mainNavigation.bg, legacyPalette.mainNavigation.fg),
        default: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.gray.base, legacyPalette.mainNavigation.fg),
        transparent: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.gray.base, legacyPalette.mainNavigation.fg),
        primary: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.state.info.fg, legacyPalette.mainNavigation.fg),
        positive: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.state.success.fg, legacyPalette.mainNavigation.fg),
        caution: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.state.warning.fg, legacyPalette.mainNavigation.fg),
        critical: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.state.danger.fg, legacyPalette.mainNavigation.fg)
      }
    },
    button: {
      default: {
        bg: legacyPalette.component.bg,
        fg: legacyPalette.component.fg,
        dark: _isDark(legacyPalette.component.bg, legacyPalette.component.fg),
        default: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.default.base, legacyPalette.component.fg),
        transparent: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.default.base, legacyPalette.component.fg),
        primary: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.primary.base, legacyPalette.component.fg),
        positive: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.success.base, legacyPalette.component.fg),
        caution: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.warning.base, legacyPalette.component.fg),
        critical: _buildTints(legacyPalette.component.bg, legacyPalette.defaultButton.danger.base, legacyPalette.component.fg)
      },
      navbar: {
        bg: legacyPalette.mainNavigation.bg,
        fg: legacyPalette.mainNavigation.fg,
        dark: _isDark(legacyPalette.mainNavigation.bg, legacyPalette.mainNavigation.fg),
        default: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.default.base, legacyPalette.mainNavigation.fg),
        transparent: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.default.base, legacyPalette.mainNavigation.fg),
        primary: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.primary.base, legacyPalette.mainNavigation.fg),
        positive: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.success.base, legacyPalette.mainNavigation.fg),
        caution: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.warning.base, legacyPalette.mainNavigation.fg),
        critical: _buildTints(legacyPalette.mainNavigation.bg, legacyPalette.defaultButton.danger.base, legacyPalette.mainNavigation.fg)
      }
    }
  };
}
function buildLegacyTheme(partialLegacyTheme) {
  const legacyTheme = resolveLegacyTheme(partialLegacyTheme), legacyPalette = buildLegacyPalette(legacyTheme), legacyTones = buildLegacyTones(legacyPalette), color = buildColor(legacyPalette, legacyTones), fonts = buildFonts(legacyTheme);
  return {
    __dark: _isDark(color.light.default.base.bg, color.light.default.base.fg),
    __legacy: !0,
    color,
    fonts
  };
}
const defaultCustomProperties = {
  "--font-family-monospace": studioTheme.fonts.code.family,
  "--font-family-base": studioTheme.fonts.text.family,
  "--black": black.hex,
  "--white": white.hex,
  // Brand
  "--brand-primary": blue[500].hex,
  // Component
  "--component-bg": white.hex,
  "--component-text-color": black.hex,
  // Gray
  "--gray": gray[500].hex,
  "--gray-base": gray[500].hex,
  // Default button
  "--default-button-color": gray[500].hex,
  "--default-button-danger-color": red[500].hex,
  "--default-button-primary-color": blue[500].hex,
  "--default-button-success-color": green[500].hex,
  "--default-button-warning-color": yellow[500].hex,
  // Focus
  "--focus-color": blue[500].hex,
  // Screen
  "--screen-medium-break": "512px",
  "--screen-default-break": "640px",
  "--screen-large-break": "960px",
  "--screen-xlarge-break": "1600px",
  // State
  "--state-info-color": blue[500].hex,
  "--state-success-color": green[500].hex,
  "--state-warning-color": yellow[500].hex,
  "--state-danger-color": red[500].hex,
  // Navbar
  "--main-navigation-color": black.hex,
  "--main-navigation-color--inverted": white.hex
};
function resolveLegacyTheme(legacyTheme) {
  const props2 = {
    ...defaultCustomProperties,
    ...legacyTheme
  };
  return props2["--focus-color"] = legacyTheme["--focus-color"] || props2["--brand-primary"], props2["--default-button-primary-color"] = legacyTheme["--default-button-primary-color"] || props2["--brand-primary"], props2["--main-navigation-color"] = legacyTheme["--main-navigation-color"] || props2["--black"], props2["--main-navigation-color--inverted"] = legacyTheme["--main-navigation-color--inverted"] || props2["--white"], props2["--state-info-color"] = legacyTheme["--brand-primary"] || props2["--brand-primary"], props2;
}
const defaultTheme = buildTheme(), isThemerTheme = (theme) => theme.__themer === !0;
function getThemeValues(theme) {
  return {
    ...defaultTheme,
    v2: theme.v2,
    fonts: isThemerTheme(theme) ? defaultTheme.fonts : theme.fonts ?? defaultTheme.fonts,
    color: theme.color ?? defaultTheme.color
  };
}
function StudioThemeProvider(t0) {
  const $ = c(18), {
    children
  } = t0, theme = useActiveWorkspace().activeWorkspace.theme;
  if (theme.__legacy) {
    const scheme = theme.__dark ? "dark" : "light";
    let t12;
    $[0] !== theme ? (t12 = getThemeValues(theme), $[0] = theme, $[1] = t12) : t12 = $[1];
    let t22;
    $[2] !== children ? (t22 = /* @__PURE__ */ jsx(LayerProvider, { children }), $[2] = children, $[3] = t22) : t22 = $[3];
    let t32;
    $[4] !== scheme || $[5] !== t12 || $[6] !== t22 ? (t32 = /* @__PURE__ */ jsx(ThemeProvider, { scheme, theme: t12, children: t22 }), $[4] = scheme, $[5] = t12, $[6] = t22, $[7] = t32) : t32 = $[7];
    let t4;
    return $[8] !== scheme || $[9] !== t32 ? (t4 = /* @__PURE__ */ jsx(ColorSchemeSetValueContext.Provider, { value: !1, children: /* @__PURE__ */ jsx(ColorSchemeValueContext.Provider, { value: scheme, children: t32 }) }), $[8] = scheme, $[9] = t32, $[10] = t4) : t4 = $[10], t4;
  }
  let t1;
  $[11] !== theme ? (t1 = getThemeValues(theme), $[11] = theme, $[12] = t1) : t1 = $[12];
  let t2;
  $[13] !== children ? (t2 = /* @__PURE__ */ jsx(LayerProvider, { children }), $[13] = children, $[14] = t2) : t2 = $[14];
  let t3;
  return $[15] !== t1 || $[16] !== t2 ? (t3 = /* @__PURE__ */ jsx(ThemeProvider, { theme: t1, children: t2 }), $[15] = t1, $[16] = t2, $[17] = t3) : t3 = $[17], t3;
}
const PerformanceINPMeasured = defineEvent({
  name: "Performance INP Measured",
  // Sample at most every minute
  maxSampleRate: 6e4,
  version: 1,
  description: "Performance INP (Interaction to Next Paint) measurement happened"
});
function getInterestingAttrs(node) {
  if (!node || !(node instanceof Element))
    return;
  const ui = node.getAttribute("data-ui") || void 0, testId = node.getAttribute("data-testid") || void 0;
  return ui || testId ? {
    ui,
    testId
  } : void 0;
}
function getElementIdentifier(node) {
  if (!node)
    return null;
  if (!(node instanceof Element))
    return node.nodeName;
  const {
    nodeName,
    classList,
    id: id2
  } = node;
  return nodeName.toLowerCase() + (id2 ? `#${id2}` : "") + (classList ? `.${classList.value.replaceAll(" ", ".")}` : "");
}
function isPerformanceEventTiming(entry) {
  return entry.entryType === "event";
}
function useMeasurePerformanceTelemetry() {
  const $ = c(5), telemetry = useTelemetry();
  let t0;
  $[0] !== telemetry ? (t0 = (list, observer) => {
    const entries = list.getEntries();
    let maxEntry;
    for (const entry of entries)
      isPerformanceEventTiming(entry) && entry.duration > (maxEntry?.duration || 0) && (maxEntry = entry);
    maxEntry && telemetry.log(PerformanceINPMeasured, {
      target: getElementIdentifier(maxEntry.target),
      attrs: getInterestingAttrs(maxEntry.target),
      interaction: maxEntry.name,
      duration: maxEntry.duration
    });
  }, $[0] = telemetry, $[1] = t0) : t0 = $[1];
  const onEvent = t0;
  let t1, t2;
  $[2] !== onEvent ? (t1 = () => {
    if (!("PerformanceObserver" in globalThis))
      return;
    const observer_0 = new PerformanceObserver(onEvent);
    return observer_0.observe({
      type: "event",
      buffered: !0
    }), () => {
      observer_0.disconnect();
    };
  }, t2 = [onEvent], $[2] = onEvent, $[3] = t1, $[4] = t2) : (t1 = $[3], t2 = $[4]), useEffect(t1, t2);
}
function PerformanceTelemetryTracker(props2) {
  return useMeasurePerformanceTelemetry(), props2.children;
}
const sessionId = createSessionId(), DEBUG_TELEMETRY = !!(typeof process < "u" && process.env?.SANITY_STUDIO_DEBUG_TELEMETRY), debugLoggingStore = {
  // submit any pending events every <n> ms
  flushInterval: 1e3,
  // implements user consent resolving
  resolveConsent: () => Promise.resolve({
    status: "granted"
  }),
  // implements sending events to backend
  sendEvents: async (batch) => {
    console.log("[telemetry] submit events (noop): %O", batch);
  },
  // opts into a different strategy for sending events when the browser close, reload or navigate away from the current page
  sendBeacon: (batch) => (console.log("[telemetry] submit events (noop): %O", batch), !0)
};
function StudioTelemetryProvider(props2) {
  const client = useClient({
    apiVersion: "v2023-12-18"
  }), projectId = client.config().projectId, storeOptions = useMemo(() => DEBUG_TELEMETRY ? debugLoggingStore : {
    // submit any pending events every <n> ms
    flushInterval: 3e4,
    // implements user consent resolving
    resolveConsent: () => client.request({
      uri: "/intake/telemetry-status",
      tag: "telemetry-consent.studio"
    }),
    // implements sending events to backend
    sendEvents: (batch) => client.request({
      uri: "/intake/batch",
      method: "POST",
      json: !0,
      body: {
        projectId,
        batch
      }
    }),
    // opts into a different strategy for sending events when the browser close, reload or navigate away from the current page
    sendBeacon: (batch_0) => navigator.sendBeacon(client.getUrl("/intake/batch"), JSON.stringify({
      projectId,
      batch: batch_0
    }))
  }, [client, projectId]), store = useMemo(() => createBatchedStore(sessionId, storeOptions), [storeOptions]);
  return useEffect(() => {
    const workspaces = arrify(props2.config), datasetNames = [], workspaceNames = [];
    workspaces.forEach((workspace) => {
      datasetNames.push(workspace.dataset), workspaceNames.push(workspace.name || "<unnamed>");
    }), store.logger.updateUserProperties({
      userAgent: navigator.userAgent,
      screen: {
        density: window.devicePixelRatio,
        height: window.screen.height,
        width: window.screen.width,
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth
      },
      studioVersion: SANITY_VERSION,
      plugins: workspaces.flatMap((workspace_0) => workspace_0.plugins?.flatMap((plugin) => ({
        name: plugin.name || "<unnamed>"
      })) || []),
      uniqueWorkspaceNames: new Set(workspaceNames).size,
      uniqueDatasetNames: new Set(datasetNames).size,
      workspaceNames,
      datasetNames
    });
  }, [props2.config, store.logger]), /* @__PURE__ */ jsx(TelemetryProvider, { store, children: /* @__PURE__ */ jsx(PerformanceTelemetryTracker, { children: props2.children }) });
}
const ListItem = styled(Flex)``, ErrorMessageRoot = styled(Box).attrs({
  padding: 4
})``;
function ErrorMessage(t0) {
  const $ = c(20), {
    error,
    message,
    path,
    stack
  } = t0;
  let t1, t2;
  $[0] !== error ? (t1 = () => {
    console.error(error);
  }, t2 = [error], $[0] = error, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useEffect(t1, t2);
  const last2 = path[path.length - 1];
  let t3;
  $[3] !== last2.type ? (t3 = startCase(last2.type), $[3] = last2.type, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t3 ? (t4 = /* @__PURE__ */ jsx(Flex, { direction: "column", gap: 2, children: /* @__PURE__ */ jsxs(Text$1, { weight: "medium", size: 3, children: [
    t3,
    " Error"
  ] }) }), $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== message ? (t5 = /* @__PURE__ */ jsx(Card, { tone: "critical", overflow: "auto", padding: 4, children: /* @__PURE__ */ jsx(Code, { children: message }) }), $[7] = message, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== path ? (t6 = path.map(_temp$8), $[9] = path, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t6 ? (t7 = /* @__PURE__ */ jsx(Flex, { as: "ul", direction: "column", gap: 2, children: t6 }), $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== stack ? (t8 = stack && /* @__PURE__ */ jsxs("details", { children: [
    /* @__PURE__ */ jsx(Text$1, { as: "summary", children: "Stack Trace" }),
    /* @__PURE__ */ jsx(Box, { overflow: "auto", marginTop: 4, children: /* @__PURE__ */ jsx(Code, { children: stack }) })
  ] }), $[13] = stack, $[14] = t8) : t8 = $[14];
  let t9;
  return $[15] !== t4 || $[16] !== t5 || $[17] !== t7 || $[18] !== t8 ? (t9 = /* @__PURE__ */ jsxs(ErrorMessageRoot, { forwardedAs: Flex, direction: "column", gap: 4, children: [
    t4,
    t5,
    t7,
    t8
  ] }), $[15] = t4, $[16] = t5, $[17] = t7, $[18] = t8, $[19] = t9) : t9 = $[19], t9;
}
function _temp$8(t0, index) {
  const {
    name,
    type
  } = t0;
  return /* @__PURE__ */ jsxs(ListItem, { forwardedAs: "li", gap: 2, align: "center", children: [
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Code, { children: name }) }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: type }) })
  ] }, index);
}
function createRouter(opts) {
  const {
    basePath = "/",
    tools
  } = opts, toolRoute = route.create("/:tool", (toolParams) => {
    let tool = tools.find((current) => current.name === toolParams.tool);
    return !tool && toolParams.tool === "desk" && (tool = tools.find((current) => current.name === "structure")), tool ? route.scope(tool.name, "/", tool.router) : route.create("/");
  });
  return route.create(basePath, [route.intents("/intent"), toolRoute]);
}
function getOrderedTools(tools) {
  const config = {}.toolSwitcher || {}, order = config.order || [], hidden = config.hidden || [];
  if (!order.length && !hidden.length)
    return tools;
  const keyed = tools.reduce((target, tool) => {
    const title = tool.title || "<unknown>";
    if (!tool.name)
      return console.warn(`Tool "${title}" does not have the required "name" property`), target;
    if (target[tool.name]) {
      const existing = target[tool.name].tool.title;
      return console.warn(`Tools with duplicate name "${tool.name}" found ("${title}" and "${existing}")`), target;
    }
    const toolIndex = order.indexOf(tool.name);
    return target[tool.name] = {
      tool,
      index: toolIndex === -1 ? 1 / 0 : toolIndex
    }, target;
  }, {}), isVisible2 = (tool) => hidden.indexOf(tool.name) === -1, ret = tools.filter(isVisible2);
  return ret.sort((tool1, tool2) => {
    const toolA = keyed[tool1.name], toolB = keyed[tool2.name], indexA = toolA ? toolA.index : 1 / 0, indexB = toolB ? toolB.index : 1 / 0;
    return indexA === indexB ? 0 : indexA - indexB;
  }), ret;
}
const WEIGHTED_CREATE_INTENT_PARAMS = ["template"], WEIGHTED_EDIT_INTENT_PARAMS = ["mode"];
function resolveUrlStateWithDefaultTool(tools, state) {
  const defaultTool = getOrderedTools(tools)[0];
  return !state || state.tool || !defaultTool ? state : Object.assign({}, state, {
    tool: defaultTool.name
  });
}
function makeBackwardsCompatible(tools, state) {
  return state && (getOrderedTools(tools).find((tool) => tool.name === state.space) ? {
    ...state,
    tool: state.space,
    space: void 0
  } : state);
}
function resolveDefaultState(tools, state) {
  return resolveUrlStateWithDefaultTool(tools, makeBackwardsCompatible(tools, state));
}
function resolveIntentState(tools, prevState, nextState) {
  const {
    intent,
    params,
    payload
  } = nextState;
  if (typeof intent != "string")
    throw new Error("intent must be a string");
  if (!isRecord$4(params))
    throw new Error("intent params must be a string");
  const orderedTools = getOrderedTools(tools), currentTool = prevState?.tool ? orderedTools.find((tool) => tool.name === prevState.tool) : null, otherTools = currentTool ? orderedTools.filter((tool) => tool !== currentTool) : orderedTools;
  let weightedParams = [];
  intent === "create" ? weightedParams = WEIGHTED_CREATE_INTENT_PARAMS : intent === "edit" && (weightedParams = WEIGHTED_EDIT_INTENT_PARAMS);
  const initialMatch = {
    score: -1,
    tool: null
  }, {
    tool: matchingTool
  } = (currentTool ? [currentTool, ...otherTools] : orderedTools).reduce((prev, tool) => {
    if (!tool || typeof tool.canHandleIntent != "function")
      return prev;
    const canHandle = tool.canHandleIntent(intent, params, prevState && prevState[tool.name]);
    if (typeof canHandle == "boolean")
      return canHandle && prev.score < 0 ? {
        score: 0,
        tool
      } : prev;
    if (!isRecord$4(canHandle))
      return prev;
    const score = weightedParams.reduce((prevScore, weightedParam) => weightedParam in params && canHandle[weightedParam] === !0 ? prevScore + 1 : prevScore, 0);
    return score > prev.score ? {
      score,
      tool
    } : prev;
  }, initialMatch);
  if (matchingTool?.getIntentState) {
    const _toolState = matchingTool.getIntentState(intent, params, prevState && prevState[matchingTool.name], payload), {
      _searchParams,
      ...toolState
    } = _toolState, nextUrlState = {
      ...prevState,
      _searchParams: nextState._searchParams,
      tool: matchingTool.name,
      [matchingTool.name]: toolState
    };
    if (matchingTool.router?.__unsafe_disableScopedSearchParams) {
      const stickyParams = nextState._searchParams?.filter(([key]) => STICKY_PARAMS.includes(key));
      nextUrlState._searchParams = [...stickyParams || [], ...Array.isArray(_searchParams) ? _searchParams : []];
    } else
      toolState._searchParams = _searchParams;
    return {
      type: "state",
      isNotFound: !1,
      state: nextUrlState
    };
  }
  return {
    type: "intent",
    isNotFound: !0,
    intent: {
      name: intent,
      params
    }
  };
}
function decodeUrlState(rootRouter, pathname) {
  return {
    type: "state",
    state: rootRouter.decode(pathname) || {},
    isNotFound: rootRouter.isNotFound(pathname)
  };
}
function WorkspaceRouterProvider(t0) {
  const $ = c(10), {
    children,
    LoadingComponent,
    workspace
  } = t0, {
    basePath,
    tools
  } = workspace, history2 = useRouterHistory();
  let t1, t2;
  $[0] !== basePath || $[1] !== tools ? (t2 = createRouter({
    basePath,
    tools
  }), $[0] = basePath, $[1] = tools, $[2] = t2) : t2 = $[2], t1 = t2;
  const router = t1, [state, onNavigate] = useRouterFromWorkspaceHistory(history2, router, tools), handleCatchError = _temp$7;
  if (!state) {
    let t32;
    return $[3] !== LoadingComponent ? (t32 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[3] = LoadingComponent, $[4] = t32) : t32 = $[4], t32;
  }
  let t3;
  return $[5] !== children || $[6] !== onNavigate || $[7] !== router || $[8] !== state ? (t3 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: handleCatchError, children: /* @__PURE__ */ jsx(RouterProvider, { onNavigate, router, state, children }) }), $[5] = children, $[6] = onNavigate, $[7] = router, $[8] = state, $[9] = t3) : t3 = $[9], t3;
}
function _temp$7(t0) {
  const {
    error
  } = t0;
  throw error;
}
function useRouterFromWorkspaceHistory(history2, router, tools) {
  const store = useMemo(() => {
    const routerBasePath = router.getBasePath(), routerBasePathRegex = new RegExp(`^${escapeRegExp$1(routerBasePath)}(\\/|\\?|$)`, "i"), shouldHandle = (pathname) => (
      // this is necessary to prevent emissions intended for other workspaces.
      routerBasePath === "/" ? !0 : routerBasePathRegex.test(pathname)
    );
    return {
      subscribe: (onStoreChange) => history2.listen(onStoreChange),
      getSnapshot: () => `${history2.location.pathname}${history2.location.search || ""}`,
      // Always return null for the server snapshot, as we can't know how to resolve intents until after authentication is done, which is browser-only
      getServerSnapshot: () => null,
      selector: (pathname_0) => typeof pathname_0 == "string" && shouldHandle(pathname_0) ? decodeUrlState(router, pathname_0) : null
    };
  }, [history2, router]), event = useSyncExternalStoreWithSelector(store.subscribe, store.getSnapshot, store.getServerSnapshot, store.selector, isEqual$2), prevEvent = useRef(event);
  useEffect(() => {
    if (event?.type === "state" && !event.state?.intent) {
      const defaultState = resolveDefaultState(tools, event.state);
      defaultState && defaultState !== event.state && history2.replace(router.encode(defaultState));
    }
  }, [event?.state, event?.type, history2, router, tools]), useEffect(() => {
    const resolvedIntent = maybeResolveIntent(event, router, tools, prevEvent);
    resolvedIntent ? history2.replace(resolvedIntent) : prevEvent.current = event;
  }, [event, history2, router, tools]);
  const handleNavigate = useMemo(() => ({
    path,
    replace
  }) => {
    const predictedEvent = store.selector(path), resolvedIntent_0 = maybeResolveIntent(predictedEvent, router, tools, prevEvent), resolvedPath = typeof resolvedIntent_0 == "string" ? resolvedIntent_0 : path;
    replace ? history2.replace(resolvedPath) : history2.push(resolvedPath);
  }, [history2, router, store, tools]);
  return [event?.state ?? null, handleNavigate];
}
function maybeResolveIntent(event, router, tools, prevEvent) {
  if (event?.type === "state" && event.state?.intent) {
    const redirectState = resolveIntentState(tools, prevEvent.current?.type === "state" ? prevEvent.current.state : {}, event.state);
    if (redirectState?.type === "state")
      return router.encode(redirectState.state);
  }
  return null;
}
function useWorkspaceLoader(activeWorkspace) {
  const $ = c(3), [error, handleError] = useState(null);
  if (error)
    throw error;
  const [workspace, setWorkspace] = useState(null);
  let t0, t1;
  return $[0] !== activeWorkspace ? (t0 = () => {
    const subscription = combineLatest(activeWorkspace.__internal.sources.map(_temp2$1)).pipe(map((results) => {
      const errors = results.filter(_temp3);
      if (errors.length)
        throw new ConfigResolutionError({
          name: activeWorkspace.name,
          causes: errors,
          type: "workspace"
        });
      return results;
    }), map((t2) => {
      const [rootSource, ...restOfSources] = t2;
      return {
        ...activeWorkspace,
        ...rootSource,
        unstable_sources: [rootSource, ...restOfSources],
        type: "workspace"
      };
    })).subscribe({
      next: setWorkspace,
      error: handleError
    });
    return () => subscription.unsubscribe();
  }, t1 = [activeWorkspace], $[0] = activeWorkspace, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), workspace;
}
function _temp3(result) {
  return result instanceof ConfigResolutionError;
}
function _temp2$1(t0) {
  const {
    source
  } = t0;
  return source.pipe(catchError(_temp$6));
}
function _temp$6(err) {
  if (err instanceof ConfigResolutionError)
    return of(err);
  throw err;
}
function WorkspaceLoader(t0) {
  const $ = c(12), {
    children,
    LoadingComponent
  } = t0, {
    activeWorkspace
  } = useActiveWorkspace(), workspace = useWorkspaceLoader(activeWorkspace);
  if (!workspace) {
    let t12;
    return $[0] !== LoadingComponent ? (t12 = /* @__PURE__ */ jsx(LoadingComponent, {}), $[0] = LoadingComponent, $[1] = t12) : t12 = $[1], t12;
  }
  let t1;
  $[2] !== LoadingComponent || $[3] !== children || $[4] !== workspace ? (t1 = /* @__PURE__ */ jsx(WorkspaceRouterProvider, { LoadingComponent, workspace, children }), $[2] = LoadingComponent, $[3] = children, $[4] = workspace, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== t1 || $[7] !== workspace.unstable_sources[0] ? (t2 = /* @__PURE__ */ jsx(SourceProvider, { source: workspace.unstable_sources[0], children: t1 }), $[6] = t1, $[7] = workspace.unstable_sources[0], $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== t2 || $[10] !== workspace ? (t3 = /* @__PURE__ */ jsx(WorkspaceProvider, { workspace, children: t2 }), $[9] = t2, $[10] = workspace, $[11] = t3) : t3 = $[11], t3;
}
function WorkspaceLoaderBoundary(t0) {
  const $ = c(5);
  let props2;
  if ($[0] !== t0) {
    const {
      ConfigErrorsComponent,
      ...t12
    } = t0;
    props2 = t12, $[0] = t0, $[1] = props2;
  } else
    props2 = $[1];
  let t1;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    error: null
  }, $[2] = t1) : t1 = $[2];
  const [t2, setError] = useState(t1), {
    error
  } = t2;
  if (error)
    throw error;
  let t3;
  return $[3] !== props2 ? (t3 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: setError, children: /* @__PURE__ */ jsx(WorkspaceLoader, { ...props2 }) }), $[3] = props2, $[4] = t3) : t3 = $[4], t3;
}
Refractor.registerLanguage(bash);
Refractor.registerLanguage(javascript);
Refractor.registerLanguage(json);
Refractor.registerLanguage(jsx2);
Refractor.registerLanguage(typescript);
function StudioProvider(t0) {
  const $ = c(21), {
    children,
    config,
    basePath,
    onSchemeChange,
    scheme,
    unstable_history: history2,
    unstable_noAuthBoundary: noAuthBoundary
  } = t0;
  errorReporter.initialize();
  let t1, t2;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(MaybeEnableErrorReporting, { errorReporter }), $[0] = t2) : t2 = $[0];
  let t3;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(ComlinkRouteHandler, {}), $[1] = t3) : t3 = $[1];
  let t4;
  $[2] !== children ? (t4 = /* @__PURE__ */ jsx(LocaleProvider, { children: /* @__PURE__ */ jsxs(PackageVersionStatusProvider, { children: [
    t2,
    /* @__PURE__ */ jsx(ResourceCacheProvider, { children: /* @__PURE__ */ jsxs(AppIdCacheProvider, { children: [
      t3,
      /* @__PURE__ */ jsx(StudioAnnouncementsProvider, { children: /* @__PURE__ */ jsx(GlobalPerspectiveProvider, { children }) })
    ] }) })
  ] }) }), $[2] = children, $[3] = t4) : t4 = $[3];
  let t5;
  $[4] !== config || $[5] !== t4 ? (t5 = /* @__PURE__ */ jsx(WorkspaceLoaderBoundary, { LoadingComponent: LoadingBlock, ConfigErrorsComponent: ConfigErrorsScreen, children: /* @__PURE__ */ jsx(StudioTelemetryProvider, { config, children: t4 }) }), $[4] = config, $[5] = t4, $[6] = t5) : t5 = $[6], t1 = t5;
  const _children = t1;
  let t6;
  $[7] !== _children || $[8] !== noAuthBoundary ? (t6 = /* @__PURE__ */ jsx(StudioThemeProvider, { children: /* @__PURE__ */ jsx(UserColorManagerProvider, { children: noAuthBoundary ? _children : /* @__PURE__ */ jsx(AuthBoundary, { LoadingComponent: LoadingBlock, AuthenticateComponent: AuthenticateScreen, NotAuthenticatedComponent: NotAuthenticatedScreen, children: _children }) }) }), $[7] = _children, $[8] = noAuthBoundary, $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== history2 || $[11] !== t6 ? (t7 = /* @__PURE__ */ jsx(ActiveWorkspaceMatcher, { unstable_history: history2, NotFoundComponent: NotFoundScreen, LoadingComponent: LoadingBlock, children: t6 }), $[10] = history2, $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== basePath || $[14] !== config || $[15] !== t7 ? (t8 = /* @__PURE__ */ jsx(ToastProvider, { paddingY: 7, zOffset: Z_OFFSET$1.toast, children: /* @__PURE__ */ jsx(StudioErrorBoundary, { children: /* @__PURE__ */ jsx(StudioRootErrorHandler, { children: /* @__PURE__ */ jsx(WorkspacesProvider, { config, basePath, LoadingComponent: LoadingBlock, children: t7 }) }) }) }), $[13] = basePath, $[14] = config, $[15] = t7, $[16] = t8) : t8 = $[16];
  let t9;
  return $[17] !== onSchemeChange || $[18] !== scheme || $[19] !== t8 ? (t9 = /* @__PURE__ */ jsx(ColorSchemeProvider, { onSchemeChange, scheme, children: t8 }), $[17] = onSchemeChange, $[18] = scheme, $[19] = t8, $[20] = t9) : t9 = $[20], t9;
}
function Studio(props2) {
  const $ = c(11), {
    basePath,
    config,
    onSchemeChange,
    scheme,
    unstable_globalStyles: globalStyles,
    unstable_history,
    unstable_noAuthBoundary
  } = props2;
  let t0;
  $[0] !== globalStyles ? (t0 = globalStyles && /* @__PURE__ */ jsx(GlobalStyle, {}), $[0] = globalStyles, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(StudioLayout, {}), $[2] = t1) : t1 = $[2];
  let t2;
  return $[3] !== basePath || $[4] !== config || $[5] !== onSchemeChange || $[6] !== scheme || $[7] !== t0 || $[8] !== unstable_history || $[9] !== unstable_noAuthBoundary ? (t2 = /* @__PURE__ */ jsxs(StudioProvider, { basePath, config, onSchemeChange, scheme, unstable_history, unstable_noAuthBoundary, children: [
    t0,
    t1
  ] }), $[3] = basePath, $[4] = config, $[5] = onSchemeChange, $[6] = scheme, $[7] = t0, $[8] = unstable_history, $[9] = unstable_noAuthBoundary, $[10] = t2) : t2 = $[10], t2;
}
function renderStudio(rootElement, config, options = !1) {
  if (!rootElement)
    throw new Error("Missing root element to mount application into");
  const opts = typeof options == "boolean" ? {
    reactStrictMode: options
  } : options, {
    reactStrictMode = !1,
    basePath
  } = opts, root = createRoot(rootElement);
  return root.render(reactStrictMode ? /* @__PURE__ */ jsx(StrictMode, { children: /* @__PURE__ */ jsx(Studio, { config, basePath, unstable_globalStyles: !0 }) }) : /* @__PURE__ */ jsx(Studio, { config, basePath, unstable_globalStyles: !0 })), () => root.unmount();
}
function useClient(clientOptions2) {
  const $ = c(5), source = useSource();
  if (!clientOptions2) {
    console.warn('Calling `useClient()` without specifying an API version is deprecated and will stop working in the next major version - please specify a date, e.g. `useClient({apiVersion: "2025-02-10"})`.');
    let t02;
    return $[0] !== source ? (t02 = source.getClient({
      apiVersion: "v2025-02-07"
    }), $[0] = source, $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  return $[2] !== clientOptions2 || $[3] !== source ? (t0 = source.getClient(clientOptions2), $[2] = clientOptions2, $[3] = source, $[4] = t0) : t0 = $[4], t0;
}
function useConditionalToast(params) {
  const $ = c(8), toast = useToast(), [enabledAt, setEnabledAt] = useState();
  let t0, t1;
  $[0] !== params.enabled ? (t0 = () => {
    setEnabledAt((current) => params.enabled ? current || /* @__PURE__ */ new Date() : void 0);
  }, t1 = [params.enabled], $[0] = params.enabled, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
  const now = useCurrentTime(1e3), enabled = enabledAt && params.enabled && now.getTime() - enabledAt.getTime() > (params?.delay ?? 0);
  let t2, t3;
  $[3] !== enabled || $[4] !== params || $[5] !== toast ? (t2 = () => {
    if (enabled)
      return toast.push({
        ...params,
        duration: 1 / 0
      }), () => {
        toast.push({
          ...params,
          duration: 0.01
        });
      };
  }, t3 = [params, toast, enabled], $[3] = enabled, $[4] = params, $[5] = toast, $[6] = t2, $[7] = t3) : (t2 = $[6], t3 = $[7]), useEffect(t2, t3);
}
function useCurrentTime(updateIntervalMs) {
  const $ = c(4);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ new Date(), $[0] = t0) : t0 = $[0];
  const [currentTime, setCurrentTime] = useState(t0);
  let t1, t2;
  return $[1] !== updateIntervalMs ? (t1 = () => {
    const intervalId = setInterval(() => {
      setCurrentTime(/* @__PURE__ */ new Date());
    }, updateIntervalMs);
    return () => clearInterval(intervalId);
  }, t2 = [updateIntervalMs], $[1] = updateIntervalMs, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), currentTime;
}
function useDocumentOperationEvent(publishedDocId, docTypeName) {
  const $ = c(4), documentStore = useDocumentStore();
  let t0, t1;
  return $[0] !== docTypeName || $[1] !== documentStore.pair || $[2] !== publishedDocId ? (t1 = documentStore.pair.operationEvents(publishedDocId, docTypeName), $[0] = docTypeName, $[1] = documentStore.pair, $[2] = publishedDocId, $[3] = t1) : t1 = $[3], t0 = t1, useObservable(t0);
}
const PERIODS = ["days", "hours", "minutes", "seconds", "milliseconds"];
function useFormattedDuration(durationMs, options) {
  const {
    style = "short",
    resolution = "seconds"
  } = options || {}, unitDisplay = style, locale = useCurrentLocale().id, listFormat = useListFormat({
    type: "unit",
    style
  }), isNegative = durationMs < 0, duration = parseMilliseconds(Math.abs(durationMs)), formatters2 = useMemo(() => ({
    days: intlCache.numberFormat(locale, {
      style: "unit",
      unit: "day",
      unitDisplay
    }),
    hours: intlCache.numberFormat(locale, {
      style: "unit",
      unit: "hour",
      unitDisplay
    }),
    minutes: intlCache.numberFormat(locale, {
      style: "unit",
      unit: "minute",
      unitDisplay
    }),
    seconds: intlCache.numberFormat(locale, {
      style: "unit",
      unit: "second",
      unitDisplay
    }),
    milliseconds: intlCache.numberFormat(locale, {
      style: "unit",
      unit: "millisecond",
      unitDisplay
    })
  }), [locale, unitDisplay]), parts = [];
  for (const period of PERIODS) {
    const value = duration[period];
    if (!value || resolution === "seconds" && period === "milliseconds")
      continue;
    const prefix = isNegative && parts.length === 0 ? "-" : "";
    parts.push(`${prefix}${formatters2[period].format(value)}`);
  }
  const formatted = parts.length === 0 ? (
    // If passing duration 0, we still want to show something
    formatters2[resolution].format(0)
  ) : (
    // Usually, we want to join the parts with the locales list formatter
    listFormat.format(parts)
  ), iso8601 = durationToISO8601(duration, isNegative);
  return {
    formatted,
    iso8601
  };
}
function parseMilliseconds(milliseconds) {
  return {
    days: Math.trunc(milliseconds / 864e5),
    hours: Math.trunc(milliseconds / 36e5) % 24,
    minutes: Math.trunc(milliseconds / 6e4) % 60,
    seconds: Math.trunc(milliseconds / 1e3) % 60,
    milliseconds: Math.trunc(milliseconds) % 1e3
  };
}
function durationToISO8601(dur, isNegative) {
  const date = dur.days ? `${dur.days}D` : "";
  let time = "";
  if (dur.hours && (time += `${dur.hours}H`), dur.minutes && (time += `${dur.minutes}M`), dur.milliseconds ? time += `${((dur.seconds * 1e3 + dur.milliseconds) / 1e3).toFixed(3)}S` : dur.seconds && (time += `${dur.seconds}S`), !date && !time)
    return "PT0S";
  const duration = `P${(time ? [date, time] : [date]).join("T")}`;
  return isNegative ? `-${duration}` : duration;
}
const isCopyHotKey = isHotkey("mod+c"), isPasteHotKey = isHotkey("mod+v");
function useGlobalCopyPasteElementHandler(t0) {
  const $ = c(11), {
    value,
    element,
    focusPath
  } = t0, {
    onCopy,
    onPaste
  } = useCopyPaste();
  let t1;
  $[0] !== focusPath || $[1] !== onCopy || $[2] !== onPaste || $[3] !== value ? (t1 = (event) => {
    const targetElement = event.target;
    if (isCopyHotKey(event)) {
      if (isNativeEditableElement(targetElement) || hasSelection() || isEmptyFocusPath(focusPath))
        return;
      event.preventDefault(), event.stopPropagation(), onCopy(focusPath, value, {
        context: {
          source: "keyboardShortcut"
        }
      });
    }
    if (isPasteHotKey(event)) {
      if (isNativeEditableElement(targetElement) || isEmptyFocusPath(focusPath) || isFileTargetElement(targetElement))
        return;
      event.stopPropagation(), event.preventDefault(), onPaste(focusPath, value, {
        context: {
          source: "keyboardShortcut"
        }
      });
    }
  }, $[0] = focusPath, $[1] = onCopy, $[2] = onPaste, $[3] = value, $[4] = t1) : t1 = $[4];
  const handleKeydown = useEffectEvent(t1);
  let t2;
  $[5] !== element || $[6] !== handleKeydown ? (t2 = () => (element?.addEventListener("keydown", handleKeydown), () => {
    element?.removeEventListener("keydown", handleKeydown);
  }), $[5] = element, $[6] = handleKeydown, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== element || $[9] !== onPaste ? (t3 = [element, onPaste], $[8] = element, $[9] = onPaste, $[10] = t3) : t3 = $[10], useEffect(t2, t3);
}
const FAVORITES_FETCH_TIMEOUT = 3e3;
function useManageFavorite({
  documentId,
  documentType,
  projectId,
  dataset,
  resourceId: paramResourceId,
  resourceType,
  schemaName
}) {
  const {
    node
  } = useComlinkStore();
  if (resourceType === "studio" && (!projectId || !dataset))
    throw new Error("projectId and dataset are required for studio resources");
  const resourceId = resourceType === "studio" && !paramResourceId ? `${projectId}.${dataset}` : paramResourceId;
  if (!resourceId)
    throw new Error("resourceId is required for media-library and canvas resources");
  const context = useMemo(() => ({
    documentId,
    documentType,
    resourceId,
    resourceType,
    schemaName
  }), [documentId, documentType, resourceId, resourceType, schemaName]), stateController = useMemo(() => optimisticState({
    node,
    context
  }), [context, node]), state = useObservable(stateController.state);
  return {
    favorite: useCallback(() => stateController.setState(!0), [stateController]),
    unfavorite: useCallback(() => stateController.setState(!1), [stateController]),
    isFavorited: state?.value,
    isReady: state?.isReady ?? !1
  };
}
const INITIAL_STATE$1 = {
  value: void 0,
  isReady: !1
};
function optimisticState({
  node,
  context
}) {
  const dispatchSubject = new Subject(), setState = (value) => dispatchSubject.next(value);
  let previousState;
  return {
    state: iif(() => typeof node > "u", of(INITIAL_STATE$1), merge(dispatchSubject.pipe(distinctUntilChanged$1(), filter$1((value) => typeof value == "boolean"), connect((shared) => merge(shared.pipe(map$1((value) => ({
      type: "SET",
      payload: value
    }))), shared.pipe(debounceTime$1(750), filter$1((value) => typeof previousState > "u" ? !1 : value !== previousState), writeRemoteState({
      node,
      context
    }), tap$1(({
      success,
      isFavorited
    }) => {
      success && (previousState = isFavorited);
    }), switchMap$1(() => EMPTY$6))))), readRemoteState({
      node,
      context
    }).pipe(map$1((response) => ({
      type: "END_READ",
      payload: response
    })), tap$1(({
      payload
    }) => {
      previousState = payload.isFavorited;
    }), startWith$1({
      type: "BEGIN_READ"
    }))).pipe(reducer())),
    setState
  };
}
function reducer() {
  return scan$1((previousState, action) => {
    switch (action.type) {
      case "BEGIN_READ":
        return {
          ...previousState,
          isReady: !1
        };
      case "END_READ":
        return {
          ...previousState,
          value: action.payload.isFavorited,
          isReady: !0
        };
      case "SET":
        return {
          ...previousState,
          value: action.payload
        };
      default:
        return previousState;
    }
  }, INITIAL_STATE$1);
}
function readRemoteState({
  node,
  context
}) {
  if (typeof context.resourceId > "u")
    return EMPTY$6;
  if (typeof node > "u")
    return EMPTY$6;
  const payload = {
    document: {
      id: context.documentId,
      type: context.documentType,
      resource: {
        id: context.resourceId,
        type: context.resourceType,
        schemaName: context.schemaName
      }
    }
  };
  return from(node.fetch("dashboard/v1/events/favorite/query", payload)).pipe(timeout({
    first: FAVORITES_FETCH_TIMEOUT,
    with: () => throwError(() => new Error("Favorites service connection timeout"))
  }), map$1((response) => ({
    isFavorited: response.isFavorited
  })), catchError$1((err) => (console.error("Favorites service connection error", err), of({
    isFavorited: !1
  }))));
}
function writeRemoteState({
  node,
  context
}) {
  return pipe(mergeMap$1((value) => {
    if (typeof context.resourceId > "u")
      return EMPTY$6;
    if (typeof node > "u")
      return EMPTY$6;
    const payload = {
      eventType: value ? "added" : "removed",
      document: {
        id: context.documentId,
        type: context.documentType,
        resource: {
          id: context.resourceId,
          type: context.resourceType,
          ...context.schemaName ? {
            schemaName: context.schemaName
          } : {}
        }
      }
    };
    return from(node.fetch("dashboard/v1/events/favorite/mutate", payload)).pipe(catchError$1((error) => (console.error("Favorites service write error", error), NEVER)), map$1((response) => ({
      success: typeof response == "object" && response !== null && "success" in response && !!response.success,
      isFavorited: value
    })));
  }, 1));
}
function useNumberFormat(t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, currentLocale = useCurrentLocale().id;
  let t2;
  return $[2] !== currentLocale || $[3] !== options ? (t2 = intlCache.numberFormat(currentLocale, options), $[2] = currentLocale, $[3] = options, $[4] = t2) : t2 = $[4], t2;
}
const useReconnectingToast = (isReconnecting) => {
  const $ = c(5), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("common.reconnecting.toast.title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== isReconnecting || $[3] !== t0 ? (t1 = {
    enabled: isReconnecting,
    delay: 2e3,
    id: "sanity/reconnecting",
    status: "warning",
    title: t0
  }, $[2] = isReconnecting, $[3] = t0, $[4] = t1) : t1 = $[4], useConditionalToast(t1);
}, DASHBOARD_DOMAIN = "https://www.sanity.io", getDashboardPath = ({
  organizationId,
  appId,
  workspaceName
}) => `${DASHBOARD_DOMAIN}/@${organizationId}/studio/${appId}/${workspaceName}`, useStudioUrl = (defaultUrl) => {
  const renderingContext = useRenderingContext(), {
    studioApp,
    loading: appIdLoading
  } = useStudioAppIdStore({
    enabled: !0
  }), {
    activeWorkspace
  } = useActiveWorkspace(), {
    value: organizationId,
    loading: organizationIdLoading
  } = useProjectOrganizationId(), isLoading = appIdLoading || organizationIdLoading, isCoreUi = renderingContext?.name === "coreUi", studioUrl = useMemo(() => !isCoreUi || isLoading || !studioApp?.appId || !organizationId ? defaultUrl || window.location.toString() : getDashboardPath({
    organizationId,
    appId: studioApp.appId,
    workspaceName: activeWorkspace.name
  }), [activeWorkspace.name, defaultUrl, isCoreUi, isLoading, organizationId, studioApp?.appId]);
  return {
    buildStudioUrl: useCallback(({
      coreUi,
      studio
    }) => (isCoreUi ? coreUi : studio)?.(studioUrl) || studioUrl, [isCoreUi, studioUrl]),
    studioUrl
  };
}, SYNCING = {
  isSyncing: !0
}, NOT_SYNCING = {
  isSyncing: !1
};
function useSyncState(publishedDocId, documentType, version) {
  const $ = c(5), documentStore = useDocumentStore();
  let t0, t1;
  return $[0] !== documentStore.pair || $[1] !== documentType || $[2] !== publishedDocId || $[3] !== version ? (t1 = documentStore.pair.consistencyStatus(publishedDocId, documentType, version).pipe(map(_temp$5)), $[0] = documentStore.pair, $[1] = documentType, $[2] = publishedDocId, $[3] = version, $[4] = t1) : t1 = $[4], t0 = t1, useObservable(t0, NOT_SYNCING);
}
function _temp$5(isConsistent) {
  return isConsistent ? NOT_SYNCING : SYNCING;
}
function useTemplates() {
  return useSource().templates;
}
function useTimeAgo(time, t0) {
  const $ = c(5);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1;
  let t2;
  return $[2] !== options.agoSuffix || $[3] !== options.minimal ? (t2 = {
    minimal: options.minimal,
    useTemporalPhrase: options.agoSuffix
  }, $[2] = options.agoSuffix, $[3] = options.minimal, $[4] = t2) : t2 = $[4], useRelativeTime(time, t2);
}
function useTools() {
  return useSource().tools;
}
const INITIAL_STATE = {
  data: [],
  error: null,
  loading: !0
};
function useUserListWithPermissions(opts) {
  const {
    documentValue,
    permission
  } = opts, projectStore = useProjectStore(), userStore = useUserStore(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [state, setState] = useState(INITIAL_STATE), [users$, systemGroup$] = useMemo(() => {
    const _users$ = projectStore.get().pipe(map$1((res) => res.members?.filter((m) => !m.isRobot))).pipe(shareReplay$1(1)).pipe(switchMap$1(async (members) => {
      const ids = members.map(({
        id: id2
      }) => id2);
      return await userStore.getUsers(ids);
    }), map$1((res_0) => res_0.map((user) => ({
      displayName: user.displayName,
      id: user.id,
      granted: !1
    })))), _systemGroup$ = client.observable.fetch('*[_type == "system.group"]').pipe(shareReplay$1(1));
    return [_users$, _systemGroup$];
  }, [client.observable, projectStore, userStore]), list$ = useMemo(() => forkJoin([users$, systemGroup$]).pipe(mergeMap$1(async ([users_0, groups]) => {
    const grantPromises = users_0?.map(async (user_0) => {
      const flattenedGrants = [...groups.map((group2) => group2.members.includes(user_0.id) ? group2.grants : [])].flat(), {
        granted
      } = await grantsPermissionOn(user_0.id, flattenedGrants, permission, documentValue);
      return {
        ...user_0,
        granted
      };
    });
    return await Promise.all(grantPromises || []);
  })).pipe(map$1((res_1) => ({
    error: null,
    loading: !1,
    data: sortBy(res_1, "displayName")
  }))), [documentValue, permission, users$, systemGroup$]);
  return useEffect(() => {
    const initial$ = of(INITIAL_STATE), sub2 = concat(initial$, list$).subscribe({
      next: setState,
      error: (error) => {
        setState({
          data: [],
          error,
          loading: !1
        });
      }
    });
    return () => {
      sub2.unsubscribe();
    };
  }, [list$]), state;
}
function DocumentStatus({
  draft,
  published,
  versions,
  singleLine
}) {
  const {
    data: releases2
  } = useActiveReleases(), versionsList = useMemo(() => Object.entries(versions ?? {}), [versions]), {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Flex, { align: singleLine ? "center" : "flex-start", direction: singleLine ? "row" : "column", gap: 3, wrap: "nowrap", children: [
    published && /* @__PURE__ */ jsx(VersionStatus, { title: t("release.chip.published"), mode: "published", timestamp: published._updatedAt, tone: "positive" }),
    draft && /* @__PURE__ */ jsx(VersionStatus, { title: t("release.chip.draft"), mode: "draft", timestamp: draft._updatedAt, tone: "caution" }),
    versionsList.map(([versionName, snapshot2]) => {
      if (!snapshot2)
        return null;
      const release = releases2?.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === versionName);
      return /* @__PURE__ */ jsx(VersionStatus, { mode: snapshot2?._updatedAt === snapshot2?._createdAt ? "created" : "edited", title: release?.metadata.title || t("release.placeholder-untitled-release"), timestamp: snapshot2?._updatedAt, tone: release ? getReleaseTone(release) : "default" }, versionName);
    })
  ] });
}
const labels = {
  draft: "document-status.edited",
  published: "document-status.date",
  edited: "document-status.edited",
  created: "document-status.created"
}, VersionStatus = (t0) => {
  const $ = c(19), {
    title,
    timestamp,
    mode,
    tone
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    minimal: !0,
    useTemporalPhrase: !0
  }, $[0] = t1) : t1 = $[0];
  const relativeTime = useRelativeTime(timestamp || "", t1);
  let t2;
  $[1] !== tone ? (t2 = /* @__PURE__ */ jsx(ReleaseAvatar, { tone, padding: 0 }), $[1] = tone, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== t || $[4] !== title ? (t3 = title || t("release.placeholder-untitled-release"), $[3] = t, $[4] = title, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    color: "var(--card-muted-fg-color)"
  }, $[6] = t4) : t4 = $[6];
  const t5 = labels[mode];
  let t6;
  $[7] !== relativeTime || $[8] !== t || $[9] !== t5 ? (t6 = t(t5, {
    date: relativeTime
  }), $[7] = relativeTime, $[8] = t, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t6 ? (t7 = /* @__PURE__ */ jsx("span", { style: t4, children: t6 }), $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t3 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Text$1, { size: 1, children: [
    t3,
    " ",
    t7
  ] }), $[13] = t3, $[14] = t7, $[15] = t8) : t8 = $[15];
  let t9;
  return $[16] !== t2 || $[17] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t2,
    t8
  ] }), $[16] = t2, $[17] = t8, $[18] = t9) : t9 = $[18], t9;
}, strings = {
  "retry.title": "Retry",
  "copy-error-details.description": "These technical details may be useful for developers.",
  "copy-error-details.title": "Copy error details",
  "copy-error-details.toast.get-failed": "Failed to get error details",
  "copy-error-details.toast.copy-failed": "Failed to copy error details"
}, TOAST_ID = "copyErrorDetails";
function useCopyErrorDetails(error, eventId) {
  const $ = c(4), toast = useToast();
  let t0;
  return $[0] !== error || $[1] !== eventId || $[2] !== toast ? (t0 = () => {
    of({
      error,
      eventId
    }).pipe(serializeError(), catchError$1((serializeErrorError) => (console.error(serializeErrorError), toast.push({
      status: "error",
      title: strings["copy-error-details.toast.get-failed"],
      id: TOAST_ID
    }), EMPTY$6)), tap$1(_temp$4), catchError$1((copyErrorError) => (console.error(copyErrorError), toast.push({
      status: "error",
      title: strings["copy-error-details.toast.copy-failed"],
      id: TOAST_ID
    }), EMPTY$6))).subscribe();
  }, $[0] = error, $[1] = eventId, $[2] = toast, $[3] = t0) : t0 = $[3], t0;
}
function _temp$4(errorDetailsString) {
  return navigator.clipboard.writeText(errorDetailsString);
}
function serializeError() {
  return map$1(({
    error,
    eventId
  }) => {
    const errorInfo = isRecord$4(error) ? pick(error, Object.getOwnPropertyNames(error)) : void 0;
    return JSON.stringify({
      error: errorInfo,
      eventId
    }, null, 2);
  });
}
const ErrorActions = (t0) => {
  const $ = c(10), {
    error,
    eventId,
    onRetry: onRetry2,
    isRetrying,
    size
  } = t0, copyErrorDetails = useCopyErrorDetails(error, eventId);
  let t1;
  $[0] !== isRetrying || $[1] !== onRetry2 || $[2] !== size ? (t1 = onRetry2 && /* @__PURE__ */ jsx(Button, { disabled: isRetrying, loading: isRetrying, onClick: onRetry2, text: strings["retry.title"], tone: "primary", icon: SyncIcon, size }), $[0] = isRetrying, $[1] = onRetry2, $[2] = size, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== copyErrorDetails || $[5] !== size ? (t2 = /* @__PURE__ */ jsx(Tooltip, { content: strings["copy-error-details.description"], children: /* @__PURE__ */ jsx(Button, { onClick: copyErrorDetails, text: strings["copy-error-details.title"], tone: "default", mode: "ghost", icon: CopyIcon, size }) }), $[4] = copyErrorDetails, $[5] = size, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== t1 || $[8] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Inline, { space: 3, children: [
    t1,
    t2
  ] }), $[7] = t1, $[8] = t2, $[9] = t3) : t3 = $[9], t3;
}, actionIds = /* @__PURE__ */ new WeakMap();
let counter = 0;
function getHookId(actionHook) {
  const cachedId = actionIds.get(actionHook);
  if (cachedId) return cachedId;
  const id2 = `${actionHook.name || actionHook.displayName || "<anonymous>"}-${counter++}`;
  return actionIds.set(actionHook, id2), id2;
}
function defineHookStateComponent({
  hook: useHook,
  id: id2
}) {
  const HookStateComponent = (t0) => {
    const $ = c(9), {
      args,
      handleNext,
      handleReset
    } = t0;
    let t1;
    $[0] !== handleReset ? (t1 = () => {
      handleReset(id2);
    }, $[0] = handleReset, $[1] = t1) : t1 = $[1];
    let t2;
    $[2] !== args || $[3] !== t1 ? (t2 = {
      ...args,
      onComplete: t1
    }, $[2] = args, $[3] = t1, $[4] = t2) : t2 = $[4];
    const hookState = useHook(t2);
    let t3, t4;
    return $[5] !== handleNext || $[6] !== hookState ? (t3 = () => (hookState ? handleNext(id2, {
      ...hookState,
      action: useHook.action
    }) : handleNext(id2, hookState), () => {
      handleNext(id2, null);
    }), t4 = [handleNext, hookState], $[5] = handleNext, $[6] = hookState, $[7] = t3, $[8] = t4) : (t3 = $[7], t4 = $[8]), useEffect(t3, t4), null;
  }, {
    displayName = "HookState"
  } = useHook;
  return HookStateComponent.displayName = displayName, memo(
    HookStateComponent,
    // Only re-render if the args prop changes, ignore other prop changes
    (prev, next) => prev.args === next.args
  );
}
const HookCollectionState = memo(({
  hooks,
  keys,
  args,
  handleNext,
  handleReset
}) => {
  const HooksState = useMemo(() => hooks.map((hook) => {
    const id2 = getHookId(hook), key = keys[id2] || 0;
    return [defineHookStateComponent({
      hook,
      id: id2
    }), `${id2}-${key}`];
  }), [hooks, keys]);
  return /* @__PURE__ */ jsx(Fragment, { children: HooksState.map(([HookState, key_0]) => /* @__PURE__ */ jsx(HookState, { args, handleNext, handleReset }, key_0)) });
});
HookCollectionState.displayName = "Memo(HookCollectionState)";
function useHookCollectionKeys(onReset) {
  const $ = c(6);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const [keys, setKeys] = useState(t0);
  let t1;
  $[1] !== onReset ? (t1 = (id2) => {
    setKeys((currentKeys) => ({
      ...currentKeys,
      [id2]: (currentKeys[id2] || 0) + 1
    })), onReset?.();
  }, $[1] = onReset, $[2] = t1) : t1 = $[2];
  const handleReset = t1;
  let t2;
  return $[3] !== handleReset || $[4] !== keys ? (t2 = {
    keys,
    handleReset
  }, $[3] = handleReset, $[4] = keys, $[5] = t2) : t2 = $[5], t2;
}
const throttleOptions = {
  trailing: !0
};
function mapHooksToStates(states, {
  hooks
}) {
  return hooks.map((hook) => {
    const id2 = getHookId(hook);
    return states.get(id2);
  }).filter(isNonNullable$3);
}
function useHookCollectionStates(t0) {
  const $ = c(13), {
    hooks,
    group: group2
  } = t0, [states] = useState(_temp$3);
  let t1;
  $[0] !== hooks || $[1] !== states ? (t1 = () => mapHooksToStates(states, {
    hooks
  }), $[0] = hooks, $[1] = states, $[2] = t1) : t1 = $[2];
  const [snapshot2, setSnapshot2] = useState(t1), abortControllerRef = useRef(null);
  let t2;
  $[3] !== hooks || $[4] !== states ? (t2 = () => {
    abortControllerRef.current?.abort(), abortControllerRef.current = new AbortController(), postTask(() => {
      setSnapshot2(mapHooksToStates(states, {
        hooks
      }));
    }, {
      signal: abortControllerRef.current.signal
    })?.catch(_temp2);
  }, $[3] = hooks, $[4] = states, $[5] = t2) : t2 = $[5];
  const requestUpdateSnapshot = useThrottledCallback(t2, 60, throttleOptions);
  let t3;
  $[6] !== group2 || $[7] !== requestUpdateSnapshot || $[8] !== states ? (t3 = (id2, hookState) => {
    let shouldUpdateSnapshot = !0;
    const hookGroup = hookState?.group || ["default"];
    if (hookState === null || group2 && !hookGroup.includes(group2))
      states.delete(id2);
    else {
      if (states.has(id2)) {
        const prev = states.get(id2);
        shouldUpdateSnapshot = !deepEquals(prev, hookState);
      }
      states.set(id2, hookState);
    }
    shouldUpdateSnapshot && requestUpdateSnapshot();
  }, $[6] = group2, $[7] = requestUpdateSnapshot, $[8] = states, $[9] = t3) : t3 = $[9];
  const handleNext = t3;
  let t4;
  return $[10] !== handleNext || $[11] !== snapshot2 ? (t4 = {
    states: snapshot2,
    handleNext
  }, $[10] = handleNext, $[11] = snapshot2, $[12] = t4) : t4 = $[12], t4;
}
function _temp2(error) {
  if (error.name !== "AbortError")
    throw error;
}
function _temp$3() {
  return /* @__PURE__ */ new Map();
}
const GetHookCollectionStateComponent = memo((props2) => {
  const $ = c(15), {
    hooks,
    args,
    children,
    group: group2,
    onReset
  } = props2, {
    handleReset,
    keys
  } = useHookCollectionKeys(onReset);
  let t0;
  $[0] !== group2 || $[1] !== hooks ? (t0 = {
    hooks,
    group: group2
  }, $[0] = group2, $[1] = hooks, $[2] = t0) : t0 = $[2];
  const {
    states,
    handleNext
  } = useHookCollectionStates(t0);
  let t1, t2;
  $[3] !== children || $[4] !== states ? (t2 = children({
    states
  }), $[3] = children, $[4] = states, $[5] = t2) : t2 = $[5], t1 = t2;
  const result = t1, t3 = hooks;
  let t4;
  $[6] !== args || $[7] !== handleNext || $[8] !== handleReset || $[9] !== keys || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(HookCollectionState, { hooks: t3, keys, args, handleNext, handleReset }), $[6] = args, $[7] = handleNext, $[8] = handleReset, $[9] = keys, $[10] = t3, $[11] = t4) : t4 = $[11];
  let t5;
  return $[12] !== result || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t4,
    result
  ] }), $[12] = result, $[13] = t4, $[14] = t5) : t5 = $[14], t5;
});
GetHookCollectionStateComponent.displayName = "Memo(GetHookCollectionState)";
const GetHookCollectionState = GetHookCollectionStateComponent;
function IntentButton(props2) {
  const $ = c(2);
  let t0;
  return $[0] !== props2 ? (t0 = props2.disabled ? /* @__PURE__ */ jsx(Button, { ...props2, as: "a", role: "link", "aria-disabled": "true" }) : /* @__PURE__ */ jsx(Button, { ...props2, as: IntentLink }), $[0] = props2, $[1] = t0) : t0 = $[1], t0;
}
const StyledContainer = styled(Container$2)((props2) => {
  const {
    theme
  } = props2, {
    container,
    media
  } = theme.sanity;
  return _responsive(media, props2.$width, (val) => ({
    // Make sure that the Container gets the correct width when used inside a popover.
    width: val === "auto" ? "none" : rem(container[val]),
    // Make sure that the Container width is constrained by available space.
    maxWidth: "100%"
  }));
}), PopoverContainer = forwardRef(function(props2, ref) {
  const $ = c(7);
  let restProps, width;
  $[0] !== props2 ? ({
    width,
    ...restProps
  } = props2, $[0] = props2, $[1] = restProps, $[2] = width) : (restProps = $[1], width = $[2]);
  const widthArr = useArrayProp(width);
  let t0;
  return $[3] !== ref || $[4] !== restProps || $[5] !== widthArr ? (t0 = /* @__PURE__ */ jsx(StyledContainer, { ...restProps, "data-ui": "PopoverContainer", $width: widthArr, ref }), $[3] = ref, $[4] = restProps, $[5] = widthArr, $[6] = t0) : t0 = $[6], t0;
}), StyledPopover$2 = styled(Popover)(() => css`
    // Make the popover scrollable if it overflows the viewport
    [data-ui='Popover__wrapper'] {
      overflow: auto;
    }
  `), StickyLayer = styled(Layer)((props2) => {
  const radii = props2.theme.sanity.radius[3];
  return css`
    position: sticky;
    top: 0;
    width: 100%;
    background: var(--card-bg-color);
    border-bottom: 1px solid var(--card-border-color);
    border-top-left-radius: ${radii}px;
    border-top-right-radius: ${radii}px;
  `;
});
function PopoverDialog(props2) {
  const $ = c(23), {
    children,
    header,
    onClose,
    referenceElement,
    containerRef,
    width
  } = props2;
  let t0;
  $[0] !== onClose || $[1] !== referenceElement ? (t0 = () => {
    onClose(), referenceElement?.focus();
  }, $[0] = onClose, $[1] = referenceElement, $[2] = t0) : t0 = $[2];
  const handleClose = t0;
  let t1;
  $[3] !== header ? (t1 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: header }) }), $[3] = header, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    content: "Close"
  }, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== handleClose ? (t3 = /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: handleClose, tooltipProps: t2 }), $[6] = handleClose, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t1 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(StickyLayer, { children: /* @__PURE__ */ jsx(Box, { padding: 2, paddingLeft: 4, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t1,
    t3
  ] }) }) }), $[8] = t1, $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== children ? (t5 = /* @__PURE__ */ jsx(Box, { padding: 4, children }), $[11] = children, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== containerRef || $[14] !== t4 || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(FocusLock, { autoFocus: !0, children: /* @__PURE__ */ jsxs(Stack, { ref: containerRef, children: [
    t4,
    t5
  ] }) }), $[13] = containerRef, $[14] = t4, $[15] = t5, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== t6 || $[18] !== width ? (t7 = /* @__PURE__ */ jsx(PopoverContainer, { width, children: t6 }), $[17] = t6, $[18] = width, $[19] = t7) : t7 = $[19];
  const content = t7;
  let t8;
  return $[20] !== content || $[21] !== referenceElement ? (t8 = /* @__PURE__ */ jsx(StyledPopover$2, { portal: !0, constrainSize: !0, content, open: !0, referenceElement }), $[20] = content, $[21] = referenceElement, $[22] = t8) : t8 = $[22], t8;
}
const StyledCard = styled(Card)(() => css`
    /* TextWithTone uses its own logic to set color, and we therefore need */
    /* to override this logic in order to set the correct color in different states */
    &[data-selected],
    &[data-pressed],
    &:active {
      [data-ui='TextWithTone'] {
        color: inherit;
      }
    }
  `);
function usePreviewCard() {
  const context = useContext(PreviewCardContext);
  if (!context)
    throw new Error("PreviewCard: missing context value");
  return context;
}
const PreviewCard = forwardRef(function(props2, ref) {
  const $ = c(16);
  let as, children, restProps, selected;
  $[0] !== props2 ? ({
    children,
    selected,
    as,
    ...restProps
  } = props2, $[0] = props2, $[1] = as, $[2] = children, $[3] = restProps, $[4] = selected) : (as = $[1], children = $[2], restProps = $[3], selected = $[4]);
  let t0, t1;
  $[5] !== selected ? (t1 = {
    selected
  }, $[5] = selected, $[6] = t1) : t1 = $[6], t0 = t1;
  const value = t0;
  let t2;
  $[7] !== children || $[8] !== value ? (t2 = /* @__PURE__ */ jsx(PreviewCardContext.Provider, { value, children }), $[7] = children, $[8] = value, $[9] = t2) : t2 = $[9];
  let t3;
  return $[10] !== as || $[11] !== ref || $[12] !== restProps || $[13] !== selected || $[14] !== t2 ? (t3 = /* @__PURE__ */ jsx(StyledCard, { "data-ui": "PreviewCard", ...restProps, forwardedAs: as, ref, selected, children: t2 }), $[10] = as, $[11] = ref, $[12] = restProps, $[13] = selected, $[14] = t2, $[15] = t3) : t3 = $[15], t3;
}), ReferenceInputPreviewCard = styled(PreviewCard)`
  /* this is a hack to avoid layout jumps while previews are loading
there's probably better ways of solving this */
  min-height: 36px;
`, MediaWrapper = styled.span((props2) => {
  const {
    $dimensions,
    $layout,
    $radius,
    $responsive
  } = props2, width = $dimensions.width || 0, height = $dimensions.width || 0, iconSize = PREVIEW_SIZES[$layout].icon;
  return css`
    position: relative;
    width: ${$responsive ? "100%" : rem(width)};
    height: ${$responsive ? "100%" : rem(height)};
    min-width: ${$responsive ? void 0 : rem(width)};
    border-radius: ${({
    theme
  }) => rem(theme.sanity.radius[$radius])};
    display: flex;
    overflow: hidden;
    overflow: clip;
    align-items: center;
    justify-content: center;

    & img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: inherit;
    }

    & svg {
      // Shared styles for SVG icons
      color: var(--card-icon-color);
      display: block;
      flex: 1;

      // Specific styles for non Sanity icons
      &:not([data-sanity-icon]) {
        height: 1em;
        width: 1em;
        max-width: 1em;
        max-height: 1em;
      }

      // Specific styles for Sanity icons
      &[data-sanity-icon] {
        display: block;
        font-size: calc(${iconSize} / 16 * 1em);
      }
    }

    & > span[data-border] {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      box-shadow: inset 0 0 0 1px var(--card-fg-color);
      opacity: 0.1;
      border-radius: inherit;
      pointer-events: none;
    }
  `;
});
MediaWrapper.displayName = "Styled(MediaWrapper)";
function Media(props2) {
  const $ = c(14), {
    border: t0,
    dimensions,
    layout,
    media,
    radius: t1,
    responsive: t2,
    styles
  } = props2, border = t0 === void 0 ? !0 : t0, radius = t1 === void 0 ? 1 : t1, responsive = t2 === void 0 ? !1 : t2, t3 = styles?.media;
  let t4;
  $[0] !== dimensions || $[1] !== layout || $[2] !== media ? (t4 = renderMedia({
    dimensions,
    layout,
    media
  }), $[0] = dimensions, $[1] = layout, $[2] = media, $[3] = t4) : t4 = $[3];
  let t5;
  $[4] !== border ? (t5 = border && /* @__PURE__ */ jsx("span", { "data-border": !0 }), $[4] = border, $[5] = t5) : t5 = $[5];
  let t6;
  return $[6] !== dimensions || $[7] !== layout || $[8] !== radius || $[9] !== responsive || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 ? (t6 = /* @__PURE__ */ jsxs(MediaWrapper, { $dimensions: dimensions, $layout: layout, $radius: radius, $responsive: responsive, className: t3, "data-testid": "Media", children: [
    t4,
    t5
  ] }), $[6] = dimensions, $[7] = layout, $[8] = radius, $[9] = responsive, $[10] = t3, $[11] = t4, $[12] = t5, $[13] = t6) : t6 = $[13], t6;
}
function renderMedia(props2) {
  const {
    dimensions,
    layout,
    media,
    styles
  } = props2;
  return isValidElementType(media) ? /* @__PURE__ */ jsx(media, { dimensions, layout }) : typeof media == "string" ? /* @__PURE__ */ jsx(Text$1, { as: "span", className: styles?.mediaString, size: 1, children: media }) : isValidElement(media) ? media : null;
}
function renderPreviewMedia(value, layout, dimensions) {
  return isValidElementType(value) ? /* @__PURE__ */ jsx(value, { layout, dimensions }) : typeof value == "string" ? /* @__PURE__ */ jsx("div", { children: value }) : value;
}
function renderPreviewNode(value, layout, fallbackNode) {
  return typeof value == "string" ? value : isValidElementType(value) ? /* @__PURE__ */ jsx(value, { layout }) : value || fallbackNode;
}
const DEFAULT_MEDIA_DIMENSIONS$6 = {
  ...PREVIEW_SIZES.compact.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
}, Root$6 = styled(Flex)`
  height: ${rem(PREVIEW_SIZES.compact.media.height)};
  box-sizing: content-box;
`, TitleSkeleton$2 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
})`
  max-width: ${rem(160)};
  width: 80%;
`;
function CompactPreview(props2) {
  const $ = c(32), {
    children,
    isPlaceholder,
    media,
    status,
    title
  } = props2, {
    t
  } = useTranslation();
  let t0;
  $[0] !== status ? (t0 = status && /* @__PURE__ */ jsx(Box, { "data-testid": "compact-preview__status", paddingLeft: 4, paddingRight: 1, children: renderPreviewNode(status, "compact") }), $[0] = status, $[1] = t0) : t0 = $[1];
  const statusNode = t0;
  if (isPlaceholder) {
    const t12 = media ? 1 : 2;
    let t22;
    $[2] !== media ? (t22 = media && /* @__PURE__ */ jsx(Skeleton, { animated: !0, radius: 2, style: PREVIEW_SIZES.compact.media }), $[2] = media, $[3] = t22) : t22 = $[3];
    let t32;
    $[4] === Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(Stack, { "data-testid": "compact-preview__heading", flex: 1, space: 2, children: /* @__PURE__ */ jsx(TitleSkeleton$2, {}) }), $[4] = t32) : t32 = $[4];
    let t42;
    $[5] !== statusNode || $[6] !== t22 ? (t42 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 2, children: [
      t22,
      t32,
      statusNode
    ] }), $[5] = statusNode, $[6] = t22, $[7] = t42) : t42 = $[7];
    let t52;
    return $[8] !== t12 || $[9] !== t42 ? (t52 = /* @__PURE__ */ jsx(Root$6, { align: "center", "data-testid": "default-preview", paddingLeft: t12, paddingRight: 2, paddingY: 1, children: t42 }), $[8] = t12, $[9] = t42, $[10] = t52) : t52 = $[10], t52;
  }
  const t1 = media ? 1 : 2;
  let t2;
  $[11] !== media ? (t2 = media && /* @__PURE__ */ jsx(Media, { border: !1, dimensions: DEFAULT_MEDIA_DIMENSIONS$6, layout: "compact", media }), $[11] = media, $[12] = t2) : t2 = $[12];
  let t3;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    color: "inherit"
  }, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== title ? (t4 = title && renderPreviewNode(title, "compact"), $[14] = title, $[15] = t4) : t4 = $[15];
  let t5;
  $[16] !== t || $[17] !== title ? (t5 = !title && /* @__PURE__ */ jsx("span", { style: {
    color: "var(--card-muted-fg-color)"
  }, children: t("preview.default.title-fallback") }), $[16] = t, $[17] = title, $[18] = t5) : t5 = $[18];
  let t6;
  $[19] !== t4 || $[20] !== t5 ? (t6 = /* @__PURE__ */ jsx(Stack, { "data-testid": "compact-preview__header", flex: 1, space: 2, children: /* @__PURE__ */ jsxs(Text$1, { size: 1, style: t3, textOverflow: "ellipsis", weight: "medium", children: [
    t4,
    t5
  ] }) }), $[19] = t4, $[20] = t5, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== statusNode || $[23] !== t2 || $[24] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 2, children: [
    t2,
    t6,
    statusNode
  ] }), $[22] = statusNode, $[23] = t2, $[24] = t6, $[25] = t7) : t7 = $[25];
  let t8;
  $[26] !== children ? (t8 = children && /* @__PURE__ */ jsx(Box, { marginLeft: 1, children }), $[26] = children, $[27] = t8) : t8 = $[27];
  let t9;
  return $[28] !== t1 || $[29] !== t7 || $[30] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Root$6, { align: "center", "data-testid": "compact-preview", paddingLeft: t1, paddingRight: 2, paddingY: 1, children: [
    t7,
    t8
  ] }), $[28] = t1, $[29] = t7, $[30] = t8, $[31] = t9) : t9 = $[31], t9;
}
const DEFAULT_MEDIA_DIMENSIONS$5 = {
  ...PREVIEW_SIZES.default.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
}, Root$5 = styled(Flex)`
  height: ${rem(PREVIEW_SIZES.default.media.height)};
  box-sizing: content-box;
`, TitleSkeleton$1 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
})`
  max-width: ${rem(160)};
  width: 80%;
`, SubtitleSkeleton$1 = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
})`
  max-width: ${rem(120)};
  width: 60%;
`, SKELETON_DELAY = 300;
function DefaultPreview(props2) {
  const $ = c(52), {
    title,
    subtitle,
    media,
    status,
    isPlaceholder,
    children,
    styles
  } = props2, {
    t
  } = useTranslation(), t0 = styles?.root, t1 = !!subtitle && styles?.hasSubtitle;
  let t2;
  $[0] !== t0 || $[1] !== t1 ? (t2 = classNames(t0, t1), $[0] = t0, $[1] = t1, $[2] = t2) : t2 = $[2];
  const rootClassName = t2;
  let t3;
  $[3] !== status || $[4] !== styles?.status ? (t3 = status && /* @__PURE__ */ jsx(Box, { className: styles?.status, "data-testid": "default-preview__status", children: renderPreviewNode(status, "default") }), $[3] = status, $[4] = styles?.status, $[5] = t3) : t3 = $[5];
  const statusNode = t3;
  if (isPlaceholder) {
    const t42 = styles?.placeholder, t52 = media ? 2 : 3;
    let t62;
    $[6] !== media ? (t62 = media && /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Skeleton, { animated: !0, delay: SKELETON_DELAY, radius: 1, style: PREVIEW_SIZES.default.media }) }), $[6] = media, $[7] = t62) : t62 = $[7];
    let t72;
    $[8] === Symbol.for("react.memo_cache_sentinel") ? (t72 = /* @__PURE__ */ jsxs(Stack, { "data-testid": "default-preview__heading", flex: 1, space: 2, children: [
      /* @__PURE__ */ jsx(TitleSkeleton$1, { delay: SKELETON_DELAY }),
      /* @__PURE__ */ jsx(SubtitleSkeleton$1, { delay: SKELETON_DELAY })
    ] }), $[8] = t72) : t72 = $[8];
    let t82;
    $[9] !== statusNode ? (t82 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 1, children: statusNode }), $[9] = statusNode, $[10] = t82) : t82 = $[10];
    let t92;
    $[11] !== t62 || $[12] !== t82 ? (t92 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 2, children: [
      t62,
      t72,
      t82
    ] }), $[11] = t62, $[12] = t82, $[13] = t92) : t92 = $[13];
    let t102;
    return $[14] !== t42 || $[15] !== t52 || $[16] !== t92 ? (t102 = /* @__PURE__ */ jsx(Root$5, { align: "center", className: t42, "data-testid": "default-preview", padding: 2, paddingLeft: t52, children: t92 }), $[14] = t42, $[15] = t52, $[16] = t92, $[17] = t102) : t102 = $[17], t102;
  }
  const t4 = media ? 2 : 3;
  let t5;
  $[18] !== media || $[19] !== styles ? (t5 = media && /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Media, { dimensions: DEFAULT_MEDIA_DIMENSIONS$5, layout: "default", media, styles }) }), $[18] = media, $[19] = styles, $[20] = t5) : t5 = $[20];
  const t6 = styles?.heading, t7 = styles?.title;
  let t8;
  $[21] === Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    color: "inherit"
  }, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] !== title ? (t9 = title && renderPreviewNode(title, "default"), $[22] = title, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== t || $[25] !== title ? (t10 = !title && /* @__PURE__ */ jsx("span", { style: {
    color: "var(--card-muted-fg-color)"
  }, children: t("preview.default.title-fallback") }), $[24] = t, $[25] = title, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== t10 || $[28] !== t7 || $[29] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Text$1, { className: t7, size: 1, style: t8, textOverflow: "ellipsis", weight: "medium", children: [
    t9,
    t10
  ] }), $[27] = t10, $[28] = t7, $[29] = t9, $[30] = t11) : t11 = $[30];
  let t12;
  $[31] !== styles?.subtitle || $[32] !== subtitle ? (t12 = subtitle && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", className: styles?.subtitle, children: renderPreviewNode(subtitle, "default") }), $[31] = styles?.subtitle, $[32] = subtitle, $[33] = t12) : t12 = $[33];
  let t13;
  $[34] !== t11 || $[35] !== t12 || $[36] !== t6 ? (t13 = /* @__PURE__ */ jsxs(Stack, { className: t6, "data-testid": "default-preview__header", flex: 1, space: 2, children: [
    t11,
    t12
  ] }), $[34] = t11, $[35] = t12, $[36] = t6, $[37] = t13) : t13 = $[37];
  let t14;
  $[38] !== statusNode ? (t14 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 1, children: statusNode }), $[38] = statusNode, $[39] = t14) : t14 = $[39];
  let t15;
  $[40] !== children || $[41] !== styles?.children ? (t15 = children && /* @__PURE__ */ jsx("div", { className: styles?.children, children }), $[40] = children, $[41] = styles?.children, $[42] = t15) : t15 = $[42];
  let t16;
  $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t5 ? (t16 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 2, children: [
    t5,
    t13,
    t14,
    t15
  ] }), $[43] = t13, $[44] = t14, $[45] = t15, $[46] = t5, $[47] = t16) : t16 = $[47];
  let t17;
  return $[48] !== rootClassName || $[49] !== t16 || $[50] !== t4 ? (t17 = /* @__PURE__ */ jsx(Root$5, { align: "center", className: rootClassName, "data-testid": "default-preview", padding: 2, paddingLeft: t4, children: t16 }), $[48] = rootClassName, $[49] = t16, $[50] = t4, $[51] = t17) : t17 = $[51], t17;
}
const DEFAULT_MEDIA_DIMENSIONS$4 = {
  ...PREVIEW_SIZES.detail.media,
  fit: "crop",
  aspect: 1,
  dpr: getDevicePixelRatio()
};
function DetailPreview(props2) {
  const $ = c(47), {
    title,
    subtitle,
    description,
    mediaDimensions: t0,
    media,
    status,
    children,
    isPlaceholder
  } = props2, mediaDimensions = t0 === void 0 ? DEFAULT_MEDIA_DIMENSIONS$4 : t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== status ? (t1 = status && /* @__PURE__ */ jsx(StatusBox, { marginLeft: 3, paddingRight: 1, children: renderPreviewNode(status, "detail") }), $[0] = status, $[1] = t1) : t1 = $[1];
  const statusNode = t1;
  if (isPlaceholder) {
    const t22 = media ? 2 : 3;
    let t32;
    $[2] !== media ? (t32 = media && /* @__PURE__ */ jsx(MediaSkeleton$1, { "data-testid": "detail-preview__media" }), $[2] = media, $[3] = t32) : t32 = $[3];
    let t42, t52;
    $[4] === Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(TitleSkeleton$3, {}), t52 = /* @__PURE__ */ jsx(SubtitleSkeleton$2, {}), $[4] = t42, $[5] = t52) : (t42 = $[4], t52 = $[5]);
    let t62;
    $[6] !== description ? (t62 = description && /* @__PURE__ */ jsx(Box, { marginTop: 1, children: /* @__PURE__ */ jsx(DescriptionSkeleton, {}) }), $[6] = description, $[7] = t62) : t62 = $[7];
    let t72;
    $[8] !== t62 ? (t72 = /* @__PURE__ */ jsx(Flex, { align: "center", "data-testid": "detail-preview__header", flex: 1, children: /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
      t42,
      t52,
      t62
    ] }) }), $[8] = t62, $[9] = t72) : t72 = $[9];
    let t82;
    $[10] !== statusNode || $[11] !== t32 || $[12] !== t72 ? (t82 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 3, children: [
      t32,
      t72,
      statusNode
    ] }), $[10] = statusNode, $[11] = t32, $[12] = t72, $[13] = t82) : t82 = $[13];
    let t92;
    return $[14] !== t22 || $[15] !== t82 ? (t92 = /* @__PURE__ */ jsx(RootFlex$7, { "data-testid": "detail-preview", paddingLeft: t22, paddingRight: 2, paddingY: 2, children: t82 }), $[14] = t22, $[15] = t82, $[16] = t92) : t92 = $[16], t92;
  }
  const t2 = media ? 2 : 3;
  let t3;
  $[17] !== media || $[18] !== mediaDimensions ? (t3 = media && /* @__PURE__ */ jsx(Media, { dimensions: mediaDimensions, layout: "detail", media }), $[17] = media, $[18] = mediaDimensions, $[19] = t3) : t3 = $[19];
  let t4;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    color: "inherit"
  }, $[20] = t4) : t4 = $[20];
  let t5;
  $[21] !== title ? (t5 = title && renderPreviewNode(title, "detail"), $[21] = title, $[22] = t5) : t5 = $[22];
  let t6;
  $[23] !== t || $[24] !== title ? (t6 = !title && /* @__PURE__ */ jsx(Fragment, { children: t("preview.default.title-fallback") }), $[23] = t, $[24] = title, $[25] = t6) : t6 = $[25];
  let t7;
  $[26] !== t5 || $[27] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Text$1, { textOverflow: "ellipsis", size: 1, style: t4, weight: "medium", children: [
    t5,
    t6
  ] }), $[26] = t5, $[27] = t6, $[28] = t7) : t7 = $[28];
  let t8;
  $[29] !== subtitle ? (t8 = subtitle && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: renderPreviewNode(subtitle, "detail") }), $[29] = subtitle, $[30] = t8) : t8 = $[30];
  let t9;
  $[31] !== description ? (t9 = description && /* @__PURE__ */ jsx(Box, { marginTop: 1, children: /* @__PURE__ */ jsx(DescriptionText, { muted: !0, size: 1, children: renderPreviewNode(description, "detail") }) }), $[31] = description, $[32] = t9) : t9 = $[32];
  let t10;
  $[33] !== t7 || $[34] !== t8 || $[35] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t7,
    t8,
    t9
  ] }), $[33] = t7, $[34] = t8, $[35] = t9, $[36] = t10) : t10 = $[36];
  let t11;
  $[37] !== statusNode || $[38] !== t10 ? (t11 = /* @__PURE__ */ jsxs(Flex, { align: "center", "data-testid": "detail-preview__header", flex: 1, children: [
    t10,
    statusNode
  ] }), $[37] = statusNode, $[38] = t10, $[39] = t11) : t11 = $[39];
  let t12;
  $[40] !== children || $[41] !== t11 || $[42] !== t3 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: 3, children: [
    t3,
    t11,
    children
  ] }), $[40] = children, $[41] = t11, $[42] = t3, $[43] = t12) : t12 = $[43];
  let t13;
  return $[44] !== t12 || $[45] !== t2 ? (t13 = /* @__PURE__ */ jsx(RootFlex$7, { "data-testid": "detail-preview", paddingLeft: t2, paddingRight: 2, paddingY: 2, children: t12 }), $[44] = t12, $[45] = t2, $[46] = t13) : t13 = $[46], t13;
}
const SIZE = 43, STROKE_WIDTH$1 = 3, Root$4 = styled.svg`
  width: ${SIZE}px;
  height: ${SIZE}px;
  transform: rotate(-90deg);
`, BgCircle = styled.circle(({
  theme
}) => {
  const {
    color
  } = theme.sanity;
  return css`
    fill: none;
    stroke: ${hues.gray[color.dark ? 900 : 100].hex};
    stroke-width: ${STROKE_WIDTH$1}px;
  `;
}), ProgressCircle = styled.circle(({
  theme
}) => {
  const {
    color
  } = theme.sanity;
  return css`
    fill: none;
    stroke: ${hues.blue[color.dark ? 400 : 500].hex};
    stroke-width: ${STROKE_WIDTH$1}px;
    transition: stroke-dashoffset 75ms;
  `;
});
function CircularProgress(props2) {
  const $ = c(3), {
    value: valueProp
  } = props2, value = Math.min(Math.max(valueProp, 0), 100), radius = SIZE / 2 - STROKE_WIDTH$1 / 2, circ = 2 * Math.PI * radius, offset = (100 - value) / 100 * circ, viewBox = `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(BgCircle, { cx: SIZE, cy: SIZE, r: radius }), $[0] = t0) : t0 = $[0];
  const t1 = `${offset}px`;
  let t2;
  return $[1] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Root$4, { viewBox, children: [
    t0,
    /* @__PURE__ */ jsx(ProgressCircle, { cx: SIZE, cy: SIZE, r: radius, style: {
      strokeDasharray: circ,
      strokeDashoffset: t1
    } })
  ] }), $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}
const STROKE_WIDTH = 0.5, Root$3 = styled(Card)`
  overflow: hidden;
  overflow: clip;
`, Bar = styled(Card)(({
  theme
}) => {
  const {
    color
  } = theme.sanity;
  return css`
    height: ${STROKE_WIDTH}rem;
    background: ${hues.blue[color.dark ? 400 : 500].hex};
    transition: transform 75ms;
  `;
});
function LinearProgress(props2) {
  const $ = c(2), {
    value
  } = props2, t0 = `translate3d(${value - 100}%, 0, 0)`;
  let t1;
  return $[0] !== t0 ? (t1 = /* @__PURE__ */ jsx(Root$3, { radius: 5, children: /* @__PURE__ */ jsx(Bar, { radius: 5, style: {
    transform: t0
  } }) }), $[0] = t0, $[1] = t1) : t1 = $[1], t1;
}
const RootBox$1 = styled(Box)`
  position: relative;
`, MediaFlex = styled(Flex).attrs({
  align: "center",
  justify: "center"
})`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`, MediaSkeleton = styled(Skeleton).attrs({
  animated: !0,
  radius: 2
})`
  width: 100%;
  height: 100%;
`, ProgressFlex = styled(Flex).attrs({
  align: "center",
  justify: "center"
})`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  &:before {
    background-color: var(--card-bg-color);
    opacity: 0.75;
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  > svg {
    position: relative;
    z-index: 2;
  }
`, TooltipContentStack = styled(Stack).attrs({
  space: 2
})`
  max-width: ${rem(200)};
`, DEFAULT_MEDIA_DIMENSIONS$3 = {
  ...PREVIEW_SIZES.media.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
};
function MediaPreview(props2) {
  const $ = c(30), {
    media,
    mediaDimensions: t0,
    children,
    isPlaceholder,
    progress: t1,
    subtitle,
    title,
    withBorder: t2,
    withRadius: t3
  } = props2, mediaDimensions = t0 === void 0 ? DEFAULT_MEDIA_DIMENSIONS$3 : t0, progress = t1 === void 0 ? -1 : t1, withBorder = t2 === void 0 ? !0 : t2, withRadius = t3 === void 0 ? !0 : t3, aspect = mediaDimensions.aspect || 1;
  let t4;
  const t5 = `${100 / aspect}%`;
  let t6;
  $[0] !== t5 ? (t6 = {
    paddingBottom: t5
  }, $[0] = t5, $[1] = t6) : t6 = $[1], t4 = t6;
  const STYLES_PADDER = t4;
  let t7;
  bb0: {
    if (!title || !subtitle) {
      t7 = null;
      break bb0;
    }
    let t82;
    $[2] !== title ? (t82 = title && /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, weight: "medium", children: renderPreviewNode(title, "media") }), $[2] = title, $[3] = t82) : t82 = $[3];
    let t92;
    $[4] !== subtitle ? (t92 = subtitle && /* @__PURE__ */ jsx(Text$1, { align: "center", muted: !0, size: 1, children: renderPreviewNode(subtitle, "media") }), $[4] = subtitle, $[5] = t92) : t92 = $[5];
    let t102;
    $[6] !== t82 || $[7] !== t92 ? (t102 = /* @__PURE__ */ jsxs(TooltipContentStack, { children: [
      t82,
      t92
    ] }), $[6] = t82, $[7] = t92, $[8] = t102) : t102 = $[8], t7 = t102;
  }
  const tooltipContent = t7;
  let t8;
  $[9] !== STYLES_PADDER ? (t8 = /* @__PURE__ */ jsx("div", { style: STYLES_PADDER }), $[9] = STYLES_PADDER, $[10] = t8) : t8 = $[10];
  const t9 = !tooltipContent;
  let t10;
  $[11] !== isPlaceholder || $[12] !== media || $[13] !== mediaDimensions || $[14] !== withBorder || $[15] !== withRadius ? (t10 = isPlaceholder ? /* @__PURE__ */ jsx(MediaSkeleton, {}) : /* @__PURE__ */ jsx(Media, { border: withBorder, dimensions: mediaDimensions, layout: "media", media, radius: withRadius ? 1 : 0, responsive: !0 }), $[11] = isPlaceholder, $[12] = media, $[13] = mediaDimensions, $[14] = withBorder, $[15] = withRadius, $[16] = t10) : t10 = $[16];
  let t11;
  $[17] !== progress ? (t11 = typeof progress == "number" && progress > -1 && /* @__PURE__ */ jsx(ProgressFlex, { children: /* @__PURE__ */ jsx(CircularProgress, { value: progress }) }), $[17] = progress, $[18] = t11) : t11 = $[18];
  let t12;
  $[19] !== t10 || $[20] !== t11 ? (t12 = /* @__PURE__ */ jsxs(MediaFlex, { children: [
    t10,
    t11
  ] }), $[19] = t10, $[20] = t11, $[21] = t12) : t12 = $[21];
  let t13;
  $[22] !== t12 || $[23] !== t9 || $[24] !== tooltipContent ? (t13 = /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, disabled: t9, placement: "top", portal: !0, children: t12 }), $[22] = t12, $[23] = t9, $[24] = tooltipContent, $[25] = t13) : t13 = $[25];
  let t14;
  return $[26] !== children || $[27] !== t13 || $[28] !== t8 ? (t14 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsxs(RootBox$1, { "data-testid": "media-preview", flex: 1, overflow: "hidden", children: [
    t8,
    t13,
    children
  ] }) }), $[26] = children, $[27] = t13, $[28] = t8, $[29] = t14) : t14 = $[29], t14;
}
const HeaderFlex$4 = styled(Flex).attrs({
  align: "center"
})`
  height: ${rem(PREVIEW_SIZES.block.media.height)};
  white-space: nowrap;
  position: relative;
  z-index: 1;
`, MediaCard = styled(Card)`
  overflow: hidden;
  position: relative;
  padding-bottom: ${({
  $ratio
}) => $ratio}%;

  & > span {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`, RootBox = styled(Box).attrs({
  overflow: "hidden"
})`
  border-radius: ${({
  theme
}) => theme.sanity.radius[1]}px;
`, DEFAULT_MEDIA_DIMENSIONS$2 = {
  ...PREVIEW_SIZES.blockImage.media,
  fit: "fillmax",
  dpr: getDevicePixelRatio()
}, getRatio = (dimensions) => {
  const {
    height,
    width
  } = dimensions;
  return !height || !width ? 1 : height / width * 100;
};
function BlockImagePreview(props2) {
  const $ = c(35), {
    actions,
    title,
    subtitle,
    description,
    fallbackTitle: t0,
    mediaDimensions: t1,
    media,
    children,
    status
  } = props2, fallbackTitle = t0 === void 0 ? "Untitled" : t0, mediaDimensions = t1 === void 0 ? DEFAULT_MEDIA_DIMENSIONS$2 : t1;
  let t2;
  $[0] !== fallbackTitle || $[1] !== title ? (t2 = (title || fallbackTitle) && /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: title ? renderPreviewNode(title, "block") : fallbackTitle }), $[0] = fallbackTitle, $[1] = title, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== subtitle ? (t3 = subtitle && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: renderPreviewNode(subtitle, "block") }), $[3] = subtitle, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t2,
    t3
  ] }), $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  $[8] !== status ? (t5 = status && /* @__PURE__ */ jsx(Box, { paddingX: 2, paddingY: 3, children: renderPreviewNode(status, "block") }), $[8] = status, $[9] = t5) : t5 = $[9];
  const t6 = actions;
  let t7;
  $[10] !== t5 || $[11] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { gap: 1, paddingLeft: 1, children: [
    t5,
    t6
  ] }), $[10] = t5, $[11] = t6, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== t4 || $[14] !== t7 ? (t8 = /* @__PURE__ */ jsxs(HeaderFlex$4, { paddingBottom: 3, paddingLeft: 2, paddingRight: 1, paddingTop: 1, children: [
    t4,
    t7
  ] }), $[13] = t4, $[14] = t7, $[15] = t8) : t8 = $[15];
  let t9;
  $[16] !== mediaDimensions ? (t9 = getRatio(mediaDimensions), $[16] = mediaDimensions, $[17] = t9) : t9 = $[17];
  const t10 = media;
  let t11;
  $[18] !== mediaDimensions || $[19] !== t10 ? (t11 = /* @__PURE__ */ jsx(Media, { border: !1, dimensions: mediaDimensions, layout: "blockImage", media: t10, radius: 0, responsive: !0 }), $[18] = mediaDimensions, $[19] = t10, $[20] = t11) : t11 = $[20];
  let t12;
  $[21] !== t11 || $[22] !== t9 ? (t12 = /* @__PURE__ */ jsx(MediaCard, { $ratio: t9, __unstable_checkered: !0, display: "flex", sizing: "border", radius: 2, tone: "inherit", children: t11 }), $[21] = t11, $[22] = t9, $[23] = t12) : t12 = $[23];
  let t13;
  $[24] !== t12 || $[25] !== t8 ? (t13 = /* @__PURE__ */ jsxs(Stack, { children: [
    t8,
    t12
  ] }), $[24] = t12, $[25] = t8, $[26] = t13) : t13 = $[26];
  let t14;
  $[27] !== description ? (t14 = description && /* @__PURE__ */ jsx(Box, { paddingX: 2, paddingY: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, children: renderPreviewNode(description, "block") }) }), $[27] = description, $[28] = t14) : t14 = $[28];
  let t15;
  $[29] !== children ? (t15 = children && /* @__PURE__ */ jsx("div", { children }), $[29] = children, $[30] = t15) : t15 = $[30];
  let t16;
  return $[31] !== t13 || $[32] !== t14 || $[33] !== t15 ? (t16 = /* @__PURE__ */ jsxs(RootBox, { children: [
    t13,
    t14,
    t15
  ] }), $[31] = t13, $[32] = t14, $[33] = t15, $[34] = t16) : t16 = $[34], t16;
}
const DEFAULT_MEDIA_DIMENSIONS$1 = {
  ...PREVIEW_SIZES.block.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
}, HeaderFlex$3 = styled(Flex).attrs({
  align: "center"
})`
  min-height: ${rem(PREVIEW_SIZES.block.media.height)};
`;
function BlockPreview(props2) {
  const $ = c(30), {
    actions,
    title,
    subtitle,
    description,
    mediaDimensions: t0,
    media,
    status,
    children
  } = props2, mediaDimensions = t0 === void 0 ? DEFAULT_MEDIA_DIMENSIONS$1 : t0;
  let t1;
  $[0] !== media || $[1] !== mediaDimensions ? (t1 = media && /* @__PURE__ */ jsx(Media, { dimensions: mediaDimensions, layout: "block", media }), $[0] = media, $[1] = mediaDimensions, $[2] = t1) : t1 = $[2];
  const t2 = media ? 2 : 1;
  let t3;
  $[3] !== title ? (t3 = title ? renderPreviewNode(title, "block") : "Untitled", $[3] = title, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", weight: "medium", children: t3 }), $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== subtitle ? (t5 = subtitle && /* @__PURE__ */ jsx(Box, { marginTop: 2, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: renderPreviewNode(subtitle, "block") }) }), $[7] = subtitle, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== description ? (t6 = description && /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: renderPreviewNode(description, "block") }) }), $[9] = description, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== t2 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Box, { flex: 1, paddingLeft: t2, children: [
    t4,
    t5,
    t6
  ] }), $[11] = t2, $[12] = t4, $[13] = t5, $[14] = t6, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== status ? (t8 = status && /* @__PURE__ */ jsx(Box, { paddingX: 2, paddingY: 3, children: renderPreviewNode(status, "block") }), $[16] = status, $[17] = t8) : t8 = $[17];
  const t9 = actions;
  let t10;
  $[18] !== t8 || $[19] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { gap: 1, paddingLeft: 1, children: [
    t8,
    t9
  ] }), $[18] = t8, $[19] = t9, $[20] = t10) : t10 = $[20];
  let t11;
  $[21] !== t1 || $[22] !== t10 || $[23] !== t7 ? (t11 = /* @__PURE__ */ jsxs(HeaderFlex$3, { "data-testid": "block-preview__header", children: [
    t1,
    t7,
    t10
  ] }), $[21] = t1, $[22] = t10, $[23] = t7, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== children ? (t12 = children && /* @__PURE__ */ jsx("div", { "data-testid": "block-preview__children", children }), $[25] = children, $[26] = t12) : t12 = $[26];
  let t13;
  return $[27] !== t11 || $[28] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Stack, { "data-testid": "block-preview", space: 1, children: [
    t11,
    t12
  ] }), $[27] = t11, $[28] = t12, $[29] = t13) : t13 = $[29], t13;
}
const RootSpan = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  height: calc(1em - 1px);
  max-width: 100%;
`, MediaSpan = styled.span`
  position: relative;
  display: inline-block;
  width: calc(1em - 1px);
  height: calc(1em - 1px);
  min-width: calc(1em - 1px);

  & img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${({
  theme
}) => rem(theme.sanity.radius[1])};
  }

  & img + span {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    box-shadow: inset 0 0 0 1px var(--card-fg-color);
    opacity: 0.2;
    border-radius: ${({
  theme
}) => rem(theme.sanity.radius[1])};
  }

  & svg {
    display: block;
    font-size: calc(14 / 16 * 1em);
    margin: 1px 0;

    &[data-sanity-icon] {
      font-size: calc(18 / 16 * 1em);
      margin: calc(1px + (2 / 18 * -1em)) 0;
    }
  }
`, TextSpan = styled(Text$1).attrs({
  forwardedAs: "span"
})(({
  theme
}) => {
  const textFont = theme.sanity.fonts.text, textSize = textFont.sizes[1];
  return css`
    font-size: calc(${textSize.fontSize} / 16 * 1em);
    font-weight: ${textFont.weights.medium};
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    line-height: ${textSize.lineHeight / textSize.fontSize};
    padding-left: 0.5em;
    padding-right: calc(0.5em - 2px);
    min-width: 0;

    & > span {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      overflow: clip;
    }
  `;
}), DEFAULT_MEDIA_DIMENSIONS = {
  ...PREVIEW_SIZES.inline.media,
  fit: "crop",
  aspect: 1,
  dpr: getDevicePixelRatio()
};
function InlinePreview(props2) {
  const $ = c(11), {
    title,
    fallbackTitle: t0,
    media,
    mediaDimensions: t1
  } = props2, fallbackTitle = t0 === void 0 ? "Untitled" : t0, mediaDimensions = t1 === void 0 ? DEFAULT_MEDIA_DIMENSIONS : t1;
  let t2;
  $[0] !== media || $[1] !== mediaDimensions ? (t2 = media && /* @__PURE__ */ jsxs(MediaSpan, { "data-testid": "inline-preview-media", children: [
    renderPreviewMedia(media, "inline", mediaDimensions),
    /* @__PURE__ */ jsx("span", {})
  ] }), $[0] = media, $[1] = mediaDimensions, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== fallbackTitle || $[4] !== title ? (t3 = renderPreviewNode(title, "inline", fallbackTitle), $[3] = fallbackTitle, $[4] = title, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(TextSpan, { "data-testid": "inline-preview-title", size: 1, children: t3 }), $[6] = t3, $[7] = t4) : t4 = $[7];
  let t5;
  return $[8] !== t2 || $[9] !== t4 ? (t5 = /* @__PURE__ */ jsxs(RootSpan, { "data-testid": "inline-preview", children: [
    t2,
    t4
  ] }), $[8] = t2, $[9] = t4, $[10] = t5) : t5 = $[10], t5;
}
const DEFAULT_MEDIA_DIMENSION = {
  ...PREVIEW_SIZES.default.media,
  aspect: 1,
  fit: "crop",
  dpr: getDevicePixelRatio()
}, Root$2 = styled(Box)`
  height: 100%;

  a {
    color: currentColor;
    text-decoration: none;
  }

  svg[data-sanity-icon] {
    margin: 0;
  }
`, HeaderFlex$2 = styled(Flex).attrs({
  align: "center"
})`
  height: ${rem(PREVIEW_SIZES.default.media.height)};
`, TitleSkeleton = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1
})`
  max-width: ${rem(160)};
  width: 80%;
`, SubtitleSkeleton = styled(TextSkeleton).attrs({
  animated: !0,
  radius: 1,
  size: 1
})`
  max-width: ${rem(120)};
  width: 60%;
`;
function TemplatePreview(props2) {
  const $ = c(25), {
    description,
    isPlaceholder,
    media,
    mediaDimensions: t0,
    subtitle: Subtitle,
    title: t1
  } = props2, mediaDimensions = t0 === void 0 ? DEFAULT_MEDIA_DIMENSION : t0, Title2 = t1 === void 0 ? "Untitled" : t1;
  if (isPlaceholder) {
    let t22;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(Root$2, { children: /* @__PURE__ */ jsx(HeaderFlex$2, { children: /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
      /* @__PURE__ */ jsx(TitleSkeleton, {}),
      /* @__PURE__ */ jsx(SubtitleSkeleton, {})
    ] }) }) }), $[0] = t22) : t22 = $[0], t22;
  }
  let t2;
  $[1] !== Title2 ? (t2 = isValidElementType(Title2) && /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Title2, { layout: "default" }) }), $[1] = Title2, $[2] = t2) : t2 = $[2];
  let t3;
  $[3] !== Title2 ? (t3 = isValidElement(Title2) && /* @__PURE__ */ jsx(Text$1, { textOverflow: "ellipsis", children: Title2 }), $[3] = Title2, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== Subtitle ? (t4 = isValidElementType(Subtitle) && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Subtitle, { layout: "default" }) }), $[5] = Subtitle, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== Subtitle ? (t5 = isValidElement(Subtitle) && /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, textOverflow: "ellipsis", children: Subtitle }), $[7] = Subtitle, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
    t2,
    t3,
    t4,
    t5
  ] }), $[9] = t2, $[10] = t3, $[11] = t4, $[12] = t5, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== media || $[15] !== mediaDimensions ? (t7 = media && /* @__PURE__ */ jsx(Flex, { align: "flex-start", paddingLeft: 2, children: /* @__PURE__ */ jsx(Media, { dimensions: mediaDimensions, layout: "default", media }) }), $[14] = media, $[15] = mediaDimensions, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(HeaderFlex$2, { children: [
    t6,
    t7
  ] }), $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== description ? (t9 = description && /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text$1, { muted: !0, size: 1, style: {
    whiteSpace: "break-spaces"
  }, children: description }) }), $[20] = description, $[21] = t9) : t9 = $[21];
  let t10;
  return $[22] !== t8 || $[23] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Root$2, { children: [
    t8,
    t9
  ] }), $[22] = t8, $[23] = t9, $[24] = t10) : t10 = $[24], t10;
}
const MUTATION_ATTRIBUTE_FILTER = ["aria-hidden", "disabled", "href"], FOCUSABLE = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
function getFocusableElements(element) {
  return [...element.querySelectorAll(FOCUSABLE)].filter((el) => !el.hasAttribute("disabled") && el.getAttribute("aria-hidden") !== "true");
}
function useRovingFocus(props2) {
  const $ = c(37), {
    direction: t0,
    initialFocus,
    loop: t1,
    navigation: t2,
    pause: t3,
    rootElement
  } = props2, direction = t0 === void 0 ? "horizontal" : t0, loop = t1 === void 0 ? !0 : t1;
  let t4;
  $[0] !== t2 ? (t4 = t2 === void 0 ? ["arrows"] : t2, $[0] = t2, $[1] = t4) : t4 = $[1];
  const navigation = t4, pause = t3 === void 0 ? !1 : t3, [focusedIndex, setFocusedIndex] = useState(-1);
  let t5;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t5 = [], $[2] = t5) : t5 = $[2];
  const [focusableElements, setFocusableElements] = useState(t5), focusableLen = focusableElements.length, lastFocusableIndex = focusableLen - 1, nextKey = direction === "horizontal" ? "ArrowRight" : "ArrowDown", prevKey = direction === "horizontal" ? "ArrowLeft" : "ArrowUp";
  let t6;
  $[3] !== rootElement ? (t6 = () => {
    if (rootElement) {
      const els = getFocusableElements(rootElement);
      setFocusableElements(els);
    }
  }, $[3] = rootElement, $[4] = t6) : t6 = $[4];
  const handleSetElements = t6;
  let t7;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t7 = (index) => {
    setFocusedIndex(index);
  }, $[5] = t7) : t7 = $[5];
  const handleFocus = t7;
  let t8;
  $[6] !== focusableLen || $[7] !== lastFocusableIndex || $[8] !== loop || $[9] !== navigation || $[10] !== nextKey || $[11] !== pause || $[12] !== prevKey ? (t8 = (event) => {
    if (pause)
      return;
    const focusPrev = () => {
      event.preventDefault(), setFocusedIndex((prevIndex) => {
        const next = (prevIndex + lastFocusableIndex) % focusableLen;
        return !loop && next === lastFocusableIndex ? prevIndex : next;
      });
    }, focusNext = () => {
      event.preventDefault(), setFocusedIndex((prevIndex_0) => {
        const next_0 = (prevIndex_0 + 1) % focusableLen;
        return !loop && next_0 === 0 ? prevIndex_0 : next_0;
      });
    };
    event.key === "Tab" && navigation.includes("tab") && (event.shiftKey ? focusPrev() : focusNext()), navigation.includes("arrows") && (event.key === prevKey && focusPrev(), event.key === nextKey && focusNext());
  }, $[6] = focusableLen, $[7] = lastFocusableIndex, $[8] = loop, $[9] = navigation, $[10] = nextKey, $[11] = pause, $[12] = prevKey, $[13] = t8) : t8 = $[13];
  const handleKeyDown = t8;
  let t9;
  $[14] !== handleSetElements ? (t9 = () => {
    handleSetElements();
  }, $[14] = handleSetElements, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== direction || $[17] !== handleSetElements || $[18] !== initialFocus ? (t10 = [handleSetElements, initialFocus, direction], $[16] = direction, $[17] = handleSetElements, $[18] = initialFocus, $[19] = t10) : t10 = $[19], useEffect(t9, t10);
  let t11;
  $[20] !== handleSetElements || $[21] !== rootElement ? (t11 = () => {
    const mo = new MutationObserver(handleSetElements);
    return rootElement && mo.observe(rootElement, {
      childList: !0,
      subtree: !0,
      attributeFilter: MUTATION_ATTRIBUTE_FILTER
    }), () => {
      mo.disconnect();
    };
  }, $[20] = handleSetElements, $[21] = rootElement, $[22] = t11) : t11 = $[22];
  let t12;
  $[23] !== focusableElements || $[24] !== handleSetElements || $[25] !== rootElement ? (t12 = [focusableElements, handleSetElements, rootElement], $[23] = focusableElements, $[24] = handleSetElements, $[25] = rootElement, $[26] = t12) : t12 = $[26], useEffect(t11, t12);
  let t13, t14;
  $[27] !== focusableElements || $[28] !== focusedIndex || $[29] !== initialFocus || $[30] !== lastFocusableIndex ? (t13 = () => {
    focusableElements.forEach((el, index_0) => {
      index_0 === focusedIndex ? (el.setAttribute("tabIndex", "0"), el.setAttribute("aria-selected", "true"), el.focus(), el.onfocus = () => handleFocus(index_0), el.onblur = () => handleFocus(-1)) : (el.setAttribute("tabIndex", "-1"), el.setAttribute("aria-selected", "false"), el.onfocus = () => handleFocus(index_0));
    }), focusedIndex === -1 && focusableElements && focusableElements[initialFocus === "last" ? lastFocusableIndex : 0]?.setAttribute("tabIndex", "0");
  }, t14 = [focusableElements, focusedIndex, handleFocus, initialFocus, lastFocusableIndex], $[27] = focusableElements, $[28] = focusedIndex, $[29] = initialFocus, $[30] = lastFocusableIndex, $[31] = t13, $[32] = t14) : (t13 = $[31], t14 = $[32]), useEffect(t13, t14);
  let t15, t16;
  $[33] !== handleKeyDown || $[34] !== rootElement ? (t15 = () => (rootElement?.addEventListener("keydown", handleKeyDown), () => {
    rootElement?.removeEventListener("keydown", handleKeyDown);
  }), t16 = [handleKeyDown, rootElement], $[33] = handleKeyDown, $[34] = rootElement, $[35] = t15, $[36] = t16) : (t15 = $[35], t16 = $[36]), useEffect(t15, t16);
}
const StyledButton = styled(Button)`
  position: relative;
  // The children in button is rendered inside a span, we need to absolutely position it.
  & > span:nth-child(2) {
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 0;
  }
`, Dot = styled.div({
  width: 4,
  height: 4,
  borderRadius: 3,
  boxShadow: "0 0 0 1px var(--card-bg-color)"
}), StatusButton = forwardRef(function(props2, ref) {
  const $ = c(22);
  let disabledProp, icon, label, restProps, t0, text, tone;
  $[0] !== props2 ? ({
    disabled: disabledProp,
    icon,
    "aria-label": label,
    mode: t0,
    text,
    tone,
    ...restProps
  } = props2, $[0] = props2, $[1] = disabledProp, $[2] = icon, $[3] = label, $[4] = restProps, $[5] = t0, $[6] = text, $[7] = tone) : (disabledProp = $[1], icon = $[2], label = $[3], restProps = $[4], t0 = $[5], text = $[6], tone = $[7]);
  const mode = t0 === void 0 ? "bleed" : t0;
  let t1;
  const t2 = `var(--card-badge-${tone}-dot-color)`;
  let t3;
  $[8] !== t2 ? (t3 = {
    backgroundColor: t2
  }, $[8] = t2, $[9] = t3) : t3 = $[9], t1 = t3;
  const dotStyle = t1, disabled = !!disabledProp;
  let t4;
  $[10] !== dotStyle || $[11] !== tone ? (t4 = tone && /* @__PURE__ */ jsx(Dot, { style: dotStyle }), $[10] = dotStyle, $[11] = tone, $[12] = t4) : t4 = $[12];
  let t5;
  return $[13] !== disabled || $[14] !== icon || $[15] !== label || $[16] !== mode || $[17] !== ref || $[18] !== restProps || $[19] !== t4 || $[20] !== text ? (t5 = /* @__PURE__ */ jsx(StyledButton, { "data-ui": "StatusButton", ...restProps, "aria-label": label, disabled, mode, ref, text, icon, children: t4 }), $[13] = disabled, $[14] = icon, $[15] = label, $[16] = mode, $[17] = ref, $[18] = restProps, $[19] = t4, $[20] = text, $[21] = t5) : t5 = $[21], t5;
}), TooltipOfDisabled = forwardRef(function(t0, ref) {
  const $ = c(13);
  let children, content, disabled, restProps;
  $[0] !== t0 ? ({
    children,
    content,
    disabled,
    ...restProps
  } = t0, $[0] = t0, $[1] = children, $[2] = content, $[3] = disabled, $[4] = restProps) : (children = $[1], content = $[2], disabled = $[3], restProps = $[4]);
  const t1 = disabled || !content;
  let t2;
  $[5] !== children ? (t2 = /* @__PURE__ */ jsx("div", { children }), $[5] = children, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== content || $[8] !== ref || $[9] !== restProps || $[10] !== t1 || $[11] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { ...restProps, content, disabled: t1, ref, children: t2 }), $[7] = content, $[8] = ref, $[9] = restProps, $[10] = t1, $[11] = t2, $[12] = t3) : t3 = $[12], t3;
}), ImperativeToast = forwardRef((_, ref) => {
  const $ = c(2), {
    push
  } = useToast();
  let t0;
  return $[0] !== push ? (t0 = () => ({
    push
  }), $[0] = push, $[1] = t0) : t0 = $[1], useImperativeHandle(ref, t0), null;
});
ImperativeToast.displayName = "ForwardRef(ImperativeToast)";
function useZIndex() {
  return useContext(ZIndexContext);
}
function LegacyLayerProvider(t0) {
  const $ = c(3), {
    children,
    zOffset: zOffsetKey
  } = t0, zOffset = useZIndex()[zOffsetKey];
  let t1;
  return $[0] !== children || $[1] !== zOffset ? (t1 = /* @__PURE__ */ jsx(LayerProvider, { zOffset, children }), $[0] = children, $[1] = zOffset, $[2] = t1) : t1 = $[2], t1;
}
const EMPTY = [];
function WithReferringDocuments(t0) {
  const $ = c(3), {
    children,
    id: id2
  } = t0, t1 = useReferringDocuments(id2, EMPTY);
  let t2;
  return $[0] !== children || $[1] !== t1 ? (t2 = children(t1), $[0] = children, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
}
function ZIndexProvider(t0) {
  const $ = c(2), {
    children
  } = t0;
  let t1;
  return $[0] !== children ? (t1 = /* @__PURE__ */ jsx(ZIndexContext.Provider, { value: zIndexContextDefaults, children }), $[0] = children, $[1] = t1) : t1 = $[1], t1;
}
function getDialogCopy(t) {
  return {
    thread: {
      title: t("delete-thread.title"),
      body: t("delete-thread.body"),
      confirmButtonText: t("delete-thread.confirm")
    },
    comment: {
      title: t("delete-comment.title"),
      body: t("delete-comment.body"),
      confirmButtonText: t("delete-comment.confirm")
    }
  };
}
function CommentDeleteDialog(props2) {
  const $ = c(27), {
    isParent,
    onClose,
    commentId,
    onConfirm,
    loading,
    error
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = getDialogCopy(t), $[0] = t, $[1] = t0) : t0 = $[1];
  const dialogCopy = t0, {
    title,
    body,
    confirmButtonText
  } = dialogCopy[isParent ? "thread" : "comment"];
  let t1;
  $[2] !== commentId || $[3] !== onConfirm ? (t1 = () => {
    onConfirm(commentId);
  }, $[2] = commentId, $[3] = onConfirm, $[4] = t1) : t1 = $[4];
  const handleDelete = t1;
  let t2;
  $[5] !== onClose ? (t2 = {
    onClick: onClose
  }, $[5] = onClose, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== confirmButtonText || $[8] !== handleDelete || $[9] !== loading ? (t3 = {
    loading,
    onClick: handleDelete,
    text: confirmButtonText,
    tone: "critical"
  }, $[7] = confirmButtonText, $[8] = handleDelete, $[9] = loading, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== t2 || $[12] !== t3 ? (t4 = {
    cancelButton: t2,
    confirmButton: t3
  }, $[11] = t2, $[12] = t3, $[13] = t4) : t4 = $[13];
  let t5;
  $[14] !== body ? (t5 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: body }), $[14] = body, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== error || $[17] !== t ? (t6 = error && /* @__PURE__ */ jsx(TextWithTone, { tone: "critical", children: t("delete-dialog.error") }), $[16] = error, $[17] = t, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== t5 || $[20] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t5,
    t6
  ] }), $[19] = t5, $[20] = t6, $[21] = t7) : t7 = $[21];
  let t8;
  return $[22] !== onClose || $[23] !== t4 || $[24] !== t7 || $[25] !== title ? (t8 = /* @__PURE__ */ jsx(Dialog$1, { footer: t4, header: title, id: "delete-comment-dialog", onClose, width: 0, children: t7 }), $[22] = onClose, $[23] = t4, $[24] = t7, $[25] = title, $[26] = t8) : t8 = $[26], t8;
}
const CommentDisabledIcon = forwardRef(function(props2, ref) {
  const $ = c(5);
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M5.92627 14.5381H7.92627V18.5381L11.9263 14.5381H15.9263C17.0308 14.5381 17.9263 13.6427 17.9263 12.5381V6.53809C17.9263 5.43352 17.0308 4.53809 15.9263 4.53809H5.92627C4.8217 4.53809 3.92627 5.43352 3.92627 6.53809V12.5381C3.92627 13.6427 4.8217 14.5381 5.92627 14.5381Z", stroke: "currentColor", strokeWidth: "1.2", strokeLinejoin: "round" }), t1 = /* @__PURE__ */ jsx("path", { d: "M2.77256 2.66835C2.54413 2.51319 2.23317 2.57259 2.07802 2.80103L1.40378 3.7937C1.32927 3.9034 1.30139 4.0382 1.32627 4.16845C1.35115 4.29871 1.42676 4.41374 1.53646 4.48825L19.5861 16.7479C19.8146 16.903 20.1255 16.8436 20.2807 16.6152L20.9549 15.6225C21.0294 15.5128 21.0573 15.378 21.0324 15.2478C21.0076 15.1175 20.9319 15.0025 20.8222 14.928L2.77256 2.66835Z", fill: "currentColor", strokeLinejoin: "round" }), $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]);
  let t2;
  return $[2] !== props2 || $[3] !== ref ? (t2 = /* @__PURE__ */ jsxs("svg", { "data-sanity-icon": "comment-disabled", width: "1em", height: "1em", ref, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1
  ] }), $[2] = props2, $[3] = ref, $[4] = t2) : t2 = $[4], t2;
});
forwardRef(function(props2, ref) {
  const $ = c(4);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M7.5 15.5H9.5V19.5L13.5 15.5H17.5C18.6046 15.5 19.5 14.6046 19.5 13.5V7.5C19.5 6.39543 18.6046 5.5 17.5 5.5H7.5C6.39543 5.5 5.5 6.39543 5.5 7.5V13.5C5.5 14.6046 6.39543 15.5 7.5 15.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.2" }), $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== props2 || $[2] !== ref ? (t1 = /* @__PURE__ */ jsx("svg", { "data-sanity-icon": "comment", width: "1em", height: "1em", ref, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2, children: t0 }), $[1] = props2, $[2] = ref, $[3] = t1) : t1 = $[3], t1;
});
const MentionIcon = forwardRef(function(props2, ref) {
  const $ = c(5);
  let t0, t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M16.6633 18.9383C15.539 19.6562 14.2034 20.0723 12.7705 20.0723C8.77022 20.0723 5.52734 16.8294 5.52734 12.8291C5.52734 8.82881 8.77022 5.58594 12.7705 5.58594C16.7708 5.58594 20.0137 8.82881 20.0137 12.8291C20.0137 13.6623 19.8249 14.7093 19.6141 15.2077C19.5578 15.3408 19.479 15.4845 19.3936 15.6238C19.0955 16.1106 18.5507 16.3721 17.9807 16.4018V16.4018C16.8271 16.462 15.8588 15.5428 15.8588 14.3877V9.27302", stroke: "currentColor", strokeWidth: 1.2, strokeLinejoin: "round" }), t1 = /* @__PURE__ */ jsx("circle", { cx: "12.5732", cy: "12.8291", r: "3.08691", stroke: "currentColor", strokeWidth: 1.2 }), $[0] = t0, $[1] = t1) : (t0 = $[0], t1 = $[1]);
  let t2;
  return $[2] !== props2 || $[3] !== ref ? (t2 = /* @__PURE__ */ jsxs("svg", { "data-sanity-icon": "mention", fill: "none", height: "1em", ref, viewBox: "0 0 25 25", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1
  ] }), $[2] = props2, $[3] = ref, $[4] = t2) : t2 = $[4], t2;
}), ReactionIcon = forwardRef(function(props2, ref) {
  const $ = c(8);
  let t0, t1, t2, t3, t4;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { d: "M10.1044 10.4011L10.1044 10.9972", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "square" }), t1 = /* @__PURE__ */ jsx("path", { d: "M14.2393 10.4011L14.2393 10.9972", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "square" }), t2 = /* @__PURE__ */ jsx("path", { d: "M7.12128 14.1151C7.70803 15.0226 9.66113 16.8377 11.7735 16.8377C13.8859 16.8377 15.6713 15.0226 16.4257 14.1151", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "square" }), t3 = /* @__PURE__ */ jsx("path", { d: "M16.703 6.43905C15.3486 5.36511 13.6357 4.72374 11.773 4.72374C7.38731 4.72374 3.83203 8.27902 3.83203 12.6647C3.83203 17.0503 7.38731 20.6056 11.773 20.6056C16.0995 20.6056 19.618 17.1455 19.712 12.8415", stroke: "currentColor", strokeWidth: 1.2 }), t4 = /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1135 9.03425L19.1135 11.4903L20.3135 11.4903L20.3135 9.03425L22.7693 9.03425L22.7693 7.83425L20.3135 7.83425L20.3135 5.37941L19.1135 5.37941L19.1135 7.83425L16.6584 7.83425L16.6584 9.03425L19.1135 9.03425Z", fill: "currentColor" }), $[0] = t0, $[1] = t1, $[2] = t2, $[3] = t3, $[4] = t4) : (t0 = $[0], t1 = $[1], t2 = $[2], t3 = $[3], t4 = $[4]);
  let t5;
  return $[5] !== props2 || $[6] !== ref ? (t5 = /* @__PURE__ */ jsxs("svg", { "data-sanity-icon": "add-reaction", fill: "none", height: "1em", ref, viewBox: "0 0 25 25", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...props2, children: [
    t0,
    t1,
    t2,
    t3,
    t4
  ] }), $[5] = props2, $[6] = ref, $[7] = t5) : t5 = $[7], t5;
}), SendIcon = forwardRef(function(props2, ref) {
  const $ = c(4);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("path", { clipRule: "evenodd", d: "M21.1602 12.5L7.16016 19.5V14.8765L13.6656 12.4989L7.16016 9.97149L7.16016 5.5L21.1602 12.5Z", stroke: "currentColor", strokeWidth: 1.2, strokeLinejoin: "round" }), $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] !== props2 || $[2] !== ref ? (t1 = /* @__PURE__ */ jsx("svg", { "data-sanity-icon": "send", fill: "none", height: "1em", ref, viewBox: "0 0 25 25", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...props2, children: t0 }), $[1] = props2, $[2] = ref, $[3] = t1) : t1 = $[3], t1;
}), StyledAvatar = styled(Avatar)`
  svg > ellipse {
    stroke: transparent;
  }
`, SYMBOLS = /[^\p{Alpha}\p{White_Space}]/gu, WHITESPACE = new RegExp("\\p{White_Space}+", "u");
function nameToInitials(fullName) {
  const namesArray = fullName.replace(SYMBOLS, "").split(WHITESPACE);
  return namesArray.length === 1 ? `${namesArray[0].charAt(0)}`.toUpperCase() : `${namesArray[0].charAt(0)}${namesArray[namesArray.length - 1].charAt(0)}`;
}
function CommentsAvatar(props2) {
  const $ = c(12);
  let restProps, userProp;
  $[0] !== props2 ? ({
    user: userProp,
    ...restProps
  } = props2, $[0] = props2, $[1] = restProps, $[2] = userProp) : (restProps = $[1], userProp = $[2]);
  const user = userProp;
  let t0;
  const t1 = user?.displayName || "";
  let t2;
  $[3] !== t1 ? (t2 = nameToInitials(t1), $[3] = t1, $[4] = t2) : t2 = $[4], t0 = t2;
  const initials = t0;
  if (!user) {
    let t32;
    return $[5] !== restProps ? (t32 = /* @__PURE__ */ jsx(StyledAvatar, { ...restProps }), $[5] = restProps, $[6] = t32) : t32 = $[6], t32;
  }
  const t3 = user?.imageUrl, t4 = user?.displayName;
  let t5;
  return $[7] !== initials || $[8] !== restProps || $[9] !== t3 || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(StyledAvatar, { initials, src: t3, title: t4, ...restProps }), $[7] = initials, $[8] = restProps, $[9] = t3, $[10] = t4, $[11] = t5) : t5 = $[11], t5;
}
const SpacerAvatar = styled.div((props2) => {
  const theme = getTheme_v2(props2.theme), {
    $size = 1
  } = props2;
  return css`
    min-width: ${theme.avatar.sizes[$size]?.size}px;
  `;
}), mentionObject = defineField({
  name: "mention",
  type: "object",
  fields: [{
    name: "userId",
    type: "string"
  }]
}), blockType = defineField({
  type: "block",
  name: "block",
  of: [mentionObject],
  marks: {
    annotations: []
  },
  styles: [{
    title: "Normal",
    value: "normal"
  }],
  lists: []
}), portableTextType = defineArrayMember({
  type: "array",
  name: "body",
  of: [blockType]
}), schema = Schema.compile({
  name: "comments",
  types: [portableTextType]
}), editorSchemaType = schema.get("body"), Span = styled.span(({
  theme
}) => {
  const {
    regular
  } = theme.sanity.fonts?.text.weights || {}, {
    hovered
  } = theme.sanity.color?.card || {}, {
    bg
  } = theme.sanity.color.selectable?.caution.pressed || {};
  return css`
    font-weight: ${regular};
    color: var(--card-link-fg-color);
    border-radius: 2px;
    background-color: ${hovered.bg};
    padding: 1px;
    box-sizing: border-box;

    &[data-active='true'] {
      background-color: ${bg};
    }
  `;
});
function MentionInlineBlock(props2) {
  const $ = c(15), {
    selected,
    userId
  } = props2, [user, loading] = useUser(userId), currentUser = useCurrentUser();
  if (!user || loading) {
    let t02;
    return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(TextSkeleton, { "data-testid": "comment-mentions-loading-skeleton", style: {
      width: "10ch"
    }, size: 0, muted: !0, radius: 1, animated: !0 }), $[0] = t02) : t02 = $[0], t02;
  }
  let t0;
  $[1] !== user ? (t0 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(CommentsAvatar, { user }) }), $[1] = user, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== user.displayName ? (t1 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: user.displayName }), $[3] = user.displayName, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== t0 || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t0,
    t1
  ] }), $[5] = t0, $[6] = t1, $[7] = t2) : t2 = $[7];
  const t3 = currentUser?.id === userId;
  let t4;
  $[8] !== selected || $[9] !== t3 || $[10] !== user.displayName ? (t4 = /* @__PURE__ */ jsxs(Span, { "data-selected": selected, "data-active": t3, children: [
    "@",
    user.displayName
  ] }), $[8] = selected, $[9] = t3, $[10] = user.displayName, $[11] = t4) : t4 = $[11];
  let t5;
  return $[12] !== t2 || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, content: t2, children: t4 }), $[12] = t2, $[13] = t4, $[14] = t5) : t5 = $[14], t5;
}
const NormalText = styled(Text$1)`
  word-break: break-word;
`;
function NormalBlock(props2) {
  const $ = c(2), {
    children
  } = props2;
  let t0;
  return $[0] !== children ? (t0 = /* @__PURE__ */ jsx(NormalText, { size: 1, children }), $[0] = children, $[1] = t0) : t0 = $[1], t0;
}
const renderBlock = (blockProps) => {
  const {
    children
  } = blockProps;
  return /* @__PURE__ */ jsx(NormalBlock, { children });
}, renderChild = (childProps) => {
  const {
    children,
    value,
    selected
  } = childProps;
  return value._type === "mention" && value.userId ? /* @__PURE__ */ jsx(MentionInlineBlock, { selected, userId: value?.userId }) : children;
}, Z_OFFSET = 9999999;
function CommentInputDiscardDialog(props2) {
  const $ = c(25), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    onClose,
    onConfirm
  } = props2;
  let t0;
  $[0] !== onClose ? (t0 = (e) => {
    e.stopPropagation(), onClose();
  }, $[0] = onClose, $[1] = t0) : t0 = $[1];
  const handleCancelClick = t0;
  let t1;
  $[2] !== onConfirm ? (t1 = (e_0) => {
    e_0.stopPropagation(), onConfirm();
  }, $[2] = onConfirm, $[3] = t1) : t1 = $[3];
  const handleConfirmClick = t1;
  let t2;
  $[4] !== t ? (t2 = t("discard.header"), $[4] = t, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== handleCancelClick ? (t3 = {
    onClick: handleCancelClick
  }, $[6] = handleCancelClick, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t ? (t4 = t("discard.button-confirm"), $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== handleConfirmClick || $[11] !== t4 ? (t5 = {
    onClick: handleConfirmClick,
    text: t4,
    tone: "critical"
  }, $[10] = handleConfirmClick, $[11] = t4, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== t3 || $[14] !== t5 ? (t6 = {
    cancelButton: t3,
    confirmButton: t5
  }, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  $[16] !== t ? (t7 = t("discard.text"), $[16] = t, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t7 }), $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  return $[20] !== onClose || $[21] !== t2 || $[22] !== t6 || $[23] !== t8 ? (t9 = /* @__PURE__ */ jsx(ThemeColorProvider, { tone: "default", children: /* @__PURE__ */ jsx(DialogProvider, { zOffset: Z_OFFSET, children: /* @__PURE__ */ jsx(Dialog$1, { header: t2, id: "discard-comment-dialog", onClose, width: 0, onClickOutside: onClose, footer: t6, children: t8 }) }) }), $[20] = onClose, $[21] = t2, $[22] = t6, $[23] = t8, $[24] = t9) : t9 = $[24], t9;
}
const InnerFlex = styled(Flex)``, SKELETON_INLINE_STYLE$1 = {
  width: "50%"
};
function MentionsMenuItem(props2) {
  const $ = c(23), {
    user,
    onSelect
  } = props2, [loadedUser] = useUser(user.id), {
    t
  } = useTranslation(commentsLocaleNamespace), t0 = user.granted ? void 0 : "inactive";
  let t1;
  $[0] !== loadedUser || $[1] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentsAvatar, { user: loadedUser, status: t0 }), $[0] = loadedUser, $[1] = t0, $[2] = t1) : t1 = $[2];
  const avatar = t1;
  let t2;
  $[3] !== loadedUser ? (t2 = loadedUser ? /* @__PURE__ */ jsx(Text$1, { size: 1, textOverflow: "ellipsis", title: loadedUser.displayName, children: loadedUser.displayName }) : /* @__PURE__ */ jsx(TextSkeleton, { size: 1, style: SKELETON_INLINE_STYLE$1 }), $[3] = loadedUser, $[4] = t2) : t2 = $[4];
  const text = t2;
  let t3;
  $[5] !== onSelect || $[6] !== user.id ? (t3 = () => {
    onSelect(user.id);
  }, $[5] = onSelect, $[6] = user.id, $[7] = t3) : t3 = $[7];
  const handleSelect = t3, t4 = !user.granted;
  let t5;
  $[8] !== text ? (t5 = /* @__PURE__ */ jsx(Box, { children: text }), $[8] = text, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== avatar || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsxs(InnerFlex, { align: "center", gap: 2, flex: 1, children: [
    avatar,
    t5
  ] }), $[10] = avatar, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t || $[14] !== user.granted ? (t7 = !user.granted && /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", children: t("mentions.unauthorized-user") }), $[13] = t, $[14] = user.granted, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t6 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t6,
    t7
  ] }), $[16] = t6, $[17] = t7, $[18] = t8) : t8 = $[18];
  let t9;
  return $[19] !== handleSelect || $[20] !== t4 || $[21] !== t8 ? (t9 = /* @__PURE__ */ jsx(Card, { as: "button", disabled: t4, onClick: handleSelect, padding: 2, radius: 2, children: t8 }), $[19] = handleSelect, $[20] = t4, $[21] = t8, $[22] = t9) : t9 = $[22], t9;
}
const EMPTY_ARRAY$5 = [], Root$1 = styled(Stack)({
  maxWidth: "220px"
  // todo: improve
}), ITEM_HEIGHT = 41, LIST_PADDING = 4, MAX_ITEMS = 7, FlexWrap = styled(Flex)({
  maxHeight: ITEM_HEIGHT * MAX_ITEMS + LIST_PADDING * 2 + ITEM_HEIGHT / 2
}), MentionsMenu = forwardRef(function(props2, ref) {
  const $ = c(24), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    loading,
    onSelect,
    options: t0,
    inputElement
  } = props2;
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? [] : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const options = t1, [searchTerm, setSearchTerm] = useState(""), commandListRef = useRef(null);
  let t2, t3;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t2 = () => ({
    setSearchTerm(term) {
      setSearchTerm(term);
    }
  }), t3 = [], $[2] = t2, $[3] = t3) : (t2 = $[2], t3 = $[3]), useImperativeHandle(ref, t2, t3);
  let t4;
  $[4] !== onSelect ? (t4 = (itemProps) => /* @__PURE__ */ jsx(MentionsMenuItem, { user: itemProps, onSelect }), $[4] = onSelect, $[5] = t4) : t4 = $[5];
  const renderItem2 = t4;
  let t5;
  $[6] !== options ? (t5 = (index) => !options?.[index]?.granted, $[6] = options, $[7] = t5) : t5 = $[7];
  const getItemDisabled = t5;
  let t6;
  bb0: {
    if (!searchTerm) {
      t6 = options || EMPTY_ARRAY$5;
      break bb0;
    }
    let t72;
    if ($[8] !== options || $[9] !== searchTerm) {
      const deburredSearchTerm = deburr(searchTerm).toLocaleLowerCase();
      t72 = options?.map(_temp$2)?.filter((option_0) => option_0?.displayName?.includes(deburredSearchTerm))?.sort((a, b) => {
        const matchA = a.displayName?.startsWith(deburredSearchTerm), matchB = b.displayName?.startsWith(deburredSearchTerm);
        return matchA && !matchB ? -1 : !matchA && matchB ? 1 : 0;
      }), $[8] = options, $[9] = searchTerm, $[10] = t72;
    } else
      t72 = $[10];
    t6 = t72 || EMPTY_ARRAY$5;
  }
  const filteredOptions = t6;
  if (loading) {
    let t72;
    return $[11] === Symbol.for("react.memo_cache_sentinel") ? (t72 = /* @__PURE__ */ jsx(Root$1, { children: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) }), $[11] = t72) : t72 = $[11], t72;
  }
  const _inputElement = inputElement || void 0;
  let t7;
  $[12] !== filteredOptions.length || $[13] !== t ? (t7 = filteredOptions.length === 0 && /* @__PURE__ */ jsx(Box, { padding: 5, children: /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, muted: !0, children: t("mentions.no-users-found") }) }), $[12] = filteredOptions.length, $[13] = t, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== _inputElement || $[16] !== filteredOptions || $[17] !== getItemDisabled || $[18] !== renderItem2 || $[19] !== t ? (t8 = filteredOptions.length > 0 && /* @__PURE__ */ jsx(FlexWrap, { direction: "column", flex: 1, overflow: "hidden", children: /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("mentions.user-list-aria-label"), fixedHeight: !0, getItemDisabled, inputElement: _inputElement, itemHeight: 41, items: filteredOptions, padding: 1, ref: commandListRef, renderItem: renderItem2 }) }), $[15] = _inputElement, $[16] = filteredOptions, $[17] = getItemDisabled, $[18] = renderItem2, $[19] = t, $[20] = t8) : t8 = $[20];
  let t9;
  return $[21] !== t7 || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { direction: "column", height: "fill", "data-testid": "comments-mentions-menu", children: [
    t7,
    t8
  ] }), $[21] = t7, $[22] = t8, $[23] = t9) : t9 = $[23], t9;
});
function _temp$2(option) {
  return {
    ...option,
    displayName: deburr(option.displayName || "").toLocaleLowerCase()
  };
}
function useCommentInput() {
  const ctx = useContext(CommentInputContext);
  if (!ctx)
    throw new Error("useCommentInputContext must be used within a CommentInputProvider");
  return ctx;
}
const EVENT_LISTENER_OPTIONS = {
  passive: !0
};
function useCursorElement(opts) {
  const $ = c(8), {
    disabled,
    rootElement
  } = opts, [cursorRect, setCursorRect] = useState(null);
  let t0;
  bb0: {
    if (!cursorRect) {
      t0 = null;
      break bb0;
    }
    let t12;
    $[0] !== cursorRect ? (t12 = {
      getBoundingClientRect: () => cursorRect
    }, $[0] = cursorRect, $[1] = t12) : t12 = $[1], t0 = t12;
  }
  const cursorElement = t0;
  let t1;
  $[2] !== disabled || $[3] !== rootElement ? (t1 = () => {
    if (disabled) {
      setCursorRect(null);
      return;
    }
    const sel = window.getSelection();
    if (!sel || !sel.isCollapsed || sel.rangeCount === 0)
      return;
    const range2 = sel.getRangeAt(0);
    if (!rootElement?.contains(range2.commonAncestorContainer)) {
      setCursorRect(null);
      return;
    }
    const rect = range2?.getBoundingClientRect();
    rect && setCursorRect(rect);
  }, $[2] = disabled, $[3] = rootElement, $[4] = t1) : t1 = $[4];
  const handleSelectionChange = t1;
  let t2, t3;
  return $[5] !== handleSelectionChange ? (t2 = () => (document.addEventListener("selectionchange", handleSelectionChange, EVENT_LISTENER_OPTIONS), () => {
    document.removeEventListener("selectionchange", handleSelectionChange);
  }), t3 = [handleSelectionChange], $[5] = handleSelectionChange, $[6] = t2, $[7] = t3) : (t2 = $[6], t3 = $[7]), useEffect(t2, t3), cursorElement;
}
const POPOVER_FALLBACK_PLACEMENTS$1 = ["bottom", "top"], INLINE_STYLE = {
  outline: "none"
}, EMPTY_ARRAY$4 = [], PlaceholderWrapper = styled.span((props2) => {
  const {
    color
  } = getTheme_v2(props2.theme);
  return css`
    color: ${color.input.default.enabled.placeholder};
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    display: block;
  `;
}), StyledPopover$1 = styled(Popover)(({
  theme
}) => {
  const {
    space,
    radius
  } = theme.sanity;
  return css`
    &[data-placement='bottom'] {
      transform: translateY(${space[1]}px);
    }

    &[data-placement='top'] {
      transform: translateY(-${space[1]}px);
    }

    [data-ui='Popover__wrapper'] {
      border-radius: ${radius[3]}px;
      display: flex;
      flex-direction: column;
      overflow: clip;
      overflow: hidden;
      position: relative;
      width: 300px; // todo: improve
    }
  `;
});
function Editable(props2) {
  const $ = c(54), {
    t
  } = useTranslation(commentsLocaleNamespace), {
    focusLock,
    onFocus,
    onBlur,
    onKeyDown,
    onSubmit,
    placeholder: t0,
    renderBlock: renderBlock2
  } = props2;
  let t1;
  $[0] !== t || $[1] !== t0 ? (t1 = t0 === void 0 ? t("compose.create-comment-placeholder") : t0, $[0] = t, $[1] = t0, $[2] = t1) : t1 = $[2];
  const placeholder = t1, popoverRef = useRef(null), [rootElement, setRootElement] = useState(null), [inputElement, setInputElement] = useState(null), mentionsMenuRef = useRef(null), selection = usePortableTextEditorSelection(), {
    canSubmit,
    closeMentions,
    insertMention,
    mentionOptions,
    mentionsMenuOpen,
    mentionsSearchTerm,
    onBeforeInput,
    value
  } = useCommentInput(), t2 = !mentionsMenuOpen;
  let t3;
  $[3] !== rootElement || $[4] !== t2 ? (t3 = {
    disabled: t2,
    rootElement
  }, $[3] = rootElement, $[4] = t2, $[5] = t3) : t3 = $[5];
  const cursorElement = useCursorElement(t3);
  let t4;
  $[6] !== placeholder ? (t4 = () => /* @__PURE__ */ jsx(PlaceholderWrapper, { children: placeholder }), $[6] = placeholder, $[7] = t4) : t4 = $[7];
  const renderPlaceholder = t4;
  let t5;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => [popoverRef.current], $[8] = t5) : t5 = $[8], useClickOutsideEvent(mentionsMenuOpen && closeMentions, t5);
  let t6;
  $[9] !== canSubmit || $[10] !== closeMentions || $[11] !== mentionsMenuOpen || $[12] !== onKeyDown || $[13] !== onSubmit ? (t6 = (event) => {
    bb14: switch (event.key) {
      case "Enter": {
        if (event.shiftKey)
          break bb14;
        if (mentionsMenuOpen) {
          event.preventDefault(), event.stopPropagation(), closeMentions();
          break bb14;
        }
        onSubmit && canSubmit && (event.preventDefault(), event.stopPropagation(), onSubmit());
        break bb14;
      }
      case "Escape":
      case "ArrowLeft":
      case "ArrowRight": {
        mentionsMenuOpen && (event.preventDefault(), event.stopPropagation(), closeMentions());
        break bb14;
      }
    }
    onKeyDown && onKeyDown(event);
  }, $[9] = canSubmit, $[10] = closeMentions, $[11] = mentionsMenuOpen, $[12] = onKeyDown, $[13] = onSubmit, $[14] = t6) : t6 = $[14];
  const handleKeyDown = t6;
  let t7;
  bb0: {
    if (selection) {
      t7 = void 0;
      break bb0;
    }
    const t82 = value || EMPTY_ARRAY$4;
    let t102, t92;
    if ($[15] !== t82) {
      const lastBlock = t82.slice(-1)[0], lastChild = isPortableTextTextBlock(lastBlock) ? lastBlock.children.slice(-1)[0] : void 0;
      if (!lastChild) {
        t7 = void 0;
        break bb0;
      }
      t92 = [{
        _key: lastBlock._key
      }, "children", {
        _key: lastChild._key
      }], t102 = isPortableTextSpan(lastChild) ? lastChild.text.length : 0, $[15] = t82, $[16] = t102, $[17] = t92, $[18] = t7;
    } else
      t102 = $[16], t92 = $[17], t7 = $[18];
    let t112;
    $[19] !== t102 || $[20] !== t92 ? (t112 = {
      path: t92,
      offset: t102
    }, $[19] = t102, $[20] = t92, $[21] = t112) : t112 = $[21];
    const point = t112;
    let t122;
    $[22] !== point ? (t122 = {
      focus: point,
      anchor: point
    }, $[22] = point, $[23] = t122) : t122 = $[23], t7 = t122;
  }
  const initialSelectionAtEndOfContent = t7;
  let t8, t9;
  $[24] !== mentionsSearchTerm ? (t8 = () => {
    mentionsMenuRef.current?.setSearchTerm(mentionsSearchTerm);
  }, t9 = [mentionsSearchTerm], $[24] = mentionsSearchTerm, $[25] = t8, $[26] = t9) : (t8 = $[25], t9 = $[26]), useEffect(t8, t9);
  let t10, t11;
  $[27] !== closeMentions || $[28] !== mentionsMenuOpen || $[29] !== selection ? (t10 = () => {
    mentionsMenuOpen && selection && !isEqual$2(selection.anchor, selection.focus) && closeMentions();
  }, t11 = [mentionsMenuOpen, closeMentions, selection], $[27] = closeMentions, $[28] = mentionsMenuOpen, $[29] = selection, $[30] = t10, $[31] = t11) : (t10 = $[30], t11 = $[31]), useEffect(t10, t11);
  const t12 = mentionOptions.data || EMPTY_ARRAY$4;
  let t13;
  $[32] !== inputElement || $[33] !== insertMention || $[34] !== mentionOptions.loading || $[35] !== t12 ? (t13 = /* @__PURE__ */ jsx(MentionsMenu, { inputElement, loading: mentionOptions.loading, onSelect: insertMention, options: t12, ref: mentionsMenuRef }), $[32] = inputElement, $[33] = insertMention, $[34] = mentionOptions.loading, $[35] = t12, $[36] = t13) : t13 = $[36];
  const popoverContent = t13, t14 = !mentionsMenuOpen;
  let t15;
  $[37] !== cursorElement || $[38] !== mentionsMenuOpen || $[39] !== popoverContent || $[40] !== t14 ? (t15 = /* @__PURE__ */ jsx(StyledPopover$1, { arrow: !1, constrainSize: !0, content: popoverContent, disabled: t14, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS$1, open: mentionsMenuOpen, placement: "bottom", ref: popoverRef, referenceElement: cursorElement }), $[37] = cursorElement, $[38] = mentionsMenuOpen, $[39] = popoverContent, $[40] = t14, $[41] = t15) : t15 = $[41];
  const t16 = focusLock ? 0 : void 0;
  let t17;
  $[42] !== handleKeyDown || $[43] !== initialSelectionAtEndOfContent || $[44] !== onBeforeInput || $[45] !== onBlur || $[46] !== onFocus || $[47] !== renderBlock2 || $[48] !== renderPlaceholder || $[49] !== t16 ? (t17 = /* @__PURE__ */ jsx(PortableTextEditable, { "data-testid": "comment-input-editable", "data-ui": "EditableElement", onBeforeInput, onBlur, onFocus, onKeyDown: handleKeyDown, ref: setInputElement, renderBlock: renderBlock2, renderChild, renderPlaceholder, selection: initialSelectionAtEndOfContent, style: INLINE_STYLE, tabIndex: t16 }), $[42] = handleKeyDown, $[43] = initialSelectionAtEndOfContent, $[44] = onBeforeInput, $[45] = onBlur, $[46] = onFocus, $[47] = renderBlock2, $[48] = renderPlaceholder, $[49] = t16, $[50] = t17) : t17 = $[50];
  let t18;
  return $[51] !== t15 || $[52] !== t17 ? (t18 = /* @__PURE__ */ jsxs("div", { ref: setRootElement, children: [
    t15,
    t17
  ] }), $[51] = t15, $[52] = t17, $[53] = t18) : t18 = $[53], t18;
}
Editable.displayName = "Editable";
const EditableWrap = styled(Box)`
  max-height: 20vh;
  overflow-y: auto;
`, ButtonDivider = styled(MenuDivider)({
  height: 20,
  width: 1
});
function focusRingBorderStyle(border) {
  return `inset 0 0 0 ${border.width}px ${border.color}`;
}
const RootCard = styled(Card)(({
  theme
}) => {
  const {
    color,
    input,
    radius
  } = getTheme_v2(theme), radii = radius[2];
  return css`
    border-radius: ${radii}px;
    box-shadow: var(--input-box-shadow);

    --input-box-shadow: ${focusRingBorderStyle({
    color: color.input.default.enabled.border,
    width: input.border.width
  })};

    &:not([data-expand-on-focus='false'], :focus-within) {
      background: transparent;
      box-shadow: unset;
    }

    &[data-focused='true']:focus-within {
      ${EditableWrap} {
        min-height: 1em;
      }

      /* box-shadow: inset 0 0 0 1px var(--card-focus-ring-color); */
      --input-box-shadow: ${focusRingBorderStyle({
    color: "var(--card-focus-ring-color)",
    width: input.border.width
  })};
    }

    &:focus-within {
      ${EditableWrap} {
        min-height: 1em;
      }
    }

    &[data-expand-on-focus='false'] {
      ${EditableWrap} {
        min-height: 1em;
      }
    }

    &[data-expand-on-focus='true'] {
      [data-ui='CommentInputActions']:not([hidden]) {
        display: none;
      }

      &:focus-within {
        [data-ui='CommentInputActions'] {
          display: flex;
        }
      }
    }
    &:hover {
      --input-box-shadow: ${focusRingBorderStyle({
    color: color.input.default.hovered.border,
    width: input.border.width
  })};
    }
  `;
}), AvatarContainer = styled.div((props2) => `
    min-height: ${getTheme_v2(props2.theme).avatar.sizes[1]?.size}px;
    display: flex;
    align-items: center;
  `);
function CommentInputInner(props2) {
  const $ = c(41), {
    avatarSize: t0,
    currentUser,
    focusLock,
    onBlur,
    onFocus,
    onKeyDown,
    onSubmit,
    placeholder,
    renderBlock: renderBlock2,
    withAvatar
  } = props2, avatarSize = t0 === void 0 ? 1 : t0, [user] = useUser(currentUser.id), {
    canSubmit,
    expandOnFocus,
    focused,
    hasChanges,
    insertAtChar,
    openMentions,
    readOnly,
    mentionOptions
  } = useCommentInput(), {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t1;
  $[0] !== avatarSize || $[1] !== user || $[2] !== withAvatar ? (t1 = withAvatar ? /* @__PURE__ */ jsx(AvatarContainer, { children: /* @__PURE__ */ jsx(CommentsAvatar, { user, size: avatarSize }) }) : null, $[0] = avatarSize, $[1] = user, $[2] = withAvatar, $[3] = t1) : t1 = $[3];
  const avatar = t1;
  let t2;
  $[4] !== insertAtChar || $[5] !== openMentions ? (t2 = (e) => {
    e.stopPropagation(), insertAtChar(), openMentions();
  }, $[4] = insertAtChar, $[5] = openMentions, $[6] = t2) : t2 = $[6];
  const handleMentionButtonClicked = t2, t3 = expandOnFocus && !canSubmit ? "true" : "false", t4 = focused ? "true" : "false", t5 = readOnly ? "transparent" : "default";
  let t6;
  $[7] !== focusLock || $[8] !== onBlur || $[9] !== onFocus || $[10] !== onKeyDown || $[11] !== onSubmit || $[12] !== placeholder || $[13] !== renderBlock2 ? (t6 = /* @__PURE__ */ jsx(EditableWrap, { "data-ui": "CommentInputEditableWrap", paddingX: 1, paddingY: 2, sizing: "border", children: /* @__PURE__ */ jsx(Editable, { focusLock, onBlur, onFocus, onKeyDown, onSubmit, placeholder, renderBlock: renderBlock2 }) }), $[7] = focusLock, $[8] = onBlur, $[9] = onFocus, $[10] = onKeyDown, $[11] = onSubmit, $[12] = placeholder, $[13] = renderBlock2, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== handleMentionButtonClicked || $[16] !== mentionOptions.disabled || $[17] !== readOnly || $[18] !== t ? (t7 = !mentionOptions.disabled && /* @__PURE__ */ jsx(Button, { "aria-label": t("compose.mention-user-aria-label"), "data-testid": "comment-input-mention-button", disabled: readOnly, icon: MentionIcon, mode: "bleed", type: "button", onClick: handleMentionButtonClicked, tooltipProps: {
    content: t("compose.mention-user-tooltip")
  } }), $[15] = handleMentionButtonClicked, $[16] = mentionOptions.disabled, $[17] = readOnly, $[18] = t, $[19] = t7) : t7 = $[19];
  let t8;
  $[20] !== canSubmit || $[21] !== hasChanges || $[22] !== mentionOptions.disabled || $[23] !== onSubmit || $[24] !== readOnly || $[25] !== t ? (t8 = onSubmit && /* @__PURE__ */ jsxs(Fragment, { children: [
    !mentionOptions.disabled && /* @__PURE__ */ jsx(ButtonDivider, {}),
    /* @__PURE__ */ jsx(Button, { "aria-label": t("compose.send-comment-aria-label"), "data-testid": "comment-input-send-button", disabled: !canSubmit || !hasChanges || readOnly, icon: SendIcon, mode: hasChanges && canSubmit ? "default" : "bleed", onClick: onSubmit, tone: hasChanges && canSubmit ? "primary" : "default", tooltipProps: {
      content: t("compose.send-comment-tooltip")
    } })
  ] }), $[20] = canSubmit, $[21] = hasChanges, $[22] = mentionOptions.disabled, $[23] = onSubmit, $[24] = readOnly, $[25] = t, $[26] = t8) : t8 = $[26];
  let t9;
  $[27] !== t7 || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsx(Flex, { align: "center", "data-ui": "CommentInputActions", gap: 1, justify: "flex-end", padding: 1, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    t7,
    t8
  ] }) }), $[27] = t7, $[28] = t8, $[29] = t9) : t9 = $[29];
  let t10;
  $[30] !== t6 || $[31] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { children: [
    t6,
    t9
  ] }), $[30] = t6, $[31] = t9, $[32] = t10) : t10 = $[32];
  let t11;
  $[33] !== t10 || $[34] !== t3 || $[35] !== t4 || $[36] !== t5 ? (t11 = /* @__PURE__ */ jsx(RootCard, { id: "comment-input-root", "data-expand-on-focus": t3, "data-focused": t4, flex: 1, sizing: "border", tone: t5, children: t10 }), $[33] = t10, $[34] = t3, $[35] = t4, $[36] = t5, $[37] = t11) : t11 = $[37];
  let t12;
  return $[38] !== avatar || $[39] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 2, children: [
    avatar,
    t11
  ] }), $[38] = avatar, $[39] = t11, $[40] = t12) : t12 = $[40], t12;
}
function CommentInputProvider(props2) {
  const $ = c(42), {
    children,
    expandOnFocus: t0,
    focused,
    focusOnMount: t1,
    mentionOptions,
    onMentionMenuOpenChange,
    value,
    readOnly
  } = props2, expandOnFocus = t0 === void 0 ? !1 : t0, focusOnMount = t1 === void 0 ? !1 : t1, editor2 = usePortableTextEditor(), [mentionsMenuOpen, setMentionsMenuOpen] = useState(!1), [mentionsSearchTerm, setMentionsSearchTerm] = useState(""), [selectionAtMentionInsert, setSelectionAtMentionInsert] = useState(null);
  let t2, t3;
  $[0] !== value ? (t3 = hasCommentMessageValue(value), $[0] = value, $[1] = t3) : t3 = $[1], t2 = t3;
  const canSubmit = t2, hasChanges = useCommentHasChanged(value);
  let t4;
  $[2] !== editor2 || $[3] !== readOnly ? (t4 = () => {
    readOnly || PortableTextEditor.focus(editor2);
  }, $[2] = editor2, $[3] = readOnly, $[4] = t4) : t4 = $[4];
  const focusEditor = t4;
  let t5;
  $[5] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setMentionsMenuOpen(!1), setMentionsSearchTerm(""), setSelectionAtMentionInsert(null);
  }, $[5] = t5) : t5 = $[5];
  const closeMentions = t5;
  let t6;
  $[6] !== editor2 || $[7] !== mentionOptions?.disabled ? (t6 = () => {
    mentionOptions?.disabled || (setMentionsMenuOpen(!0), setMentionsSearchTerm(""), setMentionsMenuOpen(!0), setSelectionAtMentionInsert(PortableTextEditor.getSelection(editor2)));
  }, $[6] = editor2, $[7] = mentionOptions?.disabled, $[8] = t6) : t6 = $[8];
  const openMentions = t6;
  let t7;
  $[9] !== editor2 || $[10] !== mentionOptions?.disabled || $[11] !== mentionsSearchTerm || $[12] !== openMentions ? (t7 = (event) => {
    if (mentionOptions?.disabled)
      return;
    const selection = PortableTextEditor.getSelection(editor2), cursorOffset = selection ? selection.focus.offset : 0, focusChild = PortableTextEditor.focusChild(editor2), focusSpan = isPortableTextSpan(focusChild) && focusChild || void 0, isInsertText = event.inputType === "insertText", isDeleteText = event.inputType === "deleteContentBackward", isInsertingAtChar = isInsertText && event.data === "@", lastIndexOfAt = focusSpan?.text.slice(0, Math.max(0, cursorOffset)).lastIndexOf("@") || 0, isWhitespaceCharBeforeCursorPosition = focusSpan?.text.slice(cursorOffset - 1, cursorOffset) === " ", filterStartsWithSpaceChar = isInsertText && event.data === " " && !mentionsSearchTerm;
    if (isInsertingAtChar && (cursorOffset < 1 || isWhitespaceCharBeforeCursorPosition)) {
      openMentions();
      return;
    }
    if (filterStartsWithSpaceChar || isDeleteText && (focusSpan?.text.length === 1 || lastIndexOfAt === (focusSpan?.text.length || 0) - 1)) {
      closeMentions();
      return;
    }
    if (isPortableTextSpan(focusChild)) {
      let term = focusChild.text.slice(lastIndexOfAt + 1, cursorOffset);
      isInsertText && (term = term + event.data), isDeleteText && (term = term.slice(0, Math.max(0, term.length - 1))), setMentionsSearchTerm(term);
    }
  }, $[9] = editor2, $[10] = mentionOptions?.disabled, $[11] = mentionsSearchTerm, $[12] = openMentions, $[13] = t7) : t7 = $[13];
  const onBeforeInput = t7;
  let t8;
  $[14] !== editor2 ? (t8 = () => {
    setMentionsMenuOpen(!0), PortableTextEditor.focus(editor2), PortableTextEditor.insertChild(editor2, editor2.schemaTypes.span, {
      text: "@"
    }), setSelectionAtMentionInsert(PortableTextEditor.getSelection(editor2));
  }, $[14] = editor2, $[15] = t8) : t8 = $[15];
  const insertAtChar = t8;
  let t9;
  $[16] !== mentionsMenuOpen || $[17] !== onMentionMenuOpenChange ? (t9 = () => onMentionMenuOpenChange?.(mentionsMenuOpen), $[16] = mentionsMenuOpen, $[17] = onMentionMenuOpenChange, $[18] = t9) : t9 = $[18], useDidUpdate(mentionsMenuOpen, t9);
  let t10;
  $[19] !== editor2 || $[20] !== selectionAtMentionInsert ? (t10 = (userId) => {
    const mentionSchemaType = editor2.schemaTypes.inlineObjects.find(_temp$1), [span, spanPath] = selectionAtMentionInsert && PortableTextEditor.findByPath(editor2, selectionAtMentionInsert.focus.path) || [];
    if (span && isPortableTextSpan(span) && spanPath && mentionSchemaType) {
      PortableTextEditor.focus(editor2);
      const offset = PortableTextEditor.getSelection(editor2)?.focus.offset;
      typeof offset < "u" && (PortableTextEditor.delete(editor2, {
        anchor: {
          path: spanPath,
          offset: span.text.lastIndexOf("@")
        },
        focus: {
          path: spanPath,
          offset
        }
      }, {
        mode: "selected"
      }), PortableTextEditor.insertChild(editor2, mentionSchemaType, {
        userId
      }), PortableTextEditor.insertChild(editor2, editor2.schemaTypes.span, {
        text: " "
      }));
    }
  }, $[19] = editor2, $[20] = selectionAtMentionInsert, $[21] = t10) : t10 = $[21];
  const insertMention = t10;
  let t11;
  const t12 = !!readOnly;
  let t13;
  $[22] !== canSubmit || $[23] !== editor2 || $[24] !== expandOnFocus || $[25] !== focusEditor || $[26] !== focusOnMount || $[27] !== focused || $[28] !== hasChanges || $[29] !== insertAtChar || $[30] !== insertMention || $[31] !== mentionOptions || $[32] !== mentionsMenuOpen || $[33] !== mentionsSearchTerm || $[34] !== onBeforeInput || $[35] !== openMentions || $[36] !== t12 || $[37] !== value ? (t13 = {
    canSubmit,
    closeMentions,
    editor: editor2,
    expandOnFocus,
    focused,
    focusEditor,
    focusOnMount,
    hasChanges,
    insertAtChar,
    insertMention,
    mentionOptions,
    mentionsMenuOpen,
    mentionsSearchTerm,
    onBeforeInput,
    openMentions,
    readOnly: t12,
    value
  }, $[22] = canSubmit, $[23] = editor2, $[24] = expandOnFocus, $[25] = focusEditor, $[26] = focusOnMount, $[27] = focused, $[28] = hasChanges, $[29] = insertAtChar, $[30] = insertMention, $[31] = mentionOptions, $[32] = mentionsMenuOpen, $[33] = mentionsSearchTerm, $[34] = onBeforeInput, $[35] = openMentions, $[36] = t12, $[37] = value, $[38] = t13) : t13 = $[38], t11 = t13;
  const ctxValue = t11;
  let t14;
  return $[39] !== children || $[40] !== ctxValue ? (t14 = /* @__PURE__ */ jsx(CommentInputContext.Provider, { value: ctxValue, children }), $[39] = children, $[40] = ctxValue, $[41] = t14) : t14 = $[41], t14;
}
function _temp$1(t) {
  return t.name === "mention";
}
const EMPTY_ARRAY$3 = [], SCROLL_INTO_VIEW_OPTIONS = {
  behavior: "smooth",
  block: "center",
  inline: "center"
}, CommentInput = forwardRef(function(props2, ref) {
  const $ = c(58), {
    avatarSize,
    currentUser,
    expandOnFocus,
    focusLock: t0,
    focusOnMount,
    mentionOptions,
    onBlur,
    onChange,
    onDiscardCancel,
    onDiscardConfirm,
    onFocus,
    onKeyDown,
    onMentionMenuOpenChange,
    onSubmit,
    placeholder,
    readOnly,
    renderBlock: t1,
    value: t2,
    withAvatar: t3
  } = props2, focusLock = t0 === void 0 ? !1 : t0, renderBlock$12 = t1 === void 0 ? renderBlock : t1, value = t2 === void 0 ? EMPTY_ARRAY$3 : t2, withAvatar = t3 === void 0 ? !0 : t3, [focused, setFocused] = useState(!1), editorRef = useRef(null), editorContainerRef = useRef(null), [showDiscardDialog, setShowDiscardDialog] = useState(!1), preDivRef = useRef(null), postDivRef = useRef(null), innerRef = useRef(null);
  let t4;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t4 = keyGenerator$1(), $[0] = t4) : t4 = $[0];
  const [editorInstanceKey, setEditorInstanceKey] = useState(t4);
  let t5;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    requestAnimationFrame(() => {
      editorRef.current && PortableTextEditor.focus(editorRef.current);
    });
  }, $[1] = t5) : t5 = $[1];
  const requestFocus = t5;
  let t6;
  $[2] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    setEditorInstanceKey(keyGenerator$1());
  }, $[2] = t6) : t6 = $[2];
  const resetEditorInstance = t6;
  let t7;
  $[3] !== focusOnMount || $[4] !== onChange ? (t7 = (change) => {
    if (change.type === "ready" && focusOnMount && requestFocus(), change.type === "focus" && setFocused(!0), change.type === "blur" && setFocused(!1), change.type === "patch" && editorRef.current) {
      const editorStateValue = PortableTextEditor.getValue(editorRef.current);
      onChange(editorStateValue || EMPTY_ARRAY$3);
    }
  }, $[3] = focusOnMount, $[4] = onChange, $[5] = t7) : t7 = $[5];
  const handleChange = t7;
  let t8;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t8 = () => {
    editorContainerRef.current?.scrollIntoView(SCROLL_INTO_VIEW_OPTIONS);
  }, $[6] = t8) : t8 = $[6];
  const scrollToEditor = t8;
  let t9;
  $[7] !== onSubmit ? (t9 = () => {
    onSubmit?.(), resetEditorInstance(), requestFocus(), scrollToEditor();
  }, $[7] = onSubmit, $[8] = t9) : t9 = $[8];
  const handleSubmit = t9;
  let t10;
  $[9] !== onDiscardConfirm ? (t10 = () => {
    onDiscardConfirm(), resetEditorInstance();
  }, $[9] = onDiscardConfirm, $[10] = t10) : t10 = $[10];
  const handleDiscardConfirm = t10;
  let t11, t12;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    open: () => {
      setShowDiscardDialog(!0);
    },
    close: () => {
      setShowDiscardDialog(!1), requestFocus();
    }
  }, $[11] = t12) : t12 = $[11], t11 = t12;
  const discardDialogController = t11;
  let t13, t14;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t13 = () => ({
    focus: requestFocus,
    blur() {
      editorRef.current && PortableTextEditor.blur(editorRef.current);
    },
    scrollTo: scrollToEditor,
    reset: resetEditorInstance,
    discardDialogController
  }), t14 = [discardDialogController, requestFocus, resetEditorInstance, scrollToEditor], $[12] = t13, $[13] = t14) : (t13 = $[12], t14 = $[13]), useImperativeHandle(ref, t13, t14);
  let t15;
  $[14] !== focusLock ? (t15 = (event) => {
    if (!focusLock)
      return;
    const target = event.target, innerEl = innerRef.current;
    if (innerEl && target === preDivRef.current) {
      focusLastDescendant(innerEl);
      return;
    }
    innerEl && target === postDivRef.current && focusFirstDescendant(innerEl);
  }, $[14] = focusLock, $[15] = t15) : t15 = $[15];
  const handleFocus = t15;
  let t16;
  $[16] !== handleDiscardConfirm || $[17] !== onDiscardCancel || $[18] !== showDiscardDialog ? (t16 = showDiscardDialog && onDiscardCancel && /* @__PURE__ */ jsx(CommentInputDiscardDialog, { onClose: onDiscardCancel, onConfirm: handleDiscardConfirm }), $[16] = handleDiscardConfirm, $[17] = onDiscardCancel, $[18] = showDiscardDialog, $[19] = t16) : t16 = $[19];
  const t17 = value || EMPTY_ARRAY$3;
  let t18;
  $[20] !== focusLock ? (t18 = focusLock && /* @__PURE__ */ jsx("div", { ref: preDivRef, tabIndex: 0 }), $[20] = focusLock, $[21] = t18) : t18 = $[21];
  const t19 = onSubmit && handleSubmit;
  let t20;
  $[22] !== avatarSize || $[23] !== currentUser || $[24] !== focusLock || $[25] !== onBlur || $[26] !== onFocus || $[27] !== onKeyDown || $[28] !== placeholder || $[29] !== renderBlock$12 || $[30] !== t19 || $[31] !== withAvatar ? (t20 = /* @__PURE__ */ jsx(Stack, { ref: innerRef, children: /* @__PURE__ */ jsx(CommentInputInner, { avatarSize, currentUser, focusLock, onBlur, onFocus, onKeyDown, onSubmit: t19, placeholder, renderBlock: renderBlock$12, withAvatar }) }), $[22] = avatarSize, $[23] = currentUser, $[24] = focusLock, $[25] = onBlur, $[26] = onFocus, $[27] = onKeyDown, $[28] = placeholder, $[29] = renderBlock$12, $[30] = t19, $[31] = withAvatar, $[32] = t20) : t20 = $[32];
  let t21;
  $[33] !== focusLock ? (t21 = focusLock && /* @__PURE__ */ jsx("div", { ref: postDivRef, tabIndex: 0 }), $[33] = focusLock, $[34] = t21) : t21 = $[34];
  let t22;
  $[35] !== expandOnFocus || $[36] !== focusOnMount || $[37] !== focused || $[38] !== mentionOptions || $[39] !== onMentionMenuOpenChange || $[40] !== readOnly || $[41] !== t18 || $[42] !== t20 || $[43] !== t21 || $[44] !== value ? (t22 = /* @__PURE__ */ jsxs(CommentInputProvider, { expandOnFocus, focused, focusOnMount, mentionOptions, onMentionMenuOpenChange, readOnly, value, children: [
    t18,
    t20,
    t21
  ] }), $[35] = expandOnFocus, $[36] = focusOnMount, $[37] = focused, $[38] = mentionOptions, $[39] = onMentionMenuOpenChange, $[40] = readOnly, $[41] = t18, $[42] = t20, $[43] = t21, $[44] = value, $[45] = t22) : t22 = $[45];
  let t23;
  $[46] !== editorInstanceKey || $[47] !== handleChange || $[48] !== readOnly || $[49] !== t17 || $[50] !== t22 ? (t23 = /* @__PURE__ */ jsx(PortableTextEditor, { onChange: handleChange, readOnly, ref: editorRef, schemaType: editorSchemaType, value: t17, children: t22 }, editorInstanceKey), $[46] = editorInstanceKey, $[47] = handleChange, $[48] = readOnly, $[49] = t17, $[50] = t22, $[51] = t23) : t23 = $[51];
  let t24;
  $[52] !== handleFocus || $[53] !== t23 ? (t24 = /* @__PURE__ */ jsx(Stack, { ref: editorContainerRef, "data-testid": "comment-input", onFocus: handleFocus, children: t23 }), $[52] = handleFocus, $[53] = t23, $[54] = t24) : t24 = $[54];
  let t25;
  return $[55] !== t16 || $[56] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t16,
    t24
  ] }), $[55] = t16, $[56] = t24, $[57] = t25) : t25 = $[57], t25;
}), HighlightSpan = styled.span(({
  theme
}) => {
  const isDark = theme.sanity.v2?.color._dark, addedBg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 800 : 100].hex, addedBorder = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 700 : 300].hex, addedHoverBg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 700 : 200].hex, addedHoverBorder = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 600 : 400].hex, addedNestedBg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 700 : 200].hex, addedNesterBorder = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 600 : 400].hex;
  return css`
    box-sizing: border-box;
    transition:
      background-color 100ms ease,
      border-color 100ms ease;

    // Make sure that child elements appropriately blend with the
    // background of the highlight span
    * {
      mix-blend-mode: ${isDark ? "screen" : "multiply"};
    }

    &[data-inline-comment-state='added'][data-inline-comment-nested='false'] {
      background-color: ${addedBg};
      border-bottom: 2px solid ${addedBorder};
    }

    &[data-inline-comment-state='added'][data-inline-comment-nested='true'] {
      background-color: ${addedNestedBg};
      border-bottom: 2px solid ${addedNesterBorder};
    }

    &[data-inline-comment-state='added'][data-inline-comment-nested='false'][data-hovered='true'] {
      background-color: ${addedHoverBg};
      border-bottom: 2px solid ${addedHoverBorder};
    }

    &[data-inline-comment-state='authoring'] {
      background-color: ${addedBg};
      border-bottom: 2px solid ${addedBorder};
    }
  `;
}), CommentInlineHighlightSpan = forwardRef(function(props2, ref) {
  const $ = c(14);
  let children, isAdded, isAuthoring, isHovered, isNested, rest;
  $[0] !== props2 ? ({
    children,
    isAdded,
    isAuthoring,
    isHovered,
    isNested,
    ...rest
  } = props2, $[0] = props2, $[1] = children, $[2] = isAdded, $[3] = isAuthoring, $[4] = isHovered, $[5] = isNested, $[6] = rest) : (children = $[1], isAdded = $[2], isAuthoring = $[3], isHovered = $[4], isNested = $[5], rest = $[6]);
  const state = isAdded ? "added" : isAuthoring ? "authoring" : void 0, t0 = isHovered ? "true" : "false", t1 = isNested ? "true" : "false";
  let t2;
  return $[7] !== children || $[8] !== ref || $[9] !== rest || $[10] !== state || $[11] !== t0 || $[12] !== t1 ? (t2 = /* @__PURE__ */ jsx(HighlightSpan, { ...rest, "data-hovered": t0, "data-inline-comment-nested": t1, "data-inline-comment-state": state, ref, children }), $[7] = children, $[8] = ref, $[9] = rest, $[10] = state, $[11] = t0, $[12] = t1, $[13] = t2) : t2 = $[13], t2;
}), PortableTextWrap = styled(Stack)(() => css`
    & > [data-ui='Text']:not(:first-child) {
      margin-top: 1em; // todo: improve
    }

    & > [data-ui='Text']:has(> span:empty) {
      display: none;
    }
  `), EMPTY_ARRAY$2 = [];
function NormalBlockTransformed(props2) {
  const $ = c(4);
  let t0, t1;
  $[0] !== props2.children ? (t1 = transformChildren(props2.children), $[0] = props2.children, $[1] = t1) : t1 = $[1], t0 = t1;
  const children = t0;
  let t2;
  return $[2] !== children ? (t2 = /* @__PURE__ */ jsx(NormalBlock, { children }), $[2] = children, $[3] = t2) : t2 = $[3], t2;
}
const components = {
  // Since we do not offer any formatting options, we can just use the normal block for all of these.
  block: {
    normal: NormalBlockTransformed,
    h1: NormalBlockTransformed,
    h2: NormalBlockTransformed,
    h3: NormalBlockTransformed,
    h4: NormalBlockTransformed,
    h5: NormalBlockTransformed,
    h6: NormalBlockTransformed,
    blockquote: NormalBlockTransformed,
    code: NormalBlockTransformed
  },
  list: {
    bullet: Fragment$1,
    number: Fragment$1,
    checkmarks: Fragment$1
  },
  listItem: {
    bullet: NormalBlockTransformed,
    number: NormalBlockTransformed,
    checkmarks: NormalBlockTransformed
  },
  // Since we do not offer any formatting options, we can just use the normal block for all of these.
  marks: {
    strong: Fragment$1,
    em: Fragment$1,
    code: Fragment$1,
    underline: Fragment$1,
    strikeThrough: Fragment$1,
    link: Fragment$1
  },
  types: {
    mention: (props2) => /* @__PURE__ */ jsx(MentionInlineBlock, { userId: props2?.value?.userId, selected: !1 })
  }
};
function CommentMessageSerializer(props2) {
  const $ = c(2), {
    blocks
  } = props2, t0 = blocks || EMPTY_ARRAY$2;
  let t1;
  return $[0] !== t0 ? (t1 = /* @__PURE__ */ jsx(PortableTextWrap, { children: /* @__PURE__ */ jsx(PortableText$1, { value: t0, components }) }), $[0] = t0, $[1] = t1) : t1 = $[1], t1;
}
const FLEX_GAP = 3, EmojiText = styled(Text$1)`
  font-family:
    'Twemoji Mozilla', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji',
    'EmojiOne Color', 'Android Emoji', sans-serif;
`, GRID_COLUMNS = 6;
function CommentReactionsMenu(props2) {
  const $ = c(24), {
    options,
    onSelect
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
  const [focusableElements, setFocusableElements] = useState(t0), [rootElement, setRootElement] = useState(null), [focusedIndex, setFocusedIndex] = useState(0);
  let t1;
  $[1] !== focusableElements.length ? (t1 = (event) => {
    const focusableLen = focusableElements.length;
    event.key === "ArrowRight" && setFocusedIndex((prev) => (prev + 1) % focusableLen), event.key === "ArrowLeft" && setFocusedIndex((prev_0) => (prev_0 - 1 + focusableLen) % focusableLen);
  }, $[1] = focusableElements.length, $[2] = t1) : t1 = $[2];
  const handleRootKeyDown = t1;
  let t2;
  $[3] !== focusableElements || $[4] !== onSelect || $[5] !== options ? (t2 = (event_0) => {
    const index = focusableElements.indexOf(event_0.currentTarget);
    setFocusedIndex(index), onSelect(options[index]);
  }, $[3] = focusableElements, $[4] = onSelect, $[5] = options, $[6] = t2) : t2 = $[6];
  const handleOptionClick = t2;
  let t3, t4;
  $[7] !== rootElement ? (t3 = () => {
    if (rootElement) {
      const buttons = rootElement.querySelectorAll("button");
      setFocusableElements(Array.from(buttons));
    }
  }, t4 = [rootElement], $[7] = rootElement, $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5, t6;
  $[10] !== focusableElements || $[11] !== focusedIndex ? (t5 = () => {
    focusableElements.length > 0 && focusableElements[focusedIndex].focus();
  }, t6 = [focusableElements, focusedIndex], $[10] = focusableElements, $[11] = focusedIndex, $[12] = t5, $[13] = t6) : (t5 = $[12], t6 = $[13]), useEffect(t5, t6);
  let t7;
  if ($[14] !== handleOptionClick || $[15] !== options || $[16] !== t) {
    let t82;
    $[18] !== handleOptionClick || $[19] !== t ? (t82 = (o) => {
      const emoji = COMMENT_REACTION_EMOJIS[o.shortName];
      return /* @__PURE__ */ jsx(Button$1, { "aria-label": t("reactions.react-with-aria-label", {
        reactionName: o.title || o.shortName
      }), mode: "bleed", onClick: handleOptionClick, padding: 2, role: "menuitem", tabIndex: -1, children: /* @__PURE__ */ jsx(EmojiText, { align: "center", size: 2, children: emoji }) }, o.shortName);
    }, $[18] = handleOptionClick, $[19] = t, $[20] = t82) : t82 = $[20], t7 = options.map(t82), $[14] = handleOptionClick, $[15] = options, $[16] = t, $[17] = t7;
  } else
    t7 = $[17];
  let t8;
  return $[21] !== handleRootKeyDown || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Grid, { columns: GRID_COLUMNS, gap: 1, onKeyDown: handleRootKeyDown, ref: setRootElement, role: "menu", children: t7 }), $[21] = handleRootKeyDown, $[22] = t7, $[23] = t8) : t8 = $[23], t8;
}
const POPOVER_FALLBACK_PLACEMENTS = ["top", "bottom"];
function CommentReactionsMenuButton(props2) {
  const $ = c(35), {
    onMenuClose,
    onMenuOpen,
    onSelect,
    options,
    readOnly,
    renderMenuButton: renderMenuButton2,
    mode
  } = props2, [buttonElement, setButtonElement] = useState(null), popoverRef = useRef(null), [open, setOpen] = useState(!1), {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== onMenuClose || $[1] !== onMenuOpen || $[2] !== open ? (t0 = () => {
    const next = !open;
    setOpen(next), next ? onMenuOpen?.() : onMenuClose?.();
  }, $[0] = onMenuClose, $[1] = onMenuOpen, $[2] = open, $[3] = t0) : t0 = $[3];
  const handleClick = t0;
  let t1;
  $[4] !== onMenuClose || $[5] !== open ? (t1 = () => {
    open && (setOpen(!1), onMenuClose?.());
  }, $[4] = onMenuClose, $[5] = open, $[6] = t1) : t1 = $[6];
  const handleClose = t1;
  let t2;
  $[7] !== buttonElement || $[8] !== handleClose || $[9] !== open ? (t2 = () => {
    open && (handleClose(), buttonElement?.focus());
  }, $[7] = buttonElement, $[8] = handleClose, $[9] = open, $[10] = t2) : t2 = $[10];
  const handleCloseAndFocus = t2;
  let t3;
  $[11] !== handleCloseAndFocus ? (t3 = (event) => {
    const {
      key,
      shiftKey
    } = event;
    (shiftKey && key === "Tab" || key === "Escape" || key === "Tab") && handleCloseAndFocus();
  }, $[11] = handleCloseAndFocus, $[12] = t3) : t3 = $[12];
  const handleKeyDown = t3;
  let t4;
  $[13] !== buttonElement ? (t4 = () => [popoverRef.current, buttonElement], $[13] = buttonElement, $[14] = t4) : t4 = $[14], useClickOutsideEvent(handleClose, t4);
  let t5;
  $[15] !== handleClose || $[16] !== onSelect ? (t5 = (option) => {
    onSelect(option), handleClose();
  }, $[15] = handleClose, $[16] = onSelect, $[17] = t5) : t5 = $[17];
  const handleSelect = t5;
  let t6, t7;
  if ($[18] !== handleClick || $[19] !== mode || $[20] !== open || $[21] !== readOnly || $[22] !== renderMenuButton2 || $[23] !== t) {
    const btn = renderMenuButton2({
      open,
      tooltipContent: t(mode === "upsell" ? "list-item.context-menu-add-reaction-upsell" : "list-item.context-menu-add-reaction"),
      t
    });
    t7 = cloneElement(btn, {
      "aria-expanded": open,
      "aria-haspopup": "true",
      disabled: readOnly || mode === "upsell",
      id: "reactions-menu-button",
      onClick: handleClick,
      ref: setButtonElement
    }), $[18] = handleClick, $[19] = mode, $[20] = open, $[21] = readOnly, $[22] = renderMenuButton2, $[23] = t, $[24] = t7;
  } else
    t7 = $[24];
  t6 = t7;
  const button = t6;
  let t8;
  $[25] !== handleSelect || $[26] !== options ? (t8 = /* @__PURE__ */ jsx(CommentReactionsMenu, { onSelect: handleSelect, options }), $[25] = handleSelect, $[26] = options, $[27] = t8) : t8 = $[27];
  let t9;
  $[28] !== handleKeyDown || $[29] !== t8 ? (t9 = /* @__PURE__ */ jsx(Card, { "aria-labelledby": "reactions-menu-button", onKeyDown: handleKeyDown, padding: 1, radius: 3, tone: "default", children: t8 }), $[28] = handleKeyDown, $[29] = t8, $[30] = t9) : t9 = $[30];
  const popoverContent = t9;
  let t10;
  return $[31] !== button || $[32] !== open || $[33] !== popoverContent ? (t10 = /* @__PURE__ */ jsx(Popover, { constrainSize: !0, content: popoverContent, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS, open, placement: "bottom", portal: !0, ref: popoverRef, tone: "default", children: button }), $[31] = button, $[32] = open, $[33] = popoverContent, $[34] = t10) : t10 = $[34], t10;
}
const TEXT_SIZE = 1, ContentStack = styled(Stack)`
  max-width: 180px;
`, TextGroup = styled.div`
  display: inline-block;
`, InlineText = styled(Text$1).attrs({
  size: TEXT_SIZE
})`
  display: inline-block !important;

  & > span {
    white-space: break-spaces;
  }
`, TextBox = styled(Box)`
  line-height: 1;
  text-align: center;
`, LEADING_NON_WHITESPACE_RE = /^\S+/;
function UserDisplayName(props2) {
  const $ = c(7), {
    currentUserId,
    isFirst,
    userId
  } = props2, [user] = useUser(userId), {
    t
  } = useTranslation(commentsLocaleNamespace);
  if (currentUserId === userId) {
    const context = isFirst ? "leading" : void 0, t02 = user?.displayName;
    let t1;
    return $[0] !== context || $[1] !== t || $[2] !== t02 ? (t1 = t("reactions.user-list.you", {
      context,
      replace: {
        name: t02
      }
    }), $[0] = context, $[1] = t, $[2] = t02, $[3] = t1) : t1 = $[3], t1;
  }
  let t0;
  return $[4] !== t || $[5] !== user?.displayName ? (t0 = user?.displayName || t("reactions.user-list.unknown-user-fallback-name"), $[4] = t, $[5] = user?.displayName, $[6] = t0) : t0 = $[6], t0;
}
function CommentReactionsUsersTooltip(props2) {
  const $ = c(10);
  let children, restProps;
  $[0] !== props2 ? ({
    children,
    ...restProps
  } = props2, $[0] = props2, $[1] = children, $[2] = restProps) : (children = $[1], restProps = $[2]);
  let t0;
  $[3] !== restProps ? (t0 = /* @__PURE__ */ jsx(CommentReactionsUsersTooltipContent, { ...restProps }), $[3] = restProps, $[4] = t0) : t0 = $[4];
  let t1;
  $[5] !== children ? (t1 = /* @__PURE__ */ jsx("div", { children }), $[5] = children, $[6] = t1) : t1 = $[6];
  let t2;
  return $[7] !== t0 || $[8] !== t1 ? (t2 = /* @__PURE__ */ jsx(Tooltip, { content: t0, placement: "bottom", portal: !0, children: t1 }), $[7] = t0, $[8] = t1, $[9] = t2) : t2 = $[9], t2;
}
function FormattedUserList(t0) {
  const $ = c(5), {
    currentUserId,
    userIds
  } = t0;
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    style: "long",
    type: "conjunction"
  }, $[0] = t1) : t1 = $[0];
  const listFormat = useListFormat(t1);
  if (userIds.length === 0)
    return null;
  let elements;
  if ($[1] !== currentUserId || $[2] !== listFormat || $[3] !== userIds) {
    const parts = listFormat.formatToParts(userIds);
    elements = [];
    for (let i = 0; i < parts.length; i++) {
      const item = parts[i];
      if (item.type === "literal") {
        elements.push(/* @__PURE__ */ jsx(InlineText, { children: item.value }, `literal-${i}`));
        continue;
      }
      const nextItem = parts[i + 1];
      if (nextItem && nextItem.type === "literal" && LEADING_NON_WHITESPACE_RE.test(nextItem.value)) {
        const [t2] = nextItem.value.match(LEADING_NON_WHITESPACE_RE) || [], nonWhitespace = t2 === void 0 ? "" : t2;
        elements.push(/* @__PURE__ */ jsxs(TextGroup, { children: [
          /* @__PURE__ */ jsx(InlineText, { weight: "medium", children: /* @__PURE__ */ jsx(UserDisplayName, { currentUserId, isFirst: i === 0, userId: item.value }) }),
          /* @__PURE__ */ jsx(InlineText, { children: nonWhitespace })
        ] }, item.value)), nextItem.value = nextItem.value.slice(nonWhitespace.length);
        continue;
      }
      elements.push(/* @__PURE__ */ jsx(InlineText, { weight: "medium", children: /* @__PURE__ */ jsx(UserDisplayName, { currentUserId, isFirst: i === 0, userId: item.value }) }, item.value));
    }
    $[1] = currentUserId, $[2] = listFormat, $[3] = userIds, $[4] = elements;
  } else
    elements = $[4];
  return elements;
}
function CommentReactionsUsersTooltipContent(props2) {
  const $ = c(19), {
    currentUser,
    reactionName,
    userIds
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== currentUser || $[1] !== userIds ? (t0 = () => currentUser ? /* @__PURE__ */ jsx(FormattedUserList, { currentUserId: currentUser.id, userIds }) : null, $[0] = currentUser, $[1] = userIds, $[2] = t0) : t0 = $[2];
  const UserList = t0, t1 = COMMENT_REACTION_EMOJIS[reactionName];
  let t2;
  $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(Flex, { justify: "center", paddingBottom: 2, paddingTop: 1, children: /* @__PURE__ */ jsx(EmojiText, { size: 4, children: t1 }) }), $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== reactionName ? (t3 = {
    reactionName
  }, $[5] = reactionName, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== reactionName ? (t4 = () => /* @__PURE__ */ jsx(InlineText, { muted: !0, children: reactionName }), $[7] = reactionName, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== UserList || $[10] !== t4 ? (t5 = {
    UserList,
    ReactionName: t4,
    Text: _temp
  }, $[9] = UserList, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  $[12] !== t || $[13] !== t3 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(TextBox, { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "reactions.users-reacted-with-reaction", values: t3, components: t5 }) }), $[12] = t, $[13] = t3, $[14] = t5, $[15] = t6) : t6 = $[15];
  let t7;
  return $[16] !== t2 || $[17] !== t6 ? (t7 = /* @__PURE__ */ jsxs(ContentStack, { padding: 1, children: [
    t2,
    t6
  ] }), $[16] = t2, $[17] = t6, $[18] = t7) : t7 = $[18], t7;
}
function _temp(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(InlineText, { muted: !0, children }),
    " ",
    /* @__PURE__ */ jsx("wbr", {}),
    " "
  ] });
}
const TransparentCard = styled(Card)`
  background: none;
`;
function groupReactionsByName(reactions) {
  const grouped = reactions.reduce((acc, reaction) => {
    const {
      shortName
    } = reaction;
    return acc[shortName] || (acc[shortName] = []), acc[shortName].push(reaction), acc;
  }, {});
  return Object.entries(grouped).sort(([nameA], [nameB]) => {
    const indexA = reactions.findIndex((r) => r.shortName === nameA), indexB = reactions.findIndex((r) => r.shortName === nameB);
    return indexA - indexB;
  });
}
const renderMenuButton$1 = ({
  open,
  tooltipContent
}) => /* @__PURE__ */ jsx(Button$1, { fontSize: 1, mode: "ghost", padding: 0, radius: "full", selected: open, children: /* @__PURE__ */ jsx(Flex, { paddingX: 3, paddingY: 2, children: /* @__PURE__ */ jsx(Tooltip, { animate: !0, content: tooltipContent, disabled: open, children: /* @__PURE__ */ jsx(Text$1, { size: 1, children: /* @__PURE__ */ jsx(ReactionIcon, {}) }) }) }) }), CommentReactionsBar = memo(function(props2) {
  const {
    currentUser,
    onSelect,
    reactions,
    readOnly,
    mode
  } = props2, handleSelect = useCallback((name) => {
    const option = COMMENT_REACTION_OPTIONS.find((o) => o.shortName === name);
    option && onSelect(option);
  }, [onSelect]), currentUserReactionNames = useMemo(() => reactions.filter((r) => r.userId === currentUser?.id).map((r_0) => r_0.shortName), [currentUser?.id, reactions]), groupedReactions = useMemo(() => groupReactionsByName(reactions).filter(([name_0]) => COMMENT_REACTION_EMOJIS[name_0]), [reactions]), [sortedGroupedReactions, setSortedGroupedReactions] = useState(() => ({
    // An array of the initial order of the reactions. This is used to sort the reactions.
    // E.g. [':+1:', ':heart:']
    sortOrder: Object.keys(Object.fromEntries(groupedReactions)),
    // We cache the groupedReactions to know when we should update the sortedReactions, ensuring we don't run into an infinite render loop.
    groupedReactions: [],
    sortedReactions: []
  }));
  let {
    sortedReactions
  } = sortedGroupedReactions;
  if (sortedGroupedReactions.groupedReactions !== groupedReactions) {
    const {
      sortOrder
    } = sortedGroupedReactions;
    sortedReactions = groupedReactions.sort(([nameA], [nameB]) => {
      const indexA = sortOrder.indexOf(nameA), indexB = sortOrder.indexOf(nameB);
      return indexA === -1 ? 1 : indexB === -1 ? -1 : indexA - indexB;
    }), setSortedGroupedReactions({
      groupedReactions,
      sortOrder: sortedReactions.map(([name_1]) => name_1),
      sortedReactions
    });
  }
  return /* @__PURE__ */ jsx(Flex, { align: "center", gap: 1, wrap: "wrap", children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    sortedReactions.map(([name_2, reactionsList]) => {
      const hasReacted = currentUserReactionNames.includes(name_2), userIds = reactionsList.map((r_1) => r_1.userId), emoji = COMMENT_REACTION_EMOJIS[name_2];
      return /* @__PURE__ */ jsx(CommentReactionsUsersTooltip, { currentUser, reactionName: name_2, userIds, children: /* @__PURE__ */ jsx(TransparentCard, { tone: "default", children: /* @__PURE__ */ jsx(
        Button$1,
        {
          disabled: readOnly || mode === "upsell",
          mode: "ghost",
          onClick: () => handleSelect(name_2),
          padding: 2,
          radius: "full",
          selected: hasReacted,
          tone: hasReacted ? "primary" : "default",
          children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
            /* @__PURE__ */ jsx(EmojiText, { size: 1, children: emoji }),
            /* @__PURE__ */ jsx(Text$1, { size: 0, weight: hasReacted ? "semibold" : "medium", children: reactionsList?.length })
          ] })
        }
      ) }) }, name_2);
    }),
    /* @__PURE__ */ jsx(TransparentCard, { tone: "default", children: /* @__PURE__ */ jsx(
      CommentReactionsMenuButton,
      {
        mode,
        onSelect: (o_0) => handleSelect(o_0.shortName),
        options: COMMENT_REACTION_OPTIONS,
        readOnly,
        renderMenuButton: renderMenuButton$1
      }
    ) })
  ] }) });
});
CommentReactionsBar.displayName = "Memo(CommentReactionsBar)";
const renderMenuButton = ({
  open,
  tooltipContent,
  t
}) => /* @__PURE__ */ jsx(Button, { "aria-label": t("list-item.context-menu-add-reaction-aria-label"), icon: ReactionIcon, mode: "bleed", selected: open, tooltipProps: {
  content: tooltipContent
} }), POPOVER_PROPS = {
  placement: "bottom-end"
}, FloatingCard = styled(Card)`
  &:empty {
    display: none;
  }
`;
function CommentsListItemContextMenu(props2) {
  const $ = c(29), {
    canDelete,
    canEdit,
    isParent,
    mode,
    onCopyLink,
    onDeleteStart,
    onEditStart,
    onMenuClose,
    onMenuOpen,
    onReactionSelect,
    onStatusChange,
    readOnly,
    status
  } = props2, showMenuButton = !!(onCopyLink || onDeleteStart || onEditStart), {
    t
  } = useTranslation(commentsLocaleNamespace), hasContextMenuOptions = !!(canDelete || canEdit || onCopyLink);
  let t0;
  $[0] !== mode || $[1] !== onMenuClose || $[2] !== onMenuOpen || $[3] !== onReactionSelect || $[4] !== readOnly ? (t0 = onReactionSelect && /* @__PURE__ */ jsx(CommentReactionsMenuButton, { mode, onMenuClose, onMenuOpen, onSelect: onReactionSelect, options: COMMENT_REACTION_OPTIONS, readOnly, renderMenuButton }), $[0] = mode, $[1] = onMenuClose, $[2] = onMenuOpen, $[3] = onReactionSelect, $[4] = readOnly, $[5] = t0) : t0 = $[5];
  let t1;
  $[6] !== isParent || $[7] !== onStatusChange || $[8] !== readOnly || $[9] !== status || $[10] !== t ? (t1 = isParent && onStatusChange && /* @__PURE__ */ jsx(Button, { "aria-label": t(status === "open" ? "list-item.resolved-tooltip-aria-label" : "list-item.re-open-resolved-aria-label"), "data-testid": "comments-list-item-status-button", disabled: readOnly, icon: status === "open" ? CheckmarkCircleIcon : UndoIcon, mode: "bleed", onClick: onStatusChange, tooltipProps: {
    content: t(status === "open" ? "list-item.resolved-tooltip-content" : "list-item.re-open-resolved")
  } }), $[6] = isParent, $[7] = onStatusChange, $[8] = readOnly, $[9] = status, $[10] = t, $[11] = t1) : t1 = $[11];
  let t2;
  $[12] !== canDelete || $[13] !== canEdit || $[14] !== hasContextMenuOptions || $[15] !== mode || $[16] !== onCopyLink || $[17] !== onDeleteStart || $[18] !== onEditStart || $[19] !== onMenuClose || $[20] !== onMenuOpen || $[21] !== readOnly || $[22] !== showMenuButton || $[23] !== t ? (t2 = hasContextMenuOptions && /* @__PURE__ */ jsx(MenuButton$1, { id: "comment-actions-menu", button: /* @__PURE__ */ jsx(ContextMenuButton, { "aria-label": t("list-item.open-menu-aria-label"), disabled: readOnly, hidden: !showMenuButton }), onOpen: onMenuOpen, onClose: onMenuClose, menu: /* @__PURE__ */ jsxs(Menu, { children: [
    /* @__PURE__ */ jsx(MenuItem$1, { hidden: !canEdit, icon: EditIcon, onClick: onEditStart, text: t("list-item.edit-comment"), tooltipProps: mode === "upsell" ? {
      content: t("list-item.edit-comment-upsell")
    } : void 0, disabled: mode === "upsell" }),
    /* @__PURE__ */ jsx(MenuItem$1, { hidden: !canDelete, icon: TrashIcon, onClick: onDeleteStart, text: t("list-item.delete-comment"), tone: "critical" }),
    onCopyLink && /* @__PURE__ */ jsx(MenuDivider, { hidden: !canDelete && !canEdit }),
    /* @__PURE__ */ jsx(MenuItem$1, { hidden: !onCopyLink, icon: LinkIcon, onClick: onCopyLink, text: t("list-item.copy-link") })
  ] }), popover: POPOVER_PROPS }), $[12] = canDelete, $[13] = canEdit, $[14] = hasContextMenuOptions, $[15] = mode, $[16] = onCopyLink, $[17] = onDeleteStart, $[18] = onEditStart, $[19] = onMenuClose, $[20] = onMenuOpen, $[21] = readOnly, $[22] = showMenuButton, $[23] = t, $[24] = t2) : t2 = $[24];
  let t3;
  return $[25] !== t0 || $[26] !== t1 || $[27] !== t2 ? (t3 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsxs(FloatingCard, { display: "flex", shadow: 2, padding: 1, radius: 2, sizing: "border", children: [
    t0,
    t1,
    t2
  ] }) }) }), $[25] = t0, $[26] = t1, $[27] = t2, $[28] = t3) : t3 = $[28], t3;
}
function truncate(str, length = 250) {
  return str.length <= length ? str : `${str.slice(0, length)}...`;
}
const InlineBox = styled(Box).attrs({
  marginLeft: 1,
  marginRight: 2
})`
  &:not([data-hidden]) {
    display: inline;
  }
`, BlockQuoteStack = styled(Stack)(({
  theme,
  $hasReferencedValue
}) => {
  const isDark = theme.sanity.v2?.color._dark, hue = $hasReferencedValue ? COMMENTS_HIGHLIGHT_HUE_KEY : "gray", borderColor = isDark ? hues[hue][700].hex : hues[hue][300].hex;
  return css`
    border-left: 2px solid ${borderColor};
    word-break: break-word;
  `;
});
function CommentsListItemReferencedValue(props2) {
  const $ = c(13), {
    hasReferencedValue,
    value
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = t("list-item.missing-referenced-value-tooltip-content"), $[0] = t, $[1] = t0) : t0 = $[1];
  const tooltipText = t0;
  let t1;
  bb0: {
    if (Array.isArray(value) && value?.filter(isPortableTextTextBlock).length > 0) {
      let t22;
      if ($[2] !== value) {
        const text = value?.map(toPlainText).join(" ");
        t22 = truncate(text), $[2] = value, $[3] = t22;
      } else
        t22 = $[3];
      t1 = t22;
      break bb0;
    }
    t1 = null;
  }
  const resolvedValue = t1;
  if (!resolvedValue)
    return null;
  const t2 = !!hasReferencedValue;
  let t3;
  $[4] !== hasReferencedValue || $[5] !== tooltipText ? (t3 = !hasReferencedValue && /* @__PURE__ */ jsx(Tooltip, { content: tooltipText, children: /* @__PURE__ */ jsx(InlineBox, { children: /* @__PURE__ */ jsx(LinkRemovedIcon, {}) }) }), $[4] = hasReferencedValue, $[5] = tooltipText, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== resolvedValue || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Flex, { align: "flex-start", children: /* @__PURE__ */ jsxs(Text$1, { size: 1, muted: !0, children: [
    t3,
    resolvedValue
  ] }) }), $[7] = resolvedValue, $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== t2 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(BlockQuoteStack, { $hasReferencedValue: t2, "data-testid": "comments-list-item-referenced-value", flex: 1, forwardedAs: "blockquote", padding: 1, paddingLeft: 2, sizing: "border", children: t4 }), $[10] = t2, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
const stopPropagation = (e) => e.stopPropagation(), ContextMenuBox = styled(Box)``, SKELETON_INLINE_STYLE = {
  width: "50%"
}, EMPTY_ARRAY$1 = [], TimeText = styled(Text$1)(({
  theme
}) => {
  const isDark = theme.sanity.color.dark, fg = hues.gray[isDark ? 200 : 800].hex;
  return css`
    min-width: max-content;
    --card-fg-color: ${fg};
    color: var(--card-fg-color);
  `;
}), HeaderFlex$1 = styled(Flex)((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    min-height: ${theme.avatar.sizes[props2.$size]?.size}px;
  `;
}), IntentText = styled(Text$1)(({
  theme
}) => {
  const isDark = theme.sanity.color.dark, fg = hues.gray[isDark ? 200 : 800].hex;
  return css`
    --card-fg-color: ${fg};
    color: var(--card-fg-color);
  `;
}), InnerStack = styled(Stack)`
  transition: opacity 200ms ease;

  &[data-muted='true'] {
    transition: unset;
    opacity: 0.5;
  }
`, ErrorFlex = styled(Flex)((props2) => {
  const theme = getTheme_v2(props2.theme);
  return css`
    min-height: ${theme.avatar.sizes[props2.$size]?.size}px;
  `;
}), RetryCardButton = styled(Card)`
  // Add not on hover
  &:not(:hover) {
    background-color: transparent;
  }
`, RootStack = styled(Stack)(({
  theme
}) => {
  const {
    space
  } = theme.sanity;
  return css`
    position: relative;

    // Only show the floating layer on hover when hover is supported.
    // Else, the layer is always visible.
    @media (hover: hover) {
      ${ContextMenuBox} {
        opacity: 0;
        position: absolute;
        right: 0;
        top: 0;
        transform: translate(${space[1]}px, -${space[1]}px);
      }

      ${ContextMenuBox} {
        &:focus-within {
          opacity: 1;
        }
      }

      &:hover {
        ${ContextMenuBox} {
          opacity: 1;
        }
      }
    }

    &[data-menu-open='true'] {
      ${ContextMenuBox} {
        opacity: 1;
      }
    }
  `;
}), RELATIVE_TIME_OPTIONS = {
  useTemporalPhrase: !0
};
function CommentsListItemLayout(props2) {
  const {
    avatarSize = 1,
    canDelete,
    canEdit,
    comment,
    currentUser,
    hasError,
    hasReferencedValue,
    intent,
    isParent,
    isRetrying,
    mentionOptions,
    mode,
    onCopyLink,
    onCreateRetry,
    onDelete,
    onEdit,
    onInputKeyDown,
    onReactionSelect,
    onStatusChange,
    readOnly,
    withAvatar = !0
  } = props2, {
    _createdAt,
    authorId,
    message,
    _id,
    lastEditedAt
  } = comment, [user] = useUser(authorId), {
    t
  } = useTranslation(commentsLocaleNamespace), [value, setValue] = useState(message), [isEditing, setIsEditing] = useState(!1), rootElementRef = useRef(null), startMessage = useRef(message), [menuOpen, setMenuOpen] = useState(!1), commentInputRef = useRef(null), hasChanges = useCommentHasChanged(value), hasValue2 = useMemo(() => hasCommentMessageValue(value), [value]), reactions = useMemo(() => (comment?.reactions?.filter((r) => r?._optimisticState !== "removed") || EMPTY_ARRAY$1).filter((r_0) => "userId" in r_0 && "shortName" in r_0), [comment?.reactions]), hasReactions = !!reactions?.length, createdDate = _createdAt ? new Date(_createdAt) : /* @__PURE__ */ new Date(), editedDate = lastEditedAt ? new Date(lastEditedAt) : null, createdTimeAgo = useRelativeTime(createdDate, RELATIVE_TIME_OPTIONS), dateTimeFormat = useDateTimeFormat({
    dateStyle: "full",
    timeStyle: "medium"
  }), formattedCreatedAt = dateTimeFormat.format(createdDate), formattedLastEditAt = editedDate ? dateTimeFormat.format(editedDate) : null, displayError = hasError || isRetrying;
  useEffect(() => {
    isEditing || (startMessage.current = message, setValue(message));
  }, [isEditing, message]);
  const handleMenuOpen = useCallback(() => setMenuOpen(!0), []), handleMenuClose = useCallback(() => setMenuOpen(!1), []), handleCopyLink = useCallback(() => onCopyLink?.(_id), [_id, onCopyLink]), handleCreateRetry = useCallback((e) => {
    e.stopPropagation(), onCreateRetry?.(_id);
  }, [_id, onCreateRetry]), handleDelete = useCallback(() => onDelete(_id), [_id, onDelete]), cancelEdit = useCallback(() => {
    setIsEditing(!1), setValue(startMessage.current);
  }, []), startDiscard = useCallback(() => {
    if (!hasValue2 || !hasChanges) {
      cancelEdit();
      return;
    }
    commentInputRef.current?.discardDialogController.open();
  }, [cancelEdit, hasChanges, hasValue2]), handleInputKeyDown = useCallback((event) => {
    event.isDefaultPrevented() || (event.key === "Escape" && (event.preventDefault(), event.stopPropagation(), startDiscard()), onInputKeyDown && onInputKeyDown(event));
  }, [onInputKeyDown, startDiscard]), cancelDiscard = useCallback(() => {
    commentInputRef.current?.discardDialogController.close();
  }, []), confirmDiscard = useCallback(() => {
    commentInputRef.current?.discardDialogController.close(), cancelEdit();
  }, [cancelEdit]), handleReactionSelect = useCallback((reaction) => {
    onReactionSelect?.(_id, reaction);
  }, [_id, onReactionSelect]), handleEditSubmit = useCallback(() => {
    onEdit(_id, {
      message: value
    }), setIsEditing(!1);
  }, [_id, onEdit, value]), handleOpenStatusChange = useCallback(() => {
    onStatusChange?.(_id, comment.status === "open" ? "resolved" : "open");
  }, [_id, comment.status, onStatusChange]), toggleEdit = useCallback(() => {
    setIsEditing((v) => !v);
  }, []), handleCloseMenu = useCallback(() => setMenuOpen(!1), []), handleRootKeyDown = useCallback((event_0) => {
    event_0.key === "Escape" && !hasChanges && cancelEdit();
  }, [cancelEdit, hasChanges]);
  useDidUpdate(isEditing, handleCloseMenu), useClickOutsideEvent(!hasChanges && cancelEdit, () => [rootElementRef.current]);
  const name = user?.displayName ? /* @__PURE__ */ jsx(Text$1, { size: 1, weight: "medium", textOverflow: "ellipsis", title: user.displayName, children: user.displayName }) : /* @__PURE__ */ jsx(TextSkeleton, { size: 1, style: SKELETON_INLINE_STYLE });
  return /* @__PURE__ */ jsxs(RootStack, { "data-menu-open": menuOpen ? "true" : "false", "data-testid": "comments-list-item-layout", onKeyDown: handleRootKeyDown, ref: rootElementRef, space: 4, children: [
    /* @__PURE__ */ jsxs(InnerStack, { space: 1, "data-muted": displayError, children: [
      /* @__PURE__ */ jsxs(HeaderFlex$1, { align: "center", gap: FLEX_GAP, flex: 1, $size: avatarSize, children: [
        withAvatar && /* @__PURE__ */ jsx(CommentsAvatar, { user, size: avatarSize }),
        /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 2, paddingY: intent ? 2 : 0, children: [
          /* @__PURE__ */ jsx(Flex, { align: "center", paddingBottom: comment.context?.intent ? 0 : 1, sizing: "border", flex: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "flex-end", gap: 2, children: [
            /* @__PURE__ */ jsx(Box, { flex: 1, children: name }),
            !displayError && /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
              /* @__PURE__ */ jsx(TimeText, { muted: !0, size: 0, children: /* @__PURE__ */ jsx("time", { dateTime: createdDate.toISOString(), title: formattedCreatedAt, children: createdTimeAgo }) }),
              formattedLastEditAt && editedDate && /* @__PURE__ */ jsx(TimeText, { muted: !0, size: 0, title: formattedLastEditAt, children: /* @__PURE__ */ jsxs("time", { dateTime: editedDate.toISOString(), title: formattedLastEditAt, children: [
                "(",
                t("list-item.layout-edited"),
                ")"
              ] }) })
            ] })
          ] }) }),
          intent && /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(IntentText, { muted: !0, size: 0, textOverflow: "ellipsis", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "list-item.layout-context", values: {
            title: intent.title,
            intent: "edit"
          }, components: {
            IntentLink: ({
              children
            }) => intent ? /* @__PURE__ */ jsx(IntentLink, { params: intent.params, intent: intent.name, children }) : void 0
          } }) }) })
        ] }),
        !isEditing && !displayError && /* @__PURE__ */ jsx(ContextMenuBox, { "data-root-menu": isParent ? "true" : "false", onClick: stopPropagation, children: /* @__PURE__ */ jsx(CommentsListItemContextMenu, { canDelete, canEdit, isParent, mode, onCopyLink: onCopyLink ? handleCopyLink : void 0, onDeleteStart: handleDelete, onEditStart: toggleEdit, onMenuClose: handleMenuClose, onMenuOpen: handleMenuOpen, onReactionSelect: handleReactionSelect, onStatusChange: onStatusChange ? handleOpenStatusChange : void 0, readOnly, status: comment.status }) })
      ] }),
      isTextSelectionComment(comment) && !!comment?.contentSnapshot && /* @__PURE__ */ jsxs(Flex, { gap: FLEX_GAP, marginBottom: 3, children: [
        withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
        /* @__PURE__ */ jsx(CommentsListItemReferencedValue, { hasReferencedValue, value: comment?.contentSnapshot })
      ] }),
      isEditing && /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 2, children: [
        withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
        /* @__PURE__ */ jsx(Stack, { flex: 1, children: /* @__PURE__ */ jsx(CommentInput, { currentUser, focusOnMount: !0, mentionOptions, onChange: setValue, onDiscardCancel: cancelDiscard, onDiscardConfirm: confirmDiscard, onKeyDown: handleInputKeyDown, onSubmit: handleEditSubmit, readOnly, ref: commentInputRef, value, withAvatar: !1 }) })
      ] }),
      !isEditing && /* @__PURE__ */ jsxs(Flex, { gap: FLEX_GAP, children: [
        withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
        /* @__PURE__ */ jsx(CommentMessageSerializer, { blocks: message })
      ] }),
      hasReactions && /* @__PURE__ */ jsxs(Flex, { gap: FLEX_GAP, marginTop: 2, children: [
        withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
        /* @__PURE__ */ jsx(Box, { onClick: stopPropagation, children: /* @__PURE__ */ jsx(CommentReactionsBar, { currentUser, mode, onSelect: handleReactionSelect, reactions, readOnly }) })
      ] })
    ] }),
    displayError && /* @__PURE__ */ jsxs(ErrorFlex, { gap: FLEX_GAP, $size: avatarSize, children: [
      withAvatar && /* @__PURE__ */ jsx(SpacerAvatar, { $size: avatarSize }),
      /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, flex: 1, children: [
        /* @__PURE__ */ jsxs(Text$1, { muted: !0, size: 1, children: [
          hasError && t("list-item.layout-failed-sent"),
          isRetrying && t("list-item.layout-posting")
        ] }),
        /* @__PURE__ */ jsx(Flex, { hidden: isRetrying, children: /* @__PURE__ */ jsx(RetryCardButton, { __unstable_focusRing: !0, display: "flex", forwardedAs: "button", onClick: handleCreateRetry, padding: 1, radius: 2, tone: "primary", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t("list-item.layout-retry") }) }) })
      ] })
    ] })
  ] });
}
const ThreadCard = styled(Card).attrs({
  padding: 3,
  radius: 3,
  sizing: "border"
})((props2) => {
  const {
    theme
  } = props2, isDark = theme.sanity.color.dark, activeBg = hues[COMMENTS_HIGHLIGHT_HUE_KEY][isDark ? 900 : 50].hex, defaultBg = hues.gray[isDark ? 900 : 50].hex;
  return css`
      background-color: ${defaultBg};

      &[data-active='true'] {
        background-color: ${activeBg};
      }
    `;
}), EMPTY_ARRAY = [], MAX_COLLAPSED_REPLIES = 5, DEFAULT_AVATAR_CONFIG = {
  avatarSize: 1,
  parentCommentAvatar: !0,
  replyAvatar: !0,
  threadCommentsAvatar: !0
}, StyledThreadCard = styled(ThreadCard)(() => css`
    position: relative;

    &:has(> [data-ui='GhostButton']:focus:focus-visible) {
      box-shadow:
        inset 0 0 0 1px var(--card-border-color),
        0 0 0 1px var(--card-bg-color),
        0 0 0 2px var(--card-focus-ring-color);
    }

    // The hover styles is managed with the [data-hovered] attribute instead of the :hover pseudo class
    // since we want to show the hover styles when hovering over the menu items in the context menu as well.
    // The context menu is rendered using a portal, so the :hover pseudo class won't work when hovering over
    // the menu items.
    &:not([data-active='true']) {
      @media (hover: hover) {
        &[data-hovered='true'] {
          [data-root-menu='true'] {
            opacity: 1;
          }
        }
      }
    }
  `), ExpandButton = styled(Button)(({
  theme
}) => {
  const {
    medium
  } = theme.sanity.fonts.text.weights;
  return css`
    font-weight: ${medium};
  `;
}), GhostButton = styled.button`
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
`, CommentsListItem = memo(function(props2) {
  const {
    avatarConfig = DEFAULT_AVATAR_CONFIG,
    canReply,
    currentUser,
    hasReferencedValue,
    innerPadding,
    isSelected,
    mentionOptions,
    mode,
    onCopyLink,
    onCreateRetry,
    onDelete,
    onEdit,
    onKeyDown,
    onPathSelect,
    onReactionSelect,
    onReply,
    onStatusChange,
    parentComment,
    readOnly,
    replies = EMPTY_ARRAY
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace), [value, setValue] = useState(EMPTY_ARRAY), [collapsed, setCollapsed] = useState(!0), [didExpand, setDidExpand] = useState(!1), replyInputRef = useRef(null), {
    isTopLayer
  } = useLayer(), hasValue2 = useMemo(() => hasCommentMessageValue(value), [value]), [mouseOver, setMouseOver] = useState(!1), handleMouseEnter = useCallback(() => setMouseOver(!0), []), handleMouseLeave = useCallback(() => setMouseOver(!1), []), handleReplySubmit = useCallback(() => {
    const nextComment = {
      message: value,
      parentCommentId: parentComment._id,
      status: parentComment?.status || "open",
      // Since this is a reply to an existing comment, we use the same thread ID as the parent
      threadId: parentComment.threadId,
      // A new comment will not have any reactions
      reactions: EMPTY_ARRAY,
      payload: {
        fieldPath: parentComment.target.path?.field || ""
      }
    };
    onReply?.(nextComment), setValue(EMPTY_ARRAY);
  }, [onReply, parentComment._id, parentComment?.status, parentComment.target.path?.field, parentComment.threadId, value]), startDiscard = useCallback(() => {
    if (!hasValue2) {
      setValue(EMPTY_ARRAY);
      return;
    }
    replyInputRef.current?.discardDialogController.open();
  }, [hasValue2]), handleInputKeyDown = useCallback((event) => {
    event.isDefaultPrevented() || event.key === "Escape" && (event.preventDefault(), event.stopPropagation(), startDiscard());
  }, [startDiscard]), cancelDiscard = useCallback(() => {
    replyInputRef.current?.discardDialogController.close();
  }, []), confirmDiscard = useCallback(() => {
    setValue(EMPTY_ARRAY), replyInputRef.current?.discardDialogController.close(), replyInputRef.current?.focus();
  }, []), handleThreadRootClick = useCallback((e) => {
    e.stopPropagation(), isTopLayer && onPathSelect?.({
      fieldPath: parentComment.target.path?.field || "",
      origin: "inspector",
      threadId: parentComment.threadId
    });
  }, [isTopLayer, onPathSelect, parentComment.target.path?.field, parentComment.threadId]), handleExpand = useCallback((e_0) => {
    e_0.stopPropagation(), setCollapsed(!1), setDidExpand(!0);
  }, []), splicedReplies = useMemo(() => collapsed ? replies?.slice(-5) : replies, [replies, collapsed]), showCollapseButton = useMemo(() => replies ? replies.length > MAX_COLLAPSED_REPLIES : !1, [replies]), expandButtonText = useMemo(() => `${replies?.length - MAX_COLLAPSED_REPLIES} more ${replies?.length - MAX_COLLAPSED_REPLIES === 1 ? "comment" : "comments"}`, [replies?.length]);
  useEffect(() => {
    replies.length > MAX_COLLAPSED_REPLIES && !didExpand && setCollapsed(!0);
  }, [didExpand, replies]);
  const renderedReplies = useMemo(() => splicedReplies.map((reply) => /* @__PURE__ */ jsx(Stack, { as: "li", ...applyCommentIdAttr(reply._id), children: /* @__PURE__ */ jsx(CommentsListItemLayout, { avatarSize: avatarConfig.avatarSize, canDelete: reply.authorId === currentUser.id, canEdit: reply.authorId === currentUser.id, comment: reply, currentUser, hasError: reply._state?.type === "createError", isRetrying: reply._state?.type === "createRetrying", intent: commentIntentIfDiffers(parentComment, reply), mentionOptions, mode, onCopyLink, onCreateRetry, onDelete, onEdit, onInputKeyDown: handleInputKeyDown, onReactionSelect, readOnly, withAvatar: avatarConfig.threadCommentsAvatar }) }, reply._id)), [avatarConfig.threadCommentsAvatar, avatarConfig.avatarSize, currentUser, handleInputKeyDown, mentionOptions, onCopyLink, onCreateRetry, onDelete, onEdit, onReactionSelect, parentComment, readOnly, splicedReplies, mode]);
  return /* @__PURE__ */ jsxs(StyledThreadCard, { "data-active": isSelected ? "true" : "false", "data-hovered": mouseOver ? "true" : "false", "data-testid": "comments-list-item", "data-ui": "CommentsListItem", onClick: handleThreadRootClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [
    /* @__PURE__ */ jsx(GhostButton, { "data-ui": "GhostButton", "aria-label": t("list-item.go-to-field-button.aria-label") }),
    /* @__PURE__ */ jsxs(
      Stack,
      {
        as: "ul",
        padding: innerPadding,
        paddingBottom: canReply ? void 0 : 1,
        space: 4,
        children: [
          /* @__PURE__ */ jsx(Stack, { as: "li", ...applyCommentIdAttr(parentComment._id), children: /* @__PURE__ */ jsx(CommentsListItemLayout, { avatarSize: avatarConfig.avatarSize, canDelete: parentComment.authorId === currentUser.id, canEdit: parentComment.authorId === currentUser.id, comment: parentComment, currentUser, hasError: parentComment._state?.type === "createError", hasReferencedValue, intent: parentComment.context?.intent, isParent: !0, isRetrying: parentComment._state?.type === "createRetrying", mentionOptions, mode, onCopyLink, onCreateRetry, onDelete, onEdit, onInputKeyDown: onKeyDown, onReactionSelect, onStatusChange, readOnly, withAvatar: avatarConfig.parentCommentAvatar }) }),
          showCollapseButton && !didExpand && /* @__PURE__ */ jsxs(Flex, { gap: 1, paddingY: 1, sizing: "border", children: [
            /* @__PURE__ */ jsx(SpacerAvatar, {}),
            /* @__PURE__ */ jsx(ExpandButton, { iconRight: ChevronDownIcon, mode: "bleed", onClick: handleExpand, text: expandButtonText })
          ] }),
          renderedReplies,
          canReply && /* @__PURE__ */ jsx(CommentInput, { avatarSize: avatarConfig.avatarSize, currentUser, expandOnFocus: !0, mentionOptions, onChange: setValue, onDiscardCancel: cancelDiscard, onDiscardConfirm: confirmDiscard, onKeyDown: handleInputKeyDown, onSubmit: handleReplySubmit, placeholder: t(mode === "upsell" ? "compose.reply-placeholder-upsell" : "compose.reply-placeholder"), readOnly: readOnly || mode === "upsell", ref: replyInputRef, value, withAvatar: avatarConfig.replyAvatar })
        ]
      }
    )
  ] });
});
CommentsListItem.displayName = "Memo(CommentsListItem)";
function getEmptyStateMessages(t) {
  return {
    open: {
      title: t("list-status.empty-state-open-title"),
      message: t("list-status.empty-state-open-text")
    },
    resolved: {
      title: t("list-status.empty-state-resolved-title"),
      message: t("list-status.empty-state-resolved-text")
    }
  };
}
function CommentsListStatus(props2) {
  const $ = c(17), {
    status,
    error,
    loading,
    hasNoComments
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = getEmptyStateMessages(t), $[0] = t, $[1] = t0) : t0 = $[1];
  const emptyStateMessages = t0;
  if (error) {
    let t1;
    $[2] !== t ? (t1 = t("list-status.error"), $[2] = t, $[3] = t1) : t1 = $[3];
    let t2;
    return $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", flex: 1, padding: 4, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Text$1, { size: 1, muted: !0, children: t1 }) }) }), $[4] = t1, $[5] = t2) : t2 = $[5], t2;
  }
  if (loading) {
    let t1;
    $[6] !== t ? (t1 = t("list-status.loading"), $[6] = t, $[7] = t1) : t1 = $[7];
    let t2;
    return $[8] !== t1 ? (t2 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: t1 }), $[8] = t1, $[9] = t2) : t2 = $[9], t2;
  }
  if (hasNoComments) {
    const t1 = emptyStateMessages[status];
    let t2;
    $[10] !== t1.title ? (t2 = /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, muted: !0, weight: "medium", children: t1.title }), $[10] = t1.title, $[11] = t2) : t2 = $[11];
    const t3 = emptyStateMessages[status];
    let t4;
    $[12] !== t3.message ? (t4 = /* @__PURE__ */ jsx(Text$1, { align: "center", size: 1, muted: !0, children: t3.message }), $[12] = t3.message, $[13] = t4) : t4 = $[13];
    let t5;
    return $[14] !== t2 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", flex: 1, sizing: "border", children: /* @__PURE__ */ jsx(Container$2, { width: 0, padding: 4, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      t2,
      t4
    ] }) }) }), $[14] = t2, $[15] = t4, $[16] = t5) : t5 = $[16], t5;
  }
  return null;
}
const EMPTY_PT_ARRAY = [];
function CreateNewThreadInput(props2) {
  const $ = c(26), {
    currentUser,
    fieldTitle,
    mentionOptions,
    mode,
    onBlur,
    onFocus,
    onKeyDown,
    onNewThreadCreate,
    readOnly
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace), [value, setValue] = useState(EMPTY_PT_ARRAY), commentInputHandle = useRef(null);
  let t0;
  $[0] !== onNewThreadCreate || $[1] !== value ? (t0 = () => {
    onNewThreadCreate?.(value), setValue(EMPTY_PT_ARRAY);
  }, $[0] = onNewThreadCreate, $[1] = value, $[2] = t0) : t0 = $[2];
  const handleSubmit = t0;
  let t1, t2;
  $[3] !== value ? (t2 = hasCommentMessageValue(value), $[3] = value, $[4] = t2) : t2 = $[4], t1 = t2;
  const hasValue2 = t1;
  let t3;
  $[5] !== hasValue2 ? (t3 = () => {
    hasValue2 && commentInputHandle.current?.discardDialogController.open();
  }, $[5] = hasValue2, $[6] = t3) : t3 = $[6];
  const startDiscard = t3;
  let t4;
  $[7] !== onKeyDown || $[8] !== startDiscard ? (t4 = (event) => {
    event.isDefaultPrevented() || (event.key === "Escape" && (event.preventDefault(), event.stopPropagation(), startDiscard()), onKeyDown && onKeyDown(event));
  }, $[7] = onKeyDown, $[8] = startDiscard, $[9] = t4) : t4 = $[9];
  const handleInputKeyDown = t4;
  let t5;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setValue(EMPTY_PT_ARRAY), commentInputHandle.current?.discardDialogController.close(), commentInputHandle.current?.focus();
  }, $[10] = t5) : t5 = $[10];
  const confirmDiscard = t5;
  let t6;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    commentInputHandle.current?.discardDialogController.close();
  }, $[11] = t6) : t6 = $[11];
  const cancelDiscard = t6;
  let t7;
  $[12] !== fieldTitle || $[13] !== mode || $[14] !== t ? (t7 = mode === "upsell" ? t("compose.add-comment-input-placeholder-upsell") : /* @__PURE__ */ jsx(Translate, { t, i18nKey: "compose.add-comment-input-placeholder", values: {
    field: fieldTitle
  } }), $[12] = fieldTitle, $[13] = mode, $[14] = t, $[15] = t7) : t7 = $[15];
  const placeholder = t7, t8 = readOnly || mode === "upsell";
  let t9;
  return $[16] !== currentUser || $[17] !== handleInputKeyDown || $[18] !== handleSubmit || $[19] !== mentionOptions || $[20] !== onBlur || $[21] !== onFocus || $[22] !== placeholder || $[23] !== t8 || $[24] !== value ? (t9 = /* @__PURE__ */ jsx(CommentInput, { currentUser, expandOnFocus: !0, mentionOptions, onBlur, onChange: setValue, onDiscardCancel: cancelDiscard, onDiscardConfirm: confirmDiscard, onKeyDown: handleInputKeyDown, onFocus, onSubmit: handleSubmit, placeholder, readOnly: t8, ref: commentInputHandle, value }), $[16] = currentUser, $[17] = handleInputKeyDown, $[18] = handleSubmit, $[19] = mentionOptions, $[20] = onBlur, $[21] = onFocus, $[22] = placeholder, $[23] = t8, $[24] = value, $[25] = t9) : t9 = $[25], t9;
}
const HeaderFlex = styled(Flex)`
  min-height: 25px;
`, BreadcrumbsButton = styled(Button$1)(({
  theme
}) => {
  const fg = theme.sanity.color.base.fg;
  return css`
    --card-fg-color: ${fg};

    // The width is needed to make the text ellipsis work
    // in the breadcrumbs component
    max-width: 100%;
  `;
});
function CommentThreadLayout(props2) {
  const {
    breadcrumbs,
    canCreateNewThread,
    children,
    currentUser,
    fieldPath,
    isSelected,
    mentionOptions,
    mode,
    onNewThreadCreate,
    onPathSelect,
    readOnly
  } = props2, {
    t
  } = useTranslation(commentsLocaleNamespace), handleNewThreadCreate = useCallback((payload) => {
    const nextComment = {
      message: payload,
      parentCommentId: void 0,
      status: "open",
      // Since this is a new comment, we generate a new thread ID
      threadId: uuid(),
      // New comments have no reactions
      reactions: [],
      payload: {
        fieldPath
      }
    };
    onNewThreadCreate?.(nextComment);
  }, [onNewThreadCreate, fieldPath]), handleBreadcrumbsClick = useCallback((e) => {
    e.stopPropagation(), onPathSelect?.({
      fieldPath,
      origin: "inspector",
      threadId: null
    });
  }, [fieldPath, onPathSelect]), handleNewThreadClick = useCallback((e_0) => {
    e_0.stopPropagation(), e_0.detail !== 0 && onPathSelect?.({
      fieldPath,
      origin: "inspector",
      threadId: null
    });
  }, [fieldPath, onPathSelect]), crumbsTitlePath = useMemo(() => breadcrumbs?.map((p) => p.title) || [], [breadcrumbs]), lastCrumb = crumbsTitlePath[crumbsTitlePath.length - 1];
  return /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    /* @__PURE__ */ jsx(HeaderFlex, { align: "center", gap: 2, paddingRight: 1, sizing: "border", children: /* @__PURE__ */ jsx(Stack, { flex: 1, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(BreadcrumbsButton, { "aria-label": t("list-item.breadcrumb-button-go-to-field-aria-label", {
      field: lastCrumb
    }), mode: "bleed", onClick: handleBreadcrumbsClick, padding: 2, space: 2, children: /* @__PURE__ */ jsx(CommentBreadcrumbs, { maxLength: 3, titlePath: crumbsTitlePath }) }) }) }) }),
    canCreateNewThread && /* @__PURE__ */ jsx(ThreadCard, { onClick: handleNewThreadClick, "data-active": isSelected, children: /* @__PURE__ */ jsx(CreateNewThreadInput, { currentUser, fieldTitle: lastCrumb, mentionOptions, mode, onNewThreadCreate: handleNewThreadCreate, readOnly }) }),
    /* @__PURE__ */ jsx(Stack, { space: 2, children })
  ] });
}
function groupThreads(comments2) {
  return comments2.reduce((acc, comment) => {
    const field = comment.fieldPath;
    return acc[field] || (acc[field] = []), acc[field].push(comment), acc;
  }, {});
}
const CommentsListInner = forwardRef(function(props2, ref) {
  const {
    beforeListNode,
    comments: comments2,
    currentUser,
    error,
    loading,
    mentionOptions,
    mode,
    onCopyLink,
    onCreateRetry,
    onDelete,
    onEdit,
    onNewThreadCreate,
    onPathSelect,
    onReactionSelect,
    onReply,
    onStatusChange,
    readOnly,
    selectedPath,
    status
  } = props2, [boundaryElement, setBoundaryElement] = useState(null), groupedThreads = useMemo(() => Object.entries(groupThreads(comments2)), [comments2]), showComments = !loading && !error && groupedThreads.length > 0;
  return /* @__PURE__ */ jsxs(Flex, { "data-testid": "comments-list", direction: "column", flex: 1, height: "fill", overflow: "hidden", ref: setBoundaryElement, sizing: "border", children: [
    mode !== "upsell" && /* @__PURE__ */ jsx(CommentsListStatus, { error, hasNoComments: groupedThreads.length === 0, loading, status }),
    (showComments || beforeListNode) && /* @__PURE__ */ jsxs(Stack, { as: "ul", flex: 1, overflow: "auto", padding: 3, paddingTop: 1, paddingBottom: 6, sizing: "border", space: 1, ref, children: [
      beforeListNode,
      /* @__PURE__ */ jsx(BoundaryElementProvider, { element: boundaryElement, children: groupedThreads?.map(([fieldPath, group2]) => {
        const breadcrumbs = group2[0].breadcrumbs, firstThreadId = group2[0].threadId, newThreadSelected = selectedPath?.fieldPath === fieldPath && !selectedPath.threadId;
        return /* @__PURE__ */ jsx(Stack, { as: "li", paddingTop: 3, ...applyCommentsGroupAttr(firstThreadId), children: /* @__PURE__ */ jsx(CommentThreadLayout, { breadcrumbs, canCreateNewThread: status === "open", currentUser, fieldPath, isSelected: newThreadSelected, mentionOptions, mode, onNewThreadCreate, onPathSelect, readOnly, children: group2.map((item) => {
          const replies = item.replies.slice().reverse(), canReply = status === "open" && item.parentComment._state?.type !== "createError" && item.parentComment._state?.type !== "createRetrying", threadIsSelected = selectedPath?.threadId === item.parentComment.threadId && selectedPath?.fieldPath === item.parentComment.target.path?.field;
          return /* @__PURE__ */ jsx(CommentsListItem, { canReply, currentUser, hasReferencedValue: item.hasReferencedValue, isSelected: threadIsSelected, mentionOptions, mode, onCopyLink, onCreateRetry, onDelete, onEdit, onPathSelect, onReactionSelect, onReply, onStatusChange, parentComment: item.parentComment, readOnly, replies }, item.parentComment._id);
        }) }, fieldPath) }, fieldPath);
      }) })
    ] })
  ] });
}), CommentsList = memo(CommentsListInner), Root = styled(Box)`
  max-width: 280px;
`, fadeInKeyFrame = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`, StyledPopover = styled(Popover)`
  opacity: 0;
  // Fade in the popover after 500ms
  animation: ${fadeInKeyFrame} 200ms 500ms forwards;
`;
function CommentsOnboardingPopover(props2) {
  const $ = c(23);
  let onDismiss, rest;
  $[0] !== props2 ? ({
    onDismiss,
    ...rest
  } = props2, $[0] = props2, $[1] = onDismiss, $[2] = rest) : (onDismiss = $[1], rest = $[2]);
  const {
    t
  } = useTranslation(commentsLocaleNamespace);
  let t0;
  $[3] !== t ? (t0 = t("onboarding.header"), $[3] = t, $[4] = t0) : t0 = $[4];
  let t1;
  $[5] !== t0 ? (t1 = /* @__PURE__ */ jsx(Text$1, { weight: "medium", size: 1, children: t0 }), $[5] = t0, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] !== t ? (t2 = t("onboarding.body"), $[7] = t, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text$1, { size: 1, children: t2 }), $[9] = t2, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== t ? (t4 = t("onboarding.dismiss"), $[11] = t, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== onDismiss || $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(Flex, { justify: "flex-end", marginTop: 2, children: /* @__PURE__ */ jsx(Button, { text: t4, tone: "primary", onClick: onDismiss }) }), $[13] = onDismiss, $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== t1 || $[17] !== t3 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(Root, { padding: 4, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t1,
    t3,
    t5
  ] }) }), $[16] = t1, $[17] = t3, $[18] = t5, $[19] = t6) : t6 = $[19];
  let t7;
  return $[20] !== rest || $[21] !== t6 ? (t7 = /* @__PURE__ */ jsx(StyledPopover, { content: t6, open: !0, portal: !0, ...rest }), $[20] = rest, $[21] = t6, $[22] = t7) : t7 = $[22], t7;
}
function CommentsUpsellPanel(props2) {
  const $ = c(4), {
    data,
    onPrimaryClick,
    onSecondaryClick
  } = props2;
  let t0;
  return $[0] !== data || $[1] !== onPrimaryClick || $[2] !== onSecondaryClick ? (t0 = /* @__PURE__ */ jsx(Container$2, { width: 1, children: /* @__PURE__ */ jsx(Box, { marginBottom: 6, children: /* @__PURE__ */ jsx(UpsellPanel, { data, onPrimaryClick, onSecondaryClick }) }) }), $[0] = data, $[1] = onPrimaryClick, $[2] = onSecondaryClick, $[3] = t0) : t0 = $[3], t0;
}
function useSanityCreateConfig() {
  const context = useContext(SanityCreateConfigContext);
  if (!context)
    throw new Error("useSanityCreateConfig must be used within a SanityCreateConfigProvider");
  return context;
}
export {
  ActiveWorkspaceMatcher,
  AddonDatasetProvider,
  ArrayOfObjectOptionsInput,
  ArrayOfObjectsFunctions,
  ArrayOfObjectsInput,
  ArrayOfObjectsInputMember,
  ArrayOfObjectsInputMembers,
  ArrayOfObjectsItem,
  ArrayOfOptionsInput,
  ArrayOfPrimitiveOptionsInput,
  ArrayOfPrimitivesFunctions,
  ArrayOfPrimitivesInput,
  ArrayOfPrimitivesItem,
  AutoCollapseMenu,
  AvatarSkeleton$1 as AvatarSkeleton,
  BetaBadge,
  PortableTextInput as BlockEditor,
  BlockImagePreview,
  BlockPreview,
  BooleanInput,
  COMMENTS_INSPECTOR_NAME,
  CONNECTING,
  CapabilityGate,
  ChangeBreadcrumb,
  ChangeConnectorRoot,
  ChangeFieldWrapper,
  ChangeIndicator,
  ChangeIndicatorsTracker,
  ChangeList,
  ChangeResolver,
  ChangeTitleSegment,
  ChangesError,
  CircularProgress,
  CollapseMenu,
  CollapseMenuButton,
  ColorSchemeCustomProvider,
  ColorSchemeLocalStorageProvider,
  ColorSchemeProvider,
  CommandList,
  CommentDeleteDialog,
  CommentDisabledIcon,
  CommentInlineHighlightSpan,
  CommentInput,
  CommentsAuthoringPathProvider,
  CommentsEnabledProvider,
  CommentsIntentProvider,
  CommentsList,
  CommentsProvider,
  CommentsSelectedPathProvider,
  CompactPreview,
  Rule as ConcreteRuleClass,
  ConfigPropertyError,
  ConfigResolutionError,
  ContextMenuButton,
  CopyPasteProvider,
  CorsOriginError,
  StudioCrossDatasetReferenceInput as CrossDatasetReferenceInput,
  DEFAULT_MAX_RECURSION_DEPTH,
  DEFAULT_STUDIO_CLIENT_OPTIONS,
  DRAFTS_FOLDER,
  DateInput,
  DateTimeInput$2 as DateTimeInput,
  DefaultPreview,
  DetailPreview,
  DiffCard,
  DiffErrorBoundary,
  DiffFromTo,
  DiffInspectWrapper,
  DiffString,
  DiffStringSegment,
  DiffTooltip,
  DocumentPreviewPresence,
  DocumentStatus,
  DocumentStatusIndicator,
  EMPTY_ARRAY$A as EMPTY_ARRAY,
  EMPTY_OBJECT,
  EditPortal,
  EditScheduleForm,
  EmailInput,
  ErrorActions,
  ErrorMessage,
  Event$1 as Event,
  EventsProvider,
  FallbackDiff,
  FieldActionMenu,
  FieldActionsProvider,
  FieldActionsResolver,
  FieldChange,
  FieldPresence,
  FieldPresenceInner,
  FieldPresenceWithOverlay,
  StudioFileInput as FileInput,
  Filters,
  FormBuilder,
  FormCallbacksProvider,
  FormField,
  FormFieldHeaderText,
  FormFieldSet,
  FormFieldStatus,
  FormFieldValidationStatus,
  FormInput,
  FormProvider,
  FormValueProvider,
  FromTo,
  FromToArrow,
  GetFormValueProvider,
  GetHookCollectionState,
  GroupChange,
  Hotkeys,
  HoveredFieldProvider,
  StudioImageInput as ImageInput,
  ImperativeToast,
  InlinePreview,
  InsufficientPermissionsMessage,
  IntentButton,
  IsLastPaneProvider,
  LATEST,
  LegacyLayerProvider,
  LinearProgress,
  LoadingBlock,
  LocaleProvider,
  LocaleProviderBase,
  MediaPreview,
  MemberField,
  MemberFieldError,
  MemberFieldSet,
  MemberItemError,
  MetaInfo,
  NoChanges,
  NumberInput,
  ObjectInput,
  ObjectInputMember,
  ObjectInputMembers,
  ObjectMembers,
  PatchEvent,
  PerspectiveProvider,
  PopoverDialog,
  PortableTextInput,
  PresenceOverlay,
  PresenceScope,
  Preview$1 as Preview,
  PreviewCard,
  PreviewLoader,
  RELEASES_INTENT,
  RELEASES_STUDIO_CLIENT_OPTIONS,
  StudioReferenceInput as ReferenceInput,
  ReferenceInputOptionsProvider,
  ReferenceInputPreviewCard,
  RelativeTime,
  ReleaseAvatar,
  Resizable,
  ResourceCacheProvider,
  RevertChangesButton,
  SANITY_PATCH_TYPE,
  SANITY_VERSION,
  SESSION_ID,
  SanityCreateConfigProvider,
  SanityDefaultPreview,
  ScheduleAction,
  ScheduledBadge,
  SchemaError,
  ScrollContainer,
  SearchButton,
  SearchDialog,
  SearchHeader,
  SearchPopover,
  SearchProvider,
  SearchResultItemPreview,
  SelectInput,
  SlugInput,
  SourceProvider,
  StatusButton,
  StringInput,
  Studio,
  StudioAnnouncementsCard,
  StudioAnnouncementsDialog,
  StudioLayout,
  StudioLayoutComponent,
  StudioLogo,
  StudioNavbar,
  StudioProvider,
  StudioToolMenu,
  TIMELINE_ITEM_I18N_KEY_MAPPING,
  TagsArrayInput,
  TelephoneInput,
  TemplatePreview,
  TextInput,
  TextWithTone,
  Timeline,
  TimelineController,
  ToolLink,
  TooltipOfDisabled,
  TransformPatches,
  Translate,
  UniversalArrayInput,
  UpsellDescriptionSerializer,
  UpsellDialogDismissed,
  UpsellDialogLearnMoreCtaClicked,
  UpsellDialogUpgradeCtaClicked,
  UpsellDialogViewed,
  UrlInput,
  UserAvatar,
  UserColorManagerProvider,
  VERSION_FOLDER,
  ValueError,
  VersionChip$1 as VersionChip,
  VersionInlineBadge,
  VirtualizerScrollInstanceProvider,
  WithReferringDocuments,
  WorkspaceLoaderBoundary as WorkspaceLoader,
  WorkspaceProvider,
  WorkspacesProvider,
  ZIndexProvider,
  _createAuthStore,
  _isCustomDocumentTypeDefinition,
  _isSanityDocumentTypeDefinition,
  asLoadable,
  buildCommentRangeDecorations,
  buildLegacyTheme,
  buildRangeDecorationSelectionsFromComments,
  buildTextSelectionFromFragment,
  catchWithCount,
  checkoutPair,
  collate,
  createAuthStore,
  createBufferedDocument,
  createConfig,
  createConnectionStatusStore,
  createDefaultIcon,
  createDocumentPreviewStore,
  createDocumentStore,
  createDraftFrom,
  createGrantsStore,
  createHistoryStore,
  createHookFromObservableFactory,
  createKeyValueStore,
  createMockAuthStore,
  createObservableBufferedDocument,
  createPatchChannel,
  createPlugin,
  createPresenceStore,
  createProjectStore,
  createPublishedFrom,
  createSWR,
  createSanityMediaLibraryFileSource,
  createSanityMediaLibraryImageSource,
  createSchema,
  createSearch,
  createSharedResizeObserver,
  createSourceFromConfig,
  createUserColorManager,
  createUserStore,
  createWorkspaceFromConfig,
  dec,
  decodePath,
  defaultLocale,
  defaultRenderAnnotation,
  defaultRenderBlock,
  defaultRenderField,
  defaultRenderInlineBlock,
  defaultRenderInput,
  defaultRenderItem,
  defaultRenderPreview,
  defaultTemplateForType,
  defaultTemplatesForSchema,
  defaultTheme,
  defineConfig,
  defineDocumentFieldAction,
  defineDocumentInspector,
  defineLocale,
  defineLocaleResourceBundle,
  defineLocalesResources,
  definePlugin,
  defineSearchFilter,
  defineSearchFilterOperators,
  defineSearchOperator,
  diffMatchPatch,
  diffResolver,
  documentFieldActionsReducer,
  documentIdEquals,
  editState,
  emitOperation,
  encodePath,
  escapeField,
  fieldNeedsEscape,
  findIndex,
  flattenConfig,
  formatRelativeLocale,
  formatRelativeLocalePublishDate,
  fromMutationPatches,
  getAnnotationAtPath,
  getAnnotationColor,
  getCalendarLabels,
  getConfigContextFromSource,
  getDiffAtPath,
  getDocumentPairPermissions,
  getDocumentValuePermissions,
  getDocumentVariantType,
  getDraftId,
  getExpandOperations,
  getIdPair,
  getInitialValueStream,
  getItemKey$1 as getItemKey,
  getItemKeySegment,
  getNamelessWorkspaceIdentifier,
  getPairListener,
  getPreviewPaths,
  getPreviewStateObservable$1 as getPreviewStateObservable,
  getPreviewValueWithFallback,
  getProviderTitle,
  getPublishedId,
  getReleaseIdFromReleaseDocumentId,
  getReleaseTone,
  getSanityCreateLinkMetadata,
  getSchemaTypeTitle,
  getSearchableTypes,
  getTemplatePermissions,
  getValueAtPath,
  getValueError,
  getVersionFromId,
  getVersionId,
  getVersionInlineBadge,
  getWorkspaceIdentifier,
  globalScope,
  grantsPermissionOn,
  hasCommentMessageValue,
  idMatchesPerspective,
  inc,
  initialDocumentFieldActions,
  insert$1 as insert,
  isAddedItemDiff,
  isArray,
  isArrayOfBlocksInputProps,
  isArrayOfObjectsInputProps,
  isArrayOfPrimitivesInputProps,
  isAuthStore,
  isBooleanInputProps,
  isBuilder,
  isCookielessCompatibleLoginMethod,
  isCreateDocumentVersionEvent,
  isCreateLiveDocumentEvent,
  isDeleteDocumentGroupEvent,
  isDeleteDocumentVersionEvent,
  isDev,
  isDraft,
  isDraftId,
  isDraftPerspective,
  isEditDocumentVersionEvent,
  isEmptyObject$1 as isEmptyObject,
  isFieldChange,
  isGoingToUnpublish,
  isGroupChange,
  isNonNullable$3 as isNonNullable,
  isNumberInputProps,
  isObjectInputProps,
  isObjectItemProps,
  isPerspectiveRaw,
  isProd,
  isPublishDocumentVersionEvent,
  isPublishedId,
  isPublishedPerspective,
  isRecord$4 as isRecord,
  isReleaseDocument,
  isReleasePerspective,
  isReleaseScheduledOrScheduling,
  isRemovedItemDiff,
  isSanityCreateExcludedType,
  isSanityCreateLinked,
  isSanityCreateLinkedDocument,
  isSanityCreateStartCompatibleDoc,
  isScheduleDocumentVersionEvent,
  isString,
  isStringInputProps,
  isSystemBundle,
  isSystemBundleName,
  isTextSelectionComment,
  isTruthy,
  isUnchangedDiff,
  isUnpublishDocumentEvent,
  isUnscheduleDocumentVersionEvent,
  isUpdateLiveDocumentEvent,
  isValidAnnouncementAudience,
  isValidAnnouncementRole,
  isVersionId,
  joinPath,
  listenQuery,
  matchWorkspace,
  newDraftFrom,
  noop$1 as noop,
  normalizeIndexSegment,
  normalizeIndexTupleSegment,
  normalizeKeySegment,
  normalizePathSegment,
  onRetry,
  operationEvents,
  operatorDefinitions,
  pathToString$1 as pathToString,
  pathsAreEqual,
  prefixPath,
  prepareConfig,
  prepareForPreview,
  prepareTemplates,
  remoteSnapshots,
  removeDupes$3 as removeDupes,
  removeMissingReferences,
  removeUndefinedLocaleResources,
  renderStudio,
  resizeObserver,
  resolveConditionalProperty,
  resolveConfig,
  resolveDiffComponent,
  resolveInitialObjectValue,
  resolveInitialValue,
  resolveInitialValueForType,
  resolveSchemaTypes,
  serializeError,
  set,
  setAtPath,
  setIfMissing,
  sliceString,
  snapshotPair,
  stringToPath,
  supportsTouch,
  systemBundles,
  toMutationPatches,
  truncateString,
  uncaughtErrorHandler,
  unset,
  useObserveDocument as unstable_useObserveDocument,
  useDocumentPreview as unstable_useValuePreview,
  usEnglishLocale,
  useActiveReleases,
  useActiveWorkspace,
  useAddonDataset,
  useAnnotationColor,
  useArchivedReleases,
  useCanvasCompanionDoc,
  useChangeIndicatorsReportedValues,
  useChangeIndicatorsReporter,
  useClient,
  useColorScheme,
  useColorSchemeInternalValue,
  useColorSchemeOptions,
  useColorSchemeSetValue,
  useColorSchemeValue,
  useComlinkStore,
  useComments,
  useCommentsEnabled,
  useCommentsSelectedPath,
  useCommentsTelemetry,
  useConditionalToast,
  useConfigContextFromSource,
  useConnectionState,
  useConnectionStatusStore,
  useCopyErrorDetails,
  useCopyPaste,
  useCurrentLocale,
  useCurrentUser,
  useDataset,
  useDateTimeFormat,
  useDidUpdate,
  useDiffAnnotationColor,
  useDocumentChange,
  useDocumentForm,
  useDocumentOperation,
  useDocumentOperationEvent,
  useDocumentPairPermissions,
  useDocumentPairPermissionsFromHookFactory,
  useDocumentPresence,
  useDocumentPreviewStore,
  useDocumentStore,
  useDocumentType,
  useDocumentValuePermissions,
  useDocumentValues,
  useDocumentVersionInfo,
  useDocumentVersionTypeSortedList,
  useDocumentVersions,
  useEditState,
  useEvents,
  useEventsStore,
  useExcludedPerspective,
  useFeatureEnabled,
  useFieldActions,
  useFormBuilder,
  useFormCallbacks,
  useFormState,
  useFormValue,
  useFormattedDuration,
  useGetFormValue,
  useGetI18nText,
  useGlobalCopyPasteElementHandler,
  useGlobalPresence,
  useGrantsStore,
  useHistoryStore,
  useHoveredField,
  useI18nText,
  useInitialValue,
  useInitialValueResolverContext,
  useIsReleaseActive,
  useKeyValueStore,
  useListFormat,
  useLoadable,
  useLocale,
  useManageFavorite,
  useMiddlewareComponents,
  useNavigateToCanvasDoc,
  useNumberFormat,
  useOnScroll,
  useOnlyHasVersions,
  usePerspective,
  usePresenceStore,
  usePreviewCard,
  useProject,
  useProjectDatasets,
  useProjectId$1 as useProjectId,
  useProjectStore,
  useReconnectingToast,
  useReferenceInputOptions,
  useReferringDocuments,
  useRelativeTime,
  useReleasesIds,
  useRenderingContextStore,
  useResolveInitialValueForType,
  useResourceCache,
  useReviewChanges,
  useRovingFocus,
  useSanityCreateConfig,
  useSchema,
  useSearchMaxFieldDepth,
  useSearchState,
  useSetPerspective,
  useSource,
  useStudioUrl,
  useSyncState,
  useTemplatePermissions,
  useTemplatePermissionsFromHookFactory,
  useTemplates,
  useThrottledCallback,
  useTimeAgo,
  useTimelineSelector,
  useTimelineStore,
  useTools,
  useTrackerStore,
  useTrackerStoreReporter,
  useTranslation,
  useTreeEditingEnabled,
  useUnique,
  useUnitFormatter,
  useUser,
  useUserColor,
  useUserColorManager,
  useUserListWithPermissions,
  useUserStore,
  useValidationStatus,
  useVersionOperations,
  useVirtualizerScrollInstance,
  useWorkspace,
  useWorkspaceLoader,
  useWorkspaceSchemaId,
  useWorkspaces,
  useZIndex,
  userHasRole,
  validateBasePaths,
  validateDocument,
  validateNames,
  validateWorkspaces,
  validation,
  visitDiff
};
//# sourceMappingURL=index.mjs.map
